/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 995);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var evalAllowed = false;
try {
  eval('evalAllowed = true');
} catch (e) {
  // eval not allowed due to CSP
}

// RHL needs setPrototypeOf to operate Component inheritance, and eval to patch methods
var platformSupported = !!Object.setPrototypeOf && evalAllowed;

if (true) {
  if (false) {
    // we are not in prod mode, but RHL could not be activated
    console.warn('React-Hot-Loaded is not supported in this environment');
  }
  module.exports = __webpack_require__(996);
} else {
  module.exports = require('./dist/react-hot-loader.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(997);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SvgIcon = __webpack_require__(1740);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SvgIcon2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(1737);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(194);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(742);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(743);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1205)();
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(625);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80), __webpack_require__(186)(module)))

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppBar__);
/* unused harmony reexport AppBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AutoComplete__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoComplete___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Avatar__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Avatar__);
/* unused harmony reexport Avatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Badge__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Badge__);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BottomNavigation__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BottomNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BottomNavigation__);
/* unused harmony reexport BottomNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BottomNavigation_BottomNavigationItem__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BottomNavigation_BottomNavigationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BottomNavigation_BottomNavigationItem__);
/* unused harmony reexport BottomNavigationItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Card__);
/* unused harmony reexport Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Card_CardActions__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Card_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Card_CardActions__);
/* unused harmony reexport CardActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Card_CardHeader__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Card_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Card_CardHeader__);
/* unused harmony reexport CardHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Card_CardMedia__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Card_CardMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Card_CardMedia__);
/* unused harmony reexport CardMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card_CardTitle__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card_CardTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Card_CardTitle__);
/* unused harmony reexport CardTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Card_CardText__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Card_CardText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Card_CardText__);
/* unused harmony reexport CardText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Checkbox__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__Checkbox___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Chip__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Chip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__Chip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CircularProgress__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__CircularProgress___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__DatePicker__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_15__DatePicker___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Dialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_16__Dialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Divider__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Divider__);
/* unused harmony reexport Divider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Drawer__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__Drawer__);
/* unused harmony reexport Drawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropDownMenu__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropDownMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__DropDownMenu__);
/* unused harmony reexport DropDownMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__FlatButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_20__FlatButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FloatingActionButton__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FloatingActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__FloatingActionButton__);
/* unused harmony reexport FloatingActionButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FontIcon__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FontIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__FontIcon__);
/* unused harmony reexport FontIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__GridList__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__GridList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__GridList__);
/* unused harmony reexport GridList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__GridList_GridTile__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__GridList_GridTile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__GridList_GridTile__);
/* unused harmony reexport GridTile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__IconButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_25__IconButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__IconMenu__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__IconMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__IconMenu__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_26__IconMenu___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__LinearProgress__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__LinearProgress__);
/* unused harmony reexport LinearProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__List__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__List__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_28__List___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__List_ListItem__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__List_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__List_ListItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_29__List_ListItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__List_makeSelectable__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__List_makeSelectable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__List_makeSelectable__);
/* unused harmony reexport makeSelectable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__Menu__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_31__Menu___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__MenuItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_32__MenuItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__styles_MuiThemeProvider__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__styles_MuiThemeProvider__);
/* unused harmony reexport MuiThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Paper__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__Paper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_34__Paper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__Popover__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_35__Popover___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__RadioButton__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__RadioButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_36__RadioButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__RadioButton_RadioButtonGroup__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__RadioButton_RadioButtonGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__RadioButton_RadioButtonGroup__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_37__RadioButton_RadioButtonGroup___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__RaisedButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_38__RaisedButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__RefreshIndicator__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__RefreshIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__RefreshIndicator__);
/* unused harmony reexport RefreshIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__SelectField__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_40__SelectField___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Slider__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__Slider__);
/* unused harmony reexport Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Subheader__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Subheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__Subheader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_42__Subheader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__SvgIcon__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__SvgIcon__);
/* unused harmony reexport SvgIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Stepper_Step__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Stepper_Step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__Stepper_Step__);
/* unused harmony reexport Step */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Stepper_StepButton__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Stepper_StepButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__Stepper_StepButton__);
/* unused harmony reexport StepButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Stepper_StepContent__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Stepper_StepContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__Stepper_StepContent__);
/* unused harmony reexport StepContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Stepper_StepLabel__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Stepper_StepLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__Stepper_StepLabel__);
/* unused harmony reexport StepLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Stepper_Stepper__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Stepper_Stepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__Stepper_Stepper__);
/* unused harmony reexport Stepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Snackbar__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__Snackbar__);
/* unused harmony reexport Snackbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Tabs__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__Tabs__);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Tabs_Tab__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Tabs_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__Tabs_Tab__);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__Table__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_52__Table___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Table_TableBody__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Table_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__Table_TableBody__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_53__Table_TableBody___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Table_TableFooter__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Table_TableFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__Table_TableFooter__);
/* unused harmony reexport TableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Table_TableHeader__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Table_TableHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__Table_TableHeader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_55__Table_TableHeader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Table_TableHeaderColumn__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Table_TableHeaderColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__Table_TableHeaderColumn__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_56__Table_TableHeaderColumn___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Table_TableRow__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Table_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__Table_TableRow__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_57__Table_TableRow___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Table_TableRowColumn__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Table_TableRowColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__Table_TableRowColumn__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_58__Table_TableRowColumn___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__TextField__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_59__TextField___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TimePicker__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__TimePicker__);
/* unused harmony reexport TimePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__Toggle__);
/* unused harmony reexport Toggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Toolbar__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__Toolbar__);
/* unused harmony reexport Toolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Toolbar_ToolbarGroup__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Toolbar_ToolbarGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__Toolbar_ToolbarGroup__);
/* unused harmony reexport ToolbarGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Toolbar_ToolbarSeparator__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Toolbar_ToolbarSeparator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__Toolbar_ToolbarSeparator__);
/* unused harmony reexport ToolbarSeparator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Toolbar_ToolbarTitle__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Toolbar_ToolbarTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__Toolbar_ToolbarTitle__);
/* unused harmony reexport ToolbarTitle */






































































































































/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__regions_areas__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__regions_ports__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contracts__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cargoes_types__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cargoes_terms__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cargoes_duplicates__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cargoes_ldRates__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cargoes_requests__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cargoes_names__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__letters__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__annotations__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__gazetters__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__companies__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__counties__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__nationalities__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__vessels_claims__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__vessels_requests__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__yards__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__registerClass__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__piClubs__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__statistics_users__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__statistics_emails__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__statistics_monitor__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__statistics_st__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__statistics_cargoRequests__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__statistics_vesselPositions__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__statistics_composition__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__files__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__preferences__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__preferences_filterAnnotations__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__preferences_mailRecognizeSpamList__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__sender__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__packingList__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__domains__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__users_subscribers__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__backendNotifications__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__timeCharters__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__fuel__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__disbursement__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__integrators_integrators__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__reqLDRates__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__analytics_mailers__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__trainings__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__prices__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__design__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__tc_requests__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__vessels_sales__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__vessels_composition__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__analytics_linksList__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__flagCompliance__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__sanctions__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__tc_indexes__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__hsCodes__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__issues__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__orders__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__hires_requests__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__devUtils__ = __webpack_require__(1434);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

// user

// regions areas ports


// contracts

// cargoes








// letters



// gazetters

// companies

// countries

// nationalities

// vessels



// yards

// register classes

// pi clubs

// statistics







// files


// serviceProvider


// preferences




// sender emails




// domains


// sender emails


// notifications


// time charter






// cargo req ldrates


// mailers


// new trainings


// pda


// design


// tc

// sales


// vessel composition


// analytics


// flag compliance


// sanctions


// tc indexes


// hs codes


// issues


// orders


// hires

// dev-utils


var api = _extends({
    users: __WEBPACK_IMPORTED_MODULE_0__users__["d" /* default */],
    getUser: __WEBPACK_IMPORTED_MODULE_0__users__["h" /* getUser */],
    authUser: __WEBPACK_IMPORTED_MODULE_0__users__["a" /* authUser */],
    logoutUser: __WEBPACK_IMPORTED_MODULE_0__users__["k" /* logoutUser */],
    createNewUser: __WEBPACK_IMPORTED_MODULE_0__users__["c" /* createNewUser */],
    findUser: __WEBPACK_IMPORTED_MODULE_0__users__["e" /* findUser */],
    findUsers: __WEBPACK_IMPORTED_MODULE_0__users__["g" /* findUsers */],
    findUserById: __WEBPACK_IMPORTED_MODULE_0__users__["f" /* findUserById */],
    getUserList: __WEBPACK_IMPORTED_MODULE_0__users__["j" /* getUserList */],
    banUserById: __WEBPACK_IMPORTED_MODULE_0__users__["b" /* banUserById */],
    unbanUserById: __WEBPACK_IMPORTED_MODULE_0__users__["o" /* unbanUserById */],

    getAreas: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["f" /* getAreas */],
    getArea: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["d" /* getArea */],
    updateArea: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["k" /* updateArea */],
    deleteArea: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["c" /* deleteArea */],
    updateAreaAlt: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["l" /* updateAreaAlt */],
    createArea: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["b" /* createArea */],
    transformAreaToPort: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["j" /* transformAreaToPort */],
    joinAreaToArea: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["h" /* joinAreaToArea */],
    getAreaRelations: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["e" /* getAreaRelations */],
    addAreaToArea: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["a" /* addAreaToArea */],

    checkAndCreateRegion: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["d" /* checkAndCreateRegion */],
    findPort: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["e" /* findPort */],
    findPortAdmin: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["f" /* findPortAdmin */],

    getPorts: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["k" /* getPorts */],
    getAllPorts: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["g" /* getAllPorts */],
    getAllPortsWithCountryNames: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["i" /* getAllPortsWithCountryNames */],
    getAllPortsWithAltNames: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["h" /* getAllPortsWithAltNames */],

    getServiceProvidersHistory: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["d" /* getServiceProvidersHistory */],

    updatePort: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["o" /* updatePort */],
    updatePortAlt: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["p" /* updatePortAlt */],
    addNewPort: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["a" /* addNewPort */],
    getPort: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["j" /* getPort */],
    mergeAreaOrPortToPort: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["l" /* mergeAreaOrPortToPort */],
    mergeAreaToArea: __WEBPACK_IMPORTED_MODULE_1__regions_areas__["i" /* mergeAreaToArea */],
    getCargoTypes: __WEBPACK_IMPORTED_MODULE_4__cargoes_types__["a" /* getCargoTypes */],

    approvePortModificationField: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["b" /* approvePortModificationField */],
    rejectPortModificationField: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["m" /* rejectPortModificationField */],
    updatePortModificationField: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["q" /* updatePortModificationField */],

    getContracts: __WEBPACK_IMPORTED_MODULE_3__contracts__["a" /* getContracts */],
    getTimeContracts: __WEBPACK_IMPORTED_MODULE_3__contracts__["b" /* getTimeContracts */],

    cargoAssigner: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["a" /* default */],
    getCargoAssigners: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["c" /* getCargoAssigners */],
    getCargoAssignersPost: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["d" /* getCargoAssignersPost */],
    getCargoGazetters: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["e" /* getCargoGazetters */],
    deleteCargoGazetter: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["b" /* deleteCargoGazetter */],
    updateCargoAssigner: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["h" /* updateCargoAssigner */],
    getOneCargoByRealCargoId: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["f" /* getOneCargoByRealCargoId */],
    updateRealAdditionalInfo: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["i" /* updateRealAdditionalInfo */],
    getRealCargoNameWithGaz: __WEBPACK_IMPORTED_MODULE_5__cargoes_assigners__["g" /* getRealCargoNameWithGaz */],

    getTermEntities: __WEBPACK_IMPORTED_MODULE_6__cargoes_terms__["a" /* getTermEntities */],

    getCargoDuplicates: __WEBPACK_IMPORTED_MODULE_7__cargoes_duplicates__["b" /* getCargoDuplicates */],
    deleteCargoDuplicate: __WEBPACK_IMPORTED_MODULE_7__cargoes_duplicates__["a" /* deleteCargoDuplicate */],

    getLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_8__cargoes_ldRates__["b" /* getLoadingAndDischarging */],
    updateLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_8__cargoes_ldRates__["c" /* updateLoadingAndDischarging */],
    deleteLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_8__cargoes_ldRates__["a" /* deleteLoadingAndDischarging */],

    getLetters: __WEBPACK_IMPORTED_MODULE_12__letters__["c" /* getLetters */],
    getLetter: __WEBPACK_IMPORTED_MODULE_12__letters__["b" /* getLetter */],
    updateLetter: __WEBPACK_IMPORTED_MODULE_12__letters__["j" /* updateLetter */],
    sendRefNumber: __WEBPACK_IMPORTED_MODULE_12__letters__["h" /* sendRefNumber */],
    sendLetterToArchive: __WEBPACK_IMPORTED_MODULE_12__letters__["g" /* sendLetterToArchive */],
    saveAsSpam: __WEBPACK_IMPORTED_MODULE_12__letters__["d" /* saveAsSpam */],
    fetchPredictorType: __WEBPACK_IMPORTED_MODULE_12__letters__["a" /* fetchPredictorType */],

    postAnnotations: __WEBPACK_IMPORTED_MODULE_13__annotations__["a" /* postAnnotations */],
    postRequestCargo: __WEBPACK_IMPORTED_MODULE_10__cargoes_requests__["d" /* postRequestCargo */],
    getCargoMonitor: __WEBPACK_IMPORTED_MODULE_10__cargoes_requests__["c" /* getCargoMonitor */],
    changeUserCargoRequest: __WEBPACK_IMPORTED_MODULE_10__cargoes_requests__["a" /* changeUserCargoRequest */],
    deleteCargoRequest: __WEBPACK_IMPORTED_MODULE_10__cargoes_requests__["b" /* deleteCargoRequest */],

    getCargoByNameOrType: __WEBPACK_IMPORTED_MODULE_11__cargoes_names__["a" /* getCargoByNameOrType */],

    getCargoNamesAutocomplete: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["f" /* getCargoNamesAutocomplete */],
    getCargoRealNames: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["g" /* getCargoRealNames */],
    updateCargoRealName: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["l" /* updateCargoRealName */],
    checkForDeleteCargoName: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["c" /* checkForDeleteCargoName */],
    convertUserCargoToAdmin: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["d" /* convertUserCargoToAdmin */],
    deleteCargoRealName: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["e" /* deleteCargoRealName */],
    getTagsCategories: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["i" /* getTagsCategories */],
    addTagsCategories: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["b" /* addTagsCategories */],
    addTag: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["a" /* addTag */],
    searchTags: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["k" /* searchTags */],
    saveTags: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["j" /* saveTags */],
    getCargoRealNamesPaginated: __WEBPACK_IMPORTED_MODULE_9__cargoes_realNames__["h" /* getCargoRealNamesPaginated */],
    getCargoNamesMatches: __WEBPACK_IMPORTED_MODULE_11__cargoes_names__["b" /* getCargoNamesMatches */],
    postGazetters: __WEBPACK_IMPORTED_MODULE_14__gazetters__["c" /* postGazetters */],
    saveGazetters: __WEBPACK_IMPORTED_MODULE_14__gazetters__["h" /* saveGazetters */],
    saveGazettersNew: __WEBPACK_IMPORTED_MODULE_14__gazetters__["i" /* saveGazettersNew */],
    saveGazetterPartially: __WEBPACK_IMPORTED_MODULE_14__gazetters__["g" /* saveGazetterPartially */],
    loadGazetteerIndex: __WEBPACK_IMPORTED_MODULE_14__gazetters__["b" /* loadGazetteerIndex */],
    saveGazetteerIndex: __WEBPACK_IMPORTED_MODULE_14__gazetters__["f" /* saveGazetteerIndex */],
    loadGazetteer: __WEBPACK_IMPORTED_MODULE_14__gazetters__["a" /* loadGazetteer */],
    saveGazetteer: __WEBPACK_IMPORTED_MODULE_14__gazetters__["e" /* saveGazetteer */],
    removeGazetteerDuplicates: __WEBPACK_IMPORTED_MODULE_14__gazetters__["d" /* removeGazetteerDuplicates */],

    findCompany: __WEBPACK_IMPORTED_MODULE_15__companies__["d" /* findCompany */],
    getCompanies: __WEBPACK_IMPORTED_MODULE_15__companies__["h" /* getCompanies */],
    getRealCompanies: __WEBPACK_IMPORTED_MODULE_15__companies__["i" /* getRealCompanies */],
    findRealCompany: __WEBPACK_IMPORTED_MODULE_15__companies__["g" /* findRealCompany */],
    saveRealCompany: __WEBPACK_IMPORTED_MODULE_15__companies__["j" /* saveRealCompany */],
    deleteRealCompany: __WEBPACK_IMPORTED_MODULE_15__companies__["b" /* deleteRealCompany */],

    getCountries: __WEBPACK_IMPORTED_MODULE_16__counties__["a" /* getCountries */],

    getNationalities: __WEBPACK_IMPORTED_MODULE_17__nationalities__["a" /* getNationalities */],

    findYards: __WEBPACK_IMPORTED_MODULE_21__yards__["b" /* findYards */],
    addYard: __WEBPACK_IMPORTED_MODULE_21__yards__["a" /* addYard */],
    getYardById: __WEBPACK_IMPORTED_MODULE_21__yards__["c" /* getYardById */],

    findClasses: __WEBPACK_IMPORTED_MODULE_22__registerClass__["b" /* findClasses */],
    addClass: __WEBPACK_IMPORTED_MODULE_22__registerClass__["a" /* addClass */],
    getClassById: __WEBPACK_IMPORTED_MODULE_22__registerClass__["c" /* getClassById */],

    findPIClubs: __WEBPACK_IMPORTED_MODULE_23__piClubs__["b" /* findPIClubs */],
    addPIClub: __WEBPACK_IMPORTED_MODULE_23__piClubs__["a" /* addPIClub */],
    getPIClubById: __WEBPACK_IMPORTED_MODULE_23__piClubs__["c" /* getPIClubById */],
    deleteNameSuggestion: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["d" /* deleteNameSuggestion */],
    renameVessel: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["i" /* renameVessel */],
    findVessel: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["f" /* findVessel */],
    getVessels: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["h" /* getVessels */],
    confirmVessel: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["c" /* confirmVessel */],
    getVessel: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["g" /* getVessel */],
    deleteVessel: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["e" /* deleteVessel */],
    addVessel: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["a" /* addVessel */],
    updateVessel: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["j" /* updateVessel */],
    updateVesselImage: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["k" /* updateVesselImage */],
    checkImoNumberRegistered: __WEBPACK_IMPORTED_MODULE_18__vessels_vessels__["b" /* checkImoNumberRegistered */],

    postRequestVessel: __WEBPACK_IMPORTED_MODULE_20__vessels_requests__["d" /* postRequestVessel */],
    getVesselMonitor: __WEBPACK_IMPORTED_MODULE_20__vessels_requests__["c" /* getVesselMonitor */],
    changeUserVesselRequest: __WEBPACK_IMPORTED_MODULE_20__vessels_requests__["a" /* changeUserVesselRequest */],
    deleteVesselRequest: __WEBPACK_IMPORTED_MODULE_20__vessels_requests__["b" /* deleteVesselRequest */],

    getVesselClaims: __WEBPACK_IMPORTED_MODULE_19__vessels_claims__["b" /* getVesselClaims */],
    acceptUserClaimsToVessel: __WEBPACK_IMPORTED_MODULE_19__vessels_claims__["a" /* acceptUserClaimsToVessel */],
    rejectUserClaimsToVessel: __WEBPACK_IMPORTED_MODULE_19__vessels_claims__["c" /* rejectUserClaimsToVessel */],

    getStatisticsUsers: __WEBPACK_IMPORTED_MODULE_24__statistics_users__["a" /* getStatisticsUsers */],
    getStatisticsEmails: __WEBPACK_IMPORTED_MODULE_25__statistics_emails__["a" /* getStatisticsEmails */],
    getStatisticsMonitor: __WEBPACK_IMPORTED_MODULE_26__statistics_monitor__["a" /* getStatisticsMonitor */],
    getStatisticsCargoRequests: __WEBPACK_IMPORTED_MODULE_28__statistics_cargoRequests__["a" /* getStatisticsCargoRequests */],
    getStatisticsVesselPositions: __WEBPACK_IMPORTED_MODULE_29__statistics_vesselPositions__["a" /* getStatisticsVesselPositions */],
    getCompositionStats: __WEBPACK_IMPORTED_MODULE_30__statistics_composition__["a" /* getCompositionStats */],

    uploadFile: __WEBPACK_IMPORTED_MODULE_31__files__["a" /* uploadFile */],

    setUserToBlackList: __WEBPACK_IMPORTED_MODULE_0__users__["l" /* setUserToBlackList */],
    setUserToWhiteList: __WEBPACK_IMPORTED_MODULE_0__users__["m" /* setUserToWhiteList */],
    getUserLimitationsList: __WEBPACK_IMPORTED_MODULE_0__users__["i" /* getUserLimitationsList */],
    toggleWhiteList: __WEBPACK_IMPORTED_MODULE_0__users__["n" /* toggleWhiteList */],

    rejectPortModifications: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["n" /* rejectPortModifications */],
    approvePortModifications: __WEBPACK_IMPORTED_MODULE_2__regions_ports__["c" /* approvePortModifications */],

    rejectServiceProvider: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["g" /* rejectServiceProvider */],
    approveServiceProvider: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["c" /* approveServiceProvider */],
    updateServiceProviders: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["h" /* updateServiceProviders */],
    approveNewServiceProvider: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["a" /* approveNewServiceProvider */],
    rejectNewServiceProvider: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["e" /* rejectNewServiceProvider */],
    approveRemoveServiceProvider: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["b" /* approveRemoveServiceProvider */],
    rejectRemoveServiceProvider: __WEBPACK_IMPORTED_MODULE_32__regions_serviceProvider_js__["f" /* rejectRemoveServiceProvider */],

    createFilterAnnotationsPreference: __WEBPACK_IMPORTED_MODULE_34__preferences_filterAnnotations__["a" /* createFilterAnnotationsPreference */],

    updatePreference: __WEBPACK_IMPORTED_MODULE_33__preferences__["d" /* updatePreference */],
    deletePreference: __WEBPACK_IMPORTED_MODULE_33__preferences__["a" /* deletePreference */],
    getPreference: __WEBPACK_IMPORTED_MODULE_33__preferences__["b" /* getPreference */],
    getPreferences: __WEBPACK_IMPORTED_MODULE_33__preferences__["c" /* getPreferences */],
    updatePreferenceMeta: __WEBPACK_IMPORTED_MODULE_33__preferences__["e" /* updatePreferenceMeta */],

    getMailRecognizeSpamList: __WEBPACK_IMPORTED_MODULE_35__preferences_mailRecognizeSpamList__["b" /* getMailRecognizeSpamList */],
    createMailRecognizeSpamList: __WEBPACK_IMPORTED_MODULE_35__preferences_mailRecognizeSpamList__["a" /* createMailRecognizeSpamList */],
    updateMailRecognizeSpamList: __WEBPACK_IMPORTED_MODULE_35__preferences_mailRecognizeSpamList__["c" /* updateMailRecognizeSpamList */],

    getSendEmailList: __WEBPACK_IMPORTED_MODULE_36__sender__["b" /* getSendEmailList */],
    getSendEmail: __WEBPACK_IMPORTED_MODULE_36__sender__["a" /* getSendEmail */],
    getStatisticsSt: __WEBPACK_IMPORTED_MODULE_27__statistics_st__["a" /* getStatisticsSt */],

    connectNewDomainToUser: __WEBPACK_IMPORTED_MODULE_38__domains__["a" /* connectNewDomainToUser */],
    deleteDomain: __WEBPACK_IMPORTED_MODULE_38__domains__["b" /* deleteDomain */],
    getListDomain: __WEBPACK_IMPORTED_MODULE_38__domains__["c" /* getListDomain */],

    getSubscribers: __WEBPACK_IMPORTED_MODULE_39__users_subscribers__["a" /* getSubscribers */],

    getBackendNotifications: __WEBPACK_IMPORTED_MODULE_40__backendNotifications__["d" /* getBackendNotifications */],
    getBackendNotification: __WEBPACK_IMPORTED_MODULE_40__backendNotifications__["c" /* getBackendNotification */],
    deleteBackendNotification: __WEBPACK_IMPORTED_MODULE_40__backendNotifications__["b" /* deleteBackendNotification */],
    updateBackendNotification: __WEBPACK_IMPORTED_MODULE_40__backendNotifications__["e" /* updateBackendNotification */],
    createBackendNotification: __WEBPACK_IMPORTED_MODULE_40__backendNotifications__["a" /* createBackendNotification */]
}, __WEBPACK_IMPORTED_MODULE_37__packingList__, {
    timeCharters: __WEBPACK_IMPORTED_MODULE_41__timeCharters__["a" /* default */],
    fuel: __WEBPACK_IMPORTED_MODULE_42__fuel__["a" /* default */],
    disbursement: __WEBPACK_IMPORTED_MODULE_43__disbursement__["a" /* default */],
    setNewParticipantsRoles: __WEBPACK_IMPORTED_MODULE_15__companies__["k" /* setNewParticipantsRoles */],
    getReqLDRates: __WEBPACK_IMPORTED_MODULE_45__reqLDRates__["d" /* getReqLDRates */],
    deleteReqLDRate: __WEBPACK_IMPORTED_MODULE_45__reqLDRates__["b" /* deleteReqLDRate */],
    editReqLDRate: __WEBPACK_IMPORTED_MODULE_45__reqLDRates__["c" /* editReqLDRate */],
    addReqLDRate: __WEBPACK_IMPORTED_MODULE_45__reqLDRates__["a" /* addReqLDRate */],

    sendTrainings: __WEBPACK_IMPORTED_MODULE_47__trainings__["b" /* sendTrainings */],
    deleteTraining: __WEBPACK_IMPORTED_MODULE_47__trainings__["a" /* deleteTraining */],

    pdaGetAll: __WEBPACK_IMPORTED_MODULE_48__prices__["c" /* pdaGetAll */],
    pdaDelete: __WEBPACK_IMPORTED_MODULE_48__prices__["b" /* pdaDelete */],
    pdaUpdate: __WEBPACK_IMPORTED_MODULE_48__prices__["d" /* pdaUpdate */],
    pdaAdd: __WEBPACK_IMPORTED_MODULE_48__prices__["a" /* pdaAdd */],
    getIntegrators: __WEBPACK_IMPORTED_MODULE_44__integrators_integrators__["c" /* getIntegrators */],
    getIntegratorCompanies: __WEBPACK_IMPORTED_MODULE_44__integrators_integrators__["b" /* getIntegratorCompanies */],
    getCompanyUser: __WEBPACK_IMPORTED_MODULE_44__integrators_integrators__["a" /* getCompanyUser */],
    findVesselDesign: __WEBPACK_IMPORTED_MODULE_49__design__["a" /* findVesselDesign */],
    postRequestTc: __WEBPACK_IMPORTED_MODULE_50__tc_requests__["c" /* postRequestTc */],
    getRequestsTc: __WEBPACK_IMPORTED_MODULE_50__tc_requests__["b" /* getRequestsTc */],
    deleteTcRequest: __WEBPACK_IMPORTED_MODULE_50__tc_requests__["a" /* deleteTcRequest */],
    postVesselSale: __WEBPACK_IMPORTED_MODULE_51__vessels_sales__["c" /* postVesselSale */],
    getVesselSales: __WEBPACK_IMPORTED_MODULE_51__vessels_sales__["b" /* getVesselSales */],
    deleteVesselSale: __WEBPACK_IMPORTED_MODULE_51__vessels_sales__["a" /* deleteVesselSale */],

    getAnalyticsLinksList: __WEBPACK_IMPORTED_MODULE_53__analytics_linksList__["d" /* getAnalyticsLinksList */],
    createAnalyticsLinks: __WEBPACK_IMPORTED_MODULE_53__analytics_linksList__["a" /* createAnalyticsLinks */],
    updateAnalyticsLinksList: __WEBPACK_IMPORTED_MODULE_53__analytics_linksList__["f" /* updateAnalyticsLinksList */],
    deleteAnalyticLink: __WEBPACK_IMPORTED_MODULE_53__analytics_linksList__["b" /* deleteAnalyticLink */],
    findAnalyticsTags: __WEBPACK_IMPORTED_MODULE_53__analytics_linksList__["c" /* findAnalyticsTags */],
    addMailerGoogle: __WEBPACK_IMPORTED_MODULE_46__analytics_mailers__["a" /* addMailerGoogle */],
    getInternalMailers: __WEBPACK_IMPORTED_MODULE_46__analytics_mailers__["b" /* getInternalMailers */],
    removeInternalMailer: __WEBPACK_IMPORTED_MODULE_46__analytics_mailers__["c" /* removeInternalMailer */],

    getFlagCompliance: __WEBPACK_IMPORTED_MODULE_54__flagCompliance__["a" /* getFlagCompliance */],
    updateFlagCompliance: __WEBPACK_IMPORTED_MODULE_54__flagCompliance__["b" /* updateFlagCompliance */],

    getVesselSanctions: __WEBPACK_IMPORTED_MODULE_55__sanctions__["a" /* getVesselSanctions */],
    updateVesselCompliance: __WEBPACK_IMPORTED_MODULE_55__sanctions__["b" /* updateVesselCompliance */],

    getEmailsForVesselComposition: __WEBPACK_IMPORTED_MODULE_52__vessels_composition__["b" /* getEmailsForVesselComposition */],
    approveVesselSize: __WEBPACK_IMPORTED_MODULE_52__vessels_composition__["a" /* approveVesselSize */],
    rejectVesselSize: __WEBPACK_IMPORTED_MODULE_52__vessels_composition__["d" /* rejectVesselSize */],
    getVesselsCompositions: __WEBPACK_IMPORTED_MODULE_52__vessels_composition__["c" /* getVesselsCompositions */],
    getPredefinedIndexes: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["d" /* getPredefinedIndexes */],
    getTcHireIdeas: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["e" /* getTcHireIdeas */],
    exportTcIndexes: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["b" /* exportTcIndexes */],
    getVesselDwtTypes: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["f" /* getVesselDwtTypes */],
    approveHireIdea: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["a" /* approveHireIdea */],
    rejectHireIdea: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["h" /* rejectHireIdea */],
    updateHireIdea: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["i" /* updateHireIdea */],
    getVias: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["g" /* getVias */],
    getPortMainRegion: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["c" /* getPortMainRegion */],

    sendToDev: __WEBPACK_IMPORTED_MODULE_53__analytics_linksList__["e" /* sendToDev */],

    hsCodeFind: __WEBPACK_IMPORTED_MODULE_57__hsCodes__["a" /* hsCodeFind */],

    getIssues: __WEBPACK_IMPORTED_MODULE_58__issues__["d" /* getIssues */],
    getIssue: __WEBPACK_IMPORTED_MODULE_58__issues__["c" /* getIssue */],
    updateIssueStatus: __WEBPACK_IMPORTED_MODULE_58__issues__["f" /* updateIssueStatus */],
    addIssueComment: __WEBPACK_IMPORTED_MODULE_58__issues__["a" /* addIssueComment */],
    deleteIssueComment: __WEBPACK_IMPORTED_MODULE_58__issues__["b" /* deleteIssueComment */],
    updateIssueComment: __WEBPACK_IMPORTED_MODULE_58__issues__["e" /* updateIssueComment */],

    saveRequestsDataCreated: __WEBPACK_IMPORTED_MODULE_59__orders__["a" /* saveRequestsDataCreated */],
    saveRequestsDataDeleted: __WEBPACK_IMPORTED_MODULE_59__orders__["b" /* saveRequestsDataDeleted */],

    getHiresList: __WEBPACK_IMPORTED_MODULE_60__hires_requests__["b" /* getHiresList */],
    postRequestHire: __WEBPACK_IMPORTED_MODULE_60__hires_requests__["c" /* postRequestHire */],
    updateHireIdeas: __WEBPACK_IMPORTED_MODULE_60__hires_requests__["d" /* updateHireIdeas */],
    exportHireIdeas: __WEBPACK_IMPORTED_MODULE_60__hires_requests__["a" /* exportHireIdeas */],
    idsConvert: __WEBPACK_IMPORTED_MODULE_61__devUtils__["a" /* idsConvert */],
    idsEntities: __WEBPACK_IMPORTED_MODULE_61__devUtils__["b" /* idsEntities */]
});

var _default = api;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(api, 'api', '/opt/atlassian/pipelines/agent/build/client/app/services/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/services/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return GET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return AUTH_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return LOGOUT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return GET_USER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BAN_USER_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return UNBAN_USER_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return GET_USER_LIMITATIONS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return SET_USER_TO_WHITE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return SET_USER_TO_BLACK_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return TOGGLE_WHITE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADD_USERS_FROM_AUTOCOMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return GET_CARGO_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return GET_CARGO_ASSIGNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return GET_CARGO_ASSIGNERS_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return UPDATE_CARGO_ASSIGNER; });
/* unused harmony export DELETE_CARGO_ASSIGNER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return SAVE_STATUS_CARGO_ASSIGNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return SEARCH_CARGO_ASSIGNERS; });
/* unused harmony export CLEAR_STATUS_CARGO_ASSIGNER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return GET_CARGO_GAZETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return DELETE_CARGO_GAZETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return GET_CARGO_REAL_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return GET_CARGO_REAL_NAMES_PAGINATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return UPDATE_CARGO_REAL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return DELETE_CARGO_REAL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return GET_CARGO_TAGS_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return SAVE_STATUS_CARGO_REAL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLEAR_STATUS_CARGO_REAL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return SEARCH_CARGO_REAL_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return UPDATE_TAGS_DATA_IN_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return GET_CARGOES_BY_TYPE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return GET_CARGO_DUPLICATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DELETE_CARGO_DUPLICATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return SEARCH_CARGO_DUPLICATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLEAR_DUPLICATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return GET_LOADING_AND_DISCHARGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DELETE_LOADING_AND_DISCHARGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return UPDATE_LOADING_AND_DISCHARGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return SEARCH_LOADING_AND_DISCHARGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return SAVE_STATUS_LOADING_AND_DISCHARGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLEAR_STATUS_LOADING_AND_DISCHARGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return GET_ALL_PORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return GET_PORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return GET_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return UPDATE_PORT_SUGGESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return UPDATE_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return UPDATE_PORT_ALT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_NEW_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return SEARCH_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return SAVE_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLEAR_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CHANGE_PORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return GET_AREAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return GET_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return UPDATE_AREA_SUGGESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return UPDATE_AREA_ALT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return UPDATE_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return SEARCH_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return SAVE_AREA; });
/* unused harmony export CLEAR_AREA_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CREATE_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DELETE_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return REMOVE_AREA_CHILD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return GET_TERM_ENTITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return GET_LETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return GET_LETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return UPDATE_LETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return REMOVE_LETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return POST_ANNOTATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return REMOVE_ANNOTATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CREATE_FILTER_ANNOTATIONS_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return GET_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return GET_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DELETE_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return UPDATE_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return UPDATE_PREFERENCE_META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return SELECT_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CHANGE_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLEAR_SELECT_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return GET_MAIL_RECOGNIZE_SPAM_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CREATE_MAIL_RECOGNIZE_SPAM_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return UPDATE_MAIL_RECOGNIZE_SPAM_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return GET_CARGO_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return UPDATE_CARGO_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return REMOVE_LAST_CARGO_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CARGO_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CREATE_CARGO_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLEAR_CARGO_ORDER_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return UPDATE_CARGO_ORDER_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return REMOVE_ALL_CARGO_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return RESET_CARGO_ORDERS; });
/* unused harmony export GET_TC_ORDERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return UPDATE_TC_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return REMOVE_LAST_TC_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_TC_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CREATE_TC_ORDERS; });
/* unused harmony export CLEAR_TC_ORDER_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return UPDATE_TC_ORDER_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return REMOVE_ALL_TC_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return RESET_TC_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return POST_CARGO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return GET_CARGO_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return UPDATE_CARGO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return DELETE_CARGO_REQUEST; });
/* unused harmony export CLEAR_CARGO_REQUEST_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return POST_TC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return GET_TC_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DELETE_TC_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return GET_TC_INDEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return GET_VESSEL_REQUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return POST_VESSEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return UPDATE_VESSEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return DELETE_VESSEL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CONFIRM_VESSEL; });
/* unused harmony export CLEAR_VESSEL_REQUEST_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return GET_VESSEL_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return UPDATE_VESSEL_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return REMOVE_LAST_VESSEL_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_VESSEL_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CREATE_VESSEL_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CLEAR_VESSEL_ORDER_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return UPDATE_VESSEL_ORDER_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return REMOVE_ALL_VESSEL_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return RESET_VESSEL_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return GET_VESSEL_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CREATE_VESSEL_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return UPDATE_VESSEL_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return UPDATE_VESSEL_SIZE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ADD_VESSEL_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return REMOVE_LAST_VESSEL_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return REMOVE_ALL_VESSEL_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return NOTIFICATION_PURPOSE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return GET_VESSEL_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CREATE_VESSEL_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return UPDATE_VESSEL_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return UPDATE_VESSEL_SALE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADD_VESSEL_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return REMOVE_LAST_VESSEL_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return REMOVE_ALL_VESSEL_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return POST_VESSEL_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DELETE_VESSEL_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return RESET_VESSEL_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return GET_VESSELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return GET_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DELETE_NAME_SUGGESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return RENAME_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return UPDATE_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return DELETE_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADD_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return SAVE_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CLEAR_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return UPDATE_VESSEL_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return GET_VESSEL_CLAIMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPT_USER_CLAIMS_TO_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return REJECT_USER_CLAIMS_TO_VESSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return POST_GAZETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return SAVE_GAZETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return SAVE_GAZETTERS_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return REMOVE_GAZETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return LIST_GAZETTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return GET_CONTRACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return GET_TIME_CONTRACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DELETE_NOTIFICATION; });
/* unused harmony export CLEAR_NOTIFICATIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return GET_BACKEND_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return GET_BACKEND_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return UPDATE_BACKEND_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return DELETE_BACKEND_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CREATE_BACKEND_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return GET_COUNTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return GET_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return GET_REAL_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return GET_ANALYTICS_LINKS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return SEND_TRAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ADD_YARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return FIND_YARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return GET_YARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return GET_STATISTICS_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return SEARCH_STATISTICS_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return GET_STATISTICS_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return SEARCH_STATISTICS_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return GET_STATISTICS_MONITOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return SEARCH_STATISTICS_MONITOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return GET_STATISTICS_CARGO_REQUESTS; });
/* unused harmony export SEARCH_STATISTICS_CARGO_REQUESTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return GET_STATISTICS_VESSEL_POSITIONS; });
/* unused harmony export SEARCH_STATISTICS_VESSEL_POSITIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return GET_SEND_EMAIL_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return GET_SEND_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CONNECT_NEW_DOMAIN_TO_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return DELETE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return GET_LIST_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return GET_SUBSCRIBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return GET_REQ_LD_RATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DELETE_REQ_LD_RATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return EDIT_REQ_LD_RATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return SEND_GAZETTER_TRAININGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return DELETE_GAZETTER_TRAINING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return GET_INTEGRATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return GET_INTEGRATOR_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return GET_COMPANY_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return GET_FLAG_COMPLIANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return GET_ISSUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return GET_ISSUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return UPDATE_ISSUE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ISSUE_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return UPDATE_ISSUE_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DELETE_ISSUE_COMMENT; });
/* unused harmony export SAVE_REQUESTS_DATA_CREATED */
/* unused harmony export SAVE_REQUESTS_DATA_DELETED */
/* unused harmony export UPDATE_HIRE_ORDER */
/* unused harmony export REMOVE_LAST_HIRE_ORDER */
/* unused harmony export ADD_HIRE_ORDER */
/* unused harmony export CREATE_HIRE_ORDERS */
/* unused harmony export UPDATE_HIRE_ORDER_USER */
/* unused harmony export REMOVE_ALL_HIRE_ORDERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return GET_HIRE_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return POST_HIRE_REQUEST; });
/* unused harmony export UPDATE_HIRE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DELETE_HIRE_REQUEST; });
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

var REQUEST = 'REQUEST';
var SUCCESS = 'SUCCESS';
var FAILURE = 'FAILURE';

/**
 * @typedef {Object} RequestTypes
 * @property {string} REQUEST - The request type.
 * @property {string} SUCCESS - The success type.
 * @property {string} FAILURE - The failure type.
 */

/**
 * Creates request types based on the provided base.
 *
 * @param {string} base - The base string for creating request types.
 * @returns {RequestTypes} The request types object.
 */
function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce(function (acc, type) {
    acc[type] = base + '_' + type;
    return acc;
  }, /** @type {RequestTypes} */{});
}

/**
 * User
 * */
var GET_USER = createRequestTypes('GET_USER');
var AUTH_USER = createRequestTypes('AUTH_USER');
var LOGOUT_USER = createRequestTypes('LOGOUT_USER');
var GET_USER_LIST = createRequestTypes('GET_USER_LIST');
var BAN_USER_BY_ID = createRequestTypes('BAN_USER_BY_ID');
var UNBAN_USER_BY_ID = createRequestTypes('UNBAN_USER_BY_ID');
var GET_USER_LIMITATIONS_LIST = createRequestTypes('GET_USER_LIMITATIONS_LIST');
var SET_USER_TO_WHITE_LIST = createRequestTypes('SET_USER_TO_WHITE_LIST');
var SET_USER_TO_BLACK_LIST = createRequestTypes('SET_USER_TO_BLACK_LIST');
var TOGGLE_WHITE_LIST = createRequestTypes('TOGGLE_WHITE_LIST');
var ADD_USERS_FROM_AUTOCOMPLETE = 'ADD_USERS_FROM_AUTOCOMPLETE';

/**
 * Cargo types
 * */
var GET_CARGO_TYPES = createRequestTypes('GET_CARGO_TYPES');

/**
 * Cargo assigners
 * */
var GET_CARGO_ASSIGNERS = createRequestTypes('GET_CARGO_ASSIGNERS');
var GET_CARGO_ASSIGNERS_POST = createRequestTypes('GET_CARGO_ASSIGNERS_POST');
var UPDATE_CARGO_ASSIGNER = createRequestTypes('UPDATE_CARGO_ASSIGNER');
var DELETE_CARGO_ASSIGNER = createRequestTypes('DELETE_CARGO_ASSIGNER');
var SAVE_STATUS_CARGO_ASSIGNER = 'SAVE_STATUS_CARGO_ASSIGNER';
var SEARCH_CARGO_ASSIGNERS = 'SEARCH_CARGO_ASSIGNERS';
var CLEAR_STATUS_CARGO_ASSIGNER = 'CLEAR_STATUS_CARGO_ASSIGNER';

/**
 * Cargo gazetters
 */
var GET_CARGO_GAZETTERS = createRequestTypes('GET_CARGO_GAZETTERS');
var DELETE_CARGO_GAZETTER = createRequestTypes('DELETE_CARGO_GAZETTER');

/**
 * Cargo real names
 * */
var GET_CARGO_REAL_NAMES = createRequestTypes('GET_CARGO_REAL_NAMES');
var GET_CARGO_REAL_NAMES_PAGINATED = createRequestTypes('GET_CARGO_REAL_NAMES_PAGINATED');
var UPDATE_CARGO_REAL_NAME = createRequestTypes('UPDATE_CARGO_REAL_NAME');
var DELETE_CARGO_REAL_NAME = createRequestTypes('DELETE_CARGO_REAL_NAME');
var GET_CARGO_TAGS_CATEGORIES = createRequestTypes('GET_CARGO_TAGS_CATEGORIES');
var SAVE_STATUS_CARGO_REAL_NAME = 'SAVE_STATUS_CARGO_REAL_NAME';
var CLEAR_STATUS_CARGO_REAL_NAME = 'CLEAR_STATUS_CARGO_REAL_NAME';
var SEARCH_CARGO_REAL_NAMES = 'SEARCH_CARGO_REAL_NAMES';
var UPDATE_TAGS_DATA_IN_ROW = 'UPDATE_TAGS_DATA_IN_ROW';

/**
 * Cargoes common
 */
var GET_CARGOES_BY_TYPE_NAME = createRequestTypes('GET_CARGOES_BY_TYPE_NAME');

/**
 * Cargo duplicates
 * */
var GET_CARGO_DUPLICATES = createRequestTypes('GET_CARGO_DUPLICATES');
var DELETE_CARGO_DUPLICATE = createRequestTypes('DELETE_CARGO_DUPLICATE');
var SEARCH_CARGO_DUPLICATES = 'SEARCH_CARGO_DUPLICATES';
var CLEAR_DUPLICATES = 'CLEAR_DUPLICATES';

/**
 * Cargo loading and discharging
 * */
var GET_LOADING_AND_DISCHARGING = createRequestTypes('GET_LOADING_AND_DISCHARGING');
var DELETE_LOADING_AND_DISCHARGING = createRequestTypes('DELETE_LOADING_AND_DISCHARGING');
var UPDATE_LOADING_AND_DISCHARGING = createRequestTypes('UPDATE_LOADING_AND_DISCHARGING');
var SEARCH_LOADING_AND_DISCHARGING = 'SEARCH_LOADING_AND_DISCHARGING';
var SAVE_STATUS_LOADING_AND_DISCHARGING = 'SAVE_STATUS_LOADING_AND_DISCHARGING';
var CLEAR_STATUS_LOADING_AND_DISCHARGING = 'CLEAR_STATUS_LOADING_AND_DISCHARGING';

/**
 * Ports
 * */
var GET_ALL_PORTS = createRequestTypes('GET_ALL_PORTS');
var GET_PORTS = createRequestTypes('GET_PORTS');
var GET_PORT = createRequestTypes('GET_PORT');
var UPDATE_PORT_SUGGESTIONS = 'UPDATE_PORT_SUGGESTIONS';
var UPDATE_PORT = createRequestTypes('UPDATE_PORT');
var UPDATE_PORT_ALT = createRequestTypes('UPDATE_PORT_ALT');
var ADD_NEW_PORT = createRequestTypes('ADD_NEW_PORT');
var SEARCH_PORT = 'SEARCH_PORT';
var SAVE_PORT = 'SAVE_PORT';
var CLEAR_PORT = 'CLEAR_PORT';
var CHANGE_PORT = 'CHANGE_PORT';

/**
 * Areas
 * */
var GET_AREAS = createRequestTypes('GET_AREAS');
var GET_AREA = createRequestTypes('GET_AREA');
var UPDATE_AREA_SUGGESTIONS = 'UPDATE_AREA_SUGGESTIONS';
var UPDATE_AREA_ALT = createRequestTypes('UPDATE_AREA_ALT');
var UPDATE_AREA = createRequestTypes('UPDATE_AREA');
var SEARCH_AREA = 'SEARCH_AREA';
var SAVE_AREA = 'SAVE_AREA';
var CLEAR_AREA_STATUS = 'CLEAR_AREA_STATUS';
var CREATE_AREA = createRequestTypes('CREATE_AREA');
var DELETE_AREA = createRequestTypes('DELETE_AREA');
var REMOVE_AREA_CHILD = createRequestTypes('REMOVE_AREA_CHILD');

/**
 * Cargo entities
 * */
var GET_TERM_ENTITIES = createRequestTypes('GET_TERM_ENTITIES');

/**
 * Letters
 * */
var GET_LETTERS = 'GET_LETTERS';
var GET_LETTER = createRequestTypes('GET_LETTER');
var UPDATE_LETTER = createRequestTypes('UPDATE_LETTER');
var REMOVE_LETTER = 'REMOVE_LETTER';

/**
 * Annotations
 * */
var POST_ANNOTATIONS = createRequestTypes('POST_ANNOTATIONS');
var REMOVE_ANNOTATIONS = 'REMOVE_ANNOTATIONS';

/**
 * preference
 * */
var CREATE_FILTER_ANNOTATIONS_PREFERENCE = createRequestTypes('CREATE_FILTER_ANNOTATIONS_PREFERENCE');

/**
 * preference
 * */
var GET_PREFERENCES = createRequestTypes('GET_PREFERENCES');
var GET_PREFERENCE = createRequestTypes('GET_PREFERENCE');
var DELETE_PREFERENCE = createRequestTypes('DELETE_PREFERENCE');
var UPDATE_PREFERENCE = createRequestTypes('UPDATE_PREFERENCE');
var UPDATE_PREFERENCE_META = createRequestTypes('UPDATE_PREFERENCE_META');
var SELECT_PREFERENCE = 'SELECT_PREFERENCE';
var CHANGE_PREFERENCE = 'CHANGE_PREFERENCE';
var CLEAR_SELECT_PREFERENCE = 'CLEAR_SELECT_PREFERENCE';

/**
 * ADMIN PANEL - preference
 * */
var GET_MAIL_RECOGNIZE_SPAM_LIST = createRequestTypes('GET_MAIL_RECOGNIZE_SPAM_LIST');
var CREATE_MAIL_RECOGNIZE_SPAM_LIST = createRequestTypes('CREATE_MAIL_RECOGNIZE_SPAM_LIST');
var UPDATE_MAIL_RECOGNIZE_SPAM_LIST = createRequestTypes('UPDATE_MAIL_RECOGNIZE_SPAM_LIST');

/**
 * Cargo orders
 * */
var GET_CARGO_ORDERS = 'GET_CARGO_ORDERS';
var UPDATE_CARGO_ORDER = 'UPDATE_CARGO_ORDER';
var REMOVE_LAST_CARGO_ORDER = 'REMOVE_LAST_CARGO_ORDER';
var ADD_CARGO_ORDER = 'ADD_CARGO_ORDER';
var CREATE_CARGO_ORDERS = 'CREATE_CARGO_ORDERS';
var CLEAR_CARGO_ORDER_MESSAGE = 'CLEAR_CARGO_ORDER_MESSAGE';
var UPDATE_CARGO_ORDER_USER = 'UPDATE_CARGO_ORDER_USER';
var REMOVE_ALL_CARGO_ORDERS = 'REMOVE_ALL_CARGO_ORDERS';
var RESET_CARGO_ORDERS = 'RESET_CARGO_ORDERS';

/**
 * Tc orders
 * */
var GET_TC_ORDERS = 'GET_TC_ORDERS';
var UPDATE_TC_ORDER = 'UPDATE_TC_ORDER';
var REMOVE_LAST_TC_ORDER = 'REMOVE_LAST_TC_ORDER';
var ADD_TC_ORDER = 'ADD_TC_ORDER';
var CREATE_TC_ORDERS = 'CREATE_TC_ORDERS';
var CLEAR_TC_ORDER_MESSAGE = 'CLEAR_TC_ORDER_MESSAGE';
var UPDATE_TC_ORDER_USER = 'UPDATE_TC_ORDER_USER';
var REMOVE_ALL_TC_ORDERS = 'REMOVE_ALL_TC_ORDERS';
var RESET_TC_ORDERS = 'RESET_TC_ORDERS';

/**
 * Cargo request
 * */
var POST_CARGO_REQUEST = createRequestTypes('POST_CARGO_REQUEST');
var GET_CARGO_REQUESTS = createRequestTypes('GET_CARGO_REQUESTS');
var UPDATE_CARGO_REQUEST = createRequestTypes('UPDATE_CARGO_REQUEST');
var DELETE_CARGO_REQUEST = createRequestTypes('DELETE_CARGO_REQUEST');
var CLEAR_CARGO_REQUEST_MESSAGE = 'CLEAR_CARGO_REQUEST_MESSAGE';

/**
 * TC request
 * */
var POST_TC_REQUEST = createRequestTypes('POST_TC_REQUEST');
var GET_TC_REQUESTS = createRequestTypes('GET_TC_REQUESTS');
var DELETE_TC_REQUEST = createRequestTypes('DELETE_TC_REQUEST');

/** Tc index
 */
var GET_TC_INDEXES = createRequestTypes('GET_TC_INDEXES');
/**
 * Vessel request
 * */
var GET_VESSEL_REQUESTS = createRequestTypes('GET_VESSEL_REQUESTS');
var POST_VESSEL_REQUEST = createRequestTypes('POST_VESSEL_REQUEST');
var UPDATE_VESSEL_REQUEST = createRequestTypes('UPDATE_VESSEL_REQUEST');
var DELETE_VESSEL_REQUEST = createRequestTypes('DELETE_VESSEL_REQUEST');
var CONFIRM_VESSEL = createRequestTypes('CONFIRM_VESSEL');
var CLEAR_VESSEL_REQUEST_MESSAGE = 'CLEAR_VESSEL_REQUEST_MESSAGE';

/**
 * Vessel orders
 * */
var GET_VESSEL_ORDERS = 'GET_VESSEL_ORDERS';
var UPDATE_VESSEL_ORDER = 'UPDATE_VESSEL_ORDER';
var REMOVE_LAST_VESSEL_ORDER = 'REMOVE_LAST_VESSEL_ORDER';
var ADD_VESSEL_ORDER = 'ADD_VESSEL_ORDER';
var CREATE_VESSEL_ORDERS = 'CREATE_VESSEL_ORDERS';
var CLEAR_VESSEL_ORDER_MESSAGE = 'CLEAR_VESSEL_ORDER_MESSAGE';
var UPDATE_VESSEL_ORDER_USER = 'UPDATE_VESSEL_ORDER_USER';
var REMOVE_ALL_VESSEL_ORDERS = 'REMOVE_ALL_VESSEL_ORDERS';
var RESET_VESSEL_ORDERS = 'RESET_VESSEL_ORDERS';

/**
 * Vessel sizes
 */
var GET_VESSEL_SIZES = 'GET_VESSEL_SIZES';
var CREATE_VESSEL_SIZES = 'CREATE_VESSEL_SIZES';
var UPDATE_VESSEL_SIZE = 'UPDATE_VESSEL_SIZE';
var UPDATE_VESSEL_SIZE_USER = 'UPDATE_VESSEL_SIZE_USER';
var ADD_VESSEL_SIZE = 'ADD_VESSEL_SIZE';
var REMOVE_LAST_VESSEL_SIZE = 'REMOVE_LAST_VESSEL_SIZE';
var REMOVE_ALL_VESSEL_SIZES = 'REMOVE_ALL_VESSEL_SIZES';

var NOTIFICATION_PURPOSE_REQUIRED = 'NOTIFICATION_PURPOSE_REQUIRED';

/**
 * Vessel sales
 */
var GET_VESSEL_SALES = createRequestTypes('GET_VESSEL_SALES');
var CREATE_VESSEL_SALES = 'CREATE_VESSEL_SALES';
var UPDATE_VESSEL_SALE = 'UPDATE_VESSEL_SALE';
var UPDATE_VESSEL_SALE_USER = 'UPDATE_VESSEL_SALE_USER';
var ADD_VESSEL_SALE = 'ADD_VESSEL_SALE';
var REMOVE_LAST_VESSEL_SALE = 'REMOVE_LAST_VESSEL_SALE';
var REMOVE_ALL_VESSEL_SALES = 'REMOVE_ALL_VESSEL_SALES';
var POST_VESSEL_SALE = createRequestTypes('POST_VESSEL_SALE');
var DELETE_VESSEL_SALE = createRequestTypes('DELETE_VESSEL_SALE');
var RESET_VESSEL_SALES = 'RESET_VESSEL_SALES';
/**
 * Vessels
 * */
var GET_VESSELS = createRequestTypes('GET_VESSELS');
var GET_VESSEL = createRequestTypes('GET_VESSEL');
var DELETE_NAME_SUGGESTION = createRequestTypes('DELETE_NAME_SUGGESTION');
var RENAME_VESSEL = createRequestTypes('RENAME_VESSEL');
var UPDATE_VESSEL = createRequestTypes('UPDATE_VESSEL');
var DELETE_VESSEL = createRequestTypes('DELETE_VESSEL');
var ADD_VESSEL = createRequestTypes('ADD_VESSEL');
var SAVE_VESSEL = 'SAVE_VESSEL';
var CLEAR_VESSEL = 'CLEAR_VESSEL';
var UPDATE_VESSEL_IMAGE = createRequestTypes('UPDATE_VESSEL_IMAGE');

/**
 * Vessel claims
 * */
var GET_VESSEL_CLAIMS = createRequestTypes('GET_VESSEL_CLAIMS');
var ACCEPT_USER_CLAIMS_TO_VESSEL = createRequestTypes('ACCEPT_USER_CLAIMS_TO_VESSEL');
var REJECT_USER_CLAIMS_TO_VESSEL = createRequestTypes('REJECT_USER_CLAIMS_TO_VESSEL');

/**
 * Gazetters
 * */
var POST_GAZETTERS = createRequestTypes('POST_GAZETTERS');
var SAVE_GAZETTERS = createRequestTypes('SAVE_GAZETTERS');
var SAVE_GAZETTERS_NEW = createRequestTypes('SAVE_GAZETTERS_NEW');
var REMOVE_GAZETTERS = 'REMOVE_GAZETTERS';
var LIST_GAZETTERS = createRequestTypes('LIST_GAZETTERS');

/**
 * Contracts
 * */
var GET_CONTRACTS = createRequestTypes('GET_CONTRACTS');
var GET_TIME_CONTRACTS = createRequestTypes('GET_TIME_CONTRACTS');

/**
 * Notifications
 * */
var ADD_NOTIFICATION = 'ADD_NOTIFICATION';
var DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
var CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

var GET_BACKEND_NOTIFICATIONS = createRequestTypes('GET_BACKEND_NOTIFICATIONS');
var GET_BACKEND_NOTIFICATION = createRequestTypes('GET_BACKEND_NOTIFICATIONS');
var UPDATE_BACKEND_NOTIFICATION = createRequestTypes('UPDATE_BACKEND_NOTIFICATION');
var DELETE_BACKEND_NOTIFICATION = createRequestTypes('DELETE_BACKEND_NOTIFICATION');
var CREATE_BACKEND_NOTIFICATION = createRequestTypes('CREATE_BACKEND_NOTIFICATION');

/**
 * Countries
 * */
var GET_COUNTRIES = createRequestTypes('GET_COUNTRIES');

/**
 * Companies
 * */
var GET_COMPANIES = createRequestTypes('GET_COMPANIES');
var GET_REAL_COMPANIES = createRequestTypes('GET_REAL_COMPANIES');

/**
 * Analytics dashboard
 */
var GET_ANALYTICS_LINKS_LIST = createRequestTypes('GET_ANALYTICS_LINKS_LIST');

/**
 * Companies
 * */
var SEND_TRAIN = createRequestTypes('SEND_TRAIN');

/**
 * Yards
 */
var ADD_YARD = createRequestTypes('ADD_YARD');
var FIND_YARDS = createRequestTypes('FIND_YARDS');
var GET_YARD = createRequestTypes('GET_YARD');

/**
 * Statistics
 * */
var GET_STATISTICS_USERS = createRequestTypes('GET_STATISTICS_USERS');
var SEARCH_STATISTICS_USERS = 'SEARCH_STATISTICS_USERS';

var GET_STATISTICS_EMAILS = createRequestTypes('GET_STATISTICS_EMAILS');
var SEARCH_STATISTICS_EMAILS = 'SEARCH_STATISTICS_EMAILS';

var GET_STATISTICS_MONITOR = createRequestTypes('GET_STATISTICS_MONITOR');
var SEARCH_STATISTICS_MONITOR = 'SEARCH_STATISTICS_MONITOR';

var GET_STATISTICS_CARGO_REQUESTS = createRequestTypes('GET_STATISTICS_CARGO_REQUESTS');
var SEARCH_STATISTICS_CARGO_REQUESTS = 'SEARCH_STATISTICS_CARGO_REQUESTS';

var GET_STATISTICS_VESSEL_POSITIONS = createRequestTypes('GET_STATISTICS_VESSEL_POSITIONS');
var SEARCH_STATISTICS_VESSEL_POSITIONS = 'SEARCH_STATISTICS_VESSEL_POSITIONS';

/**
 * Sender
 * */
var GET_SEND_EMAIL_LIST = createRequestTypes('GET_SEND_EMAIL_LIST');
var GET_SEND_EMAIL = createRequestTypes('GET_SEND_EMAIL');

/**
 * Domains
 * */
var CONNECT_NEW_DOMAIN_TO_USER = createRequestTypes('CONNECT_NEW_DOMAIN_TO_USER');
var DELETE_DOMAIN = createRequestTypes('DELETE_DOMAIN');
var GET_LIST_DOMAIN = createRequestTypes('GET_LIST_DOMAIN');

/**
 * Subscribers
 * */
var GET_SUBSCRIBERS = createRequestTypes('GET_SUBSCRIBERS');

/**
 * LD Rates
 */
var GET_REQ_LD_RATES = createRequestTypes('GET_REQ_LD_RATES');
var DELETE_REQ_LD_RATES = createRequestTypes('DELETE_REQ_LD_RATES');
var EDIT_REQ_LD_RATES = createRequestTypes('EDIT_REQ_LD_RATES');

// Gazetters trainings
var SEND_GAZETTER_TRAININGS = createRequestTypes('SEND_GAZETTER_TRAININGS');
var DELETE_GAZETTER_TRAINING = createRequestTypes('DELETE_GAZETTER_TRAINING');
// integrators

var GET_INTEGRATORS = createRequestTypes('GET_INTEGRATORS');

// integrator companies

var GET_INTEGRATOR_COMPANIES = createRequestTypes('GET_INTEGRATOR_COMPANIES');

// company user
var GET_COMPANY_USER = createRequestTypes('GET_COMPANY_USER');

// flag compliance
var GET_FLAG_COMPLIANCE = createRequestTypes('GET_FLAG_COMPLIANCE');

// issue reports
var GET_ISSUES = createRequestTypes('GET_ISSUES');
var GET_ISSUE = createRequestTypes('GET_ISSUE');
var UPDATE_ISSUE_STATUS = createRequestTypes('UPDATE_ISSUE_STATUS');
var ADD_ISSUE_COMMENT = createRequestTypes('ADD_ISSUE_COMMENT');
var UPDATE_ISSUE_COMMENT = createRequestTypes('UPDATE_ISSUE_COMMENT');
var DELETE_ISSUE_COMMENT = createRequestTypes('DELETE_ISSUE_COMMENT');

// save requests data
var SAVE_REQUESTS_DATA_CREATED = createRequestTypes('SAVE_REQUESTS_DATA_CREATED');
var SAVE_REQUESTS_DATA_DELETED = createRequestTypes('SAVE_REQUESTS_DATA_DELETED');

/**
 * Hires
 * */
var UPDATE_HIRE_ORDER = 'UPDATE_HIRE_ORDER';
var REMOVE_LAST_HIRE_ORDER = 'REMOVE_LAST_HIRE_ORDER';
var ADD_HIRE_ORDER = 'ADD_HIRE_ORDER';
var CREATE_HIRE_ORDERS = 'CREATE_HIRE_ORDERS';
var UPDATE_HIRE_ORDER_USER = 'UPDATE_HIRE_ORDER_USER';
var REMOVE_ALL_HIRE_ORDERS = 'REMOVE_ALL_HIRE_ORDERS';

/**
 * Hire request
 * */
var GET_HIRE_ORDERS = createRequestTypes('GET_HIRE_ORDERS');
var POST_HIRE_REQUEST = createRequestTypes('POST_HIRE_REQUEST');
var UPDATE_HIRE_REQUEST = createRequestTypes('UPDATE_HIRE_REQUEST');
var DELETE_HIRE_REQUEST = createRequestTypes('DELETE_HIRE_REQUEST');
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(REQUEST, 'REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SUCCESS, 'SUCCESS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(FAILURE, 'FAILURE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(createRequestTypes, 'createRequestTypes', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_USER, 'GET_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(AUTH_USER, 'AUTH_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(LOGOUT_USER, 'LOGOUT_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_USER_LIST, 'GET_USER_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(BAN_USER_BY_ID, 'BAN_USER_BY_ID', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UNBAN_USER_BY_ID, 'UNBAN_USER_BY_ID', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_USER_LIMITATIONS_LIST, 'GET_USER_LIMITATIONS_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SET_USER_TO_WHITE_LIST, 'SET_USER_TO_WHITE_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SET_USER_TO_BLACK_LIST, 'SET_USER_TO_BLACK_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(TOGGLE_WHITE_LIST, 'TOGGLE_WHITE_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_USERS_FROM_AUTOCOMPLETE, 'ADD_USERS_FROM_AUTOCOMPLETE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_TYPES, 'GET_CARGO_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_ASSIGNERS, 'GET_CARGO_ASSIGNERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_ASSIGNERS_POST, 'GET_CARGO_ASSIGNERS_POST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_CARGO_ASSIGNER, 'UPDATE_CARGO_ASSIGNER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_CARGO_ASSIGNER, 'DELETE_CARGO_ASSIGNER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_STATUS_CARGO_ASSIGNER, 'SAVE_STATUS_CARGO_ASSIGNER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_CARGO_ASSIGNERS, 'SEARCH_CARGO_ASSIGNERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_STATUS_CARGO_ASSIGNER, 'CLEAR_STATUS_CARGO_ASSIGNER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_GAZETTERS, 'GET_CARGO_GAZETTERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_CARGO_GAZETTER, 'DELETE_CARGO_GAZETTER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_REAL_NAMES, 'GET_CARGO_REAL_NAMES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_REAL_NAMES_PAGINATED, 'GET_CARGO_REAL_NAMES_PAGINATED', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_CARGO_REAL_NAME, 'UPDATE_CARGO_REAL_NAME', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_CARGO_REAL_NAME, 'DELETE_CARGO_REAL_NAME', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_TAGS_CATEGORIES, 'GET_CARGO_TAGS_CATEGORIES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_STATUS_CARGO_REAL_NAME, 'SAVE_STATUS_CARGO_REAL_NAME', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_STATUS_CARGO_REAL_NAME, 'CLEAR_STATUS_CARGO_REAL_NAME', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_CARGO_REAL_NAMES, 'SEARCH_CARGO_REAL_NAMES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_TAGS_DATA_IN_ROW, 'UPDATE_TAGS_DATA_IN_ROW', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGOES_BY_TYPE_NAME, 'GET_CARGOES_BY_TYPE_NAME', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_DUPLICATES, 'GET_CARGO_DUPLICATES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_CARGO_DUPLICATE, 'DELETE_CARGO_DUPLICATE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_CARGO_DUPLICATES, 'SEARCH_CARGO_DUPLICATES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_DUPLICATES, 'CLEAR_DUPLICATES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_LOADING_AND_DISCHARGING, 'GET_LOADING_AND_DISCHARGING', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_LOADING_AND_DISCHARGING, 'DELETE_LOADING_AND_DISCHARGING', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_LOADING_AND_DISCHARGING, 'UPDATE_LOADING_AND_DISCHARGING', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_LOADING_AND_DISCHARGING, 'SEARCH_LOADING_AND_DISCHARGING', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_STATUS_LOADING_AND_DISCHARGING, 'SAVE_STATUS_LOADING_AND_DISCHARGING', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_STATUS_LOADING_AND_DISCHARGING, 'CLEAR_STATUS_LOADING_AND_DISCHARGING', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_ALL_PORTS, 'GET_ALL_PORTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_PORTS, 'GET_PORTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_PORT, 'GET_PORT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_PORT_SUGGESTIONS, 'UPDATE_PORT_SUGGESTIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_PORT, 'UPDATE_PORT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_PORT_ALT, 'UPDATE_PORT_ALT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_NEW_PORT, 'ADD_NEW_PORT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_PORT, 'SEARCH_PORT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_PORT, 'SAVE_PORT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_PORT, 'CLEAR_PORT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CHANGE_PORT, 'CHANGE_PORT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_AREAS, 'GET_AREAS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_AREA, 'GET_AREA', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_AREA_SUGGESTIONS, 'UPDATE_AREA_SUGGESTIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_AREA_ALT, 'UPDATE_AREA_ALT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_AREA, 'UPDATE_AREA', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_AREA, 'SEARCH_AREA', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_AREA, 'SAVE_AREA', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_AREA_STATUS, 'CLEAR_AREA_STATUS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_AREA, 'CREATE_AREA', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_AREA, 'DELETE_AREA', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_AREA_CHILD, 'REMOVE_AREA_CHILD', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_TERM_ENTITIES, 'GET_TERM_ENTITIES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_LETTERS, 'GET_LETTERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_LETTER, 'GET_LETTER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_LETTER, 'UPDATE_LETTER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_LETTER, 'REMOVE_LETTER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(POST_ANNOTATIONS, 'POST_ANNOTATIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_ANNOTATIONS, 'REMOVE_ANNOTATIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_FILTER_ANNOTATIONS_PREFERENCE, 'CREATE_FILTER_ANNOTATIONS_PREFERENCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_PREFERENCES, 'GET_PREFERENCES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_PREFERENCE, 'GET_PREFERENCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_PREFERENCE, 'DELETE_PREFERENCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_PREFERENCE, 'UPDATE_PREFERENCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_PREFERENCE_META, 'UPDATE_PREFERENCE_META', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SELECT_PREFERENCE, 'SELECT_PREFERENCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CHANGE_PREFERENCE, 'CHANGE_PREFERENCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_SELECT_PREFERENCE, 'CLEAR_SELECT_PREFERENCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_MAIL_RECOGNIZE_SPAM_LIST, 'GET_MAIL_RECOGNIZE_SPAM_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_MAIL_RECOGNIZE_SPAM_LIST, 'CREATE_MAIL_RECOGNIZE_SPAM_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_MAIL_RECOGNIZE_SPAM_LIST, 'UPDATE_MAIL_RECOGNIZE_SPAM_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_ORDERS, 'GET_CARGO_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_CARGO_ORDER, 'UPDATE_CARGO_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_LAST_CARGO_ORDER, 'REMOVE_LAST_CARGO_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_CARGO_ORDER, 'ADD_CARGO_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_CARGO_ORDERS, 'CREATE_CARGO_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_CARGO_ORDER_MESSAGE, 'CLEAR_CARGO_ORDER_MESSAGE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_CARGO_ORDER_USER, 'UPDATE_CARGO_ORDER_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_ALL_CARGO_ORDERS, 'REMOVE_ALL_CARGO_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(RESET_CARGO_ORDERS, 'RESET_CARGO_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_TC_ORDERS, 'GET_TC_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_TC_ORDER, 'UPDATE_TC_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_LAST_TC_ORDER, 'REMOVE_LAST_TC_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_TC_ORDER, 'ADD_TC_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_TC_ORDERS, 'CREATE_TC_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_TC_ORDER_MESSAGE, 'CLEAR_TC_ORDER_MESSAGE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_TC_ORDER_USER, 'UPDATE_TC_ORDER_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_ALL_TC_ORDERS, 'REMOVE_ALL_TC_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(RESET_TC_ORDERS, 'RESET_TC_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(POST_CARGO_REQUEST, 'POST_CARGO_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CARGO_REQUESTS, 'GET_CARGO_REQUESTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_CARGO_REQUEST, 'UPDATE_CARGO_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_CARGO_REQUEST, 'DELETE_CARGO_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_CARGO_REQUEST_MESSAGE, 'CLEAR_CARGO_REQUEST_MESSAGE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(POST_TC_REQUEST, 'POST_TC_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_TC_REQUESTS, 'GET_TC_REQUESTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_TC_REQUEST, 'DELETE_TC_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_TC_INDEXES, 'GET_TC_INDEXES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_VESSEL_REQUESTS, 'GET_VESSEL_REQUESTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(POST_VESSEL_REQUEST, 'POST_VESSEL_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_REQUEST, 'UPDATE_VESSEL_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_VESSEL_REQUEST, 'DELETE_VESSEL_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CONFIRM_VESSEL, 'CONFIRM_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_VESSEL_REQUEST_MESSAGE, 'CLEAR_VESSEL_REQUEST_MESSAGE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_VESSEL_ORDERS, 'GET_VESSEL_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_ORDER, 'UPDATE_VESSEL_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_LAST_VESSEL_ORDER, 'REMOVE_LAST_VESSEL_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_VESSEL_ORDER, 'ADD_VESSEL_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_VESSEL_ORDERS, 'CREATE_VESSEL_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_VESSEL_ORDER_MESSAGE, 'CLEAR_VESSEL_ORDER_MESSAGE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_ORDER_USER, 'UPDATE_VESSEL_ORDER_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_ALL_VESSEL_ORDERS, 'REMOVE_ALL_VESSEL_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(RESET_VESSEL_ORDERS, 'RESET_VESSEL_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_VESSEL_SIZES, 'GET_VESSEL_SIZES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_VESSEL_SIZES, 'CREATE_VESSEL_SIZES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_SIZE, 'UPDATE_VESSEL_SIZE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_SIZE_USER, 'UPDATE_VESSEL_SIZE_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_VESSEL_SIZE, 'ADD_VESSEL_SIZE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_LAST_VESSEL_SIZE, 'REMOVE_LAST_VESSEL_SIZE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_ALL_VESSEL_SIZES, 'REMOVE_ALL_VESSEL_SIZES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(NOTIFICATION_PURPOSE_REQUIRED, 'NOTIFICATION_PURPOSE_REQUIRED', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_VESSEL_SALES, 'GET_VESSEL_SALES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_VESSEL_SALES, 'CREATE_VESSEL_SALES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_SALE, 'UPDATE_VESSEL_SALE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_SALE_USER, 'UPDATE_VESSEL_SALE_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_VESSEL_SALE, 'ADD_VESSEL_SALE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_LAST_VESSEL_SALE, 'REMOVE_LAST_VESSEL_SALE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_ALL_VESSEL_SALES, 'REMOVE_ALL_VESSEL_SALES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(POST_VESSEL_SALE, 'POST_VESSEL_SALE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_VESSEL_SALE, 'DELETE_VESSEL_SALE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(RESET_VESSEL_SALES, 'RESET_VESSEL_SALES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_VESSELS, 'GET_VESSELS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_VESSEL, 'GET_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_NAME_SUGGESTION, 'DELETE_NAME_SUGGESTION', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(RENAME_VESSEL, 'RENAME_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL, 'UPDATE_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_VESSEL, 'DELETE_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_VESSEL, 'ADD_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_VESSEL, 'SAVE_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_VESSEL, 'CLEAR_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_VESSEL_IMAGE, 'UPDATE_VESSEL_IMAGE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_VESSEL_CLAIMS, 'GET_VESSEL_CLAIMS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ACCEPT_USER_CLAIMS_TO_VESSEL, 'ACCEPT_USER_CLAIMS_TO_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REJECT_USER_CLAIMS_TO_VESSEL, 'REJECT_USER_CLAIMS_TO_VESSEL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(POST_GAZETTERS, 'POST_GAZETTERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_GAZETTERS, 'SAVE_GAZETTERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_GAZETTERS_NEW, 'SAVE_GAZETTERS_NEW', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_GAZETTERS, 'REMOVE_GAZETTERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(LIST_GAZETTERS, 'LIST_GAZETTERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_CONTRACTS, 'GET_CONTRACTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_TIME_CONTRACTS, 'GET_TIME_CONTRACTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_NOTIFICATION, 'ADD_NOTIFICATION', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_NOTIFICATION, 'DELETE_NOTIFICATION', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CLEAR_NOTIFICATIONS, 'CLEAR_NOTIFICATIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_BACKEND_NOTIFICATIONS, 'GET_BACKEND_NOTIFICATIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_BACKEND_NOTIFICATION, 'GET_BACKEND_NOTIFICATION', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_BACKEND_NOTIFICATION, 'UPDATE_BACKEND_NOTIFICATION', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_BACKEND_NOTIFICATION, 'DELETE_BACKEND_NOTIFICATION', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_BACKEND_NOTIFICATION, 'CREATE_BACKEND_NOTIFICATION', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_COUNTRIES, 'GET_COUNTRIES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_COMPANIES, 'GET_COMPANIES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_REAL_COMPANIES, 'GET_REAL_COMPANIES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_ANALYTICS_LINKS_LIST, 'GET_ANALYTICS_LINKS_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEND_TRAIN, 'SEND_TRAIN', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_YARD, 'ADD_YARD', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(FIND_YARDS, 'FIND_YARDS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_YARD, 'GET_YARD', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_STATISTICS_USERS, 'GET_STATISTICS_USERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_STATISTICS_USERS, 'SEARCH_STATISTICS_USERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_STATISTICS_EMAILS, 'GET_STATISTICS_EMAILS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_STATISTICS_EMAILS, 'SEARCH_STATISTICS_EMAILS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_STATISTICS_MONITOR, 'GET_STATISTICS_MONITOR', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_STATISTICS_MONITOR, 'SEARCH_STATISTICS_MONITOR', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_STATISTICS_CARGO_REQUESTS, 'GET_STATISTICS_CARGO_REQUESTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_STATISTICS_CARGO_REQUESTS, 'SEARCH_STATISTICS_CARGO_REQUESTS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_STATISTICS_VESSEL_POSITIONS, 'GET_STATISTICS_VESSEL_POSITIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEARCH_STATISTICS_VESSEL_POSITIONS, 'SEARCH_STATISTICS_VESSEL_POSITIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_SEND_EMAIL_LIST, 'GET_SEND_EMAIL_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_SEND_EMAIL, 'GET_SEND_EMAIL', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CONNECT_NEW_DOMAIN_TO_USER, 'CONNECT_NEW_DOMAIN_TO_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_DOMAIN, 'DELETE_DOMAIN', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_LIST_DOMAIN, 'GET_LIST_DOMAIN', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_SUBSCRIBERS, 'GET_SUBSCRIBERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_REQ_LD_RATES, 'GET_REQ_LD_RATES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_REQ_LD_RATES, 'DELETE_REQ_LD_RATES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(EDIT_REQ_LD_RATES, 'EDIT_REQ_LD_RATES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SEND_GAZETTER_TRAININGS, 'SEND_GAZETTER_TRAININGS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_GAZETTER_TRAINING, 'DELETE_GAZETTER_TRAINING', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_INTEGRATORS, 'GET_INTEGRATORS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_INTEGRATOR_COMPANIES, 'GET_INTEGRATOR_COMPANIES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_COMPANY_USER, 'GET_COMPANY_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_FLAG_COMPLIANCE, 'GET_FLAG_COMPLIANCE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_ISSUES, 'GET_ISSUES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_ISSUE, 'GET_ISSUE', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_ISSUE_STATUS, 'UPDATE_ISSUE_STATUS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_ISSUE_COMMENT, 'ADD_ISSUE_COMMENT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_ISSUE_COMMENT, 'UPDATE_ISSUE_COMMENT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_ISSUE_COMMENT, 'DELETE_ISSUE_COMMENT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_REQUESTS_DATA_CREATED, 'SAVE_REQUESTS_DATA_CREATED', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(SAVE_REQUESTS_DATA_DELETED, 'SAVE_REQUESTS_DATA_DELETED', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_HIRE_ORDER, 'UPDATE_HIRE_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_LAST_HIRE_ORDER, 'REMOVE_LAST_HIRE_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(ADD_HIRE_ORDER, 'ADD_HIRE_ORDER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(CREATE_HIRE_ORDERS, 'CREATE_HIRE_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_HIRE_ORDER_USER, 'UPDATE_HIRE_ORDER_USER', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(REMOVE_ALL_HIRE_ORDERS, 'REMOVE_ALL_HIRE_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(GET_HIRE_ORDERS, 'GET_HIRE_ORDERS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(POST_HIRE_REQUEST, 'POST_HIRE_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(UPDATE_HIRE_REQUEST, 'UPDATE_HIRE_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  reactHotLoader.register(DELETE_HIRE_REQUEST, 'DELETE_HIRE_REQUEST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ActionTypes.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(42);
var core = __webpack_require__(107);
var hide = __webpack_require__(86);
var redefine = __webpack_require__(87);
var ctx = __webpack_require__(108);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(644);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1252), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(251);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1278);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1282);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(251);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RaisedButton = __webpack_require__(1742);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RaisedButton2.default;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var styles = {
    tableHeaderColumnCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        padding: '0 5px'
    },
    tableRowColumnCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '20%',
        padding: '0 5px'
    },
    tableRowColumnBigCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '500px',
        width: '30%',
        padding: '0 5px'
    },
    tableHeaderColumnSmallCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '100px',
        padding: '0 5px'
    },
    tableRowColumnSmallCSS: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '100px',
        padding: '0 5px'
    },
    tableRowColumnModified: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '150px',
        padding: '0 5px'
    },
    tableRowColumnModifed: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '150px',
        padding: '0 5px'
    },
    fullHeightFlexContainer: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    greenBtn: { background: '#27ae60', color: '#fff' },
    tableRowBordered: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '100px',
        padding: '15px 15px 15px 15px',
        borderLeft: '1px solid rgb(224, 224, 224)',
        borderRight: '1px solid rgb(224, 224, 224)'
    },
    tableRowBorderedTop: {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        maxWidth: '100px',
        padding: '15px 15px 15px 15px',
        borderLeft: '1px solid rgb(224, 224, 224)',
        borderRight: '1px solid rgb(224, 224, 224)',
        borderTop: '1px solid rgb(224, 224, 224'
    },
    nestedRowColumn: {
        flex: '1',
        height: '100%',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        padding: '15px 15px 15px 15px',
        maxWidth: '200px'
    },
    selectFieldCSS: {
        padding: '0 5px',
        width: '90%',
        fontSize: '13px'
    },
    textLabel: {
        marginBottom: '-14px',
        color: 'rgb(158, 158, 158)'
    },
    menuItemCSS: {
        width: 'auto',
        fontSize: '13px'
    },
    autoCompleteCSS: {
        fontSize: '13px'
    },
    circularProgress: {
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    headline: {
        fontSize: 24,
        paddingTop: 16,
        marginBottom: 12,
        fontWeight: 400
    },
    RaisedButton: {
        margin: '0 0 0 20px'
    },
    importVesselsBtn: {
        margin: '0 0 0 20px'
    },
    autoCompleteListStyle: {
        overflow: 'auto',
        maxHeight: '300px'
    },
    textField: {
        fontSize: '13px'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    },
    btnOrders: {
        minWidth: '25%',
        color: '#fff'
    },
    btnNewOrders: {
        minWidth: '25%',
        color: '#fff'
    },
    approvedBtn: {
        backgroundColor: 'rgb(164, 198, 57)',
        color: '#fff'
    },
    dangerText: {
        color: '#f44336'
    },

    autoHeightContainer: {
        height: 'auto'
    },

    autoHeightButton: {
        padding: '10px 0px'
    }
};

var _default = styles;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/styles/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/styles/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1725);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TextField = __webpack_require__(1783);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextField2.default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year())) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(1446)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1340);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MenuItem = __webpack_require__(504);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItem2.default;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport all */
/* unused harmony reexport race */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(1335);
/* unused harmony reexport takeEvery */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* unused harmony reexport throttle */




/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getNormalErrors;
/* harmony export (immutable) */ __webpack_exports__["c"] = showNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





function getNormalErrors() {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var errors = {};
    var error = '';

    if (response.statusText) {
        error = response.statusText;
    }

    response.errors && response.errors.forEach(function (err) {
        if (err.field) {
            if (err.messages && Array.isArray(err.messages)) {
                errors[err.field] = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(err.messages, '[0]', 'error');
            }
        } else if (err.message) {
            error = err.message;
        }
    });

    return {
        errors: errors,
        error: error
    };
}

/**
 * 
 * @param {string} message 
 * @param {'success' | 'warning' | 'error'} type 
 * @param {{ autoDismiss?: number }} opts
 */
function showNotification() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$autoDismiss = _ref.autoDismiss,
        autoDismiss = _ref$autoDismiss === undefined ? 5 : _ref$autoDismiss;

    __WEBPACK_IMPORTED_MODULE_1_store_configureStore__["d" /* store */].dispatch({
        type: 'ADD_NOTIFICATION',
        notification: {
            title: type.toUpperCase(),
            message: message || type,
            level: type,
            autoDismiss: autoDismiss
        }
    });
}

var helpers = {
    filterSearch: function filterSearch(searchArray, searchText, searchFields) {
        var filteredArray = [];

        for (var i = 0; i < searchArray.length; i++) {
            var splitString = '';

            for (var j = 0; j < searchFields.length; j++) {
                if (searchArray[i][searchFields[j]]) {
                    splitString = splitString + ' ' + searchArray[i][searchFields[j]];
                }
            }
            if (splitString.toLowerCase().includes(searchText)) {
                filteredArray.push(searchArray[i]);
            }
        }
        return filteredArray;
    },
    getRandomNumber: function getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    },
    createHashColor: function createHashColor() {
        var hex = 'ABCDEF';
        var colorArray = [];

        for (var i = 0; i < 6; i++) {
            colorArray.push(hex.split('')[this.getRandomNumber(0, 6)]);
        }

        return '#' + colorArray.join('');
    },
    createRGBAColor: function createRGBAColor() {
        var opacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

        return '(' + this.getRandomNumber(0, 255) + ',' + this.getRandomNumber(0, 255) + ',' + this.getRandomNumber(0, 255) + ',' + opacity + '\')\')';
    },
    getSelection: function getSelection(element) {
        var startOffset = 0;
        var endOffset = 0;
        /* get selection of user selection window.getSelection() */
        var range = window.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange();

        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.startContainer, range.startOffset);

        startOffset = preCaretRange.toString().length;
        endOffset = startOffset + range.toString().length;

        return {
            start: startOffset,
            end: endOffset,
            string: range.toString()
        };
    },
    getNextId: function getNextId(items) {
        var nextId = 0;

        items.forEach(function (item) {
            if (item.id >= nextId) {
                nextId = item.id;
            }
        });

        return nextId + 1;
    },
    sortByDate: function sortByDate(field) {
        return function (a, b) {
            return new Date(b[field]) - new Date(a[field]);
        };
    },
    isDirty: function isDirty() {},
    escapeRegExp: function escapeRegExp(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    },


    /**
     * 
     * @param {string} str 
     */
    getUrlFromString: function getUrlFromString(str) {
        var pattern = new RegExp('(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?', 'i'); // fragment locator

        var url = str.match(pattern);

        return url ? url[0] : '';
    },
    sleep: function sleep(ms) {
        return new Promise(function (resolve) {
            return setTimeout(resolve, ms);
        });
    },
    clearLetters: function clearLetters(value) {
        return value.replace(/[.,]+/g, '.').replace(/[^.\d]/g, '');
    },


    /**
     * @param {any} user
     * @param {string[]} addEmails 
     * @returns 
     */
    isDevAllowed: function isDevAllowed(user) {
        var addEmails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        if (!user || !user.email) {
            return false;
        }
        return ['serhsamiy@gmail.com', 'qa@shipnext.com', 'd.kundasov@shipnext.com', 'a.timotin+qa@shipnext.com', 'admin@shipnext.com', 'sergey.s@myco.com', 'ss@shipnext.com', 's.semernev@shipnext.com', 'n.liashenko@shipnext.com', 'a77shiptest@gmail.com', 'o.korostin@shipnext.com'].concat(_toConsumableArray(addEmails)).includes(user && user.email.toLowerCase());
    },
    prepareOneTimeAuthSession: function prepareOneTimeAuthSession(userId) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                                method: 'post',
                                url: '/api/v1/auth/prepareOneTimeAuthSession',
                                data: {
                                    userId: userId
                                }
                            }).then(function (response) {
                                return response.data.data;
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
};

var _default = helpers;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getNormalErrors, 'getNormalErrors', '/opt/atlassian/pipelines/agent/build/client/app/helpers/index.js');
    reactHotLoader.register(showNotification, 'showNotification', '/opt/atlassian/pipelines/agent/build/client/app/helpers/index.js');
    reactHotLoader.register(helpers, 'helpers', '/opt/atlassian/pipelines/agent/build/client/app/helpers/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/helpers/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AutoComplete = __webpack_require__(1793);

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AutoComplete2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _IconButton = __webpack_require__(345);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IconButton2.default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SelectField = __webpack_require__(1835);

var _SelectField2 = _interopRequireDefault(_SelectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SelectField2.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;

var _Table2 = __webpack_require__(1850);

var _Table3 = _interopRequireDefault(_Table2);

var _TableBody2 = __webpack_require__(782);

var _TableBody3 = _interopRequireDefault(_TableBody2);

var _TableFooter2 = __webpack_require__(783);

var _TableFooter3 = _interopRequireDefault(_TableFooter2);

var _TableHeader2 = __webpack_require__(784);

var _TableHeader3 = _interopRequireDefault(_TableHeader2);

var _TableHeaderColumn2 = __webpack_require__(514);

var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);

var _TableRow2 = __webpack_require__(785);

var _TableRow3 = _interopRequireDefault(_TableRow2);

var _TableRowColumn2 = __webpack_require__(354);

var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Table = _Table3.default;
exports.TableBody = _TableBody3.default;
exports.TableFooter = _TableFooter3.default;
exports.TableHeader = _TableHeader3.default;
exports.TableHeaderColumn = _TableHeaderColumn3.default;
exports.TableRow = _TableRow3.default;
exports.TableRowColumn = _TableRowColumn3.default;
exports.default = _Table3.default;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentRemoveCircleOutline = function ContentRemoveCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ContentRemoveCircleOutline = (0, _pure2.default)(ContentRemoveCircleOutline);
ContentRemoveCircleOutline.displayName = 'ContentRemoveCircleOutline';
ContentRemoveCircleOutline.muiName = 'SvgIcon';

exports.default = ContentRemoveCircleOutline;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlatButton = __webpack_require__(1724);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlatButton2.default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = __webpack_require__(2053);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(2081);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(2101);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(2102);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(2103);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(2104);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dialog = __webpack_require__(1816);

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dialog2.default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {
    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || 'linear';

    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionTypes */
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return change; });
/* unused harmony export clearAsyncError */
/* unused harmony export clearFields */
/* unused harmony export clearSubmitErrors */
/* unused harmony export destroy */
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* unused harmony export reset */
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return submit; });
/* unused harmony export touch */
/* unused harmony export unregisterField */
/* unused harmony export untouch */
/* unused harmony export updateSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(696);
/* unused harmony reexport defaultShouldAsyncValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(697);
/* unused harmony reexport defaultShouldValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(698);
/* unused harmony reexport defaultShouldError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(699);
/* unused harmony reexport defaultShouldWarn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1475);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(1476);
/* unused harmony reexport FormName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(1477);
/* unused harmony reexport FormSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__SubmissionError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(1479);
/* unused harmony reexport propTypes */
/* unused harmony reexport fieldInputPropTypes */
/* unused harmony reexport fieldMetaPropTypes */
/* unused harmony reexport fieldPropTypes */
/* unused harmony reexport fieldArrayFieldsPropTypes */
/* unused harmony reexport fieldArrayMetaPropTypes */
/* unused harmony reexport fieldArrayPropTypes */
/* unused harmony reexport formPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(1480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(1547);
/* unused harmony reexport Fields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(1550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__FieldArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(1568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_14__formValueSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(1570);
/* unused harmony reexport formValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(1574);
/* unused harmony reexport getFormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(1576);
/* unused harmony reexport getFormNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(1578);
/* unused harmony reexport getFormValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(1580);
/* unused harmony reexport getFormInitialValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(1582);
/* unused harmony reexport getFormSyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(1584);
/* unused harmony reexport getFormMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(1586);
/* unused harmony reexport getFormAsyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(1588);
/* unused harmony reexport getFormSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(1590);
/* unused harmony reexport getFormSubmitErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(1592);
/* unused harmony reexport isAsyncValidating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(1594);
/* unused harmony reexport isDirty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(1596);
/* unused harmony reexport isInvalid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(1599);
/* unused harmony reexport isPristine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(1600);
/* unused harmony reexport isValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(1601);
/* unused harmony reexport isSubmitting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(1603);
/* unused harmony reexport hasSubmitSucceeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(1605);
/* unused harmony reexport hasSubmitFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(1607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(1638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(1641);
/* unused harmony reexport values */










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = addNotification;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function addNotification(notification) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
        notification: notification
    };
}

function deleteNotification(notification) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["V" /* DELETE_NOTIFICATION */],
        notification: notification
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(addNotification, 'addNotification', '/opt/atlassian/pipelines/agent/build/client/app/actions/notifications/notifications.js');
    reactHotLoader.register(deleteNotification, 'deleteNotification', '/opt/atlassian/pipelines/agent/build/client/app/actions/notifications/notifications.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(1546);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(1225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(1235);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(1236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(1237);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(1238);
/* unused harmony reexport IndexRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(150);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(433);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(435);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(1240);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(637);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(214);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(1245);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(1246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(1249);
/* unused harmony reexport hashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(634);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(390);
module.exports.easing = __webpack_require__(3325);
module.exports.canvas = __webpack_require__(3326);
module.exports.options = __webpack_require__(3327);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddCircleOutline = function ContentAddCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ContentAddCircleOutline = (0, _pure2.default)(ContentAddCircleOutline);
ContentAddCircleOutline.displayName = 'ContentAddCircleOutline';
ContentAddCircleOutline.muiName = 'SvgIcon';

exports.default = ContentAddCircleOutline;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(998);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export sagaMiddleware */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return history; });
/* harmony export (immutable) */ __webpack_exports__["b"] = execute;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserPerms; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sagas__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reducers__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userPermissions__ = __webpack_require__(1713);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











var sagaMiddleware = Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["a" /* default */])();

var store = Object(__WEBPACK_IMPORTED_MODULE_2_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_6_reducers__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__["composeWithDevTools"])(Object(__WEBPACK_IMPORTED_MODULE_2_redux__["applyMiddleware"])(sagaMiddleware)));

var history = Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* browserHistory */], store);

function execute(saga) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return sagaMiddleware.run.apply(sagaMiddleware, [saga].concat(args)).done;
}

var UserPerms = new __WEBPACK_IMPORTED_MODULE_7__userPermissions__["a" /* UserPermissionService */](store);

var sagaTask = sagaMiddleware.run( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__sagas__["a" /* default */])();

                case 2:
                case 'end':
                    return _context.stop();
            }
        }
    }, _callee, this);
}));

if (false) {
    module.hot.accept('../reducers', function () {
        var nextRootReducer = require('../reducers');
        store.replaceReducer(nextRootReducer);
    });

    module.hot.accept('../sagas', function () {
        var getNewSagas = require('../sagas');
        sagaTask.cancel();

        sagaTask.done.then(function () {
            sagaTask = sagaMiddleware.run( /*#__PURE__*/regeneratorRuntime.mark(function replacedSaga(action) {
                return regeneratorRuntime.wrap(function replacedSaga$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return getNewSagas();

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, replacedSaga, this);
            }));
        });
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sagaMiddleware, 'sagaMiddleware', '/opt/atlassian/pipelines/agent/build/client/app/store/configureStore.js');
    reactHotLoader.register(store, 'store', '/opt/atlassian/pipelines/agent/build/client/app/store/configureStore.js');
    reactHotLoader.register(history, 'history', '/opt/atlassian/pipelines/agent/build/client/app/store/configureStore.js');
    reactHotLoader.register(execute, 'execute', '/opt/atlassian/pipelines/agent/build/client/app/store/configureStore.js');
    reactHotLoader.register(UserPerms, 'UserPerms', '/opt/atlassian/pipelines/agent/build/client/app/store/configureStore.js');
    reactHotLoader.register(sagaTask, 'sagaTask', '/opt/atlassian/pipelines/agent/build/client/app/store/configureStore.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getCargoOrders */
/* harmony export (immutable) */ __webpack_exports__["b"] = createCargoOrders;
/* unused harmony export clearMessage */
/* harmony export (immutable) */ __webpack_exports__["f"] = updateCargoOrder;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCargoOrder;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeLastCargoOrder;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateCargoOrderUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeAllCargoOrders;
/* harmony export (immutable) */ __webpack_exports__["e"] = resetCargoOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoOrders() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_15" /* GET_CARGO_ORDERS */]
    };
}

function createCargoOrders(cargoOrders, user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["C" /* CREATE_CARGO_ORDERS */],
        items: cargoOrders,
        user: user
    };
}

function clearMessage(cargoOrderKey) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["q" /* CLEAR_CARGO_ORDER_MESSAGE */],
        cargoOrderKey: cargoOrderKey
    };
}

function updateCargoOrder(numberOrder, newCargoOrder) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_124" /* UPDATE_CARGO_ORDER */],
        numberOrder: numberOrder,
        newCargoOrder: newCargoOrder
    };
}

function addCargoOrder() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["b" /* ADD_CARGO_ORDER */]
    };
}

function removeLastCargoOrder() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_84" /* REMOVE_LAST_CARGO_ORDER */]
    };
}

function updateCargoOrderUser(user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_125" /* UPDATE_CARGO_ORDER_USER */],
        user: user
    };
}

function removeAllCargoOrders() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_76" /* REMOVE_ALL_CARGO_ORDERS */]
    };
}

function resetCargoOrders() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_91" /* RESET_CARGO_ORDERS */]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoOrders, 'getCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(createCargoOrders, 'createCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(clearMessage, 'clearMessage', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(updateCargoOrder, 'updateCargoOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(addCargoOrder, 'addCargoOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(removeLastCargoOrder, 'removeLastCargoOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(updateCargoOrderUser, 'updateCargoOrderUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(removeAllCargoOrders, 'removeAllCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    reactHotLoader.register(resetCargoOrders, 'resetCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var styles = {
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

var Pagination = function (_React$Component) {
    _inherits(Pagination, _React$Component);

    function Pagination(props, context) {
        _classCallCheck(this, Pagination);

        var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props, context));

        _this.selectRowsPerPage = _this.selectRowsPerPage.bind(_this);
        _this.selectPageNumber = _this.selectPageNumber.bind(_this);

        _this.renderRowsPerPage = _this.renderRowsPerPage.bind(_this);
        _this.renderRowRange = _this.renderRowRange.bind(_this);

        _this.numberOfPages = _this.numberOfPages.bind(_this);

        _this.incrementPage = _this.incrementPage.bind(_this);
        _this.decrementPage = _this.decrementPage.bind(_this);
        return _this;
    }

    _createClass(Pagination, [{
        key: 'selectRowsPerPage',
        value: function selectRowsPerPage(event) {
            var updatedState = Object.assign({}, this.props);
            updatedState.numberOfRows = parseInt(event.target.innerText);
            if (updatedState.numberOfRows * this.props.page > this.props.total) {
                var updatedPage = Math.ceil(this.props.total / updatedState.numberOfRows);
                updatedState.page = updatedPage;
                this.props.updateRows(updatedState);
            } else {
                this.props.updateRows(updatedState);
            }
        }
    }, {
        key: 'selectPageNumber',
        value: function selectPageNumber(event) {
            var updatedState = Object.assign({}, this.props);
            updatedState.page = parseInt(event.target.innerText);
            this.props.updateRows(updatedState);
        }
    }, {
        key: 'numberOfPages',
        value: function numberOfPages() {
            var numArray = [];
            for (var i = 0; i < Math.ceil(this.props.total / this.props.numberOfRows); i++) {
                numArray.push(i + 1);
            }

            return numArray.map(function (pageValue, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { key: index, value: pageValue, primaryText: pageValue });
            });
        }
    }, {
        key: 'incrementPage',
        value: function incrementPage() {
            if (this.props.page >= this.props.total / this.props.numberOfRows) {
                return;
            }

            var updatedState = Object.assign({}, this.props);
            updatedState.page++;
            this.props.updateRows(updatedState);
        }
    }, {
        key: 'decrementPage',
        value: function decrementPage() {
            if (this.props.page <= 1) {
                return;
            }

            var updatedState = Object.assign({}, this.props);
            updatedState.page--;
            this.props.updateRows(updatedState);
        }
    }, {
        key: 'renderRowsPerPage',
        value: function renderRowsPerPage() {
            return this.props.rowsPerPage.map(function (rowValue, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { key: index, value: rowValue, primaryText: rowValue });
            });
        }
    }, {
        key: 'renderRowRange',
        value: function renderRowRange() {
            var page = this.props.page || 1;
            var to = Math.min(page * this.props.numberOfRows, this.props.total);
            var from = Math.min((page - 1) * this.props.numberOfRows + 1, to);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                from,
                ' - ',
                to
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: styles.paginationContainer },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.paginationSection },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: styles.paginationText },
                        'Page:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                        {
                            autoWidth: true,
                            style: styles.paginationSelect,
                            value: this.props.page,
                            onChange: this.selectPageNumber
                        },
                        this.numberOfPages()
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.paginationSection },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: styles.paginationText },
                        'Rows Per Page:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                        {
                            autoWidth: true,
                            style: styles.paginationSelect,
                            value: this.props.numberOfRows,
                            onChange: this.selectRowsPerPage
                        },
                        this.renderRowsPerPage()
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.paginationSection },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: styles.paginationText },
                        this.renderRowRange(),
                        '  of ',
                        this.props.total
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.paginationSection },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                        {
                            iconStyle: this.props.page <= 1 ? styles.navigationLeftFirstPage : styles.navigationLeft,
                            name: 'navigationLeft',
                            disabled: this.props.page <= 1,
                            onClick: this.decrementPage
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                        {
                            iconStyle: this.props.page >= this.props.total / this.props.numberOfRows ? styles.navigationRightLastPage : styles.navigationRight,
                            name: 'navigationRight',
                            disabled: this.props.page >= this.props.total / this.props.numberOfRows,
                            onClick: this.incrementPage
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Pagination;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Pagination.defaultProps = {
    total: 0,
    page: 1,
    rowsPerPage: [10, 20, 30],
    numberOfRows: 10
};

Pagination.propTypes = {
    total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    page: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    numberOfRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    rowsPerPage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    updateRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var _default = Pagination;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Libs/Pagination.jsx');
    reactHotLoader.register(Pagination, 'Pagination', '/opt/atlassian/pipelines/agent/build/client/app/components/Libs/Pagination.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Libs/Pagination.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["f"] = getPorts;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPort;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAllPorts;
/* harmony export (immutable) */ __webpack_exports__["g"] = savePort;
/* harmony export (immutable) */ __webpack_exports__["k"] = updatePortSuggestions;
/* harmony export (immutable) */ __webpack_exports__["j"] = updatePortAlt;
/* harmony export (immutable) */ __webpack_exports__["i"] = updatePort;
/* harmony export (immutable) */ __webpack_exports__["h"] = searchPort;
/* harmony export (immutable) */ __webpack_exports__["b"] = changePort;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearPort;
/* harmony export (immutable) */ __webpack_exports__["a"] = addNewPort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getPorts(pagination) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_37" /* GET_PORTS */].REQUEST,
        pagination: pagination
    };
}

function getPort(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_36" /* GET_PORT */].REQUEST,
        data: data
    };
}

function getAllPorts() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_4" /* GET_ALL_PORTS */].REQUEST
    };
}

function savePort(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_98" /* SAVE_PORT */],
        item: item
    };
}

function updatePortSuggestions(suggestions) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_135" /* UPDATE_PORT_SUGGESTIONS */],
        suggestions: suggestions
    };
}

function updatePortAlt(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_134" /* UPDATE_PORT_ALT */].REQUEST,
        item: item
    };
}

function updatePort(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_133" /* UPDATE_PORT */].REQUEST,
        data: data
    };
}

function searchPort(search) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_108" /* SEARCH_PORT */],
        search: search
    };
}

function changePort(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["o" /* CHANGE_PORT */],
        data: data
    };
}

function clearPort() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["s" /* CLEAR_PORT */]
    };
}

function addNewPort(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["d" /* ADD_NEW_PORT */].REQUEST,
        data: data
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getPorts, 'getPorts', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(getPort, 'getPort', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(getAllPorts, 'getAllPorts', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(savePort, 'savePort', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(updatePortSuggestions, 'updatePortSuggestions', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(updatePortAlt, 'updatePortAlt', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(updatePort, 'updatePort', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(searchPort, 'searchPort', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(changePort, 'changePort', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(clearPort, 'clearPort', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    reactHotLoader.register(addNewPort, 'addNewPort', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/ports.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CircularProgress = __webpack_require__(1789);

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CircularProgress2.default;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toggle = __webpack_require__(2210);

Object.defineProperty(exports, 'Toggle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toggle).default;
  }
});

var _Slider = __webpack_require__(2211);

Object.defineProperty(exports, 'Slider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _Checkbox = __webpack_require__(2212);

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

var _TextField = __webpack_require__(2213);

Object.defineProperty(exports, 'TextField', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextField).default;
  }
});

var _TimePicker = __webpack_require__(2214);

Object.defineProperty(exports, 'TimePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TimePicker).default;
  }
});

var _DatePicker = __webpack_require__(2215);

Object.defineProperty(exports, 'DatePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DatePicker).default;
  }
});

var _SelectField = __webpack_require__(2216);

Object.defineProperty(exports, 'SelectField', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SelectField).default;
  }
});

var _AutoComplete = __webpack_require__(2217);

Object.defineProperty(exports, 'AutoComplete', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AutoComplete).default;
  }
});

var _RadioButtonGroup = __webpack_require__(2218);

Object.defineProperty(exports, 'RadioButtonGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RadioButtonGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Checkbox = __webpack_require__(1803);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(293)('wks');
var uid = __webpack_require__(171);
var Symbol = __webpack_require__(42).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(110);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = __webpack_require__(2105);

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = __webpack_require__(896);

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = __webpack_require__(2108);

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = __webpack_require__(2109);

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = __webpack_require__(2111);

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = __webpack_require__(2112);

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = __webpack_require__(898);

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = __webpack_require__(2118);

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(550);



var babelPluginFlowReactPropTypes_proptype_CellPosition =  true ? null : {
  columnIndex: require('prop-types').number.isRequired,
  rowIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellPosition', {
  value: babelPluginFlowReactPropTypes_proptype_CellPosition,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRendererParams =  true ? null : {
  columnIndex: require('prop-types').number.isRequired,
  isScrolling: require('prop-types').bool.isRequired,
  isVisible: require('prop-types').bool.isRequired,
  key: require('prop-types').string.isRequired,
  parent: require('prop-types').object.isRequired,
  rowIndex: require('prop-types').number.isRequired,
  style: require('prop-types').object.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRendererParams', {
  value: babelPluginFlowReactPropTypes_proptype_CellRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_CellRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: require('prop-types').object.isRequired,
  cellRenderer: require('prop-types').func.isRequired,
  columnSizeAndPositionManager: typeof ScalingCellSizeAndPositionManager === 'function' ? require('prop-types').instanceOf(ScalingCellSizeAndPositionManager).isRequired : require('prop-types').any.isRequired,
  columnStartIndex: require('prop-types').number.isRequired,
  columnStopIndex: require('prop-types').number.isRequired,
  deferredMeasurementCache: require('prop-types').object,
  horizontalOffsetAdjustment: require('prop-types').number.isRequired,
  isScrolling: require('prop-types').bool.isRequired,
  parent: require('prop-types').object.isRequired,
  rowSizeAndPositionManager: typeof ScalingCellSizeAndPositionManager === 'function' ? require('prop-types').instanceOf(ScalingCellSizeAndPositionManager).isRequired : require('prop-types').any.isRequired,
  rowStartIndex: require('prop-types').number.isRequired,
  rowStopIndex: require('prop-types').number.isRequired,
  scrollLeft: require('prop-types').number.isRequired,
  scrollTop: require('prop-types').number.isRequired,
  styleCache: require('prop-types').object.isRequired,
  verticalOffsetAdjustment: require('prop-types').number.isRequired,
  visibleColumnIndices: require('prop-types').object.isRequired,
  visibleRowIndices: require('prop-types').object.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams', {
  value: babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellRangeRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRangeRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_CellRangeRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellSizeGetter =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellSizeGetter', {
  value: babelPluginFlowReactPropTypes_proptype_CellSizeGetter,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_CellSize =  true ? null : require('prop-types').oneOfType([require('prop-types').func, require('prop-types').number]);
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellSize', {
  value: babelPluginFlowReactPropTypes_proptype_CellSize,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_NoContentRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_NoContentRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_NoContentRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Scroll =  true ? null : {
  clientHeight: require('prop-types').number.isRequired,
  clientWidth: require('prop-types').number.isRequired,
  scrollHeight: require('prop-types').number.isRequired,
  scrollLeft: require('prop-types').number.isRequired,
  scrollTop: require('prop-types').number.isRequired,
  scrollWidth: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Scroll', {
  value: babelPluginFlowReactPropTypes_proptype_Scroll,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: require('prop-types').bool.isRequired,
  vertical: require('prop-types').bool.isRequired,
  size: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange', {
  value: babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: require('prop-types').number.isRequired,
  columnOverscanStopIndex: require('prop-types').number.isRequired,
  columnStartIndex: require('prop-types').number.isRequired,
  columnStopIndex: require('prop-types').number.isRequired,
  rowOverscanStartIndex: require('prop-types').number.isRequired,
  rowOverscanStopIndex: require('prop-types').number.isRequired,
  rowStartIndex: require('prop-types').number.isRequired,
  rowStopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RenderedSection', {
  value: babelPluginFlowReactPropTypes_proptype_RenderedSection,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: require('prop-types').oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: require('prop-types').oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: require('prop-types').number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: require('prop-types').number.isRequired,


  // Begin of range of visible cells
  startIndex: require('prop-types').number.isRequired,


  // End of range of visible cells
  stopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams', {
  value: babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: require('prop-types').number.isRequired,
  overscanStopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndices', {
  value: babelPluginFlowReactPropTypes_proptype_OverscanIndices,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter', {
  value: babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Alignment =  true ? null : require('prop-types').oneOf(['auto', 'end', 'start', 'center']);
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Alignment', {
  value: babelPluginFlowReactPropTypes_proptype_Alignment,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_VisibleCellRange =  true ? null : {
  start: require('prop-types').number,
  stop: require('prop-types').number
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_VisibleCellRange', {
  value: babelPluginFlowReactPropTypes_proptype_VisibleCellRange,
  configurable: true
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = NumberField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




function clearNumberString(str, canBeNegative, floatNumber) {
    var code0 = '0'.charCodeAt(0);
    var code9 = '9'.charCodeAt(0);
    var dst = '';
    var aDigitBefore = false;
    var aDotBefore = false;
    for (var i = 0; i < str.length; i++) {
        var code = str.charCodeAt(i);
        if (canBeNegative && i === 0 && str[i] === '-' || floatNumber && aDigitBefore && !aDotBefore && str[i] === '.' || code >= code0 && code <= code9) {
            dst += str[i];
            // Legacy equivalent of ||= operator
            aDigitBefore = code >= code0 && code <= code9 ? true : aDigitBefore;
            aDotBefore = str[i] === '.' ? true : aDotBefore;
        }
    }
    return dst;
}

/** @param {{ canBeNegative?: boolean, floatNumber?: boolean, [key: string]: any }} props */
function NumberField(_ref) {
    var canBeNegative = _ref.canBeNegative,
        floatNumber = _ref.floatNumber,
        props = _objectWithoutProperties(_ref, ['canBeNegative', 'floatNumber']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, _extends({}, props, {
        type: 'text',
        onChange: function onChange(e) {
            for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                rest[_key - 1] = arguments[_key];
            }

            if (e.target.value.length > 0) {
                var strValue = clearNumberString(e.target.value, canBeNegative, floatNumber);
                if (strValue !== e.target.value) {
                    e.target.value = strValue;
                    props.onChange && props.onChange(e, strValue);
                    return;
                }
            }
            props.onChange && props.onChange.apply(props, [e].concat(rest));
        }
    }));
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(clearNumberString, 'clearNumberString', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/NumberField/index.jsx');
    reactHotLoader.register(NumberField, 'NumberField', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/NumberField/index.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formName; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var formName = {
    portUpdate: 'port-update',
    portUpdateAddDetail: 'port-update-add-detail',
    portUpdateEditDetail: 'port-update-edit-detail',
    portUpdateAddServiceProvider: 'port-update-add-service-provider',
    portUpdateEditServiceProvider: 'port-update-edit-service-provider',

    portCreate: 'port-create'
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(formName, 'formName', '/opt/atlassian/pipelines/agent/build/client/app/data/formNames.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(47)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(37);
var IE8_DOM_DEFINE = __webpack_require__(583);
var toPrimitive = __webpack_require__(118);
var dP = Object.defineProperty;

exports.f = __webpack_require__(65) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(119);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(644);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isServer; });
/* harmony export (immutable) */ __webpack_exports__["k"] = noop;
/* harmony export (immutable) */ __webpack_exports__["c"] = functionalUpdate;
/* harmony export (immutable) */ __webpack_exports__["h"] = isValidTimeout;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureQueryKeyArray;
/* harmony export (immutable) */ __webpack_exports__["a"] = difference;
/* harmony export (immutable) */ __webpack_exports__["q"] = replaceAt;
/* harmony export (immutable) */ __webpack_exports__["v"] = timeUntilStale;
/* harmony export (immutable) */ __webpack_exports__["o"] = parseQueryArgs;
/* harmony export (immutable) */ __webpack_exports__["m"] = parseMutationArgs;
/* harmony export (immutable) */ __webpack_exports__["l"] = parseFilterArgs;
/* harmony export (immutable) */ __webpack_exports__["n"] = parseMutationFilterArgs;
/* unused harmony export mapQueryStatusFilter */
/* harmony export (immutable) */ __webpack_exports__["j"] = matchQuery;
/* harmony export (immutable) */ __webpack_exports__["i"] = matchMutation;
/* harmony export (immutable) */ __webpack_exports__["f"] = hashQueryKeyByOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = hashQueryKey;
/* unused harmony export stableValueHash */
/* harmony export (immutable) */ __webpack_exports__["p"] = partialMatchKey;
/* unused harmony export partialDeepEqual */
/* harmony export (immutable) */ __webpack_exports__["r"] = replaceEqualDeep;
/* harmony export (immutable) */ __webpack_exports__["t"] = shallowEqualObjects;
/* unused harmony export isPlainObject */
/* unused harmony export isQueryKey */
/* unused harmony export isError */
/* harmony export (immutable) */ __webpack_exports__["u"] = sleep;
/* harmony export (immutable) */ __webpack_exports__["s"] = scheduleMicrotask;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAbortController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
      mutationFn: arg1
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(670);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.url = exports.required = exports.presence = exports.numericality = exports.length = exports.inclusion = exports.format = exports.file = exports.exclusion = exports.email = exports.date = exports.confirmation = exports.addValidator = exports.acceptance = exports.absence = undefined;

var _absence = __webpack_require__(2197);

var _absence2 = _interopRequireDefault(_absence);

var _acceptance = __webpack_require__(2199);

var _acceptance2 = _interopRequireDefault(_acceptance);

var _addValidator = __webpack_require__(2200);

var _addValidator2 = _interopRequireDefault(_addValidator);

var _confirmation = __webpack_require__(2201);

var _confirmation2 = _interopRequireDefault(_confirmation);

var _date = __webpack_require__(2202);

var _date2 = _interopRequireDefault(_date);

var _email = __webpack_require__(2203);

var _email2 = _interopRequireDefault(_email);

var _file = __webpack_require__(553);

var _file2 = _interopRequireDefault(_file);

var _format = __webpack_require__(2204);

var _format2 = _interopRequireDefault(_format);

var _inclusion = __webpack_require__(913);

var _inclusion2 = _interopRequireDefault(_inclusion);

var _exclusion = __webpack_require__(2205);

var _exclusion2 = _interopRequireDefault(_exclusion);

var _length = __webpack_require__(2206);

var _length2 = _interopRequireDefault(_length);

var _numericality = __webpack_require__(2207);

var _numericality2 = _interopRequireDefault(_numericality);

var _presence = __webpack_require__(2208);

var _presence2 = _interopRequireDefault(_presence);

var _url = __webpack_require__(2209);

var _url2 = _interopRequireDefault(_url);

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var required = _presence2.default; // alias

exports.default = _validators2.default;
exports.absence = _absence2.default;
exports.acceptance = _acceptance2.default;
exports.addValidator = _addValidator2.default;
exports.confirmation = _confirmation2.default;
exports.date = _date2.default;
exports.email = _email2.default;
exports.exclusion = _exclusion2.default;
exports.file = _file2.default;
exports.format = _format2.default;
exports.inclusion = _inclusion2.default;
exports.length = _length2.default;
exports.numericality = _numericality2.default;
exports.presence = _presence2.default;
exports.required = required;
exports.url = _url2.default;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _bind2 = __webpack_require__(385)

var _bind3 = _interopRequireDefault(_bind2)

var _isFunction2 = __webpack_require__(318)

var _isFunction3 = _interopRequireDefault(_isFunction2)

var _reduce3 = __webpack_require__(2256)

var _reduce4 = _interopRequireDefault(_reduce3)

var _forEach2 = __webpack_require__(899)

var _forEach3 = _interopRequireDefault(_forEach2)

var _lowerFirst2 = __webpack_require__(2258)

var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)

var _has2 = __webpack_require__(2265)

var _has3 = _interopRequireDefault(_has2)

exports.construct = construct
exports.componentDidMount = componentDidMount
exports.componentDidUpdate = componentDidUpdate
exports.componentWillUnmount = componentWillUnmount

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/)
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key]
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key]
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key]
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue)
    }
  })
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  )
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap)
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents()
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
  registerEvents(component, instance, eventMap)
}

function componentWillUnmount(component) {
  component.unregisterAllEvents()
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        )
      }
      return acc
    },
    []
  )

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  )
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(671);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Paper = __webpack_require__(1741);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Paper2.default;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDelete = function ActionDelete(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
  );
};
ActionDelete = (0, _pure2.default)(ActionDelete);
ActionDelete.displayName = 'ActionDelete';
ActionDelete.muiName = 'SvgIcon';

exports.default = ActionDelete;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red50 = exports.red50 = '#ffebee';
var red100 = exports.red100 = '#ffcdd2';
var red200 = exports.red200 = '#ef9a9a';
var red300 = exports.red300 = '#e57373';
var red400 = exports.red400 = '#ef5350';
var red500 = exports.red500 = '#f44336';
var red600 = exports.red600 = '#e53935';
var red700 = exports.red700 = '#d32f2f';
var red800 = exports.red800 = '#c62828';
var red900 = exports.red900 = '#b71c1c';
var redA100 = exports.redA100 = '#ff8a80';
var redA200 = exports.redA200 = '#ff5252';
var redA400 = exports.redA400 = '#ff1744';
var redA700 = exports.redA700 = '#d50000';

var pink50 = exports.pink50 = '#fce4ec';
var pink100 = exports.pink100 = '#f8bbd0';
var pink200 = exports.pink200 = '#f48fb1';
var pink300 = exports.pink300 = '#f06292';
var pink400 = exports.pink400 = '#ec407a';
var pink500 = exports.pink500 = '#e91e63';
var pink600 = exports.pink600 = '#d81b60';
var pink700 = exports.pink700 = '#c2185b';
var pink800 = exports.pink800 = '#ad1457';
var pink900 = exports.pink900 = '#880e4f';
var pinkA100 = exports.pinkA100 = '#ff80ab';
var pinkA200 = exports.pinkA200 = '#ff4081';
var pinkA400 = exports.pinkA400 = '#f50057';
var pinkA700 = exports.pinkA700 = '#c51162';

var purple50 = exports.purple50 = '#f3e5f5';
var purple100 = exports.purple100 = '#e1bee7';
var purple200 = exports.purple200 = '#ce93d8';
var purple300 = exports.purple300 = '#ba68c8';
var purple400 = exports.purple400 = '#ab47bc';
var purple500 = exports.purple500 = '#9c27b0';
var purple600 = exports.purple600 = '#8e24aa';
var purple700 = exports.purple700 = '#7b1fa2';
var purple800 = exports.purple800 = '#6a1b9a';
var purple900 = exports.purple900 = '#4a148c';
var purpleA100 = exports.purpleA100 = '#ea80fc';
var purpleA200 = exports.purpleA200 = '#e040fb';
var purpleA400 = exports.purpleA400 = '#d500f9';
var purpleA700 = exports.purpleA700 = '#aa00ff';

var deepPurple50 = exports.deepPurple50 = '#ede7f6';
var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
var deepPurple200 = exports.deepPurple200 = '#b39ddb';
var deepPurple300 = exports.deepPurple300 = '#9575cd';
var deepPurple400 = exports.deepPurple400 = '#7e57c2';
var deepPurple500 = exports.deepPurple500 = '#673ab7';
var deepPurple600 = exports.deepPurple600 = '#5e35b1';
var deepPurple700 = exports.deepPurple700 = '#512da8';
var deepPurple800 = exports.deepPurple800 = '#4527a0';
var deepPurple900 = exports.deepPurple900 = '#311b92';
var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';

var indigo50 = exports.indigo50 = '#e8eaf6';
var indigo100 = exports.indigo100 = '#c5cae9';
var indigo200 = exports.indigo200 = '#9fa8da';
var indigo300 = exports.indigo300 = '#7986cb';
var indigo400 = exports.indigo400 = '#5c6bc0';
var indigo500 = exports.indigo500 = '#3f51b5';
var indigo600 = exports.indigo600 = '#3949ab';
var indigo700 = exports.indigo700 = '#303f9f';
var indigo800 = exports.indigo800 = '#283593';
var indigo900 = exports.indigo900 = '#1a237e';
var indigoA100 = exports.indigoA100 = '#8c9eff';
var indigoA200 = exports.indigoA200 = '#536dfe';
var indigoA400 = exports.indigoA400 = '#3d5afe';
var indigoA700 = exports.indigoA700 = '#304ffe';

var blue50 = exports.blue50 = '#e3f2fd';
var blue100 = exports.blue100 = '#bbdefb';
var blue200 = exports.blue200 = '#90caf9';
var blue300 = exports.blue300 = '#64b5f6';
var blue400 = exports.blue400 = '#42a5f5';
var blue500 = exports.blue500 = '#2196f3';
var blue600 = exports.blue600 = '#1e88e5';
var blue700 = exports.blue700 = '#1976d2';
var blue800 = exports.blue800 = '#1565c0';
var blue900 = exports.blue900 = '#0d47a1';
var blueA100 = exports.blueA100 = '#82b1ff';
var blueA200 = exports.blueA200 = '#448aff';
var blueA400 = exports.blueA400 = '#2979ff';
var blueA700 = exports.blueA700 = '#2962ff';

var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
var lightBlue200 = exports.lightBlue200 = '#81d4fa';
var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
var lightBlue400 = exports.lightBlue400 = '#29b6f6';
var lightBlue500 = exports.lightBlue500 = '#03a9f4';
var lightBlue600 = exports.lightBlue600 = '#039be5';
var lightBlue700 = exports.lightBlue700 = '#0288d1';
var lightBlue800 = exports.lightBlue800 = '#0277bd';
var lightBlue900 = exports.lightBlue900 = '#01579b';
var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
var lightBlueA700 = exports.lightBlueA700 = '#0091ea';

var cyan50 = exports.cyan50 = '#e0f7fa';
var cyan100 = exports.cyan100 = '#b2ebf2';
var cyan200 = exports.cyan200 = '#80deea';
var cyan300 = exports.cyan300 = '#4dd0e1';
var cyan400 = exports.cyan400 = '#26c6da';
var cyan500 = exports.cyan500 = '#00bcd4';
var cyan600 = exports.cyan600 = '#00acc1';
var cyan700 = exports.cyan700 = '#0097a7';
var cyan800 = exports.cyan800 = '#00838f';
var cyan900 = exports.cyan900 = '#006064';
var cyanA100 = exports.cyanA100 = '#84ffff';
var cyanA200 = exports.cyanA200 = '#18ffff';
var cyanA400 = exports.cyanA400 = '#00e5ff';
var cyanA700 = exports.cyanA700 = '#00b8d4';

var teal50 = exports.teal50 = '#e0f2f1';
var teal100 = exports.teal100 = '#b2dfdb';
var teal200 = exports.teal200 = '#80cbc4';
var teal300 = exports.teal300 = '#4db6ac';
var teal400 = exports.teal400 = '#26a69a';
var teal500 = exports.teal500 = '#009688';
var teal600 = exports.teal600 = '#00897b';
var teal700 = exports.teal700 = '#00796b';
var teal800 = exports.teal800 = '#00695c';
var teal900 = exports.teal900 = '#004d40';
var tealA100 = exports.tealA100 = '#a7ffeb';
var tealA200 = exports.tealA200 = '#64ffda';
var tealA400 = exports.tealA400 = '#1de9b6';
var tealA700 = exports.tealA700 = '#00bfa5';

var green50 = exports.green50 = '#e8f5e9';
var green100 = exports.green100 = '#c8e6c9';
var green200 = exports.green200 = '#a5d6a7';
var green300 = exports.green300 = '#81c784';
var green400 = exports.green400 = '#66bb6a';
var green500 = exports.green500 = '#4caf50';
var green600 = exports.green600 = '#43a047';
var green700 = exports.green700 = '#388e3c';
var green800 = exports.green800 = '#2e7d32';
var green900 = exports.green900 = '#1b5e20';
var greenA100 = exports.greenA100 = '#b9f6ca';
var greenA200 = exports.greenA200 = '#69f0ae';
var greenA400 = exports.greenA400 = '#00e676';
var greenA700 = exports.greenA700 = '#00c853';

var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
var lightGreen100 = exports.lightGreen100 = '#dcedc8';
var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
var lightGreen300 = exports.lightGreen300 = '#aed581';
var lightGreen400 = exports.lightGreen400 = '#9ccc65';
var lightGreen500 = exports.lightGreen500 = '#8bc34a';
var lightGreen600 = exports.lightGreen600 = '#7cb342';
var lightGreen700 = exports.lightGreen700 = '#689f38';
var lightGreen800 = exports.lightGreen800 = '#558b2f';
var lightGreen900 = exports.lightGreen900 = '#33691e';
var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
var lightGreenA700 = exports.lightGreenA700 = '#64dd17';

var lime50 = exports.lime50 = '#f9fbe7';
var lime100 = exports.lime100 = '#f0f4c3';
var lime200 = exports.lime200 = '#e6ee9c';
var lime300 = exports.lime300 = '#dce775';
var lime400 = exports.lime400 = '#d4e157';
var lime500 = exports.lime500 = '#cddc39';
var lime600 = exports.lime600 = '#c0ca33';
var lime700 = exports.lime700 = '#afb42b';
var lime800 = exports.lime800 = '#9e9d24';
var lime900 = exports.lime900 = '#827717';
var limeA100 = exports.limeA100 = '#f4ff81';
var limeA200 = exports.limeA200 = '#eeff41';
var limeA400 = exports.limeA400 = '#c6ff00';
var limeA700 = exports.limeA700 = '#aeea00';

var yellow50 = exports.yellow50 = '#fffde7';
var yellow100 = exports.yellow100 = '#fff9c4';
var yellow200 = exports.yellow200 = '#fff59d';
var yellow300 = exports.yellow300 = '#fff176';
var yellow400 = exports.yellow400 = '#ffee58';
var yellow500 = exports.yellow500 = '#ffeb3b';
var yellow600 = exports.yellow600 = '#fdd835';
var yellow700 = exports.yellow700 = '#fbc02d';
var yellow800 = exports.yellow800 = '#f9a825';
var yellow900 = exports.yellow900 = '#f57f17';
var yellowA100 = exports.yellowA100 = '#ffff8d';
var yellowA200 = exports.yellowA200 = '#ffff00';
var yellowA400 = exports.yellowA400 = '#ffea00';
var yellowA700 = exports.yellowA700 = '#ffd600';

var amber50 = exports.amber50 = '#fff8e1';
var amber100 = exports.amber100 = '#ffecb3';
var amber200 = exports.amber200 = '#ffe082';
var amber300 = exports.amber300 = '#ffd54f';
var amber400 = exports.amber400 = '#ffca28';
var amber500 = exports.amber500 = '#ffc107';
var amber600 = exports.amber600 = '#ffb300';
var amber700 = exports.amber700 = '#ffa000';
var amber800 = exports.amber800 = '#ff8f00';
var amber900 = exports.amber900 = '#ff6f00';
var amberA100 = exports.amberA100 = '#ffe57f';
var amberA200 = exports.amberA200 = '#ffd740';
var amberA400 = exports.amberA400 = '#ffc400';
var amberA700 = exports.amberA700 = '#ffab00';

var orange50 = exports.orange50 = '#fff3e0';
var orange100 = exports.orange100 = '#ffe0b2';
var orange200 = exports.orange200 = '#ffcc80';
var orange300 = exports.orange300 = '#ffb74d';
var orange400 = exports.orange400 = '#ffa726';
var orange500 = exports.orange500 = '#ff9800';
var orange600 = exports.orange600 = '#fb8c00';
var orange700 = exports.orange700 = '#f57c00';
var orange800 = exports.orange800 = '#ef6c00';
var orange900 = exports.orange900 = '#e65100';
var orangeA100 = exports.orangeA100 = '#ffd180';
var orangeA200 = exports.orangeA200 = '#ffab40';
var orangeA400 = exports.orangeA400 = '#ff9100';
var orangeA700 = exports.orangeA700 = '#ff6d00';

var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
var deepOrange100 = exports.deepOrange100 = '#ffccbc';
var deepOrange200 = exports.deepOrange200 = '#ffab91';
var deepOrange300 = exports.deepOrange300 = '#ff8a65';
var deepOrange400 = exports.deepOrange400 = '#ff7043';
var deepOrange500 = exports.deepOrange500 = '#ff5722';
var deepOrange600 = exports.deepOrange600 = '#f4511e';
var deepOrange700 = exports.deepOrange700 = '#e64a19';
var deepOrange800 = exports.deepOrange800 = '#d84315';
var deepOrange900 = exports.deepOrange900 = '#bf360c';
var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';

var brown50 = exports.brown50 = '#efebe9';
var brown100 = exports.brown100 = '#d7ccc8';
var brown200 = exports.brown200 = '#bcaaa4';
var brown300 = exports.brown300 = '#a1887f';
var brown400 = exports.brown400 = '#8d6e63';
var brown500 = exports.brown500 = '#795548';
var brown600 = exports.brown600 = '#6d4c41';
var brown700 = exports.brown700 = '#5d4037';
var brown800 = exports.brown800 = '#4e342e';
var brown900 = exports.brown900 = '#3e2723';

var blueGrey50 = exports.blueGrey50 = '#eceff1';
var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
var blueGrey200 = exports.blueGrey200 = '#b0bec5';
var blueGrey300 = exports.blueGrey300 = '#90a4ae';
var blueGrey400 = exports.blueGrey400 = '#78909c';
var blueGrey500 = exports.blueGrey500 = '#607d8b';
var blueGrey600 = exports.blueGrey600 = '#546e7a';
var blueGrey700 = exports.blueGrey700 = '#455a64';
var blueGrey800 = exports.blueGrey800 = '#37474f';
var blueGrey900 = exports.blueGrey900 = '#263238';

var grey50 = exports.grey50 = '#fafafa';
var grey100 = exports.grey100 = '#f5f5f5';
var grey200 = exports.grey200 = '#eeeeee';
var grey300 = exports.grey300 = '#e0e0e0';
var grey400 = exports.grey400 = '#bdbdbd';
var grey500 = exports.grey500 = '#9e9e9e';
var grey600 = exports.grey600 = '#757575';
var grey700 = exports.grey700 = '#616161';
var grey800 = exports.grey800 = '#424242';
var grey900 = exports.grey900 = '#212121';

var black = exports.black = '#000000';
var white = exports.white = '#ffffff';

var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotifyManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notifyManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(70);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["s" /* scheduleMicrotask */])(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["s" /* scheduleMicrotask */])(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentCreate = function ContentCreate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
  );
};
ContentCreate = (0, _pure2.default)(ContentCreate);
ContentCreate.displayName = 'ContentCreate';
ContentCreate.muiName = 'SvgIcon';

exports.default = ContentCreate;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messages = __webpack_require__(912);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = {
  allowBlank: false,
  urlProtocols: ['http', 'https'],
  dateFormat: 'yyyy-mm-dd', // ISO
  dateYmd: 'ymd',
  accept: ['1', 'true'],
  caseSensitive: true // confirmation, inclusion, exclusion
};

var Validators = {
  formatMessage: formatMessage,
  formatSize: formatSize,
  defaultOptions: DEFAULT_OPTIONS,
  messages: _messages2.default,
  pluralRules: {
    0: 'zero',
    1: 'one'
  }
};

exports.default = Validators;


function formatSize(size, unit) {
  return size + ' ' + unit;
}

function formatMessage(msg) {
  if (msg.props) {
    msg = msg.props;
  }
  var text = msg.defaultMessage || msg.id || '';
  var rules = Validators.pluralRules;
  return !msg.values ? text : parseMsg(text, function (part) {
    var parts = part.split(',');
    var count = msg.values[parts[0]];
    // {value} OR {count, number}
    if (parts.length <= 2) {
      return count == null ? '' : '' + count;
    }
    // plural
    var plural = parts.slice(2).join(',').trim();
    var info = {};
    var result = parseMsg(plural, null, rules[+count] || 'other', info);
    return info.found ? result : parseMsg(plural, null, 'other', {});
  });
}

function parseMsg(msg, func, pattern, info) {
  var start = msg.indexOf('{');
  if (start < 0) return pattern ? '' : msg;
  var index = start;
  var count = 1;
  var len = msg.length;
  while (count > 0 && index < len) {
    ++index;
    if (msg.charAt(index) === '{') {
      ++count;
    }
    if (msg.charAt(index) === '}') {
      --count;
    }
  }
  if (pattern) {
    if (pattern === msg.slice(0, start).trim()) {
      info.found = true;
      return msg.slice(start + 1, index).trim();
    }
    return parseMsg(msg.slice(index + 1), null, pattern, info);
  }

  // func gets all '{.*}' parts
  // e.g:
  // - {count}
  // - {count, plural, one {1 thing} other {many things}}
  // - ...
  return msg.slice(0, start) + parseMsg(func(msg.slice(start + 1, index).trim()), func) + parseMsg(msg.slice(index + 1), func);
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TO_STRING = exports.HAS_PROP = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.regFormat = regFormat;
exports.prepare = prepare;
exports.trunc = trunc;
exports.selectNum = selectNum;
exports.isNumber = isNumber;
exports.prepareMsg = prepareMsg;
exports.toObjectMsg = toObjectMsg;
exports.memoize = memoize;

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HAS_PROP = exports.HAS_PROP = {}.hasOwnProperty;
var TO_STRING = exports.TO_STRING = {}.toString;

function regFormat(func, messageType) {
  return memoize(function (options) {
    options = options || {};
    var msg = options.msg || options.message;

    return prepare(options['if'], options.unless, options.allowBlank, function (value) {
      if (!value.match(func(options))) {
        return _validators2.default.formatMessage(prepareMsg(msg, messageType));
      }
    });
  });
}

function prepare(ifCond, unlessCond, allowBlank, func) {
  return function (value) {
    var allValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
      value = value == null ? '' : '' + value;

      if ((allowBlank != null ? allowBlank : _validators2.default.defaultOptions.allowBlank) && !value.trim()) {
        return;
      }
    }
    if ((typeof ifCond !== 'function' || ifCond(allValues, value)) && (typeof unlessCond !== 'function' || !unlessCond(allValues, value))) {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return func.apply(undefined, [value, allValues].concat(args));
    }
  };
}

function trunc(num) {
  /* istanbul ignore next */
  return Math.trunc ? Math.trunc(num) : num < 0 ? Math.ceil(num) : Math.floor(num);
}

function selectNum(var1, var2) {
  return isNumber(var1) ? +var1 : arguments.length > 1 && isNumber(var2) ? +var2 : null;
}

function isNumber(num) {
  // eslint-disable-next-line
  return !isNaN(num) && (0 != num || '' !== ('' + num).trim());
}

function prepareMsg(msg, type, values) {
  if (msg == null) {
    return defaultMessage(type, values);
  }
  if (HAS_PROP.call(msg, 'props') && isReactElement(msg)) {
    msg = msg.props;
  }
  if (msg[type] != null) {
    msg = msg[type];
  }
  if (isObject(msg)) {
    if (HAS_PROP.call(msg, 'id') || HAS_PROP.call(msg, 'defaultMessage')) {
      return Object.assign({}, msg, { values: values });
    }
    return defaultMessage(type, values);
  }
  return { id: msg, defaultMessage: msg, values: values };
}

function toObjectMsg(msg) {
  if (msg == null) return null;
  return isObject(msg) ? msg : { id: msg, defaultMessage: msg };
}

function memoize(func) {
  if (!func.cache) {
    func.cache = {};
  }
  return function (options) {
    var key = stringify(options);
    return HAS_PROP.call(func.cache, key) ? func.cache[key] : func.cache[key] = func(options);
  };
}

// private
function defaultMessage(type, values) {
  var msg = _validators2.default.messages[type];
  return typeof msg === 'string' ? { defaultMessage: msg, values: values } : Object.assign({}, msg, { values: values });
}

function stringify(options) {
  var arr = [];
  var value = void 0;
  for (var k in options) {
    if (HAS_PROP.call(options, k)) {
      value = options[k];
      arr.push(k, isReactElement(value) ? stringify(value.props) : isObject(value) ? stringify(value) : value.toString());
    }
  }
  return JSON.stringify(arr);
}

function isReactElement(object) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && '$$typeof' in object;
}

function isObject(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && TO_STRING.call(obj) === '[object Object]' && obj !== null;
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(66);
var createDesc = __webpack_require__(170);
module.exports = __webpack_require__(65) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(42);
var hide = __webpack_require__(86);
var has = __webpack_require__(92);
var SRC = __webpack_require__(171)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(107).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var fails = __webpack_require__(47);
var defined = __webpack_require__(119);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);

exports.default = {

  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),

  horizontal: horizontal,

  vertical: vertical,

  origin: _propTypes2.default.shape({
    horizontal: horizontal,
    vertical: vertical
  }),

  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),

  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])

};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = toUTC;
/* harmony export (immutable) */ __webpack_exports__["a"] = fromUTC;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeLocalAppearUTC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return localToUTC; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function toUTC(date) {
    if (!date.getDate) {
        date = new Date(date);
    }
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}

function fromUTC(date) {
    if (!date.getDate) {
        date = new Date(date);
    }
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

var getTimezoneOffset = function getTimezoneOffset(value) {
    return value.getTimezoneOffset() * 60000;
};

var makeLocalAppearUTC = function makeLocalAppearUTC(value) {
    var dateTime = new Date(value);
    var utcFromLocal = new Date(dateTime.getTime() + getTimezoneOffset(dateTime));
    return utcFromLocal;
};

var localToUTC = function localToUTC(dateTime) {
    var utcFromLocal = new Date(dateTime.getTime() - getTimezoneOffset(dateTime));
    return utcFromLocal;
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(toUTC, "toUTC", "/opt/atlassian/pipelines/agent/build/client/app/helpers/dates.js");
    reactHotLoader.register(fromUTC, "fromUTC", "/opt/atlassian/pipelines/agent/build/client/app/helpers/dates.js");
    reactHotLoader.register(getTimezoneOffset, "getTimezoneOffset", "/opt/atlassian/pipelines/agent/build/client/app/helpers/dates.js");
    reactHotLoader.register(makeLocalAppearUTC, "makeLocalAppearUTC", "/opt/atlassian/pipelines/agent/build/client/app/helpers/dates.js");
    reactHotLoader.register(localToUTC, "localToUTC", "/opt/atlassian/pipelines/agent/build/client/app/helpers/dates.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 92 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(244);
var defined = __webpack_require__(119);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(245);
var createDesc = __webpack_require__(170);
var toIObject = __webpack_require__(93);
var toPrimitive = __webpack_require__(118);
var has = __webpack_require__(92);
var IE8_DOM_DEFINE = __webpack_require__(583);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(65) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(92);
var toObject = __webpack_require__(68);
var IE_PROTO = __webpack_require__(403)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(1226);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(665);
var isBuffer = __webpack_require__(1341);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getVesselOrders */
/* harmony export (immutable) */ __webpack_exports__["c"] = createVesselOrders;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearMessage;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateVesselOrder;
/* harmony export (immutable) */ __webpack_exports__["a"] = addVesselOrder;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeLastVesselOrder;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateVesselOrderUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeAllVesselOrders;
/* harmony export (immutable) */ __webpack_exports__["f"] = resetVesselOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getVesselOrders() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_60" /* GET_VESSEL_ORDERS */]
    };
}

function createVesselOrders(items, user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["G" /* CREATE_VESSEL_ORDERS */],
        items: items,
        user: user
    };
}

function clearMessage(vesselOrderKey) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["x" /* CLEAR_VESSEL_ORDER_MESSAGE */],
        vesselOrderKey: vesselOrderKey
    };
}

function updateVesselOrder(numberOrder, newVesselOrder) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_143" /* UPDATE_VESSEL_ORDER */],
        numberOrder: numberOrder,
        newVesselOrder: newVesselOrder
    };
}

function addVesselOrder() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["i" /* ADD_VESSEL_ORDER */]
    };
}

function removeLastVesselOrder() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_86" /* REMOVE_LAST_VESSEL_ORDER */]
    };
}

function updateVesselOrderUser(user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_144" /* UPDATE_VESSEL_ORDER_USER */],
        user: user
    };
}

function removeAllVesselOrders() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_78" /* REMOVE_ALL_VESSEL_ORDERS */]
    };
}

function resetVesselOrders() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_93" /* RESET_VESSEL_ORDERS */]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVesselOrders, 'getVesselOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(createVesselOrders, 'createVesselOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(clearMessage, 'clearMessage', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(updateVesselOrder, 'updateVesselOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(addVesselOrder, 'addVesselOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(removeLastVesselOrder, 'removeLastVesselOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(updateVesselOrderUser, 'updateVesselOrderUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(removeAllVesselOrders, 'removeAllVesselOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    reactHotLoader.register(resetVesselOrders, 'resetVesselOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;

var _Popover2 = __webpack_require__(226);

var _Popover3 = _interopRequireDefault(_Popover2);

var _PopoverAnimationVertical2 = __webpack_require__(494);

var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Popover = _Popover3.default;
exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
exports.default = _Popover3.default;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationChevronLeft = function NavigationChevronLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
  );
};
NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
NavigationChevronLeft.displayName = 'NavigationChevronLeft';
NavigationChevronLeft.muiName = 'SvgIcon';

exports.default = NavigationChevronLeft;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationChevronRight = function NavigationChevronRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
  );
};
NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
NavigationChevronRight.displayName = 'NavigationChevronRight';
NavigationChevronRight.muiName = 'SvgIcon';

exports.default = NavigationChevronRight;

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export checkHasChange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckDiffText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasChangesLiftsCranes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var checkHasChange = function checkHasChange(oldValue, newValue) {
    if (oldValue === null && newValue === undefined || oldValue === undefined && newValue === null || newValue === oldValue) {
        return false;
    }
    return true;
};

var CheckDiffText = function CheckDiffText(_ref) {
    var oldValue = _ref.oldValue,
        newValue = _ref.newValue;

    if (checkHasChange(oldValue, newValue)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'dirty-text' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'old' },
                oldValue
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'new' },
                newValue
            )
        );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        oldValue
    );
};

var hasChanges = function hasChanges(oldValues, newValues) {
    if (oldValues === newValues) return false;

    var normalizedOld = oldValues || {};
    var normalizedNew = newValues || {};

    var cleanOld = Object.fromEntries(Object.entries(normalizedOld).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            _k = _ref3[0],
            v = _ref3[1];

        return v !== undefined;
    }));
    var cleanNew = Object.fromEntries(Object.entries(normalizedNew).filter(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            _k = _ref5[0],
            v = _ref5[1];

        return v !== undefined;
    }));

    return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(cleanOld, cleanNew);
};

var hasChangesLiftsCranesDetails = function hasChangesLiftsCranesDetails(values) {
    var hasChange = false;
    Object.values(values).forEach(function (value) {
        value.details.forEach(function (detail) {
            if (['change', 'new'].includes(detail.status)) hasChange = true;
        });
    });
    return hasChange;
};

var hasChangesLiftsCranes = function hasChangesLiftsCranes(oldValues, newValues) {
    var normalizedOld = oldValues || {};
    var normalizedNew = newValues || {};

    if (hasChangesLiftsCranesDetails(normalizedNew)) return true;

    var compareRange = function compareRange(oldRange, newRange) {
        var oldClean = {
            checked: oldRange && oldRange.checked ? oldRange.checked : false,
            details: oldRange && oldRange.details ? oldRange.details.map(function (d) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(d, ['status', '_id']);
            }) : []
        };
        var newClean = {
            checked: newRange && newRange.checked ? newRange.checked : false,
            details: newRange && newRange.details ? newRange.details.map(function (d) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(d, ['status', '_id']);
            }) : []
        };
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(oldClean, newClean);
    };

    var allKeys = new Set([].concat(_toConsumableArray(Object.keys(normalizedOld)), _toConsumableArray(Object.keys(normalizedNew))));
    return Array.from(allKeys).some(function (key) {
        return !compareRange(normalizedOld[key], normalizedNew[key]);
    });
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(checkHasChange, 'checkHasChange', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/utils.js');
    reactHotLoader.register(CheckDiffText, 'CheckDiffText', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/utils.js');
    reactHotLoader.register(hasChanges, 'hasChanges', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/utils.js');
    reactHotLoader.register(hasChangesLiftsCranesDetails, 'hasChangesLiftsCranesDetails', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/utils.js');
    reactHotLoader.register(hasChangesLiftsCranes, 'hasChangesLiftsCranes', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/utils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageControlPoint = function ImageControlPoint(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ImageControlPoint = (0, _pure2.default)(ImageControlPoint);
ImageControlPoint.displayName = 'ImageControlPoint';
ImageControlPoint.muiName = 'SvgIcon';

exports.default = ImageControlPoint;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(76);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(47);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(442)('wks');
var uid = __webpack_require__(312);
var Symbol = __webpack_require__(152).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__(344);

var _events2 = _interopRequireDefault(_events);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _FocusRipple = __webpack_require__(492);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(736);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement('style');
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    _events2.default.on(window, 'keydown', function (event) {
      tabPressed = (0, _keycode2.default)(event) === 'tab';
    });
    listening = true;
  }
}

var EnhancedButton = function (_Component) {
  (0, _inherits3.default)(EnhancedButton, _Component);

  function EnhancedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleKeyDown = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
          _this.removeKeyboardFocus(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleKeyUp = function (event) {
      _this.props.onKeyUp(event);
    }, _this.handleBlur = function (event) {
      _this.cancelFocusTimeout();
      _this.removeKeyboardFocus(event);
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (event) event.persist();
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        // setTimeout is needed because the focus event fires first
        // Wait so that we can capture if this was a keyboard focus
        // or touch focus
        _this.focusTimeout = setTimeout(function () {
          if (tabPressed) {
            _this.setKeyboardFocus(event);
            tabPressed = false;
          }
        }, 150);

        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      _this.cancelFocusTimeout();
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.removeKeyboardFocus(event);
        _this.props.onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          disabled = _props.disabled,
          disableKeyboardFocus = _props.disableKeyboardFocus,
          keyboardFocused = _props.keyboardFocused;

      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
        this.setState({ isKeyboardFocused: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      injectStyle();
      listenForTabPresses();
      if (this.state.isKeyboardFocused) {
        this.button.focus();
        this.props.onKeyboardFocus(null, true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        if (nextProps.onKeyboardFocus) {
          nextProps.onKeyboardFocus(null, false);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
    }
  }, {
    key: 'isKeyboardFocused',
    value: function isKeyboardFocused() {
      return this.state.isKeyboardFocused;
    }
  }, {
    key: 'removeKeyboardFocus',
    value: function removeKeyboardFocus(event) {
      if (this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        this.props.onKeyboardFocus(event, false);
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus(event) {
      if (!this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: true });
        this.props.onKeyboardFocus(event, true);
      }
    }
  }, {
    key: 'cancelFocusTimeout',
    value: function cancelFocusTimeout() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
        this.focusTimeout = null;
      }
    }
  }, {
    key: 'createButtonChildren',
    value: function createButtonChildren() {
      var _props2 = this.props,
          centerRipple = _props2.centerRipple,
          children = _props2.children,
          disabled = _props2.disabled,
          disableFocusRipple = _props2.disableFocusRipple,
          disableKeyboardFocus = _props2.disableKeyboardFocus,
          disableTouchRipple = _props2.disableTouchRipple,
          focusRippleColor = _props2.focusRippleColor,
          focusRippleOpacity = _props2.focusRippleOpacity,
          touchRippleColor = _props2.touchRippleColor,
          touchRippleOpacity = _props2.touchRippleOpacity;
      var isKeyboardFocused = this.state.isKeyboardFocused;

      // Focus Ripple

      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
        color: focusRippleColor,
        opacity: focusRippleOpacity,
        show: isKeyboardFocused,
        style: {
          overflow: 'hidden'
        },
        key: 'focusRipple'
      }) : undefined;

      // Touch Ripple
      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
        _TouchRipple2.default,
        {
          centerRipple: centerRipple,
          color: touchRippleColor,
          opacity: touchRippleOpacity,
          key: 'touchRipple'
        },
        children
      ) : undefined;

      return [focusRipple, touchRipple, touchRipple ? undefined : children];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          centerRipple = _props3.centerRipple,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableFocusRipple = _props3.disableFocusRipple,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          disableTouchRipple = _props3.disableTouchRipple,
          focusRippleColor = _props3.focusRippleColor,
          focusRippleOpacity = _props3.focusRippleOpacity,
          href = _props3.href,
          keyboardFocused = _props3.keyboardFocused,
          touchRippleColor = _props3.touchRippleColor,
          touchRippleOpacity = _props3.touchRippleOpacity,
          onBlur = _props3.onBlur,
          onClick = _props3.onClick,
          onFocus = _props3.onFocus,
          onKeyUp = _props3.onKeyUp,
          onKeyDown = _props3.onKeyDown,
          onKeyboardFocus = _props3.onKeyboardFocus,
          style = _props3.style,
          tabIndex = _props3.tabIndex,
          type = _props3.type,
          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          enhancedButton = _context$muiTheme.enhancedButton;


      var mergedStyles = (0, _simpleAssign2.default)({
        border: 10,
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
        cursor: disabled ? 'default' : 'pointer',
        textDecoration: 'none',
        margin: 0,
        padding: 0,
        outline: 'none',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        position: 'relative', // This is needed so that ripples do not bleed past border radius.
        verticalAlign: href ? 'middle' : null
      }, style);

      // Passing both background:none & backgroundColor can break due to object iteration order
      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
        mergedStyles.background = 'none';
      }

      if (disabled && href) {
        return _react2.default.createElement(
          'span',
          (0, _extends3.default)({}, other, {
            style: mergedStyles
          }),
          children
        );
      }

      var buttonProps = (0, _extends3.default)({}, other, {
        style: prepareStyles(mergedStyles),
        ref: function ref(node) {
          return _this2.button = node;
        },
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
      });

      if (href) buttonProps.href = href;

      var buttonChildren = this.createButtonChildren();

      if (_react2.default.isValidElement(containerElement)) {
        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
      }

      if (!href && containerElement === 'button') {
        buttonProps.type = type;
      }

      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
    }
  }]);
  return EnhancedButton;
}(_react.Component);

EnhancedButton.defaultProps = {
  containerElement: 'button',
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  tabIndex: 0,
  type: 'button'
};
EnhancedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedButton.propTypes =  false ? {
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  disableFocusRipple: _propTypes2.default.bool,
  disableKeyboardFocus: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusRippleColor: _propTypes2.default.string,
  focusRippleOpacity: _propTypes2.default.number,
  href: _propTypes2.default.string,
  keyboardFocused: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  style: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,
  touchRippleColor: _propTypes2.default.string,
  touchRippleOpacity: _propTypes2.default.number,
  type: _propTypes2.default.string
} : {};
exports.default = EnhancedButton;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _DatePicker = __webpack_require__(1805);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DatePicker2.default;

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = useDebounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



// debounce hook to delay function call
function useDebounce(value, delay) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(value),
        _useState2 = _slicedToArray(_useState, 2),
        debouncedValue = _useState2[0],
        setDebouncedValue = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);

        return function () {
            clearTimeout(handler);
        };
    }, [value]);

    return debouncedValue;
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(useDebounce, 'useDebounce', '/opt/atlassian/pipelines/agent/build/client/app/helpers/useDebounce.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red = undefined;

var _each = __webpack_require__(2116);

var _each2 = _interopRequireDefault(_each);

var _tinycolor = __webpack_require__(2117);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
    var checked = 0;
    var passed = 0;
    (0, _each2.default)(keysToCheck, function (letter) {
      if (data[letter]) {
        checked += 1;
        if (!isNaN(data[letter])) {
          passed += 1;
        }
        if (letter === 's' || letter === 'l') {
          var percentPatt = /^\d+%$/;
          if (percentPatt.test(data[letter])) {
            passed += 1;
          }
        }
      }
    });
    return checked === passed ? data : false;
  },
  toState: function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;

    return {
      hsl: hsl,
      hex: transparent ? 'transparent' : '#' + hex,
      rgb: rgb,
      hsv: hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source
    };
  },
  isValidHex: function isValidHex(hex) {
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
  },
  getContrastingColor: function getContrastingColor(data) {
    if (!data) {
      return '#fff';
    }
    var col = this.toState(data);
    if (col.hex === 'transparent') {
      return 'rgba(0,0,0,0.4)';
    }
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
  }
};
var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(48);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(12);
var core = __webpack_require__(107);
var fails = __webpack_require__(47);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(108);
var IObject = __webpack_require__(244);
var toObject = __webpack_require__(68);
var toLength = __webpack_require__(60);
var asc = __webpack_require__(419);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(622);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["f"] = logoutUser;
/* unused harmony export getUser */
/* harmony export (immutable) */ __webpack_exports__["b"] = authUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = getUserList;
/* harmony export (immutable) */ __webpack_exports__["c"] = banUserById;
/* harmony export (immutable) */ __webpack_exports__["j"] = unbanUserById;
/* harmony export (immutable) */ __webpack_exports__["a"] = addUsersFromAutocomplete;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUserLimitationsList;
/* harmony export (immutable) */ __webpack_exports__["g"] = setUserToBlackList;
/* harmony export (immutable) */ __webpack_exports__["h"] = setUserToWhiteList;
/* harmony export (immutable) */ __webpack_exports__["i"] = toggleWhiteList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function logoutUser() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_66" /* LOGOUT_USER */].REQUEST
    };
}

function getUser() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_54" /* GET_USER */].REQUEST
    };
}

function authUser(email, password) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["m" /* AUTH_USER */].REQUEST,
        email: email,
        password: password
    };
}

function getUserList(pagination) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_56" /* GET_USER_LIST */].REQUEST,
        pagination: pagination
    };
}

function banUserById(user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["n" /* BAN_USER_BY_ID */].REQUEST,
        user: user
    };
}

function unbanUserById(user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_118" /* UNBAN_USER_BY_ID */].REQUEST,
        user: user
    };
}

function addUsersFromAutocomplete(users) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["g" /* ADD_USERS_FROM_AUTOCOMPLETE */],
        users: users
    };
}

function getUserLimitationsList() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_55" /* GET_USER_LIMITATIONS_LIST */].REQUEST
    };
}

function setUserToBlackList(emails, user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_115" /* SET_USER_TO_BLACK_LIST */].REQUEST,
        emails: emails,
        user: user
    };
}

function setUserToWhiteList(emails, user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_116" /* SET_USER_TO_WHITE_LIST */].REQUEST,
        emails: emails,
        user: user
    };
}

function toggleWhiteList(user, whiteActive) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_117" /* TOGGLE_WHITE_LIST */].REQUEST,
        user: user,
        whiteActive: whiteActive
    };
}

// todo change bane file to users

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(logoutUser, 'logoutUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(getUser, 'getUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(authUser, 'authUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(getUserList, 'getUserList', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(banUserById, 'banUserById', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(unbanUserById, 'unbanUserById', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(addUsersFromAutocomplete, 'addUsersFromAutocomplete', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(getUserLimitationsList, 'getUserLimitationsList', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(setUserToBlackList, 'setUserToBlackList', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(setUserToWhiteList, 'setUserToWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    reactHotLoader.register(toggleWhiteList, 'toggleWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.Menu = undefined;

var _Menu2 = __webpack_require__(352);

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = __webpack_require__(26);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Menu = _Menu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _Menu3.default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Toggle = __webpack_require__(1857);

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Toggle2.default;

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = createTcOrders;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateTcOrder;
/* harmony export (immutable) */ __webpack_exports__["a"] = addTcOrder;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeLastTcOrder;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateTcOrderUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = resetTcOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function createTcOrders(tcOrders, user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["F" /* CREATE_TC_ORDERS */],
        items: tcOrders,
        user: user
    };
}

function updateTcOrder(numberOrder, newTcOrder) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_139" /* UPDATE_TC_ORDER */],
        numberOrder: numberOrder,
        newTcOrder: newTcOrder
    };
}

function addTcOrder() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["f" /* ADD_TC_ORDER */]
    };
}

function removeLastTcOrder() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_85" /* REMOVE_LAST_TC_ORDER */]
    };
}

function updateTcOrderUser(user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_140" /* UPDATE_TC_ORDER_USER */],
        user: user
    };
}

function resetTcOrders() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_92" /* RESET_TC_ORDERS */]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(createTcOrders, 'createTcOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/orders.js');
    reactHotLoader.register(updateTcOrder, 'updateTcOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/orders.js');
    reactHotLoader.register(addTcOrder, 'addTcOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/orders.js');
    reactHotLoader.register(removeLastTcOrder, 'removeLastTcOrder', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/orders.js');
    reactHotLoader.register(updateTcOrderUser, 'updateTcOrderUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/orders.js');
    reactHotLoader.register(resetTcOrders, 'resetTcOrders', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCountries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCountries() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_24" /* GET_COUNTRIES */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCountries, 'getCountries', '/opt/atlassian/pipelines/agent/build/client/app/actions/countries.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RadioElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDefaultCargoRequestValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRANSPORTATION_ALL; });
/* unused harmony export CATEGORIES_ALL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPackingTransportation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPackingForBreakBulk; });
/* unused harmony export CONTAINER_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OWNER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOT_RESET_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return displayValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var RadioElement = function RadioElement(_ref) {
    var value = _ref.value,
        checkedValue = _ref.checkedValue,
        _ref$label = _ref.label,
        label = _ref$label === undefined ? '' : _ref$label,
        _ref$onCheck = _ref.onCheck,
        onCheck = _ref$onCheck === undefined ? function () {} : _ref$onCheck,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _key = _ref._key;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(checkedValue),
        _useState2 = _slicedToArray(_useState, 2),
        valueSelected = _useState2[0],
        setValueSelected = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setValueSelected(checkedValue);
    }, [checkedValue]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui__["q" /* RadioButtonGroup */],
        { key: _key, name: label, onChange: onCheck, valueSelected: valueSelected },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["p" /* RadioButton */], {
            label: label.toUpperCase(),
            value: value,
            disabled: disabled,
            style: {
                height: '48px'
            },
            labelStyle: {
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '22px',
                marginTop: '12px'
            },
            iconStyle: {
                marginTop: '6px'
            }
        })
    );
};

/**
 * 
 * @param {string | undefined} field 
 */
var getDefaultCargoRequestValue = function getDefaultCargoRequestValue(field) {
    switch (field) {
        case 'packing':
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__["a" /* orderNew */].cargo[0].packing);
        case 'density':
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__["a" /* orderNew */].cargo[0].packing.pack.densities[0]);
        case 'containerDetails':
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__["a" /* orderNew */].cargo[0].containerDetails);
        case undefined:
        default:
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__["a" /* orderNew */]);
    }
};

var TRANSPORTATION_ALL = ['breakbulk', 'bulk', 'container', 'wetbulk'];

var CATEGORIES_ALL = ['bulk', 'unpacked', 'packed', 'loose', 'wetBulk', 'container'];

var getPackingTransportation = function getPackingTransportation(cargoType) {
    switch (cargoType) {
        case 'Metals & Steel Products':
            return {
                breakbulk: ['packed', 'loose'],
                bulk: ['bulk'],
                container: ['container']
            };
        case 'Forest Products':
            return {
                breakbulk: ['packed', 'loose'],
                bulk: ['bulk'],
                container: ['container']
            };
        case 'Equipment & Machinery':
            return {
                breakbulk: ['unpacked'],
                container: ['container']
            };
        case 'Grains & Agricultural Products':
            return {
                breakbulk: ['packed'],
                bulk: ['bulk'],
                container: ['container'],
                wetbulk: ['wetBulk']
            };
        case 'Fertilizers':
            return {
                breakbulk: ['packed'],
                bulk: ['bulk'],
                container: ['container'],
                wetbulk: ['wetBulk']
            };
        case 'Oil & Chemicals':
            return {
                breakbulk: ['packed'],
                bulk: ['bulk'],
                container: ['container'],
                wetbulk: ['wetBulk']
            };
        case 'Minerals and Rocks':
            return {
                breakbulk: ['packed'],
                bulk: ['bulk'],
                container: ['container']
            };
        case 'Food and Beverages':
            return {
                breakbulk: ['packed'],
                bulk: ['bulk'],
                container: ['container'],
                wetbulk: ['wetBulk']
            };
        case 'Perishables':
            return {
                breakbulk: ['packed'],
                bulk: ['bulk'],
                container: ['container']
            };
        case 'Live Stock':
            return {
                breakbulk: ['unpacked'],
                container: ['container']
            };
        case 'Organic Material':
            return {
                breakbulk: ['packed'],
                bulk: ['bulk'],
                container: ['container']
            };
        case 'Consumer Goods':
            return {
                breakbulk: ['unpacked', 'packed'],
                container: ['container']
            };
        case 'Project & General cargo':
            return {
                breakbulk: ['unpacked', 'packed'],
                container: ['container']
            };
        case 'Containers':
            return {
                container: ['container']
            };
        case 'Other':
        default:
            return {
                breakbulk: CATEGORIES_ALL,
                bulk: CATEGORIES_ALL,
                container: CATEGORIES_ALL,
                wetbulk: CATEGORIES_ALL
            };
    }
};

var getPackingForBreakBulk = function getPackingForBreakBulk(details) {
    switch (details) {
        case 1:
            return ['unpacked'];
        case 2:
            return ['unpacked', 'packed'];
        case 3:
            return ['loose', 'packed'];
        case 4:
            return ['packed'];
        case 5:
            return ['loose'];
        case 6:
            return ['loose', 'packed'];
        case 7:
            return ['packed'];
        case 8:
            return ['packed'];
        case 9:
            return ['packed'];
        case 10:
            return ['unpacked', 'packed'];
        case 11:
            return ['unpacked'];
        case 12:
            return ['unpacked'];
        case 13:
            return ['unpacked'];
        case 14:
            return ['unpacked'];
        default:
            return CATEGORIES_ALL;
    }
};

var CONTAINER_TYPES = [{ name: '20\' Standard Container' }, { name: '20\' Specialized Container' }, { name: '20\' Closed Top Container' }, { name: '20\' Flatrack Container' }, { name: '20\' High Cube Container' }, { name: '20\' Open Top Container' }, { name: '20\' Open Top/Hard Top Container' }, { name: '20\' Open Top High Cube Container' }, { name: '20\' Refrigerated Container' }, { name: '20\' Tank Container', isTank: true }, { name: '40\' Standard Container' }, { name: '40\' Specialized Container' }, { name: '40\' High Cube Container' }, { name: '40\' High Cube Refrigerated Container' }, { name: '40\' Flatrack Container' }, { name: '40\' Open Top Container' }, { name: '40\' Open Top/Hard Top Container' }, { name: '40\' Open Top High Cube Container' }, { name: '40\' Platform Container' }, { name: '40\' Refrigerated Container' }, { name: '40\' Tank Container', isTank: true }, { name: '45\' Standard Container' }, { name: '45\' Specialized Container' }, { name: '45\' High Cube Container' }, { name: '45\' Refrigerated Container' }, { name: 'Livestock Container' }, { name: 'Quadcon Container' }, { name: 'Tricon Container' }, { name: '8\' Standard Container' }, { name: '8\' High Cube Container' }, { name: '10\' Standard Container' }, { name: '10\' Specialized Container' }, { name: '10\' Closed Top Container' }, { name: '10\' High Cube Container' }, { name: '10\' Flatrack Container' }, { name: '10\' Refrigerated Container' }, { name: '11\' Standard Container' }, { name: '11\' Open Top Container' }, { name: '11\' Refrigerated Container' }, { name: '24\' Specialized Container' }, { name: '30\' Standard Container' }, { name: '30\' Specialized Container' }, { name: '30\' High Cube Container' }, { name: '50\' Standard Container' }, { name: '53\' Standard Container' }, { name: '53\' Specialized Container' }, { name: '53\' High Cube Container' }];

var OWNER_TYPES = [{
    name: 'shipper',
    value: 'Shipper’s Owned'
}, {
    name: 'carrier',
    value: 'Carrier\'s Owned'
}, {
    name: 'liner',
    value: 'Liner Owned'
}, {
    name: 'leased',
    value: 'Leased'
}];

var NOT_RESET_FIELDS = ['unitsWeight', 'unitsVolume', 'temperatureMin', 'temperatureMax', 'moistureMin', 'moistureMax', 'numberOfHeadsMin', 'numberOfHeadsMax', 'weightPerHead', 'ventilation', 'bundlesQuantity', 'unitsQuantity', 'unitVolume', 'unitWeight'];

/**
 * @param {any} from
 * @param {string} valuePath
 * @param {boolean} [disabled]
 * @param {any} [toDefault] 
 */
var displayValue = function displayValue(from, valuePath) {
    var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var toDefault = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    if (disabled) {
        return toDefault;
    }
    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(from, valuePath, toDefault);
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RadioElement, 'RadioElement', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(getDefaultCargoRequestValue, 'getDefaultCargoRequestValue', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(TRANSPORTATION_ALL, 'TRANSPORTATION_ALL', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(CATEGORIES_ALL, 'CATEGORIES_ALL', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(getPackingTransportation, 'getPackingTransportation', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(getPackingForBreakBulk, 'getPackingForBreakBulk', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(CONTAINER_TYPES, 'CONTAINER_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(OWNER_TYPES, 'OWNER_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(NOT_RESET_FIELDS, 'NOT_RESET_FIELDS', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    reactHotLoader.register(displayValue, 'displayValue', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/common.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createComponent;

var _react = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates a component class that renders the given Material UI component
 *
 * @param MaterialUIComponent The material ui component to render
 * @param mapProps A mapping of props provided by redux-form to the props the Material UI
 * component needs
 */
function createComponent(MaterialUIComponent, mapProps) {
  var InputComponent = function (_Component) {
    _inherits(InputComponent, _Component);

    function InputComponent() {
      _classCallCheck(this, InputComponent);

      return _possibleConstructorReturn(this, (InputComponent.__proto__ || Object.getPrototypeOf(InputComponent)).apply(this, arguments));
    }

    _createClass(InputComponent, [{
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.refs.component;
      }
    }, {
      key: 'render',
      value: function render() {
        return (0, _react.createElement)(MaterialUIComponent, _extends({}, mapProps(this.props), {
          ref: 'component'
        }));
      }
    }]);

    return InputComponent;
  }(_react.Component);

  InputComponent.displayName = 'ReduxFormMaterialUI' + MaterialUIComponent.name;
  return InputComponent;
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var color = __webpack_require__(958);
var helpers = __webpack_require__(45);

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = color(origin);
				if (c0.valid) {
					c1 = color(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	}
});

Element.extend = helpers.inherits;

module.exports = Element;


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VesselDwtTypesContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PredefinedIndexesContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChangeFieldsContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RemoveRowContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddUpdateContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ViasContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HandleUpdateErrorsContext; });
/* unused harmony export ErrorsContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TcIndexTable__ = __webpack_require__(3496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Filters__ = __webpack_require__(3511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_tc_indexes__ = __webpack_require__(3513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_query__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Misc__ = __webpack_require__(3514);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





















var VesselDwtTypesContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var PredefinedIndexesContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var ChangeFieldsContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var RemoveRowContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var AddUpdateContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({});
var ViasContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var HandleUpdateErrorsContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var ErrorsContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext([]);

var queryClient = new __WEBPACK_IMPORTED_MODULE_15_react_query__["QueryClient"]();
var getDefaultFilters = function getDefaultFilters() {
    return { confirmed: true };
};

function TcIndexPage(_ref) {
    var _this = this;

    var tcHireIdeas = _ref.tcHireIdeas,
        total = _ref.total,
        getTcHireIdeas = _ref.getTcHireIdeas,
        isLoaded = _ref.isLoaded,
        addNotification = _ref.addNotification;

    var rowsPerPage = [25, 50, 100];

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        rows = _useState2[0],
        setRows = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        rowsChanged = _useState4[0],
        setRowsChanged = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState6 = _slicedToArray(_useState5, 2),
        page = _useState6[0],
        setPage = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(25),
        _useState8 = _slicedToArray(_useState7, 2),
        numberOfRows = _useState8[0],
        setNumberOfRows = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState10 = _slicedToArray(_useState9, 2),
        vesselDwtTypes = _useState10[0],
        setVesselDwtTypes = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState12 = _slicedToArray(_useState11, 2),
        predefinedIndexes = _useState12[0],
        setPredefinedIndexes = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState14 = _slicedToArray(_useState13, 2),
        vias = _useState14[0],
        setVias = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState16 = _slicedToArray(_useState15, 2),
        errors = _useState16[0],
        setErrors = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(getDefaultFilters()),
        _useState18 = _slicedToArray(_useState17, 2),
        filters = _useState18[0],
        setFilters = _useState18[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setRows(tcHireIdeas);
        setErrors(tcHireIdeas.map(function (r) {
            return getDefaultError(r);
        }));
    }, [tcHireIdeas]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].getVesselDwtTypes().then(function (res) {
            setVesselDwtTypes(res.data);
        });

        __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].getPredefinedIndexes().then(function (res) {
            setPredefinedIndexes(res.data);
        });
        __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].getVias().then(function (res) {
            setVias(res.data);
        });
    }, []);

    var handleUpdatePagination = function handleUpdatePagination(_ref2) {
        var p = _ref2.page,
            n = _ref2.numberOfRows;

        setPage(p);
        setNumberOfRows(n);
        setRowsChanged([]);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setTimeout(function () {
            getTcHireIdeas(_extends({
                page: page,
                limit: numberOfRows
            }, filters));
        }, 200); // tiny delay, for the state to be updated before data fetch (only for visual)
    }, [filters, page, numberOfRows]);

    var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
        total: total,
        rowsPerPage: rowsPerPage,
        page: page,
        numberOfRows: numberOfRows,
        updateRows: handleUpdatePagination
    });

    var changeFieldsMultiple = function changeFieldsMultiple(changes) {
        var newRows = __WEBPACK_IMPORTED_MODULE_5_immer__["b" /* produce */](rows, function (_rows) {
            changes.forEach(function (change) {
                var index = change.index,
                    field = change.field,
                    value = change.value;

                __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.set(_rows[index], field, value);
            });
        });

        var newChanged = __WEBPACK_IMPORTED_MODULE_5_immer__["b" /* produce */](rowsChanged, function (_rowsChanged) {
            changes.forEach(function (change) {
                var index = change.index;

                var alreadyInChanged = _rowsChanged.findIndex(function (rC) {
                    return rC._id === newRows[index]._id;
                });

                if (alreadyInChanged >= 0) {
                    _rowsChanged.splice(alreadyInChanged, 1);
                }

                _rowsChanged.push(newRows[index]);
            });
        });

        setRows(newRows);
        setRowsChanged(newChanged);
    };

    var removeRow = function removeRow(rowId) {
        var newRows = __WEBPACK_IMPORTED_MODULE_5_immer__["b" /* produce */](rows, function (_rows) {
            _rows.splice(rowId, 1);
        });

        var newErrors = __WEBPACK_IMPORTED_MODULE_5_immer__["b" /* produce */](errors, function (_errors) {
            _errors.splice(rowId, 1);
        });

        setRows(newRows);
        setErrors(newErrors);
    };

    var changeFilters = function changeFilters(value) {
        setFilters(_extends({}, filters, { page: 1 }, value));
    };

    var clearFilters = function clearFilters() {
        setFilters(getDefaultFilters());
        setPage(1);
    };

    var addRow = function addRow() {
        var defaultHireIdea = getDefaultHireIdea();
        setRows([defaultHireIdea].concat(_toConsumableArray(rows)));
        setRowsChanged([].concat(_toConsumableArray(rowsChanged), [defaultHireIdea]));
        setErrors([getDefaultError({ _id: defaultHireIdea.unique_id }, { isNew: true })].concat(_toConsumableArray(errors)));
    };

    var updateRows = function updateRows() {
        if (!rowsChanged.length) return;

        if (errors.find(function (e) {
            return Object.values(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.omit(e, ['_id'])).find(function (_e) {
                return _e;
            });
        })) {
            addNotification(__WEBPACK_IMPORTED_MODULE_14__common__["a" /* notifications */].error('Please fill in all required fields.'));
            return;
        }

        var toUpdate = rowsChanged.map(function (change) {
            var changeForSave = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(change);

            if (!changeForSave.vesselId) delete changeForSave.vesselId;
            return _extends({}, changeForSave, {
                regionFrom: changeForSave.regionFrom._id,
                regionTo: changeForSave.regionTo._id,
                placeFrom: changeForSave.placeFrom ? changeForSave.placeFrom._id : undefined,
                placeTo: changeForSave.placeTo ? changeForSave.placeTo._id : undefined,
                via: changeForSave.via ? changeForSave.via._id : undefined,
                vesselDwtGroup: changeForSave.vesselDwtGroup._id
            });
        });

        __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].updateHireIdea({ update: toUpdate }).then(function (res) {
            if (!res.errors || !res.errors.length) {
                addNotification(__WEBPACK_IMPORTED_MODULE_14__common__["a" /* notifications */].success('Added successfully.'));
                getTcHireIdeas(_extends({ page: page, limit: numberOfRows }, filters));
                setRowsChanged([]);
            } else {
                addNotification(__WEBPACK_IMPORTED_MODULE_14__common__["a" /* notifications */].error(res.errors[0].message));
            }
        });
    };

    var handleUpdateErrors = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index, field, value) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (errors.length) {
                                setErrors(function (prev) {
                                    var newErrors = __WEBPACK_IMPORTED_MODULE_5_immer__["b" /* produce */](prev, function (_errors) {
                                        if (rows[index].typeByPurpose) {
                                            __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.set(_errors[index], 'typeGeneral', false);
                                        }
                                        _errors[index][field] = value;
                                    });
                                    return newErrors;
                                });
                            }

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function handleUpdateErrors(_x, _x2, _x3) {
            return _ref3.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: { display: 'flex', justifyContent: 'flex-end' } },
                renderPagination,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_15_react_query__["QueryClientProvider"],
                    { client: queryClient },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Misc__["a" /* default */], { filters: filters })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                AddUpdateContext.Provider,
                { value: { addRow: addRow, updateRows: updateRows } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    VesselDwtTypesContext.Provider,
                    { value: vesselDwtTypes },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Filters__["a" /* default */], {
                        filters: filters,
                        changeFilters: changeFilters,
                        clearFilters: clearFilters
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["d" /* CircularProgress */], {
            className: !isLoaded ? '' : 'hidden',
            style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].circularProgress
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: isLoaded ? '' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-body' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    ChangeFieldsContext.Provider,
                    { value: changeFieldsMultiple },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        RemoveRowContext.Provider,
                        { value: removeRow },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            VesselDwtTypesContext.Provider,
                            { value: vesselDwtTypes },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                PredefinedIndexesContext.Provider,
                                { value: predefinedIndexes },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    HandleUpdateErrorsContext.Provider,
                                    { value: handleUpdateErrors },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        ViasContext.Provider,
                                        { value: vias },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TcIndexTable__["a" /* default */], {
                                            rows: rows,
                                            errors: errors
                                        })
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
}

function getDefaultHireIdea() {
    var unique_id = Object(__WEBPACK_IMPORTED_MODULE_4_uuid__["a" /* v4 */])();

    function generateEndAt() {
        var date = new Date();

        var endDate = new Date(date.toISOString().slice(0, 10) + 'T23:59:59.000Z');

        var distance = 7 - new Date(date.toISOString().slice(0, 10) + 'T00:00:00.000Z').getDay();

        endDate.setDate(endDate.getDate() + distance);

        return endDate;
    }

    return {
        key: unique_id,
        unique_id: unique_id,
        can: generateEndAt(),
        clean: false,
        confirmed: true,
        rejected: false,
        lay: new Date(),
        roundTrip: false,
        vessel: {},
        vesselDwtGroup: {}
    };
}

function getDefaultError(r) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$isNew = _ref4.isNew,
        isNew = _ref4$isNew === undefined ? false : _ref4$isNew;

    var value = !!isNew;
    return {
        _id: r._id || r.unique_id,
        tcIndex: value,
        layCan: false,
        typeGeneral: value,
        vesselDwtGroup: value,
        regionFrom: value,
        regionTo: value
    };
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLoaded: state.tcIndexes.isLoaded,
        tcHireIdeas: state.tcIndexes.items,
        total: state.tcIndexes.pageInfo ? state.tcIndexes.pageInfo.count : 0
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getTcHireIdeas: __WEBPACK_IMPORTED_MODULE_11_actions_tc_indexes__["a" /* getTcHireIdeas */],
        addNotification: __WEBPACK_IMPORTED_MODULE_12_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(TcIndexPage);

/* harmony default export */ __webpack_exports__["h"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselDwtTypesContext, 'VesselDwtTypesContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(PredefinedIndexesContext, 'PredefinedIndexesContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(ChangeFieldsContext, 'ChangeFieldsContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(RemoveRowContext, 'RemoveRowContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(AddUpdateContext, 'AddUpdateContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(ViasContext, 'ViasContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(HandleUpdateErrorsContext, 'HandleUpdateErrorsContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(ErrorsContext, 'ErrorsContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(queryClient, 'queryClient', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(getDefaultFilters, 'getDefaultFilters', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(TcIndexPage, 'TcIndexPage', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(getDefaultHireIdea, 'getDefaultHireIdea', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(getDefaultError, 'getDefaultError', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexPage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(65)) {
  var LIBRARY = __webpack_require__(148);
  var global = __webpack_require__(42);
  var fails = __webpack_require__(47);
  var $export = __webpack_require__(12);
  var $typed = __webpack_require__(304);
  var $buffer = __webpack_require__(427);
  var ctx = __webpack_require__(108);
  var anInstance = __webpack_require__(177);
  var propertyDesc = __webpack_require__(170);
  var hide = __webpack_require__(86);
  var redefineAll = __webpack_require__(179);
  var toInteger = __webpack_require__(110);
  var toLength = __webpack_require__(60);
  var toIndex = __webpack_require__(611);
  var toAbsoluteIndex = __webpack_require__(173);
  var toPrimitive = __webpack_require__(118);
  var has = __webpack_require__(92);
  var classof = __webpack_require__(208);
  var isObject = __webpack_require__(48);
  var toObject = __webpack_require__(68);
  var isArrayIter = __webpack_require__(416);
  var create = __webpack_require__(174);
  var getPrototypeOf = __webpack_require__(95);
  var gOPN = __webpack_require__(175).f;
  var getIterFn = __webpack_require__(418);
  var uid = __webpack_require__(171);
  var wks = __webpack_require__(59);
  var createArrayMethod = __webpack_require__(121);
  var createArrayIncludes = __webpack_require__(294);
  var speciesConstructor = __webpack_require__(247);
  var ArrayIterators = __webpack_require__(421);
  var Iterators = __webpack_require__(210);
  var $iterDetect = __webpack_require__(299);
  var setSpecies = __webpack_require__(176);
  var arrayFill = __webpack_require__(420);
  var arrayCopyWithin = __webpack_require__(600);
  var $DP = __webpack_require__(66);
  var $GOPD = __webpack_require__(94);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(606);
var $export = __webpack_require__(12);
var shared = __webpack_require__(293)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(609))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(264),
    overRest = __webpack_require__(1675),
    setToString = __webpack_require__(728);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(1743));
var _createClass = _interopDefault(__webpack_require__(1744));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(1745));
var _getPrototypeOf = _interopDefault(__webpack_require__(1747));
var _inherits = _interopDefault(__webpack_require__(1748));
var _typeof = _interopDefault(__webpack_require__(744));
var _objectWithoutProperties = _interopDefault(__webpack_require__(1750));
var _extends = _interopDefault(__webpack_require__(1752));
var React = _interopDefault(__webpack_require__(1));
var PropTypes = _interopDefault(__webpack_require__(5));
var warning = _interopDefault(__webpack_require__(56));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1762);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253)))

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["f"] = getVessels;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteNameSuggestion;
/* harmony export (immutable) */ __webpack_exports__["g"] = renameVessel;
/* harmony export (immutable) */ __webpack_exports__["c"] = confirmVessel;
/* unused harmony export getVessel */
/* harmony export (immutable) */ __webpack_exports__["i"] = updateVessel;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteVessel;
/* harmony export (immutable) */ __webpack_exports__["a"] = addVessel;
/* harmony export (immutable) */ __webpack_exports__["h"] = saveVessel;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearVessel;
/* harmony export (immutable) */ __webpack_exports__["j"] = updateVesselImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getVessels(pagination) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_58" /* GET_VESSELS */].REQUEST,
        pagination: pagination
    };
}

function deleteNameSuggestion(_ref) {
    var vessel = _ref.vessel,
        refreshVessel = _ref.refreshVessel,
        suggestedName = _ref.suggestedName;

    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["U" /* DELETE_NAME_SUGGESTION */].REQUEST,
        vessel: vessel,
        refreshVessel: refreshVessel,
        suggestedName: suggestedName
    };
}

function renameVessel(vessel, refreshVessel) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_90" /* RENAME_VESSEL */].REQUEST,
        vessel: vessel,
        refreshVessel: refreshVessel
    };
}

function confirmVessel(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["y" /* CONFIRM_VESSEL */].REQUEST,
        id: id
    };
}

function getVessel(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_57" /* GET_VESSEL */].REQUEST,
        id: id
    };
}

function updateVessel(vessel) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_141" /* UPDATE_VESSEL */].REQUEST,
        vessel: vessel
    };
}

function deleteVessel(vessel) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Z" /* DELETE_VESSEL */].REQUEST,
        vessel: vessel
    };
}

function addVessel(vessel) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["h" /* ADD_VESSEL */].REQUEST,
        vessel: vessel
    };
}

function saveVessel(vessel) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_102" /* SAVE_VESSEL */],
        vessel: vessel
    };
}

function clearVessel() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["w" /* CLEAR_VESSEL */]
    };
}

function updateVesselImage(vesselId, images) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_142" /* UPDATE_VESSEL_IMAGE */].REQUEST,
        vesselId: vesselId,
        images: images
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVessels, 'getVessels', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(deleteNameSuggestion, 'deleteNameSuggestion', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(renameVessel, 'renameVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(confirmVessel, 'confirmVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(getVessel, 'getVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(updateVessel, 'updateVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(deleteVessel, 'deleteVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(addVessel, 'addVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(saveVessel, 'saveVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(clearVessel, 'clearVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    reactHotLoader.register(updateVesselImage, 'updateVesselImage', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/vessels.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(278);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__core__, "QueryClient")) __webpack_require__.d(__webpack_exports__, "QueryClient", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["QueryClient"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__core__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, "QueryClientProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["QueryClientProvider"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__core__, "useMutation")) __webpack_require__.d(__webpack_exports__, "useMutation", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["useMutation"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__core__, "useQuery")) __webpack_require__.d(__webpack_exports__, "useQuery", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["useQuery"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__core__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, "useQueryClient", function() { return __WEBPACK_IMPORTED_MODULE_0__core__["useQueryClient"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react__ = __webpack_require__(1907);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__react__, "QueryClient")) __webpack_require__.d(__webpack_exports__, "QueryClient", function() { return __WEBPACK_IMPORTED_MODULE_1__react__["QueryClient"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__react__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, "QueryClientProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__react__["QueryClientProvider"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__react__, "useMutation")) __webpack_require__.d(__webpack_exports__, "useMutation", function() { return __WEBPACK_IMPORTED_MODULE_1__react__["useMutation"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__react__, "useQuery")) __webpack_require__.d(__webpack_exports__, "useQuery", function() { return __WEBPACK_IMPORTED_MODULE_1__react__["useQuery"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__react__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, "useQueryClient", function() { return __WEBPACK_IMPORTED_MODULE_1__react__["useQueryClient"]; });



/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useFormContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormContextProvider; });
/* harmony export (immutable) */ __webpack_exports__["b"] = useForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var Context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();

var useFormContext = function useFormContext() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(Context);
};

var FormContextProvider = Context.Provider;

function serializeValues(config, values) {
    Object.entries(config).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            c = _ref2[1];

        if (c.serialize) {
            values[k] = c.serialize(values[k]);
        }
    });
    return values;
}

function useForm(_ref3) {
    var config = _ref3.config,
        initialState = _ref3.initialState,
        captureSaveHandler = _ref3.captureSaveHandler,
        onChange = _ref3.onChange;

    var saveHandlersRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        values: initialState,
        errors: {}
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        captureSaveHandler(function (values) {
            var saveHandlers = saveHandlersRef.current;
            saveHandlers.forEach(function (handler) {
                return handler(values);
            });
            serializeValues(config, values);
        });
    }, []);

    var onChangeKeyValue = function onChangeKeyValue(key, value) {
        var conf = config[key];
        var parsed = value;

        if (conf) {
            if (value !== null) {
                if (conf.type === 'number') {
                    parsed = parseFloat(value);
                }
            }

            if (conf.onChange) {
                // eslint-disable-next-line no-use-before-define
                conf.onChange(parsed, form);
            }
        }

        setState(function (st) {
            var _extends3;

            var validationResult = conf && conf.validate ? conf.validate(parsed, st.values) : null;

            var _ref4 = validationResult && (typeof validationResult === 'undefined' ? 'undefined' : _typeof(validationResult)) === 'object' ? validationResult : {},
                clearErrorFor = _ref4.clearErrorFor;

            var newError = typeof validationResult === 'string' ? validationResult : undefined;

            var newValues = _extends({}, st.values, _defineProperty({}, key, parsed));

            if (onChange) {
                onChange(serializeValues(config, _extends({}, newValues)));
            }

            return _extends({}, st, {
                values: newValues,
                errors: _extends({}, st.errors, (_extends3 = {}, _defineProperty(_extends3, clearErrorFor || key, undefined), _defineProperty(_extends3, key, newError), _extends3))
            });
        });
    };

    var handleChange = function handleChange(e) {
        if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object' && 'field' in e && 'value' in e) {
            onChangeKeyValue(e.field, e.value);
        } else if (Array.isArray(e)) {
            e.forEach(function (change) {
                if (change) {
                    onChangeKeyValue(change.field, change.value);
                }
            });
        } else {
            var value = e.target.value;

            onChangeKeyValue(e.target.name, value === '' ? null : value);
        }
    };

    var addSaveHandler = function addSaveHandler(saveHandler) {
        saveHandlersRef.current.push(saveHandler);
    };

    var form = {
        config: config,
        values: state.values,
        errors: state.errors,
        setState: setState,
        onChange: handleChange,
        addSaveHandler: addSaveHandler
    };

    return form;
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Context, 'Context', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/form.jsx');
    reactHotLoader.register(useFormContext, 'useFormContext', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/form.jsx');
    reactHotLoader.register(FormContextProvider, 'FormContextProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/form.jsx');
    reactHotLoader.register(serializeValues, 'serializeValues', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/form.jsx');
    reactHotLoader.register(useForm, 'useForm', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/form.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(256),
    baseIteratee = __webpack_require__(882),
    baseMap = __webpack_require__(2079),
    isArray = __webpack_require__(67);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(2182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "accessibilityOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(907);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultOverscanIndicesGetter", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__["c"]; });









/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @namespace Chart
 */
var Chart = __webpack_require__(3324)();

Chart.helpers = __webpack_require__(45);

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
__webpack_require__(3328)(Chart);

Chart.Animation = __webpack_require__(961);
Chart.animationService = __webpack_require__(962);
Chart.defaults = __webpack_require__(58);
Chart.Element = __webpack_require__(131);
Chart.elements = __webpack_require__(168);
Chart.Interaction = __webpack_require__(963);
Chart.layouts = __webpack_require__(287);
Chart.platform = __webpack_require__(964);
Chart.plugins = __webpack_require__(965);
Chart.Scale = __webpack_require__(288);
Chart.scaleService = __webpack_require__(167);
Chart.Ticks = __webpack_require__(289);
Chart.Tooltip = __webpack_require__(966);

__webpack_require__(3338)(Chart);
__webpack_require__(3339)(Chart);

__webpack_require__(3340)(Chart);
__webpack_require__(3341)(Chart);
__webpack_require__(3342)(Chart);
__webpack_require__(3343)(Chart);
__webpack_require__(3344)(Chart);
__webpack_require__(3345)(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
__webpack_require__(3346)(Chart);
__webpack_require__(3347)(Chart);
__webpack_require__(3348)(Chart);
__webpack_require__(3349)(Chart);
__webpack_require__(3350)(Chart);
__webpack_require__(3351)(Chart);
__webpack_require__(3352)(Chart);

__webpack_require__(3353)(Chart);
__webpack_require__(3354)(Chart);
__webpack_require__(3355)(Chart);
__webpack_require__(3356)(Chart);
__webpack_require__(3357)(Chart);
__webpack_require__(3358)(Chart);
__webpack_require__(3359)(Chart);

// Loading built-in plugins
var plugins = __webpack_require__(3360);
for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		Chart.plugins.register(plugins[k]);
	}
}

Chart.platform.initialize();

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.pluginService = Chart.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
Chart.PluginBase = Chart.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
Chart.canvasHelpers = Chart.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
Chart.layoutService = Chart.layouts;


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function BasicSelector(_ref) {
    var value = _ref.value,
        _ref$dataList = _ref.dataList,
        dataList = _ref$dataList === undefined ? [] : _ref$dataList,
        onChange = _ref.onChange,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$iconStyle = _ref.iconStyle,
        iconStyle = _ref$iconStyle === undefined ? {} : _ref$iconStyle,
        _ref$labelStyle = _ref.labelStyle,
        labelStyle = _ref$labelStyle === undefined ? {} : _ref$labelStyle,
        _ref$underlineStyle = _ref.underlineStyle,
        underlineStyle = _ref$underlineStyle === undefined ? {} : _ref$underlineStyle,
        _ref$fields = _ref.fields,
        fields = _ref$fields === undefined ? [] : _ref$fields,
        _ref$floatingLabelTex = _ref.floatingLabelText,
        floatingLabelText = _ref$floatingLabelTex === undefined ? '' : _ref$floatingLabelTex,
        _ref$floatingLabelSty = _ref.floatingLabelStyle,
        floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
        _ref$hintText = _ref.hintText,
        hintText = _ref$hintText === undefined ? '' : _ref$hintText,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$customRender = _ref.customRender,
        customRender = _ref$customRender === undefined ? undefined : _ref$customRender,
        _ref$multiple = _ref.multiple,
        multiple = _ref$multiple === undefined ? false : _ref$multiple,
        _ref$selectionRendere = _ref.selectionRenderer,
        selectionRenderer = _ref$selectionRendere === undefined ? undefined : _ref$selectionRendere;

    var renderMenuItem = function renderMenuItem(item) {
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
            var values = [];
            fields.forEach(function (f) {
                return values.push(item[f]);
            });

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], {
                key: item._id,
                value: item._id,
                primaryText: values.join(' - ')
            });
        }
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], {
            key: item,
            value: item,
            primaryText: item
        });
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["s" /* SelectField */],
        {
            floatingLabelText: floatingLabelText,
            hintText: hintText,
            value: value,
            onChange: onChange,
            style: _extends({ width: '100%' }, style),
            iconStyle: _extends({}, iconStyle),
            underlineStyle: _extends({}, underlineStyle),
            labelStyle: _extends({ height: '50px' }, labelStyle),
            floatingLabelStyle: _extends({}, floatingLabelStyle),
            autoWidth: true,
            disabled: disabled,
            multiple: multiple,
            selectionRenderer: selectionRenderer
        },
        customRender || dataList.map(function (item) {
            return renderMenuItem(item);
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(BasicSelector);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BasicSelector, 'BasicSelector', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Basic/BasicSelector.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Basic/BasicSelector.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(171)('meta');
var isObject = __webpack_require__(48);
var has = __webpack_require__(92);
var setDesc = __webpack_require__(66).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(47)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(59)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(86)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(152);
var core = __webpack_require__(73);
var ctx = __webpack_require__(444);
var hide = __webpack_require__(216);
var has = __webpack_require__(182);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(183);
var IE8_DOM_DEFINE = __webpack_require__(642);
var toPrimitive = __webpack_require__(445);
var dP = Object.defineProperty;

exports.f = __webpack_require__(184) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values and color names.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["h"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["f"] = put;
/* unused harmony export all */
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["c"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["e"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["d"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["g"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationClose = function NavigationClose(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
NavigationClose = (0, _pure2.default)(NavigationClose);
NavigationClose.displayName = 'NavigationClose';
NavigationClose.muiName = 'SvgIcon';

exports.default = NavigationClose;

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = updateLetter;
/* unused harmony export watchUpdateLetter */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLetter;
/* unused harmony export watchGetLetter */
/* harmony export (immutable) */ __webpack_exports__["c"] = sendToDev;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveAsSpam;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cargoes_ordersNew__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vessels_orders__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vessels_size__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tc_orders__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vessels_sales__ = __webpack_require__(693);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(updateLetter),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateLetter),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getLetter),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetLetter),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(sendToDev),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(saveAsSpam);












/**
 *
 * @param letter
 * @param typeLetter
 * @param server
 */
function updateLetter(letter) {
    var typeLetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : letter.type;
    var server = arguments[2];
    var response;
    return regeneratorRuntime.wrap(function updateLetter$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    letter.type = typeLetter;

                    _context.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateLetter, letter, server);

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 34;
                        break;
                    }

                    if (response.data.eh === 'api') {
                        response.data.owner = letter.owner;
                    }

                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_130" /* UPDATE_LETTER */].SUCCESS,
                        data: response.data
                    });

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Letter ' + letter._id + ' was update',
                            level: 'success',
                            _id: letter._id,
                            autoDismiss: 2
                        }
                    });

                case 10:
                    if (!(letter.type === 'cargo')) {
                        _context.next = 20;
                        break;
                    }

                    if (!letter.fromCargoOrders) {
                        _context.next = 16;
                        break;
                    }

                    _context.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__cargoes_ordersNew__["a" /* createCargoOrders */], response);

                case 14:
                    _context.next = 18;
                    break;

                case 16:
                    _context.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_6__tc_orders__["a" /* createTcOrders */], response);

                case 18:
                    _context.next = 33;
                    break;

                case 20:
                    if (!(letter.type === 'vessel')) {
                        _context.next = 33;
                        break;
                    }

                    if (!letter.fromVesselSizes) {
                        _context.next = 26;
                        break;
                    }

                    _context.next = 24;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_5__vessels_size__["a" /* createVesselSizes */], response);

                case 24:
                    _context.next = 33;
                    break;

                case 26:
                    if (!letter.fromVesselSales) {
                        _context.next = 31;
                        break;
                    }

                    _context.next = 29;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_7__vessels_sales__["a" /* createVesselSales */], response);

                case 29:
                    _context.next = 33;
                    break;

                case 31:
                    _context.next = 33;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4__vessels_orders__["a" /* createVesselOrders */], response);

                case 33:
                    return _context.abrupt('return', response);

                case 34:
                    _context.next = 36;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_130" /* UPDATE_LETTER */].FAILURE,
                        errors: response.errors
                    });

                case 36:
                    _context.next = 38;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Letter ' + letter._id + ' something get wrong',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 999
                        }
                    });

                case 38:
                    console.log(letter);

                    return _context.abrupt('return', response);

                case 40:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchUpdateLetter() {
    var _ref, letter, typeLetter;

    return regeneratorRuntime.wrap(function watchUpdateLetter$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 10;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_130" /* UPDATE_LETTER */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    letter = _ref.letter;
                    typeLetter = _ref.typeLetter;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateLetter, letter, typeLetter);

                case 8:
                    _context2.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get letter by id
 * */
function getLetter(id) {
    var response;
    return regeneratorRuntime.wrap(function getLetter$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getLetter, id);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_31" /* GET_LETTER */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Letter ' + id + ' was get',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context3.abrupt('return', response);

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_31" /* GET_LETTER */].FAILURE,
                        errors: response.errors
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Letter ' + id + ' something get wrong',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 99999
                        }
                    });

                case 13:
                    return _context3.abrupt('return', response);

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetLetter() {
    var _ref2, id;

    return regeneratorRuntime.wrap(function watchGetLetter$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 16;
                        break;
                    }

                    _context4.prev = 1;
                    _context4.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_31" /* GET_LETTER */].REQUEST);

                case 4:
                    _ref2 = _context4.sent;
                    id = _ref2.id;
                    _context4.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getLetter, id);

                case 8:
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](1);
                    _context4.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: _context4.t0.toString(),
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 99999
                        }
                    });

                case 14:
                    _context4.next = 0;
                    break;

                case 16:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[1, 10]]);
}

function sendToDev(data) {
    var response;
    return regeneratorRuntime.wrap(function sendToDev$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].sendToDev, data);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 7;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'letter sent to dev',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 6:
                    return _context5.abrupt('return', response);

                case 7:
                    _context5.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something wrong ',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 99999
                        }
                    });

                case 9:
                    return _context5.abrupt('return', response);

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function saveAsSpam(data) {
    var response;
    return regeneratorRuntime.wrap(function saveAsSpam$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveAsSpam, data);

                case 2:
                    response = _context6.sent;

                    if (!(response.status === 200)) {
                        _context6.next = 7;
                        break;
                    }

                    _context6.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Letter saved as spam',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 25
                        }
                    });

                case 6:
                    return _context6.abrupt('return', response);

                case 7:
                    _context6.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 50
                        }
                    });

                case 9:
                    return _context6.abrupt('return', response);

                case 10:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

var _default = [watchGetLetter, watchUpdateLetter];
/* unused harmony default export */ var _unused_webpack_default_export = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(updateLetter, 'updateLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/lettersNew.js');
    reactHotLoader.register(watchUpdateLetter, 'watchUpdateLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/lettersNew.js');
    reactHotLoader.register(getLetter, 'getLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/lettersNew.js');
    reactHotLoader.register(watchGetLetter, 'watchGetLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/lettersNew.js');
    reactHotLoader.register(sendToDev, 'sendToDev', '/opt/atlassian/pipelines/agent/build/client/app/sagas/lettersNew.js');
    reactHotLoader.register(saveAsSpam, 'saveAsSpam', '/opt/atlassian/pipelines/agent/build/client/app/sagas/lettersNew.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/lettersNew.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, __webpack_provided_window_dot_React, __webpack_provided_window_dot_ReactDOM) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.ReactTooltip=f()}})(function(){var define,module,exports;return function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r}()({1:[function(require,module,exports){(function(){"use strict";var hasOwn={}.hasOwnProperty;function classNames(){var classes=[];for(var i=0;i<arguments.length;i++){var arg=arguments[i];if(!arg)continue;var argType=typeof arg;if(argType==="string"||argType==="number"){classes.push(arg)}else if(Array.isArray(arg)){classes.push(classNames.apply(null,arg))}else if(argType==="object"){for(var key in arg){if(hasOwn.call(arg,key)&&arg[key]){classes.push(key)}}}}return classes.join(" ")}if(typeof module!=="undefined"&&module.exports){module.exports=classNames}else if(typeof define==="function"&&typeof define.amd==="object"&&define.amd){define("classnames",[],function(){return classNames})}else{window.classNames=classNames}})()},{}],2:[function(require,module,exports){"use strict";function makeEmptyFunction(arg){return function(){return arg}}var emptyFunction=function emptyFunction(){};emptyFunction.thatReturns=makeEmptyFunction;emptyFunction.thatReturnsFalse=makeEmptyFunction(false);emptyFunction.thatReturnsTrue=makeEmptyFunction(true);emptyFunction.thatReturnsNull=makeEmptyFunction(null);emptyFunction.thatReturnsThis=function(){return this};emptyFunction.thatReturnsArgument=function(arg){return arg};module.exports=emptyFunction},{}],3:[function(require,module,exports){(function(process){"use strict";var validateFormat=function validateFormat(format){};if(process.env.NODE_ENV!=="production"){validateFormat=function validateFormat(format){if(format===undefined){throw new Error("invariant requires an error message argument")}}}function invariant(condition,format,a,b,c,d,e,f){validateFormat(format);if(!condition){var error;if(format===undefined){error=new Error("Minified exception occurred; use the non-minified dev environment "+"for the full error message and additional helpful warnings.")}else{var args=[a,b,c,d,e,f];var argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++]}));error.name="Invariant Violation"}error.framesToPop=1;throw error}}module.exports=invariant}).call(this,require("_process"))},{_process:6}],4:[function(require,module,exports){(function(process){"use strict";var emptyFunction=require("./emptyFunction");var warning=emptyFunction;if(process.env.NODE_ENV!=="production"){var printWarning=function printWarning(format){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key]}var argIndex=0;var message="Warning: "+format.replace(/%s/g,function(){return args[argIndex++]});if(typeof console!=="undefined"){console.error(message)}try{throw new Error(message)}catch(x){}};warning=function warning(condition,format){if(format===undefined){throw new Error("`warning(condition, format, ...args)` requires a warning "+"message argument")}if(format.indexOf("Failed Composite propType: ")===0){return}if(!condition){for(var _len2=arguments.length,args=Array(_len2>2?_len2-2:0),_key2=2;_key2<_len2;_key2++){args[_key2-2]=arguments[_key2]}printWarning.apply(undefined,[format].concat(args))}}}module.exports=warning}).call(this,require("_process"))},{"./emptyFunction":2,_process:6}],5:[function(require,module,exports){"use strict";var getOwnPropertySymbols=Object.getOwnPropertySymbols;var hasOwnProperty=Object.prototype.hasOwnProperty;var propIsEnumerable=Object.prototype.propertyIsEnumerable;function toObject(val){if(val===null||val===undefined){throw new TypeError("Object.assign cannot be called with null or undefined")}return Object(val)}function shouldUseNative(){try{if(!Object.assign){return false}var test1=new String("abc");test1[5]="de";if(Object.getOwnPropertyNames(test1)[0]==="5"){return false}var test2={};for(var i=0;i<10;i++){test2["_"+String.fromCharCode(i)]=i}var order2=Object.getOwnPropertyNames(test2).map(function(n){return test2[n]});if(order2.join("")!=="0123456789"){return false}var test3={};"abcdefghijklmnopqrst".split("").forEach(function(letter){test3[letter]=letter});if(Object.keys(Object.assign({},test3)).join("")!=="abcdefghijklmnopqrst"){return false}return true}catch(err){return false}}module.exports=shouldUseNative()?Object.assign:function(target,source){var from;var to=toObject(target);var symbols;for(var s=1;s<arguments.length;s++){from=Object(arguments[s]);for(var key in from){if(hasOwnProperty.call(from,key)){to[key]=from[key]}}if(getOwnPropertySymbols){symbols=getOwnPropertySymbols(from);for(var i=0;i<symbols.length;i++){if(propIsEnumerable.call(from,symbols[i])){to[symbols[i]]=from[symbols[i]]}}}}return to}},{}],6:[function(require,module,exports){var process=module.exports={};var cachedSetTimeout;var cachedClearTimeout;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){cachedSetTimeout=setTimeout}else{cachedSetTimeout=defaultSetTimout}}catch(e){cachedSetTimeout=defaultSetTimout}try{if(typeof clearTimeout==="function"){cachedClearTimeout=clearTimeout}else{cachedClearTimeout=defaultClearTimeout}}catch(e){cachedClearTimeout=defaultClearTimeout}})();function runTimeout(fun){if(cachedSetTimeout===setTimeout){return setTimeout(fun,0)}if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout){cachedSetTimeout=setTimeout;return setTimeout(fun,0)}try{return cachedSetTimeout(fun,0)}catch(e){try{return cachedSetTimeout.call(null,fun,0)}catch(e){return cachedSetTimeout.call(this,fun,0)}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout){return clearTimeout(marker)}if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout){cachedClearTimeout=clearTimeout;return clearTimeout(marker)}try{return cachedClearTimeout(marker)}catch(e){try{return cachedClearTimeout.call(null,marker)}catch(e){return cachedClearTimeout.call(this,marker)}}}var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){if(!draining||!currentQueue){return}draining=false;if(currentQueue.length){queue=currentQueue.concat(queue)}else{queueIndex=-1}if(queue.length){drainQueue()}}function drainQueue(){if(draining){return}var timeout=runTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run()}}queueIndex=-1;len=queue.length}currentQueue=null;draining=false;runClearTimeout(timeout)}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i]}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){runTimeout(drainQueue)}};function Item(fun,array){this.fun=fun;this.array=array}Item.prototype.run=function(){this.fun.apply(null,this.array)};process.title="browser";process.browser=true;process.env={};process.argv=[];process.version="";process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.prependListener=noop;process.prependOnceListener=noop;process.listeners=function(name){return[]};process.binding=function(name){throw new Error("process.binding is not supported")};process.cwd=function(){return"/"};process.chdir=function(dir){throw new Error("process.chdir is not supported")};process.umask=function(){return 0}},{}],7:[function(require,module,exports){(function(process){"use strict";if(process.env.NODE_ENV!=="production"){var invariant=require("fbjs/lib/invariant");var warning=require("fbjs/lib/warning");var ReactPropTypesSecret=require("./lib/ReactPropTypesSecret");var loggedTypeFailures={}}function checkPropTypes(typeSpecs,values,location,componentName,getStack){if(process.env.NODE_ENV!=="production"){for(var typeSpecName in typeSpecs){if(typeSpecs.hasOwnProperty(typeSpecName)){var error;try{invariant(typeof typeSpecs[typeSpecName]==="function","%s: %s type `%s` is invalid; it must be a function, usually from "+"the `prop-types` package, but received `%s`.",componentName||"React class",location,typeSpecName,typeof typeSpecs[typeSpecName]);error=typeSpecs[typeSpecName](values,typeSpecName,componentName,location,null,ReactPropTypesSecret)}catch(ex){error=ex}warning(!error||error instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker "+"function must return `null` or an `Error` but returned a %s. "+"You may have forgotten to pass an argument to the type checker "+"creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and "+"shape all require an argument).",componentName||"React class",location,typeSpecName,typeof error);if(error instanceof Error&&!(error.message in loggedTypeFailures)){loggedTypeFailures[error.message]=true;var stack=getStack?getStack():"";warning(false,"Failed %s type: %s%s",location,error.message,stack!=null?stack:"")}}}}}module.exports=checkPropTypes}).call(this,require("_process"))},{"./lib/ReactPropTypesSecret":11,_process:6,"fbjs/lib/invariant":3,"fbjs/lib/warning":4}],8:[function(require,module,exports){"use strict";var emptyFunction=require("fbjs/lib/emptyFunction");var invariant=require("fbjs/lib/invariant");var ReactPropTypesSecret=require("./lib/ReactPropTypesSecret");module.exports=function(){function shim(props,propName,componentName,location,propFullName,secret){if(secret===ReactPropTypesSecret){return}invariant(false,"Calling PropTypes validators directly is not supported by the `prop-types` package. "+"Use PropTypes.checkPropTypes() to call them. "+"Read more at http://fb.me/use-check-prop-types")}shim.isRequired=shim;function getShim(){return shim}var ReactPropTypes={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim};ReactPropTypes.checkPropTypes=emptyFunction;ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes}},{"./lib/ReactPropTypesSecret":11,"fbjs/lib/emptyFunction":2,"fbjs/lib/invariant":3}],9:[function(require,module,exports){(function(process){"use strict";var emptyFunction=require("fbjs/lib/emptyFunction");var invariant=require("fbjs/lib/invariant");var warning=require("fbjs/lib/warning");var assign=require("object-assign");var ReactPropTypesSecret=require("./lib/ReactPropTypesSecret");var checkPropTypes=require("./checkPropTypes");module.exports=function(isValidElement,throwOnDirectAccess){var ITERATOR_SYMBOL=typeof Symbol==="function"&&Symbol.iterator;var FAUX_ITERATOR_SYMBOL="@@iterator";function getIteratorFn(maybeIterable){var iteratorFn=maybeIterable&&(ITERATOR_SYMBOL&&maybeIterable[ITERATOR_SYMBOL]||maybeIterable[FAUX_ITERATOR_SYMBOL]);if(typeof iteratorFn==="function"){return iteratorFn}}var ANONYMOUS="<<anonymous>>";var ReactPropTypes={array:createPrimitiveTypeChecker("array"),bool:createPrimitiveTypeChecker("boolean"),func:createPrimitiveTypeChecker("function"),number:createPrimitiveTypeChecker("number"),object:createPrimitiveTypeChecker("object"),string:createPrimitiveTypeChecker("string"),symbol:createPrimitiveTypeChecker("symbol"),any:createAnyTypeChecker(),arrayOf:createArrayOfTypeChecker,element:createElementTypeChecker(),instanceOf:createInstanceTypeChecker,node:createNodeChecker(),objectOf:createObjectOfTypeChecker,oneOf:createEnumTypeChecker,oneOfType:createUnionTypeChecker,shape:createShapeTypeChecker,exact:createStrictShapeTypeChecker};function is(x,y){if(x===y){return x!==0||1/x===1/y}else{return x!==x&&y!==y}}function PropTypeError(message){this.message=message;this.stack=""}PropTypeError.prototype=Error.prototype;function createChainableTypeChecker(validate){if(process.env.NODE_ENV!=="production"){var manualPropTypeCallCache={};var manualPropTypeWarningCount=0}function checkType(isRequired,props,propName,componentName,location,propFullName,secret){componentName=componentName||ANONYMOUS;propFullName=propFullName||propName;if(secret!==ReactPropTypesSecret){if(throwOnDirectAccess){invariant(false,"Calling PropTypes validators directly is not supported by the `prop-types` package. "+"Use `PropTypes.checkPropTypes()` to call them. "+"Read more at http://fb.me/use-check-prop-types")}else if(process.env.NODE_ENV!=="production"&&typeof console!=="undefined"){var cacheKey=componentName+":"+propName;if(!manualPropTypeCallCache[cacheKey]&&manualPropTypeWarningCount<3){warning(false,"You are manually calling a React.PropTypes validation "+"function for the `%s` prop on `%s`. This is deprecated "+"and will throw in the standalone `prop-types` package. "+"You may be seeing this warning due to a third-party PropTypes "+"library. See https://fb.me/react-warning-dont-call-proptypes "+"for details.",propFullName,componentName);manualPropTypeCallCache[cacheKey]=true;manualPropTypeWarningCount++}}}if(props[propName]==null){if(isRequired){if(props[propName]===null){return new PropTypeError("The "+location+" `"+propFullName+"` is marked as required "+("in `"+componentName+"`, but its value is `null`."))}return new PropTypeError("The "+location+" `"+propFullName+"` is marked as required in "+("`"+componentName+"`, but its value is `undefined`."))}return null}else{return validate(props,propName,componentName,location,propFullName)}}var chainedCheckType=checkType.bind(null,false);chainedCheckType.isRequired=checkType.bind(null,true);return chainedCheckType}function createPrimitiveTypeChecker(expectedType){function validate(props,propName,componentName,location,propFullName,secret){var propValue=props[propName];var propType=getPropType(propValue);if(propType!==expectedType){var preciseType=getPreciseType(propValue);return new PropTypeError("Invalid "+location+" `"+propFullName+"` of type "+("`"+preciseType+"` supplied to `"+componentName+"`, expected ")+("`"+expectedType+"`."))}return null}return createChainableTypeChecker(validate)}function createAnyTypeChecker(){return createChainableTypeChecker(emptyFunction.thatReturnsNull)}function createArrayOfTypeChecker(typeChecker){function validate(props,propName,componentName,location,propFullName){if(typeof typeChecker!=="function"){return new PropTypeError("Property `"+propFullName+"` of component `"+componentName+"` has invalid PropType notation inside arrayOf.")}var propValue=props[propName];if(!Array.isArray(propValue)){var propType=getPropType(propValue);return new PropTypeError("Invalid "+location+" `"+propFullName+"` of type "+("`"+propType+"` supplied to `"+componentName+"`, expected an array."))}for(var i=0;i<propValue.length;i++){var error=typeChecker(propValue,i,componentName,location,propFullName+"["+i+"]",ReactPropTypesSecret);if(error instanceof Error){return error}}return null}return createChainableTypeChecker(validate)}function createElementTypeChecker(){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];if(!isValidElement(propValue)){var propType=getPropType(propValue);return new PropTypeError("Invalid "+location+" `"+propFullName+"` of type "+("`"+propType+"` supplied to `"+componentName+"`, expected a single ReactElement."))}return null}return createChainableTypeChecker(validate)}function createInstanceTypeChecker(expectedClass){function validate(props,propName,componentName,location,propFullName){if(!(props[propName]instanceof expectedClass)){var expectedClassName=expectedClass.name||ANONYMOUS;var actualClassName=getClassName(props[propName]);return new PropTypeError("Invalid "+location+" `"+propFullName+"` of type "+("`"+actualClassName+"` supplied to `"+componentName+"`, expected ")+("instance of `"+expectedClassName+"`."))}return null}return createChainableTypeChecker(validate)}function createEnumTypeChecker(expectedValues){if(!Array.isArray(expectedValues)){process.env.NODE_ENV!=="production"?warning(false,"Invalid argument supplied to oneOf, expected an instance of array."):void 0;return emptyFunction.thatReturnsNull}function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];for(var i=0;i<expectedValues.length;i++){if(is(propValue,expectedValues[i])){return null}}var valuesString=JSON.stringify(expectedValues);return new PropTypeError("Invalid "+location+" `"+propFullName+"` of value `"+propValue+"` "+("supplied to `"+componentName+"`, expected one of "+valuesString+"."))}return createChainableTypeChecker(validate)}function createObjectOfTypeChecker(typeChecker){function validate(props,propName,componentName,location,propFullName){if(typeof typeChecker!=="function"){return new PropTypeError("Property `"+propFullName+"` of component `"+componentName+"` has invalid PropType notation inside objectOf.")}var propValue=props[propName];var propType=getPropType(propValue);if(propType!=="object"){return new PropTypeError("Invalid "+location+" `"+propFullName+"` of type "+("`"+propType+"` supplied to `"+componentName+"`, expected an object."))}for(var key in propValue){if(propValue.hasOwnProperty(key)){var error=typeChecker(propValue,key,componentName,location,propFullName+"."+key,ReactPropTypesSecret);if(error instanceof Error){return error}}}return null}return createChainableTypeChecker(validate)}function createUnionTypeChecker(arrayOfTypeCheckers){if(!Array.isArray(arrayOfTypeCheckers)){process.env.NODE_ENV!=="production"?warning(false,"Invalid argument supplied to oneOfType, expected an instance of array."):void 0;return emptyFunction.thatReturnsNull}for(var i=0;i<arrayOfTypeCheckers.length;i++){var checker=arrayOfTypeCheckers[i];if(typeof checker!=="function"){warning(false,"Invalid argument supplied to oneOfType. Expected an array of check functions, but "+"received %s at index %s.",getPostfixForTypeWarning(checker),i);return emptyFunction.thatReturnsNull}}function validate(props,propName,componentName,location,propFullName){for(var i=0;i<arrayOfTypeCheckers.length;i++){var checker=arrayOfTypeCheckers[i];if(checker(props,propName,componentName,location,propFullName,ReactPropTypesSecret)==null){return null}}return new PropTypeError("Invalid "+location+" `"+propFullName+"` supplied to "+("`"+componentName+"`."))}return createChainableTypeChecker(validate)}function createNodeChecker(){function validate(props,propName,componentName,location,propFullName){if(!isNode(props[propName])){return new PropTypeError("Invalid "+location+" `"+propFullName+"` supplied to "+("`"+componentName+"`, expected a ReactNode."))}return null}return createChainableTypeChecker(validate)}function createShapeTypeChecker(shapeTypes){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];var propType=getPropType(propValue);if(propType!=="object"){return new PropTypeError("Invalid "+location+" `"+propFullName+"` of type `"+propType+"` "+("supplied to `"+componentName+"`, expected `object`."))}for(var key in shapeTypes){var checker=shapeTypes[key];if(!checker){continue}var error=checker(propValue,key,componentName,location,propFullName+"."+key,ReactPropTypesSecret);if(error){return error}}return null}return createChainableTypeChecker(validate)}function createStrictShapeTypeChecker(shapeTypes){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];var propType=getPropType(propValue);if(propType!=="object"){return new PropTypeError("Invalid "+location+" `"+propFullName+"` of type `"+propType+"` "+("supplied to `"+componentName+"`, expected `object`."))}var allKeys=assign({},props[propName],shapeTypes);for(var key in allKeys){var checker=shapeTypes[key];if(!checker){return new PropTypeError("Invalid "+location+" `"+propFullName+"` key `"+key+"` supplied to `"+componentName+"`."+"\nBad object: "+JSON.stringify(props[propName],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(shapeTypes),null,"  "))}var error=checker(propValue,key,componentName,location,propFullName+"."+key,ReactPropTypesSecret);if(error){return error}}return null}return createChainableTypeChecker(validate)}function isNode(propValue){switch(typeof propValue){case"number":case"string":case"undefined":return true;case"boolean":return!propValue;case"object":if(Array.isArray(propValue)){return propValue.every(isNode)}if(propValue===null||isValidElement(propValue)){return true}var iteratorFn=getIteratorFn(propValue);if(iteratorFn){var iterator=iteratorFn.call(propValue);var step;if(iteratorFn!==propValue.entries){while(!(step=iterator.next()).done){if(!isNode(step.value)){return false}}}else{while(!(step=iterator.next()).done){var entry=step.value;if(entry){if(!isNode(entry[1])){return false}}}}}else{return false}return true;default:return false}}function isSymbol(propType,propValue){if(propType==="symbol"){return true}if(propValue["@@toStringTag"]==="Symbol"){return true}if(typeof Symbol==="function"&&propValue instanceof Symbol){return true}return false}function getPropType(propValue){var propType=typeof propValue;if(Array.isArray(propValue)){return"array"}if(propValue instanceof RegExp){return"object"}if(isSymbol(propType,propValue)){return"symbol"}return propType}function getPreciseType(propValue){if(typeof propValue==="undefined"||propValue===null){return""+propValue}var propType=getPropType(propValue);if(propType==="object"){if(propValue instanceof Date){return"date"}else if(propValue instanceof RegExp){return"regexp"}}return propType}function getPostfixForTypeWarning(value){var type=getPreciseType(value);switch(type){case"array":case"object":return"an "+type;case"boolean":case"date":case"regexp":return"a "+type;default:return type}}function getClassName(propValue){if(!propValue.constructor||!propValue.constructor.name){return ANONYMOUS}return propValue.constructor.name}ReactPropTypes.checkPropTypes=checkPropTypes;ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes}}).call(this,require("_process"))},{"./checkPropTypes":7,"./lib/ReactPropTypesSecret":11,_process:6,"fbjs/lib/emptyFunction":2,"fbjs/lib/invariant":3,"fbjs/lib/warning":4,"object-assign":5}],10:[function(require,module,exports){(function(process){if(process.env.NODE_ENV!=="production"){var REACT_ELEMENT_TYPE=typeof Symbol==="function"&&Symbol.for&&Symbol.for("react.element")||60103;var isValidElement=function(object){return typeof object==="object"&&object!==null&&object.$$typeof===REACT_ELEMENT_TYPE};var throwOnDirectAccess=true;module.exports=require("./factoryWithTypeCheckers")(isValidElement,throwOnDirectAccess)}else{module.exports=require("./factoryWithThrowingShims")()}}).call(this,require("_process"))},{"./factoryWithThrowingShims":8,"./factoryWithTypeCheckers":9,_process:6}],11:[function(require,module,exports){"use strict";var ReactPropTypesSecret="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";module.exports=ReactPropTypesSecret},{}],12:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default={GLOBAL:{HIDE:"__react_tooltip_hide_event",REBUILD:"__react_tooltip_rebuild_event",SHOW:"__react_tooltip_show_event"}}},{}],13:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(target){target.prototype.isCustomEvent=function(ele){var event=this.state.event;return event||!!ele.getAttribute("data-event")};target.prototype.customBindListener=function(ele){var _this=this;var _state=this.state,event=_state.event,eventOff=_state.eventOff;var dataEvent=ele.getAttribute("data-event")||event;var dataEventOff=ele.getAttribute("data-event-off")||eventOff;dataEvent.split(" ").forEach(function(event){ele.removeEventListener(event,customListener);customListener=checkStatus.bind(_this,dataEventOff);ele.addEventListener(event,customListener,false)});if(dataEventOff){dataEventOff.split(" ").forEach(function(event){ele.removeEventListener(event,_this.hideTooltip);ele.addEventListener(event,_this.hideTooltip,false)})}};target.prototype.customUnbindListener=function(ele){var _state2=this.state,event=_state2.event,eventOff=_state2.eventOff;var dataEvent=event||ele.getAttribute("data-event");var dataEventOff=eventOff||ele.getAttribute("data-event-off");ele.removeEventListener(dataEvent,customListener);if(dataEventOff)ele.removeEventListener(dataEventOff,this.hideTooltip)}};var checkStatus=function checkStatus(dataEventOff,e){var show=this.state.show;var id=this.props.id;var dataIsCapture=e.currentTarget.getAttribute("data-iscapture");var isCapture=dataIsCapture&&dataIsCapture==="true"||this.props.isCapture;var currentItem=e.currentTarget.getAttribute("currentItem");if(!isCapture)e.stopPropagation();if(show&&currentItem==="true"){if(!dataEventOff)this.hideTooltip(e)}else{e.currentTarget.setAttribute("currentItem","true");setUntargetItems(e.currentTarget,this.getTargetArray(id));this.showTooltip(e)}};var setUntargetItems=function setUntargetItems(currentTarget,targetArray){for(var i=0;i<targetArray.length;i++){if(currentTarget!==targetArray[i]){targetArray[i].setAttribute("currentItem","false")}else{targetArray[i].setAttribute("currentItem","true")}}};var customListener=void 0},{}],14:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(target){target.prototype.getEffect=function(currentTarget){var dataEffect=currentTarget.getAttribute("data-effect");return dataEffect||this.props.effect||"float"}}},{}],15:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(target){target.prototype.isCapture=function(currentTarget){var dataIsCapture=currentTarget.getAttribute("data-iscapture");return dataIsCapture&&dataIsCapture==="true"||this.props.isCapture||false}}},{}],16:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(target){target.hide=function(target){dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE,{target:target})};target.rebuild=function(){dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD)};target.show=function(target){dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW,{target:target})};target.prototype.globalRebuild=function(){if(this.mount){this.unbindListener();this.bindListener()}};target.prototype.globalShow=function(event){if(this.mount){var e={currentTarget:event.detail.target};this.showTooltip(e,true)}};target.prototype.globalHide=function(event){if(this.mount){var hasTarget=event&&event.detail&&event.detail.target&&true||false;this.hideTooltip({currentTarget:hasTarget&&event.detail.target},hasTarget)}}};var _constant=require("../constant");var _constant2=_interopRequireDefault(_constant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var dispatchGlobalEvent=function dispatchGlobalEvent(eventName,opts){var event=void 0;if(typeof window.CustomEvent==="function"){event=new window.CustomEvent(eventName,{detail:opts})}else{event=document.createEvent("Event");event.initEvent(eventName,false,true);event.detail=opts}window.dispatchEvent(event)}},{"../constant":12}],17:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(target){target.prototype.bindRemovalTracker=function(){var _this=this;var MutationObserver=getMutationObserverClass();if(MutationObserver==null)return;var observer=new MutationObserver(function(mutations){for(var m1=0;m1<mutations.length;m1++){var mutation=mutations[m1];for(var m2=0;m2<mutation.removedNodes.length;m2++){var element=mutation.removedNodes[m2];if(element===_this.state.currentTarget){_this.hideTooltip();return}}}});observer.observe(window.document,{childList:true,subtree:true});this.removalTracker=observer};target.prototype.unbindRemovalTracker=function(){if(this.removalTracker){this.removalTracker.disconnect();this.removalTracker=null}}};var getMutationObserverClass=function getMutationObserverClass(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}},{}],18:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(target){target.prototype.bindWindowEvents=function(resizeHide){window.removeEventListener(_constant2.default.GLOBAL.HIDE,this.globalHide);window.addEventListener(_constant2.default.GLOBAL.HIDE,this.globalHide,false);window.removeEventListener(_constant2.default.GLOBAL.REBUILD,this.globalRebuild);window.addEventListener(_constant2.default.GLOBAL.REBUILD,this.globalRebuild,false);window.removeEventListener(_constant2.default.GLOBAL.SHOW,this.globalShow);window.addEventListener(_constant2.default.GLOBAL.SHOW,this.globalShow,false);if(resizeHide){window.removeEventListener("resize",this.onWindowResize);window.addEventListener("resize",this.onWindowResize,false)}};target.prototype.unbindWindowEvents=function(){window.removeEventListener(_constant2.default.GLOBAL.HIDE,this.globalHide);window.removeEventListener(_constant2.default.GLOBAL.REBUILD,this.globalRebuild);window.removeEventListener(_constant2.default.GLOBAL.SHOW,this.globalShow);window.removeEventListener("resize",this.onWindowResize)};target.prototype.onWindowResize=function(){if(!this.mount)return;this.hideTooltip()}};var _constant=require("../constant");var _constant2=_interopRequireDefault(_constant);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}},{"../constant":12}],19:[function(require,module,exports){(function(global){"use strict";var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _class,_class2,_temp;var _react=typeof window!=="undefined"?__webpack_provided_window_dot_React:typeof global!=="undefined"?global["React"]:null;var _react2=_interopRequireDefault(_react);var _propTypes=require("prop-types");var _propTypes2=_interopRequireDefault(_propTypes);var _reactDom=typeof window!=="undefined"?__webpack_provided_window_dot_ReactDOM:typeof global!=="undefined"?global["ReactDOM"]:null;var _reactDom2=_interopRequireDefault(_reactDom);var _classnames=require("classnames");var _classnames2=_interopRequireDefault(_classnames);var _staticMethods=require("./decorators/staticMethods");var _staticMethods2=_interopRequireDefault(_staticMethods);var _windowListener=require("./decorators/windowListener");var _windowListener2=_interopRequireDefault(_windowListener);var _customEvent=require("./decorators/customEvent");var _customEvent2=_interopRequireDefault(_customEvent);var _isCapture=require("./decorators/isCapture");var _isCapture2=_interopRequireDefault(_isCapture);var _getEffect=require("./decorators/getEffect")
;var _getEffect2=_interopRequireDefault(_getEffect);var _trackRemoval=require("./decorators/trackRemoval");var _trackRemoval2=_interopRequireDefault(_trackRemoval);var _getPosition=require("./utils/getPosition");var _getPosition2=_interopRequireDefault(_getPosition);var _getTipContent=require("./utils/getTipContent");var _getTipContent2=_interopRequireDefault(_getTipContent);var _aria=require("./utils/aria");var _nodeListToArray=require("./utils/nodeListToArray");var _nodeListToArray2=_interopRequireDefault(_nodeListToArray);var _style=require("./style");var _style2=_interopRequireDefault(_style);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return call&&(typeof call==="object"||typeof call==="function")?call:self}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}var ReactTooltip=(0,_staticMethods2.default)(_class=(0,_windowListener2.default)(_class=(0,_customEvent2.default)(_class=(0,_isCapture2.default)(_class=(0,_getEffect2.default)(_class=(0,_trackRemoval2.default)(_class=(_temp=_class2=function(_React$Component){_inherits(ReactTooltip,_React$Component);function ReactTooltip(props){_classCallCheck(this,ReactTooltip);var _this=_possibleConstructorReturn(this,(ReactTooltip.__proto__||Object.getPrototypeOf(ReactTooltip)).call(this,props));_this.state={place:"top",type:"dark",effect:"float",show:false,border:false,offset:{},extraClass:"",html:false,delayHide:0,delayShow:0,event:props.event||null,eventOff:props.eventOff||null,currentEvent:null,currentTarget:null,ariaProps:(0,_aria.parseAria)(props),isEmptyTip:false,disable:false,originTooltip:null,isMultiline:false};_this.bind(["showTooltip","updateTooltip","hideTooltip","getTooltipContent","globalRebuild","globalShow","globalHide","onWindowResize"]);_this.mount=true;_this.delayShowLoop=null;_this.delayHideLoop=null;_this.intervalUpdateContent=null;return _this}_createClass(ReactTooltip,[{key:"bind",value:function bind(methodArray){var _this2=this;methodArray.forEach(function(method){_this2[method]=_this2[method].bind(_this2)})}},{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,insecure=_props.insecure,resizeHide=_props.resizeHide;if(insecure){this.setStyleHeader()}this.bindListener();this.bindWindowEvents(resizeHide)}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){var ariaProps=this.state.ariaProps;var newAriaProps=(0,_aria.parseAria)(props);var isChanged=Object.keys(newAriaProps).some(function(props){return newAriaProps[props]!==ariaProps[props]});if(isChanged){this.setState({ariaProps:newAriaProps})}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.mount=false;this.clearTimer();this.unbindListener();this.removeScrollListener();this.unbindWindowEvents()}},{key:"getTargetArray",value:function getTargetArray(id){var targetArray=void 0;if(!id){targetArray=document.querySelectorAll("[data-tip]:not([data-for])")}else{var escaped=id.replace(/\\/g,"\\\\").replace(/"/g,'\\"');targetArray=document.querySelectorAll('[data-tip][data-for="'+escaped+'"]')}return(0,_nodeListToArray2.default)(targetArray)}},{key:"bindListener",value:function bindListener(){var _this3=this;var _props2=this.props,id=_props2.id,globalEventOff=_props2.globalEventOff;var targetArray=this.getTargetArray(id);targetArray.forEach(function(target){var isCaptureMode=_this3.isCapture(target);var effect=_this3.getEffect(target);if(target.getAttribute("currentItem")===null){target.setAttribute("currentItem","false")}_this3.unbindBasicListener(target);if(_this3.isCustomEvent(target)){_this3.customBindListener(target);return}target.addEventListener("mouseenter",_this3.showTooltip,isCaptureMode);if(effect==="float"){target.addEventListener("mousemove",_this3.updateTooltip,isCaptureMode)}target.addEventListener("mouseleave",_this3.hideTooltip,isCaptureMode)});if(globalEventOff){window.removeEventListener(globalEventOff,this.hideTooltip);window.addEventListener(globalEventOff,this.hideTooltip,false)}this.bindRemovalTracker()}},{key:"unbindListener",value:function unbindListener(){var _this4=this;var _props3=this.props,id=_props3.id,globalEventOff=_props3.globalEventOff;var targetArray=this.getTargetArray(id);targetArray.forEach(function(target){_this4.unbindBasicListener(target);if(_this4.isCustomEvent(target))_this4.customUnbindListener(target)});if(globalEventOff)window.removeEventListener(globalEventOff,this.hideTooltip);this.unbindRemovalTracker()}},{key:"unbindBasicListener",value:function unbindBasicListener(target){var isCaptureMode=this.isCapture(target);target.removeEventListener("mouseenter",this.showTooltip,isCaptureMode);target.removeEventListener("mousemove",this.updateTooltip,isCaptureMode);target.removeEventListener("mouseleave",this.hideTooltip,isCaptureMode)}},{key:"getTooltipContent",value:function getTooltipContent(){var _props4=this.props,getContent=_props4.getContent,children=_props4.children;var content=void 0;if(getContent){if(Array.isArray(getContent)){content=getContent[0]&&getContent[0](this.state.originTooltip)}else{content=getContent(this.state.originTooltip)}}return(0,_getTipContent2.default)(this.state.originTooltip,children,content,this.state.isMultiline)}},{key:"isEmptyTip",value:function isEmptyTip(placeholder){return typeof placeholder==="string"&&placeholder===""||placeholder===null}},{key:"showTooltip",value:function showTooltip(e,isGlobalCall){var _this5=this;if(isGlobalCall){var targetArray=this.getTargetArray(this.props.id);var isMyElement=targetArray.some(function(ele){return ele===e.currentTarget});if(!isMyElement)return}var _props5=this.props,multiline=_props5.multiline,getContent=_props5.getContent;var originTooltip=e.currentTarget.getAttribute("data-tip");var isMultiline=e.currentTarget.getAttribute("data-multiline")||multiline||false;var switchToSolid=e instanceof window.FocusEvent||isGlobalCall;var scrollHide=true;if(e.currentTarget.getAttribute("data-scroll-hide")){scrollHide=e.currentTarget.getAttribute("data-scroll-hide")==="true"}else if(this.props.scrollHide!=null){scrollHide=this.props.scrollHide}this.clearTimer();this.setState({originTooltip:originTooltip,isMultiline:isMultiline,desiredPlace:e.currentTarget.getAttribute("data-place")||this.props.place||"top",place:e.currentTarget.getAttribute("data-place")||this.props.place||"top",type:e.currentTarget.getAttribute("data-type")||this.props.type||"dark",effect:switchToSolid&&"solid"||this.getEffect(e.currentTarget),offset:e.currentTarget.getAttribute("data-offset")||this.props.offset||{},html:e.currentTarget.getAttribute("data-html")?e.currentTarget.getAttribute("data-html")==="true":this.props.html||false,delayShow:e.currentTarget.getAttribute("data-delay-show")||this.props.delayShow||0,delayHide:e.currentTarget.getAttribute("data-delay-hide")||this.props.delayHide||0,border:e.currentTarget.getAttribute("data-border")?e.currentTarget.getAttribute("data-border")==="true":this.props.border||false,extraClass:e.currentTarget.getAttribute("data-class")||this.props.class||this.props.className||"",disable:e.currentTarget.getAttribute("data-tip-disable")?e.currentTarget.getAttribute("data-tip-disable")==="true":this.props.disable||false},function(){if(scrollHide)_this5.addScrollListener(e);_this5.updateTooltip(e);if(getContent&&Array.isArray(getContent)){_this5.intervalUpdateContent=setInterval(function(){if(_this5.mount){var _getContent=_this5.props.getContent;var placeholder=(0,_getTipContent2.default)(originTooltip,"",_getContent[0](),isMultiline);var isEmptyTip=_this5.isEmptyTip(placeholder);_this5.setState({isEmptyTip:isEmptyTip});_this5.updatePosition()}},getContent[1])}})}},{key:"updateTooltip",value:function updateTooltip(e){var _this6=this;var _state=this.state,delayShow=_state.delayShow,show=_state.show,disable=_state.disable;var afterShow=this.props.afterShow;var placeholder=this.getTooltipContent();var delayTime=show?0:parseInt(delayShow,10);var eventTarget=e.currentTarget;if(this.isEmptyTip(placeholder)||disable)return;var updateState=function updateState(){if(Array.isArray(placeholder)&&placeholder.length>0||placeholder){var isInvisible=!_this6.state.show;_this6.setState({currentEvent:e,currentTarget:eventTarget,show:true},function(){_this6.updatePosition();if(isInvisible&&afterShow)afterShow()})}};clearTimeout(this.delayShowLoop);if(delayShow){this.delayShowLoop=setTimeout(updateState,delayTime)}else{updateState()}}},{key:"hideTooltip",value:function hideTooltip(e,hasTarget){var _this7=this;var _state2=this.state,delayHide=_state2.delayHide,disable=_state2.disable;var afterHide=this.props.afterHide;var placeholder=this.getTooltipContent();if(!this.mount)return;if(this.isEmptyTip(placeholder)||disable)return;if(hasTarget){var targetArray=this.getTargetArray(this.props.id);var isMyElement=targetArray.some(function(ele){return ele===e.currentTarget});if(!isMyElement||!this.state.show)return}var resetState=function resetState(){var isVisible=_this7.state.show;_this7.setState({show:false},function(){_this7.removeScrollListener();if(isVisible&&afterHide)afterHide()})};this.clearTimer();if(delayHide){this.delayHideLoop=setTimeout(resetState,parseInt(delayHide,10))}else{resetState()}}},{key:"addScrollListener",value:function addScrollListener(e){var isCaptureMode=this.isCapture(e.currentTarget);window.addEventListener("scroll",this.hideTooltip,isCaptureMode)}},{key:"removeScrollListener",value:function removeScrollListener(){window.removeEventListener("scroll",this.hideTooltip)}},{key:"updatePosition",value:function updatePosition(){var _this8=this;var _state3=this.state,currentEvent=_state3.currentEvent,currentTarget=_state3.currentTarget,place=_state3.place,desiredPlace=_state3.desiredPlace,effect=_state3.effect,offset=_state3.offset;var node=_reactDom2.default.findDOMNode(this);var result=(0,_getPosition2.default)(currentEvent,currentTarget,node,place,desiredPlace,effect,offset);if(result.isNewState){return this.setState(result.newState,function(){_this8.updatePosition()})}node.style.left=result.position.left+"px";node.style.top=result.position.top+"px"}},{key:"setStyleHeader",value:function setStyleHeader(){var head=document.getElementsByTagName("head")[0];if(!head.querySelector('style[id="react-tooltip"]')){var tag=document.createElement("style");tag.id="react-tooltip";tag.innerHTML=_style2.default;head.insertBefore(tag,head.firstChild)}}},{key:"clearTimer",value:function clearTimer(){clearTimeout(this.delayShowLoop);clearTimeout(this.delayHideLoop);clearInterval(this.intervalUpdateContent)}},{key:"render",value:function render(){var _state4=this.state,extraClass=_state4.extraClass,html=_state4.html,ariaProps=_state4.ariaProps,disable=_state4.disable;var placeholder=this.getTooltipContent();var isEmptyTip=this.isEmptyTip(placeholder);var tooltipClass=(0,_classnames2.default)("__react_component_tooltip",{show:this.state.show&&!disable&&!isEmptyTip},{border:this.state.border},{"place-top":this.state.place==="top"},{"place-bottom":this.state.place==="bottom"},{"place-left":this.state.place==="left"},{"place-right":this.state.place==="right"},{"type-dark":this.state.type==="dark"},{"type-success":this.state.type==="success"},{"type-warning":this.state.type==="warning"},{"type-error":this.state.type==="error"},{"type-info":this.state.type==="info"},{"type-light":this.state.type==="light"});var Wrapper=this.props.wrapper;if(ReactTooltip.supportedWrappers.indexOf(Wrapper)<0){Wrapper=ReactTooltip.defaultProps.wrapper}if(html){return _react2.default.createElement(Wrapper,_extends({className:tooltipClass+" "+extraClass,id:this.props.id},ariaProps,{"data-id":"tooltip",dangerouslySetInnerHTML:{__html:placeholder}}))}else{return _react2.default.createElement(Wrapper,_extends({className:tooltipClass+" "+extraClass,id:this.props.id},ariaProps,{"data-id":"tooltip"}),placeholder)}}}]);return ReactTooltip}(_react2.default.Component),_class2.propTypes={children:_propTypes2.default.any,place:_propTypes2.default.string,type:_propTypes2.default.string,effect:_propTypes2.default.string,offset:_propTypes2.default.object,multiline:_propTypes2.default.bool,border:_propTypes2.default.bool,insecure:_propTypes2.default.bool,class:_propTypes2.default.string,className:_propTypes2.default.string,id:_propTypes2.default.string,html:_propTypes2.default.bool,delayHide:_propTypes2.default.number,delayShow:_propTypes2.default.number,event:_propTypes2.default.string,eventOff:_propTypes2.default.string,watchWindow:_propTypes2.default.bool,isCapture:_propTypes2.default.bool,globalEventOff:_propTypes2.default.string,getContent:_propTypes2.default.any,afterShow:_propTypes2.default.func,afterHide:_propTypes2.default.func,disable:_propTypes2.default.bool,scrollHide:_propTypes2.default.bool,resizeHide:_propTypes2.default.bool,wrapper:_propTypes2.default.string},_class2.defaultProps={insecure:true,resizeHide:true,wrapper:"div"},_class2.supportedWrappers=["div","span"],_class2.displayName="ReactTooltip",_temp))||_class)||_class)||_class)||_class)||_class)||_class;module.exports=ReactTooltip}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{})},{"./decorators/customEvent":13,"./decorators/getEffect":14,"./decorators/isCapture":15,"./decorators/staticMethods":16,"./decorators/trackRemoval":17,"./decorators/windowListener":18,"./style":20,"./utils/aria":21,"./utils/getPosition":22,"./utils/getTipContent":23,"./utils/nodeListToArray":24,classnames:1,"prop-types":10}],20:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default='.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}'},{}],21:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.parseAria=parseAria;function parseAria(props){var ariaObj={};Object.keys(props).filter(function(prop){return/(^aria-\w+$|^role$)/.test(prop)}).forEach(function(prop){ariaObj[prop]=props[prop]});return ariaObj}},{}],22:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(e,target,node,place,desiredPlace,effect,offset){var _getDimensions=getDimensions(node),tipWidth=_getDimensions.width,tipHeight=_getDimensions.height;var _getDimensions2=getDimensions(target),targetWidth=_getDimensions2.width,targetHeight=_getDimensions2.height;var _getCurrentOffset=getCurrentOffset(e,target,effect),mouseX=_getCurrentOffset.mouseX,mouseY=_getCurrentOffset.mouseY;var defaultOffset=getDefaultPosition(effect,targetWidth,targetHeight,tipWidth,tipHeight);var _calculateOffset=calculateOffset(offset),extraOffset_X=_calculateOffset.extraOffset_X,extraOffset_Y=_calculateOffset.extraOffset_Y;var windowWidth=window.innerWidth;var windowHeight=window.innerHeight;var _getParent=getParent(node),parentTop=_getParent.parentTop,parentLeft=_getParent.parentLeft;var getTipOffsetLeft=function getTipOffsetLeft(place){var offset_X=defaultOffset[place].l;return mouseX+offset_X+extraOffset_X};var getTipOffsetRight=function getTipOffsetRight(place){var offset_X=defaultOffset[place].r;return mouseX+offset_X+extraOffset_X};var getTipOffsetTop=function getTipOffsetTop(place){var offset_Y=defaultOffset[place].t;return mouseY+offset_Y+extraOffset_Y};var getTipOffsetBottom=function getTipOffsetBottom(place){var offset_Y=defaultOffset[place].b;return mouseY+offset_Y+extraOffset_Y};var outsideVertical=function outsideVertical(){var result=false;var newPlace=void 0;if(getTipOffsetTop("left")<0&&getTipOffsetBottom("left")<=windowHeight&&getTipOffsetBottom("bottom")<=windowHeight){result=true;newPlace="bottom"}else if(getTipOffsetBottom("left")>windowHeight&&getTipOffsetTop("left")>=0&&getTipOffsetTop("top")>=0){result=true;newPlace="top"}return{result:result,newPlace:newPlace}};var outsideLeft=function outsideLeft(){var _outsideVertical=outsideVertical(),result=_outsideVertical.result,newPlace=_outsideVertical.newPlace;if(result&&outsideHorizontal().result){return{result:false}}if(!result&&getTipOffsetLeft("left")<0&&getTipOffsetRight("right")<=windowWidth){result=true;newPlace="right"}return{result:result,newPlace:newPlace}};var outsideRight=function outsideRight(){var _outsideVertical2=outsideVertical(),result=_outsideVertical2.result,newPlace=_outsideVertical2.newPlace;if(result&&outsideHorizontal().result){return{result:false}}if(!result&&getTipOffsetRight("right")>windowWidth&&getTipOffsetLeft("left")>=0){result=true;newPlace="left"}return{result:result,newPlace:newPlace}};var outsideHorizontal=function outsideHorizontal(){var result=false;var newPlace=void 0;if(getTipOffsetLeft("top")<0&&getTipOffsetRight("top")<=windowWidth&&getTipOffsetRight("right")<=windowWidth){result=true;newPlace="right"}else if(getTipOffsetRight("top")>windowWidth&&getTipOffsetLeft("top")>=0&&getTipOffsetLeft("left")>=0){result=true;newPlace="left"}return{result:result,newPlace:newPlace}};var outsideTop=function outsideTop(){var _outsideHorizontal=outsideHorizontal(),result=_outsideHorizontal.result,newPlace=_outsideHorizontal.newPlace;if(result&&outsideVertical().result){return{result:false}}if(!result&&getTipOffsetTop("top")<0&&getTipOffsetBottom("bottom")<=windowHeight){result=true;newPlace="bottom"}return{result:result,newPlace:newPlace}};var outsideBottom=function outsideBottom(){var _outsideHorizontal2=outsideHorizontal(),result=_outsideHorizontal2.result,newPlace=_outsideHorizontal2.newPlace;if(result&&outsideVertical().result){return{result:false}}if(!result&&getTipOffsetBottom("bottom")>windowHeight&&getTipOffsetTop("top")>=0){result=true;newPlace="top"}return{result:result,newPlace:newPlace}};var outsideLeftResult=outsideLeft();var outsideRightResult=outsideRight();var outsideTopResult=outsideTop();var outsideBottomResult=outsideBottom();if(place==="left"&&outsideLeftResult.result){return{isNewState:true,newState:{place:outsideLeftResult.newPlace}}}else if(place==="right"&&outsideRightResult.result){return{isNewState:true,newState:{place:outsideRightResult.newPlace}}}else if(place==="top"&&outsideTopResult.result){return{isNewState:true,newState:{place:outsideTopResult.newPlace}}}else if(place==="bottom"&&outsideBottomResult.result){return{isNewState:true,newState:{place:outsideBottomResult.newPlace}}}if(place!==desiredPlace){if(desiredPlace==="top"&&!outsideTopResult.result){return{isNewState:true,newState:{place:"top"}}}else if(desiredPlace==="left"&&!outsideLeftResult.result){return{isNewState:true,newState:{place:"left"}}}else if(desiredPlace==="right"&&!outsideRightResult.result){return{isNewState:true,newState:{place:"right"}}}else if(desiredPlace==="bottom"&&!outsideBottomResult.result){return{isNewState:true,newState:{place:"bottom"}}}}return{isNewState:false,position:{left:parseInt(getTipOffsetLeft(place)-parentLeft,10),top:parseInt(getTipOffsetTop(place)-parentTop,10)}}};var getDimensions=function getDimensions(node){var _node$getBoundingClie=node.getBoundingClientRect(),height=_node$getBoundingClie.height,width=_node$getBoundingClie.width;return{height:parseInt(height,10),width:parseInt(width,10)}};var getCurrentOffset=function getCurrentOffset(e,currentTarget,effect){var boundingClientRect=currentTarget.getBoundingClientRect();var targetTop=boundingClientRect.top;var targetLeft=boundingClientRect.left;var _getDimensions3=getDimensions(currentTarget),targetWidth=_getDimensions3.width,targetHeight=_getDimensions3.height;if(effect==="float"){return{mouseX:e.clientX,mouseY:e.clientY}}return{mouseX:targetLeft+targetWidth/2,mouseY:targetTop+targetHeight/2}};var getDefaultPosition=function getDefaultPosition(effect,targetWidth,targetHeight,tipWidth,tipHeight){var top=void 0;var right=void 0;var bottom=void 0;var left=void 0;var disToMouse=3;var triangleHeight=2;var cursorHeight=12;if(effect==="float"){top={l:-(tipWidth/2),r:tipWidth/2,t:-(tipHeight+disToMouse+triangleHeight),b:-disToMouse};bottom={l:-(tipWidth/2),r:tipWidth/2,t:disToMouse+cursorHeight,b:tipHeight+disToMouse+triangleHeight+cursorHeight};left={l:-(tipWidth+disToMouse+triangleHeight),r:-disToMouse,t:-(tipHeight/2),b:tipHeight/2};right={l:disToMouse,r:tipWidth+disToMouse+triangleHeight,t:-(tipHeight/2),b:tipHeight/2}}else if(effect==="solid"){top={l:-(tipWidth/2),r:tipWidth/2,t:-(targetHeight/2+tipHeight+triangleHeight),b:-(targetHeight/2)};bottom={l:-(tipWidth/2),r:tipWidth/2,t:targetHeight/2,b:targetHeight/2+tipHeight+triangleHeight};left={l:-(tipWidth+targetWidth/2+triangleHeight),r:-(targetWidth/2),t:-(tipHeight/2),b:tipHeight/2};right={l:targetWidth/2,r:tipWidth+targetWidth/2+triangleHeight,t:-(tipHeight/2),b:tipHeight/2}}return{top:top,bottom:bottom,left:left,right:right}};var calculateOffset=function calculateOffset(offset){var extraOffset_X=0;var extraOffset_Y=0;if(Object.prototype.toString.apply(offset)==="[object String]"){offset=JSON.parse(offset.toString().replace(/\'/g,'"'))}for(var key in offset){if(key==="top"){extraOffset_Y-=parseInt(offset[key],10)}else if(key==="bottom"){extraOffset_Y+=parseInt(offset[key],10)}else if(key==="left"){extraOffset_X-=parseInt(offset[key],10)}else if(key==="right"){extraOffset_X+=parseInt(offset[key],10)}}return{extraOffset_X:extraOffset_X,extraOffset_Y:extraOffset_Y}};var getParent=function getParent(currentTarget){var currentParent=currentTarget;while(currentParent){if(window.getComputedStyle(currentParent).getPropertyValue("transform")!=="none")break;currentParent=currentParent.parentElement}var parentTop=currentParent&&currentParent.getBoundingClientRect().top||0;var parentLeft=currentParent&&currentParent.getBoundingClientRect().left||0;return{parentTop:parentTop,parentLeft:parentLeft}}},{}],23:[function(require,module,exports){(function(global){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(tip,children,getContent,multiline){if(children)return children;if(getContent!==undefined&&getContent!==null)return getContent;if(getContent===null)return null;var regexp=/<br\s*\/?>/;if(!multiline||multiline==="false"||!regexp.test(tip)){return tip}return tip.split(regexp).map(function(d,i){return _react2.default.createElement("span",{key:i,className:"multi-line"},d)})};var _react=typeof window!=="undefined"?__webpack_provided_window_dot_React:typeof global!=="undefined"?global["React"]:null;var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{})},{}],24:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=function(nodeList){var length=nodeList.length;if(nodeList.hasOwnProperty){return Array.prototype.slice.call(nodeList)}return new Array(length).fill().map(function(index){return nodeList[index]})}},{}]},{},[19])(19)});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80), __webpack_require__(1), __webpack_require__(49)))

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = postAnnotations;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeAnnotations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postAnnotations(text, typeLetter, selectedServer, options) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_68" /* POST_ANNOTATIONS */].REQUEST,
        text: text,
        typeLetter: typeLetter,
        selectedServer: selectedServer,
        options: options
    };
}

function removeAnnotations() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_81" /* REMOVE_ANNOTATIONS */]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postAnnotations, 'postAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/actions/annotations.js');
    reactHotLoader.register(removeAnnotations, 'removeAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/actions/annotations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = postGazetters;
/* unused harmony export saveGazetters */
/* harmony export (immutable) */ __webpack_exports__["b"] = removeGazetters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postGazetters(text, options) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_70" /* POST_GAZETTERS */].REQUEST,
        text: text,
        options: options
    };
}

function saveGazetters(gazetters) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].REQUEST,
        gazetters: gazetters
    };
}

function removeGazetters() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_83" /* REMOVE_GAZETTERS */]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postGazetters, 'postGazetters', '/opt/atlassian/pipelines/agent/build/client/app/actions/gazetters.js');
    reactHotLoader.register(saveGazetters, 'saveGazetters', '/opt/atlassian/pipelines/agent/build/client/app/actions/gazetters.js');
    reactHotLoader.register(removeGazetters, 'removeGazetters', '/opt/atlassian/pipelines/agent/build/client/app/actions/gazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = saveRequestsDataCreated;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveRequestsDataDeleted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(saveRequestsDataCreated),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(saveRequestsDataDeleted);






/**
 * 
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {object} data 
 * @returns 
 */
function saveRequestsDataCreated(type, data) {
  var response;
  return regeneratorRuntime.wrap(function saveRequestsDataCreated$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveRequestsDataCreated, type, data);

        case 2:
          response = _context.sent;
          return _context.abrupt('return', response);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/**
 * 
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {{ _id: string }} data 
 * @returns 
 */
function saveRequestsDataDeleted(type, data) {
  var response;
  return regeneratorRuntime.wrap(function saveRequestsDataDeleted$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveRequestsDataDeleted, type, data);

        case 2:
          response = _context2.sent;
          return _context2.abrupt('return', response);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(saveRequestsDataCreated, 'saveRequestsDataCreated', '/opt/atlassian/pipelines/agent/build/client/app/sagas/orders.js');
  reactHotLoader.register(saveRequestsDataDeleted, 'saveRequestsDataDeleted', '/opt/atlassian/pipelines/agent/build/client/app/sagas/orders.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(187),
    getPrototype = __webpack_require__(535),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getAreas;
/* harmony export (immutable) */ __webpack_exports__["b"] = getArea;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteArea;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveArea;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateAreaSuggestions;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateAreaAlt;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateArea;
/* harmony export (immutable) */ __webpack_exports__["f"] = searchArea;
/* unused harmony export createArea */
/* harmony export (immutable) */ __webpack_exports__["d"] = removeAreaChild;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getAreas() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_7" /* GET_AREAS */].REQUEST
    };
}

function getArea(areaId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_6" /* GET_AREA */].REQUEST,
        areaId: areaId
    };
}

function deleteArea(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["J" /* DELETE_AREA */].REQUEST,
        item: item
    };
}

function saveArea(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_95" /* SAVE_AREA */],
        item: item
    };
}

function updateAreaSuggestions(suggestions) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_121" /* UPDATE_AREA_SUGGESTIONS */],
        suggestions: suggestions
    };
}

function updateAreaAlt(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_120" /* UPDATE_AREA_ALT */].REQUEST,
        item: item
    };
}

function updateArea(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_119" /* UPDATE_AREA */].REQUEST,
        item: item
    };
}

function searchArea(search) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_103" /* SEARCH_AREA */],
        search: search
    };
}

function createArea(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["A" /* CREATE_AREA */].REQUEST,
        item: item
    };
}

function removeAreaChild(parentId, childId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_82" /* REMOVE_AREA_CHILD */].REQUEST,
        parentId: parentId,
        childId: childId
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getAreas, 'getAreas', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(getArea, 'getArea', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(deleteArea, 'deleteArea', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(saveArea, 'saveArea', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(updateAreaSuggestions, 'updateAreaSuggestions', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(updateAreaAlt, 'updateAreaAlt', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(updateArea, 'updateArea', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(searchArea, 'searchArea', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(createArea, 'createArea', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    reactHotLoader.register(removeAreaChild, 'removeAreaChild', '/opt/atlassian/pipelines/agent/build/client/app/actions/regions/areas.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PORT_FACILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PORT_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PORT_WAREHOUSE_TYPES; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var PORT_FACILITIES = [{ name: 'breakBulk', label: 'Break bulk' }, { name: 'dryDock', label: 'Dry Dock' }, { name: 'roro', label: 'Ro-Ro' }, { name: 'container', label: 'Container' }, { name: 'lpg', label: 'LPG' }, { name: 'lng', label: 'LNG' }, { name: 'liquid', label: 'Liquid' }, { name: 'multipurpose', label: 'Multipurpose' }, { name: 'passenger', label: 'Passenger' }, { name: 'dryBulk', label: 'Dry Bulk' }, { name: 'bunkering', label: 'Bunkering' }, { name: 'steel', label: 'Steel' }, { name: 'shipyard', label: 'Shipyard' }, { name: 'reefer', label: 'Reefer' }];

var PORT_RESTRICTIONS = [{ name: 'maxDraught', label: 'Max Draft, m' }, { name: 'maxBeam', label: 'Max Beam, m' }, { name: 'maxLOA', label: 'Max LOA, m' }, { name: 'maxDWT', label: 'Max DWT, mt' }, { name: 'channelDepth', label: 'Channel Depth, m' }, { name: 'anchorageDepth', label: 'Anchorage Depth, m' }, { name: 'meanTide', label: 'Mean Tide, m' }];

var PORT_WAREHOUSE_TYPES = [{ name: 'timber', label: 'Timber' }, { name: 'grain', label: 'Grain' }, { name: 'lpg', label: 'LPG' }, { name: 'chemicals', label: 'Chemicals' }, { name: 'dryBulk', label: 'Dry bulk (ore, coal, etc)' }, { name: 'liquid', label: 'Liquid' }, { name: 'general', label: 'General cargo' }, { name: 'reefer', label: 'Reefer cargo' }];
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PORT_FACILITIES, 'PORT_FACILITIES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ports.js');
    reactHotLoader.register(PORT_RESTRICTIONS, 'PORT_RESTRICTIONS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ports.js');
    reactHotLoader.register(PORT_WAREHOUSE_TYPES, 'PORT_WAREHOUSE_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/constants/ports.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);
var layouts = __webpack_require__(287);

module.exports = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			layouts.addBox(chart, scale);
		});
	}
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.Arc = __webpack_require__(3332);
module.exports.Line = __webpack_require__(3333);
module.exports.Point = __webpack_require__(3334);
module.exports.Rectangle = __webpack_require__(3335);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddUpdateContext; });
/* unused harmony export ChangeFieldsContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RemoveRowContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HandleUpdateErrorsContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VesselDwtTypesContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CargoTypesContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CurrentTypeByPurposeContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Filters__ = __webpack_require__(3530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HiresTable__ = __webpack_require__(3533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ExportDialog__ = __webpack_require__(3544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_hire__ = __webpack_require__(372);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















function transformArray(array) {
    var validFields = Array.from(__WEBPACK_IMPORTED_MODULE_12_constants_hire__["b" /* HiresExportFieldsMapping */].keys()).filter(function (key) {
        return array.some(function (obj) {
            return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(obj, key);
        });
    });

    return array.map(function (obj) {
        var transformedEntries = validFields.map(function (key) {
            var value = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(obj, key);
            return [__WEBPACK_IMPORTED_MODULE_12_constants_hire__["b" /* HiresExportFieldsMapping */].get(key).placeHolder, value === null || value === undefined || !value.toString() ? '-' : value];
        }).filter(Boolean);

        return Object.fromEntries(transformedEntries);
    });
}

var AddUpdateContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({});
var ChangeFieldsContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var RemoveRowContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var HandleUpdateErrorsContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var VesselDwtTypesContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var CargoTypesContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var CurrentTypeByPurposeContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);

function HiresPage() {
    var _this = this;

    var rowsPerPage = [25, 50, 100];

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState2 = _slicedToArray(_useState, 2),
        total = _useState2[0],
        setTotal = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        errors = _useState4[0],
        setErrors = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        rows = _useState6[0],
        setRows = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState8 = _slicedToArray(_useState7, 2),
        rowsChanged = _useState8[0],
        setRowsChanged = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState10 = _slicedToArray(_useState9, 2),
        page = _useState10[0],
        setPage = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(25),
        _useState12 = _slicedToArray(_useState11, 2),
        numberOfRows = _useState12[0],
        setNumberOfRows = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])( /** @type {import('./Filters').Filters} */{ typeByPurpose: 'MPP' }),
        _useState14 = _slicedToArray(_useState13, 2),
        filters = _useState14[0],
        setFilters = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState16 = _slicedToArray(_useState15, 2),
        isLoaded = _useState16[0],
        setIsLoaded = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState18 = _slicedToArray(_useState17, 2),
        exportDialogOpened = _useState18[0],
        setExportDialogOpened = _useState18[1];

    var _useState19 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState20 = _slicedToArray(_useState19, 2),
        vesselDwtTypes = _useState20[0],
        setVesselDwtTypes = _useState20[1];

    var _useState21 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState22 = _slicedToArray(_useState21, 2),
        cargoTypes = _useState22[0],
        setCargoTypes = _useState22[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getVesselDwtTypes().then(function (res) {
            setVesselDwtTypes(res.data);
        });

        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getCargoTypes().then(function (res) {
            return setCargoTypes(res.data);
        });
    }, []);

    var getData = function getData(_filters) {
        setIsLoaded(false);
        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getHiresList(_filters).then(function (res) {
            if (!res.errors || !res.errors.length) {
                setRows(res.data.items);
                setTotal(res.data.total);
                setErrors(res.data.items.map(function (r) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2__common__["b" /* getDefaultError */])(r);
                }));
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(res.errors[0].messages[0], 'error');
            }

            setIsLoaded(true);
        });
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getData(_extends({}, filters, {
            page: page,
            limit: numberOfRows
        }));
    }, [filters, page, numberOfRows]);

    var handleUpdatePagination = function handleUpdatePagination(_ref) {
        var p = _ref.page,
            n = _ref.numberOfRows;

        if (numberOfRows !== n) {
            setPage(1);
        } else {
            setPage(p);
        }
        setNumberOfRows(n);
        setRowsChanged([]);
    };

    var updateRows = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var toUpdate, response;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (rowsChanged.length) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            if (!errors.find(function (e) {
                                return Object.values(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.omit(e, ['_id'])).find(function (_e) {
                                    return _e;
                                });
                            })) {
                                _context.next = 5;
                                break;
                            }

                            Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])('Please fill in all required fields.', 'error');
                            return _context.abrupt('return');

                        case 5:
                            toUpdate = rowsChanged.map(function (change) {
                                var changeForSave = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(change);

                                var result = _extends({}, changeForSave, {
                                    delivery: changeForSave.delivery ? changeForSave.delivery._id : undefined,
                                    redelivery: changeForSave.redelivery ? changeForSave.redelivery._id : undefined,
                                    mainRegionDelivery: changeForSave.mainRegionDelivery ? changeForSave.mainRegionDelivery._id : undefined,
                                    mainRegionRedelivery: changeForSave.mainRegionRedelivery ? changeForSave.mainRegionRedelivery._id : undefined,
                                    vesselId: changeForSave.vessel ? changeForSave.vessel._id : undefined,
                                    hire: parseFloat(changeForSave.hire),
                                    cargoId: changeForSave.cargo ? changeForSave.cargo._id : undefined,
                                    cargoTypeId: changeForSave.cargoTypeId ? changeForSave.cargoTypeId._id : undefined,
                                    cargoRegionId: changeForSave.cargoRegionId ? changeForSave.cargoRegionId._id : undefined,
                                    fuelPrice: changeForSave.fuelPrice,
                                    vesselDwtGroup: changeForSave.vesselDwtGroup._id,
                                    bunkerPlace: changeForSave.bunkerPlace ? changeForSave.bunkerPlace._id : undefined,
                                    typeByPurpose: filters.typeByPurpose
                                });

                                delete result.vessel;

                                return result;
                            });
                            _context.next = 8;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].updateHireIdeas({ update: toUpdate });

                        case 8:
                            response = _context.sent;

                            if (!response.errors || !response.errors.length) {
                                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])('Added successfully.', 'success');
                                setPage(1);
                                getData(_extends({
                                    page: 1, limit: numberOfRows }, filters));
                                setRowsChanged([]);
                            } else {
                                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(response.errors[0].messages[0], 'error');
                            }

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function updateRows() {
            return _ref2.apply(this, arguments);
        };
    }();

    /**
     * @param {*} value 
     * @param {{ clear?: boolean }} opts 
     */
    var changeFilters = function changeFilters(value) {
        var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref3$clear = _ref3.clear,
            clear = _ref3$clear === undefined ? false : _ref3$clear;

        setFilters(_extends({}, clear ? {} : filters, { page: 1 }, value));
        setPage(1);
        setRows([]);
        setRowsChanged([]);
    };

    var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Libs_Pagination__["a" /* default */], {
        total: total,
        rowsPerPage: rowsPerPage,
        page: page,
        numberOfRows: numberOfRows,
        updateRows: handleUpdatePagination
    });

    var addRow = function addRow() {
        var defaultHire = Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* getDefaultHire */])();

        setRows(function (currentRows) {
            var newRows = [defaultHire].concat(_toConsumableArray(currentRows));
            return newRows;
        });

        setRowsChanged(function (currentChanged) {
            var newChanged = [defaultHire].concat(_toConsumableArray(currentChanged));
            return newChanged;
        });

        setErrors(function (currentErrors) {
            return [Object(__WEBPACK_IMPORTED_MODULE_2__common__["b" /* getDefaultError */])({ _id: defaultHire.uniqueId }, { isNew: true })].concat(_toConsumableArray(currentErrors));
        });
    };

    function changeFieldsMultiple(changes) {
        var newRows = __WEBPACK_IMPORTED_MODULE_10_immer__["b" /* produce */](rows, function (_rows) {
            changes.forEach(function (change) {
                var index = change.index,
                    field = change.field,
                    value = change.value;

                if (typeof index !== 'number' || index < 0 || index >= _rows.length) {
                    console.warn('Invalid index:', index, 'rows length:', _rows.length);
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.set(_rows[index], field, value);
            });
        });

        var newChanged = __WEBPACK_IMPORTED_MODULE_10_immer__["b" /* produce */](rowsChanged, function (_rowsChanged) {
            changes.forEach(function (change) {
                var index = change.index;

                if (!newRows[index]) {
                    console.warn('Row not found at index:', index);
                    return;
                }

                var changedRow = _extends({}, newRows[index]);
                var alreadyInChanged = _rowsChanged.findIndex(function (rC) {
                    var rowId = rC._id;
                    var newRowId = changedRow._id;
                    console.log('Comparing IDs:', {
                        rowId: rowId,
                        newRowId: newRowId,
                        matches: rowId === newRowId
                    });
                    return rowId === newRowId;
                });

                if (alreadyInChanged >= 0) {
                    _rowsChanged[alreadyInChanged] = changedRow;
                } else {
                    _rowsChanged.push(changedRow);
                }
            });
        });

        setRows([].concat(_toConsumableArray(newRows)));
        setRowsChanged([].concat(_toConsumableArray(newChanged)));
    }

    var removeRow = function removeRow(rowId) {
        var newRows = __WEBPACK_IMPORTED_MODULE_10_immer__["b" /* produce */](rows, function (_rows) {
            _rows.splice(rowId, 1);
        });

        var newErrors = __WEBPACK_IMPORTED_MODULE_10_immer__["b" /* produce */](errors, function (_errors) {
            _errors.splice(rowId, 1);
        });

        setRows(newRows);
        setErrors(newErrors);
    };

    var handleUpdateErrors = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(index, field, value) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (errors.length) {
                                errors[index] && setErrors(function (prev) {
                                    var newErrors = __WEBPACK_IMPORTED_MODULE_10_immer__["b" /* produce */](prev, function (_errors) {
                                        _errors[index][field] = value;
                                    });
                                    return newErrors;
                                });
                            }

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function handleUpdateErrors(_x2, _x3, _x4) {
            return _ref4.apply(this, arguments);
        };
    }();

    /**
     * @param {'csv' | 'json'} extention 
     * @param {Record<string, 1 | -1>} select 
     */
    var exportRows = function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(extention, select) {
            var response, jsonContent, blob, url, a, transformedData, escapeCsvValue, csvContent, _blob, _url, _a;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].exportHireIdeas(extention, _extends({}, filters, { page: page, limit: numberOfRows }), select);

                        case 2:
                            response = _context3.sent;

                            if (Array.isArray(response.data)) {
                                _context3.next = 6;
                                break;
                            }

                            Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(response.errors[0].messages[0], 'error');
                            return _context3.abrupt('return');

                        case 6:

                            if (extention === 'json') {
                                jsonContent = JSON.stringify(response.data, null, 2);
                                blob = new Blob([jsonContent], { type: 'application/json;charset=utf-8;' });
                                url = URL.createObjectURL(blob);
                                a = document.createElement('a');

                                a.href = url;
                                a.download = 'Hires.json';
                                a.click();
                                URL.revokeObjectURL(url);
                            } else {
                                transformedData = transformArray(response.data);

                                escapeCsvValue = function escapeCsvValue(value) {
                                    if (value === null || value === undefined || !value.toString()) return null;
                                    var stringValue = String(value);
                                    return '"\u200E' + stringValue.replace(/"/g, '""').trim() + '\u200E"';
                                };

                                csvContent = [Object.keys(transformedData[0]).map(function (header) {
                                    return escapeCsvValue(header);
                                }).filter(Boolean).join(',')].concat(_toConsumableArray(transformedData.map(function (row) {
                                    return Object.values(row).map(function (value) {
                                        return escapeCsvValue(value);
                                    }).filter(Boolean).join(',');
                                }))).join('\n');
                                _blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csvContent], {
                                    type: 'text/csv;charset=utf-8;'
                                });
                                _url = URL.createObjectURL(_blob);
                                _a = document.createElement('a');

                                _a.href = _url;
                                _a.download = 'Hires.csv';
                                _a.click();
                                URL.revokeObjectURL(_url);
                            }

                        case 7:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function exportRows(_x5, _x6) {
            return _ref5.apply(this, arguments);
        };
    }();

    var handleOpenExportDialog = function handleOpenExportDialog() {
        setExportDialogOpened(!exportDialogOpened);
    };

    var renderPurposeToggle = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_material_ui__["q" /* RadioButtonGroup */],
        {
            onChange: function onChange(_e, v) {
                return changeFilters({ typeByPurpose: v, vesselDwtGroup: undefined });
            },
            style: _extends({}, __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].radioGroup, { display: 'flex', gap: '25px' }),
            name: 'typeByPurpose',
            valueSelected: filters.typeByPurpose
        },
        [{ value: '', label: 'All' }, { value: 'MPP', label: 'MPP' }, { value: 'BULK', label: 'BULK' }].map(function (e) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["p" /* RadioButton */], {
                key: e.label,
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].radioButton, { width: 'unset' }),
                value: e.value,
                label: e.label
            });
        })
    );

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        VesselDwtTypesContext.Provider,
        { value: vesselDwtTypes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ExportDialog__["a" /* default */], { open: exportDialogOpened, handleOpenExportDialog: handleOpenExportDialog, exportRows: exportRows }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-header', style: { display: 'flex', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    renderPurposeToggle
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    renderPagination
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-header', style: { flexDirection: 'column' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    AddUpdateContext.Provider,
                    { value: {
                            addRow: addRow, updateRows: updateRows, handleOpenExportDialog: handleOpenExportDialog
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Filters__["a" /* default */], {
                        filters: filters,
                        changeFilters: changeFilters,
                        clearFilters: function clearFilters() {
                            return changeFilters({ typeByPurpose: 'MPP' }, { clear: true });
                        }
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["d" /* CircularProgress */], {
                className: !isLoaded ? '' : 'hidden',
                style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].circularProgress
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: isLoaded ? '' : 'hidden', style: { marginTop: '10px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        RemoveRowContext.Provider,
                        { value: removeRow },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            HandleUpdateErrorsContext.Provider,
                            { value: handleUpdateErrors },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                CargoTypesContext.Provider,
                                { value: cargoTypes },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    CurrentTypeByPurposeContext.Provider,
                                    { value: filters.typeByPurpose },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HiresTable__["a" /* default */], { rows: rows, errors: errors, changeFieldsMultiple: changeFieldsMultiple })
                                )
                            )
                        )
                    )
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(HiresPage);

/* harmony default export */ __webpack_exports__["g"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(transformArray, 'transformArray', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(AddUpdateContext, 'AddUpdateContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(ChangeFieldsContext, 'ChangeFieldsContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(RemoveRowContext, 'RemoveRowContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(HandleUpdateErrorsContext, 'HandleUpdateErrorsContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(VesselDwtTypesContext, 'VesselDwtTypesContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(CargoTypesContext, 'CargoTypesContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(CurrentTypeByPurposeContext, 'CurrentTypeByPurposeContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(HiresPage, 'HiresPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresPage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(585);
var enumBugKeys = __webpack_require__(404);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(110);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(37);
var dPs = __webpack_require__(586);
var enumBugKeys = __webpack_require__(404);
var IE_PROTO = __webpack_require__(403)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(401)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(405).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(585);
var hiddenKeys = __webpack_require__(404).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(42);
var dP = __webpack_require__(66);
var DESCRIPTORS = __webpack_require__(65);
var SPECIES = __webpack_require__(59)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(108);
var call = __webpack_require__(598);
var isArrayIter = __webpack_require__(416);
var anObject = __webpack_require__(37);
var toLength = __webpack_require__(60);
var getIterFn = __webpack_require__(418);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(87);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 182 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(217);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(218)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(648);
var defined = __webpack_require__(440);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223),
    getRawTag = __webpack_require__(1358),
    objectToString = __webpack_require__(1359);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1365),
    getValue = __webpack_require__(1368);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export updateLetter */
/* unused harmony export watchUpdateLetter */
/* harmony export (immutable) */ __webpack_exports__["b"] = getLetter;
/* unused harmony export watchGetLetter */
/* unused harmony export saveAsSpam */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cargoes_orders__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vessels_orders__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vessels_size__ = __webpack_require__(688);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(updateLetter),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateLetter),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getLetter),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetLetter),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(saveAsSpam);










/**
 *
 * @param letter
 * @param typeLetter
 * @param server
 */
function updateLetter(letter) {
    var typeLetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : letter.type;
    var server = arguments[2];
    var response;
    return regeneratorRuntime.wrap(function updateLetter$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    letter.type = typeLetter;

                    _context.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateLetter, letter, server);

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 25;
                        break;
                    }

                    if (response.data.eh === 'api') {
                        response.data.owner = letter.owner;
                    }

                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_130" /* UPDATE_LETTER */].SUCCESS,
                        data: response.data
                    });

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Letter ' + letter._id + ' was update',
                            level: 'success',
                            _id: letter._id,
                            autoDismiss: 2
                        }
                    });

                case 10:

                    console.log('updateLetter', letter, response);

                    if (!(letter.type === 'cargo')) {
                        _context.next = 16;
                        break;
                    }

                    _context.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__cargoes_orders__["a" /* createCargoOrders */], response);

                case 14:
                    _context.next = 24;
                    break;

                case 16:
                    if (!(letter.type === 'vessel' && !letter.fromVesselSizes)) {
                        _context.next = 21;
                        break;
                    }

                    _context.next = 19;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4__vessels_orders__["a" /* createVesselOrders */], response);

                case 19:
                    _context.next = 24;
                    break;

                case 21:
                    if (!(letter.type === 'vessel' && letter.fromVesselSizes)) {
                        _context.next = 24;
                        break;
                    }

                    _context.next = 24;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_5__vessels_size__["a" /* createVesselSizes */], response);

                case 24:
                    return _context.abrupt('return', response);

                case 25:
                    _context.next = 27;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_130" /* UPDATE_LETTER */].FAILURE,
                        errors: response.errors
                    });

                case 27:
                    _context.next = 29;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Letter ' + letter._id + ' something get wrong',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 999
                        }
                    });

                case 29:
                    return _context.abrupt('return', response);

                case 30:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchUpdateLetter() {
    var _ref, letter, typeLetter;

    return regeneratorRuntime.wrap(function watchUpdateLetter$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 10;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_130" /* UPDATE_LETTER */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    letter = _ref.letter;
                    typeLetter = _ref.typeLetter;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateLetter, letter, typeLetter);

                case 8:
                    _context2.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get letter by id
 * */
function getLetter(id) {
    var response;
    return regeneratorRuntime.wrap(function getLetter$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getLetter, id);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_31" /* GET_LETTER */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Letter ' + id + ' was get',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context3.abrupt('return', response);

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_31" /* GET_LETTER */].FAILURE,
                        errors: response.errors
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Letter ' + id + ' something get wrong',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 99999
                        }
                    });

                case 13:
                    return _context3.abrupt('return', response);

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetLetter() {
    var _ref2, id;

    return regeneratorRuntime.wrap(function watchGetLetter$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 16;
                        break;
                    }

                    _context4.prev = 1;
                    _context4.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_31" /* GET_LETTER */].REQUEST);

                case 4:
                    _ref2 = _context4.sent;
                    id = _ref2.id;
                    _context4.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getLetter, id);

                case 8:
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](1);
                    _context4.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: _context4.t0.toString(),
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 99999
                        }
                    });

                case 14:
                    _context4.next = 0;
                    break;

                case 16:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[1, 10]]);
}

function saveAsSpam(data) {
    var response;
    return regeneratorRuntime.wrap(function saveAsSpam$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveAsSpam, data);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 7;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Letter saved as spam',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 25
                        }
                    });

                case 6:
                    return _context5.abrupt('return', response);

                case 7:
                    _context5.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 50
                        }
                    });

                case 9:
                    return _context5.abrupt('return', response);

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

var _default = [watchGetLetter, watchUpdateLetter];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(updateLetter, 'updateLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/letters.js');
    reactHotLoader.register(watchUpdateLetter, 'watchUpdateLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/letters.js');
    reactHotLoader.register(getLetter, 'getLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/letters.js');
    reactHotLoader.register(watchGetLetter, 'watchGetLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/letters.js');
    reactHotLoader.register(saveAsSpam, 'saveAsSpam', '/opt/atlassian/pipelines/agent/build/client/app/sagas/letters.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/letters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = postAnnotations;
/* unused harmony export watchPostAnnotations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(postAnnotations),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchPostAnnotations);





/**
 * Get annotations by text
 * */
function postAnnotations(text, typeLetter, selectedServer, options) {
    var response;
    return regeneratorRuntime.wrap(function postAnnotations$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].postAnnotations, text, typeLetter, selectedServer, options);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_68" /* POST_ANNOTATIONS */].SUCCESS,
                        data: response.data.annotations,
                        headers: response.headers
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Annotations obtain',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context.abrupt('return', response);

                case 9:
                    _context.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_68" /* POST_ANNOTATIONS */].FAILURE
                    });

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something get wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 99999
                        }
                    });

                case 13:
                    return _context.abrupt('return', response);

                case 14:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchPostAnnotations() {
    var _ref, text, typeLetter, selectedServer, options;

    return regeneratorRuntime.wrap(function watchPostAnnotations$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 18;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_68" /* POST_ANNOTATIONS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    text = _ref.text;
                    typeLetter = _ref.typeLetter;
                    selectedServer = _ref.selectedServer;
                    options = _ref.options;
                    _context2.prev = 8;
                    _context2.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(postAnnotations, text, typeLetter, selectedServer, options);

                case 11:
                    _context2.next = 16;
                    break;

                case 13:
                    _context2.prev = 13;
                    _context2.t0 = _context2['catch'](8);

                    console.dir(_context2.t0);

                case 16:
                    _context2.next = 0;
                    break;

                case 18:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[8, 13]]);
}

var _default = [watchPostAnnotations];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postAnnotations, 'postAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/sagas/annotations.js');
    reactHotLoader.register(watchPostAnnotations, 'watchPostAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/sagas/annotations.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/annotations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = getVesselSales;
/* harmony export (immutable) */ __webpack_exports__["b"] = createVesselSales;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateVesselSale;
/* harmony export (immutable) */ __webpack_exports__["a"] = addVesselSale;
/* harmony export (immutable) */ __webpack_exports__["f"] = removeLastVesselSale;
/* harmony export (immutable) */ __webpack_exports__["g"] = resetVesselSales;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateVesselSaleUser;
/* unused harmony export removeAllVesselSales */
/* harmony export (immutable) */ __webpack_exports__["e"] = postVesselSale;
/* unused harmony export postVesselSaleResponse */
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteVesselSale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getVesselSales(filter) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_62" /* GET_VESSEL_SALES */].REQUEST,
        filter: filter
    };
}

function createVesselSales(items, user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["H" /* CREATE_VESSEL_SALES */],
        items: items,
        user: user
    };
}

function updateVesselSale(numberSale, newVesselSale) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_146" /* UPDATE_VESSEL_SALE */],
        numberSale: numberSale,
        newVesselSale: newVesselSale
    };
}

function addVesselSale() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["j" /* ADD_VESSEL_SALE */]
    };
}

function removeLastVesselSale() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_87" /* REMOVE_LAST_VESSEL_SALE */]
    };
}

function resetVesselSales() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_94" /* RESET_VESSEL_SALES */]
    };
}

function updateVesselSaleUser(user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_147" /* UPDATE_VESSEL_SALE_USER */],
        user: user
    };
}

function removeAllVesselSales() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_79" /* REMOVE_ALL_VESSEL_SALES */]
    };
}

function postVesselSale(vesselId, vesselSaleRequest) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].REQUEST,
        vesselSaleRequest: vesselSaleRequest,
        vesselId: vesselId
    };
}

function postVesselSaleResponse(response) {
    if (response.status) {
        return {
            type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].SUCCESS,
            vesselSaleRequest: response.vesselSaleRequest,
            message: response.message
        };
    }

    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].FAILURE,
        vesselSaleRequest: response.vesselSaleRequest,
        error: response.error
    };
}

function deleteVesselSale(saleId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_1" /* DELETE_VESSEL_SALE */].REQUEST,
        saleId: saleId
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVesselSales, 'getVesselSales', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(createVesselSales, 'createVesselSales', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(updateVesselSale, 'updateVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(addVesselSale, 'addVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(removeLastVesselSale, 'removeLastVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(resetVesselSales, 'resetVesselSales', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(updateVesselSaleUser, 'updateVesselSaleUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(removeAllVesselSales, 'removeAllVesselSales', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(postVesselSale, 'postVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(postVesselSaleResponse, 'postVesselSaleResponse', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    reactHotLoader.register(deleteVesselSale, 'deleteVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/sales.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1495);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(318),
    isLength = __webpack_require__(489);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(735);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_download__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_download__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var Attachments = function Attachments(_ref) {
    var attachments = _ref.attachments,
        toggleAttachmentsDialog = _ref.toggleAttachmentsDialog,
        openedAttachmentsDialog = _ref.openedAttachmentsDialog,
        buttonStyle = _ref.buttonStyle,
        labelStyle = _ref.labelStyle,
        style = _ref.style;

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["g" /* FlatButton */], {
        label: 'CLOSE',
        primary: true,
        onClick: toggleAttachmentsDialog
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default.a,
            {
                open: openedAttachmentsDialog,
                title: 'Attachments',
                actions: actions,
                onRequestClose: toggleAttachmentsDialog,
                bodyStyle: {
                    overflowY: 'scroll',
                    minHeight: '53vh'
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["j" /* List */],
                null,
                attachments && attachments.map(function (attachment) {
                    var url = '/api/v1/file/' + attachment.fileId;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { key: attachment._id, style: { textDecoration: 'none' }, href: url, download: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["k" /* ListItem */], {
                            key: attachment._id,
                            primaryText: attachment.name,
                            leftIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_download___default.a, null)
                        })
                    );
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
            onClick: toggleAttachmentsDialog,
            label: 'Attachments',
            className: 'btn',
            buttonStyle: buttonStyle,
            labelStyle: labelStyle,
            style: style,
            primary: true,
            disabled: attachments && !attachments.length
        })
    );
};

var _default = Attachments;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Attachments, 'Attachments', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Attachments.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Attachments.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_query__ = __webpack_require__(141);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var ToSpamButton = function ToSpamButton(_ref) {
    var letterId = _ref.letterId,
        _onSuccess = _ref.onSuccess,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        rest = _objectWithoutProperties(_ref, ['letterId', 'onSuccess', 'disabled']);

    var spamMutation = Object(__WEBPACK_IMPORTED_MODULE_6_react_query__["useMutation"])(function (id) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_4_sagas_lettersNew__["b" /* saveAsSpam */], id);
    }, {
        onSuccess: function onSuccess(result) {
            if (result.status === 200 && _onSuccess) {
                _onSuccess();
            }
        },
        onError: function onError(err) {
            console.error(err);
            Object(__WEBPACK_IMPORTED_MODULE_5_actions_notifications_notifications__["a" /* addNotification */])({
                title: 'Error',
                message: 'Failed to mark email as spam.',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 3
            });
        }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, _extends({
        className: 'btn',
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '10px 10px 10px 0' },
        buttonStyle: {
            height: '25px',
            lineHeight: '25px',
            backgroundColor: disabled ? '#E5E5E5' : '#3f51b5'
        },
        label: 'To spam',
        onClick: function onClick() {
            return spamMutation.mutate(letterId);
        },
        disabled: disabled,
        secondary: true
    }, rest));
};

ToSpamButton.propTypes = {
    letterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    onSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

ToSpamButton.defaultProps = {
    disabled: false
};

var _default = ToSpamButton;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ToSpamButton, 'ToSpamButton', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/ToSpamButton.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/ToSpamButton.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscribable; });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useQueryClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryClientProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var defaultContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(getQueryClientContext(__WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: client
  }, children));
};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = CollapseCustomizable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_hardware_keyboard_arrow_down__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_hardware_keyboard_arrow_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_hardware_keyboard_arrow_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_up__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollapseCustomizable_scss__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollapseCustomizable_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CollapseCustomizable_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */








function CollapseCustomizable(_ref) {
    var head = _ref.head,
        _ref$body = _ref.body,
        body = _ref$body === undefined ? null : _ref$body,
        _key = _ref._key,
        _ref$headStyle = _ref.headStyle,
        headStyle = _ref$headStyle === undefined ? {} : _ref$headStyle,
        _ref$bodyStyle = _ref.bodyStyle,
        bodyStyle = _ref$bodyStyle === undefined ? {} : _ref$bodyStyle,
        _ref$withCollapseIcon = _ref.withCollapseIcon,
        withCollapseIcon = _ref$withCollapseIcon === undefined ? true : _ref$withCollapseIcon;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState2 = _slicedToArray(_useState, 2),
        isCollapsed = _useState2[0],
        setIsCollapsed = _useState2[1];

    var collapse = function collapse(e) {
        if (e.target.tagName.toLowerCase() !== 'input') {
            setIsCollapsed(!isCollapsed);
        }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'collapse-customizable', key: _key },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'collapse-customizable-head',
                style: headStyle,
                onClick: collapse
            },
            head,
            withCollapseIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton___default.a,
                {
                    className: 'collapse-customizable-arrow'
                },
                isCollapsed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_hardware_keyboard_arrow_down___default.a, { color: '#B2B2B2' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_up___default.a, { color: '#B2B2B2' })
            ) : null
        ),
        body ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'collapse-customizable-body',
                style: _extends({}, bodyStyle, {
                    maxHeight: isCollapsed ? '0px' : 'unset',
                    overflow: 'hidden'
                })
            },
            body
        ) : null
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CollapseCustomizable, 'CollapseCustomizable', '/opt/atlassian/pipelines/agent/build/client/app/components/common/CollapseCustomizable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCargoTypes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoTypes() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_20" /* GET_CARGO_TYPES */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoTypes, 'getCargoTypes', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/types.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var mapError = function mapError(_ref) {
  var errorProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'errorText';
  var _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === undefined ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning,
      input = _ref.input,
      props = _objectWithoutProperties(_ref, ['meta', 'input']);

  return touched && (error || warning) ? _extends({}, props, input, _defineProperty({}, errorProp, error || warning)) : _extends({}, input, props);
};

exports.default = mapError;

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export adminEmails */
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var constants = {
    GOOGLE_MAP_API_KEY: 'AIzaSyD-7kzo47fZMNaWiYvsK8bACYuF1pR-RrM'
};

/**
 * @deprecated user role should be used to check for admin. See {UserPerms}
 */
var adminEmails = ['sergey.s@myco.com', 'ss@shipnext.com', 's.semernev@shipnext.com', 'n.liashenko@shipnext.com', 'serhsamiy@gmail.com', 'd.kundasov@shipnext.com', 'chartering@l3r.net', 'e.koraia@shipnext.com', 'chepkalenkos@mail.ru', 'oxidksushkin@gmail.com', 'vzoteeva0308@gmail.com'];

var _default = constants;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(constants, 'constants', '/opt/atlassian/pipelines/agent/build/client/app/constants/index.js');
    reactHotLoader.register(adminEmails, 'adminEmails', '/opt/atlassian/pipelines/agent/build/client/app/constants/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/constants/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(3279);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_index__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var defaultStyles = {
    headerCol: _extends({}, __WEBPACK_IMPORTED_MODULE_0_styles_index__["a" /* default */].tableHeaderColumnCSS, {
        textAlign: 'center',
        border: '1px solid #eaeaea',
        fontSize: '10px',
        boxSizing: 'border-box'
    }),
    tableRow: _extends({}, __WEBPACK_IMPORTED_MODULE_0_styles_index__["a" /* default */].tableRowColumnCSS, {
        borderLeft: '1px solid #eaeaea',
        boxSizing: 'border-box'
    }),
    borderRight: '1px solid #eaeaea'
};

var styles = _extends({}, defaultStyles, {
    headerColSm: _extends({}, defaultStyles.headerCol, {
        width: '4%'
    }),
    tableRowSm: _extends({}, defaultStyles.tableRow, {
        width: '4%'
    }),
    error: {
        borderTop: '1px solid salmon',
        borderRight: '1px solid salmon',
        borderBottom: '1px solid salmon',
        borderLeft: '1px solid salmon'
    },
    buttons: {
        style: {
            height: '25px',
            lineHeight: '25px',
            marginTop: '10px'
        },
        labelStyle: {
            fontSize: '13px'
        }
    }
});

var _default = styles;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(defaultStyles, 'defaultStyles', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/styles.js');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/styles.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/styles.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(66).f;
var has = __webpack_require__(92);
var TAG = __webpack_require__(59)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(109);
var TAG = __webpack_require__(59)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var defined = __webpack_require__(119);
var fails = __webpack_require__(47);
var spaces = __webpack_require__(407);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1215);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(151);

var _Actions = __webpack_require__(309);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(154);
var createDesc = __webpack_require__(250);
module.exports = __webpack_require__(184) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(651);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(661);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(77);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getVesselSizes;
/* harmony export (immutable) */ __webpack_exports__["b"] = createVesselSizes;
/* harmony export (immutable) */ __webpack_exports__["a"] = addVesselSize;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateVesselSize;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateVesselSizeUser;
/* harmony export (immutable) */ __webpack_exports__["f"] = removeLastVesselSize;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeAllVesselSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = notificationPurposeRequired;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getVesselSizes() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_63" /* GET_VESSEL_SIZES */]
    };
}

function createVesselSizes(items) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["I" /* CREATE_VESSEL_SIZES */],
        items: items
    };
}

function addVesselSize() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["k" /* ADD_VESSEL_SIZE */]
    };
}

function updateVesselSize(numberSize, newVesselSize) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_148" /* UPDATE_VESSEL_SIZE */],
        numberSize: numberSize,
        newVesselSize: newVesselSize
    };
}

function updateVesselSizeUser(user) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_149" /* UPDATE_VESSEL_SIZE_USER */],
        user: user
    };
}

function removeLastVesselSize() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_88" /* REMOVE_LAST_VESSEL_SIZE */]
    };
}

function removeAllVesselSize() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_80" /* REMOVE_ALL_VESSEL_SIZES */]
    };
}

function notificationPurposeRequired() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_67" /* NOTIFICATION_PURPOSE_REQUIRED */]
    };
}

// TOT update vessel order user

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVesselSizes, 'getVesselSizes', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    reactHotLoader.register(createVesselSizes, 'createVesselSizes', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    reactHotLoader.register(addVesselSize, 'addVesselSize', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    reactHotLoader.register(updateVesselSize, 'updateVesselSize', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    reactHotLoader.register(updateVesselSizeUser, 'updateVesselSizeUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    reactHotLoader.register(removeLastVesselSize, 'removeLastVesselSize', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    reactHotLoader.register(removeAllVesselSize, 'removeAllVesselSize', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    reactHotLoader.register(notificationPurposeRequired, 'notificationPurposeRequired', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/size.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = refNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(refNumber);




// eslint-disable-next-line import/prefer-default-export
function refNumber(response) {
    var store, refNo;
    return regeneratorRuntime.wrap(function refNumber$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 2:
                    store = _context.sent;
                    refNo = void 0;

                    if (response.clientRefNo) {
                        refNo = response.clientRefNo;
                    } else {
                        refNo = response.refNo;
                    }

                    __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].sendRefNumber(store.letter._id, { refNo: refNo, requestId: response.id });

                case 6:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(refNumber, 'refNumber', '/opt/atlassian/pipelines/agent/build/client/app/sagas/refNumber.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _RenderToLayer = __webpack_require__(745);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _lodash = __webpack_require__(1753);

var _lodash2 = _interopRequireDefault(_lodash);

var _PopoverAnimationDefault = __webpack_require__(1754);

var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'none'
  }
};

var Popover = function (_Component) {
  (0, _inherits3.default)(Popover, _Component);

  function Popover(props, context) {
    (0, _classCallCheck3.default)(this, Popover);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));

    _this.timeout = null;

    _this.renderLayer = function () {
      var _this$props = _this.props,
          animated = _this$props.animated,
          animation = _this$props.animation,
          anchorEl = _this$props.anchorEl,
          anchorOrigin = _this$props.anchorOrigin,
          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
          canAutoPosition = _this$props.canAutoPosition,
          children = _this$props.children,
          onRequestClose = _this$props.onRequestClose,
          style = _this$props.style,
          targetOrigin = _this$props.targetOrigin,
          useLayerForClickAway = _this$props.useLayerForClickAway,
          scrollableContainer = _this$props.scrollableContainer,
          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);


      var styleRoot = style;

      if (!animated) {
        styleRoot = {
          position: 'fixed',
          zIndex: _this.context.muiTheme.zIndex.popover
        };

        if (!_this.state.open) {
          return null;
        }

        return _react2.default.createElement(
          _Paper2.default,
          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
          children
        );
      }

      var Animation = animation || _PopoverAnimationDefault2.default;

      return _react2.default.createElement(
        Animation,
        (0, _extends3.default)({
          targetOrigin: targetOrigin,
          style: styleRoot
        }, other, {
          open: _this.state.open && !_this.state.closing
        }),
        children
      );
    };

    _this.componentClickAway = function () {
      _this.requestClose('clickAway');
    };

    _this.setPlacement = function (scrolling) {
      if (!_this.state.open) {
        return;
      }

      if (!_this.popoverRefs.layer.getLayer()) {
        return;
      }

      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
      if (!targetEl) {
        return;
      }

      var _this$props2 = _this.props,
          targetOrigin = _this$props2.targetOrigin,
          anchorOrigin = _this$props2.anchorOrigin;

      var anchorEl = _this.props.anchorEl || _this.anchorEl;

      var anchor = _this.getAnchorPosition(anchorEl);
      var target = _this.getTargetPosition(targetEl);

      var targetPosition = {
        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
      };

      if (scrolling && _this.props.autoCloseWhenOffScreen) {
        _this.autoCloseWhenOffScreen(anchor);
      }

      if (_this.props.canAutoPosition) {
        target = _this.getTargetPosition(targetEl); // update as height may have changed
        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
      }

      targetEl.style.top = targetPosition.top + 'px';
      targetEl.style.left = targetPosition.left + 'px';
      targetEl.style.maxHeight = window.innerHeight + 'px';
    };

    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);

    _this.popoverRefs = {};

    _this.state = {
      open: props.open,
      closing: false
    };
    return _this;
  }

  (0, _createClass3.default)(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open === this.props.open) {
        return;
      }

      if (nextProps.open) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
        this.setState({
          open: true,
          closing: false
        });
      } else {
        if (nextProps.animated) {
          if (this.timeout !== null) return;
          this.setState({ closing: true });
          this.timeout = setTimeout(function () {
            _this2.setState({
              open: false
            }, function () {
              _this2.timeout = null;
            });
          }, 500);
        } else {
          this.setState({
            open: false
          });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      clearTimeout(this.placementTimeout);
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
      this.handleScroll.cancel();

      if (this.placementTimeout) {
        clearTimeout(this.placementTimeout);
        this.placementTimeout = null;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }, {
    key: 'requestClose',
    value: function requestClose(reason) {
      if (this.props.onRequestClose) {
        this.props.onRequestClose(reason);
      }
    }
  }, {
    key: 'getAnchorPosition',
    value: function getAnchorPosition(el) {
      if (!el) {
        el = _reactDom2.default.findDOMNode(this);
      }

      var rect = el.getBoundingClientRect();
      var a = {
        top: rect.top,
        left: rect.left,
        width: el.offsetWidth,
        height: el.offsetHeight
      };

      a.right = rect.right || a.left + a.width;
      a.bottom = rect.bottom || a.top + a.height;
      a.middle = a.left + (a.right - a.left) / 2;
      a.center = a.top + (a.bottom - a.top) / 2;

      return a;
    }
  }, {
    key: 'getTargetPosition',
    value: function getTargetPosition(targetEl) {
      return {
        top: 0,
        center: targetEl.offsetHeight / 2,
        bottom: targetEl.offsetHeight,
        left: 0,
        middle: targetEl.offsetWidth / 2,
        right: targetEl.offsetWidth
      };
    }
  }, {
    key: 'autoCloseWhenOffScreen',
    value: function autoCloseWhenOffScreen(anchorPosition) {
      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
        this.requestClose('offScreen');
      }
    }
  }, {
    key: 'getOverlapMode',
    value: function getOverlapMode(anchor, target, median) {
      if ([anchor, target].indexOf(median) >= 0) return 'auto';
      if (anchor === target) return 'inclusive';
      return 'exclusive';
    }
  }, {
    key: 'getPositions',
    value: function getPositions(anchor, target) {
      var a = (0, _extends3.default)({}, anchor);
      var t = (0, _extends3.default)({}, target);

      var positions = {
        x: ['left', 'right'].filter(function (p) {
          return p !== t.horizontal;
        }),
        y: ['top', 'bottom'].filter(function (p) {
          return p !== t.vertical;
        })
      };

      var overlap = {
        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
      };

      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');

      if (overlap.y !== 'auto') {
        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
        if (overlap.y === 'inclusive') {
          t.vertical = t.vertical;
        }
      }

      if (overlap.x !== 'auto') {
        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
        if (overlap.y === 'inclusive') {
          t.horizontal = t.horizontal;
        }
      }

      return {
        positions: positions,
        anchorPos: a
      };
    }
  }, {
    key: 'applyAutoPositionIfNeeded',
    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
          positions = _getPositions.positions,
          anchorPos = _getPositions.anchorPos;

      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
        if (newTop + target.bottom <= window.innerHeight) {
          targetPosition.top = Math.max(0, newTop);
        } else {
          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
          if (newTop + target.bottom <= window.innerHeight) {
            targetPosition.top = Math.max(0, newTop);
          }
        }
      }

      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
        if (newLeft + target.right <= window.innerWidth) {
          targetPosition.left = Math.max(0, newLeft);
        } else {
          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
          if (newLeft + target.right <= window.innerWidth) {
            targetPosition.left = Math.max(0, newLeft);
          }
        }
      }

      return targetPosition;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var eventListener = this.state.open ? _react2.default.createElement(_reactEventListener2.default, {
        target: this.props.scrollableContainer,
        onScroll: this.handleScroll,
        onResize: this.handleResize
      }) : null;
      return _react2.default.createElement(
        'div',
        { style: styles.root },
        eventListener,
        _react2.default.createElement(_RenderToLayer2.default, {
          ref: function ref(_ref) {
            return _this3.popoverRefs.layer = _ref;
          },
          open: this.state.open,
          componentClickAway: this.componentClickAway,
          useLayerForClickAway: this.props.useLayerForClickAway,
          render: this.renderLayer
        })
      );
    }
  }]);
  return Popover;
}(_react.Component);

Popover.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  animated: true,
  autoCloseWhenOffScreen: true,
  canAutoPosition: true,
  onRequestClose: function onRequestClose() {},
  open: false,
  scrollableContainer: 'window',
  style: {
    overflowY: 'auto'
  },
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  useLayerForClickAway: true,
  zDepth: 1
};
Popover.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Popover.propTypes =  false ? {
  /**
   * This is the DOM element that will be used to set the position of the
   * popover.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * This is the point on the anchor where the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it is added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, the popover will hide when the anchor is scrolled off the screen.
   */
  autoCloseWhenOffScreen: _propTypes2.default.bool,
  /**
   * If true, the popover (potentially) ignores `targetOrigin`
   * and `anchorOrigin` to make itself fit on screen,
   * which is useful for mobile devices.
   */
  canAutoPosition: _propTypes2.default.bool,
  /**
   * The content of the popover.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Callback function fired when the popover is requested to be closed.
   *
   * @param {string} reason The reason for the close request. Possibles values
   * are 'clickAway' and 'offScreen'.
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * If true, the popover is visible.
   */
  open: _propTypes2.default.bool,
  /**
   * Represents the parent scrollable container.
   * It can be an element or a string like `window`.
   */
  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying
   * elements, and trigger an `onRequestClose('clickAway')` call.
   */
  useLayerForClickAway: _propTypes2.default.bool,
  /**
   * The zDepth of the popover.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Popover;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1765)
var ieee754 = __webpack_require__(1766)
var isArray = __webpack_require__(349)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var keys = __webpack_require__(1771);
var hasBinary = __webpack_require__(754);
var sliceBuffer = __webpack_require__(1772);
var after = __webpack_require__(1773);
var utf8 = __webpack_require__(1774);

var base64encoder;
if (typeof ArrayBuffer !== 'undefined') {
  base64encoder = __webpack_require__(1775);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(1776);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
  );
};
HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
HardwareKeyboardArrowUp.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
  );
};
HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
HardwareKeyboardArrowDown.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(357),
    baseAssignValue = __webpack_require__(793);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();









var HtmlContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function (props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isOpenDialog = _useState2[0],
        setIsOpenDialog = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.letter),
        _useState4 = _slicedToArray(_useState3, 2),
        letter = _useState4[0],
        setLetter = _useState4[1];

    var iframeRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

    var toggleDialog = function toggleDialog() {
        setIsOpenDialog(!isOpenDialog);
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setLetter(props.letter);
    }, [props.letter]);

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
        label: 'CLOSE',
        primary: true,
        onClick: toggleDialog
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
            onClick: toggleDialog,
            disabled: !letter.html,
            label: 'HTML',
            labelStyle: { fontSize: '10px' },
            style: { height: '25px', minWidth: '50px' },
            buttonStyle: { height: '25px', lineHeight: '25px' },
            primary: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
            {
                title: 'HTML',
                actions: actions,
                modal: false,
                contentStyle: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].Dialog,
                open: isOpenDialog,
                onRequestClose: toggleDialog
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
                srcDoc: letter.html,
                sandbox: '',
                title: 'html_iframe',
                style: {
                    overflow: 'auto', border: 'none', width: '100%', height: '65vh'
                },
                ref: iframeRef,
                frameBorder: '0'
            })
        )
    );
});

var _default = HtmlContent;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HtmlContent, 'HtmlContent', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/HtmlContent.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/HtmlContent.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = useRefState;
/* unused harmony export useMemoryState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function useRefState(initialValue) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialValue),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var stateRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(state);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        stateRef.current = state;
    }, [state]);

    return [state, setState, stateRef];
}

var memoryState = {};

function useMemoryState(key, initialState) {
    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
        var hasMemoryValue = Object.prototype.hasOwnProperty.call(memoryState, key);
        if (hasMemoryValue) {
            return memoryState[key];
        }

        return typeof initialState === 'function' ? initialState() : initialState;
    }),
        _useState4 = _slicedToArray(_useState3, 2),
        state = _useState4[0],
        setState = _useState4[1];

    function onChange(nextState) {
        memoryState[key] = nextState;
        setState(nextState);
    }

    return [state, onChange];
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(useRefState, 'useRefState', '/opt/atlassian/pipelines/agent/build/client/app/helpers/react.utils.js');
    reactHotLoader.register(memoryState, 'memoryState', '/opt/atlassian/pipelines/agent/build/client/app/helpers/react.utils.js');
    reactHotLoader.register(useMemoryState, 'useMemoryState', '/opt/atlassian/pipelines/agent/build/client/app/helpers/react.utils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = letterMapper;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnnotationTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(letterMapper);

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-04-24 16:15:10 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-10-08 17:51:18
 */




function letterMapper(characters) {
    var currentRange, content, contentStart, lastItem, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, range;

    return regeneratorRuntime.wrap(function letterMapper$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    currentRange = void 0;
                    content = '';
                    contentStart = 0;
                    lastItem = void 0;
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 7;
                    _iterator = characters[Symbol.iterator]();

                case 9:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _context.next = 30;
                        break;
                    }

                    item = _step.value;
                    range = item.ids.join(',');

                    if (!(currentRange !== range)) {
                        _context.next = 25;
                        break;
                    }

                    if (!(content.length > 0)) {
                        _context.next = 24;
                        break;
                    }

                    if (!lastItem) {
                        _context.next = 19;
                        break;
                    }

                    _context.next = 17;
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'span',
                        {
                            key: contentStart + '-' + currentRange,
                            'data-for': 'gaz',
                            'data-tip': currentRange,
                            style: lastItem.style
                        },
                        content
                    );

                case 17:
                    _context.next = 21;
                    break;

                case 19:
                    _context.next = 21;
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'span',
                        { key: contentStart },
                        content
                    );

                case 21:

                    lastItem = undefined;
                    contentStart = item.symbolPosition;
                    content = '';

                case 24:
                    currentRange = range;

                case 25:

                    content += item.symbol;
                    if (item.ids.length > 0) {
                        lastItem = item;
                    }

                case 27:
                    _iteratorNormalCompletion = true;
                    _context.next = 9;
                    break;

                case 30:
                    _context.next = 36;
                    break;

                case 32:
                    _context.prev = 32;
                    _context.t0 = _context['catch'](7);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                case 36:
                    _context.prev = 36;
                    _context.prev = 37;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }

                case 39:
                    _context.prev = 39;

                    if (!_didIteratorError) {
                        _context.next = 42;
                        break;
                    }

                    throw _iteratorError;

                case 42:
                    return _context.finish(39);

                case 43:
                    return _context.finish(36);

                case 44:
                    if (!(content.length > 0)) {
                        _context.next = 52;
                        break;
                    }

                    if (!lastItem) {
                        _context.next = 50;
                        break;
                    }

                    _context.next = 48;
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'span',
                        {
                            key: contentStart + '-' + currentRange,
                            'data-for': 'gaz',
                            'data-tip': currentRange,
                            style: lastItem.style
                        },
                        content
                    );

                case 48:
                    _context.next = 52;
                    break;

                case 50:
                    _context.next = 52;
                    return content;

                case 52:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[7, 32, 36, 44], [37,, 39, 43]]);
}

var AnnotationTooltip = function (_React$Component) {
    _inherits(AnnotationTooltip, _React$Component);

    function AnnotationTooltip() {
        _classCallCheck(this, AnnotationTooltip);

        return _possibleConstructorReturn(this, (AnnotationTooltip.__proto__ || Object.getPrototypeOf(AnnotationTooltip)).apply(this, arguments));
    }

    _createClass(AnnotationTooltip, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.refs.tooltip && this.refs.tooltip.globalRebuild();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                tooltips = _props.tooltips,
                renderTooltip = _props.renderTooltip;


            return tooltips && tooltips.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_tooltip___default.a, {
                id: 'gaz',
                ref: 'tooltip',
                getContent: function getContent(tip) {
                    var tooltip = tooltips.find(function (item) {
                        return item.ids.join(',') === tip;
                    });
                    if (!tooltip || typeof renderTooltip !== 'function') {
                        console.warn('There is no such item ' + tip + ' found');
                        return null;
                    }

                    return renderTooltip(tooltip);
                }
            }) : null;
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(letterMapper, 'letterMapper', '/opt/atlassian/pipelines/agent/build/client/app/helpers/annotations.js');
    reactHotLoader.register(AnnotationTooltip, 'AnnotationTooltip', '/opt/atlassian/pipelines/agent/build/client/app/helpers/annotations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isCancelable;
/* unused harmony export CancelledError */
/* harmony export (immutable) */ __webpack_exports__["c"] = isCancelledError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Retryer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focusManager__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__onlineManager__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(70);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      Object(__WEBPACK_IMPORTED_MODULE_2__utils__["u" /* sleep */])(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0__focusManager__["a" /* focusManager */].isFocused() || !__WEBPACK_IMPORTED_MODULE_1__onlineManager__["a" /* onlineManager */].isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return produce; });
/* unused harmony export setAutoFreeze */
/* unused harmony export setUseProxies */
/* unused harmony export applyPatches */
/* unused harmony export Immer */
/* unused harmony export original */
/* unused harmony export isDraft */
/* unused harmony export nothing */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var NOTHING = typeof Symbol !== "undefined" ? Symbol("immer-nothing") : defineProperty({}, "immer-nothing", true);

var DRAFT_STATE = typeof Symbol !== "undefined" ? Symbol("immer-state") : "__$immer_state";

function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}

function isDraftable(value) {
    if (!value) return false;
    if ((typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object") return false;
    if (Array.isArray(value)) return true;
    var proto = Object.getPrototypeOf(value);
    return proto === null || proto === Object.prototype;
}

function original(value) {
    if (value && value[DRAFT_STATE]) {
        return value[DRAFT_STATE].base;
    }
    // otherwise return undefined
}

var assign = Object.assign || function assign(target, value) {
    for (var key in value) {
        if (has(value, key)) {
            target[key] = value[key];
        }
    }
    return target;
};

function shallowCopy(value) {
    if (Array.isArray(value)) return value.slice();
    var target = value.__proto__ === undefined ? Object.create(null) : {};
    return assign(target, value);
}

function each(value, cb) {
    if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            cb(i, value[i], value);
        }
    } else {
        for (var key in value) {
            cb(key, value[key], value);
        }
    }
}

function has(thing, prop) {
    return Object.prototype.hasOwnProperty.call(thing, prop);
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

function generatePatches(state, basePath, patches, inversePatches) {
    Array.isArray(state.base) ? generateArrayPatches(state, basePath, patches, inversePatches) : generateObjectPatches(state, basePath, patches, inversePatches);
}

function generateArrayPatches(state, basePath, patches, inversePatches) {
    var base = state.base,
        copy = state.copy,
        assigned = state.assigned;

    var minLength = Math.min(base.length, copy.length);

    // Look for replaced indices.
    for (var i = 0; i < minLength; i++) {
        if (assigned[i] && base[i] !== copy[i]) {
            var path = basePath.concat(i);
            patches.push({ op: "replace", path: path, value: copy[i] });
            inversePatches.push({ op: "replace", path: path, value: base[i] });
        }
    }

    // Did the array expand?
    if (minLength < copy.length) {
        for (var _i = minLength; _i < copy.length; _i++) {
            patches.push({
                op: "add",
                path: basePath.concat(_i),
                value: copy[_i]
            });
        }
        inversePatches.push({
            op: "replace",
            path: basePath.concat("length"),
            value: base.length
        });
    }

    // ...or did it shrink?
    else if (minLength < base.length) {
            patches.push({
                op: "replace",
                path: basePath.concat("length"),
                value: copy.length
            });
            for (var _i2 = minLength; _i2 < base.length; _i2++) {
                inversePatches.push({
                    op: "add",
                    path: basePath.concat(_i2),
                    value: base[_i2]
                });
            }
        }
}

function generateObjectPatches(state, basePath, patches, inversePatches) {
    var base = state.base,
        copy = state.copy;

    each(state.assigned, function (key, assignedValue) {
        var origValue = base[key];
        var value = copy[key];
        var op = !assignedValue ? "remove" : key in base ? "replace" : "add";
        if (origValue === base && op === "replace") return;
        var path = basePath.concat(key);
        patches.push(op === "remove" ? { op: op, path: path } : { op: op, path: path, value: value });
        inversePatches.push(op === "add" ? { op: "remove", path: path } : op === "remove" ? { op: "add", path: path, value: origValue } : { op: "replace", path: path, value: origValue });
    });
}

function applyPatches(draft, patches) {
    for (var i = 0; i < patches.length; i++) {
        var patch = patches[i];
        var path = patch.path;

        if (path.length === 0 && patch.op === "replace") {
            draft = patch.value;
        } else {
            var base = draft;
            for (var _i3 = 0; _i3 < path.length - 1; _i3++) {
                base = base[path[_i3]];
                if (!base || (typeof base === "undefined" ? "undefined" : _typeof(base)) !== "object") throw new Error("Cannot apply patch, path doesn't resolve: " + path.join("/")); // prettier-ignore
            }
            var key = path[path.length - 1];
            switch (patch.op) {
                case "replace":
                case "add":
                    // TODO: add support is not extensive, it does not support insertion or `-` atm!
                    base[key] = patch.value;
                    break;
                case "remove":
                    if (Array.isArray(base)) {
                        if (key !== base.length - 1) throw new Error("Only the last index of an array can be removed, index: " + key + ", length: " + base.length); // prettier-ignore
                        base.length -= 1;
                    } else {
                        delete base[key];
                    }
                    break;
                default:
                    throw new Error("Unsupported patch operation: " + patch.op);
            }
        }
    }
    return draft;
}

// @ts-check

var descriptors = {};

// For nested produce calls:
var scopes = [];
var currentScope = function currentScope() {
    return scopes[scopes.length - 1];
};

function willFinalize(result, baseDraft, needPatches) {
    var scope = currentScope();
    scope.forEach(function (state) {
        return state.finalizing = true;
    });
    if (result === undefined || result === baseDraft) {
        if (needPatches) markChangesRecursively(baseDraft);
        // This is faster when we don't care about which attributes changed.
        markChangesSweep(scope);
    }
}

function createDraft(base, parent) {
    if (isDraft(base)) throw new Error("This should never happen. Please report: https://github.com/mweststrate/immer/issues/new"); // prettier-ignore

    var draft = shallowCopy(base);
    each(base, function (prop) {
        Object.defineProperty(draft, "" + prop, createPropertyProxy("" + prop));
    });

    var state = {
        modified: false,
        finalizing: false,
        finalized: false,
        assigned: {}, // true: value was assigned to these props, false: was removed
        parent: parent,
        base: base,
        draft: draft,
        copy: null,
        revoke: revoke,
        revoked: false
    };

    createHiddenProperty(draft, DRAFT_STATE, state);
    currentScope().push(state);
    return draft;
}

function revoke() {
    this.revoked = true;
}

function source(state) {
    return state.copy || state.base;
}

function _get(state, prop) {
    assertUnrevoked(state);
    var value = source(state)[prop];
    // Drafts are only created for proxyable values that exist in the base state.
    if (!state.finalizing && value === state.base[prop] && isDraftable(value)) {
        prepareCopy(state);
        return state.copy[prop] = createDraft(value, state);
    }
    return value;
}

function _set(state, prop, value) {
    assertUnrevoked(state);
    state.assigned[prop] = true; // optimization; skip this if there is no listener
    if (!state.modified) {
        if (is(source(state)[prop], value)) return;
        markChanged(state);
        prepareCopy(state);
    }
    state.copy[prop] = value;
}

function markChanged(state) {
    if (!state.modified) {
        state.modified = true;
        if (state.parent) markChanged(state.parent);
    }
}

function prepareCopy(state) {
    if (!state.copy) state.copy = shallowCopy(state.base);
}

function createPropertyProxy(prop) {
    return descriptors[prop] || (descriptors[prop] = {
        configurable: true,
        enumerable: true,
        get: function get$$1() {
            return _get(this[DRAFT_STATE], prop);
        },
        set: function set$$1(value) {
            _set(this[DRAFT_STATE], prop, value);
        }
    });
}

function assertUnrevoked(state) {
    if (state.revoked === true) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(state.copy || state.base));
}

// This looks expensive, but only proxies are visited, and only objects without known changes are scanned.
function markChangesSweep(scope) {
    // The natural order of drafts in the `scope` array is based on when they
    // were accessed. By processing drafts in reverse natural order, we have a
    // better chance of processing leaf nodes first. When a leaf node is known to
    // have changed, we can avoid any traversal of its ancestor nodes.
    for (var i = scope.length - 1; i >= 0; i--) {
        var state = scope[i];
        if (state.modified === false) {
            if (Array.isArray(state.base)) {
                if (hasArrayChanges(state)) markChanged(state);
            } else if (hasObjectChanges(state)) markChanged(state);
        }
    }
}

function markChangesRecursively(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") return;
    var state = object[DRAFT_STATE];
    if (!state) return;
    var base = state.base,
        draft = state.draft,
        assigned = state.assigned;

    if (!Array.isArray(object)) {
        // Look for added keys.
        Object.keys(draft).forEach(function (key) {
            // The `undefined` check is a fast path for pre-existing keys.
            if (base[key] === undefined && !has(base, key)) {
                assigned[key] = true;
                markChanged(state);
            } else if (!assigned[key]) {
                // Only untouched properties trigger recursion.
                markChangesRecursively(draft[key]);
            }
        });
        // Look for removed keys.
        Object.keys(base).forEach(function (key) {
            // The `undefined` check is a fast path for pre-existing keys.
            if (draft[key] === undefined && !has(draft, key)) {
                assigned[key] = false;
                markChanged(state);
            }
        });
    } else if (hasArrayChanges(state)) {
        markChanged(state);
        assigned.length = true;
        if (draft.length < base.length) {
            for (var i = draft.length; i < base.length; i++) {
                assigned[i] = false;
            }
        } else {
            for (var _i = base.length; _i < draft.length; _i++) {
                assigned[_i] = true;
            }
        }
        for (var _i2 = 0; _i2 < draft.length; _i2++) {
            // Only untouched indices trigger recursion.
            if (assigned[_i2] === undefined) markChangesRecursively(draft[_i2]);
        }
    }
}

function hasObjectChanges(state) {
    var base = state.base,
        draft = state.draft;

    // Search for added keys. Start at the back, because non-numeric keys
    // are ordered by time of definition on the object.

    var keys = Object.keys(draft);
    for (var i = keys.length - 1; i >= 0; i--) {
        // The `undefined` check is a fast path for pre-existing keys.
        if (base[keys[i]] === undefined && !has(base, keys[i])) {
            return true;
        }
    }

    // Since no keys have been added, we can compare lengths to know if an
    // object has been deleted.
    return keys.length !== Object.keys(base).length;
}

function hasArrayChanges(state) {
    var draft = state.draft;

    if (draft.length !== state.base.length) return true;
    // See #116
    // If we first shorten the length, our array interceptors will be removed.
    // If after that new items are added, result in the same original length,
    // those last items will have no intercepting property.
    // So if there is no own descriptor on the last position, we know that items were removed and added
    // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
    // the last one
    var descriptor = Object.getOwnPropertyDescriptor(draft, draft.length - 1);
    // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)
    if (descriptor && !descriptor.get) return true;
    // For all other cases, we don't have to compare, as they would have been picked up by the index setters
    return false;
}

function createHiddenProperty(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        enumerable: false,
        writable: true
    });
}



var legacyProxy = Object.freeze({
	scopes: scopes,
	currentScope: currentScope,
	willFinalize: willFinalize,
	createDraft: createDraft
});

// @ts-check

// For nested produce calls:
var scopes$1 = [];
var currentScope$1 = function currentScope() {
    return scopes$1[scopes$1.length - 1];
};

// Do nothing before being finalized.
function willFinalize$1() {}

function createDraft$1(base, parent) {
    if (isDraft(base)) throw new Error("This should never happen. Please report: https://github.com/mweststrate/immer/issues/new"); // prettier-ignore

    var state = {
        modified: false, // this tree is modified (either this object or one of it's children)
        assigned: {}, // true: value was assigned to these props, false: was removed
        parent: parent,
        base: base,
        draft: null, // the root proxy
        drafts: {}, // proxied properties
        copy: null,
        revoke: null,
        finalized: false
    };

    var _ref = Array.isArray(base) ? Proxy.revocable([state], arrayTraps) : Proxy.revocable(state, objectTraps),
        revoke = _ref.revoke,
        proxy = _ref.proxy;

    state.draft = proxy;
    state.revoke = revoke;

    currentScope$1().push(state);
    return proxy;
}

var objectTraps = {
    get: get$1,
    has: function has$$1(target, prop) {
        return prop in source$1(target);
    },
    ownKeys: function ownKeys(target) {
        return Reflect.ownKeys(source$1(target));
    },

    set: set$1,
    deleteProperty: deleteProperty,
    getOwnPropertyDescriptor: getOwnPropertyDescriptor,
    defineProperty: defineProperty$1,
    setPrototypeOf: function setPrototypeOf() {
        throw new Error("Immer does not support `setPrototypeOf()`.");
    }
};

var arrayTraps = {};
each(objectTraps, function (key, fn) {
    arrayTraps[key] = function () {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function (state, prop) {
    if (isNaN(parseInt(prop))) throw new Error("Immer does not support deleting properties from arrays: " + prop);
    return objectTraps.deleteProperty.call(this, state[0], prop);
};
arrayTraps.set = function (state, prop, value) {
    if (prop !== "length" && isNaN(parseInt(prop))) throw new Error("Immer does not support setting non-numeric properties on arrays: " + prop);
    return objectTraps.set.call(this, state[0], prop, value);
};

function source$1(state) {
    return state.modified === true ? state.copy : state.base;
}

function get$1(state, prop) {
    if (prop === DRAFT_STATE) return state;
    if (state.modified) {
        var value = state.copy[prop];
        if (value === state.base[prop] && isDraftable(value))
            // only create proxy if it is not yet a proxy, and not a new object
            // (new objects don't need proxying, they will be processed in finalize anyway)
            return state.copy[prop] = createDraft$1(value, state);
        return value;
    } else {
        if (has(state.drafts, prop)) return state.drafts[prop];
        var _value = state.base[prop];
        if (!isDraft(_value) && isDraftable(_value)) return state.drafts[prop] = createDraft$1(_value, state);
        return _value;
    }
}

function set$1(state, prop, value) {
    if (!state.modified) {
        // Optimize based on value's truthiness. Truthy values are guaranteed to
        // never be undefined, so we can avoid the `in` operator. Lastly, truthy
        // values may be drafts, but falsy values are never drafts.
        var isUnchanged = value ? is(state.base[prop], value) || value === state.drafts[prop] : is(state.base[prop], value) && prop in state.base;
        if (isUnchanged) return true;
        markChanged$1(state);
    }
    state.assigned[prop] = true;
    state.copy[prop] = value;
    return true;
}

function deleteProperty(state, prop) {
    // The `undefined` check is a fast path for pre-existing keys.
    if (state.base[prop] !== undefined || prop in state.base) {
        state.assigned[prop] = false;
        markChanged$1(state);
    }
    if (state.copy) delete state.copy[prop];
    return true;
}

function getOwnPropertyDescriptor(state, prop) {
    var owner = state.modified ? state.copy : has(state.drafts, prop) ? state.drafts : state.base;
    var descriptor = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (descriptor && !(Array.isArray(owner) && prop === "length")) descriptor.configurable = true;
    return descriptor;
}

function defineProperty$1() {
    throw new Error("Immer does not support defining properties on draft objects.");
}

function markChanged$1(state) {
    if (!state.modified) {
        state.modified = true;
        state.copy = shallowCopy(state.base);
        // copy the drafts over the base-copy
        assign(state.copy, state.drafts); // yup that works for arrays as well
        if (state.parent) markChanged$1(state.parent);
    }
}

var modernProxy = Object.freeze({
	scopes: scopes$1,
	currentScope: currentScope$1,
	willFinalize: willFinalize$1,
	createDraft: createDraft$1
});

function verifyMinified() {}

var configDefaults = {
    useProxies: typeof Proxy !== "undefined" && typeof Reflect !== "undefined",
    autoFreeze: typeof process !== "undefined" ? "production" !== "production" : verifyMinified.name === "verifyMinified",
    onAssign: null,
    onDelete: null,
    onCopy: null
};

var Immer = function () {
    function Immer(config) {
        classCallCheck(this, Immer);

        assign(this, configDefaults, config);
        this.setUseProxies(this.useProxies);
        this.produce = this.produce.bind(this);
    }

    createClass(Immer, [{
        key: "produce",
        value: function produce(base, recipe, patchListener) {
            var _this = this;

            // curried invocation
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;

                // prettier-ignore
                return function () {
                    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                    }

                    var base = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultBase;
                    return _this.produce(base, function (draft) {
                        var _recipe;

                        return (_recipe = recipe).call.apply(_recipe, [draft, draft].concat(args));
                    });
                };
            }

            // prettier-ignore
            {
                if (typeof recipe !== "function") throw new Error("if first argument is not a function, the second argument to produce should be a function");
                if (patchListener !== undefined && typeof patchListener !== "function") throw new Error("the third argument of a producer should not be set or a function");
            }

            var result = void 0;
            // Only create proxies for plain objects/arrays.
            if (!isDraftable(base)) {
                result = recipe(base);
                if (result === undefined) return base;
            }
            // See #100, don't nest producers
            else if (isDraft(base)) {
                    result = recipe.call(base, base);
                    if (result === undefined) return base;
                }
                // The given value must be proxied.
                else {
                        this.scopes.push([]);
                        var baseDraft = this.createDraft(base);
                        try {
                            result = recipe.call(baseDraft, baseDraft);
                            this.willFinalize(result, baseDraft, !!patchListener);

                            // Never generate patches when no listener exists.
                            var patches = patchListener && [],
                                inversePatches = patchListener && [];

                            // Finalize the modified draft...
                            if (result === undefined || result === baseDraft) {
                                result = this.finalize(baseDraft, [], patches, inversePatches);
                            }
                            // ...or use a replacement value.
                            else {
                                    // Users must never modify the draft _and_ return something else.
                                    if (baseDraft[DRAFT_STATE].modified) throw new Error("An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft."); // prettier-ignore

                                    // Finalize the replacement in case it contains (or is) a subset of the draft.
                                    if (isDraftable(result)) result = this.finalize(result);

                                    if (patchListener) {
                                        patches.push({
                                            op: "replace",
                                            path: [],
                                            value: result
                                        });
                                        inversePatches.push({
                                            op: "replace",
                                            path: [],
                                            value: base
                                        });
                                    }
                                }
                        } finally {
                            this.currentScope().forEach(function (state) {
                                return state.revoke();
                            });
                            this.scopes.pop();
                        }
                        patchListener && patchListener(patches, inversePatches);
                    }
            // Normalize the result.
            return result === NOTHING ? undefined : result;
        }
    }, {
        key: "setAutoFreeze",
        value: function setAutoFreeze(value) {
            this.autoFreeze = value;
        }
    }, {
        key: "setUseProxies",
        value: function setUseProxies(value) {
            this.useProxies = value;
            assign(this, value ? modernProxy : legacyProxy);
        }
        /**
         * @internal
         * Finalize a draft, returning either the unmodified base state or a modified
         * copy of the base state.
         */

    }, {
        key: "finalize",
        value: function finalize(draft, path, patches, inversePatches) {
            var state = draft[DRAFT_STATE];
            if (!state) {
                if (Object.isFrozen(draft)) return draft;
                return this.finalizeTree(draft);
            }
            if (!state.modified) return state.base;
            if (!state.finalized) {
                state.finalized = true;
                this.finalizeTree(state.draft, path, patches, inversePatches);
                if (this.onDelete) {
                    var assigned = state.assigned;

                    for (var prop in assigned) {
                        assigned[prop] || this.onDelete(state, prop);
                    }
                }
                if (this.onCopy) this.onCopy(state);
                if (this.autoFreeze) Object.freeze(state.copy);
                if (patches) generatePatches(state, path, patches, inversePatches);
            }
            return state.copy;
        }
        /**
         * @internal
         * Finalize all drafts in the given state tree.
         */

    }, {
        key: "finalizeTree",
        value: function finalizeTree(root, path, patches, inversePatches) {
            var _this2 = this;

            var state = root[DRAFT_STATE];
            if (state) {
                root = this.useProxies ? state.copy : state.copy = shallowCopy(state.draft);
            }
            var onAssign = this.onAssign;

            var finalizeProperty = function finalizeProperty(prop, value, parent) {
                // Only `root` can be a draft in here.
                var inDraft = state && parent === root;
                if (isDraftable(value)) {
                    // Skip unchanged properties in draft objects.
                    if (inDraft && is(value, state.base[prop])) return;

                    // Find proxies within new objects. Frozen objects are already finalized.
                    if (!isDraft(value)) {
                        if (!Object.isFrozen(value)) each(value, finalizeProperty);
                        if (onAssign && inDraft) onAssign(state, prop, value);
                        return;
                    }

                    // prettier-ignore
                    parent[prop] =
                    // Patches are never generated for assigned properties.
                    patches && parent === root && !(state && state.assigned[prop]) ? _this2.finalize(value, path.concat(prop), patches, inversePatches) : _this2.finalize(value);

                    if (onAssign && inDraft) onAssign(state, prop, parent[prop]);
                    return;
                }
                // Call `onAssign` for primitive values.
                if (onAssign && inDraft && !is(value, state.base[prop])) {
                    onAssign(state, prop, value);
                }
            };
            each(root, finalizeProperty);
            return root;
        }
    }]);
    return Immer;
}();

var immer = new Immer();

/**
 * The `produce` function takes a value and a "recipe function" (whose
 * return value often depends on the base state). The recipe function is
 * free to mutate its first argument however it wants. All mutations are
 * only ever applied to a __copy__ of the base state.
 *
 * Pass only a function to create a "curried producer" which relieves you
 * from passing the recipe function every time.
 *
 * Only plain objects and arrays are made mutable. All other objects are
 * considered uncopyable.
 *
 * Note: This function is __bound__ to its `Immer` instance.
 *
 * @param {any} base - the initial state
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the initial state if nothing was modified
 */
var produce = immer.produce;
/**
 * Pass true to automatically freeze all copies created by Immer.
 *
 * By default, auto-freezing is disabled in production.
 */
var setAutoFreeze = function setAutoFreeze(value) {
  return immer.setAutoFreeze(value);
};

/**
 * Pass true to use the ES2015 `Proxy` class when creating drafts, which is
 * always faster than using ES5 proxies.
 *
 * By default, feature detection is used, so calling this is rarely necessary.
 */
var setUseProxies = function setUseProxies(value) {
  return immer.setUseProxies(value);
};

/**
 * Apply an array of Immer patches to the first argument.
 *
 * This function is a producer, which means copy-on-write is in effect.
 */
var applyPatches$1 = produce(applyPatches);


/* harmony default export */ __webpack_exports__["a"] = (produce);
//# sourceMappingURL=immer.module.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(253)))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionInfo = function ActionInfo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
  );
};
ActionInfo = (0, _pure2.default)(ActionInfo);
ActionInfo.displayName = 'ActionInfo';
ActionInfo.muiName = 'SvgIcon';

exports.default = ActionInfo;

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_error_boundary__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_error_boundary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_error_boundary__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var ErrorFallback = function ErrorFallback(_ref) {
    var error = _ref.error;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'react-error' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Something went wrong'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            error.message
        )
    );
};

var ErrorBoundary = function ErrorBoundary(_ref2) {
    var children = _ref2.children;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_error_boundary__["ErrorBoundary"],
        {
            FallbackComponent: ErrorFallback
        },
        children
    );
};

var _default = ErrorBoundary;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ErrorFallback, 'ErrorFallback', '/opt/atlassian/pipelines/agent/build/client/app/components/common/ErrorBoundary.jsx');
    reactHotLoader.register(ErrorBoundary, 'ErrorBoundary', '/opt/atlassian/pipelines/agent/build/client/app/components/common/ErrorBoundary.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/common/ErrorBoundary.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(795),
    baseKeys = __webpack_require__(2057),
    isArrayLike = __webpack_require__(193);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlockWrapper_scss__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlockWrapper_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BlockWrapper_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var BlockWrapper = function BlockWrapper(_ref) {
    var title = _ref.title,
        children = _ref.children;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'block-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'block-title' },
            title
        ),
        children
    );
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BlockWrapper, 'BlockWrapper', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/BlockWrapper.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function VesselAutoComplete(_ref) {
    var selectValue = _ref.selectValue,
        _ref$customValue = _ref.customValue,
        customValue = _ref$customValue === undefined ? '' : _ref$customValue,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$textFieldStyle = _ref.textFieldStyle,
        textFieldStyle = _ref$textFieldStyle === undefined ? {} : _ref$textFieldStyle,
        _ref$underlineStyle = _ref.underlineStyle,
        underlineStyle = _ref$underlineStyle === undefined ? {} : _ref$underlineStyle,
        _ref$floatingLabelSty = _ref.floatingLabelStyle,
        floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
        _ref$hintText = _ref.hintText,
        hintText = _ref$hintText === undefined ? '' : _ref$hintText,
        _ref$menuStyle = _ref.menuStyle,
        menuStyle = _ref$menuStyle === undefined ? {} : _ref$menuStyle,
        _ref$popoverProps = _ref.popoverProps,
        popoverProps = _ref$popoverProps === undefined ? {} : _ref$popoverProps,
        _ref$inputStyle = _ref.inputStyle,
        inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
        _ref$field = _ref.field,
        field = _ref$field === undefined ? '' : _ref$field,
        _ref$handleChangeCust = _ref.handleChangeCustomValue,
        handleChangeCustomValue = _ref$handleChangeCust === undefined ? function () {} : _ref$handleChangeCust,
        _ref$shouldClearCusto = _ref.shouldClearCustomValue,
        shouldClearCustomValue = _ref$shouldClearCusto === undefined ? false : _ref$shouldClearCusto,
        _ref$fullWidth = _ref.fullWidth,
        fullWidth = _ref$fullWidth === undefined ? true : _ref$fullWidth,
        _ref$id = _ref.id,
        id = _ref$id === undefined ? '' : _ref$id,
        _ref$dataSourceConfig = _ref.dataSourceConfig,
        dataSourceConfig = _ref$dataSourceConfig === undefined ? {
        withName: true,
        withImo: false,
        withBlt: false
    } : _ref$dataSourceConfig;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(customValue),
        _useState2 = _slicedToArray(_useState, 2),
        vesselValue = _useState2[0],
        setVesselValue = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        vessels = _useState4[0],
        setVessels = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState6 = _slicedToArray(_useState5, 2),
        preventFirstSearch = _useState6[0],
        setPreventFirstSearch = _useState6[1];

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__["a" /* default */])(vesselValue, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setVesselValue('');
    }, [shouldClearCustomValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].findVessel(debouncedSearchValue, true, false).then(function (result) {
            var withName = dataSourceConfig.withName,
                withImo = dataSourceConfig.withImo,
                withBlt = dataSourceConfig.withBlt;

            var _vessels = (result.data.data || []).map(function (_v) {
                return _extends({}, _v, {
                    compoundName: '' + (withName ? _v.name : '') + (withImo ? ' (' + _v.imoNumber + ')' : '') + (withBlt ? ' (' + _v.blt + ')' : '')
                });
            });
            setVessels(_vessels);
        });
    }, [debouncedSearchValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setVesselValue(customValue);
    }, [customValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPreventFirstSearch(false);
    }, []);

    var chooseVessel = function chooseVessel(selectedValue, index) {
        if (index < 0) {
            return;
        }
        selectValue(selectedValue);
        handleChangeCustomValue(vesselValue);
    };

    var changeVesselValue = function changeVesselValue(value) {
        setVesselValue(value);
        handleChangeCustomValue('');
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
        name: 'vessel',
        id: id,
        value: vesselValue,
        searchText: vesselValue,
        dataSource: vessels,
        dataSourceConfig: { text: field || 'compoundName', value: 'item' },
        hintText: hintText === null ? null : 'Vessel name',
        onUpdateInput: function onUpdateInput(val) {
            return changeVesselValue(val);
        },
        onNewRequest: function onNewRequest(val, index) {
            return chooseVessel(val, index);
        },
        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
        textFieldStyle: _extends({ fontSize: '13px' }, textFieldStyle),
        style: style,
        underlineStyle: _extends({}, underlineStyle),
        floatingLabelStyle: _extends({}, floatingLabelStyle),
        fullWidth: fullWidth || !style.width,
        listStyle: { overflow: 'auto', maxHeight: '300px' },
        inputStyle: _extends({}, inputStyle),
        popoverProps: _extends({
            canAutoPosition: true
        }, popoverProps),
        menuStyle: _extends({}, menuStyle)
    });
}

var _default = VesselAutoComplete;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselAutoComplete, 'VesselAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/common/VesselAutoComplete.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/common/VesselAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(291);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function BasicInput(_ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        _ref$floatingLabelSty = _ref.floatingLabelStyle,
        floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$underlineStyle = _ref.underlineStyle,
        underlineStyle = _ref$underlineStyle === undefined ? {} : _ref$underlineStyle,
        name = _ref.name,
        type = _ref.type,
        _ref$onBlur = _ref.onBlur,
        onBlur = _ref$onBlur === undefined ? function () {} : _ref$onBlur,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder,
        _ref$onFocus = _ref.onFocus,
        onFocus = _ref$onFocus === undefined ? function () {} : _ref$onFocus;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
        name: name + Object(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])(),
        value: value || '',
        onChange: onChange,
        floatingLabelStyle: floatingLabelStyle,
        style: _extends({ width: '100%' }, style),
        underlineStyle: underlineStyle,
        type: type,
        onBlur: onBlur,
        disabled: disabled,
        placeholder: placeholder,
        onFocus: onFocus
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(BasicInput);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BasicInput, 'BasicInput', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Basic/BasicInput.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Basic/BasicInput.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(109);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(37);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(37);
var aFunction = __webpack_require__(76);
var SPECIES = __webpack_require__(59)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(440);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1257);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1268);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(647);
var enumBugKeys = __webpack_require__(449);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export prepareGetParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function prepareGetParams(data) {
    if (!Object.keys(data).length) {
        return '';
    }

    return '?' + Object.keys(data).map(function (k) {
        return k + '=' + encodeURIComponent(typeof data[k] === 'string' ? data[k] : JSON.stringify(data[k]));
    }).join('&');
}

var api = {
    call: function call(url) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
        var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        var apiUrl = '/api/' + 'v1/' + url;
        var axiosConf = _extends({
            url: type === 'get' ? '' + apiUrl + prepareGetParams(data) : apiUrl,
            method: type
        }, config);

        if (type !== 'get') {
            axiosConf.data = data;
        }

        return __WEBPACK_IMPORTED_MODULE_0_axios___default()(axiosConf).then(function (result) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(result, 'data', result);
        }).catch(function (error) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data', error);
        });
    },
    callV2: function callV2(url) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
        var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        var apiUrl = '/api/v2/' + url;
        var axiosConf = _extends({
            url: type === 'get' ? '' + apiUrl + prepareGetParams(data) : apiUrl,
            method: type
        }, config);

        if (type !== 'get') {
            axiosConf.data = data;
        }

        return __WEBPACK_IMPORTED_MODULE_0_axios___default()(axiosConf).then(function (result) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(result, 'data', result);
        }).catch(function (error) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(error, 'response.data', error);
        });
    }
};

var _default = api;
/* harmony default export */ __webpack_exports__["a"] = (_default);

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(prepareGetParams, 'prepareGetParams', '/opt/atlassian/pipelines/agent/build/client/app/services/base.js');
    reactHotLoader.register(api, 'api', '/opt/atlassian/pipelines/agent/build/client/app/services/base.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/services/base.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(316);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["k"] = saveToStaging;
/* harmony export (immutable) */ __webpack_exports__["j"] = saveToProduction;
/* harmony export (immutable) */ __webpack_exports__["c"] = postGazetters;
/* harmony export (immutable) */ __webpack_exports__["h"] = saveGazetters;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadGazetteerIndex;
/* harmony export (immutable) */ __webpack_exports__["f"] = saveGazetteerIndex;
/* harmony export (immutable) */ __webpack_exports__["a"] = loadGazetteer;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveGazetteer;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeGazetteerDuplicates;
/* harmony export (immutable) */ __webpack_exports__["l"] = syncFeaturesFromDb;
/* harmony export (immutable) */ __webpack_exports__["i"] = saveGazettersNew;
/* harmony export (immutable) */ __webpack_exports__["g"] = saveGazetterPartially;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var gazetteerService = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: 'https://gazetteers.run.shipnext.com',
    auth: {
        username: 'admin',
        password: '7ErdM[~SbGt$+.2!'
    }
});

function saveToStaging() {
    return gazetteerService.post('/snapshot');
}

function saveToProduction() {
    return gazetteerService.post('/deploy');
}

function postGazetters(text) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: 'https://gazetteers.run.shipnext.com/annotate',
        data: _extends({ text: text }, options)
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response;
    });
}

function saveGazetters(gazetters) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/gazetters',
        data: gazetters,
        withCredentials: true
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response;
    });
}

function loadGazetteerIndex() {
    return gazetteerService.get('/def');
}

function saveGazetteerIndex(version, content) {
    return gazetteerService.put('/def', content, {
        params: {
            version: version
        }
    });
}

function loadGazetteer(filename, type) {
    return gazetteerService.get('/lst/' + filename);
}

function saveGazetteer(filename, version, content) {
    return gazetteerService.put('/lst/' + filename, content, {
        headers: {
            'Content-Type': 'text/plain'
        },
        params: {
            version: version
        }
    });
}

function removeGazetteerDuplicates(filename) {
    return gazetteerService.post('/lst/removeDuplicates/' + filename, undefined);
}

function syncFeaturesFromDb() {
    return gazetteerService.post('/syncFeatures', undefined);
}

function saveGazettersNew(gazetters) {
    return gazetteerService.patch('/lst', gazetters, {
        withCredentials: true
    });
}

/**
 * 
 * @param {string} gazetterName 
 * @param {GazetteerOperation[]} values 
 * @returns 
 */
function saveGazetterPartially(gazetterName, values, version) {
    return gazetteerService.patch('/lst/' + gazetterName, values, {
        withCredentials: true,
        params: {
            version: version
        }
    });
}

/**
 * Array of gazetteer operation objects that define changes to be made to gazetteers.
 * Each operation object has a status field that determines the type of operation.
 * 
 * @typedef {Object} GazetteerOperation
 * @property {"new"|"replace"|"remove"|"renameFeature"} status - The type of operation to perform
 * @property {string} value - The new value or target value for the operation
 * @property {string} [oldValue] - The old value being replaced (required for "replace" and "renameFeature" operations)
 * @property {Object|null} [lastFeatures] - The last known features object (used for "new" and "replace" operations)

 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(gazetteerService, 'gazetteerService', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(saveToStaging, 'saveToStaging', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(saveToProduction, 'saveToProduction', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(postGazetters, 'postGazetters', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(saveGazetters, 'saveGazetters', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(loadGazetteerIndex, 'loadGazetteerIndex', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(saveGazetteerIndex, 'saveGazetteerIndex', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(loadGazetteer, 'loadGazetteer', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(saveGazetteer, 'saveGazetteer', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(removeGazetteerDuplicates, 'removeGazetteerDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(syncFeaturesFromDb, 'syncFeaturesFromDb', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(saveGazettersNew, 'saveGazettersNew', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    reactHotLoader.register(saveGazetterPartially, 'saveGazetterPartially', '/opt/atlassian/pipelines/agent/build/client/app/services/gazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(326);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(478);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 264 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(193),
    isObjectLike = __webpack_require__(135);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1730);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1731);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultUtils = undefined;
exports.dateTimeFormat = dateTimeFormat;
exports.getYear = getYear;
exports.setYear = setYear;
exports.addDays = addDays;
exports.addMonths = addMonths;
exports.addYears = addYears;
exports.cloneDate = cloneDate;
exports.cloneAsDate = cloneAsDate;
exports.getDaysInMonth = getDaysInMonth;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getWeekArray = getWeekArray;
exports.localizedWeekday = localizedWeekday;
exports.formatIso = formatIso;
exports.isEqualDate = isEqualDate;
exports.isBeforeDate = isBeforeDate;
exports.isAfterDate = isAfterDate;
exports.isBetweenDates = isBetweenDates;
exports.monthDiff = monthDiff;
exports.yearDiff = yearDiff;

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function dateTimeFormat(locale, options) {
   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;

  this.format = function (date) {
    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    } else if (options.year === 'numeric' && options.month === 'long') {
      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
    } else if (options.weekday === 'narrow') {
      return dayAbbreviation[date.getDay()];
    } else if (options.year === 'numeric') {
      return date.getFullYear().toString();
    } else if (options.day === 'numeric') {
      return date.getDate();
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
    }
  };
}

function getYear(d) {
  return d.getFullYear();
}

function setYear(d, year) {
  var newDate = cloneDate(d);
  newDate.setFullYear(year);
  return newDate;
}

function addDays(d, days) {
  var newDate = cloneDate(d);
  newDate.setDate(d.getDate() + days);
  return newDate;
}

function addMonths(d, months) {
  var newDate = cloneDate(d);
  newDate.setMonth(d.getMonth() + months);
  return newDate;
}

function addYears(d, years) {
  var newDate = cloneDate(d);
  newDate.setFullYear(d.getFullYear() + years);
  return newDate;
}

function cloneDate(d) {
  return new Date(d.getTime());
}

function cloneAsDate(d) {
  var clonedDate = cloneDate(d);
  clonedDate.setHours(0, 0, 0, 0);
  return clonedDate;
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

function getFirstDayOfWeek() {
  var now = new Date();
  return new Date(now.setDate(now.getDate() - now.getDay()));
}

function getWeekArray(d, firstDayOfWeek) {
  var dayArray = [];
  var daysInMonth = getDaysInMonth(d);
  var weekArray = [];
  var week = [];

  for (var i = 1; i <= daysInMonth; i++) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
  }

  var addWeek = function addWeek(week) {
    var emptyDays = 7 - week.length;
    for (var _i = 0; _i < emptyDays; ++_i) {
      week[weekArray.length ? 'push' : 'unshift'](null);
    }
    weekArray.push(week);
  };

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      addWeek(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      addWeek(week);
    }
  });

  return weekArray;
}

function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
  var firstDayDate = getFirstDayOfWeek();

  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
}

// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
function formatIso(date) {
  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
}

function isEqualDate(d1, d2) {
  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

function isBeforeDate(d1, d2) {
  var date1 = cloneAsDate(d1);
  var date2 = cloneAsDate(d2);

  return date1.getTime() < date2.getTime();
}

function isAfterDate(d1, d2) {
  var date1 = cloneAsDate(d1);
  var date2 = cloneAsDate(d2);

  return date1.getTime() > date2.getTime();
}

function isBetweenDates(dateToCheck, startDate, endDate) {
  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
}

function monthDiff(d1, d2) {
  var m = void 0;
  m = (d1.getFullYear() - d2.getFullYear()) * 12;
  m += d1.getMonth();
  m -= d2.getMonth();
  return m;
}

function yearDiff(d1, d2) {
  return ~~(monthDiff(d1, d2) / 12);
}

var defaultUtils = exports.defaultUtils = {
  getYear: getYear,
  setYear: setYear,
  addDays: addDays,
  addMonths: addMonths,
  addYears: addYears,
  getFirstDayOfMonth: getFirstDayOfMonth,
  getWeekArray: getWeekArray,
  monthDiff: monthDiff
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.DropDownMenu = undefined;

var _DropDownMenu2 = __webpack_require__(1817);

var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);

var _MenuItem2 = __webpack_require__(504);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DropDownMenu = _DropDownMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _DropDownMenu3.default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;

var _RadioButton2 = __webpack_require__(776);

var _RadioButton3 = _interopRequireDefault(_RadioButton2);

var _RadioButtonGroup2 = __webpack_require__(779);

var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RadioButton = _RadioButton3.default;
exports.RadioButtonGroup = _RadioButtonGroup3.default;
exports.default = _RadioButton3.default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addHours = addHours;
exports.addMinutes = addMinutes;
exports.addSeconds = addSeconds;
exports.formatTime = formatTime;
exports.rad2deg = rad2deg;
exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
exports.isInner = isInner;
function addHours(d, hours) {
  var newDate = clone(d);
  newDate.setHours(d.getHours() + hours);
  return newDate;
}

function addMinutes(d, minutes) {
  var newDate = clone(d);
  newDate.setMinutes(d.getMinutes() + minutes);
  return newDate;
}

function addSeconds(d, seconds) {
  var newDate = clone(d);
  newDate.setSeconds(d.getMinutes() + seconds);
  return newDate;
}

function clone(d) {
  return new Date(d.getTime());
}

/**
 * @param date [Date] A Date object.
 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
 *
 * @return String A string representing the formatted time.
 */
function formatTime(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!date) return '';
  var hours = date.getHours();
  var mins = date.getMinutes().toString();

  if (format === 'ampm') {
    var isAM = hours < 12;
    hours = hours % 12;
    var additional = isAM ? ' am' : ' pm';
    hours = (hours || 12).toString();

    if (mins.length < 2) mins = '0' + mins;

    if (pedantic) {
      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
      if (hours === '12' && mins === '00') {
        return additional === ' pm' ? '12 noon' : '12 midnight';
      }
    }

    return hours + (mins === '00' ? '' : ':' + mins) + additional;
  }

  hours = hours.toString();

  if (hours.length < 2) hours = '0' + hours;
  if (mins.length < 2) mins = '0' + mins;

  return hours + ':' + mins;
}

function rad2deg(rad) {
  return rad * 57.29577951308232;
}

function getTouchEventOffsetValues(event) {
  var el = event.target;
  var boundingRect = el.getBoundingClientRect();

  return {
    offsetX: event.clientX - boundingRect.left,
    offsetY: event.clientY - boundingRect.top
  };
}

function isInner(props) {
  if (props.type !== 'hour') {
    return false;
  }
  return props.value < 1 || props.value > 12;
}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Title;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_alert_warning__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_alert_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_alert_warning__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




/**
 * @param {{ orderNumber: number, warnings: any, text: string }} param0 
 */
function Title(_ref) {
    var orderNumber = _ref.orderNumber,
        warnings = _ref.warnings,
        text = _ref.text;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'title title_sticky',
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '35px',
                    fontWeight: 'bold'
                }
            },
            text,
            ' ',
            orderNumber,
            warnings && warnings.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_alert_warning___default.a, { color: 'orangered' }) : null
        ),
        warnings && warnings.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                    display: 'flex',
                    color: 'orangered',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '5px',
                    marginTop: '5px'
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Warnings'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ol',
                null,
                warnings.map(function (w) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        null,
                        w.message
                    );
                })
            )
        ) : null
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Title, 'Title', '/opt/atlassian/pipelines/agent/build/client/app/components/common/RequestTitle.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getLetter */
/* unused harmony export updateLetter */
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getLetter(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_31" /* GET_LETTER */].REQUEST,
        id: id
    };
}

function updateLetter(id, letter, typeLetter) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_130" /* UPDATE_LETTER */].REQUEST,
        id: id,
        letter: letter,
        typeLetter: typeLetter
    };
}

function removeLetter() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_89" /* REMOVE_LETTER */]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getLetter, 'getLetter', '/opt/atlassian/pipelines/agent/build/client/app/actions/letters.js');
    reactHotLoader.register(updateLetter, 'updateLetter', '/opt/atlassian/pipelines/agent/build/client/app/actions/letters.js');
    reactHotLoader.register(removeLetter, 'removeLetter', '/opt/atlassian/pipelines/agent/build/client/app/actions/letters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = postRequestVessel;
/* unused harmony export postRequestVesselResponse */
/* harmony export (immutable) */ __webpack_exports__["b"] = getRequestsVessel;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateRequestVessel;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteRequestVessel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postRequestVessel(vesselRequest) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].REQUEST,
        vesselRequest: vesselRequest
    };
}

function postRequestVesselResponse(response) {
    if (response.status) {
        return {
            type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].SUCCESS,
            vesselRequest: response.vesselRequest,
            message: response.message
        };
    }

    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].FAILURE,
        vesselRequest: response.vesselRequest,
        error: response.error
    };
}

function getRequestsVessel(filter) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_61" /* GET_VESSEL_REQUESTS */].REQUEST,
        filter: filter
    };
}

function updateRequestVessel(vesselRequestId, userId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_145" /* UPDATE_VESSEL_REQUEST */].REQUEST,
        vesselRequestId: vesselRequestId,
        userId: userId
    };
}

function deleteRequestVessel(vesselId, requestId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_0" /* DELETE_VESSEL_REQUEST */].REQUEST,
        vesselId: vesselId,
        requestId: requestId
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestVessel, 'postRequestVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/request.js');
    reactHotLoader.register(postRequestVesselResponse, 'postRequestVesselResponse', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/request.js');
    reactHotLoader.register(getRequestsVessel, 'getRequestsVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/request.js');
    reactHotLoader.register(updateRequestVessel, 'updateRequestVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/request.js');
    reactHotLoader.register(deleteRequestVessel, 'deleteRequestVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/request.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFileDownload = function FileFileDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
  );
};
FileFileDownload = (0, _pure2.default)(FileFileDownload);
FileFileDownload.displayName = 'FileFileDownload';
FileFileDownload.muiName = 'SvgIcon';

exports.default = FileFileDownload;

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FailedTwinsContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = FailedToSent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FailedToSentTable__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(277);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    max-width: unset;\n'], ['\n    max-width: unset;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    height: 76vh;\n'], ['\n    display: flex;\n    flex-direction: column;\n    height: 76vh;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    flex: 1;\n    overflow-y: auto;\n    min-height: 0;\n'], ['\n    flex: 1;\n    overflow-y: auto;\n    min-height: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    color: indianred;\n    text-align: center;\n    margin: 0 0 16px 0;\n    flex-shrink: 0;\n'], ['\n    color: indianred;\n    text-align: center;\n    margin: 0 0 16px 0;\n    flex-shrink: 0;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    padding: 16px 36px 0 0;\n    display: flex;\n    flex-direction: row-reverse;\n    flex-shrink: 0;\n'], ['\n    padding: 16px 36px 0 0;\n    display: flex;\n    flex-direction: row-reverse;\n    flex-shrink: 0;\n']);

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable function-paren-newline */





var FailedTwinsContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({
    failedTwins: /** @type {FailedTwin[]} */[],
    setFailedTwins: /** @type {React.Dispatch<React.SetStateAction<(FailedTwin & UpdateStatuses & Selections)[]>>} */function setFailedTwins() {}
});

/**
 * @param {{
 *  open: boolean
 *  failedTwinsList: (FailedTwin & UpdateStatuses)[],
 *  handleToggleDialog: () => void,
 *  disabled: boolean,
 *  sendRequest: Function,
 * }} param0 
 * @returns 
 */
function FailedToSent(_ref) {
    var _this = this;

    var open = _ref.open,
        failedTwinsList = _ref.failedTwinsList,
        handleToggleDialog = _ref.handleToggleDialog,
        disabled = _ref.disabled,
        sendRequest = _ref.sendRequest;

    /**
     * @param {(FailedTwin & UpdateStatuses)[]} twins
     * @returns {(FailedTwin & UpdateStatuses)[]}
     */
    var getSortedTwins = function getSortedTwins(twins) {
        if (!twins) return [];
        return twins.slice().sort(function (a, b) {
            return !!a.isByPayloadHash - !!b.isByPayloadHash;
        });
    };

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
        return getSortedTwins(failedTwinsList);
    }),
        _useState2 = _slicedToArray(_useState, 2),
        failedTwins = _useState2[0],
        setFailedTwins = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setFailedTwins(getSortedTwins(failedTwinsList));
    }, [failedTwinsList]);

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["g" /* FlatButton */], {
        label: 'Close',
        primary: true,
        onClick: handleToggleDialog
    })];

    var calculateAmount = function calculateAmount(amount) {
        if (amount >= 10) return '9+';
        return amount;
    };

    var sendOne = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index) {
            var result;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setFailedTwins(function (prevFailedTwins) {
                                var updatedTwins = [].concat(_toConsumableArray(prevFailedTwins));
                                updatedTwins[index].status = 'pending';
                                return updatedTwins;
                            });
                            _context.next = 3;
                            return sendRequest(failedTwins[index]);

                        case 3:
                            result = _context.sent;


                            setFailedTwins(function (prevFailedTwins) {
                                var updatedTwins = [].concat(_toConsumableArray(prevFailedTwins));
                                updatedTwins[index].status = result[0].status;
                                updatedTwins[index].message = result[0].message;
                                updatedTwins[index].refNos = Array.from(new Set(result.map(function (r) {
                                    return r.refNo;
                                })));
                                return updatedTwins;
                            });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function sendOne(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var sendAll = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, index;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 3;
                            _iterator = Object.keys(failedTwinsList)[Symbol.iterator]();

                        case 5:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context2.next = 12;
                                break;
                            }

                            index = _step.value;
                            _context2.next = 9;
                            return sendOne(index);

                        case 9:
                            _iteratorNormalCompletion = true;
                            _context2.next = 5;
                            break;

                        case 12:
                            _context2.next = 18;
                            break;

                        case 14:
                            _context2.prev = 14;
                            _context2.t0 = _context2['catch'](3);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 18:
                            _context2.prev = 18;
                            _context2.prev = 19;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 21:
                            _context2.prev = 21;

                            if (!_didIteratorError) {
                                _context2.next = 24;
                                break;
                            }

                            throw _iteratorError;

                        case 24:
                            return _context2.finish(21);

                        case 25:
                            return _context2.finish(18);

                        case 26:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this, [[3, 14, 18, 26], [19,, 21, 25]]);
        }));

        return function sendAll() {
            return _ref3.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledDialog,
            {
                open: open,
                actions: actions,
                onRequestClose: handleToggleDialog,
                contentStyle: {
                    maxWidth: 'unset'
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                DialogContent,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledCaution,
                    null,
                    'Current request data will be applied to other emails, proceed with caution.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    ScrollableContent,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        FailedTwinsContext.Provider,
                        { value: { failedTwins: failedTwins, setFailedTwins: setFailedTwins } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FailedToSentTable__["a" /* default */], { sendRequest: sendOne })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledButtonCont,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], { label: 'send all', primary: true, onClick: sendAll })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
            labelStyle: { fontSize: '10px' },
            style: { height: '25px' },
            buttonStyle: { height: '25px', lineHeight: '25px' },
            label: 'Failed twins (' + calculateAmount(failedTwinsList.length || 0) + ')',
            primary: true,
            onClick: handleToggleDialog,
            disabled: disabled || !failedTwinsList.length
        })
    );
}

/**
 * @typedef {Object} FailedTwin
 * @property {string} _id
 * @property {string} subject
 * @property {{ _id: string, email: string }} owner
 * @property {IContext} context
 * @property {string} realUserEmail
 * @property {string[]} [refNos]
 * @property {boolean} [isByPayloadHash]
 */

/**
 * @typedef {Object} UpdateStatuses
 * @property {'success' | 'error' | 'pending'} status
 * @property {string} message
 */

var StyledDialog = Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_material_ui__["f" /* Dialog */])(_templateObject);

var DialogContent = __WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */].div(_templateObject2);

var ScrollableContent = __WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */].div(_templateObject3);

var StyledCaution = __WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */].h2(_templateObject4);

var StyledButtonCont = __WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* default */].div(_templateObject5);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FailedTwinsContext, 'FailedTwinsContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSent.jsx');
    reactHotLoader.register(FailedToSent, 'FailedToSent', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSent.jsx');
    reactHotLoader.register(StyledDialog, 'StyledDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSent.jsx');
    reactHotLoader.register(DialogContent, 'DialogContent', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSent.jsx');
    reactHotLoader.register(ScrollableContent, 'ScrollableContent', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSent.jsx');
    reactHotLoader.register(StyledCaution, 'StyledCaution', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSent.jsx');
    reactHotLoader.register(StyledButtonCont, 'StyledButtonCont', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSent.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetConsumer */
/* unused harmony export StyleSheetContext */
/* unused harmony export StyleSheetManager */
/* unused harmony export ThemeConsumer */
/* unused harmony export ThemeContext */
/* unused harmony export ThemeProvider */
/* unused harmony export __PRIVATE__ */
/* unused harmony export createGlobalStyle */
/* unused harmony export css */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dt; });
/* unused harmony export isStyledComponent */
/* unused harmony export keyframes */
/* unused harmony export styled */
/* unused harmony export useTheme */
/* unused harmony export version */
/* unused harmony export withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shallowequal__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_unitless__ = __webpack_require__(1901);
var f="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",m="active",y="data-styled-version",v="6.1.13",g="/*!sc*/\n",S="undefined"!=typeof window&&"HTMLElement"in window,w=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),b={},E=/invalid hook call/i,N=new Set,P=function(t,n){if(false){var o=n?' with the id of "'.concat(n,'"'):"",s="The component ".concat(t).concat(o," has been created dynamically.\n")+"You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",i=console.error;try{var a=!0;console.error=function(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];E.test(t)?(a=!1,N.delete(s)):i.apply(void 0,e([t],n,!1))},r(),a&&!N.has(s)&&(console.warn(s),N.add(s))}catch(e){E.test(e.message)&&N.delete(s)}finally{console.error=i}}},_=Object.freeze([]),C=Object.freeze({});function I(e,t,n){return void 0===n&&(n=C),e.theme!==n.theme&&e.theme||t||n.theme}var A=new Set(["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","use","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"]),O=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,D=/(^-|-$)/g;function R(e){return e.replace(O,"-").replace(D,"")}var T=/(a)(d)/gi,k=52,j=function(e){return String.fromCharCode(e+(e>25?39:97))};function x(e){var t,n="";for(t=Math.abs(e);t>k;t=t/k|0)n=j(t%k)+n;return(j(t%k)+n).replace(T,"$1-$2")}var V,F=5381,M=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},z=function(e){return M(F,e)};function $(e){return x(z(e)>>>0)}function B(e){return"production"!=="production"&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function L(e){return"string"==typeof e&&("production"==="production"||e.charAt(0)===e.charAt(0).toLowerCase())}var G="function"==typeof Symbol&&Symbol.for,Y=G?Symbol.for("react.memo"):60115,W=G?Symbol.for("react.forward_ref"):60112,q={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},H={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},U={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},J=((V={})[W]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},V[Y]=U,V);function X(e){return("type"in(t=e)&&t.type.$$typeof)===Y?U:"$$typeof"in e?J[e.$$typeof]:q;var t}var Z=Object.defineProperty,K=Object.getOwnPropertyNames,Q=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,ne=Object.prototype;function oe(e,t,n){if("string"!=typeof t){if(ne){var o=te(t);o&&o!==ne&&oe(e,o,n)}var r=K(t);Q&&(r=r.concat(Q(t)));for(var s=X(e),i=X(t),a=0;a<r.length;++a){var c=r[a];if(!(c in H||n&&n[c]||i&&c in i||s&&c in s)){var l=ee(t,c);try{Z(e,c,l)}catch(e){}}}}return e}function re(e){return"function"==typeof e}function se(e){return"object"==typeof e&&"styledComponentId"in e}function ie(e,t){return e&&t?"".concat(e," ").concat(t):e||t||""}function ae(e,t){if(0===e.length)return"";for(var n=e[0],o=1;o<e.length;o++)n+=t?t+e[o]:e[o];return n}function ce(e){return null!==e&&"object"==typeof e&&e.constructor.name===Object.name&&!("props"in e&&e.$$typeof)}function le(e,t,n){if(void 0===n&&(n=!1),!n&&!ce(e)&&!Array.isArray(e))return t;if(Array.isArray(t))for(var o=0;o<t.length;o++)e[o]=le(e[o],t[o]);else if(ce(t))for(var o in t)e[o]=le(e[o],t[o]);return e}function ue(e,t){Object.defineProperty(e,"toString",{value:t})}var pe= false?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",18:"ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"}:{};function de(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];for(var n=e[0],o=[],r=1,s=e.length;r<s;r+=1)o.push(e[r]);return o.forEach(function(e){n=n.replace(/%[a-z]/,e)}),n}function he(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];return true?new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t," for more information.").concat(n.length>0?" Args: ".concat(n.join(", ")):"")):new Error(de.apply(void 0,e([pe[t]],n,!1)).trim())}var fe=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}return e.prototype.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},e.prototype.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,o=n.length,r=o;e>=r;)if((r<<=1)<0)throw he(16,"".concat(e));this.groupSizes=new Uint32Array(r),this.groupSizes.set(n),this.length=r;for(var s=o;s<r;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=(s=0,t.length);s<a;s++)this.tag.insertRule(i,t[s])&&(this.groupSizes[e]++,i++)},e.prototype.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),o=n+t;this.groupSizes[e]=0;for(var r=n;r<o;r++)this.tag.deleteRule(n)}},e.prototype.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],o=this.indexOfGroup(e),r=o+n,s=o;s<r;s++)t+="".concat(this.tag.getRule(s)).concat(g);return t},e}(),me=1<<30,ye=new Map,ve=new Map,ge=1,Se=function(e){if(ye.has(e))return ye.get(e);for(;ve.has(ge);)ge++;var t=ge++;if(false)throw he(16,"".concat(t));return ye.set(e,t),ve.set(t,e),t},we=function(e,t){ge=t+1,ye.set(e,t),ve.set(t,e)},be="style[".concat(f,"][").concat(y,'="').concat(v,'"]'),Ee=new RegExp("^".concat(f,'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),Ne=function(e,t,n){for(var o,r=n.split(","),s=0,i=r.length;s<i;s++)(o=r[s])&&e.registerName(t,o)},Pe=function(e,t){for(var n,o=(null!==(n=t.textContent)&&void 0!==n?n:"").split(g),r=[],s=0,i=o.length;s<i;s++){var a=o[s].trim();if(a){var c=a.match(Ee);if(c){var l=0|parseInt(c[1],10),u=c[2];0!==l&&(we(u,l),Ne(e,u,c[3]),e.getTag().insertRules(l,r)),r.length=0}else r.push(a)}}},_e=function(e){for(var t=document.querySelectorAll(be),n=0,o=t.length;n<o;n++){var r=t[n];r&&r.getAttribute(f)!==m&&(Pe(e,r),r.parentNode&&r.parentNode.removeChild(r))}};function Ce(){return true?__webpack_require__.nc:null}var Ie=function(e){var t=document.head,n=e||t,o=document.createElement("style"),r=function(e){var t=Array.from(e.querySelectorAll("style[".concat(f,"]")));return t[t.length-1]}(n),s=void 0!==r?r.nextSibling:null;o.setAttribute(f,m),o.setAttribute(y,v);var i=Ce();return i&&o.setAttribute("nonce",i),n.insertBefore(o,s),o},Ae=function(){function e(e){this.element=Ie(e),this.element.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,o=t.length;n<o;n++){var r=t[n];if(r.ownerNode===e)return r}throw he(17)}(this.element),this.length=0}return e.prototype.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},e.prototype.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},e.prototype.getRule=function(e){var t=this.sheet.cssRules[e];return t&&t.cssText?t.cssText:""},e}(),Oe=function(){function e(e){this.element=Ie(e),this.nodes=this.element.childNodes,this.length=0}return e.prototype.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t);return this.element.insertBefore(n,this.nodes[e]||null),this.length++,!0}return!1},e.prototype.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},e.prototype.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),De=function(){function e(e){this.rules=[],this.length=0}return e.prototype.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},e.prototype.deleteRule=function(e){this.rules.splice(e,1),this.length--},e.prototype.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),Re=S,Te={isServer:!S,useCSSOMInjection:!w},ke=function(){function e(e,n,o){void 0===e&&(e=C),void 0===n&&(n={});var r=this;this.options=Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},Te),e),this.gs=n,this.names=new Map(o),this.server=!!e.isServer,!this.server&&S&&Re&&(Re=!1,_e(this)),ue(this,function(){return function(e){for(var t=e.getTag(),n=t.length,o="",r=function(n){var r=function(e){return ve.get(e)}(n);if(void 0===r)return"continue";var s=e.names.get(r),i=t.getGroup(n);if(void 0===s||!s.size||0===i.length)return"continue";var a="".concat(f,".g").concat(n,'[id="').concat(r,'"]'),c="";void 0!==s&&s.forEach(function(e){e.length>0&&(c+="".concat(e,","))}),o+="".concat(i).concat(a,'{content:"').concat(c,'"}').concat(g)},s=0;s<n;s++)r(s);return o}(r)})}return e.registerId=function(e){return Se(e)},e.prototype.rehydrate=function(){!this.server&&S&&_e(this)},e.prototype.reconstructWithOptions=function(n,o){return void 0===o&&(o=!0),new e(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},this.options),n),this.gs,o&&this.names||void 0)},e.prototype.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},e.prototype.getTag=function(){return this.tag||(this.tag=(e=function(e){var t=e.useCSSOMInjection,n=e.target;return e.isServer?new De(n):t?new Ae(n):new Oe(n)}(this.options),new fe(e)));var e},e.prototype.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},e.prototype.registerName=function(e,t){if(Se(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},e.prototype.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(Se(e),n)},e.prototype.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},e.prototype.clearRules=function(e){this.getTag().clearGroup(Se(e)),this.clearNames(e)},e.prototype.clearTag=function(){this.tag=void 0},e}(),je=/&/g,xe=/^\s*\/\/.*$/gm;function Ve(e,t){return e.map(function(e){return"rule"===e.type&&(e.value="".concat(t," ").concat(e.value),e.value=e.value.replaceAll(",",",".concat(t," ")),e.props=e.props.map(function(e){return"".concat(t," ").concat(e)})),Array.isArray(e.children)&&"@keyframes"!==e.type&&(e.children=Ve(e.children,t)),e})}function Fe(e){var t,n,o,r=void 0===e?C:e,s=r.options,i=void 0===s?C:s,a=r.plugins,c=void 0===a?_:a,l=function(e,o,r){return r.startsWith(n)&&r.endsWith(n)&&r.replaceAll(n,"").length>0?".".concat(t):e},u=c.slice();u.push(function(e){e.type===__WEBPACK_IMPORTED_MODULE_4_stylis__["a" /* RULESET */]&&e.value.includes("&")&&(e.props[0]=e.props[0].replace(je,n).replace(o,l))}),i.prefix&&u.push(__WEBPACK_IMPORTED_MODULE_4_stylis__["d" /* prefixer */]),u.push(__WEBPACK_IMPORTED_MODULE_4_stylis__["g" /* stringify */]);var p=function(e,r,s,a){void 0===r&&(r=""),void 0===s&&(s=""),void 0===a&&(a="&"),t=a,n=r,o=new RegExp("\\".concat(n,"\\b"),"g");var c=e.replace(xe,""),l=__WEBPACK_IMPORTED_MODULE_4_stylis__["b" /* compile */](s||r?"".concat(s," ").concat(r," { ").concat(c," }"):c);i.namespace&&(l=Ve(l,i.namespace));var p=[];return __WEBPACK_IMPORTED_MODULE_4_stylis__["f" /* serialize */](l,__WEBPACK_IMPORTED_MODULE_4_stylis__["c" /* middleware */](u.concat(__WEBPACK_IMPORTED_MODULE_4_stylis__["e" /* rulesheet */](function(e){return p.push(e)})))),p};return p.hash=c.length?c.reduce(function(e,t){return t.name||he(15),M(e,t.name)},F).toString():"",p}var Me=new ke,ze=Fe(),$e=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext({shouldForwardProp:void 0,styleSheet:Me,stylis:ze}),Be=$e.Consumer,Le=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(void 0);function Ge(){return Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])($e)}function Ye(e){var t=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(e.stylisPlugins),n=t[0],r=t[1],c=Ge().styleSheet,l=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t},[e.disableCSSOMInjection,e.sheet,e.target,c]),u=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function(){return Fe({options:{namespace:e.namespace,prefix:e.enableVendorPrefixes},plugins:n})},[e.enableVendorPrefixes,e.namespace,n]);Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){__WEBPACK_IMPORTED_MODULE_3_shallowequal___default()(n,e.stylisPlugins)||r(e.stylisPlugins)},[e.stylisPlugins]);var d=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function(){return{shouldForwardProp:e.shouldForwardProp,styleSheet:l,stylis:u}},[e.shouldForwardProp,l,u]);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement($e.Provider,{value:d},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Le.Provider,{value:u},e.children))}var We=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=ze);var o=n.name+t.hash;e.hasNameForId(n.id,o)||e.insertRules(n.id,o,t(n.rules,o,"@keyframes"))},this.name=e,this.id="sc-keyframes-".concat(e),this.rules=t,ue(this,function(){throw he(12,String(n.name))})}return e.prototype.getName=function(e){return void 0===e&&(e=ze),this.name+e.hash},e}(),qe=function(e){return e>="A"&&e<="Z"};function He(e){for(var t="",n=0;n<e.length;n++){var o=e[n];if(1===n&&"-"===o&&"-"===e[0])return e;qe(o)?t+="-"+o.toLowerCase():t+=o}return t.startsWith("ms-")?"-"+t:t}var Ue=function(e){return null==e||!1===e||""===e},Je=function(t){var n,o,r=[];for(var s in t){var i=t[s];t.hasOwnProperty(s)&&!Ue(i)&&(Array.isArray(i)&&i.isCss||re(i)?r.push("".concat(He(s),":"),i,";"):ce(i)?r.push.apply(r,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])(["".concat(s," {")],Je(i),!1),["}"],!1)):r.push("".concat(He(s),": ").concat((n=s,null==(o=i)||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||n in __WEBPACK_IMPORTED_MODULE_5__emotion_unitless__["a" /* default */]||n.startsWith("--")?String(o).trim():"".concat(o,"px")),";")))}return r};function Xe(e,t,n,o){if(Ue(e))return[];if(se(e))return[".".concat(e.styledComponentId)];if(re(e)){if(!re(s=e)||s.prototype&&s.prototype.isReactComponent||!t)return[e];var r=e(t);return"production"==="production"||"object"!=typeof r||Array.isArray(r)||r instanceof We||ce(r)||null===r||console.error("".concat(B(e)," is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")),Xe(r,t,n,o)}var s;return e instanceof We?n?(e.inject(n,o),[e.getName(o)]):[e]:ce(e)?Je(e):Array.isArray(e)?Array.prototype.concat.apply(_,e.map(function(e){return Xe(e,t,n,o)})):[e.toString()]}function Ze(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(re(n)&&!se(n))return!1}return!0}var Ke=z(v),Qe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"==="production"&&(void 0===n||n.isStatic)&&Ze(e),this.componentId=t,this.baseHash=M(Ke,t),this.baseStyle=n,ke.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var o=this.baseStyle?this.baseStyle.generateAndInjectStyles(e,t,n):"";if(this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(this.componentId,this.staticRulesId))o=ie(o,this.staticRulesId);else{var r=ae(Xe(this.rules,e,t,n)),s=x(M(this.baseHash,r)>>>0);if(!t.hasNameForId(this.componentId,s)){var i=n(r,".".concat(s),void 0,this.componentId);t.insertRules(this.componentId,s,i)}o=ie(o,s),this.staticRulesId=s}else{for(var a=M(this.baseHash,n.hash),c="",l=0;l<this.rules.length;l++){var u=this.rules[l];if("string"==typeof u)c+=u,"production"!=="production"&&(a=M(a,u));else if(u){var p=ae(Xe(u,e,t,n));a=M(a,p+l),c+=p}}if(c){var d=x(a>>>0);t.hasNameForId(this.componentId,d)||t.insertRules(this.componentId,d,n(c,".".concat(d),void 0,this.componentId)),o=ie(o,d)}}return o},e}(),et=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(void 0),tt=et.Consumer;function nt(){var e=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(et);if(!e)throw he(18);return e}function ot(e){var n=__WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(et),r=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function(){return function(e,n){if(!e)throw he(14);if(re(e)){var o=e(n);if(false)throw he(7);return o}if(Array.isArray(e)||"object"!=typeof e)throw he(8);return n?Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},n),e):e}(e.theme,n)},[e.theme,n]);return e.children?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(et.Provider,{value:r},e.children):null}var rt={},st=new Set;function it(e,r,s){var i=se(e),a=e,c=!L(e),p=r.attrs,d=void 0===p?_:p,h=r.componentId,f=void 0===h?function(e,t){var n="string"!=typeof e?"sc":R(e);rt[n]=(rt[n]||0)+1;var o="".concat(n,"-").concat($(v+n+rt[n]));return t?"".concat(t,"-").concat(o):o}(r.displayName,r.parentComponentId):h,m=r.displayName,y=void 0===m?function(e){return L(e)?"styled.".concat(e):"Styled(".concat(B(e),")")}(e):m,g=r.displayName&&r.componentId?"".concat(R(r.displayName),"-").concat(r.componentId):r.componentId||f,S=i&&a.attrs?a.attrs.concat(d).filter(Boolean):d,w=r.shouldForwardProp;if(i&&a.shouldForwardProp){var b=a.shouldForwardProp;if(r.shouldForwardProp){var E=r.shouldForwardProp;w=function(e,t){return b(e,t)&&E(e,t)}}else w=b}var N=new Qe(s,g,i?a.componentStyle:void 0);function O(e,r){return function(e,r,s){var i=e.attrs,a=e.componentStyle,c=e.defaultProps,p=e.foldedComponentIds,d=e.styledComponentId,h=e.target,f=__WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(et),m=Ge(),y=e.shouldForwardProp||m.shouldForwardProp;"production"!=="production"&&Object(__WEBPACK_IMPORTED_MODULE_2_react__["useDebugValue"])(d);var v=I(r,f,c)||C,g=function(e,n,o){for(var r,s=Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},n),{className:void 0,theme:o}),i=0;i<e.length;i+=1){var a=re(r=e[i])?r(s):r;for(var c in a)s[c]="className"===c?ie(s[c],a[c]):"style"===c?Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},s[c]),a[c]):a[c]}return n.className&&(s.className=ie(s.className,n.className)),s}(i,r,v),S=g.as||h,w={};for(var b in g)void 0===g[b]||"$"===b[0]||"as"===b||"theme"===b&&g.theme===v||("forwardedAs"===b?w.as=g.forwardedAs:y&&!y(b,S)||(w[b]=g[b],y||"development"!=="production"||Object(__WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__["a" /* default */])(b)||st.has(b)||!A.has(S)||(st.add(b),console.warn('styled-components: it looks like an unknown prop "'.concat(b,'" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));var E=function(e,t){var n=Ge(),o=e.generateAndInjectStyles(t,n.styleSheet,n.stylis);return"production"!=="production"&&Object(__WEBPACK_IMPORTED_MODULE_2_react__["useDebugValue"])(o),o}(a,g);"production"!=="production"&&e.warnTooManyClasses&&e.warnTooManyClasses(E);var N=ie(p,d);return E&&(N+=" "+E),g.className&&(N+=" "+g.className),w[L(S)&&!A.has(S)?"class":"className"]=N,w.ref=s,Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(S,w)}(D,e,r)}O.displayName=y;var D=__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(O);return D.attrs=S,D.componentStyle=N,D.displayName=y,D.shouldForwardProp=w,D.foldedComponentIds=i?ie(a.foldedComponentIds,a.styledComponentId):"",D.styledComponentId=g,D.target=i?a.target:e,Object.defineProperty(D,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(e){this._foldedDefaultProps=i?function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];for(var o=0,r=t;o<r.length;o++)le(e,r[o],!0);return e}({},a.defaultProps,e):e}}),"production"!=="production"&&(P(y,g),D.warnTooManyClasses=function(e,t){var n={},o=!1;return function(r){if(!o&&(n[r]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'.concat(t,'"'):"";console.warn("Over ".concat(200," classes were generated for component ").concat(e).concat(s,".\n")+"Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),o=!0,n={}}}}(y,g)),ue(D,function(){return".".concat(D.styledComponentId)}),c&&oe(D,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0}),D}function at(e,t){for(var n=[e[0]],o=0,r=t.length;o<r;o+=1)n.push(t[o],e[o+1]);return n}var ct=function(e){return Object.assign(e,{isCss:!0})};function lt(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];if(re(t)||ce(t))return ct(Xe(at(_,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([t],n,!0))));var r=t;return 0===n.length&&1===r.length&&"string"==typeof r[0]?Xe(r):ct(Xe(at(r,n)))}function ut(n,o,r){if(void 0===r&&(r=C),!o)throw he(1,o);var s=function(t){for(var s=[],i=1;i<arguments.length;i++)s[i-1]=arguments[i];return n(o,r,lt.apply(void 0,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([t],s,!1)))};return s.attrs=function(e){return ut(n,o,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},r),{attrs:Array.prototype.concat(r.attrs,e).filter(Boolean)}))},s.withConfig=function(e){return ut(n,o,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},r),e))},s}var pt=function(e){return ut(it,e)},dt=pt;A.forEach(function(e){dt[e]=pt(e)});var ht=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=Ze(e),ke.registerId(this.componentId+1)}return e.prototype.createStyles=function(e,t,n,o){var r=o(ae(Xe(this.rules,t,n,o)),""),s=this.componentId+e;n.insertRules(s,s,r)},e.prototype.removeStyles=function(e,t){t.clearRules(this.componentId+e)},e.prototype.renderStyles=function(e,t,n,o){e>2&&ke.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,o)},e}();function ft(n){for(var r=[],s=1;s<arguments.length;s++)r[s-1]=arguments[s];var i=lt.apply(void 0,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([n],r,!1)),a="sc-global-".concat($(JSON.stringify(i))),c=new ht(i,a);"production"!=="production"&&P(a);var l=function(e){var t=Ge(),n=__WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(et),r=__WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(t.styleSheet.allocateGSInstance(a)).current;return"production"!=="production"&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(e.children)&&console.warn("The global style component ".concat(a," was given child JSX. createGlobalStyle does not render children.")),"production"!=="production"&&i.some(function(e){return"string"==typeof e&&-1!==e.indexOf("@import")})&&console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."),t.styleSheet.server&&u(r,e,t.styleSheet,n,t.stylis),__WEBPACK_IMPORTED_MODULE_2_react___default.a.useLayoutEffect(function(){if(!t.styleSheet.server)return u(r,e,t.styleSheet,n,t.stylis),function(){return c.removeStyles(r,t.styleSheet)}},[r,e,t.styleSheet,n,t.stylis]),null};function u(e,n,o,r,s){if(c.isStatic)c.renderStyles(e,b,o,s);else{var i=Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},n),{theme:I(n,r,l.defaultProps)});c.renderStyles(e,i,o,s)}}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.memo(l)}function mt(t){for(var n=[],o=1;o<arguments.length;o++)n[o-1]=arguments[o];"production"!=="production"&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");var r=ae(lt.apply(void 0,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spreadArray */])([t],n,!1))),s=$(r);return new We(s,r)}function yt(e){var n=__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function(n,r){var s=I(n,__WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(et),e.defaultProps);return"production"!=="production"&&void 0===s&&console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "'.concat(B(e),'"')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(e,Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},n,{theme:s,ref:r}))});return n.displayName="WithTheme(".concat(B(e),")"),oe(n,e)}var vt=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Ce(),o=ae([n&&'nonce="'.concat(n,'"'),"".concat(f,'="true"'),"".concat(y,'="').concat(v,'"')].filter(Boolean)," ");return"<style ".concat(o,">").concat(t,"</style>")},this.getStyleTags=function(){if(e.sealed)throw he(2);return e._emitSheetCSS()},this.getStyleElement=function(){var n;if(e.sealed)throw he(2);var r=e.instance.toString();if(!r)return[];var s=((n={})[f]="",n[y]=v,n.dangerouslySetInnerHTML={__html:r},n),i=Ce();return i&&(s.nonce=i),[__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("style",Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({},s,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new ke({isServer:!0}),this.sealed=!1}return e.prototype.collectStyles=function(e){if(this.sealed)throw he(2);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Ye,{sheet:this.instance},e)},e.prototype.interleaveWithNodeStream=function(e){throw he(3)},e}(),gt={StyleSheet:ke,mainSheet:Me};"production"!=="production"&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");var St="__sc-".concat(f,"__");"production"!=="production"&&"test"!=="production"&&"undefined"!=typeof window&&(window[St]||(window[St]=0),1===window[St]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window[St]+=1);
//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(253)))

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__retryer__ = __webpack_require__(236);
/* unused harmony reexport CancelledError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queryCache__ = __webpack_require__(803);
/* unused harmony reexport QueryCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queryClient__ = __webpack_require__(1904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryClient", function() { return __WEBPACK_IMPORTED_MODULE_2__queryClient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queryObserver__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryObserver", function() { return __WEBPACK_IMPORTED_MODULE_3__queryObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__queriesObserver__ = __webpack_require__(807);
/* unused harmony reexport QueriesObserver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__infiniteQueryObserver__ = __webpack_require__(808);
/* unused harmony reexport InfiniteQueryObserver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutationCache__ = __webpack_require__(804);
/* unused harmony reexport MutationCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutationObserver__ = __webpack_require__(809);
/* unused harmony reexport MutationObserver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger__ = __webpack_require__(363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setLogger", function() { return __WEBPACK_IMPORTED_MODULE_8__logger__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notifyManager__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "notifyManager", function() { return __WEBPACK_IMPORTED_MODULE_9__notifyManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__focusManager__ = __webpack_require__(362);
/* unused harmony reexport focusManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__onlineManager__ = __webpack_require__(523);
/* unused harmony reexport onlineManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(70);
/* unused harmony reexport hashQueryKey */
/* unused harmony reexport isError */
/* unused harmony reexport isCancelledError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hydration__ = __webpack_require__(1905);
/* unused harmony reexport dehydrate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return __WEBPACK_IMPORTED_MODULE_13__hydration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__types__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14__types__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, "QueryClientProvider", function() { return __WEBPACK_IMPORTED_MODULE_14__types__["QueryClientProvider"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14__types__, "useMutation")) __webpack_require__.d(__webpack_exports__, "useMutation", function() { return __WEBPACK_IMPORTED_MODULE_14__types__["useMutation"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14__types__, "useQuery")) __webpack_require__.d(__webpack_exports__, "useQuery", function() { return __WEBPACK_IMPORTED_MODULE_14__types__["useQuery"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_14__types__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, "useQueryClient", function() { return __WEBPACK_IMPORTED_MODULE_14__types__["useQueryClient"]; });














 // Types



/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LIQUID_TYPES_BY_PURPOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return types; });
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

var types = ['BULK', 'BULKTANK', 'CAR', 'CONT', 'LIVESTOCK', 'MPP', 'PASS', 'PASSCAR', 'REEFER', 'TANK'];

var LIQUID_TYPES_BY_PURPOSE = ['BULKTANK', 'TANK'];


;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(types, 'types', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselTypes.js');
  reactHotLoader.register(LIQUID_TYPES_BY_PURPOSE, 'LIQUID_TYPES_BY_PURPOSE', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselTypes.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__specialtyConfig__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__specialtyConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__specialtyConfig__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var WITHOUT_SPECIALTY = '__WITHOUT_SPECIALTY__';

function TypeBySpecialty(_ref) {
    var _ref$getError = _ref.getError,
        getError = _ref$getError === undefined ? undefined : _ref$getError,
        changeField = _ref.changeField,
        typeBySpecialty = _ref.typeBySpecialty,
        typeByPurpose = _ref.typeByPurpose,
        _ref$modifiedFields = _ref.modifiedFields,
        modifiedFields = _ref$modifiedFields === undefined ? undefined : _ref$modifiedFields,
        _ref$underStyle = _ref.underStyle,
        underStyle = _ref$underStyle === undefined ? {} : _ref$underStyle,
        _ref$fromTcOrder = _ref.fromTcOrder,
        fromTcOrder = _ref$fromTcOrder === undefined ? false : _ref$fromTcOrder,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$withoutSpecialty = _ref.withoutSpecialtyEnabled,
        withoutSpecialtyEnabled = _ref$withoutSpecialty === undefined ? false : _ref$withoutSpecialty;

    var prevTypeByPurpose = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(typeByPurpose);

    // reset typeBySpecialty when typeByPurpose changes
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var hadPurpose = prevTypeByPurpose.current;
        var purposeChanged = hadPurpose && hadPurpose !== typeByPurpose;

        if (purposeChanged && typeBySpecialty) {
            changeField([{ field: 'typeBySpecialty', value: null }]);
        }

        prevTypeByPurpose.current = typeByPurpose;
    }, [typeByPurpose, typeBySpecialty, changeField]);

    var handleChange = function handleChange(e, index, value) {
        var fields = [{ field: 'typeBySpecialty', value: value }];

        // clear linerMeter fields when selecting ro-ro/ro-lo types
        var isRoRoType = /ro-(ro|lo)/i.test(value);
        if (isRoRoType) {
            if (fromTcOrder) {
                fields.push({ field: 'linerMeterMin', value: null }, { field: 'linerMeterMax', value: null });
            } else {
                fields.push({ field: 'linerMeter', value: null });
            }
        }

        changeField(fields);
    };

    var specialtyOptions = typeByPurpose ? __WEBPACK_IMPORTED_MODULE_3__specialtyConfig___default.a[typeByPurpose.toLowerCase()] || [] : [];

    var showUnderline = modifiedFields && modifiedFields.includes('typeBySpecialty');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
        {
            value: typeBySpecialty,
            disabled: !typeByPurpose,
            onChange: handleChange,
            maxHeight: 200,
            name: 'typeBySpecialty',
            floatingLabelText: 'Type By Specialty',
            errorText: getError ? getError.typeBySpecialty : '',
            fullWidth: true,
            autoWidth: true,
            underlineStyle: showUnderline ? underStyle : null,
            style: style
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, { value: '', primaryText: '' }),
        withoutSpecialtyEnabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
            value: WITHOUT_SPECIALTY,
            primaryText: 'Without Specialty',
            innerDivStyle: { fontWeight: 'bold' }
        }) : null,
        specialtyOptions.map(function (specialType, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                key: 'specialType_' + i,
                value: specialType,
                primaryText: specialType
            });
        })
    );
}

var _default = TypeBySpecialty;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(WITHOUT_SPECIALTY, 'WITHOUT_SPECIALTY', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeBySpecialty.jsx');
    reactHotLoader.register(TypeBySpecialty, 'TypeBySpecialty', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeBySpecialty.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeBySpecialty.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TANK_COATING_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEATING_MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IGS_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return iceClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ventilationNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return imoAppNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return imoClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ventilationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fitted; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var TANK_COATING_TYPES = ['Epoxy', 'Hempel Hempadur Phenolic Epoxy', 'Jotun Primastic Unversal Alu Red Toned', 'Jotun Universal Alu Turquoise', 'Korepox / Eh 2350', 'Marine Line', 'Marine Line 784 (Advanced Polymer Coating)', 'Phenolic Epoxy', 'Stainless Steel', 'Zinc'];

var HEATING_MEDIUM = ['Water', 'Steam', 'Thermal Oil'];

var IGS_TYPES = ['Flue gas', 'Inert gas (IG) generator', 'Nitrogen'];

var iceClassNames = [null, 'fitted', '1AS', '1A', '1B', '1C', '1D'];
var ventilationNames = ['Electrical', 'Natural'];
var imoAppNames = ['Appendix a', 'Appendix b', 'Appendix c', 'Appendix a, b', 'Appendix a, c', 'Appendix b, c', 'Appendix a, b, c'];
var imoClassNames = ['1', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '2', '2.1', '2.2', '2.3', '3', '4', '4.1', '4.2', '4.3', '5', '5.1', '5.2', '6', '6.1', '6.2', '7', '8', '9'];

var ventilationOptions = [{ value: 'electrical', label: 'Electrical' }, { value: 'natural', label: 'Natural' }];

var fitted = {
    co2Fitted: 'co2Fitted',
    a60BulkheadFitted: 'a60BulkheadFitted',
    newPanama: 'newPanama',
    cementHolesFitted: 'cementHolesFitted',
    referPlugFitted: 'referPlugFitted',
    itfFitted: 'itfFitted',
    lakesFitted: 'lakesFitted',
    strengthenHeavy: 'strengthenHeavy',
    logsFitted: 'logsFitted',
    aussieFitted: 'aussieFitted',
    ventilation: 'ventilation',
    ventilationFitted: 'ventilationFitted',
    imoFitted: 'imoFitted',
    bwts: 'bwts',
    coiled: 'coiled',
    containerFitted: 'containerFitted',
    carFitted: 'carFitted',
    rampway: 'rampway',
    grainFitted: 'grainFitted',
    cargoTankDryer: 'cargoTankDryer',
    cargoCoolingSystem: 'cargoCoolingSystem',
    crudeOilWashing: 'crudeOilWashing',
    rcttms: 'rcttms',
    rctpms: 'rctpms',
    bowChainStopper: 'bowChainStopper',
    ngs: 'ngs',
    vrs: 'vrs',
    bowThruster: 'bowThruster',
    stemThruster: 'stemThruster',
    scrubberFitted: 'scrubberFitted',
    igsFitted: 'igs.fitted',
    boxShaped: 'boxShaped',
    openHatch: 'openHatch'
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TANK_COATING_TYPES, 'TANK_COATING_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(HEATING_MEDIUM, 'HEATING_MEDIUM', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(IGS_TYPES, 'IGS_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(iceClassNames, 'iceClassNames', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(ventilationNames, 'ventilationNames', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(imoAppNames, 'imoAppNames', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(imoClassNames, 'imoClassNames', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(ventilationOptions, 'ventilationOptions', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    reactHotLoader.register(fitted, 'fitted', '/opt/atlassian/pipelines/agent/build/client/app/constants/vesselRequirements.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentClear = function ContentClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
  );
};
ContentClear = (0, _pure2.default)(ContentClear);
ContentClear.displayName = 'ContentClear';
ContentClear.muiName = 'SvgIcon';

exports.default = ContentClear;

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






function PortsAutoComplete(_ref) {
    var _this = this;

    var selectValue = _ref.selectValue,
        _ref$customValue = _ref.customValue,
        customValue = _ref$customValue === undefined ? '' : _ref$customValue,
        _ref$floatingLabelTex = _ref.floatingLabelText,
        floatingLabelText = _ref$floatingLabelTex === undefined ? '' : _ref$floatingLabelTex,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$textFieldStyle = _ref.textFieldStyle,
        textFieldStyle = _ref$textFieldStyle === undefined ? {} : _ref$textFieldStyle,
        _ref$underlineStyle = _ref.underlineStyle,
        underlineStyle = _ref$underlineStyle === undefined ? {} : _ref$underlineStyle,
        _ref$floatingLabelSty = _ref.floatingLabelStyle,
        floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
        hintText = _ref.hintText,
        _ref$menuStyle = _ref.menuStyle,
        menuStyle = _ref$menuStyle === undefined ? {} : _ref$menuStyle,
        _ref$popoverProps = _ref.popoverProps,
        popoverProps = _ref$popoverProps === undefined ? {} : _ref$popoverProps,
        _ref$inputStyle = _ref.inputStyle,
        inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
        _ref$field = _ref.field,
        field = _ref$field === undefined ? '' : _ref$field,
        _ref$handleChangeCust = _ref.handleChangeCustomValue,
        handleChangeCustomValue = _ref$handleChangeCust === undefined ? function (v) {} : _ref$handleChangeCust,
        _ref$withAreas = _ref.withAreas,
        withAreas = _ref$withAreas === undefined ? false : _ref$withAreas,
        _ref$mainRegions = _ref.mainRegions,
        mainRegions = _ref$mainRegions === undefined ? false : _ref$mainRegions,
        onlyAreas = _ref.onlyAreas,
        _ref$shouldClearCusto = _ref.shouldClearCustomValue,
        shouldClearCustomValue = _ref$shouldClearCusto === undefined ? false : _ref$shouldClearCusto,
        _ref$isInBalticIndex = _ref.isInBalticIndex,
        isInBalticIndex = _ref$isInBalticIndex === undefined ? false : _ref$isInBalticIndex,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(customValue),
        _useState2 = _slicedToArray(_useState, 2),
        portValue = _useState2[0],
        setPortValue = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        ports = _useState4[0],
        setPorts = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState6 = _slicedToArray(_useState5, 2),
        preventFirstSearch = _useState6[0],
        setPreventFirstSearch = _useState6[1];

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__["a" /* default */])(portValue, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPortValue('');
    }, [shouldClearCustomValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch) return;

        if (!debouncedSearchValue || debouncedSearchValue.length < 2) {
            handleChangeCustomValue({});
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].findPortAdmin({
            name: debouncedSearchValue, withAreas: withAreas, onlyAreas: onlyAreas, mainRegions: mainRegions, isInBalticIndex: isInBalticIndex
        }).then(function (result) {
            if (mainRegions) {
                setPorts(result.data.data.filter(function (p) {
                    return p.mainRegion;
                }));
            } else {
                setPorts(result.data.data);
            }
        });
    }, [debouncedSearchValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPreventFirstSearch(false);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPortValue(customValue);
    }, [customValue]);

    var choosePort = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(selectedValue, index) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(index < 0)) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            _context.next = 4;
                            return selectValue(selectedValue);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function choosePort(_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }();

    var changePortValue = function changePortValue(val) {
        setPortValue(val);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
        name: name || 'port',
        value: portValue,
        searchText: portValue,
        dataSource: ports,
        dataSourceConfig: { text: field || 'name', value: 'item' },
        hintText: hintText === null ? null : hintText || 'Port',
        floatingLabelText: floatingLabelText,
        onUpdateInput: function onUpdateInput(val) {
            return changePortValue(val);
        },
        onNewRequest: function onNewRequest(val, index) {
            return choosePort(val, index);
        },
        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
        textFieldStyle: _extends({ fontSize: '13px', height: '72px' }, textFieldStyle),
        style: style,
        underlineStyle: _extends({}, underlineStyle),
        floatingLabelStyle: _extends({}, floatingLabelStyle),
        fullWidth: !style.width,
        listStyle: { overflow: 'auto', maxHeight: '300px' },
        inputStyle: _extends({}, inputStyle),
        popoverProps: _extends({
            canAutoPosition: true
        }, popoverProps),
        menuStyle: _extends({}, menuStyle),
        disabled: disabled
    });
}

var _default = PortsAutoComplete;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsAutoComplete, 'PortsAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/common/PortsAutoComplete.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/common/PortsAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDone = function ActionDone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
  );
};
ActionDone = (0, _pure2.default)(ActionDone);
ActionDone.displayName = 'ActionDone';
ActionDone.muiName = 'SvgIcon';

exports.default = ActionDone;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAdd = function ContentAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
  );
};
ContentAdd = (0, _pure2.default)(ContentAdd);
ContentAdd.displayName = 'ContentAdd';
ContentAdd.muiName = 'SvgIcon';

exports.default = ContentAdd;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionInfoOutline = function ActionInfoOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z' })
  );
};
ActionInfoOutline = (0, _pure2.default)(ActionInfoOutline);
ActionInfoOutline.displayName = 'ActionInfoOutline';
ActionInfoOutline.muiName = 'SvgIcon';

exports.default = ActionInfoOutline;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);

function filterByPosition(array, position) {
	return helpers.where(array, function(v) {
		return v.position === position;
	});
}

function sortByWeight(array, reverse) {
	array.forEach(function(v, i) {
		v._tmpIndex_ = i;
		return v;
	});
	array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0._tmpIndex_ - v1._tmpIndex_ :
			v0.weight - v1.weight;
	});
	array.forEach(function(v) {
		delete v._tmpIndex_;
	});
}

/**
 * @interface ILayoutItem
 * @prop {String} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
 * @prop {Function} getPadding -  Returns an object with padding on the edges
 * @prop {Number} width - Width of item. Must be valid after update()
 * @prop {Number} height - Height of item. Must be valid after update()
 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
module.exports = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {Object} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {Object} item - the item to configure with the given options
	 * @param {Object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {Number} width - the width to fit into
	 * @param {Number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers.options.toPadding(layoutOptions.padding);
		var leftPadding = padding.left;
		var rightPadding = padding.right;
		var topPadding = padding.top;
		var bottomPadding = padding.bottom;

		var leftBoxes = filterByPosition(chart.boxes, 'left');
		var rightBoxes = filterByPosition(chart.boxes, 'right');
		var topBoxes = filterByPosition(chart.boxes, 'top');
		var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
		var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

		// Sort boxes by weight. A higher weight is further away from the chart area
		sortByWeight(leftBoxes, true);
		sortByWeight(rightBoxes, false);
		sortByWeight(topBoxes, true);
		sortByWeight(bottomBoxes, false);

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//
		// What we do to find the best sizing, we do the following
		// 1. Determine the minimum size of the chart area.
		// 2. Split the remaining width equally between each vertical axis
		// 3. Split the remaining height equally between each horizontal axis
		// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
		// 5. Adjust the sizes of each axis based on it's minimum reported size.
		// 6. Refit each axis
		// 7. Position each axis in the final location
		// 8. Tell the chart the final location of the chart area
		// 9. Tell any axes that overlay the chart area the positions of the chart area

		// Step 1
		var chartWidth = width - leftPadding - rightPadding;
		var chartHeight = height - topPadding - bottomPadding;
		var chartAreaWidth = chartWidth / 2; // min 50%
		var chartAreaHeight = chartHeight / 2; // min 50%

		// Step 2
		var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

		// Step 3
		var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

		// Step 4
		var maxChartAreaWidth = chartWidth;
		var maxChartAreaHeight = chartHeight;
		var minBoxSizes = [];

		function getMinimumBoxSize(box) {
			var minSize;
			var isHorizontal = box.isHorizontal();

			if (isHorizontal) {
				minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
				maxChartAreaHeight -= minSize.height;
			} else {
				minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
				maxChartAreaWidth -= minSize.width;
			}

			minBoxSizes.push({
				horizontal: isHorizontal,
				minSize: minSize,
				box: box,
			});
		}

		helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

		// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
		var maxHorizontalLeftPadding = 0;
		var maxHorizontalRightPadding = 0;
		var maxVerticalTopPadding = 0;
		var maxVerticalBottomPadding = 0;

		helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
			if (horizontalBox.getPadding) {
				var boxPadding = horizontalBox.getPadding();
				maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
				maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
			}
		});

		helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
			if (verticalBox.getPadding) {
				var boxPadding = verticalBox.getPadding();
				maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
				maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
			}
		});

		// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
		// be if the axes are drawn at their minimum sizes.
		// Steps 5 & 6
		var totalLeftBoxesWidth = leftPadding;
		var totalRightBoxesWidth = rightPadding;
		var totalTopBoxesHeight = topPadding;
		var totalBottomBoxesHeight = bottomPadding;

		// Function to fit a box
		function fitBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
				return minBox.box === box;
			});

			if (minBoxSize) {
				if (box.isHorizontal()) {
					var scaleMargin = {
						left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
						right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
						top: 0,
						bottom: 0
					};

					// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
					// on the margin. Sometimes they need to increase in size slightly
					box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
				} else {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight);
				}
			}
		}

		// Update, and calculate the left and right margins for the horizontal boxes
		helpers.each(leftBoxes.concat(rightBoxes), fitBox);

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		// Set the Left and Right margins for the horizontal boxes
		helpers.each(topBoxes.concat(bottomBoxes), fitBox);

		// Figure out how much margin is on the top and bottom of the vertical boxes
		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});

		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		function finalFitVerticalBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
				return minSize.box === box;
			});

			var scaleMargin = {
				left: 0,
				right: 0,
				top: totalTopBoxesHeight,
				bottom: totalBottomBoxesHeight
			};

			if (minBoxSize) {
				box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
			}
		}

		// Let the left layout know the final margin
		helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

		// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
		totalLeftBoxesWidth = leftPadding;
		totalRightBoxesWidth = rightPadding;
		totalTopBoxesHeight = topPadding;
		totalBottomBoxesHeight = bottomPadding;

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});
		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		// We may be adding some padding to account for rotated x axis labels
		var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
		totalLeftBoxesWidth += leftPaddingAddition;
		totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

		var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
		totalTopBoxesHeight += topPaddingAddition;
		totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

		// Figure out if our chart area changed. This would occur if the dataset layout label rotation
		// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
		// without calling `fit` again
		var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
		var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

		if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
			helpers.each(leftBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(rightBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(topBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			helpers.each(bottomBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			maxChartAreaHeight = newMaxChartAreaHeight;
			maxChartAreaWidth = newMaxChartAreaWidth;
		}

		// Step 7 - Position the boxes
		var left = leftPadding + leftPaddingAddition;
		var top = topPadding + topPaddingAddition;

		function placeBox(box) {
			if (box.isHorizontal()) {
				box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
				box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
				box.top = top;
				box.bottom = top + box.height;

				// Move to next point
				top = box.bottom;

			} else {

				box.left = left;
				box.right = left + box.width;
				box.top = totalTopBoxesHeight;
				box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

				// Move to next point
				left = box.right;
			}
		}

		helpers.each(leftBoxes.concat(topBoxes), placeBox);

		// Account for chart width and height
		left += maxChartAreaWidth;
		top += maxChartAreaHeight;

		helpers.each(rightBoxes, placeBox);
		helpers.each(bottomBoxes, placeBox);

		// Step 8
		chart.chartArea = {
			left: totalLeftBoxesWidth,
			top: totalTopBoxesHeight,
			right: totalLeftBoxesWidth + maxChartAreaWidth,
			bottom: totalTopBoxesHeight + maxChartAreaHeight
		};

		// Step 9
		helpers.each(chartAreaBoxes, function(box) {
			box.left = chart.chartArea.left;
			box.top = chart.chartArea.top;
			box.right = chart.chartArea.right;
			box.bottom = chart.chartArea.bottom;

			box.update(maxChartAreaWidth, maxChartAreaHeight);
		});
	}
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);
var helpers = __webpack_require__(45);
var Ticks = __webpack_require__(289);

defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// line height
		lineHeight: 1.2,

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: Ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getLineValue(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

function computeTextSize(context, tick, font) {
	return helpers.isArray(tick) ?
		helpers.longestText(context, font, tick) :
		context.measureText(tick).width;
}

function parseFontOptions(options) {
	var valueOrDefault = helpers.valueOrDefault;
	var globalDefaults = defaults.global;
	var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
	var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
	var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

	return {
		size: size,
		style: style,
		family: family,
		font: helpers.fontString(size, style, family)
	};
}

function parseLineHeight(options) {
	return helpers.options.toLineHeight(
		helpers.valueOrDefault(options.lineHeight, 1.2),
		helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
}

module.exports = Element.extend({
	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	mergeTicksOptions: function() {
		var ticks = this.options.ticks;
		if (ticks.minor === false) {
			ticks.minor = {
				display: false
			};
		}
		if (ticks.major === false) {
			ticks.major = {
				display: false
			};
		}
		for (var key in ticks) {
			if (key !== 'major' && key !== 'minor') {
				if (typeof ticks.minor[key] === 'undefined') {
					ticks.minor[key] = ticks[key];
				}
				if (typeof ticks.major[key] === 'undefined') {
					ticks.major[key] = ticks[key];
				}
			}
		}
	},
	beforeUpdate: function() {
		helpers.callback(this.options.beforeUpdate, [this]);
	},

	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var i, ilen, labels, label, ticks, tick;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);
		me.longestTextCache = me.longestTextCache || {};

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		me.afterBuildTicks();

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = labels.length; i < ilen; ++i) {
			label = labels[i];
			tick = ticks[i];
			if (!tick) {
				ticks.push(tick = {
					label: label,
					major: false
				});
			} else {
				tick.label = label;
			}
		}

		me._ticks = ticks;

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();
		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: function() {
		helpers.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers.noop,
	afterDataLimits: function() {
		helpers.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers.noop,
	afterBuildTicks: function() {
		helpers.callback(this.options.afterBuildTicks, [this]);
	},

	beforeTickToLabelConversion: function() {
		helpers.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var context = me.ctx;
		var tickOpts = me.options.ticks;
		var labels = labelsFromTicks(me._ticks);

		// Get the width of each grid by calculating the difference
		// between x offsets between 0 and 1.
		var tickFont = parseFontOptions(tickOpts);
		context.font = tickFont.font;

		var labelRotation = tickOpts.minRotation || 0;

		if (labels.length && me.options.display && me.isHorizontal()) {
			var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
			var labelWidth = originalLabelWidth;
			var cosRotation, sinRotation;

			// Allow 3 pixels x2 padding either side for label readability
			var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

			// Max label rotation can be set or default to 90 - also act as a loop counter
			while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
				var angleRadians = helpers.toRadians(labelRotation);
				cosRotation = Math.cos(angleRadians);
				sinRotation = Math.sin(angleRadians);

				if (sinRotation * originalLabelWidth > me.maxHeight) {
					// go back one step
					labelRotation--;
					break;
				}

				labelRotation++;
				labelWidth = cosRotation * originalLabelWidth;
			}
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var labels = labelsFromTicks(me._ticks);

		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = opts.display;
		var isHorizontal = me.isHorizontal();

		var tickFont = parseFontOptions(tickOpts);
		var tickMarkLength = opts.gridLines.tickMarkLength;

		// Width
		if (isHorizontal) {
			// subtract the margins to line up with the chartArea if we are a full width scale
			minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
		} else {
			minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
		}

		// height
		if (isHorizontal) {
			minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
		} else {
			minSize.height = me.maxHeight; // fill all the height
		}

		// Are we showing a title for the scale?
		if (scaleLabelOpts.display && display) {
			var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
			var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
			var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

			if (isHorizontal) {
				minSize.height += deltaHeight;
			} else {
				minSize.width += deltaHeight;
			}
		}

		// Don't bother fitting the ticks if we are not showing them
		if (tickOpts.display && display) {
			var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
			var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
			var lineSpace = tickFont.size * 0.5;
			var tickPadding = me.options.ticks.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				me.longestLabelWidth = largestTextWidth;

				var angleRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				// TODO - improve this calculation
				var labelHeight = (sinRotation * largestTextWidth)
					+ (tickFont.size * tallestLabelHeightInLines)
					+ (lineSpace * (tallestLabelHeightInLines - 1))
					+ lineSpace; // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				me.ctx.font = tickFont.font;
				var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
				var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (me.labelRotation !== 0) {
					me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
					me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
				} else {
					me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
					me.paddingRight = lastLabelWidth / 2 + 3;
				}
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				if (tickOpts.mirror) {
					largestTextWidth = 0;
				} else {
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					largestTextWidth += tickPadding + lineSpace;
				}

				minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

				me.paddingTop = tickFont.size / 2;
				me.paddingBottom = tickFont.size / 2;
			}
		}

		me.handleMargins();

		me.width = minSize.width;
		me.height = minSize.height;
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
			me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
			me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
			me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
		}
	},

	afterFit: function() {
		helpers.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},
	isFullWidth: function() {
		return (this.options.fullWidth);
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (helpers.isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if (typeof rawValue === 'number' && !isFinite(rawValue)) {
			return NaN;
		}
		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		if (me.isHorizontal()) {
			var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
			var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var pixel = (tickWidth * index) + me.paddingLeft;

			if (offset) {
				pixel += tickWidth / 2;
			}

			var finalVal = me.left + Math.round(pixel);
			finalVal += me.isFullWidth() ? me.margins.left : 0;
			return finalVal;
		}
		var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
		return me.top + (index * (innerHeight / (me._ticks.length - 1)));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;
		if (me.isHorizontal()) {
			var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
			var valueOffset = (innerWidth * decimal) + me.paddingLeft;

			var finalVal = me.left + Math.round(valueOffset);
			finalVal += me.isFullWidth() ? me.margins.left : 0;
			return finalVal;
		}
		return me.top + (decimal * me.height);
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var skipRatio;
		var me = this;
		var isHorizontal = me.isHorizontal();
		var optionTicks = me.options.ticks.minor;
		var tickCount = ticks.length;
		var labelRotationRadians = helpers.toRadians(me.labelRotation);
		var cosRotation = Math.cos(labelRotationRadians);
		var longestRotatedLabel = me.longestLabelWidth * cosRotation;
		var result = [];
		var i, tick, shouldSkip;

		// figure out the maximum number of gridlines to show
		var maxTicks;
		if (optionTicks.maxTicksLimit) {
			maxTicks = optionTicks.maxTicksLimit;
		}

		if (isHorizontal) {
			skipRatio = false;

			if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
				skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
			}

			// if they defined a max number of optionTicks,
			// increase skipRatio until that number is met
			if (maxTicks && tickCount > maxTicks) {
				skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
			}
		}

		for (i = 0; i < tickCount; i++) {
			tick = ticks[i];

			// Since we always show the last tick,we need may need to hide the last shown one before
			shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
			if (shouldSkip && i !== tickCount - 1) {
				// leave tick in place but make sure it's not displayed (#4635)
				delete tick.label;
			}
			result.push(tick);
		}
		return result;
	},

	// Actually draw the scale on the canvas
	// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
	draw: function(chartArea) {
		var me = this;
		var options = me.options;
		if (!options.display) {
			return;
		}

		var context = me.ctx;
		var globalDefaults = defaults.global;
		var optionTicks = options.ticks.minor;
		var optionMajorTicks = options.ticks.major || optionTicks;
		var gridLines = options.gridLines;
		var scaleLabel = options.scaleLabel;

		var isRotated = me.labelRotation !== 0;
		var isHorizontal = me.isHorizontal();

		var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
		var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
		var tickFont = parseFontOptions(optionTicks);
		var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
		var majorTickFont = parseFontOptions(optionMajorTicks);

		var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

		var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
		var scaleLabelFont = parseFontOptions(scaleLabel);
		var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
		var labelRotationRadians = helpers.toRadians(me.labelRotation);

		var itemsToDraw = [];

		var axisWidth = me.options.gridLines.lineWidth;
		var xTickStart = options.position === 'right' ? me.left : me.right - axisWidth - tl;
		var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
		var yTickStart = options.position === 'bottom' ? me.top + axisWidth : me.bottom - tl - axisWidth;
		var yTickEnd = options.position === 'bottom' ? me.top + axisWidth + tl : me.bottom + axisWidth;

		helpers.each(ticks, function(tick, index) {
			// autoskipper skipped this tick (#4635)
			if (helpers.isNullOrUndef(tick.label)) {
				return;
			}

			var label = tick.label;
			var lineWidth, lineColor, borderDash, borderDashOffset;
			if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash;
				borderDashOffset = gridLines.zeroLineBorderDashOffset;
			} else {
				lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
				lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
				borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
				borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
			}

			// Common properties
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
			var textAlign = 'middle';
			var textBaseline = 'middle';
			var tickPadding = optionTicks.padding;

			if (isHorizontal) {
				var labelYOffset = tl + tickPadding;

				if (options.position === 'bottom') {
					// bottom
					textBaseline = !isRotated ? 'top' : 'middle';
					textAlign = !isRotated ? 'center' : 'right';
					labelY = me.top + labelYOffset;
				} else {
					// top
					textBaseline = !isRotated ? 'bottom' : 'middle';
					textAlign = !isRotated ? 'center' : 'left';
					labelY = me.bottom - labelYOffset;
				}

				var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
				if (xLineValue < me.left) {
					lineColor = 'rgba(0,0,0,0)';
				}
				xLineValue += helpers.aliasPixel(lineWidth);

				labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

				tx1 = tx2 = x1 = x2 = xLineValue;
				ty1 = yTickStart;
				ty2 = yTickEnd;
				y1 = chartArea.top;
				y2 = chartArea.bottom + axisWidth;
			} else {
				var isLeft = options.position === 'left';
				var labelXOffset;

				if (optionTicks.mirror) {
					textAlign = isLeft ? 'left' : 'right';
					labelXOffset = tickPadding;
				} else {
					textAlign = isLeft ? 'right' : 'left';
					labelXOffset = tl + tickPadding;
				}

				labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

				var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
				if (yLineValue < me.top) {
					lineColor = 'rgba(0,0,0,0)';
				}
				yLineValue += helpers.aliasPixel(lineWidth);

				labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

				tx1 = xTickStart;
				tx2 = xTickEnd;
				x1 = chartArea.left;
				x2 = chartArea.right + axisWidth;
				ty1 = ty2 = y1 = y2 = yLineValue;
			}

			itemsToDraw.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				labelX: labelX,
				labelY: labelY,
				glWidth: lineWidth,
				glColor: lineColor,
				glBorderDash: borderDash,
				glBorderDashOffset: borderDashOffset,
				rotation: -1 * labelRotationRadians,
				label: label,
				major: tick.major,
				textBaseline: textBaseline,
				textAlign: textAlign
			});
		});

		// Draw all of the tick labels, tick marks, and grid lines at the correct places
		helpers.each(itemsToDraw, function(itemToDraw) {
			if (gridLines.display) {
				context.save();
				context.lineWidth = itemToDraw.glWidth;
				context.strokeStyle = itemToDraw.glColor;
				if (context.setLineDash) {
					context.setLineDash(itemToDraw.glBorderDash);
					context.lineDashOffset = itemToDraw.glBorderDashOffset;
				}

				context.beginPath();

				if (gridLines.drawTicks) {
					context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
					context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
				}

				if (gridLines.drawOnChartArea) {
					context.moveTo(itemToDraw.x1, itemToDraw.y1);
					context.lineTo(itemToDraw.x2, itemToDraw.y2);
				}

				context.stroke();
				context.restore();
			}

			if (optionTicks.display) {
				// Make sure we draw text in the correct color and font
				context.save();
				context.translate(itemToDraw.labelX, itemToDraw.labelY);
				context.rotate(itemToDraw.rotation);
				context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
				context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
				context.textBaseline = itemToDraw.textBaseline;
				context.textAlign = itemToDraw.textAlign;

				var label = itemToDraw.label;
				if (helpers.isArray(label)) {
					var lineCount = label.length;
					var lineHeight = tickFont.size * 1.5;
					var y = me.isHorizontal() ? 0 : -lineHeight * (lineCount - 1) / 2;

					for (var i = 0; i < lineCount; ++i) {
						// We just make sure the multiline element is a string here..
						context.fillText('' + label[i], 0, y);
						// apply same lineSpacing as calculated @ L#320
						y += lineHeight;
					}
				} else {
					context.fillText(label, 0, 0);
				}
				context.restore();
			}
		});

		if (scaleLabel.display) {
			// Draw the scale label
			var scaleLabelX;
			var scaleLabelY;
			var rotation = 0;
			var halfLineHeight = parseLineHeight(scaleLabel) / 2;

			if (isHorizontal) {
				scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
				scaleLabelY = options.position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = options.position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + ((me.bottom - me.top) / 2);
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}

			context.save();
			context.translate(scaleLabelX, scaleLabelY);
			context.rotate(rotation);
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillStyle = scaleLabelFontColor; // render in correct colour
			context.font = scaleLabelFont.font;
			context.fillText(scaleLabel.labelString, 0, 0);
			context.restore();
		}

		if (gridLines.drawBorder) {
			// Draw the line at the edge of the axis
			context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
			context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
			var x1 = me.left;
			var x2 = me.right + axisWidth;
			var y1 = me.top;
			var y2 = me.bottom + axisWidth;

			var aliasPixel = helpers.aliasPixel(context.lineWidth);
			if (isHorizontal) {
				y1 = y2 = options.position === 'top' ? me.bottom : me.top;
				y1 += aliasPixel;
				y2 += aliasPixel;
			} else {
				x1 = x2 = options.position === 'left' ? me.right : me.left;
				x1 += aliasPixel;
				x2 += aliasPixel;
			}

			context.beginPath();
			context.moveTo(x1, y1);
			context.lineTo(x2, y2);
			context.stroke();
		}
	}
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
module.exports = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {String|Array} the label to display
		 */
		values: function(value) {
			return helpers.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {Number} the value to be formatted
		 * @param index {Number} the position of the tickValue parameter in the ticks array
		 * @param ticks {Array<Number>} the list of ticks being converted
		 * @return {String} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers.log10(Math.abs(tickValue));
					tickString = tickValue.toExponential(Math.floor(logTick) - Math.floor(logDelta));
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getIntegrators;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIntegratorCompanies;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCompanyUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();



function getIntegrators() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_27" /* GET_INTEGRATORS */].REQUEST
  };
}

function getIntegratorCompanies(_ref) {
  var id = _ref.id,
      page = _ref.page,
      limit = _ref.limit;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_28" /* GET_INTEGRATOR_COMPANIES */].REQUEST,
    id: id,
    page: page,
    limit: limit
  };
}

function getCompanyUser(id, integratorId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_22" /* GET_COMPANY_USER */].REQUEST,
    id: id,
    integratorId: integratorId
  };
}
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getIntegrators, "getIntegrators", "/opt/atlassian/pipelines/agent/build/client/app/actions/integrators/integrators.js");
  reactHotLoader.register(getIntegratorCompanies, "getIntegratorCompanies", "/opt/atlassian/pipelines/agent/build/client/app/actions/integrators/integrators.js");
  reactHotLoader.register(getCompanyUser, "getCompanyUser", "/opt/atlassian/pipelines/agent/build/client/app/actions/integrators/integrators.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v1_js__ = __webpack_require__(3487);
/* unused harmony reexport v1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v3_js__ = __webpack_require__(3489);
/* unused harmony reexport v3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v4_js__ = __webpack_require__(3491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v5_js__ = __webpack_require__(3492);
/* unused harmony reexport v5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nil_js__ = __webpack_require__(3494);
/* unused harmony reexport NIL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version_js__ = __webpack_require__(3495);
/* unused harmony reexport version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate_js__ = __webpack_require__(400);
/* unused harmony reexport validate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stringify_js__ = __webpack_require__(399);
/* unused harmony reexport stringify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parse_js__ = __webpack_require__(985);
/* unused harmony reexport parse */










/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_vesselTypes__ = __webpack_require__(279);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var notifications = {
    error: function error(message) {
        return {
            title: 'Error',
            message: message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3
        };
    },
    success: function success(message) {
        return {
            title: 'Success',
            message: message,
            level: 'success',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3
        };
    }
};

var selectTypes = function selectTypes(vessel, vesselDwtTypes) {
    var res = {};
    if (__WEBPACK_IMPORTED_MODULE_0_constants_vesselTypes__["b" /* types */].includes(vessel.typeByPurpose)) {
        res.typeByPurpose = vessel.typeByPurpose;
    }

    var foundGroup = vesselDwtTypes.find(function (v) {
        return v.min <= vessel.deadWeight.sDWT && vessel.deadWeight.sDWT <= v.max && v.typeByPurpose.includes(vessel.typeByPurpose);
    });

    if (foundGroup) {
        res.vesselDwtGroup = foundGroup;
    } else {
        res.vesselDwtGroup = {};
    }

    return res;
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(notifications, 'notifications', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/common.js');
    reactHotLoader.register(selectTypes, 'selectTypes', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/common.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(107);
var global = __webpack_require__(42);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(148) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(93);
var toLength = __webpack_require__(60);
var toAbsoluteIndex = __webpack_require__(173);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 295 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(109);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(110);
var defined = __webpack_require__(119);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(48);
var cof = __webpack_require__(109);
var MATCH = __webpack_require__(59)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(59)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(208);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(602);
var redefine = __webpack_require__(87);
var hide = __webpack_require__(86);
var fails = __webpack_require__(47);
var defined = __webpack_require__(119);
var wks = __webpack_require__(59);
var regexpExec = __webpack_require__(422);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(42);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(42);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(87);
var redefineAll = __webpack_require__(179);
var meta = __webpack_require__(147);
var forOf = __webpack_require__(178);
var anInstance = __webpack_require__(177);
var isObject = __webpack_require__(48);
var fails = __webpack_require__(47);
var $iterDetect = __webpack_require__(299);
var setToStringTag = __webpack_require__(207);
var inheritIfRequired = __webpack_require__(408);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(42);
var hide = __webpack_require__(86);
var uid = __webpack_require__(171);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(148) || !__webpack_require__(47)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(42)[K];
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(12);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(12);
var aFunction = __webpack_require__(76);
var ctx = __webpack_require__(108);
var forOf = __webpack_require__(178);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(123);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 312 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1259)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(645)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 314 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(187),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(188);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(187),
    isObject = __webpack_require__(89);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1373),
    listCacheDelete = __webpack_require__(1374),
    listCacheGet = __webpack_require__(1375),
    listCacheHas = __webpack_require__(1376),
    listCacheSet = __webpack_require__(1377);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(255);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1379);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["f"] = findVessel;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkImoNumberRegistered;
/* harmony export (immutable) */ __webpack_exports__["h"] = getVessels;
/* harmony export (immutable) */ __webpack_exports__["c"] = confirmVessel;
/* harmony export (immutable) */ __webpack_exports__["g"] = getVessel;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteNameSuggestion;
/* harmony export (immutable) */ __webpack_exports__["i"] = renameVessel;
/* harmony export (immutable) */ __webpack_exports__["j"] = updateVessel;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteVessel;
/* harmony export (immutable) */ __webpack_exports__["a"] = addVessel;
/* harmony export (immutable) */ __webpack_exports__["k"] = updateVesselImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function findVessel(name, confirmed, isNameSuggestion) {
    var data = confirmed === 'undefined' ? { query: name } : { query: name, confirmed: confirmed };
    data = isNameSuggestion === 'undefined' ? _extends({}, data) : _extends({}, data, { isNameSuggestion: isNameSuggestion });
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/vessels/find',
        data: data,
        withCredentials: true
    });
}

function checkImoNumberRegistered(imoNumber) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/vessels/find',
        data: {
            query: imoNumber,
            checkIn: ['imoNumber']
        },
        withCredentials: true
    }).then(function (response) {
        return response.data.data.length > 0;
    });
}

function getVessels(_ref) {
    var page = _ref.page,
        limit = _ref.limit,
        notConfirmed = _ref.notConfirmed,
        sanctioned = _ref.sanctioned,
        modifiedFilter = _ref.modifiedFilter,
        isNameSuggestion = _ref.isNameSuggestion,
        filterCargoExclusions = _ref.filterCargoExclusions,
        filterTradingRestrictions = _ref.filterTradingRestrictions,
        _ref$photosFilter = _ref.photosFilter,
        photosFilter = _ref$photosFilter === undefined ? 'all' : _ref$photosFilter,
        dwtMin = _ref.dwtMin,
        dwtMax = _ref.dwtMax,
        bltMin = _ref.bltMin,
        bltMax = _ref.bltMax,
        typeByPurpose = _ref.typeByPurpose,
        typeBySpecialty = _ref.typeBySpecialty,
        sortValue = _ref.sortValue,
        sortField = _ref.sortField;

    var query = new URLSearchParams();
    query.append('page', page);
    query.append('limit', limit);
    query.append('notConfirmed', notConfirmed);
    query.append('photosFilter', photosFilter);
    query.append('modifiedFilter', modifiedFilter);
    query.append('isNameSuggestion', isNameSuggestion);
    query.append('cargoExclusionsUpdatedFrom', filterCargoExclusions);
    query.append('tradingRestrictionsUpdatedFrom', filterTradingRestrictions);
    sanctioned && query.append('sanctioned', sanctioned);
    dwtMin && query.append('dwtMin', dwtMin);
    dwtMax && query.append('dwtMax', dwtMax);
    typeByPurpose && query.append('typeByPurpose', typeByPurpose);
    bltMin && query.append('bltMin', bltMin);
    bltMax && query.append('bltMax', bltMax);
    typeBySpecialty && query.append('typeBySpecialty', typeBySpecialty);
    sortValue && query.append('sortValue', sortValue);
    sortField && query.append('sortField', sortField);

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/vessels?' + query.toString(),
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function confirmVessel(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/vessels/' + id + '/confirm',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getVessel(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/vessels/admin/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteNameSuggestion(_ref2) {
    var vessel = _ref2.vessel,
        suggestedName = _ref2.suggestedName;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/vessels/' + vessel.imoNumber + '/nameSuggestion',
        data: {
            name: suggestedName.name
        },

        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function renameVessel(vessel) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',

        url: '/api/v1/vessels/' + vessel.imoNumber + '/rename',

        data: {
            imo: +vessel.imoNumber,

            name: vessel.suggestedName.name || vessel.name
        },

        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateVessel(vessel) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/vessels/admin/' + vessel._id,
        data: _extends({}, vessel),
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteVessel(vessel) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/vessels/' + vessel._id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function addVessel(vessel) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/vessels/admin',
        data: _extends({}, vessel),
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateVesselImage(_id, image) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/vessels/admin/' + _id + '/image',
        data: {
            images: [image]
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(findVessel, 'findVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(checkImoNumberRegistered, 'checkImoNumberRegistered', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(getVessels, 'getVessels', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(confirmVessel, 'confirmVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(getVessel, 'getVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(deleteNameSuggestion, 'deleteNameSuggestion', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(renameVessel, 'renameVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(updateVessel, 'updateVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(deleteVessel, 'deleteVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(addVessel, 'addVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    reactHotLoader.register(updateVesselImage, 'updateVesselImage', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/vessels.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getLoadingAndDischarging;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateLoadingAndDischarging;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteLoadingAndDischarging;
/* harmony export (immutable) */ __webpack_exports__["d"] = saveStatusLoadingAndDischarging;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearStatusLoadingAndDischarging;
/* harmony export (immutable) */ __webpack_exports__["e"] = searchLoadingAndDischarging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getLoadingAndDischarging() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_34" /* GET_LOADING_AND_DISCHARGING */].REQUEST
    };
}

function updateLoadingAndDischarging(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_131" /* UPDATE_LOADING_AND_DISCHARGING */].REQUEST,
        item: item
    };
}

function deleteLoadingAndDischarging(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["T" /* DELETE_LOADING_AND_DISCHARGING */].REQUEST,
        item: item
    };
}

function saveStatusLoadingAndDischarging(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_101" /* SAVE_STATUS_LOADING_AND_DISCHARGING */],
        item: item
    };
}

function clearStatusLoadingAndDischarging(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["v" /* CLEAR_STATUS_LOADING_AND_DISCHARGING */],
        item: item
    };
}

function searchLoadingAndDischarging(search) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_107" /* SEARCH_LOADING_AND_DISCHARGING */],
        search: search
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getLoadingAndDischarging, 'getLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/ldRates.js');
    reactHotLoader.register(updateLoadingAndDischarging, 'updateLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/ldRates.js');
    reactHotLoader.register(deleteLoadingAndDischarging, 'deleteLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/ldRates.js');
    reactHotLoader.register(saveStatusLoadingAndDischarging, 'saveStatusLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/ldRates.js');
    reactHotLoader.register(clearStatusLoadingAndDischarging, 'clearStatusLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/ldRates.js');
    reactHotLoader.register(searchLoadingAndDischarging, 'searchLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/ldRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getAreas;
/* unused harmony export watchGetAreas */
/* unused harmony export updateArea */
/* unused harmony export watchUpdateArea */
/* unused harmony export updateAreaAlt */
/* unused harmony export watchUpdateAreaAlt */
/* harmony export (immutable) */ __webpack_exports__["a"] = createArea;
/* unused harmony export watchCreateArea */
/* harmony export (immutable) */ __webpack_exports__["d"] = transformAreaToPort;
/* unused harmony export deleteArea */
/* unused harmony export watchDeleteArea */
/* unused harmony export removeAreaChild */
/* unused harmony export watchRemoveAreaChild */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getAreas),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetAreas),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updateArea),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateArea),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(updateAreaAlt),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateAreaAlt),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(createArea),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchCreateArea),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(transformAreaToPort),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(deleteArea),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteArea),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(removeAreaChild),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(watchRemoveAreaChild);





/**
 * Get areas
 * */
// const watchGetAreas = callBaseSaga({
//     actionName: 'GET_AREAS',
//     methodApi: 'getAreas',
//     notificationOptions: {},
// });


function getAreas() {
    var response;
    return regeneratorRuntime.wrap(function getAreas$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getAreas);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_7" /* GET_AREAS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_7" /* GET_AREAS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetAreas() {
    return regeneratorRuntime.wrap(function watchGetAreas$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_7" /* GET_AREAS */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getAreas);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function updateArea(item) {
    var requestItem, response;
    return regeneratorRuntime.wrap(function updateArea$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    requestItem = _extends({}, item);
                    _context3.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateArea, requestItem);

                case 3:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 10;
                        break;
                    }

                    _context3.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_119" /* UPDATE_AREA */].SUCCESS,
                        item: _extends({}, requestItem, response.data.data)
                    });

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: item.name + ' updated',
                            level: 'success',
                            _id: item._id,
                            autoDismiss: 2
                        }
                    });

                case 9:
                    return _context3.abrupt('return');

                case 10:
                    _context3.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_119" /* UPDATE_AREA */].FAILURE,
                        item: item,
                        errors: response.errors
                    });

                case 12:
                    _context3.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: item._id,
                            autoDismiss: 2
                        }
                    });

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchUpdateArea() {
    var _ref, item;

    return regeneratorRuntime.wrap(function watchUpdateArea$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_119" /* UPDATE_AREA */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    item = _ref.item;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateArea, item);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function updateAreaAlt(item) {
    var response;
    return regeneratorRuntime.wrap(function updateAreaAlt$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateAreaAlt, item);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_120" /* UPDATE_AREA_ALT */].SUCCESS,
                        item: response.item
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.item.name + ' updated',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return');

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_120" /* UPDATE_AREA_ALT */].FAILURE,
                        item: response.item,
                        errors: response.errors
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: response.item._id,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchUpdateAreaAlt() {
    var _ref2, _item;

    return regeneratorRuntime.wrap(function watchUpdateAreaAlt$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_120" /* UPDATE_AREA_ALT */].REQUEST);

                case 3:
                    _ref2 = _context6.sent;
                    _item = _ref2.item;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateAreaAlt, _item);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function createArea(item) {
    var response;
    return regeneratorRuntime.wrap(function createArea$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].createArea, item);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["A" /* CREATE_AREA */].SUCCESS,
                        item: _extends({}, item, response.data.data)
                    });

                case 6:
                    _context7.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: item.name + ' created',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context7.abrupt('return', response.data.data);

                case 9:
                    _context7.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["A" /* CREATE_AREA */].FAILURE
                    });

                case 11:
                    _context7.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function watchCreateArea() {
    var _ref3, _item2;

    return regeneratorRuntime.wrap(function watchCreateArea$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 9;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["A" /* CREATE_AREA */].REQUEST);

                case 3:
                    _ref3 = _context8.sent;
                    _item2 = _ref3.item;
                    _context8.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(createArea, _item2);

                case 7:
                    _context8.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function transformAreaToPort() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var data = arguments[1];
    var response;
    return regeneratorRuntime.wrap(function transformAreaToPort$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].transformAreaToPort, id, data);

                case 2:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 7;
                        break;
                    }

                    _context9.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: '' + response.data.message,
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 6:
                    return _context9.abrupt('return', response);

                case 7:
                    _context9.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 9:
                    return _context9.abrupt('return', response);

                case 10:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function deleteArea(item) {
    var response;
    return regeneratorRuntime.wrap(function deleteArea$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteArea, item);

                case 2:
                    response = _context10.sent;

                    if (!(response.status === 200)) {
                        _context10.next = 9;
                        break;
                    }

                    _context10.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["J" /* DELETE_AREA */].SUCCESS,
                        item: item
                    });

                case 6:
                    _context10.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: '' + response.data.message,
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context10.abrupt('return', response);

                case 9:
                    _context10.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["J" /* DELETE_AREA */].FAILURE
                    });

                case 11:
                    _context10.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function watchDeleteArea() {
    var _ref4, _item3;

    return regeneratorRuntime.wrap(function watchDeleteArea$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    if (false) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["J" /* DELETE_AREA */].REQUEST);

                case 3:
                    _ref4 = _context11.sent;
                    _item3 = _ref4.item;
                    _context11.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteArea, _item3);

                case 7:
                    _context11.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function removeAreaChild(parentId, childId) {
    var parent, requestItem, response;
    return regeneratorRuntime.wrap(function removeAreaChild$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])(function (state) {
                        return state.areas.items.find(function (item) {
                            return item._id === parentId;
                        });
                    });

                case 2:
                    parent = _context12.sent;
                    requestItem = {
                        _id: parent._id,
                        name: parent.name,
                        childs: parent.childs.filter(function (id) {
                            return id !== childId;
                        })
                    };
                    _context12.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateArea, requestItem);

                case 6:
                    response = _context12.sent;

                    if (!(response.status === 200)) {
                        _context12.next = 13;
                        break;
                    }

                    _context12.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_82" /* REMOVE_AREA_CHILD */].SUCCESS,
                        parentId: parentId,
                        childId: childId
                    });

                case 10:
                    _context12.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: parent.name + ' updated',
                            level: 'success',
                            _id: parent._id,
                            autoDismiss: 2
                        }
                    });

                case 12:
                    return _context12.abrupt('return');

                case 13:
                    _context12.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_82" /* REMOVE_AREA_CHILD */].FAILURE,
                        parentId: parentId,
                        childId: childId,
                        errors: response.errors
                    });

                case 15:
                    _context12.next = 17;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: parent._id,
                            autoDismiss: 2
                        }
                    });

                case 17:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function watchRemoveAreaChild() {
    var _ref5, parentId, childId;

    return regeneratorRuntime.wrap(function watchRemoveAreaChild$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    if (false) {
                        _context13.next = 10;
                        break;
                    }

                    _context13.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_82" /* REMOVE_AREA_CHILD */].REQUEST);

                case 3:
                    _ref5 = _context13.sent;
                    parentId = _ref5.parentId;
                    childId = _ref5.childId;
                    _context13.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(removeAreaChild, parentId, childId);

                case 8:
                    _context13.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

var _default = [watchGetAreas, watchUpdateArea, watchUpdateAreaAlt, watchCreateArea, watchDeleteArea, watchRemoveAreaChild];
/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getAreas, 'getAreas', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(watchGetAreas, 'watchGetAreas', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(updateArea, 'updateArea', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(watchUpdateArea, 'watchUpdateArea', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(updateAreaAlt, 'updateAreaAlt', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(watchUpdateAreaAlt, 'watchUpdateAreaAlt', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(createArea, 'createArea', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(watchCreateArea, 'watchCreateArea', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(transformAreaToPort, 'transformAreaToPort', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(deleteArea, 'deleteArea', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(watchDeleteArea, 'watchDeleteArea', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(removeAreaChild, 'removeAreaChild', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(watchRemoveAreaChild, 'watchRemoveAreaChild', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/areas.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(709);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(181);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(1504);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(261);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(1506);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(181);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(181);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1536);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(1539);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(717);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderNew; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function getDefaultDimension() {
    return {
        value: undefined,
        deviation: undefined,
        term: undefined,
        unit: undefined
    };
}

var orderNew = {
    comm: undefined,
    terms: {
        user: []
    },
    loadingPortDetails: '',
    unloadingPortDetails: '',
    ldRates: {
        discharging: {
            quantity: undefined,
            dimension: undefined,
            speed: undefined,
            abbreviation: undefined,
            term: undefined,
            type: undefined
        },
        loading: {
            quantity: undefined,
            dimension: undefined,
            speed: undefined,
            abbreviation: undefined,
            term: undefined,
            type: undefined
        }
    },
    cargo: [{
        cargoName: '',
        details: 0,
        cargoTypeName: '',
        cargoType: '',
        dangerous: {
            value: false,
            class: [],
            unNumber: ''
        },
        packing: {
            category: 'unpacked',
            pack: {
                name: undefined,
                unitsQuantity: undefined,
                unitsQuantityIsCalc: true,
                sf: '',
                sfUnit: 'cbm/mt',
                unitsWeight: [{
                    value: undefined,
                    unit: 'mt',
                    deviation: undefined,
                    deviationSign: {
                        sign1: '+',
                        sign2: '-'
                    }
                }, {
                    value: undefined,
                    unit: 'mt',
                    deviation: undefined
                }],
                unitsVolume: [{
                    value: undefined,
                    unit: 'cbm',
                    deviation: undefined,
                    deviationSign: {
                        sign1: '+',
                        sign2: '-'
                    }
                }, {
                    value: undefined,
                    unit: 'cbm',
                    deviation: undefined
                }],
                unitWeight: _extends({}, getDefaultDimension(), {
                    unit: 'mt'
                }),
                unitVolume: {
                    value: undefined,
                    unit: 'm3'
                },
                temperatureMin: undefined,
                temperatureMax: undefined,
                moistureMin: undefined,
                moistureMax: undefined,
                numberOfHeadsMin: undefined,
                numberOfHeadsMax: undefined,
                weightPerHead: undefined,
                ventilation: false,
                maxUnitLength: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                unitBeam: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                unitHeight: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                stackable: {
                    value: false,
                    tiers: undefined,
                    dunnaging: false,
                    nested: false
                },
                unitLength: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                maxUnitWidth: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                unitDiam: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                density: undefined,
                pourPointMin: undefined,
                pourPointMax: undefined,
                boilingPointMin: undefined,
                boilingPointMax: undefined,
                flashPointMin: undefined,
                flashPointMax: undefined,
                densities: [{ density: undefined, temperature: undefined }],
                meltingPointMin: undefined,
                meltingPointMax: undefined,
                flammable: false,
                voyageHeatMin: undefined,
                voyageHeatMax: undefined,
                loadingHeatMin: undefined,
                loadingHeatMax: undefined,
                dischargeHeatMin: undefined,
                dischargeHeatMax: undefined,
                maxAdjacentHeat: undefined,
                bundleBeam: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                bundleHeight: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                bundleLength: _extends({}, getDefaultDimension(), {
                    unit: 'mm'
                }),
                bundlesQuantity: undefined,
                netWeight: _extends({}, getDefaultDimension(), {
                    unit: 'mt'
                })
            }
        },
        containerDetails: {
            kind: undefined,
            ownNum: undefined,
            sealNum: undefined,
            owner: 'shipper',
            stc: undefined,
            terms: undefined
        },
        packingList: [{
            name: undefined,
            weight: undefined,
            weightIsCalc: false,
            length: undefined,
            width: undefined,
            height: undefined,
            quantity: undefined,
            totalWeight: undefined,
            imdg: undefined,
            grossWeight: undefined,
            netWeight: undefined,
            taraWeight: undefined,
            area: undefined,
            areaIsCalc: false,
            volume: undefined,
            volumeIsCalc: false
        }],
        validateErrors: [],
        hsCodeId: { _id: undefined, text: undefined },
        additionalCargoDetails: undefined,
        typeOfTransportation: 'breakbulk',
        clauses: [{ name: 'Shipment', value: 'under deck' }, { name: 'Cradles to be for', value: 'Charterer\'s account' }]
    }],
    clientRefNo: undefined,
    incoterms: {
        kind: undefined,
        place: undefined
    },
    totalValues: {
        weight: undefined,
        weightWithPercent: undefined,
        volume: undefined,
        volumeWithPercent: undefined,
        isCalc: true
    },
    details: 0,
    contract: '',
    cancellingDate: '',
    readinessDate: '',
    unloadingPort: '',
    loadingPort: '',
    validateErrors: [],
    loadingPortName: '',
    unloadingPortName: '',
    loadingPorts: [{
        namePort: '',
        idPort: '',
        cancellingDate: '',
        readinessDate: '',
        additionalLayCanDetails: undefined,
        layCanType: 'layCan'
    }],
    unloadingPorts: [{
        namePort: '',
        idPort: ''
    }],
    loadingPortsNew: [{
        oneOf: [{
            cancellingDate: '',
            readinessDate: '',
            andOr: '',
            port: '',
            portName: '',
            details: undefined,
            additionalLayCanDetails: undefined,
            layCanType: 'layCan'
        }]
    }],
    unloadingPortsNew: [{
        oneOf: [{
            andOr: '',
            port: '',
            portName: '',
            details: undefined
        }]
    }],
    loadingPortsMap: [{
        port: {
            andOr: 'and',
            cancellingDate: '',
            readinessDate: '',
            details: undefined,
            portName: '',
            additionalLayCanDetails: undefined,
            layCanType: 'layCan'
        },
        sign: 'and'
    }],
    unloadingPortsMap: [{
        port: {
            andOr: 'and',
            details: undefined,
            portName: ''
        },
        sign: 'and'
    }],
    user: ''
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getDefaultDimension, 'getDefaultDimension', '/opt/atlassian/pipelines/agent/build/client/app/mocks/cargo/orderNew.js');
    reactHotLoader.register(orderNew, 'orderNew', '/opt/atlassian/pipelines/agent/build/client/app/mocks/cargo/orderNew.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(463),
    setCacheAdd = __webpack_require__(1667),
    setCacheHas = __webpack_require__(1668);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1669);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(487),
    isFlattenable = __webpack_require__(1673);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(event) {
      event.target.removeEventListener(event.type, recursiveFunction);
      return callback(event);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },
  isKeyboard: function isKeyboard(event) {
    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
  }
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FontIcon = __webpack_require__(346);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Tooltip = __webpack_require__(740);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _childUtils = __webpack_require__(741);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      boxSizing: 'border-box',
      overflow: 'visible',
      transition: _transitions2.default.easeOut(),
      padding: baseTheme.spacing.iconSize / 2,
      width: baseTheme.spacing.iconSize * 2,
      height: baseTheme.spacing.iconSize * 2,
      fontSize: 0
    },
    tooltip: {
      boxSizing: 'border-box'
    },
    disabled: {
      color: baseTheme.palette.disabledColor,
      fill: baseTheme.palette.disabledColor,
      cursor: 'default'
    }
  };
}

var IconButton = function (_Component) {
  (0, _inherits3.default)(IconButton, _Component);

  function IconButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      // Not to be confonded with the touch property.
      // This state is to determined if it's a mobile device.
      touch: false,
      tooltipShown: false
    }, _this.handleBlur = function (event) {
      _this.hideTooltip();
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      _this.showTooltip();
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.button.isKeyboardFocused()) {
        _this.hideTooltip();
      }
      _this.setState({ hovered: false });
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseOut = function (event) {
      if (_this.props.disabled) _this.hideTooltip();
      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
    }, _this.handleMouseEnter = function (event) {
      _this.showTooltip();

      // Cancel hover styles for touch devices
      if (!_this.state.touch) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onKeyboardFocus = _this$props.onKeyboardFocus;

      if (isKeyboardFocused && !disabled) {
        _this.showTooltip();
        if (onFocus) {
          onFocus(event);
        }
      } else {
        _this.hideTooltip();
        if (onBlur) {
          onBlur(event);
        }
      }

      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      if (onKeyboardFocus) {
        onKeyboardFocus(event, isKeyboardFocused);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hovered: false });
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus() {
      this.button.setKeyboardFocus();
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      if (this.props.tooltip) {
        this.setState({ tooltipShown: true });
      }
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      if (this.props.tooltip) this.setState({ tooltipShown: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          hoveredStyle = _props.hoveredStyle,
          disableTouchRipple = _props.disableTouchRipple,
          children = _props.children,
          iconClassName = _props.iconClassName,
          style = _props.style,
          tooltip = _props.tooltip,
          tooltipPositionProp = _props.tooltipPosition,
          tooltipStyles = _props.tooltipStyles,
          touch = _props.touch,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);

      var fonticon = void 0;

      var styles = getStyles(this.props, this.context);
      var tooltipPosition = tooltipPositionProp.split('-');

      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});

      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
        label: tooltip,
        show: this.state.tooltipShown,
        touch: touch,
        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
        verticalPosition: tooltipPosition[0],
        horizontalPosition: tooltipPosition[1]
      }) : null;

      if (iconClassName) {
        var iconHoverColor = iconStyle.iconHoverColor,
            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);


        fonticon = _react2.default.createElement(
          _FontIcon2.default,
          {
            className: iconClassName,
            hoverColor: disabled ? null : iconHoverColor,
            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
            color: this.context.muiTheme.baseTheme.palette.textColor
          },
          children
        );
      }

      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({
          ref: function ref(_ref2) {
            return _this2.button = _ref2;
          }
        }, other, {
          centerRipple: true,
          disabled: disabled,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          disableTouchRipple: disableTouchRipple,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onMouseOut: this.handleMouseOut,
          onKeyboardFocus: this.handleKeyboardFocus
        }),
        tooltipElement,
        fonticon,
        (0, _childUtils.extendChildren)(children, {
          style: childrenStyle
        })
      );
    }
  }]);
  return IconButton;
}(_react.Component);

IconButton.muiName = 'IconButton';
IconButton.defaultProps = {
  disabled: false,
  disableTouchRipple: false,
  iconStyle: {},
  tooltipPosition: 'bottom-center',
  touch: false
};
IconButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
IconButton.propTypes =  false ? {
  /**
   * Can be used to pass a `FontIcon` element as the icon for the button.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * If true, the element will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element when the component is hovered.
   */
  hoveredStyle: _propTypes2.default.object,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
   */
  iconClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the icon element.
   * Note: you can specify iconHoverColor as a String inside this object.
   */
  iconStyle: _propTypes2.default.object,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} keyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseOut: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The text to supply to the element's tooltip.
   */
  tooltip: _propTypes2.default.node,
  /**
   * The vertical and horizontal positions, respectively, of the element's tooltip.
   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
   * "bottom-left", and "top-left".
   */
  tooltipPosition: _propTypes4.default.cornersAndCenter,
  /**
   * Override the inline-styles of the tooltip element.
   */
  tooltipStyles: _propTypes2.default.object,
  /**
   * If true, increase the tooltip element's size. Useful for increasing tooltip
   * readability on mobile devices.
   */
  touch: _propTypes2.default.bool
} : {};
exports.default = IconButton;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FontIcon = __webpack_require__(1736);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon2.default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(194);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _colorManipulator = __webpack_require__(155);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _IconButton = __webpack_require__(30);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _expandLess = __webpack_require__(495);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _expandMore = __webpack_require__(496);

var _expandMore2 = _interopRequireDefault(_expandMore);

var _NestedList = __webpack_require__(1757);

var _NestedList2 = _interopRequireDefault(_NestedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
      insetChildren = props.insetChildren,
      leftAvatar = props.leftAvatar,
      leftCheckbox = props.leftCheckbox,
      leftIcon = props.leftIcon,
      nestedItems = props.nestedItems,
      nestedLevel = props.nestedLevel,
      rightAvatar = props.rightAvatar,
      rightIcon = props.rightIcon,
      rightIconButton = props.rightIconButton,
      rightToggle = props.rightToggle,
      secondaryText = props.secondaryText,
      secondaryTextLines = props.secondaryTextLines;
  var muiTheme = context.muiTheme;
  var listItem = muiTheme.listItem;


  var textColor = muiTheme.baseTheme.palette.textColor;
  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
  var twoLine = secondaryText && secondaryTextLines === 1;
  var threeLine = secondaryText && secondaryTextLines > 1;

  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;

  var styles = {
    root: {
      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
      color: textColor,
      display: 'block',
      fontSize: 16,
      lineHeight: '16px',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },

    // This inner div is needed so that ripples will span the entire container
    innerDiv: {
      marginLeft: nestedLevel * listItem.nestedLevelDepth,
      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
      paddingBottom: singleAvatar ? 20 : 16,
      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
      position: 'relative'
    },

    icons: {
      height: 24,
      width: 24,
      display: 'block',
      position: 'absolute',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      margin: 12
    },

    leftIcon: {
      left: 4
    },

    rightIcon: {
      right: 4
    },

    avatars: {
      position: 'absolute',
      top: singleAvatar ? 8 : 16
    },

    label: {
      cursor: 'pointer'
    },

    leftAvatar: {
      left: 16
    },

    rightAvatar: {
      right: 16
    },

    leftCheckbox: {
      position: 'absolute',
      display: 'block',
      width: 24,
      top: twoLine ? 24 : singleAvatar ? 16 : 12,
      left: 16
    },

    primaryText: {},

    rightIconButton: {
      position: 'absolute',
      display: 'block',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      right: 4
    },

    rightToggle: {
      position: 'absolute',
      display: 'block',
      width: 54,
      top: twoLine ? 25 : singleAvatar ? 17 : 13,
      right: 8
    },

    secondaryText: {
      fontSize: 14,
      lineHeight: threeLine ? '18px' : '16px',
      height: threeLine ? 36 : 16,
      margin: 0,
      marginTop: 4,
      color: listItem.secondaryTextColor,

      // needed for 2 and 3 line ellipsis
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: threeLine ? null : 'nowrap',
      display: threeLine ? '-webkit-box' : null,
      WebkitLineClamp: threeLine ? 2 : null,
      WebkitBoxOrient: threeLine ? 'vertical' : null
    }
  };

  return styles;
}

var ListItem = function (_Component) {
  (0, _inherits3.default)(ListItem, _Component);

  function ListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      open: false,
      rightIconButtonHovered: false,
      rightIconButtonKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (_this.props.primaryTogglesNestedList) {
        _this.handleNestedListToggle(event);
      }
    }, _this.handleNestedListToggle = function (event) {
      if (_this.props.leftCheckbox) {
        event.preventDefault();
      }
      event.stopPropagation();

      if (_this.props.open === null) {
        _this.setState({ open: !_this.state.open }, function () {
          _this.props.onNestedListToggle(_this);
        });
      } else {
        // Exposing `this` in the callback is quite a bad API.
        // I'm doing a one level deep clone to expose a fake state.open.
        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
          state: {
            open: !_this.state.open
          }
        }));
      }
    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
      if (isKeyboardFocused) {
        _this.setState({
          isKeyboardFocused: false,
          rightIconButtonKeyboardFocused: isKeyboardFocused
        });
      }

      var iconButton = _this.props.rightIconButton;

      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleRightIconButtonMouseLeave = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: false });
      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
    }, _this.handleRightIconButtonMouseEnter = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: true });
      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
    }, _this.handleRightIconButtonMouseUp = function (event) {
      var iconButton = _this.props.rightIconButton;
      event.stopPropagation();
      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
    }, _this.handleRightIconButtonClick = function (event) {
      var iconButton = _this.props.rightIconButton;

      // Stop the event from bubbling up to the list-item
      event.stopPropagation();
      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _this.handleTouchEnd = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchEnd(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.open !== null) this.setState({ open: nextProps.open });
      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }

    // This method is needed by the `MenuItem` component.

  }, {
    key: 'applyFocusState',
    value: function applyFocusState(focusState) {
      if (this.button) {
        var buttonEl = _reactDom2.default.findDOMNode(this.button);

        switch (focusState) {
          case 'none':
            buttonEl.blur();
            break;
          case 'focused':
            buttonEl.focus();
            break;
          case 'keyboard-focused':
            this.button.setKeyboardFocus();
            buttonEl.focus();
            break;
        }
      }
    }
  }, {
    key: 'createDisabledElement',
    value: function createDisabledElement(styles, contentChildren, additionalProps) {
      var _props = this.props,
          innerDivStyle = _props.innerDivStyle,
          style = _props.style;


      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createLabelElement',
    value: function createLabelElement(styles, contentChildren, additionalProps) {
      var _props2 = this.props,
          innerDivStyle = _props2.innerDivStyle,
          style = _props2.style;


      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);

      return _react2.default.createElement(
        'label',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createTextElement',
    value: function createTextElement(styles, data, key) {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      if (_react2.default.isValidElement(data)) {
        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
        if (typeof data.type === 'string') {
          // if element is a native dom node
          style = prepareStyles(style);
        }
        return _react2.default.cloneElement(data, {
          key: key,
          style: style
        });
      }

      return _react2.default.createElement(
        'div',
        { key: key, style: prepareStyles(styles) },
        data
      );
    }
  }, {
    key: 'pushElement',
    value: function pushElement(children, element, baseStyles, additionalProps) {
      if (element) {
        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
          key: children.length,
          style: styles
        }, additionalProps)));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          hoverColor = _props3.hoverColor,
          initiallyOpen = _props3.initiallyOpen,
          innerDivStyle = _props3.innerDivStyle,
          insetChildren = _props3.insetChildren,
          leftAvatar = _props3.leftAvatar,
          leftCheckbox = _props3.leftCheckbox,
          leftIcon = _props3.leftIcon,
          nestedItems = _props3.nestedItems,
          nestedLevel = _props3.nestedLevel,
          nestedListStyle = _props3.nestedListStyle,
          onKeyboardFocus = _props3.onKeyboardFocus,
          isKeyboardFocused = _props3.isKeyboardFocused,
          onMouseEnter = _props3.onMouseEnter,
          onMouseLeave = _props3.onMouseLeave,
          onNestedListToggle = _props3.onNestedListToggle,
          onTouchStart = _props3.onTouchStart,
          onClick = _props3.onClick,
          rightAvatar = _props3.rightAvatar,
          rightIcon = _props3.rightIcon,
          rightIconButton = _props3.rightIconButton,
          rightToggle = _props3.rightToggle,
          primaryText = _props3.primaryText,
          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
          secondaryText = _props3.secondaryText,
          secondaryTextLines = _props3.secondaryTextLines,
          style = _props3.style,
          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var contentChildren = [children];

      if (leftIcon) {
        var additionalProps = {
          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
        };
        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
      }

      if (rightIcon) {
        var _additionalProps = {
          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
        };
        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
      }

      if (leftAvatar) {
        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
      }

      if (rightAvatar) {
        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
      }

      if (leftCheckbox) {
        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
      }

      // RightIconButtonElement
      var hasNestListItems = nestedItems.length;
      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;

      if (rightIconButton || needsNestedIndicator) {
        var rightIconButtonElement = rightIconButton;
        var rightIconButtonHandlers = {
          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
          onMouseEnter: this.handleRightIconButtonMouseEnter,
          onMouseLeave: this.handleRightIconButtonMouseLeave,
          onClick: this.handleRightIconButtonClick,
          onMouseDown: this.handleRightIconButtonMouseUp,
          onMouseUp: this.handleRightIconButtonMouseUp
        };

        // Create a nested list indicator icon if we don't have an icon on the right
        if (needsNestedIndicator) {
          rightIconButtonElement = this.state.open ? _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandLess2.default, null)
          ) : _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandMore2.default, null)
          );
          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
        }

        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
      }

      if (rightToggle) {
        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
      }

      if (primaryText) {
        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
        contentChildren.push(primaryTextElement);
      }

      if (secondaryText) {
        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
        contentChildren.push(secondaryTextElement);
      }

      var nestedList = nestedItems.length ? _react2.default.createElement(
        _NestedList2.default,
        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
        nestedItems
      ) : undefined;

      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);

      return _react2.default.createElement(
        'div',
        null,
        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({
            containerElement: containerElement
          }, other, {
            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
            onKeyboardFocus: this.handleKeyboardFocus,
            onMouseLeave: this.handleMouseLeave,
            onMouseEnter: this.handleMouseEnter,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd,
            onClick: this.handleClick,
            disabled: disabled,
            ref: function ref(node) {
              return _this2.button = node;
            },
            style: (0, _simpleAssign2.default)({}, styles.root, style)
          }),
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
            contentChildren
          )
        ),
        nestedList
      );
    }
  }]);
  return ListItem;
}(_react.Component);

ListItem.muiName = 'ListItem';
ListItem.defaultProps = {
  autoGenerateNestedIndicator: true,
  containerElement: 'span',
  disableKeyboardFocus: false,
  disabled: false,
  initiallyOpen: false,
  insetChildren: false,
  nestedItems: [],
  nestedLevel: 0,
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onNestedListToggle: function onNestedListToggle() {},
  onTouchEnd: function onTouchEnd() {},
  onTouchStart: function onTouchStart() {},
  open: null,
  primaryTogglesNestedList: false,
  secondaryTextLines: 1
};
ListItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ListItem.propTypes =  false ? {
  /**
   * If true, generate a nested-list-indicator icon when nested list
   * items are detected. Note that an indicator will not be created
   * if a `rightIcon` or `rightIconButton` has been provided to
   * the element.
   */
  autoGenerateNestedIndicator: _propTypes2.default.bool,
  /**
   * Children passed into the `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * The element to use as the container for the ListItem. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * ListItem in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element will not be able to be focused by the keyboard.
   */
  disableKeyboardFocus: _propTypes2.default.bool,
  /**
   * If true, the element will not be clickable
   * and will not display hover effects.
   * This is automatically disabled if either `leftCheckbox`
   * or `rightToggle` is set.
   */
  disabled: _propTypes2.default.bool,
  /**
  * Override the hover background color.
  */
  hoverColor: _propTypes2.default.string,
  /**
   * If true, the nested `ListItem`s are initially displayed.
   */
  initiallyOpen: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the inner div element.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented by 72px.
   * This is useful if there is no left avatar or left icon.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * Use to control if the list item should render as keyboard focused.  If
   * undefined (default), this will be automatically managed.  If provided,
   * it will change the components style.  Note that this will not change the
   * actual focus - and should only be used when you want to simulate
   * keyboard focus (eg. in a rich text input autocomplete).
   */
  isKeyboardFocused: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the left side.
   */
  leftAvatar: _propTypes2.default.element,
  /**
   * This is the `Checkbox` element to be displayed on the left side.
   */
  leftCheckbox: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * An array of `ListItem`s to nest underneath the current `ListItem`.
   */
  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
  /**
   * Controls how deep a `ListItem` appears.
   * This property is automatically managed, so modify at your own risk.
   */
  nestedLevel: _propTypes2.default.number,
  /**
   * Override the inline-styles of the nested items' `NestedList`.
   */
  nestedListStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the list item is clicked.
   *
   * @param {object} event Click event targeting the list item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` toggles its nested list.
   *
   * @param {object} listItem The `ListItem`.
   */
  onNestedListToggle: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Control toggle state of nested list.
   */
  open: _propTypes2.default.bool,
  /**
   * This is the block element that contains the primary text.
   * If a string is passed in, a div tag will be rendered.
   */
  primaryText: _propTypes2.default.node,
  /**
   * If true, clicking or tapping the primary text of the `ListItem`
   * toggles the nested list.
   */
  primaryTogglesNestedList: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the right side.
   */
  rightAvatar: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * This is the `IconButton` to be displayed on the right side.
   * Hovering over this button will remove the `ListItem` hover.
   * Also, clicking on this button will not trigger a
   * ripple on the `ListItem`; the event will be stopped and prevented
   * from bubbling up to cause a `ListItem` click.
   */
  rightIconButton: _propTypes2.default.element,
  /**
   * This is the `Toggle` element to display on the right side.
   */
  rightToggle: _propTypes2.default.element,
  /**
   * This is the block element that contains the secondary text.
   * If a string is passed in, a div tag will be rendered.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Can be 1 or 2. This is the number of secondary
   * text lines before ellipsis will show.
   */
  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ListItem;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Subheader = __webpack_require__(497);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_Component) {
  (0, _inherits3.default)(List, _Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var hasSubheader = false;

      var firstChild = _react.Children.toArray(children)[0];
      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
        hasSubheader = true;
      }

      var styles = {
        root: {
          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
        }
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return List;
}(_react.Component);

List.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
List.propTypes =  false ? {
  /**
   * These are usually `ListItem`s that are passed to
   * be part of the list.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = List;

/***/ }),
/* 349 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 350 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 351 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toArray2 = __webpack_require__(737);

var _toArray3 = _interopRequireDefault(_toArray2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(194);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _ClickAwayListener = __webpack_require__(503);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _List = __webpack_require__(348);

var _List2 = _interopRequireDefault(_List);

var _menuUtils = __webpack_require__(1794);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var desktop = props.desktop,
      maxHeight = props.maxHeight,
      width = props.width;
  var muiTheme = context.muiTheme;


  var styles = {
    root: {
      // Nested div because the List scales x faster than it scales y
      zIndex: muiTheme.zIndex.menu,
      maxHeight: maxHeight,
      overflowY: maxHeight ? 'auto' : null
    },
    divider: {
      marginTop: 7,
      marginBottom: 8
    },
    list: {
      display: 'table-cell',
      paddingBottom: desktop ? 16 : 8,
      paddingTop: desktop ? 16 : 8,
      userSelect: 'none',
      width: width
    },
    selectedMenuItem: {
      color: muiTheme.menuItem.selectedTextColor
    }
  };

  return styles;
}

var Menu = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu(props, context) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));

    _initialiseProps.call(_this);

    var filteredChildren = _this.getFilteredChildren(props.children);
    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);

    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
      props.onMenuItemFocusChange(null, newFocusIndex);
    }
    _this.state = {
      focusIndex: newFocusIndex,
      isKeyboardFocused: props.initiallyKeyboardFocused,
      keyWidth: props.desktop ? 64 : 56
    };

    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
    return _this;
  }

  (0, _createClass3.default)(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
      this.setScollPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selectedIndex = void 0;
      var filteredChildren = this.getFilteredChildren(nextProps.children);

      if (this.props.multiple !== true) {
        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
      } else {
        selectedIndex = this.state.focusIndex;
      }

      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
        this.props.onMenuItemFocusChange(null, newFocusIndex);
      }
      this.setState({
        focusIndex: newFocusIndex,
        keyWidth: nextProps.desktop ? 64 : 56
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoWidth) this.setWidth();
    }
  }, {
    key: 'getValueLink',


    // Do not use outside of this component, it will be removed once valueLink is deprecated
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'setKeyboardFocused',
    value: function setKeyboardFocused(keyboardFocused) {
      this.setState({
        isKeyboardFocused: keyboardFocused
      });
    }
  }, {
    key: 'getFilteredChildren',
    value: function getFilteredChildren(children) {
      var filteredChildren = [];
      _react2.default.Children.forEach(children, function (child) {
        if (child) {
          filteredChildren.push(child);
        }
      });
      return filteredChildren;
    }
  }, {
    key: 'cloneMenuItem',
    value: function cloneMenuItem(child, childIndex, styles, index) {
      var _this2 = this;

      var childIsDisabled = child.props.disabled;

      var selectedChildStyles = {};
      if (!childIsDisabled) {
        var selected = this.isChildSelected(child, this.props);

        if (selected) {
          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
        }
      }
      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);

      var extraProps = {
        desktop: this.props.desktop,
        style: mergedChildStyles
      };
      if (!childIsDisabled) {
        var isFocused = childIndex === this.state.focusIndex;
        var focusState = 'none';
        if (isFocused) {
          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
        }

        (0, _simpleAssign2.default)(extraProps, {
          focusState: focusState,
          onClick: function onClick(event) {
            _this2.handleMenuItemClick(event, child, index);
            if (child.props.onClick) child.props.onClick(event);
          },
          ref: isFocused ? 'focusedMenuItem' : null
        });
      }
      return _react2.default.cloneElement(child, extraProps);
    }
  }, {
    key: 'decrementKeyboardFocusIndex',
    value: function decrementKeyboardFocusIndex(event) {
      var index = this.state.focusIndex;

      index--;
      if (index < 0) index = 0;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'getMenuItemCount',
    value: function getMenuItemCount(filteredChildren) {
      var menuItemCount = 0;
      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';
        var childIsDisabled = child.props.disabled;
        if (!childIsADivider && !childIsDisabled) menuItemCount++;
      });
      return menuItemCount;
    }
  }, {
    key: 'getLastSelectedIndex',
    value: function getLastSelectedIndex(props, filteredChildren) {
      var _this3 = this;

      var selectedIndex = -1;
      var menuItemIndex = 0;

      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';

        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
        if (!childIsADivider) menuItemIndex++;
      });

      return selectedIndex;
    }
  }, {
    key: 'setFocusIndexStartsWith',
    value: function setFocusIndexStartsWith(event, keys, filteredChildren) {
      var foundIndex = -1;
      _react2.default.Children.forEach(filteredChildren, function (child, index) {
        if (foundIndex >= 0) {
          return;
        }
        var primaryText = child.props.primaryText;

        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
          foundIndex = index;
        }
      });
      if (foundIndex >= 0) {
        this.setFocusIndex(event, foundIndex, true);
        return true;
      }
      return false;
    }
  }, {
    key: 'handleMenuItemClick',
    value: function handleMenuItemClick(event, item, index) {
      var children = this.props.children;
      var multiple = this.props.multiple;
      var valueLink = this.getValueLink(this.props);
      var menuValue = valueLink.value;
      var itemValue = item.props.value;
      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);

      this.setFocusIndex(event, focusIndex, false);

      if (multiple) {
        menuValue = menuValue || [];

        var itemIndex = menuValue.indexOf(itemValue);

        var _menuValue = menuValue,
            _menuValue2 = (0, _toArray3.default)(_menuValue),
            newMenuValue = _menuValue2.slice(0);

        if (itemIndex === -1) {
          newMenuValue.push(itemValue);
        } else {
          newMenuValue.splice(itemIndex, 1);
        }

        valueLink.requestChange(event, newMenuValue);
      } else if (!multiple && itemValue !== menuValue) {
        valueLink.requestChange(event, itemValue);
      }

      this.props.onItemClick(event, item, index);
    }
  }, {
    key: 'incrementKeyboardFocusIndex',
    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
      var index = this.state.focusIndex;
      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;

      index++;
      if (index > maxIndex) index = maxIndex;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'isChildSelected',
    value: function isChildSelected(child, props) {
      var menuValue = this.getValueLink(props).value;
      var childValue = child.props.value;

      if (props.multiple) {
        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
      } else {
        return child.props.hasOwnProperty('value') && menuValue === childValue;
      }
    }
  }, {
    key: 'setFocusIndex',
    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
      if (this.props.onMenuItemFocusChange) {
        // Do this even if `newIndex === this.state.focusIndex` to allow users
        // to detect up-arrow on the first MenuItem or down-arrow on the last.
        this.props.onMenuItemFocusChange(event, newIndex);
      }
      this.setState({
        focusIndex: newIndex,
        isKeyboardFocused: isKeyboardFocused
      });
    }
  }, {
    key: 'setScollPosition',
    value: function setScollPosition() {
      var desktop = this.props.desktop;
      var focusedMenuItem = this.refs.focusedMenuItem;
      var menuItemHeight = desktop ? 32 : 48;

      if (focusedMenuItem) {
        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;

        // Make the focused item be the 2nd item in the list the user sees
        var scrollTop = selectedOffSet - menuItemHeight;
        if (scrollTop < menuItemHeight) scrollTop = 0;

        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
      }
    }
  }, {
    key: 'cancelScrollEvent',
    value: function cancelScrollEvent(event) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = _reactDom2.default.findDOMNode(this);
      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
      var elWidth = el.offsetWidth;
      var keyWidth = this.state.keyWidth;
      var minWidth = keyWidth * 1.5;
      var keyIncrements = elWidth / keyWidth;
      var newWidth = void 0;

      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
      newWidth = keyIncrements * keyWidth;

      if (newWidth < minWidth) newWidth = minWidth;

      el.style.width = newWidth + 'px';
      listEl.style.width = newWidth + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          desktop = _props.desktop,
          disableAutoFocus = _props.disableAutoFocus,
          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          multiple = _props.multiple,
          onItemClick = _props.onItemClick,
          onEscKeyDown = _props.onEscKeyDown,
          onMenuItemFocusChange = _props.onMenuItemFocusChange,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          menuItemStyle = _props.menuItemStyle,
          style = _props.style,
          value = _props.value,
          valueLink = _props.valueLink,
          width = _props.width,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemClick', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);

      var filteredChildren = this.getFilteredChildren(children);

      var menuItemIndex = 0;
      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
        var childIsDisabled = child.props.disabled;
        var childName = child.type ? child.type.muiName : '';
        var newChild = child;

        switch (childName) {
          case 'MenuItem':
            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
            break;

          case 'Divider':
            newChild = _react2.default.cloneElement(child, {
              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
            });
            break;
        }

        if (childName === 'MenuItem' && !childIsDisabled) {
          menuItemIndex++;
        }

        return newChild;
      });

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.handleClickAway },
        _react2.default.createElement(
          'div',
          {
            onKeyDown: this.handleKeyDown,
            onWheel: this.handleOnWheel,
            style: prepareStyles(mergedRootStyles),
            ref: 'scrollContainer',
            role: 'presentation'
          },
          _react2.default.createElement(
            _List2.default,
            (0, _extends3.default)({}, other, {
              ref: 'list',
              style: mergedListStyles,
              role: 'menu'
            }),
            newChildren
          )
        )
      );
    }
  }]);
  return Menu;
}(_react.Component);

Menu.defaultProps = {
  autoWidth: true,
  desktop: false,
  disableAutoFocus: false,
  initiallyKeyboardFocused: false,
  maxHeight: null,
  multiple: false,
  onChange: function onChange() {},
  onEscKeyDown: function onEscKeyDown() {},
  onItemClick: function onItemClick() {},
  onKeyDown: function onKeyDown() {}
};
Menu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleClickAway = function (event) {
    if (event.defaultPrevented) {
      return;
    }

    var focusIndex = _this5.state.focusIndex;

    if (focusIndex < 0) {
      return;
    }

    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var focusedItem = filteredChildren[focusIndex];
    if (!!focusedItem && focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
      return;
    }

    _this5.setFocusIndex(event, -1, false);
  };

  this.handleKeyDown = function (event) {
    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var key = (0, _keycode2.default)(event);
    switch (key) {
      case 'down':
        event.preventDefault();
        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        break;
      case 'esc':
        _this5.props.onEscKeyDown(event);
        break;
      case 'tab':
        event.preventDefault();
        if (event.shiftKey) {
          _this5.decrementKeyboardFocusIndex(event);
        } else {
          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        }
        break;
      case 'up':
        event.preventDefault();
        _this5.decrementKeyboardFocusIndex(event);
        break;
      default:
        if (key && key.length === 1) {
          var hotKeys = _this5.hotKeyHolder.append(key);
          if (_this5.setFocusIndexStartsWith(event, hotKeys, filteredChildren)) {
            event.preventDefault();
          }
        }
    }
    _this5.props.onKeyDown(event);
  };

  this.handleOnWheel = function (event) {
    var scrollContainer = _this5.refs.scrollContainer;
    // Only scroll lock if the the Menu is scrollable.
    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;

    var scrollTop = scrollContainer.scrollTop,
        scrollHeight = scrollContainer.scrollHeight,
        clientHeight = scrollContainer.clientHeight;

    var wheelDelta = event.deltaY;
    var isDeltaPositive = wheelDelta > 0;

    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
      scrollContainer.scrollTop = scrollHeight;
      return _this5.cancelScrollEvent(event);
    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
      scrollContainer.scrollTop = 0;
      return _this5.cancelScrollEvent(event);
    }
  };
};

Menu.propTypes =  false ? {
  /**
   * If true, the width of the menu will be set automatically
   * according to the widths of its children,
   * using proper keyline increments (64px for desktop,
   * 56px otherwise).
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The content of the menu. This is usually used to pass `MenuItem`
   * elements.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the menu item will render with compact desktop styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu will not be auto-focused.
   */
  disableAutoFocus: _propTypes2.default.bool,
  /**
   * If true, the menu will be keyboard-focused initially.
   */
  initiallyKeyboardFocused: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the menu in pixels. If specified,
   * the menu will be scrollable if it is taller than the provided
   * height.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item with `value` not
   * equal to the current `value` of the menu is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   * @param {any}  value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is focused and the *Esc* key
   * is pressed.
   *
   * @param {object} event `keydown` event targeting the menu.
   */
  onEscKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   * @param {object} menuItem The menu item.
   * @param {number} index The index of the menu item.
   */
  onItemClick: _propTypes2.default.func,
  /** @ignore */
  onKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when the focus on a `MenuItem` is changed.
   * There will be some "duplicate" changes reported if two different
   * focusing event happen, for example if a `MenuItem` is focused via
   * the keyboard and then it is clicked on.
   *
   * @param {object} event The event that triggered the focus change.
   * The event can be null since the focus can be changed for non-event
   * reasons such as prop changes.
   * @param {number} newFocusIndex The index of the newly focused
   * `MenuItem` or `-1` if focus was lost.
   */
  onMenuItemFocusChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   * This component also supports valueLink.
   */
  value: _propTypes2.default.any,
  /**
   * ValueLink for the menu's `value`.
   */
  valueLink: _propTypes2.default.object,
  /**
   * The width of the menu. If not specified, the menu's width
   * will be set according to the widths of its children, using
   * proper keyline increments (64px for desktop, 56px otherwise).
   */
  width: _propTypes4.default.stringOrNumber
} : {};
exports.default = Menu;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Snackbar = __webpack_require__(1844);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Snackbar2.default;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableRowColumn = context.muiTheme.tableRowColumn;


  var styles = {
    root: {
      paddingLeft: tableRowColumn.spacing,
      paddingRight: tableRowColumn.spacing,
      height: tableRowColumn.height,
      textAlign: 'left',
      fontSize: 13,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  };

  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
    styles.textAlign = 'right';
  }

  return styles;
}

var TableRowColumn = function (_Component) {
  (0, _inherits3.default)(TableRowColumn, _Component);

  function TableRowColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableRowColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.onClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.props.columnNumber);
      }
    }, _this.onMouseEnter = function (event) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: true });
        if (_this.props.onHover) {
          _this.props.onHover(event, _this.props.columnNumber);
        }
      }
    }, _this.onMouseLeave = function (event) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: false });
        if (_this.props.onHoverExit) {
          _this.props.onHoverExit(event, _this.props.columnNumber);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableRowColumn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          columnNumber = _props.columnNumber,
          hoverable = _props.hoverable,
          onClick = _props.onClick,
          onHover = _props.onHover,
          onHoverExit = _props.onHoverExit,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var handlers = {
        onClick: this.onClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      };

      return _react2.default.createElement(
        'td',
        (0, _extends3.default)({
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, handlers, other),
        children
      );
    }
  }]);
  return TableRowColumn;
}(_react.Component);

TableRowColumn.defaultProps = {
  hoverable: false
};
TableRowColumn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableRowColumn.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * Number to identify the header row. This property
   * is automatically populated when used with TableHeader.
   */
  columnNumber: _propTypes2.default.number,
  /**
   * @ignore
   * If true, this column responds to hover events.
   */
  hoverable: _propTypes2.default.bool,
  /** @ignore */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onHover: _propTypes2.default.func,
  /**
   * @ignore
   * Callback function for hover exit event.
   */
  onHoverExit: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableRowColumn;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMoreVert = function NavigationMoreVert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
NavigationMoreVert.displayName = 'NavigationMoreVert';
NavigationMoreVert.muiName = 'SvgIcon';

exports.default = NavigationMoreVert;

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-04-04 14:36:00 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-04-04 17:05:40
 */





var AwaitableBtn = function (_React$Component) {
    _inherits(AwaitableBtn, _React$Component);

    function AwaitableBtn(props, context) {
        _classCallCheck(this, AwaitableBtn);

        var _this = _possibleConstructorReturn(this, (AwaitableBtn.__proto__ || Object.getPrototypeOf(AwaitableBtn)).call(this, props, context));

        _this.state = { waiting: false };

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(AwaitableBtn, [{
        key: "onClick",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.setState({ waiting: true });
                                _context.prev = 1;
                                _context.next = 4;
                                return this.props.children.props.onClick(e);

                            case 4:
                                _context.prev = 4;

                                this.setState({ waiting: false });
                                return _context.finish(4);

                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1,, 4, 7]]);
            }));

            function onClick(_x) {
                return _ref.apply(this, arguments);
            }

            return onClick;
        }()
    }, {
        key: "render",
        value: function render() {
            var _props$children$props = this.props.children.props,
                onClick = _props$children$props.onClick,
                disabled = _props$children$props.disabled,
                className = _props$children$props.className;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](this.props.children, {
                    onClick: this.onClick,
                    disabled: this.state.waiting || disabled,
                    className: className || "" + (" awaitable-btn " + (this.state.waiting ? " wait" : ""))
                })
            );
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AwaitableBtn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = AwaitableBtn;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AwaitableBtn, "AwaitableBtn", "/opt/atlassian/pipelines/agent/build/client/app/components/Base/AwaitableBtn/index.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Base/AwaitableBtn/index.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(793),
    eq = __webpack_require__(255);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserSelector__ = __webpack_require__(1883);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-10-23 10:43:48 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-10-23 11:07:57
 */



var _default = __WEBPACK_IMPORTED_MODULE_0__UserSelector__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Base/UserSelector/index.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_DatePicker__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/require-default-props */
/*
 * @Author: steelhouse 
 * @Date: 2018-08-15 15:25:07 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-08-15 16:28:37
 */








var styles = {
    labelStyle: { fontSize: '10px' },
    RaisedButtonStyle: { height: '25px', margin: '0 10px 0 0' },
    RaisedButtonButtonStyles: { height: '25px', lineHeight: '25px' },
    DatePickerErrorStyle: { fontSize: '13px', width: '90px', margin: '0 10px 0 0' },
    DatePickerTextFieldStyle: { fontSize: '13px', width: '90px', margin: '0 10px 0 0' }
};

var DateRangeSelector = function (_React$Component) {
    _inherits(DateRangeSelector, _React$Component);

    function DateRangeSelector(props) {
        _classCallCheck(this, DateRangeSelector);

        var _this = _possibleConstructorReturn(this, (DateRangeSelector.__proto__ || Object.getPrototypeOf(DateRangeSelector)).call(this, props));

        _this.setCurrentDate = _this.setCurrentDate.bind(_this);
        _this.setSelectedDate = _this.setSelectedDate.bind(_this);
        _this.setDay = _this.setDay.bind(_this);
        return _this;
    }

    _createClass(DateRangeSelector, [{
        key: 'computeRangeConstraints',


        /**
         * 
         * @param {Date|undefined} fromDate 
         * @param {Date|undefined} untilDate 
         */
        value: function computeRangeConstraints(fromDate, untilDate) {
            var from = fromDate ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(fromDate) : __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc();
            var until = untilDate ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(untilDate) : __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc();

            var minFrom = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc();
            var maxFrom = until;

            var minUntil = __WEBPACK_IMPORTED_MODULE_2_moment___default()(from);
            var maxUntil = __WEBPACK_IMPORTED_MODULE_2_moment___default()(from).add(2, 'years');

            var disabledRemoveDayFromBtn = __WEBPACK_IMPORTED_MODULE_2_moment___default()(from).isSameOrBefore(minFrom, 'days');
            var disabledAddDayFromBtn = __WEBPACK_IMPORTED_MODULE_2_moment___default()(from).isSameOrAfter(maxFrom, 'days');

            var disabledRemoveDayUntilFromBtn = __WEBPACK_IMPORTED_MODULE_2_moment___default()(until).isSameOrBefore(minUntil, 'days');
            var disabledAddDayUntilBtn = __WEBPACK_IMPORTED_MODULE_2_moment___default()(until).isSameOrAfter(maxUntil, 'days');

            return {
                from: from.local(true).toDate(),
                until: until.local(true).toDate(),
                minFrom: minFrom.local(true).toDate(),
                maxFrom: maxFrom.local(true).toDate(),
                minUntil: minUntil.local(true).toDate(),
                maxUntil: maxUntil.local(true).toDate(),
                disabledRemoveDayFromBtn: disabledRemoveDayFromBtn,
                disabledAddDayFromBtn: disabledAddDayFromBtn,
                disabledRemoveDayUntilFromBtn: disabledRemoveDayUntilFromBtn,
                disabledAddDayUntilBtn: disabledAddDayUntilBtn
            };
        }
    }, {
        key: 'setSelectedDate',
        value: function setSelectedDate(date, type) {
            // date picker return selected date in local timezone, so change to utc here
            var inUtc = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).utcOffset(0, true);
            this._changeDate(inUtc, type);
        }
    }, {
        key: 'setCurrentDate',
        value: function setCurrentDate(type) {
            var currentDate = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc();

            this._changeDate(currentDate, type);
        }
    }, {
        key: 'setDay',
        value: function setDay(type, direction) {
            var _props = this.props,
                from = _props.from,
                until = _props.until,
                onChange = _props.onChange;


            if (!from || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(from).isValid()) {
                from = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc().toDate();
            }

            if (type === 'from') {
                from = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(from).add(direction, 'days').toDate();
            } else {
                var baseUntil = !until || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(until).isValid() ? __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(from) : __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(until);
                until = baseUntil.add(direction, 'days').toDate();
            }

            if (!until || !__WEBPACK_IMPORTED_MODULE_2_moment___default()(until).isValid() || __WEBPACK_IMPORTED_MODULE_2_moment___default()(until).isBefore(from)) {
                until = from;
            }

            if (onChange) {
                onChange({ from: from, until: until });
            }
        }
    }, {
        key: '_changeDate',
        value: function _changeDate(date, type) {
            var _props2 = this.props,
                from = _props2.from,
                until = _props2.until;


            if (type === 'from') {
                from = this.onSetFrom(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(date)).toDate();

                if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(from).isAfter(until)) {
                    until = this.onSetUntil(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(from)).toDate();
                }
            } else {
                until = this.onSetUntil(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(date)).toDate();

                if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(from).isAfter(until)) {
                    from = this.onSetFrom(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(until)).toDate();
                }
            }

            this.props.onChange({
                from: from,
                until: until
            });
        }

        /**
         * 
         * @param {moment.Moment} date 
         * @returns {moment.Moment}
         */

    }, {
        key: 'onSetFrom',
        value: function onSetFrom(date) {
            return date.set({
                hours: 0, minutes: 0, seconds: 0, milliseconds: 0
            });
        }

        /**
         * 
         * @param {moment.Moment} date 
         * @returns {moment.Moment}
         */

    }, {
        key: 'onSetUntil',
        value: function onSetUntil(date) {
            return date.set({
                hours: 23, minutes: 59, seconds: 59, milliseconds: 999
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                fromDate = _props3.from,
                untilDate = _props3.until,
                fromHint = _props3.fromHint,
                untilHint = _props3.untilHint,
                fromLabel = _props3.fromLabel,
                untilLabel = _props3.untilLabel,
                errorFrom = _props3.errorFrom,
                errorUntil = _props3.errorUntil;

            var _computeRangeConstrai = this.computeRangeConstraints(fromDate, untilDate),
                from = _computeRangeConstrai.from,
                until = _computeRangeConstrai.until,
                maxFrom = _computeRangeConstrai.maxFrom,
                minFrom = _computeRangeConstrai.minFrom,
                maxUntil = _computeRangeConstrai.maxUntil,
                minUntil = _computeRangeConstrai.minUntil,
                disabledAddDayFromBtn = _computeRangeConstrai.disabledAddDayFromBtn,
                disabledRemoveDayFromBtn = _computeRangeConstrai.disabledRemoveDayFromBtn,
                disabledAddDayUntilBtn = _computeRangeConstrai.disabledAddDayUntilBtn,
                disabledRemoveDayUntilFromBtn = _computeRangeConstrai.disabledRemoveDayUntilFromBtn;

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                null,
                fromLabel && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'div',
                        { className: 'column-left' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            'div',
                            { className: 'label' },
                            fromLabel
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    null,
                    fromHint ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'span',
                        { style: { color: '#f00', fontSize: '12px' } },
                        'Date from clarified ',
                        __WEBPACK_IMPORTED_MODULE_2_moment___default()(fromHint).format('DD-MM-YYYY')
                    ) : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'row full' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.labelStyle,
                        style: styles.RaisedButtonStyle,
                        buttonStyle: styles.RaisedButtonButtonStyles,
                        label: 'Current date',
                        onClick: function onClick() {
                            return _this2.setCurrentDate('from');
                        },
                        primary: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.labelStyle,
                        style: styles.RaisedButtonStyle,
                        buttonStyle: styles.RaisedButtonButtonStyles,
                        label: '-day',
                        onClick: function onClick() {
                            return _this2.setDay('from', -1);
                        },
                        primary: true,
                        disabled: disabledRemoveDayFromBtn
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_DatePicker___default.a, {
                        autoOk: true,
                        maxDate: maxFrom,
                        minDate: minFrom,
                        value: from,
                        id: 'uniqueid',
                        errorText: errorFrom,
                        errorStyle: styles.DatePickerErrorStyle,
                        textFieldStyle: styles.DatePickerTextFieldStyle,
                        onChange: function onChange(e, date) {
                            return _this2.setSelectedDate(date, 'from');
                        },
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD-MM-YYYY');
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.labelStyle,
                        style: styles.RaisedButtonStyle,
                        buttonStyle: styles.RaisedButtonButtonStyles,
                        label: '+day',
                        onClick: function onClick() {
                            return _this2.setDay('from', 1);
                        },
                        primary: true,
                        disabled: disabledAddDayFromBtn
                    })
                ),
                untilLabel && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'div',
                        { className: 'column-left' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            'div',
                            { className: 'label' },
                            untilLabel
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    null,
                    untilHint ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'span',
                        { style: { color: '#f00', fontSize: '12px' } },
                        'Date from clarified ',
                        __WEBPACK_IMPORTED_MODULE_2_moment___default()(untilHint).format('DD-MM-YYYY')
                    ) : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'row full' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.labelStyle,
                        style: styles.RaisedButtonStyle,
                        buttonStyle: styles.RaisedButtonButtonStyles,
                        label: 'Current date',
                        onClick: function onClick() {
                            return _this2.setCurrentDate('until');
                        },
                        primary: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.labelStyle,
                        style: styles.RaisedButtonStyle,
                        buttonStyle: styles.RaisedButtonButtonStyles,
                        onClick: function onClick() {
                            return _this2.setDay('until', -1);
                        },
                        label: '-day',
                        primary: true,
                        disabled: disabledRemoveDayUntilFromBtn
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_DatePicker___default.a, {
                        autoOk: true,
                        maxDate: maxUntil,
                        minDate: minUntil,
                        value: until,
                        id: 'uniqueid',
                        errorText: errorUntil,
                        errorStyle: styles.DatePickerErrorStyle,
                        textFieldStyle: styles.DatePickerTextFieldStyle,
                        onChange: function onChange(e, date) {
                            return _this2.setSelectedDate(date, 'until');
                        },
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD-MM-YYYY');
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.labelStyle,
                        style: styles.RaisedButtonStyle,
                        buttonStyle: styles.RaisedButtonButtonStyles,
                        onClick: function onClick() {
                            return _this2.setDay('until', 1);
                        },
                        label: '+day',
                        primary: true,
                        disabled: disabledAddDayUntilBtn
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return DateRangeSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DateRangeSelector.propTypes = {
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["instanceOf"](Date), __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
    until: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["instanceOf"](Date), __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),

    fromHint: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["instanceOf"](Date), __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
    untilHint: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["instanceOf"](Date), __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
    fromLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    untilLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    errorFrom: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    errorUntil: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]
};
var _default = DateRangeSelector;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/DateRangeSelector/index.js');
    reactHotLoader.register(DateRangeSelector, 'DateRangeSelector', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/DateRangeSelector/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/DateRangeSelector/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionOpenInNew = function ActionOpenInNew(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
  );
};
ActionOpenInNew = (0, _pure2.default)(ActionOpenInNew);
ActionOpenInNew.displayName = 'ActionOpenInNew';
ActionOpenInNew.muiName = 'SvgIcon';

exports.default = ActionOpenInNew;

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FocusManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribable__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(70);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* isServer */] && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(__WEBPACK_IMPORTED_MODULE_1__subscribable__["a" /* Subscribable */]);
var focusManager = new FocusManager();

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLogger;
/* harmony export (immutable) */ __webpack_exports__["b"] = setLogger;
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Flag = function (_React$Component) {
    _inherits(Flag, _React$Component);

    function Flag(props) {
        _classCallCheck(this, Flag);

        var _this = _possibleConstructorReturn(this, (Flag.__proto__ || Object.getPrototypeOf(Flag)).call(this, props));

        _this.changeSelect = _this.changeSelect.bind(_this);
        return _this;
    }

    _createClass(Flag, [{
        key: 'changeSelect',
        value: function changeSelect(e, i, value) {
            this.props.changeAutoComplete('flag', this.props.countries.find(function (country) {
                return country._id === value;
            }));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getCountries();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                getError = _props.getError,
                countries = _props.countries,
                confirmed = _props.confirmed,
                flagObject = _props.flagObject,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                {
                    value: flagObject._id,
                    onChange: this.changeSelect,
                    errorText: getError && getError('flag'),
                    maxHeight: 200,
                    name: 'flag',
                    disabled: confirmed,
                    floatingLabelText: 'Flag',
                    fullWidth: true,

                    underlineStyle: modifiedFields && modifiedFields.includes('flag') ? underStyle : null
                },
                countries.map(function (country, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                        key: index,
                        value: country._id,
                        primaryText: country.name
                    });
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Flag;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var items = _ref.countries.items;

    return {
        countries: items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCountries: __WEBPACK_IMPORTED_MODULE_3_actions_countries__["a" /* getCountries */]
    }, dispatch);
})(Flag);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Flag, 'Flag', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Flag.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Flag.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_vesselTypes__ = __webpack_require__(279);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TypeByPurpose = function (_React$Component) {
    _inherits(TypeByPurpose, _React$Component);

    function TypeByPurpose() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TypeByPurpose);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeByPurpose.__proto__ || Object.getPrototypeOf(TypeByPurpose)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (value) {
            var _this$props = _this.props,
                changeField = _this$props.changeField,
                fromTcOrder = _this$props.fromTcOrder;


            var toChange = [{ field: 'typeByPurpose', value: value }];

            if (fromTcOrder) {
                toChange.push(fromTcOrder && !['MPP', 'PASSCAR'].includes(value) && { field: 'linerMeterMin', value: null }, fromTcOrder && !['MPP', 'PASSCAR'].includes(value) && { field: 'linerMeterMax', value: null }, fromTcOrder && !['MPP', 'CONT'].includes(value) && { field: 'teuMin', value: null }, fromTcOrder && !['MPP', 'CONT'].includes(value) && { field: 'teuMax', value: null });
            } else {
                !['MPP', 'PASSCAR'].includes(value) && toChange.push({ field: 'linerMeter', value: null });
            }

            changeField(toChange);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TypeByPurpose, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                type = _props.type,
                modifiedFields = _props.modifiedFields,
                purposeErrorField = _props.purposeErrorField,
                underStyle = _props.underStyle;


            var hasErrorBorder = purposeErrorField && purposeErrorField.hasOwnProperty('borderColor');
            var isModified = modifiedFields && modifiedFields.includes('typeByPurpose');

            var underlineStyle = null;
            if (hasErrorBorder) {
                underlineStyle = purposeErrorField;
            } else if (isModified) {
                underlineStyle = underStyle;
            }

            var floatingLabelStyle = hasErrorBorder ? { color: purposeErrorField.borderColor } : null;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
                {
                    value: type,
                    disabled: confirmed,
                    onChange: function onChange(e, index, value) {
                        return _this2.onChange(value);
                    },
                    maxHeight: 200,
                    name: 'typeByPurpose',
                    floatingLabelText: 'Type By Purpose',
                    errorText: getError && getError.typeByPurpose,
                    fullWidth: true,
                    input: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { required: true }),
                    required: true,
                    underlineStyle: underlineStyle,
                    floatingLabelStyle: floatingLabelStyle
                },
                __WEBPACK_IMPORTED_MODULE_3_constants_vesselTypes__["b" /* types */].map(function (type, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                        key: i,
                        value: type,
                        primaryText: type
                    });
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TypeByPurpose;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TypeByPurpose;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TypeByPurpose, 'TypeByPurpose', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeByPurpose.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeByPurpose.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_vessel__ = __webpack_require__(827);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







/**
 * @param {{
 *  getError?: Function,
 *  changeField: Function,
 *  confirmed?: boolean,
 *  type: '' | 'SID' | 'TWEEN',
 *  modifiedFields?: any,
 *  underStyle?: React.CSSProperties,
 * }} props 
 * @returns 
 */
var TypeByConstruction = function TypeByConstruction(props) {
    var getError = props.getError,
        changeField = props.changeField,
        confirmed = props.confirmed,
        type = props.type,
        modifiedFields = props.modifiedFields,
        underStyle = props.underStyle;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
        {
            value: type,
            disabled: confirmed,
            onChange: function onChange(_e, _index, value) {
                changeField({
                    field: 'typeByConstruction',
                    value: value
                });
            },
            maxHeight: 200,
            name: 'typeByConstruction',
            floatingLabelText: 'Type By Construction',
            errorText: getError && getError('typeByConstruction'),
            fullWidth: true,

            underlineStyle: modifiedFields && modifiedFields.includes('typeByConstruction') ? underStyle : null
        },
        __WEBPACK_IMPORTED_MODULE_3_constants_vessel__["a" /* TYPES_BY_CONSTRUCTION */].map(function (t, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                key: t + '_' + i,
                value: t,
                primaryText: t
            });
        })
    );
};

var _default = TypeByConstruction;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TypeByConstruction, 'TypeByConstruction', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeByConstruction.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeByConstruction.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var types = ['CR', 'DR', 'GN', 'HC', 'BT', 'CL', 'WN', 'PM'];
var typeName = ['Gear', 'Derrick', 'Gantry', 'Hose Crane', 'Boom Transporter', 'Cargo Lift', 'Winch', 'Pump'];

var GearV2 = function (_React$Component) {
    _inherits(GearV2, _React$Component);

    function GearV2(props) {
        _classCallCheck(this, GearV2);

        var _this = _possibleConstructorReturn(this, (GearV2.__proto__ || Object.getPrototypeOf(GearV2)).call(this, props));

        _this.addGear = _this.addGear.bind(_this);
        _this.removeGear = _this.removeGear.bind(_this);
        return _this;
    }

    _createClass(GearV2, [{
        key: 'addGear',
        value: function addGear() {
            var gearV2 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.gearV2);

            gearV2.summary.push({
                type: '',
                quantity: undefined,
                capacity: undefined,
                outreach: undefined,
                radius: undefined,
                maxSWL: undefined,
                combinable: false
            });

            this.props.changeField([{ field: 'gearV2', value: gearV2 }]);
        }
    }, {
        key: 'removeGear',
        value: function removeGear(index) {
            var gearV2 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.gearV2);
            gearV2.summary.splice(index, 1);
            this.props.changeField([{ field: 'gearV2', value: gearV2 }]);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                changeField = _props.changeField,
                getError = _props.getError,
                gearV2 = _props.gearV2,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle,
                toggleLabelStyle = _props.toggleLabelStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                gearV2.summary.map(function (gear, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: index, className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-' + (_this2.props.fromTc ? '3' : '2') },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                                {
                                    value: gearV2.summary[index].type || '',
                                    onChange: function onChange(e, i, value) {
                                        changeField([{
                                            field: 'gearV2[summary][' + index + '].type',
                                            value: value
                                        }, {
                                            field: 'geared',
                                            value: true
                                        }]);
                                    },
                                    disabled: confirmed,
                                    errorText: getError && getError('gearV2[summary][' + index + '].type')
                                    // maxHeight={200}
                                    , name: 'type',
                                    floatingLabelText: 'Type',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    fullWidth: true,
                                    autoWidth: true,

                                    underlineStyle: modifiedFields && modifiedFields.includes('gearV2[summary][' + index + '].type') ? underStyle : null
                                },
                                types.map(function (type, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                        key: index,
                                        value: type,
                                        primaryText: typeName[index]
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                name: 'gearV2[summary].quantity',
                                floatingLabelText: 'Quantity',
                                floatingLabelStyle: { fontSize: '13px' },
                                value: gearV2.summary[index].quantity || '',
                                fullWidth: true,
                                disabled: !gearV2.summary[index].type,
                                errorText: getError && getError('gearV2[summary][' + index + '].quantity'),
                                onChange: function onChange(e, value) {
                                    changeField([{
                                        field: 'gearV2[summary][' + index + '].quantity',
                                        value: value,
                                        type: 'number'
                                    }]);
                                },
                                underlineStyle: modifiedFields && modifiedFields.includes('gearV2[summary][' + index + '].quantity') ? underStyle : null
                            })
                        ),
                        _this2.props.fromTc !== true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                    name: 'gearV2[summary].capacity',
                                    floatingLabelText: 'Capacity, mt',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    value: gearV2.summary[index].capacity || '',
                                    fullWidth: true,
                                    floatNumber: true,
                                    disabled: !gearV2.summary[index].type,
                                    errorText: getError && getError('gearV2[summary][' + index + '].capacity'),
                                    onChange: function onChange(e, value) {
                                        changeField([{
                                            field: 'gearV2[summary][' + index + '].capacity',
                                            value: value,
                                            type: 'number'
                                        }]);
                                    },

                                    underlineStyle: modifiedFields && modifiedFields.includes('gearV2[summary][' + index + '].capacity') ? underStyle : null

                                })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                    name: 'gearV2[summary].capacityMin',
                                    floatingLabelText: 'Capacity min, mt',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    value: gearV2.summary[index].capacityMin || '',
                                    fullWidth: true,
                                    type: 'number',
                                    disabled: !gearV2.summary[index].type,
                                    onChange: function onChange(e, value) {
                                        changeField([{
                                            field: 'gearV2[summary][' + index + '].capacityMin',
                                            value: value,
                                            type: 'number'
                                        }]);
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                    name: 'gearV2[summary].capacityMax',
                                    floatingLabelText: 'Capacity max, mt',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    value: gearV2.summary[index].capacityMax || '',
                                    fullWidth: true,
                                    floatNumber: true,
                                    disabled: !gearV2.summary[index].type,
                                    onChange: function onChange(e, value) {
                                        changeField([{
                                            field: 'gearV2[summary][' + index + '].capacityMax',
                                            value: value,
                                            type: 'number'
                                        }]);
                                    }
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                name: 'outreach',
                                floatingLabelText: 'Outreach, m',
                                floatingLabelStyle: { fontSize: '13px' },
                                value: gearV2.summary[index].outreach || '',
                                errorText: getError && getError('gearV2[summary][' + index + '].outreach'),
                                fullWidth: true,
                                floatNumber: true,
                                disabled: !gearV2.summary[index].type,
                                onChange: function onChange(e, value) {
                                    changeField([{
                                        field: 'gearV2[summary][' + index + '].outreach',
                                        value: value,
                                        type: 'number'
                                    }]);
                                },

                                underlineStyle: modifiedFields && modifiedFields.includes('gearV2[summary][' + index + '].outreach') ? underStyle : null
                            })
                        ),
                        _this2.props.fromTc !== true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-1' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                    name: 'radius',
                                    floatingLabelText: 'Radius, m',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    value: gearV2.summary[index].radius || '',
                                    errorText: getError && getError('gearV2[summary][' + index + '].radius'),
                                    fullWidth: true,
                                    disabled: !gearV2.summary[index].type,
                                    floatNumber: true,
                                    onChange: function onChange(e, value) {
                                        changeField([{
                                            field: 'gearV2[summary][' + index + '].radius',
                                            value: value,
                                            type: 'number'
                                        }]);
                                    },
                                    underlineStyle: modifiedFields && modifiedFields.includes('gearV2[summary][' + index + '].radius') ? underStyle : null
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                    name: 'maxSWL',
                                    floatingLabelText: 'max SWL, mt',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    value: gearV2.summary[index].maxSWL || '',
                                    errorText: getError && getError('gearV2[summary][' + index + '].maxSWL'),
                                    fullWidth: true,
                                    disabled: !gearV2.summary[index].type,
                                    floatNumber: true,
                                    onChange: function onChange(e, value) {
                                        changeField([{
                                            field: 'gearV2[summary][' + index + '].maxSWL',
                                            value: value,
                                            type: 'number'
                                        }]);
                                    },

                                    underlineStyle: modifiedFields && modifiedFields.includes('gearV2[summary][' + index + '].maxSWL') ? underStyle : null
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-1 middle-xs center-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { margin: '25px 0 0 0' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle___default.a, {
                                        name: 'combinable',
                                        label: 'Comby',
                                        disabled: !gearV2.summary[index].type,
                                        toggled: gearV2.summary[index].combinable,
                                        onToggle: function onToggle(e, value) {
                                            changeField([{
                                                field: 'gearV2[summary][' + index + '].combinable',
                                                value: value
                                            }]);
                                        },

                                        labelStyle: modifiedFields && modifiedFields.includes('gearV2[summary][' + index + '].combinable') ? toggleLabelStyle : null
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1 middle-xs center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { margin: '25px 0 0 0' } },
                                index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: confirmed
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                        onClick: _this2.addGear,
                                        color: 'green'
                                    })
                                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: confirmed
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                        onClick: function onClick() {
                                            _this2.removeGear(index);
                                        },
                                        color: 'red'
                                    })
                                )
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return GearV2;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = GearV2;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(types, 'types', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GearV2.jsx');
    reactHotLoader.register(typeName, 'typeName', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GearV2.jsx');
    reactHotLoader.register(GearV2, 'GearV2', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GearV2.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GearV2.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Base_NumberField__ = __webpack_require__(63);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










var grabNames = ['Electro-hydraulic', 'Mechanical', 'Electro-hydraulic remote control', 'Mechanical remote control'];

var GrabV2 = function GrabV2(props) {
    var changeField = props.changeField,
        getError = props.getError,
        grabs = props.grabs,
        confirmed = props.confirmed,
        modifiedFields = props.modifiedFields,
        underStyle = props.underStyle,
        fromTc = props.fromTc;


    var addGrab = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var next = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(grabs);
        next.summary.push({
            type: '',
            quantity: '',
            volume: '',
            maxSWL: ''
        });
        changeField({ field: 'grabV2', value: next });
    }, [grabs, changeField]);

    var removeGrab = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (index) {
        var next = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(grabs);
        next.summary.splice(index, 1);
        changeField({ field: 'grabV2', value: next });
    }, [grabs, changeField]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        grabs.summary.map(function (grab, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'grabV2_' + index, className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                        {
                            value: grabs.summary[index].type || '',
                            onChange: function onChange(e, i, value) {
                                changeField([{
                                    field: 'grabV2[summary][' + index + '].type',
                                    value: value
                                }, { field: 'grabbed', value: true }, { field: 'geared', value: true }]);
                            },
                            disabled: confirmed,
                            errorText: getError && getError('grabV2[summary][' + index + '].type'),
                            maxHeight: 200,
                            name: 'type',
                            floatingLabelText: 'Type',
                            floatingLabelStyle: { fontSize: '13px' },
                            fullWidth: true,
                            autoWidth: true,

                            underlineStyle: modifiedFields && modifiedFields.includes('grabV2[summary][' + index + '].type') ? underStyle : null

                        },
                        grabNames.map(function (grabName, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                key: index,
                                value: grabName,
                                primaryText: grabName
                            });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-' + (fromTc ? '2' : '3') },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                        name: 'grabV2.summary.quantity',
                        floatingLabelText: 'Quantity',
                        floatingLabelStyle: { fontSize: '13px' },
                        value: grabs.summary[index].quantity || '',
                        fullWidth: true,
                        disabled: !grabs.summary[index].type,
                        errorText: getError && getError('grabV2[summary][' + index + '].quantity'),
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'grabV2[summary][' + index + '].quantity',
                                value: value,
                                type: 'number'
                            });
                        },

                        underlineStyle: modifiedFields && modifiedFields.includes('grabV2[summary][' + index + '].quantity') ? underStyle : null

                    })
                ),
                fromTc !== true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                            name: 'grabV2.summary.volume',
                            floatingLabelText: 'Volume, cbm',
                            floatingLabelStyle: { fontSize: '13px' },
                            value: grabs.summary[index].volume || '',
                            fullWidth: true,
                            floatNumber: true,
                            disabled: !grabs.summary[index].type,
                            errorText: getError && getError('grabV2[summary].' + index + '.volume'),
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'grabV2[summary][' + index + '].volume',
                                    value: value,
                                    type: 'number'
                                });
                            },

                            underlineStyle: modifiedFields && modifiedFields.includes('grabV2[summary][' + index + '].volume') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                            name: 'grabV2.summary.maxSWL',
                            floatingLabelText: 'Max SWL, m3',
                            floatingLabelStyle: { fontSize: '13px' },
                            value: grabs.summary[index].maxSWL || '',
                            fullWidth: true,
                            floatNumber: true,
                            disabled: !grabs.summary[index].type,
                            errorText: getError && getError('grabV2[summary].' + index + '.maxSWL'),
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'grabV2[summary].' + index + '.maxSWL',
                                    value: value,
                                    type: 'number'
                                });
                            },

                            underlineStyle: modifiedFields && modifiedFields.includes('grabV2[summary][' + index + '].maxSWL') ? underStyle : null
                        })
                    )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                            name: 'grabV2.summary.volumeMin',
                            floatingLabelText: 'Volume min, cbm',
                            floatingLabelStyle: { fontSize: '13px' },
                            value: grabs.summary[index].volumeMin || '',
                            fullWidth: true,
                            floatNumber: true,
                            disabled: !grabs.summary[index].type,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'grabV2[summary][' + index + '].volumeMin',
                                    value: value,
                                    type: 'number'
                                });
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                            name: 'grabV2.summary.volumeMax',
                            floatingLabelText: 'Volume max, cbm',
                            floatingLabelStyle: { fontSize: '13px' },
                            value: grabs.summary[index].volumeMax || '',
                            fullWidth: true,
                            floatNumber: true,
                            disabled: !grabs.summary[index].type,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'grabV2[summary][' + index + '].volumeMax',
                                    value: value,
                                    type: 'number'
                                });
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-1 middle-xs center-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { margin: '25px 0 0 0' } },
                        index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                            {
                                disabled: confirmed
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                onClick: addGrab,
                                color: 'green'
                            })
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                            {
                                disabled: confirmed
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                onClick: function onClick() {
                                    removeGrab(index);
                                },
                                color: 'red'
                            })
                        )
                    )
                )
            );
        })
    );
};

var _default = GrabV2;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(grabNames, 'grabNames', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GrabV2.jsx');
    reactHotLoader.register(GrabV2, 'GrabV2', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GrabV2.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GrabV2.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = prepareExclToLoad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Chip__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Chip__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var mainRole = 'owner';

function withExclusions(getData, Component) {
    return function (_React$Component) {
        _inherits(_class, _React$Component);

        function _class(props) {
            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _this.state = {
                exclusionsData: [],
                currentExcl: { _id: '', name: '' }
            };
            _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
            _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
            _this.renderRestrictions = _this.renderRestrictions.bind(_this);
            _this.handleRequestDelete = _this.handleRequestDelete.bind(_this);
            return _this;
        }

        _createClass(_class, [{
            key: 'changeAutoComplete',
            value: function changeAutoComplete(searchText) {
                var _this2 = this;

                this.setState({
                    exclusionsData: [],
                    currentExcl: _extends({}, this.state.currentExcl, {
                        name: searchText
                    })
                }, function () {
                    if (searchText.length >= 2) {
                        getData(searchText).then(function (response) {
                            if (response.status === 200) {
                                var exclusions = response.data.data.map(function (exclusion) {
                                    return _extends({}, exclusion);
                                });

                                if (!exclusions.length) {
                                    _this2.setState({
                                        exclusionsData: [],
                                        currentExcl: _extends({}, _this2.state.currentExcl, {
                                            name: searchText
                                        })
                                    });
                                } else {
                                    _this2.setState({
                                        exclusionsData: exclusions
                                    });
                                }
                            }
                        }).catch(function (error) {
                            console.error('Error AutoComplete Trading Restrictions - Trading Restrictions component', error);
                            return null;
                        });
                    }
                });
            }
        }, {
            key: 'chooseAutoComplete',
            value: function chooseAutoComplete(type, updateProperties) {
                if (!updateProperties || !updateProperties._id) return;

                this.setState({
                    exclusionsData: [],
                    currentExcl: _extends({}, this.state.currentExcl, {
                        name: ''
                    })
                });
                if (this.props[type].find(function (excl) {
                    return excl._id === updateProperties._id;
                })) {
                    console.log(this.props[type].find(function (excl) {
                        return excl._id === updateProperties._id;
                    }), updateProperties);
                    return;
                };
                this.props.changeField({
                    field: type,
                    value: [].concat(_toConsumableArray(this.props[type]), [updateProperties])
                });
            }
        }, {
            key: 'handleRequestDelete',
            value: function handleRequestDelete(type, excl) {
                var newRestrictions = this.props[type].filter(function (restriction) {
                    if (restriction._id === excl._id) {
                        if (restriction.role === excl.role) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                });
                this.props.changeField({
                    field: type,
                    value: newRestrictions
                });
            }
        }, {
            key: 'renderRestrictions',
            value: function renderRestrictions(type) {
                var _this3 = this;

                return this.props[type].map(function (excl) {
                    var ownersExcl = excl.role === mainRole;
                    var canDelete = ownersExcl && _this3.props.deleteOwners || !ownersExcl;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Chip___default.a
                        //onRequestDelete={!ownersExcl ? () => this.handleRequestDelete(type, excl._id) : null}
                        ,
                        { onRequestDelete: canDelete ? function () {
                                return _this3.handleRequestDelete(type, excl);
                            } : null,
                            labelStyle: { maxWidth: canDelete ? 'calc(100% - 24px)' : '', display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis' },
                            style: { margin: 4, maxWidth: '100%' },
                            key: excl._id + excl.role,
                            backgroundColor: ownersExcl ? '#E6E6E6' : '#D6EDBD'
                        },
                        excl.name
                    );
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var renderRestrictions = this.renderRestrictions,
                    handleRequestDelete = this.handleRequestDelete,
                    chooseAutoComplete = this.chooseAutoComplete,
                    changeAutoComplete = this.changeAutoComplete;
                var _state = this.state,
                    exclusionsData = _state.exclusionsData,
                    currentExcl = _state.currentExcl;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({ dataSource: exclusionsData, currentExcl: currentExcl, renderExcl: renderRestrictions, del: handleRequestDelete, choose: chooseAutoComplete, change: changeAutoComplete }, this.props));
            }
        }, {
            key: '__reactstandin__regenerateByEval',
            // @ts-ignore
            value: function __reactstandin__regenerateByEval(key, code) {
                // @ts-ignore
                this[key] = eval(code);
            }
        }]);

        return _class;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
}

var _default = withExclusions;
/* harmony default export */ __webpack_exports__["a"] = (_default);

function prepareExclToLoad(list) {
    var isRewriteOwnerExclusions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return isRewriteOwnerExclusions ? list.map(function (item) {
        return { id: item._id };
    }) : list.filter(function (item) {
        return item.role !== 'owner';
    }).map(function (item) {
        return { id: item._id };
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(mainRole, 'mainRole', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/withExclusions.js');
    reactHotLoader.register(withExclusions, 'withExclusions', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/withExclusions.js');
    reactHotLoader.register(prepareExclToLoad, 'prepareExclToLoad', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/withExclusions.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/withExclusions.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GearedGrabbed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);


(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var gearedGrabbedMap = {
    geared: {
        name: 'geared',
        notSet: 'Gears not set',
        isTrue: 'Geared',
        isFalse: 'Gearless'
    },
    grabbed: {
        name: 'grabbed',
        notSet: 'Grabs not set',
        isTrue: 'Grabbed',
        isFalse: 'Grabless'
    }
};

/**
 * 
 * @param {{
 *  gearedGrabbed: boolean | null, 
 *  fieldName: string, 
 *  confirmed: boolean, 
 *  modifiedFields?: string[],
 *  styles: React.CSSProperties,
 *  onChange: Function
 * }} param0 
 * @returns 
 */
function GearedGrabbed(_ref) {
    var _ref$gearedGrabbed = _ref.gearedGrabbed,
        gearedGrabbed = _ref$gearedGrabbed === undefined ? null : _ref$gearedGrabbed,
        fieldName = _ref.fieldName,
        confirmed = _ref.confirmed,
        modifiedFields = _ref.modifiedFields,
        styles = _ref.styles,
        _onChange = _ref.onChange;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
        {
            value: gearedGrabbed,
            style: { margin: (gearedGrabbed === null ? '-20px' : '-35px') + ' 0 -25px 0' },
            onChange: function onChange(e, i, value) {
                return _onChange(value);
            },
            disabled: !confirmed,
            name: gearedGrabbedMap[fieldName].name,
            floatingLabelText: gearedGrabbed !== null && gearedGrabbedMap[fieldName].isTrue,
            underlineStyle: modifiedFields && modifiedFields.includes(gearedGrabbedMap[fieldName].name) ? styles.underlineStyle : null,
            fullWidth: true
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_MenuItem___default.a, { value: null, primaryText: gearedGrabbedMap[fieldName].notSet }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_MenuItem___default.a, { value: true, primaryText: gearedGrabbedMap[fieldName].isTrue }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_MenuItem___default.a, { value: false, primaryText: gearedGrabbedMap[fieldName].isFalse })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(gearedGrabbedMap, 'gearedGrabbedMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GearedGrabbed.jsx');
    reactHotLoader.register(GearedGrabbed, 'GearedGrabbed', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/GearedGrabbed.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextDispatchHireOrders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Management__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_AnnotationsEditor__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HiresTable__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_letters__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_AnnotationsList__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hireOrdersReducer__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_ErrorBoundary__ = __webpack_require__(239);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





















var ContextDispatchHireOrders = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);

function LetterHire(props) {
    var _this = this;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ annotationsServer: 'mailparse.net', clarifiedServer: 'standart' }),
        _useState2 = _slicedToArray(_useState, 2),
        servers = _useState2[0],
        setServers = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        annotations = _useState4[0],
        setAnnotations = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState6 = _slicedToArray(_useState5, 2),
        annotationsLoaded = _useState6[0],
        setAnnotationsLoaded = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState8 = _slicedToArray(_useState7, 2),
        updated = _useState8[0],
        setUpdated = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState10 = _slicedToArray(_useState9, 2),
        openedAttachmentsDialog = _useState10[0],
        setOpenedAttachmentsDialog = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.location.state ? props.location.state.modifiedTextLetter : ''),
        _useState12 = _slicedToArray(_useState11, 2),
        modifiedTextLetter = _useState12[0],
        setModifiedTextLetter = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.location.state ? props.location.state.initialTextLetter : ''),
        _useState14 = _slicedToArray(_useState13, 2),
        initialTextLetter = _useState14[0],
        setInitialTextLetter = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState16 = _slicedToArray(_useState15, 2),
        letter = _useState16[0],
        setLetter = _useState16[1];

    var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_16__hireOrdersReducer__["a" /* reducer */], []),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        stateHireOrders = _useReducer2[0],
        dispatchHireOrders = _useReducer2[1];

    var _getLetterData = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var editedText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var _ref2, _letter, annotationsResponse, clarifiedLetter;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            setAnnotationsLoaded(false);
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].getLetter(props.routeParams.id);

                        case 4:
                            _ref2 = _context.sent;
                            _letter = _ref2.data;


                            setLetter(_letter);

                            _letter.gazettersArr = [];
                            _letter.type = 'hire';
                            _letter.fromHireOrders = true;

                            if (editedText) {
                                _letter.text = editedText;
                            }

                            _context.next = 13;
                            return __WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].postAnnotations(_letter.text,
                            // _letter.type,
                            'vessel', // temporal - due to nonexistant hire annotations server
                            servers.annotationsServer, {
                                emailId: _letter._id,
                                subject: _letter.subject,
                                date: __WEBPACK_IMPORTED_MODULE_10_moment___default()(_letter.date).format('DD-MM-YYYY')
                            });

                        case 13:
                            annotationsResponse = _context.sent;


                            if (annotationsResponse) {
                                _letter.gazettersArr = annotationsResponse.data.annotations;
                                setAnnotationsLoaded(true);
                                setAnnotations(_letter.gazettersArr);
                                if (annotationsResponse.data.newclarified) {
                                    _letter.newclarified = annotationsResponse.data.newclarified;
                                }
                            }

                            _context.next = 17;
                            return __WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].updateLetter(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.omit(_letter, 'gazettersArr'), servers.clarifiedServer);

                        case 17:
                            clarifiedLetter = _context.sent;


                            setLetter(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.omit(_letter, 'gazettersArr'));

                            if (clarifiedLetter.status === 200) {
                                if (clarifiedLetter.data.clarified && clarifiedLetter.data.clarified.length > 0) {
                                    // TODO: fill with hire orders when hire clarified arrives
                                    dispatchHireOrders({ type: 'CLEAR_ORDERS' });
                                } else {
                                    Object(__WEBPACK_IMPORTED_MODULE_15_helpers__["c" /* showNotification */])('Hire orders were not created.', 'warning');
                                    dispatchHireOrders({ type: 'CLEAR_ORDERS' });
                                }
                            } else {
                                Object(__WEBPACK_IMPORTED_MODULE_15_helpers__["c" /* showNotification */])('Hire orders were not created.', 'warning');
                                dispatchHireOrders({ type: 'CLEAR_ORDERS' });
                            }
                            _context.next = 25;
                            break;

                        case 22:
                            _context.prev = 22;
                            _context.t0 = _context['catch'](0);

                            props.addNotification({
                                type: __WEBPACK_IMPORTED_MODULE_6_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                                notification: {
                                    title: 'Error',
                                    message: _context.t0.errors.messages[0],
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 10
                                }
                            });

                        case 25:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[0, 22]]);
        }));

        return function _getLetterData() {
            return _ref.apply(this, arguments);
        };
    }();

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (modifiedTextLetter) {
            _getLetterData(modifiedTextLetter);
        } else {
            _getLetterData();
        }

        return function () {
            props.removeGazetters();
            props.removeAnnotations();
            props.removeLetter();
        };
    }, []);

    var updatePostGazetters = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_textLetter) {
            var _gazetters;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            setAnnotationsLoaded(false);
                            setAnnotations([]);
                            setUpdated(true);
                            _context2.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].postGazetters(_textLetter, {
                                emailId: letter._id,
                                subject: letter.subject,
                                date: __WEBPACK_IMPORTED_MODULE_10_moment___default()(letter.date).format('DD-MM-YYYY')
                            });

                        case 5:
                            _gazetters = _context2.sent;


                            setAnnotations(_gazetters.data.map(function (gazetter, key) {
                                return _extends({}, gazetter, {
                                    id: key,
                                    state: ''
                                });
                            }));
                            setAnnotationsLoaded(true);

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function updatePostGazetters(_x2) {
            return _ref3.apply(this, arguments);
        };
    }();

    var addOrderTable = function addOrderTable() {
        dispatchHireOrders({ type: 'ADD_ORDER' });
    };

    var removeOrderTable = function removeOrderTable() {
        dispatchHireOrders({ type: 'REMOVE_ORDER' });
    };

    var clearOrderTable = function clearOrderTable() {
        dispatchHireOrders({ type: 'CLEAR_ORDERS' });
    };

    /**
     * @param {import('../../../../mocks/hire/order').HireOrderRaw} order 
     */
    var checkForErrors = function checkForErrors(order) {
        var vesselData = order.vesselData,
            hire = order.hire,
            hireType = order.hireType,
            delivery = order.delivery,
            redelivery = order.redelivery;

        /** @type {{ field: string, message: string }[]} */

        var errors = [];

        if (!vesselData._id) errors.push({ field: 'vesselName', message: 'Vessel ID is required.' });

        if (!hire) errors.push({ field: 'hire', message: 'Hire value is required' });

        if (!hireType) errors.push({ field: 'hireType', message: 'Hire type is required' });

        if (!delivery._id) errors.push({ field: 'delivery', message: 'Delivery is required' });

        if (!redelivery._id) errors.push({ field: 'redelivery', message: 'Redelivery is required' });

        return errors;
    };

    /**
     * @param {import('../../../../mocks/hire/order').HireOrderRaw} order 
     */
    var prepareHire = function prepareHire(order) {
        var vesselData = order.vesselData,
            cargo = order.cargo,
            cargoRegion = order.cargoRegion,
            delivery = order.delivery,
            redelivery = order.redelivery,
            hire = order.hire;

        return _extends({}, __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.pick(order, ['hireType', 'duration', 'lay', 'can']), {
            cargoId: cargo ? cargo._id : undefined,
            vesselId: vesselData ? vesselData._id : undefined,
            cargoRegionId: cargoRegion ? cargoRegion._id : undefined,
            delivery: delivery._id,
            redelivery: redelivery._id,
            mailId: letter._id,
            hire: parseFloat(hire)
        });
    };

    var sendRequestHire = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var hasErrors, preparedHires, results;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            console.log(stateHireOrders);

                            hasErrors = false;


                            stateHireOrders.forEach(function (order, index) {
                                var errors = checkForErrors(order);

                                if (errors.length) {
                                    hasErrors = true;
                                    errors.forEach(function (error) {
                                        return Object(__WEBPACK_IMPORTED_MODULE_15_helpers__["c" /* showNotification */])('Hire #' + (index + 1) + ' --- ' + error.message, 'error', { autoDismiss: 20 });
                                    });
                                }
                            });

                            if (!hasErrors) {
                                _context3.next = 5;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 5:
                            preparedHires = stateHireOrders.map(function (h) {
                                return prepareHire(h);
                            });
                            _context3.next = 8;
                            return Promise.all(preparedHires.map(function (h) {
                                return __WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].postRequestHire(h);
                            })).catch(function (e) {
                                return Object(__WEBPACK_IMPORTED_MODULE_15_helpers__["c" /* showNotification */])(e.message);
                            });

                        case 8:
                            results = _context3.sent;


                            results && results.forEach(function (res, index) {
                                if (res.errors.length) {
                                    Object(__WEBPACK_IMPORTED_MODULE_15_helpers__["c" /* showNotification */])('Hire #' + (index + 1) + ' --- ' + res.errors[0].messages[0], 'error', { autoDismiss: 20 });
                                } else {
                                    Object(__WEBPACK_IMPORTED_MODULE_15_helpers__["c" /* showNotification */])('Success hire request', 'success', { autoDismiss: 20 });
                                }
                            });

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function sendRequestHire() {
            return _ref4.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'single-letter-hire', className: 'single-letter' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'content', style: { width: '60vw' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Management__["a" /* default */], {
                getLetterData: _getLetterData,
                openedAttachmentsDialog: openedAttachmentsDialog,
                originalText: initialTextLetter || letter.text,
                routeParams: props.routeParams,
                router: props.router,
                textLetter: modifiedTextLetter || letter.text,
                toggleAttachmentsDialog: function toggleAttachmentsDialog() {
                    return setOpenedAttachmentsDialog(!openedAttachmentsDialog);
                },
                updatePostGazetters: updatePostGazetters,
                servers: servers,
                setServers: setServers,
                letter: letter
            }),
            updated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18__common_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_AnnotationsEditor__["a" /* default */], { letterText: letter.text })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18__common_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_AnnotationsEditor__["a" /* default */], { letterText: modifiedTextLetter || letter.text })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18__common_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_AnnotationsList__["a" /* default */], { annotations: annotations, annotationsLoaded: annotationsLoaded })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'sidebar', style: { width: '40vw' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                null,
                'Hire orders'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18__common_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    ContextDispatchHireOrders.Provider,
                    { value: dispatchHireOrders },
                    stateHireOrders.map(function (o, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HiresTable__["a" /* default */], { key: 'hireOrder_' + i, hireOrderNumber: i, hireOrder: o });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'controller-orders', style: { width: '40vw' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui__["g" /* FlatButton */], { style: { color: 'white' }, onClick: addOrderTable, label: 'Add' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui__["g" /* FlatButton */], { style: { color: 'white' }, onClick: removeOrderTable, label: 'Remove' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui__["g" /* FlatButton */], { style: { color: 'white' }, onClick: clearOrderTable, label: 'Clear' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui__["g" /* FlatButton */], { style: { color: 'white' }, onClick: sendRequestHire, label: 'Send' })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        postGazetters: __WEBPACK_IMPORTED_MODULE_7_actions_gazetters__["a" /* postGazetters */],
        removeGazetters: __WEBPACK_IMPORTED_MODULE_7_actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_8_actions_annotations__["b" /* removeAnnotations */],
        removeLetter: __WEBPACK_IMPORTED_MODULE_9_actions_letters__["a" /* removeLetter */],
        addNotification: __WEBPACK_IMPORTED_MODULE_12__actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(LetterHire);

/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ContextDispatchHireOrders, 'ContextDispatchHireOrders', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/LetterHire.jsx');
    reactHotLoader.register(LetterHire, 'LetterHire', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/LetterHire.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/LetterHire.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export hireTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIRE_TYPES_MAP; });
/* unused harmony export FUEL_TYPES_MAP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HiresExportFieldsMapping; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var hireTypes = ['hireIdea', 'fixedRate', 'offerRate'];

var HIRE_TYPES_MAP = [{
    field: 'hireIdea',
    placeHolder: 'Hire Idea'
}, {
    field: 'fixedRate',
    placeHolder: 'Fixed Rate'
}, {
    field: 'offerRate',
    placeHolder: 'Offer Rate'
}];

var fuelTypesTuple = [['ifo180', 'IFO 180'], ['mgo', 'IFO 180'], ['vlsfo', 'IFO 180']];

var FUEL_TYPES_MAP = fuelTypesTuple.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        field = _ref2[0],
        placeHolder = _ref2[1];

    return { field: field, placeHolder: placeHolder };
});

/**
 * @typedef {'hireIdea' | 'fixedRate' | 'offerRate'} HireType
 */

var HiresExportFieldsMapping = new Map([['vessel.imoNumber', { placeHolder: 'Imo number' }], ['vessel.name', { placeHolder: 'Name' }], ['vessel.blt', { placeHolder: 'Blt' }], ['vessel.deadWeight.sDWT', { placeHolder: 'DWT' }], ['vessel.typeByPurpose', { placeHolder: 'Type by Purpose' }], ['vessel.typeByConstruction', { placeHolder: 'Type by Construction' }], ['vessel.geared', { placeHolder: 'Geared' }], ['vessel.capacity.grain', { placeHolder: 'Capacity (grain)' }], ['vessel.capacity.bale', { placeHolder: 'Capacity (bale)' }], ['vessel.capacity.teu', { placeHolder: 'Capacity (teu)' }], ['vessel.capacity.feu', { placeHolder: 'Capacity (feu)' }], ['vessel.speedConsumptionV2.mode', { placeHolder: 'Speed consumption mode' }], ['vessel.speedConsumptionV2.speed', { placeHolder: 'Speed' }], ['vessel.speedConsumptionV2.ifo.typeIfo', { placeHolder: 'Consumption ifo type' }], ['vessel.speedConsumptionV2.ifo.cons', { placeHolder: 'Consumption ifo' }], ['vessel.speedConsumptionV2.mdo.typeMdo', { placeHolder: 'Consumption mdo type' }], ['vessel.speedConsumptionV2.mdo.cons', { placeHolder: 'Consumption mdo' }], ['vesselDwtGroup.name', { placeHolder: 'Dwt group' }], ['vesselDwtGroup.min', { placeHolder: 'Dwt group (min)' }], ['vesselDwtGroup.max', { placeHolder: 'Dwt group (max)' }], ['placeFrom.name', { placeHolder: 'Place from' }], ['regionFrom.name', { placeHolder: 'Region from' }], ['regionFrom.mainRegion', { placeHolder: 'Region from (main region)' }], ['regionFrom.isInBalticIndex', { placeHolder: 'Region from (baltic index)' }], ['delivery.name', { placeHolder: 'Delivery' }], ['mainRegionDelivery.name', { placeHolder: 'Main region delivery' }], ['placeTo.name', { placeHolder: 'Place to' }], ['regionTo.name', { placeHolder: 'Region to' }], ['regionTo.mainRegion', { placeHolder: 'Region to (main region)' }], ['regionTo.isInBalticIndex', { placeHolder: 'Region to (baltic index)' }], ['redelivery.name', { placeHolder: 'Redelivery' }], ['mainRegionRedelivery.name', { placeHolder: 'Main region redelivery' }], ['lay', { placeHolder: 'Lay' }], ['can', { placeHolder: 'Can' }], ['hireType', { placeHolder: 'Hire type' }], ['hire', { placeHolder: 'Hire' }], ['via', { placeHolder: 'Via' }], ['duration', { placeHolder: 'Duration' }], ['clean', { placeHolder: 'Clean' }], ['balastBonus', { placeHolder: 'Balast bonus' }], ['intake', { placeHolder: 'Intake' }], ['roundTrip', { placeHolder: 'Round trip' }], ['fuelPrice.vlsfo', { placeHolder: 'Fuel price (vlsfo)' }], ['fuelPrice.mgo', { placeHolder: 'Fuel price (mgo)' }], ['fuelPrice.ifo380', { placeHolder: 'Fuel price (ifo380)' }], ['bunkerPlace.areaParent', { placeHolder: 'Bunker place (area parent)' }], ['bunkerPlace.name', { placeHolder: 'Bunker place (name)' }], ['duration', { placeHolder: 'Duration' }], ['cargoRegionId.areaParent', { placeHolder: 'Cargo region (area parent)' }], ['cargoRegionId.mainRegion', { placeHolder: 'Cargo region (main region)' }], ['cargoRegionId.name', { placeHolder: 'Cargo region (name)' }], ['cargoTypeId.name', { placeHolder: 'Cargo type' }],
// ['cargo', { placeHolder: 'Cargo' }],
['addedBy.email', { placeHolder: 'Added by (email)' }], ['createdAt', { placeHolder: 'Created at' }]]);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(hireTypes, 'hireTypes', '/opt/atlassian/pipelines/agent/build/client/app/constants/hire.js');
    reactHotLoader.register(HIRE_TYPES_MAP, 'HIRE_TYPES_MAP', '/opt/atlassian/pipelines/agent/build/client/app/constants/hire.js');
    reactHotLoader.register(fuelTypesTuple, 'fuelTypesTuple', '/opt/atlassian/pipelines/agent/build/client/app/constants/hire.js');
    reactHotLoader.register(FUEL_TYPES_MAP, 'FUEL_TYPES_MAP', '/opt/atlassian/pipelines/agent/build/client/app/constants/hire.js');
    reactHotLoader.register(HiresExportFieldsMapping, 'HiresExportFieldsMapping', '/opt/atlassian/pipelines/agent/build/client/app/constants/hire.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettings = function ActionSettings(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
  );
};
ActionSettings = (0, _pure2.default)(ActionSettings);
ActionSettings.displayName = 'ActionSettings';
ActionSettings.muiName = 'SvgIcon';

exports.default = ActionSettings;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.beginDrag = beginDrag;
exports.publishDragSource = publishDragSource;
exports.hover = hover;
exports.drop = drop;
exports.endDrag = endDrag;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(67);

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = __webpack_require__(89);

var _isObject2 = _interopRequireDefault(_isObject);

var _matchesType = __webpack_require__(871);

var _matchesType2 = _interopRequireDefault(_matchesType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = exports.HOVER = 'dnd-core/HOVER';
var DROP = exports.DROP = 'dnd-core/DROP';
var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';

function beginDrag(sourceIds) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
	var publishSource = options.publishSource,
	    clientOffset = options.clientOffset,
	    getSourceClientOffset = options.getSourceClientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');

	for (var i = 0; i < sourceIds.length; i++) {
		(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	}

	var sourceId = null;
	for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
		if (monitor.canDragSource(sourceIds[_i])) {
			sourceId = sourceIds[_i];
			break;
		}
	}
	if (sourceId === null) {
		return;
	}

	var sourceClientOffset = null;
	if (clientOffset) {
		(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
		sourceClientOffset = getSourceClientOffset(sourceId);
	}

	var source = registry.getSource(sourceId);
	var item = source.beginDrag(monitor, sourceId);
	(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');

	registry.pinSource(sourceId);

	var itemType = registry.getSourceType(sourceId);
	return {
		type: BEGIN_DRAG,
		itemType: itemType,
		item: item,
		sourceId: sourceId,
		clientOffset: clientOffset,
		sourceClientOffset: sourceClientOffset,
		isSourcePublic: publishSource
	};
}

function publishDragSource() {
	var monitor = this.getMonitor();
	if (!monitor.isDragging()) {
		return;
	}

	return { type: PUBLISH_DRAG_SOURCE };
}

function hover(targetIdsArg) {
	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    _ref$clientOffset = _ref.clientOffset,
	    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
	var targetIds = targetIdsArg.slice(0);

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');

	// First check invariants.
	for (var i = 0; i < targetIds.length; i++) {
		var targetId = targetIds[i];
		(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');

		var target = registry.getTarget(targetId);
		(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
	}

	var draggedItemType = monitor.getItemType();

	// Remove those targetIds that don't match the targetType.  This
	// fixes shallow isOver which would only be non-shallow because of
	// non-matching targets.
	for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
		var _targetId = targetIds[_i2];
		var targetType = registry.getTargetType(_targetId);
		if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
			targetIds.splice(_i2, 1);
		}
	}

	// Finally call hover on all matching targets.
	for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
		var _targetId2 = targetIds[_i3];
		var _target = registry.getTarget(_targetId2);
		_target.hover(monitor, _targetId2);
	}

	return {
		type: HOVER,
		targetIds: targetIds,
		clientOffset: clientOffset
	};
}

function drop() {
	var _this = this;

	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');

	var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);

	targetIds.reverse();
	targetIds.forEach(function (targetId, index) {
		var target = registry.getTarget(targetId);

		var dropResult = target.drop(monitor, targetId);
		(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
		if (typeof dropResult === 'undefined') {
			dropResult = index === 0 ? {} : monitor.getDropResult();
		}

		_this.store.dispatch({
			type: DROP,
			dropResult: _extends({}, options, dropResult)
		});
	});
}

function endDrag() {
	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');

	var sourceId = monitor.getSourceId();
	var source = registry.getSource(sourceId, true);
	source.endDrag(monitor, sourceId);

	registry.unpinSource();

	return { type: END_DRAG };
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addSource = addSource;
exports.addTarget = addTarget;
exports.removeSource = removeSource;
exports.removeTarget = removeTarget;
var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';

function addSource(sourceId) {
	return {
		type: ADD_SOURCE,
		sourceId: sourceId
	};
}

function addTarget(targetId) {
	return {
		type: ADD_TARGET,
		targetId: targetId
	};
}

function removeSource(sourceId) {
	return {
		type: REMOVE_SOURCE,
		sourceId: sourceId
	};
}

function removeTarget(targetId) {
	return {
		type: REMOVE_TARGET,
		targetId: targetId
	};
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = checkDecoratorArguments;
function checkDecoratorArguments(functionName, signature) {
	if (false) {
		for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
			var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
			if (arg && arg.prototype && arg.prototype.render) {
				// eslint-disable-next-line no-console
				console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
				return;
			}
		}
	}
}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1)
var PropTypes = __webpack_require__(5)
var Tag = __webpack_require__(2186)
var Input = __webpack_require__(2187)
var Suggestions = __webpack_require__(2188)

var KEYS = {
  ENTER: 13,
  TAB: 9,
  BACKSPACE: 8,
  UP_ARROW: 38,
  DOWN_ARROW: 40
}

var CLASS_NAMES = {
  root: 'react-tags',
  rootFocused: 'is-focused',
  selected: 'react-tags__selected',
  selectedTag: 'react-tags__selected-tag',
  selectedTagName: 'react-tags__selected-tag-name',
  search: 'react-tags__search',
  searchInput: 'react-tags__search-input',
  suggestions: 'react-tags__suggestions',
  suggestionActive: 'is-active',
  suggestionDisabled: 'is-disabled'
}

var ReactTags = (function (superclass) {
  function ReactTags (props) {
    superclass.call(this, props)

    this.state = {
      query: '',
      focused: false,
      expandable: false,
      selectedIndex: -1,
      classNames: Object.assign({}, CLASS_NAMES, this.props.classNames)
    }
  }

  if ( superclass ) ReactTags.__proto__ = superclass;
  ReactTags.prototype = Object.create( superclass && superclass.prototype );
  ReactTags.prototype.constructor = ReactTags;

  ReactTags.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
    this.setState({
      classNames: Object.assign({}, CLASS_NAMES, newProps.classNames)
    })
  };

  ReactTags.prototype.handleChange = function handleChange (e) {
    var query = e.target.value

    if (this.props.handleInputChange) {
      this.props.handleInputChange(query)
    }

    this.setState({ query: query })
  };

  ReactTags.prototype.handleKeyDown = function handleKeyDown (e) {
    var ref = this.state;
    var query = ref.query;
    var selectedIndex = ref.selectedIndex;

    // when one of the terminating keys is pressed, add current query to the tags.
    if (this.props.delimiters.indexOf(e.keyCode) !== -1) {
      (query || selectedIndex > -1) && e.preventDefault()

      if (query.length >= this.props.minQueryLength) {
        // Check if the user typed in an existing suggestion.
        var match = this.suggestions.state.options.findIndex(function (suggestion) {
          return suggestion.name.search(new RegExp(("^" + query + "$"), 'i')) === 0
        })

        var index = selectedIndex === -1 ? match : selectedIndex

        if (index > -1) {
          this.addTag(this.suggestions.state.options[index])
        } else if (this.props.allowNew) {
          this.addTag({ name: query })
        }
      }
    }

    // when backspace key is pressed and query is blank, delete the last tag
    if (e.keyCode === KEYS.BACKSPACE && query.length === 0 && this.props.allowBackspace) {
      this.deleteTag(this.props.tags.length - 1)
    }

    if (e.keyCode === KEYS.UP_ARROW) {
      e.preventDefault()

      // if last item, cycle to the bottom
      if (selectedIndex <= 0) {
        this.setState({ selectedIndex: this.suggestions.state.options.length - 1 })
      } else {
        this.setState({ selectedIndex: selectedIndex - 1 })
      }
    }

    if (e.keyCode === KEYS.DOWN_ARROW) {
      e.preventDefault()

      this.setState({ selectedIndex: (selectedIndex + 1) % this.suggestions.state.options.length })
    }
  };

  ReactTags.prototype.handleClick = function handleClick (e) {
    if (document.activeElement !== e.target) {
      this.input.input.focus()
    }
  };

  ReactTags.prototype.handleBlur = function handleBlur () {
    this.setState({ focused: false, selectedIndex: -1 })
  };

  ReactTags.prototype.handleFocus = function handleFocus () {
    this.setState({ focused: true })
  };

  ReactTags.prototype.addTag = function addTag (tag) {
    if (tag.disabled) {
      return
    }

    this.props.handleAddition(tag)

    // reset the state
    this.setState({
      query: '',
      selectedIndex: -1
    })
  };

  ReactTags.prototype.deleteTag = function deleteTag (i) {
    this.props.handleDelete(i)
    this.setState({ query: '' })
  };

  ReactTags.prototype.render = function render () {
    var this$1 = this;

    var listboxId = 'ReactTags-listbox'

    var TagComponent = this.props.tagComponent || Tag

    var tags = this.props.tags.map(function (tag, i) { return (
      React.createElement( TagComponent, {
        key: i, tag: tag, classNames: this$1.state.classNames, onDelete: this$1.deleteTag.bind(this$1, i) })
    ); })

    var expandable = this.state.focused && this.state.query.length >= this.props.minQueryLength
    var classNames = [this.state.classNames.root]

    this.state.focused && classNames.push(this.state.classNames.rootFocused)

    return (
      React.createElement( 'div', { className: classNames.join(' '), onClick: this.handleClick.bind(this) },
        React.createElement( 'div', { className: this.state.classNames.selected, 'aria-live': 'polite', 'aria-relevant': 'additions removals' },
          tags
        ),
        React.createElement( 'div', {
          className: this.state.classNames.search, onBlur: this.handleBlur.bind(this), onFocus: this.handleFocus.bind(this), onChange: this.handleChange.bind(this), onKeyDown: this.handleKeyDown.bind(this) },
          React.createElement( Input, Object.assign({}, this.state, { ref: function (c) { this$1.input = c }, listboxId: listboxId, autofocus: this.props.autofocus, autoresize: this.props.autoresize, expandable: expandable, placeholder: this.props.placeholder })),
          React.createElement( Suggestions, Object.assign({}, this.state, { ref: function (c) { this$1.suggestions = c }, listboxId: listboxId, expandable: expandable, suggestions: this.props.suggestions, addTag: this.addTag.bind(this), maxSuggestionsLength: this.props.maxSuggestionsLength }))
        )
      )
    )
  };

  return ReactTags;
}(React.Component));

ReactTags.defaultProps = {
  tags: [],
  placeholder: 'Add new tag',
  suggestions: [],
  autofocus: true,
  autoresize: true,
  delimiters: [KEYS.TAB, KEYS.ENTER],
  minQueryLength: 2,
  maxSuggestionsLength: 6,
  allowNew: false,
  allowBackspace: true,
  tagComponent: null
}

ReactTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object),
  placeholder: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.object),
  autofocus: PropTypes.bool,
  autoresize: PropTypes.bool,
  delimiters: PropTypes.arrayOf(PropTypes.number),
  handleDelete: PropTypes.func.isRequired,
  handleAddition: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func,
  minQueryLength: PropTypes.number,
  maxSuggestionsLength: PropTypes.number,
  classNames: PropTypes.object,
  allowNew: PropTypes.bool,
  allowBackspace: PropTypes.bool,
  tagComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element
  ])
}

module.exports = ReactTags


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowLeft = function HardwareKeyboardArrowLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' })
  );
};
HardwareKeyboardArrowLeft = (0, _pure2.default)(HardwareKeyboardArrowLeft);
HardwareKeyboardArrowLeft.displayName = 'HardwareKeyboardArrowLeft';
HardwareKeyboardArrowLeft.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowLeft;

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = CompaniesAutoComplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






/**
 * @param {{
 *  customValue?: string,
 *  style?: React.CSSProperties,
 *  popoverProps?: React.CSSProperties,
 *  textFieldStyle?: React.CSSProperties,
 *  underlineStyle?: React.CSSProperties,
 *  floatingLabelStyle?: React.CSSProperties,
 *  inputStyle?: React.CSSProperties,
 *  menuStyle?: React.CSSProperties,
 *  disabled?: boolean,
 *  hintText?: string,
 *  hintStyle?: React.CSSProperties,
 *  floatingLabelText?: string,
 *  errorText?: string,
 *  onTextChange?: Function,
 *  onCompanySelected: Function,
 *  resetInput?: boolean,
 *  withRealCompanies?: boolean,
 *  onlyWithOwner?: boolean,
 * }} param0 
 */
function CompaniesAutoComplete(_ref) {
    var _ref$customValue = _ref.customValue,
        customValue = _ref$customValue === undefined ? '' : _ref$customValue,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$popoverProps = _ref.popoverProps,
        popoverProps = _ref$popoverProps === undefined ? {} : _ref$popoverProps,
        _ref$textFieldStyle = _ref.textFieldStyle,
        textFieldStyle = _ref$textFieldStyle === undefined ? {} : _ref$textFieldStyle,
        _ref$underlineStyle = _ref.underlineStyle,
        underlineStyle = _ref$underlineStyle === undefined ? {} : _ref$underlineStyle,
        _ref$floatingLabelSty = _ref.floatingLabelStyle,
        floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
        _ref$inputStyle = _ref.inputStyle,
        inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
        _ref$menuStyle = _ref.menuStyle,
        menuStyle = _ref$menuStyle === undefined ? {} : _ref$menuStyle,
        _ref$hintStyle = _ref.hintStyle,
        hintStyle = _ref$hintStyle === undefined ? {} : _ref$hintStyle,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$hintText = _ref.hintText,
        hintText = _ref$hintText === undefined ? '' : _ref$hintText,
        _ref$floatingLabelTex = _ref.floatingLabelText,
        floatingLabelText = _ref$floatingLabelTex === undefined ? '' : _ref$floatingLabelTex,
        _ref$errorText = _ref.errorText,
        errorText = _ref$errorText === undefined ? undefined : _ref$errorText,
        _ref$onTextChange = _ref.onTextChange,
        onTextChange = _ref$onTextChange === undefined ? function () {} : _ref$onTextChange,
        _ref$onCompanySelecte = _ref.onCompanySelected,
        onCompanySelected = _ref$onCompanySelecte === undefined ? function (val) {} : _ref$onCompanySelecte,
        _ref$resetInput = _ref.resetInput,
        resetInput = _ref$resetInput === undefined ? false : _ref$resetInput,
        _ref$withRealCompanie = _ref.withRealCompanies,
        withRealCompanies = _ref$withRealCompanie === undefined ? false : _ref$withRealCompanie,
        _ref$onlyWithOwner = _ref.onlyWithOwner,
        onlyWithOwner = _ref$onlyWithOwner === undefined ? false : _ref$onlyWithOwner;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(customValue),
        _useState2 = _slicedToArray(_useState, 2),
        companyValue = _useState2[0],
        setCompanyValue = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        companies = _useState4[0],
        setCompanies = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState6 = _slicedToArray(_useState5, 2),
        preventFirstSearch = _useState6[0],
        setPreventFirstSearch = _useState6[1];

    var initialUpdateIgnoredRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__["a" /* default */])(companyValue, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPreventFirstSearch(false);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCompanyValue(customValue);
    }, [customValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].findCompany(debouncedSearchValue, withRealCompanies, onlyWithOwner).then(function (response) {
            var _companies = response.data.data.map(function (_company) {
                return {
                    name: _company.name,
                    item: _company
                };
            });

            setCompanies(_companies);
        }).catch(function () {
            return null;
        });
    }, [debouncedSearchValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (resetInput) {
            setCompanyValue('');
        }
    }, [resetInput]);

    var changeCompanyValue = function changeCompanyValue(val) {
        setCompanyValue(val);
    };

    var chooseCompany = function chooseCompany(val) {
        var next = val && val.name ? val.name : '';
        setCompanyValue(next);
        onCompanySelected(val);
        onTextChange(next);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
        name: 'company',
        searchText: companyValue,
        dataSource: companies,
        dataSourceConfig: { text: 'name', value: 'item' },
        hintText: hintText || 'Company name',
        floatingLabelText: floatingLabelText,
        errorText: errorText,
        onUpdateInput: function onUpdateInput(val) {
            if (!initialUpdateIgnoredRef.current) {
                initialUpdateIgnoredRef.current = true;
                if (!val) {
                    return;
                }
            }
            changeCompanyValue(val);
            onTextChange(val);
        },
        onNewRequest: function onNewRequest(val) {
            return chooseCompany(val);
        },
        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
        textFieldStyle: _extends({ fontSize: '13px' }, textFieldStyle),
        style: style,
        underlineStyle: _extends({}, underlineStyle),
        floatingLabelStyle: _extends({}, floatingLabelStyle),
        fullWidth: !style.width,
        listStyle: { overflow: 'auto', maxHeight: '300px' },
        inputStyle: _extends({}, inputStyle),
        popoverProps: _extends({
            canAutoPosition: true
        }, popoverProps),
        menuStyle: _extends({}, menuStyle),
        disabled: disabled,
        hintStyle: _extends({}, hintStyle)
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CompaniesAutoComplete, 'CompaniesAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/common/CompaniesAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _default = ["Bunker Trader", "Classification Society & Flag State representative", "Marine equipment & spare parts", "P & I", "Pilotage", "Port Agency", "Port Authority", "Port Operator", "Repairer & Shipbuilder", "Salvage & Rescue", "Ship Chandler", "Stevedoring Company", "Survey Company", "Towage"];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/data/portActivities.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = UserAutoComplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






/**
* @param {{
*  customValue?: string,
*  style?: React.CSSProperties,
*  popoverProps?: React.CSSProperties,
*  textFieldStyle?: React.CSSProperties,
*  underlineStyle?: React.CSSProperties,
*  floatingLabelStyle?: React.CSSProperties,
*  inputStyle?: React.CSSProperties,
*  menuStyle?: React.CSSProperties,
*  disabled?: boolean,
*  hintText?: string,
*  hintStyle?: React.CSSProperties,
*  onUserSelected: Function,
*  onUserChanging?: Function,
*  resetInput?: boolean,
*  withExtendedData?: boolean,
*  floatingLabelText?: string,
*  errorText?: string,
* }} param0 
*/

function UserAutoComplete(_ref) {
    var _this = this;

    var _ref$customValue = _ref.customValue,
        customValue = _ref$customValue === undefined ? '' : _ref$customValue,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$popoverProps = _ref.popoverProps,
        popoverProps = _ref$popoverProps === undefined ? {} : _ref$popoverProps,
        _ref$textFieldStyle = _ref.textFieldStyle,
        textFieldStyle = _ref$textFieldStyle === undefined ? {} : _ref$textFieldStyle,
        _ref$underlineStyle = _ref.underlineStyle,
        underlineStyle = _ref$underlineStyle === undefined ? {} : _ref$underlineStyle,
        _ref$floatingLabelSty = _ref.floatingLabelStyle,
        floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
        _ref$inputStyle = _ref.inputStyle,
        inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
        _ref$menuStyle = _ref.menuStyle,
        menuStyle = _ref$menuStyle === undefined ? {} : _ref$menuStyle,
        _ref$hintStyle = _ref.hintStyle,
        hintStyle = _ref$hintStyle === undefined ? {} : _ref$hintStyle,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$hintText = _ref.hintText,
        hintText = _ref$hintText === undefined ? '' : _ref$hintText,
        _ref$onUserSelected = _ref.onUserSelected,
        onUserSelected = _ref$onUserSelected === undefined ? function (val) {} : _ref$onUserSelected,
        _ref$onUserChanging = _ref.onUserChanging,
        onUserChanging = _ref$onUserChanging === undefined ? function (val) {} : _ref$onUserChanging,
        _ref$resetInput = _ref.resetInput,
        resetInput = _ref$resetInput === undefined ? false : _ref$resetInput,
        _ref$withExtendedData = _ref.withExtendedData,
        withExtendedData = _ref$withExtendedData === undefined ? false : _ref$withExtendedData,
        _ref$floatingLabelTex = _ref.floatingLabelText,
        floatingLabelText = _ref$floatingLabelTex === undefined ? '' : _ref$floatingLabelTex,
        _ref$errorText = _ref.errorText,
        errorText = _ref$errorText === undefined ? '' : _ref$errorText;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(customValue),
        _useState2 = _slicedToArray(_useState, 2),
        userEmailValue = _useState2[0],
        setUserEmailValue = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState4 = _slicedToArray(_useState3, 2),
        user = _useState4[0],
        setUser = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        users = _useState6[0],
        setUsers = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState8 = _slicedToArray(_useState7, 2),
        preventFirstSearch = _useState8[0],
        setPreventFirstSearch = _useState8[1];

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_2_helpers_useDebounce__["a" /* default */])(userEmailValue, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPreventFirstSearch(false);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setUserEmailValue(customValue || '');
    }, [customValue]);

    var setCompanyValueFromOutside = function setCompanyValueFromOutside() {
        setUserEmailValue('');
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (resetInput) {
            setUserEmailValue('');
        }
    }, [resetInput]);

    var changeEmail = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setUserEmailValue(value);
                            setUser(null);
                            if (onUserChanging) onUserChanging(value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function changeEmail(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 3) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].findUser(debouncedSearchValue, withExtendedData).then(function (res) {
            setUsers(res.data.data.map(function (item) {
                return {
                    user: item.email,
                    item: item
                };
            }));
        }).catch();
    }, [debouncedSearchValue]);

    var chooseEmail = function chooseEmail(val) {
        setUser(val);
        onUserSelected(val);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */], {
        name: 'userEmail',
        textFieldStyle: _extends({ fontSize: '13px' }, textFieldStyle),
        hintText: hintText || 'User email or id',
        searchText: userEmailValue,
        dataSource: users || [],
        dataSourceConfig: { text: 'user', value: 'item' },
        onUpdateInput: changeEmail,
        onNewRequest: chooseEmail,
        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */].noFilter,
        listStyle: { overflow: 'auto', maxHeight: '300px' },
        style: _extends({}, style),
        underlineStyle: _extends({}, underlineStyle),
        floatingLabelStyle: _extends({}, floatingLabelStyle),
        floatingLabelText: floatingLabelText,
        inputStyle: _extends({}, inputStyle),
        popoverProps: _extends({
            canAutoPosition: true,
            style: {
                width: '300px'
            }
        }, popoverProps),
        errorText: errorText,
        fullWidth: true,
        disabled: disabled,
        hintStyle: _extends({}, hintStyle),
        menuStyle: _extends({}, menuStyle)
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(UserAutoComplete, 'UserAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/common/UserAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHistory = function ActionHistory(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
  );
};
ActionHistory = (0, _pure2.default)(ActionHistory);
ActionHistory.displayName = 'ActionHistory';
ActionHistory.muiName = 'SvgIcon';

exports.default = ActionHistory;

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_google_maps__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_google_maps_lib_components_addons_MarkerWithLabel__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_google_maps_lib_components_addons_MarkerWithLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_google_maps_lib_components_addons_MarkerWithLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_data_formNames__ = __webpack_require__(64);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MapComponent = function (_Component) {
    _inherits(MapComponent, _Component);

    function MapComponent(props) {
        _classCallCheck(this, MapComponent);

        var _this = _possibleConstructorReturn(this, (MapComponent.__proto__ || Object.getPrototypeOf(MapComponent)).call(this, props));

        _this.state = {
            zoom: 1,
            center: {
                lat: 41.3533701,
                lng: -11.74670153
            }
        };

        if (_this.props.rememberOldCoords) {
            _this.state.oldCoords = _this.props.coordinates || [];
        }

        _this.mapOnClick = _this.mapOnClick.bind(_this);
        return _this;
    }

    _createClass(MapComponent, [{
        key: 'mapOnClick',
        value: function mapOnClick(event) {
            var latitude = event.latLng.lat();
            var longitude = event.latLng.lng();

            this.props.change && this.props.change('coordinates', [longitude, latitude]);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(_ref) {
            var coordinates = _ref.coordinates,
                _ref$rememberOldCoord = _ref.rememberOldCoords,
                rememberOldCoords = _ref$rememberOldCoord === undefined ? false : _ref$rememberOldCoord;

            var lat = isNaN(parseFloat(coordinates[1])) ? 0 : parseFloat(coordinates[1]);
            var lng = isNaN(parseFloat(coordinates[0])) ? 0 : parseFloat(coordinates[0]);
            var state = {
                center: {
                    lat: lat,
                    lng: lng
                }
            };

            if (rememberOldCoords && (!this.state.oldCoords || this.state.oldCoords && !this.state.oldCoords.length)) {
                state.oldCoords = coordinates;
            }

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                coordinates = _props.coordinates,
                _props$rememberOldCoo = _props.rememberOldCoords,
                rememberOldCoords = _props$rememberOldCoo === undefined ? false : _props$rememberOldCoo;
            var _state = this.state,
                zoom = _state.zoom,
                center = _state.center,
                _state$oldCoords = _state.oldCoords,
                oldCoords = _state$oldCoords === undefined ? [] : _state$oldCoords;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_google_maps__["GoogleMap"],
                {
                    ref: 'googleMap',
                    zoom: zoom,
                    defaultZoom: 1,
                    center: center,
                    onClick: this.mapOnClick,
                    defaultOptions: {
                        scrollwheel: true,
                        draggableCursor: 'pointer'
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_google_maps__["Marker"], {
                    position: {
                        lat: parseFloat(coordinates[1]),
                        lng: parseFloat(coordinates[0])
                    }
                }),
                rememberOldCoords && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_google_maps_lib_components_addons_MarkerWithLabel__["MarkerWithLabel"],
                    {
                        position: {
                            lat: parseFloat(oldCoords[1]),
                            lng: parseFloat(oldCoords[0])
                        },
                        labelAnchor: new google.maps.Point(0, 0),
                        labelStyle: { backgroundColor: 'rgba(0, 0, 0, 0.3)', color: '#eee', fontSize: '14px' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Saved coordinates'
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return MapComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MapComponent.propTypes = {};

MapComponent.defaultProps = {};

var selector = Object(__WEBPACK_IMPORTED_MODULE_7_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_8_data_formNames__["a" /* formName */].portCreate);
var MapWithConnect = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        coordinates: selector(state, 'coordinates') || ownProps.coordinates
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_6_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(MapComponent);

var MyMapComponent = Object(__WEBPACK_IMPORTED_MODULE_4_react_google_maps__["withGoogleMap"])(MapWithConnect);

var _default = MyMapComponent;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MapComponent, 'MapComponent', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/MapComponent.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/MapComponent.jsx');
    reactHotLoader.register(MapWithConnect, 'MapWithConnect', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/MapComponent.jsx');
    reactHotLoader.register(MyMapComponent, 'MyMapComponent', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/MapComponent.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/MapComponent.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(136),
    createWrap = __webpack_require__(2235),
    getHolder = __webpack_require__(557),
    replaceHolders = __webpack_require__(387);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(377),
    isObject = __webpack_require__(89);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128724
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128685
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {Number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @function
	 */
	isArray: Array.isArray ? Array.isArray : function(value) {
		return Object.prototype.toString.call(value) === '[object Array]';
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {Number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {Function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {Object|Array} loopable - The object or array to be iterated.
	 * @param {Function} fn - The function to call for each item.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see http://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {Boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @param {Object} [options] - Merging options:
	 * @param {Function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {Object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @returns {Object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {Object} target - The target object in which all objects are merged into.
	 * @param {Object} arg1 - Object containing additional properties to merge in target.
	 * @param {Object} argN - Additional objects containing properties to merge in target.
	 * @returns {Object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

module.exports = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Base_RenderField__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var COMPONENTS = [{
  title: 'Subscription',
  component: 'Subscription'
}];

var UserDetails = function (_Component) {
  _inherits(UserDetails, _Component);

  function UserDetails() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, UserDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserDetails.__proto__ || Object.getPrototypeOf(UserDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      data: {},
      errors: {},
      component: 'Subscription',
      error: ''
    }, _this.handleChange = __WEBPACK_IMPORTED_MODULE_1_components_Base_RenderField__["a" /* handleChange */].bind(_this), _this.fetchUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var id, result, errorMsg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = _this.props.params.id;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].users.getOne(id);

            case 3:
              result = _context.sent;

              if (!(result.status === 200)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return', _this.setState({ data: result.data }));

            case 6:
              errorMsg = Object(__WEBPACK_IMPORTED_MODULE_3_helpers__["b" /* getNormalErrors */])(result).error;

              Object(__WEBPACK_IMPORTED_MODULE_3_helpers__["c" /* showNotification */])(errorMsg, 'error');

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchUser();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          _state$data = _state.data,
          _state$data$name = _state$data.name,
          name = _state$data$name === undefined ? '' : _state$data$name,
          _state$data$surname = _state$data.surname,
          surname = _state$data$surname === undefined ? '' : _state$data$surname,
          _state$data$email = _state$data.email,
          email = _state$data$email === undefined ? '' : _state$data$email,
          data = _state.data,
          component = _state.component;

      var Component = __webpack_require__(3384)("./" + component).default;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container user-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  padding: '20px',
                  minHeight: '400px',
                  borderRight: '1px solid rgb(158, 158, 158)'
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12 m-b-1 b-b-1 p-b-1' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    'USER INFO'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'NAME:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    name + ' ' + surname
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'm-t-1' },
                    'EMAIL:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    email
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  COMPONENTS.map(function (menuItem) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        key: menuItem.component,
                        className: 'menu-item ' + (menuItem.component === component ? 'active' : ''),
                        onClick: function onClick() {
                          return _this3.handleChange('component', menuItem.component);
                        }
                      },
                      menuItem.title
                    );
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-8' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '20px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, {
                data: data,
                fetchUser: this.fetchUser
              })
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return UserDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = UserDetails;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(COMPONENTS, 'COMPONENTS', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Details/index.js');
  reactHotLoader.register(UserDetails, 'UserDetails', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Details/index.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Details/index.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TimeCharter = function (_PureComponent) {
  _inherits(TimeCharter, _PureComponent);

  function TimeCharter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeCharter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeCharter.__proto__ || Object.getPrototypeOf(TimeCharter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      type: 'Mpp' // ['Mpp', 'Bulk']
    }, _this.changeType = function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Mpp';


      if (value === _this.state.type) {
        return false;
      }

      _this.setState({ type: value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeCharter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var Component = __webpack_require__(3416)("./" + this.state.type).default;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-12 text-center m-v-1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
              label: 'MPP TONNAGE',
              primary: true,
              onClick: function onClick() {
                return _this2.changeType('Mpp');
              },
              style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
              buttonStyle: { lineHeight: '25px', height: '25px' },
              labelStyle: { fontSize: '11px' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
              label: 'BULK TONNAGE',
              primary: true,
              onClick: function onClick() {
                return _this2.changeType('Bulk');
              },
              style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
              buttonStyle: { lineHeight: '25px', height: '25px' },
              labelStyle: { fontSize: '11px' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TimeCharter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _default = TimeCharter;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TimeCharter, 'TimeCharter', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/index.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/index.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function transformRegion(region) {
  return _extends({}, region, {
    dwtGroup: region.dwtGroup.reduce(function (res, g) {
      res[g.nameDwtGroup] = _extends({
        percentToWW: g.percentToWW
      }, g.prices.reduce(function (resPrices, price) {
        resPrices[price.name] = {
          value: price.value,
          editedByUser: price.editedByUser
        };

        return resPrices;
      }, {}));

      return res;
    }, {})
  });
}

var Region = function (_Component) {
  _inherits(Region, _Component);

  function Region(props) {
    var _this2 = this;

    _classCallCheck(this, Region);

    var _this = _possibleConstructorReturn(this, (Region.__proto__ || Object.getPrototypeOf(Region)).call(this, props));

    _this.transformRegion = transformRegion;

    _this.toggleUnfold = function () {
      _this.setState({ unfold: !_this.state.unfold });
    };

    _this.toggleState = function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'askingForSaveWWR';

      _this.setState(_defineProperty({}, key, !_this.state[key]));
    };

    _this.askForSave = function () {
      _this.isWWR() ? _this.toggleState('askingForSaveWWR') : _this.save();
    };

    _this.save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$state, data, errors, tcRates, result;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, data = _this$state.data, errors = _this$state.errors;
              tcRates = _this.props.tcRates;

              if (!Object.keys(errors).reduce(function (res, key) {
                if (errors[key]) {
                  res = true;
                  return res;
                }
              }, false)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["c" /* showNotification */])('There is an error. Check out inputs', 'error'));

            case 4:
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].timeCharters.updateTimeCharterRegion({
                type: _this.props.type,
                _id: data._id,
                dwtGroup: Object.keys(data.dwtGroup).reduce(function (res, key) {
                  res.push({
                    nameDwtGroup: key,
                    percentToWW: data.dwtGroup[key].percentToWW,
                    prices: tcRates.reduce(function (resPrice, rate) {
                      resPrice.push({
                        name: rate,
                        value: data.dwtGroup[key][rate].value,
                        editedByUser: data.dwtGroup[key][rate].editedByUser
                      });

                      return resPrice;
                    }, [])
                  });
                  return res;
                }, [])
              });

            case 6:
              result = _context.sent;

              if (!(result.status === 200)) {
                _context.next = 12;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["c" /* showNotification */])('Region has been updated');
              _context.next = 11;
              return _this.props.getRegions();

            case 11:
              return _context.abrupt('return', _context.sent);

            case 12:

              Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["c" /* showNotification */])(Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["b" /* getNormalErrors */])(result).error, 'error');

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.remove = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.props.removeRegion(_this.state.data._id);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this.recalculate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.props.recalculateRegion(_this.state.data);

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.isWWR = function () {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(_this.state, 'data.region.name', '') === 'WWR';
    };

    _this.state = {
      data: _this.transformRegion(_this.props.data),
      ts: _this.props.ts,
      unfold: _this.props.unfold,
      defaultUnfold: _this.props.unfold,
      askingForSaveWWR: false,
      errors: {}
    };
    return _this;
  }

  _createClass(Region, [{
    key: 'handleChange',
    value: function handleChange() {
      var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


      function validateValue(value) {
        if (typeof value !== 'boolean') {
          var dots = 0;
          value = value.replace(/[^\d|\.|-]/, '').replace(/\./g, function () {
            return dots++ > 0 ? '' : '.';
          }).replace(/\-/g, function (match, str) {
            return str === 0 ? '-' : '';
          });
        }
        return value;
      }

      var data = JSON.parse(JSON.stringify(this.state.data));
      var errors = {};

      changes.forEach(function (v) {
        __WEBPACK_IMPORTED_MODULE_1_lodash_set___default()(data, v.key, validateValue(v.value));
        if (!v.noError) {
          errors[v.key] = v.value && typeof v.value !== 'boolean' && !isNaN(parseFloat(v.value)) ? '' : 'required';
        }
      });

      this.setState({
        data: data,
        errors: _extends({}, this.state.errors, errors)
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(state, 'data._id', null) != __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(props, 'data._id', null) || state.ts != props.ts) {
        var unfoldChange = {};

        if (__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(state, 'defaultUnfold', null) != __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(props, 'unfold', null)) {
          unfoldChange = {
            unfold: props.unfold,
            defaultUnfold: props.unfold
          };
        }

        return _extends({
          data: transformRegion(props.data),
          ts: props.ts
        }, unfoldChange);
      }

      return null;
    }
  }]);

  return Region;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Region;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(transformRegion, 'transformRegion', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Base/region.js');
  reactHotLoader.register(Region, 'Region', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Base/region.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Base/region.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__region__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegionModalAdd__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DWT_GROUPS = {
  'minibulk': '< 10000 minibulker',
  'handysize': '10000 - 34999 handysize',
  'handymax': '35000 - 59999 handymax (supramax)',
  'panamax': '60000 -79999 panamax (new panamax)',
  'capesize': '80000 - 179999 Capesize',
  'verylarge': '180000 - 320000 VLCC (Very Large Crude Carriers)',
  'ultraverylarge': '> 320000 ULCC (Ultra Large Crude Carriers)'
};
var TC_RATES = ['tcRatesDay'];

var TimeCharterBulk = function (_PureComponent) {
  _inherits(TimeCharterBulk, _PureComponent);

  function TimeCharterBulk() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeCharterBulk);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeCharterBulk.__proto__ || Object.getPrototypeOf(TimeCharterBulk)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      regions: [],
      isDialogOpened: false,
      unfoldView: localStorage.getItem('unfoldView') ? JSON.parse(localStorage.getItem('unfoldView')) : true
    }, _this.getRegions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].timeCharters.fetchTimeCharterRegions({ type: 'bulk' });

            case 2:
              result = _context.sent;


              if (result.status === 200) {
                _this.setState({ regions: result.data });
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.removeRegion = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var result, errors;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].timeCharters.removeTimeCharterRegion({ _id: id });

              case 2:
                result = _context2.sent;

                if (!(result.status === 200)) {
                  _context2.next = 8;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])('Region has been removed');
                _context2.next = 7;
                return _this.getRegions();

              case 7:
                return _context2.abrupt('return', _context2.sent);

              case 8:
                errors = Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["b" /* getNormalErrors */])(result);

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])(errors.error, 'error');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), _this.recalculateRegion = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var result, errors;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].timeCharters.recalculateTimeCharterRegion(data._id, data);

              case 2:
                result = _context3.sent;

                if (!(result.status === 200)) {
                  _context3.next = 8;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])('Region has been recalculated');
                _context3.next = 7;
                return _this.getRegions();

              case 7:
                return _context3.abrupt('return', _context3.sent);

              case 8:
                errors = Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["b" /* getNormalErrors */])(result);

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])(errors.error, 'error');

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }(), _this.toggleState = function (e) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'isDialogOpened';

      _this.setState(_defineProperty({}, key, !_this.state[key]));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeCharterBulk, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getRegions();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          _state$regions = _state.regions,
          regions = _state$regions === undefined ? [] : _state$regions,
          isDialogOpened = _state.isDialogOpened,
          unfoldView = _state.unfoldView;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'text-center color-common' },
          'Bulk'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
          label: 'Unfold: ' + unfoldView,
          primary: true,
          onClick: function onClick() {
            _this3.toggleState(null, 'unfoldView');
            localStorage.setItem('unfoldView', !unfoldView);
          },
          style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
          buttonStyle: { lineHeight: '25px', height: '25px' },
          labelStyle: { fontSize: '11px' }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RegionModalAdd__["default"], {
          isDialogOpened: isDialogOpened,
          toggleDialog: this.toggleState,
          getRegions: this.getRegions,
          config: { dwtGroups: DWT_GROUPS },
          type: 'bulk'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["Table"],
          { selectable: false, className: 'time-charter-table' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeader"],
            { displaySelectAll: false, adjustForCheckbox: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],
              { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnCSS, { width: '20%' }) },
                'Region'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnCSS, { width: '20%' }) },
                'DWT groups (mt)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '10%' }) },
                '+/-(%) to ww'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '50%' }), colSpan: 4 },
                'TCRates by Vessel\'s type, usd/day'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableBody"],
            { displayRowCheckbox: false },
            regions.length ? regions.map(function (r, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__region__["default"], {
                data: r,
                key: 'time-charter-region-' + r._id,
                ts: Date.now(),
                removeRegion: _this3.removeRegion,
                recalculateRegion: _this3.recalculateRegion,
                getRegions: _this3.getRegions,
                dwtGroups: DWT_GROUPS,
                tcRates: TC_RATES,
                unfold: unfoldView,
                type: 'bulk'
              });
            }) : 'No data'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'm-v-1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
            label: '+ Add',
            primary: true,
            onClick: this.toggleState,
            style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
            buttonStyle: { lineHeight: '25px', height: '25px' },
            labelStyle: { fontSize: '11px' }
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TimeCharterBulk;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _default = TimeCharterBulk;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DWT_GROUPS, 'DWT_GROUPS', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Bulk/index.js');
  reactHotLoader.register(TC_RATES, 'TC_RATES', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Bulk/index.js');
  reactHotLoader.register(TimeCharterBulk, 'TimeCharterBulk', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Bulk/index.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Bulk/index.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var RegionModalAdd = function (_Component) {
  _inherits(RegionModalAdd, _Component);

  function RegionModalAdd() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, RegionModalAdd);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegionModalAdd.__proto__ || Object.getPrototypeOf(RegionModalAdd)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      data: {},
      areas: [],
      errors: {},
      error: ''
    }, _this.fetchAreas = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value.length < 2)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].findPortAdmin({ name: value, withAreas: true });

              case 4:
                result = _context.sent;


                if (result.status === 200) {
                  _this.setState({
                    areas: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(result, 'data.data', []).map(function (ar) {
                      return { title: '' + ar.name + (ar.unLoCode ? ' (' + ar.unLoCode + ')' : ''),
                        value: ar._id };
                    })
                  });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }(), _this.handleChange = function (key) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (key !== '_id') {
        var dots = 0;
        value = value.replace(/[^\d|\.|-]/, '').replace(/\./g, function () {
          return dots++ > 0 ? '' : '.';
        }).replace(/\-/g, function (match, str) {
          return str === 0 ? '-' : '';
        });
      }

      var data = _this.state.data;
      __WEBPACK_IMPORTED_MODULE_1_lodash_set___default()(data, key, value);

      _this.setState({
        data: data,
        errors: _extends({}, _this.state.errors, _defineProperty({}, key, value && (key === '_id' ? true : !isNaN(parseFloat(value))) ? '' : 'required')),
        error: ''
      });
    }, _this.validate = function () {
      var data = _this.state.data;

      var errors = {};

      if (!data._id) {
        errors._id = 'required';
      }

      if (!Object.keys(errors).length) {
        return true;
      }

      _this.setState({ errors: errors });
      return false;
    }, _this.save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var data, dwtGroups, result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = _this.state.data;
              dwtGroups = _this.props.config.dwtGroups;


              Object.keys(dwtGroups).forEach(function (key) {
                return data[key] = 0;
              });

              if (_this.validate()) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])('There is an error. Check out inputs', 'error'));

            case 5:
              _context2.next = 7;
              return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].timeCharters.createTimeCharterRegion({
                type: _this.props.type,
                region: data._id,
                percentList: Object.keys(dwtGroups).reduce(function (res, key) {
                  res[key] = +data[key];

                  return res;
                }, {})
              });

            case 7:
              result = _context2.sent;

              if (!(result.status === 200)) {
                _context2.next = 13;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])('Region has been created');
              _context2.next = 12;
              return _this.props.getRegions();

            case 12:
              return _context2.abrupt('return', _this.props.toggleDialog());

            case 13:

              _this.setState(_extends({}, Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["b" /* getNormalErrors */])(result)));
              Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])(_this.state.error, 'error');

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RegionModalAdd, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          toggleDialog = _props.toggleDialog,
          isDialogOpened = _props.isDialogOpened;
      var _state = this.state,
          data = _state.data,
          areas = _state.areas;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
        {
          title: 'Add new region',
          actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
            label: 'Ok',
            primary: true,
            onClick: this.save
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
            label: 'Cancel',
            primary: true,
            onClick: toggleDialog
          })],
          open: isDialogOpened,
          autoScrollBodyContent: true,
          modal: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'm-b-0' },
          'Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a, {
          hintText: 'Name',
          floatingLabelText: 'Name',
          dataSource: areas,
          dataSourceConfig: { text: 'title', value: 'value' },
          onUpdateInput: function onUpdateInput(value) {
            _this3.handleChange('_id', '');_this3.fetchAreas(value);
          },
          onNewRequest: function onNewRequest(selected) {
            return _this3.handleChange('_id', selected.value);
          },
          fullWidth: true,
          filter: __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a.noFilter,
          menuStyle: { maxHeight: '300px', overflowY: 'auto' },
          errorText: data._id ? '' : 'required'
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RegionModalAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = RegionModalAdd;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RegionModalAdd, 'RegionModalAdd', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/RegionModalAdd.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/RegionModalAdd.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__region__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegionModalAdd__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DWT_GROUPS = {
  '3000_4500': 'DWT 3000-4500',
  '4501_6700': 'DWT 4501-6700',
  '6701_9000': 'DWT 6701-9000',
  '9001_12900': 'DWT 9001-12900',
  '12901_17800': 'DWT 12901-17800',
  '17801_24000': 'DWT 17801-24000'
};
var TC_RATES = ['sidGless', 'sidCranneTo80mt', 'tweenCranneTo80mt', 'tweenCrane80_160mt'];

var TimeCharterMpp = function (_PureComponent) {
  _inherits(TimeCharterMpp, _PureComponent);

  function TimeCharterMpp() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeCharterMpp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeCharterMpp.__proto__ || Object.getPrototypeOf(TimeCharterMpp)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      regions: [],
      isDialogOpened: false,
      unfoldView: localStorage.getItem('unfoldView') ? JSON.parse(localStorage.getItem('unfoldView')) : true
    }, _this.getRegions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].timeCharters.fetchTimeCharterRegions({ type: 'mpp' });

            case 2:
              result = _context.sent;


              if (result.status === 200) {
                _this.setState({ regions: result.data });
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.removeRegion = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var result, errors;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].timeCharters.removeTimeCharterRegion({ _id: id });

              case 2:
                result = _context2.sent;

                if (!(result.status === 200)) {
                  _context2.next = 8;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])('Region has been removed');
                _context2.next = 7;
                return _this.getRegions();

              case 7:
                return _context2.abrupt('return', _context2.sent);

              case 8:
                errors = Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["b" /* getNormalErrors */])(result);

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])(errors.error, 'error');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), _this.recalculateRegion = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var result, errors;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].timeCharters.recalculateTimeCharterRegion(data._id, data);

              case 2:
                result = _context3.sent;

                if (!(result.status === 200)) {
                  _context3.next = 8;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])('Region has been recalculated');
                _context3.next = 7;
                return _this.getRegions();

              case 7:
                return _context3.abrupt('return', _context3.sent);

              case 8:
                errors = Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["b" /* getNormalErrors */])(result);

                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])(errors.error, 'error');

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }(), _this.toggleState = function (e) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'isDialogOpened';

      _this.setState(_defineProperty({}, key, !_this.state[key]));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeCharterMpp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getRegions();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          _state$regions = _state.regions,
          regions = _state$regions === undefined ? [] : _state$regions,
          isDialogOpened = _state.isDialogOpened,
          unfoldView = _state.unfoldView;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'text-center color-common' },
          'Mpp'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
          label: 'Unfold: ' + unfoldView,
          primary: true,
          onClick: function onClick() {
            _this3.toggleState(null, 'unfoldView');
            localStorage.setItem('unfoldView', !unfoldView);
          },
          style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
          buttonStyle: { lineHeight: '25px', height: '25px' },
          labelStyle: { fontSize: '11px' }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RegionModalAdd__["default"], {
          isDialogOpened: isDialogOpened,
          toggleDialog: this.toggleState,
          getRegions: this.getRegions,
          config: { dwtGroups: DWT_GROUPS },
          type: 'mpp'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["Table"],
          { selectable: false, className: 'time-charter-table' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeader"],
            { displaySelectAll: false, adjustForCheckbox: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],
              { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnCSS, { width: '20%' }) },
                'Region'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnCSS, { width: '20%' }) },
                'DWT groups (mt)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '10%' }) },
                '+/-(%) to ww'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '50%' }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["Table"],
                  { selectable: false },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeader"],
                    {
                      displaySelectAll: false,
                      adjustForCheckbox: false,
                      style: { borderBottom: 'none' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        { colSpan: 4 },
                        'TCRates by Vessel\'s type, usd/day'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],
                      { style: { borderBottom: 'none' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'SID Gless'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'SID crane < 80 mt'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'TWEEN crane < 80 mt'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'TWEEN crane 80-160 mt'
                      )
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableBody"],
            { displayRowCheckbox: false },
            regions.length ? regions.map(function (r, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__region__["default"], {
                data: r,
                key: 'time-charter-region-' + r._id,
                ts: Date.now(),
                removeRegion: _this3.removeRegion,
                recalculateRegion: _this3.recalculateRegion,
                getRegions: _this3.getRegions,
                dwtGroups: DWT_GROUPS,
                tcRates: TC_RATES,
                unfold: unfoldView,
                type: 'mpp'
              });
            }) : 'No data'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'm-v-1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
            label: '+ Add',
            primary: true,
            onClick: this.toggleState,
            style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
            buttonStyle: { lineHeight: '25px', height: '25px' },
            labelStyle: { fontSize: '11px' }
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TimeCharterMpp;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _default = TimeCharterMpp;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DWT_GROUPS, 'DWT_GROUPS', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Mpp/index.js');
  reactHotLoader.register(TC_RATES, 'TC_RATES', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Mpp/index.js');
  reactHotLoader.register(TimeCharterMpp, 'TimeCharterMpp', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Mpp/index.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Mpp/index.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = renderApiList;
/* harmony export (immutable) */ __webpack_exports__["c"] = renderApiDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emailRegExp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();



function checkParams(id) {
  if (!id) {
    location.replace("/integrators/list");
  }
}

function renderApiList(list) {
  return list.map(function (api, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      {
        style: { height: "45px", textOverflow: "ellipsis", overflow: "hidden" },
        key: api.name
      },
      i + 1 + ". API " + api.name
    );
  });
}

function renderApiDetails(list, field, limit) {
  return list.map(function (api, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      {
        style: { height: "45px", textOverflow: "ellipsis", overflow: "hidden" },
        key: api.name
      },
      api[field] + "/" + (api[limit] ? api[limit] : "∞")
    );
  });
}

var emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(checkParams, "checkParams", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/utils.js");
  reactHotLoader.register(renderApiList, "renderApiList", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/utils.js");
  reactHotLoader.register(renderApiDetails, "renderApiDetails", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/utils.js");
  reactHotLoader.register(emailRegExp, "emailRegExp", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/utils.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export withButtonedCollapse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapseBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return transfer; });
/* harmony export (immutable) */ __webpack_exports__["g"] = generateHatchTweenDeckStr;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sizesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sizesFieldsNamesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deadWeightFieldsNamesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return rtFieldsNamesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return capacityV2FieldsNamesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return techEquipCertificateFieldsNamesMap; });
/* unused harmony export cellsNamesMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return basicNamesFieldsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return registerClassFieldsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dimensionsFieldsMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_common_CollapseBasic__ = __webpack_require__(3478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_right__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_notifications_notifications__ = __webpack_require__(41);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












function withButtonedCollapse(Component, other) {
    return function (props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_common_CollapseBasic__["a" /* default */], _extends({
            controls: Component && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
        }, props));
    };
}

/**
 * @param {{ type: string, 
 *           size: any, 
 *           sizes?: any, 
 *           field?: string, 
 *           index: number, 
 *           accept: (any) => void, 
 *           reject: (any) => void, 
 *           transfer: (any) => void, 
 *           emailIds: string[],
 *           keep_id?: boolean,
 *           addNotification: function,
 *           addToMultiTransfer: function,
 *           shouldShowApproveReject: boolean,
 * }} props,
 * @returns {ReactElement}
 */
function ControlButtons(_ref) {
    var type = _ref.type,
        size = _ref.size,
        sizes = _ref.sizes,
        field = _ref.field,
        index = _ref.index,
        accept = _ref.accept,
        reject = _ref.reject,
        transfer = _ref.transfer,
        emailIds = _ref.emailIds,
        keep_id = _ref.keep_id,
        addNotification = _ref.addNotification,
        addToMultiTransfer = _ref.addToMultiTransfer,
        shouldShowApproveReject = _ref.shouldShowApproveReject;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isOpen = _useState2[0],
        setIsOpen = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState4 = _slicedToArray(_useState3, 2),
        reason = _useState4[0],
        setReason = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        addToMultiTransfer({
            type: type, index: index, size: size, sizes: sizes, field: field, emailIds: emailIds, keep_id: keep_id
        });
    }, []);

    var submitReject = function submitReject() {
        if (!reason) {
            addNotification({
                title: 'Error',
                message: 'Reject reason is required',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3
            });
            return;
        }
        reject({
            type: type, index: index, size: size, sizes: sizes, field: field, emailIds: emailIds, reason: reason
        });
        setReason('');
        setIsOpen(false);
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
        label: 'Cancel',
        primary: true,
        onClick: function onClick() {
            return setIsOpen(false);
        }
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
        label: 'Save',
        primary: true,
        keyboardFocused: true,
        onClick: function onClick() {
            return submitReject();
        }
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
            {
                open: isOpen,
                actions: actions
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                value: reason,
                floatingLabelText: 'Reject reason',
                onChange: function onChange(e) {
                    return setReason(e.target.value);
                },
                multiLine: true,
                fullWidth: true,
                errorText: !reason && 'Reject reason is required'
            })
        ),
        shouldShowApproveReject && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                {
                    style: { width: '24px', height: '30px', padding: 0 }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                    onClick: function onClick(e) {
                        setIsOpen(true);
                        e.stopPropagation();
                    },
                    color: 'red'
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                {
                    style: { width: '24px', height: '30px', padding: 0 }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default.a, {
                    onClick: function onClick(e) {
                        accept({
                            type: type, index: index, size: size, sizes: sizes, field: field, emailIds: emailIds, keep_id: keep_id
                        });
                        e.stopPropagation();
                    },
                    color: 'green'
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
            {
                style: { width: '24px', height: '30px', padding: 0 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_right___default.a, {
                onClick: function onClick(e) {
                    transfer({
                        type: type, index: index, size: size, sizes: sizes, field: field, emailIds: emailIds, keep_id: keep_id
                    });
                    e.stopPropagation();
                }
            })
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_9_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(ControlButtons);

/* harmony default export */ __webpack_exports__["e"] = (_default);

var CollapseBody = withButtonedCollapse();

var transfer = function transfer(modification, setModifySizes) {
    var size = modification.size,
        sizes = modification.sizes,
        groupField = modification.field,
        type = modification.type,
        emailIds = modification.emailIds,
        keep_id = modification.keep_id;

    var field = sizesFieldsNamesMap[type];
    var value = void 0;

    if (['string', 'boolean'].includes(_typeof(size[field].value))) {
        value = size[field].value;
    } else if (keep_id) {
        value = size[field].value;
    } else {
        value = __WEBPACK_IMPORTED_MODULE_1_lodash__["omit"](size[field].value, ['_id']);
    }

    setModifySizes({ field: field, value: value });

    return {
        field: field, emailIds: emailIds, groupField: groupField, sizes: sizes, type: type
    };
};

function generateHatchTweenDeckStr(data) {
    var l = data.l,
        b = data.b,
        h = data.h;

    var str = '';

    if (l) str += 'L: ' + l + ' ';
    if (b) str += 'B: ' + b + ' ';
    if (h) str += 'H: ' + h + ' ';

    return str;
}

var sizesMap = {
    grouppedByGears: 'Gears',
    grouppedBySpeedConsumption: 'Speeds and consumption',
    grouppedByBoxShaped: 'Box shaped',
    grouppedByOpenHatch: 'Open hatch',
    grouppedByTypeByConstruction: 'Type by construction',
    grouppedByTypeByPurpose: 'Type by purpose',
    grouppedByTypeBySpecialty: 'Type by specialty',
    grouppedByTechEquipCertificate: 'TechEquipCertificate',
    grouppedByDeadWeight: 'Deadweight',
    grouppedByRt: 'Tonnage',
    grouppedByHatches: 'Hatches',
    grouppedByHolds: 'Holds',
    grouppedByCapacityV2: 'Capacity',
    grouppedByCells: 'Cells',
    grouppedByFlags: 'Flag',
    grouppedByRegisterClass: 'Register class',
    grouppedByPIClub: 'PI Club',
    grouppedByGrabs: 'Grabs',
    grouppedByDimensions: 'Dimensions'
};

var sizesFieldsNamesMap = {
    grouppedByGears: 'gearV2',
    grouppedBySpeedConsumption: 'speedConsumptionV2',
    grouppedByBoxShaped: 'boxShaped',
    grouppedByOpenHatch: 'openHatch',
    grouppedByTypeByConstruction: 'typeByConstruction',
    grouppedByTypeByPurpose: 'typeByPurpose',
    grouppedByTypeBySpecialty: 'typeBySpecialty',
    grouppedByTechEquipCertificate: 'techEquipCertificate',
    grouppedByDeadWeight: 'deadWeight',
    grouppedByRt: 'rt',
    grouppedByCells: 'cells',
    grouppedByCapacityV2: 'capacityV2',
    grouppedByFlags: 'flag',
    grouppedByRegisterClass: 'registerClass',
    grouppedByPIClub: 'piClub',
    grouppedByGrabs: 'grabV2',
    grouppedByDimensions: 'dimensions'
};

var deadWeightFieldsNamesMap = {
    sLoaded: 'Summer loaded',
    sDWT: 'Summer dwt',
    sDWCC: 'Summer dwcc',
    sDraft: 'Summer draft',
    sTpc: 'Summer tpc',
    sTpi: 'Summer tpi',

    tLoaded: 'Tropical loaded',
    tDWT: 'Tropical dwt',
    tDWCC: 'Tropical dwcc',
    tDraft: 'Tropical draft',
    tTpc: 'Tropical tpc',
    tTpi: 'Tropical tpi',

    wLoaded: 'Winter loaded',
    wDWT: 'Winter dwt',
    wDWCC: 'Winter dwcc',
    wDraft: 'Winter draft',
    wTpc: 'Winter tpc',
    wTpi: 'Winter tpi',

    fLoaded: 'Fresh loaded',
    fDWT: 'Fresh dwt',
    fDWCC: 'Fresh dwcc',
    fDraft: 'Fresh draft',
    fTpc: 'Fresh tpc',
    fTpi: 'Fresh tpi'
};

var rtFieldsNamesMap = {
    gt: 'GT', nt: 'NT', suezGt: 'Suez GT', suezNt: 'Suez NT', panamaGt: 'Panama GT', panamaNt: 'Panama NT'
};

var capacityV2FieldsNamesMap = {
    bale: 'Bale', grain: 'Grain', teu: 'TEU', feu: 'FEU', summary: 'Summary'
};

var techEquipCertificateFieldsNamesMap = {
    a60BulkheadFitted: 'A60Bulkhead',
    aussieFitted: 'Aussie',
    cementHolesFitted: 'Cement holes',
    co2Fitted: 'CO2',
    iceClass: 'Ice class',
    imoApp: 'Imo app',
    imoClass: 'Imo class',
    imoFitted: 'Imo',
    itfFitted: 'Itf',
    lakesFitted: 'Lakes',
    logsFitted: 'Logs',
    referPlugFitted: 'Refer plug',
    referPlugsAmount: 'R. plugs amount',
    scrubber_fitted: 'Scrubber',
    strengthenHeavy: 'Strengthen heavy',
    ventilationFitted: 'Vent. fit',
    ventilation: 'Ventilation'
};

var cellsNamesMap = {
    holds: 'Holds', hatches: 'Hatches', tweenDecks: 'Tweendecks'
};

var basicNamesFieldsMap = {
    name: 'Name'
};

var registerClassFieldsMap = _extends({}, basicNamesFieldsMap, {
    iacsRegister: 'IACS',
    isPublic: 'Public'
});

var dimensionsFieldsMap = {
    loa: 'Loa', beam: 'Beam', lbp: 'Lbp', depth: 'Depth', depthMoulded: 'Depth-moulded'
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(withButtonedCollapse, 'withButtonedCollapse', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(ControlButtons, 'ControlButtons', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(CollapseBody, 'CollapseBody', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(transfer, 'transfer', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(generateHatchTweenDeckStr, 'generateHatchTweenDeckStr', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(sizesMap, 'sizesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(sizesFieldsNamesMap, 'sizesFieldsNamesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(deadWeightFieldsNamesMap, 'deadWeightFieldsNamesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(rtFieldsNamesMap, 'rtFieldsNamesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(capacityV2FieldsNamesMap, 'capacityV2FieldsNamesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(techEquipCertificateFieldsNamesMap, 'techEquipCertificateFieldsNamesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(cellsNamesMap, 'cellsNamesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(basicNamesFieldsMap, 'basicNamesFieldsMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(registerClassFieldsMap, 'registerClassFieldsMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(dimensionsFieldsMap, 'dimensionsFieldsMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/utils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(400);

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ __webpack_exports__["a"] = (stringify);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regex_js__ = __webpack_require__(3488);


function validate(uuid) {
  return typeof uuid === 'string' && __WEBPACK_IMPORTED_MODULE_0__regex_js__["a" /* default */].test(uuid);
}

/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var document = __webpack_require__(42).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(42);
var core = __webpack_require__(107);
var LIBRARY = __webpack_require__(148);
var wksExt = __webpack_require__(584);
var defineProperty = __webpack_require__(66).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(293)('keys');
var uid = __webpack_require__(171);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 404 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(42).document;
module.exports = document && document.documentElement;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(48);
var anObject = __webpack_require__(37);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(108)(Function.call, __webpack_require__(94).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var setPrototypeOf = __webpack_require__(406).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(110);
var defined = __webpack_require__(119);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 410 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(148);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(87);
var hide = __webpack_require__(86);
var Iterators = __webpack_require__(210);
var $iterCreate = __webpack_require__(413);
var setToStringTag = __webpack_require__(207);
var getPrototypeOf = __webpack_require__(95);
var ITERATOR = __webpack_require__(59)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(174);
var descriptor = __webpack_require__(170);
var setToStringTag = __webpack_require__(207);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(86)(IteratorPrototype, __webpack_require__(59)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(298);
var defined = __webpack_require__(119);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(59)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(210);
var ITERATOR = __webpack_require__(59)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(66);
var createDesc = __webpack_require__(170);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(208);
var ITERATOR = __webpack_require__(59)('iterator');
var Iterators = __webpack_require__(210);
module.exports = __webpack_require__(107).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1094);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(68);
var toAbsoluteIndex = __webpack_require__(173);
var toLength = __webpack_require__(60);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(149);
var step = __webpack_require__(601);
var Iterators = __webpack_require__(210);
var toIObject = __webpack_require__(93);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(412)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(246);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(297)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(108);
var invoke = __webpack_require__(591);
var html = __webpack_require__(405);
var cel = __webpack_require__(401);
var global = __webpack_require__(42);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(109)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(42);
var macrotask = __webpack_require__(424).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(109)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(76);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(42);
var DESCRIPTORS = __webpack_require__(65);
var LIBRARY = __webpack_require__(148);
var $typed = __webpack_require__(304);
var hide = __webpack_require__(86);
var redefineAll = __webpack_require__(179);
var fails = __webpack_require__(47);
var anInstance = __webpack_require__(177);
var toInteger = __webpack_require__(110);
var toLength = __webpack_require__(60);
var toIndex = __webpack_require__(611);
var gOPN = __webpack_require__(175).f;
var dP = __webpack_require__(66).f;
var arrayFill = __webpack_require__(420);
var setToStringTag = __webpack_require__(207);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(181);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1216);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(80), __webpack_require__(4)(module)))

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(150);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(1244);

var _PathUtils = __webpack_require__(151);

var _runTransitionHook = __webpack_require__(436);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(309);

var _LocationUtils = __webpack_require__(215);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(215);

var _DOMUtils = __webpack_require__(310);

var _DOMStateStorage = __webpack_require__(638);

var _PathUtils = __webpack_require__(151);

var _ExecutionEnvironment = __webpack_require__(438);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(442)('keys');
var uid = __webpack_require__(312);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(73);
var global = __webpack_require__(152);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(311) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(153);
var core = __webpack_require__(73);
var fails = __webpack_require__(218);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1254);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(217);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 446 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(183);
var dPs = __webpack_require__(1261);
var enumBugKeys = __webpack_require__(449);
var IE_PROTO = __webpack_require__(441)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(643)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1264).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 448 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 449 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(154).f;
var has = __webpack_require__(182);
var TAG = __webpack_require__(112)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1265);
var global = __webpack_require__(152);
var hide = __webpack_require__(216);
var Iterators = __webpack_require__(219);
var TO_STRING_TAG = __webpack_require__(112)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(112);


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(152);
var core = __webpack_require__(73);
var LIBRARY = __webpack_require__(311);
var wksExt = __webpack_require__(452);
var defineProperty = __webpack_require__(154).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 454 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(314);
var createDesc = __webpack_require__(250);
var toIObject = __webpack_require__(185);
var toPrimitive = __webpack_require__(445);
var has = __webpack_require__(182);
var IE8_DOM_DEFINE = __webpack_require__(642);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(184) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1323), __esModule: true };

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(99);
var normalizeHeaderName = __webpack_require__(1343);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(666);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(666);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253)))

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(67),
    isKey = __webpack_require__(462),
    stringToPath = __webpack_require__(1360),
    toString = __webpack_require__(674);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(67),
    isSymbol = __webpack_require__(316);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1362),
    mapCacheDelete = __webpack_require__(1378),
    mapCacheGet = __webpack_require__(1380),
    mapCacheHas = __webpack_require__(1381),
    mapCacheSet = __webpack_require__(1382);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(188),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = findCompany;
/* harmony export (immutable) */ __webpack_exports__["e"] = findCompanyById;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = disapproveUser;
/* harmony export (immutable) */ __webpack_exports__["f"] = findMembersOfCompany;
/* harmony export (immutable) */ __webpack_exports__["k"] = setNewParticipantsRoles;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCompanies;
/* harmony export (immutable) */ __webpack_exports__["i"] = getRealCompanies;
/* harmony export (immutable) */ __webpack_exports__["g"] = findRealCompany;
/* harmony export (immutable) */ __webpack_exports__["j"] = saveRealCompany;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteRealCompany;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function findCompany(text) {
    var withRealCompanies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var onlyWithOwner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/companies/find',
        data: {
            query: text,
            withRealCompanies: withRealCompanies,
            onlyWithOwner: onlyWithOwner
        },
        withCredentials: true
    });
}

function findCompanyById(companyId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/companies/' + companyId,
        withCredentials: true
    }).then(function (response) {
        return response.data.data;
    }).catch(function (error) {
        return console.error(error);
    });
}

function approveUser(user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/companies/' + user.company._id + '/members/' + (user.participantId || user._id) + '/approve',
        data: {
            user: user
        },
        withCredentials: true
    }).then(function (response) {
        return response.data.data.message;
    }).catch(function (error) {
        return console.error(error);
    });
}

function disapproveUser(user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/companies/' + user.company._id + '/members/' + (user.participantId || user._id) + '/disapprove',
        data: {
            user: user
        },
        withCredentials: true
    }).then(function (response) {
        return response.data.data.message;
    }).catch(function (error) {
        return console.error(error);
    });
}

function findMembersOfCompany(_ref) {
    var _id = _ref._id,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? undefined : _ref$name;

    var data = {
        query: _id || name
    };

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/companies/find-roles',
        data: data,
        withCredentials: true
    }).then(function (response) {
        return response.data.data;
    }).catch(function (error) {
        return console.error(error);
    });
}

function setNewParticipantsRoles(newParticipants, companyId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/companies/update-roles',
        data: {
            query: {
                newParticipants: newParticipants,
                companyId: companyId
            }
        },
        withCredentials: true
    });
}

function getCompanies() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/companies',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function getRealCompanies() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/companies/realCompany/ifchor',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function findRealCompany(type, text) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/companies/realCompany/findRealCompanies/' + type,
        data: {
            query: text
        },
        withCredentials: true
    });
}

function saveRealCompany(parentId, realCompanyId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/companies/realCompany/ifchor/' + parentId + '/' + realCompanyId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function deleteRealCompany(companyId, companyIdToRemove) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/companies/realCompany/ifchor/' + companyId + '/' + companyIdToRemove,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(findCompany, 'findCompany', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(findCompanyById, 'findCompanyById', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(approveUser, 'approveUser', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(disapproveUser, 'disapproveUser', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(findMembersOfCompany, 'findMembersOfCompany', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(setNewParticipantsRoles, 'setNewParticipantsRoles', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(getCompanies, 'getCompanies', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(getRealCompanies, 'getRealCompanies', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(findRealCompany, 'findRealCompany', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(saveRealCompany, 'saveRealCompany', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    reactHotLoader.register(deleteRealCompany, 'deleteRealCompany', '/opt/atlassian/pipelines/agent/build/client/app/services/companies.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["g"] = rejectServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["c"] = approveServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateServiceProviders;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveNewServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["e"] = rejectNewServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = approveRemoveServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["f"] = rejectRemoveServiceProvider;
/* harmony export (immutable) */ __webpack_exports__["d"] = getServiceProvidersHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function rejectServiceProvider(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/provider/' + data._id + '/reject',
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw error.response.data.errors[0].messages[0];
    });
}

function approveServiceProvider(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/provider/' + data._id + '/approve',
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw error.response.data.errors[0].messages[0];
    });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  serviceProviders: any[]
 * }} data
 */
function updateServiceProviders(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/provider/' + data._id + '/updateFieldServiceProviders',
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            serviceProviders: data.serviceProviders
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw error.response.data.errors[0].messages[0];
    });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
function approveNewServiceProvider(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/provider/' + data._id + '/approveNew',
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw error.response.data.errors[0].messages[0];
    });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
function rejectNewServiceProvider(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/provider/' + data._id + '/rejectNew',
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw error.response.data.errors[0].messages[0];
    });
}

/**
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
function approveRemoveServiceProvider(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/provider/' + data._id + '/approveRemove',
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw error.response.data.errors[0].messages[0];
    });
}

/**
 * 
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  providerId: string
 * }} data
 */
function rejectRemoveServiceProvider(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/provider/' + data._id + '/rejectRemove',
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            providerId: data.providerId
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw error.response.data.errors[0].messages[0];
    });
}

function getServiceProvidersHistory(portId, data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/ports/' + portId + '/service-providers/history',
        data: data,
        withCredentials: true
    }).then(function (response) {
        response.data.total = response.headers['x-total-count'];
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(rejectServiceProvider, 'rejectServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    reactHotLoader.register(approveServiceProvider, 'approveServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    reactHotLoader.register(updateServiceProviders, 'updateServiceProviders', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    reactHotLoader.register(approveNewServiceProvider, 'approveNewServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    reactHotLoader.register(rejectNewServiceProvider, 'rejectNewServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    reactHotLoader.register(approveRemoveServiceProvider, 'approveRemoveServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    reactHotLoader.register(rejectRemoveServiceProvider, 'rejectRemoveServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    reactHotLoader.register(getServiceProvidersHistory, 'getServiceProvidersHistory', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/serviceProvider.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getUserMail;
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function getUserMail(letter) {
    if (letter.eh === 'api' && letter.owner) {
        return letter.owner.email;
    }
    if (letter.realUserEmail) {
        return letter.realUserEmail;
    }
    return letter.sender && letter.sender[0].address;
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getUserMail, 'getUserMail', '/opt/atlassian/pipelines/agent/build/client/app/sagas/common.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getPort */
/* unused harmony export watchGetPort */
/* harmony export (immutable) */ __webpack_exports__["b"] = getPorts;
/* unused harmony export watchGetPorts */
/* unused harmony export getAllPorts */
/* unused harmony export watchGetAllPorts */
/* harmony export (immutable) */ __webpack_exports__["c"] = updatePort;
/* unused harmony export watchUpdatePort */
/* unused harmony export addNewPort */
/* unused harmony export watchAddNewPort */
/* unused harmony export updatePortAlt */
/* unused harmony export watchUpdatePortAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getPort),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetPort),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getPorts),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetPorts),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getAllPorts),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchGetAllPorts),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(updatePort),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdatePort),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(addNewPort),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchAddNewPort),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(updatePortAlt),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdatePortAlt);





/**
* Get port
* */
function getPort(data) {
    var response;
    return regeneratorRuntime.wrap(function getPort$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getPort, data);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_36" /* GET_PORT */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_36" /* GET_PORT */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

/**
 * Watcher get ports
 * */
function watchGetPort() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchGetPort$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_36" /* GET_PORT */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(getPort, data);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get ports
 * */
function getPorts(pagination) {
    var response;
    return regeneratorRuntime.wrap(function getPorts$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getPorts, pagination);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_37" /* GET_PORTS */].SUCCESS,
                        data: response
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_37" /* GET_PORTS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

/**
 * Watcher get ports
 * */
function watchGetPorts() {
    var _ref2, pagination;

    return regeneratorRuntime.wrap(function watchGetPorts$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_37" /* GET_PORTS */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    pagination = _ref2.pagination;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(getPorts, pagination);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Get all ports
 * */
function getAllPorts() {
    var response;
    return regeneratorRuntime.wrap(function getAllPorts$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getAllPorts);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 7;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_4" /* GET_ALL_PORTS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context5.abrupt('return', response);

                case 7:
                    _context5.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_4" /* GET_ALL_PORTS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

/**
 * Watcher get all ports
 * */
function watchGetAllPorts() {
    return regeneratorRuntime.wrap(function watchGetAllPorts$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 7;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_4" /* GET_ALL_PORTS */].REQUEST);

                case 3:
                    _context6.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getAllPorts);

                case 5:
                    _context6.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

/**
 * Update port
 * */
function updatePort(data) {
    var values, response;
    return regeneratorRuntime.wrap(function updatePort$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    values = _extends({}, data);


                    values.country = values.country._id;

                    _context7.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updatePort, values);

                case 4:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 11;
                        break;
                    }

                    _context7.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_133" /* UPDATE_PORT */].SUCCESS,
                        data: data
                    });

                case 8:
                    _context7.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Port updated',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 10:
                    return _context7.abrupt('return', response);

                case 11:
                    _context7.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_133" /* UPDATE_PORT */].FAILURE,
                        data: data
                    });

                case 13:
                    _context7.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 10
                        }
                    });

                case 15:
                    return _context7.abrupt('return', response);

                case 16:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

/**
 * Watcher update port
 * */
function watchUpdatePort() {
    var _ref3, _data;

    return regeneratorRuntime.wrap(function watchUpdatePort$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 9;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_133" /* UPDATE_PORT */].REQUEST);

                case 3:
                    _ref3 = _context8.sent;
                    _data = _ref3.data;
                    _context8.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updatePort, _data);

                case 7:
                    _context8.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/**
 * Create new port
 * */
function addNewPort(data) {
    var response;
    return regeneratorRuntime.wrap(function addNewPort$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].addNewPort, data);

                case 2:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["d" /* ADD_NEW_PORT */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context9.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Success created',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context9.abrupt('return', response);

                case 9:
                    _context9.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["d" /* ADD_NEW_PORT */].FAILURE,
                        data: response.data
                    });

                case 11:
                    _context9.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 13:
                    return _context9.abrupt('return', response);

                case 14:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

/**
 * Watcher update port
 * */
function watchAddNewPort() {
    var _ref4, _data2;

    return regeneratorRuntime.wrap(function watchAddNewPort$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (false) {
                        _context10.next = 9;
                        break;
                    }

                    _context10.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["d" /* ADD_NEW_PORT */].REQUEST);

                case 3:
                    _ref4 = _context10.sent;
                    _data2 = _ref4.data;
                    _context10.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(addNewPort, _data2);

                case 7:
                    _context10.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

/**
 * Update port alternative names
 * */
function updatePortAlt(item) {
    var response;
    return regeneratorRuntime.wrap(function updatePortAlt$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updatePortAlt, item);

                case 2:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_134" /* UPDATE_PORT_ALT */].SUCCESS,
                        item: response.item
                    });

                case 6:
                    _context11.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.item.name + ' updated',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context11.abrupt('return', response);

                case 9:
                    _context11.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_134" /* UPDATE_PORT_ALT */].FAILURE,
                        item: response.item,
                        errors: response.errors
                    });

                case 11:
                    _context11.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: response.item._id,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

/**
 * Watcher update port
 * */
function watchUpdatePortAlt() {
    var _ref5, item;

    return regeneratorRuntime.wrap(function watchUpdatePortAlt$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    if (false) {
                        _context12.next = 9;
                        break;
                    }

                    _context12.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_134" /* UPDATE_PORT_ALT */].REQUEST);

                case 3:
                    _ref5 = _context12.sent;
                    item = _ref5.item;
                    _context12.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updatePortAlt, item);

                case 7:
                    _context12.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

var _default = [watchGetPort, watchGetAllPorts, watchGetPorts, watchUpdatePortAlt, watchUpdatePort, watchAddNewPort];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getPort, 'getPort', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(watchGetPort, 'watchGetPort', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(getPorts, 'getPorts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(watchGetPorts, 'watchGetPorts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(getAllPorts, 'getAllPorts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(watchGetAllPorts, 'watchGetAllPorts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(updatePort, 'updatePort', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(watchUpdatePort, 'watchUpdatePort', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(addNewPort, 'addNewPort', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(watchAddNewPort, 'watchAddNewPort', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(updatePortAlt, 'updatePortAlt', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(watchUpdatePortAlt, 'watchUpdatePortAlt', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/regions/ports.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getBackendNotifications */
/* unused harmony export watchGetBackendNotifications */
/* unused harmony export getBackendNotification */
/* unused harmony export watchGetBackendNotification */
/* harmony export (immutable) */ __webpack_exports__["c"] = updateBackendNotification;
/* unused harmony export watchUpdateBackendNotification */
/* unused harmony export deleteBackendNotification */
/* unused harmony export watchDeleteBackendNotification */
/* harmony export (immutable) */ __webpack_exports__["a"] = createBackendNotification;
/* unused harmony export watchCreateBackendNotification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getBackendNotifications),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetBackendNotifications),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getBackendNotification),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetBackendNotification),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(updateBackendNotification),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateBackendNotification),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(deleteBackendNotification),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteBackendNotification),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(createBackendNotification),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchCreateBackendNotification);





/**
 * Get all notifications
 * */
function getBackendNotifications() {
    var response;
    return regeneratorRuntime.wrap(function getBackendNotifications$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getBackendNotifications);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_9" /* GET_BACKEND_NOTIFICATIONS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_9" /* GET_BACKEND_NOTIFICATIONS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetBackendNotifications() {
    return regeneratorRuntime.wrap(function watchGetBackendNotifications$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_9" /* GET_BACKEND_NOTIFICATIONS */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getBackendNotifications);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get one notification by id
 * */
function getBackendNotification(_id) {
    var response;
    return regeneratorRuntime.wrap(function getBackendNotification$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getBackendNotification, _id);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_8" /* GET_BACKEND_NOTIFICATION */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_8" /* GET_BACKEND_NOTIFICATION */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetBackendNotification() {
    var _ref, _id;

    return regeneratorRuntime.wrap(function watchGetBackendNotification$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_8" /* GET_BACKEND_NOTIFICATION */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    _id = _ref._id;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getBackendNotifications, _id);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Update notification by id
 * */
function updateBackendNotification(data) {
    var response;
    return regeneratorRuntime.wrap(function updateBackendNotification$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateBackendNotification, data);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].SUCCESS,
                        data: data
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Notification was updated',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 20
                        }
                    });

                case 8:
                    return _context5.abrupt('return', response);

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 20
                        }
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                    return _context5.abrupt('return', response);

                case 14:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchUpdateBackendNotification() {
    var _ref2, data;

    return regeneratorRuntime.wrap(function watchUpdateBackendNotification$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].REQUEST);

                case 3:
                    _ref2 = _context6.sent;
                    data = _ref2.data;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateBackendNotification, data);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

/**
 * Delete notification by id
 * */
function deleteBackendNotification(id) {
    var response;
    return regeneratorRuntime.wrap(function deleteBackendNotification$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteBackendNotification, id);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["K" /* DELETE_BACKEND_NOTIFICATION */].SUCCESS,
                        data: id
                    });

                case 6:
                    _context7.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Notification was deleted',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 20
                        }
                    });

                case 8:
                    return _context7.abrupt('return', response);

                case 9:
                    _context7.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 20
                        }
                    });

                case 11:
                    _context7.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["K" /* DELETE_BACKEND_NOTIFICATION */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                    return _context7.abrupt('return', response);

                case 14:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function watchDeleteBackendNotification() {
    var _ref3, id;

    return regeneratorRuntime.wrap(function watchDeleteBackendNotification$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 9;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["K" /* DELETE_BACKEND_NOTIFICATION */].REQUEST);

                case 3:
                    _ref3 = _context8.sent;
                    id = _ref3.id;
                    _context8.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteBackendNotification, id);

                case 7:
                    _context8.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/**
 * Create notification
 * */
function createBackendNotification(data) {
    var response;
    return regeneratorRuntime.wrap(function createBackendNotification$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].createBackendNotification, data);

                case 2:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["B" /* CREATE_BACKEND_NOTIFICATION */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context9.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Notification was created',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 20
                        }
                    });

                case 8:
                    return _context9.abrupt('return', response);

                case 9:
                    _context9.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 20
                        }
                    });

                case 11:
                    _context9.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["B" /* CREATE_BACKEND_NOTIFICATION */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                    return _context9.abrupt('return', response);

                case 14:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function watchCreateBackendNotification() {
    var _ref4, _data;

    return regeneratorRuntime.wrap(function watchCreateBackendNotification$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (false) {
                        _context10.next = 9;
                        break;
                    }

                    _context10.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["B" /* CREATE_BACKEND_NOTIFICATION */].REQUEST);

                case 3:
                    _ref4 = _context10.sent;
                    _data = _ref4.data;
                    _context10.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(createBackendNotification, _data);

                case 7:
                    _context10.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

var _default = [watchGetBackendNotifications, watchGetBackendNotification, watchDeleteBackendNotification, watchUpdateBackendNotification, watchCreateBackendNotification];
/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getBackendNotifications, 'getBackendNotifications', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(watchGetBackendNotifications, 'watchGetBackendNotifications', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(getBackendNotification, 'getBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(watchGetBackendNotification, 'watchGetBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(updateBackendNotification, 'updateBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(watchUpdateBackendNotification, 'watchUpdateBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(deleteBackendNotification, 'deleteBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(watchDeleteBackendNotification, 'watchDeleteBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(createBackendNotification, 'createBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(watchCreateBackendNotification, 'watchCreateBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/notifications/backendNotifications.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getReqRates;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteReqRates;
/* unused harmony export editReqRates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getReqRates() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_41" /* GET_REQ_LD_RATES */].REQUEST
    };
}

function deleteReqRates() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["X" /* DELETE_REQ_LD_RATES */].REQUEST
    };
}

function editReqRates() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_2" /* EDIT_REQ_LD_RATES */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getReqRates, 'getReqRates', '/opt/atlassian/pipelines/agent/build/client/app/actions/reqldRates/reqRates.js');
    reactHotLoader.register(deleteReqRates, 'deleteReqRates', '/opt/atlassian/pipelines/agent/build/client/app/actions/reqldRates/reqRates.js');
    reactHotLoader.register(editReqRates, 'editReqRates', '/opt/atlassian/pipelines/agent/build/client/app/actions/reqldRates/reqRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(1509);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(157);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(123);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(1518);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(263);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(1555);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(326);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(1598);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(338),
    arrayIncludes = __webpack_require__(339),
    arrayIncludesWith = __webpack_require__(485),
    arrayMap = __webpack_require__(256),
    baseUnary = __webpack_require__(486),
    cacheHas = __webpack_require__(340);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1674),
    isObjectLike = __webpack_require__(135);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 491 */
/***/ (function(module, exports) {

var CONSTANTS = {

  // Positions
  positions: {
    tl: 'tl',
    tr: 'tr',
    tc: 'tc',
    bl: 'bl',
    br: 'br',
    bc: 'bc'
  },

  // Levels
  levels: {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info'
  },

  // Notification defaults
  notification: {
    title: null,
    message: null,
    level: null,
    position: 'tr',
    autoDismiss: 5,
    dismissible: true,
    action: null
  }
};


module.exports = CONSTANTS;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(194);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(195);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _ScaleIn = __webpack_require__(1729);

var _ScaleIn2 = _interopRequireDefault(_ScaleIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pulsateDuration = 750;

var FocusRipple = function (_Component) {
  (0, _inherits3.default)(FocusRipple, _Component);

  function FocusRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FocusRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
      if (!innerCircle) return;

      var startScale = 'scale(1)';
      var endScale = 'scale(0.85)';
      var currentScale = innerCircle.style.transform || startScale;
      var nextScale = currentScale === startScale ? endScale : startScale;

      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FocusRipple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      } else {
        if (this.timeout) clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'getRippleElement',
    value: function getRippleElement(props) {
      var color = props.color,
          innerStyle = props.innerStyle,
          opacity = props.opacity;
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          ripple = _context$muiTheme.ripple;


      var innerStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        opacity: opacity ? opacity : 0.16,
        backgroundColor: color || ripple.color,
        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
      }, innerStyle);

      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;
      // For browsers that don't support endsWith()
      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }
      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          style = _props.style;


      var mergedRootStyles = (0, _simpleAssign2.default)({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }, style);

      var ripple = show ? this.getRippleElement(this.props) : null;

      return _react2.default.createElement(
        _ScaleIn2.default,
        {
          maxScale: 0.85,
          style: mergedRootStyles
        },
        ripple
      );
    }
  }]);
  return FocusRipple;
}(_react.Component);

FocusRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FocusRipple.propTypes =  false ? {
  color: _propTypes2.default.string,
  innerStyle: _propTypes2.default.object,
  opacity: _propTypes2.default.number,
  show: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};
exports.default = FocusRipple;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMenu = function NavigationMenu(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
  );
};
NavigationMenu = (0, _pure2.default)(NavigationMenu);
NavigationMenu.displayName = 'NavigationMenu';
NavigationMenu.muiName = 'SvgIcon';

exports.default = NavigationMenu;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'center');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
      maxHeight: '100%'
    }
  };
}

var PopoverAnimationVertical = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationVertical, _Component);

  function PopoverAnimationVertical() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationVertical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;


      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        this.props.children
      );
    }
  }]);
  return PopoverAnimationVertical;
}(_react.Component);

PopoverAnimationVertical.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationVertical.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationVertical.propTypes =  false ? {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationVertical;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandLess = function NavigationExpandLess(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
  );
};
NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
NavigationExpandLess.displayName = 'NavigationExpandLess';
NavigationExpandLess.muiName = 'SvgIcon';

exports.default = NavigationExpandLess;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandMore = function NavigationExpandMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
  );
};
NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
NavigationExpandMore.displayName = 'NavigationExpandMore';
NavigationExpandMore.muiName = 'SvgIcon';

exports.default = NavigationExpandMore;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Subheader = __webpack_require__(1758);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Subheader2.default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectable = undefined;

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colorManipulator = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeSelectable = function makeSelectable(MyComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    (0, _inherits3.default)(_class, _Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
        }
        return previousValue || _this.isChildSelected(child, _this.props);
      }, _this.handleItemClick = function (event, item) {
        var itemValue = item.props.value;

        if (itemValue !== _this.props.value) {
          if (_this.props.onChange) {
            _this.props.onChange(event, itemValue);
          }
        }
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(_class, [{
      key: 'extendChild',
      value: function extendChild(child, styles, selectedItemStyle) {
        var _this2 = this;

        if (child && child.type && child.type.muiName === 'ListItem') {
          var selected = this.isChildSelected(child, this.props);
          var selectedChildrenStyles = void 0;
          if (selected) {
            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
          }

          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);

          this.keyIndex += 1;

          return _react2.default.cloneElement(child, {
            onClick: function onClick(event) {
              _this2.handleItemClick(event, child);
              if (child.props.onClick) {
                child.props.onClick(event);
              }
            },
            key: this.keyIndex,
            style: mergedChildrenStyles,
            nestedItems: child.props.nestedItems.map(function (child) {
              return _this2.extendChild(child, styles, selectedItemStyle);
            }),
            initiallyOpen: this.isInitiallyOpen(child)
          });
        } else {
          return child;
        }
      }
    }, {
      key: 'isInitiallyOpen',
      value: function isInitiallyOpen(child) {
        if (child.props.initiallyOpen) {
          return child.props.initiallyOpen;
        }
        return this.hasSelectedDescendant(false, child);
      }
    }, {
      key: 'isChildSelected',
      value: function isChildSelected(child, props) {
        return props.value === child.props.value;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            children = _props.children,
            selectedItemStyle = _props.selectedItemStyle,
            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);


        this.keyIndex = 0;
        var styles = {};

        if (!selectedItemStyle) {
          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
        }

        return _react2.default.createElement(
          MyComponent,
          (0, _extends3.default)({}, other, this.state),
          _react.Children.map(children, function (child) {
            return _this3.extendChild(child, styles, selectedItemStyle);
          })
        );
      }
    }]);
    return _class;
  }(_react.Component), _class.propTypes = {
    children: _propTypes2.default.node,
    onChange: _propTypes2.default.func,
    selectedItemStyle: _propTypes2.default.object,
    value: _propTypes2.default.any
  }, _class.contextTypes = {
    muiTheme: _propTypes2.default.object.isRequired
  }, _temp2;
};

exports.makeSelectable = makeSelectable;
exports.default = makeSelectable;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(138)('socket.io-parser');
var Emitter = __webpack_require__(227);
var binary = __webpack_require__(1764);
var isArray = __webpack_require__(349);
var isBuf = __webpack_require__(750);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

var ERROR_PACKET = exports.ERROR + '"encode error"';

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  } else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    var payload = tryStringify(obj.data);
    if (payload !== false) {
      str += payload;
    } else {
      return ERROR_PACKET;
    }
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

function tryStringify(str) {
  try {
    return JSON.stringify(str);
  } catch(e){
    return false;
  }
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  } else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  } else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) {
    return error('unknown packet type ' + p.type);
  }

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var buf = '';
    while (str.charAt(++i) !== '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      p.nsp += c;
      if (i === str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i === str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    var payload = tryParse(str.substr(i));
    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
    if (isPayloadValid) {
      p.data = payload;
    } else {
      return error('invalid payload');
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch(e){
    return false;
  }
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(msg) {
  return {
    type: exports.ERROR,
    data: 'parser error: ' + msg
  };
}


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(1769);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new self[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(229);
var Emitter = __webpack_require__(227);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // results of ReactNative environment detection
  this.isReactNative = opts.isReactNative;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getVesselClaims;
/* harmony export (immutable) */ __webpack_exports__["a"] = acceptUserClaimsToVessel;
/* harmony export (immutable) */ __webpack_exports__["c"] = rejectUserClaimsToVessel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getVesselClaims() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_59" /* GET_VESSEL_CLAIMS */].REQUEST
    };
}

function acceptUserClaimsToVessel(userId, vesselId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["a" /* ACCEPT_USER_CLAIMS_TO_VESSEL */].REQUEST,
        userId: userId,
        vesselId: vesselId
    };
}

function rejectUserClaimsToVessel(userId, vesselId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_75" /* REJECT_USER_CLAIMS_TO_VESSEL */].REQUEST,
        userId: userId,
        vesselId: vesselId
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVesselClaims, 'getVesselClaims', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/claims.js');
    reactHotLoader.register(acceptUserClaimsToVessel, 'acceptUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/claims.js');
    reactHotLoader.register(rejectUserClaimsToVessel, 'rejectUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/actions/vessels/claims.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(344);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDescendant = function isDescendant(el, target) {
  if (target !== null) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

var clickAwayEvents = ['mouseup', 'touchend'];
var bind = function bind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.on(document, event, callback);
  });
};
var unbind = function unbind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.off(document, event, callback);
  });
};

var ClickAwayListener = function (_Component) {
  (0, _inherits3.default)(ClickAwayListener, _Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.isCurrentlyMounted) {
        var el = _reactDom2.default.findDOMNode(_this);

        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isCurrentlyMounted = true;
      if (this.props.onClickAway) {
        bind(this.handleClickAway);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.onClickAway !== this.props.onClickAway) {
        unbind(this.handleClickAway);
        if (this.props.onClickAway) {
          bind(this.handleClickAway);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isCurrentlyMounted = false;
      unbind(this.handleClickAway);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return ClickAwayListener;
}(_react.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes2.default.element,
  onClickAway: _propTypes2.default.func
} : {};
exports.default = ClickAwayListener;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(194);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Popover = __webpack_require__(226);

var _Popover2 = _interopRequireDefault(_Popover);

var _check = __webpack_require__(505);

var _check2 = _interopRequireDefault(_check);

var _ListItem = __webpack_require__(347);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Menu = __webpack_require__(352);

var _Menu2 = _interopRequireDefault(_Menu);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nestedMenuStyle = {
  position: 'relative'
};

function getStyles(props, context) {
  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
  var textColor = context.muiTheme.baseTheme.palette.textColor;
  var indent = props.desktop ? 64 : 72;
  var sidePadding = props.desktop ? 24 : 16;

  var styles = {
    root: {
      color: props.disabled ? disabledColor : textColor,
      cursor: props.disabled ? 'default' : 'pointer',
      minHeight: props.desktop ? '32px' : '48px',
      lineHeight: props.desktop ? '32px' : '48px',
      fontSize: props.desktop ? 15 : 16,
      whiteSpace: 'nowrap'
    },

    innerDivStyle: {
      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
      paddingRight: props.rightIcon ? indent : sidePadding,
      paddingBottom: 0,
      paddingTop: 0
    },

    secondaryText: {
      float: 'right'
    },

    leftIconDesktop: {
      margin: 0,
      left: 24,
      top: 4
    },

    rightIconDesktop: {
      margin: 0,
      right: 24,
      top: 4,
      fill: context.muiTheme.menuItem.rightIconDesktopFill
    }
  };

  return styles;
}

var MenuItem = function (_Component) {
  (0, _inherits3.default)(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.cloneMenuItem = function (item) {
      return _react2.default.cloneElement(item, {
        onClick: function onClick(event) {
          if (!item.props.menuItems) {
            _this.handleRequestClose();
          }

          if (item.props.onClick) {
            item.props.onClick(event);
          }
        }
      });
    }, _this.handleClick = function (event) {
      event.preventDefault();

      _this.setState({
        open: true,
        anchorEl: _reactDom2.default.findDOMNode(_this)
      });

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleRequestClose = function () {
      _this.setState({
        open: false,
        anchorEl: null
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.open && nextProps.focusState === 'none') {
        this.handleRequestClose();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.open) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: 'applyFocusState',
    value: function applyFocusState() {
      this.refs.listItem.applyFocusState(this.props.focusState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          children = _props.children,
          desktop = _props.desktop,
          disabled = _props.disabled,
          focusState = _props.focusState,
          innerDivStyle = _props.innerDivStyle,
          insetChildren = _props.insetChildren,
          leftIcon = _props.leftIcon,
          menuItems = _props.menuItems,
          rightIcon = _props.rightIcon,
          secondaryText = _props.secondaryText,
          style = _props.style,
          animation = _props.animation,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);

      // Left Icon
      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
      if (leftIconElement) {
        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
      }

      // Right Icon
      var rightIconElement = void 0;
      if (rightIcon) {
        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
      }

      // Secondary Text
      var secondaryTextElement = void 0;
      if (secondaryText) {
        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;

        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.secondaryText) },
          secondaryText
        );
      }
      var childMenuPopover = void 0;
      if (menuItems) {
        childMenuPopover = _react2.default.createElement(
          _Popover2.default,
          {
            animation: animation,
            anchorOrigin: anchorOrigin,
            anchorEl: this.state.anchorEl,
            open: this.state.open,
            targetOrigin: targetOrigin,
            useLayerForClickAway: false,
            onRequestClose: this.handleRequestClose
          },
          _react2.default.createElement(
            _Menu2.default,
            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
            _react2.default.Children.map(menuItems, this.cloneMenuItem)
          )
        );
        other.onClick = this.handleClick;
      }

      return _react2.default.createElement(
        _ListItem2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          hoverColor: this.context.muiTheme.menuItem.hoverColor,
          innerDivStyle: mergedInnerDivStyles,
          insetChildren: insetChildren,
          leftIcon: leftIconElement,
          ref: 'listItem',
          rightIcon: rightIconElement,
          role: 'menuitem',
          style: mergedRootStyles
        }),
        children,
        secondaryTextElement,
        childMenuPopover
      );
    }
  }]);
  return MenuItem;
}(_react.Component);

MenuItem.muiName = 'MenuItem';
MenuItem.defaultProps = {
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
  checked: false,
  desktop: false,
  disabled: false,
  focusState: 'none',
  insetChildren: false,
  targetOrigin: { horizontal: 'left', vertical: 'top' }
};
MenuItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MenuItem.propTypes =  false ? {
  /**
   * Location of the anchor for the popover of nested `MenuItem`
   * elements.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, a left check mark will be rendered.
   */
  checked: _propTypes2.default.bool,
  /**
   * Elements passed as children to the underlying `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   * If true, the menu item will render with compact desktop
   * styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu item will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The focus state of the menu item. This prop is used to set the focus
   * state of the underlying `ListItem`.
   */
  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
  /**
   * Override the inline-styles of the inner div.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented.
   * This is only needed when there is no `leftIcon`.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * `MenuItem` elements to nest within the menu item.
   */
  menuItems: _propTypes2.default.node,
  /**
   * Callback function fired when the menu item is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Can be used to render primary text within the menu item.
   */
  primaryText: _propTypes2.default.node,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * Can be used to render secondary text within the menu item.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Location on the popover of nested `MenuItem` elements that will attach
   * to the anchor's origin.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * The value of the menu item.
   */
  value: _propTypes2.default.any
} : {};
exports.default = MenuItem;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCheck = function NavigationCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
  );
};
NavigationCheck = (0, _pure2.default)(NavigationCheck);
NavigationCheck.displayName = 'NavigationCheck';
NavigationCheck.muiName = 'SvgIcon';

exports.default = NavigationCheck;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Divider = __webpack_require__(1795);

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Divider2.default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _FocusRipple = __webpack_require__(492);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(736);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      position: 'relative',
      overflow: 'visible',
      display: 'table',
      height: 'auto',
      width: '100%'
    },
    input: {
      position: 'absolute',
      cursor: 'inherit',
      pointerEvents: 'all',
      opacity: 0,
      width: '100%',
      height: '100%',
      zIndex: 2,
      left: 0,
      boxSizing: 'border-box',
      padding: 0,
      margin: 0
    },
    controls: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    label: {
      float: 'left',
      position: 'relative',
      display: 'block',
      width: 'calc(100% - 60px)',
      lineHeight: '24px',
      color: baseTheme.palette.textColor,
      fontFamily: baseTheme.fontFamily
    },
    wrap: {
      transition: _transitions2.default.easeOut(),
      float: 'left',
      position: 'relative',
      display: 'block',
      flexShrink: 0,
      width: 60 - baseTheme.spacing.desktopGutterLess,
      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
    },
    ripple: {
      color: props.rippleColor || baseTheme.palette.primary1Color,
      height: '200%',
      width: '200%',
      top: -12,
      left: -12
    }
  };
}

var EnhancedSwitch = function (_Component) {
  (0, _inherits3.default)(EnhancedSwitch, _Component);

  function EnhancedSwitch() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedSwitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleChange = function (event) {
      _this.tabPressed = false;
      _this.setState({
        isKeyboardFocused: false
      });

      var isInputChecked = _this.refs.checkbox.checked;

      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
        _this.props.onParentShouldUpdate(isInputChecked);
      }

      if (_this.props.onSwitch) {
        _this.props.onSwitch(event, isInputChecked);
      }
    }, _this.handleKeyDown = function (event) {
      var code = (0, _keycode2.default)(event);

      if (code === 'tab') {
        _this.tabPressed = true;
      }
      if (_this.state.isKeyboardFocused && code === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
        _this.handleChange(event);
      }
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.refs.touchRipple.start(event);
      }
    }, _this.handleMouseUp = function () {
      _this.refs.touchRipple.end();
    }, _this.handleMouseLeave = function () {
      _this.refs.touchRipple.end();
    }, _this.handleTouchStart = function (event) {
      _this.refs.touchRipple.start(event);
    }, _this.handleTouchEnd = function () {
      _this.refs.touchRipple.end();
    }, _this.handleBlur = function (event) {
      _this.setState({
        isKeyboardFocused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      // setTimeout is needed becuase the focus event fires first
      // Wait so that we can capture if this was a keyboard focus
      // or touch focus
      setTimeout(function () {
        if (_this.tabPressed) {
          _this.setState({
            isKeyboardFocused: true
          });
        }
      }, 150);

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedSwitch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var inputNode = this.refs.checkbox;
      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
        this.props.onParentShouldUpdate(inputNode.checked);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hasCheckedProp = nextProps.hasOwnProperty('checked');
      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;

      if (hasCheckedProp || hasNewDefaultProp) {
        var switched = nextProps.checked || nextProps.defaultChecked || false;

        this.setState({
          switched: switched
        });

        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
          this.props.onParentShouldUpdate(switched);
        }
      }
    }
  }, {
    key: 'isSwitched',
    value: function isSwitched() {
      return this.refs.checkbox.checked;
    }

    // no callback here because there is no event

  }, {
    key: 'setSwitched',
    value: function setSwitched(newSwitchedValue) {
      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
        if (this.props.onParentShouldUpdate) {
          this.props.onParentShouldUpdate(newSwitchedValue);
        }
        this.refs.checkbox.checked = newSwitchedValue;
      } else {
         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.refs.checkbox.value;
    }

    // Checkbox inputs only use SPACE to change their state. Using ENTER will
    // update the ui but not the input.


    /**
     * Because both the ripples and the checkbox input cannot share pointer
     * events, the checkbox input takes control of pointer events and calls
     * ripple animations manually.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          value = _props.value,
          checked = _props.checked,
          iconStyle = _props.iconStyle,
          inputStyle = _props.inputStyle,
          inputType = _props.inputType,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          onSwitch = _props.onSwitch,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onParentShouldUpdate = _props.onParentShouldUpdate,
          disabled = _props.disabled,
          disableTouchRipple = _props.disableTouchRipple,
          disableFocusRipple = _props.disableFocusRipple,
          className = _props.className,
          rippleColor = _props.rippleColor,
          rippleStyle = _props.rippleStyle,
          style = _props.style,
          switched = _props.switched,
          switchElement = _props.switchElement,
          thumbStyle = _props.thumbStyle,
          trackStyle = _props.trackStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'checked', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);

      if (thumbStyle) {
        wrapStyles.marginLeft /= 2;
        wrapStyles.marginRight /= 2;
      }

      var labelElement = label && _react2.default.createElement(
        'label',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
        label
      );

      var showTouchRipple = !disabled && !disableTouchRipple;
      var showFocusRipple = !disabled && !disableFocusRipple;

      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
        ref: 'touchRipple',
        key: 'touchRipple',
        style: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        centerRipple: true
      });

      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
        key: 'focusRipple',
        innerStyle: mergedRippleStyle,
        color: mergedRippleStyle.color,
        muiTheme: this.context.muiTheme,
        show: this.state.isKeyboardFocused
      });

      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];

      var touchHandlers = showTouchRipple ? {
        onMouseUp: this.handleMouseUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};

      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
        ref: 'checkbox',
        type: inputType,
        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
        name: name,
        value: value,
        checked: this.state.switched,
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange
      }, touchHandlers));

      // If toggle component (indicated by whether the style includes thumb) manually lay out
      // elements in order to nest ripple elements
      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        switchElement,
        ripples
      ) : _react2.default.createElement(
        'div',
        { style: prepareStyles(wrapStyles) },
        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
        _react2.default.createElement(
          _Paper2.default,
          { style: thumbStyle, zDepth: 1, circle: true },
          ' ',
          ripples,
          ' '
        )
      );

      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
        'div',
        { style: styles.controls },
        switchOrThumbElement,
        labelElement
      ) : _react2.default.createElement(
        'div',
        { style: styles.controls },
        labelElement,
        switchOrThumbElement
      );

      return _react2.default.createElement(
        'div',
        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp
        }),
        inputElement,
        elementsInOrder
      );
    }
  }]);
  return EnhancedSwitch;
}(_react.Component);

EnhancedSwitch.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedSwitch.propTypes =  false ? {
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultChecked: _propTypes2.default.bool,
  disableFocusRipple: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  iconStyle: _propTypes2.default.object,
  inputStyle: _propTypes2.default.object,
  inputType: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.node,
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  labelStyle: _propTypes2.default.object,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onParentShouldUpdate: _propTypes2.default.func,
  onSwitch: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  rippleColor: _propTypes2.default.string,
  rippleStyle: _propTypes2.default.object,
  style: _propTypes2.default.object,
  switchElement: _propTypes2.default.element.isRequired,
  switched: _propTypes2.default.bool.isRequired,
  thumbStyle: _propTypes2.default.object,
  trackStyle: _propTypes2.default.object,
  value: _propTypes2.default.any
} : {};
exports.default = EnhancedSwitch;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(266);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _SlideInChild = __webpack_require__(1814);

var _SlideInChild2 = _interopRequireDefault(_SlideInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideIn = function (_Component) {
  (0, _inherits3.default)(SlideIn, _Component);

  function SlideIn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SlideIn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
      return _this.props.direction;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SlideIn, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          enterDelay = _props.enterDelay,
          children = _props.children,
          childStyle = _props.childStyle,
          direction = _props.direction,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        overflow: 'hidden',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _SlideInChild2.default,
          {
            key: child.key,
            direction: direction,
            enterDelay: enterDelay,
            getLeaveDirection: _this2.getLeaveDirection,
            style: childStyle
          },
          child
        );
      }, this);

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);
  return SlideIn;
}(_react.Component);

SlideIn.defaultProps = {
  enterDelay: 0,
  direction: 'left'
};
SlideIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SlideIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
  enterDelay: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = SlideIn;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.IconMenu = undefined;

var _IconMenu2 = __webpack_require__(1824);

var _IconMenu3 = _interopRequireDefault(_IconMenu2);

var _MenuItem2 = __webpack_require__(504);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.IconMenu = _IconMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _IconMenu3.default;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1829);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1832);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Slider = __webpack_require__(1836);

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Slider2.default;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCheckCircle = function ActionCheckCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
  );
};
ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
ActionCheckCircle.displayName = 'ActionCheckCircle';
ActionCheckCircle.muiName = 'SvgIcon';

exports.default = ActionCheckCircle;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tabs = exports.Tab = undefined;

var _Tab2 = __webpack_require__(781);

var _Tab3 = _interopRequireDefault(_Tab2);

var _Tabs2 = __webpack_require__(1847);

var _Tabs3 = _interopRequireDefault(_Tabs2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tab = _Tab3.default;
exports.Tabs = _Tabs3.default;
exports.default = _Tabs3.default;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tooltip = __webpack_require__(740);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;


  return {
    root: {
      fontWeight: 'normal',
      fontSize: 12,
      paddingLeft: tableHeaderColumn.spacing,
      paddingRight: tableHeaderColumn.spacing,
      height: tableHeaderColumn.height,
      textAlign: 'left',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      color: tableHeaderColumn.textColor,
      position: 'relative'
    },
    tooltip: {
      boxSizing: 'border-box',
      marginTop: tableHeaderColumn.height / 2
    }
  };
}

var TableHeaderColumn = function (_Component) {
  (0, _inherits3.default)(TableHeaderColumn, _Component);

  function TableHeaderColumn() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableHeaderColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.onMouseEnter = function () {
      if (_this.props.tooltip !== undefined) {
        _this.setState({ hovered: true });
      }
    }, _this.onMouseLeave = function () {
      if (_this.props.tooltip !== undefined) {
        _this.setState({ hovered: false });
      }
    }, _this.onClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.props.columnNumber);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableHeaderColumn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          columnNumber = _props.columnNumber,
          hoverable = _props.hoverable,
          onClick = _props.onClick,
          onHover = _props.onHover,
          onHoverExit = _props.onHoverExit,
          style = _props.style,
          tooltip = _props.tooltip,
          tooltipStyle = _props.tooltipStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var handlers = {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onClick: this.onClick
      };

      var tooltipNode = void 0;

      if (tooltip !== undefined) {
        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
          label: tooltip,
          show: this.state.hovered,
          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
        });
      }

      return _react2.default.createElement(
        'th',
        (0, _extends3.default)({
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, handlers, other),
        tooltipNode,
        children
      );
    }
  }]);
  return TableHeaderColumn;
}(_react.Component);

TableHeaderColumn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableHeaderColumn.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Number to identify the header row. This property
   * is automatically populated when used with TableHeader.
   */
  columnNumber: _propTypes2.default.number,
  /**
   * @ignore
   * Not used here but we need to remove it from the root element.
   */
  hoverable: _propTypes2.default.bool,
  /** @ignore */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   * Not used here but we need to remove it from the root element.
   */
  onHover: _propTypes2.default.func,
  /**
   * @ignore
   * Not used here but we need to remove it from the root element.
   */
  onHoverExit: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The string to supply to the tooltip. If not
   * string is supplied no tooltip will be shown.
   */
  tooltip: _propTypes2.default.string,
  /**
   * Additional styling that can be applied to the tooltip.
   */
  tooltipStyle: _propTypes2.default.object
} : {};
exports.default = TableHeaderColumn;

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getSocketconnection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sockets__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var socket = void 0;

function getSocketconnection(props) {
    var retries = 0;

    function connectSocket() {
        socket = __WEBPACK_IMPORTED_MODULE_0_sockets__["a" /* default */].connect(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(props, ['userId']));
    }

    function reconnect() {
        if (retries < 3 && !socket) {
            connectSocket();
            retries++;
            if (!socket) {
                reconnect();
            }
        }
    }

    reconnect();

    return socket;
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(socket, 'socket', '/opt/atlassian/pipelines/agent/build/client/app/helpers/socket.js');
    reactHotLoader.register(getSocketconnection, 'getSocketconnection', '/opt/atlassian/pipelines/agent/build/client/app/helpers/socket.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128508
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(795),
    baseKeysIn = __webpack_require__(1868),
    isArrayLike = __webpack_require__(193);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(77),
    stubFalse = __webpack_require__(1865);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_react_utils__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_realCompanies__ = __webpack_require__(520);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var companiesConfig = {
    text: 'name',
    value: '_id'
};

function loadCompanies(search, withRealCompanies) {
    if (search.length < 2) {
        return [];
    }
    return __WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].findCompany(search, withRealCompanies).then(function (response) {
        return response.data.data;
    }).catch(function (err) {
        console.error(err);
        return null;
    });
}

function DisponentOwner(_ref) {
    var _this = this;

    var disponentOwner = _ref.disponentOwner,
        changeField = _ref.changeField,
        confirmed = _ref.confirmed,
        _ref$textFieldStyle = _ref.textFieldStyle,
        textFieldStyle = _ref$textFieldStyle === undefined ? undefined : _ref$textFieldStyle,
        _ref$context = _ref.context,
        context = _ref$context === undefined ? undefined : _ref$context;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        disponents = _useState2[0],
        setDisponents = _useState2[1];

    var _useRefState = Object(__WEBPACK_IMPORTED_MODULE_3_helpers_react_utils__["a" /* useRefState */])(''),
        _useRefState2 = _slicedToArray(_useRefState, 3),
        search = _useRefState2[0],
        setSearch = _useRefState2[1],
        searchRef = _useRefState2[2];

    var onChangeAutoCompleteDisponent = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var withIfchorBroker, companies;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setSearch(e);

                            changeField({
                                field: 'disponentOwner',
                                value: { _id: undefined, name: e }
                            });

                            withIfchorBroker = void 0;


                            if (context) {
                                withIfchorBroker = Object(__WEBPACK_IMPORTED_MODULE_4_helpers_realCompanies__["a" /* calculateIsIfchorBroker */])(context.userId.email);
                            }

                            _context.next = 6;
                            return loadCompanies(e, withIfchorBroker);

                        case 6:
                            companies = _context.sent;

                            if (!(searchRef.current !== e)) {
                                _context.next = 9;
                                break;
                            }

                            return _context.abrupt('return');

                        case 9:

                            setDisponents(companies);

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function onChangeAutoCompleteDisponent(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var onChooseAutoCompleteDisponent = function onChooseAutoCompleteDisponent(e) {
        changeField({
            field: 'disponentOwner',
            value: e
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */], {
        name: 'disponentName',
        floatingLabelText: 'Disponent owner',
        textFieldStyle: _extends({ fontSize: '16px' }, textFieldStyle),
        hintText: 'Disponent owner',
        searchText: search || disponentOwner && disponentOwner.name || '',
        dataSource: disponents,
        onUpdateInput: onChangeAutoCompleteDisponent,
        onNewRequest: onChooseAutoCompleteDisponent,
        dataSourceConfig: companiesConfig,
        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */].noFilter,
        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
        menuStyle: { width: 'auto' },
        popoverProps: {
            canAutoPosition: true
        },
        fullWidth: true,
        disabled: confirmed
    });
}

var _default = DisponentOwner;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(companiesConfig, 'companiesConfig', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/DisponentOwner.jsx');
    reactHotLoader.register(loadCompanies, 'loadCompanies', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/DisponentOwner.jsx');
    reactHotLoader.register(DisponentOwner, 'DisponentOwner', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/DisponentOwner.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/DisponentOwner.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = calculateIsIfchorBroker;
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function calculateIsIfchorBroker(email) {
    return (/@(ifchor\.(ch|com))/i.test(email)
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(calculateIsIfchorBroker, "calculateIsIfchorBroker", "/opt/atlassian/pipelines/agent/build/client/app/helpers/realCompanies.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertWarning = function AlertWarning(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};
AlertWarning = (0, _pure2.default)(AlertWarning);
AlertWarning.displayName = 'AlertWarning';
AlertWarning.muiName = 'SvgIcon';

exports.default = AlertWarning;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContentCopy = function ContentContentCopy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
  );
};
ContentContentCopy = (0, _pure2.default)(ContentContentCopy);
ContentContentCopy.displayName = 'ContentContentCopy';
ContentContentCopy.muiName = 'SvgIcon';

exports.default = ContentContentCopy;

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OnlineManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onlineManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribable__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(70);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* isServer */] && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(__WEBPACK_IMPORTED_MODULE_1__subscribable__["a" /* Subscribable */]);
var onlineManager = new OnlineManager();

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focusManager__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscribable__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__retryer__ = __webpack_require__(236);








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(__WEBPACK_IMPORTED_MODULE_2__utils__["k" /* noop */]);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* isServer */] || this.currentResult.isStale || !Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* isValidTimeout */])(this.options.staleTime)) {
      return;
    }

    var time = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* timeUntilStale */])(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (__WEBPACK_IMPORTED_MODULE_2__utils__["g" /* isServer */] || this.options.enabled === false || !Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* isValidTimeout */])(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || __WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["r" /* replaceEqualDeep */])(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            Object(__WEBPACK_IMPORTED_MODULE_6__logger__["a" /* getLogger */])().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["r" /* replaceEqualDeep */])(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            Object(__WEBPACK_IMPORTED_MODULE_6__logger__["a" /* getLogger */])().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["t" /* shallowEqualObjects */])(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !Object(__WEBPACK_IMPORTED_MODULE_7__retryer__["c" /* isCancelledError */])(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(__WEBPACK_IMPORTED_MODULE_5__subscribable__["a" /* Subscribable */]);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowForward = function NavigationArrowForward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z' })
  );
};
NavigationArrowForward = (0, _pure2.default)(NavigationArrowForward);
NavigationArrowForward.displayName = 'NavigationArrowForward';
NavigationArrowForward.muiName = 'SvgIcon';

exports.default = NavigationArrowForward;

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PUMP_TYPES = ["Unknown", "Centrifugal", "Vac-Strip", "Reciprocating", "Screw", "Gear", "Eductors / Ejector", "Peristaltic", "Lobe", "Piston", "Deepwell", "BDPS", "Desmi Rotordynamic", "Marflex Deepwell", "Hydraulic Driven", "Framo"];

var Pumps = function (_React$Component) {
    _inherits(Pumps, _React$Component);

    function Pumps(props) {
        _classCallCheck(this, Pumps);

        var _this = _possibleConstructorReturn(this, (Pumps.__proto__ || Object.getPrototypeOf(Pumps)).call(this, props));

        _this.addRow = _this.addRow.bind(_this);
        _this.removeRow = _this.removeRow.bind(_this);
        return _this;
    }

    _createClass(Pumps, [{
        key: 'addRow',
        value: function addRow() {
            var pumps = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.pumps);

            pumps.push({
                type: '',
                quantity: '',
                capacity: ''
            });

            this.props.changeField({ field: 'pumps.' + this.props.type, value: pumps });
        }
    }, {
        key: 'removeRow',
        value: function removeRow(index) {
            var pumps = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.pumps);
            pumps.splice(index, 1);
            this.props.changeField({ field: 'pumps.' + this.props.type, value: pumps });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.pumps.length === 0) {
                this.addRow();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                changeField = _props.changeField,
                getError = _props.getError,
                pumps = _props.pumps,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                pumps.map(function (pump, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: index, className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                                {
                                    value: pump.type || '',
                                    onChange: function onChange(e, i, value) {
                                        changeField([{
                                            field: 'pumps.' + _this2.props.type + '[' + index + '].type',
                                            value: value
                                        }]);
                                    },
                                    disabled: confirmed,
                                    errorText: getError && getError('pumps.' + _this2.props.type + '[' + index + '].type'),
                                    maxHeight: 200,
                                    name: 'type',
                                    floatingLabelText: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(_this2.props.type) + ' pump type',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    fullWidth: true,
                                    autoWidth: true,
                                    underlineStyle: modifiedFields && modifiedFields.includes('pumps.' + _this2.props.type + '[' + index + '].type') ? underStyle : null

                                },
                                PUMP_TYPES.map(function (type) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                        key: type,
                                        value: type,
                                        primaryText: type
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                                name: 'pumps.' + _this2.props.type + '[' + index + '].quantity',
                                floatingLabelText: 'Quantity',
                                floatingLabelStyle: { fontSize: '13px' },
                                value: pump.quantity || '',
                                fullWidth: true,
                                disabled: !pump.type,
                                errorText: getError && getError('pumps.' + _this2.props.type + '[' + index + '].quantity'),
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: 'pumps.' + _this2.props.type + '[' + index + '].quantity',
                                        value: value,
                                        type: 'number'
                                    });
                                },

                                underlineStyle: modifiedFields && modifiedFields.includes('pumps.' + _this2.props.type + '[' + index + '].quantity') ? underStyle : null

                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                                name: 'pumps.' + _this2.props.type + '[' + index + '].capacity',
                                floatingLabelText: 'Capacity, m3/hour',
                                floatingLabelStyle: { fontSize: '13px' },
                                value: pump.capacity || '',
                                fullWidth: true,
                                floatNumber: true,
                                disabled: !pump.type,
                                errorText: getError && getError('pumps.' + _this2.props.type + '[' + index + '].capacity'),
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: 'pumps.' + _this2.props.type + '[' + index + '].capacity',
                                        value: value,
                                        type: 'number'
                                    });
                                },

                                underlineStyle: modifiedFields && modifiedFields.includes('pumps.' + _this2.props.type + '[' + index + '].capacity') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1 middle-xs center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { margin: '25px 0 0 0' } },
                                index === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: confirmed,
                                        onClick: _this2.addRow
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                                ),
                                index !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: confirmed,
                                        onClick: function onClick() {
                                            _this2.removeRow(index);
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                                )
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Pumps;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Pumps;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PUMP_TYPES, 'PUMP_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Pumps.jsx');
    reactHotLoader.register(Pumps, 'Pumps', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Pumps.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Pumps.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSearch = function ActionSearch(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })
  );
};
ActionSearch = (0, _pure2.default)(ActionSearch);
ActionSearch.displayName = 'ActionSearch';
ActionSearch.muiName = 'SvgIcon';

exports.default = ActionSearch;

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkGrabs; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var checkGrabs = function checkGrabs(array) {
    return array.map(function (item) {
        var cleaned = {};
        Object.entries(item).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                val = _ref2[1];

            if (val) {
                cleaned[key] = val;
            }
        });
        return cleaned;
    }).filter(function (_ref3) {
        var type = _ref3.type,
            quantity = _ref3.quantity;
        return !!type && !!quantity;
    });
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(checkGrabs, "checkGrabs", "/opt/atlassian/pipelines/agent/build/client/app/helpers/vessels.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128738
      var cssReload = require("!../../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VesselRequirements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitialVesselRequirementsContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fixVesselRequirementsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_vesselRequirements__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Form_formConfig_utils__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Form_form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_vesselTypes__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Vessels_Single_Rows_TypeByPurpose__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Vessels_Single_Rows_TypeBySpecialty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Vessels_Single_Rows_TypeByConstruction__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Vessels_Single_Rows_RegisterClassMulti__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Form_FormSelectFlags__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Form_FormGearsAndGrabs__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Form_FormPumps__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_Form_FormIGS__ = __webpack_require__(1975);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
















var InitialVesselRequirementsContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});

var fixVesselRequirementsData = function fixVesselRequirementsData(vr) {
    if (!vr || (typeof vr === 'undefined' ? 'undefined' : _typeof(vr)) !== 'object') return;

    if (vr.typeByPurpose) vr.typeByPurpose = vr.typeByPurpose.toUpperCase();
    if (vr.typeBySpecialty) vr.typeBySpecialty = vr.typeBySpecialty.toUpperCase();
    if (vr.typeByConstruction) vr.typeByConstruction = vr.typeByConstruction.toUpperCase();
};

var validateMin = __WEBPACK_IMPORTED_MODULE_2__common_Form_formConfig_utils__["a" /* formConfigUtils */].validateMin,
    validateMax = __WEBPACK_IMPORTED_MODULE_2__common_Form_formConfig_utils__["a" /* formConfigUtils */].validateMax;


var config = {
    dwtMin: {
        label: 'DWT min',
        type: 'number',
        validate: validateMin({ maxFieldName: 'dwtMax' })
    },
    dwtMax: {
        label: 'DWT max',
        type: 'number',
        validate: validateMax({ minFieldName: 'dwtMin' })
    },
    capacityMin: {
        label: 'Capacity min',
        type: 'number',
        validate: validateMin({ maxFieldName: 'capacityMax' })
    },
    capacityMax: {
        label: 'Capacity max',
        type: 'number',
        validate: validateMax({ minFieldName: 'capacityMin' })
    },
    typeByPurpose: {
        render: function render(_ref) {
            var form = _ref.form;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Vessels_Single_Rows_TypeByPurpose__["a" /* default */], {
                type: form.values.typeByPurpose,
                changeField: form.onChange,
                fromTcOrder: true
            });
        }
    },
    typeBySpecialty: {
        render: function render(_ref2) {
            var form = _ref2.form;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Vessels_Single_Rows_TypeBySpecialty__["a" /* default */], {
                typeBySpecialty: form.values.typeBySpecialty,
                changeField: form.onChange,
                typeByPurpose: form.values.typeByPurpose,
                fromTcOrder: true
            });
        }
    },
    typeByConstruction: {
        render: function render(_ref3) {
            var form = _ref3.form;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Vessels_Single_Rows_TypeByConstruction__["a" /* default */], {
                type: form.values.typeByConstruction,
                changeField: form.onChange
            });
        }
    },
    iceClass: {
        label: 'Ice Class',
        type: 'select',
        options: __WEBPACK_IMPORTED_MODULE_1__constants_vesselRequirements__["e" /* iceClassNames */]
    },
    teuMin: {
        label: 'Teu min, m',
        type: 'number',
        validate: validateMin({
            maxFieldName: 'teuMax',
            min: 50,
            max: 30000
        }),
        disabled: function disabled(form) {
            return !['MPP', 'CONT'].includes(form.values.typeByPurpose);
        }
    },
    teuMax: {
        label: 'Teu max, m',
        type: 'number',
        validate: validateMax({ minFieldName: 'teuMin', min: 50, max: 30000 }),
        disabled: function disabled(form) {
            return form.config.teuMin.disabled(form);
        }
    },
    linerMeterMin: {
        label: 'Liner meter min, m',
        type: 'number',
        validate: validateMin({ maxFieldName: 'linerMeterMax' }),
        disabled: function disabled(form) {
            return !/ro-(ro|lo)/i.test(form.values.typeBySpecialty);
        }
    },
    linerMeterMax: {
        label: 'Liner meter max, m',
        type: 'number',
        validate: validateMax({ maxFieldName: 'linerMeterMin' }),
        disabled: function disabled(form) {
            return form.config.linerMeterMin.disabled(form);
        }
    },
    loaMax: {
        label: 'LOA max, m',
        type: 'number'
    },
    beamMax: {
        label: 'Beam max, m',
        type: 'number'
    },
    draftMax: {
        label: 'Draft max, m',
        type: 'number'
    },
    piClubMember: {
        label: 'PI Club',
        type: 'checkbox'
    },
    ageMin: {
        label: 'Age min',
        type: 'number',
        validate: validateMin({ maxFieldName: 'ageMax' })
    },
    ageMax: {
        label: 'Age max',
        type: 'number',
        validate: validateMax({ minFieldName: 'ageMin' })
    },
    openHatch: {
        label: 'Open hatch',
        type: 'select-fitted'
    },
    boxShaped: {
        label: 'Box shaped',
        type: 'select-fitted'
    },
    registerClasses: {
        serialize: function serialize(registerClasses) {
            return registerClasses && registerClasses.map(function (x) {
                return _extends({}, x, { registerClass: x._id });
            });
        },

        render: function render(_ref4) {
            var form = _ref4.form;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Vessels_Single_Rows_RegisterClassMulti__["a" /* RegisterClassMultiNoRedux */], {
                captureSaveHandler: form.addSaveHandler,
                tcOrder: { vesselRequirements: { registerClasses: form.values.registerClasses || [] } },
                updateTcOrder: function updateTcOrder(_, values) {
                    form.onChange({
                        field: 'registerClasses',
                        value: values.vesselRequirements.registerClasses
                    });
                }
            });
        }
    },
    flags: {
        serialize: function serialize(flags) {
            return flags && flags.map(function (x) {
                return _extends({}, x, { flag: x._id || x.flag._id });
            });
        },

        render: __WEBPACK_IMPORTED_MODULE_10__common_Form_FormSelectFlags__["a" /* FormSelectFlags */]
    },
    gearV2: {
        render: __WEBPACK_IMPORTED_MODULE_11__common_Form_FormGearsAndGrabs__["a" /* FormGears */]
    },
    grabV2: {
        render: __WEBPACK_IMPORTED_MODULE_11__common_Form_FormGearsAndGrabs__["b" /* FormGrabs */]
    },
    pumps: {
        render: __WEBPACK_IMPORTED_MODULE_12__common_Form_FormPumps__["a" /* FormPumps */]
    },
    ventilationFitted: {
        label: 'Ventilation',
        type: 'select-fitted',
        onChange: function onChange(value, form) {
            return !value && form.onChange({ field: 'ventilationType', value: '' });
        }
    },
    ventilationType: {
        label: 'Ventilation',
        type: 'select',
        options: __WEBPACK_IMPORTED_MODULE_1__constants_vesselRequirements__["i" /* ventilationOptions */],
        disabled: function disabled(form) {
            return !form.values.ventilationFitted;
        }
    },
    referPlugFitted: {
        label: 'Reefer plug',
        type: 'select-fitted',
        onChange: function onChange(value, form) {
            return !value && form.onChange([{ field: 'referPlugQuantity', value: null }]);
        }
    },
    referPlugQuantity: {
        label: 'Reefer plugs quantity',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.referPlugFitted;
        }
    },
    imoFitted: {
        label: 'Imo',
        type: 'select-fitted',
        onChange: function onChange(value, form) {
            return !value && form.onChange([{ field: 'imoApp', value: null }, { field: 'imoClass', value: null }]);
        }
    },
    imoApp: {
        label: 'Imo app',
        type: 'select',
        options: __WEBPACK_IMPORTED_MODULE_1__constants_vesselRequirements__["f" /* imoAppNames */],
        disabled: function disabled(form) {
            return !form.values.imoFitted;
        },
        onChange: function onChange(_, form) {
            return form.onChange({ field: 'imoFitted', value: true });
        }
    },
    imoClass: {
        label: 'Imo class',
        type: 'select',
        options: __WEBPACK_IMPORTED_MODULE_1__constants_vesselRequirements__["g" /* imoClassNames */],
        disabled: function disabled(form) {
            return !form.values.imoFitted;
        },
        onChange: function onChange(_, form) {
            return form.onChange({ field: 'imoFitted', value: true });
        }
    },
    scrubberFitted: {
        label: 'Scrubber',
        type: 'select-fitted'
    },
    co2Fitted: {
        label: 'CO2Fitted',
        type: 'select-fitted'
    },
    a60BulkheadFitted: {
        label: 'A60 bulkhead',
        type: 'select-fitted'
    },
    itfFitted: {
        label: 'Itf',
        type: 'select-fitted'
    },
    cementHolesFitted: {
        label: 'Cement holes',
        type: 'select-fitted'
    },
    lakesFitted: {
        label: 'Lakes',
        type: 'select-fitted'
    },
    logsFitted: {
        label: 'Logs',
        type: 'select-fitted'
    },
    aussieFitted: {
        label: 'Aussie',
        type: 'select-fitted'
    },
    strengthenHeavy: {
        label: 'Strengthened heavy',
        type: 'select-fitted'
    },
    wholeTank: {
        label: 'Whole Tank',
        type: 'checkbox'
    },
    coatingType: {
        label: 'Coating Type',
        type: 'select',
        options: [''].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__constants_vesselRequirements__["c" /* TANK_COATING_TYPES */]))
    },
    'heating.exchanger': {
        label: 'Heat Exchanger',
        type: 'select-fitted',
        onChange: function onChange(value, form) {
            !value && form.onChange(['heating.medium', 'heating.maxLoaded', 'heating.maxMaintained'].map(function (field) {
                return { field: field, value: null };
            }));
        }
    },
    'heating.medium': {
        label: 'Heating medium',
        type: 'select',
        options: [''].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__constants_vesselRequirements__["a" /* HEATING_MEDIUM */])),
        disabled: function disabled(form) {
            return !form.values['heating.exchanger'];
        }
    },
    'heating.maxLoaded': {
        label: 'Max loaded °C',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values['heating.exchanger'];
        }
    },
    'heating.maxMaintained': {
        label: 'Max maintained °C',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values['heating.exchanger'];
        }
    },
    newPanama: {
        label: 'New Panama',
        type: 'select-fitted'
    },
    bwts: {
        label: 'BWTS',
        hint: 'Ballast water treatment system',
        type: 'select-fitted'
    },
    coiled: {
        label: 'Coiled',
        type: 'select-fitted'
    },
    cargoTankDryer: {
        label: 'Cargo tank dryer',
        type: 'select-fitted'
    },
    cargoCoolingSystem: {
        label: 'Cargo cooling system',
        type: 'select-fitted'
    },
    crudeOilWashing: {
        label: 'Crude oil washing',
        type: 'select-fitted'
    },
    rcttms: {
        label: 'RCTTMS',
        hint: 'Remote cargo tank temperature monitoring system',
        type: 'select-fitted'
    },
    rctpms: {
        label: 'RCTPMS',
        hint: 'Remote cargo tank pressure monitoring system',
        type: 'select-fitted'
    },
    bowChainStopper: {
        label: 'Bow chain stopper',
        type: 'select-fitted'
    },
    chainSize: {
        label: 'Chain size, mm',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.bowChainStopper;
        }
    },
    ngs: {
        label: 'NGS',
        type: 'select-fitted'
    },
    ngsCapacity: {
        label: 'Capacity, cbm/hr (95%)',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.ngs;
        }
    },
    vrs: {
        label: 'VRS',
        type: 'select-fitted'
    },
    vrsNumLines: {
        label: 'Num of independent lines',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.vrs;
        }
    },
    bowThruster: {
        label: 'Bow thruster',
        type: 'select-fitted'
    },
    bowThrusterNum: {
        label: 'Num, pc',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.bowThruster;
        }
    },
    bowThrusterBhp: {
        label: 'BHP',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.bowThruster;
        }
    },
    bowThrusterKw: {
        label: 'kW',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.bowThruster;
        }
    },
    stemThruster: {
        label: 'Stem thruster',
        type: 'select-fitted'
    },
    stemThrusterNum: {
        label: 'Num, pc',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.stemThruster;
        }
    },
    stemThrusterBhp: {
        label: 'BHP',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.stemThruster;
        }
    },
    stemThrusterKw: {
        label: 'kW',
        type: 'number',
        disabled: function disabled(form) {
            return !form.values.stemThruster;
        }
    },
    igsFitted: {
        label: 'IGS',
        type: 'select-fitted'
    },
    igs: {
        render: __WEBPACK_IMPORTED_MODULE_13__common_Form_FormIGS__["a" /* FormIGS */]
    }
};

var deleteObjectNulls = function deleteObjectNulls(obj) {
    // eslint-disable-next-line no-restricted-syntax
    for (var key in obj) {
        if (obj[key] === null) {
            delete obj[key];
        }
    }
    return obj;
};

function VesselRequirements(_ref5) {
    var _onChange = _ref5.onChange,
        captureSaveHandler = _ref5.captureSaveHandler,
        _ref5$initialState = _ref5.initialState,
        initialState = _ref5$initialState === undefined ? {} : _ref5$initialState;

    var form = Object(__WEBPACK_IMPORTED_MODULE_3__common_Form_form__["b" /* useForm */])({
        config: config,
        initialState: initialState,
        captureSaveHandler: captureSaveHandler,
        onChange: function onChange(data) {
            _onChange({
                vesselRequirements: _extends({}, data, {
                    gearV2: data.gearV2 && _extends({}, data.gearV2, {
                        summary: data.gearV2.summary.filter(function (x) {
                            return x.type;
                        }).map(function (_ref6) {
                            var capacityMin = _ref6.capacityMin,
                                x = _objectWithoutProperties(_ref6, ['capacityMin']);

                            return deleteObjectNulls(_extends({}, x, { capacity: capacityMin }));
                        })
                    }),
                    grabV2: data.grabV2 && _extends({}, data.grabV2, {
                        summary: data.grabV2.summary.filter(function (x) {
                            return x.type;
                        }).map(function (_ref7) {
                            var volumeMin = _ref7.volumeMin,
                                x = _objectWithoutProperties(_ref7, ['volumeMin']);

                            return deleteObjectNulls(_extends({}, x, { volume: volumeMin }));
                        })
                    }),

                    // turn the flat 'key.values' into a nested key: { value1: '...', value2: '...' }
                    'heating.exchanger': undefined,
                    'heating.medium': undefined,
                    'heating.maxLoaded': undefined,
                    'heating.maxMaintained': undefined,
                    heating: data['heating.exchanger'] ? {
                        exchanger: true,
                        medium: data['heating.medium'],
                        maxLoaded: data['heating.maxLoaded'],
                        maxMaintained: data['heating.maxMaintained']
                    } : undefined
                })
            });
        }
    });

    var isDryCargo = !__WEBPACK_IMPORTED_MODULE_5__constants_vesselTypes__["a" /* LIQUID_TYPES_BY_PURPOSE */].includes(form.values.typeByPurpose);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'paper-block margin-bottom' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'name-block static huge-name' },
            'Vessel Requirements'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__common_Form_form__["a" /* FormContextProvider */],
            { value: form },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                InitialVesselRequirementsContext.Provider,
                { value: initialState },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'dwtMin' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'dwtMax' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'capacityMin' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'capacityMax' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'typeByPurpose' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'typeBySpecialty' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'typeByConstruction' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'iceClass' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'teuMin' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'teuMax' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'linerMeterMin' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'linerMeterMax' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'loaMax' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'beamMax' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'draftMax' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'piClubMember' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'ageMin' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'ageMax' }),
                    !isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'piClubMember' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'openHatch' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'boxShaped' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["a" /* FormInput */], { name: 'registerClasses' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["a" /* FormInput */], { name: 'flags' }),
                isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["a" /* FormInput */], { name: 'gearV2' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["a" /* FormInput */], { name: 'grabV2' })
                ),
                !isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Pumps'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["a" /* FormInput */], { name: 'pumps' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Tank Coating'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'wholeTank' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'coatingType' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Heating'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'heating.exchanger' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'heating.medium' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'heating.maxLoaded' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'heating.maxMaintained' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block static huge-name' },
                    'Technical equipment / certificate'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'ventilationFitted' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'ventilationType' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'referPlugFitted' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'referPlugQuantity' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'imoFitted' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'imoApp' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'imoClass' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'scrubberFitted' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'co2Fitted' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'a60BulkheadFitted' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'itfFitted' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'cementHolesFitted' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'lakesFitted' }),
                    isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'logsFitted' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'aussieFitted' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'strengthenHeavy' })
                    ),
                    !isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'newPanama' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'bwts' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'coiled' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'cargoTankDryer' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'cargoCoolingSystem' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'crudeOilWashing' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'rcttms' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'rctpms' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'bowChainStopper' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'chainSize' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-6' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'ngs' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'ngsCapacity' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'vrs' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'vrsNumLines' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'bowThruster' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'bowThrusterNum' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'bowThrusterBhp' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'bowThrusterKw' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'stemThruster' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'stemThrusterNum' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'stemThrusterBhp' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["b" /* FormInputCol */], { name: 'stemThrusterKw' })
                    )
                ),
                !isDryCargo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Form_FormInput__["a" /* FormInput */], { name: 'igs' })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(InitialVesselRequirementsContext, 'InitialVesselRequirementsContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements.jsx');
    reactHotLoader.register(fixVesselRequirementsData, 'fixVesselRequirementsData', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements.jsx');
    reactHotLoader.register(validateMin, 'validateMin', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements.jsx');
    reactHotLoader.register(validateMax, 'validateMax', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements.jsx');
    reactHotLoader.register(config, 'config', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements.jsx');
    reactHotLoader.register(deleteObjectNulls, 'deleteObjectNulls', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements.jsx');
    reactHotLoader.register(VesselRequirements, 'VesselRequirements', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/VesselRequirements.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = postRequestCargo;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRequestsCargo;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateRequestCargo;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteRequestCargo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postRequestCargo(cargoRequest) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].REQUEST,
        cargoRequest: cargoRequest
    };
}

function getRequestsCargo(filter) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_18" /* GET_CARGO_REQUESTS */].REQUEST,
        filter: filter
    };
}

function updateRequestCargo(cargoRequestId, userId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_127" /* UPDATE_CARGO_REQUEST */].REQUEST,
        cargoRequestId: cargoRequestId,
        userId: userId
    };
}

function deleteRequestCargo(cargoRequestId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["O" /* DELETE_CARGO_REQUEST */].REQUEST,
        cargoRequestId: cargoRequestId
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestCargo, 'postRequestCargo', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/requests.js');
    reactHotLoader.register(getRequestsCargo, 'getRequestsCargo', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/requests.js');
    reactHotLoader.register(updateRequestCargo, 'updateRequestCargo', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/requests.js');
    reactHotLoader.register(deleteRequestCargo, 'deleteRequestCargo', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCargoAssigners;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCargoAssignersPost;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateCargoAssigner;
/* unused harmony export searchCargoAssigners */
/* harmony export (immutable) */ __webpack_exports__["c"] = saveStatusCargoAssigner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoAssigners() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].REQUEST
    };
}

function getCargoAssignersPost(realCargoIds) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].REQUEST,
        realCargoIds: realCargoIds
    };
}

function updateCargoAssigner(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_123" /* UPDATE_CARGO_ASSIGNER */].REQUEST,
        item: item
    };
}

function searchCargoAssigners(search) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_104" /* SEARCH_CARGO_ASSIGNERS */],
        search: search
    };
}

function saveStatusCargoAssigner(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_99" /* SAVE_STATUS_CARGO_ASSIGNER */],
        item: item
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoAssigners, 'getCargoAssigners', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/assigners.js');
    reactHotLoader.register(getCargoAssignersPost, 'getCargoAssignersPost', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/assigners.js');
    reactHotLoader.register(updateCargoAssigner, 'updateCargoAssigner', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/assigners.js');
    reactHotLoader.register(searchCargoAssigners, 'searchCargoAssigners', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/assigners.js');
    reactHotLoader.register(saveStatusCargoAssigner, 'saveStatusCargoAssigner', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/assigners.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = '__NATIVE_FILE__';
var URL = exports.URL = '__NATIVE_URL__';
var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropContext = __webpack_require__(868);

Object.defineProperty(exports, 'DragDropContext', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContext).default;
  }
});

var _DragDropContextProvider = __webpack_require__(2029);

Object.defineProperty(exports, 'DragDropContextProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContextProvider).default;
  }
});

var _DragLayer = __webpack_require__(2030);

Object.defineProperty(exports, 'DragLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragLayer).default;
  }
});

var _DragSource = __webpack_require__(2031);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(2041);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(869);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = isDisposable;

function isDisposable(obj) {
  return Boolean(obj && typeof obj.dispose === 'function');
}

module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["f"] = selectPreference;
/* harmony export (immutable) */ __webpack_exports__["a"] = changePreference;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearSelectPreference;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPreferences;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPreference;
/* harmony export (immutable) */ __webpack_exports__["c"] = deletePreference;
/* harmony export (immutable) */ __webpack_exports__["g"] = updatePreference;
/* harmony export (immutable) */ __webpack_exports__["h"] = updatePreferenceMeta;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function selectPreference(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_112" /* SELECT_PREFERENCE */],
        data: data
    };
}

function changePreference(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["p" /* CHANGE_PREFERENCE */],
        data: data
    };
}

function clearSelectPreference() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["t" /* CLEAR_SELECT_PREFERENCE */]
    };
}

function getPreferences(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_39" /* GET_PREFERENCES */].REQUEST,
        data: data
    };
}

function getPreference(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_38" /* GET_PREFERENCE */].REQUEST,
        data: data
    };
}

function deletePreference(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["W" /* DELETE_PREFERENCE */].REQUEST,
        data: data
    };
}

function updatePreference(data, _id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_136" /* UPDATE_PREFERENCE */].REQUEST,
        data: data,
        _id: _id
    };
}

function updatePreferenceMeta(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_137" /* UPDATE_PREFERENCE_META */].REQUEST,
        data: data
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(selectPreference, 'selectPreference', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    reactHotLoader.register(changePreference, 'changePreference', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    reactHotLoader.register(clearSelectPreference, 'clearSelectPreference', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    reactHotLoader.register(getPreferences, 'getPreferences', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    reactHotLoader.register(getPreference, 'getPreference', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    reactHotLoader.register(deletePreference, 'deletePreference', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    reactHotLoader.register(updatePreference, 'updatePreference', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    reactHotLoader.register(updatePreferenceMeta, 'updatePreferenceMeta', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(880),
    castFunction = __webpack_require__(881);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(319),
    stackClear = __webpack_require__(2061),
    stackDelete = __webpack_require__(2062),
    stackGet = __webpack_require__(2063),
    stackHas = __webpack_require__(2064),
    stackSet = __webpack_require__(2065);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(873),
    stubArray = __webpack_require__(889);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(880),
    createBaseEach = __webpack_require__(2080);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 544 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(885);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    isSymbol = __webpack_require__(316);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(902);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(903);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });






/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__ = __webpack_require__(2174);




var babelPluginFlowReactPropTypes_proptype_VisibleCellRange = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_VisibleCellRange || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(5).any;




/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var babelPluginFlowReactPropTypes_proptype_RowRendererParams =  true ? null : {
  index: require('prop-types').number.isRequired,
  isScrolling: require('prop-types').bool.isRequired,
  isVisible: require('prop-types').bool.isRequired,
  key: require('prop-types').string.isRequired,
  parent: require('prop-types').object.isRequired,
  style: require('prop-types').object.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RowRendererParams', {
  value: babelPluginFlowReactPropTypes_proptype_RowRendererParams,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RowRenderer =  true ? null : require('prop-types').func;
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RowRenderer', {
  value: babelPluginFlowReactPropTypes_proptype_RowRenderer,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: require('prop-types').number.isRequired,
  overscanStopIndex: require('prop-types').number.isRequired,
  startIndex: require('prop-types').number.isRequired,
  stopIndex: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RenderedRows', {
  value: babelPluginFlowReactPropTypes_proptype_RenderedRows,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Scroll =  true ? null : {
  clientHeight: require('prop-types').number.isRequired,
  scrollHeight: require('prop-types').number.isRequired,
  scrollTop: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Scroll', {
  value: babelPluginFlowReactPropTypes_proptype_Scroll,
  configurable: true
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = LinksTags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function LinksTags(_ref) {
    var tags = _ref.tags,
        setTags = _ref.setTags,
        _ref$placeHolder = _ref.placeHolder,
        placeHolder = _ref$placeHolder === undefined ? 'Search by tag' : _ref$placeHolder;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        suggestions = _useState2[0],
        setSuggestions = _useState2[1];

    var handleDeleteTag = function handleDeleteTag(index) {
        var tagsCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(tags);
        tagsCopy.splice(index, 1);
        setTags(tagsCopy);
    };

    var handleAddition = function handleAddition(tag) {
        var newTags = __WEBPACK_IMPORTED_MODULE_0_immer__["b" /* produce */](tags, function (draftTags) {
            if (!draftTags.some(function (dt) {
                return dt.name === tag.name;
            })) {
                draftTags.push(tag);
            }
        });

        setTags(newTags);
    };

    var handleInputChange = function handleInputChange(searchText) {
        if (searchText.length < 2) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findAnalyticsTags(searchText).then(function (response) {
            setSuggestions(response.data.map(function (s) {
                return _extends({}, s, { name: s.value });
            }));
        });
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default.a, {
        allowNew: true,
        autofocus: false,
        tags: tags,
        suggestions: suggestions,
        handleDelete: handleDeleteTag,
        handleAddition: handleAddition,
        handleInputChange: handleInputChange,
        placeholder: placeHolder,
        suggestionComponent: SuggestionComponent
    });
}

function SuggestionComponent(_ref2) {
    var item = _ref2.item,
        query = _ref2.query;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        {
            id: item.id,
            className: item.name === query ? 'match' : 'no-match'
        },
        item.name
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LinksTags, 'LinksTags', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/LinksTags.jsx');
    reactHotLoader.register(SuggestionComponent, 'SuggestionComponent', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/LinksTags.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFileList = isFileList;

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACCEPT_SEP_REG = /\s*,\s*/;
// eslint-disable-next-line no-useless-escape
var ESCAPE_REG = /([.+?^=!:${}()|[\]\/\\])/g; // Removed star char
var ANY_REG = /\*/g;

var file = (0, _helpers.memoize)(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      msg = _ref.msg,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      minFiles = _ref.minFiles,
      maxFiles = _ref.maxFiles,
      ifCond = _ref.if,
      unless = _ref.unless,
      allowBlank = _ref.allowBlank;

  msg = msg || message;

  minFiles = (0, _helpers.selectNum)(minFiles);
  maxFiles = (0, _helpers.selectNum)(maxFiles);
  if (maxFiles < 0) {
    maxFiles = null;
  }
  if (minFiles === null) {
    minFiles = 1;
  }

  if (typeof accept === 'string' && accept.trim()) {
    accept = accept.trim().toLowerCase().split(ACCEPT_SEP_REG).map(function (type) {
      return type.charAt(0) === '.' || type.indexOf('*') < 0 ? type : new RegExp('^' + type.replace(ESCAPE_REG, '\\$1').replace(ANY_REG, '.*') + '$', 'i');
    });
  } else {
    accept = null;
  }

  var min = minSize != null ? sizeToInt(minSize) : null;
  var max = maxSize != null ? sizeToInt(maxSize) : null;

  return (0, _helpers.prepare)(ifCond, unless, false, function (value) {
    var isAFileList = isFileList(value);

    // special blank check
    if ((allowBlank != null ? allowBlank : _validators2.default.defaultOptions.allowBlank) && isAFileList && value.length === 0) {
      return;
    }
    if (!isAFileList) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'file'));
    }
    if (isNaN(value.length)) {
      value = [value];
    }
    if (value.length < minFiles) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'fileTooFew', { count: minFiles }));
    }
    if (maxFiles !== null && value.length > maxFiles) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'fileTooMany', { count: maxFiles }));
    }

    var acceptError = [];
    var tooSmallError = [];
    var tooBigError = [];

    var _loop = function _loop(i, len, _val, _ftype, _fext) {
      _val = value[i];
      if (accept) {
        _ftype = _val.type || '';
        _fext = fileExt(_val.name || '');
        if (!accept.some(function (type) {
          return typeof type === 'string' ? type === (type.charAt(0) === '.' ? _fext : _ftype) : type.test(_ftype);
        })) {
          acceptError.push(_val);
        }
      }
      if (min != null && _val.size < min) {
        tooSmallError.push(_val);
      }
      if (max != null && _val.size > max) {
        tooBigError.push(_val);
      }
      val = _val;
      ftype = _ftype;
      fext = _fext;
    };

    for (var i = 0, len = value.length, val, ftype, fext; i < len; ++i) {
      _loop(i, len, val, ftype, fext);
    }
    if (acceptError.length) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'fileAccept', { files: acceptError, count: acceptError.length }));
    }
    if (tooSmallError.length) {
      var pair = parse(minSize);
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'fileTooSmall', {
        files: tooSmallError,
        count: tooSmallError.length,
        size: _validators2.default.formatSize(pair[1], pair[2] || 'B')
      }));
    }
    if (tooBigError.length) {
      var _pair = parse(maxSize);
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'fileTooBig', {
        files: tooBigError,
        count: tooBigError.length,
        size: _validators2.default.formatSize(_pair[1], _pair[2] || 'B')
      }));
    }
  });
});

exports.default = file;
function isFileList(value) {
  if (typeof FileList !== 'undefined' && value instanceof FileList || typeof File !== 'undefined' && (value instanceof File || value[0] instanceof File)) {
    return true;
  }
  var str = _helpers.TO_STRING.call(value);
  return str === '[object FileList]' || str === '[object File]' || _helpers.TO_STRING.call(value[0]) === '[object File]';
}

// private
// eslint-disable-next-line no-useless-escape
var SIZE_REG = /^([\d\.]+)\s*([KMGTPE]?B)?$/;
var SIZE_UNITS = {
  B: 1,
  KB: 1024,
  MB: 1048576,
  GB: 1073741824,
  TB: 1099511627776,
  PB: 1125899906842624,
  EB: 1152921504606847000
};

function parse(size) {
  return SIZE_REG.exec(('' + size).trim());
}

function sizeToInt(size) {
  var pair = parse(size);
  return pair ? pair[1] * (SIZE_UNITS[pair[2]] || 1) : null;
}

function fileExt(filename) {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 1).toLowerCase();
}

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRecommendedTitle; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var getRecommendedTitle = function getRecommendedTitle(serviceProvider) {
    if (!serviceProvider.recommended) return '';

    var parts = ['Recommended'];
    if (serviceProvider.recommended.addedBy) {
        parts.push('by ' + serviceProvider.recommended.addedBy.email);
    }
    if (serviceProvider.recommended.endAt) {
        parts.push('until ' + new Date(serviceProvider.recommended.endAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }));
    }
    return parts.join(' ');
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getRecommendedTitle, 'getRecommendedTitle', '/opt/atlassian/pipelines/agent/build/client/app/helpers/ports.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(377),
    baseLodash = __webpack_require__(556);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// return marker coords from port/area
// only first coordinates taken from area polygons
function computeCoords(areasOrCords, type) {
    if (type === 'area') {
        return areasOrCords.map(function (item) {
            if (item.coordinates) {
                return {
                    lat: parseFloat(item.coordinates[1]),
                    lng: parseFloat(item.coordinates[0])
                };
            } else if (item.areaCoordinatesPolygons && item.areaCoordinatesPolygons.coordinates) {
                var polygon = item.areaCoordinatesPolygons.coordinates[0];
                if (!polygon) {
                    return;
                }
                var point = polygon[0][0];
                return {
                    lat: parseFloat(point[1]),
                    lng: parseFloat(point[0])
                };
            }
        }).filter(function (p) {
            return p;
        });
    }
    return [{
        lat: parseFloat(areasOrCords[1]),
        lng: parseFloat(areasOrCords[0])
    }];
}

var Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
        _classCallCheck(this, Map);

        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

        var coordinates = props.coordinates,
            type = props.type,
            areaPolygon = props.areaPolygon;

        _this.state = {
            coordinates: computeCoords(coordinates, type),
            areaPolygon: areaPolygon
        };
        return _this;
    }

    _createClass(Map, [{
        key: 'makeBounds',
        value: function makeBounds() {
            var coordinates = this.state.coordinates;


            if (coordinates.length === 0) {
                return;
            }

            var bounds = new google.maps.LatLngBounds();

            coordinates.forEach(function (item) {
                bounds.extend(item);
            });

            if (this.props.type !== 'ports') {
                this.refs.googleMap.fitBounds(bounds);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.makeBounds();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            google.maps.event.trigger(this.refs.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, 'resize');
            this.makeBounds();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(_ref) {
            var coordinates = _ref.coordinates,
                type = _ref.type,
                areaPolygon = _ref.areaPolygon;

            this.setState({
                coordinates: computeCoords(coordinates, type),
                areaPolygon: areaPolygon
            });

            if (areaPolygon) {
                var poly = new google.maps.Polygon({
                    paths: areaPolygon
                });

                var bounds = new google.maps.LatLngBounds();
                var paths = poly.getPaths();
                var path = void 0;
                for (var i = 0; i < paths.getLength(); i++) {
                    path = paths.getAt(i);
                    for (var ii = 0; ii < path.getLength(); ii++) {
                        bounds.extend(path.getAt(ii));
                    }
                }

                this.refs.googleMap.fitBounds(bounds);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                coordinates = _state.coordinates,
                areaPolygon = _state.areaPolygon;
            var editCoordsMarker = this.props.editCoordsMarker;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_google_maps__["GoogleMap"],
                    {
                        ref: 'googleMap',
                        defaultZoom: 10,
                        zoom: 10,
                        defaultCenter: {
                            lat: coordinates[0] ? coordinates[0].lat : 0,
                            lng: coordinates[0] ? coordinates[0].lng : 0
                        }
                    },
                    coordinates.map(function (item, key) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"], {
                            key: key,
                            position: {
                                lat: item.lat,
                                lng: item.lng
                            }
                        });
                    }),
                    areaPolygon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Polygon"], {
                        path: areaPolygon.map(function (point) {
                            if (point.lng || point.lat) {
                                if (point.lng && point.lat) {
                                    return point;
                                }
                                return {};
                            }
                            return {
                                lat: point[1],
                                lng: point[0]
                            };
                        }),
                        options: {
                            strokeColor: '#00f',
                            fillColor: '#00f'
                        }
                    }),
                    areaPolygon && (editCoordsMarker || editCoordsMarker === 0) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"], {
                        position: areaPolygon[editCoordsMarker]
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Map;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var MyMapComponent = Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withGoogleMap"])(Map);

var _default = MyMapComponent;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(computeCoords, 'computeCoords', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Map.jsx');
    reactHotLoader.register(Map, 'Map', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Map.jsx');
    reactHotLoader.register(MyMapComponent, 'MyMapComponent', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Map.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Map.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVisibility = function ActionVisibility(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ActionVisibility = (0, _pure2.default)(ActionVisibility);
ActionVisibility.displayName = 'ActionVisibility';
ActionVisibility.muiName = 'SvgIcon';

exports.default = ActionVisibility;

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Controller; });
/* unused harmony export FormProvider */
/* unused harmony export appendErrors */
/* unused harmony export get */
/* unused harmony export transformToNestObject */
/* unused harmony export useController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useFieldArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useForm; });
/* unused harmony export useFormContext */
/* unused harmony export useWatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var isHTMLElement = function isHTMLElement(value) {
    return value instanceof HTMLElement;
};

var EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
    INPUT: 'input'
};
var VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
var SELECT = 'select';
var UNDEFINED = 'undefined';
var INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};

function attachEventListeners(_ref, shouldAttachChangeEvent, handleChange) {
    var ref = _ref.ref;

    if (isHTMLElement(ref) && handleChange) {
        ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
        ref.addEventListener(EVENTS.BLUR, handleChange);
    }
}

var isNullOrUndefined = function isNullOrUndefined(value) {
    return value == null;
};

var isObjectType = function isObjectType(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
};
var isObject = function isObject(value) {
    return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);
};

var isKey = function isKey(value) {
    return (/^\w*$/.test(value)
    );
};

var compact = function compact(value) {
    return value.filter(Boolean);
};

var stringToPath = function stringToPath(input) {
    return compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));
};

function set(object, path, value) {
    var index = -1;
    var tempPath = isKey(path) ? [path] : stringToPath(path);
    var length = tempPath.length;
    var lastIndex = length - 1;
    while (++index < length) {
        var key = tempPath[index];
        var newValue = value;
        if (index !== lastIndex) {
            var objValue = object[key];
            newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

var transformToNestObject = function transformToNestObject(data) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var key in data) {
        !isKey(key) ? set(value, key, data[key]) : value[key] = data[key];
    }
    return value;
};

var isUndefined = function isUndefined(val) {
    return val === undefined;
};

var _get = function _get() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var path = arguments[1];
    var defaultValue = arguments[2];

    var result = compact(path.split(/[,[\].]+?/)).reduce(function (result, key) {
        return isNullOrUndefined(result) ? result : result[key];
    }, obj);
    return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};

var focusOnErrorField = function focusOnErrorField(fields, fieldErrors) {
    for (var key in fields) {
        if (_get(fieldErrors, key)) {
            var field = fields[key];
            if (field) {
                if (field.ref.focus && isUndefined(field.ref.focus())) {
                    break;
                } else if (field.options) {
                    field.options[0].ref.focus();
                    break;
                }
            }
        }
    }
};

var removeAllEventListeners = function removeAllEventListeners(ref, validateWithStateUpdate) {
    if (isHTMLElement(ref) && ref.removeEventListener) {
        ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
        ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
        ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
    }
};

var defaultReturn = {
    isValid: false,
    value: null
};
var getRadioValue = function getRadioValue(options) {
    return Array.isArray(options) ? options.reduce(function (previous, option) {
        return option && option.ref.checked ? {
            isValid: true,
            value: option.ref.value
        } : previous;
    }, defaultReturn) : defaultReturn;
};

var getMultipleSelectValue = function getMultipleSelectValue(options) {
    return [].concat(_toConsumableArray(options)).filter(function (_ref2) {
        var selected = _ref2.selected;
        return selected;
    }).map(function (_ref3) {
        var value = _ref3.value;
        return value;
    });
};

var isRadioInput = function isRadioInput(element) {
    return element.type === 'radio';
};

var isFileInput = function isFileInput(element) {
    return element.type === 'file';
};

var isCheckBoxInput = function isCheckBoxInput(element) {
    return element.type === 'checkbox';
};

var isMultipleSelect = function isMultipleSelect(element) {
    return element.type === SELECT + '-multiple';
};

var defaultResult = {
    value: false,
    isValid: false
};
var validResult = { value: true, isValid: true };
var getCheckboxValue = function getCheckboxValue(options) {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            var values = options.filter(function (option) {
                return option && option.ref.checked;
            }).map(function (_ref4) {
                var value = _ref4.ref.value;
                return value;
            });
            return { value: values, isValid: !!values.length };
        }
        var _options$0$ref = options[0].ref,
            checked = _options$0$ref.checked,
            value = _options$0$ref.value,
            attributes = _options$0$ref.attributes;

        return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || value === '' ? validResult : { value: value, isValid: true } : validResult : defaultResult;
    }
    return defaultResult;
};

function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
    var field = fieldsRef.current[name];
    if (field) {
        var _field$ref = field.ref,
            value = _field$ref.value,
            disabled = _field$ref.disabled,
            ref = field.ref,
            valueAsNumber = field.valueAsNumber,
            valueAsDate = field.valueAsDate,
            setValueAs = field.setValueAs;

        if (disabled && excludeDisabled) {
            return;
        }
        if (isFileInput(ref)) {
            return ref.files;
        }
        if (isRadioInput(ref)) {
            return getRadioValue(field.options).value;
        }
        if (isMultipleSelect(ref)) {
            return getMultipleSelectValue(ref.options);
        }
        if (isCheckBoxInput(ref)) {
            return getCheckboxValue(field.options).value;
        }
        return shouldKeepRawValue ? value : valueAsNumber ? value === '' ? NaN : +value : valueAsDate ? ref.valueAsDate : setValueAs ? setValueAs(value) : value;
    }
    if (shallowFieldsStateRef) {
        return _get(shallowFieldsStateRef.current, name);
    }
}

function isDetached(element) {
    if (!element) {
        return true;
    }
    if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
        return false;
    }
    return isDetached(element.parentNode);
}

var isEmptyObject = function isEmptyObject(value) {
    return isObject(value) && !Object.keys(value).length;
};

var isBoolean = function isBoolean(value) {
    return typeof value === 'boolean';
};

function baseGet(object, updatePath) {
    var length = updatePath.slice(0, -1).length;
    var index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function unset(object, path) {
    var updatePath = isKey(path) ? [path] : stringToPath(path);
    var childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    var key = updatePath[updatePath.length - 1];
    var previousObjRef = void 0;
    if (childObject) {
        delete childObject[key];
    }
    for (var k = 0; k < updatePath.slice(0, -1).length; k++) {
        var index = -1;
        var objectRef = void 0;
        var currentPaths = updatePath.slice(0, -(k + 1));
        var currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            var item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index && (isObject(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter(function (data) {
                return isObject(data) && !isEmptyObject(data) || isBoolean(data);
            }).length)) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

var isSameRef = function isSameRef(fieldValue, ref) {
    return fieldValue && fieldValue.ref === ref;
};
function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
    var ref = field.ref,
        name = field.ref.name;

    var fieldRef = fieldsRef.current[name];
    if (!shouldUnregister) {
        var value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
        !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
    }
    if (!ref.type || !fieldRef) {
        delete fieldsRef.current[name];
        return;
    }
    if (isRadioInput(ref) || isCheckBoxInput(ref)) {
        if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
            compact(fieldRef.options).forEach(function () {
                var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var index = arguments[1];

                if (isDetached(option.ref) && isSameRef(option, option.ref) || forceDelete) {
                    removeAllEventListeners(option.ref, handleChange);
                    unset(fieldRef.options, '[' + index + ']');
                }
            });
            if (fieldRef.options && !compact(fieldRef.options).length) {
                delete fieldsRef.current[name];
            }
        } else {
            delete fieldsRef.current[name];
        }
    } else if (isDetached(ref) && isSameRef(fieldRef, ref) || forceDelete) {
        removeAllEventListeners(ref, handleChange);
        delete fieldsRef.current[name];
    }
}

var isPrimitive = function isPrimitive(value) {
    return isNullOrUndefined(value) || !isObjectType(value);
};

function deepMerge(target, source) {
    if (isPrimitive(target) || isPrimitive(source)) {
        return source;
    }
    for (var key in source) {
        var targetValue = target[key];
        var sourceValue = source[key];
        try {
            target[key] = isObject(targetValue) && isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
        } catch (_a) {}
    }
    return target;
}

function deepEqual(object1, object2, isErrorObject) {
    if (isPrimitive(object1) || isPrimitive(object2) || object1 instanceof Date || object2 instanceof Date) {
        return object1 === object2;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(object1)) {
        var keys1 = Object.keys(object1);
        var keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                var val1 = object1[key];
                if (!(isErrorObject && key === 'ref')) {
                    var val2 = object2[key];
                    if ((isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
                        return false;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return true;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    var index = -1;
    while (++index < values.length) {
        for (var key in values[index]) {
            if (Array.isArray(values[index][key])) {
                !dirtyFields[index] && (dirtyFields[index] = {});
                dirtyFields[index][key] = [];
                setDirtyFields(values[index][key], _get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
            } else {
                deepEqual(_get(defaultValues[index] || {}, key), values[index][key]) ? set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), _defineProperty({}, key, true));
            }
        }
        parentNode && !dirtyFields.length && delete parentNode[parentName];
    }
    return dirtyFields;
}
var setFieldArrayDirtyFields = function setFieldArrayDirtyFields(values, defaultValues, dirtyFields) {
    return deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));
};

var isString = function isString(value) {
    return typeof value === 'string';
};

var getFieldsValues = function getFieldsValues(fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) {
    var output = {};

    var _loop = function _loop(name) {
        if (isUndefined(search) || (isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find(function (data) {
            return name.startsWith(data);
        }))) {
            output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
        }
    };

    for (var name in fieldsRef.current) {
        _loop(name);
    }
    return shouldUnregister ? transformToNestObject(output) : deepMerge(shallowFieldsState, transformToNestObject(output));
};

var isErrorStateChanged = function isErrorStateChanged(_ref5) {
    var errors = _ref5.errors,
        name = _ref5.name,
        error = _ref5.error,
        validFields = _ref5.validFields,
        fieldsWithValidation = _ref5.fieldsWithValidation;

    var isValid = isUndefined(error);
    var previousError = _get(errors, name);
    return isValid && !!previousError || !isValid && !deepEqual(previousError, error, true) || isValid && _get(fieldsWithValidation, name) && !_get(validFields, name);
};

var isRegex = function isRegex(value) {
    return value instanceof RegExp;
};

var getValueAndMessage = function getValueAndMessage(validationData) {
    return isObject(validationData) && !isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
};

var isFunction = function isFunction(value) {
    return typeof value === 'function';
};

var isMessage = function isMessage(value) {
    return isString(value) || Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(value);
};

function getValidateError(result, ref) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

    if (isMessage(result) || isBoolean(result) && !result) {
        return {
            type: type,
            message: isMessage(result) ? result : '',
            ref: ref
        };
    }
}

var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
    return validateAllFieldCriteria ? Object.assign(Object.assign({}, errors[name]), { types: Object.assign(Object.assign({}, errors[name] && errors[name].types ? errors[name].types : {}), _defineProperty({}, type, message || true)) }) : {};
};

var validateField = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fieldsRef, validateAllFieldCriteria, _ref7, shallowFieldsStateRef) {
        var ref = _ref7.ref,
            value = _ref7.ref.value,
            options = _ref7.options,
            required = _ref7.required,
            maxLength = _ref7.maxLength,
            minLength = _ref7.minLength,
            min = _ref7.min,
            max = _ref7.max,
            pattern = _ref7.pattern,
            validate = _ref7.validate;

        var name, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref8, _value, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, maxLengthOutput, minLengthOutput, _exceedMax, _exceedMin, _getValueAndMessage, patternValue, _message, fieldValue, validateRef, result, validateError, validationResult, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step2$value, key, validateFunction, validateResult, _validateError;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        name = ref.name;
                        error = {};
                        isRadio = isRadioInput(ref);
                        isCheckBox = isCheckBoxInput(ref);
                        isRadioOrCheckbox = isRadio || isCheckBox;
                        isEmpty = value === '';
                        appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

                        getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
                            var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
                            var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;

                            var message = exceedMax ? maxLengthMessage : minLengthMessage;
                            error[name] = Object.assign({ type: exceedMax ? maxType : minType, message: message,
                                ref: ref }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
                        };

                        if (!(required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid))) {
                            _context.next = 14;
                            break;
                        }

                        _ref8 = isMessage(required) ? { value: !!required, message: required } : getValueAndMessage(required), _value = _ref8.value, message = _ref8.message;

                        if (!_value) {
                            _context.next = 14;
                            break;
                        }

                        error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message: message, ref: isRadioOrCheckbox ? ((fieldsRef.current[name].options || [])[0] || {}).ref : ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

                        if (validateAllFieldCriteria) {
                            _context.next = 14;
                            break;
                        }

                        return _context.abrupt('return', error);

                    case 14:
                        if (!((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && value !== '')) {
                            _context.next = 24;
                            break;
                        }

                        exceedMax = void 0;
                        exceedMin = void 0;
                        maxOutput = getValueAndMessage(max);
                        minOutput = getValueAndMessage(min);

                        if (!isNaN(value)) {
                            valueNumber = ref.valueAsNumber || parseFloat(value);

                            if (!isNullOrUndefined(maxOutput.value)) {
                                exceedMax = valueNumber > maxOutput.value;
                            }
                            if (!isNullOrUndefined(minOutput.value)) {
                                exceedMin = valueNumber < minOutput.value;
                            }
                        } else {
                            valueDate = ref.valueAsDate || new Date(value);

                            if (isString(maxOutput.value)) {
                                exceedMax = valueDate > new Date(maxOutput.value);
                            }
                            if (isString(minOutput.value)) {
                                exceedMin = valueDate < new Date(minOutput.value);
                            }
                        }

                        if (!(exceedMax || exceedMin)) {
                            _context.next = 24;
                            break;
                        }

                        getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

                        if (validateAllFieldCriteria) {
                            _context.next = 24;
                            break;
                        }

                        return _context.abrupt('return', error);

                    case 24:
                        if (!(isString(value) && !isEmpty && (maxLength || minLength))) {
                            _context.next = 33;
                            break;
                        }

                        maxLengthOutput = getValueAndMessage(maxLength);
                        minLengthOutput = getValueAndMessage(minLength);
                        _exceedMax = !isNullOrUndefined(maxLengthOutput.value) && value.length > maxLengthOutput.value;
                        _exceedMin = !isNullOrUndefined(minLengthOutput.value) && value.length < minLengthOutput.value;

                        if (!(_exceedMax || _exceedMin)) {
                            _context.next = 33;
                            break;
                        }

                        getMinMaxMessage(_exceedMax, maxLengthOutput.message, minLengthOutput.message);

                        if (validateAllFieldCriteria) {
                            _context.next = 33;
                            break;
                        }

                        return _context.abrupt('return', error);

                    case 33:
                        if (!(isString(value) && pattern && !isEmpty)) {
                            _context.next = 39;
                            break;
                        }

                        _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, _message = _getValueAndMessage.message;

                        if (!(isRegex(patternValue) && !patternValue.test(value))) {
                            _context.next = 39;
                            break;
                        }

                        error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.pattern, message: _message,
                            ref: ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, _message));

                        if (validateAllFieldCriteria) {
                            _context.next = 39;
                            break;
                        }

                        return _context.abrupt('return', error);

                    case 39:
                        if (!validate) {
                            _context.next = 90;
                            break;
                        }

                        fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
                        validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;

                        if (!isFunction(validate)) {
                            _context.next = 53;
                            break;
                        }

                        _context.next = 45;
                        return validate(fieldValue);

                    case 45:
                        result = _context.sent;
                        validateError = getValidateError(result, validateRef);

                        if (!validateError) {
                            _context.next = 51;
                            break;
                        }

                        error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

                        if (validateAllFieldCriteria) {
                            _context.next = 51;
                            break;
                        }

                        return _context.abrupt('return', error);

                    case 51:
                        _context.next = 90;
                        break;

                    case 53:
                        if (!isObject(validate)) {
                            _context.next = 90;
                            break;
                        }

                        validationResult = {};
                        _iteratorNormalCompletion2 = true;
                        _didIteratorError2 = false;
                        _iteratorError2 = undefined;
                        _context.prev = 58;
                        _iterator2 = Object.entries(validate)[Symbol.iterator]();

                    case 60:
                        if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                            _context.next = 72;
                            break;
                        }

                        _step2$value = _slicedToArray(_step2.value, 2), key = _step2$value[0], validateFunction = _step2$value[1];

                        if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
                            _context.next = 64;
                            break;
                        }

                        return _context.abrupt('break', 72);

                    case 64:
                        _context.next = 66;
                        return validateFunction(fieldValue);

                    case 66:
                        validateResult = _context.sent;
                        _validateError = getValidateError(validateResult, validateRef, key);

                        if (_validateError) {
                            validationResult = Object.assign(Object.assign({}, _validateError), appendErrorsCurry(key, _validateError.message));
                            if (validateAllFieldCriteria) {
                                error[name] = validationResult;
                            }
                        }

                    case 69:
                        _iteratorNormalCompletion2 = true;
                        _context.next = 60;
                        break;

                    case 72:
                        _context.next = 78;
                        break;

                    case 74:
                        _context.prev = 74;
                        _context.t0 = _context['catch'](58);
                        _didIteratorError2 = true;
                        _iteratorError2 = _context.t0;

                    case 78:
                        _context.prev = 78;
                        _context.prev = 79;

                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }

                    case 81:
                        _context.prev = 81;

                        if (!_didIteratorError2) {
                            _context.next = 84;
                            break;
                        }

                        throw _iteratorError2;

                    case 84:
                        return _context.finish(81);

                    case 85:
                        return _context.finish(78);

                    case 86:
                        if (isEmptyObject(validationResult)) {
                            _context.next = 90;
                            break;
                        }

                        error[name] = Object.assign({ ref: validateRef }, validationResult);

                        if (validateAllFieldCriteria) {
                            _context.next = 90;
                            break;
                        }

                        return _context.abrupt('return', error);

                    case 90:
                        return _context.abrupt('return', error);

                    case 91:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[58, 74, 78, 86], [79,, 81, 85]]);
    }));

    return function validateField(_x5, _x6, _x7, _x8) {
        return _ref6.apply(this, arguments);
    };
}();

var getPath = function getPath(rootPath, values) {
    var paths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    for (var property in values) {
        var rootName = rootPath + (isObject(values) ? '.' + property : '[' + property + ']');
        isPrimitive(values[property]) ? paths.push(rootName) : getPath(rootName, values[property], paths);
    }
    return paths;
};

var assignWatchFields = function assignWatchFields(fieldValues, fieldName, watchFields, inputValue, isSingleField) {
    var value = undefined;
    watchFields.add(fieldName);
    if (!isEmptyObject(fieldValues)) {
        value = _get(fieldValues, fieldName);
        if (isObject(value) || Array.isArray(value)) {
            getPath(fieldName, value).forEach(function (name) {
                return watchFields.add(name);
            });
        }
    }
    return isUndefined(value) ? isSingleField ? inputValue : _get(inputValue, fieldName) : value;
};

var skipValidation = function skipValidation(_ref9) {
    var isOnBlur = _ref9.isOnBlur,
        isOnChange = _ref9.isOnChange,
        isOnTouch = _ref9.isOnTouch,
        isTouched = _ref9.isTouched,
        isReValidateOnBlur = _ref9.isReValidateOnBlur,
        isReValidateOnChange = _ref9.isReValidateOnChange,
        isBlurEvent = _ref9.isBlurEvent,
        isSubmitted = _ref9.isSubmitted,
        isOnAll = _ref9.isOnAll;

    if (isOnAll) {
        return false;
    } else if (!isSubmitted && isOnTouch) {
        return !(isTouched || isBlurEvent);
    } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
        return !isBlurEvent;
    } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var getFieldArrayParentName = function getFieldArrayParentName(name) {
    return name.substring(0, name.indexOf('['));
};

var isMatchFieldArrayName = function isMatchFieldArrayName(name, searchName) {
    return RegExp(('^' + searchName + '([|.)\\d+').replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
};
var isNameInFieldArray = function isNameInFieldArray(names, name) {
    return [].concat(_toConsumableArray(names)).some(function (current) {
        return isMatchFieldArrayName(name, current);
    });
};

var isSelectInput = function isSelectInput(element) {
    return element.type === SELECT + '-one';
};

function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
    var observer = new MutationObserver(function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = Object.values(fieldsRef.current)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var field = _step3.value;

                if (field && field.options) {
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = field.options[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var option = _step4.value;

                            if (option && option.ref && isDetached(option.ref)) {
                                removeFieldEventListenerAndRef(field);
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                } else if (field && isDetached(field.ref)) {
                    removeFieldEventListenerAndRef(field);
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    });
    observer.observe(window.document, {
        childList: true,
        subtree: true
    });
    return observer;
}

var isWeb = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== UNDEFINED && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== UNDEFINED;

function cloneObject(data) {
    var _a;
    var copy = void 0;
    if (isPrimitive(data) || isWeb && (data instanceof File || isHTMLElement(data))) {
        return data;
    }
    if (!['Set', 'Map', 'Object', 'Date', 'Array'].includes((_a = data.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
        return data;
    }
    if (data instanceof Date) {
        copy = new Date(data.getTime());
        return copy;
    }
    if (data instanceof Set) {
        copy = new Set();
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = data[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var item = _step5.value;

                copy.add(item);
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        return copy;
    }
    if (data instanceof Map) {
        copy = new Map();
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = data.keys()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var key = _step6.value;

                copy.set(key, cloneObject(data.get(key)));
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        return copy;
    }
    copy = Array.isArray(data) ? [] : {};
    for (var _key in data) {
        copy[_key] = cloneObject(data[_key]);
    }
    return copy;
}

var modeChecker = function modeChecker(mode) {
    return {
        isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
        isOnBlur: mode === VALIDATION_MODE.onBlur,
        isOnChange: mode === VALIDATION_MODE.onChange,
        isOnAll: mode === VALIDATION_MODE.all,
        isOnTouch: mode === VALIDATION_MODE.onTouched
    };
};

var isRadioOrCheckboxFunction = function isRadioOrCheckboxFunction(ref) {
    return isRadioInput(ref) || isCheckBoxInput(ref);
};

var isWindowUndefined = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === UNDEFINED;
var isProxyEnabled = isWeb ? 'Proxy' in window : (typeof Proxy === 'undefined' ? 'undefined' : _typeof(Proxy)) !== UNDEFINED;
function useForm() {
    var _this2 = this;

    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref10$mode = _ref10.mode,
        mode = _ref10$mode === undefined ? VALIDATION_MODE.onSubmit : _ref10$mode,
        _ref10$reValidateMode = _ref10.reValidateMode,
        reValidateMode = _ref10$reValidateMode === undefined ? VALIDATION_MODE.onChange : _ref10$reValidateMode,
        resolver = _ref10.resolver,
        context = _ref10.context,
        _ref10$defaultValues = _ref10.defaultValues,
        defaultValues = _ref10$defaultValues === undefined ? {} : _ref10$defaultValues,
        _ref10$shouldFocusErr = _ref10.shouldFocusError,
        shouldFocusError = _ref10$shouldFocusErr === undefined ? true : _ref10$shouldFocusErr,
        _ref10$shouldUnregist = _ref10.shouldUnregister,
        shouldUnregister = _ref10$shouldUnregist === undefined ? true : _ref10$shouldUnregist,
        criteriaMode = _ref10.criteriaMode;

    var fieldsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var fieldArrayDefaultValuesRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var fieldArrayValuesRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var watchFieldsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Set());
    var useWatchFieldsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var useWatchRenderFunctionsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var fieldsWithValidationRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var validFieldsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var defaultValuesRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(defaultValues);
    var isUnMount = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var isWatchAllRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
    var handleChangeRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var shallowFieldsStateRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var resetFieldArrayFunctionRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});
    var contextRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(context);
    var resolverRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(resolver);
    var fieldArrayNamesRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Set());
    var modeRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(modeChecker(mode));
    var _modeRef$current = modeRef.current,
        isOnSubmit = _modeRef$current.isOnSubmit,
        isOnTouch = _modeRef$current.isOnTouch;

    var isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touched: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: !isOnSubmit,
        errors: {}
    }),
        _useState2 = _slicedToArray(_useState, 2),
        formState = _useState2[0],
        setFormState = _useState2[1];

    var readFormStateRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({
        isDirty: !isProxyEnabled,
        dirtyFields: !isProxyEnabled,
        touched: !isProxyEnabled || isOnTouch,
        isValidating: !isProxyEnabled,
        isSubmitting: !isProxyEnabled,
        isValid: !isProxyEnabled
    });
    var formStateRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(formState);
    var observerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var _useRef$current = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(modeChecker(reValidateMode)).current,
        isReValidateOnBlur = _useRef$current.isOnBlur,
        isReValidateOnChange = _useRef$current.isOnChange;

    contextRef.current = context;
    resolverRef.current = resolver;
    formStateRef.current = formState;
    shallowFieldsStateRef.current = shouldUnregister ? {} : isEmptyObject(shallowFieldsStateRef.current) ? cloneObject(defaultValues) : shallowFieldsStateRef.current;
    var updateFormState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (!isUnMount.current) {
            formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
            setFormState(formStateRef.current);
        }
    }, []);
    var updateIsValidating = function updateIsValidating() {
        return readFormStateRef.current.isValidating && updateFormState({
            isValidating: true
        });
    };
    var shouldRenderBaseOnError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, error) {
        var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var isValid = arguments[4];

        var shouldReRender = shouldRender || isErrorStateChanged({
            errors: formStateRef.current.errors,
            error: error,
            name: name,
            validFields: validFieldsRef.current,
            fieldsWithValidation: fieldsWithValidationRef.current
        });
        var previousError = _get(formStateRef.current.errors, name);
        if (error) {
            unset(validFieldsRef.current, name);
            shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error, true);
            set(formStateRef.current.errors, name, error);
        } else {
            if (_get(fieldsWithValidationRef.current, name) || resolverRef.current) {
                set(validFieldsRef.current, name, true);
                shouldReRender = shouldReRender || previousError;
            }
            unset(formStateRef.current.errors, name);
        }
        if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state) || readFormStateRef.current.isValidating) {
            updateFormState(Object.assign(Object.assign(Object.assign({}, state), resolverRef.current ? { isValid: !!isValid } : {}), { isValidating: false }));
        }
    }, []);
    var setFieldValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, rawValue) {
        var _fieldsRef$current$na = fieldsRef.current[name],
            ref = _fieldsRef$current$na.ref,
            options = _fieldsRef$current$na.options;

        var value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;
        if (isRadioInput(ref)) {
            (options || []).forEach(function (_ref11) {
                var radioRef = _ref11.ref;
                return radioRef.checked = radioRef.value === value;
            });
        } else if (isFileInput(ref) && !isString(value)) {
            ref.files = value;
        } else if (isMultipleSelect(ref)) {
            [].concat(_toConsumableArray(ref.options)).forEach(function (selectRef) {
                return selectRef.selected = value.includes(selectRef.value);
            });
        } else if (isCheckBoxInput(ref) && options) {
            options.length > 1 ? options.forEach(function (_ref12) {
                var checkboxRef = _ref12.ref;
                return checkboxRef.checked = Array.isArray(value) ? !!value.find(function (data) {
                    return data === checkboxRef.value;
                }) : value === checkboxRef.value;
            }) : options[0].ref.checked = !!value;
        } else {
            ref.value = value;
        }
    }, []);
    var isFormDirty = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, data) {
        if (readFormStateRef.current.isDirty) {
            var formValues = getValues();
            name && data && set(formValues, name, data);
            return !deepEqual(formValues, defaultValuesRef.current);
        }
        return false;
    }, []);
    var updateAndGetDirtyState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
        var shouldRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
            var isFieldDirty = !deepEqual(_get(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            var isDirtyFieldExist = _get(formStateRef.current.dirtyFields, name);
            var previousIsDirty = formStateRef.current.isDirty;
            isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
            var state = {
                isDirty: isFormDirty(),
                dirtyFields: formStateRef.current.dirtyFields
            };
            var isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== _get(formStateRef.current.dirtyFields, name);
            isChanged && shouldRender && updateFormState(state);
            return isChanged ? state : {};
        }
        return {};
    }, []);
    var executeValidation = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(name, skipReRender) {
            var error;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (true) {
                                _context2.next = 4;
                                break;
                            }

                            if (fieldsRef.current[name]) {
                                _context2.next = 4;
                                break;
                            }

                            console.warn('📋 Field is missing with `name` attribute: ', name);
                            return _context2.abrupt('return', false);

                        case 4:
                            _context2.next = 6;
                            return validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef);

                        case 6:
                            _context2.t0 = name;
                            error = _context2.sent[_context2.t0];

                            shouldRenderBaseOnError(name, error, skipReRender);
                            return _context2.abrupt('return', isUndefined(error));

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x17, _x18) {
            return _ref13.apply(this, arguments);
        };
    }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    var executeSchemaOrResolverValidation = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(names) {
            var _ref15, errors, previousFormIsValid, isInputsValid, error;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

                        case 2:
                            _ref15 = _context3.sent;
                            errors = _ref15.errors;
                            previousFormIsValid = formStateRef.current.isValid;

                            if (!Array.isArray(names)) {
                                _context3.next = 11;
                                break;
                            }

                            isInputsValid = names.map(function (name) {
                                var error = _get(errors, name);
                                error ? set(formStateRef.current.errors, name, error) : unset(formStateRef.current.errors, name);
                                return !error;
                            }).every(Boolean);

                            updateFormState({
                                isValid: isEmptyObject(errors),
                                isValidating: false
                            });
                            return _context3.abrupt('return', isInputsValid);

                        case 11:
                            error = _get(errors, names);

                            shouldRenderBaseOnError(names, error, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
                            return _context3.abrupt('return', !error);

                        case 14:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2);
        }));

        return function (_x19) {
            return _ref14.apply(this, arguments);
        };
    }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    var trigger = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(name) {
            var fields, result;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            fields = name || Object.keys(fieldsRef.current);

                            updateIsValidating();

                            if (!resolverRef.current) {
                                _context5.next = 4;
                                break;
                            }

                            return _context5.abrupt('return', executeSchemaOrResolverValidation(fields));

                        case 4:
                            if (!Array.isArray(fields)) {
                                _context5.next = 11;
                                break;
                            }

                            !name && (formStateRef.current.errors = {});
                            _context5.next = 8;
                            return Promise.all(fields.map(function () {
                                var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    _context4.next = 2;
                                                    return executeValidation(data, null);

                                                case 2:
                                                    return _context4.abrupt('return', _context4.sent);

                                                case 3:
                                                case 'end':
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this2);
                                }));

                                return function (_x21) {
                                    return _ref17.apply(this, arguments);
                                };
                            }()));

                        case 8:
                            result = _context5.sent;

                            updateFormState({
                                isValidating: false
                            });
                            return _context5.abrupt('return', result.every(Boolean));

                        case 11:
                            _context5.next = 13;
                            return executeValidation(fields);

                        case 13:
                            return _context5.abrupt('return', _context5.sent);

                        case 14:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this2);
        }));

        return function (_x20) {
            return _ref16.apply(this, arguments);
        };
    }(), [executeSchemaOrResolverValidation, executeValidation]);
    var setInternalValues = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, value, _ref18) {
        var shouldDirty = _ref18.shouldDirty,
            shouldValidate = _ref18.shouldValidate;

        var data = {};
        set(data, name, value);
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
            for (var _iterator7 = getPath(name, value)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var fieldName = _step7.value;

                if (fieldsRef.current[fieldName]) {
                    setFieldValue(fieldName, _get(data, fieldName));
                    shouldDirty && updateAndGetDirtyState(fieldName);
                    shouldValidate && trigger(fieldName);
                }
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                }
            } finally {
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }
    }, [trigger, setFieldValue, updateAndGetDirtyState]);
    var setInternalValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, value, config) {
        !shouldUnregister && !isPrimitive(value) && set(shallowFieldsStateRef.current, name, Array.isArray(value) ? [].concat(_toConsumableArray(value)) : Object.assign({}, value));
        if (fieldsRef.current[name]) {
            setFieldValue(name, value);
            config.shouldDirty && updateAndGetDirtyState(name);
            config.shouldValidate && trigger(name);
        } else if (!isPrimitive(value)) {
            setInternalValues(name, value, config);
            if (fieldArrayNamesRef.current.has(name)) {
                var parentName = getFieldArrayParentName(name) || name;
                set(fieldArrayDefaultValuesRef.current, name, value);
                resetFieldArrayFunctionRef.current[parentName](_defineProperty({}, parentName, _get(fieldArrayDefaultValuesRef.current, parentName)));
                if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
                    set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
                    updateFormState({
                        isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), _defineProperty({}, name, value)), defaultValuesRef.current)
                    });
                }
            }
        }
        !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
    }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);
    var isFieldWatched = function isFieldWatched(name) {
        return isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
    };
    var renderWatchedInputs = function renderWatchedInputs(name) {
        var found = true;
        if (!isEmptyObject(useWatchFieldsRef.current)) {
            for (var key in useWatchFieldsRef.current) {
                if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
                    useWatchRenderFunctionsRef.current[key]();
                    found = false;
                }
            }
        }
        return found;
    };
    function setValue(name, value, config) {
        setInternalValue(name, value, config || {});
        isFieldWatched(name) && updateFormState();
        renderWatchedInputs(name);
    }
    handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref20) {
            var type = _ref20.type,
                target = _ref20.target;

            var name, field, error, isValid, isBlurEvent, shouldSkipValidation, state, shouldRender, _ref21, errors, previousFormIsValid, parentNodeName, currentError;

            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            name = target.name;
                            field = fieldsRef.current[name];
                            error = void 0;
                            isValid = void 0;

                            if (!field) {
                                _context6.next = 33;
                                break;
                            }

                            isBlurEvent = type === EVENTS.BLUR;
                            shouldSkipValidation = skipValidation(Object.assign({ isBlurEvent: isBlurEvent,
                                isReValidateOnChange: isReValidateOnChange,
                                isReValidateOnBlur: isReValidateOnBlur, isTouched: !!_get(formStateRef.current.touched, name), isSubmitted: formStateRef.current.isSubmitted }, modeRef.current));
                            state = updateAndGetDirtyState(name, false);
                            shouldRender = !isEmptyObject(state) || !isBlurEvent && isFieldWatched(name);

                            if (isBlurEvent && !_get(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
                                set(formStateRef.current.touched, name, true);
                                state = Object.assign(Object.assign({}, state), { touched: formStateRef.current.touched });
                            }
                            if (!shouldUnregister && isCheckBoxInput(target)) {
                                set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
                            }

                            if (!shouldSkipValidation) {
                                _context6.next = 14;
                                break;
                            }

                            !isBlurEvent && renderWatchedInputs(name);
                            return _context6.abrupt('return', (!isEmptyObject(state) || shouldRender && isEmptyObject(state)) && updateFormState(state));

                        case 14:
                            updateIsValidating();

                            if (!resolverRef.current) {
                                _context6.next = 27;
                                break;
                            }

                            _context6.next = 18;
                            return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

                        case 18:
                            _ref21 = _context6.sent;
                            errors = _ref21.errors;
                            previousFormIsValid = formStateRef.current.isValid;

                            error = _get(errors, name);
                            if (isCheckBoxInput(target) && !error && resolverRef.current) {
                                parentNodeName = getFieldArrayParentName(name);
                                currentError = _get(errors, parentNodeName, {});

                                currentError.type && currentError.message && (error = currentError);
                                if (parentNodeName && (currentError || _get(formStateRef.current.errors, parentNodeName))) {
                                    name = parentNodeName;
                                }
                            }
                            isValid = isEmptyObject(errors);
                            previousFormIsValid !== isValid && (shouldRender = true);
                            _context6.next = 31;
                            break;

                        case 27:
                            _context6.next = 29;
                            return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

                        case 29:
                            _context6.t0 = name;
                            error = _context6.sent[_context6.t0];

                        case 31:
                            !isBlurEvent && renderWatchedInputs(name);
                            shouldRenderBaseOnError(name, error, shouldRender, state, isValid);

                        case 33:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this2);
        }));

        return function (_x22) {
            return _ref19.apply(this, arguments);
        };
    }();
    function setFieldArrayDefaultValues(data) {
        if (!shouldUnregister) {
            var copy = cloneObject(data);
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = fieldArrayNamesRef.current[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var value = _step8.value;

                    if (isKey(value) && !copy[value]) {
                        copy = Object.assign(Object.assign({}, copy), _defineProperty({}, value, []));
                    }
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            return copy;
        }
        return data;
    }
    function getValues(payload) {
        if (isString(payload)) {
            return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
        }
        if (Array.isArray(payload)) {
            var data = {};
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = payload[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var name = _step9.value;

                    set(data, name, getFieldValue(fieldsRef, name, shallowFieldsStateRef));
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            return data;
        }
        return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
    }
    var validateResolver = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
            var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var newDefaultValues, _ref23, errors, isValid;

            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            newDefaultValues = isEmptyObject(fieldsRef.current) ? defaultValuesRef.current : {};
                            _context7.next = 3;
                            return resolverRef.current(Object.assign(Object.assign(Object.assign({}, newDefaultValues), getValues()), values), contextRef.current, isValidateAllFieldCriteria);

                        case 3:
                            _context7.t0 = _context7.sent;

                            if (_context7.t0) {
                                _context7.next = 6;
                                break;
                            }

                            _context7.t0 = {};

                        case 6:
                            _ref23 = _context7.t0;
                            errors = _ref23.errors;
                            isValid = isEmptyObject(errors);

                            formStateRef.current.isValid !== isValid && updateFormState({
                                isValid: isValid
                            });

                        case 10:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this2);
        }));

        return function () {
            return _ref22.apply(this, arguments);
        };
    }(), [isValidateAllFieldCriteria]);
    var removeFieldEventListener = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, forceDelete) {
        findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);
        if (shouldUnregister) {
            unset(validFieldsRef.current, field.ref.name);
            unset(fieldsWithValidationRef.current, field.ref.name);
        }
    }, [shouldUnregister]);
    var updateWatchedValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
        if (isWatchAllRef.current) {
            updateFormState();
        } else {
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = watchFieldsRef.current[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var watchField = _step10.value;

                    if (watchField.startsWith(name)) {
                        updateFormState();
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }

            renderWatchedInputs(name);
        }
    }, []);
    var removeFieldEventListenerAndRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, forceDelete) {
        if (field) {
            removeFieldEventListener(field, forceDelete);
            if (shouldUnregister && !compact(field.options || []).length) {
                unset(formStateRef.current.errors, field.ref.name);
                set(formStateRef.current.dirtyFields, field.ref.name, true);
                updateFormState({
                    isDirty: isFormDirty()
                });
                readFormStateRef.current.isValid && resolverRef.current && validateResolver();
                updateWatchedValue(field.ref.name);
            }
        }
    }, [validateResolver, removeFieldEventListener]);
    function clearErrors(name) {
        name && (Array.isArray(name) ? name : [name]).forEach(function (inputName) {
            return fieldsRef.current[inputName] && isKey(inputName) ? delete formStateRef.current.errors[inputName] : unset(formStateRef.current.errors, inputName);
        });
        updateFormState({
            errors: name ? formStateRef.current.errors : {}
        });
    }
    function setError(name, error) {
        var ref = (fieldsRef.current[name] || {}).ref;
        set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), { ref: ref }));
        updateFormState({
            isValid: false
        });
        error.shouldFocus && ref && ref.focus && ref.focus();
    }
    var watchInternal = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (fieldNames, defaultValue, watchId) {
        var watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
        var fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);
        if (isString(fieldNames)) {
            var parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;
            if (fieldArrayNamesRef.current.has(parentNodeName)) {
                fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
            }
            return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(_get(defaultValuesRef.current, fieldNames)) ? defaultValue : _get(defaultValuesRef.current, fieldNames), true);
        }
        var combinedDefaultValues = isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;
        if (Array.isArray(fieldNames)) {
            return fieldNames.reduce(function (previous, name) {
                return Object.assign(Object.assign({}, previous), _defineProperty({}, name, assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)));
            }, {});
        }
        isWatchAllRef.current = isUndefined(watchId);
        return transformToNestObject(!isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
    }, []);
    function watch(fieldNames, defaultValue) {
        return watchInternal(fieldNames, defaultValue);
    }
    function unregister(name) {
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
            for (var _iterator11 = (Array.isArray(name) ? name : [name])[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var fieldName = _step11.value;

                removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
            }
        } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                    _iterator11.return();
                }
            } finally {
                if (_didIteratorError11) {
                    throw _iteratorError11;
                }
            }
        }
    }
    function registerFieldRef(ref) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (false) {
            if (!ref.name) {
                return console.warn('📋 Field is missing `name` attribute', ref, 'https://react-hook-form.com/api#useForm');
            }
            if (fieldArrayNamesRef.current.has(ref.name.split(/\[\d+\]$/)[0]) && !RegExp(('^' + ref.name.split(/\[\d+\]$/)[0] + '[\\d+].\\w+').replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(ref.name)) {
                return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', ref, 'https://react-hook-form.com/api#useFieldArray');
            }
        }
        var name = ref.name,
            type = ref.type,
            value = ref.value;

        var fieldRefAndValidationOptions = Object.assign({ ref: ref }, options);
        var fields = fieldsRef.current;
        var isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
        var isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);
        var compareRef = function compareRef(currentRef) {
            return isWeb && (!isHTMLElement(ref) || currentRef === ref);
        };
        var field = fields[name];
        var isEmptyDefaultValue = true;
        var defaultValue = void 0;
        if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && compact(field.options).find(function (option) {
            return value === option.ref.value && compareRef(option.ref);
        }) : compareRef(field.ref))) {
            fields[name] = Object.assign(Object.assign({}, field), options);
            return;
        }
        if (type) {
            field = isRadioOrCheckbox ? Object.assign({ options: [].concat(_toConsumableArray(compact(field && field.options || [])), [{
                    ref: ref
                }]), ref: { type: type, name: name } }, options) : Object.assign({}, fieldRefAndValidationOptions);
        } else {
            field = fieldRefAndValidationOptions;
        }
        fields[name] = field;
        var isEmptyUnmountFields = isUndefined(_get(shallowFieldsStateRef.current, name));
        if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
            defaultValue = _get(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
            isEmptyDefaultValue = isUndefined(defaultValue);
            if (!isEmptyDefaultValue && !isFieldArray) {
                setFieldValue(name, defaultValue);
            }
        }
        if (!isEmptyObject(options)) {
            set(fieldsWithValidationRef.current, name, true);
            if (!isOnSubmit && readFormStateRef.current.isValid) {
                validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then(function (error) {
                    var previousFormIsValid = formStateRef.current.isValid;
                    isEmptyObject(error) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);
                    previousFormIsValid !== isEmptyObject(error) && updateFormState();
                });
            }
        }
        if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
            !isFieldArray && unset(formStateRef.current.dirtyFields, name);
        }
        if (type) {
            attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
        }
    }
    function register(refOrRegisterOptions, options) {
        if (!isWindowUndefined) {
            if (isString(refOrRegisterOptions)) {
                registerFieldRef({ name: refOrRegisterOptions }, options);
            } else if (isObject(refOrRegisterOptions) && 'name' in refOrRegisterOptions) {
                registerFieldRef(refOrRegisterOptions, options);
            } else {
                return function (ref) {
                    return ref && registerFieldRef(ref, refOrRegisterOptions);
                };
            }
        }
    }
    var handleSubmit = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (onValid, onInvalid) {
        return function () {
            var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(e) {
                var fieldErrors, fieldValues, _ref25, errors, values, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, field, name, fieldError;

                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (e && e.preventDefault) {
                                    e.preventDefault();
                                    e.persist();
                                }
                                fieldErrors = {};
                                fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));

                                readFormStateRef.current.isSubmitting && updateFormState({
                                    isSubmitting: true
                                });
                                _context8.prev = 4;

                                if (!resolverRef.current) {
                                    _context8.next = 15;
                                    break;
                                }

                                _context8.next = 8;
                                return resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);

                            case 8:
                                _ref25 = _context8.sent;
                                errors = _ref25.errors;
                                values = _ref25.values;

                                formStateRef.current.errors = fieldErrors = errors;
                                fieldValues = values;
                                _context8.next = 45;
                                break;

                            case 15:
                                _iteratorNormalCompletion12 = true;
                                _didIteratorError12 = false;
                                _iteratorError12 = undefined;
                                _context8.prev = 18;
                                _iterator12 = Object.values(fieldsRef.current)[Symbol.iterator]();

                            case 20:
                                if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                                    _context8.next = 31;
                                    break;
                                }

                                field = _step12.value;

                                if (!field) {
                                    _context8.next = 28;
                                    break;
                                }

                                name = field.ref.name;
                                _context8.next = 26;
                                return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

                            case 26:
                                fieldError = _context8.sent;

                                if (fieldError[name]) {
                                    set(fieldErrors, name, fieldError[name]);
                                    unset(validFieldsRef.current, name);
                                } else if (_get(fieldsWithValidationRef.current, name)) {
                                    unset(formStateRef.current.errors, name);
                                    set(validFieldsRef.current, name, true);
                                }

                            case 28:
                                _iteratorNormalCompletion12 = true;
                                _context8.next = 20;
                                break;

                            case 31:
                                _context8.next = 37;
                                break;

                            case 33:
                                _context8.prev = 33;
                                _context8.t0 = _context8['catch'](18);
                                _didIteratorError12 = true;
                                _iteratorError12 = _context8.t0;

                            case 37:
                                _context8.prev = 37;
                                _context8.prev = 38;

                                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                    _iterator12.return();
                                }

                            case 40:
                                _context8.prev = 40;

                                if (!_didIteratorError12) {
                                    _context8.next = 43;
                                    break;
                                }

                                throw _iteratorError12;

                            case 43:
                                return _context8.finish(40);

                            case 44:
                                return _context8.finish(37);

                            case 45:
                                if (!(isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every(function (name) {
                                    return name in fieldsRef.current;
                                }))) {
                                    _context8.next = 51;
                                    break;
                                }

                                updateFormState({
                                    errors: {},
                                    isSubmitting: true
                                });
                                _context8.next = 49;
                                return onValid(fieldValues, e);

                            case 49:
                                _context8.next = 57;
                                break;

                            case 51:
                                formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                                _context8.t1 = onInvalid;

                                if (!_context8.t1) {
                                    _context8.next = 56;
                                    break;
                                }

                                _context8.next = 56;
                                return onInvalid(formStateRef.current.errors, e);

                            case 56:
                                shouldFocusError && focusOnErrorField(fieldsRef.current, formStateRef.current.errors);

                            case 57:
                                _context8.prev = 57;

                                formStateRef.current.isSubmitting = false;
                                updateFormState({
                                    isSubmitted: true,
                                    isSubmitting: false,
                                    isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
                                    submitCount: formStateRef.current.submitCount + 1
                                });
                                return _context8.finish(57);

                            case 61:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this2, [[4,, 57, 61], [18, 33, 37, 45], [38,, 40, 44]]);
            }));

            return function (_x25) {
                return _ref24.apply(this, arguments);
            };
        }();
    }, [shouldFocusError, isValidateAllFieldCriteria]);
    var resetRefs = function resetRefs(_ref26) {
        var errors = _ref26.errors,
            isDirty = _ref26.isDirty,
            isSubmitted = _ref26.isSubmitted,
            touched = _ref26.touched,
            isValid = _ref26.isValid,
            submitCount = _ref26.submitCount,
            dirtyFields = _ref26.dirtyFields;

        if (!isValid) {
            validFieldsRef.current = {};
            fieldsWithValidationRef.current = {};
        }
        fieldArrayDefaultValuesRef.current = {};
        watchFieldsRef.current = new Set();
        isWatchAllRef.current = false;
        updateFormState({
            submitCount: submitCount ? formStateRef.current.submitCount : 0,
            isDirty: isDirty ? formStateRef.current.isDirty : false,
            isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
            isValid: isValid ? formStateRef.current.isValid : false,
            dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
            touched: touched ? formStateRef.current.touched : {},
            errors: errors ? formStateRef.current.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    var reset = function reset(values) {
        var omitResetState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (isWeb) {
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
                for (var _iterator13 = Object.values(fieldsRef.current)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                    var field = _step13.value;

                    if (field) {
                        var ref = field.ref,
                            options = field.options;

                        var inputRef = isRadioOrCheckboxFunction(ref) && Array.isArray(options) ? options[0].ref : ref;
                        if (isHTMLElement(inputRef)) {
                            try {
                                inputRef.closest('form').reset();
                                break;
                            } catch (_a) {}
                        }
                    }
                }
            } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion13 && _iterator13.return) {
                        _iterator13.return();
                    }
                } finally {
                    if (_didIteratorError13) {
                        throw _iteratorError13;
                    }
                }
            }
        }
        fieldsRef.current = {};
        defaultValuesRef.current = Object.assign({}, values || defaultValuesRef.current);
        values && renderWatchedInputs('');
        Object.values(resetFieldArrayFunctionRef.current).forEach(function (resetFieldArray) {
            return isFunction(resetFieldArray) && resetFieldArray();
        });
        shallowFieldsStateRef.current = shouldUnregister ? {} : cloneObject(values || defaultValuesRef.current);
        resetRefs(omitResetState);
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        resolver && readFormStateRef.current.isValid && validateResolver();
        observerRef.current = observerRef.current || !isWeb ? observerRef.current : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
    }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        return function () {
            observerRef.current && observerRef.current.disconnect();
            isUnMount.current = true;
            if (false) {
                return;
            }
            Object.values(fieldsRef.current).forEach(function (field) {
                return removeFieldEventListenerAndRef(field, true);
            });
        };
    }, []);
    if (!resolver && readFormStateRef.current.isValid) {
        formState.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
    }
    var commonProps = {
        trigger: trigger,
        setValue: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(setValue, [setInternalValue, trigger]),
        getValues: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(getValues, []),
        register: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(register, [defaultValuesRef.current]),
        unregister: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(unregister, []),
        formState: isProxyEnabled ? new Proxy(formState, {
            get: function get(obj, prop) {
                if (false) {
                    if (prop === 'isValid' && isOnSubmit) {
                        console.warn('📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState');
                    }
                }
                if (prop in obj) {
                    readFormStateRef.current[prop] = true;
                    return obj[prop];
                }
                return undefined;
            }
        }) : formState
    };
    var control = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        return Object.assign({ isFormDirty: isFormDirty,
            updateWatchedValue: updateWatchedValue,
            shouldUnregister: shouldUnregister,
            updateFormState: updateFormState,
            removeFieldEventListener: removeFieldEventListener,
            watchInternal: watchInternal, mode: modeRef.current, reValidateMode: {
                isReValidateOnBlur: isReValidateOnBlur,
                isReValidateOnChange: isReValidateOnChange
            }, validateResolver: resolver ? validateResolver : undefined, fieldsRef: fieldsRef,
            resetFieldArrayFunctionRef: resetFieldArrayFunctionRef,
            useWatchFieldsRef: useWatchFieldsRef,
            useWatchRenderFunctionsRef: useWatchRenderFunctionsRef,
            fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef,
            validFieldsRef: validFieldsRef,
            fieldsWithValidationRef: fieldsWithValidationRef,
            fieldArrayNamesRef: fieldArrayNamesRef,
            readFormStateRef: readFormStateRef,
            formStateRef: formStateRef,
            defaultValuesRef: defaultValuesRef,
            shallowFieldsStateRef: shallowFieldsStateRef,
            fieldArrayValuesRef: fieldArrayValuesRef }, commonProps);
    }, [defaultValuesRef.current, updateWatchedValue, shouldUnregister, removeFieldEventListener, watchInternal]);
    return Object.assign({ watch: watch,
        control: control,
        handleSubmit: handleSubmit, reset: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(reset, []), clearErrors: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(clearErrors, []), setError: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(setError, []), errors: formState.errors }, commonProps);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}

var FormContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);
FormContext.displayName = 'RHFContext';
var useFormContext = function useFormContext() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(FormContext);
};
var FormProvider = function FormProvider(_a) {
    var children = _a.children,
        props = __rest(_a, ["children"]);
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FormContext.Provider, { value: Object.assign({}, props) }, children);
};

var generateId = function generateId() {
    var d = (typeof performance === 'undefined' ? 'undefined' : _typeof(performance)) === UNDEFINED ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};

function removeAtIndexes(data, indexes) {
    var i = 0;
    var temp = [].concat(_toConsumableArray(data));
    var _iteratorNormalCompletion14 = true;
    var _didIteratorError14 = false;
    var _iteratorError14 = undefined;

    try {
        for (var _iterator14 = indexes[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var index = _step14.value;

            temp.splice(index - i, 1);
            i++;
        }
    } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
            }
        } finally {
            if (_didIteratorError14) {
                throw _iteratorError14;
            }
        }
    }

    return compact(temp).length ? temp : [];
}
var removeArrayAt = function removeArrayAt(data, index) {
    return isUndefined(index) ? [] : removeAtIndexes(data, (Array.isArray(index) ? index : [index]).sort(function (a, b) {
        return a - b;
    }));
};

var moveArrayAt = function moveArrayAt(data, from, to) {
    if (Array.isArray(data)) {
        if (isUndefined(data[to])) {
            data[to] = undefined;
        }
        data.splice(to, 0, data.splice(from, 1)[0]);
        return data;
    }
    return [];
};

var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
    var temp = [data[indexB], data[indexA]];
    data[indexA] = temp[0];
    data[indexB] = temp[1];
};

function prepend(data, value) {
    return [].concat(_toConsumableArray(Array.isArray(value) ? value : [value || undefined]), _toConsumableArray(data));
}

function insert(data, index, value) {
    return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(Array.isArray(value) ? value : [value || undefined]), _toConsumableArray(data.slice(index)));
}

var fillEmptyArray = function fillEmptyArray(value) {
    return Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;
};

var fillBooleanArray = function fillBooleanArray(value) {
    return (Array.isArray(value) ? value : [value]).map(function (data) {
        if (isObject(data)) {
            var object = {};
            for (var key in data) {
                object[key] = true;
            }
            return object;
        }
        return true;
    });
};

var mapIds = function mapIds() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var keyName = arguments[1];
    var skipWarn = arguments[2];

    if (false) {
        if (!skipWarn) {
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
                for (var _iterator15 = values[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                    var value = _step15.value;

                    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
                        if (keyName in value) {
                            console.warn('\uD83D\uDCCB useFieldArray fieldValues contain the keyName `' + keyName + '` which is reserved for use by useFieldArray. https://react-hook-form.com/api#useFieldArray');
                            break;
                        }
                    } else {
                        console.warn('\uD83D\uDCCB useFieldArray input\'s name should be in object shape instead of flat array. https://react-hook-form.com/api#useFieldArray');
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError15 = true;
                _iteratorError15 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion15 && _iterator15.return) {
                        _iterator15.return();
                    }
                } finally {
                    if (_didIteratorError15) {
                        throw _iteratorError15;
                    }
                }
            }
        }
    }
    return values.map(function (value) {
        return Object.assign(_defineProperty({}, keyName, value[keyName] || generateId()), value);
    });
};
var useFieldArray = function useFieldArray(_ref27) {
    var control = _ref27.control,
        name = _ref27.name,
        _ref27$keyName = _ref27.keyName,
        keyName = _ref27$keyName === undefined ? 'id' : _ref27$keyName;

    var methods = useFormContext();
    if (false) {
        if (!control && !methods) {
            throw new Error('📋 useFieldArray is missing `control` prop. https://react-hook-form.com/api#useFieldArray');
        }
    }
    var focusIndexRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(-1);
    var isUnMount = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

    var _ref28 = control || methods.control,
        isFormDirty = _ref28.isFormDirty,
        updateWatchedValue = _ref28.updateWatchedValue,
        resetFieldArrayFunctionRef = _ref28.resetFieldArrayFunctionRef,
        fieldArrayNamesRef = _ref28.fieldArrayNamesRef,
        fieldsRef = _ref28.fieldsRef,
        defaultValuesRef = _ref28.defaultValuesRef,
        removeFieldEventListener = _ref28.removeFieldEventListener,
        formStateRef = _ref28.formStateRef,
        shallowFieldsStateRef = _ref28.shallowFieldsStateRef,
        updateFormState = _ref28.updateFormState,
        readFormStateRef = _ref28.readFormStateRef,
        validFieldsRef = _ref28.validFieldsRef,
        fieldsWithValidationRef = _ref28.fieldsWithValidationRef,
        fieldArrayDefaultValuesRef = _ref28.fieldArrayDefaultValuesRef,
        validateResolver = _ref28.validateResolver,
        getValues = _ref28.getValues,
        shouldUnregister = _ref28.shouldUnregister,
        fieldArrayValuesRef = _ref28.fieldArrayValuesRef;

    var getDefaultValues = function getDefaultValues(values) {
        return _get(shouldUnregister ? values : shallowFieldsStateRef.current, name, []);
    };
    var fieldArrayParentName = getFieldArrayParentName(name);
    var memoizedDefaultValues = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([].concat(_toConsumableArray(_get(fieldArrayDefaultValuesRef.current, fieldArrayParentName) ? getDefaultValues(fieldArrayDefaultValuesRef.current) : getDefaultValues(defaultValuesRef.current))));

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(mapIds(memoizedDefaultValues.current, keyName)),
        _useState4 = _slicedToArray(_useState3, 2),
        fields = _useState4[0],
        setFields = _useState4[1];

    set(fieldArrayValuesRef.current, name, compact(fields));
    var omitKey = function omitKey(fields) {
        return fields.map(function () {
            var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var _b = keyName,
                omitted = _a[_b],
                rest = __rest(_a, [(typeof _b === 'undefined' ? 'undefined' : _typeof(_b)) === "symbol" ? _b : _b + ""]);
            return rest;
        });
    };
    fieldArrayNamesRef.current.add(name);
    var getFieldArrayValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        return _get(fieldArrayValuesRef.current, name, []);
    }, [name]);
    var getCurrentFieldsValues = function getCurrentFieldsValues() {
        return mapIds(_get(getValues(), name, getFieldArrayValue()).map(function (item, index) {
            return Object.assign(Object.assign({}, getFieldArrayValue()[index]), item);
        }), keyName, true);
    };
    fieldArrayNamesRef.current.add(name);
    if (fieldArrayParentName && !_get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) {
        set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, cloneObject(_get(defaultValuesRef.current, fieldArrayParentName)));
    }
    var setFieldAndValidState = function setFieldAndValidState(fieldsValues) {
        setFields(fieldsValues);
        set(fieldArrayValuesRef.current, name, fieldsValues);
        if (readFormStateRef.current.isValid && validateResolver) {
            var values = getValues();
            set(values, name, fieldsValues);
            validateResolver(values);
        }
    };
    var resetFields = function resetFields() {
        for (var key in fieldsRef.current) {
            if (isMatchFieldArrayName(key, name)) {
                removeFieldEventListener(fieldsRef.current[key], true);
                delete fieldsRef.current[key];
            }
        }
    };
    var cleanup = function cleanup(ref) {
        return !compact(_get(ref, name, [])).length && unset(ref, name);
    };
    var updateDirtyFieldsWithDefaultValues = function updateDirtyFieldsWithDefaultValues(updatedFieldArrayValues) {
        if (updatedFieldArrayValues) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
        }
    };
    var batchStateUpdate = function batchStateUpdate(method, args, updatedFieldValues) {
        var updatedFormValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var shouldSet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        var shouldUpdateValid = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

        if (_get(shallowFieldsStateRef.current, name)) {
            var output = method(_get(shallowFieldsStateRef.current, name), args.argA, args.argB);
            shouldSet && set(shallowFieldsStateRef.current, name, output);
        }
        if (_get(fieldArrayDefaultValuesRef.current, name)) {
            var _output = method(_get(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);
            shouldSet && set(fieldArrayDefaultValuesRef.current, name, _output);
        }
        if (Array.isArray(_get(formStateRef.current.errors, name))) {
            var _output2 = method(_get(formStateRef.current.errors, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.errors, name, _output2);
            cleanup(formStateRef.current.errors);
        }
        if (readFormStateRef.current.touched && _get(formStateRef.current.touched, name)) {
            var _output3 = method(_get(formStateRef.current.touched, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.touched, name, _output3);
            cleanup(formStateRef.current.touched);
        }
        if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFormValues), _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
            updateDirtyFieldsWithDefaultValues(updatedFieldValues);
            cleanup(formStateRef.current.dirtyFields);
        }
        if (shouldUpdateValid && readFormStateRef.current.isValid && !validateResolver) {
            set(validFieldsRef.current, name, method(_get(validFieldsRef.current, name, []), args.argA));
            cleanup(validFieldsRef.current);
            set(fieldsWithValidationRef.current, name, method(_get(fieldsWithValidationRef.current, name, []), args.argA));
            cleanup(fieldsWithValidationRef.current);
        }
        if (!isUnMount.current && readFormStateRef.current.isDirty) {
            updateFormState({
                isDirty: isFormDirty(name, omitKey(updatedFormValues))
            });
        }
    };
    var append = function append(value) {
        var shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var appendValue = Array.isArray(value) ? value : [value];
        var updateFormValues = [].concat(_toConsumableArray(getCurrentFieldsValues()), _toConsumableArray(mapIds(appendValue, keyName)));
        setFieldAndValidState(updateFormValues);
        if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
            updateDirtyFieldsWithDefaultValues(updateFormValues);
            updateFormState({
                isDirty: true,
                dirtyFields: formStateRef.current.dirtyFields
            });
        }
        !shouldUnregister && set(shallowFieldsStateRef.current, name, [].concat(_toConsumableArray(_get(shallowFieldsStateRef.current, name) || []), _toConsumableArray(cloneObject(appendValue))));
        focusIndexRef.current = shouldFocus ? _get(fieldArrayValuesRef.current, name).length - 1 : -1;
    };
    var prepend$1 = function prepend$1(value) {
        var shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var emptyArray = fillEmptyArray(value);
        var updatedFieldArrayValues = prepend(getCurrentFieldsValues(), mapIds(Array.isArray(value) ? value : [value], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate(prepend, {
            argA: emptyArray,
            argC: fillBooleanArray(value)
        }, updatedFieldArrayValues);
        focusIndexRef.current = shouldFocus ? 0 : -1;
    };
    var remove = function remove(index) {
        var fieldValues = getCurrentFieldsValues();
        var updatedFieldValues = removeArrayAt(fieldValues, index);
        setFieldAndValidState(updatedFieldValues);
        resetFields();
        batchStateUpdate(removeArrayAt, {
            argA: index,
            argC: index
        }, updatedFieldValues, removeArrayAt(fieldValues, index), true, true);
    };
    var insert$1 = function insert$1(index, value) {
        var shouldFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var emptyArray = fillEmptyArray(value);
        var fieldValues = getCurrentFieldsValues();
        var updatedFieldArrayValues = insert(fieldValues, index, mapIds(Array.isArray(value) ? value : [value], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate(insert, {
            argA: index,
            argB: emptyArray,
            argC: index,
            argD: fillBooleanArray(value)
        }, updatedFieldArrayValues, insert(fieldValues, index));
        focusIndexRef.current = shouldFocus ? index : -1;
    };
    var swap = function swap(indexA, indexB) {
        var fieldValues = getCurrentFieldsValues();
        swapArrayAt(fieldValues, indexA, indexB);
        resetFields();
        setFieldAndValidState([].concat(_toConsumableArray(fieldValues)));
        batchStateUpdate(swapArrayAt, {
            argA: indexA,
            argB: indexB,
            argC: indexA,
            argD: indexB
        }, undefined, fieldValues, false);
    };
    var move = function move(from, to) {
        var fieldValues = getCurrentFieldsValues();
        moveArrayAt(fieldValues, from, to);
        resetFields();
        setFieldAndValidState([].concat(_toConsumableArray(fieldValues)));
        batchStateUpdate(moveArrayAt, {
            argA: from,
            argB: to,
            argC: from,
            argD: to
        }, undefined, fieldValues, false);
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (false) {
            if (!name) {
                console.warn('📋 useFieldArray is missing `name` attribute. https://react-hook-form.com/api#useFieldArray');
            }
        }
        var defaultValues = _get(fieldArrayDefaultValuesRef.current, name);
        if (defaultValues && fields.length < defaultValues.length) {
            set(fieldArrayDefaultValuesRef.current, name, defaultValues.slice(1));
        }
        updateWatchedValue(name);
        if (focusIndexRef.current > -1) {
            for (var key in fieldsRef.current) {
                var field = fieldsRef.current[key];
                if (key.startsWith(name + '[' + focusIndexRef.current + ']') && field.ref.focus) {
                    field.ref.focus();
                    break;
                }
            }
        }
        focusIndexRef.current = -1;
    }, [fields, name]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var resetFunctions = resetFieldArrayFunctionRef.current;
        var fieldArrayNames = fieldArrayNamesRef.current;
        if (!getFieldArrayParentName(name)) {
            resetFunctions[name] = function (data) {
                resetFields();
                !data && unset(fieldArrayDefaultValuesRef.current, name);
                unset(shallowFieldsStateRef.current, name);
                memoizedDefaultValues.current = _get(data || defaultValuesRef.current, name);
                if (!isUnMount.current) {
                    setFields(mapIds(memoizedDefaultValues.current, keyName));
                }
            };
        }
        return function () {
            isUnMount.current = true;
            shouldUnregister && remove();
            resetFields();
            delete resetFunctions[name];
            unset(fieldArrayValuesRef.current, name);
            fieldArrayNames.delete(name);
        };
    }, []);
    return {
        swap: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(swap, [name]),
        move: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(move, [name]),
        prepend: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(prepend$1, [name]),
        append: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(append, [name]),
        remove: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(remove, [name]),
        insert: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(insert$1, [name]),
        fields: compact(fields)
    };
};

var getInputValue = function getInputValue(event) {
    return isPrimitive(event) || !isObject(event.target) || isObject(event.target) && !event.type ? event : isUndefined(event.target.value) ? event.target.checked : event.target.value;
};

function useController(_ref29) {
    var name = _ref29.name,
        rules = _ref29.rules,
        defaultValue = _ref29.defaultValue,
        control = _ref29.control,
        onFocus = _ref29.onFocus;

    var methods = useFormContext();
    if (false) {
        if (!control && !methods) {
            throw new Error('📋 Controller is missing `control` prop. https://react-hook-form.com/api#Controller');
        }
    }

    var _ref30 = control || methods.control,
        defaultValuesRef = _ref30.defaultValuesRef,
        setValue = _ref30.setValue,
        register = _ref30.register,
        unregister = _ref30.unregister,
        trigger = _ref30.trigger,
        mode = _ref30.mode,
        _ref30$reValidateMode = _ref30.reValidateMode,
        isReValidateOnBlur = _ref30$reValidateMode.isReValidateOnBlur,
        isReValidateOnChange = _ref30$reValidateMode.isReValidateOnChange,
        formState = _ref30.formState,
        _ref30$formStateRef$c = _ref30.formStateRef.current,
        isSubmitted = _ref30$formStateRef$c.isSubmitted,
        touched = _ref30$formStateRef$c.touched,
        errors = _ref30$formStateRef$c.errors,
        updateFormState = _ref30.updateFormState,
        readFormStateRef = _ref30.readFormStateRef,
        fieldsRef = _ref30.fieldsRef,
        fieldArrayNamesRef = _ref30.fieldArrayNamesRef,
        shallowFieldsStateRef = _ref30.shallowFieldsStateRef;

    var isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);
    var getInitialValue = function getInitialValue() {
        return !isUndefined(_get(shallowFieldsStateRef.current, name)) && isNotFieldArray ? _get(shallowFieldsStateRef.current, name) : isUndefined(defaultValue) ? _get(defaultValuesRef.current, name) : defaultValue;
    };

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(getInitialValue()),
        _useState6 = _slicedToArray(_useState5, 2),
        value = _useState6[0],
        setInputStateValue = _useState6[1];

    var valueRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(value);
    var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({
        focus: function focus() {
            return null;
        }
    });
    var onFocusRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(onFocus || function () {
        if (isFunction(ref.current.focus)) {
            ref.current.focus();
        }
        if (false) {
            if (!isFunction(ref.current.focus)) {
                console.warn('\uD83D\uDCCB \'ref\' from Controller render prop must be attached to a React component or a DOM Element whose ref provides a \'focus()\' method');
            }
        }
    });
    var shouldValidate = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (isBlurEvent) {
        return !skipValidation(Object.assign({ isBlurEvent: isBlurEvent,
            isReValidateOnBlur: isReValidateOnBlur,
            isReValidateOnChange: isReValidateOnChange,
            isSubmitted: isSubmitted, isTouched: !!_get(touched, name) }, mode));
    }, [isReValidateOnBlur, isReValidateOnChange, isSubmitted, touched, name, mode]);
    var commonTask = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_ref31) {
        var _ref32 = _slicedToArray(_ref31, 1),
            event = _ref32[0];

        var data = getInputValue(event);
        setInputStateValue(data);
        valueRef.current = data;
        return data;
    }, []);
    var registerField = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (shouldUpdateValue) {
        if (false) {
            if (!name) {
                return console.warn('📋 Field is missing `name` prop. https://react-hook-form.com/api#Controller');
            }
        }
        if (fieldsRef.current[name]) {
            fieldsRef.current[name] = Object.assign({ ref: fieldsRef.current[name].ref }, rules);
        } else {
            register(Object.defineProperties({
                name: name,
                focus: onFocusRef.current
            }, {
                value: {
                    set: function set(data) {
                        setInputStateValue(data);
                        valueRef.current = data;
                    },
                    get: function get() {
                        return valueRef.current;
                    }
                }
            }), rules);
            shouldUpdateValue = isUndefined(_get(defaultValuesRef.current, name));
        }
        shouldUpdateValue && isNotFieldArray && setInputStateValue(getInitialValue());
    }, [rules, name, register]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        return function () {
            return unregister(name);
        };
    }, [name]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (false) {
            if (isUndefined(value)) {
                console.warn('\uD83D\uDCCB ' + name + ' is missing in the \'defaultValue\' prop of either its Controller (https://react-hook-form.com/api#Controller) or useForm (https://react-hook-form.com/api#useForm)');
            }
            if (!isNotFieldArray && isUndefined(defaultValue)) {
                console.warn('📋 Controller is missing `defaultValue` prop when using `useFieldArray`. https://react-hook-form.com/api#Controller');
            }
        }
        registerField();
    }, [registerField]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        !fieldsRef.current[name] && registerField(true);
    });
    var onBlur = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (readFormStateRef.current.touched && !_get(touched, name)) {
            set(touched, name, true);
            updateFormState({
                touched: touched
            });
        }
        shouldValidate(true) && trigger(name);
    }, [name, updateFormState, shouldValidate, trigger, readFormStateRef]);
    var onChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        for (var _len = arguments.length, event = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
            event[_key2] = arguments[_key2];
        }

        return setValue(name, commonTask(event), {
            shouldValidate: shouldValidate(),
            shouldDirty: true
        });
    }, [setValue, name, shouldValidate]);
    return {
        field: {
            onChange: onChange,
            onBlur: onBlur,
            name: name,
            value: value,
            ref: ref
        },
        meta: Object.defineProperties({
            invalid: !!_get(errors, name)
        }, {
            isDirty: {
                get: function get() {
                    return !!_get(formState.dirtyFields, name);
                }
            },
            isTouched: {
                get: function get() {
                    return !!_get(formState.touched, name);
                }
            }
        })
    };
}

function useWatch(_ref33) {
    var control = _ref33.control,
        name = _ref33.name,
        defaultValue = _ref33.defaultValue;

    var methods = useFormContext();
    if (false) {
        if (!control && !methods) {
            throw new Error('📋 useWatch is missing `control` prop. https://react-hook-form.com/api#useWatch');
        }
    }

    var _ref34 = control || methods.control,
        useWatchFieldsRef = _ref34.useWatchFieldsRef,
        useWatchRenderFunctionsRef = _ref34.useWatchRenderFunctionsRef,
        watchInternal = _ref34.watchInternal,
        defaultValuesRef = _ref34.defaultValuesRef;

    var updateValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])()[1];
    var idRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var defaultValueRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(defaultValue);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (false) {
            if (name === '') {
                console.warn('📋 useWatch is missing `name` attribute. https://react-hook-form.com/api#useWatch');
            }
        }
        var id = idRef.current = generateId();
        var watchFieldsHookRender = useWatchRenderFunctionsRef.current;
        var watchFieldsHook = useWatchFieldsRef.current;
        watchFieldsHook[id] = new Set();
        watchFieldsHookRender[id] = function () {
            return updateValue({});
        };
        watchInternal(name, defaultValueRef.current, id);
        return function () {
            delete watchFieldsHook[id];
            delete watchFieldsHookRender[id];
        };
    }, [name, useWatchRenderFunctionsRef, useWatchFieldsRef, watchInternal, defaultValueRef]);
    return idRef.current ? watchInternal(name, defaultValueRef.current, idRef.current) : isUndefined(defaultValue) ? isString(name) ? _get(defaultValuesRef.current, name) : Array.isArray(name) ? name.reduce(function (previous, inputName) {
        return Object.assign(Object.assign({}, previous), _defineProperty({}, inputName, _get(defaultValuesRef.current, inputName)));
    }, {}) : defaultValuesRef.current : defaultValue;
}

var Controller = function Controller(props) {
    var rules = props.rules,
        as = props.as,
        render = props.render,
        defaultValue = props.defaultValue,
        control = props.control,
        onFocus = props.onFocus,
        rest = __rest(props, ["rules", "as", "render", "defaultValue", "control", "onFocus"]);

    var _useController = useController(props),
        field = _useController.field,
        meta = _useController.meta;

    var componentProps = Object.assign(Object.assign({}, rest), field);
    return as ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(as) ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(as, componentProps) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(as, componentProps) : render ? render(field, meta) : null;
};


//# sourceMappingURL=index.esm.js.map

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(isHTMLElement, 'isHTMLElement', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(EVENTS, 'EVENTS', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(VALIDATION_MODE, 'VALIDATION_MODE', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(SELECT, 'SELECT', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(UNDEFINED, 'UNDEFINED', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(INPUT_VALIDATION_RULES, 'INPUT_VALIDATION_RULES', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(attachEventListeners, 'attachEventListeners', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isNullOrUndefined, 'isNullOrUndefined', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isObjectType, 'isObjectType', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isObject, 'isObject', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isKey, 'isKey', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(compact, 'compact', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(stringToPath, 'stringToPath', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(set, 'set', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(transformToNestObject, 'transformToNestObject', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isUndefined, 'isUndefined', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(_get, 'get', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(focusOnErrorField, 'focusOnErrorField', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(removeAllEventListeners, 'removeAllEventListeners', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(defaultReturn, 'defaultReturn', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getRadioValue, 'getRadioValue', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getMultipleSelectValue, 'getMultipleSelectValue', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isRadioInput, 'isRadioInput', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isFileInput, 'isFileInput', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isCheckBoxInput, 'isCheckBoxInput', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isMultipleSelect, 'isMultipleSelect', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(defaultResult, 'defaultResult', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(validResult, 'validResult', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getCheckboxValue, 'getCheckboxValue', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getFieldValue, 'getFieldValue', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isDetached, 'isDetached', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isEmptyObject, 'isEmptyObject', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isBoolean, 'isBoolean', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(baseGet, 'baseGet', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(unset, 'unset', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isSameRef, 'isSameRef', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(findRemovedFieldAndRemoveListener, 'findRemovedFieldAndRemoveListener', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isPrimitive, 'isPrimitive', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(deepMerge, 'deepMerge', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(deepEqual, 'deepEqual', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(setDirtyFields, 'setDirtyFields', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(setFieldArrayDirtyFields, 'setFieldArrayDirtyFields', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isString, 'isString', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getFieldsValues, 'getFieldsValues', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isErrorStateChanged, 'isErrorStateChanged', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isRegex, 'isRegex', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getValueAndMessage, 'getValueAndMessage', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isFunction, 'isFunction', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isMessage, 'isMessage', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getValidateError, 'getValidateError', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(appendErrors, 'appendErrors', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(validateField, 'validateField', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getPath, 'getPath', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(assignWatchFields, 'assignWatchFields', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(skipValidation, 'skipValidation', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getFieldArrayParentName, 'getFieldArrayParentName', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isMatchFieldArrayName, 'isMatchFieldArrayName', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isNameInFieldArray, 'isNameInFieldArray', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isSelectInput, 'isSelectInput', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(onDomRemove, 'onDomRemove', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isWeb, 'isWeb', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(cloneObject, 'cloneObject', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(modeChecker, 'modeChecker', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isRadioOrCheckboxFunction, 'isRadioOrCheckboxFunction', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isWindowUndefined, 'isWindowUndefined', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(isProxyEnabled, 'isProxyEnabled', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(useForm, 'useForm', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(__rest, '__rest', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(FormContext, 'FormContext', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(useFormContext, 'useFormContext', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(FormProvider, 'FormProvider', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(generateId, 'generateId', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(removeAtIndexes, 'removeAtIndexes', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(removeArrayAt, 'removeArrayAt', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(moveArrayAt, 'moveArrayAt', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(swapArrayAt, 'swapArrayAt', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(prepend, 'prepend', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(insert, 'insert', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(fillEmptyArray, 'fillEmptyArray', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(fillBooleanArray, 'fillBooleanArray', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(mapIds, 'mapIds', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(useFieldArray, 'useFieldArray', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(getInputValue, 'getInputValue', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(useController, 'useController', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(useWatch, 'useWatch', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    reactHotLoader.register(Controller, 'Controller', '/opt/atlassian/pipelines/agent/build/node_modules/react-hook-form/dist/index.esm.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextCountries; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_left__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_highlight_off__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_highlight_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_highlight_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sidebar__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PortAdd_MapComponent__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blocks_Facilities_Facilities__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__blocks_PortRestrictions_PortRestrictions__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__blocks_Warehouses_Warehouses__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blocks_Other_Other__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__blocks_LiftAndCranes_LiftAndCranes__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__blocks_ServiceProviders_ServiceProviders__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__hooks_ports__ = __webpack_require__(3262);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


























var styles = {
    btnBack: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' }
    },
    btnSubmit: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' }
    }
};

var serializeId = function serializeId(v) {
    return v && (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v._id ? v._id : v || undefined;
};

var ContextCountries = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])([]);

var PortManagement = function PortManagement(_ref) {
    var initialPort = _ref.port,
        getPort = _ref.getPort,
        clearPort = _ref.clearPort,
        routeParams = _ref.routeParams,
        router = _ref.router,
        getCountries = _ref.getCountries,
        countries = _ref.countries;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        port: initialPort,
        addedBy: { email: '', name: '', addedAt: '' },
        newPort: initialPort,
        serviceProviders: initialPort.serviceProviders,
        newServiceProviders: initialPort.serviceProviders,
        disabled: false,
        liftsCranes: initialPort.liftsCranes
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var _usePortMutations = Object(__WEBPACK_IMPORTED_MODULE_23__hooks_ports__["a" /* usePortMutations */])(initialPort._id),
        approve = _usePortMutations.approve,
        reject = _usePortMutations.reject,
        updateField = _usePortMutations.updateField,
        approveField = _usePortMutations.approveField,
        rejectField = _usePortMutations.rejectField;

    var _useServiceProvidersM = Object(__WEBPACK_IMPORTED_MODULE_23__hooks_ports__["b" /* useServiceProvidersMutations */])(initialPort._id),
        approveServiceProvider = _useServiceProvidersM.approveServiceProvider,
        rejectServiceProvider = _useServiceProvidersM.rejectServiceProvider,
        updateServiceProvider = _useServiceProvidersM.updateServiceProvider,
        approveNewServiceProvider = _useServiceProvidersM.approveNewServiceProvider,
        rejectNewServiceProvider = _useServiceProvidersM.rejectNewServiceProvider,
        approveRemoveServiceProvider = _useServiceProvidersM.approveRemoveServiceProvider,
        rejectRemoveServiceProvider = _useServiceProvidersM.rejectRemoveServiceProvider;

    var handleApproveNewServiceProvider = function handleApproveNewServiceProvider(serviceProvider, onComplete) {
        approveNewServiceProvider.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            providerId: serviceProvider._id
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                if (onComplete) {
                    onComplete();
                }
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    var handleRejectNewServiceProvider = function handleRejectNewServiceProvider(serviceProvider, onComplete) {
        rejectNewServiceProvider.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            providerId: serviceProvider._id
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                if (onComplete) {
                    onComplete();
                }
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    var handleApproveRemoveServiceProvider = function handleApproveRemoveServiceProvider(serviceProvider) {
        approveRemoveServiceProvider.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            providerId: serviceProvider._id
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    var handleRejectRemoveServiceProvider = function handleRejectRemoveServiceProvider(serviceProvider) {
        rejectRemoveServiceProvider.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            providerId: serviceProvider._id
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    var handleApproveServiceProvider = function handleApproveServiceProvider(serviceProvider) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { isNew: false, isRemove: false };

        if (opts.isNew) {
            return handleApproveNewServiceProvider(serviceProvider, opts.onComplete);
        }

        if (opts.isRemove) {
            return handleApproveRemoveServiceProvider(serviceProvider);
        }

        approveServiceProvider.mutate({
            _id: serviceProvider._id,
            historyId: serviceProvider.history._id,
            updateAt: Date.parse(serviceProvider.history.updateAt)
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    var handleRejectServiceProvider = function handleRejectServiceProvider(serviceProvider) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { isNew: false, isRemove: false };

        if (opts.isNew) {
            return handleRejectNewServiceProvider(serviceProvider, opts.onComplete);
        }

        if (opts.isRemove) {
            return handleRejectRemoveServiceProvider(serviceProvider);
        }

        console.log('handleRejectServiceProvider', serviceProvider);

        rejectServiceProvider.mutate({
            _id: serviceProvider._id,
            historyId: serviceProvider.history._id,
            updateAt: Date.parse(serviceProvider.history.updateAt)
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    var handleUpdateServiceProvider = function handleUpdateServiceProvider(serviceProviders, onComplete) {
        var payloadProviders = Array.isArray(serviceProviders) ? serviceProviders.map(function (sp) {
            if (!sp.recommended || !sp.recommended.endAt) {
                delete sp.recommended;
            }

            if (!sp.contactPersonId || !sp.contactPersonId._id) {
                delete sp.contactPersonId;
            }

            return _extends({}, sp, {
                companyId: serializeId(sp.companyId),
                contactPersonId: serializeId(sp.contactPersonId)
            });
        }) : serviceProviders;

        updateServiceProvider.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            serviceProviders: payloadProviders
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                if (onComplete) {
                    onComplete();
                }
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    /**
     * @param {string} field
     */
    var handleApproveField = function handleApproveField(field) {
        approveField.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            fields: [field]
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    /**
     * @param {string} field
     */
    var handleRejectField = function handleRejectField(field) {
        rejectField.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            fields: [field]
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                return getPort({ id: routeParams.id, history: true, all: true });
            }
        });
    };

    /**
     * @param {string} field
     * @param {any} value
     * @param {function} [onComplete]
     */
    var updatePortField = function updatePortField(field, value, onComplete) {
        updateField.mutate({
            _id: state.port._id,
            historyId: state.port.history[0]._id,
            updateAt: Date.parse(state.port.history[0].updateAt),
            toUpdate: { field: field, value: value }
        }, {
            onSuccess: function onSuccess() {
                clearPort();
                getPort({ id: routeParams.id, history: true, all: true });
                if (onComplete) {
                    onComplete();
                }
            }
        });
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getPort({ id: routeParams.id, history: true, all: true });
        getCountries();

        return function () {
            return clearPort();
        };
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var newState = {
            port: initialPort,
            newPort: initialPort,
            disabled: false,
            addedBy: state.addedBy,
            serviceProviders: initialPort.serviceProviders,
            newServiceProviders: initialPort.serviceProviders,
            liftsCranes: initialPort.liftsCranes,
            newLiftsCranes: initialPort.liftsCranes
        };

        if (initialPort.firstLoad && initialPort.history && initialPort.history.length === 0) {
            clearPort();
            router.push('/regions/ports/' + routeParams.id);
            return;
        }

        if (initialPort.history && initialPort.history.length > 0) {
            newState.port = Object.assign({}, initialPort, initialPort.history[0].originalValues);
            newState.newPort = Object.assign({}, initialPort, initialPort.history[0].changedValues);

            if (!newState.port.portLimitations) {
                newState.port.portLimitations = initialPort.portLimitations;
            }

            if (!initialPort.history[0].changedValues.portLimitations) {
                delete newState.newPort.portLimitations;
            }

            newState.addedBy = initialPort.history[0].addedBy;
            newState.addedBy.addedAt = initialPort.history[0].addedAt;

            newState.serviceProviders = [].concat(_toConsumableArray(initialPort.history[0].originalValues.serviceProviders));
            newState.newServiceProviders = [].concat(_toConsumableArray(initialPort.history[0].changedValues.serviceProviders));

            if (initialPort.history[0].originalValues.liftsCranes) {
                newState.liftsCranes = _extends({}, initialPort.history[0].originalValues.liftsCranes);
            }

            newState.newLiftsCranes = _extends({}, initialPort.history[0].changedValues.liftsCranes);

            // Process service providers
            newState.serviceProviders.forEach(function (serviceProvider) {
                var currentServiceProvider = newState.newServiceProviders.find(function (newServiceProvider) {
                    return serviceProvider._id === newServiceProvider._id;
                });

                if (currentServiceProvider && currentServiceProvider.history.length && __WEBPACK_IMPORTED_MODULE_16_lodash___default.a.isEqual(__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.omit(currentServiceProvider, ['_id', 'history', '__v']), currentServiceProvider.history[0].changedValues)) {
                    serviceProvider.status = 'normal';
                    return;
                }

                if (currentServiceProvider && currentServiceProvider.history.length !== 0) {
                    serviceProvider.status = 'change';
                    serviceProvider.provider = currentServiceProvider.history[0].changedValues;
                    serviceProvider.history = currentServiceProvider.history[0];
                    newState.disabled = true;
                } else if (currentServiceProvider && currentServiceProvider.history.length === 0) {
                    serviceProvider.status = 'normal';
                } else {
                    serviceProvider.status = 'remove';
                    // serviceProvider.history = currentServiceProvider.history[0];
                }
            });

            // Process new service providers
            newState.newServiceProviders.forEach(function (newServiceProvider) {
                var currentServiceProvider = newState.serviceProviders.find(function (serviceProvider) {
                    return serviceProvider._id === newServiceProvider._id;
                });

                if (!currentServiceProvider) {
                    newState.serviceProviders.push(newServiceProvider);
                    newState.serviceProviders[newState.serviceProviders.length - 1].status = 'new';
                }
            });

            newState.serviceProviders = [].concat(_toConsumableArray(newState.serviceProviders), _toConsumableArray(initialPort.serviceProviders));
            newState.serviceProviders = __WEBPACK_IMPORTED_MODULE_16_lodash___default.a.uniqBy(newState.serviceProviders, '_id');

            newState.serviceProviders.forEach(function (serviceProvider) {
                if (!serviceProvider.status) {
                    serviceProvider.status = 'normal';
                }
            });

            // Process lifts and cranes
            Object.keys(newState.liftsCranes).forEach(function (key) {
                newState.liftsCranes[key].details.forEach(function (detail) {
                    var currentDetail = newState.newLiftsCranes[key].details.find(function (newDetail) {
                        return detail._id === newDetail._id;
                    });

                    if (currentDetail && (detail.value !== currentDetail.value || detail.name !== currentDetail.name)) {
                        detail.status = 'change';
                        detail.changes = currentDetail;
                    } else if (currentDetail) {
                        detail.status = 'normal';
                        // detail.changes = currentDetail;
                    } else {
                        detail.status = 'remove';
                    }
                });
            });

            Object.keys(newState.newLiftsCranes).forEach(function (key) {
                newState.newLiftsCranes[key].details.forEach(function (newDetail) {
                    var currentDetail = newState.liftsCranes[key] && newState.liftsCranes[key].details.find(function (detail) {
                        return detail._id === newDetail._id;
                    });

                    if (!currentDetail) {
                        newState.liftsCranes[key].details.push(newDetail);
                        newState.liftsCranes[key].details[newState.liftsCranes[key].details.length - 1].status = 'new';
                    }
                });
            });
        }

        setState(newState);
    }, [initialPort]);

    var approvePort = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            approve.mutate({
                                _id: state.port._id,
                                historyId: state.port.history[0]._id,
                                updateAt: Date.parse(state.port.history[0].updateAt)
                            }, {
                                onSuccess: function onSuccess() {
                                    clearPort();
                                    return getPort({ id: routeParams.id, history: true, all: true });
                                }
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function approvePort() {
            return _ref2.apply(this, arguments);
        };
    }();

    var rejectPort = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            reject.mutate({
                                _id: state.port._id,
                                historyId: state.port.history[0]._id,
                                updateAt: Date.parse(state.port.history[0].updateAt)
                            }, {
                                onSuccess: function onSuccess() {
                                    clearPort();
                                    return getPort({ id: routeParams.id, history: true, all: true });
                                },
                                onError: function onError(error) {
                                    console.error('Failed to reject port:', error);
                                }
                            });

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function rejectPort() {
            return _ref3.apply(this, arguments);
        };
    }();

    var port = state.port,
        newPort = state.newPort,
        addedBy = state.addedBy,
        disabled = state.disabled,
        serviceProviders = state.serviceProviders;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container', id: 'single-port' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'management' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    label: 'Back to list',
                    style: styles.btnBack.style,
                    labelStyle: styles.btnBack.labelStyle,
                    labelPosition: 'before',
                    icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_hardware_keyboard_arrow_left___default.a, null),
                    containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */], { to: '/regions/ports' }),
                    primary: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    label: 'Approve port modification',
                    style: styles.btnSubmit.style,
                    labelStyle: styles.btnSubmit.labelStyle,
                    labelPosition: 'before',
                    icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done___default.a, null),
                    backgroundColor: '#a4c639',
                    onClick: approvePort,
                    disabled: disabled
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    label: 'Reject port modification',
                    style: styles.btnSubmit.style,
                    labelStyle: styles.btnSubmit.labelStyle,
                    labelPosition: 'before',
                    icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_highlight_off___default.a, null),
                    backgroundColor: '#f00',
                    onClick: rejectPort,
                    disabled: disabled
                })
            )
        ),
        addedBy.email ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'management' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block' },
                    'Added by'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Email - ',
                    addedBy.email
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Name - ',
                    addedBy.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Added at - ',
                    new Date(addedBy.addedAt).toLocaleString('en-GB', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                )
            )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Sidebar__["a" /* default */], {
                    port: port,
                    newPort: newPort
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                ContextCountries.Provider,
                { value: countries },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-lg-9 col-xs-9 main' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'add-coords-map' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'main__title' },
                                'Coordinates'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PortAdd_MapComponent__["a" /* default */], {
                                coordinates: port.coordinates,
                                googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_13_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
                                loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '100%', height: '300px' } }),
                                mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                                rememberOldCoords: true
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__blocks_ServiceProviders_ServiceProviders__["b" /* default */], {
                            port: state.newPort,
                            pendingChanges: port.history ? port.history[0] : null,
                            serviceProviders: serviceProviders,
                            onSaveChanges: handleUpdateServiceProvider,
                            onApproveField: handleApproveServiceProvider,
                            onRejectField: handleRejectServiceProvider
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__blocks_PortRestrictions_PortRestrictions__["a" /* default */], {
                            port: state.newPort,
                            pendingChanges: port.history ? port.history[0] : null,
                            onApproveField: handleApproveField,
                            onRejectField: handleRejectField,
                            updatePortField: updatePortField
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__blocks_LiftAndCranes_LiftAndCranes__["a" /* default */], {
                            port: state.newPort,
                            pendingChanges: port.history ? port.history[0] : null,
                            onApproveField: handleApproveField,
                            onRejectField: handleRejectField,
                            updatePortField: updatePortField
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__blocks_Facilities_Facilities__["a" /* default */], {
                            port: state.newPort,
                            pendingChanges: port.history ? port.history[0] : null,
                            updatePortField: updatePortField,
                            onApproveField: handleApproveField,
                            onRejectField: handleRejectField
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__blocks_Warehouses_Warehouses__["a" /* default */], {
                            port: state.newPort,
                            pendingChanges: port.history ? port.history[0] : null,
                            updatePortField: updatePortField,
                            onApproveField: handleApproveField,
                            onRejectField: handleRejectField
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7__common_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__blocks_Other_Other__["a" /* default */], {
                            port: state.newPort,
                            pendingChanges: port.history ? port.history[0] : null,
                            updatePortField: updatePortField,
                            onApproveField: handleApproveField,
                            onRejectField: handleRejectField
                        })
                    )
                )
            )
        )
    );
};

var PortManagementForm = Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_14__data_formNames__["a" /* formName */].portUpdate,
    enableReinitialize: true
})(PortManagement);

var _default = Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(function (_ref4) {
    var port = _ref4.port,
        isLogged = _ref4.user.isLogged,
        countries = _ref4.countries;
    return {
        port: port,
        isLogged: isLogged,
        countries: countries && countries.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["bindActionCreators"])({
        getPort: __WEBPACK_IMPORTED_MODULE_12_actions_regions_ports__["e" /* getPort */],
        clearPort: __WEBPACK_IMPORTED_MODULE_12_actions_regions_ports__["c" /* clearPort */],
        getCountries: __WEBPACK_IMPORTED_MODULE_20_actions_countries__["a" /* getCountries */]
    }, dispatch);
})(PortManagementForm);

/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/PortManagement.jsx');
    reactHotLoader.register(serializeId, 'serializeId', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/PortManagement.jsx');
    reactHotLoader.register(ContextCountries, 'ContextCountries', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/PortManagement.jsx');
    reactHotLoader.register(PortManagement, 'PortManagement', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/PortManagement.jsx');
    reactHotLoader.register(PortManagementForm, 'PortManagementForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/PortManagement.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/PortManagement.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHighlightOff = function ActionHighlightOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ActionHighlightOff = (0, _pure2.default)(ActionHighlightOff);
ActionHighlightOff.displayName = 'ActionHighlightOff';
ActionHighlightOff.muiName = 'SvgIcon';

exports.default = ActionHighlightOff;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128703
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSave = function ContentSave(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' })
  );
};
ContentSave = (0, _pure2.default)(ContentSave);
ContentSave.displayName = 'ContentSave';
ContentSave.muiName = 'SvgIcon';

exports.default = ContentSave;

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkIfUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkIfUpdateGazetter; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/**
 * 
 * @param {import('./UpdateRealCargoDialog').RealCargo} item 
 * @param {any[]} cargoTypes 
 * @returns 
 */
var checkIfUpdate = function checkIfUpdate(item, cargoTypes) {
    if (item.parent.red.name === '') {
        return false;
    }

    if (item.name === '') {
        return false;
    }

    var isChecked = cargoTypes.find(function (cargoType) {
        return item.parent.red.name === cargoType.name;
    });

    return !!isChecked;
};

/**
 * 
 * @param {import('./UpdateRealCargoDialog').Gazetter} item 
 * @param {any[]} cargoTypes 
 * @returns 
 */
var checkIfUpdateGazetter = function checkIfUpdateGazetter(item, cargoTypes) {
    if (!item.CargoCategory) {
        return false;
    }

    if (item.realCargoName === '') {
        return false;
    }

    var isChecked = cargoTypes.find(function (cargoType) {
        return item.CargoCategoryName === cargoType.name;
    });

    return !!isChecked;
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(checkIfUpdate, 'checkIfUpdate', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/utils.js');
    reactHotLoader.register(checkIfUpdateGazetter, 'checkIfUpdateGazetter', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/utils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getCargoRealNames */
/* harmony export (immutable) */ __webpack_exports__["d"] = updateCargoRealName;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteCargoRealName;
/* unused harmony export searchCargoRealNames */
/* harmony export (immutable) */ __webpack_exports__["c"] = saveStatusCargoRealName;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateTagsDataInRow;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCargoRealNamesPaginated;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoRealNames() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_16" /* GET_CARGO_REAL_NAMES */].REQUEST
    };
}

function updateCargoRealName(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_126" /* UPDATE_CARGO_REAL_NAME */].REQUEST,
        item: item
    };
}

function deleteCargoRealName(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["N" /* DELETE_CARGO_REAL_NAME */].REQUEST,
        item: item
    };
}

function searchCargoRealNames(search) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_106" /* SEARCH_CARGO_REAL_NAMES */],
        search: search
    };
}

function saveStatusCargoRealName(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_100" /* SAVE_STATUS_CARGO_REAL_NAME */],
        item: item
    };
}

function updateTagsDataInRow(_id, tags) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_138" /* UPDATE_TAGS_DATA_IN_ROW */],
        _id: _id,
        tags: tags
    };
}

function getCargoRealNamesPaginated(opts) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_17" /* GET_CARGO_REAL_NAMES_PAGINATED */].REQUEST,
        opts: opts
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoRealNames, 'getCargoRealNames', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/realNames.js');
    reactHotLoader.register(updateCargoRealName, 'updateCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/realNames.js');
    reactHotLoader.register(deleteCargoRealName, 'deleteCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/realNames.js');
    reactHotLoader.register(searchCargoRealNames, 'searchCargoRealNames', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/realNames.js');
    reactHotLoader.register(saveStatusCargoRealName, 'saveStatusCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/realNames.js');
    reactHotLoader.register(updateTagsDataInRow, 'updateTagsDataInRow', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/realNames.js');
    reactHotLoader.register(getCargoRealNamesPaginated, 'getCargoRealNamesPaginated', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/realNames.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getCargoDuplicates;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteCargoDuplicate;
/* harmony export (immutable) */ __webpack_exports__["d"] = searchCargoDuplicates;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearDuplicates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoDuplicates() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_13" /* GET_CARGO_DUPLICATES */].REQUEST
    };
}

function deleteCargoDuplicate(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["L" /* DELETE_CARGO_DUPLICATE */].REQUEST,
        item: item
    };
}

function searchCargoDuplicates(search) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_105" /* SEARCH_CARGO_DUPLICATES */],
        search: search
    };
}

function clearDuplicates() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["r" /* CLEAR_DUPLICATES */]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoDuplicates, 'getCargoDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/duplicates.js');
    reactHotLoader.register(deleteCargoDuplicate, 'deleteCargoDuplicate', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/duplicates.js');
    reactHotLoader.register(searchCargoDuplicates, 'searchCargoDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/duplicates.js');
    reactHotLoader.register(clearDuplicates, 'clearDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/duplicates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function OpenMailBlock(_ref) {
    var mailId = _ref.mailId;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'paper-block' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'name-block absolute small-name' },
            'email'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            'Id: ',
            mailId
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["r" /* RaisedButton */], {
            onClick: function onClick() {
                return window.open('/' + mailId, "_blank");
            },
            label: 'Open Mail',
            style: { marginLeft: '20px' },
            primary: true
        })
    );
}

var _default = OpenMailBlock;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(OpenMailBlock, 'OpenMailBlock', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/Mails/OpenMailBlock.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/Mails/OpenMailBlock.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EhSelector__ = __webpack_require__(3291);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EhSelector__["a"]; });



/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsUsers;
/* harmony export (immutable) */ __webpack_exports__["b"] = searchStatisticsUsers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsUsers(from, until) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_47" /* GET_STATISTICS_USERS */].REQUEST,
        from: from,
        until: until
    };
}

function searchStatisticsUsers(searchText) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_111" /* SEARCH_STATISTICS_USERS */],
        searchText: searchText
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsUsers, 'getStatisticsUsers', '/opt/atlassian/pipelines/agent/build/client/app/actions/statistics/users.js');
    reactHotLoader.register(searchStatisticsUsers, 'searchStatisticsUsers', '/opt/atlassian/pipelines/agent/build/client/app/actions/statistics/users.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export connectNewDomainToUser */
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteDomain;
/* harmony export (immutable) */ __webpack_exports__["b"] = getListDomain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function connectNewDomainToUser(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["z" /* CONNECT_NEW_DOMAIN_TO_USER */].REQUEST,
        data: data
    };
}

function deleteDomain(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["P" /* DELETE_DOMAIN */].REQUEST,
        data: data
    };
}

function getListDomain() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_33" /* GET_LIST_DOMAIN */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(connectNewDomainToUser, 'connectNewDomainToUser', '/opt/atlassian/pipelines/agent/build/client/app/actions/domains.js');
    reactHotLoader.register(deleteDomain, 'deleteDomain', '/opt/atlassian/pipelines/agent/build/client/app/actions/domains.js');
    reactHotLoader.register(getListDomain, 'getListDomain', '/opt/atlassian/pipelines/agent/build/client/app/actions/domains.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Base_region__ = __webpack_require__(393);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Region = function (_BaseRegion) {
  _inherits(Region, _BaseRegion);

  function Region() {
    _classCallCheck(this, Region);

    return _possibleConstructorReturn(this, (Region.__proto__ || Object.getPrototypeOf(Region)).apply(this, arguments));
  }

  _createClass(Region, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          _state$data = _state.data,
          region = _state$data.region,
          dwtGroup = _state$data.dwtGroup,
          _state$unfold = _state.unfold,
          unfold = _state$unfold === undefined ? true : _state$unfold,
          errors = _state.errors,
          askingForSaveWWR = _state.askingForSaveWWR;
      var _props = this.props,
          dwtGroups = _props.dwtGroups,
          tcRates = _props.tcRates;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
        { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
          {
            title: 'Are you sure?',
            actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
              label: 'Ok',
              primary: true,
              onClick: function onClick() {
                _this2.save();
                _this2.toggleState('askingForSaveWWR');
              }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
              label: 'Cancel',
              primary: true,
              onClick: function onClick() {
                return _this2.toggleState('askingForSaveWWR');
              }
            })],
            open: askingForSaveWWR,
            autoScrollBodyContent: true,
            modal: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Are you sure you want to save wwr region? All other regions will be recalculated'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
          { style: { width: '20%' } },
          unfold ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              region.name || 'no name'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu___default.a,
              {
                value: 'askForSave',
                style: { padding: 0 },
                onChange: function onChange(e, key, handler) {
                  return _this2[handler]();
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'askForSave', primaryText: 'save' }),
              !this.isWWR() && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'recalculate', primaryText: 'recalculate', key: 1 }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'remove', primaryText: 'remove', key: 2 })]
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            {
              onClick: this.toggleUnfold,
              style: { cursor: 'pointer' }
            },
            region.name || 'no name'
          )
        ),
        unfold ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
            { style: { width: '20%', padding: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroups).map(function (key, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                    { key: 'dwt-group-name-' + i },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                      null,
                      dwtGroups[key]
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
            { style: { width: '10%', padding: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroup).map(function (key, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                    { key: 'dwt-group-percent-' + i },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                        value: dwtGroup[key].percentToWW,
                        hintText: '0',
                        onChange: function onChange(e, value) {
                          return _this2.handleChange([{ key: 'dwtGroup.' + key + '.percentToWW', value: value }]);
                        },
                        fullWidth: true,
                        errorText: errors['dwtGroup.' + key + '.percentToWW'] ? 'required' : '',
                        disabled: _this2.isWWR()
                      })
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
            { style: { width: '50%', padding: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroup).map(function (key, j) {
                  var markEditedByUser = dwtGroup[key].tcRatesDay.editedByUser ? {
                    underlineFocusStyle: { borderColor: __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__["orange500"] },
                    underlineStyle: { borderColor: __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__["orange500"] }
                  } : {};

                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                    { key: 'tc-rate-' + j },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, _extends({
                        value: dwtGroup[key].tcRatesDay.value,
                        hintText: '0',
                        onChange: function onChange(e, value) {
                          var changes = [{ key: 'dwtGroup.' + key + '.tcRatesDay.value', value: value }];
                          if (!dwtGroup[key].tcRatesDay.editedByUser) {
                            changes.push({ key: 'dwtGroup.' + key + '.tcRatesDay.editedByUser', value: true, noError: true });
                          }
                          _this2.handleChange(changes);
                        },
                        fullWidth: true,
                        errorText: errors['dwtGroup.' + key + '.tcRatesDay.value'] ? 'required' : ''
                      }, markEditedByUser))
                    )
                  );
                })
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"], { style: { width: '20%', padding: 0 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"], { style: { width: '10%', padding: 0 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"], { style: { width: '50%', padding: 0 } })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Region;
}(__WEBPACK_IMPORTED_MODULE_9__Base_region__["default"]);

var _default = Region;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Region, 'Region', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Bulk/region.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Bulk/region.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Base_region__ = __webpack_require__(393);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Region = function (_BaseRegion) {
  _inherits(Region, _BaseRegion);

  function Region() {
    _classCallCheck(this, Region);

    return _possibleConstructorReturn(this, (Region.__proto__ || Object.getPrototypeOf(Region)).apply(this, arguments));
  }

  _createClass(Region, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          _state$data = _state.data,
          region = _state$data.region,
          dwtGroup = _state$data.dwtGroup,
          _state$unfold = _state.unfold,
          unfold = _state$unfold === undefined ? true : _state$unfold,
          errors = _state.errors,
          askingForSaveWWR = _state.askingForSaveWWR;
      var _props = this.props,
          dwtGroups = _props.dwtGroups,
          tcRates = _props.tcRates;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
        { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
          {
            title: 'Are you sure?',
            actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
              label: 'Ok',
              primary: true,
              onClick: function onClick() {
                _this2.save();
                _this2.toggleState('askingForSaveWWR');
              }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
              label: 'Cancel',
              primary: true,
              onClick: function onClick() {
                return _this2.toggleState('askingForSaveWWR');
              }
            })],
            open: askingForSaveWWR,
            autoScrollBodyContent: true,
            modal: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Are you sure you want to save wwr region? All other regions will be recalculated'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
          { style: { width: '20%' } },
          unfold ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              region.name || 'no name'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_material_ui_DropDownMenu___default.a,
              {
                value: 'askForSave',
                style: { padding: 0 },
                onChange: function onChange(e, key, handler) {
                  return _this2[handler]();
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'askForSave', primaryText: 'save' }),
              !this.isWWR() && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'recalculate', primaryText: 'recalculate', key: 1 }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'remove', primaryText: 'remove', key: 2 })]
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            {
              onClick: this.toggleUnfold,
              style: { cursor: 'pointer' }
            },
            region.name || 'no name'
          )
        ),
        unfold ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
            { style: { width: '20%', padding: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroups).map(function (key, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                    { key: 'dwt-group-name-' + i },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                      null,
                      dwtGroups[key]
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
            { style: { width: '10%', padding: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroup).map(function (key, i) {
                  return key === '_id' ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                    { key: 'dwt-group-percent-' + i },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                        value: dwtGroup[key].percentToWW,
                        hintText: '0',
                        onChange: function onChange(e, value) {
                          return _this2.handleChange([{ key: 'dwtGroup.' + key + '.percentToWW', value: value }]);
                        },
                        fullWidth: true,
                        errorText: errors['dwtGroup.' + key + '.percentToWW'] ? 'required' : '',
                        disabled: _this2.isWWR()
                      })
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
            { style: { width: '50%', padding: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                  null,
                  tcRates.map(function (rate, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                      { style: { padding: 0 }, key: 'region-' + i },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                          { displayRowCheckbox: false },
                          Object.keys(dwtGroup).map(function (key, j) {
                            var markEditedByUser = dwtGroup[key][rate].editedByUser ? {
                              underlineFocusStyle: { borderColor: __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__["orange500"] },
                              underlineStyle: { borderColor: __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_colors__["orange500"] }
                            } : {};

                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                              { key: 'tc-rate-' + i + '-' + j },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, _extends({
                                  value: dwtGroup[key][rate].value,
                                  hintText: '0',
                                  onChange: function onChange(e, value) {
                                    var changes = [{ key: 'dwtGroup.' + key + '.' + rate + '.value', value: value }];
                                    if (!dwtGroup[key][rate].editedByUser) {
                                      changes.push({ key: 'dwtGroup.' + key + '.' + rate + '.editedByUser', value: true, noError: true });
                                    }
                                    _this2.handleChange(changes);
                                  },
                                  fullWidth: true,
                                  errorText: errors['dwtGroup.' + key + '.' + rate + '.value'] ? 'required' : ''
                                }, markEditedByUser))
                              )
                            );
                          })
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"], { style: { width: '20%', padding: 0 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"], { style: { width: '10%', padding: 0 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"], { style: { width: '50%', padding: 0 } })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Region;
}(__WEBPACK_IMPORTED_MODULE_9__Base_region__["default"]);

var _default = Region;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Region, 'Region', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Mpp/region.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Mpp/region.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_tc_requests__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Base_Mails_OpenMailBlock__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sagas_orders__ = __webpack_require__(163);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TcRequestsItem = function (_React$PureComponent) {
    _inherits(TcRequestsItem, _React$PureComponent);

    function TcRequestsItem() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, TcRequestsItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TcRequestsItem.__proto__ || Object.getPrototypeOf(TcRequestsItem)).call.apply(_ref, [this].concat(args))), _this), _this.saveRequestsDataDeleted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return Object(__WEBPACK_IMPORTED_MODULE_7_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_8_sagas_orders__["b" /* saveRequestsDataDeleted */], 'tc', { mailId: _this.props.item.mailId });

                        case 3:
                            _context.next = 8;
                            break;

                        case 5:
                            _context.prev = 5;
                            _context.t0 = _context['catch'](0);

                            console.error(_context.t0);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 5]]);
        })), _this.deleteCargoRequest = function () {
            _this.props.item.mailId && _this.saveRequestsDataDeleted();
            _this.props.deleteRequestTC(_this.props.item._id);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TcRequestsItem, [{
        key: 'render',
        value: function render() {
            var item = this.props.item;


            var managementBlock = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'paper-block' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'name-block absolute small-name' },
                    'Managment'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["r" /* RaisedButton */], {
                    onClick: this.deleteCargoRequest,
                    label: 'Delete',
                    style: { margin: '0 10px 0 0' },
                    secondary: true
                })
            );

            if (this.props.item.deleteBy) {
                managementBlock = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Deleted'
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'span',
                        null,
                        'Delete at: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.deleteAt).format('MM-DD-YYYY'),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'span',
                        null,
                        'Delete by: '
                    ),
                    item.deleteBy.email
                );
            }

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'paper-block item-request' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'unique info'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'refNo: '
                        ),
                        item.refNo
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Delivery'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Delivery port: '
                        ),
                        item.deliveryPlaces[0].port ? item.deliveryPlaces[0].port.name : '',
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Readiness Date: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.readinessDate).startOf('day').toDate().toLocaleDateString(),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Cancelling Date: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.cancellingDate).startOf('day').toDate().toLocaleDateString(),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Redelivery'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Redelivery Port: '
                        ),
                        item.redeliveryPlaces[0] && item.redeliveryPlaces[0].port ? item.redeliveryPlaces[0].port.name : '---',
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'cargo'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Cargo included: '
                        ),
                        item.cargo.included[0] && item.cargo.included[0].cargo && item.cargo.included[0].cargo.name,
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Cargo excluded: '
                        ),
                        item.cargo.excluded[0] && item.cargo.excluded[0].cargo && item.cargo.excluded[0].cargo.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Company'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        item.context.company && item.context.company.name
                    ),
                    item.account && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Account'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        item.account.name
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'User'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        item.context.user.name,
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Surname: '
                        ),
                        item.context.user.surname,
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null)
                    ),
                    item.realUser && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Real user'
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'span',
                            null,
                            'Email: '
                        ),
                        item.realUser.email,
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br', null)
                    ),
                    managementBlock,
                    item.mailId && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Base_Mails_OpenMailBlock__["a" /* default */], { mailId: item.mailId })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TcRequestsItem;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        deleteRequestTC: __WEBPACK_IMPORTED_MODULE_3_actions_tc_requests__["a" /* deleteRequestTC */]
    }, dispatch);
})(TcRequestsItem);

/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TcRequestsItem, 'TcRequestsItem', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = postRequestTC;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRequestsTC;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteRequestTC;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postRequestTC(tcRequest, index) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_72" /* POST_TC_REQUEST */].REQUEST,
        tcRequest: tcRequest,
        index: index
    };
}

function getRequestsTC(filter) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_51" /* GET_TC_REQUESTS */].REQUEST,
        filter: filter
    };
}

function deleteRequestTC(tcRequestId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Y" /* DELETE_TC_REQUEST */].REQUEST,
        tcRequestId: tcRequestId
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestTC, 'postRequestTC', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/requests.js');
    reactHotLoader.register(getRequestsTC, 'getRequestsTC', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/requests.js');
    reactHotLoader.register(deleteRequestTC, 'deleteRequestTC', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_tc_requests__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Base_EhSelector___ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Item__ = __webpack_require__(574);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var styles = {
    radioGroup: {
        margin: '20px 0'
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%'
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

var getDefaultState = function getDefaultState() {
    return {
        search: null,
        eh: [],
        delivery: {
            _id: null,
            name: null
        },
        redelivery: {
            _id: null,
            name: null
        },
        deliveryList: [],
        redeliveryList: [],
        readinessDate: null,
        cancellingDate: null,
        page: 1,
        limit: 50
    };
};

var TCRequestsList = function (_React$PureComponent) {
    _inherits(TCRequestsList, _React$PureComponent);

    function TCRequestsList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TCRequestsList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TCRequestsList.__proto__ || Object.getPrototypeOf(TCRequestsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = getDefaultState(), _this.changeField = function (field, value) {
            _this.setState(_defineProperty({}, field, value || null));
        }, _this.handleEhChange = function (eh) {
            _this.setState(_extends({}, _this.state, {
                eh: eh
            }));
        }, _this.onChangeAutoComplete = function (type, searchText) {
            _this.setState(_defineProperty({}, type, { name: searchText }));

            if (searchText.length <= 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findPortAdmin({ name: searchText, withAreas: true }).then(function (response) {
                var portsList = [];
                response.data.data.forEach(function (port) {
                    if (port.sub) {
                        port.sub.forEach(function (subPort) {
                            portsList.push({
                                name: subPort.name + ' - country ' + port.country.name,
                                item: subPort
                            });
                        });
                    }

                    var name = '';
                    if (port.country) {
                        name = port.name + ' - country ' + port.country.name;
                    } else {
                        name = port.name;
                    }

                    portsList.push({
                        name: name,
                        item: port
                    });
                });

                _this.setState(_defineProperty({}, type + 'List', portsList));
            }).catch(function () {
                return null;
            });
        }, _this.onChooseAutoComplete = function (type, updateProperties) {
            if (!updateProperties) {
                return;
            }

            _this.setState(_defineProperty({}, '' + type, {
                _id: updateProperties.item._id,
                name: updateProperties.name
            }));
        }, _this.updateRows = function () {
            var _this$state = _this.state,
                page = _this$state.page,
                limit = _this$state.limit,
                _this$state$readiness = _this$state.readinessDate,
                readinessDate = _this$state$readiness === undefined ? undefined : _this$state$readiness,
                _this$state$cancellin = _this$state.cancellingDate,
                cancellingDate = _this$state$cancellin === undefined ? undefined : _this$state$cancellin,
                _this$state$delivery = _this$state.delivery,
                delivery = _this$state$delivery === undefined ? undefined : _this$state$delivery,
                _this$state$redeliver = _this$state.redelivery,
                redelivery = _this$state$redeliver === undefined ? undefined : _this$state$redeliver,
                eh = _this$state.eh,
                _this$state$search = _this$state.search,
                search = _this$state$search === undefined ? undefined : _this$state$search;


            var fromPublicMailParsers = [];
            var fromNonPublicMailParsers = [];

            eh.forEach(function (item) {
                switch (item) {
                    case 'fix':
                    case 'varamar':
                        fromPublicMailParsers.push(item + '@shipnext.com');
                        break;
                    case 'broker':
                    case 'api':
                        fromNonPublicMailParsers.push(item);
                    default:
                        break;
                }
            });

            _this.props.getRequestsTC({
                page: page,
                limit: limit,
                filters: {
                    search: search || undefined,
                    eh: eh,
                    fromPublicMailParsers: fromPublicMailParsers,
                    fromNonPublicMailParsers: fromNonPublicMailParsers,
                    readinessDate: readinessDate,
                    cancellingDate: cancellingDate,
                    delivery: delivery && delivery._id,
                    redelivery: redelivery && redelivery._id
                }
            });
        }, _this.handleSearch = function () {
            _this.setState({
                page: 1
            }, function () {
                _this.updateRows();
            });
        }, _this.prevPage = function () {
            _this.setState({
                page: _this.props.tcRequestsResponse.previous
            }, function () {
                _this.updateRows();
            });
        }, _this.nextPage = function () {
            _this.setState({
                page: _this.props.tcRequestsResponse.next
            }, function () {
                _this.updateRows();
            });
        }, _this.handleClearFilters = function () {
            _this.setState(getDefaultState(), function () {
                _this.updateRows();
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TCRequestsList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getRequestsTC({});
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                search = _state.search,
                delivery = _state.delivery,
                redelivery = _state.redelivery,
                deliveryList = _state.deliveryList,
                redeliveryList = _state.redeliveryList,
                readinessDate = _state.readinessDate,
                cancellingDate = _state.cancellingDate;
            var tcRequests = this.props.tcRequests;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'filter' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'search filter-column', style: { width: '100%', justifyContent: 'space-between' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                                value: search || '',
                                floatingLabelText: 'Search',
                                onChange: function onChange(e, value) {
                                    _this2.changeField('search', value);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Base_EhSelector___["a" /* EhSelector */], { values: this.state.eh, onChange: this.handleEhChange }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { style: { display: 'flex', alignItems: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationLeft,
                                        name: 'navigationLeft',
                                        onClick: this.prevPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'item' },
                                    'Page: ',
                                    this.state.page
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationRight,
                                        name: 'navigationRight',
                                        onClick: this.nextPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default.a, {
                                label: 'Search',
                                style: { fontSize: '13px', margin: '0 0 0 10px' },
                                onClick: this.handleSearch,
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default.a, {
                                label: 'Clear filters',
                                style: { fontSize: '13px', margin: '0 0 0 10px' },
                                onClick: this.handleClearFilters,
                                primary: true
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'filter-column paper-block' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name-block absolute small-name' },
                                'Dates'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui__["e" /* DatePicker */], {
                                onChange: function onChange(e, date) {
                                    _this2.changeField('readinessDate', __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY'));
                                },
                                floatingLabelText: 'readinessDate',
                                formatDate: function formatDate(date) {
                                    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY');
                                },
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },
                                autoOk: true,
                                value: readinessDate && new Date(readinessDate)
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui__["e" /* DatePicker */], {
                                onChange: function onChange(e, date) {
                                    _this2.changeField('cancellingDate', __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY'));
                                },
                                floatingLabelText: 'cancellingDate',
                                formatDate: function formatDate(date) {
                                    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY');
                                },
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },
                                autoOk: true,
                                value: cancellingDate && new Date(cancellingDate),
                                minDate: readinessDate ? new Date(readinessDate) : new Date()
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'filter-column paper-block' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name-block absolute small-name' },
                                'Del / Redel'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui__["a" /* AutoComplete */], {
                                floatingLabelText: 'Delivery port',
                                searchText: delivery.name || '',
                                dataSource: deliveryList,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: function onUpdateInput(val) {
                                    return _this2.onChangeAutoComplete('delivery', val);
                                },
                                onNewRequest: function onNewRequest(val) {
                                    return _this2.onChooseAutoComplete('delivery', val);
                                },
                                filter: __WEBPACK_IMPORTED_MODULE_12_material_ui__["a" /* AutoComplete */].noFilter,
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },

                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui__["a" /* AutoComplete */], {
                                floatingLabelText: 'Redelivery port',
                                searchText: redelivery.name || '',
                                dataSource: redeliveryList,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: function onUpdateInput(val) {
                                    return _this2.onChangeAutoComplete('redelivery', val);
                                },
                                onNewRequest: function onNewRequest(val) {
                                    return _this2.onChooseAutoComplete('redelivery', val);
                                },
                                filter: __WEBPACK_IMPORTED_MODULE_12_material_ui__["a" /* AutoComplete */].noFilter,
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },

                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'list-requests' },
                        tcRequests && tcRequests.map(function (item) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Item__["default"], { key: item._id, item: item });
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TCRequestsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        tcRequests: state.tcRequests.items,
        tcRequestsResponse: state.tcRequests,
        cargoTypes: state.cargoTypes
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getRequestsTC: __WEBPACK_IMPORTED_MODULE_5_actions_tc_requests__["b" /* getRequestsTC */]
    }, dispatch);
})(TCRequestsList);

/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/List.jsx');
    reactHotLoader.register(getDefaultState, 'getDefaultState', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/List.jsx');
    reactHotLoader.register(TCRequestsList, 'TCRequestsList', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(576);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var TimeCharterRequests = function (_React$PureComponent) {
    _inherits(TimeCharterRequests, _React$PureComponent);

    function TimeCharterRequests() {
        _classCallCheck(this, TimeCharterRequests);

        return _possibleConstructorReturn(this, (TimeCharterRequests.__proto__ || Object.getPrototypeOf(TimeCharterRequests)).apply(this, arguments));
    }

    _createClass(TimeCharterRequests, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getCargoTypes();
        }
    }, {
        key: 'render',
        value: function render() {
            var isLoaded = this.props.isLoaded;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'cargo-requests', className: 'requests-page page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default.a, {
                    className: !isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_5_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Timecharter requests'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__List__["default"], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TimeCharterRequests;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var isLoaded = _ref.tcRequests.isLoaded;

    return {
        isLoaded: isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCargoTypes: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_types__["a" /* getCargoTypes */]
    }, dispatch);
})(TimeCharterRequests);

/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TimeCharterRequests, 'TimeCharterRequests', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TimeCharter/Requests/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128312
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TcIndexPage__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__ = __webpack_require__(41);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








var NotificationContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);

function TcIndex(_ref) {
    var addNotification = _ref.addNotification;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Tc Hire Idea'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                NotificationContext.Provider,
                { value: addNotification },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TcIndexPage__["h" /* default */], null)
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(TcIndex);

/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(NotificationContext, 'NotificationContext', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndex.jsx');
    reactHotLoader.register(TcIndex, 'TcIndex', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndex.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndex.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = isValidUuid;
/* harmony export (immutable) */ __webpack_exports__["b"] = postRegularForm;
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function isValidUuid(uuid) {
    return (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(uuid)
    );
}

function postRegularForm(url, data) {
    var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_blank';

    var form = document.createElement('form');
    var input = document.createElement('input');
    form.name = 'form' + Math.random();
    form.method = 'POST';
    form.target = target;
    form.action = url;
    input.type = 'hidden';
    input.name = 'data';
    input.value = JSON.stringify(data);
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    form.remove();
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(isValidUuid, 'isValidUuid', '/opt/atlassian/pipelines/agent/build/client/app/helpers/miscellaneous.js');
    reactHotLoader.register(postRegularForm, 'postRegularForm', '/opt/atlassian/pipelines/agent/build/client/app/helpers/miscellaneous.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = getIssues;
/* harmony export (immutable) */ __webpack_exports__["c"] = getIssue;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateIssueStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = addIssueComment;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateIssueComment;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteIssueComment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getIssues(pagination) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_30" /* GET_ISSUES */].REQUEST,
        pagination: pagination
    };
}

function getIssue(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_29" /* GET_ISSUE */].REQUEST,
        id: id
    };
}

function updateIssueStatus(id, status) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].REQUEST,
        id: id,
        status: status
    };
}

function addIssueComment(id, data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].REQUEST,
        id: id,
        data: data
    };
}

function updateIssueComment(id, commentId, data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].REQUEST,
        id: id,
        commentId: commentId,
        data: data
    };
}

function deleteIssueComment(id, commentId) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].REQUEST,
        id: id,
        commentId: commentId
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getIssues, 'getIssues', '/opt/atlassian/pipelines/agent/build/client/app/actions/issues.js');
    reactHotLoader.register(getIssue, 'getIssue', '/opt/atlassian/pipelines/agent/build/client/app/actions/issues.js');
    reactHotLoader.register(updateIssueStatus, 'updateIssueStatus', '/opt/atlassian/pipelines/agent/build/client/app/actions/issues.js');
    reactHotLoader.register(addIssueComment, 'addIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/actions/issues.js');
    reactHotLoader.register(updateIssueComment, 'updateIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/actions/issues.js');
    reactHotLoader.register(deleteIssueComment, 'deleteIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/actions/issues.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return statuses; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Status;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * @type {Object.<string, React.CSSProperties>}
 */
var commonChipStyle = {
    style: {
        cursor: 'pointer'
    },
    labelStyle: {
        fontSize: '12px',
        lineHeight: '20px'
    }
};

var statuses = {
    new: {
        chip: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
            { style: _extends({ backgroundColor: '#82C3FF' }, commonChipStyle.style), labelStyle: commonChipStyle.labelStyle },
            'New'
        )
    },
    confirmed: {
        chip: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
            { style: _extends({ backgroundColor: '#7ADCCA' }, commonChipStyle.style), labelStyle: commonChipStyle.labelStyle },
            'Confirmed'
        )
    },
    inProgress: {
        chip: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
            { style: _extends({ backgroundColor: '#F8BF50' }, commonChipStyle.style), labelStyle: commonChipStyle.labelStyle },
            'In progress'
        )
    },
    fixed: {
        chip: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
            { style: _extends({ backgroundColor: '#75C422' }, commonChipStyle.style), labelStyle: commonChipStyle.labelStyle },
            'Fixed'
        )
    },
    notBug: {
        chip: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
            { style: _extends({ backgroundColor: '#C9CEF7' }, commonChipStyle.style), labelStyle: commonChipStyle.labelStyle },
            'Not bug'
        )
    }
};

function Status(_ref) {
    var status = _ref.status,
        handleChangeStatus = _ref.handleChangeStatus,
        props = _objectWithoutProperties(_ref, ['status', 'handleChangeStatus']);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(status),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setValue(status);
    }, [status]);

    var handleChange = function handleChange(_e, _i, v) {
        if (status === v) return;
        handleChangeStatus(v);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
            style: _extends({ height: '28px' }, props.style || {}),
            className: props.className || ''
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
            {
                value: value,
                selectionRenderer: function selectionRenderer(value) {
                    return statuses[value].chip;
                },
                onChange: handleChange,
                iconStyle: {
                    height: '24px',
                    width: '24px',
                    padding: 0,
                    top: '-4px'
                },
                style: {
                    height: '28px',
                    width: '164px',
                    lineHeight: '24px',
                    position: 'relative',
                    textAlign: 'center',
                    marginTop: '2px'
                },
                menuStyle: {
                    position: 'absolute'
                },
                underlineStyle: {
                    position: 'relative',
                    top: '21px'
                },
                listStyle: {
                    padding: '4px 0'
                },
                menuItemStyle: {
                    padding: 'auto 0'
                }
            },
            Object.entries(statuses).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,
                    {
                        key: key,
                        value: key,
                        style: {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    },
                    value.chip
                );
            })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(commonChipStyle, 'commonChipStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/Status.jsx');
    reactHotLoader.register(statuses, 'statuses', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/Status.jsx');
    reactHotLoader.register(Status, 'Status', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/Status.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(65) && !__webpack_require__(47)(function () {
  return Object.defineProperty(__webpack_require__(401)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(59);


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(92);
var toIObject = __webpack_require__(93);
var arrayIndexOf = __webpack_require__(294)(false);
var IE_PROTO = __webpack_require__(403)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(66);
var anObject = __webpack_require__(37);
var getKeys = __webpack_require__(172);

module.exports = __webpack_require__(65) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(93);
var gOPN = __webpack_require__(175).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(172);
var gOPS = __webpack_require__(295);
var pIE = __webpack_require__(245);
var toObject = __webpack_require__(68);
var IObject = __webpack_require__(244);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(47)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(76);
var isObject = __webpack_require__(48);
var invoke = __webpack_require__(591);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(42).parseInt;
var $trim = __webpack_require__(209).trim;
var ws = __webpack_require__(407);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(42).parseFloat;
var $trim = __webpack_require__(209).trim;

module.exports = 1 / $parseFloat(__webpack_require__(407) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(109);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(48);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 596 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(410);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(37);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(76);
var toObject = __webpack_require__(68);
var IObject = __webpack_require__(244);
var toLength = __webpack_require__(60);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(68);
var toAbsoluteIndex = __webpack_require__(173);
var toLength = __webpack_require__(60);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(422);
__webpack_require__(12)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(65) && /./g.flags != 'g') __webpack_require__(66).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(246)
});


/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(37);
var isObject = __webpack_require__(48);
var newPromiseCapability = __webpack_require__(426);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(607);
var validate = __webpack_require__(211);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(303)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(66).f;
var create = __webpack_require__(174);
var redefineAll = __webpack_require__(179);
var ctx = __webpack_require__(108);
var anInstance = __webpack_require__(177);
var forOf = __webpack_require__(178);
var $iterDefine = __webpack_require__(412);
var step = __webpack_require__(601);
var setSpecies = __webpack_require__(176);
var DESCRIPTORS = __webpack_require__(65);
var fastKey = __webpack_require__(147).fastKey;
var validate = __webpack_require__(211);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(607);
var validate = __webpack_require__(211);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(303)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(121)(0);
var redefine = __webpack_require__(87);
var meta = __webpack_require__(147);
var assign = __webpack_require__(588);
var weak = __webpack_require__(610);
var isObject = __webpack_require__(48);
var fails = __webpack_require__(47);
var validate = __webpack_require__(211);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(303)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(179);
var getWeak = __webpack_require__(147).getWeak;
var anObject = __webpack_require__(37);
var isObject = __webpack_require__(48);
var anInstance = __webpack_require__(177);
var forOf = __webpack_require__(178);
var createArrayMethod = __webpack_require__(121);
var $has = __webpack_require__(92);
var validate = __webpack_require__(211);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(110);
var toLength = __webpack_require__(60);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(175);
var gOPS = __webpack_require__(295);
var anObject = __webpack_require__(37);
var Reflect = __webpack_require__(42).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(296);
var isObject = __webpack_require__(48);
var toLength = __webpack_require__(60);
var ctx = __webpack_require__(108);
var IS_CONCAT_SPREADABLE = __webpack_require__(59)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(60);
var repeat = __webpack_require__(409);
var defined = __webpack_require__(119);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(172);
var toIObject = __webpack_require__(93);
var isEnum = __webpack_require__(245).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(208);
var from = __webpack_require__(617);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(178);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 618 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(619);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(431);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(80)))

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(624);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(628);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(428);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(1233);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(434);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(248);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(1241);

var _runTransitionHook = __webpack_require__(436);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(215);

var _PathUtils = __webpack_require__(151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(436);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(637);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getMuiTheme = __webpack_require__(1285);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MuiThemeProvider = function (_Component) {
  (0, _inherits3.default)(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.Component);

MuiThemeProvider.childContextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MuiThemeProvider.propTypes =  false ? {
  children: _propTypes2.default.element,
  muiTheme: _propTypes2.default.object
} : {};
exports.default = MuiThemeProvider;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(182);
var toObject = __webpack_require__(249);
var IE_PROTO = __webpack_require__(441)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(184) && !__webpack_require__(218)(function () {
  return Object.defineProperty(__webpack_require__(643)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(217);
var document = __webpack_require__(152).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1255), __esModule: true };

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(311);
var $export = __webpack_require__(153);
var redefine = __webpack_require__(646);
var hide = __webpack_require__(216);
var Iterators = __webpack_require__(219);
var $iterCreate = __webpack_require__(1260);
var setToStringTag = __webpack_require__(450);
var getPrototypeOf = __webpack_require__(641);
var ITERATOR = __webpack_require__(112)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(216);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(182);
var toIObject = __webpack_require__(185);
var arrayIndexOf = __webpack_require__(1262)(false);
var IE_PROTO = __webpack_require__(441)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(448);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(446);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(647);
var hiddenKeys = __webpack_require__(449).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1286), __esModule: true };

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(653);
var ITERATOR = __webpack_require__(112)('iterator');
var Iterators = __webpack_require__(219);
module.exports = __webpack_require__(73).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(448);
var TAG = __webpack_require__(112)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(1312);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(659);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(660);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1327);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1328);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(663);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(315);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);
var settle = __webpack_require__(1344);
var buildURL = __webpack_require__(1346);
var parseHeaders = __webpack_require__(1347);
var isURLSameOrigin = __webpack_require__(1348);
var createError = __webpack_require__(667);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1349);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1350);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1345);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(461),
    toKey = __webpack_require__(257);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(463);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1383);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["f"] = getAreas;
/* harmony export (immutable) */ __webpack_exports__["d"] = getArea;
/* harmony export (immutable) */ __webpack_exports__["k"] = updateArea;
/* harmony export (immutable) */ __webpack_exports__["j"] = transformAreaToPort;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateAreaAlt;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteArea;
/* harmony export (immutable) */ __webpack_exports__["b"] = createArea;
/* harmony export (immutable) */ __webpack_exports__["i"] = mergeAreaToArea;
/* harmony export (immutable) */ __webpack_exports__["h"] = joinAreaToArea;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAreaRelations;
/* harmony export (immutable) */ __webpack_exports__["a"] = addAreaToArea;
/* harmony export (immutable) */ __webpack_exports__["g"] = getAreasAtPoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getAreas() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/ports/areas',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function getArea(areaId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/ports/areas/' + areaId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    });
}

function updateArea(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/areas/' + item._id,
        withCredentials: true,
        data: _extends({}, item)
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function transformAreaToPort(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/areas/' + id + '/transform',
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateAreaAlt(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/' + item._id + '/alt',
        data: {
            alt: item.alt
        },
        withCredentials: true
    }).then(function (response) {
        return _extends({}, response.data, {
            item: item
        });
    }) // todo sending response.response
    .catch(function (response) {
        return _extends({}, response.response.data, {
            item: item
        });
    });
}

function deleteArea(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/ports/areas/' + item._id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function createArea(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/ports/areas/',
        withCredentials: true,
        data: _extends({}, item)
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function mergeAreaToArea(areaId, mergeId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/areas/' + areaId + '/merge',
        withCredentials: true,
        data: {
            mergeId: mergeId
        }
    });
}

function joinAreaToArea(mergeId, areaId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/areas/' + areaId + '/join',
        withCredentials: true,
        data: {
            mergeId: mergeId
        }
    });
}

function getAreaRelations(areaId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/ports/areas/' + areaId + '?withTree=true',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function addAreaToArea(areaParentId, areaToAdd) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/areas/' + areaParentId,
        withCredentials: true,
        data: _extends({}, areaToAdd, {
            recalculateChildPorts: true
        })
    });
}

/** @param {[number, number]} lnglat Longitude, latitude */
function getAreasAtPoint(lnglat) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/areas-at-point/' + lnglat[0] + '/' + lnglat[1],
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getAreas, 'getAreas', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(getArea, 'getArea', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(updateArea, 'updateArea', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(transformAreaToPort, 'transformAreaToPort', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(updateAreaAlt, 'updateAreaAlt', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(deleteArea, 'deleteArea', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(createArea, 'createArea', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(mergeAreaToArea, 'mergeAreaToArea', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(joinAreaToArea, 'joinAreaToArea', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(getAreaRelations, 'getAreaRelations', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(addAreaToArea, 'addAreaToArea', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    reactHotLoader.register(getAreasAtPoint, 'getAreasAtPoint', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/areas.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCargoByNameOrType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCargoNamesMatches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



function getCargoByNameOrType(_ref) {
    var _ref$name = _ref.name,
        name = _ref$name === undefined ? undefined : _ref$name,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? undefined : _ref$type;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/cargo/find',
        withCredentials: true,
        data: {
            name: name,
            type: type
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

/**
 * @param {string[]} names 
 */
var getCargoNamesMatches = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'POST',
                            url: '/api/v2/names-matcher/cargo-names',
                            withCredentials: true,
                            data: {
                                names: names
                            }
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getCargoNamesMatches() {
        return _ref2.apply(this, arguments);
    };
}();
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoByNameOrType, 'getCargoByNameOrType', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/names.js');
    reactHotLoader.register(getCargoNamesMatches, 'getCargoNamesMatches', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/names.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["g"] = sendLetterToArchive;
/* harmony export (immutable) */ __webpack_exports__["h"] = sendRefNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = getLetters;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLetter;
/* harmony export (immutable) */ __webpack_exports__["j"] = updateLetter;
/* unused harmony export sendEmailsFailedToNew */
/* harmony export (immutable) */ __webpack_exports__["f"] = sendEmailsToNew;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveEmailsToDev;
/* harmony export (immutable) */ __webpack_exports__["i"] = sendToRabbit;
/* harmony export (immutable) */ __webpack_exports__["d"] = saveAsSpam;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchPredictorType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function sendLetterToArchive(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/mails/mail/' + id + '/archive',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function sendRefNumber(id, _ref) {
    var refNo = _ref.refNo,
        requestId = _ref.requestId;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/mails/mail/' + id,
        data: {
            refNo: refNo,
            requestId: requestId
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getLetters(pagination) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/mails' + (pagination.archive ? '/archiveLetters' : ''),
        withCredentials: true,
        params: {
            eh: pagination.eh,
            page: pagination.page,
            limit: pagination.limit,
            search: pagination.search,
            typeMail: pagination.typeMail,
            statusMail: pagination.statusMail,
            withAttachments: pagination.withAttachments,
            dateStart: pagination.dateStart,
            dateEnd: pagination.dateEnd,
            brokerMails: pagination.brokerMails,
            listeners: pagination.listeners,
            showUniqueBrokerMails: pagination.showUniqueBrokerMails,
            isNosa: pagination.isNosa
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getLetter(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/mails/mail/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateLetter(letter) {
    var server = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var urlServer = server === 'standart' || server === '' ? '' : 'http://' + server;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: urlServer + '/api/v1/mails/update/' + letter._id,
        data: letter,
        // withCredentials: urlServer !== '',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response ? response.response.data : response;
    });
}

function sendEmailsFailedToNew(failedEmailsAmount, total) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'patch',
        url: '/api/v1/mails/failedToNew',
        data: {
            amount: failedEmailsAmount,
            total: total
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response ? response.response.data : response;
    });
}

function sendEmailsToNew(emailsAmount, emailStatus, total) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'patch',
        url: '/api/v1/mails/emailsToNew',
        data: {
            amount: emailsAmount,
            total: total,
            emailStatus: emailStatus
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response ? response.response.data : response;
    });
}

function saveEmailsToDev(emailsStatus, emailsAmount) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/mails/saveMultipleToDev',
        data: {
            emailsStatus: emailsStatus,
            amount: emailsAmount
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response ? response.response.data : response;
    });
}

function sendToRabbit(idsArr) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'patch',
        url: '/api/v1/mails/emailsToNew',
        data: {
            idsArr: idsArr
        },
        withCredentials: true
    }).then(function (respose) {
        return respose.data;
    }).catch(function (response) {
        return response.response ? response.response.data : response;
    });
}

function saveAsSpam(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/mails/markSpam/' + id
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function fetchPredictorType(mailData) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/mails/predictor-type',
        data: mailData
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sendLetterToArchive, 'sendLetterToArchive', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(sendRefNumber, 'sendRefNumber', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(getLetters, 'getLetters', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(getLetter, 'getLetter', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(updateLetter, 'updateLetter', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(sendEmailsFailedToNew, 'sendEmailsFailedToNew', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(sendEmailsToNew, 'sendEmailsToNew', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(saveEmailsToDev, 'saveEmailsToDev', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(sendToRabbit, 'sendToRabbit', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(saveAsSpam, 'saveAsSpam', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    reactHotLoader.register(fetchPredictorType, 'fetchPredictorType', '/opt/atlassian/pipelines/agent/build/client/app/services/letters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getNationalities;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getNationalities(query) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v2/nationalities?q=' + encodeURIComponent(query),
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getNationalities, 'getNationalities', '/opt/atlassian/pipelines/agent/build/client/app/services/nationalities.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = getPredefinedIndexes;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTcHireIdeas;
/* harmony export (immutable) */ __webpack_exports__["f"] = getVesselDwtTypes;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveHireIdea;
/* harmony export (immutable) */ __webpack_exports__["h"] = rejectHireIdea;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateHireIdea;
/* harmony export (immutable) */ __webpack_exports__["g"] = getVias;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPortMainRegion;
/* harmony export (immutable) */ __webpack_exports__["b"] = exportTcIndexes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getPredefinedIndexes() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/adminPanel/tcIndex/predefinedIndexes',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getTcHireIdeas() {
    var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex/find',
        withCredentials: true,
        data: filter
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getVesselDwtTypes() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/vessels/vesselDwtTypes',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function approveHireIdea(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex/' + id + '/confirm',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function rejectHireIdea(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex/' + id + '/reject',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateHireIdea(opts) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex',
        withCredentials: true,
        data: {
            delete: opts.delete || [],
            update: opts.update || []
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getVias() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/vessels/via',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getPortMainRegion(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/adminPanel/tcIndex/portGlobalArea/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function exportTcIndexes() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/tcIndex/export',
        withCredentials: true,
        data: filters
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getPredefinedIndexes, 'getPredefinedIndexes', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(getTcHireIdeas, 'getTcHireIdeas', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(getVesselDwtTypes, 'getVesselDwtTypes', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(approveHireIdea, 'approveHireIdea', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(rejectHireIdea, 'rejectHireIdea', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(updateHireIdea, 'updateHireIdea', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(getVias, 'getVias', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(getPortMainRegion, 'getPortMainRegion', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    reactHotLoader.register(exportTcIndexes, 'exportTcIndexes', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/indexes.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hsCodeFind; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/**
 * @param {string} text
 */
// eslint-disable-next-line import/prefer-default-export
var hsCodeFind = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(text) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'post',
                            url: '/api/v2/hsCodes/find',
                            withCredentials: true,
                            data: {
                                text: text
                            }
                        });

                    case 3:
                        response = _context.sent;
                        return _context.abrupt('return', response.data.data);

                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context['catch'](0);
                        return _context.abrupt('return', _context.t0.response);

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[0, 7]]);
    }));

    return function hsCodeFind(_x) {
        return _ref.apply(this, arguments);
    };
}();
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(hsCodeFind, 'hsCodeFind', '/opt/atlassian/pipelines/agent/build/client/app/services/hsCodes.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(24)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(24)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(24)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(24)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(24)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createVesselOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_vessels_orders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_order_json__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_order_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_order_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(467);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createVesselOrders);

/* eslint-disable require-yield */







function fillAndCreateVesselOrders(clarified) {
    var items = [];

    clarified.forEach(function (item) {
        if (item.mVOpen) {
            var openPositions = item.mVOpen.map(function (openPosition) {
                var open = __WEBPACK_IMPORTED_MODULE_3_moment___default()(openPosition.open).utc().startOf('day').toDate();
                var close = __WEBPACK_IMPORTED_MODULE_3_moment___default()(openPosition.close).utc().startOf('day').toDate();

                var currentDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day').toDate();

                var from = open;
                var until = close;

                var fromOld = '';
                var untilOld = '';

                if (open < currentDate) {
                    from = currentDate;
                    fromOld = open;
                }

                if (close < currentDate) {
                    until = currentDate;
                    untilOld = close;
                }

                return {
                    namePort: openPosition.name,
                    where: openPosition.where ? openPosition.where.id : '',
                    from: from,
                    until: until,
                    fromOld: fromOld,
                    untilOld: untilOld
                };
            });

            items.push(_extends({}, __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_order_json___default.a, {
                open: openPositions,
                vesselName: item.mv.name,
                vessel: item.mv._id,
                imoNumber: item.mv.imoNumber,
                DWT: item.mv.dw ? item.mv.dw.summer : null,
                BLT: item.mv.blt,
                maintenance: item.maintenance,
                disponentOwner: item.mv.disponentOwner,
                warnings: item.warnings,
                failedTwinsByTextHash: item.failedTwinsByTextHash
            }));
        } else {
            items.push(__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_order_json___default.a);
        }
    });

    return items;
}

function createVesselOrders(response) {
    var vesselOrders, userEmail;
    return regeneratorRuntime.wrap(function createVesselOrders$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!(response.status === 200)) {
                        _context.next = 16;
                        break;
                    }

                    if (!(response.data.clarified && response.data.clarified.length > 0)) {
                        _context.next = 10;
                        break;
                    }

                    // const vesselOrders = yield call(fillAndCreateVesselOrders, response.data.clarified);
                    vesselOrders = fillAndCreateVesselOrders(response.data.clarified);
                    userEmail = Object(__WEBPACK_IMPORTED_MODULE_5__common__["a" /* getUserMail */])(response.data);
                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Created',
                            message: vesselOrders.length + ' vessel orders created',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_orders__["c" /* createVesselOrders */](vesselOrders, { email: userEmail }));

                case 8:
                    _context.next = 14;
                    break;

                case 10:
                    _context.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'Vessel orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 12:
                    _context.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_orders__["f" /* resetVesselOrders */]());

                case 14:
                    _context.next = 20;
                    break;

                case 16:
                    _context.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'Vessel orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 18:
                    _context.next = 20;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_orders__["a" /* addVesselOrder */]());

                case 20:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fillAndCreateVesselOrders, 'fillAndCreateVesselOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/orders.js');
    reactHotLoader.register(createVesselOrders, 'createVesselOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = {"vesselName":"","vessel":"","open":[{"namePort":"","where":"","from":"","until":""}],"preferredCargo":"","terms":[],"user":"","validateErrors":[],"successMessage":{},"loadingPortName":"","maintenance":null,"disponentOwner":{"name":""}}

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createVesselSizes;
/* unused harmony export purposeRequired */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_vessels_size__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_size_json__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_size_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_size_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fillAndCreateVesselSizes),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(createVesselSizes),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(purposeRequired);






function fillAndCreateVesselSizes(clarified) {
    var items;
    return regeneratorRuntime.wrap(function fillAndCreateVesselSizes$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    items = [];

                    clarified.forEach(function (item) {
                        if (item.warnings && item.warnings.length) return;
                        items.push(_extends({}, __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_size_json___default.a, {
                            vesselName: item.mv.name,
                            vessel: item.mv._id,
                            imoNumber: item.mv.imoNumber,
                            DWT: item.mv.dw ? item.mv.dw.summer : null,
                            BLT: item.mv.blt
                        }));
                    });

                    return _context.abrupt('return', items.length ? items : [__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_size_json___default.a]);

                case 3:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function createVesselSizes(response) {
    var vesselSizes;
    return regeneratorRuntime.wrap(function createVesselSizes$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (!(response.status === 200)) {
                        _context2.next = 19;
                        break;
                    }

                    if (!(response.data.clarified && response.data.clarified.length > 0)) {
                        _context2.next = 11;
                        break;
                    }

                    _context2.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(fillAndCreateVesselSizes, response.data.clarified);

                case 4:
                    vesselSizes = _context2.sent;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Created',
                            message: 'The ' + vesselSizes.length + ' vessel sizes created',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 7:
                    _context2.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_size__["b" /* createVesselSizes */](vesselSizes));

                case 9:
                    _context2.next = 17;
                    break;

                case 11:
                    _context2.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The vessel sizes were not created',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 13:
                    _context2.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_size__["e" /* removeAllVesselSize */]());

                case 15:
                    _context2.next = 17;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_size__["a" /* addVesselSize */]());

                case 17:
                    _context2.next = 23;
                    break;

                case 19:
                    _context2.next = 21;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The vessel sizes were not created',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 21:
                    _context2.next = 23;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_size__["a" /* addVesselSize */]());

                case 23:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function purposeRequired() {
    return regeneratorRuntime.wrap(function purposeRequired$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'Type By Purpose is required',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fillAndCreateVesselSizes, 'fillAndCreateVesselSizes', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/size.js');
    reactHotLoader.register(createVesselSizes, 'createVesselSizes', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/size.js');
    reactHotLoader.register(purposeRequired, 'purposeRequired', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/size.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = {"vesselName":"","vessel":"","items":[],"user":"","validateErrors":[],"successMessage":{},"loadingPortName":""}

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getListGazetters;
/* harmony export (immutable) */ __webpack_exports__["c"] = postGazetters;
/* unused harmony export watchPostGazetters */
/* harmony export (immutable) */ __webpack_exports__["d"] = saveGazetters;
/* unused harmony export watchSaveGazetters */
/* unused harmony export saveGazettersNew */
/* unused harmony export watchSaveGazettersNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getListGazetters),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(postGazetters),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchPostGazetters),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(saveGazetters),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchSaveGazetters),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(saveGazettersNew),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchSaveGazettersNew);





/**
 * Get gazetters by text
 * */
function getListGazetters() {
    var response;
    return regeneratorRuntime.wrap(function getListGazetters$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].loadGazetteerIndex);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_65" /* LIST_GAZETTERS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Success get list gazetters',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context.abrupt('return', response);

                case 9:
                    _context.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Error',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_65" /* LIST_GAZETTERS */].FAILURE,
                        errors: errors
                    });

                case 13:
                    return _context.abrupt('return', response);

                case 14:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

/**
 * Get gazetters by text
 * */
function postGazetters(text) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var response;
    return regeneratorRuntime.wrap(function postGazetters$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].postGazetters, text, options);

                case 3:
                    response = _context2.sent;

                    console.log('response', response);

                    if (!(response.status === 200)) {
                        _context2.next = 11;
                        break;
                    }

                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_70" /* POST_GAZETTERS */].SUCCESS,
                        data: response.data.gazetteers
                    });

                case 8:
                    _context2.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Success post and get gazzeters',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 10:
                    return _context2.abrupt('return', response);

                case 11:
                    _context2.next = 19;
                    break;

                case 13:
                    _context2.prev = 13;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 17;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Error',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 17:
                    _context2.next = 19;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_70" /* POST_GAZETTERS */].FAILURE,
                        errors: _context2.t0
                    });

                case 19:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 13]]);
}

function watchPostGazetters() {
    var _ref, text, options;

    return regeneratorRuntime.wrap(function watchPostGazetters$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (false) {
                        _context3.next = 10;
                        break;
                    }

                    _context3.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_70" /* POST_GAZETTERS */].REQUEST);

                case 3:
                    _ref = _context3.sent;
                    text = _ref.text;
                    options = _ref.options;
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(postGazetters, text, options);

                case 8:
                    _context3.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

/**
 * Get gazetters by text
 * 
 * @param {*} gazetters
 * @returns {Object} response
 * */
function saveGazetters(gazetters) {
    var response;
    return regeneratorRuntime.wrap(function saveGazetters$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveGazetters, gazetters);

                case 2:
                    response = _context4.sent;

                    if (!(response.status === 200)) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].SUCCESS,
                        data: gazetters
                    });

                case 6:
                    _context4.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Success save gazetters',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context4.abrupt('return', response);

                case 9:
                    throw response;

                case 10:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function watchSaveGazetters() {
    var _ref2, gazetters;

    return regeneratorRuntime.wrap(function watchSaveGazetters$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    if (false) {
                        _context5.next = 19;
                        break;
                    }

                    _context5.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].REQUEST);

                case 3:
                    _ref2 = _context5.sent;
                    gazetters = _ref2.gazetters;
                    _context5.prev = 5;
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(saveGazetters, gazetters);

                case 8:
                    _context5.next = 17;
                    break;

                case 10:
                    _context5.prev = 10;
                    _context5.t0 = _context5['catch'](5);
                    _context5.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: _context5.t0.message,
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 14:
                    _context5.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].FAILURE,
                        errors: _context5.t0.message
                    });

                case 16:
                    return _context5.abrupt('return', _context5.t0);

                case 17:
                    _context5.next = 0;
                    break;

                case 19:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[5, 10]]);
}

/**
 * Get gazetters by text
 * 
 * @param {*} gazetters
 * @returns {Object} response
 * */
function saveGazettersNew(gazetters) {
    var response;
    return regeneratorRuntime.wrap(function saveGazettersNew$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveGazettersNew, gazetters);

                case 2:
                    response = _context6.sent;

                    if (response) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_97" /* SAVE_GAZETTERS_NEW */].SUCCESS,
                        data: gazetters
                    });

                case 6:
                    _context6.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Success save new gazetters',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context6.abrupt('return', { status: 204 });

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function watchSaveGazettersNew() {
    var _ref3, _gazetters;

    return regeneratorRuntime.wrap(function watchSaveGazettersNew$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    if (false) {
                        _context7.next = 19;
                        break;
                    }

                    _context7.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_97" /* SAVE_GAZETTERS_NEW */].REQUEST);

                case 3:
                    _ref3 = _context7.sent;
                    _gazetters = _ref3.gazetters;
                    _context7.prev = 5;
                    _context7.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(saveGazetters, _gazetters);

                case 8:
                    _context7.next = 17;
                    break;

                case 10:
                    _context7.prev = 10;
                    _context7.t0 = _context7['catch'](5);
                    _context7.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: _context7.t0.message,
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 14:
                    _context7.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_97" /* SAVE_GAZETTERS_NEW */].FAILURE,
                        errors: _context7.t0.message
                    });

                case 16:
                    return _context7.abrupt('return', _context7.t0);

                case 17:
                    _context7.next = 0;
                    break;

                case 19:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this, [[5, 10]]);
}

var _default = [watchPostGazetters, watchSaveGazetters, watchSaveGazettersNew];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getListGazetters, 'getListGazetters', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    reactHotLoader.register(postGazetters, 'postGazetters', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    reactHotLoader.register(watchPostGazetters, 'watchPostGazetters', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    reactHotLoader.register(saveGazetters, 'saveGazetters', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    reactHotLoader.register(watchSaveGazetters, 'watchSaveGazetters', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    reactHotLoader.register(saveGazettersNew, 'saveGazettersNew', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    reactHotLoader.register(watchSaveGazettersNew, 'watchSaveGazettersNew', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export sendTrain */
/* unused harmony export watchSendTrain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(sendTrain),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchSendTrain);





/**
 * Send train
 * */
function sendTrain(data) {
    var response;
    return regeneratorRuntime.wrap(function sendTrain$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].sendTrain, data);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_114" /* SEND_TRAIN */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'train sent',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context.abrupt('return', response);

                case 9:
                    _context.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something wrong ',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 99999
                        }
                    });

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_114" /* SEND_TRAIN */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                    return _context.abrupt('return', response);

                case 14:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchSendTrain() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchSendTrain$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_114" /* SEND_TRAIN */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(sendTrain, data);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchSendTrain];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sendTrain, 'sendTrain', '/opt/atlassian/pipelines/agent/build/client/app/sagas/train.js');
    reactHotLoader.register(watchSendTrain, 'watchSendTrain', '/opt/atlassian/pipelines/agent/build/client/app/sagas/train.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/train.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = connectNewDomainToUser;
/* unused harmony export watchConnectNewDomainToUser */
/* unused harmony export deleteDomain */
/* unused harmony export watchDeleteDomain */
/* unused harmony export getListDomain */
/* unused harmony export watchGetListDomain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(connectNewDomainToUser),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchConnectNewDomainToUser),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(deleteDomain),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteDomain),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getListDomain),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchGetListDomain);





/**
 * Connect new domain to user
 * */
function connectNewDomainToUser(data) {
    var response;
    return regeneratorRuntime.wrap(function connectNewDomainToUser$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].connectNewDomainToUser, data);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["z" /* CONNECT_NEW_DOMAIN_TO_USER */].SUCCESS,
                        data: response
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data && response.data.message,
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 5
                        }
                    });

                case 8:
                    return _context.abrupt('return', response);

                case 9:
                    _context.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["z" /* CONNECT_NEW_DOMAIN_TO_USER */].FAILURE,
                        errors: response.errors
                    });

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Failed',
                            message: response.data && response.data.errors && response.data.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 999
                        }
                    });

                case 13:
                    return _context.abrupt('return', response);

                case 14:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchConnectNewDomainToUser() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchConnectNewDomainToUser$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["z" /* CONNECT_NEW_DOMAIN_TO_USER */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(connectNewDomainToUser, data);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * DELETE_DOMAIN
 * */
function deleteDomain(data) {
    var response;
    return regeneratorRuntime.wrap(function deleteDomain$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteDomain, data);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["P" /* DELETE_DOMAIN */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data && response.data.message,
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 5
                        }
                    });

                case 8:
                    return _context3.abrupt('return', response);

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["P" /* DELETE_DOMAIN */].FAILURE,
                        errors: response.errors
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Failed',
                            message: response.data && response.data.errors && response.data.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 999
                        }
                    });

                case 13:
                    return _context3.abrupt('return', response);

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchDeleteDomain() {
    var _ref2, _data;

    return regeneratorRuntime.wrap(function watchDeleteDomain$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["P" /* DELETE_DOMAIN */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    _data = _ref2.data;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteDomain, _data);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * DELETE_DOMAIN
 * */
function getListDomain() {
    var response;
    return regeneratorRuntime.wrap(function getListDomain$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getListDomain);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 7;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_33" /* GET_LIST_DOMAIN */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context5.abrupt('return', response);

                case 7:
                    _context5.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_33" /* GET_LIST_DOMAIN */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context5.abrupt('return', response);

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchGetListDomain() {
    return regeneratorRuntime.wrap(function watchGetListDomain$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 7;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_33" /* GET_LIST_DOMAIN */].REQUEST);

                case 3:
                    _context6.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getListDomain);

                case 5:
                    _context6.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

var _default = [watchConnectNewDomainToUser, watchDeleteDomain, watchGetListDomain];
/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(connectNewDomainToUser, 'connectNewDomainToUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/domains.js');
    reactHotLoader.register(watchConnectNewDomainToUser, 'watchConnectNewDomainToUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/domains.js');
    reactHotLoader.register(deleteDomain, 'deleteDomain', '/opt/atlassian/pipelines/agent/build/client/app/sagas/domains.js');
    reactHotLoader.register(watchDeleteDomain, 'watchDeleteDomain', '/opt/atlassian/pipelines/agent/build/client/app/sagas/domains.js');
    reactHotLoader.register(getListDomain, 'getListDomain', '/opt/atlassian/pipelines/agent/build/client/app/sagas/domains.js');
    reactHotLoader.register(watchGetListDomain, 'watchGetListDomain', '/opt/atlassian/pipelines/agent/build/client/app/sagas/domains.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/domains.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createVesselSales;
/* unused harmony export getSalesVesselWatch */
/* unused harmony export postVesselSaleRequestWatch */
/* unused harmony export watchDeleteVesselSale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_vessels_sales__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__refNumber__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(467);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fillAndCreateVesselSales),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(createVesselSales),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(postVesselSaleRequest),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(getSalesVessel),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getSalesVesselWatch),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(postVesselSaleRequestWatch),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(deleteVesselSale),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteVesselSale);









// eslint-disable-next-line require-yield
function fillAndCreateVesselSales(clarified) {
    var items;
    return regeneratorRuntime.wrap(function fillAndCreateVesselSales$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    items = [];


                    clarified.forEach(function (item) {
                        if (item.vessel) {
                            items.push(_extends({}, __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json___default.a, {
                                vessel: item.vessel._id,
                                vesselName: item.vessel.name,
                                imoNumber: item.vessel.imoNumber,
                                DWT: item.vessel.deadWeight.sDWT,
                                BLT: item.vessel.blt
                            }));
                        } else {
                            items.push(__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json___default.a);
                        }
                    });

                    return _context.abrupt('return', items);

                case 3:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function createVesselSales(response) {
    var vesselSales, userEmail;
    return regeneratorRuntime.wrap(function createVesselSales$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (!(response.status === 200)) {
                        _context2.next = 18;
                        break;
                    }

                    if (!(response.data.clarified && response.data.clarified.length > 0)) {
                        _context2.next = 12;
                        break;
                    }

                    _context2.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(fillAndCreateVesselSales, response.data.clarified);

                case 4:
                    vesselSales = _context2.sent;
                    userEmail = Object(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* getUserMail */])(response.data);
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Created',
                            message: 'The ' + vesselSales.length + ' vessel sales created',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 8:
                    _context2.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_sales__["b" /* createVesselSales */](vesselSales, { email: userEmail }));

                case 10:
                    _context2.next = 16;
                    break;

                case 12:
                    _context2.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The vessel sales did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 14:
                    _context2.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_sales__["g" /* resetVesselSales */]());

                case 16:
                    _context2.next = 22;
                    break;

                case 18:
                    _context2.next = 20;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The vessel sales did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 20:
                    _context2.next = 22;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_vessels_sales__["a" /* addVesselSale */]());

                case 22:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function postVesselSaleRequest(vesselId, vesselSale) {
    var response;
    return regeneratorRuntime.wrap(function postVesselSaleRequest$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].postVesselSale, vesselId, vesselSale);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 11;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].SUCCESS,
                        data: response.data,
                        vesselSale: vesselSale
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success vessel sale - ' + (vesselSale.keyVesselSale + 1),
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 8:
                    _context3.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_5__refNumber__["a" /* refNumber */], response.data);

                case 10:
                    return _context3.abrupt('return', response);

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error vessel sale - ' + (vesselSale.keyVesselSale + 1),
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 13:
                    _context3.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].FAILURE,
                        errors: response.errors,
                        vesselSale: vesselSale
                    });

                case 15:
                    return _context3.abrupt('return', response);

                case 16:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function getSalesVessel(filter) {
    var response;
    return regeneratorRuntime.wrap(function getSalesVessel$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].getVesselSales, filter);

                case 2:
                    response = _context4.sent;

                    if (!(response.status === 200)) {
                        _context4.next = 7;
                        break;
                    }

                    _context4.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_62" /* GET_VESSEL_SALES */].SUCCESS,
                        data: response
                    });

                case 6:
                    return _context4.abrupt('return', response);

                case 7:
                    _context4.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_62" /* GET_VESSEL_SALES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context4.abrupt('return', response);

                case 10:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getSalesVesselWatch() {
    var _ref, filter;

    return regeneratorRuntime.wrap(function getSalesVesselWatch$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    if (false) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_62" /* GET_VESSEL_SALES */].REQUEST);

                case 3:
                    _ref = _context5.sent;
                    filter = _ref.filter;
                    _context5.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getSalesVessel, filter);

                case 7:
                    _context5.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function postVesselSaleRequestWatch() {
    var vesselSale;
    return regeneratorRuntime.wrap(function postVesselSaleRequestWatch$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 8;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].REQUEST);

                case 3:
                    vesselSale = _context6.sent;
                    _context6.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(postVesselSaleRequest, vesselSale.vesselId, vesselSale.vesselSaleRequest);

                case 6:
                    _context6.next = 0;
                    break;

                case 8:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function deleteVesselSale(saleId) {
    var response, store;
    return regeneratorRuntime.wrap(function deleteVesselSale$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].deleteVesselSale, saleId);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 12;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 6:
                    store = _context7.sent;
                    _context7.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_1" /* DELETE_VESSEL_SALE */].SUCCESS,
                        saleId: saleId,
                        email: store.user.user.email
                    });

                case 9:
                    _context7.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.messages[0],
                            level: 'success',
                            _id: saleId,
                            autoDismiss: 2
                        }
                    });

                case 11:
                    return _context7.abrupt('return', response);

                case 12:
                    _context7.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_1" /* DELETE_VESSEL_SALE */].FAILURE,
                        saleId: saleId,
                        error: response.errors
                    });

                case 14:
                    _context7.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: saleId,
                            autoDismiss: 2
                        }
                    });

                case 16:
                    return _context7.abrupt('return', response);

                case 17:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function watchDeleteVesselSale() {
    var _ref2, saleId;

    return regeneratorRuntime.wrap(function watchDeleteVesselSale$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 9;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_1" /* DELETE_VESSEL_SALE */].REQUEST);

                case 3:
                    _ref2 = _context8.sent;
                    saleId = _ref2.saleId;
                    _context8.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteVesselSale, saleId);

                case 7:
                    _context8.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

var _default = [postVesselSaleRequestWatch, getSalesVesselWatch, watchDeleteVesselSale];
/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fillAndCreateVesselSales, 'fillAndCreateVesselSales', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(createVesselSales, 'createVesselSales', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(postVesselSaleRequest, 'postVesselSaleRequest', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(getSalesVessel, 'getSalesVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(getSalesVesselWatch, 'getSalesVesselWatch', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(postVesselSaleRequestWatch, 'postVesselSaleRequestWatch', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(deleteVesselSale, 'deleteVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(watchDeleteVesselSale, 'watchDeleteVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/sales.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = {"vesselName":null,"vessel":null,"ideaPrice":0,"salePrice":0,"user":null,"validateErrors":[],"successMessage":{}}

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(471);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(1478);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(704);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(1487);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1510);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(331);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(1523);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(123);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(334);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1540);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(708);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(710);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(1554);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(157);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(262);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(709);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(261);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(263);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(703);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1676),
    shortOut = __webpack_require__(730);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(188);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(341),
    baseRest = __webpack_require__(136),
    baseUniq = __webpack_require__(732),
    isArrayLikeObject = __webpack_require__(265);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(338),
    arrayIncludes = __webpack_require__(339),
    arrayIncludesWith = __webpack_require__(485),
    cacheHas = __webpack_require__(340),
    createSet = __webpack_require__(1678),
    setToArray = __webpack_require__(343);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(188),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();



var companyUser = function companyUser() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, data: {} };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_22" /* GET_COMPANY_USER */].REQUEST:
      return _extends({}, state, {
        isLoaded: false
      });
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_22" /* GET_COMPANY_USER */].SUCCESS:
      {
        return _extends({}, state, action.data, {
          isLoaded: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_22" /* GET_COMPANY_USER */].FAILURE:
      return _extends({}, state, action.data, {
        isLoaded: true
      });
    default:
      return state;
  }
};

var _default = companyUser;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(companyUser, "companyUser", "/opt/atlassian/pipelines/agent/build/client/app/reducers/integrators/user.js");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/reducers/integrators/user.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(220);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toArray2 = __webpack_require__(737);

var _toArray3 = _interopRequireDefault(_toArray2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(266);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _dom = __webpack_require__(738);

var _dom2 = _interopRequireDefault(_dom);

var _CircleRipple = __webpack_require__(1733);

var _CircleRipple2 = _interopRequireDefault(_CircleRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remove the first element of the array
var shift = function shift(_ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      newArray = _ref2.slice(1);

  return newArray;
};

var TouchRipple = function (_Component) {
  (0, _inherits3.default)(TouchRipple, _Component);

  function TouchRipple(props, context) {
    (0, _classCallCheck3.default)(this, TouchRipple);

    // Touch start produces a mouse down event for compat reasons. To avoid
    // showing ripples twice we skip showing a ripple for the first mouse down
    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
    // to avoid re-rendering when we change it.
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));

    _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.start(event, false);
      }
    };

    _this.handleMouseUp = function () {
      _this.end();
    };

    _this.handleMouseLeave = function () {
      _this.end();
    };

    _this.handleTouchStart = function (event) {
      event.stopPropagation();
      // If the user is swiping (not just tapping), save the position so we can
      // abort ripples if the user appears to be scrolling.
      if (_this.props.abortOnScroll && event.touches) {
        _this.startListeningForScrollAbort(event);
        _this.startTime = Date.now();
      }
      _this.start(event, true);
    };

    _this.handleTouchEnd = function () {
      _this.end();
    };

    _this.handleTouchMove = function (event) {
      // Stop trying to abort if we're already 300ms into the animation
      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
      if (timeSinceStart > 300) {
        _this.stopListeningForScrollAbort();
        return;
      }

      // If the user is scrolling...
      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
      if (deltaY > 6 || deltaX > 6) {
        var currentRipples = _this.state.ripples;
        var ripple = currentRipples[0];
        // This clone will replace the ripple in ReactTransitionGroup with a
        // version that will disappear immediately when removed from the DOM
        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
        // Remove the old ripple and replace it with the new updated one
        currentRipples = shift(currentRipples);
        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
        _this.setState({ ripples: currentRipples }, function () {
          // Call end after we've set the ripple to abort otherwise the setState
          // in end() merges with this and the ripple abort fails
          _this.end();
        });
      }
    };

    _this.ignoreNextMouseDown = false;

    _this.state = {
      // This prop allows us to only render the ReactTransitionGroup
      // on the first click of the component, making the inital render faster.
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
    return _this;
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'start',
    value: function start(event, isRippleTouchGenerated) {
      var theme = this.context.muiTheme.ripple;

      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }

      var ripples = this.state.ripples;

      // Add a ripple to the ripples array
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
        key: this.state.nextKey,
        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
        color: this.props.color || theme.color,
        opacity: this.props.opacity,
        touchGenerated: isRippleTouchGenerated
      })]);

      this.ignoreNextMouseDown = isRippleTouchGenerated;
      this.setState({
        hasRipples: true,
        nextKey: this.state.nextKey + 1,
        ripples: ripples
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var currentRipples = this.state.ripples;
      this.setState({
        ripples: shift(currentRipples)
      });
      if (this.props.abortOnScroll) {
        this.stopListeningForScrollAbort();
      }
    }

    // Check if the user seems to be scrolling and abort the animation if so

  }, {
    key: 'startListeningForScrollAbort',
    value: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      // Note that when scolling Chrome throttles this event to every 200ms
      // Also note we don't listen for scroll events directly as there's no general
      // way to cover cases like scrolling within containers on the page
      document.body.addEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'stopListeningForScrollAbort',
    value: function stopListeningForScrollAbort() {
      document.body.removeEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'getRippleStyle',
    value: function getRippleStyle(event) {
      var el = _reactDom2.default.findDOMNode(this);
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = _dom2.default.offset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;

      return {
        directionInvariant: true,
        height: rippleSize,
        width: rippleSize,
        top: top,
        left: left
      };
    }
  }, {
    key: 'calcDiag',
    value: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style;
      var _state = this.state,
          hasRipples = _state.hasRipples,
          ripples = _state.ripples;
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var rippleGroup = void 0;

      if (hasRipples) {
        var mergedStyles = (0, _simpleAssign2.default)({
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
        }, style);

        rippleGroup = _react2.default.createElement(
          _TransitionGroup2.default,
          { style: prepareStyles(mergedStyles) },
          ripples
        );
      }

      return _react2.default.createElement(
        'div',
        {
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        },
        rippleGroup,
        children
      );
    }
  }]);
  return TouchRipple;
}(_react.Component);

TouchRipple.defaultProps = {
  abortOnScroll: true
};
TouchRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TouchRipple.propTypes =  false ? {
  abortOnScroll: _propTypes2.default.bool,
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = TouchRipple;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(651);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AppBar = __webpack_require__(1735);

var _AppBar2 = _interopRequireDefault(_AppBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AppBar2.default;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var verticalPosition = props.verticalPosition;
  var horizontalPosition = props.horizontalPosition;
  var touchMarginOffset = props.touch ? 10 : 0;
  var touchOffsetTop = props.touch ? -20 : -10;
  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;

  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      zIndex = _context$muiTheme.zIndex,
      tooltip = _context$muiTheme.tooltip,
      borderRadius = _context$muiTheme.borderRadius;


  var styles = {
    root: {
      position: 'absolute',
      fontFamily: baseTheme.fontFamily,
      fontSize: '10px',
      lineHeight: '22px',
      padding: '0 8px',
      zIndex: zIndex.tooltip,
      color: tooltip.color,
      overflow: 'hidden',
      top: -10000,
      borderRadius: borderRadius,
      userSelect: 'none',
      opacity: 0,
      right: horizontalPosition === 'left' ? 12 : null,
      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    label: {
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    ripple: {
      position: 'absolute',
      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
      top: verticalPosition === 'bottom' ? 0 : '100%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    },
    rootWhenShown: {
      top: verticalPosition === 'top' ? touchOffsetTop : 36,
      opacity: tooltip.opacity,
      transform: 'translate(0px, ' + offset + 'px)',
      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    rootWhenTouched: {
      fontSize: '14px',
      lineHeight: '32px',
      padding: '0 16px'
    },
    rippleWhenShown: {
      backgroundColor: tooltip.rippleBackgroundColor,
      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    }
  };

  return styles;
}

var Tooltip = function (_Component) {
  (0, _inherits3.default)(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      offsetWidth: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setRippleSize();
      this.setTooltipPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setTooltipPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setRippleSize();
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var ripple = this.refs.ripple;
      var tooltip = this.refs.tooltip;
      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);

      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
      if (this.props.show) {
        ripple.style.height = rippleDiameter + 'px';
        ripple.style.width = rippleDiameter + 'px';
      } else {
        ripple.style.width = '0px';
        ripple.style.height = '0px';
      }
    }
  }, {
    key: 'setTooltipPosition',
    value: function setTooltipPosition() {
      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          horizontalPosition = _props.horizontalPosition,
          label = _props.label,
          show = _props.show,
          touch = _props.touch,
          verticalPosition = _props.verticalPosition,
          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: 'tooltip',
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
        }),
        _react2.default.createElement('div', {
          ref: 'ripple',
          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
        }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          label
        )
      );
    }
  }]);
  return Tooltip;
}(_react.Component);

Tooltip.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tooltip.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
  label: _propTypes2.default.node.isRequired,
  show: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  touch: _propTypes2.default.bool,
  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
} : {};
exports.default = Tooltip;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendChildren = extendChildren;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extendChildren(children, extendedProps, extendedChildren) {
  return _react2.default.Children.map(children, function (child) {
    if (!_react2.default.isValidElement(child)) {
      return child;
    }

    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;

    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;

    return _react2.default.cloneElement(child, newProps, newChildren);
  });
}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(1738);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(1739);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 744 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _dom = __webpack_require__(738);

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
var RenderToLayer = function (_Component) {
  (0, _inherits3.default)(RenderToLayer, _Component);

  function RenderToLayer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RenderToLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      if (!_this.props.componentClickAway) {
        return;
      }

      if (!_this.props.open) {
        return;
      }

      var el = _this.layer;
      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
        _this.props.componentClickAway(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RenderToLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderLayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unrenderLayer();
    }
  }, {
    key: 'getLayer',
    value: function getLayer() {
      return this.layer;
    }
  }, {
    key: 'unrenderLayer',
    value: function unrenderLayer() {
      if (!this.layer) {
        return;
      }

      if (this.props.useLayerForClickAway) {
        this.layer.style.position = 'relative';
        this.layer.removeEventListener('click', this.onClickAway);
      } else {
        window.removeEventListener('click', this.onClickAway);
      }

      (0, _reactDom.unmountComponentAtNode)(this.layer);
      document.body.removeChild(this.layer);
      this.layer = null;
    }

    /**
     * By calling this method in componentDidMount() and
     * componentDidUpdate(), you're effectively creating a "wormhole" that
     * funnels React's hierarchical updates through to a DOM node on an
     * entirely different part of the page.
     */

  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          render = _props.render;


      if (open) {
        if (!this.layer) {
          this.layer = document.createElement('div');
          document.body.appendChild(this.layer);

          if (this.props.useLayerForClickAway) {
            this.layer.addEventListener('click', this.onClickAway);
            this.layer.style.position = 'fixed';
            this.layer.style.top = 0;
            this.layer.style.bottom = 0;
            this.layer.style.left = 0;
            this.layer.style.right = 0;
            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
          } else {
            setTimeout(function () {
              window.addEventListener('click', _this2.onClickAway);
            }, 0);
          }
        }

        var layerElement = render();
        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
      } else {
        this.unrenderLayer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return RenderToLayer;
}(_react.Component);

RenderToLayer.defaultProps = {
  useLayerForClickAway: true
};
RenderToLayer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RenderToLayer.propTypes =  false ? {
  componentClickAway: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  render: _propTypes2.default.func.isRequired,
  useLayerForClickAway: _propTypes2.default.bool
} : {};
exports.default = RenderToLayer;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Drawer = __webpack_require__(1755);

var _Drawer2 = _interopRequireDefault(_Drawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Drawer2.default;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _AutoLockScrolling = __webpack_require__(1756);

var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var overlay = context.muiTheme.overlay;


  var style = {
    root: {
      position: 'fixed',
      height: '100%',
      width: '100%',
      top: 0,
      left: '-100%',
      opacity: 0,
      backgroundColor: overlay.backgroundColor,
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)

      // Two ways to promote overlay to its own render layer
      willChange: 'opacity',
      transform: 'translateZ(0)',

      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    }
  };

  if (props.show) {
    (0, _simpleAssign2.default)(style.root, {
      left: 0,
      opacity: 1,
      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
    });
  }

  return style;
}

var Overlay = function (_Component) {
  (0, _inherits3.default)(Overlay, _Component);

  function Overlay() {
    (0, _classCallCheck3.default)(this, Overlay);
    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
  }

  (0, _createClass3.default)(Overlay, [{
    key: 'setOpacity',
    value: function setOpacity(opacity) {
      this.refs.overlay.style.opacity = opacity;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoLockScrolling = _props.autoLockScrolling,
          show = _props.show,
          style = _props.style,
          transitionEnabled = _props.transitionEnabled,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
      );
    }
  }]);
  return Overlay;
}(_react.Component);

Overlay.defaultProps = {
  autoLockScrolling: true,
  style: {},
  transitionEnabled: true
};
Overlay.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Overlay.propTypes =  false ? {
  autoLockScrolling: _propTypes2.default.bool,
  show: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  transitionEnabled: _propTypes2.default.bool
} : {};
exports.default = Overlay;

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_socket_io_client__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var socket = {
    connection: null,
    connect: function connect(props) {
        var _this = this;

        if (this.connection) {
            return this.connection;

            this.disconnect();
        }

        if (props.userId) {
            this.connection = __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default.a.connect('/v1', {
                path: '/socket.io',
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionDelay: 500,
                reconnectionAttempts: Number.MAX_VALUE
            });

            this.connection.on('connected', function (message) {
                //  console.log('connect', message);
                _this.connection.emit('messages:get');
            });

            this.connection.on('disconnect', function () {
                //  console.log('disconnect');
            });

            this.connection.on('messages:receive', function () {
                //    console.log('messages:receive');
            });
            return this.connection;
        }
    },
    disconnect: function disconnect() {
        if (this.connection) {
            this.connection.off('messages:receive');
            this.connection.disconnect();
            this.connection = null;
        }
    }
};

var _default = socket;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(socket, 'socket', '/opt/atlassian/pipelines/agent/build/client/app/sockets/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sockets/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 749 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {
module.exports = isBuf;

var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

var isView = function (obj) {
  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
};

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228).Buffer))

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(1767);
var Socket = __webpack_require__(757);
var Emitter = __webpack_require__(227);
var parser = __webpack_require__(499);
var on = __webpack_require__(758);
var bind = __webpack_require__(759);
var debug = __webpack_require__(138)('socket.io-client:manager');
var indexOf = __webpack_require__(756);
var Backoff = __webpack_require__(1781);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(500);
var XHR = __webpack_require__(1770);
var JSONP = __webpack_require__(1777);
var websocket = __webpack_require__(1778);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(501);
var parseqs = __webpack_require__(350);
var parser = __webpack_require__(229);
var inherit = __webpack_require__(351);
var yeast = __webpack_require__(755);
var debug = __webpack_require__(138)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(500);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */

/*
 * Module requirements.
 */

var isArray = __webpack_require__(349);

var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' ||
                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
var withNativeFile = typeof File === 'function' ||
                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
    (withNativeBlob && obj instanceof Blob) ||
    (withNativeFile && obj instanceof File)
  ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228).Buffer))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 756 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(499);
var Emitter = __webpack_require__(227);
var toArray = __webpack_require__(1780);
var on = __webpack_require__(758);
var bind = __webpack_require__(759);
var debug = __webpack_require__(138)('socket.io-client:socket');
var parseqs = __webpack_require__(350);
var hasBin = __webpack_require__(754);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  this.flags = {};
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = {
    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
    data: args
  };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  this.flags = {};

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  var sameNamespace = packet.nsp === this.nsp;
  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

  if (!sameNamespace && !rootNamespaceError) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags.compress = compress;
  return this;
};

/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */

Socket.prototype.binary = function (binary) {
  this.flags.binary = binary;
  return this;
};


/***/ }),
/* 758 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileAttachment = function FileAttachment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z' })
  );
};
FileAttachment = (0, _pure2.default)(FileAttachment);
FileAttachment.displayName = 'FileAttachment';
FileAttachment.muiName = 'SvgIcon';

exports.default = FileAttachment;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Avatar = __webpack_require__(1796);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar2.default;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var selected = props.selected;
  var bottomNavigation = context.muiTheme.bottomNavigation;


  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;

  var styles = {
    root: {
      transition: 'padding-top 0.3s',
      paddingTop: selected ? 6 : 8,
      paddingBottom: 10,
      paddingLeft: 12,
      paddingRight: 12,
      minWidth: 80,
      maxWidth: 168
    },
    label: {
      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
      transition: 'color 0.3s, font-size 0.3s',
      color: color
    },
    icon: {
      display: 'block',
      /**
       * Used to ensure SVG icons are centered
       */
      width: '100%'
    },
    iconColor: color
  };

  return styles;
}

var BottomNavigationItem = function BottomNavigationItem(props, context) {
  var label = props.label,
      icon = props.icon,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
  var prepareStyles = context.muiTheme.prepareStyles;

  var styles = getStyles(props, context);

  var styledIcon = (0, _react.cloneElement)(icon, {
    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
    color: icon.props.color || styles.iconColor
  });

  return _react2.default.createElement(
    _EnhancedButton2.default,
    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
    styledIcon,
    _react2.default.createElement(
      'div',
      { style: prepareStyles(styles.label) },
      label
    )
  );
};

BottomNavigationItem.propTypes =  false ? {
  /**
   * Set the icon representing the view for this item.
   */
  icon: _propTypes2.default.node,
  /**
   * Set the label describing the view for this item.
   */
  label: _propTypes2.default.node,
  /**
   * @ignore
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

BottomNavigationItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = BottomNavigationItem;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keyboardArrowUp = __webpack_require__(230);

var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);

var _keyboardArrowDown = __webpack_require__(231);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

var _IconButton = __webpack_require__(30);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      top: 0,
      bottom: 0,
      right: 4,
      margin: 'auto',
      position: 'absolute'
    }
  };
}

var CardExpandable = function (_Component) {
  (0, _inherits3.default)(CardExpandable, _Component);

  function CardExpandable() {
    (0, _classCallCheck3.default)(this, CardExpandable);
    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardExpandable, [{
    key: 'render',
    value: function render() {
      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _IconButton2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          onClick: this.props.onExpanding,
          iconStyle: this.props.iconStyle
        },
        this.props.expanded ? this.props.openIcon : this.props.closeIcon
      );
    }
  }]);
  return CardExpandable;
}(_react.Component);

CardExpandable.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardExpandable.defaultProps = {
  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
};
CardExpandable.propTypes =  false ? {
  closeIcon: _propTypes2.default.node,
  expanded: _propTypes2.default.bool,
  iconStyle: _propTypes2.default.object,
  onExpanding: _propTypes2.default.func.isRequired,
  openIcon: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = CardExpandable;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Avatar = __webpack_require__(761);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      fontWeight: card.fontWeight,
      boxSizing: 'border-box',
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    text: {
      display: 'inline-block',
      verticalAlign: 'top',
      whiteSpace: 'normal',
      paddingRight: '90px'
    },
    avatar: {
      marginRight: 16
    },
    title: {
      color: props.titleColor || card.titleColor,
      display: 'block',
      fontSize: 15
    },
    subtitle: {
      color: props.subtitleColor || card.subtitleColor,
      display: 'block',
      fontSize: 14
    }
  };
}

var CardHeader = function (_Component) {
  (0, _inherits3.default)(CardHeader, _Component);

  function CardHeader() {
    (0, _classCallCheck3.default)(this, CardHeader);
    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          avatarProp = _props.avatar,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          openIcon = _props.openIcon,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          textStyle = _props.textStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle', 'iconStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var avatar = avatarProp;

      if ((0, _react.isValidElement)(avatarProp)) {
        avatar = _react2.default.cloneElement(avatar, {
          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
        });
      } else if (avatar !== null) {
        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        avatar,
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
            title
          ),
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
            subtitle
          )
        ),
        children
      );
    }
  }]);
  return CardHeader;
}(_react.Component);

CardHeader.muiName = 'CardHeader';
CardHeader.defaultProps = {
  avatar: null
};
CardHeader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardHeader.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
   * If `avatar` is an `Avatar` or other element, it will be rendered.
   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
   */
  avatar: _propTypes2.default.node,
  /**
   * Can be used to render elements inside the Card Header.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the iconStyle of the Icon Button.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
   */
  openIcon: _propTypes2.default.node,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in Card Header.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the text.
   */
  textStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in Card Header.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardHeader;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      position: 'relative'
    },
    title: {
      fontSize: 24,
      color: props.titleColor || card.titleColor,
      display: 'block',
      lineHeight: '36px'
    },
    subtitle: {
      fontSize: 14,
      color: props.subtitleColor || card.subtitleColor,
      display: 'block'
    }
  };
}

var CardTitle = function (_Component) {
  (0, _inherits3.default)(CardTitle, _Component);

  function CardTitle() {
    (0, _classCallCheck3.default)(this, CardTitle);
    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'closeIcon', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedTitleStyle) },
          title
        ),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedSubtitleStyle) },
          subtitle
        ),
        children
      );
    }
  }]);
  return CardTitle;
}(_react.Component);

CardTitle.muiName = 'CardTitle';
CardTitle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardTitle.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Title.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in the Card Title.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in the Card Title.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardTitle;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardMedia = context.muiTheme.cardMedia;


  return {
    root: {
      position: 'relative'
    },
    overlayContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0
    },
    overlay: {
      height: '100%',
      position: 'relative'
    },
    overlayContent: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      paddingTop: 8,
      background: cardMedia.overlayContentBackground
    },
    media: {},
    mediaChild: {
      verticalAlign: 'top',
      maxWidth: '100%',
      minWidth: '100%',
      width: '100%'
    }
  };
}

var CardMedia = function (_Component) {
  (0, _inherits3.default)(CardMedia, _Component);

  function CardMedia() {
    (0, _classCallCheck3.default)(this, CardMedia);
    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardMedia, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          mediaStyle = _props.mediaStyle,
          overlay = _props.overlay,
          overlayContainerStyle = _props.overlayContainerStyle,
          overlayContentStyle = _props.overlayContentStyle,
          overlayStyle = _props.overlayStyle,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
      var titleColor = this.context.muiTheme.cardMedia.titleColor;
      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
      var color = this.context.muiTheme.cardMedia.color;

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (!child) {
          return child;
        }

        return _react2.default.cloneElement(child, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
        });
      });

      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
        var childMuiName = child && child.type ? child.type.muiName : null;

        if (childMuiName === 'CardHeader' || childMuiName === 'CardTitle') {
          return _react2.default.cloneElement(child, {
            titleColor: titleColor,
            subtitleColor: subtitleColor
          });
        } else if (childMuiName === 'CardText') {
          return _react2.default.cloneElement(child, {
            color: color
          });
        } else {
          return child;
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedMediaStyle) },
          styledChildren
        ),
        overlay ? _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedOverlayContainerStyle) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(extendedOverlayStyle) },
            _react2.default.createElement(
              'div',
              { style: prepareStyles(extendedOverlayContentStyle) },
              overlayChildren
            )
          )
        ) : ''
      );
    }
  }]);
  return CardMedia;
}(_react.Component);

CardMedia.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardMedia.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Media.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the Card Media.
   */
  mediaStyle: _propTypes2.default.object,
  /**
   * Can be used to render overlay element in Card Media.
   */
  overlay: _propTypes2.default.node,
  /**
   * Override the inline-styles of the overlay container.
   */
  overlayContainerStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay content.
   */
  overlayContentStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay element.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardMedia;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardText = context.muiTheme.cardText;


  return {
    root: {
      padding: 16,
      fontSize: 14,
      color: props.color || cardText.textColor
    }
  };
}

var CardText = function (_Component) {
  (0, _inherits3.default)(CardText, _Component);

  function CardText() {
    (0, _classCallCheck3.default)(this, CardText);
    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          color = _props.color,
          expandable = _props.expandable,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        children
      );
    }
  }]);
  return CardText;
}(_react.Component);

CardText.muiName = 'CardText';
CardText.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardText.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Text.
   */
  children: _propTypes2.default.node,
  /**
   * Override the CardText color.
   */
  color: _propTypes2.default.string,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardText;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      padding: 8,
      position: 'relative'
    },
    action: {
      marginRight: 8
    }
  };
}

var CardActions = function (_Component) {
  (0, _inherits3.default)(CardActions, _Component);

  function CardActions() {
    (0, _classCallCheck3.default)(this, CardActions);
    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (_react2.default.isValidElement(child)) {
          return _react2.default.cloneElement(child, {
            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
          });
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        styledChildren
      );
    }
  }]);
  return CardActions;
}(_react.Component);

CardActions.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardActions.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Action.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardActions;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';

exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleCheckBox = function ToggleCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
  );
};
ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
ToggleCheckBox.displayName = 'ToggleCheckBox';
ToggleCheckBox.muiName = 'SvgIcon';

exports.default = ToggleCheckBox;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Chip = __webpack_require__(1804);

var _Chip2 = _interopRequireDefault(_Chip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chip2.default;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCancel = function NavigationCancel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
  );
};
NavigationCancel = (0, _pure2.default)(NavigationCancel);
NavigationCancel.displayName = 'NavigationCancel';
NavigationCancel.muiName = 'SvgIcon';

exports.default = NavigationCancel;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
  );
};
NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
NavigationArrowDropDown.muiName = 'SvgIcon';

exports.default = NavigationArrowDropDown;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(69);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _titleBar;

  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      gridTile = _context$muiTheme.gridTile;


  var actionPos = props.actionIcon && props.actionPosition;

  var styles = {
    root: {
      position: 'relative',
      display: 'block',
      height: '100%',
      overflow: 'hidden'
    },
    titleBar: (_titleBar = {
      position: 'absolute',
      left: 0,
      right: 0
    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
    titleWrap: {
      flexGrow: 1,
      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
      color: gridTile.textColor,
      overflow: 'hidden'
    },
    title: {
      fontSize: '16px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    subtitle: {
      fontSize: '12px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    actionIcon: {
      order: actionPos === 'left' ? -1 : 1
    },
    childImg: {
      height: '100%',
      transform: 'translateX(-50%)',
      position: 'relative',
      left: '50%'
    }
  };
  return styles;
}

var GridTile = function (_Component) {
  (0, _inherits3.default)(GridTile, _Component);

  function GridTile() {
    (0, _classCallCheck3.default)(this, GridTile);
    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
  }

  (0, _createClass3.default)(GridTile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureImageCover();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureImageCover();
    }
  }, {
    key: 'ensureImageCover',
    value: function ensureImageCover() {
      var _this2 = this;

      var imgEl = this.refs.img;

      if (imgEl) {
        var fit = function fit() {
          if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
            var isRtl = _this2.context.muiTheme.isRtl;

            imgEl.style.height = 'auto';
            if (isRtl) {
              imgEl.style.right = '0';
            } else {
              imgEl.style.left = '0';
            }
            imgEl.style.width = '100%';
            imgEl.style.top = '50%';
            imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
          }
          imgEl.removeEventListener('load', fit);
          imgEl = null; // prevent closure memory leak
        };
        if (imgEl.complete) {
          fit();
        } else {
          imgEl.addEventListener('load', fit);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          subtitle = _props.subtitle,
          titlePosition = _props.titlePosition,
          titleBackground = _props.titleBackground,
          titleStyle = _props.titleStyle,
          subtitleStyle = _props.subtitleStyle,
          actionIcon = _props.actionIcon,
          actionPosition = _props.actionPosition,
          style = _props.style,
          children = _props.children,
          containerElement = _props.containerElement,
          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'subtitleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);

      var titleBar = null;

      if (title) {
        titleBar = _react2.default.createElement(
          'div',
          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.titleWrap) },
            _react2.default.createElement(
              'div',
              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
              title
            ),
            subtitle ? _react2.default.createElement(
              'div',
              { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
              subtitle
            ) : null
          ),
          actionIcon ? _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.actionIcon) },
            actionIcon
          ) : null
        );
      }

      var newChildren = children;

      // if there is a single image passed as children
      // clone it and add our styles
      if (_react2.default.Children.count(children) === 1) {
        newChildren = _react2.default.Children.map(children, function (child) {
          if (child.type === 'img') {
            return _react2.default.cloneElement(child, {
              key: 'img',
              ref: 'img',
              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
            });
          } else {
            return child;
          }
        });
      }

      var containerProps = (0, _extends3.default)({
        style: prepareStyles(mergedRootStyles)
      }, other);

      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
    }
  }]);
  return GridTile;
}(_react.Component);

GridTile.defaultProps = {
  titlePosition: 'bottom',
  titleBackground: 'rgba(0, 0, 0, 0.4)',
  actionPosition: 'right',
  cols: 1,
  rows: 1,
  containerElement: 'div'
};
GridTile.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
GridTile.propTypes =  false ? {
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: _propTypes2.default.element,
  /**
   * Position of secondary action IconButton.
   */
  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in whichcase GridTile takes care of making the image "cover" available space
   * (similar to background-size: cover or to object-fit:cover).
   */
  children: _propTypes2.default.node,
  /**
   * Width of the tile in number of grid cells.
   */
  cols: _propTypes2.default.number,
  /**
   * Either a string used as tag name for the tile root element, or a ReactElement.
   * This is useful when you have, for example, a custom implementation of
   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
   * In case you pass a ReactElement, please ensure that it passes all props,
   * accepts styles overrides and render it's children.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * Height of the tile in number of grid cells.
   */
  rows: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the inline-styles of the subtitle element.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Title to be displayed on tile.
   */
  title: _propTypes2.default.node,
  /**
   * Style used for title bar background.
   * Useful for setting custom gradients for example
   */
  titleBackground: _propTypes2.default.string,
  /**
   * Position of the title bar (container of title, subtitle and action icon).
   */
  titlePosition: _propTypes2.default.oneOf(['top', 'bottom']),
  /**
   * Override the inline-styles of the title element.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = GridTile;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;

var _List2 = __webpack_require__(348);

var _List3 = _interopRequireDefault(_List2);

var _ListItem2 = __webpack_require__(347);

var _ListItem3 = _interopRequireDefault(_ListItem2);

var _makeSelectable2 = __webpack_require__(498);

var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.List = _List3.default;
exports.ListItem = _ListItem3.default;
exports.makeSelectable = _makeSelectable3.default;
exports.default = _List3.default;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedSwitch = __webpack_require__(507);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

var _radioButtonUnchecked = __webpack_require__(777);

var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);

var _radioButtonChecked = __webpack_require__(778);

var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var radioButton = context.muiTheme.radioButton;


  return {
    icon: {
      height: radioButton.size,
      width: radioButton.size
    },
    target: {
      transition: _transitions2.default.easeOut(),
      position: 'absolute',
      opacity: 1,
      transform: 'scale(1)',
      fill: radioButton.borderColor
    },
    fill: {
      position: 'absolute',
      opacity: 1,
      transform: 'scale(0)',
      transformOrigin: '50% 50%',
      transition: _transitions2.default.easeOut(),
      fill: radioButton.checkedColor
    },
    targetWhenChecked: {
      opacity: 0,
      transform: 'scale(0)'
    },
    fillWhenChecked: {
      opacity: 1,
      transform: 'scale(1)'
    },
    targetWhenDisabled: {
      fill: radioButton.disabledColor
    },
    fillWhenDisabled: {
      fill: radioButton.disabledColor
    },
    label: {
      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
    },
    ripple: {
      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
    }
  };
}

var RadioButton = function (_Component) {
  (0, _inherits3.default)(RadioButton, _Component);

  function RadioButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RadioButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
      if (_this.props.onCheck) {
        _this.props.onCheck(event, _this.props.value);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // Only called when selected, not when unselected.


  (0, _createClass3.default)(RadioButton, [{
    key: 'isChecked',
    value: function isChecked() {
      return this.refs.enhancedSwitch.isSwitched();
    }

    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
    // RadioButton's checked value.

  }, {
    key: 'setChecked',
    value: function setChecked(newCheckedValue) {
      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.refs.enhancedSwitch.getValue();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checkedIcon = _props.checkedIcon,
          checked = _props.checked,
          iconStyle = _props.iconStyle,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          onCheck = _props.onCheck,
          uncheckedIcon = _props.uncheckedIcon,
          disabled = _props.disabled,
          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);


      var styles = getStyles(this.props, this.context);

      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);

      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);

      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });

      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });

      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);

      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
        ref: 'enhancedSwitch',
        inputType: 'radio',
        checked: checked,
        switched: checked,
        disabled: disabled,
        rippleColor: styles.ripple.color,
        iconStyle: mergedIconStyle,
        labelStyle: mergedLabelStyle,
        labelPosition: labelPosition,
        onSwitch: this.handleSwitch,
        switchElement: _react2.default.createElement(
          'div',
          null,
          uncheckedElement,
          checkedElement
        )
      }));
    }
  }]);
  return RadioButton;
}(_react.Component);

RadioButton.defaultProps = {
  checked: false,
  disabled: false,
  labelPosition: 'right'
};
RadioButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RadioButton.propTypes =  false ? {
  /**
   * @ignore
   * checked if true
   * Used internally by `RadioButtonGroup`.
   */
  checked: _propTypes2.default.bool,
  /**
   * The icon element to show when the radio button is checked.
   */
  checkedIcon: _propTypes2.default.element,
  /**
   * If true, the radio button is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the input element.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * @ignore
   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
   * Where the label will be placed next to the radio button.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Override the inline-styles of the label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * @ignore
   * Callback function fired when the radio button is checked. Note that this
   * function will not be called if the radio button is part of a
   * radio button group: in this case, use the `onChange` property of
   * `RadioButtonGroup`.
   *
   * @param {object} event `change` event targeting the element.
   * @param {string} value The element's `value`.
   */
  onCheck: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The icon element to show when the radio button is unchecked.
   */
  uncheckedIcon: _propTypes2.default.element,
  /**
   * The value of the radio button.
   */
  value: _propTypes2.default.any
} : {};
exports.default = RadioButton;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
ToggleRadioButtonUnchecked.muiName = 'SvgIcon';

exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
ToggleRadioButtonChecked.muiName = 'SvgIcon';

exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RadioButton = __webpack_require__(776);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButtonGroup = function (_Component) {
  (0, _inherits3.default)(RadioButtonGroup, _Component);

  function RadioButtonGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RadioButtonGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      numberCheckedRadioButtons: 0,
      selected: ''
    }, _this.handleChange = function (event, newSelection) {
      _this.updateRadioButtons(newSelection);

      // Successful update
      if (_this.state.numberCheckedRadioButtons === 0) {
        if (_this.props.onChange) _this.props.onChange(event, newSelection);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RadioButtonGroup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var cnt = 0;
      var selected = '';
      var _props = this.props,
          valueSelected = _props.valueSelected,
          defaultSelected = _props.defaultSelected;

      if (valueSelected !== undefined) {
        selected = valueSelected;
      } else if (defaultSelected !== undefined) {
        selected = defaultSelected;
      }

      _react2.default.Children.forEach(this.props.children, function (option) {
        if (_this2.hasCheckAttribute(option)) cnt++;
      }, this);

      this.setState({
        numberCheckedRadioButtons: cnt,
        selected: selected
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasOwnProperty('valueSelected')) {
        this.setState({
          selected: nextProps.valueSelected
        });
      }
    }
  }, {
    key: 'hasCheckAttribute',
    value: function hasCheckAttribute(radioButton) {
      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
    }
  }, {
    key: 'updateRadioButtons',
    value: function updateRadioButtons(newSelection) {
      if (this.state.numberCheckedRadioButtons === 0) {
        this.setState({ selected: newSelection });
      } else {
         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
      }
    }
  }, {
    key: 'getSelectedValue',
    value: function getSelectedValue() {
      return this.state.selected;
    }
  }, {
    key: 'setSelectedValue',
    value: function setSelectedValue(newSelectionValue) {
      this.updateRadioButtons(newSelectionValue);
    }
  }, {
    key: 'clearValue',
    value: function clearValue() {
      this.setSelectedValue('');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var prepareStyles = this.context.muiTheme.prepareStyles;


      var options = _react2.default.Children.map(this.props.children, function (option) {
        var _option$props = option.props,
            name = _option$props.name,
            value = _option$props.value,
            label = _option$props.label,
            onCheck = _option$props.onCheck,
            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);


        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
          ref: option.props.value,
          name: _this3.props.name,
          key: option.props.value,
          value: option.props.value,
          label: option.props.label,
          labelPosition: _this3.props.labelPosition,
          onCheck: _this3.handleChange,
          checked: option.props.value === _this3.state.selected
        }));
      }, this);

      return _react2.default.createElement(
        'div',
        {
          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
          className: this.props.className
        },
        options
      );
    }
  }]);
  return RadioButtonGroup;
}(_react.Component);

RadioButtonGroup.defaultProps = {
  style: {}
};
RadioButtonGroup.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RadioButtonGroup.propTypes =  false ? {
  /**
   * Should be used to pass `RadioButton` components.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The `value` property of the radio button that will be
   * selected by default. This takes precedence over the `checked` property
   * of the `RadioButton` elements.
   */
  defaultSelected: _propTypes2.default.any,
  /**
   * Where the label will be placed for all child radio buttons.
   * This takes precedence over the `labelPosition` property of the
   * `RadioButton` elements.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * The name that will be applied to all child radio buttons.
   */
  name: _propTypes2.default.string.isRequired,
  /**
   * Callback function that is fired when a radio button has
   * been checked.
   *
   * @param {object} event `change` event targeting the selected
   * radio button.
   * @param {*} value The `value` of the selected radio button.
   */
  onChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The `value` of the currently selected radio button.
   */
  valueSelected: _propTypes2.default.any
} : {};
exports.default = RadioButtonGroup;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _typeof2 = __webpack_require__(251);

var _typeof3 = _interopRequireDefault(_typeof2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkCircle = __webpack_require__(512);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyles = function getStyles(_ref, _ref2) {
  var active = _ref.active,
      completed = _ref.completed,
      disabled = _ref.disabled;
  var muiTheme = _ref2.muiTheme,
      stepper = _ref2.stepper;
  var _muiTheme$stepper = muiTheme.stepper,
      textColor = _muiTheme$stepper.textColor,
      disabledTextColor = _muiTheme$stepper.disabledTextColor,
      iconColor = _muiTheme$stepper.iconColor,
      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
  var baseTheme = muiTheme.baseTheme;
  var orientation = stepper.orientation;


  var styles = {
    root: {
      height: orientation === 'horizontal' ? 72 : 64,
      color: textColor,
      display: 'flex',
      alignItems: 'center',
      fontFamily: baseTheme.fontFamily,
      fontSize: 14,
      paddingLeft: 14,
      paddingRight: 14
    },
    icon: {
      color: iconColor,
      display: 'block',
      fontSize: 24,
      width: 24,
      height: 24
    },
    iconContainer: {
      paddingRight: 8
    }
  };

  if (active) {
    styles.root.fontWeight = 500;
  }

  if (!completed && !active) {
    styles.icon.color = inactiveIconColor;
  }

  if (disabled) {
    styles.icon.color = inactiveIconColor;
    styles.root.color = disabledTextColor;
    styles.root.cursor = 'default';
  }

  return styles;
};

var renderIcon = function renderIcon(completed, icon, styles) {
  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);

  if (iconType === 'number' || iconType === 'string') {
    if (completed) {
      return _react2.default.createElement(_checkCircle2.default, {
        color: styles.icon.color,
        style: styles.icon
      });
    }

    return _react2.default.createElement(
      _SvgIcon2.default,
      { color: styles.icon.color, style: styles.icon },
      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
      _react2.default.createElement(
        'text',
        {
          x: '12',
          y: '16',
          textAnchor: 'middle',
          fontSize: '12',
          fill: '#fff'
        },
        icon
      )
    );
  }

  return icon;
};

var StepLabel = function StepLabel(props, context) {
  var active = props.active,
      children = props.children,
      completed = props.completed,
      userIcon = props.icon,
      iconContainerStyle = props.iconContainerStyle,
      last = props.last,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
  var prepareStyles = context.muiTheme.prepareStyles;

  var styles = getStyles(props, context);
  var icon = renderIcon(completed, userIcon, styles);

  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
    icon && _react2.default.createElement(
      'span',
      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
      icon
    ),
    children
  );
};

StepLabel.muiName = 'StepLabel';

StepLabel.propTypes =  false ? {
  /**
   * Sets active styling. Overrides disabled coloring.
   */
  active: _propTypes2.default.bool,
  /**
   * The label text node
   */
  children: _propTypes2.default.node,
  /**
   * Sets completed styling. Overrides disabled coloring.
   */
  completed: _propTypes2.default.bool,
  /**
   * Sets disabled styling.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Override the inline-styles of the icon container element.
   */
  iconContainerStyle: _propTypes2.default.object,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * Override the inline-style of the root element.
   */
  style: _propTypes2.default.object
} : {};

StepLabel.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired,
  stepper: _propTypes2.default.object
};

exports.default = StepLabel;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    root: {
      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
      fontWeight: 500,
      fontSize: 14,
      width: props.width,
      textTransform: 'uppercase',
      padding: 0
    },
    button: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: props.label && props.icon ? 72 : 48
    }
  };
}

var Tab = function (_Component) {
  (0, _inherits3.default)(Tab, _Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(_this.props.value, event, _this);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          index = _props.index,
          onActive = _props.onActive,
          onClick = _props.onClick,
          selected = _props.selected,
          label = _props.label,
          buttonStyle = _props.buttonStyle,
          style = _props.style,
          value = _props.value,
          width = _props.width,
          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onClick', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);


      var styles = getStyles(this.props, this.context);

      var iconElement = void 0;
      if (icon && _react2.default.isValidElement(icon)) {
        iconElement = _react2.default.cloneElement(icon, {
          style: {
            fontSize: 24,
            color: icon.props && icon.props.style && icon.props.style.color ? icon.props.style.color : styles.root.color,
            marginBottom: label ? 5 : 0
          }
        });
      }

      var rippleOpacity = 0.3;
      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          style: (0, _simpleAssign2.default)(styles.root, style),
          focusRippleColor: rippleColor,
          touchRippleColor: rippleColor,
          focusRippleOpacity: rippleOpacity,
          touchRippleOpacity: rippleOpacity,
          onClick: this.handleClick
        }),
        _react2.default.createElement(
          'div',
          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
          iconElement,
          label
        )
      );
    }
  }]);
  return Tab;
}(_react.Component);

Tab.muiName = 'Tab';
Tab.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tab.propTypes =  false ? {
  /**
   * Override the inline-styles of the button element.
   */
  buttonStyle: _propTypes2.default.object,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   */
  index: _propTypes2.default.any,
  /**
   * Sets the text value of the tab item to the string specified.
   */
  label: _propTypes2.default.node,
  /**
   * Fired when the active tab changes by touch or tap.
   * Use this event to specify any functionality when an active tab changes.
   * For example - we are using this to route to home when the third tab becomes active.
   * This function will always recieve the active tab as it\'s first argument.
   */
  onActive: _propTypes2.default.func,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   * Defines if the current tab is selected or not.
   * The Tabs component is responsible for setting this property.
   */
  selected: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * If value prop passed to Tabs component, this value prop is also required.
   * It assigns a value to the tab so that it can be selected by the Tabs.
   */
  value: _propTypes2.default.any,
  /**
   * @ignore
   * This property is overriden by the Tabs component.
   */
  width: _propTypes2.default.string
} : {};
exports.default = Tab;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(220);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__(251);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(57);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TableRowColumn = __webpack_require__(354);

var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);

var _ClickAwayListener = __webpack_require__(503);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableBody = function (_Component) {
  (0, _inherits3.default)(TableBody, _Component);

  function TableBody() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableBody);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedRows: []
    }, _this.isControlled = false, _this.handleClickAway = function () {
      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length > 0) {
        var selectedRows = [];
        _this.setState({ selectedRows: selectedRows });
        if (_this.props.onRowSelection) {
          _this.props.onRowSelection(selectedRows);
        }
      }
    }, _this.onRowClick = function (event, rowNumber) {
      event.stopPropagation();

      if (_this.props.selectable) {
        // Prevent text selection while selecting rows.
        if (window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects.length > 0) {
          window.getSelection().removeAllRanges();
        }
        _this.processRowSelection(event, rowNumber);
      }
    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
      event.stopPropagation();
      if (_this.props.onCellClick) {
        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
      }
    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
      if (_this.props.onCellHover) {
        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
      }
      _this.onRowHover(event, rowNumber);
    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
      if (_this.props.onCellHoverExit) {
        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
      }
      _this.onRowHoverExit(event, rowNumber);
    }, _this.onRowHover = function (event, rowNumber) {
      if (_this.props.onRowHover) {
        _this.props.onRowHover(rowNumber);
      }
    }, _this.onRowHoverExit = function (event, rowNumber) {
      if (_this.props.onRowHoverExit) {
        _this.props.onRowHoverExit(rowNumber);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableBody, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.preScanRows) {
        this.setState({
          selectedRows: this.getSelectedRows(this.props)
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.preScanRows) {
        this.setState({ // eslint-disable-line react/no-did-mount-set-state
          selectedRows: this.getSelectedRows(this.props)
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
        if (!nextProps.allRowsSelected) {
          this.setState({
            selectedRows: []
          });
          return;
        }
      }

      this.setState({
        selectedRows: this.getSelectedRows(nextProps)
      });
    }
  }, {
    key: 'createRows',
    value: function createRows() {
      var _this2 = this;

      var numChildren = _react2.default.Children.count(this.props.children);
      var rowNumber = 0;
      var handlers = {
        onCellClick: this.onCellClick,
        onCellHover: this.onCellHover,
        onCellHoverExit: this.onCellHoverExit,
        onRowHover: this.onRowHover,
        onRowHoverExit: this.onRowHoverExit,
        onRowClick: this.onRowClick
      };

      return _react2.default.Children.map(this.props.children, function (child) {
        if (_react2.default.isValidElement(child)) {
          var props = {
            hoverable: _this2.props.showRowHover,
            selected: _this2.isRowSelected(rowNumber),
            striped: _this2.props.stripedRows && rowNumber % 2 === 0,
            rowNumber: rowNumber++
          };

          if (rowNumber === numChildren) {
            props.displayBorder = false;
          }

          var children = [_this2.createRowCheckboxColumn(props)];

          _react2.default.Children.forEach(child.props.children, function (child) {
            children.push(child);
          });

          return _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children);
        }
      });
    }
  }, {
    key: 'createRowCheckboxColumn',
    value: function createRowCheckboxColumn(rowProps) {
      if (!this.props.displayRowCheckbox) {
        return null;
      }

      var name = rowProps.rowNumber + '-cb';
      var disabled = !this.props.selectable;

      return _react2.default.createElement(
        _TableRowColumn2.default,
        {
          key: name,
          columnNumber: 0,
          style: {
            width: 24,
            cursor: disabled ? 'default' : 'inherit'
          }
        },
        _react2.default.createElement(_Checkbox2.default, {
          name: name,
          value: 'selected',
          disabled: disabled,
          checked: rowProps.selected
        })
      );
    }
  }, {
    key: 'getSelectedRows',
    value: function getSelectedRows(props) {
      var _this3 = this;

      var selectedRows = [];

      if (props.selectable) {
        var index = 0;
        _react2.default.Children.forEach(props.children, function (child) {
          if (_react2.default.isValidElement(child)) {
            if (child.props.selected !== undefined) {
              _this3.isControlled = true;
            }

            if (child.props.selected && (selectedRows.length === 0 || props.multiSelectable)) {
              selectedRows.push(index);
            }

            index++;
          }
        });
      }

      return selectedRows;
    }
  }, {
    key: 'isRowSelected',
    value: function isRowSelected(rowNumber) {
      var _this4 = this;

      if (this.props.allRowsSelected) {
        return true;
      }

      return this.state.selectedRows.some(function (row) {
        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
          if (_this4.isValueInRange(rowNumber, row)) {
            return true;
          }
        } else {
          if (row === rowNumber) {
            return true;
          }
        }

        return false;
      });
    }
  }, {
    key: 'isValueInRange',
    value: function isValueInRange(value, range) {
      if (!range) return false;

      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
        return true;
      }

      return false;
    }
  }, {
    key: 'processRowSelection',
    value: function processRowSelection(event, rowNumber) {
      var selectedRows = [].concat((0, _toConsumableArray3.default)(this.state.selectedRows));

      if (event.shiftKey && this.props.multiSelectable && selectedRows.length > 0) {
        var lastIndex = selectedRows.length - 1;
        var lastSelection = selectedRows[lastIndex];

        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
          lastSelection.end = rowNumber;
        } else {
          selectedRows.splice(lastIndex, 1, {
            start: lastSelection,
            end: rowNumber
          });
        }
      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
        var idx = selectedRows.indexOf(rowNumber);
        if (idx < 0) {
          var foundRange = false;
          for (var i = 0; i < selectedRows.length; i++) {
            var range = selectedRows[i];
            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;

            if (this.isValueInRange(rowNumber, range)) {
              var _selectedRows;

              foundRange = true;
              var values = this.splitRange(range, rowNumber);
              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
            }
          }

          if (!foundRange) selectedRows.push(rowNumber);
        } else {
          selectedRows.splice(idx, 1);
        }
      } else {
        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
          selectedRows = [];
        } else {
          selectedRows = [rowNumber];
        }
      }

      if (!this.isControlled) {
        this.setState({ selectedRows: selectedRows });
      }

      if (this.props.onRowSelection) {
        this.props.onRowSelection(this.flattenRanges(selectedRows));
      }
    }
  }, {
    key: 'splitRange',
    value: function splitRange(range, splitPoint) {
      var splitValues = [];
      var startOffset = range.start - splitPoint;
      var endOffset = range.end - splitPoint;

      // Process start half
      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));

      // Process end half
      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));

      return splitValues;
    }
  }, {
    key: 'genRangeOfValues',
    value: function genRangeOfValues(start, offset) {
      var values = [];
      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
      while (offset !== 0) {
        values.push(start + offset);
        offset += dir;
      }

      return values;
    }
  }, {
    key: 'flattenRanges',
    value: function flattenRanges(selectedRows) {
      var _this5 = this;

      return selectedRows.reduce(function (rows, row) {
        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
          var values = _this5.genRangeOfValues(row.end, row.start - row.end);
          rows.push.apply(rows, [row.end].concat((0, _toConsumableArray3.default)(values)));
        } else {
          rows.push(row);
        }

        return rows;
      }, []).sort();
    }
  }, {
    key: 'getColumnId',
    value: function getColumnId(columnNumber) {
      return columnNumber - 1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          allRowsSelected = _props.allRowsSelected,
          multiSelectable = _props.multiSelectable,
          onCellClick = _props.onCellClick,
          onCellHover = _props.onCellHover,
          onCellHoverExit = _props.onCellHoverExit,
          onRowHover = _props.onRowHover,
          onRowHoverExit = _props.onRowHoverExit,
          onRowSelection = _props.onRowSelection,
          selectable = _props.selectable,
          deselectOnClickaway = _props.deselectOnClickaway,
          showRowHover = _props.showRowHover,
          stripedRows = _props.stripedRows,
          displayRowCheckbox = _props.displayRowCheckbox,
          preScanRows = _props.preScanRows,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'allRowsSelected', 'multiSelectable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowHover', 'onRowHoverExit', 'onRowSelection', 'selectable', 'deselectOnClickaway', 'showRowHover', 'stripedRows', 'displayRowCheckbox', 'preScanRows']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.handleClickAway },
        _react2.default.createElement(
          'tbody',
          (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
          this.createRows()
        )
      );
    }
  }]);
  return TableBody;
}(_react.Component);

TableBody.muiName = 'TableBody';
TableBody.defaultProps = {
  allRowsSelected: false,
  deselectOnClickaway: true,
  displayRowCheckbox: true,
  multiSelectable: false,
  preScanRows: true,
  selectable: true,
  style: {}
};
TableBody.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableBody.propTypes =  false ? {
  /**
   * @ignore
   * Set to true to indicate that all rows should be selected.
   */
  allRowsSelected: _propTypes2.default.bool,
  /**
   * Children passed to table body.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Controls whether or not to deselect all selected
   * rows after clicking outside the table.
   */
  deselectOnClickaway: _propTypes2.default.bool,
  /**
   * Controls the display of the row checkbox. The default value is true.
   */
  displayRowCheckbox: _propTypes2.default.bool,
  /**
   * @ignore
   * If true, multiple table rows can be selected.
   * CTRL/CMD+Click and SHIFT+Click are valid actions.
   * The default value is false.
   */
  multiSelectable: _propTypes2.default.bool,
  /**
   * @ignore
   * Callback function for when a cell is clicked.
   */
  onCellClick: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is hovered. rowNumber
   * is the row number of the hovered row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is no longer hovered.
   * rowNumber is the row number of the row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHoverExit: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is hovered.
   * rowNumber is the row number of the hovered row.
   */
  onRowHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is no longer
   * hovered. rowNumber is the row number of the row
   * that is no longer hovered.
   */
  onRowHoverExit: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a row is selected. selectedRows is an
   * array of all row selections. If all rows have been selected,
   * the string "all" will be returned instead to indicate that
   * all rows have been selected.
   */
  onRowSelection: _propTypes2.default.func,
  /**
   * Controls whether or not the rows are pre-scanned to determine
   * initial state. If your table has a large number of rows and
   * you are experiencing a delay in rendering, turn off this property.
   */
  preScanRows: _propTypes2.default.bool,
  /**
   * @ignore
   * If true, table rows can be selected. If multiple
   * row selection is desired, enable multiSelectable.
   * The default value is true.
   */
  selectable: _propTypes2.default.bool,
  /**
   * If true, table rows will be highlighted when
   * the cursor is hovering over the row. The default
   * value is false.
   */
  showRowHover: _propTypes2.default.bool,
  /**
   * If true, every other table row starting
   * with the first row will be striped. The default value is false.
   */
  stripedRows: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableBody;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(220);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TableRowColumn = __webpack_require__(354);

var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableFooter = context.muiTheme.tableFooter;


  return {
    cell: {
      borderTop: '1px solid ' + tableFooter.borderColor,
      verticalAlign: 'bottom',
      padding: 20,
      textAlign: 'left',
      whiteSpace: 'nowrap'
    }
  };
}

var TableFooter = function (_Component) {
  (0, _inherits3.default)(TableFooter, _Component);

  function TableFooter() {
    (0, _classCallCheck3.default)(this, TableFooter);
    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          adjustForCheckbox = _props.adjustForCheckbox,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
        var newChildProps = {
          displayBorder: false,
          key: 'f-' + rowNumber,
          rowNumber: rowNumber,
          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
        };

        var newDescendants = void 0;

        if (adjustForCheckbox) {
          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
        } else {
          newDescendants = child.props.children;
        }

        return _react2.default.cloneElement(child, newChildProps, newDescendants);
      });

      return _react2.default.createElement(
        'tfoot',
        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
        footerRows
      );
    }
  }]);
  return TableFooter;
}(_react.Component);

TableFooter.muiName = 'TableFooter';
TableFooter.defaultProps = {
  adjustForCheckbox: true,
  style: {}
};
TableFooter.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableFooter.propTypes =  false ? {
  /**
   * @ignore
   * Controls whether or not header rows should be adjusted
   * for a checkbox column. If the select all checkbox is true,
   * this property will not influence the number of columns.
   * This is mainly useful for "super header" rows so that
   * the checkbox column does not create an offset that needs
   * to be accounted for manually.
   */
  adjustForCheckbox: _propTypes2.default.bool,
  /**
   * Children passed to table footer.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableFooter;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(57);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TableHeaderColumn = __webpack_require__(514);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tableHeader = context.muiTheme.tableHeader;


  return {
    root: {
      borderBottom: '1px solid ' + tableHeader.borderColor
    }
  };
}

var TableHeader = function (_Component) {
  (0, _inherits3.default)(TableHeader, _Component);

  function TableHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
      if (_this.props.onSelectAll) {
        _this.props.onSelectAll(checked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableHeader, [{
    key: 'createSuperHeaderRows',
    value: function createSuperHeaderRows() {
      var numChildren = _react2.default.Children.count(this.props.children);
      if (numChildren === 1) return undefined;

      var superHeaders = [];
      for (var index = 0; index < numChildren - 1; index++) {
        var child = this.props.children[index];

        if (!_react2.default.isValidElement(child)) continue;

        var props = {
          key: 'sh' + index,
          rowNumber: index
        };
        superHeaders.push(this.createSuperHeaderRow(child, props));
      }

      if (superHeaders.length) return superHeaders;
    }
  }, {
    key: 'createSuperHeaderRow',
    value: function createSuperHeaderRow(child, props) {
      var children = [];
      if (this.props.adjustForCheckbox) {
        children.push(this.getCheckboxPlaceholder(props));
      }
      _react2.default.Children.forEach(child.props.children, function (child) {
        children.push(child);
      });

      return _react2.default.cloneElement(child, props, children);
    }
  }, {
    key: 'createBaseHeaderRow',
    value: function createBaseHeaderRow() {
      var childrenArray = _react2.default.Children.toArray(this.props.children);
      var numChildren = childrenArray.length;
      if (numChildren < 1) {
        return null;
      }

      var child = childrenArray[numChildren - 1];

      var props = {
        key: 'h' + numChildren,
        rowNumber: numChildren
      };

      var children = [this.getSelectAllCheckboxColumn(props)];
      _react2.default.Children.forEach(child.props.children, function (child) {
        children.push(child);
      });

      return _react2.default.cloneElement(child, props, children);
    }
  }, {
    key: 'getCheckboxPlaceholder',
    value: function getCheckboxPlaceholder(props) {
      if (!this.props.adjustForCheckbox) return null;

      var disabled = !this.props.enableSelectAll;
      var key = 'hpcb' + props.rowNumber;
      return _react2.default.createElement(_TableHeaderColumn2.default, {
        key: key,
        style: {
          width: 24,
          cursor: disabled ? 'default' : 'inherit'
        }
      });
    }
  }, {
    key: 'getSelectAllCheckboxColumn',
    value: function getSelectAllCheckboxColumn(props) {
      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);

      var disabled = !this.props.enableSelectAll;
      var checkbox = _react2.default.createElement(_Checkbox2.default, {
        key: 'selectallcb',
        name: 'selectallcb',
        value: 'selected',
        disabled: disabled,
        checked: this.props.selectAllSelected,
        onCheck: this.handleCheckAll
      });

      var key = 'hpcb' + props.rowNumber;
      return _react2.default.createElement(
        _TableHeaderColumn2.default,
        {
          key: key,
          style: {
            width: 24,
            cursor: disabled ? 'not-allowed' : 'inherit'
          }
        },
        checkbox
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var superHeaderRows = this.createSuperHeaderRows();
      var baseHeaderRow = this.createBaseHeaderRow();

      return _react2.default.createElement(
        'thead',
        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        superHeaderRows,
        baseHeaderRow
      );
    }
  }]);
  return TableHeader;
}(_react.Component);

TableHeader.muiName = 'TableHeader';
TableHeader.defaultProps = {
  adjustForCheckbox: true,
  displaySelectAll: true,
  enableSelectAll: true,
  selectAllSelected: false
};
TableHeader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableHeader.propTypes =  false ? {
  /**
   * Controls whether or not header rows should be
   * adjusted for a checkbox column. If the select all
   * checkbox is true, this property will not influence
   * the number of columns. This is mainly useful for
   * "super header" rows so that the checkbox column
   * does not create an offset that needs to be accounted
   * for manually.
   */
  adjustForCheckbox: _propTypes2.default.bool,
  /**
   * Children passed to table header.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Controls whether or not the select all checkbox is displayed.
   */
  displaySelectAll: _propTypes2.default.bool,
  /**
   * If set to true, the select all button will be interactable.
   * If set to false, the button will not be interactable.
   * To hide the checkbox, set displaySelectAll to false.
   */
  enableSelectAll: _propTypes2.default.bool,
  /**
   * @ignore
   * Callback when select all has been checked.
   */
  onSelectAll: _propTypes2.default.func,
  /**
   * @ignore
   * True when select all has been checked.
   */
  selectAllSelected: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableHeader;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var tableRow = context.muiTheme.tableRow;


  var cellBgColor = 'inherit';
  if (props.hovered || state.hovered) {
    cellBgColor = tableRow.hoverColor;
  } else if (props.selected) {
    cellBgColor = tableRow.selectedColor;
  } else if (props.striped) {
    cellBgColor = tableRow.stripeColor;
  }

  return {
    root: {
      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
      color: tableRow.textColor,
      height: tableRow.height
    },
    cell: {
      backgroundColor: cellBgColor
    }
  };
}

var TableRow = function (_Component) {
  (0, _inherits3.default)(TableRow, _Component);

  function TableRow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.onCellClick = function (event, columnIndex) {
      if (_this.props.selectable && _this.props.onCellClick) {
        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
      }
      event.ctrlKey = true;
      _this.onRowClick(event);
    }, _this.onCellHover = function (event, columnIndex) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: true });
        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
        _this.onRowHover(event);
      }
    }, _this.onCellHoverExit = function (event, columnIndex) {
      if (_this.props.hoverable) {
        _this.setState({ hovered: false });
        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
        _this.onRowHoverExit(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableRow, [{
    key: 'onRowClick',
    value: function onRowClick(event) {
      if (this.props.selectable && this.props.onRowClick) {
        this.props.onRowClick(event, this.props.rowNumber);
      }
    }
  }, {
    key: 'onRowHover',
    value: function onRowHover(event) {
      if (this.props.onRowHover) {
        this.props.onRowHover(event, this.props.rowNumber);
      }
    }
  }, {
    key: 'onRowHoverExit',
    value: function onRowHoverExit(event) {
      if (this.props.onRowHoverExit) {
        this.props.onRowHoverExit(event, this.props.rowNumber);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          displayBorder = _props.displayBorder,
          hoverable = _props.hoverable,
          hovered = _props.hovered,
          onCellClick = _props.onCellClick,
          onCellHover = _props.onCellHover,
          onCellHoverExit = _props.onCellHoverExit,
          onRowClick = _props.onRowClick,
          onRowHover = _props.onRowHover,
          onRowHoverExit = _props.onRowHoverExit,
          rowNumber = _props.rowNumber,
          selectable = _props.selectable,
          selected = _props.selected,
          striped = _props.striped,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
        if (_react2.default.isValidElement(child)) {
          return _react2.default.cloneElement(child, {
            columnNumber: columnNumber,
            hoverable: _this2.props.hoverable,
            key: _this2.props.rowNumber + '-' + columnNumber,
            onClick: _this2.onCellClick,
            onHover: _this2.onCellHover,
            onHoverExit: _this2.onCellHoverExit,
            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
          });
        }
      });

      return _react2.default.createElement(
        'tr',
        (0, _extends3.default)({
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, other),
        rowColumns
      );
    }
  }]);
  return TableRow;
}(_react.Component);

TableRow.defaultProps = {
  displayBorder: true,
  hoverable: false,
  hovered: false,
  selectable: true,
  striped: false
};
TableRow.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TableRow.propTypes =  false ? {
  /**
   * Children passed to table row.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, row border will be displayed for the row.
   * If false, no border will be drawn.
   */
  displayBorder: _propTypes2.default.bool,
  /**
   * Controls whether or not the row responds to hover events.
   */
  hoverable: _propTypes2.default.bool,
  /**
   * Controls whether or not the row should be rendered as being
   * hovered. This property is evaluated in addition to this.state.hovered
   * and can be used to synchronize the hovered state with some other
   * external events.
   */
  hovered: _propTypes2.default.bool,
  /**
   * @ignore
   * Called when a row cell is clicked.
   * rowNumber is the row number and columnId is
   * the column number or the column key.
   */
  onCellClick: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is hovered.
   * rowNumber is the row number of the hovered row
   * and columnId is the column number or the column key of the cell.
   */
  onCellHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table cell is no longer hovered.
   * rowNumber is the row number of the row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHoverExit: _propTypes2.default.func,
  /**
   * @ignore
   * Called when row is clicked.
   */
  onRowClick: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is hovered.
   * rowNumber is the row number of the hovered row.
   */
  onRowHover: _propTypes2.default.func,
  /**
   * @ignore
   * Called when a table row is no longer hovered.
   * rowNumber is the row number of the row that is no longer hovered.
   */
  onRowHoverExit: _propTypes2.default.func,
  /**
   * Number to identify the row. This property is
   * automatically populated when used with the TableBody component.
   */
  rowNumber: _propTypes2.default.number,
  /**
   * If true, table rows can be selected. If multiple row
   * selection is desired, enable multiSelectable.
   * The default value is true.
   */
  selectable: _propTypes2.default.bool,
  /**
   * Indicates that a particular row is selected.
   * This property can be used to programmatically select rows.
   */
  selected: _propTypes2.default.bool,
  /**
   * Indicates whether or not the row is striped.
   */
  striped: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = TableRow;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TimePicker = __webpack_require__(1851);

var _TimePicker2 = _interopRequireDefault(_TimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TimePicker2.default;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = __webpack_require__(510);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _timeUtils = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var styles = {
    root: {
      directionInvariant: true,
      display: 'inline-block',
      position: 'absolute',
      width: 32,
      height: 32,
      borderRadius: '100%',
      left: 'calc(50% - 16px)',
      top: 10,
      textAlign: 'center',
      paddingTop: 5,
      userSelect: 'none', /* Chrome all / Safari all */
      fontSize: '1.1em',
      pointerEvents: 'none',
      boxSizing: 'border-box'
    }
  };

  var muiTheme = context.muiTheme;


  var pos = props.value;

  if (props.type === 'hour') {
    pos %= 12;
  } else {
    pos = pos / 5;
  }

  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];

  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];

  if (props.isSelected) {
    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
    styles.root.color = muiTheme.timePicker.selectTextColor;
  }

  var transformPos = positions[pos];

  if ((0, _timeUtils.isInner)(props)) {
    styles.root.width = 28;
    styles.root.height = 28;
    styles.root.left = 'calc(50% - 14px)';
    transformPos = innerPositions[pos];
  }

  var _transformPos = transformPos,
      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
      x = _transformPos2[0],
      y = _transformPos2[1];

  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';

  return styles;
}

var ClockNumber = function (_Component) {
  (0, _inherits3.default)(ClockNumber, _Component);

  function ClockNumber() {
    (0, _classCallCheck3.default)(this, ClockNumber);
    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
  }

  (0, _createClass3.default)(ClockNumber, [{
    key: 'render',
    value: function render() {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var clockNumber = this.props.value === 0 ? '00' : this.props.value;

      return _react2.default.createElement(
        'span',
        { style: prepareStyles(styles.root) },
        clockNumber
      );
    }
  }]);
  return ClockNumber;
}(_react.Component);

ClockNumber.defaultProps = {
  value: 0,
  type: 'minute',
  isSelected: false
};
ClockNumber.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ClockNumber.propTypes =  false ? {
  isSelected: _propTypes2.default.bool,
  onSelected: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['hour', 'minute']),
  value: _propTypes2.default.number
} : {};
exports.default = ClockNumber;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _timeUtils = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calcAngle(value, base) {
  value %= base;
  var angle = 360 / base * value;
  return angle;
}

function getStyles(props, context, state) {
  var hasSelected = props.hasSelected,
      type = props.type,
      value = props.value;
  var inner = state.inner;
  var timePicker = context.muiTheme.timePicker;

  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);

  var styles = {
    root: {
      height: inner ? '30%' : '40%',
      background: timePicker.accentColor,
      width: 2,
      left: 'calc(50% - 1px)',
      position: 'absolute',
      bottom: '50%',
      transformOrigin: 'bottom',
      pointerEvents: 'none',
      transform: 'rotateZ(' + angle + 'deg)'
    },
    mark: {
      boxSizing: 'content-box',
      background: timePicker.selectTextColor,
      border: '4px solid ' + timePicker.accentColor,
      display: hasSelected && 'none',
      width: 7,
      height: 7,
      position: 'absolute',
      top: -5,
      left: -6,
      borderRadius: '100%'
    }
  };

  return styles;
}

var ClockPointer = function (_Component) {
  (0, _inherits3.default)(ClockPointer, _Component);

  function ClockPointer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClockPointer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inner: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClockPointer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        inner: (0, _timeUtils.isInner)(this.props)
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        inner: (0, _timeUtils.isInner)(nextProps)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.value === null) {
        return _react2.default.createElement('span', null);
      }

      var styles = getStyles(this.props, this.context, this.state);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      return _react2.default.createElement(
        'div',
        { style: prepareStyles(styles.root) },
        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
      );
    }
  }]);
  return ClockPointer;
}(_react.Component);

ClockPointer.defaultProps = {
  hasSelected: false,
  value: null,
  type: 'minute'
};
ClockPointer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ClockPointer.propTypes =  false ? {
  hasSelected: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['hour', 'minute']),
  value: _propTypes2.default.number
} : {};
exports.default = ClockPointer;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var firstChild = props.firstChild,
      lastChild = props.lastChild;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      button = _context$muiTheme.button,
      toolbar = _context$muiTheme.toolbar;


  var marginHorizontal = baseTheme.spacing.desktopGutter;
  var marginVertical = (toolbar.height - button.height) / 2;

  var styles = {
    root: {
      position: 'relative',
      marginLeft: firstChild ? -marginHorizontal : undefined,
      marginRight: lastChild ? -marginHorizontal : undefined,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    dropDownMenu: {
      root: {
        color: toolbar.color, // removes hover color change, we want to keep it
        marginRight: baseTheme.spacing.desktopGutter,
        flex: 1,
        whiteSpace: 'nowrap'
      },
      controlBg: {
        backgroundColor: toolbar.menuHoverColor,
        borderRadius: 0
      },
      underline: {
        display: 'none'
      }
    },
    button: {
      margin: marginVertical + 'px ' + marginHorizontal + 'px',
      position: 'relative'
    },
    icon: {
      root: {
        cursor: 'pointer',
        lineHeight: toolbar.height + 'px',
        paddingLeft: baseTheme.spacing.desktopGutter
      }
    },
    span: {
      color: toolbar.iconColor,
      lineHeight: toolbar.height + 'px'
    }
  };

  return styles;
}

var ToolbarGroup = function (_Component) {
  (0, _inherits3.default)(ToolbarGroup, _Component);

  function ToolbarGroup() {
    (0, _classCallCheck3.default)(this, ToolbarGroup);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarGroup, [{
    key: 'handleMouseLeaveFontIcon',
    value: function handleMouseLeaveFontIcon(style) {
      return function (event) {
        event.target.style.zIndex = 'auto';
        event.target.style.color = style.root.color;
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          firstChild = _props.firstChild,
          lastChild = _props.lastChild,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        if (!currentChild) {
          return null;
        }
        if (!currentChild.type) {
          return currentChild;
        }
        switch (currentChild.type.muiName) {
          case 'DropDownMenu':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
              underlineStyle: styles.dropDownMenu.underline
            });
          case 'RaisedButton':
          case 'FlatButton':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
            });
          case 'FontIcon':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
            });
          case 'ToolbarSeparator':
          case 'ToolbarTitle':
            return _react2.default.cloneElement(currentChild, {
              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
            });
          default:
            return currentChild;
        }
      }, this);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        newChildren
      );
    }
  }]);
  return ToolbarGroup;
}(_react.Component);

ToolbarGroup.defaultProps = {
  firstChild: false,
  lastChild: false
};
ToolbarGroup.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarGroup.propTypes =  false ? {
  /**
   * Can be any node or number of nodes.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
   * to prevent setting the left gap.
   */
  firstChild: _propTypes2.default.bool,
  /**
   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
   * to prevent setting the right gap.
   */
  lastChild: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ToolbarGroup;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      backgroundColor: toolbar.separatorColor,
      display: 'block',
      height: baseTheme.spacing.desktopGutterMore,
      marginLeft: baseTheme.spacing.desktopGutter,
      width: 1
    }
  };
}

var ToolbarSeparator = function (_Component) {
  (0, _inherits3.default)(ToolbarSeparator, _Component);

  function ToolbarSeparator() {
    (0, _classCallCheck3.default)(this, ToolbarSeparator);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarSeparator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
    }
  }]);
  return ToolbarSeparator;
}(_react.Component);

ToolbarSeparator.muiName = 'ToolbarSeparator';
ToolbarSeparator.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarSeparator.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ToolbarSeparator;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      paddingRight: baseTheme.spacing.desktopGutterLess,
      lineHeight: toolbar.height + 'px',
      fontSize: toolbar.titleFontSize,
      fontFamily: baseTheme.fontFamily,
      position: 'relative',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  };
}

var ToolbarTitle = function (_Component) {
  (0, _inherits3.default)(ToolbarTitle, _Component);

  function ToolbarTitle() {
    (0, _classCallCheck3.default)(this, ToolbarTitle);
    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolbarTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          text = _props.text,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
        }, other),
        text
      );
    }
  }]);
  return ToolbarTitle;
}(_react.Component);

ToolbarTitle.muiName = 'ToolbarTitle';
ToolbarTitle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ToolbarTitle.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The text to be displayed.
   */
  text: _propTypes2.default.node
} : {};
exports.default = ToolbarTitle;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(342),
    assignInWith = __webpack_require__(1862),
    baseRest = __webpack_require__(136),
    customDefaultsAssignIn = __webpack_require__(1870);

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(args) {
  args.push(undefined, customDefaultsAssignIn);
  return apply(assignInWith, undefined, args);
});

module.exports = defaults;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(729);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(136),
    isIterateeCall = __webpack_require__(1863);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1864),
    isArguments = __webpack_require__(488),
    isArray = __webpack_require__(67),
    isBuffer = __webpack_require__(518),
    isIndex = __webpack_require__(271),
    isTypedArray = __webpack_require__(796);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1866),
    baseUnary = __webpack_require__(486),
    nodeUtil = __webpack_require__(1867);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false,
            info: {},
            error: {}
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            this.setState({
                hasError: true,
                info: info,
                error: error
            });
        }
    }, {
        key: "render",
        value: function render() {
            var hasError = this.state.hasError;


            if (hasError) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "react-error" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h1",
                        null,
                        "Something went wrong"
                    )
                );
            }

            return this.props.children;
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ErrorBoundary;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/ErrorBoundary.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/ErrorBoundary.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_annotations__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectedTextPopup__ = __webpack_require__(1893);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var AnnotationsEditor = function (_React$Component) {
    _inherits(AnnotationsEditor, _React$Component);

    function AnnotationsEditor(props) {
        var _this$state;

        _classCallCheck(this, AnnotationsEditor);

        var _this = _possibleConstructorReturn(this, (AnnotationsEditor.__proto__ || Object.getPrototypeOf(AnnotationsEditor)).call(this, props));

        _this.state = (_this$state = {
            renderContent: []
        }, _defineProperty(_this$state, 'renderContent', []), _defineProperty(_this$state, 'openPopover', false), _this$state);

        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.closePopover = _this.closePopover.bind(_this);
        return _this;
    }

    _createClass(AnnotationsEditor, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            var letterText = newProps.letterText,
                annotations = newProps.annotations;


            if (letterText && annotations.length > 0) {
                var clearedAnnotations = this.clearUnusefullWords(annotations);
                var sortedAnnotations = this.sortForLongerAnnotate(clearedAnnotations);

                this.createRenderedContent(letterText, sortedAnnotations);
            } else {
                this.setState({
                    renderContent: undefined,
                    tooltips: undefined
                });
            }
        }
    }, {
        key: 'sortForLongerAnnotate',
        value: function sortForLongerAnnotate(annotations) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(annotations, function (a, b) {
                return -a.features.string.length;
            });
        }
    }, {
        key: 'clearUnusefullWords',
        value: function clearUnusefullWords(annotations) {
            var array = annotations.filter(function (annotation) {
                return annotation.type !== 'Lookup' && annotation.type !== 'Sentence' && annotation.type !== 'Split' && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(annotation, 'features.rule');
            });

            var map = new Map();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    var key = item.type + "-" + item.features.rule + "-" + item.start + "-" + item.end;
                    map.set(key, item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return Array.from(map.values());
        }
    }, {
        key: 'createRenderedContent',
        value: function createRenderedContent(letterText, annotations) {
            var renderContent = letterText.split('');

            renderContent = renderContent.map(function (symbol, symbolPosition) {
                symbol = symbol === ' ' ? '\xA0' : symbol;
                return {
                    symbol: symbol,
                    symbolPosition: symbolPosition,
                    style: {},
                    ids: [],
                    tooltipContent: []
                };
            });

            for (var i = 0; i < annotations.length; i++) {
                var hashColor = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].createHashColor();
                for (var j = annotations[i].start; j < annotations[i].end; j++) {
                    if (renderContent[j]) {
                        renderContent[j].style = {
                            background: hashColor
                        };
                        renderContent[j].ids.push(annotations[i].id);
                        renderContent[j].tooltipContent.push({
                            rule: annotations[i].features.rule,
                            type: annotations[i].type
                        });
                    }
                }
            }

            var tooltips = this.createTooltips(renderContent);

            this.setState({
                renderContent: renderContent,
                tooltips: tooltips
            });
        }
    }, {
        key: 'createTooltips',
        value: function createTooltips(characters) {
            var map = new Map();
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = characters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var char = _step2.value;

                    map.set(char.ids.join(''), char);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return Array.from(map.values());
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp(ev) {
            var range = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].getSelection(ev.target.parentNode);

            if (range.start === range.end) {
                return;
            }

            var hashColor = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].createHashColor();
            var renderContent = this.state.renderContent.slice(0);

            renderContent.forEach(function (el) {
                if (el.position >= range.start && el.position < range.end) {
                    renderContent.push({
                        style: {
                            background: hashColor
                        }
                    });
                }
            });

            this.setState({
                renderContent: renderContent,
                openPopover: true,
                anchorEl: ev.target,
                chosenText: range.string
            });
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.setState({
                openPopover: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelectedTextPopup__["a" /* default */], {
                    openPopover: this.state.openPopover,
                    anchorEl: this.state.anchorEl,
                    closePopover: this.closePopover,
                    chosenText: this.state.chosenText
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'letter-text', onMouseUp: this.onMouseUp },
                    this.state.renderContent ? Array.from(Object(__WEBPACK_IMPORTED_MODULE_6_helpers_annotations__["b" /* letterMapper */])(this.state.renderContent)) : this.props.letterText
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_helpers_annotations__["a" /* AnnotationTooltip */], { tooltips: this.state.tooltips, renderTooltip: function renderTooltip(tooltip) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'tooltip-row' },
                            tooltip.tooltipContent.map(function (t, k) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { key: k, className: 'tooltip-column' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col' },
                                        'Rule - ' + t.rule + ', '
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col' },
                                        'Type - ' + t.type
                                    )
                                );
                            })
                        );
                    } })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationsEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        letterText: ownProps.letterText,
        annotations: state.annotations.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationsEditor);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationsEditor, 'AnnotationsEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/AnnotationsEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/AnnotationsEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var AnnotationsList = function (_React$Component) {
    _inherits(AnnotationsList, _React$Component);

    function AnnotationsList(props) {
        _classCallCheck(this, AnnotationsList);

        var _this = _possibleConstructorReturn(this, (AnnotationsList.__proto__ || Object.getPrototypeOf(AnnotationsList)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            annotations: _this.props.annotations,
            searchText: ''
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }

    _createClass(AnnotationsList, [{
        key: 'filterAnnotations',
        value: function filterAnnotations(searchArray, searchText) {
            searchText = searchText.toLowerCase();

            return searchArray.filter(function (annotation) {
                if (annotation.features) {
                    if (annotation.features.rule) if (annotation.features.rule.toLowerCase().includes(searchText)) return true;

                    if (annotation.features.majorType) if (annotation.features.majorType.toLowerCase().includes(searchText)) return true;

                    if (annotation.features.string) if (annotation.features.string.toLowerCase().includes(searchText)) return true;
                }

                if (annotation.type) {
                    if (annotation.type.toLowerCase().includes(searchText)) {
                        return true;
                    }
                }

                if (annotation.id) {
                    var id = annotation.id + '';
                    if (id.includes(searchText)) {
                        return true;
                    }
                }

                return false;
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            var _this2 = this;

            if (props.annotations.length) {
                this.setState({
                    annotations: props.annotations,
                    total: props.annotations.length
                }, function () {
                    _this2.handleUpdateRow(_this2.state);
                });
            }
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            var _this3 = this;

            var annotations = this.filterAnnotations(this.props.annotations, e.target.value);

            this.setState({
                annotations: annotations,
                total: annotations.length
            }, function () {
                _this3.handleUpdateRow(_this3.state);
            });
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.annotations.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var renderComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'annotations-list-b' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                        className: this.props.isLoaded ? 'hidden' : '',
                        style: {
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)'
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? 'navigation' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-arrows' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__["a" /* default */], {
                            total: this.state.annotations.length,
                            rowsPerPage: this.state.rowsPerPage,
                            page: this.state.page,
                            numberOfRows: this.state.numberOfRows,
                            updateRows: this.handleUpdateRow
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-search' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                            hintText: 'Search',
                            hintStyle: { fontSize: 12 },
                            style: { fontSize: 12 },
                            onChange: this.handleSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-info' },
                        'Total annotations: ',
                        this.state.annotations.length
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? 'annotations-table' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeader"],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                                { style: { height: '28px' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Value'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Rule'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Type'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'MajorType'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'id'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                            { displayRowCheckbox: false },
                            this.state.rows.map(function (annotation, i) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                                    { style: { height: '28px' }, key: i },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.string
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.rule
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.type
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.majorType
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.id
                                    )
                                );
                            })
                        )
                    )
                )
            );
            var renderError = 'Something wrong with request';

            if (this.props.isError) {
                renderComponent = null;
            } else {
                renderError = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                renderComponent,
                renderError
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        annotations: state.annotations.items,
        isLoaded: state.annotations.isLoaded,
        error: state.annotations.error,
        isError: state.annotations.isError
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationsList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationsList, 'AnnotationsList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/AnnotationsList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/AnnotationsList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px'
        }
    }
};

var TextEditor = function (_React$Component) {
    _inherits(TextEditor, _React$Component);

    function TextEditor(props) {
        _classCallCheck(this, TextEditor);

        var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));

        _this.state = {
            open: false,
            textLetter: props.textLetter,
            originalText: props.originalText
        };

        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.changeTextLetterText = _this.changeTextLetterText.bind(_this);
        _this.returnOriginalText = _this.returnOriginalText.bind(_this);
        _this.updateGazetters = _this.updateGazetters.bind(_this);
        return _this;
    }

    _createClass(TextEditor, [{
        key: 'returnOriginalText',
        value: function returnOriginalText() {
            this.setState({
                textLetter: this.props.originalText
            });
        }
    }, {
        key: 'updateGazetters',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var textLetter;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                textLetter = this.state.textLetter;

                                if (!textLetter) {
                                    _context.next = 8;
                                    break;
                                }

                                this.toggleDialog();

                                this.props.removeAnnotations();
                                this.props.removeGazetters();
                                _context.next = 7;
                                return this.props.getLetterData(textLetter);

                            case 7:
                                this.props.updatePostGazetters(textLetter);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateGazetters() {
                return _ref.apply(this, arguments);
            }

            return updateGazetters;
        }()
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                textLetter: nextProps.textLetter,
                originalText: nextProps.originalText
            });
        }
    }, {
        key: 'changeTextLetterText',
        value: function changeTextLetterText(e) {
            this.setState({
                textLetter: e.target.value
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            var open = this.state.open;

            this.setState({
                open: !open
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                textLetter = _state.textLetter,
                open = _state.open;

            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RE-ANNOTATE',
                primary: true,
                onClick: this.updateGazetters
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RETURN ORIGINAL TEXT',
                primary: true,
                onClick: this.returnOriginalText
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'CLOSE',
                primary: true,
                onClick: this.toggleDialog
            })];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    label: 'Editor',
                    labelStyle: styles.button.labelStyle,
                    style: styles.button.style,
                    buttonStyle: styles.button.buttonStyle,
                    onClick: this.toggleDialog,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
                    {
                        title: 'Edit letter text',
                        actions: actions,
                        contentStyle: styles.dialog.contentStyle,
                        open: open,
                        modal: true
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                        style: styles.textarea.style,
                        value: textLetter,
                        onChange: this.changeTextLetterText
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TextEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TextEditor;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/TextEditor.jsx');
    reactHotLoader.register(TextEditor, 'TextEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/TextEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/TextEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false,
            info: {},
            error: {}
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            this.setState({
                hasError: true,
                info: info,
                error: error
            });
        }
    }, {
        key: "render",
        value: function render() {
            var hasError = this.state.hasError;


            if (hasError) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "react-error" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h1",
                        null,
                        "Something went wrong"
                    )
                );
            }

            return this.props.children;
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ErrorBoundary;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/ErrorBoundary.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/ErrorBoundary.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDoneAll = function ActionDoneAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z' })
  );
};
ActionDoneAll = (0, _pure2.default)(ActionDoneAll);
ActionDoneAll.displayName = 'ActionDoneAll';
ActionDoneAll.muiName = 'SvgIcon';

exports.default = ActionDoneAll;

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__query__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribable__ = __webpack_require__(198);





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* hashQueryKeyByOptions */])(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new __WEBPACK_IMPORTED_MODULE_2__query__["a" /* Query */]({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* matchQuery */])(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* matchQuery */])(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(__WEBPACK_IMPORTED_MODULE_4__subscribable__["a" /* Subscribable */]);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribable__ = __webpack_require__(198);




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new __WEBPACK_IMPORTED_MODULE_2__mutation__["a" /* Mutation */]({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__notifyManager__["a" /* notifyManager */].batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["i" /* matchMutation */])(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["i" /* matchMutation */])(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__notifyManager__["a" /* notifyManager */].batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return __WEBPACK_IMPORTED_MODULE_1__notifyManager__["a" /* notifyManager */].batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* noop */]);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(__WEBPACK_IMPORTED_MODULE_4__subscribable__["a" /* Subscribable */]);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mutation; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getDefaultState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__retryer__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(70);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* noop */]);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      Object(__WEBPACK_IMPORTED_MODULE_1__logger__["a" /* getLogger */])().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new __WEBPACK_IMPORTED_MODULE_3__retryer__["a" /* Retryer */]({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    __WEBPACK_IMPORTED_MODULE_2__notifyManager__["a" /* notifyManager */].batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        isPaused: true
      });

    case 'continue':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        isPaused: false
      });

    case 'loading':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = infiniteQueryBehavior;
/* unused harmony export getNextPageParam */
/* unused harmony export getPreviousPageParam */
/* harmony export (immutable) */ __webpack_exports__["a"] = hasNextPage;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasPreviousPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__retryer__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(70);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getAbortController */])();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if (Object(__WEBPACK_IMPORTED_MODULE_0__retryer__["b" /* isCancelable */])(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if (Object(__WEBPACK_IMPORTED_MODULE_0__retryer__["b" /* isCancelable */])(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueriesObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queryObserver__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribable__ = __webpack_require__(198);





var QueriesObserver = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(QueriesObserver, _Subscribable);

  function QueriesObserver(client, queries) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.queries = [];
    _this.result = [];
    _this.observers = [];
    _this.observersMap = {};

    if (queries) {
      _this.setQueries(queries);
    }

    return _this;
  }

  var _proto = QueriesObserver.prototype;

  _proto.onSubscribe = function onSubscribe() {
    var _this2 = this;

    if (this.listeners.length === 1) {
      this.observers.forEach(function (observer) {
        observer.subscribe(function (result) {
          _this2.onUpdate(observer, result);
        });
      });
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.observers.forEach(function (observer) {
      observer.destroy();
    });
  };

  _proto.setQueries = function setQueries(queries, notifyOptions) {
    this.queries = queries;
    this.updateObservers(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.result;
  };

  _proto.getOptimisticResult = function getOptimisticResult(queries) {
    return this.findMatchingObservers(queries).map(function (match) {
      return match.observer.getOptimisticResult(match.defaultedQueryOptions);
    });
  };

  _proto.findMatchingObservers = function findMatchingObservers(queries) {
    var _this3 = this;

    var prevObservers = this.observers;
    var defaultedQueryOptions = queries.map(function (options) {
      return _this3.client.defaultQueryObserverOptions(options);
    });
    var matchingObservers = defaultedQueryOptions.flatMap(function (defaultedOptions) {
      var match = prevObservers.find(function (observer) {
        return observer.options.queryHash === defaultedOptions.queryHash;
      });

      if (match != null) {
        return [{
          defaultedQueryOptions: defaultedOptions,
          observer: match
        }];
      }

      return [];
    });
    var matchedQueryHashes = matchingObservers.map(function (match) {
      return match.defaultedQueryOptions.queryHash;
    });
    var unmatchedQueries = defaultedQueryOptions.filter(function (defaultedOptions) {
      return !matchedQueryHashes.includes(defaultedOptions.queryHash);
    });
    var unmatchedObservers = prevObservers.filter(function (prevObserver) {
      return !matchingObservers.some(function (match) {
        return match.observer === prevObserver;
      });
    });
    var newOrReusedObservers = unmatchedQueries.map(function (options, index) {
      if (options.keepPreviousData) {
        // return previous data from one of the observers that no longer match
        var previouslyUsedObserver = unmatchedObservers[index];

        if (previouslyUsedObserver !== undefined) {
          return {
            defaultedQueryOptions: options,
            observer: previouslyUsedObserver
          };
        }
      }

      return {
        defaultedQueryOptions: options,
        observer: _this3.getObserver(options)
      };
    });

    var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
      return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
    };

    return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
  };

  _proto.getObserver = function getObserver(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var currentObserver = this.observersMap[defaultedOptions.queryHash];
    return currentObserver != null ? currentObserver : new __WEBPACK_IMPORTED_MODULE_3__queryObserver__["a" /* QueryObserver */](this.client, defaultedOptions);
  };

  _proto.updateObservers = function updateObservers(notifyOptions) {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__notifyManager__["a" /* notifyManager */].batch(function () {
      var prevObservers = _this4.observers;

      var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes


      newObserverMatches.forEach(function (match) {
        return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
      });
      var newObservers = newObserverMatches.map(function (match) {
        return match.observer;
      });
      var newObserversMap = Object.fromEntries(newObservers.map(function (observer) {
        return [observer.options.queryHash, observer];
      }));
      var newResult = newObservers.map(function (observer) {
        return observer.getCurrentResult();
      });
      var hasIndexChange = newObservers.some(function (observer, index) {
        return observer !== prevObservers[index];
      });

      if (prevObservers.length === newObservers.length && !hasIndexChange) {
        return;
      }

      _this4.observers = newObservers;
      _this4.observersMap = newObserversMap;
      _this4.result = newResult;

      if (!_this4.hasListeners()) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* difference */])(prevObservers, newObservers).forEach(function (observer) {
        observer.destroy();
      });
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* difference */])(newObservers, prevObservers).forEach(function (observer) {
        observer.subscribe(function (result) {
          _this4.onUpdate(observer, result);
        });
      });

      _this4.notify();
    });
  };

  _proto.onUpdate = function onUpdate(observer, result) {
    var index = this.observers.indexOf(observer);

    if (index !== -1) {
      this.result = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* replaceAt */])(this.result, index, result);
      this.notify();
    }
  };

  _proto.notify = function notify() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_2__notifyManager__["a" /* notifyManager */].batch(function () {
      _this5.listeners.forEach(function (listener) {
        listener(_this5.result);
      });
    });
  };

  return QueriesObserver;
}(__WEBPACK_IMPORTED_MODULE_4__subscribable__["a" /* Subscribable */]);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteQueryObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queryObserver__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__ = __webpack_require__(806);




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }

  var _proto = InfiniteQueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);

    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      behavior: Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["c" /* infiniteQueryBehavior */])()
    }), notifyOptions);
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["c" /* infiniteQueryBehavior */])();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };

  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    var state = query.state;

    var result = _QueryObserver.prototype.createResult.call(this, query, options);

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["a" /* hasNextPage */])(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["b" /* hasPreviousPage */])(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };

  return InfiniteQueryObserver;
}(__WEBPACK_IMPORTED_MODULE_2__queryObserver__["a" /* QueryObserver */]);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribable__ = __webpack_require__(198);





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : Object(__WEBPACK_IMPORTED_MODULE_2__mutation__["b" /* getDefaultState */])();

    var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(__WEBPACK_IMPORTED_MODULE_4__subscribable__["a" /* Subscribable */]);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useQueryErrorResetBoundary; });
/* unused harmony export QueryErrorResetBoundary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shouldThrowError;
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useBaseQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QueryErrorResetBoundary__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(811);





function useBaseQuery(options, Observer) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();
  var errorResetBoundary = Object(__WEBPACK_IMPORTED_MODULE_2__QueryErrorResetBoundary__["a" /* useQueryErrorResetBoundary */])();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* shouldThrowError */])(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowBack = function NavigationArrowBack(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
  );
};
NavigationArrowBack = (0, _pure2.default)(NavigationArrowBack);
NavigationArrowBack.displayName = 'NavigationArrowBack';
NavigationArrowBack.muiName = 'SvgIcon';

exports.default = NavigationArrowBack;

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_vessels_vessels__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_vessels_size__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Base_NumberField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Vessels_Single_Rows_Name__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Vessels_Single_Rows_ExNames__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Vessels_Single_Rows_Nationalities__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Vessels_Single_Rows_ImoNumber__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Vessels_Single_Rows_Blt__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Vessels_Single_Rows_BuilderYard__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Vessels_Single_Rows_BuilderCountry__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Vessels_Single_Rows_Flag__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Vessels_Single_Rows_PortOfRegistry__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Vessels_Single_Rows_RegisterClasses__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Vessels_Single_Rows_PIClub__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Vessels_Single_Rows_Manager__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Vessels_Single_Rows_TypeByPurpose__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Vessels_Single_Rows_TypeByConstruction__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Vessels_Single_Rows_TypeBySize__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Vessels_Single_Rows_TypeBySpecialty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Vessels_Single_Rows_GearV2__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Vessels_Single_Rows_GrabV2__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Vessels_Single_Rows_TechEquipCertificate__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Vessels_Single_Rows_CargoExclussionsV2__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Vessels_Single_Rows_Tonnage__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Vessels_Single_Rows_Deadweight__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Vessels_Single_Rows_CapacityV2__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Vessels_Single_Rows_Dimensions__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Vessels_Single_Rows_HoldsHatchesTop__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Vessels_Single_Rows_Cells__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Vessels_Single_Rows_Areas__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Vessels_Single_Rows_SpeedConsumptionV2__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Vessels_Single_Rows_Strength__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Vessels_Single_Rows_StackWeight__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Vessels_Single_Rows_OtherFields__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Vessels_Single_Rows_Design__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Vessels_Single_Rows_DisponentOwner__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Vessels_Single_Rows_Bunkers__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Vessels_Single_Rows_Description__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Vessels_Single_Rows_LinerMeter__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Vessels_Single_Rows_GearedGrabbed__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Vessels_Single_Rows_Pumps__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Vessels_Single_Rows_LastCargo__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Vessels_Single_Rows_CapacityTanker__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Vessels_Single_Rows_Manifolds__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Vessels_Single_Rows_CertificateOfFitness__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Vessels_Single_Rows_withExclusions__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Vessels_Single_Rows_Attachments__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__VesselShortInfo__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__utils__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_components_Vessels_Single_Rows_RegisteredOwner__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_helpers_vessels__ = __webpack_require__(528);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








































































var styles = {
    toggleLabelStyle: {
        color: __WEBPACK_IMPORTED_MODULE_12_material_ui_styles_colors__["orange900"]
    },
    underlineStyle: {
        borderColor: __WEBPACK_IMPORTED_MODULE_12_material_ui_styles_colors__["orange500"]
    }
};

var defaultCargo = {
    cargo: { _id: '', name: '' },
    date: null
};

function scroll() {
    this.blur();
}

function getInitialState(opts) {
    return _extends({
        confirmed: true,
        areas: {},
        speeds: {},
        strength: {
            tanktopByHolds: ['']
        },
        stackWeight: {},
        certificateOfFitness: [],
        consumptions: {
            laden: [],
            ballast: [],
            eco: [],
            portIdle: [],
            portWorking: []
        },
        holds: { lowerDims: [], tweenDims: [] },
        hatches: { size: [] },
        holdsHatchesProducer: '',

        builderV2: {
            yard: { _id: '', name: '' },
            country: { _id: '', name: '' }
        },
        registerNumber: '',
        registerClasses: [{ _id: '', name: '' }],
        classNotation: '',
        piClubObject: { _id: '', name: '' },
        iacsRegister: false,
        typeByPurpose: undefined,
        typeByConstruction: undefined,
        typeBySpecialty: '',
        typeBySize: '',
        openHatch: null,
        boxShaped: null,
        dimensions: {
            loa: undefined,
            beam: undefined,
            depth: undefined,
            lbp: undefined,
            beamMoulded: undefined,
            depthMoulded: undefined,
            bowToCenterManifold: undefined,
            keelToMast: undefined,
            airdrftLightship: undefined,
            airdrftNormBallast: undefined,
            airdrftLoadSumDwt: undefined,
            wltohcBallast: undefined,
            wltohcDeball: undefined,
            bwtlhc: undefined,
            parallelBodyLoaded: undefined,
            parallelBodyFore: undefined,
            parallelBodyAft: undefined,
            sttbr: undefined,
            bwtbr: undefined,
            freshWaterAllowance: undefined,
            dtcr: undefined
        },
        manifolds: {
            bcm: undefined,
            scm: undefined,
            betweenManifolds: undefined,
            list: [{
                number: undefined,
                size: undefined,
                commonLine: undefined
            }]
        },
        bunkers: [{
            quantity: undefined,
            typeOfFuel: ''
        }],
        gearV2: {
            summary: [{
                type: '',
                quantity: undefined,
                capacity: undefined,
                outreach: undefined,
                radius: undefined,
                maxSWL: undefined,
                combinable: false
            }]
        },
        geared: null,
        grabV2: {
            summary: [{
                type: '',
                quantity: '',
                volume: ''
            }]
        },
        grabbed: null,
        pumps: {
            cargo: [{
                type: '',
                quantity: '',
                capacity: ''
            }],
            ballast: [{
                type: '',
                quantity: '',
                capacity: ''
            }]
        },
        techEquipCertificate: {
            co2Fitted: null,
            a60BulkheadFitted: null,
            cementHolesCount: '',
            cementHolesDia: '',
            newPanama: null,
            cementHolesFitted: null,
            referPlugFitted: null,
            itfFitted: null,
            lakesFitted: null,
            strengthenHeavy: null,
            logsFitted: null,
            aussieFitted: null,
            iceClass: '',
            ventilation: '',
            ventilationFitted: null,
            imoApp: '',
            imoClass: '',
            imoFitted: null,
            bwts: null,
            coiled: null,
            containerFitted: null,
            carFitted: null,
            rampway: null,
            lxb: '',
            grainFitted: null,
            grainHoles: '',
            grainDia: '',
            cargoTankDryer: null,
            cargoCoolingSystem: null,
            crudeOilWashing: null,
            rcttms: null,
            rctpms: null,
            bowChainStopper: null,
            chainSize: '',
            ngs: null,
            ngsCapacity: '',
            vrs: null,
            vrsNumLines: '',
            bowThruster: null,
            bowThrusterNum: '',
            bowThrusterBhp: '',
            bowThrusterKw: '',
            stemThruster: null,
            stemThrusterNum: '',
            stemThrusterBhp: '',
            stemThrusterKw: '',
            igs: {
                fitted: null,
                systems: [{
                    type: '',
                    capacity: '',
                    percentage: ''
                }]
            },
            referPlugsAmount: undefined
        },
        cargoExclusionV2Object: { _id: '', name: '' },
        cargoExclusionV2List: [],
        cargoExclusionsV2: [],
        lastCargo: [{
            cargoes: [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo)]
        }],
        deadWeight: {
            sLoaded: undefined,
            sDWT: undefined,
            sDWCC: undefined,
            sDraft: undefined,
            sTpc: undefined,
            sTpi: undefined,
            tLoaded: undefined,
            tDWT: undefined,
            tDWCC: undefined,
            tDraft: undefined,
            tTpc: undefined,
            tTpi: undefined,
            wLoaded: undefined,
            wDWT: undefined,
            wDWCC: undefined,
            wDraft: undefined,
            wTpc: undefined,
            wTpi: undefined,
            fLoaded: undefined,
            fDWT: undefined,
            fDWCC: undefined,
            fDraft: undefined,
            fTpc: undefined,
            fTpi: undefined
        },
        rt: {
            gt: undefined,
            nt: undefined,
            suezGt: undefined,
            suezNt: undefined,
            panamaGt: undefined,
            panamaNt: undefined
        },
        capacityV2: {
            grain: undefined,
            bale: undefined,
            teu: undefined,
            feu: undefined,
            constant: undefined,
            summary: [{
                hold: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined
                },
                tweenDeck: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined
                }
            }]
        },
        capacityTanker: {
            segregation: '',
            details: '',
            ttlCapacity: '',
            cargoGrades: '',
            tanks: [{
                port: '',
                starboard: ''
            }],
            slops: [{
                port: '',
                starboard: ''
            }],
            ballastTanks: [{
                port: '',
                starboard: ''
            }],
            cargoCapacity: '',
            slopsCapacity: '',
            ballastCapacity: '',
            wholeTank: '',
            coatingType: '',
            heating: {
                exchanger: null,
                medium: '',
                maxLoaded: '',
                maxMaintained: ''
            }
        },
        holdsV2: [],
        doubleHull: undefined,
        hullNumber: '',
        callSign: '',
        officialNumber: '',
        mmsi: '',
        cells: [{
            holds: {
                l: undefined,
                b: undefined,
                h: undefined,
                area: undefined
            },
            tweenDecks: [{
                l: undefined, b: undefined, h: undefined, area: undefined
            }, {
                l: undefined, b: undefined, h: undefined, area: undefined
            }],
            hatches: [{ l: undefined, b: undefined, area: undefined }, { l: undefined, b: undefined, area: undefined }]
        }],
        temporaryHohaAreas: {
            mainDeckSummArea: null,
            tweenDecksSummArea: null,
            hatchesSummArea: null
        },
        speedConsumptionV2: [{
            mode: '',
            speed: undefined,
            ifo: {
                typeIfo: 'HFO 180',
                cons: undefined
            },
            mdo: {
                typeMdo: 'MGO',
                cons: undefined
            },
            lngCons: undefined
        }],
        exNames: [],
        nationalities: [],

        flagObject: { _id: '', name: '' },
        flag: { _id: '', name: '' },
        managerObject: { _id: '', name: '' },
        manager: { _id: '', name: '' },
        registeredOwner: { _id: '', name: '' },
        homePortObject: { _id: '', name: '' },
        homePort: { _id: '', name: '' },

        name: undefined,
        imoNumber: undefined,
        type: '',
        image: undefined,
        blt: undefined,
        attachments: [],
        attachmentsArray: [],

        typeOfPage: 'new',
        engineLocation: undefined,
        engines: [{
            type: undefined,
            number: undefined,
            capacity: undefined,
            rpm: undefined,
            makeType: undefined
        }],
        errors: [],

        modifiedFields: [],
        currentlyModifiedFields: [],
        purposeErrorField: {},
        toggleSpeedConsAll: {
            IFO: false,
            MDO: false
        },
        windScale: undefined,
        description: undefined,
        design: { _id: '', name: '' },
        disponentOwner: { _id: '', name: '' },
        sanctions: []
    }, opts);
}

var SizesTable = function (_React$Component) {
    _inherits(SizesTable, _React$Component);

    function SizesTable(props) {
        _classCallCheck(this, SizesTable);

        var _this = _possibleConstructorReturn(this, (SizesTable.__proto__ || Object.getPrototypeOf(SizesTable)).call(this, props));

        _this.changeFieldsMultiple = function (changes) {
            var state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.state);

            if (!Array.isArray(changes)) {
                changes = [changes];
            }

            changes.forEach(function (_ref) {
                var field = _ref.field,
                    value = _ref.value,
                    type = _ref.type;

                state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, type && type === 'array' ? [value] : value);
                state.currentlyModifiedFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(_this.state.currentlyModifiedFields), [field]));
            });

            _this.setState(state);
        };

        _this.changeModifiedMultiple = function () {
            var modifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.state);

            var modificationKeys = [];

            modifications.forEach(function (modification) {
                modificationKeys.push(Object.keys(modification)[0]);
            });

            state.currentlyModifiedFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(_this.state.currentlyModifiedFields), modificationKeys));

            _this.setState(function (s) {
                return _extends({}, s, { currentlyModifiedFields: state.currentlyModifiedFields });
            });
        };

        var stateOpts = {};

        stateOpts.showAddButton = props.hasOwnProperty('showAddButton') ? props.showAddButton : true;

        _this.state = getInitialState(stateOpts);

        _this.changeField = _this.changeField.bind(_this);
        _this.changeAreas = _this.changeAreas.bind(_this);
        _this.getError = _this.getError.bind(_this);
        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
        _this.toggleIacsRegister = _this.toggleIacsRegister.bind(_this);
        _this.toggleOpenHatch = _this.toggleOpenHatch.bind(_this);
        _this.toggleBoxShaped = _this.toggleBoxShaped.bind(_this);
        _this.changeHolds = _this.changeHolds.bind(_this);
        _this.changeHatches = _this.changeHatches.bind(_this);
        _this.clearError = _this.clearError.bind(_this);
        _this.findType = _this.findType.bind(_this);
        _this.sizeUpdate = _this.sizeUpdate.bind(_this);
        _this.prepareToLoad = _this.prepareToLoad.bind(_this);
        _this.sizeAdd = _this.sizeAdd.bind(_this);
        _this.changeSizeArray = _this.changeSizeArray.bind(_this);
        _this.getOldData = _this.getOldData.bind(_this);
        _this.toggleModifySpeedCons = _this.toggleModifySpeedCons.bind(_this);
        _this.changeGrabbed = _this.changeGrabbed.bind(_this);
        _this.changeGeared = _this.changeGeared.bind(_this);
        _this.updateWithModifiedSizes = _this.updateWithModifiedSizes.bind(_this);
        return _this;
    }

    _createClass(SizesTable, [{
        key: 'getOldData',
        value: function getOldData(vesselData) {
            var vessel = _extends({}, getInitialState(), vesselData);

            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.defaults(vessel.capacityTanker, getInitialState().capacityTanker);

            if (!vessel.holds.tweenDims && !vessel.holds.lowerDims) {
                vessel.holds = _extends({}, getInitialState().holds, vessel.holds);
            }

            if (!vessel.grabV2.summary || !vessel.grabV2.summary.length) {
                vessel.grabV2 = getInitialState().grabV2;
            }

            if (!vessel.gearV2.summary || !vessel.gearV2.summary.length) {
                vessel.gearV2 = getInitialState().gearV2;
            }

            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel.attachments[0], 'name')) {
                vessel.attachmentsArray = [];

                vessel.attachments.forEach(function (item) {
                    vessel.attachmentsArray.push(item);
                });

                vessel.attachments = [];

                vessel.attachmentsArray.forEach(function (item) {
                    vessel.attachments.push(item._id);
                });
            }

            if (!vessel.capacityV2.summary || !vessel.capacityV2.summary.length) {
                var _getInitialState = getInitialState(),
                    summary = _getInitialState.capacityV2.summary;

                vessel.capacityV2.summary = summary;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = vessel.lastCargo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var tank = _step.value;

                    for (var i = tank.cargoes.length; i < 3; i++) {
                        tank.cargoes.push(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (vessel.registerClass && vessel.registerClass._id && !vessel.registerClasses[0]._id) {
                vessel.registerClasses = [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(vessel.registerClass)];
            }

            return vessel;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.changeField({
                field: 'temporaryHohaAreas',
                value: {
                    mainDeckSummArea: parseFloat(this.state.areas.mainDeck) || 0,
                    tweenDecksSummArea: parseFloat(this.state.areas.tweenDeck) || 0
                }
            });

            if (this.props.routeParams.id) {
                Object(__WEBPACK_IMPORTED_MODULE_3_services_vessels_vessels__["g" /* getVessel */])(this.props.routeParams.id).then(function (response) {
                    response.data.type = _this2.findType(response.data.type);

                    for (var item in response.data) {
                        var obj = response.data[item];
                        if (typeof obj === 'string') {
                            continue;
                        }

                        // remove empty objects
                        if (obj === null || obj === undefined || Array.isArray(obj) && obj.length === 0 || Object.keys(obj).length === 0 && obj.constructor === Object) {
                            delete response.data[item];
                        }
                    }
                    var vessel = _this2.getOldData(response.data);

                    _this2.setState(vessel);
                });
            }
        }
    }, {
        key: 'findType',
        value: function findType(type) {
            switch (type) {
                case 'CONT':
                case 'Fully Cellular Container':
                    return 'CONT';
                case 'ROLO':
                case 'Passenger/Cargo Vessel':
                case 'Deck Cargo Carrier':
                case 'Ro-Ro/Lo-Lo':
                case 'Reefer/Ro-Ro Cargo':
                case 'Reefer/Pallets Carrier':
                case 'Ro-Ro/Container':
                case 'Product Carrier/Ro-Ro':
                case 'Barge Carrier':
                    return 'ROLO';
                case 'RORO':
                case 'Pass./Car Ferry':
                case 'Ro-Ro Freight/Passenger':
                case 'Ro-Ro':
                case 'Pure Car Carrier':
                case 'Palletised Cargo Carrier':
                    return 'RORO';
                case 'SID':
                case 'minibulk':
                case 'panamax':
                case 'Miscellaneous Dry Bulk':
                case 'Cement Carrier':
                case 'Aggregate Carrier':
                case 'Bulk Carrier':
                case 'Ore Carrier':
                case 'Ore/Oil Carrier':
                case 'Urea Carrier':
                case 'Open Hatch Carrier':
                case 'Chip Carrier':
                case 'Slurry Carrier':
                case 'handymax':
                case 'Ore & Sulphuric Acid Carrier':
                case 'Forest Product Carrier':
                case 'supramax':
                case 'overpanamax':
                case 'Salt Carrier':
                case 'capesize':
                case 'handysize':
                    return 'SID';
                case 'TWEEN':
                case 'General Cargo':
                case 'Reefer':
                case 'Reefer/General Cargo':
                case 'Miscellaneous Cargo':
                case 'Multi-Purpose':
                case 'Multi-Purpose/Heavy Lift Cargo':
                case 'Products/Multi-Purpose Cargo':
                case 'Heavy Lift Cargo Vessel':
                    return 'TWEEN/MPP';
                case 'Product Carrier':
                case 'Chemical Unknown Carrier':
                case 'Bunkering Vessel':
                case 'Chemical Bulk Tanker':
                case 'Chemical & Oil Carrier':
                case 'Chem Parcel Tanker':
                case 'Molten Sulphur Carrier':
                case 'Asphalt & Bitumen Carrier':
                case 'Tanker':
                case 'Water Carrier':
                case 'Edible Oil Carrier':
                case 'Sulphuric Acid Carrier':
                case 'Oil & Liquid Gas Carrier':
                case 'Fruit Juice Carrier':
                case 'Methanol Carrier':
                case 'Phosphoric Acid Carrier':
                case 'Shuttle Tanker':
                case 'Oil Recovery Tanker':
                    return 'TANK';
                case 'Cruise Ship':
                case 'Landing Craft':
                case 'Pass./Car Catamaran Vessel':
                case 'Passenger Vessel':
                case 'Waste Disposal Carrier':
                case 'Livestock Carrier':
                case 'Limestone Carrier':
                case 'Reefer Fish Carrier':
                    return 'OTHER';
            }

            return type;
        }
    }, {
        key: 'checkGears',
        value: function checkGears(array) {
            return array.filter(function (item) {
                if (item.combinable) {
                    return true;
                }

                for (var key in item) {
                    if (key !== 'combinable') {
                        return !!item[key];
                    }
                }
            });
        }

        /** @param {{ field: string, value: unknown, type?: string, cb?: Function }} param0 */

    }, {
        key: 'changeField',
        value: function changeField(_ref2) {
            var _this3 = this;

            var field = _ref2.field,
                value = _ref2.value,
                type = _ref2.type,
                cb = _ref2.cb;

            this.setState(Object(__WEBPACK_IMPORTED_MODULE_2_immer__["b" /* produce */])(function (state) {
                if (type === 'number' && value === '') {
                    value = undefined;
                }

                if ((_this3.state.toggleSpeedConsAll.IFO || _this3.state.toggleSpeedConsAll.MDO) && (field.endsWith('.typeIfo') || field.endsWith('.typeMdo'))) {
                    var _state$toggleSpeedCon = _this3.state.toggleSpeedConsAll,
                        toggleIfo = _state$toggleSpeedCon.IFO,
                        toggleMdo = _state$toggleSpeedCon.MDO;

                    var typeFuel = field.search(/mdo/) >= 0 ? 'mdo' : 'ifo';
                    var speedConsCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this3.state.speedConsumptionV2);
                    var modifiedFieldsCopy = new Set(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this3.state.modifiedFields));

                    typeFuel === 'ifo' && toggleIfo && speedConsCopy.forEach(function (item, index) {
                        modifiedFieldsCopy.add('speedConsumptionV2[' + index + '][ifo].typeIfo');
                        item[typeFuel].typeIfo = value;
                    });

                    typeFuel === 'mdo' && toggleMdo && speedConsCopy.forEach(function (item, index) {
                        modifiedFieldsCopy.add('speedConsumptionV2[' + index + '][mdo].typeMdo');
                        item[typeFuel].typeMdo = value;
                    });

                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, 'speedConsumptionV2', speedConsCopy);
                    _this3.setState({
                        currentlyModifiedFields: [].concat(_toConsumableArray(modifiedFieldsCopy)),
                        modifiedFields: [].concat(_toConsumableArray(modifiedFieldsCopy))
                    });
                }

                if (type === 'array') {
                    state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, [].concat(_toConsumableArray(state[field]), [value]));
                } else {
                    state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, value);
                }

                state.errors = state.errors.filter(function (error) {
                    if (!error.field) {
                        return false;
                    }

                    return error.field && !error.field.includes(error.field.replace(/\[|\]\./g, '.'));
                });
            }), function () {
                cb && cb();
            });

            this.setState({
                currentlyModifiedFields: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(this.state.currentlyModifiedFields), [field]))
            });
        }
    }, {
        key: 'changeAreas',
        value: function changeAreas(_ref3) {
            var _this4 = this;

            var field = _ref3.field,
                value = _ref3.value,
                hatchesField = _ref3.hatchesField;
            var hatchesSummArea = this.state.temporaryHohaAreas.hatchesSummArea;

            hatchesSummArea = parseFloat(hatchesSummArea) || null;

            var _state$areas = this.state.areas,
                mainDeck = _state$areas.mainDeck,
                tweenDeck = _state$areas.tweenDeck,
                weatherDeck = _state$areas.weatherDeck;

            mainDeck = parseFloat(mainDeck) || null;
            tweenDeck = parseFloat(tweenDeck) || null;
            weatherDeck = parseFloat(weatherDeck) || null;
            value = parseFloat(value) || null;

            if (field === 'areas.mainDeck') {
                this.setState(function (state) {
                    return {
                        areas: _extends({}, state.areas, {
                            mainDeck: value,
                            total: (value || 0) + (tweenDeck || 0) + (weatherDeck || 0) + (hatchesSummArea || 0)
                        }),
                        currentlyModifiedFields: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(state.currentlyModifiedFields), ['areas.mainDeck']))
                    };
                });
            } else if (field === 'areas.tweenDeck') {
                this.setState(function (state) {
                    return {
                        areas: _extends({}, state.areas, {
                            tweenDeck: value,
                            total: (value || 0) + (mainDeck || 0) + (weatherDeck || 0) + (hatchesSummArea || 0)
                        }),
                        currentlyModifiedFields: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(state.currentlyModifiedFields), ['areas.tweenDeck']))
                    };
                });
            } else if (hatchesField) {
                var state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state);
                state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, value);
                this.setState(state, function () {
                    var cells = _this4.state.cells;

                    hatchesSummArea = 0;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = cells[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var cell = _step2.value;

                            hatchesSummArea += (parseFloat(cell.hatches[0].area) || 0) + (parseFloat(cell.hatches[1].area) || 0);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    _this4.changeField({
                        field: 'temporaryHohaAreas.hatchesSummArea',
                        value: hatchesSummArea
                    });
                    _this4.setState(function (state) {
                        return {
                            areas: _extends({}, state.areas, {
                                total: (hatchesSummArea || 0) + (mainDeck || 0) + (tweenDeck || 0) + (weatherDeck || 0) /* + (total || 0)*/
                            })
                        };
                    });
                });
            } else {
                var _state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state);
                _state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(_state, field, value);
                var _weatherDeck = _state.areas.weatherDeck;
                var _state2 = _state,
                    cells = _state2.cells,
                    temporaryHohaAreas = _state2.temporaryHohaAreas;

                var _mainDeck = 0;
                var _tweenDeck = 0;
                _weatherDeck = parseFloat(_weatherDeck) || 0;

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = cells[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var cell = _step3.value;

                        _mainDeck += _state.temporaryHohaAreas.mainDeckSummArea + (parseFloat(cell.holds.area) || 0);
                        _tweenDeck += (_state.temporaryHohaAreas.tweenDecksSummArea || 0) + (parseFloat(cell.tweenDecks[0].area) || 0) + (parseFloat(cell.tweenDecks[1].area) || 0);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                _state.areas.mainDeck = _mainDeck;
                _state.areas.tweenDeck = _tweenDeck;
                _state.areas.total = _state.areas.mainDeck + _state.areas.tweenDeck + _weatherDeck + hatchesSummArea;

                _state.errors = _state.errors.filter(function (error) {
                    if (!error.field) {
                        return false;
                    }

                    return !error.field.includes(field);
                });

                this.setState(_state);
            }

            if (field === 'areas.weatherDeck') {
                this.setState(function (state) {
                    return {
                        currentlyModifiedFields: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(state.currentlyModifiedFields), ['areas.weatherDeck']))
                    };
                });
            }
        }
    }, {
        key: 'getError',
        value: function getError(field) {
            if (!this.state.errors.length) {
                return '';
            }

            var errorObject = this.state.errors.find(function (error) {
                return error.field === field;
            });

            return errorObject ? errorObject.messages[0] : '';
        }
    }, {
        key: 'clearError',
        value: function clearError(field) {
            var errors = this.state.errors.filter(function (error) {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes(field);
            });

            this.setState({
                errors: errors
            });
        }
    }, {
        key: 'changeAutoComplete',
        value: function changeAutoComplete(type, object) {
            var _this5 = this;

            var state = this.state;

            state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, type, object._id);
            state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, type + 'Object', {
                name: object.name,
                _id: object._id
            });

            this.setState(state, function () {
                _this5.clearError(type);
            });

            this.changeField({
                field: type,
                value: { _id: object._id, name: object.name }
            });
        }
    }, {
        key: 'toggleIacsRegister',
        value: function toggleIacsRegister(e, value) {
            this.changeField({
                field: 'iacsRegister',
                value: value
            });
        }
    }, {
        key: 'toggleOpenHatch',
        value: function toggleOpenHatch(e, value) {
            this.changeField({
                field: 'openHatch',
                value: value
            });
        }
    }, {
        key: 'toggleBoxShaped',
        value: function toggleBoxShaped(e, value) {
            this.changeField({
                field: 'boxShaped',
                value: value
            });
        }
    }, {
        key: 'toggleModifySpeedCons',
        value: function toggleModifySpeedCons(type) {
            this.setState({
                toggleSpeedConsAll: _extends({}, this.state.toggleSpeedConsAll, _defineProperty({}, type, !this.state.toggleSpeedConsAll[type]))
            });
        }
    }, {
        key: 'changeHolds',
        value: function changeHolds(value) {
            value = Math.abs(parseInt(value));

            var state = this.state;
            state.holds.quantity = value;

            var lowerDims = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.holds.lowerDims);
            var tweenDims = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.holds.tweenDims);

            state.holds.lowerDims = this.changeSizeArray(lowerDims, value);
            state.holds.tweenDims = this.changeSizeArray(tweenDims, value);

            state.currentlyModifiedFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(this.state.currentlyModifiedFields), ['holds.quantity']));

            state.errors = state.errors.filter(function (error) {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes('holds.quantity');
            });

            this.setState(state);
        }
    }, {
        key: 'changeHatches',
        value: function changeHatches(value) {
            value = Math.abs(parseInt(value));

            var state = this.state;
            state.hatches.quantity = value;

            var size = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.hatches.size);

            state.hatches.size = this.changeSizeArray(size, value);

            state.currentlyModifiedFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(this.state.currentlyModifiedFields), ['hatches.quantity'])), state.errors = state.errors.filter(function (error) {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes('hatches.quantity');
            });

            this.setState(state);
        }
    }, {
        key: 'changeSizeArray',
        value: function changeSizeArray(array, value) {
            var diff = Math.abs(array.length - value);

            if (value > array.length) {
                for (var i = 0; i <= diff - 1; i++) {
                    array.push({});
                }
            } else if (value < array.length) {
                array.splice(value, diff);
            }

            return array;
        }

        /**
         * The function serializes the vessel data into a backend JSON.
         */

    }, {
        key: 'prepareToLoad',
        value: function prepareToLoad(vessel, add) {
            if (vessel.errors.length > 0) {
                var el = document.getElementsByName(vessel.errors[0].field)[0];
                el.scrollIntoView();

                return;
            }

            var _getInitialState2 = getInitialState(),
                defaultBuilderV2 = _getInitialState2.builderV2,
                defaultFlagObject = _getInitialState2.flagObject,
                defaultManagerObject = _getInitialState2.managerObject,
                defaultHomePortObject = _getInitialState2.homePortObject;

            vessel.flagObject = vessel.flag ? vessel.flag : defaultFlagObject;
            vessel.flag = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'flag._id') && vessel.flag._id !== '' ? vessel.flag._id : this.state.flag;
            vessel.owner = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'owner._id') && vessel.owner._id !== '' ? vessel.owner._id : this.state.owner;
            vessel.registeredOwner = this.state.registeredOwner && this.state.registeredOwner._id ? this.state.registeredOwner._id : undefined;
            vessel.manager = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'managerObject._id') && vessel.managerObject._id !== '' ? vessel.managerObject._id : undefined;
            vessel.managerObject = this.state.manager ? this.state.manager : defaultManagerObject;
            vessel.homePort = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'homePortObject._id') && vessel.homePortObject._id !== '' ? vessel.homePortObject._id : undefined;
            vessel.homePortObject = this.state.homePort ? this.state.homePort : defaultHomePortObject;
            vessel.builderV2.country = this.state.builderV2.country || defaultBuilderV2.country;
            vessel.builderV2.country = this.state.builderV2.country ? this.state.builderV2.country._id : defaultBuilderV2.country._id;
            vessel.images = this.state.images ? this.state.images.map(function (im) {
                return im._id;
            }) : undefined;

            if (!vessel.capacityV2.summary) {
                vessel.capacityV2.summary = [];
            }

            if (vessel.rt) {
                vessel.rt.panamaNt = vessel.rt.panamaNt || undefined;
                vessel.rt.suezGt = vessel.rt.suezGt || undefined;
                vessel.rt.suezNt = vessel.rt.suezNt || undefined;
                vessel.rt.nt = vessel.rt.nt || undefined;
                vessel.rt.gt = vessel.rt.gt || undefined;
            }

            if (vessel.cargoExclusionsV2.length) {
                vessel.cargoExclusionsV2 = Object(__WEBPACK_IMPORTED_MODULE_56__Vessels_Single_Rows_withExclusions__["b" /* prepareExclToLoad */])(vessel.cargoExclusionsV2);
            }
            if (vessel.tradingRestrictions && vessel.tradingRestrictions.length) {
                vessel.tradingRestrictions = Object(__WEBPACK_IMPORTED_MODULE_56__Vessels_Single_Rows_withExclusions__["b" /* prepareExclToLoad */])(vessel.tradingRestrictions);
            }

            if (vessel.dimensions) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = Object.entries(vessel.dimensions)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var _step4$value = _slicedToArray(_step4.value, 2),
                            key = _step4$value[0],
                            value = _step4$value[1];

                        if (!value) {
                            vessel.dimensions[key] = undefined;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }

            if (vessel.engines) {
                for (var i = 0; i < vessel.engines.length; i++) {
                    var engine = vessel.engines[i];
                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = Object.entries(engine)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var _step5$value = _slicedToArray(_step5.value, 2),
                                key = _step5$value[0],
                                value = _step5$value[1];

                            if (!value) {
                                engine[key] = undefined;
                            }
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            }

            if (vessel.deadWeight) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = Object.entries(vessel.deadWeight)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var _step6$value = _slicedToArray(_step6.value, 2),
                            key = _step6$value[0],
                            value = _step6$value[1];

                        vessel.deadWeight[key] = value ? parseFloat(value) : undefined;
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }

            if (vessel.techEquipCertificate) {
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                    for (var _iterator7 = Object.entries(vessel.techEquipCertificate)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var _step7$value = _slicedToArray(_step7.value, 2),
                            key = _step7$value[0],
                            value = _step7$value[1];

                        if (!value) {
                            vessel.techEquipCertificate[key] = undefined;
                        }
                    }
                } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                            _iterator7.return();
                        }
                    } finally {
                        if (_didIteratorError7) {
                            throw _iteratorError7;
                        }
                    }
                }

                var igs = vessel.techEquipCertificate.igs;

                if (igs) {
                    igs.fitted = igs.fitted || undefined;
                    if (igs.systems) {
                        igs.systems = igs.systems.filter(function (s) {
                            return s.type || s.capacity || s.percentage;
                        }).map(function (s) {
                            return {
                                type: s.type || undefined,
                                capacity: parseFloat(s.capacity) || undefined,
                                percentage: parseFloat(s.percentage) || undefined
                            };
                        });
                    }
                }
            }

            if (vessel.areas) {
                vessel.areas.mainDeck = vessel.areas.mainDeck || undefined;
                vessel.areas.tweenDeck = vessel.areas.tweenDeck || undefined;
                vessel.areas.weatherDeck = vessel.areas.weatherDeck || undefined;
                vessel.areas.total = vessel.areas.total || undefined;
            }

            if (vessel.strength) {
                vessel.strength.maxTt = vessel.strength.maxTt || undefined;
                vessel.strength.maxTween = vessel.strength.maxTween || undefined;
                vessel.strength.maxWeather = vessel.strength.maxWeather || undefined;
            }

            if (vessel.stackWeight) {
                vessel.stackWeight['20hold'] = vessel.stackWeight['20hold'] || undefined;
                vessel.stackWeight['20deck'] = vessel.stackWeight['20deck'] || undefined;
                vessel.stackWeight['40hold'] = vessel.stackWeight['40hold'] || undefined;
                vessel.stackWeight['40deck'] = vessel.stackWeight['40deck'] || undefined;
            }

            vessel.cells = vessel.cells.filter(function (item) {
                var holdsLen = Object.values(item.holds).filter(function (_item) {
                    return _item;
                }).length;
                var tweenDecksLen0 = Object.values(item.tweenDecks[0]).filter(function (_item) {
                    return _item;
                }).length;
                var tweenDecksLen1 = Object.values(item.tweenDecks[1]).filter(function (_item) {
                    return _item;
                }).length;

                var hatchesLen0 = Object.values(item.hatches[0]).filter(function (_item) {
                    return _item;
                }).length;
                var hatchesLen1 = Object.values(item.hatches[1]).filter(function (_item) {
                    return _item;
                }).length;

                return holdsLen || tweenDecksLen0 || tweenDecksLen1 || hatchesLen0 || hatchesLen1;
            });

            if (vessel.cells) {
                vessel.cells.forEach(function (cell) {
                    cell.holds.l = parseFloat(cell.holds.l) || undefined;
                    cell.holds.b = parseFloat(cell.holds.b) || undefined;
                    cell.holds.h = parseFloat(cell.holds.h) || undefined;
                    cell.holds.area = parseFloat(cell.holds.area) || undefined;

                    cell.tweenDecks[0].l = parseFloat(cell.tweenDecks[0].l) || undefined;
                    cell.tweenDecks[0].b = parseFloat(cell.tweenDecks[0].b) || undefined;
                    cell.tweenDecks[0].h = parseFloat(cell.tweenDecks[0].h) || undefined;
                    cell.tweenDecks[0].area = parseFloat(cell.tweenDecks[0].area) || undefined;

                    cell.tweenDecks[1].l = parseFloat(cell.tweenDecks[1].l) || undefined;
                    cell.tweenDecks[1].b = parseFloat(cell.tweenDecks[1].b) || undefined;
                    cell.tweenDecks[1].h = parseFloat(cell.tweenDecks[1].h) || undefined;
                    cell.tweenDecks[1].area = parseFloat(cell.tweenDecks[1].area) || undefined;

                    cell.hatches[0].l = parseFloat(cell.hatches[0].l) || undefined;
                    cell.hatches[0].b = parseFloat(cell.hatches[0].b) || undefined;
                    cell.hatches[0].area = parseFloat(cell.hatches[0].area) || undefined;

                    cell.hatches[1].l = parseFloat(cell.hatches[1].l) || undefined;
                    cell.hatches[1].b = parseFloat(cell.hatches[1].b) || undefined;
                    cell.hatches[1].area = parseFloat(cell.hatches[1].area) || undefined;
                });
            }

            if (vessel.speedConsumptionV2) {
                vessel.speedConsumptionV2.forEach(function (val) {
                    val.speed = parseFloat(val.speed) || undefined;
                    val.ifo.cons = parseFloat(val.ifo.cons) || undefined;
                    val.mdo.cons = parseFloat(val.mdo.cons) || undefined;
                    val.lngCons = parseFloat(val.lngCons) || undefined;
                });
            }

            vessel.speedConsumptionV2 = vessel.speedConsumptionV2.filter(function (item) {
                return item.mode;
            });

            if (vessel.capacityV2) {
                vessel.capacityV2.constant = parseFloat(vessel.capacityV2.constant) || undefined;
                vessel.capacityV2.grain = parseFloat(vessel.capacityV2.grain) || undefined;
                vessel.capacityV2.bale = parseFloat(vessel.capacityV2.bale) || undefined;
                vessel.capacityV2.teu = parseFloat(vessel.capacityV2.teu) || undefined;
                vessel.capacityV2.feu = parseFloat(vessel.capacityV2.feu) || undefined;

                vessel.capacityV2.summary.forEach(function (item) {
                    if (!item.hold) item.hold = {};
                    item.hold.grain = parseFloat(item.hold.grain) || undefined;
                    item.hold.bale = parseFloat(item.hold.bale) || undefined;
                    item.hold.teu = parseFloat(item.hold.teu) || undefined;
                    item.hold.feu = parseFloat(item.hold.feu) || undefined;

                    if (!item.tweenDeck) item.tweenDeck = {};
                    item.tweenDeck.grain = parseFloat(item.tweenDeck.grain) || undefined;
                    item.tweenDeck.bale = parseFloat(item.tweenDeck.bale) || undefined;
                    item.tweenDeck.teu = parseFloat(item.tweenDeck.teu) || undefined;
                    item.tweenDeck.feu = parseFloat(item.tweenDeck.feu) || undefined;
                });
            }

            vessel.gearV2.summary = this.checkGears(vessel.gearV2.summary);
            vessel.grabV2.summary = Object(__WEBPACK_IMPORTED_MODULE_63_helpers_vessels__["a" /* checkGrabs */])(vessel.grabV2.summary);

            vessel.capacityV2.summary = this.checkCapacity(vessel.capacityV2.summary);

            if (vessel.grabV2) {
                vessel.grabV2.summary.forEach(function (grab) {
                    grab.type = grab.type || '';
                    grab.quantity = grab.quantity || undefined;
                    grab.volume = grab.volume || undefined;
                });
            }

            if (vessel.holds) {
                vessel.holds.quantity = vessel.holds.quantity || undefined;

                if (vessel.holds.lowerDims && vessel.holds.lowerDims.length) {
                    vessel.holds.lowerDims.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                        dim.h = dim.h || undefined;
                    });
                }

                if (vessel.holds.tweenDims && vessel.holds.tweenDims.length) {
                    vessel.holds.tweenDims.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                        dim.h = dim.h || undefined;
                    });
                }
            }

            if (vessel.hatches) {
                if (vessel.hatches.hatchType === 'Mc Greegor') {
                    vessel.hatches.hatchType = 'Mc Gregor';
                }
                if (vessel.hatches.size && vessel.hatches.size.length) {
                    vessel.hatches.size.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                    });
                }
            }

            vessel.imoClass = vessel.imoClass || undefined;

            if (vessel.builderV2 && vessel.builderV2.yard === '') {
                vessel.builderV2.yard = undefined;
            }

            if (vessel.bunkers.length > 0) {
                vessel.bunkers = vessel.bunkers.filter(function (item) {
                    return item.quantity && item.typeOfFuel;
                });
            }

            if (!vessel.disponentOwner._id && !vessel.disponentOwner.name) {
                delete vessel.disponentOwner;
            }

            if (vessel.pumps && vessel.pumps.cargo) {
                vessel.pumps.cargo = vessel.pumps.cargo.filter(function (p) {
                    return p.type || p.quantity || p.capacity;
                });
            }
            if (vessel.pumps && vessel.pumps.ballast) {
                vessel.pumps.ballast = vessel.pumps.ballast.filter(function (p) {
                    return p.type || p.quantity || p.capacity;
                });
            }
            if (vessel.registerClasses) {
                vessel.registerClasses = vessel.registerClasses.filter(function (c) {
                    return c.name && (c._id || c.iacsRegister === true || c.iacsRegister === false);
                }).map(function (c) {
                    return {
                        _id: c._id || undefined,
                        name: c.name || undefined,
                        iacsRegister: c.iacsRegister === true || c.iacsRegister === false ? c.iacsRegister : undefined
                    };
                });
                vessel.registerClass = undefined;
            }
            if (vessel.capacityTanker.tanks) {
                vessel.capacityTanker.tanks = vessel.capacityTanker.tanks.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.capacityTanker.slops) {
                vessel.capacityTanker.slops = vessel.capacityTanker.slops.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.capacityTanker.ballastTanks) {
                vessel.capacityTanker.ballastTanks = vessel.capacityTanker.ballastTanks.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.manifolds && vessel.manifolds.list) {
                vessel.manifolds.list = vessel.manifolds.list.filter(function (m) {
                    return m.number || m.size || m.commonLine;
                });
            }
            if (vessel.lastCargo) {
                vessel.lastCargo = vessel.lastCargo.map(function (tank) {
                    return {
                        cargoes: tank.cargoes.filter(function (c) {
                            return c.cargo._id && c.date;
                        }).map(function (c) {
                            return _extends({}, c, {
                                cargo: c.cargo._id.toString()
                            });
                        })
                    };
                });
            }
            if (vessel.certificateOfFitness) {
                vessel.certificateOfFitness = vessel.certificateOfFitness.map(function (c) {
                    return c._id;
                });
            }
            if (vessel.strength && vessel.strength.tanktopByHolds) {
                vessel.strength.tanktopByHolds = vessel.strength.tanktopByHolds.map(function (s) {
                    return parseInt(s, 10);
                }).filter(function (s) {
                    return !isNaN(s);
                });
            }

            delete vessel.modifiedFields;

            // field from old vessel model
            delete vessel.draft;
            delete vessel.tonnage;
            delete vessel.gears;
            delete vessel.consumptions;
            delete vessel.dw;
            delete vessel.capacity;
            return vessel;
        }
    }, {
        key: 'sizeUpdate',
        value: function sizeUpdate() {
            var vessel = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state);
            if (!vessel.typeByPurpose) {
                this.setState({
                    purposeErrorField: {
                        borderColor: __WEBPACK_IMPORTED_MODULE_12_material_ui_styles_colors__["red500"]
                    }
                });
                Object(__WEBPACK_IMPORTED_MODULE_58_helpers__["c" /* showNotification */])('Type by Purpose is required', 'error');
            } else {
                vessel = this.prepareToLoad(vessel);
                vessel && this.props.updateVessel(vessel);
            }
        }
    }, {
        key: 'sizeAdd',
        value: function sizeAdd() {
            var vessel = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state);
            if (!vessel.typeByPurpose) {
                this.setState({
                    purposeErrorField: {
                        borderColor: __WEBPACK_IMPORTED_MODULE_12_material_ui_styles_colors__["red500"]
                    }
                });
                Object(__WEBPACK_IMPORTED_MODULE_58_helpers__["c" /* showNotification */])('Type by Purpose is required', 'error');
            } else {
                vessel = this.prepareToLoad(vessel, true);
                vessel && this.props.addVessel(vessel);
            }
        }
    }, {
        key: 'changeGeared',
        value: function changeGeared(value) {
            var change = {
                geared: value,
                currentlyModifiedFields: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(this.state.currentlyModifiedFields), ['geared']))
            };

            if (!value) {
                var _getInitialState3 = getInitialState(),
                    grabbed = _getInitialState3.grabbed,
                    gearV2 = _getInitialState3.gearV2,
                    grabV2 = _getInitialState3.grabV2;

                change.gearV2 = gearV2;
                change.grabV2 = grabV2;
                change.grabbed = grabbed;
            }

            this.setState(change);
        }
    }, {
        key: 'changeGrabbed',
        value: function changeGrabbed(value) {
            var change = {
                grabbed: value,
                currentlyModifiedFields: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(this.state.currentlyModifiedFields), ['grabbed']))
            };

            if (!value) {
                var _getInitialState4 = getInitialState(),
                    grabV2 = _getInitialState4.grabV2;

                change.grabV2 = grabV2;
            }

            this.setState(change);
        }
    }, {
        key: 'checkCapacity',
        value: function checkCapacity(array) {
            return array.filter(function (item) {
                var _item$hold = item.hold,
                    hg = _item$hold.grain,
                    hb = _item$hold.bale,
                    ht = _item$hold.teu,
                    hf = _item$hold.feu,
                    _item$tweenDeck = item.tweenDeck,
                    tg = _item$tweenDeck.grain,
                    tb = _item$tweenDeck.bale,
                    tt = _item$tweenDeck.teu,
                    tf = _item$tweenDeck.feu;


                return hg || hb || ht || hf || tg || tb || tt || tf;
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.modifySizes !== this.props.modifySizes) {
                this.updateWithModifiedSizes(this.props.modifySizes);
            }

            /* delete scroll event listener from input elements */
            var inputs = document.querySelectorAll('input[type=number]');

            inputs.forEach(function (input) {
                input.removeEventListener('mousewheel', scroll);
                input.addEventListener('mousewheel', scroll);
            });
        }
    }, {
        key: 'updateWithModifiedSizes',
        value: function updateWithModifiedSizes(modifySizes) {
            var arrayIndex = void 0;
            switch (modifySizes.field) {
                case 'gearV2':
                    modifySizes.value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(modifySizes.value, ['approved', 'rejected']);
                    if (this.state.gearV2.summary.length === 1 && !this.state.gearV2.summary[0].type) {
                        this.changeFieldsMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["b" /* getPlainDeepKeysValues */])({ gearV2: { summary: [modifySizes.value] } }).map(function (o) {
                            var v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        })), [{ field: 'geared', value: true }]));
                    } else {
                        if (this.state.gearV2.summary.some(function (g) {
                            var _modifySizes$value = modifySizes.value,
                                type = _modifySizes$value.type,
                                quantity = _modifySizes$value.quantity,
                                capacity = _modifySizes$value.capacity,
                                outreach = _modifySizes$value.outreach,
                                maxSWL = _modifySizes$value.maxSWL;

                            return g.type === type && g.quantity === quantity && g.capacity === capacity && g.outreach === outreach && g.maxSWL === maxSWL;
                        })) {
                            return;
                        }
                        var emp = [];
                        emp.length = this.state.gearV2.summary.length;
                        this.changeFieldsMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["b" /* getPlainDeepKeysValues */])({
                            gearV2: {
                                summary: [].concat(emp, [modifySizes.value])
                            }
                        }).map(function (o) {
                            var v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        })), [{
                            geared: true
                        }]));
                    }

                    arrayIndex = this.state.gearV2.summary.length === 1 && !this.state.gearV2.summary[0].type ? 0 : this.state.gearV2.summary.length;
                    this.changeModifiedMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        arrayIndex: arrayIndex,
                        stateField: 'gearV2.summary',
                        value: modifySizes.value
                    })), _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'geared',
                        value: true
                    }))));
                    break;
                case 'grabV2':
                    if (this.state.grabV2.summary.some(function (g) {
                        var _modifySizes$value2 = modifySizes.value,
                            type = _modifySizes$value2.type,
                            volume = _modifySizes$value2.volume,
                            quantity = _modifySizes$value2.quantity;

                        return g.type === type && g.volume === volume && g.quantity === quantity;
                    })) {
                        return;
                    }
                    modifySizes.value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(modifySizes.value, ['approved', 'rejected']);
                    if (this.state.grabV2.summary.length === 1 && !this.state.grabV2.summary[0].type) {
                        this.changeFieldsMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["b" /* getPlainDeepKeysValues */])({ grabV2: { summary: [modifySizes.value] } }).map(function (o) {
                            var v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        })), [{ field: 'geared', value: true }, { field: 'grabbed', value: true }]));
                    } else {
                        var _emp = [];
                        _emp.length = this.state.grabV2.summary.length;
                        this.changeFieldsMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["b" /* getPlainDeepKeysValues */])({
                            grabV2: {
                                summary: [].concat(_emp, [modifySizes.value])
                            }
                        }).map(function (o) {
                            var v = Object.entries(o)[0];
                            return { field: v[0], value: v[1] };
                        })), [{
                            geared: true
                        }]));
                    }

                    arrayIndex = this.state.grabV2.summary.length === 1 && !this.state.grabV2.summary[0].type ? 0 : this.state.grabV2.summary.length;
                    this.changeModifiedMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        arrayIndex: arrayIndex,
                        stateField: 'grabV2.summary',
                        value: modifySizes.value
                    })), _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'geared',
                        value: true
                    })), _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'grabbed',
                        value: true
                    }))));
                    break;
                case 'speedConsumptionV2':
                    if (this.state.speedConsumptionV2.some(function (g) {
                        var _modifySizes$value3 = modifySizes.value,
                            mode = _modifySizes$value3.mode,
                            speed = _modifySizes$value3.speed,
                            ifo = _modifySizes$value3.ifo,
                            mdo = _modifySizes$value3.mdo;

                        return g.mode === mode && g.speed === speed && ifo && g.ifo.typeIfo === ifo.typeIfo && g.ifo.cons === ifo.cons && mdo && g.mdo.typeIfo === mdo.typeIfo && g.mdo.cons === mdo.cons;
                    })) {
                        return;
                    }
                    if (this.state.speedConsumptionV2.length === 1 && !this.state.speedConsumptionV2[0].mode) {
                        this.changeFieldsMultiple([{
                            field: modifySizes.field,
                            value: [Object.assign({}, getInitialState().speedConsumptionV2[0], modifySizes.value)]
                        }]);
                        this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                            arrayIndex: 0,
                            stateField: 'speedConsumptionV2',
                            value: modifySizes.value
                        }));
                    } else {
                        this.changeFieldsMultiple([{
                            field: modifySizes.field,
                            value: [].concat(_toConsumableArray(this.state.speedConsumptionV2), [Object.assign({}, getInitialState().speedConsumptionV2[0], modifySizes.value)])
                        }]);
                        this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                            arrayIndex: this.state.speedConsumptionV2.length,
                            stateField: 'speedConsumptionV2',
                            value: modifySizes.value
                        }));
                    }
                    break;
                case 'typeByPurpose':
                case 'typeByConstruction':
                case 'typeBySpecialty':
                    this.changeFieldsMultiple([{
                        field: modifySizes.field,
                        value: modifySizes.value
                    }]);
                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: modifySizes.field,
                        value: modifySizes.value
                    }));
                    break;
                case 'deadWeight':
                    this.changeFieldsMultiple([{
                        field: 'deadWeight',
                        value: _extends({}, this.state.deadWeight, modifySizes.value)
                    }]);
                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'deadWeight',
                        value: modifySizes.value
                    }));
                    break;
                case 'dimensions':
                    this.changeFieldsMultiple([{
                        field: 'dimensions',
                        value: _extends({}, this.state.dimensions, modifySizes.value)
                    }, {
                        field: 'dimensionsV2',
                        value: _extends({}, this.state.dimensionsV2, modifySizes.value)
                    }]);
                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'dimensions',
                        value: modifySizes.value
                    }));
                    break;
                case 'rt':
                    this.changeFieldsMultiple([{
                        field: 'rt',
                        value: _extends({}, this.state.rt, modifySizes.value)
                    }]);
                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'rt',
                        value: modifySizes.value
                    }));
                    break;
                case 'techEquipCertificate':
                    this.changeFieldsMultiple([{
                        field: 'techEquipCertificate',
                        value: _extends({}, this.state.techEquipCertificate, modifySizes.value)
                    }]);
                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'techEquipCertificate',
                        value: modifySizes.value
                    }));
                    break;
                case 'cells':
                    var isSame = true;

                    var modifyArray = Object.values(modifySizes.value);

                    for (var i = 0; i < modifyArray.length; i++) {
                        var g = this.state.cells[i];
                        var _modifyArray$i = modifyArray[i],
                            _modifyArray$i$holds = _modifyArray$i.holds,
                            holds = _modifyArray$i$holds === undefined ? {} : _modifyArray$i$holds,
                            tweenDecks = _modifyArray$i.tweenDecks,
                            hatches = _modifyArray$i.hatches;

                        if (!(holds && g.holds.l === holds.l && g.holds.b === holds.b && g.holds.h === holds.h && g.tweenDecks[0].l === tweenDecks[0].l && g.tweenDecks[0].b === tweenDecks[0].b && g.tweenDecks[0].h === tweenDecks[0].h && g.tweenDecks[1].l === tweenDecks[1].l && g.tweenDecks[1].b === tweenDecks[1].b && g.tweenDecks[1].h === tweenDecks[1].h && g.hatches[0].l === hatches[0].l && g.hatches[0].b === hatches[0].b && g.hatches[1].l === hatches[1].l && g.hatches[1].b === hatches[1].b)) {
                            isSame = false;
                            break;
                        }
                    }

                    if (isSame) return;

                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = Object.values(modifySizes.value)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var val = _step8.value;

                            if (!val.holds) val.holds = {};
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }

                    var updatedCells = [];

                    var vals = Object.values(modifySizes.value);

                    for (var _i = 0; _i < vals.length; _i++) {
                        updatedCells.push(Object.assign({}, this.state.cells[_i] || {}, vals[_i] || {}));
                    }

                    this.changeFieldsMultiple({
                        field: 'cells',
                        value: updatedCells
                    });

                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        arrayIndex: 0,
                        stateField: 'cells',
                        value: updatedCells
                    }));
                    break;
                case 'flag':
                    this.changeFieldsMultiple([{
                        field: 'flag',
                        value: _extends({}, modifySizes.value)
                    }, {
                        field: 'flagObject',
                        value: _extends({}, modifySizes.value)
                    }]);
                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'flag',
                        value: modifySizes.value
                    }));
                    break;
                case 'registerClass':
                case 'registerClasses':
                    var v = modifySizes.value;

                    if (modifySizes.field === 'registerClass') {
                        v = [v];
                    }

                    this.changeFieldsMultiple([{
                        field: 'registerClasses',
                        value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(v)
                    }]);
                    this.changeModifiedMultiple(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'registerClasses',
                        value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(v)
                    }));
                    break;
                case 'piClub':
                    this.changeFieldsMultiple([{
                        field: 'piClub',
                        value: _extends({}, modifySizes.value)
                    }, {
                        field: 'piClubObject',
                        value: _extends({}, modifySizes.value)
                    }]);
                    this.changeModifiedMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'piClub',
                        value: modifySizes.value
                    })), _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'piClubObject',
                        value: modifySizes.value
                    }))));
                    break;
                case 'capacityV2':
                    this.changeFieldsMultiple([{
                        field: 'capacityV2',
                        value: _extends({}, this.state.capacityV2, modifySizes.value)
                    }, {
                        field: 'capacity',
                        value: _extends({}, this.state.capacity, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(modifySizes.value, ['summary']))
                    }]);
                    this.changeModifiedMultiple([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_60__utils__["a" /* calculateDeepPaths */])({
                        stateField: 'capacityV2',
                        value: modifySizes.value
                    }))));
                    break;
                case 'boxShaped':
                case 'openHatch':
                    this.changeFieldsMultiple([{
                        field: modifySizes.field,
                        value: modifySizes.value
                    }]);
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var _state3 = this.state,
                confirmed = _state3.confirmed,
                areas = _state3.areas,
                strength = _state3.strength,
                stackWeight = _state3.stackWeight,
                certificateOfFitness = _state3.certificateOfFitness,
                holds = _state3.holds,
                hatches = _state3.hatches,
                holdsHatchesProducer = _state3.holdsHatchesProducer,
                builderV2 = _state3.builderV2,
                registerNumber = _state3.registerNumber,
                registerClasses = _state3.registerClasses,
                classNotation = _state3.classNotation,
                piClubObject = _state3.piClubObject,
                piClub = _state3.piClub,
                typeByPurpose = _state3.typeByPurpose,
                typeByConstruction = _state3.typeByConstruction,
                typeBySpecialty = _state3.typeBySpecialty,
                typeBySize = _state3.typeBySize,
                openHatch = _state3.openHatch,
                boxShaped = _state3.boxShaped,
                gearV2 = _state3.gearV2,
                geared = _state3.geared,
                grabV2 = _state3.grabV2,
                grabbed = _state3.grabbed,
                pumps = _state3.pumps,
                techEquipCertificate = _state3.techEquipCertificate,
                cargoExclusionV2Object = _state3.cargoExclusionV2Object,
                cargoExclusionV2List = _state3.cargoExclusionV2List,
                cargoExclusionsV2 = _state3.cargoExclusionsV2,
                deadWeight = _state3.deadWeight,
                rt = _state3.rt,
                dimensions = _state3.dimensions,
                manifolds = _state3.manifolds,
                capacityV2 = _state3.capacityV2,
                capacityTanker = _state3.capacityTanker,
                cells = _state3.cells,
                temporaryHohaAreas = _state3.temporaryHohaAreas,
                speedConsumptionV2 = _state3.speedConsumptionV2,
                flagObject = _state3.flagObject,
                flag = _state3.flag,
                managerObject = _state3.managerObject,
                manager = _state3.manager,
                registeredOwner = _state3.registeredOwner,
                homePortObject = _state3.homePortObject,
                homePort = _state3.homePort,
                name = _state3.name,
                imoNumber = _state3.imoNumber,
                blt = _state3.blt,
                exNames = _state3.exNames,
                nationalities = _state3.nationalities,
                typeOfPage = _state3.typeOfPage,
                engineLocation = _state3.engineLocation,
                engines = _state3.engines,
                modifiedFields = _state3.modifiedFields,
                currentlyModifiedFields = _state3.currentlyModifiedFields,
                purposeErrorField = _state3.purposeErrorField,
                toggleSpeedConsAll = _state3.toggleSpeedConsAll,
                windScale = _state3.windScale,
                bunkers = _state3.bunkers,
                description = _state3.description,
                design = _state3.design,
                disponentOwner = _state3.disponentOwner,
                linerMeter = _state3.linerMeter,
                showAddButton = _state3.showAddButton,
                doubleHull = _state3.doubleHull,
                hullNumber = _state3.hullNumber,
                callSign = _state3.callSign,
                officialNumber = _state3.officialNumber,
                mmsi = _state3.mmsi,
                lastCargo = _state3.lastCargo,
                attachmentsArray = _state3.attachmentsArray;


            console.log(grabV2);

            var _getInitialState5 = getInitialState(),
                defaultBuilderV2 = _getInitialState5.builderV2;

            var allModifiedFields = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(modifiedFields), _toConsumableArray(currentlyModifiedFields)));

            var linerMeterDisabled = !new RegExp('ro-(ro|lo)', 'i').test(typeBySpecialty);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'top-bar', style: { background: '#fff', margin: '-18px 0 -7px 0' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton___default.a, {
                            backgroundColor: '#00bcd4',
                            labelStyle: { color: '#fff', fontWeight: 'bold' },
                            label: 'UPDATE',
                            onClick: this.sizeUpdate,
                            disabled: !this.state._id
                        }),
                        showAddButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton___default.a, {
                            backgroundColor: '#00bcd4',
                            labelColor: '#fff',
                            label: 'CREATE',
                            onClick: this.sizeAdd,
                            disabled: !!this.state._id
                        })
                    )
                ),
                this.props.numberSizeTable || this.props.numberSizeTable === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__VesselShortInfo__["a" /* default */], {
                    numberSizeTable: this.props.numberSizeTable
                }) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-5' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Vessels_Single_Rows_Name__["a" /* default */], {
                                name: name,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Vessels_Single_Rows_ExNames__["a" /* default */], {
                            exNames: exNames,
                            confirmed: !confirmed,
                            changeField: this.changeField,
                            getError: this.getError,
                            modifiedFields: allModifiedFields,
                            underStyle: styles.underlineStyle
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-5' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Vessels_Single_Rows_ImoNumber__["a" /* default */], {
                                imoNumber: imoNumber,
                                confirmed: !confirmed,
                                typeOfPage: typeOfPage,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Vessels_Single_Rows_Nationalities__["a" /* default */], {
                            value: nationalities,
                            confirmed: !confirmed,
                            changeField: this.changeField,
                            getError: this.getError,
                            modifiedFields: allModifiedFields,
                            underStyle: styles.underlineStyle
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Vessels_Single_Rows_Blt__["a" /* default */], {
                                blt: blt,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-9' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-2' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { style: { margin: '40px 0 0', textAlign: 'right' } },
                                        'Builder:'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Vessels_Single_Rows_BuilderYard__["a" /* default */], {
                                        getError: this.getError,
                                        changeField: this.changeField,
                                        yard: builderV2.yard || builderV2.yard || defaultBuilderV2.yard,
                                        confirmed: !confirmed,
                                        modifiedFields: allModifiedFields,
                                        underStyle: styles.underlineStyle
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Vessels_Single_Rows_BuilderCountry__["a" /* default */], {
                                        getError: this.getError,
                                        changeAutoComplete: this.changeAutoComplete,
                                        country: builderV2.country || builderV2.country || defaultBuilderV2.country,
                                        confirmed: !confirmed,
                                        modifiedFields: allModifiedFields,
                                        underStyle: styles.underlineStyle
                                    })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Vessels_Single_Rows_Flag__["a" /* default */], {
                                changeAutoComplete: this.changeAutoComplete,
                                getError: this.getError,
                                flagObject: flag._id ? flag : flagObject,
                                confirmed: !confirmed,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Vessels_Single_Rows_PortOfRegistry__["a" /* default */], {
                                homePortObject: homePort && homePort._id ? homePort : homePortObject,
                                confirmed: !confirmed,
                                changeAutoComplete: this.changeAutoComplete,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["A" /* TextField */], {
                                name: 'registerNumber',
                                disabled: !confirmed,
                                value: registerNumber,
                                floatingLabelText: 'Registry \u2116',
                                onChange: function onChange(e) {
                                    return _this6.changeField( /** @type {any} */{
                                        field: 'registerNumber',
                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                    });
                                },
                                fullWidth: true
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Vessels_Single_Rows_RegisterClasses__["a" /* default */], {
                        registerClasses: registerClasses,
                        changeField: this.changeFieldsMultiple,
                        confirmed: confirmed,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle,
                        clearError: this.clearError
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["A" /* TextField */], {
                        name: 'classNotation',
                        disabled: !confirmed,
                        value: classNotation,
                        floatingLabelText: 'Class notation',
                        onChange: function onChange(e) {
                            return _this6.changeField( /** @type {any} */{
                                field: 'classNotation',
                                value: /** @type {HTMLInputElement} */e.currentTarget.value
                            });
                        },
                        fullWidth: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Vessels_Single_Rows_PIClub__["a" /* default */], {
                                piClubObject: piClubObject.name.length || !piClub ? piClubObject : piClub,
                                changeField: this.changeField,
                                confirmed: !confirmed,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle,
                                clearError: this.clearError
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62_components_Vessels_Single_Rows_RegisteredOwner__["a" /* default */], {
                                _registeredOwnerObject: registeredOwner,
                                confirmed: !confirmed,
                                changeAutoComplete: this.changeAutoComplete,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Vessels_Single_Rows_Manager__["a" /* default */], {
                                managerObject: manager && manager._id ? manager : managerObject,
                                confirmed: !confirmed,
                                changeAutoComplete: this.changeAutoComplete,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__Vessels_Single_Rows_Design__["a" /* default */], {
                                design: design,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__Vessels_Single_Rows_DisponentOwner__["a" /* default */], {
                                changeField: this.changeField,
                                confirmed: !confirmed,
                                disponentOwner: disponentOwner
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_material_ui__["s" /* SelectField */],
                                {
                                    value: openHatch,
                                    onChange: function onChange(e, i, value) {
                                        return _this6.changeFieldsMultiple([{ field: 'openHatch', value: value }]);
                                    },
                                    disabled: !confirmed,
                                    name: 'openHatch',
                                    floatingLabelText: 'Open Hatch',
                                    labelStyle: allModifiedFields && allModifiedFields.includes('openHatch') ? styles.toggleLabelStyle : null,
                                    underlineStyle: allModifiedFields && allModifiedFields.includes('openHatch') ? styles.underlineStyle : null,
                                    autoWidth: true,
                                    fullWidth: true
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["m" /* MenuItem */], { value: null, primaryText: undefined }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["m" /* MenuItem */], { value: true, primaryText: 'Yes' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["m" /* MenuItem */], { value: false, primaryText: 'No' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_material_ui__["s" /* SelectField */],
                                {
                                    value: boxShaped,
                                    onChange: function onChange(e, i, value) {
                                        return _this6.changeFieldsMultiple([{ field: 'boxShaped', value: value }]);
                                    },
                                    disabled: !confirmed,
                                    name: 'boxShaped',
                                    floatingLabelText: 'Box Shaped',
                                    labelStyle: allModifiedFields && allModifiedFields.includes('boxShaped') ? styles.toggleLabelStyle : null,
                                    underlineStyle: allModifiedFields && allModifiedFields.includes('boxShaped') ? styles.underlineStyle : null,
                                    autoWidth: true,
                                    fullWidth: true
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["m" /* MenuItem */], { value: null, primaryText: undefined }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["m" /* MenuItem */], { value: true, primaryText: 'Yes' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["m" /* MenuItem */], { value: false, primaryText: 'No' })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox___default.a, {
                                style: { margin: '40px 0 0' },
                                label: 'Double hull',
                                checked: doubleHull,
                                disabled: !confirmed,
                                onCheck: function onCheck() {
                                    return _this6.changeField( /** @type {any} */{
                                        field: 'doubleHull',
                                        value: !doubleHull
                                    });
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["A" /* TextField */], {
                                name: 'hullNumber',
                                disabled: !confirmed,
                                value: hullNumber,
                                floatingLabelText: 'Hull number',
                                onChange: function onChange(e) {
                                    return _this6.changeField( /** @type {any} */{
                                        field: 'hullNumber',
                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                    });
                                },
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["A" /* TextField */], {
                                name: 'callSign',
                                disabled: !confirmed,
                                value: callSign,
                                floatingLabelText: 'Call sign',
                                onChange: function onChange(e) {
                                    return _this6.changeField( /** @type {any} */{
                                        field: 'callSign',
                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                    });
                                },
                                fullWidth: true
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["A" /* TextField */], {
                                name: 'officialNumber',
                                disabled: !confirmed,
                                value: officialNumber,
                                floatingLabelText: 'Official number',
                                onChange: function onChange(e) {
                                    return _this6.changeField( /** @type {any} */{
                                        field: 'officialNumber',
                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                    });
                                },
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["A" /* TextField */], {
                                name: 'mmsi',
                                disabled: !confirmed,
                                value: mmsi,
                                floatingLabelText: 'MMSI',
                                onChange: function onChange(e) {
                                    return _this6.changeField( /** @type {any} */{
                                        field: 'mmsi',
                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                    });
                                },
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__Vessels_Single_Rows_LinerMeter__["a" /* default */], {
                                linerMeter: linerMeter,
                                linerMeterDisabled: linerMeterDisabled,
                                changeFieldsMultiple: this.changeFieldsMultiple,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Vessels_Single_Rows_TypeByPurpose__["a" /* default */], {
                                type: typeByPurpose,
                                confirmed: !confirmed,
                                changeField: this.changeFieldsMultiple,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: purposeErrorField.hasOwnProperty('borderColor') ? purposeErrorField : styles.underlineStyle,
                                purposeErrorField: purposeErrorField
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Vessels_Single_Rows_TypeBySpecialty__["a" /* default */], {
                                typeBySpecialty: typeBySpecialty,
                                confirmed: !confirmed,
                                changeField: this.changeFieldsMultiple,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle,
                                typeByPurpose: typeByPurpose
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Vessels_Single_Rows_TypeByConstruction__["a" /* default */], {
                                type: typeByConstruction,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Vessels_Single_Rows_TypeBySize__["a" /* default */], {
                                type: typeBySize,
                                confirmed: confirmed,
                                changeField: this.changeFieldsMultiple,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'name-block static huge-name' },
                                'GEAR:'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'col-xs-3 col-xs-offset-8'
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__Vessels_Single_Rows_GearedGrabbed__["a" /* default */], {
                                confirmed: confirmed,
                                fieldName: 'geared',
                                gearedGrabbed: geared,
                                onChange: this.changeGeared,
                                modifiedFields: allModifiedFields,
                                styles: styles
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Vessels_Single_Rows_GearV2__["a" /* default */], {
                                gearV2: gearV2,
                                confirmed: !confirmed,
                                changeField: this.changeFieldsMultiple,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle,
                                toggleLabelStyle: styles.toggleLabelStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    {
                        title: 'GRABS:',
                        titleControl: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__Vessels_Single_Rows_GearedGrabbed__["a" /* default */], {
                            confirmed: confirmed,
                            fieldName: 'grabbed',
                            gearedGrabbed: grabbed,
                            onChange: this.changeGrabbed,
                            modifiedFields: allModifiedFields,
                            styles: styles
                        })
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__Vessels_Single_Rows_GrabV2__["a" /* default */], {
                        grabs: grabV2,
                        confirmed: !confirmed,
                        changeField: this.changeFieldsMultiple,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'PUMPS:' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__Vessels_Single_Rows_Pumps__["a" /* default */], {
                                type: 'cargo',
                                pumps: pumps.cargo,
                                confirmed: !confirmed,
                                changeField: this.changeFieldsMultiple,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__Vessels_Single_Rows_Pumps__["a" /* default */], {
                                type: 'ballast',
                                pumps: pumps.ballast,
                                confirmed: !confirmed,
                                changeField: this.changeFieldsMultiple,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__Vessels_Single_Rows_TechEquipCertificate__["a" /* default */], {
                                confirmed: !confirmed,
                                techEquipCertificate: techEquipCertificate,
                                changeField: this.changeFieldsMultiple,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle,
                                toggleLabelStyle: styles.toggleLabelStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'TONNAGE, reg tons'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__Vessels_Single_Rows_Tonnage__["a" /* default */], {
                                confirmed: !confirmed,
                                rt: rt,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'CARGO EXCLUSIONS'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__Vessels_Single_Rows_CargoExclussionsV2__["a" /* default */], {
                                cargoExclusionV2Object: cargoExclusionV2Object,
                                cargoExclusionV2List: cargoExclusionV2List.length || !cargoExclusionsV2 ? cargoExclusionV2List : cargoExclusionsV2,
                                cargoExclusionsV2: cargoExclusionsV2,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'Last 3 Cargo', initiallyCollapsed: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__Vessels_Single_Rows_LastCargo__["a" /* default */], {
                        lastCargo: lastCargo,
                        disabled: !confirmed,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'name-block static huge-name' },
                                'DEADWEIGHT / OTHER:'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3 col-xs-offset-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Base_NumberField__["a" /* default */], {
                                name: 'capacityV2.constant',
                                floatingLabelText: 'Constant, mt',
                                style: { margin: '-35px 0 -25px 0' },
                                value: capacityV2.constant || '',
                                fullWidth: true,
                                floatNumber: true,
                                errorText: this.getError('capacityV2.constant'),
                                onChange: function onChange(e, value) {
                                    _this6.changeFieldsMultiple([{
                                        field: 'capacityV2.constant',
                                        value: value,
                                        type: 'number'
                                    }]);
                                },
                                underlineStyle: modifiedFields && modifiedFields.includes('capacityV2.constant') ? styles.underlineStyle : null
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__Vessels_Single_Rows_Deadweight__["a" /* default */], {
                                deadWeight: deadWeight,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle,
                                clearError: this.clearError
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'CAPACITY GENERAL' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__Vessels_Single_Rows_CapacityV2__["a" /* default */], {
                        capacityV2: capacityV2,
                        confirmed: !confirmed,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'HO/HA' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Vessels_Single_Rows_HoldsHatchesTop__["a" /* default */], {
                        holds: holds,
                        confirmed: !confirmed,
                        hatches: hatches,
                        holdsHatchesProducer: holdsHatchesProducer,
                        changeHolds: this.changeHolds,
                        changeHatches: this.changeHatches,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__Vessels_Single_Rows_Cells__["a" /* default */], {
                        cells: cells,
                        changeAreas: this.changeAreas,
                        changeField: this.changeField,
                        confirmed: !confirmed,
                        getError: this.getError,
                        temporaryHohaAreas: temporaryHohaAreas,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__Vessels_Single_Rows_Areas__["a" /* default */], {
                        areas: areas,
                        confirmed: !confirmed,
                        changeAreas: this.changeAreas,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'CAPACITY TANKER' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__Vessels_Single_Rows_CapacityTanker__["a" /* default */], {
                        capacityTanker: capacityTanker,
                        confirmed: !confirmed,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'DIMENSIONS, m'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__Vessels_Single_Rows_Dimensions__["a" /* default */], {
                                dimensions: dimensions,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'MANIFOLDS' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__Vessels_Single_Rows_Manifolds__["a" /* default */], {
                        manifolds: manifolds,
                        confirmed: !confirmed,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'name-block static huge-name' },
                                'SPEED & CONSUMPTION:'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-offset-5', style: { marginTop: '2px' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'name-block static huge-name', style: { color: '#b0b0b0', fontSize: '14px' } },
                                'Modify all:'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Toggle___default.a, {
                                name: 'modifyAllIfo',
                                label: 'IFO',
                                disabled: !confirmed,
                                toggled: toggleSpeedConsAll.IFO,
                                onToggle: function onToggle() {
                                    return _this6.toggleModifySpeedCons('IFO');
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Toggle___default.a, {
                                name: 'modifyAllMdo',
                                label: 'MDO',
                                disabled: !confirmed,
                                toggled: toggleSpeedConsAll.MDO,
                                onToggle: function onToggle() {
                                    return _this6.toggleModifySpeedCons('MDO');
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__Vessels_Single_Rows_SpeedConsumptionV2__["a" /* default */], {
                                speedConsumptionV2: speedConsumptionV2,
                                confirmed: !confirmed,
                                changeField: this.changeField,
                                getError: this.getError,
                                modifiedFields: allModifiedFields,
                                underStyle: styles.underlineStyle
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'BUNKERS'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__Vessels_Single_Rows_Bunkers__["a" /* default */], {
                        bunkers: bunkers,
                        confirmed: !confirmed,
                        changeField: this.changeField,
                        getError: this.getError
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'PERMISSIBLE LOADS' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__Vessels_Single_Rows_Strength__["a" /* default */], {
                        strength: strength,
                        confirmed: !confirmed,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__Vessels_Single_Rows_StackWeight__["a" /* default */], {
                        stackWeight: stackWeight,
                        confirmed: !confirmed,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_61__CollapsableSection__["a" /* default */],
                    { title: 'CERTIFICATE OF FITNESS' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__Vessels_Single_Rows_CertificateOfFitness__["a" /* default */], {
                        confirmed: confirmed,
                        certificateOfFitness: certificateOfFitness,
                        changeField: this.changeField
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'OTHER FIELDS'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__Vessels_Single_Rows_OtherFields__["a" /* default */], {
                        confirmed: !confirmed,
                        engineLocation: engineLocation,
                        engines: engines,
                        windScale: windScale,
                        changeField: this.changeField,
                        getError: this.getError,
                        modifiedFields: allModifiedFields,
                        underStyle: styles.underlineStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'DESCRIPTION'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__Vessels_Single_Rows_Description__["a" /* default */], {
                        confirmed: !confirmed,
                        description: description,
                        changeField: this.changeField,
                        getError: this.getError
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom', style: { paddingTop: '10px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__Vessels_Single_Rows_Attachments__["a" /* default */], {
                        attachments: attachmentsArray,
                        changeField: this.changeField,
                        confirmed: confirmed
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SizesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(
/** @param {any} param0 */
function (_ref4) {
    var vessel = _ref4.vessel;
    return {
        vessel: vessel
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
        updateVessel: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_vessels__["i" /* updateVessel */],
        addVessel: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_vessels__["a" /* addVessel */],
        notificationPurposeRequired: __WEBPACK_IMPORTED_MODULE_7_actions_vessels_size__["d" /* notificationPurposeRequired */],
        saveVessel: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_vessels__["h" /* saveVessel */],
        clearVessel: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_vessels__["b" /* clearVessel */]
    }, dispatch);
})(SizesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/SizesTable.jsx');
    reactHotLoader.register(defaultCargo, 'defaultCargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/SizesTable.jsx');
    reactHotLoader.register(scroll, 'scroll', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/SizesTable.jsx');
    reactHotLoader.register(getInitialState, 'getInitialState', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/SizesTable.jsx');
    reactHotLoader.register(SizesTable, 'SizesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/SizesTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/SizesTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Name = function (_React$PureComponent) {
    _inherits(Name, _React$PureComponent);

    function Name() {
        _classCallCheck(this, Name);

        return _possibleConstructorReturn(this, (Name.__proto__ || Object.getPrototypeOf(Name)).apply(this, arguments));
    }

    _createClass(Name, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                confirmed = _props.confirmed,
                getError = _props.getError,
                changeField = _props.changeField,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                        name: 'name',
                        disabled: confirmed,
                        floatingLabelText: 'Name',
                        value: name || '',
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'name',
                                value: value
                            });
                        },
                        errorText: getError('name'),
                        fullWidth: true,

                        underlineStyle: modifiedFields && modifiedFields.includes('name') ? underStyle : null
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Name;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Name;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Name, 'Name', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Name.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Name.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var styles = {
    button: __WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors__["orange500"]
};

var ExNames = function (_React$Component) {
    _inherits(ExNames, _React$Component);

    function ExNames(props) {
        _classCallCheck(this, ExNames);

        var _this = _possibleConstructorReturn(this, (ExNames.__proto__ || Object.getPrototypeOf(ExNames)).call(this, props));

        _this.state = {
            open: false,
            anchorEl: null,
            exNameAdd: ''
        };

        _this.handleOpen = _this.handleOpen.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.menuItems = _this.menuItems.bind(_this);
        _this.removeVesselName = _this.removeVesselName.bind(_this);
        _this.handleVesselAddNameField = _this.handleVesselAddNameField.bind(_this);
        _this.handleVesselAddFormerName = _this.handleVesselAddFormerName.bind(_this);
        return _this;
    }

    _createClass(ExNames, [{
        key: 'handleOpen',
        value: function handleOpen(e) {
            e.preventDefault();

            this.setState({
                open: true,
                anchorEl: e.currentTarget
            });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.setState({
                open: false
            });
        }
    }, {
        key: 'removeVesselName',
        value: function removeVesselName(index) {
            var exNames = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.exNames);
            exNames.splice(index, 1);
            this.props.changeField({
                field: 'exNames',
                value: exNames
            });
        }
    }, {
        key: 'handleVesselAddNameField',
        value: function handleVesselAddNameField(exNameAdd) {
            this.setState({
                exNameAdd: exNameAdd
            });
        }
    }, {
        key: 'handleVesselAddFormerName',
        value: function handleVesselAddFormerName(exName) {
            var exNames = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.exNames);
            var exNameAdd = this.state.exNameAdd;


            if (exNameAdd.trim()) {
                exNames.push({ name: exNameAdd });

                this.props.changeField({
                    field: 'exNames',
                    value: exNames
                });

                this.setState({
                    exNameAdd: ''
                });

                this.menuItems(exNames);
            }
        }
    }, {
        key: 'menuItems',
        value: function menuItems(exNames) {
            var _this2 = this;

            return exNames.map(function (exName, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                    key: index,
                    value: exName.name,
                    primaryText: exName.name,
                    rightIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                        onClick: function onClick() {
                            _this2.removeVesselName(index);
                        },
                        color: 'red'
                    })
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                open = _state.open,
                anchorEl = _state.anchorEl,
                exNameAdd = _state.exNameAdd;
            var _props = this.props,
                confirmed = _props.confirmed,
                getError = _props.getError,
                exNames = _props.exNames,
                modifiedFields = _props.modifiedFields;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default.a, {
                        disabled: confirmed,
                        name: 'exNameAdd',
                        value: exNameAdd,
                        errorText: getError('exNameAdd'),
                        onChange: function onChange(e, value) {
                            _this3.handleVesselAddNameField(value);
                        },
                        floatingLabelText: 'Former vessel name',
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-1' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,
                        { onClick: this.handleVesselAddFormerName, style: { margin: '20px 0 0' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3', style: { margin: '28px 0 0 0' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                        onClick: this.handleOpen,
                        label: 'Past names',
                        labelStyle: { fontSize: '13px' },
                        disabled: !exNames.length,
                        backgroundColor: modifiedFields && modifiedFields.includes('exNames') ? styles.button : null
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Popover___default.a,
                        {
                            open: open,
                            anchorEl: anchorEl,
                            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                            targetOrigin: { horizontal: 'left', vertical: 'top' },
                            onRequestClose: this.handleClose
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu___default.a,
                            null,
                            this.menuItems(exNames)
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ExNames;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ExNames;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/ExNames.jsx');
    reactHotLoader.register(ExNames, 'ExNames', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/ExNames.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/ExNames.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_nationalities__ = __webpack_require__(678);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var styles = {
    button: __WEBPACK_IMPORTED_MODULE_10_material_ui_styles_colors__["orange500"]
};

var Nationalities = function (_React$Component) {
    _inherits(Nationalities, _React$Component);

    function Nationalities(props) {
        _classCallCheck(this, Nationalities);

        var _this = _possibleConstructorReturn(this, (Nationalities.__proto__ || Object.getPrototypeOf(Nationalities)).call(this, props));

        _this.state = {
            open: false,
            query: '',
            nationality: null, // The nationality represented by the query
            dataSource: [],
            anchorEl: null
        };

        _this.handleOpen = _this.handleOpen.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.menuItems = _this.menuItems.bind(_this);
        _this.handleRemove = _this.handleRemove.bind(_this);
        _this.handleAdd = _this.handleAdd.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(Nationalities, [{
        key: 'handleOpen',
        value: function handleOpen(e) {
            e.preventDefault();

            this.setState({
                open: true,
                anchorEl: e.currentTarget
            });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.setState({
                open: false
            });
        }
    }, {
        key: 'handleRemove',
        value: function handleRemove(id) {
            var value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.value);
            var index = value.findIndex(function (item) {
                return item.id === id;
            });
            if (index < 0) return;
            value.splice(index, 1);
            this.props.changeField({
                field: 'nationalities',
                value: value
            });
        }
    }, {
        key: 'handleAdd',
        value: function handleAdd() {
            var nationality = this.state.nationality;


            if (!nationality) return;

            var value = this.props.value;

            if (value.findIndex(function (n) {
                return n.id === nationality.id;
            }) < 0) {
                this.props.changeField({
                    field: 'nationalities',
                    value: [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(value)), [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(nationality, ['name'])])
                });
            }

            this.setState({
                query: '',
                nationality: null,
                dataSource: []
            });
        }
    }, {
        key: 'menuItems',
        value: function menuItems(nationalities) {
            var _this2 = this;

            return nationalities.map(function (item) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                    key: item.id,
                    value: item.id,
                    primaryText: item.names.join(' / '),
                    rightIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                        onClick: function onClick() {
                            return _this2.handleRemove(item.id);
                        },
                        color: 'red'
                    })
                });
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(query) {
            var _this3 = this;

            this.setState({ query: query });

            Object(__WEBPACK_IMPORTED_MODULE_11__services_nationalities__["a" /* getNationalities */])(query).then(function (_ref) {
                var errors = _ref.errors,
                    data = _ref.data;

                if (errors.length) return;
                _this3.setState({
                    dataSource: data.map(function (item) {
                        return _extends({}, item, {
                            name: item.names.join(' / ')
                        });
                    })
                });
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(nationality) {
            this.setState({ nationality: nationality });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                open = _state.open,
                query = _state.query,
                dataSource = _state.dataSource,
                anchorEl = _state.anchorEl;
            var _props = this.props,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                value = _props.value;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                        name: 'query',
                        floatingLabelText: 'Officers / Crew',
                        disabled: confirmed,
                        searchText: query,
                        dataSource: dataSource,
                        dataSourceConfig: { text: 'name', value: 'id' },
                        onUpdateInput: this.handleSearch,
                        onNewRequest: this.handleChange,
                        filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px' },
                        popoverProps: { canAutoPosition: true },
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-1' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default.a,
                        { onClick: this.handleAdd, style: { margin: '20px 0 0' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3', style: { margin: '28px 0 0 0' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                        onClick: this.handleOpen,
                        label: 'Nationality',
                        labelStyle: { fontSize: '13px' },
                        disabled: !value.length,
                        backgroundColor: modifiedFields && modifiedFields.includes('nationalities') ? styles.button : null
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Popover___default.a,
                        {
                            open: open,
                            anchorEl: anchorEl,
                            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                            targetOrigin: { horizontal: 'left', vertical: 'top' },
                            onRequestClose: this.handleClose
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default.a,
                            null,
                            this.menuItems(value)
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Nationalities;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Nationalities;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Nationalities.jsx');
    reactHotLoader.register(Nationalities, 'Nationalities', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Nationalities.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Nationalities.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_NumberField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ImoNumber = function (_React$Component) {
    _inherits(ImoNumber, _React$Component);

    function ImoNumber(props) {
        _classCallCheck(this, ImoNumber);

        var _this = _possibleConstructorReturn(this, (ImoNumber.__proto__ || Object.getPrototypeOf(ImoNumber)).call(this, props));

        _this.state = {
            imoNumber: props.imoNumber,
            hasError: props.getError('imoNumber'),
            disabled: false,
            confirmed: props.confirmed
        };

        _this.changeAndCheckImoNumber = _this.changeAndCheckImoNumber.bind(_this);
        return _this;
    }

    _createClass(ImoNumber, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.imoNumber !== this.state.imoNumber || this.state.hasError.length > 0 || nextProps.getError('name').length > 0 || nextProps.confirmed !== this.state.confirmed;
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                imoNumber: nextProps.imoNumber,
                hasError: nextProps.getError('imoNumber'),
                disabled: nextProps.typeOfPage !== 'new',
                confirmed: nextProps.confirmed
            });
        }
    }, {
        key: 'changeAndCheckImoNumber',
        value: function changeAndCheckImoNumber(e, value) {
            var _this2 = this;

            var re = /^[0-9]*$/gm;

            if (value[0] === '0') {
                return this.setState({
                    imoNumber: ''
                }, function () {
                    _this2.props.changeField({
                        field: 'imoNumber',
                        value: value
                    });
                });
            }

            if (re.test(value) && value.length < 7) {
                return this.setState({
                    imoNumber: parseInt(value, 10),
                    hasError: ''
                }, function () {
                    _this2.props.changeField({
                        field: 'imoNumber',
                        value: value
                    });
                });
            } else if (value.length === 7) {
                this.setState({
                    imoNumber: parseInt(value, 10)
                }, function () {
                    __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].checkImoNumberRegistered(value).then(function (registered) {
                        if (registered) {
                            _this2.setState({
                                hasError: 'imoNumber already exist'
                            });
                        } else {
                            _this2.setState({
                                hasError: ''
                            }, function () {
                                _this2.props.changeField({
                                    field: 'imoNumber',
                                    value: value
                                });
                            });
                        }
                    }).catch(function (err) {
                        console.error(err);
                        Object(__WEBPACK_IMPORTED_MODULE_4_helpers__["c" /* showNotification */])('Request failed', 'error');
                    });
                });
            } else if (value.length > 7) {
                return this.setState({
                    imoNumber: value.replace(value.substring(value.length - 1), ""),
                    hasError: ''
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                imoNumber = _state.imoNumber,
                hasError = _state.hasError,
                disabled = _state.disabled,
                confirmed = _state.confirmed;
            var _props = this.props,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                name: 'imoNumber',
                type: 'number',
                floatingLabelText: 'IMO NO',
                value: imoNumber || '',
                errorText: hasError,
                disabled: disabled || confirmed,
                onChange: this.changeAndCheckImoNumber,
                fullWidth: true,

                underlineStyle: modifiedFields && modifiedFields.includes('imoNumber') ? underStyle : null
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ImoNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ImoNumber;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ImoNumber, 'ImoNumber', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/ImoNumber.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/ImoNumber.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var years = [];

for (var i = new Date(1960, 1, 1).getFullYear(); i <= new Date().getFullYear(); i++) {
    years.push(i);
}

var Blt = function (_React$Component) {
    _inherits(Blt, _React$Component);

    function Blt() {
        _classCallCheck(this, Blt);

        return _possibleConstructorReturn(this, (Blt.__proto__ || Object.getPrototypeOf(Blt)).apply(this, arguments));
    }

    _createClass(Blt, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                blt = _props.blt,
                confirmed = _props.confirmed,
                getError = _props.getError,
                changeField = _props.changeField,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
                {
                    value: blt,
                    onChange: function onChange(e, i, value) {
                        changeField({
                            field: 'blt',
                            value: value
                        });
                    },
                    disabled: confirmed,
                    errorText: getError('blt'),
                    maxHeight: 200,
                    name: 'blt',
                    floatingLabelText: 'Year',
                    fullWidth: true,

                    underlineStyle: modifiedFields && modifiedFields.includes('blt') ? underStyle : null
                },
                years.map(function (year, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                        key: index,
                        value: year,
                        primaryText: year
                    });
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Blt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Blt;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(years, 'years', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Blt.jsx');
    reactHotLoader.register(Blt, 'Blt', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Blt.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Blt.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var BuilderYard = function (_React$Component) {
    _inherits(BuilderYard, _React$Component);

    function BuilderYard(props) {
        _classCallCheck(this, BuilderYard);

        var _this = _possibleConstructorReturn(this, (BuilderYard.__proto__ || Object.getPrototypeOf(BuilderYard)).call(this, props));

        _this.state = {
            yards: []
        };

        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(BuilderYard, [{
        key: 'changeAutoComplete',
        value: function changeAutoComplete(searchText) {
            var _this2 = this;

            this.props.changeField({
                field: 'builderV2.yard.name',
                value: searchText
            });

            this.setState({
                yards: []
            }, function () {
                if (searchText) {
                    __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].findYards(searchText).then(function (response) {
                        if (response.status === 200) {
                            var yards = response.data.data.map(function (yard) {
                                return {
                                    name: yard.name,
                                    yard: yard
                                };
                            });

                            if (!yards.length) {
                                _this2.setState({
                                    yards: []
                                });

                                _this2.props.changeField({
                                    field: 'builderV2.yard._id',
                                    value: ''
                                });
                            } else {
                                _this2.setState({
                                    yards: yards
                                });
                            }
                        }
                    }).catch(function (error) {
                        console.error('Error AutoComplete Yards - Builder component', error);
                        return null;
                    });
                } else {
                    _this2.props.changeField({
                        field: 'builderV2.yard._id',
                        value: ''
                    });
                }
            });
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            this.setState({
                name: '',
                yards: []
            });

            this.props.changeField({
                field: 'builderV2.yard',
                value: updateProperties.yard
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var yards = this.state.yards;
            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                yard = _props.yard,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                name: 'yard',
                disabled: confirmed,
                floatingLabelText: 'Yard',
                searchText: yard && yard.name || '',
                dataSource: yards,
                dataSourceConfig: { text: 'name', value: 'yard' },
                onUpdateInput: this.changeAutoComplete,
                onNewRequest: this.chooseAutoComplete,
                filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                errorText: getError('yard'),
                listStyle: { overflow: 'auto', maxHeight: '300px' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true,

                underlineStyle: modifiedFields && modifiedFields.includes('builderV2.yard.name') ? underStyle : null
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return BuilderYard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = BuilderYard;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BuilderYard, 'BuilderYard', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/BuilderYard.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/BuilderYard.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var BuilderCountry = function (_React$Component) {
    _inherits(BuilderCountry, _React$Component);

    function BuilderCountry(props) {
        _classCallCheck(this, BuilderCountry);

        var _this = _possibleConstructorReturn(this, (BuilderCountry.__proto__ || Object.getPrototypeOf(BuilderCountry)).call(this, props));

        _this.changeSelect = _this.changeSelect.bind(_this);
        return _this;
    }

    _createClass(BuilderCountry, [{
        key: 'changeSelect',
        value: function changeSelect(e, i, value) {
            this.props.changeAutoComplete('builderV2.country', this.props.countries.find(function (country) {
                return country._id === value;
            }));
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getCountries();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                getError = _props.getError,
                countries = _props.countries,
                confirmed = _props.confirmed,
                country = _props.country,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                {
                    value: typeof country === 'string' ? country : country._id,
                    onChange: this.changeSelect,
                    errorText: getError('country'),
                    maxHeight: 200,
                    name: 'builderCountry',
                    disabled: confirmed,
                    floatingLabelText: 'Country',
                    fullWidth: true,

                    underlineStyle: modifiedFields && modifiedFields.includes('builderV2.country') ? underStyle : null
                },
                countries.map(function (country, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                        key: index,
                        value: country._id,
                        primaryText: country.name
                    });
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return BuilderCountry;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var items = _ref.countries.items;

    return {
        countries: items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCountries: __WEBPACK_IMPORTED_MODULE_3_actions_countries__["a" /* getCountries */]
    }, dispatch);
})(BuilderCountry);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BuilderCountry, 'BuilderCountry', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/BuilderCountry.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/BuilderCountry.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PortOfRegistry = function (_React$PureComponent) {
    _inherits(PortOfRegistry, _React$PureComponent);

    function PortOfRegistry(props) {
        _classCallCheck(this, PortOfRegistry);

        var _this = _possibleConstructorReturn(this, (PortOfRegistry.__proto__ || Object.getPrototypeOf(PortOfRegistry)).call(this, props));

        _this.state = {
            ports: [],
            homePortObject: props.homePortObject
        };

        _this.changeAutoCompete = _this.changeAutoCompete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(PortOfRegistry, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                homePortObject: nextProps.homePortObject
            });
        }
    }, {
        key: 'changeAutoCompete',
        value: function changeAutoCompete(searchText) {
            var _this2 = this;

            this.props.changeAutoComplete('homePort', { name: searchText, _id: '' });
            this.setState({
                homePortObject: {
                    name: searchText,
                    _id: ''
                }
            }, function () {
                var name = _this2.state.homePortObject.name;


                if (name.length < 2) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].findPortAdmin({ name: name }).then(function (response) {
                    if (response.status === 200) {
                        var ports = response.data.data.map(function (port) {
                            return {
                                name: port.country ? port.name + ', ' + port.country.name : port.name,
                                port: port
                            };
                        });

                        _this2.setState({
                            ports: ports
                        });
                    }
                }).catch(function (error) {
                    console.error('Error AutoComplete ports - port of registry', error);

                    return null;
                });
            });
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            var _this3 = this;

            this.setState({
                homePortObject: updateProperties.port
            }, function () {
                _this3.props.changeAutoComplete('homePort', updateProperties.port);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                ports = _state.ports,
                homePortObject = _state.homePortObject;
            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                name: 'homeport',
                disabled: confirmed,
                floatingLabelText: 'Port of registry',
                searchText: homePortObject.name,
                dataSource: ports,
                dataSourceConfig: { text: 'name', value: 'port' },
                onUpdateInput: this.changeAutoCompete,
                onNewRequest: this.chooseAutoComplete,
                filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                errorText: getError('homePort'),
                listStyle: { overflow: 'auto', maxHeight: '300px' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true,

                underlineStyle: modifiedFields && modifiedFields.includes('homePort') ? underStyle : null
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PortOfRegistry;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = PortOfRegistry;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortOfRegistry, 'PortOfRegistry', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/PortOfRegistry.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/PortOfRegistry.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterClass__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








/**
 * @param {{
 *   confirmed: boolean,
 *   registerClasses: object[],
 *   changeField: Function,
 *   getError: Function,
 *   clearError: Function,
 *   modifiedFields?: string[],
 *   underStyle?: import('react').CSSProperties,
 * }} props
 */
function RegisterClasses(_ref) {
    var confirmed = _ref.confirmed,
        registerClasses = _ref.registerClasses,
        modifiedFields = _ref.modifiedFields,
        underStyle = _ref.underStyle,
        changeField = _ref.changeField,
        getError = _ref.getError,
        clearError = _ref.clearError;

    var handleAdd = function handleAdd() {
        changeField({
            field: 'registerClasses',
            value: [].concat(_toConsumableArray(registerClasses), [{ _id: '', name: '' }])
        });
    };
    var handleRemove = function handleRemove(index) {
        var value = registerClasses.slice();
        value.splice(index, 1);
        changeField({
            field: 'registerClasses',
            value: value
        });
    };
    var handleChange = function handleChange(index, changes) {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }
        changeField(changes.map(function (_ref2) {
            var field = _ref2.field,
                value = _ref2.value;
            return {
                field: field === 'registerClass' ? 'registerClasses.' + index : 'registerClasses.' + index + '.' + field.replace('registerClass.', ''),
                value: value
            };
        }));
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        registerClasses.map(function (registerClass, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: registerClass._id + '-' + index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RegisterClass__["a" /* default */], {
                        registerClass: registerClass,
                        changeField: function changeField(change) {
                            return handleChange(index, change);
                        },
                        confirmed: !confirmed,
                        getError: index === 0 ? function () {
                            return getError('registerClasses');
                        } : function () {
                            return '';
                        },
                        underStyle: modifiedFields && modifiedFields.includes('registerClasses.' + index + '.name') ? underStyle : null,
                        clearError: clearError
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    index === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["h" /* IconButton */],
                        {
                            onClick: handleAdd,
                            style: { margin: '28px 0 0 8px' }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                    ),
                    index !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["h" /* IconButton */],
                        {
                            onClick: function onClick() {
                                return handleRemove(index);
                            },
                            style: { margin: '28px 0 0 8px' }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                    )
                )
            );
        })
    );
}

var _default = RegisterClasses;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RegisterClasses, 'RegisterClasses', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClasses.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClasses.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var RegisterClass = function (_React$Component) {
    _inherits(RegisterClass, _React$Component);

    function RegisterClass(props) {
        _classCallCheck(this, RegisterClass);

        var _this = _possibleConstructorReturn(this, (RegisterClass.__proto__ || Object.getPrototypeOf(RegisterClass)).call(this, props));

        _this.state = {
            classes: []
        };

        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(RegisterClass, [{
        key: 'changeAutoComplete',
        value: function changeAutoComplete(searchText) {
            var _this2 = this;

            this.props.changeField([{
                field: 'registerClass.name',
                value: searchText
            }, {
                field: 'registerClass._id',
                value: ''
            }, {
                field: 'registerClass.iacsRegister',
                value: false
            }]);

            this.setState({
                classes: []
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this2.props.registerClass._id && searchText) {
                                    _this2.props.changeField([{
                                        field: 'errors',
                                        value: {
                                            field: 'registerClass',
                                            messages: ['Please select register class from dropdown']
                                        },
                                        type: 'array'
                                    }]);
                                }

                                if (!searchText) {
                                    _context.next = 6;
                                    break;
                                }

                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].findClasses(searchText).then(function (response) {
                                    if (response.status === 200) {
                                        var regClasses = response.data.data.map(function (regClass) {
                                            return {
                                                name: regClass.name,
                                                regClass: regClass
                                            };
                                        });

                                        if (!regClasses.length) {
                                            _this2.setState({
                                                classes: []
                                            });

                                            _this2.props.changeField({
                                                field: 'registerClass._id',
                                                value: ''
                                            });
                                        } else {
                                            _this2.setState({
                                                classes: regClasses
                                            });
                                        }
                                    }
                                }).catch(function (error) {
                                    console.error('Error AutoComplete Register classes - RegisterClass component', error);
                                    return null;
                                });

                            case 4:
                                _context.next = 7;
                                break;

                            case 6:
                                _this2.props.clearError('registerClass');

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            })));
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            this.setState({
                classes: []
            });

            this.props.changeField([{
                field: 'registerClass',
                value: updateProperties.regClass
            }]);

            this.props.clearError('registerClass');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var classes = this.state.classes;
            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                underStyle = _props.underStyle,
                registerClass = _props.registerClass;


            var checked = !!registerClass.iacsRegister;
            var disabled = !!registerClass.name;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                    name: 'registerClass',
                    disabled: confirmed,
                    floatingLabelText: 'Register Class(Class)',
                    searchText: registerClass.name,
                    dataSource: classes,
                    dataSourceConfig: { text: 'name', value: 'registerClass' },
                    onUpdateInput: this.changeAutoComplete,
                    onNewRequest: this.chooseAutoComplete,
                    filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                    errorText: getError('registerClass'),
                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                    popoverProps: {
                        canAutoPosition: true
                    },
                    style: { width: '70%' },
                    fullWidth: true,

                    underlineStyle: underStyle
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["b" /* Checkbox */], {
                    style: { width: '30%', margin: '40px 0 0 20px' },
                    label: 'IACS',
                    checked: checked,
                    disabled: disabled,
                    onCheck: function onCheck() {
                        return _this3.props.changeField([{ field: 'registerClass.iacsRegister', value: !registerClass.iacsRegister }]);
                    }
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RegisterClass;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = RegisterClass;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RegisterClass, 'RegisterClass', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClass.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClass.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PIClub = function (_React$Component) {
    _inherits(PIClub, _React$Component);

    function PIClub(props) {
        _classCallCheck(this, PIClub);

        var _this = _possibleConstructorReturn(this, (PIClub.__proto__ || Object.getPrototypeOf(PIClub)).call(this, props));

        _this.state = {
            clubs: []
        };

        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(PIClub, [{
        key: 'changeAutoComplete',
        value: function changeAutoComplete(searchText) {
            var _this2 = this;

            this.props.changeField({
                field: 'piClubObject.name',
                value: searchText
            });

            this.props.changeField({
                field: 'piClubObject._id',
                value: ''
            });

            this.setState({
                clubs: []
            }, function () {
                if (searchText) {
                    __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].findPIClubs(searchText).then(function (response) {
                        if (response.status === 200) {
                            var piClubs = response.data.data.map(function (piClub) {
                                return {
                                    name: piClub.name,
                                    piClub: piClub
                                };
                            });

                            if (!piClubs.length) {
                                _this2.setState({
                                    clubs: []
                                });

                                _this2.props.changeField({
                                    field: 'piClubObject._id',
                                    value: ''
                                });
                            } else {
                                _this2.setState({
                                    clubs: piClubs
                                });
                            }
                        }
                    }).catch(function (error) {
                        console.error('Error AutoComplete PI clubs - PIClub component', error);
                        return null;
                    });
                } else {
                    _this2.props.clearError('piClubObject');
                }
            });
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            this.setState({
                clubs: []
            });

            this.props.changeField({
                field: 'piClubObject',
                value: updateProperties.piClub
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var clubs = this.state.clubs;
            var _props = this.props,
                piClubObject = _props.piClubObject,
                getError = _props.getError,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                name: 'piClubObject',
                disabled: confirmed,
                dataSource: clubs,
                dataSourceConfig: { text: 'name', value: 'piClub' },
                floatingLabelText: 'P&I Club',
                searchText: piClubObject.name,
                onUpdateInput: this.changeAutoComplete,
                onNewRequest: this.chooseAutoComplete,
                filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                errorText: getError('piClubObject'),
                listStyle: { overflow: 'auto', maxHeight: '300px' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true,

                underlineStyle: modifiedFields && modifiedFields.includes('piClubObject.name') ? underStyle : null
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PIClub;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = PIClub;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PIClub, 'PIClub', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/PIClub.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/PIClub.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Manager = function (_React$PureComponent) {
    _inherits(Manager, _React$PureComponent);

    function Manager(props) {
        _classCallCheck(this, Manager);

        var _this = _possibleConstructorReturn(this, (Manager.__proto__ || Object.getPrototypeOf(Manager)).call(this, props));

        _this.state = {
            companies: [],
            managerObject: props.managerObject
        };

        _this.changeAutoCompete = _this.changeAutoCompete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(Manager, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                managerObject: nextProps.managerObject
            });
        }
    }, {
        key: 'changeAutoCompete',
        value: function changeAutoCompete(searchText) {
            var _this2 = this;

            this.setState({
                managerObject: {
                    name: searchText,
                    _id: ''
                }
            }, function () {
                if (searchText) {
                    __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].findCompany(searchText).then(function (response) {
                        if (response.status === 200) {
                            var companies = response.data.data.map(function (company) {
                                return {
                                    name: company.name,
                                    company: company
                                };
                            });

                            _this2.setState({
                                companies: companies
                            });
                        }
                    }).catch(function (error) {
                        console.error('Error AutoComplete companies - manager component', error);
                        return null;
                    });
                }
            });
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            var _this3 = this;

            this.setState({
                managerObject: updateProperties.company
            }, function () {
                _this3.props.changeAutoComplete('manager', updateProperties.company);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                companies = _state.companies,
                managerObject = _state.managerObject;
            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                disabled: confirmed,
                name: 'manager',
                floatingLabelText: 'Manager',
                searchText: managerObject.name,
                dataSource: companies,
                dataSourceConfig: { text: 'name', value: 'company' },
                onUpdateInput: this.changeAutoCompete,
                onNewRequest: this.chooseAutoComplete,
                filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                errorText: getError('manager'),
                listStyle: { overflow: 'auto', maxHeight: '300px' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true,

                underlineStyle: modifiedFields && modifiedFields.includes('manager') ? underStyle : null
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Manager;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Manager, 'Manager', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Manager.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Manager.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPES_BY_CONSTRUCTION; });
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

var TYPES_BY_CONSTRUCTION = ['', 'SID', 'TWEEN'];
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TYPES_BY_CONSTRUCTION, 'TYPES_BY_CONSTRUCTION', '/opt/atlassian/pipelines/agent/build/client/app/constants/vessel.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TYPES_BY_SIZE = ['Baby-cape', 'Capesize', 'Handysize', 'Handymax', 'Kamsarmax', 'Newcastlemax', 'Panamax', 'Post-panamax', 'Supramax', 'Ultramax', 'Valemax', 'Vloc', 'Aframax', 'Amur', 'Large Modern Ecotype', 'Omskiy', 'Sibirskiy', 'Suezmax', 'Volgo Balt', 'Volgo Don', 'Sokol'];

var TypeBySize = function (_React$Component) {
    _inherits(TypeBySize, _React$Component);

    function TypeBySize() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TypeBySize);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeBySize.__proto__ || Object.getPrototypeOf(TypeBySize)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (value) {
            var changeField = _this.props.changeField;

            changeField([{ field: 'typeBySize', value: value }]);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TypeBySize, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                type = _props.type,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
                {
                    value: type,
                    disabled: !confirmed,
                    onChange: function onChange(e, index, value) {
                        return _this2.onChange(value);
                    },
                    maxHeight: 200,
                    name: 'typeBySize',
                    floatingLabelText: 'Type By Size',
                    errorText: getError && getError('typeBySize'),
                    fullWidth: true,
                    input: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { required: true }),
                    required: true,
                    underlineStyle: modifiedFields && modifiedFields.includes('typeBySize') ? underStyle : null,
                    autoWidth: true
                },
                [''].concat(TYPES_BY_SIZE).map(function (type, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                        key: i,
                        value: type,
                        primaryText: type
                    });
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TypeBySize;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TypeBySize;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TYPES_BY_SIZE, 'TYPES_BY_SIZE', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeBySize.jsx');
    reactHotLoader.register(TypeBySize, 'TypeBySize', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeBySize.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TypeBySize.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_info__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var styles = {
    selectorFitted: {
        fontSize: '13px'
    },
    infoIcon: {
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        margin: '-3px 0 0 0.5em',
        color: '#dadada',
        cursor: 'pointer'
    }
};

var TechEquipCertificate = function (_React$Component) {
    _inherits(TechEquipCertificate, _React$Component);

    function TechEquipCertificate() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TechEquipCertificate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TechEquipCertificate.__proto__ || Object.getPrototypeOf(TechEquipCertificate)).call.apply(_ref, [this].concat(args))), _this), _this.changeFields = function (fieldName, value) {
            var changeField = _this.props.changeField;

            var toChange = [{
                field: 'techEquipCertificate.' + fieldName,
                value: value
            }];

            switch (true) {
                case fieldName === __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].ventilationFitted && !value:
                    toChange.push({
                        field: 'techEquipCertificate.' + __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].ventilation,
                        value: ''
                    });
                    break;

                case fieldName === __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].imoFitted && !value:
                    toChange.push({
                        field: 'techEquipCertificate.imoApp',
                        value: ''
                    }, {
                        field: 'techEquipCertificate.imoClass',
                        value: ''
                    });
                    break;

                case fieldName === __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].referPlugFitted && !value:
                    toChange.push({
                        field: 'techEquipCertificate.referPlugsAmount',
                        value: 0
                    });
                    break;

                default:
                    break;
            }

            changeField(toChange);
        }, _this.addIgsRow = function () {
            var igs = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.techEquipCertificate.igs);
            igs.systems.push({
                type: '',
                capacity: '',
                percentage: ''
            });
            _this.props.changeField({ field: 'techEquipCertificate.igs', value: igs });
        }, _this.removeIgsRow = function (index) {
            var igs = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.techEquipCertificate.igs);
            igs.systems.splice(index, 1);
            _this.props.changeField({ field: 'techEquipCertificate.igs', value: igs });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TechEquipCertificate, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                confirmed = _props.confirmed,
                changeField = _props.changeField,
                getError = _props.getError,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle,
                toggleLabelStyle = _props.toggleLabelStyle;
            var changeFields = this.changeFields;
            var _props$techEquipCerti = this.props.techEquipCertificate,
                co2Fitted = _props$techEquipCerti.co2Fitted,
                a60BulkheadFitted = _props$techEquipCerti.a60BulkheadFitted,
                newPanama = _props$techEquipCerti.newPanama,
                cementHolesFitted = _props$techEquipCerti.cementHolesFitted,
                cementHolesCount = _props$techEquipCerti.cementHolesCount,
                cementHolesDia = _props$techEquipCerti.cementHolesDia,
                referPlugFitted = _props$techEquipCerti.referPlugFitted,
                itfFitted = _props$techEquipCerti.itfFitted,
                lakesFitted = _props$techEquipCerti.lakesFitted,
                strengthenHeavy = _props$techEquipCerti.strengthenHeavy,
                logsFitted = _props$techEquipCerti.logsFitted,
                aussieFitted = _props$techEquipCerti.aussieFitted,
                iceClass = _props$techEquipCerti.iceClass,
                ventilation = _props$techEquipCerti.ventilation,
                ventilationFitted = _props$techEquipCerti.ventilationFitted,
                imoApp = _props$techEquipCerti.imoApp,
                imoClass = _props$techEquipCerti.imoClass,
                imoFitted = _props$techEquipCerti.imoFitted,
                bwts = _props$techEquipCerti.bwts,
                coiled = _props$techEquipCerti.coiled,
                containerFitted = _props$techEquipCerti.containerFitted,
                carFitted = _props$techEquipCerti.carFitted,
                rampway = _props$techEquipCerti.rampway,
                lxb = _props$techEquipCerti.lxb,
                grainFitted = _props$techEquipCerti.grainFitted,
                grainHoles = _props$techEquipCerti.grainHoles,
                grainDia = _props$techEquipCerti.grainDia,
                cargoTankDryer = _props$techEquipCerti.cargoTankDryer,
                cargoCoolingSystem = _props$techEquipCerti.cargoCoolingSystem,
                crudeOilWashing = _props$techEquipCerti.crudeOilWashing,
                rcttms = _props$techEquipCerti.rcttms,
                rctpms = _props$techEquipCerti.rctpms,
                bowChainStopper = _props$techEquipCerti.bowChainStopper,
                chainSize = _props$techEquipCerti.chainSize,
                ngs = _props$techEquipCerti.ngs,
                ngsCapacity = _props$techEquipCerti.ngsCapacity,
                vrs = _props$techEquipCerti.vrs,
                vrsNumLines = _props$techEquipCerti.vrsNumLines,
                bowThruster = _props$techEquipCerti.bowThruster,
                bowThrusterNum = _props$techEquipCerti.bowThrusterNum,
                bowThrusterBhp = _props$techEquipCerti.bowThrusterBhp,
                bowThrusterKw = _props$techEquipCerti.bowThrusterKw,
                stemThruster = _props$techEquipCerti.stemThruster,
                stemThrusterNum = _props$techEquipCerti.stemThrusterNum,
                stemThrusterBhp = _props$techEquipCerti.stemThrusterBhp,
                stemThrusterKw = _props$techEquipCerti.stemThrusterKw,
                scrubberFitted = _props$techEquipCerti.scrubberFitted,
                referPlugsAmount = _props$techEquipCerti.referPlugsAmount,
                igs = _props$techEquipCerti.igs;


            var igsSystems = igs && igs.systems || [];
            if (!igsSystems.length) {
                igsSystems.push({
                    type: '',
                    capacity: '',
                    percentage: ''
                });
            }

            function renderSelectFitted(fieldName, fieldValue, label) {
                var hint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                if (hint) {
                    label = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
                        null,
                        label,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { 'data-tip': hint, style: { pointerEvents: 'all' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_info___default.a, { style: styles.infoIcon })
                        )
                    );
                }
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                    {
                        value: fieldValue,
                        onChange: function onChange(e, i, value) {
                            return changeFields(fieldName, value);
                        },
                        disabled: confirmed,
                        name: fieldName,
                        floatingLabelText: label,
                        floatingLabelStyle: { fontSize: '13px' },
                        labelStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.' + fieldName) ? toggleLabelStyle : null,
                        underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.' + fieldName) ? underStyle : null,
                        autoWidth: true,
                        fullWidth: true
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { value: null, primaryText: undefined }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { value: true, primaryText: 'Yes' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { value: false, primaryText: 'No' })
                );
            }

            function renderNumberField(field, value, label) {
                var disabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var floatingNumber = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'techEquipCertificate.' + field,
                    floatingLabelText: label,
                    floatingLabelStyle: { fontSize: '13px' },
                    value: value || '',
                    style: styles.selectorFitted,
                    fullWidth: true,
                    floatNumber: floatingNumber,
                    disabled: disabled,
                    errorText: getError('techEquipCertificate.' + field),
                    onChange: function onChange(e, value) {
                        changeField([{
                            field: 'techEquipCertificate.' + field,
                            value: value,
                            type: 'number'
                        }]);
                    },

                    underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.' + field) ? underStyle : null
                });
            }

            function renderTextField(field, value, label) {
                var disabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                    name: 'techEquipCertificate.' + field,
                    floatingLabelText: label,
                    floatingLabelStyle: { fontSize: '13px' },
                    value: value || '',
                    style: styles.selectorFitted,
                    fullWidth: true,
                    disabled: disabled,
                    errorText: getError('techEquipCertificate.' + field),
                    onChange: function onChange(e, value) {
                        changeField([{
                            field: 'techEquipCertificate.' + field,
                            value: value,
                            type: 'number'
                        }]);
                    },

                    underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.' + field) ? underStyle : null
                });
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12', style: { margin: '0px 0px 20px 0px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { className: 'name-block static huge-name' },
                            'TECHNICAL EQUIPMENT / CERTIFICATE'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].co2Fitted, co2Fitted, 'CO2Fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].a60BulkheadFitted, a60BulkheadFitted, 'A60 bulkhead fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].newPanama, newPanama, 'New Panama')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].itfFitted, itfFitted, 'Itf fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].lakesFitted, lakesFitted, 'Lakes fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].logsFitted, logsFitted, 'Logs fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].strengthenHeavy, strengthenHeavy, 'Strengthened heavy')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].aussieFitted, aussieFitted, 'Aussie fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].scrubberFitted, scrubberFitted, 'Scrubber fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].ventilationFitted, ventilationFitted, 'Ventilation fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                            {
                                value: ventilation,
                                onChange: function onChange(e, i, value) {
                                    changeField([{
                                        field: 'techEquipCertificate.ventilation',
                                        value: value
                                    }]);
                                },
                                style: styles.selectorFitted,
                                disabled: !ventilationFitted,
                                errorText: getError('techEquipCertificate.ventilation'),
                                maxHeight: 200,
                                name: 'ventilation',
                                floatingLabelText: 'Ventilation',
                                fullWidth: true,
                                autoWidth: true,
                                underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.ventilation') ? underStyle : null
                            },
                            __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["h" /* ventilationNames */].map(function (ventilationName, index) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                    key: ventilationName + '_' + index,
                                    value: ventilationName,
                                    primaryText: ventilationName
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                            {
                                value: iceClass,
                                onChange: function onChange(e, i, value) {
                                    changeField([{
                                        field: 'techEquipCertificate.iceClass',
                                        value: value
                                    }]);
                                },
                                style: styles.selectorFitted,
                                disabled: confirmed,
                                errorText: getError('techEquipCertificate.iceClass'),
                                maxHeight: 200,
                                name: 'iceClass',
                                floatingLabelText: 'Ice Class',
                                fullWidth: true,
                                autoWidth: true,
                                underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.iceClass') ? underStyle : null
                            },
                            __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["e" /* iceClassNames */].map(function (iceClassName, index) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                    key: iceClassName + '_' + index,
                                    value: iceClassName || '',
                                    primaryText: iceClassName
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].imoFitted, imoFitted, 'Imo fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                            {
                                value: imoClass,
                                onChange: function onChange(e, i, value) {
                                    changeField([{
                                        field: 'techEquipCertificate.imoClass',
                                        value: value
                                    }]);
                                },
                                style: styles.selectorFitted,
                                disabled: !imoFitted,
                                errorText: getError('techEquipCertificate.imoClass'),
                                maxHeight: 200,
                                name: 'imoClass',
                                floatingLabelText: 'Imo class',
                                fullWidth: true,
                                autoWidth: true,
                                underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.imoClass') ? underStyle : null
                            },
                            __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["g" /* imoClassNames */].map(function (imoClassName, index) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                    key: imoClassName + '_' + index,
                                    value: imoClassName,
                                    primaryText: imoClassName
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                            {
                                value: imoApp,
                                onChange: function onChange(e, i, value) {
                                    changeField([{
                                        field: 'techEquipCertificate.imoApp',
                                        value: value
                                    }]);
                                },
                                style: styles.selectorFitted,
                                errorText: getError('techEquipCertificate.imoApp'),
                                maxHeight: 200,
                                name: 'imoApp',
                                floatingLabelText: 'Appendix',
                                fullWidth: true,
                                autoWidth: true,
                                underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.imoApp') ? underStyle : null
                            },
                            __WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["f" /* imoAppNames */].map(function (imoAppName, index) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                    key: imoAppName + '_' + index,
                                    value: imoAppName,
                                    primaryText: imoAppName
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].referPlugFitted, referPlugFitted, 'Refer plug fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                            name: 'techEquipCertificate.referPlugsAmount',
                            floatingLabelText: 'Reefer plugs amount',
                            value: referPlugsAmount || '',
                            style: styles.selectorFitted,
                            fullWidth: true,
                            disabled: !referPlugFitted,
                            errorText: getError('techEquipCertificate.referPlugsAmount'),
                            onChange: function onChange(e, value) {
                                changeField([{
                                    field: 'techEquipCertificate.referPlugsAmount',
                                    value: value,
                                    type: 'number'
                                }]);
                            },

                            underlineStyle: modifiedFields && modifiedFields.includes('techEquipCertificate.referPlugsAmount') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].bwts, bwts, 'BWTS', 'Ballast water treatment system')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].coiled, coiled, 'Coiled')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].containerFitted, containerFitted, 'Container fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].carFitted, carFitted, 'Car fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].rampway, rampway, 'Rampway')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderTextField('lxb', lxb, 'lxb, m', !rampway)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].grainFitted, grainFitted, 'Grain fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('grainHoles', grainHoles, 'Num of holes', !grainFitted)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('grainDia', grainDia, 'Dia, mm', !grainFitted, true)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].cementHolesFitted, cementHolesFitted, 'Cement holes fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('cementHolesCount', cementHolesCount, 'Num of holes', !cementHolesFitted)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('cementHolesDia', cementHolesDia, 'Dia, mm', !cementHolesFitted, true)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].cargoTankDryer, cargoTankDryer, 'Cargo tank dryer')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].cargoCoolingSystem, cargoCoolingSystem, 'Cargo cooling system')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].crudeOilWashing, crudeOilWashing, 'Crude oil washing')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].rcttms, rcttms, 'RCTTMS', 'Remote cargo tank temperature monitoring system')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].rctpms, rctpms, 'RCTPMS', 'Remote cargo tank pressure monitoring system')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].bowChainStopper, bowChainStopper, 'Bow chain stopper')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('chainSize', chainSize, 'Chain size, mm', !bowChainStopper, true)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].ngs, ngs, 'NGS')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('ngsCapacity', ngsCapacity, 'Capacity, cbm/hr (95%)', !ngs, true)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].vrs, vrs, 'VRS')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('vrsNumLines', vrsNumLines, 'Num of independent lines', !vrs)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].bowThruster, bowThruster, 'Bow thruster')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('bowThrusterNum', bowThrusterNum, 'Num, pc', !bowThruster)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('bowThrusterBhp', bowThrusterBhp, 'BHP', !bowThruster, true)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('bowThrusterKw', bowThrusterKw, 'kW', !bowThruster, true)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].stemThruster, stemThruster, 'Stem thruster')
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('stemThrusterNum', stemThrusterNum, 'Num, pc', !stemThruster)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('stemThrusterBhp', stemThrusterBhp, 'BHP', !stemThruster, true)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        renderNumberField('stemThrusterKw', stemThrusterKw, 'kW', !stemThruster, true)
                    )
                ),
                igsSystems.map(function (system, index) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'row', key: 'isgSystems_' + index },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            index === 0 && renderSelectFitted(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["d" /* fitted */].igsFitted, igs && igs.fitted, 'IGS')
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                                {
                                    value: system.type || '',
                                    onChange: function onChange(e, i, value) {
                                        changeField([{
                                            field: 'techEquipCertificate.igs.systems[' + index + '].type',
                                            value: value
                                        }]);
                                    },
                                    disabled: !(igs && igs.fitted),
                                    errorText: getError && getError('igs.systems[' + index + '].type'),
                                    maxHeight: 200,
                                    name: 'type',
                                    floatingLabelText: 'IGS type',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    fullWidth: true,
                                    autoWidth: true,
                                    underlineStyle: modifiedFields && modifiedFields.includes('igs.systems[' + index + '].type') ? underStyle : null
                                },
                                [''].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9_constants_vesselRequirements__["b" /* IGS_TYPES */])).map(function (type) {
                                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                        key: type,
                                        value: type,
                                        primaryText: type
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            renderNumberField('igs.systems[' + index + '].capacity', system.capacity, 'Capacity, cbm/hr', !(igs && igs.fitted), true)
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2' },
                            renderNumberField('igs.systems[' + index + '].percentage', system.percentage, '%', !(igs && igs.fitted), true)
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { style: { margin: '25px 0 0 0' } },
                                index === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: !(igs && igs.fitted),
                                        onClick: _this2.addIgsRow
                                    },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                                ),
                                index !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: !(igs && igs.fitted),
                                        onClick: function onClick() {
                                            _this2.removeIgsRow(index);
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                                )
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TechEquipCertificate;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = TechEquipCertificate;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TechEquipCertificate.jsx');
    reactHotLoader.register(TechEquipCertificate, 'TechEquipCertificate', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TechEquipCertificate.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TechEquipCertificate.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withExclusions_js__ = __webpack_require__(369);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var type = 'cargoExclusionsV2';

var style = {
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    }
};

var CargoExclusionsV2 = function (_React$Component) {
    _inherits(CargoExclusionsV2, _React$Component);

    function CargoExclusionsV2() {
        _classCallCheck(this, CargoExclusionsV2);

        return _possibleConstructorReturn(this, (CargoExclusionsV2.__proto__ || Object.getPrototypeOf(CargoExclusionsV2)).apply(this, arguments));
    }

    _createClass(CargoExclusionsV2, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                cargoExclusionV2List = _props.cargoExclusionV2List,
                cargoExclusionsV2 = _props.cargoExclusionsV2,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle,
                renderExcl = _props.renderExcl,
                choose = _props.choose,
                change = _props.change,
                dataSource = _props.dataSource,
                currentExcl = _props.currentExcl;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: style.wrapper },
                    renderExcl(type)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a, {
                    name: 'cargoExclusionV2',
                    disabled: confirmed,
                    dataSource: dataSource,
                    dataSourceConfig: { text: 'name', value: 'cargoExclusionV2' },
                    floatingLabelText: 'Cargo Exclussions',
                    searchText: currentExcl.name || '',
                    onUpdateInput: change,
                    onNewRequest: function onNewRequest(excl) {
                        return choose(type, excl);
                    },
                    filter: __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a.noFilter,
                    errorText: getError('cargoExclusionV2'),
                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                    popoverProps: {
                        canAutoPosition: true
                    },
                    fullWidth: true,

                    underlineStyle: modifiedFields && modifiedFields.includes('cargoExclusionsV2') ? underStyle : null
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoExclusionsV2;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_4__withExclusions_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getCargoNamesAutocomplete, CargoExclusionsV2);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(type, 'type', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CargoExclussionsV2.jsx');
    reactHotLoader.register(style, 'style', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CargoExclussionsV2.jsx');
    reactHotLoader.register(CargoExclusionsV2, 'CargoExclusionsV2', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CargoExclussionsV2.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CargoExclussionsV2.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Tonnage = function (_React$Component) {
    _inherits(Tonnage, _React$Component);

    function Tonnage() {
        _classCallCheck(this, Tonnage);

        return _possibleConstructorReturn(this, (Tonnage.__proto__ || Object.getPrototypeOf(Tonnage)).apply(this, arguments));
    }

    _createClass(Tonnage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                confirmed = _props.confirmed,
                getError = _props.getError,
                changeField = _props.changeField,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;
            var _props$rt = this.props.rt,
                gt = _props$rt.gt,
                nt = _props$rt.nt,
                panamaGt = _props$rt.panamaGt,
                panamaNt = _props$rt.panamaNt,
                suezGt = _props$rt.suezGt,
                suezNt = _props$rt.suezNt;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                            name: 'GT',
                            floatingLabelText: 'GT',
                            value: gt || '',
                            floatNumber: true,
                            disabled: confirmed,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'rt.gt',
                                    value: value
                                });
                            },
                            errorText: getError('GT'),
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('rt.gt') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                            name: 'NT',
                            floatingLabelText: 'NT',
                            value: nt || '',
                            floatNumber: true,
                            disabled: confirmed,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'rt.nt',
                                    value: value
                                });
                            },
                            errorText: getError('NT'),
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('rt.nt') ? underStyle : null
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                            name: 'suezGT',
                            floatingLabelText: 'Suez GT',
                            value: suezGt || '',
                            floatNumber: true,
                            disabled: confirmed,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'rt.suezGt',
                                    value: value
                                });
                            },
                            errorText: getError('suezGT'),
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('rt.suezGt') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                            name: 'suezNT',
                            floatingLabelText: 'Suez NT',
                            value: suezNt || '',
                            floatNumber: true,
                            disabled: confirmed,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'rt.suezNt',
                                    value: value
                                });
                            },
                            errorText: getError('suezNT'),
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('rt.suezNt') ? underStyle : null
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                            name: 'panamaGT',
                            floatingLabelText: 'Panama GT',
                            value: panamaGt || '',
                            floatNumber: true,
                            disabled: confirmed,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'rt.panamaGt',
                                    value: value
                                });
                            },
                            errorText: getError('panamaGT'),
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('rt.panamaGt') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                            name: 'panamaNT',
                            floatingLabelText: 'Panama NT',
                            value: panamaNt || '',
                            floatNumber: true,
                            disabled: confirmed,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'rt.panamaNt',
                                    value: value
                                });
                            },
                            errorText: getError('panamaNT'),
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('rt.panamaNt') ? underStyle : null
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Tonnage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Tonnage;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Tonnage, 'Tonnage', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Tonnage.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Tonnage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Base_NumberField__ = __webpack_require__(63);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var COLUMNS = ['Loaded', 'DWT', 'DWCC', 'Draft', 'Tpc', 'Tpi', 'FreeBoard'];

var PREFIXES = {
    s: 'Summer',
    t: 'Tropical',
    w: 'Winter',
    f: 'Fresh',
    tf: 'Tropical Fresh',
    p: 'Panama',
    ti: 'Timber',
    l: 'Lakes',
    ls: 'Lightship',
    n: 'Nrml Blst Cond'
};

/** @type {Record<string, React.CSSProperties>} */
var styles = {
    underlineStyle: {
        borderColor: __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__["orange500"]
    },
    headerCol: {
        whiteSpace: 'normal',
        padding: '0 5px',
        wordBreak: 'break-word',
        hyphens: 'auto'
    },
    col: {
        padding: '0 5px'
    }
};

var Deadweight = function (_React$Component) {
    _inherits(Deadweight, _React$Component);

    function Deadweight() {
        _classCallCheck(this, Deadweight);

        return _possibleConstructorReturn(this, (Deadweight.__proto__ || Object.getPrototypeOf(Deadweight)).apply(this, arguments));
    }

    _createClass(Deadweight, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                confirmed = _props.confirmed,
                changeField = _props.changeField,
                getError = _props.getError,
                deadWeight = _props.deadWeight,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            var textField = function textField(item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                    { key: '' + item + index, style: styles.col },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Base_NumberField__["a" /* default */], {
                        name: item,
                        floatNumber: true,
                        value: deadWeight[item] || '',
                        disabled: confirmed,
                        errorText: getError('deadWeight.' + item),
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'deadWeight.' + item,
                                value: value
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('deadWeight.' + item) ? underStyle : null,
                        style: { maxWidth: '50px' }
                    })
                );
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["Table"],
                    { selectable: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeader"],
                        { adjustForCheckbox: false, displaySelectAll: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"], { style: { width: '120px' } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: styles.headerCol },
                                'Loaded displacement'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: styles.headerCol },
                                'DWT, mt'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: styles.headerCol },
                                'DWCC'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: styles.headerCol },
                                'Draft, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: styles.headerCol },
                                'Tpc'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: styles.headerCol },
                                'Tpi'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: styles.headerCol },
                                'Free-board, m'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableBody"],
                        { displayRowCheckbox: false },
                        Object.entries(PREFIXES).map(function (_ref) {
                            var _ref2 = _slicedToArray(_ref, 2),
                                prefix = _ref2[0],
                                caption = _ref2[1];

                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                { key: prefix },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { width: '120px', paddingRight: '0' } },
                                    caption
                                ),
                                COLUMNS.map(function (column, index) {
                                    return textField(prefix + column, index);
                                })
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Deadweight;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Deadweight;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(COLUMNS, 'COLUMNS', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Deadweight.jsx');
    reactHotLoader.register(PREFIXES, 'PREFIXES', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Deadweight.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Deadweight.jsx');
    reactHotLoader.register(Deadweight, 'Deadweight', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Deadweight.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Deadweight.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/** @type {Record<string, import('react').CSSProperties>} */
var styles = {
    headerCol: {
        borderLeft: '1px solid #DFDFDF',
        borderRight: '1px solid #DFDFDF',
        paddingLeft: '0',
        paddingRight: '0',
        textAlign: 'center'
    },
    actionsCol: {
        paddingLeft: '0',
        paddingRight: '0',
        textAlign: 'center'
    },
    topCol: {
        borderBottom: '0',
        paddingLeft: '7px',
        paddingRight: '7px'
    },
    bottomCol: {
        borderTop: '0',
        paddingLeft: '7px',
        paddingRight: '7px'
    },
    topRow: {
        borderBottom: '0'
    },
    bottomRow: {
        borderTop: '0'
    }
};

var CapacityV2 = function (_React$Component) {
    _inherits(CapacityV2, _React$Component);

    function CapacityV2(props) {
        _classCallCheck(this, CapacityV2);

        var _this = _possibleConstructorReturn(this, (CapacityV2.__proto__ || Object.getPrototypeOf(CapacityV2)).call(this, props));

        _this.add = _this.add.bind(_this);
        _this.remove = _this.remove.bind(_this);
        return _this;
    }

    _createClass(CapacityV2, [{
        key: 'add',
        value: function add() {
            var summary = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.capacityV2.summary);

            summary.push({
                hold: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined
                },
                tweenDeck: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined
                }
            });

            this.props.changeField({ field: 'capacityV2.summary', value: summary });
        }
    }, {
        key: 'remove',
        value: function remove(index) {
            var summary = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.capacityV2.summary);
            summary.splice(index, 1);
            this.props.changeField({ field: 'capacityV2.summary', value: summary });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$capacityV = this.props.capacityV2,
                grain = _props$capacityV.grain,
                bale = _props$capacityV.bale,
                teu = _props$capacityV.teu,
                feu = _props$capacityV.feu,
                summary = _props$capacityV.summary,
                constant = _props$capacityV.constant;
            var _props = this.props,
                getError = _props.getError,
                changeField = _props.changeField,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            var tableItem = function tableItem(stateName1, stateName2, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                    name: 'summary[' + index + '].' + stateName1 + '.' + stateName2,
                    value: summary[index][stateName1] ? summary[index][stateName1][stateName2] || '' : '',
                    floatNumber: true,
                    disabled: confirmed,
                    errorText: getError('capacityV2[summary][' + index + '][' + stateName1 + '].' + stateName2),
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityV2.summary[' + index + '][' + stateName1 + '].' + stateName2,
                            value: value
                        });
                        if (stateName1 === 'hold' || stateName1 === 'tweenDeck') {
                            var opposite = stateName1 === 'hold' ? 'tweenDeck' : 'hold';
                            if (summary[index][opposite] && summary[index][opposite][stateName2]) {
                                changeField({
                                    field: 'capacityV2.summary[' + index + '][compartment].' + stateName2,
                                    value: parseInt(value, 10) + parseInt(summary[index][opposite][stateName2], 10) || ''
                                });
                            }
                        }
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityV2[summary][' + index + '][' + stateName1 + '].' + stateName2) ? underStyle : null
                });
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                            name: 'capacityV2.grain',
                            floatingLabelText: 'Grain, m3',
                            value: grain || '',
                            disabled: confirmed,
                            errorText: getError('capacityV2.grain'),
                            fullWidth: true,
                            floatNumber: true,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'capacityV2.grain',
                                    value: value,
                                    type: 'number'
                                });
                            },
                            underlineStyle: modifiedFields && modifiedFields.includes('capacityV2.grain') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                            disabled: confirmed,
                            name: 'capacityV2.bale',
                            floatingLabelText: 'Bale, m3',
                            value: bale || '',
                            errorText: getError('capacityV2.bale'),
                            fullWidth: true,
                            floatNumber: true,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'capacityV2.bale',
                                    value: value,
                                    type: 'number'
                                });
                            },
                            underlineStyle: modifiedFields && modifiedFields.includes('capacityV2.bale') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                            disabled: confirmed,
                            name: 'capacityV2.teu',
                            floatingLabelText: 'TEU',
                            value: teu || '',
                            errorText: getError('capacityV2.teu'),
                            fullWidth: true,
                            floatNumber: true,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'capacityV2.teu',
                                    value: value,
                                    type: 'number'
                                });
                            },
                            underlineStyle: modifiedFields && modifiedFields.includes('capacityV2.teu') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                            disabled: confirmed,
                            name: 'capacityV2.feu',
                            floatingLabelText: 'FEU',
                            value: feu || '',
                            fullWidth: true,
                            floatNumber: true,
                            errorText: getError('capacityV2.feu'),
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'capacityV2.feu',
                                    value: value,
                                    type: 'number'
                                });
                            },
                            underlineStyle: modifiedFields && modifiedFields.includes('capacityV2.feu') ? underStyle : null
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["Table"],
                            {
                                selectable: false,
                                style: { border: '1px solid #DFDFDF' }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeader"],
                                {
                                    adjustForCheckbox: false,
                                    displaySelectAll: false
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: { textAlign: 'center' } },
                                        'Hold'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: { textAlign: 'center' } },
                                        'Tweendeck'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: { textAlign: 'center' } },
                                        'Compartment',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        '(Hold + Tween)'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableBody"],
                                { displayRowCheckbox: false },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"], { style: { width: '80px' }, rowSpan: 2 }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'grain, m3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'bale, m3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'grain, m3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'bale, m3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'grain, m3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'bale, m3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"], { style: { width: '80px' }, rowSpan: 2 })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'TEU'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'FEU'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'TEU'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'FEU'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'TEU'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.headerCol },
                                        'FEU'
                                    )
                                ),
                                summary && summary.map(function (item, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        { key: 'capacitySummary_' + index },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                            { key: '1-' + index, style: styles.topRow },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { rowSpan: 2 },
                                                index + 1
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.topCol },
                                                tableItem('hold', 'grain', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.topCol },
                                                tableItem('hold', 'bale', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.topCol },
                                                tableItem('tweenDeck', 'grain', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.topCol },
                                                tableItem('tweenDeck', 'bale', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.topCol },
                                                tableItem('compartment', 'grain', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.topCol },
                                                tableItem('compartment', 'bale', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { rowSpan: 2, style: styles.actionsCol },
                                                index === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default.a,
                                                    {
                                                        disabled: confirmed,
                                                        onClick: function onClick() {
                                                            return _this2.add();
                                                        }
                                                    },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                                                ),
                                                index !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default.a,
                                                    { onClick: function onClick() {
                                                            return _this2.remove(index);
                                                        } },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                                                )
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                            { key: '2-' + index, style: styles.bottomRow },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.bottomCol },
                                                tableItem('hold', 'teu', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.bottomCol },
                                                tableItem('hold', 'feu', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.bottomCol },
                                                tableItem('tweenDeck', 'teu', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.bottomCol },
                                                tableItem('tweenDeck', 'feu', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.bottomCol },
                                                tableItem('compartment', 'teu', index)
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                { style: styles.bottomCol },
                                                tableItem('compartment', 'feu', index)
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CapacityV2;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = CapacityV2;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CapacityV2.jsx');
    reactHotLoader.register(CapacityV2, 'CapacityV2', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CapacityV2.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CapacityV2.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_info__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_NumberField__ = __webpack_require__(63);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var FIELDS = {
    loa: { label: 'LOA' },
    lbp: { label: 'LBP' },
    beam: { label: 'Beam' },
    depth: { label: 'Depth' },
    beamMoulded: { label: 'Beam moulded' },
    depthMoulded: { label: 'Depth moulded' },
    bowToCenterManifold: { label: 'Bow to center manifold' },
    keelToMast: { label: 'Keel to mast' },
    airdrftLightship: { label: 'Airdrft / lightship' },
    airdrftNormBallast: { label: 'Airdrft / norm ballast' },
    airdrftLoadSumDwt: { label: 'Airdrft / load sum dwt' },
    wltohcBallast: { label: 'WLTOHC / ballast', hint: 'Waterline to hatch coaming' },
    wltohcDeball: { label: 'WLTOHC / deballast', hint: 'Waterline to hatch coaming' },
    bwtlhc: { label: 'BWTLHC', hint: 'Bow to aft last hatch' },
    parallelBodyLoaded: { label: 'Parallel body loaded' },
    parallelBodyFore: { label: 'Parallel body fore' },
    parallelBodyAft: { label: 'Parallel body aft' },
    sttbr: { label: 'STTBR', hint: 'Distance fm stern to bridge' },
    bwtbr: { label: 'BWTBR', hint: 'Distance fm bow to bridge' },
    freshWaterAllowance: { label: 'Frsh wtr allwnce fwa' },
    dtcr: { label: 'DTCR', hint: 'Height from deck to top of the crane' }
};

var LAYOUT = [['loa', 'lbp', 'beam', 'depth', 'beamMoulded', 'depthMoulded', 'bowToCenterManifold', 'keelToMast', 'airdrftLightship', 'airdrftNormBallast', 'airdrftLoadSumDwt'], ['wltohcBallast', 'wltohcDeball', 'bwtlhc'], ['parallelBodyLoaded', 'parallelBodyFore', 'parallelBodyAft', 'sttbr', 'bwtbr', 'freshWaterAllowance', 'dtcr']];

var styles = {
    infoIcon: {
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        margin: '-3px 0 0 0.5em',
        color: '#dadada',
        cursor: 'pointer'
    }
};

function Dimensions(_ref) {
    var confirmed = _ref.confirmed,
        changeField = _ref.changeField,
        getError = _ref.getError,
        underStyle = _ref.underStyle,
        modifiedFields = _ref.modifiedFields,
        dimensions = _ref.dimensions;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        LAYOUT.map(function (fields) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: fields[0] },
                fields.map(function (field) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3', key: field },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Base_NumberField__["a" /* default */], {
                            name: field,
                            value: dimensions[field] || '',
                            floatNumber: true,
                            floatingLabelText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                null,
                                FIELDS[field].label,
                                !!FIELDS[field].hint && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    {
                                        'data-tip': FIELDS[field].hint,
                                        style: { pointerEvents: 'all' }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_info___default.a, { style: styles.infoIcon })
                                )
                            ),
                            disabled: confirmed,
                            min: 0,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'dimensions.' + field,
                                    value: value
                                });
                            },
                            errorText: getError('dimensions.' + field),
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('dimensions.' + field) ? underStyle : null
                        })
                    );
                })
            );
        })
    );
}

var _default = Dimensions;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FIELDS, 'FIELDS', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Dimensions.jsx');
    reactHotLoader.register(LAYOUT, 'LAYOUT', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Dimensions.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Dimensions.jsx');
    reactHotLoader.register(Dimensions, 'Dimensions', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Dimensions.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Dimensions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var hatchTypes = ['', 'Standard', 'Sliding', 'Rolling', 'Folding', 'Pontoon', 'Single Pull', 'Piggy-back', 'Stacking type'];

var producers = ['', 'Mc Gregor', 'MC Gregor-Navire', 'Kayaba', 'Nakata Mac', 'Kvaerner', 'MACOR', 'SEOHAE', 'TTS Hua Hai', 'Tsuji'];

var HoldsHatchesTop = function (_React$Component) {
    _inherits(HoldsHatchesTop, _React$Component);

    function HoldsHatchesTop() {
        _classCallCheck(this, HoldsHatchesTop);

        return _possibleConstructorReturn(this, (HoldsHatchesTop.__proto__ || Object.getPrototypeOf(HoldsHatchesTop)).apply(this, arguments));
    }

    _createClass(HoldsHatchesTop, [{
        key: 'render',
        value: function render() {
            var holdsQuantity = this.props.holds.quantity;
            var hatchesQuantity = this.props.hatches.quantity;
            var hatchType = this.props.hatches.hatchType;
            var _props = this.props,
                getError = _props.getError,
                changeField = _props.changeField,
                changeHolds = _props.changeHolds,
                changeHatches = _props.changeHatches,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle,
                holdsHatchesProducer = _props.holdsHatchesProducer;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Base_NumberField__["a" /* default */], {
                        name: 'holds.quantity',
                        floatingLabelText: 'Holds',
                        value: holdsQuantity || '',
                        fullWidth: true,
                        disabled: confirmed,
                        min: 0,
                        max: 10,
                        onInput: function onInput(e) {
                            e.target.value = Math.min(20, parseInt(e.target.value)).toString().slice(0, 2);
                        },
                        onChange: function onChange(e, value) {
                            changeHolds(value);
                        },
                        errorText: getError('holds.quantity'),

                        underlineStyle: modifiedFields && modifiedFields.includes('holds.quantity') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Base_NumberField__["a" /* default */], {
                        name: 'hatches.quantity',
                        floatingLabelText: 'Hatch',
                        value: hatchesQuantity || '',
                        disabled: confirmed,
                        fullWidth: true,
                        min: 0,
                        max: 10,
                        onInput: function onInput(e) {
                            e.target.value = Math.min(40, parseInt(e.target.value)).toString().slice(0, 2);
                        },
                        onChange: function onChange(e, value) {
                            changeHatches(value);
                        },
                        errorText: getError('hatches.quantity'),

                        underlineStyle: modifiedFields && modifiedFields.includes('hatches.quantity') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
                        {
                            value: hatchType,
                            disabled: confirmed,
                            onChange: function onChange(e, i, value) {
                                changeField({
                                    field: 'hatches.hatchType',
                                    value: value
                                });
                            },
                            maxHeight: 200,
                            name: 'hatches.hatchType',
                            floatingLabelText: 'Hatch type',
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('hatches.hatchType') ? underStyle : null
                        },
                        hatchTypes.map(function (hatchType, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                                key: index,
                                value: hatchType,
                                primaryText: hatchType
                            });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
                        {
                            value: holdsHatchesProducer,
                            disabled: confirmed,
                            onChange: function onChange(e, i, value) {
                                changeField({
                                    field: 'holdsHatchesProducer',
                                    value: value
                                });
                            },
                            maxHeight: 200,
                            name: 'holdsHatchesProducer',
                            floatingLabelText: 'Producer',
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('holdsHatchesProducer') ? underStyle : null
                        },
                        producers.map(function (name) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                                key: name,
                                value: name,
                                primaryText: name
                            });
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return HoldsHatchesTop;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = HoldsHatchesTop;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(hatchTypes, 'hatchTypes', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/HoldsHatchesTop.jsx');
    reactHotLoader.register(producers, 'producers', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/HoldsHatchesTop.jsx');
    reactHotLoader.register(HoldsHatchesTop, 'HoldsHatchesTop', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/HoldsHatchesTop.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/HoldsHatchesTop.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Cells = function (_React$Component) {
    _inherits(Cells, _React$Component);

    function Cells(props) {
        _classCallCheck(this, Cells);

        var _this = _possibleConstructorReturn(this, (Cells.__proto__ || Object.getPrototypeOf(Cells)).call(this, props));

        _this.add = _this.add.bind(_this);
        _this.remove = _this.remove.bind(_this);
        return _this;
    }

    _createClass(Cells, [{
        key: 'add',
        value: function add() {
            var cells = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cells);

            cells.push({
                holds: {
                    l: '',
                    b: '',
                    h: '',
                    area: ''
                },
                tweenDecks: [{ l: '', b: '', h: '', area: '' }, { l: '', b: '', h: '', area: '' }],
                hatches: [{ l: '', b: '', area: '' }, { l: '', b: '', area: '' }]
            });

            this.props.changeField({
                field: 'cells',
                value: cells
            });
        }
    }, {
        key: 'remove',
        value: function remove(index) {
            var cells = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cells);
            cells.splice(index, 1);
            this.props.changeField({
                field: 'cells',
                value: cells
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                changeField = _props.changeField,
                changeAreas = _props.changeAreas,
                cells = _props.cells,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            var tableItemHolds = function tableItemHolds(stateName, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                    name: 'cells[' + index + '][holds].' + stateName,
                    value: cells[index]['holds'] ? cells[index]['holds'][stateName] : '',
                    disabled: confirmed,
                    errorText: getError('cells[' + index + '][holds].' + stateName),
                    floatNumber: true,
                    min: 0,
                    style: { width: '3em' },
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'cells[' + index + '][holds].' + stateName,
                            value: value
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('cells[' + index + '][holds].' + stateName) ? underStyle : null
                });
            };

            var tableItemTweenHatch = function tableItemTweenHatch(stateName, stateNameArrIndex, dimensionName, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                    name: 'cells[' + index + '][' + stateName + '][' + stateNameArrIndex + '].' + dimensionName,
                    value: cells[index][stateName][stateNameArrIndex] ? cells[index][stateName][stateNameArrIndex][dimensionName] : '',
                    disabled: confirmed,
                    errorText: getError('cells[' + index + '][' + stateName + '][' + stateNameArrIndex + '].' + dimensionName),
                    floatNumber: true,
                    min: 0,
                    style: { width: '3em' },
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'cells[' + index + '][' + stateName + '][' + stateNameArrIndex + '].' + dimensionName,
                            value: value
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('cells[' + index + '][' + stateName + '][' + stateNameArrIndex + '].' + dimensionName) ? underStyle : null
                });
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["Table"],
                    {
                        showCheckboxes: false,
                        selectable: false,
                        style: { border: '1px solid #DFDFDF' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeader"],
                        {
                            adjustForCheckbox: false,
                            displaySelectAll: false
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { margin: '0 0 0 155px' } },
                                    'Holds'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { margin: '0 0 0 115px' } },
                                    'Tweendecks'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { margin: '0 0 0 70px' } },
                                    'Hatches'
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableBody"],
                        {
                            displayRowCheckbox: false
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { paddingLeft: '13px' } },
                                'Cell No'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { borderLeft: '1px solid #DEDEDE', paddingLeft: '25px' } },
                                'L, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '25px' } },
                                'B, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '20px' } },
                                'H, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '10px' } },
                                'Area, m2'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { borderLeft: '1px solid #DEDEDE' } },
                                'L, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '13px' } },
                                'B, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '13px' } },
                                'H, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '13px' } },
                                'Area, m2'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { borderLeft: '1px solid #DEDEDE' } },
                                'L, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '13px' } },
                                'B, m'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                { style: { padding: '13px' } },
                                'Area, m2'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"], { style: { borderLeft: '1px solid #DEDEDE', paddingLeft: '13px' } })
                        ),
                        cells.map(function (item, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                {
                                    key: index
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { style: { margin: '25px 0 0 0' } },
                                        index + 1
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { borderLeft: '1px solid #DEDEDE', padding: '13px' } },
                                    tableItemHolds('l', index)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { padding: '13px' } },
                                    tableItemHolds('b', index)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { padding: '13px' } },
                                    tableItemHolds('h', index)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { padding: '10px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                                        name: 'cells[' + index + '][holds]area',
                                        value: cells[index].holds ? cells[index].holds.area : '',
                                        disabled: confirmed,
                                        errorText: getError('cells[' + index + '][holds]area'),
                                        floatNumber: true,
                                        style: { width: '3em' },
                                        min: 0,
                                        onChange: function onChange(e, value) {
                                            changeAreas({
                                                field: 'cells[' + index + '][holds].area',
                                                value: value
                                            });
                                            changeField({
                                                field: 'cells[' + index + '][holds].area',
                                                value: value
                                            });
                                        },
                                        underlineStyle: modifiedFields && modifiedFields.includes('cells[' + index + '][holds].area') ? underStyle : null
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { borderLeft: '1px solid #DEDEDE', paddingLeft: '13px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'table',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tbody',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('tweenDecks', 0, 'l', index)
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('tweenDecks', 1, 'l', index)
                                                )
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { paddingLeft: '13px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'table',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tbody',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('tweenDecks', 0, 'b', index)
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('tweenDecks', 1, 'b', index)
                                                )
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { paddingLeft: '13px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'table',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tbody',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('tweenDecks', 0, 'h', index)
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('tweenDecks', 1, 'h', index)
                                                )
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { paddingLeft: '13px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'table',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tbody',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                                                        name: 'cells[' + index + '][tweenDecks][0].area',
                                                        value: cells[index].tweenDecks[0] ? cells[index].tweenDecks[0].area : '',
                                                        disabled: confirmed,
                                                        errorText: getError('cells[' + index + '][tweenDecks][0].area'),
                                                        floatNumber: true,
                                                        min: 0,
                                                        style: { width: '3em' },
                                                        onChange: function onChange(e, value) {
                                                            changeAreas({
                                                                field: 'cells[' + index + '][tweenDecks][0].area',
                                                                value: value
                                                            });

                                                            changeField({
                                                                field: 'cells[' + index + '][tweenDecks][0].area',
                                                                value: value
                                                            });
                                                        },
                                                        underlineStyle: modifiedFields && modifiedFields.includes('cells[' + index + '][tweenDecks][0].area') ? underStyle : null
                                                    })
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                                                        name: 'cells[' + index + '][tweenDecks][1].area',
                                                        value: cells[index].tweenDecks[1] ? cells[index].tweenDecks[1].area : '',
                                                        disabled: confirmed,
                                                        errorText: getError('cells[' + index + '][tweenDecks][1].area'),
                                                        floatNumber: true,
                                                        min: 0,
                                                        style: { width: '3em' },
                                                        onChange: function onChange(e, value) {
                                                            changeAreas({
                                                                field: 'cells[' + index + '][tweenDecks][1].area',
                                                                value: value
                                                            });
                                                            changeField({
                                                                field: 'cells[' + index + '][tweenDecks][1].area',
                                                                value: value
                                                            });
                                                        },
                                                        underlineStyle: modifiedFields && modifiedFields.includes('cells[' + index + '][tweenDecks][1].area') ? underStyle : null
                                                    })
                                                )
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { borderLeft: '1px solid #DEDEDE', paddingLeft: '13px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'table',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tbody',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('hatches', 0, 'l', index)
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('hatches', 1, 'l', index)
                                                )
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { paddingLeft: '13px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'table',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tbody',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('hatches', 0, 'b', index)
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    tableItemTweenHatch('hatches', 1, 'b', index)
                                                )
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { paddingLeft: '13px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'table',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tbody',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                                                        name: 'cells[' + index + '][hatches][0].area',
                                                        value: cells[index].hatches[0] ? cells[index].hatches[0].area : '',
                                                        disabled: confirmed,
                                                        errorText: getError('cells[' + index + '][hatches][0].area'),
                                                        floatNumber: true,
                                                        min: 0,
                                                        style: { width: '3em' },
                                                        onChange: function onChange(e, value) {
                                                            changeAreas({
                                                                field: 'cells[' + index + '][hatches][0].area',
                                                                value: value,
                                                                hatchesField: true
                                                            });
                                                            changeField({
                                                                field: 'cells[' + index + '][hatches][0].area',
                                                                value: value
                                                            });
                                                        },
                                                        underlineStyle: modifiedFields && modifiedFields.includes('cells[' + index + '][hatches][0].area') ? underStyle : null
                                                    })
                                                )
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Base_NumberField__["a" /* default */], {
                                                        name: 'cells[' + index + '][hatches][1].area',
                                                        value: cells[index].hatches[1] ? cells[index].hatches[1].area : '',
                                                        disabled: confirmed,
                                                        errorText: getError('cells[' + index + '][hatches][1].area'),
                                                        floatNumber: true,
                                                        min: 0,
                                                        style: { width: '3em' },
                                                        onChange: function onChange(e, value) {
                                                            changeAreas({
                                                                field: 'cells[' + index + '][hatches][1].area',
                                                                value: value,
                                                                hatchesField: true
                                                            });
                                                            changeField({
                                                                field: 'cells[' + index + '][hatches][1].area',
                                                                value: value
                                                            });
                                                        },
                                                        underlineStyle: modifiedFields && modifiedFields.includes('cells[' + index + '][hatches][1].area') ? underStyle : null

                                                    })
                                                )
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                    { style: { borderLeft: '1px solid #DEDEDE', paddingRight: '2em' } },
                                    !index ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default.a,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                            onClick: function onClick() {
                                                _this2.add();
                                            },
                                            style: { margin: '70px 0 0 0' },
                                            color: 'green'
                                        })
                                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default.a,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                            onClick: function onClick() {
                                                _this2.remove(index);
                                            },
                                            style: { margin: '30px 0 0 0' },
                                            color: 'red'
                                        })
                                    )
                                )
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Cells;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Cells;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Cells, 'Cells', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Cells.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Cells.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Areas = function (_React$Component) {
    _inherits(Areas, _React$Component);

    function Areas() {
        _classCallCheck(this, Areas);

        return _possibleConstructorReturn(this, (Areas.__proto__ || Object.getPrototypeOf(Areas)).apply(this, arguments));
    }

    _createClass(Areas, [{
        key: 'render',
        value: function render() {
            var _props$areas = this.props.areas,
                mainDeck = _props$areas.mainDeck,
                tweenDeck = _props$areas.tweenDeck,
                weatherDeck = _props$areas.weatherDeck,
                total = _props$areas.total,
                confirmed = _props$areas.confirmed;
            var _props = this.props,
                getError = _props.getError,
                changeField = _props.changeField,
                changeAreas = _props.changeAreas,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            floatNumber: true,
                            min: 0,
                            fullWidth: true,
                            disabled: confirmed,
                            name: 'areas.mainDeck',
                            floatingLabelText: 'Area main deck, m2',
                            value: mainDeck || '',
                            errorText: getError('areas.mainDeck'),
                            onChange: function onChange(e, value) {
                                changeAreas({ field: 'areas.mainDeck', value: value });
                            },
                            underlineStyle: modifiedFields && modifiedFields.includes('areas.mainDeck') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            floatNumber: true,
                            min: 0,
                            fullWidth: true,
                            disabled: confirmed,
                            name: 'areas.tweenDeck',
                            floatingLabelText: 'Area tween deck, m2',
                            value: tweenDeck || '',
                            errorText: getError('areas.tweenDeck'),
                            onChange: function onChange(e, value) {
                                changeAreas({ field: 'areas.tweenDeck', value: value });
                            },
                            underlineStyle: modifiedFields && modifiedFields.includes('areas.tweenDeck') ? underStyle : null
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            floatNumber: true,
                            min: 0,
                            fullWidth: true,
                            disabled: confirmed,
                            name: 'areas.weatherDeck',
                            floatingLabelText: 'Area weather deck, m2',
                            value: weatherDeck || '',
                            errorText: getError('areas.weatherDeck'),
                            onChange: function onChange(e, value) {
                                changeAreas({ field: 'areas.weatherDeck', value: value });
                            },
                            underlineStyle: modifiedFields && modifiedFields.includes('areas.weatherDeck') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            name: 'areas.total',
                            floatingLabelText: 'Total, m2',
                            value: total || '',
                            disabled: confirmed,
                            errorText: getError('areas.total'),
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'areas.total',
                                    value: value,
                                    type: 'number'
                                });
                            },
                            floatNumber: true,
                            min: 0,
                            fullWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('areas.total') ? underStyle : null
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Areas;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Areas;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Areas, 'Areas', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Areas.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Areas.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var modes = ['Laden', 'Ballast', 'Eco Laden', 'Eco Ballast', 'Idle', 'Working'];
var typesOfIfo = ["VLS FO", "ULS FO", "HFO 180", "HFO 380"];
var typesOfMdo = ["MGO", "LS MGO"];

var SpeedConsumptionV2 = function (_React$Component) {
    _inherits(SpeedConsumptionV2, _React$Component);

    function SpeedConsumptionV2(props) {
        _classCallCheck(this, SpeedConsumptionV2);

        var _this = _possibleConstructorReturn(this, (SpeedConsumptionV2.__proto__ || Object.getPrototypeOf(SpeedConsumptionV2)).call(this, props));

        _this.add = _this.add.bind(_this);
        _this.remove = _this.remove.bind(_this);
        _this.removeSpeed = _this.removeSpeed.bind(_this);
        return _this;
    }

    _createClass(SpeedConsumptionV2, [{
        key: 'add',
        value: function add() {
            var speedConsumptionV2 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.speedConsumptionV2);

            speedConsumptionV2.push({
                mode: '',
                speed: '',
                ifo: {
                    typeIfo: 'HFO 180',
                    cons: ''
                },
                mdo: {
                    typeMdo: 'MGO',
                    cons: ''
                }
            });

            this.props.changeField({
                field: 'speedConsumptionV2',
                value: speedConsumptionV2
            });
        }
    }, {
        key: 'remove',
        value: function remove(index) {
            var speedConsumptionV2 = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.speedConsumptionV2);

            speedConsumptionV2.splice(index, 1);
            this.props.changeField({
                field: 'speedConsumptionV2',
                value: speedConsumptionV2
            });
        }
    }, {
        key: 'removeSpeed',
        value: function removeSpeed(index) {
            this.props.changeField({
                field: 'speedConsumptionV2[' + index + '].speed',
                value: ''
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.changeField({
                field: 'speedConsumptionV2',
                value: this.props.speedConsumptionV2
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                getError = _props.getError,
                changeField = _props.changeField,
                confirmed = _props.confirmed,
                speedConsumptionV2 = _props.speedConsumptionV2,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                speedConsumptionV2.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row', key: index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                                {
                                    name: 'speedConsumptionV2[' + index + '].mode',
                                    disabled: confirmed,
                                    value: speedConsumptionV2[index].mode || '',
                                    errorText: getError('speedConsumptionV2[' + index + '].mode'),
                                    onChange: function onChange(e, i, value) {
                                        changeField({
                                            field: 'speedConsumptionV2[' + index + '].mode',
                                            value: value
                                        });

                                        // remove data from speed input if 'idle' or 'working' are selected
                                        if (modes.indexOf(value) === 5 || modes.indexOf(value) === 6) {
                                            _this2.removeSpeed(index);
                                        }
                                    },
                                    floatingLabelText: 'Mode (sea, port)',
                                    fullWidth: true,

                                    underlineStyle: modifiedFields && modifiedFields.includes('speedConsumptionV2[' + index + '].mode') ? underStyle : null
                                },
                                modes.map(function (mode, modeIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                        key: modeIndex,
                                        value: mode,
                                        primaryText: mode
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                name: 'speedConsumptionV2[' + index + '].speed',
                                floatingLabelText: 'Speed, kn',
                                value: speedConsumptionV2[index].speed || '',
                                floatNumber: true,
                                disabled: modes.indexOf(speedConsumptionV2[index].mode) === 4 || modes.indexOf(speedConsumptionV2[index].mode) === 5 ? !confirmed : confirmed,
                                errorText: getError('speedConsumptionV2[' + index + '].speed'),
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: 'speedConsumptionV2[' + index + '].speed',
                                        value: value
                                    });
                                },
                                fullWidth: true,

                                underlineStyle: modifiedFields && modifiedFields.includes('speedConsumptionV2[' + index + '].speed') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                                {
                                    name: 'speedConsumptionV2[' + index + '][ifo].typeIfo',
                                    disabled: confirmed,
                                    value: speedConsumptionV2[index].ifo.typeIfo || '',
                                    errorText: getError('speedConsumptionV2[' + index + '][ifo].typeIfo'),
                                    onChange: function onChange(e, i, value) {
                                        changeField({
                                            field: 'speedConsumptionV2[' + index + '][ifo].typeIfo',
                                            value: value
                                        });
                                    },
                                    floatingLabelText: 'IFO',
                                    fullWidth: true,

                                    underlineStyle: modifiedFields && modifiedFields.includes('speedConsumptionV2[' + index + '][ifo].typeIfo') ? underStyle : null
                                },
                                typesOfIfo.map(function (type, typeIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                        key: typeIndex,
                                        value: type,
                                        primaryText: type
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                name: 'speedConsumptionV2[' + index + '][ifo].cons',
                                disabled: confirmed,
                                value: speedConsumptionV2[index].ifo.cons || '',
                                errorText: getError('speedConsumptionV2[' + index + '][ifo].cons'),
                                floatNumber: true,
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: 'speedConsumptionV2[' + index + '][ifo].cons',
                                        value: value
                                    });
                                },
                                floatingLabelText: 'Cons',
                                fullWidth: true,

                                underlineStyle: modifiedFields && modifiedFields.includes('speedConsumptionV2[' + index + '][ifo].cons') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                                {
                                    name: 'speedConsumptionV2[' + index + '][mdo].typeMdo',
                                    disabled: confirmed,
                                    value: speedConsumptionV2[index].mdo ? speedConsumptionV2[index].mdo.typeMdo || '' : '',
                                    errorText: getError('speedConsumptionV2[' + index + '][mdo].typeMdo'),
                                    onChange: function onChange(e, i, value) {
                                        changeField({
                                            field: 'speedConsumptionV2[' + index + '][mdo].typeMdo',
                                            value: value
                                        });
                                    },
                                    floatingLabelText: 'MDO',
                                    fullWidth: true,

                                    underlineStyle: modifiedFields && modifiedFields.includes('speedConsumptionV2[' + index + '][mdo].typeMdo') ? underStyle : null
                                },
                                typesOfMdo.map(function (type, typeIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                        key: typeIndex,
                                        value: type,
                                        primaryText: type
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                name: 'speedConsumptionV2[' + index + '][mdo].cons',
                                disabled: confirmed,
                                value: speedConsumptionV2[index].mdo ? speedConsumptionV2[index].mdo.cons || '' : '',
                                errorText: getError('speedConsumptionV2[' + index + '][mdo].cons'),
                                floatNumber: true,
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: 'speedConsumptionV2[' + index + '][mdo].cons',
                                        value: value
                                    });
                                },
                                floatingLabelText: 'Cons',
                                fullWidth: true,

                                underlineStyle: modifiedFields && modifiedFields.includes('speedConsumptionV2[' + index + '][mdo].cons') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                                name: 'speedConsumptionV2[' + index + '].lngCons',
                                disabled: confirmed,
                                value: speedConsumptionV2[index].lngCons || '',
                                errorText: getError('speedConsumptionV2[' + index + '].lngCons'),
                                floatNumber: true,
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: 'speedConsumptionV2[' + index + '].lngCons',
                                        value: value
                                    });
                                },
                                floatingLabelText: 'LNG',
                                fullWidth: true,

                                underlineStyle: modifiedFields && modifiedFields.includes('speedConsumptionV2[' + index + '].lngCons') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default.a, {
                                style: { margin: '35px 0 0' },
                                label: 'Scrubber',
                                checked: speedConsumptionV2[index].scrubber,
                                onCheck: function onCheck(e, checked) {
                                    changeField({
                                        field: 'speedConsumptionV2[' + index + '].scrubber',
                                        value: checked
                                    });
                                },
                                iconStyle: { marginRight: '8px' }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1' },
                            !index ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                { style: { margin: '25px 0 0 0' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                    onClick: function onClick() {
                                        _this2.add();
                                    },
                                    color: 'green'
                                })
                            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                { style: { margin: '25px 0 0 0' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                    onClick: function onClick() {
                                        _this2.remove(index);
                                    },
                                    color: 'red'
                                })
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SpeedConsumptionV2;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = SpeedConsumptionV2;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(modes, 'modes', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SpeedConsumptionV2.jsx');
    reactHotLoader.register(typesOfIfo, 'typesOfIfo', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SpeedConsumptionV2.jsx');
    reactHotLoader.register(typesOfMdo, 'typesOfMdo', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SpeedConsumptionV2.jsx');
    reactHotLoader.register(SpeedConsumptionV2, 'SpeedConsumptionV2', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SpeedConsumptionV2.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SpeedConsumptionV2.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Base_NumberField__ = __webpack_require__(63);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var TOP_LABELS = {
    maxTt: 'Max TT strength by hold',
    maxTween: 'Max Tween strength'
};

var BOTTOM_LABELS = {
    upperDeck: 'Upper deck strength',
    crossDeck: 'Cross deck strength',
    hatchCover: 'Hatch cover strength',
    maxWeather: 'Max Weather Deck strength'
};

/** @type {Record<string, import('react').CSSProperties>} */
var styles = {
    actionsCol: {
        width: '50px',
        paddingLeft: '0',
        paddingRight: '0',
        textAlign: 'center'
    },
    numberCol: {
        width: '40px',
        paddingLeft: '20px',
        paddingRight: '0',
        textAlign: 'left'
    }
};

function StrengthNumerics(_ref) {
    var labels = _ref.labels,
        getError = _ref.getError,
        changeField = _ref.changeField,
        modifiedFields = _ref.modifiedFields,
        underStyle = _ref.underStyle,
        strength = _ref.strength,
        confirmed = _ref.confirmed;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        Object.entries(labels).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                field = _ref3[0],
                label = _ref3[1];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6', key: field },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Base_NumberField__["a" /* default */], {
                    disabled: confirmed,
                    name: 'strength.' + field,
                    floatingLabelText: label,
                    value: strength[field] || '',
                    errorText: getError('strength.' + field),
                    fullWidth: true,
                    floatNumber: true,
                    min: 0,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'strength.' + field,
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('strength.' + field) ? underStyle : null
                })
            );
        })
    );
}

/** @param {{ getError, changeField, modifiedFields, underStyle, strength, confirmed }} props */
function Strength(props) {
    var confirmed = props.confirmed,
        getError = props.getError,
        modifiedFields = props.modifiedFields,
        changeField = props.changeField,
        underStyle = props.underStyle;
    var tanktopByHolds = props.strength.tanktopByHolds;

    if (!tanktopByHolds) {
        tanktopByHolds = [''];
    }
    var addRow = function addRow() {
        props.changeField({
            field: 'strength.tanktopByHolds',
            value: [].concat(_toConsumableArray(tanktopByHolds), [undefined])
        });
    };
    var removeRow = function removeRow(index) {
        var slice = tanktopByHolds.slice();
        slice.splice(index, 1);
        props.changeField({
            field: 'strength.tanktopByHolds',
            value: slice
        });
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StrengthNumerics, _extends({ labels: TOP_LABELS }, props))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["u" /* Table */],
                    { selectable: false, style: { border: '1px solid rgb(223, 223, 223)' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["w" /* TableHeader */],
                        { displaySelectAll: false, adjustForCheckbox: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui__["y" /* TableRow */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui__["x" /* TableHeaderColumn */],
                                { colSpan: 3 },
                                'Tanktop strength by holds'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["v" /* TableBody */],
                        { displayRowCheckbox: false },
                        tanktopByHolds.map(function (strength, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui__["y" /* TableRow */],
                                { key: index },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.numberCol },
                                    index + 1
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Base_NumberField__["a" /* default */], {
                                        disabled: confirmed,
                                        name: 'strength.tanktopByHolds[' + index + ']',
                                        value: strength || '',
                                        errorText: getError('strength.tanktopByHolds[' + index + ']'),
                                        fullWidth: true,
                                        floatNumber: true,
                                        min: 0,
                                        onChange: function onChange(e, value) {
                                            changeField({
                                                field: 'strength.tanktopByHolds[' + index + ']',
                                                value: value,
                                                type: 'number'
                                            });
                                        },
                                        underlineStyle: modifiedFields && modifiedFields.includes('strength.tanktopByHolds[' + index + ']') ? underStyle : null
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.actionsCol },
                                    index === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton___default.a,
                                        {
                                            disabled: props.confirmed,
                                            onClick: addRow },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                                    ),
                                    index !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton___default.a,
                                        { onClick: function onClick() {
                                                return removeRow(index);
                                            } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                                    )
                                )
                            );
                        })
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StrengthNumerics, _extends({ labels: BOTTOM_LABELS }, props))
        )
    );
}

var _default = Strength;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TOP_LABELS, 'TOP_LABELS', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Strength.jsx');
    reactHotLoader.register(BOTTOM_LABELS, 'BOTTOM_LABELS', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Strength.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Strength.jsx');
    reactHotLoader.register(StrengthNumerics, 'StrengthNumerics', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Strength.jsx');
    reactHotLoader.register(Strength, 'Strength', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Strength.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Strength.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var StackWeight = function (_React$Component) {
    _inherits(StackWeight, _React$Component);

    function StackWeight(props) {
        _classCallCheck(this, StackWeight);

        var _this = _possibleConstructorReturn(this, (StackWeight.__proto__ || Object.getPrototypeOf(StackWeight)).call(this, props));

        _this.state = {
            '20hold': props.stackWeight['20hold'],
            '20deck': props.stackWeight['20deck'],
            '40hold': props.stackWeight['40hold'],
            '40deck': props.stackWeight['40deck'],
            confirmed: props.confirmed
        };
        return _this;
    }

    _createClass(StackWeight, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                '20hold': nextProps.stackWeight['20hold'],
                '20deck': nextProps.stackWeight['20deck'],
                '40hold': nextProps.stackWeight['40hold'],
                '40deck': nextProps.stackWeight['40deck'],
                confirmed: nextProps.confirmed
            });
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.stackWeight['20hold'] !== this.state['20hold'] || nextProps.stackWeight['20deck'] !== this.state['20deck'] || nextProps.stackWeight['40hold'] !== this.state['40hold'] || nextProps.stackWeight['40deck'] !== this.state['40deck'] || nextProps.getError('stackWeight.20hold').length > 0 || nextProps.getError('stackWeight.20deck').length > 0 || nextProps.getError('stackWeight.40hold').length > 0 || nextProps.getError('stackWeight.40deck').length > 0 || nextProps.confirmed !== this.state.confirmed;
        }
    }, {
        key: 'render',
        value: function render() {
            var confirmed = this.state.confirmed;
            var _props = this.props,
                getError = _props.getError,
                changeField = _props.changeField,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            disabled: confirmed,
                            name: 'stackWeight.20hold',
                            floatingLabelText: '20\' Max stackweight hold',
                            value: this.state['20hold'] || '',
                            errorText: getError('stackWeight.20hold'),
                            fullWidth: true,
                            floatNumber: true,
                            min: 0,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'stackWeight.20hold',
                                    value: value,
                                    type: 'number'
                                });
                            },

                            underlineStyle: modifiedFields && modifiedFields.includes('stackWeight.20hold') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            disabled: confirmed,
                            name: 'stackWeight.20deck',
                            floatingLabelText: '20\' Max stackweight deck',
                            value: this.state['20deck'] || '',
                            errorText: getError('stackWeight.20deck'),
                            fullWidth: true,
                            floatNumber: true,
                            min: 0,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'stackWeight.20deck',
                                    value: value,
                                    type: 'number'
                                });
                            },

                            underlineStyle: modifiedFields && modifiedFields.includes('stackWeight.20deck') ? underStyle : null
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            disabled: confirmed,
                            name: 'stackWeight.40hold',
                            floatingLabelText: '40\' Max stackweight hold',
                            value: this.state['40hold'] || '',
                            errorText: getError('stackWeight.40hold'),
                            fullWidth: true,
                            floatNumber: true,
                            min: 0,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'stackWeight.40hold',
                                    value: value,
                                    type: 'number'
                                });
                            },

                            underlineStyle: modifiedFields && modifiedFields.includes('stackWeight.40hold') ? underStyle : null
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], {
                            disabled: confirmed,
                            name: 'stackWeight.40deck',
                            floatingLabelText: '40\' Max stackweight deck',
                            value: this.state['40deck'] || '',
                            errorText: getError('stackWeight.40deck'),
                            fullWidth: true,
                            floatNumber: true,
                            min: 0,
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'stackWeight.40deck',
                                    value: value,
                                    type: 'number'
                                });
                            },

                            underlineStyle: modifiedFields && modifiedFields.includes('stackWeight.40deck') ? underStyle : null
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return StackWeight;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = StackWeight;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StackWeight, 'StackWeight', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/StackWeight.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/StackWeight.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Base_NumberField__ = __webpack_require__(63);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











var engineLocations = ['aft', 'mid', 'fore', ''];
var engineTypes = ['Main Engine', 'Aux Engine', 'Emergency', 'Gen', 'Power Packs', 'Boilers'];
var defaultEngine = {
    type: undefined,
    number: undefined,
    capacity: undefined,
    rpm: undefined,
    makeType: undefined
};
var capacityUnits = {
    'Boilers': 'mt/hr',
    'Power Packs': 'm3/hr'
};

/** @param {object} props */
function OtherFields(_ref) {
    var getError = _ref.getError,
        changeField = _ref.changeField,
        confirmed = _ref.confirmed,
        engineLocation = _ref.engineLocation,
        windScale = _ref.windScale,
        modifiedFields = _ref.modifiedFields,
        underStyle = _ref.underStyle,
        engines = _ref.engines;

    if (!engines || !engines.length) {
        engines = [_extends({}, defaultEngine)];
    }
    var addRow = function addRow() {
        changeField({
            field: 'engines',
            value: [].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(engines)), [_extends({}, defaultEngine)])
        });
    };
    var removeRow = function removeRow(index) {
        var list = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(engines);
        list.splice(index, 1);
        changeField({ field: 'engines', value: list });
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField___default.a,
                    {
                        value: engineLocation,
                        disabled: confirmed,
                        onChange: function onChange(e, i, value) {
                            changeField({
                                field: 'engineLocation',
                                value: value
                            });
                        },
                        errorText: getError('engineLocation'),
                        maxHeight: 200,
                        name: 'engineLocation',
                        floatingLabelText: 'Engine location',
                        fullWidth: true,

                        underlineStyle: modifiedFields && modifiedFields.includes('engineLocation') ? underStyle : null
                    },
                    engineLocations.map(function (engineLocation, index) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, {
                            key: engineLocation + '_' + index,
                            value: engineLocation,
                            primaryText: engineLocation
                        });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField___default.a,
                    {
                        value: windScale,
                        disabled: confirmed,
                        onChange: function onChange(e, i, value) {
                            changeField({
                                field: 'windScale',
                                value: value
                            });
                        },
                        errorText: getError('windScale'),
                        maxHeight: 200,
                        name: 'windScale',
                        floatingLabelText: 'WindScale',
                        fullWidth: true,

                        underlineStyle: modifiedFields && modifiedFields.includes('windScale') ? underStyle : null
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 0, primaryText: '0 (0—0,2 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 1, primaryText: '1 (0,3—1,5 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 2, primaryText: '2 (1,6—3,3 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 3, primaryText: '3 (3,4—5,4 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 4, primaryText: '4 (5,5—7,9 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 5, primaryText: '5 (8,0—10,7 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 6, primaryText: '6 (10,8—13,8 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 7, primaryText: '7 (13,9—17,1 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 8, primaryText: '8 (17,2—20,7 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 9, primaryText: '9 (20,8—24,4 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 10, primaryText: '10 (24,5—28,4 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 11, primaryText: '11 (28,5—32,6 m/s)' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, { value: 12, primaryText: '12 (33 and more m/s)' })
                )
            )
        ),
        engines.map(function (engine, index) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'row', key: engine.type + '_' + index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField___default.a,
                        {
                            value: engine.type,
                            onChange: function onChange(e, i, value) {
                                changeField({
                                    field: 'engines[' + index + '].type',
                                    value: value
                                });
                            },
                            disabled: confirmed,
                            errorText: getError('engines[' + index + '].type'),
                            maxHeight: 200,
                            name: 'engines[' + index + '].type',
                            floatingLabelText: 'Engine',
                            fullWidth: true,
                            autoWidth: true,
                            underlineStyle: modifiedFields && modifiedFields.includes('engines[' + index + '].type') ? underStyle : null
                        },
                        [''].concat(engineTypes).map(function (type) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, {
                                key: type,
                                value: type,
                                primaryText: type
                            });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                        name: 'engines[' + index + '].number',
                        floatingLabelText: 'Number, pc',
                        value: engine.number || '',
                        disabled: confirmed,
                        errorText: getError('engines[' + index + '].number'),
                        fullWidth: true,
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'engines[' + index + '].number',
                                value: value,
                                type: 'number'
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('engines[' + index + '].number') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                        name: 'engines[' + index + '].capacity',
                        floatingLabelText: 'Capacity, ' + (capacityUnits[engine.type] || 'kw'),
                        value: engine.capacity || '',
                        disabled: confirmed,
                        errorText: getError('engines[' + index + '].capacity'),
                        fullWidth: true,
                        floatNumber: true,
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'engines[' + index + '].capacity',
                                value: value,
                                type: 'number'
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('engines[' + index + '].capacity') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Base_NumberField__["a" /* default */], {
                        name: 'engines[' + index + '].rpm',
                        floatingLabelText: 'RPM',
                        value: engine.rpm || '',
                        disabled: confirmed,
                        errorText: getError('engines[' + index + '].rpm'),
                        fullWidth: true,
                        floatNumber: true,
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'engines[' + index + '].rpm',
                                value: value,
                                type: 'number'
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('engines[' + index + '].rpm') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default.a, {
                        name: 'engines[' + index + '].makeType',
                        floatingLabelText: 'Make/Type',
                        value: engine.makeType || '',
                        disabled: confirmed,
                        errorText: getError('engines[' + index + '].makeType'),
                        fullWidth: true,
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'engines[' + index + '].makeType',
                                value: value,
                                type: 'number'
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('engines[' + index + '].makeType') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-1' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { margin: '25px 0 0 0' } },
                        index === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                            {
                                disabled: confirmed,
                                onClick: addRow
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                        ),
                        index !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                            {
                                disabled: confirmed,
                                onClick: function onClick() {
                                    removeRow(index);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                        )
                    )
                )
            );
        })
    );
}

var _default = OtherFields;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(engineLocations, 'engineLocations', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/OtherFields.jsx');
    reactHotLoader.register(engineTypes, 'engineTypes', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/OtherFields.jsx');
    reactHotLoader.register(defaultEngine, 'defaultEngine', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/OtherFields.jsx');
    reactHotLoader.register(capacityUnits, 'capacityUnits', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/OtherFields.jsx');
    reactHotLoader.register(OtherFields, 'OtherFields', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/OtherFields.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/OtherFields.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Design = function (_React$Component) {
    _inherits(Design, _React$Component);

    function Design(props) {
        _classCallCheck(this, Design);

        var _this = _possibleConstructorReturn(this, (Design.__proto__ || Object.getPrototypeOf(Design)).call(this, props));

        _this.state = {
            designs: []
        };

        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(Design, [{
        key: 'changeAutoComplete',
        value: function changeAutoComplete(searchText) {
            var _this2 = this;

            this.props.changeField({
                field: 'design.name',
                value: searchText,
                type: undefined,
                cb: function cb() {
                    if (searchText) {
                        __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].findVesselDesign(searchText).then(function (response) {
                            if (response.status === 200) {
                                var designs = response.data.data.map(function (design) {
                                    return {
                                        name: design.name,
                                        design: design
                                    };
                                });

                                if (!designs.length) {
                                    _this2.setState({
                                        designs: []
                                    });

                                    _this2.props.changeField({
                                        field: 'design._id',
                                        value: ''
                                    });
                                } else {
                                    _this2.setState({
                                        designs: designs
                                    });
                                }
                            }
                        }).catch(function (error) {
                            console.error('Error AutoComplete vessel Design - component', error);
                            return null;
                        });
                    } else {
                        _this2.props.changeField({
                            field: 'design._id',
                            value: ''
                        });
                    }
                }
            });
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            this.setState({
                clubs: []
            });

            this.props.changeField({
                field: 'design',
                value: updateProperties.design
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var designs = this.state.designs;
            var _props = this.props,
                getError = _props.getError,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle,
                design = _props.design;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                name: 'pi-club',
                disabled: confirmed,
                dataSource: designs,
                dataSourceConfig: { text: 'name', value: 'design' },
                floatingLabelText: 'Design',
                searchText: design.name,
                onUpdateInput: this.changeAutoComplete,
                onNewRequest: this.chooseAutoComplete,
                filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                errorText: getError('design'),
                listStyle: { overflow: 'auto', maxHeight: '300px' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true,

                underlineStyle: modifiedFields && modifiedFields.includes('design.name') ? underStyle : null
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Design;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Design;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Design, 'Design', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Design.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Design.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Base_NumberField__ = __webpack_require__(63);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var typeOfFuel = ["HFO 180", "HFO 380", "MGO", "LS MGO", "LNG"];

var Bunkers = function (_React$Component) {
    _inherits(Bunkers, _React$Component);

    function Bunkers(props) {
        _classCallCheck(this, Bunkers);

        var _this = _possibleConstructorReturn(this, (Bunkers.__proto__ || Object.getPrototypeOf(Bunkers)).call(this, props));

        _this.addBunker = _this.addBunker.bind(_this);
        _this.removeBunker = _this.removeBunker.bind(_this);
        return _this;
    }

    _createClass(Bunkers, [{
        key: 'addBunker',
        value: function addBunker() {
            var bunkers = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.bunkers);

            bunkers.push({
                quantity: undefined,
                typeOfFuel: ''
            });

            this.props.changeField({ field: 'bunkers', value: bunkers });
        }
    }, {
        key: 'removeBunker',
        value: function removeBunker(index) {
            var bunkers = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.bunkers);
            bunkers.splice(index, 1);
            this.props.changeField({ field: 'bunkers', value: bunkers });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                changeField = _props.changeField,
                getError = _props.getError,
                bunkers = _props.bunkers,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                underStyle = _props.underStyle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                bunkers.map(function (bunker, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: index, className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                                {
                                    value: bunker.typeOfFuel || '',
                                    onChange: function onChange(e, i, value) {
                                        changeField({
                                            field: 'bunkers[' + index + '].typeOfFuel',
                                            value: value
                                        });
                                    },
                                    disabled: confirmed,
                                    errorText: getError('bunkers.' + index + '.typeOfFuel'),
                                    maxHeight: 200,
                                    name: 'typeOfFuel',
                                    floatingLabelText: 'Type of Fuel',
                                    fullWidth: true,

                                    underlineStyle: modifiedFields && modifiedFields.includes('bunkers[' + index + '].typeOfFuel') ? underStyle : null

                                },
                                typeOfFuel.map(function (type, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, {
                                        key: index,
                                        value: type,
                                        primaryText: type
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                                name: 'bunkers.quantity',
                                floatingLabelText: 'Quantity, mt',
                                value: bunker.quantity || '',
                                fullWidth: true,
                                floatNumber: true,
                                disabled: !bunker.typeOfFuel,
                                errorText: getError('bunkers.' + index + '.quantity'),
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: 'bunkers[' + index + '].quantity',
                                        value: value,
                                        type: 'number'
                                    });
                                },

                                underlineStyle: modifiedFields && modifiedFields.includes('bunkers[' + index + '].quantity') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1 middle-xs center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { margin: '25px 0 0 0' } },
                                index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: confirmed
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                        onClick: _this2.addBunker,
                                        color: 'green'
                                    })
                                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                    {
                                        disabled: confirmed
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                        onClick: function onClick() {
                                            _this2.removeBunker(index);
                                        },
                                        color: 'red'
                                    })
                                )
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Bunkers;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Bunkers;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(typeOfFuel, 'typeOfFuel', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Bunkers.jsx');
    reactHotLoader.register(Bunkers, 'Bunkers', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Bunkers.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Bunkers.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Description = function (_React$Component) {
    _inherits(Description, _React$Component);

    function Description() {
        _classCallCheck(this, Description);

        return _possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).apply(this, arguments));
    }

    _createClass(Description, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                description = _props.description,
                changeField = _props.changeField;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                            value: description || '',
                            onChange: function onChange(e, value) {
                                changeField({
                                    field: 'description',
                                    value: value
                                });
                            },
                            hintText: 'Description',
                            multiLine: true,
                            fullWidth: true
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Description;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Description;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Description, 'Description', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Description.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Description.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function LinerMeter(_ref) {
    var linerMeter = _ref.linerMeter,
        linerMeterDisabled = _ref.linerMeterDisabled,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        _ref$modifiedFields = _ref.modifiedFields,
        modifiedFields = _ref$modifiedFields === undefined ? null : _ref$modifiedFields,
        _ref$underStyle = _ref.underStyle,
        underStyle = _ref$underStyle === undefined ? null : _ref$underStyle;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
        name: 'linerMeter',
        floatingLabelText: 'Liner meter, m',
        value: linerMeter || '',
        onChange: function onChange(e) {
            return changeFieldsMultiple([{ field: 'linerMeter', value: parseFloat(e.target.value) }]);
        },
        disabled: linerMeterDisabled,
        underlineStyle: modifiedFields && modifiedFields.includes('linerMeter') ? underStyle : null,
        fullWidth: true
    });
}

var _default = LinerMeter;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LinerMeter, 'LinerMeter', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/LinerMeter.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/LinerMeter.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_clear__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services__ = __webpack_require__(10);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var defaultCargo = {
    cargo: { _id: '', name: '' },
    date: null
};

var defaultTank = {
    cargoes: [__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(defaultCargo), __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(defaultCargo), __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(defaultCargo)]
};

function LastCargoCell(_ref) {
    var field = _ref.field,
        cargo = _ref.cargo,
        underStyle = _ref.underStyle,
        modifiedFields = _ref.modifiedFields,
        disabled = _ref.disabled,
        getError = _ref.getError,
        changeField = _ref.changeField;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(cargo.cargo.name),
        _useState2 = _slicedToArray(_useState, 2),
        query = _useState2[0],
        setQuery = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        queryChanged = _useState4[0],
        setQueryChanged = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        dataSource = _useState6[0],
        setDataSource = _useState6[1];

    var handleUpdateInput = function handleUpdateInput(value) {
        setQuery(value);
        if (!queryChanged) {
            setQueryChanged(true);
        }
        if (value.length < 2) return;
        __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].getCargoNamesAutocomplete(value).then(function (res) {
            var cargoes = res.data.data.slice(0, 100).map(function (cargo) {
                return {
                    _id: cargo._id,
                    name: cargo.name
                };
            });
            setDataSource(cargoes);
        }).catch(console.error);
    };
    var handleNewRequest = function handleNewRequest(cargo) {
        changeField({
            field: field + '.cargo',
            value: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(cargo)
        });
    };
    var handleDateChange = function handleDateChange(_e, date) {
        changeField({
            field: field + '.date',
            value: date ? new Date(date) : null
        });
    };
    Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
        if (!queryChanged && query !== cargo.cargo.name) {
            setQuery(cargo.cargo.name);
        }
    });
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete___default.a, {
            name: field + '.cargo',
            disabled: disabled,
            searchText: query,
            dataSource: dataSource,
            dataSourceConfig: { text: 'name', value: '_id' },
            onUpdateInput: handleUpdateInput,
            onNewRequest: handleNewRequest,
            filter: __WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete___default.a.noFilter,
            listStyle: { overflow: 'auto', maxHeight: '300px' },
            popoverProps: { canAutoPosition: true },
            underlineStyle: modifiedFields && modifiedFields.includes(field + '.cargo') ? underStyle : null,
            errorText: getError(field + '.cargo'),
            fullWidth: true
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { style: { display: 'flex' } },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_DatePicker___default.a, {
                autoOk: true,
                name: field + '.date',
                maxDate: new Date(),
                onChange: handleDateChange,
                value: cargo.date ? new Date(cargo.date) : null,
                formatDate: function formatDate(date) {
                    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('YYYY-MM-DD');
                },
                underlineStyle: modifiedFields && modifiedFields.includes(field + '.date') ? underStyle : null,
                errorText: getError(field + '.date'),
                fullWidth: true,
                style: { flex: '1 1 auto' }
            }),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,
                {
                    onClick: function onClick() {
                        return handleDateChange(null, null);
                    },
                    style: { flex: '0 0 auto', padding: '0', width: '24px', height: '24px', marginTop: '15px' }
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_clear___default.a, { color: '#9e9e9e' })
            )
        )
    );
}

/** @param {object} props */
function LastCargo(_ref2) {
    var disabled = _ref2.disabled,
        changeField = _ref2.changeField,
        getError = _ref2.getError,
        modifiedFields = _ref2.modifiedFields,
        underStyle = _ref2.underStyle,
        lastCargo = _ref2.lastCargo;

    var handleAddTank = function handleAddTank() {
        changeField({
            field: 'lastCargo',
            value: [].concat(_toConsumableArray(lastCargo), [__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(defaultTank)])
        });
    };
    var handleRemoveTank = function handleRemoveTank(index) {
        var value = lastCargo.slice();
        value.splice(index, 1);
        changeField({
            field: 'lastCargo',
            value: value
        });
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
        { selectable: false },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
            { adjustForCheckbox: false, displaySelectAll: false },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    { style: { width: '80px' } },
                    'Tank'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    null,
                    '1 Cargo'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    null,
                    '2 Cargo'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    null,
                    '3 Cargo'
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"], { style: { width: '80px' } })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
            { displayRowCheckbox: false },
            (lastCargo || []).map(function (tank, tankIndex) {
                return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                    { key: '' + tankIndex },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                        { style: { width: '80px' } },
                        tankIndex + 1
                    ),
                    tank.cargoes.map(function (cargo, cargoIndex) {
                        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { key: cargoIndex + '-' + cargo._id },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(LastCargoCell, {
                                field: 'lastCargo.' + tankIndex + '.cargoes.' + cargoIndex,
                                cargo: cargo,
                                disabled: disabled,
                                underStyle: underStyle,
                                modifiedFields: modifiedFields,
                                getError: getError,
                                changeField: changeField
                            })
                        );
                    }),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                        { style: { width: '80px' } },
                        tankIndex === 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,
                            {
                                onClick: handleAddTank,
                                style: { margin: '28px 0 0 8px' }
                            },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                        ),
                        tankIndex !== 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,
                            {
                                onClick: function onClick() {
                                    return handleRemoveTank(tankIndex);
                                },
                                style: { margin: '28px 0 0 8px' }
                            },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                        )
                    )
                );
            })
        )
    );
}

var _default = LastCargo;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(defaultCargo, 'defaultCargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/LastCargo.jsx');
    reactHotLoader.register(defaultTank, 'defaultTank', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/LastCargo.jsx');
    reactHotLoader.register(LastCargoCell, 'LastCargoCell', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/LastCargo.jsx');
    reactHotLoader.register(LastCargo, 'LastCargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/LastCargo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/LastCargo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Base_NumberField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_vesselRequirements__ = __webpack_require__(281);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














function fixPrecisionError(n) {
    if (n === '' || n === null || n === undefined) return n;

    var _n$toFixed$split = n.toFixed(10).split('.'),
        _n$toFixed$split2 = _slicedToArray(_n$toFixed$split, 2),
        int = _n$toFixed$split2[0],
        frac = _n$toFixed$split2[1];

    frac = ('.' + (frac || '')).replace(/0+$/g, '').replace(/\.$/g, '');
    return parseFloat(int + frac);
}

function PortStarboardTable(_ref) {
    var items = _ref.items,
        confirmed = _ref.confirmed,
        field = _ref.field,
        getError = _ref.getError,
        changeField = _ref.changeField,
        modifiedFields = _ref.modifiedFields,
        underStyle = _ref.underStyle,
        caption = _ref.caption;

    var handleAdd = function handleAdd() {
        var value = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(items);
        value.push({
            port: '',
            starboard: ''
        });
        changeField({ field: field, value: value });
    };
    var handleRemove = function handleRemove(index) {
        var newItems = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(items);
        newItems.splice(index, 1);
        changeField({ field: field, value: newItems });
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["Table"],
            {
                selectable: false,
                style: { border: '1px solid #DFDFDF' }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeader"],
                {
                    adjustForCheckbox: false,
                    displaySelectAll: false
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                        {
                            style: { textAlign: 'center', borderBottomWidth: '2px' },
                            colSpan: 2
                        },
                        caption
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                        { style: { textAlign: 'center', paddingLeft: '0', paddingRight: '0' } },
                        'Port, m3'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                        { style: { textAlign: 'center', paddingLeft: '0', paddingRight: '0' } },
                        'Starboard, m3'
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["Table"],
            {
                selectable: false,
                style: { border: '1px solid #DFDFDF' }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                items.map(function (_ref2, index) {
                    var port = _ref2.port,
                        starboard = _ref2.starboard;
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                        { key: index },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                            { style: {
                                    width: '25px', paddingLeft: '0', paddingRight: '0', textAlign: 'center'
                                }
                            },
                            index + 1
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                            { style: { paddingLeft: '5px', paddingRight: '5px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                                name: field + '[' + index + '].port',
                                value: port || '',
                                disabled: confirmed,
                                errorText: getError(field + '[' + index + '].port'),
                                fullWidth: true,
                                floatNumber: true,
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: field + '[' + index + '].port',
                                        value: value,
                                        type: 'number'
                                    });
                                },
                                underlineStyle: modifiedFields && modifiedFields.includes(field + '[' + index + '].port') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                            { style: { paddingLeft: '5px', paddingRight: '5px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                                name: field + '[' + index + '].starboard',
                                value: starboard || '',
                                disabled: confirmed,
                                errorText: getError(field + '[' + index + '].starboard'),
                                fullWidth: true,
                                floatNumber: true,
                                onChange: function onChange(e, value) {
                                    changeField({
                                        field: field + '[' + index + '].starboard',
                                        value: value,
                                        type: 'number'
                                    });
                                },
                                underlineStyle: modifiedFields && modifiedFields.includes(field + '[' + index + '].starboard') ? underStyle : null
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                            { style: { width: '50px', paddingLeft: 0, paddingRight: 0 } },
                            index === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                {
                                    disabled: confirmed,
                                    onClick: handleAdd
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                            ),
                            index !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                { onClick: function onClick() {
                                        return handleRemove(index);
                                    } },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                            )
                        )
                    );
                })
            )
        )
    );
}

/** @param {object} props */
function CapacityTanker(_ref3) {
    var capacityTanker = _ref3.capacityTanker,
        confirmed = _ref3.confirmed,
        getError = _ref3.getError,
        changeField = _ref3.changeField,
        modifiedFields = _ref3.modifiedFields,
        underStyle = _ref3.underStyle;
    var segregation = capacityTanker.segregation,
        details = capacityTanker.details,
        ttlCapacity = capacityTanker.ttlCapacity,
        cargoGrades = capacityTanker.cargoGrades,
        tanks = capacityTanker.tanks,
        slops = capacityTanker.slops,
        ballastTanks = capacityTanker.ballastTanks,
        cargoCapacity = capacityTanker.cargoCapacity,
        slopsCapacity = capacityTanker.slopsCapacity,
        ballastCapacity = capacityTanker.ballastCapacity,
        wholeTank = capacityTanker.wholeTank,
        coatingType = capacityTanker.coatingType,
        heating = capacityTanker.heating;

    var handleChangeItem = function handleChangeItem(change) {
        changeField(change);
        var c = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(capacityTanker);
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.set({ capacityTanker: c }, change.field, change.value);
        if (change.field.startsWith('capacityTanker.tanks')) {
            changeField({
                field: 'capacityTanker.cargoCapacity',
                value: fixPrecisionError(c.tanks.reduce(function (s, t) {
                    return s + (parseFloat(t.port) || 0) + (parseFloat(t.starboard) || 0);
                }, 0))
            });
        } else if (change.field.startsWith('capacityTanker.slops')) {
            changeField({
                field: 'capacityTanker.slopsCapacity',
                value: fixPrecisionError(c.slops.reduce(function (s, t) {
                    return s + (parseFloat(t.port) || 0) + (parseFloat(t.starboard) || 0);
                }, 0))
            });
        } else if (change.field.startsWith('capacityTanker.ballastTanks')) {
            changeField({
                field: 'capacityTanker.ballastCapacity',
                value: fixPrecisionError(c.ballastTanks.reduce(function (s, t) {
                    return s + (parseFloat(t.port) || 0) + (parseFloat(t.starboard) || 0);
                }, 0))
            });
        }
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.segregation',
                    floatingLabelText: 'Segregation, number',
                    value: segregation || '',
                    disabled: confirmed,
                    errorText: getError('capacityTanker.segregation'),
                    fullWidth: true,
                    floatNumber: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.segregation',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.segregation') ? underStyle : null
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                    name: 'capacityTanker.details',
                    floatingLabelText: 'Details',
                    value: details || '',
                    disabled: confirmed,
                    errorText: getError('capacityTanker.details'),
                    fullWidth: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.details',
                            value: value
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.details') ? underStyle : null
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.ttlCapacity',
                    floatingLabelText: 'TTL capacity (98%), m3',
                    value: ttlCapacity || '',
                    disabled: confirmed,
                    errorText: getError('capacityTanker.ttlCapacity'),
                    fullWidth: true,
                    floatNumber: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.ttlCapacity',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.ttlCapacity') ? underStyle : null
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.cargoGrades',
                    floatingLabelText: 'Cargo grades, num',
                    value: cargoGrades || '',
                    disabled: confirmed,
                    errorText: getError('capacityTanker.cargoGrades'),
                    fullWidth: true,
                    floatNumber: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.cargoGrades',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.cargoGrades') ? underStyle : null
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PortStarboardTable, {
                    items: tanks || [],
                    field: 'capacityTanker.tanks',
                    caption: 'Tanks',
                    confirmed: confirmed,
                    getError: getError,
                    changeField: handleChangeItem,
                    modifiedFields: modifiedFields,
                    underStyle: underStyle
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.cargoCapacity',
                    floatingLabelText: 'Cargo capacity (98%), m3',
                    value: cargoCapacity || '',
                    disabled: confirmed,
                    errorText: getError('capacityTanker.cargoCapacity'),
                    fullWidth: true,
                    floatNumber: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.cargoCapacity',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.cargoCapacity') ? underStyle : null
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PortStarboardTable, {
                    items: slops || [],
                    field: 'capacityTanker.slops',
                    caption: 'Slops',
                    confirmed: confirmed,
                    getError: getError,
                    changeField: handleChangeItem,
                    modifiedFields: modifiedFields,
                    underStyle: underStyle
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.slopsCapacity',
                    floatingLabelText: 'Slops capacity (98%), m3',
                    value: slopsCapacity || '',
                    disabled: confirmed,
                    errorText: getError('capacityTanker.slopsCapacity'),
                    fullWidth: true,
                    floatNumber: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.slopsCapacity',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.slopsCapacity') ? underStyle : null
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PortStarboardTable, {
                    items: ballastTanks || [],
                    field: 'capacityTanker.ballastTanks',
                    caption: 'Ballast tanks',
                    confirmed: confirmed,
                    getError: getError,
                    changeField: handleChangeItem,
                    modifiedFields: modifiedFields,
                    underStyle: underStyle
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.ballastCapacity',
                    floatingLabelText: 'Ballast capacity (98%), m3',
                    value: ballastCapacity || '',
                    disabled: confirmed,
                    errorText: getError('capacityTanker.ballastCapacity'),
                    fullWidth: true,
                    floatNumber: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.ballastCapacity',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.ballastCapacity') ? underStyle : null
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'name-block huge-name', style: { margin: '2em 0 0' } },
                    'TANK COATING'
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default.a, {
                    label: 'Whole Tank',
                    checked: !!wholeTank,
                    onCheck: function onCheck(e, value) {
                        return changeField({
                            field: 'capacityTanker.wholeTank',
                            value: value
                        });
                    },
                    style: { marginTop: '36px' }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                    {
                        value: coatingType,
                        disabled: confirmed,
                        onChange: function onChange(e, i, value) {
                            changeField({
                                field: 'capacityTanker.coatingType',
                                value: value
                            });
                        },
                        maxHeight: 200,
                        name: 'capacityTanker.coatingType',
                        floatingLabelText: 'Type',
                        fullWidth: true,
                        underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.coatingType') ? underStyle : null
                    },
                    [''].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__constants_vesselRequirements__["c" /* TANK_COATING_TYPES */])).map(function (name) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, {
                            key: name,
                            value: name,
                            primaryText: name
                        });
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'name-block huge-name', style: { margin: '2em 0 0' } },
                    'HEATING'
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                    {
                        value: heating.exchanger,
                        disabled: confirmed,
                        onChange: function onChange(e, i, value) {
                            changeField({
                                field: 'capacityTanker.heating.exchanger',
                                value: value
                            });
                        },
                        maxHeight: 200,
                        name: 'capacityTanker.heating.exchanger',
                        floatingLabelText: 'Heat Exchanger',
                        fullWidth: true,
                        underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.heating.exchanger') ? underStyle : null
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: null, primaryText: undefined }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: true, primaryText: 'Yes' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: false, primaryText: 'No' })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                    {
                        value: heating.medium,
                        disabled: confirmed || !heating.exchanger,
                        onChange: function onChange(e, i, value) {
                            changeField({
                                field: 'capacityTanker.heating.medium',
                                value: value
                            });
                        },
                        maxHeight: 200,
                        name: 'capacityTanker.heating.medium',
                        floatingLabelText: 'Heating medium',
                        fullWidth: true,
                        underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.heating.medium') ? underStyle : null
                    },
                    [''].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__constants_vesselRequirements__["a" /* HEATING_MEDIUM */])).map(function (name) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, {
                            key: name,
                            value: name,
                            primaryText: name
                        });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.heating.maxLoaded',
                    floatingLabelText: 'Max loaded \xB0C',
                    value: heating.maxLoaded,
                    disabled: confirmed || !heating.exchanger,
                    errorText: getError('capacityTanker.heating.maxLoaded'),
                    fullWidth: true,
                    floatNumber: true,
                    canBeNegative: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.heating.maxLoaded',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.heating.maxLoaded') ? underStyle : null
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_NumberField__["a" /* default */], {
                    name: 'capacityTanker.heating.maxMaintained',
                    floatingLabelText: 'Max maintained \xB0C',
                    value: heating.maxMaintained,
                    disabled: confirmed || !heating.exchanger,
                    errorText: getError('capacityTanker.heating.maxMaintained'),
                    fullWidth: true,
                    floatNumber: true,
                    canBeNegative: true,
                    onChange: function onChange(e, value) {
                        changeField({
                            field: 'capacityTanker.heating.maxMaintained',
                            value: value,
                            type: 'number'
                        });
                    },
                    underlineStyle: modifiedFields && modifiedFields.includes('capacityTanker.heating.maxMaintained') ? underStyle : null
                })
            )
        )
    );
}

var _default = CapacityTanker;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fixPrecisionError, 'fixPrecisionError', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CapacityTanker.jsx');
    reactHotLoader.register(PortStarboardTable, 'PortStarboardTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CapacityTanker.jsx');
    reactHotLoader.register(CapacityTanker, 'CapacityTanker', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CapacityTanker.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CapacityTanker.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Base_NumberField__ = __webpack_require__(63);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










var MAIN_LABELS = {
    bcm: 'BCM, m',
    scm: 'SCM, m',
    betweenManifolds: 'Between manifolds, m'

    /** @param {object} props */
};function Manifolds(_ref) {
    var confirmed = _ref.confirmed,
        changeField = _ref.changeField,
        getError = _ref.getError,
        underStyle = _ref.underStyle,
        modifiedFields = _ref.modifiedFields,
        manifolds = _ref.manifolds;

    var addRow = function addRow() {
        var list = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(manifolds.list);
        list.push({
            number: undefined,
            size: undefined,
            commonLine: undefined
        });
        changeField({ field: 'manifolds.list', value: list });
    };
    var removeRow = function removeRow(index) {
        var list = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(manifolds.list);
        list.splice(index, 1);
        changeField({ field: 'manifolds.list', value: list });
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            Object.entries(MAIN_LABELS).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    field = _ref3[0],
                    label = _ref3[1];

                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4', key: 'manifolds.' + field },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                        name: 'manifolds.' + field,
                        floatingLabelText: label,
                        value: manifolds[field] || '',
                        disabled: confirmed,
                        errorText: getError('manifolds.' + field),
                        fullWidth: true,
                        floatNumber: true,
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'manifolds.' + field,
                                value: value,
                                type: 'number'
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('manifolds.' + field) ? underStyle : null
                    })
                );
            })
        ),
        manifolds.list.map(function (_ref4, index) {
            var number = _ref4.number,
                size = _ref4.size,
                commonLine = _ref4.commonLine;
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'row', key: 'manifoldsList_' + index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                        name: 'manifolds.list[' + index + '].number',
                        floatingLabelText: 'Number',
                        value: number || '',
                        disabled: confirmed,
                        errorText: getError('manifolds.list[' + index + '].number'),
                        fullWidth: true,
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'manifolds.list[' + index + '].number',
                                value: value,
                                type: 'number'
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('manifolds.list[' + index + '].number') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Base_NumberField__["a" /* default */], {
                        name: 'manifolds.list[' + index + '].size',
                        floatingLabelText: 'Size, m',
                        value: size || '',
                        disabled: confirmed,
                        errorText: getError('manifolds.list[' + index + '].size'),
                        fullWidth: true,
                        floatNumber: true,
                        onChange: function onChange(e, value) {
                            changeField({
                                field: 'manifolds.list[' + index + '].size',
                                value: value,
                                type: 'number'
                            });
                        },
                        underlineStyle: modifiedFields && modifiedFields.includes('manifolds.list[' + index + '].size') ? underStyle : null
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_SelectField___default.a,
                        {
                            value: commonLine,
                            onChange: function onChange(e, i, value) {
                                changeField({
                                    field: 'manifolds.list[' + index + '].commonLine',
                                    value: value
                                });
                            },
                            disabled: confirmed,
                            name: 'manifolds.list[' + index + '].commonLine',
                            floatingLabelText: 'Common Line',
                            underlineStyle: modifiedFields && modifiedFields.includes('manifolds.list[' + index + '].commonLine') ? underStyle : null,
                            autoWidth: true,
                            fullWidth: true
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { value: null, primaryText: undefined }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { value: true, primaryText: 'Yes' }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_MenuItem___default.a, { value: false, primaryText: 'No' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-1' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { margin: '25px 0 0 0' } },
                        index === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                            {
                                disabled: confirmed,
                                onClick: addRow
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                        ),
                        index !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                            {
                                disabled: confirmed,
                                onClick: function onClick() {
                                    removeRow(index);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                        )
                    )
                )
            );
        })
    );
}

var _default = Manifolds;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MAIN_LABELS, 'MAIN_LABELS', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Manifolds.jsx');
    reactHotLoader.register(Manifolds, 'Manifolds', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Manifolds.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Manifolds.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_clear__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_search__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










/** @type {Record<string, import('react').CSSProperties>} */
var styles = {
    container: {
        maxHeight: '100px',
        overflowY: 'auto'
    },
    header: {
        border: '1px solid #E0E0E0',
        borderBottom: '0',
        background: '#F5F5F5',
        padding: '10px 8px',
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#333333',
        height: '32px',
        marginRight: '34px'
    },
    contentCol: {
        padding: '0'
    },
    content: {
        maxHeight: '282px',
        overflowY: 'auto',
        borderTop: '1px solid #DFDFDF',
        borderBottom: '1px solid #DFDFDF'
    },
    itemRow: {
        height: '28px',
        border: '1px solid #DFDFDF',
        borderBottom: '0',
        overflow: 'hidden'
    },
    itemCol: {
        padding: '8px',
        height: '28px',
        fontSize: '12px',
        lineHeight: '14px',
        marginRight: '34px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    inputCol: {
        position: 'relative',
        marginTop: '-1px',
        padding: '0 8px',
        height: '28px',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#9E9E9E',
        border: '1px solid #DFDFDF',
        marginRight: '34px'
    },
    actionsCol: {
        float: 'right',
        padding: '0',
        textAlign: 'center',
        width: '34px',
        height: '28px',
        fontSize: '12px',
        lineHeight: '14px',
        borderLeft: '1px solid #DFDFDF'
    },
    deleteBtn: {
        padding: '2px',
        width: '24px',
        height: '24px',
        lineHeight: '24px'
    },
    searchIcon: {
        position: 'absolute',
        top: '4px',
        left: '8px',
        width: '16px',
        height: '16px',
        pointerEvents: 'none',
        transform: 'scaleX(-100%)'
    },
    searchField: {
        border: '1px solid #E6E6E6',
        borderRadius: '12px',
        height: '24px',
        fontSize: '12px'
    },
    searchInput: {
        paddingLeft: '30px',
        paddingRight: '12px'
    }
};

function CertificateOfFitness(_ref) {
    var confirmed = _ref.confirmed,
        changeField = _ref.changeField,
        certificateOfFitness = _ref.certificateOfFitness;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),
        _useState2 = _slicedToArray(_useState, 2),
        query = _useState2[0],
        setQuery = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        dataSource = _useState4[0],
        setDataSource = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({
        filter: '',
        cargoes: certificateOfFitness
    }),
        _useState6 = _slicedToArray(_useState5, 2),
        _useState6$ = _useState6[0],
        filter = _useState6$.filter,
        cargoes = _useState6$.cargoes,
        setFilter = _useState6[1];

    var prevCertificateOfFitness = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(certificateOfFitness);
    });
    var handleUpdateInput = function handleUpdateInput(value) {
        setQuery(value);
        if (value.length < 2) return;
        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].getCargoNamesAutocomplete(value).then(function (res) {
            var cargoes = res.data.data.slice(0, 100).map(function (cargo) {
                return {
                    _id: cargo._id,
                    name: cargo.name
                };
            });
            setDataSource(cargoes);
        }).catch(console.error);
    };
    var updateFilter = function updateFilter(newFilter, newCargoes) {
        var lowerFilter = newFilter.toLowerCase();
        setFilter({
            filter: newFilter,
            cargoes: (newCargoes || certificateOfFitness).filter(function (cargo) {
                return cargo.name.toLowerCase().includes(lowerFilter);
            })
        });
    };
    var handleNewRequest = function handleNewRequest(newCargo) {
        // case when cargo selecting using 'enter'
        if (typeof newCargo === 'string') return;
        if (certificateOfFitness && certificateOfFitness.find(function (cargo) {
            return cargo._id === newCargo._id;
        })) {
            return;
        }
        var newCargoes = [].concat(_toConsumableArray(certificateOfFitness || []), [newCargo]);
        changeField({
            field: 'certificateOfFitness',
            value: newCargoes
        });
        setQuery('');
        updateFilter(filter, newCargoes);
    };
    var removeRow = function removeRow(id) {
        changeField({
            field: 'certificateOfFitness',
            value: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(certificateOfFitness || []).filter(function (cargo) {
                return cargo._id !== id;
            })
        });
    };
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"])(prevCertificateOfFitness.current, certificateOfFitness)) {
            prevCertificateOfFitness.current = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(certificateOfFitness);
            updateFilter(filter);
        }
    });
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { margin: '12px 0', position: 'relative' } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default.a, {
                        name: 'certOfFitFilter',
                        value: filter,
                        disabled: !confirmed,
                        fullWidth: true,
                        onChange: function onChange(e, value) {
                            updateFilter(value);
                        },
                        underlineShow: false,
                        style: styles.searchField,
                        inputStyle: styles.searchInput
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_search___default.a, { color: '#888', style: styles.searchIcon })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: styles.header },
                    'List of products'
                ),
                cargoes.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: styles.content },
                    cargoes.map(function (cargo) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { style: styles.itemRow, key: cargo._id },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { style: styles.actionsCol },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default.a,
                                    {
                                        disabled: !confirmed,
                                        onClick: function onClick() {
                                            return removeRow(cargo._id);
                                        },
                                        style: styles.deleteBtn
                                    },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_clear___default.a, { color: '#B2B2B2', hoverColor: '#a2a2a2' })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { style: styles.itemCol },
                                cargo.name
                            )
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: styles.inputCol },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                        name: 'query',
                        placeholder: 'Enter cargo\u2026',
                        disabled: !confirmed,
                        searchText: query,
                        dataSource: dataSource,
                        dataSourceConfig: { text: 'name', value: '_id' },
                        onUpdateInput: handleUpdateInput,
                        onNewRequest: handleNewRequest,
                        filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px' },
                        popoverProps: { canAutoPosition: true },
                        maxSearchResults: 50,
                        fullWidth: true,
                        underlineShow: false,
                        textFieldStyle: { height: '28px', fontSize: '12px' },
                        inputStyle: { color: '#999999' }
                    })
                )
            )
        )
    );
}

var _default = CertificateOfFitness;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CertificateOfFitness.jsx');
    reactHotLoader.register(CertificateOfFitness, 'CertificateOfFitness', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CertificateOfFitness.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/CertificateOfFitness.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_useDebounce__ = __webpack_require__(116);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






/**
 * 
 * @param {{ 
 *  getError: Function, 
 *  modifiedFields?: any, 
 *  underStyle?: any, 
 *  changeAutoComplete: Function,
 *  _registeredOwnerObject: { _id: string, name: string },
 *  confirmed?: boolean,
 * }} param0 
 * @returns 
 */
function RegisteredOwner(_ref) {
    var getError = _ref.getError,
        modifiedFields = _ref.modifiedFields,
        underStyle = _ref.underStyle,
        changeAutoComplete = _ref.changeAutoComplete,
        confirmed = _ref.confirmed,
        _registeredOwnerObject = _ref._registeredOwnerObject;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        companies = _useState2[0],
        setCompanies = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_registeredOwnerObject),
        _useState4 = _slicedToArray(_useState3, 2),
        registeredOwnerObject = _useState4[0],
        setRegisteredOwnerObject = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setRegisteredOwnerObject(_registeredOwnerObject);
    }, [_registeredOwnerObject._id]);

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_3_helpers_useDebounce__["a" /* default */])(registeredOwnerObject ? registeredOwnerObject.name : '', 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (debouncedSearchValue.length < 2) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].findCompany(debouncedSearchValue).then(function (response) {
            if (response.status === 200) {
                var foundCompanies = response.data.data.map(function (company) {
                    return {
                        name: company.name,
                        company: company
                    };
                });

                setCompanies(foundCompanies);
            }
        }).catch(function (error) {
            console.error('Error AutoComplete', error);

            return null;
        });
    }, [debouncedSearchValue]);

    var changeAutoCompete = function changeAutoCompete(searchText) {
        if (!searchText) {
            changeAutoComplete('registeredOwner', { _id: '', name: '' });
        }

        setRegisteredOwnerObject({
            _id: '', name: searchText
        });
    };

    var chooseAutoComplete = function chooseAutoComplete(updateProperties) {
        if (!updateProperties.company) return;
        setRegisteredOwnerObject(updateProperties.company);
        changeAutoComplete('registeredOwner', updateProperties.company);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
        name: 'registeredOwner',
        floatingLabelText: 'Ship Owner',
        disabled: confirmed,
        searchText: registeredOwnerObject.name,
        dataSource: companies,
        dataSourceConfig: { text: 'name', value: 'company' },
        onUpdateInput: changeAutoCompete,
        onNewRequest: chooseAutoComplete,
        filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
        errorText: getError('owner'),
        listStyle: { overflow: 'auto', maxHeight: '300px' },
        popoverProps: {
            canAutoPosition: true
        },
        fullWidth: true,

        underlineStyle: modifiedFields && modifiedFields.includes('owner') ? underStyle : null
    });
}

var _default = RegisteredOwner;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RegisteredOwner, 'RegisteredOwner', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisteredOwner.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisteredOwner.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Tank;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








function Tank(_ref) {
    var category = _ref.category,
        cargoPacking = _ref.cargoPacking,
        disabledAll = _ref.disabledAll,
        modifyFields = _ref.modifyFields,
        errors = _ref.errors;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(errors),
        _useState2 = _slicedToArray(_useState, 2),
        _errors = _useState2[0],
        set_errors = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        set_errors(errors);
    }, [errors]);

    var addDensity = function addDensity() {
        cargoPacking.pack.densities.push(Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('density'));

        modifyFields({
            field: 'packing.pack.densities',
            value: cargoPacking.pack.densities
        });
    };

    var removeDensity = function removeDensity(index) {
        cargoPacking.pack.densities.splice(index, 1);

        modifyFields({
            field: 'packing.pack.densities',
            value: cargoPacking.pack.densities
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        cargoPacking.pack.densities.map(function (densityData, dIndex) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'row',
                    style: { width: '100%' },
                    key: 'densityData__' + dIndex
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                        value: densityData.density || '',
                        hintText: 'Density, kg/m3',
                        floatingLabelText: 'Density, kg/m3',
                        disabled: disabledAll,
                        style: {
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px'
                        },
                        onChange: function onChange(e) {
                            return modifyFields({
                                field: 'packing.pack.densities[' + dIndex + '].density',
                                value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                            });
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                        value: densityData.temperature || '',
                        hintText: 'Temperature, \xB0C',
                        floatingLabelText: 'Temperature, \xB0C',
                        disabled: disabledAll,
                        style: {
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px'
                        },
                        onChange: function onChange(e) {
                            return modifyFields({
                                field: 'packing.pack.densities[' + dIndex + '].temperature',
                                value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                            });
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-1' },
                    !dIndex ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                        { disabled: disabledAll, style: { margin: '30px 0 0 0' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_add_circle_outline___default.a, {
                            onClick: function onClick() {
                                return !disabledAll && addDensity();
                            },
                            color: 'green'
                        })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                        { disabled: disabledAll, style: { margin: '30px 0 0 0' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                            onClick: function onClick() {
                                return !disabledAll && removeDensity(dIndex);
                            },
                            color: 'red'
                        })
                    )
                )
            );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'row',
                style: { width: '100%' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.pourPointMin', disabledAll),
                    disabled: disabledAll,
                    hintText: 'Pour Point min, \xB0C',
                    floatingLabelText: 'Pour Point min, \xB0C',
                    required: true,
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.pourPointMin',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.pourPointMax', disabledAll),
                    errorText: _errors.pourPointMax && _errors.pourPointMax.messages[0],
                    disabled: disabledAll,
                    hintText: 'Pour Point max, \xB0C',
                    floatingLabelText: 'Pour Point max, \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.pourPointMax',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.boilingPointMin', disabledAll),
                    disabled: disabledAll,
                    hintText: 'Boiling Point min, \xB0C',
                    floatingLabelText: 'Boiling Point min, \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.boilingPointMin',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.boilingPointMax', disabledAll),
                    errorText: _errors.boilingPointMax && _errors.boilingPointMax.messages[0],
                    disabled: disabledAll,
                    hintText: 'Boiling Point max, \xB0C',
                    floatingLabelText: 'Boiling Point max, \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.boilingPointMax',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'row',
                style: { width: '100%' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.meltingPointMin', disabledAll),
                    disabled: disabledAll,
                    hintText: 'Melting Point min, \xB0C',
                    floatingLabelText: 'Melting Point min, \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.meltingPointMin',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.meltingPointMax', disabledAll),
                    errorText: _errors.meltingPointMax && _errors.meltingPointMax.messages[0],
                    disabled: disabledAll,
                    hintText: 'Melting Point max, \xB0C',
                    floatingLabelText: 'Melting Point max, \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.meltingPointMax',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["b" /* Checkbox */], {
                    label: 'Flammable',
                    checked: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.flammable', disabledAll, false),
                    disabled: disabledAll,
                    onCheck: function onCheck() {
                        return modifyFields({
                            field: 'packing.pack.flammable',
                            value: !cargoPacking.pack.flammable
                        });
                    },
                    style: {
                        marginTop: '28px'
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.flashPointMin', disabledAll),
                    disabled: !cargoPacking.pack.flammable || disabledAll,
                    hintText: 'Flash Point, \xB0C',
                    floatingLabelText: 'Flash Point, \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.flashPointMin',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'row',
                style: { width: '100%' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'col-xs-3',
                    style: { height: '48px', display: 'flex', alignItems: 'center' }
                },
                'HEATING'
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'row',
                style: { width: '100%' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.voyageHeatMin', disabledAll),
                    disabled: disabledAll,
                    hintText: 'Voyage Heat, min \xB0C',
                    floatingLabelText: 'Voyage Heat, min \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.voyageHeatMin',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.voyageHeatMax', disabledAll),
                    errorText: _errors.voyageHeatMax && _errors.voyageHeatMax.messages[0],
                    disabled: disabledAll,
                    hintText: 'Voyage Heat, max \xB0C',
                    floatingLabelText: 'Voyage Heat, max \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.voyageHeatMax',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.loadingHeatMin', disabledAll),
                    disabled: disabledAll,
                    hintText: 'Loading Heat, min \xB0C',
                    floatingLabelText: 'Loading Heat, min \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.loadingHeatMin',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.loadingHeatMax', disabledAll),
                    errorText: _errors.loadingHeatMax && _errors.loadingHeatMax.messages[0],
                    disabled: disabledAll,
                    hintText: 'Loading Heat, max \xB0C',
                    floatingLabelText: 'Loading Heat, max \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.loadingHeatMax',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'row',
                style: { width: '100%', height: '92px' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.dischargeHeatMin', disabledAll),
                    disabled: disabledAll,
                    hintText: 'Discharge Heat, min \xB0C',
                    floatingLabelText: 'Discharge Heat, min \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.dischargeHeatMin',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.dischargeHeatMax', disabledAll),
                    errorText: _errors.dischargeHeatMax && _errors.dischargeHeatMax.messages[0],
                    disabled: disabledAll,
                    hintText: 'Discharge Heat, max \xB0C',
                    floatingLabelText: 'Discharge Heat, max \xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.dischargeHeatMax',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.maxAdjacentHeat', disabledAll),
                    disabled: disabledAll,
                    hintText: 'Max Adjacent Heat,\xB0C',
                    floatingLabelText: 'Max Adjacent Heat,\xB0C',
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields({
                            field: 'packing.pack.maxAdjacentHeat',
                            value: __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].clearLetters(e.target.value)
                        });
                    }
                })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Tank, 'Tank', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Tank.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidateFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fieldsMap; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var fieldsMap = {
    pourPoint: {
        min: 'pourPointMin',
        max: 'pourPointMax'
    },
    boilingPoint: {
        min: 'boilingPointMin',
        max: 'boilingPointMax'
    },
    meltingPoint: {
        min: 'meltingPointMin',
        max: 'meltingPointMax'
    },
    voyageHeat: {
        min: 'voyageHeatMin',
        max: 'voyageHeatMax'
    },
    loadingHeat: {
        min: 'loadingHeatMin',
        max: 'loadingHeatMax'
    },
    dischargeHeat: {
        min: 'dischargeHeatMin',
        max: 'dischargeHeatMax'
    },
    numberOfHeads: {
        min: 'numberOfHeadsMin',
        max: 'numberOfHeadsMax'
    },
    moisture: {
        min: 'moistureMin',
        max: 'moistureMax'
    },
    temperature: {
        min: 'temperatureMin',
        max: 'temperatureMax'
    }
};

var getValidateFields = function getValidateFields(fieldName) {
    var initialName = fieldName.replace('packing.pack.', '').replace('Min', '').replace('Max', '');

    return fieldsMap[initialName];
};


;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fieldsMap, 'fieldsMap', '/opt/atlassian/pipelines/agent/build/client/app/constants/validateFields.js');
    reactHotLoader.register(getValidateFields, 'getValidateFields', '/opt/atlassian/pipelines/agent/build/client/app/constants/validateFields.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = FormInputCol;
/* harmony export (immutable) */ __webpack_exports__["a"] = FormInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormField__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormCheckbox__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormSelect__ = __webpack_require__(855);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var inputsByType = {
    number: __WEBPACK_IMPORTED_MODULE_2__FormField__["b" /* FormField */],
    checkbox: __WEBPACK_IMPORTED_MODULE_3__FormCheckbox__["a" /* FormCheckbox */],
    select: __WEBPACK_IMPORTED_MODULE_4__FormSelect__["a" /* FormSelect */],
    'select-fitted': __WEBPACK_IMPORTED_MODULE_4__FormSelect__["a" /* FormSelect */]
};

function FormInputCol(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'col-xs-3 flexed' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FormInput, props)
    );
}

function FormInput(props) {
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var conf = form.config[props.name];
    var Component = inputsByType[conf.type] || conf.render;
    if (Component) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, _extends({ form: form }, props));
    }

    throw new Error('Form input type ' + props.name + ' is not supported');
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(inputsByType, 'inputsByType', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormInput.jsx');
    reactHotLoader.register(FormInputCol, 'FormInputCol', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormInput.jsx');
    reactHotLoader.register(FormInput, 'FormInput', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormInput.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = FormField;
/* harmony export (immutable) */ __webpack_exports__["a"] = Field;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_NumberField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function FormField(_ref) {
    var name = _ref.name,
        rest = _objectWithoutProperties(_ref, ['name']);

    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var conf = form.config[name] || {};
    var value = form.values[name];
    var error = form.errors[name];

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Field, _extends({
        name: name,
        value: value,
        onChange: form.onChange,
        type: conf.type,
        label: conf.label,
        required: conf.required,
        error: error,
        disabled: conf.disabled && conf.disabled(form)
    }, rest));
}

function Field(_ref2) {
    var value = _ref2.value,
        label = _ref2.label,
        error = _ref2.error,
        rest = _objectWithoutProperties(_ref2, ['value', 'label', 'error']);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Base_NumberField__["a" /* default */], _extends({
        value: value === null || value === undefined ? '' : value,
        floatingLabelText: label,
        fullWidth: true,
        floatingLabelStyle: error ? { color: '#f44336' } : {},
        className: error && 'hasValidationError',
        errorText: error
    }, rest));
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FormField, 'FormField', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormField.jsx');
    reactHotLoader.register(Field, 'Field', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormField.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Select; });
/* harmony export (immutable) */ __webpack_exports__["a"] = FormSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var styles = {
    infoIcon: {
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        margin: '-3px 0 0 0.5em',
        color: '#dadada',
        cursor: 'pointer'
    }
};

var fittedOptions = [{ value: null, label: undefined }, { value: true, label: 'Yes' }, { value: false, label: 'No' }];

function FormSelect(_ref) {
    var name = _ref.name,
        rest = _objectWithoutProperties(_ref, ['name']);

    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var conf = form.config[name] || {};
    var value = form.values[name];

    var confOptions = conf.type === 'select-fitted' ? fittedOptions : conf.options;
    var first = confOptions[0];
    var options = first && (typeof first === 'undefined' ? 'undefined' : _typeof(first)) === 'object' ? confOptions : confOptions.map(function (option) {
        return { value: option, label: option };
    });

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Select, _extends({
        name: name,
        value: value,
        label: conf.label,
        onChange: form.onChange,
        disabled: conf.disabled && conf.disabled(form),
        options: options
    }, rest));
}

function Select(_ref2) {
    var name = _ref2.name,
        label = _ref2.label,
        hint = _ref2.hint,
        value = _ref2.value,
        options = _ref2.options,
        _onChange = _ref2.onChange,
        rest = _objectWithoutProperties(_ref2, ['name', 'label', 'hint', 'value', 'options', 'onChange']);

    var first = options[0];
    options = first && (typeof first === 'undefined' ? 'undefined' : _typeof(first)) === 'object' ? options : options.map(function (option) {
        return { value: option, label: option };
    });

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
        _extends({
            name: name,
            value: value || '',
            onChange: function onChange(_e, _i, val) {
                return _onChange({ field: name, value: val });
            },
            floatingLabelText: hint ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,
                null,
                label,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'span',
                    { 'data-tip': hint, style: { pointerEvents: 'all' } },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info___default.a, { style: styles.infoIcon })
                )
            ) : label,
            fullWidth: true,
            autoWidth: true
        }, rest),
        options.map(function (option, index) {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], {
                key: index,
                value: option.value,
                primaryText: option.label
            });
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormSelect.jsx');
    reactHotLoader.register(fittedOptions, 'fittedOptions', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormSelect.jsx');
    reactHotLoader.register(FormSelect, 'FormSelect', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormSelect.jsx');
    reactHotLoader.register(Select, 'Select', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormSelect.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegisterClassMultiNoRedux; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_react_utils__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_add_circle_outline__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














var styles = {
    add: {
        display: 'flex',
        justifyContent: 'center'
    },
    chips: {
        margin: '8px 8px 0 0'
    }
};

var getDefaultRegisterClass = function getDefaultRegisterClass() {
    return {
        _id: null,
        excluded: false,
        iacsRegister: false,
        name: null,
        registerClass: null
    };
};

function RegisterClassMulti(_ref) {
    var _this = this;

    var numberOrderTable = _ref.numberOrderTable,
        tcOrder = _ref.tcOrder,
        updateTcOrder = _ref.updateTcOrder,
        captureSaveHandler = _ref.captureSaveHandler;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        classes = _useState2[0],
        setClasses = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(getDefaultRegisterClass()),
        _useState4 = _slicedToArray(_useState3, 2),
        selectedClass = _useState4[0],
        setselectedClass = _useState4[1];

    var _useRefState = Object(__WEBPACK_IMPORTED_MODULE_7_helpers_react_utils__["a" /* useRefState */])(''),
        _useRefState2 = _slicedToArray(_useRefState, 3),
        search = _useRefState2[0],
        setSearch = _useRefState2[1],
        searchRef = _useRefState2[2];

    var changeAutoComplete = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchText) {
            var classes;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setSearch(searchText);

                            if (!(searchText.length < 2)) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt('return');

                        case 3:
                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].findClasses(searchText);

                        case 5:
                            classes = _context.sent;

                            if (!(searchRef.current !== searchText)) {
                                _context.next = 8;
                                break;
                            }

                            return _context.abrupt('return');

                        case 8:

                            if (classes.status === 200) {
                                setClasses(classes.data.data);
                            }

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function changeAutoComplete(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var chooseAutoComplete = function chooseAutoComplete(selected) {
        setselectedClass(_extends({}, getDefaultRegisterClass(), selected));
    };

    var addRegisterClass = function addRegisterClass() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$ignoreAny = _ref3.ignoreAny,
            ignoreAny = _ref3$ignoreAny === undefined ? false : _ref3$ignoreAny;

        var _tcOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(tcOrder);
        var _id = selectedClass._id,
            iacsRegister = selectedClass.iacsRegister,
            name = selectedClass.name;


        if (!_id && ignoreAny) return _tcOrder.vesselRequirements.registerClasses;

        if (Array.isArray(_tcOrder.vesselRequirements.registerClasses)) {
            var alreadyExists = _tcOrder.vesselRequirements.registerClasses.findIndex(function (i) {
                return i._id === _id && i.iacsRegister === iacsRegister && i.name === name;
            });

            if (alreadyExists < 0) {
                _tcOrder.vesselRequirements.registerClasses.push(selectedClass);
                updateTcOrder(numberOrderTable, _tcOrder);
            }
        } else {
            _tcOrder.vesselRequirements.registerClasses = [selectedClass];
            updateTcOrder(numberOrderTable, _tcOrder);
        }

        setselectedClass(getDefaultRegisterClass());
        setSearch('');

        return _tcOrder.vesselRequirements.registerClasses;
    };

    // captureSaveHandler doesn't work correctly otherwise
    var addRegisterClassRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    addRegisterClassRef.current = addRegisterClass;

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (captureSaveHandler) {
            captureSaveHandler(function (values) {
                values.registerClasses = addRegisterClassRef.current({ ignoreAny: true });
            });
        }
    }, []);

    var deleteRegisterClass = function deleteRegisterClass(index) {
        var _tcOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(tcOrder);

        _tcOrder.vesselRequirements.registerClasses.splice(index, 1);

        updateTcOrder(numberOrderTable, _tcOrder);
    };

    var changeSelected = function changeSelected(field, value) {
        setselectedClass(_extends({}, selectedClass, _defineProperty({}, field, value)));
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row', style: { height: '72px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a, {
                    name: 'cargoName',
                    textFieldStyle: { fontSize: '16px' },
                    hintText: 'Register classes',
                    searchText: search || selectedClass.name || '',
                    dataSource: classes,
                    dataSourceConfig: { text: 'name', value: 'item' },
                    onUpdateInput: function onUpdateInput(value) {
                        return changeAutoComplete(value);
                    },
                    onNewRequest: function onNewRequest(value) {
                        return chooseAutoComplete(value);
                    },
                    filter: __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a.noFilter,
                    listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                    menuStyle: { width: 'auto' },
                    popoverProps: {
                        canAutoPosition: true
                    },
                    fullWidth: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["b" /* Checkbox */], {
                    label: 'IACS register',
                    iconStyle: { marginRight: '5px' },
                    checked: selectedClass && selectedClass.iacsRegister,
                    onCheck: function onCheck() {
                        return changeSelected('iacsRegister', !selectedClass.iacsRegister);
                    },
                    disabled: !!selectedClass._id
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["b" /* Checkbox */], {
                    label: 'Excluded',
                    iconStyle: { marginRight: '5px' },
                    checked: selectedClass.excluded,
                    onCheck: function onCheck() {
                        return changeSelected('excluded', !selectedClass.excluded);
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-1' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_material_ui__["h" /* IconButton */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_add_circle_outline___default.a, {
                        onClick: addRegisterClass,
                        color: 'green'
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-12', style: { display: 'flex', flexFlow: 'wrap' } },
                tcOrder.vesselRequirements.registerClasses && tcOrder.vesselRequirements.registerClasses.map(function (registerClass, index) {
                    var backgroundColor = registerClass.excluded ? '#e6e6e6' : '#d6edbd';
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8_material_ui__["c" /* Chip */],
                        {
                            key: 'cgo_' + index,
                            onRequestDelete: function onRequestDelete() {
                                return deleteRegisterClass(index);
                            },
                            style: _extends({}, styles.chips, { backgroundColor: backgroundColor, whiteSpace: 'initial' })
                        },
                        registerClass.iacsRegister && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            '(IACS)'
                        ),
                        registerClass.excluded && ' - ',
                        '' + (registerClass.name || 'Any')
                    );
                })
            )
        )
    );
}

var RegisterClassMultiNoRedux = RegisterClassMulti;

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_4_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(RegisterClassMulti);

/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClassMulti.jsx');
    reactHotLoader.register(getDefaultRegisterClass, 'getDefaultRegisterClass', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClassMulti.jsx');
    reactHotLoader.register(RegisterClassMulti, 'RegisterClassMulti', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClassMulti.jsx');
    reactHotLoader.register(RegisterClassMultiNoRedux, 'RegisterClassMultiNoRedux', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClassMulti.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/RegisterClassMulti.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_annotations__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectedTextPopup__ = __webpack_require__(1976);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var AnnotationEditor = function (_React$Component) {
    _inherits(AnnotationEditor, _React$Component);

    function AnnotationEditor(props) {
        _classCallCheck(this, AnnotationEditor);

        var _this = _possibleConstructorReturn(this, (AnnotationEditor.__proto__ || Object.getPrototypeOf(AnnotationEditor)).call(this, props));

        _this.state = {
            renderContent: [],
            openPopover: false
        };

        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.closePopover = _this.closePopover.bind(_this);
        return _this;
    }

    _createClass(AnnotationEditor, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            var letterText = newProps.letterText,
                annotations = newProps.annotations;


            if (letterText && annotations.length > 0) {
                var clearedAnnotations = this.clearUnusefullWords(annotations);
                var sortedAnnotations = this.sortForLongerAnnotate(clearedAnnotations);

                this.createRenderedContent(letterText, sortedAnnotations);
            } else {
                this.setState({
                    renderContent: undefined,
                    tooltips: undefined
                });
            }
        }
    }, {
        key: 'sortForLongerAnnotate',
        value: function sortForLongerAnnotate(annotations) {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(annotations, function (a, b) {
                return -a.features.string.length;
            });
        }
    }, {
        key: 'clearUnusefullWords',
        value: function clearUnusefullWords(annotations) {
            var array = annotations.filter(function (annotation) {
                return annotation.type !== 'Lookup' && annotation.type !== 'Sentence' && annotation.type !== 'Split' && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(annotation, 'features.rule') && annotation.features.rule.toLowerCase().includes('saf') && annotation.type.toLowerCase().includes('cargoannotation');
            });

            var map = new Map();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    var key = item.type + "-" + item.features.rule + "-" + item.start + "-" + item.end;
                    map.set(key, item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return Array.from(map.values());
        }
    }, {
        key: 'createRenderedContent',
        value: function createRenderedContent(letterText, annotations) {
            var renderContent = letterText.split('');

            renderContent = renderContent.map(function (symbol, symbolPosition) {
                symbol = symbol === ' ' ? '\xA0' : symbol;
                return {
                    symbol: symbol,
                    symbolPosition: symbolPosition,
                    style: {},
                    ids: [],
                    tooltipContent: []
                };
            });

            for (var i = 0; i < annotations.length; i++) {
                var hashColor = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].createHashColor();
                for (var j = annotations[i].start; j < annotations[i].end; j++) {
                    if (renderContent[j]) {
                        renderContent[j].style = {
                            background: hashColor
                        };
                        renderContent[j].ids.push(annotations[i].id);
                        renderContent[j].tooltipContent.push({
                            rule: annotations[i].features.rule,
                            type: annotations[i].type
                        });
                    } else {
                        console.warn('Wrong list of annotations. Please reannotate letter.');
                    }
                }
            }

            var tooltips = this.createTooltips(renderContent);

            this.setState({
                renderContent: renderContent,
                tooltips: tooltips
            });
        }
    }, {
        key: 'createTooltips',
        value: function createTooltips(characters) {
            var map = new Map();
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = characters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var char = _step2.value;

                    map.set(char.ids.join(''), char);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return Array.from(map.values());
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp(ev) {
            var range = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].getSelection(ev.target.parentNode);

            if (range.start === range.end) {
                return;
            }

            var hashColor = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].createHashColor();
            var renderContent = this.state.renderContent.slice(0);

            renderContent.forEach(function (el) {
                if (el.position >= range.start && el.position < range.end) {
                    renderContent.push({
                        style: {
                            background: hashColor
                        }
                    });
                }
            });

            this.setState({
                renderContent: renderContent,
                openPopover: true,
                anchorEl: ev.target,
                chosenText: range.string
            });
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.setState({
                openPopover: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                openPopover = _state.openPopover,
                anchorEl = _state.anchorEl,
                chosenText = _state.chosenText;
            var _props = this.props,
                annotations = _props.annotations,
                letterText = _props.letterText;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelectedTextPopup__["a" /* default */], {
                    openPopover: openPopover,
                    anchorEl: anchorEl,
                    closePopover: this.closePopover,
                    chosenText: chosenText
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'letter-text', onMouseUp: this.onMouseUp },
                    this.state.renderContent ? Array.from(Object(__WEBPACK_IMPORTED_MODULE_6_helpers_annotations__["b" /* letterMapper */])(this.state.renderContent)) : letterText
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_helpers_annotations__["a" /* AnnotationTooltip */], { tooltips: this.state.tooltips, renderTooltip: function renderTooltip(tooltip) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'tooltip-row' },
                            tooltip.tooltipContent.map(function (t, k) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { key: k, className: 'tooltip-column' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col' },
                                        'Rule - ' + t.rule + ', '
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col' },
                                        'Type - ' + t.type
                                    )
                                );
                            })
                        );
                    } })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var annotations = _ref.annotations.items;
    var letterText = _ref2.letterText;

    return {
        letterText: letterText,
        annotations: annotations
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationEditor);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationEditor, 'AnnotationEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/AnnotationsEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/AnnotationsEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AnnotationsList = function (_React$Component) {
    _inherits(AnnotationsList, _React$Component);

    function AnnotationsList(props) {
        _classCallCheck(this, AnnotationsList);

        var _this = _possibleConstructorReturn(this, (AnnotationsList.__proto__ || Object.getPrototypeOf(AnnotationsList)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            annotations: _this.props.annotations,
            searchText: ''
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }

    _createClass(AnnotationsList, [{
        key: 'filterAnnotations',
        value: function filterAnnotations(searchArray, searchText) {
            searchText = searchText.toLowerCase();

            return searchArray.filter(function (annotation) {
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(annotation, 'features.rule') && annotation.features.rule.toLowerCase().includes(searchText)) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(annotation, 'features.majorType') && annotation.features.majorType.toLowerCase().includes(searchText)) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(annotation, 'features.string') && annotation.features.string.toLowerCase().includes(searchText)) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(annotation, 'type') && annotation.type.toLowerCase().includes(searchText)) {
                    return true;
                }

                if (annotation.id) {
                    var id = annotation.id + '';
                    if (id.includes(searchText)) {
                        return true;
                    }
                }

                return false;
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            var _this2 = this;

            if (props.annotations.length) {
                this.setState({
                    annotations: props.annotations,
                    total: props.annotations.length
                }, function () {
                    _this2.handleUpdateRow(_this2.state);
                });
            }
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            var _this3 = this;

            var annotations = this.filterAnnotations(this.props.annotations, e.target.value);

            this.setState({
                annotations: annotations,
                total: annotations.length
            }, function () {
                _this3.handleUpdateRow(_this3.state);
            });
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.annotations.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var renderComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'annotations-list-b', style: { height: '40vh' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default.a, {
                        className: this.props.isLoaded ? 'hidden' : '',
                        style: {
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)'
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? 'navigation' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-arrows' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                            total: this.state.annotations.length,
                            rowsPerPage: this.state.rowsPerPage,
                            page: this.state.page,
                            numberOfRows: this.state.numberOfRows,
                            updateRows: this.handleUpdateRow
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-search' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                            hintText: 'Search',
                            hintStyle: { fontSize: 12 },
                            style: { fontSize: 12 },
                            onChange: this.handleSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-info' },
                        'Total annotations: ',
                        this.state.annotations.length
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? 'annotations-table' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeader"],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                                { style: { height: '28px' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Value'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Rule'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Type'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'MajorType'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'id'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                            { displayRowCheckbox: false },
                            this.state.rows.map(function (annotation, i) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                                    { style: { height: '28px' }, key: i },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.string
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.rule
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.type
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.majorType
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.id
                                    )
                                );
                            })
                        )
                    )
                )
            );
            var renderError = 'Something wrong with request';

            if (this.props.isError) {
                renderComponent = null;
            } else {
                renderError = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                renderComponent,
                renderError
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        annotations: state.annotations.items,
        isLoaded: state.annotations.isLoaded,
        error: state.annotations.error,
        isError: state.annotations.isError
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationsList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationsList, 'AnnotationsList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/AnnotationsList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/AnnotationsList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var HtmlContent = function HtmlContent(_ref) {
    var letter = _ref.letter;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        isOpenDialog: false
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var toggleDialog = function toggleDialog() {
        setState(function (prevState) {
            return _extends({}, prevState, {
                isOpenDialog: !prevState.isOpenDialog
            });
        });
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
        label: 'CLOSE',
        primary: true,
        onClick: toggleDialog
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
            onClick: toggleDialog,
            disabled: !letter.html,
            label: 'HTML',
            labelStyle: { fontSize: '10px' },
            style: { height: '25px' },
            buttonStyle: { height: '25px', lineHeight: '25px' },
            primary: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
            {
                title: 'HTML',
                actions: actions,
                modal: false,
                contentStyle: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].Dialog,
                open: state.isOpenDialog,
                onRequestClose: toggleDialog
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
                title: 'HTML Content',
                srcDoc: letter.html,
                sandbox: '',
                style: {
                    overflow: 'auto',
                    border: 'none',
                    width: '100%',
                    height: '65vh'
                },
                frameBorder: '0'
            })
        )
    );
};

var _default = HtmlContent;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HtmlContent, 'HtmlContent', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/HtmlContent.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/HtmlContent.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px'
        }
    }
};

var TextEditor = function (_React$Component) {
    _inherits(TextEditor, _React$Component);

    function TextEditor(props) {
        _classCallCheck(this, TextEditor);

        var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));

        _this.state = {
            open: false,
            textLetter: props.textLetter,
            originalText: props.originalText
        };

        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.changeTextLetterText = _this.changeTextLetterText.bind(_this);
        _this.returnOriginalText = _this.returnOriginalText.bind(_this);
        _this.updateGazetters = _this.updateGazetters.bind(_this);
        return _this;
    }

    _createClass(TextEditor, [{
        key: 'returnOriginalText',
        value: function returnOriginalText() {
            this.setState({
                textLetter: this.props.originalText
            });
        }
    }, {
        key: 'updateGazetters',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var textLetter;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                textLetter = this.state.textLetter;

                                if (!textLetter) {
                                    _context.next = 8;
                                    break;
                                }

                                this.toggleDialog();

                                this.props.removeAnnotations();
                                this.props.removeGazetters();
                                _context.next = 7;
                                return this.props.getLetterData(textLetter);

                            case 7:
                                this.props.updatePostGazetters(textLetter);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateGazetters() {
                return _ref.apply(this, arguments);
            }

            return updateGazetters;
        }()
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                textLetter: nextProps.textLetter,
                originalText: nextProps.originalText
            });
        }
    }, {
        key: 'changeTextLetterText',
        value: function changeTextLetterText(e) {
            this.setState({
                textLetter: e.target.value
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            var open = this.state.open;

            this.setState({
                open: !open
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                textLetter = _state.textLetter,
                open = _state.open;

            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RE-ANNOTATE',
                primary: true,
                onClick: this.updateGazetters
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RETURN ORIGINAL TEXT',
                primary: true,
                onClick: this.returnOriginalText
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'CLOSE',
                primary: true,
                onClick: this.toggleDialog
            })];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    label: 'Editor',
                    labelStyle: styles.button.labelStyle,
                    style: styles.button.style,
                    buttonStyle: styles.button.buttonStyle,
                    onClick: this.toggleDialog,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
                    {
                        title: 'Edit letter text',
                        actions: actions,
                        contentStyle: styles.dialog.contentStyle,
                        open: open,
                        modal: true
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                        style: styles.textarea.style,
                        value: textLetter,
                        onChange: this.changeTextLetterText
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TextEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TextEditor;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/TextEditor.jsx');
    reactHotLoader.register(TextEditor, 'TextEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/TextEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/TextEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false,
            info: {},
            error: {}
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            this.setState({
                hasError: true,
                info: info,
                error: error
            });
        }
    }, {
        key: "render",
        value: function render() {
            var hasError = this.state.hasError;


            if (hasError) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "react-error" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h1",
                        null,
                        "Something went wrong"
                    )
                );
            }

            return this.props.children;
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ErrorBoundary;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/ErrorBoundary.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/ErrorBoundary.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getTermEntities;
/* unused harmony export getTermEntitiesResponse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getTermEntities() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].REQUEST
    };
}

function getTermEntitiesResponse(data) {
    if (data) {
        return {
            type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].SUCCESS,
            data: data
        };
    }

    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].FAILURE
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getTermEntities, 'getTermEntities', '/opt/atlassian/pipelines/agent/build/client/app/actions/termEntities.js');
    reactHotLoader.register(getTermEntitiesResponse, 'getTermEntitiesResponse', '/opt/atlassian/pipelines/agent/build/client/app/actions/termEntities.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getContracts;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTimeContracts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getContracts() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_23" /* GET_CONTRACTS */].REQUEST
    };
}

function getTimeContracts() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_53" /* GET_TIME_CONTRACTS */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getContracts, 'getContracts', '/opt/atlassian/pipelines/agent/build/client/app/actions/contracts.js');
    reactHotLoader.register(getTimeContracts, 'getTimeContracts', '/opt/atlassian/pipelines/agent/build/client/app/actions/contracts.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_query__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_configureStore__ = __webpack_require__(50);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();














var ArchiveLetter = function ArchiveLetter(_ref) {
    var router = _ref.router,
        letter = _ref.letter;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isPopupOpen = _useState2[0],
        setPopupOpen = _useState2[1];

    var archiveMutation = Object(__WEBPACK_IMPORTED_MODULE_2_react_query__["useMutation"])(function () {
        return __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].sendLetterToArchive(letter._id);
    }, {
        onSuccess: function onSuccess(response) {
            if (response.status) {
                router.push('/');
            }
        },
        onError: function onError(error) {
            console.error('Failed to archive letter:', error);
            __WEBPACK_IMPORTED_MODULE_9_store_configureStore__["d" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_actions_notifications_notifications__["a" /* addNotification */])({
                title: 'Error',
                message: 'Failed to send letter to archive.',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 3
            }));
        }
    });

    var handleSendToArchive = function handleSendToArchive() {
        archiveMutation.mutate();
    };

    var togglePopup = function togglePopup() {
        return setPopupOpen(!isPopupOpen);
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
        label: 'Cancel',
        primary: true,
        onClick: togglePopup
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
        label: 'Send',
        secondary: true,
        onClick: handleSendToArchive,
        disabled: archiveMutation.isLoading
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
            labelStyle: { fontSize: '10px' },
            style: { height: '25px' },
            buttonStyle: { height: '25px', lineHeight: '25px' },
            label: archiveMutation.isLoading ? 'Sending...' : 'Send to archive',
            onClick: togglePopup,
            secondary: true,
            disabled: archiveMutation.isLoading
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default.a,
            {
                title: 'Send letter to archive?',
                actions: actions,
                open: isPopupOpen,
                onRequestClose: togglePopup
            },
            'This letter will be sent to the archive.'
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        letter: state.letter
    };
})(ArchiveLetter));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ArchiveLetter, 'ArchiveLetter', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/ArchiveLetter.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/ArchiveLetter.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getEmptyImage = exports.NativeTypes = undefined;
exports.default = createHTML5Backend;

var _HTML5Backend = __webpack_require__(2002);

var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);

var _getEmptyImage = __webpack_require__(2008);

var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);

var _NativeTypes = __webpack_require__(533);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NativeTypes = NativeTypes;
exports.getEmptyImage = _getEmptyImage2.default;
function createHTML5Backend(manager) {
	return new _HTML5Backend2.default(manager);
}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(484),
    baseRest = __webpack_require__(136),
    isArrayLikeObject = __webpack_require__(265);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = exports.isFirefox = undefined;

var _memoize = __webpack_require__(672);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
  return (/firefox/i.test(navigator.userAgent)
  );
});
var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
  return Boolean(window.safari);
});

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = DragDropContext;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dndCore = __webpack_require__(2009);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(180);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _checkDecoratorArguments = __webpack_require__(376);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
	dragDropManager: _propTypes2.default.object.isRequired
};

var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
	return {
		dragDropManager: new _dndCore.DragDropManager(backend, context)
	};
};

var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
	// Auto-detect ES6 default export for people still using ES5
	var backend = backendOrModule;
	if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
		backend = backend.default;
	}
	(0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
	return backend;
};

function DragDropContext(backendOrModule) {
	_checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params

	var backend = unpackBackendForEs5Users(backendOrModule);
	var childContext = createChildContext(backend);

	return function decorateContext(DecoratedComponent) {
		var _class, _temp;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragDropContextContainer = (_temp = _class = function (_Component) {
			_inherits(DragDropContextContainer, _Component);

			function DragDropContextContainer() {
				_classCallCheck(this, DragDropContextContainer);

				return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
			}

			_createClass(DragDropContextContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'getManager',
				value: function getManager() {
					return childContext.dragDropManager;
				}
			}, {
				key: 'getChildContext',
				value: function getChildContext() {
					return childContext;
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragDropContextContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);


		return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
	};
}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOffset;
exports.getSourceClientOffset = getSourceClientOffset;
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;

var _dragDrop = __webpack_require__(374);

var initialState = {
	initialSourceClientOffset: null,
	initialClientOffset: null,
	clientOffset: null
};

function areOffsetsEqual(offsetA, offsetB) {
	if (offsetA === offsetB) {
		return true;
	}
	return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}

function dragOffset() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return {
				initialSourceClientOffset: action.sourceClientOffset,
				initialClientOffset: action.clientOffset,
				clientOffset: action.clientOffset
			};
		case _dragDrop.HOVER:
			if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
				return state;
			}
			return _extends({}, state, {
				clientOffset: action.clientOffset
			});
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
			return initialState;
		default:
			return state;
	}
}

function getSourceClientOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset,
	    initialSourceClientOffset = state.initialSourceClientOffset;

	if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
		y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	};
}

function getDifferenceFromInitialOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset;

	if (!clientOffset || !initialClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x - initialClientOffset.x,
		y: clientOffset.y - initialClientOffset.y
	};
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = matchesType;

var _isArray = __webpack_require__(67);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesType(targetType, draggedItemType) {
	if ((0, _isArray2.default)(targetType)) {
		return targetType.some(function (t) {
			return t === draggedItemType;
		});
	} else {
		return targetType === draggedItemType;
	}
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dirtyHandlerIds;
exports.areDirty = areDirty;

var _xor = __webpack_require__(2015);

var _xor2 = _interopRequireDefault(_xor);

var _intersection = __webpack_require__(2017);

var _intersection2 = _interopRequireDefault(_intersection);

var _dragDrop = __webpack_require__(374);

var _registry = __webpack_require__(375);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NONE = [];
var ALL = [];

function dirtyHandlerIds() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
	var action = arguments[1];
	var dragOperation = arguments[2];

	switch (action.type) {
		case _dragDrop.HOVER:
			break;
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
		case _registry.REMOVE_TARGET:
		case _registry.REMOVE_SOURCE:
			return NONE;
		case _dragDrop.BEGIN_DRAG:
		case _dragDrop.PUBLISH_DRAG_SOURCE:
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
		default:
			return ALL;
	}

	var targetIds = action.targetIds;
	var prevTargetIds = dragOperation.targetIds;

	var result = (0, _xor2.default)(targetIds, prevTargetIds);

	var didChange = false;
	if (result.length === 0) {
		for (var i = 0; i < targetIds.length; i++) {
			if (targetIds[i] !== prevTargetIds[i]) {
				didChange = true;
				break;
			}
		}
	} else {
		didChange = true;
	}

	if (!didChange) {
		return NONE;
	}

	var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	var innermostTargetId = targetIds[targetIds.length - 1];

	if (prevInnermostTargetId !== innermostTargetId) {
		if (prevInnermostTargetId) {
			result.push(prevInnermostTargetId);
		}
		if (innermostTargetId) {
			result.push(innermostTargetId);
		}
	}

	return result;
}

function areDirty(state, handlerIds) {
	if (state === NONE) {
		return false;
	}

	if (state === ALL || typeof handlerIds === 'undefined') {
		return true;
	}

	return (0, _intersection2.default)(handlerIds, state).length > 0;
}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = shallowEqualScalar;
function shallowEqualScalar(objA, objB) {
	if (objA === objB) {
		return true;
	}

	if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
		return false;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i])) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = decorateHandler;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _disposables = __webpack_require__(2032);

var _isPlainObject = __webpack_require__(164);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(180);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _shallowEqual = __webpack_require__(536);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(874);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isClassComponent = function isClassComponent(Comp) {
	return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
};

function decorateHandler(_ref) {
	var _class, _temp;

	var DecoratedComponent = _ref.DecoratedComponent,
	    createHandler = _ref.createHandler,
	    createMonitor = _ref.createMonitor,
	    createConnector = _ref.createConnector,
	    registerHandler = _ref.registerHandler,
	    containerDisplayName = _ref.containerDisplayName,
	    getType = _ref.getType,
	    collect = _ref.collect,
	    options = _ref.options;
	var _options$arePropsEqua = options.arePropsEqual,
	    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

	var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

	var DragDropContainer = (_temp = _class = function (_Component) {
		_inherits(DragDropContainer, _Component);

		_createClass(DragDropContainer, [{
			key: 'getHandlerId',
			value: function getHandlerId() {
				return this.handlerId;
			}
		}, {
			key: 'getDecoratedComponentInstance',
			value: function getDecoratedComponentInstance() {
				return this.decoratedComponentInstance;
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
			}
		}]);

		function DragDropContainer(props, context) {
			_classCallCheck(this, DragDropContainer);

			var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));

			_this.handleChange = _this.handleChange.bind(_this);
			_this.handleChildRef = _this.handleChildRef.bind(_this);

			(0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

			_this.manager = _this.context.dragDropManager;
			_this.handlerMonitor = createMonitor(_this.manager);
			_this.handlerConnector = createConnector(_this.manager.getBackend());
			_this.handler = createHandler(_this.handlerMonitor);

			_this.disposable = new _disposables.SerialDisposable();
			_this.receiveProps(props);
			_this.state = _this.getCurrentState();
			_this.dispose();
			return _this;
		}

		_createClass(DragDropContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.isCurrentlyMounted = true;
				this.disposable = new _disposables.SerialDisposable();
				this.currentType = null;
				this.receiveProps(this.props);
				this.handleChange();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!arePropsEqual(nextProps, this.props)) {
					this.receiveProps(nextProps);
					this.handleChange();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.dispose();
				this.isCurrentlyMounted = false;
			}
		}, {
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.handler.receiveProps(props);
				this.receiveType(getType(props));
			}
		}, {
			key: 'receiveType',
			value: function receiveType(type) {
				if (type === this.currentType) {
					return;
				}

				this.currentType = type;

				var _registerHandler = registerHandler(type, this.handler, this.manager),
				    handlerId = _registerHandler.handlerId,
				    unregister = _registerHandler.unregister;

				this.handlerId = handlerId;
				this.handlerMonitor.receiveHandlerId(handlerId);
				this.handlerConnector.receiveHandlerId(handlerId);

				var globalMonitor = this.manager.getMonitor();
				var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });

				this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				if (!this.isCurrentlyMounted) {
					return;
				}

				var nextState = this.getCurrentState();
				if (!(0, _shallowEqual2.default)(nextState, this.state)) {
					this.setState(nextState);
				}
			}
		}, {
			key: 'dispose',
			value: function dispose() {
				this.disposable.dispose();
				this.handlerConnector.receiveHandlerId(null);
			}
		}, {
			key: 'handleChildRef',
			value: function handleChildRef(component) {
				this.decoratedComponentInstance = component;
				this.handler.receiveComponent(component);
			}
		}, {
			key: 'getCurrentState',
			value: function getCurrentState() {
				var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);

				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
				}

				return nextState;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
					ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
				}));
			}
		}]);

		return DragDropContainer;
	}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
		dragDropManager: _propTypes2.default.object.isRequired
	}, _temp);


	return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = wrapConnectorHooks;

var _react = __webpack_require__(1);

var _cloneWithRef = __webpack_require__(2040);

var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function throwIfCompositeComponentElement(element) {
	// Custom components can no longer be wrapped directly in React DnD 2.0
	// so that we don't need to depend on findDOMNode() from react-dom.
	if (typeof element.type === 'string') {
		return;
	}

	var displayName = element.type.displayName || element.type.name || 'the component';

	throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
	return function () {
		var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		// When passed a node, call the hook straight away.
		if (!(0, _react.isValidElement)(elementOrNode)) {
			var node = elementOrNode;
			hook(node, options);
			return undefined;
		}

		// If passed a ReactElement, clone it and attach this function as a ref.
		// This helps us achieve a neat API where user doesn't even know that refs
		// are being used under the hood.
		var element = elementOrNode;
		throwIfCompositeComponentElement(element);

		// When no options are passed, use the hook directly
		var ref = options ? function (node) {
			return hook(node, options);
		} : hook;

		return (0, _cloneWithRef2.default)(element, ref);
	};
}

function wrapConnectorHooks(hooks) {
	var wrappedHooks = {};

	Object.keys(hooks).forEach(function (key) {
		var hook = hooks[key];
		var wrappedHook = wrapHookToRecognizeElement(hook);
		wrappedHooks[key] = function () {
			return wrappedHook;
		};
	});

	return wrappedHooks;
}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = areOptionsEqual;

var _shallowEqual = __webpack_require__(536);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areOptionsEqual(nextOptions, currentOptions) {
	if (currentOptions === nextOptions) {
		return true;
	}

	return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isValidType;

var _isArray = __webpack_require__(67);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidType(type, allowArray) {
	return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
		return isValidType(t, false);
	});
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePalette = function ImagePalette(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
ImagePalette = (0, _pure2.default)(ImagePalette);
ImagePalette.displayName = 'ImagePalette';
ImagePalette.muiName = 'SvgIcon';

exports.default = ImagePalette;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(2055),
    keys = __webpack_require__(240);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(264);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2059),
    baseMatchesProperty = __webpack_require__(2073),
    identity = __webpack_require__(264),
    isArray = __webpack_require__(67),
    property = __webpack_require__(2076);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2066),
    isObjectLike = __webpack_require__(135);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(338),
    arraySome = __webpack_require__(2067),
    cacheHas = __webpack_require__(340);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(77);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(888),
    getSymbols = __webpack_require__(541),
    keys = __webpack_require__(240);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(487),
    isArray = __webpack_require__(67);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 889 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2070),
    Map = __webpack_require__(464),
    Promise = __webpack_require__(2071),
    Set = __webpack_require__(733),
    WeakMap = __webpack_require__(891),
    baseGetTag = __webpack_require__(187),
    toSource = __webpack_require__(673);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(188),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 893 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(461),
    isArguments = __webpack_require__(488),
    isArray = __webpack_require__(67),
    isIndex = __webpack_require__(271),
    isLength = __webpack_require__(489),
    toKey = __webpack_require__(257);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(487),
    getPrototype = __webpack_require__(535),
    getSymbols = __webpack_require__(541),
    stubArray = __webpack_require__(889);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboard = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _checkboard = __webpack_require__(2107);

var checkboard = _interopRequireWildcard(_checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports.default = Checkboard;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    now = __webpack_require__(2114),
    toNumber = __webpack_require__(547);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(897);

var _debounce2 = _interopRequireDefault(_debounce);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, _color2.default.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue)));
      }
    }, {
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }]);

    return ColorPicker;
  }(_react.PureComponent || _react.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports.default = ColorWrap;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(543),
    baseEach = __webpack_require__(542),
    castFunction = __webpack_require__(881),
    isArray = __webpack_require__(67);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pink", function() { return pink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepPurple", function() { return deepPurple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indigo", function() { return indigo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightBlue", function() { return lightBlue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cyan", function() { return cyan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightGreen", function() { return lightGreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lime", function() { return lime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "amber", function() { return amber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orange", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepOrange", function() { return deepOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "brown", function() { return brown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grey", function() { return grey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blueGrey", function() { return blueGrey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkText", function() { return darkText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightText", function() { return lightText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkIcons", function() { return darkIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightIcons", function() { return lightIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "white", function() { return white; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "black", function() { return black; });
var red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white = "#ffffff";
var black = "#000000";

/* harmony default export */ __webpack_exports__["default"] = ({
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
});


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderUsefulLines; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var SCORE_THRESHOLD = 0.8;

var renderUsefulLines = function renderUsefulLines(predictorData, textLetter) {
    if (!predictorData || !predictorData.details || !predictorData.details.lines || !predictorData.details.lines.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            textLetter
        );
    }

    var linesMap = new Map(predictorData.details.lines.map(function (item) {
        return [item.line.toLowerCase(), item];
    }));

    var lines = textLetter.split('\n');

    return lines.map(function (line, idx) {
        var matchedData = linesMap.get(line.trim().toLowerCase());

        var backgroundColor = 'transparent';
        var borderLeftColor = 'transparent';

        if (matchedData) {
            var isHighScore = matchedData.predicted_score >= SCORE_THRESHOLD;
            backgroundColor = isHighScore ? 'rgba(76, 175, 80, 0.25)' : 'rgba(244, 67, 54, 0.15)';
            borderLeftColor = isHighScore ? '#4CAF50' : '#F44336';
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                key: idx,
                style: {
                    backgroundColor: backgroundColor,
                    borderLeft: '3px solid ' + borderLeftColor,
                    paddingLeft: '8px',
                    margin: '2px 0'
                },
                title: matchedData ? 'Score: ' + (matchedData.predicted_score * 100).toFixed(1) + '% | Label: ' + matchedData.predicted_label : ''
            },
            line || '\xA0'
        );
    });
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SCORE_THRESHOLD, 'SCORE_THRESHOLD', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/utils.jsx');
    reactHotLoader.register(renderUsefulLines, 'renderUsefulLines', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/utils.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(2169);









var AutoSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        {
          className: className,
          ref: this._setRef,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: require('prop-types').func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: require('prop-types').string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: require('prop-types').number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: require('prop-types').number,


  /** Disable dynamic :height property */
  disableHeight: require('prop-types').bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: require('prop-types').bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: require('prop-types').string,


  /** Callback to be invoked on-resize */
  onResize: require('prop-types').func.isRequired,


  /** Optional inline style */
  style: require('prop-types').object
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);








var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellRendererParams = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_CellRendererParams || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_NoContentRenderer = __webpack_require__(144).babelPluginFlowReactPropTypes_proptype_NoContentRenderer || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(551).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_RenderedRows = __webpack_require__(551).babelPluginFlowReactPropTypes_proptype_RenderedRows || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_RowRenderer = __webpack_require__(551).babelPluginFlowReactPropTypes_proptype_RowRenderer || __webpack_require__(5).any;





/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Grid__["default"], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_7__Grid__["accessibilityOverscanIndicesGetter"],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": require('prop-types').string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: require('prop-types').bool.isRequired,


  /** Optional CSS class name */
  className: require('prop-types').string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: require('prop-types').number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: require('prop-types').number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: typeof babelPluginFlowReactPropTypes_proptype_NoContentRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_NoContentRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_NoContentRenderer).isRequired,


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: require('prop-types').func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: require('prop-types').func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: typeof babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter === 'function' ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired : babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter).isRequired,


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: require('prop-types').number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: typeof babelPluginFlowReactPropTypes_proptype_RowRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_RowRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_RowRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_RowRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_RowRenderer).isRequired,


  /** Number of rows in list. */
  rowCount: require('prop-types').number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: typeof babelPluginFlowReactPropTypes_proptype_Alignment === 'function' ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired : babelPluginFlowReactPropTypes_proptype_Alignment : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Alignment).isRequired,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: require('prop-types').number.isRequired,


  /** Vertical offset. */
  scrollTop: require('prop-types').number,


  /** Optional inline style */
  style: require('prop-types').object.isRequired,


  /** Tab index for focus */
  tabIndex: require('prop-types').number,


  /** Width of list */
  width: require('prop-types').number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_updateScrollIndexHelper__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultCellRangeRenderer__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__ = __webpack_require__(905);







var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_NoContentRenderer = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_NoContentRenderer || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellRangeRenderer = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellRangeRenderer || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellRenderer = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellRenderer || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId = __webpack_require__(905).babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId || __webpack_require__(5).any;












/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props));

    _this.state = {
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null
    };
    _this._onGridRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._cellCache = {};
    _this._styleCache = {};
    _this._scrollbarSizeMeasured = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      _this._resetStyleCache();
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);

    _this._columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._columnWidthGetter(params);
      },
      estimatedCellSize: _this._getEstimatedColumnSize(props)
    });
    _this._rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._rowHeightGetter(params);
      },
      estimatedCellSize: _this._getEstimatedRowSize(props)
    });
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  // See defaultCellRangeRenderer() for more information on the usage of these caches


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = this._scrollbarSize;
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;


      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;


      this._columnSizeAndPositionManager.resetCell(columnIndex);
      this._rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && columnIndex <= scrollToColumn;
      this._recomputeScrollTopFlag = scrollToRow >= 0 && rowIndex <= scrollToRow;

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._cellCache = {};
      this._styleCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = getScrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        this.scrollToPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_12__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: this._columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_12__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: this._rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getScrollbarSize = this.props.getScrollbarSize;

      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()

      this._scrollbarSize = getScrollbarSize();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }

      this._calculateChildrenToRender();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var _state2 = this.state,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;


      if (nextProps.columnCount === 0 && scrollLeft !== 0 || nextProps.rowCount === 0 && scrollTop !== 0) {
        this.scrollToPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        var newState = {};

        if (nextProps.scrollLeft != null) {
          newState.scrollLeft = nextProps.scrollLeft;
        }
        if (nextProps.scrollTop != null) {
          newState.scrollTop = nextProps.scrollTop;
        }

        this.scrollToPosition(newState);
      }

      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
        this._styleCache = {};
      }

      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);

      this._columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
      });
      this._rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: this._getEstimatedRowSize(nextProps)
      });

      var _props6 = this.props,
          columnCount = _props6.columnCount,
          rowCount = _props6.rowCount;

      // Special case when either cols or rows were 0
      // This would prevent any cells from rendering
      // So we need to reset row scroll if cols changed from 0 (and vice versa)

      if (columnCount === 0 || rowCount === 0) {
        columnCount = 0;
        rowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && this.props.isScrolling === true) {
        this._resetStyleCache();
      }

      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: columnCount,
        cellSize: typeof this.props.columnWidth === 'number' ? this.props.columnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: this.props.scrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollLeftForScrollToColumn(nextProps, _this3.state);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: rowCount,
        cellSize: typeof this.props.rowHeight === 'number' ? this.props.rowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: this.props.scrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollTopForScrollToRow(nextProps, _this3.state);
        }
      });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this._calculateChildrenToRender(nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          autoContainerWidth = _props7.autoContainerWidth,
          autoHeight = _props7.autoHeight,
          autoWidth = _props7.autoWidth,
          className = _props7.className,
          containerProps = _props7.containerProps,
          containerRole = _props7.containerRole,
          containerStyle = _props7.containerStyle,
          height = _props7.height,
          id = _props7.id,
          noContentRenderer = _props7.noContentRenderer,
          role = _props7.role,
          style = _props7.style,
          tabIndex = _props7.tabIndex,
          width = _props7.width;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          scrollLeft = state.scrollLeft,
          scrollTop = state.scrollTop;


      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
        this._rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                this._columnStartIndex = 0;
                this._columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                this._rowStartIndex = 0;
                this._rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
          columnStartIndex: this._columnStartIndex,
          columnStopIndex: this._columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          parent: this,
          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
          rowStartIndex: this._rowStartIndex,
          rowStopIndex: this._rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__["cancelAnimationTimeout"])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_15__utils_requestAnimationTimeout__["requestAnimationTimeout"])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */

  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this4 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props8 = _this4.props,
              height = _props8.height,
              onScroll = _props8.onScroll,
              width = _props8.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this._scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var columnCount = props.columnCount,
          height = props.height,
          scrollToAlignment = props.scrollToAlignment,
          scrollToColumn = props.scrollToColumn,
          width = props.width;
      var scrollLeft = state.scrollLeft;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;

        return this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollLeft = state.scrollLeft;

      var calculatedScrollLeft = this._getCalculatedScrollLeft(props, state);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        this.scrollToPosition({
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var height = props.height,
          rowCount = props.rowCount,
          scrollToAlignment = props.scrollToAlignment,
          scrollToRow = props.scrollToRow,
          width = props.width;
      var scrollTop = state.scrollTop;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

        return this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];
        }
      }

      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollTop = state.scrollTop;

      var calculatedScrollTop = this._getCalculatedScrollTop(props, state);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        this.scrollToPosition({
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_14_dom_helpers_util_scrollbarSize___default.a,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0
};
Grid.propTypes =  true ? null : {
  "aria-label": require('prop-types').string.isRequired,
  "aria-readonly": require('prop-types').bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: require('prop-types').bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: require('prop-types').bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: require('prop-types').bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: typeof babelPluginFlowReactPropTypes_proptype_CellRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_CellRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_CellRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_CellRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellRenderer).isRequired,


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: typeof babelPluginFlowReactPropTypes_proptype_CellRangeRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_CellRangeRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_CellRangeRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_CellRangeRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellRangeRenderer).isRequired,


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: require('prop-types').string,


  /** Number of columns in grid.  */
  columnCount: require('prop-types').number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,


  /** Unfiltered props for the Grid container. */
  containerProps: require('prop-types').object,


  /** ARIA role for the cell-container.  */
  containerRole: require('prop-types').string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: require('prop-types').object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: require('prop-types').object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: require('prop-types').number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: require('prop-types').number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: require('prop-types').func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: require('prop-types').number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: require('prop-types').string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: require('prop-types').bool,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: typeof babelPluginFlowReactPropTypes_proptype_NoContentRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_NoContentRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_NoContentRenderer).isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: require('prop-types').func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: require('prop-types').func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: require('prop-types').func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: require('prop-types').number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: typeof babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter === 'function' ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired : babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter).isRequired,


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: require('prop-types').number.isRequired,


  /** ARIA role for the grid element.  */
  role: require('prop-types').string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,


  /** Number of rows in grid.  */
  rowCount: require('prop-types').number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: require('prop-types').number.isRequired,


  /** Horizontal offset. */
  scrollLeft: require('prop-types').number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: typeof babelPluginFlowReactPropTypes_proptype_Alignment === 'function' ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired : babelPluginFlowReactPropTypes_proptype_Alignment : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Alignment).isRequired,


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: require('prop-types').number.isRequired,


  /** Vertical offset. */
  scrollTop: require('prop-types').number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: require('prop-types').number.isRequired,


  /** Optional inline style */
  style: require('prop-types').object.isRequired,


  /** Tab index for focus */
  tabIndex: require('prop-types').number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: require('prop-types').number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelAnimationTimeout", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestAnimationTimeout", function() { return requestAnimationTimeout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animationFrame__ = __webpack_require__(2175);


var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId =  true ? null : {
  id: require('prop-types').number.isRequired
};
if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId', {
  value: babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId,
  configurable: true
});


var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["a" /* caf */])(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = Date.now();

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["b" /* raf */])(timeout)
  };

  return frame;
};

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
var babelPluginFlowReactPropTypes_proptype_OverscanIndices = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_OverscanIndices || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams || __webpack_require__(5).any;

var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

var babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams || __webpack_require__(5).any;

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LinksTags__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

















var getDefaultLinkData = function getDefaultLinkData() {
    return {
        value: null,
        tags: []
    };
};

function AddUpdateModal(_ref) {
    var _this = this;

    var open = _ref.open,
        setOpen = _ref.setOpen,
        type = _ref.type,
        _ref$toEdit = _ref.toEdit,
        toEdit = _ref$toEdit === undefined ? undefined : _ref$toEdit,
        handleSearch = _ref.handleSearch,
        addNotification = _ref.addNotification,
        _ref$fromLetter = _ref.fromLetter,
        fromLetter = _ref$fromLetter === undefined ? false : _ref$fromLetter,
        handleModifyLinksList = _ref.handleModifyLinksList;

    var defaultLink = getDefaultLinkData();
    if (fromLetter) {
        defaultLink.value = window.location.href;
    }

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([defaultLink]),
        _useState2 = _slicedToArray(_useState, 2),
        linksData = _useState2[0],
        setLinksData = _useState2[1];

    var handleClose = function handleClose() {
        setLinksData([defaultLink]);
        setOpen(!open);
    };

    var addRow = function addRow() {
        setLinksData(linksData.concat(getDefaultLinkData()));
    };

    var removeRow = function removeRow(index) {
        var _linksData = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(linksData);
        _linksData.splice(index, 1);
        setLinksData(_linksData);
    };

    var modifyLinkData = function modifyLinkData(_type, tagData, index) {
        var _linksData = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(linksData);
        _linksData[index][_type] = tagData;
        setLinksData(_linksData);
    };

    var handleSave = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            __WEBPACK_IMPORTED_MODULE_8_services__["a" /* default */].createAnalyticsLinks(linksData).then(function (response) {
                                if (!response.errors.length) {
                                    addNotification({
                                        title: 'Success',
                                        message: 'Record/s created successfully',
                                        level: 'success',
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 3
                                    });
                                    handleClose();
                                    handleModifyLinksList && handleModifyLinksList();
                                    handleSearch && handleSearch();
                                } else {
                                    addNotification({
                                        title: 'Error',
                                        message: response.errors[0].message || response.errors[0].messages[0],
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 3
                                    });
                                }
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function handleSave() {
            return _ref2.apply(this, arguments);
        };
    }();

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
        label: 'Cancel',
        primary: true,
        onClick: handleClose
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
        label: 'Submit',
        primary: true,
        keyboardFocused: true,
        onClick: handleSave
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default.a,
            {
                title: (type + ' records').toUpperCase(),
                open: open,
                actions: actions,
                onRequestClose: handleClose,
                className: 'identify-please'
            },
            toEdit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkRow, {
                type: type,
                key: 'toEdit',
                record: toEdit
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["u" /* Table */],
                {
                    selectable: false,
                    style: { maxHeight: '300px', overflowY: 'auto' }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["w" /* TableHeader */],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                        {
                            style: _extends({}, __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnCSS, { width: '53%' })
                        },
                        'Value'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                        {
                            style: _extends({}, __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnCSS, { width: '33%' })
                        },
                        'Tags'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["v" /* TableBody */],
                    {
                        displayRowCheckbox: false
                    },
                    linksData.map(function (record, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkRow, {
                            type: type,
                            record: record,
                            index: index,
                            key: 'toAdd_' + index,
                            add: addRow,
                            remove: removeRow,
                            modifyLinkData: modifyLinkData
                        });
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_13_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_11_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(AddUpdateModal);

/* harmony default export */ __webpack_exports__["a"] = (_default);

function LinkRow(_ref3) {
    var key = _ref3.key,
        record = _ref3.record,
        index = _ref3.index,
        add = _ref3.add,
        remove = _ref3.remove,
        modifyLinkData = _ref3.modifyLinkData,
        type = _ref3.type;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui__["y" /* TableRow */],
        {
            key: key
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
            {
                style: { padding: 0, width: '53%' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                defaultValue: record.value,
                floatingLabelText: 'Record',
                onChange: function onChange(e) {
                    return modifyLinkData('value', e.target.value, index);
                },
                style: { width: '95%' },
                multiLine: true
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
            {
                style: { padding: 0, width: '33%', whiteSpace: 'unset' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LinksTags__["a" /* default */], {
                tags: record.tags,
                setTags: function setTags(tags) {
                    return modifyLinkData('tags', tags, index);
                },
                placeHolder: 'Add tag'
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
            {
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableRowColumnSmallCSS, { width: '12%' })
            },
            !index ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default.a, {
                    onClick: function onClick() {
                        add();
                    },
                    style: { margin: '70px 0 0 0' },
                    color: 'green'
                })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                    onClick: function onClick() {
                        remove(index);
                    },
                    style: { margin: '30px 0 0 0' },
                    color: 'red'
                })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getDefaultLinkData, 'getDefaultLinkData', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/AddUpdateModal.jsx');
    reactHotLoader.register(AddUpdateModal, 'AddUpdateModal', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/AddUpdateModal.jsx');
    reactHotLoader.register(LinkRow, 'LinkRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/AddUpdateModal.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/AddUpdateModal.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = withMutation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_query__ = __webpack_require__(141);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




/**
 * a hoc that connects a component to a react-query mutation
 * @param {object} config - config
 * @param {function} config.mutationFn - async function that performs the mutation - api call
 * @param {object} [config.mutationOptions={}] - optional options to pass directly to useMutation (onSuccess, onError...)
 * @param {function} config.mapMutationToProps - a function to map the mutation state and actions to props for the wrapped component
 */
function withMutation(config) {
    var mutationFn = config.mutationFn,
        _config$mutationOptio = config.mutationOptions,
        mutationOptions = _config$mutationOptio === undefined ? {} : _config$mutationOptio,
        mapMutationToProps = config.mapMutationToProps;


    return function (WrappedComponent) {
        var WithMutation = function WithMutation(props) {
            var mutationResult = Object(__WEBPACK_IMPORTED_MODULE_1_react_query__["useMutation"])(mutationFn, mutationOptions);

            var newProps = mapMutationToProps(mutationResult.mutateAsync, mutationResult, props);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, newProps));
        };

        return WithMutation;
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(withMutation, 'withMutation', '/opt/atlassian/pipelines/agent/build/client/app/HOC/common.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_regions_ports__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var PortsAltNamesRow = function PortsAltNamesRow(_ref) {
    var initialItem = _ref.item,
        initialTags = _ref.tags,
        suggestionsPorts = _ref.suggestionsPorts,
        savePort = _ref.savePort,
        updatePortSuggestions = _ref.updatePortSuggestions,
        updatePortAlt = _ref.updatePortAlt,
        updateExternalAltsState = _ref.updateExternalAltsState;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialItem),
        _useState2 = _slicedToArray(_useState, 2),
        item = _useState2[0],
        setItem = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialTags),
        _useState4 = _slicedToArray(_useState3, 2),
        tags = _useState4[0],
        setTags = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setItem(initialItem);
        setTags(initialTags);
    }, []);

    var updatePort = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        updatePortAlt(item);
        updatePortSuggestions([]);
        var newItem = _extends({}, item, {
            isUpdate: false,
            alt: tags.map(function (tag) {
                return tag.name;
            })
        });

        setItem(newItem);
        updateExternalAltsState && updateExternalAltsState(newItem.alt);
    }, [item, updatePortAlt]);

    var handleInputChange = function handleInputChange(searchText) {
        if (searchText.length < 3) {
            updatePortSuggestions([]);
            return;
        }

        __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].findPortAdmin({ name: searchText, withAreas: true }).then(function (response) {
            updatePortSuggestions(response.data.data);
        });
    };

    var handleDelete = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (i) {
        var newTags = tags.slice(0);
        newTags.splice(i, 1);

        var newItem = _extends({}, item, {
            isUpdate: true,
            alt: newTags.map(function (newTag) {
                return newTag.name;
            })
        });

        setTags(newTags);
        setItem(newItem);

        updatePortSuggestions([]);
        savePort(newItem);
    }, [tags, item, savePort, updatePortSuggestions]);

    var handleAddition = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (tag) {
        if (!tag.name.replace(/\s/g, '').length) {
            return;
        }

        var alreadySuggested = suggestionsPorts.some(function (port) {
            return port.name.toLowerCase() === tag.name.toLowerCase();
        });

        if (alreadySuggested) {
            return;
        }

        var newTags = [].concat(_toConsumableArray(tags), [tag]);

        var newItem = _extends({}, item, {
            isUpdate: true,
            alt: newTags.map(function (newTag) {
                return newTag.name;
            })
        });

        setTags(newTags);
        setItem(newItem);

        updatePortSuggestions([]);
        savePort(newItem);
    }, [tags, item, suggestionsPorts, savePort, updatePortSuggestions]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRow"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS },
            item.name + ' (' + (item.country ? item.country.name : '') + ')'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default.a, {
                allowNew: true,
                autofocus: false,
                tags: tags,
                suggestions: [],
                handleDelete: handleDelete,
                handleAddition: handleAddition,
                handleInputChange: handleInputChange
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: item.isUpdate ? 'update-item' : 'hidden update-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, { label: 'Update', primary: true, onClick: updatePort })
            )
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref2, _ref3) {
    var ports = _ref2.ports;
    var item = _ref3.item;

    var tags = item.alt.map(function (port, key) {
        return {
            id: key,
            name: port
        };
    });

    return {
        item: item,
        tags: tags,
        suggestionsPorts: ports.suggestions
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        savePort: __WEBPACK_IMPORTED_MODULE_8_actions_regions_ports__["g" /* savePort */],
        updatePortSuggestions: __WEBPACK_IMPORTED_MODULE_8_actions_regions_ports__["k" /* updatePortSuggestions */],
        updatePortAlt: __WEBPACK_IMPORTED_MODULE_8_actions_regions_ports__["j" /* updatePortAlt */]
    }, dispatch);
})(PortsAltNamesRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsAltNamesRow, 'PortsAltNamesRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortsAltNames/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortsAltNames/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPortLabelTypes; });
/* unused harmony export getLabels */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(277);
var _templateObject = _taggedTemplateLiteral(['\n    display: inline-flex;\n    height: 20px;\n    padding: 0 12px;\n    align-items: center;\n    gap: 10px;\n    border-radius: 20px;\n    background-color: ', ';\n    justify-content: center;\n    font-size: 12px;\n    white-space: nowrap;\n    margin-right: 4px;\n'], ['\n    display: inline-flex;\n    height: 20px;\n    padding: 0 12px;\n    align-items: center;\n    gap: 10px;\n    border-radius: 20px;\n    background-color: ', ';\n    justify-content: center;\n    font-size: 12px;\n    white-space: nowrap;\n    margin-right: 4px;\n']);

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }




var backgroundsMap = {
    new: { text: 'New', color: '#82C3FF' },
    user: { text: 'User', color: '#75C422' },
    update: { text: 'Update', color: '#FFA500' }
};

var Chip = __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* default */].div(_templateObject, function (props) {
    return props.$bgColor;
});

/**
 * derives label types from port properties
 * @param {object} port - port object
 * @returns {string[]} array of label types
 */
var getPortLabelTypes = function getPortLabelTypes(port) {
    if (!port) return [];

    return [port._id && !port.portApproved && 'new', port._id && !port.portApproved && 'user', port.changes && port.portApproved && 'update', port.history && port.history.length && port.portApproved && 'update'].filter(Boolean);
};

/**
 * @param {string | string[]} types - 'new' | 'user' | 'update' or array of these
 * @returns {React.ReactElement[]} array of styled Chip components
 */
var getLabels = function getLabels(types) {
    var typeArray = Array.isArray(types) ? types : [types];

    return typeArray.map(function (type, index) {
        var config = backgroundsMap[type];
        if (!config) return null;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Chip,
            { key: type + '-' + index, $bgColor: config.color },
            config.text
        );
    }).filter(Boolean);
};

var _default = getLabels;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(backgroundsMap, 'backgroundsMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/Labels.jsx');
    reactHotLoader.register(Chip, 'Chip', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/Labels.jsx');
    reactHotLoader.register(getPortLabelTypes, 'getPortLabelTypes', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/Labels.jsx');
    reactHotLoader.register(getLabels, 'getLabels', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/Labels.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/common/Labels.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxFormValidators = __webpack_require__(2198);

var messages = (0, _reduxFormValidators.defineMessages)({
  absence: {
    id: 'form.errors.absence',
    defaultMessage: 'must be blank'
  },
  acceptance: {
    id: 'form.errors.acceptance',
    defaultMessage: 'must be accepted'
  },
  confirmation: {
    id: 'form.errors.confirmation',
    defaultMessage: "doesn't match `{fieldLabel}`"
  },
  dateFormat: {
    id: 'form.errors.dateFormat',
    defaultMessage: 'expected format: {format}'
  },
  dateInvalid: {
    id: 'form.errors.dateInvalid',
    defaultMessage: 'is not a valid date'
  },
  dateRange: {
    id: 'form.errors.dateRange',
    defaultMessage: 'shoud be {op} {date}'
  },
  email: {
    id: 'form.errors.email',
    defaultMessage: 'is not a valid email'
  },
  equalTo: {
    id: 'form.errors.equalTo',
    defaultMessage: 'must be equal to {count, number}'
  },
  even: {
    id: 'form.errors.even',
    defaultMessage: 'must be even'
  },
  exclusion: {
    id: 'form.errors.exclusion',
    defaultMessage: 'is reserved'
  },
  file: {
    id: 'form.errors.file',
    defaultMessage: 'is not a file'
  },
  fileAccept: {
    id: 'form.errors.fileAccept',
    defaultMessage: 'invalid file {count, plural, one {type} other {types ({count})}}'
  },
  fileTooBig: {
    id: 'form.errors.fileTooBig',
    defaultMessage: '{count, plural, one {is} other {{count} files are}} too big (maximum is {count, plural, one {{size}} other {{size} each}})'
  },
  fileTooFew: {
    id: 'form.errors.fileTooFew',
    defaultMessage: 'invalid number of files (minimum is {count})'
  },
  fileTooMany: {
    id: 'form.errors.fileTooMany',
    defaultMessage: 'invalid number of files (maximum is {count})'
  },
  fileTooSmall: {
    id: 'form.errors.fileTooSmall',
    defaultMessage: '{count, plural, one {is} other {{count} files are}} too small (minimum is {count, plural, one {{size}} other {{size} each}})'
  },
  greaterThan: {
    id: 'form.errors.greaterThan',
    defaultMessage: 'must be greater than {count, number}'
  },
  greaterThanOrEqualTo: {
    id: 'form.errors.greaterThanOrEqualTo',
    defaultMessage: 'must be greater than or equal to {count, number}'
  },
  inclusion: {
    id: 'form.errors.inclusion',
    defaultMessage: 'is not included in the list'
  },
  invalid: {
    id: 'form.errors.invalid',
    defaultMessage: 'is invalid'
  },
  lessThan: {
    id: 'form.errors.lessThan',
    defaultMessage: 'must be less than {count, number}'
  },
  lessThanOrEqualTo: {
    id: 'form.errors.lessThanOrEqualTo',
    defaultMessage: 'must be less than or equal to {count, number}'
  },
  notAnInteger: {
    id: 'form.errors.notAnInteger',
    defaultMessage: 'is not an integer'
  },
  notANumber: {
    id: 'form.errors.notANumber',
    defaultMessage: 'is not a number'
  },
  odd: {
    id: 'form.errors.odd',
    defaultMessage: 'must be odd'
  },
  otherThan: {
    id: 'form.errors.otherThan',
    defaultMessage: 'must be other than {count, number}'
  },
  presence: {
    id: 'form.errors.presence',
    defaultMessage: 'is required'
  },
  tooLong: {
    id: 'form.errors.tooLong',
    defaultMessage: 'is too long (maximum is {count, number} {count, plural, one {character} other {characters}})'
  },
  tooShort: {
    id: 'form.errors.tooShort',
    defaultMessage: 'is too short (minimum is {count, number} {count, plural, one {character} other {characters}})'
  },
  url: {
    id: 'form.errors.url',
    defaultMessage: 'is not a valid URL'
  },
  wrongLength: {
    id: 'form.errors.wrongLength',
    defaultMessage: 'is the wrong length (should be {count, number} {count, plural, one {character} other {characters}})'
  }
});

exports.default = messages;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inclusionExclusion = inclusionExclusion;

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inclusion = (0, _helpers.memoize)(function (options) {
  return inclusionExclusion(true, options);
});

exports.default = inclusion;
function inclusionExclusion(inclusion, _ref) {
  var inc = _ref.in,
      within = _ref.within,
      caseSensitive = _ref.caseSensitive,
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless,
      allowBlank = _ref.allowBlank;

  msg = msg || message;
  within = [].concat(within || inc).map(function (val) {
    return '' + val;
  });

  return (0, _helpers.prepare)(ifCond, unless, allowBlank, function (value) {
    var cs = caseSensitive != null ? caseSensitive : _validators2.default.defaultOptions.caseSensitive;
    var array = within;

    if (!cs) {
      value = value.toLowerCase();
      array = array.map(function (val) {
        return val.toLowerCase();
      });
    }
    if (inclusion) {
      if (array.indexOf(value) < 0) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'inclusion'));
      }
    } else {
      if (array.indexOf(value) >= 0) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'exclusion'));
      }
    }
  });
}

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _default = ['GMT -12', 'GMT -11', 'GMT -10', 'GMT -9:30', 'GMT -9', 'GMT -8:30', 'GMT -8', 'GMT -7', 'GMT -6', 'GMT -5', 'GMT -4', 'GMT -3:30', 'GMT -3', 'GMT -2', 'GMT -1', 'GMT Z', 'GMT +1', 'GMT +2', 'GMT +3', 'GMT +3:30', 'GMT +4', 'GMT +4:30', 'GMT +5', 'GMT +5:30', 'GMT +6', 'GMT +6:30', 'GMT +7', 'GMT +8', 'GMT +9', 'GMT +9:30', 'GMT +10', 'GMT +10:30', 'GMT +11', 'GMT +11:30', 'GMT +12'];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/data/gmt.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortManagement_common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortsAltNames_Row__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__ = __webpack_require__(53);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












var styles = {
    dialog: {
        contentStyle: { width: '700px', maxWidth: '90%', padding: '14px' }
    },
    textField: {
        marginBottom: '8px'
    },
    actionButtons: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px'
    }
};

var INITIAL_DISPLAY_COUNT = 5;

var AltNames = function AltNames(_ref) {
    var port = _ref.port,
        suggestionsPorts = _ref.suggestionsPorts,
        changePort = _ref.changePort,
        _ref$isForApproval = _ref.isForApproval,
        isForApproval = _ref$isForApproval === undefined ? false : _ref$isForApproval;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isExpanded = _useState2[0],
        setIsExpanded = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isDialogOpen = _useState4[0],
        setIsDialogOpen = _useState4[1];

    var hasMoreNames = port.alt.length > INITIAL_DISPLAY_COUNT;
    var displayedNames = isExpanded ? port.alt : port.alt.slice(0, INITIAL_DISPLAY_COUNT);

    var handleOpenDialog = function handleOpenDialog() {
        setIsDialogOpen(true);
    };

    var handleCloseDialog = function handleCloseDialog() {
        setIsDialogOpen(false);
    };

    var updateExternalAltsState = function updateExternalAltsState(alts) {
        changePort({ alt: alts });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
            {
                title: 'Edit Alternative Names',
                open: isDialogOpen,
                onRequestClose: handleCloseDialog,
                contentStyle: styles.dialog.contentStyle,
                autoScrollBodyContent: true
            },
            suggestionsPorts && suggestionsPorts.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'port-suggestions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'title' },
                    'This name has been already used:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content' },
                    suggestionsPorts.map(function (p) {
                        return p.alt ? ' ' + p.name + ' - (' + p.alt.join(', ') + ')' : p.name + ', ';
                    })
                )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PortsAltNames_Row__["a" /* default */], { item: port, updateExternalAltsState: updateExternalAltsState })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'info__altNames' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'info__title' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'gray' },
                    'Alternative Names: '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton___default.a,
                    {
                        tooltip: isForApproval ? 'Port is not approved yet.' : 'Edit Alternative Names',
                        onClick: !isForApproval ? handleOpenDialog : function () {},
                        style: {
                            marginLeft: '25px', padding: '0', width: '24px', height: '24px'
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_create___default.a, { color: '#CBCBCB', viewBox: '0 0 30 30' })
                )
            ),
            port.alt.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'alt-names-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'alt-names-list' },
                    displayedNames.map(function (name, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { key: index },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PortManagement_common_utils__["a" /* CheckDiffText */], {
                                oldValue: port.alt[index] || '',
                                newValue: name
                            })
                        );
                    })
                ),
                hasMoreNames && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                        className: 'show-more-button',
                        onClick: function onClick() {
                            return setIsExpanded(!isExpanded);
                        }
                    },
                    isExpanded ? 'Show less' : 'Show all (' + port.alt.length + ')'
                )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'no-alt-names' },
                'No alternative names'
            )
        )
    );
};

AltNames.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
    })
};

AltNames.defaultProps = {
    port: {}
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(function (state) {
    return {
        port: state.port,
        suggestionsPorts: state.ports.suggestions
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(AltNames);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/AltNames.jsx');
    reactHotLoader.register(INITIAL_DISPLAY_COUNT, 'INITIAL_DISPLAY_COUNT', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/AltNames.jsx');
    reactHotLoader.register(AltNames, 'AltNames', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/AltNames.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/AltNames.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export futureDateOnly */
/* harmony export (immutable) */ __webpack_exports__["a"] = ServiceProviderFormFields;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CompaniesAutoComplete__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Emails__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Phones__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_data_portActivities__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_UserAutoComplete__ = __webpack_require__(382);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// client/app/components/Regions/Port/ServiceProviders/FormFields.jsx














var styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    }
};

var emptyLimitation = {
    maxDraught: undefined,
    maxBeam: undefined,
    maxLOA: undefined,
    maxDWT: undefined,
    channelDepth: undefined,
    anchorageDepth: undefined
};

var futureDateOnly = function futureDateOnly(value) {
    if (!value) return undefined;
    var d = value instanceof Date ? value : new Date(value);
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return d.getTime() <= today.getTime() ? 'Select a future date' : undefined;
};

var validateContactPerson = function validateContactPerson(val) {
    if (!val) return undefined;
    if (!val._id && val.email) return 'Select user from list';
    if (val.email && val.email.length < 3) return 'User email must be at least 3 characters long';
    return undefined;
};

function renderRecommendedEndAt(_ref) {
    var input = _ref.input,
        meta = _ref.meta,
        rest = _objectWithoutProperties(_ref, ['input', 'meta']);

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var base = function base() {
        return input.value ? new Date(input.value) : new Date();
    };

    var addMonths = function addMonths(n) {
        var d = base();
        d.setMonth(d.getMonth() + n);
        input.onChange(d);
    };

    var addYears = function addYears(n) {
        var d = base();
        d.setFullYear(d.getFullYear() + n);
        input.onChange(d);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: {
                display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end'
            }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["e" /* DatePicker */], _extends({}, rest, {
            value: input.value ? Object(__WEBPACK_IMPORTED_MODULE_11__helpers_dates__["d" /* toUTC */])(input.value) : undefined,
            onChange: function onChange(_e, date) {
                return input.onChange(date);
            },
            onBlur: function onBlur() {
                return input.onBlur(input.value);
            },
            shouldDisableDate: function shouldDisableDate(dateSelected) {
                return dateSelected.getTime() <= today.getTime();
            },
            errorText: meta.touched && meta.error,
            textFieldStyle: { fontSize: '13px' },
            minDate: today
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
            label: '+1 month',
            type: 'button',
            labelStyle: { fontSize: '12px', padding: 0 },
            style: { marginTop: '16px' },
            onClick: function onClick() {
                return addMonths(1);
            }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
            label: '+1 year',
            type: 'button',
            labelStyle: { fontSize: '12px', padding: 0 },
            style: { marginTop: '16px' },
            onClick: function onClick() {
                return addYears(1);
            }
        }),
        input.value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
            {
                title: 'Remove recommended',
                style: {
                    width: 32, height: 32, padding: 0, marginTop: '16px'
                },
                iconStyle: { color: '#d32f2f' },
                onClick: function onClick() {
                    input.onChange({ endAt: null, at: null, addedBy: null });
                    input.onBlur(null);
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
        ) : null
    );
}

function renderCompanyNameAutoComplete(_ref2) {
    var input = _ref2.input,
        meta = _ref2.meta,
        change = _ref2.change,
        companyIdPath = _ref2.companyIdPath,
        contactPersonPath = _ref2.contactPersonPath;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_CompaniesAutoComplete__["a" /* default */], {
        customValue: input.value || '',
        onTextChange: function onTextChange(val) {
            input.onChange(val);
            change(companyIdPath, undefined);
            change(contactPersonPath, { _id: '', email: '' });
        },
        onCompanySelected: function onCompanySelected(val) {
            var name = val && val.name ? val.name : '';
            var item = val && val.item ? val.item : null;
            var _id = item && item._id ? item._id : undefined;
            input.onChange(name);
            change(companyIdPath, _id ? { _id: _id, name: name } : null);
        },
        floatingLabelText: 'Company name',
        floatingLabelStyle: styles.textField.floatingLabelStyle,
        errorText: meta.touched && meta.error
    });
}

function renderContactUserAutoComplete(_ref3) {
    var input = _ref3.input,
        meta = _ref3.meta,
        change = _ref3.change,
        field = _ref3.field,
        companyFields = _ref3.companyFields;

    var _onUserSelected = function _onUserSelected(value) {
        if (value.company) {
            change(companyFields.companyId, { _id: value.company._id, name: value.company.name });
            change(companyFields.name, value.company.name);
        }

        change('' + field, { _id: value._id, email: value.email });
    };

    var onUserChanging = function onUserChanging(value) {
        change('' + field, { _id: '', email: value });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_UserAutoComplete__["a" /* default */], {
        customValue: input.value && _typeof(input.value) === 'object' ? input.value.email || '' : input.value || '',
        onUserSelected: function onUserSelected(val) {
            var item = val && val.item ? val.item : null;
            var email = item && item.name ? item.name : '';
            var _id = item && item._id ? item._id : undefined;

            change(field, _id || email ? { _id: _id, email: email } : null);

            if (item) {
                _onUserSelected(item);
            }
        },
        onUserChanging: onUserChanging,
        textFieldStyle: { height: '72px' },
        inputStyle: { marginTop: '12px' }
        // errorText={errors}
        , hintText: 'Contact person',
        floatingLabelText: 'Contact person',
        withExtendedData: true,
        errorText: meta.error ? meta.error : null
    });
}

function renderPortLimitations(_ref4) {
    var fields = _ref4.fields;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        fields.map(function (field, limitationIndex) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: 'limitation_' + limitationIndex },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: field + '.berth',
                        floatingLabelText: 'Berth',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])()]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: field + '.maxDraught',
                        floatingLabelText: 'Max draft, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: field + '.maxBeam',
                        floatingLabelText: 'Max beam, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: field + '.maxLOA',
                        floatingLabelText: 'Max LOA, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: field + '.maxDWT',
                        floatingLabelText: 'Max DWT, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000000, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: field + '.channelDepth',
                        floatingLabelText: 'Channel Depth, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'center-xs', style: { display: 'inline-flex', width: '8%' } },
                        limitationIndex === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                            { onClick: function onClick() {
                                    return fields.push(emptyLimitation);
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point___default.a, null)
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                            { onClick: function onClick() {
                                    return fields.remove(limitationIndex);
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                        )
                    )
                )
            );
        })
    );
}

function ServiceProviderFormFields(_ref5) {
    var field = _ref5.field,
        serviceProvider = _ref5.serviceProvider,
        formChange = _ref5.formChange,
        hasRecommended = _ref5.hasRecommended;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(hasRecommended),
        _useState2 = _slicedToArray(_useState, 2),
        _hasRecommended = _useState2[0],
        setHasRecommended = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!serviceProvider) return;
        var activities = Array.isArray(serviceProvider.activities) ? serviceProvider.activities : [];
        var hasPortAgency = activities.includes('Port Agency');
        if (hasPortAgency) return;

        var rec = serviceProvider.recommended;
        var alreadyCleared = !rec || rec.endAt == null && rec.at == null && rec.addedBy == null;
        if (!alreadyCleared) {
            formChange(field + '.recommended', { endAt: null, at: null, addedBy: null });
        }
    }, [field, formChange, serviceProvider && serviceProvider.activities, serviceProvider && serviceProvider.recommended]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setHasRecommended(hasRecommended);
    }, [hasRecommended]);

    var canBeRecommended = function canBeRecommended() {
        if (!hasRecommended) {
            return true;
        }

        if (_hasRecommended._id === serviceProvider._id) {
            return true;
        }

        return false;
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],
                    {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["SelectField"],
                        name: field + '.activities',
                        floatingLabelText: 'Activities',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        multiple: true,
                        value: serviceProvider && serviceProvider.activities,
                        fullWidth: true,
                        autoWidth: true,
                        validate: Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])(),
                        onChange: function onChange(_event, _index, value) {
                            var activities = Array.isArray(value) ? value : [];
                            if (!activities.includes('Port Agency')) {
                                formChange(field + '.recommended', { endAt: null, at: null, addedBy: null });
                            }
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_9_data_portActivities__["a" /* default */].map(function (portActivity, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], { key: index, value: portActivity, primaryText: portActivity });
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                    name: field + '.contactPersonId',
                    component: renderContactUserAutoComplete,
                    validate: [validateContactPerson],
                    props: {
                        change: formChange,
                        field: field + '.contactPersonId',
                        companyFields: {
                            companyId: field + '.companyId',
                            name: field + '.name'
                        }
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                    name: field + '.name',
                    component: renderCompanyNameAutoComplete,
                    validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["length"])({ min: 3, max: 266 })],
                    props: {
                        change: formChange,
                        companyIdPath: field + '.companyId',
                        contactPersonPath: field + '.contactPersonId',
                        currentCompanyId: serviceProvider && serviceProvider.companyId
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], { name: field + '.companyId', component: 'input', type: 'hidden' })
            )
        ),
        serviceProvider && serviceProvider.activities && serviceProvider.activities.includes('Stevedoring Company') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["b" /* FieldArray */], { name: field + '.limitations', component: renderPortLimitations }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["b" /* FieldArray */], { name: field + '.emails', component: __WEBPACK_IMPORTED_MODULE_7__Emails__["a" /* default */] })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["b" /* FieldArray */], { name: field + '.phones', component: __WEBPACK_IMPORTED_MODULE_8__Phones__["a" /* default */] })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], { component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"], name: field + '.address', floatingLabelText: 'Address', floatingLabelStyle: styles.textField.floatingLabelStyle, fullWidth: true, validate: Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])() })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], { component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"], name: field + '.PIC', floatingLabelText: 'PIC', floatingLabelStyle: styles.textField.floatingLabelStyle, fullWidth: true, validate: Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])() })
            )
        ),
        serviceProvider && serviceProvider.activities && Array.isArray(serviceProvider.activities) && canBeRecommended() && serviceProvider.activities.includes('Port Agency') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-5' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-7' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                    name: field + '.recommended.endAt',
                    component: renderRecommendedEndAt,
                    floatingLabelText: 'Recommended until',
                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                    fullWidth: true,
                    validate: [futureDateOnly]
                })
            )
        ) : null
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(emptyLimitation, 'emptyLimitation', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(futureDateOnly, 'futureDateOnly', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(validateContactPerson, 'validateContactPerson', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(renderRecommendedEndAt, 'renderRecommendedEndAt', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(renderCompanyNameAutoComplete, 'renderCompanyNameAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(renderContactUserAutoComplete, 'renderContactUserAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(renderPortLimitations, 'renderPortLimitations', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    reactHotLoader.register(ServiceProviderFormFields, 'ServiceProviderFormFields', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/FormFields.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_data_formNames__ = __webpack_require__(64);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

















var styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    icon: {
        color: 'rgb(0, 188, 212)'
    }
};

function Emails(_ref) {
    var fields = _ref.fields;

    var addEmail = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        fields.push('');
    }, [fields]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        fields.map(function (field, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__["TextField"],
                        name: field,
                        floatingLabelText: 'Email company',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        fullWidth: true,
                        validate: Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["email"])()
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2 center-xs middle-xs' },
                    index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: addEmail
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default.a, null)
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: function onClick() {
                                fields.remove(index);
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                    )
                )
            );
        })
    );
}

Emails.propTypes = {
    fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var selector = Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_11_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        serviceProviders: selector(state, 'serviceProviders')
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_7_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(Emails);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Emails.jsx');
    reactHotLoader.register(Emails, 'Emails', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Emails.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Emails.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Emails.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_data_formNames__ = __webpack_require__(64);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

















var styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    icon: {
        color: 'rgb(0, 188, 212)'
    }
};

function Phones(_ref) {
    var fields = _ref.fields,
        _ref$countries = _ref.countries,
        countries = _ref$countries === undefined ? [] : _ref$countries;

    var addPhone = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        fields.push('');
    }, [fields]);

    var filteredCountries = countries.filter(function (country) {
        return country.phoneCode && country.phoneCode[0];
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        fields.map(function (field, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],
                        {
                            component: __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__["SelectField"],
                            name: field + '.code',
                            floatingLabelText: 'Country',
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            fullWidth: true,
                            autoWidth: true,
                            validate: Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])()
                        },
                        filteredCountries.map(function (country, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], {
                                key: key,
                                value: country.phoneCode ? country.phoneCode[0] : '',
                                primaryText: country.phoneCode[0] + ' ' + country.name
                            });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__["TextField"],
                        name: field + '.phone',
                        floatingLabelText: 'Phone number',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        fullWidth: true,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ int: true }), Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["length"])({ min: 7, max: 15 })]
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2 center-xs middle-xs', style: { display: 'flex' } },
                    index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: addPhone
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default.a, null)
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: function onClick() {
                                fields.remove(index);
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                    )
                )
            );
        })
    );
}

Phones.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    countries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

Phones.defaultProps = {
    port: {},
    countries: []
};

var selector = Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_11_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        countries: state.countries.items,
        serviceProviders: selector(state, 'serviceProviders')
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_7_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(Phones);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Phones.jsx');
    reactHotLoader.register(Phones, 'Phones', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Phones.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Phones.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Phones.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_regions_serviceProvider__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles__ = __webpack_require__(20);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













var dialogStyles = {
    contentStyle: { width: '76%', padding: '20px', maxWidth: 'unset' }
};

var statusesList = [{ name: 'All', value: null }, { name: 'Approved', value: ['approved'] }, { name: 'Rejected', value: ['rejected'] }];

var Row = function Row(_ref) {
    var item = _ref.item;
    var _item$newServiceProvi = item.newServiceProvider,
        name = _item$newServiceProvi.name,
        activities = _item$newServiceProvi.activities,
        address = _item$newServiceProvi.address,
        PIC = _item$newServiceProvi.PIC,
        phones = _item$newServiceProvi.phones,
        emails = _item$newServiceProvi.emails,
        statusAt = item.statusAt,
        status = item.status,
        email = item.statusBy.email;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
            name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
            activities.join(', ')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
            address
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
            PIC
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
            phones.map(function (phone, phoneIndex) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: phoneIndex },
                    phone.code + ' ' + phone.phone
                );
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
            emails.map(function (em, emIndex) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: emIndex },
                    em
                );
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '21%' }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'service-providers-history__table-cell status-at' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'status',
                        style: status === 'approved' ? { color: '#4D9E0E' } : { color: '#E34848' }
                    },
                    status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["a" /* fromUTC */])(statusAt).toLocaleString()
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'by ' + email
                )
            )
        )
    );
};

var ServiceProvidersHistoryDialog = function ServiceProvidersHistoryDialog(_ref2) {
    var open = _ref2.open,
        toggle = _ref2.toggle;

    var defaultPagination = {
        page: 1,
        filters: {
            query: '',
            dateFrom: '',
            dateTo: '',
            statuses: null
        },
        limit: 25
    };

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        rowsPerPage: [25, 50, 100],
        pagination: Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["defaults"])({}, defaultPagination),
        serviceProvidersHistory: [],
        total: 0
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var updateRows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var currentState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state;

            var portId, _currentState$paginat, page, limit, filters, res;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            portId = window.location.pathname.split('/').slice(-1)[0];
                            _currentState$paginat = currentState.pagination, page = _currentState$paginat.page, limit = _currentState$paginat.limit, filters = _currentState$paginat.filters;
                            _context.next = 4;
                            return Object(__WEBPACK_IMPORTED_MODULE_8_services_regions_serviceProvider__["d" /* getServiceProvidersHistory */])(portId, { page: page, limit: limit, filters: filters });

                        case 4:
                            res = _context.sent;

                            setState(function (prev) {
                                return _extends({}, prev, { serviceProvidersHistory: res.data, total: res.total });
                            });

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function () {
            return _ref3.apply(this, arguments);
        };
    }(), [state]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (open) {
            updateRows();
        }
    }, [open]);

    var handleChangeSearch = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e, value) {
        setState(function (prev) {
            return _extends({}, prev, {
                pagination: _extends({}, prev.pagination, {
                    page: 1,
                    filters: _extends({}, prev.pagination.filters, {
                        query: value
                    })
                })
            });
        });
    }, []);

    var handleSearch = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        updateRows();
    }, [updateRows]);

    var handleStartDateFilter = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e, date) {
        setState(function (prev) {
            var newState = _extends({}, prev, {
                pagination: _extends({}, prev.pagination, {
                    page: 1,
                    filters: _extends({}, prev.pagination.filters, {
                        dateFrom: Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["d" /* toUTC */])(date)
                    })
                })
            });
            updateRows(newState);
            return newState;
        });
    }, [updateRows]);

    var handleEndDateFilter = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e, date) {
        setState(function (prev) {
            var newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59));
            var newState = _extends({}, prev, {
                pagination: _extends({}, prev.pagination, {
                    page: 1,
                    filters: _extends({}, prev.pagination.filters, {
                        dateTo: newDate.toISOString()
                    })
                })
            });
            updateRows(newState);
            return newState;
        });
    }, [updateRows]);

    var handleRemoveDate = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (type) {
        setState(function (prev) {
            var newState = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(prev);
            if (type === 'from') {
                newState.pagination.filters.dateFrom = '';
            } else if (type === 'to') {
                newState.pagination.filters.dateTo = '';
            }
            updateRows(newState);
            return newState;
        });
    }, [updateRows]);

    var handleChangePagination = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_ref4) {
        var page = _ref4.page,
            numberOfRows = _ref4.numberOfRows;

        setState(function (prev) {
            var newState = _extends({}, prev, {
                pagination: _extends({}, prev.pagination, {
                    page: page,
                    limit: numberOfRows
                })
            });
            updateRows(newState);
            return newState;
        });
    }, [updateRows]);

    var handleSelectStatus = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (ev, i, value) {
        setState(function (prev) {
            var newState = _extends({}, prev, {
                pagination: _extends({}, prev.pagination, {
                    page: 1,
                    filters: _extends({}, prev.pagination.filters, {
                        statuses: value
                    })
                })
            });
            updateRows(newState);
            return newState;
        });
    }, [updateRows]);

    var _state$pagination = state.pagination,
        _state$pagination$fil = _state$pagination.filters,
        query = _state$pagination$fil.query,
        dateFrom = _state$pagination$fil.dateFrom,
        dateTo = _state$pagination$fil.dateTo,
        statuses = _state$pagination$fil.statuses,
        page = _state$pagination.page,
        limit = _state$pagination.limit,
        rowsPerPage = state.rowsPerPage,
        serviceProvidersHistory = state.serviceProvidersHistory,
        total = state.total;


    var minDate = new Date();
    var maxDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 1);
    maxDate.setFullYear(maxDate.getFullYear() + 1);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui__["f" /* Dialog */],
        {
            open: open,
            contentStyle: dialogStyles.contentStyle,
            onRequestClose: toggle,
            paperClassName: 'dialog-service-provider',
            bodyStyle: { overflowY: 'auto' },
            modal: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'title-wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'title' },
                'Service Provider History'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                { onClick: toggle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default.a, { color: '#B3B3B3' })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'service-providers-history' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'service-providers-history__header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'service-providers-history__header-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["TextField"], {
                        value: query,
                        onChange: handleChangeSearch,
                        hintText: 'Search',
                        onKeyPress: function onKeyPress(event) {
                            if (event.charCode === 13) {
                                event.preventDefault();
                                handleSearch();
                            }
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'service-providers-history__header-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                        label: 'Search',
                        style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].RaisedButton,
                        primary: true,
                        onClick: handleSearch
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'service-providers-history__header-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["s" /* SelectField */],
                        {
                            style: { width: '100%' },
                            fullWidth: true,
                            autoWidth: true,
                            value: statuses,
                            onChange: handleSelectStatus
                        },
                        statusesList.map(function (s, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], {
                                key: key,
                                style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS,
                                value: s.value,
                                primaryText: s.name
                            });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'service-providers-history__header-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
                        total: total,
                        rowsPerPage: rowsPerPage,
                        page: page,
                        numberOfRows: limit,
                        updateRows: handleChangePagination
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'service-providers-history__filters' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'service-providers-history__filters-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["e" /* DatePicker */], {
                        floatingLabelText: 'Filter start date:',
                        autoOk: true,
                        minDate: minDate,
                        maxDate: maxDate,
                        textFieldStyle: { width: '120px' },
                        shouldDisableDate: function shouldDisableDate(dateSelected) {
                            return dateSelected.getTime() > new Date(dateTo).getTime();
                        },
                        onChange: handleStartDateFilter,
                        value: dateFrom ? Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["a" /* fromUTC */])(dateFrom) : undefined
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                        {
                            style: { margin: '25px 7px 0 -7px' },
                            disabled: !dateFrom,
                            onClick: function onClick() {
                                return handleRemoveDate('from');
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: dateFrom ? 'red' : 'black' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'service-providers-history__filters-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["e" /* DatePicker */], {
                        floatingLabelText: 'Filter end date:',
                        autoOk: true,
                        minDate: minDate,
                        maxDate: maxDate,
                        textFieldStyle: { width: '120px' },
                        shouldDisableDate: function shouldDisableDate(dateSelected) {
                            return dateSelected.getTime() < new Date(dateFrom).getTime();
                        },
                        onChange: handleEndDateFilter,
                        value: dateTo ? Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["a" /* fromUTC */])(dateTo) : undefined
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                        {
                            style: { margin: '25px 0 0 -7px' },
                            disabled: !dateTo,
                            onClick: function onClick() {
                                return handleRemoveDate('to');
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: dateTo ? 'red' : 'black' })
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-body service-providers-history__table' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["u" /* Table */],
                    { selectable: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["w" /* TableHeader */],
                        { displaySelectAll: false, adjustForCheckbox: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                'company'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                'activity'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                'address'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                'PIC'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                'phone'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                'email'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '21%' }) },
                                'by User'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["v" /* TableBody */],
                        { displayRowCheckbox: false },
                        serviceProvidersHistory.map(function (item) {
                            return item.newServiceProvider && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, {
                                key: item.newServiceProvider._id + item.statusAt,
                                item: item
                            });
                        })
                    )
                )
            )
        )
    );
};

ServiceProvidersHistoryDialog.propTypes = {
    open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Row.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        newServiceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
            activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
            address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
            PIC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
            phones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
                code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
                phone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
            })).isRequired,
            emails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
            _id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
        }).isRequired,
        statusAt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        statusBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
        }).isRequired
    }).isRequired
};

var _default = ServiceProvidersHistoryDialog;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(dialogStyles, 'dialogStyles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(statusesList, 'statusesList', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(Row, 'Row', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(ServiceProvidersHistoryDialog, 'ServiceProvidersHistoryDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersHistoryDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _withScriptjs = __webpack_require__(2234)

Object.defineProperty(exports, "withScriptjs", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withScriptjs).default
  },
})

var _withGoogleMap = __webpack_require__(2254)

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default
  },
})

var _GoogleMap = __webpack_require__(2255)

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default
  },
})

var _Circle = __webpack_require__(2267)

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default
  },
})

var _Marker = __webpack_require__(2268)

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default
  },
})

var _Polyline = __webpack_require__(2269)

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default
  },
})

var _Polygon = __webpack_require__(2270)

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default
  },
})

var _Rectangle = __webpack_require__(2271)

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default
  },
})

var _InfoWindow = __webpack_require__(2272)

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default
  },
})

var _OverlayView = __webpack_require__(2273)

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default
  },
})

var _GroundOverlay = __webpack_require__(2278)

Object.defineProperty(exports, "GroundOverlay", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroundOverlay).default
  },
})

var _DirectionsRenderer = __webpack_require__(2279)

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default
  },
})

var _FusionTablesLayer = __webpack_require__(2280)

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default
  },
})

var _KmlLayer = __webpack_require__(2281)

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default
  },
})

var _TrafficLayer = __webpack_require__(2282)

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default
  },
})

var _StreetViewPanorama = __webpack_require__(2283)

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default
  },
})

var _BicyclingLayer = __webpack_require__(2284)

Object.defineProperty(exports, "BicyclingLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BicyclingLayer).default
  },
})

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(264),
    metaMap = __webpack_require__(922);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(891);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(924),
    composeArgsRight = __webpack_require__(925),
    countHolders = __webpack_require__(2238),
    createCtor = __webpack_require__(386),
    createRecurry = __webpack_require__(926),
    getHolder = __webpack_require__(557),
    reorder = __webpack_require__(2247),
    replaceHolders = __webpack_require__(387),
    root = __webpack_require__(77);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 924 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 925 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(2239),
    setData = __webpack_require__(929),
    setWrapToString = __webpack_require__(930);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(922),
    noop = __webpack_require__(490);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(377),
    baseLodash = __webpack_require__(556);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(921),
    shortOut = __webpack_require__(730);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(2244),
    insertWrapDetails = __webpack_require__(2245),
    setToString = __webpack_require__(728),
    updateWrapDetails = __webpack_require__(2246);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 931 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(431);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 933 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Areas__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Ports__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sagas_regions_areas__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sagas_regions_ports__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MergeErrorDialog__ = __webpack_require__(2304);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var MergingPage = function (_React$Component) {
    _inherits(MergingPage, _React$Component);

    function MergingPage(props) {
        var _this2 = this;

        _classCallCheck(this, MergingPage);

        var _this = _possibleConstructorReturn(this, (MergingPage.__proto__ || Object.getPrototypeOf(MergingPage)).call(this, props));

        _this.handleMergeErrorOpened = function () {
            _this.setState({
                isMergeErrorOpened: !_this.state.isMergeErrorOpened
            });
        };

        _this.handleBypassError = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var areaInfo, updatedAltsArea;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getArea(_this.state.destinationArea._id);

                        case 3:
                            areaInfo = _context.sent;

                            if (!(areaInfo.status !== 200)) {
                                _context.next = 7;
                                break;
                            }

                            _this.props.addNotification({
                                title: 'Error',
                                message: 'Destination area not found',
                                level: 'error',
                                _id: new Date(),
                                autoDismiss: 10
                            });
                            return _context.abrupt('return');

                        case 7:
                            _context.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].updateAreaAlt({
                                _id: _this.state.destinationArea._id,
                                alt: areaInfo.data.alt.filter(function (a) {
                                    return !_this.state.errorAltNames.includes(a.toLowerCase());
                                })
                            });

                        case 9:
                            updatedAltsArea = _context.sent;

                            if (!(updatedAltsArea.status !== 200)) {
                                _context.next = 13;
                                break;
                            }

                            _this.props.addNotification({
                                title: 'Error',
                                message: updatedAltsArea.data.errors[0].messages[0],
                                level: 'error',
                                _id: new Date(),
                                autoDismiss: 10
                            });

                            return _context.abrupt('return');

                        case 13:

                            _this.mergeAreas();
                            _this.handleMergeErrorOpened();
                            _context.next = 20;
                            break;

                        case 17:
                            _context.prev = 17;
                            _context.t0 = _context['catch'](0);

                            _this.props.addNotification({
                                title: 'Error',
                                message: 'Could not merge areas',
                                level: 'error',
                                _id: new Date(),
                                autoDismiss: 10
                            });

                        case 20:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 17]]);
        }));


        _this.state = {
            sourceArea: {},
            destinationArea: {},

            sourcePort: {},
            destinationPort: {},

            disabledMergeAreas: true,
            disabledMergePorts: true,
            disableAddAreaToArea: true,

            clearAreas: false,
            clearPorts: false,
            errorAltNames: [],
            isMergeErrorOpened: false
        };

        _this.mergePorts = _this.mergePorts.bind(_this);
        _this.mergeAreas = _this.mergeAreas.bind(_this);
        _this.joinAreas = _this.joinAreas.bind(_this);
        _this.addAreaToArea = _this.addAreaToArea.bind(_this);
        _this.addValue = _this.addValue.bind(_this);
        return _this;
    }

    _createClass(MergingPage, [{
        key: 'checkForUpdate',
        value: function checkForUpdate() {
            if (this.state.sourceArea._id && this.state.destinationArea._id) {
                this.setState({
                    disabledMergeAreas: false,
                    disableAddAreaToArea: false
                });
            } else {
                this.setState({
                    disabledMergeAreas: true,
                    disableAddAreaToArea: true
                });
            }

            if (this.state.sourcePort._id && this.state.destinationPort._id) {
                this.setState({
                    disabledMergePorts: false
                });
            } else {
                this.setState({
                    disabledMergePorts: true
                });
            }
        }
    }, {
        key: 'addValue',
        value: function addValue(type, valueObject) {
            var _this3 = this;

            this.setState(_defineProperty({}, type, valueObject), function () {
                _this3.checkForUpdate();
            });
        }
    }, {
        key: 'mergePorts',
        value: function mergePorts() {
            var _this4 = this;

            this.setState({
                disabledMergePorts: true
            }, function () {
                __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].mergeAreaOrPortToPort(_this4.state.destinationPort._id, _this4.state.sourcePort._id).then(function (response) {
                    return _this4.setState({
                        sourcePort: {},
                        destinationPort: {},
                        disabledMergePorts: true,
                        clearPorts: true
                    }, function () {
                        _this4.props.addNotification({
                            title: 'Success',
                            message: response.data.data.message,
                            level: 'success',
                            _id: new Date(),
                            autoDismiss: 2
                        });

                        _this4.setState({
                            clearPorts: false
                        }, function () {
                            if (_this4.props.createNewArea) {
                                _this4.updateAreasAndPorts();
                            }
                        });
                    });
                }).catch(function (error) {
                    _this4.setState({
                        disabledMergePorts: false
                    }, function () {
                        _this4.props.addNotification({
                            title: 'Error',
                            message: error.response.data.errors[0].messages[0],
                            level: 'error',
                            _id: new Date(),
                            autoDismiss: 10
                        });
                    });
                });
            });
        }
    }, {
        key: 'updateAreas',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_8_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_9_sagas_regions_areas__["c" /* getAreas */]);

                            case 2:

                                this.props.createNewArea();

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function updateAreas() {
                return _ref2.apply(this, arguments);
            }

            return updateAreas;
        }()
    }, {
        key: 'updateAreasAndPorts',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_8_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_9_sagas_regions_areas__["c" /* getAreas */]);

                            case 2:
                                _context3.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_8_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_10_sagas_regions_ports__["b" /* getPorts */]);

                            case 4:

                                this.props.createNewArea();

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function updateAreasAndPorts() {
                return _ref3.apply(this, arguments);
            }

            return updateAreasAndPorts;
        }()
    }, {
        key: 'mergeAreas',
        value: function mergeAreas() {
            var _this5 = this;

            this.setState({
                disabledMergeAreas: true
            }, function () {
                __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].mergeAreaToArea(_this5.state.destinationArea._id, _this5.state.sourceArea._id).then(function (response) {
                    return _this5.setState({
                        sourceArea: {},
                        destinationArea: {},
                        disabledMergeAreas: true,
                        clearAreas: true
                    }, function () {
                        _this5.props.addNotification({
                            title: 'Success',
                            message: response.data.data.message,
                            level: 'success',
                            _id: new Date(),
                            autoDismiss: 2
                        });

                        _this5.setState({
                            clearAreas: false,
                            errorAltNames: []
                        }, function () {
                            if (_this5.props.createNewArea) {
                                _this5.updateAreas();
                            }
                        });
                    });
                }).catch(function (error) {
                    _this5.setState({
                        disabledMergeAreas: false
                    }, function () {
                        var message = error.response.data.errors[0].messages[0];
                        _this5.props.addNotification({
                            title: 'Error',
                            message: message,
                            level: 'error',
                            _id: new Date(),
                            autoDismiss: 10
                        });
                        if (/area already exists with this alt names/i.test(message)) {
                            var errorAltNames = [];

                            if (error.response.data.names) {
                                errorAltNames = error.response.data.names.map(function (n) {
                                    return n.toLowerCase();
                                });
                            }

                            _this5.setState({
                                errorAltNames: errorAltNames
                            });
                            _this5.handleMergeErrorOpened();
                        }
                    });
                });
            });
        }
    }, {
        key: 'addAreaToArea',
        value: function addAreaToArea() {
            this.props.updateArea({
                _id: this.state.destinationArea._id,
                name: this.state.destinationArea.name, // to show in the notification
                childs: [].concat(_toConsumableArray(this.state.destinationArea.childs.map(function (item) {
                    return item._id;
                })), [this.state.sourceArea._id])
            });
        }
    }, {
        key: 'joinAreas',
        value: function joinAreas() {
            var _this6 = this;

            this.setState({
                disabledMergeAreas: true
            }, function () {
                __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].joinAreaToArea(_this6.state.destinationArea._id, _this6.state.sourceArea._id).then(function (response) {
                    return _this6.setState({
                        sourceArea: {},
                        destinationArea: {},
                        disabledMergeAreas: true,
                        clearAreas: true
                    }, function () {
                        _this6.props.addNotification({
                            title: 'Success',
                            message: response.data.data.message,
                            level: 'success',
                            _id: new Date(),
                            autoDismiss: 2
                        });

                        _this6.setState({
                            clearAreas: false
                        }, function () {
                            if (_this6.props.createNewArea) {
                                _this6.updateAreas();
                            }
                        });
                    });
                }).catch(function (error) {
                    _this6.setState({
                        disabledMergeAreas: false
                    }, function () {
                        _this6.props.addNotification({
                            title: 'Error',
                            message: error.response.data.errors[0].messages[0],
                            level: 'error',
                            _id: new Date(),
                            autoDismiss: 10
                        });
                    });
                });
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this7 = this;

            if (nextProps.area && nextProps.area._id && this.state.sourceArea._id !== nextProps.area._id) {
                __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].findPortAdmin({ name: nextProps.area.name, onlyAreasWithChild: true }).then(function (response) {
                    if (response.status === 200) {
                        var sourceObject = { name: '' };

                        response.data.data.forEach(function (item) {
                            if (item._id === nextProps.area._id) {
                                sourceObject = item;
                            }
                        });

                        _this7.setState({
                            sourcePort: sourceObject,
                            sourceArea: sourceObject
                        });
                    }
                });
            }
            // Clear sourceArea & destinationArea after update finishes
            if (nextProps.isUpdating !== this.state.isUpdating) {
                this.setState(function (state) {
                    return {
                        isUpdating: nextProps.isUpdating,
                        sourceArea: !nextProps.isUpdating ? {} : state.sourceArea,
                        destinationArea: !nextProps.destinationArea ? {} : state.destinationArea,
                        clearAreas: nextProps.isUpdating // original hack to notify subcomponent
                    };
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                disabledMergeAreas = _state.disabledMergeAreas,
                disabledMergePorts = _state.disabledMergePorts,
                disableAddAreaToArea = _state.disableAddAreaToArea,
                clearAreas = _state.clearAreas,
                clearPorts = _state.clearPorts,
                sourcePort = _state.sourcePort,
                sourceArea = _state.sourceArea,
                errorAltNames = _state.errorAltNames,
                isMergeErrorOpened = _state.isMergeErrorOpened,
                destinationArea = _state.destinationArea;
            var isUpdating = this.props.isUpdating;

            var areaButtonsDisabled = !destinationArea._id || !sourceArea._id || isUpdating;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'merging', className: 'container', style: { maxWidth: '100%' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MergeErrorDialog__["a" /* default */], {
                    errorAltNames: errorAltNames,
                    handleBypassError: this.handleBypassError,
                    handleMergeErrorOpened: this.handleMergeErrorOpened,
                    isMergeErrorOpened: isMergeErrorOpened
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Areas__["a" /* default */], {
                    mergeAreas: this.mergeAreas,
                    joinAreas: this.joinAreas,
                    addAreaToArea: this.addAreaToArea,
                    addValue: this.addValue,
                    disabledBtn: areaButtonsDisabled,
                    disabledAddAreaToArea: areaButtonsDisabled,
                    clearAreas: clearAreas,
                    sourceArea: sourceArea
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Ports__["a" /* default */], {
                    mergePorts: this.mergePorts,
                    addValue: this.addValue,
                    disabledBtn: disabledMergePorts,
                    clearPorts: clearPorts,
                    sourcePort: sourcePort
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return MergingPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref4, _ref5) {
    var isLogged = _ref4.user.isLogged,
        areas = _ref4.areas;
    var area = _ref5.area;
    return {
        isLogged: isLogged,
        area: area,
        isUpdating: areas.isUpdating
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__["a" /* addNotification */],
        updateArea: __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__["g" /* updateArea */]
    }, dispatch);
})(MergingPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MergingPage, 'MergingPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleStar = function ToggleStar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
  );
};
ToggleStar = (0, _pure2.default)(ToggleStar);
ToggleStar.displayName = 'ToggleStar';
ToggleStar.muiName = 'SvgIcon';

exports.default = ToggleStar;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleStarBorder = function ToggleStarBorder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
  );
};
ToggleStarBorder = (0, _pure2.default)(ToggleStarBorder);
ToggleStarBorder.displayName = 'ToggleStarBorder';
ToggleStarBorder.muiName = 'SvgIcon';

exports.default = ToggleStarBorder;

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PortsAreasToggler = function (_React$Component) {
    _inherits(PortsAreasToggler, _React$Component);

    function PortsAreasToggler(props) {
        _classCallCheck(this, PortsAreasToggler);

        return _possibleConstructorReturn(this, (PortsAreasToggler.__proto__ || Object.getPrototypeOf(PortsAreasToggler)).call(this, props));
    }

    _createClass(PortsAreasToggler, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                toggleShowPorts = _props.toggleShowPorts,
                toggleShowAreas = _props.toggleShowAreas,
                showChilds = _props.showChilds;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block margin-10', style: { textAlign: "center", paddingTop: '10px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                    label: 'Ports',
                    secondary: showChilds === 'ports',
                    style: { marginBottom: '10px' },
                    onClick: toggleShowPorts
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                    label: 'Areas',
                    secondary: showChilds !== 'ports',
                    onClick: toggleShowAreas
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PortsAreasToggler;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = PortsAreasToggler;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsAreasToggler, 'PortsAreasToggler', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/PortsAreasToggler.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/PortsAreasToggler.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentRemove = function ContentRemove(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 13H5v-2h14v2z' })
  );
};
ContentRemove = (0, _pure2.default)(ContentRemove);
ContentRemove.displayName = 'ContentRemove';
ContentRemove.muiName = 'SvgIcon';

exports.default = ContentRemove;

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IsEditModeOnContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BlockWrapper__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ServiceProviders_scss__ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ServiceProviders_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ServiceProviders_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ServiceProvidersApproval_Component__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ServiceProvidersView_ServiceProvidersView__ = __webpack_require__(3257);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var IsEditModeOnContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(false);

var ServiceProvidersManagement = function ServiceProvidersManagement(_ref) {
    var port = _ref.port,
        onApproveField = _ref.onApproveField,
        onRejectField = _ref.onRejectField,
        serviceProviders = _ref.serviceProviders,
        onSaveChanges = _ref.onSaveChanges;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isEditing = _useState2[0],
        setIsEditing = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(port.serviceProviders),
        _useState4 = _slicedToArray(_useState3, 2),
        portServiceProviders = _useState4[0],
        setPortServiceProviders = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPortServiceProviders(port.serviceProviders);
    }, [port.serviceProviders]);

    var resetServiceProviders = function resetServiceProviders() {
        setPortServiceProviders(port.serviceProviders);
    };

    var cancelEdit = function cancelEdit() {
        setIsEditing(false);
        resetServiceProviders();
    };

    var hasChanges = serviceProviders && serviceProviders.find(function (s) {
        return ['change', 'new', 'remove'].includes(s.status);
    });

    var saveChanges = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            onSaveChanges(portServiceProviders, function () {
                                setIsEditing(false);
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveChanges() {
            return _ref2.apply(this, arguments);
        };
    }();

    if (hasChanges) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__common_BlockWrapper__["a" /* BlockWrapper */],
            { title: 'Service Providers' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ServiceProvidersApproval_Component__["a" /* default */], {
                serviceProviders: serviceProviders,
                rejectServiceProvider: onRejectField,
                approveServiceProvider: onApproveField
            })
        );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__common_BlockWrapper__["a" /* BlockWrapper */],
        { title: 'Service Providers' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            IsEditModeOnContext.Provider,
            { value: isEditing },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ServiceProvidersView_ServiceProvidersView__["a" /* default */], {
                serviceProviders: portServiceProviders,
                updateServiceProviders: setPortServiceProviders,
                resetServiceProviders: resetServiceProviders
            }),
            isEditing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-actions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                    label: 'Save Changes',
                    primary: true,
                    onClick: saveChanges
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                    label: 'Cancel',
                    secondary: true,
                    onClick: cancelEdit,
                    style: { marginRight: '10px' }
                })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-actions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                    label: 'Edit Service Providers',
                    onClick: function onClick() {
                        return setIsEditing(true);
                    },
                    primary: true
                })
            )
        )
    );
};

ServiceProvidersManagement.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        serviceProviders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    }).isRequired,
    onApproveField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRejectField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    serviceProviders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_5_data_formNames__["a" /* formName */].portUpdate,
    enableReinitialize: true
})(ServiceProvidersManagement);

var _default = ServiceProvidersManagement;
/* harmony default export */ __webpack_exports__["b"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(IsEditModeOnContext, 'IsEditModeOnContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProviders.jsx');
    reactHotLoader.register(ServiceProvidersManagement, 'ServiceProvidersManagement', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProviders.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProviders.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleStar = exports.ToggleStarHalf = exports.ToggleStarBorder = exports.ToggleRadioButtonUnchecked = exports.ToggleRadioButtonChecked = exports.ToggleIndeterminateCheckBox = exports.ToggleCheckBox = exports.ToggleCheckBoxOutlineBlank = exports.SocialWhatshot = exports.SocialShare = exports.SocialSentimentVerySatisfied = exports.SocialSentimentVeryDissatisfied = exports.SocialSentimentSatisfied = exports.SocialSentimentNeutral = exports.SocialSentimentDissatisfied = exports.SocialSchool = exports.SocialPublic = exports.SocialPoll = exports.SocialPlusOne = exports.SocialPerson = exports.SocialPersonOutline = exports.SocialPersonAdd = exports.SocialPeople = exports.SocialPeopleOutline = exports.SocialPartyMode = exports.SocialPages = exports.SocialNotifications = exports.SocialNotificationsPaused = exports.SocialNotificationsOff = exports.SocialNotificationsNone = exports.SocialNotificationsActive = exports.SocialMood = exports.SocialMoodBad = exports.SocialLocationCity = exports.SocialGroup = exports.SocialGroupAdd = exports.SocialDomain = exports.SocialCake = exports.PlacesSpa = exports.PlacesSmokingRooms = exports.PlacesSmokeFree = exports.PlacesRvHookup = exports.PlacesRoomService = exports.PlacesPool = exports.PlacesKitchen = exports.PlacesHotTub = exports.PlacesGolfCourse = exports.PlacesFreeBreakfast = exports.PlacesFitnessCenter = exports.PlacesChildFriendly = exports.PlacesChildCare = exports.PlacesCasino = exports.PlacesBusinessCenter = exports.PlacesBeachAccess = exports.PlacesAllInclusive = exports.PlacesAirportShuttle = exports.PlacesAcUnit = exports.NotificationWifi = exports.NotificationWc = exports.NotificationVpnLock = exports.NotificationVoiceChat = undefined;
exports.NotificationVibration = exports.NotificationTimeToLeave = exports.NotificationTapAndPlay = exports.NotificationSystemUpdate = exports.NotificationSync = exports.NotificationSyncProblem = exports.NotificationSyncDisabled = exports.NotificationSms = exports.NotificationSmsFailed = exports.NotificationSimCardAlert = exports.NotificationSdCard = exports.NotificationRvHookup = exports.NotificationPriorityHigh = exports.NotificationPower = exports.NotificationPhonePaused = exports.NotificationPhoneMissed = exports.NotificationPhoneLocked = exports.NotificationPhoneInTalk = exports.NotificationPhoneForwarded = exports.NotificationPhoneBluetoothSpeaker = exports.NotificationPersonalVideo = exports.NotificationOndemandVideo = exports.NotificationNoEncryption = exports.NotificationNetworkLocked = exports.NotificationNetworkCheck = exports.NotificationMore = exports.NotificationMms = exports.NotificationLiveTv = exports.NotificationFolderSpecial = exports.NotificationEventNote = exports.NotificationEventBusy = exports.NotificationEventAvailable = exports.NotificationEnhancedEncryption = exports.NotificationDriveEta = exports.NotificationDoNotDisturb = exports.NotificationDoNotDisturbOn = exports.NotificationDoNotDisturbOff = exports.NotificationDoNotDisturbAlt = exports.NotificationDiscFull = exports.NotificationConfirmationNumber = exports.NotificationBluetoothAudio = exports.NotificationAirlineSeatReclineNormal = exports.NotificationAirlineSeatReclineExtra = exports.NotificationAirlineSeatLegroomReduced = exports.NotificationAirlineSeatLegroomNormal = exports.NotificationAirlineSeatLegroomExtra = exports.NotificationAirlineSeatIndividualSuite = exports.NotificationAirlineSeatFlat = exports.NotificationAirlineSeatFlatAngled = exports.NotificationAdb = exports.NavigationArrowDropRight = exports.NavigationUnfoldMore = exports.NavigationUnfoldLess = exports.NavigationSubdirectoryArrowRight = exports.NavigationSubdirectoryArrowLeft = exports.NavigationRefresh = exports.NavigationMoreVert = exports.NavigationMoreHoriz = exports.NavigationMenu = exports.NavigationLastPage = exports.NavigationFullscreen = exports.NavigationFullscreenExit = exports.NavigationFirstPage = exports.NavigationExpandMore = exports.NavigationExpandLess = exports.NavigationClose = exports.NavigationChevronRight = exports.NavigationChevronLeft = exports.NavigationCheck = exports.NavigationCancel = exports.NavigationArrowUpward = exports.NavigationArrowForward = exports.NavigationArrowDropUp = exports.NavigationArrowDropDown = exports.NavigationArrowDropDownCircle = exports.NavigationArrowDownward = exports.NavigationArrowBack = exports.NavigationApps = exports.MapsZoomOutMap = exports.MapsTransferWithinAStation = exports.MapsTram = exports.MapsTrain = exports.MapsTraffic = exports.MapsTerrain = exports.MapsSubway = exports.MapsStreetview = exports.MapsStoreMallDirectory = exports.MapsSatellite = exports.MapsRestaurant = exports.MapsRestaurantMenu = exports.MapsRateReview = exports.MapsPlace = exports.MapsPinDrop = exports.MapsPersonPin = exports.MapsPersonPinCircle = exports.MapsNearMe = exports.MapsNavigation = exports.MapsMyLocation = exports.MapsMap = exports.MapsLocalTaxi = undefined;
exports.MapsLocalShipping = exports.MapsLocalSee = exports.MapsLocalPrintshop = exports.MapsLocalPostOffice = exports.MapsLocalPlay = exports.MapsLocalPizza = exports.MapsLocalPhone = exports.MapsLocalPharmacy = exports.MapsLocalParking = exports.MapsLocalOffer = exports.MapsLocalMovies = exports.MapsLocalMall = exports.MapsLocalLibrary = exports.MapsLocalLaundryService = exports.MapsLocalHotel = exports.MapsLocalHospital = exports.MapsLocalGroceryStore = exports.MapsLocalGasStation = exports.MapsLocalFlorist = exports.MapsLocalDrink = exports.MapsLocalDining = exports.MapsLocalConvenienceStore = exports.MapsLocalCarWash = exports.MapsLocalCafe = exports.MapsLocalBar = exports.MapsLocalAtm = exports.MapsLocalAirport = exports.MapsLocalActivity = exports.MapsLayers = exports.MapsLayersClear = exports.MapsHotel = exports.MapsFlight = exports.MapsEvStation = exports.MapsEditLocation = exports.MapsDirections = exports.MapsDirectionsWalk = exports.MapsDirectionsTransit = exports.MapsDirectionsSubway = exports.MapsDirectionsRun = exports.MapsDirectionsRailway = exports.MapsDirectionsCar = exports.MapsDirectionsBus = exports.MapsDirectionsBoat = exports.MapsDirectionsBike = exports.MapsBeenhere = exports.MapsAddLocation = exports.ImageWbSunny = exports.ImageWbIridescent = exports.ImageWbIncandescent = exports.ImageWbCloudy = exports.ImageWbAuto = exports.ImageVignette = exports.ImageViewCompact = exports.ImageViewComfy = exports.ImageTune = exports.ImageTransform = exports.ImageTonality = exports.ImageTimer = exports.ImageTimerOff = exports.ImageTimer3 = exports.ImageTimer10 = exports.ImageTimelapse = exports.ImageTexture = exports.ImageTagFaces = exports.ImageSwitchVideo = exports.ImageSwitchCamera = exports.ImageStyle = exports.ImageStraighten = exports.ImageSlideshow = exports.ImageRotateRight = exports.ImageRotateLeft = exports.ImageRotate90DegreesCcw = exports.ImageRemoveRedEye = exports.ImagePortrait = exports.ImagePictureAsPdf = exports.ImagePhoto = exports.ImagePhotoSizeSelectSmall = exports.ImagePhotoSizeSelectLarge = exports.ImagePhotoSizeSelectActual = exports.ImagePhotoLibrary = exports.ImagePhotoFilter = exports.ImagePhotoCamera = exports.ImagePhotoAlbum = exports.ImagePanorama = exports.ImagePanoramaWideAngle = exports.ImagePanoramaVertical = exports.ImagePanoramaHorizontal = exports.ImagePanoramaFishEye = exports.ImagePalette = exports.ImageNavigateNext = exports.ImageNavigateBefore = exports.ImageNature = exports.ImageNaturePeople = exports.ImageMusicNote = exports.ImageMovieFilter = exports.ImageMovieCreation = exports.ImageMonochromePhotos = exports.ImageLoupe = exports.ImageLooks = exports.ImageLooksTwo = undefined;
exports.ImageLooksOne = exports.ImageLooks6 = exports.ImageLooks5 = exports.ImageLooks4 = exports.ImageLooks3 = exports.ImageLinkedCamera = exports.ImageLens = exports.ImageLeakRemove = exports.ImageLeakAdd = exports.ImageLandscape = exports.ImageIso = exports.ImageImage = exports.ImageImageAspectRatio = exports.ImageHealing = exports.ImageHdrWeak = exports.ImageHdrStrong = exports.ImageHdrOn = exports.ImageHdrOff = exports.ImageGridOn = exports.ImageGridOff = exports.ImageGrain = exports.ImageGradient = exports.ImageFlip = exports.ImageFlashOn = exports.ImageFlashOff = exports.ImageFlashAuto = exports.ImageFlare = exports.ImageFilter = exports.ImageFilterVintage = exports.ImageFilterTiltShift = exports.ImageFilterNone = exports.ImageFilterHdr = exports.ImageFilterFrames = exports.ImageFilterDrama = exports.ImageFilterCenterFocus = exports.ImageFilterBAndW = exports.ImageFilter9 = exports.ImageFilter9Plus = exports.ImageFilter8 = exports.ImageFilter7 = exports.ImageFilter6 = exports.ImageFilter5 = exports.ImageFilter4 = exports.ImageFilter3 = exports.ImageFilter2 = exports.ImageFilter1 = exports.ImageExposure = exports.ImageExposureZero = exports.ImageExposurePlus2 = exports.ImageExposurePlus1 = exports.ImageExposureNeg2 = exports.ImageExposureNeg1 = exports.ImageEdit = exports.ImageDetails = exports.ImageDehaze = exports.ImageCrop = exports.ImageCropSquare = exports.ImageCropRotate = exports.ImageCropPortrait = exports.ImageCropOriginal = exports.ImageCropLandscape = exports.ImageCropFree = exports.ImageCropDin = exports.ImageCrop75 = exports.ImageCrop54 = exports.ImageCrop32 = exports.ImageCrop169 = exports.ImageControlPoint = exports.ImageControlPointDuplicate = exports.ImageCompare = exports.ImageColorize = exports.ImageColorLens = exports.ImageCollections = exports.ImageCollectionsBookmark = exports.ImageCenterFocusWeak = exports.ImageCenterFocusStrong = exports.ImageCamera = exports.ImageCameraRoll = exports.ImageCameraRear = exports.ImageCameraFront = exports.ImageCameraAlt = exports.ImageBurstMode = exports.ImageBrush = exports.ImageBrokenImage = exports.ImageBrightness7 = exports.ImageBrightness6 = exports.ImageBrightness5 = exports.ImageBrightness4 = exports.ImageBrightness3 = exports.ImageBrightness2 = exports.ImageBrightness1 = exports.ImageBlurOn = exports.ImageBlurOff = exports.ImageBlurLinear = exports.ImageBlurCircular = exports.ImageAudiotrack = exports.ImageAssistant = exports.ImageAssistantPhoto = exports.ImageAdjust = exports.ImageAddToPhotos = undefined;
exports.ImageAddAPhoto = exports.HardwareWatch = exports.HardwareVideogameAsset = exports.HardwareTv = exports.HardwareToys = exports.HardwareTablet = exports.HardwareTabletMac = exports.HardwareTabletAndroid = exports.HardwareSpeaker = exports.HardwareSpeakerGroup = exports.HardwareSmartphone = exports.HardwareSimCard = exports.HardwareSecurity = exports.HardwareScanner = exports.HardwareRouter = exports.HardwarePowerInput = exports.HardwarePhonelink = exports.HardwarePhonelinkOff = exports.HardwarePhoneIphone = exports.HardwarePhoneAndroid = exports.HardwareMouse = exports.HardwareMemory = exports.HardwareLaptop = exports.HardwareLaptopWindows = exports.HardwareLaptopMac = exports.HardwareLaptopChromebook = exports.HardwareKeyboard = exports.HardwareKeyboardVoice = exports.HardwareKeyboardTab = exports.HardwareKeyboardReturn = exports.HardwareKeyboardHide = exports.HardwareKeyboardCapslock = exports.HardwareKeyboardBackspace = exports.HardwareKeyboardArrowUp = exports.HardwareKeyboardArrowRight = exports.HardwareKeyboardArrowLeft = exports.HardwareKeyboardArrowDown = exports.HardwareHeadset = exports.HardwareHeadsetMic = exports.HardwareGamepad = exports.HardwareDock = exports.HardwareDevicesOther = exports.HardwareDeviceHub = exports.HardwareDeveloperBoard = exports.HardwareDesktopWindows = exports.HardwareDesktopMac = exports.HardwareComputer = exports.HardwareCast = exports.HardwareCastConnected = exports.FileFolder = exports.FileFolderShared = exports.FileFolderOpen = exports.FileFileUpload = exports.FileFileDownload = exports.FileCreateNewFolder = exports.FileCloud = exports.FileCloudUpload = exports.FileCloudQueue = exports.FileCloudOff = exports.FileCloudDownload = exports.FileCloudDone = exports.FileCloudCircle = exports.FileAttachment = exports.EditorWrapText = exports.EditorVerticalAlignTop = exports.EditorVerticalAlignCenter = exports.EditorVerticalAlignBottom = exports.EditorTitle = exports.EditorTextFields = exports.EditorStrikethroughS = exports.EditorSpaceBar = exports.EditorShowChart = exports.EditorShortText = exports.EditorPublish = exports.EditorPieChart = exports.EditorPieChartOutlined = exports.EditorMultilineChart = exports.EditorMoneyOff = exports.EditorMonetizationOn = exports.EditorModeEdit = exports.EditorModeComment = exports.EditorMergeType = exports.EditorLinearScale = exports.EditorInsertPhoto = exports.EditorInsertLink = exports.EditorInsertInvitation = exports.EditorInsertEmoticon = exports.EditorInsertDriveFile = exports.EditorInsertComment = exports.EditorInsertChart = exports.EditorHighlight = exports.EditorFunctions = exports.EditorFormatUnderlined = exports.EditorFormatTextdirectionRToL = exports.EditorFormatTextdirectionLToR = exports.EditorFormatStrikethrough = exports.EditorFormatSize = exports.EditorFormatShapes = exports.EditorFormatQuote = exports.EditorFormatPaint = undefined;
exports.EditorFormatListNumbered = exports.EditorFormatListBulleted = exports.EditorFormatLineSpacing = exports.EditorFormatItalic = exports.EditorFormatIndentIncrease = exports.EditorFormatIndentDecrease = exports.EditorFormatColorText = exports.EditorFormatColorReset = exports.EditorFormatColorFill = exports.EditorFormatClear = exports.EditorFormatBold = exports.EditorFormatAlignRight = exports.EditorFormatAlignLeft = exports.EditorFormatAlignJustify = exports.EditorFormatAlignCenter = exports.EditorDragHandle = exports.EditorBubbleChart = exports.EditorBorderVertical = exports.EditorBorderTop = exports.EditorBorderStyle = exports.EditorBorderRight = exports.EditorBorderOuter = exports.EditorBorderLeft = exports.EditorBorderInner = exports.EditorBorderHorizontal = exports.EditorBorderColor = exports.EditorBorderClear = exports.EditorBorderBottom = exports.EditorBorderAll = exports.EditorAttachMoney = exports.EditorAttachFile = exports.DeviceWifiTethering = exports.DeviceWifiLock = exports.DeviceWidgets = exports.DeviceWallpaper = exports.DeviceUsb = exports.DeviceStorage = exports.DeviceSignalWifiOff = exports.DeviceSignalWifi4Bar = exports.DeviceSignalWifi4BarLock = exports.DeviceSignalWifi3Bar = exports.DeviceSignalWifi3BarLock = exports.DeviceSignalWifi2Bar = exports.DeviceSignalWifi2BarLock = exports.DeviceSignalWifi1Bar = exports.DeviceSignalWifi1BarLock = exports.DeviceSignalWifi0Bar = exports.DeviceSignalCellularOff = exports.DeviceSignalCellularNull = exports.DeviceSignalCellularNoSim = exports.DeviceSignalCellularConnectedNoInternet4Bar = exports.DeviceSignalCellularConnectedNoInternet3Bar = exports.DeviceSignalCellularConnectedNoInternet2Bar = exports.DeviceSignalCellularConnectedNoInternet1Bar = exports.DeviceSignalCellularConnectedNoInternet0Bar = exports.DeviceSignalCellular4Bar = exports.DeviceSignalCellular3Bar = exports.DeviceSignalCellular2Bar = exports.DeviceSignalCellular1Bar = exports.DeviceSignalCellular0Bar = exports.DeviceSettingsSystemDaydream = exports.DeviceSdStorage = exports.DeviceScreenRotation = exports.DeviceScreenLockRotation = exports.DeviceScreenLockPortrait = exports.DeviceScreenLockLandscape = exports.DeviceNfc = exports.DeviceNetworkWifi = exports.DeviceNetworkCell = exports.DeviceLocationSearching = exports.DeviceLocationDisabled = exports.DeviceGraphicEq = exports.DeviceGpsOff = exports.DeviceGpsNotFixed = exports.DeviceGpsFixed = exports.DeviceDvr = exports.DeviceDevices = exports.DeviceDeveloperMode = exports.DeviceDataUsage = exports.DeviceBrightnessMedium = exports.DeviceBrightnessLow = exports.DeviceBrightnessHigh = exports.DeviceBrightnessAuto = exports.DeviceBluetooth = exports.DeviceBluetoothSearching = exports.DeviceBluetoothDisabled = exports.DeviceBluetoothConnected = exports.DeviceBatteryUnknown = exports.DeviceBatteryStd = exports.DeviceBatteryFull = exports.DeviceBatteryChargingFull = exports.DeviceBatteryCharging90 = exports.DeviceBatteryCharging80 = exports.DeviceBatteryCharging60 = exports.DeviceBatteryCharging50 = exports.DeviceBatteryCharging30 = exports.DeviceBatteryCharging20 = exports.DeviceBatteryAlert = exports.DeviceBattery90 = exports.DeviceBattery80 = undefined;
exports.DeviceBattery60 = exports.DeviceBattery50 = exports.DeviceBattery30 = exports.DeviceBattery20 = exports.DeviceAirplanemodeInactive = exports.DeviceAirplanemodeActive = exports.DeviceAddAlarm = exports.DeviceAccessTime = exports.DeviceAccessAlarms = exports.DeviceAccessAlarm = exports.ContentWeekend = exports.ContentUndo = exports.ContentUnarchive = exports.ContentTextFormat = exports.ContentSort = exports.ContentSend = exports.ContentSelectAll = exports.ContentSave = exports.ContentReport = exports.ContentReply = exports.ContentReplyAll = exports.ContentRemove = exports.ContentRemoveCircle = exports.ContentRemoveCircleOutline = exports.ContentRedo = exports.ContentNextWeek = exports.ContentMoveToInbox = exports.ContentMarkunread = exports.ContentMail = exports.ContentLowPriority = exports.ContentLink = exports.ContentInbox = exports.ContentGesture = exports.ContentForward = exports.ContentFontDownload = exports.ContentFlag = exports.ContentFilterList = exports.ContentDrafts = exports.ContentDeleteSweep = exports.ContentCreate = exports.ContentContentPaste = exports.ContentContentCut = exports.ContentContentCopy = exports.ContentClear = exports.ContentBlock = exports.ContentBackspace = exports.ContentArchive = exports.ContentAdd = exports.ContentAddCircle = exports.ContentAddCircleOutline = exports.ContentAddBox = exports.CommunicationVpnKey = exports.CommunicationVoicemail = exports.CommunicationTextsms = exports.CommunicationSwapCalls = exports.CommunicationStopScreenShare = exports.CommunicationStayPrimaryPortrait = exports.CommunicationStayPrimaryLandscape = exports.CommunicationStayCurrentPortrait = exports.CommunicationStayCurrentLandscape = exports.CommunicationSpeakerPhone = exports.CommunicationScreenShare = exports.CommunicationRssFeed = exports.CommunicationRingVolume = exports.CommunicationPresentToAll = exports.CommunicationPortableWifiOff = exports.CommunicationPhonelinkSetup = exports.CommunicationPhonelinkRing = exports.CommunicationPhonelinkLock = exports.CommunicationPhonelinkErase = exports.CommunicationPhone = exports.CommunicationNoSim = exports.CommunicationMessage = exports.CommunicationMailOutline = exports.CommunicationLocationOn = exports.CommunicationLocationOff = exports.CommunicationLiveHelp = exports.CommunicationInvertColorsOff = exports.CommunicationImportExport = exports.CommunicationImportContacts = exports.CommunicationForum = exports.CommunicationEmail = exports.CommunicationDialpad = exports.CommunicationDialerSip = exports.CommunicationContacts = exports.CommunicationContactPhone = exports.CommunicationContactMail = exports.CommunicationComment = exports.CommunicationClearAll = exports.CommunicationChat = exports.CommunicationChatBubble = exports.CommunicationChatBubbleOutline = exports.CommunicationCall = exports.CommunicationCallSplit = exports.CommunicationCallReceived = exports.CommunicationCallMissed = exports.CommunicationCallMissedOutgoing = exports.CommunicationCallMerge = exports.CommunicationCallMade = exports.CommunicationCallEnd = undefined;
exports.CommunicationBusiness = exports.AvWeb = exports.AvWebAsset = exports.AvVolumeUp = exports.AvVolumeOff = exports.AvVolumeMute = exports.AvVolumeDown = exports.AvVideocam = exports.AvVideocamOff = exports.AvVideoLibrary = exports.AvVideoLabel = exports.AvVideoCall = exports.AvSurroundSound = exports.AvSubtitles = exports.AvSubscriptions = exports.AvStop = exports.AvSortByAlpha = exports.AvSnooze = exports.AvSlowMotionVideo = exports.AvSkipPrevious = exports.AvSkipNext = exports.AvShuffle = exports.AvReplay = exports.AvReplay5 = exports.AvReplay30 = exports.AvReplay10 = exports.AvRepeat = exports.AvRepeatOne = exports.AvRemoveFromQueue = exports.AvRecentActors = exports.AvRadio = exports.AvQueue = exports.AvQueuePlayNext = exports.AvQueueMusic = exports.AvPlaylistPlay = exports.AvPlaylistAdd = exports.AvPlaylistAddCheck = exports.AvPlayCircleOutline = exports.AvPlayCircleFilled = exports.AvPlayArrow = exports.AvPause = exports.AvPauseCircleOutline = exports.AvPauseCircleFilled = exports.AvNote = exports.AvNotInterested = exports.AvNewReleases = exports.AvMusicVideo = exports.AvMovie = exports.AvMic = exports.AvMicOff = exports.AvMicNone = exports.AvLoop = exports.AvLibraryMusic = exports.AvLibraryBooks = exports.AvLibraryAdd = exports.AvHighQuality = exports.AvHearing = exports.AvHd = exports.AvGames = exports.AvForward5 = exports.AvForward30 = exports.AvForward10 = exports.AvFiberSmartRecord = exports.AvFiberPin = exports.AvFiberNew = exports.AvFiberManualRecord = exports.AvFiberDvr = exports.AvFeaturedVideo = exports.AvFeaturedPlayList = exports.AvFastRewind = exports.AvFastForward = exports.AvExplicit = exports.AvEqualizer = exports.AvClosedCaption = exports.AvCallToAction = exports.AvBrandingWatermark = exports.AvAvTimer = exports.AvArtTrack = exports.AvAlbum = exports.AvAirplay = exports.AvAddToQueue = exports.AlertWarning = exports.AlertError = exports.AlertErrorOutline = exports.AlertAddAlert = exports.ActionZoomOut = exports.ActionZoomIn = exports.ActionYoutubeSearchedFor = exports.ActionWork = exports.ActionWatchLater = exports.ActionVisibility = exports.ActionVisibilityOff = exports.ActionViewWeek = exports.ActionViewStream = exports.ActionViewQuilt = exports.ActionViewModule = exports.ActionViewList = exports.ActionViewHeadline = exports.ActionViewDay = exports.ActionViewColumn = undefined;
exports.ActionViewCarousel = exports.ActionViewArray = exports.ActionViewAgenda = exports.ActionVerifiedUser = exports.ActionUpdate = exports.ActionTurnedIn = exports.ActionTurnedInNot = exports.ActionTrendingUp = exports.ActionTrendingFlat = exports.ActionTrendingDown = exports.ActionTranslate = exports.ActionTrackChanges = exports.ActionTouchApp = exports.ActionToll = exports.ActionToday = exports.ActionToc = exports.ActionTimeline = exports.ActionThumbsUpDown = exports.ActionThumbUp = exports.ActionThumbDown = exports.ActionThreeDRotation = exports.ActionTheaters = exports.ActionTab = exports.ActionTabUnselected = exports.ActionSystemUpdateAlt = exports.ActionSwapVerticalCircle = exports.ActionSwapVert = exports.ActionSwapHoriz = exports.ActionSupervisorAccount = exports.ActionSubject = exports.ActionStore = exports.ActionStars = exports.ActionSpellcheck = exports.ActionSpeakerNotes = exports.ActionSpeakerNotesOff = exports.ActionShoppingCart = exports.ActionShoppingBasket = exports.ActionShop = exports.ActionShopTwo = exports.ActionSettings = exports.ActionSettingsVoice = exports.ActionSettingsRemote = exports.ActionSettingsPower = exports.ActionSettingsPhone = exports.ActionSettingsOverscan = exports.ActionSettingsInputSvideo = exports.ActionSettingsInputHdmi = exports.ActionSettingsInputComposite = exports.ActionSettingsInputComponent = exports.ActionSettingsInputAntenna = exports.ActionSettingsEthernet = exports.ActionSettingsCell = exports.ActionSettingsBrightness = exports.ActionSettingsBluetooth = exports.ActionSettingsBackupRestore = exports.ActionSettingsApplications = exports.ActionSearch = exports.ActionSchedule = exports.ActionRowing = exports.ActionRoundedCorner = exports.ActionRoom = exports.ActionRestore = exports.ActionRestorePage = exports.ActionReportProblem = exports.ActionReorder = exports.ActionRemoveShoppingCart = exports.ActionRedeem = exports.ActionRecordVoiceOver = exports.ActionReceipt = exports.ActionQuestionAnswer = exports.ActionQueryBuilder = exports.ActionPrint = exports.ActionPregnantWoman = exports.ActionPowerSettingsNew = exports.ActionPolymer = exports.ActionPlayForWork = exports.ActionPictureInPicture = exports.ActionPictureInPictureAlt = exports.ActionPets = exports.ActionPermScanWifi = exports.ActionPermPhoneMsg = exports.ActionPermMedia = exports.ActionPermIdentity = exports.ActionPermDeviceInformation = exports.ActionPermDataSetting = exports.ActionPermContactCalendar = exports.ActionPermCameraMic = exports.ActionPayment = exports.ActionPanTool = exports.ActionPageview = exports.ActionOpenWith = exports.ActionOpenInNew = exports.ActionOpenInBrowser = exports.ActionOpacity = exports.ActionOfflinePin = exports.ActionNoteAdd = exports.ActionMotorcycle = exports.ActionMarkunreadMailbox = exports.ActionLoyalty = exports.ActionLock = undefined;
exports.ActionLockOutline = exports.ActionLockOpen = exports.ActionList = exports.ActionLineWeight = exports.ActionLineStyle = exports.ActionLightbulbOutline = exports.ActionLaunch = exports.ActionLanguage = exports.ActionLabel = exports.ActionLabelOutline = exports.ActionInvertColors = exports.ActionInput = exports.ActionInfo = exports.ActionInfoOutline = exports.ActionImportantDevices = exports.ActionHttps = exports.ActionHttp = exports.ActionHourglassFull = exports.ActionHourglassEmpty = exports.ActionHome = exports.ActionHistory = exports.ActionHighlightOff = exports.ActionHelp = exports.ActionHelpOutline = exports.ActionGroupWork = exports.ActionGrade = exports.ActionGif = exports.ActionGetApp = exports.ActionGavel = exports.ActionGTranslate = exports.ActionFlipToFront = exports.ActionFlipToBack = exports.ActionFlightTakeoff = exports.ActionFlightLand = exports.ActionFingerprint = exports.ActionFindReplace = exports.ActionFindInPage = exports.ActionFeedback = exports.ActionFavorite = exports.ActionFavoriteBorder = exports.ActionFace = exports.ActionExtension = exports.ActionExplore = exports.ActionExitToApp = exports.ActionEvent = exports.ActionEventSeat = exports.ActionEuroSymbol = exports.ActionEject = exports.ActionDonutSmall = exports.ActionDonutLarge = exports.ActionDone = exports.ActionDoneAll = exports.ActionDns = exports.ActionDescription = exports.ActionDelete = exports.ActionDeleteForever = exports.ActionDateRange = exports.ActionDashboard = exports.ActionCreditCard = exports.ActionCopyright = exports.ActionCompareArrows = exports.ActionCode = exports.ActionClass = exports.ActionChromeReaderMode = exports.ActionCheckCircle = exports.ActionChangeHistory = exports.ActionCardTravel = exports.ActionCardMembership = exports.ActionCardGiftcard = exports.ActionCameraEnhance = exports.ActionCached = exports.ActionBuild = exports.ActionBugReport = exports.ActionBookmark = exports.ActionBookmarkBorder = exports.ActionBook = exports.ActionBackup = exports.ActionAutorenew = exports.ActionAssignment = exports.ActionAssignmentTurnedIn = exports.ActionAssignmentReturned = exports.ActionAssignmentReturn = exports.ActionAssignmentLate = exports.ActionAssignmentInd = exports.ActionAssessment = exports.ActionAspectRatio = exports.ActionAnnouncement = exports.ActionAndroid = exports.ActionAllOut = exports.ActionAlarm = exports.ActionAlarmOn = exports.ActionAlarmOff = exports.ActionAlarmAdd = exports.ActionAddShoppingCart = exports.ActionAccountCircle = exports.ActionAccountBox = exports.ActionAccountBalance = exports.ActionAccountBalanceWallet = exports.ActionAccessible = exports.ActionAccessibility = undefined;

var _accessibility = __webpack_require__(2352);

var _accessibility2 = _interopRequireDefault(_accessibility);

var _accessible = __webpack_require__(2353);

var _accessible2 = _interopRequireDefault(_accessible);

var _accountBalanceWallet = __webpack_require__(2354);

var _accountBalanceWallet2 = _interopRequireDefault(_accountBalanceWallet);

var _accountBalance = __webpack_require__(2355);

var _accountBalance2 = _interopRequireDefault(_accountBalance);

var _accountBox = __webpack_require__(2356);

var _accountBox2 = _interopRequireDefault(_accountBox);

var _accountCircle = __webpack_require__(2357);

var _accountCircle2 = _interopRequireDefault(_accountCircle);

var _addShoppingCart = __webpack_require__(2358);

var _addShoppingCart2 = _interopRequireDefault(_addShoppingCart);

var _alarmAdd = __webpack_require__(2359);

var _alarmAdd2 = _interopRequireDefault(_alarmAdd);

var _alarmOff = __webpack_require__(2360);

var _alarmOff2 = _interopRequireDefault(_alarmOff);

var _alarmOn = __webpack_require__(2361);

var _alarmOn2 = _interopRequireDefault(_alarmOn);

var _alarm = __webpack_require__(2362);

var _alarm2 = _interopRequireDefault(_alarm);

var _allOut = __webpack_require__(2363);

var _allOut2 = _interopRequireDefault(_allOut);

var _android = __webpack_require__(2364);

var _android2 = _interopRequireDefault(_android);

var _announcement = __webpack_require__(2365);

var _announcement2 = _interopRequireDefault(_announcement);

var _aspectRatio = __webpack_require__(2366);

var _aspectRatio2 = _interopRequireDefault(_aspectRatio);

var _assessment = __webpack_require__(2367);

var _assessment2 = _interopRequireDefault(_assessment);

var _assignmentInd = __webpack_require__(2368);

var _assignmentInd2 = _interopRequireDefault(_assignmentInd);

var _assignmentLate = __webpack_require__(2369);

var _assignmentLate2 = _interopRequireDefault(_assignmentLate);

var _assignmentReturn = __webpack_require__(2370);

var _assignmentReturn2 = _interopRequireDefault(_assignmentReturn);

var _assignmentReturned = __webpack_require__(2371);

var _assignmentReturned2 = _interopRequireDefault(_assignmentReturned);

var _assignmentTurnedIn = __webpack_require__(2372);

var _assignmentTurnedIn2 = _interopRequireDefault(_assignmentTurnedIn);

var _assignment = __webpack_require__(2373);

var _assignment2 = _interopRequireDefault(_assignment);

var _autorenew = __webpack_require__(2374);

var _autorenew2 = _interopRequireDefault(_autorenew);

var _backup = __webpack_require__(2375);

var _backup2 = _interopRequireDefault(_backup);

var _book = __webpack_require__(2376);

var _book2 = _interopRequireDefault(_book);

var _bookmarkBorder = __webpack_require__(2377);

var _bookmarkBorder2 = _interopRequireDefault(_bookmarkBorder);

var _bookmark = __webpack_require__(2378);

var _bookmark2 = _interopRequireDefault(_bookmark);

var _bugReport = __webpack_require__(2379);

var _bugReport2 = _interopRequireDefault(_bugReport);

var _build = __webpack_require__(2380);

var _build2 = _interopRequireDefault(_build);

var _cached = __webpack_require__(941);

var _cached2 = _interopRequireDefault(_cached);

var _cameraEnhance = __webpack_require__(2381);

var _cameraEnhance2 = _interopRequireDefault(_cameraEnhance);

var _cardGiftcard = __webpack_require__(2382);

var _cardGiftcard2 = _interopRequireDefault(_cardGiftcard);

var _cardMembership = __webpack_require__(2383);

var _cardMembership2 = _interopRequireDefault(_cardMembership);

var _cardTravel = __webpack_require__(2384);

var _cardTravel2 = _interopRequireDefault(_cardTravel);

var _changeHistory = __webpack_require__(2385);

var _changeHistory2 = _interopRequireDefault(_changeHistory);

var _checkCircle = __webpack_require__(512);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _chromeReaderMode = __webpack_require__(2386);

var _chromeReaderMode2 = _interopRequireDefault(_chromeReaderMode);

var _class = __webpack_require__(2387);

var _class2 = _interopRequireDefault(_class);

var _code = __webpack_require__(2388);

var _code2 = _interopRequireDefault(_code);

var _compareArrows = __webpack_require__(2389);

var _compareArrows2 = _interopRequireDefault(_compareArrows);

var _copyright = __webpack_require__(2390);

var _copyright2 = _interopRequireDefault(_copyright);

var _creditCard = __webpack_require__(2391);

var _creditCard2 = _interopRequireDefault(_creditCard);

var _dashboard = __webpack_require__(2392);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dateRange = __webpack_require__(2393);

var _dateRange2 = _interopRequireDefault(_dateRange);

var _deleteForever = __webpack_require__(2394);

var _deleteForever2 = _interopRequireDefault(_deleteForever);

var _delete = __webpack_require__(79);

var _delete2 = _interopRequireDefault(_delete);

var _description = __webpack_require__(942);

var _description2 = _interopRequireDefault(_description);

var _dns = __webpack_require__(2395);

var _dns2 = _interopRequireDefault(_dns);

var _doneAll = __webpack_require__(802);

var _doneAll2 = _interopRequireDefault(_doneAll);

var _done = __webpack_require__(284);

var _done2 = _interopRequireDefault(_done);

var _donutLarge = __webpack_require__(2396);

var _donutLarge2 = _interopRequireDefault(_donutLarge);

var _donutSmall = __webpack_require__(2397);

var _donutSmall2 = _interopRequireDefault(_donutSmall);

var _eject = __webpack_require__(2398);

var _eject2 = _interopRequireDefault(_eject);

var _euroSymbol = __webpack_require__(2399);

var _euroSymbol2 = _interopRequireDefault(_euroSymbol);

var _eventSeat = __webpack_require__(2400);

var _eventSeat2 = _interopRequireDefault(_eventSeat);

var _event = __webpack_require__(2401);

var _event2 = _interopRequireDefault(_event);

var _exitToApp = __webpack_require__(2402);

var _exitToApp2 = _interopRequireDefault(_exitToApp);

var _explore = __webpack_require__(2403);

var _explore2 = _interopRequireDefault(_explore);

var _extension = __webpack_require__(2404);

var _extension2 = _interopRequireDefault(_extension);

var _face = __webpack_require__(2405);

var _face2 = _interopRequireDefault(_face);

var _favoriteBorder = __webpack_require__(2406);

var _favoriteBorder2 = _interopRequireDefault(_favoriteBorder);

var _favorite = __webpack_require__(2407);

var _favorite2 = _interopRequireDefault(_favorite);

var _feedback = __webpack_require__(2408);

var _feedback2 = _interopRequireDefault(_feedback);

var _findInPage = __webpack_require__(2409);

var _findInPage2 = _interopRequireDefault(_findInPage);

var _findReplace = __webpack_require__(2410);

var _findReplace2 = _interopRequireDefault(_findReplace);

var _fingerprint = __webpack_require__(2411);

var _fingerprint2 = _interopRequireDefault(_fingerprint);

var _flightLand = __webpack_require__(2412);

var _flightLand2 = _interopRequireDefault(_flightLand);

var _flightTakeoff = __webpack_require__(2413);

var _flightTakeoff2 = _interopRequireDefault(_flightTakeoff);

var _flipToBack = __webpack_require__(2414);

var _flipToBack2 = _interopRequireDefault(_flipToBack);

var _flipToFront = __webpack_require__(2415);

var _flipToFront2 = _interopRequireDefault(_flipToFront);

var _gTranslate = __webpack_require__(2416);

var _gTranslate2 = _interopRequireDefault(_gTranslate);

var _gavel = __webpack_require__(2417);

var _gavel2 = _interopRequireDefault(_gavel);

var _getApp = __webpack_require__(2418);

var _getApp2 = _interopRequireDefault(_getApp);

var _gif = __webpack_require__(2419);

var _gif2 = _interopRequireDefault(_gif);

var _grade = __webpack_require__(2420);

var _grade2 = _interopRequireDefault(_grade);

var _groupWork = __webpack_require__(2421);

var _groupWork2 = _interopRequireDefault(_groupWork);

var _helpOutline = __webpack_require__(2422);

var _helpOutline2 = _interopRequireDefault(_helpOutline);

var _help = __webpack_require__(2423);

var _help2 = _interopRequireDefault(_help);

var _highlightOff = __webpack_require__(562);

var _highlightOff2 = _interopRequireDefault(_highlightOff);

var _history = __webpack_require__(383);

var _history2 = _interopRequireDefault(_history);

var _home = __webpack_require__(2424);

var _home2 = _interopRequireDefault(_home);

var _hourglassEmpty = __webpack_require__(2425);

var _hourglassEmpty2 = _interopRequireDefault(_hourglassEmpty);

var _hourglassFull = __webpack_require__(2426);

var _hourglassFull2 = _interopRequireDefault(_hourglassFull);

var _http = __webpack_require__(2427);

var _http2 = _interopRequireDefault(_http);

var _https = __webpack_require__(2428);

var _https2 = _interopRequireDefault(_https);

var _importantDevices = __webpack_require__(2429);

var _importantDevices2 = _interopRequireDefault(_importantDevices);

var _infoOutline = __webpack_require__(286);

var _infoOutline2 = _interopRequireDefault(_infoOutline);

var _info = __webpack_require__(238);

var _info2 = _interopRequireDefault(_info);

var _input = __webpack_require__(2430);

var _input2 = _interopRequireDefault(_input);

var _invertColors = __webpack_require__(2431);

var _invertColors2 = _interopRequireDefault(_invertColors);

var _labelOutline = __webpack_require__(2432);

var _labelOutline2 = _interopRequireDefault(_labelOutline);

var _label = __webpack_require__(2433);

var _label2 = _interopRequireDefault(_label);

var _language = __webpack_require__(2434);

var _language2 = _interopRequireDefault(_language);

var _launch = __webpack_require__(2435);

var _launch2 = _interopRequireDefault(_launch);

var _lightbulbOutline = __webpack_require__(2436);

var _lightbulbOutline2 = _interopRequireDefault(_lightbulbOutline);

var _lineStyle = __webpack_require__(2437);

var _lineStyle2 = _interopRequireDefault(_lineStyle);

var _lineWeight = __webpack_require__(2438);

var _lineWeight2 = _interopRequireDefault(_lineWeight);

var _list = __webpack_require__(943);

var _list2 = _interopRequireDefault(_list);

var _lockOpen = __webpack_require__(2439);

var _lockOpen2 = _interopRequireDefault(_lockOpen);

var _lockOutline = __webpack_require__(2440);

var _lockOutline2 = _interopRequireDefault(_lockOutline);

var _lock = __webpack_require__(2441);

var _lock2 = _interopRequireDefault(_lock);

var _loyalty = __webpack_require__(2442);

var _loyalty2 = _interopRequireDefault(_loyalty);

var _markunreadMailbox = __webpack_require__(2443);

var _markunreadMailbox2 = _interopRequireDefault(_markunreadMailbox);

var _motorcycle = __webpack_require__(2444);

var _motorcycle2 = _interopRequireDefault(_motorcycle);

var _noteAdd = __webpack_require__(2445);

var _noteAdd2 = _interopRequireDefault(_noteAdd);

var _offlinePin = __webpack_require__(2446);

var _offlinePin2 = _interopRequireDefault(_offlinePin);

var _opacity = __webpack_require__(2447);

var _opacity2 = _interopRequireDefault(_opacity);

var _openInBrowser = __webpack_require__(2448);

var _openInBrowser2 = _interopRequireDefault(_openInBrowser);

var _openInNew = __webpack_require__(361);

var _openInNew2 = _interopRequireDefault(_openInNew);

var _openWith = __webpack_require__(2449);

var _openWith2 = _interopRequireDefault(_openWith);

var _pageview = __webpack_require__(2450);

var _pageview2 = _interopRequireDefault(_pageview);

var _panTool = __webpack_require__(2451);

var _panTool2 = _interopRequireDefault(_panTool);

var _payment = __webpack_require__(2452);

var _payment2 = _interopRequireDefault(_payment);

var _permCameraMic = __webpack_require__(2453);

var _permCameraMic2 = _interopRequireDefault(_permCameraMic);

var _permContactCalendar = __webpack_require__(2454);

var _permContactCalendar2 = _interopRequireDefault(_permContactCalendar);

var _permDataSetting = __webpack_require__(2455);

var _permDataSetting2 = _interopRequireDefault(_permDataSetting);

var _permDeviceInformation = __webpack_require__(2456);

var _permDeviceInformation2 = _interopRequireDefault(_permDeviceInformation);

var _permIdentity = __webpack_require__(2457);

var _permIdentity2 = _interopRequireDefault(_permIdentity);

var _permMedia = __webpack_require__(2458);

var _permMedia2 = _interopRequireDefault(_permMedia);

var _permPhoneMsg = __webpack_require__(2459);

var _permPhoneMsg2 = _interopRequireDefault(_permPhoneMsg);

var _permScanWifi = __webpack_require__(2460);

var _permScanWifi2 = _interopRequireDefault(_permScanWifi);

var _pets = __webpack_require__(2461);

var _pets2 = _interopRequireDefault(_pets);

var _pictureInPictureAlt = __webpack_require__(2462);

var _pictureInPictureAlt2 = _interopRequireDefault(_pictureInPictureAlt);

var _pictureInPicture = __webpack_require__(2463);

var _pictureInPicture2 = _interopRequireDefault(_pictureInPicture);

var _playForWork = __webpack_require__(2464);

var _playForWork2 = _interopRequireDefault(_playForWork);

var _polymer = __webpack_require__(2465);

var _polymer2 = _interopRequireDefault(_polymer);

var _powerSettingsNew = __webpack_require__(2466);

var _powerSettingsNew2 = _interopRequireDefault(_powerSettingsNew);

var _pregnantWoman = __webpack_require__(2467);

var _pregnantWoman2 = _interopRequireDefault(_pregnantWoman);

var _print = __webpack_require__(2468);

var _print2 = _interopRequireDefault(_print);

var _queryBuilder = __webpack_require__(2469);

var _queryBuilder2 = _interopRequireDefault(_queryBuilder);

var _questionAnswer = __webpack_require__(2470);

var _questionAnswer2 = _interopRequireDefault(_questionAnswer);

var _receipt = __webpack_require__(2471);

var _receipt2 = _interopRequireDefault(_receipt);

var _recordVoiceOver = __webpack_require__(2472);

var _recordVoiceOver2 = _interopRequireDefault(_recordVoiceOver);

var _redeem = __webpack_require__(2473);

var _redeem2 = _interopRequireDefault(_redeem);

var _removeShoppingCart = __webpack_require__(2474);

var _removeShoppingCart2 = _interopRequireDefault(_removeShoppingCart);

var _reorder = __webpack_require__(2475);

var _reorder2 = _interopRequireDefault(_reorder);

var _reportProblem = __webpack_require__(2476);

var _reportProblem2 = _interopRequireDefault(_reportProblem);

var _restorePage = __webpack_require__(2477);

var _restorePage2 = _interopRequireDefault(_restorePage);

var _restore = __webpack_require__(2478);

var _restore2 = _interopRequireDefault(_restore);

var _room = __webpack_require__(2479);

var _room2 = _interopRequireDefault(_room);

var _roundedCorner = __webpack_require__(2480);

var _roundedCorner2 = _interopRequireDefault(_roundedCorner);

var _rowing = __webpack_require__(2481);

var _rowing2 = _interopRequireDefault(_rowing);

var _schedule = __webpack_require__(2482);

var _schedule2 = _interopRequireDefault(_schedule);

var _search = __webpack_require__(527);

var _search2 = _interopRequireDefault(_search);

var _settingsApplications = __webpack_require__(2483);

var _settingsApplications2 = _interopRequireDefault(_settingsApplications);

var _settingsBackupRestore = __webpack_require__(2484);

var _settingsBackupRestore2 = _interopRequireDefault(_settingsBackupRestore);

var _settingsBluetooth = __webpack_require__(2485);

var _settingsBluetooth2 = _interopRequireDefault(_settingsBluetooth);

var _settingsBrightness = __webpack_require__(2486);

var _settingsBrightness2 = _interopRequireDefault(_settingsBrightness);

var _settingsCell = __webpack_require__(2487);

var _settingsCell2 = _interopRequireDefault(_settingsCell);

var _settingsEthernet = __webpack_require__(2488);

var _settingsEthernet2 = _interopRequireDefault(_settingsEthernet);

var _settingsInputAntenna = __webpack_require__(2489);

var _settingsInputAntenna2 = _interopRequireDefault(_settingsInputAntenna);

var _settingsInputComponent = __webpack_require__(2490);

var _settingsInputComponent2 = _interopRequireDefault(_settingsInputComponent);

var _settingsInputComposite = __webpack_require__(2491);

var _settingsInputComposite2 = _interopRequireDefault(_settingsInputComposite);

var _settingsInputHdmi = __webpack_require__(2492);

var _settingsInputHdmi2 = _interopRequireDefault(_settingsInputHdmi);

var _settingsInputSvideo = __webpack_require__(2493);

var _settingsInputSvideo2 = _interopRequireDefault(_settingsInputSvideo);

var _settingsOverscan = __webpack_require__(2494);

var _settingsOverscan2 = _interopRequireDefault(_settingsOverscan);

var _settingsPhone = __webpack_require__(2495);

var _settingsPhone2 = _interopRequireDefault(_settingsPhone);

var _settingsPower = __webpack_require__(2496);

var _settingsPower2 = _interopRequireDefault(_settingsPower);

var _settingsRemote = __webpack_require__(2497);

var _settingsRemote2 = _interopRequireDefault(_settingsRemote);

var _settingsVoice = __webpack_require__(2498);

var _settingsVoice2 = _interopRequireDefault(_settingsVoice);

var _settings = __webpack_require__(373);

var _settings2 = _interopRequireDefault(_settings);

var _shopTwo = __webpack_require__(2499);

var _shopTwo2 = _interopRequireDefault(_shopTwo);

var _shop = __webpack_require__(2500);

var _shop2 = _interopRequireDefault(_shop);

var _shoppingBasket = __webpack_require__(2501);

var _shoppingBasket2 = _interopRequireDefault(_shoppingBasket);

var _shoppingCart = __webpack_require__(2502);

var _shoppingCart2 = _interopRequireDefault(_shoppingCart);

var _speakerNotesOff = __webpack_require__(2503);

var _speakerNotesOff2 = _interopRequireDefault(_speakerNotesOff);

var _speakerNotes = __webpack_require__(944);

var _speakerNotes2 = _interopRequireDefault(_speakerNotes);

var _spellcheck = __webpack_require__(2504);

var _spellcheck2 = _interopRequireDefault(_spellcheck);

var _stars = __webpack_require__(2505);

var _stars2 = _interopRequireDefault(_stars);

var _store = __webpack_require__(2506);

var _store2 = _interopRequireDefault(_store);

var _subject = __webpack_require__(2507);

var _subject2 = _interopRequireDefault(_subject);

var _supervisorAccount = __webpack_require__(2508);

var _supervisorAccount2 = _interopRequireDefault(_supervisorAccount);

var _swapHoriz = __webpack_require__(2509);

var _swapHoriz2 = _interopRequireDefault(_swapHoriz);

var _swapVert = __webpack_require__(2510);

var _swapVert2 = _interopRequireDefault(_swapVert);

var _swapVerticalCircle = __webpack_require__(2511);

var _swapVerticalCircle2 = _interopRequireDefault(_swapVerticalCircle);

var _systemUpdateAlt = __webpack_require__(2512);

var _systemUpdateAlt2 = _interopRequireDefault(_systemUpdateAlt);

var _tabUnselected = __webpack_require__(2513);

var _tabUnselected2 = _interopRequireDefault(_tabUnselected);

var _tab = __webpack_require__(2514);

var _tab2 = _interopRequireDefault(_tab);

var _theaters = __webpack_require__(2515);

var _theaters2 = _interopRequireDefault(_theaters);

var _threeDRotation = __webpack_require__(2516);

var _threeDRotation2 = _interopRequireDefault(_threeDRotation);

var _thumbDown = __webpack_require__(2517);

var _thumbDown2 = _interopRequireDefault(_thumbDown);

var _thumbUp = __webpack_require__(2518);

var _thumbUp2 = _interopRequireDefault(_thumbUp);

var _thumbsUpDown = __webpack_require__(2519);

var _thumbsUpDown2 = _interopRequireDefault(_thumbsUpDown);

var _timeline = __webpack_require__(2520);

var _timeline2 = _interopRequireDefault(_timeline);

var _toc = __webpack_require__(2521);

var _toc2 = _interopRequireDefault(_toc);

var _today = __webpack_require__(2522);

var _today2 = _interopRequireDefault(_today);

var _toll = __webpack_require__(2523);

var _toll2 = _interopRequireDefault(_toll);

var _touchApp = __webpack_require__(2524);

var _touchApp2 = _interopRequireDefault(_touchApp);

var _trackChanges = __webpack_require__(2525);

var _trackChanges2 = _interopRequireDefault(_trackChanges);

var _translate = __webpack_require__(2526);

var _translate2 = _interopRequireDefault(_translate);

var _trendingDown = __webpack_require__(2527);

var _trendingDown2 = _interopRequireDefault(_trendingDown);

var _trendingFlat = __webpack_require__(2528);

var _trendingFlat2 = _interopRequireDefault(_trendingFlat);

var _trendingUp = __webpack_require__(2529);

var _trendingUp2 = _interopRequireDefault(_trendingUp);

var _turnedInNot = __webpack_require__(2530);

var _turnedInNot2 = _interopRequireDefault(_turnedInNot);

var _turnedIn = __webpack_require__(2531);

var _turnedIn2 = _interopRequireDefault(_turnedIn);

var _update = __webpack_require__(2532);

var _update2 = _interopRequireDefault(_update);

var _verifiedUser = __webpack_require__(2533);

var _verifiedUser2 = _interopRequireDefault(_verifiedUser);

var _viewAgenda = __webpack_require__(2534);

var _viewAgenda2 = _interopRequireDefault(_viewAgenda);

var _viewArray = __webpack_require__(2535);

var _viewArray2 = _interopRequireDefault(_viewArray);

var _viewCarousel = __webpack_require__(2536);

var _viewCarousel2 = _interopRequireDefault(_viewCarousel);

var _viewColumn = __webpack_require__(2537);

var _viewColumn2 = _interopRequireDefault(_viewColumn);

var _viewDay = __webpack_require__(2538);

var _viewDay2 = _interopRequireDefault(_viewDay);

var _viewHeadline = __webpack_require__(2539);

var _viewHeadline2 = _interopRequireDefault(_viewHeadline);

var _viewList = __webpack_require__(2540);

var _viewList2 = _interopRequireDefault(_viewList);

var _viewModule = __webpack_require__(2541);

var _viewModule2 = _interopRequireDefault(_viewModule);

var _viewQuilt = __webpack_require__(2542);

var _viewQuilt2 = _interopRequireDefault(_viewQuilt);

var _viewStream = __webpack_require__(2543);

var _viewStream2 = _interopRequireDefault(_viewStream);

var _viewWeek = __webpack_require__(2544);

var _viewWeek2 = _interopRequireDefault(_viewWeek);

var _visibilityOff = __webpack_require__(2545);

var _visibilityOff2 = _interopRequireDefault(_visibilityOff);

var _visibility = __webpack_require__(559);

var _visibility2 = _interopRequireDefault(_visibility);

var _watchLater = __webpack_require__(2546);

var _watchLater2 = _interopRequireDefault(_watchLater);

var _work = __webpack_require__(2547);

var _work2 = _interopRequireDefault(_work);

var _youtubeSearchedFor = __webpack_require__(2548);

var _youtubeSearchedFor2 = _interopRequireDefault(_youtubeSearchedFor);

var _zoomIn = __webpack_require__(2549);

var _zoomIn2 = _interopRequireDefault(_zoomIn);

var _zoomOut = __webpack_require__(2550);

var _zoomOut2 = _interopRequireDefault(_zoomOut);

var _addAlert = __webpack_require__(2551);

var _addAlert2 = _interopRequireDefault(_addAlert);

var _errorOutline = __webpack_require__(2552);

var _errorOutline2 = _interopRequireDefault(_errorOutline);

var _error = __webpack_require__(2553);

var _error2 = _interopRequireDefault(_error);

var _warning = __webpack_require__(521);

var _warning2 = _interopRequireDefault(_warning);

var _addToQueue = __webpack_require__(2554);

var _addToQueue2 = _interopRequireDefault(_addToQueue);

var _airplay = __webpack_require__(2555);

var _airplay2 = _interopRequireDefault(_airplay);

var _album = __webpack_require__(2556);

var _album2 = _interopRequireDefault(_album);

var _artTrack = __webpack_require__(2557);

var _artTrack2 = _interopRequireDefault(_artTrack);

var _avTimer = __webpack_require__(2558);

var _avTimer2 = _interopRequireDefault(_avTimer);

var _brandingWatermark = __webpack_require__(2559);

var _brandingWatermark2 = _interopRequireDefault(_brandingWatermark);

var _callToAction = __webpack_require__(2560);

var _callToAction2 = _interopRequireDefault(_callToAction);

var _closedCaption = __webpack_require__(2561);

var _closedCaption2 = _interopRequireDefault(_closedCaption);

var _equalizer = __webpack_require__(2562);

var _equalizer2 = _interopRequireDefault(_equalizer);

var _explicit = __webpack_require__(2563);

var _explicit2 = _interopRequireDefault(_explicit);

var _fastForward = __webpack_require__(2564);

var _fastForward2 = _interopRequireDefault(_fastForward);

var _fastRewind = __webpack_require__(2565);

var _fastRewind2 = _interopRequireDefault(_fastRewind);

var _featuredPlayList = __webpack_require__(2566);

var _featuredPlayList2 = _interopRequireDefault(_featuredPlayList);

var _featuredVideo = __webpack_require__(2567);

var _featuredVideo2 = _interopRequireDefault(_featuredVideo);

var _fiberDvr = __webpack_require__(2568);

var _fiberDvr2 = _interopRequireDefault(_fiberDvr);

var _fiberManualRecord = __webpack_require__(2569);

var _fiberManualRecord2 = _interopRequireDefault(_fiberManualRecord);

var _fiberNew = __webpack_require__(2570);

var _fiberNew2 = _interopRequireDefault(_fiberNew);

var _fiberPin = __webpack_require__(2571);

var _fiberPin2 = _interopRequireDefault(_fiberPin);

var _fiberSmartRecord = __webpack_require__(2572);

var _fiberSmartRecord2 = _interopRequireDefault(_fiberSmartRecord);

var _forward = __webpack_require__(2573);

var _forward2 = _interopRequireDefault(_forward);

var _forward3 = __webpack_require__(2574);

var _forward4 = _interopRequireDefault(_forward3);

var _forward5 = __webpack_require__(2575);

var _forward6 = _interopRequireDefault(_forward5);

var _games = __webpack_require__(2576);

var _games2 = _interopRequireDefault(_games);

var _hd = __webpack_require__(2577);

var _hd2 = _interopRequireDefault(_hd);

var _hearing = __webpack_require__(2578);

var _hearing2 = _interopRequireDefault(_hearing);

var _highQuality = __webpack_require__(2579);

var _highQuality2 = _interopRequireDefault(_highQuality);

var _libraryAdd = __webpack_require__(2580);

var _libraryAdd2 = _interopRequireDefault(_libraryAdd);

var _libraryBooks = __webpack_require__(2581);

var _libraryBooks2 = _interopRequireDefault(_libraryBooks);

var _libraryMusic = __webpack_require__(2582);

var _libraryMusic2 = _interopRequireDefault(_libraryMusic);

var _loop = __webpack_require__(2583);

var _loop2 = _interopRequireDefault(_loop);

var _micNone = __webpack_require__(2584);

var _micNone2 = _interopRequireDefault(_micNone);

var _micOff = __webpack_require__(2585);

var _micOff2 = _interopRequireDefault(_micOff);

var _mic = __webpack_require__(2586);

var _mic2 = _interopRequireDefault(_mic);

var _movie = __webpack_require__(2587);

var _movie2 = _interopRequireDefault(_movie);

var _musicVideo = __webpack_require__(2588);

var _musicVideo2 = _interopRequireDefault(_musicVideo);

var _newReleases = __webpack_require__(2589);

var _newReleases2 = _interopRequireDefault(_newReleases);

var _notInterested = __webpack_require__(2590);

var _notInterested2 = _interopRequireDefault(_notInterested);

var _note = __webpack_require__(2591);

var _note2 = _interopRequireDefault(_note);

var _pauseCircleFilled = __webpack_require__(2592);

var _pauseCircleFilled2 = _interopRequireDefault(_pauseCircleFilled);

var _pauseCircleOutline = __webpack_require__(2593);

var _pauseCircleOutline2 = _interopRequireDefault(_pauseCircleOutline);

var _pause = __webpack_require__(2594);

var _pause2 = _interopRequireDefault(_pause);

var _playArrow = __webpack_require__(2595);

var _playArrow2 = _interopRequireDefault(_playArrow);

var _playCircleFilled = __webpack_require__(2596);

var _playCircleFilled2 = _interopRequireDefault(_playCircleFilled);

var _playCircleOutline = __webpack_require__(2597);

var _playCircleOutline2 = _interopRequireDefault(_playCircleOutline);

var _playlistAddCheck = __webpack_require__(2598);

var _playlistAddCheck2 = _interopRequireDefault(_playlistAddCheck);

var _playlistAdd = __webpack_require__(2599);

var _playlistAdd2 = _interopRequireDefault(_playlistAdd);

var _playlistPlay = __webpack_require__(2600);

var _playlistPlay2 = _interopRequireDefault(_playlistPlay);

var _queueMusic = __webpack_require__(2601);

var _queueMusic2 = _interopRequireDefault(_queueMusic);

var _queuePlayNext = __webpack_require__(2602);

var _queuePlayNext2 = _interopRequireDefault(_queuePlayNext);

var _queue = __webpack_require__(2603);

var _queue2 = _interopRequireDefault(_queue);

var _radio = __webpack_require__(2604);

var _radio2 = _interopRequireDefault(_radio);

var _recentActors = __webpack_require__(2605);

var _recentActors2 = _interopRequireDefault(_recentActors);

var _removeFromQueue = __webpack_require__(2606);

var _removeFromQueue2 = _interopRequireDefault(_removeFromQueue);

var _repeatOne = __webpack_require__(2607);

var _repeatOne2 = _interopRequireDefault(_repeatOne);

var _repeat = __webpack_require__(2608);

var _repeat2 = _interopRequireDefault(_repeat);

var _replay = __webpack_require__(2609);

var _replay2 = _interopRequireDefault(_replay);

var _replay3 = __webpack_require__(2610);

var _replay4 = _interopRequireDefault(_replay3);

var _replay5 = __webpack_require__(2611);

var _replay6 = _interopRequireDefault(_replay5);

var _replay7 = __webpack_require__(945);

var _replay8 = _interopRequireDefault(_replay7);

var _shuffle = __webpack_require__(2612);

var _shuffle2 = _interopRequireDefault(_shuffle);

var _skipNext = __webpack_require__(2613);

var _skipNext2 = _interopRequireDefault(_skipNext);

var _skipPrevious = __webpack_require__(2614);

var _skipPrevious2 = _interopRequireDefault(_skipPrevious);

var _slowMotionVideo = __webpack_require__(2615);

var _slowMotionVideo2 = _interopRequireDefault(_slowMotionVideo);

var _snooze = __webpack_require__(2616);

var _snooze2 = _interopRequireDefault(_snooze);

var _sortByAlpha = __webpack_require__(2617);

var _sortByAlpha2 = _interopRequireDefault(_sortByAlpha);

var _stop = __webpack_require__(2618);

var _stop2 = _interopRequireDefault(_stop);

var _subscriptions = __webpack_require__(2619);

var _subscriptions2 = _interopRequireDefault(_subscriptions);

var _subtitles = __webpack_require__(2620);

var _subtitles2 = _interopRequireDefault(_subtitles);

var _surroundSound = __webpack_require__(2621);

var _surroundSound2 = _interopRequireDefault(_surroundSound);

var _videoCall = __webpack_require__(2622);

var _videoCall2 = _interopRequireDefault(_videoCall);

var _videoLabel = __webpack_require__(2623);

var _videoLabel2 = _interopRequireDefault(_videoLabel);

var _videoLibrary = __webpack_require__(2624);

var _videoLibrary2 = _interopRequireDefault(_videoLibrary);

var _videocamOff = __webpack_require__(2625);

var _videocamOff2 = _interopRequireDefault(_videocamOff);

var _videocam = __webpack_require__(2626);

var _videocam2 = _interopRequireDefault(_videocam);

var _volumeDown = __webpack_require__(2627);

var _volumeDown2 = _interopRequireDefault(_volumeDown);

var _volumeMute = __webpack_require__(2628);

var _volumeMute2 = _interopRequireDefault(_volumeMute);

var _volumeOff = __webpack_require__(2629);

var _volumeOff2 = _interopRequireDefault(_volumeOff);

var _volumeUp = __webpack_require__(2630);

var _volumeUp2 = _interopRequireDefault(_volumeUp);

var _webAsset = __webpack_require__(2631);

var _webAsset2 = _interopRequireDefault(_webAsset);

var _web = __webpack_require__(2632);

var _web2 = _interopRequireDefault(_web);

var _business = __webpack_require__(2633);

var _business2 = _interopRequireDefault(_business);

var _callEnd = __webpack_require__(2634);

var _callEnd2 = _interopRequireDefault(_callEnd);

var _callMade = __webpack_require__(2635);

var _callMade2 = _interopRequireDefault(_callMade);

var _callMerge = __webpack_require__(2636);

var _callMerge2 = _interopRequireDefault(_callMerge);

var _callMissedOutgoing = __webpack_require__(2637);

var _callMissedOutgoing2 = _interopRequireDefault(_callMissedOutgoing);

var _callMissed = __webpack_require__(2638);

var _callMissed2 = _interopRequireDefault(_callMissed);

var _callReceived = __webpack_require__(2639);

var _callReceived2 = _interopRequireDefault(_callReceived);

var _callSplit = __webpack_require__(2640);

var _callSplit2 = _interopRequireDefault(_callSplit);

var _call = __webpack_require__(2641);

var _call2 = _interopRequireDefault(_call);

var _chatBubbleOutline = __webpack_require__(2642);

var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);

var _chatBubble = __webpack_require__(2643);

var _chatBubble2 = _interopRequireDefault(_chatBubble);

var _chat = __webpack_require__(2644);

var _chat2 = _interopRequireDefault(_chat);

var _clearAll = __webpack_require__(2645);

var _clearAll2 = _interopRequireDefault(_clearAll);

var _comment = __webpack_require__(2646);

var _comment2 = _interopRequireDefault(_comment);

var _contactMail = __webpack_require__(2647);

var _contactMail2 = _interopRequireDefault(_contactMail);

var _contactPhone = __webpack_require__(2648);

var _contactPhone2 = _interopRequireDefault(_contactPhone);

var _contacts = __webpack_require__(2649);

var _contacts2 = _interopRequireDefault(_contacts);

var _dialerSip = __webpack_require__(2650);

var _dialerSip2 = _interopRequireDefault(_dialerSip);

var _dialpad = __webpack_require__(2651);

var _dialpad2 = _interopRequireDefault(_dialpad);

var _email = __webpack_require__(2652);

var _email2 = _interopRequireDefault(_email);

var _forum = __webpack_require__(2653);

var _forum2 = _interopRequireDefault(_forum);

var _importContacts = __webpack_require__(2654);

var _importContacts2 = _interopRequireDefault(_importContacts);

var _importExport = __webpack_require__(2655);

var _importExport2 = _interopRequireDefault(_importExport);

var _invertColorsOff = __webpack_require__(2656);

var _invertColorsOff2 = _interopRequireDefault(_invertColorsOff);

var _liveHelp = __webpack_require__(2657);

var _liveHelp2 = _interopRequireDefault(_liveHelp);

var _locationOff = __webpack_require__(2658);

var _locationOff2 = _interopRequireDefault(_locationOff);

var _locationOn = __webpack_require__(2659);

var _locationOn2 = _interopRequireDefault(_locationOn);

var _mailOutline = __webpack_require__(2660);

var _mailOutline2 = _interopRequireDefault(_mailOutline);

var _message = __webpack_require__(2661);

var _message2 = _interopRequireDefault(_message);

var _noSim = __webpack_require__(2662);

var _noSim2 = _interopRequireDefault(_noSim);

var _phone = __webpack_require__(2663);

var _phone2 = _interopRequireDefault(_phone);

var _phonelinkErase = __webpack_require__(2664);

var _phonelinkErase2 = _interopRequireDefault(_phonelinkErase);

var _phonelinkLock = __webpack_require__(2665);

var _phonelinkLock2 = _interopRequireDefault(_phonelinkLock);

var _phonelinkRing = __webpack_require__(2666);

var _phonelinkRing2 = _interopRequireDefault(_phonelinkRing);

var _phonelinkSetup = __webpack_require__(2667);

var _phonelinkSetup2 = _interopRequireDefault(_phonelinkSetup);

var _portableWifiOff = __webpack_require__(2668);

var _portableWifiOff2 = _interopRequireDefault(_portableWifiOff);

var _presentToAll = __webpack_require__(2669);

var _presentToAll2 = _interopRequireDefault(_presentToAll);

var _ringVolume = __webpack_require__(2670);

var _ringVolume2 = _interopRequireDefault(_ringVolume);

var _rssFeed = __webpack_require__(2671);

var _rssFeed2 = _interopRequireDefault(_rssFeed);

var _screenShare = __webpack_require__(2672);

var _screenShare2 = _interopRequireDefault(_screenShare);

var _speakerPhone = __webpack_require__(2673);

var _speakerPhone2 = _interopRequireDefault(_speakerPhone);

var _stayCurrentLandscape = __webpack_require__(2674);

var _stayCurrentLandscape2 = _interopRequireDefault(_stayCurrentLandscape);

var _stayCurrentPortrait = __webpack_require__(2675);

var _stayCurrentPortrait2 = _interopRequireDefault(_stayCurrentPortrait);

var _stayPrimaryLandscape = __webpack_require__(2676);

var _stayPrimaryLandscape2 = _interopRequireDefault(_stayPrimaryLandscape);

var _stayPrimaryPortrait = __webpack_require__(2677);

var _stayPrimaryPortrait2 = _interopRequireDefault(_stayPrimaryPortrait);

var _stopScreenShare = __webpack_require__(2678);

var _stopScreenShare2 = _interopRequireDefault(_stopScreenShare);

var _swapCalls = __webpack_require__(2679);

var _swapCalls2 = _interopRequireDefault(_swapCalls);

var _textsms = __webpack_require__(2680);

var _textsms2 = _interopRequireDefault(_textsms);

var _voicemail = __webpack_require__(2681);

var _voicemail2 = _interopRequireDefault(_voicemail);

var _vpnKey = __webpack_require__(2682);

var _vpnKey2 = _interopRequireDefault(_vpnKey);

var _addBox = __webpack_require__(2683);

var _addBox2 = _interopRequireDefault(_addBox);

var _addCircleOutline = __webpack_require__(46);

var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);

var _addCircle = __webpack_require__(2684);

var _addCircle2 = _interopRequireDefault(_addCircle);

var _add = __webpack_require__(285);

var _add2 = _interopRequireDefault(_add);

var _archive = __webpack_require__(2685);

var _archive2 = _interopRequireDefault(_archive);

var _backspace = __webpack_require__(2686);

var _backspace2 = _interopRequireDefault(_backspace);

var _block = __webpack_require__(2687);

var _block2 = _interopRequireDefault(_block);

var _clear = __webpack_require__(282);

var _clear2 = _interopRequireDefault(_clear);

var _contentCopy = __webpack_require__(522);

var _contentCopy2 = _interopRequireDefault(_contentCopy);

var _contentCut = __webpack_require__(2688);

var _contentCut2 = _interopRequireDefault(_contentCut);

var _contentPaste = __webpack_require__(2689);

var _contentPaste2 = _interopRequireDefault(_contentPaste);

var _create = __webpack_require__(83);

var _create2 = _interopRequireDefault(_create);

var _deleteSweep = __webpack_require__(946);

var _deleteSweep2 = _interopRequireDefault(_deleteSweep);

var _drafts = __webpack_require__(2690);

var _drafts2 = _interopRequireDefault(_drafts);

var _filterList = __webpack_require__(2691);

var _filterList2 = _interopRequireDefault(_filterList);

var _flag = __webpack_require__(2692);

var _flag2 = _interopRequireDefault(_flag);

var _fontDownload = __webpack_require__(2693);

var _fontDownload2 = _interopRequireDefault(_fontDownload);

var _forward7 = __webpack_require__(2694);

var _forward8 = _interopRequireDefault(_forward7);

var _gesture = __webpack_require__(2695);

var _gesture2 = _interopRequireDefault(_gesture);

var _inbox = __webpack_require__(2696);

var _inbox2 = _interopRequireDefault(_inbox);

var _link = __webpack_require__(2697);

var _link2 = _interopRequireDefault(_link);

var _lowPriority = __webpack_require__(2698);

var _lowPriority2 = _interopRequireDefault(_lowPriority);

var _mail = __webpack_require__(2699);

var _mail2 = _interopRequireDefault(_mail);

var _markunread = __webpack_require__(2700);

var _markunread2 = _interopRequireDefault(_markunread);

var _moveToInbox = __webpack_require__(2701);

var _moveToInbox2 = _interopRequireDefault(_moveToInbox);

var _nextWeek = __webpack_require__(2702);

var _nextWeek2 = _interopRequireDefault(_nextWeek);

var _redo = __webpack_require__(2703);

var _redo2 = _interopRequireDefault(_redo);

var _removeCircleOutline = __webpack_require__(33);

var _removeCircleOutline2 = _interopRequireDefault(_removeCircleOutline);

var _removeCircle = __webpack_require__(2704);

var _removeCircle2 = _interopRequireDefault(_removeCircle);

var _remove = __webpack_require__(938);

var _remove2 = _interopRequireDefault(_remove);

var _replyAll = __webpack_require__(2705);

var _replyAll2 = _interopRequireDefault(_replyAll);

var _reply = __webpack_require__(2706);

var _reply2 = _interopRequireDefault(_reply);

var _report = __webpack_require__(2707);

var _report2 = _interopRequireDefault(_report);

var _save = __webpack_require__(564);

var _save2 = _interopRequireDefault(_save);

var _selectAll = __webpack_require__(2708);

var _selectAll2 = _interopRequireDefault(_selectAll);

var _send = __webpack_require__(2709);

var _send2 = _interopRequireDefault(_send);

var _sort = __webpack_require__(2710);

var _sort2 = _interopRequireDefault(_sort);

var _textFormat = __webpack_require__(2711);

var _textFormat2 = _interopRequireDefault(_textFormat);

var _unarchive = __webpack_require__(2712);

var _unarchive2 = _interopRequireDefault(_unarchive);

var _undo = __webpack_require__(2713);

var _undo2 = _interopRequireDefault(_undo);

var _weekend = __webpack_require__(2714);

var _weekend2 = _interopRequireDefault(_weekend);

var _accessAlarm = __webpack_require__(2715);

var _accessAlarm2 = _interopRequireDefault(_accessAlarm);

var _accessAlarms = __webpack_require__(2716);

var _accessAlarms2 = _interopRequireDefault(_accessAlarms);

var _accessTime = __webpack_require__(2717);

var _accessTime2 = _interopRequireDefault(_accessTime);

var _addAlarm = __webpack_require__(2718);

var _addAlarm2 = _interopRequireDefault(_addAlarm);

var _airplanemodeActive = __webpack_require__(2719);

var _airplanemodeActive2 = _interopRequireDefault(_airplanemodeActive);

var _airplanemodeInactive = __webpack_require__(2720);

var _airplanemodeInactive2 = _interopRequireDefault(_airplanemodeInactive);

var _battery = __webpack_require__(2721);

var _battery2 = _interopRequireDefault(_battery);

var _battery3 = __webpack_require__(2722);

var _battery4 = _interopRequireDefault(_battery3);

var _battery5 = __webpack_require__(2723);

var _battery6 = _interopRequireDefault(_battery5);

var _battery7 = __webpack_require__(2724);

var _battery8 = _interopRequireDefault(_battery7);

var _battery9 = __webpack_require__(2725);

var _battery10 = _interopRequireDefault(_battery9);

var _battery11 = __webpack_require__(2726);

var _battery12 = _interopRequireDefault(_battery11);

var _batteryAlert = __webpack_require__(2727);

var _batteryAlert2 = _interopRequireDefault(_batteryAlert);

var _batteryCharging = __webpack_require__(2728);

var _batteryCharging2 = _interopRequireDefault(_batteryCharging);

var _batteryCharging3 = __webpack_require__(2729);

var _batteryCharging4 = _interopRequireDefault(_batteryCharging3);

var _batteryCharging5 = __webpack_require__(2730);

var _batteryCharging6 = _interopRequireDefault(_batteryCharging5);

var _batteryCharging7 = __webpack_require__(2731);

var _batteryCharging8 = _interopRequireDefault(_batteryCharging7);

var _batteryCharging9 = __webpack_require__(2732);

var _batteryCharging10 = _interopRequireDefault(_batteryCharging9);

var _batteryCharging11 = __webpack_require__(2733);

var _batteryCharging12 = _interopRequireDefault(_batteryCharging11);

var _batteryChargingFull = __webpack_require__(2734);

var _batteryChargingFull2 = _interopRequireDefault(_batteryChargingFull);

var _batteryFull = __webpack_require__(2735);

var _batteryFull2 = _interopRequireDefault(_batteryFull);

var _batteryStd = __webpack_require__(2736);

var _batteryStd2 = _interopRequireDefault(_batteryStd);

var _batteryUnknown = __webpack_require__(2737);

var _batteryUnknown2 = _interopRequireDefault(_batteryUnknown);

var _bluetoothConnected = __webpack_require__(2738);

var _bluetoothConnected2 = _interopRequireDefault(_bluetoothConnected);

var _bluetoothDisabled = __webpack_require__(2739);

var _bluetoothDisabled2 = _interopRequireDefault(_bluetoothDisabled);

var _bluetoothSearching = __webpack_require__(2740);

var _bluetoothSearching2 = _interopRequireDefault(_bluetoothSearching);

var _bluetooth = __webpack_require__(2741);

var _bluetooth2 = _interopRequireDefault(_bluetooth);

var _brightnessAuto = __webpack_require__(2742);

var _brightnessAuto2 = _interopRequireDefault(_brightnessAuto);

var _brightnessHigh = __webpack_require__(2743);

var _brightnessHigh2 = _interopRequireDefault(_brightnessHigh);

var _brightnessLow = __webpack_require__(2744);

var _brightnessLow2 = _interopRequireDefault(_brightnessLow);

var _brightnessMedium = __webpack_require__(2745);

var _brightnessMedium2 = _interopRequireDefault(_brightnessMedium);

var _dataUsage = __webpack_require__(2746);

var _dataUsage2 = _interopRequireDefault(_dataUsage);

var _developerMode = __webpack_require__(2747);

var _developerMode2 = _interopRequireDefault(_developerMode);

var _devices = __webpack_require__(2748);

var _devices2 = _interopRequireDefault(_devices);

var _dvr = __webpack_require__(2749);

var _dvr2 = _interopRequireDefault(_dvr);

var _gpsFixed = __webpack_require__(2750);

var _gpsFixed2 = _interopRequireDefault(_gpsFixed);

var _gpsNotFixed = __webpack_require__(2751);

var _gpsNotFixed2 = _interopRequireDefault(_gpsNotFixed);

var _gpsOff = __webpack_require__(2752);

var _gpsOff2 = _interopRequireDefault(_gpsOff);

var _graphicEq = __webpack_require__(2753);

var _graphicEq2 = _interopRequireDefault(_graphicEq);

var _locationDisabled = __webpack_require__(2754);

var _locationDisabled2 = _interopRequireDefault(_locationDisabled);

var _locationSearching = __webpack_require__(2755);

var _locationSearching2 = _interopRequireDefault(_locationSearching);

var _networkCell = __webpack_require__(2756);

var _networkCell2 = _interopRequireDefault(_networkCell);

var _networkWifi = __webpack_require__(2757);

var _networkWifi2 = _interopRequireDefault(_networkWifi);

var _nfc = __webpack_require__(2758);

var _nfc2 = _interopRequireDefault(_nfc);

var _screenLockLandscape = __webpack_require__(2759);

var _screenLockLandscape2 = _interopRequireDefault(_screenLockLandscape);

var _screenLockPortrait = __webpack_require__(2760);

var _screenLockPortrait2 = _interopRequireDefault(_screenLockPortrait);

var _screenLockRotation = __webpack_require__(2761);

var _screenLockRotation2 = _interopRequireDefault(_screenLockRotation);

var _screenRotation = __webpack_require__(2762);

var _screenRotation2 = _interopRequireDefault(_screenRotation);

var _sdStorage = __webpack_require__(2763);

var _sdStorage2 = _interopRequireDefault(_sdStorage);

var _settingsSystemDaydream = __webpack_require__(2764);

var _settingsSystemDaydream2 = _interopRequireDefault(_settingsSystemDaydream);

var _signalCellular0Bar = __webpack_require__(2765);

var _signalCellular0Bar2 = _interopRequireDefault(_signalCellular0Bar);

var _signalCellular1Bar = __webpack_require__(2766);

var _signalCellular1Bar2 = _interopRequireDefault(_signalCellular1Bar);

var _signalCellular2Bar = __webpack_require__(2767);

var _signalCellular2Bar2 = _interopRequireDefault(_signalCellular2Bar);

var _signalCellular3Bar = __webpack_require__(2768);

var _signalCellular3Bar2 = _interopRequireDefault(_signalCellular3Bar);

var _signalCellular4Bar = __webpack_require__(2769);

var _signalCellular4Bar2 = _interopRequireDefault(_signalCellular4Bar);

var _signalCellularConnectedNoInternet0Bar = __webpack_require__(2770);

var _signalCellularConnectedNoInternet0Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet0Bar);

var _signalCellularConnectedNoInternet1Bar = __webpack_require__(2771);

var _signalCellularConnectedNoInternet1Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet1Bar);

var _signalCellularConnectedNoInternet2Bar = __webpack_require__(2772);

var _signalCellularConnectedNoInternet2Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet2Bar);

var _signalCellularConnectedNoInternet3Bar = __webpack_require__(2773);

var _signalCellularConnectedNoInternet3Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet3Bar);

var _signalCellularConnectedNoInternet4Bar = __webpack_require__(2774);

var _signalCellularConnectedNoInternet4Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet4Bar);

var _signalCellularNoSim = __webpack_require__(2775);

var _signalCellularNoSim2 = _interopRequireDefault(_signalCellularNoSim);

var _signalCellularNull = __webpack_require__(2776);

var _signalCellularNull2 = _interopRequireDefault(_signalCellularNull);

var _signalCellularOff = __webpack_require__(2777);

var _signalCellularOff2 = _interopRequireDefault(_signalCellularOff);

var _signalWifi0Bar = __webpack_require__(2778);

var _signalWifi0Bar2 = _interopRequireDefault(_signalWifi0Bar);

var _signalWifi1BarLock = __webpack_require__(2779);

var _signalWifi1BarLock2 = _interopRequireDefault(_signalWifi1BarLock);

var _signalWifi1Bar = __webpack_require__(2780);

var _signalWifi1Bar2 = _interopRequireDefault(_signalWifi1Bar);

var _signalWifi2BarLock = __webpack_require__(2781);

var _signalWifi2BarLock2 = _interopRequireDefault(_signalWifi2BarLock);

var _signalWifi2Bar = __webpack_require__(2782);

var _signalWifi2Bar2 = _interopRequireDefault(_signalWifi2Bar);

var _signalWifi3BarLock = __webpack_require__(2783);

var _signalWifi3BarLock2 = _interopRequireDefault(_signalWifi3BarLock);

var _signalWifi3Bar = __webpack_require__(2784);

var _signalWifi3Bar2 = _interopRequireDefault(_signalWifi3Bar);

var _signalWifi4BarLock = __webpack_require__(2785);

var _signalWifi4BarLock2 = _interopRequireDefault(_signalWifi4BarLock);

var _signalWifi4Bar = __webpack_require__(2786);

var _signalWifi4Bar2 = _interopRequireDefault(_signalWifi4Bar);

var _signalWifiOff = __webpack_require__(2787);

var _signalWifiOff2 = _interopRequireDefault(_signalWifiOff);

var _storage = __webpack_require__(2788);

var _storage2 = _interopRequireDefault(_storage);

var _usb = __webpack_require__(2789);

var _usb2 = _interopRequireDefault(_usb);

var _wallpaper = __webpack_require__(2790);

var _wallpaper2 = _interopRequireDefault(_wallpaper);

var _widgets = __webpack_require__(2791);

var _widgets2 = _interopRequireDefault(_widgets);

var _wifiLock = __webpack_require__(2792);

var _wifiLock2 = _interopRequireDefault(_wifiLock);

var _wifiTethering = __webpack_require__(2793);

var _wifiTethering2 = _interopRequireDefault(_wifiTethering);

var _attachFile = __webpack_require__(2794);

var _attachFile2 = _interopRequireDefault(_attachFile);

var _attachMoney = __webpack_require__(2795);

var _attachMoney2 = _interopRequireDefault(_attachMoney);

var _borderAll = __webpack_require__(2796);

var _borderAll2 = _interopRequireDefault(_borderAll);

var _borderBottom = __webpack_require__(2797);

var _borderBottom2 = _interopRequireDefault(_borderBottom);

var _borderClear = __webpack_require__(2798);

var _borderClear2 = _interopRequireDefault(_borderClear);

var _borderColor = __webpack_require__(2799);

var _borderColor2 = _interopRequireDefault(_borderColor);

var _borderHorizontal = __webpack_require__(2800);

var _borderHorizontal2 = _interopRequireDefault(_borderHorizontal);

var _borderInner = __webpack_require__(2801);

var _borderInner2 = _interopRequireDefault(_borderInner);

var _borderLeft = __webpack_require__(2802);

var _borderLeft2 = _interopRequireDefault(_borderLeft);

var _borderOuter = __webpack_require__(2803);

var _borderOuter2 = _interopRequireDefault(_borderOuter);

var _borderRight = __webpack_require__(2804);

var _borderRight2 = _interopRequireDefault(_borderRight);

var _borderStyle = __webpack_require__(2805);

var _borderStyle2 = _interopRequireDefault(_borderStyle);

var _borderTop = __webpack_require__(2806);

var _borderTop2 = _interopRequireDefault(_borderTop);

var _borderVertical = __webpack_require__(2807);

var _borderVertical2 = _interopRequireDefault(_borderVertical);

var _bubbleChart = __webpack_require__(2808);

var _bubbleChart2 = _interopRequireDefault(_bubbleChart);

var _dragHandle = __webpack_require__(2809);

var _dragHandle2 = _interopRequireDefault(_dragHandle);

var _formatAlignCenter = __webpack_require__(2810);

var _formatAlignCenter2 = _interopRequireDefault(_formatAlignCenter);

var _formatAlignJustify = __webpack_require__(2811);

var _formatAlignJustify2 = _interopRequireDefault(_formatAlignJustify);

var _formatAlignLeft = __webpack_require__(2812);

var _formatAlignLeft2 = _interopRequireDefault(_formatAlignLeft);

var _formatAlignRight = __webpack_require__(2813);

var _formatAlignRight2 = _interopRequireDefault(_formatAlignRight);

var _formatBold = __webpack_require__(2814);

var _formatBold2 = _interopRequireDefault(_formatBold);

var _formatClear = __webpack_require__(2815);

var _formatClear2 = _interopRequireDefault(_formatClear);

var _formatColorFill = __webpack_require__(2816);

var _formatColorFill2 = _interopRequireDefault(_formatColorFill);

var _formatColorReset = __webpack_require__(2817);

var _formatColorReset2 = _interopRequireDefault(_formatColorReset);

var _formatColorText = __webpack_require__(2818);

var _formatColorText2 = _interopRequireDefault(_formatColorText);

var _formatIndentDecrease = __webpack_require__(2819);

var _formatIndentDecrease2 = _interopRequireDefault(_formatIndentDecrease);

var _formatIndentIncrease = __webpack_require__(2820);

var _formatIndentIncrease2 = _interopRequireDefault(_formatIndentIncrease);

var _formatItalic = __webpack_require__(2821);

var _formatItalic2 = _interopRequireDefault(_formatItalic);

var _formatLineSpacing = __webpack_require__(2822);

var _formatLineSpacing2 = _interopRequireDefault(_formatLineSpacing);

var _formatListBulleted = __webpack_require__(2823);

var _formatListBulleted2 = _interopRequireDefault(_formatListBulleted);

var _formatListNumbered = __webpack_require__(2824);

var _formatListNumbered2 = _interopRequireDefault(_formatListNumbered);

var _formatPaint = __webpack_require__(2825);

var _formatPaint2 = _interopRequireDefault(_formatPaint);

var _formatQuote = __webpack_require__(2826);

var _formatQuote2 = _interopRequireDefault(_formatQuote);

var _formatShapes = __webpack_require__(2827);

var _formatShapes2 = _interopRequireDefault(_formatShapes);

var _formatSize = __webpack_require__(2828);

var _formatSize2 = _interopRequireDefault(_formatSize);

var _formatStrikethrough = __webpack_require__(2829);

var _formatStrikethrough2 = _interopRequireDefault(_formatStrikethrough);

var _formatTextdirectionLToR = __webpack_require__(2830);

var _formatTextdirectionLToR2 = _interopRequireDefault(_formatTextdirectionLToR);

var _formatTextdirectionRToL = __webpack_require__(2831);

var _formatTextdirectionRToL2 = _interopRequireDefault(_formatTextdirectionRToL);

var _formatUnderlined = __webpack_require__(2832);

var _formatUnderlined2 = _interopRequireDefault(_formatUnderlined);

var _functions = __webpack_require__(2833);

var _functions2 = _interopRequireDefault(_functions);

var _highlight = __webpack_require__(2834);

var _highlight2 = _interopRequireDefault(_highlight);

var _insertChart = __webpack_require__(2835);

var _insertChart2 = _interopRequireDefault(_insertChart);

var _insertComment = __webpack_require__(2836);

var _insertComment2 = _interopRequireDefault(_insertComment);

var _insertDriveFile = __webpack_require__(2837);

var _insertDriveFile2 = _interopRequireDefault(_insertDriveFile);

var _insertEmoticon = __webpack_require__(2838);

var _insertEmoticon2 = _interopRequireDefault(_insertEmoticon);

var _insertInvitation = __webpack_require__(2839);

var _insertInvitation2 = _interopRequireDefault(_insertInvitation);

var _insertLink = __webpack_require__(2840);

var _insertLink2 = _interopRequireDefault(_insertLink);

var _insertPhoto = __webpack_require__(2841);

var _insertPhoto2 = _interopRequireDefault(_insertPhoto);

var _linearScale = __webpack_require__(2842);

var _linearScale2 = _interopRequireDefault(_linearScale);

var _mergeType = __webpack_require__(2843);

var _mergeType2 = _interopRequireDefault(_mergeType);

var _modeComment = __webpack_require__(2844);

var _modeComment2 = _interopRequireDefault(_modeComment);

var _modeEdit = __webpack_require__(947);

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _monetizationOn = __webpack_require__(2845);

var _monetizationOn2 = _interopRequireDefault(_monetizationOn);

var _moneyOff = __webpack_require__(2846);

var _moneyOff2 = _interopRequireDefault(_moneyOff);

var _multilineChart = __webpack_require__(2847);

var _multilineChart2 = _interopRequireDefault(_multilineChart);

var _pieChartOutlined = __webpack_require__(2848);

var _pieChartOutlined2 = _interopRequireDefault(_pieChartOutlined);

var _pieChart = __webpack_require__(2849);

var _pieChart2 = _interopRequireDefault(_pieChart);

var _publish = __webpack_require__(2850);

var _publish2 = _interopRequireDefault(_publish);

var _shortText = __webpack_require__(2851);

var _shortText2 = _interopRequireDefault(_shortText);

var _showChart = __webpack_require__(2852);

var _showChart2 = _interopRequireDefault(_showChart);

var _spaceBar = __webpack_require__(2853);

var _spaceBar2 = _interopRequireDefault(_spaceBar);

var _strikethroughS = __webpack_require__(2854);

var _strikethroughS2 = _interopRequireDefault(_strikethroughS);

var _textFields = __webpack_require__(2855);

var _textFields2 = _interopRequireDefault(_textFields);

var _title = __webpack_require__(2856);

var _title2 = _interopRequireDefault(_title);

var _verticalAlignBottom = __webpack_require__(2857);

var _verticalAlignBottom2 = _interopRequireDefault(_verticalAlignBottom);

var _verticalAlignCenter = __webpack_require__(2858);

var _verticalAlignCenter2 = _interopRequireDefault(_verticalAlignCenter);

var _verticalAlignTop = __webpack_require__(2859);

var _verticalAlignTop2 = _interopRequireDefault(_verticalAlignTop);

var _wrapText = __webpack_require__(2860);

var _wrapText2 = _interopRequireDefault(_wrapText);

var _attachment = __webpack_require__(760);

var _attachment2 = _interopRequireDefault(_attachment);

var _cloudCircle = __webpack_require__(2861);

var _cloudCircle2 = _interopRequireDefault(_cloudCircle);

var _cloudDone = __webpack_require__(2862);

var _cloudDone2 = _interopRequireDefault(_cloudDone);

var _cloudDownload = __webpack_require__(2863);

var _cloudDownload2 = _interopRequireDefault(_cloudDownload);

var _cloudOff = __webpack_require__(2864);

var _cloudOff2 = _interopRequireDefault(_cloudOff);

var _cloudQueue = __webpack_require__(2865);

var _cloudQueue2 = _interopRequireDefault(_cloudQueue);

var _cloudUpload = __webpack_require__(2866);

var _cloudUpload2 = _interopRequireDefault(_cloudUpload);

var _cloud = __webpack_require__(2867);

var _cloud2 = _interopRequireDefault(_cloud);

var _createNewFolder = __webpack_require__(2868);

var _createNewFolder2 = _interopRequireDefault(_createNewFolder);

var _fileDownload = __webpack_require__(275);

var _fileDownload2 = _interopRequireDefault(_fileDownload);

var _fileUpload = __webpack_require__(948);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _folderOpen = __webpack_require__(2869);

var _folderOpen2 = _interopRequireDefault(_folderOpen);

var _folderShared = __webpack_require__(2870);

var _folderShared2 = _interopRequireDefault(_folderShared);

var _folder = __webpack_require__(2871);

var _folder2 = _interopRequireDefault(_folder);

var _castConnected = __webpack_require__(2872);

var _castConnected2 = _interopRequireDefault(_castConnected);

var _cast = __webpack_require__(2873);

var _cast2 = _interopRequireDefault(_cast);

var _computer = __webpack_require__(2874);

var _computer2 = _interopRequireDefault(_computer);

var _desktopMac = __webpack_require__(2875);

var _desktopMac2 = _interopRequireDefault(_desktopMac);

var _desktopWindows = __webpack_require__(2876);

var _desktopWindows2 = _interopRequireDefault(_desktopWindows);

var _developerBoard = __webpack_require__(2877);

var _developerBoard2 = _interopRequireDefault(_developerBoard);

var _deviceHub = __webpack_require__(2878);

var _deviceHub2 = _interopRequireDefault(_deviceHub);

var _devicesOther = __webpack_require__(2879);

var _devicesOther2 = _interopRequireDefault(_devicesOther);

var _dock = __webpack_require__(2880);

var _dock2 = _interopRequireDefault(_dock);

var _gamepad = __webpack_require__(2881);

var _gamepad2 = _interopRequireDefault(_gamepad);

var _headsetMic = __webpack_require__(2882);

var _headsetMic2 = _interopRequireDefault(_headsetMic);

var _headset = __webpack_require__(2883);

var _headset2 = _interopRequireDefault(_headset);

var _keyboardArrowDown = __webpack_require__(231);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

var _keyboardArrowLeft = __webpack_require__(379);

var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);

var _keyboardArrowRight = __webpack_require__(949);

var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);

var _keyboardArrowUp = __webpack_require__(230);

var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);

var _keyboardBackspace = __webpack_require__(2884);

var _keyboardBackspace2 = _interopRequireDefault(_keyboardBackspace);

var _keyboardCapslock = __webpack_require__(2885);

var _keyboardCapslock2 = _interopRequireDefault(_keyboardCapslock);

var _keyboardHide = __webpack_require__(2886);

var _keyboardHide2 = _interopRequireDefault(_keyboardHide);

var _keyboardReturn = __webpack_require__(2887);

var _keyboardReturn2 = _interopRequireDefault(_keyboardReturn);

var _keyboardTab = __webpack_require__(2888);

var _keyboardTab2 = _interopRequireDefault(_keyboardTab);

var _keyboardVoice = __webpack_require__(2889);

var _keyboardVoice2 = _interopRequireDefault(_keyboardVoice);

var _keyboard = __webpack_require__(2890);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _laptopChromebook = __webpack_require__(2891);

var _laptopChromebook2 = _interopRequireDefault(_laptopChromebook);

var _laptopMac = __webpack_require__(2892);

var _laptopMac2 = _interopRequireDefault(_laptopMac);

var _laptopWindows = __webpack_require__(2893);

var _laptopWindows2 = _interopRequireDefault(_laptopWindows);

var _laptop = __webpack_require__(2894);

var _laptop2 = _interopRequireDefault(_laptop);

var _memory = __webpack_require__(2895);

var _memory2 = _interopRequireDefault(_memory);

var _mouse = __webpack_require__(2896);

var _mouse2 = _interopRequireDefault(_mouse);

var _phoneAndroid = __webpack_require__(2897);

var _phoneAndroid2 = _interopRequireDefault(_phoneAndroid);

var _phoneIphone = __webpack_require__(2898);

var _phoneIphone2 = _interopRequireDefault(_phoneIphone);

var _phonelinkOff = __webpack_require__(2899);

var _phonelinkOff2 = _interopRequireDefault(_phonelinkOff);

var _phonelink = __webpack_require__(2900);

var _phonelink2 = _interopRequireDefault(_phonelink);

var _powerInput = __webpack_require__(2901);

var _powerInput2 = _interopRequireDefault(_powerInput);

var _router = __webpack_require__(2902);

var _router2 = _interopRequireDefault(_router);

var _scanner = __webpack_require__(2903);

var _scanner2 = _interopRequireDefault(_scanner);

var _security = __webpack_require__(2904);

var _security2 = _interopRequireDefault(_security);

var _simCard = __webpack_require__(2905);

var _simCard2 = _interopRequireDefault(_simCard);

var _smartphone = __webpack_require__(2906);

var _smartphone2 = _interopRequireDefault(_smartphone);

var _speakerGroup = __webpack_require__(2907);

var _speakerGroup2 = _interopRequireDefault(_speakerGroup);

var _speaker = __webpack_require__(2908);

var _speaker2 = _interopRequireDefault(_speaker);

var _tabletAndroid = __webpack_require__(2909);

var _tabletAndroid2 = _interopRequireDefault(_tabletAndroid);

var _tabletMac = __webpack_require__(2910);

var _tabletMac2 = _interopRequireDefault(_tabletMac);

var _tablet = __webpack_require__(2911);

var _tablet2 = _interopRequireDefault(_tablet);

var _toys = __webpack_require__(2912);

var _toys2 = _interopRequireDefault(_toys);

var _tv = __webpack_require__(2913);

var _tv2 = _interopRequireDefault(_tv);

var _videogameAsset = __webpack_require__(2914);

var _videogameAsset2 = _interopRequireDefault(_videogameAsset);

var _watch = __webpack_require__(2915);

var _watch2 = _interopRequireDefault(_watch);

var _addAPhoto = __webpack_require__(2916);

var _addAPhoto2 = _interopRequireDefault(_addAPhoto);

var _addToPhotos = __webpack_require__(2917);

var _addToPhotos2 = _interopRequireDefault(_addToPhotos);

var _adjust = __webpack_require__(2918);

var _adjust2 = _interopRequireDefault(_adjust);

var _assistantPhoto = __webpack_require__(2919);

var _assistantPhoto2 = _interopRequireDefault(_assistantPhoto);

var _assistant = __webpack_require__(2920);

var _assistant2 = _interopRequireDefault(_assistant);

var _audiotrack = __webpack_require__(2921);

var _audiotrack2 = _interopRequireDefault(_audiotrack);

var _blurCircular = __webpack_require__(2922);

var _blurCircular2 = _interopRequireDefault(_blurCircular);

var _blurLinear = __webpack_require__(2923);

var _blurLinear2 = _interopRequireDefault(_blurLinear);

var _blurOff = __webpack_require__(2924);

var _blurOff2 = _interopRequireDefault(_blurOff);

var _blurOn = __webpack_require__(2925);

var _blurOn2 = _interopRequireDefault(_blurOn);

var _brightness = __webpack_require__(2926);

var _brightness2 = _interopRequireDefault(_brightness);

var _brightness3 = __webpack_require__(2927);

var _brightness4 = _interopRequireDefault(_brightness3);

var _brightness5 = __webpack_require__(2928);

var _brightness6 = _interopRequireDefault(_brightness5);

var _brightness7 = __webpack_require__(2929);

var _brightness8 = _interopRequireDefault(_brightness7);

var _brightness9 = __webpack_require__(2930);

var _brightness10 = _interopRequireDefault(_brightness9);

var _brightness11 = __webpack_require__(2931);

var _brightness12 = _interopRequireDefault(_brightness11);

var _brightness13 = __webpack_require__(2932);

var _brightness14 = _interopRequireDefault(_brightness13);

var _brokenImage = __webpack_require__(2933);

var _brokenImage2 = _interopRequireDefault(_brokenImage);

var _brush = __webpack_require__(2934);

var _brush2 = _interopRequireDefault(_brush);

var _burstMode = __webpack_require__(2935);

var _burstMode2 = _interopRequireDefault(_burstMode);

var _cameraAlt = __webpack_require__(2936);

var _cameraAlt2 = _interopRequireDefault(_cameraAlt);

var _cameraFront = __webpack_require__(2937);

var _cameraFront2 = _interopRequireDefault(_cameraFront);

var _cameraRear = __webpack_require__(2938);

var _cameraRear2 = _interopRequireDefault(_cameraRear);

var _cameraRoll = __webpack_require__(2939);

var _cameraRoll2 = _interopRequireDefault(_cameraRoll);

var _camera = __webpack_require__(2940);

var _camera2 = _interopRequireDefault(_camera);

var _centerFocusStrong = __webpack_require__(2941);

var _centerFocusStrong2 = _interopRequireDefault(_centerFocusStrong);

var _centerFocusWeak = __webpack_require__(2942);

var _centerFocusWeak2 = _interopRequireDefault(_centerFocusWeak);

var _collectionsBookmark = __webpack_require__(2943);

var _collectionsBookmark2 = _interopRequireDefault(_collectionsBookmark);

var _collections = __webpack_require__(2944);

var _collections2 = _interopRequireDefault(_collections);

var _colorLens = __webpack_require__(2945);

var _colorLens2 = _interopRequireDefault(_colorLens);

var _colorize = __webpack_require__(2946);

var _colorize2 = _interopRequireDefault(_colorize);

var _compare = __webpack_require__(2947);

var _compare2 = _interopRequireDefault(_compare);

var _controlPointDuplicate = __webpack_require__(2948);

var _controlPointDuplicate2 = _interopRequireDefault(_controlPointDuplicate);

var _controlPoint = __webpack_require__(106);

var _controlPoint2 = _interopRequireDefault(_controlPoint);

var _crop = __webpack_require__(2949);

var _crop2 = _interopRequireDefault(_crop);

var _crop3 = __webpack_require__(2950);

var _crop4 = _interopRequireDefault(_crop3);

var _crop5 = __webpack_require__(2951);

var _crop6 = _interopRequireDefault(_crop5);

var _crop7 = __webpack_require__(2952);

var _crop8 = _interopRequireDefault(_crop7);

var _cropDin = __webpack_require__(2953);

var _cropDin2 = _interopRequireDefault(_cropDin);

var _cropFree = __webpack_require__(2954);

var _cropFree2 = _interopRequireDefault(_cropFree);

var _cropLandscape = __webpack_require__(2955);

var _cropLandscape2 = _interopRequireDefault(_cropLandscape);

var _cropOriginal = __webpack_require__(2956);

var _cropOriginal2 = _interopRequireDefault(_cropOriginal);

var _cropPortrait = __webpack_require__(2957);

var _cropPortrait2 = _interopRequireDefault(_cropPortrait);

var _cropRotate = __webpack_require__(2958);

var _cropRotate2 = _interopRequireDefault(_cropRotate);

var _cropSquare = __webpack_require__(2959);

var _cropSquare2 = _interopRequireDefault(_cropSquare);

var _crop9 = __webpack_require__(2960);

var _crop10 = _interopRequireDefault(_crop9);

var _dehaze = __webpack_require__(2961);

var _dehaze2 = _interopRequireDefault(_dehaze);

var _details = __webpack_require__(2962);

var _details2 = _interopRequireDefault(_details);

var _edit = __webpack_require__(950);

var _edit2 = _interopRequireDefault(_edit);

var _exposureNeg = __webpack_require__(2963);

var _exposureNeg2 = _interopRequireDefault(_exposureNeg);

var _exposureNeg3 = __webpack_require__(2964);

var _exposureNeg4 = _interopRequireDefault(_exposureNeg3);

var _exposurePlus = __webpack_require__(2965);

var _exposurePlus2 = _interopRequireDefault(_exposurePlus);

var _exposurePlus3 = __webpack_require__(2966);

var _exposurePlus4 = _interopRequireDefault(_exposurePlus3);

var _exposureZero = __webpack_require__(2967);

var _exposureZero2 = _interopRequireDefault(_exposureZero);

var _exposure = __webpack_require__(2968);

var _exposure2 = _interopRequireDefault(_exposure);

var _filter = __webpack_require__(2969);

var _filter2 = _interopRequireDefault(_filter);

var _filter3 = __webpack_require__(2970);

var _filter4 = _interopRequireDefault(_filter3);

var _filter5 = __webpack_require__(2971);

var _filter6 = _interopRequireDefault(_filter5);

var _filter7 = __webpack_require__(2972);

var _filter8 = _interopRequireDefault(_filter7);

var _filter9 = __webpack_require__(2973);

var _filter10 = _interopRequireDefault(_filter9);

var _filter11 = __webpack_require__(2974);

var _filter12 = _interopRequireDefault(_filter11);

var _filter13 = __webpack_require__(2975);

var _filter14 = _interopRequireDefault(_filter13);

var _filter15 = __webpack_require__(2976);

var _filter16 = _interopRequireDefault(_filter15);

var _filter9Plus = __webpack_require__(2977);

var _filter9Plus2 = _interopRequireDefault(_filter9Plus);

var _filter17 = __webpack_require__(2978);

var _filter18 = _interopRequireDefault(_filter17);

var _filterBAndW = __webpack_require__(2979);

var _filterBAndW2 = _interopRequireDefault(_filterBAndW);

var _filterCenterFocus = __webpack_require__(2980);

var _filterCenterFocus2 = _interopRequireDefault(_filterCenterFocus);

var _filterDrama = __webpack_require__(2981);

var _filterDrama2 = _interopRequireDefault(_filterDrama);

var _filterFrames = __webpack_require__(2982);

var _filterFrames2 = _interopRequireDefault(_filterFrames);

var _filterHdr = __webpack_require__(2983);

var _filterHdr2 = _interopRequireDefault(_filterHdr);

var _filterNone = __webpack_require__(2984);

var _filterNone2 = _interopRequireDefault(_filterNone);

var _filterTiltShift = __webpack_require__(2985);

var _filterTiltShift2 = _interopRequireDefault(_filterTiltShift);

var _filterVintage = __webpack_require__(2986);

var _filterVintage2 = _interopRequireDefault(_filterVintage);

var _filter19 = __webpack_require__(2987);

var _filter20 = _interopRequireDefault(_filter19);

var _flare = __webpack_require__(2988);

var _flare2 = _interopRequireDefault(_flare);

var _flashAuto = __webpack_require__(2989);

var _flashAuto2 = _interopRequireDefault(_flashAuto);

var _flashOff = __webpack_require__(2990);

var _flashOff2 = _interopRequireDefault(_flashOff);

var _flashOn = __webpack_require__(2991);

var _flashOn2 = _interopRequireDefault(_flashOn);

var _flip = __webpack_require__(2992);

var _flip2 = _interopRequireDefault(_flip);

var _gradient = __webpack_require__(2993);

var _gradient2 = _interopRequireDefault(_gradient);

var _grain = __webpack_require__(2994);

var _grain2 = _interopRequireDefault(_grain);

var _gridOff = __webpack_require__(2995);

var _gridOff2 = _interopRequireDefault(_gridOff);

var _gridOn = __webpack_require__(2996);

var _gridOn2 = _interopRequireDefault(_gridOn);

var _hdrOff = __webpack_require__(2997);

var _hdrOff2 = _interopRequireDefault(_hdrOff);

var _hdrOn = __webpack_require__(2998);

var _hdrOn2 = _interopRequireDefault(_hdrOn);

var _hdrStrong = __webpack_require__(2999);

var _hdrStrong2 = _interopRequireDefault(_hdrStrong);

var _hdrWeak = __webpack_require__(3000);

var _hdrWeak2 = _interopRequireDefault(_hdrWeak);

var _healing = __webpack_require__(3001);

var _healing2 = _interopRequireDefault(_healing);

var _imageAspectRatio = __webpack_require__(3002);

var _imageAspectRatio2 = _interopRequireDefault(_imageAspectRatio);

var _image = __webpack_require__(3003);

var _image2 = _interopRequireDefault(_image);

var _iso = __webpack_require__(3004);

var _iso2 = _interopRequireDefault(_iso);

var _landscape = __webpack_require__(3005);

var _landscape2 = _interopRequireDefault(_landscape);

var _leakAdd = __webpack_require__(3006);

var _leakAdd2 = _interopRequireDefault(_leakAdd);

var _leakRemove = __webpack_require__(3007);

var _leakRemove2 = _interopRequireDefault(_leakRemove);

var _lens = __webpack_require__(3008);

var _lens2 = _interopRequireDefault(_lens);

var _linkedCamera = __webpack_require__(3009);

var _linkedCamera2 = _interopRequireDefault(_linkedCamera);

var _looks = __webpack_require__(3010);

var _looks2 = _interopRequireDefault(_looks);

var _looks3 = __webpack_require__(3011);

var _looks4 = _interopRequireDefault(_looks3);

var _looks5 = __webpack_require__(3012);

var _looks6 = _interopRequireDefault(_looks5);

var _looks7 = __webpack_require__(3013);

var _looks8 = _interopRequireDefault(_looks7);

var _looksOne = __webpack_require__(3014);

var _looksOne2 = _interopRequireDefault(_looksOne);

var _looksTwo = __webpack_require__(3015);

var _looksTwo2 = _interopRequireDefault(_looksTwo);

var _looks9 = __webpack_require__(3016);

var _looks10 = _interopRequireDefault(_looks9);

var _loupe = __webpack_require__(3017);

var _loupe2 = _interopRequireDefault(_loupe);

var _monochromePhotos = __webpack_require__(3018);

var _monochromePhotos2 = _interopRequireDefault(_monochromePhotos);

var _movieCreation = __webpack_require__(3019);

var _movieCreation2 = _interopRequireDefault(_movieCreation);

var _movieFilter = __webpack_require__(3020);

var _movieFilter2 = _interopRequireDefault(_movieFilter);

var _musicNote = __webpack_require__(3021);

var _musicNote2 = _interopRequireDefault(_musicNote);

var _naturePeople = __webpack_require__(3022);

var _naturePeople2 = _interopRequireDefault(_naturePeople);

var _nature = __webpack_require__(3023);

var _nature2 = _interopRequireDefault(_nature);

var _navigateBefore = __webpack_require__(3024);

var _navigateBefore2 = _interopRequireDefault(_navigateBefore);

var _navigateNext = __webpack_require__(3025);

var _navigateNext2 = _interopRequireDefault(_navigateNext);

var _palette = __webpack_require__(879);

var _palette2 = _interopRequireDefault(_palette);

var _panoramaFishEye = __webpack_require__(3026);

var _panoramaFishEye2 = _interopRequireDefault(_panoramaFishEye);

var _panoramaHorizontal = __webpack_require__(3027);

var _panoramaHorizontal2 = _interopRequireDefault(_panoramaHorizontal);

var _panoramaVertical = __webpack_require__(3028);

var _panoramaVertical2 = _interopRequireDefault(_panoramaVertical);

var _panoramaWideAngle = __webpack_require__(3029);

var _panoramaWideAngle2 = _interopRequireDefault(_panoramaWideAngle);

var _panorama = __webpack_require__(3030);

var _panorama2 = _interopRequireDefault(_panorama);

var _photoAlbum = __webpack_require__(3031);

var _photoAlbum2 = _interopRequireDefault(_photoAlbum);

var _photoCamera = __webpack_require__(3032);

var _photoCamera2 = _interopRequireDefault(_photoCamera);

var _photoFilter = __webpack_require__(3033);

var _photoFilter2 = _interopRequireDefault(_photoFilter);

var _photoLibrary = __webpack_require__(3034);

var _photoLibrary2 = _interopRequireDefault(_photoLibrary);

var _photoSizeSelectActual = __webpack_require__(3035);

var _photoSizeSelectActual2 = _interopRequireDefault(_photoSizeSelectActual);

var _photoSizeSelectLarge = __webpack_require__(3036);

var _photoSizeSelectLarge2 = _interopRequireDefault(_photoSizeSelectLarge);

var _photoSizeSelectSmall = __webpack_require__(3037);

var _photoSizeSelectSmall2 = _interopRequireDefault(_photoSizeSelectSmall);

var _photo = __webpack_require__(3038);

var _photo2 = _interopRequireDefault(_photo);

var _pictureAsPdf = __webpack_require__(3039);

var _pictureAsPdf2 = _interopRequireDefault(_pictureAsPdf);

var _portrait = __webpack_require__(3040);

var _portrait2 = _interopRequireDefault(_portrait);

var _removeRedEye = __webpack_require__(3041);

var _removeRedEye2 = _interopRequireDefault(_removeRedEye);

var _rotate90DegreesCcw = __webpack_require__(3042);

var _rotate90DegreesCcw2 = _interopRequireDefault(_rotate90DegreesCcw);

var _rotateLeft = __webpack_require__(3043);

var _rotateLeft2 = _interopRequireDefault(_rotateLeft);

var _rotateRight = __webpack_require__(3044);

var _rotateRight2 = _interopRequireDefault(_rotateRight);

var _slideshow = __webpack_require__(3045);

var _slideshow2 = _interopRequireDefault(_slideshow);

var _straighten = __webpack_require__(3046);

var _straighten2 = _interopRequireDefault(_straighten);

var _style = __webpack_require__(3047);

var _style2 = _interopRequireDefault(_style);

var _switchCamera = __webpack_require__(3048);

var _switchCamera2 = _interopRequireDefault(_switchCamera);

var _switchVideo = __webpack_require__(3049);

var _switchVideo2 = _interopRequireDefault(_switchVideo);

var _tagFaces = __webpack_require__(3050);

var _tagFaces2 = _interopRequireDefault(_tagFaces);

var _texture = __webpack_require__(3051);

var _texture2 = _interopRequireDefault(_texture);

var _timelapse = __webpack_require__(3052);

var _timelapse2 = _interopRequireDefault(_timelapse);

var _timer = __webpack_require__(3053);

var _timer2 = _interopRequireDefault(_timer);

var _timer3 = __webpack_require__(3054);

var _timer4 = _interopRequireDefault(_timer3);

var _timerOff = __webpack_require__(3055);

var _timerOff2 = _interopRequireDefault(_timerOff);

var _timer5 = __webpack_require__(3056);

var _timer6 = _interopRequireDefault(_timer5);

var _tonality = __webpack_require__(3057);

var _tonality2 = _interopRequireDefault(_tonality);

var _transform = __webpack_require__(3058);

var _transform2 = _interopRequireDefault(_transform);

var _tune = __webpack_require__(3059);

var _tune2 = _interopRequireDefault(_tune);

var _viewComfy = __webpack_require__(3060);

var _viewComfy2 = _interopRequireDefault(_viewComfy);

var _viewCompact = __webpack_require__(3061);

var _viewCompact2 = _interopRequireDefault(_viewCompact);

var _vignette = __webpack_require__(3062);

var _vignette2 = _interopRequireDefault(_vignette);

var _wbAuto = __webpack_require__(3063);

var _wbAuto2 = _interopRequireDefault(_wbAuto);

var _wbCloudy = __webpack_require__(3064);

var _wbCloudy2 = _interopRequireDefault(_wbCloudy);

var _wbIncandescent = __webpack_require__(3065);

var _wbIncandescent2 = _interopRequireDefault(_wbIncandescent);

var _wbIridescent = __webpack_require__(3066);

var _wbIridescent2 = _interopRequireDefault(_wbIridescent);

var _wbSunny = __webpack_require__(3067);

var _wbSunny2 = _interopRequireDefault(_wbSunny);

var _addLocation = __webpack_require__(3068);

var _addLocation2 = _interopRequireDefault(_addLocation);

var _beenhere = __webpack_require__(3069);

var _beenhere2 = _interopRequireDefault(_beenhere);

var _directionsBike = __webpack_require__(3070);

var _directionsBike2 = _interopRequireDefault(_directionsBike);

var _directionsBoat = __webpack_require__(3071);

var _directionsBoat2 = _interopRequireDefault(_directionsBoat);

var _directionsBus = __webpack_require__(3072);

var _directionsBus2 = _interopRequireDefault(_directionsBus);

var _directionsCar = __webpack_require__(3073);

var _directionsCar2 = _interopRequireDefault(_directionsCar);

var _directionsRailway = __webpack_require__(3074);

var _directionsRailway2 = _interopRequireDefault(_directionsRailway);

var _directionsRun = __webpack_require__(3075);

var _directionsRun2 = _interopRequireDefault(_directionsRun);

var _directionsSubway = __webpack_require__(3076);

var _directionsSubway2 = _interopRequireDefault(_directionsSubway);

var _directionsTransit = __webpack_require__(3077);

var _directionsTransit2 = _interopRequireDefault(_directionsTransit);

var _directionsWalk = __webpack_require__(3078);

var _directionsWalk2 = _interopRequireDefault(_directionsWalk);

var _directions = __webpack_require__(3079);

var _directions2 = _interopRequireDefault(_directions);

var _editLocation = __webpack_require__(3080);

var _editLocation2 = _interopRequireDefault(_editLocation);

var _evStation = __webpack_require__(3081);

var _evStation2 = _interopRequireDefault(_evStation);

var _flight = __webpack_require__(3082);

var _flight2 = _interopRequireDefault(_flight);

var _hotel = __webpack_require__(3083);

var _hotel2 = _interopRequireDefault(_hotel);

var _layersClear = __webpack_require__(3084);

var _layersClear2 = _interopRequireDefault(_layersClear);

var _layers = __webpack_require__(3085);

var _layers2 = _interopRequireDefault(_layers);

var _localActivity = __webpack_require__(3086);

var _localActivity2 = _interopRequireDefault(_localActivity);

var _localAirport = __webpack_require__(3087);

var _localAirport2 = _interopRequireDefault(_localAirport);

var _localAtm = __webpack_require__(3088);

var _localAtm2 = _interopRequireDefault(_localAtm);

var _localBar = __webpack_require__(3089);

var _localBar2 = _interopRequireDefault(_localBar);

var _localCafe = __webpack_require__(3090);

var _localCafe2 = _interopRequireDefault(_localCafe);

var _localCarWash = __webpack_require__(3091);

var _localCarWash2 = _interopRequireDefault(_localCarWash);

var _localConvenienceStore = __webpack_require__(3092);

var _localConvenienceStore2 = _interopRequireDefault(_localConvenienceStore);

var _localDining = __webpack_require__(3093);

var _localDining2 = _interopRequireDefault(_localDining);

var _localDrink = __webpack_require__(3094);

var _localDrink2 = _interopRequireDefault(_localDrink);

var _localFlorist = __webpack_require__(3095);

var _localFlorist2 = _interopRequireDefault(_localFlorist);

var _localGasStation = __webpack_require__(3096);

var _localGasStation2 = _interopRequireDefault(_localGasStation);

var _localGroceryStore = __webpack_require__(3097);

var _localGroceryStore2 = _interopRequireDefault(_localGroceryStore);

var _localHospital = __webpack_require__(3098);

var _localHospital2 = _interopRequireDefault(_localHospital);

var _localHotel = __webpack_require__(3099);

var _localHotel2 = _interopRequireDefault(_localHotel);

var _localLaundryService = __webpack_require__(3100);

var _localLaundryService2 = _interopRequireDefault(_localLaundryService);

var _localLibrary = __webpack_require__(3101);

var _localLibrary2 = _interopRequireDefault(_localLibrary);

var _localMall = __webpack_require__(3102);

var _localMall2 = _interopRequireDefault(_localMall);

var _localMovies = __webpack_require__(3103);

var _localMovies2 = _interopRequireDefault(_localMovies);

var _localOffer = __webpack_require__(3104);

var _localOffer2 = _interopRequireDefault(_localOffer);

var _localParking = __webpack_require__(3105);

var _localParking2 = _interopRequireDefault(_localParking);

var _localPharmacy = __webpack_require__(3106);

var _localPharmacy2 = _interopRequireDefault(_localPharmacy);

var _localPhone = __webpack_require__(3107);

var _localPhone2 = _interopRequireDefault(_localPhone);

var _localPizza = __webpack_require__(3108);

var _localPizza2 = _interopRequireDefault(_localPizza);

var _localPlay = __webpack_require__(3109);

var _localPlay2 = _interopRequireDefault(_localPlay);

var _localPostOffice = __webpack_require__(3110);

var _localPostOffice2 = _interopRequireDefault(_localPostOffice);

var _localPrintshop = __webpack_require__(3111);

var _localPrintshop2 = _interopRequireDefault(_localPrintshop);

var _localSee = __webpack_require__(3112);

var _localSee2 = _interopRequireDefault(_localSee);

var _localShipping = __webpack_require__(3113);

var _localShipping2 = _interopRequireDefault(_localShipping);

var _localTaxi = __webpack_require__(3114);

var _localTaxi2 = _interopRequireDefault(_localTaxi);

var _map = __webpack_require__(3115);

var _map2 = _interopRequireDefault(_map);

var _myLocation = __webpack_require__(3116);

var _myLocation2 = _interopRequireDefault(_myLocation);

var _navigation = __webpack_require__(3117);

var _navigation2 = _interopRequireDefault(_navigation);

var _nearMe = __webpack_require__(3118);

var _nearMe2 = _interopRequireDefault(_nearMe);

var _personPinCircle = __webpack_require__(3119);

var _personPinCircle2 = _interopRequireDefault(_personPinCircle);

var _personPin = __webpack_require__(3120);

var _personPin2 = _interopRequireDefault(_personPin);

var _pinDrop = __webpack_require__(3121);

var _pinDrop2 = _interopRequireDefault(_pinDrop);

var _place = __webpack_require__(3122);

var _place2 = _interopRequireDefault(_place);

var _rateReview = __webpack_require__(3123);

var _rateReview2 = _interopRequireDefault(_rateReview);

var _restaurantMenu = __webpack_require__(3124);

var _restaurantMenu2 = _interopRequireDefault(_restaurantMenu);

var _restaurant = __webpack_require__(3125);

var _restaurant2 = _interopRequireDefault(_restaurant);

var _satellite = __webpack_require__(3126);

var _satellite2 = _interopRequireDefault(_satellite);

var _storeMallDirectory = __webpack_require__(3127);

var _storeMallDirectory2 = _interopRequireDefault(_storeMallDirectory);

var _streetview = __webpack_require__(3128);

var _streetview2 = _interopRequireDefault(_streetview);

var _subway = __webpack_require__(3129);

var _subway2 = _interopRequireDefault(_subway);

var _terrain = __webpack_require__(3130);

var _terrain2 = _interopRequireDefault(_terrain);

var _traffic = __webpack_require__(3131);

var _traffic2 = _interopRequireDefault(_traffic);

var _train = __webpack_require__(3132);

var _train2 = _interopRequireDefault(_train);

var _tram = __webpack_require__(3133);

var _tram2 = _interopRequireDefault(_tram);

var _transferWithinAStation = __webpack_require__(3134);

var _transferWithinAStation2 = _interopRequireDefault(_transferWithinAStation);

var _zoomOutMap = __webpack_require__(3135);

var _zoomOutMap2 = _interopRequireDefault(_zoomOutMap);

var _apps = __webpack_require__(3136);

var _apps2 = _interopRequireDefault(_apps);

var _arrowBack = __webpack_require__(813);

var _arrowBack2 = _interopRequireDefault(_arrowBack);

var _arrowDownward = __webpack_require__(3137);

var _arrowDownward2 = _interopRequireDefault(_arrowDownward);

var _arrowDropDownCircle = __webpack_require__(3138);

var _arrowDropDownCircle2 = _interopRequireDefault(_arrowDropDownCircle);

var _arrowDropDown = __webpack_require__(773);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _arrowDropUp = __webpack_require__(3139);

var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);

var _arrowForward = __webpack_require__(525);

var _arrowForward2 = _interopRequireDefault(_arrowForward);

var _arrowUpward = __webpack_require__(951);

var _arrowUpward2 = _interopRequireDefault(_arrowUpward);

var _cancel = __webpack_require__(772);

var _cancel2 = _interopRequireDefault(_cancel);

var _check = __webpack_require__(505);

var _check2 = _interopRequireDefault(_check);

var _chevronLeft = __webpack_require__(103);

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronRight = __webpack_require__(104);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _close = __webpack_require__(158);

var _close2 = _interopRequireDefault(_close);

var _expandLess = __webpack_require__(495);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _expandMore = __webpack_require__(496);

var _expandMore2 = _interopRequireDefault(_expandMore);

var _firstPage = __webpack_require__(3140);

var _firstPage2 = _interopRequireDefault(_firstPage);

var _fullscreenExit = __webpack_require__(3141);

var _fullscreenExit2 = _interopRequireDefault(_fullscreenExit);

var _fullscreen = __webpack_require__(3142);

var _fullscreen2 = _interopRequireDefault(_fullscreen);

var _lastPage = __webpack_require__(3143);

var _lastPage2 = _interopRequireDefault(_lastPage);

var _menu = __webpack_require__(493);

var _menu2 = _interopRequireDefault(_menu);

var _moreHoriz = __webpack_require__(3144);

var _moreHoriz2 = _interopRequireDefault(_moreHoriz);

var _moreVert = __webpack_require__(355);

var _moreVert2 = _interopRequireDefault(_moreVert);

var _refresh = __webpack_require__(3145);

var _refresh2 = _interopRequireDefault(_refresh);

var _subdirectoryArrowLeft = __webpack_require__(3146);

var _subdirectoryArrowLeft2 = _interopRequireDefault(_subdirectoryArrowLeft);

var _subdirectoryArrowRight = __webpack_require__(3147);

var _subdirectoryArrowRight2 = _interopRequireDefault(_subdirectoryArrowRight);

var _unfoldLess = __webpack_require__(3148);

var _unfoldLess2 = _interopRequireDefault(_unfoldLess);

var _unfoldMore = __webpack_require__(3149);

var _unfoldMore2 = _interopRequireDefault(_unfoldMore);

var _navigationArrowDropRight = __webpack_require__(3150);

var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);

var _adb = __webpack_require__(3151);

var _adb2 = _interopRequireDefault(_adb);

var _airlineSeatFlatAngled = __webpack_require__(3152);

var _airlineSeatFlatAngled2 = _interopRequireDefault(_airlineSeatFlatAngled);

var _airlineSeatFlat = __webpack_require__(3153);

var _airlineSeatFlat2 = _interopRequireDefault(_airlineSeatFlat);

var _airlineSeatIndividualSuite = __webpack_require__(3154);

var _airlineSeatIndividualSuite2 = _interopRequireDefault(_airlineSeatIndividualSuite);

var _airlineSeatLegroomExtra = __webpack_require__(3155);

var _airlineSeatLegroomExtra2 = _interopRequireDefault(_airlineSeatLegroomExtra);

var _airlineSeatLegroomNormal = __webpack_require__(3156);

var _airlineSeatLegroomNormal2 = _interopRequireDefault(_airlineSeatLegroomNormal);

var _airlineSeatLegroomReduced = __webpack_require__(3157);

var _airlineSeatLegroomReduced2 = _interopRequireDefault(_airlineSeatLegroomReduced);

var _airlineSeatReclineExtra = __webpack_require__(3158);

var _airlineSeatReclineExtra2 = _interopRequireDefault(_airlineSeatReclineExtra);

var _airlineSeatReclineNormal = __webpack_require__(3159);

var _airlineSeatReclineNormal2 = _interopRequireDefault(_airlineSeatReclineNormal);

var _bluetoothAudio = __webpack_require__(3160);

var _bluetoothAudio2 = _interopRequireDefault(_bluetoothAudio);

var _confirmationNumber = __webpack_require__(3161);

var _confirmationNumber2 = _interopRequireDefault(_confirmationNumber);

var _discFull = __webpack_require__(3162);

var _discFull2 = _interopRequireDefault(_discFull);

var _doNotDisturbAlt = __webpack_require__(3163);

var _doNotDisturbAlt2 = _interopRequireDefault(_doNotDisturbAlt);

var _doNotDisturbOff = __webpack_require__(3164);

var _doNotDisturbOff2 = _interopRequireDefault(_doNotDisturbOff);

var _doNotDisturbOn = __webpack_require__(3165);

var _doNotDisturbOn2 = _interopRequireDefault(_doNotDisturbOn);

var _doNotDisturb = __webpack_require__(3166);

var _doNotDisturb2 = _interopRequireDefault(_doNotDisturb);

var _driveEta = __webpack_require__(3167);

var _driveEta2 = _interopRequireDefault(_driveEta);

var _enhancedEncryption = __webpack_require__(3168);

var _enhancedEncryption2 = _interopRequireDefault(_enhancedEncryption);

var _eventAvailable = __webpack_require__(3169);

var _eventAvailable2 = _interopRequireDefault(_eventAvailable);

var _eventBusy = __webpack_require__(3170);

var _eventBusy2 = _interopRequireDefault(_eventBusy);

var _eventNote = __webpack_require__(3171);

var _eventNote2 = _interopRequireDefault(_eventNote);

var _folderSpecial = __webpack_require__(3172);

var _folderSpecial2 = _interopRequireDefault(_folderSpecial);

var _liveTv = __webpack_require__(3173);

var _liveTv2 = _interopRequireDefault(_liveTv);

var _mms = __webpack_require__(3174);

var _mms2 = _interopRequireDefault(_mms);

var _more = __webpack_require__(3175);

var _more2 = _interopRequireDefault(_more);

var _networkCheck = __webpack_require__(3176);

var _networkCheck2 = _interopRequireDefault(_networkCheck);

var _networkLocked = __webpack_require__(3177);

var _networkLocked2 = _interopRequireDefault(_networkLocked);

var _noEncryption = __webpack_require__(3178);

var _noEncryption2 = _interopRequireDefault(_noEncryption);

var _ondemandVideo = __webpack_require__(3179);

var _ondemandVideo2 = _interopRequireDefault(_ondemandVideo);

var _personalVideo = __webpack_require__(3180);

var _personalVideo2 = _interopRequireDefault(_personalVideo);

var _phoneBluetoothSpeaker = __webpack_require__(3181);

var _phoneBluetoothSpeaker2 = _interopRequireDefault(_phoneBluetoothSpeaker);

var _phoneForwarded = __webpack_require__(3182);

var _phoneForwarded2 = _interopRequireDefault(_phoneForwarded);

var _phoneInTalk = __webpack_require__(3183);

var _phoneInTalk2 = _interopRequireDefault(_phoneInTalk);

var _phoneLocked = __webpack_require__(3184);

var _phoneLocked2 = _interopRequireDefault(_phoneLocked);

var _phoneMissed = __webpack_require__(3185);

var _phoneMissed2 = _interopRequireDefault(_phoneMissed);

var _phonePaused = __webpack_require__(3186);

var _phonePaused2 = _interopRequireDefault(_phonePaused);

var _power = __webpack_require__(3187);

var _power2 = _interopRequireDefault(_power);

var _priorityHigh = __webpack_require__(3188);

var _priorityHigh2 = _interopRequireDefault(_priorityHigh);

var _rvHookup = __webpack_require__(3189);

var _rvHookup2 = _interopRequireDefault(_rvHookup);

var _sdCard = __webpack_require__(3190);

var _sdCard2 = _interopRequireDefault(_sdCard);

var _simCardAlert = __webpack_require__(3191);

var _simCardAlert2 = _interopRequireDefault(_simCardAlert);

var _smsFailed = __webpack_require__(3192);

var _smsFailed2 = _interopRequireDefault(_smsFailed);

var _sms = __webpack_require__(3193);

var _sms2 = _interopRequireDefault(_sms);

var _syncDisabled = __webpack_require__(3194);

var _syncDisabled2 = _interopRequireDefault(_syncDisabled);

var _syncProblem = __webpack_require__(3195);

var _syncProblem2 = _interopRequireDefault(_syncProblem);

var _sync = __webpack_require__(3196);

var _sync2 = _interopRequireDefault(_sync);

var _systemUpdate = __webpack_require__(3197);

var _systemUpdate2 = _interopRequireDefault(_systemUpdate);

var _tapAndPlay = __webpack_require__(3198);

var _tapAndPlay2 = _interopRequireDefault(_tapAndPlay);

var _timeToLeave = __webpack_require__(3199);

var _timeToLeave2 = _interopRequireDefault(_timeToLeave);

var _vibration = __webpack_require__(3200);

var _vibration2 = _interopRequireDefault(_vibration);

var _voiceChat = __webpack_require__(3201);

var _voiceChat2 = _interopRequireDefault(_voiceChat);

var _vpnLock = __webpack_require__(3202);

var _vpnLock2 = _interopRequireDefault(_vpnLock);

var _wc = __webpack_require__(3203);

var _wc2 = _interopRequireDefault(_wc);

var _wifi = __webpack_require__(3204);

var _wifi2 = _interopRequireDefault(_wifi);

var _acUnit = __webpack_require__(3205);

var _acUnit2 = _interopRequireDefault(_acUnit);

var _airportShuttle = __webpack_require__(3206);

var _airportShuttle2 = _interopRequireDefault(_airportShuttle);

var _allInclusive = __webpack_require__(3207);

var _allInclusive2 = _interopRequireDefault(_allInclusive);

var _beachAccess = __webpack_require__(3208);

var _beachAccess2 = _interopRequireDefault(_beachAccess);

var _businessCenter = __webpack_require__(3209);

var _businessCenter2 = _interopRequireDefault(_businessCenter);

var _casino = __webpack_require__(3210);

var _casino2 = _interopRequireDefault(_casino);

var _childCare = __webpack_require__(3211);

var _childCare2 = _interopRequireDefault(_childCare);

var _childFriendly = __webpack_require__(3212);

var _childFriendly2 = _interopRequireDefault(_childFriendly);

var _fitnessCenter = __webpack_require__(3213);

var _fitnessCenter2 = _interopRequireDefault(_fitnessCenter);

var _freeBreakfast = __webpack_require__(3214);

var _freeBreakfast2 = _interopRequireDefault(_freeBreakfast);

var _golfCourse = __webpack_require__(3215);

var _golfCourse2 = _interopRequireDefault(_golfCourse);

var _hotTub = __webpack_require__(3216);

var _hotTub2 = _interopRequireDefault(_hotTub);

var _kitchen = __webpack_require__(3217);

var _kitchen2 = _interopRequireDefault(_kitchen);

var _pool = __webpack_require__(3218);

var _pool2 = _interopRequireDefault(_pool);

var _roomService = __webpack_require__(3219);

var _roomService2 = _interopRequireDefault(_roomService);

var _rvHookup3 = __webpack_require__(3220);

var _rvHookup4 = _interopRequireDefault(_rvHookup3);

var _smokeFree = __webpack_require__(3221);

var _smokeFree2 = _interopRequireDefault(_smokeFree);

var _smokingRooms = __webpack_require__(3222);

var _smokingRooms2 = _interopRequireDefault(_smokingRooms);

var _spa = __webpack_require__(3223);

var _spa2 = _interopRequireDefault(_spa);

var _cake = __webpack_require__(3224);

var _cake2 = _interopRequireDefault(_cake);

var _domain = __webpack_require__(3225);

var _domain2 = _interopRequireDefault(_domain);

var _groupAdd = __webpack_require__(3226);

var _groupAdd2 = _interopRequireDefault(_groupAdd);

var _group = __webpack_require__(3227);

var _group2 = _interopRequireDefault(_group);

var _locationCity = __webpack_require__(3228);

var _locationCity2 = _interopRequireDefault(_locationCity);

var _moodBad = __webpack_require__(3229);

var _moodBad2 = _interopRequireDefault(_moodBad);

var _mood = __webpack_require__(3230);

var _mood2 = _interopRequireDefault(_mood);

var _notificationsActive = __webpack_require__(3231);

var _notificationsActive2 = _interopRequireDefault(_notificationsActive);

var _notificationsNone = __webpack_require__(3232);

var _notificationsNone2 = _interopRequireDefault(_notificationsNone);

var _notificationsOff = __webpack_require__(3233);

var _notificationsOff2 = _interopRequireDefault(_notificationsOff);

var _notificationsPaused = __webpack_require__(3234);

var _notificationsPaused2 = _interopRequireDefault(_notificationsPaused);

var _notifications = __webpack_require__(3235);

var _notifications2 = _interopRequireDefault(_notifications);

var _pages = __webpack_require__(3236);

var _pages2 = _interopRequireDefault(_pages);

var _partyMode = __webpack_require__(3237);

var _partyMode2 = _interopRequireDefault(_partyMode);

var _peopleOutline = __webpack_require__(3238);

var _peopleOutline2 = _interopRequireDefault(_peopleOutline);

var _people = __webpack_require__(3239);

var _people2 = _interopRequireDefault(_people);

var _personAdd = __webpack_require__(3240);

var _personAdd2 = _interopRequireDefault(_personAdd);

var _personOutline = __webpack_require__(3241);

var _personOutline2 = _interopRequireDefault(_personOutline);

var _person = __webpack_require__(3242);

var _person2 = _interopRequireDefault(_person);

var _plusOne = __webpack_require__(3243);

var _plusOne2 = _interopRequireDefault(_plusOne);

var _poll = __webpack_require__(3244);

var _poll2 = _interopRequireDefault(_poll);

var _public = __webpack_require__(3245);

var _public2 = _interopRequireDefault(_public);

var _school = __webpack_require__(3246);

var _school2 = _interopRequireDefault(_school);

var _sentimentDissatisfied = __webpack_require__(3247);

var _sentimentDissatisfied2 = _interopRequireDefault(_sentimentDissatisfied);

var _sentimentNeutral = __webpack_require__(3248);

var _sentimentNeutral2 = _interopRequireDefault(_sentimentNeutral);

var _sentimentSatisfied = __webpack_require__(3249);

var _sentimentSatisfied2 = _interopRequireDefault(_sentimentSatisfied);

var _sentimentVeryDissatisfied = __webpack_require__(3250);

var _sentimentVeryDissatisfied2 = _interopRequireDefault(_sentimentVeryDissatisfied);

var _sentimentVerySatisfied = __webpack_require__(3251);

var _sentimentVerySatisfied2 = _interopRequireDefault(_sentimentVerySatisfied);

var _share = __webpack_require__(3252);

var _share2 = _interopRequireDefault(_share);

var _whatshot = __webpack_require__(3253);

var _whatshot2 = _interopRequireDefault(_whatshot);

var _checkBoxOutlineBlank = __webpack_require__(769);

var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);

var _checkBox = __webpack_require__(770);

var _checkBox2 = _interopRequireDefault(_checkBox);

var _indeterminateCheckBox = __webpack_require__(3254);

var _indeterminateCheckBox2 = _interopRequireDefault(_indeterminateCheckBox);

var _radioButtonChecked = __webpack_require__(778);

var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);

var _radioButtonUnchecked = __webpack_require__(777);

var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);

var _starBorder = __webpack_require__(936);

var _starBorder2 = _interopRequireDefault(_starBorder);

var _starHalf = __webpack_require__(3255);

var _starHalf2 = _interopRequireDefault(_starHalf);

var _star = __webpack_require__(935);

var _star2 = _interopRequireDefault(_star);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ActionAccessibility = _accessibility2.default;
exports.ActionAccessible = _accessible2.default;
exports.ActionAccountBalanceWallet = _accountBalanceWallet2.default;
exports.ActionAccountBalance = _accountBalance2.default;
exports.ActionAccountBox = _accountBox2.default;
exports.ActionAccountCircle = _accountCircle2.default;
exports.ActionAddShoppingCart = _addShoppingCart2.default;
exports.ActionAlarmAdd = _alarmAdd2.default;
exports.ActionAlarmOff = _alarmOff2.default;
exports.ActionAlarmOn = _alarmOn2.default;
exports.ActionAlarm = _alarm2.default;
exports.ActionAllOut = _allOut2.default;
exports.ActionAndroid = _android2.default;
exports.ActionAnnouncement = _announcement2.default;
exports.ActionAspectRatio = _aspectRatio2.default;
exports.ActionAssessment = _assessment2.default;
exports.ActionAssignmentInd = _assignmentInd2.default;
exports.ActionAssignmentLate = _assignmentLate2.default;
exports.ActionAssignmentReturn = _assignmentReturn2.default;
exports.ActionAssignmentReturned = _assignmentReturned2.default;
exports.ActionAssignmentTurnedIn = _assignmentTurnedIn2.default;
exports.ActionAssignment = _assignment2.default;
exports.ActionAutorenew = _autorenew2.default;
exports.ActionBackup = _backup2.default;
exports.ActionBook = _book2.default;
exports.ActionBookmarkBorder = _bookmarkBorder2.default;
exports.ActionBookmark = _bookmark2.default;
exports.ActionBugReport = _bugReport2.default;
exports.ActionBuild = _build2.default;
exports.ActionCached = _cached2.default;
exports.ActionCameraEnhance = _cameraEnhance2.default;
exports.ActionCardGiftcard = _cardGiftcard2.default;
exports.ActionCardMembership = _cardMembership2.default;
exports.ActionCardTravel = _cardTravel2.default;
exports.ActionChangeHistory = _changeHistory2.default;
exports.ActionCheckCircle = _checkCircle2.default;
exports.ActionChromeReaderMode = _chromeReaderMode2.default;
exports.ActionClass = _class2.default;
exports.ActionCode = _code2.default;
exports.ActionCompareArrows = _compareArrows2.default;
exports.ActionCopyright = _copyright2.default;
exports.ActionCreditCard = _creditCard2.default;
exports.ActionDashboard = _dashboard2.default;
exports.ActionDateRange = _dateRange2.default;
exports.ActionDeleteForever = _deleteForever2.default;
exports.ActionDelete = _delete2.default;
exports.ActionDescription = _description2.default;
exports.ActionDns = _dns2.default;
exports.ActionDoneAll = _doneAll2.default;
exports.ActionDone = _done2.default;
exports.ActionDonutLarge = _donutLarge2.default;
exports.ActionDonutSmall = _donutSmall2.default;
exports.ActionEject = _eject2.default;
exports.ActionEuroSymbol = _euroSymbol2.default;
exports.ActionEventSeat = _eventSeat2.default;
exports.ActionEvent = _event2.default;
exports.ActionExitToApp = _exitToApp2.default;
exports.ActionExplore = _explore2.default;
exports.ActionExtension = _extension2.default;
exports.ActionFace = _face2.default;
exports.ActionFavoriteBorder = _favoriteBorder2.default;
exports.ActionFavorite = _favorite2.default;
exports.ActionFeedback = _feedback2.default;
exports.ActionFindInPage = _findInPage2.default;
exports.ActionFindReplace = _findReplace2.default;
exports.ActionFingerprint = _fingerprint2.default;
exports.ActionFlightLand = _flightLand2.default;
exports.ActionFlightTakeoff = _flightTakeoff2.default;
exports.ActionFlipToBack = _flipToBack2.default;
exports.ActionFlipToFront = _flipToFront2.default;
exports.ActionGTranslate = _gTranslate2.default;
exports.ActionGavel = _gavel2.default;
exports.ActionGetApp = _getApp2.default;
exports.ActionGif = _gif2.default;
exports.ActionGrade = _grade2.default;
exports.ActionGroupWork = _groupWork2.default;
exports.ActionHelpOutline = _helpOutline2.default;
exports.ActionHelp = _help2.default;
exports.ActionHighlightOff = _highlightOff2.default;
exports.ActionHistory = _history2.default;
exports.ActionHome = _home2.default;
exports.ActionHourglassEmpty = _hourglassEmpty2.default;
exports.ActionHourglassFull = _hourglassFull2.default;
exports.ActionHttp = _http2.default;
exports.ActionHttps = _https2.default;
exports.ActionImportantDevices = _importantDevices2.default;
exports.ActionInfoOutline = _infoOutline2.default;
exports.ActionInfo = _info2.default;
exports.ActionInput = _input2.default;
exports.ActionInvertColors = _invertColors2.default;
exports.ActionLabelOutline = _labelOutline2.default;
exports.ActionLabel = _label2.default;
exports.ActionLanguage = _language2.default;
exports.ActionLaunch = _launch2.default;
exports.ActionLightbulbOutline = _lightbulbOutline2.default;
exports.ActionLineStyle = _lineStyle2.default;
exports.ActionLineWeight = _lineWeight2.default;
exports.ActionList = _list2.default;
exports.ActionLockOpen = _lockOpen2.default;
exports.ActionLockOutline = _lockOutline2.default;
exports.ActionLock = _lock2.default;
exports.ActionLoyalty = _loyalty2.default;
exports.ActionMarkunreadMailbox = _markunreadMailbox2.default;
exports.ActionMotorcycle = _motorcycle2.default;
exports.ActionNoteAdd = _noteAdd2.default;
exports.ActionOfflinePin = _offlinePin2.default;
exports.ActionOpacity = _opacity2.default;
exports.ActionOpenInBrowser = _openInBrowser2.default;
exports.ActionOpenInNew = _openInNew2.default;
exports.ActionOpenWith = _openWith2.default;
exports.ActionPageview = _pageview2.default;
exports.ActionPanTool = _panTool2.default;
exports.ActionPayment = _payment2.default;
exports.ActionPermCameraMic = _permCameraMic2.default;
exports.ActionPermContactCalendar = _permContactCalendar2.default;
exports.ActionPermDataSetting = _permDataSetting2.default;
exports.ActionPermDeviceInformation = _permDeviceInformation2.default;
exports.ActionPermIdentity = _permIdentity2.default;
exports.ActionPermMedia = _permMedia2.default;
exports.ActionPermPhoneMsg = _permPhoneMsg2.default;
exports.ActionPermScanWifi = _permScanWifi2.default;
exports.ActionPets = _pets2.default;
exports.ActionPictureInPictureAlt = _pictureInPictureAlt2.default;
exports.ActionPictureInPicture = _pictureInPicture2.default;
exports.ActionPlayForWork = _playForWork2.default;
exports.ActionPolymer = _polymer2.default;
exports.ActionPowerSettingsNew = _powerSettingsNew2.default;
exports.ActionPregnantWoman = _pregnantWoman2.default;
exports.ActionPrint = _print2.default;
exports.ActionQueryBuilder = _queryBuilder2.default;
exports.ActionQuestionAnswer = _questionAnswer2.default;
exports.ActionReceipt = _receipt2.default;
exports.ActionRecordVoiceOver = _recordVoiceOver2.default;
exports.ActionRedeem = _redeem2.default;
exports.ActionRemoveShoppingCart = _removeShoppingCart2.default;
exports.ActionReorder = _reorder2.default;
exports.ActionReportProblem = _reportProblem2.default;
exports.ActionRestorePage = _restorePage2.default;
exports.ActionRestore = _restore2.default;
exports.ActionRoom = _room2.default;
exports.ActionRoundedCorner = _roundedCorner2.default;
exports.ActionRowing = _rowing2.default;
exports.ActionSchedule = _schedule2.default;
exports.ActionSearch = _search2.default;
exports.ActionSettingsApplications = _settingsApplications2.default;
exports.ActionSettingsBackupRestore = _settingsBackupRestore2.default;
exports.ActionSettingsBluetooth = _settingsBluetooth2.default;
exports.ActionSettingsBrightness = _settingsBrightness2.default;
exports.ActionSettingsCell = _settingsCell2.default;
exports.ActionSettingsEthernet = _settingsEthernet2.default;
exports.ActionSettingsInputAntenna = _settingsInputAntenna2.default;
exports.ActionSettingsInputComponent = _settingsInputComponent2.default;
exports.ActionSettingsInputComposite = _settingsInputComposite2.default;
exports.ActionSettingsInputHdmi = _settingsInputHdmi2.default;
exports.ActionSettingsInputSvideo = _settingsInputSvideo2.default;
exports.ActionSettingsOverscan = _settingsOverscan2.default;
exports.ActionSettingsPhone = _settingsPhone2.default;
exports.ActionSettingsPower = _settingsPower2.default;
exports.ActionSettingsRemote = _settingsRemote2.default;
exports.ActionSettingsVoice = _settingsVoice2.default;
exports.ActionSettings = _settings2.default;
exports.ActionShopTwo = _shopTwo2.default;
exports.ActionShop = _shop2.default;
exports.ActionShoppingBasket = _shoppingBasket2.default;
exports.ActionShoppingCart = _shoppingCart2.default;
exports.ActionSpeakerNotesOff = _speakerNotesOff2.default;
exports.ActionSpeakerNotes = _speakerNotes2.default;
exports.ActionSpellcheck = _spellcheck2.default;
exports.ActionStars = _stars2.default;
exports.ActionStore = _store2.default;
exports.ActionSubject = _subject2.default;
exports.ActionSupervisorAccount = _supervisorAccount2.default;
exports.ActionSwapHoriz = _swapHoriz2.default;
exports.ActionSwapVert = _swapVert2.default;
exports.ActionSwapVerticalCircle = _swapVerticalCircle2.default;
exports.ActionSystemUpdateAlt = _systemUpdateAlt2.default;
exports.ActionTabUnselected = _tabUnselected2.default;
exports.ActionTab = _tab2.default;
exports.ActionTheaters = _theaters2.default;
exports.ActionThreeDRotation = _threeDRotation2.default;
exports.ActionThumbDown = _thumbDown2.default;
exports.ActionThumbUp = _thumbUp2.default;
exports.ActionThumbsUpDown = _thumbsUpDown2.default;
exports.ActionTimeline = _timeline2.default;
exports.ActionToc = _toc2.default;
exports.ActionToday = _today2.default;
exports.ActionToll = _toll2.default;
exports.ActionTouchApp = _touchApp2.default;
exports.ActionTrackChanges = _trackChanges2.default;
exports.ActionTranslate = _translate2.default;
exports.ActionTrendingDown = _trendingDown2.default;
exports.ActionTrendingFlat = _trendingFlat2.default;
exports.ActionTrendingUp = _trendingUp2.default;
exports.ActionTurnedInNot = _turnedInNot2.default;
exports.ActionTurnedIn = _turnedIn2.default;
exports.ActionUpdate = _update2.default;
exports.ActionVerifiedUser = _verifiedUser2.default;
exports.ActionViewAgenda = _viewAgenda2.default;
exports.ActionViewArray = _viewArray2.default;
exports.ActionViewCarousel = _viewCarousel2.default;
exports.ActionViewColumn = _viewColumn2.default;
exports.ActionViewDay = _viewDay2.default;
exports.ActionViewHeadline = _viewHeadline2.default;
exports.ActionViewList = _viewList2.default;
exports.ActionViewModule = _viewModule2.default;
exports.ActionViewQuilt = _viewQuilt2.default;
exports.ActionViewStream = _viewStream2.default;
exports.ActionViewWeek = _viewWeek2.default;
exports.ActionVisibilityOff = _visibilityOff2.default;
exports.ActionVisibility = _visibility2.default;
exports.ActionWatchLater = _watchLater2.default;
exports.ActionWork = _work2.default;
exports.ActionYoutubeSearchedFor = _youtubeSearchedFor2.default;
exports.ActionZoomIn = _zoomIn2.default;
exports.ActionZoomOut = _zoomOut2.default;
exports.AlertAddAlert = _addAlert2.default;
exports.AlertErrorOutline = _errorOutline2.default;
exports.AlertError = _error2.default;
exports.AlertWarning = _warning2.default;
exports.AvAddToQueue = _addToQueue2.default;
exports.AvAirplay = _airplay2.default;
exports.AvAlbum = _album2.default;
exports.AvArtTrack = _artTrack2.default;
exports.AvAvTimer = _avTimer2.default;
exports.AvBrandingWatermark = _brandingWatermark2.default;
exports.AvCallToAction = _callToAction2.default;
exports.AvClosedCaption = _closedCaption2.default;
exports.AvEqualizer = _equalizer2.default;
exports.AvExplicit = _explicit2.default;
exports.AvFastForward = _fastForward2.default;
exports.AvFastRewind = _fastRewind2.default;
exports.AvFeaturedPlayList = _featuredPlayList2.default;
exports.AvFeaturedVideo = _featuredVideo2.default;
exports.AvFiberDvr = _fiberDvr2.default;
exports.AvFiberManualRecord = _fiberManualRecord2.default;
exports.AvFiberNew = _fiberNew2.default;
exports.AvFiberPin = _fiberPin2.default;
exports.AvFiberSmartRecord = _fiberSmartRecord2.default;
exports.AvForward10 = _forward2.default;
exports.AvForward30 = _forward4.default;
exports.AvForward5 = _forward6.default;
exports.AvGames = _games2.default;
exports.AvHd = _hd2.default;
exports.AvHearing = _hearing2.default;
exports.AvHighQuality = _highQuality2.default;
exports.AvLibraryAdd = _libraryAdd2.default;
exports.AvLibraryBooks = _libraryBooks2.default;
exports.AvLibraryMusic = _libraryMusic2.default;
exports.AvLoop = _loop2.default;
exports.AvMicNone = _micNone2.default;
exports.AvMicOff = _micOff2.default;
exports.AvMic = _mic2.default;
exports.AvMovie = _movie2.default;
exports.AvMusicVideo = _musicVideo2.default;
exports.AvNewReleases = _newReleases2.default;
exports.AvNotInterested = _notInterested2.default;
exports.AvNote = _note2.default;
exports.AvPauseCircleFilled = _pauseCircleFilled2.default;
exports.AvPauseCircleOutline = _pauseCircleOutline2.default;
exports.AvPause = _pause2.default;
exports.AvPlayArrow = _playArrow2.default;
exports.AvPlayCircleFilled = _playCircleFilled2.default;
exports.AvPlayCircleOutline = _playCircleOutline2.default;
exports.AvPlaylistAddCheck = _playlistAddCheck2.default;
exports.AvPlaylistAdd = _playlistAdd2.default;
exports.AvPlaylistPlay = _playlistPlay2.default;
exports.AvQueueMusic = _queueMusic2.default;
exports.AvQueuePlayNext = _queuePlayNext2.default;
exports.AvQueue = _queue2.default;
exports.AvRadio = _radio2.default;
exports.AvRecentActors = _recentActors2.default;
exports.AvRemoveFromQueue = _removeFromQueue2.default;
exports.AvRepeatOne = _repeatOne2.default;
exports.AvRepeat = _repeat2.default;
exports.AvReplay10 = _replay2.default;
exports.AvReplay30 = _replay4.default;
exports.AvReplay5 = _replay6.default;
exports.AvReplay = _replay8.default;
exports.AvShuffle = _shuffle2.default;
exports.AvSkipNext = _skipNext2.default;
exports.AvSkipPrevious = _skipPrevious2.default;
exports.AvSlowMotionVideo = _slowMotionVideo2.default;
exports.AvSnooze = _snooze2.default;
exports.AvSortByAlpha = _sortByAlpha2.default;
exports.AvStop = _stop2.default;
exports.AvSubscriptions = _subscriptions2.default;
exports.AvSubtitles = _subtitles2.default;
exports.AvSurroundSound = _surroundSound2.default;
exports.AvVideoCall = _videoCall2.default;
exports.AvVideoLabel = _videoLabel2.default;
exports.AvVideoLibrary = _videoLibrary2.default;
exports.AvVideocamOff = _videocamOff2.default;
exports.AvVideocam = _videocam2.default;
exports.AvVolumeDown = _volumeDown2.default;
exports.AvVolumeMute = _volumeMute2.default;
exports.AvVolumeOff = _volumeOff2.default;
exports.AvVolumeUp = _volumeUp2.default;
exports.AvWebAsset = _webAsset2.default;
exports.AvWeb = _web2.default;
exports.CommunicationBusiness = _business2.default;
exports.CommunicationCallEnd = _callEnd2.default;
exports.CommunicationCallMade = _callMade2.default;
exports.CommunicationCallMerge = _callMerge2.default;
exports.CommunicationCallMissedOutgoing = _callMissedOutgoing2.default;
exports.CommunicationCallMissed = _callMissed2.default;
exports.CommunicationCallReceived = _callReceived2.default;
exports.CommunicationCallSplit = _callSplit2.default;
exports.CommunicationCall = _call2.default;
exports.CommunicationChatBubbleOutline = _chatBubbleOutline2.default;
exports.CommunicationChatBubble = _chatBubble2.default;
exports.CommunicationChat = _chat2.default;
exports.CommunicationClearAll = _clearAll2.default;
exports.CommunicationComment = _comment2.default;
exports.CommunicationContactMail = _contactMail2.default;
exports.CommunicationContactPhone = _contactPhone2.default;
exports.CommunicationContacts = _contacts2.default;
exports.CommunicationDialerSip = _dialerSip2.default;
exports.CommunicationDialpad = _dialpad2.default;
exports.CommunicationEmail = _email2.default;
exports.CommunicationForum = _forum2.default;
exports.CommunicationImportContacts = _importContacts2.default;
exports.CommunicationImportExport = _importExport2.default;
exports.CommunicationInvertColorsOff = _invertColorsOff2.default;
exports.CommunicationLiveHelp = _liveHelp2.default;
exports.CommunicationLocationOff = _locationOff2.default;
exports.CommunicationLocationOn = _locationOn2.default;
exports.CommunicationMailOutline = _mailOutline2.default;
exports.CommunicationMessage = _message2.default;
exports.CommunicationNoSim = _noSim2.default;
exports.CommunicationPhone = _phone2.default;
exports.CommunicationPhonelinkErase = _phonelinkErase2.default;
exports.CommunicationPhonelinkLock = _phonelinkLock2.default;
exports.CommunicationPhonelinkRing = _phonelinkRing2.default;
exports.CommunicationPhonelinkSetup = _phonelinkSetup2.default;
exports.CommunicationPortableWifiOff = _portableWifiOff2.default;
exports.CommunicationPresentToAll = _presentToAll2.default;
exports.CommunicationRingVolume = _ringVolume2.default;
exports.CommunicationRssFeed = _rssFeed2.default;
exports.CommunicationScreenShare = _screenShare2.default;
exports.CommunicationSpeakerPhone = _speakerPhone2.default;
exports.CommunicationStayCurrentLandscape = _stayCurrentLandscape2.default;
exports.CommunicationStayCurrentPortrait = _stayCurrentPortrait2.default;
exports.CommunicationStayPrimaryLandscape = _stayPrimaryLandscape2.default;
exports.CommunicationStayPrimaryPortrait = _stayPrimaryPortrait2.default;
exports.CommunicationStopScreenShare = _stopScreenShare2.default;
exports.CommunicationSwapCalls = _swapCalls2.default;
exports.CommunicationTextsms = _textsms2.default;
exports.CommunicationVoicemail = _voicemail2.default;
exports.CommunicationVpnKey = _vpnKey2.default;
exports.ContentAddBox = _addBox2.default;
exports.ContentAddCircleOutline = _addCircleOutline2.default;
exports.ContentAddCircle = _addCircle2.default;
exports.ContentAdd = _add2.default;
exports.ContentArchive = _archive2.default;
exports.ContentBackspace = _backspace2.default;
exports.ContentBlock = _block2.default;
exports.ContentClear = _clear2.default;
exports.ContentContentCopy = _contentCopy2.default;
exports.ContentContentCut = _contentCut2.default;
exports.ContentContentPaste = _contentPaste2.default;
exports.ContentCreate = _create2.default;
exports.ContentDeleteSweep = _deleteSweep2.default;
exports.ContentDrafts = _drafts2.default;
exports.ContentFilterList = _filterList2.default;
exports.ContentFlag = _flag2.default;
exports.ContentFontDownload = _fontDownload2.default;
exports.ContentForward = _forward8.default;
exports.ContentGesture = _gesture2.default;
exports.ContentInbox = _inbox2.default;
exports.ContentLink = _link2.default;
exports.ContentLowPriority = _lowPriority2.default;
exports.ContentMail = _mail2.default;
exports.ContentMarkunread = _markunread2.default;
exports.ContentMoveToInbox = _moveToInbox2.default;
exports.ContentNextWeek = _nextWeek2.default;
exports.ContentRedo = _redo2.default;
exports.ContentRemoveCircleOutline = _removeCircleOutline2.default;
exports.ContentRemoveCircle = _removeCircle2.default;
exports.ContentRemove = _remove2.default;
exports.ContentReplyAll = _replyAll2.default;
exports.ContentReply = _reply2.default;
exports.ContentReport = _report2.default;
exports.ContentSave = _save2.default;
exports.ContentSelectAll = _selectAll2.default;
exports.ContentSend = _send2.default;
exports.ContentSort = _sort2.default;
exports.ContentTextFormat = _textFormat2.default;
exports.ContentUnarchive = _unarchive2.default;
exports.ContentUndo = _undo2.default;
exports.ContentWeekend = _weekend2.default;
exports.DeviceAccessAlarm = _accessAlarm2.default;
exports.DeviceAccessAlarms = _accessAlarms2.default;
exports.DeviceAccessTime = _accessTime2.default;
exports.DeviceAddAlarm = _addAlarm2.default;
exports.DeviceAirplanemodeActive = _airplanemodeActive2.default;
exports.DeviceAirplanemodeInactive = _airplanemodeInactive2.default;
exports.DeviceBattery20 = _battery2.default;
exports.DeviceBattery30 = _battery4.default;
exports.DeviceBattery50 = _battery6.default;
exports.DeviceBattery60 = _battery8.default;
exports.DeviceBattery80 = _battery10.default;
exports.DeviceBattery90 = _battery12.default;
exports.DeviceBatteryAlert = _batteryAlert2.default;
exports.DeviceBatteryCharging20 = _batteryCharging2.default;
exports.DeviceBatteryCharging30 = _batteryCharging4.default;
exports.DeviceBatteryCharging50 = _batteryCharging6.default;
exports.DeviceBatteryCharging60 = _batteryCharging8.default;
exports.DeviceBatteryCharging80 = _batteryCharging10.default;
exports.DeviceBatteryCharging90 = _batteryCharging12.default;
exports.DeviceBatteryChargingFull = _batteryChargingFull2.default;
exports.DeviceBatteryFull = _batteryFull2.default;
exports.DeviceBatteryStd = _batteryStd2.default;
exports.DeviceBatteryUnknown = _batteryUnknown2.default;
exports.DeviceBluetoothConnected = _bluetoothConnected2.default;
exports.DeviceBluetoothDisabled = _bluetoothDisabled2.default;
exports.DeviceBluetoothSearching = _bluetoothSearching2.default;
exports.DeviceBluetooth = _bluetooth2.default;
exports.DeviceBrightnessAuto = _brightnessAuto2.default;
exports.DeviceBrightnessHigh = _brightnessHigh2.default;
exports.DeviceBrightnessLow = _brightnessLow2.default;
exports.DeviceBrightnessMedium = _brightnessMedium2.default;
exports.DeviceDataUsage = _dataUsage2.default;
exports.DeviceDeveloperMode = _developerMode2.default;
exports.DeviceDevices = _devices2.default;
exports.DeviceDvr = _dvr2.default;
exports.DeviceGpsFixed = _gpsFixed2.default;
exports.DeviceGpsNotFixed = _gpsNotFixed2.default;
exports.DeviceGpsOff = _gpsOff2.default;
exports.DeviceGraphicEq = _graphicEq2.default;
exports.DeviceLocationDisabled = _locationDisabled2.default;
exports.DeviceLocationSearching = _locationSearching2.default;
exports.DeviceNetworkCell = _networkCell2.default;
exports.DeviceNetworkWifi = _networkWifi2.default;
exports.DeviceNfc = _nfc2.default;
exports.DeviceScreenLockLandscape = _screenLockLandscape2.default;
exports.DeviceScreenLockPortrait = _screenLockPortrait2.default;
exports.DeviceScreenLockRotation = _screenLockRotation2.default;
exports.DeviceScreenRotation = _screenRotation2.default;
exports.DeviceSdStorage = _sdStorage2.default;
exports.DeviceSettingsSystemDaydream = _settingsSystemDaydream2.default;
exports.DeviceSignalCellular0Bar = _signalCellular0Bar2.default;
exports.DeviceSignalCellular1Bar = _signalCellular1Bar2.default;
exports.DeviceSignalCellular2Bar = _signalCellular2Bar2.default;
exports.DeviceSignalCellular3Bar = _signalCellular3Bar2.default;
exports.DeviceSignalCellular4Bar = _signalCellular4Bar2.default;
exports.DeviceSignalCellularConnectedNoInternet0Bar = _signalCellularConnectedNoInternet0Bar2.default;
exports.DeviceSignalCellularConnectedNoInternet1Bar = _signalCellularConnectedNoInternet1Bar2.default;
exports.DeviceSignalCellularConnectedNoInternet2Bar = _signalCellularConnectedNoInternet2Bar2.default;
exports.DeviceSignalCellularConnectedNoInternet3Bar = _signalCellularConnectedNoInternet3Bar2.default;
exports.DeviceSignalCellularConnectedNoInternet4Bar = _signalCellularConnectedNoInternet4Bar2.default;
exports.DeviceSignalCellularNoSim = _signalCellularNoSim2.default;
exports.DeviceSignalCellularNull = _signalCellularNull2.default;
exports.DeviceSignalCellularOff = _signalCellularOff2.default;
exports.DeviceSignalWifi0Bar = _signalWifi0Bar2.default;
exports.DeviceSignalWifi1BarLock = _signalWifi1BarLock2.default;
exports.DeviceSignalWifi1Bar = _signalWifi1Bar2.default;
exports.DeviceSignalWifi2BarLock = _signalWifi2BarLock2.default;
exports.DeviceSignalWifi2Bar = _signalWifi2Bar2.default;
exports.DeviceSignalWifi3BarLock = _signalWifi3BarLock2.default;
exports.DeviceSignalWifi3Bar = _signalWifi3Bar2.default;
exports.DeviceSignalWifi4BarLock = _signalWifi4BarLock2.default;
exports.DeviceSignalWifi4Bar = _signalWifi4Bar2.default;
exports.DeviceSignalWifiOff = _signalWifiOff2.default;
exports.DeviceStorage = _storage2.default;
exports.DeviceUsb = _usb2.default;
exports.DeviceWallpaper = _wallpaper2.default;
exports.DeviceWidgets = _widgets2.default;
exports.DeviceWifiLock = _wifiLock2.default;
exports.DeviceWifiTethering = _wifiTethering2.default;
exports.EditorAttachFile = _attachFile2.default;
exports.EditorAttachMoney = _attachMoney2.default;
exports.EditorBorderAll = _borderAll2.default;
exports.EditorBorderBottom = _borderBottom2.default;
exports.EditorBorderClear = _borderClear2.default;
exports.EditorBorderColor = _borderColor2.default;
exports.EditorBorderHorizontal = _borderHorizontal2.default;
exports.EditorBorderInner = _borderInner2.default;
exports.EditorBorderLeft = _borderLeft2.default;
exports.EditorBorderOuter = _borderOuter2.default;
exports.EditorBorderRight = _borderRight2.default;
exports.EditorBorderStyle = _borderStyle2.default;
exports.EditorBorderTop = _borderTop2.default;
exports.EditorBorderVertical = _borderVertical2.default;
exports.EditorBubbleChart = _bubbleChart2.default;
exports.EditorDragHandle = _dragHandle2.default;
exports.EditorFormatAlignCenter = _formatAlignCenter2.default;
exports.EditorFormatAlignJustify = _formatAlignJustify2.default;
exports.EditorFormatAlignLeft = _formatAlignLeft2.default;
exports.EditorFormatAlignRight = _formatAlignRight2.default;
exports.EditorFormatBold = _formatBold2.default;
exports.EditorFormatClear = _formatClear2.default;
exports.EditorFormatColorFill = _formatColorFill2.default;
exports.EditorFormatColorReset = _formatColorReset2.default;
exports.EditorFormatColorText = _formatColorText2.default;
exports.EditorFormatIndentDecrease = _formatIndentDecrease2.default;
exports.EditorFormatIndentIncrease = _formatIndentIncrease2.default;
exports.EditorFormatItalic = _formatItalic2.default;
exports.EditorFormatLineSpacing = _formatLineSpacing2.default;
exports.EditorFormatListBulleted = _formatListBulleted2.default;
exports.EditorFormatListNumbered = _formatListNumbered2.default;
exports.EditorFormatPaint = _formatPaint2.default;
exports.EditorFormatQuote = _formatQuote2.default;
exports.EditorFormatShapes = _formatShapes2.default;
exports.EditorFormatSize = _formatSize2.default;
exports.EditorFormatStrikethrough = _formatStrikethrough2.default;
exports.EditorFormatTextdirectionLToR = _formatTextdirectionLToR2.default;
exports.EditorFormatTextdirectionRToL = _formatTextdirectionRToL2.default;
exports.EditorFormatUnderlined = _formatUnderlined2.default;
exports.EditorFunctions = _functions2.default;
exports.EditorHighlight = _highlight2.default;
exports.EditorInsertChart = _insertChart2.default;
exports.EditorInsertComment = _insertComment2.default;
exports.EditorInsertDriveFile = _insertDriveFile2.default;
exports.EditorInsertEmoticon = _insertEmoticon2.default;
exports.EditorInsertInvitation = _insertInvitation2.default;
exports.EditorInsertLink = _insertLink2.default;
exports.EditorInsertPhoto = _insertPhoto2.default;
exports.EditorLinearScale = _linearScale2.default;
exports.EditorMergeType = _mergeType2.default;
exports.EditorModeComment = _modeComment2.default;
exports.EditorModeEdit = _modeEdit2.default;
exports.EditorMonetizationOn = _monetizationOn2.default;
exports.EditorMoneyOff = _moneyOff2.default;
exports.EditorMultilineChart = _multilineChart2.default;
exports.EditorPieChartOutlined = _pieChartOutlined2.default;
exports.EditorPieChart = _pieChart2.default;
exports.EditorPublish = _publish2.default;
exports.EditorShortText = _shortText2.default;
exports.EditorShowChart = _showChart2.default;
exports.EditorSpaceBar = _spaceBar2.default;
exports.EditorStrikethroughS = _strikethroughS2.default;
exports.EditorTextFields = _textFields2.default;
exports.EditorTitle = _title2.default;
exports.EditorVerticalAlignBottom = _verticalAlignBottom2.default;
exports.EditorVerticalAlignCenter = _verticalAlignCenter2.default;
exports.EditorVerticalAlignTop = _verticalAlignTop2.default;
exports.EditorWrapText = _wrapText2.default;
exports.FileAttachment = _attachment2.default;
exports.FileCloudCircle = _cloudCircle2.default;
exports.FileCloudDone = _cloudDone2.default;
exports.FileCloudDownload = _cloudDownload2.default;
exports.FileCloudOff = _cloudOff2.default;
exports.FileCloudQueue = _cloudQueue2.default;
exports.FileCloudUpload = _cloudUpload2.default;
exports.FileCloud = _cloud2.default;
exports.FileCreateNewFolder = _createNewFolder2.default;
exports.FileFileDownload = _fileDownload2.default;
exports.FileFileUpload = _fileUpload2.default;
exports.FileFolderOpen = _folderOpen2.default;
exports.FileFolderShared = _folderShared2.default;
exports.FileFolder = _folder2.default;
exports.HardwareCastConnected = _castConnected2.default;
exports.HardwareCast = _cast2.default;
exports.HardwareComputer = _computer2.default;
exports.HardwareDesktopMac = _desktopMac2.default;
exports.HardwareDesktopWindows = _desktopWindows2.default;
exports.HardwareDeveloperBoard = _developerBoard2.default;
exports.HardwareDeviceHub = _deviceHub2.default;
exports.HardwareDevicesOther = _devicesOther2.default;
exports.HardwareDock = _dock2.default;
exports.HardwareGamepad = _gamepad2.default;
exports.HardwareHeadsetMic = _headsetMic2.default;
exports.HardwareHeadset = _headset2.default;
exports.HardwareKeyboardArrowDown = _keyboardArrowDown2.default;
exports.HardwareKeyboardArrowLeft = _keyboardArrowLeft2.default;
exports.HardwareKeyboardArrowRight = _keyboardArrowRight2.default;
exports.HardwareKeyboardArrowUp = _keyboardArrowUp2.default;
exports.HardwareKeyboardBackspace = _keyboardBackspace2.default;
exports.HardwareKeyboardCapslock = _keyboardCapslock2.default;
exports.HardwareKeyboardHide = _keyboardHide2.default;
exports.HardwareKeyboardReturn = _keyboardReturn2.default;
exports.HardwareKeyboardTab = _keyboardTab2.default;
exports.HardwareKeyboardVoice = _keyboardVoice2.default;
exports.HardwareKeyboard = _keyboard2.default;
exports.HardwareLaptopChromebook = _laptopChromebook2.default;
exports.HardwareLaptopMac = _laptopMac2.default;
exports.HardwareLaptopWindows = _laptopWindows2.default;
exports.HardwareLaptop = _laptop2.default;
exports.HardwareMemory = _memory2.default;
exports.HardwareMouse = _mouse2.default;
exports.HardwarePhoneAndroid = _phoneAndroid2.default;
exports.HardwarePhoneIphone = _phoneIphone2.default;
exports.HardwarePhonelinkOff = _phonelinkOff2.default;
exports.HardwarePhonelink = _phonelink2.default;
exports.HardwarePowerInput = _powerInput2.default;
exports.HardwareRouter = _router2.default;
exports.HardwareScanner = _scanner2.default;
exports.HardwareSecurity = _security2.default;
exports.HardwareSimCard = _simCard2.default;
exports.HardwareSmartphone = _smartphone2.default;
exports.HardwareSpeakerGroup = _speakerGroup2.default;
exports.HardwareSpeaker = _speaker2.default;
exports.HardwareTabletAndroid = _tabletAndroid2.default;
exports.HardwareTabletMac = _tabletMac2.default;
exports.HardwareTablet = _tablet2.default;
exports.HardwareToys = _toys2.default;
exports.HardwareTv = _tv2.default;
exports.HardwareVideogameAsset = _videogameAsset2.default;
exports.HardwareWatch = _watch2.default;
exports.ImageAddAPhoto = _addAPhoto2.default;
exports.ImageAddToPhotos = _addToPhotos2.default;
exports.ImageAdjust = _adjust2.default;
exports.ImageAssistantPhoto = _assistantPhoto2.default;
exports.ImageAssistant = _assistant2.default;
exports.ImageAudiotrack = _audiotrack2.default;
exports.ImageBlurCircular = _blurCircular2.default;
exports.ImageBlurLinear = _blurLinear2.default;
exports.ImageBlurOff = _blurOff2.default;
exports.ImageBlurOn = _blurOn2.default;
exports.ImageBrightness1 = _brightness2.default;
exports.ImageBrightness2 = _brightness4.default;
exports.ImageBrightness3 = _brightness6.default;
exports.ImageBrightness4 = _brightness8.default;
exports.ImageBrightness5 = _brightness10.default;
exports.ImageBrightness6 = _brightness12.default;
exports.ImageBrightness7 = _brightness14.default;
exports.ImageBrokenImage = _brokenImage2.default;
exports.ImageBrush = _brush2.default;
exports.ImageBurstMode = _burstMode2.default;
exports.ImageCameraAlt = _cameraAlt2.default;
exports.ImageCameraFront = _cameraFront2.default;
exports.ImageCameraRear = _cameraRear2.default;
exports.ImageCameraRoll = _cameraRoll2.default;
exports.ImageCamera = _camera2.default;
exports.ImageCenterFocusStrong = _centerFocusStrong2.default;
exports.ImageCenterFocusWeak = _centerFocusWeak2.default;
exports.ImageCollectionsBookmark = _collectionsBookmark2.default;
exports.ImageCollections = _collections2.default;
exports.ImageColorLens = _colorLens2.default;
exports.ImageColorize = _colorize2.default;
exports.ImageCompare = _compare2.default;
exports.ImageControlPointDuplicate = _controlPointDuplicate2.default;
exports.ImageControlPoint = _controlPoint2.default;
exports.ImageCrop169 = _crop2.default;
exports.ImageCrop32 = _crop4.default;
exports.ImageCrop54 = _crop6.default;
exports.ImageCrop75 = _crop8.default;
exports.ImageCropDin = _cropDin2.default;
exports.ImageCropFree = _cropFree2.default;
exports.ImageCropLandscape = _cropLandscape2.default;
exports.ImageCropOriginal = _cropOriginal2.default;
exports.ImageCropPortrait = _cropPortrait2.default;
exports.ImageCropRotate = _cropRotate2.default;
exports.ImageCropSquare = _cropSquare2.default;
exports.ImageCrop = _crop10.default;
exports.ImageDehaze = _dehaze2.default;
exports.ImageDetails = _details2.default;
exports.ImageEdit = _edit2.default;
exports.ImageExposureNeg1 = _exposureNeg2.default;
exports.ImageExposureNeg2 = _exposureNeg4.default;
exports.ImageExposurePlus1 = _exposurePlus2.default;
exports.ImageExposurePlus2 = _exposurePlus4.default;
exports.ImageExposureZero = _exposureZero2.default;
exports.ImageExposure = _exposure2.default;
exports.ImageFilter1 = _filter2.default;
exports.ImageFilter2 = _filter4.default;
exports.ImageFilter3 = _filter6.default;
exports.ImageFilter4 = _filter8.default;
exports.ImageFilter5 = _filter10.default;
exports.ImageFilter6 = _filter12.default;
exports.ImageFilter7 = _filter14.default;
exports.ImageFilter8 = _filter16.default;
exports.ImageFilter9Plus = _filter9Plus2.default;
exports.ImageFilter9 = _filter18.default;
exports.ImageFilterBAndW = _filterBAndW2.default;
exports.ImageFilterCenterFocus = _filterCenterFocus2.default;
exports.ImageFilterDrama = _filterDrama2.default;
exports.ImageFilterFrames = _filterFrames2.default;
exports.ImageFilterHdr = _filterHdr2.default;
exports.ImageFilterNone = _filterNone2.default;
exports.ImageFilterTiltShift = _filterTiltShift2.default;
exports.ImageFilterVintage = _filterVintage2.default;
exports.ImageFilter = _filter20.default;
exports.ImageFlare = _flare2.default;
exports.ImageFlashAuto = _flashAuto2.default;
exports.ImageFlashOff = _flashOff2.default;
exports.ImageFlashOn = _flashOn2.default;
exports.ImageFlip = _flip2.default;
exports.ImageGradient = _gradient2.default;
exports.ImageGrain = _grain2.default;
exports.ImageGridOff = _gridOff2.default;
exports.ImageGridOn = _gridOn2.default;
exports.ImageHdrOff = _hdrOff2.default;
exports.ImageHdrOn = _hdrOn2.default;
exports.ImageHdrStrong = _hdrStrong2.default;
exports.ImageHdrWeak = _hdrWeak2.default;
exports.ImageHealing = _healing2.default;
exports.ImageImageAspectRatio = _imageAspectRatio2.default;
exports.ImageImage = _image2.default;
exports.ImageIso = _iso2.default;
exports.ImageLandscape = _landscape2.default;
exports.ImageLeakAdd = _leakAdd2.default;
exports.ImageLeakRemove = _leakRemove2.default;
exports.ImageLens = _lens2.default;
exports.ImageLinkedCamera = _linkedCamera2.default;
exports.ImageLooks3 = _looks2.default;
exports.ImageLooks4 = _looks4.default;
exports.ImageLooks5 = _looks6.default;
exports.ImageLooks6 = _looks8.default;
exports.ImageLooksOne = _looksOne2.default;
exports.ImageLooksTwo = _looksTwo2.default;
exports.ImageLooks = _looks10.default;
exports.ImageLoupe = _loupe2.default;
exports.ImageMonochromePhotos = _monochromePhotos2.default;
exports.ImageMovieCreation = _movieCreation2.default;
exports.ImageMovieFilter = _movieFilter2.default;
exports.ImageMusicNote = _musicNote2.default;
exports.ImageNaturePeople = _naturePeople2.default;
exports.ImageNature = _nature2.default;
exports.ImageNavigateBefore = _navigateBefore2.default;
exports.ImageNavigateNext = _navigateNext2.default;
exports.ImagePalette = _palette2.default;
exports.ImagePanoramaFishEye = _panoramaFishEye2.default;
exports.ImagePanoramaHorizontal = _panoramaHorizontal2.default;
exports.ImagePanoramaVertical = _panoramaVertical2.default;
exports.ImagePanoramaWideAngle = _panoramaWideAngle2.default;
exports.ImagePanorama = _panorama2.default;
exports.ImagePhotoAlbum = _photoAlbum2.default;
exports.ImagePhotoCamera = _photoCamera2.default;
exports.ImagePhotoFilter = _photoFilter2.default;
exports.ImagePhotoLibrary = _photoLibrary2.default;
exports.ImagePhotoSizeSelectActual = _photoSizeSelectActual2.default;
exports.ImagePhotoSizeSelectLarge = _photoSizeSelectLarge2.default;
exports.ImagePhotoSizeSelectSmall = _photoSizeSelectSmall2.default;
exports.ImagePhoto = _photo2.default;
exports.ImagePictureAsPdf = _pictureAsPdf2.default;
exports.ImagePortrait = _portrait2.default;
exports.ImageRemoveRedEye = _removeRedEye2.default;
exports.ImageRotate90DegreesCcw = _rotate90DegreesCcw2.default;
exports.ImageRotateLeft = _rotateLeft2.default;
exports.ImageRotateRight = _rotateRight2.default;
exports.ImageSlideshow = _slideshow2.default;
exports.ImageStraighten = _straighten2.default;
exports.ImageStyle = _style2.default;
exports.ImageSwitchCamera = _switchCamera2.default;
exports.ImageSwitchVideo = _switchVideo2.default;
exports.ImageTagFaces = _tagFaces2.default;
exports.ImageTexture = _texture2.default;
exports.ImageTimelapse = _timelapse2.default;
exports.ImageTimer10 = _timer2.default;
exports.ImageTimer3 = _timer4.default;
exports.ImageTimerOff = _timerOff2.default;
exports.ImageTimer = _timer6.default;
exports.ImageTonality = _tonality2.default;
exports.ImageTransform = _transform2.default;
exports.ImageTune = _tune2.default;
exports.ImageViewComfy = _viewComfy2.default;
exports.ImageViewCompact = _viewCompact2.default;
exports.ImageVignette = _vignette2.default;
exports.ImageWbAuto = _wbAuto2.default;
exports.ImageWbCloudy = _wbCloudy2.default;
exports.ImageWbIncandescent = _wbIncandescent2.default;
exports.ImageWbIridescent = _wbIridescent2.default;
exports.ImageWbSunny = _wbSunny2.default;
exports.MapsAddLocation = _addLocation2.default;
exports.MapsBeenhere = _beenhere2.default;
exports.MapsDirectionsBike = _directionsBike2.default;
exports.MapsDirectionsBoat = _directionsBoat2.default;
exports.MapsDirectionsBus = _directionsBus2.default;
exports.MapsDirectionsCar = _directionsCar2.default;
exports.MapsDirectionsRailway = _directionsRailway2.default;
exports.MapsDirectionsRun = _directionsRun2.default;
exports.MapsDirectionsSubway = _directionsSubway2.default;
exports.MapsDirectionsTransit = _directionsTransit2.default;
exports.MapsDirectionsWalk = _directionsWalk2.default;
exports.MapsDirections = _directions2.default;
exports.MapsEditLocation = _editLocation2.default;
exports.MapsEvStation = _evStation2.default;
exports.MapsFlight = _flight2.default;
exports.MapsHotel = _hotel2.default;
exports.MapsLayersClear = _layersClear2.default;
exports.MapsLayers = _layers2.default;
exports.MapsLocalActivity = _localActivity2.default;
exports.MapsLocalAirport = _localAirport2.default;
exports.MapsLocalAtm = _localAtm2.default;
exports.MapsLocalBar = _localBar2.default;
exports.MapsLocalCafe = _localCafe2.default;
exports.MapsLocalCarWash = _localCarWash2.default;
exports.MapsLocalConvenienceStore = _localConvenienceStore2.default;
exports.MapsLocalDining = _localDining2.default;
exports.MapsLocalDrink = _localDrink2.default;
exports.MapsLocalFlorist = _localFlorist2.default;
exports.MapsLocalGasStation = _localGasStation2.default;
exports.MapsLocalGroceryStore = _localGroceryStore2.default;
exports.MapsLocalHospital = _localHospital2.default;
exports.MapsLocalHotel = _localHotel2.default;
exports.MapsLocalLaundryService = _localLaundryService2.default;
exports.MapsLocalLibrary = _localLibrary2.default;
exports.MapsLocalMall = _localMall2.default;
exports.MapsLocalMovies = _localMovies2.default;
exports.MapsLocalOffer = _localOffer2.default;
exports.MapsLocalParking = _localParking2.default;
exports.MapsLocalPharmacy = _localPharmacy2.default;
exports.MapsLocalPhone = _localPhone2.default;
exports.MapsLocalPizza = _localPizza2.default;
exports.MapsLocalPlay = _localPlay2.default;
exports.MapsLocalPostOffice = _localPostOffice2.default;
exports.MapsLocalPrintshop = _localPrintshop2.default;
exports.MapsLocalSee = _localSee2.default;
exports.MapsLocalShipping = _localShipping2.default;
exports.MapsLocalTaxi = _localTaxi2.default;
exports.MapsMap = _map2.default;
exports.MapsMyLocation = _myLocation2.default;
exports.MapsNavigation = _navigation2.default;
exports.MapsNearMe = _nearMe2.default;
exports.MapsPersonPinCircle = _personPinCircle2.default;
exports.MapsPersonPin = _personPin2.default;
exports.MapsPinDrop = _pinDrop2.default;
exports.MapsPlace = _place2.default;
exports.MapsRateReview = _rateReview2.default;
exports.MapsRestaurantMenu = _restaurantMenu2.default;
exports.MapsRestaurant = _restaurant2.default;
exports.MapsSatellite = _satellite2.default;
exports.MapsStoreMallDirectory = _storeMallDirectory2.default;
exports.MapsStreetview = _streetview2.default;
exports.MapsSubway = _subway2.default;
exports.MapsTerrain = _terrain2.default;
exports.MapsTraffic = _traffic2.default;
exports.MapsTrain = _train2.default;
exports.MapsTram = _tram2.default;
exports.MapsTransferWithinAStation = _transferWithinAStation2.default;
exports.MapsZoomOutMap = _zoomOutMap2.default;
exports.NavigationApps = _apps2.default;
exports.NavigationArrowBack = _arrowBack2.default;
exports.NavigationArrowDownward = _arrowDownward2.default;
exports.NavigationArrowDropDownCircle = _arrowDropDownCircle2.default;
exports.NavigationArrowDropDown = _arrowDropDown2.default;
exports.NavigationArrowDropUp = _arrowDropUp2.default;
exports.NavigationArrowForward = _arrowForward2.default;
exports.NavigationArrowUpward = _arrowUpward2.default;
exports.NavigationCancel = _cancel2.default;
exports.NavigationCheck = _check2.default;
exports.NavigationChevronLeft = _chevronLeft2.default;
exports.NavigationChevronRight = _chevronRight2.default;
exports.NavigationClose = _close2.default;
exports.NavigationExpandLess = _expandLess2.default;
exports.NavigationExpandMore = _expandMore2.default;
exports.NavigationFirstPage = _firstPage2.default;
exports.NavigationFullscreenExit = _fullscreenExit2.default;
exports.NavigationFullscreen = _fullscreen2.default;
exports.NavigationLastPage = _lastPage2.default;
exports.NavigationMenu = _menu2.default;
exports.NavigationMoreHoriz = _moreHoriz2.default;
exports.NavigationMoreVert = _moreVert2.default;
exports.NavigationRefresh = _refresh2.default;
exports.NavigationSubdirectoryArrowLeft = _subdirectoryArrowLeft2.default;
exports.NavigationSubdirectoryArrowRight = _subdirectoryArrowRight2.default;
exports.NavigationUnfoldLess = _unfoldLess2.default;
exports.NavigationUnfoldMore = _unfoldMore2.default;
exports.NavigationArrowDropRight = _navigationArrowDropRight2.default;
exports.NotificationAdb = _adb2.default;
exports.NotificationAirlineSeatFlatAngled = _airlineSeatFlatAngled2.default;
exports.NotificationAirlineSeatFlat = _airlineSeatFlat2.default;
exports.NotificationAirlineSeatIndividualSuite = _airlineSeatIndividualSuite2.default;
exports.NotificationAirlineSeatLegroomExtra = _airlineSeatLegroomExtra2.default;
exports.NotificationAirlineSeatLegroomNormal = _airlineSeatLegroomNormal2.default;
exports.NotificationAirlineSeatLegroomReduced = _airlineSeatLegroomReduced2.default;
exports.NotificationAirlineSeatReclineExtra = _airlineSeatReclineExtra2.default;
exports.NotificationAirlineSeatReclineNormal = _airlineSeatReclineNormal2.default;
exports.NotificationBluetoothAudio = _bluetoothAudio2.default;
exports.NotificationConfirmationNumber = _confirmationNumber2.default;
exports.NotificationDiscFull = _discFull2.default;
exports.NotificationDoNotDisturbAlt = _doNotDisturbAlt2.default;
exports.NotificationDoNotDisturbOff = _doNotDisturbOff2.default;
exports.NotificationDoNotDisturbOn = _doNotDisturbOn2.default;
exports.NotificationDoNotDisturb = _doNotDisturb2.default;
exports.NotificationDriveEta = _driveEta2.default;
exports.NotificationEnhancedEncryption = _enhancedEncryption2.default;
exports.NotificationEventAvailable = _eventAvailable2.default;
exports.NotificationEventBusy = _eventBusy2.default;
exports.NotificationEventNote = _eventNote2.default;
exports.NotificationFolderSpecial = _folderSpecial2.default;
exports.NotificationLiveTv = _liveTv2.default;
exports.NotificationMms = _mms2.default;
exports.NotificationMore = _more2.default;
exports.NotificationNetworkCheck = _networkCheck2.default;
exports.NotificationNetworkLocked = _networkLocked2.default;
exports.NotificationNoEncryption = _noEncryption2.default;
exports.NotificationOndemandVideo = _ondemandVideo2.default;
exports.NotificationPersonalVideo = _personalVideo2.default;
exports.NotificationPhoneBluetoothSpeaker = _phoneBluetoothSpeaker2.default;
exports.NotificationPhoneForwarded = _phoneForwarded2.default;
exports.NotificationPhoneInTalk = _phoneInTalk2.default;
exports.NotificationPhoneLocked = _phoneLocked2.default;
exports.NotificationPhoneMissed = _phoneMissed2.default;
exports.NotificationPhonePaused = _phonePaused2.default;
exports.NotificationPower = _power2.default;
exports.NotificationPriorityHigh = _priorityHigh2.default;
exports.NotificationRvHookup = _rvHookup2.default;
exports.NotificationSdCard = _sdCard2.default;
exports.NotificationSimCardAlert = _simCardAlert2.default;
exports.NotificationSmsFailed = _smsFailed2.default;
exports.NotificationSms = _sms2.default;
exports.NotificationSyncDisabled = _syncDisabled2.default;
exports.NotificationSyncProblem = _syncProblem2.default;
exports.NotificationSync = _sync2.default;
exports.NotificationSystemUpdate = _systemUpdate2.default;
exports.NotificationTapAndPlay = _tapAndPlay2.default;
exports.NotificationTimeToLeave = _timeToLeave2.default;
exports.NotificationVibration = _vibration2.default;
exports.NotificationVoiceChat = _voiceChat2.default;
exports.NotificationVpnLock = _vpnLock2.default;
exports.NotificationWc = _wc2.default;
exports.NotificationWifi = _wifi2.default;
exports.PlacesAcUnit = _acUnit2.default;
exports.PlacesAirportShuttle = _airportShuttle2.default;
exports.PlacesAllInclusive = _allInclusive2.default;
exports.PlacesBeachAccess = _beachAccess2.default;
exports.PlacesBusinessCenter = _businessCenter2.default;
exports.PlacesCasino = _casino2.default;
exports.PlacesChildCare = _childCare2.default;
exports.PlacesChildFriendly = _childFriendly2.default;
exports.PlacesFitnessCenter = _fitnessCenter2.default;
exports.PlacesFreeBreakfast = _freeBreakfast2.default;
exports.PlacesGolfCourse = _golfCourse2.default;
exports.PlacesHotTub = _hotTub2.default;
exports.PlacesKitchen = _kitchen2.default;
exports.PlacesPool = _pool2.default;
exports.PlacesRoomService = _roomService2.default;
exports.PlacesRvHookup = _rvHookup4.default;
exports.PlacesSmokeFree = _smokeFree2.default;
exports.PlacesSmokingRooms = _smokingRooms2.default;
exports.PlacesSpa = _spa2.default;
exports.SocialCake = _cake2.default;
exports.SocialDomain = _domain2.default;
exports.SocialGroupAdd = _groupAdd2.default;
exports.SocialGroup = _group2.default;
exports.SocialLocationCity = _locationCity2.default;
exports.SocialMoodBad = _moodBad2.default;
exports.SocialMood = _mood2.default;
exports.SocialNotificationsActive = _notificationsActive2.default;
exports.SocialNotificationsNone = _notificationsNone2.default;
exports.SocialNotificationsOff = _notificationsOff2.default;
exports.SocialNotificationsPaused = _notificationsPaused2.default;
exports.SocialNotifications = _notifications2.default;
exports.SocialPages = _pages2.default;
exports.SocialPartyMode = _partyMode2.default;
exports.SocialPeopleOutline = _peopleOutline2.default;
exports.SocialPeople = _people2.default;
exports.SocialPersonAdd = _personAdd2.default;
exports.SocialPersonOutline = _personOutline2.default;
exports.SocialPerson = _person2.default;
exports.SocialPlusOne = _plusOne2.default;
exports.SocialPoll = _poll2.default;
exports.SocialPublic = _public2.default;
exports.SocialSchool = _school2.default;
exports.SocialSentimentDissatisfied = _sentimentDissatisfied2.default;
exports.SocialSentimentNeutral = _sentimentNeutral2.default;
exports.SocialSentimentSatisfied = _sentimentSatisfied2.default;
exports.SocialSentimentVeryDissatisfied = _sentimentVeryDissatisfied2.default;
exports.SocialSentimentVerySatisfied = _sentimentVerySatisfied2.default;
exports.SocialShare = _share2.default;
exports.SocialWhatshot = _whatshot2.default;
exports.ToggleCheckBoxOutlineBlank = _checkBoxOutlineBlank2.default;
exports.ToggleCheckBox = _checkBox2.default;
exports.ToggleIndeterminateCheckBox = _indeterminateCheckBox2.default;
exports.ToggleRadioButtonChecked = _radioButtonChecked2.default;
exports.ToggleRadioButtonUnchecked = _radioButtonUnchecked2.default;
exports.ToggleStarBorder = _starBorder2.default;
exports.ToggleStarHalf = _starHalf2.default;
exports.ToggleStar = _star2.default;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCached = function ActionCached(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z' })
  );
};
ActionCached = (0, _pure2.default)(ActionCached);
ActionCached.displayName = 'ActionCached';
ActionCached.muiName = 'SvgIcon';

exports.default = ActionCached;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDescription = function ActionDescription(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' })
  );
};
ActionDescription = (0, _pure2.default)(ActionDescription);
ActionDescription.displayName = 'ActionDescription';
ActionDescription.muiName = 'SvgIcon';

exports.default = ActionDescription;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionList = function ActionList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z' })
  );
};
ActionList = (0, _pure2.default)(ActionList);
ActionList.displayName = 'ActionList';
ActionList.muiName = 'SvgIcon';

exports.default = ActionList;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSpeakerNotes = function ActionSpeakerNotes(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z' })
  );
};
ActionSpeakerNotes = (0, _pure2.default)(ActionSpeakerNotes);
ActionSpeakerNotes.displayName = 'ActionSpeakerNotes';
ActionSpeakerNotes.muiName = 'SvgIcon';

exports.default = ActionSpeakerNotes;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvReplay = function AvReplay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z' })
  );
};
AvReplay = (0, _pure2.default)(AvReplay);
AvReplay.displayName = 'AvReplay';
AvReplay.muiName = 'SvgIcon';

exports.default = AvReplay;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentDeleteSweep = function ContentDeleteSweep(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z' })
  );
};
ContentDeleteSweep = (0, _pure2.default)(ContentDeleteSweep);
ContentDeleteSweep.displayName = 'ContentDeleteSweep';
ContentDeleteSweep.muiName = 'SvgIcon';

exports.default = ContentDeleteSweep;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorModeEdit = function EditorModeEdit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
  );
};
EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
EditorModeEdit.displayName = 'EditorModeEdit';
EditorModeEdit.muiName = 'SvgIcon';

exports.default = EditorModeEdit;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFileUpload = function FileFileUpload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z' })
  );
};
FileFileUpload = (0, _pure2.default)(FileFileUpload);
FileFileUpload.displayName = 'FileFileUpload';
FileFileUpload.muiName = 'SvgIcon';

exports.default = FileFileUpload;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowRight = function HardwareKeyboardArrowRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' })
  );
};
HardwareKeyboardArrowRight = (0, _pure2.default)(HardwareKeyboardArrowRight);
HardwareKeyboardArrowRight.displayName = 'HardwareKeyboardArrowRight';
HardwareKeyboardArrowRight.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowRight;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageEdit = function ImageEdit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
  );
};
ImageEdit = (0, _pure2.default)(ImageEdit);
ImageEdit.displayName = 'ImageEdit';
ImageEdit.muiName = 'SvgIcon';

exports.default = ImageEdit;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowUpward = function NavigationArrowUpward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z' })
  );
};
NavigationArrowUpward = (0, _pure2.default)(NavigationArrowUpward);
NavigationArrowUpward.displayName = 'NavigationArrowUpward';
NavigationArrowUpward.muiName = 'SvgIcon';

exports.default = NavigationArrowUpward;

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    icon: {
        color: 'rgb(0, 188, 212)'
    }
};

var validateEmail = function validateEmail(email) {
    if (!email) return '';
    var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return re.test(email) ? '' : 'Invalid email address';
};

var Emails = function Emails(_ref) {
    var _ref$emails = _ref.emails,
        emails = _ref$emails === undefined ? [''] : _ref$emails,
        onChange = _ref.onChange,
        error = _ref.error;

    var addEmail = function addEmail() {
        onChange([].concat(_toConsumableArray(emails), ['']));
    };

    var removeEmail = function removeEmail(index) {
        var newEmails = emails.filter(function (_, i) {
            return i !== index;
        });
        onChange(newEmails);
    };

    var handleEmailChange = function handleEmailChange(index, value) {
        var newEmails = [].concat(_toConsumableArray(emails));
        newEmails[index] = value;
        onChange(newEmails);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        emails.map(function (email, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                        value: email,
                        onChange: function onChange(e) {
                            return handleEmailChange(index, e.target.value);
                        },
                        floatingLabelText: 'Email company',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        fullWidth: true,
                        errorText: validateEmail(email)
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2 center-xs middle-xs', style: { display: 'flex' } },
                    index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: addEmail
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_image_control_point___default.a, null)
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: function onClick() {
                                return removeEmail(index);
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                    )
                )
            );
        })
    );
};

Emails.propTypes = {
    emails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var _default = Emails;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Emails.jsx');
    reactHotLoader.register(validateEmail, 'validateEmail', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Emails.jsx');
    reactHotLoader.register(Emails, 'Emails', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Emails.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Emails.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









var styles = {
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    icon: {
        color: 'rgb(0, 188, 212)'
    }
};

var validatePhone = function validatePhone(phone) {
    if (!phone) return 'Required';
    if (!/^\d+$/.test(phone)) return 'Must be a number';
    if (phone.length < 7 || phone.length > 15) return 'Must be between 7 and 15 digits';
    return '';
};

var Phones = function Phones(_ref) {
    var _ref$phones = _ref.phones,
        phones = _ref$phones === undefined ? [{ code: '', phone: '' }] : _ref$phones,
        onChange = _ref.onChange,
        error = _ref.error,
        countries = _ref.countries;

    var filteredCountries = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        return countries.filter(function (country) {
            return country.phoneCode && country.phoneCode[0];
        });
    }, [countries]);

    var addPhone = function addPhone() {
        onChange([].concat(_toConsumableArray(phones), [{ code: '', phone: '' }]));
    };

    var removePhone = function removePhone(index) {
        var newPhones = phones.filter(function (_, i) {
            return i !== index;
        });
        onChange(newPhones);
    };

    var handlePhoneChange = function handlePhoneChange(index, field, value) {
        var newPhones = [].concat(_toConsumableArray(phones));
        newPhones[index] = _extends({}, newPhones[index], _defineProperty({}, field, value));
        onChange(newPhones);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        phones.map(function (phone, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                        {
                            value: phone.code,
                            onChange: function onChange(e, i, value) {
                                return handlePhoneChange(index, 'code', value);
                            },
                            floatingLabelText: 'Country',
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            fullWidth: true,
                            autoWidth: true,
                            errorText: !phone.code ? 'Required' : ''
                        },
                        filteredCountries.map(function (country, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], {
                                key: key,
                                value: country.phoneCode[0],
                                primaryText: country.phoneCode[0] + ' ' + country.name
                            });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                        value: phone.phone,
                        onChange: function onChange(e) {
                            return handlePhoneChange(index, 'phone', e.target.value);
                        },
                        floatingLabelText: 'Phone number',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        fullWidth: true,
                        errorText: validatePhone(phone.phone)
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2 center-xs middle-xs', style: { display: 'flex' } },
                    index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: addPhone
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default.a, null)
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon,
                            onClick: function onClick() {
                                return removePhone(index);
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                    )
                )
            );
        })
    );
};

Phones.propTypes = {
    phones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        phone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })),
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    countries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        phoneCode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    })).isRequired
};

var _default = Phones;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Phones.jsx');
    reactHotLoader.register(validatePhone, 'validatePhone', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Phones.jsx');
    reactHotLoader.register(Phones, 'Phones', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Phones.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/Phones.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_clear__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





/**
 * @typedef {Object} WithClearButtonProps
 * @property {any} value - the value to determine if clear button should be shown
 * @property {any} [clearValue] - the value to determine if clear button should be shown
 * @property {() => void} onClear - callback function to clear the value
 * @property {Object} [containerStyle] - optional styles for the container div
 * @property {Object} [clearButtonStyle] - optional styles for the clear button
 * @property {Object} [inputStyle] - optional styles for the input
 */

/**
 * Higher-order component that adds a clear button to input components
 * @template T
 * @param {React.ComponentType<T>} WrappedComponent - the component to wrap
 * @returns {React.ComponentType<T & WithClearButtonProps>} enhanced component with clear button
 */
var withClearButton = function withClearButton(WrappedComponent) {
    return function (_ref) {
        var value = _ref.value,
            _ref$clearValue = _ref.clearValue,
            clearValue = _ref$clearValue === undefined ? false : _ref$clearValue,
            onClear = _ref.onClear,
            _ref$containerStyle = _ref.containerStyle,
            containerStyle = _ref$containerStyle === undefined ? {} : _ref$containerStyle,
            _ref$clearButtonStyle = _ref.clearButtonStyle,
            clearButtonStyle = _ref$clearButtonStyle === undefined ? {} : _ref$clearButtonStyle,
            _ref$inputStyle = _ref.inputStyle,
            inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
            props = _objectWithoutProperties(_ref, ['value', 'clearValue', 'onClear', 'containerStyle', 'clearButtonStyle', 'inputStyle']);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: _extends({ position: 'relative' }, containerStyle) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, {
                value: value,
                inputStyle: _extends({}, inputStyle, clearValue ? { paddingRight: '24px' } : {})
            })),
            clearValue && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                {
                    onClick: onClear,
                    style: _extends({
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 24,
                        height: 24,
                        padding: 0,
                        zIndex: 2
                    }, clearButtonStyle),
                    iconStyle: { width: '16px', height: '16px' }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_clear___default.a, { style: { width: '16px', height: '16px' } })
            )
        );
    };
};

var _default = withClearButton;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(withClearButton, 'withClearButton', '/opt/atlassian/pipelines/agent/build/client/app/components/common/HOC/withClearButton.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/common/HOC/withClearButton.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IsCargoesFromUsersContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandleToggleConvertDialogContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_realNames__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_tags__ = __webpack_require__(3275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddTagsModal__ = __webpack_require__(3276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RealNamesRow__ = __webpack_require__(3277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_assigners__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConvertCargoDialog__ = __webpack_require__(3281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

















var rowsPerPage = [50, 100];

function FightRerenderWrapper(_ref) {
    var children = _ref.children;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'table-body' },
        children
    );
}

/**
 * 
 * @param {{
 *  rows: any[],
 *  cargoTypes: any[],
 *  SEARATES_CATEGORIES: any[],
 * }} param0
 * @returns 
 */
function _table(_ref2) {
    var rows = _ref2.rows,
        cargoTypes = _ref2.cargoTypes,
        SEARATES_CATEGORIES = _ref2.SEARATES_CATEGORIES;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_material_ui__["u" /* Table */],
        { selectable: false },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui__["w" /* TableHeader */],
            { displaySelectAll: false, adjustForCheckbox: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui__["y" /* TableRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnCSS, { width: '20%', maxWidth: 'unset' }) },
                    'Real Cargo name'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnCSS, { width: '20%', maxWidth: 'unset' }) },
                    'Cargo type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '10%', maxWidth: 'unset' }) },
                    'Details'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '7%', maxWidth: 'unset' }) },
                    'SF'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '20%', maxWidth: 'unset' }) },
                    'Tags'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '23%', maxWidth: 'unset' }) },
                    'Management'
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_material_ui__["v" /* TableBody */],
            { displayRowCheckbox: false },
            rows.map(function (r, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RealNamesRow__["a" /* default */], {
                    key: 'r_' + index,
                    item: r,
                    cargoTypes: cargoTypes,
                    SEARATES_CATEGORIES: SEARATES_CATEGORIES
                });
            })
        )
    );
}

var NamesTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(_table);

var IsCargoesFromUsersContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);
var HandleToggleConvertDialogContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);

/**
 * 
 * @param {RealNamesTableProps} props
 */
function RealNamesTable(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState2 = _slicedToArray(_useState, 2),
        search = _useState2[0],
        setSearch = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        searchApplied = _useState4[0],
        setSearchApplied = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState6 = _slicedToArray(_useState5, 2),
        page = _useState6[0],
        setPage = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(50),
        _useState8 = _slicedToArray(_useState7, 2),
        limit = _useState8[0],
        setLimit = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.items),
        _useState10 = _slicedToArray(_useState9, 2),
        rows = _useState10[0],
        setRows = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState12 = _slicedToArray(_useState11, 2),
        total = _useState12[0],
        setTotal = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState14 = _slicedToArray(_useState13, 2),
        manageTagsModalOpen = _useState14[0],
        setManageTagsModalOpen = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState16 = _slicedToArray(_useState15, 2),
        initialTagsCategories = _useState16[0],
        setInitialTagsCategories = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState18 = _slicedToArray(_useState17, 2),
        isCargoesFromUsers = _useState18[0],
        setIsCargoesFromUsers = _useState18[1];

    var _useState19 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState20 = _slicedToArray(_useState19, 2),
        openConvertDialog = _useState20[0],
        setOpenConvertDialog = _useState20[1];

    var _useState21 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState22 = _slicedToArray(_useState21, 2),
        currentCargoId = _useState22[0],
        setCurrentCargoId = _useState22[1];

    var changeSearch = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (value) {
        setSearch(value);
    }, []);
    var getCategories = function getCategories() {
        props.getCargoTagsCategories();
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        props.getCargoRealNamesPaginated({ limit: limit, page: page, filters: { search: search } });
        getCategories();
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        props.items.length && props.getCargoAssignersPost(props.items.map(function (i) {
            return i._id;
        }));
    }, [props.items]);

    var searchNames = function searchNames(_ref3) {
        var _ref3$newPage = _ref3.newPage,
            newPage = _ref3$newPage === undefined ? 1 : _ref3$newPage,
            _ref3$newLimit = _ref3.newLimit,
            newLimit = _ref3$newLimit === undefined ? 50 : _ref3$newLimit,
            _ref3$newSearchApplie = _ref3.newSearchApplied,
            newSearchApplied = _ref3$newSearchApplie === undefined ? false : _ref3$newSearchApplie,
            _ref3$additionalFilte = _ref3.additionalFilters,
            additionalFilters = _ref3$additionalFilte === undefined ? { isCargoesFromUsers: isCargoesFromUsers } : _ref3$additionalFilte;

        props.getCargoRealNamesPaginated({
            page: newPage,
            limit: newLimit,
            filters: _extends({
                search: newSearchApplied ? search : undefined
            }, additionalFilters)
        });
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setInitialTagsCategories(props.cargoTagsCategories);
    }, [props.cargoTagsCategories]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setTotal(props.total);
        setRows(props.items);
    }, [props.total, props.items, props.page, props.limit]);

    var handleToggleManageTags = function handleToggleManageTags() {
        setManageTagsModalOpen(!manageTagsModalOpen);
    };

    var handleUpdateRow = function handleUpdateRow(_ref4) {
        var _page = _ref4.page,
            numberOfRows = _ref4.numberOfRows;

        setLimit(numberOfRows);
        setPage(_page);
        searchNames({
            newPage: _page,
            newLimit: numberOfRows,
            newSearchApplied: !!searchApplied
        });
    };

    var handleClickSearch = function handleClickSearch() {
        setPage(1);
        setSearchApplied(!!search);
        searchNames({
            newPage: 1,
            newLimit: limit,
            newSearchApplied: !!search
        });
    };

    var handleCheckFromUsers = function handleCheckFromUsers() {
        setPage(1);
        setSearchApplied(!!search);
        setIsCargoesFromUsers(!isCargoesFromUsers);
        searchNames({
            newPage: 1,
            newLimit: limit,
            newSearchApplied: true,
            additionalFilters: { isCargoesFromUsers: !isCargoesFromUsers }
        });
    };

    var handleToggleConvertDialog = function handleToggleConvertDialog(cargoId) {
        if (openConvertDialog) {
            setCurrentCargoId(null);
        } else {
            setCurrentCargoId(cargoId);
        }

        setOpenConvertDialog(!openConvertDialog);
    };

    var handleConvert = function handleConvert() {
        __WEBPACK_IMPORTED_MODULE_13_services__["a" /* default */].convertUserCargoToAdmin(currentCargoId).then(function (response) {
            if (response.status === 200) {
                Object(__WEBPACK_IMPORTED_MODULE_14__helpers__["c" /* showNotification */])('Cargo converted successfully. ' + (response.data.data.hasDuplicates ? 'Cargo has duplicates.' : ''), 'success');
                setOpenConvertDialog(!openConvertDialog);
                props.getCargoRealNamesPaginated({ limit: limit, page: page, filters: { search: search } });
                setCurrentCargoId(null);
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_14__helpers__["c" /* showNotification */])('Failed to convert cargo. Error: ' + response.errors[0].messages[0], 'error');
            }
        });
    };

    var actionsConvert = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["g" /* FlatButton */], {
        label: 'Close',
        primary: true,
        onClick: handleToggleConvertDialog
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["g" /* FlatButton */], {
        label: 'Convert',
        primary: true,
        onClick: handleConvert
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        IsCargoesFromUsersContext.Provider,
        { value: isCargoesFromUsers },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            HandleToggleConvertDialogContext.Provider,
            { value: handleToggleConvertDialog },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                openConvertDialog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ConvertCargoDialog__["a" /* default */], {
                    open: openConvertDialog,
                    actions: actionsConvert,
                    handleClose: handleToggleConvertDialog,
                    handleConvert: handleConvert
                }) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AddTagsModal__["a" /* default */], {
                    manageTagsModalOpen: manageTagsModalOpen,
                    handleToggleManageTags: handleToggleManageTags,
                    getCategories: getCategories,
                    initialTagsCategories: initialTagsCategories
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item management' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["A" /* TextField */], {
                            value: search || '',
                            floatingLabelText: 'Search',
                            onChange: function onChange(e) {
                                return changeSearch(e.target.value || undefined);
                            },
                            onKeyDown: function onKeyDown(e) {
                                return e.keyCode === 13 && handleClickSearch();
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["b" /* Checkbox */], {
                            label: 'User cargoes',
                            checked: isCargoesFromUsers,
                            onCheck: handleCheckFromUsers,
                            style: { width: 'unset' },
                            labelStyle: { fontSize: '13px', width: '100%' }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["r" /* RaisedButton */], {
                            label: 'Search',
                            onClick: handleClickSearch,
                            primary: true
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["r" /* RaisedButton */], {
                            onClick: handleToggleManageTags,
                            label: 'Manage Tags',
                            primary: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Libs_Pagination__["a" /* default */], {
                            total: total,
                            rowsPerPage: rowsPerPage,
                            page: page,
                            numberOfRows: limit,
                            updateRows: handleUpdateRow
                        })
                    )
                ),
                props.isLoaded ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    FightRerenderWrapper,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NamesTable, {
                        rows: rows,
                        cargoTypes: props.cargoTypes,
                        SEARATES_CATEGORIES: props.seaRatesCategories
                    })
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["d" /* CircularProgress */], {
                    style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].circularProgress
                })
            )
        )
    );
}

RealNamesTable.defaultProps = {
    total: 0,
    page: 1,
    limit: 50,
    items: [],
    isLoaded: false,
    getCargoRealNamesPaginated: function getCargoRealNamesPaginated() {},
    getCargoTagsCategories: function getCargoTagsCategories() {},
    getCargoAssignersPost: function getCargoAssignersPost() {},
    cargoTypes: [],
    seaRatesCategories: []
};

RealNamesTable.propTypes = {
    total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    page: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    isLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    getCargoRealNamesPaginated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getCargoAssignersPost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getCargoTagsCategories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    cargoTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    seaRatesCategories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    var _state$cargoRealNames = state.cargoRealNames,
        items = _state$cargoRealNames.items,
        total = _state$cargoRealNames.total,
        filters = _state$cargoRealNames.filters,
        page = _state$cargoRealNames.page,
        limit = _state$cargoRealNames.limit,
        isLoaded = _state$cargoRealNames.isLoaded,
        seaRatesCategories = _state$cargoRealNames.categories;
    var cargoTagsCategories = state.cargoTagsCategories.items;
    var cargoTypes = state.cargoTypes;


    if (items.length && state.cargoAssigners.items.length) {
        items.forEach(function (row) {
            state.cargoAssigners.items.forEach(function (cargo) {
                if (row._id === cargo.realCargoId && cargo.seaRatesCategories && cargo.seaRatesCategories.length) {
                    row.hasSeaRates = true;
                }
            });
        });
    }

    return {
        items: items,
        total: total,
        search: filters ? filters.search : undefined,
        page: page,
        limit: limit,
        isLoaded: isLoaded,
        cargoTagsCategories: cargoTagsCategories,
        cargoTypes: cargoTypes,
        seaRatesCategories: seaRatesCategories
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getCargoTagsCategories: __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_tags__["a" /* getCargoTagsCategories */],
        getCargoRealNamesPaginated: __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_realNames__["b" /* getCargoRealNamesPaginated */],
        getCargoAssignersPost: __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_assigners__["b" /* getCargoAssignersPost */]
    }, dispatch);
})(RealNamesTable);

/* harmony default export */ __webpack_exports__["c"] = (_default);

/**
 * props
 * @typedef {Object} RealNamesTableProps
 * @property {any[]} items 
 * @property {number} total
 * @property {string} search
 * @property {number} page
 * @property {number} limit
 * @property {boolean} isLoaded
 * @property {Function} getCargoRealNamesPaginated
 * @property {Function} getCargoTagsCategories
 * @property {any[]} cargoTagsCategories
 * @property {any[]} cargoTypes
 * @property {any[]} seaRatesCategories
 * @property {Function} getCargoAssignersPost
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(rowsPerPage, 'rowsPerPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    reactHotLoader.register(FightRerenderWrapper, 'FightRerenderWrapper', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    reactHotLoader.register(_table, '_table', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    reactHotLoader.register(NamesTable, 'NamesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    reactHotLoader.register(IsCargoesFromUsersContext, 'IsCargoesFromUsersContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    reactHotLoader.register(HandleToggleConvertDialogContext, 'HandleToggleConvertDialogContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    reactHotLoader.register(RealNamesTable, 'RealNamesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128595
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CenterBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var CenterBox = function CenterBox(_ref) {
    var children = _ref.children;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            className: 'center-xs middle-xs',
            style: { display: 'flex', alignItems: 'center', justifyContent: 'center' }
        },
        children
    );
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CenterBox, 'CenterBox', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/utils.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var convert = __webpack_require__(3329);
var string = __webpack_require__(3331);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(960);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Element = __webpack_require__(131);

var exports = module.exports = Element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);

defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	}
});

module.exports = {
	frameDuration: 17,
	animations: [],
	dropFrames: 0,
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {Number} duration - The animation duration in ms.
	 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;
		var startTime = Date.now();
		var framesToDrop = 0;

		if (me.dropFrames > 1) {
			framesToDrop = Math.floor(me.dropFrames);
			me.dropFrames = me.dropFrames % 1;
		}

		me.advance(1 + framesToDrop);

		var endTime = Date.now();

		me.dropFrames += (endTime - startTime) / me.frameDuration;

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function(count) {
		var animations = this.animations;
		var animation, chart;
		var i = 0;

		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;

			animation.currentStep = (animation.currentStep || 0) + count;
			animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

			helpers.callback(animation.render, [chart, animation], chart);
			helpers.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= animation.numSteps) {
				helpers.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {Point} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param chart {chart} the chart
 * @param handler {Function} the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param items {ChartElement[]} elements to filter
 * @param position {Point} the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param chart {Chart} the chart to look at elements from
 * @param position {Point} the point to be nearest to
 * @param intersect {Boolean} if true, only consider items that intersect the position
 * @param distanceMetric {Function} function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);

		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {String} axis the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
module.exports = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

			// We have multiple items at the same distance from the event. Now sort by smallest
			if (nearestItems.length > 1) {
				nearestItems.sort(function(a, b) {
					var sizeA = a.getArea();
					var sizeB = b.getArea();
					var ret = sizeA - sizeB;

					if (ret === 0) {
						// if equal sort by dataset index
						ret = a._datasetIndex - b._datasetIndex;
					}

					return ret;
				});
			}

			// Return only 1 item
			return nearestItems.slice(0, 1);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);
var basic = __webpack_require__(3336);
var dom = __webpack_require__(3337);

// @TODO Make possible to select another platform at build time.
var implementation = dom._enabled ? dom : basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
module.exports = helpers.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {Object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {Boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {String} type - The ({@link IEvent}) type to listen for
	 * @param {Function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart -Chart from which to remove the listener
	 * @param {String} type - The ({@link IEvent}) type to remove
	 * @param {Function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

/**
 * @interface IPlatform
 * Allows abstracting platform dependencies away from the chart
 * @borrows Chart.platform.acquireContext as acquireContext
 * @borrows Chart.platform.releaseContext as releaseContext
 * @borrows Chart.platform.addEventListener as addEventListener
 * @borrows Chart.platform.removeEventListener as removeEventListener
 */

/**
 * @interface IEvent
 * @prop {String} type - The event type name, possible values are:
 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
 */


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);

defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
module.exports = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {Number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {Array} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Object} chart - The chart instance for which plugins should be called.
	 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {Boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {Array} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers.clone(defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

/**
 * Plugin extension hooks.
 * @interface IPlugin
 * @since 2.1.0
 */
/**
 * @method IPlugin#beforeInit
 * @desc Called before initializing `chart`.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterInit
 * @desc Called after `chart` has been initialized and before the first update.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeUpdate
 * @desc Called before updating `chart`. If any plugin returns `false`, the update
 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart update.
 */
/**
 * @method IPlugin#afterUpdate
 * @desc Called after `chart` has been updated and before rendering. Note that this
 * hook will not be called if the chart update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsUpdate
 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
 * the datasets update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} false to cancel the datasets update.
 * @since version 2.1.5
*/
/**
 * @method IPlugin#afterDatasetsUpdate
 * @desc Called after the `chart` datasets have been updated. Note that this hook
 * will not be called if the datasets update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @since version 2.1.5
 */
/**
 * @method IPlugin#beforeDatasetUpdate
 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
 * returns `false`, the datasets update is cancelled until another `update` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetUpdate
 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
 * that this hook will not be called if the datasets update has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeLayout
 * @desc Called before laying out `chart`. If any plugin returns `false`,
 * the layout update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart layout.
 */
/**
 * @method IPlugin#afterLayout
 * @desc Called after the `chart` has been layed out. Note that this hook will not
 * be called if the layout update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeRender
 * @desc Called before rendering `chart`. If any plugin returns `false`,
 * the rendering is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart rendering.
 */
/**
 * @method IPlugin#afterRender
 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
 * that this hook will not be called if the rendering has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDraw
 * @desc Called before drawing `chart` at every animation frame specified by the given
 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
 * another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart drawing.
 */
/**
 * @method IPlugin#afterDraw
 * @desc Called after the `chart` has been drawn for the specific easing value. Note
 * that this hook will not be called if the drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsDraw
 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
 * the datasets drawing is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetsDraw
 * @desc Called after the `chart` datasets have been drawn. Note that this hook
 * will not be called if the datasets drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetDraw
 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
 * is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetDraw
 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
 * (datasets are drawn in the reverse order). Note that this hook will not be called
 * if the datasets drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeTooltipDraw
 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
 * the tooltip drawing is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
 */
/**
 * @method IPlugin#afterTooltipDraw
 * @desc Called after drawing the `tooltip`. Note that this hook will not
 * be called if the tooltip drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeEvent
 * @desc Called before processing the specified `event`. If any plugin returns `false`,
 * the event will be discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterEvent
 * @desc Called after the `event` has been consumed. Note that this hook
 * will not be called if the `event` has been previously discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#resize
 * @desc Called after the chart as been resized.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#destroy
 * @desc Called after the chart as been destroyed.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);
var helpers = __webpack_require__(45);

defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {Point} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: Math.round(x / count),
			y: Math.round(y / count)
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {Point} the position of the event in canvas coordinates
	 * @returns {Point} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

/**
 * Helper method to merge the opacity into a color
 */
function mergeOpacity(colorString, opacity) {
	var color = helpers.color(colorString);
	return color.alpha(opacity * color.alpha()).rgbaString();
}

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {String} value - The value to split by newline.
 * @returns {Array} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


// Private helper to create a tooltip item model
// @param element : the chart element (point, arc, bar) to create the tooltip item for
// @return : new tooltip item
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {Object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = defaults.global;
	var valueOrDefault = helpers.valueOrDefault;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers.each(body, function(bodyItem) {
		helpers.each(bodyItem.before, maxLineWidth);
		helpers.each(bodyItem.lines, maxLineWidth);
		helpers.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports = module.exports = Element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = Math.round(tooltipPosition.x);
			model.y = Math.round(tooltipPosition.y);
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx, opacity) {
		var title = vm.title;

		if (title.length) {
			ctx.textAlign = vm._titleAlign;
			ctx.textBaseline = 'top';

			var titleFontSize = vm.titleFontSize;
			var titleSpacing = vm.titleSpacing;

			ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
			ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			var i, len;
			for (i = 0, len = title.length; i < len; ++i) {
				ctx.fillText(title[i], pt.x, pt.y);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === title.length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx, opacity) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var body = vm.body;

		ctx.textAlign = vm._bodyAlign;
		ctx.textBaseline = 'top';
		ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		// Before Body
		var xLinePadding = 0;
		var fillLineOfText = function(line) {
			ctx.fillText(line, pt.x + xLinePadding, pt.y);
			pt.y += bodyFontSize + bodySpacing;
		};

		// Before body lines
		ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
		helpers.each(vm.beforeBody, fillLineOfText);

		var drawColorBoxes = vm.displayColors;
		xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

		// Draw body lines now
		helpers.each(body, function(bodyItem, i) {
			var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
			ctx.fillStyle = textColor;
			helpers.each(bodyItem.before, fillLineOfText);

			helpers.each(bodyItem.lines, function(line) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
					ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
					ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
					ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(line);
			});

			helpers.each(bodyItem.after, fillLineOfText);
		});

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx, opacity) {
		var footer = vm.footer;

		if (footer.length) {
			pt.y += vm.footerMarginTop;

			ctx.textAlign = vm._footerAlign;
			ctx.textBaseline = 'top';

			ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
			ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			helpers.each(footer, function(line) {
				ctx.fillText(line, pt.x, pt.y);
				pt.y += vm.footerFontSize + vm.footerSpacing;
			});
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
		ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
		ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

			// Draw Title, Body, and Footer
			pt.x += vm.xPadding;
			pt.y += vm.yPadding;

			// Titles
			this.drawTitle(pt, vm, ctx, opacity);

			// Body
			this.drawBody(pt, vm, ctx, opacity);

			// Footer
			this.drawFooter(pt, vm, ctx, opacity);
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {Boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
		}

		// Remember Last Actives
		changed = !helpers.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
exports.positioners = positioners;



/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsEmails;
/* unused harmony export searchStatisticsEmails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsEmails(from, until, isWorkingHours) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_45" /* GET_STATISTICS_EMAILS */].REQUEST,
        from: from,
        until: until,
        isWorkingHours: isWorkingHours
    };
}

function searchStatisticsEmails(searchText) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_109" /* SEARCH_STATISTICS_EMAILS */],
        searchText: searchText
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsEmails, 'getStatisticsEmails', '/opt/atlassian/pipelines/agent/build/client/app/actions/statistics/emails.js');
    reactHotLoader.register(searchStatisticsEmails, 'searchStatisticsEmails', '/opt/atlassian/pipelines/agent/build/client/app/actions/statistics/emails.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsVesselPositions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsVesselPositions(from, until) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_48" /* GET_STATISTICS_VESSEL_POSITIONS */].REQUEST,
        from: from,
        until: until
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsVesselPositions, 'getStatisticsVesselPositions', '/opt/atlassian/pipelines/agent/build/client/app/actions/statistics/vesselPositions.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsCargoRequests;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsCargoRequests(from, until) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_44" /* GET_STATISTICS_CARGO_REQUESTS */].REQUEST,
        from: from,
        until: until
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsCargoRequests, 'getStatisticsCargoRequests', '/opt/atlassian/pipelines/agent/build/client/app/actions/statistics/cargoRequests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Fuse.js v3.3.0 - Lightweight fuzzy-search (http://fusejs.io)
 * 
 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Fuse", [], factory);
	else if(typeof exports === 'object')
		exports["Fuse"] = factory();
	else
		root["Fuse"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (obj) {
  return !Array.isArray ? Object.prototype.toString.call(obj) === '[object Array]' : Array.isArray(obj);
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bitapRegexSearch = __webpack_require__(5);
var bitapSearch = __webpack_require__(7);
var patternAlphabet = __webpack_require__(4);

var Bitap = function () {
  function Bitap(pattern, _ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? 0 : _ref$location,
        _ref$distance = _ref.distance,
        distance = _ref$distance === undefined ? 100 : _ref$distance,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
        _ref$maxPatternLength = _ref.maxPatternLength,
        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
        _ref$isCaseSensitive = _ref.isCaseSensitive,
        isCaseSensitive = _ref$isCaseSensitive === undefined ? false : _ref$isCaseSensitive,
        _ref$tokenSeparator = _ref.tokenSeparator,
        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
        _ref$findAllMatches = _ref.findAllMatches,
        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
        _ref$minMatchCharLeng = _ref.minMatchCharLength,
        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;

    _classCallCheck(this, Bitap);

    this.options = {
      location: location,
      distance: distance,
      threshold: threshold,
      maxPatternLength: maxPatternLength,
      isCaseSensitive: isCaseSensitive,
      tokenSeparator: tokenSeparator,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength
    };

    this.pattern = this.options.isCaseSensitive ? pattern : pattern.toLowerCase();

    if (this.pattern.length <= maxPatternLength) {
      this.patternAlphabet = patternAlphabet(this.pattern);
    }
  }

  _createClass(Bitap, [{
    key: 'search',
    value: function search(text) {
      if (!this.options.isCaseSensitive) {
        text = text.toLowerCase();
      }

      // Exact match
      if (this.pattern === text) {
        return {
          isMatch: true,
          score: 0,
          matchedIndices: [[0, text.length - 1]]
        };
      }

      // When pattern length is greater than the machine word length, just do a a regex comparison
      var _options = this.options,
          maxPatternLength = _options.maxPatternLength,
          tokenSeparator = _options.tokenSeparator;

      if (this.pattern.length > maxPatternLength) {
        return bitapRegexSearch(text, this.pattern, tokenSeparator);
      }

      // Otherwise, use Bitap algorithm
      var _options2 = this.options,
          location = _options2.location,
          distance = _options2.distance,
          threshold = _options2.threshold,
          findAllMatches = _options2.findAllMatches,
          minMatchCharLength = _options2.minMatchCharLength;

      return bitapSearch(text, this.pattern, this.patternAlphabet, {
        location: location,
        distance: distance,
        threshold: threshold,
        findAllMatches: findAllMatches,
        minMatchCharLength: minMatchCharLength
      });
    }
  }]);

  return Bitap;
}();

// let x = new Bitap("od mn war", {})
// let result = x.search("Old Man's War")
// console.log(result)

module.exports = Bitap;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = __webpack_require__(0);

var deepValue = function deepValue(obj, path, list) {
  if (!path) {
    // If there's no path left, we've gotten to the object we care about.
    list.push(obj);
  } else {
    var dotIndex = path.indexOf('.');
    var firstSegment = path;
    var remaining = null;

    if (dotIndex !== -1) {
      firstSegment = path.slice(0, dotIndex);
      remaining = path.slice(dotIndex + 1);
    }

    var value = obj[firstSegment];

    if (value !== null && value !== undefined) {
      if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
        list.push(value.toString());
      } else if (isArray(value)) {
        // Search each item in the array.
        for (var i = 0, len = value.length; i < len; i += 1) {
          deepValue(value[i], remaining, list);
        }
      } else if (remaining) {
        // An object. Recurse further.
        deepValue(value, remaining, list);
      }
    }
  }

  return list;
};

module.exports = function (obj, path) {
  return deepValue(obj, path, []);
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var matchedIndices = [];
  var start = -1;
  var end = -1;
  var i = 0;

  for (var len = matchmask.length; i < len; i += 1) {
    var match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        matchedIndices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    matchedIndices.push([start, i - 1]);
  }

  return matchedIndices;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (pattern) {
  var mask = {};
  var len = pattern.length;

  for (var i = 0; i < len; i += 1) {
    mask[pattern.charAt(i)] = 0;
  }

  for (var _i = 0; _i < len; _i += 1) {
    mask[pattern.charAt(_i)] |= 1 << len - _i - 1;
  }

  return mask;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SPECIAL_CHARS_REGEX = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;

module.exports = function (text, pattern) {
  var tokenSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : / +/g;

  var regex = new RegExp(pattern.replace(SPECIAL_CHARS_REGEX, '\\$&').replace(tokenSeparator, '|'));
  var matches = text.match(regex);
  var isMatch = !!matches;
  var matchedIndices = [];

  if (isMatch) {
    for (var i = 0, matchesLen = matches.length; i < matchesLen; i += 1) {
      var match = matches[i];
      matchedIndices.push([text.indexOf(match), match.length - 1]);
    }
  }

  return {
    // TODO: revisit this score
    score: isMatch ? 0.5 : 1,
    isMatch: isMatch,
    matchedIndices: matchedIndices
  };
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (pattern, _ref) {
  var _ref$errors = _ref.errors,
      errors = _ref$errors === undefined ? 0 : _ref$errors,
      _ref$currentLocation = _ref.currentLocation,
      currentLocation = _ref$currentLocation === undefined ? 0 : _ref$currentLocation,
      _ref$expectedLocation = _ref.expectedLocation,
      expectedLocation = _ref$expectedLocation === undefined ? 0 : _ref$expectedLocation,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 100 : _ref$distance;

  var accuracy = errors / pattern.length;
  var proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
  }

  return accuracy + proximity / distance;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bitapScore = __webpack_require__(6);
var matchedIndices = __webpack_require__(3);

module.exports = function (text, pattern, patternAlphabet, _ref) {
  var _ref$location = _ref.location,
      location = _ref$location === undefined ? 0 : _ref$location,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 100 : _ref$distance,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;

  var expectedLocation = location;
  // Set starting location at beginning text and initialize the alphabet.
  var textLen = text.length;
  // Highest score beyond which we give up.
  var currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  var bestLocation = text.indexOf(pattern, expectedLocation);

  var patternLen = pattern.length;

  // a mask of the matches
  var matchMask = [];
  for (var i = 0; i < textLen; i += 1) {
    matchMask[i] = 0;
  }

  if (bestLocation !== -1) {
    var score = bitapScore(pattern, {
      errors: 0,
      currentLocation: bestLocation,
      expectedLocation: expectedLocation,
      distance: distance
    });
    currentThreshold = Math.min(score, currentThreshold);

    // What about in the other direction? (speed up)
    bestLocation = text.lastIndexOf(pattern, expectedLocation + patternLen);

    if (bestLocation !== -1) {
      var _score = bitapScore(pattern, {
        errors: 0,
        currentLocation: bestLocation,
        expectedLocation: expectedLocation,
        distance: distance
      });
      currentThreshold = Math.min(_score, currentThreshold);
    }
  }

  // Reset the best location
  bestLocation = -1;

  var lastBitArr = [];
  var finalScore = 1;
  var binMax = patternLen + textLen;

  var mask = 1 << patternLen - 1;

  for (var _i = 0; _i < patternLen; _i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    var binMin = 0;
    var binMid = binMax;

    while (binMin < binMid) {
      var _score3 = bitapScore(pattern, {
        errors: _i,
        currentLocation: expectedLocation + binMid,
        expectedLocation: expectedLocation,
        distance: distance
      });

      if (_score3 <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    var start = Math.max(1, expectedLocation - binMid + 1);
    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    var bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << _i) - 1;

    for (var j = finish; j >= start; j -= 1) {
      var currentLocation = j - 1;
      var charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (charMatch) {
        matchMask[currentLocation] = 1;
      }

      // First pass: exact match
      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (_i !== 0) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = bitapScore(pattern, {
          errors: _i,
          currentLocation: currentLocation,
          expectedLocation: expectedLocation,
          distance: distance
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break;
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    var _score2 = bitapScore(pattern, {
      errors: _i + 1,
      currentLocation: expectedLocation,
      expectedLocation: expectedLocation,
      distance: distance
    });

    // console.log('score', score, finalScore)

    if (_score2 > currentThreshold) {
      break;
    }

    lastBitArr = bitArr;
  }

  // console.log('FINAL SCORE', finalScore)

  // Count exact matches (those with a score of 0) to be "almost" exact
  return {
    isMatch: bestLocation >= 0,
    score: finalScore === 0 ? 0.001 : finalScore,
    matchedIndices: matchedIndices(matchMask, minMatchCharLength)
  };
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bitap = __webpack_require__(1);
var deepValue = __webpack_require__(2);
var isArray = __webpack_require__(0);

var Fuse = function () {
  function Fuse(list, _ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? 0 : _ref$location,
        _ref$distance = _ref.distance,
        distance = _ref$distance === undefined ? 100 : _ref$distance,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
        _ref$maxPatternLength = _ref.maxPatternLength,
        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
        _ref$caseSensitive = _ref.caseSensitive,
        caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
        _ref$tokenSeparator = _ref.tokenSeparator,
        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
        _ref$findAllMatches = _ref.findAllMatches,
        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
        _ref$minMatchCharLeng = _ref.minMatchCharLength,
        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng,
        _ref$id = _ref.id,
        id = _ref$id === undefined ? null : _ref$id,
        _ref$keys = _ref.keys,
        keys = _ref$keys === undefined ? [] : _ref$keys,
        _ref$shouldSort = _ref.shouldSort,
        shouldSort = _ref$shouldSort === undefined ? true : _ref$shouldSort,
        _ref$getFn = _ref.getFn,
        getFn = _ref$getFn === undefined ? deepValue : _ref$getFn,
        _ref$sortFn = _ref.sortFn,
        sortFn = _ref$sortFn === undefined ? function (a, b) {
      return a.score - b.score;
    } : _ref$sortFn,
        _ref$tokenize = _ref.tokenize,
        tokenize = _ref$tokenize === undefined ? false : _ref$tokenize,
        _ref$matchAllTokens = _ref.matchAllTokens,
        matchAllTokens = _ref$matchAllTokens === undefined ? false : _ref$matchAllTokens,
        _ref$includeMatches = _ref.includeMatches,
        includeMatches = _ref$includeMatches === undefined ? false : _ref$includeMatches,
        _ref$includeScore = _ref.includeScore,
        includeScore = _ref$includeScore === undefined ? false : _ref$includeScore,
        _ref$verbose = _ref.verbose,
        verbose = _ref$verbose === undefined ? false : _ref$verbose;

    _classCallCheck(this, Fuse);

    this.options = {
      location: location,
      distance: distance,
      threshold: threshold,
      maxPatternLength: maxPatternLength,
      isCaseSensitive: caseSensitive,
      tokenSeparator: tokenSeparator,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      id: id,
      keys: keys,
      includeMatches: includeMatches,
      includeScore: includeScore,
      shouldSort: shouldSort,
      getFn: getFn,
      sortFn: sortFn,
      verbose: verbose,
      tokenize: tokenize,
      matchAllTokens: matchAllTokens
    };

    this.setCollection(list);
  }

  _createClass(Fuse, [{
    key: 'setCollection',
    value: function setCollection(list) {
      this.list = list;
      return list;
    }
  }, {
    key: 'search',
    value: function search(pattern) {
      this._log('---------\nSearch pattern: "' + pattern + '"');

      var _prepareSearchers2 = this._prepareSearchers(pattern),
          tokenSearchers = _prepareSearchers2.tokenSearchers,
          fullSearcher = _prepareSearchers2.fullSearcher;

      var _search2 = this._search(tokenSearchers, fullSearcher),
          weights = _search2.weights,
          results = _search2.results;

      this._computeScore(weights, results);

      if (this.options.shouldSort) {
        this._sort(results);
      }

      return this._format(results);
    }
  }, {
    key: '_prepareSearchers',
    value: function _prepareSearchers() {
      var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var tokenSearchers = [];

      if (this.options.tokenize) {
        // Tokenize on the separator
        var tokens = pattern.split(this.options.tokenSeparator);
        for (var i = 0, len = tokens.length; i < len; i += 1) {
          tokenSearchers.push(new Bitap(tokens[i], this.options));
        }
      }

      var fullSearcher = new Bitap(pattern, this.options);

      return { tokenSearchers: tokenSearchers, fullSearcher: fullSearcher };
    }
  }, {
    key: '_search',
    value: function _search() {
      var tokenSearchers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var fullSearcher = arguments[1];

      var list = this.list;
      var resultMap = {};
      var results = [];

      // Check the first item in the list, if it's a string, then we assume
      // that every item in the list is also a string, and thus it's a flattened array.
      if (typeof list[0] === 'string') {
        // Iterate over every item
        for (var i = 0, len = list.length; i < len; i += 1) {
          this._analyze({
            key: '',
            value: list[i],
            record: i,
            index: i
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }

        return { weights: null, results: results };
      }

      // Otherwise, the first item is an Object (hopefully), and thus the searching
      // is done on the values of the keys of each item.
      var weights = {};
      for (var _i = 0, _len = list.length; _i < _len; _i += 1) {
        var item = list[_i];
        // Iterate over every key
        for (var j = 0, keysLen = this.options.keys.length; j < keysLen; j += 1) {
          var key = this.options.keys[j];
          if (typeof key !== 'string') {
            weights[key.name] = {
              weight: 1 - key.weight || 1
            };
            if (key.weight <= 0 || key.weight > 1) {
              throw new Error('Key weight has to be > 0 and <= 1');
            }
            key = key.name;
          } else {
            weights[key] = {
              weight: 1
            };
          }

          this._analyze({
            key: key,
            value: this.options.getFn(item, key),
            record: item,
            index: _i
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }
      }

      return { weights: weights, results: results };
    }
  }, {
    key: '_analyze',
    value: function _analyze(_ref2, _ref3) {
      var key = _ref2.key,
          _ref2$arrayIndex = _ref2.arrayIndex,
          arrayIndex = _ref2$arrayIndex === undefined ? -1 : _ref2$arrayIndex,
          value = _ref2.value,
          record = _ref2.record,
          index = _ref2.index;
      var _ref3$tokenSearchers = _ref3.tokenSearchers,
          tokenSearchers = _ref3$tokenSearchers === undefined ? [] : _ref3$tokenSearchers,
          _ref3$fullSearcher = _ref3.fullSearcher,
          fullSearcher = _ref3$fullSearcher === undefined ? [] : _ref3$fullSearcher,
          _ref3$resultMap = _ref3.resultMap,
          resultMap = _ref3$resultMap === undefined ? {} : _ref3$resultMap,
          _ref3$results = _ref3.results,
          results = _ref3$results === undefined ? [] : _ref3$results;

      // Check if the texvaluet can be searched
      if (value === undefined || value === null) {
        return;
      }

      var exists = false;
      var averageScore = -1;
      var numTextMatches = 0;

      if (typeof value === 'string') {
        this._log('\nKey: ' + (key === '' ? '-' : key));

        var mainSearchResult = fullSearcher.search(value);
        this._log('Full text: "' + value + '", score: ' + mainSearchResult.score);

        if (this.options.tokenize) {
          var words = value.split(this.options.tokenSeparator);
          var scores = [];

          for (var i = 0; i < tokenSearchers.length; i += 1) {
            var tokenSearcher = tokenSearchers[i];

            this._log('\nPattern: "' + tokenSearcher.pattern + '"');

            // let tokenScores = []
            var hasMatchInText = false;

            for (var j = 0; j < words.length; j += 1) {
              var word = words[j];
              var tokenSearchResult = tokenSearcher.search(word);
              var obj = {};
              if (tokenSearchResult.isMatch) {
                obj[word] = tokenSearchResult.score;
                exists = true;
                hasMatchInText = true;
                scores.push(tokenSearchResult.score);
              } else {
                obj[word] = 1;
                if (!this.options.matchAllTokens) {
                  scores.push(1);
                }
              }
              this._log('Token: "' + word + '", score: ' + obj[word]);
              // tokenScores.push(obj)
            }

            if (hasMatchInText) {
              numTextMatches += 1;
            }
          }

          averageScore = scores[0];
          var scoresLen = scores.length;
          for (var _i2 = 1; _i2 < scoresLen; _i2 += 1) {
            averageScore += scores[_i2];
          }
          averageScore = averageScore / scoresLen;

          this._log('Token score average:', averageScore);
        }

        var finalScore = mainSearchResult.score;
        if (averageScore > -1) {
          finalScore = (finalScore + averageScore) / 2;
        }

        this._log('Score average:', finalScore);

        var checkTextMatches = this.options.tokenize && this.options.matchAllTokens ? numTextMatches >= tokenSearchers.length : true;

        this._log('\nCheck Matches: ' + checkTextMatches);

        // If a match is found, add the item to <rawResults>, including its score
        if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
          // Check if the item already exists in our results
          var existingResult = resultMap[index];
          if (existingResult) {
            // Use the lowest score
            // existingResult.score, bitapResult.score
            existingResult.output.push({
              key: key,
              arrayIndex: arrayIndex,
              value: value,
              score: finalScore,
              matchedIndices: mainSearchResult.matchedIndices
            });
          } else {
            // Add it to the raw result list
            resultMap[index] = {
              item: record,
              output: [{
                key: key,
                arrayIndex: arrayIndex,
                value: value,
                score: finalScore,
                matchedIndices: mainSearchResult.matchedIndices
              }]
            };

            results.push(resultMap[index]);
          }
        }
      } else if (isArray(value)) {
        for (var _i3 = 0, len = value.length; _i3 < len; _i3 += 1) {
          this._analyze({
            key: key,
            arrayIndex: _i3,
            value: value[_i3],
            record: record,
            index: index
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }
      }
    }
  }, {
    key: '_computeScore',
    value: function _computeScore(weights, results) {
      this._log('\n\nComputing score:\n');

      for (var i = 0, len = results.length; i < len; i += 1) {
        var output = results[i].output;
        var scoreLen = output.length;

        var currScore = 1;
        var bestScore = 1;

        for (var j = 0; j < scoreLen; j += 1) {
          var weight = weights ? weights[output[j].key].weight : 1;
          var score = weight === 1 ? output[j].score : output[j].score || 0.001;
          var nScore = score * weight;

          if (weight !== 1) {
            bestScore = Math.min(bestScore, nScore);
          } else {
            output[j].nScore = nScore;
            currScore *= nScore;
          }
        }

        results[i].score = bestScore === 1 ? currScore : bestScore;

        this._log(results[i]);
      }
    }
  }, {
    key: '_sort',
    value: function _sort(results) {
      this._log('\n\nSorting....');
      results.sort(this.options.sortFn);
    }
  }, {
    key: '_format',
    value: function _format(results) {
      var finalOutput = [];

      if (this.options.verbose) {
        this._log('\n\nOutput:\n\n', JSON.stringify(results));
      }

      var transformers = [];

      if (this.options.includeMatches) {
        transformers.push(function (result, data) {
          var output = result.output;
          data.matches = [];

          for (var i = 0, len = output.length; i < len; i += 1) {
            var item = output[i];

            if (item.matchedIndices.length === 0) {
              continue;
            }

            var obj = {
              indices: item.matchedIndices,
              value: item.value
            };
            if (item.key) {
              obj.key = item.key;
            }
            if (item.hasOwnProperty('arrayIndex') && item.arrayIndex > -1) {
              obj.arrayIndex = item.arrayIndex;
            }
            data.matches.push(obj);
          }
        });
      }

      if (this.options.includeScore) {
        transformers.push(function (result, data) {
          data.score = result.score;
        });
      }

      for (var i = 0, len = results.length; i < len; i += 1) {
        var result = results[i];

        if (this.options.id) {
          result.item = this.options.getFn(result.item, this.options.id)[0];
        }

        if (!transformers.length) {
          finalOutput.push(result.item);
          continue;
        }

        var data = {
          item: result.item
        };

        for (var j = 0, _len2 = transformers.length; j < _len2; j += 1) {
          transformers[j](result, data);
        }

        finalOutput.push(data);
      }

      return finalOutput;
    }
  }, {
    key: '_log',
    value: function _log() {
      if (this.options.verbose) {
        var _console;

        (_console = console).log.apply(_console, arguments);
      }
    }
  }]);

  return Fuse;
}();

module.exports = Fuse;

/***/ })
/******/ ]);
});
//# sourceMappingURL=fuse.js.map

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = handleChange;
/* unused harmony export getError */
/* unused harmony export renderError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();






function handleChange(key, value) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'text' : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? false : _ref$required;

  function isTypeNumber() {
    return type === 'number';
  }

  function validateValue(value) {
    var dots = 0;
    return !isTypeNumber() ? value : value.replace(/[^\d|\.|-]/, '').replace(/\./g, function () {
      return dots++ > 0 ? '' : '.';
    }).replace(/\-/g, function (match, str) {
      return str === 0 ? '-' : '';
    });
  }

  var state = JSON.parse(JSON.stringify(this.state));
  var errors = {};

  __WEBPACK_IMPORTED_MODULE_2_lodash_set___default()(state, key, validateValue(value));

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.state, key, '') === __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(state, key, '')) {
    return false;
  }

  errors[key] = (value && isTypeNumber() ? !isNaN(parseFloat(value)) : true) ? '' : required ? 'required' : '';

  this.setState(_extends({}, state, {
    errors: _extends({}, this.state.errors, errors)
  }));
}

function getError(error, cb) {
  var composedErrors = Object(__WEBPACK_IMPORTED_MODULE_3_helpers__["b" /* getNormalErrors */])(error);
  var errData = composedErrors.errors;
  var errMsg = composedErrors.errors;
  var stateErr = {
    errors: {},
    error: ''
  };

  errMsg && (stateErr.error = errMsg);
  Object.keys(errData).length && (stateErr.errors = errData);

  if (!Object.keys(stateErr).length) {
    return false;
  }

  if (Object.keys(stateErr.errors || {}).length && !stateErr.error) {
    stateErr.error = 'Check all fields filled correctly';
  }

  this.setState(_extends({}, stateErr), cb);

  return stateErr;
}

function renderError() {
  return this.state.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'm-v-1 error' },
    this.state.error
  ) : '';
}
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(handleChange, 'handleChange', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/RenderField/index.js');
  reactHotLoader.register(getError, 'getError', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/RenderField/index.js');
  reactHotLoader.register(renderError, 'renderError', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/RenderField/index.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Base_RenderField__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Subscription = function (_Component) {
  _inherits(Subscription, _Component);

  function Subscription() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Subscription);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Subscription.__proto__ || Object.getPrototypeOf(Subscription)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      amount: 1,
      period: 'months', //months, years, days
      trial: false,
      errors: {},
      error: ''
    }, _this.handleChange = __WEBPACK_IMPORTED_MODULE_6_components_Base_RenderField__["a" /* handleChange */].bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Subscription, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var data = nextProps.data;


      if (nextProps.data) {
        var dataIsEmpty = true;

        for (var key in data) {
          dataIsEmpty = false;
          break;
        }

        if (!dataIsEmpty) {
          this.setState({
            trial: data.trial
          });
        }
      }
    }

    // not necessary due to stripe integration
    // extendSubscription = async () => {
    //   let { fetchUser, data } = this.props;
    //   let { period, amount, trial } = this.state;

    //   let result = await api.users.extendSubscription(data._id, {period, amount, trial});

    //   if (result.status === 200) {
    //     await fetchUser();
    //     return showNotification('User\'s subscription has been updated');
    //   }

    //   this.setState({...getNormalErrors(result)})
    //   showNotification(this.state.error, 'error')
    // }

  }, {
    key: 'render',
    value: function render() {
      var _props$data = this.props.data,
          endAt = _props$data.endAt,
          _props$data$subscript = _props$data.subscriptions,
          subscriptions = _props$data$subscript === undefined ? [] : _props$data$subscript;
      var _state = this.state,
          period = _state.period,
          amount = _state.amount,
          trial = _state.trial;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'SUBSCRIPTION'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'm-t-1' },
          'Subscription ends at ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(endAt).format('DD.MM.YYYY')
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'm-t-1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            subscriptions.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12 m-t-2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'payment-history' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'text-center bold' },
                      'Billing History'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12 m-t-1 payment-history_header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'row' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-md-4' },
                        'Date'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-md-4' },
                        'Subscription is active'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-md-4' },
                        'Status'
                      )
                    )
                  ),
                  [].concat(_toConsumableArray(subscriptions)).reverse().map(function (sc) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        className: 'col-md-12 payment-history_entry',
                        key: sc.addedAt
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-4' },
                          __WEBPACK_IMPORTED_MODULE_1_moment___default()(sc.addedAt).format('DD.MM.YYYY HH:mm')
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-4' },
                          __WEBPACK_IMPORTED_MODULE_1_moment___default()(sc.from).format('DD.MM.YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(sc.to).format('DD.MM.YYYY')
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-4' },
                          sc.statusText
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Subscription;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Subscription;
/* harmony default export */ __webpack_exports__["default"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Subscription, 'Subscription', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Details/Subscription.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Details/Subscription.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {/* xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported XLSX */
/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */
var XLSX = {};
(function make_xlsx(XLSX){
XLSX.version = '0.12.13';
var current_codepage = 1200, current_ansi = 1252;
/*global cptable:true, window */
if(true) {
	if(typeof cptable === 'undefined') {
		if(typeof global !== 'undefined') global.cptable = __webpack_require__(974);
		else if(typeof window !== 'undefined') window.cptable = __webpack_require__(974);
	}
}

var VALID_ANSI = [ 874, 932, 936, 949, 950 ];
for(var i = 0; i <= 8; ++i) VALID_ANSI.push(1250 + i);
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
var CS2CP = ({
0:    1252, /* ANSI */
1:   65001, /* DEFAULT */
2:   65001, /* SYMBOL */
77:  10000, /* MAC */
128:   932, /* SHIFTJIS */
129:   949, /* HANGUL */
130:  1361, /* JOHAB */
134:   936, /* GB2312 */
136:   950, /* CHINESEBIG5 */
161:  1253, /* GREEK */
162:  1254, /* TURKISH */
163:  1258, /* VIETNAMESE */
177:  1255, /* HEBREW */
178:  1256, /* ARABIC */
186:  1257, /* BALTIC */
204:  1251, /* RUSSIAN */
222:   874, /* THAI */
238:  1250, /* EASTEUROPE */
255:  1252, /* OEM */
69:   6969  /* MISC */
});

var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
function reset_ansi() { set_ansi(1252); }

var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
function reset_cp() { set_cp(1200); reset_ansi(); }

function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }

function utf16leread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
	return o.join("");
}
function utf16beread(data) {
	var o = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
	return o.join("");
}

var debom = function(data) {
	var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
	if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
	if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
	if(c1 == 0xFEFF) return data.slice(1);
	return data;
};

var _getchar = function _gc1(x) { return String.fromCharCode(x); };
if(typeof cptable !== 'undefined') {
	set_cp = function(cp) { current_codepage = cp; };
	debom = function(data) {
		if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.slice(2))); }
		return data;
	};
	_getchar = function _gc2(x) {
		if(current_codepage === 1200) return String.fromCharCode(x);
		return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
	};
}
var DENSE = null;
var DIF_XL = true;
var Base64 = (function make_b64(){
	var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	return {
		encode: function(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			for(var i = 0; i < input.length; ) {
				c1 = input.charCodeAt(i++);
				e1 = (c1 >> 2);

				c2 = input.charCodeAt(i++);
				e2 = ((c1 & 3) << 4) | (c2 >> 4);

				c3 = input.charCodeAt(i++);
				e3 = ((c2 & 15) << 2) | (c3 >> 6);
				e4 = (c3 & 63);
				if (isNaN(c2)) { e3 = e4 = 64; }
				else if (isNaN(c3)) { e4 = 64; }
				o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
			}
			return o;
		},
		decode: function b64_decode(input) {
			var o = "";
			var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
			input = input.replace(/[^\w\+\/\=]/g, "");
			for(var i = 0; i < input.length;) {
				e1 = map.indexOf(input.charAt(i++));
				e2 = map.indexOf(input.charAt(i++));
				c1 = (e1 << 2) | (e2 >> 4);
				o += String.fromCharCode(c1);

				e3 = map.indexOf(input.charAt(i++));
				c2 = ((e2 & 15) << 4) | (e3 >> 2);
				if (e3 !== 64) { o += String.fromCharCode(c2); }

				e4 = map.indexOf(input.charAt(i++));
				c3 = ((e3 & 3) << 6) | e4;
				if (e4 !== 64) { o += String.fromCharCode(c3); }
			}
			return o;
		}
	};
})();
var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && process.versions.node);

if(typeof Buffer !== 'undefined') {
	// $FlowIgnore
	if(!Buffer.from) Buffer.from = function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); };
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
}

function new_raw_buf(len) {
	/* jshint -W056 */
	return has_buf ? Buffer.alloc(len) : new Array(len);
	/* jshint +W056 */
}

var s2a = function s2a(s) {
	if(has_buf) return Buffer.from(s, "binary");
	return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
};

function s2ab(s) {
	if(typeof ArrayBuffer === 'undefined') return s2a(s);
	var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

function a2s(data) {
	if(Array.isArray(data)) return data.map(_chr).join("");
	var o = []; for(var i = 0; i < data.length; ++i) o[i] = _chr(data[i]); return o.join("");
}

function a2u(data) {
	if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
	return new Uint8Array(data);
}

function ab2a(data) {
	if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
	if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
var o = new Array(data.length);
	for(var i = 0; i < data.length; ++i) o[i] = data[i];
	return o;
}

var bconcat = function(bufs) { return [].concat.apply([], bufs); };

var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W041 */
var SSF = ({});
var make_ssf = function make_ssf(SSF){
SSF.version = '0.10.2';
function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
var p2_32 = Math.pow(2,32);
function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
function isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
var days = [
	['Sun', 'Sunday'],
	['Mon', 'Monday'],
	['Tue', 'Tuesday'],
	['Wed', 'Wednesday'],
	['Thu', 'Thursday'],
	['Fri', 'Friday'],
	['Sat', 'Saturday']
];
var months = [
	['J', 'Jan', 'January'],
	['F', 'Feb', 'February'],
	['M', 'Mar', 'March'],
	['A', 'Apr', 'April'],
	['M', 'May', 'May'],
	['J', 'Jun', 'June'],
	['J', 'Jul', 'July'],
	['A', 'Aug', 'August'],
	['S', 'Sep', 'September'],
	['O', 'Oct', 'October'],
	['N', 'Nov', 'November'],
	['D', 'Dec', 'December']
];
function init_table(t) {
	t[0]=  'General';
	t[1]=  '0';
	t[2]=  '0.00';
	t[3]=  '#,##0';
	t[4]=  '#,##0.00';
	t[9]=  '0%';
	t[10]= '0.00%';
	t[11]= '0.00E+00';
	t[12]= '# ?/?';
	t[13]= '# ??/??';
	t[14]= 'm/d/yy';
	t[15]= 'd-mmm-yy';
	t[16]= 'd-mmm';
	t[17]= 'mmm-yy';
	t[18]= 'h:mm AM/PM';
	t[19]= 'h:mm:ss AM/PM';
	t[20]= 'h:mm';
	t[21]= 'h:mm:ss';
	t[22]= 'm/d/yy h:mm';
	t[37]= '#,##0 ;(#,##0)';
	t[38]= '#,##0 ;[Red](#,##0)';
	t[39]= '#,##0.00;(#,##0.00)';
	t[40]= '#,##0.00;[Red](#,##0.00)';
	t[45]= 'mm:ss';
	t[46]= '[h]:mm:ss';
	t[47]= 'mmss.0';
	t[48]= '##0.0E+0';
	t[49]= '@';
	t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
	t[65535]= 'General';
}

var table_fmt = {};
init_table(table_fmt);
function frac(x, D, mixed) {
	var sgn = x < 0 ? -1 : 1;
	var B = x * sgn;
	var P_2 = 0, P_1 = 1, P = 0;
	var Q_2 = 1, Q_1 = 0, Q = 0;
	var A = Math.floor(B);
	while(Q_1 < D) {
		A = Math.floor(B);
		P = A * P_1 + P_2;
		Q = A * Q_1 + Q_2;
		if((B - A) < 0.00000005) break;
		B = 1 / (B - A);
		P_2 = P_1; P_1 = P;
		Q_2 = Q_1; Q_1 = Q;
	}
	if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
	if(!mixed) return [0, sgn * P, Q];
	var q = Math.floor(sgn * P/Q);
	return [q, sgn*P - q*Q, Q];
}
function parse_date_code(v,opts,b2) {
	if(v > 2958465 || v < 0) return null;
	var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
	var dout=[];
	var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
	if(Math.abs(out.u) < 1e-6) out.u = 0;
	if(opts && opts.date1904) date += 1462;
	if(out.u > 0.9999) {
		out.u = 0;
		if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
	}
	if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
	else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
	else {
		if(date > 60) --date;
		/* 1 = Jan 1 1900 in Gregorian */
		var d = new Date(1900, 0, 1);
		d.setDate(d.getDate() + date - 1);
		dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
		dow = d.getDay();
		if(date < 60) dow = (dow + 6) % 7;
		if(b2) dow = fix_hijri(d, dout);
	}
	out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
	out.S = time % 60; time = Math.floor(time / 60);
	out.M = time % 60; time = Math.floor(time / 60);
	out.H = time;
	out.q = dow;
	return out;
}
SSF.parse_date_code = parse_date_code;
var basedate = new Date(1899, 11, 31, 0, 0, 0);
var dnthresh = basedate.getTime();
var base1904 = new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1461*24*60*60*1000;
	else if(v >= base1904) epoch += 24*60*60*1000;
	return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
}
function general_fmt_int(v) { return v.toString(10); }
SSF._general_int = general_fmt_int;
var general_fmt_num = (function make_general_fmt_num() {
var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/;
function gfn2(v) {
	var w = (v<0?12:11);
	var o = gfn5(v.toFixed(12)); if(o.length <= w) return o;
	o = v.toPrecision(10); if(o.length <= w) return o;
	return v.toExponential(5);
}
function gfn3(v) {
	var o = v.toFixed(11).replace(gnr1,".$1");
	if(o.length > (v<0?12:11)) o = v.toPrecision(6);
	return o;
}
function gfn4(o) {
	for(var i = 0; i != o.length; ++i) if((o.charCodeAt(i) | 0x20) === 101) return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");
	return o;
}
function gfn5(o) {
	return o.indexOf(".") > -1 ? o.replace(gnr2,"").replace(gnr1,".$1") : o;
}
return function general_fmt_num(v) {
	var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
	else if(Math.abs(V) <= 9) o = gfn2(v);
	else if(V === 10) o = v.toFixed(10).substr(0,12);
	else o = gfn3(v);
	return gfn5(gfn4(o));
};})();
SSF._general_num = general_fmt_num;
function general_fmt(v, opts) {
	switch(typeof v) {
		case 'string': return v;
		case 'boolean': return v ? "TRUE" : "FALSE";
		case 'number': return (v|0) === v ? general_fmt_int(v) : general_fmt_num(v);
		case 'undefined': return "";
		case 'object':
			if(v == null) return "";
			if(v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
	}
	throw new Error("unsupported value in General format: " + v);
}
SSF._general = general_fmt;
function fix_hijri() { return 0; }
/*jshint -W086 */
function write_date(type, fmt, val, ss0) {
	var o="", ss=0, tt=0, y = val.y, out, outl = 0;
	switch(type) {
		case 98: /* 'b' buddhist year */
			y = val.y + 543;
			/* falls through */
		case 121: /* 'y' year */
		switch(fmt.length) {
			case 1: case 2: out = y % 100; outl = 2; break;
			default: out = y % 10000; outl = 4; break;
		} break;
		case 109: /* 'm' month */
		switch(fmt.length) {
			case 1: case 2: out = val.m; outl = fmt.length; break;
			case 3: return months[val.m-1][1];
			case 5: return months[val.m-1][0];
			default: return months[val.m-1][2];
		} break;
		case 100: /* 'd' day */
		switch(fmt.length) {
			case 1: case 2: out = val.d; outl = fmt.length; break;
			case 3: return days[val.q][0];
			default: return days[val.q][1];
		} break;
		case 104: /* 'h' 12-hour */
		switch(fmt.length) {
			case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 72: /* 'H' 24-hour */
		switch(fmt.length) {
			case 1: case 2: out = val.H; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 77: /* 'M' minutes */
		switch(fmt.length) {
			case 1: case 2: out = val.M; outl = fmt.length; break;
			default: throw 'bad minute format: ' + fmt;
		} break;
		case 115: /* 's' seconds */
			if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
			if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
			else tt = ss0 === 1 ? 10 : 1;
			ss = Math.round((tt)*(val.S + val.u));
			if(ss >= 60*tt) ss = 0;
			if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
			o = pad0(ss,2 + ss0);
			if(fmt === 'ss') return o.substr(0,2);
			return "." + o.substr(2,fmt.length-1);
		case 90: /* 'Z' absolute time */
		switch(fmt) {
			case '[h]': case '[hh]': out = val.D*24+val.H; break;
			case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
			case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
			default: throw 'bad abstime format: ' + fmt;
		} outl = fmt.length === 3 ? 1 : 2; break;
		case 101: /* 'e' era */
			out = y; outl = 1;
	}
	if(outl > 0) return pad0(out, outl); else return "";
}
/*jshint +W086 */
function commaify(s) {
	var w = 3;
	if(s.length <= w) return s;
	var j = (s.length % w), o = s.substr(0,j);
	for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
	return o;
}
var write_num = (function make_write_num(){
var pct1 = /%/g;
function write_num_pct(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_cm(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_exp(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(o.indexOf("e") === -1) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			while(o.substr(0,2) === "0.") {
				o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
				o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
			}
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(r, aval, sign) {
	var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
	var myn = (rr - base*den), myd = den;
	return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
}
function write_num_f2(r, aval, sign) {
	return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
}
var dec1 = /^#*0*\.([0#]+)/;
var closeparen = /\).*[0#]/;
var phone = /\(###\) ###\\?-####/;
function hashq(str) {
	var o = "", cc;
	for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
		case 35: break;
		case 63: o+= " "; break;
		case 48: o+= "0"; break;
		default: o+= String.fromCharCode(cc);
	}
	return o;
}
function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
function dec(val, d) {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 0;
	}
	return Math.round((val-Math.floor(val))*Math.pow(10,d));
}
function carry(val, d) {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 1;
	}
	return 0;
}
function flr(val) { if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0)); return ""+Math.floor(val); }
function write_num_flt(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_flt('n', ffmt, val);
		return '(' + write_num_flt('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = pad0r(val,0); if(o === "0") o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_flt(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = pad0r(val, 0);
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		ri = dec(val, r[1].length);
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
	}
	switch(fmt) {
		case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
		case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
		case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
		default:
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num_cm2(type, fmt, val){
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_pct2(type, fmt, val){
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_exp2(fmt, val){
	var o;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp2(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(!o.match(/[Ee]/)) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
function write_num_int(type, fmt, val) {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_int('n', ffmt, val);
		return '(' + write_num_int('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = (""+val); if(val === 0) o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
		o = o.replace(/\.(\d*)$/,function($$, $1) {
return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_int(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(r[4].length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", r[1], ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + r[2] + "/" + r[3];
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = "" + val;
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
	}
	switch(fmt) {
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
		default:
			if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
	}
	throw new Error("unsupported format |" + fmt + "|");
}
return function write_num(type, fmt, val) {
	return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
};})();
function split_fmt(fmt) {
	var out = [];
	var in_str = false/*, cc*/;
	for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
		case 34: /* '"' */
			in_str = !in_str; break;
		case 95: case 42: case 92: /* '_' '*' '\\' */
			++i; break;
		case 59: /* ';' */
			out[out.length] = fmt.substr(j,i-j);
			j = i+1;
	}
	out[out.length] = fmt.substr(j);
	if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
	return out;
}
SSF._split = split_fmt;
var abstime = /\[[HhMmSs]*\]/;
function fmt_is_date(fmt) {
	var i = 0, /*cc = 0,*/ c = "", o = "";
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': if(isgeneral(fmt, i)) i+= 6; i++; break;
			case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) ++i; ++i; break;
			case '\\': i+=2; break;
			case '_': i+=2; break;
			case '@': ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
			case 'A': case 'a':
				if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
				if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
				++i; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.match(abstime)) return true;
				break;
			case '.':
				/* falls through */
			case '0': case '#':
				while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
				break;
			case '?': while(fmt.charAt(++i) === c){/* empty */} break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
			case '(': case ')': ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
			case ' ': ++i; break;
			default: ++i; break;
		}
	}
	return false;
}
SSF.is_date = fmt_is_date;
function eval_fmt(fmt, v, opts, flen) {
	var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
	var hr='H';
	/* Tokenize */
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': /* General */
				if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
				out[out.length] = {t:'G', v:'General'}; i+=7; break;
			case '"': /* Literal text */
				for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
				out[out.length] = {t:'t', v:o}; ++i; break;
			case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
				out[out.length] = {t:t, v:w}; ++i; break;
			case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
			case '@': /* Text Placeholder */
				out[out.length] = {t:'T', v:v}; ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
					if(dt==null) { dt=parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
					out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
				}
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				c = c.toLowerCase();
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
				if(v < 0) return "";
				if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
				o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
				if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
				if(c === 'h') c = hr;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case 'A': case 'a':
				var q={t:c, v:c};
				if(dt==null) dt=parse_date_code(v, opts);
				if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
				else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
				else { q.t = "t"; ++i; }
				if(dt==null && q.t === 'T') return "";
				out[out.length] = q; lst = c; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
				if(o.match(abstime)) {
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					out[out.length] = {t:'Z', v:o.toLowerCase()};
					lst = o.charAt(1);
				} else if(o.indexOf("$") > -1) {
					o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
					if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
				}
				break;
			/* Numbers */
			case '.':
				if(dt != null) {
					o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
					out[out.length] = {t:'s', v:o}; break;
				}
				/* falls through */
			case '0': case '#':
				o = c; while((++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) || (c=='\\' && fmt.charAt(i+1) == "-" && i < fmt.length - 2 && "0#".indexOf(fmt.charAt(i+2))>-1)) o += c;
				out[out.length] = {t:'n', v:o}; break;
			case '?':
				o = c; while(fmt.charAt(++i) === c) o+=c;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
			case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
				out[out.length] = {t:'D', v:o}; break;
			case ' ': out[out.length] = {t:c, v:c}; ++i; break;
			default:
				if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
				out[out.length] = {t:'t', v:c}; ++i; break;
		}
	}
	var bt = 0, ss0 = 0, ssm;
	for(i=out.length-1, lst='t'; i >= 0; --i) {
		switch(out[i].t) {
			case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
			case 's':
				if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
				if(bt < 3) bt = 3;
			/* falls through */
			case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
			case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
			case 'X': /*if(out[i].v === "B2");*/
				break;
			case 'Z':
				if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
				if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
				if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
		}
	}
	switch(bt) {
		case 0: break;
		case 1:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			if(dt.M >=  60) { dt.M = 0; ++dt.H; }
			break;
		case 2:
if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			break;
	}
	/* replace fields */
	var nstr = "", jj;
	for(i=0; i < out.length; ++i) {
		switch(out[i].t) {
			case 't': case 'T': case ' ': case 'D': break;
			case 'X': out[i].v = ""; out[i].t = ";"; break;
			case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
				out[i].t = 't'; break;
			case 'n': case '(': case '?':
				jj = i+1;
				while(out[jj] != null && (
					(c=out[jj].t) === "?" || c === "D" ||
					((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
					(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
					(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
				)) {
					out[i].v += out[jj].v;
					out[jj] = {v:"", t:";"}; ++jj;
				}
				nstr += out[i].v;
				i = jj-1; break;
			case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
		}
	}
	var vv = "", myv, ostr;
	if(nstr.length > 0) {
		if(nstr.charCodeAt(0) == 40) /* '(' */ {
			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
			ostr = write_num('(', nstr, myv);
		} else {
			myv = (v<0 && flen > 1 ? -v : v);
			ostr = write_num('n', nstr, myv);
			if(myv < 0 && out[0] && out[0].t == 't') {
				ostr = ostr.substr(1);
				out[0].v = "-" + out[0].v;
			}
		}
		jj=ostr.length-1;
		var decpt = out.length;
		for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
		var lasti=out.length;
		if(decpt === out.length && ostr.indexOf("E") === -1) {
			for(i=out.length-1; i>= 0;--i) {
				if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
				if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
				else if(jj < 0) out[i].v = "";
				else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
		}
		else if(decpt !== out.length && ostr.indexOf("E") === -1) {
			jj = ostr.indexOf(".")-1;
			for(i=decpt; i>= 0; --i) {
				if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
				vv = out[i].v.substr(j+1);
				for(; j>=0; --j) {
					if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			jj = ostr.indexOf(".")+1;
			for(i=decpt; i<out.length; ++i) {
				if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
				vv = out[i].v.substr(0,j);
				for(; j<out[i].v.length; ++j) {
					if(jj<ostr.length) vv += ostr.charAt(jj++);
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
		}
	}
	for(i=0; i<out.length; ++i) if(out[i] != null && 'n(?'.indexOf(out[i].t)>-1) {
		myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
		out[i].v = write_num(out[i].t, out[i].v, myv);
		out[i].t = 't';
	}
	var retval = "";
	for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
	return retval;
}
SSF._eval = eval_fmt;
var cfregex = /\[[=<>]/;
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(v, rr) {
	if(rr == null) return false;
	var thresh = parseFloat(rr[2]);
	switch(rr[1]) {
		case "=":  if(v == thresh) return true; break;
		case ">":  if(v >  thresh) return true; break;
		case "<":  if(v <  thresh) return true; break;
		case "<>": if(v != thresh) return true; break;
		case ">=": if(v >= thresh) return true; break;
		case "<=": if(v <= thresh) return true; break;
	}
	return false;
}
function choose_fmt(f, v) {
	var fmt = split_fmt(f);
	var l = fmt.length, lat = fmt[l-1].indexOf("@");
	if(l<4 && lat>-1) --l;
	if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
	if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
	switch(fmt.length) {
		case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
		case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
		case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
		case 4: break;
	}
	var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
	if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
	if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
		var m1 = fmt[0].match(cfregex2);
		var m2 = fmt[1].match(cfregex2);
		return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
	}
	return [l, ff];
}
function format(fmt,v,o) {
	if(o == null) o = {};
	var sfmt = "";
	switch(typeof fmt) {
		case "string":
			if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
			else sfmt = fmt;
			break;
		case "number":
			if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
			else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
			break;
	}
	if(isgeneral(sfmt,0)) return general_fmt(v, o);
	if(v instanceof Date) v = datenum_local(v, o.date1904);
	var f = choose_fmt(sfmt, v);
	if(isgeneral(f[1])) return general_fmt(v, o);
	if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
	else if(v === "" || v == null) return "";
	return eval_fmt(f[1], v, o, f[0]);
}
function load_entry(fmt, idx) {
	if(typeof idx != 'number') {
		idx = +idx || -1;
for(var i = 0; i < 0x0188; ++i) {
if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
			if(table_fmt[i] == fmt) { idx = i; break; }
		}
if(idx < 0) idx = 0x187;
	}
table_fmt[idx] = fmt;
	return idx;
}
SSF.load = load_entry;
SSF._table = table_fmt;
SSF.get_table = function get_table() { return table_fmt; };
SSF.load_table = function load_table(tbl) {
	for(var i=0; i!=0x0188; ++i)
		if(tbl[i] !== undefined) load_entry(tbl[i], i);
};
SSF.init_table = init_table;
SSF.format = format;
};
make_ssf(SSF);
/* map from xlml named formats to SSF TODO: localize */
var XLMLFormatMap/*{[string]:string}*/ = ({
	"General Number": "General",
	"General Date": SSF._table[22],
	"Long Date": "dddd, mmmm dd, yyyy",
	"Medium Date": SSF._table[15],
	"Short Date": SSF._table[14],
	"Long Time": SSF._table[19],
	"Medium Time": SSF._table[18],
	"Short Time": SSF._table[20],
	"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"Fixed": SSF._table[2],
	"Standard": SSF._table[4],
	"Percent": SSF._table[10],
	"Scientific": SSF._table[11],
	"Yes/No": '"Yes";"Yes";"No";@',
	"True/False": '"True";"True";"False";@',
	"On/Off": '"Yes";"Yes";"No";@'
});

var SSFImplicit/*{[number]:string}*/ = ({
	"5": '"$"#,##0_);\\("$"#,##0\\)',
	"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"23": 'General', "24": 'General', "25": 'General', "26": 'General',
	"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
	"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
	"36": 'm/d/yy',
	"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
	"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
	"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
	"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
	"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
	"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
	"59": '0',
	"60": '0.00',
	"61": '#,##0',
	"62": '#,##0.00',
	"63": '"$"#,##0_);\\("$"#,##0\\)',
	"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"67": '0%',
	"68": '0.00%',
	"69": '# ?/?',
	"70": '# ??/??',
	"71": 'm/d/yy',
	"72": 'm/d/yy',
	"73": 'd-mmm-yy',
	"74": 'd-mmm',
	"75": 'mmm-yy',
	"76": 'h:mm',
	"77": 'h:mm:ss',
	"78": 'm/d/yy h:mm',
	"79": 'mm:ss',
	"80": '[h]:mm:ss',
	"81": 'mmss.0'
});

/* dateNF parse TODO: move to SSF */
var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(dateNF) {
	var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
	fmt = fmt.replace(dateNFregex, "(\\d+)");
	return new RegExp("^" + fmt + "$");
}
function dateNF_fix(str, dateNF, match) {
	var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
	(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
		var v = parseInt(match[i+1], 10);
		switch(n.toLowerCase().charAt(0)) {
			case 'y': Y = v; break; case 'd': d = v; break;
			case 'h': H = v; break; case 's': S = v; break;
			case 'm': if(H >= 0) M = v; else m = v; break;
		}
	});
	if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
	var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
	if(datestr.length == 7) datestr = "0" + datestr;
	if(datestr.length == 8) datestr = "20" + datestr;
	var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
	if(H == -1 && M == -1 && S == -1) return datestr;
	if(Y == -1 && m == -1 && d == -1) return timestr;
	return datestr + "T" + timestr;
}

var DO_NOT_EXPORT_CFB = true;
/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*jshint eqnull:true */
/*exported CFB */
/*global module, require:false, process:false, Buffer:false, Uint8Array:false */

/* [MS-CFB] v20171201 */
var CFB = (function _CFB(){
var exports = {};
exports.version = '1.0.7';
/* [MS-CFB] 2.6.4 */
function namecmp(l, r) {
	var L = l.split("/"), R = r.split("/");
	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
		if((c = L[i].length - R[i].length)) return c;
		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
	}
	return L.length - R.length;
}
function dirname(p) {
	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(0, c+1);
}

function filename(p) {
	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(c+1);
}
var fs;
function get_fs() { return fs || (fs = __webpack_require__(975)); }
function parse(file, options) {
if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
var mver = 3;
var ssz = 512;
var nmfs = 0; // number of mini FAT sectors
var difat_sec_cnt = 0;
var dir_start = 0;
var minifat_start = 0;
var difat_start = 0;

var fat_addrs = []; // locations of FAT sectors

/* [MS-CFB] 2.2 Compound File Header */
var blob = file.slice(0,512);
prep_blob(blob, 0);

/* major version */
var mv = check_get_mver(blob);
mver = mv[0];
switch(mver) {
	case 3: ssz = 512; break; case 4: ssz = 4096; break;
	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
}

/* reprocess header */
if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
/* Save header for final object */
var header = file.slice(0,ssz);

check_shifts(blob, mver);

// Number of Directory Sectors
var dir_cnt = blob.read_shift(4, 'i');
if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

// Number of FAT Sectors
blob.l += 4;

// First Directory Sector Location
dir_start = blob.read_shift(4, 'i');

// Transaction Signature
blob.l += 4;

// Mini Stream Cutoff Size
blob.chk('00100000', 'Mini Stream Cutoff Size: ');

// First Mini FAT Sector Location
minifat_start = blob.read_shift(4, 'i');

// Number of Mini FAT Sectors
nmfs = blob.read_shift(4, 'i');

// First DIFAT sector location
difat_start = blob.read_shift(4, 'i');

// Number of DIFAT Sectors
difat_sec_cnt = blob.read_shift(4, 'i');

// Grab FAT Sector Locations
for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
	q = blob.read_shift(4, 'i');
	if(q<0) break;
	fat_addrs[j] = q;
}

/** Break the file up into sectors */
var sectors = sectorify(file, ssz);

sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

/** Chains */
var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);

sector_list[dir_start].name = "!Directory";
if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
sector_list[fat_addrs[0]].name = "!FAT";
sector_list.fat_addrs = fat_addrs;
sector_list.ssz = ssz;

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
var files = {}, Paths = [], FileIndex = [], FullPaths = [];
read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

build_full_paths(FileIndex, FullPaths, Paths);
Paths.shift();

var o = {
	FileIndex: FileIndex,
	FullPaths: FullPaths
};

// $FlowIgnore
if(options && options.raw) o.raw = {header: header, sectors: sectors};
return o;
} // parse

/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
function check_get_mver(blob) {
	// header signature 8
	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

	// clsid 16
	blob.chk(HEADER_CLSID, 'CLSID: ');

	// minor version 2
	var mver = blob.read_shift(2, 'u');

	return [blob.read_shift(2,'u'), mver];
}
function check_shifts(blob, mver) {
	var shift = 0x09;

	// Byte Order
	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
	blob.l += 2;

	// Sector Shift
	switch((shift = blob.read_shift(2))) {
		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
	}

	// Mini Sector Shift
	blob.chk('0600', 'Mini Sector Shift: ');

	// Reserved
	blob.chk('000000000000', 'Reserved: ');
}

/** Break the file up into sectors */
function sectorify(file, ssz) {
	var nsectors = Math.ceil(file.length/ssz)-1;
	var sectors = [];
	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
	sectors[nsectors-1] = file.slice(nsectors*ssz);
	return sectors;
}

/* [MS-CFB] 2.6.4 Red-Black Tree */
function build_full_paths(FI, FP, Paths) {
	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
	var dad = [], q = [];

	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

	for(; j < q.length; ++j) {
		i = q[j];
		L = FI[i].L; R = FI[i].R; C = FI[i].C;
		if(dad[i] === i) {
			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
		}
		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
		if(L !== -1) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
		if(R !== -1) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
	}
	for(i=1; i < pl; ++i) if(dad[i] === i) {
		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
	}

	for(i=1; i < pl; ++i) {
		if(FI[i].type === 0 /* unknown */) continue;
		j = dad[i];
		if(j === 0) FP[i] = FP[0] + "/" + FP[i];
		else while(j !== 0 && j !== dad[j]) {
			FP[i] = FP[j] + "/" + FP[i];
			j = dad[j];
		}
		dad[i] = 0;
	}

	FP[0] += "/";
	for(i=1; i < pl; ++i) {
		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
	}
}

function get_mfat_entry(entry, payload, mini) {
	var start = entry.start, size = entry.size;
	//return (payload.slice(start*MSSZ, start*MSSZ + size));
	var o = [];
	var idx = start;
	while(mini && size > 0 && idx >= 0) {
		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
		size -= MSSZ;
		idx = __readInt32LE(mini, idx * 4);
	}
	if(o.length === 0) return (new_buf(0));
	return (bconcat(o).slice(0, entry.size));
}

/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */
function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
	var q = ENDOFCHAIN;
	if(idx === ENDOFCHAIN) {
		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
	} else if(idx !== -1 /*FREESECT*/) {
		var sector = sectors[idx], m = (ssz>>>2)-1;
		if(!sector) return;
		for(var i = 0; i < m; ++i) {
			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
			fat_addrs.push(q);
		}
		sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
	}
}

/** Follow the linked list of sectors for a given starting point */
function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
	var buf = [], buf_chain = [];
	if(!chkd) chkd = [];
	var modulus = ssz - 1, j = 0, jj = 0;
	for(j=start; j>=0;) {
		chkd[j] = true;
		buf[buf.length] = j;
		buf_chain.push(sectors[j]);
		var addr = fat_addrs[Math.floor(j*4/ssz)];
		jj = ((j*4) & modulus);
		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
		if(!sectors[addr]) break;
		j = __readInt32LE(sectors[addr], jj);
	}
	return {nodes: buf, data:__toBuffer([buf_chain])};
}

/** Chase down the sector linked lists */
function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
	var sl = sectors.length, sector_list = ([]);
	var chkd = [], buf = [], buf_chain = [];
	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
	for(i=0; i < sl; ++i) {
		buf = ([]);
		k = (i + dir_start); if(k >= sl) k-=sl;
		if(chkd[k]) continue;
		buf_chain = [];
		for(j=k; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
	}
	return sector_list;
}

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
	var minifat_store = 0, pl = (Paths.length?2:0);
	var sector = sector_list[dir_start].data;
	var i = 0, namelen = 0, name;
	for(; i < sector.length; i+= 128) {
		var blob = sector.slice(i, i+128);
		prep_blob(blob, 64);
		namelen = blob.read_shift(2);
		name = __utf16le(blob,0,namelen-pl);
		Paths.push(name);
		var o = ({
			name:  name,
			type:  blob.read_shift(1),
			color: blob.read_shift(1),
			L:     blob.read_shift(4, 'i'),
			R:     blob.read_shift(4, 'i'),
			C:     blob.read_shift(4, 'i'),
			clsid: blob.read_shift(16),
			state: blob.read_shift(4, 'i'),
			start: 0,
			size: 0
		});
		var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
		var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
		o.start = blob.read_shift(4, 'i');
		o.size = blob.read_shift(4, 'i');
		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
		if(o.type === 5) { /* root */
			minifat_store = o.start;
			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
			/*minifat_size = o.size;*/
		} else if(o.size >= 4096 /* MSCSZ */) {
			o.storage = 'fat';
			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
			sector_list[o.start].name = o.name;
			o.content = (sector_list[o.start].data.slice(0,o.size));
		} else {
			o.storage = 'minifat';
			if(o.size < 0) o.size = 0;
			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
			}
		}
		if(o.content) prep_blob(o.content, 0);
		files[name] = o;
		FileIndex.push(o);
	}
}

function read_date(blob, offset) {
	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
}

function read_file(filename, options) {
	get_fs();
	return parse(fs.readFileSync(filename), options);
}

function read(blob, options) {
	switch(options && options.type || "base64") {
		case "file": return read_file(blob, options);
		case "base64": return parse(s2a(Base64.decode(blob)), options);
		case "binary": return parse(s2a(blob), options);
	}
	return parse(blob, options);
}

function init_cfb(cfb, opts) {
	var o = opts || {}, root = o.root || "Root Entry";
	if(!cfb.FullPaths) cfb.FullPaths = [];
	if(!cfb.FileIndex) cfb.FileIndex = [];
	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
	if(cfb.FullPaths.length === 0) {
		cfb.FullPaths[0] = root + "/";
		cfb.FileIndex[0] = ({ name: root, type: 5 });
	}
	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
	seed_cfb(cfb);
}
function seed_cfb(cfb) {
	var nm = "\u0001Sh33tJ5";
	if(CFB.find(cfb, "/" + nm)) return;
	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
	rebuild_cfb(cfb);
}
function rebuild_cfb(cfb, f) {
	init_cfb(cfb);
	var gc = false, s = false;
	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
		var _file = cfb.FileIndex[i];
		switch(_file.type) {
			case 0:
				if(s) gc = true;
				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
				break;
			case 1: case 2: case 5:
				s = true;
				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
				break;
			default: gc = true; break;
		}
	}
	if(!gc && !f) return;

	var now = new Date(1987, 1, 19), j = 0;
	var data = [];
	for(i = 0; i < cfb.FullPaths.length; ++i) {
		if(cfb.FileIndex[i].type === 0) continue;
		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
	}
	for(i = 0; i < data.length; ++i) {
		var dad = dirname(data[i][0]);
		s = false;
		for(j = 0; j < data.length; ++j) if(data[j][0] === dad) s = true;
		if(!s) data.push([dad, ({
			name: filename(dad).replace("/",""),
			type: 1,
			clsid: HEADER_CLSID,
			ct: now, mt: now,
			content: null
		})]);
	}

	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
	cfb.FullPaths = []; cfb.FileIndex = [];
	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
	for(i = 0; i < data.length; ++i) {
		var elt = cfb.FileIndex[i];
		var nm = cfb.FullPaths[i];

		elt.name =  filename(nm).replace("/","");
		elt.L = elt.R = elt.C = -(elt.color = 1);
		elt.size = elt.content ? elt.content.length : 0;
		elt.start = 0;
		elt.clsid = (elt.clsid || HEADER_CLSID);
		if(i === 0) {
			elt.C = data.length > 1 ? 1 : -1;
			elt.size = 0;
			elt.type = 5;
		} else if(nm.slice(-1) == "/") {
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
			elt.C = j >= data.length ? -1 : j;
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
			elt.R = j >= data.length ? -1 : j;
			elt.type = 1;
		} else {
			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
			elt.type = 2;
		}
	}

}

function _write(cfb, options) {
	var _opts = options || {};
	rebuild_cfb(cfb);
	var L = (function(cfb){
		var mini_size = 0, fat_size = 0;
		for(var i = 0; i < cfb.FileIndex.length; ++i) {
			var file = cfb.FileIndex[i];
			if(!file.content) continue;
var flen = file.content.length;
			if(flen > 0){
				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
				else fat_size += (flen + 0x01FF) >> 9;
			}
		}
		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
		var mini_cnt = (mini_size + 7) >> 3;
		var mfat_cnt = (mini_size + 0x7F) >> 7;
		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
		var fat_cnt = (fat_base + 0x7F) >> 7;
		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
		cfb.FileIndex[0].size = mini_size << 6;
		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
		return L;
	})(cfb);
	var o = new_buf(L[7] << 9);
	var i = 0, T = 0;
	{
		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
		o.write_shift(2, 0x003E);
		o.write_shift(2, 0x0003);
		o.write_shift(2, 0xFFFE);
		o.write_shift(2, 0x0009);
		o.write_shift(2, 0x0006);
		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, L[2]);
		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
		o.write_shift(4, 0);
		o.write_shift(4, 1<<12);
		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
		o.write_shift(4, L[3]);
		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
		o.write_shift(4, L[1]);
		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
	}
	if(L[1]) {
		for(T = 0; T < L[1]; ++T) {
			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
		}
	}
	var chainit = function(w) {
		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
	};
	T = i = 0;
	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
	chainit(L[3]);
	chainit(L[4]);
	var j = 0, flen = 0;
	var file = cfb.FileIndex[0];
	for(; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(flen < 0x1000) continue;
		file.start = T;
		chainit((flen + 0x01FF) >> 9);
	}
	chainit((L[6] + 7) >> 3);
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	T = i = 0;
	for(j = 0; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
flen = file.content.length;
		if(!flen || flen >= 0x1000) continue;
		file.start = T;
		chainit((flen + 0x3F) >> 6);
	}
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	for(i = 0; i < L[4]<<2; ++i) {
		var nm = cfb.FullPaths[i];
		if(!nm || nm.length === 0) {
			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
			continue;
		}
		file = cfb.FileIndex[i];
		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
		var _nm = (i === 0 && _opts.root) || file.name;
		flen = 2*(_nm.length+1);
		o.write_shift(64, _nm, "utf16le");
		o.write_shift(2, flen);
		o.write_shift(1, file.type);
		o.write_shift(1, file.color);
		o.write_shift(-4, file.L);
		o.write_shift(-4, file.R);
		o.write_shift(-4, file.C);
		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
		else o.write_shift(16, file.clsid, "hex");
		o.write_shift(4, file.state || 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, file.start);
		o.write_shift(4, file.size); o.write_shift(4, 0);
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size >= 0x1000) {
			o.l = (file.start+1) << 9;
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x1FF; ++j) o.write_shift(1, 0);
		}
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
if(file.size > 0 && file.size < 0x1000) {
			for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
			for(; j & 0x3F; ++j) o.write_shift(1, 0);
		}
	}
	while(o.l < o.length) o.write_shift(1, 0);
	return o;
}
/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
function find(cfb, path) {
	var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
	var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
	var k = false;
	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
	else k = path.indexOf("/") !== -1;
	var UCPath = path.toUpperCase();
	var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
	if(w !== -1) return cfb.FileIndex[w];

	var m = !UCPath.match(chr1);
	UCPath = UCPath.replace(chr0,'');
	if(m) UCPath = UCPath.replace(chr1,'!');
	for(w = 0; w < UCFullPaths.length; ++w) {
		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
	}
	return null;
}
/** CFB Constants */
var MSSZ = 64; /* Mini Sector Size = 1<<6 */
//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */
var ENDOFCHAIN = -2;
/* 2.2 Compound File Header */
var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
var HEADER_CLSID = '00000000000000000000000000000000';
var consts = {
	/* 2.1 Compund File Sector Numbers and Types */
	MAXREGSECT: -6,
	DIFSECT: -4,
	FATSECT: -3,
	ENDOFCHAIN: ENDOFCHAIN,
	FREESECT: -1,
	/* 2.2 Compound File Header */
	HEADER_SIGNATURE: HEADER_SIGNATURE,
	HEADER_MINOR_VERSION: '3e00',
	MAXREGSID: -6,
	NOSTREAM: -1,
	HEADER_CLSID: HEADER_CLSID,
	/* 2.6.1 Compound File Directory Entry */
	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
};

function write_file(cfb, filename, options) {
	get_fs();
	var o = _write(cfb, options);
fs.writeFileSync(filename, o);
}

function a2s(o) {
	var out = new Array(o.length);
	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
	return out.join("");
}

function write(cfb, options) {
	var o = _write(cfb, options);
	switch(options && options.type) {
		case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
		case "binary": return a2s(o);
		case "base64": return Base64.encode(a2s(o));
	}
	return o;
}
function cfb_new(opts) {
	var o = ({});
	init_cfb(o, opts);
	return o;
}

function cfb_add(cfb, name, content, opts) {
	var unsafe = opts && opts.unsafe;
	if(!unsafe) init_cfb(cfb);
	var file = !unsafe && CFB.find(cfb, name);
	if(!file) {
		var fpath = cfb.FullPaths[0];
		if(name.slice(0, fpath.length) == fpath) fpath = name;
		else {
			if(fpath.slice(-1) != "/") fpath += "/";
			fpath = (fpath + name).replace("//","/");
		}
		file = ({name: filename(name), type: 2});
		cfb.FileIndex.push(file);
		cfb.FullPaths.push(fpath);
		if(!unsafe) CFB.utils.cfb_gc(cfb);
	}
file.content = (content);
	file.size = content ? content.length : 0;
	if(opts) {
		if(opts.CLSID) file.clsid = opts.CLSID;
	}
	return file;
}

function cfb_del(cfb, name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex.splice(j, 1);
		cfb.FullPaths.splice(j, 1);
		return true;
	}
	return false;
}

function cfb_mov(cfb, old_name, new_name) {
	init_cfb(cfb);
	var file = CFB.find(cfb, old_name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex[j].name = filename(new_name);
		cfb.FullPaths[j] = new_name;
		return true;
	}
	return false;
}

function cfb_gc(cfb) { rebuild_cfb(cfb, true); }

exports.find = find;
exports.read = read;
exports.parse = parse;
exports.write = write;
exports.writeFile = write_file;
exports.utils = {
	cfb_new: cfb_new,
	cfb_add: cfb_add,
	cfb_del: cfb_del,
	cfb_mov: cfb_mov,
	cfb_gc: cfb_gc,
	ReadShift: ReadShift,
	CheckField: CheckField,
	prep_blob: prep_blob,
	bconcat: bconcat,
	consts: consts
};

return exports;
})();

if("function" !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
var _fs;
if(true) try { _fs = __webpack_require__(975); } catch(e) {}

/* normalize data for blob ctor */
function blobify(data) {
	if(typeof data === "string") return s2ab(data);
	if(Array.isArray(data)) return a2u(data);
	return data;
}
/* write or download file */
function write_dl(fname, payload, enc) {
	/*global IE_SaveFile, Blob, navigator, saveAs, URL, document, File, chrome */
	if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
	var data = (enc == "utf8") ? utf8write(payload) : payload;
if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
	if(typeof Blob !== 'undefined') {
		var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
		if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
			var url = URL.createObjectURL(blob);
if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
			}
			var a = document.createElement("a");
			if(a.download != null) {
a.download = fname; a.href = url; document.body.appendChild(a); a.click();
document.body.removeChild(a);
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return url;
			}
		}
	}
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var out = File(fname); out.open("w"); out.encoding = "binary";
		if(Array.isArray(payload)) payload = a2s(payload);
		out.write(payload); out.close(); return payload;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("cannot save file " + fname);
}

/* read binary data from file */
function read_binary(path) {
	if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var infile = File(path); infile.open("r"); infile.encoding = "binary";
		var data = infile.read(); infile.close();
		return data;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("Cannot access file " + path);
}
function keys(o) {
	var ks = Object.keys(o), o2 = [];
	for(var i = 0; i < ks.length; ++i) if(o.hasOwnProperty(ks[i])) o2.push(ks[i]);
	return o2;
}

function evert_key(obj, key) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
	return o;
}

function evert(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
	return o;
}

function evert_num(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
	return o;
}

function evert_arr(obj) {
	var o = ([]), K = keys(obj);
	for(var i = 0; i !== K.length; ++i) {
		if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
		o[obj[K[i]]].push(K[i]);
	}
	return o;
}

var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
var dnthresh = basedate.getTime() + (new Date().getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
function datenum(v, date1904) {
	var epoch = v.getTime();
	if(date1904) epoch -= 1462*24*60*60*1000;
	return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
}
function numdate(v) {
	var out = new Date();
	out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
	return out;
}

/* ISO 8601 Duration */
function parse_isodur(s) {
	var sec = 0, mt = 0, time = false;
	var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
	if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
	for(var i = 1; i != m.length; ++i) {
		if(!m[i]) continue;
		mt = 1;
		if(i > 3) time = true;
		switch(m[i].slice(m[i].length-1)) {
			case 'Y':
				throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
			case 'D': mt *= 24;
				/* falls through */
			case 'H': mt *= 60;
				/* falls through */
			case 'M':
				if(!time) throw new Error("Unsupported ISO Duration Field: M");
				else mt *= 60;
				/* falls through */
			case 'S': break;
		}
		sec += mt * parseInt(m[i], 10);
	}
	return sec;
}

var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
if(isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
var good_pd = good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */
function parseDate(str, fixdate) {
	var d = new Date(str);
	if(good_pd) {
if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
		else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
		return d;
	}
	if(str instanceof Date) return str;
	if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
		var s = d.getFullYear();
		if(str.indexOf("" + s) > -1) return d;
		d.setFullYear(d.getFullYear() + 100); return d;
	}
	var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
	var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
	if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
	return out;
}

function cc2str(arr) {
	var o = "";
	for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
	return o;
}

function dup(o) {
	if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
	if(typeof o != 'object' || o == null) return o;
	if(o instanceof Date) return new Date(o.getTime());
	var out = {};
	for(var k in o) if(o.hasOwnProperty(k)) out[k] = dup(o[k]);
	return out;
}

function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }

/* TODO: stress test */
function fuzzynum(s) {
	var v = Number(s);
	if(!isNaN(v)) return v;
	var wt = 1;
	var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
	if(!isNaN(v = Number(ss))) return v / wt;
	ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
	if(!isNaN(v = Number(ss))) return v / wt;
	return v;
}
function fuzzydate(s) {
	var o = new Date(s), n = new Date(NaN);
	var y = o.getYear(), m = o.getMonth(), d = o.getDate();
	if(isNaN(d)) return n;
	if(y < 0 || y > 8099) return n;
	if((m > 0 || d > 1) && y != 101) return o;
	if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) return o;
	if(s.match(/[^-0-9:,\/\\]/)) return n;
	return o;
}

var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
function split_regex(str, re, def) {
	if(safe_split_regex || typeof re == "string") return str.split(re);
	var p = str.split(re), o = [p[0]];
	for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
	return o;
}
function getdatastr(data) {
	if(!data) return null;
	if(data.data) return debom(data.data);
	if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
	if(data.asBinary) return debom(data.asBinary());
	if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
	return null;
}

function getdatabin(data) {
	if(!data) return null;
	if(data.data) return char_codes(data.data);
	if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
	if(data._data && data._data.getContent) {
		var o = data._data.getContent();
		if(typeof o == "string") return char_codes(o);
		return Array.prototype.slice.call(o);
	}
	return null;
}

function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }

/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
/* OASIS does not comment on filename case sensitivity */
function safegetzipfile(zip, file) {
	var k = keys(zip.files);
	var f = file.toLowerCase(), g = f.replace(/\//g,'\\');
	for(var i=0; i<k.length; ++i) {
		var n = k[i].toLowerCase();
		if(f == n || g == n) return zip.files[k[i]];
	}
	return null;
}

function getzipfile(zip, file) {
	var o = safegetzipfile(zip, file);
	if(o == null) throw new Error("Cannot find file " + file + " in zip");
	return o;
}

function getzipdata(zip, file, safe) {
	if(!safe) return getdata(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipdata(zip, file); } catch(e) { return null; }
}

function getzipstr(zip, file, safe) {
	if(!safe) return getdatastr(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipstr(zip, file); } catch(e) { return null; }
}

function zipentries(zip) {
	var k = keys(zip.files), o = [];
	for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i]);
	return o.sort();
}

var jszip;
/*global JSZipSync:true */
if(typeof JSZipSync !== 'undefined') jszip = JSZipSync;
if(true) {
	if(typeof module !== 'undefined' && module.exports) {
		if(typeof jszip === 'undefined') jszip = __webpack_require__(3399);
	}
}

function resolve_path(path, base) {
	var result = base.split('/');
	if(base.slice(-1) != "/") result.pop(); // folder path
	var target = path.split('/');
	while (target.length !== 0) {
		var step = target.shift();
		if (step === '..') result.pop();
		else if (step !== '.') result.push(step);
	}
	return result.join('/');
}
var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var tagregex=/<[\/\?]?[a-zA-Z0-9:]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s?[\/\?]?>/g;
if(!(XML_HEADER.match(tagregex))) tagregex = /<[^>]*>/g;
var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(tag, skip_root) {
	var z = ({});
	var eq = 0, c = 0;
	for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
	if(!skip_root) z[0] = tag.slice(0, eq);
	if(eq === tag.length) return z;
	var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
	if(m) for(i = 0; i != m.length; ++i) {
		cc = m[i];
		for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
		q = cc.slice(0,c).trim();
		while(cc.charCodeAt(c+1) == 32) ++c;
		quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
		v = cc.slice(c+1+quot, cc.length-quot);
		for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
		if(j===q.length) {
			if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
			z[q] = v;
		}
		else {
			var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
			if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
			z[k] = v;
		}
	}
	return z;
}
function strip_ns(x) { return x.replace(nsregex2, "<$1"); }

var encodings = {
	'&quot;': '"',
	'&apos;': "'",
	'&gt;': '>',
	'&lt;': '<',
	'&amp;': '&'
};
var rencoding = evert(encodings);
//var rencstr = "&<>'\"".split("");

// TODO: CP remap (need to read file version to determine OS)
var unescapexml = (function() {
	/* 22.4.2.4 bstr (Basic String) */
	var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g, coderegex = /_x([\da-fA-F]{4})_/g;
	return function unescapexml(text) {
		var s = text + '', i = s.indexOf("<![CDATA[");
		if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
		var j = s.indexOf("]]>");
		return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
	};
})();

var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function escapexml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
}
function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }

var htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
}

function escapexlml(text){
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
}

/* TODO: handle codepages */
var xlml_fixstr = (function() {
	var entregex = /&#(\d+);/g;
	function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
	return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
})();
var xlml_unfixstr = (function() {
	return function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); };
})();

function parsexmlbool(value) {
	switch(value) {
		case 1: case true: case '1': case 'true': case 'TRUE': return true;
		/* case '0': case 'false': case 'FALSE':*/
		default: return false;
	}
}

var utf8read = function utf8reada(orig) {
	var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
	while (i < orig.length) {
		c = orig.charCodeAt(i++);
		if (c < 128) { out += String.fromCharCode(c); continue; }
		d = orig.charCodeAt(i++);
		if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
		e = orig.charCodeAt(i++);
		if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
		f = orig.charCodeAt(i++);
		w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
		out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
		out += String.fromCharCode(0xDC00 + (w&1023));
	}
	return out;
};

var utf8write = function(orig) {
	var out = [], i = 0, c = 0, d = 0;
	while(i < orig.length) {
		c = orig.charCodeAt(i++);
		switch(true) {
			case c < 128: out.push(String.fromCharCode(c)); break;
			case c < 2048:
				out.push(String.fromCharCode(192 + (c >> 6)));
				out.push(String.fromCharCode(128 + (c & 63)));
				break;
			case c >= 55296 && c < 57344:
				c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
				out.push(String.fromCharCode(240 + ((d >>18) & 7)));
				out.push(String.fromCharCode(144 + ((d >>12) & 63)));
				out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
				out.push(String.fromCharCode(128 + (d & 63)));
				break;
			default:
				out.push(String.fromCharCode(224 + (c >> 12)));
				out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
				out.push(String.fromCharCode(128 + (c & 63)));
		}
	}
	return out.join("");
};

if(has_buf) {
	var utf8readb = function utf8readb(data) {
		var out = Buffer.alloc(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	};
	var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
	var utf8readc = function utf8readc(data) { return Buffer.from(data, 'binary').toString('utf8'); };
	if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;

	utf8write = function(data) { return Buffer.from(data, 'utf8').toString("binary"); };
}

// matches <foo>...</foo> extracts content
var matchtag = (function() {
	var mtcache = ({});
	return function matchtag(f,g) {
		var t = f+"|"+(g||"");
		if(mtcache[t]) return mtcache[t];
		return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
	};
})();

var htmldecode = (function() {
	var entities = [
		['nbsp', ' '], ['middot', '·'],
		['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
	].map(function(x) { return [new RegExp('&' + x[0] + ';', "g"), x[1]]; });
	return function htmldecode(str) {
		var o = str.trim().replace(/\s+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g,"\n").replace(/<[^>]*>/g,"");
		for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
		return o;
	};
})();

var vtregex = (function(){ var vt_cache = {};
	return function vt_regex(bt) {
		if(vt_cache[bt] !== undefined) return vt_cache[bt];
		return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
};})();
var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(data, opts) {
	var h = parsexmltag(data);

	var matches = data.match(vtregex(h.baseType))||[];
	var res = [];
	if(matches.length != h.size) {
		if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
		return res;
	}
	matches.forEach(function(x) {
		var v = x.replace(vtvregex,"").match(vtmregex);
		if(v) res.push({v:utf8read(v[2]), t:v[1]});
	});
	return res;
}

var wtregex = /(^\s|\s$|\n)/;
function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }

function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}

function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }

function write_vt(s) {
	switch(typeof s) {
		case 'string': return writextag('vt:lpwstr', s);
		case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', String(s));
		case 'boolean': return writextag('vt:bool',s?'true':'false');
	}
	if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
	throw new Error("Unable to serialize " + s);
}

var XMLNS = ({
	'dc': 'http://purl.org/dc/elements/1.1/',
	'dcterms': 'http://purl.org/dc/terms/',
	'dcmitype': 'http://purl.org/dc/dcmitype/',
	'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
	'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
	'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
	'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
	'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
	'xsd': 'http://www.w3.org/2001/XMLSchema'
});

XMLNS.main = [
	'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
	'http://purl.oclc.org/ooxml/spreadsheetml/main',
	'http://schemas.microsoft.com/office/excel/2006/main',
	'http://schemas.microsoft.com/office/excel/2006/2'
];

var XLMLNS = ({
	'o':    'urn:schemas-microsoft-com:office:office',
	'x':    'urn:schemas-microsoft-com:office:excel',
	'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
	'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
	'mv':   'http://macVmlSchemaUri',
	'v':    'urn:schemas-microsoft-com:vml',
	'html': 'http://www.w3.org/TR/REC-html40'
});
function read_double_le(b, idx) {
	var s = 1 - 2 * (b[idx + 7] >>> 7);
	var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
	var m = (b[idx+6]&0x0f);
	for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
	if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
	if(e == 0) e = -1022;
	else { e -= 1023; m += Math.pow(2,52); }
	return s * Math.pow(2, e - 52) * m;
}

function write_double_le(b, v, idx) {
	var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
	var av = bs ? (-v) : v;
	if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
	else if(av == 0) e = m = 0;
	else {
		e = Math.floor(Math.log(av) / Math.LN2);
		m = av * Math.pow(2, 52 - e);
		if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
		else { m -= Math.pow(2,52); e+=1023; }
	}
	for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
	b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
	b[idx + 7] = (e >> 4) | bs;
}

var __toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
var ___toBuffer = __toBuffer;
var __utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
var ___utf16le = __utf16le;
var __hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
var ___hexlify = __hexlify;
var __utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
var ___utf8 = __utf8;
var __lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpstr = __lpstr;
var __cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___cpstr = __cpstr;
var __lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpwstr = __lpwstr;
var __lpp4, ___lpp4;
__lpp4 = ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
var __8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
var ___8lpp4 = __8lpp4;
var __double, ___double;
__double = ___double = function(b, idx) { return read_double_le(b, idx);};
var is_buf = function is_buf_a(a) { return Array.isArray(a); };

if(has_buf) {
	__utf16le = function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; };
	__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
	__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
	__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
	__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
	__utf8 = function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); };
	__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);};
	bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs); };
	__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
	is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a); };
}

/* from js-xls */
if(typeof cptable !== 'undefined') {
	__utf16le = function(b,s,e) { return cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
	__utf8 = function(b,s,e) { return cptable.utils.decode(65001, b.slice(s,e)); };
	__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
	__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
	__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
	__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
	__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
}

var __readUInt8 = function(b, idx) { return b[idx]; };
var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };

function ReadShift(size, t) {
	var o="", oI, oR, oo=[], w, vv, i, loc;
	switch(t) {
		case 'dbcs':
			loc = this.l;
			if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
			else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
			size *= 2;
			break;

		case 'utf8': o = __utf8(this, this.l, this.l + size); break;
		case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;

		case 'wstr':
			if(typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
			else return ReadShift.call(this, size, 'dbcs');
			size = 2 * size; break;

		/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
		case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
		case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
		/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
		case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
		/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
		case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;

		case 'cstr': size = 0; o = "";
			while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
			o = oo.join(""); break;
		case '_wstr': size = 0; o = "";
			while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
			size+=2; o = oo.join(""); break;

		/* sbcs and dbcs support continue records in the SST way TODO codepages */
		case 'dbcs-cont': o = ""; loc = this.l;
			for(i = 0; i < size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt16LE(this, loc)));
				loc+=2;
			} o = oo.join(""); size *= 2; break;

		case 'cpstr':
			if(typeof cptable !== 'undefined') {
				o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
				break;
			}
		/* falls through */
		case 'sbcs-cont': o = ""; loc = this.l;
			for(i = 0; i != size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt8(this, loc)));
				loc+=1;
			} o = oo.join(""); break;

		default:
	switch(size) {
		case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
		case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
		case 4: case -4:
			if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
			else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
		case 8: case -8:
			if(t === 'f') {
				if(size == 8) oR = __double(this, this.l);
				else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
				this.l += 8; return oR;
			} else size = 8;
		/* falls through */
		case 16: o = __hexlify(this, this.l, size); break;
	}}
	this.l+=size; return o;
}

var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };

function WriteShift(t, val, f) {
	var size = 0, i = 0;
	if(f === 'dbcs') {
for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
		size = 2 * val.length;
	} else if(f === 'sbcs') {
		/* TODO: codepage */
val = val.replace(/[^\x00-\x7F]/g, "_");
for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
		size = val.length;
	} else if(f === 'hex') {
		for(; i < t; ++i) {
this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
		} return this;
	} else if(f === 'utf16le') {
var end = Math.min(this.l + t, this.length);
			for(i = 0; i < Math.min(val.length, t); ++i) {
				var cc = val.charCodeAt(i);
				this[this.l++] = (cc & 0xff);
				this[this.l++] = (cc >> 8);
			}
			while(this.l < end) this[this.l++] = 0;
			return this;
	} else  switch(t) {
		case  1: size = 1; this[this.l] = val&0xFF; break;
		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
		case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
		case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
		/* falls through */
		case 16: break;
		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
	}
	this.l += size; return this;
}

function CheckField(hexstr, fld) {
	var m = __hexlify(this,this.l,hexstr.length>>1);
	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
	this.l += hexstr.length>>1;
}

function prep_blob(blob, pos) {
	blob.l = pos;
	blob.read_shift = ReadShift;
	blob.chk = CheckField;
	blob.write_shift = WriteShift;
}

function parsenoop(blob, length) { blob.l += length; }

function new_buf(sz) {
	var o = new_raw_buf(sz);
	prep_blob(o, 0);
	return o;
}

/* [MS-XLSB] 2.1.4 Record */
function recordhopper(data, cb, opts) {
	if(!data) return;
	var tmpbyte, cntbyte, length;
	prep_blob(data, data.l || 0);
	var L = data.length, RT = 0, tgt = 0;
	while(data.l < L) {
		RT = data.read_shift(1);
		if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
		var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
		tmpbyte = data.read_shift(1);
		length = tmpbyte & 0x7F;
		for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
		tgt = data.l + length;
		var d = (R.f||parsenoop)(data, length, opts);
		data.l = tgt;
		if(cb(d, R.n, RT)) return;
	}
}

/* control buffer usage for fixed-length buffers */
function buf_array() {
	var bufs = [], blksz = has_buf ? 256 : 2048;
	var newblk = function ba_newblk(sz) {
		var o = (new_buf(sz));
		prep_blob(o, 0);
		return o;
	};

	var curbuf = newblk(blksz);

	var endbuf = function ba_endbuf() {
		if(!curbuf) return;
		if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
		if(curbuf.length > 0) bufs.push(curbuf);
		curbuf = null;
	};

	var next = function ba_next(sz) {
		if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
		endbuf();
		return (curbuf = newblk(Math.max(sz+1, blksz)));
	};

	var end = function ba_end() {
		endbuf();
		return __toBuffer([bufs]);
	};

	var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };

	return ({ next:next, push:push, end:end, _bufs:bufs });
}

function write_record(ba, type, payload, length) {
	var t = +XLSBRE[type], l;
	if(isNaN(t)) return; // TODO: throw something here?
	if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
	l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
	if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
	var o = ba.next(l);
	if(t <= 0x7F) o.write_shift(1, t);
	else {
		o.write_shift(1, (t & 0x7F) + 0x80);
		o.write_shift(1, (t >> 7));
	}
	for(var i = 0; i != 4; ++i) {
		if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
		else { o.write_shift(1, length); break; }
	}
	if(length > 0 && is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */
function shift_cell_xls(cell, tgt, opts) {
	var out = dup(cell);
	if(tgt.s) {
		if(out.cRel) out.c += tgt.s.c;
		if(out.rRel) out.r += tgt.s.r;
	} else {
		if(out.cRel) out.c += tgt.c;
		if(out.rRel) out.r += tgt.r;
	}
	if(!opts || opts.biff < 12) {
		while(out.c >= 0x100) out.c -= 0x100;
		while(out.r >= 0x10000) out.r -= 0x10000;
	}
	return out;
}

function shift_range_xls(cell, range, opts) {
	var out = dup(cell);
	out.s = shift_cell_xls(out.s, range.s, opts);
	out.e = shift_cell_xls(out.e, range.s, opts);
	return out;
}

function encode_cell_xls(c, biff) {
	if(c.cRel && c.c < 0) { c = dup(c); c.c += (biff > 8) ? 0x4000 : 0x100; }
	if(c.rRel && c.r < 0) { c = dup(c); c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
	var s = encode_cell(c);
	if(c.cRel === 0) s = fix_col(s);
	if(c.rRel === 0) s = fix_row(s);
	return s;
}

function encode_range_xls(r, opts) {
	if(r.s.r == 0 && !r.s.rRel) {
		if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
			return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
		}
	}
	if(r.s.c == 0 && !r.s.cRel) {
		if(r.e.c == (opts.biff >= 12 ? 0xFFFF : 0xFF) && !r.e.cRel) {
			return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
		}
	}
	return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
}
var OFFCRYPTO = {};

var make_offcrypto = function(O, _crypto) {
	var crypto;
	if(typeof _crypto !== 'undefined') crypto = _crypto;
	else if(true) {
		try { crypto = __webpack_require__(3400); }
		catch(e) { crypto = null; }
	}

	O.rc4 = function(key, data) {
		var S = new Array(256);
		var c = 0, i = 0, j = 0, t = 0;
		for(i = 0; i != 256; ++i) S[i] = i;
		for(i = 0; i != 256; ++i) {
			j = (j + S[i] + (key[i%key.length]).charCodeAt(0))&255;
			t = S[i]; S[i] = S[j]; S[j] = t;
		}
		// $FlowIgnore
		i = j = 0; var out = Buffer(data.length);
		for(c = 0; c != data.length; ++c) {
			i = (i + 1)&255;
			j = (j + S[i])%256;
			t = S[i]; S[i] = S[j]; S[j] = t;
			out[c] = (data[c] ^ S[(S[i]+S[j])&255]);
		}
		return out;
	};

	O.md5 = function(hex) {
		if(!crypto) throw new Error("Unsupported crypto");
		return crypto.createHash('md5').update(hex).digest('hex');
	};
};
/*global crypto:true */
make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);

function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
function encode_row(row) { return "" + (row + 1); }
function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }

function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
function encode_col(col) { var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }

function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
function decode_range(range) { var x =range.split(":").map(decode_cell); return {s:x[0],e:x[x.length-1]}; }
function encode_range(cs,ce) {
	if(typeof ce === 'undefined' || typeof ce === 'number') {
return encode_range(cs.s, cs.e);
	}
if(typeof cs !== 'string') cs = encode_cell((cs));
	if(typeof ce !== 'string') ce = encode_cell((ce));
return cs == ce ? cs : cs + ":" + ce;
}

function safe_decode_range(range) {
	var o = {s:{c:0,r:0},e:{c:0,r:0}};
	var idx = 0, i = 0, cc = 0;
	var len = range.length;
	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.s.c = --idx;

	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.s.r = --idx;

	if(i === len || range.charCodeAt(++i) === 58) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.e.c = --idx;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.e.r = --idx;
	return o;
}

function safe_format_cell(cell, v) {
	var q = (cell.t == 'd' && v instanceof Date);
	if(cell.z != null) try { return (cell.w = SSF.format(cell.z, q ? datenum(v) : v)); } catch(e) { }
	try { return (cell.w = SSF.format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
}

function format_cell(cell, v, o) {
	if(cell == null || cell.t == null || cell.t == 'z') return "";
	if(cell.w !== undefined) return cell.w;
	if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
	if(v == undefined) return safe_format_cell(cell, cell.v);
	return safe_format_cell(cell, v);
}

function sheet_to_workbook(sheet, opts) {
	var n = opts && opts.sheet ? opts.sheet : "Sheet1";
	var sheets = {}; sheets[n] = sheet;
	return { SheetNames: [n], Sheets: sheets };
}

function sheet_add_aoa(_ws, data, opts) {
	var o = opts || {};
	var dense = _ws ? Array.isArray(_ws) : o.dense;
	if(DENSE != null && dense == null) dense = DENSE;
	var ws = _ws || (dense ? ([]) : ({}));
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.s.c = _range.s.c;
		range.s.r = _range.s.r;
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) range.e.r = _R = _range.e.r + 1;
	}
	for(var R = 0; R != data.length; ++R) {
		for(var C = 0; C != data[R].length; ++C) {
			if(typeof data[R][C] === 'undefined') continue;
			var cell = ({v: data[R][C] });
			if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
			var __R = _R + R, __C = _C + C;
			if(range.s.r > __R) range.s.r = __R;
			if(range.s.c > __C) range.s.c = __C;
			if(range.e.r < __R) range.e.r = __R;
			if(range.e.c < __C) range.e.c = __C;
			if(cell.v === null) { if(cell.f) cell.t = 'n'; else if(!o.cellStubs) continue; else cell.t = 'z'; }
			else if(typeof cell.v === 'number') cell.t = 'n';
			else if(typeof cell.v === 'boolean') cell.t = 'b';
			else if(cell.v instanceof Date) {
				cell.z = o.dateNF || SSF._table[14];
				if(o.cellDates) { cell.t = 'd'; cell.w = SSF.format(cell.z, datenum(cell.v)); }
				else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF.format(cell.z, cell.v); }
			}
			else cell.t = 's';
			if(dense) {
				if(!ws[__R]) ws[__R] = [];
				ws[__R][__C] = cell;
			} else {
				var cell_ref = encode_cell(({c:__C,r:__R}));
				ws[cell_ref] = cell;
			}
		}
	}
	if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
	return ws;
}
function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }

function write_UInt32LE(x, o) {
	if(!o) o = new_buf(4);
	o.write_shift(4, x);
	return o;
}

/* [MS-XLSB] 2.5.168 */
function parse_XLWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLWideString(data, o) {
	var _null = false; if(o == null) { _null = true; o = new_buf(4+2*data.length); }
	o.write_shift(4, data.length);
	if(data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.143 */
function parse_StrRun(data) {
	return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
}
function write_StrRun(run, o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, run.ich || 0);
	o.write_shift(2, run.ifnt || 0);
	return o;
}

/* [MS-XLSB] 2.5.121 */
function parse_RichStr(data, length) {
	var start = data.l;
	var flags = data.read_shift(1);
	var str = parse_XLWideString(data);
	var rgsStrRun = [];
	var z = ({ t: str, h: str });
	if((flags & 1) !== 0) { /* fRichStr */
		/* TODO: formatted string */
		var dwSizeStrRun = data.read_shift(4);
		for(var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
		z.r = rgsStrRun;
	}
	else z.r = [{ich:0, ifnt:0}];
	//if((flags & 2) !== 0) { /* fExtStr */
	//	/* TODO: phonetic string */
	//}
	data.l = start + length;
	return z;
}
function write_RichStr(str, o) {
	/* TODO: formatted string */
	var _null = false; if(o == null) { _null = true; o = new_buf(15+4*str.t.length); }
	o.write_shift(1,0);
	write_XLWideString(str.t, o);
	return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
var parse_BrtCommentText = parse_RichStr;
function write_BrtCommentText(str, o) {
	/* TODO: formatted string */
	var _null = false; if(o == null) { _null = true; o = new_buf(23+4*str.t.length); }
	o.write_shift(1,1);
	write_XLWideString(str.t, o);
	o.write_shift(4,1);
	write_StrRun({ich:0,ifnt:0}, o);
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.9 */
function parse_XLSBCell(data) {
	var col = data.read_shift(4);
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) <<16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c:col, iStyleRef: iStyleRef };
}
function write_XLSBCell(cell, o) {
	if(o == null) o = new_buf(8);
	o.write_shift(-4, cell.c);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}


/* [MS-XLSB] 2.5.21 */
var parse_XLSBCodeName = parse_XLWideString;
var write_XLSBCodeName = write_XLWideString;

/* [MS-XLSB] 2.5.166 */
function parse_XLNullableWideString(data) {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLNullableWideString(data, o) {
	var _null = false; if(o == null) { _null = true; o = new_buf(127); }
	o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
	if(data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.165 */
var parse_XLNameWideString = parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;

/* [MS-XLSB] 2.5.114 */
var parse_RelID = parse_XLNullableWideString;
var write_RelID = write_XLNullableWideString;


/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
function parse_RkNumber(data) {
	var b = data.slice(data.l, data.l+4);
	var fX100 = (b[0] & 1), fInt = (b[0] & 2);
	data.l+=4;
	b[0] &= 0xFC; // b[0] &= ~3;
	var RK = fInt === 0 ? __double([0,0,0,0,b[0],b[1],b[2],b[3]],0) : __readInt32LE(b,0)>>2;
	return fX100 ? (RK/100) : RK;
}
function write_RkNumber(data, o) {
	if(o == null) o = new_buf(4);
	var fX100 = 0, fInt = 0, d100 = data * 100;
	if((data == (data | 0)) && (data >= -(1<<29)) && (data < (1 << 29))) { fInt = 1; }
	else if((d100 == (d100 | 0)) && (d100 >= -(1<<29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
	if(fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
	else throw new Error("unsupported RkNumber " + data); // TODO
}


/* [MS-XLSB] 2.5.117 RfX */
function parse_RfX(data ) {
	var cell = ({s: {}, e: {}});
	cell.s.r = data.read_shift(4);
	cell.e.r = data.read_shift(4);
	cell.s.c = data.read_shift(4);
	cell.e.c = data.read_shift(4);
	return cell;
}
function write_RfX(r, o) {
	if(!o) o = new_buf(16);
	o.write_shift(4, r.s.r);
	o.write_shift(4, r.e.r);
	o.write_shift(4, r.s.c);
	o.write_shift(4, r.e.c);
	return o;
}

/* [MS-XLSB] 2.5.153 UncheckedRfX */
var parse_UncheckedRfX = parse_RfX;
var write_UncheckedRfX = write_RfX;

/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
/* TODO: error checking, NaN and Infinity values are not valid Xnum */
function parse_Xnum(data) { return data.read_shift(8, 'f'); }
function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }

/* [MS-XLSB] 2.5.97.2 */
var BErr = {
0x00: "#NULL!",
0x07: "#DIV/0!",
0x0F: "#VALUE!",
0x17: "#REF!",
0x1D: "#NAME?",
0x24: "#NUM!",
0x2A: "#N/A",
0x2B: "#GETTING_DATA",
0xFF: "#WTF?"
};
var RBErr = evert_num(BErr);

/* [MS-XLSB] 2.4.324 BrtColor */
function parse_BrtColor(data) {
	var out = {};
	var d = data.read_shift(1);

	//var fValidRGB = d & 1;
	var xColorType = d >>> 1;

	var index = data.read_shift(1);
	var nTS = data.read_shift(2, 'i');
	var bR = data.read_shift(1);
	var bG = data.read_shift(1);
	var bB = data.read_shift(1);
	data.l++; //var bAlpha = data.read_shift(1);

	switch(xColorType) {
		case 0: out.auto = 1; break;
		case 1:
			out.index = index;
			var icv = XLSIcv[index];
			/* automatic pseudo index 81 */
			if(icv) out.rgb = rgb2Hex(icv);
			break;
		case 2:
			/* if(!fValidRGB) throw new Error("invalid"); */
			out.rgb = rgb2Hex([bR, bG, bB]);
			break;
		case 3: out.theme = index; break;
	}
	if(nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;

	return out;
}
function write_BrtColor(color, o) {
	if(!o) o = new_buf(8);
	if(!color||color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
	if(color.index) {
		o.write_shift(1, 0x02);
		o.write_shift(1, color.index);
	} else if(color.theme) {
		o.write_shift(1, 0x06);
		o.write_shift(1, color.theme);
	} else {
		o.write_shift(1, 0x05);
		o.write_shift(1, 0);
	}
	var nTS = color.tint || 0;
	if(nTS > 0) nTS *= 32767;
	else if(nTS < 0) nTS *= 32768;
	o.write_shift(2, nTS);
	if(!color.rgb) {
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		o.write_shift(1, 0);
	} else {
		var rgb = (color.rgb || 'FFFFFF');
		o.write_shift(1, parseInt(rgb.slice(0,2),16));
		o.write_shift(1, parseInt(rgb.slice(2,4),16));
		o.write_shift(1, parseInt(rgb.slice(4,6),16));
		o.write_shift(1, 0xFF);
	}
	return o;
}

/* [MS-XLSB] 2.5.52 */
function parse_FontFlags(data) {
	var d = data.read_shift(1);
	data.l++;
	var out = {
		/* fBold: d & 0x01 */
		fItalic: d & 0x02,
		/* fUnderline: d & 0x04 */
		fStrikeout: d & 0x08,
		fOutline: d & 0x10,
		fShadow: d & 0x20,
		fCondense: d & 0x40,
		fExtend: d & 0x80
	};
	return out;
}
function write_FontFlags(font, o) {
	if(!o) o = new_buf(2);
	var grbit =
		(font.italic   ? 0x02 : 0) |
		(font.strike   ? 0x08 : 0) |
		(font.outline  ? 0x10 : 0) |
		(font.shadow   ? 0x20 : 0) |
		(font.condense ? 0x40 : 0) |
		(font.extend   ? 0x80 : 0);
	o.write_shift(1, grbit);
	o.write_shift(1, 0);
	return o;
}

/* [MS-OLEDS] 2.3.1 and 2.3.2 */
function parse_ClipboardFormatOrString(o, w) {
	// $FlowIgnore
	var ClipFmt = {2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};
	var m = o.read_shift(4);
	switch(m) {
		case 0x00000000: return "";
		case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)]||"";
	}
	if(m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
	o.l -= 4;
	return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }

/* [MS-OLEPS] 2.2 PropertyType */
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2       = 0x0002;
var VT_I4       = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL     = 0x000B;
var VT_VARIANT  = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4      = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var VT_FILETIME = 0x0040;
var VT_BLOB     = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF       = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR   = 0x1000;
//var VT_ARRAY    = 0x2000;

var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM   = [VT_STRING, VT_USTR];

/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
var DocSummaryPIDDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Category', t: VT_STRING },
0x03: { n: 'PresentationFormat', t: VT_STRING },
0x04: { n: 'ByteCount', t: VT_I4 },
0x05: { n: 'LineCount', t: VT_I4 },
0x06: { n: 'ParagraphCount', t: VT_I4 },
0x07: { n: 'SlideCount', t: VT_I4 },
0x08: { n: 'NoteCount', t: VT_I4 },
0x09: { n: 'HiddenCount', t: VT_I4 },
0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
0x0b: { n: 'ScaleCrop', t: VT_BOOL },
0x0c: { n: 'HeadingPairs', t: VT_VECTOR | VT_VARIANT },
0x0d: { n: 'TitlesOfParts', t: VT_VECTOR | VT_LPSTR },
0x0e: { n: 'Manager', t: VT_STRING },
0x0f: { n: 'Company', t: VT_STRING },
0x10: { n: 'LinksUpToDate', t: VT_BOOL },
0x11: { n: 'CharacterCount', t: VT_I4 },
0x13: { n: 'SharedDoc', t: VT_BOOL },
0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
0x18: { n: 'DigSig', t: VT_BLOB },
0x1A: { n: 'ContentType', t: VT_STRING },
0x1B: { n: 'ContentStatus', t: VT_STRING },
0x1C: { n: 'Language', t: VT_STRING },
0x1D: { n: 'Version', t: VT_STRING },
0xFF: {}
};

/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
var SummaryPIDSI = {
0x01: { n: 'CodePage', t: VT_I2 },
0x02: { n: 'Title', t: VT_STRING },
0x03: { n: 'Subject', t: VT_STRING },
0x04: { n: 'Author', t: VT_STRING },
0x05: { n: 'Keywords', t: VT_STRING },
0x06: { n: 'Comments', t: VT_STRING },
0x07: { n: 'Template', t: VT_STRING },
0x08: { n: 'LastAuthor', t: VT_STRING },
0x09: { n: 'RevNumber', t: VT_STRING },
0x0A: { n: 'EditTime', t: VT_FILETIME },
0x0B: { n: 'LastPrinted', t: VT_FILETIME },
0x0C: { n: 'CreatedDate', t: VT_FILETIME },
0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
0x0E: { n: 'PageCount', t: VT_I4 },
0x0F: { n: 'WordCount', t: VT_I4 },
0x10: { n: 'CharCount', t: VT_I4 },
0x11: { n: 'Thumbnail', t: VT_CF },
0x12: { n: 'Application', t: VT_STRING },
0x13: { n: 'DocSecurity', t: VT_I4 },
0xFF: {}
};

/* [MS-OLEPS] 2.18 */
var SpecialProperties = {
0x80000000: { n: 'Locale', t: VT_UI4 },
0x80000003: { n: 'Behavior', t: VT_UI4 },
0x72627262: {}
};

(function() {
	for(var y in SpecialProperties) if(SpecialProperties.hasOwnProperty(y))
	DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
})();

var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
var SummaryRE = evert_key(SummaryPIDSI, "n");

/* [MS-XLS] 2.4.63 Country/Region codes */
var CountryEnum = {
0x0001: "US", // United States
0x0002: "CA", // Canada
0x0003: "", // Latin America (except Brazil)
0x0007: "RU", // Russia
0x0014: "EG", // Egypt
0x001E: "GR", // Greece
0x001F: "NL", // Netherlands
0x0020: "BE", // Belgium
0x0021: "FR", // France
0x0022: "ES", // Spain
0x0024: "HU", // Hungary
0x0027: "IT", // Italy
0x0029: "CH", // Switzerland
0x002B: "AT", // Austria
0x002C: "GB", // United Kingdom
0x002D: "DK", // Denmark
0x002E: "SE", // Sweden
0x002F: "NO", // Norway
0x0030: "PL", // Poland
0x0031: "DE", // Germany
0x0034: "MX", // Mexico
0x0037: "BR", // Brazil
0x003d: "AU", // Australia
0x0040: "NZ", // New Zealand
0x0042: "TH", // Thailand
0x0051: "JP", // Japan
0x0052: "KR", // Korea
0x0054: "VN", // Viet Nam
0x0056: "CN", // China
0x005A: "TR", // Turkey
0x0069: "JS", // Ramastan
0x00D5: "DZ", // Algeria
0x00D8: "MA", // Morocco
0x00DA: "LY", // Libya
0x015F: "PT", // Portugal
0x0162: "IS", // Iceland
0x0166: "FI", // Finland
0x01A4: "CZ", // Czech Republic
0x0376: "TW", // Taiwan
0x03C1: "LB", // Lebanon
0x03C2: "JO", // Jordan
0x03C3: "SY", // Syria
0x03C4: "IQ", // Iraq
0x03C5: "KW", // Kuwait
0x03C6: "SA", // Saudi Arabia
0x03CB: "AE", // United Arab Emirates
0x03CC: "IL", // Israel
0x03CE: "QA", // Qatar
0x03D5: "IR", // Iran
0xFFFF: "US"  // United States
};

/* [MS-XLS] 2.5.127 */
var XLSFillPattern = [
	null,
	'solid',
	'mediumGray',
	'darkGray',
	'lightGray',
	'darkHorizontal',
	'darkVertical',
	'darkDown',
	'darkUp',
	'darkGrid',
	'darkTrellis',
	'lightHorizontal',
	'lightVertical',
	'lightDown',
	'lightUp',
	'lightGrid',
	'lightTrellis',
	'gray125',
	'gray0625'
];

function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }

/* [MS-XLS] 2.5.161 */
/* [MS-XLSB] 2.5.75 Icv */
var XLSIcv = rgbify([
	/* Color Constants */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	/* Overridable Defaults */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	0x800000,
	0x008000,
	0x000080,
	0x808000,
	0x800080,
	0x008080,
	0xC0C0C0,
	0x808080,
	0x9999FF,
	0x993366,
	0xFFFFCC,
	0xCCFFFF,
	0x660066,
	0xFF8080,
	0x0066CC,
	0xCCCCFF,

	0x000080,
	0xFF00FF,
	0xFFFF00,
	0x00FFFF,
	0x800080,
	0x800000,
	0x008080,
	0x0000FF,
	0x00CCFF,
	0xCCFFFF,
	0xCCFFCC,
	0xFFFF99,
	0x99CCFF,
	0xFF99CC,
	0xCC99FF,
	0xFFCC99,

	0x3366FF,
	0x33CCCC,
	0x99CC00,
	0xFFCC00,
	0xFF9900,
	0xFF6600,
	0x666699,
	0x969696,
	0x003366,
	0x339966,
	0x003300,
	0x333300,
	0x993300,
	0x993366,
	0x333399,
	0x333333,

	/* Other entries to appease BIFF8/12 */
	0xFFFFFF, /* 0x40 icvForeground ?? */
	0x000000, /* 0x41 icvBackground ?? */
	0x000000, /* 0x42 icvFrame ?? */
	0x000000, /* 0x43 icv3D ?? */
	0x000000, /* 0x44 icv3DText ?? */
	0x000000, /* 0x45 icv3DHilite ?? */
	0x000000, /* 0x46 icv3DShadow ?? */
	0x000000, /* 0x47 icvHilite ?? */
	0x000000, /* 0x48 icvCtlText ?? */
	0x000000, /* 0x49 icvCtlScrl ?? */
	0x000000, /* 0x4A icvCtlInv ?? */
	0x000000, /* 0x4B icvCtlBody ?? */
	0x000000, /* 0x4C icvCtlFrame ?? */
	0x000000, /* 0x4D icvCtlFore ?? */
	0x000000, /* 0x4E icvCtlBack ?? */
	0x000000, /* 0x4F icvCtlNeutral */
	0x000000, /* 0x50 icvInfoBk ?? */
	0x000000 /* 0x51 icvInfoText ?? */
]);

/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
/* 12.3 Part Summary <SpreadsheetML> */
/* 14.2 Part Summary <DrawingML> */
/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
var ct2type/*{[string]:string}*/ = ({
	/* Workbook */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",

	/* Worksheet */
	"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */

	/* Macrosheet */
	"application/vnd.ms-excel.intlmacrosheet": "TODO",
	"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */

	/* File Properties */
	"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
	"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
	"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",

	/* Custom Data Properties */
	"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",

	/* PivotTable */
	"application/vnd.ms-excel.pivotTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",

	/* Chart Colors */
	"application/vnd.ms-office.chartcolorstyle+xml": "TODO",

	/* Chart Style */
	"application/vnd.ms-office.chartstyle+xml": "TODO",

	/* Calculation Chain */
	"application/vnd.ms-excel.calcChain": "calcchains",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

	/* Printer Settings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",

	/* ActiveX */
	"application/vnd.ms-office.activeX": "TODO",
	"application/vnd.ms-office.activeX+xml": "TODO",

	/* Custom Toolbars */
	"application/vnd.ms-excel.attachedToolbars": "TODO",

	/* External Data Connections */
	"application/vnd.ms-excel.connections": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",

	/* External Links */
	"application/vnd.ms-excel.externalLink": "links",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",

	/* Metadata */
	"application/vnd.ms-excel.sheetMetadata": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",

	/* PivotCache */
	"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
	"application/vnd.ms-excel.pivotCacheRecords": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",

	/* Query Table */
	"application/vnd.ms-excel.queryTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",

	/* Shared Workbook */
	"application/vnd.ms-excel.userNames": "TODO",
	"application/vnd.ms-excel.revisionHeaders": "TODO",
	"application/vnd.ms-excel.revisionLog": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",

	/* Single Cell Table */
	"application/vnd.ms-excel.tableSingleCells": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",

	/* Slicer */
	"application/vnd.ms-excel.slicer": "TODO",
	"application/vnd.ms-excel.slicerCache": "TODO",
	"application/vnd.ms-excel.slicer+xml": "TODO",
	"application/vnd.ms-excel.slicerCache+xml": "TODO",

	/* Sort Map */
	"application/vnd.ms-excel.wsSortMap": "TODO",

	/* Table */
	"application/vnd.ms-excel.table": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",

	/* Themes */
	"application/vnd.openxmlformats-officedocument.theme+xml": "themes",

	/* Theme Override */
	"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",

	/* Timeline */
	"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
	"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */

	/* VBA */
	"application/vnd.ms-office.vbaProject": "vba",
	"application/vnd.ms-office.vbaProjectSignature": "vba",

	/* Volatile Dependencies */
	"application/vnd.ms-office.volatileDependencies": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",

	/* Control Properties */
	"application/vnd.ms-excel.controlproperties+xml": "TODO",

	/* Data Model */
	"application/vnd.openxmlformats-officedocument.model+data": "TODO",

	/* Survey */
	"application/vnd.ms-excel.Survey+xml": "TODO",

	/* Drawing */
	"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",

	/* VML */
	"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",

	"application/vnd.openxmlformats-package.relationships+xml": "rels",
	"application/vnd.openxmlformats-officedocument.oleObject": "TODO",

	/* Image */
	"image/png": "TODO",

	"sheet": "js"
});

var CT_LIST = (function(){
	var o = {
		workbooks: {
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
			xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
			xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
			xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
			xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
		},
		strs: { /* Shared Strings */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
			xlsb: "application/vnd.ms-excel.sharedStrings"
		},
		comments: { /* Comments */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
			xlsb: "application/vnd.ms-excel.comments"
		},
		sheets: { /* Worksheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
			xlsb: "application/vnd.ms-excel.worksheet"
		},
		charts: { /* Chartsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
			xlsb: "application/vnd.ms-excel.chartsheet"
		},
		dialogs: { /* Dialogsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
			xlsb: "application/vnd.ms-excel.dialogsheet"
		},
		macros: { /* Macrosheet (Excel 4.0 Macros) */
			xlsx: "application/vnd.ms-excel.macrosheet+xml",
			xlsb: "application/vnd.ms-excel.macrosheet"
		},
		styles: { /* Styles */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
			xlsb: "application/vnd.ms-excel.styles"
		}
	};
	keys(o).forEach(function(k) { ["xlsm", "xlam"].forEach(function(v) { if(!o[k][v]) o[k][v] = o[k].xlsx; }); });
	keys(o).forEach(function(k){ keys(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
	return o;
})();

var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);

XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';

function new_ct() {
	return ({
		workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
		rels:[], strs:[], comments:[], links:[],
		coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
		calcchains:[], vba: [], drawings: [],
		TODO:[], xmlns: "" });
}

function parse_ct(data) {
	var ct = new_ct();
	if(!data || !data.match) return ct;
	var ctext = {};
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0].replace(nsregex,"<")) {
			case '<?xml': break;
			case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
			case '<Default': ctext[y.Extension] = y.ContentType; break;
			case '<Override':
				if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
				break;
		}
	});
	if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
	ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
	ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
	ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
	ct.defaults = ctext;
	delete ct.calcchains;
	return ct;
}

var CTYPE_XML_ROOT = writextag('Types', null, {
	'xmlns': XMLNS.CT,
	'xmlns:xsd': XMLNS.xsd,
	'xmlns:xsi': XMLNS.xsi
});

var CTYPE_DEFAULTS = [
	['xml', 'application/xml'],
	['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
	['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
	/* from test files */
	['bmp', 'image/bmp'],
	['png', 'image/png'],
	['gif', 'image/gif'],
	['emf', 'image/x-emf'],
	['wmf', 'image/x-wmf'],
	['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
	['tif', 'image/tiff'], ['tiff', 'image/tiff'],
	['pdf', 'application/pdf'],
	['rels', type2ct.rels[0]]
].map(function(x) {
	return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
});

function write_ct(ct, opts) {
	var o = [], v;
	o[o.length] = (XML_HEADER);
	o[o.length] = (CTYPE_XML_ROOT);
	o = o.concat(CTYPE_DEFAULTS);
	var f1 = function(w) {
		if(ct[w] && ct[w].length > 0) {
			v = ct[w][0];
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		}
	};
	var f2 = function(w) {
		(ct[w]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		});
	};
	var f3 = function(t) {
		(ct[t]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': type2ct[t][0]
			}));
		});
	};
	f1('workbooks');
	f2('sheets');
	f2('charts');
	f3('themes');
	['strs', 'styles'].forEach(f1);
	['coreprops', 'extprops', 'custprops'].forEach(f3);
	f3('vba');
	f3('comments');
	f3('drawings');
	if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 9.3 Relationships */
var RELS = ({
	WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
	VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
	VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
});

/* 9.3.3 Representing Relationships */
function get_rels_path(file) {
	var n = file.lastIndexOf("/");
	return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
}

function parse_rels(data, currentFilePath) {
	if (!data) return data;
	if (currentFilePath.charAt(0) !== '/') {
		currentFilePath = '/'+currentFilePath;
	}
	var rels = {};
	var hash = {};

	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		/* 9.3.2.2 OPC_Relationships */
		if (y[0] === '<Relationship') {
			var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; rel.TargetMode = y.TargetMode;
			var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
			rels[canonictarget] = rel;
			hash[y.Id] = rel;
		}
	});
	rels["!id"] = hash;
	return rels;
}

XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';

var RELS_ROOT = writextag('Relationships', null, {
	//'xmlns:ns0': XMLNS.RELS,
	'xmlns': XMLNS.RELS
});

/* TODO */
function write_rels(rels) {
	var o = [XML_HEADER, RELS_ROOT];
	keys(rels['!id']).forEach(function(rid) {
		o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
	});
	if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

function add_rels(rels, rId, f, type, relobj) {
	if(!relobj) relobj = {};
	if(!rels['!id']) rels['!id'] = {};
	if(rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId){/* empty */}
	relobj.Id = 'rId' + rId;
	relobj.Type = type;
	relobj.Target = f;
	if(relobj.Type == RELS.HLINK) relobj.TargetMode = "External";
	if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
	rels['!id'][relobj.Id] = relobj;
	rels[('/' + relobj.Target).replace("//","/")] = relobj;
	return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
/* Part 3 Section 4 Manifest File */
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(d, opts) {
	var str = xlml_normalize(d);
	var Rn;
	var FEtag;
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'manifest': break; // 4.2 <manifest:manifest>
		case 'file-entry': // 4.3 <manifest:file-entry>
			FEtag = parsexmltag(Rn[0], false);
			if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
			break;
		case 'encryption-data': // 4.4 <manifest:encryption-data>
		case 'algorithm': // 4.5 <manifest:algorithm>
		case 'start-key-generation': // 4.6 <manifest:start-key-generation>
		case 'key-derivation': // 4.7 <manifest:key-derivation>
			throw new Error("Unsupported ODS Encryption");
		default: if(opts && opts.WTF) throw Rn;
	}
}

function write_manifest(manifest) {
	var o = [XML_HEADER];
	o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
	o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
	for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
	o.push('</manifest:manifest>');
	return o.join("");
}

/* Part 3 Section 6 Metadata Manifest File */
function write_rdf_type(file, res, tag) {
	return [
		'  <rdf:Description rdf:about="' + file + '">\n',
		'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf_has(base, file) {
	return [
		'  <rdf:Description rdf:about="' + base + '">\n',
		'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf(rdf) {
	var o = [XML_HEADER];
	o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
	for(var i = 0; i != rdf.length; ++i) {
		o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
		o.push(write_rdf_has("",rdf[i][0]));
	}
	o.push(write_rdf_type("","Document", "pkg"));
	o.push('</rdf:RDF>');
	return o.join("");
}
/* TODO: pull properties */
var write_meta_ods = (function() {
	var payload = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	return function wmo() {
		return payload;
	};
})();

/* ECMA-376 Part II 11.1 Core Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var CORE_PROPS = [
	["cp:category", "Category"],
	["cp:contentStatus", "ContentStatus"],
	["cp:keywords", "Keywords"],
	["cp:lastModifiedBy", "LastAuthor"],
	["cp:lastPrinted", "LastPrinted"],
	["cp:revision", "RevNumber"],
	["cp:version", "Version"],
	["dc:creator", "Author"],
	["dc:description", "Comments"],
	["dc:identifier", "Identifier"],
	["dc:language", "Language"],
	["dc:subject", "Subject"],
	["dc:title", "Title"],
	["dcterms:created", "CreatedDate", 'date'],
	["dcterms:modified", "ModifiedDate", 'date']
];

XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';

var CORE_PROPS_REGEX = (function() {
	var r = new Array(CORE_PROPS.length);
	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
		r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
	}
	return r;
})();

function parse_core_props(data) {
	var p = {};
	data = utf8read(data);

	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
		if(cur != null && cur.length > 0) p[f[1]] = cur[1];
		if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
	}

	return p;
}

var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
	//'xmlns': XMLNS.CORE_PROPS,
	'xmlns:cp': XMLNS.CORE_PROPS,
	'xmlns:dc': XMLNS.dc,
	'xmlns:dcterms': XMLNS.dcterms,
	'xmlns:dcmitype': XMLNS.dcmitype,
	'xmlns:xsi': XMLNS.xsi
});

function cp_doit(f, g, h, o, p) {
	if(p[f] != null || g == null || g === "") return;
	p[f] = g;
	o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
}

function write_core_props(cp, _opts) {
	var opts = _opts || {};
	var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
	if(!cp && !opts.Props) return o.join("");

	if(cp) {
		if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	}

	for(var i = 0; i != CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
		if(v === true) v = "1";
		else if(v === false) v = "0";
		else if(typeof v == "number") v = String(v);
		if(v != null) cp_doit(f[0], v, null, o, p);
	}
	if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var EXT_PROPS = [
	["Application", "Application", "string"],
	["AppVersion", "AppVersion", "string"],
	["Company", "Company", "string"],
	["DocSecurity", "DocSecurity", "string"],
	["Manager", "Manager", "string"],
	["HyperlinksChanged", "HyperlinksChanged", "bool"],
	["SharedDoc", "SharedDoc", "bool"],
	["LinksUpToDate", "LinksUpToDate", "bool"],
	["ScaleCrop", "ScaleCrop", "bool"],
	["HeadingPairs", "HeadingPairs", "raw"],
	["TitlesOfParts", "TitlesOfParts", "raw"]
];

XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';

var PseudoPropsPairs = [
	"Worksheets",  "SheetNames",
	"NamedRanges", "DefinedNames",
	"Chartsheets", "ChartNames"
];
function load_props_pairs(HP, TOP, props, opts) {
	var v = [];
	if(typeof HP == "string") v = parseVector(HP, opts);
	else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
	var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
	var idx = 0, len = 0;
	if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
		len = +(v[i+1].v);
		switch(v[i].v) {
			case "Worksheets":
			case "工作表":
			case "Листы":
			case "أوراق العمل":
			case "ワークシート":
			case "גליונות עבודה":
			case "Arbeitsblätter":
			case "Çalışma Sayfaları":
			case "Feuilles de calcul":
			case "Fogli di lavoro":
			case "Folhas de cálculo":
			case "Planilhas":
			case "Regneark":
			case "Werkbladen":
				props.Worksheets = len;
				props.SheetNames = parts.slice(idx, idx + len);
				break;

			case "Named Ranges":
			case "名前付き一覧":
			case "Benannte Bereiche":
			case "Navngivne områder":
				props.NamedRanges = len;
				props.DefinedNames = parts.slice(idx, idx + len);
				break;

			case "Charts":
			case "Diagramme":
				props.Chartsheets = len;
				props.ChartNames = parts.slice(idx, idx + len);
				break;
		}
		idx += len;
	}
}

function parse_ext_props(data, p, opts) {
	var q = {}; if(!p) p = {};
	data = utf8read(data);

	EXT_PROPS.forEach(function(f) {
		switch(f[2]) {
			case "string": p[f[1]] = (data.match(matchtag(f[0]))||[])[1]; break;
			case "bool": p[f[1]] = (data.match(matchtag(f[0]))||[])[1] === "true"; break;
			case "raw":
				var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
				if(cur && cur.length > 0) q[f[1]] = cur[1];
				break;
		}
	});

	if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);

	return p;
}

var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.EXT_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_ext_props(cp) {
	var o = [], W = writextag;
	if(!cp) cp = {};
	cp.Application = "SheetJS";
	o[o.length] = (XML_HEADER);
	o[o.length] = (EXT_PROPS_XML_ROOT);

	EXT_PROPS.forEach(function(f) {
		if(cp[f[1]] === undefined) return;
		var v;
		switch(f[2]) {
			case 'string': v = String(cp[f[1]]); break;
			case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
		}
		if(v !== undefined) o[o.length] = (W(f[0], v));
	});

	/* TODO: HeadingPairs, TitlesOfParts */
	o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
	o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
	if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */
XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';

var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(data, opts) {
	var p = {}, name = "";
	var m = data.match(custregex);
	if(m) for(var i = 0; i != m.length; ++i) {
		var x = m[i], y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			case '<Properties': break;
			case '<property': name = y.name; break;
			case '</property>': name = null; break;
			default: if (x.indexOf('<vt:') === 0) {
				var toks = x.split('>');
				var type = toks[0].slice(4), text = toks[1];
				/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
				switch(type) {
					case 'lpstr': case 'bstr': case 'lpwstr':
						p[name] = unescapexml(text);
						break;
					case 'bool':
						p[name] = parsexmlbool(text);
						break;
					case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
						p[name] = parseInt(text, 10);
						break;
					case 'r4': case 'r8': case 'decimal':
						p[name] = parseFloat(text);
						break;
					case 'filetime': case 'date':
						p[name] = parseDate(text);
						break;
					case 'cy': case 'error':
						p[name] = unescapexml(text);
						break;
					default:
						if(type.slice(-1) == '/') break;
						if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
				}
			} else if(x.slice(0,2) === "</") {/* empty */
			} else if(opts.WTF) throw new Error(x);
		}
	}
	return p;
}

var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.CUST_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_cust_props(cp) {
	var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
	if(!cp) return o.join("");
	var pid = 1;
	keys(cp).forEach(function custprop(k) { ++pid;
		o[o.length] = (writextag('property', write_vt(cp[k]), {
			'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
			'pid': pid,
			'name': k
		}));
	});
	if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* Common Name -> XLML Name */
var XLMLDocPropsMap = {
	Title: 'Title',
	Subject: 'Subject',
	Author: 'Author',
	Keywords: 'Keywords',
	Comments: 'Description',
	LastAuthor: 'LastAuthor',
	RevNumber: 'Revision',
	Application: 'AppName',
	/* TotalTime: 'TotalTime', */
	LastPrinted: 'LastPrinted',
	CreatedDate: 'Created',
	ModifiedDate: 'LastSaved',
	/* Pages */
	/* Words */
	/* Characters */
	Category: 'Category',
	/* PresentationFormat */
	Manager: 'Manager',
	Company: 'Company',
	/* Guid */
	/* HyperlinkBase */
	/* Bytes */
	/* Lines */
	/* Paragraphs */
	/* CharactersWithSpaces */
	AppVersion: 'Version',

	ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
	Identifier: 'Identifier', /* NOTE: missing from schema */
	Language: 'Language' /* NOTE: missing from schema */
};
var evert_XLMLDPM = evert(XLMLDocPropsMap);

function xlml_set_prop(Props, tag, val) {
	tag = evert_XLMLDPM[tag] || tag;
	Props[tag] = val;
}

function xlml_write_docprops(Props, opts) {
	var o = [];
	keys(XLMLDocPropsMap).map(function(m) {
		for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
		for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
		throw m;
	}).forEach(function(p) {
		if(Props[p[1]] == null) return;
		var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
		switch(p[2]) {
			case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
		}
		if(typeof m == 'number') m = String(m);
		else if(m === true || m === false) { m = m ? "1" : "0"; }
		else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
		o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
	});
	return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
}
function xlml_write_custprops(Props, Custprops) {
	var BLACKLIST = ["Worksheets","SheetNames"];
	var T = 'CustomDocumentProperties';
	var o = [];
	if(Props) keys(Props).forEach(function(k) {
if(!Props.hasOwnProperty(k)) return;
		for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
		for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
		for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;

		var m = Props[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	if(Custprops) keys(Custprops).forEach(function(k) {
if(!Custprops.hasOwnProperty(k)) return;
		if(Props && Props.hasOwnProperty(k)) return;
		var m = Custprops[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */
/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
function parse_FILETIME(blob) {
	var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
	return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
}
function write_FILETIME(time) {
	var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
	var t = date.getTime() / 1000 + 11644473600;
	var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
	l *= 1e7; h *= 1e7;
	var w = (l / Math.pow(2,32)) | 0;
	if(w > 0) { l = l % Math.pow(2,32); h += w; }
	var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
}

/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
function parse_lpstr(blob, type, pad) {
	var start = blob.l;
	var str = blob.read_shift(0, 'lpstr-cp');
	if(pad) while((blob.l - start) & 3) ++blob.l;
	return str;
}

/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
function parse_lpwstr(blob, type, pad) {
	var str = blob.read_shift(0, 'lpwstr');
	if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
	return str;
}


/* [MS-OSHARED] 2.3.3.1.11 VtString */
/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
function parse_VtStringBase(blob, stringType, pad) {
	if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
	return parse_lpstr(blob, stringType, pad);
}

function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }

/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
function parse_VtVecUnalignedLpstrValue(blob) {
	var length = blob.read_shift(4);
	var ret = [];
	for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
	return ret;
}

/* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */
function parse_VtVecUnalignedLpstr(blob) {
	return parse_VtVecUnalignedLpstrValue(blob);
}

/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
function parse_VtHeadingPair(blob) {
	var headingString = parse_TypedPropertyValue(blob, VT_USTR);
	var headerParts = parse_TypedPropertyValue(blob, VT_I4);
	return [headingString, headerParts];
}

/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
function parse_VtVecHeadingPairValue(blob) {
	var cElements = blob.read_shift(4);
	var out = [];
	for(var i = 0; i != cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
	return out;
}

/* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */
function parse_VtVecHeadingPair(blob) {
	// NOTE: When invoked, wType & padding were already consumed
	return parse_VtVecHeadingPairValue(blob);
}

/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
function parse_dictionary(blob,CodePage) {
	var cnt = blob.read_shift(4);
	var dict = ({});
	for(var j = 0; j != cnt; ++j) {
		var pid = blob.read_shift(4);
		var len = blob.read_shift(4);
		dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
	}
	if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
	return dict;
}

/* [MS-OLEPS] 2.9 BLOB */
function parse_BLOB(blob) {
	var size = blob.read_shift(4);
	var bytes = blob.slice(blob.l,blob.l+size);
	blob.l += size;
	if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
	return bytes;
}

/* [MS-OLEPS] 2.11 ClipboardData */
function parse_ClipboardData(blob) {
	// TODO
	var o = {};
	o.Size = blob.read_shift(4);
	//o.Format = blob.read_shift(4);
	blob.l += o.Size + 3 - (o.Size - 1) % 4;
	return o;
}

/* [MS-OLEPS] 2.15 TypedPropertyValue */
function parse_TypedPropertyValue(blob, type, _opts) {
	var t = blob.read_shift(2), ret, opts = _opts||{};
	blob.l += 2;
	if(type !== VT_VARIANT)
	if(t !== type && VT_CUSTOM.indexOf(type)===-1) throw new Error('Expected type ' + type + ' saw ' + t);
	switch(type === VT_VARIANT ? t : type) {
		case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
		case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
		case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
		case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
		case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
		case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
		case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
		case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
		case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
		case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
		case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
		case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPair(blob);
		case 0x101E /*VT_LPSTR*/: return parse_VtVecUnalignedLpstr(blob);
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
	}
}
function write_TypedPropertyValue(type, value) {
	var o = new_buf(4), p = new_buf(4);
	o.write_shift(4, type == 0x50 ? 0x1F : type);
	switch(type) {
		case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
		case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
		case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
		case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
		case 0x1F /*VT_LPWSTR*/:
		case 0x50 /*VT_STRING*/:
p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			p.write_shift(4, value.length + 1);
			p.write_shift(0, value, "dbcs");
			while(p.l != p.length) p.write_shift(1, 0);
			break;
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
	}
	return bconcat([o, p]);
}

/* [MS-OLEPS] 2.20 PropertySet */
function parse_PropertySet(blob, PIDSI) {
	var start_addr = blob.l;
	var size = blob.read_shift(4);
	var NumProps = blob.read_shift(4);
	var Props = [], i = 0;
	var CodePage = 0;
	var Dictionary = -1, DictObj = ({});
	for(i = 0; i != NumProps; ++i) {
		var PropID = blob.read_shift(4);
		var Offset = blob.read_shift(4);
		Props[i] = [PropID, Offset + start_addr];
	}
	Props.sort(function(x,y) { return x[1] - y[1]; });
	var PropH = {};
	for(i = 0; i != NumProps; ++i) {
		if(blob.l !== Props[i][1]) {
			var fail = true;
			if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
				case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
				case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
			}
			if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
			if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
		}
		if(PIDSI) {
			var piddsi = PIDSI[Props[i][0]];
			PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
			if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
			if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
				case 0: PropH[piddsi.n] = 1252;
					/* falls through */
				case 874:
				case 932:
				case 936:
				case 949:
				case 950:
				case 1250:
				case 1251:
				case 1253:
				case 1254:
				case 1255:
				case 1256:
				case 1257:
				case 1258:
				case 10000:
				case 1200:
				case 1201:
				case 1252:
				case 65000: case -536:
				case 65001: case -535:
					set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
				default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
			}
		} else {
			if(Props[i][0] === 0x1) {
				CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
				set_cp(CodePage);
				if(Dictionary !== -1) {
					var oldpos = blob.l;
					blob.l = Props[Dictionary][1];
					DictObj = parse_dictionary(blob,CodePage);
					blob.l = oldpos;
				}
			} else if(Props[i][0] === 0) {
				if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
				DictObj = parse_dictionary(blob,CodePage);
			} else {
				var name = DictObj[Props[i][0]];
				var val;
				/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
				switch(blob[blob.l]) {
					case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
					case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
					case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
					case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
					case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
					case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
					default: throw new Error("unparsed value: " + blob[blob.l]);
				}
				PropH[name] = val;
			}
		}
	}
	blob.l = start_addr + size; /* step ahead to skip padding */
	return PropH;
}
var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ].concat(PseudoPropsPairs);
function guess_property_type(val) {
	switch(typeof val) {
		case "boolean": return 0x0B;
		case "number": return ((val|0)==val) ? 0x03 : 0x05;
		case "string": return 0x1F;
		case "object": if(val instanceof Date) return 0x40; break;
	}
	return -1;
}
function write_PropertySet(entries, RE, PIDSI) {
	var hdr = new_buf(8), piao = [], prop = [];
	var sz = 8, i = 0;

	var pr = new_buf(8), pio = new_buf(8);
	pr.write_shift(4, 0x0002);
	pr.write_shift(4, 0x04B0);
	pio.write_shift(4, 0x0001);
	prop.push(pr); piao.push(pio);
	sz += 8 + pr.length;

	if(!RE) {
		pio = new_buf(8);
		pio.write_shift(4, 0);
		piao.unshift(pio);

		var bufs = [new_buf(4)];
		bufs[0].write_shift(4, entries.length);
		for(i = 0; i < entries.length; ++i) {
			var value = entries[i][0];
			pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			pr.write_shift(4, i+2);
			pr.write_shift(4, value.length + 1);
			pr.write_shift(0, value, "dbcs");
			while(pr.l != pr.length) pr.write_shift(1, 0);
			bufs.push(pr);
		}
		pr = bconcat(bufs);
		prop.unshift(pr);
		sz += 8 + pr.length;
	}

	for(i = 0; i < entries.length; ++i) {
		if(RE && !RE[entries[i][0]]) continue;
		if(XLSPSSkip.indexOf(entries[i][0]) > -1) continue;
		if(entries[i][1] == null) continue;

		var val = entries[i][1], idx = 0;
		if(RE) {
			idx = +RE[entries[i][0]];
			var pinfo = (PIDSI)[idx];
			if(pinfo.p == "version" && typeof val == "string") {
var arr = val.split(".");
				val = ((+arr[0])<<16) + ((+arr[1])||0);
			}
			pr = write_TypedPropertyValue(pinfo.t, val);
		} else {
			var T = guess_property_type(val);
			if(T == -1) { T = 0x1F; val = String(val); }
			pr = write_TypedPropertyValue(T, val);
		}
		prop.push(pr);

		pio = new_buf(8);
		pio.write_shift(4, !RE ? 2+i : idx);
		piao.push(pio);

		sz += 8 + pr.length;
	}

	var w = 8 * (prop.length + 1);
	for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
	hdr.write_shift(4, sz);
	hdr.write_shift(4, prop.length);
	return bconcat([hdr].concat(piao).concat(prop));
}

/* [MS-OLEPS] 2.21 PropertySetStream */
function parse_PropertySetStream(file, PIDSI, clsid) {
	var blob = file.content;
	if(!blob) return ({});
	prep_blob(blob, 0);

	var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
	blob.chk('feff', 'Byte Order: ');

	/*var vers = */blob.read_shift(2); // TODO: check version
	var SystemIdentifier = blob.read_shift(4);
	var CLSID = blob.read_shift(16);
	if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
	NumSets = blob.read_shift(4);
	if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
	FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);

	if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
	else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
	var PSet0 = parse_PropertySet(blob, PIDSI);

	var rval = ({ SystemIdentifier: SystemIdentifier });
	for(var y in PSet0) rval[y] = PSet0[y];
	//rval.blob = blob;
	rval.FMTID = FMTID0;
	//rval.PSet0 = PSet0;
	if(NumSets === 1) return rval;
	if(Offset1 - blob.l == 2) blob.l += 2;
	if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
	var PSet1;
	try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
	for(y in PSet1) rval[y] = PSet1[y];
	rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
	return rval;
}
function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
	var hdr = new_buf(entries2 ? 68 : 48);
	var bufs = [hdr];
	hdr.write_shift(2, 0xFFFE);
	hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
	hdr.write_shift(4, 0x32363237);
	hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
	hdr.write_shift(4, (entries2 ? 2 : 1));
	hdr.write_shift(16, clsid, "hex");
	hdr.write_shift(4, (entries2 ? 68 : 48));
	var ps0 = write_PropertySet(entries, RE, PIDSI);
	bufs.push(ps0);

	if(entries2) {
		var ps1 = write_PropertySet(entries2, null, null);
		hdr.write_shift(16, clsid2, "hex");
		hdr.write_shift(4, 68 + ps0.length);
		bufs.push(ps1);
	}
	return bconcat(bufs);
}

function parsenoop2(blob, length) { blob.read_shift(length); return null; }
function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }

function parslurp(blob, length, cb) {
	var arr = [], target = blob.l + length;
	while(blob.l < target) arr.push(cb(blob, target - blob.l));
	if(target !== blob.l) throw new Error("Slurp error");
	return arr;
}

function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }

function parseuint16(blob) { return blob.read_shift(2, 'u'); }
function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}

/* --- 2.5 Structures --- */

/* [MS-XLS] 2.5.10 Bes (boolean or error) */
function parse_Bes(blob) {
	var v = blob.read_shift(1), t = blob.read_shift(1);
	return t === 0x01 ? v : v === 0x01;
}
function write_Bes(v, t, o) {
	if(!o) o = new_buf(2);
	o.write_shift(1, +v);
	o.write_shift(1, ((t == 'e') ? 1 : 0));
	return o;
}

/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
function parse_ShortXLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
	var encoding = 'sbcs-cont';
	var cp = current_codepage;
	if(opts && opts.biff >= 8) current_codepage = 1200;
	if(!opts || opts.biff == 8 ) {
		var fHighByte = blob.read_shift(1);
		if(fHighByte) { encoding = 'dbcs-cont'; }
	} else if(opts.biff == 12) {
		encoding = 'wstr';
	}
	if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
	var o = cch ? blob.read_shift(cch, encoding) : "";
	current_codepage = cp;
	return o;
}

/* 2.5.293 XLUnicodeRichExtendedString */
function parse_XLUnicodeRichExtendedString(blob) {
	var cp = current_codepage;
	current_codepage = 1200;
	var cch = blob.read_shift(2), flags = blob.read_shift(1);
	var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
	var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
	var cRun = 0, cbExtRst;
	var z = {};
	if(fRichSt) cRun = blob.read_shift(2);
	if(fExtSt) cbExtRst = blob.read_shift(4);
	var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
	var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
	if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
	if(fExtSt) blob.l += cbExtRst; //TODO: parse this
	z.t = msg;
	if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
	current_codepage = cp;
	return z;
}

/* 2.5.296 XLUnicodeStringNoCch */
function parse_XLUnicodeStringNoCch(blob, cch, opts) {
	var retval;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
		if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
	}
	var fHighByte = blob.read_shift(1);
	if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
	else { retval = blob.read_shift(cch, 'dbcs-cont'); }
	return retval;
}

/* 2.5.294 XLUnicodeString */
function parse_XLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	if(cch === 0) { blob.l++; return ""; }
	return parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */
function parse_XLUnicodeString2(blob, length, opts) {
	if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */
function write_XLUnicodeString(str, opts, o) {
	if(!o) o = new_buf(3 + 2 * str.length);
	o.write_shift(2, str.length);
	o.write_shift(1, 1);
	o.write_shift(31, str, 'utf16le');
	return o;
}

/* [MS-XLS] 2.5.61 ControlInfo */
function parse_ControlInfo(blob) {
	var flags = blob.read_shift(1);
	blob.l++;
	var accel = blob.read_shift(2);
	blob.l += 2;
	return [flags, accel];
}

/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
function parse_URLMoniker(blob) {
	var len = blob.read_shift(4), start = blob.l;
	var extra = false;
	if(len > 24) {
		/* look ahead */
		blob.l += len - 24;
		if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
		blob.l = start;
	}
	var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
	if(extra) blob.l += 24;
	return url;
}

/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
function parse_FileMoniker(blob) {
	blob.l += 2; //var cAnti = blob.read_shift(2);
	var ansiPath = blob.read_shift(0, 'lpstr-ansi');
	blob.l += 2; //var endServer = blob.read_shift(2);
	if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
	var sz = blob.read_shift(4);
	if(sz === 0) return ansiPath.replace(/\\/g,"/");
	var bytes = blob.read_shift(4);
	if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
	var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
	return unicodePath;
}

/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
function parse_HyperlinkMoniker(blob, length) {
	var clsid = blob.read_shift(16); length -= 16;
	switch(clsid) {
		case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
		case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
		default: throw new Error("Unsupported Moniker " + clsid);
	}
}

/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
function parse_HyperlinkString(blob) {
	var len = blob.read_shift(4);
	var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
	return o;
}

/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
function parse_Hyperlink(blob, length) {
	var end = blob.l + length;
	var sVer = blob.read_shift(4);
	if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
	var flags = blob.read_shift(2);
	blob.l += 2;
	var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
	if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
	if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0020) guid = blob.read_shift(16);
	if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
	blob.l = end;
	var target = targetFrameName||moniker||oleMoniker||"";
	if(target && Loc) target+="#"+Loc;
	if(!target) target = "#" + Loc;
	var out = ({Target:target});
	if(guid) out.guid = guid;
	if(fileTime) out.time = fileTime;
	if(displayName) out.Tooltip = displayName;
	return out;
}
function write_Hyperlink(hl) {
	var out = new_buf(512), i = 0;
	var Target = hl.Target;
	var F = Target.indexOf("#") > -1 ? 0x1f : 0x17;
	switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
	out.write_shift(4,2); out.write_shift(4, F);
	var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
	if(F == 0x1C) {
		Target = Target.slice(1);
		out.write_shift(4, Target.length + 1);
		for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
		out.write_shift(2, 0);
	} else if(F & 0x02) {
		data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		out.write_shift(4, 2*(Target.length + 1));
		for(i = 0; i < Target.length; ++i) out.write_shift(2, Target.charCodeAt(i));
		out.write_shift(2, 0);
	} else {
		data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var P = 0;
		while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
		out.write_shift(2, P);
		out.write_shift(4, Target.length + 1);
		for(i = 0; i < Target.length; ++i) out.write_shift(1, Target.charCodeAt(i) & 0xFF);
		out.write_shift(1, 0);
		out.write_shift(2, 0xFFFF);
		out.write_shift(2, 0xDEAD);
		for(i = 0; i < 6; ++i) out.write_shift(4, 0);
	}
	return out.slice(0, out.l);
}

/* 2.5.178 LongRGBA */
function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }

/* 2.5.177 LongRGB */
function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }


/* [MS-XLS] 2.5.19 */
function parse_XLSCell(blob) {
	var rw = blob.read_shift(2); // 0-indexed
	var col = blob.read_shift(2);
	var ixfe = blob.read_shift(2);
	return ({r:rw, c:col, ixfe:ixfe});
}
function write_XLSCell(R, C, ixfe, o) {
	if(!o) o = new_buf(6);
	o.write_shift(2, R);
	o.write_shift(2, C);
	o.write_shift(2, ixfe||0);
	return o;
}

/* [MS-XLS] 2.5.134 */
function parse_frtHeader(blob) {
	var rt = blob.read_shift(2);
	var flags = blob.read_shift(2); // TODO: parse these flags
	blob.l += 8;
	return {type: rt, flags: flags};
}



function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }

/* [MS-XLS] 2.5.344 */
function parse_XTI(blob, length, opts) {
	var w = opts.biff > 8 ? 4 : 2;
	var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
	return [iSupBook, itabFirst, itabLast];
}

/* [MS-XLS] 2.5.218 */
function parse_RkRec(blob) {
	var ixfe = blob.read_shift(2);
	var RK = parse_RkNumber(blob);
	return [ixfe, RK];
}

/* [MS-XLS] 2.5.1 */
function parse_AddinUdf(blob, length, opts) {
	blob.l += 4; length -= 4;
	var l = blob.l + length;
	var udfName = parse_ShortXLUnicodeString(blob, length, opts);
	var cb = blob.read_shift(2);
	l -= blob.l;
	if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
	blob.l += cb;
	return udfName;
}

/* [MS-XLS] 2.5.209 TODO: Check sizes */
function parse_Ref8U(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(2);
	var colLast = blob.read_shift(2);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}
function write_Ref8U(r, o) {
	if(!o) o = new_buf(8);
	o.write_shift(2, r.s.r);
	o.write_shift(2, r.e.r);
	o.write_shift(2, r.s.c);
	o.write_shift(2, r.e.c);
	return o;
}

/* [MS-XLS] 2.5.211 */
function parse_RefU(blob) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(1);
	var colLast = blob.read_shift(1);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}

/* [MS-XLS] 2.5.207 */
var parse_Ref = parse_RefU;

/* [MS-XLS] 2.5.143 */
function parse_FtCmo(blob) {
	blob.l += 4;
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var flags = blob.read_shift(2);
	blob.l+=12;
	return [id, ot, flags];
}

/* [MS-XLS] 2.5.149 */
function parse_FtNts(blob) {
	var out = {};
	blob.l += 4;
	blob.l += 16; // GUID TODO
	out.fSharedNote = blob.read_shift(2);
	blob.l += 4;
	return out;
}

/* [MS-XLS] 2.5.142 */
function parse_FtCf(blob) {
	var out = {};
	blob.l += 4;
	blob.cf = blob.read_shift(2);
	return out;
}

/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
var FtTab = {
0x00: parse_FtSkip,      /* FtEnd */
0x04: parse_FtSkip,      /* FtMacro */
0x05: parse_FtSkip,      /* FtButton */
0x06: parse_FtSkip,      /* FtGmo */
0x07: parse_FtCf,        /* FtCf */
0x08: parse_FtSkip,      /* FtPioGrbit */
0x09: parse_FtSkip,      /* FtPictFmla */
0x0A: parse_FtSkip,      /* FtCbls */
0x0B: parse_FtSkip,      /* FtRbo */
0x0C: parse_FtSkip,      /* FtSbs */
0x0D: parse_FtNts,       /* FtNts */
0x0E: parse_FtSkip,      /* FtSbsFmla */
0x0F: parse_FtSkip,      /* FtGboData */
0x10: parse_FtSkip,      /* FtEdoData */
0x11: parse_FtSkip,      /* FtRboData */
0x12: parse_FtSkip,      /* FtCblsData */
0x13: parse_FtSkip,      /* FtLbsData */
0x14: parse_FtSkip,      /* FtCblsFmla */
0x15: parse_FtCmo
};
function parse_FtArray(blob, length) {
	var tgt = blob.l + length;
	var fts = [];
	while(blob.l < tgt) {
		var ft = blob.read_shift(2);
		blob.l-=2;
		try {
			fts.push(FtTab[ft](blob, tgt - blob.l));
		} catch(e) { blob.l = tgt; return fts; }
	}
	if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
	return fts;
}

/* --- 2.4 Records --- */

/* [MS-XLS] 2.4.21 */
function parse_BOF(blob, length) {
	var o = {BIFFVer:0, dt:0};
	o.BIFFVer = blob.read_shift(2); length -= 2;
	if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
	switch(o.BIFFVer) {
		case 0x0600: /* BIFF8 */
		case 0x0500: /* BIFF5 */
		case 0x0400: /* BIFF4 */
		case 0x0300: /* BIFF3 */
		case 0x0200: /* BIFF2 */
		case 0x0002: case 0x0007: /* BIFF2 */
			break;
		default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
	}

	blob.read_shift(length);
	return o;
}
function write_BOF(wb, t, o) {
	var h = 0x0600, w = 16;
	switch(o.bookType) {
		case 'biff8': break;
		case 'biff5': h = 0x0500; w = 8; break;
		case 'biff4': h = 0x0004; w = 6; break;
		case 'biff3': h = 0x0003; w = 6; break;
		case 'biff2': h = 0x0002; w = 4; break;
		case 'xla': break;
		default: throw new Error("unsupported BIFF version");
	}
	var out = new_buf(w);
	out.write_shift(2, h);
	out.write_shift(2, t);
	if(w > 4) out.write_shift(2, 0x7262);
	if(w > 6) out.write_shift(2, 0x07CD);
	if(w > 8) {
		out.write_shift(2, 0xC009);
		out.write_shift(2, 0x0001);
		out.write_shift(2, 0x0706);
		out.write_shift(2, 0x0000);
	}
	return out;
}


/* [MS-XLS] 2.4.146 */
function parse_InterfaceHdr(blob, length) {
	if(length === 0) return 0x04b0;
	if((blob.read_shift(2))!==0x04b0){/* empty */}
	return 0x04b0;
}


/* [MS-XLS] 2.4.349 */
function parse_WriteAccess(blob, length, opts) {
	if(opts.enc) { blob.l += length; return ""; }
	var l = blob.l;
	// TODO: make sure XLUnicodeString doesnt overrun
	var UserName = parse_XLUnicodeString2(blob, 0, opts);
	blob.read_shift(length + l - blob.l);
	return UserName;
}
function write_WriteAccess(s, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(b8 ? 112 : 54);
	o.write_shift(opts.biff == 8 ? 2 : 1, 7);
	if(b8) o.write_shift(1, 0);
	o.write_shift(4, 0x33336853);
	o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
	while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
	return o;
}

/* [MS-XLS] 2.4.351 */
function parse_WsBool(blob, length, opts) {
	var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
	return { fDialog: flags & 0x10 };
}

/* [MS-XLS] 2.4.28 */
function parse_BoundSheet8(blob, length, opts) {
	var pos = blob.read_shift(4);
	var hidden = blob.read_shift(1) & 0x03;
	var dt = blob.read_shift(1);
	switch(dt) {
		case 0: dt = 'Worksheet'; break;
		case 1: dt = 'Macrosheet'; break;
		case 2: dt = 'Chartsheet'; break;
		case 6: dt = 'VBAModule'; break;
	}
	var name = parse_ShortXLUnicodeString(blob, 0, opts);
	if(name.length === 0) name = "Sheet1";
	return { pos:pos, hs:hidden, dt:dt, name:name };
}
function write_BoundSheet8(data, opts) {
	var w = (!opts || opts.biff >= 8 ? 2 : 1);
	var o = new_buf(8 + w * data.name.length);
	o.write_shift(4, data.pos);
	o.write_shift(1, data.hs || 0);
	o.write_shift(1, data.dt);
	o.write_shift(1, data.name.length);
	if(opts.biff >= 8) o.write_shift(1, 1);
	o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
	var out = o.slice(0, o.l);
	out.l = o.l; return out;
}

/* [MS-XLS] 2.4.265 TODO */
function parse_SST(blob, length) {
	var end = blob.l + length;
	var cnt = blob.read_shift(4);
	var ucnt = blob.read_shift(4);
	var strs = ([]);
	for(var i = 0; i != ucnt && blob.l < end; ++i) {
		strs.push(parse_XLUnicodeRichExtendedString(blob));
	}
	strs.Count = cnt; strs.Unique = ucnt;
	return strs;
}

/* [MS-XLS] 2.4.107 */
function parse_ExtSST(blob, length) {
	var extsst = {};
	extsst.dsst = blob.read_shift(2);
	blob.l += length-2;
	return extsst;
}


/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
function parse_Row(blob) {
	var z = ({});
	z.r = blob.read_shift(2);
	z.c = blob.read_shift(2);
	z.cnt = blob.read_shift(2) - z.c;
	var miyRw = blob.read_shift(2);
	blob.l += 4; // reserved(2), unused(2)
	var flags = blob.read_shift(1); // various flags
	blob.l += 3; // reserved(8), ixfe(12), flags(4)
	if(flags & 0x07) z.level = flags & 0x07;
	// collapsed: flags & 0x10
	if(flags & 0x20) z.hidden = true;
	if(flags & 0x40) z.hpt = miyRw / 20;
	return z;
}


/* [MS-XLS] 2.4.125 */
function parse_ForceFullCalculation(blob) {
	var header = parse_frtHeader(blob);
	if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
	var fullcalc = blob.read_shift(4);
	return fullcalc !== 0x0;
}





/* [MS-XLS] 2.4.215 rt */
function parse_RecalcId(blob) {
	blob.read_shift(2);
	return blob.read_shift(4);
}

/* [MS-XLS] 2.4.87 */
function parse_DefaultRowHeight(blob, length, opts) {
	var f = 0;
	if(!(opts && opts.biff == 2)) {
		f = blob.read_shift(2);
	}
	var miyRw = blob.read_shift(2);
	if((opts && opts.biff == 2)) {
		f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
	}
	var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
	return [fl, miyRw];
}

/* [MS-XLS] 2.4.345 TODO */
function parse_Window1(blob) {
	var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
	var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
	var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
	return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
		FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
}
function write_Window1() {
	var o = new_buf(18);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0x7260);
	o.write_shift(2, 0x44c0);
	o.write_shift(2, 0x38);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 1);
	o.write_shift(2, 0x01f4);
	return o;
}
/* [MS-XLS] 2.4.346 TODO */
function parse_Window2(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff < 8) return {};
	var f = blob.read_shift(2);
	return { RTL: f & 0x40 };
}
function write_Window2(view) {
	var o = new_buf(18), f = 0x6b6;
	if(view && view.RTL) f |= 0x40;
	o.write_shift(2, f);
	o.write_shift(4, 0);
	o.write_shift(4, 64);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLS] 2.4.122 TODO */
function parse_Font(blob, length, opts) {
	var o = {
		dyHeight: blob.read_shift(2),
		fl: blob.read_shift(2)
	};
	switch((opts && opts.biff) || 8) {
		case 2: break;
		case 3: case 4: blob.l += 2; break;
		default: blob.l += 10; break;
	}
	o.name = parse_ShortXLUnicodeString(blob, 0, opts);
	return o;
}
function write_Font(data, opts) {
	var name = data.name || "Arial";
	var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
	var o = new_buf(w);
	o.write_shift(2, (data.sz || 12) * 20);
	o.write_shift(4, 0);
	o.write_shift(2, 400);
	o.write_shift(4, 0);
	o.write_shift(2, 0);
	o.write_shift(1, name.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
	return o;
}

/* [MS-XLS] 2.4.149 */
function parse_LabelSst(blob) {
	var cell = parse_XLSCell(blob);
	cell.isst = blob.read_shift(4);
	return cell;
}

/* [MS-XLS] 2.4.148 */
function parse_Label(blob, length, opts) {
	var target = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) blob.l++;
	var str = parse_XLUnicodeString(blob, target - blob.l, opts);
	cell.val = str;
	return cell;
}
function write_Label(R, C, v, os, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
	write_XLSCell(R, C, os, o);
	o.write_shift(2, v.length);
	if(b8) o.write_shift(1, 1);
	o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
	return o;
}


/* [MS-XLS] 2.4.126 Number Formats */
function parse_Format(blob, length, opts) {
	var numFmtId = blob.read_shift(2);
	var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
	return [numFmtId, fmtstr];
}
function write_Format(i, f, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
	o.write_shift(2, i);
	o.write_shift((b5 ? 1 : 2), f.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(out.l == null) out.l = out.length;
	return out;
}
var parse_BIFF2Format = parse_XLUnicodeString2;

/* [MS-XLS] 2.4.90 */
function parse_Dimensions(blob, length, opts) {
	var end = blob.l + length;
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var r = blob.read_shift(w), R = blob.read_shift(w);
	var c = blob.read_shift(2), C = blob.read_shift(2);
	blob.l = end;
	return {s: {r:r, c:c}, e: {r:R, c:C}};
}
function write_Dimensions(range, opts) {
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var o = new_buf(2*w + 6);
	o.write_shift(w, range.s.r);
	o.write_shift(w, range.e.r + 1);
	o.write_shift(2, range.s.c);
	o.write_shift(2, range.e.c + 1);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.220 */
function parse_RK(blob) {
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrec = parse_RkRec(blob);
	return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
}

/* [MS-XLS] 2.4.175 */
function parse_MulRk(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrecs = [];
	while(blob.l < target) rkrecs.push(parse_RkRec(blob));
	if(blob.l !== target) throw new Error("MulRK read error");
	var lastcol = blob.read_shift(2);
	if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
	return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
}
/* [MS-XLS] 2.4.174 */
function parse_MulBlank(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var ixfes = [];
	while(blob.l < target) ixfes.push(blob.read_shift(2));
	if(blob.l !== target) throw new Error("MulBlank read error");
	var lastcol = blob.read_shift(2);
	if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
	return {r:rw, c:col, C:lastcol, ixfe:ixfes};
}

/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
function parse_CellStyleXF(blob, length, style, opts) {
	var o = {};
	var a = blob.read_shift(4), b = blob.read_shift(4);
	var c = blob.read_shift(4), d = blob.read_shift(2);
	o.patternType = XLSFillPattern[c >> 26];

	if(!opts.cellStyles) return o;
	o.alc = a & 0x07;
	o.fWrap = (a >> 3) & 0x01;
	o.alcV = (a >> 4) & 0x07;
	o.fJustLast = (a >> 7) & 0x01;
	o.trot = (a >> 8) & 0xFF;
	o.cIndent = (a >> 16) & 0x0F;
	o.fShrinkToFit = (a >> 20) & 0x01;
	o.iReadOrder = (a >> 22) & 0x02;
	o.fAtrNum = (a >> 26) & 0x01;
	o.fAtrFnt = (a >> 27) & 0x01;
	o.fAtrAlc = (a >> 28) & 0x01;
	o.fAtrBdr = (a >> 29) & 0x01;
	o.fAtrPat = (a >> 30) & 0x01;
	o.fAtrProt = (a >> 31) & 0x01;

	o.dgLeft = b & 0x0F;
	o.dgRight = (b >> 4) & 0x0F;
	o.dgTop = (b >> 8) & 0x0F;
	o.dgBottom = (b >> 12) & 0x0F;
	o.icvLeft = (b >> 16) & 0x7F;
	o.icvRight = (b >> 23) & 0x7F;
	o.grbitDiag = (b >> 30) & 0x03;

	o.icvTop = c & 0x7F;
	o.icvBottom = (c >> 7) & 0x7F;
	o.icvDiag = (c >> 14) & 0x7F;
	o.dgDiag = (c >> 21) & 0x0F;

	o.icvFore = d & 0x7F;
	o.icvBack = (d >> 7) & 0x7F;
	o.fsxButton = (d >> 14) & 0x01;
	return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}

/* [MS-XLS] 2.4.353 TODO: actually do this right */
function parse_XF(blob, length, opts) {
	var o = {};
	o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
	o.fStyle = (o.flags >> 2) & 0x01;
	length -= 6;
	o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
	return o;
}
function write_XF(data, ixfeP, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? 16 : 20);
	o.write_shift(2, 0);
	if(data.style) {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, 0xFFF4);
	} else {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, (ixfeP<<4));
	}
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	if(!b5) o.write_shift(4, 0);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.134 */
function parse_Guts(blob) {
	blob.l += 4;
	var out = [blob.read_shift(2), blob.read_shift(2)];
	if(out[0] !== 0) out[0]--;
	if(out[1] !== 0) out[1]--;
	if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
	return out;
}
function write_Guts(guts) {
	var o = new_buf(8);
	o.write_shift(4, 0);
	o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
	o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
	return o;
}

/* [MS-XLS] 2.4.24 */
function parse_BoolErr(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_Bes(blob, 2);
	cell.val = val;
	cell.t = (val === true || val === false) ? 'b' : 'e';
	return cell;
}
function write_BoolErr(R, C, v, os, opts, t) {
	var o = new_buf(8);
	write_XLSCell(R, C, os, o);
	write_Bes(v, t, o);
	return o;
}

/* [MS-XLS] 2.4.180 Number */
function parse_Number(blob) {
	var cell = parse_XLSCell(blob, 6);
	var xnum = parse_Xnum(blob, 8);
	cell.val = xnum;
	return cell;
}
function write_Number(R, C, v, os) {
	var o = new_buf(14);
	write_XLSCell(R, C, os, o);
	write_Xnum(v, o);
	return o;
}

var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136

/* [MS-XLS] 2.4.271 */
function parse_SupBook(blob, length, opts) {
	var end = blob.l + length;
	var ctab = blob.read_shift(2);
	var cch = blob.read_shift(2);
	opts.sbcch = cch;
	if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
	if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
	var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
	/* TODO: 2.5.277 Virtual Path */
	var rgst = [];
	while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
	return [cch, ctab, virtPath, rgst];
}

/* [MS-XLS] 2.4.105 TODO */
function parse_ExternName(blob, length, opts) {
	var flags = blob.read_shift(2);
	var body;
	var o = ({
		fBuiltIn: flags & 0x01,
		fWantAdvise: (flags >>> 1) & 0x01,
		fWantPict: (flags >>> 2) & 0x01,
		fOle: (flags >>> 3) & 0x01,
		fOleLink: (flags >>> 4) & 0x01,
		cf: (flags >>> 5) & 0x3FF,
		fIcon: flags >>> 15 & 0x01
	});
	if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
	//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
	o.body = body || blob.read_shift(length-2);
	if(typeof body === "string") o.Name = body;
	return o;
}

/* [MS-XLS] 2.4.150 TODO */
var XLSLblBuiltIn = [
	"_xlnm.Consolidate_Area",
	"_xlnm.Auto_Open",
	"_xlnm.Auto_Close",
	"_xlnm.Extract",
	"_xlnm.Database",
	"_xlnm.Criteria",
	"_xlnm.Print_Area",
	"_xlnm.Print_Titles",
	"_xlnm.Recorder",
	"_xlnm.Data_Form",
	"_xlnm.Auto_Activate",
	"_xlnm.Auto_Deactivate",
	"_xlnm.Sheet_Title",
	"_xlnm._FilterDatabase"
];
function parse_Lbl(blob, length, opts) {
	var target = blob.l + length;
	var flags = blob.read_shift(2);
	var chKey = blob.read_shift(1);
	var cch = blob.read_shift(1);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var itab = 0;
	if(!opts || opts.biff >= 5) {
		if(opts.biff != 5) blob.l += 2;
		itab = blob.read_shift(2);
		if(opts.biff == 5) blob.l += 2;
		blob.l += 4;
	}
	var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
	if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
	var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
	var rgce = target == blob.l || cce === 0 ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
	return {
		chKey: chKey,
		Name: name,
		itab: itab,
		rgce: rgce
	};
}

/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
function parse_ExternSheet(blob, length, opts) {
	if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
	var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
	while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
		// [iSupBook, itabFirst, itabLast];
	if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
	return o;
}
function parse_BIFF5ExternSheet(blob, length, opts) {
	if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
	var o = parse_ShortXLUnicodeString(blob, length, opts);
	return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}

/* [MS-XLS] 2.4.176 TODO: check older biff */
function parse_NameCmt(blob, length, opts) {
	if(opts.biff < 8) { blob.l += length; return; }
	var cchName = blob.read_shift(2);
	var cchComment = blob.read_shift(2);
	var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
	var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
	return [name, comment];
}

/* [MS-XLS] 2.4.260 */
function parse_ShrFmla(blob, length, opts) {
	var ref = parse_RefU(blob, 6);
	blob.l++;
	var cUse = blob.read_shift(1);
	length -= 8;
	return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
}

/* [MS-XLS] 2.4.4 TODO */
function parse_Array(blob, length, opts) {
	var ref = parse_Ref(blob, 6);
	/* TODO: fAlwaysCalc */
	switch(opts.biff) {
		case 2: blob.l ++; length -= 7; break;
		case 3: case 4: blob.l += 2; length -= 8; break;
		default: blob.l += 6; length -= 12;
	}
	return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
}

/* [MS-XLS] 2.4.173 */
function parse_MTRSettings(blob) {
	var fMTREnabled = blob.read_shift(4) !== 0x00;
	var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
	var cUserThreadCount = blob.read_shift(4);
	return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
}

/* [MS-XLS] 2.5.186 TODO: BIFF5 */
function parse_NoteSh(blob, length, opts) {
	if(opts.biff < 8) return;
	var row = blob.read_shift(2), col = blob.read_shift(2);
	var flags = blob.read_shift(2), idObj = blob.read_shift(2);
	var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
	if(opts.biff < 8) blob.read_shift(1);
	return [{r:row,c:col}, stAuthor, idObj, flags];
}

/* [MS-XLS] 2.4.179 */
function parse_Note(blob, length, opts) {
	/* TODO: Support revisions */
	return parse_NoteSh(blob, length, opts);
}

/* [MS-XLS] 2.4.168 */
function parse_MergeCells(blob, length) {
	var merges = [];
	var cmcs = blob.read_shift(2);
	while (cmcs--) merges.push(parse_Ref8U(blob,length));
	return merges;
}
function write_MergeCells(merges) {
	var o = new_buf(2 + merges.length * 8);
	o.write_shift(2, merges.length);
	for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
	return o;
}

/* [MS-XLS] 2.4.181 TODO: parse all the things! */
function parse_Obj(blob, length, opts) {
	if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
	var cmo = parse_FtCmo(blob, 22); // id, ot, flags
	var fts = parse_FtArray(blob, length-22, cmo[1]);
	return { cmo: cmo, ft:fts };
}
/* from older spec */
var parse_BIFF5OT = [];
parse_BIFF5OT[0x08] = function(blob, length) {
	var tgt = blob.l + length;
	blob.l += 10; // todo
	var cf = blob.read_shift(2);
	blob.l += 4;
	blob.l += 2; //var cbPictFmla = blob.read_shift(2);
	blob.l += 2;
	blob.l += 2; //var grbit = blob.read_shift(2);
	blob.l += 4;
	var cchName = blob.read_shift(1);
	blob.l += cchName; // TODO: stName
	blob.l = tgt; // TODO: fmla
	return { fmt:cf };
};

function parse_BIFF5Obj(blob, length, opts) {
	blob.l += 4; //var cnt = blob.read_shift(4);
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var grbit = blob.read_shift(2);
	blob.l += 2; //var colL = blob.read_shift(2);
	blob.l += 2; //var dxL = blob.read_shift(2);
	blob.l += 2; //var rwT = blob.read_shift(2);
	blob.l += 2; //var dyT = blob.read_shift(2);
	blob.l += 2; //var colR = blob.read_shift(2);
	blob.l += 2; //var dxR = blob.read_shift(2);
	blob.l += 2; //var rwB = blob.read_shift(2);
	blob.l += 2; //var dyB = blob.read_shift(2);
	blob.l += 2; //var cbMacro = blob.read_shift(2);
	blob.l += 6;
	length -= 36;
	var fts = [];
	fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
	return { cmo: [id, ot, grbit], ft:fts };
}

/* [MS-XLS] 2.4.329 TODO: parse properly */
function parse_TxO(blob, length, opts) {
	var s = blob.l;
	var texts = "";
try {
	blob.l += 4;
	var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
	var controlInfo; // eslint-disable-line no-unused-vars
	if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
	else controlInfo = parse_ControlInfo(blob, 6, opts);
	var cchText = blob.read_shift(2);
	/*var cbRuns = */blob.read_shift(2);
	/*var ifntEmpty = */parseuint16(blob, 2);
	var len = blob.read_shift(2);
	blob.l += len;
	//var fmla = parse_ObjFmla(blob, s + length - blob.l);

	for(var i = 1; i < blob.lens.length-1; ++i) {
		if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
		var hdr = blob[blob.l];
		var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
		texts += t;
		if(texts.length >= (hdr ? cchText : 2*cchText)) break;
	}
	if(texts.length !== cchText && texts.length !== cchText*2) {
		throw new Error("cchText: " + cchText + " != " + texts.length);
	}

	blob.l = s + length;
	/* [MS-XLS] 2.5.272 TxORuns */
//	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
	return { t: texts };
} catch(e) { blob.l = s + length; return { t: texts }; }
}

/* [MS-XLS] 2.4.140 */
function parse_HLink(blob, length) {
	var ref = parse_Ref8U(blob, 8);
	blob.l += 16; /* CLSID */
	var hlink = parse_Hyperlink(blob, length-24);
	return [ref, hlink];
}
function write_HLink(hl) {
	var O = new_buf(24);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
	for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
	return bconcat([O, write_Hyperlink(hl[1])]);
}


/* [MS-XLS] 2.4.141 */
function parse_HLinkTooltip(blob, length) {
	blob.read_shift(2);
	var ref = parse_Ref8U(blob, 8);
	var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
	wzTooltip = wzTooltip.replace(chr0,"");
	return [ref, wzTooltip];
}
function write_HLinkTooltip(hl) {
	var TT = hl[1].Tooltip;
	var O = new_buf(10 + 2 * (TT.length + 1));
	O.write_shift(2, 0x0800);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
	O.write_shift(2, 0);
	return O;
}

/* [MS-XLS] 2.4.63 */
function parse_Country(blob) {
	var o = [0,0], d;
	d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
	d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
	return o;
}
function write_Country(o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, 0x01);
	o.write_shift(2, 0x01);
	return o;
}

/* [MS-XLS] 2.4.50 ClrtClient */
function parse_ClrtClient(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.188 */
function parse_Palette(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob, 8));
	return o;
}

/* [MS-XLS] 2.4.354 */
function parse_XFCRC(blob) {
	blob.l += 2;
	var o = {cxfs:0, crc:0};
	o.cxfs = blob.read_shift(2);
	o.crc = blob.read_shift(4);
	return o;
}

/* [MS-XLS] 2.4.53 TODO: parse flags */
/* [MS-XLSB] 2.4.323 TODO: parse flags */
function parse_ColInfo(blob, length, opts) {
	if(!opts.cellStyles) return parsenoop(blob, length);
	var w = opts && opts.biff >= 12 ? 4 : 2;
	var colFirst = blob.read_shift(w);
	var colLast = blob.read_shift(w);
	var coldx = blob.read_shift(w);
	var ixfe = blob.read_shift(w);
	var flags = blob.read_shift(2);
	if(w == 2) blob.l += 2;
	return {s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags};
}

/* [MS-XLS] 2.4.257 */
function parse_Setup(blob, length) {
	var o = {};
	if(length < 32) return o;
	blob.l += 16;
	o.header = parse_Xnum(blob, 8);
	o.footer = parse_Xnum(blob, 8);
	blob.l += 2;
	return o;
}

/* [MS-XLS] 2.4.261 */
function parse_ShtProps(blob, length, opts) {
	var def = {area:false};
	if(opts.biff != 5) { blob.l += length; return def; }
	var d = blob.read_shift(1); blob.l += 3;
	if((d & 0x10)) def.area = true;
	return def;
}

/* [MS-XLS] 2.4.241 */
function write_RRTabId(n) {
	var out = new_buf(2 * n);
	for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
	return out;
}

var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */

/* --- Specific to versions before BIFF8 --- */
function parse_ImData(blob) {
	var cf = blob.read_shift(2);
	var env = blob.read_shift(2);
	var lcb = blob.read_shift(4);
	var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
	blob.l += lcb;
	return o;
}

/* BIFF2_??? where ??? is the name from [XLS] */
function parse_BIFF2STR(blob, length, opts) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var str = parse_XLUnicodeString2(blob, length-7, opts);
	cell.t = 'str';
	cell.val = str;
	return cell;
}

function parse_BIFF2NUM(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = parse_Xnum(blob, 8);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2NUM(r, c, val) {
	var out = new_buf(15);
	write_BIFF2Cell(out, r, c);
	out.write_shift(8, val, 'f');
	return out;
}

function parse_BIFF2INT(blob) {
	var cell = parse_XLSCell(blob, 6);
	++blob.l;
	var num = blob.read_shift(2);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2INT(r, c, val) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	out.write_shift(2, val);
	return out;
}

function parse_BIFF2STRING(blob) {
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, 'sbcs-cont');
}

/* TODO: convert to BIFF8 font struct */
function parse_BIFF2FONTXTRA(blob, length) {
	blob.l += 6; // unknown
	blob.l += 2; // font weight "bls"
	blob.l += 1; // charset
	blob.l += 3; // unknown
	blob.l += 1; // font family
	blob.l += length - 13;
}

/* TODO: parse rich text runs */
function parse_RString(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	var cch = blob.read_shift(2);
	var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
	blob.l = end;
	cell.t = 'str';
	cell.val = str;
	return cell;
}
/* from js-harb (C) 2014-present  SheetJS */
var DBF = (function() {
var dbf_codepage_map = {
	/* Code Pages Supported by Visual FoxPro */
0x01:   437,           0x02:   850,
0x03:  1252,           0x04: 10000,
0x64:   852,           0x65:   866,
0x66:   865,           0x67:   861,
0x68:   895,           0x69:   620,
0x6A:   737,           0x6B:   857,
0x78:   950,           0x79:   949,
0x7A:   936,           0x7B:   932,
0x7C:   874,           0x7D:  1255,
0x7E:  1256,           0x96: 10007,
0x97: 10029,           0x98: 10006,
0xC8:  1250,           0xC9:  1251,
0xCA:  1254,           0xCB:  1253,

	/* shapefile DBF extension */
0x00: 20127,           0x08:   865,
0x09:   437,           0x0A:   850,
0x0B:   437,           0x0D:   437,
0x0E:   850,           0x0F:   437,
0x10:   850,           0x11:   437,
0x12:   850,           0x13:   932,
0x14:   850,           0x15:   437,
0x16:   850,           0x17:   865,
0x18:   437,           0x19:   437,
0x1A:   850,           0x1B:   437,
0x1C:   863,           0x1D:   850,
0x1F:   852,           0x22:   852,
0x23:   852,           0x24:   860,
0x25:   850,           0x26:   866,
0x37:   850,           0x40:   852,
0x4D:   936,           0x4E:   949,
0x4F:   950,           0x50:   874,
0x57:  1252,           0x58:  1252,
0x59:  1252,

0xFF: 16969
};

/* TODO: find an actual specification */
function dbf_to_aoa(buf, opts) {
	var out = [];
	/* TODO: browser based */
	var d = (new_raw_buf(1));
	switch(opts.type) {
		case 'base64': d = s2a(Base64.decode(buf)); break;
		case 'binary': d = s2a(buf); break;
		case 'buffer':
		case 'array': d = buf; break;
	}
	prep_blob(d, 0);
	/* header */
	var ft = d.read_shift(1);
	var memo = false;
	var vfp = false, l7 = false;
	switch(ft) {
		case 0x02: case 0x03: break;
		case 0x30: vfp = true; memo = true; break;
		case 0x31: vfp = true; break;
		case 0x83: memo = true; break;
		case 0x8B: memo = true; break;
		case 0x8C: memo = true; l7 = true; break;
		case 0xF5: memo = true; break;
		default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
	}
	var /*filedate = new Date(),*/ nrow = 0, fpos = 0;
	if(ft == 0x02) nrow = d.read_shift(2);
	/*filedate = new Date(d.read_shift(1) + 1900, d.read_shift(1) - 1, d.read_shift(1));*/d.l += 3;
	if(ft != 0x02) nrow = d.read_shift(4);
	if(ft != 0x02) fpos = d.read_shift(2);
	var rlen = d.read_shift(2);

	var /*flags = 0,*/ current_cp = 1252;
	if(ft != 0x02) {
	d.l+=16;
	/*flags = */d.read_shift(1);
	//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));

	/* codepage present in FoxPro */
	if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
	d.l+=1;

	d.l+=2;
	}
	if(l7) d.l += 36;
var fields = [], field = ({});
	var hend = fpos - 10 - (vfp ? 264 : 0), ww = l7 ? 32 : 11;
	while(ft == 0x02 ? d.l < d.length && d[d.l] != 0x0d: d.l < hend) {
		field = ({});
		field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
		d.l += ww;
		field.type = String.fromCharCode(d.read_shift(1));
		if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
		field.len = d.read_shift(1);
		if(ft == 0x02) field.offset = d.read_shift(2);
		field.dec = d.read_shift(1);
		if(field.name.length) fields.push(field);
		if(ft != 0x02) d.l += l7 ? 13 : 14;
		switch(field.type) {
			case 'B': // VFP Double
				if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'G': // General
			case 'P': // Picture
				if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'C': // character
			case 'D': // date
			case 'F': // floating point
			case 'I': // long
			case 'L': // boolean
			case 'M': // memo
			case 'N': // number
			case 'O': // double
			case 'T': // datetime
			case 'Y': // currency
			case '0': // VFP _NullFlags
			case '@': // timestamp
			case '+': // autoincrement
				break;
			default: throw new Error('Unknown Field Type: ' + field.type);
		}
	}
	if(d[d.l] !== 0x0D) d.l = fpos-1;
	else if(ft == 0x02) d.l = 0x209;
	if(ft != 0x02) {
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	}
	/* data */
	var R = 0, C = 0;
	out[0] = [];
	for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
	while(nrow-- > 0) {
		if(d[d.l] === 0x2A) { d.l+=rlen; continue; }
		++d.l;
		out[++R] = []; C = 0;
		for(C = 0; C != fields.length; ++C) {
			var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
			prep_blob(dd, 0);
			var s = cptable.utils.decode(current_cp, dd);
			switch(fields[C].type) {
				case 'C':
					out[R][C] = cptable.utils.decode(current_cp, dd);
					out[R][C] = out[R][C].trim();
					break;
				case 'D':
					if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
					else out[R][C] = s;
					break;
				case 'F': out[R][C] = parseFloat(s.trim()); break;
				case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
				case 'L': switch(s.toUpperCase()) {
					case 'Y': case 'T': out[R][C] = true; break;
					case 'N': case 'F': out[R][C] = false; break;
					case ' ': case '?': out[R][C] = false; break; /* NOTE: technically uninitialized */
					default: throw new Error("DBF Unrecognized L:|" + s + "|");
					} break;
				case 'M': /* TODO: handle memo files */
					if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
					out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
					break;
				case 'N': out[R][C] = +s.replace(/\u0000/g,"").trim(); break;
				case '@': out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400); break;
				case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
				case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4; break;
				case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
				case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
					/* falls through */
				case 'G': case 'P': dd.l += fields[C].len; break;
				case '0':
					if(fields[C].name === '_NullFlags') break;
					/* falls through */
				default: throw new Error("DBF Unsupported data type " + fields[C].type);
			}
		}
	}
	if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
	if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
	return out;
}

function dbf_to_sheet(buf, opts) {
	var o = opts || {};
	if(!o.dateNF) o.dateNF = "yyyymmdd";
	return aoa_to_sheet(dbf_to_aoa(buf, o), o);
}

function dbf_to_workbook(buf, opts) {
	try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
	catch(e) { if(opts && opts.WTF) throw e; }
	return ({SheetNames:[],Sheets:{}});
}

var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
function sheet_to_dbf(ws, opts) {
	var o = opts || {};
	if(o.type == "string") throw new Error("Cannot write DBF to JS string");
	var ba = buf_array();
	var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
	var headers = aoa[0], data = aoa.slice(1);
	var i = 0, j = 0, hcnt = 0, rlen = 1;
	for(i = 0; i < headers.length; ++i) {
		if(i == null) continue;
		++hcnt;
		if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
		if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
		if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
			if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
	}
	var range = safe_decode_range(ws['!ref']);
	var coltypes = [];
	for(i = 0; i <= range.e.c - range.s.c; ++i) {
		var col = [];
		for(j=0; j < data.length; ++j) {
			if(data[j][i] != null) col.push(data[j][i]);
		}
		if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
		var guess = '', _guess = '';
		for(j = 0; j < col.length; ++j) {
			switch(typeof col[j]) {
				/* TODO: check if L2 compat is desired */
				case 'number': _guess = 'B'; break;
				case 'string': _guess = 'C'; break;
				case 'boolean': _guess = 'L'; break;
				case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
				default: _guess = 'C';
			}
			guess = guess && guess != _guess ? 'C' : _guess;
			if(guess == 'C') break;
		}
		rlen += _RLEN[guess] || 0;
		coltypes[i] = guess;
	}

	var h = ba.next(32);
	h.write_shift(4, 0x13021130);
	h.write_shift(4, data.length);
	h.write_shift(2, 296 + 32 * hcnt);
	h.write_shift(2, rlen);
	for(i=0; i < 4; ++i) h.write_shift(4, 0);
	h.write_shift(4, 0x00000300); // TODO: CP

	for(i = 0, j = 0; i < headers.length; ++i) {
		if(headers[i] == null) continue;
		var hf = ba.next(32);
		var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
		hf.write_shift(1, _f, "sbcs");
		hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
		hf.write_shift(4, j);
		hf.write_shift(1, _RLEN[coltypes[i]] || 0);
		hf.write_shift(1, 0);
		hf.write_shift(1, 0x02);
		hf.write_shift(4, 0);
		hf.write_shift(1, 0);
		hf.write_shift(4, 0);
		hf.write_shift(4, 0);
		j += _RLEN[coltypes[i]] || 0;
	}

	var hb = ba.next(264);
	hb.write_shift(4, 0x0000000D);
	for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
	for(i=0; i < data.length; ++i) {
		var rout = ba.next(rlen);
		rout.write_shift(1, 0);
		for(j=0; j<headers.length; ++j) {
			if(headers[j] == null) continue;
			switch(coltypes[j]) {
				case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
				case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
				case 'D':
					if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
					else {
						rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
						rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
						rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
					} break;
				case 'C':
					var _s = String(data[i][j]||"");
					rout.write_shift(1, _s, "sbcs");
					for(hcnt=0; hcnt < 250-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
			}
		}
		// data
	}
	ba.next(1).write_shift(1, 0x1A);
	return ba.end();
}
	return {
		to_workbook: dbf_to_workbook,
		to_sheet: dbf_to_sheet,
		from_sheet: sheet_to_dbf
	};
})();

var SYLK = (function() {
	/* TODO: find an actual specification */
	function sylk_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return sylk_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return sylk_to_aoa_str(d, opts);
			case 'buffer': return sylk_to_aoa_str(d.toString('binary'), opts);
			case 'array': return sylk_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function sylk_to_aoa_str(str, opts) {
		var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
		var formats = [];
		var next_cell_format = null;
		var sht = {}, rowinfo = [], colinfo = [], cw = [];
		var Mval = 0, j;
		for (; ri !== records.length; ++ri) {
			Mval = 0;
			var rstr=records[ri].trim();
			var record=rstr.replace(/;;/g, "\u0001").split(";").map(function(x) { return x.replace(/\u0001/g, ";"); });
			var RT=record[0], val;
			if(rstr.length > 0) switch(RT) {
			case 'ID': break; /* header */
			case 'E': break; /* EOF */
			case 'B': break; /* dimensions */
			case 'O': break; /* options? */
			case 'P':
				if(record[1].charAt(0) == 'P')
					formats.push(rstr.slice(3).replace(/;;/g, ";"));
				break;
			case 'C':
			var C_seen_K = false, C_seen_X = false;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'K':
					val = record[rj].slice(1);
					if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
					else if(val === 'TRUE') val = true;
					else if(val === 'FALSE') val = false;
					else if(!isNaN(fuzzynum(val))) {
						val = fuzzynum(val);
						if(next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
					} else if(!isNaN(fuzzydate(val).getDate())) {
						val = parseDate(val);
					}
					if(typeof cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = cptable.utils.decode(opts.codepage, val);
					C_seen_K = true;
					break;
				case 'E':
					var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
					arr[R][C] = [arr[R][C], formula];
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(C_seen_K) { arr[R][C] = val; next_cell_format = null; }
			break;
			case 'F':
			var F_seen = 0;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
				case 'F': break; /* ??? */
				case 'G': break; /* hide grid */
				case 'P':
					next_cell_format = formats[parseInt(record[rj].slice(1))];
					break;
				case 'S': break; /* cell style */
				case 'D': break; /* column */
				case 'N': break; /* font */
				case 'W':
					cw = record[rj].slice(1).split(" ");
					for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
						Mval = parseInt(cw[2], 10);
						colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
					} break;
				case 'C': /* default column format */
					C = parseInt(record[rj].slice(1))-1;
					if(!colinfo[C]) colinfo[C] = {};
					break;
				case 'R': /* row properties */
					R = parseInt(record[rj].slice(1))-1;
					if(!rowinfo[R]) rowinfo[R] = {};
					if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
					else if(Mval === 0) rowinfo[R].hidden = true;
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(F_seen < 1) next_cell_format = null; break;
			default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
		}
		if(rowinfo.length > 0) sht['!rows'] = rowinfo;
		if(colinfo.length > 0) sht['!cols'] = colinfo;
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return [arr, sht];
	}

	function sylk_to_sheet(d, opts) {
		var aoasht = sylk_to_aoa(d, opts);
		var aoa = aoasht[0], ws = aoasht[1];
		var o = aoa_to_sheet(aoa, opts);
		keys(ws).forEach(function(k) { o[k] = ws[k]; });
		return o;
	}

	function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }

	function write_ws_cell_sylk(cell, ws, R, C) {
		var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
		switch(cell.t) {
			case 'n':
				o += (cell.v||0);
				if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
			case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
			case 'e': o += cell.w || cell.v; break;
			case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
			case 's': o += '"' + cell.v.replace(/"/g,"") + '"'; break;
		}
		return o;
	}

	function write_ws_cols_sylk(out, cols) {
		cols.forEach(function(col, i) {
			var rec = "F;W" + (i+1) + " " + (i+1) + " ";
			if(col.hidden) rec += "0";
			else {
				if(typeof col.width == 'number') col.wpx = width2px(col.width);
				if(typeof col.wpx == 'number') col.wch = px2char(col.wpx);
				if(typeof col.wch == 'number') rec += Math.round(col.wch);
			}
			if(rec.charAt(rec.length - 1) != " ") out.push(rec);
		});
	}

	function write_ws_rows_sylk(out, rows) {
		rows.forEach(function(row, i) {
			var rec = "F;";
			if(row.hidden) rec += "M0;";
			else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
			else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
			if(rec.length > 2) out.push(rec + "R" + (i+1));
		});
	}

	function sheet_to_sylk(ws, opts) {
		var preamble = ["ID;PWXL;N;E"], o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		var RS = "\r\n";

		preamble.push("P;PGeneral");
		preamble.push("F;P0;DG0G8;M255");
		if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
		if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);

		preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
				o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
			}
		}
		return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
	}

	return {
		to_workbook: sylk_to_workbook,
		to_sheet: sylk_to_sheet,
		from_sheet: sheet_to_sylk
	};
})();

var DIF = (function() {
	function dif_to_aoa(d, opts) {
		switch(opts.type) {
			case 'base64': return dif_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return dif_to_aoa_str(d, opts);
			case 'buffer': return dif_to_aoa_str(d.toString('binary'), opts);
			case 'array': return dif_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function dif_to_aoa_str(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
			if (R < 0) continue;
			var metadata = records[ri].trim().split(",");
			var type = metadata[0], value = metadata[1];
			++ri;
			var data = records[ri].trim();
			switch (+type) {
				case -1:
					if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
					else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
					break;
				case 0:
					if(data === 'TRUE') arr[R][C] = true;
					else if(data === 'FALSE') arr[R][C] = false;
					else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
					else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
					else arr[R][C] = value;
					++C; break;
				case 1:
					data = data.slice(1,data.length-1);
					arr[R][C++] = data !== '' ? data : null;
					break;
			}
			if (data === 'EOD') break;
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
	function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }

	var sheet_to_dif = (function() {
		var push_field = function pf(o, topic, v, n, s) {
			o.push(topic);
			o.push(v + "," + n);
			o.push('"' + s.replace(/"/g,'""') + '"');
		};
		var push_value = function po(o, type, v, s) {
			o.push(type + "," + v);
			o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
		};
		return function sheet_to_dif(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			push_field(o, "TABLE", 0, 1, "sheetjs");
			push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
			push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
			push_field(o, "DATA", 0, 0,"");
			for(var R = r.s.r; R <= r.e.r; ++R) {
				push_value(o, -1, 0, "BOT");
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell) { push_value(o, 1, 0, ""); continue;}
					switch(cell.t) {
						case 'n':
							var val = DIF_XL ? cell.w : cell.v;
							if(!val && cell.v != null) val = cell.v;
							if(val == null) {
								if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
								else push_value(o, 1, 0, "");
							}
							else push_value(o, 0, val, "V");
							break;
						case 'b':
							push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
							break;
						case 's':
							push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
							break;
						case 'd':
							if(!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
							if(DIF_XL) push_value(o, 0, cell.w, "V");
							else push_value(o, 1, 0, cell.w);
							break;
						default: push_value(o, 1, 0, "");
					}
				}
			}
			push_value(o, -1, 0, "EOD");
			var RS = "\r\n";
			var oo = o.join(RS);
			//while((oo.length & 0x7F) != 0) oo += "\0";
			return oo;
		};
	})();
	return {
		to_workbook: dif_to_workbook,
		to_sheet: dif_to_sheet,
		from_sheet: sheet_to_dif
	};
})();

var ETH = (function() {
	function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
	function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }

	function eth_to_aoa(str, opts) {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
		for (; ri !== records.length; ++ri) {
			var record = records[ri].trim().split(":");
			if(record[0] !== 'cell') continue;
			var addr = decode_cell(record[1]);
			if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
			R = addr.r; C = addr.c;
			switch(record[2]) {
				case 't': arr[R][C] = decode(record[3]); break;
				case 'v': arr[R][C] = +record[3]; break;
				case 'vtf': var _f = record[record.length - 1];
					/* falls through */
				case 'vtc':
					switch(record[3]) {
						case 'nl': arr[R][C] = +record[4] ? true : false; break;
						default: arr[R][C] = +record[4]; break;
					}
					if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
			}
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
	function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }

	var header = [
		"socialcalc:version:1.5",
		"MIME-Version: 1.0",
		"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
	].join("\n");

	var sep = [
		"--SocialCalcSpreadsheetControlSave",
		"Content-type: text/plain; charset=UTF-8"
	].join("\n") + "\n";

	/* TODO: the other parts */
	var meta = [
		"# SocialCalc Spreadsheet Control Save",
		"part:sheet"
	].join("\n");

	var end = "--SocialCalcSpreadsheetControlSave--";

	function sheet_to_eth_data(ws) {
		if(!ws || !ws['!ref']) return "";
		var o = [], oo = [], cell, coord = "";
		var r = decode_range(ws['!ref']);
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null || cell.t === 'z') continue;
				oo = ["cell", coord, 't'];
				switch(cell.t) {
					case 's': case 'str': oo.push(encode(cell.v)); break;
					case 'n':
						if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
						else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
						break;
					case 'b':
						oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
						oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
						break;
					case 'd':
						var t = datenum(parseDate(cell.v));
						oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
						oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
						break;
					case 'e': continue;
				}
				o.push(oo.join(":"));
			}
		}
		o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
		o.push("valueformat:1:text-wiki");
		//o.push("copiedfrom:" + ws['!ref']); // clipboard only
		return o.join("\n");
	}

	function sheet_to_eth(ws) {
		return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
		// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
	}

	return {
		to_workbook: eth_to_workbook,
		to_sheet: eth_to_sheet,
		from_sheet: sheet_to_eth
	};
})();

var PRN = (function() {
	function set_text_arr(data, arr, R, C, o) {
		if(o.raw) arr[R][C] = data;
		else if(data === 'TRUE') arr[R][C] = true;
		else if(data === 'FALSE') arr[R][C] = false;
		else if(data === ""){/* empty */}
		else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
		else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
		else arr[R][C] = data;
	}

	function prn_to_aoa_str(f, opts) {
		var o = opts || {};
		var arr = ([]);
		if(!f || f.length === 0) return arr;
		var lines = f.split(/[\r\n]/);
		var L = lines.length - 1;
		while(L >= 0 && lines[L].length === 0) --L;
		var start = 10, idx = 0;
		var R = 0;
		for(; R <= L; ++R) {
			idx = lines[R].indexOf(" ");
			if(idx == -1) idx = lines[R].length; else idx++;
			start = Math.max(start, idx);
		}
		for(R = 0; R <= L; ++R) {
			arr[R] = [];
			/* TODO: confirm that widths are always 10 */
			var C = 0;
			set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
			for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
				set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
		}
		if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
		return arr;
	}

	// List of accepted CSV separators
	var guess_seps = {
0x2C: ',',
0x09: "\t",
0x3B: ';'
	};

	// CSV separator weights to be used in case of equal numbers
	var guess_sep_weights = {
0x2C: 3,
0x09: 2,
0x3B: 1
	};

	function guess_sep(str) {
		var cnt = {}, instr = false, end = 0, cc = 0;
		for(;end < str.length;++end) {
			if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
			else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
		}

		cc = [];
		for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
			cc.push([ cnt[end], end ]);
		}

		if ( !cc.length ) {
			cnt = guess_sep_weights;
			for(end in cnt) if ( cnt.hasOwnProperty(end) ) {
				cc.push([ cnt[end], end ]);
			}
		}

		cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });

		return guess_seps[cc.pop()[1]];
	}

	function dsv_to_sheet_str(str, opts) {
		var o = opts || {};
		var sep = "";
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ws = o.dense ? ([]) : ({});
		var range = ({s: {c:0, r:0}, e: {c:0, r:0}});

		if(str.slice(0,4) == "sep=" && str.charCodeAt(5) == 10) { sep = str.charAt(4); str = str.slice(6); }
		else sep = guess_sep(str.slice(0,1024));
		var R = 0, C = 0, v = 0;
		var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0;
		str = str.replace(/\r\n/mg, "\n");
		var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
		function finish_cell() {
			var s = str.slice(start, end);
			var cell = ({});
			if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
			if(s.length === 0) cell.t = 'z';
			else if(o.raw) { cell.t = 's'; cell.v = s; }
			else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
			else if(s.charCodeAt(0) == 0x3D) {
				if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
				else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
				else { cell.t = 's'; cell.v = s; } }
			else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
			else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
			else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
			else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
				cell.z = o.dateNF || SSF._table[14];
				var k = 0;
				if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
				if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
				else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
				if(o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
				if(!o.cellNF) delete cell.z;
			} else {
				cell.t = 's';
				cell.v = s;
			}
			if(cell.t == 'z'){}
			else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
			else ws[encode_cell({c:C,r:R})] = cell;
			start = end+1;
			if(range.e.c < C) range.e.c = C;
			if(range.e.r < R) range.e.r = R;
			if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
		}
		outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
			case 0x22: instr = !instr; break;
			case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
			default: break;
		}
		if(end - start > 0) finish_cell();

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function prn_to_sheet_str(str, opts) {
		if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
		if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
		return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
	}

	function prn_to_sheet(d, opts) {
		var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
		switch(opts.type) {
			case 'base64': str = Base64.decode(d); break;
			case 'binary': str = d; break;
			case 'buffer': str = d.toString('binary'); break;
			case 'array': str = cc2str(d); break;
			case 'string': str = d; break;
			default: throw new Error("Unrecognized type " + opts.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
		else if((opts.type == 'binary' || opts.type == 'buffer') && typeof cptable !== 'undefined' && opts.codepage)  str = cptable.utils.decode(opts.codepage, cptable.utils.encode(1252,str));
		if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
		return prn_to_sheet_str(str, opts);
	}

	function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }

	function sheet_to_prn(ws) {
		var o = [];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var oo = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null) { oo.push("          "); continue; }
				var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
				while(w.length < 10) w += " ";
				oo.push(w + (C === 0 ? " " : ""));
			}
			o.push(oo.join(""));
		}
		return o.join("\n");
	}

	return {
		to_workbook: prn_to_workbook,
		to_sheet: prn_to_sheet,
		from_sheet: sheet_to_prn
	};
})();

/* Excel defaults to SYLK but warns if data is not valid */
function read_wb_ID(d, opts) {
	var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
	try {
		var out = SYLK.to_workbook(d, o);
		o.WTF = OLD_WTF;
		return out;
	} catch(e) {
		o.WTF = OLD_WTF;
		if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
		return PRN.to_workbook(d, opts);
	}
}

var WK_ = (function() {
	function lotushopper(data, cb, opts) {
		if(!data) return;
		prep_blob(data, data.l || 0);
		var Enum = opts.Enum || WK1Enum;
		while(data.l < data.length) {
			var RT = data.read_shift(2);
			var R = Enum[RT] || Enum[0xFF];
			var length = data.read_shift(2);
			var tgt = data.l + length;
			var d = (R.f||parsenoop)(data, length, opts);
			data.l = tgt;
			if(cb(d, R.n, RT)) return;
		}
	}

	function lotus_to_workbook(d, opts) {
		switch(opts.type) {
			case 'base64': return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
			case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
			case 'buffer':
			case 'array': return lotus_to_workbook_buf(d, opts);
		}
		throw "Unsupported type " + opts.type;
	}

	function lotus_to_workbook_buf(d, opts) {
		if(!d) return d;
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var s = ((o.dense ? [] : {})), n = "Sheet1", sidx = 0;
		var sheets = {}, snames = [n];

		var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
		var sheetRows = o.sheetRows || 0;

		if(d[2] == 0x02) o.Enum = WK1Enum;
		else if(d[2] == 0x1a) o.Enum = WK3Enum;
		else if(d[2] == 0x0e) { o.Enum = WK3Enum; o.qpro = true; d.l = 0; }
		else throw new Error("Unrecognized LOTUS BOF " + d[2]);
		lotushopper(d, function(val, Rn, RT) {
			if(d[2] == 0x02) switch(RT) {
				case 0x00:
					o.vers = val;
					if(val >= 0x1000) o.qpro = true;
					break;
				case 0x06: refguess = val; break; /* RANGE */
				case 0x0F: /* LABEL */
					if(!o.qpro) val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x0D: /* INTEGER */
				case 0x0E: /* NUMBER */
				case 0x10: /* FORMULA */
				case 0x33: /* STRING */
					/* TODO: actual translation of the format code */
					if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
						val[1].z = o.dateNF || SSF._table[14];
						if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
					}
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					break;
			} else switch(RT) {
				case 0x16: /* LABEL16 */
					val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x17: /* NUMBER17 */
				case 0x18: /* NUMBER18 */
				case 0x19: /* FORMULA19 */
				case 0x25: /* NUMBER25 */
				case 0x27: /* NUMBER27 */
				case 0x28: /* FORMULA28 */
					if(val[3] > sidx) {
						s["!ref"] = encode_range(refguess);
						sheets[n] = s;
						s = (o.dense ? [] : {});
						refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
						sidx = val[3]; n = "Sheet" + (sidx + 1);
						snames.push(n);
					}
					if(sheetRows > 0 && val[0].r >= sheetRows) break;
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
					if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
					break;
				default: break;
			}
		}, o);

		s["!ref"] = encode_range(refguess);
		sheets[n] = s;
		return { SheetNames: snames, Sheets:sheets };
	}

	function parse_RANGE(blob) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		o.s.c = blob.read_shift(2);
		o.s.r = blob.read_shift(2);
		o.e.c = blob.read_shift(2);
		o.e.r = blob.read_shift(2);
		if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
		return o;
	}

	function parse_cell(blob, length, opts) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		if(opts.qpro && opts.vers != 0x5120) {
			o[0].c = blob.read_shift(1);
			blob.l++;
			o[0].r = blob.read_shift(2);
			blob.l+=2;
		} else {
			o[2] = blob.read_shift(1);
			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
		}
		return o;
	}

	function parse_LABEL(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		o[1].t = 's';
		if(opts.vers == 0x5120) {
			blob.l++;
			var len = blob.read_shift(1);
			o[1].v = blob.read_shift(len, 'utf8');
			return o;
		}
		if(opts.qpro) blob.l++;
		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
		return o;
	}

	function parse_INTEGER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(2, 'i');
		return o;
	}

	function parse_NUMBER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(8, 'f');
		return o;
	}

	function parse_FORMULA(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		/* TODO: formula */
		o[1].v = blob.read_shift(8, 'f');
		if(opts.qpro) blob.l = tgt;
		else {
			var flen = blob.read_shift(2);
			blob.l += flen;
		}
		return o;
	}

	function parse_cell_3(blob) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
		return o;
	}

	function parse_LABEL_16(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].t = 's';
		o[1].v = blob.read_shift(length - 4, 'cstr');
		return o;
	}

	function parse_NUMBER_18(blob, length) {
		var o = parse_cell_3(blob, length);
		o[1].v = blob.read_shift(2);
		var v = o[1].v >> 1;
		/* TODO: figure out all of the corner cases */
		if(o[1].v & 0x1) {
			switch(v & 0x07) {
				case 1: v = (v >> 3) * 500; break;
				case 2: v = (v >> 3) / 20; break;
				case 4: v = (v >> 3) / 2000; break;
				case 6: v = (v >> 3) / 16; break;
				case 7: v = (v >> 3) / 64; break;
				default: throw "unknown NUMBER_18 encoding " + (v & 0x07);
			}
		}
		o[1].v = v;
		return o;
	}

	function parse_NUMBER_17(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		var v2 = blob.read_shift(4);
		var e = blob.read_shift(2);
		if(e == 0xFFFF) { o[1].v = 0; return o; }
		var s = e & 0x8000; e = (e&0x7FFF) - 16446;
		o[1].v = (s*2 - 1) * ((e > 0 ? (v2 << e) : (v2 >>> -e)) + (e > -32 ? (v1 << (e + 32)) : (v1 >>> -(e + 32))));
		return o;
	}

	function parse_FORMULA_19(blob, length) {
		var o = parse_NUMBER_17(blob, 14);
		blob.l += length - 14; /* TODO: formula */
		return o;
	}

	function parse_NUMBER_25(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(4);
		o[1].v = v1 >> 6;
		return o;
	}

	function parse_NUMBER_27(blob, length) {
		var o = parse_cell_3(blob, length);
		var v1 = blob.read_shift(8,'f');
		o[1].v = v1;
		return o;
	}

	function parse_FORMULA_28(blob, length) {
		var o = parse_NUMBER_27(blob, 14);
		blob.l += length - 10; /* TODO: formula */
		return o;
	}

	var WK1Enum = {
0x0000: { n:"BOF", f:parseuint16 },
0x0001: { n:"EOF" },
0x0002: { n:"CALCMODE" },
0x0003: { n:"CALCORDER" },
0x0004: { n:"SPLIT" },
0x0005: { n:"SYNC" },
0x0006: { n:"RANGE", f:parse_RANGE },
0x0007: { n:"WINDOW1" },
0x0008: { n:"COLW1" },
0x0009: { n:"WINTWO" },
0x000A: { n:"COLW2" },
0x000B: { n:"NAME" },
0x000C: { n:"BLANK" },
0x000D: { n:"INTEGER", f:parse_INTEGER },
0x000E: { n:"NUMBER", f:parse_NUMBER },
0x000F: { n:"LABEL", f:parse_LABEL },
0x0010: { n:"FORMULA", f:parse_FORMULA },
0x0018: { n:"TABLE" },
0x0019: { n:"ORANGE" },
0x001A: { n:"PRANGE" },
0x001B: { n:"SRANGE" },
0x001C: { n:"FRANGE" },
0x001D: { n:"KRANGE1" },
0x0020: { n:"HRANGE" },
0x0023: { n:"KRANGE2" },
0x0024: { n:"PROTEC" },
0x0025: { n:"FOOTER" },
0x0026: { n:"HEADER" },
0x0027: { n:"SETUP" },
0x0028: { n:"MARGINS" },
0x0029: { n:"LABELFMT" },
0x002A: { n:"TITLES" },
0x002B: { n:"SHEETJS" },
0x002D: { n:"GRAPH" },
0x002E: { n:"NGRAPH" },
0x002F: { n:"CALCCOUNT" },
0x0030: { n:"UNFORMATTED" },
0x0031: { n:"CURSORW12" },
0x0032: { n:"WINDOW" },
0x0033: { n:"STRING", f:parse_LABEL },
0x0037: { n:"PASSWORD" },
0x0038: { n:"LOCKED" },
0x003C: { n:"QUERY" },
0x003D: { n:"QUERYNAME" },
0x003E: { n:"PRINT" },
0x003F: { n:"PRINTNAME" },
0x0040: { n:"GRAPH2" },
0x0041: { n:"GRAPHNAME" },
0x0042: { n:"ZOOM" },
0x0043: { n:"SYMSPLIT" },
0x0044: { n:"NSROWS" },
0x0045: { n:"NSCOLS" },
0x0046: { n:"RULER" },
0x0047: { n:"NNAME" },
0x0048: { n:"ACOMM" },
0x0049: { n:"AMACRO" },
0x004A: { n:"PARSE" },
0x00FF: { n:"", f:parsenoop }
	};

	var WK3Enum = {
0x0000: { n:"BOF" },
0x0001: { n:"EOF" },
0x0003: { n:"??" },
0x0004: { n:"??" },
0x0005: { n:"??" },
0x0006: { n:"??" },
0x0007: { n:"??" },
0x0009: { n:"??" },
0x000a: { n:"??" },
0x000b: { n:"??" },
0x000c: { n:"??" },
0x000e: { n:"??" },
0x000f: { n:"??" },
0x0010: { n:"??" },
0x0011: { n:"??" },
0x0012: { n:"??" },
0x0013: { n:"??" },
0x0015: { n:"??" },
0x0016: { n:"LABEL16", f:parse_LABEL_16},
0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
0x001a: { n:"??" },
0x001b: { n:"??" },
0x001c: { n:"??" },
0x001d: { n:"??" },
0x001e: { n:"??" },
0x001f: { n:"??" },
0x0021: { n:"??" },
0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
0x00FF: { n:"", f:parsenoop }
	};
	return {
		to_workbook: lotus_to_workbook
	};
})();
/* Parse a list of <r> tags */
var parse_rs = (function parse_rs_factory() {
	var tregex = matchtag("t"), rpregex = matchtag("rPr"), rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/, nlregex = /\r\n/g;
	/* 18.4.7 rPr CT_RPrElt */
	var parse_rpr = function parse_rpr(rpr, intro, outro) {
		var font = {}, cp = 65001, align = "";
		var pass = false;
		var m = rpr.match(tagregex), i = 0;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;

				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					cp = CS2CP[parseInt(y.val, 10)];
					break;

				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;

				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;

				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;

				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;

				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;

				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;

				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;

				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;

				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;

				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': align = y.val; break;

				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;

				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		var style = [];

		if(font.u) style.push("text-decoration: underline;");
		if(font.uval) style.push("text-underline-style:" + font.uval + ";");
		if(font.sz) style.push("font-size:" + font.sz + "pt;");
		if(font.outline) style.push("text-effect: outline;");
		if(font.shadow) style.push("text-shadow: auto;");
		intro.push('<span style="' + style.join("") + '">');

		if(font.b) { intro.push("<b>"); outro.push("</b>"); }
		if(font.i) { intro.push("<i>"); outro.push("</i>"); }
		if(font.strike) { intro.push("<s>"); outro.push("</s>"); }

		if(align == "superscript") align = "sup";
		else if(align == "subscript") align = "sub";
		if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }

		outro.push("</span>");
		return cp;
	};

	/* 18.4.4 r CT_RElt */
	function parse_r(r) {
		var terms = [[],"",[]];
		/* 18.4.12 t ST_Xstring */
		var t = r.match(tregex)/*, cp = 65001*/;
		if(!t) return "";
		terms[1] = t[1];

		var rpr = r.match(rpregex);
		if(rpr) /*cp = */parse_rpr(rpr[1], terms[0], terms[2]);

		return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
	}
	return function parse_rs(rs) {
		return rs.replace(rregex,"").split(rend).map(parse_r).join("");
	};
})();

/* 18.4.8 si CT_Rst */
var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(x, opts) {
	var html = opts ? opts.cellHTML : true;
	var z = {};
	if(!x) return null;
	//var y;
	/* 18.4.12 t ST_Xstring (Plaintext String) */
	// TODO: is whitespace actually valid here?
	if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
		z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
		z.r = utf8read(x);
		if(html) z.h = escapehtml(z.t);
	}
	/* 18.4.4 r CT_RElt (Rich Text Run) */
	else if((/*y = */x.match(sirregex))) {
		z.r = utf8read(x);
		z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
		if(html) z.h = parse_rs(z.r);
	}
	/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
	/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
	return z;
}

/* 18.4 Shared String Table */
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(data, opts) {
	var s = ([]), ss = "";
	if(!data) return s;
	/* 18.4.9 sst CT_Sst */
	var sst = data.match(sstr0);
	if(sst) {
		ss = sst[2].replace(sstr1,"").split(sstr2);
		for(var i = 0; i != ss.length; ++i) {
			var o = parse_si(ss[i].trim(), opts);
			if(o != null) s[s.length] = o;
		}
		sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
	}
	return s;
}

RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
var straywsregex = /^\s|\s$|[\t\n\r]/;
function write_sst_xml(sst, opts) {
	if(!opts.bookSST) return "";
	var o = [XML_HEADER];
	o[o.length] = (writextag('sst', null, {
		xmlns: XMLNS.main[0],
		count: sst.Count,
		uniqueCount: sst.Unique
	}));
	for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
		var s = sst[i];
		var sitag = "<si>";
		if(s.r) sitag += s.r;
		else {
			sitag += "<t";
			if(!s.t) s.t = "";
			if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
			sitag += ">" + escapexml(s.t) + "</t>";
		}
		sitag += "</si>";
		o[o.length] = (sitag);
	}
	if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */
function parse_BrtBeginSst(data) {
	return [data.read_shift(4), data.read_shift(4)];
}

/* [MS-XLSB] 2.1.7.45 Shared Strings */
function parse_sst_bin(data, opts) {
	var s = ([]);
	var pass = false;
	recordhopper(data, function hopper_sst(val, R_n, RT) {
		switch(RT) {
			case 0x009F: /* 'BrtBeginSst' */
				s.Count = val[0]; s.Unique = val[1]; break;
			case 0x0013: /* 'BrtSSTItem' */
				s.push(val); break;
			case 0x00A0: /* 'BrtEndSst' */
				return true;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if(R_n.indexOf("Begin") > 0){/* empty */}
				else if(R_n.indexOf("End") > 0){/* empty */}
				if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return s;
}

function write_BrtBeginSst(sst, o) {
	if(!o) o = new_buf(8);
	o.write_shift(4, sst.Count);
	o.write_shift(4, sst.Unique);
	return o;
}

var write_BrtSSTItem = write_RichStr;

function write_sst_bin(sst) {
	var ba = buf_array();
	write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
	for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
	/* FRTSST */
	write_record(ba, "BrtEndSst");
	return ba.end();
}
function _JS2ANSI(str) {
	if(typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
	var o = [], oo = str.split("");
	for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.4 Version */
function parse_CRYPTOVersion(blob, length) {
	var o = {};
	o.Major = blob.read_shift(2);
	o.Minor = blob.read_shift(2);
if(length >= 4) blob.l += length - 4;
	return o;
}

/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
function parse_DataSpaceVersionInfo(blob) {
	var o = {};
	o.id = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
function parse_DataSpaceMapEntry(blob) {
	var len = blob.read_shift(4);
	var end = blob.l + len - 4;
	var o = {};
	var cnt = blob.read_shift(4);
	var comps = [];
	/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
	while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
	o.name = blob.read_shift(0, 'lpp4');
	o.comps = comps;
	if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
function parse_DataSpaceMap(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
function parse_DataSpaceDefinition(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
function parse_TransformInfoHeader(blob) {
	var o = {};
	/*var len = */blob.read_shift(4);
	blob.l += 4; // must be 0x1
	o.id = blob.read_shift(0, 'lpp4');
	o.name = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

function parse_Primary(blob) {
	/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
	var hdr = parse_TransformInfoHeader(blob);
	/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
	hdr.ename = blob.read_shift(0, '8lpp4');
	hdr.blksz = blob.read_shift(4);
	hdr.cmode = blob.read_shift(4);
	if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
	return hdr;
}

/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
function parse_EncryptionHeader(blob, length) {
	var tgt = blob.l + length;
	var o = {};
	o.Flags = (blob.read_shift(4) & 0x3F);
	blob.l += 4;
	o.AlgID = blob.read_shift(4);
	var valid = false;
	switch(o.AlgID) {
		case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
		case 0x6801: valid = (o.Flags == 0x04); break;
		case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
		default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
	}
	if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
	o.AlgIDHash = blob.read_shift(4);
	o.KeySize = blob.read_shift(4);
	o.ProviderType = blob.read_shift(4);
	blob.l += 8;
	o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
	blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
function parse_EncryptionVerifier(blob, length) {
	var o = {}, tgt = blob.l + length;
	blob.l += 4; // SaltSize must be 0x10
	o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
	o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
	/*var sz = */blob.read_shift(4);
	o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
function parse_EncryptionInfo(blob) {
	var vers = parse_CRYPTOVersion(blob);
	switch(vers.Minor) {
		case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
		case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
		case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
	}
	throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}

/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
function parse_EncInfoStd(blob) {
	var flags = blob.read_shift(4);
	if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
	var sz = blob.read_shift(4);
	//var tgt = blob.l + sz;
	var hdr = parse_EncryptionHeader(blob, sz);
	var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
	return { t:"Std", h:hdr, v:verifier };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
function parse_EncInfoAgl(blob) {
	var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
	blob.l+=4;
	var xml = blob.read_shift(blob.length - blob.l, 'utf8');
	var o = {};
	xml.replace(tagregex, function xml_agile(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;
			case '<encryption': case '</encryption>': break;
			case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
			case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
			case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
			case '</keyEncryptors>': break;

			case '<keyEncryptor': o.uri = y.uri; break;
			case '</keyEncryptor>': break;
			case '<encryptedKey': o.encs.push(y); break;
			default: throw y[0];
		}
	});
	return o;
}

/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
function parse_RC4CryptoHeader(blob, length) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
	if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
	if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
	o.Flags = blob.read_shift(4); length -= 4;
	var sz = blob.read_shift(4); length -= 4;
	o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
	o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
	return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
function parse_RC4Header(blob) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
	if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
	o.Salt = blob.read_shift(16);
	o.EncryptedVerifier = blob.read_shift(16);
	o.EncryptedVerifierHash = blob.read_shift(16);
	return o;
}

/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
function crypto_CreatePasswordVerifier_Method1(Password) {
	var Verifier = 0x0000, PasswordArray;
	var PasswordDecoded = _JS2ANSI(Password);
	var len = PasswordDecoded.length + 1, i, PasswordByte;
	var Intermediate1, Intermediate2, Intermediate3;
	PasswordArray = new_raw_buf(len);
	PasswordArray[0] = PasswordDecoded.length;
	for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
	for(i = len-1; i >= 0; --i) {
		PasswordByte = PasswordArray[i];
		Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
		Intermediate2 = (Verifier << 1) & 0x7FFF;
		Intermediate3 = Intermediate1 | Intermediate2;
		Verifier = Intermediate3 ^ PasswordByte;
	}
	return Verifier ^ 0xCE4B;
}

/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
var crypto_CreateXorArray_Method1 = (function() {
	var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
	var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
	var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
	var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
	var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
	var CreateXorKey_Method1 = function(Password) {
		var XorKey = InitialCode[Password.length - 1];
		var CurrentElement = 0x68;
		for(var i = Password.length-1; i >= 0; --i) {
			var Char = Password[i];
			for(var j = 0; j != 7; ++j) {
				if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
				Char *= 2; --CurrentElement;
			}
		}
		return XorKey;
	};
	return function(password) {
		var Password = _JS2ANSI(password);
		var XorKey = CreateXorKey_Method1(Password);
		var Index = Password.length;
		var ObfuscationArray = new_raw_buf(16);
		for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
		var Temp, PasswordLastChar, PadIndex;
		if((Index & 1) === 1) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			PasswordLastChar = Password[Password.length - 1];
			ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
		}
		while(Index > 0) {
			--Index;
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
		}
		Index = 15;
		PadIndex = 15 - Password.length;
		while(PadIndex > 0) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
			--Index;
			--PadIndex;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			--PadIndex;
		}
		return ObfuscationArray;
	};
})();

/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
	/* If XorArray is set, use it; if O is not set, make changes in-place */
	if(!O) O = Data;
	if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
	var Index, Value;
	for(Index = 0; Index != Data.length; ++Index) {
		Value = Data[Index];
		Value ^= XorArray[XorArrayIndex];
		Value = ((Value>>5) | (Value<<3)) & 0xFF;
		O[Index] = Value;
		++XorArrayIndex;
	}
	return [O, XorArrayIndex, XorArray];
};

var crypto_MakeXorDecryptor = function(password) {
	var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
	return function(Data) {
		var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
		XorArrayIndex = O[1];
		return O[0];
	};
};

/* 2.5.343 */
function parse_XORObfuscation(blob, length, opts, out) {
	var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
	if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
	out.valid = o.verificationBytes === o.verifier;
	if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
	return o;
}

/* 2.4.117 */
function parse_FilePassHeader(blob, length, oo) {
	var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
	if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
	else o.Data = parse_RC4CryptoHeader(blob, length);
	return o;
}
function parse_FilePass(blob, length, opts) {
	var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
	if(o.Type) parse_FilePassHeader(blob, length-2, o);
	else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
	return o;
}


var RTF = (function() {
	function rtf_to_sheet(d, opts) {
		switch(opts.type) {
			case 'base64': return rtf_to_sheet_str(Base64.decode(d), opts);
			case 'binary': return rtf_to_sheet_str(d, opts);
			case 'buffer': return rtf_to_sheet_str(d.toString('binary'), opts);
			case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}

	function rtf_to_sheet_str(str, opts) {
		var o = opts || {};
		var ws = o.dense ? ([]) : ({});
		var range = ({s: {c:0, r:0}, e: {c:0, r:0}});

		// TODO: parse
		if(!str.match(/\\trowd/)) throw new Error("RTF missing table");

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }

	/* TODO: this is a stub */
	function sheet_to_rtf(ws) {
		var o = ["{\\rtf1\\ansi"];
		var r = safe_decode_range(ws['!ref']), cell;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			o.push("\\trowd\\trautofit1");
			for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
			o.push("\\pard\\intbl");
			for(C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
				o.push(" " + (cell.w || (format_cell(cell), cell.w)));
				o.push("\\cell");
			}
			o.push("\\pard\\intbl\\row");
		}
		return o.join("") + "}";
	}

	return {
		to_workbook: rtf_to_workbook,
		to_sheet: rtf_to_sheet,
		from_sheet: sheet_to_rtf
	};
})();
function hex2RGB(h) {
	var o = h.slice(h[0]==="#"?1:0).slice(0,6);
	return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
}
function rgb2Hex(rgb) {
	for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
	return o.toString(16).toUpperCase().slice(1);
}

function rgb2HSL(rgb) {
	var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
	var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
	if(C === 0) return [0, 0, R];

	var H6 = 0, S = 0, L2 = (M + m);
	S = C / (L2 > 1 ? 2 - L2 : L2);
	switch(M){
		case R: H6 = ((G - B) / C + 6)%6; break;
		case G: H6 = ((B - R) / C + 2); break;
		case B: H6 = ((R - G) / C + 4); break;
	}
	return [H6 / 6, S, L2 / 2];
}

function hsl2RGB(hsl){
	var H = hsl[0], S = hsl[1], L = hsl[2];
	var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
	var rgb = [m,m,m], h6 = 6*H;

	var X;
	if(S !== 0) switch(h6|0) {
		case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
		case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
		case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
		case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
		case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
		case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
	}
	for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
	return rgb;
}

/* 18.8.3 bgColor tint algorithm */
function rgb_tint(hex, tint) {
	if(tint === 0) return hex;
	var hsl = rgb2HSL(hex2RGB(hex));
	if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
	else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
	return rgb2Hex(hsl2RGB(hsl));
}

/* 18.3.1.13 width calculations */
/* [MS-OI29500] 2.1.595 Column Width & Formatting */
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
/* XLSX/XLSB/XLS specify width in units of MDW */
function find_mdw_colw(collw) {
	var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
	if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
	MDW = _MDW;
}
/* XLML specifies width in terms of pixels */
/*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/

function process_col(coll) {
	if(coll.width) {
		coll.wpx = width2px(coll.width);
		coll.wch = px2char(coll.wpx);
		coll.MDW = MDW;
	} else if(coll.wpx) {
		coll.wch = px2char(coll.wpx);
		coll.width = char2width(coll.wch);
		coll.MDW = MDW;
	} else if(typeof coll.wch == 'number') {
		coll.width = char2width(coll.wch);
		coll.wpx = width2px(coll.width);
		coll.MDW = MDW;
	}
	if(coll.customWidth) delete coll.customWidth;
}

var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(px) { return px * 96 / PPI; }
function pt2px(pt) { return pt * PPI / 96; }

/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
var XLMLPatternTypeMap = {
	"None": "none",
	"Solid": "solid",
	"Gray50": "mediumGray",
	"Gray75": "darkGray",
	"Gray25": "lightGray",
	"HorzStripe": "darkHorizontal",
	"VertStripe": "darkVertical",
	"ReverseDiagStripe": "darkDown",
	"DiagStripe": "darkUp",
	"DiagCross": "darkGrid",
	"ThickDiagCross": "darkTrellis",
	"ThinHorzStripe": "lightHorizontal",
	"ThinVertStripe": "lightVertical",
	"ThinReverseDiagStripe": "lightDown",
	"ThinHorzCross": "lightGrid"
};

/* 18.8.5 borders CT_Borders */
function parse_borders(t, styles, themes, opts) {
	styles.Borders = [];
	var border = {}/*, sub_border = {}*/;
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch (y[0]) {
			case '<borders': case '<borders>': case '</borders>': break;

			/* 18.8.4 border CT_Border */
			case '<border': case '<border>': case '<border/>':
				border = {};
				if (y.diagonalUp) { border.diagonalUp = y.diagonalUp; }
				if (y.diagonalDown) { border.diagonalDown = y.diagonalDown; }
				styles.Borders.push(border);
				break;
			case '</border>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<left/>': break;
			case '<left': case '<left>': break;
			case '</left>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<right/>': break;
			case '<right': case '<right>': break;
			case '</right>': break;

			/* 18.8.43 top CT_BorderPr */
			case '<top/>': break;
			case '<top': case '<top>': break;
			case '</top>': break;

			/* 18.8.6 bottom CT_BorderPr */
			case '<bottom/>': break;
			case '<bottom': case '<bottom>': break;
			case '</bottom>': break;

			/* 18.8.13 diagonal CT_BorderPr */
			case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
			case '</diagonal>': break;

			/* 18.8.25 horizontal CT_BorderPr */
			case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
			case '</horizontal>': break;

			/* 18.8.44 vertical CT_BorderPr */
			case '<vertical': case '<vertical>': case '<vertical/>': break;
			case '</vertical>': break;

			/* 18.8.37 start CT_BorderPr */
			case '<start': case '<start>': case '<start/>': break;
			case '</start>': break;

			/* 18.8.16 end CT_BorderPr */
			case '<end': case '<end>': case '<end/>': break;
			case '</end>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color>': break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
			}
		}
	});
}

/* 18.8.21 fills CT_Fills */
function parse_fills(t, styles, themes, opts) {
	styles.Fills = [];
	var fill = {};
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			case '<fills': case '<fills>': case '</fills>': break;

			/* 18.8.20 fill CT_Fill */
			case '<fill>': case '<fill': case '<fill/>':
				fill = {}; styles.Fills.push(fill); break;
			case '</fill>': break;

			/* 18.8.24 gradientFill CT_GradientFill */
			case '<gradientFill>': break;
			case '<gradientFill':
			case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;

			/* 18.8.32 patternFill CT_PatternFill */
			case '<patternFill': case '<patternFill>':
				if(y.patternType) fill.patternType = y.patternType;
				break;
			case '<patternFill/>': case '</patternFill>': break;

			/* 18.8.3 bgColor CT_Color */
			case '<bgColor':
				if(!fill.bgColor) fill.bgColor = {};
				if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
				if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
				break;
			case '<bgColor/>': case '</bgColor>': break;

			/* 18.8.19 fgColor CT_Color */
			case '<fgColor':
				if(!fill.fgColor) fill.fgColor = {};
				if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.fgColor.rgb = y.rgb.slice(-6);
				break;
			case '<fgColor/>': case '</fgColor>': break;

			/* 18.8.38 stop CT_GradientStop */
			case '<stop': case '<stop/>': break;
			case '</stop>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color/>': break;
			case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
			}
		}
	});
}

/* 18.8.23 fonts CT_Fonts */
function parse_fonts(t, styles, themes, opts) {
	styles.Fonts = [];
	var font = {};
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x);
		switch (y[0]) {
			case '<fonts': case '<fonts>': case '</fonts>': break;

			/* 18.8.22 font CT_Font */
			case '<font': case '<font>': break;
			case '</font>': case '<font/>':
				styles.Fonts.push(font);
				font = {};
				break;

			/* 18.8.29 name CT_FontName */
			case '<name': if(y.val) font.name = y.val; break;
			case '<name/>': case '</name>': break;

			/* 18.8.2  b CT_BooleanProperty */
			case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
			case '<b/>': font.bold = 1; break;

			/* 18.8.26 i CT_BooleanProperty */
			case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
			case '<i/>': font.italic = 1; break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				switch(y.val) {
					case "none": font.underline = 0x00; break;
					case "single": font.underline = 0x01; break;
					case "double": font.underline = 0x02; break;
					case "singleAccounting": font.underline = 0x21; break;
					case "doubleAccounting": font.underline = 0x22; break;
				} break;
			case '<u/>': font.underline = 1; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
			case '<strike/>': font.strike = 1; break;

			/* 18.4.2  outline CT_BooleanProperty */
			case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
			case '<outline/>': font.outline = 1; break;

			/* 18.8.36 shadow CT_BooleanProperty */
			case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
			case '<shadow/>': font.shadow = 1; break;

			/* 18.8.12 condense CT_BooleanProperty */
			case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
			case '<condense/>': font.condense = 1; break;

			/* 18.8.17 extend CT_BooleanProperty */
			case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
			case '<extend/>': font.extend = 1; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': if(y.val) font.sz = +y.val; break;
			case '<sz/>': case '</sz>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
			case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
			case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.18 family CT_FontFamily */
			case '<family': if(y.val) font.family = parseInt(y.val,10); break;
			case '<family/>': case '</family>': break;

			/* 18.8.35 scheme CT_FontScheme */
			case '<scheme': if(y.val) font.scheme = y.val; break;
			case '<scheme/>': case '</scheme>': break;

			/* 18.4.1 charset CT_IntProperty */
			case '<charset':
				if(y.val == '1') break;
				y.codepage = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.?.? color CT_Color */
			case '<color':
				if(!font.color) font.color = {};
				if(y.auto) font.color.auto = parsexmlbool(y.auto);

				if(y.rgb) font.color.rgb = y.rgb.slice(-6);
				else if(y.indexed) {
					font.color.index = parseInt(y.indexed, 10);
					var icv = XLSIcv[font.color.index];
					if(font.color.index == 81) icv = XLSIcv[1];
					if(!icv) throw new Error(x);
					font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
				} else if(y.theme) {
					font.color.theme = parseInt(y.theme, 10);
					if(y.tint) font.color.tint = parseFloat(y.tint);
					if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
						font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
					}
				}

				break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
			}
		}
	});
}

/* 18.8.31 numFmts CT_NumFmts */
function parse_numFmts(t, styles, opts) {
	styles.NumberFmt = [];
	var k/*Array<number>*/ = (keys(SSF._table));
	for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
	var m = t[0].match(tagregex);
	if(!m) return;
	for(i=0; i < m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(y[0]) {
			case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
			case '<numFmt': {
				var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
				styles.NumberFmt[j] = f;
				if(j>0) {
					if(j > 0x188) {
						for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
						styles.NumberFmt[j] = f;
					}
					SSF.load(f,j);
				}
			} break;
			case '</numFmt>': break;
			default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
		}
	}
}

function write_numFmts(NF) {
	var o = ["<numFmts>"];
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
	});
	if(o.length === 1) return "";
	o[o.length] = ("</numFmts>");
	o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
	return o.join("");
}

/* 18.8.10 cellXfs CT_CellXfs */
var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
function parse_cellXfs(t, styles, opts) {
	styles.CellXf = [];
	var xf;
	var pass = false;
	t[0].match(tagregex).forEach(function(x) {
		var y = parsexmltag(x), i = 0;
		switch(y[0]) {
			case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;

			/* 18.8.45 xf CT_Xf */
			case '<xf': case '<xf/>':
				xf = y;
				delete xf[0];
				for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
					xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
				for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
					xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
				if(xf.numFmtId > 0x188) {
					for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
				}
				styles.CellXf.push(xf); break;
			case '</xf>': break;

			/* 18.8.1 alignment CT_CellAlignment */
			case '<alignment': case '<alignment/>':
				var alignment = {};
				if(y.vertical) alignment.vertical = y.vertical;
				if(y.horizontal) alignment.horizontal = y.horizontal;
				if(y.textRotation != null) alignment.textRotation = y.textRotation;
				if(y.indent) alignment.indent = y.indent;
				if(y.wrapText) alignment.wrapText = y.wrapText;
				xf.alignment = alignment;
				break;
			case '</alignment>': break;

			/* 18.8.33 protection CT_CellProtection */
			case '<protection': case '</protection>': case '<protection/>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
			}
		}
	});
}

function write_cellXfs(cellXfs) {
	var o = [];
	o[o.length] = (writextag('cellXfs',null));
	cellXfs.forEach(function(c) { o[o.length] = (writextag('xf', null, c)); });
	o[o.length] = ("</cellXfs>");
	if(o.length === 2) return "";
	o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
	return o.join("");
}

/* 18.8 Styles CT_Stylesheet*/
var parse_sty_xml= (function make_pstyx() {
var numFmtRegex = /<numFmts([^>]*)>[\S\s]*?<\/numFmts>/;
var cellXfRegex = /<cellXfs([^>]*)>[\S\s]*?<\/cellXfs>/;
var fillsRegex = /<fills([^>]*)>[\S\s]*?<\/fills>/;
var fontsRegex = /<fonts([^>]*)>[\S\s]*?<\/fonts>/;
var bordersRegex = /<borders([^>]*)>[\S\s]*?<\/borders>/;

return function parse_sty_xml(data, themes, opts) {
	var styles = {};
	if(!data) return styles;
	data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
	/* 18.8.39 styleSheet CT_Stylesheet */
	var t;

	/* 18.8.31 numFmts CT_NumFmts ? */
	if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);

	/* 18.8.23 fonts CT_Fonts ? */
	if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);

	/* 18.8.21 fills CT_Fills ? */
	if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);

	/* 18.8.5  borders CT_Borders ? */
	if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);

	/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */

	/* 18.8.10 cellXfs CT_CellXfs ? */
	if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);

	/* 18.8.8  cellStyles CT_CellStyles ? */
	/* 18.8.15 dxfs CT_Dxfs ? */
	/* 18.8.42 tableStyles CT_TableStyles ? */
	/* 18.8.11 colors CT_Colors ? */
	/* 18.2.10 extLst CT_ExtensionList ? */

	return styles;
};
})();

var STYLES_XML_ROOT = writextag('styleSheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:vt': XMLNS.vt
});

RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";

function write_sty_xml(wb, opts) {
	var o = [XML_HEADER, STYLES_XML_ROOT], w;
	if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
	o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
	o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
	o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
	o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
	if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
	o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
	o[o.length] = ('<dxfs count="0"/>');
	o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');

	if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */
function parse_BrtFmt(data, length) {
	var numFmtId = data.read_shift(2);
	var stFmtCode = parse_XLWideString(data,length-2);
	return [numFmtId, stFmtCode];
}
function write_BrtFmt(i, f, o) {
	if(!o) o = new_buf(6 + 4 * f.length);
	o.write_shift(2, i);
	write_XLWideString(f, o);
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(o.l == null) o.l = o.length;
	return out;
}

/* [MS-XLSB] 2.4.659 BrtFont TODO */
function parse_BrtFont(data, length, opts) {
	var out = ({});

	out.sz = data.read_shift(2) / 20;

	var grbit = parse_FontFlags(data, 2, opts);
	if(grbit.fCondense) out.condense = 1;
	if(grbit.fExtend) out.extend = 1;
	if(grbit.fShadow) out.shadow = 1;
	if(grbit.fOutline) out.outline = 1;
	if(grbit.fStrikeout) out.strike = 1;
	if(grbit.fItalic) out.italic = 1;

	var bls = data.read_shift(2);
	if(bls === 0x02BC) out.bold = 1;

	switch(data.read_shift(2)) {
		/* case 0: out.vertAlign = "baseline"; break; */
		case 1: out.vertAlign = "superscript"; break;
		case 2: out.vertAlign = "subscript"; break;
	}

	var underline = data.read_shift(1);
	if(underline != 0) out.underline = underline;

	var family = data.read_shift(1);
	if(family > 0) out.family = family;

	var bCharSet = data.read_shift(1);
	if(bCharSet > 0) out.charset = bCharSet;

	data.l++;
	out.color = parse_BrtColor(data, 8);

	switch(data.read_shift(1)) {
		/* case 0: out.scheme = "none": break; */
		case 1: out.scheme = "major"; break;
		case 2: out.scheme = "minor"; break;
	}

	out.name = parse_XLWideString(data, length - 21);

	return out;
}
function write_BrtFont(font, o) {
	if(!o) o = new_buf(25+4*32);
	o.write_shift(2, font.sz * 20);
	write_FontFlags(font, o);
	o.write_shift(2, font.bold ? 0x02BC : 0x0190);
	var sss = 0;
	if(font.vertAlign == "superscript") sss = 1;
	else if(font.vertAlign == "subscript") sss = 2;
	o.write_shift(2, sss);
	o.write_shift(1, font.underline || 0);
	o.write_shift(1, font.family || 0);
	o.write_shift(1, font.charset || 0);
	o.write_shift(1, 0);
	write_BrtColor(font.color, o);
	var scheme = 0;
	if(font.scheme == "major") scheme = 1;
	if(font.scheme == "minor") scheme = 2;
	o.write_shift(1, scheme);
	write_XLWideString(font.name, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.650 BrtFill */
var XLSBFillPTNames = [
	"none",
	"solid",
	"mediumGray",
	"darkGray",
	"lightGray",
	"darkHorizontal",
	"darkVertical",
	"darkDown",
	"darkUp",
	"darkGrid",
	"darkTrellis",
	"lightHorizontal",
	"lightVertical",
	"lightDown",
	"lightUp",
	"lightGrid",
	"lightTrellis",
	"gray125",
	"gray0625"
];
var rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
/* TODO: gradient fill representation */
var parse_BrtFill = parsenoop;
function write_BrtFill(fill, o) {
	if(!o) o = new_buf(4*3 + 8*7 + 16*1);
	var fls = rev_XLSBFillPTNames[fill.patternType];
	if(fls == null) fls = 0x28;
	o.write_shift(4, fls);
	var j = 0;
	if(fls != 0x28) {
		/* TODO: custom FG Color */
		write_BrtColor({auto:1}, o);
		/* TODO: custom BG Color */
		write_BrtColor({auto:1}, o);

		for(; j < 12; ++j) o.write_shift(4, 0);
	} else {
		for(; j < 4; ++j) o.write_shift(4, 0);

		for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
		/* iGradientType */
		/* xnumDegree */
		/* xnumFillToLeft */
		/* xnumFillToRight */
		/* xnumFillToTop */
		/* xnumFillToBottom */
		/* cNumStop */
		/* xfillGradientStop */
	}
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.824 BrtXF */
function parse_BrtXF(data, length) {
	var tgt = data.l + length;
	var ixfeParent = data.read_shift(2);
	var ifmt = data.read_shift(2);
	data.l = tgt;
	return {ixfe:ixfeParent, numFmtId:ifmt };
}
function write_BrtXF(data, ixfeP, o) {
	if(!o) o = new_buf(16);
	o.write_shift(2, ixfeP||0);
	o.write_shift(2, data.numFmtId||0);
	o.write_shift(2, 0); /* iFont */
	o.write_shift(2, 0); /* iFill */
	o.write_shift(2, 0); /* ixBorder */
	o.write_shift(1, 0); /* trot */
	o.write_shift(1, 0); /* indent */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* xfGrbitAtr */
	o.write_shift(1, 0);
	return o;
}

/* [MS-XLSB] 2.5.4 Blxf TODO */
function write_Blxf(data, o) {
	if(!o) o = new_buf(10);
	o.write_shift(1, 0); /* dg */
	o.write_shift(1, 0);
	o.write_shift(4, 0); /* color */
	o.write_shift(4, 0); /* color */
	return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */
var parse_BrtBorder = parsenoop;
function write_BrtBorder(border, o) {
	if(!o) o = new_buf(51);
	o.write_shift(1, 0); /* diagonal */
	write_Blxf(null, o); /* top */
	write_Blxf(null, o); /* bottom */
	write_Blxf(null, o); /* left */
	write_Blxf(null, o); /* right */
	write_Blxf(null, o); /* diag */
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.763 BrtStyle TODO */
function write_BrtStyle(style, o) {
	if(!o) o = new_buf(12+4*10);
	o.write_shift(4, style.xfId);
	o.write_shift(2, 1);
	o.write_shift(1, +style.builtinId);
	o.write_shift(1, 0); /* iLevel */
	write_XLNullableWideString(style.name || "", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
	var o = new_buf(4+256*2*4);
	o.write_shift(4, cnt);
	write_XLNullableWideString(defTableStyle, o);
	write_XLNullableWideString(defPivotStyle, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.1.7.50 Styles */
function parse_sty_bin(data, themes, opts) {
	var styles = {};
	styles.NumberFmt = ([]);
	for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];

	styles.CellXf = [];
	styles.Fonts = [];
	var state = [];
	var pass = false;
	recordhopper(data, function hopper_sty(val, R_n, RT) {
		switch(RT) {
			case 0x002C: /* 'BrtFmt' */
				styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
				break;
			case 0x002B: /* 'BrtFont' */
				styles.Fonts.push(val);
				if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
					val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
				}
				break;
			case 0x0401: /* 'BrtKnownFonts' */ break;
			case 0x002D: /* 'BrtFill' */ break;
			case 0x002E: /* 'BrtBorder' */ break;
			case 0x002F: /* 'BrtXF' */
				if(state[state.length - 1] == "BrtBeginCellXFs") {
					styles.CellXf.push(val);
				}
				break;
			case 0x0030: /* 'BrtStyle' */
			case 0x01FB: /* 'BrtDXF' */
			case 0x023C: /* 'BrtMRUColor' */
			case 0x01DB: /* 'BrtIndexedColor': */
				break;

			case 0x0493: /* 'BrtDXF14' */
			case 0x0836: /* 'BrtDXF15' */
			case 0x046A: /* 'BrtSlicerStyleElement' */
			case 0x0200: /* 'BrtTableStyleElement' */
			case 0x082F: /* 'BrtTimelineStyleElement' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
				else if((R_n||"").indexOf("End") > 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return styles;
}

function write_FMTS_bin(ba, NF) {
	if(!NF) return;
	var cnt = 0;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
	});

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
	});
	write_record(ba, "BrtEndFmts");
}

function write_FONTS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
	write_record(ba, "BrtFont", write_BrtFont({
		sz:12,
		color: {theme:1},
		name: "Calibri",
		family: 2,
		scheme: "minor"
	}));
	/* 1*65491BrtFont [ACFONTS] */
	write_record(ba, "BrtEndFonts");
}

function write_FILLS_bin(ba) {
	var cnt = 2;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"none"}));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"gray125"}));
	/* 1*65431BrtFill */
	write_record(ba, "BrtEndFills");
}

function write_BORDERS_bin(ba) {
	var cnt = 1;

	if(cnt == 0) return;
	write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
	write_record(ba, "BrtBorder", write_BrtBorder({}));
	/* 1*65430BrtBorder */
	write_record(ba, "BrtEndBorders");
}

function write_CELLSTYLEXFS_bin(ba) {
	var cnt = 1;
	write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
	write_record(ba, "BrtXF", write_BrtXF({
		numFmtId:0,
		fontId:0,
		fillId:0,
		borderId:0
	}, 0xFFFF));
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellStyleXFs");
}

function write_CELLXFS_bin(ba, data) {
	write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
	data.forEach(function(c) { write_record(ba, "BrtXF", write_BrtXF(c,0)); });
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellXFs");
}

function write_STYLES_bin(ba) {
	var cnt = 1;

	write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
	write_record(ba, "BrtStyle", write_BrtStyle({
		xfId:0,
		builtinId:0,
		name:"Normal"
	}));
	/* 1*65430(BrtStyle *FRT) */
	write_record(ba, "BrtEndStyles");
}

function write_DXFS_bin(ba) {
	var cnt = 0;

	write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
	/* *2147483647(BrtDXF *FRT) */
	write_record(ba, "BrtEndDXFs");
}

function write_TABLESTYLES_bin(ba) {
	var cnt = 0;

	write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
	/* *TABLESTYLE */
	write_record(ba, "BrtEndTableStyles");
}

function write_COLORPALETTE_bin() {
	return;
	/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
}

/* [MS-XLSB] 2.1.7.50 Styles */
function write_sty_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginStyleSheet");
	write_FMTS_bin(ba, wb.SSF);
	write_FONTS_bin(ba, wb);
	write_FILLS_bin(ba, wb);
	write_BORDERS_bin(ba, wb);
	write_CELLSTYLEXFS_bin(ba, wb);
	write_CELLXFS_bin(ba, opts.cellXfs);
	write_STYLES_bin(ba, wb);
	write_DXFS_bin(ba, wb);
	write_TABLESTYLES_bin(ba, wb);
	write_COLORPALETTE_bin(ba, wb);
	/* FRTSTYLESHEET*/
	write_record(ba, "BrtEndStyleSheet");
	return ba.end();
}
RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";

/* 20.1.6.2 clrScheme CT_ColorScheme */
function parse_clrScheme(t, themes, opts) {
	themes.themeElements.clrScheme = [];
	var color = {};
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
			case '<a:clrScheme': case '</a:clrScheme>': break;

			/* 20.1.2.3.32 srgbClr CT_SRgbColor */
			case '<a:srgbClr':
				color.rgb = y.val; break;

			/* 20.1.2.3.33 sysClr CT_SystemColor */
			case '<a:sysClr':
				color.rgb = y.lastClr; break;

			/* 20.1.4.1.1 accent1 (Accent 1) */
			/* 20.1.4.1.2 accent2 (Accent 2) */
			/* 20.1.4.1.3 accent3 (Accent 3) */
			/* 20.1.4.1.4 accent4 (Accent 4) */
			/* 20.1.4.1.5 accent5 (Accent 5) */
			/* 20.1.4.1.6 accent6 (Accent 6) */
			/* 20.1.4.1.9 dk1 (Dark 1) */
			/* 20.1.4.1.10 dk2 (Dark 2) */
			/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
			/* 20.1.4.1.19 hlink (Hyperlink) */
			/* 20.1.4.1.22 lt1 (Light 1) */
			/* 20.1.4.1.23 lt2 (Light 2) */
			case '<a:dk1>': case '</a:dk1>':
			case '<a:lt1>': case '</a:lt1>':
			case '<a:dk2>': case '</a:dk2>':
			case '<a:lt2>': case '</a:lt2>':
			case '<a:accent1>': case '</a:accent1>':
			case '<a:accent2>': case '</a:accent2>':
			case '<a:accent3>': case '</a:accent3>':
			case '<a:accent4>': case '</a:accent4>':
			case '<a:accent5>': case '</a:accent5>':
			case '<a:accent6>': case '</a:accent6>':
			case '<a:hlink>': case '</a:hlink>':
			case '<a:folHlink>': case '</a:folHlink>':
				if (y[0].charAt(1) === '/') {
					themes.themeElements.clrScheme.push(color);
					color = {};
				} else {
					color.name = y[0].slice(3, y[0].length - 1);
				}
				break;

			default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
		}
	});
}

/* 20.1.4.1.18 fontScheme CT_FontScheme */
function parse_fontScheme() { }

/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
function parse_fmtScheme() { }

var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;

/* 20.1.6.10 themeElements CT_BaseStyles */
function parse_themeElements(data, themes, opts) {
	themes.themeElements = {};

	var t;

	[
		/* clrScheme CT_ColorScheme */
		['clrScheme', clrsregex, parse_clrScheme],
		/* fontScheme CT_FontScheme */
		['fontScheme', fntsregex, parse_fontScheme],
		/* fmtScheme CT_StyleMatrix */
		['fmtScheme', fmtsregex, parse_fmtScheme]
	].forEach(function(m) {
		if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
		m[2](t, themes, opts);
	});
}

var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;

/* 14.2.7 Theme Part */
function parse_theme_xml(data, opts) {
	/* 20.1.6.9 theme CT_OfficeStyleSheet */
	if(!data || data.length === 0) return parse_theme_xml(write_theme());

	var t;
	var themes = {};

	/* themeElements CT_BaseStyles */
	if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
	parse_themeElements(t[0], themes, opts);

	return themes;
}

function write_theme(Themes, opts) {
	if(opts && opts.themeXLSX) return opts.themeXLSX;
	var o = [XML_HEADER];
	o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
	o[o.length] =  '<a:themeElements>';

	o[o.length] =   '<a:clrScheme name="Office">';
	o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
	o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
	o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
	o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
	o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
	o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
	o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
	o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
	o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
	o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
	o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
	o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
	o[o.length] =   '</a:clrScheme>';

	o[o.length] =   '<a:fontScheme name="Office">';
	o[o.length] =    '<a:majorFont>';
	o[o.length] =     '<a:latin typeface="Cambria"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:majorFont>';
	o[o.length] =    '<a:minorFont>';
	o[o.length] =     '<a:latin typeface="Calibri"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:minorFont>';
	o[o.length] =   '</a:fontScheme>';

	o[o.length] =   '<a:fmtScheme name="Office">';
	o[o.length] =    '<a:fillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:fillStyleLst>';
	o[o.length] =    '<a:lnStyleLst>';
	o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =    '</a:lnStyleLst>';
	o[o.length] =    '<a:effectStyleLst>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
	o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =    '</a:effectStyleLst>';
	o[o.length] =    '<a:bgFillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:bgFillStyleLst>';
	o[o.length] =   '</a:fmtScheme>';
	o[o.length] =  '</a:themeElements>';

	o[o.length] =  '<a:objectDefaults>';
	o[o.length] =   '<a:spDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:spDef>';
	o[o.length] =   '<a:lnDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:lnDef>';
	o[o.length] =  '</a:objectDefaults>';
	o[o.length] =  '<a:extraClrSchemeLst/>';
	o[o.length] = '</a:theme>';
	return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
function parse_Theme(blob, length, opts) {
	var end = blob.l + length;
	var dwThemeVersion = blob.read_shift(4);
	if(dwThemeVersion === 124226) return;
	if(!opts.cellStyles || !jszip) { blob.l = end; return; }
	var data = blob.slice(blob.l);
	blob.l = end;
	var zip; try { zip = new jszip(data); } catch(e) { return; }
	var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
	if(!themeXML) return;
	return parse_theme_xml(themeXML, opts);
}

/* 2.5.49 */
function parse_ColorTheme(blob) { return blob.read_shift(4); }

/* 2.5.155 */
function parse_FullColorExt(blob) {
	var o = {};
	o.xclrType = blob.read_shift(2);
	o.nTintShade = blob.read_shift(2);
	switch(o.xclrType) {
		case 0: blob.l += 4; break;
		case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
		case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
		case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
		case 4: blob.l += 4; break;
	}
	blob.l += 8;
	return o;
}

/* 2.5.164 TODO: read 7 bits*/
function parse_IcvXF(blob, length) {
	return parsenoop(blob, length);
}

/* 2.5.280 */
function parse_XFExtGradient(blob, length) {
	return parsenoop(blob, length);
}

/* [MS-XLS] 2.5.108 */
function parse_ExtProp(blob) {
	var extType = blob.read_shift(2);
	var cb = blob.read_shift(2) - 4;
	var o = [extType];
	switch(extType) {
		case 0x04: case 0x05: case 0x07: case 0x08:
		case 0x09: case 0x0A: case 0x0B: case 0x0D:
			o[1] = parse_FullColorExt(blob, cb); break;
		case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
		case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
		default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
	}
	return o;
}

/* 2.4.355 */
function parse_XFExt(blob, length) {
	var end = blob.l + length;
	blob.l += 2;
	var ixfe = blob.read_shift(2);
	blob.l += 2;
	var cexts = blob.read_shift(2);
	var ext = [];
	while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
	return {ixfe:ixfe, ext:ext};
}

/* xf is an XF, see parse_XFExt for xfext */
function update_xfext(xf, xfext) {
	xfext.forEach(function(xfe) {
		switch(xfe[0]) { /* 2.5.108 extPropData */
			case 0x04: break; /* foreground color */
			case 0x05: break; /* background color */
			case 0x06: break; /* gradient fill */
			case 0x07: break; /* top cell border color */
			case 0x08: break; /* bottom cell border color */
			case 0x09: break; /* left cell border color */
			case 0x0a: break; /* right cell border color */
			case 0x0b: break; /* diagonal cell border color */
			case 0x0d: break; /* text color */
			case 0x0e: break; /* font scheme */
			case 0x0f: break; /* indentation level */
		}
	});
}

/* 18.6 Calculation Chain */
function parse_cc_xml(data) {
	var d = [];
	if(!data) return d;
	var i = 1;
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			/* 18.6.2  calcChain CT_CalcChain 1 */
			case '<calcChain': case '<calcChain>': case '</calcChain>': break;
			/* 18.6.1  c CT_CalcCell 1 */
			case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
		}
	});
	return d;
}

//function write_cc_xml(data, opts) { }

/* [MS-XLSB] 2.6.4.1 */
function parse_BrtCalcChainItem$(data) {
	var out = {};
	out.i = data.read_shift(4);
	var cell = {};
	cell.r = data.read_shift(4);
	cell.c = data.read_shift(4);
	out.r = encode_cell(cell);
	var flags = data.read_shift(1);
	if(flags & 0x2) out.l = '1';
	if(flags & 0x8) out.a = '1';
	return out;
}

/* 18.6 Calculation Chain */
function parse_cc_bin(data, name, opts) {
	var out = [];
	var pass = false;
	recordhopper(data, function hopper_cc(val, R_n, RT) {
		switch(RT) {
			case 0x003F: /* 'BrtCalcChainItem$' */
				out.push(val); break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */
function parse_xlink_xml() {
	//var opts = _opts || {};
	//if(opts.WTF) throw "XLSX External Link";
}

/* [MS-XLSB] 2.1.7.25 External Link */
function parse_xlink_bin(data, name, _opts) {
	if(!data) return data;
	var opts = _opts || {};

	var pass = false, end = false;

	recordhopper(data, function xlink_parse(val, R_n, RT) {
		if(end) return;
		switch(RT) {
			case 0x0167: /* 'BrtSupTabs' */
			case 0x016B: /* 'BrtExternTableStart' */
			case 0x016C: /* 'BrtExternTableEnd' */
			case 0x016E: /* 'BrtExternRowHdr' */
			case 0x016F: /* 'BrtExternCellBlank' */
			case 0x0170: /* 'BrtExternCellReal' */
			case 0x0171: /* 'BrtExternCellBool' */
			case 0x0172: /* 'BrtExternCellError' */
			case 0x0173: /* 'BrtExternCellString' */
			case 0x01D8: /* 'BrtExternValueMeta' */
			case 0x0241: /* 'BrtSupNameStart' */
			case 0x0242: /* 'BrtSupNameValueStart' */
			case 0x0243: /* 'BrtSupNameValueEnd' */
			case 0x0244: /* 'BrtSupNameNum' */
			case 0x0245: /* 'BrtSupNameErr' */
			case 0x0246: /* 'BrtSupNameSt' */
			case 0x0247: /* 'BrtSupNameNil' */
			case 0x0248: /* 'BrtSupNameBool' */
			case 0x0249: /* 'BrtSupNameFmla' */
			case 0x024A: /* 'BrtSupNameBits' */
			case 0x024B: /* 'BrtSupNameEnd' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
		}
	}, opts);
}
RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
/* 20.5 DrawingML - SpreadsheetML Drawing */
function parse_drawing(data, rels) {
	if(!data) return "??";
	/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/
	var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];

	return rels['!id'][id].Target;
}

/* L.5.5.2 SpreadsheetML Comments + VML Schema */
var _shapeid = 1024;
function write_comments_vml(rId, comments) {
	var csize = [21600, 21600];
	/* L.5.2.1.2 Path Attribute */
	var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
	var o = [
		writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
		writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
		writextag("v:shapetype", [
			writextag("v:stroke", null, {joinstyle:"miter"}),
			writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
		].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
	];
	while(_shapeid < rId * 1000) _shapeid += 1000;

	comments.forEach(function(x) { var c = decode_cell(x[0]);
	o = o.concat([
	'<v:shape' + wxt_helper({
		id:'_x0000_s' + (++_shapeid),
		type:"#_x0000_t202",
		style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10;visibility:hidden",
		fillcolor:"#ECFAD4",
		strokecolor:"#edeaa1"
	}) + '>',
		writextag('v:fill', writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}), {'color2':"#BEFF82", 'angle':"-180", 'type':"gradient"}),
		writextag("v:shadow", null, {on:"t", 'obscured':"t"}),
		writextag("v:path", null, {'o:connecttype':"none"}),
		'<v:textbox><div style="text-align:left"></div></v:textbox>',
		'<x:ClientData ObjectType="Note">',
			'<x:MoveWithCells/>',
			'<x:SizeWithCells/>',
			/* Part 4 19.4.2.3 Anchor (Anchor) */
			writetag('x:Anchor', [c.c, 0, c.r, 0, c.c+3, 100, c.r+5, 100].join(",")),
			writetag('x:AutoFill', "False"),
			writetag('x:Row', String(c.r)),
			writetag('x:Column', String(c.c)),
			'<x:Visible/>',
		'</x:ClientData>',
	'</v:shape>'
	]); });
	o.push('</xml>');
	return o.join("");
}

RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";

function parse_comments(zip, dirComments, sheets, sheetRels, opts) {
	for(var i = 0; i != dirComments.length; ++i) {
		var canonicalpath=dirComments[i];
		var comments=parse_cmnt(getzipdata(zip, canonicalpath.replace(/^\//,''), true), canonicalpath, opts);
		if(!comments || !comments.length) continue;
		// find the sheets targeted by these comments
		var sheetNames = keys(sheets);
		for(var j = 0; j != sheetNames.length; ++j) {
			var sheetName = sheetNames[j];
			var rels = sheetRels[sheetName];
			if(rels) {
				var rel = rels[canonicalpath];
				if(rel) insertCommentsIntoSheet(sheetName, sheets[sheetName], comments);
			}
		}
	}
}

function insertCommentsIntoSheet(sheetName, sheet, comments) {
	var dense = Array.isArray(sheet);
	var cell, r;
	comments.forEach(function(comment) {
		if(dense) {
			r = decode_cell(comment.ref);
			if(!sheet[r.r]) sheet[r.r] = [];
			cell = sheet[r.r][r.c];
		} else cell = sheet[comment.ref];
		if (!cell) {
			cell = {};
			if(dense) sheet[r.r][r.c] = cell;
			else sheet[comment.ref] = cell;
			var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
			var thisCell = decode_cell(comment.ref);
			if(range.s.r > thisCell.r) range.s.r = thisCell.r;
			if(range.e.r < thisCell.r) range.e.r = thisCell.r;
			if(range.s.c > thisCell.c) range.s.c = thisCell.c;
			if(range.e.c < thisCell.c) range.e.c = thisCell.c;
			var encoded = encode_range(range);
			if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
		}

		if (!cell.c) cell.c = [];
		var o = ({a: comment.author, t: comment.t, r: comment.r});
		if(comment.h) o.h = comment.h;
		cell.c.push(o);
	});
}

/* 18.7 Comments */
function parse_comments_xml(data, opts) {
	/* 18.7.6 CT_Comments */
	if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
	var authors = [];
	var commentList = [];
	var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
	if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
		if(a) authors.push(a[1]);
	});
	var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
	if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
		if(!cm) return;
		var y = parsexmltag(cm[0]);
		var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
		var cell = decode_cell(y.ref);
		if(opts.sheetRows && opts.sheetRows <= cell.r) return;
		var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
		var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
		comment.r = rt.r;
		if(rt.r == "<t></t>") rt.t = rt.h = "";
		comment.t = rt.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		if(opts.cellHTML) comment.h = rt.h;
		commentList.push(comment);
	});
	return commentList;
}

var CMNT_XML_ROOT = writextag('comments', null, { 'xmlns': XMLNS.main[0] });
function write_comments_xml(data) {
	var o = [XML_HEADER, CMNT_XML_ROOT];

	var iauthor = [];
	o.push("<authors>");
	data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
		if(iauthor.indexOf(a) > -1) return;
		iauthor.push(a);
		o.push("<author>" + a + "</author>");
	}); });
	o.push("</authors>");
	o.push("<commentList>");
	data.forEach(function(d) {
		d[1].forEach(function(c) {
			/* 18.7.3 CT_Comment */
			o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
			o.push(writetag("t", c.t == null ? "" : c.t));
			o.push('</text></comment>');
		});
	});
	o.push("</commentList>");
	if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */
function parse_BrtBeginComment(data) {
	var out = {};
	out.iauthor = data.read_shift(4);
	var rfx = parse_UncheckedRfX(data, 16);
	out.rfx = rfx.s;
	out.ref = encode_cell(rfx.s);
	data.l += 16; /*var guid = parse_GUID(data); */
	return out;
}
function write_BrtBeginComment(data, o) {
	if(o == null) o = new_buf(36);
	o.write_shift(4, data[1].iauthor);
	write_UncheckedRfX((data[0]), o);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
var parse_BrtCommentAuthor = parse_XLWideString;
function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }

/* [MS-XLSB] 2.1.7.8 Comments */
function parse_comments_bin(data, opts) {
	var out = [];
	var authors = [];
	var c = {};
	var pass = false;
	recordhopper(data, function hopper_cmnt(val, R_n, RT) {
		switch(RT) {
			case 0x0278: /* 'BrtCommentAuthor' */
				authors.push(val); break;
			case 0x027B: /* 'BrtBeginComment' */
				c = val; break;
			case 0x027D: /* 'BrtCommentText' */
				c.t = val.t; c.h = val.h; c.r = val.r; break;
			case 0x027C: /* 'BrtEndComment' */
				c.author = authors[c.iauthor];
				delete c.iauthor;
				if(opts.sheetRows && opts.sheetRows <= c.rfx.r) break;
				if(!c.t) c.t = "";
				delete c.rfx; out.push(c); break;

			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;


			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

function write_comments_bin(data) {
	var ba = buf_array();
	var iauthor = [];
	write_record(ba, "BrtBeginComments");

	write_record(ba, "BrtBeginCommentAuthors");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			if(iauthor.indexOf(c.a) > -1) return;
			iauthor.push(c.a.slice(0,54));
			write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
		});
	});
	write_record(ba, "BrtEndCommentAuthors");

	write_record(ba, "BrtBeginCommentList");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			c.iauthor = iauthor.indexOf(c.a);
			var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
			write_record(ba, "BrtBeginComment", write_BrtBeginComment([range, c]));
			if(c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
			write_record(ba, "BrtEndComment");
			delete c.iauthor;
		});
	});
	write_record(ba, "BrtEndCommentList");

	write_record(ba, "BrtEndComments");
	return ba.end();
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(cfb) {
	var newcfb = CFB.utils.cfb_new({root:"R"});
	cfb.FullPaths.forEach(function(p, i) {
		if(p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
		var newpath = p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
		CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
	});
	return CFB.write(newcfb);
}

function fill_vba_xls(cfb, vba) {
	vba.FullPaths.forEach(function(p, i) {
		if(i == 0) return;
		var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
		if(newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
	});
}

var VBAFMTS = [ "xlsb", "xlsm", "xlam", "biff8", "xla" ];

RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";

/* macro and dialog sheet stubs */
function parse_ds_bin() { return {'!type':'dialog'}; }
function parse_ds_xml() { return {'!type':'dialog'}; }
function parse_ms_bin() { return {'!type':'macro'}; }
function parse_ms_xml() { return {'!type':'macro'}; }
/* TODO: it will be useful to parse the function str */
var rc_to_a1 = (function(){
	var rcregex = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
	var rcbase = ({r:0,c:0});
	function rcfunc($$,$1,$2,$3,$4,$5) {
		var R = $3.length>0?parseInt($3,10)|0:0, C = $5.length>0?parseInt($5,10)|0:0;
		if(C<0 && $4.length === 0) C=0;
		var cRel = false, rRel = false;
		if($4.length > 0 || $5.length == 0) cRel = true; if(cRel) C += rcbase.c; else --C;
		if($2.length > 0 || $3.length == 0) rRel = true; if(rRel) R += rcbase.r; else --R;
		return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
	}
	return function rc_to_a1(fstr, base) {
		rcbase = base;
		return fstr.replace(rcregex, rcfunc);
	};
})();

var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g;
var a1_to_rc =(function(){
	return function a1_to_rc(fstr, base) {
		return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			var c = decode_col($3) - ($2 ? 0 : base.c);
			var r = decode_row($5) - ($4 ? 0 : base.r);
			var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
			var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
			return $1 + "R" + R + "C" + C;
		});
	};
})();

/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
function shift_formula_str(f, delta) {
	return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
		return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
	});
}

function shift_formula_xlsx(f, range, cell) {
	var r = decode_range(range), s = r.s, c = decode_cell(cell);
	var delta = {r:c.r - s.r, c:c.c - s.c};
	return shift_formula_str(f, delta);
}

/* TODO: parse formula */
function fuzzyfmla(f) {
	if(f.length == 1) return false;
	return true;
}

function _xlfn(f) {
	return f.replace(/_xlfn\./g,"");
}
function parseread1(blob) { blob.l+=1; return; }

/* [MS-XLS] 2.5.51 */
function parse_ColRelU(blob, length) {
	var c = blob.read_shift(length == 1 ? 1 : 2);
	return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
function parse_RgceArea(blob, length, opts) {
	var w = 2;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
		else if(opts.biff == 12) w = 4;
	}
	var r=blob.read_shift(w), R=blob.read_shift(w);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}
/* BIFF 2-5 encodes flags in the row field */
function parse_RgceArea_BIFF2(blob) {
	var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
	var c=blob.read_shift(1);
	var C=blob.read_shift(1);
	return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
function parse_RgceAreaRel(blob, length, opts) {
	if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
	var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}

/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
function parse_RgceLoc(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
	var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
	var c = parse_ColRelU(blob, 2);
	return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
}
function parse_RgceLoc_BIFF2(blob) {
	var r = parse_ColRelU(blob, 2);
	var c = blob.read_shift(1);
	return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
}

/* [MS-XLS] 2.5.198.107, 2.5.47 */
function parse_RgceElfLoc(blob) {
	var r = blob.read_shift(2);
	var c = blob.read_shift(2);
	return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
}

/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
function parse_RgceLocRel(blob, length, opts) {
	var biff = opts && opts.biff ? opts.biff : 8;
	if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
	var r = blob.read_shift(biff >= 12 ? 4 : 2);
	var cl = blob.read_shift(2);
	var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
	cl &= 0x3FFF;
	if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
	if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
	return {r:r,c:cl,cRel:cRel,rRel:rRel};
}
function parse_RgceLocRel_BIFF2(blob) {
	var rl = blob.read_shift(2);
	var c = blob.read_shift(1);
	var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
	rl &= 0x3FFF;
	if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
	if(cRel == 1 && c >= 0x80) c = c - 0x100;
	return {r:rl,c:c,cRel:cRel,rRel:rRel};
}

/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
function parse_PtgArea(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
function parse_PtgArea3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2, 'i');
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	var area = parse_RgceArea(blob, w, opts);
	return [type, ixti, area];
}

/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
function parse_PtgAreaErr(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
	return [type];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
function parse_PtgAreaErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
function parse_PtgAreaN(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceAreaRel(blob, length - 1, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
function parse_PtgArray(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
	return [type];
}

/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
function parse_PtgAttrBaxcel(blob) {
	var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
	var bitBaxcel = 1;
	blob.l += 4;
	return [bitSemi, bitBaxcel];
}

/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
function parse_PtgAttrChoose(blob, length, opts) {
	blob.l +=2;
	var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var o = [];
	/* offset is 1 less than the number of elements */
	for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
	return o;
}

/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
function parse_PtgAttrGoto(blob, length, opts) {
	var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
function parse_PtgAttrIf(blob, length, opts) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLSB] 2.5.97.28 */
function parse_PtgAttrIfError(blob) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(2)];
}

/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
function parse_PtgAttrSemi(blob, length, opts) {
	var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += opts && opts.biff == 2 ? 3 : 4;
	return [bitSemi];
}

/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
function parse_PtgAttrSpaceType(blob) {
	var type = blob.read_shift(1), cch = blob.read_shift(1);
	return [type, cch];
}

/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
function parse_PtgAttrSpace(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
function parse_PtgAttrSpaceSemi(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob, 2);
}

/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
function parse_PtgRef(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLoc(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
function parse_PtgRefN(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLocRel(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
function parse_PtgRef3d(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var ixti = blob.read_shift(2); // XtiIndex
	if(opts && opts.biff == 5) blob.l += 12;
	var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
	return [type, ixti, loc];
}


/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
function parse_PtgFunc(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
	return [FtabArgc[iftab], Ftab[iftab], type];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
function parse_PtgFuncVar(blob, length, opts) {
	var type = blob[blob.l++];
	var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
	return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
}

function parsetab(blob) {
	return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
}

/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
function parse_PtgAttrSum(blob, length, opts) {
	blob.l += opts && opts.biff == 2 ? 3 : 4; return;
}

/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
function parse_PtgExp(blob, length, opts) {
	blob.l++;
	if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
	var row = blob.read_shift(2);
	var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [row, col];
}

/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }

/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }

/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}

/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }

/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }

/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
function parse_SerAr(blob, biff) {
	var val = [blob.read_shift(1)];
	if(biff == 12) switch(val[0]) {
		case 0x02: val[0] = 0x04; break; /* SerBool */
		case 0x04: val[0] = 0x10; break; /* SerErr */
		case 0x00: val[0] = 0x01; break; /* SerNum */
		case 0x01: val[0] = 0x02; break; /* SerStr */
	}
	switch(val[0]) {
		case 0x04: /* SerBool -- boolean */
			val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
			if(biff != 12) blob.l += 7; break;
		case 0x25: /* appears to be an alias */
		case 0x10: /* SerErr -- error */
			val[1] = BErr[blob[blob.l]];
			blob.l += ((biff == 12) ? 4 : 8); break;
		case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
			blob.l += 8; break;
		case 0x01: /* SerNum -- Xnum */
			val[1] = parse_Xnum(blob, 8); break;
		case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
			val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
		default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
	}
	return val;
}

/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
function parse_PtgExtraMem(blob, cce, opts) {
	var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
	var out = [];
	for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
	return out;
}

/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
function parse_PtgExtraArray(blob, length, opts) {
	var rows = 0, cols = 0;
	if(opts.biff == 12) {
		rows = blob.read_shift(4); // DRw
		cols = blob.read_shift(4); // DCol
	} else {
		cols = 1 + blob.read_shift(1); //DColByteU
		rows = 1 + blob.read_shift(2); //DRw
	}
	if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
	// $FlowIgnore
	for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
		for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
	return o;
}

/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
function parse_PtgName(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
	var nameindex = blob.read_shift(w);
	switch(opts.biff) {
		case 2: blob.l += 5; break;
		case 3: case 4: blob.l += 8; break;
		case 5: blob.l += 12; break;
	}
	return [type, 0, nameindex];
}

/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
function parse_PtgNameX(blob, length, opts) {
	if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2); // XtiIndex
	var nameindex = blob.read_shift(4);
	return [type, ixti, nameindex];
}
function parse_PtgNameX_BIFF5(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2, 'i'); // XtiIndex
	blob.l += 8;
	var nameindex = blob.read_shift(2);
	blob.l += 12;
	return [type, ixti, nameindex];
}

/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
function parse_PtgMemArea(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += (opts && opts.biff == 2 ? 3 : 4);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}

/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
function parse_PtgMemFunc(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}


/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
function parse_PtgRefErr(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += 4;
	if(opts.biff < 8) blob.l--;
	if(opts.biff == 12) blob.l += 2;
	return [type];
}

/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
function parse_PtgRefErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 4;
	if(opts) switch(opts.biff) {
		case 5: w = 15; break;
		case 12: w = 6; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
var parse_PtgMemErr = parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
var parse_PtgMemNoMem = parsenoop;
/* [MS-XLS] 2.5.198.92 */
var parse_PtgTbl = parsenoop;

function parse_PtgElfLoc(blob, length, opts) {
	blob.l += 2;
	return [parse_RgceElfLoc(blob, 4, opts)];
}
function parse_PtgElfNoop(blob) {
	blob.l += 6;
	return [];
}
/* [MS-XLS] 2.5.198.46 */
var parse_PtgElfCol = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */
var parse_PtgElfColS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */
var parse_PtgElfColSV = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */
var parse_PtgElfColV = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */
function parse_PtgElfLel(blob) {
	blob.l += 2;
	return [parseuint16(blob), blob.read_shift(2) & 0x01];
}
/* [MS-XLS] 2.5.198.51 */
var parse_PtgElfRadical = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */
var parse_PtgElfRadicalLel = parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */
var parse_PtgElfRadicalS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */
var parse_PtgElfRw = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */
var parse_PtgElfRwV = parse_PtgElfLoc;

/* [MS-XLSB] 2.5.97.52 TODO */
var PtgListRT = [
	"Data",
	"All",
	"Headers",
	"??",
	"?Data2",
	"??",
	"?DataHeaders",
	"??",
	"Totals",
	"??",
	"??",
	"??",
	"?DataTotals",
	"??",
	"??",
	"??",
	"?Current"
];
function parse_PtgList(blob) {
	blob.l += 2;
	var ixti = blob.read_shift(2);
	var flags = blob.read_shift(2);
	var idx = blob.read_shift(4);
	var c = blob.read_shift(2);
	var C = blob.read_shift(2);
	var rt = PtgListRT[(flags >> 2) & 0x1F];
	return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
function parse_PtgSxName(blob) {
	blob.l += 2;
	return [blob.read_shift(4)];
}

/* [XLS] old spec */
function parse_PtgSheet(blob, length, opts) {
	blob.l += 5;
	blob.l += 2;
	blob.l += (opts.biff == 2 ? 1 : 4);
	return ["PTGSHEET"];
}
function parse_PtgEndSheet(blob, length, opts) {
	blob.l += (opts.biff == 2 ? 4 : 5);
	return ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgMemNoMemN(blob) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgAttrNoop(blob) {
	blob.l += 4;
	return [0, 0];
}

/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
var PtgTypes = {
0x01: { n:'PtgExp', f:parse_PtgExp },
0x02: { n:'PtgTbl', f:parse_PtgTbl },
0x03: { n:'PtgAdd', f:parseread1 },
0x04: { n:'PtgSub', f:parseread1 },
0x05: { n:'PtgMul', f:parseread1 },
0x06: { n:'PtgDiv', f:parseread1 },
0x07: { n:'PtgPower', f:parseread1 },
0x08: { n:'PtgConcat', f:parseread1 },
0x09: { n:'PtgLt', f:parseread1 },
0x0A: { n:'PtgLe', f:parseread1 },
0x0B: { n:'PtgEq', f:parseread1 },
0x0C: { n:'PtgGe', f:parseread1 },
0x0D: { n:'PtgGt', f:parseread1 },
0x0E: { n:'PtgNe', f:parseread1 },
0x0F: { n:'PtgIsect', f:parseread1 },
0x10: { n:'PtgUnion', f:parseread1 },
0x11: { n:'PtgRange', f:parseread1 },
0x12: { n:'PtgUplus', f:parseread1 },
0x13: { n:'PtgUminus', f:parseread1 },
0x14: { n:'PtgPercent', f:parseread1 },
0x15: { n:'PtgParen', f:parseread1 },
0x16: { n:'PtgMissArg', f:parseread1 },
0x17: { n:'PtgStr', f:parse_PtgStr },
0x1A: { n:'PtgSheet', f:parse_PtgSheet },
0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
0x1C: { n:'PtgErr', f:parse_PtgErr },
0x1D: { n:'PtgBool', f:parse_PtgBool },
0x1E: { n:'PtgInt', f:parse_PtgInt },
0x1F: { n:'PtgNum', f:parse_PtgNum },
0x20: { n:'PtgArray', f:parse_PtgArray },
0x21: { n:'PtgFunc', f:parse_PtgFunc },
0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
0x23: { n:'PtgName', f:parse_PtgName },
0x24: { n:'PtgRef', f:parse_PtgRef },
0x25: { n:'PtgArea', f:parse_PtgArea },
0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
0x2C: { n:'PtgRefN', f:parse_PtgRefN },
0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
0x39: { n:'PtgNameX', f:parse_PtgNameX },
0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
0xFF: {}
};
/* These are duplicated in the PtgTypes table */
var PtgDupes = {
0x40: 0x20, 0x60: 0x20,
0x41: 0x21, 0x61: 0x21,
0x42: 0x22, 0x62: 0x22,
0x43: 0x23, 0x63: 0x23,
0x44: 0x24, 0x64: 0x24,
0x45: 0x25, 0x65: 0x25,
0x46: 0x26, 0x66: 0x26,
0x47: 0x27, 0x67: 0x27,
0x48: 0x28, 0x68: 0x28,
0x49: 0x29, 0x69: 0x29,
0x4A: 0x2A, 0x6A: 0x2A,
0x4B: 0x2B, 0x6B: 0x2B,
0x4C: 0x2C, 0x6C: 0x2C,
0x4D: 0x2D, 0x6D: 0x2D,
0x4E: 0x2E, 0x6E: 0x2E,
0x4F: 0x2F, 0x6F: 0x2F,
0x58: 0x22, 0x78: 0x22,
0x59: 0x39, 0x79: 0x39,
0x5A: 0x3A, 0x7A: 0x3A,
0x5B: 0x3B, 0x7B: 0x3B,
0x5C: 0x3C, 0x7C: 0x3C,
0x5D: 0x3D, 0x7D: 0x3D
};
(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();

var Ptg18 = {
0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
0x19: { n:'PtgList', f:parse_PtgList },
0x1D: { n:'PtgSxName', f:parse_PtgSxName },
0xFF: {}
};
var Ptg19 = {
0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
0xFF: {}
};
Ptg19[0x21] = Ptg19[0x20];

/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
function parse_RgbExtra(blob, length, rgce, opts) {
	if(opts.biff < 8) return parsenoop(blob, length);
	var target = blob.l + length;
	var o = [];
	for(var i = 0; i !== rgce.length; ++i) {
		switch(rgce[i][0]) {
			case 'PtgArray': /* PtgArray -> PtgExtraArray */
				rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
				o.push(rgce[i][1]);
				break;
			case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
				rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
				o.push(rgce[i][2]);
				break;
			case 'PtgExp': /* PtgExp -> PtgExtraCol */
				if(opts && opts.biff == 12) {
					rgce[i][1][1] = blob.read_shift(4);
					o.push(rgce[i][1]);
				} break;
			case 'PtgList': /* TODO: PtgList -> PtgExtraList */
			case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
			case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
			case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
				throw "Unsupported " + rgce[i][0];
			default: break;
		}
	}
	length = target - blob.l;
	/* note: this is technically an error but Excel disregards */
	//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
	if(length !== 0) o.push(parsenoop(blob, length));
	return o;
}

/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
function parse_Rgce(blob, length, opts) {
	var target = blob.l + length;
	var R, id, ptgs = [];
	while(target != blob.l) {
		length = target - blob.l;
		id = blob[blob.l];
		R = PtgTypes[id];
		if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
		if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
		else { ptgs.push([R.n, R.f(blob, length, opts)]); }
	}
	return ptgs;
}

function stringify_array(f) {
	var o = [];
	for(var i = 0; i < f.length; ++i) {
		var x = f[i], r = [];
		for(var j = 0; j < x.length; ++j) {
			var y = x[j];
			if(y) switch(y[0]) {
				// TODO: handle embedded quotes
				case 0x02:
r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
				default: r.push(y[1]);
			} else r.push("");
		}
		o.push(r.join(","));
	}
	return o.join(";");
}

/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
var PtgBinOp = {
	PtgAdd: "+",
	PtgConcat: "&",
	PtgDiv: "/",
	PtgEq: "=",
	PtgGe: ">=",
	PtgGt: ">",
	PtgLe: "<=",
	PtgLt: "<",
	PtgMul: "*",
	PtgNe: "<>",
	PtgPower: "^",
	PtgSub: "-"
};
function formula_quote_sheet_name(sname, opts) {
	if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
	if(sname.indexOf(" ") > -1) return "'" + sname + "'";
	return sname;
}
function get_ixti_raw(supbooks, ixti, opts) {
	if(!supbooks) return "SH33TJSERR0";
	if(!supbooks.XTI) return "SH33TJSERR6";
	var XTI = supbooks.XTI[ixti];
	if(opts.biff > 8 && !supbooks.XTI[ixti]) return supbooks.SheetNames[ixti];
	if(opts.biff < 8) {
		if(ixti > 10000) ixti-= 65536;
		if(ixti < 0) ixti = -ixti;
		return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
	}
	if(!XTI) return "SH33TJSERR1";
	var o = "";
	if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
		case 0x0165: /* 'BrtSupSelf' */
			o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x0166: /* 'BrtSupSame' */
			if(opts.SID != null) return supbooks.SheetNames[opts.SID];
			return "SH33TJSSAME" + supbooks[XTI[0]][0];
		case 0x0163: /* 'BrtSupBookSrc' */
			/* falls through */
		default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
	}
	switch(supbooks[XTI[0]][0][0]) {
		case 0x0401:
			o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x3A01: return "SH33TJSERR8";
		default:
			if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
			o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
	}
}
function get_ixti(supbooks, ixti, opts) {
	return formula_quote_sheet_name(get_ixti_raw(supbooks, ixti, opts), opts);
}
function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
	var biff = (opts && opts.biff) || 8;
	var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
	var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
	if(!formula[0] || !formula[0][0]) return "";
	var last_sp = -1, sp = "";
	for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
		var f = formula[0][ff];
		switch(f[0]) {
			case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
				stack.push("-" + stack.pop()); break;
			case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
				stack.push("+" + stack.pop()); break;
			case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
				stack.push(stack.pop() + "%"); break;

			case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
			case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
			case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
			case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
			case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
			case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
			case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
			case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
			case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
			case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
			case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
			case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
				e1 = stack.pop(); e2 = stack.pop();
				if(last_sp >= 0) {
					switch(formula[0][last_sp][1][0]) {
						case 0:
							// $FlowIgnore
							sp = fill(" ", formula[0][last_sp][1][1]); break;
						case 1:
							// $FlowIgnore
							sp = fill("\r", formula[0][last_sp][1][1]); break;
						default:
							sp = "";
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					e2 = e2 + sp;
					last_sp = -1;
				}
				stack.push(e2+PtgBinOp[f[0]]+e1);
				break;

			case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+" "+e1);
				break;
			case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+","+e1);
				break;
			case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+":"+e1);
				break;

			case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
				break;
			case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
				break;
			case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
				break;
			case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
				break;


			case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
c = shift_cell_xls((f[1][1]), _range, opts);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
				sname = get_ixti(supbooks, ixti, opts);
				var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
				stack.push(sname + "!" + encode_cell_xls(c, biff));
				break;

			case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
			case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
				/* f[1] = [argc, func, type] */
				var argc = (f[1][0]), func = (f[1][1]);
				if(!argc) argc = 0;
				argc &= 0x7F;
				var args = argc == 0 ? [] : stack.slice(-argc);
				stack.length -= argc;
				if(func === 'User') func = args.shift();
				stack.push(func + "(" + args.join(",") + ")");
				break;

			case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
				stack.push(f[1] ? "TRUE" : "FALSE"); break;
			case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
				stack.push(f[1]); break;
			case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
				stack.push(String(f[1])); break;
			case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
				// $FlowIgnore
				stack.push('"' + f[1] + '"'); break;
			case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
				stack.push(f[1]); break;
			case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
r = shift_range_xls(f[1][1], _range, opts);
				stack.push(encode_range_xls((r), opts));
				break;
			case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
ixti = f[1][1]; r = f[1][2];
				sname = get_ixti(supbooks, ixti, opts);
				stack.push(sname + "!" + encode_range_xls((r), opts));
				break;
			case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
				stack.push("SUM(" + stack.pop() + ")");
				break;

			case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
			case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
				break;

			case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
				/* f[1] = type, 0, nameindex */
				nameidx = (f[1][2]);
				var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
				var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
				if(name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
				stack.push(name);
				break;

			case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
				/* f[1] = type, ixti, nameindex */
				var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
				/* TODO: Properly handle missing values */
				if(opts.biff <= 5) {
					if(bookidx < 0) bookidx = -bookidx;
					if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
				} else {
					var o = "";
					if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
					else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
						if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
							o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
						}
					}
					else o = supbooks.SheetNames[nameidx-1]+ "!";
					if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
					else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
					else o += "SH33TJSERRX";
					stack.push(o);
					break;
				}
				if(!externbook) externbook = {Name: "SH33TJSERRY"};
				stack.push(externbook.Name);
				break;

			case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
				var lp = '(', rp = ')';
				if(last_sp >= 0) {
					sp = "";
					switch(formula[0][last_sp][1][0]) {
						// $FlowIgnore
						case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
						// $FlowIgnore
						case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
						default:
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					last_sp = -1;
				}
				stack.push(lp + stack.pop() + rp); break;

			case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
				stack.push('#REF!'); break;

			case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
				stack.push('#REF!'); break;

			case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
				c = {c:(f[1][1]),r:(f[1][0])};
				var q = ({c: cell.c, r:cell.r});
				if(supbooks.sharedf[encode_cell(c)]) {
					var parsedf = (supbooks.sharedf[encode_cell(c)]);
					stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
				}
				else {
					var fnd = false;
					for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
						/* TODO: should be something like range_has */
						e2 = supbooks.arrayf[e1];
						if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
						if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
						stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
						fnd = true;
						break;
					}
					if(!fnd) stack.push(f[1]);
				}
				break;

			case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
				stack.push("{" + stringify_array(f[1]) + "}");
				break;

			case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
				//stack.push("(" + f[2].map(encode_range).join(",") + ")");
				break;

			case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
			case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
				last_sp = ff;
				break;

			case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
				break;

			case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
				break;

			case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
				stack.push("");
				break;

			case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
				stack.push("#REF!"); break;

			case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
				stack.push("#REF!"); break;

			case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
				// $FlowIgnore
				stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
				break;

			case 'PtgMemAreaN':
			case 'PtgMemNoMemN':
			case 'PtgAttrNoop':
			case 'PtgSheet':
			case 'PtgEndSheet':
				break;

			case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
				break;
			case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
				break;

			case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
			case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
			case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
			case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
			case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
			case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
			case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
			case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
			case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
			case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
				throw new Error("Unsupported ELFs");

			case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
				throw new Error('Unrecognized Formula Token: ' + String(f));
			default: throw new Error('Unrecognized Formula Token: ' + String(f));
		}
		var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
		if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
			f = formula[0][last_sp];
			var _left = true;
			switch(f[1][0]) {
				/* note: some bad XLSB files omit the PtgParen */
				case 4: _left = false;
				/* falls through */
				case 0:
					// $FlowIgnore
					sp = fill(" ", f[1][1]); break;
				case 5: _left = false;
				/* falls through */
				case 1:
					// $FlowIgnore
					sp = fill("\r", f[1][1]); break;
				default:
					sp = "";
					// $FlowIgnore
					if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
			}
			stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
			last_sp = -1;
		}
	}
	if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
	return stack[0];
}

/* [MS-XLS] 2.5.198.1 TODO */
function parse_ArrayParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.3 TODO */
function parse_XLSCellParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.21 */
function parse_NameParsedFormula(blob, length, opts, cce) {
	var target = blob.l + length;
	var rgce = parse_Rgce(blob, cce, opts);
	var rgcb;
	if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.118 TODO */
function parse_SharedParsedFormula(blob, length, opts) {
	var target = blob.l + length;
	var rgcb, cce = blob.read_shift(2); // length of rgce
	var rgce = parse_Rgce(blob, cce, opts);
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
function parse_FormulaValue(blob) {
	var b;
	if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
	switch(blob[blob.l]) {
		case 0x00: blob.l += 8; return ["String", 's'];
		case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
		case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
		case 0x03: blob.l += 8; return ["",'s'];
	}
	return [];
}

/* [MS-XLS] 2.4.127 TODO */
function parse_Formula(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob, 6);
	if(opts.biff == 2) ++blob.l;
	var val = parse_FormulaValue(blob,8);
	var flags = blob.read_shift(1);
	if(opts.biff != 2) {
		blob.read_shift(1);
		if(opts.biff >= 5) {
			/*var chn = */blob.read_shift(4);
		}
	}
	var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
	return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
}

/* XLSB Parsed Formula records have the same shape */
function parse_XLSBParsedFormula(data, length, opts) {
	var cce = data.read_shift(4);
	var rgce = parse_Rgce(data, cce, opts);
	var cb = data.read_shift(4);
	var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
	return [rgce, rgcb];
}

/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLS] 2.5.198.4 */
var Cetab = {
0x0000: 'BEEP',
0x0001: 'OPEN',
0x0002: 'OPEN.LINKS',
0x0003: 'CLOSE.ALL',
0x0004: 'SAVE',
0x0005: 'SAVE.AS',
0x0006: 'FILE.DELETE',
0x0007: 'PAGE.SETUP',
0x0008: 'PRINT',
0x0009: 'PRINTER.SETUP',
0x000A: 'QUIT',
0x000B: 'NEW.WINDOW',
0x000C: 'ARRANGE.ALL',
0x000D: 'WINDOW.SIZE',
0x000E: 'WINDOW.MOVE',
0x000F: 'FULL',
0x0010: 'CLOSE',
0x0011: 'RUN',
0x0016: 'SET.PRINT.AREA',
0x0017: 'SET.PRINT.TITLES',
0x0018: 'SET.PAGE.BREAK',
0x0019: 'REMOVE.PAGE.BREAK',
0x001A: 'FONT',
0x001B: 'DISPLAY',
0x001C: 'PROTECT.DOCUMENT',
0x001D: 'PRECISION',
0x001E: 'A1.R1C1',
0x001F: 'CALCULATE.NOW',
0x0020: 'CALCULATION',
0x0022: 'DATA.FIND',
0x0023: 'EXTRACT',
0x0024: 'DATA.DELETE',
0x0025: 'SET.DATABASE',
0x0026: 'SET.CRITERIA',
0x0027: 'SORT',
0x0028: 'DATA.SERIES',
0x0029: 'TABLE',
0x002A: 'FORMAT.NUMBER',
0x002B: 'ALIGNMENT',
0x002C: 'STYLE',
0x002D: 'BORDER',
0x002E: 'CELL.PROTECTION',
0x002F: 'COLUMN.WIDTH',
0x0030: 'UNDO',
0x0031: 'CUT',
0x0032: 'COPY',
0x0033: 'PASTE',
0x0034: 'CLEAR',
0x0035: 'PASTE.SPECIAL',
0x0036: 'EDIT.DELETE',
0x0037: 'INSERT',
0x0038: 'FILL.RIGHT',
0x0039: 'FILL.DOWN',
0x003D: 'DEFINE.NAME',
0x003E: 'CREATE.NAMES',
0x003F: 'FORMULA.GOTO',
0x0040: 'FORMULA.FIND',
0x0041: 'SELECT.LAST.CELL',
0x0042: 'SHOW.ACTIVE.CELL',
0x0043: 'GALLERY.AREA',
0x0044: 'GALLERY.BAR',
0x0045: 'GALLERY.COLUMN',
0x0046: 'GALLERY.LINE',
0x0047: 'GALLERY.PIE',
0x0048: 'GALLERY.SCATTER',
0x0049: 'COMBINATION',
0x004A: 'PREFERRED',
0x004B: 'ADD.OVERLAY',
0x004C: 'GRIDLINES',
0x004D: 'SET.PREFERRED',
0x004E: 'AXES',
0x004F: 'LEGEND',
0x0050: 'ATTACH.TEXT',
0x0051: 'ADD.ARROW',
0x0052: 'SELECT.CHART',
0x0053: 'SELECT.PLOT.AREA',
0x0054: 'PATTERNS',
0x0055: 'MAIN.CHART',
0x0056: 'OVERLAY',
0x0057: 'SCALE',
0x0058: 'FORMAT.LEGEND',
0x0059: 'FORMAT.TEXT',
0x005A: 'EDIT.REPEAT',
0x005B: 'PARSE',
0x005C: 'JUSTIFY',
0x005D: 'HIDE',
0x005E: 'UNHIDE',
0x005F: 'WORKSPACE',
0x0060: 'FORMULA',
0x0061: 'FORMULA.FILL',
0x0062: 'FORMULA.ARRAY',
0x0063: 'DATA.FIND.NEXT',
0x0064: 'DATA.FIND.PREV',
0x0065: 'FORMULA.FIND.NEXT',
0x0066: 'FORMULA.FIND.PREV',
0x0067: 'ACTIVATE',
0x0068: 'ACTIVATE.NEXT',
0x0069: 'ACTIVATE.PREV',
0x006A: 'UNLOCKED.NEXT',
0x006B: 'UNLOCKED.PREV',
0x006C: 'COPY.PICTURE',
0x006D: 'SELECT',
0x006E: 'DELETE.NAME',
0x006F: 'DELETE.FORMAT',
0x0070: 'VLINE',
0x0071: 'HLINE',
0x0072: 'VPAGE',
0x0073: 'HPAGE',
0x0074: 'VSCROLL',
0x0075: 'HSCROLL',
0x0076: 'ALERT',
0x0077: 'NEW',
0x0078: 'CANCEL.COPY',
0x0079: 'SHOW.CLIPBOARD',
0x007A: 'MESSAGE',
0x007C: 'PASTE.LINK',
0x007D: 'APP.ACTIVATE',
0x007E: 'DELETE.ARROW',
0x007F: 'ROW.HEIGHT',
0x0080: 'FORMAT.MOVE',
0x0081: 'FORMAT.SIZE',
0x0082: 'FORMULA.REPLACE',
0x0083: 'SEND.KEYS',
0x0084: 'SELECT.SPECIAL',
0x0085: 'APPLY.NAMES',
0x0086: 'REPLACE.FONT',
0x0087: 'FREEZE.PANES',
0x0088: 'SHOW.INFO',
0x0089: 'SPLIT',
0x008A: 'ON.WINDOW',
0x008B: 'ON.DATA',
0x008C: 'DISABLE.INPUT',
0x008E: 'OUTLINE',
0x008F: 'LIST.NAMES',
0x0090: 'FILE.CLOSE',
0x0091: 'SAVE.WORKBOOK',
0x0092: 'DATA.FORM',
0x0093: 'COPY.CHART',
0x0094: 'ON.TIME',
0x0095: 'WAIT',
0x0096: 'FORMAT.FONT',
0x0097: 'FILL.UP',
0x0098: 'FILL.LEFT',
0x0099: 'DELETE.OVERLAY',
0x009B: 'SHORT.MENUS',
0x009F: 'SET.UPDATE.STATUS',
0x00A1: 'COLOR.PALETTE',
0x00A2: 'DELETE.STYLE',
0x00A3: 'WINDOW.RESTORE',
0x00A4: 'WINDOW.MAXIMIZE',
0x00A6: 'CHANGE.LINK',
0x00A7: 'CALCULATE.DOCUMENT',
0x00A8: 'ON.KEY',
0x00A9: 'APP.RESTORE',
0x00AA: 'APP.MOVE',
0x00AB: 'APP.SIZE',
0x00AC: 'APP.MINIMIZE',
0x00AD: 'APP.MAXIMIZE',
0x00AE: 'BRING.TO.FRONT',
0x00AF: 'SEND.TO.BACK',
0x00B9: 'MAIN.CHART.TYPE',
0x00BA: 'OVERLAY.CHART.TYPE',
0x00BB: 'SELECT.END',
0x00BC: 'OPEN.MAIL',
0x00BD: 'SEND.MAIL',
0x00BE: 'STANDARD.FONT',
0x00BF: 'CONSOLIDATE',
0x00C0: 'SORT.SPECIAL',
0x00C1: 'GALLERY.3D.AREA',
0x00C2: 'GALLERY.3D.COLUMN',
0x00C3: 'GALLERY.3D.LINE',
0x00C4: 'GALLERY.3D.PIE',
0x00C5: 'VIEW.3D',
0x00C6: 'GOAL.SEEK',
0x00C7: 'WORKGROUP',
0x00C8: 'FILL.GROUP',
0x00C9: 'UPDATE.LINK',
0x00CA: 'PROMOTE',
0x00CB: 'DEMOTE',
0x00CC: 'SHOW.DETAIL',
0x00CE: 'UNGROUP',
0x00CF: 'OBJECT.PROPERTIES',
0x00D0: 'SAVE.NEW.OBJECT',
0x00D1: 'SHARE',
0x00D2: 'SHARE.NAME',
0x00D3: 'DUPLICATE',
0x00D4: 'APPLY.STYLE',
0x00D5: 'ASSIGN.TO.OBJECT',
0x00D6: 'OBJECT.PROTECTION',
0x00D7: 'HIDE.OBJECT',
0x00D8: 'SET.EXTRACT',
0x00D9: 'CREATE.PUBLISHER',
0x00DA: 'SUBSCRIBE.TO',
0x00DB: 'ATTRIBUTES',
0x00DC: 'SHOW.TOOLBAR',
0x00DE: 'PRINT.PREVIEW',
0x00DF: 'EDIT.COLOR',
0x00E0: 'SHOW.LEVELS',
0x00E1: 'FORMAT.MAIN',
0x00E2: 'FORMAT.OVERLAY',
0x00E3: 'ON.RECALC',
0x00E4: 'EDIT.SERIES',
0x00E5: 'DEFINE.STYLE',
0x00F0: 'LINE.PRINT',
0x00F3: 'ENTER.DATA',
0x00F9: 'GALLERY.RADAR',
0x00FA: 'MERGE.STYLES',
0x00FB: 'EDITION.OPTIONS',
0x00FC: 'PASTE.PICTURE',
0x00FD: 'PASTE.PICTURE.LINK',
0x00FE: 'SPELLING',
0x0100: 'ZOOM',
0x0103: 'INSERT.OBJECT',
0x0104: 'WINDOW.MINIMIZE',
0x0109: 'SOUND.NOTE',
0x010A: 'SOUND.PLAY',
0x010B: 'FORMAT.SHAPE',
0x010C: 'EXTEND.POLYGON',
0x010D: 'FORMAT.AUTO',
0x0110: 'GALLERY.3D.BAR',
0x0111: 'GALLERY.3D.SURFACE',
0x0112: 'FILL.AUTO',
0x0114: 'CUSTOMIZE.TOOLBAR',
0x0115: 'ADD.TOOL',
0x0116: 'EDIT.OBJECT',
0x0117: 'ON.DOUBLECLICK',
0x0118: 'ON.ENTRY',
0x0119: 'WORKBOOK.ADD',
0x011A: 'WORKBOOK.MOVE',
0x011B: 'WORKBOOK.COPY',
0x011C: 'WORKBOOK.OPTIONS',
0x011D: 'SAVE.WORKSPACE',
0x0120: 'CHART.WIZARD',
0x0121: 'DELETE.TOOL',
0x0122: 'MOVE.TOOL',
0x0123: 'WORKBOOK.SELECT',
0x0124: 'WORKBOOK.ACTIVATE',
0x0125: 'ASSIGN.TO.TOOL',
0x0127: 'COPY.TOOL',
0x0128: 'RESET.TOOL',
0x0129: 'CONSTRAIN.NUMERIC',
0x012A: 'PASTE.TOOL',
0x012E: 'WORKBOOK.NEW',
0x0131: 'SCENARIO.CELLS',
0x0132: 'SCENARIO.DELETE',
0x0133: 'SCENARIO.ADD',
0x0134: 'SCENARIO.EDIT',
0x0135: 'SCENARIO.SHOW',
0x0136: 'SCENARIO.SHOW.NEXT',
0x0137: 'SCENARIO.SUMMARY',
0x0138: 'PIVOT.TABLE.WIZARD',
0x0139: 'PIVOT.FIELD.PROPERTIES',
0x013A: 'PIVOT.FIELD',
0x013B: 'PIVOT.ITEM',
0x013C: 'PIVOT.ADD.FIELDS',
0x013E: 'OPTIONS.CALCULATION',
0x013F: 'OPTIONS.EDIT',
0x0140: 'OPTIONS.VIEW',
0x0141: 'ADDIN.MANAGER',
0x0142: 'MENU.EDITOR',
0x0143: 'ATTACH.TOOLBARS',
0x0144: 'VBAActivate',
0x0145: 'OPTIONS.CHART',
0x0148: 'VBA.INSERT.FILE',
0x014A: 'VBA.PROCEDURE.DEFINITION',
0x0150: 'ROUTING.SLIP',
0x0152: 'ROUTE.DOCUMENT',
0x0153: 'MAIL.LOGON',
0x0156: 'INSERT.PICTURE',
0x0157: 'EDIT.TOOL',
0x0158: 'GALLERY.DOUGHNUT',
0x015E: 'CHART.TREND',
0x0160: 'PIVOT.ITEM.PROPERTIES',
0x0162: 'WORKBOOK.INSERT',
0x0163: 'OPTIONS.TRANSITION',
0x0164: 'OPTIONS.GENERAL',
0x0172: 'FILTER.ADVANCED',
0x0175: 'MAIL.ADD.MAILER',
0x0176: 'MAIL.DELETE.MAILER',
0x0177: 'MAIL.REPLY',
0x0178: 'MAIL.REPLY.ALL',
0x0179: 'MAIL.FORWARD',
0x017A: 'MAIL.NEXT.LETTER',
0x017B: 'DATA.LABEL',
0x017C: 'INSERT.TITLE',
0x017D: 'FONT.PROPERTIES',
0x017E: 'MACRO.OPTIONS',
0x017F: 'WORKBOOK.HIDE',
0x0180: 'WORKBOOK.UNHIDE',
0x0181: 'WORKBOOK.DELETE',
0x0182: 'WORKBOOK.NAME',
0x0184: 'GALLERY.CUSTOM',
0x0186: 'ADD.CHART.AUTOFORMAT',
0x0187: 'DELETE.CHART.AUTOFORMAT',
0x0188: 'CHART.ADD.DATA',
0x0189: 'AUTO.OUTLINE',
0x018A: 'TAB.ORDER',
0x018B: 'SHOW.DIALOG',
0x018C: 'SELECT.ALL',
0x018D: 'UNGROUP.SHEETS',
0x018E: 'SUBTOTAL.CREATE',
0x018F: 'SUBTOTAL.REMOVE',
0x0190: 'RENAME.OBJECT',
0x019C: 'WORKBOOK.SCROLL',
0x019D: 'WORKBOOK.NEXT',
0x019E: 'WORKBOOK.PREV',
0x019F: 'WORKBOOK.TAB.SPLIT',
0x01A0: 'FULL.SCREEN',
0x01A1: 'WORKBOOK.PROTECT',
0x01A4: 'SCROLLBAR.PROPERTIES',
0x01A5: 'PIVOT.SHOW.PAGES',
0x01A6: 'TEXT.TO.COLUMNS',
0x01A7: 'FORMAT.CHARTTYPE',
0x01A8: 'LINK.FORMAT',
0x01A9: 'TRACER.DISPLAY',
0x01AE: 'TRACER.NAVIGATE',
0x01AF: 'TRACER.CLEAR',
0x01B0: 'TRACER.ERROR',
0x01B1: 'PIVOT.FIELD.GROUP',
0x01B2: 'PIVOT.FIELD.UNGROUP',
0x01B3: 'CHECKBOX.PROPERTIES',
0x01B4: 'LABEL.PROPERTIES',
0x01B5: 'LISTBOX.PROPERTIES',
0x01B6: 'EDITBOX.PROPERTIES',
0x01B7: 'PIVOT.REFRESH',
0x01B8: 'LINK.COMBO',
0x01B9: 'OPEN.TEXT',
0x01BA: 'HIDE.DIALOG',
0x01BB: 'SET.DIALOG.FOCUS',
0x01BC: 'ENABLE.OBJECT',
0x01BD: 'PUSHBUTTON.PROPERTIES',
0x01BE: 'SET.DIALOG.DEFAULT',
0x01BF: 'FILTER',
0x01C0: 'FILTER.SHOW.ALL',
0x01C1: 'CLEAR.OUTLINE',
0x01C2: 'FUNCTION.WIZARD',
0x01C3: 'ADD.LIST.ITEM',
0x01C4: 'SET.LIST.ITEM',
0x01C5: 'REMOVE.LIST.ITEM',
0x01C6: 'SELECT.LIST.ITEM',
0x01C7: 'SET.CONTROL.VALUE',
0x01C8: 'SAVE.COPY.AS',
0x01CA: 'OPTIONS.LISTS.ADD',
0x01CB: 'OPTIONS.LISTS.DELETE',
0x01CC: 'SERIES.AXES',
0x01CD: 'SERIES.X',
0x01CE: 'SERIES.Y',
0x01CF: 'ERRORBAR.X',
0x01D0: 'ERRORBAR.Y',
0x01D1: 'FORMAT.CHART',
0x01D2: 'SERIES.ORDER',
0x01D3: 'MAIL.LOGOFF',
0x01D4: 'CLEAR.ROUTING.SLIP',
0x01D5: 'APP.ACTIVATE.MICROSOFT',
0x01D6: 'MAIL.EDIT.MAILER',
0x01D7: 'ON.SHEET',
0x01D8: 'STANDARD.WIDTH',
0x01D9: 'SCENARIO.MERGE',
0x01DA: 'SUMMARY.INFO',
0x01DB: 'FIND.FILE',
0x01DC: 'ACTIVE.CELL.FONT',
0x01DD: 'ENABLE.TIPWIZARD',
0x01DE: 'VBA.MAKE.ADDIN',
0x01E0: 'INSERTDATATABLE',
0x01E1: 'WORKGROUP.OPTIONS',
0x01E2: 'MAIL.SEND.MAILER',
0x01E5: 'AUTOCORRECT',
0x01E9: 'POST.DOCUMENT',
0x01EB: 'PICKLIST',
0x01ED: 'VIEW.SHOW',
0x01EE: 'VIEW.DEFINE',
0x01EF: 'VIEW.DELETE',
0x01FD: 'SHEET.BACKGROUND',
0x01FE: 'INSERT.MAP.OBJECT',
0x01FF: 'OPTIONS.MENONO',
0x0205: 'MSOCHECKS',
0x0206: 'NORMAL',
0x0207: 'LAYOUT',
0x0208: 'RM.PRINT.AREA',
0x0209: 'CLEAR.PRINT.AREA',
0x020A: 'ADD.PRINT.AREA',
0x020B: 'MOVE.BRK',
0x0221: 'HIDECURR.NOTE',
0x0222: 'HIDEALL.NOTES',
0x0223: 'DELETE.NOTE',
0x0224: 'TRAVERSE.NOTES',
0x0225: 'ACTIVATE.NOTES',
0x026C: 'PROTECT.REVISIONS',
0x026D: 'UNPROTECT.REVISIONS',
0x0287: 'OPTIONS.ME',
0x028D: 'WEB.PUBLISH',
0x029B: 'NEWWEBQUERY',
0x02A1: 'PIVOT.TABLE.CHART',
0x02F1: 'OPTIONS.SAVE',
0x02F3: 'OPTIONS.SPELL',
0x0328: 'HIDEALL.INKANNOTS'
};

/* [MS-XLS] 2.5.198.17 */
/* [MS-XLSB] 2.5.97.10 */
var Ftab = {
0x0000: 'COUNT',
0x0001: 'IF',
0x0002: 'ISNA',
0x0003: 'ISERROR',
0x0004: 'SUM',
0x0005: 'AVERAGE',
0x0006: 'MIN',
0x0007: 'MAX',
0x0008: 'ROW',
0x0009: 'COLUMN',
0x000A: 'NA',
0x000B: 'NPV',
0x000C: 'STDEV',
0x000D: 'DOLLAR',
0x000E: 'FIXED',
0x000F: 'SIN',
0x0010: 'COS',
0x0011: 'TAN',
0x0012: 'ATAN',
0x0013: 'PI',
0x0014: 'SQRT',
0x0015: 'EXP',
0x0016: 'LN',
0x0017: 'LOG10',
0x0018: 'ABS',
0x0019: 'INT',
0x001A: 'SIGN',
0x001B: 'ROUND',
0x001C: 'LOOKUP',
0x001D: 'INDEX',
0x001E: 'REPT',
0x001F: 'MID',
0x0020: 'LEN',
0x0021: 'VALUE',
0x0022: 'TRUE',
0x0023: 'FALSE',
0x0024: 'AND',
0x0025: 'OR',
0x0026: 'NOT',
0x0027: 'MOD',
0x0028: 'DCOUNT',
0x0029: 'DSUM',
0x002A: 'DAVERAGE',
0x002B: 'DMIN',
0x002C: 'DMAX',
0x002D: 'DSTDEV',
0x002E: 'VAR',
0x002F: 'DVAR',
0x0030: 'TEXT',
0x0031: 'LINEST',
0x0032: 'TREND',
0x0033: 'LOGEST',
0x0034: 'GROWTH',
0x0035: 'GOTO',
0x0036: 'HALT',
0x0037: 'RETURN',
0x0038: 'PV',
0x0039: 'FV',
0x003A: 'NPER',
0x003B: 'PMT',
0x003C: 'RATE',
0x003D: 'MIRR',
0x003E: 'IRR',
0x003F: 'RAND',
0x0040: 'MATCH',
0x0041: 'DATE',
0x0042: 'TIME',
0x0043: 'DAY',
0x0044: 'MONTH',
0x0045: 'YEAR',
0x0046: 'WEEKDAY',
0x0047: 'HOUR',
0x0048: 'MINUTE',
0x0049: 'SECOND',
0x004A: 'NOW',
0x004B: 'AREAS',
0x004C: 'ROWS',
0x004D: 'COLUMNS',
0x004E: 'OFFSET',
0x004F: 'ABSREF',
0x0050: 'RELREF',
0x0051: 'ARGUMENT',
0x0052: 'SEARCH',
0x0053: 'TRANSPOSE',
0x0054: 'ERROR',
0x0055: 'STEP',
0x0056: 'TYPE',
0x0057: 'ECHO',
0x0058: 'SET.NAME',
0x0059: 'CALLER',
0x005A: 'DEREF',
0x005B: 'WINDOWS',
0x005C: 'SERIES',
0x005D: 'DOCUMENTS',
0x005E: 'ACTIVE.CELL',
0x005F: 'SELECTION',
0x0060: 'RESULT',
0x0061: 'ATAN2',
0x0062: 'ASIN',
0x0063: 'ACOS',
0x0064: 'CHOOSE',
0x0065: 'HLOOKUP',
0x0066: 'VLOOKUP',
0x0067: 'LINKS',
0x0068: 'INPUT',
0x0069: 'ISREF',
0x006A: 'GET.FORMULA',
0x006B: 'GET.NAME',
0x006C: 'SET.VALUE',
0x006D: 'LOG',
0x006E: 'EXEC',
0x006F: 'CHAR',
0x0070: 'LOWER',
0x0071: 'UPPER',
0x0072: 'PROPER',
0x0073: 'LEFT',
0x0074: 'RIGHT',
0x0075: 'EXACT',
0x0076: 'TRIM',
0x0077: 'REPLACE',
0x0078: 'SUBSTITUTE',
0x0079: 'CODE',
0x007A: 'NAMES',
0x007B: 'DIRECTORY',
0x007C: 'FIND',
0x007D: 'CELL',
0x007E: 'ISERR',
0x007F: 'ISTEXT',
0x0080: 'ISNUMBER',
0x0081: 'ISBLANK',
0x0082: 'T',
0x0083: 'N',
0x0084: 'FOPEN',
0x0085: 'FCLOSE',
0x0086: 'FSIZE',
0x0087: 'FREADLN',
0x0088: 'FREAD',
0x0089: 'FWRITELN',
0x008A: 'FWRITE',
0x008B: 'FPOS',
0x008C: 'DATEVALUE',
0x008D: 'TIMEVALUE',
0x008E: 'SLN',
0x008F: 'SYD',
0x0090: 'DDB',
0x0091: 'GET.DEF',
0x0092: 'REFTEXT',
0x0093: 'TEXTREF',
0x0094: 'INDIRECT',
0x0095: 'REGISTER',
0x0096: 'CALL',
0x0097: 'ADD.BAR',
0x0098: 'ADD.MENU',
0x0099: 'ADD.COMMAND',
0x009A: 'ENABLE.COMMAND',
0x009B: 'CHECK.COMMAND',
0x009C: 'RENAME.COMMAND',
0x009D: 'SHOW.BAR',
0x009E: 'DELETE.MENU',
0x009F: 'DELETE.COMMAND',
0x00A0: 'GET.CHART.ITEM',
0x00A1: 'DIALOG.BOX',
0x00A2: 'CLEAN',
0x00A3: 'MDETERM',
0x00A4: 'MINVERSE',
0x00A5: 'MMULT',
0x00A6: 'FILES',
0x00A7: 'IPMT',
0x00A8: 'PPMT',
0x00A9: 'COUNTA',
0x00AA: 'CANCEL.KEY',
0x00AB: 'FOR',
0x00AC: 'WHILE',
0x00AD: 'BREAK',
0x00AE: 'NEXT',
0x00AF: 'INITIATE',
0x00B0: 'REQUEST',
0x00B1: 'POKE',
0x00B2: 'EXECUTE',
0x00B3: 'TERMINATE',
0x00B4: 'RESTART',
0x00B5: 'HELP',
0x00B6: 'GET.BAR',
0x00B7: 'PRODUCT',
0x00B8: 'FACT',
0x00B9: 'GET.CELL',
0x00BA: 'GET.WORKSPACE',
0x00BB: 'GET.WINDOW',
0x00BC: 'GET.DOCUMENT',
0x00BD: 'DPRODUCT',
0x00BE: 'ISNONTEXT',
0x00BF: 'GET.NOTE',
0x00C0: 'NOTE',
0x00C1: 'STDEVP',
0x00C2: 'VARP',
0x00C3: 'DSTDEVP',
0x00C4: 'DVARP',
0x00C5: 'TRUNC',
0x00C6: 'ISLOGICAL',
0x00C7: 'DCOUNTA',
0x00C8: 'DELETE.BAR',
0x00C9: 'UNREGISTER',
0x00CC: 'USDOLLAR',
0x00CD: 'FINDB',
0x00CE: 'SEARCHB',
0x00CF: 'REPLACEB',
0x00D0: 'LEFTB',
0x00D1: 'RIGHTB',
0x00D2: 'MIDB',
0x00D3: 'LENB',
0x00D4: 'ROUNDUP',
0x00D5: 'ROUNDDOWN',
0x00D6: 'ASC',
0x00D7: 'DBCS',
0x00D8: 'RANK',
0x00DB: 'ADDRESS',
0x00DC: 'DAYS360',
0x00DD: 'TODAY',
0x00DE: 'VDB',
0x00DF: 'ELSE',
0x00E0: 'ELSE.IF',
0x00E1: 'END.IF',
0x00E2: 'FOR.CELL',
0x00E3: 'MEDIAN',
0x00E4: 'SUMPRODUCT',
0x00E5: 'SINH',
0x00E6: 'COSH',
0x00E7: 'TANH',
0x00E8: 'ASINH',
0x00E9: 'ACOSH',
0x00EA: 'ATANH',
0x00EB: 'DGET',
0x00EC: 'CREATE.OBJECT',
0x00ED: 'VOLATILE',
0x00EE: 'LAST.ERROR',
0x00EF: 'CUSTOM.UNDO',
0x00F0: 'CUSTOM.REPEAT',
0x00F1: 'FORMULA.CONVERT',
0x00F2: 'GET.LINK.INFO',
0x00F3: 'TEXT.BOX',
0x00F4: 'INFO',
0x00F5: 'GROUP',
0x00F6: 'GET.OBJECT',
0x00F7: 'DB',
0x00F8: 'PAUSE',
0x00FB: 'RESUME',
0x00FC: 'FREQUENCY',
0x00FD: 'ADD.TOOLBAR',
0x00FE: 'DELETE.TOOLBAR',
0x00FF: 'User',
0x0100: 'RESET.TOOLBAR',
0x0101: 'EVALUATE',
0x0102: 'GET.TOOLBAR',
0x0103: 'GET.TOOL',
0x0104: 'SPELLING.CHECK',
0x0105: 'ERROR.TYPE',
0x0106: 'APP.TITLE',
0x0107: 'WINDOW.TITLE',
0x0108: 'SAVE.TOOLBAR',
0x0109: 'ENABLE.TOOL',
0x010A: 'PRESS.TOOL',
0x010B: 'REGISTER.ID',
0x010C: 'GET.WORKBOOK',
0x010D: 'AVEDEV',
0x010E: 'BETADIST',
0x010F: 'GAMMALN',
0x0110: 'BETAINV',
0x0111: 'BINOMDIST',
0x0112: 'CHIDIST',
0x0113: 'CHIINV',
0x0114: 'COMBIN',
0x0115: 'CONFIDENCE',
0x0116: 'CRITBINOM',
0x0117: 'EVEN',
0x0118: 'EXPONDIST',
0x0119: 'FDIST',
0x011A: 'FINV',
0x011B: 'FISHER',
0x011C: 'FISHERINV',
0x011D: 'FLOOR',
0x011E: 'GAMMADIST',
0x011F: 'GAMMAINV',
0x0120: 'CEILING',
0x0121: 'HYPGEOMDIST',
0x0122: 'LOGNORMDIST',
0x0123: 'LOGINV',
0x0124: 'NEGBINOMDIST',
0x0125: 'NORMDIST',
0x0126: 'NORMSDIST',
0x0127: 'NORMINV',
0x0128: 'NORMSINV',
0x0129: 'STANDARDIZE',
0x012A: 'ODD',
0x012B: 'PERMUT',
0x012C: 'POISSON',
0x012D: 'TDIST',
0x012E: 'WEIBULL',
0x012F: 'SUMXMY2',
0x0130: 'SUMX2MY2',
0x0131: 'SUMX2PY2',
0x0132: 'CHITEST',
0x0133: 'CORREL',
0x0134: 'COVAR',
0x0135: 'FORECAST',
0x0136: 'FTEST',
0x0137: 'INTERCEPT',
0x0138: 'PEARSON',
0x0139: 'RSQ',
0x013A: 'STEYX',
0x013B: 'SLOPE',
0x013C: 'TTEST',
0x013D: 'PROB',
0x013E: 'DEVSQ',
0x013F: 'GEOMEAN',
0x0140: 'HARMEAN',
0x0141: 'SUMSQ',
0x0142: 'KURT',
0x0143: 'SKEW',
0x0144: 'ZTEST',
0x0145: 'LARGE',
0x0146: 'SMALL',
0x0147: 'QUARTILE',
0x0148: 'PERCENTILE',
0x0149: 'PERCENTRANK',
0x014A: 'MODE',
0x014B: 'TRIMMEAN',
0x014C: 'TINV',
0x014E: 'MOVIE.COMMAND',
0x014F: 'GET.MOVIE',
0x0150: 'CONCATENATE',
0x0151: 'POWER',
0x0152: 'PIVOT.ADD.DATA',
0x0153: 'GET.PIVOT.TABLE',
0x0154: 'GET.PIVOT.FIELD',
0x0155: 'GET.PIVOT.ITEM',
0x0156: 'RADIANS',
0x0157: 'DEGREES',
0x0158: 'SUBTOTAL',
0x0159: 'SUMIF',
0x015A: 'COUNTIF',
0x015B: 'COUNTBLANK',
0x015C: 'SCENARIO.GET',
0x015D: 'OPTIONS.LISTS.GET',
0x015E: 'ISPMT',
0x015F: 'DATEDIF',
0x0160: 'DATESTRING',
0x0161: 'NUMBERSTRING',
0x0162: 'ROMAN',
0x0163: 'OPEN.DIALOG',
0x0164: 'SAVE.DIALOG',
0x0165: 'VIEW.GET',
0x0166: 'GETPIVOTDATA',
0x0167: 'HYPERLINK',
0x0168: 'PHONETIC',
0x0169: 'AVERAGEA',
0x016A: 'MAXA',
0x016B: 'MINA',
0x016C: 'STDEVPA',
0x016D: 'VARPA',
0x016E: 'STDEVA',
0x016F: 'VARA',
0x0170: 'BAHTTEXT',
0x0171: 'THAIDAYOFWEEK',
0x0172: 'THAIDIGIT',
0x0173: 'THAIMONTHOFYEAR',
0x0174: 'THAINUMSOUND',
0x0175: 'THAINUMSTRING',
0x0176: 'THAISTRINGLENGTH',
0x0177: 'ISTHAIDIGIT',
0x0178: 'ROUNDBAHTDOWN',
0x0179: 'ROUNDBAHTUP',
0x017A: 'THAIYEAR',
0x017B: 'RTD',

0x017C: 'CUBEVALUE',
0x017D: 'CUBEMEMBER',
0x017E: 'CUBEMEMBERPROPERTY',
0x017F: 'CUBERANKEDMEMBER',
0x0180: 'HEX2BIN',
0x0181: 'HEX2DEC',
0x0182: 'HEX2OCT',
0x0183: 'DEC2BIN',
0x0184: 'DEC2HEX',
0x0185: 'DEC2OCT',
0x0186: 'OCT2BIN',
0x0187: 'OCT2HEX',
0x0188: 'OCT2DEC',
0x0189: 'BIN2DEC',
0x018A: 'BIN2OCT',
0x018B: 'BIN2HEX',
0x018C: 'IMSUB',
0x018D: 'IMDIV',
0x018E: 'IMPOWER',
0x018F: 'IMABS',
0x0190: 'IMSQRT',
0x0191: 'IMLN',
0x0192: 'IMLOG2',
0x0193: 'IMLOG10',
0x0194: 'IMSIN',
0x0195: 'IMCOS',
0x0196: 'IMEXP',
0x0197: 'IMARGUMENT',
0x0198: 'IMCONJUGATE',
0x0199: 'IMAGINARY',
0x019A: 'IMREAL',
0x019B: 'COMPLEX',
0x019C: 'IMSUM',
0x019D: 'IMPRODUCT',
0x019E: 'SERIESSUM',
0x019F: 'FACTDOUBLE',
0x01A0: 'SQRTPI',
0x01A1: 'QUOTIENT',
0x01A2: 'DELTA',
0x01A3: 'GESTEP',
0x01A4: 'ISEVEN',
0x01A5: 'ISODD',
0x01A6: 'MROUND',
0x01A7: 'ERF',
0x01A8: 'ERFC',
0x01A9: 'BESSELJ',
0x01AA: 'BESSELK',
0x01AB: 'BESSELY',
0x01AC: 'BESSELI',
0x01AD: 'XIRR',
0x01AE: 'XNPV',
0x01AF: 'PRICEMAT',
0x01B0: 'YIELDMAT',
0x01B1: 'INTRATE',
0x01B2: 'RECEIVED',
0x01B3: 'DISC',
0x01B4: 'PRICEDISC',
0x01B5: 'YIELDDISC',
0x01B6: 'TBILLEQ',
0x01B7: 'TBILLPRICE',
0x01B8: 'TBILLYIELD',
0x01B9: 'PRICE',
0x01BA: 'YIELD',
0x01BB: 'DOLLARDE',
0x01BC: 'DOLLARFR',
0x01BD: 'NOMINAL',
0x01BE: 'EFFECT',
0x01BF: 'CUMPRINC',
0x01C0: 'CUMIPMT',
0x01C1: 'EDATE',
0x01C2: 'EOMONTH',
0x01C3: 'YEARFRAC',
0x01C4: 'COUPDAYBS',
0x01C5: 'COUPDAYS',
0x01C6: 'COUPDAYSNC',
0x01C7: 'COUPNCD',
0x01C8: 'COUPNUM',
0x01C9: 'COUPPCD',
0x01CA: 'DURATION',
0x01CB: 'MDURATION',
0x01CC: 'ODDLPRICE',
0x01CD: 'ODDLYIELD',
0x01CE: 'ODDFPRICE',
0x01CF: 'ODDFYIELD',
0x01D0: 'RANDBETWEEN',
0x01D1: 'WEEKNUM',
0x01D2: 'AMORDEGRC',
0x01D3: 'AMORLINC',
0x01D4: 'CONVERT',
0x02D4: 'SHEETJS',
0x01D5: 'ACCRINT',
0x01D6: 'ACCRINTM',
0x01D7: 'WORKDAY',
0x01D8: 'NETWORKDAYS',
0x01D9: 'GCD',
0x01DA: 'MULTINOMIAL',
0x01DB: 'LCM',
0x01DC: 'FVSCHEDULE',
0x01DD: 'CUBEKPIMEMBER',
0x01DE: 'CUBESET',
0x01DF: 'CUBESETCOUNT',
0x01E0: 'IFERROR',
0x01E1: 'COUNTIFS',
0x01E2: 'SUMIFS',
0x01E3: 'AVERAGEIF',
0x01E4: 'AVERAGEIFS'
};
var FtabArgc = {
0x0002: 1, /* ISNA */
0x0003: 1, /* ISERROR */
0x000A: 0, /* NA */
0x000F: 1, /* SIN */
0x0010: 1, /* COS */
0x0011: 1, /* TAN */
0x0012: 1, /* ATAN */
0x0013: 0, /* PI */
0x0014: 1, /* SQRT */
0x0015: 1, /* EXP */
0x0016: 1, /* LN */
0x0017: 1, /* LOG10 */
0x0018: 1, /* ABS */
0x0019: 1, /* INT */
0x001A: 1, /* SIGN */
0x001B: 2, /* ROUND */
0x001E: 2, /* REPT */
0x001F: 3, /* MID */
0x0020: 1, /* LEN */
0x0021: 1, /* VALUE */
0x0022: 0, /* TRUE */
0x0023: 0, /* FALSE */
0x0026: 1, /* NOT */
0x0027: 2, /* MOD */
0x0028: 3, /* DCOUNT */
0x0029: 3, /* DSUM */
0x002A: 3, /* DAVERAGE */
0x002B: 3, /* DMIN */
0x002C: 3, /* DMAX */
0x002D: 3, /* DSTDEV */
0x002F: 3, /* DVAR */
0x0030: 2, /* TEXT */
0x0035: 1, /* GOTO */
0x003D: 3, /* MIRR */
0x003F: 0, /* RAND */
0x0041: 3, /* DATE */
0x0042: 3, /* TIME */
0x0043: 1, /* DAY */
0x0044: 1, /* MONTH */
0x0045: 1, /* YEAR */
0x0046: 1, /* WEEKDAY */
0x0047: 1, /* HOUR */
0x0048: 1, /* MINUTE */
0x0049: 1, /* SECOND */
0x004A: 0, /* NOW */
0x004B: 1, /* AREAS */
0x004C: 1, /* ROWS */
0x004D: 1, /* COLUMNS */
0x004F: 2, /* ABSREF */
0x0050: 2, /* RELREF */
0x0053: 1, /* TRANSPOSE */
0x0055: 0, /* STEP */
0x0056: 1, /* TYPE */
0x0059: 0, /* CALLER */
0x005A: 1, /* DEREF */
0x005E: 0, /* ACTIVE.CELL */
0x005F: 0, /* SELECTION */
0x0061: 2, /* ATAN2 */
0x0062: 1, /* ASIN */
0x0063: 1, /* ACOS */
0x0065: 3, /* HLOOKUP */
0x0066: 3, /* VLOOKUP */
0x0069: 1, /* ISREF */
0x006A: 1, /* GET.FORMULA */
0x006C: 2, /* SET.VALUE */
0x006F: 1, /* CHAR */
0x0070: 1, /* LOWER */
0x0071: 1, /* UPPER */
0x0072: 1, /* PROPER */
0x0075: 2, /* EXACT */
0x0076: 1, /* TRIM */
0x0077: 4, /* REPLACE */
0x0079: 1, /* CODE */
0x007E: 1, /* ISERR */
0x007F: 1, /* ISTEXT */
0x0080: 1, /* ISNUMBER */
0x0081: 1, /* ISBLANK */
0x0082: 1, /* T */
0x0083: 1, /* N */
0x0085: 1, /* FCLOSE */
0x0086: 1, /* FSIZE */
0x0087: 1, /* FREADLN */
0x0088: 2, /* FREAD */
0x0089: 2, /* FWRITELN */
0x008A: 2, /* FWRITE */
0x008C: 1, /* DATEVALUE */
0x008D: 1, /* TIMEVALUE */
0x008E: 3, /* SLN */
0x008F: 4, /* SYD */
0x0090: 4, /* DDB */
0x00A1: 1, /* DIALOG.BOX */
0x00A2: 1, /* CLEAN */
0x00A3: 1, /* MDETERM */
0x00A4: 1, /* MINVERSE */
0x00A5: 2, /* MMULT */
0x00AC: 1, /* WHILE */
0x00AF: 2, /* INITIATE */
0x00B0: 2, /* REQUEST */
0x00B1: 3, /* POKE */
0x00B2: 2, /* EXECUTE */
0x00B3: 1, /* TERMINATE */
0x00B8: 1, /* FACT */
0x00BA: 1, /* GET.WORKSPACE */
0x00BD: 3, /* DPRODUCT */
0x00BE: 1, /* ISNONTEXT */
0x00C3: 3, /* DSTDEVP */
0x00C4: 3, /* DVARP */
0x00C5: 1, /* TRUNC */
0x00C6: 1, /* ISLOGICAL */
0x00C7: 3, /* DCOUNTA */
0x00C9: 1, /* UNREGISTER */
0x00CF: 4, /* REPLACEB */
0x00D2: 3, /* MIDB */
0x00D3: 1, /* LENB */
0x00D4: 2, /* ROUNDUP */
0x00D5: 2, /* ROUNDDOWN */
0x00D6: 1, /* ASC */
0x00D7: 1, /* DBCS */
0x00E1: 0, /* END.IF */
0x00E5: 1, /* SINH */
0x00E6: 1, /* COSH */
0x00E7: 1, /* TANH */
0x00E8: 1, /* ASINH */
0x00E9: 1, /* ACOSH */
0x00EA: 1, /* ATANH */
0x00EB: 3, /* DGET */
0x00F4: 1, /* INFO */
0x00F7: 4, /* DB */
0x00FC: 2, /* FREQUENCY */
0x0101: 1, /* EVALUATE */
0x0105: 1, /* ERROR.TYPE */
0x010F: 1, /* GAMMALN */
0x0111: 4, /* BINOMDIST */
0x0112: 2, /* CHIDIST */
0x0113: 2, /* CHIINV */
0x0114: 2, /* COMBIN */
0x0115: 3, /* CONFIDENCE */
0x0116: 3, /* CRITBINOM */
0x0117: 1, /* EVEN */
0x0118: 3, /* EXPONDIST */
0x0119: 3, /* FDIST */
0x011A: 3, /* FINV */
0x011B: 1, /* FISHER */
0x011C: 1, /* FISHERINV */
0x011D: 2, /* FLOOR */
0x011E: 4, /* GAMMADIST */
0x011F: 3, /* GAMMAINV */
0x0120: 2, /* CEILING */
0x0121: 4, /* HYPGEOMDIST */
0x0122: 3, /* LOGNORMDIST */
0x0123: 3, /* LOGINV */
0x0124: 3, /* NEGBINOMDIST */
0x0125: 4, /* NORMDIST */
0x0126: 1, /* NORMSDIST */
0x0127: 3, /* NORMINV */
0x0128: 1, /* NORMSINV */
0x0129: 3, /* STANDARDIZE */
0x012A: 1, /* ODD */
0x012B: 2, /* PERMUT */
0x012C: 3, /* POISSON */
0x012D: 3, /* TDIST */
0x012E: 4, /* WEIBULL */
0x012F: 2, /* SUMXMY2 */
0x0130: 2, /* SUMX2MY2 */
0x0131: 2, /* SUMX2PY2 */
0x0132: 2, /* CHITEST */
0x0133: 2, /* CORREL */
0x0134: 2, /* COVAR */
0x0135: 3, /* FORECAST */
0x0136: 2, /* FTEST */
0x0137: 2, /* INTERCEPT */
0x0138: 2, /* PEARSON */
0x0139: 2, /* RSQ */
0x013A: 2, /* STEYX */
0x013B: 2, /* SLOPE */
0x013C: 4, /* TTEST */
0x0145: 2, /* LARGE */
0x0146: 2, /* SMALL */
0x0147: 2, /* QUARTILE */
0x0148: 2, /* PERCENTILE */
0x014B: 2, /* TRIMMEAN */
0x014C: 2, /* TINV */
0x0151: 2, /* POWER */
0x0156: 1, /* RADIANS */
0x0157: 1, /* DEGREES */
0x015A: 2, /* COUNTIF */
0x015B: 1, /* COUNTBLANK */
0x015E: 4, /* ISPMT */
0x015F: 3, /* DATEDIF */
0x0160: 1, /* DATESTRING */
0x0161: 2, /* NUMBERSTRING */
0x0168: 1, /* PHONETIC */
0x0170: 1, /* BAHTTEXT */
0x0171: 1, /* THAIDAYOFWEEK */
0x0172: 1, /* THAIDIGIT */
0x0173: 1, /* THAIMONTHOFYEAR */
0x0174: 1, /* THAINUMSOUND */
0x0175: 1, /* THAINUMSTRING */
0x0176: 1, /* THAISTRINGLENGTH */
0x0177: 1, /* ISTHAIDIGIT */
0x0178: 1, /* ROUNDBAHTDOWN */
0x0179: 1, /* ROUNDBAHTUP */
0x017A: 1, /* THAIYEAR */
0x017E: 3, /* CUBEMEMBERPROPERTY */
0x0181: 1, /* HEX2DEC */
0x0188: 1, /* OCT2DEC */
0x0189: 1, /* BIN2DEC */
0x018C: 2, /* IMSUB */
0x018D: 2, /* IMDIV */
0x018E: 2, /* IMPOWER */
0x018F: 1, /* IMABS */
0x0190: 1, /* IMSQRT */
0x0191: 1, /* IMLN */
0x0192: 1, /* IMLOG2 */
0x0193: 1, /* IMLOG10 */
0x0194: 1, /* IMSIN */
0x0195: 1, /* IMCOS */
0x0196: 1, /* IMEXP */
0x0197: 1, /* IMARGUMENT */
0x0198: 1, /* IMCONJUGATE */
0x0199: 1, /* IMAGINARY */
0x019A: 1, /* IMREAL */
0x019E: 4, /* SERIESSUM */
0x019F: 1, /* FACTDOUBLE */
0x01A0: 1, /* SQRTPI */
0x01A1: 2, /* QUOTIENT */
0x01A4: 1, /* ISEVEN */
0x01A5: 1, /* ISODD */
0x01A6: 2, /* MROUND */
0x01A8: 1, /* ERFC */
0x01A9: 2, /* BESSELJ */
0x01AA: 2, /* BESSELK */
0x01AB: 2, /* BESSELY */
0x01AC: 2, /* BESSELI */
0x01AE: 3, /* XNPV */
0x01B6: 3, /* TBILLEQ */
0x01B7: 3, /* TBILLPRICE */
0x01B8: 3, /* TBILLYIELD */
0x01BB: 2, /* DOLLARDE */
0x01BC: 2, /* DOLLARFR */
0x01BD: 2, /* NOMINAL */
0x01BE: 2, /* EFFECT */
0x01BF: 6, /* CUMPRINC */
0x01C0: 6, /* CUMIPMT */
0x01C1: 2, /* EDATE */
0x01C2: 2, /* EOMONTH */
0x01D0: 2, /* RANDBETWEEN */
0x01D4: 3, /* CONVERT */
0x01DC: 2, /* FVSCHEDULE */
0x01DF: 1, /* CUBESETCOUNT */
0x01E0: 2, /* IFERROR */
0xFFFF: 0
};
/* [MS-XLSX] 2.2.3 Functions */
/* [MS-XLSB] 2.5.97.10 Ftab */
var XLSXFutureFunctions = {
	"_xlfn.ACOT": "ACOT",
	"_xlfn.ACOTH": "ACOTH",
	"_xlfn.AGGREGATE": "AGGREGATE",
	"_xlfn.ARABIC": "ARABIC",
	"_xlfn.AVERAGEIF": "AVERAGEIF",
	"_xlfn.AVERAGEIFS": "AVERAGEIFS",
	"_xlfn.BASE": "BASE",
	"_xlfn.BETA.DIST": "BETA.DIST",
	"_xlfn.BETA.INV": "BETA.INV",
	"_xlfn.BINOM.DIST": "BINOM.DIST",
	"_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
	"_xlfn.BINOM.INV": "BINOM.INV",
	"_xlfn.BITAND": "BITAND",
	"_xlfn.BITLSHIFT": "BITLSHIFT",
	"_xlfn.BITOR": "BITOR",
	"_xlfn.BITRSHIFT": "BITRSHIFT",
	"_xlfn.BITXOR": "BITXOR",
	"_xlfn.CEILING.MATH": "CEILING.MATH",
	"_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
	"_xlfn.CHISQ.DIST": "CHISQ.DIST",
	"_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
	"_xlfn.CHISQ.INV": "CHISQ.INV",
	"_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
	"_xlfn.CHISQ.TEST": "CHISQ.TEST",
	"_xlfn.COMBINA": "COMBINA",
	"_xlfn.CONCAT": "CONCAT",
	"_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
	"_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
	"_xlfn.COT": "COT",
	"_xlfn.COTH": "COTH",
	"_xlfn.COUNTIFS": "COUNTIFS",
	"_xlfn.COVARIANCE.P": "COVARIANCE.P",
	"_xlfn.COVARIANCE.S": "COVARIANCE.S",
	"_xlfn.CSC": "CSC",
	"_xlfn.CSCH": "CSCH",
	"_xlfn.DAYS": "DAYS",
	"_xlfn.DECIMAL": "DECIMAL",
	"_xlfn.ECMA.CEILING": "ECMA.CEILING",
	"_xlfn.ERF.PRECISE": "ERF.PRECISE",
	"_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
	"_xlfn.EXPON.DIST": "EXPON.DIST",
	"_xlfn.F.DIST": "F.DIST",
	"_xlfn.F.DIST.RT": "F.DIST.RT",
	"_xlfn.F.INV": "F.INV",
	"_xlfn.F.INV.RT": "F.INV.RT",
	"_xlfn.F.TEST": "F.TEST",
	"_xlfn.FILTERXML": "FILTERXML",
	"_xlfn.FLOOR.MATH": "FLOOR.MATH",
	"_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
	"_xlfn.FORECAST.ETS": "FORECAST.ETS",
	"_xlfn.FORECAST.ETS.CONFINT": "FORECAST.ETS.CONFINT",
	"_xlfn.FORECAST.ETS.SEASONALITY": "FORECAST.ETS.SEASONALITY",
	"_xlfn.FORECAST.ETS.STAT": "FORECAST.ETS.STAT",
	"_xlfn.FORECAST.LINEAR": "FORECAST.LINEAR",
	"_xlfn.FORMULATEXT": "FORMULATEXT",
	"_xlfn.GAMMA": "GAMMA",
	"_xlfn.GAMMA.DIST": "GAMMA.DIST",
	"_xlfn.GAMMA.INV": "GAMMA.INV",
	"_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
	"_xlfn.GAUSS": "GAUSS",
	"_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
	"_xlfn.IFERROR": "IFERROR",
	"_xlfn.IFNA": "IFNA",
	"_xlfn.IFS": "IFS",
	"_xlfn.IMCOSH": "IMCOSH",
	"_xlfn.IMCOT": "IMCOT",
	"_xlfn.IMCSC": "IMCSC",
	"_xlfn.IMCSCH": "IMCSCH",
	"_xlfn.IMSEC": "IMSEC",
	"_xlfn.IMSECH": "IMSECH",
	"_xlfn.IMSINH": "IMSINH",
	"_xlfn.IMTAN": "IMTAN",
	"_xlfn.ISFORMULA": "ISFORMULA",
	"_xlfn.ISO.CEILING": "ISO.CEILING",
	"_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
	"_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
	"_xlfn.LOGNORM.INV": "LOGNORM.INV",
	"_xlfn.MAXIFS": "MAXIFS",
	"_xlfn.MINIFS": "MINIFS",
	"_xlfn.MODE.MULT": "MODE.MULT",
	"_xlfn.MODE.SNGL": "MODE.SNGL",
	"_xlfn.MUNIT": "MUNIT",
	"_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
	"_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
	"_xlfn.NIGBINOM": "NIGBINOM",
	"_xlfn.NORM.DIST": "NORM.DIST",
	"_xlfn.NORM.INV": "NORM.INV",
	"_xlfn.NORM.S.DIST": "NORM.S.DIST",
	"_xlfn.NORM.S.INV": "NORM.S.INV",
	"_xlfn.NUMBERVALUE": "NUMBERVALUE",
	"_xlfn.PDURATION": "PDURATION",
	"_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
	"_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
	"_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
	"_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
	"_xlfn.PERMUTATIONA": "PERMUTATIONA",
	"_xlfn.PHI": "PHI",
	"_xlfn.POISSON.DIST": "POISSON.DIST",
	"_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
	"_xlfn.QUARTILE.INC": "QUARTILE.INC",
	"_xlfn.QUERYSTRING": "QUERYSTRING",
	"_xlfn.RANK.AVG": "RANK.AVG",
	"_xlfn.RANK.EQ": "RANK.EQ",
	"_xlfn.RRI": "RRI",
	"_xlfn.SEC": "SEC",
	"_xlfn.SECH": "SECH",
	"_xlfn.SHEET": "SHEET",
	"_xlfn.SHEETS": "SHEETS",
	"_xlfn.SKEW.P": "SKEW.P",
	"_xlfn.STDEV.P": "STDEV.P",
	"_xlfn.STDEV.S": "STDEV.S",
	"_xlfn.SUMIFS": "SUMIFS",
	"_xlfn.SWITCH": "SWITCH",
	"_xlfn.T.DIST": "T.DIST",
	"_xlfn.T.DIST.2T": "T.DIST.2T",
	"_xlfn.T.DIST.RT": "T.DIST.RT",
	"_xlfn.T.INV": "T.INV",
	"_xlfn.T.INV.2T": "T.INV.2T",
	"_xlfn.T.TEST": "T.TEST",
	"_xlfn.TEXTJOIN": "TEXTJOIN",
	"_xlfn.UNICHAR": "UNICHAR",
	"_xlfn.UNICODE": "UNICODE",
	"_xlfn.VAR.P": "VAR.P",
	"_xlfn.VAR.S": "VAR.S",
	"_xlfn.WEBSERVICE": "WEBSERVICE",
	"_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
	"_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
	"_xlfn.XOR": "XOR",
	"_xlfn.Z.TEST": "Z.TEST"
};

/* Part 3 TODO: actually parse formulae */
function ods_to_csf_formula(f) {
	if(f.slice(0,3) == "of:") f = f.slice(3);
	/* 5.2 Basic Expressions */
	if(f.charCodeAt(0) == 61) {
		f = f.slice(1);
		if(f.charCodeAt(0) == 61) f = f.slice(1);
	}
	f = f.replace(/COM\.MICROSOFT\./g, "");
	/* Part 3 Section 5.8 References */
	f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
	/* TODO: something other than this */
	f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
	return f.replace(/[;~]/g,",").replace(/\|/g,";");
}

function csf_to_ods_formula(f) {
	var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
	/* TODO: something other than this */
	return o.replace(/;/g, "|").replace(/,/g,";");
}

function ods_to_csf_3D(r) {
	var a = r.split(":");
	var s = a[0].split(".")[0];
	return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
}

function csf_to_ods_3D(r) {
	return r.replace(/\./,"!");
}

var strs = {}; // shared strings
var _ssfopts = {}; // spreadsheet formatting options

RELS.WS = [
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
	"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
];

function get_sst_id(sst, str) {
	for(var i = 0, len = sst.length; i < len; ++i) if(sst[i].t === str) { sst.Count ++; return i; }
	sst[len] = {t:str}; sst.Count ++; sst.Unique ++; return len;
}

function col_obj_w(C, col) {
	var p = ({min:C+1,max:C+1});
	/* wch (chars), wpx (pixels) */
	var wch = -1;
	if(col.MDW) MDW = col.MDW;
	if(col.width != null) p.customWidth = 1;
	else if(col.wpx != null) wch = px2char(col.wpx);
	else if(col.wch != null) wch = col.wch;
	if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
	else if(col.width != null) p.width = col.width;
	if(col.hidden) p.hidden = true;
	return p;
}

function default_margins(margins, mode) {
	if(!margins) return;
	var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
	if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
	if(margins.left   == null) margins.left   = defs[0];
	if(margins.right  == null) margins.right  = defs[1];
	if(margins.top    == null) margins.top    = defs[2];
	if(margins.bottom == null) margins.bottom = defs[3];
	if(margins.header == null) margins.header = defs[4];
	if(margins.footer == null) margins.footer = defs[5];
}

function get_cell_style(styles, cell, opts) {
	var z = opts.revssf[cell.z != null ? cell.z : "General"];
	var i = 0x3c, len = styles.length;
	if(z == null && opts.ssf) {
		for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
			SSF.load(cell.z, i);
			// $FlowIgnore
			opts.ssf[i] = cell.z;
			opts.revssf[cell.z] = z = i;
			break;
		}
	}
	for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
	styles[len] = {
		numFmtId:z,
		fontId:0,
		fillId:0,
		borderId:0,
		xfId:0,
		applyNumberFormat:1
	};
	return len;
}

function safe_format(p, fmtid, fillid, opts, themes, styles) {
	if(p.t === 'z') return;
	if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
	try {
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(SSF._table[fmtid] == null) SSF.load(SSFImplicit[fmtid] || "General", fmtid);
		if(p.t === 'e') p.w = p.w || BErr[p.v];
		else if(fmtid === 0) {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else if(p.t === 'd') {
				var dd = datenum(p.v);
				if((dd|0) === dd) p.w = SSF._general_int(dd);
				else p.w = SSF._general_num(dd);
			}
			else if(p.v === undefined) return "";
			else p.w = SSF._general(p.v,_ssfopts);
		}
		else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
		else p.w = SSF.format(fmtid,p.v,_ssfopts);
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts.cellStyles) return;
	if(fillid != null) try {
		p.s = styles.Fills[fillid];
		if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
			p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
			if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
		}
		if (p.s.bgColor && p.s.bgColor.theme) {
			p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
			if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
		}
	} catch(e) { if(opts.WTF && styles.Fills) throw e; }
}

function check_ws(ws, sname, i) {
	if(ws && ws['!ref']) {
		var range = safe_decode_range(ws['!ref']);
		if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
	}
}
function parse_ws_xml_dim(ws, s) {
	var d = safe_decode_range(s);
	if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var sheetdataregex = /<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var dimregex = /"(\w*:\w*)"/;
var colregex = /<(?:\w:)?col[^>]*[\/]?>/g;
var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
var sheetprregex = /<(?:\w:)?sheetPr(?:[^>a-z][^>]*)?\/>/;
var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */
function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;

	/* 18.3.1.99 worksheet CT_Worksheet */
	var s = opts.dense ? ([]) : ({});
	var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });

	var data1 = "", data2 = "";
	var mtch = data.match(sheetdataregex);
	if(mtch) {
		data1 = data.slice(0, mtch.index);
		data2 = data.slice(mtch.index + mtch[0].length);
	} else data1 = data2 = data;

	/* 18.3.1.82 sheetPr CT_SheetPr */
	var sheetPr = data1.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.35 dimension CT_SheetDimension */
	// $FlowIgnore
	var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
	if(ridx > 0) {
		var ref = data1.slice(ridx,ridx+50).match(dimregex);
		if(ref) parse_ws_xml_dim(s, ref[1]);
	}

	/* 18.3.1.88 sheetViews CT_SheetViews */
	var svs = data1.match(svsregex);
	if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);

	/* 18.3.1.17 cols CT_Cols */
	var columns = [];
	if(opts.cellStyles) {
		/* 18.3.1.13 col CT_Col */
		var cols = data1.match(colregex);
		if(cols) parse_ws_xml_cols(columns, cols);
	}

	/* 18.3.1.80 sheetData CT_SheetData ? */
	if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);

	/* 18.3.1.2  autoFilter CT_AutoFilter */
	var afilter = data2.match(afregex);
	if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);

	/* 18.3.1.55 mergeCells CT_MergeCells */
	var merges = [];
	var _merge = data2.match(mergecregex);
	if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
		merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));

	/* 18.3.1.48 hyperlinks CT_Hyperlinks */
	var hlink = data2.match(hlinkregex);
	if(hlink) parse_ws_xml_hlinks(s, hlink, rels);

	/* 18.3.1.62 pageMargins CT_PageMargins */
	var margins = data2.match(marginregex);
	if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));

	if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
	if(opts.sheetRows > 0 && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(columns.length > 0) s["!cols"] = columns;
	if(merges.length > 0) s["!merges"] = merges;
	return s;
}

function write_ws_xml_merges(merges) {
	if(merges.length === 0) return "";
	var o = '<mergeCells count="' + merges.length + '">';
	for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
	return o + '</mergeCells>';
}

/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
	var data = parsexmltag(sheetPr);
	if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
	if(data.codeName) wb.Sheets[idx].CodeName = data.codeName;
}

/* 18.3.1.85 sheetProtection CT_SheetProtection */
function write_ws_xml_protection(sp) {
	// algorithmName, hashValue, saltValue, spinCountpassword
	var o = ({sheet:1});
	var deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
	deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
	/* TODO: algorithm */
	if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
	return writextag('sheetProtection', null, o);
}

function parse_ws_xml_hlinks(s, data, rels) {
	var dense = Array.isArray(s);
	for(var i = 0; i != data.length; ++i) {
		var val = parsexmltag(utf8read(data[i]), true);
		if(!val.ref) return;
		var rel = ((rels || {})['!id']||[])[val.id];
		if(rel) {
			val.Target = rel.Target;
			if(val.location) val.Target += "#"+val.location;
		} else {
			val.Target = "#" + val.location;
			rel = {Target: val.Target, TargetMode: 'Internal'};
		}
		val.Rel = rel;
		if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
		var rng = safe_decode_range(val.ref);
		for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
			var addr = encode_cell({c:C,r:R});
			if(dense) {
				if(!s[R]) s[R] = [];
				if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
				s[R][C].l = val;
			} else {
				if(!s[addr]) s[addr] = {t:"z",v:undefined};
				s[addr].l = val;
			}
		}
	}
}

function parse_ws_xml_margins(margin) {
	var o = {};
	["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
		if(margin[k]) o[k] = parseFloat(margin[k]);
	});
	return o;
}
function write_ws_xml_margins(margin) {
	default_margins(margin);
	return writextag('pageMargins', null, margin);
}

function parse_ws_xml_cols(columns, cols) {
	var seencol = false;
	for(var coli = 0; coli != cols.length; ++coli) {
		var coll = parsexmltag(cols[coli], true);
		if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
		var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
		delete coll.min; delete coll.max; coll.width = +coll.width;
		if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
		process_col(coll);
		while(colm <= colM) columns[colm++] = dup(coll);
	}
}

function write_ws_xml_cols(ws, cols) {
	var o = ["<cols>"], col;
	for(var i = 0; i != cols.length; ++i) {
		if(!(col = cols[i])) continue;
		o[o.length] = (writextag('col', null, col_obj_w(i, col)));
	}
	o[o.length] = "</cols>";
	return o.join("");
}

function parse_ws_xml_autofilter(data) {
	var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
	return o;
}
function write_ws_xml_autofilter(data) {
	return writextag("autoFilter", null, {ref:data.ref});
}

/* 18.3.1.88 sheetViews CT_SheetViews */
/* 18.3.1.87 sheetView CT_SheetView */
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/>/;
function parse_ws_xml_sheetviews(data, wb) {
	(data.match(sviewregex)||[]).forEach(function(r) {
		var tag = parsexmltag(r);
		if(parsexmlbool(tag.rightToLeft)) {
			if(!wb.Views) wb.Views = [{}];
			if(!wb.Views[0]) wb.Views[0] = {};
			wb.Views[0].RTL = true;
		}
	});
}
function write_ws_xml_sheetviews(ws, opts, idx, wb) {
	var sview = {workbookViewId:"0"};
	// $FlowIgnore
	if( (((wb||{}).Workbook||{}).Views||[])[0] ) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
	return writextag("sheetViews", writextag("sheetView", null, sview), {});
}

function write_ws_xml_cell(cell, ref, ws, opts) {
	if(cell.v === undefined && cell.f === undefined || cell.t === 'z') return "";
	var vv = "";
	var oldt = cell.t, oldv = cell.v;
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'n': vv = ''+cell.v; break;
		case 'e': vv = BErr[cell.v]; break;
		case 'd':
			if(opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
			else {
				cell = dup(cell);
				cell.t = 'n';
				vv = ''+(cell.v = datenum(parseDate(cell.v)));
			}
			if(typeof cell.z === 'undefined') cell.z = SSF._table[14];
			break;
		default: vv = cell.v; break;
	}
	var v = writetag('v', escapexml(vv)), o = ({r:ref});
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	if(os !== 0) o.s = os;
	switch(cell.t) {
		case 'n': break;
		case 'd': o.t = "d"; break;
		case 'b': o.t = "b"; break;
		case 'e': o.t = "e"; break;
		default: if(cell.v == null) { delete cell.t; break; }
			if(opts.bookSST) {
				v = writetag('v', ''+get_sst_id(opts.Strings, cell.v));
				o.t = "s"; break;
			}
			o.t = "str"; break;
	}
	if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
	if(cell.f) {
		var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
		v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
	}
	if(cell.l) ws['!links'].push([ref, cell.l]);
	if(cell.c) ws['!comments'].push([ref, cell.c]);
	return writextag('c', v, o);
}

var parse_ws_xml_data = (function() {
	var cellregex = /<(?:\w+:)?c[ >]/, rowregex = /<\/(?:\w+:)?row>/;
	var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
	var refregex = /ref=["']([^"']*)["']/;
	var match_v = matchtag("v"), match_f = matchtag("f");

return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
	var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
	var tag, tagr = 0, tagc = 0;
	var sstr, ftag;
	var fmtid = 0, fillid = 0;
	var do_format = Array.isArray(styles.CellXf), cf;
	var arrayf = [];
	var sharedf = [];
	var dense = Array.isArray(s);
	var rows = [], rowobj = {}, rowrite = false;
	for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
		x = marr[mt].trim();
		var xlen = x.length;
		if(xlen === 0) continue;

		/* 18.3.1.73 row CT_Row */
		for(ri = 0; ri < xlen; ++ri) if(x.charCodeAt(ri) === 62) break; ++ri;
		tag = parsexmltag(x.slice(0,ri), true);
		tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
		if(opts.sheetRows && opts.sheetRows < tagr) continue;
		if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
		if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;

		if(opts && opts.cellStyles) {
			rowobj = {}; rowrite = false;
			if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
			if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
			if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
			if(rowrite) rows[tagr-1] = rowobj;
		}

		/* 18.3.1.4 c CT_Cell */
		cells = x.slice(ri).split(cellregex);
		for(ri = 0; ri != cells.length; ++ri) {
			x = cells[ri].trim();
			if(x.length === 0) continue;
			cref = x.match(rregex); idx = ri; i=0; cc=0;
			x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
			if(cref != null && cref.length === 2) {
				idx = 0; d=cref[1];
				for(i=0; i != d.length; ++i) {
					if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
					idx = 26*idx + cc;
				}
				--idx;
				tagc = idx;
			} else ++tagc;
			for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
			tag = parsexmltag(x.slice(0,i), true);
			if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
			d = x.slice(i);
			p = ({t:""});

			if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
			if(opts.cellFormula) {
				if((cref=d.match(match_f))!= null && cref[1] !== '') {
					/* TODO: match against XLSXFutureFunctions */
					p.f=_xlfn(unescapexml(utf8read(cref[1])));
					if(cref[0].indexOf('t="array"') > -1) {
						p.F = (d.match(refregex)||[])[1];
						if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
					} else if(cref[0].indexOf('t="shared"') > -1) {
						// TODO: parse formula
						ftag = parsexmltag(cref[0]);
						sharedf[parseInt(ftag.si, 10)] = [ftag, _xlfn(unescapexml(utf8read(cref[1])))];
					}
				} else if((cref=d.match(/<f[^>]*\/>/))) {
					ftag = parsexmltag(cref[0]);
					if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][0].ref, tag.r);
				}
				/* TODO: factor out contains logic */
				var _tag = decode_cell(tag.r);
				for(i = 0; i < arrayf.length; ++i)
					if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
						if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
							p.F = arrayf[i][1];
			}

			if(tag.t == null && p.v === undefined) {
				if(p.f || p.F) {
					p.v = 0; p.t = "n";
				} else if(!opts.sheetStubs) continue;
				else p.t = "z";
			}
			else p.t = tag.t || "n";
			if(guess.s.c > idx) guess.s.c = idx;
			if(guess.e.c < idx) guess.e.c = idx;
			/* 18.18.11 t ST_CellType */
			switch(p.t) {
				case 'n':
					if(p.v == "" || p.v == null) {
						if(!opts.sheetStubs) continue;
						p.t = 'z';
					} else p.v = parseFloat(p.v);
					break;
				case 's':
					if(typeof p.v == 'undefined') {
						if(!opts.sheetStubs) continue;
						p.t = 'z';
					} else {
						sstr = strs[parseInt(p.v, 10)];
						p.v = sstr.t;
						p.r = sstr.r;
						if(opts.cellHTML) p.h = sstr.h;
					}
					break;
				case 'str':
					p.t = "s";
					p.v = (p.v!=null) ? utf8read(p.v) : '';
					if(opts.cellHTML) p.h = escapehtml(p.v);
					break;
				case 'inlineStr':
					cref = d.match(isregex);
					p.t = 's';
					if(cref != null && (sstr = parse_si(cref[1]))) p.v = sstr.t; else p.v = "";
					break;
				case 'b': p.v = parsexmlbool(p.v); break;
				case 'd':
					if(opts.cellDates) p.v = parseDate(p.v, 1);
					else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
					break;
				/* error string in .w, number in .v */
				case 'e':
					if(!opts || opts.cellText !== false) p.w = p.v;
					p.v = RBErr[p.v]; break;
			}
			/* formatting */
			fmtid = fillid = 0;
			if(do_format && tag.s !== undefined) {
				cf = styles.CellXf[tag.s];
				if(cf != null) {
					if(cf.numFmtId != null) fmtid = cf.numFmtId;
					if(opts.cellStyles) {
						if(cf.fillId != null) fillid = cf.fillId;
					}
				}
			}
			safe_format(p, fmtid, fillid, opts, themes, styles);
			if(opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
			if(dense) {
				var _r = decode_cell(tag.r);
				if(!s[_r.r]) s[_r.r] = [];
				s[_r.r][_r.c] = p;
			} else s[tag.r] = p;
		}
	}
	if(rows.length > 0) s['!rows'] = rows;
}; })();

function write_ws_xml_data(ws, opts, idx, wb) {
	var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
	var dense = Array.isArray(ws);
	var params = ({r:rr}), row, height = -1;
	for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
	for(R = range.s.r; R <= range.e.r; ++R) {
		r = [];
		rr = encode_row(R);
		for(C = range.s.c; C <= range.e.c; ++C) {
			ref = cols[C] + rr;
			var _cell = dense ? (ws[R]||[])[C]: ws[ref];
			if(_cell === undefined) continue;
			if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
		}
		if(r.length > 0 || (rows && rows[R])) {
			params = ({r:rr});
			if(rows && rows[R]) {
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
			}
			o[o.length] = (writextag('row', r.join(""), params));
		}
	}
	if(rows) for(; R < rows.length; ++R) {
		if(rows && rows[R]) {
			params = ({r:R+1});
			row = rows[R];
			if(row.hidden) params.hidden = 1;
			height = -1;
			if (row.hpx) height = px2pt(row.hpx);
			else if (row.hpt) height = row.hpt;
			if (height > -1) { params.ht = height; params.customHeight = 1; }
			if (row.level) { params.outlineLevel = row.level; }
			o[o.length] = (writextag('row', "", params));
		}
	}
	return o.join("");
}

var WS_XML_ROOT = writextag('worksheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_ws_xml(idx, opts, wb, rels) {
	var o = [XML_HEADER, WS_XML_ROOT];
	var s = wb.SheetNames[idx], sidx = 0, rdata = "";
	var ws = wb.Sheets[s];
	if(ws == null) ws = {};
	var ref = ws['!ref'] || 'A1';
	var range = safe_decode_range(ref);
	if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
		range.e.c = Math.min(range.e.c, 0x3FFF);
		range.e.r = Math.min(range.e.c, 0xFFFFF);
		ref = encode_range(range);
	}
	if(!rels) rels = {};
	ws['!comments'] = [];
	ws['!drawing'] = [];

	if(opts.bookType !== 'xlsx' && wb.vbaraw) {
		var cname = wb.SheetNames[idx];
		try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
		o[o.length] = (writextag('sheetPr', null, {'codeName': escapexml(cname)}));
	}

	o[o.length] = (writextag('dimension', null, {'ref': ref}));

	o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);

	/* TODO: store in WB, process styles */
	if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
		defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
		baseColWidth:opts.sheetFormat.baseColWidth||'10',
		outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
	}));

	if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));

	o[sidx = o.length] = '<sheetData/>';
	ws['!links'] = [];
	if(ws['!ref'] != null) {
		rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
		if(rdata.length > 0) o[o.length] = (rdata);
	}
	if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }

	/* sheetCalcPr */

	if(ws['!protect'] != null) o[o.length] = write_ws_xml_protection(ws['!protect']);

	/* protectedRanges */
	/* scenarios */

	if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter']);

	/* sortState */
	/* dataConsolidate */
	/* customSheetViews */

	if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));

	/* phoneticPr */
	/* conditionalFormatting */
	/* dataValidations */

	var relc = -1, rel, rId = -1;
	if(ws['!links'].length > 0) {
		o[o.length] = "<hyperlinks>";
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			rel = ({"ref":l[0]});
			if(l[1].Target.charAt(0) != "#") {
				rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
				rel["r:id"] = "rId"+rId;
			}
			if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
			if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
			o[o.length] = writextag("hyperlink",null,rel);
		});
		o[o.length] = "</hyperlinks>";
	}
	delete ws['!links'];

	/* printOptions */
	if (ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	/* pageSetup */

	//var hfidx = o.length;
	o[o.length] = "";

	/* rowBreaks */
	/* colBreaks */
	/* customProperties */
	/* cellWatches */

	o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));

	/* smartTags */

	if(ws['!drawing'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
	}
	else delete ws['!drawing'];

	if(ws['!comments'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
		ws['!legacy'] = rId;
	}

	/* drawingHF */
	/* picture */
	/* oleObjects */
	/* controls */
	/* webPublishItems */
	/* tableParts */
	/* extList */

	if(o.length>2) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.726 BrtRowHdr */
function parse_BrtRowHdr(data, length) {
	var z = ({});
	var tgt = data.l + length;
	z.r = data.read_shift(4);
	data.l += 4; // TODO: ixfe
	var miyRw = data.read_shift(2);
	data.l += 1; // TODO: top/bot padding
	var flags = data.read_shift(1);
	data.l = tgt;
	if(flags & 0x07) z.level = flags & 0x07;
	if(flags & 0x10) z.hidden = true;
	if(flags & 0x20) z.hpt = miyRw / 20;
	return z;
}
function write_BrtRowHdr(R, range, ws) {
	var o = new_buf(17+8*16);
	var row = (ws['!rows']||[])[R]||{};
	o.write_shift(4, R);

	o.write_shift(4, 0); /* TODO: ixfe */

	var miyRw = 0x0140;
	if(row.hpx) miyRw = px2pt(row.hpx) * 20;
	else if(row.hpt) miyRw = row.hpt * 20;
	o.write_shift(2, miyRw);

	o.write_shift(1, 0); /* top/bot padding */

	var flags = 0x0;
	if(row.level) flags |= row.level;
	if(row.hidden) flags |= 0x10;
	if(row.hpx || row.hpt) flags |= 0x20;
	o.write_shift(1, flags);

	o.write_shift(1, 0); /* phonetic guide */

	/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
	var ncolspan = 0, lcs = o.l;
	o.l += 4;

	var caddr = {r:R, c:0};
	for(var i = 0; i < 16; ++i) {
		if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
		var first = -1, last = -1;
		for(var j = (i<<10); j < ((i+1)<<10); ++j) {
			caddr.c = j;
			var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
			if(cell) { if(first < 0) first = j; last = j; }
		}
		if(first < 0) continue;
		++ncolspan;
		o.write_shift(4, first);
		o.write_shift(4, last);
	}

	var l = o.l;
	o.l = lcs;
	o.write_shift(4, ncolspan);
	o.l = l;

	return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_row_header(ba, ws, range, R) {
	var o = write_BrtRowHdr(R, range, ws);
	if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 'BrtRowHdr', o);
}

/* [MS-XLSB] 2.4.820 BrtWsDim */
var parse_BrtWsDim = parse_UncheckedRfX;
var write_BrtWsDim = write_UncheckedRfX;

/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
function parse_BrtWsFmtInfo() {
}
//function write_BrtWsFmtInfo(ws, o) { }

/* [MS-XLSB] 2.4.823 BrtWsProp */
function parse_BrtWsProp(data, length) {
	var z = {};
	/* TODO: pull flags */
	data.l += 19;
	z.name = parse_XLSBCodeName(data, length - 19);
	return z;
}
function write_BrtWsProp(str, o) {
	if(o == null) o = new_buf(84+4*str.length);
	for(var i = 0; i < 3; ++i) o.write_shift(1,0);
	write_BrtColor({auto:1}, o);
	o.write_shift(-4,-1);
	o.write_shift(-4,-1);
	write_XLSBCodeName(str, o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.306 BrtCellBlank */
function parse_BrtCellBlank(data) {
	var cell = parse_XLSBCell(data);
	return [cell];
}
function write_BrtCellBlank(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	return write_XLSBCell(ncell, o);
}


/* [MS-XLSB] 2.4.307 BrtCellBool */
function parse_BrtCellBool(data) {
	var cell = parse_XLSBCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtCellBool(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}

/* [MS-XLSB] 2.4.308 BrtCellError */
function parse_BrtCellError(data) {
	var cell = parse_XLSBCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}

/* [MS-XLSB] 2.4.311 BrtCellIsst */
function parse_BrtCellIsst(data) {
	var cell = parse_XLSBCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtCellIsst(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}

/* [MS-XLSB] 2.4.313 BrtCellReal */
function parse_BrtCellReal(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtCellReal(cell, ncell, o) {
	if(o == null) o = new_buf(16);
	write_XLSBCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.314 BrtCellRk */
function parse_BrtCellRk(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtCellRk(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}


/* [MS-XLSB] 2.4.317 BrtCellSt */
function parse_BrtCellSt(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtCellSt(cell, ncell, o) {
	if(o == null) o = new_buf(12 + 4 * cell.v.length);
	write_XLSBCell(ncell, o);
	write_XLWideString(cell.v, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.653 BrtFmlaBool */
function parse_BrtFmlaBool(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'b'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.654 BrtFmlaError */
function parse_BrtFmlaError(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'e'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.655 BrtFmlaNum */
function parse_BrtFmlaNum(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_Xnum(data);
	var o = [cell, value, 'n'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.656 BrtFmlaString */
function parse_BrtFmlaString(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_XLWideString(data);
	var o = [cell, value, 'str'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.682 BrtMergeCell */
var parse_BrtMergeCell = parse_UncheckedRfX;
var write_BrtMergeCell = write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
function write_BrtBeginMergeCells(cnt, o) {
	if(o == null) o = new_buf(4);
	o.write_shift(4, cnt);
	return o;
}

/* [MS-XLSB] 2.4.662 BrtHLink */
function parse_BrtHLink(data, length) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var relId = parse_XLNullableWideString(data);
	var loc = parse_XLWideString(data);
	var tooltip = parse_XLWideString(data);
	var display = parse_XLWideString(data);
	data.l = end;
	var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
	if(tooltip) o.Tooltip = tooltip;
	return o;
}
function write_BrtHLink(l, rId) {
	var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
	write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
	write_RelID("rId" + rId, o);
	var locidx = l[1].Target.indexOf("#");
	var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
	write_XLWideString(loc || "", o);
	write_XLWideString(l[1].Tooltip || "", o);
	write_XLWideString("", o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.6 BrtArrFmla */
function parse_BrtArrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_RfX(data, 16);
	var fAlwaysCalc = data.read_shift(1);
	var o = [rfx]; o[2] = fAlwaysCalc;
	if(opts.cellFormula) {
		var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
		o[1] = formula;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.750 BrtShrFmla */
function parse_BrtShrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data, 16);
	var o = [rfx];
	if(opts.cellFormula) {
		var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
		o[1] = formula;
		data.l = end;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.323 BrtColInfo */
/* TODO: once XLS ColInfo is set, combine the functions */
function write_BrtColInfo(C, col, o) {
	if(o == null) o = new_buf(18);
	var p = col_obj_w(C, col);
	o.write_shift(-4, C);
	o.write_shift(-4, C);
	o.write_shift(4, (p.width || 10) * 256);
	o.write_shift(4, 0/*ixfe*/); // style
	var flags = 0;
	if(col.hidden) flags |= 0x01;
	if(typeof p.width == 'number') flags |= 0x02;
	o.write_shift(1, flags); // bit flag
	o.write_shift(1, 0); // bit flag
	return o;
}

/* [MS-XLSB] 2.4.678 BrtMargins */
var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
function parse_BrtMargins(data) {
	var margins = ({});
	BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
	return margins;
}
function write_BrtMargins(margins, o) {
	if(o == null) o = new_buf(6*8);
	default_margins(margins);
	BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
	return o;
}

/* [MS-XLSB] 2.4.299 BrtBeginWsView */
function parse_BrtBeginWsView(data) {
	var f = data.read_shift(2);
	data.l += 28;
	return { RTL: f & 0x20 };
}
function write_BrtBeginWsView(ws, Workbook, o) {
	if(o == null) o = new_buf(30);
	var f = 0x39c;
	if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
	o.write_shift(2, f); // bit flag
	o.write_shift(4, 0);
	o.write_shift(4, 0); // view first row
	o.write_shift(4, 0); // view first col
	o.write_shift(1, 0); // gridline color ICV
	o.write_shift(1, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 100); // zoom scale
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(4, 0); // workbook view id
	return o;
}

/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
function write_BrtCellIgnoreEC(ref) {
	var o = new_buf(24);
	o.write_shift(4, 4);
	o.write_shift(4, 1);
	write_UncheckedRfX(ref, o);
	return o;
}

/* [MS-XLSB] 2.4.748 BrtSheetProtection */
function write_BrtSheetProtection(sp, o) {
	if(o == null) o = new_buf(16*4+2);
	o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
	o.write_shift(4, 1); // this record should not be written if no protection
	[
		["objects",             false], // fObjects
		["scenarios",           false], // fScenarios
		["formatCells",          true], // fFormatCells
		["formatColumns",        true], // fFormatColumns
		["formatRows",           true], // fFormatRows
		["insertColumns",        true], // fInsertColumns
		["insertRows",           true], // fInsertRows
		["insertHyperlinks",     true], // fInsertHyperlinks
		["deleteColumns",        true], // fDeleteColumns
		["deleteRows",           true], // fDeleteRows
		["selectLockedCells",   false], // fSelLockedCells
		["sort",                 true], // fSort
		["autoFilter",           true], // fAutoFilter
		["pivotTables",          true], // fPivotTables
		["selectUnlockedCells", false]  // fSelUnlockedCells
	].forEach(function(n) {
if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
		else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
	});
	return o;
}

/* [MS-XLSB] 2.1.7.61 Worksheet */
function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
	if(!data) return data;
	var opts = _opts || {};
	if(!rels) rels = {'!id':{}};
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var s = (opts.dense ? [] : {});

	var ref;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	var pass = false, end = false;
	var row, p, cf, R, C, addr, sstr, rr, cell;
	var merges = [];
	opts.biff = 12;
	opts['!row'] = 0;

	var ai = 0, af = false;

	var arrayf = [];
	var sharedf = {};
	var supbooks = opts.supbooks || ([[]]);
	supbooks.sharedf = sharedf;
	supbooks.arrayf = arrayf;
	supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
	if(!opts.supbooks) {
		opts.supbooks = supbooks;
		if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
	}

	var colinfo = [], rowinfo = [];
	var seencol = false;

	recordhopper(data, function ws_parse(val, R_n, RT) {
		if(end) return;
		switch(RT) {
			case 0x0094: /* 'BrtWsDim' */
				ref = val; break;
			case 0x0000: /* 'BrtRowHdr' */
				row = val;
				if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
				rr = encode_row(R = row.r);
				opts['!row'] = row.r;
				if(val.hidden || val.hpt || val.level != null) {
					if(val.hpt) val.hpx = pt2px(val.hpt);
					rowinfo[val.r] = val;
				}
				break;

			case 0x0002: /* 'BrtCellRk' */
			case 0x0003: /* 'BrtCellError' */
			case 0x0004: /* 'BrtCellBool' */
			case 0x0005: /* 'BrtCellReal' */
			case 0x0006: /* 'BrtCellSt' */
			case 0x0007: /* 'BrtCellIsst' */
			case 0x0008: /* 'BrtFmlaString' */
			case 0x0009: /* 'BrtFmlaNum' */
			case 0x000A: /* 'BrtFmlaBool' */
			case 0x000B: /* 'BrtFmlaError' */
				p = ({t:val[2]});
				switch(val[2]) {
					case 'n': p.v = val[1]; break;
					case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
					case 'b': p.v = val[1] ? true : false; break;
					case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
					case 'str': p.t = 's'; p.v = val[1]; break;
				}
				if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
				C = val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(opts.cellFormula) {
					af = false;
					for(ai = 0; ai < arrayf.length; ++ai) {
						var aii = arrayf[ai];
						if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
							if(C >= aii[0].s.c && C <= aii[0].e.c) {
								p.F = encode_range(aii[0]); af = true;
							}
					}
					if(!af && val.length > 3) p.f = val[3];
				}
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
					var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
				}
				break;

			case 0x0001: /* 'BrtCellBlank' */
				if(!opts.sheetStubs || pass) break;
				p = ({t:'z',v:undefined});
				C = val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				break;

			case 0x00B0: /* 'BrtMergeCell' */
				merges.push(val); break;

			case 0x01EE: /* 'BrtHLink' */
				var rel = rels['!id'][val.relId];
				if(rel) {
					val.Target = rel.Target;
					if(val.loc) val.Target += "#"+val.loc;
					val.Rel = rel;
				} else if(val.relId == '') {
					val.Target = "#" + val.loc;
				}
				for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
					if(opts.dense) {
						if(!s[R]) s[R] = [];
						if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
						s[R][C].l = val;
					} else {
						addr = encode_cell({c:C,r:R});
						if(!s[addr]) s[addr] = {t:'z',v:undefined};
						s[addr].l = val;
					}
				}
				break;

			case 0x01AA: /* 'BrtArrFmla' */
				if(!opts.cellFormula) break;
				arrayf.push(val);
				cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				cell.F = encode_range(val[0]);
				break;
			case 0x01AB: /* 'BrtShrFmla' */
				if(!opts.cellFormula) break;
				sharedf[encode_cell(val[0].s)] = val[1];
				cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				break;

			/* identical to 'ColInfo' in XLS */
			case 0x003C: /* 'BrtColInfo' */
				if(!opts.cellStyles) break;
				while(val.e >= val.s) {
					colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01) };
					if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
					process_col(colinfo[val.e+1]);
				}
				break;

			case 0x00A1: /* 'BrtBeginAFilter' */
				s['!autofilter'] = { ref:encode_range(val) };
				break;

			case 0x01DC: /* 'BrtMargins' */
				s['!margins'] = val;
				break;

			case 0x0093: /* 'BrtWsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0089: /* 'BrtBeginWsView' */
				if(!wb.Views) wb.Views = [{}];
				if(!wb.Views[0]) wb.Views[0] = {};
				if(val.RTL) wb.Views[0].RTL = true;
				break;

			case 0x01E5: /* 'BrtWsFmtInfo' */
				break;
			case 0x00AF: /* 'BrtAFilterDateGroupItem' */
			case 0x0284: /* 'BrtActiveX' */
			case 0x0271: /* 'BrtBigName' */
			case 0x0232: /* 'BrtBkHim' */
			case 0x018C: /* 'BrtBrk' */
			case 0x0458: /* 'BrtCFIcon' */
			case 0x047A: /* 'BrtCFRuleExt' */
			case 0x01D7: /* 'BrtCFVO' */
			case 0x041A: /* 'BrtCFVO14' */
			case 0x0289: /* 'BrtCellIgnoreEC' */
			case 0x0451: /* 'BrtCellIgnoreEC14' */
			case 0x0031: /* 'BrtCellMeta' */
			case 0x024D: /* 'BrtCellSmartTagProperty' */
			case 0x025F: /* 'BrtCellWatch' */
			case 0x0234: /* 'BrtColor' */
			case 0x041F: /* 'BrtColor14' */
			case 0x00A8: /* 'BrtColorFilter' */
			case 0x00AE: /* 'BrtCustomFilter' */
			case 0x049C: /* 'BrtCustomFilter14' */
			case 0x01F3: /* 'BrtDRef' */
			case 0x0040: /* 'BrtDVal' */
			case 0x041D: /* 'BrtDVal14' */
			case 0x0226: /* 'BrtDrawing' */
			case 0x00AB: /* 'BrtDynamicFilter' */
			case 0x00A7: /* 'BrtFilter' */
			case 0x0499: /* 'BrtFilter14' */
			case 0x00A9: /* 'BrtIconFilter' */
			case 0x049D: /* 'BrtIconFilter14' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x0295: /* 'BrtListPart' */
			case 0x027F: /* 'BrtOleObject' */
			case 0x01DE: /* 'BrtPageSetup' */
			case 0x0097: /* 'BrtPane' */
			case 0x0219: /* 'BrtPhoneticInfo' */
			case 0x01DD: /* 'BrtPrintOptions' */
			case 0x0218: /* 'BrtRangeProtection' */
			case 0x044F: /* 'BrtRangeProtection14' */
			case 0x02A8: /* 'BrtRangeProtectionIso' */
			case 0x0450: /* 'BrtRangeProtectionIso14' */
			case 0x0400: /* 'BrtRwDescent' */
			case 0x0098: /* 'BrtSel' */
			case 0x0297: /* 'BrtSheetCalcProp' */
			case 0x0217: /* 'BrtSheetProtection' */
			case 0x02A6: /* 'BrtSheetProtectionIso' */
			case 0x01F8: /* 'BrtSlc' */
			case 0x0413: /* 'BrtSparkline' */
			case 0x01AC: /* 'BrtTable' */
			case 0x00AA: /* 'BrtTop10Filter' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0032: /* 'BrtValueMeta' */
			case 0x0816: /* 'BrtWebExtension' */
			case 0x0415: /* 'BrtWsFmtInfoEx14' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	delete opts.supbooks;
	delete opts['!row'];

	if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
	if(opts.sheetRows && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(merges.length > 0) s["!merges"] = merges;
	if(colinfo.length > 0) s["!cols"] = colinfo;
	if(rowinfo.length > 0) s["!rows"] = rowinfo;
	return s;
}

/* TODO: something useful -- this is a stub */
function write_ws_bin_cell(ba, cell, R, C, opts, ws) {
	if(cell.v === undefined) return "";
	var vv = "";
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'd': // no BrtCellDate :(
			cell = dup(cell);
			cell.z = cell.z || SSF._table[14];
			cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
			break;
		/* falls through */
		case 'n': case 'e': vv = ''+cell.v; break;
		default: vv = cell.v; break;
	}
	var o = ({r:R, c:C});
	/* TODO: cell style */
	o.s = get_cell_style(opts.cellXfs, cell, opts);
	if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
	if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
	switch(cell.t) {
		case 's': case 'str':
			if(opts.bookSST) {
				vv = get_sst_id(opts.Strings, (cell.v));
				o.t = "s"; o.v = vv;
				write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
			} else {
				o.t = "str";
				write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
			}
			return;
		case 'n':
			/* TODO: determine threshold for Real vs RK */
			if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
			else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
			return;
		case 'b':
			o.t = "b";
			write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
			return;
		case 'e': /* TODO: error */ o.t = "e"; break;
	}
	write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
}

function write_CELLTABLE(ba, ws, idx, opts) {
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	write_record(ba, 'BrtBeginSheetData');
	var dense = Array.isArray(ws);
	var cap = range.e.r;
	if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
	for(var R = range.s.r; R <= cap; ++R) {
		rr = encode_row(R);
		/* [ACCELLTABLE] */
		/* BrtRowHdr */
		write_row_header(ba, ws, range, R);
		if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
			/* *16384CELL */
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_bin_cell(ba, cell, R, C, opts, ws);
		}
	}
	write_record(ba, 'BrtEndSheetData');
}

function write_MERGECELLS(ba, ws) {
	if(!ws || !ws['!merges']) return;
	write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
	ws['!merges'].forEach(function(m) { write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m)); });
	write_record(ba, 'BrtEndMergeCells');
}

function write_COLINFOS(ba, ws) {
	if(!ws || !ws['!cols']) return;
	write_record(ba, 'BrtBeginColInfos');
	ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m)); });
	write_record(ba, 'BrtEndColInfos');
}

function write_IGNOREECS(ba, ws) {
	if(!ws || !ws['!ref']) return;
	write_record(ba, 'BrtBeginCellIgnoreECs');
	write_record(ba, 'BrtCellIgnoreEC', write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
	write_record(ba, 'BrtEndCellIgnoreECs');
}

function write_HLINKS(ba, ws, rels) {
	/* *BrtHLink */
	ws['!links'].forEach(function(l) {
		if(!l[1].Target) return;
		var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
		write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
	});
	delete ws['!links'];
}
function write_LEGACYDRAWING(ba, ws, idx, rels) {
	/* [BrtLegacyDrawing] */
	if(ws['!comments'].length > 0) {
		var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
		ws['!legacy'] = rId;
	}
}

function write_AUTOFILTER(ba, ws) {
	if(!ws['!autofilter']) return;
	write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(safe_decode_range(ws['!autofilter'].ref)));
	/* *FILTERCOLUMN */
	/* [SORTSTATE] */
	/* BrtEndAFilter */
	write_record(ba, "BrtEndAFilter");
}

function write_WSVIEWS2(ba, ws, Workbook) {
	write_record(ba, "BrtBeginWsViews");
	{ /* 1*WSVIEW2 */
		/* [ACUID] */
		write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
		/* [BrtPane] */
		/* *4BrtSel */
		/* *4SXSELECT */
		/* *FRT */
		write_record(ba, "BrtEndWsView");
	}
	/* *FRT */
	write_record(ba, "BrtEndWsViews");
}

function write_WSFMTINFO() {
	/* [ACWSFMTINFO] */
	//write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
}

function write_SHEETPROTECT(ba, ws) {
	if(!ws['!protect']) return;
	/* [BrtSheetProtectionIso] */
	write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
}

function write_ws_bin(idx, opts, wb, rels) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
	var r = safe_decode_range(ws['!ref'] || "A1");
	if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
		r.e.c = Math.min(r.e.c, 0x3FFF);
		r.e.r = Math.min(r.e.c, 0xFFFFF);
	}
	ws['!links'] = [];
	/* passed back to write_zip and removed there */
	ws['!comments'] = [];
	write_record(ba, "BrtBeginSheet");
	if(wb.vbaraw) write_record(ba, "BrtWsProp", write_BrtWsProp(c));
	write_record(ba, "BrtWsDim", write_BrtWsDim(r));
	write_WSVIEWS2(ba, ws, wb.Workbook);
	write_WSFMTINFO(ba, ws);
	write_COLINFOS(ba, ws, idx, opts, wb);
	write_CELLTABLE(ba, ws, idx, opts, wb);
	/* [BrtSheetCalcProp] */
	write_SHEETPROTECT(ba, ws);
	/* *([BrtRangeProtectionIso] BrtRangeProtection) */
	/* [SCENMAN] */
	write_AUTOFILTER(ba, ws);
	/* [SORTSTATE] */
	/* [DCON] */
	/* [USERSHVIEWS] */
	write_MERGECELLS(ba, ws);
	/* [BrtPhoneticInfo] */
	/* *CONDITIONALFORMATTING */
	/* [DVALS] */
	write_HLINKS(ba, ws, rels);
	/* [BrtPrintOptions] */
	if(ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
	/* [BrtPageSetup] */
	/* [HEADERFOOTER] */
	/* [RWBRK] */
	/* [COLBRK] */
	/* *BrtBigName */
	/* [CELLWATCHES] */
	write_IGNOREECS(ba, ws);
	/* [SMARTTAGS] */
	/* [BrtDrawing] */
	write_LEGACYDRAWING(ba, ws, idx, rels);
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [OLEOBJECTS] */
	/* [ACTIVEXCONTROLS] */
	/* [WEBPUBITEMS] */
	/* [LISTPARTS] */
	/* FRTWORKSHEET */
	write_record(ba, "BrtEndSheet");
	return ba.end();
}
function parse_numCache(data) {
	var col = [];

	/* 21.2.2.150 pt CT_NumVal */
	(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
		var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
		if(!q) return;
		col[+q[1]] = +q[2];
	});

	/* 21.2.2.71 formatCode CT_Xstring */
	var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);

	return [col, nf];
}

/* 21.2 DrawingML - Charts */
function parse_chart(data, name, opts, rels, wb, csheet) {
	var cs = ((csheet || {"!type":"chart"}));
	if(!data) return csheet;
	/* 21.2.2.27 chart CT_Chart */

	var C = 0, R = 0, col = "A";
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	/* 21.2.2.120 numCache CT_NumData */
	(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
		var cache = parse_numCache(nc);
		refguess.s.r = refguess.s.c = 0;
		refguess.e.c = C;
		col = encode_col(C);
		cache[0].forEach(function(n,i) {
			cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
			R = i;
		});
		if(refguess.e.r < R) refguess.e.r = R;
		++C;
	});
	if(C > 0) cs["!ref"] = encode_range(refguess);
	return cs;
}
RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";

var CS_XML_ROOT = writextag('chartsheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

/* 18.3 Worksheets also covers Chartsheets */
function parse_cs_xml(data, opts, idx, rels, wb) {
	if(!data) return data;
	/* 18.3.1.12 chartsheet CT_ChartSheet */
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!chart':null, '!rel':""};
	var m;

	/* 18.3.1.83 sheetPr CT_ChartsheetPr */
	var sheetPr = data.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.36 drawing CT_Drawing */
	if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];

	if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_xml(idx, opts, wb, rels) {
	var o = [XML_HEADER, CS_XML_ROOT];
	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.331 BrtCsProp */
function parse_BrtCsProp(data, length) {
	data.l += 10;
	var name = parse_XLWideString(data, length - 10);
	return { name: name };
}

/* [MS-XLSB] 2.1.7.7 Chart Sheet */
function parse_cs_bin(data, opts, idx, rels, wb) {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!chart':null, '!rel':""};
	var state = [];
	var pass = false;
	recordhopper(data, function cs_parse(val, R_n, RT) {
		switch(RT) {

			case 0x0226: /* 'BrtDrawing' */
				s['!rel'] = val; break;

			case 0x028B: /* 'BrtCsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0232: /* 'BrtBkHim' */
			case 0x028C: /* 'BrtCsPageSetup' */
			case 0x029D: /* 'BrtCsProtection' */
			case 0x02A7: /* 'BrtCsProtectionIso' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x01DC: /* 'BrtMargins' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); break;

			default:
				if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
				else if((R_n||"").indexOf("End") > 0) state.pop();
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	if(rels['!id'][s['!rel']]) s['!chart'] = rels['!id'][s['!rel']];
	return s;
}
function write_cs_bin() {
	var ba = buf_array();
	write_record(ba, "BrtBeginSheet");
	/* [BrtCsProp] */
	/* CSVIEWS */
	/* [[BrtCsProtectionIso] BrtCsProtection] */
	/* [USERCSVIEWS] */
	/* [BrtMargins] */
	/* [BrtCsPageSetup] */
	/* [HEADERFOOTER] */
	/* BrtDrawing */
	/* [BrtLegacyDrawing] */
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [WEBPUBITEMS] */
	/* FRTCHARTSHEET */
	write_record(ba, "BrtEndSheet");
	return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */
var WBPropsDef = [
	['allowRefreshQuery',           false, "bool"],
	['autoCompressPictures',        true,  "bool"],
	['backupFile',                  false, "bool"],
	['checkCompatibility',          false, "bool"],
	['CodeName',                    ''],
	['date1904',                    false, "bool"],
	['defaultThemeVersion',         0,      "int"],
	['filterPrivacy',               false, "bool"],
	['hidePivotFieldList',          false, "bool"],
	['promptedSolutions',           false, "bool"],
	['publishItems',                false, "bool"],
	['refreshAllConnections',       false, "bool"],
	['saveExternalLinkValues',      true,  "bool"],
	['showBorderUnselectedTables',  true,  "bool"],
	['showInkAnnotation',           true,  "bool"],
	['showObjects',                 'all'],
	['showPivotChartFilter',        false, "bool"],
	['updateLinks', 'userSet']
];

/* 18.2.30 (CT_BookView) Defaults */
var WBViewDef = [
	['activeTab',                   0,      "int"],
	['autoFilterDateGrouping',      true,  "bool"],
	['firstSheet',                  0,      "int"],
	['minimized',                   false, "bool"],
	['showHorizontalScroll',        true,  "bool"],
	['showSheetTabs',               true,  "bool"],
	['showVerticalScroll',          true,  "bool"],
	['tabRatio',                    600,    "int"],
	['visibility',                  'visible']
	//window{Height,Width}, {x,y}Window
];

/* 18.2.19 (CT_Sheet) Defaults */
var SheetDef = [
	//['state', 'visible']
];

/* 18.2.2  (CT_CalcPr) Defaults */
var CalcPrDef = [
	['calcCompleted', 'true'],
	['calcMode', 'auto'],
	['calcOnSave', 'true'],
	['concurrentCalc', 'true'],
	['fullCalcOnLoad', 'false'],
	['fullPrecision', 'true'],
	['iterate', 'false'],
	['iterateCount', '100'],
	['iterateDelta', '0.001'],
	['refMode', 'A1']
];

/* 18.2.3 (CT_CustomWorkbookView) Defaults */
/*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/

function push_defaults_array(target, defaults) {
	for(var j = 0; j != target.length; ++j) { var w = target[j];
		for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
			if(w[z[0]] == null) w[z[0]] = z[1];
			else switch(z[2]) {
			case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
			case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
			}
		}
	}
}
function push_defaults(target, defaults) {
	for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
		if(target[z[0]] == null) target[z[0]] = z[1];
		else switch(z[2]) {
			case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
			case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
		}
	}
}

function parse_wb_defaults(wb) {
	push_defaults(wb.WBProps, WBPropsDef);
	push_defaults(wb.CalcPr, CalcPrDef);

	push_defaults_array(wb.WBView, WBViewDef);
	push_defaults_array(wb.Sheets, SheetDef);

	_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
}

function safe1904(wb) {
	/* TODO: store date1904 somewhere else */
	if(!wb.Workbook) return "false";
	if(!wb.Workbook.WBProps) return "false";
	return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}

var badchars = "][*?\/\\".split("");
function check_ws_name(n, safe) {
	if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
	var _good = true;
	badchars.forEach(function(c) {
		if(n.indexOf(c) == -1) return;
		if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
		_good = false;
	});
	return _good;
}
function check_wb_names(N, S, codes) {
	N.forEach(function(n,i) {
		check_ws_name(n);
		for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
		if(codes) {
			var cn = (S && S[i] && S[i].CodeName) || n;
			if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
		}
	});
}
function check_wb(wb) {
	if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
	if(!wb.SheetNames.length) throw new Error("Workbook is empty");
	var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
	check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
	for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
	/* TODO: validate workbook */
}
/* 18.2 Workbook */
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(data, opts) {
	if(!data) throw new Error("Could not find file");
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
	var pass = false, xmlns = "xmlns";
	var dname = {}, dnstart = 0;
	data.replace(tagregex, function xml_wb(x, idx) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 18.2.27 workbook CT_Workbook 1 */
			case '<workbook':
				if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
				wb.xmlns = y[xmlns];
				break;
			case '</workbook>': break;

			/* 18.2.13 fileVersion CT_FileVersion ? */
			case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
			case '<fileVersion/>': case '</fileVersion>': break;

			/* 18.2.12 fileSharing CT_FileSharing ? */
			case '<fileSharing': case '<fileSharing/>': break;

			/* 18.2.28 workbookPr CT_WorkbookPr ? */
			case '<workbookPr':
			case '<workbookPr/>':
				WBPropsDef.forEach(function(w) {
					if(y[w[0]] == null) return;
					switch(w[2]) {
						case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
						case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
						default: wb.WBProps[w[0]] = y[w[0]];
					}
				});
				if(y.codeName) wb.WBProps.CodeName = y.codeName;
				break;
			case '</workbookPr>': break;

			/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
			case '<workbookProtection': break;
			case '<workbookProtection/>': break;

			/* 18.2.1  bookViews CT_BookViews ? */
			case '<bookViews': case '<bookViews>': case '</bookViews>': break;
			/* 18.2.30   workbookView CT_BookView + */
			case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
			case '</workbookView>': break;

			/* 18.2.20 sheets CT_Sheets 1 */
			case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
			/* 18.2.19   sheet CT_Sheet + */
			case '<sheet':
				switch(y.state) {
					case "hidden": y.Hidden = 1; break;
					case "veryHidden": y.Hidden = 2; break;
					default: y.Hidden = 0;
				}
				delete y.state;
				y.name = unescapexml(utf8read(y.name));
				delete y[0]; wb.Sheets.push(y); break;
			case '</sheet>': break;

			/* 18.2.15 functionGroups CT_FunctionGroups ? */
			case '<functionGroups': case '<functionGroups/>': break;
			/* 18.2.14   functionGroup CT_FunctionGroup + */
			case '<functionGroup': break;

			/* 18.2.9  externalReferences CT_ExternalReferences ? */
			case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
			/* 18.2.8    externalReference CT_ExternalReference + */
			case '<externalReference': break;

			/* 18.2.6  definedNames CT_DefinedNames ? */
			case '<definedNames/>': break;
			case '<definedNames>': case '<definedNames': pass=true; break;
			case '</definedNames>': pass=false; break;
			/* 18.2.5    definedName CT_DefinedName + */
			case '<definedName': {
				dname = {};
				dname.Name = y.name;
				if(y.comment) dname.Comment = y.comment;
				if(y.localSheetId) dname.Sheet = +y.localSheetId;
				dnstart = idx + x.length;
			}	break;
			case '</definedName>': {
				dname.Ref = data.slice(dnstart, idx);
				wb.Names.push(dname);
			} break;
			case '<definedName/>': break;

			/* 18.2.2  calcPr CT_CalcPr ? */
			case '<calcPr': delete y[0]; wb.CalcPr = y; break;
			case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
			case '</calcPr>': break;

			/* 18.2.16 oleSize CT_OleSize ? (ref required) */
			case '<oleSize': break;

			/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
			case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
			/* 18.2.3    customWorkbookView CT_CustomWorkbookView + */
			case '<customWorkbookView': case '</customWorkbookView>': break;

			/* 18.2.18 pivotCaches CT_PivotCaches ? */
			case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
			/* 18.2.17 pivotCache CT_PivotCache ? */
			case '<pivotCache': break;

			/* 18.2.21 smartTagPr CT_SmartTagPr ? */
			case '<smartTagPr': case '<smartTagPr/>': break;

			/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
			case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
			/* 18.2.22   smartTagType CT_SmartTagType ? */
			case '<smartTagType': break;

			/* 18.2.24 webPublishing CT_WebPublishing ? */
			case '<webPublishing': case '<webPublishing/>': break;

			/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
			case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;

			/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
			case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
			/* 18.2.25 webPublishObject CT_WebPublishObject ? */
			case '<webPublishObject': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7    ext CT_Extension + */
			case '<ext': pass=true; break; //TODO: check with versions of excel
			case '</ext>': pass=false; break;

			/* Others */
			case '<ArchID': break;
			case '<AlternateContent':
			case '<AlternateContent>': pass=true; break;
			case '</AlternateContent>': pass=false; break;

			/* TODO */
			case '<revisionPtr': break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
		}
		return x;
	});
	if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);

	parse_wb_defaults(wb);

	return wb;
}

var WB_XML_ROOT = writextag('workbook', null, {
	'xmlns': XMLNS.main[0],
	//'xmlns:mx': XMLNS.mx,
	//'xmlns:s': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_wb_xml(wb) {
	var o = [XML_HEADER];
	o[o.length] = WB_XML_ROOT;

	var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);

	/* fileVersion */
	/* fileSharing */

	var workbookPr = ({codeName:"ThisWorkbook"});
	if(wb.Workbook && wb.Workbook.WBProps) {
		WBPropsDef.forEach(function(x) {
if((wb.Workbook.WBProps[x[0]]) == null) return;
			if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
			workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
		});
if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
	}
	o[o.length] = (writextag('workbookPr', null, workbookPr));

	/* workbookProtection */
	/* bookViews */

	o[o.length] = "<sheets>";
	var sheets = wb.Workbook && wb.Workbook.Sheets || [];
	for(var i = 0; i != wb.SheetNames.length; ++i) {
		var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
		sht.sheetId = ""+(i+1);
		sht["r:id"] = "rId"+(i+1);
		if(sheets[i]) switch(sheets[i].Hidden) {
			case 1: sht.state = "hidden"; break;
			case 2: sht.state = "veryHidden"; break;
		}
		o[o.length] = (writextag('sheet',null,sht));
	}
	o[o.length] = "</sheets>";

	/* functionGroups */
	/* externalReferences */

	if(write_names) {
		o[o.length] = "<definedNames>";
		if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
			var d = {name:n.Name};
			if(n.Comment) d.comment = n.Comment;
			if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
			if(!n.Ref) return;
			o[o.length] = writextag('definedName', String(n.Ref), d);
		});
		o[o.length] = "</definedNames>";
	}

	/* calcPr */
	/* oleSize */
	/* customWorkbookViews */
	/* pivotCaches */
	/* smartTagPr */
	/* smartTagTypes */
	/* webPublishing */
	/* fileRecoveryPr */
	/* webPublishObjects */
	/* extLst */

	if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */
function parse_BrtBundleSh(data, length) {
	var z = {};
	z.Hidden = data.read_shift(4); //hsState ST_SheetState
	z.iTabID = data.read_shift(4);
	z.strRelID = parse_RelID(data,length-8);
	z.name = parse_XLWideString(data);
	return z;
}
function write_BrtBundleSh(data, o) {
	if(!o) o = new_buf(127);
	o.write_shift(4, data.Hidden);
	o.write_shift(4, data.iTabID);
	write_RelID(data.strRelID, o);
	write_XLWideString(data.name.slice(0,31), o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.815 BrtWbProp */
function parse_BrtWbProp(data, length) {
	var o = ({});
	var flags = data.read_shift(4);
	o.defaultThemeVersion = data.read_shift(4);
	var strName = (length > 8) ? parse_XLWideString(data) : "";
	if(strName.length > 0) o.CodeName = strName;
	o.autoCompressPictures = !!(flags & 0x10000);
	o.backupFile = !!(flags & 0x40);
	o.checkCompatibility = !!(flags & 0x1000);
	o.date1904 = !!(flags & 0x01);
	o.filterPrivacy = !!(flags & 0x08);
	o.hidePivotFieldList = !!(flags & 0x400);
	o.promptedSolutions = !!(flags & 0x10);
	o.publishItems = !!(flags & 0x800);
	o.refreshAllConnections = !!(flags & 0x40000);
	o.saveExternalLinkValues = !!(flags & 0x80);
	o.showBorderUnselectedTables = !!(flags & 0x04);
	o.showInkAnnotation = !!(flags & 0x20);
	o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
	o.showPivotChartFilter = !!(flags & 0x8000);
	o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
	return o;
}
function write_BrtWbProp(data, o) {
	if(!o) o = new_buf(72);
	var flags = 0;
	if(data) {
		/* TODO: mirror parse_BrtWbProp fields */
		if(data.filterPrivacy) flags |= 0x08;
	}
	o.write_shift(4, flags);
	o.write_shift(4, 0);
	write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
	return o.slice(0, o.l);
}

function parse_BrtFRTArchID$(data, length) {
	var o = {};
	data.read_shift(4);
	o.ArchID = data.read_shift(4);
	data.l += length - 8;
	return o;
}

/* [MS-XLSB] 2.4.687 BrtName */
function parse_BrtName(data, length, opts) {
	var end = data.l + length;
	data.l += 4; //var flags = data.read_shift(4);
	data.l += 1; //var chKey = data.read_shift(1);
	var itab = data.read_shift(4);
	var name = parse_XLNameWideString(data);
	var formula = parse_XLSBNameParsedFormula(data, 0, opts);
	var comment = parse_XLNullableWideString(data);
	//if(0 /* fProc */) {
		// unusedstring1: XLNullableWideString
		// description: XLNullableWideString
		// helpTopic: XLNullableWideString
		// unusedstring2: XLNullableWideString
	//}
	data.l = end;
	var out = ({Name:name, Ptg:formula});
	if(itab < 0xFFFFFFF) out.Sheet = itab;
	if(comment) out.Comment = comment;
	return out;
}

/* [MS-XLSB] 2.1.7.61 Workbook */
function parse_wb_bin(data, opts) {
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
	var pass = false;

	if(!opts) opts = {};
	opts.biff = 12;

	var Names = [];
	var supbooks = ([[]]);
	supbooks.SheetNames = [];
	supbooks.XTI = [];

	recordhopper(data, function hopper_wb(val, R_n, RT) {
		switch(RT) {
			case 0x009C: /* 'BrtBundleSh' */
				supbooks.SheetNames.push(val.name);
				wb.Sheets.push(val); break;

			case 0x0099: /* 'BrtWbProp' */
				wb.WBProps = val; break;

			case 0x0027: /* 'BrtName' */
				if(val.Sheet != null) opts.SID = val.Sheet;
				val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
				delete opts.SID;
				delete val.Ptg;
				Names.push(val);
				break;
			case 0x040C: /* 'BrtNameExt' */ break;

			case 0x0165: /* 'BrtSupSelf' */
			case 0x0166: /* 'BrtSupSame' */
			case 0x0163: /* 'BrtSupBookSrc' */
			case 0x029B: /* 'BrtSupAddin' */
				if(!supbooks[0].length) supbooks[0] = [RT, val];
				else supbooks.push([RT, val]);
				supbooks[supbooks.length - 1].XTI = [];
				break;
			case 0x016A: /* 'BrtExternSheet' */
				if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
				supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
				supbooks.XTI = supbooks.XTI.concat(val);
				break;
			case 0x0169: /* 'BrtPlaceholderName' */
				break;

			/* case 'BrtModelTimeGroupingCalcCol' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0C01: /* 'BrtRevisionPtr' */
			case 0x0817: /* 'BrtAbsPath15' */
			case 0x0216: /* 'BrtBookProtection' */
			case 0x02A5: /* 'BrtBookProtectionIso' */
			case 0x009E: /* 'BrtBookView' */
			case 0x009D: /* 'BrtCalcProp' */
			case 0x0262: /* 'BrtCrashRecErr' */
			case 0x0802: /* 'BrtDecoupledPivotCacheID' */
			case 0x009B: /* 'BrtFileRecover' */
			case 0x0224: /* 'BrtFileSharing' */
			case 0x02A4: /* 'BrtFileSharingIso' */
			case 0x0080: /* 'BrtFileVersion' */
			case 0x0299: /* 'BrtFnGroup' */
			case 0x0850: /* 'BrtModelRelationship' */
			case 0x084D: /* 'BrtModelTable' */
			case 0x0225: /* 'BrtOleSize' */
			case 0x0805: /* 'BrtPivotTableRef' */
			case 0x0254: /* 'BrtSmartTagType' */
			case 0x081C: /* 'BrtTableSlicerCacheID' */
			case 0x081B: /* 'BrtTableSlicerCacheIDs' */
			case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
			case 0x018D: /* 'BrtUserBookView' */
			case 0x009A: /* 'BrtWbFactoid' */
			case 0x045D: /* 'BrtWbProp14' */
			case 0x0229: /* 'BrtWebOpt' */
			case 0x082B: /* 'BrtWorkBookPr15' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;

			case 0x0010: /* 'BrtFRTArchID$' */ break;

			default:
				if((R_n||"").indexOf("Begin") > 0){/* empty */}
				else if((R_n||"").indexOf("End") > 0){/* empty */}
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	parse_wb_defaults(wb);

	// $FlowIgnore
	wb.Names = Names;

	(wb).supbooks = supbooks;
	return wb;
}

function write_BUNDLESHS(ba, wb) {
	write_record(ba, "BrtBeginBundleShs");
	for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
		var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
		var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
		write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
	}
	write_record(ba, "BrtEndBundleShs");
}

/* [MS-XLSB] 2.4.649 BrtFileVersion */
function write_BrtFileVersion(data, o) {
	if(!o) o = new_buf(127);
	for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
	write_XLWideString("SheetJS", o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString("7262", o);
	o.length = o.l;
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.301 BrtBookView */
function write_BrtBookView(idx, o) {
	if(!o) o = new_buf(29);
	o.write_shift(-4, 0);
	o.write_shift(-4, 460);
	o.write_shift(4,  28800);
	o.write_shift(4,  17600);
	o.write_shift(4,  500);
	o.write_shift(4,  idx);
	o.write_shift(4,  idx);
	var flags = 0x78;
	o.write_shift(1,  flags);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

function write_BOOKVIEWS(ba, wb) {
	/* required if hidden tab appears before visible tab */
	if(!wb.Workbook || !wb.Workbook.Sheets) return;
	var sheets = wb.Workbook.Sheets;
	var i = 0, vistab = -1, hidden = -1;
	for(; i < sheets.length; ++i) {
		if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
		else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
	}
	if(hidden > vistab) return;
	write_record(ba, "BrtBeginBookViews");
	write_record(ba, "BrtBookView", write_BrtBookView(vistab));
	/* 1*(BrtBookView *FRT) */
	write_record(ba, "BrtEndBookViews");
}

/* [MS-XLSB] 2.4.305 BrtCalcProp */
/*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/

/* [MS-XLSB] 2.4.646 BrtFileRecover */
/*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/

/* [MS-XLSB] 2.1.7.61 Workbook */
function write_wb_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginBook");
	write_record(ba, "BrtFileVersion", write_BrtFileVersion());
	/* [[BrtFileSharingIso] BrtFileSharing] */
	write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
	/* [ACABSPATH] */
	/* [[BrtBookProtectionIso] BrtBookProtection] */
	write_BOOKVIEWS(ba, wb, opts);
	write_BUNDLESHS(ba, wb, opts);
	/* [FNGROUP] */
	/* [EXTERNALS] */
	/* *BrtName */
	/* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */
	/* [BrtOleSize] */
	/* *(BrtUserBookView *FRT) */
	/* [PIVOTCACHEIDS] */
	/* [BrtWbFactoid] */
	/* [SMARTTAGTYPES] */
	/* [BrtWebOpt] */
	/* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */
	/* [WEBPUBITEMS] */
	/* [CRERRS] */
	/* FRTWORKBOOK */
	write_record(ba, "BrtEndBook");

	return ba.end();
}
function parse_wb(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
	return parse_wb_xml((data), opts);
}

function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
	if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
	return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
}

function parse_sty(data, name, themes, opts) {
	if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
	return parse_sty_xml((data), themes, opts);
}

function parse_theme(data, name, opts) {
	return parse_theme_xml(data, opts);
}

function parse_sst(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
	return parse_sst_xml((data), opts);
}

function parse_cmnt(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
	return parse_comments_xml((data), opts);
}

function parse_cc(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
	return parse_cc_xml((data), name, opts);
}

function parse_xlink(data, name, opts) {
	if(name.slice(-4)===".bin") return parse_xlink_bin((data), name, opts);
	return parse_xlink_xml((data), name, opts);
}

function write_wb(wb, name, opts) {
	return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
}

function write_ws(data, name, opts, wb, rels) {
	return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
}

// eslint-disable-next-line no-unused-vars
function write_cs(data, name, opts, wb, rels) {
	return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
}

function write_sty(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
}

function write_sst(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
}

function write_cmnt(data, name, opts) {
	return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/
var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
var _chr = function(c) { return String.fromCharCode(c); };
function xlml_parsexmltag(tag, skip_root) {
	var words = tag.split(/\s+/);
	var z = ([]); if(!skip_root) z[0] = words[0];
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}
function xlml_parsexmltagobj(tag) {
	var words = tag.split(/\s+/);
	var z = {};
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}

// ----

function xlml_format(format, value) {
	var fmt = XLMLFormatMap[format] || unescapexml(format);
	if(fmt === "General") return SSF._general(value);
	return SSF.format(fmt, value);
}

function xlml_set_custprop(Custprops, key, cp, val) {
	var oval = val;
	switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
		case "boolean": oval = parsexmlbool(val); break;
		case "i2": case "int": oval = parseInt(val, 10); break;
		case "r4": case "float": oval = parseFloat(val); break;
		case "date": case "dateTime.tz": oval = parseDate(val); break;
		case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
		default: throw new Error("bad custprop:" + cp[0]);
	}
	Custprops[unescapexml(key)] = oval;
}

function safe_format_xlml(cell, nf, o) {
	if(cell.t === 'z') return;
	if(!o || o.cellText !== false) try {
		if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
		else if(nf === "General") {
			if(cell.t === 'n') {
				if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
				else cell.w = SSF._general_num(cell.v);
			}
			else cell.w = SSF._general(cell.v);
		}
		else cell.w = xlml_format(nf||"General", cell.v);
	} catch(e) { if(o.WTF) throw e; }
	try {
		var z = XLMLFormatMap[nf]||nf||"General";
		if(o.cellNF) cell.z = z;
		if(o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
			var _d = SSF.parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	} catch(e) { if(o.WTF) throw e; }
}

function process_style_xlml(styles, stag, opts) {
	if(opts.cellStyles) {
		if(stag.Interior) {
			var I = stag.Interior;
			if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
		}
	}
	styles[stag.ID] = stag;
}

/* TODO: there must exist some form of OSP-blessed spec */
function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
	var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
	var interiors = [];
	var i = 0;
	if(sid === undefined && row) sid = row.StyleID;
	if(sid === undefined && csty) sid = csty.StyleID;
	while(styles[sid] !== undefined) {
		if(styles[sid].nf) nf = styles[sid].nf;
		if(styles[sid].Interior) interiors.push(styles[sid].Interior);
		if(!styles[sid].Parent) break;
		sid = styles[sid].Parent;
	}
	switch(data.Type) {
		case 'Boolean':
			cell.t = 'b';
			cell.v = parsexmlbool(xml);
			break;
		case 'String':
			cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
			cell.v = xml.indexOf("<") > -1 ? unescapexml(ss) : cell.r;
			break;
		case 'DateTime':
			if(xml.slice(-1) != "Z") xml += "Z";
			cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
			if(cell.v !== cell.v) cell.v = unescapexml(xml);
			else if(cell.v<60) cell.v = cell.v -1;
			if(!nf || nf == "General") nf = "yyyy-mm-dd";
			/* falls through */
		case 'Number':
			if(cell.v === undefined) cell.v=+xml;
			if(!cell.t) cell.t = 'n';
			break;
		case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
		default: cell.t = 's'; cell.v = xlml_fixstr(ss||xml); break;
	}
	safe_format_xlml(cell, nf, o);
	if(o.cellFormula !== false) {
		if(cell.Formula) {
			var fstr = unescapexml(cell.Formula);
			/* strictly speaking, the leading = is required but some writers omit */
			if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
			cell.f = rc_to_a1(fstr, base);
			delete cell.Formula;
			if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
			else if(cell.ArrayRange) {
				cell.F = rc_to_a1(cell.ArrayRange, base);
				arrayf.push([safe_decode_range(cell.F), cell.F]);
			}
		} else {
			for(i = 0; i < arrayf.length; ++i)
				if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
					if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
						cell.F = arrayf[i][1];
		}
	}
	if(o.cellStyles) {
		interiors.forEach(function(x) {
			if(!S.patternType && x.patternType) S.patternType = x.patternType;
		});
		cell.s = S;
	}
	if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}

function xlml_clean_comment(comment) {
	comment.t = comment.v || "";
	comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
	comment.v = comment.w = comment.ixfe = undefined;
}

function xlml_normalize(d) {
	if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
	if(typeof d === 'string') return d;
	/* duktape */
	if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
	throw new Error("Bad input format: expected Buffer or string");
}

/* TODO: Everything */
/* UOS uses CJK in tags */
var xlmlregex = /<(\/?)([^\s?>!\/:]*:|)([^\s?>:\/]+)[^>]*>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
function parse_xlml_xml(d, _opts) {
	var opts = _opts || {};
	make_ssf(SSF);
	var str = debom(xlml_normalize(d));
	if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
		if(typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
		else str = utf8read(str);
	}
	var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
	if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
	if(ishtml) return HTML_.to_workbook(str, opts);
	var Rn;
	var state = [], tmp;
	if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
	var table = {}, cell = ({}), row = {};// eslint-disable-line no-unused-vars
	var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
	var c = 0, r = 0;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	var styles = {}, stag = {};
	var ss = "", fidx = 0;
	var merges = [];
	var Props = {}, Custprops = {}, pidx = 0, cp = [];
	var comments = [], comment = ({});
	var cstys = [], csty, seencol = false;
	var arrayf = [];
	var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
	var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
	xlmlregex.lastIndex = 0;
	str = str.replace(/<!--([\s\S]*?)-->/mg,"");
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'Data':
			if(state[state.length-1][1]) break;
			if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]=="Comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
			else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
			break;
		case 'Cell':
			if(Rn[1]==='/'){
				if(comments.length > 0) cell.c = comments;
				if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
					if(opts.dense) {
						if(!cursheet[r]) cursheet[r] = [];
						cursheet[r][c] = cell;
					} else cursheet[encode_col(c) + encode_row(r)] = cell;
				}
				if(cell.HRef) {
					cell.l = ({Target:cell.HRef});
					if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
					delete cell.HRef; delete cell.HRefScreenTip;
				}
				if(cell.MergeAcross || cell.MergeDown) {
					cc = c + (parseInt(cell.MergeAcross,10)|0);
					rr = r + (parseInt(cell.MergeDown,10)|0);
					merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
				}
				if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
				else if(cell.MergeAcross || cell.MergeDown) {
for(var cma = c; cma <= cc; ++cma) {
						for(var cmd = r; cmd <= rr; ++cmd) {
							if(cma > c || cmd > r) {
								if(opts.dense) {
									if(!cursheet[cmd]) cursheet[cmd] = [];
									cursheet[cmd][cma] = {t:'z'};
								} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
							}
						}
					}
					c = cc + 1;
				}
				else ++c;
			} else {
				cell = xlml_parsexmltagobj(Rn[0]);
				if(cell.Index) c = +cell.Index - 1;
				if(c < refguess.s.c) refguess.s.c = c;
				if(c > refguess.e.c) refguess.e.c = c;
				if(Rn[0].slice(-2) === "/>") ++c;
				comments = [];
			}
			break;
		case 'Row':
			if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
				if(r < refguess.s.r) refguess.s.r = r;
				if(r > refguess.e.r) refguess.e.r = r;
				if(Rn[0].slice(-2) === "/>") {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
				}
				c = 0; ++r;
			} else {
				row = xlml_parsexmltag(Rn[0]);
				if(row.Index) r = +row.Index - 1;
				rowobj = {};
				if(row.AutoFitHeight == "0" || row.Height) {
					rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
					rowinfo[r] = rowobj;
				}
				if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
			}
			break;
		case 'Worksheet': /* TODO: read range from FullRows/FullColumns */
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				sheetnames.push(sheetname);
				if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
					cursheet["!ref"] = encode_range(refguess);
					if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
						cursheet["!fullref"] = cursheet["!ref"];
						refguess.e.r = opts.sheetRows - 1;
						cursheet["!ref"] = encode_range(refguess);
					}
				}
				if(merges.length) cursheet["!merges"] = merges;
				if(cstys.length > 0) cursheet["!cols"] = cstys;
				if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
				sheets[sheetname] = cursheet;
			} else {
				refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
				r = c = 0;
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				sheetname = unescapexml(tmp.Name);
				cursheet = (opts.dense ? [] : {});
				merges = [];
				arrayf = [];
				rowinfo = [];
				wsprops = {name:sheetname, Hidden:0};
				Workbook.Sheets.push(wsprops);
			}
			break;
		case 'Table':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].slice(-2) == "/>") break;
			else {
				table = xlml_parsexmltag(Rn[0]);
				state.push([Rn[3], false]);
				cstys = []; seencol = false;
			}
			break;

		case 'Style':
			if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
			else stag = xlml_parsexmltag(Rn[0]);
			break;

		case 'NumberFormat':
			stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
			if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
			for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == stag.nf) break;
			if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == null) { SSF.load(stag.nf, ssfidx); break; }
			break;

		case 'Column':
			if(state[state.length-1][0] !== 'Table') break;
			csty = xlml_parsexmltag(Rn[0]);
			if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
			if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
			if(!seencol && csty.wpx > 10) {
				seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
				for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
			}
			if(seencol) process_col(csty);
			cstys[(csty.Index-1||cstys.length)] = csty;
			for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
			break;

		case 'NamedRange':
			if(!Workbook.Names) Workbook.Names = [];
			var _NamedRange = parsexmltag(Rn[0]);
			var _DefinedName = ({
				Name: _NamedRange.Name,
				Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
			});
			if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
Workbook.Names.push(_DefinedName);
			break;

		case 'NamedCell': break;
		case 'B': break;
		case 'I': break;
		case 'U': break;
		case 'S': break;
		case 'Sub': break;
		case 'Sup': break;
		case 'Span': break;
		case 'Border': break;
		case 'Alignment': break;
		case 'Borders': break;
		case 'Font':
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
			else fidx = Rn.index + Rn[0].length;
			break;
		case 'Interior':
			if(!opts.cellStyles) break;
			stag.Interior = xlml_parsexmltag(Rn[0]);
			break;
		case 'Protection': break;

		case 'Author':
		case 'Title':
		case 'Description':
		case 'Created':
		case 'Keywords':
		case 'Subject':
		case 'Category':
		case 'Company':
		case 'LastAuthor':
		case 'LastSaved':
		case 'LastPrinted':
		case 'Version':
		case 'Revision':
		case 'TotalTime':
		case 'HyperlinkBase':
		case 'Manager':
		case 'ContentStatus':
		case 'Identifier':
		case 'Language':
		case 'AppName':
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") xlml_set_prop(Props, Rn[3], str.slice(pidx, Rn.index));
			else pidx = Rn.index + Rn[0].length;
			break;
		case 'Paragraphs': break;

		case 'Styles':
		case 'Workbook':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else state.push([Rn[3], false]);
			break;

		case 'Comment':
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				xlml_clean_comment(comment);
				comments.push(comment);
			} else {
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				comment = ({a:tmp.Author});
			}
			break;

		case 'AutoFilter':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				var AutoFilter = xlml_parsexmltag(Rn[0]);
				cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
				state.push([Rn[3], true]);
			}
			break;

		case 'Name': break;

		case 'ComponentOptions':
		case 'DocumentProperties':
		case 'CustomDocumentProperties':
		case 'OfficeDocumentSettings':
		case 'PivotTable':
		case 'PivotCache':
		case 'Names':
		case 'MapInfo':
		case 'PageBreaks':
		case 'QueryTable':
		case 'DataValidation':
		case 'Sorting':
		case 'Schema':
		case 'data':
		case 'ConditionalFormatting':
		case 'SmartTagType':
		case 'SmartTags':
		case 'ExcelWorkbook':
		case 'WorkbookOptions':
		case 'WorksheetOptions':
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			break;

		default:
			/* FODS file root is <office:document> */
			if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
			/* UOS file root is <uof:UOF> */
			if(state.length == 0 && Rn[3] == "UOF") return parse_fods(str, opts);

			var seen = true;
			switch(state[state.length-1][0]) {
				/* OfficeDocumentSettings */
				case 'OfficeDocumentSettings': switch(Rn[3]) {
					case 'AllowPNG': break;
					case 'RemovePersonalInformation': break;
					case 'DownloadComponents': break;
					case 'LocationOfComponents': break;
					case 'Colors': break;
					case 'Color': break;
					case 'Index': break;
					case 'RGB': break;
					case 'PixelsPerInch': break; // TODO: set PPI
					case 'TargetScreenSize': break;
					case 'ReadOnlyRecommended': break;
					default: seen = false;
				} break;

				/* ComponentOptions */
				case 'ComponentOptions': switch(Rn[3]) {
					case 'Toolbar': break;
					case 'HideOfficeLogo': break;
					case 'SpreadsheetAutoFit': break;
					case 'Label': break;
					case 'Caption': break;
					case 'MaxHeight': break;
					case 'MaxWidth': break;
					case 'NextSheetNumber': break;
					default: seen = false;
				} break;

				/* ExcelWorkbook */
				case 'ExcelWorkbook': switch(Rn[3]) {
					case 'Date1904':
Workbook.WBProps.date1904 = true;
						break;
					case 'WindowHeight': break;
					case 'WindowWidth': break;
					case 'WindowTopX': break;
					case 'WindowTopY': break;
					case 'TabRatio': break;
					case 'ProtectStructure': break;
					case 'ProtectWindows': break;
					case 'ActiveSheet': break;
					case 'DisplayInkNotes': break;
					case 'FirstVisibleSheet': break;
					case 'SupBook': break;
					case 'SheetName': break;
					case 'SheetIndex': break;
					case 'SheetIndexFirst': break;
					case 'SheetIndexLast': break;
					case 'Dll': break;
					case 'AcceptLabelsInFormulas': break;
					case 'DoNotSaveLinkValues': break;
					case 'Iteration': break;
					case 'MaxIterations': break;
					case 'MaxChange': break;
					case 'Path': break;
					case 'Xct': break;
					case 'Count': break;
					case 'SelectedSheets': break;
					case 'Calculation': break;
					case 'Uncalced': break;
					case 'StartupPrompt': break;
					case 'Crn': break;
					case 'ExternName': break;
					case 'Formula': break;
					case 'ColFirst': break;
					case 'ColLast': break;
					case 'WantAdvise': break;
					case 'Boolean': break;
					case 'Error': break;
					case 'Text': break;
					case 'OLE': break;
					case 'NoAutoRecover': break;
					case 'PublishObjects': break;
					case 'DoNotCalculateBeforeSave': break;
					case 'Number': break;
					case 'RefModeR1C1': break;
					case 'EmbedSaveSmartTags': break;
					default: seen = false;
				} break;

				/* WorkbookOptions */
				case 'WorkbookOptions': switch(Rn[3]) {
					case 'OWCVersion': break;
					case 'Height': break;
					case 'Width': break;
					default: seen = false;
				} break;

				/* WorksheetOptions */
				case 'WorksheetOptions': switch(Rn[3]) {
					case 'Visible':
						if(Rn[0].slice(-2) === "/>"){/* empty */}
						else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
							case "SheetHidden": wsprops.Hidden = 1; break;
							case "SheetVeryHidden": wsprops.Hidden = 2; break;
						}
						else pidx = Rn.index + Rn[0].length;
						break;
					case 'Header':
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						cursheet['!margins'].header = parsexmltag(Rn[0]).Margin;
						break;
					case 'Footer':
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						cursheet['!margins'].footer = parsexmltag(Rn[0]).Margin;
						break;
					case 'PageMargins':
						var pagemargins = parsexmltag(Rn[0]);
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
						if(pagemargins.Top) cursheet['!margins'].top = pagemargins.Top;
						if(pagemargins.Left) cursheet['!margins'].left = pagemargins.Left;
						if(pagemargins.Right) cursheet['!margins'].right = pagemargins.Right;
						if(pagemargins.Bottom) cursheet['!margins'].bottom = pagemargins.Bottom;
						break;
					case 'DisplayRightToLeft':
						if(!Workbook.Views) Workbook.Views = [];
						if(!Workbook.Views[0]) Workbook.Views[0] = {};
						Workbook.Views[0].RTL = true;
						break;

					case 'Unsynced': break;
					case 'Print': break;
					case 'Panes': break;
					case 'Scale': break;
					case 'Pane': break;
					case 'Number': break;
					case 'Layout': break;
					case 'PageSetup': break;
					case 'Selected': break;
					case 'ProtectObjects': break;
					case 'EnableSelection': break;
					case 'ProtectScenarios': break;
					case 'ValidPrinterInfo': break;
					case 'HorizontalResolution': break;
					case 'VerticalResolution': break;
					case 'NumberofCopies': break;
					case 'ActiveRow': break;
					case 'ActiveCol': break;
					case 'ActivePane': break;
					case 'TopRowVisible': break;
					case 'TopRowBottomPane': break;
					case 'LeftColumnVisible': break;
					case 'LeftColumnRightPane': break;
					case 'FitToPage': break;
					case 'RangeSelection': break;
					case 'PaperSizeIndex': break;
					case 'PageLayoutZoom': break;
					case 'PageBreakZoom': break;
					case 'FilterOn': break;
					case 'DoNotDisplayGridlines': break;
					case 'SplitHorizontal': break;
					case 'SplitVertical': break;
					case 'FreezePanes': break;
					case 'FrozenNoSplit': break;
					case 'FitWidth': break;
					case 'FitHeight': break;
					case 'CommentsLayout': break;
					case 'Zoom': break;
					case 'LeftToRight': break;
					case 'Gridlines': break;
					case 'AllowSort': break;
					case 'AllowFilter': break;
					case 'AllowInsertRows': break;
					case 'AllowDeleteRows': break;
					case 'AllowInsertCols': break;
					case 'AllowDeleteCols': break;
					case 'AllowInsertHyperlinks': break;
					case 'AllowFormatCells': break;
					case 'AllowSizeCols': break;
					case 'AllowSizeRows': break;
					case 'NoSummaryRowsBelowDetail': break;
					case 'TabColorIndex': break;
					case 'DoNotDisplayHeadings': break;
					case 'ShowPageLayoutZoom': break;
					case 'NoSummaryColumnsRightDetail': break;
					case 'BlackAndWhite': break;
					case 'DoNotDisplayZeros': break;
					case 'DisplayPageBreak': break;
					case 'RowColHeadings': break;
					case 'DoNotDisplayOutline': break;
					case 'NoOrientation': break;
					case 'AllowUsePivotTables': break;
					case 'ZeroHeight': break;
					case 'ViewableRange': break;
					case 'Selection': break;
					case 'ProtectContents': break;
					default: seen = false;
				} break;

				/* PivotTable */
				case 'PivotTable': case 'PivotCache': switch(Rn[3]) {
					case 'ImmediateItemsOnDrop': break;
					case 'ShowPageMultipleItemLabel': break;
					case 'CompactRowIndent': break;
					case 'Location': break;
					case 'PivotField': break;
					case 'Orientation': break;
					case 'LayoutForm': break;
					case 'LayoutSubtotalLocation': break;
					case 'LayoutCompactRow': break;
					case 'Position': break;
					case 'PivotItem': break;
					case 'DataType': break;
					case 'DataField': break;
					case 'SourceName': break;
					case 'ParentField': break;
					case 'PTLineItems': break;
					case 'PTLineItem': break;
					case 'CountOfSameItems': break;
					case 'Item': break;
					case 'ItemType': break;
					case 'PTSource': break;
					case 'CacheIndex': break;
					case 'ConsolidationReference': break;
					case 'FileName': break;
					case 'Reference': break;
					case 'NoColumnGrand': break;
					case 'NoRowGrand': break;
					case 'BlankLineAfterItems': break;
					case 'Hidden': break;
					case 'Subtotal': break;
					case 'BaseField': break;
					case 'MapChildItems': break;
					case 'Function': break;
					case 'RefreshOnFileOpen': break;
					case 'PrintSetTitles': break;
					case 'MergeLabels': break;
					case 'DefaultVersion': break;
					case 'RefreshName': break;
					case 'RefreshDate': break;
					case 'RefreshDateCopy': break;
					case 'VersionLastRefresh': break;
					case 'VersionLastUpdate': break;
					case 'VersionUpdateableMin': break;
					case 'VersionRefreshableMin': break;
					case 'Calculation': break;
					default: seen = false;
				} break;

				/* PageBreaks */
				case 'PageBreaks': switch(Rn[3]) {
					case 'ColBreaks': break;
					case 'ColBreak': break;
					case 'RowBreaks': break;
					case 'RowBreak': break;
					case 'ColStart': break;
					case 'ColEnd': break;
					case 'RowEnd': break;
					default: seen = false;
				} break;

				/* AutoFilter */
				case 'AutoFilter': switch(Rn[3]) {
					case 'AutoFilterColumn': break;
					case 'AutoFilterCondition': break;
					case 'AutoFilterAnd': break;
					case 'AutoFilterOr': break;
					default: seen = false;
				} break;

				/* QueryTable */
				case 'QueryTable': switch(Rn[3]) {
					case 'Id': break;
					case 'AutoFormatFont': break;
					case 'AutoFormatPattern': break;
					case 'QuerySource': break;
					case 'QueryType': break;
					case 'EnableRedirections': break;
					case 'RefreshedInXl9': break;
					case 'URLString': break;
					case 'HTMLTables': break;
					case 'Connection': break;
					case 'CommandText': break;
					case 'RefreshInfo': break;
					case 'NoTitles': break;
					case 'NextId': break;
					case 'ColumnInfo': break;
					case 'OverwriteCells': break;
					case 'DoNotPromptForFile': break;
					case 'TextWizardSettings': break;
					case 'Source': break;
					case 'Number': break;
					case 'Decimal': break;
					case 'ThousandSeparator': break;
					case 'TrailingMinusNumbers': break;
					case 'FormatSettings': break;
					case 'FieldType': break;
					case 'Delimiters': break;
					case 'Tab': break;
					case 'Comma': break;
					case 'AutoFormatName': break;
					case 'VersionLastEdit': break;
					case 'VersionLastRefresh': break;
					default: seen = false;
				} break;

				case 'Sorting':
				case 'ConditionalFormatting':
				case 'DataValidation':
				switch(Rn[3]) {
					case 'Range': break;
					case 'Type': break;
					case 'Min': break;
					case 'Max': break;
					case 'Sort': break;
					case 'Descending': break;
					case 'Order': break;
					case 'CaseSensitive': break;
					case 'Value': break;
					case 'ErrorStyle': break;
					case 'ErrorMessage': break;
					case 'ErrorTitle': break;
					case 'CellRangeList': break;
					case 'InputMessage': break;
					case 'InputTitle': break;
					case 'ComboHide': break;
					case 'InputHide': break;
					case 'Condition': break;
					case 'Qualifier': break;
					case 'UseBlank': break;
					case 'Value1': break;
					case 'Value2': break;
					case 'Format': break;
					default: seen = false;
				} break;

				/* MapInfo (schema) */
				case 'MapInfo': case 'Schema': case 'data': switch(Rn[3]) {
					case 'Map': break;
					case 'Entry': break;
					case 'Range': break;
					case 'XPath': break;
					case 'Field': break;
					case 'XSDType': break;
					case 'FilterOn': break;
					case 'Aggregate': break;
					case 'ElementType': break;
					case 'AttributeType': break;
				/* These are from xsd (XML Schema Definition) */
					case 'schema':
					case 'element':
					case 'complexType':
					case 'datatype':
					case 'all':
					case 'attribute':
					case 'extends': break;

					case 'row': break;
					default: seen = false;
				} break;

				/* SmartTags (can be anything) */
				case 'SmartTags': break;

				default: seen = false; break;
			}
			if(seen) break;
			/* CustomDocumentProperties */
			if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
			if(state[state.length-1][0]==='CustomDocumentProperties') {
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_custprop(Custprops, Rn[3], cp, str.slice(pidx, Rn.index));
				else { cp = Rn; pidx = Rn.index + Rn[0].length; }
				break;
			}
			if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
	}
	var out = ({});
	if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
	out.SheetNames = sheetnames;
	out.Workbook = Workbook;
	out.SSF = SSF.get_table();
	out.Props = Props;
	out.Custprops = Custprops;
	return out;
}

function parse_xlml(data, opts) {
	fix_read_opts(opts=opts||{});
	switch(opts.type||"base64") {
		case "base64": return parse_xlml_xml(Base64.decode(data), opts);
		case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
		case "array": return parse_xlml_xml(a2s(data), opts);
	}
}

/* TODO */
function write_props_xlml(wb, opts) {
	var o = [];
	/* DocumentProperties */
	if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
	/* CustomDocumentProperties */
	if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
	return o.join("");
}
/* TODO */
function write_wb_xlml() {
	/* OfficeDocumentSettings */
	/* ExcelWorkbook */
	return "";
}
/* TODO */
function write_sty_xlml(wb, opts) {
	/* Styles */
	var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
	opts.cellXfs.forEach(function(xf, id) {
		var payload = [];
		payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(SSF._table[xf.numFmtId])}));
		styles.push(writextag('Style', payload.join(""), {"ss:ID": "s" + (21+id)}));
	});
	return writextag("Styles", styles.join(""));
}
function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
function write_names_xlml(wb) {
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != null) continue;
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return writextag("Names", out.join(""));
}
function write_ws_xlml_names(ws, opts, idx, wb) {
	if(!ws) return "";
	if(!((wb||{}).Workbook||{}).Names) return "";
var names = wb.Workbook.Names;
	var out = [];
	outer: for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != idx) continue;
		/*switch(n.Name) {
			case "_": continue;
		}*/
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return out.join("");
}
/* WorksheetOptions */
function write_ws_xlml_wsopts(ws, opts, idx, wb) {
	if(!ws) return "";
	var o = [];
	/* NOTE: spec technically allows any order, but stick with implied order */

	/* FitToPage */
	/* DoNotDisplayColHeaders */
	/* DoNotDisplayRowHeaders */
	/* ViewableRange */
	/* Selection */
	/* GridlineColor */
	/* Name */
	/* ExcelWorksheetType */
	/* IntlMacro */
	/* Unsynced */
	/* Selected */
	/* CodeName */

	if(ws['!margins']) {
		o.push("<PageSetup>");
		if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
		if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
		o.push(writextag("PageMargins", null, {
			'x:Bottom': ws['!margins'].bottom || "0.75",
			'x:Left': ws['!margins'].left || "0.7",
			'x:Right': ws['!margins'].right || "0.7",
			'x:Top': ws['!margins'].top || "0.75"
		}));
		o.push("</PageSetup>");
	}

	/* PageSetup */
	/* DisplayPageBreak */
	/* TransitionExpressionEvaluation */
	/* TransitionFormulaEntry */
	/* Print */
	/* Zoom */
	/* PageLayoutZoom */
	/* PageBreakZoom */
	/* ShowPageBreakZoom */
	/* DefaultRowHeight */
	/* DefaultColumnWidth */
	/* StandardWidth */

	if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
		/* Visible */
		if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
		else {
			/* Selected */
			for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
			if(i == idx) o.push("<Selected/>");
		}
	}

	/* LeftColumnVisible */

	if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");

	/* GridlineColorIndex */
	/* DisplayFormulas */
	/* DoNotDisplayGridlines */
	/* DoNotDisplayHeadings */
	/* DoNotDisplayOutline */
	/* ApplyAutomaticOutlineStyles */
	/* NoSummaryRowsBelowDetail */
	/* NoSummaryColumnsRightDetail */
	/* DoNotDisplayZeros */
	/* ActiveRow */
	/* ActiveColumn */
	/* FilterOn */
	/* RangeSelection */
	/* TopRowVisible */
	/* TopRowBottomPane */
	/* LeftColumnRightPane */
	/* ActivePane */
	/* SplitHorizontal */
	/* SplitVertical */
	/* FreezePanes */
	/* FrozenNoSplit */
	/* TabColorIndex */
	/* Panes */

	/* NOTE: Password not supported in XLML Format */
	if(ws['!protect']) {
		o.push(writetag("ProtectContents", "True"));
		if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
		if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
		if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
		else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
	[
		[ "formatCells", "AllowFormatCells" ],
		[ "formatColumns", "AllowSizeCols" ],
		[ "formatRows", "AllowSizeRows" ],
		[ "insertColumns", "AllowInsertCols" ],
		[ "insertRows", "AllowInsertRows" ],
		[ "insertHyperlinks", "AllowInsertHyperlinks" ],
		[ "deleteColumns", "AllowDeleteCols" ],
		[ "deleteRows", "AllowDeleteRows" ],
		[ "sort", "AllowSort" ],
		[ "autoFilter", "AllowFilter" ],
		[ "pivotTables", "AllowUsePivotTables" ]
	].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
	}

	if(o.length == 0) return "";
	return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
}
function write_ws_xlml_comment(comments) {
	return comments.map(function(c) {
		// TODO: formatted text
		var t = xlml_unfixstr(c.t||"");
		var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
		return writextag("Comment", d, {"ss:Author":c.a});
	}).join("");
}
function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
	if(!cell || (cell.v == undefined && cell.f == undefined)) return "";

	var attr = {};
	if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
	if(cell.F && cell.F.slice(0, ref.length) == ref) {
		var end = decode_cell(cell.F.slice(ref.length + 1));
		attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
	}

	if(cell.l && cell.l.Target) {
		attr["ss:HRef"] = escapexml(cell.l.Target);
		if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
	}

	if(ws['!merges']) {
		var marr = ws['!merges'];
		for(var mi = 0; mi != marr.length; ++mi) {
			if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
			if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
			if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
		}
	}

	var t = "", p = "";
	switch(cell.t) {
		case 'z': return "";
		case 'n': t = 'Number'; p = String(cell.v); break;
		case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
		case 'e': t = 'Error'; p = BErr[cell.v]; break;
		case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || SSF._table[14]; break;
		case 's': t = 'String'; p = escapexlml(cell.v||""); break;
	}
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	attr["ss:StyleID"] = "s" + (21+os);
	attr["ss:Index"] = addr.c + 1;
	var _v = (cell.v != null ? p : "");
	var m = '<Data ss:Type="' + t + '">' + _v + '</Data>';

	if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);

	return writextag("Cell", m, attr);
}
function write_ws_xlml_row(R, row) {
	var o = '<Row ss:Index="' + (R+1) + '"';
	if(row) {
		if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
		if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
		if(row.hidden) o += ' ss:Hidden="1"';
	}
	return o + '>';
}
/* TODO */
function write_ws_xlml_table(ws, opts, idx, wb) {
	if(!ws['!ref']) return "";
	var range = safe_decode_range(ws['!ref']);
	var marr = ws['!merges'] || [], mi = 0;
	var o = [];
	if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
		process_col(n);
		var w = !!n.width;
		var p = col_obj_w(i, n);
		var k = {"ss:Index":i+1};
		if(w) k['ss:Width'] = width2px(p.width);
		if(n.hidden) k['ss:Hidden']="1";
		o.push(writextag("Column",null,k));
	});
	var dense = Array.isArray(ws);
	for(var R = range.s.r; R <= range.e.r; ++R) {
		var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
		for(var C = range.s.c; C <= range.e.c; ++C) {
			var skip = false;
			for(mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c > C) continue;
				if(marr[mi].s.r > R) continue;
				if(marr[mi].e.c < C) continue;
				if(marr[mi].e.r < R) continue;
				if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
				break;
			}
			if(skip) continue;
			var addr = {r:R,c:C};
			var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
			row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
		}
		row.push("</Row>");
		if(row.length > 2) o.push(row.join(""));
	}
	return o.join("");
}
function write_ws_xlml(idx, opts, wb) {
	var o = [];
	var s = wb.SheetNames[idx];
	var ws = wb.Sheets[s];

	var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Names>" + t + "</Names>");

	/* Table */
	t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Table>" + t + "</Table>");

	/* WorksheetOptions */
	o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));

	return o.join("");
}
function write_xlml(wb, opts) {
	if(!opts) opts = {};
	if(!wb.SSF) wb.SSF = SSF.get_table();
	if(wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	}
	var d = [];
	d.push(write_props_xlml(wb, opts));
	d.push(write_wb_xlml(wb, opts));
	d.push("");
	d.push("");
	for(var i = 0; i < wb.SheetNames.length; ++i)
		d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
	d[2] = write_sty_xlml(wb, opts);
	d[3] = write_names_xlml(wb, opts);
	return XML_HEADER + writextag("Workbook", d.join(""), {
		'xmlns':      XLMLNS.ss,
		'xmlns:o':    XLMLNS.o,
		'xmlns:x':    XLMLNS.x,
		'xmlns:ss':   XLMLNS.ss,
		'xmlns:dt':   XLMLNS.dt,
		'xmlns:html': XLMLNS.html
	});
}
/* [MS-OLEDS] 2.3.8 CompObjStream */
function parse_compobj(obj) {
	var v = {};
	var o = obj.content;
/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
	o.l = 28;

	v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
	v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);

	if(o.length - o.l <= 4) return v;

	var m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");

	if(o.length - o.l <= 4) return v;
	m = o.read_shift(4);
	if(m !== 0x71b239f4) return v;
	v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);

	m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
}

/*
	Continue logic for:
	- 2.4.58 Continue
	- 2.4.59 ContinueBigName
	- 2.4.60 ContinueFrt
	- 2.4.61 ContinueFrt11
	- 2.4.62 ContinueFrt12
*/
function slurp(R, blob, length, opts) {
	var l = length;
	var bufs = [];
	var d = blob.slice(blob.l,blob.l+l);
	if(opts && opts.enc && opts.enc.insitu) switch(R.n) {
	case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': break;
	default:
		if(d.length === 0) break;
		opts.enc.insitu(d);
	}
	bufs.push(d);
	blob.l += l;
	var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
	var start = 0;
	while(next != null && next.n.slice(0,8) === 'Continue') {
		l = __readUInt16LE(blob,blob.l+2);
		start = blob.l + 4;
		if(next.n == 'ContinueFrt') start += 4;
		else if(next.n.slice(0,11) == 'ContinueFrt') start += 12;
		bufs.push(blob.slice(start,blob.l+4+l));
		blob.l += 4+l;
		next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
	}
	var b = (bconcat(bufs));
	prep_blob(b, 0);
	var ll = 0; b.lens = [];
	for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
	return R.f(b, b.length, opts);
}

function safe_format_xf(p, opts, date1904) {
	if(p.t === 'z') return;
	if(!p.XF) return;
	var fmtid = 0;
	try {
		fmtid = p.z || p.XF.numFmtId || 0;
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
		else if(fmtid === 0 || fmtid == "General") {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else p.w = SSF._general(p.v);
		}
		else p.w = SSF.format(fmtid,p.v, {date1904:!!date1904});
	} catch(e) { if(opts.WTF) throw e; }
	if(opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
		var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
	}
}

function make_cell(val, ixfe, t) {
	return ({v:val, ixfe:ixfe, t:t});
}

// 2.3.2
function parse_workbook(blob, options) {
	var wb = ({opts:{}});
	var Sheets = {};
	if(DENSE != null && options.dense == null) options.dense = DENSE;
	var out = ((options.dense ? [] : {}));
	var Directory = {};
	var range = ({});
	var last_formula = null;
	var sst = ([]);
	var cur_sheet = "";
	var Preamble = {};
	var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
	var sharedf = {};
	var arrayf = [];
	var temp_val;
	var country;
	var cell_valid = true;
	var XFs = []; /* XF records */
	var palette = [];
	var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
	var get_rgb = function getrgb(icv) {
		if(icv < 8) return XLSIcv[icv];
		if(icv < 64) return palette[icv-8] || XLSIcv[icv];
		return XLSIcv[icv];
	};
	var process_cell_style = function pcs(cell, line, options) {
		var xfd = line.XF.data;
		if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
		line.s = ({});
		line.s.patternType = xfd.patternType;
		var t;
		if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
		if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
	};
	var addcell = function addcell(cell, line, options) {
		if(file_depth > 1) return;
		if(options.sheetRows && cell.r >= options.sheetRows) cell_valid = false;
		if(!cell_valid) return;
		if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
		delete line.ixfe; delete line.XF;
		lastcell = cell;
		last_cell = encode_cell(cell);
		if(range.s) {
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
		}
		if(range.e) {
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
		}
		if(options.cellFormula && line.f) {
			for(var afi = 0; afi < arrayf.length; ++afi) {
				if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
				if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
				line.F = encode_range(arrayf[afi][0]);
				if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
				if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
				break;
			}
		}
		{
			if(options.dense) {
				if(!out[cell.r]) out[cell.r] = [];
				out[cell.r][cell.c] = line;
			} else out[last_cell] = line;
		}
	};
	var opts = ({
		enc: false, // encrypted
		sbcch: 0, // cch in the preceding SupBook
		snames: [], // sheetnames
		sharedf: sharedf, // shared formulae by address
		arrayf: arrayf, // array formulae array
		rrtabid: [], // RRTabId
		lastuser: "", // Last User from WriteAccess
		biff: 8, // BIFF version
		codepage: 0, // CP from CodePage record
		winlocked: 0, // fLockWn from WinProtect
		cellStyles: !!options && !!options.cellStyles,
		WTF: !!options && !!options.wtf
	});
	if(options.password) opts.password = options.password;
	var themes;
	var merges = [];
	var objects = [];
	var colinfo = [], rowinfo = [];
	// eslint-disable-next-line no-unused-vars
	var defwidth = 0, defheight = 0; // twips / MDW respectively
	var seencol = false;
	var supbooks = ([]); // 1-indexed, will hold extern names
	supbooks.SheetNames = opts.snames;
	supbooks.sharedf = opts.sharedf;
	supbooks.arrayf = opts.arrayf;
	supbooks.names = [];
	supbooks.XTI = [];
	var last_Rn = '';
	var file_depth = 0; /* TODO: make a real stack */
	var BIFF2Fmt = 0, BIFF2FmtTable = [];
	var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
	var last_lbl;

	/* explicit override for some broken writers */
	opts.codepage = 1200;
	set_cp(1200);
	var seen_codepage = false;
	while(blob.l < blob.length - 1) {
		var s = blob.l;
		var RecordType = blob.read_shift(2);
		if(RecordType === 0 && last_Rn === 'EOF') break;
		var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
		var R = XLSRecordEnum[RecordType];
		//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
		//if(!R) console.log(blob.slice(blob.l, blob.l + length));
		if(R && R.f) {
			if(options.bookSheets) {
				if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
			}
			last_Rn = R.n;
			if(R.r === 2 || R.r == 12) {
				var rt = blob.read_shift(2); length -= 2;
				if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
				if(R.r == 12){ blob.l += 10; length -= 10; } // skip FRT
			}
			//console.error(R,blob.l,length,blob.length);
			var val;
			if(R.n === 'EOF') val = R.f(blob, length, opts);
			else val = slurp(R, blob, length, opts);
			var Rn = R.n;
			if(file_depth == 0 && Rn != 'BOF') continue;
			/* nested switch statements to workaround V8 128 limit */
			switch(Rn) {
				/* Workbook Options */
				case 'Date1904':
wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
				case 'WriteProtect': wb.opts.WriteProtect = true; break;
				case 'FilePass':
					if(!opts.enc) blob.l = 0;
					opts.enc = val;
					if(!options.password) throw new Error("File is password-protected");
					if(val.valid == null) throw new Error("Encryption scheme unsupported");
					if(!val.valid) throw new Error("Password is incorrect");
					break;
				case 'WriteAccess': opts.lastuser = val; break;
				case 'FileSharing': break; //TODO
				case 'CodePage':
					/* overrides based on test cases */
					switch(val) {
						case 0x5212: val =  1200; break;
						case 0x8000: val = 10000; break;
						case 0x8001: val =  1252; break;
					}
					set_cp(opts.codepage = val);
					seen_codepage = true;
					break;
				case 'RRTabId': opts.rrtabid = val; break;
				case 'WinProtect': opts.winlocked = val; break;
				case 'Template': break; // TODO
				case 'BookBool': break; // TODO
				case 'UsesELFs': break;
				case 'MTRSettings': break;
				case 'RefreshAll':
				case 'CalcCount':
				case 'CalcDelta':
				case 'CalcIter':
				case 'CalcMode':
				case 'CalcPrecision':
				case 'CalcSaveRecalc':
					wb.opts[Rn] = val; break;
				case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
				case 'Uncalced': break;
				case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
				case 'WsBool':
					if(val.fDialog) out["!type"] = "dialog";
					break; // TODO
				case 'XF': XFs.push(val); break;
				case 'ExtSST': break; // TODO
				case 'BookExt': break; // TODO
				case 'RichTextStream': break;
				case 'BkHim': break;

				case 'SupBook':
					supbooks.push([val]);
					supbooks[supbooks.length-1].XTI = [];
					break;
				case 'ExternName':
					supbooks[supbooks.length-1].push(val);
					break;
				case 'Index': break; // TODO
				case 'Lbl':
					last_lbl = ({
						Name: val.Name,
						Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
					});
					if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
					supbooks.names.push(last_lbl);
					if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length-1].push(val);
					if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
						if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
							FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
					break;
				case 'ExternCount': opts.ExternCount = val; break;
				case 'ExternSheet':
					if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
				case 'NameCmt':
					/* TODO: search for correct name */
					if(opts.biff < 8) break;
					if(last_lbl != null) last_lbl.Comment = val[1];
					break;

				case 'Protect': out["!protect"] = val; break; /* for sheet or book */
				case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
				case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/

				case 'BoundSheet8': {
					Directory[val.pos] = val;
					opts.snames.push(val.name);
				} break;
				case 'EOF': {
					if(--file_depth) break;
					if(range.e) {
						if(range.e.r > 0 && range.e.c > 0) {
							range.e.r--; range.e.c--;
							out["!ref"] = encode_range(range);
							if(options.sheetRows && options.sheetRows <= range.e.r) {
								var tmpri = range.e.r;
								range.e.r = options.sheetRows - 1;
								out["!fullref"] = out["!ref"];
								out["!ref"] = encode_range(range);
								range.e.r = tmpri;
							}
							range.e.r++; range.e.c++;
						}
						if(merges.length > 0) out["!merges"] = merges;
						if(objects.length > 0) out["!objects"] = objects;
						if(colinfo.length > 0) out["!cols"] = colinfo;
						if(rowinfo.length > 0) out["!rows"] = rowinfo;
						Workbook.Sheets.push(wsprops);
					}
					if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
					out = ((options.dense ? [] : {}));
				} break;
				case 'BOF': {
					if(opts.biff === 8) opts.biff = {
0x0009:2,
0x0209:3,
0x0409:4
					}[RecordType] || {
0x0200:2,
0x0300:3,
0x0400:4,
0x0500:5,
0x0600:8,
0x0002:2,
0x0007:2
					}[val.BIFFVer] || 8;
					if(file_depth++) break;
					cell_valid = true;
					out = ((options.dense ? [] : {}));

					if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
					if(opts.biff < 5) {
						if(cur_sheet === "") cur_sheet = "Sheet1";
						range = {s:{r:0,c:0},e:{r:0,c:0}};
						/* fake BoundSheet8 */
						var fakebs8 = {pos: blob.l - length, name:cur_sheet};
						Directory[fakebs8.pos] = fakebs8;
						opts.snames.push(cur_sheet);
					}
					else cur_sheet = (Directory[s] || {name:""}).name;
					if(val.dt == 0x20) out["!type"] = "chart";
					if(val.dt == 0x40) out["!type"] = "macro";
					merges = [];
					objects = [];
					opts.arrayf = arrayf = [];
					colinfo = []; rowinfo = [];
					defwidth = defheight = 0;
					seencol = false;
					wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
				} break;

				case 'Number': case 'BIFF2NUM': case 'BIFF2INT': {
					if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'BoolErr': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'RK': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulRk': {
					for(var j = val.c; j <= val.C; ++j) {
						var ixfe = val.rkrec[j-val.c][0];
						temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:j, r:val.r}, temp_val, options);
					}
				} break;
				case 'Formula': {
					if(val.val == 'String') { last_formula = val; break; }
					temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
					temp_val.XF = XFs[temp_val.ixfe];
					if(options.cellFormula) {
						var _f = val.formula;
						if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
							var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
							var _fe = encode_cell({r:_fr, c:_fc});
							if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
							else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
						} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
					}
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell(val.cell, temp_val, options);
					last_formula = val;
				} break;
				case 'String': {
					if(last_formula) { /* technically always true */
						last_formula.val = val;
						temp_val = make_cell(val, last_formula.cell.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(last_formula.cell, temp_val, options);
						last_formula = null;
					} else throw new Error("String record expects Formula");
				} break;
				case 'Array': {
					arrayf.push(val);
					var _arraystart = encode_cell(val[0].s);
					cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
					if(options.cellFormula && cc) {
						if(!last_formula) break; /* technically unreachable */
						if(!_arraystart || !cc) break;
						cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
						cc.F = encode_range(val[0]);
					}
				} break;
				case 'ShrFmla': {
					if(!cell_valid) break;
					if(!options.cellFormula) break;
					if(last_cell) {
						/* TODO: capture range */
						if(!last_formula) break; /* technically unreachable */
						sharedf[encode_cell(last_formula.cell)]= val[0];
						cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
						(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
					}
				} break;
				case 'LabelSst':
					temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;
				case 'Blank': if(options.sheetStubs) {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulBlank': if(options.sheetStubs) {
					for(var _j = val.c; _j <= val.C; ++_j) {
						var _ixfe = val.ixfe[_j-val.c];
						temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:_j, r:val.r}, temp_val, options);
					}
				} break;
				case 'RString':
				case 'Label': case 'BIFF2STR':
					temp_val=make_cell(val.val, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x1F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;

				case 'Dimensions': {
					if(file_depth === 1) range = val; /* TODO: stack */
				} break;
				case 'SST': {
					sst = val;
				} break;
				case 'Format': { /* val = [id, fmt] */
					if(opts.biff == 4) {
						BIFF2FmtTable[BIFF2Fmt++] = val[1];
						for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(SSF._table[b4idx] == val[1]) break;
						if(b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
					}
					else SSF.load(val[1], val[0]);
				} break;
				case 'BIFF2FORMAT': {
					BIFF2FmtTable[BIFF2Fmt++] = val;
					for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(SSF._table[b2idx] == val) break;
					if(b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
				} break;

				case 'MergeCells': merges = merges.concat(val); break;

				case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
				case 'TxO': opts.lastobj.TxO = val; break;
				case 'ImData': opts.lastobj.ImData = val; break;

				case 'HLink': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc) cc.l = val[1];
						}
				} break;
				case 'HLinkTooltip': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc && cc.l) cc.l.Tooltip = val[1];
							}
				} break;

				/* Comments */
				case 'Note': {
					if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
					cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
					var noteobj = objects[val[2]];
					if(!cc) break;
					if(!cc.c) cc.c = [];
					cmnt = {a:val[1],t:noteobj.TxO.t};
					cc.c.push(cmnt);
				} break;

				default: switch(R.n) { /* nested */
				case 'ClrtClient': break;
				case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;

				case 'DefColWidth': defwidth = val; break;
				case 'DefaultRowHeight': defheight = val[1]; break; // TODO: flags

				case 'ColInfo': {
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256 };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
				} break;
				case 'Row': {
					var rowobj = {};
					if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
					if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
					if(val.hpt) {
						rowinfo[val.r] = rowobj;
						rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
					}
				} break;

				case 'LeftMargin':
				case 'RightMargin':
				case 'TopMargin':
				case 'BottomMargin':
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'][Rn.slice(0,-6).toLowerCase()] = val;
					break;

				case 'Setup': // TODO
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'].header = val.header;
					out['!margins'].footer = val.footer;
					break;

				case 'Window2': // TODO
					// $FlowIgnore
					if(val.RTL) Workbook.Views[0].RTL = true;
					break;

				case 'Header': break; // TODO
				case 'Footer': break; // TODO
				case 'HCenter': break; // TODO
				case 'VCenter': break; // TODO
				case 'Pls': break; // TODO
				case 'GCW': break;
				case 'LHRecord': break;
				case 'DBCell': break; // TODO
				case 'EntExU2': break; // TODO
				case 'SxView': break; // TODO
				case 'Sxvd': break; // TODO
				case 'SXVI': break; // TODO
				case 'SXVDEx': break; // TODO
				case 'SxIvd': break; // TODO
				case 'SXString': break; // TODO
				case 'Sync': break;
				case 'Addin': break;
				case 'SXDI': break; // TODO
				case 'SXLI': break; // TODO
				case 'SXEx': break; // TODO
				case 'QsiSXTag': break; // TODO
				case 'Selection': break;
				case 'Feat': break;
				case 'FeatHdr': case 'FeatHdr11': break;
				case 'Feature11': case 'Feature12': case 'List12': break;
				case 'Country': country = val; break;
				case 'RecalcId': break;
				case 'DxGCol': break; // TODO: htmlify
				case 'Fbi': case 'Fbi2': case 'GelFrame': break;
				case 'Font': break; // TODO
				case 'XFCRC': break; // TODO
				case 'Style': break; // TODO
				case 'StyleExt': break; // TODO
				case 'Palette': palette = val; break;
				case 'Theme': themes = val; break;
				/* Protection */
				case 'ScenarioProtect': break;
				case 'ObjProtect': break;

				/* Conditional Formatting */
				case 'CondFmt12': break;

				/* Table */
				case 'Table': break; // TODO
				case 'TableStyles': break; // TODO
				case 'TableStyle': break; // TODO
				case 'TableStyleElement': break; // TODO

				/* PivotTable */
				case 'SXStreamID': break; // TODO
				case 'SXVS': break; // TODO
				case 'DConRef': break; // TODO
				case 'SXAddl': break; // TODO
				case 'DConBin': break; // TODO
				case 'DConName': break; // TODO
				case 'SXPI': break; // TODO
				case 'SxFormat': break; // TODO
				case 'SxSelect': break; // TODO
				case 'SxRule': break; // TODO
				case 'SxFilt': break; // TODO
				case 'SxItm': break; // TODO
				case 'SxDXF': break; // TODO

				/* Scenario Manager */
				case 'ScenMan': break;

				/* Data Consolidation */
				case 'DCon': break;

				/* Watched Cell */
				case 'CellWatch': break;

				/* Print Settings */
				case 'PrintRowCol': break;
				case 'PrintGrid': break;
				case 'PrintSize': break;

				case 'XCT': break;
				case 'CRN': break;

				case 'Scl': {
					//console.log("Zoom Level:", val[0]/val[1],val);
				} break;
				case 'SheetExt': {
					/* empty */
				} break;
				case 'SheetExtOptional': {
					/* empty */
				} break;

				/* VBA */
				case 'ObNoMacros': {
					/* empty */
				} break;
				case 'ObProj': {
					/* empty */
				} break;
				case 'CodeName': {
if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
					else wsprops.CodeName = val || wsprops.name;
				} break;
				case 'GUIDTypeLib': {
					/* empty */
				} break;

				case 'WOpt': break; // TODO: WTF?
				case 'PhoneticInfo': break;

				case 'OleObjectSize': break;

				/* Differential Formatting */
				case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;

				/* Data Validation */
				case 'Dv': case 'DVal': break;

				/* Data Series */
				case 'BRAI': case 'Series': case 'SeriesText': break;

				/* Data Connection */
				case 'DConn': break;
				case 'DbOrParamQry': break;
				case 'DBQueryExt': break;

				case 'OleDbConn': break;
				case 'ExtString': break;

				/* Formatting */
				case 'IFmtRecord': break;
				case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;

				/* Explicitly Ignored */
				case 'Excel9File': break;
				case 'Units': break;
				case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': break;
				case 'BuiltInFnGroupCount': /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */ break;
				/* View Stuff */
				case 'Window1': case 'HideObj': case 'GridSet': case 'Guts':
				case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd':
				case 'Pane': break;
				default: switch(R.n) { /* nested */
				/* Chart */
				case 'Dat':
				case 'Begin': case 'End':
				case 'StartBlock': case 'EndBlock':
				case 'Frame': case 'Area':
				case 'Axis': case 'AxisLine': case 'Tick': break;
				case 'AxesUsed':
				case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
				case 'LineFormat': case 'AreaFormat':
				case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
				case 'PlotArea': case 'PlotGrowth': break;
				case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
				case 'DataFormat': case 'SerToCrt': case 'FontX': break;
				case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
				case 'ShtProps': break;
				case 'DefaultText': case 'Text': case 'CatLab': break;
				case 'DataLabExtContents': break;
				case 'Legend': case 'LegendException': break;
				case 'Pie': case 'Scatter': break;
				case 'PieFormat': case 'MarkerFormat': break;
				case 'StartObject': case 'EndObject': break;
				case 'AlRuns': case 'ObjectLink': break;
				case 'SIIndex': break;
				case 'AttachedLabel': case 'YMult': break;

				/* Chart Group */
				case 'Line': case 'Bar': break;
				case 'Surf': break;

				/* Axis Group */
				case 'AxisParent': break;
				case 'Pos': break;
				case 'ValueRange': break;

				/* Pivot Chart */
				case 'SXViewEx9': break; // TODO
				case 'SXViewLink': break;
				case 'PivotChartBits': break;
				case 'SBaseRef': break;
				case 'TextPropsStream': break;

				/* Chart Misc */
				case 'LnExt': break;
				case 'MkrExt': break;
				case 'CrtCoopt': break;

				/* Query Table */
				case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
				case 'TxtQry': break;

				/* Filter */
				case 'FilterMode': break;
				case 'AutoFilter': case 'AutoFilterInfo': break;
				case 'AutoFilter12': break;
				case 'DropDownObjIds': break;
				case 'Sort': break;
				case 'SortData': break;

				/* Drawing */
				case 'ShapePropsStream': break;
				case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
				/* Pub Stuff */
				case 'WebPub': case 'AutoWebPub': break;

				/* Print Stuff */
				case 'HeaderFooter': case 'HFPicture': case 'PLV':
				case 'HorizontalPageBreaks': case 'VerticalPageBreaks': break;
				/* Behavioral */
				case 'Backup': case 'CompressPictures': case 'Compat12': break;

				/* Should not Happen */
				case 'Continue': case 'ContinueFrt12': break;

				/* Future Records */
				case 'FrtFontList': case 'FrtWrapper': break;

				default: switch(R.n) { /* nested */
				/* BIFF5 records */
				case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;

				/* BIFF2-4 records */
				case 'BIFF2FONTCLR': case 'BIFF2FMTCNT': case 'BIFF2FONTXTRA': break;
				case 'BIFF2XF': case 'BIFF3XF': case 'BIFF4XF': break;
				case 'BIFF4FMTCNT': case 'BIFF2ROW': case 'BIFF2WINDOW2': break;

				/* Miscellaneous */
				case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
				case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
				case 'Name': break;
				case 'LHNGraph': case 'FnGroupName': case 'AddMenu': case 'LPr': break;
				case 'ListObj': case 'ListField': break;
				case 'RRSort': break;
				case 'BigName': break;
				case 'ToolbarHdr': case 'ToolbarEnd': break;
				case 'DDEObjName': break;
				case 'FRTArchId$': break;
				default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
			}}}}
		} else blob.l += length;
	}
	wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
	if(!options.bookSheets) wb.Sheets=Sheets;
	if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
	wb.Preamble=Preamble;
	wb.Strings = sst;
	wb.SSF = SSF.get_table();
	if(opts.enc) wb.Encryption = opts.enc;
	if(themes) wb.Themes = themes;
	wb.Metadata = {};
	if(country !== undefined) wb.Metadata.Country = country;
	if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
	wb.Workbook = Workbook;
	return wb;
}

/* TODO: split props*/
var PSCLSID = {
	SI: "e0859ff2f94f6810ab9108002b27b3d9",
	DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
	UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(cfb, props, o) {
	/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
	var DSI = CFB.find(cfb, '!DocumentSummaryInformation');
	if(DSI && DSI.size > 0) try {
		var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
		for(var d in DocSummary) props[d] = DocSummary[d];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
	var SI = CFB.find(cfb, '!SummaryInformation');
	if(SI && SI.size > 0) try {
		var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
		for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	if(props.HeadingPairs && props.TitlesOfParts) {
		load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
		delete props.HeadingPairs; delete props.TitlesOfParts;
	}
}
function write_xls_props(wb, cfb) {
	var DSEntries = [], SEntries = [], CEntries = [];
	var i = 0, Keys;
	if(wb.Props) {
		Keys = keys(wb.Props);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
	}
	if(wb.Custprops) {
		Keys = keys(wb.Custprops);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) if(!(wb.Props||{}).hasOwnProperty(Keys[i])) (DocSummaryRE.hasOwnProperty(Keys[i]) ? DSEntries : SummaryRE.hasOwnProperty(Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
	}
	var CEntries2 = [];
	for(i = 0; i < CEntries.length; ++i) {
		if(XLSPSSkip.indexOf(CEntries[i][0]) > -1) continue;
		if(CEntries[i][1] == null) continue;
		CEntries2.push(CEntries[i]);
	}
	if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
	if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
}

function parse_xlscfb(cfb, options) {
if(!options) options = {};
fix_read_opts(options);
reset_cp();
if(options.codepage) set_ansi(options.codepage);
var CompObj, WB;
if(cfb.FullPaths) {
	if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
	CompObj = CFB.find(cfb, '!CompObj');
	WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
} else {
	switch(options.type) {
		case 'base64': cfb = s2a(Base64.decode(cfb)); break;
		case 'binary': cfb = s2a(cfb); break;
		case 'buffer': break;
		case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
	}
	prep_blob(cfb, 0);
	WB = ({content: cfb});
}
var WorkbookP;

var _data;
if(CompObj) parse_compobj(CompObj);
if(options.bookProps && !options.bookSheets) WorkbookP = ({});
else {
	var T = has_buf ? 'buffer' : 'array';
	if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
	/* Quattro Pro 7-8 */
	else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Quattro Pro 9 */
	else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	else throw new Error("Cannot find Workbook stream");
	if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
}

var props = {};
if(cfb.FullPaths) parse_xls_props(cfb, props, options);

WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
if(options.bookFiles) WorkbookP.cfb = cfb;
/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
return WorkbookP;
}


function write_xlscfb(wb, opts) {
	var o = opts || {};
	var cfb = CFB.utils.cfb_new({root:"R"});
	var wbpath = "/Workbook";
	switch(o.bookType || "xls") {
		case "xls": o.bookType = "biff8";
		/* falls through */
		case "xla": if(!o.bookType) o.bookType = "xla";
		/* falls through */
		case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
		case "biff5": wbpath = "/Book"; o.biff = 5; break;
		default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
	}
	CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
	if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
	// TODO: SI, DSI, CO
	if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
	return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */
var XLSBRecordEnum = {
0x0000: { n:"BrtRowHdr", f:parse_BrtRowHdr },
0x0001: { n:"BrtCellBlank", f:parse_BrtCellBlank },
0x0002: { n:"BrtCellRk", f:parse_BrtCellRk },
0x0003: { n:"BrtCellError", f:parse_BrtCellError },
0x0004: { n:"BrtCellBool", f:parse_BrtCellBool },
0x0005: { n:"BrtCellReal", f:parse_BrtCellReal },
0x0006: { n:"BrtCellSt", f:parse_BrtCellSt },
0x0007: { n:"BrtCellIsst", f:parse_BrtCellIsst },
0x0008: { n:"BrtFmlaString", f:parse_BrtFmlaString },
0x0009: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
0x000A: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
0x000B: { n:"BrtFmlaError", f:parse_BrtFmlaError },
0x0010: { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ },
0x0013: { n:"BrtSSTItem", f:parse_RichStr },
0x0014: { n:"BrtPCDIMissing" },
0x0015: { n:"BrtPCDINumber" },
0x0016: { n:"BrtPCDIBoolean" },
0x0017: { n:"BrtPCDIError" },
0x0018: { n:"BrtPCDIString" },
0x0019: { n:"BrtPCDIDatetime" },
0x001A: { n:"BrtPCDIIndex" },
0x001B: { n:"BrtPCDIAMissing" },
0x001C: { n:"BrtPCDIANumber" },
0x001D: { n:"BrtPCDIABoolean" },
0x001E: { n:"BrtPCDIAError" },
0x001F: { n:"BrtPCDIAString" },
0x0020: { n:"BrtPCDIADatetime" },
0x0021: { n:"BrtPCRRecord" },
0x0022: { n:"BrtPCRRecordDt" },
0x0023: { n:"BrtFRTBegin" },
0x0024: { n:"BrtFRTEnd" },
0x0025: { n:"BrtACBegin" },
0x0026: { n:"BrtACEnd" },
0x0027: { n:"BrtName", f:parse_BrtName },
0x0028: { n:"BrtIndexRowBlock" },
0x002A: { n:"BrtIndexBlock" },
0x002B: { n:"BrtFont", f:parse_BrtFont },
0x002C: { n:"BrtFmt", f:parse_BrtFmt },
0x002D: { n:"BrtFill", f:parse_BrtFill },
0x002E: { n:"BrtBorder", f:parse_BrtBorder },
0x002F: { n:"BrtXF", f:parse_BrtXF },
0x0030: { n:"BrtStyle" },
0x0031: { n:"BrtCellMeta" },
0x0032: { n:"BrtValueMeta" },
0x0033: { n:"BrtMdb" },
0x0034: { n:"BrtBeginFmd" },
0x0035: { n:"BrtEndFmd" },
0x0036: { n:"BrtBeginMdx" },
0x0037: { n:"BrtEndMdx" },
0x0038: { n:"BrtBeginMdxTuple" },
0x0039: { n:"BrtEndMdxTuple" },
0x003A: { n:"BrtMdxMbrIstr" },
0x003B: { n:"BrtStr" },
0x003C: { n:"BrtColInfo", f:parse_ColInfo },
0x003E: { n:"BrtCellRString" },
0x003F: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
0x0040: { n:"BrtDVal" },
0x0041: { n:"BrtSxvcellNum" },
0x0042: { n:"BrtSxvcellStr" },
0x0043: { n:"BrtSxvcellBool" },
0x0044: { n:"BrtSxvcellErr" },
0x0045: { n:"BrtSxvcellDate" },
0x0046: { n:"BrtSxvcellNil" },
0x0080: { n:"BrtFileVersion" },
0x0081: { n:"BrtBeginSheet" },
0x0082: { n:"BrtEndSheet" },
0x0083: { n:"BrtBeginBook", f:parsenoop, p:0 },
0x0084: { n:"BrtEndBook" },
0x0085: { n:"BrtBeginWsViews" },
0x0086: { n:"BrtEndWsViews" },
0x0087: { n:"BrtBeginBookViews" },
0x0088: { n:"BrtEndBookViews" },
0x0089: { n:"BrtBeginWsView", f:parse_BrtBeginWsView },
0x008A: { n:"BrtEndWsView" },
0x008B: { n:"BrtBeginCsViews" },
0x008C: { n:"BrtEndCsViews" },
0x008D: { n:"BrtBeginCsView" },
0x008E: { n:"BrtEndCsView" },
0x008F: { n:"BrtBeginBundleShs" },
0x0090: { n:"BrtEndBundleShs" },
0x0091: { n:"BrtBeginSheetData" },
0x0092: { n:"BrtEndSheetData" },
0x0093: { n:"BrtWsProp", f:parse_BrtWsProp },
0x0094: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
0x0097: { n:"BrtPane" },
0x0098: { n:"BrtSel" },
0x0099: { n:"BrtWbProp", f:parse_BrtWbProp },
0x009A: { n:"BrtWbFactoid" },
0x009B: { n:"BrtFileRecover" },
0x009C: { n:"BrtBundleSh", f:parse_BrtBundleSh },
0x009D: { n:"BrtCalcProp" },
0x009E: { n:"BrtBookView" },
0x009F: { n:"BrtBeginSst", f:parse_BrtBeginSst },
0x00A0: { n:"BrtEndSst" },
0x00A1: { n:"BrtBeginAFilter", f:parse_UncheckedRfX },
0x00A2: { n:"BrtEndAFilter" },
0x00A3: { n:"BrtBeginFilterColumn" },
0x00A4: { n:"BrtEndFilterColumn" },
0x00A5: { n:"BrtBeginFilters" },
0x00A6: { n:"BrtEndFilters" },
0x00A7: { n:"BrtFilter" },
0x00A8: { n:"BrtColorFilter" },
0x00A9: { n:"BrtIconFilter" },
0x00AA: { n:"BrtTop10Filter" },
0x00AB: { n:"BrtDynamicFilter" },
0x00AC: { n:"BrtBeginCustomFilters" },
0x00AD: { n:"BrtEndCustomFilters" },
0x00AE: { n:"BrtCustomFilter" },
0x00AF: { n:"BrtAFilterDateGroupItem" },
0x00B0: { n:"BrtMergeCell", f:parse_BrtMergeCell },
0x00B1: { n:"BrtBeginMergeCells" },
0x00B2: { n:"BrtEndMergeCells" },
0x00B3: { n:"BrtBeginPivotCacheDef" },
0x00B4: { n:"BrtEndPivotCacheDef" },
0x00B5: { n:"BrtBeginPCDFields" },
0x00B6: { n:"BrtEndPCDFields" },
0x00B7: { n:"BrtBeginPCDField" },
0x00B8: { n:"BrtEndPCDField" },
0x00B9: { n:"BrtBeginPCDSource" },
0x00BA: { n:"BrtEndPCDSource" },
0x00BB: { n:"BrtBeginPCDSRange" },
0x00BC: { n:"BrtEndPCDSRange" },
0x00BD: { n:"BrtBeginPCDFAtbl" },
0x00BE: { n:"BrtEndPCDFAtbl" },
0x00BF: { n:"BrtBeginPCDIRun" },
0x00C0: { n:"BrtEndPCDIRun" },
0x00C1: { n:"BrtBeginPivotCacheRecords" },
0x00C2: { n:"BrtEndPivotCacheRecords" },
0x00C3: { n:"BrtBeginPCDHierarchies" },
0x00C4: { n:"BrtEndPCDHierarchies" },
0x00C5: { n:"BrtBeginPCDHierarchy" },
0x00C6: { n:"BrtEndPCDHierarchy" },
0x00C7: { n:"BrtBeginPCDHFieldsUsage" },
0x00C8: { n:"BrtEndPCDHFieldsUsage" },
0x00C9: { n:"BrtBeginExtConnection" },
0x00CA: { n:"BrtEndExtConnection" },
0x00CB: { n:"BrtBeginECDbProps" },
0x00CC: { n:"BrtEndECDbProps" },
0x00CD: { n:"BrtBeginECOlapProps" },
0x00CE: { n:"BrtEndECOlapProps" },
0x00CF: { n:"BrtBeginPCDSConsol" },
0x00D0: { n:"BrtEndPCDSConsol" },
0x00D1: { n:"BrtBeginPCDSCPages" },
0x00D2: { n:"BrtEndPCDSCPages" },
0x00D3: { n:"BrtBeginPCDSCPage" },
0x00D4: { n:"BrtEndPCDSCPage" },
0x00D5: { n:"BrtBeginPCDSCPItem" },
0x00D6: { n:"BrtEndPCDSCPItem" },
0x00D7: { n:"BrtBeginPCDSCSets" },
0x00D8: { n:"BrtEndPCDSCSets" },
0x00D9: { n:"BrtBeginPCDSCSet" },
0x00DA: { n:"BrtEndPCDSCSet" },
0x00DB: { n:"BrtBeginPCDFGroup" },
0x00DC: { n:"BrtEndPCDFGroup" },
0x00DD: { n:"BrtBeginPCDFGItems" },
0x00DE: { n:"BrtEndPCDFGItems" },
0x00DF: { n:"BrtBeginPCDFGRange" },
0x00E0: { n:"BrtEndPCDFGRange" },
0x00E1: { n:"BrtBeginPCDFGDiscrete" },
0x00E2: { n:"BrtEndPCDFGDiscrete" },
0x00E3: { n:"BrtBeginPCDSDTupleCache" },
0x00E4: { n:"BrtEndPCDSDTupleCache" },
0x00E5: { n:"BrtBeginPCDSDTCEntries" },
0x00E6: { n:"BrtEndPCDSDTCEntries" },
0x00E7: { n:"BrtBeginPCDSDTCEMembers" },
0x00E8: { n:"BrtEndPCDSDTCEMembers" },
0x00E9: { n:"BrtBeginPCDSDTCEMember" },
0x00EA: { n:"BrtEndPCDSDTCEMember" },
0x00EB: { n:"BrtBeginPCDSDTCQueries" },
0x00EC: { n:"BrtEndPCDSDTCQueries" },
0x00ED: { n:"BrtBeginPCDSDTCQuery" },
0x00EE: { n:"BrtEndPCDSDTCQuery" },
0x00EF: { n:"BrtBeginPCDSDTCSets" },
0x00F0: { n:"BrtEndPCDSDTCSets" },
0x00F1: { n:"BrtBeginPCDSDTCSet" },
0x00F2: { n:"BrtEndPCDSDTCSet" },
0x00F3: { n:"BrtBeginPCDCalcItems" },
0x00F4: { n:"BrtEndPCDCalcItems" },
0x00F5: { n:"BrtBeginPCDCalcItem" },
0x00F6: { n:"BrtEndPCDCalcItem" },
0x00F7: { n:"BrtBeginPRule" },
0x00F8: { n:"BrtEndPRule" },
0x00F9: { n:"BrtBeginPRFilters" },
0x00FA: { n:"BrtEndPRFilters" },
0x00FB: { n:"BrtBeginPRFilter" },
0x00FC: { n:"BrtEndPRFilter" },
0x00FD: { n:"BrtBeginPNames" },
0x00FE: { n:"BrtEndPNames" },
0x00FF: { n:"BrtBeginPName" },
0x0100: { n:"BrtEndPName" },
0x0101: { n:"BrtBeginPNPairs" },
0x0102: { n:"BrtEndPNPairs" },
0x0103: { n:"BrtBeginPNPair" },
0x0104: { n:"BrtEndPNPair" },
0x0105: { n:"BrtBeginECWebProps" },
0x0106: { n:"BrtEndECWebProps" },
0x0107: { n:"BrtBeginEcWpTables" },
0x0108: { n:"BrtEndECWPTables" },
0x0109: { n:"BrtBeginECParams" },
0x010A: { n:"BrtEndECParams" },
0x010B: { n:"BrtBeginECParam" },
0x010C: { n:"BrtEndECParam" },
0x010D: { n:"BrtBeginPCDKPIs" },
0x010E: { n:"BrtEndPCDKPIs" },
0x010F: { n:"BrtBeginPCDKPI" },
0x0110: { n:"BrtEndPCDKPI" },
0x0111: { n:"BrtBeginDims" },
0x0112: { n:"BrtEndDims" },
0x0113: { n:"BrtBeginDim" },
0x0114: { n:"BrtEndDim" },
0x0115: { n:"BrtIndexPartEnd" },
0x0116: { n:"BrtBeginStyleSheet" },
0x0117: { n:"BrtEndStyleSheet" },
0x0118: { n:"BrtBeginSXView" },
0x0119: { n:"BrtEndSXVI" },
0x011A: { n:"BrtBeginSXVI" },
0x011B: { n:"BrtBeginSXVIs" },
0x011C: { n:"BrtEndSXVIs" },
0x011D: { n:"BrtBeginSXVD" },
0x011E: { n:"BrtEndSXVD" },
0x011F: { n:"BrtBeginSXVDs" },
0x0120: { n:"BrtEndSXVDs" },
0x0121: { n:"BrtBeginSXPI" },
0x0122: { n:"BrtEndSXPI" },
0x0123: { n:"BrtBeginSXPIs" },
0x0124: { n:"BrtEndSXPIs" },
0x0125: { n:"BrtBeginSXDI" },
0x0126: { n:"BrtEndSXDI" },
0x0127: { n:"BrtBeginSXDIs" },
0x0128: { n:"BrtEndSXDIs" },
0x0129: { n:"BrtBeginSXLI" },
0x012A: { n:"BrtEndSXLI" },
0x012B: { n:"BrtBeginSXLIRws" },
0x012C: { n:"BrtEndSXLIRws" },
0x012D: { n:"BrtBeginSXLICols" },
0x012E: { n:"BrtEndSXLICols" },
0x012F: { n:"BrtBeginSXFormat" },
0x0130: { n:"BrtEndSXFormat" },
0x0131: { n:"BrtBeginSXFormats" },
0x0132: { n:"BrtEndSxFormats" },
0x0133: { n:"BrtBeginSxSelect" },
0x0134: { n:"BrtEndSxSelect" },
0x0135: { n:"BrtBeginISXVDRws" },
0x0136: { n:"BrtEndISXVDRws" },
0x0137: { n:"BrtBeginISXVDCols" },
0x0138: { n:"BrtEndISXVDCols" },
0x0139: { n:"BrtEndSXLocation" },
0x013A: { n:"BrtBeginSXLocation" },
0x013B: { n:"BrtEndSXView" },
0x013C: { n:"BrtBeginSXTHs" },
0x013D: { n:"BrtEndSXTHs" },
0x013E: { n:"BrtBeginSXTH" },
0x013F: { n:"BrtEndSXTH" },
0x0140: { n:"BrtBeginISXTHRws" },
0x0141: { n:"BrtEndISXTHRws" },
0x0142: { n:"BrtBeginISXTHCols" },
0x0143: { n:"BrtEndISXTHCols" },
0x0144: { n:"BrtBeginSXTDMPS" },
0x0145: { n:"BrtEndSXTDMPs" },
0x0146: { n:"BrtBeginSXTDMP" },
0x0147: { n:"BrtEndSXTDMP" },
0x0148: { n:"BrtBeginSXTHItems" },
0x0149: { n:"BrtEndSXTHItems" },
0x014A: { n:"BrtBeginSXTHItem" },
0x014B: { n:"BrtEndSXTHItem" },
0x014C: { n:"BrtBeginMetadata" },
0x014D: { n:"BrtEndMetadata" },
0x014E: { n:"BrtBeginEsmdtinfo" },
0x014F: { n:"BrtMdtinfo" },
0x0150: { n:"BrtEndEsmdtinfo" },
0x0151: { n:"BrtBeginEsmdb" },
0x0152: { n:"BrtEndEsmdb" },
0x0153: { n:"BrtBeginEsfmd" },
0x0154: { n:"BrtEndEsfmd" },
0x0155: { n:"BrtBeginSingleCells" },
0x0156: { n:"BrtEndSingleCells" },
0x0157: { n:"BrtBeginList" },
0x0158: { n:"BrtEndList" },
0x0159: { n:"BrtBeginListCols" },
0x015A: { n:"BrtEndListCols" },
0x015B: { n:"BrtBeginListCol" },
0x015C: { n:"BrtEndListCol" },
0x015D: { n:"BrtBeginListXmlCPr" },
0x015E: { n:"BrtEndListXmlCPr" },
0x015F: { n:"BrtListCCFmla" },
0x0160: { n:"BrtListTrFmla" },
0x0161: { n:"BrtBeginExternals" },
0x0162: { n:"BrtEndExternals" },
0x0163: { n:"BrtSupBookSrc", f:parse_RelID},
0x0165: { n:"BrtSupSelf" },
0x0166: { n:"BrtSupSame" },
0x0167: { n:"BrtSupTabs" },
0x0168: { n:"BrtBeginSupBook" },
0x0169: { n:"BrtPlaceholderName" },
0x016A: { n:"BrtExternSheet", f:parse_ExternSheet },
0x016B: { n:"BrtExternTableStart" },
0x016C: { n:"BrtExternTableEnd" },
0x016E: { n:"BrtExternRowHdr" },
0x016F: { n:"BrtExternCellBlank" },
0x0170: { n:"BrtExternCellReal" },
0x0171: { n:"BrtExternCellBool" },
0x0172: { n:"BrtExternCellError" },
0x0173: { n:"BrtExternCellString" },
0x0174: { n:"BrtBeginEsmdx" },
0x0175: { n:"BrtEndEsmdx" },
0x0176: { n:"BrtBeginMdxSet" },
0x0177: { n:"BrtEndMdxSet" },
0x0178: { n:"BrtBeginMdxMbrProp" },
0x0179: { n:"BrtEndMdxMbrProp" },
0x017A: { n:"BrtBeginMdxKPI" },
0x017B: { n:"BrtEndMdxKPI" },
0x017C: { n:"BrtBeginEsstr" },
0x017D: { n:"BrtEndEsstr" },
0x017E: { n:"BrtBeginPRFItem" },
0x017F: { n:"BrtEndPRFItem" },
0x0180: { n:"BrtBeginPivotCacheIDs" },
0x0181: { n:"BrtEndPivotCacheIDs" },
0x0182: { n:"BrtBeginPivotCacheID" },
0x0183: { n:"BrtEndPivotCacheID" },
0x0184: { n:"BrtBeginISXVIs" },
0x0185: { n:"BrtEndISXVIs" },
0x0186: { n:"BrtBeginColInfos" },
0x0187: { n:"BrtEndColInfos" },
0x0188: { n:"BrtBeginRwBrk" },
0x0189: { n:"BrtEndRwBrk" },
0x018A: { n:"BrtBeginColBrk" },
0x018B: { n:"BrtEndColBrk" },
0x018C: { n:"BrtBrk" },
0x018D: { n:"BrtUserBookView" },
0x018E: { n:"BrtInfo" },
0x018F: { n:"BrtCUsr" },
0x0190: { n:"BrtUsr" },
0x0191: { n:"BrtBeginUsers" },
0x0193: { n:"BrtEOF" },
0x0194: { n:"BrtUCR" },
0x0195: { n:"BrtRRInsDel" },
0x0196: { n:"BrtRREndInsDel" },
0x0197: { n:"BrtRRMove" },
0x0198: { n:"BrtRREndMove" },
0x0199: { n:"BrtRRChgCell" },
0x019A: { n:"BrtRREndChgCell" },
0x019B: { n:"BrtRRHeader" },
0x019C: { n:"BrtRRUserView" },
0x019D: { n:"BrtRRRenSheet" },
0x019E: { n:"BrtRRInsertSh" },
0x019F: { n:"BrtRRDefName" },
0x01A0: { n:"BrtRRNote" },
0x01A1: { n:"BrtRRConflict" },
0x01A2: { n:"BrtRRTQSIF" },
0x01A3: { n:"BrtRRFormat" },
0x01A4: { n:"BrtRREndFormat" },
0x01A5: { n:"BrtRRAutoFmt" },
0x01A6: { n:"BrtBeginUserShViews" },
0x01A7: { n:"BrtBeginUserShView" },
0x01A8: { n:"BrtEndUserShView" },
0x01A9: { n:"BrtEndUserShViews" },
0x01AA: { n:"BrtArrFmla", f:parse_BrtArrFmla },
0x01AB: { n:"BrtShrFmla", f:parse_BrtShrFmla },
0x01AC: { n:"BrtTable" },
0x01AD: { n:"BrtBeginExtConnections" },
0x01AE: { n:"BrtEndExtConnections" },
0x01AF: { n:"BrtBeginPCDCalcMems" },
0x01B0: { n:"BrtEndPCDCalcMems" },
0x01B1: { n:"BrtBeginPCDCalcMem" },
0x01B2: { n:"BrtEndPCDCalcMem" },
0x01B3: { n:"BrtBeginPCDHGLevels" },
0x01B4: { n:"BrtEndPCDHGLevels" },
0x01B5: { n:"BrtBeginPCDHGLevel" },
0x01B6: { n:"BrtEndPCDHGLevel" },
0x01B7: { n:"BrtBeginPCDHGLGroups" },
0x01B8: { n:"BrtEndPCDHGLGroups" },
0x01B9: { n:"BrtBeginPCDHGLGroup" },
0x01BA: { n:"BrtEndPCDHGLGroup" },
0x01BB: { n:"BrtBeginPCDHGLGMembers" },
0x01BC: { n:"BrtEndPCDHGLGMembers" },
0x01BD: { n:"BrtBeginPCDHGLGMember" },
0x01BE: { n:"BrtEndPCDHGLGMember" },
0x01BF: { n:"BrtBeginQSI" },
0x01C0: { n:"BrtEndQSI" },
0x01C1: { n:"BrtBeginQSIR" },
0x01C2: { n:"BrtEndQSIR" },
0x01C3: { n:"BrtBeginDeletedNames" },
0x01C4: { n:"BrtEndDeletedNames" },
0x01C5: { n:"BrtBeginDeletedName" },
0x01C6: { n:"BrtEndDeletedName" },
0x01C7: { n:"BrtBeginQSIFs" },
0x01C8: { n:"BrtEndQSIFs" },
0x01C9: { n:"BrtBeginQSIF" },
0x01CA: { n:"BrtEndQSIF" },
0x01CB: { n:"BrtBeginAutoSortScope" },
0x01CC: { n:"BrtEndAutoSortScope" },
0x01CD: { n:"BrtBeginConditionalFormatting" },
0x01CE: { n:"BrtEndConditionalFormatting" },
0x01CF: { n:"BrtBeginCFRule" },
0x01D0: { n:"BrtEndCFRule" },
0x01D1: { n:"BrtBeginIconSet" },
0x01D2: { n:"BrtEndIconSet" },
0x01D3: { n:"BrtBeginDatabar" },
0x01D4: { n:"BrtEndDatabar" },
0x01D5: { n:"BrtBeginColorScale" },
0x01D6: { n:"BrtEndColorScale" },
0x01D7: { n:"BrtCFVO" },
0x01D8: { n:"BrtExternValueMeta" },
0x01D9: { n:"BrtBeginColorPalette" },
0x01DA: { n:"BrtEndColorPalette" },
0x01DB: { n:"BrtIndexedColor" },
0x01DC: { n:"BrtMargins", f:parse_BrtMargins },
0x01DD: { n:"BrtPrintOptions" },
0x01DE: { n:"BrtPageSetup" },
0x01DF: { n:"BrtBeginHeaderFooter" },
0x01E0: { n:"BrtEndHeaderFooter" },
0x01E1: { n:"BrtBeginSXCrtFormat" },
0x01E2: { n:"BrtEndSXCrtFormat" },
0x01E3: { n:"BrtBeginSXCrtFormats" },
0x01E4: { n:"BrtEndSXCrtFormats" },
0x01E5: { n:"BrtWsFmtInfo", f:parse_BrtWsFmtInfo },
0x01E6: { n:"BrtBeginMgs" },
0x01E7: { n:"BrtEndMGs" },
0x01E8: { n:"BrtBeginMGMaps" },
0x01E9: { n:"BrtEndMGMaps" },
0x01EA: { n:"BrtBeginMG" },
0x01EB: { n:"BrtEndMG" },
0x01EC: { n:"BrtBeginMap" },
0x01ED: { n:"BrtEndMap" },
0x01EE: { n:"BrtHLink", f:parse_BrtHLink },
0x01EF: { n:"BrtBeginDCon" },
0x01F0: { n:"BrtEndDCon" },
0x01F1: { n:"BrtBeginDRefs" },
0x01F2: { n:"BrtEndDRefs" },
0x01F3: { n:"BrtDRef" },
0x01F4: { n:"BrtBeginScenMan" },
0x01F5: { n:"BrtEndScenMan" },
0x01F6: { n:"BrtBeginSct" },
0x01F7: { n:"BrtEndSct" },
0x01F8: { n:"BrtSlc" },
0x01F9: { n:"BrtBeginDXFs" },
0x01FA: { n:"BrtEndDXFs" },
0x01FB: { n:"BrtDXF" },
0x01FC: { n:"BrtBeginTableStyles" },
0x01FD: { n:"BrtEndTableStyles" },
0x01FE: { n:"BrtBeginTableStyle" },
0x01FF: { n:"BrtEndTableStyle" },
0x0200: { n:"BrtTableStyleElement" },
0x0201: { n:"BrtTableStyleClient" },
0x0202: { n:"BrtBeginVolDeps" },
0x0203: { n:"BrtEndVolDeps" },
0x0204: { n:"BrtBeginVolType" },
0x0205: { n:"BrtEndVolType" },
0x0206: { n:"BrtBeginVolMain" },
0x0207: { n:"BrtEndVolMain" },
0x0208: { n:"BrtBeginVolTopic" },
0x0209: { n:"BrtEndVolTopic" },
0x020A: { n:"BrtVolSubtopic" },
0x020B: { n:"BrtVolRef" },
0x020C: { n:"BrtVolNum" },
0x020D: { n:"BrtVolErr" },
0x020E: { n:"BrtVolStr" },
0x020F: { n:"BrtVolBool" },
0x0210: { n:"BrtBeginCalcChain$" },
0x0211: { n:"BrtEndCalcChain$" },
0x0212: { n:"BrtBeginSortState" },
0x0213: { n:"BrtEndSortState" },
0x0214: { n:"BrtBeginSortCond" },
0x0215: { n:"BrtEndSortCond" },
0x0216: { n:"BrtBookProtection" },
0x0217: { n:"BrtSheetProtection" },
0x0218: { n:"BrtRangeProtection" },
0x0219: { n:"BrtPhoneticInfo" },
0x021A: { n:"BrtBeginECTxtWiz" },
0x021B: { n:"BrtEndECTxtWiz" },
0x021C: { n:"BrtBeginECTWFldInfoLst" },
0x021D: { n:"BrtEndECTWFldInfoLst" },
0x021E: { n:"BrtBeginECTwFldInfo" },
0x0224: { n:"BrtFileSharing" },
0x0225: { n:"BrtOleSize" },
0x0226: { n:"BrtDrawing", f:parse_RelID },
0x0227: { n:"BrtLegacyDrawing" },
0x0228: { n:"BrtLegacyDrawingHF" },
0x0229: { n:"BrtWebOpt" },
0x022A: { n:"BrtBeginWebPubItems" },
0x022B: { n:"BrtEndWebPubItems" },
0x022C: { n:"BrtBeginWebPubItem" },
0x022D: { n:"BrtEndWebPubItem" },
0x022E: { n:"BrtBeginSXCondFmt" },
0x022F: { n:"BrtEndSXCondFmt" },
0x0230: { n:"BrtBeginSXCondFmts" },
0x0231: { n:"BrtEndSXCondFmts" },
0x0232: { n:"BrtBkHim" },
0x0234: { n:"BrtColor" },
0x0235: { n:"BrtBeginIndexedColors" },
0x0236: { n:"BrtEndIndexedColors" },
0x0239: { n:"BrtBeginMRUColors" },
0x023A: { n:"BrtEndMRUColors" },
0x023C: { n:"BrtMRUColor" },
0x023D: { n:"BrtBeginDVals" },
0x023E: { n:"BrtEndDVals" },
0x0241: { n:"BrtSupNameStart" },
0x0242: { n:"BrtSupNameValueStart" },
0x0243: { n:"BrtSupNameValueEnd" },
0x0244: { n:"BrtSupNameNum" },
0x0245: { n:"BrtSupNameErr" },
0x0246: { n:"BrtSupNameSt" },
0x0247: { n:"BrtSupNameNil" },
0x0248: { n:"BrtSupNameBool" },
0x0249: { n:"BrtSupNameFmla" },
0x024A: { n:"BrtSupNameBits" },
0x024B: { n:"BrtSupNameEnd" },
0x024C: { n:"BrtEndSupBook" },
0x024D: { n:"BrtCellSmartTagProperty" },
0x024E: { n:"BrtBeginCellSmartTag" },
0x024F: { n:"BrtEndCellSmartTag" },
0x0250: { n:"BrtBeginCellSmartTags" },
0x0251: { n:"BrtEndCellSmartTags" },
0x0252: { n:"BrtBeginSmartTags" },
0x0253: { n:"BrtEndSmartTags" },
0x0254: { n:"BrtSmartTagType" },
0x0255: { n:"BrtBeginSmartTagTypes" },
0x0256: { n:"BrtEndSmartTagTypes" },
0x0257: { n:"BrtBeginSXFilters" },
0x0258: { n:"BrtEndSXFilters" },
0x0259: { n:"BrtBeginSXFILTER" },
0x025A: { n:"BrtEndSXFilter" },
0x025B: { n:"BrtBeginFills" },
0x025C: { n:"BrtEndFills" },
0x025D: { n:"BrtBeginCellWatches" },
0x025E: { n:"BrtEndCellWatches" },
0x025F: { n:"BrtCellWatch" },
0x0260: { n:"BrtBeginCRErrs" },
0x0261: { n:"BrtEndCRErrs" },
0x0262: { n:"BrtCrashRecErr" },
0x0263: { n:"BrtBeginFonts" },
0x0264: { n:"BrtEndFonts" },
0x0265: { n:"BrtBeginBorders" },
0x0266: { n:"BrtEndBorders" },
0x0267: { n:"BrtBeginFmts" },
0x0268: { n:"BrtEndFmts" },
0x0269: { n:"BrtBeginCellXFs" },
0x026A: { n:"BrtEndCellXFs" },
0x026B: { n:"BrtBeginStyles" },
0x026C: { n:"BrtEndStyles" },
0x0271: { n:"BrtBigName" },
0x0272: { n:"BrtBeginCellStyleXFs" },
0x0273: { n:"BrtEndCellStyleXFs" },
0x0274: { n:"BrtBeginComments" },
0x0275: { n:"BrtEndComments" },
0x0276: { n:"BrtBeginCommentAuthors" },
0x0277: { n:"BrtEndCommentAuthors" },
0x0278: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
0x0279: { n:"BrtBeginCommentList" },
0x027A: { n:"BrtEndCommentList" },
0x027B: { n:"BrtBeginComment", f:parse_BrtBeginComment},
0x027C: { n:"BrtEndComment" },
0x027D: { n:"BrtCommentText", f:parse_BrtCommentText },
0x027E: { n:"BrtBeginOleObjects" },
0x027F: { n:"BrtOleObject" },
0x0280: { n:"BrtEndOleObjects" },
0x0281: { n:"BrtBeginSxrules" },
0x0282: { n:"BrtEndSxRules" },
0x0283: { n:"BrtBeginActiveXControls" },
0x0284: { n:"BrtActiveX" },
0x0285: { n:"BrtEndActiveXControls" },
0x0286: { n:"BrtBeginPCDSDTCEMembersSortBy" },
0x0288: { n:"BrtBeginCellIgnoreECs" },
0x0289: { n:"BrtCellIgnoreEC" },
0x028A: { n:"BrtEndCellIgnoreECs" },
0x028B: { n:"BrtCsProp", f:parse_BrtCsProp },
0x028C: { n:"BrtCsPageSetup" },
0x028D: { n:"BrtBeginUserCsViews" },
0x028E: { n:"BrtEndUserCsViews" },
0x028F: { n:"BrtBeginUserCsView" },
0x0290: { n:"BrtEndUserCsView" },
0x0291: { n:"BrtBeginPcdSFCIEntries" },
0x0292: { n:"BrtEndPCDSFCIEntries" },
0x0293: { n:"BrtPCDSFCIEntry" },
0x0294: { n:"BrtBeginListParts" },
0x0295: { n:"BrtListPart" },
0x0296: { n:"BrtEndListParts" },
0x0297: { n:"BrtSheetCalcProp" },
0x0298: { n:"BrtBeginFnGroup" },
0x0299: { n:"BrtFnGroup" },
0x029A: { n:"BrtEndFnGroup" },
0x029B: { n:"BrtSupAddin" },
0x029C: { n:"BrtSXTDMPOrder" },
0x029D: { n:"BrtCsProtection" },
0x029F: { n:"BrtBeginWsSortMap" },
0x02A0: { n:"BrtEndWsSortMap" },
0x02A1: { n:"BrtBeginRRSort" },
0x02A2: { n:"BrtEndRRSort" },
0x02A3: { n:"BrtRRSortItem" },
0x02A4: { n:"BrtFileSharingIso" },
0x02A5: { n:"BrtBookProtectionIso" },
0x02A6: { n:"BrtSheetProtectionIso" },
0x02A7: { n:"BrtCsProtectionIso" },
0x02A8: { n:"BrtRangeProtectionIso" },
0x0400: { n:"BrtRwDescent" },
0x0401: { n:"BrtKnownFonts" },
0x0402: { n:"BrtBeginSXTupleSet" },
0x0403: { n:"BrtEndSXTupleSet" },
0x0404: { n:"BrtBeginSXTupleSetHeader" },
0x0405: { n:"BrtEndSXTupleSetHeader" },
0x0406: { n:"BrtSXTupleSetHeaderItem" },
0x0407: { n:"BrtBeginSXTupleSetData" },
0x0408: { n:"BrtEndSXTupleSetData" },
0x0409: { n:"BrtBeginSXTupleSetRow" },
0x040A: { n:"BrtEndSXTupleSetRow" },
0x040B: { n:"BrtSXTupleSetRowItem" },
0x040C: { n:"BrtNameExt" },
0x040D: { n:"BrtPCDH14" },
0x040E: { n:"BrtBeginPCDCalcMem14" },
0x040F: { n:"BrtEndPCDCalcMem14" },
0x0410: { n:"BrtSXTH14" },
0x0411: { n:"BrtBeginSparklineGroup" },
0x0412: { n:"BrtEndSparklineGroup" },
0x0413: { n:"BrtSparkline" },
0x0414: { n:"BrtSXDI14" },
0x0415: { n:"BrtWsFmtInfoEx14" },
0x0416: { n:"BrtBeginConditionalFormatting14" },
0x0417: { n:"BrtEndConditionalFormatting14" },
0x0418: { n:"BrtBeginCFRule14" },
0x0419: { n:"BrtEndCFRule14" },
0x041A: { n:"BrtCFVO14" },
0x041B: { n:"BrtBeginDatabar14" },
0x041C: { n:"BrtBeginIconSet14" },
0x041D: { n:"BrtDVal14" },
0x041E: { n:"BrtBeginDVals14" },
0x041F: { n:"BrtColor14" },
0x0420: { n:"BrtBeginSparklines" },
0x0421: { n:"BrtEndSparklines" },
0x0422: { n:"BrtBeginSparklineGroups" },
0x0423: { n:"BrtEndSparklineGroups" },
0x0425: { n:"BrtSXVD14" },
0x0426: { n:"BrtBeginSXView14" },
0x0427: { n:"BrtEndSXView14" },
0x0428: { n:"BrtBeginSXView16" },
0x0429: { n:"BrtEndSXView16" },
0x042A: { n:"BrtBeginPCD14" },
0x042B: { n:"BrtEndPCD14" },
0x042C: { n:"BrtBeginExtConn14" },
0x042D: { n:"BrtEndExtConn14" },
0x042E: { n:"BrtBeginSlicerCacheIDs" },
0x042F: { n:"BrtEndSlicerCacheIDs" },
0x0430: { n:"BrtBeginSlicerCacheID" },
0x0431: { n:"BrtEndSlicerCacheID" },
0x0433: { n:"BrtBeginSlicerCache" },
0x0434: { n:"BrtEndSlicerCache" },
0x0435: { n:"BrtBeginSlicerCacheDef" },
0x0436: { n:"BrtEndSlicerCacheDef" },
0x0437: { n:"BrtBeginSlicersEx" },
0x0438: { n:"BrtEndSlicersEx" },
0x0439: { n:"BrtBeginSlicerEx" },
0x043A: { n:"BrtEndSlicerEx" },
0x043B: { n:"BrtBeginSlicer" },
0x043C: { n:"BrtEndSlicer" },
0x043D: { n:"BrtSlicerCachePivotTables" },
0x043E: { n:"BrtBeginSlicerCacheOlapImpl" },
0x043F: { n:"BrtEndSlicerCacheOlapImpl" },
0x0440: { n:"BrtBeginSlicerCacheLevelsData" },
0x0441: { n:"BrtEndSlicerCacheLevelsData" },
0x0442: { n:"BrtBeginSlicerCacheLevelData" },
0x0443: { n:"BrtEndSlicerCacheLevelData" },
0x0444: { n:"BrtBeginSlicerCacheSiRanges" },
0x0445: { n:"BrtEndSlicerCacheSiRanges" },
0x0446: { n:"BrtBeginSlicerCacheSiRange" },
0x0447: { n:"BrtEndSlicerCacheSiRange" },
0x0448: { n:"BrtSlicerCacheOlapItem" },
0x0449: { n:"BrtBeginSlicerCacheSelections" },
0x044A: { n:"BrtSlicerCacheSelection" },
0x044B: { n:"BrtEndSlicerCacheSelections" },
0x044C: { n:"BrtBeginSlicerCacheNative" },
0x044D: { n:"BrtEndSlicerCacheNative" },
0x044E: { n:"BrtSlicerCacheNativeItem" },
0x044F: { n:"BrtRangeProtection14" },
0x0450: { n:"BrtRangeProtectionIso14" },
0x0451: { n:"BrtCellIgnoreEC14" },
0x0457: { n:"BrtList14" },
0x0458: { n:"BrtCFIcon" },
0x0459: { n:"BrtBeginSlicerCachesPivotCacheIDs" },
0x045A: { n:"BrtEndSlicerCachesPivotCacheIDs" },
0x045B: { n:"BrtBeginSlicers" },
0x045C: { n:"BrtEndSlicers" },
0x045D: { n:"BrtWbProp14" },
0x045E: { n:"BrtBeginSXEdit" },
0x045F: { n:"BrtEndSXEdit" },
0x0460: { n:"BrtBeginSXEdits" },
0x0461: { n:"BrtEndSXEdits" },
0x0462: { n:"BrtBeginSXChange" },
0x0463: { n:"BrtEndSXChange" },
0x0464: { n:"BrtBeginSXChanges" },
0x0465: { n:"BrtEndSXChanges" },
0x0466: { n:"BrtSXTupleItems" },
0x0468: { n:"BrtBeginSlicerStyle" },
0x0469: { n:"BrtEndSlicerStyle" },
0x046A: { n:"BrtSlicerStyleElement" },
0x046B: { n:"BrtBeginStyleSheetExt14" },
0x046C: { n:"BrtEndStyleSheetExt14" },
0x046D: { n:"BrtBeginSlicerCachesPivotCacheID" },
0x046E: { n:"BrtEndSlicerCachesPivotCacheID" },
0x046F: { n:"BrtBeginConditionalFormattings" },
0x0470: { n:"BrtEndConditionalFormattings" },
0x0471: { n:"BrtBeginPCDCalcMemExt" },
0x0472: { n:"BrtEndPCDCalcMemExt" },
0x0473: { n:"BrtBeginPCDCalcMemsExt" },
0x0474: { n:"BrtEndPCDCalcMemsExt" },
0x0475: { n:"BrtPCDField14" },
0x0476: { n:"BrtBeginSlicerStyles" },
0x0477: { n:"BrtEndSlicerStyles" },
0x0478: { n:"BrtBeginSlicerStyleElements" },
0x0479: { n:"BrtEndSlicerStyleElements" },
0x047A: { n:"BrtCFRuleExt" },
0x047B: { n:"BrtBeginSXCondFmt14" },
0x047C: { n:"BrtEndSXCondFmt14" },
0x047D: { n:"BrtBeginSXCondFmts14" },
0x047E: { n:"BrtEndSXCondFmts14" },
0x0480: { n:"BrtBeginSortCond14" },
0x0481: { n:"BrtEndSortCond14" },
0x0482: { n:"BrtEndDVals14" },
0x0483: { n:"BrtEndIconSet14" },
0x0484: { n:"BrtEndDatabar14" },
0x0485: { n:"BrtBeginColorScale14" },
0x0486: { n:"BrtEndColorScale14" },
0x0487: { n:"BrtBeginSxrules14" },
0x0488: { n:"BrtEndSxrules14" },
0x0489: { n:"BrtBeginPRule14" },
0x048A: { n:"BrtEndPRule14" },
0x048B: { n:"BrtBeginPRFilters14" },
0x048C: { n:"BrtEndPRFilters14" },
0x048D: { n:"BrtBeginPRFilter14" },
0x048E: { n:"BrtEndPRFilter14" },
0x048F: { n:"BrtBeginPRFItem14" },
0x0490: { n:"BrtEndPRFItem14" },
0x0491: { n:"BrtBeginCellIgnoreECs14" },
0x0492: { n:"BrtEndCellIgnoreECs14" },
0x0493: { n:"BrtDxf14" },
0x0494: { n:"BrtBeginDxF14s" },
0x0495: { n:"BrtEndDxf14s" },
0x0499: { n:"BrtFilter14" },
0x049A: { n:"BrtBeginCustomFilters14" },
0x049C: { n:"BrtCustomFilter14" },
0x049D: { n:"BrtIconFilter14" },
0x049E: { n:"BrtPivotCacheConnectionName" },
0x0800: { n:"BrtBeginDecoupledPivotCacheIDs" },
0x0801: { n:"BrtEndDecoupledPivotCacheIDs" },
0x0802: { n:"BrtDecoupledPivotCacheID" },
0x0803: { n:"BrtBeginPivotTableRefs" },
0x0804: { n:"BrtEndPivotTableRefs" },
0x0805: { n:"BrtPivotTableRef" },
0x0806: { n:"BrtSlicerCacheBookPivotTables" },
0x0807: { n:"BrtBeginSxvcells" },
0x0808: { n:"BrtEndSxvcells" },
0x0809: { n:"BrtBeginSxRow" },
0x080A: { n:"BrtEndSxRow" },
0x080C: { n:"BrtPcdCalcMem15" },
0x0813: { n:"BrtQsi15" },
0x0814: { n:"BrtBeginWebExtensions" },
0x0815: { n:"BrtEndWebExtensions" },
0x0816: { n:"BrtWebExtension" },
0x0817: { n:"BrtAbsPath15" },
0x0818: { n:"BrtBeginPivotTableUISettings" },
0x0819: { n:"BrtEndPivotTableUISettings" },
0x081B: { n:"BrtTableSlicerCacheIDs" },
0x081C: { n:"BrtTableSlicerCacheID" },
0x081D: { n:"BrtBeginTableSlicerCache" },
0x081E: { n:"BrtEndTableSlicerCache" },
0x081F: { n:"BrtSxFilter15" },
0x0820: { n:"BrtBeginTimelineCachePivotCacheIDs" },
0x0821: { n:"BrtEndTimelineCachePivotCacheIDs" },
0x0822: { n:"BrtTimelineCachePivotCacheID" },
0x0823: { n:"BrtBeginTimelineCacheIDs" },
0x0824: { n:"BrtEndTimelineCacheIDs" },
0x0825: { n:"BrtBeginTimelineCacheID" },
0x0826: { n:"BrtEndTimelineCacheID" },
0x0827: { n:"BrtBeginTimelinesEx" },
0x0828: { n:"BrtEndTimelinesEx" },
0x0829: { n:"BrtBeginTimelineEx" },
0x082A: { n:"BrtEndTimelineEx" },
0x082B: { n:"BrtWorkBookPr15" },
0x082C: { n:"BrtPCDH15" },
0x082D: { n:"BrtBeginTimelineStyle" },
0x082E: { n:"BrtEndTimelineStyle" },
0x082F: { n:"BrtTimelineStyleElement" },
0x0830: { n:"BrtBeginTimelineStylesheetExt15" },
0x0831: { n:"BrtEndTimelineStylesheetExt15" },
0x0832: { n:"BrtBeginTimelineStyles" },
0x0833: { n:"BrtEndTimelineStyles" },
0x0834: { n:"BrtBeginTimelineStyleElements" },
0x0835: { n:"BrtEndTimelineStyleElements" },
0x0836: { n:"BrtDxf15" },
0x0837: { n:"BrtBeginDxfs15" },
0x0838: { n:"brtEndDxfs15" },
0x0839: { n:"BrtSlicerCacheHideItemsWithNoData" },
0x083A: { n:"BrtBeginItemUniqueNames" },
0x083B: { n:"BrtEndItemUniqueNames" },
0x083C: { n:"BrtItemUniqueName" },
0x083D: { n:"BrtBeginExtConn15" },
0x083E: { n:"BrtEndExtConn15" },
0x083F: { n:"BrtBeginOledbPr15" },
0x0840: { n:"BrtEndOledbPr15" },
0x0841: { n:"BrtBeginDataFeedPr15" },
0x0842: { n:"BrtEndDataFeedPr15" },
0x0843: { n:"BrtTextPr15" },
0x0844: { n:"BrtRangePr15" },
0x0845: { n:"BrtDbCommand15" },
0x0846: { n:"BrtBeginDbTables15" },
0x0847: { n:"BrtEndDbTables15" },
0x0848: { n:"BrtDbTable15" },
0x0849: { n:"BrtBeginDataModel" },
0x084A: { n:"BrtEndDataModel" },
0x084B: { n:"BrtBeginModelTables" },
0x084C: { n:"BrtEndModelTables" },
0x084D: { n:"BrtModelTable" },
0x084E: { n:"BrtBeginModelRelationships" },
0x084F: { n:"BrtEndModelRelationships" },
0x0850: { n:"BrtModelRelationship" },
0x0851: { n:"BrtBeginECTxtWiz15" },
0x0852: { n:"BrtEndECTxtWiz15" },
0x0853: { n:"BrtBeginECTWFldInfoLst15" },
0x0854: { n:"BrtEndECTWFldInfoLst15" },
0x0855: { n:"BrtBeginECTWFldInfo15" },
0x0856: { n:"BrtFieldListActiveItem" },
0x0857: { n:"BrtPivotCacheIdVersion" },
0x0858: { n:"BrtSXDI15" },
0x0859: { n:"BrtBeginModelTimeGroupings" },
0x085A: { n:"BrtEndModelTimeGroupings" },
0x085B: { n:"BrtBeginModelTimeGrouping" },
0x085C: { n:"BrtEndModelTimeGrouping" },
0x085D: { n:"BrtModelTimeGroupingCalcCol" },
0x0C00: { n:"BrtUid" },
0x0C01: { n:"BrtRevisionPtr" },
0xFFFF: { n:"" }
};

var XLSBRE = evert_key(XLSBRecordEnum, 'n');

/* [MS-XLS] 2.3 Record Enumeration */
var XLSRecordEnum = {
0x0003: { n:"BIFF2NUM", f:parse_BIFF2NUM },
0x0004: { n:"BIFF2STR", f:parse_BIFF2STR },
0x0006: { n:"Formula", f:parse_Formula },
0x0009: { n:'BOF', f:parse_BOF },
0x000a: { n:'EOF', f:parsenoop2 },
0x000c: { n:"CalcCount", f:parseuint16 },
0x000d: { n:"CalcMode", f:parseuint16 },
0x000e: { n:"CalcPrecision", f:parsebool },
0x000f: { n:"CalcRefMode", f:parsebool },
0x0010: { n:"CalcDelta", f:parse_Xnum },
0x0011: { n:"CalcIter", f:parsebool },
0x0012: { n:"Protect", f:parsebool },
0x0013: { n:"Password", f:parseuint16 },
0x0014: { n:"Header", f:parse_XLHeaderFooter },
0x0015: { n:"Footer", f:parse_XLHeaderFooter },
0x0017: { n:"ExternSheet", f:parse_ExternSheet },
0x0018: { n:"Lbl", f:parse_Lbl },
0x0019: { n:"WinProtect", f:parsebool },
0x001a: { n:"VerticalPageBreaks" },
0x001b: { n:"HorizontalPageBreaks" },
0x001c: { n:"Note", f:parse_Note },
0x001d: { n:"Selection" },
0x0022: { n:"Date1904", f:parsebool },
0x0023: { n:"ExternName", f:parse_ExternName },
0x0026: { n:"LeftMargin", f:parse_Xnum },
0x0027: { n:"RightMargin", f:parse_Xnum },
0x0028: { n:"TopMargin", f:parse_Xnum },
0x0029: { n:"BottomMargin", f:parse_Xnum },
0x002a: { n:"PrintRowCol", f:parsebool },
0x002b: { n:"PrintGrid", f:parsebool },
0x002f: { n:"FilePass", f:parse_FilePass },
0x0031: { n:"Font", f:parse_Font },
0x0033: { n:"PrintSize", f:parseuint16 },
0x003c: { n:"Continue" },
0x003d: { n:"Window1", f:parse_Window1 },
0x0040: { n:"Backup", f:parsebool },
0x0041: { n:"Pane" },
0x0042: { n:'CodePage', f:parseuint16 },
0x004d: { n:"Pls" },
0x0050: { n:"DCon" },
0x0051: { n:"DConRef" },
0x0052: { n:"DConName" },
0x0055: { n:"DefColWidth", f:parseuint16 },
0x0059: { n:"XCT" },
0x005a: { n:"CRN" },
0x005b: { n:"FileSharing" },
0x005c: { n:'WriteAccess', f:parse_WriteAccess },
0x005d: { n:"Obj", f:parse_Obj },
0x005e: { n:"Uncalced" },
0x005f: { n:"CalcSaveRecalc", f:parsebool },
0x0060: { n:"Template" },
0x0061: { n:"Intl" },
0x0063: { n:"ObjProtect", f:parsebool },
0x007d: { n:"ColInfo", f:parse_ColInfo },
0x0080: { n:"Guts", f:parse_Guts },
0x0081: { n:"WsBool", f:parse_WsBool },
0x0082: { n:"GridSet", f:parseuint16 },
0x0083: { n:"HCenter", f:parsebool },
0x0084: { n:"VCenter", f:parsebool },
0x0085: { n:'BoundSheet8', f:parse_BoundSheet8 },
0x0086: { n:"WriteProtect" },
0x008c: { n:"Country", f:parse_Country },
0x008d: { n:"HideObj", f:parseuint16 },
0x0090: { n:"Sort" },
0x0092: { n:"Palette", f:parse_Palette },
0x0097: { n:"Sync" },
0x0098: { n:"LPr" },
0x0099: { n:"DxGCol" },
0x009a: { n:"FnGroupName" },
0x009b: { n:"FilterMode" },
0x009c: { n:"BuiltInFnGroupCount", f:parseuint16 },
0x009d: { n:"AutoFilterInfo" },
0x009e: { n:"AutoFilter" },
0x00a0: { n:"Scl", f:parse_Scl },
0x00a1: { n:"Setup", f:parse_Setup },
0x00ae: { n:"ScenMan" },
0x00af: { n:"SCENARIO" },
0x00b0: { n:"SxView" },
0x00b1: { n:"Sxvd" },
0x00b2: { n:"SXVI" },
0x00b4: { n:"SxIvd" },
0x00b5: { n:"SXLI" },
0x00b6: { n:"SXPI" },
0x00b8: { n:"DocRoute" },
0x00b9: { n:"RecipName" },
0x00bd: { n:"MulRk", f:parse_MulRk },
0x00be: { n:"MulBlank", f:parse_MulBlank },
0x00c1: { n:'Mms', f:parsenoop2 },
0x00c5: { n:"SXDI" },
0x00c6: { n:"SXDB" },
0x00c7: { n:"SXFDB" },
0x00c8: { n:"SXDBB" },
0x00c9: { n:"SXNum" },
0x00ca: { n:"SxBool", f:parsebool },
0x00cb: { n:"SxErr" },
0x00cc: { n:"SXInt" },
0x00cd: { n:"SXString" },
0x00ce: { n:"SXDtr" },
0x00cf: { n:"SxNil" },
0x00d0: { n:"SXTbl" },
0x00d1: { n:"SXTBRGIITM" },
0x00d2: { n:"SxTbpg" },
0x00d3: { n:"ObProj" },
0x00d5: { n:"SXStreamID" },
0x00d7: { n:"DBCell" },
0x00d8: { n:"SXRng" },
0x00d9: { n:"SxIsxoper" },
0x00da: { n:"BookBool", f:parseuint16 },
0x00dc: { n:"DbOrParamQry" },
0x00dd: { n:"ScenarioProtect", f:parsebool },
0x00de: { n:"OleObjectSize" },
0x00e0: { n:"XF", f:parse_XF },
0x00e1: { n:'InterfaceHdr', f:parse_InterfaceHdr },
0x00e2: { n:'InterfaceEnd', f:parsenoop2 },
0x00e3: { n:"SXVS" },
0x00e5: { n:"MergeCells", f:parse_MergeCells },
0x00e9: { n:"BkHim" },
0x00eb: { n:"MsoDrawingGroup" },
0x00ec: { n:"MsoDrawing" },
0x00ed: { n:"MsoDrawingSelection" },
0x00ef: { n:"PhoneticInfo" },
0x00f0: { n:"SxRule" },
0x00f1: { n:"SXEx" },
0x00f2: { n:"SxFilt" },
0x00f4: { n:"SxDXF" },
0x00f5: { n:"SxItm" },
0x00f6: { n:"SxName" },
0x00f7: { n:"SxSelect" },
0x00f8: { n:"SXPair" },
0x00f9: { n:"SxFmla" },
0x00fb: { n:"SxFormat" },
0x00fc: { n:"SST", f:parse_SST },
0x00fd: { n:"LabelSst", f:parse_LabelSst },
0x00ff: { n:"ExtSST", f:parse_ExtSST },
0x0100: { n:"SXVDEx" },
0x0103: { n:"SXFormula" },
0x0122: { n:"SXDBEx" },
0x0137: { n:"RRDInsDel" },
0x0138: { n:"RRDHead" },
0x013b: { n:"RRDChgCell" },
0x013d: { n:"RRTabId", f:parseuint16a },
0x013e: { n:"RRDRenSheet" },
0x013f: { n:"RRSort" },
0x0140: { n:"RRDMove" },
0x014a: { n:"RRFormat" },
0x014b: { n:"RRAutoFmt" },
0x014d: { n:"RRInsertSh" },
0x014e: { n:"RRDMoveBegin" },
0x014f: { n:"RRDMoveEnd" },
0x0150: { n:"RRDInsDelBegin" },
0x0151: { n:"RRDInsDelEnd" },
0x0152: { n:"RRDConflict" },
0x0153: { n:"RRDDefName" },
0x0154: { n:"RRDRstEtxp" },
0x015f: { n:"LRng" },
0x0160: { n:"UsesELFs", f:parsebool },
0x0161: { n:"DSF", f:parsenoop2 },
0x0191: { n:"CUsr" },
0x0192: { n:"CbUsr" },
0x0193: { n:"UsrInfo" },
0x0194: { n:"UsrExcl" },
0x0195: { n:"FileLock" },
0x0196: { n:"RRDInfo" },
0x0197: { n:"BCUsrs" },
0x0198: { n:"UsrChk" },
0x01a9: { n:"UserBView" },
0x01aa: { n:"UserSViewBegin" },
0x01ab: { n:"UserSViewEnd" },
0x01ac: { n:"RRDUserView" },
0x01ad: { n:"Qsi" },
0x01ae: { n:"SupBook", f:parse_SupBook },
0x01af: { n:"Prot4Rev", f:parsebool },
0x01b0: { n:"CondFmt" },
0x01b1: { n:"CF" },
0x01b2: { n:"DVal" },
0x01b5: { n:"DConBin" },
0x01b6: { n:"TxO", f:parse_TxO },
0x01b7: { n:"RefreshAll", f:parsebool },
0x01b8: { n:"HLink", f:parse_HLink },
0x01b9: { n:"Lel" },
0x01ba: { n:"CodeName", f:parse_XLUnicodeString },
0x01bb: { n:"SXFDBType" },
0x01bc: { n:"Prot4RevPass", f:parseuint16 },
0x01bd: { n:"ObNoMacros" },
0x01be: { n:"Dv" },
0x01c0: { n:"Excel9File", f:parsenoop2 },
0x01c1: { n:"RecalcId", f:parse_RecalcId, r:2},
0x01c2: { n:"EntExU2", f:parsenoop2 },
0x0200: { n:"Dimensions", f:parse_Dimensions },
0x0201: { n:"Blank", f:parse_Blank },
0x0203: { n:"Number", f:parse_Number },
0x0204: { n:"Label", f:parse_Label },
0x0205: { n:"BoolErr", f:parse_BoolErr },
0x0206: { n:"Formula", f:parse_Formula },
0x0207: { n:"String", f:parse_String },
0x0208: { n:'Row', f:parse_Row },
0x020b: { n:"Index" },
0x0221: { n:"Array", f:parse_Array },
0x0225: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
0x0236: { n:"Table" },
0x023e: { n:"Window2", f:parse_Window2 },
0x027e: { n:"RK", f:parse_RK },
0x0293: { n:"Style" },
0x0406: { n:"Formula", f:parse_Formula },
0x0418: { n:"BigName" },
0x041e: { n:"Format", f:parse_Format },
0x043c: { n:"ContinueBigName" },
0x04bc: { n:"ShrFmla", f:parse_ShrFmla },
0x0800: { n:"HLinkTooltip", f:parse_HLinkTooltip },
0x0801: { n:"WebPub" },
0x0802: { n:"QsiSXTag" },
0x0803: { n:"DBQueryExt" },
0x0804: { n:"ExtString" },
0x0805: { n:"TxtQry" },
0x0806: { n:"Qsir" },
0x0807: { n:"Qsif" },
0x0808: { n:"RRDTQSIF" },
0x0809: { n:'BOF', f:parse_BOF },
0x080a: { n:"OleDbConn" },
0x080b: { n:"WOpt" },
0x080c: { n:"SXViewEx" },
0x080d: { n:"SXTH" },
0x080e: { n:"SXPIEx" },
0x080f: { n:"SXVDTEx" },
0x0810: { n:"SXViewEx9" },
0x0812: { n:"ContinueFrt" },
0x0813: { n:"RealTimeData" },
0x0850: { n:"ChartFrtInfo" },
0x0851: { n:"FrtWrapper" },
0x0852: { n:"StartBlock" },
0x0853: { n:"EndBlock" },
0x0854: { n:"StartObject" },
0x0855: { n:"EndObject" },
0x0856: { n:"CatLab" },
0x0857: { n:"YMult" },
0x0858: { n:"SXViewLink" },
0x0859: { n:"PivotChartBits" },
0x085a: { n:"FrtFontList" },
0x0862: { n:"SheetExt" },
0x0863: { n:"BookExt", r:12},
0x0864: { n:"SXAddl" },
0x0865: { n:"CrErr" },
0x0866: { n:"HFPicture" },
0x0867: { n:'FeatHdr', f:parsenoop2 },
0x0868: { n:"Feat" },
0x086a: { n:"DataLabExt" },
0x086b: { n:"DataLabExtContents" },
0x086c: { n:"CellWatch" },
0x0871: { n:"FeatHdr11" },
0x0872: { n:"Feature11" },
0x0874: { n:"DropDownObjIds" },
0x0875: { n:"ContinueFrt11" },
0x0876: { n:"DConn" },
0x0877: { n:"List12" },
0x0878: { n:"Feature12" },
0x0879: { n:"CondFmt12" },
0x087a: { n:"CF12" },
0x087b: { n:"CFEx" },
0x087c: { n:"XFCRC", f:parse_XFCRC, r:12 },
0x087d: { n:"XFExt", f:parse_XFExt, r:12 },
0x087e: { n:"AutoFilter12" },
0x087f: { n:"ContinueFrt12" },
0x0884: { n:"MDTInfo" },
0x0885: { n:"MDXStr" },
0x0886: { n:"MDXTuple" },
0x0887: { n:"MDXSet" },
0x0888: { n:"MDXProp" },
0x0889: { n:"MDXKPI" },
0x088a: { n:"MDB" },
0x088b: { n:"PLV" },
0x088c: { n:"Compat12", f:parsebool, r:12 },
0x088d: { n:"DXF" },
0x088e: { n:"TableStyles", r:12 },
0x088f: { n:"TableStyle" },
0x0890: { n:"TableStyleElement" },
0x0892: { n:"StyleExt" },
0x0893: { n:"NamePublish" },
0x0894: { n:"NameCmt", f:parse_NameCmt, r:12 },
0x0895: { n:"SortData" },
0x0896: { n:"Theme", f:parse_Theme, r:12 },
0x0897: { n:"GUIDTypeLib" },
0x0898: { n:"FnGrp12" },
0x0899: { n:"NameFnGrp12" },
0x089a: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
0x089b: { n:"CompressPictures", f:parsenoop2 },
0x089c: { n:"HeaderFooter" },
0x089d: { n:"CrtLayout12" },
0x089e: { n:"CrtMlFrt" },
0x089f: { n:"CrtMlFrtContinue" },
0x08a3: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
0x08a4: { n:"ShapePropsStream" },
0x08a5: { n:"TextPropsStream" },
0x08a6: { n:"RichTextStream" },
0x08a7: { n:"CrtLayout12A" },
0x1001: { n:"Units" },
0x1002: { n:"Chart" },
0x1003: { n:"Series" },
0x1006: { n:"DataFormat" },
0x1007: { n:"LineFormat" },
0x1009: { n:"MarkerFormat" },
0x100a: { n:"AreaFormat" },
0x100b: { n:"PieFormat" },
0x100c: { n:"AttachedLabel" },
0x100d: { n:"SeriesText" },
0x1014: { n:"ChartFormat" },
0x1015: { n:"Legend" },
0x1016: { n:"SeriesList" },
0x1017: { n:"Bar" },
0x1018: { n:"Line" },
0x1019: { n:"Pie" },
0x101a: { n:"Area" },
0x101b: { n:"Scatter" },
0x101c: { n:"CrtLine" },
0x101d: { n:"Axis" },
0x101e: { n:"Tick" },
0x101f: { n:"ValueRange" },
0x1020: { n:"CatSerRange" },
0x1021: { n:"AxisLine" },
0x1022: { n:"CrtLink" },
0x1024: { n:"DefaultText" },
0x1025: { n:"Text" },
0x1026: { n:"FontX", f:parseuint16 },
0x1027: { n:"ObjectLink" },
0x1032: { n:"Frame" },
0x1033: { n:"Begin" },
0x1034: { n:"End" },
0x1035: { n:"PlotArea" },
0x103a: { n:"Chart3d" },
0x103c: { n:"PicF" },
0x103d: { n:"DropBar" },
0x103e: { n:"Radar" },
0x103f: { n:"Surf" },
0x1040: { n:"RadarArea" },
0x1041: { n:"AxisParent" },
0x1043: { n:"LegendException" },
0x1044: { n:"ShtProps", f:parse_ShtProps },
0x1045: { n:"SerToCrt" },
0x1046: { n:"AxesUsed" },
0x1048: { n:"SBaseRef" },
0x104a: { n:"SerParent" },
0x104b: { n:"SerAuxTrend" },
0x104e: { n:"IFmtRecord" },
0x104f: { n:"Pos" },
0x1050: { n:"AlRuns" },
0x1051: { n:"BRAI" },
0x105b: { n:"SerAuxErrBar" },
0x105c: { n:"ClrtClient", f:parse_ClrtClient },
0x105d: { n:"SerFmt" },
0x105f: { n:"Chart3DBarShape" },
0x1060: { n:"Fbi" },
0x1061: { n:"BopPop" },
0x1062: { n:"AxcExt" },
0x1063: { n:"Dat" },
0x1064: { n:"PlotGrowth" },
0x1065: { n:"SIIndex" },
0x1066: { n:"GelFrame" },
0x1067: { n:"BopPopCustom" },
0x1068: { n:"Fbi2" },

0x0000: { n:"Dimensions", f:parse_Dimensions },
0x0002: { n:"BIFF2INT", f:parse_BIFF2INT },
0x0005: { n:"BoolErr", f:parse_BoolErr },
0x0007: { n:"String", f:parse_BIFF2STRING },
0x0008: { n:"BIFF2ROW" },
0x000b: { n:"Index" },
0x0016: { n:"ExternCount", f:parseuint16 },
0x001e: { n:"BIFF2FORMAT", f:parse_BIFF2Format },
0x001f: { n:"BIFF2FMTCNT" }, /* 16-bit cnt of BIFF2FORMAT records */
0x0020: { n:"BIFF2COLINFO" },
0x0021: { n:"Array", f:parse_Array },
0x0025: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
0x0032: { n:"BIFF2FONTXTRA", f:parse_BIFF2FONTXTRA },
0x0034: { n:"DDEObjName" },
0x003e: { n:"BIFF2WINDOW2" },
0x0043: { n:"BIFF2XF" },
0x0045: { n:"BIFF2FONTCLR" },
0x0056: { n:"BIFF4FMTCNT" }, /* 16-bit cnt, similar to BIFF2 */
0x007e: { n:"RK" }, /* Not necessarily same as 0x027e */
0x007f: { n:"ImData", f:parse_ImData },
0x0087: { n:"Addin" },
0x0088: { n:"Edg" },
0x0089: { n:"Pub" },
0x0091: { n:"Sub" },
0x0094: { n:"LHRecord" },
0x0095: { n:"LHNGraph" },
0x0096: { n:"Sound" },
0x00a9: { n:"CoordList" },
0x00ab: { n:"GCW" },
0x00bc: { n:"ShrFmla" }, /* Not necessarily same as 0x04bc */
0x00bf: { n:"ToolbarHdr" },
0x00c0: { n:"ToolbarEnd" },
0x00c2: { n:"AddMenu" },
0x00c3: { n:"DelMenu" },
0x00d6: { n:"RString", f:parse_RString },
0x00df: { n:"UDDesc" },
0x00ea: { n:"TabIdConf" },
0x0162: { n:"XL5Modify" },
0x01a5: { n:"FileSharing2" },
0x0209: { n:'BOF', f:parse_BOF },
0x0218: { n:"Lbl", f:parse_Lbl },
0x0223: { n:"ExternName", f:parse_ExternName },
0x0231: { n:"Font" },
0x0243: { n:"BIFF3XF" },
0x0409: { n:'BOF', f:parse_BOF },
0x0443: { n:"BIFF4XF" },
0x086d: { n:"FeatInfo" },
0x0873: { n:"FeatInfo11" },
0x0881: { n:"SXAddl12" },
0x08c0: { n:"AutoWebPub" },
0x08c1: { n:"ListObj" },
0x08c2: { n:"ListField" },
0x08c3: { n:"ListDV" },
0x08c4: { n:"ListCondFmt" },
0x08c5: { n:"ListCF" },
0x08c6: { n:"FMQry" },
0x08c7: { n:"FMSQry" },
0x08c8: { n:"PLV" },
0x08c9: { n:"LnExt" },
0x08ca: { n:"MkrExt" },
0x08cb: { n:"CrtCoopt" },
0x08d6: { n:"FRTArchId$", r:12 },

0x7262: {}
};

var XLSRE = evert_key(XLSRecordEnum, 'n');
function write_biff_rec(ba, type, payload, length) {
	var t = +type || +XLSRE[type];
	if(isNaN(t)) return;
	var len = length || (payload||[]).length || 0;
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, len);
	if(len > 0 && is_buf(payload)) ba.push(payload);
}

function write_BIFF2Cell(out, r, c) {
	if(!out) out = new_buf(7);
	out.write_shift(2, r);
	out.write_shift(2, c);
	out.write_shift(2, 0);
	out.write_shift(1, 0);
	return out;
}

function write_BIFF2BERR(r, c, val, t) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	if(t == 'e') { out.write_shift(1, val); out.write_shift(1, 1); }
	else { out.write_shift(1, val?1:0); out.write_shift(1, 0); }
	return out;
}

/* TODO: codepage, large strings */
function write_BIFF2LABEL(r, c, val) {
	var out = new_buf(8 + 2*val.length);
	write_BIFF2Cell(out, r, c);
	out.write_shift(1, val.length);
	out.write_shift(val.length, val, 'sbcs');
	return out.l < out.length ? out.slice(0, out.l) : out;
}

function write_ws_biff2_cell(ba, cell, R, C) {
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			if((v == (v|0)) && (v >= 0) && (v < 65536))
				write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
			else
				write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, cell.v));
			return;
	}
	write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
}

function write_ws_biff2(ba, ws, idx, opts) {
	var dense = Array.isArray(ws);
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
	if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, 0x3FFF);
		ref = encode_range(range);
	}
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff2_cell(ba, cell, R, C, opts);
		}
	}
}

/* Based on test files */
function write_biff2_buf(wb, opts) {
	var o = opts || {};
	if(DENSE != null && o.dense == null) o.dense = DENSE;
	var ba = buf_array();
	var idx = 0;
	for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
	if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
	write_biff_rec(ba, 0x0009, write_BOF(wb, 0x10, o));
	/* ... */
	write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
	/* ... */
	write_biff_rec(ba, 0x000A);
	return ba.end();
}

function write_FONTS_biff8(ba, data, opts) {
	write_biff_rec(ba, "Font", write_Font({
		sz:12,
		color: {theme:1},
		name: "Arial",
		family: 2,
		scheme: "minor"
	}, opts));
}


function write_FMTS_biff8(ba, NF, opts) {
	if(!NF) return;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, "Format", write_Format(i, NF[i], opts));
	});
}

function write_FEAT(ba, ws) {
	/* [MS-XLS] 2.4.112 */
	var o = new_buf(19);
	o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
	write_biff_rec(ba, "FeatHdr", o);
	/* [MS-XLS] 2.4.111 */
	o = new_buf(39);
	o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
	o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
	write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
	o.write_shift(4, 4);
	write_biff_rec(ba, "Feat", o);
}

function write_CELLXFS_biff8(ba, opts) {
	for(var i = 0; i < 16; ++i) write_biff_rec(ba, "XF", write_XF({numFmtId:0, style:true}, 0, opts));
	opts.cellXfs.forEach(function(c) {
		write_biff_rec(ba, "XF", write_XF(c, 0, opts));
	});
}

function write_ws_biff8_hlinks(ba, ws) {
	for(var R=0; R<ws['!links'].length; ++R) {
		var HL = ws['!links'][R];
		write_biff_rec(ba, "HLink", write_HLink(HL));
		if(HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
	}
	delete ws['!links'];
}

function write_ws_biff8_cell(ba, cell, R, C, opts) {
	var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			/* TODO: emit RK as appropriate */
			write_biff_rec(ba, "Number", write_Number(R, C, v, os, opts));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0205, write_BoolErr(R, C, cell.v, os, opts, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, "Label", write_Label(R, C, cell.v, os, opts));
			return;
	}
	write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
}

/* [MS-XLS] 2.1.7.20.5 */
function write_ws_biff8(idx, opts, wb) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var _WB = ((wb||{}).Workbook||{});
	var _sheet = ((_WB.Sheets||[])[idx]||{});
	var dense = Array.isArray(ws);
	var b8 = opts.biff == 8;
	var ref, rr = "", cols = [];
	var range = safe_decode_range(ws['!ref'] || "A1");
	var MAX_ROWS = b8 ? 65536 : 16384;
	if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, MAX_ROWS-1);
	}

	write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
	/* ... */
	write_biff_rec(ba, "CalcMode", writeuint16(1));
	write_biff_rec(ba, "CalcCount", writeuint16(100));
	write_biff_rec(ba, "CalcRefMode", writebool(true));
	write_biff_rec(ba, "CalcIter", writebool(false));
	write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
	write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
	write_biff_rec(ba, "PrintRowCol", writebool(false));
	write_biff_rec(ba, "PrintGrid", writebool(false));
	write_biff_rec(ba, "GridSet", writeuint16(1));
	write_biff_rec(ba, "Guts", write_Guts([0,0]));
	/* ... */
	write_biff_rec(ba, "HCenter", writebool(false));
	write_biff_rec(ba, "VCenter", writebool(false));
	/* ... */
	write_biff_rec(ba, "Dimensions", write_Dimensions(range, opts));
	/* ... */

	if(b8) ws['!links'] = [];
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff8_cell(ba, cell, R, C, opts);
			if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
		}
	}
	var cname = _sheet.CodeName || _sheet.name || s;
	/* ... */
	if(b8 && _WB.Views) write_biff_rec(ba, "Window2", write_Window2(_WB.Views[0]));
	/* ... */
	if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']));
	/* ... */
	if(b8) write_ws_biff8_hlinks(ba, ws);
	/* ... */
	write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname, opts));
	/* ... */
	if(b8) write_FEAT(ba, ws);
	/* ... */
	write_biff_rec(ba, "EOF");
	return ba.end();
}

/* [MS-XLS] 2.1.7.20.3 */
function write_biff8_global(wb, bufs, opts) {
	var A = buf_array();
	var _WB = ((wb||{}).Workbook||{});
	var _sheets = (_WB.Sheets||[]);
	var _wb = _WB.WBProps||{};
	var b8 = opts.biff == 8, b5 = opts.biff == 5;
	write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
	if(opts.bookType == "xla") write_biff_rec(A, "Addin");
	write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
	write_biff_rec(A, "Mms", writezeroes(2));
	if(b5) write_biff_rec(A, "ToolbarHdr");
	if(b5) write_biff_rec(A, "ToolbarEnd");
	write_biff_rec(A, "InterfaceEnd");
	write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
	write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
	if(b8) write_biff_rec(A, "DSF", writeuint16(0));
	if(b8) write_biff_rec(A, "Excel9File");
	write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
	if(b8 && wb.vbaraw) {
		write_biff_rec(A, "ObProj");
		var cname = _wb.CodeName || "ThisWorkbook";
		write_biff_rec(A, "CodeName", write_XLUnicodeString(cname, opts));
	}
	write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
	write_biff_rec(A, "WinProtect", writebool(false));
	write_biff_rec(A, "Protect", writebool(false));
	write_biff_rec(A, "Password", writeuint16(0));
	if(b8) write_biff_rec(A, "Prot4Rev", writebool(false));
	if(b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
	write_biff_rec(A, "Window1", write_Window1(opts));
	write_biff_rec(A, "Backup", writebool(false));
	write_biff_rec(A, "HideObj", writeuint16(0));
	write_biff_rec(A, "Date1904", writebool(safe1904(wb)=="true"));
	write_biff_rec(A, "CalcPrecision", writebool(true));
	if(b8) write_biff_rec(A, "RefreshAll", writebool(false));
	write_biff_rec(A, "BookBool", writeuint16(0));
	/* ... */
	write_FONTS_biff8(A, wb, opts);
	write_FMTS_biff8(A, wb.SSF, opts);
	write_CELLXFS_biff8(A, opts);
	/* ... */
	if(b8) write_biff_rec(A, "UsesELFs", writebool(false));
	var a = A.end();

	var C = buf_array();
	if(b8) write_biff_rec(C, "Country", write_Country());
	/* BIFF8: [SST *Continue] ExtSST */
	write_biff_rec(C, "EOF");
	var c = C.end();

	var B = buf_array();
	var blen = 0, j = 0;
	for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
	var start = a.length + blen + c.length;
	for(j = 0; j < wb.SheetNames.length; ++j) {
		var _sheet = _sheets[j] || ({});
		write_biff_rec(B, "BoundSheet8", write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
		start += bufs[j].length;
	}
	/* 1*BoundSheet8 */
	var b = B.end();
	if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);

	var out = [];
	if(a.length) out.push(a);
	if(b.length) out.push(b);
	if(c.length) out.push(c);
	return __toBuffer([out]);
}

/* [MS-XLS] 2.1.7.20 Workbook Stream */
function write_biff8_buf(wb, opts) {
	var o = opts || {};
	var bufs = [];

	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
		o.ssf = wb.SSF;
	}
	o.cellXfs = [];
	o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
	get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});

	for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
	bufs.unshift(write_biff8_global(wb, bufs, o));
	return __toBuffer([bufs]);
}

function write_biff_buf(wb, opts) {
	var o = opts || {};
	switch(o.biff || 2) {
		case 8: case 5: return write_biff8_buf(wb, opts);
		case 4: case 3: case 2: return write_biff2_buf(wb, opts);
	}
	throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */
var HTML_ = (function() {
	function html_to_sheet(str, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		var mtch = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2 = str.match(/<\/table/i);
		var i = mtch.index, j = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>0 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t = tag.t || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(unescapexml(m));
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) continue;
				var o = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's'){}
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || SSF._table[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function html_to_book(str, opts) {
		return sheet_to_workbook(html_to_sheet(str, opts), opts);
	}
	function make_html_row(ws, r, R, o) {
		var M = (ws['!merges'] ||[]);
		var oo = [];
		var nullcell = "<td>" + (o.editable ? '<span contenteditable="true"></span>' : "" ) + "</td>";
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			if(!cell || cell.v == null) { oo.push(nullcell); continue; }
			/* TODO: html entities */
			var w = cell.h || escapexml(cell.w || (format_cell(cell), cell.w) || "");
			var sp = {};
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			sp.t = cell.t;
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			sp.id = "sjs-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	function make_html_preamble(ws, R, o) {
		var out = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var _END = '</body></html>';
	function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
		var o = opts || {};
		var header = o.header != null ? o.header : _BEGIN;
		var footer = o.footer != null ? o.footer : _END;
		var out = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");
	}

	return {
		to_workbook: html_to_book,
		to_sheet: html_to_sheet,
		_row: make_html_row,
		BEGIN: _BEGIN,
		END: _END,
		_preamble: make_html_preamble,
		from_sheet: sheet_to_html
	};
})();

function parse_dom_table(table, _opts) {
	var opts = _opts || {};
	if(DENSE != null) opts.dense = DENSE;
	var ws = opts.dense ? ([]) : ({});
	var rows = table.getElementsByTagName('tr');
	var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
	var range = {s:{r:0,c:0},e:{r:sheetRows - 1,c:0}};
	var merges = [], midx = 0;
	var R = 0, _C = 0, C = 0, RS = 0, CS = 0;
	for(; R < sheetRows; ++R) {
		var row = rows[R];
		var elts = (row.children);
		for(_C = C = 0; _C < elts.length; ++_C) {
			var elt = elts[_C], v = htmldecode(elts[_C].innerHTML);
			for(midx = 0; midx < merges.length; ++midx) {
				var m = merges[midx];
				if(m.s.c == C && m.s.r <= R && R <= m.e.r) { C = m.e.c+1; midx = -1; }
			}
			/* TODO: figure out how to extract nonstandard mso- style */
			CS = +elt.getAttribute("colspan") || 1;
			if((RS = +elt.getAttribute("rowspan"))>0 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
			var o = {t:'s', v:v};
			var _t = elt.getAttribute("t") || "";
			if(v != null) {
				if(v.length == 0) o.t = _t || 'z';
				else if(opts.raw || v.trim().length == 0 || _t == "s"){}
				else if(v === 'TRUE') o = {t:'b', v:true};
				else if(v === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
				else if(!isNaN(fuzzydate(v).getDate())) {
					o = ({t:'d', v:parseDate(v)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || SSF._table[14];
				}
			}
			if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
			else ws[encode_cell({c:C, r:R})] = o;
			if(range.e.c < C) range.e.c = C;
			C += CS;
		}
	}
	if(merges.length) ws['!merges'] = merges;
	ws['!ref'] = encode_range(range);
	if(sheetRows < rows.length) ws['!fullref'] = encode_range((range.e.r = rows.length-1,range));
	return ws;
}

function table_to_book(table, opts) {
	return sheet_to_workbook(parse_dom_table(table, opts), opts);
}
/* OpenDocument */
var parse_content_xml = (function() {

	/* 6.1.2 White Space Characters */
	var parse_text_p = function(text) {
		return unescapexml(text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n")
			.replace(/<[^>]*>/g,"")
		);
	};

	var number_formats = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};

	return function pcx(d, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var str = xlml_normalize(d);
		var state = [], tmp;
		var tag;
		var NFtag = {name:""}, NF = "", pidx = 0;
		var sheetag;
		var rowtag;
		var Sheets = {}, SheetNames = [];
		var ws = opts.dense ? ([]) : ({});
		var Rn, q;
		var ctag = ({value:""});
		var textp = "", textpidx = 0, textptag;
		var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
		var row_ol = 0;
		var number_format_map = {};
		var merges = [], mrange = {}, mR = 0, mC = 0;
		var rowinfo = [], rowpeat = 1, colpeat = 1;
		var arrayf = [];
		var WB = {Names:[]};
		var atag = ({});
		var _Ref = ["", ""];
		var comments = [], comment = ({});
		var creator = "", creatoridx = 0;
		var isstub = false, intable = false;
		var i = 0;
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {

			case 'table': case '工作表': // 9.1.2 <table:table>
				if(Rn[1]==='/') {
					if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
					if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
						ws['!fullref'] = ws['!ref'];
						range.e.r = opts.sheetRows - 1;
						ws['!ref'] = encode_range(range);
					}
					if(merges.length) ws['!merges'] = merges;
					if(rowinfo.length) ws["!rows"] = rowinfo;
					sheetag.name = utf8read(sheetag['名称'] || sheetag.name);
					if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
					SheetNames.push(sheetag.name);
					Sheets[sheetag.name] = ws;
					intable = false;
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					sheetag = parsexmltag(Rn[0], false);
					R = C = -1;
					range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
					ws = opts.dense ? ([]) : ({}); merges = [];
					rowinfo = [];
					intable = true;
				}
				break;

			case 'table-row-group': // 9.1.9 <table:table-row-group>
				if(Rn[1] === "/") --row_ol; else ++row_ol;
				break;
			case 'table-row': case '行': // 9.1.3 <table:table-row>
				if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
				rowtag = parsexmltag(Rn[0], false);
				if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
				rowpeat = +rowtag['number-rows-repeated'] || 1;
				/* TODO: remove magic */
				if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
				C = -1; break;
			case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
				++C;
				if(opts.sheetStubs) {
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
					else ws[encode_cell({r:R,c:C})] = {t:'z'};
				}
				break; /* stub */
			case 'table-cell': case '数据':
				if(Rn[0].charAt(Rn[0].length-2) === '/') {
					++C;
					ctag = parsexmltag(Rn[0], false);
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					q = ({t:'z', v:null});
					if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
					if((ctag['数据类型'] || ctag['value-type']) == "string") {
						q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
						if(opts.dense) {
							if(!ws[R]) ws[R] = [];
							ws[R][C] = q;
						} else {
							ws[encode_cell({r:R,c:C})] = q;
						}
					}
					C+= colpeat-1;
				} else if(Rn[1]!=='/') {
					++C;
					colpeat = 1;
					var rptR = rowpeat ? R + rowpeat - 1 : R;
					if(C > range.e.c) range.e.c = C;
					if(C < range.s.c) range.s.c = C;
					if(R < range.s.r) range.s.r = R;
					if(rptR > range.e.r) range.e.r = rptR;
					ctag = parsexmltag(Rn[0], false);
					comments = []; comment = ({});
					q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
					if(opts.cellFormula) {
						if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
						if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
							mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							q.F = encode_range(mrange);
							arrayf.push([mrange, q.F]);
						}
						if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
						else for(i = 0; i < arrayf.length; ++i)
							if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
								if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
									q.F = arrayf[i][1];
					}
					if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
						mR = parseInt(ctag['number-rows-spanned'],10) || 0;
						mC = parseInt(ctag['number-columns-spanned'],10) || 0;
						mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
						merges.push(mrange);
					}

					/* 19.675.2 table:number-columns-repeated */
					if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);

					/* 19.385 office:value-type */
					switch(q.t) {
						case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
						case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
							if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
							q.z = 'm/d/yy'; break;
						case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400; break;
						case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
						default:
							if(q.t === 'string' || q.t === 'text' || !q.t) {
								q.t = 's';
								if(ctag['string-value'] != null) textp = unescapexml(ctag['string-value']);
							} else throw new Error('Unsupported value type ' + q.t);
					}
				} else {
					isstub = false;
					if(q.t === 's') {
						q.v = textp || '';
						isstub = textpidx == 0;
					}
					if(atag.Target) q.l = atag;
					if(comments.length > 0) { q.c = comments; comments = []; }
					if(textp && opts.cellText !== false) q.w = textp;
					if(!isstub || opts.sheetStubs) {
						if(!(opts.sheetRows && opts.sheetRows <= R)) {
							for(var rpt = 0; rpt < rowpeat; ++rpt) {
								colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
								if(opts.dense) {
									if(!ws[R + rpt]) ws[R + rpt] = [];
									ws[R + rpt][C] = rpt == 0 ? q : dup(q);
									while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
								} else {
									ws[encode_cell({r:R + rpt,c:C})] = q;
									while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
								}
								if(range.e.c <= C) range.e.c = C;
							}
						}
					}
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					C += colpeat-1; colpeat = 0;
					q = {};
					textp = "";
				}
				atag = ({});
				break; // 9.1.4 <table:table-cell>

			/* pure state */
			case 'document': // TODO: <office:document> is the root for FODS
			case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
			case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
			case 'scripts': // 3.12 <office:scripts>
			case 'styles': // TODO <office:styles>
			case 'font-face-decls': // 3.14 <office:font-face-decls>
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;

			case 'annotation': // 14.1 <office:annotation>
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					comment.t = textp;
					comment.a = creator;
					comments.push(comment);
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
				creator = ""; creatoridx = 0;
				textp = ""; textpidx = 0;
				break;

			case 'creator': // 4.3.2.7 <dc:creator>
				if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
				else creatoridx = Rn.index + Rn[0].length;
				break;

			/* ignore state */
			case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
			case 'settings': // TODO: <office:settings>
			case 'config-item-set': // TODO: <office:config-item-set>
			case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
			case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
			case 'config-item-map-named': // TODO: <office:config-item-map-entry>
			case 'shapes': // 9.2.8 <table:shapes>
			case 'frame': // 10.4.2 <draw:frame>
			case 'text-box': // 10.4.3 <draw:text-box>
			case 'image': // 10.4.4 <draw:image>
			case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
			case 'list-style': // 16.30 <text:list-style>
			case 'form': // 13.13 <form:form>
			case 'dde-links': // 9.8 <table:dde-links>
			case 'event-listeners': // TODO
			case 'chart': // TODO
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
				textp = ""; textpidx = 0;
				break;

			case 'scientific-number': // TODO: <number:scientific-number>
				break;
			case 'currency-symbol': // TODO: <number:currency-symbol>
				break;
			case 'currency-style': // TODO: <number:currency-style>
				break;
			case 'number-style': // 16.27.2 <number:number-style>
			case 'percentage-style': // 16.27.9 <number:percentage-style>
			case 'date-style': // 16.27.10 <number:date-style>
			case 'time-style': // 16.27.18 <number:time-style>
				if(Rn[1]==='/'){
					number_format_map[NFtag.name] = NF;
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
				} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					NF = "";
					NFtag = parsexmltag(Rn[0], false);
					state.push([Rn[3], true]);
				} break;

			case 'script': break; // 3.13 <office:script>
			case 'libraries': break; // TODO: <ooo:libraries>
			case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
			case 'master-styles': break; // TODO: <office:master-styles>

			case 'default-style': // TODO: <style:default-style>
			case 'page-layout': break; // TODO: <style:page-layout>
			case 'style': break; // 16.2 <style:style>
			case 'map': break; // 16.3 <style:map>
			case 'font-face': break; // 16.21 <style:font-face>

			case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
			case 'table-properties': break; // 17.15 <style:table-properties>
			case 'table-column-properties': break; // 17.16 <style:table-column-properties>
			case 'table-row-properties': break; // 17.17 <style:table-row-properties>
			case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>

			case 'number': // 16.27.3 <number:number>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'fraction': break; // TODO 16.27.6 <number:fraction>

			case 'day': // 16.27.11 <number:day>
			case 'month': // 16.27.12 <number:month>
			case 'year': // 16.27.13 <number:year>
			case 'era': // 16.27.14 <number:era>
			case 'day-of-week': // 16.27.15 <number:day-of-week>
			case 'week-of-year': // 16.27.16 <number:week-of-year>
			case 'quarter': // 16.27.17 <number:quarter>
			case 'hours': // 16.27.19 <number:hours>
			case 'minutes': // 16.27.20 <number:minutes>
			case 'seconds': // 16.27.21 <number:seconds>
			case 'am-pm': // 16.27.22 <number:am-pm>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'boolean-style': break; // 16.27.23 <number:boolean-style>
			case 'boolean': break; // 16.27.24 <number:boolean>
			case 'text-style': break; // 16.27.25 <number:text-style>
			case 'text': // 16.27.26 <number:text>
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") switch(state[state.length-1][0]) {
					case 'number-style':
					case 'date-style':
					case 'time-style':
						NF += str.slice(pidx, Rn.index);
						break;
				}
				else pidx = Rn.index + Rn[0].length;
				break;

			case 'named-range': // 9.4.12 <table:named-range>
				tag = parsexmltag(Rn[0], false);
				_Ref = ods_to_csf_3D(tag['cell-range-address']);
				var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
				if(intable) nrange.Sheet = SheetNames.length;
				WB.Names.push(nrange);
				break;

			case 'text-content': break; // 16.27.27 <number:text-content>
			case 'text-properties': break; // 16.27.27 <style:text-properties>
			case 'embedded-text': break; // 16.27.4 <number:embedded-text>

			case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3

			case 'forms': break; // 12.25.2 13.2
			case 'table-column': break; // 9.1.6 <table:table-column>
			case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
			case 'table-rows': break; // 9.1.12 <table:table-rows>
			/* TODO: outline levels */
			case 'table-column-group': break; // 9.1.10 <table:table-column-group>
			case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
			case 'table-columns': break; // 9.1.12 <table:table-columns>

			case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904

			case 'graphic-properties': break; // 17.21 <style:graphic-properties>
			case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
			case 'named-expressions': break; // 9.4.11 <table:named-expressions>
			case 'label-range': break; // 9.4.9 <table:label-range>
			case 'label-ranges': break; // 9.4.10 <table:label-ranges>
			case 'named-expression': break; // 9.4.13 <table:named-expression>
			case 'sort': break; // 9.4.19 <table:sort>
			case 'sort-by': break; // 9.4.20 <table:sort-by>
			case 'sort-groups': break; // 9.4.22 <table:sort-groups>

			case 'tab': break; // 6.1.4 <text:tab>
			case 'line-break': break; // 6.1.5 <text:line-break>
			case 'span': break; // 6.1.7 <text:span>
			case 'p': case '文本串': // 5.1.3 <text:p>
				if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) textp = (textp.length > 0 ? textp + "\n" : "") + parse_text_p(str.slice(textpidx,Rn.index), textptag);
				else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
				break; // <text:p>
			case 's': break; // <text:s>

			case 'database-range': // 9.4.15 <table:database-range>
				if(Rn[1]==='/') break;
				try {
					_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
					Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
				} catch(e) {/* empty */}
				break;

			case 'date': break; // <*:date>

			case 'object': break; // 10.4.6.2 <draw:object>
			case 'title': case '标题': break; // <*:title> OR <uof:标题>
			case 'desc': break; // <*:desc>
			case 'binary-data': break; // 10.4.5 TODO: b64 blob

			/* 9.2 Advanced Tables */
			case 'table-source': break; // 9.2.6
			case 'scenario': break; // 9.2.6

			case 'iteration': break; // 9.4.3 <table:iteration>
			case 'content-validations': break; // 9.4.4 <table:
			case 'content-validation': break; // 9.4.5 <table:
			case 'help-message': break; // 9.4.6 <table:
			case 'error-message': break; // 9.4.7 <table:
			case 'database-ranges': break; // 9.4.14 <table:database-ranges>
			case 'filter': break; // 9.5.2 <table:filter>
			case 'filter-and': break; // 9.5.3 <table:filter-and>
			case 'filter-or': break; // 9.5.4 <table:filter-or>
			case 'filter-condition': break; // 9.5.5 <table:filter-condition>

			case 'list-level-style-bullet': break; // 16.31 <text:
			case 'list-level-style-number': break; // 16.32 <text:
			case 'list-level-properties': break; // 17.19 <style:

			/* 7.3 Document Fields */
			case 'sender-firstname': // 7.3.6.2
			case 'sender-lastname': // 7.3.6.3
			case 'sender-initials': // 7.3.6.4
			case 'sender-title': // 7.3.6.5
			case 'sender-position': // 7.3.6.6
			case 'sender-email': // 7.3.6.7
			case 'sender-phone-private': // 7.3.6.8
			case 'sender-fax': // 7.3.6.9
			case 'sender-company': // 7.3.6.10
			case 'sender-phone-work': // 7.3.6.11
			case 'sender-street': // 7.3.6.12
			case 'sender-city': // 7.3.6.13
			case 'sender-postal-code': // 7.3.6.14
			case 'sender-country': // 7.3.6.15
			case 'sender-state-or-province': // 7.3.6.16
			case 'author-name': // 7.3.7.1
			case 'author-initials': // 7.3.7.2
			case 'chapter': // 7.3.8
			case 'file-name': // 7.3.9
			case 'template-name': // 7.3.9
			case 'sheet-name': // 7.3.9
				break;

			case 'event-listener':
				break;
			/* TODO: FODS Properties */
			case 'initial-creator':
			case 'creation-date':
			case 'print-date':
			case 'generator':
			case 'document-statistic':
			case 'user-defined':
			case 'editing-duration':
			case 'editing-cycles':
				break;

			/* TODO: FODS Config */
			case 'config-item':
				break;

			/* TODO: style tokens */
			case 'page-number': break; // TODO <text:page-number>
			case 'page-count': break; // TODO <text:page-count>
			case 'time': break; // TODO <text:time>

			/* 9.3 Advanced Table Cells */
			case 'cell-range-source': break; // 9.3.1 <table:
			case 'detective': break; // 9.3.2 <table:
			case 'operation': break; // 9.3.3 <table:
			case 'highlighted-range': break; // 9.3.4 <table:

			/* 9.6 Data Pilot Tables <table: */
			case 'data-pilot-table': // 9.6.3
			case 'source-cell-range': // 9.6.5
			case 'source-service': // 9.6.6
			case 'data-pilot-field': // 9.6.7
			case 'data-pilot-level': // 9.6.8
			case 'data-pilot-subtotals': // 9.6.9
			case 'data-pilot-subtotal': // 9.6.10
			case 'data-pilot-members': // 9.6.11
			case 'data-pilot-member': // 9.6.12
			case 'data-pilot-display-info': // 9.6.13
			case 'data-pilot-sort-info': // 9.6.14
			case 'data-pilot-layout-info': // 9.6.15
			case 'data-pilot-field-reference': // 9.6.16
			case 'data-pilot-groups': // 9.6.17
			case 'data-pilot-group': // 9.6.18
			case 'data-pilot-group-member': // 9.6.19
				break;

			/* 10.3 Drawing Shapes */
			case 'rect': // 10.3.2
				break;

			/* 14.6 DDE Connections */
			case 'dde-connection-decls': // 14.6.2 <text:
			case 'dde-connection-decl': // 14.6.3 <text:
			case 'dde-link': // 14.6.4 <table:
			case 'dde-source': // 14.6.5 <office:
				break;

			case 'properties': break; // 13.7 <form:properties>
			case 'property': break; // 13.8 <form:property>

			case 'a': // 6.1.8 hyperlink
				if(Rn[1]!== '/') {
					atag = parsexmltag(Rn[0], false);
					if(!atag.href) break;
					atag.Target = atag.href; delete atag.href;
					if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
						_Ref = ods_to_csf_3D(atag.Target.slice(1));
						atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
					}
				}
				break;

			/* non-standard */
			case 'table-protection': break;
			case 'data-pilot-grand-total': break; // <table:
			case 'office-document-common-attrs': break; // bare
			default: switch(Rn[2]) {
				case 'dc:':       // TODO: properties
				case 'calcext:':  // ignore undocumented extensions
				case 'loext:':    // ignore undocumented extensions
				case 'ooo:':      // ignore undocumented extensions
				case 'chartooo:': // ignore undocumented extensions
				case 'draw:':     // TODO: drawing
				case 'style:':    // TODO: styles
				case 'chart:':    // TODO: charts
				case 'form:':     // TODO: forms
				case 'uof:':      // TODO: uof
				case '表:':       // TODO: uof
				case '字:':       // TODO: uof
					break;
				default: if(opts.WTF) throw new Error(Rn);
			}
		}
		var out = ({
			Sheets: Sheets,
			SheetNames: SheetNames,
			Workbook: WB
		});
		if(opts.bookSheets) delete out.Sheets;
		return out;
	};
})();

function parse_ods(zip, opts) {
	opts = opts || ({});
	var ods = !!safegetzipfile(zip, 'objectdata');
	if(ods) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
	var content = getzipstr(zip, 'content.xml');
	if(!content) throw new Error("Missing content.xml in " + (ods ? "ODS" : "UOF")+ " file");
	var wb = parse_content_xml(ods ? content : utf8read(content), opts);
	if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
	return wb;
}
function parse_fods(data, opts) {
	return parse_content_xml(data, opts);
}

/* OpenDocument */
var write_styles_ods = (function() {
	var payload = '<office:document-styles ' + wxt_helper({
		'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
		'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
		'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
		'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
		'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
		'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
		'xmlns:xlink':    "http://www.w3.org/1999/xlink",
		'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
		'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
		'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
		'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
		'office:version': "1.2"
	}) + '></office:document-styles>';
	return function wso() {
		return XML_HEADER + payload;
	};
})();
var write_content_ods = (function() {
	/* 6.1.2 White Space Characters */
	var write_text_p = function(text) {
		return escapexml(text)
			.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
			.replace(/\t/g, "<text:tab/>")
			.replace(/\n/g, "<text:line-break/>")
			.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
	};

	var null_cell_xml = '          <table:table-cell />\n';
	var covered_cell_xml = '          <table:covered-table-cell/>\n';
	var write_ws = function(ws, wb, i) {
		/* Section 9 Tables */
		var o = [];
		o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '">\n');
		var R=0,C=0, range = decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var dense = Array.isArray(ws);
		for(R = 0; R < range.s.r; ++R) o.push('        <table:table-row></table:table-row>\n');
		for(; R <= range.e.r; ++R) {
			o.push('        <table:table-row>\n');
			for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
			for(; C <= range.e.c; ++C) {
				var skip = false, ct = {}, textp = "";
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
					ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
					break;
				}
				if(skip) { o.push(covered_cell_xml); continue; }
				var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(cell && cell.f) {
					ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
					if(cell.F) {
						if(cell.F.slice(0, ref.length) == ref) {
							var _Fref = decode_range(cell.F);
							ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
							ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
						}
					}
				}
				if(!cell) { o.push(null_cell_xml); continue; }
				switch(cell.t) {
					case 'b':
						textp = (cell.v ? 'TRUE' : 'FALSE');
						ct['office:value-type'] = "boolean";
						ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
						break;
					case 'n':
						textp = (cell.w||String(cell.v||0));
						ct['office:value-type'] = "float";
						ct['office:value'] = (cell.v||0);
						break;
					case 's': case 'str':
						textp = cell.v;
						ct['office:value-type'] = "string";
						break;
					case 'd':
						textp = (cell.w||(parseDate(cell.v).toISOString()));
						ct['office:value-type'] = "date";
						ct['office:date-value'] = (parseDate(cell.v).toISOString());
						ct['table:style-name'] = "ce1";
						break;
					//case 'e':
					default: o.push(null_cell_xml); continue;
				}
				var text_p = write_text_p(textp);
				if(cell.l && cell.l.Target) {
					var _tgt = cell.l.Target; _tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
					text_p = writextag('text:a', text_p, {'xlink:href': _tgt});
				}
				o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
			}
			o.push('        </table:table-row>\n');
		}
		o.push('      </table:table>\n');
		return o.join("");
	};

	var write_automatic_styles_ods = function(o) {
		o.push(' <office:automatic-styles>\n');
		o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
		o.push('   <number:month number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:day number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:year/>\n');
		o.push('  </number:date-style>\n');
		o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
		o.push(' </office:automatic-styles>\n');
	};

	return function wcx(wb, opts) {
		var o = [XML_HEADER];
		/* 3.1.3.2 */
		var attr = wxt_helper({
			'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':        "http://www.w3.org/1999/xlink",
			'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
			'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
			'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
			'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
			'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
			'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
			'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
			'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
			'xmlns:ooo':          "http://openoffice.org/2004/office",
			'xmlns:ooow':         "http://openoffice.org/2004/writer",
			'xmlns:oooc':         "http://openoffice.org/2004/calc",
			'xmlns:dom':          "http://www.w3.org/2001/xml-events",
			'xmlns:xforms':       "http://www.w3.org/2002/xforms",
			'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
			'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
			'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
			'xmlns:rpt':          "http://openoffice.org/2005/report",
			'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
			'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
			'xmlns:tableooo':     "http://openoffice.org/2009/table",
			'xmlns:drawooo':      "http://openoffice.org/2010/draw",
			'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
			'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
			'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
			'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
			'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
			'office:version':     "1.2"
		});

		var fods = wxt_helper({
			'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
			'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
		});

		if(opts.bookType == "fods") o.push('<office:document' + attr + fods + '>\n');
		else o.push('<office:document-content' + attr  + '>\n');
		write_automatic_styles_ods(o);
		o.push('  <office:body>\n');
		o.push('    <office:spreadsheet>\n');
		for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
		o.push('    </office:spreadsheet>\n');
		o.push('  </office:body>\n');
		if(opts.bookType == "fods") o.push('</office:document>');
		else o.push('</office:document-content>');
		return o.join("");
	};
})();

function write_ods(wb, opts) {
	if(opts.bookType == "fods") return write_content_ods(wb, opts);

var zip = new jszip();
	var f = "";

	var manifest = [];
	var rdf = [];

	/* Part 3 Section 3.3 MIME Media Type */
	f = "mimetype";
	zip.file(f, "application/vnd.oasis.opendocument.spreadsheet");

	/* Part 1 Section 2.2 Documents */
	f = "content.xml";
	zip.file(f, write_content_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "ContentFile"]);

	/* TODO: these are hard-coded styles to satiate excel */
	f = "styles.xml";
	zip.file(f, write_styles_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "StylesFile"]);

	/* TODO: this is hard-coded to satiate excel */
	f = "meta.xml";
	zip.file(f, write_meta_ods());
	manifest.push([f, "text/xml"]);
	rdf.push([f, "MetadataFile"]);

	/* Part 3 Section 6 Metadata Manifest File */
	f = "manifest.rdf";
	zip.file(f, write_rdf(rdf/*, opts*/));
	manifest.push([f, "application/rdf+xml"]);

	/* Part 3 Section 4 Manifest File */
	f = "META-INF/manifest.xml";
	zip.file(f, write_manifest(manifest/*, opts*/));

	return zip;
}

function write_sheet_index(wb, sheet) {
	if(!sheet) return 0;
	var idx = wb.SheetNames.indexOf(sheet);
	if(idx == -1) throw new Error("Sheet not found: " + sheet);
	return idx;
}

function write_obj_str(factory) {
	return function write_str(wb, o) {
		var idx = write_sheet_index(wb, o.sheet);
		return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
	};
}

var write_htm_str = write_obj_str(HTML_);
var write_csv_str = write_obj_str({from_sheet:sheet_to_csv});
var write_slk_str = write_obj_str(SYLK);
var write_dif_str = write_obj_str(DIF);
var write_prn_str = write_obj_str(PRN);
var write_rtf_str = write_obj_str(RTF);
var write_txt_str = write_obj_str({from_sheet:sheet_to_txt});
var write_dbf_buf = write_obj_str(DBF);
var write_eth_str = write_obj_str(ETH);

function fix_opts_func(defaults) {
	return function fix_opts(opts) {
		for(var i = 0; i != defaults.length; ++i) {
			var d = defaults[i];
			if(opts[d[0]] === undefined) opts[d[0]] = d[1];
			if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
		}
	};
}

var fix_read_opts = fix_opts_func([
	['cellNF', false], /* emit cell number format string as .z */
	['cellHTML', true], /* emit html string as .h */
	['cellFormula', true], /* emit formulae as .f */
	['cellStyles', false], /* emits style/theme as .s */
	['cellText', true], /* emit formatted text as .w */
	['cellDates', false], /* emit date cells with type `d` */

	['sheetStubs', false], /* emit empty cells */
	['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */

	['bookDeps', false], /* parse calculation chains */
	['bookSheets', false], /* only try to get sheet names (no Sheets) */
	['bookProps', false], /* only try to get properties (no Sheets) */
	['bookFiles', false], /* include raw file structure (keys, files, cfb) */
	['bookVBA', false], /* include vba raw data (vbaraw) */

	['password',''], /* password */
	['WTF', false] /* WTF mode (throws errors) */
]);


var fix_write_opts = fix_opts_func([
	['cellDates', false], /* write date cells with type `d` */

	['bookSST', false], /* Generate Shared String Table */

	['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */

	['compression', false], /* Use file compression */

	['WTF', false] /* WTF mode (throws errors) */
]);
function get_sheet_type(n) {
	if(RELS.WS.indexOf(n) > -1) return "sheet";
	if(RELS.CS && n == RELS.CS) return "chart";
	if(RELS.DS && n == RELS.DS) return "dialog";
	if(RELS.MS && n == RELS.MS) return "macro";
	return (n && n.length) ? n : "sheet";
}
function safe_parse_wbrels(wbrels, sheets) {
	if(!wbrels) return 0;
	try {
		wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
	} catch(e) { return null; }
	return !wbrels || wbrels.length === 0 ? null : wbrels;
}

function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
	try {
		sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
		var data = getzipdata(zip, path);
		switch(stype) {
			case 'sheet': sheets[sheet]=parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'chart':
				var cs = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
				sheets[sheet] = cs;
				if(!cs || !cs['!chart']) break;
				var dfile = resolve_path(cs['!chart'].Target, path);
				var drelsp = get_rels_path(dfile);
				var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
				var chartp = resolve_path(draw, dfile);
				var crelsp = get_rels_path(chartp);
				cs = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, cs);
				break;
			case 'macro': sheets[sheet]=parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'dialog': sheets[sheet]=parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
		}
	} catch(e) { if(opts.WTF) throw e; }
}

function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }

function parse_zip(zip, opts) {
	make_ssf(SSF);
	opts = opts || {};
	fix_read_opts(opts);

	/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
	/* UOC */
	if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
	/* Numbers */
	if(safegetzipfile(zip, 'Index/Document.iwa')) throw new Error('Unsupported NUMBERS file');

	var entries = zipentries(zip);
	var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
	var xlsb = false;
	var sheets, binname;
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.xml";
		if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
	}
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.bin";
		if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
		dir.workbooks.push(binname);
		xlsb = true;
	}
	if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;

	var themes = ({});
	var styles = ({});
	if(!opts.bookSheets && !opts.bookProps) {
		strs = [];
		if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }

		if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);

		if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
	}

	/*var externbooks = */dir.links.map(function(link) {
		return parse_xlink(getzipdata(zip, strip_front_slash(link)), link, opts);
	});

	var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);

	var props = {}, propdata = "";

	if(dir.coreprops.length) {
		propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
		if(propdata) props = parse_core_props(propdata);
		if(dir.extprops.length !== 0) {
			propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
			if(propdata) parse_ext_props(propdata, props, opts);
		}
	}

	var custprops = {};
	if(!opts.bookSheets || opts.bookProps) {
		if (dir.custprops.length !== 0) {
			propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
			if(propdata) custprops = parse_cust_props(propdata, opts);
		}
	}

	var out = ({});
	if(opts.bookSheets || opts.bookProps) {
		if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
		else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
		if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
		if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
		if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
	}
	sheets = {};

	var deps = {};
	if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);

	var i=0;
	var sheetRels = ({});
	var path, relsPath;

	{
		var wbsheets = wb.Sheets;
		props.Worksheets = wbsheets.length;
		props.SheetNames = [];
		for(var j = 0; j != wbsheets.length; ++j) {
			props.SheetNames[j] = wbsheets[j].name;
		}
	}

	var wbext = xlsb ? "bin" : "xml";
	var wbrelsi = dir.workbooks[0].lastIndexOf("/");
	var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
	if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
	var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
	if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);

	/* Numbers iOS hack */
	var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
	for(i = 0; i != props.Worksheets; ++i) {
		var stype = "sheet";
		if(wbrels && wbrels[i]) {
			path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
			if(!safegetzipfile(zip, path)) path = wbrels[i][1];
			if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
			stype = wbrels[i][2];
		} else {
			path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
			path = path.replace(/sheet0\./,"sheet.");
		}
		relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
		safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
	}

	if(dir.comments) parse_comments(zip, dir.comments, sheets, sheetRels, opts);

	out = ({
		Directory: dir,
		Workbook: wb,
		Props: props,
		Custprops: custprops,
		Deps: deps,
		Sheets: sheets,
		SheetNames: props.SheetNames,
		Strings: strs,
		Styles: styles,
		Themes: themes,
		SSF: SSF.get_table()
	});
	if(opts.bookFiles) {
		out.keys = entries;
		out.files = zip.files;
	}
	if(opts.bookVBA) {
		if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
		else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
	}
	return out;
}

/* [MS-OFFCRYPTO] 2.1.1 */
function parse_xlsxcfb(cfb, _opts) {
	var opts = _opts || {};
	var f = '/!DataSpaces/Version';
	var data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var version = */parse_DataSpaceVersionInfo(data.content);

	/* 2.3.4.1 */
	f = '/!DataSpaces/DataSpaceMap';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var dsm = parse_DataSpaceMap(data.content);
	if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.2 */
	f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var seds = parse_DataSpaceDefinition(data.content);
	if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.3 */
	f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var hdr = */parse_Primary(data.content);

	f = '/EncryptionInfo';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var einfo = parse_EncryptionInfo(data.content);

	/* 2.3.4.4 */
	f = '/EncryptedPackage';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);

/*global decrypt_agile */
if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
/*global decrypt_std76 */
if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
	throw new Error("File is password-protected");
}

function write_zip(wb, opts) {
	_shapeid = 1024;
	if(opts.bookType == "ods") return write_ods(wb, opts);
	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
var zip = new jszip();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip.file(f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames){/* empty */}
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip.file(f, write_ext_props(wb.Props, opts));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip.file(f, write_cust_props(wb.Custprops, opts));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	f = "xl/workbook." + wbext;
	zip.file(f, write_wb(wb, f, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart": /*
			f = "xl/chartsheets/sheet" + rId + "." + wbext;
			zip.file(f, write_cs(rId-1, f, opts, wb, wsrels));
			ct.charts.push(f);
			add_rels(wsrels, -1, "chartsheets/sheet" + rId + "." + wbext, RELS.CS);
			break; */
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip.file(f, write_ws(rId-1, f, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			if(comments && comments.length > 0) {
				var cf = "xl/comments" + rId + "." + wbext;
				zip.file(cf, write_cmnt(comments, cf, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
			}
			if(ws['!legacy']) {
				zip.file("xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip.file(get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip.file(f, write_sst(opts.Strings, f, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip.file(f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip.file(f, write_sty(wb, f, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip.file(f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	zip.file("[Content_Types].xml", write_ct(ct, opts));
	zip.file('_rels/.rels', write_rels(opts.rels));
	zip.file('xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}
function firstbyte(f,o) {
	var x = "";
	switch((o||{}).type || "base64") {
		case 'buffer': return [f[0], f[1], f[2], f[3]];
		case 'base64': x = Base64.decode(f.slice(0,24)); break;
		case 'binary': x = f; break;
		case 'array':  return [f[0], f[1], f[2], f[3]];
		default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
	}
	return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3)];
}

function read_cfb(cfb, opts) {
	if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
	return parse_xlscfb(cfb, opts);
}

function read_zip(data, opts) {
var zip, d = data;
	var o = opts||{};
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	switch(o.type) {
		case "base64": zip = new jszip(d, { base64:true }); break;
		case "binary": case "array": zip = new jszip(d, { base64:false }); break;
		case "buffer": zip = new jszip(d); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	return parse_zip(zip, o);
}

function read_plaintext(data, o) {
	var i = 0;
	main: while(i < data.length) switch(data.charCodeAt(i)) {
		case 0x0A: case 0x0D: case 0x20: ++i; break;
		case 0x3C: return parse_xlml(data.slice(i),o);
		default: break main;
	}
	return PRN.to_workbook(data, o);
}

function read_plaintext_raw(data, o) {
	var str = "", bytes = firstbyte(data, o);
	switch(o.type) {
		case 'base64': str = Base64.decode(data); break;
		case 'binary': str = data; break;
		case 'buffer': str = data.toString('binary'); break;
		case 'array': str = cc2str(data); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
	return read_plaintext(str, o);
}

function read_utf16(data, o) {
	var d = data;
	if(o.type == 'base64') d = Base64.decode(d);
	d = cptable.utils.decode(1200, d.slice(2), 'str');
	o.type = "binary";
	return read_plaintext(d, o);
}

function bstrify(data) {
	return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
}

function read_prn(data, d, o, str) {
	if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
	return PRN.to_workbook(d, o);
}

function readSync(data, opts) {
	reset_cp();
	if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), opts);
	var d = data, n = [0,0,0,0], str = false;
	var o = opts||{};
	_ssfopts = {};
	if(o.dateNF) _ssfopts.dateNF = o.dateNF;
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); }
	if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
	if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
		// $FlowIgnore
		var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
		// $FlowIgnore
		if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
	}
	switch((n = firstbyte(d, o))[0]) {
		case 0xD0: return read_cfb(CFB.read(d, o), o);
		case 0x09: return parse_xlscfb(d, o);
		case 0x3C: return parse_xlml(d, o);
		case 0x49: if(n[1] === 0x44) return read_wb_ID(d, o); break;
		case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
		case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
		case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
		case 0xFF: if(n[1] === 0xFE) { return read_utf16(d, o); } break;
		case 0x00: if(n[1] === 0x00 && n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o); break;
		case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
		case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
		case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
	}
	if(n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
	return read_prn(data, d, o, str);
}

function readFileSync(filename, opts) {
	var o = opts||{}; o.type = 'file';
	return readSync(filename, o);
}
function write_zip_type(wb, opts) {
	var o = opts||{};
	var z = write_zip(wb, o);
	var oopts = {};
	if(o.compression) oopts.compression = 'DEFLATE';
	switch(o.type) {
		case "base64": oopts.type = "base64"; break;
		case "binary": oopts.type = "string"; break;
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		case "buffer":
		case "file": oopts.type = has_buf ? "nodebuffer" : "string"; break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	if(o.type === "file") return write_dl(o.file, z.generate(oopts));
	var out = z.generate(oopts);
	return o.type == "string" ? utf8read(out) : out;
}

function write_cfb_type(wb, opts) {
	var o = opts||{};
	var cfb = write_xlscfb(wb, o);
	switch(o.type) {
		case "base64": case "binary": break;
		case "buffer": case "array": o.type = ""; break;
		case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		default: throw new Error("Unrecognized type " + o.type);
	}
	return CFB.write(cfb, o);
}

function write_string_type(out, opts, bom) {
	if(!bom) bom = "";
	var o = bom + out;
	switch(opts.type) {
		case "base64": return Base64.encode(utf8write(o));
		case "binary": return utf8write(o);
		case "string": return out;
		case "file": return write_dl(opts.file, o, 'utf8');
		case "buffer": {
			if(has_buf) return Buffer.from(o, 'utf8');
			else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

function write_stxt_type(out, opts) {
	switch(opts.type) {
		case "base64": return Base64.encode(out);
		case "binary": return out;
		case "string": return out; /* override in sheet_to_txt */
		case "file": return write_dl(opts.file, out, 'binary');
		case "buffer": {
			if(has_buf) return Buffer.from(out, 'binary');
			else return out.split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

/* TODO: test consistency */
function write_binary_type(out, opts) {
	switch(opts.type) {
		case "string":
		case "base64":
		case "binary":
			var bstr = "";
			// $FlowIgnore
			for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
			return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
		case "file": return write_dl(opts.file, out);
		case "buffer": return out;
		default: throw new Error("Unrecognized type " + opts.type);
	}
}

function writeSync(wb, opts) {
	check_wb(wb);
	var o = opts||{};
	if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
	switch(o.bookType || 'xlsb') {
		case 'xml':
		case 'xlml': return write_string_type(write_xlml(wb, o), o);
		case 'slk':
		case 'sylk': return write_string_type(write_slk_str(wb, o), o);
		case 'htm':
		case 'html': return write_string_type(write_htm_str(wb, o), o);
		case 'txt': return write_stxt_type(write_txt_str(wb, o), o);
		case 'csv': return write_string_type(write_csv_str(wb, o), o, "\ufeff");
		case 'dif': return write_string_type(write_dif_str(wb, o), o);
		case 'dbf': return write_binary_type(write_dbf_buf(wb, o), o);
		case 'prn': return write_string_type(write_prn_str(wb, o), o);
		case 'rtf': return write_string_type(write_rtf_str(wb, o), o);
		case 'eth': return write_string_type(write_eth_str(wb, o), o);
		case 'fods': return write_string_type(write_ods(wb, o), o);
		case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
		case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
		case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
		case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
		case 'biff8':
		case 'xla':
		case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
		case 'xlsx':
		case 'xlsm':
		case 'xlam':
		case 'xlsb':
		case 'ods': return write_zip_type(wb, o);
		default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
	}
}

function resolve_book_type(o) {
	if(o.bookType) return;
	var _BT = {
		"xls": "biff8",
		"htm": "html",
		"slk": "sylk",
		"socialcalc": "eth",
		"Sh33tJS": "WTF"
	};
	var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
	if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
	o.bookType = _BT[o.bookType] || o.bookType;
}

function writeFileSync(wb, filename, opts) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSync(wb, o);
}

function writeFileAsync(filename, wb, opts, cb) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	o.type = 'buffer';
	var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
	return _fs.writeFile(filename, writeSync(wb, o), _cb);
}
function sheet_to_json(sheet, opts) {
	if(sheet == null || sheet["!ref"] == null) return [];
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], isempty = true, v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var raw = o.raw;
	var defval = o.defval;
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols = [];
	var out = [];
	var outi = 0, counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0, CC = 0;
	if(dense && !sheet[R]) sheet[R] = [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = 0;
				for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
				hdr[C] = vv;
		}
	}
	var row = (header === 1) ? [] : {};
	for (R = r.s.r + offset; R <= r.e.r; ++R) {
		rr = encode_row(R);
		isempty = true;
		if(header === 1) row = [];
		else {
			row = {};
			if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
			else row.__rowNum__ = R;
		}
		if(!dense || sheet[R]) for (C = r.s.c; C <= r.e.c; ++C) {
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			if(val === undefined || val.t === undefined) {
				if(defval === undefined) continue;
				if(hdr[C] != null) { row[hdr[C]] = defval; }
				continue;
			}
			v = val.v;
			switch(val.t){
				case 'z': if(v == null) break; continue;
				case 'e': v = void 0; break;
				case 's': case 'd': case 'b': case 'n': break;
				default: throw new Error('unrecognized type ' + val.t);
			}
			if(hdr[C] != null) {
				if(v == null) {
					if(defval !== undefined) row[hdr[C]] = defval;
					else if(raw && v === null) row[hdr[C]] = null;
					else continue;
				} else {
					row[hdr[C]] = raw ? v : format_cell(val,v,o);
				}
				if(v != null) isempty = false;
			}
		}
		if((isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row;
	}
	out.length = outi;
	return out;
}

var qreg = /"/g;
function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
	var isempty = true;
	var row = [], txt = "", rr = encode_row(R);
	for(var C = r.s.c; C <= r.e.c; ++C) {
		if (!cols[C]) continue;
		var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
		if(val == null) txt = "";
		else if(val.v != null) {
			isempty = false;
			txt = ''+format_cell(val, null, o);
			for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
			if(txt == "ID") txt = '"ID"';
		} else if(val.f != null && !val.F) {
			isempty = false;
			txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
		} else txt = "";
		/* NOTE: Excel CSV does not support array formulae */
		row.push(txt);
	}
	if(o.blankrows === false && isempty) return null;
	return row.join(FS);
}

function sheet_to_csv(sheet, opts) {
	var out = [];
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) return "";
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row = "", cols = [];
	o.dense = Array.isArray(sheet);
	var colinfo = o.skipHidden && sheet["!cols"] || [];
	var rowinfo = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
		if(row == null) { continue; }
		if(o.strip) row = row.replace(endregex,"");
		out.push(row + RS);
	}
	delete o.dense;
	return out.join("");
}

function sheet_to_txt(sheet, opts) {
	if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
	var s = sheet_to_csv(sheet, opts);
	if(typeof cptable == 'undefined' || opts.type == 'string') return s;
	var o = cptable.utils.encode(1200, s, 'str');
	return String.fromCharCode(255) + String.fromCharCode(254) + o;
}

function sheet_to_formulae(sheet) {
	var y = "", x, val="";
	if(sheet == null || sheet["!ref"] == null) return [];
	var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
	var cmds = [];
	var dense = Array.isArray(sheet);
	for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		rr = encode_row(R);
		for(C = r.s.c; C <= r.e.c; ++C) {
			y = cols[C] + rr;
			x = dense ? (sheet[R]||[])[C] : sheet[y];
			val = "";
			if(x === undefined) continue;
			else if(x.F != null) {
				y = x.F;
				if(!x.f) continue;
				val = x.f;
				if(y.indexOf(":") == -1) y = y + ":" + y;
			}
			if(x.f != null) val = x.f;
			else if(x.t == 'z') continue;
			else if(x.t == 'n' && x.v != null) val = "" + x.v;
			else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
			else if(x.w !== undefined) val = "'" + x.w;
			else if(x.v === undefined) continue;
			else if(x.t == 's') val = "'" + x.v;
			else val = ""+x.v;
			cmds[cmds.length] = y + "=" + val;
		}
	}
	return cmds;
}

function sheet_add_json(_ws, js, opts) {
	var o = opts || {};
	var offset = +!o.skipHeader;
	var ws = _ws || ({});
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var cell;
	var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) { _R = range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
	}
	var hdr = o.header || [], C = 0;

	js.forEach(function (JS, R) {
		keys(JS).forEach(function(k) {
			if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
			var v = JS[k];
			var t = 'z';
			var z = "";
			if(typeof v == 'number') t = 'n';
			else if(typeof v == 'boolean') t = 'b';
			else if(typeof v == 'string') t = 's';
			else if(v instanceof Date) {
				t = 'd';
				if(!o.cellDates) { t = 'n'; v = datenum(v); }
				z = o.dateNF || SSF._table[14];
			}
			ws[encode_cell({c:_C + C,r:_R + R + offset})] = cell = ({t:t, v:v});
			if(z) cell.z = z;
		});
	});
	range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
	var __R = encode_row(_R);
	if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
	ws['!ref'] = encode_range(range);
	return ws;
}
function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }

var utils = {
	encode_col: encode_col,
	encode_row: encode_row,
	encode_cell: encode_cell,
	encode_range: encode_range,
	decode_col: decode_col,
	decode_row: decode_row,
	split_cell: split_cell,
	decode_cell: decode_cell,
	decode_range: decode_range,
	format_cell: format_cell,
	get_formulae: sheet_to_formulae,
	make_csv: sheet_to_csv,
	make_json: sheet_to_json,
	make_formulae: sheet_to_formulae,
	sheet_add_aoa: sheet_add_aoa,
	sheet_add_json: sheet_add_json,
	aoa_to_sheet: aoa_to_sheet,
	json_to_sheet: json_to_sheet,
	table_to_sheet: parse_dom_table,
	table_to_book: table_to_book,
	sheet_to_csv: sheet_to_csv,
	sheet_to_txt: sheet_to_txt,
	sheet_to_json: sheet_to_json,
	sheet_to_html: HTML_.from_sheet,
	sheet_to_dif: DIF.from_sheet,
	sheet_to_slk: SYLK.from_sheet,
	sheet_to_eth: ETH.from_sheet,
	sheet_to_formulae: sheet_to_formulae,
	sheet_to_row_object_array: sheet_to_json
};

(function(utils) {
utils.consts = utils.consts || {};
function add_consts(R/*Array<any>*/) { R.forEach(function(a){ utils.consts[a[0]] = a[1]; }); }

function get_default(x, y, z) { return x[y] != null ? x[y] : (x[y] = z); }

/* get cell, creating a stub if necessary */
function ws_get_cell_stub(ws, R, C) {
	/* A1 cell address */
	if(typeof R == "string") return ws[R] || (ws[R] = {t:'z'});
	/* cell address object */
	if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
	/* R and C are 0-based indices */
	return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
}

/* find sheet index for given name / validate index */
function wb_sheet_idx(wb, sh) {
	if(typeof sh == "number") {
		if(sh >= 0 && wb.SheetNames.length > sh) return sh;
		throw new Error("Cannot find sheet # " + sh);
	} else if(typeof sh == "string") {
		var idx = wb.SheetNames.indexOf(sh);
		if(idx > -1) return idx;
		throw new Error("Cannot find sheet name |" + sh + "|");
	} else throw new Error("Cannot find sheet |" + sh + "|");
}

/* simple blank workbook object */
utils.book_new = function() {
	return { SheetNames: [], Sheets: {} };
};

/* add a worksheet to the end of a given workbook */
utils.book_append_sheet = function(wb, ws, name) {
	if(!name) for(var i = 1; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
	if(!name) throw new Error("Too many worksheets");
	check_ws_name(name);
	if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");

	wb.SheetNames.push(name);
	wb.Sheets[name] = ws;
};

/* set sheet visibility (visible/hidden/very hidden) */
utils.book_set_sheet_visibility = function(wb, sh, vis) {
	get_default(wb,"Workbook",{});
	get_default(wb.Workbook,"Sheets",[]);

	var idx = wb_sheet_idx(wb, sh);
	// $FlowIgnore
	get_default(wb.Workbook.Sheets,idx, {});

	switch(vis) {
		case 0: case 1: case 2: break;
		default: throw new Error("Bad sheet visibility setting " + vis);
	}
	// $FlowIgnore
	wb.Workbook.Sheets[idx].Hidden = vis;
};
add_consts([
	["SHEET_VISIBLE", 0],
	["SHEET_HIDDEN", 1],
	["SHEET_VERY_HIDDEN", 2]
]);

/* set number format */
utils.cell_set_number_format = function(cell, fmt) {
	cell.z = fmt;
	return cell;
};

/* set cell hyperlink */
utils.cell_set_hyperlink = function(cell, target, tooltip) {
	if(!target) {
		delete cell.l;
	} else {
		cell.l = ({ Target: target });
		if(tooltip) cell.l.Tooltip = tooltip;
	}
	return cell;
};
utils.cell_set_internal_link = function(cell, range, tooltip) { return utils.cell_set_hyperlink(cell, "#" + range, tooltip); };

/* add to cell comments */
utils.cell_add_comment = function(cell, text, author) {
	if(!cell.c) cell.c = [];
	cell.c.push({t:text, a:author||"SheetJS"});
};

/* set array formula and flush related cells */
utils.sheet_set_array_formula = function(ws, range, formula) {
	var rng = typeof range != "string" ? range : safe_decode_range(range);
	var rngstr = typeof range == "string" ? range : encode_range(range);
	for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
		var cell = ws_get_cell_stub(ws, R, C);
		cell.t = 'n';
		cell.F = rngstr;
		delete cell.v;
		if(R == rng.s.r && C == rng.s.c) cell.f = formula;
	}
	return ws;
};

return utils;
})(utils);

if(has_buf && "function" != 'undefined') (function() {
	var Readable = __webpack_require__(3401).Readable;

	var write_csv_stream = function(sheet, opts) {
		var stream = Readable();
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var R = r.s.r;
		var BOM = false;
		stream._read = function() {
			if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
			if(R > r.e.r) return stream.push(null);
			while(R <= r.e.r) {
				++R;
				if ((rowinfo[R-1]||{}).hidden) continue;
				row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
				if(row != null) {
					if(o.strip) row = row.replace(endregex,"");
					stream.push(row + RS);
					break;
				}
			}
		};
		return stream;
	};

	var write_html_stream = function(ws, opts) {
		var stream = Readable();

		var o = opts || {};
		var header = o.header != null ? o.header : HTML_.BEGIN;
		var footer = o.footer != null ? o.footer : HTML_.END;
		stream.push(header);
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		stream.push(HTML_._preamble(ws, r, o));
		var R = r.s.r;
		var end = false;
		stream._read = function() {
			if(R > r.e.r) {
				if(!end) { end = true; stream.push("</table>" + footer); }
				return stream.push(null);
			}
			while(R <= r.e.r) {
				stream.push(HTML_._row(ws, r, R, o));
				++R;
				break;
			}
		};
		return stream;
	};

	XLSX.stream = {
		to_html: write_html_stream,
		to_csv: write_csv_stream
	};
})();

XLSX.parse_xlscfb = parse_xlscfb;
XLSX.parse_ods = parse_ods;
XLSX.parse_fods = parse_fods;
XLSX.write_ods = write_ods;
XLSX.parse_zip = parse_zip;
XLSX.read = readSync; //xlsread
XLSX.readFile = readFileSync; //readFile
XLSX.readFileSync = readFileSync;
XLSX.write = writeSync;
XLSX.writeFile = writeFileSync;
XLSX.writeFileSync = writeFileSync;
XLSX.writeFileAsync = writeFileAsync;
XLSX.utils = utils;
XLSX.SSF = SSF;
XLSX.CFB = CFB;
})( true ? exports : XLSX);
/*exported XLS, ODS */
var XLS = XLSX, ODS = XLSX;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80), __webpack_require__(228).Buffer, __webpack_require__(253)))

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W100 */
var cptable = {version:"1.13.0"};
cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[932] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
return {"enc": e, "dec": d }; })();
cptable[936] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
return {"enc": e, "dec": d }; })();
cptable[949] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
return {"enc": e, "dec": d }; })();
cptable[950] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
return {"enc": e, "dec": d }; })();
cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
return {"enc": e, "dec": d }; })();
cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
// eslint-disable-next-line no-undef
if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
/* cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ft=javascript: */
/*jshint newcap: false */
(function(root, factory) {
  /*jshint ignore:start */
  /*eslint-disable */
  "use strict";
  if(typeof cptable === "undefined") {
    if(true){
      var cpt = cptable;
      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
      else root.cptable = factory(cpt);
    } else throw new Error("cptable not found");
  } else cptable = factory(cptable);
  /*eslint-enable */
  /*jshint ignore:end */
}(this, function(cpt){
  "use strict";
  /*global module, Buffer */
  var magic = {
    "1200":"utf16le",
    "1201":"utf16be",
    "12000":"utf32le",
    "12001":"utf32be",
    "16969":"utf64le",
    "20127":"ascii",
    "65000":"utf7",
    "65001":"utf8"
  };

  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
  var dbcs_cache = [932,936,949,950];
  var magic_cache = [65001];
  var magic_decode = {};
  var magic_encode = {};
  var cpdcache = {};
  var cpecache = {};

  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
  var cca = function cca(x) { return x.charCodeAt(0); };

  var has_buf = (typeof Buffer !== 'undefined');
  if(has_buf) {
    // $FlowIgnore
    if(!Buffer.from) Buffer.from = function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); };
    // $FlowIgnore
    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };

    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
    var make_EE = function make_EE(E){
      var EE = Buffer.allocUnsafe(65536);
      for(var i = 0; i < 65536;++i) EE[i] = 0;
      var keys = Object.keys(E), len = keys.length;
      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
        if(!(e = keys[ee])) continue;
        EE[e.charCodeAt(0)] = E[e];
      }
      return EE;
    };
    var sbcs_encode = function make_sbcs_encode(cp) {
      var EE = make_EE(cpt[cp].enc);
      return function sbcs_e(data, ofmt) {
        var len = data.length;
        var out, i=0, j=0, D=0, w=0;
        if(typeof data === 'string') {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
        } else if(Buffer.isBuffer(data)) {
          out = Buffer.allocUnsafe(2*len);
          j = 0;
          for(i = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) out[j++] = EE[D];
            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
            else {
              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
              if(w < 65536) out[j++] = EE[w];
              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
            }
          }
          out = out.slice(0,j);
        } else {
          out = Buffer.allocUnsafe(len);
          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var sbcs_decode = function make_sbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c="";
      for(d=0;d<D.length;++d) {
        if(!(c=D[d])) continue;
        var w = c.charCodeAt(0);
        DD[2*d] = w&255; DD[2*d+1] = w>>8;
      }
      return function sbcs_d(data) {
        var len = data.length, i=0, j=0;
        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
          }
        }
        return mdb.slice(0, 2 * len).toString('ucs2');
      };
    };
    var dbcs_encode = function make_dbcs_encode(cp) {
      var E = cpt[cp].enc;
      var EE = Buffer.allocUnsafe(131072);
      for(var i = 0; i < 131072; ++i) EE[i] = 0;
      var keys = Object.keys(E);
      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
        if(!(e = keys[ee])) continue;
        var f = e.charCodeAt(0);
        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
      }
      return function dbcs_e(data, ofmt) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
        if(typeof data === 'string') {
          for(i = k = 0; i < len; ++i) {
            j = data.charCodeAt(i)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
          out = out.slice(0,k);
        } else if(Buffer.isBuffer(data)) {
          for(i = k = 0; i < len; ++i) {
            D = data[i];
            if(D < 128) j = D;
            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
            else { jj = j-65536;
              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
            }
          }
          out = out.slice(0,k);
        } else {
          for(i = k = 0; i < len; i++) {
            j = data[i].charCodeAt(0)*2;
            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
          }
        }
        if(!ofmt || ofmt === 'buf') return out;
        if(ofmt !== 'arr') return out.toString('binary');
        return [].slice.call(out);
      };
    };
    var dbcs_decode = function make_dbcs_decode(cp) {
      var D = cpt[cp].dec;
      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
      for(d = 0; d < D.length; ++d) {
        if(!(c=D[d])) continue;
        w = c.charCodeAt(0);
        j = 2*d;
        DD[j] = w&255; DD[j+1] = w>>8;
      }
      return function dbcs_d(data) {
        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
        if(Buffer.isBuffer(data)) {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else if(typeof data === "string") {
          for(i = 0; i < len; i++) {
            j = 2*data.charCodeAt(i);
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        } else {
          for(i = 0; i < len; i++) {
            j = 2*data[i];
            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
            out[k++] = DD[j]; out[k++] = DD[j+1];
          }
        }
        return out.slice(0,k).toString('ucs2');
      };
    };
    magic_decode[65001] = function utf8_d(data) {
      if(typeof data === "string") return utf8_d(data.split("").map(cca));
      var len = data.length, w = 0, ww = 0;
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      var i = 0;
      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
        j = 1; D = data[i];
        if(D < 128) w = D;
        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
        else {
          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
        }
      }
      return mdb.slice(0,k).toString('ucs2');
    };
    magic_encode[65001] = function utf8_e(data, ofmt) {
      if(has_buf && Buffer.isBuffer(data)) {
        if(!ofmt || ofmt === 'buf') return data;
        if(ofmt !== 'arr') return data.toString('binary');
        return [].slice.call(data);
      }
      var len = data.length, w = 0, ww = 0, j = 0;
      var direct = typeof data === "string";
      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
      for(var i = 0; i < len; ++i) {
        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
        if(w <= 0x007F) mdb[j++] = w;
        else if(w <= 0x07FF) {
          mdb[j++] = 192 + (w >> 6);
          mdb[j++] = 128 + (w&63);
        } else if(w >= 0xD800 && w <= 0xDFFF) {
          w -= 0xD800; ++i;
          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
          mdb[j++] = 240 + ((ww>>>18) & 0x07);
          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
          mdb[j++] = 128 + (ww & 0x3F);
        } else {
          mdb[j++] = 224 + (w >> 12);
          mdb[j++] = 128 + ((w >> 6)&63);
          mdb[j++] = 128 + (w&63);
        }
      }
      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
      return [].slice.call(mdb, 0, j);
    };
  }

  var encache = function encache() {
    if(has_buf) {
      if(cpdcache[sbcs_cache[0]]) return;
      var i=0, s=0;
      for(i = 0; i < sbcs_cache.length; ++i) {
        s = sbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = sbcs_decode(s);
          cpecache[s] = sbcs_encode(s);
        }
      }
      for(i = 0; i < dbcs_cache.length; ++i) {
        s = dbcs_cache[i];
        if(cpt[s]) {
          cpdcache[s] = dbcs_decode(s);
          cpecache[s] = dbcs_encode(s);
        }
      }
      for(i = 0; i < magic_cache.length; ++i) {
        s = magic_cache[i];
        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
        if(magic_encode[s]) cpecache[s] = magic_encode[s];
      }
    }
  };
  var null_enc = function(data, ofmt) { void ofmt; return ""; };
  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
  var decache = function decache() {
    if(has_buf) {
      if(!cpdcache[sbcs_cache[0]]) return;
      sbcs_cache.forEach(cp_decache);
      dbcs_cache.forEach(cp_decache);
      magic_cache.forEach(cp_decache);
    }
    last_enc = null_enc; last_cp = 0;
  };
  var cache = {
    encache: encache,
    decache: decache,
    sbcs: sbcs_cache,
    dbcs: dbcs_cache
  };

  encache();

  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
  var last_enc = null_enc, last_cp = 0;
  var encode = function encode(cp, data, ofmt) {
    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
    var len = data.length;
    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
    var C = cpt[cp], E, M = "";
    var isstr = typeof data === 'string';
    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
      w = E[isstr? data.charAt(i) : data[i]];
      if(w > 255) {
        out[j] = w>>8;
        out[++j] = w&255;
      } else out[j] = w&255;
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(has_buf && isstr) { out = Buffer.from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else if(w <= 0x07FF) {
            out[j]   = 192 + (w >> 6);
            out[++j] = 128 + (w&63);
          } else if(w >= 0xD800 && w <= 0xDFFF) {
            w -= 0xD800;
            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
            out[j]   = 240 + ((ww>>>18) & 0x07);
            out[++j] = 144 + ((ww>>>12) & 0x3F);
            out[++j] = 128 + ((ww>>>6) & 0x3F);
            out[++j] = 128 + (ww & 0x3F);
          } else {
            out[j]   = 224 + (w >> 12);
            out[++j] = 128 + ((w >> 6)&63);
            out[++j] = 128 + (w&63);
          }
        }
        break;
      case "ascii":
        if(has_buf && typeof data === "string") { out = Buffer.from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i, ++j) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w <= 0x007F) out[j] = w;
          else throw new Error("bad ascii " + w);
        }
        break;
      case "utf16le":
        if(has_buf && typeof data === "string") { out = Buffer.from(data, M); j = out.length; break; }
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w&255;
          out[j++] = w>>8;
        }
        break;
      case "utf16be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          out[j++] = w>>8;
          out[j++] = w&255;
        }
        break;
      case "utf32le":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255; w >>= 8;
          out[j++] = w&255;
        }
        break;
      case "utf32be":
        for(i = 0; i < len; ++i) {
          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
          out[j+3] = w&255; w >>= 8;
          out[j+2] = w&255; w >>= 8;
          out[j+1] = w&255; w >>= 8;
          out[j] = w&255;
          j+=4;
        }
        break;
      case "utf7":
        for(i = 0; i < len; i++) {
          var c = isstr ? data.charAt(i) : data[i].charAt(0);
          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
          var tt = encode(1201, c);
          out[j++] = 0x2b;
          out[j++] = BM.charCodeAt(tt[0]>>2);
          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
          out[j++] = 0x2d;
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    out = out.slice(0,j);
    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
    if(!ofmt || ofmt === 'buf') return out;
    if(ofmt !== 'arr') return out.toString('binary');
    return [].slice.call(out);
  };
  var decode = function decode(cp, data) {
    var F; if((F=cpdcache[cp])) return F(data);
    if(typeof data === "string") return decode(cp, data.split("").map(cca));
    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
    var C = cpt[cp], D, M="";
    if(C && (D=C.dec)) {
      for(i = 0; i < len; i+=j) {
        j = 2;
        s = D[(data[i]<<8)+ data[i+1]];
        if(!s) {
          j = 1;
          s = D[data[i]];
        }
        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
        out[k++] = s;
      }
    }
    else if((M=magic[cp])) switch(M) {
      case "utf8":
        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
        for(; i < len; i+=j) {
          j = 1;
          if(data[i] < 128) w = data[i];
          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
          if(w < 65536) { out[k++] = String.fromCharCode(w); }
          else {
            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
          }
        }
        break;
      case "ascii":
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
        k = len; break;
      case "utf16le":
        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
        }
        break;
      case "utf16be":
        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
        j = 2;
        for(; i+1 < len; i+=j) {
          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
        }
        break;
      case "utf32le":
        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf32be":
        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
        j = 4;
        for(; i < len; i+=j) {
          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
          if(w > 0xFFFF) {
            w -= 0x10000;
            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
          }
          else out[k++] = String.fromCharCode(w);
        }
        break;
      case "utf7":
        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
        }
        for(; i < len; i+=j) {
          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
          j=1;
          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
          // eslint-disable-next-line no-useless-escape
          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
          var dash = 0;
          if(data[i+j] === 0x2d) { ++j; dash=1; }
          var tt = [];
          var o64 = "";
          var c1=0, c2=0, c3=0;
          var e1=0, e2=0, e3=0, e4=0;
          for(var l = 1; l < j - dash;) {
            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
            c1 = e1 << 2 | e2 >> 4;
            tt.push(c1);
            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e3 === -1) break;
            c2 = (e2 & 15) << 4 | e3 >> 2;
            tt.push(c2);
            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
            if(e4 === -1) break;
            c3 = (e3 & 3) << 6 | e4;
            if(e4 < 64) tt.push(c3);
          }
          o64 = decode(1201, tt);
          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
        }
        break;
      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    return out.slice(0,k).join("");
  };
  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
  return cpt;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228).Buffer))

/***/ }),
/* 975 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getSendEmailList;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSendEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getSendEmailList(pagination) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].REQUEST,
        pagination: pagination
    };
}

function getSendEmail(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_42" /* GET_SEND_EMAIL */].REQUEST,
        id: id
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getSendEmailList, 'getSendEmailList', '/opt/atlassian/pipelines/agent/build/client/app/actions/sender.js');
    reactHotLoader.register(getSendEmail, 'getSendEmail', '/opt/atlassian/pipelines/agent/build/client/app/actions/sender.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getBackendNotifications;
/* unused harmony export getBackendNotification */
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteBackendNotification;
/* unused harmony export updateBackendNotification */
/* unused harmony export createBackendNotification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getBackendNotifications() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_9" /* GET_BACKEND_NOTIFICATIONS */].REQUEST
    };
}

function getBackendNotification(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_8" /* GET_BACKEND_NOTIFICATION */].REQUEST,
        data: id
    };
}

function deleteBackendNotification(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["K" /* DELETE_BACKEND_NOTIFICATION */].REQUEST,
        id: id
    };
}

function updateBackendNotification(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].REQUEST,
        data: data
    };
}

function createBackendNotification(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].REQUEST,
        data: data
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getBackendNotifications, 'getBackendNotifications', '/opt/atlassian/pipelines/agent/build/client/app/actions/notifications/backendNotifications.js');
    reactHotLoader.register(getBackendNotification, 'getBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/actions/notifications/backendNotifications.js');
    reactHotLoader.register(deleteBackendNotification, 'deleteBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/actions/notifications/backendNotifications.js');
    reactHotLoader.register(updateBackendNotification, 'updateBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/actions/notifications/backendNotifications.js');
    reactHotLoader.register(createBackendNotification, 'createBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/actions/notifications/backendNotifications.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = LoginAsPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LoginAsPage_scss__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LoginAsPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LoginAsPage_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_react_utils__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IdsManipulators_IdsConverter__ = __webpack_require__(3444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IdsManipulators_IdsEntities__ = __webpack_require__(3445);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var copyToClipboard = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId) {
        var session, link;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].prepareOneTimeAuthSession(userId);

                    case 2:
                        session = _context.sent;
                        link = "https://shipnext.com" + '/api/v1/auth/loginAs?key=' + session.key;


                        console.log(link);

                        navigator.clipboard.writeText(link);

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function copyToClipboard(_x) {
        return _ref.apply(this, arguments);
    };
}();

var loginInNewPage = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userId) {
        var session, link, form;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].prepareOneTimeAuthSession(userId);

                    case 2:
                        session = _context2.sent;
                        link = "https://shipnext.com" + '/api/v1/auth/loginAs?key=' + session.key;
                        form = document.createElement('form');

                        form.method = 'POST';
                        form.action = link;
                        form.target = '_blank';

                        document.body.appendChild(form);

                        form.submit();
                        form.remove();

                    case 11:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function loginInNewPage(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

/**
 * @param {{ customCompanyName?: string }} props
 */


(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













function loadUserInfo(emailLike) {
    if (emailLike.length < 3) {
        return [];
    }
    return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findUser(emailLike).then(function (response) {
        return response.data.data;
    }).catch(function (err) {
        console.error(err);
        return null;
    });
}

function LoginAsPage(_ref3) {
    var searchUsers = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(searchText) {
            var _emails;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            setSearch(searchText);

                            _context3.next = 3;
                            return loadUserInfo(searchText);

                        case 3:
                            _emails = _context3.sent;

                            if (!(searchRef.current !== searchText)) {
                                _context3.next = 6;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 6:

                            if (Array.isArray(_emails) && customCompanyName) {
                                _emails = _emails.filter(function (e) {
                                    return e.company.name && new RegExp(customCompanyName, 'i').test(e.company.name);
                                });
                            }

                            setResults(_emails);

                        case 8:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        return function searchUsers(_x3) {
            return _ref4.apply(this, arguments);
        };
    }();

    var customCompanyName = _ref3.customCompanyName;

    var _useRefState = Object(__WEBPACK_IMPORTED_MODULE_7_helpers_react_utils__["a" /* useRefState */])(''),
        _useRefState2 = _slicedToArray(_useRefState, 3),
        search = _useRefState2[0],
        setSearch = _useRefState2[1],
        searchRef = _useRefState2[2];

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        emails = _useState2[0],
        setResults = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState4 = _slicedToArray(_useState3, 2),
        user = _useState4[0],
        setUser = _useState4[1];

    function onUserSelected(_user) {
        setSearch('');
        setUser(_user);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'login-as-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper___default.a,
            { style: { padding: '20px' }, zDepth: 2, rounded: false, className: 'wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                null,
                'This block allows to log in as specific user'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'notes' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Security considerations:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        null,
                        'admin rights (only specific devs can use);'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        null,
                        'auth link valid for one day;'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        null,
                        'authorization lasts for the session time;'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        null,
                        'link invalidates after first usage (aka one time auth link);'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: '' },
                'User email:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
                name: 'userEmail',
                textFieldStyle: { fontSize: '13px' },
                hintText: 'User email or id',
                searchText: search,
                dataSource: emails || [],
                dataSourceConfig: { text: 'email', value: 'item' },
                onUpdateInput: searchUsers,
                onNewRequest: onUserSelected,
                filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
                listStyle: { overflow: 'auto', maxHeight: '300px' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true
            }),
            user ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'line' },
                    'Selected user:',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    user.email,
                    ' (',
                    user.company && user.company.name,
                    ')'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'buttons' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: '' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, { label: 'Copy auth link', primary: true, onClick: function onClick() {
                                return copyToClipboard(user._id);
                            } })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: '' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, { label: 'Login in new page', secondary: true, onClick: function onClick() {
                                return loginInNewPage(user._id);
                            } })
                    )
                )
            ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ids-manipulators' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IdsManipulators_IdsConverter__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__IdsManipulators_IdsEntities__["a" /* default */], null)
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(loadUserInfo, 'loadUserInfo', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/LoginAsPage.jsx');
    reactHotLoader.register(copyToClipboard, 'copyToClipboard', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/LoginAsPage.jsx');
    reactHotLoader.register(loginInNewPage, 'loginInNewPage', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/LoginAsPage.jsx');
    reactHotLoader.register(LoginAsPage, 'LoginAsPage', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/LoginAsPage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getAnalyticsLinksList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getAnalyticsLinksList() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_5" /* GET_ANALYTICS_LINKS_LIST */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getAnalyticsLinksList, 'getAnalyticsLinksList', '/opt/atlassian/pipelines/agent/build/client/app/actions/analytics/linksList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = RangeDates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








function RangeDates(_ref) {
    var from = _ref.from,
        until = _ref.until,
        changeDateRange = _ref.changeDateRange,
        handleChangeDate = _ref.handleChangeDate;

    var maxDate = new Date();
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker___default.a, {
            floatingLabelText: 'Filter start date:',
            autoOk: true,
            maxDate: until ? Object(__WEBPACK_IMPORTED_MODULE_2_helpers_dates__["c" /* makeLocalAppearUTC */])(new Date(until)) : maxDate,
            textFieldStyle: { width: '120px' },
            onChange: function onChange(_, date) {
                return changeDateRange('from', __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).utcOffset(0, true));
            },
            value: from ? Object(__WEBPACK_IMPORTED_MODULE_2_helpers_dates__["c" /* makeLocalAppearUTC */])(from) : undefined
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
            {
                style: { margin: '25px 7px 0 -7px' },
                disabled: !from,
                onClick: function onClick() {
                    return handleChangeDate('from', null);
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                color: from ? 'red' : 'black'
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker___default.a, {
            style: { marginLeft: '15px' },
            floatingLabelText: 'Filter end date:',
            autoOk: true,
            minDate: from ? new Date(from) : undefined,
            textFieldStyle: { width: '120px' },
            onChange: function onChange(_, date) {
                return changeDateRange('until', __WEBPACK_IMPORTED_MODULE_3_moment___default()(Object(__WEBPACK_IMPORTED_MODULE_2_helpers_dates__["b" /* localToUTC */])(date)).utcOffset(0, true).set({ hour: 23, minute: 59, second: 59 }));
            },
            value: until ? Object(__WEBPACK_IMPORTED_MODULE_2_helpers_dates__["c" /* makeLocalAppearUTC */])(until) : undefined
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
            {
                style: { margin: '25px 7px 0 -7px' },
                disabled: !until,
                onClick: function onClick() {
                    return handleChangeDate('until', null);
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                color: until ? 'red' : 'black'
            })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RangeDates, 'RangeDates', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/RangeDates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FlagComplianceRow__ = __webpack_require__(3469);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var styles = {
    flag: {
        width: '15%',
        whiteSpace: 'break-spaces'
    },
    riskFactor: {
        width: '10%'
    },
    avoid: {
        width: '65%'
    },
    controls: {
        display: 'flex',
        margin: 'auto'
    }
};

function FlagComplianceTable(_ref) {
    var flagComplianceList = _ref.flagComplianceList;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        rows = _useState2[0],
        setRows = _useState2[1];

    var handleUpdateRow = function handleUpdateRow() {
        setRows(flagComplianceList);
    };

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        handleUpdateRow();
    }, [flagComplianceList]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'table-body' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_material_ui__["u" /* Table */],
                {
                    selectable: false
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_material_ui__["w" /* TableHeader */],
                    {
                        displaySelectAll: false,
                        adjustForCheckbox: false
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["y" /* TableRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                            { style: styles.flag },
                            'Flag'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                            { style: styles.riskFactor },
                            'Risk Factor'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                            { style: styles.avoid },
                            'Avoid countries'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                            { style: styles.controls },
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_material_ui__["v" /* TableBody */],
                    { displayRowCheckbox: false },
                    rows.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FlagComplianceRow__["a" /* default */], {
                            key: item._id,
                            item: item
                        });
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        flagComplianceList: state.flagCompliance.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(FlagComplianceTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagComplianceTable.jsx');
    reactHotLoader.register(FlagComplianceTable, 'FlagComplianceTable', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagComplianceTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagComplianceTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_scss__ = __webpack_require__(3486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_scss__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










/**
 * @param {{ 
 *      filters: Filters, 
 *      selectSize: Function,
 *      sizesCounters: Array,
 * }} props
 */
function VesselsComposition(_ref) {
    var selectSize = _ref.selectSize,
        sizesCounters = _ref.sizesCounters;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        _sizesCounters = _useState2[0],
        _setSizesCounters = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        _setSizesCounters(sizesCounters);
    }, [sizesCounters]);

    var chooseVessel = function chooseVessel(vessel) {
        selectSize(vessel);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        _sizesCounters.map(function (sizesCounter, sIndex) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                { key: 'sizesCounter_' + sIndex },
                sizesCounter.vessel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'sizesCounter',
                        onClick: function onClick() {
                            return chooseVessel(sizesCounter.vessel);
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        { className: 'sizesCounter--vessel' },
                        sizesCounter.vessel.name + ' (' + sizesCounter.vessel.imoNumber + ')'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'sizesCounter--data' },
                        Object.entries(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.omit(sizesCounter, 'vessel')).map(function (item, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { key: item[0] + '_' + index + '}' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'b',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_5__utils_js__["k" /* sizesMap */][item[0]]
                                ),
                                ': ',
                                item[1],
                                '\xA0\xA0\xA0'
                            );
                        })
                    )
                )
            );
        })
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(VesselsComposition);

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * 
 * @typedef {import('./Main.jsx').FiltersState} Filters 
 * @typedef {import('./Main.jsx').FiltersStateSetter} FiltersSetter
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselsComposition, 'VesselsComposition', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Composition.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Composition.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringify_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(985);



function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ __webpack_exports__["a"] = (function (name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = Object(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__stringify_js__["a" /* default */])(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
});

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(400);


function parse(uuid) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = BasicCheckBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(291);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function BasicCheckBox(_ref) {
    var _ref$label = _ref.label,
        label = _ref$label === undefined ? '' : _ref$label,
        checked = _ref.checked,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$labelStyle = _ref.labelStyle,
        labelStyle = _ref$labelStyle === undefined ? {} : _ref$labelStyle,
        handleChange = _ref.handleChange,
        _ref$iconStyle = _ref.iconStyle,
        iconStyle = _ref$iconStyle === undefined ? {} : _ref$iconStyle;

    var onCheck = function onCheck() {
        handleChange(!checked);
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["b" /* Checkbox */], {
        name: Object(__WEBPACK_IMPORTED_MODULE_2_uuid__["a" /* v4 */])(),
        checked: checked,
        onCheck: onCheck,
        label: label,
        style: _extends({}, style),
        labelStyle: _extends({}, labelStyle),
        iconStyle: _extends({ width: '20px', marginLeft: '-1px' }, iconStyle)
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BasicCheckBox, 'BasicCheckBox', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Basic/BasicCheckBox.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Basic_RangeDates__ = __webpack_require__(3505);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function LayCan(_ref) {
    var lay = _ref.lay,
        can = _ref.can,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        setHasErrors = _ref.setHasErrors;

    var minDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'month').toDate();
    var handleChangeDate = function handleChangeDate(field, date) {
        var toChange = [{
            index: countIndex,
            field: field,
            value: date
        }];

        if (field === 'lay' && Date.parse(date) > Date.parse(can)) {
            toChange.push({
                index: countIndex,
                field: 'can',
                value: date
            });
        }

        if (field === 'can' && Date.parse(lay) > Date.parse(date)) {
            toChange.push({
                index: countIndex,
                field: 'lay',
                value: date
            });
        }

        changeFieldsMultiple(toChange);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!lay || !can) {
                setHasErrors('layCan', true);
            } else {
                setHasErrors('layCan', false);
            }
        }
    }, [lay, can]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Basic_RangeDates__["a" /* default */], {
        minDate: minDate,
        from: lay,
        until: can,
        handleChangeDate: handleChangeDate
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(LayCan);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LayCan, 'LayCan', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/LayCan.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/LayCan.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__ = __webpack_require__(243);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function Duration(_ref) {
    var duration = _ref.duration,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? undefined : _ref$type;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(duration),
        _useState2 = _slicedToArray(_useState, 2),
        stateDuration = _useState2[0],
        setStateDuration = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setStateDuration(duration);
    }, [duration]);

    var changeDuration = function changeDuration() {
        duration !== stateDuration && changeFieldsMultiple([{
            index: countIndex,
            field: 'duration',
            value: stateDuration
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__["a" /* default */], {
        name: 'duration',
        value: stateDuration,
        onChange: function onChange(e) {
            return setStateDuration(e.target.value);
        },
        floatingLabelStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        type: type || 'string',
        onBlur: changeDuration
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Duration);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Duration, 'Duration', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Durations.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Durations.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = withBasicIconButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function withBasicIconButton(Component) {
    return function (props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
            {
                style: {
                    width: '40px',
                    height: '40px',
                    padding: 0
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props)
        );
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(withBasicIconButton, 'withBasicIconButton', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Basic/BasicIconButton.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_common_CompaniesAutoComplete__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_issues__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IssueItem__ = __webpack_require__(3518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_socket__ = __webpack_require__(515);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















var rowsPerPage = [25, 50, 100];

var minDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()([2017, 10, 3]).toDate();
var maxDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();

var defaultStatus = 'all';
var STATUSES = {
    all: 'All',
    new: 'New',
    inProgress: 'In progress',
    confirmed: 'Confirmed',
    fixed: 'Fixed',
    notBug: 'Not bug'
};

var getDefaultFilters = function getDefaultFilters() {
    return {
        statuses: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        company: undefined,
        withAttachments: undefined,
        takenByMe: undefined,
        topics: undefined
    };
};

var UserContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({});

function IssuesList(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        issues = _useState2[0],
        setIssues = _useState2[1];

    var issuesRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(issues);

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState4 = _slicedToArray(_useState3, 2),
        search = _useState4[0],
        setSearch = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState6 = _slicedToArray(_useState5, 2),
        total = _useState6[0],
        setTotal = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState8 = _slicedToArray(_useState7, 2),
        page = _useState8[0],
        setPage = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(25),
        _useState10 = _slicedToArray(_useState9, 2),
        numberOfRows = _useState10[0],
        setNumberOfRows = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(getDefaultFilters()),
        _useState12 = _slicedToArray(_useState11, 2),
        filters = _useState12[0],
        setFilters = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState14 = _slicedToArray(_useState13, 2),
        resetCompanyInput = _useState14[0],
        setResetCompanyInput = _useState14[1];

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
        // trigger capture any issues change (run on every rerender)
        // that prevent keeping old issues state 
        issuesRef.current = issues;
    });

    /**
     * 
     * @param {UpdateIssueMessage} message 
     * @param {any[]} issuesCurrent 
     */
    var messageHandler = function messageHandler(message, issuesCurrent) {
        var id = message.id,
            status = message.status,
            user = message.user;

        var foundIssueIndex = issuesCurrent.findIndex(function (i) {
            return i._id === id;
        });

        if (foundIssueIndex >= 0) {
            var clones = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(issuesCurrent);

            clones[foundIssueIndex] = _extends({}, clones[foundIssueIndex], {
                status: status,
                statusBy: user
            });

            setIssues(clones);
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var socket = Object(__WEBPACK_IMPORTED_MODULE_12__helpers_socket__["a" /* getSocketconnection */])(props);

        /**
         * uses ref to address the last version of issues state
         * @param {UpdateIssueMessage} message 
         */
        var handler = function handler(message) {
            return messageHandler(message, issuesRef.current);
        };

        socket.on('admin:newIssueChanges', handler);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setIssues(props.issues);
        setTotal(props.total);
    }, [props.issues]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        props.getIssues({
            page: page,
            limit: numberOfRows,
            filters: filters
        });
    }, [page, numberOfRows, filters]);

    var handleChangeSearch = function handleChangeSearch(_e, v) {
        setSearch(v);
    };

    var handleSearch = function handleSearch() {
        setPage(1);
        setFilters(_extends({}, filters, {
            topics: search || undefined
        }));
    };

    var changeStatus = function changeStatus(_e, value) {
        setPage(1);
        setFilters(_extends({}, filters, {
            statuses: value !== 'all' ? [value] : undefined
        }));
    };

    var handleUpdateRow = function handleUpdateRow(_ref) {
        var p = _ref.page,
            n = _ref.numberOfRows;

        setPage(numberOfRows !== n ? 1 : p);
        setNumberOfRows(n);
    };

    var handleCheckWithAttachments = function handleCheckWithAttachments(_e, withAttachments) {
        setPage(1);
        setFilters(_extends({}, filters, {
            withAttachments: withAttachments
        }));
    };

    var handleCheckTakenByMe = function handleCheckTakenByMe(_e, takenByMe) {
        setPage(1);
        setFilters(_extends({}, filters, {
            takenByMe: takenByMe
        }));
    };

    /**
     * 
     * @param {'dateFrom' | 'dateTo'} type 
     * @param {Date} value 
     */
    var handleStartDateFilter = function handleStartDateFilter(type, value) {
        setFilters(_extends({}, filters, _defineProperty({}, type, type === 'dateFrom' ? Object(__WEBPACK_IMPORTED_MODULE_8_helpers_dates__["d" /* toUTC */])(value) : Object(__WEBPACK_IMPORTED_MODULE_8_helpers_dates__["d" /* toUTC */])(value.setHours(23, 59, 59, 999)))));
    };

    /**
     * 
     * @param {{ item: { _id: string, name: string } } | undefined} [value] 
     */
    var onCompanySelected = function onCompanySelected(value) {
        setPage(1);

        if (!value) {
            setResetCompanyInput(true);
            setTimeout(function () {
                return setResetCompanyInput(false);
            }, 100);
        }

        setFilters(_extends({}, filters, {
            company: value ? value.item._id : value
        }));
    };

    /**
     * 
     * @param {'dateFrom' | 'dateTo'} type 
     */
    var handleRemoveDate = function handleRemoveDate(type) {
        setFilters(_extends({}, filters, _defineProperty({}, type, undefined)));
    };

    var handleChangeIssue = function handleChangeIssue(issueIndex, _ref2) {
        var status = _ref2.status,
            _id = _ref2._id;

        var clones = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(issues);

        clones[issueIndex] = _extends({}, clones[issueIndex], {
            status: status,
            statusBy: props.user
        });

        props.updateIssueStatus(_id, status);

        setIssues(clones);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'issue-reports' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'name' },
                'ISSUE REPORTS'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'issues-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'issues-header-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                        defaultValue: search,
                        hintText: 'Search',
                        onChange: handleChangeSearch,
                        onKeyPress: function onKeyPress(event) {
                            if (event.charCode === 13) {
                                event.preventDefault();
                                handleSearch();
                            }
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                        label: 'Search',
                        style: { margin: '0 0 0 20px' },
                        primary: true,
                        onClick: handleSearch
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'issues-header-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
                        total: total,
                        rowsPerPage: rowsPerPage,
                        page: page,
                        numberOfRows: numberOfRows,
                        updateRows: handleUpdateRow
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'issues-info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'issues-info-item' },
                    'TOTAL:  ',
                    total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'issues-info-item' },
                    'PAGES:  ',
                    Math.ceil(total / numberOfRows)
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'issues-filters' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'filter filter-statuses' },
                    'Filter by Status:',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["q" /* RadioButtonGroup */],
                        {
                            onChange: changeStatus,
                            className: 'statuses',
                            name: 'type-mail',
                            defaultSelected: defaultStatus
                        },
                        Object.entries(STATUSES).map(function (_ref3) {
                            var _ref4 = _slicedToArray(_ref3, 2),
                                value = _ref4[0],
                                label = _ref4[1];

                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["p" /* RadioButton */], {
                                key: value,
                                className: 'statuses-item',
                                iconStyle: { marginRight: '4px' },
                                value: value,
                                label: label
                            });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'filter' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'filter-checkboxes' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["b" /* Checkbox */], {
                                label: 'Only with attachments',
                                checked: filters.withAttachments,
                                onCheck: handleCheckWithAttachments
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["b" /* Checkbox */], {
                                label: 'Issue reports taken by me',
                                checked: filters.takenByMe,
                                onCheck: handleCheckTakenByMe
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'filter filter-company' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_common_CompaniesAutoComplete__["a" /* default */], {
                        onCompanySelected: onCompanySelected,
                        resetInput: resetCompanyInput,
                        style: { width: '256px' },
                        hintStyle: { fontSize: '16px' },
                        onlyWithOwner: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                        {
                            style: { margin: '2px 0 0 -7px' },
                            disabled: !filters.company,
                            onClick: function onClick() {
                                return onCompanySelected();
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                            color: filters.company ? 'red' : 'black'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'filter filter-date-inputs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["e" /* DatePicker */], {
                        floatingLabelText: 'Filter start date:',
                        autoOk: true,
                        minDate: minDate,
                        maxDate: maxDate,
                        textFieldStyle: { width: '120px' },
                        shouldDisableDate: function shouldDisableDate(dateSelected) {
                            return dateSelected.getTime() > new Date(filters.dateTo).getTime();
                        },
                        onChange: function onChange(_e, d) {
                            return handleStartDateFilter('dateFrom', d);
                        },
                        value: filters.dateFrom ? Object(__WEBPACK_IMPORTED_MODULE_8_helpers_dates__["a" /* fromUTC */])(filters.dateFrom) : undefined,
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD-MM-YYYY');
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                        {
                            style: { margin: '25px 7px 0 -7px' },
                            disabled: !filters.dateFrom,
                            onClick: function onClick() {
                                return handleRemoveDate('dateFrom');
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                            color: filters.dateFrom ? 'red' : 'black'
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["e" /* DatePicker */], {
                        floatingLabelText: 'Filter end date:',
                        autoOk: true,
                        minDate: minDate,
                        maxDate: maxDate,
                        textFieldStyle: { width: '120px' },

                        shouldDisableDate: function shouldDisableDate(dateSelected) {
                            return dateSelected.getTime() < new Date(filters.dateFrom).getTime();
                        },

                        onChange: function onChange(_e, d) {
                            return handleStartDateFilter('dateTo', d);
                        },
                        value: filters.dateTo ? Object(__WEBPACK_IMPORTED_MODULE_8_helpers_dates__["a" /* fromUTC */])(filters.dateTo) : undefined,
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD-MM-YYYY');
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                        {
                            style: { margin: '25px 0 0 -7px' },
                            disabled: !filters.dateTo,
                            onClick: function onClick() {
                                return handleRemoveDate('dateTo');
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                            color: filters.dateTo ? 'red' : 'black'
                        })
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    UserContext.Provider,
                    { value: props.user },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'issues-list' },
                        issues.map(function (issue, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__IssueItem__["a" /* default */], {
                                key: issue._id,
                                index: index,
                                issue: issue,
                                handleChangeIssue: handleChangeIssue
                            });
                        })
                    )
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function (_ref5) {
    var issues = _ref5.issues,
        user = _ref5.user.user;
    return {
        isLoaded: issues.isLoaded,
        issues: issues.data,
        total: issues.count ? issues.count.total : 0,
        user: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pick(user, ['_id', 'email']),
        userId: user && user._id
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        getIssues: __WEBPACK_IMPORTED_MODULE_10_actions_issues__["d" /* getIssues */],
        updateIssueStatus: __WEBPACK_IMPORTED_MODULE_10_actions_issues__["f" /* updateIssueStatus */]
    }, dispatch);
})(IssuesList);

/* harmony default export */ __webpack_exports__["b"] = (_default);

/**
 * @typedef {Object} UpdateIssueMessage
 * @property {string} id
 * @property {string} status 
 * @property {User} user
 */

/**
 * @typedef {Object} User
 * @property {string} _id
 * @property {string} email
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(rowsPerPage, 'rowsPerPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(minDate, 'minDate', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(maxDate, 'maxDate', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(defaultStatus, 'defaultStatus', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(STATUSES, 'STATUSES', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(getDefaultFilters, 'getDefaultFilters', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(UserContext, 'UserContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(IssuesList, 'IssuesList', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Topics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




/**
 * 
 * @param {{ topics: string[] }} param0 
 * @returns 
 */
function Topics(_ref) {
    var topics = _ref.topics;


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'topics' },
        topics.map(function (topic, index) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_material_ui__["c" /* Chip */],
                {
                    key: topic + '_' + index,
                    className: 'topic',
                    labelStyle: { fontSize: '12px', lineHeight: '20px' }
                },
                topic
            );
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Topics, 'Topics', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/Topics.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export generateEndAt */
/* harmony export (immutable) */ __webpack_exports__["c"] = getDefaultHire;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDefaultError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXPORT_MAP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(291);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function generateEndAt() {
    var date = new Date();

    var endDate = new Date(date.toISOString().slice(0, 10) + 'T23:59:59.000Z');

    var distance = 7 - new Date(date.toISOString().slice(0, 10) + 'T00:00:00.000Z').getDay();

    endDate.setDate(endDate.getDate() + distance);

    return endDate;
}

function getDefaultHire() {
    var uniqueId = Object(__WEBPACK_IMPORTED_MODULE_0_uuid__["a" /* v4 */])();

    return {
        key: uniqueId,
        uniqueId: uniqueId,
        can: generateEndAt(),
        lay: new Date(),
        hire: undefined,
        hireType: undefined,
        delivery: {},
        redelivery: {},
        mainRegionDelivery: {},
        mainRegionRedelivery: {},
        vessel: undefined
    };
}

function getDefaultError(r) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$isNew = _ref.isNew,
        isNew = _ref$isNew === undefined ? false : _ref$isNew;

    var value = !!isNew;
    return {
        _id: r._id || r.uniqueId,
        hire: value,
        hireType: value,
        mainRegionDelivery: value,
        mainRegionRedelivery: value,
        vesselDwtGroup: value
    };
}

// 1 - add to export select
// -1 - remore from export select
var EXPORT_MAP = {
    vessel: { value: 1, label: 'Vessel' },
    lay: { value: 1, label: 'Lay' },
    can: { value: 1, label: 'Can' },
    hire: { value: 1, label: 'Hire' },
    hireType: { value: 1, label: 'Hire type' },
    // delivery: 1,
    // redelivery: 1,
    mainRegionDelivery: { value: 1, label: 'Main region delivery' },
    mainRegionRedelivery: { value: 1, label: 'Main region redelivery' },
    fuelPrice: { value: 1, label: 'Fuel price' },
    duration: { value: 1, label: 'Duration' },
    cargo: { value: 1, label: 'Cargo' },
    cargoRegion: { value: 1, label: 'Cargo region' },
    vesselDwtGroup: { value: 1, label: 'Vessel dwt group' },
    bunkerPlace: { value: 1, label: 'Bunker place' }
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(generateEndAt, 'generateEndAt', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/common.js');
    reactHotLoader.register(getDefaultHire, 'getDefaultHire', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/common.js');
    reactHotLoader.register(getDefaultError, 'getDefaultError', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/common.js');
    reactHotLoader.register(EXPORT_MAP, 'EXPORT_MAP', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/common.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return s; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HiresPage__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rowData_FromTo__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TcIndex_RowData_LayCan__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rowData_HireType__ = __webpack_require__(3534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rowData_HireValue__ = __webpack_require__(3535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rowData_VesselInfo__ = __webpack_require__(3536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TcIndex_RowData_Durations__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rowData_FuelPrice__ = __webpack_require__(3537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rowData_HireCargo__ = __webpack_require__(3538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rowData_HireCargoRegion__ = __webpack_require__(3539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rowData_Remove__ = __webpack_require__(3540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rowData_DwtGroup__ = __webpack_require__(3541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rowData_BunkerPlace__ = __webpack_require__(3542);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















var s = {
    small: _extends({}, __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__["a" /* default */].tableRowSm, { height: 'unset' }),
    normal: _extends({}, __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__["a" /* default */].tableRow, { height: 'unset' })
};

var placesMap = {
    placeFrom: 'delivery',
    placeTo: 'redelivery',
    regionFrom: 'mainRegionDelivery',
    regionTo: 'mainRegionRedelivery'
};

function HiresTableRow(_ref) {
    var hireData = _ref.hireData,
        _errors = _ref.errors,
        rowIndex = _ref.rowIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    var handleUpdateErrors = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__HiresPage__["d" /* HandleUpdateErrorsContext */]);
    var currentTypeByPurpose = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__HiresPage__["c" /* CurrentTypeByPurposeContext */]);
    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__HiresPage__["f" /* VesselDwtTypesContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(hireData),
        _useState2 = _slicedToArray(_useState, 2),
        localHireData = _useState2[0],
        setLocalHireData = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_errors),
        _useState4 = _slicedToArray(_useState3, 2),
        errors = _useState4[0],
        setErrors = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        currentDwtGroups = _useState6[0],
        setCurrentDwtGroups = _useState6[1];

    var handleFieldChange = function handleFieldChange(changes) {
        changes.forEach(function (_ref2) {
            var field = _ref2.field,
                value = _ref2.value;

            setLocalHireData(function (prev) {
                return _extends({}, prev, _defineProperty({}, field, value));
            });
        });
        changeFieldsMultiple(changes);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (currentTypeByPurpose || localHireData.vessel && localHireData.vessel.typeByPurpose) {
            setCurrentDwtGroups(vesselDwtTypes.filter(function (d) {
                return d.typeByPurpose.includes(currentTypeByPurpose || localHireData.vessel.typeByPurpose);
            }));
        }
    }, [currentTypeByPurpose, localHireData.vessel]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setErrors(_errors[rowIndex]);
    }, [_errors]);

    var handleErrors = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, value) {
        try {
            if (handleUpdateErrors) {
                handleUpdateErrors(rowIndex, field, value);
            }
        } catch (error) {
            console.error('Error in handleUpdateErrors:', error);
        }
    }, [handleUpdateErrors, rowIndex]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
            { key: hireData._id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__rowData_VesselInfo__["a" /* default */], {
                vessel: localHireData.vessel,
                changeFieldsMultiple: handleFieldChange,
                countIndex: rowIndex,
                setHasErrors: handleErrors,
                required: false
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal, errors && errors.vesselDwtGroup ? __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__rowData_DwtGroup__["a" /* default */], {
                    vesselType: localHireData.vesselDwtGroup,
                    changeFieldsMultiple: handleFieldChange,
                    countIndex: rowIndex,
                    currentDwtGroups: currentDwtGroups,
                    required: true,
                    setHasErrors: handleErrors
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__rowData_FromTo__["a" /* default */], _extends({
                    name: 'delivery_' + rowIndex,
                    field: 'delivery',
                    data: localHireData.delivery,
                    changeFieldsMultiple: handleFieldChange,
                    countIndex: rowIndex,
                    mainRegions: false,
                    withAreas: false,
                    setHasErrors: handleErrors,
                    checkRequiredMain: false,
                    bunkerPlace: localHireData.bunkerPlace
                }, placesMap))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal, errors && errors.mainRegionDelivery ? __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__rowData_FromTo__["a" /* default */], _extends({
                    name: 'mainRegionDelivery_' + rowIndex,
                    field: 'mainRegionDelivery',
                    data: localHireData.mainRegionDelivery,
                    changeFieldsMultiple: handleFieldChange,
                    countIndex: rowIndex,
                    setHasErrors: handleErrors,
                    required: true,
                    mainRegions: true,
                    withAreas: true,
                    isInBalticIndex: true,
                    onlyAreas: true,
                    bunkerPlace: localHireData.bunkerPlace
                }, placesMap))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__rowData_FromTo__["a" /* default */], _extends({
                    name: 'redelivery_' + rowIndex,
                    field: 'redelivery',
                    data: localHireData.redelivery,
                    changeFieldsMultiple: handleFieldChange,
                    countIndex: rowIndex,
                    mainRegions: false,
                    withAreas: false,
                    setHasErrors: handleErrors,
                    checkRequiredMain: false
                }, placesMap))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal, errors && errors.mainRegionRedelivery ? __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__rowData_FromTo__["a" /* default */], _extends({
                    name: 'mainRegionRedelivery_' + rowIndex,
                    field: 'mainRegionRedelivery',
                    data: localHireData.mainRegionRedelivery,
                    changeFieldsMultiple: handleFieldChange,
                    countIndex: rowIndex,
                    setHasErrors: handleErrors,
                    required: true,
                    mainRegions: true,
                    withAreas: true,
                    onlyAreas: true,
                    isInBalticIndex: true
                }, placesMap))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TcIndex_RowData_LayCan__["a" /* default */], {
                    lay: localHireData.lay,
                    can: localHireData.can,
                    required: true,
                    setHasErrors: handleErrors,
                    countIndex: rowIndex,
                    changeFieldsMultiple: handleFieldChange
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, errors && errors.hireType ? __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__rowData_HireType__["a" /* default */], {
                    hireType: localHireData.hireType,
                    countIndex: rowIndex,
                    changeFieldsMultiple: handleFieldChange,
                    required: true,
                    setHasErrors: handleErrors
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, errors && errors.hire ? __WEBPACK_IMPORTED_MODULE_3__TcIndex_styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__rowData_HireValue__["a" /* default */], {
                    hire: localHireData.hire,
                    countIndex: rowIndex,
                    setHasErrors: handleErrors,
                    changeFieldsMultiple: handleFieldChange,
                    required: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__rowData_FuelPrice__["a" /* default */], {
                fuelPrice: localHireData.fuelPrice,
                countIndex: rowIndex,
                changeFieldsMultiple: handleFieldChange,
                lay: localHireData.lay,
                bunkerPlace: localHireData.bunkerPlace,
                mainRegionDelivery: localHireData.mainRegionDelivery
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__rowData_BunkerPlace__["a" /* default */], _extends({
                    name: 'bunkerPlace_' + rowIndex,
                    field: 'bunkerPlace',
                    data: localHireData.bunkerPlace,
                    changeFieldsMultiple: handleFieldChange,
                    countIndex: rowIndex,
                    setHasErrors: handleErrors,
                    mainRegions: true,
                    withAreas: true,
                    onlyAreas: true,
                    isInBalticIndex: true,
                    lay: localHireData.lay
                }, placesMap))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TcIndex_RowData_Durations__["a" /* default */], {
                    duration: localHireData.duration,
                    countIndex: rowIndex,
                    changeFieldsMultiple: handleFieldChange,
                    type: 'number'
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__rowData_HireCargo__["a" /* default */], {
                    cargo: localHireData.cargo,
                    countIndex: rowIndex,
                    changeFieldsMultiple: handleFieldChange,
                    cargoType: localHireData.cargoTypeId
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__rowData_HireCargoRegion__["a" /* default */], {
                    cargoRegion: localHireData.cargoRegionId,
                    countIndex: rowIndex,
                    changeFieldsMultiple: handleFieldChange
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, { padding: '0 3px', borderRight: '1px solid #eaeaea', textAlign: 'center'
                    })
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__rowData_Remove__["a" /* Remove */], {
                    hireDataId: localHireData._id || localHireData.uniqueId,
                    changeFieldsMultiple: handleFieldChange,
                    countIndex: rowIndex
                })
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(HiresTableRow, function (prev, next) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"])(prev.hireData, next.hireData) && Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"])(prev.errors, next.errors) && prev.rowIndex === next.rowIndex && prev.changeFieldsMultiple === next.changeFieldsMultiple;
});

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(s, 's', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresTableRow.jsx');
    reactHotLoader.register(placesMap, 'placesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresTableRow.jsx');
    reactHotLoader.register(HiresTableRow, 'HiresTableRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresTableRow.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresTableRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_PortsAutoComplete__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






/**
 * @param {FromToProps} param0 
 */
function FromTo(_ref) {
    var _this = this;

    var field = _ref.field,
        data = _ref.data,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        _ref$setHasErrors = _ref.setHasErrors,
        setHasErrors = _ref$setHasErrors === undefined ? function (_a, _b) {} : _ref$setHasErrors,
        mainRegions = _ref.mainRegions,
        withAreas = _ref.withAreas,
        _ref$onlyAreas = _ref.onlyAreas,
        onlyAreas = _ref$onlyAreas === undefined ? false : _ref$onlyAreas,
        _ref$isInBalticIndex = _ref.isInBalticIndex,
        isInBalticIndex = _ref$isInBalticIndex === undefined ? false : _ref$isInBalticIndex,
        _ref$placeFrom = _ref.placeFrom,
        placeFrom = _ref$placeFrom === undefined ? 'placeFrom' : _ref$placeFrom,
        _ref$placeTo = _ref.placeTo,
        placeTo = _ref$placeTo === undefined ? 'placeTo' : _ref$placeTo,
        _ref$regionFrom = _ref.regionFrom,
        regionFrom = _ref$regionFrom === undefined ? 'regionFrom' : _ref$regionFrom,
        _ref$regionTo = _ref.regionTo,
        regionTo = _ref$regionTo === undefined ? 'regionTo' : _ref$regionTo,
        _ref$checkRequiredMai = _ref.checkRequiredMain,
        checkRequiredMain = _ref$checkRequiredMai === undefined ? true : _ref$checkRequiredMai,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name,
        selectPortCustom = _ref.selectPortCustom;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(data),
        _useState2 = _slicedToArray(_useState, 2),
        current = _useState2[0],
        setCurrent = _useState2[1];

    var selectPort = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(port) {
            var value, toChange, main, mainValue;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setCurrent(port);

                            value = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(port, ['_id', 'name', 'areaParent']);
                            toChange = [{ index: countIndex, field: field, value: value }];

                            if (![regionFrom, regionTo].includes(field)) {
                                _context.next = 8;
                                break;
                            }

                            toChange.push({
                                index: countIndex,
                                field: field === regionFrom ? placeFrom : placeTo,
                                value: {}
                            });

                            if (field === regionFrom) {
                                toChange.push({ index: countIndex, field: 'bunkerPlace', value: value });
                            }
                            _context.next = 14;
                            break;

                        case 8:
                            _context.next = 10;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getPortMainRegion(port._id);

                        case 10:
                            main = _context.sent;
                            mainValue = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(main.data[0] || {}, ['_id', 'name', 'areaParent']);

                            toChange.push({
                                index: countIndex,
                                field: field === placeFrom ? regionFrom : regionTo,
                                value: mainValue
                            });
                            toChange.push({ index: countIndex, field: 'bunkerPlace', value: mainValue });

                        case 14:

                            changeFieldsMultiple(toChange);

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function selectPort(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCurrent(data);
    }, [data]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            var hasError = !data || !data._id;
            if (checkRequiredMain && [regionFrom, regionTo].includes(field)) {
                setHasErrors(field, hasError);
            } else if (!checkRequiredMain) {
                setHasErrors(field, hasError);
            }
        }
    }, [current]);

    var handleChangeCustomValue = function handleChangeCustomValue(value) {
        changeFieldsMultiple([{
            index: countIndex,
            field: field,
            value: value
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_common_PortsAutoComplete__["a" /* default */], {
        name: name,
        customValue: current ? current.name : '',
        selectValue: selectPortCustom || selectPort,
        floatingLabelStyle: { display: 'none' },
        hintText: null,
        underlineStyle: { display: 'none' },
        inputStyle: { fontSize: '10px' },
        style: { top: 'unset' },
        menuStyle: { width: '300px' },
        popoverProps: {
            style: { width: '300px' }
        },
        withAreas: withAreas,
        mainRegions: mainRegions,
        onlyAreas: onlyAreas,
        handleChangeCustomValue: handleChangeCustomValue,
        isInBalticIndex: isInBalticIndex
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(FromTo);

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * @typedef {Object} FromToProps
 * @property {string} field
 * @property {*} data
 * @property {(_: any[]) => void} changeFieldsMultiple
 * @property {number} countIndex
 * @property {boolean} [required]
 * @property {Function} setHasErrors
 * @property {boolean} [mainRegions]
 * @property {boolean} [withAreas]
 * @property {boolean} [onlyAreas]
 * @property {boolean} [isInBalticIndex]
 * @property {string} [placeFrom]
 * @property {string} [placeTo]
 * @property {string} [regionFrom]
 * @property {string} [regionTo]
 * @property {boolean} [checkRequiredMain]
 * @property {string} [name]
 * @property {Function} [selectPortCustom]
 * @property {*} [bunkerPlace]
 * @property {string} [lay] used for getting fuel price on specific date
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FromTo, 'FromTo', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/FromTo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/FromTo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_App__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_load_google_maps_api__ = __webpack_require__(3547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_load_google_maps_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_load_google_maps_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_query__ = __webpack_require__(141);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();









var queryClient = new __WEBPACK_IMPORTED_MODULE_6_react_query__["QueryClient"]({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 2
        }
    }
});

var render = void 0;

__WEBPACK_IMPORTED_MODULE_5_load_google_maps_api___default()({
    key: __WEBPACK_IMPORTED_MODULE_4_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
    libraries: ['drawing', 'geometry']
}).then(function () {
    render = function render(Component) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_query__["QueryClientProvider"],
                { client: queryClient },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
            )
        ), document.getElementById('root'));
    };

    render(__WEBPACK_IMPORTED_MODULE_3__app_App__["a" /* default */]);
});

if (false) {
    module.hot.accept('./app/App', function () {
        render(App);
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(queryClient, 'queryClient', '/opt/atlassian/pipelines/agent/build/client/main.js');
    reactHotLoader.register(render, 'render', '/opt/atlassian/pipelines/agent/build/client/main.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1)),classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},AppContainer=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,e.apply(this,arguments))}return inherits(t,e),t.prototype.render=function(){return React.Children.only(this.props.children)},t}(React.Component),hot_prod=function(){return function(e){return e}},areComponentsEqual=function(e,t){return e===t},setConfig=function(){},cold=function(e){return e},configureComponent=function(){};exports.AppContainer=AppContainer,exports.hot=hot_prod,exports.areComponentsEqual=areComponentsEqual,exports.setConfig=setConfig,exports.cold=cold,exports.configureComponent=configureComponent;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=__webpack_require__(206),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.1";


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),m=__webpack_require__(206),r=__webpack_require__(999);function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0)});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden")}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case xa:return"Profiler";case wa:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return(a.displayName||"Context")+".Consumer";case ya:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(y(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId)}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return!1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
function xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift()}return!0}function zc(a,b,c){xc(a)&&c.delete(b)}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&jc.shift()}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc)}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)))}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift()}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d])}}var Qc=r.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F))}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d))}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else{var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else{if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d)}jd(a,b,d,null,c)}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return!1;return!0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ke(c)}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d))}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null)}))}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h))}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u)}w=null}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else{J=De;var K=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value)}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}se(g,b)})}function ef(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function nf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var tf=0;function uf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[wf]||a[ff];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return{current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--)}function I(a,b){Af++;zf[Af]=a.current;a.current=b}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M)}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c)}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return!0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c)}
var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a)}jg()}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null)}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null}}else og=og.next=b}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function zg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k)}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d)}}}var Fg=(new aa.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
var Kg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c)}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null)}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b)}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d)}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=
Wg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}H(ah);I(ah,b)}function fh(){H(ah);H(bh);H(ch)}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c))}function hh(a){bh.current===a&&(H(ah),H(bh))}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c)}jh=a;kh=rf(b.firstChild)}else a.flags=a.flags&-1025|2,lh=!1,jh=a}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a}
function rh(a){if(a!==jh)return!1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}kh=null}}else kh=jh?rf(a.stateNode.nextSibling):null;return!0}
function sh(){kh=jh=null;lh=!1}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e)}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else{if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a}return T}function Jh(a,b){return"function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes}catch(q){c(function(){throw q;})}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return[b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d)}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d)}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0)});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b()}finally{wh.transition=c}})}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d)}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return[d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36))},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d)}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b)}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1)}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo)}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b)}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4)};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf)}mf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d)}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else{if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W)}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else{if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432)}else{if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b)};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Wi(a,c)}else b.current=null}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Eg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else{d=b;try{e()}catch(f){Wi(d,f)}}c=c.next}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){Wi(b,
f)}break;case 5:Vi(b);break;case 4:cj(a,b)}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b)}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c)}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h)}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b))}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O())})}ig()}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function ni(a,b){I(rj,qj);qj|=b;tj|=b}function Ki(){qj=rj.current;H(rj)}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki()}c=c.return}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}yh=!1}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null)}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else{var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var t=zg(-1,1);t.tag=2;Ag(h,t)}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v)}p.flags|=4096;p.lanes=b;break a}p=p.return}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return}while(null!==p)}Zj(c)}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e)}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y)}function Rj(){for(;null!==Y&&!Qf();)bk(Y)}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===V&&(V=5)}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode}w=u}h=-1===A||-1===p?null:{start:A,end:p}}else h=null;h=h||{start:0,end:0}}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek()}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J)}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L}"function"===typeof Q?Q(q):Q.current=q}}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Z=null;$f();X=e}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64))}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return!1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}
function fk(){if(null===yj)return!1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return!0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b))}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b)}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c))}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else{ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c)}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else{e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling}else fi(a,b,d,c),sh();b=b.child}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}fi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return!(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b)}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}this._internalRoot=c}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null)};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null})};function rk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a)}}lk(b,g,a,e)}else{f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a)}}Xj(function(){lk(b,g,a,e)})}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4)}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864)}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c)}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig())}};Ib=function(){0===(X&49)&&(Vj(),Oj())};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.1",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;exports.createPortal=uk;
exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig()}};exports.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
exports.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null})}),!0):!1};exports.unstable_batchedUpdates=Wj;exports.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};exports.version="17.0.1";


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1000);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.20.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0))};g=function(a,b){u=setTimeout(a,b)};h=function(){clearTimeout(u)};exports.unstable_shouldYield=function(){return!1};k=exports.unstable_forceFrameRate=function(){}}else{var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null)}catch(b){throw G.postMessage(null),b;}}else A=!1};f=function(a){B=a;A||(A=!0,G.postMessage(null))};g=function(a,b){C=
x(function(){a(exports.unstable_now())},b)};h=function(){y(C);C=-1}}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M)}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else{var b=J(M);null!==b&&g(U,b.startTime-a)}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b)}else K(L);O=J(L)}if(null!==O)var m=!0;else{var n=J(M);null!==n&&g(U,n.startTime-b);m=!1}return m}finally{O=null,P=c,Q=!1}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V))};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_images_favicon_ico__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_images_favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_images_favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_sass_app_scss__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_sass_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_sass_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Layouts_Layout__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_Login__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Letters_List_Page__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Letters_Single_Train_Page__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Letters_Single_Vessel_Page__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Letters_Single_Size_AnnotatorVesselSizePage__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Letters_SingleNew_Cargo_LetterCargo__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Letters_SingleNew_Hire_LetterHire__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Letters_Single_Sales_Page__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Letters_Single_Gazetter_Page__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Regions_PortsAltNames_Page__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Regions_Ports_Page__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Regions_Port_Page__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Regions_PortAdd_Page__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Regions_AreasAltNames_Page__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Regions_Merging_Page__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Regions_Dashboard_Page__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Regions_PortManagement_PortManagement__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Cargoes_Assigners_CargoEditorPage__ = __webpack_require__(3265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Cargoes_RealNames_RealNamesPage__ = __webpack_require__(3274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Cargoes_Duplicates_Page__ = __webpack_require__(3282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Cargoes_LDRates_Page__ = __webpack_require__(3285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Cargoes_Requests_Page__ = __webpack_require__(3288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Vessels_List_Page__ = __webpack_require__(3293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Vessels_Requests_Page__ = __webpack_require__(3304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Vessels_Sales_VesselSales__ = __webpack_require__(3307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Vessels_Claims_Page__ = __webpack_require__(3310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Vessels_Single_Page__ = __webpack_require__(3313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Statistics_Users_Page__ = __webpack_require__(3319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Statistics_Emails_Page__ = __webpack_require__(3364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Statistics_Monitor_Page__ = __webpack_require__(3367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Statistics_St_Page__ = __webpack_require__(3371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Statistics_Composition_Page__ = __webpack_require__(3378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Users_BanList_Page__ = __webpack_require__(3381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Users_Details__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Users_BlackAndWhiteLists_Page__ = __webpack_require__(3385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Users_SuspiciousSessions_Page__ = __webpack_require__(3390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Gazetteers_Page__ = __webpack_require__(3391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_PackingList_Page__ = __webpack_require__(3397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Letters_Sender_Page__ = __webpack_require__(3403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Letters_Sender_Single__ = __webpack_require__(3404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Domains_Page__ = __webpack_require__(3405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Users_Subscribers_Page__ = __webpack_require__(3410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_BackendNotifications_List__ = __webpack_require__(3412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_TimeCharter__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Fuel__ = __webpack_require__(3417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Disbursement__ = __webpack_require__(3420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_components_Integrators_List_Page__ = __webpack_require__(3423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_components_Integrators_Companies_Page__ = __webpack_require__(3427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_components_Integrators_User_Page__ = __webpack_require__(3430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Cargoes_RequestsLDRates_ReqLDRates__ = __webpack_require__(3433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Statistics_vessel_updater_Page__ = __webpack_require__(3436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Prices_Pda_Pda__ = __webpack_require__(3439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_LoginAsPage__ = __webpack_require__(3443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Letters_SingleNew_TC_LetterTc__ = __webpack_require__(3446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_TimeCharter_Requests_Page__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Companies_CompanyRealName_Page__ = __webpack_require__(3457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Analytics_AnalyticsDashboard__ = __webpack_require__(3462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_FlagCompliance_FlagCompliance__ = __webpack_require__(3467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Detentions_Detentions__ = __webpack_require__(3471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Vessels_Composition_Main__ = __webpack_require__(3476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Vessels_Composition_Composition__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_TcIndex_TcIndex__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Analytics_mailers_Mailers__ = __webpack_require__(3516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Issues_List_List__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Issues_Issue_Issue__ = __webpack_require__(3519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_LoginAsPage_LoginAsPageCustom__ = __webpack_require__(3528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_components_Hires_Hires__ = __webpack_require__(3529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_components_Statistics_Queues_Page__ = __webpack_require__(3545);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















// helpers


// login


// annotations








// gazzeters


// regions









// cargoes






// vessels






// statistics






// users list





// gazetteers


// packing list


// sender email list



// sender email list


// Subscribers


// backend notifications list


// time charter table







// ldrates



// pda




// timecharter



// company real name


// Analytics


// FlagCompliance / detentions



// vessels info composition



// tc index


// mailers


// issue reports





// rabbitmq queues stats


var Authentication = function Authentication(nextState, replace, callback) {
    __WEBPACK_IMPORTED_MODULE_9__services__["a" /* default */].getUser().then(function (response) {
        if (response.status === 200) {
            if (nextState.location.pathname === '/login') {
                replace('/');
            }

            __WEBPACK_IMPORTED_MODULE_6__store_configureStore__["d" /* store */].dispatch({
                type: __WEBPACK_IMPORTED_MODULE_10_constants_ActionTypes__["_54" /* GET_USER */].SUCCESS,
                data: response.data
            });
        }

        if (response.status !== 200) {
            if (nextState.location.pathname !== '/login') {
                replace('/login?backUrl=' + encodeURIComponent(nextState.location.pathname));
            }
        }

        callback();
    }).catch(function () {
        callback();
    });
};

var isAdmin = function isAdmin(nextState, replace, callback) {
    __WEBPACK_IMPORTED_MODULE_9__services__["a" /* default */].getUser().then(function (response) {
        if (response.status === 200 && response.data.role !== 'admin') {
            replace('/');
        }

        callback();
    }).catch(function () {
        callback();
    });
};

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],
                { store: __WEBPACK_IMPORTED_MODULE_6__store_configureStore__["d" /* store */] },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_MuiThemeProvider___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_react_router__["d" /* Router */],
                        { history: __WEBPACK_IMPORTED_MODULE_6__store_configureStore__["c" /* history */] },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                            { onEnter: Authentication },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: '/login', component: __WEBPACK_IMPORTED_MODULE_12__components_Pages_Login__["a" /* default */] }),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                { component: __WEBPACK_IMPORTED_MODULE_11__components_Layouts_Layout__["a" /* default */] },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: '/', component: __WEBPACK_IMPORTED_MODULE_13__components_Letters_List_Page__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'tcIndex', component: __WEBPACK_IMPORTED_MODULE_73__components_TcIndex_TcIndex__["b" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'hires', component: __WEBPACK_IMPORTED_MODULE_78_components_Hires_Hires__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'pda', component: __WEBPACK_IMPORTED_MODULE_63__components_Prices_Pda_Pda__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'flagCompliance', component: __WEBPACK_IMPORTED_MODULE_69__components_FlagCompliance_FlagCompliance__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'detentions', component: __WEBPACK_IMPORTED_MODULE_70__components_Detentions_Detentions__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'cargoes' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'requests', component: __WEBPACK_IMPORTED_MODULE_33__components_Cargoes_Requests_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'requests/ldRates', component: __WEBPACK_IMPORTED_MODULE_61__components_Cargoes_RequestsLDRates_ReqLDRates__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'assigners', component: __WEBPACK_IMPORTED_MODULE_29__components_Cargoes_Assigners_CargoEditorPage__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'realnames', component: __WEBPACK_IMPORTED_MODULE_30__components_Cargoes_RealNames_RealNamesPage__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'duplicates', component: __WEBPACK_IMPORTED_MODULE_31__components_Cargoes_Duplicates_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'ldrates', component: __WEBPACK_IMPORTED_MODULE_32__components_Cargoes_LDRates_Page__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: '/tc' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'requests', component: __WEBPACK_IMPORTED_MODULE_66__components_TimeCharter_Requests_Page__["default"] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: '/integrators' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], {
                                        path: 'list',
                                        component: __WEBPACK_IMPORTED_MODULE_58_components_Integrators_List_Page__["a" /* default */]
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], {
                                        path: 'companies/(:id)',
                                        component: __WEBPACK_IMPORTED_MODULE_59_components_Integrators_Companies_Page__["a" /* default */]
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], {
                                        path: '(:integratorId)/user/(:id)',
                                        component: __WEBPACK_IMPORTED_MODULE_60_components_Integrators_User_Page__["a" /* default */]
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'regions' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'altports', component: __WEBPACK_IMPORTED_MODULE_21__components_Regions_PortsAltNames_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'ports', component: __WEBPACK_IMPORTED_MODULE_22__components_Regions_Ports_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'ports/add', component: __WEBPACK_IMPORTED_MODULE_24__components_Regions_PortAdd_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'ports/approve/:id', component: __WEBPACK_IMPORTED_MODULE_28__components_Regions_PortManagement_PortManagement__["b" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'ports/:id', component: __WEBPACK_IMPORTED_MODULE_23__components_Regions_Port_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'altareas', component: __WEBPACK_IMPORTED_MODULE_25__components_Regions_AreasAltNames_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'merging', component: __WEBPACK_IMPORTED_MODULE_26__components_Regions_Merging_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'dashboard', component: __WEBPACK_IMPORTED_MODULE_27__components_Regions_Dashboard_Page__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'vessels' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'claims', component: __WEBPACK_IMPORTED_MODULE_37__components_Vessels_Claims_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'requests', component: __WEBPACK_IMPORTED_MODULE_35__components_Vessels_Requests_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'list', component: __WEBPACK_IMPORTED_MODULE_34__components_Vessels_List_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'add', component: __WEBPACK_IMPORTED_MODULE_38__components_Vessels_Single_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'sales', component: __WEBPACK_IMPORTED_MODULE_36__components_Vessels_Sales_VesselSales__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'composition', component: __WEBPACK_IMPORTED_MODULE_71__components_Vessels_Composition_Main__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'composition/:id', component: __WEBPACK_IMPORTED_MODULE_72__components_Vessels_Composition_Composition__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id', component: __WEBPACK_IMPORTED_MODULE_38__components_Vessels_Single_Page__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'statistics', onEnter: isAdmin },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'users', component: __WEBPACK_IMPORTED_MODULE_39__components_Statistics_Users_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'emails', component: __WEBPACK_IMPORTED_MODULE_40__components_Statistics_Emails_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'monitor', component: __WEBPACK_IMPORTED_MODULE_41__components_Statistics_Monitor_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'st', component: __WEBPACK_IMPORTED_MODULE_42__components_Statistics_St_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'vessel-updater', component: __WEBPACK_IMPORTED_MODULE_62__components_Statistics_vessel_updater_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'composition', component: __WEBPACK_IMPORTED_MODULE_43__components_Statistics_Composition_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'queues', component: __WEBPACK_IMPORTED_MODULE_79_components_Statistics_Queues_Page__["a" /* StatsRabbitmq */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'sender', onEnter: isAdmin },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'list', component: __WEBPACK_IMPORTED_MODULE_50__components_Letters_Sender_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id', component: __WEBPACK_IMPORTED_MODULE_51__components_Letters_Sender_Single__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'users', onEnter: isAdmin },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'ban-list', component: __WEBPACK_IMPORTED_MODULE_44__components_Users_BanList_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'black-and-white-lists', component: __WEBPACK_IMPORTED_MODULE_46__components_Users_BlackAndWhiteLists_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'subscribers', component: __WEBPACK_IMPORTED_MODULE_53__components_Users_Subscribers_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'suspicious', component: __WEBPACK_IMPORTED_MODULE_47__components_Users_SuspiciousSessions_Page__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id', component: __WEBPACK_IMPORTED_MODULE_45__components_Users_Details__["default"] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    {
                                        path: 'analytics'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'dashboard', component: __WEBPACK_IMPORTED_MODULE_68__components_Analytics_AnalyticsDashboard__["a" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'mailers', component: __WEBPACK_IMPORTED_MODULE_74__components_Analytics_mailers_Mailers__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'notifications' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'list', component: __WEBPACK_IMPORTED_MODULE_54__components_BackendNotifications_List__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'gazetteer-editor', component: __WEBPACK_IMPORTED_MODULE_48__components_Gazetteers_Page__["a" /* default */] }),
                                false && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'packing-list-recognition', onEnter: isAdmin, component: __WEBPACK_IMPORTED_MODULE_49__components_PackingList_Page__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'domains', component: __WEBPACK_IMPORTED_MODULE_52__components_Domains_Page__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'time-charter', component: __WEBPACK_IMPORTED_MODULE_55__components_TimeCharter__["default"] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'fuel', component: __WEBPACK_IMPORTED_MODULE_56__components_Fuel__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'disbursement', component: __WEBPACK_IMPORTED_MODULE_57__components_Disbursement__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: '/dev-only', component: __WEBPACK_IMPORTED_MODULE_64__components_LoginAsPage__["a" /* LoginAsPage */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: '/varamar-only', component: __WEBPACK_IMPORTED_MODULE_77__components_LoginAsPage_LoginAsPageCustom__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: '/:id/train', component: __WEBPACK_IMPORTED_MODULE_14__components_Letters_Single_Train_Page__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: '/:id', component: __WEBPACK_IMPORTED_MODULE_20__components_Letters_Single_Gazetter_Page__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id/annotator/vessel', component: __WEBPACK_IMPORTED_MODULE_15__components_Letters_Single_Vessel_Page__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id/annotator/cargo', component: __WEBPACK_IMPORTED_MODULE_17__components_Letters_SingleNew_Cargo_LetterCargo__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id/annotator/hire', component: __WEBPACK_IMPORTED_MODULE_18__components_Letters_SingleNew_Hire_LetterHire__["b" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["b" /* Redirect */], { from: ':id/annotator/cargo/new', to: ':id/annotator/cargo' }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id/size/vessel', component: __WEBPACK_IMPORTED_MODULE_16__components_Letters_Single_Size_AnnotatorVesselSizePage__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id/annotator/tc', component: __WEBPACK_IMPORTED_MODULE_65__components_Letters_SingleNew_TC_LetterTc__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id/sales', component: __WEBPACK_IMPORTED_MODULE_19__components_Letters_Single_Sales_Page__["a" /* default */] }),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'companies' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'realnames', component: __WEBPACK_IMPORTED_MODULE_67__components_Companies_CompanyRealName_Page__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */],
                                    { path: 'issues' },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: 'list', component: __WEBPACK_IMPORTED_MODULE_75__components_Issues_List_List__["b" /* default */] }),
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: ':id', component: __WEBPACK_IMPORTED_MODULE_76__components_Issues_Issue_Issue__["a" /* default */] })
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Route */], { path: '*', component: __WEBPACK_IMPORTED_MODULE_13__components_Letters_List_Page__["a" /* default */], status: 404 })
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

var _default = App;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Authentication, 'Authentication', '/opt/atlassian/pipelines/agent/build/client/app/App.jsx');
    reactHotLoader.register(isAdmin, 'isAdmin', '/opt/atlassian/pipelines/agent/build/client/app/App.jsx');
    reactHotLoader.register(App, 'App', '/opt/atlassian/pipelines/agent/build/client/app/App.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/App.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128289
      var cssReload = require("!../css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1004);

__webpack_require__(1200);

__webpack_require__(1201);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1005);
__webpack_require__(1007);
__webpack_require__(1008);
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);
__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(1028);
__webpack_require__(1029);
__webpack_require__(1030);
__webpack_require__(1031);
__webpack_require__(1032);
__webpack_require__(1033);
__webpack_require__(1034);
__webpack_require__(1035);
__webpack_require__(1036);
__webpack_require__(1037);
__webpack_require__(1038);
__webpack_require__(1039);
__webpack_require__(1040);
__webpack_require__(1041);
__webpack_require__(1042);
__webpack_require__(1043);
__webpack_require__(1044);
__webpack_require__(1045);
__webpack_require__(1046);
__webpack_require__(1047);
__webpack_require__(1048);
__webpack_require__(1049);
__webpack_require__(1050);
__webpack_require__(1051);
__webpack_require__(1052);
__webpack_require__(1053);
__webpack_require__(1054);
__webpack_require__(1055);
__webpack_require__(1056);
__webpack_require__(1057);
__webpack_require__(1058);
__webpack_require__(1059);
__webpack_require__(1060);
__webpack_require__(1061);
__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(1064);
__webpack_require__(1065);
__webpack_require__(1066);
__webpack_require__(1067);
__webpack_require__(1068);
__webpack_require__(1069);
__webpack_require__(1070);
__webpack_require__(1071);
__webpack_require__(1072);
__webpack_require__(1073);
__webpack_require__(1074);
__webpack_require__(1075);
__webpack_require__(1076);
__webpack_require__(1077);
__webpack_require__(1078);
__webpack_require__(1079);
__webpack_require__(1080);
__webpack_require__(1081);
__webpack_require__(1082);
__webpack_require__(1084);
__webpack_require__(1085);
__webpack_require__(1087);
__webpack_require__(1088);
__webpack_require__(1089);
__webpack_require__(1090);
__webpack_require__(1091);
__webpack_require__(1092);
__webpack_require__(1093);
__webpack_require__(1095);
__webpack_require__(1096);
__webpack_require__(1097);
__webpack_require__(1098);
__webpack_require__(1099);
__webpack_require__(1100);
__webpack_require__(1101);
__webpack_require__(1102);
__webpack_require__(1103);
__webpack_require__(1104);
__webpack_require__(1105);
__webpack_require__(1106);
__webpack_require__(1107);
__webpack_require__(421);
__webpack_require__(1108);
__webpack_require__(602);
__webpack_require__(1109);
__webpack_require__(603);
__webpack_require__(1110);
__webpack_require__(1111);
__webpack_require__(1112);
__webpack_require__(1113);
__webpack_require__(1114);
__webpack_require__(606);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(1115);
__webpack_require__(1116);
__webpack_require__(1117);
__webpack_require__(1118);
__webpack_require__(1119);
__webpack_require__(1120);
__webpack_require__(1121);
__webpack_require__(1122);
__webpack_require__(1123);
__webpack_require__(1124);
__webpack_require__(1125);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1128);
__webpack_require__(1129);
__webpack_require__(1130);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1135);
__webpack_require__(1136);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1140);
__webpack_require__(1141);
__webpack_require__(1142);
__webpack_require__(1143);
__webpack_require__(1144);
__webpack_require__(1145);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(1155);
__webpack_require__(1156);
__webpack_require__(1157);
__webpack_require__(1158);
__webpack_require__(1159);
__webpack_require__(1160);
__webpack_require__(1161);
__webpack_require__(1162);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
__webpack_require__(1171);
__webpack_require__(1172);
__webpack_require__(1173);
__webpack_require__(1174);
__webpack_require__(1175);
__webpack_require__(1176);
__webpack_require__(1177);
__webpack_require__(1178);
__webpack_require__(1179);
__webpack_require__(1180);
__webpack_require__(1181);
__webpack_require__(1182);
__webpack_require__(1183);
__webpack_require__(1184);
__webpack_require__(1185);
__webpack_require__(1186);
__webpack_require__(1187);
__webpack_require__(1188);
__webpack_require__(1189);
__webpack_require__(1190);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(1196);
__webpack_require__(1197);
__webpack_require__(1198);
__webpack_require__(1199);
module.exports = __webpack_require__(107);


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(42);
var has = __webpack_require__(92);
var DESCRIPTORS = __webpack_require__(65);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(87);
var META = __webpack_require__(147).KEY;
var $fails = __webpack_require__(47);
var shared = __webpack_require__(293);
var setToStringTag = __webpack_require__(207);
var uid = __webpack_require__(171);
var wks = __webpack_require__(59);
var wksExt = __webpack_require__(584);
var wksDefine = __webpack_require__(402);
var enumKeys = __webpack_require__(1006);
var isArray = __webpack_require__(296);
var anObject = __webpack_require__(37);
var isObject = __webpack_require__(48);
var toIObject = __webpack_require__(93);
var toPrimitive = __webpack_require__(118);
var createDesc = __webpack_require__(170);
var _create = __webpack_require__(174);
var gOPNExt = __webpack_require__(587);
var $GOPD = __webpack_require__(94);
var $DP = __webpack_require__(66);
var $keys = __webpack_require__(172);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(175).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(245).f = $propertyIsEnumerable;
  __webpack_require__(295).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(148)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(86)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(172);
var gOPS = __webpack_require__(295);
var pIE = __webpack_require__(245);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(174) });


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(65), 'Object', { defineProperty: __webpack_require__(66).f });


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(65), 'Object', { defineProperties: __webpack_require__(586) });


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(93);
var $getOwnPropertyDescriptor = __webpack_require__(94).f;

__webpack_require__(120)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(68);
var $getPrototypeOf = __webpack_require__(95);

__webpack_require__(120)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(68);
var $keys = __webpack_require__(172);

__webpack_require__(120)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(120)('getOwnPropertyNames', function () {
  return __webpack_require__(587).f;
});


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(147).onFreeze;

__webpack_require__(120)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(147).onFreeze;

__webpack_require__(120)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(48);
var meta = __webpack_require__(147).onFreeze;

__webpack_require__(120)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(48);

__webpack_require__(120)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(48);

__webpack_require__(120)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(48);

__webpack_require__(120)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(12);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(588) });


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(12);
$export($export.S, 'Object', { is: __webpack_require__(589) });


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(12);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(406).set });


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(208);
var test = {};
test[__webpack_require__(59)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(87)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(12);

$export($export.P, 'Function', { bind: __webpack_require__(590) });


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(66).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(65) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(95);
var HAS_INSTANCE = __webpack_require__(59)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(66).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseInt = __webpack_require__(592);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseFloat = __webpack_require__(593);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(42);
var has = __webpack_require__(92);
var cof = __webpack_require__(109);
var inheritIfRequired = __webpack_require__(408);
var toPrimitive = __webpack_require__(118);
var fails = __webpack_require__(47);
var gOPN = __webpack_require__(175).f;
var gOPD = __webpack_require__(94).f;
var dP = __webpack_require__(66).f;
var $trim = __webpack_require__(209).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(174)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(65) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(87)(global, NUMBER, $Number);
}


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toInteger = __webpack_require__(110);
var aNumberValue = __webpack_require__(594);
var repeat = __webpack_require__(409);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(47)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $fails = __webpack_require__(47);
var aNumberValue = __webpack_require__(594);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(12);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(12);
var _isFinite = __webpack_require__(42).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(12);

$export($export.S, 'Number', { isInteger: __webpack_require__(595) });


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(12);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(12);
var isInteger = __webpack_require__(595);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(12);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(12);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseFloat = __webpack_require__(593);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseInt = __webpack_require__(592);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(12);
var log1p = __webpack_require__(596);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(12);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(12);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(12);
var sign = __webpack_require__(410);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(12);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(12);
var $expm1 = __webpack_require__(411);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', { fround: __webpack_require__(597) });


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(12);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(12);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(47)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', { log1p: __webpack_require__(596) });


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', { sign: __webpack_require__(410) });


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(12);
var expm1 = __webpack_require__(411);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(47)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(12);
var expm1 = __webpack_require__(411);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(173);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var toIObject = __webpack_require__(93);
var toLength = __webpack_require__(60);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(209)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(297)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(412)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $at = __webpack_require__(297)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(12);
var toLength = __webpack_require__(60);
var context = __webpack_require__(414);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(415)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(12);
var context = __webpack_require__(414);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(415)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(409)
});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(12);
var toLength = __webpack_require__(60);
var context = __webpack_require__(414);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(415)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(88)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(88)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(88)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(88)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(88)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(88)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(88)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(88)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(88)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(88)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(88)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(88)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(88)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(12);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(118);

$export($export.P + $export.F * __webpack_require__(47)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(12);
var toISOString = __webpack_require__(1083);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(47);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(87)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(59)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(86)(proto, TO_PRIMITIVE, __webpack_require__(1086));


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(118);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(12);

$export($export.S, 'Array', { isArray: __webpack_require__(296) });


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(108);
var $export = __webpack_require__(12);
var toObject = __webpack_require__(68);
var call = __webpack_require__(598);
var isArrayIter = __webpack_require__(416);
var toLength = __webpack_require__(60);
var createProperty = __webpack_require__(417);
var getIterFn = __webpack_require__(418);

$export($export.S + $export.F * !__webpack_require__(299)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var createProperty = __webpack_require__(417);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(47)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(12);
var toIObject = __webpack_require__(93);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(244) != Object || !__webpack_require__(111)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var html = __webpack_require__(405);
var cof = __webpack_require__(109);
var toAbsoluteIndex = __webpack_require__(173);
var toLength = __webpack_require__(60);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(47)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var aFunction = __webpack_require__(76);
var toObject = __webpack_require__(68);
var fails = __webpack_require__(47);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(111)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $forEach = __webpack_require__(121)(0);
var STRICT = __webpack_require__(111)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);
var isArray = __webpack_require__(296);
var SPECIES = __webpack_require__(59)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $map = __webpack_require__(121)(1);

$export($export.P + $export.F * !__webpack_require__(111)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $filter = __webpack_require__(121)(2);

$export($export.P + $export.F * !__webpack_require__(111)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $some = __webpack_require__(121)(3);

$export($export.P + $export.F * !__webpack_require__(111)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $every = __webpack_require__(121)(4);

$export($export.P + $export.F * !__webpack_require__(111)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $reduce = __webpack_require__(599);

$export($export.P + $export.F * !__webpack_require__(111)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $reduce = __webpack_require__(599);

$export($export.P + $export.F * !__webpack_require__(111)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $indexOf = __webpack_require__(294)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(111)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toIObject = __webpack_require__(93);
var toInteger = __webpack_require__(110);
var toLength = __webpack_require__(60);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(111)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(12);

$export($export.P, 'Array', { copyWithin: __webpack_require__(600) });

__webpack_require__(149)('copyWithin');


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(12);

$export($export.P, 'Array', { fill: __webpack_require__(420) });

__webpack_require__(149)('fill');


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(12);
var $find = __webpack_require__(121)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(149)(KEY);


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(12);
var $find = __webpack_require__(121)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(149)(KEY);


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(176)('Array');


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(42);
var inheritIfRequired = __webpack_require__(408);
var dP = __webpack_require__(66).f;
var gOPN = __webpack_require__(175).f;
var isRegExp = __webpack_require__(298);
var $flags = __webpack_require__(246);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(65) && (!CORRECT_NEW || __webpack_require__(47)(function () {
  re2[__webpack_require__(59)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(87)(global, 'RegExp', $RegExp);
}

__webpack_require__(176)('RegExp');


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(603);
var anObject = __webpack_require__(37);
var $flags = __webpack_require__(246);
var DESCRIPTORS = __webpack_require__(65);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(87)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(47)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(37);
var toLength = __webpack_require__(60);
var advanceStringIndex = __webpack_require__(423);
var regExpExec = __webpack_require__(300);

// @@match logic
__webpack_require__(301)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(37);
var toObject = __webpack_require__(68);
var toLength = __webpack_require__(60);
var toInteger = __webpack_require__(110);
var advanceStringIndex = __webpack_require__(423);
var regExpExec = __webpack_require__(300);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(301)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return ch;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return ch;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return ch;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(37);
var sameValue = __webpack_require__(589);
var regExpExec = __webpack_require__(300);

// @@search logic
__webpack_require__(301)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(298);
var anObject = __webpack_require__(37);
var speciesConstructor = __webpack_require__(247);
var advanceStringIndex = __webpack_require__(423);
var toLength = __webpack_require__(60);
var callRegExpExec = __webpack_require__(300);
var regexpExec = __webpack_require__(422);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';

// eslint-disable-next-line no-empty
var SUPPORTS_Y = !!(function () { try { return new RegExp('x', 'y'); } catch (e) {} })();

// @@split logic
__webpack_require__(301)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                    (rx.multiline ? 'm' : '') +
                    (rx.unicode ? 'u' : '') +
                    (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? 0xffffffff : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(148);
var global = __webpack_require__(42);
var ctx = __webpack_require__(108);
var classof = __webpack_require__(208);
var $export = __webpack_require__(12);
var isObject = __webpack_require__(48);
var aFunction = __webpack_require__(76);
var anInstance = __webpack_require__(177);
var forOf = __webpack_require__(178);
var speciesConstructor = __webpack_require__(247);
var task = __webpack_require__(424).set;
var microtask = __webpack_require__(425)();
var newPromiseCapabilityModule = __webpack_require__(426);
var perform = __webpack_require__(604);
var userAgent = __webpack_require__(302);
var promiseResolve = __webpack_require__(605);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(59)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(179)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(207)($Promise, PROMISE);
__webpack_require__(176)(PROMISE);
Wrapper = __webpack_require__(107)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(299)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(610);
var validate = __webpack_require__(211);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(303)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $typed = __webpack_require__(304);
var buffer = __webpack_require__(427);
var anObject = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(173);
var toLength = __webpack_require__(60);
var isObject = __webpack_require__(48);
var ArrayBuffer = __webpack_require__(42).ArrayBuffer;
var speciesConstructor = __webpack_require__(247);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(47)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(176)(ARRAY_BUFFER);


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
$export($export.G + $export.W + $export.F * !__webpack_require__(304).ABV, {
  DataView: __webpack_require__(427).DataView
});


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(12);
var aFunction = __webpack_require__(76);
var anObject = __webpack_require__(37);
var rApply = (__webpack_require__(42).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(47)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(12);
var create = __webpack_require__(174);
var aFunction = __webpack_require__(76);
var anObject = __webpack_require__(37);
var isObject = __webpack_require__(48);
var fails = __webpack_require__(47);
var bind = __webpack_require__(590);
var rConstruct = (__webpack_require__(42).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(66);
var $export = __webpack_require__(12);
var anObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(118);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(47)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(12);
var gOPD = __webpack_require__(94).f;
var anObject = __webpack_require__(37);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(12);
var anObject = __webpack_require__(37);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(413)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(94);
var getPrototypeOf = __webpack_require__(95);
var has = __webpack_require__(92);
var $export = __webpack_require__(12);
var isObject = __webpack_require__(48);
var anObject = __webpack_require__(37);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(94);
var $export = __webpack_require__(12);
var anObject = __webpack_require__(37);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(12);
var getProto = __webpack_require__(95);
var anObject = __webpack_require__(37);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(12);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(12);
var anObject = __webpack_require__(37);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(12);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(612) });


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(12);
var anObject = __webpack_require__(37);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(66);
var gOPD = __webpack_require__(94);
var getPrototypeOf = __webpack_require__(95);
var has = __webpack_require__(92);
var $export = __webpack_require__(12);
var createDesc = __webpack_require__(170);
var anObject = __webpack_require__(37);
var isObject = __webpack_require__(48);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(12);
var setProto = __webpack_require__(406);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(12);
var $includes = __webpack_require__(294)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(149)('includes');


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(12);
var flattenIntoArray = __webpack_require__(613);
var toObject = __webpack_require__(68);
var toLength = __webpack_require__(60);
var aFunction = __webpack_require__(76);
var arraySpeciesCreate = __webpack_require__(419);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(149)('flatMap');


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(12);
var flattenIntoArray = __webpack_require__(613);
var toObject = __webpack_require__(68);
var toLength = __webpack_require__(60);
var toInteger = __webpack_require__(110);
var arraySpeciesCreate = __webpack_require__(419);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(149)('flatten');


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(12);
var $at = __webpack_require__(297)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(12);
var $pad = __webpack_require__(614);
var userAgent = __webpack_require__(302);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(12);
var $pad = __webpack_require__(614);
var userAgent = __webpack_require__(302);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(209)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(209)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(12);
var defined = __webpack_require__(119);
var toLength = __webpack_require__(60);
var isRegExp = __webpack_require__(298);
var getFlags = __webpack_require__(246);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(413)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(402)('asyncIterator');


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(402)('observable');


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(12);
var ownKeys = __webpack_require__(612);
var toIObject = __webpack_require__(93);
var gOPD = __webpack_require__(94);
var createProperty = __webpack_require__(417);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(12);
var $values = __webpack_require__(615)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(12);
var $entries = __webpack_require__(615)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toObject = __webpack_require__(68);
var aFunction = __webpack_require__(76);
var $defineProperty = __webpack_require__(66);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(65) && $export($export.P + __webpack_require__(305), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toObject = __webpack_require__(68);
var aFunction = __webpack_require__(76);
var $defineProperty = __webpack_require__(66);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(65) && $export($export.P + __webpack_require__(305), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(118);
var getPrototypeOf = __webpack_require__(95);
var getOwnPropertyDescriptor = __webpack_require__(94).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(65) && $export($export.P + __webpack_require__(305), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(118);
var getPrototypeOf = __webpack_require__(95);
var getOwnPropertyDescriptor = __webpack_require__(94).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(65) && $export($export.P + __webpack_require__(305), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(12);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(616)('Map') });


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(12);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(616)('Set') });


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(306)('Map');


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(306)('Set');


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(306)('WeakMap');


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(306)('WeakSet');


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(307)('Map');


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(307)('Set');


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(307)('WeakMap');


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(307)('WeakSet');


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(12);

$export($export.G, { global: __webpack_require__(42) });


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(12);

$export($export.S, 'System', { global: __webpack_require__(42) });


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(12);
var cof = __webpack_require__(109);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(12);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(12);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(12);
var scale = __webpack_require__(618);
var fround = __webpack_require__(597);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(12);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(12);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(12);

$export($export.S, 'Math', { scale: __webpack_require__(618) });


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(12);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(12);
var core = __webpack_require__(107);
var global = __webpack_require__(42);
var speciesConstructor = __webpack_require__(247);
var promiseResolve = __webpack_require__(605);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(12);
var newPromiseCapability = __webpack_require__(426);
var perform = __webpack_require__(604);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(95);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(608);
var from = __webpack_require__(617);
var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(95);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(95);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(134);
var anObject = __webpack_require__(37);
var aFunction = __webpack_require__(76);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(12);
var microtask = __webpack_require__(425)();
var process = __webpack_require__(42).process;
var isNode = __webpack_require__(109)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(12);
var global = __webpack_require__(42);
var core = __webpack_require__(107);
var microtask = __webpack_require__(425)();
var OBSERVABLE = __webpack_require__(59)('observable');
var aFunction = __webpack_require__(76);
var anObject = __webpack_require__(37);
var anInstance = __webpack_require__(177);
var redefineAll = __webpack_require__(179);
var hide = __webpack_require__(86);
var forOf = __webpack_require__(178);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(176)('Observable');


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(42);
var $export = __webpack_require__(12);
var userAgent = __webpack_require__(302);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $task = __webpack_require__(424);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(421);
var getKeys = __webpack_require__(172);
var redefine = __webpack_require__(87);
var global = __webpack_require__(42);
var hide = __webpack_require__(86);
var Iterators = __webpack_require__(210);
var wks = __webpack_require__(59);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1202);
module.exports = __webpack_require__(107).RegExp.escape;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(12);
var $re = __webpack_require__(1203)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(428);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1206);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1209);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1223);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(627);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(308);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(625);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(626);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(627);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(628);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1224);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(428);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(213);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(206);

var emptyObject = __webpack_require__(1227);
var _invariant = __webpack_require__(1228);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(214);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(432);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(214);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(630);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(150);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(214);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(632);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(435);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(248);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(248);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRoute);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(248);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(631);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1242);
var objectAssign = __webpack_require__(206);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(215);

var _PathUtils = __webpack_require__(151);

var _createHistory = __webpack_require__(437);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(309);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(213);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(639);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(438);

var _BrowserProtocol = __webpack_require__(439);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1248);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(310);

var _createHistory = __webpack_require__(437);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(439);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(215);

var _PathUtils = __webpack_require__(151);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(639);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(438);

var _DOMUtils = __webpack_require__(310);

var _HashProtocol = __webpack_require__(1251);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(437);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(439);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(215);

var _DOMUtils = __webpack_require__(310);

var _DOMStateStorage = __webpack_require__(638);

var _PathUtils = __webpack_require__(151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1253);
module.exports = __webpack_require__(73).Object.getPrototypeOf;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(249);
var $getPrototypeOf = __webpack_require__(641);

__webpack_require__(443)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1256);
var $Object = __webpack_require__(73).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(153);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(184), 'Object', { defineProperty: __webpack_require__(154).f });


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1258), __esModule: true };

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(313);
__webpack_require__(451);
module.exports = __webpack_require__(452).f('iterator');


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(446);
var defined = __webpack_require__(440);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(447);
var descriptor = __webpack_require__(250);
var setToStringTag = __webpack_require__(450);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(216)(IteratorPrototype, __webpack_require__(112)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(154);
var anObject = __webpack_require__(183);
var getKeys = __webpack_require__(252);

module.exports = __webpack_require__(184) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(185);
var toLength = __webpack_require__(649);
var toAbsoluteIndex = __webpack_require__(1263);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(446);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(152).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1266);
var step = __webpack_require__(1267);
var Iterators = __webpack_require__(219);
var toIObject = __webpack_require__(185);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(645)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1269), __esModule: true };

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1270);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
module.exports = __webpack_require__(73).Symbol;


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(152);
var has = __webpack_require__(182);
var DESCRIPTORS = __webpack_require__(184);
var $export = __webpack_require__(153);
var redefine = __webpack_require__(646);
var META = __webpack_require__(1271).KEY;
var $fails = __webpack_require__(218);
var shared = __webpack_require__(442);
var setToStringTag = __webpack_require__(450);
var uid = __webpack_require__(312);
var wks = __webpack_require__(112);
var wksExt = __webpack_require__(452);
var wksDefine = __webpack_require__(453);
var enumKeys = __webpack_require__(1272);
var isArray = __webpack_require__(1273);
var anObject = __webpack_require__(183);
var isObject = __webpack_require__(217);
var toIObject = __webpack_require__(185);
var toPrimitive = __webpack_require__(445);
var createDesc = __webpack_require__(250);
var _create = __webpack_require__(447);
var gOPNExt = __webpack_require__(1274);
var $GOPD = __webpack_require__(455);
var $DP = __webpack_require__(154);
var $keys = __webpack_require__(252);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(650).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(314).f = $propertyIsEnumerable;
  __webpack_require__(454).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(311)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(216)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(312)('meta');
var isObject = __webpack_require__(217);
var has = __webpack_require__(182);
var setDesc = __webpack_require__(154).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(218)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(252);
var gOPS = __webpack_require__(454);
var pIE = __webpack_require__(314);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(448);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(185);
var gOPN = __webpack_require__(650).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1275 */
/***/ (function(module, exports) {



/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(453)('asyncIterator');


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(453)('observable');


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1279), __esModule: true };

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1280);
module.exports = __webpack_require__(73).Object.setPrototypeOf;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(153);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1281).set });


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(217);
var anObject = __webpack_require__(183);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(444)(Function.call, __webpack_require__(455).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1283), __esModule: true };

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1284);
var $Object = __webpack_require__(73).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(153);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(447) });


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(220);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = getMuiTheme;

var _lodash = __webpack_require__(1292);

var _lodash2 = _interopRequireDefault(_lodash);

var _colorManipulator = __webpack_require__(155);

var _lightBaseTheme = __webpack_require__(1293);

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

var _zIndex = __webpack_require__(1295);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _autoprefixer = __webpack_require__(1296);

var _autoprefixer2 = _interopRequireDefault(_autoprefixer);

var _callOnce = __webpack_require__(1321);

var _callOnce2 = _interopRequireDefault(_callOnce);

var _rtl = __webpack_require__(1322);

var _rtl2 = _interopRequireDefault(_rtl);

var _compose = __webpack_require__(1325);

var _compose2 = _interopRequireDefault(_compose);

var _typography = __webpack_require__(1326);

var _typography2 = _interopRequireDefault(_typography);

var _colors = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: _colors.darkWhite,
      overlayContentBackground: _colors.lightBlack,
      titleColor: _colors.darkWhite,
      subtitleColor: _colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: _colors.transparent
    },
    flatButton: {
      color: _colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: _colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: _colors.grey600,
      rightIconColor: _colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: _colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: _colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: _colors.grey700,
      inactiveIconColor: _colors.grey500,
      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
      connectorLineColor: _colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: _colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: _colors.white,
      rippleBackgroundColor: _colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(313);
__webpack_require__(1287);
module.exports = __webpack_require__(73).Array.from;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(444);
var $export = __webpack_require__(153);
var toObject = __webpack_require__(249);
var call = __webpack_require__(1288);
var isArrayIter = __webpack_require__(1289);
var toLength = __webpack_require__(649);
var createProperty = __webpack_require__(1290);
var getIterFn = __webpack_require__(652);

$export($export.S + $export.F * !__webpack_require__(1291)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(183);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(219);
var ITERATOR = __webpack_require__(112)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(154);
var createDesc = __webpack_require__(250);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(112)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80), __webpack_require__(186)(module)))

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(81);

var _colorManipulator = __webpack_require__(155);

var _spacing = __webpack_require__(1294);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey400,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  var isClient = typeof navigator !== 'undefined';
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && isClient) {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
      var stylePrefixed = prefixAll(style);

      if (isFlex) {
        var display = stylePrefixed.display;
        if (isClient) {
          // We can't apply this join with react-dom:
          // #https://github.com/facebook/react/issues/6467
          stylePrefixed.display = display[display.length - 1];
        } else {
          stylePrefixed.display = display.join('; display: ');
        }
      }

      return stylePrefixed;
    };
  } else {
    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
    var prefixer = new Prefixer({
      userAgent: userAgent
    });

    return function (style) {
      return prefixer.prefix(style);
    };
  }
};

var _createPrefixer = __webpack_require__(1297);

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _createPrefixer3 = __webpack_require__(1299);

var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);

var _autoprefixerDynamic = __webpack_require__(1304);

var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);

var _autoprefixerStatic = __webpack_require__(1313);

var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasWarnedAboutUserAgent = false;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(1298);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(654);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(655);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(656);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(456);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createPrefixer;

var _getBrowserInformation = __webpack_require__(1300);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(1303);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(456);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _addNewValuesOnly = __webpack_require__(655);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(656);

var _isObject2 = _interopRequireDefault(_isObject);

var _prefixValue = __webpack_require__(654);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
    return style;
  };

  return function () {
    /**
    * Instantiante a new prefixer
    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
    * @param {string} keepUnprefixed - keeps unprefixed properties and values
    */
    function Prefixer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Prefixer);

      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

      this._userAgent = options.userAgent || defaultUserAgent;
      this._keepUnprefixed = options.keepUnprefixed || false;

      if (this._userAgent) {
        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
      }

      // Checks if the userAgent was resolved correctly
      if (this._browserInfo && this._browserInfo.cssPrefix) {
        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
      } else {
        this._useFallback = true;
        return false;
      }

      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
      if (prefixData) {
        this._requiresPrefix = {};

        for (var property in prefixData) {
          if (prefixData[property] >= this._browserInfo.browserVersion) {
            this._requiresPrefix[property] = true;
          }
        }

        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
      } else {
        this._useFallback = true;
      }

      this._metaData = {
        browserVersion: this._browserInfo.browserVersion,
        browserName: this._browserInfo.browserName,
        cssPrefix: this._browserInfo.cssPrefix,
        jsPrefix: this._browserInfo.jsPrefix,
        keepUnprefixed: this._keepUnprefixed,
        requiresPrefix: this._requiresPrefix
      };
    }

    _createClass(Prefixer, [{
      key: 'prefix',
      value: function prefix(style) {
        // use static prefixer as fallback if userAgent can not be resolved
        if (this._useFallback) {
          return fallback(style);
        }

        // only add prefixes if needed
        if (!this._hasPropsRequiringPrefix) {
          return style;
        }

        return this._prefixStyle(style);
      }
    }, {
      key: '_prefixStyle',
      value: function _prefixStyle(style) {
        for (var property in style) {
          var value = style[property];

          // handle nested objects
          if ((0, _isObject2.default)(value)) {
            style[property] = this.prefix(value);
            // handle array values
          } else if (Array.isArray(value)) {
            var combinedValue = [];

            for (var i = 0, len = value.length; i < len; ++i) {
              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
            }

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (combinedValue.length > 0) {
              style[property] = combinedValue;
            }
          } else {
            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (_processedValue) {
              style[property] = _processedValue;
            }

            // add prefixes to properties
            if (this._requiresPrefix.hasOwnProperty(property)) {
              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
              if (!this._keepUnprefixed) {
                delete style[property];
              }
            }
          }
        }

        return style;
      }

      /**
      * Returns a prefixed version of the style object using all vendor prefixes
      * @param {Object} styles - Style object that gets prefixed properties added
      * @returns {Object} - Style object with prefixed properties and values
      */

    }], [{
      key: 'prefixAll',
      value: function prefixAll(styles) {
        return fallback(styles);
      }
    }]);

    return Prefixer;
  }();
}
module.exports = exports['default'];

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserInformation;

var _bowser = __webpack_require__(1301);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixByBrowser = {
  chrome: 'Webkit',
  safari: 'Webkit',
  ios: 'Webkit',
  android: 'Webkit',
  phantom: 'Webkit',
  opera: 'Webkit',
  webos: 'Webkit',
  blackberry: 'Webkit',
  bada: 'Webkit',
  tizen: 'Webkit',
  chromium: 'Webkit',
  vivaldi: 'Webkit',
  firefox: 'Moz',
  seamoney: 'Moz',
  sailfish: 'Moz',
  msie: 'ms',
  msedge: 'ms'
};


var browserByCanIuseAlias = {
  chrome: 'chrome',
  chromium: 'chrome',
  safari: 'safari',
  firfox: 'firefox',
  msedge: 'edge',
  opera: 'opera',
  vivaldi: 'opera',
  msie: 'ie'
};

function getBrowserName(browserInfo) {
  if (browserInfo.firefox) {
    return 'firefox';
  }

  if (browserInfo.mobile || browserInfo.tablet) {
    if (browserInfo.ios) {
      return 'ios_saf';
    } else if (browserInfo.android) {
      return 'android';
    } else if (browserInfo.opera) {
      return 'op_mini';
    }
  }

  for (var browser in browserByCanIuseAlias) {
    if (browserInfo.hasOwnProperty(browser)) {
      return browserByCanIuseAlias[browser];
    }
  }
}

/**
 * Uses bowser to get default browser browserInformation such as version and name
 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
 * @param {string} userAgent - userAgent that gets evaluated
 */
function getBrowserInformation(userAgent) {
  var browserInfo = _bowser2.default._detect(userAgent);

  if (browserInfo.yandexbrowser) {
    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
  }

  for (var browser in prefixByBrowser) {
    if (browserInfo.hasOwnProperty(browser)) {
      var prefix = prefixByBrowser[browser];

      browserInfo.jsPrefix = prefix;
      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
      break;
    }
  }

  browserInfo.browserName = getBrowserName(browserInfo);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  if (browserInfo.version) {
    browserInfo.browserVersion = parseFloat(browserInfo.version);
  } else {
    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
  }

  browserInfo.osVersion = parseFloat(browserInfo.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
    browserInfo.browserName = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // Samsung browser are basically build on Chrome > 44
  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
    browserInfo.browserName = 'and_chr';
    browserInfo.browserVersion = 44;
  }

  return browserInfo;
}
module.exports = exports['default'];

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(1302)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 1302 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedKeyframes;
function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
  var prefixedKeyframes = 'keyframes';

  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
    return cssPrefix + prefixedKeyframes;
  }
  return prefixedKeyframes;
}
module.exports = exports['default'];

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(1305);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(1306);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(1307);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(1308);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(1309);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(1310);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(1311);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
}; /* eslint-disable */

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(221);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(221);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  flex: true,
  'inline-flex': true
};
function flex(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(221);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(221);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};


var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      if (value.indexOf('column') > -1) {
        style.WebkitBoxOrient = 'vertical';
      } else {
        style.WebkitBoxOrient = 'horizontal';
      }
      if (value.indexOf('reverse') > -1) {
        style.WebkitBoxDirection = 'reverse';
      } else {
        style.WebkitBoxDirection = 'normal';
      }
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(221);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
function gradient(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(221);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};

var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true

  // TODO: chrome & opera support it
};function sizing(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(657);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var requiresPrefixDashCased = void 0;

function transition(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    // memoize the prefix array for later use
    if (!requiresPrefixDashCased) {
      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateProperty2.default)(prop);
      });
    }

    // only split multi values, not cubic beziers
    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

    requiresPrefixDashCased.forEach(function (prop) {
      multipleValues.forEach(function (val, index) {
        if (val.indexOf(prop) > -1 && prop !== 'order') {
          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
        }
      });
    });

    return multipleValues.join(',');
  }
}
module.exports = exports['default'];

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(1314);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(1315);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(1316);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(1317);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(1318);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(1319);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(1320);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
}; /* eslint-disable */

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__(457);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(457);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(657);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(457);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(456);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (false) {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(458);

var _keys2 = _interopRequireDefault(_keys);

exports.default = rtl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      if (style.directionInvariant === true) {
        return style;
      }

      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      (0, _keys2.default)(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1324);
module.exports = __webpack_require__(73).Object.keys;


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(249);
var $keys = __webpack_require__(252);

__webpack_require__(443)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _colors = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Typography = function Typography() {
  (0, _classCallCheck3.default)(this, Typography);

  // text colors
  this.textFullBlack = _colors.fullBlack;
  this.textDarkBlack = _colors.darkBlack;
  this.textLightBlack = _colors.lightBlack;
  this.textMinBlack = _colors.minBlack;
  this.textFullWhite = _colors.fullWhite;
  this.textDarkWhite = _colors.darkWhite;
  this.textLightWhite = _colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(659);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(660);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(7).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(662);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(222);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(315);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(664);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(98);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(156);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1336);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(662);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(222);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(222);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(98);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["c" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(664);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["e" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["e" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["e" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(98);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(156);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(663);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = rootSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_subscribers__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cargoes_assigners__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cargoes_gazetters__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cargoes_types__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cargoes_duplicates__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cargoes_ldRates__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cargoes_realNames__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cargoes_names__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__termEntities__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__letters__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__annotations__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__gazetters__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__regions_ports__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__regions_areas__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__cargoes_requests__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vessels_requests__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__preferences_mailRecognizeSpamList__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__preferences_filterAnnotations__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__preferences_index__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vessels_claims__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__vessels_vessels__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__contacts__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__companies__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__realCompanies__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__countries__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__statistics_users__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__statistics_emails__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__statistics_monitor__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__statistics_cargoRequests__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__statistics_vesselPositions__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__train__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__sender__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__domains__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__notifications_backendNotifications__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__reqLDRates__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__gazetterTrainings__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__integrators_integrators__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__tc_requests__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__vessels_sales__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__analytics_linksList__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__flagCompliance__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__tc_indexes__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__cargoes_tags__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__issues__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__hires_requests__ = __webpack_require__(1473);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


















































var sagas = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__users__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__cargoes_assigners__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_4__cargoes_gazetters__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__cargoes_types__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__cargoes_duplicates__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__cargoes_ldRates__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__cargoes_realNames__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__cargoes_names__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_10__termEntities__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__letters__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__annotations__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__gazetters__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_20__preferences_index__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_14__regions_ports__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_15__regions_areas__["b" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_16__cargoes_requests__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_40__vessels_sales__["b" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_17__vessels_requests__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_21__vessels_claims__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_22__vessels_vessels__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_23__contacts__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_24__companies__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_25__realCompanies__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_26__countries__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_27__statistics_users__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_28__statistics_emails__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_29__statistics_monitor__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_30__statistics_cargoRequests__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_31__statistics_vesselPositions__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_32__train__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_18__preferences_mailRecognizeSpamList__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_19__preferences_filterAnnotations__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_33__sender__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_34__domains__["b" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__users_subscribers__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_35__notifications_backendNotifications__["b" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_36__reqLDRates__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_37__gazetterTrainings__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_38__integrators_integrators__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_39__tc_requests__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_41__analytics_linksList__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_42__flagCompliance__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_43__tc_indexes__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_44__cargoes_tags__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_45__issues__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_46__hires_requests__["a" /* default */]));

function rootSaga() {
    return regeneratorRuntime.wrap(function rootSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return sagas.map(function (saga) {
                        return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(saga);
                    });

                case 3:
                    _context.next = 9;
                    break;

                case 5:
                    _context.prev = 5;
                    _context.t0 = _context['catch'](0);

                    console.error('Global async error -', _context.t0);
                    return _context.abrupt('return', _context.t0);

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 5]]);
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sagas, 'sagas', '/opt/atlassian/pipelines/agent/build/client/app/sagas/index.js');
    reactHotLoader.register(rootSaga, 'rootSaga', '/opt/atlassian/pipelines/agent/build/client/app/sagas/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getUser */
/* unused harmony export watchGetUser */
/* unused harmony export authUser */
/* unused harmony export watchAuthUser */
/* unused harmony export watchLogoutUser */
/* unused harmony export watchGetUserLimitationsList */
/* unused harmony export watchGetUserList */
/* unused harmony export watchBanUserById */
/* unused harmony export watchUnbanUserById */
/* unused harmony export watchSetUserToBlackList */
/* unused harmony export watchSetUserToWhiteList */
/* unused harmony export watchToggleWhiteList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getUser),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetUser),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(authUser),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchAuthUser),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(logoutUser),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchLogoutUser),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getUserLimitationsList),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchGetUserLimitationsList),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(getUserList),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchGetUserList),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(banUserById),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(watchBanUserById),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(unbanUserById),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(watchUnbanUserById),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(setUserToBlackList),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(watchSetUserToBlackList),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(setUserToWhiteList),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(watchSetUserToWhiteList),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(toggleWhiteList),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(watchToggleWhiteList);





function getUser() {
    var response;
    return regeneratorRuntime.wrap(function getUser$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getUser);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_54" /* GET_USER */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_54" /* GET_USER */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetUser() {
    return regeneratorRuntime.wrap(function watchGetUser$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_54" /* GET_USER */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getUser);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function authUser(email, password) {
    var response;
    return regeneratorRuntime.wrap(function authUser$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].authUser, email, password);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200 && response.data.role === 'user')) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["m" /* AUTH_USER */].FAILURE,
                        message: 'You don`t have permissions'
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].logoutUser);

                case 8:
                    return _context3.abrupt('return', response);

                case 9:
                    if (!(response.status === 200)) {
                        _context3.next = 15;
                        break;
                    }

                    _context3.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["m" /* AUTH_USER */].SUCCESS,
                        data: response.data
                    });

                case 12:
                    _context3.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'User ' + email + ' login',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 14:
                    return _context3.abrupt('return', response);

                case 15:
                    _context3.next = 17;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["m" /* AUTH_USER */].FAILURE,
                        message: response.errors ? response.errors[0].messages[0] : 'Something went wrong'
                    });

                case 17:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchAuthUser() {
    var _ref, email, password;

    return regeneratorRuntime.wrap(function watchAuthUser$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 10;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["m" /* AUTH_USER */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    email = _ref.email;
                    password = _ref.password;
                    _context4.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(authUser, email, password);

                case 8:
                    _context4.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function logoutUser() {
    var response;
    return regeneratorRuntime.wrap(function logoutUser$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].logoutUser);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_66" /* LOGOUT_USER */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'User logout',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return', response);

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_66" /* LOGOUT_USER */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 11:
                    return _context5.abrupt('return', response);

                case 12:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchLogoutUser() {
    return regeneratorRuntime.wrap(function watchLogoutUser$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 7;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_66" /* LOGOUT_USER */].REQUEST);

                case 3:
                    _context6.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(logoutUser);

                case 5:
                    _context6.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getUserLimitationsList(pagination) {
    var response;
    return regeneratorRuntime.wrap(function getUserLimitationsList$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getUserLimitationsList, pagination);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 7;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_55" /* GET_USER_LIMITATIONS_LIST */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context7.abrupt('return', response);

                case 7:
                    _context7.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_55" /* GET_USER_LIMITATIONS_LIST */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 9:
                    return _context7.abrupt('return', response);

                case 10:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function watchGetUserLimitationsList() {
    return regeneratorRuntime.wrap(function watchGetUserLimitationsList$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 7;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_55" /* GET_USER_LIMITATIONS_LIST */].REQUEST);

                case 3:
                    _context8.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getUserLimitationsList);

                case 5:
                    _context8.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function getUserList(pagination) {
    var response;
    return regeneratorRuntime.wrap(function getUserList$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getUserList, pagination);

                case 2:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 7;
                        break;
                    }

                    _context9.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_56" /* GET_USER_LIST */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context9.abrupt('return', response);

                case 7:
                    _context9.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_56" /* GET_USER_LIST */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 9:
                    return _context9.abrupt('return', response);

                case 10:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function watchGetUserList() {
    var _ref2, pagination;

    return regeneratorRuntime.wrap(function watchGetUserList$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (false) {
                        _context10.next = 9;
                        break;
                    }

                    _context10.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_56" /* GET_USER_LIST */].REQUEST);

                case 3:
                    _ref2 = _context10.sent;
                    pagination = _ref2.pagination;
                    _context10.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getUserList, pagination);

                case 7:
                    _context10.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function banUserById(user) {
    var response;
    return regeneratorRuntime.wrap(function banUserById$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    _context11.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].banUserById, user);

                case 2:
                    response = _context11.sent;

                    if (!(response.status === 200)) {
                        _context11.next = 9;
                        break;
                    }

                    _context11.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["n" /* BAN_USER_BY_ID */].SUCCESS,
                        data: user
                    });

                case 6:
                    _context11.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'User ' + user._id + ' ban',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context11.abrupt('return', response);

                case 9:
                    _context11.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 99999
                        }
                    });

                case 11:
                    _context11.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["n" /* BAN_USER_BY_ID */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 13:
                    return _context11.abrupt('return', response);

                case 14:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function watchBanUserById() {
    var _ref3, user;

    return regeneratorRuntime.wrap(function watchBanUserById$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    if (false) {
                        _context12.next = 9;
                        break;
                    }

                    _context12.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["n" /* BAN_USER_BY_ID */].REQUEST);

                case 3:
                    _ref3 = _context12.sent;
                    user = _ref3.user;
                    _context12.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(banUserById, user);

                case 7:
                    _context12.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function unbanUserById(user) {
    var response;
    return regeneratorRuntime.wrap(function unbanUserById$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].unbanUserById, user);

                case 2:
                    response = _context13.sent;

                    if (!(response.status === 200)) {
                        _context13.next = 9;
                        break;
                    }

                    _context13.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_118" /* UNBAN_USER_BY_ID */].SUCCESS,
                        data: user
                    });

                case 6:
                    _context13.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'User ' + user._id + ' unban',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context13.abrupt('return', response);

                case 9:
                    _context13.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 99999
                        }
                    });

                case 11:
                    _context13.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_118" /* UNBAN_USER_BY_ID */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 13:
                    return _context13.abrupt('return', response);

                case 14:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function watchUnbanUserById() {
    var _ref4, _user;

    return regeneratorRuntime.wrap(function watchUnbanUserById$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    if (false) {
                        _context14.next = 9;
                        break;
                    }

                    _context14.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_118" /* UNBAN_USER_BY_ID */].REQUEST);

                case 3:
                    _ref4 = _context14.sent;
                    _user = _ref4.user;
                    _context14.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(unbanUserById, _user);

                case 7:
                    _context14.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function setUserToBlackList(emails, user) {
    var response;
    return regeneratorRuntime.wrap(function setUserToBlackList$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].setUserToBlackList, emails, user);

                case 2:
                    response = _context15.sent;

                    if (!(response.status === 200)) {
                        _context15.next = 9;
                        break;
                    }

                    _context15.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_115" /* SET_USER_TO_BLACK_LIST */].SUCCESS,
                        emails: emails,
                        user: user
                    });

                case 6:
                    _context15.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: '' + response.data.message,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context15.abrupt('return', response);

                case 9:
                    _context15.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 99999
                        }
                    });

                case 11:
                    _context15.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_115" /* SET_USER_TO_BLACK_LIST */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 13:
                    return _context15.abrupt('return', response);

                case 14:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function watchSetUserToBlackList() {
    var _ref5, emails, _user2;

    return regeneratorRuntime.wrap(function watchSetUserToBlackList$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    if (false) {
                        _context16.next = 10;
                        break;
                    }

                    _context16.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_115" /* SET_USER_TO_BLACK_LIST */].REQUEST);

                case 3:
                    _ref5 = _context16.sent;
                    emails = _ref5.emails;
                    _user2 = _ref5.user;
                    _context16.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(setUserToBlackList, emails, _user2);

                case 8:
                    _context16.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

function setUserToWhiteList(emails, user) {
    var response;
    return regeneratorRuntime.wrap(function setUserToWhiteList$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    _context17.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].setUserToWhiteList, emails, user);

                case 2:
                    response = _context17.sent;

                    if (!(response.status === 200)) {
                        _context17.next = 9;
                        break;
                    }

                    _context17.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_116" /* SET_USER_TO_WHITE_LIST */].SUCCESS,
                        emails: emails,
                        user: user
                    });

                case 6:
                    _context17.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: '' + response.data.message,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context17.abrupt('return', response);

                case 9:
                    _context17.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 99999
                        }
                    });

                case 11:
                    _context17.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_116" /* SET_USER_TO_WHITE_LIST */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 13:
                    return _context17.abrupt('return', response);

                case 14:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked17, this);
}

function watchSetUserToWhiteList() {
    var _ref6, _emails, _user3;

    return regeneratorRuntime.wrap(function watchSetUserToWhiteList$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    if (false) {
                        _context18.next = 10;
                        break;
                    }

                    _context18.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_116" /* SET_USER_TO_WHITE_LIST */].REQUEST);

                case 3:
                    _ref6 = _context18.sent;
                    _emails = _ref6.emails;
                    _user3 = _ref6.user;
                    _context18.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(setUserToWhiteList, _emails, _user3);

                case 8:
                    _context18.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked18, this);
}

function toggleWhiteList(user, whiteActive) {
    var response;
    return regeneratorRuntime.wrap(function toggleWhiteList$(_context19) {
        while (1) {
            switch (_context19.prev = _context19.next) {
                case 0:
                    _context19.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].toggleWhiteList, user, whiteActive);

                case 2:
                    response = _context19.sent;

                    if (!(response.status === 200)) {
                        _context19.next = 9;
                        break;
                    }

                    _context19.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_117" /* TOGGLE_WHITE_LIST */].SUCCESS,
                        user: user,
                        whiteActive: whiteActive
                    });

                case 6:
                    _context19.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context19.abrupt('return', response);

                case 9:
                    _context19.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 99999
                        }
                    });

                case 11:
                    _context19.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_117" /* TOGGLE_WHITE_LIST */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 13:
                    return _context19.abrupt('return', response);

                case 14:
                case 'end':
                    return _context19.stop();
            }
        }
    }, _marked19, this);
}

function watchToggleWhiteList() {
    var _ref7, _user4, whiteActive;

    return regeneratorRuntime.wrap(function watchToggleWhiteList$(_context20) {
        while (1) {
            switch (_context20.prev = _context20.next) {
                case 0:
                    if (false) {
                        _context20.next = 10;
                        break;
                    }

                    _context20.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_117" /* TOGGLE_WHITE_LIST */].REQUEST);

                case 3:
                    _ref7 = _context20.sent;
                    _user4 = _ref7.user;
                    whiteActive = _ref7.whiteActive;
                    _context20.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(toggleWhiteList, _user4, whiteActive);

                case 8:
                    _context20.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context20.stop();
            }
        }
    }, _marked20, this);
}

var _default = [watchLogoutUser, watchAuthUser, watchGetUser, watchGetUserList, watchBanUserById, watchUnbanUserById, watchGetUserLimitationsList, watchSetUserToBlackList, watchSetUserToWhiteList, watchToggleWhiteList];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getUser, 'getUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchGetUser, 'watchGetUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(authUser, 'authUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchAuthUser, 'watchAuthUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(logoutUser, 'logoutUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchLogoutUser, 'watchLogoutUser', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(getUserLimitationsList, 'getUserLimitationsList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchGetUserLimitationsList, 'watchGetUserLimitationsList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(getUserList, 'getUserList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchGetUserList, 'watchGetUserList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(banUserById, 'banUserById', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchBanUserById, 'watchBanUserById', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(unbanUserById, 'unbanUserById', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchUnbanUserById, 'watchUnbanUserById', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(setUserToBlackList, 'setUserToBlackList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchSetUserToBlackList, 'watchSetUserToBlackList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(setUserToWhiteList, 'setUserToWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchSetUserToWhiteList, 'watchSetUserToWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(toggleWhiteList, 'toggleWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(watchToggleWhiteList, 'watchToggleWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["h"] = getUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = authUser;
/* harmony export (immutable) */ __webpack_exports__["k"] = logoutUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = createNewUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = findUser;
/* harmony export (immutable) */ __webpack_exports__["f"] = findUserById;
/* harmony export (immutable) */ __webpack_exports__["g"] = findUsers;
/* unused harmony export getCompanyCollegues */
/* harmony export (immutable) */ __webpack_exports__["j"] = getUserList;
/* harmony export (immutable) */ __webpack_exports__["b"] = banUserById;
/* harmony export (immutable) */ __webpack_exports__["o"] = unbanUserById;
/* harmony export (immutable) */ __webpack_exports__["i"] = getUserLimitationsList;
/* harmony export (immutable) */ __webpack_exports__["l"] = setUserToBlackList;
/* harmony export (immutable) */ __webpack_exports__["m"] = setUserToWhiteList;
/* harmony export (immutable) */ __webpack_exports__["n"] = toggleWhiteList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(254);
var getOne = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */].call('users/' + id);

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getOne(_x3) {
        return _ref2.apply(this, arguments);
    };
}();

// not necessary due to stripe integration
// async function extendSubscription(id, data) {
//   return await api.call(`users/${id}/subscription`, data, 'put');
// }

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




function getUser() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/users/profile',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function authUser(email, password) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/auth/sign_in',
        withCredentials: true,
        data: {
            email: email,
            password: password
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function logoutUser() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/users/logout',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function createNewUser(user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/auth/register',
        data: {
            name: user.name,
            surname: user.name,
            email: user.email,
            company: user.company,
            phones: user.phones
        },
        withCredentials: true
    });
}

function findUser(text) {
    var extend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var companyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/users/find',
        data: {
            query: text,
            extend: extend,
            companyName: companyName
        },
        withCredentials: true
    });
}

function findUserById(user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/users/find-by-id',
        data: {
            query: user.user._id
        },
        withCredentials: true
    }).then(function (response) {
        return response.data.data;
    }).catch(function (error) {
        return console.error(error);
    });
}

function findUsers(users) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/users/find-users',
        data: {
            query: users
        },
        withCredentials: true
    }).then(function (response) {
        return response.data.data;
    }).catch(function (error) {
        return console.error(error);
    });
}

function getCompanyCollegues(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/companies/users',
        data: {
            query: userId
        },
        withCredentials: true
    });
}

function getUserList(_ref) {
    var _ref$page = _ref.page,
        page = _ref$page === undefined ? 1 : _ref$page,
        _ref$limit = _ref.limit,
        limit = _ref$limit === undefined ? 25 : _ref$limit;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/users',
        withCredentials: true,
        data: {
            page: page,
            limit: limit,
            select: ["limitations"]
        }
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}

function banUserById(user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/users/' + user._id + '/ban',
        withCredentials: true
    }).then(function (response) {
        return response.data.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function unbanUserById(user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/users/' + user._id + '/unban',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getUserLimitationsList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/users/profile/limitation',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function setUserToBlackList(emails, user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/users/profile/limitation/black',
        withCredentials: true,
        data: {
            emails: emails,
            user: user._id
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function setUserToWhiteList(emails, user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/users/profile/limitation/white',
        withCredentials: true,
        data: {
            emails: emails,
            user: user._id
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function toggleWhiteList(user, whiteActive) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/users/profile/limitation/toggle',
        withCredentials: true,
        data: {
            user: user._id,
            whiteActive: whiteActive
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

var _default = {
    getOne: getOne
    //   extendSubscription
};
/* harmony default export */ __webpack_exports__["d"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getUser, 'getUser', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(authUser, 'authUser', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(logoutUser, 'logoutUser', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(createNewUser, 'createNewUser', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(findUser, 'findUser', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(findUserById, 'findUserById', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(findUsers, 'findUsers', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(getCompanyCollegues, 'getCompanyCollegues', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(getUserList, 'getUserList', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(banUserById, 'banUserById', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(unbanUserById, 'unbanUserById', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(getUserLimitationsList, 'getUserLimitationsList', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(setUserToBlackList, 'setUserToBlackList', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(setUserToWhiteList, 'setUserToWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(toggleWhiteList, 'toggleWhiteList', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(getOne, 'getOne', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/services/users/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);
var bind = __webpack_require__(665);
var Axios = __webpack_require__(1342);
var defaults = __webpack_require__(460);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(669);
axios.CancelToken = __webpack_require__(1356);
axios.isCancel = __webpack_require__(668);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1357);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(460);
var utils = __webpack_require__(99);
var InterceptorManager = __webpack_require__(1351);
var dispatchRequest = __webpack_require__(1352);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(667);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);
var transformData = __webpack_require__(1353);
var isCancel = __webpack_require__(668);
var defaults = __webpack_require__(460);
var isAbsoluteURL = __webpack_require__(1354);
var combineURLs = __webpack_require__(1355);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(99);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(669);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1359 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1361);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(672);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1363),
    ListCache = __webpack_require__(319),
    Map = __webpack_require__(464);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1364),
    hashDelete = __webpack_require__(1369),
    hashGet = __webpack_require__(1370),
    hashHas = __webpack_require__(1371),
    hashSet = __webpack_require__(1372);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(317);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(318),
    isMasked = __webpack_require__(1366),
    isObject = __webpack_require__(89),
    toSource = __webpack_require__(673);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1367);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(77);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(317);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(317);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(317);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1373 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(320);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(320);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(320);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(320);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(321);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1379 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(321);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(321);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(321);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223),
    arrayMap = __webpack_require__(256),
    isArray = __webpack_require__(67),
    isSymbol = __webpack_require__(316);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["e"] = findPort;
/* harmony export (immutable) */ __webpack_exports__["f"] = findPortAdmin;
/* harmony export (immutable) */ __webpack_exports__["g"] = getAllPorts;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPorts;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAllPortsWithAltNames;
/* harmony export (immutable) */ __webpack_exports__["i"] = getAllPortsWithCountryNames;
/* harmony export (immutable) */ __webpack_exports__["o"] = updatePort;
/* harmony export (immutable) */ __webpack_exports__["p"] = updatePortAlt;
/* harmony export (immutable) */ __webpack_exports__["a"] = addNewPort;
/* harmony export (immutable) */ __webpack_exports__["j"] = getPort;
/* harmony export (immutable) */ __webpack_exports__["d"] = checkAndCreateRegion;
/* harmony export (immutable) */ __webpack_exports__["l"] = mergeAreaOrPortToPort;
/* harmony export (immutable) */ __webpack_exports__["n"] = rejectPortModifications;
/* harmony export (immutable) */ __webpack_exports__["c"] = approvePortModifications;
/* harmony export (immutable) */ __webpack_exports__["b"] = approvePortModificationField;
/* harmony export (immutable) */ __webpack_exports__["m"] = rejectPortModificationField;
/* harmony export (immutable) */ __webpack_exports__["q"] = updatePortModificationField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function pickErrorMessage(error) {
    var errorMessage = '';
    if (error.response.data.errors[0].messages[0].message) {
        errorMessage = error.response.data.errors[0].messages[0].message;
    } else if (error.response.data.errors[0].messages[0]) {
        errorMessage = error.response.data.errors[0].messages[0];
    }
    return errorMessage;
}

/**
 * @deprecated use findPortAdmin for admin panel
 */
function findPort(_ref) {
    var name = _ref.name,
        _ref$withAreas = _ref.withAreas,
        withAreas = _ref$withAreas === undefined ? false : _ref$withAreas,
        _ref$onlyAreas = _ref.onlyAreas,
        onlyAreas = _ref$onlyAreas === undefined ? false : _ref$onlyAreas,
        _ref$country = _ref.country,
        country = _ref$country === undefined ? '' : _ref$country,
        _ref$onlyAreasWithChi = _ref.onlyAreasWithChild,
        onlyAreasWithChild = _ref$onlyAreasWithChi === undefined ? false : _ref$onlyAreasWithChi,
        _ref$withAreasWithChi = _ref.withAreasWithChild,
        withAreasWithChild = _ref$withAreasWithChi === undefined ? false : _ref$withAreasWithChi,
        _ref$mainRegions = _ref.mainRegions,
        mainRegions = _ref$mainRegions === undefined ? false : _ref$mainRegions,
        _ref$isInBalticIndex = _ref.isInBalticIndex,
        isInBalticIndex = _ref$isInBalticIndex === undefined ? false : _ref$isInBalticIndex;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/ports/find',
        data: {
            name: name,
            withAreas: withAreas,
            onlyAreas: onlyAreas,
            country: country,
            onlyAreasWithChild: onlyAreasWithChild,
            withAreasWithChild: withAreasWithChild,
            mainRegions: mainRegions,
            isInBalticIndex: isInBalticIndex
        },
        withCredentials: true
    });
}

function findPortAdmin(_ref2) {
    var name = _ref2.name,
        _ref2$withAreas = _ref2.withAreas,
        withAreas = _ref2$withAreas === undefined ? false : _ref2$withAreas,
        _ref2$onlyAreas = _ref2.onlyAreas,
        onlyAreas = _ref2$onlyAreas === undefined ? false : _ref2$onlyAreas,
        _ref2$country = _ref2.country,
        country = _ref2$country === undefined ? '' : _ref2$country,
        _ref2$onlyAreasWithCh = _ref2.onlyAreasWithChild,
        onlyAreasWithChild = _ref2$onlyAreasWithCh === undefined ? false : _ref2$onlyAreasWithCh,
        _ref2$withAreasWithCh = _ref2.withAreasWithChild,
        withAreasWithChild = _ref2$withAreasWithCh === undefined ? false : _ref2$withAreasWithCh,
        _ref2$mainRegions = _ref2.mainRegions,
        mainRegions = _ref2$mainRegions === undefined ? false : _ref2$mainRegions,
        _ref2$isInBalticIndex = _ref2.isInBalticIndex,
        isInBalticIndex = _ref2$isInBalticIndex === undefined ? false : _ref2$isInBalticIndex,
        _ref2$withUserPorts = _ref2.withUserPorts,
        withUserPorts = _ref2$withUserPorts === undefined ? false : _ref2$withUserPorts;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/ports/find',
        data: {
            name: name,
            withAreas: withAreas,
            onlyAreas: onlyAreas,
            country: country,
            onlyAreasWithChild: onlyAreasWithChild,
            withAreasWithChild: withAreasWithChild,
            mainRegions: mainRegions,
            isInBalticIndex: isInBalticIndex,
            withUserPorts: withUserPorts
        },
        withCredentials: true
    });
}

function getAllPorts() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/ports/allPorts',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function getPorts(_ref3) {
    var _ref3$page = _ref3.page,
        page = _ref3$page === undefined ? 1 : _ref3$page,
        _ref3$limit = _ref3.limit,
        limit = _ref3$limit === undefined ? 25 : _ref3$limit,
        _ref3$sort = _ref3.sort,
        sort = _ref3$sort === undefined ? 'name' : _ref3$sort,
        _ref3$onlyChanged = _ref3.onlyChanged,
        onlyChanged = _ref3$onlyChanged === undefined ? false : _ref3$onlyChanged,
        _ref3$query = _ref3.query,
        query = _ref3$query === undefined ? '' : _ref3$query,
        _ref3$hasRecommended = _ref3.hasRecommended,
        hasRecommended = _ref3$hasRecommended === undefined ? undefined : _ref3$hasRecommended,
        _ref3$expiredRecommen = _ref3.expiredRecommended,
        expiredRecommended = _ref3$expiredRecommen === undefined ? undefined : _ref3$expiredRecommen;

    var queryParams = new URLSearchParams();
    queryParams.append('page', page);
    queryParams.append('limit', limit);
    queryParams.append('sort', sort);
    queryParams.append('onlyChanged', onlyChanged);
    queryParams.append('query', query);

    if (hasRecommended !== undefined) {
        queryParams.append('hasRecommended', hasRecommended);
    }
    if (expiredRecommended !== undefined) {
        queryParams.append('expiredRecommended', expiredRecommended);
    }

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/ports?' + queryParams.toString(),
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function getAllPortsWithAltNames() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/ports/all',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function getAllPortsWithCountryNames() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/ports/names',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function updatePort(data) {
    // had to do that here, as redux-form reinitialises form values after normalize for http req
    var _data = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(data);
    _data.serviceProviders = _data.serviceProviders.map(function (s) {
        if (s.companyId && typeof s.companyId !== 'string' && s.companyId._id) {
            s.companyId = s.companyId._id;
        } else {
            s.companyId = undefined;
        }

        if (s.contactPersonId && typeof s.contactPersonId !== 'string' && s.contactPersonId._id) {
            s.contactPersonId = s.contactPersonId._id;
        } else {
            s.contactPersonId = undefined;
        }

        if (!s.recommended || !s.recommended.endAt) {
            delete s.recommended;
        }

        return s;
    });
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/' + _data._id,
        data: _data,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updatePortAlt(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/ports/' + item._id + '/alt',
        data: {
            alt: item.alt
        },
        withCredentials: true
    }).then(function (response) {
        return _extends({}, response.data, {
            item: item
        });
    }) // todo sending response.response
    .catch(function (response) {
        return _extends({}, response.response.data, {
            item: item
        });
    });
}

function addNewPort(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/ports/',
        data: data,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

/**
 * get port
 * @param {{
 *  id: string,
 *  all?: boolean,
 *  history?: boolean,
 * }} data 
 */
function getPort(data) {
    var all = data.all ? data.all : false;
    var url = data.history ? '/api/v1/ports/' + data.id + '/history?all=' + all : '/api/v1/ports/' + data.id;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: url,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response;
    });
}

function checkAndCreateRegion(name) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/ports/areas/check',
        withCredentials: true,
        data: {
            name: name
        }
    });
}

function mergeAreaOrPortToPort(portId, mergePortId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/' + portId + '/merge',
        withCredentials: true,
        data: {
            mergeId: mergePortId
        }
    });
}

/**
 * reject port modifications
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 * }} data 
 */
function rejectPortModifications(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/' + data._id + '/reject',
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw pickErrorMessage(error);
    });
}

/**
 * approve port modifications
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 * }} data 
 * @returns 
 */
function approvePortModifications(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/' + data._id + '/approve',
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw pickErrorMessage(error);
    });
}

/**
 * approve one port field
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  fields: string[],
 *  updateAt: number,
 * }} data 
 */
function approvePortModificationField(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/' + data._id + '/approveFields',
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            fields: data.fields
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw pickErrorMessage(error);
    });
}

/**
 * reject one port field
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  fields: string[],
 *  updateAt: number,
 * }} data 
 */
function rejectPortModificationField(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/' + data._id + '/rejectFields',
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            fields: data.fields
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw pickErrorMessage(error);
    });
}

/**
 * update one port field
 * @param {{
 *  _id: string,
 *  historyId: string,
 *  updateAt: number,
 *  toUpdate: Record<string, any>,
 * }} data 
 */
function updatePortModificationField(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/ports/' + data._id + '/updateField',
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
            toUpdate: data.toUpdate
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        throw pickErrorMessage(error);
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(pickErrorMessage, 'pickErrorMessage', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(findPort, 'findPort', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(findPortAdmin, 'findPortAdmin', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(getAllPorts, 'getAllPorts', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(getPorts, 'getPorts', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(getAllPortsWithAltNames, 'getAllPortsWithAltNames', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(getAllPortsWithCountryNames, 'getAllPortsWithCountryNames', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(updatePort, 'updatePort', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(updatePortAlt, 'updatePortAlt', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(addNewPort, 'addNewPort', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(getPort, 'getPort', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(checkAndCreateRegion, 'checkAndCreateRegion', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(mergeAreaOrPortToPort, 'mergeAreaOrPortToPort', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(rejectPortModifications, 'rejectPortModifications', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(approvePortModifications, 'approvePortModifications', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(approvePortModificationField, 'approvePortModificationField', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(rejectPortModificationField, 'rejectPortModificationField', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    reactHotLoader.register(updatePortModificationField, 'updatePortModificationField', '/opt/atlassian/pipelines/agent/build/client/app/services/regions/ports.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getContracts;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTimeContracts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getContracts() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/contracts/voyage/names',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function getTimeContracts() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/contracts/time/names',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getContracts, 'getContracts', '/opt/atlassian/pipelines/agent/build/client/app/services/contracts.js');
    reactHotLoader.register(getTimeContracts, 'getTimeContracts', '/opt/atlassian/pipelines/agent/build/client/app/services/contracts.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCargoTypes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoTypes() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/cargo/types',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoTypes, 'getCargoTypes', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/types.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getCargoAssigners;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCargoAssignersPost;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCargoGazetters;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteCargoGazetter;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateCargoAssigner;
/* harmony export (immutable) */ __webpack_exports__["f"] = getOneCargoByRealCargoId;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateRealAdditionalInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getRealCargoNameWithGaz; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(254);
var fetchSearatesCategories = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */].call('cargoassigner/searates-categories');

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function fetchSearatesCategories() {
        return _ref2.apply(this, arguments);
    };
}();

var updateAdditionalInfo = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, data) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */].call('cargoassigner/' + id + '/additional-info', data, 'post');

                    case 2:
                        return _context2.abrupt('return', _context2.sent);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function updateAdditionalInfo(_x, _x2) {
        return _ref3.apply(this, arguments);
    };
}();

var getOne = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */].call('cargoassigner/' + id);

                    case 2:
                        return _context4.abrupt('return', _context4.sent);

                    case 3:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function getOne(_x5) {
        return _ref5.apply(this, arguments);
    };
}();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




function getCargoAssigners() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/cargoassigner',
        withCredentials: true
    }) // todo sending response.data
    .then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

/**
 * 
 * @param {string[]} realCargoIds 
 * @returns 
 */
function getCargoAssignersPost(realCargoIds) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v2/cargoassigner',
        withCredentials: true,
        data: {
            realCargoIds: realCargoIds
        }
    }) // todo sending response.data
    .then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

/**
 * @param {{ page: number, limit: number, filters?: { search?: string, details?: number } }} param0
 */
function getCargoGazetters(_ref) {
    var page = _ref.page,
        limit = _ref.limit,
        _ref$filters = _ref.filters,
        filters = _ref$filters === undefined ? {} : _ref$filters;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v2/adminPanel/gazetters',
        withCredentials: true,
        data: {
            page: page, limit: limit, filters: filters
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function deleteCargoGazetter(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v2/adminPanel/gazetters/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function updateCargoAssigner(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/cargoassigner/cargo/' + item._id,
        withCredentials: true,
        data: {
            CargoCategory: item.CargoCategory,
            CargoCategoryName: item.CargoCategoryName,
            realCargoName: item.realCargoName,
            realCargoId: item.realCargoId,
            details: item.details
        }
    }) // todo sending response.data
    .then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getOneCargoByRealCargoId(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/cargoassigner/cargo/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

var updateRealAdditionalInfo = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, data) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */].call('cargoassigner/' + id + '/additional-info', data, 'post');

                    case 2:
                        return _context3.abrupt('return', _context3.sent);

                    case 3:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function updateRealAdditionalInfo(_x3, _x4) {
        return _ref4.apply(this, arguments);
    };
}();

var getRealCargoNameWithGaz = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'GET',
                            url: '/api/v2/adminPanel/realCargoName/' + id,
                            withCredentials: true
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function getRealCargoNameWithGaz(_x6) {
        return _ref6.apply(this, arguments);
    };
}();

var _default = {
    fetchSearatesCategories: fetchSearatesCategories,
    updateAdditionalInfo: updateAdditionalInfo,
    updateRealAdditionalInfo: updateRealAdditionalInfo,
    getOne: getOne,
    getRealCargoNameWithGaz: getRealCargoNameWithGaz
};
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoAssigners, 'getCargoAssigners', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(getCargoAssignersPost, 'getCargoAssignersPost', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(getCargoGazetters, 'getCargoGazetters', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(deleteCargoGazetter, 'deleteCargoGazetter', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(updateCargoAssigner, 'updateCargoAssigner', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(getOneCargoByRealCargoId, 'getOneCargoByRealCargoId', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(fetchSearatesCategories, 'fetchSearatesCategories', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(updateAdditionalInfo, 'updateAdditionalInfo', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(updateRealAdditionalInfo, 'updateRealAdditionalInfo', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(getOne, 'getOne', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(getRealCargoNameWithGaz, 'getRealCargoNameWithGaz', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/assigners.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getTermEntities;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getTermEntities() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/terms/entities',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getTermEntities, 'getTermEntities', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/terms.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getCargoDuplicates;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteCargoDuplicate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoDuplicates() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/cargo/duplicates',
        withCredentials: true
    }) // todo data without status ((
    .then(function (response) {
        return response;
    }).catch(function (response) {
        return response;
    });
}

function deleteCargoDuplicate(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v1/cargo/' + item.id,
        withCredentials: true
    }) // todo sending response.data
    .then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoDuplicates, 'getCargoDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/duplicates.js');
    reactHotLoader.register(deleteCargoDuplicate, 'deleteCargoDuplicate', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/duplicates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getLoadingAndDischarging;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateLoadingAndDischarging;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteLoadingAndDischarging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getLoadingAndDischarging() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/cargoassigner/ld',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function updateLoadingAndDischarging(item) {
    var data = {};
    data.loading = item.ldRates.loading;
    data.loading = {
        abbreviation: data.loading.abbreviation ? data.loading.abbreviation : '',
        cqd: data.loading.cqd,
        dimension: data.loading.dimension ? data.loading.dimension : '',
        speed: data.loading.speed ? data.loading.speed : '',
        term: data.loading.term ? data.loading.term : ''
    };
    data.discharging = item.ldRates.discharging;
    data.discharging = {
        abbreviation: data.discharging.abbreviation ? data.discharging.abbreviation : '',
        cqd: data.discharging.cqd,
        dimension: data.discharging.dimension ? data.discharging.dimension : '',
        speed: data.discharging.speed ? data.discharging.speed : '',
        term: data.discharging.term ? data.discharging.term : ''
    };

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/cargoassigner/ld/' + item._id,
        data: data,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteLoadingAndDischarging(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v1/cargoassigner/ld/' + item._id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getLoadingAndDischarging, 'getLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/ldRates.js');
    reactHotLoader.register(updateLoadingAndDischarging, 'updateLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/ldRates.js');
    reactHotLoader.register(deleteLoadingAndDischarging, 'deleteLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/ldRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["f"] = getCargoNamesAutocomplete;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCargoRealNames;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateCargoRealName;
/* harmony export (immutable) */ __webpack_exports__["c"] = checkForDeleteCargoName;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertUserCargoToAdmin;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteCargoRealName;
/* harmony export (immutable) */ __webpack_exports__["i"] = getTagsCategories;
/* harmony export (immutable) */ __webpack_exports__["b"] = addTagsCategories;
/* harmony export (immutable) */ __webpack_exports__["a"] = addTag;
/* harmony export (immutable) */ __webpack_exports__["k"] = searchTags;
/* harmony export (immutable) */ __webpack_exports__["j"] = saveTags;
/* harmony export (immutable) */ __webpack_exports__["h"] = getCargoRealNamesPaginated;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoNamesAutocomplete(name) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/cargo/findCargoAdminPanel',
        data: {
            name: name
        },
        withCredentials: true
    });
}

function getCargoRealNames() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/cargoassigner/cargo/names',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function updateCargoRealName(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/cargoassigner/cargo/' + item._id,
        withCredentials: true,
        data: {
            CargoCategory: item.parent.red._id,
            CargoCategoryName: item.parent.red.name,
            realCargoName: item.name,
            details: item.details ? item.details : '',
            sf: item.sf || undefined
        }
    }) // todo sending response.data
    .then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function checkForDeleteCargoName(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v2/cargoassigner/cargo/' + item._id,
        withCredentials: true
    });
}

function convertUserCargoToAdmin(cargoId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/cargo/' + cargoId + '/toAdmin',
        withCredentials: true
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteCargoRealName(item) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v2/cargoassigner/cargo/' + item._id + '?force=true',
        withCredentials: true
    }) // todo sending response.data
    .then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getTagsCategories() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/tags/categories?entity=cargoRequest',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function addTagsCategories(value, description) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/tags/categories?entity=cargoRequest',
        withCredentials: true,
        data: {
            value: value,
            description: description
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function addTag(value, categoryName) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/tags/tags/system?entity=cargoRequest',
        withCredentials: true,
        data: {
            value: value,
            categoryName: categoryName
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function searchTags(query) {
    var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/tags/tags?entity=cargoRequest&category=' + category + '&q=' + query,
        withCredentials: true
    }).then(function (response) {
        return response.data.data.map(function (item) {
            return _extends({}, item, {
                id: item._id,
                name: item.value
            });
        });
    }).catch(function (response) {
        return response.response.data;
    });
}

function saveTags(cargoId, tags) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/cargo/' + cargoId + '/tags',
        data: {
            tags: tags
        }
    });
}

/**
 * @param {{ page: number, limit: number, filters?: { search?: string } }} param0
 */
function getCargoRealNamesPaginated(_ref) {
    var page = _ref.page,
        limit = _ref.limit,
        _ref$filters = _ref.filters,
        filters = _ref$filters === undefined ? {} : _ref$filters;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v2/adminPanel/realCargoNames',
        withCredentials: true,
        data: {
            page: page, limit: limit, filters: filters
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoNamesAutocomplete, 'getCargoNamesAutocomplete', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(getCargoRealNames, 'getCargoRealNames', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(updateCargoRealName, 'updateCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(checkForDeleteCargoName, 'checkForDeleteCargoName', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(convertUserCargoToAdmin, 'convertUserCargoToAdmin', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(deleteCargoRealName, 'deleteCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(getTagsCategories, 'getTagsCategories', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(addTagsCategories, 'addTagsCategories', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(addTag, 'addTag', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(searchTags, 'searchTags', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(saveTags, 'saveTags', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    reactHotLoader.register(getCargoRealNamesPaginated, 'getCargoRealNamesPaginated', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/realNames.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = postRequestCargo;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeUserCargoRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteCargoRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCargoMonitor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postRequestCargo(cargoRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/requests/cargo',
        withCredentials: true,
        data: cargoRequest
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function changeUserCargoRequest(cargoRequestId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/requests/cargo/' + cargoRequestId + '/changeOwner',
        withCredentials: true,
        data: {
            user: userId
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteCargoRequest(cargoRequestId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/requests/cargo/' + cargoRequestId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getCargoMonitor(filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/deck/admin/cargo',
        withCredentials: true,
        data: {
            page: filter.page || 1,
            filters: filter.filters || {}
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestCargo, 'postRequestCargo', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/requests.js');
    reactHotLoader.register(changeUserCargoRequest, 'changeUserCargoRequest', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/requests.js');
    reactHotLoader.register(deleteCargoRequest, 'deleteCargoRequest', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/requests.js');
    reactHotLoader.register(getCargoMonitor, 'getCargoMonitor', '/opt/atlassian/pipelines/agent/build/client/app/services/cargoes/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = postAnnotations;
/* unused harmony export getFilters */
/* unused harmony export getFilter */
/* unused harmony export updateFilter */
/* unused harmony export deleteFilter */
/* unused harmony export addFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function chooseServer(typeLetter, typeServer) {
    if (typeLetter === 'polza') {
        return '/polza/annotate';
    } else if (typeLetter === 'sizes') {
        return '/sizes/annotate';
    }

    switch (typeServer) {
        case 'localhost':
            {
                if (typeLetter === 'cargo') {
                    return 'http://localhost:5000/annotate';
                }
                return 'http://localhost:5001/annotate';
            }
        case 's4.anotatr.com':
            {
                if (typeLetter === 'cargo') {
                    return '/s4/cargo/annotate';
                }
                return '/s4/vessel/annotate';
            }
        case 'nata.im':
            return '/servnata/api' + typeLetter + '/annotate';
        case 's11.anotatr.com':
            if (typeLetter === 'cargo') {
                return '/s11/cargo/annotate';
            }
            return '/s11/vessel/annotate';

        case 's1.anotatr.com':
            if (typeLetter === 'cargo') {
                return '/s1/cargo/annotate';
            }
            return '/s1/vessel/annotate';

        case '94.130.128.45':
            {
                if (typeLetter === 'cargo') {
                    return 'http://94.130.128.45:8086/annotate';
                }
                return 'http://94.130.128.45:8085/annotate';
            }
        case '1-shipdev.me':
            {
                if (typeLetter === 'cargo') {
                    return '/shipdev/cargo/annotate';
                }
                return '/shipdev/vessel/annotate';
            }
        case 'polza':
            {
                if (typeLetter === 'cargo') {
                    return '/polza/cargo/annotate';
                }
                return '/polza/vessel/annotate';
            }
        case 'mailparse.net':
        default:
            {
                return '/' + typeLetter + '/annotate';
            }
    }
}

function postAnnotations(text, typeLetter, typeServer) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    options = Object.assign(options, { timeout: 40 });
    var url = chooseServer(typeLetter, typeServer);

    var _options = options,
        _options$isSimpleForm = _options.isSimpleForm,
        isSimpleForm = _options$isSimpleForm === undefined ? undefined : _options$isSimpleForm,
        _options$subject = _options.subject,
        subject = _options$subject === undefined ? undefined : _options$subject,
        _options$date = _options.date,
        date = _options$date === undefined ? undefined : _options$date;


    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: url,
        params: options,
        data: {
            isSimpleForm: isSimpleForm || undefined,
            text: text,
            subject: subject,
            date: date
        }
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getFilters(user) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/get/',
        data: {
            id: user._id
        }
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getFilter(user, filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/get/',
        data: {
            id: user._id
        }
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateFilter(id, filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/get/',
        data: {
            id: user._id
        }
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteFilter(id, filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/get/',
        data: {
            id: user._id
        }
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}

function addFilter(id, filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/get/',
        data: {
            id: user._id
        }
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(chooseServer, 'chooseServer', '/opt/atlassian/pipelines/agent/build/client/app/services/annotations.js');
    reactHotLoader.register(postAnnotations, 'postAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/services/annotations.js');
    reactHotLoader.register(getFilters, 'getFilters', '/opt/atlassian/pipelines/agent/build/client/app/services/annotations.js');
    reactHotLoader.register(getFilter, 'getFilter', '/opt/atlassian/pipelines/agent/build/client/app/services/annotations.js');
    reactHotLoader.register(updateFilter, 'updateFilter', '/opt/atlassian/pipelines/agent/build/client/app/services/annotations.js');
    reactHotLoader.register(deleteFilter, 'deleteFilter', '/opt/atlassian/pipelines/agent/build/client/app/services/annotations.js');
    reactHotLoader.register(addFilter, 'addFilter', '/opt/atlassian/pipelines/agent/build/client/app/services/annotations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCountries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCountries() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/countries',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCountries, 'getCountries', '/opt/atlassian/pipelines/agent/build/client/app/services/counties.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getVesselClaims;
/* harmony export (immutable) */ __webpack_exports__["a"] = acceptUserClaimsToVessel;
/* harmony export (immutable) */ __webpack_exports__["c"] = rejectUserClaimsToVessel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getVesselClaims() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/users/claim/vessel',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function acceptUserClaimsToVessel(userId, vesselId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/users/claim/vessel/accept',
        withCredentials: true,
        data: {
            user: userId,
            vessel: vesselId
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function rejectUserClaimsToVessel(userId, vesselId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/users/claim/vessel/reject',
        withCredentials: true,
        data: {
            user: userId,
            vessel: vesselId
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVesselClaims, 'getVesselClaims', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/claims.js');
    reactHotLoader.register(acceptUserClaimsToVessel, 'acceptUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/claims.js');
    reactHotLoader.register(rejectUserClaimsToVessel, 'rejectUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/claims.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = postRequestVessel;
/* harmony export (immutable) */ __webpack_exports__["c"] = getVesselMonitor;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeUserVesselRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteVesselRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postRequestVessel(vesselRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/requests/vessel',
        data: vesselRequest,
        params: {
            wrapper: vesselRequest.clientVessel ? 'email_wrapper' : undefined
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getVesselMonitor(filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/requests/vessels',
        withCredentials: true,
        data: {
            page: filter.page || 1,
            filters: filter.filters || {},
            sort: filter.sort || {}
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function changeUserVesselRequest(vesselRequestId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/requests/vessel/' + vesselRequestId + '/changeOwner',
        withCredentials: true,
        data: {
            user: userId
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteVesselRequest(vesselId, requestId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/vessels/position/' + vesselId + '/' + requestId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestVessel, 'postRequestVessel', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/requests.js');
    reactHotLoader.register(getVesselMonitor, 'getVesselMonitor', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/requests.js');
    reactHotLoader.register(changeUserVesselRequest, 'changeUserVesselRequest', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/requests.js');
    reactHotLoader.register(deleteVesselRequest, 'deleteVesselRequest', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = findYards;
/* harmony export (immutable) */ __webpack_exports__["a"] = addYard;
/* harmony export (immutable) */ __webpack_exports__["c"] = getYardById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function findYards(text) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/yards/find',
        data: {
            query: text
        },
        withCredentials: true
    });
}

function addYard(text) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/vi/yards/save',
        data: {
            query: text
        },
        withCredentials: true
    });
}

function getYardById() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/yards',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(findYards, 'findYards', '/opt/atlassian/pipelines/agent/build/client/app/services/yards.js');
    reactHotLoader.register(addYard, 'addYard', '/opt/atlassian/pipelines/agent/build/client/app/services/yards.js');
    reactHotLoader.register(getYardById, 'getYardById', '/opt/atlassian/pipelines/agent/build/client/app/services/yards.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = findClasses;
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["c"] = getClassById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function findClasses(text) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/register-class/find',
        data: {
            query: text
        },
        withCredentials: true
    });
}

function addClass(text) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/vi/register-class/save',
        data: {
            query: text
        },
        withCredentials: true
    });
}

function getClassById() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/register-class',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(findClasses, 'findClasses', '/opt/atlassian/pipelines/agent/build/client/app/services/registerClass.js');
    reactHotLoader.register(addClass, 'addClass', '/opt/atlassian/pipelines/agent/build/client/app/services/registerClass.js');
    reactHotLoader.register(getClassById, 'getClassById', '/opt/atlassian/pipelines/agent/build/client/app/services/registerClass.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = findPIClubs;
/* harmony export (immutable) */ __webpack_exports__["a"] = addPIClub;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPIClubById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function findPIClubs(text) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/pi-club/find',
        data: {
            query: text
        },
        withCredentials: true
    });
}

function addPIClub(text) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/vi/pi-club/save',
        data: {
            query: text
        },
        withCredentials: true
    });
}

function getPIClubById() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/pi-club',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(findPIClubs, 'findPIClubs', '/opt/atlassian/pipelines/agent/build/client/app/services/piClubs.js');
    reactHotLoader.register(addPIClub, 'addPIClub', '/opt/atlassian/pipelines/agent/build/client/app/services/piClubs.js');
    reactHotLoader.register(getPIClubById, 'getPIClubById', '/opt/atlassian/pipelines/agent/build/client/app/services/piClubs.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsUsers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsUsers(from, until) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/statistics/user',
        data: {
            from: from,
            until: until
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsUsers, 'getStatisticsUsers', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/users.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsEmails;
/* unused harmony export getStatisticsEmailsReceived */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



/**
 * Get statistics emails
 * @param {number} from
 * @param {number} until
 * @param {boolean} isWorkingHours
 * @returns {Promise<Object>}
 */
function getStatisticsEmails(from, until, isWorkingHours) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/statistics/emails',
        data: {
            from: from,
            until: until,
            isWorkingHours: isWorkingHours
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getStatisticsEmailsReceived(from, until) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/statistics/emails-received',
        data: {
            from: from,
            until: until
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsEmails, 'getStatisticsEmails', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/emails.js');
    reactHotLoader.register(getStatisticsEmailsReceived, 'getStatisticsEmailsReceived', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/emails.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsMonitor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsMonitor(from, until) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/statistics/monitor',
        data: {
            from: from,
            until: until
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsMonitor, 'getStatisticsMonitor', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/monitor.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsSt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsSt(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/statistics/userStatistic',
        data: data
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsSt, 'getStatisticsSt', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/st.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsCargoRequests;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsCargoRequests(from, until) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/statistics/cargoRequests',
        data: {
            from: from,
            until: until
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsCargoRequests, 'getStatisticsCargoRequests', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/cargoRequests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsVesselPositions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getStatisticsVesselPositions(from, until) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/statistics/vesselPositions',
        data: {
            from: from,
            until: until
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsVesselPositions, 'getStatisticsVesselPositions', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/vesselPositions.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCompositionStats;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



// eslint-disable-next-line import/prefer-default-export
function getCompositionStats(from, until) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/mails/vesselComposition/stats',
        data: {
            from: from,
            until: until
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCompositionStats, 'getCompositionStats', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/composition.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = uploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function uploadFile(_ref) {
    var _ref$file = _ref.file,
        file = _ref$file === undefined ? {} : _ref$file,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'image' : _ref$type;

    var data = new FormData();
    data.append('type', type);
    data.append('file', file);

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/file/upload',
        withCredentials: true,
        data: data
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(uploadFile, 'uploadFile', '/opt/atlassian/pipelines/agent/build/client/app/services/files.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = deletePreference;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPreference;
/* harmony export (immutable) */ __webpack_exports__["d"] = updatePreference;
/* harmony export (immutable) */ __webpack_exports__["e"] = updatePreferenceMeta;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPreferences;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function deletePreference(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v1/admin/preferences/' + data._id,
        withCredentials: true
    }).then(function (response) {
        return response;
    }).catch(function (errors) {
        return errors.response;
    });
}

function getPreference(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/admin/preferences/' + data._id,
        withCredentials: true
    }).then(function (response) {
        return response;
    }).catch(function (errors) {
        return errors.response;
    });
}

function updatePreference(data, _id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/admin/preferences/' + _id,
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response;
    }).catch(function (errors) {
        return errors.response;
    });
}

function updatePreferenceMeta(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/admin/preferences/' + data._id + '/meta',
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response;
    }).catch(function (errors) {
        return errors.response;
    });
}

function getPreferences(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v1/admin/preferences/byType/' + data.type,
        withCredentials: true
    }).then(function (response) {
        return response;
    }).catch(function (errors) {
        return errors.response;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(deletePreference, 'deletePreference', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/index.js');
    reactHotLoader.register(getPreference, 'getPreference', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/index.js');
    reactHotLoader.register(updatePreference, 'updatePreference', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/index.js');
    reactHotLoader.register(updatePreferenceMeta, 'updatePreferenceMeta', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/index.js');
    reactHotLoader.register(getPreferences, 'getPreferences', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createFilterAnnotationsPreference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function createFilterAnnotationsPreference(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/admin/preferences/filter/' + data.name,
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.error;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(createFilterAnnotationsPreference, 'createFilterAnnotationsPreference', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/filterAnnotations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getMailRecognizeSpamList;
/* harmony export (immutable) */ __webpack_exports__["a"] = createMailRecognizeSpamList;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateMailRecognizeSpamList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getMailRecognizeSpamList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/admin/preferences/singleByType/mailRecognizeSpamList',
        withCredentials: true
    }).then(function (response) {
        return response;
    }).catch(function (error) {
        if (error.response.status === 404) {
            return createMailRecognizeSpamList([]);
        }

        throw error;
    });
}

function createMailRecognizeSpamList(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/admin/preferences/mailRecognizeSpamList',
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response;
    }).catch(function (error) {
        return error;
    });
}

function updateMailRecognizeSpamList(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/admin/preferences/mailRecognizeSpamList/append',
        headers: {
            'Content-Type': 'text/plain'
        },
        data: data
    }).then(function (response) {
        return response;
    }).catch(function (error) {
        return error;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getMailRecognizeSpamList, 'getMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(createMailRecognizeSpamList, 'createMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(updateMailRecognizeSpamList, 'updateMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/services/preferences/mailRecognizeSpamList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getSendEmailList;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSendEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getSendEmailList(_ref) {
    var limit = _ref.limit,
        page = _ref.page,
        filters = _ref.filters;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/sender?limit=' + limit + '&page=' + page + '&filters=' + JSON.stringify(filters.search.length >= 2 ? filters : {}),
        withCredentials: true
    });
}

function getSendEmail(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/sender/' + id,
        withCredentials: true
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getSendEmailList, 'getSendEmailList', '/opt/atlassian/pipelines/agent/build/client/app/services/sender.js');
    reactHotLoader.register(getSendEmail, 'getSendEmail', '/opt/atlassian/pipelines/agent/build/client/app/services/sender.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["loadXls"] = loadXls;
/* harmony export (immutable) */ __webpack_exports__["loadRecognitionInfo"] = loadRecognitionInfo;
/* harmony export (immutable) */ __webpack_exports__["loadFieldTypes"] = loadFieldTypes;
/* harmony export (immutable) */ __webpack_exports__["parseMailAttachments"] = parseMailAttachments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-02-26 13:24:52 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-08-15 19:15:55
 */



var apiServer = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: '/api/v1/' // http://localhost:7777
});

function loadXls(filename) {
    var download = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return apiServer.get("packing-list/getFileStream/" + encodeURIComponent(filename), { responseType: download ? 'blob' : 'arraybuffer' }).then(function (res) {
        return download ? new Blob([res.data]) : new Uint8Array(res.data);
    });
}

function loadRecognitionInfo(mailId) {
    return apiServer.get('packing-list/getRecognitionInfo/' + mailId);
}

function loadFieldTypes() {
    return apiServer.get('packing-list/fieldTypes');
}

function parseMailAttachments(mailId, attachments) {
    var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return apiServer.post('packing-list/recognizeMailAttachments/' + mailId, {
        mailId: mailId,
        attachments: attachments
    }, {
        params: {
            force: force ? "" : undefined
        }
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(apiServer, 'apiServer', '/opt/atlassian/pipelines/agent/build/client/app/services/packingList.js');
    reactHotLoader.register(loadXls, 'loadXls', '/opt/atlassian/pipelines/agent/build/client/app/services/packingList.js');
    reactHotLoader.register(loadRecognitionInfo, 'loadRecognitionInfo', '/opt/atlassian/pipelines/agent/build/client/app/services/packingList.js');
    reactHotLoader.register(loadFieldTypes, 'loadFieldTypes', '/opt/atlassian/pipelines/agent/build/client/app/services/packingList.js');
    reactHotLoader.register(parseMailAttachments, 'parseMailAttachments', '/opt/atlassian/pipelines/agent/build/client/app/services/packingList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = connectNewDomainToUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteDomain;
/* harmony export (immutable) */ __webpack_exports__["c"] = getListDomain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function connectNewDomainToUser(_ref) {
    var domain = _ref.domain,
        user = _ref.user;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/domain/',
        withCredentials: true,
        data: {
            domain: domain,
            user: user
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        return error.response;
    });
}

function deleteDomain(_ref2) {
    var id = _ref2.id;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/domain/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        return error.response;
    });
}

function getListDomain() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/domain/',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (error) {
        return error.response;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(connectNewDomainToUser, 'connectNewDomainToUser', '/opt/atlassian/pipelines/agent/build/client/app/services/domains.js');
    reactHotLoader.register(deleteDomain, 'deleteDomain', '/opt/atlassian/pipelines/agent/build/client/app/services/domains.js');
    reactHotLoader.register(getListDomain, 'getListDomain', '/opt/atlassian/pipelines/agent/build/client/app/services/domains.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getSubscribers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getSubscribers(_ref) {
    var limit = _ref.limit,
        page = _ref.page,
        filters = _ref.filters;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/subscribe/upc',
        params: {
            limit: limit,
            page: page,
            filters: JSON.stringify(_extends({}, filters, {
                search: filters.search.length > 2 ? filters.search : undefined
            }))
        },
        withCredentials: true
    }).then(function (response) {
        return response;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getSubscribers, 'getSubscribers', '/opt/atlassian/pipelines/agent/build/client/app/services/users/subscribers.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = getBackendNotifications;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBackendNotification;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteBackendNotification;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateBackendNotification;
/* harmony export (immutable) */ __webpack_exports__["a"] = createBackendNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getBackendNotifications() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/notification/actual',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function getBackendNotification(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'get',
        url: '/api/v1/notification/actual',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function deleteBackendNotification(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/notification/actual/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateBackendNotification(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/notification/actual/' + data._id,
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function createBackendNotification(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/notification/actual',
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getBackendNotifications, 'getBackendNotifications', '/opt/atlassian/pipelines/agent/build/client/app/services/backendNotifications.js');
    reactHotLoader.register(getBackendNotification, 'getBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/services/backendNotifications.js');
    reactHotLoader.register(deleteBackendNotification, 'deleteBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/services/backendNotifications.js');
    reactHotLoader.register(updateBackendNotification, 'updateBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/services/backendNotifications.js');
    reactHotLoader.register(createBackendNotification, 'createBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/services/backendNotifications.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(254);
var fetchTimeCharterRegions = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? 'mpp' : _ref2$type;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/tcRatePrices', { type: type });

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchTimeCharterRegions() {
    return _ref.apply(this, arguments);
  };
}();

var createTimeCharterRegion = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/tcRatePrice', data, 'post');

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function createTimeCharterRegion(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var removeTimeCharterRegion = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/tcRatePrice', data, 'delete');

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function removeTimeCharterRegion(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var updateTimeCharterRegion = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/tcRatePrice', data, 'put');

          case 2:
            return _context4.abrupt('return', _context4.sent);

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function updateTimeCharterRegion(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

var recalculateTimeCharterRegion = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id, data) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/tcRatePrice/recalculate?id=' + id, data, 'put');

          case 2:
            return _context5.abrupt('return', _context5.sent);

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function recalculateTimeCharterRegion(_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var _default = {
  fetchTimeCharterRegions: fetchTimeCharterRegions,
  createTimeCharterRegion: createTimeCharterRegion,
  removeTimeCharterRegion: removeTimeCharterRegion,
  updateTimeCharterRegion: updateTimeCharterRegion,
  recalculateTimeCharterRegion: recalculateTimeCharterRegion
};


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(fetchTimeCharterRegions, 'fetchTimeCharterRegions', '/opt/atlassian/pipelines/agent/build/client/app/services/timeCharters.js');
  reactHotLoader.register(createTimeCharterRegion, 'createTimeCharterRegion', '/opt/atlassian/pipelines/agent/build/client/app/services/timeCharters.js');
  reactHotLoader.register(removeTimeCharterRegion, 'removeTimeCharterRegion', '/opt/atlassian/pipelines/agent/build/client/app/services/timeCharters.js');
  reactHotLoader.register(updateTimeCharterRegion, 'updateTimeCharterRegion', '/opt/atlassian/pipelines/agent/build/client/app/services/timeCharters.js');
  reactHotLoader.register(recalculateTimeCharterRegion, 'recalculateTimeCharterRegion', '/opt/atlassian/pipelines/agent/build/client/app/services/timeCharters.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/services/timeCharters.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(254);
var _this = this;

var fetchList = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/fuelPrice'));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function fetchList() {
        return _ref.apply(this, arguments);
    };
}();

var updateAll = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/fuelPrice/updateAll', {}, 'put'));

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function updateAll() {
        return _ref2.apply(this, arguments);
    };
}();

var updateOne = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/fuelPrice', data, 'put'));

                    case 1:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function updateOne(_x) {
        return _ref3.apply(this, arguments);
    };
}();

/**
 * @param {{
 *  date: string, 
 *  isArea?: boolean,
 *  entityId: string,
 * }} filter date must be format yyyy-mm-dd
 */


(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var getFuelPriceFiltered = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref5) {
        var date = _ref5.date,
            entityId = _ref5.entityId,
            _ref5$isArea = _ref5.isArea,
            isArea = _ref5$isArea === undefined ? false : _ref5$isArea;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/fuelPriceById/' + entityId, { date: date, isArea: isArea }, 'post'));

                    case 1:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function getFuelPriceFiltered(_x2) {
        return _ref4.apply(this, arguments);
    };
}();

var getFuelPriceFilteredV2 = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref7) {
        var date = _ref7.date,
            entityId = _ref7.entityId,
            _ref7$isArea = _ref7.isArea,
            isArea = _ref7$isArea === undefined ? false : _ref7$isArea;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].callV2('prices/fuel/getByPortId/' + entityId, { date: date, isArea: isArea }, 'post'));

                    case 1:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    }));

    return function getFuelPriceFilteredV2(_x3) {
        return _ref6.apply(this, arguments);
    };
}();

var _default = {
    fetchList: fetchList,
    updateOne: updateOne,
    updateAll: updateAll,
    getFuelPriceFiltered: getFuelPriceFiltered,
    getFuelPriceFilteredV2: getFuelPriceFilteredV2
};
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fetchList, 'fetchList', '/opt/atlassian/pipelines/agent/build/client/app/services/fuel.js');
    reactHotLoader.register(updateAll, 'updateAll', '/opt/atlassian/pipelines/agent/build/client/app/services/fuel.js');
    reactHotLoader.register(updateOne, 'updateOne', '/opt/atlassian/pipelines/agent/build/client/app/services/fuel.js');
    reactHotLoader.register(getFuelPriceFiltered, 'getFuelPriceFiltered', '/opt/atlassian/pipelines/agent/build/client/app/services/fuel.js');
    reactHotLoader.register(getFuelPriceFilteredV2, 'getFuelPriceFilteredV2', '/opt/atlassian/pipelines/agent/build/client/app/services/fuel.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/services/fuel.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(254);
var fetchList = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/pdaPrice');

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchList() {
    return _ref.apply(this, arguments);
  };
}();

var create = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/pdaPrice', data, 'post');

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function create(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var updateOne = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/pdaPrice', data, 'put');

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function updateOne(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var remove = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */].call('prices/pdaPrice', { _id: id }, 'delete');

          case 2:
            return _context4.abrupt('return', _context4.sent);

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function remove(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var _default = {
  fetchList: fetchList,
  updateOne: updateOne,
  create: create,
  remove: remove
};


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(fetchList, 'fetchList', '/opt/atlassian/pipelines/agent/build/client/app/services/disbursement.js');
  reactHotLoader.register(create, 'create', '/opt/atlassian/pipelines/agent/build/client/app/services/disbursement.js');
  reactHotLoader.register(updateOne, 'updateOne', '/opt/atlassian/pipelines/agent/build/client/app/services/disbursement.js');
  reactHotLoader.register(remove, 'remove', '/opt/atlassian/pipelines/agent/build/client/app/services/disbursement.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/services/disbursement.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getIntegrators;
/* harmony export (immutable) */ __webpack_exports__["b"] = getIntegratorCompanies;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCompanyUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();



function getIntegrators() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: "get",
    url: "/api/v2/integrators"
  }).then(function (response) {
    return response.data;
  }).catch(function (response) {
    return response.response.data;
  });
}

function getIntegratorCompanies(id) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: "get",
    url: "/api/v2/integrators/" + id + "/companies"
  }).then(function (response) {
    return response.data;
  }).catch(function (response) {
    return response.response.data;
  });
}

function getCompanyUser(id, integratorId) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
    method: "get",
    url: "/api/v2/integrators/" + integratorId + "/users/" + id
  }).then(function (response) {
    return response.data;
  }).catch(function (response) {
    return response.response.data;
  });
}
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getIntegrators, "getIntegrators", "/opt/atlassian/pipelines/agent/build/client/app/services/integrators/integrators.js");
  reactHotLoader.register(getIntegratorCompanies, "getIntegratorCompanies", "/opt/atlassian/pipelines/agent/build/client/app/services/integrators/integrators.js");
  reactHotLoader.register(getCompanyUser, "getCompanyUser", "/opt/atlassian/pipelines/agent/build/client/app/services/integrators/integrators.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = getReqLDRates;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteReqLDRate;
/* harmony export (immutable) */ __webpack_exports__["c"] = editReqLDRate;
/* harmony export (immutable) */ __webpack_exports__["a"] = addReqLDRate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getReqLDRates(_ref) {
    var page = _ref.page,
        limit = _ref.limit,
        filter = _ref.filter;


    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/reqRates/',
        withCredentials: true,
        data: {
            page: page,
            limit: limit,
            filter: filter
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function deleteReqLDRate(_id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v1/reqRates/',
        withCredentials: true,
        data: {
            _id: _id
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function editReqLDRate(data) {
    var cargoWeight = data.cargoWeight,
        cargoVolume = data.cargoVolume;


    if (!cargoWeight && cargoVolume) {
        delete data.cargoWeight;
    } else if (cargoWeight && !cargoVolume) {
        delete data.cargoVolume;
    }

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/reqRates/',
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function addReqLDRate(data) {
    var cargoWeight = data.cargoWeight,
        cargoVolume = data.cargoVolume;


    if (!cargoWeight && cargoVolume) {
        delete data.cargoWeight;
    } else if (cargoWeight && !cargoVolume) {
        delete data.cargoVolume;
    }

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/reqRates/add',
        withCredentials: true,
        data: data
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getReqLDRates, 'getReqLDRates', '/opt/atlassian/pipelines/agent/build/client/app/services/reqLDRates.js');
    reactHotLoader.register(deleteReqLDRate, 'deleteReqLDRate', '/opt/atlassian/pipelines/agent/build/client/app/services/reqLDRates.js');
    reactHotLoader.register(editReqLDRate, 'editReqLDRate', '/opt/atlassian/pipelines/agent/build/client/app/services/reqLDRates.js');
    reactHotLoader.register(addReqLDRate, 'addReqLDRate', '/opt/atlassian/pipelines/agent/build/client/app/services/reqLDRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = addMailerGoogle;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInternalMailers;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeInternalMailer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function addMailerGoogle(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/users/mailGates/fromTemplate/gmail',
        withCredentials: true,
        data: {
            userId: userId
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getInternalMailers() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/adminPanel/mailers',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function removeInternalMailer(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v2/adminPanel/mailers/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(addMailerGoogle, 'addMailerGoogle', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/mailers.js');
    reactHotLoader.register(getInternalMailers, 'getInternalMailers', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/mailers.js');
    reactHotLoader.register(removeInternalMailer, 'removeInternalMailer', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/mailers.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = sendTrainings;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteTraining;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function sendTrainings(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/typedEmails',
        data: data,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteTraining(_ref) {
    var mailId = _ref.mailId;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/typedEmails/' + mailId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sendTrainings, 'sendTrainings', '/opt/atlassian/pipelines/agent/build/client/app/services/trainings.js');
    reactHotLoader.register(deleteTraining, 'deleteTraining', '/opt/atlassian/pipelines/agent/build/client/app/services/trainings.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = pdaGetAll;
/* harmony export (immutable) */ __webpack_exports__["d"] = pdaUpdate;
/* harmony export (immutable) */ __webpack_exports__["b"] = pdaDelete;
/* harmony export (immutable) */ __webpack_exports__["a"] = pdaAdd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function pdaGetAll(_ref) {
    var page = _ref.page,
        limit = _ref.limit,
        filter = _ref.filter;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/prices/pdaCustomAll',
        data: {
            page: page,
            limit: limit,
            filter: filter
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function pdaUpdate(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'put',
        url: '/api/v1/prices/pdaCustom',
        data: data,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function pdaDelete(_id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/prices/pdaCustom',
        data: {
            _id: _id
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function pdaAdd(data) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/prices/pdaCustom',
        data: _extends({}, data, {
            userEntry: false
        }),
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });;
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(pdaGetAll, 'pdaGetAll', '/opt/atlassian/pipelines/agent/build/client/app/services/prices.js');
    reactHotLoader.register(pdaUpdate, 'pdaUpdate', '/opt/atlassian/pipelines/agent/build/client/app/services/prices.js');
    reactHotLoader.register(pdaDelete, 'pdaDelete', '/opt/atlassian/pipelines/agent/build/client/app/services/prices.js');
    reactHotLoader.register(pdaAdd, 'pdaAdd', '/opt/atlassian/pipelines/agent/build/client/app/services/prices.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = findVesselDesign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function findVesselDesign(name) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v1/vesselDesign/find',
        data: {
            name: name
        },
        withCredentials: true
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(findVesselDesign, 'findVesselDesign', '/opt/atlassian/pipelines/agent/build/client/app/services/design.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = postRequestTc;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteTcRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRequestsTc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postRequestTc(tcRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/timecharters/orders/create-from-admin',
        withCredentials: true,
        data: tcRequest
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteTcRequest(tcRequestId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v2/timecharters/orders/admin/' + tcRequestId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getRequestsTc(filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v2/timecharters/orders/admin/tc',
        withCredentials: true,
        data: _extends({}, filter)
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestTc, 'postRequestTc', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/requests.js');
    reactHotLoader.register(deleteTcRequest, 'deleteTcRequest', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/requests.js');
    reactHotLoader.register(getRequestsTc, 'getRequestsTc', '/opt/atlassian/pipelines/agent/build/client/app/services/tc/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = postVesselSale;
/* harmony export (immutable) */ __webpack_exports__["b"] = getVesselSales;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteVesselSale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postVesselSale(vesselId, _ref) {
    var mailId = _ref.mailId,
        ideaPrice = _ref.ideaPrice,
        salePrice = _ref.salePrice,
        context = _ref.context,
        realUserEmail = _ref.realUserEmail;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/vessels/admin/forSale/' + vesselId,
        data: {
            mailId: mailId,
            ideaPrice: ideaPrice,
            salePrice: salePrice,
            context: context,
            realUserEmail: realUserEmail
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getVesselSales(_ref2) {
    var page = _ref2.page,
        filters = _ref2.filters;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/vessels/admin/forSale',
        data: {
            page: page || 1,
            filters: filters || {}
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteVesselSale(saleId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'delete',
        url: '/api/v1/vessels/admin/forSale/' + saleId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postVesselSale, 'postVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/sales.js');
    reactHotLoader.register(getVesselSales, 'getVesselSales', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/sales.js');
    reactHotLoader.register(deleteVesselSale, 'deleteVesselSale', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/sales.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getEmailsForVesselComposition;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveVesselSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = rejectVesselSize;
/* harmony export (immutable) */ __webpack_exports__["c"] = getVesselsCompositions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getEmailsForVesselComposition(filters) {
    var vessel = filters.vessel,
        emailId = filters.emailId,
        approved = filters.approved,
        page = filters.page,
        params = filters.params;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/mails/vesselComposition/' + (vessel._id || ''),
        withCredentials: true,
        data: {
            emailId: emailId,
            approved: approved,
            page: page,
            params: params
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function approveVesselSize(vesselId, emailIds, field, sizeIds) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/mails/vesselComposition/' + vesselId + '/approve',
        data: {
            emailIds: emailIds,
            field: field,
            sizeIds: sizeIds
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function rejectVesselSize(vesselId, emailIds, field, sizeIds, reason) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/mails/vesselComposition/' + vesselId + '/reject',
        data: {
            emailIds: emailIds,
            field: field,
            sizeIds: sizeIds,
            reason: reason
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

/**
 * 
 * @param {CompositionFilters} filters 
 */
function getVesselsCompositions(filters) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v1/mails/vesselComposition',
        data: filters,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

/**
 * @typedef {{ vesselId?: string, emailId?: string, page: number, limit: number }} CompositionFilters
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getEmailsForVesselComposition, 'getEmailsForVesselComposition', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/composition.js');
    reactHotLoader.register(approveVesselSize, 'approveVesselSize', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/composition.js');
    reactHotLoader.register(rejectVesselSize, 'rejectVesselSize', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/composition.js');
    reactHotLoader.register(getVesselsCompositions, 'getVesselsCompositions', '/opt/atlassian/pipelines/agent/build/client/app/services/vessels/composition.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["d"] = getAnalyticsLinksList;
/* harmony export (immutable) */ __webpack_exports__["a"] = createAnalyticsLinks;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateAnalyticsLinksList;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteAnalyticLink;
/* harmony export (immutable) */ __webpack_exports__["c"] = findAnalyticsTags;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendToDev;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getAnalyticsLinksList() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/adminPanel/analytics',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function createAnalyticsLinks(records) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/analytics',
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            records: records
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateAnalyticsLinksList(record) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v2/adminPanel/analytics/' + record._id,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            record: record
        }
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function deleteAnalyticLink(recordId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'DELETE',
        url: '/api/v2/adminPanel/analytics/' + recordId,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function findAnalyticsTags(search) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/adminPanel/analytics/findTags/' + search,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function sendToDev(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v1/mails/share/dev/' + id,
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getAnalyticsLinksList, 'getAnalyticsLinksList', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/linksList.js');
    reactHotLoader.register(createAnalyticsLinks, 'createAnalyticsLinks', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/linksList.js');
    reactHotLoader.register(updateAnalyticsLinksList, 'updateAnalyticsLinksList', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/linksList.js');
    reactHotLoader.register(deleteAnalyticLink, 'deleteAnalyticLink', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/linksList.js');
    reactHotLoader.register(findAnalyticsTags, 'findAnalyticsTags', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/linksList.js');
    reactHotLoader.register(sendToDev, 'sendToDev', '/opt/atlassian/pipelines/agent/build/client/app/services/analytics/linksList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getFlagCompliance;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateFlagCompliance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getFlagCompliance() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/api/v2/flag-compliance',
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function updateFlagCompliance(complianceId, _ref) {
    var avoid = _ref.avoid,
        riskFactor = _ref.riskFactor;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v2/flag-compliance/' + complianceId,
        data: {
            avoid: avoid,
            riskFactor: riskFactor
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getFlagCompliance, 'getFlagCompliance', '/opt/atlassian/pipelines/agent/build/client/app/services/flagCompliance.js');
    reactHotLoader.register(updateFlagCompliance, 'updateFlagCompliance', '/opt/atlassian/pipelines/agent/build/client/app/services/flagCompliance.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVesselSanctions; });
/* harmony export (immutable) */ __webpack_exports__["b"] = updateVesselCompliance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var getVesselSanctions = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(imo) {
        var sanctions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'GET',
                            url: '/api/v2/vessels/' + imo + '/compliance',
                            withCredentials: true
                        });

                    case 3:
                        sanctions = _context.sent;
                        return _context.abrupt('return', sanctions.data || sanctions.response.data);

                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context['catch'](0);

                        console.error('e');
                        return _context.abrupt('return', []);

                    case 11:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[0, 7]]);
    }));

    return function getVesselSanctions(_x) {
        return _ref.apply(this, arguments);
    };
}();

function updateVesselCompliance(imo, complianceId, type, data) {
    var _data;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'PUT',
        url: '/api/v2/vessels/' + imo + '/compliance/admin/' + type,
        withCredentials: true,
        data: (_data = {}, _defineProperty(_data, type, data), _defineProperty(_data, 'sanctionsId', complianceId), _data)
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVesselSanctions, 'getVesselSanctions', '/opt/atlassian/pipelines/agent/build/client/app/services/sanctions.js');
    reactHotLoader.register(updateVesselCompliance, 'updateVesselCompliance', '/opt/atlassian/pipelines/agent/build/client/app/services/sanctions.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateIssueStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addIssueComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateIssueComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteIssueComment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/**
 * 
 * @param {{
 *  page: number,
 *  limit: number,
 *  filters: Filters,
 * }} pagination 
 * @returns 
 */
var getIssues = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pagination) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'post',
                            url: '/api/v2/issues/list',
                            data: pagination
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getIssues(_x) {
        return _ref.apply(this, arguments);
    };
}();

var getIssue = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'get',
                            url: '/api/v2/issues/' + id
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function getIssue(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

/**
 * 
 * @param {string} id 
 * @param {Status } status 
 */
var updateIssueStatus = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, status) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'put',
                            url: '/api/v2/issues/' + id + '/status',
                            data: { status: status }
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function updateIssueStatus(_x3, _x4) {
        return _ref3.apply(this, arguments);
    };
}();

/**
 * 
 * @param {string} id 
 * @param {Comment} data 
 */
var addIssueComment = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id, data) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'post',
                            url: '/api/v2/issues/' + id + '/comment',
                            data: data
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function addIssueComment(_x5, _x6) {
        return _ref4.apply(this, arguments);
    };
}();

/**
 * 
 * @param {string} id 
 * @param {string} commentId
 * @param {Comment} data 
 */
var updateIssueComment = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id, commentId, data) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'put',
                            url: '/api/v2/issues/' + id + '/comment/' + commentId,
                            data: data
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function updateIssueComment(_x7, _x8, _x9) {
        return _ref5.apply(this, arguments);
    };
}();

/**
 * 
 * @param {string} id 
 * @param {string} commentId 
 */
var deleteIssueComment = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id, commentId) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'delete',
                            url: '/api/v2/issues/' + id + '/comment/' + commentId
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function deleteIssueComment(_x10, _x11) {
        return _ref6.apply(this, arguments);
    };
}();

/**
 * @typedef {Object} Filters
 * @property {string} [company]
 * @property {Date} [dateFrom]
 * @property {Date} [dateTo]
 */

/**
 * @typedef {'new' | 'inProgress' | 'confirmed' | 'fixed' | 'notBug'} Status
 */

/**
 * @typedef {Object} Comment
 * @property {string} text
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getIssues, 'getIssues', '/opt/atlassian/pipelines/agent/build/client/app/services/issues.js');
    reactHotLoader.register(getIssue, 'getIssue', '/opt/atlassian/pipelines/agent/build/client/app/services/issues.js');
    reactHotLoader.register(updateIssueStatus, 'updateIssueStatus', '/opt/atlassian/pipelines/agent/build/client/app/services/issues.js');
    reactHotLoader.register(addIssueComment, 'addIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/services/issues.js');
    reactHotLoader.register(updateIssueComment, 'updateIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/services/issues.js');
    reactHotLoader.register(deleteIssueComment, 'deleteIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/services/issues.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return saveRequestsDataCreated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveRequestsDataDeleted; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/**
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {object} request 
 * @returns 
 */
var saveRequestsDataCreated = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type, request) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'post',
                            url: '/api/v1/mails/requestsData/created/' + type,
                            withCredentials: true,
                            data: request
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function saveRequestsDataCreated(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * @param {'cargo' | 'vessel' | 'tc' | 'sales'} type 
 * @param {{ mailId: string }} request 
 * @returns 
 */
var saveRequestsDataDeleted = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(type, request) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'post',
                            url: '/api/v1/mails/requestsData/deleted/' + type,
                            withCredentials: true,
                            data: request
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function saveRequestsDataDeleted(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(saveRequestsDataCreated, 'saveRequestsDataCreated', '/opt/atlassian/pipelines/agent/build/client/app/services/orders.js');
    reactHotLoader.register(saveRequestsDataDeleted, 'saveRequestsDataDeleted', '/opt/atlassian/pipelines/agent/build/client/app/services/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = postRequestHire;
/* harmony export (immutable) */ __webpack_exports__["b"] = getHiresList;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateHireIdeas;
/* harmony export (immutable) */ __webpack_exports__["a"] = exportHireIdeas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function postRequestHire(hireRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: '/api/v2/adminPanel/hires',
        data: hireRequest,
        params: {
            wrapper: hireRequest.clientVessel ? 'email_wrapper' : undefined
        },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}

function getHiresList(filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v2/adminPanel/hires/search',
        withCredentials: true,
        data: filter
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}

function updateHireIdeas(_ref) {
    var _ref$update = _ref.update,
        update = _ref$update === undefined ? [] : _ref$update,
        _ref$toDelete = _ref.toDelete,
        toDelete = _ref$toDelete === undefined ? [] : _ref$toDelete;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v2/adminPanel/hires/update',
        data: { update: update, toDelete: toDelete },
        withCredentials: true
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response;
    });
}

/**
 * @param {'csv' | 'json'} extention 
 * @param {*} filter
 * @param {Record<string, 1 | -1>} select 
 * 
 */
function exportHireIdeas(extention, filter, select) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'post',
        url: '/api/v2/adminPanel/hires/export?q=' + extention,
        withCredentials: true,
        data: { filter: filter, select: select }
        // responseType: 'blob',
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestHire, 'postRequestHire', '/opt/atlassian/pipelines/agent/build/client/app/services/hires/requests.js');
    reactHotLoader.register(getHiresList, 'getHiresList', '/opt/atlassian/pipelines/agent/build/client/app/services/hires/requests.js');
    reactHotLoader.register(updateHireIdeas, 'updateHireIdeas', '/opt/atlassian/pipelines/agent/build/client/app/services/hires/requests.js');
    reactHotLoader.register(exportHireIdeas, 'exportHireIdeas', '/opt/atlassian/pipelines/agent/build/client/app/services/hires/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return idsConvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return idsEntities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/**
 * 
 * @param {'oid2uuid' | 'uuid2oid'} mode 
 * @param {string} body
 * @returns 
 */
var idsConvert = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(mode, body) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'post',
                            url: '/api/v2/dev-utils/convert-ids?mode=' + mode,
                            headers: {
                                'Content-Type': 'text/plain'
                            },
                            data: body,
                            withCredentials: true
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function idsConvert(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * 
 * @param {string} _id 
 * @returns 
 */
var idsEntities = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_id) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            method: 'post',
                            url: '/api/v2/dev-utils/get-entity',
                            withCredentials: true,
                            data: { _id: _id }
                        }).then(function (response) {
                            return response.data;
                        }).catch(function (response) {
                            return response.response.data;
                        }));

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function idsEntities(_x3) {
        return _ref2.apply(this, arguments);
    };
}();
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(idsConvert, 'idsConvert', '/opt/atlassian/pipelines/agent/build/client/app/services/devUtils.js');
    reactHotLoader.register(idsEntities, 'idsEntities', '/opt/atlassian/pipelines/agent/build/client/app/services/devUtils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getSubscribers */
/* unused harmony export watchGetSubscribers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getSubscribers),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetSubscribers);





function getSubscribers() {
    var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var store, response;
    return regeneratorRuntime.wrap(function getSubscribers$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 2:
                    store = _context.sent;
                    response = {};
                    _context.prev = 4;
                    _context.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getSubscribers, _.merge(store.subscribers, pagination));

                case 7:
                    response = _context.sent;
                    _context.next = 15;
                    break;

                case 10:
                    _context.prev = 10;
                    _context.t0 = _context['catch'](4);
                    _context.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].FAILURE
                    });

                case 14:
                    return _context.abrupt('return', response.data);

                case 15:
                    if (!(response.status === 200)) {
                        _context.next = 19;
                        break;
                    }

                    _context.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].SUCCESS,
                        data: response.data
                    });

                case 18:
                    return _context.abrupt('return', response);

                case 19:
                    _context.next = 21;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].FAILURE,
                        message: response.errors[0].messages[0]
                    });

                case 21:
                    return _context.abrupt('return', response);

                case 22:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[4, 10]]);
}

function watchGetSubscribers() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchGetSubscribers$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getSubscribers, data);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetSubscribers];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getSubscribers, 'getSubscribers', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/subscribers.js');
    reactHotLoader.register(watchGetSubscribers, 'watchGetSubscribers', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/subscribers.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/users/subscribers.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetCargoAssigners */
/* unused harmony export watchGetCargoAssignersPost */
/* unused harmony export watchUpdateCargoAssigner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCargoAssigners),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCargoAssigners),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getCargoAssignersPost),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCargoAssignersPost),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(updateCargoAssigner),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateCargoAssigner);





/**
 * Get cargo assigners
 * */
function getCargoAssigners() {
    var response;
    return regeneratorRuntime.wrap(function getCargoAssigners$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoAssigners);

                case 2:
                    response = _context.sent;

                    if (response) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].FAILURE,
                        errors: [{ field: 'Could not load cargoAssigners' }]
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    if (!(response && response.status === 200)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].SUCCESS,
                        data: response.data
                    });

                case 10:
                    return _context.abrupt('return', response);

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetCargoAssigners() {
    return regeneratorRuntime.wrap(function watchGetCargoAssigners$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoAssigners);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get cargo assigners post request
 * */
function getCargoAssignersPost(realCargoIds) {
    var response;
    return regeneratorRuntime.wrap(function getCargoAssignersPost$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoAssignersPost, realCargoIds);

                case 2:
                    response = _context3.sent;

                    if (response) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].FAILURE,
                        errors: [{ field: 'Could not load cargoAssigners' }]
                    });

                case 6:
                    return _context3.abrupt('return');

                case 7:
                    if (!(response && response.status === 200)) {
                        _context3.next = 11;
                        break;
                    }

                    _context3.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].SUCCESS,
                        data: response.data
                    });

                case 10:
                    return _context3.abrupt('return', response);

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetCargoAssignersPost() {
    var _ref, realCargoIds;

    return regeneratorRuntime.wrap(function watchGetCargoAssignersPost$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    realCargoIds = _ref.realCargoIds;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoAssignersPost, realCargoIds);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Update cargo assigner
 * */
function updateCargoAssigner(item) {
    var response;
    return regeneratorRuntime.wrap(function updateCargoAssigner$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateCargoAssigner, item);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_123" /* UPDATE_CARGO_ASSIGNER */].SUCCESS,
                        item: response.data
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.value + ' updated',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return');

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_123" /* UPDATE_CARGO_ASSIGNER */].FAILURE,
                        item: item,
                        errors: response.errors
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors ? response.errors[0].messages[0] : 'Something went wrong',
                            level: 'error',
                            _id: item,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchUpdateCargoAssigner() {
    var _ref2, item;

    return regeneratorRuntime.wrap(function watchUpdateCargoAssigner$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_123" /* UPDATE_CARGO_ASSIGNER */].REQUEST);

                case 3:
                    _ref2 = _context6.sent;
                    item = _ref2.item;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateCargoAssigner, item);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

var _default = [watchGetCargoAssigners, watchUpdateCargoAssigner, watchGetCargoAssignersPost];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoAssigners, 'getCargoAssigners', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/assigners.js');
    reactHotLoader.register(watchGetCargoAssigners, 'watchGetCargoAssigners', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/assigners.js');
    reactHotLoader.register(getCargoAssignersPost, 'getCargoAssignersPost', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/assigners.js');
    reactHotLoader.register(watchGetCargoAssignersPost, 'watchGetCargoAssignersPost', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/assigners.js');
    reactHotLoader.register(updateCargoAssigner, 'updateCargoAssigner', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/assigners.js');
    reactHotLoader.register(watchUpdateCargoAssigner, 'watchUpdateCargoAssigner', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/assigners.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/assigners.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetCargoGazetters */
/* unused harmony export watchDeleteCargoGazetter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCargoGazetters),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCargoGazetters),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(deleteCargoGazetter),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteCargoGazetter);





/**
 * Get cargo assigners
 * */
function getCargoGazetters(opts) {
    var response;
    return regeneratorRuntime.wrap(function getCargoGazetters$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoGazetters, opts);

                case 2:
                    response = _context.sent;

                    if (response) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].FAILURE,
                        errors: [{ field: 'Could not load cargo gazetters' }]
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    if (!(response && (!response.errors || !response.errors.length))) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].SUCCESS,
                        data: response.data
                    });

                case 10:
                    return _context.abrupt('return', response);

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetCargoGazetters() {
    var _ref, opts;

    return regeneratorRuntime.wrap(function watchGetCargoGazetters$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    opts = _ref.opts;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoGazetters, opts);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Delete cargo gazetter
 * */
function deleteCargoGazetter(item) {
    var response;
    return regeneratorRuntime.wrap(function deleteCargoGazetter$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteCargoGazetter, item);

                case 2:
                    response = _context3.sent;

                    if (!(response && !response.errors.length)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["M" /* DELETE_CARGO_GAZETTER */].SUCCESS,
                        item: item
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Deleted',
                            level: 'success',
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context3.abrupt('return');

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["M" /* DELETE_CARGO_GAZETTER */].FAILURE,
                        item: item,
                        error: response.errors
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: item._id,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchDeleteCargoGazetter() {
    var _ref2, item;

    return regeneratorRuntime.wrap(function watchDeleteCargoGazetter$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["M" /* DELETE_CARGO_GAZETTER */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    item = _ref2.item;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteCargoGazetter, item);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

var _default = [watchGetCargoGazetters, watchDeleteCargoGazetter];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoGazetters, 'getCargoGazetters', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/gazetters.js');
    reactHotLoader.register(watchGetCargoGazetters, 'watchGetCargoGazetters', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/gazetters.js');
    reactHotLoader.register(deleteCargoGazetter, 'deleteCargoGazetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/gazetters.js');
    reactHotLoader.register(watchDeleteCargoGazetter, 'watchDeleteCargoGazetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/gazetters.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/gazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetCargoTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCargoTypes),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCargoTypes);





/**
 * Get cargo types
 * */
function getCargoTypes() {
    var response;
    return regeneratorRuntime.wrap(function getCargoTypes$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoTypes);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_20" /* GET_CARGO_TYPES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_20" /* GET_CARGO_TYPES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetCargoTypes() {
    return regeneratorRuntime.wrap(function watchGetCargoTypes$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_20" /* GET_CARGO_TYPES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoTypes);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetCargoTypes];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoTypes, 'getCargoTypes', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/types.js');
    reactHotLoader.register(watchGetCargoTypes, 'watchGetCargoTypes', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/types.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/types.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetCargoDuplicates */
/* unused harmony export watchDeleteCargoDuplicate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCargoDuplicates),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCargoDuplicates),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(deleteCargoDuplicate),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteCargoDuplicate);





/**
 * Get duplicates cargo names
 * */
function getCargoDuplicates() {
    var response;
    return regeneratorRuntime.wrap(function getCargoDuplicates$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoDuplicates);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_13" /* GET_CARGO_DUPLICATES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_13" /* GET_CARGO_DUPLICATES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetCargoDuplicates() {
    return regeneratorRuntime.wrap(function watchGetCargoDuplicates$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_13" /* GET_CARGO_DUPLICATES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoDuplicates);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Delete cargo by id
 * */
function deleteCargoDuplicate(item) {
    var response;
    return regeneratorRuntime.wrap(function deleteCargoDuplicate$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteCargoDuplicate, item);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["L" /* DELETE_CARGO_DUPLICATE */].SUCCESS,
                        item: item
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context3.abrupt('return');

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["L" /* DELETE_CARGO_DUPLICATE */].FAILURE,
                        item: item,
                        errors: response.errors
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchDeleteCargoDuplicate() {
    var _ref, item;

    return regeneratorRuntime.wrap(function watchDeleteCargoDuplicate$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["L" /* DELETE_CARGO_DUPLICATE */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    item = _ref.item;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteCargoDuplicate, item);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

var _default = [watchGetCargoDuplicates, watchDeleteCargoDuplicate];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoDuplicates, 'getCargoDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/duplicates.js');
    reactHotLoader.register(watchGetCargoDuplicates, 'watchGetCargoDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/duplicates.js');
    reactHotLoader.register(deleteCargoDuplicate, 'deleteCargoDuplicate', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/duplicates.js');
    reactHotLoader.register(watchDeleteCargoDuplicate, 'watchDeleteCargoDuplicate', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/duplicates.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/duplicates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetLoadingAndDischarging */
/* unused harmony export watchUpdateLoadingAndDischarging */
/* unused harmony export watchDeleteLoadingAndDischarging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_cargoes_ldRates__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getLoadingAndDischarging),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetLoadingAndDischarging),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updateLoadingAndDischarging),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateLoadingAndDischarging),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteLoadingAndDischarging),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteLoadingAndDischarging);






/**
 * Get Loading And Discharging
 * */
function getLoadingAndDischarging() {
    var response;
    return regeneratorRuntime.wrap(function getLoadingAndDischarging$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getLoadingAndDischarging);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_34" /* GET_LOADING_AND_DISCHARGING */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_34" /* GET_LOADING_AND_DISCHARGING */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetLoadingAndDischarging() {
    return regeneratorRuntime.wrap(function watchGetLoadingAndDischarging$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_34" /* GET_LOADING_AND_DISCHARGING */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getLoadingAndDischarging);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Update Loading And Discharging
 * */
function updateLoadingAndDischarging(item) {
    var response;
    return regeneratorRuntime.wrap(function updateLoadingAndDischarging$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].updateLoadingAndDischarging, item);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_131" /* UPDATE_LOADING_AND_DISCHARGING */].SUCCESS,
                        item: item
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context3.abrupt('return');

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_131" /* UPDATE_LOADING_AND_DISCHARGING */].FAILURE,
                        errors: response.errors,
                        item: item
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: response.item._id,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchUpdateLoadingAndDischarging() {
    var _ref, item;

    return regeneratorRuntime.wrap(function watchUpdateLoadingAndDischarging$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_131" /* UPDATE_LOADING_AND_DISCHARGING */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    item = _ref.item;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateLoadingAndDischarging, item);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Delete Loading And Discharging
 * */
function deleteLoadingAndDischarging(item) {
    var response;
    return regeneratorRuntime.wrap(function deleteLoadingAndDischarging$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].deleteLoadingAndDischarging, item);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["T" /* DELETE_LOADING_AND_DISCHARGING */].SUCCESS,
                        item: item
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return');

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["T" /* DELETE_LOADING_AND_DISCHARGING */].FAILURE,
                        item: item,
                        errors: response.errors
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: response.item._id,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchDeleteLoadingAndDischarging() {
    var _ref2, _item;

    return regeneratorRuntime.wrap(function watchDeleteLoadingAndDischarging$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["T" /* DELETE_LOADING_AND_DISCHARGING */].REQUEST);

                case 3:
                    _ref2 = _context6.sent;
                    _item = _ref2.item;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteLoadingAndDischarging, _item);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

var _default = [watchGetLoadingAndDischarging, watchUpdateLoadingAndDischarging, watchDeleteLoadingAndDischarging];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getLoadingAndDischarging, 'getLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ldRates.js');
    reactHotLoader.register(watchGetLoadingAndDischarging, 'watchGetLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ldRates.js');
    reactHotLoader.register(updateLoadingAndDischarging, 'updateLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ldRates.js');
    reactHotLoader.register(watchUpdateLoadingAndDischarging, 'watchUpdateLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ldRates.js');
    reactHotLoader.register(deleteLoadingAndDischarging, 'deleteLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ldRates.js');
    reactHotLoader.register(watchDeleteLoadingAndDischarging, 'watchDeleteLoadingAndDischarging', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ldRates.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ldRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetCargoRealNames */
/* unused harmony export watchUpdateCargoRealName */
/* unused harmony export watchDeleteCargoRealName */
/* unused harmony export watchGetCargoRealNamesPaginated */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCargoRealNames),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCargoRealNames),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updateCargoRealName),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateCargoRealName),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteCargoRealName),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteCargoRealName),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(getCargoRealNamesPaginated),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCargoRealNamesPaginated);





/**
 * Delete cargo name
 * */
function getCargoRealNames() {
    var response;
    return regeneratorRuntime.wrap(function getCargoRealNames$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoRealNames);

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_16" /* GET_CARGO_REAL_NAMES */].SUCCESS,
                        data: response.data
                    });

                case 7:
                    return _context.abrupt('return');

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_16" /* GET_CARGO_REAL_NAMES */].FAILURE,
                        errors: response.errors
                    });

                case 10:
                    _context.next = 16;
                    break;

                case 12:
                    _context.prev = 12;
                    _context.t0 = _context['catch'](0);
                    _context.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 16:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 12]]);
}

function watchGetCargoRealNames() {
    return regeneratorRuntime.wrap(function watchGetCargoRealNames$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_16" /* GET_CARGO_REAL_NAMES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoRealNames);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Delete cargo name
 * */
function updateCargoRealName(item) {
    var response;
    return regeneratorRuntime.wrap(function updateCargoRealName$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateCargoRealName, item);

                case 3:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 10;
                        break;
                    }

                    _context3.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_126" /* UPDATE_CARGO_REAL_NAME */].SUCCESS,
                        item: item
                    });

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: item.name + ' updated',
                            level: 'success',
                            _id: item._id,
                            autoDismiss: 2
                        }
                    });

                case 9:
                    return _context3.abrupt('return');

                case 10:
                    _context3.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_126" /* UPDATE_CARGO_REAL_NAME */].FAILURE,
                        item: item,
                        error: response.errors
                    });

                case 12:
                    _context3.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: item._id,
                            autoDismiss: 2
                        }
                    });

                case 14:
                    _context3.next = 19;
                    break;

                case 16:
                    _context3.prev = 16;
                    _context3.t0 = _context3['catch'](0);

                    console.error(_context3.t0);

                case 19:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 16]]);
}

function watchUpdateCargoRealName() {
    var _ref, item;

    return regeneratorRuntime.wrap(function watchUpdateCargoRealName$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_126" /* UPDATE_CARGO_REAL_NAME */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    item = _ref.item;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateCargoRealName, item);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Delete cargo name
 * */
function deleteCargoRealName(item) {
    var response;
    return regeneratorRuntime.wrap(function deleteCargoRealName$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteCargoRealName, item);

                case 2:
                    response = _context5.sent;

                    if (!(response.data.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["N" /* DELETE_CARGO_REAL_NAME */].SUCCESS,
                        item: item
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: item.name + ' deleted',
                            level: 'success',
                            _id: item._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return');

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["N" /* DELETE_CARGO_REAL_NAME */].FAILURE,
                        item: item,
                        error: response.errors
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: item._id,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchDeleteCargoRealName() {
    var _ref2, _item;

    return regeneratorRuntime.wrap(function watchDeleteCargoRealName$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["N" /* DELETE_CARGO_REAL_NAME */].REQUEST);

                case 3:
                    _ref2 = _context6.sent;
                    _item = _ref2.item;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteCargoRealName, _item);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getCargoRealNamesPaginated(opts) {
    var response;
    return regeneratorRuntime.wrap(function getCargoRealNamesPaginated$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.prev = 0;
                    _context7.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoRealNamesPaginated, opts);

                case 3:
                    response = _context7.sent;

                    if (!(response && (!response.errors || !response.errors.length))) {
                        _context7.next = 8;
                        break;
                    }

                    _context7.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_17" /* GET_CARGO_REAL_NAMES_PAGINATED */].SUCCESS,
                        data: response.data
                    });

                case 7:
                    return _context7.abrupt('return');

                case 8:
                    _context7.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_17" /* GET_CARGO_REAL_NAMES_PAGINATED */].FAILURE,
                        errors: response.errors
                    });

                case 10:
                    _context7.next = 16;
                    break;

                case 12:
                    _context7.prev = 12;
                    _context7.t0 = _context7['catch'](0);
                    _context7.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 16:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this, [[0, 12]]);
}

function watchGetCargoRealNamesPaginated() {
    var _ref3, opts;

    return regeneratorRuntime.wrap(function watchGetCargoRealNamesPaginated$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 9;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_17" /* GET_CARGO_REAL_NAMES_PAGINATED */].REQUEST);

                case 3:
                    _ref3 = _context8.sent;
                    opts = _ref3.opts;
                    _context8.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoRealNamesPaginated, opts);

                case 7:
                    _context8.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

var _default = [watchUpdateCargoRealName, watchGetCargoRealNames, watchDeleteCargoRealName, watchGetCargoRealNamesPaginated];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoRealNames, 'getCargoRealNames', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(watchGetCargoRealNames, 'watchGetCargoRealNames', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(updateCargoRealName, 'updateCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(watchUpdateCargoRealName, 'watchUpdateCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(deleteCargoRealName, 'deleteCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(watchDeleteCargoRealName, 'watchDeleteCargoRealName', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(getCargoRealNamesPaginated, 'getCargoRealNamesPaginated', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(watchGetCargoRealNamesPaginated, 'watchGetCargoRealNamesPaginated', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/realNames.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getCargoesByTypeName */
/* unused harmony export watchgetCargoesByTypeName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCargoesByTypeName),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchgetCargoesByTypeName);





function getCargoesByTypeName(_ref) {
    var _ref$name = _ref.name,
        name = _ref$name === undefined ? undefined : _ref$name,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? undefined : _ref$type;
    var response;
    return regeneratorRuntime.wrap(function getCargoesByTypeName$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoByNameOrType, { name: name, type: type });

                case 3:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_10" /* GET_CARGOES_BY_TYPE_NAME */].SUCCESS,
                        data: response.data
                    });

                case 7:
                    return _context.abrupt('return');

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_10" /* GET_CARGOES_BY_TYPE_NAME */].FAILURE,
                        errors: response.errors
                    });

                case 10:
                    _context.next = 16;
                    break;

                case 12:
                    _context.prev = 12;
                    _context.t0 = _context['catch'](0);
                    _context.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 16:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 12]]);
}

function watchgetCargoesByTypeName() {
    var _ref2, filter;

    return regeneratorRuntime.wrap(function watchgetCargoesByTypeName$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_10" /* GET_CARGOES_BY_TYPE_NAME */].REQUEST);

                case 3:
                    _ref2 = _context2.sent;
                    filter = _ref2.filter;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoesByTypeName, filter);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchgetCargoesByTypeName];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoesByTypeName, 'getCargoesByTypeName', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/names.js');
    reactHotLoader.register(watchgetCargoesByTypeName, 'watchgetCargoesByTypeName', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/names.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/names.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetTermEntities */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getTermEntities),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetTermEntities);





/**
 * get term enteties
 * */
function getTermEntities() {
    var response;
    return regeneratorRuntime.wrap(function getTermEntities$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getTermEntities);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetTermEntities() {
    return regeneratorRuntime.wrap(function watchGetTermEntities$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getTermEntities);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetTermEntities];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getTermEntities, 'getTermEntities', '/opt/atlassian/pipelines/agent/build/client/app/sagas/termEntities.js');
    reactHotLoader.register(watchGetTermEntities, 'watchGetTermEntities', '/opt/atlassian/pipelines/agent/build/client/app/sagas/termEntities.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/termEntities.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createCargoOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mocks_cargo_order_json__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mocks_cargo_order_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mocks_cargo_order_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fillCargoType),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(createCargoesWithRanges),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(fillPorts),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createOrders),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fillAndCreateCargoOrders),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(createCargoOrders);









function fillCargoType(clarified) {
    var responseCargoTypes, foundedType;
    return regeneratorRuntime.wrap(function fillCargoType$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!clarified.cargo[0].cargoType) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getCargoTypes);

                case 3:
                    responseCargoTypes = _context.sent;


                    responseCargoTypes.data.push({
                        _id: '59970a4513d689b67b8bf20d',
                        name: 'Other'
                    });

                    foundedType = responseCargoTypes.data.find(function (cargoType) {
                        return cargoType._id === clarified.cargo[0].cargoType;
                    });


                    if (foundedType) {
                        clarified.cargo[0].cargoTypeName = foundedType.name;
                    }

                case 7:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function createCargoesWithRanges(clarified) {
    var cargoes, countOfCargoes, newCargo, i, packing;
    return regeneratorRuntime.wrap(function createCargoesWithRanges$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    cargoes = [];
                    countOfCargoes = 1;
                    newCargo = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(clarified.cargo[0]);


                    if (newCargo.packing.pack.unitsVolume[1].value > 0 || newCargo.packing.pack.unitsWeight[1].value > 0) {
                        countOfCargoes = 2;
                    }

                    for (i = 0; i < countOfCargoes; i++) {
                        packing = {
                            pack: {
                                unitsVolume: [{
                                    value: newCargo.packing.pack.unitsVolume[i].value,
                                    unit: newCargo.packing.pack.unitsVolume[i].unit
                                }],
                                unitsWeight: [{
                                    value: newCargo.packing.pack.unitsWeight[i].value,
                                    unit: newCargo.packing.pack.unitsWeight[i].unit
                                }]
                            }
                        };


                        cargoes.push(_extends({}, newCargo, {
                            sf: newCargo.packing.pack.sf,
                            packing: _extends({}, packing)
                        }));
                    }

                    clarified.cargo = cargoes;

                case 6:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function fillPorts(clarified) {
    var _ref, data, _ref2, _data;

    return regeneratorRuntime.wrap(function fillPorts$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (!clarified.loadingPort) {
                        _context3.next = 6;
                        break;
                    }

                    _context3.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getPort, { id: clarified.loadingPort });

                case 3:
                    _ref = _context3.sent;
                    data = _ref.data;

                    clarified.loadingPortName = data.name;

                case 6:
                    if (!clarified.unloadingPort) {
                        _context3.next = 12;
                        break;
                    }

                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getPort, { id: clarified.unloadingPort });

                case 9:
                    _ref2 = _context3.sent;
                    _data = _ref2.data;

                    clarified.unloadingPortName = _data.name;

                case 12:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function createOrders(clarified) {
    var newClarified;
    return regeneratorRuntime.wrap(function createOrders$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    newClarified = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(clarified);
                    return _context4.abrupt('return', newClarified.cargo.map(function (cargo) {
                        var loadingPorts = [];
                        var unloadingPorts = [];

                        newClarified.cargo = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge({}, __WEBPACK_IMPORTED_MODULE_5_mocks_cargo_order_json___default.a.cargo, cargo);

                        if (newClarified.loadingPort) {
                            var cancellingDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(newClarified.cancellingDate).utc().startOf('day').toDate();
                            var readinessDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(newClarified.readinessDate).utc().startOf('day').toDate();
                            var currentDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().utc().startOf('day').toDate();

                            loadingPorts.push({
                                namePort: newClarified.loadingPortName,
                                idPort: newClarified.loadingPort,
                                cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                                readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                                loadingPortDetails: '',
                                cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                                readinessDateOld: readinessDate < currentDate ? readinessDate : '' // The field helps show message that date too old
                            });

                            unloadingPorts.push({
                                namePort: newClarified.unloadingPortName,
                                idPort: newClarified.unloadingPort,
                                unloadingPortDetails: ''
                            });
                        }

                        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge({}, __WEBPACK_IMPORTED_MODULE_5_mocks_cargo_order_json___default.a, newClarified, {
                            loadingPorts: loadingPorts,
                            unloadingPorts: unloadingPorts
                        });
                    }));

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Fill data from server
 * */
function fillAndCreateCargoOrders(clarified) {
    var newClarified;
    return regeneratorRuntime.wrap(function fillAndCreateCargoOrders$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    newClarified = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(clarified);
                    _context5.next = 3;
                    return fillCargoType(newClarified);

                case 3:
                    _context5.next = 5;
                    return createCargoesWithRanges(newClarified);

                case 5:
                    _context5.next = 7;
                    return fillPorts(newClarified);

                case 7:
                    _context5.next = 9;
                    return createOrders(newClarified);

                case 9:
                    return _context5.abrupt('return', _context5.sent);

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function createCargoOrders(response) {
    var cargoOrders, key;
    return regeneratorRuntime.wrap(function createCargoOrders$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    cargoOrders = [];

                    if (!(response.status === 200)) {
                        _context6.next = 34;
                        break;
                    }

                    if (!(response.data.clarified && response.data.clarified.length > 0)) {
                        _context6.next = 28;
                        break;
                    }

                    key = 0;

                case 4:
                    if (!(key < response.data.clarified.length)) {
                        _context6.next = 21;
                        break;
                    }

                    _context6.prev = 5;
                    _context6.t0 = cargoOrders;
                    _context6.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(fillAndCreateCargoOrders, response.data.clarified[key]);

                case 9:
                    _context6.t1 = _context6.sent;

                    _context6.t0.push.call(_context6.t0, _context6.t1);

                    _context6.next = 18;
                    break;

                case 13:
                    _context6.prev = 13;
                    _context6.t2 = _context6['catch'](5);
                    _context6.next = 17;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 17:

                    console.error(_context6.t2);

                case 18:
                    key++;
                    _context6.next = 4;
                    break;

                case 21:
                    // todo change structure of array

                    cargoOrders = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatten(cargoOrders);

                    _context6.next = 24;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Created',
                            message: 'The ' + cargoOrders.length + ' cargo orders created',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 24:
                    _context6.next = 26;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["b" /* createCargoOrders */](cargoOrders));

                case 26:
                    _context6.next = 32;
                    break;

                case 28:
                    _context6.next = 30;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["e" /* resetCargoOrders */]());

                case 30:
                    _context6.next = 32;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The cargo orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 32:
                    _context6.next = 38;
                    break;

                case 34:
                    _context6.next = 36;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["e" /* resetCargoOrders */]());

                case 36:
                    _context6.next = 38;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The cargo orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 38:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this, [[5, 13]]);
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fillCargoType, 'fillCargoType', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/orders.js');
    reactHotLoader.register(createCargoesWithRanges, 'createCargoesWithRanges', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/orders.js');
    reactHotLoader.register(fillPorts, 'fillPorts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/orders.js');
    reactHotLoader.register(createOrders, 'createOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/orders.js');
    reactHotLoader.register(fillAndCreateCargoOrders, 'fillAndCreateCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/orders.js');
    reactHotLoader.register(createCargoOrders, 'createCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports = {"comm":"","terms":{"user":[]},"loadingPortDetails":"","unloadingPortDetails":"","ldRates":{"discharging":{"quantity":0,"dimension":"","speed":"","abbreviation":"","term":"","cqd":false},"loading":{"quantity":0,"dimension":"","speed":"","abbreviation":"","term":"","cqd":false}},"cargo":{"cargoName":"","details":0,"cargoTypeName":"","cargoType":"","sf":"","dangerous":{"class":[0],"unNumber":""},"packing":{"category":"unpacked","pack":{"name":"","unitsWeight":[{"value":0,"unit":"mt","deviation":0,"term":"molchopt"}],"unitsVolume":[{"value":0,"unit":"cbm","deviation":0,"term":"molchopt"}]}},"customerId":null,"hsCodeId":null,"additionalCargoDetails":null},"contract":"","cancellingDate":"","readinessDate":"","unloadingPort":"","loadingPort":"","validateErrors":[],"loadingPortName":"","unloadingPortName":"","loadingPorts":[{"namePort":"","idPort":"","cancellingDate":"","readinessDate":""}],"unloadingPorts":[{"namePort":"","idPort":""}],"user":""}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-au": 681,
	"./en-au.js": 681,
	"./en-ca": 682,
	"./en-ca.js": 682,
	"./en-gb": 683,
	"./en-gb.js": 683,
	"./en-ie": 684,
	"./en-ie.js": 684,
	"./en-nz": 685,
	"./en-nz.js": 685
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1446;

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchPostRequestCargo */
/* unused harmony export watchGetRequestsCargo */
/* unused harmony export watchUpdateRequestsCargo */
/* unused harmony export watchDeleteRequestsCargo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__refNumber__ = __webpack_require__(225);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(postRequestCargo),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchPostRequestCargo),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getRequestsCargo),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetRequestsCargo),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(updateRequestsCargo),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateRequestsCargo),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(deleteRequestsCargo),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteRequestsCargo);






function postRequestCargo(cargoRequest) {
    var response;
    return regeneratorRuntime.wrap(function postRequestCargo$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].postRequestCargo, cargoRequest);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].SUCCESS,
                        data: response.data,
                        cargoRequest: cargoRequest
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success cargo request - ' + (cargoRequest.keyCargoOrder + 1),
                            message: '' + (response.data.message || 'Found duplicate cargo.'),
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__refNumber__["a" /* refNumber */], response.data);

                case 10:
                    return _context.abrupt('return', response);

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error cargo request - ' + (cargoRequest.keyCargoOrder + 1),
                            message: response.errors[0].message || response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 13:
                    _context.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].FAILURE,
                        errors: response.errors,
                        cargoRequest: cargoRequest
                    });

                case 15:
                    return _context.abrupt('return', response);

                case 16:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchPostRequestCargo() {
    var _ref, cargoRequest;

    return regeneratorRuntime.wrap(function watchPostRequestCargo$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    cargoRequest = _ref.cargoRequest;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(postRequestCargo, cargoRequest);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 *
 * */
function getRequestsCargo(filter) {
    var response;
    return regeneratorRuntime.wrap(function getRequestsCargo$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCargoMonitor, filter);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_18" /* GET_CARGO_REQUESTS */].SUCCESS,
                        data: response
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_18" /* GET_CARGO_REQUESTS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetRequestsCargo() {
    var _ref2, filter;

    return regeneratorRuntime.wrap(function watchGetRequestsCargo$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_18" /* GET_CARGO_REQUESTS */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    filter = _ref2.filter;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getRequestsCargo, filter);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function updateRequestsCargo(cargoRequestId, userId) {
    var response;
    return regeneratorRuntime.wrap(function updateRequestsCargo$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].changeUserCargoRequest, cargoRequestId, userId);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_127" /* UPDATE_CARGO_REQUEST */].SUCCESS,
                        cargoRequestId: cargoRequestId,
                        userId: userId
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: cargoRequestId,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return');

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_127" /* UPDATE_CARGO_REQUEST */].FAILURE,
                        errors: response.errors,
                        cargoRequestId: cargoRequestId,
                        userId: userId
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: cargoRequestId,
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchUpdateRequestsCargo() {
    var _ref3, cargoRequestId, userId;

    return regeneratorRuntime.wrap(function watchUpdateRequestsCargo$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 10;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_127" /* UPDATE_CARGO_REQUEST */].REQUEST);

                case 3:
                    _ref3 = _context6.sent;
                    cargoRequestId = _ref3.cargoRequestId;
                    userId = _ref3.userId;
                    _context6.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateRequestsCargo, cargoRequestId, userId);

                case 8:
                    _context6.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function deleteRequestsCargo(cargoRequestId) {
    var response, store;
    return regeneratorRuntime.wrap(function deleteRequestsCargo$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteCargoRequest, cargoRequestId);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 12;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 6:
                    store = _context7.sent;
                    _context7.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["O" /* DELETE_CARGO_REQUEST */].SUCCESS,
                        cargoRequestId: cargoRequestId,
                        email: store.user.user.email
                    });

                case 9:
                    _context7.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: cargoRequestId,
                            autoDismiss: 2
                        }
                    });

                case 11:
                    return _context7.abrupt('return');

                case 12:
                    _context7.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["O" /* DELETE_CARGO_REQUEST */].FAILURE,
                        cargoRequestId: cargoRequestId,
                        error: response.errors
                    });

                case 14:
                    _context7.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: cargoRequestId,
                            autoDismiss: 2
                        }
                    });

                case 16:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function watchDeleteRequestsCargo() {
    var _ref4, _cargoRequestId;

    return regeneratorRuntime.wrap(function watchDeleteRequestsCargo$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 9;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["O" /* DELETE_CARGO_REQUEST */].REQUEST);

                case 3:
                    _ref4 = _context8.sent;
                    _cargoRequestId = _ref4.cargoRequestId;
                    _context8.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteRequestsCargo, _cargoRequestId);

                case 7:
                    _context8.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

var _default = [watchPostRequestCargo, watchGetRequestsCargo, watchUpdateRequestsCargo, watchDeleteRequestsCargo];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestCargo, 'postRequestCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(watchPostRequestCargo, 'watchPostRequestCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(getRequestsCargo, 'getRequestsCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(watchGetRequestsCargo, 'watchGetRequestsCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(updateRequestsCargo, 'updateRequestsCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(watchUpdateRequestsCargo, 'watchUpdateRequestsCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(deleteRequestsCargo, 'deleteRequestsCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(watchDeleteRequestsCargo, 'watchDeleteRequestsCargo', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchPostRequestVessel */
/* unused harmony export watchGetRequestsVessel */
/* unused harmony export watchUpdateRequestsVessel */
/* unused harmony export watchDeleteRequestsVessel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__refNumber__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(postRequestVessel),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchPostRequestVessel),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getRequestsVessel),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetRequestsVessel),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(updateRequestsVessel),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateRequestsVessel),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(deleteRequestsVessel),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteRequestsVessel);







function postRequestVessel(vesselRequest) {
    var response;
    return regeneratorRuntime.wrap(function postRequestVessel$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].postRequestVessel, vesselRequest);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 13;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].SUCCESS,
                        data: response.data,
                        vesselRequest: vesselRequest
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success vessel request - ' + (vesselRequest.keyVesselOrder + 1),
                            message: '' + response.data.message,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__refNumber__["a" /* refNumber */], response.data);

                case 10:
                    return _context.abrupt('return', response);

                case 13:
                    if (!(response.status === 409)) {
                        _context.next = 21;
                        break;
                    }

                    _context.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Vessel request prolonged',
                            message: '' + response.errors[0].messages[1].refNo,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 16:
                    _context.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].SUCCESS,
                        data: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[1]'),
                        vesselRequest: vesselRequest
                    });

                case 18:
                    _context.next = 20;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__refNumber__["a" /* refNumber */], { refNo: response.errors[0].messages[1].refNo });

                case 20:
                    return _context.abrupt('return', response);

                case 21:
                    _context.next = 23;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error vessel request - ' + (vesselRequest.keyVesselOrder + 1),
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 23:
                    _context.next = 25;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].FAILURE,
                        errors: response.errors,
                        vesselRequest: vesselRequest
                    });

                case 25:
                    return _context.abrupt('return', response);

                case 26:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchPostRequestVessel() {
    var _ref, vesselRequest;

    return regeneratorRuntime.wrap(function watchPostRequestVessel$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    vesselRequest = _ref.vesselRequest;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(postRequestVessel, vesselRequest);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}
/**
 *
 * */
function getRequestsVessel(filter) {
    var response;
    return regeneratorRuntime.wrap(function getRequestsVessel$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getVesselMonitor, filter);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_61" /* GET_VESSEL_REQUESTS */].SUCCESS,
                        data: response
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_61" /* GET_VESSEL_REQUESTS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetRequestsVessel() {
    var _ref2, filter;

    return regeneratorRuntime.wrap(function watchGetRequestsVessel$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_61" /* GET_VESSEL_REQUESTS */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    filter = _ref2.filter;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getRequestsVessel, filter);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function updateRequestsVessel(vesselRequestId, userId) {
    var response;
    return regeneratorRuntime.wrap(function updateRequestsVessel$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].changeUserVesselRequest, vesselRequestId, userId);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_145" /* UPDATE_VESSEL_REQUEST */].SUCCESS,
                        vesselRequestId: vesselRequestId,
                        userId: userId
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: vesselRequestId,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return', response);

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_145" /* UPDATE_VESSEL_REQUEST */].FAILURE,
                        errors: response.errors,
                        vesselRequestId: vesselRequestId,
                        userId: userId
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: vesselRequestId,
                            autoDismiss: 2
                        }
                    });

                case 13:
                    return _context5.abrupt('return', response);

                case 14:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchUpdateRequestsVessel() {
    var _ref3, vesselRequestId, userId;

    return regeneratorRuntime.wrap(function watchUpdateRequestsVessel$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 10;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_145" /* UPDATE_VESSEL_REQUEST */].REQUEST);

                case 3:
                    _ref3 = _context6.sent;
                    vesselRequestId = _ref3.vesselRequestId;
                    userId = _ref3.userId;
                    _context6.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateRequestsVessel, vesselRequestId, userId);

                case 8:
                    _context6.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function deleteRequestsVessel(vesselId, requestId) {
    var response, store;
    return regeneratorRuntime.wrap(function deleteRequestsVessel$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteVesselRequest, vesselId, requestId);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 12;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 6:
                    store = _context7.sent;
                    _context7.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_0" /* DELETE_VESSEL_REQUEST */].SUCCESS,
                        vesselId: vesselId,
                        email: store.user.user.email
                    });

                case 9:
                    _context7.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: vesselId,
                            autoDismiss: 2
                        }
                    });

                case 11:
                    return _context7.abrupt('return', response);

                case 12:
                    _context7.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_0" /* DELETE_VESSEL_REQUEST */].FAILURE,
                        vesselId: vesselId,
                        error: response.errors
                    });

                case 14:
                    _context7.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: vesselId,
                            autoDismiss: 2
                        }
                    });

                case 16:
                    return _context7.abrupt('return', response);

                case 17:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function watchDeleteRequestsVessel() {
    var _ref4, vesselId, requestId;

    return regeneratorRuntime.wrap(function watchDeleteRequestsVessel$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 10;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_0" /* DELETE_VESSEL_REQUEST */].REQUEST);

                case 3:
                    _ref4 = _context8.sent;
                    vesselId = _ref4.vesselId;
                    requestId = _ref4.requestId;
                    _context8.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteRequestsVessel, vesselId, requestId);

                case 8:
                    _context8.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

var _default = [watchPostRequestVessel, watchDeleteRequestsVessel, watchGetRequestsVessel, watchUpdateRequestsVessel];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestVessel, 'postRequestVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(watchPostRequestVessel, 'watchPostRequestVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(getRequestsVessel, 'getRequestsVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(watchGetRequestsVessel, 'watchGetRequestsVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(updateRequestsVessel, 'updateRequestsVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(watchUpdateRequestsVessel, 'watchUpdateRequestsVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(deleteRequestsVessel, 'deleteRequestsVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(watchDeleteRequestsVessel, 'watchDeleteRequestsVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getMailRecognizeSpamList */
/* unused harmony export watchGetMailRecognizeSpamList */
/* unused harmony export updateMailRecognizeSpamList */
/* unused harmony export watchUpdateMailRecognizeSpamList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getMailRecognizeSpamList),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetMailRecognizeSpamList),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(updateMailRecognizeSpamList),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateMailRecognizeSpamList);





/**
 * Get mail recognize spam
 * */
function getMailRecognizeSpamList() {
    var response;
    return regeneratorRuntime.wrap(function getMailRecognizeSpamList$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getMailRecognizeSpamList);

                case 2:
                    response = _context.sent;

                    if (!response) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Spam list updated',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_35" /* GET_MAIL_RECOGNIZE_SPAM_LIST */].SUCCESS,
                        data: response.data
                    });

                case 8:
                    return _context.abrupt('return', response);

                case 9:
                    _context.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Spam list didn`t update',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_35" /* GET_MAIL_RECOGNIZE_SPAM_LIST */].FAILURE
                    });

                case 13:
                    return _context.abrupt('return', response);

                case 14:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetMailRecognizeSpamList() {
    return regeneratorRuntime.wrap(function watchGetMailRecognizeSpamList$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_35" /* GET_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getMailRecognizeSpamList);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get mail recognize spam
 * */
function updateMailRecognizeSpamList(data) {
    var response;
    return regeneratorRuntime.wrap(function updateMailRecognizeSpamList$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateMailRecognizeSpamList, data);

                case 2:
                    response = _context3.sent;

                    if (!response) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_132" /* UPDATE_MAIL_RECOGNIZE_SPAM_LIST */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_132" /* UPDATE_MAIL_RECOGNIZE_SPAM_LIST */].FAILURE
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchUpdateMailRecognizeSpamList() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchUpdateMailRecognizeSpamList$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_132" /* UPDATE_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    data = _ref.data;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateMailRecognizeSpamList, data);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

var _default = [watchGetMailRecognizeSpamList, watchUpdateMailRecognizeSpamList];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getMailRecognizeSpamList, 'getMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(watchGetMailRecognizeSpamList, 'watchGetMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(updateMailRecognizeSpamList, 'updateMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(watchUpdateMailRecognizeSpamList, 'watchUpdateMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/mailRecognizeSpamList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export createFilterAnnotationsPreference */
/* unused harmony export watchCreateFilterAnnotationsPreference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createFilterAnnotationsPreference),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchCreateFilterAnnotationsPreference);





/**
 * Create preference
 * */
function createFilterAnnotationsPreference(data) {
    var response;
    return regeneratorRuntime.wrap(function createFilterAnnotationsPreference$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].createFilterAnnotationsPreference, data);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["D" /* CREATE_FILTER_ANNOTATIONS_PREFERENCE */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt("return", response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["D" /* CREATE_FILTER_ANNOTATIONS_PREFERENCE */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt("return", response);

                case 10:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchCreateFilterAnnotationsPreference() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchCreateFilterAnnotationsPreference$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["D" /* CREATE_FILTER_ANNOTATIONS_PREFERENCE */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* fork */])(createFilterAnnotationsPreference, data);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchCreateFilterAnnotationsPreference];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(createFilterAnnotationsPreference, "createFilterAnnotationsPreference", "/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/filterAnnotations.js");
    reactHotLoader.register(watchCreateFilterAnnotationsPreference, "watchCreateFilterAnnotationsPreference", "/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/filterAnnotations.js");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/filterAnnotations.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export deletePreference */
/* unused harmony export watchDeletePreference */
/* unused harmony export getPreference */
/* unused harmony export watchGetPreference */
/* unused harmony export getPreferences */
/* unused harmony export watchGetPreferences */
/* unused harmony export updatePreference */
/* unused harmony export watchUpdatePreferences */
/* unused harmony export updatePreferenceMeta */
/* unused harmony export watchUpdatePreferencesMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(deletePreference),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchDeletePreference),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getPreference),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetPreference),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(getPreferences),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchGetPreferences),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(updatePreference),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdatePreferences),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(updatePreferenceMeta),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdatePreferencesMeta);





/**
 * Delete preference
 * */
function deletePreference(data) {
    var response;
    return regeneratorRuntime.wrap(function deletePreference$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deletePreference, data);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Success deleted',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["W" /* DELETE_PREFERENCE */].SUCCESS,
                        data: response.data
                    });

                case 8:
                    return _context.abrupt('return', response);

                case 9:
                    _context.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Error deleted',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["W" /* DELETE_PREFERENCE */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                    return _context.abrupt('return', response);

                case 14:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchDeletePreference() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchDeletePreference$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["W" /* DELETE_PREFERENCE */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deletePreference, data);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get preference
 * */
function getPreference(data) {
    var response;
    return regeneratorRuntime.wrap(function getPreference$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getPreference, data);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_38" /* GET_PREFERENCE */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_38" /* GET_PREFERENCE */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetPreference() {
    var _ref2, _data;

    return regeneratorRuntime.wrap(function watchGetPreference$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_38" /* GET_PREFERENCE */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    _data = _ref2.data;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getPreference, _data);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Get preference
 * */
function getPreferences(data) {
    var response;
    return regeneratorRuntime.wrap(function getPreferences$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getPreferences, data);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 7;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_39" /* GET_PREFERENCES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context5.abrupt('return', response);

                case 7:
                    _context5.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_39" /* GET_PREFERENCES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context5.abrupt('return', response);

                case 10:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchGetPreferences() {
    var _ref3, _data2;

    return regeneratorRuntime.wrap(function watchGetPreferences$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_39" /* GET_PREFERENCES */].REQUEST);

                case 3:
                    _ref3 = _context6.sent;
                    _data2 = _ref3.data;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getPreferences, _data2);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

/**
 * Update preference
 * */
function updatePreference(data, _id) {
    var response;
    return regeneratorRuntime.wrap(function updatePreference$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updatePreference, data, _id);

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 9;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Preference updated',
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 6:
                    _context7.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_136" /* UPDATE_PREFERENCE */].SUCCESS,
                        data: response.data
                    });

                case 8:
                    return _context7.abrupt('return', response);

                case 9:
                    _context7.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Preference didn`t update',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 11:
                    _context7.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_136" /* UPDATE_PREFERENCE */].FAILURE
                    });

                case 13:
                    return _context7.abrupt('return', response);

                case 14:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function watchUpdatePreferences() {
    var _ref4, _data3, _id;

    return regeneratorRuntime.wrap(function watchUpdatePreferences$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 10;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_136" /* UPDATE_PREFERENCE */].REQUEST);

                case 3:
                    _ref4 = _context8.sent;
                    _data3 = _ref4.data;
                    _id = _ref4._id;
                    _context8.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updatePreference, _data3, _id);

                case 8:
                    _context8.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/**
 * Update preference meta
 * */
function updatePreferenceMeta(data) {
    var response;
    return regeneratorRuntime.wrap(function updatePreferenceMeta$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updatePreferenceMeta, data);

                case 2:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 7;
                        break;
                    }

                    _context9.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_137" /* UPDATE_PREFERENCE_META */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context9.abrupt('return', response);

                case 7:
                    _context9.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_137" /* UPDATE_PREFERENCE_META */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context9.abrupt('return', response);

                case 10:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function watchUpdatePreferencesMeta() {
    var _ref5, _data4;

    return regeneratorRuntime.wrap(function watchUpdatePreferencesMeta$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (false) {
                        _context10.next = 9;
                        break;
                    }

                    _context10.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_137" /* UPDATE_PREFERENCE_META */].REQUEST);

                case 3:
                    _ref5 = _context10.sent;
                    _data4 = _ref5.data;
                    _context10.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updatePreferenceMeta, _data4);

                case 7:
                    _context10.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

var _default = [watchDeletePreference, watchGetPreference, watchGetPreferences, watchUpdatePreferences, watchUpdatePreferencesMeta];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(deletePreference, 'deletePreference', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(watchDeletePreference, 'watchDeletePreference', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(getPreference, 'getPreference', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(watchGetPreference, 'watchGetPreference', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(getPreferences, 'getPreferences', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(watchGetPreferences, 'watchGetPreferences', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(updatePreference, 'updatePreference', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(watchUpdatePreferences, 'watchUpdatePreferences', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(updatePreferenceMeta, 'updatePreferenceMeta', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(watchUpdatePreferencesMeta, 'watchUpdatePreferencesMeta', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/preferences/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getVesselClaims */
/* unused harmony export watchGetVesselClaims */
/* unused harmony export rejectUserClaimsToVessel */
/* unused harmony export watchRejectUserClaimsToVessel */
/* unused harmony export acceptUserClaimsToVessel */
/* unused harmony export watchAcceptUserClaimsToVessel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getVesselClaims),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetVesselClaims),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(rejectUserClaimsToVessel),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchRejectUserClaimsToVessel),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(acceptUserClaimsToVessel),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchAcceptUserClaimsToVessel);





/**
 * Get vessel claims
 * */
function getVesselClaims() {
    var response;
    return regeneratorRuntime.wrap(function getVesselClaims$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getVesselClaims);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_59" /* GET_VESSEL_CLAIMS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_59" /* GET_VESSEL_CLAIMS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetVesselClaims() {
    return regeneratorRuntime.wrap(function watchGetVesselClaims$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_59" /* GET_VESSEL_CLAIMS */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getVesselClaims);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Reject vessel claims to user
 * */
function rejectUserClaimsToVessel(userId, vesselId) {
    var response;
    return regeneratorRuntime.wrap(function rejectUserClaimsToVessel$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].rejectUserClaimsToVessel, userId, vesselId);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_75" /* REJECT_USER_CLAIMS_TO_VESSEL */].SUCCESS,
                        userId: userId,
                        vesselId: vesselId
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context3.abrupt('return', response);

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_75" /* REJECT_USER_CLAIMS_TO_VESSEL */].FAILURE,
                        errors: response.errors
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 13:
                    return _context3.abrupt('return', response);

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchRejectUserClaimsToVessel() {
    var _ref, userId, vesselId;

    return regeneratorRuntime.wrap(function watchRejectUserClaimsToVessel$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 10;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_75" /* REJECT_USER_CLAIMS_TO_VESSEL */].REQUEST);

                case 3:
                    _ref = _context4.sent;
                    userId = _ref.userId;
                    vesselId = _ref.vesselId;
                    _context4.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(rejectUserClaimsToVessel, userId, vesselId);

                case 8:
                    _context4.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Accept vessel claims to user
 * */
function acceptUserClaimsToVessel(userId, vesselId) {
    var response;
    return regeneratorRuntime.wrap(function acceptUserClaimsToVessel$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].acceptUserClaimsToVessel, userId, vesselId);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["a" /* ACCEPT_USER_CLAIMS_TO_VESSEL */].SUCCESS,
                        userId: userId,
                        vesselId: vesselId
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return');

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["a" /* ACCEPT_USER_CLAIMS_TO_VESSEL */].FAILURE,
                        errors: response.errors
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchAcceptUserClaimsToVessel() {
    var _ref2, _userId, _vesselId;

    return regeneratorRuntime.wrap(function watchAcceptUserClaimsToVessel$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 10;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["a" /* ACCEPT_USER_CLAIMS_TO_VESSEL */].REQUEST);

                case 3:
                    _ref2 = _context6.sent;
                    _userId = _ref2.userId;
                    _vesselId = _ref2.vesselId;
                    _context6.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(acceptUserClaimsToVessel, _userId, _vesselId);

                case 8:
                    _context6.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

var _default = [watchGetVesselClaims, watchRejectUserClaimsToVessel, watchAcceptUserClaimsToVessel];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVesselClaims, 'getVesselClaims', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/claims.js');
    reactHotLoader.register(watchGetVesselClaims, 'watchGetVesselClaims', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/claims.js');
    reactHotLoader.register(rejectUserClaimsToVessel, 'rejectUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/claims.js');
    reactHotLoader.register(watchRejectUserClaimsToVessel, 'watchRejectUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/claims.js');
    reactHotLoader.register(acceptUserClaimsToVessel, 'acceptUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/claims.js');
    reactHotLoader.register(watchAcceptUserClaimsToVessel, 'watchAcceptUserClaimsToVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/claims.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/claims.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetVessels */
/* unused harmony export watchGetVessel */
/* unused harmony export watchConfirmVessel */
/* unused harmony export watchDeleteNameSuggestion */
/* unused harmony export watchRenameVessel */
/* unused harmony export watchUpdateVessel */
/* unused harmony export watchDeleteVessel */
/* unused harmony export watchAddVessel */
/* unused harmony export watchUpdateVesselImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getVessels),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetVessels),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getVessel),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetVessel),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(confirmVessel),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchConfirmVessel),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(deleteNameSuggestion),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(renameVessel),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(updateVessel),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteNameSuggestion),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(watchRenameVessel),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateVessel),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(deleteVessel),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteVessel),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(addVessel),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(watchAddVessel),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(updateVesselImage),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateVesselImage);






/**
 * Get vessels
 * */
function getVessels(pagination) {
    var store, response;
    return regeneratorRuntime.wrap(function getVessels$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 2:
                    store = _context.sent;
                    _context.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getVessels, _extends({}, store.vessels, pagination));

                case 5:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 10;
                        break;
                    }

                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_58" /* GET_VESSELS */].SUCCESS,
                        data: response
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                    _context.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_58" /* GET_VESSELS */].FAILURE,
                        errors: response.errors
                    });

                case 12:
                    return _context.abrupt('return', response);

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetVessels() {
    var _ref, pagination;

    return regeneratorRuntime.wrap(function watchGetVessels$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_58" /* GET_VESSELS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    pagination = _ref.pagination;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getVessels, pagination);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getVessel(id) {
    var response;
    return regeneratorRuntime.wrap(function getVessel$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getVessel, id);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_57" /* GET_VESSEL */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_57" /* GET_VESSEL */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetVessel() {
    var _ref2, id;

    return regeneratorRuntime.wrap(function watchGetVessel$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_57" /* GET_VESSEL */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    id = _ref2.id;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getVessel, id);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function confirmVessel(id) {
    var response;
    return regeneratorRuntime.wrap(function confirmVessel$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].confirmVessel, id);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["y" /* CONFIRM_VESSEL */].SUCCESS,
                        data: response.data.data
                    });

                case 8:
                    return _context5.abrupt('return', response);

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["y" /* CONFIRM_VESSEL */].FAILURE
                    });

                case 13:
                    return _context5.abrupt('return', response);

                case 14:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchConfirmVessel() {
    var _ref3, _id;

    return regeneratorRuntime.wrap(function watchConfirmVessel$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["y" /* CONFIRM_VESSEL */].REQUEST);

                case 3:
                    _ref3 = _context6.sent;
                    _id = _ref3.id;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(confirmVessel, _id);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function deleteNameSuggestion(_ref4) {
    var vessel = _ref4.vessel,
        refreshVessel = _ref4.refreshVessel,
        suggestedName = _ref4.suggestedName;
    var response;
    return regeneratorRuntime.wrap(function deleteNameSuggestion$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].deleteNameSuggestion, { vessel: vessel, suggestedName: suggestedName });

                case 2:
                    response = _context7.sent;

                    if (!(response.status === 200)) {
                        _context7.next = 10;
                        break;
                    }

                    _context7.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],

                        notification: {
                            title: 'Vessel\'s name suggestion\'s been successfully removed!',

                            message: response.data.message,

                            level: 'success',

                            _id: new Date().getMilliseconds(),

                            autoDismiss: 10
                        }
                    });

                case 6:
                    _context7.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["U" /* DELETE_NAME_SUGGESTION */].SUCCESS,

                        data: vessel
                    });

                case 8:

                    if (typeof refreshVessel === 'function') {
                        refreshVessel();
                    }

                    return _context7.abrupt('return', response);

                case 10:
                    _context7.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],

                        notification: {
                            title: response.errors[0].messages ? response.errors[0].field : 'error',

                            message: response.errors[0].messages ? response.errors[0].messages[0] : response.errors[0].message,

                            level: 'error',

                            _id: new Date().getMilliseconds(),

                            autoDismiss: 10
                        }
                    });

                case 12:
                    _context7.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["U" /* DELETE_NAME_SUGGESTION */].FAILURE,

                        errors: response.errors,

                        vessel: vessel
                    });

                case 14:

                    if (typeof refreshVessel === 'function') {
                        refreshVessel();
                    }

                    return _context7.abrupt('return', response);

                case 16:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function renameVessel(vessel, refreshVessel) {
    var response;
    return regeneratorRuntime.wrap(function renameVessel$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].renameVessel, vessel);

                case 2:
                    response = _context8.sent;

                    if (!(response.status === 200)) {
                        _context8.next = 10;
                        break;
                    }

                    _context8.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],

                        notification: {
                            title: 'Vessel\'s been successfully renamed!',

                            message: response.data.message,

                            level: 'success',

                            _id: new Date().getMilliseconds(),

                            autoDismiss: 10
                        }
                    });

                case 6:
                    _context8.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_90" /* RENAME_VESSEL */].SUCCESS,

                        data: vessel
                    });

                case 8:

                    if (typeof refreshVessel === 'function') {
                        refreshVessel();
                    }

                    return _context8.abrupt('return', response);

                case 10:
                    _context8.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],

                        notification: {
                            title: response.errors[0].messages ? response.errors[0].field : 'error',

                            message: response.errors[0].messages ? response.errors[0].messages[0] : response.errors[0].message,

                            level: 'error',

                            _id: new Date().getMilliseconds(),

                            autoDismiss: 10
                        }
                    });

                case 12:
                    _context8.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_90" /* RENAME_VESSEL */].FAILURE,

                        errors: response.errors,

                        vessel: vessel
                    });

                case 14:

                    if (typeof refreshVessel === 'function') {
                        refreshVessel();
                    }

                    return _context8.abrupt('return', response);

                case 16:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function updateVessel(vessel) {
    var response;
    return regeneratorRuntime.wrap(function updateVessel$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].updateVessel, vessel);

                case 2:
                    response = _context9.sent;

                    if (!(response.status === 200)) {
                        _context9.next = 9;
                        break;
                    }

                    _context9.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 6:
                    _context9.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_141" /* UPDATE_VESSEL */].SUCCESS,
                        data: vessel
                    });

                case 8:
                    return _context9.abrupt('return', response);

                case 9:
                    _context9.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: response.errors[0].messages ? response.errors[0].field : 'error',
                            message: response.errors[0].messages ? response.errors[0].messages[0] : response.errors[0].message,
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 11:
                    _context9.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_141" /* UPDATE_VESSEL */].FAILURE,
                        errors: response.errors,
                        vessel: vessel
                    });

                case 13:
                    return _context9.abrupt('return', response);

                case 14:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function watchDeleteNameSuggestion() {
    var _ref5, vessel, refreshVessel, suggestedName;

    return regeneratorRuntime.wrap(function watchDeleteNameSuggestion$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (false) {
                        _context10.next = 11;
                        break;
                    }

                    _context10.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["U" /* DELETE_NAME_SUGGESTION */].REQUEST);

                case 3:
                    _ref5 = _context10.sent;
                    vessel = _ref5.vessel;
                    refreshVessel = _ref5.refreshVessel;
                    suggestedName = _ref5.suggestedName;
                    _context10.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteNameSuggestion, { vessel: vessel, refreshVessel: refreshVessel, suggestedName: suggestedName });

                case 9:
                    _context10.next = 0;
                    break;

                case 11:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

function watchRenameVessel() {
    var _ref6, _vessel, _refreshVessel;

    return regeneratorRuntime.wrap(function watchRenameVessel$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    if (false) {
                        _context11.next = 10;
                        break;
                    }

                    _context11.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_90" /* RENAME_VESSEL */].REQUEST);

                case 3:
                    _ref6 = _context11.sent;
                    _vessel = _ref6.vessel;
                    _refreshVessel = _ref6.refreshVessel;
                    _context11.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(renameVessel, _vessel, _refreshVessel);

                case 8:
                    _context11.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this);
}

function watchUpdateVessel() {
    var _ref7, _vessel2;

    return regeneratorRuntime.wrap(function watchUpdateVessel$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    if (false) {
                        _context12.next = 9;
                        break;
                    }

                    _context12.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_141" /* UPDATE_VESSEL */].REQUEST);

                case 3:
                    _ref7 = _context12.sent;
                    _vessel2 = _ref7.vessel;
                    _context12.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateVessel, _vessel2);

                case 7:
                    _context12.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

function deleteVessel(vessel) {
    var response;
    return regeneratorRuntime.wrap(function deleteVessel$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    _context13.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].deleteVessel, vessel);

                case 2:
                    response = _context13.sent;

                    if (!(response.status === 200)) {
                        _context13.next = 10;
                        break;
                    }

                    _context13.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.messages,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 6:
                    _context13.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["Z" /* DELETE_VESSEL */].SUCCESS,
                        data: vessel
                    });

                case 8:

                    __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* browserHistory */].push('/vessels/list');

                    return _context13.abrupt('return', response);

                case 10:
                    _context13.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 12:
                    _context13.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["Z" /* DELETE_VESSEL */].FAILURE,
                        errors: response.errors,
                        vessel: vessel
                    });

                case 14:
                    return _context13.abrupt('return', response);

                case 15:
                case 'end':
                    return _context13.stop();
            }
        }
    }, _marked13, this);
}

function watchDeleteVessel() {
    var _ref8, _vessel3;

    return regeneratorRuntime.wrap(function watchDeleteVessel$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    if (false) {
                        _context14.next = 9;
                        break;
                    }

                    _context14.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["Z" /* DELETE_VESSEL */].REQUEST);

                case 3:
                    _ref8 = _context14.sent;
                    _vessel3 = _ref8.vessel;
                    _context14.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteVessel, _vessel3);

                case 7:
                    _context14.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context14.stop();
            }
        }
    }, _marked14, this);
}

function addVessel(vessel) {
    var response;
    return regeneratorRuntime.wrap(function addVessel$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].addVessel, vessel);

                case 2:
                    response = _context15.sent;

                    if (!(response.status === 200)) {
                        _context15.next = 10;
                        break;
                    }

                    _context15.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.messages,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 6:
                    _context15.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["h" /* ADD_VESSEL */].SUCCESS,
                        data: vessel
                    });

                case 8:

                    __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* browserHistory */].push('/vessels/list');

                    return _context15.abrupt('return', response);

                case 10:
                    _context15.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: response.errors[0].messages ? response.errors[0].field : 'error',
                            message: response.errors[0].messages ? response.errors[0].messages[0] : response.errors[0].message,
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 12:
                    _context15.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["h" /* ADD_VESSEL */].FAILURE,
                        errors: response.errors,
                        vessel: vessel
                    });

                case 14:
                    return _context15.abrupt('return', response);

                case 15:
                case 'end':
                    return _context15.stop();
            }
        }
    }, _marked15, this);
}

function watchAddVessel() {
    var _ref9, _vessel4;

    return regeneratorRuntime.wrap(function watchAddVessel$(_context16) {
        while (1) {
            switch (_context16.prev = _context16.next) {
                case 0:
                    if (false) {
                        _context16.next = 9;
                        break;
                    }

                    _context16.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["h" /* ADD_VESSEL */].REQUEST);

                case 3:
                    _ref9 = _context16.sent;
                    _vessel4 = _ref9.vessel;
                    _context16.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(addVessel, _vessel4);

                case 7:
                    _context16.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context16.stop();
            }
        }
    }, _marked16, this);
}

function updateVesselImage(vesselId, images) {
    var response;
    return regeneratorRuntime.wrap(function updateVesselImage$(_context17) {
        while (1) {
            switch (_context17.prev = _context17.next) {
                case 0:
                    _context17.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].updateVesselImage, vesselId, images);

                case 2:
                    response = _context17.sent;

                    if (!(response.status === 200)) {
                        _context17.next = 9;
                        break;
                    }

                    _context17.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Vessel image updated successfully',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 6:
                    _context17.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_142" /* UPDATE_VESSEL_IMAGE */].SUCCESS,
                        data: images
                    });

                case 8:
                    return _context17.abrupt('return', response);

                case 9:
                    _context17.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: response.errors[0].messages ? response.errors[0].field : 'error',
                            message: response.errors[0].messages ? response.errors[0].messages[0] : response.errors[0].message,
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 11:
                    _context17.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_142" /* UPDATE_VESSEL_IMAGE */].FAILURE,
                        errors: response.errors,
                        images: images
                    });

                case 13:
                    return _context17.abrupt('return', response);

                case 14:
                case 'end':
                    return _context17.stop();
            }
        }
    }, _marked17, this);
}

function watchUpdateVesselImage() {
    var _ref10, vesselId, images;

    return regeneratorRuntime.wrap(function watchUpdateVesselImage$(_context18) {
        while (1) {
            switch (_context18.prev = _context18.next) {
                case 0:
                    if (false) {
                        _context18.next = 10;
                        break;
                    }

                    _context18.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_142" /* UPDATE_VESSEL_IMAGE */].REQUEST);

                case 3:
                    _ref10 = _context18.sent;
                    vesselId = _ref10.vesselId;
                    images = _ref10.images;
                    _context18.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateVesselImage, vesselId, images);

                case 8:
                    _context18.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context18.stop();
            }
        }
    }, _marked18, this);
}

var _default = [watchGetVessels, watchGetVessel, watchDeleteNameSuggestion, watchRenameVessel, watchUpdateVessel, watchDeleteVessel, watchAddVessel, watchConfirmVessel, watchUpdateVesselImage];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getVessels, 'getVessels', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchGetVessels, 'watchGetVessels', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(getVessel, 'getVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchGetVessel, 'watchGetVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(confirmVessel, 'confirmVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchConfirmVessel, 'watchConfirmVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(deleteNameSuggestion, 'deleteNameSuggestion', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(renameVessel, 'renameVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(updateVessel, 'updateVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchDeleteNameSuggestion, 'watchDeleteNameSuggestion', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchRenameVessel, 'watchRenameVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchUpdateVessel, 'watchUpdateVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(deleteVessel, 'deleteVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchDeleteVessel, 'watchDeleteVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(addVessel, 'addVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchAddVessel, 'watchAddVessel', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(updateVesselImage, 'updateVesselImage', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(watchUpdateVesselImage, 'watchUpdateVesselImage', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/vessels/vessels.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getContacts */
/* unused harmony export watchGetContacts */
/* unused harmony export getTimeContacts */
/* unused harmony export watchGetTimeContacts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getContacts),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetContacts),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getTimeContacts),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetTimeContacts);





/**
 * Get contacts
 * */
function getContacts() {
    var response;
    return regeneratorRuntime.wrap(function getContacts$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getContracts);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_23" /* GET_CONTRACTS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_23" /* GET_CONTRACTS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetContacts() {
    return regeneratorRuntime.wrap(function watchGetContacts$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_23" /* GET_CONTRACTS */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getContacts);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getTimeContacts() {
    var response;
    return regeneratorRuntime.wrap(function getTimeContacts$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getTimeContracts);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_53" /* GET_TIME_CONTRACTS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_53" /* GET_TIME_CONTRACTS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetTimeContacts() {
    return regeneratorRuntime.wrap(function watchGetTimeContacts$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 7;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_53" /* GET_TIME_CONTRACTS */].REQUEST);

                case 3:
                    _context4.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getTimeContacts);

                case 5:
                    _context4.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

var _default = [watchGetContacts, watchGetTimeContacts];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getContacts, 'getContacts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/contacts.js');
    reactHotLoader.register(watchGetContacts, 'watchGetContacts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/contacts.js');
    reactHotLoader.register(getTimeContacts, 'getTimeContacts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/contacts.js');
    reactHotLoader.register(watchGetTimeContacts, 'watchGetTimeContacts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/contacts.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/contacts.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getCompanies */
/* unused harmony export watchGetCompanies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCompanies),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCompanies);





/**
 * Get companies
 * */
function getCompanies() {
    var response;
    return regeneratorRuntime.wrap(function getCompanies$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCompanies);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_21" /* GET_COMPANIES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_21" /* GET_COMPANIES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetCompanies() {
    return regeneratorRuntime.wrap(function watchGetCompanies$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_21" /* GET_COMPANIES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCompanies);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetCompanies];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCompanies, 'getCompanies', '/opt/atlassian/pipelines/agent/build/client/app/sagas/companies.js');
    reactHotLoader.register(watchGetCompanies, 'watchGetCompanies', '/opt/atlassian/pipelines/agent/build/client/app/sagas/companies.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/companies.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getRealCompanies */
/* unused harmony export watchGetRealCompanies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getRealCompanies),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetRealCompanies);





/**
 * Get real companies
 * */
function getRealCompanies() {
    var response;
    return regeneratorRuntime.wrap(function getRealCompanies$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getRealCompanies);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_40" /* GET_REAL_COMPANIES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_40" /* GET_REAL_COMPANIES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetRealCompanies() {
    return regeneratorRuntime.wrap(function watchGetRealCompanies$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_40" /* GET_REAL_COMPANIES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getRealCompanies);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetRealCompanies];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getRealCompanies, 'getRealCompanies', '/opt/atlassian/pipelines/agent/build/client/app/sagas/realCompanies.js');
    reactHotLoader.register(watchGetRealCompanies, 'watchGetRealCompanies', '/opt/atlassian/pipelines/agent/build/client/app/sagas/realCompanies.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/realCompanies.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getCountries */
/* unused harmony export watchGetCountries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCountries),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCountries);





/**
 * Get contacts
 * */
function getCountries() {
    var response;
    return regeneratorRuntime.wrap(function getCountries$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getCountries);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_24" /* GET_COUNTRIES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_24" /* GET_COUNTRIES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetCountries() {
    return regeneratorRuntime.wrap(function watchGetCountries$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_24" /* GET_COUNTRIES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCountries);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetCountries];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCountries, 'getCountries', '/opt/atlassian/pipelines/agent/build/client/app/sagas/countries.js');
    reactHotLoader.register(watchGetCountries, 'watchGetCountries', '/opt/atlassian/pipelines/agent/build/client/app/sagas/countries.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/countries.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getStatisticsUsers */
/* unused harmony export watchGetStatisticsUsers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStatisticsUsers),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetStatisticsUsers);






/**
 * Get statistics users
 * */
function getStatisticsUsers(from, until) {
    var response;
    return regeneratorRuntime.wrap(function getStatisticsUsers$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getStatisticsUsers, from, until);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_47" /* GET_STATISTICS_USERS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_47" /* GET_STATISTICS_USERS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetStatisticsUsers() {
    var _ref, from, until;

    return regeneratorRuntime.wrap(function watchGetStatisticsUsers$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 10;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_47" /* GET_STATISTICS_USERS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    from = _ref.from;
                    until = _ref.until;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(getStatisticsUsers, from, until);

                case 8:
                    _context2.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetStatisticsUsers];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsUsers, 'getStatisticsUsers', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/users.js');
    reactHotLoader.register(watchGetStatisticsUsers, 'watchGetStatisticsUsers', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/users.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/users.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getStatisticsEmails */
/* unused harmony export watchGetStatisticsEmails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStatisticsEmails),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetStatisticsEmails);






/**
 * Get statistics emails
 * */
function getStatisticsEmails(from, until, isWorkingHours) {
    var response;
    return regeneratorRuntime.wrap(function getStatisticsEmails$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getStatisticsEmails, from, until, isWorkingHours);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 6;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_45" /* GET_STATISTICS_EMAILS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_45" /* GET_STATISTICS_EMAILS */].FAILURE,
                        errors: response.errors
                    });

                case 8:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetStatisticsEmails() {
    var _ref, from, until, isWorkingHours;

    return regeneratorRuntime.wrap(function watchGetStatisticsEmails$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 11;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_45" /* GET_STATISTICS_EMAILS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    from = _ref.from;
                    until = _ref.until;
                    isWorkingHours = _ref.isWorkingHours;
                    _context2.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(getStatisticsEmails, from, until, isWorkingHours);

                case 9:
                    _context2.next = 0;
                    break;

                case 11:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetStatisticsEmails];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsEmails, 'getStatisticsEmails', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/emails.js');
    reactHotLoader.register(watchGetStatisticsEmails, 'watchGetStatisticsEmails', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/emails.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/emails.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getStatisticsMonitor */
/* unused harmony export watchGetStatisticsMonitor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStatisticsMonitor),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetStatisticsMonitor);





/**
 * Get statistics monitor
 * */
function getStatisticsMonitor(from, until) {
    var response;
    return regeneratorRuntime.wrap(function getStatisticsMonitor$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getStatisticsMonitor, from, until);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 6;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_46" /* GET_STATISTICS_MONITOR */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_46" /* GET_STATISTICS_MONITOR */].FAILURE,
                        errors: response.errors
                    });

                case 8:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetStatisticsMonitor() {
    var _ref, from, until;

    return regeneratorRuntime.wrap(function watchGetStatisticsMonitor$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 10;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_46" /* GET_STATISTICS_MONITOR */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    from = _ref.from;
                    until = _ref.until;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(getStatisticsMonitor, from, until);

                case 8:
                    _context2.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetStatisticsMonitor];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsMonitor, 'getStatisticsMonitor', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/monitor.js');
    reactHotLoader.register(watchGetStatisticsMonitor, 'watchGetStatisticsMonitor', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/monitor.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/monitor.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getStatisticsCargoRequests */
/* unused harmony export watchGetStatisticsCargoRequests */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStatisticsCargoRequests),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetStatisticsCargoRequests);





/**
 * Get statistics cargo requests
 * */
function getStatisticsCargoRequests(from, until) {
    var response;
    return regeneratorRuntime.wrap(function getStatisticsCargoRequests$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getStatisticsCargoRequests, from, until);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 6;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_44" /* GET_STATISTICS_CARGO_REQUESTS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_44" /* GET_STATISTICS_CARGO_REQUESTS */].FAILURE,
                        errors: response.errors
                    });

                case 8:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetStatisticsCargoRequests() {
    var _ref, from, until;

    return regeneratorRuntime.wrap(function watchGetStatisticsCargoRequests$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 10;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_44" /* GET_STATISTICS_CARGO_REQUESTS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    from = _ref.from;
                    until = _ref.until;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(getStatisticsCargoRequests, from, until);

                case 8:
                    _context2.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetStatisticsCargoRequests];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsCargoRequests, 'getStatisticsCargoRequests', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/cargoRequests.js');
    reactHotLoader.register(watchGetStatisticsCargoRequests, 'watchGetStatisticsCargoRequests', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/cargoRequests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/cargoRequests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getStatisticsVesselPositions */
/* unused harmony export watchGetStatisticsVesselPositions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getStatisticsVesselPositions),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetStatisticsVesselPositions);





/**
 * Get statistics vessel positions
 * */
function getStatisticsVesselPositions(from, until) {
    var response;
    return regeneratorRuntime.wrap(function getStatisticsVesselPositions$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getStatisticsVesselPositions, from, until);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 6;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_48" /* GET_STATISTICS_VESSEL_POSITIONS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_48" /* GET_STATISTICS_VESSEL_POSITIONS */].FAILURE,
                        errors: response.errors
                    });

                case 8:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetStatisticsVesselPositions() {
    var _ref, from, until;

    return regeneratorRuntime.wrap(function watchGetStatisticsVesselPositions$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 10;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_48" /* GET_STATISTICS_VESSEL_POSITIONS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    from = _ref.from;
                    until = _ref.until;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(getStatisticsVesselPositions, from, until);

                case 8:
                    _context2.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetStatisticsVesselPositions];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getStatisticsVesselPositions, 'getStatisticsVesselPositions', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/vesselPositions.js');
    reactHotLoader.register(watchGetStatisticsVesselPositions, 'watchGetStatisticsVesselPositions', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/vesselPositions.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/statistics/vesselPositions.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetSendLetterList */
/* unused harmony export getSendLetter */
/* unused harmony export watchGetSendLetter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getSendLetterList),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetSendLetterList),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getSendLetter),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetSendLetter);






/**
 * Get send letter
 * */
function getSendLetterList() {
    var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var store, response;
    return regeneratorRuntime.wrap(function getSendLetterList$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 2:
                    store = _context.sent;
                    response = {};
                    _context.prev = 4;
                    _context.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getSendEmailList, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge(store.senderList, pagination));

                case 7:
                    response = _context.sent;
                    _context.next = 15;
                    break;

                case 10:
                    _context.prev = 10;
                    _context.t0 = _context['catch'](4);
                    _context.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].FAILURE,
                        errors: response.data,
                        error: _context.t0
                    });

                case 14:
                    return _context.abrupt('return', response.data);

                case 15:
                    if (!(response.status === 200)) {
                        _context.next = 19;
                        break;
                    }

                    _context.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].SUCCESS,
                        data: response.data
                    });

                case 18:
                    return _context.abrupt('return', response);

                case 19:
                    _context.next = 21;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].FAILURE,
                        errors: response.errors
                    });

                case 21:
                    return _context.abrupt('return', response);

                case 22:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[4, 10]]);
}

function watchGetSendLetterList() {
    var _ref, pagination;

    return regeneratorRuntime.wrap(function watchGetSendLetterList$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    pagination = _ref.pagination;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getSendLetterList, pagination);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get send letter
 * */
function getSendLetter(id) {
    var response;
    return regeneratorRuntime.wrap(function getSendLetter$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getSendEmail, id);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_42" /* GET_SEND_EMAIL */].SUCCESS,
                        data: response.data.data
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_42" /* GET_SEND_EMAIL */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetSendLetter() {
    var _ref2, id;

    return regeneratorRuntime.wrap(function watchGetSendLetter$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_42" /* GET_SEND_EMAIL */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    id = _ref2.id;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getSendLetter, id);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

var _default = [watchGetSendLetterList, watchGetSendLetter];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getSendLetterList, 'getSendLetterList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/sender.js');
    reactHotLoader.register(watchGetSendLetterList, 'watchGetSendLetterList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/sender.js');
    reactHotLoader.register(getSendLetter, 'getSendLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/sender.js');
    reactHotLoader.register(watchGetSendLetter, 'watchGetSendLetter', '/opt/atlassian/pipelines/agent/build/client/app/sagas/sender.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/sender.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getReqLDRates */
/* unused harmony export watchGetReqLDRates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_reqldRates_reqRates__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getReqLDRates),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetReqLDRates);






/**
 * get cargo request ldrates
 */

function getReqLDRates() {
    var response;
    return regeneratorRuntime.wrap(function getReqLDRates$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getReqLDRates);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_41" /* GET_REQ_LD_RATES */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return');

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_41" /* GET_REQ_LD_RATES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetReqLDRates() {
    return regeneratorRuntime.wrap(function watchGetReqLDRates$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_41" /* GET_REQ_LD_RATES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getReqLDRates);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetReqLDRates];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getReqLDRates, 'getReqLDRates', '/opt/atlassian/pipelines/agent/build/client/app/sagas/reqLDRates.js');
    reactHotLoader.register(watchGetReqLDRates, 'watchGetReqLDRates', '/opt/atlassian/pipelines/agent/build/client/app/sagas/reqLDRates.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/reqLDRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export sendTrainings */
/* unused harmony export watchSendTraining */
/* unused harmony export deleteTraining */
/* unused harmony export watchDeleteTraining */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(sendTrainings),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchSendTraining),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(deleteTraining),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteTraining);





/**
 * Send train
 * */
function sendTrainings(data) {
    var response;
    return regeneratorRuntime.wrap(function sendTrainings$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].sendTrainings, data);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_113" /* SEND_GAZETTER_TRAININGS */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Training sent',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context.abrupt('return', response);

                case 11:
                    if (!(response.status === 400)) {
                        _context.next = 14;
                        break;
                    }

                    _context.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Letter with provided hash already exists',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 5
                        }
                    });

                case 14:
                    _context.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_113" /* SEND_GAZETTER_TRAININGS */].FAILURE,
                        errors: response.errors
                    });

                case 16:
                    return _context.abrupt('return', response);

                case 17:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchSendTraining() {
    var _ref, data;

    return regeneratorRuntime.wrap(function watchSendTraining$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_113" /* SEND_GAZETTER_TRAININGS */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(sendTrainings, data);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function deleteTraining(data) {
    var response;
    return regeneratorRuntime.wrap(function deleteTraining$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteTraining, data);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 9;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["Q" /* DELETE_GAZETTER_TRAINING */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    _context3.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: 'Letter removed',
                            level: 'success',
                            _id: response.data._id,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context3.abrupt('return', response);

                case 9:
                    _context3.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].message || response.errors[0].messages[0].message,
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 5
                        }
                    });

                case 11:
                    _context3.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["Q" /* DELETE_GAZETTER_TRAINING */].FAILURE,
                        errors: response.errors
                    });

                case 13:
                    return _context3.abrupt('return', response);

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchDeleteTraining() {
    var _ref2, _data;

    return regeneratorRuntime.wrap(function watchDeleteTraining$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["Q" /* DELETE_GAZETTER_TRAINING */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    _data = _ref2.data;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteTraining, _data);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

var _default = [watchSendTraining, watchDeleteTraining];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sendTrainings, 'sendTrainings', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetterTrainings.js');
    reactHotLoader.register(watchSendTraining, 'watchSendTraining', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetterTrainings.js');
    reactHotLoader.register(deleteTraining, 'deleteTraining', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetterTrainings.js');
    reactHotLoader.register(watchDeleteTraining, 'watchDeleteTraining', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetterTrainings.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/gazetterTrainings.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetCompanyUser */
/* unused harmony export watchGetIntegratorCompanies */
/* unused harmony export watchGetIntegrators */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(27);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getIntegrators),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getIntegratorCompanies),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getCompanyUser),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetCompanyUser),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchGetIntegratorCompanies),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchGetIntegrators);





function getIntegrators() {
  var integrators;
  return regeneratorRuntime.wrap(function getIntegrators$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_0_services__["a" /* default */].getIntegrators);

        case 3:
          integrators = _context.sent;
          _context.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* put */])({
            type: __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_27" /* GET_INTEGRATORS */].SUCCESS,
            data: integrators
          });

        case 6:
          _context.next = 12;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _context.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* put */])({
            type: __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_27" /* GET_INTEGRATORS */].FAILURE,
            errors: _context.t0
          });

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 8]]);
}

function getIntegratorCompanies(id) {
  var companies;
  return regeneratorRuntime.wrap(function getIntegratorCompanies$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_0_services__["a" /* default */].getIntegratorCompanies, id);

        case 3:
          companies = _context2.sent;
          _context2.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* put */])({
            type: __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_28" /* GET_INTEGRATOR_COMPANIES */].SUCCESS,
            data: companies,
            id: id
          });

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* put */])({
            type: __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_28" /* GET_INTEGRATOR_COMPANIES */].FAILURE,
            errors: _context2.t0
          });

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 8]]);
}
function getCompanyUser(id, integratorId) {
  var user;
  return regeneratorRuntime.wrap(function getCompanyUser$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;

          if (!integratorId) {
            _context3.next = 5;
            break;
          }

          _context3.t0 = integratorId;
          _context3.next = 8;
          break;

        case 5:
          _context3.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* select */])(function (_ref) {
            var integratorId = _ref.integratorCompanies.integratorId;
            return integratorId;
          });

        case 7:
          _context3.t0 = _context3.sent;

        case 8:
          integratorId = _context3.t0;
          _context3.next = 11;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_0_services__["a" /* default */].getCompanyUser, id, integratorId);

        case 11:
          user = _context3.sent;
          _context3.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* put */])({
            type: __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_22" /* GET_COMPANY_USER */].SUCCESS,
            data: user,
            id: id
          });

        case 14:
          _context3.next = 20;
          break;

        case 16:
          _context3.prev = 16;
          _context3.t1 = _context3["catch"](0);
          _context3.next = 20;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* put */])({
            type: __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_22" /* GET_COMPANY_USER */].FAILURE,
            errors: _context3.t1
          });

        case 20:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 16]]);
}

function watchGetCompanyUser() {
  var _ref2, id, integratorId;

  return regeneratorRuntime.wrap(function watchGetCompanyUser$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (false) {
            _context4.next = 10;
            break;
          }

          _context4.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_22" /* GET_COMPANY_USER */].REQUEST);

        case 3:
          _ref2 = _context4.sent;
          id = _ref2.id;
          integratorId = _ref2.integratorId;
          _context4.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* fork */])(getCompanyUser, id, integratorId);

        case 8:
          _context4.next = 0;
          break;

        case 10:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchGetIntegratorCompanies() {
  var _ref3, _id;

  return regeneratorRuntime.wrap(function watchGetIntegratorCompanies$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (false) {
            _context5.next = 9;
            break;
          }

          _context5.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_28" /* GET_INTEGRATOR_COMPANIES */].REQUEST);

        case 3:
          _ref3 = _context5.sent;
          _id = _ref3.id;
          _context5.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* fork */])(getIntegratorCompanies, _id);

        case 7:
          _context5.next = 0;
          break;

        case 9:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchGetIntegrators() {
  return regeneratorRuntime.wrap(function watchGetIntegrators$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_27" /* GET_INTEGRATORS */].REQUEST, getIntegrators);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

var _default = [watchGetIntegrators, watchGetIntegratorCompanies, watchGetCompanyUser];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getIntegrators, "getIntegrators", "/opt/atlassian/pipelines/agent/build/client/app/sagas/integrators/integrators.js");
  reactHotLoader.register(getIntegratorCompanies, "getIntegratorCompanies", "/opt/atlassian/pipelines/agent/build/client/app/sagas/integrators/integrators.js");
  reactHotLoader.register(getCompanyUser, "getCompanyUser", "/opt/atlassian/pipelines/agent/build/client/app/sagas/integrators/integrators.js");
  reactHotLoader.register(watchGetCompanyUser, "watchGetCompanyUser", "/opt/atlassian/pipelines/agent/build/client/app/sagas/integrators/integrators.js");
  reactHotLoader.register(watchGetIntegratorCompanies, "watchGetIntegratorCompanies", "/opt/atlassian/pipelines/agent/build/client/app/sagas/integrators/integrators.js");
  reactHotLoader.register(watchGetIntegrators, "watchGetIntegrators", "/opt/atlassian/pipelines/agent/build/client/app/sagas/integrators/integrators.js");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/sagas/integrators/integrators.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchPostRequestTc */
/* unused harmony export watchGetRequestsTc */
/* unused harmony export watchDeleteRequestsTc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__refNumber__ = __webpack_require__(225);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(postRequestTc),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchPostRequestTc),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getRequestsTc),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetRequestsTc),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteRequestsTc),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteRequestsTc);






function postRequestTc(tcRequest, keyTcOrder) {
    var response;
    return regeneratorRuntime.wrap(function postRequestTc$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].postRequestTc, tcRequest);

                case 2:
                    response = _context.sent;

                    if (!(response.data && response.errors && !response.errors.length)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_72" /* POST_TC_REQUEST */].SUCCESS,
                        data: response.data,
                        tcRequest: tcRequest
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success tc request - ' + (keyTcOrder + 1),
                            message: 'TC request created successfully',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__refNumber__["a" /* refNumber */], response.data);

                case 10:
                    return _context.abrupt('return', response);

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error tc request - ' + (keyTcOrder + 1),
                            message: response.errors[0].message || response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 13:
                    _context.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_72" /* POST_TC_REQUEST */].FAILURE,
                        errors: response.errors,
                        tcRequest: tcRequest
                    });

                case 15:
                    return _context.abrupt('return', response);

                case 16:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchPostRequestTc() {
    var _ref, tcRequest, index;

    return regeneratorRuntime.wrap(function watchPostRequestTc$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 10;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_72" /* POST_TC_REQUEST */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    tcRequest = _ref.tcRequest;
                    index = _ref.index;
                    _context2.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(postRequestTc, tcRequest, index);

                case 8:
                    _context2.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getRequestsTc(filter) {
    var response;
    return regeneratorRuntime.wrap(function getRequestsTc$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getRequestsTc, filter);

                case 2:
                    response = _context3.sent;

                    if (!response.data) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_51" /* GET_TC_REQUESTS */].SUCCESS,
                        data: response
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_51" /* GET_TC_REQUESTS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetRequestsTc() {
    var _ref2, filter;

    return regeneratorRuntime.wrap(function watchGetRequestsTc$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_51" /* GET_TC_REQUESTS */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    filter = _ref2.filter;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getRequestsTc, filter);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function deleteRequestsTc(tcRequestId) {
    var response, store;
    return regeneratorRuntime.wrap(function deleteRequestsTc$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteTcRequest, tcRequestId);

                case 2:
                    response = _context5.sent;

                    if (!response.data._id) {
                        _context5.next = 12;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* select */])();

                case 6:
                    store = _context5.sent;
                    _context5.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["Y" /* DELETE_TC_REQUEST */].SUCCESS,
                        tcRequestId: tcRequestId,
                        email: store.user.user.email
                    });

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: "Request deleted successfully",
                            level: 'success',
                            _id: tcRequestId,
                            autoDismiss: 2
                        }
                    });

                case 11:
                    return _context5.abrupt('return');

                case 12:
                    _context5.next = 14;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["Y" /* DELETE_TC_REQUEST */].FAILURE,
                        tcRequestId: tcRequestId,
                        error: response.errors
                    });

                case 14:
                    _context5.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].message,
                            level: 'error',
                            _id: tcRequestId,
                            autoDismiss: 2
                        }
                    });

                case 16:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchDeleteRequestsTc() {
    var _ref3, tcRequestId;

    return regeneratorRuntime.wrap(function watchDeleteRequestsTc$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["Y" /* DELETE_TC_REQUEST */].REQUEST);

                case 3:
                    _ref3 = _context6.sent;
                    tcRequestId = _ref3.tcRequestId;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteRequestsTc, tcRequestId);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

var _default = [watchPostRequestTc, watchGetRequestsTc, watchDeleteRequestsTc];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestTc, 'postRequestTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/requests.js');
    reactHotLoader.register(watchPostRequestTc, 'watchPostRequestTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/requests.js');
    reactHotLoader.register(getRequestsTc, 'getRequestsTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/requests.js');
    reactHotLoader.register(watchGetRequestsTc, 'watchGetRequestsTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/requests.js');
    reactHotLoader.register(deleteRequestsTc, 'deleteRequestsTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/requests.js');
    reactHotLoader.register(watchDeleteRequestsTc, 'watchDeleteRequestsTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/requests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getLinksList */
/* unused harmony export watchGetLinksList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getLinksList),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetLinksList);





/**
 * Get links list
 * */
function getLinksList() {
    var response;
    return regeneratorRuntime.wrap(function getLinksList$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getAnalyticsLinksList);

                case 2:
                    response = _context.sent;

                    if (response.errors.length) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_5" /* GET_ANALYTICS_LINKS_LIST */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_5" /* GET_ANALYTICS_LINKS_LIST */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetLinksList() {
    return regeneratorRuntime.wrap(function watchGetLinksList$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_5" /* GET_ANALYTICS_LINKS_LIST */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getLinksList);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetLinksList];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getLinksList, 'getLinksList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/analytics/linksList.js');
    reactHotLoader.register(watchGetLinksList, 'watchGetLinksList', '/opt/atlassian/pipelines/agent/build/client/app/sagas/analytics/linksList.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/analytics/linksList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export getFlagCompliance */
/* unused harmony export watchGetFlagCompliance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getFlagCompliance),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetFlagCompliance);





/**
 * Get links list
 * */
function getFlagCompliance() {
    var response;
    return regeneratorRuntime.wrap(function getFlagCompliance$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getFlagCompliance);

                case 2:
                    response = _context.sent;

                    if (response.errors.length) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_25" /* GET_FLAG_COMPLIANCE */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_25" /* GET_FLAG_COMPLIANCE */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetFlagCompliance() {
    return regeneratorRuntime.wrap(function watchGetFlagCompliance$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_25" /* GET_FLAG_COMPLIANCE */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getFlagCompliance);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchGetFlagCompliance];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getFlagCompliance, 'getFlagCompliance', '/opt/atlassian/pipelines/agent/build/client/app/sagas/flagCompliance.js');
    reactHotLoader.register(watchGetFlagCompliance, 'watchGetFlagCompliance', '/opt/atlassian/pipelines/agent/build/client/app/sagas/flagCompliance.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/flagCompliance.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetIndexesTc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__refNumber__ = __webpack_require__(225);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getIndexesTc),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetIndexesTc);






// function* postRequestTc(tcRequest, keyTcOrder) {
//     const response = yield call(api.postRequestTc, tcRequest);

//     if (response.data) {
//         yield put({
//             type: actionTypes.POST_TC_REQUEST.SUCCESS,
//             data: response.data,
//             tcRequest,
//         });

//         yield put({
//             type: actionTypes.ADD_NOTIFICATION,
//             notification: {
//                 title: `Success tc request - ${keyTcOrder + 1}`,
//                 message: 'TC request created successfully',
//                 level: 'success',
//                 _id: new Date().getMilliseconds(),
//                 autoDismiss: 10,
//             },
//         });

//         yield call(refNumber, response.data);
//         return response;
//     }

//     yield put({
//         type: actionTypes.ADD_NOTIFICATION,
//         notification: {
//             title: `Error tc request - ${keyTcOrder + 1}`,
//             message: response.errors[0].message || response.errors[0].messages[0],
//             level: 'error',
//             _id: new Date().getMilliseconds(),
//             autoDismiss: 10,
//         },
//     });

//     yield put({
//         type: actionTypes.POST_TC_REQUEST.FAILURE,
//         errors: response.errors,
//         tcRequest,
//     });

//     return response;
// }

// export function* watchPostRequestTc() {
//     while (true) {
//         const { tcRequest, index } = yield take(actionTypes.POST_TC_REQUEST.REQUEST);
//         yield fork(postRequestTc, tcRequest, index);
//     }
// }

function getIndexesTc(filter) {
    var response;
    return regeneratorRuntime.wrap(function getIndexesTc$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getTcHireIdeas, filter);

                case 2:
                    response = _context.sent;

                    if (!response.data) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_50" /* GET_TC_INDEXES */].SUCCESS,
                        data: response
                    });

                case 6:
                    return _context.abrupt('return', response);

                case 7:
                    _context.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_50" /* GET_TC_INDEXES */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context.abrupt('return', response);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchGetIndexesTc() {
    var _ref, filter;

    return regeneratorRuntime.wrap(function watchGetIndexesTc$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_50" /* GET_TC_INDEXES */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    filter = _ref.filter;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getIndexesTc, filter);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

// function* deleteRequestsTc(tcRequestId) {
//     const response = yield call(api.deleteTcRequest, tcRequestId);

//     if (response.data._id) {
//         const store = yield select();

//         yield put({
//             type: actionTypes.DELETE_TC_REQUEST.SUCCESS,
//             tcRequestId,
//             email: store.user.user.email,
//         });

//         yield put({
//             type: actionTypes.ADD_NOTIFICATION,
//             notification: {
//                 title: 'Success',
//                 message: "Request deleted successfully",
//                 level: 'success',
//                 _id: tcRequestId,
//                 autoDismiss: 2,
//             },
//         });
//         return;
//     }

//     yield put({
//         type: actionTypes.DELETE_TC_REQUEST.FAILURE,
//         tcRequestId,
//         error: response.errors,
//     });

//     yield put({
//         type: actionTypes.ADD_NOTIFICATION,
//         notification: {
//             title: 'Error',
//             message: response.errors[0].message,
//             level: 'error',
//             _id: tcRequestId,
//             autoDismiss: 2,
//         },
//     });

// }

// export function* watchDeleteRequestsTc() {
//     while (true) {
//         const { tcRequestId } = yield take(actionTypes.DELETE_TC_REQUEST.REQUEST);
//         yield fork(deleteRequestsTc, tcRequestId);
//     }
// }

var _default = [
// watchPostRequestTc,
watchGetIndexesTc];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getIndexesTc, 'getIndexesTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/indexes.js');
    reactHotLoader.register(watchGetIndexesTc, 'watchGetIndexesTc', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/indexes.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/indexes.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchCargoTagsCategories */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getCargoTagsCategories),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchCargoTagsCategories);





/**
 * Delete cargo name
 * */
function getCargoTagsCategories() {
    var response;
    return regeneratorRuntime.wrap(function getCargoTagsCategories$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getTagsCategories);

                case 3:
                    response = _context.sent;

                    if (!(response && (!response.errors || !response.errors.length))) {
                        _context.next = 8;
                        break;
                    }

                    _context.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_19" /* GET_CARGO_TAGS_CATEGORIES */].SUCCESS,
                        data: response.data
                    });

                case 7:
                    return _context.abrupt('return');

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_19" /* GET_CARGO_TAGS_CATEGORIES */].FAILURE,
                        errors: response.errors
                    });

                case 10:
                    _context.next = 16;
                    break;

                case 12:
                    _context.prev = 12;
                    _context.t0 = _context['catch'](0);
                    _context.next = 16;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 2
                        }
                    });

                case 16:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 12]]);
}

function watchCargoTagsCategories() {
    return regeneratorRuntime.wrap(function watchCargoTagsCategories$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 7;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_19" /* GET_CARGO_TAGS_CATEGORIES */].REQUEST);

                case 3:
                    _context2.next = 5;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getCargoTagsCategories);

                case 5:
                    _context2.next = 0;
                    break;

                case 7:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

var _default = [watchCargoTagsCategories];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoTagsCategories, 'getCargoTagsCategories', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/tags.js');
    reactHotLoader.register(watchCargoTagsCategories, 'watchCargoTagsCategories', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/tags.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/tags.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchGetIssues */
/* unused harmony export getIssue */
/* unused harmony export watchGetIssue */
/* unused harmony export watchUpdateIssueStatus */
/* unused harmony export watchAddIssueComment */
/* unused harmony export watchUpdateIssueComment */
/* unused harmony export watchDeleteIssueComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getIssues),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetIssues),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getIssue),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetIssue),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(updateIssueStatus),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateIssueStatus),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(addIssueComment),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchAddIssueComment),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(updateIssueComment),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(watchUpdateIssueComment),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(deleteIssueComment),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteIssueComment);






/**
 * Get list of issues
 * */
function getIssues() {
    var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var response;
    return regeneratorRuntime.wrap(function getIssues$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    response = {};
                    _context.prev = 1;
                    _context.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getIssues, pagination);

                case 4:
                    response = _context.sent;
                    _context.next = 12;
                    break;

                case 7:
                    _context.prev = 7;
                    _context.t0 = _context['catch'](1);
                    _context.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_30" /* GET_ISSUES */].FAILURE,
                        errors: response.data,
                        error: _context.t0
                    });

                case 11:
                    return _context.abrupt('return', response.data);

                case 12:
                    if (!(response && !response.errors.length)) {
                        _context.next = 16;
                        break;
                    }

                    _context.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_30" /* GET_ISSUES */].SUCCESS,
                        data: response.data
                    });

                case 15:
                    return _context.abrupt('return', response);

                case 16:
                    _context.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_30" /* GET_ISSUES */].FAILURE,
                        errors: response.errors
                    });

                case 18:
                    return _context.abrupt('return', response);

                case 19:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[1, 7]]);
}

function watchGetIssues() {
    var _ref, pagination;

    return regeneratorRuntime.wrap(function watchGetIssues$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_30" /* GET_ISSUES */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    pagination = _ref.pagination;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getIssues, pagination);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

/**
 * Get issue by id
 * */
function getIssue(id) {
    var response;
    return regeneratorRuntime.wrap(function getIssue$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getIssue, id);

                case 2:
                    response = _context3.sent;

                    if (!(response && !response.errors.length)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_29" /* GET_ISSUE */].SUCCESS,
                        data: response.data
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_29" /* GET_ISSUE */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetIssue() {
    var _ref2, id;

    return regeneratorRuntime.wrap(function watchGetIssue$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_29" /* GET_ISSUE */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    id = _ref2.id;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getIssue, id);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

/**
 * Get list of issues
 * */
function updateIssueStatus(id, status) {
    var response;
    return regeneratorRuntime.wrap(function updateIssueStatus$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    response = {};
                    _context5.prev = 1;
                    _context5.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].updateIssueStatus, id, status);

                case 4:
                    response = _context5.sent;
                    _context5.next = 12;
                    break;

                case 7:
                    _context5.prev = 7;
                    _context5.t0 = _context5['catch'](1);
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].FAILURE,
                        errors: response.data,
                        error: _context5.t0
                    });

                case 11:
                    return _context5.abrupt('return', response.data);

                case 12:
                    if (!(response && !response.errors.length)) {
                        _context5.next = 16;
                        break;
                    }

                    _context5.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].SUCCESS,
                        data: response.data
                    });

                case 15:
                    return _context5.abrupt('return', response);

                case 16:
                    _context5.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].FAILURE,
                        errors: response.errors
                    });

                case 18:
                    return _context5.abrupt('return', response);

                case 19:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[1, 7]]);
}

function watchUpdateIssueStatus() {
    var _ref3, _id, status;

    return regeneratorRuntime.wrap(function watchUpdateIssueStatus$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 10;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].REQUEST);

                case 3:
                    _ref3 = _context6.sent;
                    _id = _ref3.id;
                    status = _ref3.status;
                    _context6.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateIssueStatus, _id, status);

                case 8:
                    _context6.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

/**
 * add issue comment
 * */
function addIssueComment(id, data) {
    var response;
    return regeneratorRuntime.wrap(function addIssueComment$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    response = {};
                    _context7.prev = 1;
                    _context7.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].addIssueComment, id, data);

                case 4:
                    response = _context7.sent;
                    _context7.next = 12;
                    break;

                case 7:
                    _context7.prev = 7;
                    _context7.t0 = _context7['catch'](1);
                    _context7.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].FAILURE,
                        errors: response.data,
                        error: _context7.t0
                    });

                case 11:
                    return _context7.abrupt('return', response.data);

                case 12:
                    if (!(response && !response.errors.length)) {
                        _context7.next = 16;
                        break;
                    }

                    _context7.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].SUCCESS,
                        data: response.data
                    });

                case 15:
                    return _context7.abrupt('return', response);

                case 16:
                    _context7.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].FAILURE,
                        errors: response.errors
                    });

                case 18:
                    return _context7.abrupt('return', response);

                case 19:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this, [[1, 7]]);
}

function watchAddIssueComment() {
    var _ref4, _id2, data;

    return regeneratorRuntime.wrap(function watchAddIssueComment$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    if (false) {
                        _context8.next = 10;
                        break;
                    }

                    _context8.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].REQUEST);

                case 3:
                    _ref4 = _context8.sent;
                    _id2 = _ref4.id;
                    data = _ref4.data;
                    _context8.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(addIssueComment, _id2, data);

                case 8:
                    _context8.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

/**
 * update issue comment
 * */
function updateIssueComment(id, commentId, data) {
    var response;
    return regeneratorRuntime.wrap(function updateIssueComment$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    response = {};
                    _context9.prev = 1;
                    _context9.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].updateIssueComment, id, commentId, data);

                case 4:
                    response = _context9.sent;
                    _context9.next = 12;
                    break;

                case 7:
                    _context9.prev = 7;
                    _context9.t0 = _context9['catch'](1);
                    _context9.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].FAILURE,
                        errors: response.data,
                        error: _context9.t0
                    });

                case 11:
                    return _context9.abrupt('return', response.data);

                case 12:
                    if (!(response && !response.errors.length)) {
                        _context9.next = 16;
                        break;
                    }

                    _context9.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].SUCCESS,
                        data: response.data
                    });

                case 15:
                    return _context9.abrupt('return', response);

                case 16:
                    _context9.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].FAILURE,
                        errors: response.errors
                    });

                case 18:
                    return _context9.abrupt('return', response);

                case 19:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this, [[1, 7]]);
}

function watchUpdateIssueComment() {
    var _ref5, _id3, commentId, _data;

    return regeneratorRuntime.wrap(function watchUpdateIssueComment$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (false) {
                        _context10.next = 11;
                        break;
                    }

                    _context10.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].REQUEST);

                case 3:
                    _ref5 = _context10.sent;
                    _id3 = _ref5.id;
                    commentId = _ref5.commentId;
                    _data = _ref5.data;
                    _context10.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(updateIssueComment, _id3, commentId, _data);

                case 9:
                    _context10.next = 0;
                    break;

                case 11:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

/**
 * delete issue comment
 * */
function deleteIssueComment(id, commentId) {
    var response;
    return regeneratorRuntime.wrap(function deleteIssueComment$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    response = {};
                    _context11.prev = 1;
                    _context11.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].deleteIssueComment, id, commentId);

                case 4:
                    response = _context11.sent;
                    _context11.next = 12;
                    break;

                case 7:
                    _context11.prev = 7;
                    _context11.t0 = _context11['catch'](1);
                    _context11.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].FAILURE,
                        errors: response.data,
                        error: _context11.t0
                    });

                case 11:
                    return _context11.abrupt('return', response.data);

                case 12:
                    if (!(response && !response.errors.length)) {
                        _context11.next = 16;
                        break;
                    }

                    _context11.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].SUCCESS,
                        data: response.data
                    });

                case 15:
                    return _context11.abrupt('return', response);

                case 16:
                    _context11.next = 18;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].FAILURE,
                        errors: response.errors
                    });

                case 18:
                    return _context11.abrupt('return', response);

                case 19:
                case 'end':
                    return _context11.stop();
            }
        }
    }, _marked11, this, [[1, 7]]);
}

function watchDeleteIssueComment() {
    var _ref6, _id4, _commentId;

    return regeneratorRuntime.wrap(function watchDeleteIssueComment$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    if (false) {
                        _context12.next = 10;
                        break;
                    }

                    _context12.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_3_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].REQUEST);

                case 3:
                    _ref6 = _context12.sent;
                    _id4 = _ref6.id;
                    _commentId = _ref6.commentId;
                    _context12.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteIssueComment, _id4, _commentId);

                case 8:
                    _context12.next = 0;
                    break;

                case 10:
                case 'end':
                    return _context12.stop();
            }
        }
    }, _marked12, this);
}

var _default = [watchGetIssues, watchGetIssue, watchUpdateIssueStatus, watchAddIssueComment, watchUpdateIssueComment, watchDeleteIssueComment];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getIssues, 'getIssues', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(watchGetIssues, 'watchGetIssues', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(getIssue, 'getIssue', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(watchGetIssue, 'watchGetIssue', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(updateIssueStatus, 'updateIssueStatus', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(watchUpdateIssueStatus, 'watchUpdateIssueStatus', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(addIssueComment, 'addIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(watchAddIssueComment, 'watchAddIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(updateIssueComment, 'updateIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(watchUpdateIssueComment, 'watchUpdateIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(deleteIssueComment, 'deleteIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(watchDeleteIssueComment, 'watchDeleteIssueComment', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/issues.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export watchPostRequestHire */
/* unused harmony export watchGetRequestsHire */
/* unused harmony export watchDeleteRequestHire */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__refNumber__ = __webpack_require__(225);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(postRequestHire),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchPostRequestHire),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(getRequestsHire),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetRequestsHire),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteRequestHire),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchDeleteRequestHire);






function postRequestHire(hireRequest) {
    var response;
    return regeneratorRuntime.wrap(function postRequestHire$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].postRequestHire, hireRequest);

                case 2:
                    response = _context.sent;

                    if (!(response.status === 200)) {
                        _context.next = 11;
                        break;
                    }

                    _context.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_71" /* POST_HIRE_REQUEST */].SUCCESS,
                        data: response.data,
                        hireRequest: hireRequest
                    });

                case 6:
                    _context.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success hire request - ' + (hireRequest.keyHireOrder + 1),
                            message: '' + response.data.message,
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 8:
                    _context.next = 10;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_3__refNumber__["a" /* refNumber */], response.data);

                case 10:
                    return _context.abrupt('return', response);

                case 11:
                    _context.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error hire request - ' + (hireRequest.keyHireOrder + 1),
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 10
                        }
                    });

                case 13:
                    _context.next = 15;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_71" /* POST_HIRE_REQUEST */].FAILURE,
                        errors: response.errors,
                        hireRequest: hireRequest
                    });

                case 15:
                    return _context.abrupt('return', response);

                case 16:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchPostRequestHire() {
    var _ref, hireRequest;

    return regeneratorRuntime.wrap(function watchPostRequestHire$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (false) {
                        _context2.next = 9;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_71" /* POST_HIRE_REQUEST */].REQUEST);

                case 3:
                    _ref = _context2.sent;
                    hireRequest = _ref.hireRequest;
                    _context2.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(postRequestHire, hireRequest);

                case 7:
                    _context2.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function getRequestsHire(filter) {
    var response;
    return regeneratorRuntime.wrap(function getRequestsHire$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getHiresList, filter);

                case 2:
                    response = _context3.sent;

                    if (!(response.status === 200)) {
                        _context3.next = 7;
                        break;
                    }

                    _context3.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_26" /* GET_HIRE_ORDERS */].SUCCESS,
                        data: response
                    });

                case 6:
                    return _context3.abrupt('return', response);

                case 7:
                    _context3.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_26" /* GET_HIRE_ORDERS */].FAILURE,
                        errors: response.errors
                    });

                case 9:
                    return _context3.abrupt('return', response);

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchGetRequestsHire() {
    var _ref2, filter;

    return regeneratorRuntime.wrap(function watchGetRequestsHire$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    if (false) {
                        _context4.next = 9;
                        break;
                    }

                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_26" /* GET_HIRE_ORDERS */].REQUEST);

                case 3:
                    _ref2 = _context4.sent;
                    filter = _ref2.filter;
                    _context4.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(getRequestsHire, filter);

                case 7:
                    _context4.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function deleteRequestHire(hireId) {
    var response;
    return regeneratorRuntime.wrap(function deleteRequestHire$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].deleteRequestHire, hireId);

                case 2:
                    response = _context5.sent;

                    if (!(response.status === 200)) {
                        _context5.next = 9;
                        break;
                    }

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["R" /* DELETE_HIRE_REQUEST */].SUCCESS,
                        hireId: hireId
                        // email: store.user.user.email,
                    });

                case 6:
                    _context5.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: response.data.message,
                            level: 'success',
                            _id: hireId,
                            autoDismiss: 2
                        }
                    });

                case 8:
                    return _context5.abrupt('return', response);

                case 9:
                    _context5.next = 11;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["R" /* DELETE_HIRE_REQUEST */].FAILURE,
                        hireId: hireId,
                        error: response.errors
                    });

                case 11:
                    _context5.next = 13;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: response.errors[0].messages[0],
                            level: 'error',
                            _id: hireId,
                            autoDismiss: 2
                        }
                    });

                case 13:
                    return _context5.abrupt('return', response);

                case 14:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function watchDeleteRequestHire() {
    var _ref3, hireId;

    return regeneratorRuntime.wrap(function watchDeleteRequestHire$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (false) {
                        _context6.next = 9;
                        break;
                    }

                    _context6.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* take */])(__WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["R" /* DELETE_HIRE_REQUEST */].REQUEST);

                case 3:
                    _ref3 = _context6.sent;
                    hireId = _ref3.hireId;
                    _context6.next = 7;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(deleteRequestHire, hireId);

                case 7:
                    _context6.next = 0;
                    break;

                case 9:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

var _default = [watchPostRequestHire, watchGetRequestsHire];
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(postRequestHire, 'postRequestHire', '/opt/atlassian/pipelines/agent/build/client/app/sagas/hires/requests.js');
    reactHotLoader.register(watchPostRequestHire, 'watchPostRequestHire', '/opt/atlassian/pipelines/agent/build/client/app/sagas/hires/requests.js');
    reactHotLoader.register(getRequestsHire, 'getRequestsHire', '/opt/atlassian/pipelines/agent/build/client/app/sagas/hires/requests.js');
    reactHotLoader.register(watchGetRequestsHire, 'watchGetRequestsHire', '/opt/atlassian/pipelines/agent/build/client/app/sagas/hires/requests.js');
    reactHotLoader.register(deleteRequestHire, 'deleteRequestHire', '/opt/atlassian/pipelines/agent/build/client/app/sagas/hires/requests.js');
    reactHotLoader.register(watchDeleteRequestHire, 'watchDeleteRequestHire', '/opt/atlassian/pipelines/agent/build/client/app/sagas/hires/requests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/sagas/hires/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_user__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_subscribers__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__usersLimitations__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cargoes_assigners__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cargoes_gazetters__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cargoes_types__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cargoes_duplicates__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cargoes_ldRates__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__letters__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cargoes_realNames__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cargoes_names__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__letter__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__termEntities__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__annotations__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__gazetters__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__listGazetters__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__preferences_index__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cargoes_ordersNew__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__cargoes_requests__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__regions_ports__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__regions_port__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__regions_areas__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__contracts__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__vessels_orders__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__vessels_requests__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__vessels_claims__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__vessels_vessels__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__vessels_vessel__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__vessels_size__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__vessels_sales__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__notifications_backendNotifications__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__notifications_notifications__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__countries__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__companies__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__realCompanies__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__statistics_users__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__statistics_emails__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__statistics_monitor__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__statistics_vesselPositions__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__statistics_cargoRequests__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__integrators_integrators__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__integrators_companies__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__integrators_user__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__train__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__sender_senderList__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__sender_sender__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__domains__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__reqLDRates__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__tc_orders__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__tc_requests__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__analytics_linksList__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__flagCompliance__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__tc_indexes__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__cargoes_tags__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__issues_issues__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__issues_issue__ = __webpack_require__(1712);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

























// import cargoOrders from './cargoes/orders';























































var _default = Object(__WEBPACK_IMPORTED_MODULE_2_redux__["combineReducers"])({
    routing: __WEBPACK_IMPORTED_MODULE_0_react_router_redux__["routerReducer"],
    form: __WEBPACK_IMPORTED_MODULE_1_redux_form__["f" /* reducer */],
    user: __WEBPACK_IMPORTED_MODULE_3__users_user__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_4__users__["a" /* default */],
    letters: __WEBPACK_IMPORTED_MODULE_12__letters__["a" /* default */],
    cargoAssigners: __WEBPACK_IMPORTED_MODULE_7__cargoes_assigners__["a" /* default */],
    cargoGazetters: __WEBPACK_IMPORTED_MODULE_8__cargoes_gazetters__["a" /* default */],
    cargoTypes: __WEBPACK_IMPORTED_MODULE_9__cargoes_types__["a" /* default */],
    cargoDuplicates: __WEBPACK_IMPORTED_MODULE_10__cargoes_duplicates__["a" /* default */],
    ldRates: __WEBPACK_IMPORTED_MODULE_11__cargoes_ldRates__["a" /* default */],
    letter: __WEBPACK_IMPORTED_MODULE_15__letter__["a" /* default */],
    cargoRealNames: __WEBPACK_IMPORTED_MODULE_13__cargoes_realNames__["a" /* default */],
    cargoesNames: __WEBPACK_IMPORTED_MODULE_14__cargoes_names__["a" /* default */],
    termEntities: __WEBPACK_IMPORTED_MODULE_16__termEntities__["a" /* default */],
    annotations: __WEBPACK_IMPORTED_MODULE_17__annotations__["a" /* default */],
    cargoOrders: __WEBPACK_IMPORTED_MODULE_21__cargoes_ordersNew__["a" /* default */],
    ports: __WEBPACK_IMPORTED_MODULE_23__regions_ports__["a" /* default */],
    port: __WEBPACK_IMPORTED_MODULE_24__regions_port__["a" /* default */],
    areas: __WEBPACK_IMPORTED_MODULE_25__regions_areas__["a" /* default */],
    cargoRequests: __WEBPACK_IMPORTED_MODULE_22__cargoes_requests__["a" /* default */],
    contracts: __WEBPACK_IMPORTED_MODULE_26__contracts__["a" /* default */],
    gazetters: __WEBPACK_IMPORTED_MODULE_18__gazetters__["a" /* default */],
    listGazetters: __WEBPACK_IMPORTED_MODULE_19__listGazetters__["a" /* default */],

    preferences: __WEBPACK_IMPORTED_MODULE_20__preferences_index__["a" /* default */],

    vesselSales: __WEBPACK_IMPORTED_MODULE_33__vessels_sales__["a" /* default */],
    vesselOrders: __WEBPACK_IMPORTED_MODULE_27__vessels_orders__["a" /* default */],
    vesselSizes: __WEBPACK_IMPORTED_MODULE_32__vessels_size__["a" /* default */],
    vesselRequests: __WEBPACK_IMPORTED_MODULE_28__vessels_requests__["a" /* default */],
    vesselClaims: __WEBPACK_IMPORTED_MODULE_29__vessels_claims__["a" /* default */],
    vessels: __WEBPACK_IMPORTED_MODULE_30__vessels_vessels__["a" /* default */],
    vessel: __WEBPACK_IMPORTED_MODULE_31__vessels_vessel__["a" /* default */],

    backendNotifications: __WEBPACK_IMPORTED_MODULE_34__notifications_backendNotifications__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_35__notifications_notifications__["a" /* default */],

    countries: __WEBPACK_IMPORTED_MODULE_36__countries__["a" /* default */],
    companies: __WEBPACK_IMPORTED_MODULE_37__companies__["a" /* default */],
    realCompanies: __WEBPACK_IMPORTED_MODULE_38__realCompanies__["a" /* default */],

    statisticsUsers: __WEBPACK_IMPORTED_MODULE_39__statistics_users__["a" /* default */],
    statisticsEmails: __WEBPACK_IMPORTED_MODULE_40__statistics_emails__["a" /* default */],
    statisticsMonitor: __WEBPACK_IMPORTED_MODULE_41__statistics_monitor__["a" /* default */],
    statisticsVesselPositions: __WEBPACK_IMPORTED_MODULE_42__statistics_vesselPositions__["a" /* default */],
    statisticsCargoRequests: __WEBPACK_IMPORTED_MODULE_43__statistics_cargoRequests__["a" /* default */],

    usersLimitations: __WEBPACK_IMPORTED_MODULE_6__usersLimitations__["a" /* default */],
    train: __WEBPACK_IMPORTED_MODULE_47__train__["a" /* default */],

    senderList: __WEBPACK_IMPORTED_MODULE_48__sender_senderList__["a" /* default */],
    sender: __WEBPACK_IMPORTED_MODULE_49__sender_sender__["a" /* default */],

    domains: __WEBPACK_IMPORTED_MODULE_50__domains__["a" /* default */],
    subscribers: __WEBPACK_IMPORTED_MODULE_5__users_subscribers__["a" /* default */],

    reqLDRates: __WEBPACK_IMPORTED_MODULE_51__reqLDRates__["a" /* default */],
    integrators: __WEBPACK_IMPORTED_MODULE_44__integrators_integrators__["a" /* default */],
    integratorCompanies: __WEBPACK_IMPORTED_MODULE_45__integrators_companies__["a" /* default */],
    companyUser: __WEBPACK_IMPORTED_MODULE_46__integrators_user__["a" /* default */],
    tcOrders: __WEBPACK_IMPORTED_MODULE_52__tc_orders__["a" /* default */],
    tcRequests: __WEBPACK_IMPORTED_MODULE_53__tc_requests__["a" /* default */],
    linksList: __WEBPACK_IMPORTED_MODULE_54__analytics_linksList__["a" /* default */],

    flagCompliance: __WEBPACK_IMPORTED_MODULE_55__flagCompliance__["a" /* default */],
    tcIndexes: __WEBPACK_IMPORTED_MODULE_56__tc_indexes__["a" /* default */],

    cargoTagsCategories: __WEBPACK_IMPORTED_MODULE_57__cargoes_tags__["a" /* default */],

    issues: __WEBPACK_IMPORTED_MODULE_58__issues_issues__["a" /* default */],
    issue: __WEBPACK_IMPORTED_MODULE_59__issues_issue__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["a" /* polyfill */])(Form);
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormName);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(260);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormSection);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPropTypes */
/* unused harmony export fieldInputPropTypes */
/* unused harmony export fieldMetaPropTypes */
/* unused harmony export fieldArrayMetaPropTypes */
/* unused harmony export fieldArrayFieldsPropTypes */
/* unused harmony export fieldPropTypes */
/* unused harmony export fieldArrayPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (formPropTypes);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(43);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["a" /* polyfill */])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(704);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(703);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(325);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(1488);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(472);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(474);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(1499);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(327);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(708);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1494);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(123);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(327);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(327);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(327);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(329);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(329);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(329);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(329);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(330);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(330);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(330);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(330);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(326);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(325);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(334);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(328);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(472);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(1521);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(1526);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(1528);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(476);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(113);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(1533);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(181);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(181);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(622);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(624);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(123);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(123);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(123);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(123);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(325);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(260);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["a" /* polyfill */])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(702);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(260);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["a" /* polyfill */])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(43);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(476);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(1564);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(720);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(331);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(476);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(262);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(721);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1563);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(262);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(262);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(721);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(260);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(331);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(334);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(723);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(482);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(1637);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["a" /* polyfill */])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(1623);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(725);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(1618);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(123);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(1614);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(712);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(335);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(157);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(181);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(726);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(336);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(261);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(1622);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(1631);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(1627);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(1626);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(1630);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(481);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(157);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(727);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(43);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(700);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(43);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(325);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(43);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var user = function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        user: {},
        isLogged: false,
        message: ''
    };
    var action = arguments[1];

    switch (action.type) {
        /* AUTH USER ----------------------- */
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["m" /* AUTH_USER */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["m" /* AUTH_USER */].SUCCESS:
            return _extends({}, state, {
                user: action.data,
                isLogged: true,
                message: ''
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["m" /* AUTH_USER */].FAILURE:
            return _extends({}, state, {
                user: {},
                isLogged: false,
                message: action.message
            });
        /* GET USER ----------------------- */
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_54" /* GET_USER */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_54" /* GET_USER */].SUCCESS:
            return _extends({}, state, {
                user: action.data,
                isLogged: true,
                message: ''
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_54" /* GET_USER */].FAILURE:
            return _extends({}, state, {
                user: {},
                isLogged: false,
                message: action.message
            });
        /* LOGOUT USER ----------------------- */
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_66" /* LOGOUT_USER */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_66" /* LOGOUT_USER */].SUCCESS:
            return {
                user: {},
                isLogged: false,
                message: ''
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_66" /* LOGOUT_USER */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = user;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(user, 'user', '/opt/atlassian/pipelines/agent/build/client/app/reducers/users/user.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/users/user.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var user = function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isLoaded: false,
        isDataFromAutoComplete: false,
        data: []
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_117" /* TOGGLE_WHITE_LIST */].SUCCESS:
            {
                var data = state.data;


                data.forEach(function (user) {
                    if (user._id === action.user._id) {
                        if (user._id === action.user._id) {
                            if (user.limitations) {
                                user.limitations.whiteActive = action.whiteActive;
                            } else {
                                user.limitations = {
                                    black: [],
                                    white: [],
                                    whiteActive: action.whiteActive
                                };
                            }
                        }
                    }
                });

                return _extends({}, state, {
                    data: data
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_116" /* SET_USER_TO_WHITE_LIST */].SUCCESS:
            {
                var _data = state.data;


                _data.forEach(function (user) {
                    if (user._id === action.user._id) {
                        if (user._id === action.user._id) {
                            if (user.limitations) {
                                user.limitations.white = action.emails.map(function (email) {
                                    return {
                                        email: email
                                    };
                                });
                            } else {
                                user.limitations = {
                                    black: [],
                                    white: action.emails.map(function (email) {
                                        return {
                                            email: email
                                        };
                                    })
                                };
                            }
                        }
                    }
                });

                return _extends({}, state, {
                    data: _data
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_115" /* SET_USER_TO_BLACK_LIST */].SUCCESS:
            {
                var _data2 = state.data;


                _data2.forEach(function (user) {
                    if (user._id === action.user._id) {
                        if (user.limitations) {
                            user.limitations.black = action.emails.map(function (email) {
                                return {
                                    email: email
                                };
                            });
                        } else {
                            user.limitations = {
                                white: [],
                                black: action.emails.map(function (email) {
                                    return {
                                        email: email
                                    };
                                })
                            };
                        }
                    }
                });

                return _extends({}, state, {
                    data: _data2
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["g" /* ADD_USERS_FROM_AUTOCOMPLETE */]:
            return _extends({}, action.users, {
                isLoaded: true,
                isDataFromAutoComplete: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_56" /* GET_USER_LIST */].REQUEST:
            return _extends({}, state, {
                isDataFromAutoComplete: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_56" /* GET_USER_LIST */].SUCCESS:
            return _extends({}, state, action.data, {
                isLoaded: true,
                isDataFromAutoComplete: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_56" /* GET_USER_LIST */].FAILURE:
            return _extends({}, state, {
                isLoaded: false,
                isDataFromAutoComplete: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["n" /* BAN_USER_BY_ID */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["n" /* BAN_USER_BY_ID */].SUCCESS:
            {
                var _data3 = state.data.map(function (item) {
                    if (item._id === action.data._id) {
                        return _extends({}, action.data, {
                            banAt: new Date()
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data3
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["n" /* BAN_USER_BY_ID */].FAILURE:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_118" /* UNBAN_USER_BY_ID */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_118" /* UNBAN_USER_BY_ID */].SUCCESS:
            {
                var _data4 = state.data.map(function (item) {
                    if (item._id === action.data._id) {
                        return _extends({}, action.data, {
                            banAt: ''
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data4
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_118" /* UNBAN_USER_BY_ID */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = user;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(user, 'user', '/opt/atlassian/pipelines/agent/build/client/app/reducers/users/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/users/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var initState = {
    loading: false,
    page: 1,
    next: 2,
    previous: 1,
    limit: 25,
    sortField: 'addedAt',
    sortValue: -1,
    filters: {
        search: ''
    },
    data: []
};

var subscribers = function subscribers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].REQUEST:
            return _extends({}, state, action.pagination, {
                loading: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    loading: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].FAILURE:
            return _extends({}, state, action.data, {
                loading: true
            });

        default:
            return state;
    }
};

var _default = subscribers;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(initState, 'initState', '/opt/atlassian/pipelines/agent/build/client/app/reducers/users/subscribers.js');
    reactHotLoader.register(subscribers, 'subscribers', '/opt/atlassian/pipelines/agent/build/client/app/reducers/users/subscribers.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/users/subscribers.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var userLimitations = function userLimitations() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isLoaded: false,
        items: []
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_55" /* GET_USER_LIMITATIONS_LIST */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_55" /* GET_USER_LIMITATIONS_LIST */].SUCCESS:
            return {
                items: action.data,
                isLoaded: true
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_55" /* GET_USER_LIMITATIONS_LIST */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        default:
            return state;
    }
};

var _default = userLimitations;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(userLimitations, 'userLimitations', '/opt/atlassian/pipelines/agent/build/client/app/reducers/usersLimitations.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/usersLimitations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var cargoAssigners = function cargoAssigners() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        errors: [],
        isLoaded: false,
        searchText: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].REQUEST:
            return _extends({}, state, {
                items: [],
                errors: [],
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].SUCCESS:
            {
                var items = action.data.map(function (item) {
                    return _extends({}, item, {
                        prevState: item,
                        isUpdate: false,
                        isSuggest: false
                    });
                });

                return _extends({}, state, {
                    items: items,
                    errors: [],
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_11" /* GET_CARGO_ASSIGNERS */].FAILURE:
            return _extends({}, state, {
                errors: action.errors,
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].SUCCESS:
            {
                var _items = action.data.map(function (item) {
                    return _extends({}, item, {
                        prevState: item,
                        isUpdate: false,
                        isSuggest: false
                    });
                });

                return _extends({}, state, {
                    items: _items,
                    errors: [],
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_12" /* GET_CARGO_ASSIGNERS_POST */].FAILURE:
            return _extends({}, state, {
                errors: action.errors,
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_123" /* UPDATE_CARGO_ASSIGNER */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_123" /* UPDATE_CARGO_ASSIGNER */].SUCCESS:
            {
                var _items2 = state.items;


                _items2 = _items2.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            isUpdate: false,
                            isSuggest: false,
                            lastModify: {
                                date: action.item.lastModify.date,
                                user: action.item.lastModify.user
                            },
                            prevState: action.item
                        });
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _items2
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_123" /* UPDATE_CARGO_ASSIGNER */].FAILURE:
            {
                var _items3 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            isUpdate: true,
                            isSuggest: false
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items3
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_99" /* SAVE_STATUS_CARGO_ASSIGNER */]:
            {
                var _items4 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            isUpdate: action.item.isUpdate,
                            isSuggest: action.item.isSuggest
                        });
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _items4
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_104" /* SEARCH_CARGO_ASSIGNERS */]:
            return _extends({}, state, {
                searchText: action.search
            });

        default:
            return state;
    }
};

var _default = cargoAssigners;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoAssigners, 'cargoAssigners', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/assigners.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/assigners.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var cargoGazetters = function cargoGazetters() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        errors: [],
        isLoaded: false,
        search: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].REQUEST:
            return _extends({}, state, {
                items: [],
                errors: [],
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].SUCCESS:
            {
                var items = action.data.items.map(function (item) {
                    return _extends({}, item, {
                        prevState: item,
                        isUpdate: false
                    });
                });

                return _extends({}, state, action.data, {
                    items: items,
                    errors: [],
                    isLoaded: true

                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].FAILURE:
            return _extends({}, state, {
                errors: action.errors,
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["M" /* DELETE_CARGO_GAZETTER */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["M" /* DELETE_CARGO_GAZETTER */].SUCCESS:
            {
                var _items = state.items.filter(function (item) {
                    return !(item._id === action.item._id);
                });

                return _extends({}, state, {
                    items: _items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["M" /* DELETE_CARGO_GAZETTER */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = cargoGazetters;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoGazetters, 'cargoGazetters', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/gazetters.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/gazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var cargoTypes = function cargoTypes() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_20" /* GET_CARGO_TYPES */].REQUEST:
            return [].concat(_toConsumableArray(state));
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_20" /* GET_CARGO_TYPES */].SUCCESS:
            return [].concat(_toConsumableArray(action.data));
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_20" /* GET_CARGO_TYPES */].FAILURE:
            return [].concat(_toConsumableArray(state));
        default:
            return state;
    }
};

var _default = cargoTypes;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoTypes, 'cargoTypes', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/types.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/types.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var cargoDuplicates = function cargoDuplicates() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_13" /* GET_CARGO_DUPLICATES */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_13" /* GET_CARGO_DUPLICATES */].SUCCESS:
            var items = action.data.map(function (item) {
                return _extends({}, item, {
                    errors: []
                });
            });

            return _extends({}, state, {
                isLoaded: true,
                items: items
            });
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_13" /* GET_CARGO_DUPLICATES */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["L" /* DELETE_CARGO_DUPLICATE */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["L" /* DELETE_CARGO_DUPLICATE */].SUCCESS:
            {
                var entities = [];

                var findItem = state.items.find(function (item, i) {
                    var stateItem = item;

                    if (stateItem._id === action.item.name) {
                        stateItem.index = i;
                        return stateItem;
                    }

                    return false;
                });

                if (findItem.entities.length === 1 || findItem.entities.length === 2) {
                    state.items.splice(findItem.index, 1);
                    return _extends({}, state, {
                        items: state.items.slice()
                    });
                }

                if (findItem.entities.length > 2) {
                    entities = findItem.entities.filter(function (entity) {
                        return entity._id !== action.item.id;
                    });

                    state.items[findItem.index].entities = entities;

                    return _extends({}, state, {
                        items: state.items.slice()
                    });
                }

                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["L" /* DELETE_CARGO_DUPLICATE */].FAILURE:
            {
                var _items = state.items.map(function (item) {
                    if (action.item.name === item._id) {
                        return _extends({}, item, {
                            errors: action.errors
                        });
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _items
                });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_105" /* SEARCH_CARGO_DUPLICATES */]:
            return _extends({}, state, {
                searchText: action.search
            });

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["r" /* CLEAR_DUPLICATES */]:
            return _extends({}, state, {
                items: [],
                isLoaded: false
            });
        default:
            return state;
    }
};

var _default = cargoDuplicates;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoDuplicates, 'cargoDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/duplicates.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/duplicates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var ldRates = function ldRates() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_34" /* GET_LOADING_AND_DISCHARGING */].REQUEST:
            return _extends({}, state, {
                items: [],
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_34" /* GET_LOADING_AND_DISCHARGING */].SUCCESS:
            {
                var items = action.data.map(function (item) {
                    return _extends({}, item, {
                        isUpdate: false,
                        prevState: item
                    });
                });

                return _extends({}, state, {
                    items: items,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_34" /* GET_LOADING_AND_DISCHARGING */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_131" /* UPDATE_LOADING_AND_DISCHARGING */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_131" /* UPDATE_LOADING_AND_DISCHARGING */].SUCCESS:
            {
                var _items = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, action.item, {
                            prevState: action.item,
                            isUpdate: false
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_131" /* UPDATE_LOADING_AND_DISCHARGING */].FAILURE:
            {
                var _items2 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            isUpdate: true
                        });
                    }
                    return item;
                });

                return _extends({}, state, { items: _items2 });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["T" /* DELETE_LOADING_AND_DISCHARGING */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["T" /* DELETE_LOADING_AND_DISCHARGING */].SUCCESS:
            {
                var _items3 = state.items.filter(function (item) {
                    return !(action.item._id === item._id);
                });

                return _extends({}, state, {
                    items: _items3
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["T" /* DELETE_LOADING_AND_DISCHARGING */].FAILURE:
            {
                var _items4 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item);
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items4
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_101" /* SAVE_STATUS_LOADING_AND_DISCHARGING */]:
            {
                var _items5 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, action.item, {
                            prevState: item.prevState,
                            isUpdate: true
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items5
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_107" /* SEARCH_LOADING_AND_DISCHARGING */]:
            return _extends({}, state, {
                searchText: action.search
            });

        default:
            return state;
    }
};

var _default = ldRates;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ldRates, 'ldRates', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/ldRates.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/ldRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var letters = function letters() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { pagination: {} };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_32" /* GET_LETTERS */]:
            return _extends({}, state, action.data);
        default:
            return state;
    }
};

var _default = letters;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(letters, 'letters', '/opt/atlassian/pipelines/agent/build/client/app/reducers/letters.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/letters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var cargoRealNames = function cargoRealNames() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_16" /* GET_CARGO_REAL_NAMES */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_16" /* GET_CARGO_REAL_NAMES */].SUCCESS:
            {
                var _items = action.data.map(function (item) {
                    return _extends({}, item, {
                        prevState: item,
                        isUpdate: false
                    });
                });
                return _extends({}, state, {
                    items: _items,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_16" /* GET_CARGO_REAL_NAMES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_17" /* GET_CARGO_REAL_NAMES_PAGINATED */].REQUEST:
            return _extends({}, state, {
                items: [],
                errors: [],
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_17" /* GET_CARGO_REAL_NAMES_PAGINATED */].SUCCESS:
            {
                var _items2 = action.data.items.map(function (item) {
                    return _extends({}, item, {
                        prevState: item,
                        isUpdate: false
                    });
                });

                var categories = action.data.categories;

                return _extends({}, state, action.data, {
                    errors: [],
                    items: _items2,
                    isLoaded: true,
                    categories: categories
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_17" /* GET_CARGO_REAL_NAMES_PAGINATED */].FAILURE:
            return _extends({}, state, {
                errors: action.errors,
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["N" /* DELETE_CARGO_REAL_NAME */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["N" /* DELETE_CARGO_REAL_NAME */].SUCCESS:
            {
                var _items3 = state.items.filter(function (item) {
                    return !(item._id === action.item._id);
                });

                return _extends({}, state, {
                    items: _items3
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["N" /* DELETE_CARGO_REAL_NAME */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_126" /* UPDATE_CARGO_REAL_NAME */].REQUEST:
            var items = state.items.map(function (item) {
                if (action.item._id === item._id) {
                    return _extends({}, item, {
                        isUpdate: false,
                        prevState: item
                    });
                }

                return item;
            });

            return _extends({}, state, {
                items: items
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_126" /* UPDATE_CARGO_REAL_NAME */].SUCCESS:
            {
                var names = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            isUpdate: false
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: names
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_126" /* UPDATE_CARGO_REAL_NAME */].FAILURE:
            {
                var _names = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            errors: action.errors,
                            isUpdate: true
                        });
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _names
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_100" /* SAVE_STATUS_CARGO_REAL_NAME */]:
            {
                var _names2 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return action.item;
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _names2
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["u" /* CLEAR_STATUS_CARGO_REAL_NAME */]:
            {
                var _names3 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            prevState: action.item
                        });
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _names3
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_106" /* SEARCH_CARGO_REAL_NAMES */]:
            return _extends({}, state, {
                searchText: action.search
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_138" /* UPDATE_TAGS_DATA_IN_ROW */]:
            var index = state.items.findIndex(function (item) {
                return item._id === action._id;
            });
            state.items[index].tags = action.tags || [];
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = cargoRealNames;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoRealNames, 'cargoRealNames', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/realNames.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/realNames.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var cargoNames = function cargoNames() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_10" /* GET_CARGOES_BY_TYPE_NAME */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_10" /* GET_CARGOES_BY_TYPE_NAME */].SUCCESS:
            {
                var data = action.data.map(function (item) {
                    return _extends({}, item, {
                        prevState: item,
                        isUpdate: false
                    });
                });
                return _extends({}, state, {
                    items: data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_10" /* GET_CARGOES_BY_TYPE_NAME */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = cargoNames;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoNames, 'cargoNames', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/names.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/names.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var letter = function letter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_89" /* REMOVE_LETTER */]:
            return {
                isLoaded: false
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_31" /* GET_LETTER */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_31" /* GET_LETTER */].SUCCESS:
            return _extends({}, action.data, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_31" /* GET_LETTER */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_130" /* UPDATE_LETTER */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_130" /* UPDATE_LETTER */].SUCCESS:
            {
                return _extends({}, action.data);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_130" /* UPDATE_LETTER */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = letter;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(letter, 'letter', '/opt/atlassian/pipelines/agent/build/client/app/reducers/letter.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/letter.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var termEntities = function termEntities() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].REQUEST:
            return state;
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].SUCCESS:
            return _extends({}, action.data);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_52" /* GET_TERM_ENTITIES */].FAILURE:
            return state;

        default:
            return state;
    }
};

var _default = termEntities;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(termEntities, 'termEntities', '/opt/atlassian/pipelines/agent/build/client/app/reducers/termEntities.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/termEntities.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var annotations = function annotations() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { headers: {}, items: [], isLoaded: false };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_81" /* REMOVE_ANNOTATIONS */]:
            {
                return _extends({}, state, {
                    items: [],
                    headers: {}
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_68" /* POST_ANNOTATIONS */].REQUEST:
            return _extends({}, state, {
                items: [],
                headers: {},
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_68" /* POST_ANNOTATIONS */].SUCCESS:
            var items = action.data.map(function (item) {
                return _extends({}, item, {
                    styles: {
                        background: ''
                    }
                });
            });

            return _extends({}, state, {
                items: items,
                headers: action.headers,
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_68" /* POST_ANNOTATIONS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true,
                headers: {}
            });

        default:
            return state;
    }
};

var _default = annotations;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(annotations, 'annotations', '/opt/atlassian/pipelines/agent/build/client/app/reducers/annotations.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/annotations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var gazetters = function gazetters() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [], isLoaded: false, isError: false, error: {}
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_81" /* REMOVE_ANNOTATIONS */]:
            {
                return _extends({}, state, {
                    items: [],
                    isLoaded: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_83" /* REMOVE_GAZETTERS */]:
            {
                return _extends({}, state, {
                    items: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_70" /* POST_GAZETTERS */].REQUEST:
            return _extends({}, state, {
                items: []
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_70" /* POST_GAZETTERS */].SUCCESS:
            return _extends({}, state, {
                items: action.data.map(function (gazetter, key) {
                    return _extends({}, gazetter, {
                        id: key,
                        state: ''
                    });
                }),
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_70" /* POST_GAZETTERS */].FAILURE:
            return _extends({}, state, {
                error: action.error,
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].SUCCESS:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].FAILURE:
            return _extends({}, state, {
                error: action.error
            });

        default:
            return state;
    }
};

var _default = gazetters;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(gazetters, 'gazetters', '/opt/atlassian/pipelines/agent/build/client/app/reducers/gazetters.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/gazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var listGazetters = function listGazetters() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        originalList: [],
        filteredList: []
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_65" /* LIST_GAZETTERS */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_65" /* LIST_GAZETTERS */].SUCCESS:
            return {
                filteredList: action.data
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_65" /* LIST_GAZETTERS */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = listGazetters;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(listGazetters, 'listGazetters', '/opt/atlassian/pipelines/agent/build/client/app/reducers/listGazetters.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/listGazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var preferences = function preferences() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        selected: {},
        isLoaded: false
    };
    var action = arguments[1];


    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_38" /* GET_PREFERENCE */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_38" /* GET_PREFERENCE */].SUCCESS:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_38" /* GET_PREFERENCE */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_39" /* GET_PREFERENCES */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_39" /* GET_PREFERENCES */].SUCCESS:
            return _extends({}, state, {
                isLoaded: true,
                items: action.data
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_39" /* GET_PREFERENCES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_137" /* UPDATE_PREFERENCE_META */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_137" /* UPDATE_PREFERENCE_META */].SUCCESS:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_137" /* UPDATE_PREFERENCE_META */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["W" /* DELETE_PREFERENCE */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["W" /* DELETE_PREFERENCE */].SUCCESS:
            return {
                selected: {},
                items: state.items.filter(function (item) {
                    return item._id !== action.data._id;
                })
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["W" /* DELETE_PREFERENCE */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["p" /* CHANGE_PREFERENCE */]:
            {
                return _extends({}, state, {
                    selected: _extends({}, state.selected, {
                        shared: typeof action.data.shared !== 'undefined' ? action.data.shared : state.selected.shared,
                        filter: _extends({}, state.selected.filter, {
                            levelList: action.data.levelList,
                            selectedType: action.data.selectedType
                        })
                    })
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["t" /* CLEAR_SELECT_PREFERENCE */]:
            {
                return _extends({}, state, {
                    selected: {}
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_112" /* SELECT_PREFERENCE */]:
            {
                return _extends({}, state, {
                    selected: state.items.find(function (item) {
                        return item._id === action.data._id;
                    })
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["D" /* CREATE_FILTER_ANNOTATIONS_PREFERENCE */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["D" /* CREATE_FILTER_ANNOTATIONS_PREFERENCE */].SUCCESS:
            var items = state.items;


            items.push(action.data);

            return {
                selected: action.data,
                items: items
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["D" /* CREATE_FILTER_ANNOTATIONS_PREFERENCE */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_136" /* UPDATE_PREFERENCE */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_136" /* UPDATE_PREFERENCE */].SUCCESS:
            return _extends({}, state, {
                items: state.items.map(function (item) {
                    if (item._id === action.data._id) {
                        return action.data;
                    }

                    return item;
                })
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_136" /* UPDATE_PREFERENCE */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_132" /* UPDATE_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_132" /* UPDATE_MAIL_RECOGNIZE_SPAM_LIST */].SUCCESS:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_132" /* UPDATE_MAIL_RECOGNIZE_SPAM_LIST */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_35" /* GET_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_35" /* GET_MAIL_RECOGNIZE_SPAM_LIST */].SUCCESS:
            return _extends({}, state, {
                items: [action.data],
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_35" /* GET_MAIL_RECOGNIZE_SPAM_LIST */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["E" /* CREATE_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["E" /* CREATE_MAIL_RECOGNIZE_SPAM_LIST */].SUCCESS:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["E" /* CREATE_MAIL_RECOGNIZE_SPAM_LIST */].FAILURE:
            return _extends({}, state);

        default:
            return state;
    }
};

var _default = preferences;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(preferences, 'preferences', '/opt/atlassian/pipelines/agent/build/client/app/reducers/preferences/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/preferences/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var cargoOrders = function cargoOrders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        user: {
            email: '',
            company: '',
            name: '',
            surname: '',
            phones: [{
                code: '',
                phone: ''
            }]
        }
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_76" /* REMOVE_ALL_CARGO_ORDERS */]:
            {
                return _extends({}, state, {
                    items: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_125" /* UPDATE_CARGO_ORDER_USER */]:
            {
                var newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                newState.user = action.user;
                return newState;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["C" /* CREATE_CARGO_ORDERS */]:
            {
                var _newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState.items = action.items;
                _newState.user = Object.assign({}, _newState.user, action.user);
                return _newState;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_15" /* GET_CARGO_ORDERS */]:
            return state;
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_124" /* UPDATE_CARGO_ORDER */]:
            {
                var _newState2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState2.items[action.numberOrder] = action.newCargoOrder;
                return _newState2;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_84" /* REMOVE_LAST_CARGO_ORDER */]:
            {
                var _newState3 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState3.items.splice(-1, 1);
                return _newState3;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_91" /* RESET_CARGO_ORDERS */]:
            {
                var _newState4 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState4.items = [__WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__["a" /* orderNew */]];
                return _newState4;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["b" /* ADD_CARGO_ORDER */]:
            {
                var _newState5 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                var cloneMockOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_cargo_orderNew__["a" /* orderNew */]);

                cloneMockOrder.loadingPorts[0].cancellingDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('MM-DD-YYYY');
                cloneMockOrder.loadingPorts[0].readinessDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('MM-DD-YYYY');
                cloneMockOrder.cancellingDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('MM-DD-YYYY');
                cloneMockOrder.readinessDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('MM-DD-YYYY');

                _newState5.items.push(_extends({}, cloneMockOrder));
                return _newState5;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].REQUEST:
            {
                var _newState6 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState6.items.forEach(function (item) {
                    item.validateErrors = [];
                });
                return _newState6;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].FAILURE:
            {
                var _newState7 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                var cargoRequest = _newState7.items[action.cargoRequest.keyCargoOrder];
                cargoRequest.validateErrors = action.errors;
                return _newState7;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].SUCCESS:
            {
                var _newState8 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                var _cargoRequest = _newState8.items[action.cargoRequest.keyCargoOrder];
                _cargoRequest.successMessage = action.message;
                return _newState8;
            }

        default:
            return state;
    }
};

var _default = cargoOrders;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoOrders, 'cargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/ordersNew.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/ordersNew.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



// todo data - rename to items !!! in react components to!
var cargoRequests = function cargoRequests() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        data: [],
        isLoaded: false,
        isError: false,
        error: {}
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_18" /* GET_CARGO_REQUESTS */].REQUEST:
            return _extends({}, state, {
                data: [],
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_18" /* GET_CARGO_REQUESTS */].SUCCESS:
            {
                var data = action.data.data.map(function (item) {
                    return _extends({}, item, {
                        isUpdate: false
                    });
                });

                return _extends({}, state, action.data, {
                    isLoaded: true,
                    data: data
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_18" /* GET_CARGO_REQUESTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["O" /* DELETE_CARGO_REQUEST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["O" /* DELETE_CARGO_REQUEST */].SUCCESS:
            {
                var newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);

                newState.data.forEach(function (item) {
                    // todo bad decision :(
                    if (item._id === action.cargoRequestId) {
                        item.deleteBy = { email: action.email };
                        item.deleteAt = new Date();
                    }
                });

                return newState;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["O" /* DELETE_CARGO_REQUEST */].FAILURE:
            {
                var _newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);

                _newState.data.forEach(function (item) {
                    if (item._id === action.cargoRequestId) {
                        item.errors = action.errors;
                    }
                });

                return _newState;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_127" /* UPDATE_CARGO_REQUEST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_127" /* UPDATE_CARGO_REQUEST */].SUCCESS:
            {
                var _newState2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);

                _newState2.data.forEach(function (item) {
                    if (item._id === action.cargoRequestId) {
                        item.isUpdate = false;
                    }
                });

                return _newState2;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_127" /* UPDATE_CARGO_REQUEST */].FAILURE:
            {
                var _newState3 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);

                _newState3.data.forEach(function (item) {
                    if (item._id === action.cargoRequestId) {
                        item.isUpdate = true;
                        item.errors = action.errors;
                    }
                });

                return _newState3;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].REQUEST:
            return _extends({}, state, {
                data: []
            });
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].SUCCESS:
            {
                var _data = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state.data);
                _data.push(action.cargoRequest);
                return _extends({}, state, {
                    data: _data
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_69" /* POST_CARGO_REQUEST */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = cargoRequests;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoRequests, 'cargoRequests', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/requests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var ports = function ports() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        suggestions: [],
        searchText: '',
        items: [],
        data: [],
        isLoaded: false,
        page: 1,
        onlyChanged: false,
        query: '',
        sort: 'name'
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_37" /* GET_PORTS */].REQUEST:
            return _extends({}, state, action.pagination, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_37" /* GET_PORTS */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    sort: 'name', // change field from backend wrong format
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_37" /* GET_PORTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_4" /* GET_ALL_PORTS */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_4" /* GET_ALL_PORTS */].SUCCESS:
            {
                var temp = new Set();

                var items = action.data.map(function (port) {
                    var latlng = port.coordinates;

                    if (latlng) {
                        var key = latlng[0] + '' + latlng[1];
                        if (temp.has(key)) {
                            var newLat = latlng[1] + (Math.random() - 0.5) / 1500;
                            var newLng = latlng[0] + (Math.random() - 0.5) / 1500;

                            port.coordinates = [newLng, newLat];
                        } else {
                            temp.add(key);
                        }
                    }

                    return _extends({}, port, {
                        isUpdate: false,
                        prevState: port
                    });
                });

                return _extends({}, state, {
                    items: items,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_4" /* GET_ALL_PORTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_108" /* SEARCH_PORT */]:
            return _extends({}, state, {
                searchText: action.search
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_98" /* SAVE_PORT */]:
            {
                var _items = state.items.map(function (item) {
                    if (item._id === action.item._id) {
                        return _extends({}, item, {
                            isUpdate: true
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_135" /* UPDATE_PORT_SUGGESTIONS */]:
            {
                return _extends({}, state, {
                    suggestions: action.suggestions
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_134" /* UPDATE_PORT_ALT */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_134" /* UPDATE_PORT_ALT */].SUCCESS:
            {
                var _items2 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, action.item, {
                            prevState: action.item,
                            isUpdate: false
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items2
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_134" /* UPDATE_PORT_ALT */].FAILURE:
            {
                var _items3 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            isUpdate: true,
                            errors: action.errors
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items3
                });
            }
        default:
            return state;
    }
};

var _default = ports;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ports, 'ports', '/opt/atlassian/pipelines/agent/build/client/app/reducers/regions/ports.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/regions/ports.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var initState = {
    firstLoad: false,
    name: '',
    unLoCode: '',
    alt: [],
    country: {
        _id: undefined,
        name: undefined
    },
    timezone: '',
    coordinates: [],
    site: '',
    parent: undefined,
    childs: [],
    area: undefined,
    areaParent: false,
    lastUpdate: {
        time: undefined
    },
    autoCreated: false,
    facilities: {
        breakBulk: undefined,
        dryBulk: undefined,
        dryDock: undefined,
        container: undefined,
        liquid: undefined,
        lpg: undefined,
        lng: undefined,
        roro: undefined,
        passenger: undefined,
        multipurpose: undefined
    },
    warehouses: {
        timber: undefined,
        grain: undefined,
        lpg: undefined,
        chemicals: undefined,
        dryBulk: undefined,
        liquid: undefined,
        general: undefined,
        reefer: undefined
    },
    portLimitations: {
        maxDraught: undefined,
        maxDWT: undefined,
        cargoPier: undefined,
        anchorageDepth: undefined,
        maxBeam: undefined,
        channelDepth: undefined,
        meanTide: undefined,
        maxLOA: undefined
    },
    liftsCranes: {
        '0-24': {
            checked: undefined,
            name: '0-24',
            label: '0-24 mt:',
            details: []
        },
        '25-49': {
            name: '25-49',
            label: '25-49 mt:',
            checked: undefined,
            details: []
        },
        '50-99': {
            name: '50-99',
            label: '50-99 mt:',
            checked: undefined,
            details: []
        },
        '100-149': {
            name: '100-149',
            label: '100-149 mt:',
            checked: undefined,
            details: []
        },
        '150+': {
            name: '150+',
            label: '150+ mt:',
            checked: undefined,
            details: []
        }
    },
    serviceProviders: [],
    additionalDescription: undefined
};

var port = function port() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["s" /* CLEAR_PORT */]:
            return initState;

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_36" /* GET_PORT */].REQUEST:
            return _extends({}, state, {
                firstLoad: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_36" /* GET_PORT */].SUCCESS:
            {
                if (action.data.serviceProviders && action.data.serviceProviders.length > 0) {
                    action.data.serviceProviders.forEach(function (serviceProvider) {
                        if (!serviceProvider.limitations || !serviceProvider.limitations.length) {
                            serviceProvider.limitations = [{
                                maxDraught: undefined,
                                maxBeam: undefined,
                                maxLOA: undefined,
                                maxDWT: undefined,
                                channelDepth: undefined,
                                anchorageDepth: undefined
                            }];
                        }
                    });
                }

                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge({}, state, action.data, { firstLoad: true });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_36" /* GET_PORT */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_133" /* UPDATE_PORT */].REQUEST:
            return _extends({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_133" /* UPDATE_PORT */].SUCCESS:
            {
                return _extends({}, state, action.data);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_133" /* UPDATE_PORT */].FAILURE:
            {
                return _extends({}, state);
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["d" /* ADD_NEW_PORT */].REQUEST:
            return _extends({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["d" /* ADD_NEW_PORT */].SUCCESS:
            {
                return _extends({}, state, action.data);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["d" /* ADD_NEW_PORT */].FAILURE:
            {
                return _extends({}, state);
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["o" /* CHANGE_PORT */]:
            {
                var _data = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(action.data);
                _data.serviceProviders && _data.serviceProviders.map(function (provider) {
                    if (!provider.activities.includes('Stevedoring Company')) {
                        provider.limitations = [];
                    }
                });

                return Object.assign({}, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_data));
            }

        default:
            return state;
    }
};

var _default = port;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(initState, 'initState', '/opt/atlassian/pipelines/agent/build/client/app/reducers/regions/port.js');
    reactHotLoader.register(port, 'port', '/opt/atlassian/pipelines/agent/build/client/app/reducers/regions/port.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/regions/port.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_difference__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_union__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_union__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var areas = function areas() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        suggestions: [],
        searchText: '',
        items: [],
        isLoaded: false,
        isUpdating: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_7" /* GET_AREAS */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_7" /* GET_AREAS */].SUCCESS:
            {
                var items = action.data.map(function (item) {
                    return _extends({}, item, {
                        isUpdate: false,
                        prevState: item
                    });
                });

                return _extends({}, state, {
                    items: items,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_7" /* GET_AREAS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_103" /* SEARCH_AREA */]:
            return _extends({}, state, {
                searchText: action.search
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_95" /* SAVE_AREA */]:
            {
                var _items = state.items.map(function (item) {
                    if (item._id === action.item._id) {
                        return _extends({}, item, {
                            isUpdate: true
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    items: _items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_121" /* UPDATE_AREA_SUGGESTIONS */]:
            {
                return _extends({}, state, {
                    suggestions: action.suggestions
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_120" /* UPDATE_AREA_ALT */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_120" /* UPDATE_AREA_ALT */].SUCCESS:
            {
                var _items2 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, action.item, {
                            prevState: action.item,
                            isUpdate: false
                        });
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _items2
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_120" /* UPDATE_AREA_ALT */].FAILURE:
            {
                var _items3 = state.items.map(function (item) {
                    if (action.item._id === item._id) {
                        return _extends({}, item, {
                            isUpdate: true,
                            errors: action.item.errors
                        });
                    }
                    return item;
                });

                return _extends({}, state, {
                    items: _items3
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_119" /* UPDATE_AREA */].REQUEST:
            {
                return _extends({}, state, {
                    isUpdating: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_119" /* UPDATE_AREA */].SUCCESS:
            {
                var oldItem = state.items.find(function (i) {
                    return i._id === action.item._id;
                });
                var newChilds = action.item.childs ? __WEBPACK_IMPORTED_MODULE_1_lodash_difference___default()(action.item.childs, oldItem.childs) : [];
                var removedChilds = action.item.childs ? __WEBPACK_IMPORTED_MODULE_1_lodash_difference___default()(oldItem.childs, action.item.childs) : [];
                var newParents = action.item.parents ? __WEBPACK_IMPORTED_MODULE_1_lodash_difference___default()(action.item.parents, oldItem.parents) : [];
                var removedParents = action.item.parents ? __WEBPACK_IMPORTED_MODULE_1_lodash_difference___default()(oldItem.parents, action.item.parents) : [];
                var _items4 = state.items.map(function (item) {
                    if (item._id === action.item._id) {
                        return _extends({}, item, action.item);
                    }
                    if (newChilds.includes(item._id)) {
                        // item is added to childs
                        return _extends({}, item, {
                            parents: __WEBPACK_IMPORTED_MODULE_2_lodash_union___default()(item.parents, [action.item._id])
                        });
                    }
                    if (removedChilds.includes(item._id)) {
                        // item is removed from childs
                        return _extends({}, item, {
                            parents: item.parents.filter(function (id) {
                                return id !== action.item._id;
                            })
                        });
                    }
                    if (newParents.includes(item._id)) {
                        // item is added to parents
                        return _extends({}, item, {
                            childs: __WEBPACK_IMPORTED_MODULE_2_lodash_union___default()(item.childs, [action.item._id])
                        });
                    }
                    if (removedParents.includes(item._id)) {
                        // item is removed from parents
                        return _extends({}, item, {
                            childs: item.childs.filter(function (id) {
                                return id !== action.item._id;
                            })
                        });
                    }
                    return item;
                });
                return _extends({}, state, {
                    items: _items4,
                    isUpdating: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_119" /* UPDATE_AREA */].FAILURE:
            {
                return _extends({}, state, {
                    isUpdating: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_82" /* REMOVE_AREA_CHILD */].REQUEST:
            {
                return _extends({}, state, {
                    isUpdating: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_82" /* REMOVE_AREA_CHILD */].FAILURE:
            {
                return _extends({}, state, {
                    isUpdating: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_82" /* REMOVE_AREA_CHILD */].SUCCESS:
            {
                var _items5 = state.items.map(function (item) {
                    if (item._id === action.parentId) {
                        return _extends({}, item, {
                            childs: item.childs.filter(function (id) {
                                return id !== action.childId;
                            }),
                            childAreaCount: item.childAreaCount - 1
                        });
                    }
                    if (item._id === action.childId) {
                        return _extends({}, item, {
                            parents: (item.parents || []).filter(function (id) {
                                return id !== action.parentId;
                            })
                        });
                    }
                    return item;
                });
                return _extends({}, state, {
                    items: _items5,
                    isUpdating: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["J" /* DELETE_AREA */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["J" /* DELETE_AREA */].SUCCESS:
            {
                var _items6 = state.items.filter(function (item) {
                    return item._id !== action.item._id;
                });

                return _extends({}, state, {
                    items: _items6
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["J" /* DELETE_AREA */].FAILURE:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["A" /* CREATE_AREA */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["A" /* CREATE_AREA */].SUCCESS:
            {
                var _items7 = state.items;

                _items7.push(action.item);

                return _extends({}, state, {
                    items: _items7
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["A" /* CREATE_AREA */].FAILURE:
            {
                return _extends({}, state);
            }
        default:
            return state;
    }
};

var _default = areas;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(areas, 'areas', '/opt/atlassian/pipelines/agent/build/client/app/reducers/regions/areas.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/regions/areas.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(484),
    baseFlatten = __webpack_require__(341),
    baseRest = __webpack_require__(136),
    isArrayLikeObject = __webpack_require__(265);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 1667 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1668 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1670),
    baseIsNaN = __webpack_require__(1671),
    strictIndexOf = __webpack_require__(1672);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1670 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1671 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1672 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223),
    isArguments = __webpack_require__(488),
    isArray = __webpack_require__(67);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(187),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(342);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1677),
    defineProperty = __webpack_require__(729),
    identity = __webpack_require__(264);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1677 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(733),
    noop = __webpack_require__(490),
    setToArray = __webpack_require__(343);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var contracts = function contracts() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_23" /* GET_CONTRACTS */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_23" /* GET_CONTRACTS */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_23" /* GET_CONTRACTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_53" /* GET_TIME_CONTRACTS */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_53" /* GET_TIME_CONTRACTS */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_53" /* GET_TIME_CONTRACTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = contracts;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(contracts, 'contracts', '/opt/atlassian/pipelines/agent/build/client/app/reducers/contracts.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/contracts.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mocks_vessel_order_json__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mocks_vessel_order_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mocks_vessel_order_json__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var vesselOrders = function vesselOrders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        user: {
            email: '',
            company: '',
            name: '',
            surname: '',
            phones: [{
                code: '',
                phone: ''
            }]
        }
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_78" /* REMOVE_ALL_VESSEL_ORDERS */]:
            {
                return _extends({}, state, {
                    items: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_144" /* UPDATE_VESSEL_ORDER_USER */]:
            {
                var newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                newState.user = _extends({}, action.user);
                return newState;
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["G" /* CREATE_VESSEL_ORDERS */]:
            {
                return _extends({}, state, {
                    items: action.items,
                    user: Object.assign({}, state.user, action.user)
                });
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_60" /* GET_VESSEL_ORDERS */]:
            return state;
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_143" /* UPDATE_VESSEL_ORDER */]:
            {
                var _newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState.items[action.numberOrder] = action.newVesselOrder;
                return _newState;
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_86" /* REMOVE_LAST_VESSEL_ORDER */]:
            {
                var _newState2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState2.items.splice(-1, 1);
                return _newState2;
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_93" /* RESET_VESSEL_ORDERS */]:
            {
                var _newState3 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState3.items = [__WEBPACK_IMPORTED_MODULE_3_mocks_vessel_order_json___default.a];
                return _newState3;
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["i" /* ADD_VESSEL_ORDER */]:
            {
                var _newState4 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                var cloneMockOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_3_mocks_vessel_order_json___default.a);

                cloneMockOrder.open[0].until = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('MM-DD-YYYY');
                cloneMockOrder.open[0].from = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('MM-DD-YYYY');

                _newState4.items.push(_extends({}, cloneMockOrder));
                return _newState4;
            }

        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].REQUEST:
            {
                var _newState5 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState5.items.forEach(function (item) {
                    item.validateErrors = [];
                });
                return _newState5;
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].FAILURE:
            {
                var _newState6 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                var cargoRequest = _newState6.items[action.vesselRequest.keyVesselOrder];
                cargoRequest.validateErrors = action.errors;
                return _newState6;
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].SUCCESS:
            {
                var _newState7 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                return _newState7;
            }
        case __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["x" /* CLEAR_VESSEL_ORDER_MESSAGE */]:
            {
                var _newState8 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                return _newState8;
            }

        default:
            return state;
    }
};

var _default = vesselOrders;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vesselOrders, 'vesselOrders', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/orders.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var vesselRequests = function vesselRequests() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        data: [],
        isLoaded: false,
        results: []
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_61" /* GET_VESSEL_REQUESTS */].REQUEST:
            return _extends({}, state, {
                data: []
            });
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_61" /* GET_VESSEL_REQUESTS */].SUCCESS:
            {
                var data = action.data.data.map(function (item) {
                    return _extends({}, item, {
                        isUpdate: false
                    });
                });

                return _extends({}, state, action.data, {
                    isLoaded: true,
                    data: data
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_61" /* GET_VESSEL_REQUESTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_0" /* DELETE_VESSEL_REQUEST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_0" /* DELETE_VESSEL_REQUEST */].SUCCESS:
            {
                var _data = state.data.map(function (item) {
                    if (item._id === action.vesselRequestId) {
                        return _extends({}, item, {
                            deleteBy: { email: action.email },
                            deleteAt: new Date()
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_0" /* DELETE_VESSEL_REQUEST */].FAILURE:
            {
                var _data2 = state.data.map(function (item) {
                    if (item._id === action.vesselRequestId) {
                        return _extends({}, item, {
                            errors: action.errors
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data2
                });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_145" /* UPDATE_VESSEL_REQUEST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_145" /* UPDATE_VESSEL_REQUEST */].SUCCESS:
            {
                var _data3 = state.data.map(function (item) {
                    if (item._id === action.vesselRequestId) {
                        return _extends({}, item, {
                            isUpdate: false
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data3
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_145" /* UPDATE_VESSEL_REQUEST */].FAILURE:
            {
                var _data4 = state.data.map(function (item) {
                    if (item._id === action.vesselRequestId) {
                        return _extends({}, item, {
                            isUpdate: true,
                            errors: action.errors
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data4
                });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].REQUEST:
            return _extends({}, state, {
                data: []
            });
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].SUCCESS:
            {
                var _data5 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state.data);
                _data5.push(action.vesselRequest);

                var results = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state.results);
                results.push(action.data);

                return _extends({}, state, { data: _data5, results: results });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_73" /* POST_VESSEL_REQUEST */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = vesselRequests;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vesselRequests, 'vesselRequests', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/requests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var vesselClaims = function vesselClaims() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        errors: []
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_59" /* GET_VESSEL_CLAIMS */].REQUEST:
            return _extends({}, state, {
                items: []
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_59" /* GET_VESSEL_CLAIMS */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_59" /* GET_VESSEL_CLAIMS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true,
                error: action.errors
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["a" /* ACCEPT_USER_CLAIMS_TO_VESSEL */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["a" /* ACCEPT_USER_CLAIMS_TO_VESSEL */].SUCCESS:
            {
                var items = state.items.filter(function (vessel) {
                    return vessel._id !== action.vesselId;
                });

                return _extends({}, state, {
                    items: items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["a" /* ACCEPT_USER_CLAIMS_TO_VESSEL */].FAILURE:
            {
                return _extends({}, state, {
                    errors: action.errors
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_75" /* REJECT_USER_CLAIMS_TO_VESSEL */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_75" /* REJECT_USER_CLAIMS_TO_VESSEL */].SUCCESS:
            {
                var _items = state.items.map(function (vessel) {
                    if (vessel._id === action.vesselId) {
                        var users = vessel.users.filter(function (user) {
                            return user._id !== action.userId;
                        });

                        return _extends({}, vessel, {
                            users: users
                        });
                    }

                    return vessel;
                });

                _items = _items.filter(function (vessel) {
                    return vessel.users.length > 0;
                });

                return _extends({}, state, {
                    items: _items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_75" /* REJECT_USER_CLAIMS_TO_VESSEL */].FAILURE:
            {
                return _extends({}, state, {
                    errors: action.errors
                });
            }
        default:
            return state;
    }
};

var _default = vesselClaims;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vesselClaims, 'vesselClaims', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/claims.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/claims.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var vessels = function vessels() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isLoaded: false,
        isNameSuggestion: false,
        notConfirmed: false,
        sanctioned: undefined,
        filterCargoExclusions: undefined,
        filterTradingRestrictions: undefined,
        limit: 25,
        page: 1,
        data: []
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_58" /* GET_VESSELS */].REQUEST:
            return _extends({}, state, action.pagination);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_58" /* GET_VESSELS */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_58" /* GET_VESSELS */].FAILURE:
            return _extends({}, state, action.data, {
                isLoaded: true
            });
        default:
            return state;
    }
};

var _default = vessels;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vessels, 'vessels', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/vessels.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/vessels.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var vessel = function vessel() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { errors: [] };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["w" /* CLEAR_VESSEL */]:
            return {
                errors: []
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_102" /* SAVE_VESSEL */]:
            return _extends({}, action.vessel);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_57" /* GET_VESSEL */].REQUEST:
            return {
                errors: []
            };
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_57" /* GET_VESSEL */].SUCCESS:
            {
                var _vessel = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(action.data);
                var holds = _vessel.holds;
                var hatches = _vessel.hatches;

                if (holds.lowerDims.length === 0) {
                    _vessel.holds.lowerDims = new Array(holds.quantity).fill({});
                }

                _vessel.holds.lowerDims = holds.lowerDims.concat(new Array(holds.quantity - holds.lowerDims.length).fill({}));

                if (holds.tweenDims.length === 0) {
                    _vessel.holds.tweenDims = new Array(holds.quantity).fill({});
                }

                _vessel.holds.tweenDims = holds.tweenDims.concat(new Array(holds.quantity - holds.tweenDims.length).fill({}));

                if (hatches.size.length === 0) {
                    _vessel.hatches.size = new Array(hatches.quantity).fill({});
                }

                if (hatches.quantity < hatches.size.length) {
                    hatches.quantity = hatches.size.length;
                }

                _vessel.hatches.size = hatches.size.concat(new Array(hatches.quantity - hatches.size.length).fill({}));

                return _extends({
                    errors: []
                }, _vessel);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_57" /* GET_VESSEL */].FAILURE:
            return _extends({}, state, {
                errors: action.errors
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["U" /* DELETE_NAME_SUGGESTION */].REQUEST:
            return _extends({}, state, action.vessel, {

                errors: []
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["U" /* DELETE_NAME_SUGGESTION */].SUCCESS:
            {
                return _extends({}, state, action.vessel, {

                    errors: []
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["U" /* DELETE_NAME_SUGGESTION */].FAILURE:
            return _extends({}, state, action.vessel, {

                errors: action.errors
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_90" /* RENAME_VESSEL */].REQUEST:
            return _extends({}, state, action.vessel, {

                errors: []
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_90" /* RENAME_VESSEL */].SUCCESS:
            {
                return _extends({}, state, action.vessel, {

                    errors: []
                });
            }

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_90" /* RENAME_VESSEL */].FAILURE:
            return _extends({}, state, action.vessel, {

                errors: action.errors
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_141" /* UPDATE_VESSEL */].REQUEST:
            return _extends({}, state, action.vessel, {
                errors: []
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_141" /* UPDATE_VESSEL */].SUCCESS:
            {
                return _extends({}, state, action.vessel, {
                    errors: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_141" /* UPDATE_VESSEL */].FAILURE:
            return _extends({}, state, action.vessel, {
                errors: action.errors
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Z" /* DELETE_VESSEL */].REQUEST:
            return _extends({}, state, {
                errors: []
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Z" /* DELETE_VESSEL */].SUCCESS:
            {
                return _extends({}, state, action.vessel, {
                    errors: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Z" /* DELETE_VESSEL */].FAILURE:
            return _extends({}, state, action.vessel, {
                errors: action.errors
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["h" /* ADD_VESSEL */].REQUEST:
            return _extends({}, state, action.vessel, {
                errors: []
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["h" /* ADD_VESSEL */].SUCCESS:
            {
                return _extends({}, state, action.vessel, {
                    errors: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["h" /* ADD_VESSEL */].FAILURE:
            return _extends({}, state, action.vessel, {
                errors: action.errors
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["y" /* CONFIRM_VESSEL */].REQUEST:
            return _extends({}, state, {
                errors: []
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["y" /* CONFIRM_VESSEL */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    errors: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["y" /* CONFIRM_VESSEL */].FAILURE:
            return _extends({}, state, {
                errors: action.errors
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_142" /* UPDATE_VESSEL_IMAGE */].REQUEST:
            return _extends({}, state, {
                errors: []
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_142" /* UPDATE_VESSEL_IMAGE */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    errors: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_142" /* UPDATE_VESSEL_IMAGE */].FAILURE:
            return _extends({}, state, {
                errors: action.errors
            });
        default:
            return state;
    }
};

var _default = vessel;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vessel, 'vessel', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/vessel.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/vessel.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mocks_vessel_size_json__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mocks_vessel_size_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mocks_vessel_size_json__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var vesselSizes = function vesselSizes() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        user: {
            email: '',
            company: '',
            name: '',
            surname: '',
            phones: [{
                code: '',
                phone: ''
            }]
        }
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_80" /* REMOVE_ALL_VESSEL_SIZES */]:
            {
                return _extends({}, state, {
                    items: []
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_149" /* UPDATE_VESSEL_SIZE_USER */]:
            {
                var newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                newState.user = _extends({}, action.user);
                return newState;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["I" /* CREATE_VESSEL_SIZES */]:
            {
                return _extends({}, state, {
                    items: action.items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_63" /* GET_VESSEL_SIZES */]:
            {
                return state;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_88" /* REMOVE_LAST_VESSEL_SIZE */]:
            {
                var _newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState.items.splice(-1, 1);
                return _newState;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["k" /* ADD_VESSEL_SIZE */]:
            {
                var _newState2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                var cloneMockSize = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2__mocks_vessel_size_json___default.a);
                _newState2.items.push(_extends({}, cloneMockSize));
                return _newState2;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_148" /* UPDATE_VESSEL_SIZE */]:
            {
                var _newState3 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState3.items[action.numberSize] = action.newVesselSize;
                return _newState3;
            }

        default:
            return state;
    }
};

var _default = vesselSizes;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vesselSizes, 'vesselSizes', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/size.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/size.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var vesselSales = function vesselSales() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        user: {
            email: '',
            company: '',
            name: '',
            surname: '',
            phones: [{
                code: '',
                phone: ''
            }]
        },
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_79" /* REMOVE_ALL_VESSEL_SALES */]:
            {
                return _extends({}, state, {
                    items: []
                });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_147" /* UPDATE_VESSEL_SALE_USER */]:
            {
                var newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                newState.user = _extends({}, action.user);
                return newState;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["H" /* CREATE_VESSEL_SALES */]:
            {
                return _extends({}, state, {
                    items: action.items,
                    user: Object.assign({}, state.user, action.user)
                });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_62" /* GET_VESSEL_SALES */].REQUEST:
            return state;

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_62" /* GET_VESSEL_SALES */].SUCCESS:
            var data = action.data.data.map(function (item) {
                return _extends({}, item, {
                    isUpdate: false
                });
            });

            return _extends({}, state, action.data, {
                isLoaded: true,
                data: data
            });

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_62" /* GET_VESSEL_SALES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_146" /* UPDATE_VESSEL_SALE */]:
            {
                var _newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState.items[action.numberSale] = action.newVesselSale;
                return _newState;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_87" /* REMOVE_LAST_VESSEL_SALE */]:
            {
                var _newState2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState2.items.splice(-1, 1);
                return _newState2;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_94" /* RESET_VESSEL_SALES */]:
            {
                var _newState3 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState3.items = [__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json___default.a];
                return _newState3;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["j" /* ADD_VESSEL_SALE */]:
            {
                var _newState4 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                var cloneMockSale = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_vessel_sales_json___default.a);

                _newState4.items.push(_extends({}, cloneMockSale));
                return _newState4;
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].REQUEST:
            {
                return _extends({}, state, {
                    data: []
                });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].FAILURE:
            {
                return _extends({}, state);
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_74" /* POST_VESSEL_SALE */].SUCCESS:
            {
                var _data = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state.data);
                _data.push(action.vesselRequest);
                return _extends({}, state, { data: _data });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_1" /* DELETE_VESSEL_SALE */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_1" /* DELETE_VESSEL_SALE */].SUCCESS:
            {
                var _data2 = state.data.map(function (item) {
                    if (item._id === action.saleId) {
                        return _extends({}, item, {
                            deleteBy: { email: action.email },
                            deleteAt: new Date()
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data2
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_1" /* DELETE_VESSEL_SALE */].FAILURE:
            {
                var _data3 = state.data.map(function (item) {
                    if (item._id === action.saleId) {
                        return _extends({}, item, {
                            errors: action.errors
                        });
                    }

                    return item;
                });

                return _extends({}, state, {
                    data: _data3
                });
            }

        default:
            return state;
    }
};

var _default = vesselSales;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vesselSales, 'vesselSales', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/sales.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/vessels/sales.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var backendNotifications = function backendNotifications() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        loaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["B" /* CREATE_BACKEND_NOTIFICATION */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["B" /* CREATE_BACKEND_NOTIFICATION */].SUCCESS:
            {
                return _extends({}, state, {
                    items: [].concat(_toConsumableArray(state.items), _toConsumableArray(action.data))
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["B" /* CREATE_BACKEND_NOTIFICATION */].FAILURE:
            {
                return _extends({}, state);
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_9" /* GET_BACKEND_NOTIFICATIONS */].REQUEST:
            {
                return _extends({}, state, {
                    loaded: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_9" /* GET_BACKEND_NOTIFICATIONS */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    loaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_9" /* GET_BACKEND_NOTIFICATIONS */].FAILURE:
            {
                return _extends({}, state, {
                    loaded: true
                });
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_8" /* GET_BACKEND_NOTIFICATION */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_8" /* GET_BACKEND_NOTIFICATION */].SUCCESS:
            {
                return _extends({}, state, {
                    items: [].concat(_toConsumableArray(state.items), _toConsumableArray(action.data))
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_8" /* GET_BACKEND_NOTIFICATION */].FAILURE:
            {
                return _extends({}, state);
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].SUCCESS:
            {

                return _extends({}, state, {
                    items: state.items.map(function (item) {
                        if (item._id === action.data._id) {
                            return action.data;
                        }

                        return item;
                    })
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_122" /* UPDATE_BACKEND_NOTIFICATION */].FAILURE:
            {
                return _extends({}, state);
            }

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["K" /* DELETE_BACKEND_NOTIFICATION */].REQUEST:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["K" /* DELETE_BACKEND_NOTIFICATION */].SUCCESS:
            {
                return _extends({}, state, {
                    items: state.items.filter(function (item) {
                        return item._id !== action.data;
                    })
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["K" /* DELETE_BACKEND_NOTIFICATION */].FAILURE:
            {
                return _extends({}, state);
            }

        default:
            return state;
    }
};

var _default = backendNotifications;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(backendNotifications, 'backendNotifications', '/opt/atlassian/pipelines/agent/build/client/app/reducers/notifications/backendNotifications.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/notifications/backendNotifications.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var notifications = function notifications() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: []
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["e" /* ADD_NOTIFICATION */]:
            {
                var items = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state.items);

                items.push(action.notification);

                return _extends({}, state, {
                    items: items
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["V" /* DELETE_NOTIFICATION */]:
            {
                var _items = state.items.filter(function (item) {
                    return item._id !== action.notification._id;
                });

                return {
                    items: _items
                };
            }
        default:
            return state;
    }
};

var _default = notifications;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(notifications, 'notifications', '/opt/atlassian/pipelines/agent/build/client/app/reducers/notifications/notifications.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/notifications/notifications.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var countries = function countries() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_24" /* GET_COUNTRIES */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_24" /* GET_COUNTRIES */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_24" /* GET_COUNTRIES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = countries;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(countries, 'countries', '/opt/atlassian/pipelines/agent/build/client/app/reducers/countries.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/countries.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var companies = function companies() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_21" /* GET_COMPANIES */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_21" /* GET_COMPANIES */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_21" /* GET_COMPANIES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = companies;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(companies, 'companies', '/opt/atlassian/pipelines/agent/build/client/app/reducers/companies.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/companies.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var realCompanies = function realCompanies() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_40" /* GET_REAL_COMPANIES */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_40" /* GET_REAL_COMPANIES */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_40" /* GET_REAL_COMPANIES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = realCompanies;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(realCompanies, 'realCompanies', '/opt/atlassian/pipelines/agent/build/client/app/reducers/realCompanies.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/realCompanies.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var statisticsUsers = function statisticsUsers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: '',
        from: '',
        until: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_47" /* GET_STATISTICS_USERS */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_47" /* GET_STATISTICS_USERS */].SUCCESS:
            {
                var data = action.data;
                var items = [];

                var twoPlusesCollection = [];
                var emailVerifiedCollection = [];
                var havePasswordCollection = [];
                var otherCollection = [];

                data = data.map(function (item) {
                    item.createdAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.createdAt).utc().startOf('day').toDate();
                    return item;
                });

                data.forEach(function (item) {
                    if (item.emailVerified && item.password) {
                        twoPlusesCollection.push(item);
                    } else if (item.emailVerified && !item.password) {
                        emailVerifiedCollection.push(item);
                    } else if (!item.emailVerified && item.password) {
                        havePasswordCollection.push(item);
                    } else {
                        otherCollection.push(item);
                    }
                });

                twoPlusesCollection.sort(__WEBPACK_IMPORTED_MODULE_1_helpers__["a" /* default */].sortByDate.apply(_this, ['createdAt']));
                emailVerifiedCollection.sort(__WEBPACK_IMPORTED_MODULE_1_helpers__["a" /* default */].sortByDate.apply(_this, ['createdAt']));
                havePasswordCollection.sort(__WEBPACK_IMPORTED_MODULE_1_helpers__["a" /* default */].sortByDate.apply(_this, ['createdAt']));
                otherCollection.sort(__WEBPACK_IMPORTED_MODULE_1_helpers__["a" /* default */].sortByDate.apply(_this, ['createdAt']));

                items = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.concat([], twoPlusesCollection, emailVerifiedCollection, havePasswordCollection, otherCollection);

                // items.sort((a, b) => {
                //     if (a.emailVerified > b.emailVerified) {
                //         return -1;
                //     }
                //
                //     if (a.emailVerified < b.emailVerified) {
                //         return 1;
                //     }
                //
                //     return 0;
                // });

                return _extends({}, state, {
                    items: items,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_47" /* GET_STATISTICS_USERS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_111" /* SEARCH_STATISTICS_USERS */]:
            return _extends({}, state, {
                searchText: action.searchText
            });
        default:
            return state;
    }
};

var _default = statisticsUsers;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(statisticsUsers, 'statisticsUsers', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/users.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/users.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var statisticsEmails = function statisticsEmails() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: '',
        from: '',
        until: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_45" /* GET_STATISTICS_EMAILS */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_45" /* GET_STATISTICS_EMAILS */].SUCCESS:
            {
                var items = action.data;

                items.sort(function (a, b) {
                    return new Date(a.realDate) - new Date(b.realDate);
                });

                return _extends({}, state, {
                    items: items,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_45" /* GET_STATISTICS_EMAILS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_109" /* SEARCH_STATISTICS_EMAILS */]:
            return _extends({}, state, {
                searchText: action.searchText
            });
        default:
            return state;
    }
};

var _default = statisticsEmails;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(statisticsEmails, 'statisticsEmails', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/emails.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/emails.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var statisticsMonitor = function statisticsMonitor() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: '',
        from: '',
        until: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_46" /* GET_STATISTICS_MONITOR */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_46" /* GET_STATISTICS_MONITOR */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_110" /* SEARCH_STATISTICS_MONITOR */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_110" /* SEARCH_STATISTICS_MONITOR */]:
            return _extends({}, state, {
                searchText: action.searchText
            });
        default:
            return state;
    }
};

var _default = statisticsMonitor;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(statisticsMonitor, 'statisticsMonitor', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/monitor.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/monitor.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var vesselPositions = function vesselPositions() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: '',
        from: '',
        until: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_48" /* GET_STATISTICS_VESSEL_POSITIONS */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_48" /* GET_STATISTICS_VESSEL_POSITIONS */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_48" /* GET_STATISTICS_VESSEL_POSITIONS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        default:
            return state;
    }
};

var _default = vesselPositions;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vesselPositions, 'vesselPositions', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/vesselPositions.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/vesselPositions.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var statisticsCargoRequests = function statisticsCargoRequests() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        searchText: '',
        from: '',
        until: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_44" /* GET_STATISTICS_CARGO_REQUESTS */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_44" /* GET_STATISTICS_CARGO_REQUESTS */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_44" /* GET_STATISTICS_CARGO_REQUESTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        default:
            return state;
    }
};

var _default = statisticsCargoRequests;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(statisticsCargoRequests, 'statisticsCargoRequests', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/cargoRequests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/statistics/cargoRequests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();



var integrators = function integrators() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, data: [] };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_27" /* GET_INTEGRATORS */].REQUEST:
      return _extends({}, state, {
        isLoaded: false
      });
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_27" /* GET_INTEGRATORS */].SUCCESS:
      {
        return _extends({}, state, action.data, {
          isLoaded: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_27" /* GET_INTEGRATORS */].FAILURE:
      return _extends({}, state, action.data, {
        isLoaded: true
      });
    default:
      return state;
  }
};

var _default = integrators;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(integrators, "integrators", "/opt/atlassian/pipelines/agent/build/client/app/reducers/integrators/integrators.js");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/reducers/integrators/integrators.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();



var integratorCompanies = function integratorCompanies() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isLoaded: false,
    total: 0,
    data: [],
    integratorId: null,
    page: 1,
    limit: 25
  };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_28" /* GET_INTEGRATOR_COMPANIES */].REQUEST:
      return _extends({}, state, {
        page: action.page,
        limit: action.limit,
        isLoaded: false
      });
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_28" /* GET_INTEGRATOR_COMPANIES */].SUCCESS:
      {
        return _extends({}, state, action.data, {
          isLoaded: true,
          integratorId: action.id
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_28" /* GET_INTEGRATOR_COMPANIES */].FAILURE:
      return _extends({}, state, action.data, {
        isLoaded: true,
        integratorId: null
      });
    default:
      return state;
  }
};

var _default = integratorCompanies;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(integratorCompanies, "integratorCompanies", "/opt/atlassian/pipelines/agent/build/client/app/reducers/integrators/companies.js");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/reducers/integrators/companies.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var train = function train() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_114" /* SEND_TRAIN */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_114" /* SEND_TRAIN */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_114" /* SEND_TRAIN */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = train;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(train, 'train', '/opt/atlassian/pipelines/agent/build/client/app/reducers/train.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/train.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var initState = {
    loading: false,
    page: 1,
    next: 2,
    previous: 1,
    limit: 100,
    sortField: 'addedAt',
    sortValue: -1,
    filters: {
        search: ''
    },
    data: []
};

var senderList = function senderList() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].REQUEST:
            return _extends({}, state, action.pagination, {
                loading: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    loading: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_43" /* GET_SEND_EMAIL_LIST */].FAILURE:
            return _extends({}, state, action.data, {
                loading: true
            });

        default:
            return state;
    }
};

var _default = senderList;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(initState, 'initState', '/opt/atlassian/pipelines/agent/build/client/app/reducers/sender/senderList.js');
    reactHotLoader.register(senderList, 'senderList', '/opt/atlassian/pipelines/agent/build/client/app/reducers/sender/senderList.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/sender/senderList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var initState = {};

var sender = function sender() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_42" /* GET_SEND_EMAIL */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_42" /* GET_SEND_EMAIL */].SUCCESS:
            return _extends({}, state, action.data);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_42" /* GET_SEND_EMAIL */].FAILURE:
            return _extends({}, state);

        default:
            return state;
    }
};

var _default = sender;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(initState, 'initState', '/opt/atlassian/pipelines/agent/build/client/app/reducers/sender/sender.js');
    reactHotLoader.register(sender, 'sender', '/opt/atlassian/pipelines/agent/build/client/app/reducers/sender/sender.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/sender/sender.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var domains = function domains() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { items: [] };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["z" /* CONNECT_NEW_DOMAIN_TO_USER */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["z" /* CONNECT_NEW_DOMAIN_TO_USER */].SUCCESS:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["z" /* CONNECT_NEW_DOMAIN_TO_USER */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["P" /* DELETE_DOMAIN */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["P" /* DELETE_DOMAIN */].SUCCESS:
            {
                return _extends({}, state);
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["P" /* DELETE_DOMAIN */].FAILURE:
            return _extends({}, state);

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_33" /* GET_LIST_DOMAIN */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_33" /* GET_LIST_DOMAIN */].SUCCESS:
            {
                return {
                    items: action.data
                };
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_33" /* GET_LIST_DOMAIN */].FAILURE:
            return _extends({}, state);
        default:
            return state;
    }
};

var _default = domains;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(domains, 'domains', '/opt/atlassian/pipelines/agent/build/client/app/reducers/domains.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/domains.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var reqLDRates = function reqLDRates() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isLoaded: false,
        pagination: {},
        searchText: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["X" /* DELETE_REQ_LD_RATES */]:
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_2" /* EDIT_REQ_LD_RATES */]:
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_41" /* GET_REQ_LD_RATES */]:
            return _extends({}, state, action.data.data, {
                isLoaded: true
            });
        default:
            return state;
    }
};

var _default = reqLDRates;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(reqLDRates, 'reqLDRates', '/opt/atlassian/pipelines/agent/build/client/app/reducers/reqLDRates.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/reqLDRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_tc_order_js__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mocks_tc_order_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mocks_tc_order_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var tcOrders = function tcOrders() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        user: {
            email: '',
            company: '',
            name: '',
            surname: '',
            phones: [{
                code: '',
                phone: ''
            }]
        }
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["f" /* ADD_TC_ORDER */]:
            {
                var newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                newState.items.push(_extends({}, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_tc_order_js___default.a)));
                return newState;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["F" /* CREATE_TC_ORDERS */]:
            {
                return _extends({}, state, {
                    items: action.items,
                    user: Object.assign({}, state.user, action.user)
                });
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_139" /* UPDATE_TC_ORDER */]:
            {
                var _newState = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState.items[action.numberOrder] = action.newTcOrder;
                return _newState;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_140" /* UPDATE_TC_ORDER_USER */]:
            {
                var _newState2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState2.user = action.user;
                return _newState2;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_85" /* REMOVE_LAST_TC_ORDER */]:
            {
                var _newState3 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState3.items.splice(-1, 1);
                return _newState3;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_77" /* REMOVE_ALL_TC_ORDERS */]:
            {
                var _newState4 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState4.items = [];
                return _newState4;
            }
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_92" /* RESET_TC_ORDERS */]:
            {
                var _newState5 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
                _newState5.items = [_extends({}, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_2_mocks_tc_order_js___default.a))];
                return _newState5;
            }
        default:
            {
                return state;
            }
    }
};

var _default = tcOrders;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(tcOrders, 'tcOrders', '/opt/atlassian/pipelines/agent/build/client/app/reducers/tc/orders.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/tc/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports = {
    account: {
        _id: null,
        name: null
    },
    commission: null,
    readinessDate: undefined,
    cancellingDate: undefined,
    deliveryPlaces: [{
        port: {
            _id: null,
            name: null
        },
        details: null,
        main: true
    }],
    redeliveryPlaces: [{
        port: {
            _id: null,
            name: null
        },
        details: null,
        main: true
    }],
    tcDuration: null,
    vesselRequirements: {
        typeByPurpose: null,
        typeBySpecialty: null,
        typeByConstruction: null,
        ageMax: null,
        forHeavyCargoes: null,
        imoFitted: null,
        flags: [],
        dwtMin: null,
        dwtMax: null,
        typeSizes: [],
        geared: undefined,
        grabbed: null,
        capacityMin: null,
        capacityMax: null,
        scrubberFitted: null,
        strengthenHeavy: null,
        gearV2: {
            summary: [{
                type: null,
                quantity: null,
                capacity: null,
                outreach: null,
                maxSWL: null,
                combinable: false
            }]
        },
        grabV2: {
            summary: [{
                type: null,
                quantity: null,
                volume: null
            }]
        },
        teuMin: null,
        teuMax: null,
        linerMeterMin: null,
        linerMeterMax: null,
        loaMax: null,
        beamMax: null,
        draftMax: null,
        piClubMember: null,
        registerClasses: [
            // {
            //     "registerClass": null,
            //     "iacsRegister": null,
            //     "excluded": null,
            // }
        ]
    },
    terms: {
        user: [],
        default: []
    },
    eh: null,
    context: {
        parser: null,
        kind: null,
        userId: {
            _id: null,
            name: null,
            surname: null,
            email: null,
            company: null
        },
        companyId: {
            _id: null,
            name: null
        }
    },
    mailId: null,
    cargo: {
        included: [],
        excluded: []
    }
};

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var tcRequests = function tcRequests() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_51" /* GET_TC_REQUESTS */].REQUEST:
            return _extends({}, state, {
                items: [],
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_51" /* GET_TC_REQUESTS */].SUCCESS:
            var items = action.data.data.map(function (item) {
                return _extends({}, item);
            });

            return _extends({}, state, action.data, {
                isLoaded: true,
                items: items
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_51" /* GET_TC_REQUESTS */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Y" /* DELETE_TC_REQUEST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Y" /* DELETE_TC_REQUEST */].SUCCESS:
            {
                var newState = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state);

                newState.items.forEach(function (item) {
                    if (item._id === action.tcRequestId) {
                        item.deleteBy = { email: action.email };
                        item.deleteAt = new Date();
                    }
                });

                return newState;
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["Y" /* DELETE_TC_REQUEST */].FAILURE:
            {
                var _newState = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state);

                _newState.items.forEach(function (item) {
                    if (item._id === action.tcRequestId) {
                        item.errors = action.errors;
                    }
                });

                return _newState;
            }
        default:
            return state;
    }
};

var _default = tcRequests;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(tcRequests, 'tcRequests', '/opt/atlassian/pipelines/agent/build/client/app/reducers/tc/requests.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/tc/requests.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var links = function links() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_5" /* GET_ANALYTICS_LINKS_LIST */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_5" /* GET_ANALYTICS_LINKS_LIST */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_5" /* GET_ANALYTICS_LINKS_LIST */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = links;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(links, 'links', '/opt/atlassian/pipelines/agent/build/client/app/reducers/analytics/linksList.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/analytics/linksList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var flagCompliance = function flagCompliance() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_25" /* GET_FLAG_COMPLIANCE */].REQUEST:
            return _extends({}, state);
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_25" /* GET_FLAG_COMPLIANCE */].SUCCESS:
            {
                return _extends({}, state, {
                    items: action.data,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_25" /* GET_FLAG_COMPLIANCE */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = flagCompliance;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(flagCompliance, 'flagCompliance', '/opt/atlassian/pipelines/agent/build/client/app/reducers/flagCompliance.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/flagCompliance.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var tcIndexes = function tcIndexes() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false,
        pageInfo: {
            count: 0
        }
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_50" /* GET_TC_INDEXES */].REQUEST:
            return _extends({}, state, {
                items: [],
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_50" /* GET_TC_INDEXES */].SUCCESS:
            var items = action.data.data.docs.map(function (item) {
                return _extends({}, item);
            });

            var pageInfo = action.data.data.pageInfo[0];

            return _extends({}, state, {
                isLoaded: true,
                items: items,
                pageInfo: pageInfo
            });

        case __WEBPACK_IMPORTED_MODULE_1_constants_ActionTypes__["_50" /* GET_TC_INDEXES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        default:
            {
                return state;
            }
    }
};

var _default = tcIndexes;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(tcIndexes, 'tcIndexes', '/opt/atlassian/pipelines/agent/build/client/app/reducers/tc/indexes.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/tc/indexes.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var cargoTagsCategories = function cargoTagsCategories() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        isLoaded: false
    };
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_19" /* GET_CARGO_TAGS_CATEGORIES */].REQUEST:
            return _extends({}, state, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_19" /* GET_CARGO_TAGS_CATEGORIES */].SUCCESS:
            {
                var items = action.data.map(function (item) {
                    return _extends({}, item, {
                        isUpdate: false
                    });
                });
                return _extends({}, state, {
                    items: items,
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_19" /* GET_CARGO_TAGS_CATEGORIES */].FAILURE:
            return _extends({}, state, {
                isLoaded: true
            });
        default:
            return state;
    }
};

var _default = cargoTagsCategories;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(cargoTagsCategories, 'cargoTagsCategories', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/tags.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/cargoes/tags.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var initState = {
    loading: false,
    page: 1,
    next: 2,
    previous: 1,
    limit: 50,
    // sortField: 'addedAt',
    // sortValue: -1,
    filters: {
        search: ''
    },
    data: []
};

var issues = function issues() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_30" /* GET_ISSUES */].REQUEST:
            return _extends({}, state, action.pagination, {
                loading: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_30" /* GET_ISSUES */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    loading: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_30" /* GET_ISSUES */].FAILURE:
            return _extends({}, state, action.data, {
                loading: false
            });
        default:
            return state;
    }
};

var _default = issues;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(initState, 'initState', '/opt/atlassian/pipelines/agent/build/client/app/reducers/issues/issues.js');
    reactHotLoader.register(issues, 'issues', '/opt/atlassian/pipelines/agent/build/client/app/reducers/issues/issues.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/issues/issues.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var initState = {};

var issue = function issue() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_29" /* GET_ISSUE */].REQUEST:
            return _extends({}, state, action.data, {
                isLoaded: false
            });
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_29" /* GET_ISSUE */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_29" /* GET_ISSUE */].FAILURE:
            return _extends({}, state, action.data, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].REQUEST:
            {
                return _extends({}, state, action.data, {
                    isLoaded: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_129" /* UPDATE_ISSUE_STATUS */].FAILURE:
            return _extends({}, state, action.data, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].REQUEST:
            {
                return _extends({}, state, {
                    isLoaded: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["c" /* ADD_ISSUE_COMMENT */].FAILURE:
            return _extends({}, state, action.data, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].REQUEST:
            {
                return _extends({}, state, {
                    isLoaded: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_128" /* UPDATE_ISSUE_COMMENT */].FAILURE:
            return _extends({}, state, action.data, {
                isLoaded: true
            });

        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].REQUEST:
            {
                return _extends({}, state, {
                    isLoaded: false
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].SUCCESS:
            {
                return _extends({}, state, action.data, {
                    isLoaded: true
                });
            }
        case __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["S" /* DELETE_ISSUE_COMMENT */].FAILURE:
            return _extends({}, state, action.data, {
                isLoaded: true
            });

        default:
            return state;
    }
};

var _default = issue;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(initState, 'initState', '/opt/atlassian/pipelines/agent/build/client/app/reducers/issues/issue.js');
    reactHotLoader.register(issue, 'issue', '/opt/atlassian/pipelines/agent/build/client/app/reducers/issues/issue.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/reducers/issues/issue.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserPermissionService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_bindMethods__ = __webpack_require__(1714);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-03-19 15:12:49 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-03-19 16:40:11
 */


var UserPermissionService = function () {
    function UserPermissionService(store) {
        _classCallCheck(this, UserPermissionService);

        this.store = store;

        Object(__WEBPACK_IMPORTED_MODULE_0_helpers_bindMethods__["a" /* bindMethods */])(this);
    }

    _createClass(UserPermissionService, [{
        key: "isLoggedIn",
        value: function isLoggedIn() {
            var user = this.state.user;


            return user && user.isLogged;
        }
    }, {
        key: "isAdmin",
        value: function isAdmin() {
            var user = this.state.user;


            return user && user.isLogged && user.user.role === "admin";
        }
    }, {
        key: "isModerator",
        value: function isModerator() {
            var user = this.state.user;


            return user && user.isLogged && user.user.role === "moderator";
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }, {
        key: "state",
        get: function get() {
            return this.store.getState();
        }
    }]);

    return UserPermissionService;
}();
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(UserPermissionService, "UserPermissionService", "/opt/atlassian/pipelines/agent/build/client/app/store/userPermissions.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = bindMethods;
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-03-19 16:09:30 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-03-19 16:11:57
 */

function bindMethods(target) {
    var members = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {

        for (var _iterator = (members || Object.getOwnPropertyNames(target))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var name = _step.value;

            if (typeof target[name] === "function") {
                target[name] = target[name].bind(target);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(bindMethods, "bindMethods", "/opt/atlassian/pipelines/agent/build/client/app/helpers/bindMethods.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/favicon.ico";

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813129629
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_notification_system__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_notification_system___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_notification_system__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sockets__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_claims__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_users__ = __webpack_require__(124);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Layout = function (_React$Component) {
    _inherits(Layout, _React$Component);

    function Layout(props) {
        _classCallCheck(this, Layout);

        var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));

        _this.connectSockets = false;
        _this._notificationSystem = null;
        return _this;
    }

    _createClass(Layout, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            nextProps.notifications.forEach(function (notification) {
                _this2._notificationSystem.addNotification(_extends({}, notification, {
                    onAdd: function onAdd() {
                        return _this2.props.deleteNotification(notification);
                    }
                }));
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._notificationSystem = this.refs.notificationSystem;

            if (this.props.role === 'admin') {
                this.startSocket();
            }
        }
    }, {
        key: 'startSocket',
        value: function startSocket() {
            var _this3 = this;

            var socket = __WEBPACK_IMPORTED_MODULE_5_sockets__["a" /* default */].connect(this.props);

            socket.on('admin:newVessel', function (message) {
                _this3.props.getVessels({});

                _this3.props.addNotification({
                    title: 'New vessel was created',
                    message: 'Name - ' + message.name + ', imoNumber - ' + message.imoNumber,
                    level: 'success',
                    _id: Math.random(),
                    autoDismiss: 20,
                    action: {
                        label: 'Show vessel',
                        callback: function callback() {
                            _this3.props.router.push('/vessels/' + message._id);
                        }
                    }
                });
            });

            socket.on('admin:newClaimRightsToVessel', function (message) {
                _this3.props.getVesselClaims({});

                _this3.props.addNotification({
                    title: 'Added new claims rights to vessel',
                    message: 'User - ' + message.user.name + ', Email user - ' + message.user.email + ', Vessel name - ' + message.vessel.name,
                    level: 'success',
                    _id: Math.random(),
                    autoDismiss: 9999,
                    action: {
                        label: 'Show claims rights',
                        callback: function callback() {
                            _this3.props.router.push('/vessels/claims');
                        }
                    }
                });
            });

            socket.on('admin:newPortChanges', function (message) {
                _this3.props.getPorts({});

                if (_this3.props.router.params.id === message._id) {
                    _this3.props.router.push('/regions/ports/approve/' + message._id);
                }

                _this3.props.addNotification({
                    title: 'Added changes to port',
                    message: 'Port name - ' + message.name + ', unLoCode - ' + message.unLoCode,
                    level: 'success',
                    _id: Math.random(),
                    autoDismiss: 30,
                    action: {
                        label: 'Show port',
                        callback: function callback() {
                            _this3.props.router.push('/regions/ports/approve/' + message._id);
                            window.location.reload();
                        }
                    }
                });
            });

            socket.on('admin:newIssueCreated', function (message) {
                _this3.props.addNotification({
                    title: 'Warning',
                    message: 'New issue was created',
                    level: 'warning',
                    _id: Math.random(),
                    autoDismiss: 99,
                    action: {
                        label: 'Show issue',
                        callback: function callback() {
                            window.open('/issues/' + message._id, "_blank");
                        }
                    }
                });
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.props.isLogged && this.props.router.location.pathname != '/login') {
                __WEBPACK_IMPORTED_MODULE_5_sockets__["a" /* default */].disconnect();
                this.props.router.push('/login');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                this.props.role !== 'user' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_notification_system___default.a, { ref: 'notificationSystem' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Header__["a" /* default */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { height: "calc(100% - 64px)", overflowY: "auto" } },
                        this.props.children
                    )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h1',
                        null,
                        'This user doesn\'t have permissions'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: this.props.logoutUser },
                        'Change account'
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Layout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var user = _ref.user,
        notifications = _ref.notifications;

    return {
        isLogged: user.isLogged,
        userId: user.user._id,
        role: user.user.role,
        notifications: notifications.items

    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        deleteNotification: __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__["b" /* deleteNotification */],
        addNotification: __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__["a" /* addNotification */],
        getVessels: __WEBPACK_IMPORTED_MODULE_7_actions_vessels_vessels__["f" /* getVessels */],
        getVesselClaims: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_claims__["b" /* getVesselClaims */],
        getPorts: __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__["f" /* getPorts */],
        logoutUser: __WEBPACK_IMPORTED_MODULE_10_actions_users__["f" /* logoutUser */]
    }, dispatch);
})(Layout);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Layout, 'Layout', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Layout.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Layout.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var createReactClass = __webpack_require__(97);
var PropTypes = __webpack_require__(5);
var merge = __webpack_require__(206);
var NotificationContainer = __webpack_require__(1719);
var Constants = __webpack_require__(491);
var Styles = __webpack_require__(1722);

var NotificationSystem = createReactClass({

  uid: 3400,

  _isMounted: false,

  _getStyles: {
    overrideStyle: {},

    overrideWidth: null,

    setOverrideStyle: function(style) {
      this.overrideStyle = style;
    },

    wrapper: function() {
      if (!this.overrideStyle) return {};
      return merge({}, Styles.Wrapper, this.overrideStyle.Wrapper);
    },

    container: function(position) {
      var override = this.overrideStyle.Containers || {};
      if (!this.overrideStyle) return {};

      this.overrideWidth = Styles.Containers.DefaultStyle.width;

      if (override.DefaultStyle && override.DefaultStyle.width) {
        this.overrideWidth = override.DefaultStyle.width;
      }

      if (override[position] && override[position].width) {
        this.overrideWidth = override[position].width;
      }

      return merge({}, Styles.Containers.DefaultStyle, Styles.Containers[position], override.DefaultStyle, override[position]);
    },

    elements: {
      notification: 'NotificationItem',
      title: 'Title',
      messageWrapper: 'MessageWrapper',
      dismiss: 'Dismiss',
      action: 'Action',
      actionWrapper: 'ActionWrapper'
    },

    byElement: function(element) {
      var self = this;
      return function(level) {
        var _element = self.elements[element];
        var override = self.overrideStyle[_element] || {};
        if (!self.overrideStyle) return {};
        return merge({}, Styles[_element].DefaultStyle, Styles[_element][level], override.DefaultStyle, override[level]);
      };
    }
  },

  _didNotificationRemoved: function(uid) {
    var notification;
    var notifications = this.state.notifications.filter(function(toCheck) {
      if (toCheck.uid === uid) {
        notification = toCheck;
        return false;
      }
      return true;
    });

    if (this._isMounted) {
      this.setState({ notifications: notifications });
    }

    if (notification && notification.onRemove) {
      notification.onRemove(notification);
    }
  },

  getInitialState: function() {
    return {
      notifications: []
    };
  },

  propTypes: {
    style: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object
    ]),
    noAnimation: PropTypes.bool,
    allowHTML: PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      style: {},
      noAnimation: false,
      allowHTML: false
    };
  },

  addNotification: function(notification) {
    var _notification = merge({}, Constants.notification, notification);
    var notifications = this.state.notifications;
    var i;

    if (!_notification.level) {
      throw new Error('notification level is required.');
    }

    if (Object.keys(Constants.levels).indexOf(_notification.level) === -1) {
      throw new Error('\'' + _notification.level + '\' is not a valid level.');
    }

    // eslint-disable-next-line
    if (isNaN(_notification.autoDismiss)) {
      throw new Error('\'autoDismiss\' must be a number.');
    }

    if (Object.keys(Constants.positions).indexOf(_notification.position) === -1) {
      throw new Error('\'' + _notification.position + '\' is not a valid position.');
    }

    // Some preparations
    _notification.position = _notification.position.toLowerCase();
    _notification.level = _notification.level.toLowerCase();
    _notification.autoDismiss = parseInt(_notification.autoDismiss, 10);

    _notification.uid = _notification.uid || this.uid;
    _notification.ref = 'notification-' + _notification.uid;
    this.uid += 1;

    // do not add if the notification already exists based on supplied uid
    for (i = 0; i < notifications.length; i += 1) {
      if (notifications[i].uid === _notification.uid) {
        return false;
      }
    }

    notifications.push(_notification);

    if (typeof _notification.onAdd === 'function') {
      notification.onAdd(_notification);
    }

    this.setState({
      notifications: notifications
    });

    return _notification;
  },

  getNotificationRef: function(notification) {
    var self = this;
    var foundNotification = null;

    Object.keys(this.refs).forEach(function(container) {
      if (container.indexOf('container') > -1) {
        Object.keys(self.refs[container].refs).forEach(function(_notification) {
          var uid = notification.uid ? notification.uid : notification;
          if (_notification === 'notification-' + uid) {
            // NOTE: Stop iterating further and return the found notification.
            // Since UIDs are uniques and there won't be another notification found.
            foundNotification = self.refs[container].refs[_notification];
          }
        });
      }
    });

    return foundNotification;
  },

  removeNotification: function(notification) {
    var foundNotification = this.getNotificationRef(notification);
    return foundNotification && foundNotification._hideNotification();
  },

  editNotification: function(notification, newNotification) {
    var foundNotification = null;
    // NOTE: Find state notification to update by using
    // `setState` and forcing React to re-render the component.
    var uid = notification.uid ? notification.uid : notification;

    var newNotifications = this.state.notifications.filter(function(stateNotification) {
      if (uid === stateNotification.uid) {
        foundNotification = stateNotification;
        return false;
      }

      return true;
    });


    if (!foundNotification) {
      return;
    }

    newNotifications.push(merge(
      {},
      foundNotification,
      newNotification
    ));

    this.setState({
      notifications: newNotifications
    });
  },

  clearNotifications: function() {
    var self = this;
    Object.keys(this.refs).forEach(function(container) {
      if (container.indexOf('container') > -1) {
        Object.keys(self.refs[container].refs).forEach(function(_notification) {
          self.refs[container].refs[_notification]._hideNotification();
        });
      }
    });
  },

  componentDidMount: function() {
    this._getStyles.setOverrideStyle(this.props.style);
    this._isMounted = true;
  },

  componentWillUnmount: function() {
    this._isMounted = false;
  },

  render: function() {
    var self = this;
    var containers = null;
    var notifications = this.state.notifications;

    if (notifications.length) {
      containers = Object.keys(Constants.positions).map(function(position) {
        var _notifications = notifications.filter(function(notification) {
          return position === notification.position;
        });

        if (!_notifications.length) {
          return null;
        }

        return (
          React.createElement(NotificationContainer, {
            ref:  'container-' + position, 
            key:  position, 
            position:  position, 
            notifications:  _notifications, 
            getStyles:  self._getStyles, 
            onRemove:  self._didNotificationRemoved, 
            noAnimation:  self.props.noAnimation, 
            allowHTML:  self.props.allowHTML}
          )
        );
      });
    }


    return (
      React.createElement("div", {className: "notifications-wrapper", style:  this._getStyles.wrapper() }, 
         containers 
      )
    );
  }
});

module.exports = NotificationSystem;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var createReactClass = __webpack_require__(97);
var PropTypes = __webpack_require__(5);
var NotificationItem = __webpack_require__(1720);
var Constants = __webpack_require__(491);

var NotificationContainer = createReactClass({

  propTypes: {
    position: PropTypes.string.isRequired,
    notifications: PropTypes.array.isRequired,
    getStyles: PropTypes.object
  },

  _style: {},

  componentWillMount: function() {
    // Fix position if width is overrided
    this._style = this.props.getStyles.container(this.props.position);

    if (this.props.getStyles.overrideWidth && (this.props.position === Constants.positions.tc || this.props.position === Constants.positions.bc)) {
      this._style.marginLeft = -(this.props.getStyles.overrideWidth / 2);
    }
  },

  render: function() {
    var self = this;
    var notifications;

    if ([Constants.positions.bl, Constants.positions.br, Constants.positions.bc].indexOf(this.props.position) > -1) {
      this.props.notifications.reverse();
    }

    notifications = this.props.notifications.map(function(notification) {
      return (
        React.createElement(NotificationItem, {
          ref:  'notification-' + notification.uid, 
          key:  notification.uid, 
          notification:  notification, 
          getStyles:  self.props.getStyles, 
          onRemove:  self.props.onRemove, 
          noAnimation:  self.props.noAnimation, 
          allowHTML:  self.props.allowHTML, 
          children:  self.props.children}
        )
      );
    });

    return (
      React.createElement("div", {className:  'notifications-' + this.props.position, style:  this._style}, 
         notifications 
      )
    );
  }
});


module.exports = NotificationContainer;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var createReactClass = __webpack_require__(97);
var PropTypes = __webpack_require__(5);
var ReactDOM = __webpack_require__(49);
var Constants = __webpack_require__(491);
var Helpers = __webpack_require__(1721);
var merge = __webpack_require__(206);

/* From Modernizr */
var whichTransitionEvent = function() {
  var el = document.createElement('fakeelement');
  var transition;
  var transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
  };

  Object.keys(transitions).forEach(function(transitionKey) {
    if (el.style[transitionKey] !== undefined) {
      transition = transitions[transitionKey];
    }
  });

  return transition;
};

var NotificationItem = createReactClass({

  propTypes: {
    notification: PropTypes.object,
    getStyles: PropTypes.object,
    onRemove: PropTypes.func,
    allowHTML: PropTypes.bool,
    noAnimation: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ])
  },

  getDefaultProps: function() {
    return {
      noAnimation: false,
      onRemove: function() {},
      allowHTML: false
    };
  },

  getInitialState: function() {
    return {
      visible: undefined,
      removed: false
    };
  },

  componentWillMount: function() {
    var getStyles = this.props.getStyles;
    var level = this.props.notification.level;

    this._noAnimation = this.props.noAnimation;

    this._styles = {
      notification: getStyles.byElement('notification')(level),
      title: getStyles.byElement('title')(level),
      dismiss: getStyles.byElement('dismiss')(level),
      messageWrapper: getStyles.byElement('messageWrapper')(level),
      actionWrapper: getStyles.byElement('actionWrapper')(level),
      action: getStyles.byElement('action')(level)
    };

    if (!this.props.notification.dismissible) {
      this._styles.notification.cursor = 'default';
    }
  },

  _styles: {},

  _notificationTimer: null,

  _height: 0,

  _noAnimation: null,

  _isMounted: false,

  _removeCount: 0,

  _getCssPropertyByPosition: function() {
    var position = this.props.notification.position;
    var css = {};

    switch (position) {
    case Constants.positions.tl:
    case Constants.positions.bl:
      css = {
        property: 'left',
        value: -200
      };
      break;

    case Constants.positions.tr:
    case Constants.positions.br:
      css = {
        property: 'right',
        value: -200
      };
      break;

    case Constants.positions.tc:
      css = {
        property: 'top',
        value: -100
      };
      break;

    case Constants.positions.bc:
      css = {
        property: 'bottom',
        value: -100
      };
      break;

    default:
    }

    return css;
  },

  _defaultAction: function(event) {
    var notification = this.props.notification;

    event.preventDefault();
    this._hideNotification();
    if (typeof notification.action.callback === 'function') {
      notification.action.callback();
    }
  },

  _hideNotification: function() {
    if (this._notificationTimer) {
      this._notificationTimer.clear();
    }

    if (this._isMounted) {
      this.setState({
        visible: false,
        removed: true
      });
    }

    if (this._noAnimation) {
      this._removeNotification();
    }
  },

  _removeNotification: function() {
    this.props.onRemove(this.props.notification.uid);
  },

  _dismiss: function() {
    if (!this.props.notification.dismissible) {
      return;
    }

    this._hideNotification();
  },

  _showNotification: function() {
    var self = this;
    setTimeout(function() {
      if (self._isMounted) {
        self.setState({
          visible: true
        });
      }
    }, 50);
  },

  _onTransitionEnd: function() {
    if (this._removeCount > 0) return;
    if (this.state.removed) {
      this._removeCount += 1;
      this._removeNotification();
    }
  },

  componentDidMount: function() {
    var self = this;
    var transitionEvent = whichTransitionEvent();
    var notification = this.props.notification;
    var element = ReactDOM.findDOMNode(this);

    this._height = element.offsetHeight;

    this._isMounted = true;

    // Watch for transition end
    if (!this._noAnimation) {
      if (transitionEvent) {
        element.addEventListener(transitionEvent, this._onTransitionEnd);
      } else {
        this._noAnimation = true;
      }
    }


    if (notification.autoDismiss) {
      this._notificationTimer = new Helpers.Timer(function() {
        self._hideNotification();
      }, notification.autoDismiss * 1000);
    }

    this._showNotification();
  },

  _handleMouseEnter: function() {
    var notification = this.props.notification;
    if (notification.autoDismiss) {
      this._notificationTimer.pause();
    }
  },

  _handleMouseLeave: function() {
    var notification = this.props.notification;
    if (notification.autoDismiss) {
      this._notificationTimer.resume();
    }
  },

  componentWillUnmount: function() {
    var element = ReactDOM.findDOMNode(this);
    var transitionEvent = whichTransitionEvent();
    element.removeEventListener(transitionEvent, this._onTransitionEnd);
    this._isMounted = false;
  },

  _allowHTML: function(string) {
    return { __html: string };
  },

  render: function() {
    var notification = this.props.notification;
    var className = 'notification notification-' + notification.level;
    var notificationStyle = merge({}, this._styles.notification);
    var cssByPos = this._getCssPropertyByPosition();
    var dismiss = null;
    var actionButton = null;
    var title = null;
    var message = null;

    if (this.state.visible) {
      className += ' notification-visible';
    } else if (this.state.visible === false) {
      className += ' notification-hidden';
    }

    if (!notification.dismissible) {
      className += ' notification-not-dismissible';
    }

    if (this.props.getStyles.overrideStyle) {
      if (!this.state.visible && !this.state.removed) {
        notificationStyle[cssByPos.property] = cssByPos.value;
      }

      if (this.state.visible && !this.state.removed) {
        notificationStyle.height = this._height;
        notificationStyle[cssByPos.property] = 0;
      }

      if (this.state.removed) {
        notificationStyle.overlay = 'hidden';
        notificationStyle.height = 0;
        notificationStyle.marginTop = 0;
        notificationStyle.paddingTop = 0;
        notificationStyle.paddingBottom = 0;
      }
      notificationStyle.opacity = this.state.visible ? this._styles.notification.isVisible.opacity : this._styles.notification.isHidden.opacity;
    }

    if (notification.title) {
      title = React.createElement("h4", {className: "notification-title", style:  this._styles.title},  notification.title);
    }

    if (notification.message) {
      if (this.props.allowHTML) {
        message = (
          React.createElement("div", {className: "notification-message", style:  this._styles.messageWrapper, dangerouslySetInnerHTML:  this._allowHTML(notification.message) })
        );
      } else {
        message = (
          React.createElement("div", {className: "notification-message", style:  this._styles.messageWrapper},  notification.message)
        );
      }
    }

    if (notification.dismissible) {
      dismiss = React.createElement("span", {className: "notification-dismiss", style:  this._styles.dismiss}, "×");
    }

    if (notification.action) {
      actionButton = (
        React.createElement("div", {className: "notification-action-wrapper", style:  this._styles.actionWrapper}, 
          React.createElement("button", {className: "notification-action-button", 
            onClick:  this._defaultAction, 
            style:  this._styles.action}, 
             notification.action.label
          )
        )
      );
    }

    if (notification.children) {
      actionButton = notification.children;
    }

    return (
      React.createElement("div", {className:  className, onClick:  this._dismiss, onMouseEnter:  this._handleMouseEnter, onMouseLeave:  this._handleMouseLeave, style:  notificationStyle }, 
         title, 
         message, 
         dismiss, 
         actionButton 
      )
    );
  }

});

module.exports = NotificationItem;


/***/ }),
/* 1721 */
/***/ (function(module, exports) {

var Helpers = {
  Timer: function(callback, delay) {
    var timerId;
    var start;
    var remaining = delay;

    this.pause = function() {
      clearTimeout(timerId);
      remaining -= new Date() - start;
    };

    this.resume = function() {
      start = new Date();
      clearTimeout(timerId);
      timerId = setTimeout(callback, remaining);
    };

    this.clear = function() {
      clearTimeout(timerId);
    };

    this.resume();
  }
};

module.exports = Helpers;


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

// Used for calculations
var defaultWidth = 320;
var defaultColors = {
  success: {
    rgb: '94, 164, 0',
    hex: '#5ea400'
  },
  error: {
    rgb: '236, 61, 61',
    hex: '#ec3d3d'
  },
  warning: {
    rgb: '235, 173, 23',
    hex: '#ebad1a'
  },
  info: {
    rgb: '54, 156, 199',
    hex: '#369cc7'
  }
};
var defaultShadowOpacity = '0.9';

var STYLES = {

  Wrapper: {},
  Containers: {
    DefaultStyle: {
      fontFamily: 'inherit',
      position: 'fixed',
      width: defaultWidth,
      padding: '0 10px 10px 10px',
      zIndex: 9998,
      WebkitBoxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      boxSizing: 'border-box',
      height: 'auto'
    },

    tl: {
      top: '0px',
      bottom: 'auto',
      left: '0px',
      right: 'auto'
    },

    tr: {
      top: '0px',
      bottom: 'auto',
      left: 'auto',
      right: '0px'
    },

    tc: {
      top: '0px',
      bottom: 'auto',
      margin: '0 auto',
      left: '50%',
      marginLeft: -(defaultWidth / 2)
    },

    bl: {
      top: 'auto',
      bottom: '0px',
      left: '0px',
      right: 'auto'
    },

    br: {
      top: 'auto',
      bottom: '0px',
      left: 'auto',
      right: '0px'
    },

    bc: {
      top: 'auto',
      bottom: '0px',
      margin: '0 auto',
      left: '50%',
      marginLeft: -(defaultWidth / 2)
    }

  },

  NotificationItem: {
    DefaultStyle: {
      position: 'relative',
      width: '100%',
      cursor: 'pointer',
      borderRadius: '2px',
      fontSize: '13px',
      margin: '10px 0 0',
      padding: '10px',
      display: 'block',
      WebkitBoxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      boxSizing: 'border-box',
      opacity: 0,
      transition: '0.3s ease-in-out',
      WebkitTransform: 'translate3d(0, 0, 0)',
      transform: 'translate3d(0, 0, 0)',
      willChange: 'transform, opacity',

      isHidden: {
        opacity: 0
      },

      isVisible: {
        opacity: 1
      }
    },

    success: {
      borderTop: '2px solid ' + defaultColors.success.hex,
      backgroundColor: '#f0f5ea',
      color: '#4b583a',
      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')',
      MozBoxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')',
      boxShadow: '0 0 1px rgba(' + defaultColors.success.rgb + ',' + defaultShadowOpacity + ')'
    },

    error: {
      borderTop: '2px solid ' + defaultColors.error.hex,
      backgroundColor: '#f4e9e9',
      color: '#412f2f',
      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')',
      MozBoxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')',
      boxShadow: '0 0 1px rgba(' + defaultColors.error.rgb + ',' + defaultShadowOpacity + ')'
    },

    warning: {
      borderTop: '2px solid ' + defaultColors.warning.hex,
      backgroundColor: '#f9f6f0',
      color: '#5a5343',
      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')',
      MozBoxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')',
      boxShadow: '0 0 1px rgba(' + defaultColors.warning.rgb + ',' + defaultShadowOpacity + ')'
    },

    info: {
      borderTop: '2px solid ' + defaultColors.info.hex,
      backgroundColor: '#e8f0f4',
      color: '#41555d',
      WebkitBoxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')',
      MozBoxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')',
      boxShadow: '0 0 1px rgba(' + defaultColors.info.rgb + ',' + defaultShadowOpacity + ')'
    }
  },

  Title: {
    DefaultStyle: {
      fontSize: '14px',
      margin: '0 0 5px 0',
      padding: 0,
      fontWeight: 'bold'
    },

    success: {
      color: defaultColors.success.hex
    },

    error: {
      color: defaultColors.error.hex
    },

    warning: {
      color: defaultColors.warning.hex
    },

    info: {
      color: defaultColors.info.hex
    }

  },

  MessageWrapper: {
    DefaultStyle: {
      margin: 0,
      padding: 0
    }
  },

  Dismiss: {
    DefaultStyle: {
      fontFamily: 'Arial',
      fontSize: '17px',
      position: 'absolute',
      top: '4px',
      right: '5px',
      lineHeight: '15px',
      backgroundColor: '#dededf',
      color: '#ffffff',
      borderRadius: '50%',
      width: '14px',
      height: '14px',
      fontWeight: 'bold',
      textAlign: 'center'
    },

    success: {
      color: '#f0f5ea',
      backgroundColor: '#b0ca92'
    },

    error: {
      color: '#f4e9e9',
      backgroundColor: '#e4bebe'
    },

    warning: {
      color: '#f9f6f0',
      backgroundColor: '#e1cfac'
    },

    info: {
      color: '#e8f0f4',
      backgroundColor: '#a4becb'
    }
  },

  Action: {
    DefaultStyle: {
      background: '#ffffff',
      borderRadius: '2px',
      padding: '6px 20px',
      fontWeight: 'bold',
      margin: '10px 0 0 0',
      border: 0
    },

    success: {
      backgroundColor: defaultColors.success.hex,
      color: '#ffffff'
    },

    error: {
      backgroundColor: defaultColors.error.hex,
      color: '#ffffff'
    },

    warning: {
      backgroundColor: defaultColors.warning.hex,
      color: '#ffffff'
    },

    info: {
      backgroundColor: defaultColors.info.hex,
      color: '#ffffff'
    }
  },

  ActionWrapper: {
    DefaultStyle: {
      margin: 0,
      padding: 0
    }
  }
};

module.exports = STYLES;


/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Drawer__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_close__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_menu__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_List_ListItem__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_List_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_List_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_List_List__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_List_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_List_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_List_makeSelectable__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_List_makeSelectable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_List_makeSelectable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Header_scss__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__Header_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var SelectableList = __WEBPACK_IMPORTED_MODULE_16_material_ui_List_makeSelectable___default()(__WEBPACK_IMPORTED_MODULE_15_material_ui_List_List___default.a);

var options = {
    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
    targetOrigin: { horizontal: 'left', vertical: 'top' }
};

var styles = {
    menuItem: {
        fontSize: '15px',
        minHeight: '36px',
        lineHeight: '36px'
    },
    btn: {
        style: { margin: '10px' },
        labelStyle: { fontSize: '12px' }
    }
};

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

        _this.state = {
            openDrawer: false,
            elTarget: null,
            isOpenPopover: false
        };

        _this.handlerUserLogout = _this.handlerUserLogout.bind(_this);
        _this.handleToggleDrawer = _this.handleToggleDrawer.bind(_this);
        _this.togglePopover = _this.togglePopover.bind(_this);
        _this.closePopover = _this.closePopover.bind(_this);
        _this.clearLocalStorage = _this.clearLocalStorage.bind(_this);
        _this.onNavigate = _this.onNavigate.bind(_this);
        return _this;
    }

    _createClass(Header, [{
        key: 'togglePopover',
        value: function togglePopover(e) {
            this.setState({
                isOpenPopover: !this.state.isOpenPopover,
                elTarget: e.target
            });
        }
    }, {
        key: 'handleToggleDrawer',
        value: function handleToggleDrawer() {
            return this.setState({
                openDrawer: !this.state.openDrawer
            });
        }
    }, {
        key: 'handlerUserLogout',
        value: function handlerUserLogout(e) {
            e.preventDefault();
            this.props.logoutUser();
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.setState({
                isOpenPopover: !this.state.isOpenPopover,
                elTarget: null
            });
        }
    }, {
        key: 'clearLocalStorage',
        value: function clearLocalStorage() {
            localStorage.clear();
            this.closePopover();
        }
    }, {
        key: 'onNavigate',
        value: function onNavigate(e, uri) {
            if (!uri) return;
            this.props.router.push(uri);
            this.handleToggleDrawer();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var user = this.props.user;
            var _state = this.state,
                isOpenPopover = _state.isOpenPopover,
                elTarget = _state.elTarget,
                openDrawer = _state.openDrawer;


            function isAdmin() {
                return __WEBPACK_IMPORTED_MODULE_13_store_configureStore__["a" /* UserPerms */].isAdmin();
            }

            var items = [{
                uri: '/dev-only',
                label: 'Розбійники',
                accessCheck: function accessCheck() {
                    return __WEBPACK_IMPORTED_MODULE_17_helpers__["a" /* default */].isDevAllowed(user);
                },
                style: { color: 'red' }
            }, {
                uri: '/varamar-only',
                label: 'Custom login (varamar)',
                accessCheck: function accessCheck() {
                    return __WEBPACK_IMPORTED_MODULE_17_helpers__["a" /* default */].isDevAllowed(user, ['admin@varamar.com']);
                },
                style: { color: 'red' }
            }, { uri: '/', label: 'Letters' }, { uri: '/cargoes/assigners', label: 'Cargo editor' }, { uri: '/cargoes/realnames', label: 'Cargo real names' }, { uri: '/cargoes/duplicates', label: 'Duplicates' }, { uri: '/cargoes/ldrates', label: 'Loading and discharging' }, { uri: '/regions/altports', label: 'Ports' }, { uri: '/regions/altareas', label: 'Areas' }, { uri: '/regions/ports', label: 'Ports approve/reject' }, { uri: '/flagCompliance', label: 'Flag compliance' }, { uri: '/detentions', label: 'Detentions' }, { uri: '/integrators/list', label: 'Integrators' }, { uri: '/cargoes/requests', label: 'Cargo requests' }, { uri: '/issues/list', label: 'Issue Reports' }, { uri: '/tc/requests', label: 'Timecharter requests' }, { uri: '/vessels/requests', label: 'Vessel requests' }, { uri: '/vessels/claims', label: 'Vessel claims' }, { uri: '/vessels/list', label: 'Vessel list' }, { uri: '/vessels/sales', label: 'Vessel sales' }, { uri: '/vessels/composition', label: 'Vessels composition' }, { uri: '/tcIndex', label: 'Tc Index' }, { uri: '/hires', label: 'Hires' }, { uri: '/regions/merging', label: 'Merging' }, { uri: '/regions/dashboard', label: 'Dashboard' }, { uri: '/gazetteer-editor', label: 'Gazetteer editor' }, { uri: '/notifications/list', label: 'Notifications' }, { uri: '/packing-list-recognition', label: 'Packing list', accessCheck: function accessCheck() {
                    return false && isAdmin();
                } }, {
                label: 'Statistics',
                accessCheck: isAdmin,
                items: [{ uri: '/statistics/vessel-updater', label: 'Vessel updater', accessCheck: isAdmin }, { uri: '/statistics/st', label: 'Analysts', accessCheck: isAdmin }, { uri: '/statistics/freight', label: 'Freight', accessCheck: function accessCheck() {
                        return false && isAdmin();
                    } }]
            }, {
                label: 'Statistics internal',
                accessCheck: isAdmin,
                items: [{ uri: '/statistics/queues', label: 'Statistics queues', accessCheck: isAdmin }]
            }, { uri: '/statistics/users', label: 'Statistics users', accessCheck: isAdmin }, { uri: '/statistics/emails', label: 'Statistics emails', accessCheck: isAdmin }, { uri: '/statistics/monitor', label: 'Statistics monitor', accessCheck: isAdmin }, { uri: '/statistics/composition', label: 'Statistics composition', accessCheck: isAdmin }, {
                label: 'Analytics',
                items: [{ uri: '/analytics/dashboard', label: 'Dashboard' }, { uri: '/analytics/mailers', label: 'Mailers' }]
            }, { uri: '/companies/realnames', label: 'Company real name', accessCheck: isAdmin }, {
                label: 'Users',
                accessCheck: isAdmin,
                items: [{ uri: '/users/black-and-white-lists', label: 'Black and White Lists', accessCheck: isAdmin }, { uri: '/users/ban-list', label: 'Users list', accessCheck: isAdmin }, { uri: '/users/subscribers', label: 'Subscribers', accessCheck: isAdmin }, { uri: '/users/suspicious', label: 'Suspicious sessions', accessCheck: isAdmin }]
            }, { uri: '/sender/list', label: 'Sender email list', accessCheck: isAdmin }, { uri: '/domains', label: 'Domains list', accessCheck: isAdmin }, { uri: '/time-charter', label: 'Time Charter', accessCheck: isAdmin }, { uri: '/disbursement', label: 'Disbursement', accessCheck: isAdmin }, { uri: '/fuel', label: 'Fuel', accessCheck: isAdmin }, { uri: '/pda', label: 'PDA', accessCheck: isAdmin }, { uri: '/cargoes/requests/ldRates', label: 'L/D Rates', accessCheck: isAdmin }];

            var userName = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.togglePopover },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Popover___default.a,
                    {
                        open: isOpenPopover,
                        anchorEl: elTarget,
                        onRequestClose: this.closePopover,
                        anchorOrigin: options.anchorOrigin,
                        targetOrigin: options.targetOrigin
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                        label: 'Delete local storage',
                        style: styles.btn.style,
                        labelStyle: styles.btn.labelStyle,
                        onClick: this.clearLocalStorage,
                        secondary: true
                    })
                ),
                user.email + ' ' + user.role
            );

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'header',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar___default.a, {
                    title: userName,
                    style: { zIndex: 1 },
                    iconElementLeft: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default.a,
                        { onClick: this.handleToggleDrawer },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_menu___default.a, { onClick: this.handleToggleDrawer })
                    ),
                    iconElementRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, { label: 'Logout', onClick: this.handlerUserLogout })
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_material_ui_Drawer___default.a,
                    {
                        docked: false,
                        width: 200,
                        open: openDrawer,
                        onRequestChange: function onRequestChange(openDrawer) {
                            return _this2.setState({ openDrawer: openDrawer });
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar___default.a, {
                        title: 'MENU',
                        iconElementLeft: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default.a,
                            { onClick: this.handleToggleDrawer },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_close___default.a, { onClick: this.handleToggleDrawer })
                        )
                    }),
                    newList(items, this.props.location.pathname, { onNavigate: this.onNavigate })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function renderItem(item, location) {
    var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { childSelected: false };

    if (item.accessCheck && !item.accessCheck()) {
        return null;
    }
    var props = {
        className: ['header-menu-item', item.className].filter(function (c) {
            return c;
        }).join(' ')
    };
    if (Array.isArray(item.items)) {
        props.nestedItems = item.items.map(function (i) {
            return renderItem(i, location, ctx);
        }).filter(function (i) {
            return i;
        });
        if (props.nestedItems.length === 0) {
            return null;
        }
    }
    if (item.uri == location) {
        ctx.childSelected = true;
    }
    if (ctx.childSelected) {
        props.initiallyOpen = true;
    }
    if (item.uri) {
        props.value = item.uri;
    } else {
        props.primaryTogglesNestedList = true;
    }

    props.innerDivStyle = {
        padding: '0 16px', lineHeight: '36px', fontSize: '15px', userSelect: 'none'
    };

    if (item.innerStyle) {
        Object.assign(props.innerDivStyle, item.innerStyle);
    }

    if (item.style) {
        props.style = item.style;
    }

    // TODO: differentiate active/inactive ListItem with nested items
    // maybe render right instead of down arrow when uri and nestedItems provided
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_List_ListItem___default.a, _extends({ key: item.uri || item.label, primaryText: item.label }, props));
}

function newList(items, location, _ref) {
    var onNavigate = _ref.onNavigate;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        SelectableList,
        { value: location, onChange: onNavigate, style: { height: 'calc(100% - 64px)', overflowY: 'auto' } },
        items.map(function (item) {
            return renderItem(item, location);
        })
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref2) {
    var user = _ref2.user.user;
    return {
        user: user
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        logoutUser: __WEBPACK_IMPORTED_MODULE_12_actions_users__["f" /* logoutUser */]
    }, dispatch);
})(Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["f" /* withRouter */])(Header));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SelectableList, 'SelectableList', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Header.jsx');
    reactHotLoader.register(options, 'options', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Header.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Header.jsx');
    reactHotLoader.register(Header, 'Header', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Header.jsx');
    reactHotLoader.register(renderItem, 'renderItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Header.jsx');
    reactHotLoader.register(newList, 'newList', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Header.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Layouts/Header.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(155);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FlatButtonLabel = __webpack_require__(1734);

var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

var FlatButton = function (_Component) {
  (0, _inherits3.default)(FlatButton, _Component);

  function FlatButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FlatButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      // Cancel hover styles for touch devices
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FlatButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({
          hovered: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          children = _props.children,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          hoverColor = _props.hoverColor,
          icon = _props.icon,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          primary = _props.primary,
          rippleColor = _props.rippleColor,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
      var _context$muiTheme = this.context.muiTheme,
          borderRadius = _context$muiTheme.borderRadius,
          _context$muiTheme$but = _context$muiTheme.button,
          buttonHeight = _context$muiTheme$but.height,
          buttonMinWidth = _context$muiTheme$but.minWidth,
          buttonTextTransform = _context$muiTheme$but.textTransform,
          _context$muiTheme$fla = _context$muiTheme.flatButton,
          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
          buttonColor = _context$muiTheme$fla.color,
          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
          fontSize = _context$muiTheme$fla.fontSize,
          fontWeight = _context$muiTheme$fla.fontWeight,
          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
          textColor = _context$muiTheme$fla.textColor,
          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;

      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;

      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
      var defaultRippleColor = buttonFilterColor;
      var buttonHoverColor = hoverColor || defaultHoverColor;
      var buttonRippleColor = rippleColor || defaultRippleColor;
      var buttonBackgroundColor = backgroundColor || buttonColor;
      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        height: buttonHeight,
        lineHeight: buttonHeight + 'px',
        minWidth: fullWidth ? '100%' : buttonMinWidth,
        color: defaultTextColor,
        transition: _transitions2.default.easeOut(),
        borderRadius: borderRadius,
        userSelect: 'none',
        overflow: 'hidden',
        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
        padding: 0,
        margin: 0,
        textAlign: 'center'
      }, style);

      var iconCloned = void 0;
      var labelStyleIcon = {};

      if (icon) {
        var iconStyles = (0, _simpleAssign2.default)({
          verticalAlign: 'middle',
          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
          marginRight: label && labelPosition === 'before' ? 12 : 0
        }, icon.props.style);
        iconCloned = _react2.default.cloneElement(icon, {
          color: icon.props.color || mergedRootStyles.color,
          style: iconStyles,
          key: 'iconCloned'
        });

        if (labelPosition === 'before') {
          labelStyleIcon.paddingRight = 8;
        } else {
          labelStyleIcon.paddingLeft = 8;
        }
      }

      var mergedLabelStyles = (0, _simpleAssign2.default)({
        letterSpacing: 0,
        textTransform: textTransform,
        fontWeight: fontWeight,
        fontSize: fontSize
      }, labelStyleIcon, labelStyle);

      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          focusRippleColor: buttonRippleColor,
          focusRippleOpacity: 0.3,
          onKeyboardFocus: this.handleKeyboardFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          touchRippleColor: buttonRippleColor,
          touchRippleOpacity: 0.3
        }),
        enhancedButtonChildren
      );
    }
  }]);
  return FlatButton;
}(_react.Component);

FlatButton.muiName = 'FlatButton';
FlatButton.defaultProps = {
  disabled: false,
  fullWidth: false,
  labelStyle: {},
  labelPosition: 'after',
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onTouchStart: function onTouchStart() {},
  primary: false,
  secondary: false
};
FlatButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButton.propTypes =  false ? {
  /**
   * Color of button when mouse is not hovering over it.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * This is what will be displayed inside the button.
   * If a label is specified, the text within the label prop will
   * be displayed. Otherwise, the component will expect children
   * which will then be displayed. (In our example,
   * we are nesting an `<input type="file" />` and a `span`
   * that acts as our label to be displayed.) This only
   * applies to flat and raised buttons.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The element to use as the container for the FlatButton. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * FlatButton in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * Disables the button if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Color of button when mouse hovers over.
   */
  hoverColor: _propTypes2.default.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * Use this property to display an icon.
   */
  icon: _propTypes2.default.node,
  /**
   * Label for the button.
   */
  label: validateLabel,
  /**
   * Place label before or after the passed children.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * If true, colors button according to
   * primaryTextColor from the Theme.
   */
  primary: _propTypes2.default.bool,
  /**
   * Color for the ripple after button is clicked.
   */
  rippleColor: _propTypes2.default.string,
  /**
   * If true, colors button according to secondaryTextColor from the theme.
   * The primary prop has precendent if set to true.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FlatButton;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1726), __esModule: true };

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1727);
module.exports = __webpack_require__(73).Object.assign;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(153);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1728) });


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(252);
var gOPS = __webpack_require__(454);
var pIE = __webpack_require__(314);
var toObject = __webpack_require__(249);
var IObject = __webpack_require__(648);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(218)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(266);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _ScaleInChild = __webpack_require__(1732);

var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleIn = function (_Component) {
  (0, _inherits3.default)(ScaleIn, _Component);

  function ScaleIn() {
    (0, _classCallCheck3.default)(this, ScaleIn);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          childStyle = _props.childStyle,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _ScaleInChild2.default,
          {
            key: child.key,
            enterDelay: enterDelay,
            maxScale: maxScale,
            minScale: minScale,
            style: childStyle
          },
          child
        );
      });

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);
  return ScaleIn;
}(_react.Component);

ScaleIn.defaultProps = {
  enterDelay: 0
};
ScaleIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ScaleIn;

/***/ }),
/* 1730 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(195);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleInChild = function (_Component) {
  (0, _inherits3.default)(ScaleInChild, _Component);

  function ScaleInChild() {
    (0, _classCallCheck3.default)(this, ScaleInChild);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);
  return ScaleInChild;
}(_react.Component);

ScaleInChild.defaultProps = {
  enterDelay: 0,
  maxScale: 1,
  minScale: 0
};
ScaleInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = ScaleInChild;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(194);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(195);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleRipple = function (_Component) {
  (0, _inherits3.default)(CircleRipple, _Component);

  function CircleRipple() {
    (0, _classCallCheck3.default)(this, CircleRipple);
    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircleRipple, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = 0;
      // If the animation is aborted, remove from the DOM immediately
      var removeAfter = this.props.aborted ? 0 : 2000;
      this.enterTimer = setTimeout(callback, removeAfter);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;
      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
      _autoPrefix2.default.set(style, 'transition', transitionValue);
      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = this.props.opacity;
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
      this.leaveTimer = setTimeout(callback, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          aborted = _props.aborted,
          color = _props.color,
          opacity = _props.opacity,
          style = _props.style,
          touchGenerated = _props.touchGenerated,
          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }, style);

      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
    }
  }]);
  return CircleRipple;
}(_react.Component);

CircleRipple.defaultProps = {
  opacity: 0.1,
  aborted: false
};
CircleRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircleRipple.propTypes =  false ? {
  aborted: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object,
  touchGenerated: _propTypes2.default.bool
} : {};
exports.default = CircleRipple;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      position: 'relative',
      paddingLeft: baseTheme.spacing.desktopGutterLess,
      paddingRight: baseTheme.spacing.desktopGutterLess,
      verticalAlign: 'middle'
    }
  };
}

var FlatButtonLabel = function (_Component) {
  (0, _inherits3.default)(FlatButtonLabel, _Component);

  function FlatButtonLabel() {
    (0, _classCallCheck3.default)(this, FlatButtonLabel);
    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlatButtonLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        label
      );
    }
  }]);
  return FlatButtonLabel;
}(_react.Component);

FlatButtonLabel.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButtonLabel.propTypes =  false ? {
  label: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = FlatButtonLabel;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(458);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getStyles = getStyles;

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = __webpack_require__(30);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _menu = __webpack_require__(493);

var _menu2 = _interopRequireDefault(_menu);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      appBar = _context$muiTheme.appBar,
      iconButtonSize = _context$muiTheme.button.iconButtonSize,
      zIndex = _context$muiTheme.zIndex;


  var flatButtonSize = 36;

  var styles = {
    root: {
      position: 'relative',
      zIndex: zIndex.appBar,
      width: '100%',
      display: 'flex',
      backgroundColor: appBar.color,
      paddingLeft: appBar.padding,
      paddingRight: appBar.padding
    },
    title: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: 0,
      paddingTop: 0,
      letterSpacing: 0,
      fontSize: 24,
      fontWeight: appBar.titleFontWeight,
      color: appBar.textColor,
      height: appBar.height,
      lineHeight: appBar.height + 'px'
    },
    mainElement: {
      boxFlex: 1,
      flex: '1'
    },
    iconButtonStyle: {
      marginTop: (appBar.height - iconButtonSize) / 2,
      marginRight: 8,
      marginLeft: -16
    },
    iconButtonIconStyle: {
      fill: appBar.textColor,
      color: appBar.textColor
    },
    flatButton: {
      color: appBar.textColor,
      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
    }
  };

  return styles;
}

var AppBar = function (_Component) {
  (0, _inherits3.default)(AppBar, _Component);

  function AppBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AppBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickLeftIconButton = function (event) {
      if (_this.props.onLeftIconButtonClick) {
        _this.props.onLeftIconButtonClick(event);
      }
    }, _this.handleClickRightIconButton = function (event) {
      if (_this.props.onRightIconButtonClick) {
        _this.props.onRightIconButtonClick(event);
      }
    }, _this.handleTitleClick = function (event) {
      if (_this.props.onTitleClick) {
        _this.props.onTitleClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AppBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;

       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          titleStyle = _props.titleStyle,
          iconStyleLeft = _props.iconStyleLeft,
          iconStyleRight = _props.iconStyleRight,
          onTitleClick = _props.onTitleClick,
          showMenuIconButton = _props.showMenuIconButton,
          iconElementLeft = _props.iconElementLeft,
          iconElementRight = _props.iconElementRight,
          iconClassNameLeft = _props.iconClassNameLeft,
          iconClassNameRight = _props.iconClassNameRight,
          onLeftIconButtonClick = _props.onLeftIconButtonClick,
          onRightIconButtonClick = _props.onRightIconButtonClick,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth,
          children = _props.children,
          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleClick', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonClick', 'onRightIconButtonClick', 'className', 'style', 'zDepth', 'children']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var menuElementLeft = void 0;
      var menuElementRight = void 0;

      // If the title is a string, wrap in an h1 tag.
      // If not, wrap in a div tag.
      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';

      var titleElement = _react2.default.createElement(titleComponent, {
        onClick: this.handleTitleClick,
        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
      }, title);

      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);

      if (showMenuIconButton) {
        if (iconElementLeft) {
          var iconElementLeftProps = {};

          if (iconElementLeft.type.muiName === 'IconButton') {
            var iconElemLeftChildren = iconElementLeft.props.children;
            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;

            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
          }

          if (!iconElementLeft.props.onClick && this.props.onLeftIconButtonClick) {
            iconElementLeftProps.onClick = this.handleClickLeftIconButton;
          }

          menuElementLeft = _react2.default.createElement(
            'div',
            { style: prepareStyles(iconLeftStyle) },
            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
          );
        } else {
          menuElementLeft = _react2.default.createElement(
            _IconButton2.default,
            {
              style: iconLeftStyle,
              iconStyle: styles.iconButtonIconStyle,
              iconClassName: iconClassNameLeft,
              onClick: this.handleClickLeftIconButton
            },
            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
          );
        }
      }

      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
        marginRight: -16,
        marginLeft: 'auto'
      }, iconStyleRight);

      if (iconElementRight) {
        var iconElementRightProps = {};

        switch (iconElementRight.type.muiName) {
          case 'IconMenu':
          case 'IconButton':
            var iconElemRightChildren = iconElementRight.props.children;
            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;

            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
            break;

          case 'FlatButton':
            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
            break;

          default:
        }

        if (!iconElementRight.props.onClick && this.props.onRightIconButtonClick) {
          iconElementRightProps.onClick = this.handleClickRightIconButton;
        }

        menuElementRight = _react2.default.createElement(
          'div',
          { style: prepareStyles(iconRightStyle) },
          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
        );
      } else if (iconClassNameRight) {
        menuElementRight = _react2.default.createElement(_IconButton2.default, {
          style: iconRightStyle,
          iconStyle: styles.iconButtonIconStyle,
          iconClassName: iconClassNameRight,
          onClick: this.handleClickRightIconButton
        });
      }

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({}, other, {
          rounded: false,
          className: className,
          style: (0, _simpleAssign2.default)({}, styles.root, style),
          zDepth: zDepth
        }),
        menuElementLeft,
        titleElement,
        menuElementRight,
        children
      );
    }
  }]);
  return AppBar;
}(_react.Component);

AppBar.muiName = 'AppBar';
AppBar.defaultProps = {
  showMenuIconButton: true,
  title: '',
  zDepth: 1
};
AppBar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
AppBar.propTypes =  false ? {
  /**
   * Can be used to render a tab inside an app bar for instance.
   */
  children: _propTypes2.default.node,
  /**
   * Applied to the app bar's root element.
   */
  className: _propTypes2.default.string,
  /**
   * The classname of the icon on the left of the app bar.
   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
   */
  iconClassNameLeft: _propTypes2.default.string,
  /**
   * Similiar to the iconClassNameLeft prop except that
   * it applies to the icon displayed on the right of the app bar.
   */
  iconClassNameRight: _propTypes2.default.string,
  /**
   * The custom element to be displayed on the left side of the
   * app bar such as an SvgIcon.
   */
  iconElementLeft: _propTypes2.default.element,
  /**
   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
   */
  iconElementRight: _propTypes2.default.element,
  /**
   * Override the inline-styles of the element displayed on the left side of the app bar.
   */
  iconStyleLeft: _propTypes2.default.object,
  /**
   * Override the inline-styles of the element displayed on the right side of the app bar.
   */
  iconStyleRight: _propTypes2.default.object,
  /**
   * Callback function for when the left icon is selected via a click.
   *
   * @param {object} event Click event targeting the left `IconButton`.
   */
  onLeftIconButtonClick: _propTypes2.default.func,
  /**
   * Callback function for when the right icon is selected via a click.
   *
   * @param {object} event Click event targeting the right `IconButton`.
   */
  onRightIconButtonClick: _propTypes2.default.func,
  /**
   * Callback function for when the title text is selected via a click.
   *
   * @param {object} event Click event targeting the `title` node.
   */
  onTitleClick: _propTypes2.default.func,
  /**
   * Determines whether or not to display the Menu icon next to the title.
   * Setting this prop to false will hide the icon.
   */
  showMenuIconButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The title to display on the app bar.
   */
  title: _propTypes2.default.node,
  /**
   * Override the inline-styles of the app bar's title element.
   */
  titleStyle: _propTypes2.default.object,
  /**
   * The zDepth of the component.
   * The shadow of the app bar is also dependent on this property.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = AppBar;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var color = props.color,
      hoverColor = props.hoverColor;
  var baseTheme = context.muiTheme.baseTheme;

  var offColor = color || baseTheme.palette.textColor;
  var onColor = hoverColor || offColor;

  return {
    root: {
      color: state.hovered ? onColor : offColor,
      position: 'relative',
      fontSize: baseTheme.spacing.iconSize,
      display: 'inline-block',
      userSelect: 'none',
      transition: _transitions2.default.easeOut()
    }
  };
}

var FontIcon = function (_Component) {
  (0, _inherits3.default)(FontIcon, _Component);

  function FontIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FontIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: false });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FontIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hoverColor = _props.hoverColor,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
      }));
    }
  }]);
  return FontIcon;
}(_react.Component);

FontIcon.muiName = 'FontIcon';
FontIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
FontIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FontIcon.propTypes =  false ? {
  /**
   * This is the font color of the font icon. If not specified,
   * this component will default to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FontIcon;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _setDisplayName = __webpack_require__(742);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(743);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function (_Component) {
  (0, _inherits3.default)(SvgIcon, _Component);

  function SvgIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SvgIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleMouseEnter = function (event) {
      _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SvgIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          color = _props.color,
          hoverColor = _props.hoverColor,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          style = _props.style,
          viewBox = _props.viewBox,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
      var _context$muiTheme = this.context.muiTheme,
          svgIcon = _context$muiTheme.svgIcon,
          prepareStyles = _context$muiTheme.prepareStyles;


      var offColor = color ? color : 'currentColor';
      var onColor = hoverColor ? hoverColor : offColor;

      var mergedStyles = (0, _simpleAssign2.default)({
        display: 'inline-block',
        color: svgIcon.color,
        fill: this.state.hovered ? onColor : offColor,
        height: 24,
        width: 24,
        userSelect: 'none',
        transition: _transitions2.default.easeOut()
      }, style);

      return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({}, other, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          style: prepareStyles(mergedStyles),
          viewBox: viewBox
        }),
        children
      );
    }
  }]);
  return SvgIcon;
}(_react.Component);

SvgIcon.muiName = 'SvgIcon';
SvgIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  viewBox: '0 0 24 24'
};
SvgIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SvgIcon.propTypes =  false ? {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * This is the fill color of the svg icon.
   * If not specified, this component will default
   * to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Allows you to redefine what the coordinates
   * without units mean inside an svg element. For example,
   * if the SVG element is 500 (width) by 200 (height), and you
   * pass viewBox="0 0 50 20", this means that the coordinates inside
   * the svg will go from the top left corner (0,0) to bottom right (50,20)
   * and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};
exports.default = SvgIcon;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var rounded = props.rounded,
      circle = props.circle,
      transitionEnabled = props.transitionEnabled,
      zDepth = props.zDepth;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      paper = _context$muiTheme.paper,
      borderRadius = _context$muiTheme.borderRadius;


  return {
    root: {
      color: paper.color,
      backgroundColor: paper.backgroundColor,
      transition: transitionEnabled && _transitions2.default.easeOut(),
      boxSizing: 'border-box',
      fontFamily: baseTheme.fontFamily,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
    }
  };
}

var Paper = function (_Component) {
  (0, _inherits3.default)(Paper, _Component);

  function Paper() {
    (0, _classCallCheck3.default)(this, Paper);
    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
  }

  (0, _createClass3.default)(Paper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          circle = _props.circle,
          rounded = _props.rounded,
          style = _props.style,
          transitionEnabled = _props.transitionEnabled,
          zDepth = _props.zDepth,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return Paper;
}(_react.Component);

Paper.defaultProps = {
  circle: false,
  rounded: true,
  transitionEnabled: true,
  zDepth: 1
};
Paper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Paper.propTypes =  false ? {
  /**
   * Children passed into the paper element.
   */
  children: _propTypes2.default.node,
  /**
   * Set to true to generate a circular paper container.
   */
  circle: _propTypes2.default.bool,
  /**
   * By default, the paper container will have a border radius.
   * Set this to false to generate a container with sharp corners.
   */
  rounded: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Set to false to disable CSS transitions for the paper element.
   */
  transitionEnabled: _propTypes2.default.bool,
  /**
   * This number represents the zDepth of the paper shadow.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Paper;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(155);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      button = _context$muiTheme.button,
      raisedButton = _context$muiTheme.raisedButton,
      borderRadius = _context$muiTheme.borderRadius;
  var disabled = props.disabled,
      disabledBackgroundColor = props.disabledBackgroundColor,
      disabledLabelColor = props.disabledLabelColor,
      fullWidth = props.fullWidth,
      icon = props.icon,
      label = props.label,
      labelPosition = props.labelPosition,
      primary = props.primary,
      secondary = props.secondary,
      style = props.style;


  var amount = primary || secondary ? 0.4 : 0.08;

  var backgroundColor = raisedButton.color;
  var labelColor = raisedButton.textColor;

  if (disabled) {
    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
  } else if (primary) {
    backgroundColor = raisedButton.primaryColor;
    labelColor = raisedButton.primaryTextColor;
  } else if (secondary) {
    backgroundColor = raisedButton.secondaryColor;
    labelColor = raisedButton.secondaryTextColor;
  } else {
    if (props.backgroundColor) {
      backgroundColor = props.backgroundColor;
    }
    if (props.labelColor) {
      labelColor = props.labelColor;
    }
  }

  var buttonHeight = style && style.height || button.height;

  return {
    root: {
      display: 'inline-block',
      transition: _transitions2.default.easeOut(),
      minWidth: fullWidth ? '100%' : button.minWidth
    },
    button: {
      height: buttonHeight,
      lineHeight: buttonHeight + 'px',
      width: '100%',
      padding: 0,
      borderRadius: borderRadius,
      transition: _transitions2.default.easeOut(),
      backgroundColor: backgroundColor,
      // That's the default value for a button but not a link
      textAlign: 'center'
    },
    label: {
      position: 'relative',
      opacity: 1,
      fontSize: raisedButton.fontSize,
      letterSpacing: 0,
      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
      fontWeight: raisedButton.fontWeight,
      margin: 0,
      userSelect: 'none',
      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
      color: labelColor
    },
    icon: {
      verticalAlign: 'middle',
      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
      marginRight: label && labelPosition === 'before' ? 12 : 0
    },
    overlay: {
      height: buttonHeight,
      borderRadius: borderRadius,
      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
      transition: _transitions2.default.easeOut(),
      top: 0
    },
    ripple: {
      color: labelColor,
      opacity: !(primary || secondary) ? 0.1 : 0.16
    }
  };
}

var RaisedButton = function (_Component) {
  (0, _inherits3.default)(RaisedButton, _Component);

  function RaisedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RaisedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      keyboardFocused: false,
      touched: false,
      initialZDepth: 0,
      zDepth: 0
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.setState({
          zDepth: _this.state.initialZDepth + 1
        });
      }
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
    }, _this.handleMouseUp = function (event) {
      _this.setState({
        zDepth: _this.state.initialZDepth
      });
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.state.keyboardFocused) {
        _this.setState({
          zDepth: _this.state.initialZDepth,
          hovered: false
        });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.keyboardFocused && !_this.state.touched) {
        _this.setState({
          hovered: true
        });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({
        touched: true,
        zDepth: _this.state.initialZDepth + 1
      });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleTouchEnd = function (event) {
      _this.setState({
        touched: true,
        zDepth: _this.state.initialZDepth
      });

      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;

      _this.setState({
        zDepth: zDepth,
        keyboardFocused: keyboardFocused
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RaisedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var zDepth = this.props.disabled ? 0 : 1;
      this.setState({
        zDepth: zDepth,
        initialZDepth: zDepth
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var zDepth = nextProps.disabled ? 0 : 1;
      var nextState = {
        zDepth: zDepth,
        initialZDepth: zDepth
      };

      if (nextProps.disabled) {
        nextState.hovered = false;
      }

      this.setState(nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          buttonStyle = _props.buttonStyle,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          disabledBackgroundColor = _props.disabledBackgroundColor,
          disabledLabelColor = _props.disabledLabelColor,
          fullWidth = _props.fullWidth,
          icon = _props.icon,
          label = _props.label,
          labelColor = _props.labelColor,
          labelPosition = _props.labelPosition,
          labelStyle = _props.labelStyle,
          overlayStyle = _props.overlayStyle,
          primary = _props.primary,
          rippleStyle = _props.rippleStyle,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);

      var buttonEventHandlers = disabled ? {} : {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd,
        onKeyboardFocus: this.handleKeyboardFocus
      };

      var labelElement = label && _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)), key: 'labelElement' },
        label
      );

      var iconCloned = icon && (0, _react.cloneElement)(icon, {
        color: icon.props.color || styles.label.color,
        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style),
        key: 'iconCloned'
      });

      var overlayBackgroundProxy = {
        backgroundColor: overlayStyle && styles.overlay.backgroundColor && overlayStyle.backgroundColor || styles.overlay.backgroundColor
      };

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(
        _Paper2.default,
        {
          className: className,
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: this.state.zDepth
        },
        _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({}, other, buttonEventHandlers, {
            ref: 'container',
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
            focusRippleColor: mergedRippleStyles.color,
            touchRippleColor: mergedRippleStyles.color,
            focusRippleOpacity: mergedRippleStyles.opacity,
            touchRippleOpacity: mergedRippleStyles.opacity
          }),
          _react2.default.createElement(
            'div',
            {
              ref: 'overlay',
              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle, overlayBackgroundProxy))
            },
            enhancedButtonChildren
          )
        )
      );
    }
  }]);
  return RaisedButton;
}(_react.Component);

RaisedButton.muiName = 'RaisedButton';
RaisedButton.defaultProps = {
  disabled: false,
  labelPosition: 'after',
  fullWidth: false,
  primary: false,
  secondary: false
};
RaisedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RaisedButton.propTypes =  false ? {
  /**
   * Override the default background color for the button,
   * but not the default disabled background color
   * (use `disabledBackgroundColor` for this).
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the button element.
   */
  buttonStyle: _propTypes2.default.object,
  /**
   * The content of the button.
   * If a label is provided via the `label` prop, the text within the label
   * will be displayed in addition to the content provided here.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
    * The element to use as the container for the RaisedButton. Either a string to
    * use a DOM element or a ReactElement. This is useful for wrapping the
    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
    * that it passes all of its given props through to the underlying DOM
    * element and renders its children prop for proper integration.
    */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * If true, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the default background color for the button
   * when it is disabled.
   */
  disabledBackgroundColor: _propTypes2.default.string,
  /**
   * The color of the button's label when the button is disabled.
   */
  disabledLabelColor: _propTypes2.default.string,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * An icon to be displayed within the button.
   */
  icon: _propTypes2.default.node,
  /**
   * The label to be displayed within the button.
   * If content is provided via the `children` prop, that content will be
   * displayed in addition to the label provided here.
   */
  label: validateLabel,
  /**
   * The color of the button's label.
   */
  labelColor: _propTypes2.default.string,
  /**
   * The position of the button's label relative to the button's `children`.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline style of the button overlay.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * If true, the button will use the theme's primary color.
   */
  primary: _propTypes2.default.bool,
  /**
   * Override the inline style of the ripple element.
   */
  rippleStyle: _propTypes2.default.object,
  /**
   * If true, the button will use the theme's secondary color.
   * If both `secondary` and `primary` are true, the button will use
   * the theme's primary color.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = RaisedButton;

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(744);

var assertThisInitialized = __webpack_require__(1746);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1749);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1751);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
      maxHeight: '100%'
    },
    horizontal: {
      maxHeight: '100%',
      overflowY: 'auto',
      transform: open ? 'scaleX(1)' : 'scaleX(0)',
      opacity: open ? 1 : 0,
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
    },
    vertical: {
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
    }
  };
}

var PopoverAnimationDefault = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationDefault, _Component);

  function PopoverAnimationDefault() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationDefault, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.horizontal) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.vertical) },
            this.props.children
          )
        )
      );
    }
  }]);
  return PopoverAnimationDefault;
}(_react.Component);

PopoverAnimationDefault.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationDefault.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationDefault.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationDefault;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _autoPrefix = __webpack_require__(195);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _Overlay = __webpack_require__(747);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openNavEventHandler = null;

var Drawer = function (_Component) {
  (0, _inherits3.default)(Drawer, _Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOverlay = function (event) {
      event.preventDefault();
      _this.close('clickaway');
    }, _this.handleKeyUp = function (event) {
      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
        _this.close('escape');
      }
    }, _this.onBodyTouchStart = function (event) {
      var swipeAreaWidth = _this.props.swipeAreaWidth;

      var touchStartX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var touchStartY = event.touches[0].pageY;

      // Open only if swiping from far left (or right) while closed
      if (swipeAreaWidth !== null && !_this.state.open) {
        if (_this.props.openSecondary) {
          // If openSecondary is true calculate from the far right
          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
        } else {
          // If openSecondary is false calculate from the far left
          if (touchStartX > swipeAreaWidth) return;
        }
      }

      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
        return;
      }

      _this.maybeSwiping = true;
      _this.touchStartX = touchStartX;
      _this.touchStartY = touchStartY;

      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
    }, _this.onBodyTouchMove = function (event) {
      var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = event.touches[0].pageY;

      if (_this.state.swiping) {
        event.preventDefault();
        _this.setPosition(_this.getTranslateX(currentX));
      } else if (_this.maybeSwiping) {
        var dXAbs = Math.abs(currentX - _this.touchStartX);
        var dYAbs = Math.abs(currentY - _this.touchStartY);
        // If the user has moved his thumb ten pixels in either direction,
        // we can safely make an assumption about whether he was intending
        // to swipe or scroll.
        var threshold = 10;

        if (dXAbs > threshold && dYAbs <= threshold) {
          _this.swipeStartX = currentX;
          _this.setState({
            swiping: _this.state.open ? 'closing' : 'opening'
          });
          _this.setPosition(_this.getTranslateX(currentX));
        } else if (dXAbs <= threshold && dYAbs > threshold) {
          _this.onBodyTouchEnd();
        }
      }
    }, _this.onBodyTouchEnd = function (event) {
      if (_this.state.swiping) {
        var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();

        _this.maybeSwiping = false;
        var swiping = _this.state.swiping;
        _this.setState({
          swiping: null
        });

        // We have to open or close after setting swiping to null,
        // because only then CSS transition is enabled.
        if (translateRatio > 0.5) {
          if (swiping === 'opening') {
            _this.setPosition(_this.getMaxTranslateX());
          } else {
            _this.close('swipe');
          }
        } else {
          if (swiping === 'opening') {
            _this.open('swipe');
          } else {
            _this.setPosition(0);
          }
        }
      } else {
        _this.maybeSwiping = false;
      }

      _this.removeBodyTouchListeners();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Drawer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.maybeSwiping = false;
      this.touchStartX = null;
      this.touchStartY = null;
      this.swipeStartX = null;

      this.setState({
        open: this.props.open !== null ? this.props.open : this.props.docked,
        swiping: null
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.enableSwipeHandling();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If controlled then the open prop takes precedence.
      if (nextProps.open !== null) {
        this.setState({
          open: nextProps.open
        });
        // Otherwise, if docked is changed, change the open state for when uncontrolled.
      } else if (this.props.docked !== nextProps.docked) {
        this.setState({
          open: nextProps.docked
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.enableSwipeHandling();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.disableSwipeHandling();
      this.removeBodyTouchListeners();
    }
  }, {
    key: 'getStyles',
    value: function getStyles() {
      var muiTheme = this.context.muiTheme;
      var theme = muiTheme.drawer;

      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());

      var styles = {
        root: {
          height: '100%',
          width: this.getTranslatedWidth() || theme.width,
          position: 'fixed',
          zIndex: muiTheme.zIndex.drawer,
          left: 0,
          top: 0,
          transform: 'translate(' + x + 'px, 0)',
          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
          backgroundColor: theme.color,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch' // iOS momentum scrolling
        },
        overlay: {
          zIndex: muiTheme.zIndex.drawerOverlay,
          pointerEvents: this.state.open ? 'auto' : 'none' // Bypass mouse events when left nav is closing.
        },
        rootWhenOpenRight: {
          left: 'auto',
          right: 0
        }
      };

      return styles;
    }
  }, {
    key: 'shouldShow',
    value: function shouldShow() {
      return this.state.open || !!this.state.swiping; // component is swiping
    }
  }, {
    key: 'close',
    value: function close(reason) {
      if (this.props.open === null) this.setState({ open: false });
      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
      return this;
    }
  }, {
    key: 'open',
    value: function open(reason) {
      if (this.props.open === null) this.setState({ open: true });
      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
      return this;
    }
  }, {
    key: 'getTranslatedWidth',
    value: function getTranslatedWidth() {
      if (typeof this.props.width === 'string') {
        if (!/^\d+(\.\d+)?%$/.test(this.props.width)) {
          throw new Error('Not a valid percentage format.');
        }
        var width = parseFloat(this.props.width) / 100.0;
        // We are doing our best on the Server to render a consistent UI, hence the
        // default value of 10000
        return typeof window !== 'undefined' ? width * window.innerWidth : 10000;
      } else {
        return this.props.width;
      }
    }
  }, {
    key: 'getMaxTranslateX',
    value: function getMaxTranslateX() {
      var width = this.getTranslatedWidth() || this.context.muiTheme.drawer.width;
      return width + 10;
    }
  }, {
    key: 'getTranslateMultiplier',
    value: function getTranslateMultiplier() {
      return this.props.openSecondary ? 1 : -1;
    }
  }, {
    key: 'enableSwipeHandling',
    value: function enableSwipeHandling() {
      if (!this.props.docked) {
        document.body.addEventListener('touchstart', this.onBodyTouchStart);
        if (!openNavEventHandler) {
          openNavEventHandler = this.onBodyTouchStart;
        }
      } else {
        this.disableSwipeHandling();
      }
    }
  }, {
    key: 'disableSwipeHandling',
    value: function disableSwipeHandling() {
      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
      if (openNavEventHandler === this.onBodyTouchStart) {
        openNavEventHandler = null;
      }
    }
  }, {
    key: 'removeBodyTouchListeners',
    value: function removeBodyTouchListeners() {
      document.body.removeEventListener('touchmove', this.onBodyTouchMove);
      document.body.removeEventListener('touchend', this.onBodyTouchEnd);
      document.body.removeEventListener('touchcancel', this.onBodyTouchEnd);
    }
  }, {
    key: 'setPosition',
    value: function setPosition(translateX) {
      var rtlTranslateMultiplier = this.context.muiTheme.isRtl ? -1 : 1;
      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
      var transformCSS = 'translate(' + this.getTranslateMultiplier() * rtlTranslateMultiplier * translateX + 'px, 0)';
      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
    }
  }, {
    key: 'getTranslateX',
    value: function getTranslateX(currentX) {
      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          containerClassName = _props.containerClassName,
          containerStyle = _props.containerStyle,
          docked = _props.docked,
          openSecondary = _props.openSecondary,
          overlayClassName = _props.overlayClassName,
          overlayStyle = _props.overlayStyle,
          style = _props.style,
          zDepth = _props.zDepth;


      var styles = this.getStyles();

      var overlay = void 0;
      if (!docked) {
        overlay = _react2.default.createElement(_Overlay2.default, {
          ref: 'overlay',
          show: this.shouldShow(),
          className: overlayClassName,
          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
          transitionEnabled: !this.state.swiping,
          onClick: this.handleClickOverlay
        });
      }

      return _react2.default.createElement(
        'div',
        {
          className: className,
          style: style
        },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
        overlay,
        _react2.default.createElement(
          _Paper2.default,
          {
            ref: 'clickAwayableElement',
            zDepth: zDepth,
            rounded: false,
            transitionEnabled: !this.state.swiping,
            className: containerClassName,
            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
          },
          children
        )
      );
    }
  }]);
  return Drawer;
}(_react.Component);

Drawer.defaultProps = {
  disableSwipeToOpen: false,
  docked: true,
  open: null,
  openSecondary: false,
  swipeAreaWidth: 30,
  width: null,
  zDepth: 2
};
Drawer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Drawer.propTypes =  false ? {
  /**
   * The contents of the `Drawer`
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The CSS class name of the container element.
   */
  containerClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If true, swiping sideways when the `Drawer` is closed will not open it.
   */
  disableSwipeToOpen: _propTypes2.default.bool,
  /**
   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
   * clicking on a menu item will not close the `Drawer`.
   */
  docked: _propTypes2.default.bool,
  /**
   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
   *
   * @param {boolean} open If true, the `Drawer` was requested to be opened.
   * @param {string} reason The reason for the open or close request. Possible values are
   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
   * 'escape' (on escape key press), and 'swipe' for close requests.
   */
  onRequestChange: _propTypes2.default.func,
  /**
   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
   * into a controlled component.
   */
  open: _propTypes2.default.bool,
  /**
   * If true, the `Drawer` is positioned to open from the opposite side.
   */
  openSecondary: _propTypes2.default.bool,
  /**
   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
   */
  overlayClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The width of the left most (or right most) area in pixels where the `Drawer` can be
   * swiped open from. Setting this to `null` spans that area to the entire page
   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
   * swipeable `Tabs`: use at your own risk).
   */
  swipeAreaWidth: _propTypes2.default.number,
  /**
   * The width of the `Drawer` in pixels or percentage in string format ex. `50%` to fill
   * half of the window or `100%` and so on. Defaults to using the values from theme.
   */
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * The zDepth of the `Drawer`.
   */
  zDepth: _propTypes4.default.zDepth

} : {};
exports.default = Drawer;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalBodyOverflow = null;
var lockingCounter = 0;

var AutoLockScrolling = function (_Component) {
  (0, _inherits3.default)(AutoLockScrolling, _Component);

  function AutoLockScrolling() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AutoLockScrolling);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AutoLockScrolling, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.lock === true) {
        this.preventScrolling();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.lock !== nextProps.lock) {
        if (nextProps.lock) {
          this.preventScrolling();
        } else {
          this.allowScrolling();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.allowScrolling();
    }

    // force to only lock/unlock once

  }, {
    key: 'preventScrolling',
    value: function preventScrolling() {
      if (this.locked === true) {
        return;
      }

      lockingCounter = lockingCounter + 1;
      this.locked = true;

      // only lock the first time the component is mounted.
      if (lockingCounter === 1) {
        var body = document.getElementsByTagName('body')[0];
        originalBodyOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
      }
    }
  }, {
    key: 'allowScrolling',
    value: function allowScrolling() {
      if (this.locked === true) {
        lockingCounter = lockingCounter - 1;
        this.locked = false;
      }

      if (lockingCounter === 0 && originalBodyOverflow !== null) {
        var body = document.getElementsByTagName('body')[0];
        body.style.overflow = originalBodyOverflow || '';
        originalBodyOverflow = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return AutoLockScrolling;
}(_react.Component);

AutoLockScrolling.propTypes =  false ? {
  lock: _propTypes2.default.bool.isRequired
} : {};
exports.default = AutoLockScrolling;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = __webpack_require__(348);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NestedList = function NestedList(props) {
  var children = props.children,
      open = props.open,
      nestedLevel = props.nestedLevel,
      style = props.style;


  if (!open) {
    return null;
  }

  return _react2.default.createElement(
    _List2.default,
    { style: style },
    _react.Children.map(children, function (child) {
      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
        nestedLevel: nestedLevel + 1
      }) : child;
    })
  );
};

NestedList.propTypes =  false ? {
  children: _propTypes2.default.node,
  nestedLevel: _propTypes2.default.number.isRequired,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = NestedList;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subheader = function Subheader(props, context) {
  var children = props.children,
      inset = props.inset,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
  var _context$muiTheme = context.muiTheme,
      prepareStyles = _context$muiTheme.prepareStyles,
      subheader = _context$muiTheme.subheader;


  var styles = {
    root: {
      boxSizing: 'border-box',
      color: subheader.color,
      fontSize: 14,
      fontWeight: subheader.fontWeight,
      lineHeight: '48px',
      paddingLeft: inset ? 72 : 16,
      width: '100%'
    }
  };

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
    children
  );
};

Subheader.muiName = 'Subheader';

Subheader.propTypes =  false ? {
  /**
   * Node that will be placed inside the `Subheader`.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the `Subheader` will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

Subheader.defaultProps = {
  inset: false
};

Subheader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = Subheader;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128449
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(1761);
var parser = __webpack_require__(499);
var Manager = __webpack_require__(751);
var debug = __webpack_require__(138)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(751);
exports.Socket = __webpack_require__(757);


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(749);
var debug = __webpack_require__(138)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || (typeof location !== 'undefined' && location);
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1763);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1763 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(349);
var isBuf = __webpack_require__(750);
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1766 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(1768);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(229);


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var transports = __webpack_require__(752);
var Emitter = __webpack_require__(227);
var debug = __webpack_require__(138)('engine.io-client:socket');
var index = __webpack_require__(756);
var parser = __webpack_require__(229);
var parseuri = __webpack_require__(749);
var parseqs = __webpack_require__(350);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (typeof location !== 'undefined' && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (typeof location !== 'undefined' ? location.hostname : 'localhost');
  this.port = opts.port || (typeof location !== 'undefined' && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // detect ReactNative environment
  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

  // other options for Node.js or ReactNative client
  if (typeof self === 'undefined' || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(501);
Socket.transports = __webpack_require__(752);
Socket.parser = __webpack_require__(229);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0),
    isReactNative: this.isReactNative
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};


/***/ }),
/* 1769 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

/* global attachEvent */

/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(500);
var Polling = __webpack_require__(753);
var Emitter = __webpack_require__(227);
var inherit = __webpack_require__(351);
var debug = __webpack_require__(138)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          try {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (self.supportsBinary && contentType === 'application/octet-stream') {
              xhr.responseType = 'arraybuffer';
            }
          } catch (e) {}
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (typeof document !== 'undefined') {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (typeof document !== 'undefined') {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== 'undefined') {
  if (typeof attachEvent === 'function') {
    attachEvent('onunload', unloadHandler);
  } else if (typeof addEventListener === 'function') {
    var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}


/***/ }),
/* 1771 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 1772 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 1774 */
/***/ (function(module, exports) {

/*! https://mths.be/utf8js v2.1.2 by @mathias */

var stringFromCharCode = String.fromCharCode;

// Taken from https://mths.be/punycode
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	var value;
	var extra;
	while (counter < length) {
		value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// high surrogate, and there is a next character
			extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // low surrogate
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// unmatched surrogate; only append this code unit, in case the next
				// code unit is the high surrogate of a surrogate pair
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

// Taken from https://mths.be/punycode
function ucs2encode(array) {
	var length = array.length;
	var index = -1;
	var value;
	var output = '';
	while (++index < length) {
		value = array[index];
		if (value > 0xFFFF) {
			value -= 0x10000;
			output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
			value = 0xDC00 | value & 0x3FF;
		}
		output += stringFromCharCode(value);
	}
	return output;
}

function checkScalarValue(codePoint, strict) {
	if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
		if (strict) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
		return false;
	}
	return true;
}
/*--------------------------------------------------------------------------*/

function createByte(codePoint, shift) {
	return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
}

function encodeCodePoint(codePoint, strict) {
	if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
		return stringFromCharCode(codePoint);
	}
	var symbol = '';
	if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
		symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	}
	else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
		if (!checkScalarValue(codePoint, strict)) {
			codePoint = 0xFFFD;
		}
		symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
		symbol += createByte(codePoint, 6);
	}
	else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
		symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
		symbol += createByte(codePoint, 12);
		symbol += createByte(codePoint, 6);
	}
	symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	return symbol;
}

function utf8encode(string, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	var codePoints = ucs2decode(string);
	var length = codePoints.length;
	var index = -1;
	var codePoint;
	var byteString = '';
	while (++index < length) {
		codePoint = codePoints[index];
		byteString += encodeCodePoint(codePoint, strict);
	}
	return byteString;
}

/*--------------------------------------------------------------------------*/

function readContinuationByte() {
	if (byteIndex >= byteCount) {
		throw Error('Invalid byte index');
	}

	var continuationByte = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	if ((continuationByte & 0xC0) == 0x80) {
		return continuationByte & 0x3F;
	}

	// If we end up here, it’s not a continuation byte
	throw Error('Invalid continuation byte');
}

function decodeSymbol(strict) {
	var byte1;
	var byte2;
	var byte3;
	var byte4;
	var codePoint;

	if (byteIndex > byteCount) {
		throw Error('Invalid byte index');
	}

	if (byteIndex == byteCount) {
		return false;
	}

	// Read first byte
	byte1 = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	// 1-byte sequence (no continuation bytes)
	if ((byte1 & 0x80) == 0) {
		return byte1;
	}

	// 2-byte sequence
	if ((byte1 & 0xE0) == 0xC0) {
		byte2 = readContinuationByte();
		codePoint = ((byte1 & 0x1F) << 6) | byte2;
		if (codePoint >= 0x80) {
			return codePoint;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 3-byte sequence (may include unpaired surrogates)
	if ((byte1 & 0xF0) == 0xE0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
		if (codePoint >= 0x0800) {
			return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 4-byte sequence
	if ((byte1 & 0xF8) == 0xF0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		byte4 = readContinuationByte();
		codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
			(byte3 << 0x06) | byte4;
		if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
			return codePoint;
		}
	}

	throw Error('Invalid UTF-8 detected');
}

var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	byteArray = ucs2decode(byteString);
	byteCount = byteArray.length;
	byteIndex = 0;
	var codePoints = [];
	var tmp;
	while ((tmp = decodeSymbol(strict)) !== false) {
		codePoints.push(tmp);
	}
	return ucs2encode(codePoints);
}

module.exports = {
	version: '2.1.2',
	encode: utf8encode,
	decode: utf8decode
};


/***/ }),
/* 1775 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 1776 */
/***/ (function(module, exports) {

/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
  false;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      return buf;
    }

    return chunk;
  });
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
};

if (typeof Blob !== 'undefined') {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var Polling = __webpack_require__(753);
var inherit = __webpack_require__(351);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * Until https://github.com/tc39/proposal-global is shipped.
 */
function glob () {
  return typeof self !== 'undefined' ? self
      : typeof window !== 'undefined' ? window
      : typeof global !== 'undefined' ? global : {};
}

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    var global = glob();
    callbacks = global.___eio = (global.___eio || []);
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (typeof addEventListener === 'function') {
    addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(501);
var parser = __webpack_require__(229);
var parseqs = __webpack_require__(350);
var inherit = __webpack_require__(351);
var yeast = __webpack_require__(755);
var debug = __webpack_require__(138)('engine.io-client:websocket');
var BrowserWebSocket, NodeWebSocket;
if (typeof self === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(1779);
  } catch (e) { }
} else {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket || NodeWebSocket;

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket && !this.isReactNative ? (protocols ? new WebSocket(uri, protocols) : new WebSocket(uri)) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228).Buffer))

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 1781 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_users__ = __webpack_require__(124);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Login = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

        _this.handlerAuth = _this.handlerAuth.bind(_this);
        return _this;
    }

    _createClass(Login, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.querySelector('.login-wrapper').classList.add('show');
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                isLogged = _props.isLogged,
                router = _props.router;

            if (isLogged) {
                router.push(this.getRedirectUrl());
            }
        }
    }, {
        key: 'getRedirectUrl',
        value: function getRedirectUrl() {
            return this.props.router.location.query.backUrl || '/';
        }
    }, {
        key: 'handlerAuth',
        value: function handlerAuth(e) {
            e.preventDefault();

            this.props.authUser(this.inputEmail.input.value, this.inputPassword.input.value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'login-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'login-wrapper' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'login-title' },
                        'SHIPNEXT ADMIN PANEL'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        { onSubmit: this.handlerAuth },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                            ref: function ref(inputEmail) {
                                _this2.inputEmail = inputEmail;
                            },
                            hintText: 'EMAIL',
                            type: 'email',
                            name: 'email',
                            required: true
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                            ref: function ref(inputPassword) {
                                _this2.inputPassword = inputPassword;
                            },
                            hintText: 'PASSWORD',
                            type: 'password',
                            name: 'password',
                            required: true
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: this.props.errorMessage ? 'error' : 'hidden' },
                            this.props.errorMessage
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, { onSubmit: this.handlerAuth, label: 'login', type: 'submit' })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        errorMessage: state.user.message
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        authUser: __WEBPACK_IMPORTED_MODULE_5_actions_users__["b" /* authUser */]
    }, dispatch);
})(Login);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Login, 'Login', '/opt/atlassian/pipelines/agent/build/client/app/components/Pages/Login.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Pages/Login.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(194);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedTextarea = __webpack_require__(1784);

var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);

var _TextFieldHint = __webpack_require__(1785);

var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);

var _TextFieldLabel = __webpack_require__(1786);

var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);

var _TextFieldUnderline = __webpack_require__(1787);

var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyles = function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      _context$muiTheme$tex = _context$muiTheme.textField,
      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
      focusColor = _context$muiTheme$tex.focusColor,
      textColor = _context$muiTheme$tex.textColor,
      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
      backgroundColor = _context$muiTheme$tex.backgroundColor,
      errorColor = _context$muiTheme$tex.errorColor;


  var styles = {
    root: {
      fontSize: 16,
      lineHeight: '24px',
      width: props.fullWidth ? '100%' : 256,
      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
      display: 'inline-block',
      position: 'relative',
      backgroundColor: backgroundColor,
      fontFamily: baseTheme.fontFamily,
      transition: _transitions2.default.easeOut('200ms', 'height'),
      cursor: props.disabled ? 'not-allowed' : 'auto'
    },
    error: {
      position: 'relative',
      bottom: 2,
      fontSize: 12,
      lineHeight: '12px',
      color: errorColor,
      transition: _transitions2.default.easeOut()
    },
    floatingLabel: {
      color: props.disabled ? disabledTextColor : floatingLabelColor,
      pointerEvents: 'none'
    },
    input: {
      padding: 0,
      position: 'relative',
      width: '100%',
      border: 'none',
      outline: 'none',
      backgroundColor: 'rgba(0,0,0,0)',
      color: props.disabled ? disabledTextColor : textColor,
      cursor: 'inherit',
      font: 'inherit',
      WebkitOpacity: 1,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated style).
    },
    inputNative: {
      appearance: 'textfield' // Improve type search style.
    }
  };

  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
    marginTop: props.floatingLabelText ? 36 : 12,
    marginBottom: props.floatingLabelText ? -36 : -12,
    boxSizing: 'border-box',
    font: 'inherit'
  });

  // Do not assign a height to the textarea as he handles it on his own.
  styles.input.height = '100%';

  if (state.isFocused) {
    styles.floatingLabel.color = focusColor;
  }

  if (props.floatingLabelText) {
    styles.input.boxSizing = 'border-box';

    if (!props.multiLine) {
      styles.input.marginTop = 14;
    }

    if (state.errorText) {
      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
    }
  }

  if (state.errorText) {
    if (state.isFocused) {
      styles.floatingLabel.color = styles.error.color;
    }
  }

  return styles;
};

/**
 * Check if a value is valid to be displayed inside an input.
 *
 * @param The value to check.
 * @returns True if the string provided is valid, false otherwise.
 */
function isValid(value) {
  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
}

var TextField = function (_Component) {
  (0, _inherits3.default)(TextField, _Component);

  function TextField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocused: false,
      errorText: undefined,
      hasValue: false
    }, _this.handleInputBlur = function (event) {
      _this.setState({ isFocused: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleInputChange = function (event) {
      if (!_this.props.hasOwnProperty('value')) {
        _this.setState({ hasValue: isValid(event.target.value) });
      }
      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    }, _this.handleInputFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }
      _this.setState({ isFocused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleHeightChange = function (event, height) {
      var newHeight = height + 24;
      if (_this.props.floatingLabelText) {
        newHeight += 24;
      }
      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextField, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          hintText = _props.hintText,
          floatingLabelText = _props.floatingLabelText,
          id = _props.id;


      var propsLeaf = children ? children.props : this.props;

      this.setState({
        errorText: this.props.errorText,
        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
      });

       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;

      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled && !this.props.disabled) {
        this.setState({
          isFocused: false
        });
      }

      if (nextProps.errorText !== this.props.errorText) {
        this.setState({
          errorText: nextProps.errorText
        });
      }

      if (nextProps.children && nextProps.children.props) {
        nextProps = nextProps.children.props;
      }

      if (nextProps.hasOwnProperty('value')) {
        var hasValue = isValid(nextProps.value);

        this.setState({
          hasValue: hasValue
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'blur',
    value: function blur() {
      if (this.input) {
        this.getInputNode().blur();
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.input) {
        this.getInputNode().focus();
      }
    }
  }, {
    key: 'select',
    value: function select() {
      if (this.input) {
        this.getInputNode().select();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input ? this.getInputNode().value : undefined;
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
    }
  }, {
    key: '_isControlled',
    value: function _isControlled() {
      return this.props.hasOwnProperty('value');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          errorStyle = _props2.errorStyle,
          errorText = _props2.errorText,
          floatingLabelFixed = _props2.floatingLabelFixed,
          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
          floatingLabelStyle = _props2.floatingLabelStyle,
          floatingLabelText = _props2.floatingLabelText,
          fullWidth = _props2.fullWidth,
          hintText = _props2.hintText,
          hintStyle = _props2.hintStyle,
          id = _props2.id,
          inputStyle = _props2.inputStyle,
          multiLine = _props2.multiLine,
          onBlur = _props2.onBlur,
          onChange = _props2.onChange,
          onFocus = _props2.onFocus,
          style = _props2.style,
          type = _props2.type,
          underlineDisabledStyle = _props2.underlineDisabledStyle,
          underlineFocusStyle = _props2.underlineFocusStyle,
          underlineShow = _props2.underlineShow,
          underlineStyle = _props2.underlineStyle,
          rows = _props2.rows,
          rowsMax = _props2.rowsMax,
          textareaStyle = _props2.textareaStyle,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var inputId = id || this.uniqueId;

      var errorTextElement = this.state.errorText && _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
        this.state.errorText
      );

      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
        _TextFieldLabel2.default,
        {
          muiTheme: this.context.muiTheme,
          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
          shrinkStyle: floatingLabelShrinkStyle,
          htmlFor: inputId,
          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
          disabled: disabled
        },
        floatingLabelText
      );

      var inputProps = {
        id: inputId,
        ref: function ref(elem) {
          return _this2.input = elem;
        },
        disabled: this.props.disabled,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus
      };

      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);

      var inputElement = void 0;
      if (children) {
        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
        }));
      } else {
        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
          style: childStyleMerged,
          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
          rows: rows,
          rowsMax: rowsMax,
          hintText: hintText
        }, other, inputProps, {
          onHeightChange: this.handleHeightChange
        })) : _react2.default.createElement('input', (0, _extends3.default)({
          type: type,
          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
        }, other, inputProps));
      }

      var rootProps = {};

      if (children) {
        rootProps = other;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rootProps, {
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }),
        floatingLabelTextElement,
        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
          muiTheme: this.context.muiTheme,
          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
          style: hintStyle,
          text: hintText
        }) : null,
        inputElement,
        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
          disabled: disabled,
          disabledStyle: underlineDisabledStyle,
          error: !!this.state.errorText,
          errorStyle: errorStyle,
          focus: this.state.isFocused,
          focusStyle: underlineFocusStyle,
          muiTheme: this.context.muiTheme,
          style: underlineStyle
        }) : null,
        errorTextElement
      );
    }
  }]);
  return TextField;
}(_react.Component);

TextField.defaultProps = {
  disabled: false,
  floatingLabelFixed: false,
  multiLine: false,
  fullWidth: false,
  type: 'text',
  underlineShow: true,
  rows: 1
};
TextField.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TextField.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The text string to use for the default value.
   */
  defaultValue: _propTypes2.default.any,
  /**
   * Disables the text field if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The style object to use to override error styles.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * The error content to display.
   */
  errorText: _propTypes2.default.node,
  /**
   * If true, the floating label will float even when there is no value.
   */
  floatingLabelFixed: _propTypes2.default.bool,
  /**
   * The style object to use to override floating label styles when focused.
   */
  floatingLabelFocusStyle: _propTypes2.default.object,
  /**
   * The style object to use to override floating label styles when shrunk.
   */
  floatingLabelShrinkStyle: _propTypes2.default.object,
  /**
   * The style object to use to override floating label styles.
   */
  floatingLabelStyle: _propTypes2.default.object,
  /**
   * The content to use for the floating label element.
   */
  floatingLabelText: _propTypes2.default.node,
  /**
   * If true, the field receives the property width 100%.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the TextField's hint text element.
   */
  hintStyle: _propTypes2.default.object,
  /**
   * The hint content to display.
   */
  hintText: _propTypes2.default.node,
  /**
   * The id prop for the text field.
   */
  id: _propTypes2.default.string,
  /**
   * Override the inline-styles of the TextField's input element.
   * When multiLine is false: define the style of the input element.
   * When multiLine is true: define the style of the container of the textarea.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * If true, a textarea element will be rendered.
   * The textarea also grows and shrinks according to the number of lines.
   */
  multiLine: _propTypes2.default.bool,
  /**
   * Name applied to the input.
   */
  name: _propTypes2.default.string,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function that is fired when the textfield's value changes.
   *
   * @param {object} event Change event targeting the text field.
   * @param {string} newValue The new value of the text field.
   */
  onChange: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Number of rows to display when multiLine option is set to true.
   */
  rows: _propTypes2.default.number,
  /**
   * Maximum number of rows to display when
   * multiLine option is set to true.
   */
  rowsMax: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the TextField's textarea element.
   * The TextField use either a textarea or an input,
   * this property has effects only when multiLine is true.
   */
  textareaStyle: _propTypes2.default.object,
  /**
   * Specifies the type of input to display
   * such as "password" or "text".
   */
  type: _propTypes2.default.string,
  /**
   * Override the inline-styles of the
   * TextField's underline element when disabled.
   */
  underlineDisabledStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the TextField's
   * underline element when focussed.
   */
  underlineFocusStyle: _propTypes2.default.object,
  /**
   * If true, shows the underline for the text field.
   */
  underlineShow: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the TextField's underline element.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * The value of the text field.
   */
  value: _propTypes2.default.any
} : {};
exports.default = TextField;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rowsHeight = 24;

function getStyles(props, context, state) {
  return {
    root: {
      position: 'relative' // because the shadow has position: 'absolute'
    },
    textarea: {
      height: state.height,
      width: '100%',
      resize: 'none',
      font: 'inherit',
      padding: 0,
      cursor: 'inherit'
    },
    shadow: {
      resize: 'none',
      // Overflow also needed to here to remove the extra row
      // added to textareas in Firefox.
      overflow: 'hidden',
      // Visibility needed to hide the extra text area on ipads
      visibility: 'hidden',
      position: 'absolute',
      height: 'auto'
    }
  };
}

var EnhancedTextarea = function (_Component) {
  (0, _inherits3.default)(EnhancedTextarea, _Component);

  function EnhancedTextarea() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedTextarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: null
    }, _this.handleResize = function (event) {
      _this.syncHeightWithShadow(_this.props.value, event);
    }, _this.handleChange = function (event) {
      if (!_this.props.hasOwnProperty('value')) {
        _this.syncHeightWithShadow(event.target.value);
      }

      if (_this.props.hasOwnProperty('valueLink')) {
        _this.props.valueLink.requestChange(event.target.value);
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedTextarea, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        height: this.props.rows * rowsHeight
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow(this.props.value);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
        this.syncHeightWithShadow(nextProps.value, null, nextProps);
      }
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.refs.input;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.getInputNode().value = value;
      this.syncHeightWithShadow(value);
    }
  }, {
    key: 'syncHeightWithShadow',
    value: function syncHeightWithShadow(newValue, event, props) {
      var shadow = this.refs.shadow;
      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;

      if (displayText !== undefined) {
        shadow.value = displayText;
      }

      var newHeight = shadow.scrollHeight;

      // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013
      if (newHeight === undefined) return;

      props = props || this.props;

      if (props.rowsMax >= props.rows) {
        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
      }

      newHeight = Math.max(newHeight, rowsHeight);

      if (this.state.height !== newHeight) {
        var input = this.refs.input;
        var cursorPosition = input.selectionEnd;
        this.setState({
          height: newHeight
        }, function () {
          input.setSelectionRange(cursorPosition, cursorPosition);
        });

        if (props.onHeightChange) {
          props.onHeightChange(event, newHeight);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          onHeightChange = _props.onHeightChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          shadowStyle = _props.shadowStyle,
          style = _props.style,
          hintText = _props.hintText,
          textareaStyle = _props.textareaStyle,
          valueLink = _props.valueLink,
          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
      var props = {};

      if (this.props.hasOwnProperty('valueLink')) {
        other.value = valueLink.value;
        props.valueLink = valueLink;
      }

      return _react2.default.createElement(
        'div',
        { style: prepareStyles(rootStyles) },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement('textarea', (0, _extends3.default)({
          ref: 'shadow',
          style: prepareStyles(shadowStyles),
          tabIndex: '-1',
          rows: this.props.rows,
          defaultValue: this.props.defaultValue,
          readOnly: true,
          value: this.props.value
        }, props)),
        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
          ref: 'input',
          rows: this.props.rows,
          style: prepareStyles(textareaStyles),
          onChange: this.handleChange
        }))
      );
    }
  }]);
  return EnhancedTextarea;
}(_react.Component);

EnhancedTextarea.defaultProps = {
  rows: 1
};
EnhancedTextarea.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedTextarea.propTypes =  false ? {
  defaultValue: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  hintText: _propTypes2.default.node,
  onChange: _propTypes2.default.func,
  onHeightChange: _propTypes2.default.func,
  rows: _propTypes2.default.number,
  rowsMax: _propTypes2.default.number,
  shadowStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  textareaStyle: _propTypes2.default.object,
  value: _propTypes2.default.string,
  valueLink: _propTypes2.default.object
} : {};
exports.default = EnhancedTextarea;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var hintColor = props.muiTheme.textField.hintColor,
      show = props.show;


  return {
    root: {
      position: 'absolute',
      opacity: show ? 1 : 0,
      color: hintColor,
      transition: _transitions2.default.easeOut(),
      bottom: 12
    }
  };
}

var TextFieldHint = function TextFieldHint(props) {
  var prepareStyles = props.muiTheme.prepareStyles,
      style = props.style,
      text = props.text;


  var styles = getStyles(props);

  return _react2.default.createElement(
    'div',
    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
    text
  );
};

TextFieldHint.propTypes =  false ? {
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * True if the hint text should be visible.
   */
  show: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The hint text displayed.
   */
  text: _propTypes2.default.node
} : {};

TextFieldHint.defaultProps = {
  show: true
};

exports.default = TextFieldHint;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  var defaultStyles = {
    position: 'absolute',
    lineHeight: '22px',
    top: 38,
    transition: _transitions2.default.easeOut(),
    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
    transform: 'scale(1) translate(0, 0)',
    transformOrigin: 'left top',
    pointerEvents: 'auto',
    userSelect: 'none'
  };

  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
    transform: 'scale(0.75) translate(0, -28px)',
    pointerEvents: 'none'
  }, props.shrinkStyle) : null;

  return {
    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
  };
}

var TextFieldLabel = function TextFieldLabel(props) {
  var muiTheme = props.muiTheme,
      className = props.className,
      children = props.children,
      htmlFor = props.htmlFor,
      onClick = props.onClick;
  var prepareStyles = muiTheme.prepareStyles;

  var styles = getStyles(props);

  return _react2.default.createElement(
    'label',
    {
      className: className,
      style: prepareStyles(styles.root),
      htmlFor: htmlFor,
      onClick: onClick
    },
    children
  );
};

TextFieldLabel.propTypes =  false ? {
  /**
   * The label contents.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the label if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The id of the target element that this label should refer to.
   */
  htmlFor: _propTypes2.default.string,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * Callback function for when the label is selected via a click.
   *
   * @param {object} event Click event targeting the text field label.
   */
  onClick: _propTypes2.default.func,
  /**
   * True if the floating label should shrink.
   */
  shrink: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element when shrunk.
   */
  shrinkStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

TextFieldLabel.defaultProps = {
  disabled: false,
  shrink: false
};

exports.default = TextFieldLabel;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * True if the parent `TextField` is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is disabled.
   */
  disabledStyle: _propTypes2.default.object,
  /**
   * True if the parent `TextField` has an error.
   */
  error: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` has an error.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * True if the parent `TextField` is focused.
   */
  focus: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underline when parent `TextField` is focused.
   */
  focusStyle: _propTypes2.default.object,
  /**
   * @ignore
   * The material-ui theme applied to this component.
   */
  muiTheme: _propTypes2.default.object.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
};

var defaultProps = {
  disabled: false,
  disabledStyle: {},
  error: false,
  errorStyle: {},
  focus: false,
  focusStyle: {},
  style: {}
};

var TextFieldUnderline = function TextFieldUnderline(props) {
  var disabled = props.disabled,
      disabledStyle = props.disabledStyle,
      error = props.error,
      errorStyle = props.errorStyle,
      focus = props.focus,
      focusStyle = props.focusStyle,
      muiTheme = props.muiTheme,
      style = props.style;
  var errorStyleColor = errorStyle.color;
  var prepareStyles = muiTheme.prepareStyles,
      _muiTheme$textField = muiTheme.textField,
      borderColor = _muiTheme$textField.borderColor,
      disabledTextColor = _muiTheme$textField.disabledTextColor,
      errorColor = _muiTheme$textField.errorColor,
      focusColor = _muiTheme$textField.focusColor;


  var styles = {
    root: {
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      borderColor: borderColor,
      bottom: 8,
      boxSizing: 'content-box',
      margin: 0,
      position: 'absolute',
      width: '100%'
    },
    disabled: {
      borderBottomStyle: 'dotted',
      borderBottomWidth: 2,
      borderColor: disabledTextColor
    },
    focus: {
      borderBottomStyle: 'solid',
      borderBottomWidth: 2,
      borderColor: focusColor,
      transform: 'scaleX(0)',
      transition: _transitions2.default.easeOut()
    },
    error: {
      borderColor: errorStyleColor ? errorStyleColor : errorColor,
      transform: 'scaleX(1)'
    }
  };

  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);

  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(underline) }),
    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(focusedUnderline) })
  );
};

TextFieldUnderline.propTypes =  false ? propTypes : {};
TextFieldUnderline.defaultProps = defaultProps;

exports.default = TextFieldUnderline;

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RabbitModal__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_IconMenu__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_IconMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_IconMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_navigation_more_vert__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_navigation_more_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_navigation_more_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BrokerMailsModal__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_letters__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_defaults__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_defaults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_styles_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__OpenAll__ = __webpack_require__(1871);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









































var styles = _extends({}, __WEBPACK_IMPORTED_MODULE_21_styles_index__["a" /* default */], {
    radioGroup: {
        margin: '20px 0'
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle'
    },
    typeWidth: {
        width: '16%'
    },
    statusWidth: {
        width: '25%'
    },
    checkboxGroup: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-evenly'
    },
    checkboxGroupTitle: {
        margin: 0,
        marginRight: '1em',
        fontWeight: 'normal'
    }
});

var LettersPage = function (_React$Component) {
    _inherits(LettersPage, _React$Component);

    function LettersPage(props) {
        var _this2 = this;

        _classCallCheck(this, LettersPage);

        var _this = _possibleConstructorReturn(this, (LettersPage.__proto__ || Object.getPrototypeOf(LettersPage)).call(this, props));

        _this.handleOpenRabbitMenu = function () {
            _this.setState({ openRabbitDialog: true });
        };

        _this.handleCloseRabbitMenu = function () {
            _this.setState({ openRabbitDialog: false });
        };

        _this.handleToggleShowUniqueBrokerMails = function () {
            _this.setState({
                pagination: _extends({}, _this.state.pagination, {
                    showUniqueBrokerMails: !_this.state.pagination.showUniqueBrokerMails
                })
            });
        };

        _this.handleChangeIsNosaFilter = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(field, value) {
                var _pagination;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _pagination = __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.cloneDeep(_this.state.pagination);


                                __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.set(_pagination, 'nosaFilter.' + field, value);

                                if (_pagination.nosaFilter.isNosa && !_pagination.nosaFilter.isNotNosa) {
                                    __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.set(_pagination, 'isNosa', true);
                                } else if (!_pagination.nosaFilter.isNosa && _pagination.nosaFilter.isNotNosa) {
                                    __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.set(_pagination, 'isNosa', false);
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.set(_pagination, 'isNosa', undefined);
                                }

                                _this.setState({
                                    pagination: _pagination
                                });

                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_18_store_configureStore__["b" /* execute */])(_this.loadLetters, _pagination);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleOpenAsGazettersDialog = function () {
            _this.setState({
                openAsGazettersDialog: !_this.state.openAsGazettersDialog
            });
        };

        var pagination = {};
        try {
            var json = localStorage.getItem('pagination' + _this.props.userId);
            pagination = JSON.parse(json);
        } catch (err) {}

        pagination = __WEBPACK_IMPORTED_MODULE_20_lodash_defaults___default()(pagination, {
            page: 1,
            search: '',
            typeMail: '',
            statusMail: '',
            archive: false,
            fix: false,
            eh: [],
            limit: 25,
            brokerMails: [],
            listeners: [],
            showUniqueBrokerMails: false,
            isNosa: undefined,
            nosaFilter: {
                isNosa: undefined,
                isNotNosa: undefined
            }
        });

        _this.state = {
            showSpinner: true,
            rowsPerPage: [10, 25, 50],
            openBrokerFilterDialog: false,
            pagination: pagination,
            failedEmailsAmount: '',
            newEmailsAmount: '',
            toDevAmount: '',
            openRabbitDialog: false,
            openRabbitMenu: false,
            openAsGazettersDialog: false,
            rabbitObj: {
                id: '',
                subject: '',
                text: '',
                type: ''
            }
        };

        _this.updateRows = _this.updateRows.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.changeTypeMails = _this.changeTypeMails.bind(_this);
        _this.changeStatusMails = _this.changeStatusMails.bind(_this);
        _this.handleChangeEh = _this.handleChangeEh.bind(_this);
        _this.filterWithAttachments = _this.filterWithAttachments.bind(_this);
        _this.changeToArchiveLetters = _this.changeToArchiveLetters.bind(_this);
        _this.handleChangePagination = _this.handleChangePagination.bind(_this);

        _this.handleStartDateFilter = _this.handleStartDateFilter.bind(_this);
        _this.handleEndDateFilter = _this.handleEndDateFilter.bind(_this);

        _this.handleRemoveDate = _this.handleRemoveDate.bind(_this);

        _this.handleResendEmailsChange = _this.handleResendEmailsChange.bind(_this);
        _this.handleResendEmails = _this.handleResendEmails.bind(_this);
        _this.handleChangeSendToDev = _this.handleChangeSendToDev.bind(_this);
        _this.handleSendToDev = _this.handleSendToDev.bind(_this);
        _this.handleToggleBrokerFilterDialog = _this.handleToggleBrokerFilterDialog.bind(_this);
        _this.handleFilterBroker = _this.handleFilterBroker.bind(_this);
        _this.handleOpenRabbitDialog = _this.handleOpenRabbitDialog.bind(_this);
        _this.handleCloseRabbitDialog = _this.handleCloseRabbitDialog.bind(_this);
        _this.sendToRabbit = _this.sendToRabbit.bind(_this);
        return _this;
    }

    _createClass(LettersPage, [{
        key: 'handleChangeEh',
        value: function handleChangeEh(e, value) {
            var _this3 = this;

            var eh = e.target.dataset.eh;

            var pagination = _extends({}, this.state.pagination, {
                page: 1,
                eh: [].concat(_toConsumableArray(this.state.pagination.eh))
            });
            if (value) {
                pagination.eh.push(eh);
            } else {
                pagination.eh = pagination.eh.filter(function (i) {
                    return i !== eh;
                });
            }

            if (!pagination.eh.includes('broker')) {
                pagination.brokerMails = [];
                pagination.listeners = [];
            }

            this.setState({
                pagination: pagination
            }, function () {
                _this3.updateRows(_this3.state);
            });
        }
    }, {
        key: 'filterWithAttachments',
        value: function filterWithAttachments() {
            var _this4 = this;

            this.setState(function (state) {
                return {
                    pagination: _extends({}, state.pagination, {
                        page: 1,
                        withAttachments: !state.pagination.withAttachments
                    })
                };
            }, function () {
                _this4.updateRows(_this4.state);
            });
        }
    }, {
        key: 'changeToArchiveLetters',
        value: function changeToArchiveLetters(e, value) {
            var _this5 = this;

            var d = new Date();
            var dateStart = void 0;
            if (value && !this.state.dateStart) {
                dateStart = Object(__WEBPACK_IMPORTED_MODULE_23_helpers_dates__["d" /* toUTC */])(d.setMonth(d.getMonth() - 3));
            }

            var pagination = _extends({}, this.state.pagination, {
                dateStart: dateStart,
                page: 1,
                archive: value
            });

            this.setState({
                pagination: pagination
            }, function () {
                _this5.updateRows(_this5.state);
            });
        }
    }, {
        key: 'changeTypeMails',
        value: function changeTypeMails(e, value) {
            var _this6 = this;

            var pagination = _extends({}, this.state.pagination, {
                page: 1,
                typeMail: value
            });

            this.setState({
                pagination: pagination
            }, function () {
                _this6.updateRows(_this6.state);
            });
        }
    }, {
        key: 'changeStatusMails',
        value: function changeStatusMails(e, value) {
            var _this7 = this;

            var pagination = _extends({}, this.state.pagination, {
                page: 1,
                statusMail: value
            });

            this.setState({
                pagination: pagination
            }, function () {
                _this7.updateRows(_this7.state);
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch() {
            var _this8 = this;

            var pagination = _extends({}, this.state.pagination, {
                page: 1,
                search: this.refs.search.input.value
            });

            this.setState({
                pagination: pagination
            }, function () {
                _this8.updateRows(_this8.state);
            });
        }
    }, {
        key: 'handleChangePagination',
        value: function handleChangePagination(_ref2) {
            var _this9 = this;

            var page = _ref2.page,
                numberOfRows = _ref2.numberOfRows;

            this.setState({
                pagination: _extends({}, this.state.pagination, {
                    page: page,
                    limit: numberOfRows
                })
            }, function () {
                _this9.updateRows(_this9.state);
            });
        }
    }, {
        key: 'updateRows',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state) {
                var pagination;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                pagination = _extends({}, state.pagination);
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_18_store_configureStore__["b" /* execute */])(this.loadLetters, pagination);

                            case 3:

                                this.setState({
                                    pagination: pagination
                                });

                                this.saveToLocalStorage(pagination);

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function updateRows(_x3) {
                return _ref3.apply(this, arguments);
            }

            return updateRows;
        }()
    }, {
        key: 'loadLetters',
        value: /*#__PURE__*/regeneratorRuntime.mark(function loadLetters(pagination) {
            var response;
            return regeneratorRuntime.wrap(function loadLetters$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_19_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_16_services_letters__["c" /* getLetters */], pagination);

                        case 2:
                            response = _context3.sent;

                            if (!(response.status === 400)) {
                                _context3.next = 8;
                                break;
                            }

                            pagination.page = 1;
                            _context3.next = 7;
                            return Object(__WEBPACK_IMPORTED_MODULE_19_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_16_services_letters__["c" /* getLetters */], pagination);

                        case 7:
                            response = _context3.sent;

                        case 8:
                            _context3.next = 10;
                            return Object(__WEBPACK_IMPORTED_MODULE_19_redux_saga_effects__["c" /* put */])({
                                type: __WEBPACK_IMPORTED_MODULE_17_constants_ActionTypes__["_32" /* GET_LETTERS */],
                                data: response
                            });

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, loadLetters, this);
        })
    }, {
        key: 'saveToLocalStorage',
        value: function saveToLocalStorage(pagination) {
            localStorage.setItem('pagination' + this.props.userId, JSON.stringify(pagination));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this10 = this;

            this.updateRows(this.state).then(function () {
                return _this10.setState({
                    showSpinner: false
                });
            });
        }
    }, {
        key: 'handleStartDateFilter',
        value: function handleStartDateFilter(e, date) {
            var _this11 = this;

            var pagination = _extends({}, this.state.pagination, {
                page: 1,
                dateStart: Object(__WEBPACK_IMPORTED_MODULE_23_helpers_dates__["d" /* toUTC */])(date)
            });

            this.setState({
                pagination: pagination
            }, function () {
                _this11.updateRows(_this11.state);
            });
        }
    }, {
        key: 'handleEndDateFilter',
        value: function handleEndDateFilter(e, date) {
            var _this12 = this;

            var newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59));
            var pagination = _extends({}, this.state.pagination, {
                page: 1,
                dateEnd: newDate.toISOString()
            });

            this.setState({
                pagination: pagination
            }, function () {
                _this12.updateRows(_this12.state);
            });
        }
    }, {
        key: 'handleRemoveDate',
        value: function handleRemoveDate(type) {
            var _this13 = this;

            var state = __WEBPACK_IMPORTED_MODULE_26_lodash___default.a.cloneDeep(this.state);
            var ls = JSON.parse(localStorage['pagination' + this.props.userId]);

            if (type === 'start') {
                delete state.pagination.dateStart;
                delete ls.dateStart;
            } else if (type === 'end') {
                delete state.pagination.dateEnd;
                delete ls.dateEnd;
            }

            this.setState(_extends({}, state), function () {
                _this13.updateRows(_this13.state);
            });
            localStorage.setItem('pagination' + this.props.userId, JSON.stringify(ls));
        }
    }, {
        key: 'handleResendEmailsChange',
        value: function handleResendEmailsChange(ev, emailStatus) {
            this.setState(_defineProperty({}, emailStatus + 'EmailsAmount', ev.target.value));
        }
    }, {
        key: 'handleChangeSendToDev',
        value: function handleChangeSendToDev(ev) {
            this.setState({
                toDevAmount: ev.target.value
            });
        }
    }, {
        key: 'handleSendToDev',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(mailStatus) {
                var toDevAmount, response;
                return regeneratorRuntime.wrap(function _callee3$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                toDevAmount = this.state.toDevAmount;

                                if (toDevAmount) {
                                    _context4.next = 4;
                                    break;
                                }

                                this.props.addNotification({
                                    title: 'Error',
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    message: 'Select amount of emails',
                                    autoDismiss: 25
                                });

                                return _context4.abrupt('return');

                            case 4:
                                _context4.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_16_services_letters__["e" /* saveEmailsToDev */](mailStatus, parseInt(toDevAmount));

                            case 6:
                                response = _context4.sent;
                                _context4.next = 9;
                                return response.status;

                            case 9:
                                _context4.t0 = _context4.sent;

                                if (!(_context4.t0 === 200)) {
                                    _context4.next = 12;
                                    break;
                                }

                                this.props.addNotification({
                                    title: 'Success',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    message: 'Amount of ' + mailStatus + ' emails saved dev',
                                    autoDismiss: 25
                                });

                            case 12:

                                if (response.status === 400) {
                                    this.props.addNotification({
                                        title: 'Error',
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        message: response.errors[0].message,
                                        autoDismiss: 25
                                    });
                                }

                                _context4.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_18_store_configureStore__["b" /* execute */])(this.loadLetters, this.state.pagination);

                            case 15:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function handleSendToDev(_x4) {
                return _ref4.apply(this, arguments);
            }

            return handleSendToDev;
        }()
    }, {
        key: 'handleResendEmails',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(emailStatus) {
                var intEmailsAmount, total, pagination, response;
                return regeneratorRuntime.wrap(function _callee4$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                intEmailsAmount = parseInt(this.state[emailStatus + 'EmailsAmount']);
                                total = this.props.letters.total;
                                pagination = _extends({}, this.state.pagination);

                                if (!(intEmailsAmount && intEmailsAmount > 0 && intEmailsAmount <= total)) {
                                    _context5.next = 18;
                                    break;
                                }

                                _context5.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_16_services_letters__["f" /* sendEmailsToNew */](intEmailsAmount, emailStatus, total);

                            case 6:
                                response = _context5.sent;
                                _context5.next = 9;
                                return response.status;

                            case 9:
                                _context5.t0 = _context5.sent;

                                if (!(_context5.t0 === 200)) {
                                    _context5.next = 12;
                                    break;
                                }

                                this.props.addNotification({
                                    title: 'Success',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    message: 'Amount of emails changed from ' + emailStatus + ' to new: ' + response.data.amount,
                                    autoDismiss: 25
                                });

                            case 12:

                                if (response.status === 400) {
                                    this.props.addNotification({
                                        title: 'Error',
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        message: response.errors[0].message,
                                        autoDismiss: 25
                                    });
                                }
                                this.setState(_defineProperty({}, emailStatus + 'EmailsAmount', ''));
                                _context5.next = 16;
                                return Object(__WEBPACK_IMPORTED_MODULE_18_store_configureStore__["b" /* execute */])(this.loadLetters, pagination);

                            case 16:
                                _context5.next = 20;
                                break;

                            case 18:
                                this.props.addNotification({
                                    title: 'Error',
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    message: 'Amount of error emails out of range. Expected range: 1 to ' + total,
                                    autoDismiss: 25
                                });
                                this.setState(_defineProperty({}, emailStatus + 'EmailsAmount', ''));

                            case 20:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function handleResendEmails(_x5) {
                return _ref5.apply(this, arguments);
            }

            return handleResendEmails;
        }()
    }, {
        key: 'handleToggleBrokerFilterDialog',
        value: function handleToggleBrokerFilterDialog() {
            this.setState(function (state) {
                return {
                    openBrokerFilterDialog: !state.openBrokerFilterDialog
                };
            });
        }
    }, {
        key: 'handleFilterBroker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(brokerMails, listeners) {
                var pagination;
                return regeneratorRuntime.wrap(function _callee5$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                pagination = _extends({}, this.state.pagination, {
                                    brokerMails: brokerMails,
                                    listeners: listeners
                                });
                                _context6.next = 3;
                                return this.updateRows(_extends({}, this.state, { pagination: pagination }));

                            case 3:
                                this.handleToggleBrokerFilterDialog();

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function handleFilterBroker(_x6, _x7) {
                return _ref6.apply(this, arguments);
            }

            return handleFilterBroker;
        }()
    }, {
        key: 'handleOpenRabbitDialog',
        value: function handleOpenRabbitDialog() {
            this.setState({ openRabbitDialog: true });
        }
    }, {
        key: 'handleCloseRabbitDialog',
        value: function handleCloseRabbitDialog() {
            this.setState({ openRabbitDialog: false });
        }
    }, {
        key: 'sendToRabbit',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(idsArr) {
                var response;
                return regeneratorRuntime.wrap(function _callee6$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_16_services_letters__["i" /* sendToRabbit */](idsArr);

                            case 2:
                                response = _context7.sent;
                                _context7.next = 5;
                                return response.status;

                            case 5:
                                _context7.t0 = _context7.sent;

                                if (!(_context7.t0 === 200)) {
                                    _context7.next = 10;
                                    break;
                                }

                                this.props.addNotification({
                                    title: 'Success',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    message: 'Amount of resent emails: ' + response.data.amount,
                                    autoDismiss: 25
                                });
                                _context7.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_18_store_configureStore__["b" /* execute */])(this.loadLetters, this.state.pagination);

                            case 10:

                                if (response.status === 400) {
                                    this.props.addNotification({
                                        title: 'Error',
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        message: response.errors[0].message,
                                        autoDismiss: 25
                                    });
                                }

                            case 11:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function sendToRabbit(_x8) {
                return _ref7.apply(this, arguments);
            }

            return sendToRabbit;
        }()

        /**
         * 
         * @param {'isNosa' | 'isNotNosa'} field 
         * @param {boolean} value 
         */

    }, {
        key: 'render',
        value: function render() {
            var _this14 = this;

            var _state = this.state,
                _state$pagination = _state.pagination,
                search = _state$pagination.search,
                page = _state$pagination.page,
                limit = _state$pagination.limit,
                statusMail = _state$pagination.statusMail,
                eh = _state$pagination.eh,
                archive = _state$pagination.archive,
                typeMail = _state$pagination.typeMail,
                withAttachments = _state$pagination.withAttachments,
                dateStart = _state$pagination.dateStart,
                dateEnd = _state$pagination.dateEnd,
                showUniqueBrokerMails = _state$pagination.showUniqueBrokerMails,
                nosaFilter = _state$pagination.nosaFilter,
                rowsPerPage = _state.rowsPerPage,
                openBrokerFilterDialog = _state.openBrokerFilterDialog;
            var _props$letters = this.props.letters,
                total = _props$letters.total,
                brokerMails = _props$letters.brokerMails,
                selectedBrokerMails = _props$letters.selectedBrokerMails,
                listeners = _props$letters.listeners,
                selectedListeners = _props$letters.selectedListeners;
            var _state2 = this.state,
                rabbitObj = _state2.rabbitObj,
                openRabbitDialog = _state2.openRabbitDialog,
                openAsGazettersDialog = _state2.openAsGazettersDialog;


            var minDate = new Date();
            var maxDate = new Date();
            var currentMailStatus = this.state.pagination.statusMail || '';

            minDate.setFullYear(minDate.getFullYear() - 1);
            maxDate.setFullYear(maxDate.getFullYear() + 1);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'letters-page', className: 'page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default.a, {
                    className: this.state.showSpinner ? '' : 'hidden',
                    style: styles.circularProgress
                }),
                openBrokerFilterDialog && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__BrokerMailsModal__["a" /* default */], {
                    brokerMails: brokerMails,
                    selectedListeners: selectedListeners,
                    listeners: listeners,
                    handleClose: this.handleToggleBrokerFilterDialog,
                    handleFilterBroker: this.handleFilterBroker,
                    selectedBrokerMails: selectedBrokerMails,
                    showUniqueBrokerMails: showUniqueBrokerMails,
                    handleToggleShowUniqueBrokerMails: this.handleToggleShowUniqueBrokerMails
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RabbitModal__["a" /* default */], {
                    rabbitObj: rabbitObj,
                    open: openRabbitDialog,
                    handleClose: this.handleCloseRabbitDialog,
                    handleChange: this.changeField,
                    sendToRabbit: this.sendToRabbit,
                    letters: this.props.letters
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__OpenAll__["a" /* default */], {
                    letterIds: (this.props.letters && this.props.letters.data || []).map(function (l) {
                        return l._id;
                    }) || [],
                    open: openAsGazettersDialog,
                    handleOpen: this.handleOpenAsGazettersDialog
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.state.showSpinner ? 'hidden' : '' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Letters'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'letters-header' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'letters-header-item' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                        defaultValue: search,
                                        hintText: 'Search',
                                        ref: 'search',
                                        onKeyPress: function onKeyPress(event) {
                                            if (event.charCode === 13) {
                                                event.preventDefault();
                                                _this14.handleSearch();
                                            }
                                        }
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                        label: 'Search',
                                        style: styles.RaisedButton,
                                        primary: true,
                                        onClick: this.handleSearch
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'letters-header-item' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Libs_Pagination__["a" /* default */], {
                                        total: total,
                                        rowsPerPage: rowsPerPage,
                                        page: page,
                                        numberOfRows: limit,
                                        updateRows: this.handleChangePagination
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'letters-info' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'letters-info-item' },
                                    'TOTAL:  ',
                                    total
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'letters-info-item' },
                                    'PAGES:  ',
                                    Math.ceil(total / limit)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'filters-mails' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'filter filter-type-mail' },
                                    'Filter by type:',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButtonGroup"],
                                        {
                                            onChange: this.changeTypeMails,
                                            style: styles.radioGroup,
                                            name: 'type-mail',
                                            defaultSelected: typeMail
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.typeWidth),
                                            value: '',
                                            label: 'All'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.typeWidth),
                                            value: 'vessel',
                                            label: 'Vessel'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.typeWidth),
                                            value: 'sales',
                                            label: 'Sales'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.typeWidth),
                                            value: 'cargo',
                                            label: 'Cargo'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.typeWidth),
                                            value: 'tc',
                                            label: 'TC'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.typeWidth),
                                            value: 'spam',
                                            label: 'Spam'
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'filter filter-date-picker' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'filter-checkboxes' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                                label: 'Archive letters',
                                                checked: archive,
                                                onCheck: this.changeToArchiveLetters
                                            }),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                                label: 'Only with attachments',
                                                checked: withAttachments,
                                                onCheck: this.filterWithAttachments
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'filter-date-inputs' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_material_ui__["e" /* DatePicker */], {
                                                floatingLabelText: 'Filter start date:',
                                                autoOk: true,
                                                minDate: minDate,
                                                maxDate: maxDate,
                                                textFieldStyle: { width: '120px' },
                                                shouldDisableDate: function shouldDisableDate(dateSelected) {
                                                    return dateSelected.getTime() > new Date(dateEnd).getTime();
                                                },
                                                onChange: this.handleStartDateFilter
                                                // value={dateStart ? new Date(dateStart) : undefined}
                                                , value: dateStart ? Object(__WEBPACK_IMPORTED_MODULE_23_helpers_dates__["a" /* fromUTC */])(dateStart) : undefined
                                            }),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default.a,
                                                {
                                                    style: { margin: '25px 7px 0 -7px' },
                                                    disabled: !dateStart,
                                                    onClick: function onClick() {
                                                        return _this14.handleRemoveDate('start');
                                                    }
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                                    color: dateStart ? 'red' : 'black'
                                                })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_material_ui__["e" /* DatePicker */], {
                                                floatingLabelText: 'Filter end date:',
                                                autoOk: true,
                                                minDate: minDate,
                                                maxDate: maxDate,
                                                textFieldStyle: { width: '120px' },

                                                shouldDisableDate: function shouldDisableDate(dateSelected) {
                                                    return dateSelected.getTime() < new Date(dateStart).getTime();
                                                },

                                                onChange: this.handleEndDateFilter
                                                // value={dateEnd ? new Date(dateEnd) : undefined}
                                                , value: dateEnd ? Object(__WEBPACK_IMPORTED_MODULE_23_helpers_dates__["a" /* fromUTC */])(dateEnd) : undefined
                                            }),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default.a,
                                                {
                                                    style: { margin: '25px 0 0 -7px' },
                                                    disabled: !dateEnd,
                                                    onClick: function onClick() {
                                                        return _this14.handleRemoveDate('end');
                                                    }
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                                    color: dateEnd ? 'red' : 'black'
                                                })
                                            )
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'filter filter-status-mail ' },
                                    'Filter by status:',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButtonGroup"],
                                        {
                                            onChange: this.changeStatusMails,
                                            style: styles.radioGroup,
                                            name: 'status-mail',
                                            defaultSelected: statusMail
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.statusWidth),
                                            value: '',
                                            label: 'All'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.statusWidth),
                                            value: 'sent',
                                            label: 'Sent'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.statusWidth),
                                            value: 'failed',
                                            label: 'Failed'
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RadioButton__["RadioButton"], {
                                            style: _extends({}, styles.radioButton, styles.statusWidth),
                                            value: 'new',
                                            label: 'New'
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { style: styles.checkboxGroup },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'h3',
                                            { style: styles.checkboxGroupTitle },
                                            'From: '
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                            label: 'Fix',
                                            'data-eh': 'fix',
                                            checked: eh.includes('fix'),
                                            iconStyle: {
                                                marginRight: '8px'
                                            },
                                            onCheck: this.handleChangeEh
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                            label: 'Varamar',
                                            'data-eh': 'varamar',
                                            checked: eh.includes('varamar'),
                                            iconStyle: {
                                                marginRight: '8px'
                                            },
                                            onCheck: this.handleChangeEh
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                            label: 'Fixture',
                                            'data-eh': 'fixture',
                                            checked: eh.includes('fixture'),
                                            iconStyle: {
                                                marginRight: '8px'
                                            },
                                            onCheck: this.handleChangeEh
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                            label: 'Api',
                                            'data-eh': 'api',
                                            checked: eh.includes('api'),
                                            iconStyle: {
                                                marginRight: '8px'
                                            },
                                            onCheck: this.handleChangeEh
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                            label: 'Broker',
                                            'data-eh': 'broker',
                                            checked: eh.includes('broker'),
                                            iconStyle: {
                                                marginRight: '8px'
                                            },
                                            onCheck: this.handleChangeEh
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_18_store_configureStore__["a" /* UserPerms */].isAdmin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_12_material_ui_IconMenu___default.a,
                                            {
                                                disableAutoFocus: true,
                                                iconButtonElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default.a,
                                                    null,
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_navigation_more_vert___default.a, null)
                                                ),
                                                anchorOrigin: { horizontal: 'left', vertical: 'top' },
                                                targetOrigin: { horizontal: 'left', vertical: 'top' }
                                            },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default.a,
                                                {
                                                    style: { backgroundColor: 'transparent' }
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                                    hintText: 'Amount',
                                                    style: { width: '95px', marginRight: '20px' },
                                                    onClick: function onClick(e) {
                                                        return e.stopPropagation();
                                                    },
                                                    onChange: function onChange(ev) {
                                                        return _this14.handleResendEmailsChange(ev, 'failed');
                                                    },
                                                    value: this.state.failedEmailsAmount,
                                                    type: 'number'
                                                }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                                    label: 'Failed to New',
                                                    secondary: true,
                                                    buttonStyle: { width: '130px' },
                                                    onClick: function onClick() {
                                                        return _this14.handleResendEmails('failed');
                                                    }
                                                })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default.a,
                                                {
                                                    style: { backgroundColor: 'transparent' }
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                                    hintText: 'Amount',
                                                    style: { width: '95px', marginRight: '20px' },
                                                    onClick: function onClick(e) {
                                                        return e.stopPropagation();
                                                    },
                                                    onChange: function onChange(ev) {
                                                        return _this14.handleResendEmailsChange(ev, 'new');
                                                    },
                                                    value: this.state.newEmailsAmount,
                                                    type: 'number'
                                                }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                                    label: 'New to New',
                                                    secondary: true,
                                                    buttonStyle: { width: '130px' },
                                                    onClick: function onClick() {
                                                        return _this14.handleResendEmails('new');
                                                    }
                                                })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default.a,
                                                {
                                                    style: { backgroundColor: 'transparent' }
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                                    hintText: 'Amount',
                                                    style: { width: '95px', marginRight: '20px' },
                                                    onClick: function onClick(e) {
                                                        return e.stopPropagation();
                                                    },
                                                    onChange: function onChange(ev) {
                                                        return _this14.handleChangeSendToDev(ev);
                                                    },
                                                    value: this.state.toDevAmount,
                                                    type: 'number'
                                                }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                                    label: currentMailStatus + ' to Dev',
                                                    secondary: true,
                                                    buttonStyle: { width: '130px' },
                                                    onClick: function onClick() {
                                                        return _this14.handleSendToDev(currentMailStatus);
                                                    }
                                                })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default.a, {
                                                primaryText: 'BROKER EMAIL FILTER',
                                                onClick: function onClick() {
                                                    _this14.handleToggleBrokerFilterDialog();
                                                },
                                                style: {
                                                    margin: '6px 10px',
                                                    textAlign: 'center',
                                                    color: 'white',
                                                    backgroundColor: '#FF4081',
                                                    width: '250px'
                                                }
                                            }),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default.a, {
                                                primaryText: 'Open Requeue Modal',
                                                onClick: function onClick() {
                                                    _this14.handleOpenRabbitDialog();
                                                },
                                                style: {
                                                    margin: '6px 10px',
                                                    textAlign: 'center',
                                                    color: 'white',
                                                    backgroundColor: '#FF4081',
                                                    width: '250px'
                                                }
                                            }),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default.a, {
                                                primaryText: 'Open Mails As Gazetters Modal',
                                                onClick: function onClick() {
                                                    _this14.handleOpenAsGazettersDialog();
                                                },
                                                style: {
                                                    margin: '6px 10px',
                                                    textAlign: 'center',
                                                    color: 'white',
                                                    backgroundColor: '#FF4081',
                                                    width: '250px'
                                                }
                                            }),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_13_material_ui_MenuItem___default.a,
                                                {
                                                    style: {
                                                        backgroundColor: 'transparent',
                                                        width: '250px',
                                                        margin: '6px 8px'
                                                    },
                                                    innerDivStyle: {
                                                        padding: 0
                                                    }
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                                    label: 'noSa',
                                                    checked: nosaFilter.isNosa,
                                                    iconStyle: {
                                                        marginRight: '8px'
                                                    },
                                                    style: {
                                                        display: 'inline-block',
                                                        width: '35%',
                                                        verticalAlign: 'middle'
                                                    },
                                                    onCheck: function onCheck() {
                                                        return _this14.handleChangeIsNosaFilter('isNosa', !nosaFilter.isNosa);
                                                    }
                                                }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Checkbox___default.a, {
                                                    label: 'noSa',
                                                    checked: nosaFilter.isNotNosa,
                                                    labelStyle: {
                                                        textDecoration: 'line-through'
                                                    },
                                                    iconStyle: {
                                                        marginRight: '8px'
                                                    },
                                                    style: {
                                                        display: 'inline-block',
                                                        width: 'unset',
                                                        verticalAlign: 'middle'
                                                    },
                                                    onCheck: function onCheck() {
                                                        return _this14.handleChangeIsNosaFilter('isNotNosa', !nosaFilter.isNotNosa);
                                                    }
                                                })
                                            )
                                        )
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__List__["a" /* default */], {
                                letters: _extends({}, this.props.letters, {
                                    data: this.props.letters && this.props.letters.data ? this.props.letters.data : []
                                }),
                                userId: this.props.userId
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'letters-header' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'letters-header-item' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Libs_Pagination__["a" /* default */], {
                                        total: total,
                                        rowsPerPage: rowsPerPage,
                                        page: page,
                                        numberOfRows: limit,
                                        updateRows: this.handleChangePagination
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LettersPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref8) {
    var user = _ref8.user,
        letters = _ref8.letters;
    return {
        letters: letters,
        userId: user.user._id,
        isLogged: user.isLogged
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_25_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_24_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(LettersPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/Page.jsx');
    reactHotLoader.register(LettersPage, 'LettersPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autoPrefix = __webpack_require__(195);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return clampedValue / (max - min);
}

function getArcLength(fraction, props) {
  return fraction * Math.PI * (props.size - props.thickness);
}

function getStyles(props, context) {
  var max = props.max,
      min = props.min,
      size = props.size,
      value = props.value;
  var palette = context.muiTheme.baseTheme.palette;


  var styles = {
    root: {
      position: 'relative',
      display: 'inline-block',
      width: size,
      height: size
    },
    wrapper: {
      width: size,
      height: size,
      display: 'inline-block',
      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
      transitionTimingFunction: 'linear'
    },
    svg: {
      width: size,
      height: size,
      position: 'relative'
    },
    path: {
      stroke: props.color || palette.primary1Color,
      strokeLinecap: 'round',
      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
    }
  };

  if (props.mode === 'determinate') {
    var relVal = getRelativeValue(value, min, max);
    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
  }

  return styles;
}

var CircularProgress = function (_Component) {
  (0, _inherits3.default)(CircularProgress, _Component);

  function CircularProgress() {
    (0, _classCallCheck3.default)(this, CircularProgress);
    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircularProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scalePath(this.refs.path);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
    }
  }, {
    key: 'scalePath',
    value: function scalePath(path) {
      var _this2 = this;

      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.props.mode !== 'indeterminate') return;

      step %= 3;

      if (step === 0) {
        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
        path.style.strokeDashoffset = 0;
        path.style.transitionDuration = '0ms';
      } else if (step === 1) {
        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
        path.style.transitionDuration = '750ms';
      } else {
        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
        path.style.strokeDashoffset = getArcLength(-1, this.props);
        path.style.transitionDuration = '850ms';
      }

      this.scalePathTimer = setTimeout(function () {
        return _this2.scalePath(path, step + 1);
      }, step ? 750 : 250);
    }
  }, {
    key: 'rotateWrapper',
    value: function rotateWrapper(wrapper) {
      var _this3 = this;

      if (this.props.mode !== 'indeterminate') return;

      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');

      setTimeout(function () {
        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
      }, 50);

      this.rotateWrapperTimer = setTimeout(function () {
        return _this3.rotateWrapper(wrapper);
      }, 10050);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          innerStyle = _props.innerStyle,
          size = _props.size,
          thickness = _props.thickness,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        _react2.default.createElement(
          'div',
          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
          _react2.default.createElement(
            'svg',
            {
              viewBox: '0 0 ' + size + ' ' + size,
              style: prepareStyles(styles.svg)
            },
            _react2.default.createElement('circle', {
              ref: 'path',
              style: prepareStyles(styles.path),
              cx: size / 2,
              cy: size / 2,
              r: (size - thickness) / 2,
              fill: 'none',
              strokeWidth: thickness,
              strokeMiterlimit: '20'
            })
          )
        )
      );
    }
  }]);
  return CircularProgress;
}(_react.Component);

CircularProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100,
  size: 40,
  thickness: 3.5
};
CircularProgress.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircularProgress.propTypes =  false ? {
  /**
   * Override the progress's color.
   */
  color: _propTypes2.default.string,
  /**
   * Style for inner wrapper div.
   */
  innerStyle: _propTypes2.default.object,
  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _propTypes2.default.number,
  /**
   * The mode of show your progress, indeterminate
   * for when there is no value for progress.
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
  /**
   * The diameter of the progress in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Stroke width in pixels.
   */
  thickness: _propTypes2.default.number,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _propTypes2.default.number
} : {};
exports.default = CircularProgress;

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_socket__ = __webpack_require__(515);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function LetterList(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.letters ? props.letters.data : []),
        _useState2 = _slicedToArray(_useState, 2),
        letters = _useState2[0],
        setLetters = _useState2[1];

    var lettersRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(letters);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        // trigger capture any letters change (run on every rerender)
        // that prevent keeping old letters state 
        lettersRef.current = letters;
    });

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setLetters(props.letters.data);
    }, [props.letters.data]);

    /**
     * 
     * @param {UpdateLetterMessage} message 
     * @param {any[]} lettersCurrent 
     */
    var messageHandler = function messageHandler(message, lettersCurrent) {
        var mailId = message.mailId,
            processingCondition = message.processingCondition;

        var foundLetterIndex = lettersCurrent.findIndex(function (i) {
            return i._id === mailId;
        });

        if (foundLetterIndex >= 0) {
            var clones = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(lettersCurrent);

            clones[foundLetterIndex] = _extends({}, clones[foundLetterIndex], {
                processingCondition: [processingCondition]
            });
            setLetters(clones);
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var socket = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_socket__["a" /* getSocketconnection */])(props);

        /**
         * uses ref to address the last version of letters state
         * @param {UpdateLetterMessage} message 
         */
        var handler = function handler(message) {
            return messageHandler(message, lettersRef.current);
        };

        socket.on('admin:mail:processingCondition:changed', handler);
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'letters-collection collection' },
            letters.map(function (letter) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Item__["a" /* default */], { key: letter._id, item: letter });
            })
        )
    );
}

var _default = LetterList;
/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * @typedef {Object} UpdateLetterMessage
 * @property {string} mailId
 * @property {ProcessingCondition} processingCondition 
 */

/**
 * @typedef {Object} ProcessingCondition
 * @property {Date} date
 * @property {'pending' | 'sent'} status
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LetterList, 'LetterList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_attachment__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_attachment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_attachment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LetterCondition__ = __webpack_require__(1792);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var LetterItem = function LetterItem(_ref) {
    var item = _ref.item;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(item),
        _useState2 = _slicedToArray(_useState, 2),
        currentItem = _useState2[0],
        setCurrentItem = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCurrentItem(item);
    }, [item]);

    var backgroundColor = 'collection-item';
    var hasAttachment = currentItem.attachArr && currentItem.attachArr.length;

    switch (currentItem.type) {
        case 'cargo':
            backgroundColor = 'cargo collection-item';
            break;
        case 'vessel':
            backgroundColor = 'vessel collection-item';
            break;
    }

    if (currentItem.eh === 'fix') {
        backgroundColor = 'fix collection-item';
    } else if (currentItem.eh === 'fixture') {
        backgroundColor = 'fixture collection-item';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { className: backgroundColor },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            currentItem.eh === 'fix' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'FIX:'
                )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'SUBJECT:'
                ),
                ' ',
                currentItem.subject
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'SENDER NAME:'
                ),
                '  ',
                currentItem.sender[0].name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'DATE:'
                ),
                '  ',
                Object(__WEBPACK_IMPORTED_MODULE_3_helpers_dates__["a" /* fromUTC */])(currentItem.date).toLocaleString()
            ),
            currentItem.processingCondition && currentItem.processingCondition[currentItem.processingCondition.length - 1] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item', style: { display: 'flex', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'PROCESSING:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LetterCondition__["a" /* default */], { processingCondition: currentItem.processingCondition[currentItem.processingCondition.length - 1] })
            ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'refNo:'
                ),
                ' ',
                currentItem.refNo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'TYPE:'
                ),
                ' ',
                currentItem.type
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'LAST OPENED:'
                ),
                '  ',
                new Date(currentItem.lastModify.date).toLocaleString()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'BY USER:'
                ),
                '  ',
                currentItem.lastModify.user ? currentItem.lastModify.user.email : ''
            ),
            !!hasAttachment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'Attachments ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_attachment___default.a, { color: 'white', style: { verticalAlign: 'bottom' } }),
                    ':'
                ),
                '\xA0',
                currentItem.attachArr.length
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */],
                { to: currentItem._id, target: '_blank' },
                'GAZETTER'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */],
                { to: currentItem._id + '/annotator/vessel', target: '_blank' },
                'VESSEL'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */],
                { to: currentItem._id + '/size/vessel', target: '_blank' },
                'VESSEL SIZE'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */],
                { to: currentItem._id + '/sales', target: '_blank' },
                'VESSEL SALES'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */],
                { to: currentItem._id + '/annotator/cargo', target: '_blank' },
                'CARGO'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */],
                { to: currentItem._id + '/annotator/tc', target: '_blank' },
                'TC'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */],
                { to: currentItem._id + '/train', target: '_blank' },
                'TRAIN'
            )
        )
    );
};

var _default = LetterItem;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LetterItem, 'LetterItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = LetterCondition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





/**
 * @type {{ pending: ConditionStyles, done: ConditionStyles }}
 */
var casesMap = {
    pending: {
        backgroundColor: '#82C3FF'
    },
    done: {
        backgroundColor: '#75C422'
    }
};

/**
 * @param {{processingCondition: ProcessingCondition}} param0 
 */
function LetterCondition(_ref) {
    var processingCondition = _ref.processingCondition;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])( /**@type {ProcessingCondition & {styles?: ConditionStyles} | null} */null),
        _useState2 = _slicedToArray(_useState, 2),
        current = _useState2[0],
        setCurrent = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        setCurrent(processingCondition);
    }, [processingCondition.status]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        current ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["c" /* Chip */],
            {
                labelStyle: { lineHeight: '20px' },
                style: { marginLeft: '5px' },
                backgroundColor: casesMap[current.status].backgroundColor
            },
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(current.status)
        ) : null
    );
}

/**
 * @typedef {Object} ProcessingCondition
 * @property {'pending' | 'done'} status
 * @property {Date} date
 */

/**
 * @typedef {Object} ConditionStyles
 * @property {string} backgroundColor
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(casesMap, 'casesMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/LetterCondition.jsx');
    reactHotLoader.register(LetterCondition, 'LetterCondition', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/LetterCondition.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(251);

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _TextField = __webpack_require__(23);

var _TextField2 = _interopRequireDefault(_TextField);

var _Menu = __webpack_require__(125);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(26);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Divider = __webpack_require__(506);

var _Divider2 = _interopRequireDefault(_Divider);

var _Popover = __webpack_require__(226);

var _Popover2 = _interopRequireDefault(_Popover);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var anchorEl = state.anchorEl;
  var fullWidth = props.fullWidth;


  var styles = {
    root: {
      display: 'inline-block',
      position: 'relative',
      width: fullWidth ? '100%' : 256
    },
    menu: {
      width: '100%'
    },
    list: {
      display: 'block',
      width: fullWidth ? '100%' : 256
    },
    innerDiv: {
      overflow: 'hidden'
    }
  };

  if (anchorEl && fullWidth) {
    styles.popover = {
      width: anchorEl.clientWidth
    };
  }

  return styles;
}

var AutoComplete = function (_Component) {
  (0, _inherits3.default)(AutoComplete, _Component);

  function AutoComplete() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AutoComplete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      anchorEl: null,
      focusTextField: true,
      open: false,
      searchText: undefined
    }, _this.handleRequestClose = function () {
      // Only take into account the Popover clickAway when we are
      // not focusing the TextField.
      if (!_this.state.focusTextField) {
        _this.close();
      }
    }, _this.handleMouseDown = function (event) {
      // Keep the TextField focused
      event.preventDefault();
    }, _this.handleItemClick = function (event, child) {
      var dataSource = _this.props.dataSource;
      var index = parseInt(child.key, 10);
      var chosenRequest = dataSource[index];
      var searchText = _this.chosenRequestText(chosenRequest);

      var updateInput = function updateInput() {
        return _this.props.onUpdateInput(searchText, _this.props.dataSource, {
          source: 'click'
        });
      };
      _this.timerClickCloseId = function () {
        return setTimeout(function () {
          _this.timerClickCloseId = null;
          _this.close();
          _this.props.onNewRequest(chosenRequest, index);
        }, _this.props.menuCloseDelay);
      };

      if (typeof _this.props.searchText !== 'undefined') {
        updateInput();
        _this.timerClickCloseId();
      } else {
        _this.setState({
          searchText: searchText
        }, function () {
          updateInput();
          _this.timerClickCloseId();
        });
      }
    }, _this.chosenRequestText = function (chosenRequest) {
      if (typeof chosenRequest === 'string') {
        return chosenRequest;
      } else {
        return chosenRequest[_this.props.dataSourceConfig.text];
      }
    }, _this.handleEscKeyDown = function () {
      _this.close();
    }, _this.handleKeyDown = function (event) {
      if (_this.props.onKeyDown) _this.props.onKeyDown(event);

      switch ((0, _keycode2.default)(event)) {
        case 'enter':
          _this.close();
          var searchText = _this.state.searchText;
          if (searchText !== '') {
            _this.props.onNewRequest(searchText, -1);
          }
          break;

        case 'esc':
          _this.close();
          break;

        case 'down':
          event.preventDefault();
          _this.setState({
            open: true,
            focusTextField: false,
            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
          });
          break;

        default:
          break;
      }
    }, _this.handleChange = function (event) {
      var searchText = event.target.value;

      // Make sure that we have a new searchText.
      // Fix an issue with a Cordova Webview
      if (searchText === _this.state.searchText) {
        return;
      }

      var state = {
        open: true,
        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
      };

      if (_this.props.searchText === undefined) {
        state.searchText = searchText;
      }

      _this.setState(state);

      _this.props.onUpdateInput(searchText, _this.props.dataSource, {
        source: 'change'
      });
    }, _this.handleBlur = function (event) {
      if (_this.state.focusTextField && _this.timerClickCloseId === null) {
        _this.timerBlurClose = setTimeout(function () {
          _this.close();
        }, 0);
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      if (!_this.state.open && _this.props.openOnFocus) {
        _this.setState({
          open: true,
          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
        });
      }

      _this.setState({
        focusTextField: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AutoComplete, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.requestsList = [];
      this.setState({
        open: this.props.open,
        searchText: this.props.searchText || ''
      });
      this.timerClickCloseId = null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.searchText !== nextProps.searchText) {
        this.setState({
          searchText: nextProps.searchText
        });
      }
      if (this.props.open !== nextProps.open) {
        this.setState({
          open: nextProps.open,
          anchorEl: _reactDom2.default.findDOMNode(this.refs.searchTextField)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerClickCloseId);
      clearTimeout(this.timerBlurClose);
    }
  }, {
    key: 'close',
    value: function close() {
      this.setState({
        open: false,
        anchorEl: null
      });

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.refs.searchTextField.blur();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.refs.searchTextField.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          anchorOrigin = _props.anchorOrigin,
          animated = _props.animated,
          animation = _props.animation,
          dataSource = _props.dataSource,
          dataSourceConfig = _props.dataSourceConfig,
          disableFocusRipple = _props.disableFocusRipple,
          errorStyle = _props.errorStyle,
          floatingLabelText = _props.floatingLabelText,
          filter = _props.filter,
          fullWidth = _props.fullWidth,
          style = _props.style,
          hintText = _props.hintText,
          maxSearchResults = _props.maxSearchResults,
          menuCloseDelay = _props.menuCloseDelay,
          textFieldStyle = _props.textFieldStyle,
          menuStyle = _props.menuStyle,
          menuProps = _props.menuProps,
          listStyle = _props.listStyle,
          targetOrigin = _props.targetOrigin,
          onBlur = _props.onBlur,
          onClose = _props.onClose,
          onFocus = _props.onFocus,
          onKeyDown = _props.onKeyDown,
          onNewRequest = _props.onNewRequest,
          onUpdateInput = _props.onUpdateInput,
          openOnFocus = _props.openOnFocus,
          popoverProps = _props.popoverProps,
          searchTextProp = _props.searchText,
          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onBlur', 'onClose', 'onFocus', 'onKeyDown', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);

      var _ref2 = popoverProps || {},
          popoverStyle = _ref2.style,
          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);

      var _state = this.state,
          open = _state.open,
          anchorEl = _state.anchorEl,
          searchText = _state.searchText,
          focusTextField = _state.focusTextField;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var requestsList = [];

      dataSource.every(function (item, index) {
        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
          case 'string':
            if (filter(searchText, item, item)) {
              requestsList.push({
                text: item,
                value: _react2.default.createElement(_MenuItem2.default, {
                  innerDivStyle: styles.innerDiv,
                  value: item,
                  primaryText: item,
                  disableFocusRipple: disableFocusRipple,
                  key: index
                })
              });
            }
            break;

          case 'object':
            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
              var itemText = item[_this2.props.dataSourceConfig.text];
              if (!_this2.props.filter(searchText, itemText, item)) break;

              var itemValue = item[_this2.props.dataSourceConfig.value];
              if (itemValue && itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
                requestsList.push({
                  text: itemText,
                  value: _react2.default.cloneElement(itemValue, {
                    key: index,
                    disableFocusRipple: disableFocusRipple
                  })
                });
              } else {
                requestsList.push({
                  text: itemText,
                  value: _react2.default.createElement(_MenuItem2.default, {
                    innerDivStyle: styles.innerDiv,
                    primaryText: itemText,
                    disableFocusRipple: disableFocusRipple,
                    key: index
                  })
                });
              }
            }
            break;

          default:
          // Do nothing
        }

        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
      });

      this.requestsList = requestsList;

      var menu = open && requestsList.length > 0 && _react2.default.createElement(
        _Menu2.default,
        (0, _extends3.default)({
          ref: 'menu',
          autoWidth: false,
          disableAutoFocus: focusTextField,
          onEscKeyDown: this.handleEscKeyDown,
          initiallyKeyboardFocused: true,
          onItemClick: this.handleItemClick,
          onMouseDown: this.handleMouseDown,
          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
        }, menuProps),
        requestsList.map(function (i) {
          return i.value;
        })
      );

      return _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({
          ref: 'searchTextField',
          autoComplete: 'off',
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          floatingLabelText: floatingLabelText,
          hintText: hintText,
          fullWidth: fullWidth,
          multiLine: false,
          errorStyle: errorStyle,
          style: textFieldStyle
        }, other, {
          // value and onChange are idiomatic properties often leaked.
          // We prevent their overrides in order to reduce potential bugs.
          value: searchText,
          onChange: this.handleChange
        })),
        _react2.default.createElement(
          _Popover2.default,
          (0, _extends3.default)({
            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
            canAutoPosition: false,
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            open: open,
            anchorEl: anchorEl,
            useLayerForClickAway: false,
            onRequestClose: this.handleRequestClose,
            animated: animated,
            animation: animation
          }, popoverOther),
          menu
        )
      );
    }
  }]);
  return AutoComplete;
}(_react.Component);

AutoComplete.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  animated: true,
  dataSourceConfig: {
    text: 'text',
    value: 'value'
  },
  disableFocusRipple: true,
  filter: function filter(searchText, key) {
    return searchText !== '' && key.indexOf(searchText) !== -1;
  },
  fullWidth: false,
  open: false,
  openOnFocus: false,
  onUpdateInput: function onUpdateInput() {},
  onNewRequest: function onNewRequest() {},
  menuCloseDelay: 300,
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
AutoComplete.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
AutoComplete.propTypes =  false ? {
  /**
   * Location of the anchor for the auto complete.
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the auto complete is animated as it is toggled.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * Array of strings or nodes used to populate the list.
   */
  dataSource: _propTypes2.default.array.isRequired,
  /**
   * Config for objects list dataSource.
   *
   * @typedef {Object} dataSourceConfig
   *
   * @property {string} text `dataSource` element key used to find a string to be matched for search
   * and shown as a `TextField` input value after choosing the result.
   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
   */
  dataSourceConfig: _propTypes2.default.object,
  /**
   * Disables focus ripple when true.
   */
  disableFocusRipple: _propTypes2.default.bool,
  /**
   * Override style prop for error.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * The error content to display.
   */
  errorText: _propTypes2.default.node,
  /**
   * Callback function used to filter the auto complete.
   *
   * @param {string} searchText The text to search for within `dataSource`.
   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
   */
  filter: _propTypes2.default.func,
  /**
   * The content to use for adding floating label element.
   */
  floatingLabelText: _propTypes2.default.node,
  /**
   * If true, the field receives the property `width: 100%`.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The hint content to display.
   */
  hintText: _propTypes2.default.node,
  /**
   * Override style for list.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The max number of search results to be shown.
   * By default it shows all the items which matches filter.
   */
  maxSearchResults: _propTypes2.default.number,
  /**
   * Delay for closing time of the menu.
   */
  menuCloseDelay: _propTypes2.default.number,
  /**
   * Props to be passed to menu.
   */
  menuProps: _propTypes2.default.object,
  /**
   * Override style for menu.
   */
  menuStyle: _propTypes2.default.object,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is closed.
   */
  onClose: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /** @ignore */
  onKeyDown: _propTypes2.default.func,
  /**
   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
   *
   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
   * or the dataSource object corresponding to the list item that was selected.
   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
   * `TextField`.
   */
  onNewRequest: _propTypes2.default.func,
  /**
   * Callback function that is fired when the user updates the `TextField`.
   *
   * @param {string} searchText The auto-complete's `searchText` value.
   * @param {array} dataSource The auto-complete's `dataSource` array.
   * @param {object} params Additional information linked the update.
   */
  onUpdateInput: _propTypes2.default.func,
  /**
   * Auto complete menu is open if true.
   */
  open: _propTypes2.default.bool,
  /**
   * If true, the list item is showed when a focus event triggers.
   */
  openOnFocus: _propTypes2.default.bool,
  /**
   * Props to be passed to popover.
   */
  popoverProps: _propTypes2.default.object,
  /**
   * Text being input to auto complete.
   */
  searchText: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Origin for location of target.
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * Override the inline-styles of AutoComplete's TextField element.
   */
  textFieldStyle: _propTypes2.default.object
} : {};


AutoComplete.levenshteinDistance = function (searchText, key) {
  var current = [];
  var prev = void 0;
  var value = void 0;

  for (var i = 0; i <= key.length; i++) {
    for (var j = 0; j <= searchText.length; j++) {
      if (i && j) {
        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
      } else {
        value = i + j;
      }
      prev = current[j];
      current[j] = value;
    }
  }
  return current.pop();
};

AutoComplete.noFilter = function () {
  return true;
};

AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
  return searchText !== '' && key.indexOf(searchText) !== -1;
};

AutoComplete.caseInsensitiveFilter = function (searchText, key) {
  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
};

AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
  if (distanceLessThan === undefined) {
    return AutoComplete.levenshteinDistance;
  } else if (typeof distanceLessThan !== 'number') {
    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
  }

  return function (s, k) {
    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
  };
};

AutoComplete.fuzzyFilter = function (searchText, key) {
  var compareString = key.toLowerCase();
  searchText = searchText.toLowerCase();

  var searchTextIndex = 0;
  for (var index = 0; index < key.length; index++) {
    if (compareString[index] === searchText[searchTextIndex]) {
      searchTextIndex += 1;
    }
  }

  return searchTextIndex === searchText.length;
};

AutoComplete.Item = _MenuItem2.default;
AutoComplete.Divider = _Divider2.default;

exports.default = AutoComplete;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotKeyHolder = undefined;

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HotKeyHolder = exports.HotKeyHolder = function () {
  function HotKeyHolder() {
    var _this = this;

    (0, _classCallCheck3.default)(this, HotKeyHolder);

    this.clear = function () {
      _this.timerId = null;
      _this.lastKeys = null;
    };
  }

  (0, _createClass3.default)(HotKeyHolder, [{
    key: 'append',
    value: function append(key) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(this.clear, 500);
      return this.lastKeys = (this.lastKeys || '') + key;
    }
  }]);
  return HotKeyHolder;
}();

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Divider = function Divider(props, context) {
  var inset = props.inset,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      prepareStyles = _context$muiTheme.prepareStyles;


  var styles = {
    root: {
      margin: 0,
      marginTop: -1,
      marginLeft: inset ? 72 : 0,
      height: 1,
      border: 'none',
      backgroundColor: baseTheme.palette.borderColor
    }
  };

  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
};

Divider.muiName = 'Divider';

Divider.propTypes =  false ? {
  /**
   * If true, the `Divider` will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

Divider.defaultProps = {
  inset: false
};

Divider.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = Divider;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var backgroundColor = props.backgroundColor,
      color = props.color,
      size = props.size;
  var avatar = context.muiTheme.avatar;


  var styles = {
    root: {
      color: color || avatar.color,
      backgroundColor: backgroundColor || avatar.backgroundColor,
      userSelect: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size / 2,
      borderRadius: '50%',
      height: size,
      width: size
    },
    icon: {
      color: color || avatar.color,
      width: size * 0.6,
      height: size * 0.6,
      fontSize: size * 0.6,
      margin: size * 0.2
    }
  };

  return styles;
}

var Avatar = function (_Component) {
  (0, _inherits3.default)(Avatar, _Component);

  function Avatar() {
    (0, _classCallCheck3.default)(this, Avatar);
    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          icon = _props.icon,
          src = _props.src,
          style = _props.style,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      if (src) {
        return _react2.default.createElement('img', (0, _extends3.default)({
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, other, {
          src: src,
          className: className
        }));
      } else {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, other, {
            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
            className: className
          }),
          icon && _react2.default.cloneElement(icon, {
            color: styles.icon.color,
            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
          }),
          this.props.children
        );
      }
    }
  }]);
  return Avatar;
}(_react.Component);

Avatar.muiName = 'Avatar';
Avatar.defaultProps = {
  size: 40
};
Avatar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Avatar.propTypes =  false ? {
  /**
   * The backgroundColor of the avatar. Does not apply to image avatars.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Can be used, for instance, to render a letter inside the avatar.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root `div` or `img` element.
   */
  className: _propTypes2.default.string,
  /**
   * The icon or letter's color.
   */
  color: _propTypes2.default.string,
  /**
   * This is the SvgIcon or FontIcon to be used inside the avatar.
   */
  icon: _propTypes2.default.element,
  /**
   * This is the size of the avatar in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
   */
  src: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Avatar;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Badge = __webpack_require__(1798);

var _Badge2 = _interopRequireDefault(_Badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Badge2.default;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var primary = props.primary,
      secondary = props.secondary;
  var badge = context.muiTheme.badge;


  var badgeBackgroundColor = void 0;
  var badgeTextColor = void 0;

  if (primary) {
    badgeBackgroundColor = badge.primaryColor;
    badgeTextColor = badge.primaryTextColor;
  } else if (secondary) {
    badgeBackgroundColor = badge.secondaryColor;
    badgeTextColor = badge.secondaryTextColor;
  } else {
    badgeBackgroundColor = badge.color;
    badgeTextColor = badge.textColor;
  }

  var radius = 12;
  var radius2x = Math.floor(2 * radius);

  return {
    root: {
      position: 'relative',
      display: 'inline-block',
      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
    },
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      right: 0,
      fontWeight: badge.fontWeight,
      fontSize: radius,
      width: radius2x,
      height: radius2x,
      borderRadius: '50%',
      backgroundColor: badgeBackgroundColor,
      color: badgeTextColor
    }
  };
}

var Badge = function (_Component) {
  (0, _inherits3.default)(Badge, _Component);

  function Badge() {
    (0, _classCallCheck3.default)(this, Badge);
    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
  }

  (0, _createClass3.default)(Badge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          badgeContent = _props.badgeContent,
          badgeStyle = _props.badgeStyle,
          children = _props.children,
          primary = _props.primary,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        children,
        _react2.default.createElement(
          'span',
          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
          badgeContent
        )
      );
    }
  }]);
  return Badge;
}(_react.Component);

Badge.defaultProps = {
  primary: false,
  secondary: false
};
Badge.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Badge.propTypes =  false ? {
  /**
   * This is the content rendered within the badge.
   */
  badgeContent: _propTypes2.default.node.isRequired,
  /**
   * Override the inline-styles of the badge element.
   */
  badgeStyle: _propTypes2.default.object,
  /**
   * The badge will be added relativelty to this node.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, the badge will use the primary badge colors.
   */
  primary: _propTypes2.default.bool,
  /**
   * If true, the badge will use the secondary badge colors.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Badge;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;

var _BottomNavigation2 = __webpack_require__(1800);

var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);

var _BottomNavigationItem2 = __webpack_require__(762);

var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BottomNavigation = _BottomNavigation3.default;
exports.BottomNavigationItem = _BottomNavigationItem3.default;
exports.default = _BottomNavigation3.default;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var bottomNavigation = context.muiTheme.bottomNavigation;


  var styles = {
    root: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: bottomNavigation.backgroundColor,
      height: bottomNavigation.height
    },
    item: {
      flex: '1'
    }
  };

  return styles;
}

var BottomNavigation = function BottomNavigation(props, context) {
  var children = props.children,
      style = props.style,
      selectedIndex = props.selectedIndex,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
  var prepareStyles = context.muiTheme.prepareStyles;

  var styles = getStyles(props, context);

  var preparedChildren = _react.Children.map(children, function (child, index) {
    if (!child) {
      return null;
    }

    return (0, _react.cloneElement)(child, {
      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
      selected: index === selectedIndex
    });
  });

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
    preparedChildren
  );
};

BottomNavigation.propTypes =  false ? {
  /**
   * The `BottomNavigationItem`s to populate the element with.
   */
  children: _propTypes2.default.node,
  /**
   * The index of the currently selected navigation item.
   */
  selectedIndex: _propTypes2.default.number,
  /**
   * @ignore
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

BottomNavigation.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = BottomNavigation;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;

var _Card2 = __webpack_require__(1802);

var _Card3 = _interopRequireDefault(_Card2);

var _CardHeader2 = __webpack_require__(764);

var _CardHeader3 = _interopRequireDefault(_CardHeader2);

var _CardTitle2 = __webpack_require__(765);

var _CardTitle3 = _interopRequireDefault(_CardTitle2);

var _CardMedia2 = __webpack_require__(766);

var _CardMedia3 = _interopRequireDefault(_CardMedia2);

var _CardText2 = __webpack_require__(767);

var _CardText3 = _interopRequireDefault(_CardText2);

var _CardActions2 = __webpack_require__(768);

var _CardActions3 = _interopRequireDefault(_CardActions2);

var _CardExpandable2 = __webpack_require__(763);

var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Card = _Card3.default;
exports.CardHeader = _CardHeader3.default;
exports.CardTitle = _CardTitle3.default;
exports.CardMedia = _CardMedia3.default;
exports.CardText = _CardText3.default;
exports.CardActions = _CardActions3.default;
exports.CardExpandable = _CardExpandable3.default;
exports.default = _Card3.default;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _CardExpandable = __webpack_require__(763);

var _CardExpandable2 = _interopRequireDefault(_CardExpandable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function (_Component) {
  (0, _inherits3.default)(Card, _Component);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: null
    }, _this.handleExpanding = function (event) {
      event.preventDefault();
      var newExpandedState = !_this.state.expanded;
      // no automatic state update when the component is controlled
      if (_this.props.expanded === null) {
        _this.setState({ expanded: newExpandedState });
      }
      if (_this.props.onExpandChange) {
        _this.props.onExpandChange(newExpandedState);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Card, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          containerStyle = _props.containerStyle,
          children = _props.children,
          expandable = _props.expandable,
          expandedProp = _props.expanded,
          initiallyExpanded = _props.initiallyExpanded,
          onExpandChange = _props.onExpandChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);


      var lastElement = void 0;
      var expanded = this.state.expanded;
      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        var doClone = false;
        var newChild = undefined;
        var newProps = {};
        var element = currentChild;
        if (!currentChild || !currentChild.props) {
          return null;
        }
        if (expanded === false && currentChild.props.expandable === true) return;
        if (currentChild.props.actAsExpander === true) {
          doClone = true;
          newProps.onClick = _this2.handleExpanding;
          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
        }
        if (currentChild.props.showExpandableButton === true) {
          doClone = true;
          newChild = _react2.default.createElement(_CardExpandable2.default, {
            closeIcon: currentChild.props.closeIcon,
            expanded: expanded,
            onExpanding: _this2.handleExpanding,
            openIcon: currentChild.props.openIcon,
            iconStyle: currentChild.props.iconStyle
          });
        }
        if (doClone) {
          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
        }
        lastElement = element;
        return element;
      }, this);

      // If the last element is text or a title we should add
      // 8px padding to the bottom of the card
      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');

      var mergedStyles = (0, _simpleAssign2.default)({
        zIndex: 1
      }, style);
      var containerMergedStyles = (0, _simpleAssign2.default)({
        paddingBottom: addBottomPadding ? 8 : 0
      }, containerStyle);

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({}, other, { style: mergedStyles }),
        _react2.default.createElement(
          'div',
          { style: containerMergedStyles },
          newChildren
        )
      );
    }
  }]);
  return Card;
}(_react.Component);

Card.defaultProps = {
  expandable: false,
  expanded: null,
  initiallyExpanded: false
};
Card.propTypes =  false ? {
  /**
   * Can be used to render elements inside the Card.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If true, this card component is expandable. Can be set on any child of the `Card` component.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Whether this card is expanded.
   * If `true` or `false` the component is controlled.
   * if `null` the component is uncontrolled.
   */
  expanded: _propTypes2.default.bool,
  /**
   * Whether this card is initially expanded.
   */
  initiallyExpanded: _propTypes2.default.bool,
  /**
   * Callback function fired when the `expandable` state of the card has changed.
   *
   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
   */
  onExpandChange: _propTypes2.default.func,
  /**
   * If true, this card component will include a button to expand the card. `CardTitle`,
   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
   * of `Card` can implements `showExpandableButton` or forwards the property to a child
   * component supporting it.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Card;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedSwitch = __webpack_require__(507);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _checkBoxOutlineBlank = __webpack_require__(769);

var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);

var _checkBox = __webpack_require__(770);

var _checkBox2 = _interopRequireDefault(_checkBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var checkbox = context.muiTheme.checkbox;

  var checkboxSize = 24;

  return {
    icon: {
      height: checkboxSize,
      width: checkboxSize
    },
    check: {
      position: 'absolute',
      opacity: 0,
      transform: 'scale(0)',
      transitionOrigin: '50% 50%',
      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
      fill: checkbox.checkedColor
    },
    checkWhenSwitched: {
      opacity: 1,
      transform: 'scale(1)',
      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
    },
    checkWhenDisabled: {
      fill: checkbox.disabledColor
    },
    box: {
      position: 'absolute',
      opacity: 1,
      fill: checkbox.boxColor,
      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
    },
    boxWhenSwitched: {
      opacity: 0,
      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
      fill: checkbox.checkedColor
    },
    boxWhenDisabled: {
      fill: props.checked ? 'transparent' : checkbox.disabledColor
    },
    label: {
      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
    }
  };
}

var Checkbox = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      switched: false
    }, _this.handleStateChange = function (newSwitched) {
      _this.setState({
        switched: newSwitched
      });
    }, _this.handleCheck = function (event, isInputChecked) {
      if (_this.props.onCheck) {
        _this.props.onCheck(event, isInputChecked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          checked = _props.checked,
          defaultChecked = _props.defaultChecked,
          valueLink = _props.valueLink;


      if (checked || defaultChecked || valueLink && valueLink.value) {
        this.setState({
          switched: true
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.checked !== nextProps.checked) {
        this.setState({
          switched: nextProps.checked
        });
      }
    }
  }, {
    key: 'isChecked',
    value: function isChecked() {
      return this.refs.enhancedSwitch.isSwitched();
    }
  }, {
    key: 'setChecked',
    value: function setChecked(newCheckedValue) {
      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          iconStyle = _props2.iconStyle,
          onCheck = _props2.onCheck,
          checkedIcon = _props2.checkedIcon,
          uncheckedIcon = _props2.uncheckedIcon,
          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);

      var styles = getStyles(this.props, this.context);
      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);

      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
      }) : _react2.default.createElement(_checkBox2.default, {
        style: checkStyles
      });

      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
        style: boxStyles
      });

      var checkboxElement = _react2.default.createElement(
        'div',
        null,
        unCheckedElement,
        checkedElement
      );

      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);

      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);

      var enhancedSwitchProps = {
        ref: 'enhancedSwitch',
        inputType: 'checkbox',
        switched: this.state.switched,
        switchElement: checkboxElement,
        rippleColor: rippleColor,
        iconStyle: mergedIconStyle,
        onSwitch: this.handleCheck,
        labelStyle: labelStyle,
        onParentShouldUpdate: this.handleStateChange,
        labelPosition: this.props.labelPosition
      };

      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
    }
  }]);
  return Checkbox;
}(_react.Component);

Checkbox.defaultProps = {
  labelPosition: 'right',
  disabled: false
};
Checkbox.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Checkbox.propTypes =  false ? {
  /**
   * Checkbox is checked if true.
   */
  checked: _propTypes2.default.bool,
  /**
   * The SvgIcon to use for the checked state.
   * This is useful to create icon toggles.
   */
  checkedIcon: _propTypes2.default.element,
  /**
   * The default state of our checkbox component.
   * **Warning:** This cannot be used in conjunction with `checked`.
   * Decide between using a controlled or uncontrolled input element and remove one of these props.
   * More info: https://fb.me/react-controlled-components
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * Disabled if true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the inline-styles of the input element.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * Where the label will be placed next to the checkbox.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Overrides the inline-styles of the Checkbox element label.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function that is fired when the checkbox is checked.
   *
   * @param {object} event `change` event targeting the underlying checkbox `input`.
   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
   */
  onCheck: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The SvgIcon to use for the unchecked state.
   * This is useful to create icon toggles.
   */
  uncheckedIcon: _propTypes2.default.element,
  /**
   * ValueLink for when using controlled checkbox.
   */
  valueLink: _propTypes2.default.object
} : {};
exports.default = Checkbox;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _colorManipulator = __webpack_require__(155);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _cancel = __webpack_require__(772);

var _cancel2 = _interopRequireDefault(_cancel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var chip = context.muiTheme.chip;


  var backgroundColor = props.backgroundColor || chip.backgroundColor;
  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);

  return {
    avatar: {
      marginRight: -4
    },
    deleteIcon: {
      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
      cursor: 'pointer',
      margin: '4px 4px 0px -8px'
    },
    label: {
      color: props.labelColor || chip.textColor,
      fontSize: chip.fontSize,
      fontWeight: chip.fontWeight,
      lineHeight: '32px',
      paddingLeft: 12,
      paddingRight: 12,
      userSelect: 'none',
      whiteSpace: 'nowrap'
    },
    root: {
      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
      borderRadius: 16,
      boxShadow: state.clicked ? chip.shadow : null,
      cursor: props.onClick ? 'pointer' : 'default',
      display: 'flex',
      whiteSpace: 'nowrap',
      width: 'fit-content'
    }
  };
}

var Chip = function (_Component) {
  (0, _inherits3.default)(Chip, _Component);

  function Chip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Chip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clicked: false,
      deleteHovered: false,
      focused: false,
      hovered: false
    }, _this.handleBlur = function (event) {
      _this.setState({ clicked: false, focused: false });
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (_this.props.onClick || _this.props.onRequestDelete) {
        _this.setState({ focused: true });
      }
      _this.props.onFocus(event);
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      if (keyboardFocused) {
        _this.handleFocus();
        _this.props.onFocus(event);
      } else {
        _this.handleBlur();
      }

      _this.props.onKeyboardFocus(event, keyboardFocused);
    }, _this.handleKeyDown = function (event) {
      if ((0, _keycode2.default)(event) === 'backspace') {
        event.preventDefault();
        if (_this.props.onRequestDelete) {
          _this.props.onRequestDelete(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleMouseDown = function (event) {
      // Only listen to left clicks
      if (event.button === 0) {
        event.stopPropagation();
        if (_this.props.onClick) {
          _this.setState({ clicked: true });
        }
      }
      _this.props.onMouseDown(event);
    }, _this.handleMouseEnter = function (event) {
      if (_this.props.onClick) {
        _this.setState({ hovered: true });
      }
      _this.props.onMouseEnter(event);
    }, _this.handleMouseEnterDeleteIcon = function () {
      _this.setState({ deleteHovered: true });
    }, _this.handleMouseLeave = function (event) {
      _this.setState({
        clicked: false,
        hovered: false
      });
      _this.props.onMouseLeave(event);
    }, _this.handleMouseLeaveDeleteIcon = function () {
      _this.setState({ deleteHovered: false });
    }, _this.handleMouseUp = function (event) {
      _this.setState({ clicked: false });
      _this.props.onMouseUp(event);
    }, _this.handleClickDeleteIcon = function (event) {
      // Stop the event from bubbling up to the `Chip`
      event.stopPropagation();
      _this.props.onRequestDelete(event);
    }, _this.handleTouchEnd = function (event) {
      _this.setState({ clicked: false });
      _this.props.onTouchEnd(event);
    }, _this.handleTouchStart = function (event) {
      event.stopPropagation();
      if (_this.props.onClick) {
        _this.setState({ clicked: true });
      }
      _this.props.onTouchStart(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Chip, [{
    key: 'render',
    value: function render() {
      var buttonEventHandlers = {
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchStart: this.handleTouchStart,
        onKeyboardFocus: this.handleKeyboardFocus
      };

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var _props = this.props,
          childrenProp = _props.children,
          containerElement = _props.containerElement,
          style = _props.style,
          className = _props.className,
          deleteIconStyle = _props.deleteIconStyle,
          labelStyle = _props.labelStyle,
          labelColor = _props.labelColor,
          backgroundColor = _props.backgroundColor,
          onRequestDelete = _props.onRequestDelete,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'containerElement', 'style', 'className', 'deleteIconStyle', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);


      var deletable = this.props.onRequestDelete;
      var avatar = null;

      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
        color: styles.deleteIcon.color,
        style: (0, _simpleAssign2.default)(styles.deleteIcon, deleteIconStyle),
        onClick: this.handleClickDeleteIcon,
        onMouseEnter: this.handleMouseEnterDeleteIcon,
        onMouseLeave: this.handleMouseLeaveDeleteIcon
      }) : null;

      var children = childrenProp;
      var childCount = _react2.default.Children.count(children);

      // If the first child is an avatar, extract it and style it
      if (childCount > 1) {
        children = _react2.default.Children.toArray(children);

        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
          avatar = children.shift();

          avatar = _react2.default.cloneElement(avatar, {
            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
            size: 32
          });
        }
      }

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, buttonEventHandlers, {
          className: className,
          containerElement: containerElement,
          disableTouchRipple: true,
          disableFocusRipple: true,
          style: (0, _simpleAssign2.default)(styles.root, style)
        }),
        avatar,
        _react2.default.createElement(
          'span',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
          children
        ),
        deleteIcon
      );
    }
  }]);
  return Chip;
}(_react.Component);

Chip.defaultProps = {
  containerElement: 'div', // Firefox doesn't support nested buttons
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseDown: function onMouseDown() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseUp: function onMouseUp() {},
  onTouchEnd: function onTouchEnd() {},
  onTouchStart: function onTouchStart() {}
};
Chip.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
Chip.propTypes =  false ? {
  /**
   * Override the background color of the chip.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Used to render elements inside the Chip.
   */
  children: _propTypes2.default.node,
  /**
   * CSS `className` of the root element.
   */
  className: _propTypes2.default.node,
  /**
   * The element to use as the container for the Chip. Either a string to
   * use a DOM element or a ReactElement.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * Override the inline-styles of the delete icon.
   */
  deleteIconStyle: _propTypes2.default.object,
  /**
   * Override the label color.
   */
  labelColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the label.
   */
  labelStyle: _propTypes2.default.object,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when the `Chip` element is clicked.
   *
   * @param {object} event Click event targeting the element.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /** @ignore */
  onKeyDown: _propTypes2.default.func,
  /** @ignore */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /**
   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
   * @param {object} event `click` event targeting the element.
   */
  onRequestDelete: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Chip;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateUtils = __webpack_require__(267);

var _DatePickerDialog = __webpack_require__(1806);

var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);

var _TextField = __webpack_require__(23);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePicker = function (_Component) {
  (0, _inherits3.default)(DatePicker, _Component);

  function DatePicker() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      date: undefined
    }, _this.handleAccept = function (date) {
      if (!_this.isControlled()) {
        _this.setState({
          date: date
        });
      }
      if (_this.props.onChange) {
        _this.props.onChange(null, date);
      }
    }, _this.handleFocus = function (event) {
      event.target.blur();
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (!_this.props.disabled) {
        setTimeout(function () {
          _this.openDialog();
        }, 0);
      }
    }, _this.formatDate = function (date) {
      if (_this.props.locale) {
        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
        return new DateTimeFormat(_this.props.locale, {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric'
        }).format(date);
      } else {
        return (0, _dateUtils.formatIso)(date);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DatePicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlled()) {
        var newDate = this.getControlledDate(nextProps);
        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
          this.setState({
            date: newDate
          });
        }
      }
    }
  }, {
    key: 'getDate',
    value: function getDate() {
      return this.state.date;
    }

    /**
     * Open the date-picker dialog programmatically from a parent.
     */

  }, {
    key: 'openDialog',
    value: function openDialog() {
      /**
       * if the date is not selected then set it to new date
       * (get the current system date while doing so)
       * else set it to the currently selected date
       */
      if (this.state.date !== undefined) {
        this.setState({
          dialogDate: this.getDate()
        }, this.refs.dialogWindow.show);
      } else {
        this.setState({
          dialogDate: new Date()
        }, this.refs.dialogWindow.show);
      }
    }

    /**
     * Alias for `openDialog()` for an api consistent with TextField.
     */

  }, {
    key: 'focus',
    value: function focus() {
      this.openDialog();
    }
  }, {
    key: 'isControlled',
    value: function isControlled() {
      return this.props.hasOwnProperty('value');
    }
  }, {
    key: 'getControlledDate',
    value: function getControlledDate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (props.value instanceof Date) {
        return props.value;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          autoOk = _props.autoOk,
          cancelLabel = _props.cancelLabel,
          className = _props.className,
          container = _props.container,
          defaultDate = _props.defaultDate,
          dialogContainerStyle = _props.dialogContainerStyle,
          disableYearSelection = _props.disableYearSelection,
          firstDayOfWeek = _props.firstDayOfWeek,
          formatDateProp = _props.formatDate,
          locale = _props.locale,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          mode = _props.mode,
          okLabel = _props.okLabel,
          onDismiss = _props.onDismiss,
          onFocus = _props.onFocus,
          onShow = _props.onShow,
          onClick = _props.onClick,
          openToYearSelection = _props.openToYearSelection,
          shouldDisableDate = _props.shouldDisableDate,
          hideCalendarDate = _props.hideCalendarDate,
          style = _props.style,
          textFieldStyle = _props.textFieldStyle,
          utils = _props.utils,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onClick', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'textFieldStyle', 'utils']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var formatDate = formatDateProp || this.formatDate;

      return _react2.default.createElement(
        'div',
        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
          onFocus: this.handleFocus,
          onClick: this.handleClick,
          ref: 'input',
          style: textFieldStyle,
          value: this.state.date ? formatDate(this.state.date) : ''
        })),
        _react2.default.createElement(_DatePickerDialog2.default, {
          DateTimeFormat: DateTimeFormat,
          autoOk: autoOk,
          cancelLabel: cancelLabel,
          container: container,
          containerStyle: dialogContainerStyle,
          disableYearSelection: disableYearSelection,
          firstDayOfWeek: firstDayOfWeek,
          initialDate: this.state.dialogDate,
          locale: locale,
          maxDate: maxDate,
          minDate: minDate,
          mode: mode,
          okLabel: okLabel,
          onAccept: this.handleAccept,
          onShow: onShow,
          onDismiss: onDismiss,
          ref: 'dialogWindow',
          shouldDisableDate: shouldDisableDate,
          hideCalendarDate: hideCalendarDate,
          openToYearSelection: openToYearSelection,
          utils: utils
        })
      );
    }
  }]);
  return DatePicker;
}(_react.Component);

DatePicker.defaultProps = {
  autoOk: false,
  container: 'dialog',
  disabled: false,
  disableYearSelection: false,
  firstDayOfWeek: 1,
  hideCalendarDate: false,
  style: {},
  openToYearSelection: false
};
DatePicker.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DatePicker.propTypes =  false ? {
  /**
   * Constructor for date formatting for the specified `locale`.
   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
   *
   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
   */
  DateTimeFormat: _propTypes2.default.func,
  /**
   * If true, automatically accept and close the picker on select a date.
   */
  autoOk: _propTypes2.default.bool,
  /**
   * Override the default text of the 'Cancel' button.
   */
  cancelLabel: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Used to control how the Date Picker will be displayed when the input field is focused.
   * `dialog` (default) displays the DatePicker as a dialog with a modal.
   * `inline` displays the DatePicker below the input field (similar to auto complete).
   */
  container: _propTypes2.default.oneOf(['dialog', 'inline']),
  /**
   * This is the initial date value of the component.
   * If either `value` or `valueLink` is provided they will override this
   * prop with `value` taking precedence.
   */
  defaultDate: _propTypes2.default.object,
  /**
   * Override the inline-styles of DatePickerDialog's Container element.
   */
  dialogContainerStyle: _propTypes2.default.object,
  /**
   * Disables the year selection in the date picker.
   */
  disableYearSelection: _propTypes2.default.bool,
  /**
   * Disables the DatePicker.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used to change the first day of week. It varies from
   * Saturday to Monday between different locales.
   * The allowed range is 0 (Sunday) to 6 (Saturday).
   * The default is `1`, Monday, as per ISO 8601.
   */
  firstDayOfWeek: _propTypes2.default.number,
  /**
   * This function is called to format the date displayed in the input field, and should return a string.
   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
   *
   * @param {object} date Date object to be formatted.
   * @returns {any} The formatted date.
   */
  formatDate: _propTypes2.default.func,
  /**
   * Hide date display
   */
  hideCalendarDate: _propTypes2.default.bool,
  /**
   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
   * must provide a `DateTimeFormat` that supports the chosen `locale`.
   */
  locale: _propTypes2.default.string,
  /**
   * The ending of a range of valid dates. The range includes the endDate.
   * The default value is current date + 100 years.
   */
  maxDate: _propTypes2.default.object,
  /**
   * The beginning of a range of valid dates. The range includes the startDate.
   * The default value is current date - 100 years.
   */
  minDate: _propTypes2.default.object,
  /**
   * Tells the component to display the picker in portrait or landscape mode.
   */
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  /**
   * Override the default text of the 'OK' button.
   */
  okLabel: _propTypes2.default.node,
  /**
   * Callback function that is fired when the date value changes.
   *
   * @param {null} null Since there is no particular event associated with the change,
   * the first argument will always be null.
   * @param {object} date The new date.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function that is fired when a click event occurs on the Date Picker's `TextField`.
   *
   * @param {object} event Click event targeting the `TextField`.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function that is fired when the Date Picker's dialog is dismissed.
   */
  onDismiss: _propTypes2.default.func,
  /**
   * Callback function that is fired when the Date Picker's `TextField` gains focus.
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the Date Picker's dialog is shown.
   */
  onShow: _propTypes2.default.func,
  /**
   * If true sets the datepicker to open to year selection first.
   */
  openToYearSelection: _propTypes2.default.bool,
  /**
   * Callback function used to determine if a day's entry should be disabled on the calendar.
   *
   * @param {object} day Date object of a day.
   * @returns {boolean} Indicates whether the day should be disabled.
   */
  shouldDisableDate: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of DatePicker's TextField element.
   */
  textFieldStyle: _propTypes2.default.object,
  /**
   * This object should contain methods needed to build the calendar system.
   *
   * Useful for building a custom calendar system. Refer to the
   * [source code](https://github.com/mui-org/material-ui/blob/v0.x/src/DatePicker/dateUtils.js)
   * and an [example implementation](https://github.com/alitaheri/material-ui-persian-date-picker-utils)
   * for more information.
   */
  utils: _propTypes2.default.object,
  /**
   * Sets the date for the Date Picker programmatically.
   */
  value: _propTypes2.default.object
} : {};
exports.default = DatePicker;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _Calendar = __webpack_require__(1807);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _Dialog = __webpack_require__(36);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Popover = __webpack_require__(226);

var _Popover2 = _interopRequireDefault(_Popover);

var _PopoverAnimationVertical = __webpack_require__(494);

var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);

var _dateUtils = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerDialog = function (_Component) {
  (0, _inherits3.default)(DatePickerDialog, _Component);

  function DatePickerDialog() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatePickerDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.show = function () {
      if (_this.props.onShow && !_this.state.open) {
        _this.props.onShow();
      }

      _this.setState({
        open: true
      });
    }, _this.dismiss = function () {
      if (_this.props.onDismiss && _this.state.open) {
        _this.props.onDismiss();
      }

      _this.setState({
        open: false
      });
    }, _this.handleClickDay = function () {
      if (_this.props.autoOk) {
        setTimeout(_this.handleClickOk, 300);
      }
    }, _this.handleClickCancel = function () {
      _this.dismiss();
    }, _this.handleRequestClose = function () {
      _this.dismiss();
    }, _this.handleClickOk = function () {
      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
      }

      _this.setState({
        open: false
      });
    }, _this.handleWindowKeyUp = function (event) {
      switch ((0, _keycode2.default)(event)) {
        case 'enter':
          _this.handleClickOk();
          break;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DatePickerDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          autoOk = _props.autoOk,
          cancelLabel = _props.cancelLabel,
          container = _props.container,
          containerStyle = _props.containerStyle,
          disableYearSelection = _props.disableYearSelection,
          initialDate = _props.initialDate,
          firstDayOfWeek = _props.firstDayOfWeek,
          locale = _props.locale,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          mode = _props.mode,
          okLabel = _props.okLabel,
          onAccept = _props.onAccept,
          onDismiss = _props.onDismiss,
          onShow = _props.onShow,
          openToYearSelection = _props.openToYearSelection,
          shouldDisableDate = _props.shouldDisableDate,
          hideCalendarDate = _props.hideCalendarDate,
          style = _props.style,
          animation = _props.animation,
          utils = _props.utils,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'animation', 'utils']);
      var open = this.state.open;


      var styles = {
        dialogContent: {
          width: !hideCalendarDate && mode === 'landscape' ? 479 : 310
        },
        dialogBodyContent: {
          padding: 0,
          minHeight: hideCalendarDate || mode === 'landscape' ? 330 : 434,
          minWidth: hideCalendarDate || mode !== 'landscape' ? 310 : 479
        }
      };

      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { ref: 'root' }),
        _react2.default.createElement(
          Container,
          {
            anchorEl: this.refs.root // For Popover
            , animation: animation || _PopoverAnimationVertical2.default // For Popover
            , bodyStyle: styles.dialogBodyContent,
            contentStyle: styles.dialogContent,
            ref: 'dialog',
            repositionOnUpdate: true,
            open: open,
            onRequestClose: this.handleRequestClose,
            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
          },
          _react2.default.createElement(_reactEventListener2.default, {
            target: 'window',
            onKeyUp: this.handleWindowKeyUp
          }),
          _react2.default.createElement(_Calendar2.default, {
            autoOk: autoOk,
            DateTimeFormat: DateTimeFormat,
            cancelLabel: cancelLabel,
            disableYearSelection: disableYearSelection,
            firstDayOfWeek: firstDayOfWeek,
            initialDate: initialDate,
            locale: locale,
            onClickDay: this.handleClickDay,
            maxDate: maxDate,
            minDate: minDate,
            mode: mode,
            open: open,
            ref: 'calendar',
            onClickCancel: this.handleClickCancel,
            onClickOk: this.handleClickOk,
            okLabel: okLabel,
            openToYearSelection: openToYearSelection,
            shouldDisableDate: shouldDisableDate,
            hideCalendarDate: hideCalendarDate,
            utils: utils
          })
        )
      );
    }
  }]);
  return DatePickerDialog;
}(_react.Component);

DatePickerDialog.defaultProps = {
  DateTimeFormat: _dateUtils.dateTimeFormat,
  cancelLabel: 'Cancel',
  container: 'dialog',
  locale: 'en-US',
  okLabel: 'OK',
  openToYearSelection: false
};
DatePickerDialog.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DatePickerDialog.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func,
  animation: _propTypes2.default.func,
  autoOk: _propTypes2.default.bool,
  cancelLabel: _propTypes2.default.node,
  container: _propTypes2.default.oneOf(['dialog', 'inline']),
  containerStyle: _propTypes2.default.object,
  disableYearSelection: _propTypes2.default.bool,
  firstDayOfWeek: _propTypes2.default.number,
  hideCalendarDate: _propTypes2.default.bool,
  initialDate: _propTypes2.default.object,
  locale: _propTypes2.default.string,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  okLabel: _propTypes2.default.node,
  onAccept: _propTypes2.default.func,
  onDismiss: _propTypes2.default.func,
  onShow: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  openToYearSelection: _propTypes2.default.bool,
  shouldDisableDate: _propTypes2.default.func,
  style: _propTypes2.default.object,
  utils: _propTypes2.default.object
} : {};
exports.default = DatePickerDialog;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = __webpack_require__(220);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _CalendarActionButtons = __webpack_require__(1808);

var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);

var _CalendarMonth = __webpack_require__(1809);

var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);

var _CalendarYear = __webpack_require__(1811);

var _CalendarYear2 = _interopRequireDefault(_CalendarYear);

var _CalendarToolbar = __webpack_require__(1813);

var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);

var _DateDisplay = __webpack_require__(1815);

var _DateDisplay2 = _interopRequireDefault(_DateDisplay);

var _SlideIn = __webpack_require__(508);

var _SlideIn2 = _interopRequireDefault(_SlideIn);

var _dateUtils = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));

var Calendar = function (_Component) {
  (0, _inherits3.default)(Calendar, _Component);

  function Calendar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayDate: undefined,
      displayMonthDay: undefined,
      selectedDate: undefined,
      transitionDirection: 'left',
      transitionEnter: true
    }, _this.calendarRefs = {}, _this.handleClickDay = function (event, date) {
      _this.setSelectedDate(date);
      if (_this.props.onClickDay) _this.props.onClickDay(event, date);
    }, _this.handleMonthChange = function (months) {
      var nextDirection = _this.context.muiTheme.isRtl ? 'right' : 'left';
      var prevDirection = _this.context.muiTheme.isRtl ? 'left' : 'right';
      var direction = months >= 0 ? nextDirection : prevDirection;
      _this.setState({
        transitionDirection: direction,
        displayDate: _this.props.utils.addMonths(_this.state.displayDate, months)
      });
    }, _this.handleClickYear = function (event, year) {
      _this.setSelectedDate(_this.props.utils.setYear(_this.state.selectedDate, year), event);
      _this.handleClickDateDisplayMonthDay();
    }, _this.handleClickDateDisplayMonthDay = function () {
      _this.setState({
        displayMonthDay: true
      });
    }, _this.handleClickDateDisplayYear = function () {
      _this.setState({
        displayMonthDay: false
      });
    }, _this.handleWindowKeyDown = function (event) {
      if (_this.props.open) {
        var nextArrow = _this.context.muiTheme.isRtl ? 'left' : 'right';
        var prevArrow = _this.context.muiTheme.isRtl ? 'right' : 'left';
        switch ((0, _keycode2.default)(event)) {
          case 'up':
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(-1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(-1);
            } else {
              _this.addSelectedDays(-7);
            }
            break;

          case 'down':
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(1);
            } else {
              _this.addSelectedDays(7);
            }
            break;

          case nextArrow:
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(1);
            } else {
              _this.addSelectedDays(1);
            }
            break;

          case prevArrow:
            if (event.altKey && event.shiftKey) {
              _this.addSelectedYears(-1);
            } else if (event.shiftKey) {
              _this.addSelectedMonths(-1);
            } else {
              _this.addSelectedDays(-1);
            }
            break;
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Calendar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        displayDate: this.props.utils.getFirstDayOfMonth(this.props.initialDate),
        selectedDate: this.props.initialDate,
        displayMonthDay: !this.props.openToYearSelection
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.initialDate !== this.props.initialDate) {
        var date = nextProps.initialDate || new Date();
        this.setState({
          displayDate: this.props.utils.getFirstDayOfMonth(date),
          selectedDate: date
        });
      }
    }
  }, {
    key: 'getMinDate',
    value: function getMinDate() {
      return this.props.minDate || this.props.utils.addYears(new Date(), -100);
    }
  }, {
    key: 'getMaxDate',
    value: function getMaxDate() {
      return this.props.maxDate || this.props.utils.addYears(new Date(), 100);
    }
  }, {
    key: 'getSelectedDate',
    value: function getSelectedDate() {
      return this.state.selectedDate;
    }
  }, {
    key: 'isSelectedDateDisabled',
    value: function isSelectedDateDisabled() {
      if (!this.state.displayMonthDay) {
        return false;
      }

      if (this.calendarRefs.calendar) {
        return this.calendarRefs.calendar.isSelectedDateDisabled();
      } else {
        return false;
      }
    }
  }, {
    key: 'addSelectedDays',
    value: function addSelectedDays(days) {
      this.setSelectedDate(this.props.utils.addDays(this.state.selectedDate, days));
    }
  }, {
    key: 'addSelectedMonths',
    value: function addSelectedMonths(months) {
      this.setSelectedDate(this.props.utils.addMonths(this.state.selectedDate, months));
    }
  }, {
    key: 'addSelectedYears',
    value: function addSelectedYears(years) {
      this.setSelectedDate(this.props.utils.addYears(this.state.selectedDate, years));
    }
  }, {
    key: 'setDisplayDate',
    value: function setDisplayDate(date, newSelectedDate) {
      var newDisplayDate = this.props.utils.getFirstDayOfMonth(date);

      if (newDisplayDate !== this.state.displayDate) {
        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
        var direction = newDisplayDate > this.state.displayDate ? nextDirection : prevDirection;
        this.setState({
          displayDate: newDisplayDate,
          transitionDirection: direction,
          selectedDate: newSelectedDate || this.state.selectedDate
        });
      }
    }
  }, {
    key: 'setSelectedDate',
    value: function setSelectedDate(date) {
      var adjustedDate = date;
      var minDate = this.getMinDate();
      var maxDate = this.getMaxDate();
      if ((0, _dateUtils.isBeforeDate)(date, minDate)) {
        adjustedDate = minDate;
      } else if ((0, _dateUtils.isAfterDate)(date, maxDate)) {
        adjustedDate = maxDate;
      }

      var newDisplayDate = this.props.utils.getFirstDayOfMonth(adjustedDate);
      if (newDisplayDate !== this.state.displayDate) {
        this.setDisplayDate(newDisplayDate, adjustedDate);
      } else {
        this.setState({
          selectedDate: adjustedDate
        });
      }
    }
  }, {
    key: 'getToolbarInteractions',
    value: function getToolbarInteractions() {
      return {
        prevMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMinDate()) > 0,
        nextMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMaxDate()) < 0
      };
    }
  }, {
    key: 'yearSelector',
    value: function yearSelector() {
      if (!this.props.disableYearSelection) {
        return _react2.default.createElement(_CalendarYear2.default, {
          key: 'years',
          DateTimeFormat: this.props.DateTimeFormat,
          locale: this.props.locale,
          onClickYear: this.handleClickYear,
          selectedDate: this.state.selectedDate,
          minDate: this.getMinDate(),
          maxDate: this.getMaxDate(),
          utils: this.props.utils
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var prepareStyles = this.context.muiTheme.prepareStyles;
      var hideCalendarDate = this.props.hideCalendarDate;

      var toolbarInteractions = this.getToolbarInteractions();
      var isLandscape = this.props.mode === 'landscape';
      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;


      var styles = {
        root: {
          color: calendarTextColor,
          userSelect: 'none',
          width: !hideCalendarDate && isLandscape ? 479 : 310
        },
        calendar: {
          display: 'flex',
          flexDirection: 'column'
        },
        calendarContainer: {
          display: 'flex',
          alignContent: 'space-between',
          justifyContent: 'space-between',
          flexDirection: 'column',
          fontSize: 12,
          fontWeight: 400,
          padding: '0px 8px',
          transition: _transitions2.default.easeOut()
        },
        yearContainer: {
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',
          height: 272,
          marginTop: 10,
          overflow: 'hidden',
          width: 310
        },
        weekTitle: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          fontWeight: '500',
          height: 20,
          lineHeight: '15px',
          opacity: '0.5',
          textAlign: 'center'
        },
        weekTitleDay: {
          width: 42
        },
        transitionSlide: {
          height: 214
        }
      };

      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);

      var _props = this.props,
          cancelLabel = _props.cancelLabel,
          DateTimeFormat = _props.DateTimeFormat,
          firstDayOfWeek = _props.firstDayOfWeek,
          locale = _props.locale,
          okLabel = _props.okLabel,
          onClickCancel = _props.onClickCancel,
          onClickOk = _props.onClickOk,
          utils = _props.utils;


      return _react2.default.createElement(
        'div',
        { style: prepareStyles(styles.root) },
        _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyDown: this.handleWindowKeyDown
        }),
        !hideCalendarDate && _react2.default.createElement(_DateDisplay2.default, {
          DateTimeFormat: DateTimeFormat,
          disableYearSelection: this.props.disableYearSelection,
          onClickMonthDay: this.handleClickDateDisplayMonthDay,
          onClickYear: this.handleClickDateDisplayYear,
          locale: locale,
          monthDaySelected: this.state.displayMonthDay,
          mode: this.props.mode,
          selectedDate: this.state.selectedDate
        }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.calendar) },
          this.state.displayMonthDay && _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.calendarContainer) },
            _react2.default.createElement(_CalendarToolbar2.default, {
              DateTimeFormat: DateTimeFormat,
              locale: locale,
              displayDate: this.state.displayDate,
              onMonthChange: this.handleMonthChange,
              prevMonth: toolbarInteractions.prevMonth,
              nextMonth: toolbarInteractions.nextMonth
            }),
            _react2.default.createElement(
              'div',
              { style: prepareStyles(styles.weekTitle) },
              daysArray.map(function (event, i) {
                return _react2.default.createElement(
                  'span',
                  { key: i, style: weekTitleDayStyle },
                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
                );
              })
            ),
            _react2.default.createElement(
              _SlideIn2.default,
              { direction: this.state.transitionDirection, style: styles.transitionSlide },
              _react2.default.createElement(_CalendarMonth2.default, {
                DateTimeFormat: DateTimeFormat,
                locale: locale,
                displayDate: this.state.displayDate,
                firstDayOfWeek: this.props.firstDayOfWeek,
                key: this.state.displayDate.toDateString(),
                minDate: this.getMinDate(),
                maxDate: this.getMaxDate(),
                onClickDay: this.handleClickDay,
                ref: function ref(_ref2) {
                  return _this2.calendarRefs.calendar = _ref2;
                },
                selectedDate: this.state.selectedDate,
                shouldDisableDate: this.props.shouldDisableDate,
                utils: utils
              })
            )
          ),
          !this.state.displayMonthDay && _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.yearContainer) },
            this.yearSelector()
          ),
          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
            autoOk: this.props.autoOk,
            cancelLabel: cancelLabel,
            okLabel: okLabel,
            onClickCancel: onClickCancel,
            onClickOk: onClickOk
          })
        )
      );
    }
  }]);
  return Calendar;
}(_react.Component);

Calendar.defaultProps = {
  DateTimeFormat: _dateUtils.dateTimeFormat,
  disableYearSelection: false,
  initialDate: new Date(),
  locale: 'en-US',
  utils: _dateUtils.defaultUtils
};
Calendar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Calendar.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  autoOk: _propTypes2.default.bool,
  cancelLabel: _propTypes2.default.node,
  disableYearSelection: _propTypes2.default.bool,
  firstDayOfWeek: _propTypes2.default.number,
  hideCalendarDate: _propTypes2.default.bool,
  initialDate: _propTypes2.default.object,
  locale: _propTypes2.default.string.isRequired,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  okLabel: _propTypes2.default.node,
  onClickCancel: _propTypes2.default.func,
  onClickDay: _propTypes2.default.func,
  onClickOk: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  openToYearSelection: _propTypes2.default.bool,
  shouldDisableDate: _propTypes2.default.func,
  utils: _propTypes2.default.object
} : {};
exports.default = Calendar;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FlatButton = __webpack_require__(34);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarActionButton = function (_Component) {
  (0, _inherits3.default)(CalendarActionButton, _Component);

  function CalendarActionButton() {
    (0, _classCallCheck3.default)(this, CalendarActionButton);
    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(CalendarActionButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancelLabel = _props.cancelLabel,
          okLabel = _props.okLabel;


      var styles = {
        root: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          margin: 0,
          maxHeight: 48,
          padding: 0
        },
        flatButtons: {
          fontsize: 14,
          margin: '4px 8px 8px 0px',
          maxHeight: 36,
          minWidth: 64,
          padding: 0
        }
      };

      return _react2.default.createElement(
        'div',
        { style: styles.root },
        _react2.default.createElement(_FlatButton2.default, {
          label: cancelLabel,
          onClick: this.props.onClickCancel,
          primary: true,
          style: styles.flatButtons
        }),
        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
          label: okLabel,
          onClick: this.props.onClickOk,
          primary: true,
          style: styles.flatButtons
        })
      );
    }
  }]);
  return CalendarActionButton;
}(_react.Component);

CalendarActionButton.propTypes =  false ? {
  autoOk: _propTypes2.default.bool,
  cancelLabel: _propTypes2.default.node,
  okLabel: _propTypes2.default.node,
  onClickCancel: _propTypes2.default.func,
  onClickOk: _propTypes2.default.func
} : {};
exports.default = CalendarActionButton;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateUtils = __webpack_require__(267);

var _DayButton = __webpack_require__(1810);

var _DayButton2 = _interopRequireDefault(_DayButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    fontWeight: 400,
    height: 228,
    lineHeight: 2,
    position: 'relative',
    textAlign: 'center',
    MozPaddingStart: 0
  },
  week: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    height: 34,
    marginBottom: 2
  }
};

var CalendarMonth = function (_Component) {
  (0, _inherits3.default)(CalendarMonth, _Component);

  function CalendarMonth() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarMonth);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickDay = function (event, date) {
      if (_this.props.onClickDay) {
        _this.props.onClickDay(event, date);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarMonth, [{
    key: 'isSelectedDateDisabled',
    value: function isSelectedDateDisabled() {
      return this.selectedDateDisabled;
    }
  }, {
    key: 'shouldDisableDate',
    value: function shouldDisableDate(day) {
      if (day === null) return false;
      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);

      return disabled;
    }
  }, {
    key: 'getWeekElements',
    value: function getWeekElements() {
      var _this2 = this;

      var weekArray = this.props.utils.getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);

      return weekArray.map(function (week, i) {
        return _react2.default.createElement(
          'div',
          { key: i, style: styles.week },
          _this2.getDayElements(week, i)
        );
      }, this);
    }
  }, {
    key: 'getDayElements',
    value: function getDayElements(week, i) {
      var _this3 = this;

      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          locale = _props.locale,
          selectedDate = _props.selectedDate;


      return week.map(function (day, j) {
        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
        var disabled = _this3.shouldDisableDate(day);
        var selected = !disabled && isSameDate;

        if (isSameDate) {
          _this3.selectedDateDisabled = disabled;
        }

        return _react2.default.createElement(_DayButton2.default, {
          DateTimeFormat: DateTimeFormat,
          locale: locale,
          date: day,
          disabled: disabled,
          key: 'db' + (i + j),
          onClick: _this3.handleClickDay,
          selected: selected
        });
      }, this);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: styles.root },
        this.getWeekElements()
      );
    }
  }]);
  return CalendarMonth;
}(_react.Component);

CalendarMonth.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  autoOk: _propTypes2.default.bool,
  displayDate: _propTypes2.default.object.isRequired,
  firstDayOfWeek: _propTypes2.default.number,
  locale: _propTypes2.default.string.isRequired,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  onClickDay: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object.isRequired,
  shouldDisableDate: _propTypes2.default.func,
  utils: _propTypes2.default.object.isRequired
} : {};
exports.default = CalendarMonth;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _dateUtils = __webpack_require__(267);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var date = props.date,
      disabled = props.disabled,
      selected = props.selected;
  var hover = state.hover;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      datePicker = _context$muiTheme.datePicker;


  var labelColor = baseTheme.palette.textColor;
  var buttonStateOpacity = 0;
  var buttonStateTransform = 'scale(0)';

  if (hover || selected) {
    labelColor = datePicker.selectTextColor;
    buttonStateOpacity = selected ? 1 : 0.6;
    buttonStateTransform = 'scale(1)';
  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
    labelColor = datePicker.color;
  }

  return {
    root: {
      boxSizing: 'border-box',
      fontWeight: '400',
      opacity: disabled && '0.4',
      padding: '4px 0px',
      position: 'relative',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      width: 42
    },
    label: {
      color: labelColor,
      fontWeight: '400',
      position: 'relative'
    },
    buttonState: {
      backgroundColor: datePicker.selectColor,
      borderRadius: '50%',
      height: 34,
      left: 4,
      opacity: buttonStateOpacity,
      position: 'absolute',
      top: 0,
      transform: buttonStateTransform,
      transition: _transitions2.default.easeOut(),
      width: 34
    }
  };
}

var DayButton = function (_Component) {
  (0, _inherits3.default)(DayButton, _Component);

  function DayButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DayButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false
    }, _this.handleMouseEnter = function () {
      if (!_this.props.disabled) {
        _this.setState({ hover: true });
      }
    }, _this.handleMouseLeave = function () {
      if (!_this.props.disabled) {
        _this.setState({ hover: false });
      }
    }, _this.handleClick = function (event) {
      if (!_this.props.disabled && _this.props.onClick) {
        _this.props.onClick(event, _this.props.date);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DayButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          date = _props.date,
          disabled = _props.disabled,
          locale = _props.locale,
          onClick = _props.onClick,
          selected = _props.selected,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onClick', 'selected']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return date ? _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          disableFocusRipple: true,
          disableTouchRipple: true,
          onKeyboardFocus: this.handleKeyboardFocus,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onClick: this.handleClick,
          style: styles.root
        }),
        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          new DateTimeFormat(locale, {
            day: 'numeric'
          }).format(date)
        )
      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
    }
  }]);
  return DayButton;
}(_react.Component);

DayButton.defaultProps = {
  selected: false,
  disabled: false
};
DayButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DayButton.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  date: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  selected: _propTypes2.default.bool
} : {};
exports.default = DayButton;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _YearButton = __webpack_require__(1812);

var _YearButton2 = _interopRequireDefault(_YearButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarYear = function (_Component) {
  (0, _inherits3.default)(CalendarYear, _Component);

  function CalendarYear() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarYear);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickYear = function (event, year) {
      if (_this.props.onClickYear) {
        _this.props.onClickYear(event, year);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarYear, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToSelectedYear();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToSelectedYear();
    }
  }, {
    key: 'getYears',
    value: function getYears() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          locale = _props.locale,
          minDate = _props.minDate,
          maxDate = _props.maxDate,
          selectedDate = _props.selectedDate,
          utils = _props.utils;


      var minYear = utils.getYear(minDate);
      var maxYear = utils.getYear(maxDate);
      var years = [];

      for (var year = minYear; year <= maxYear; year++) {
        var selected = utils.getYear(selectedDate) === year;
        var selectedProps = {};
        if (selected) {
          selectedProps.ref = 'selectedYearButton';
        }

        var yearFormated = new DateTimeFormat(locale, {
          year: 'numeric'
        }).format(utils.setYear(selectedDate, year));

        var yearButton = _react2.default.createElement(
          _YearButton2.default,
          (0, _extends3.default)({
            key: 'yb' + year,
            onClick: this.handleClickYear,
            selected: selected,
            year: year,
            utils: utils
          }, selectedProps),
          yearFormated
        );

        years.push(yearButton);
      }

      return years;
    }
  }, {
    key: 'scrollToSelectedYear',
    value: function scrollToSelectedYear() {
      if (this.refs.selectedYearButton === undefined) {
        return;
      }

      var container = _reactDom2.default.findDOMNode(this);
      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);

      var containerHeight = container.clientHeight;
      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;

      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
      container.scrollTop = scrollYOffset;
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;


      var styles = {
        root: {
          backgroundColor: calendarYearBackgroundColor,
          height: 'inherit',
          lineHeight: '35px',
          overflowX: 'hidden',
          overflowY: 'scroll',
          position: 'relative'
        },
        child: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: '100%'
        }
      };

      return _react2.default.createElement(
        'div',
        { style: prepareStyles(styles.root) },
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.child) },
          this.getYears()
        )
      );
    }
  }]);
  return CalendarYear;
}(_react.Component);

CalendarYear.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CalendarYear.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  locale: _propTypes2.default.string.isRequired,
  maxDate: _propTypes2.default.object.isRequired,
  minDate: _propTypes2.default.object.isRequired,
  onClickYear: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object.isRequired,
  utils: _propTypes2.default.object.isRequired,
  wordings: _propTypes2.default.object
} : {};
exports.default = CalendarYear;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var selected = props.selected,
      year = props.year,
      utils = props.utils;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      datePicker = _context$muiTheme.datePicker;
  var hover = state.hover;


  return {
    root: {
      boxSizing: 'border-box',
      color: year === utils.getYear(new Date()) && datePicker.color,
      display: 'block',
      fontSize: 14,
      margin: '0 auto',
      position: 'relative',
      textAlign: 'center',
      lineHeight: 'inherit',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated)
    },
    label: {
      alignSelf: 'center',
      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
      fontSize: selected ? 26 : 17,
      fontWeight: hover ? 450 : selected ? 500 : 400,
      position: 'relative',
      top: -1
    }
  };
}

var YearButton = function (_Component) {
  (0, _inherits3.default)(YearButton, _Component);

  function YearButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, YearButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false
    }, _this.handleMouseEnter = function () {
      _this.setState({ hover: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hover: false });
    }, _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.props.year);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(YearButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick,
          selected = _props.selected,
          year = _props.year,
          utils = _props.utils,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onClick', 'selected', 'year', 'utils']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disableFocusRipple: true,
          disableTouchRipple: true,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onClick: this.handleClick,
          style: styles.root
        }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          children
        )
      );
    }
  }]);
  return YearButton;
}(_react.Component);

YearButton.defaultProps = {
  selected: false
};
YearButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
YearButton.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  utils: _propTypes2.default.object.isRequired,
  year: _propTypes2.default.number.isRequired
} : {};
exports.default = YearButton;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = __webpack_require__(30);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _chevronLeft = __webpack_require__(103);

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronRight = __webpack_require__(104);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _SlideIn = __webpack_require__(508);

var _SlideIn2 = _interopRequireDefault(_SlideIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'inherit',
    height: 48
  },
  titleDiv: {
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
    width: '100%'
  },
  titleText: {
    height: 'inherit',
    paddingTop: 12
  }
};

var CalendarToolbar = function (_Component) {
  (0, _inherits3.default)(CalendarToolbar, _Component);

  function CalendarToolbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarToolbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      transitionDirection: 'up'
    }, _this.handleClickPrevMonth = function () {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(-1);
      }
    }, _this.handleClickNextMonth = function () {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(1);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarToolbar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.displayDate !== this.props.displayDate) {
        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
        var direction = nextProps.displayDate > this.props.displayDate ? nextDirection : prevDirection;
        this.setState({
          transitionDirection: direction
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          locale = _props.locale,
          displayDate = _props.displayDate;


      var dateTimeFormatted = new DateTimeFormat(locale, {
        month: 'long',
        year: 'numeric'
      }).format(displayDate);

      var nextButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronLeft2.default, null) : _react2.default.createElement(_chevronRight2.default, null);
      var prevButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronRight2.default, null) : _react2.default.createElement(_chevronLeft2.default, null);

      return _react2.default.createElement(
        'div',
        { style: styles.root },
        _react2.default.createElement(
          _IconButton2.default,
          {
            disabled: !this.props.prevMonth,
            onClick: this.handleClickPrevMonth
          },
          prevButtonIcon
        ),
        _react2.default.createElement(
          _SlideIn2.default,
          {
            direction: this.state.transitionDirection,
            style: styles.titleDiv
          },
          _react2.default.createElement(
            'div',
            { key: dateTimeFormatted, style: styles.titleText },
            dateTimeFormatted
          )
        ),
        _react2.default.createElement(
          _IconButton2.default,
          {
            disabled: !this.props.nextMonth,
            onClick: this.handleClickNextMonth
          },
          nextButtonIcon
        )
      );
    }
  }]);
  return CalendarToolbar;
}(_react.Component);

CalendarToolbar.defaultProps = {
  nextMonth: true,
  prevMonth: true
};
CalendarToolbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CalendarToolbar.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  displayDate: _propTypes2.default.object.isRequired,
  locale: _propTypes2.default.string.isRequired,
  nextMonth: _propTypes2.default.bool,
  onMonthChange: _propTypes2.default.func,
  prevMonth: _propTypes2.default.bool
} : {};
exports.default = CalendarToolbar;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(195);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideInChild = function (_Component) {
  (0, _inherits3.default)(SlideInChild, _Component);

  function SlideInChild() {
    (0, _classCallCheck3.default)(this, SlideInChild);
    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(SlideInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      var direction = this.props.getLeaveDirection();
      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          getLeaveDirection = _props.getLeaveDirection,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);
  return SlideInChild;
}(_react.Component);

SlideInChild.defaultProps = {
  enterDelay: 0
};
SlideInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SlideInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  direction: _propTypes2.default.string,
  enterDelay: _propTypes2.default.number,
  // This callback is needed bacause the direction could change when leaving the DOM
  getLeaveDirection: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object
} : {};
exports.default = SlideInChild;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _SlideIn = __webpack_require__(508);

var _SlideIn2 = _interopRequireDefault(_SlideIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var datePicker = context.muiTheme.datePicker;
  var selectedYear = state.selectedYear;

  var isLandscape = props.mode === 'landscape';

  var styles = {
    root: {
      width: isLandscape ? 165 : '100%',
      height: isLandscape ? 330 : 'auto',
      float: isLandscape ? 'left' : 'none',
      fontWeight: 700,
      display: 'inline-block',
      backgroundColor: datePicker.headerColor,
      borderTopLeftRadius: 2,
      borderTopRightRadius: isLandscape ? 0 : 2,
      borderBottomLeftRadius: isLandscape ? 2 : 0,
      color: datePicker.textColor,
      padding: 20,
      boxSizing: 'border-box'
    },
    monthDay: {
      display: 'block',
      fontSize: 36,
      lineHeight: '36px',
      height: props.mode === 'landscape' ? '100%' : 38,
      opacity: selectedYear ? 0.7 : 1,
      transition: _transitions2.default.easeOut(),
      width: '100%',
      fontWeight: '500'
    },
    monthDayTitle: {
      cursor: !selectedYear ? 'default' : 'pointer',
      width: '100%',
      display: 'block'
    },
    year: {
      margin: 0,
      fontSize: 16,
      fontWeight: '500',
      lineHeight: '16px',
      height: 16,
      opacity: selectedYear ? 1 : 0.7,
      transition: _transitions2.default.easeOut(),
      marginBottom: 10
    },
    yearTitle: {
      cursor: props.disableYearSelection || selectedYear ? 'default' : 'pointer'
    }
  };

  return styles;
}

var DateDisplay = function (_Component) {
  (0, _inherits3.default)(DateDisplay, _Component);

  function DateDisplay() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DateDisplay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedYear: false,
      transitionDirection: 'up'
    }, _this.handleClickMonthDay = function () {
      if (_this.props.onClickMonthDay && _this.state.selectedYear) {
        _this.props.onClickMonthDay();
      }

      _this.setState({ selectedYear: false });
    }, _this.handleClickYear = function () {
      if (_this.props.onClickYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
        _this.props.onClickYear();
      }

      if (!_this.props.disableYearSelection) {
        _this.setState({ selectedYear: true });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DateDisplay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.monthDaySelected) {
        this.setState({ selectedYear: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedDate !== this.props.selectedDate) {
        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
        this.setState({
          transitionDirection: direction
        });
      }

      if (nextProps.monthDaySelected !== undefined) {
        this.setState({
          selectedYear: !nextProps.monthDaySelected
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          DateTimeFormat = _props.DateTimeFormat,
          disableYearSelection = _props.disableYearSelection,
          locale = _props.locale,
          mode = _props.mode,
          monthDaySelected = _props.monthDaySelected,
          onClickMonthDay = _props.onClickMonthDay,
          onClickYear = _props.onClickYear,
          selectedDate = _props.selectedDate,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onClickMonthDay', 'onClickYear', 'selectedDate', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var year = new DateTimeFormat(locale, {
        year: 'numeric'
      }).format(selectedDate);

      var dateTime = new DateTimeFormat(locale, {
        month: 'short',
        weekday: 'short',
        day: '2-digit'
      }).format(selectedDate);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
        _react2.default.createElement(
          _SlideIn2.default,
          { style: styles.year, direction: this.state.transitionDirection },
          _react2.default.createElement(
            'div',
            { key: year, style: styles.yearTitle, onClick: this.handleClickYear },
            year
          )
        ),
        _react2.default.createElement(
          _SlideIn2.default,
          { style: styles.monthDay, direction: this.state.transitionDirection },
          _react2.default.createElement(
            'div',
            {
              key: dateTime,
              onClick: this.handleClickMonthDay,
              style: styles.monthDayTitle
            },
            dateTime
          )
        )
      );
    }
  }]);
  return DateDisplay;
}(_react.Component);

DateDisplay.defaultProps = {
  disableYearSelection: false,
  monthDaySelected: true
};
DateDisplay.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DateDisplay.propTypes =  false ? {
  DateTimeFormat: _propTypes2.default.func.isRequired,
  disableYearSelection: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
  monthDaySelected: _propTypes2.default.bool,
  onClickMonthDay: _propTypes2.default.func,
  onClickYear: _propTypes2.default.func,
  selectedDate: _propTypes2.default.object.isRequired,
  style: _propTypes2.default.object
} : {};
exports.default = DateDisplay;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _Overlay = __webpack_require__(747);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _RenderToLayer = __webpack_require__(745);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _TransitionGroup = __webpack_require__(266);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransitionItem = function (_Component) {
  (0, _inherits3.default)(TransitionItem, _Component);

  function TransitionItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TransitionItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      style: {}
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TransitionItem, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimeout);
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.componentWillAppear(callback);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      var spacing = this.context.muiTheme.baseTheme.spacing;

      this.setState({
        style: {
          opacity: 1,
          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
        }
      });

      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      this.setState({
        style: {
          opacity: 0,
          transform: 'translate(0, 0)'
        }
      });

      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          children = _props.children,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
        children
      );
    }
  }]);
  return TransitionItem;
}(_react.Component);

TransitionItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TransitionItem.propTypes =  false ? {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};


function getStyles(props, context) {
  var autoScrollBodyContent = props.autoScrollBodyContent,
      open = props.open;
  var _context$muiTheme = context.muiTheme,
      _context$muiTheme$bas = _context$muiTheme.baseTheme,
      spacing = _context$muiTheme$bas.spacing,
      palette = _context$muiTheme$bas.palette,
      dialog = _context$muiTheme.dialog,
      zIndex = _context$muiTheme.zIndex;


  var gutter = spacing.desktopGutter;
  var borderScroll = '1px solid ' + palette.borderColor;

  return {
    root: {
      position: 'fixed',
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      zIndex: zIndex.dialog,
      top: 0,
      left: open ? 0 : -10000,
      width: '100%',
      height: '100%',
      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
    },
    content: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      transition: _transitions2.default.easeOut(),
      position: 'relative',
      width: '75%',
      maxWidth: spacing.desktopKeylineIncrement * 12,
      margin: '0 auto',
      zIndex: zIndex.dialog
    },
    actionsContainer: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      padding: 8,
      width: '100%',
      textAlign: 'right',
      marginTop: autoScrollBodyContent ? -1 : 0
    },
    overlay: {
      zIndex: zIndex.dialogOverlay
    },
    title: {
      margin: 0,
      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
      color: palette.textColor,
      fontSize: dialog.titleFontSize,
      lineHeight: '32px',
      fontWeight: 400,
      marginBottom: autoScrollBodyContent ? -1 : 0
    },
    body: {
      fontSize: dialog.bodyFontSize,
      color: dialog.bodyColor,
      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
      boxSizing: 'border-box',
      overflowY: autoScrollBodyContent ? 'auto' : 'hidden',
      borderTop: autoScrollBodyContent ? borderScroll : 'none',
      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
    }
  };
}

var DialogInline = function (_Component2) {
  (0, _inherits3.default)(DialogInline, _Component2);

  function DialogInline() {
    var _ref2;

    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, DialogInline);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleClickOverlay = function () {
      _this2.requestClose(false);
    }, _this2.handleKeyUp = function (event) {
      if ((0, _keycode2.default)(event) === 'esc') {
        _this2.requestClose(false);
      }
    }, _this2.handleResize = function () {
      _this2.positionDialog();
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  (0, _createClass3.default)(DialogInline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.positionDialog();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.positionDialog();
    }
  }, {
    key: 'positionDialog',
    value: function positionDialog() {
      var _props2 = this.props,
          actions = _props2.actions,
          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
          autoScrollBodyContent = _props2.autoScrollBodyContent,
          bodyStyle = _props2.bodyStyle,
          open = _props2.open,
          repositionOnUpdate = _props2.repositionOnUpdate,
          title = _props2.title;


      if (!open) {
        return;
      }

      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var container = _reactDom2.default.findDOMNode(this);
      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
      var minPaddingTop = 16;

      // Reset the height in case the window was resized.
      dialogWindow.style.height = '';
      dialogContent.style.height = '';

      var dialogWindowHeight = dialogWindow.offsetHeight;
      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;

      // Vertically center the dialog window, but make sure it doesn't
      // transition to that position.
      if (repositionOnUpdate || !container.style.paddingTop) {
        container.style.paddingTop = paddingTop + 'px';
      }

      // Force a height if the dialog is taller than clientHeight
      if (autoDetectWindowHeight || autoScrollBodyContent) {
        var styles = getStyles(this.props, this.context);
        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
        var maxDialogContentHeight = clientHeight - 2 * 64;

        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;

        if (_react2.default.Children.count(actions)) {
          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
        }

        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
        if (maxDialogContentHeight > dialogWindowHeight) {
          dialogContent.style.borderBottom = 'none';
          dialogContent.style.borderTop = 'none';
        }
      }
    }
  }, {
    key: 'requestClose',
    value: function requestClose(buttonClicked) {
      if (!buttonClicked && this.props.modal) {
        return;
      }

      if (this.props.onRequestClose) {
        this.props.onRequestClose(!!buttonClicked);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          actions = _props3.actions,
          actionsContainerClassName = _props3.actionsContainerClassName,
          actionsContainerStyle = _props3.actionsContainerStyle,
          bodyClassName = _props3.bodyClassName,
          bodyStyle = _props3.bodyStyle,
          children = _props3.children,
          className = _props3.className,
          contentClassName = _props3.contentClassName,
          contentStyle = _props3.contentStyle,
          overlayClassName = _props3.overlayClassName,
          overlayStyle = _props3.overlayStyle,
          open = _props3.open,
          paperClassName = _props3.paperClassName,
          paperProps = _props3.paperProps,
          style = _props3.style,
          titleClassName = _props3.titleClassName,
          titleStyle = _props3.titleStyle,
          title = _props3.title;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      styles.root = (0, _simpleAssign2.default)(styles.root, style);
      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);

      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
        'div',
        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
        _react2.default.Children.toArray(actions)
      );

      var titleElement = title;
      if (_react2.default.isValidElement(title)) {
        titleElement = _react2.default.cloneElement(title, {
          className: title.props.className || titleClassName,
          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
        });
      } else if (typeof title === 'string') {
        titleElement = _react2.default.createElement(
          'h3',
          { className: titleClassName, style: prepareStyles(styles.title) },
          title
        );
      }

      return _react2.default.createElement(
        'div',
        { className: className, style: prepareStyles(styles.root) },
        open && _react2.default.createElement(_reactEventListener2.default, {
          target: 'window',
          onKeyUp: this.handleKeyUp,
          onResize: this.handleResize
        }),
        _react2.default.createElement(
          _TransitionGroup2.default,
          {
            component: 'div',
            ref: 'dialogWindow',
            transitionAppear: true,
            transitionAppearTimeout: 450,
            transitionEnter: true,
            transitionEnterTimeout: 450
          },
          open && _react2.default.createElement(
            TransitionItem,
            {
              className: contentClassName,
              style: styles.content
            },
            _react2.default.createElement(
              _Paper2.default,
              (0, _extends3.default)({ className: paperClassName, zDepth: 4 }, paperProps),
              titleElement,
              _react2.default.createElement(
                'div',
                {
                  ref: 'dialogContent',
                  className: bodyClassName,
                  style: prepareStyles(styles.body)
                },
                children
              ),
              actionsContainer
            )
          )
        ),
        _react2.default.createElement(_Overlay2.default, {
          show: open,
          className: overlayClassName,
          style: styles.overlay,
          onClick: this.handleClickOverlay
        })
      );
    }
  }]);
  return DialogInline;
}(_react.Component);

DialogInline.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DialogInline.propTypes =  false ? {
  actions: _propTypes2.default.node,
  actionsContainerClassName: _propTypes2.default.string,
  actionsContainerStyle: _propTypes2.default.object,
  autoDetectWindowHeight: _propTypes2.default.bool,
  autoScrollBodyContent: _propTypes2.default.bool,
  bodyClassName: _propTypes2.default.string,
  bodyStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  contentStyle: _propTypes2.default.object,
  modal: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  overlayClassName: _propTypes2.default.string,
  overlayStyle: _propTypes2.default.object,
  paperClassName: _propTypes2.default.string,
  paperProps: _propTypes2.default.object,
  repositionOnUpdate: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  title: _propTypes2.default.node,
  titleClassName: _propTypes2.default.string,
  titleStyle: _propTypes2.default.object
} : {};

var Dialog = function (_Component3) {
  (0, _inherits3.default)(Dialog, _Component3);

  function Dialog() {
    var _ref3;

    var _temp3, _this3, _ret3;

    (0, _classCallCheck3.default)(this, Dialog);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
      return _react2.default.createElement(DialogInline, _this3.props);
    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
  }

  (0, _createClass3.default)(Dialog, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
    }
  }]);
  return Dialog;
}(_react.Component);

Dialog.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Dialog.defaultProps = {
  autoDetectWindowHeight: true,
  autoScrollBodyContent: false,
  modal: false,
  repositionOnUpdate: true
};
Dialog.propTypes =  false ? {
  /**
   * Action buttons to display below the Dialog content (`children`).
   * This property accepts either a React element, or an array of React elements.
   */
  actions: _propTypes2.default.node,
  /**
   * The `className` to add to the actions container's root element.
   */
  actionsContainerClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the actions container's root element.
   */
  actionsContainerStyle: _propTypes2.default.object,
  /**
   * If set to true, the height of the `Dialog` will be auto detected. A max height
   * will be enforced so that the content does not extend beyond the viewport.
   */
  autoDetectWindowHeight: _propTypes2.default.bool,
  /**
   * If set to true, the body content of the `Dialog` will be scrollable.
   */
  autoScrollBodyContent: _propTypes2.default.bool,
  /**
   * The `className` to add to the content's root element under the title.
   */
  bodyClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the content's root element under the title.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * The contents of the `Dialog`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The `className` to add to the content container.
   */
  contentClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the content container.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * Force the user to use one of the actions in the `Dialog`.
   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
   */
  modal: _propTypes2.default.bool,
  /**
   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
   *
   * @param {bool} buttonClicked Determines whether a button click triggered this request.
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * Controls whether the Dialog is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
   */
  overlayClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * The CSS class name of the `Paper` element.
   */
  paperClassName: _propTypes2.default.string,
  /**
   * Properties applied to the `Paper` element.
   */
  paperProps: _propTypes2.default.object,
  /**
   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
   */
  repositionOnUpdate: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
   */
  title: _propTypes2.default.node,
  /**
   * The `className` to add to the title's root container element.
   */
  titleClassName: _propTypes2.default.string,
  /**
   * Overrides the inline-styles of the title's root container element.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = Dialog;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _arrowDropDown = __webpack_require__(773);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _Menu = __webpack_require__(352);

var _Menu2 = _interopRequireDefault(_Menu);

var _ClearFix = __webpack_require__(1818);

var _ClearFix2 = _interopRequireDefault(_ClearFix);

var _Popover = __webpack_require__(226);

var _Popover2 = _interopRequireDefault(_Popover);

var _PopoverAnimationVertical = __webpack_require__(494);

var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _events = __webpack_require__(344);

var _events2 = _interopRequireDefault(_events);

var _IconButton = __webpack_require__(30);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var disabled = props.disabled;

  var spacing = context.muiTheme.baseTheme.spacing;
  var palette = context.muiTheme.baseTheme.palette;
  var accentColor = context.muiTheme.dropDownMenu.accentColor;
  return {
    control: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      height: '100%',
      position: 'relative',
      width: '100%'
    },
    icon: {
      fill: accentColor,
      position: 'absolute',
      right: spacing.desktopGutterLess,
      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
    },
    iconChildren: {
      fill: 'inherit'
    },
    label: {
      color: disabled ? palette.disabledColor : palette.textColor,
      height: spacing.desktopToolbarHeight + 'px',
      lineHeight: spacing.desktopToolbarHeight + 'px',
      overflow: 'hidden',
      opacity: 1,
      position: 'relative',
      paddingLeft: spacing.desktopGutter,
      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
      textOverflow: 'ellipsis',
      top: 0,
      whiteSpace: 'nowrap'
    },
    labelWhenOpen: {
      opacity: 0,
      top: spacing.desktopToolbarHeight / 8
    },
    root: {
      display: 'inline-block',
      fontSize: spacing.desktopDropDownMenuFontSize,
      height: spacing.desktopSubheaderHeight,
      fontFamily: context.muiTheme.baseTheme.fontFamily,
      outline: 'none',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },
    rootWhenOpen: {
      opacity: 1
    },
    underline: {
      borderTop: 'solid 1px ' + accentColor,
      bottom: 1,
      left: 0,
      margin: '-1px ' + spacing.desktopGutter + 'px',
      right: 0,
      position: 'absolute'
    }
  };
}

var DropDownMenu = function (_Component) {
  (0, _inherits3.default)(DropDownMenu, _Component);

  function DropDownMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DropDownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleClickControl = function (event) {
      event.preventDefault();
      if (!_this.props.disabled) {
        _this.setState({
          open: !_this.state.open,
          anchorEl: _this.rootNode
        });
      }
    }, _this.handleRequestCloseMenu = function () {
      _this.close(false);
    }, _this.handleEscKeyDownMenu = function () {
      _this.close(true);
    }, _this.handleKeyDown = function (event) {
      switch ((0, _keycode2.default)(event)) {
        case 'up':
        case 'down':
        case 'space':
        case 'enter':
          event.preventDefault();
          _this.setState({
            open: true,
            anchorEl: _this.rootNode
          });
          break;
      }
    }, _this.handleItemClick = function (event, child, index) {
      if (_this.props.multiple) {
        if (!_this.state.open) {
          _this.setState({ open: true });
        }
      } else {
        event.persist();
        _this.setState({
          open: false
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(event, index, child.props.value);
          }

          _this.close(_events2.default.isKeyboard(event));
        });
      }
    }, _this.handleChange = function (event, value) {
      if (_this.props.multiple && _this.props.onChange) {
        _this.props.onChange(event, undefined, value);
      }
    }, _this.close = function (isKeyboard) {
      _this.setState({
        open: false
      }, function () {
        if (_this.props.onClose) {
          _this.props.onClose();
        }

        if (isKeyboard) {
          var dropArrow = _this.arrowNode;
          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
          dropNode.focus();
          dropArrow.setKeyboardFocus(true);
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // The nested styles for drop-down-menu are modified by toolbar and possibly
  // other user components, so it will give full access to its js styles rather
  // than just the parent.


  (0, _createClass3.default)(DropDownMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoWidth) {
        this.setWidth();
      }
      if (this.props.openImmediately) {
        // TODO: Temporary fix to make openImmediately work with popover.
        /* eslint-disable react/no-did-mount-set-state */
        setTimeout(function () {
          return _this2.setState({
            open: true,
            anchorEl: _this2.rootNode
          });
        }, 0);
        /* eslint-enable react/no-did-mount-set-state */
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
    }
  }, {
    key: 'getInputNode',


    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    value: function getInputNode() {
      var _this3 = this;

      var rootNode = this.rootNode;

      rootNode.focus = function () {
        if (!_this3.props.disabled) {
          _this3.setState({
            open: !_this3.state.open,
            anchorEl: _this3.rootNode
          });
        }
      };

      return rootNode;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = this.rootNode;
      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
        el.style.width = 'auto';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          animated = _props.animated,
          animation = _props.animation,
          autoWidth = _props.autoWidth,
          multiple = _props.multiple,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          iconStyle = _props.iconStyle,
          labelStyle = _props.labelStyle,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          menuStyleProp = _props.menuStyle,
          selectionRenderer = _props.selectionRenderer,
          onClose = _props.onClose,
          openImmediately = _props.openImmediately,
          menuItemStyle = _props.menuItemStyle,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          style = _props.style,
          underlineStyle = _props.underlineStyle,
          value = _props.value,
          iconButton = _props.iconButton,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
      var _state = this.state,
          anchorEl = _state.anchorEl,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var displayValue = '';
      if (!multiple) {
        _react2.default.Children.forEach(children, function (child) {
          if (child && value === child.props.value) {
            if (selectionRenderer) {
              displayValue = selectionRenderer(value, child);
            } else {
              // This will need to be improved (in case primaryText is a node)
              displayValue = child.props.label || child.props.primaryText;
            }
          }
        });
      } else {
        var values = [];
        var selectionRendererChildren = [];
        _react2.default.Children.forEach(children, function (child) {
          if (child && value && value.indexOf(child.props.value) > -1) {
            if (selectionRenderer) {
              values.push(child.props.value);
              selectionRendererChildren.push(child);
            } else {
              values.push(child.props.label || child.props.primaryText);
            }
          }
        });

        displayValue = [];
        if (selectionRenderer) {
          displayValue = selectionRenderer(values, selectionRendererChildren);
        } else {
          displayValue = values.join(', ');
        }
      }

      var menuStyle = void 0;
      if (anchorEl && !autoWidth) {
        menuStyle = (0, _simpleAssign2.default)({
          width: anchorEl.clientWidth
        }, menuStyleProp);
      } else {
        menuStyle = menuStyleProp;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: function ref(node) {
            _this4.rootNode = node;
          },
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
        }),
        _react2.default.createElement(
          _ClearFix2.default,
          { style: styles.control, onClick: this.handleClickControl },
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
            displayValue
          ),
          _react2.default.createElement(
            _IconButton2.default,
            {
              disabled: disabled,
              onKeyDown: this.handleKeyDown,
              ref: function ref(node) {
                _this4.arrowNode = node;
              },
              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
              iconStyle: styles.iconChildren
            },
            iconButton
          ),
          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
        ),
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            anchorEl: anchorEl,
            animation: animation || _PopoverAnimationVertical2.default,
            open: open,
            animated: animated,
            onRequestClose: this.handleRequestCloseMenu
          },
          _react2.default.createElement(
            _Menu2.default,
            {
              multiple: multiple,
              maxHeight: maxHeight,
              desktop: true,
              value: value,
              onEscKeyDown: this.handleEscKeyDownMenu,
              style: menuStyle,
              listStyle: listStyle,
              onItemClick: this.handleItemClick,
              onChange: this.handleChange,
              menuItemStyle: menuItemStyle,
              selectedMenuItemStyle: selectedMenuItemStyle,
              autoWidth: autoWidth,
              width: !autoWidth && menuStyle ? menuStyle.width : null
            },
            children
          )
        )
      );
    }
  }]);
  return DropDownMenu;
}(_react.Component);

DropDownMenu.muiName = 'DropDownMenu';
DropDownMenu.defaultProps = {
  animated: true,
  autoWidth: true,
  disabled: false,
  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
  openImmediately: false,
  maxHeight: 500,
  multiple: false,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
DropDownMenu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DropDownMenu.propTypes =  false ? {
  /**
   * This is the point on the anchor that the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * The width will automatically be set according to the items inside the menu.
   * To control this width in css instead, set this prop to `false`.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
   * prop `label` that value will be used to render the representation of that
   * item within the field.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the menu.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides default `SvgIcon` dropdown arrow component.
   */
  iconButton: _propTypes2.default.node,
  /**
   * Overrides the styles of icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of label when the `DropDownMenu` is inactive.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * The style object to use to override underlying list style.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the `Menu` when it is displayed.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {object} event Click event targeting the menu item that was clicked.
   * @param {number} key The index of the clicked menu item in the `children` collection.
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is closed.
   */
  onClose: _propTypes2.default.func,
  /**
   * Set to true to have the `DropDownMenu` automatically open on mount.
   */
  openImmediately: _propTypes2.default.bool,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   * @param {any} menuItem The selected `MenuItem`.
   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
   */
  selectionRenderer: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * Overrides the inline-styles of the underline.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   */
  value: _propTypes2.default.any
} : {};
exports.default = DropDownMenu;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BeforeAfterWrapper = __webpack_require__(1819);

var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  before: {
    content: "' '",
    display: 'table'
  },
  after: {
    content: "' '",
    clear: 'both',
    display: 'table'
  }
};

var ClearFix = function ClearFix(_ref) {
  var style = _ref.style,
      children = _ref.children,
      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
  return _react2.default.createElement(
    _BeforeAfterWrapper2.default,
    (0, _extends3.default)({}, other, {
      beforeStyle: styles.before,
      afterStyle: styles.after,
      style: style
    }),
    children
  );
};

ClearFix.muiName = 'ClearFix';

ClearFix.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = ClearFix;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  BeforeAfterWrapper
 *    An alternative for the ::before and ::after css pseudo-elements for
 *    components whose styles are defined in javascript instead of css.
 *
 *  Usage: For the element that we want to apply before and after elements to,
 *    wrap its children with BeforeAfterWrapper. For example:
 *
 *                                            <Paper>
 *  <Paper>                                     <div> // See notice
 *    <BeforeAfterWrapper>        renders         <div/> // before element
 *      [children of paper]       ------>         [children of paper]
 *    </BeforeAfterWrapper>                       <div/> // after element
 *  </Paper>                                    </div>
 *                                            </Paper>
 *
 *  Notice: Notice that this div bundles together our elements. If the element
 *    that we want to apply before and after elements is a HTML tag (i.e. a
 *    div, p, or button tag), we can avoid this extra nesting by passing using
 *    the BeforeAfterWrapper in place of said tag like so:
 *
 *  <p>
 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
 *      [children of p]          ------>         [children of p]
 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
 *  </p>
 *
 *  BeforeAfterWrapper features spread functionality. This means that we can
 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
 *
 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
 *  and afterElement have a defined style position.
 */

var styles = {
  box: {
    boxSizing: 'border-box'
  }
};

var BeforeAfterWrapper = function (_Component) {
  (0, _inherits3.default)(BeforeAfterWrapper, _Component);

  function BeforeAfterWrapper() {
    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(BeforeAfterWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          beforeStyle = _props.beforeStyle,
          afterStyle = _props.afterStyle,
          beforeElementType = _props.beforeElementType,
          afterElementType = _props.afterElementType,
          elementType = _props.elementType,
          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var beforeElement = void 0;
      var afterElement = void 0;

      if (beforeStyle) {
        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
          key: '::before'
        });
      }

      if (afterStyle) {
        afterElement = _react2.default.createElement(this.props.afterElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
          key: '::after'
        });
      }

      var children = [beforeElement, this.props.children, afterElement];

      var props = other;
      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));

      return _react2.default.createElement(this.props.elementType, props, children);
    }
  }]);
  return BeforeAfterWrapper;
}(_react.Component);

BeforeAfterWrapper.defaultProps = {
  beforeElementType: 'div',
  afterElementType: 'div',
  elementType: 'div'
};
BeforeAfterWrapper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
BeforeAfterWrapper.propTypes =  false ? {
  afterElementType: _propTypes2.default.string,
  afterStyle: _propTypes2.default.object,
  beforeElementType: _propTypes2.default.string,
  beforeStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  elementType: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = BeforeAfterWrapper;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FloatingActionButton = __webpack_require__(1821);

var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FloatingActionButton2.default;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(155);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FontIcon = __webpack_require__(346);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _childUtils = __webpack_require__(741);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var floatingActionButton = context.muiTheme.floatingActionButton;


  var backgroundColor = props.backgroundColor || floatingActionButton.color;
  var iconColor = floatingActionButton.iconColor;

  if (props.disabled) {
    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
    iconColor = floatingActionButton.disabledTextColor;
  } else if (props.secondary) {
    backgroundColor = floatingActionButton.secondaryColor;
    iconColor = floatingActionButton.secondaryIconColor;
  }

  return {
    root: {
      transition: _transitions2.default.easeOut(),
      display: 'inline-block',
      backgroundColor: 'transparent'
    },
    container: {
      backgroundColor: backgroundColor,
      transition: _transitions2.default.easeOut(),
      height: floatingActionButton.buttonSize,
      width: floatingActionButton.buttonSize,
      padding: 0,
      overflow: 'hidden',
      borderRadius: '50%',
      textAlign: 'center',
      verticalAlign: 'bottom'
    },
    containerWhenMini: {
      height: floatingActionButton.miniSize,
      width: floatingActionButton.miniSize
    },
    overlay: {
      transition: _transitions2.default.easeOut(),
      top: 0
    },
    overlayWhenHovered: {
      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
    },
    icon: {
      height: floatingActionButton.buttonSize,
      lineHeight: floatingActionButton.buttonSize + 'px',
      fill: iconColor,
      color: iconColor
    },
    iconWhenMini: {
      height: floatingActionButton.miniSize,
      lineHeight: floatingActionButton.miniSize + 'px'
    }
  };
}

var FloatingActionButton = function (_Component) {
  (0, _inherits3.default)(FloatingActionButton, _Component);

  function FloatingActionButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FloatingActionButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      touch: false,
      zDepth: undefined
    }, _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.setState({ zDepth: _this.props.zDepth + 1 });
      }
      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
    }, _this.handleMouseUp = function (event) {
      _this.setState({ zDepth: _this.props.zDepth });
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.refs.container.isKeyboardFocused()) {
        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({
        touch: true,
        zDepth: _this.props.zDepth + 1
      });
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleTouchEnd = function (event) {
      _this.setState({
        touch: true,
        zDepth: _this.props.zDepth
      });
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
      if (keyboardFocused && !_this.props.disabled) {
        _this.setState({ zDepth: _this.props.zDepth + 1 });
        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
      } else if (!_this.state.hovered) {
        _this.setState({ zDepth: _this.props.zDepth });
        _this.refs.overlay.style.backgroundColor = 'transparent';
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FloatingActionButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        zDepth: this.props.disabled ? 0 : this.props.zDepth
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextState = {};

      if (nextProps.disabled !== this.props.disabled) {
        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
      }
      if (nextProps.disabled) {
        nextState.hovered = false;
      }

      this.setState(nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          className = _props.className,
          childrenProp = _props.children,
          disabled = _props.disabled,
          disabledColor = _props.disabledColor,
          mini = _props.mini,
          secondary = _props.secondary,
          iconStyle = _props.iconStyle,
          iconClassName = _props.iconClassName,
          zDepth = _props.zDepth,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'disabledColor', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var iconElement = void 0;
      if (iconClassName) {
        iconElement = _react2.default.createElement(_FontIcon2.default, {
          className: iconClassName,
          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
        });
      }

      var children = void 0;

      if (childrenProp) {
        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
          return {
            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
          };
        });
      }

      var buttonEventHandlers = disabled ? null : {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd,
        onKeyboardFocus: this.handleKeyboardFocus
      };

      return _react2.default.createElement(
        _Paper2.default,
        {
          className: className,
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          zDepth: this.state.zDepth,
          circle: true
        },
        _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({}, other, buttonEventHandlers, {
            ref: 'container',
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
            focusRippleColor: styles.icon.color,
            touchRippleColor: styles.icon.color
          }),
          _react2.default.createElement(
            'div',
            {
              ref: 'overlay',
              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
            },
            iconElement,
            children
          )
        )
      );
    }
  }]);
  return FloatingActionButton;
}(_react.Component);

FloatingActionButton.defaultProps = {
  disabled: false,
  mini: false,
  secondary: false,
  zDepth: 2
};
FloatingActionButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FloatingActionButton.propTypes =  false ? {
  /**
   * This value will override the default background color for the button.
   * However it will not override the default disabled background color.
   * This has to be set separately using the disabledColor attribute.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * This is what displayed inside the floating action button; for example, a SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the button if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * This value will override the default background color for the button when it is disabled.
   */
  disabledColor: _propTypes2.default.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * The icon within the FloatingActionButton is a FontIcon component.
   * This property is the classname of the icon to be displayed inside the button.
   * An alternative to adding an iconClassName would be to manually insert a
   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
   */
  iconClassName: _propTypes2.default.string,
  /**
   * This is the equivalent to iconClassName except that it is used for
   * overriding the inline-styles of the FontIcon component.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * If true, the button will be a small floating action button.
   */
  mini: _propTypes2.default.bool,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * If true, the button will use the secondary button colors.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The zDepth of the underlying `Paper` component.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = FloatingActionButton;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GridTile = exports.GridList = undefined;

var _GridList2 = __webpack_require__(1823);

var _GridList3 = _interopRequireDefault(_GridList2);

var _GridTile2 = __webpack_require__(774);

var _GridTile3 = _interopRequireDefault(_GridTile2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GridList = _GridList3.default;
exports.GridTile = _GridTile3.default;
exports.default = _GridList3.default;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: -props.padding / 2
    },
    item: {
      boxSizing: 'border-box',
      padding: props.padding / 2
    }
  };
}

var GridList = function (_Component) {
  (0, _inherits3.default)(GridList, _Component);

  function GridList() {
    (0, _classCallCheck3.default)(this, GridList);
    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
  }

  (0, _createClass3.default)(GridList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cols = _props.cols,
          padding = _props.padding,
          cellHeight = _props.cellHeight,
          children = _props.children,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);

      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
          return currentChild;
        }
        var childCols = currentChild.props.cols || 1;
        var childRows = currentChild.props.rows || 1;
        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
          width: 100 / cols * childCols + '%',
          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
        });

        return _react2.default.createElement(
          'div',
          { style: prepareStyles(itemStyle) },
          currentChild
        );
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
        wrappedChildren
      );
    }
  }]);
  return GridList;
}(_react.Component);

GridList.defaultProps = {
  cols: 2,
  padding: 4,
  cellHeight: 180
};
GridList.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
GridList.propTypes =  false ? {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
  /**
   * Grid Tiles that will be in Grid List.
   */
  children: _propTypes2.default.node,
  /**
   * Number of columns.
   */
  cols: _propTypes2.default.number,
  /**
   * Number of px for the padding/spacing between items.
   */
  padding: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = GridList;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(344);

var _events2 = _interopRequireDefault(_events);

var _propTypes3 = __webpack_require__(90);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Menu = __webpack_require__(352);

var _Menu2 = _interopRequireDefault(_Menu);

var _Popover = __webpack_require__(226);

var _Popover2 = _interopRequireDefault(_Popover);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconMenu = function (_Component) {
  (0, _inherits3.default)(IconMenu, _Component);

  function IconMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      menuInitiallyKeyboardFocused: false,
      open: false
    }, _this.handleItemClick = function (event, child) {
      if (_this.props.clickCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
        var isKeyboard = _events2.default.isKeyboard(event);
        _this.timerCloseId = setTimeout(function () {
          _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
        }, _this.props.clickCloseDelay);
      }

      _this.props.onItemClick(event, child);
    }, _this.handleRequestClose = function (reason) {
      _this.close(reason);
    }, _this.handleEscKeyDownMenu = function (event) {
      _this.close('escape', event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open != null) {
        this.setState({
          open: nextProps.open,
          anchorEl: this.refs.iconMenuContainer
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerCloseId);
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return this.state.open;
    }
  }, {
    key: 'close',
    value: function close(reason, isKeyboard) {
      var _this2 = this;

      if (!this.state.open) {
        return;
      }

      if (this.props.open !== null) {
        this.props.onRequestChange(false, reason);
      } else {
        this.setState({ open: false }, function () {
          // Set focus on the icon button when the menu close
          if (isKeyboard) {
            var iconButton = _this2.refs.iconButton;
            _reactDom2.default.findDOMNode(iconButton).focus();
            iconButton.setKeyboardFocus();
          }
        });
      }
    }
  }, {
    key: 'open',
    value: function open(reason, event) {
      if (this.props.open !== null) {
        this.props.onRequestChange(true, reason);

        return this.setState({
          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
          anchorEl: event.currentTarget
        });
      }

      this.setState({
        open: true,
        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
        anchorEl: event.currentTarget
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          anchorOrigin = _props.anchorOrigin,
          className = _props.className,
          animated = _props.animated,
          animation = _props.animation,
          iconButtonElement = _props.iconButtonElement,
          iconStyle = _props.iconStyle,
          onItemClick = _props.onItemClick,
          onKeyboardFocus = _props.onKeyboardFocus,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          onMouseUp = _props.onMouseUp,
          onRequestChange = _props.onRequestChange,
          onClick = _props.onClick,
          listStyle = _props.listStyle,
          menuStyle = _props.menuStyle,
          style = _props.style,
          targetOrigin = _props.targetOrigin,
          clickCloseDelay = _props.clickCloseDelay,
          useLayerForClickAway = _props.useLayerForClickAway,
          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemClick', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onClick', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'clickCloseDelay', 'useLayerForClickAway']);
      var prepareStyles = this.context.muiTheme.prepareStyles;
      var _state = this.state,
          open = _state.open,
          anchorEl = _state.anchorEl;


      var styles = {
        root: {
          display: 'inline-block',
          position: 'relative'
        },
        menu: {
          position: 'relative'
        }
      };

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);

       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;

      var iconButtonProps = {
        onKeyboardFocus: onKeyboardFocus,
        onClick: function onClick(event) {
          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
          if (iconButtonElement.props.onClick) {
            iconButtonElement.props.onClick(event);
          }
        },
        ref: 'iconButton'
      };
      if (iconStyle || iconButtonElement.props.iconStyle) {
        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
      }
      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);

      var menu = _react2.default.createElement(
        _Menu2.default,
        (0, _extends3.default)({}, other, {
          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
          onEscKeyDown: this.handleEscKeyDownMenu,
          onItemClick: this.handleItemClick,
          style: mergedMenuStyles,
          listStyle: listStyle
        }),
        this.props.children
      );

      return _react2.default.createElement(
        'div',
        {
          ref: 'iconMenuContainer',
          className: className,
          onMouseDown: onMouseDown,
          onMouseLeave: onMouseLeave,
          onMouseEnter: onMouseEnter,
          onMouseUp: onMouseUp,
          onClick: onClick,
          style: prepareStyles(mergedRootStyles)
        },
        iconButton,
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            open: open,
            anchorEl: anchorEl,
            childContextTypes: this.constructor.childContextTypes,
            useLayerForClickAway: useLayerForClickAway,
            onRequestClose: this.handleRequestClose,
            animated: animated,
            animation: animation,
            context: this.context
          },
          menu
        )
      );
    }
  }]);
  return IconMenu;
}(_react.Component);

IconMenu.muiName = 'IconMenu';
IconMenu.defaultProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  animated: true,
  multiple: false,
  open: null,
  onItemClick: function onItemClick() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseDown: function onMouseDown() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseUp: function onMouseUp() {},
  onRequestChange: function onRequestChange() {},
  onClick: function onClick() {},
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  clickCloseDelay: 200,
  useLayerForClickAway: false
};
IconMenu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
IconMenu.propTypes =  false ? {
  /**
   * This is the point on the icon where the menu
   * `targetOrigin` will attach.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * Should be used to pass `MenuItem` components.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Sets the delay in milliseconds before closing the
   * menu when an item is clicked.
   * If set to 0 then the auto close functionality
   * will be disabled.
   */
  clickCloseDelay: _propTypes2.default.number,
  /**
   * This is the `IconButton` to render. This button will open the menu.
   */
  iconButtonElement: _propTypes2.default.element.isRequired,
  /**
   * Override the inline-styles of the underlying icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the menu element.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, the value can an be array and allow the menu to be a multi-select.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when the `IconButton` element is clicked.
   *
   * @param {object} event Click event targeting the `IconButton` element.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected with a click.
   *
   * @param {object} event Click event targeting the selected menu item element.
   * @param {object} child The selected element.
   */
  onItemClick: _propTypes2.default.func,
  /**
   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseDown: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseUp: _propTypes2.default.func,
  /**
   * Callback function fired when the `open` state of the menu is requested to be changed.
   *
   * @param {boolean} open If true, the menu was requested to be opened.
   * @param {string} reason The reason for the open or close request. Possible values are
   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
   * for close requests.
   */
  onRequestChange: _propTypes2.default.func,
  /**
   * If true, the `IconMenu` is opened.
   */
  open: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the menu which will stick to the menu
   * origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying elements.
   */
  useLayerForClickAway: _propTypes2.default.bool
} : {};
exports.default = IconMenu;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LinearProgress = __webpack_require__(1826);

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LinearProgress2.default;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  var rangeValue = max - min;
  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
  return relValue * 100;
}

function getStyles(props, context) {
  var max = props.max,
      min = props.min,
      value = props.value;
  var _context$muiTheme = context.muiTheme,
      palette = _context$muiTheme.baseTheme.palette,
      borderRadius = _context$muiTheme.borderRadius;


  var styles = {
    root: {
      position: 'relative',
      height: 4,
      display: 'block',
      width: '100%',
      backgroundColor: palette.primary3Color,
      borderRadius: borderRadius,
      margin: 0,
      overflow: 'hidden'
    },
    bar: {
      height: '100%'
    },
    barFragment1: {},
    barFragment2: {}
  };

  if (props.mode === 'indeterminate') {
    styles.barFragment1 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
    };

    styles.barFragment2 = {
      position: 'absolute',
      backgroundColor: props.color || palette.primary1Color,
      top: 0,
      left: 0,
      bottom: 0,
      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
    };
  } else {
    styles.bar.backgroundColor = props.color || palette.primary1Color;
    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
    styles.bar.width = getRelativeValue(value, min, max) + '%';
  }

  return styles;
}

var LinearProgress = function (_Component) {
  (0, _inherits3.default)(LinearProgress, _Component);

  function LinearProgress() {
    (0, _classCallCheck3.default)(this, LinearProgress);
    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
  }

  (0, _createClass3.default)(LinearProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.timers = {};

      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);

      this.timers.bar2 = setTimeout(function () {
        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
      }, 850);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timers.bar1);
      clearTimeout(this.timers.bar2);
    }
  }, {
    key: 'barUpdate',
    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
      var _this3 = this;

      if (this.props.mode !== 'indeterminate') return;

      timeToNextStep = timeToNextStep || 420;
      step = step || 0;
      step %= 4;

      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
      var left = this.context.muiTheme.isRtl ? 'right' : 'left';

      if (step === 0) {
        barElement.style[left] = stepValues[0][0] + '%';
        barElement.style[right] = stepValues[0][1] + '%';
      } else if (step === 1) {
        barElement.style.transitionDuration = '840ms';
      } else if (step === 2) {
        barElement.style[left] = stepValues[1][0] + '%';
        barElement.style[right] = stepValues[1][1] + '%';
      } else if (step === 3) {
        barElement.style.transitionDuration = '0ms';
      }
      this.timers[id] = setTimeout(function () {
        return _this3.barUpdate(id, step + 1, barElement, stepValues);
      }, timeToNextStep);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.bar) },
          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
        )
      );
    }
  }]);
  return LinearProgress;
}(_react.Component);

LinearProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0,
  min: 0,
  max: 100
};
LinearProgress.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
LinearProgress.propTypes =  false ? {
  /**
   * The color of the progress bar, defaults to
   * primary color of theme.
   */
  color: _propTypes2.default.string,
  /**
   * The max value of progress, only works in determinate mode.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress, only works in determinate mode.
   */
  min: _propTypes2.default.number,
  /**
   * The mode of show your progress, indeterminate for when
   * there is no value for progress.
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The value of progress, only works in determinate mode.
   */
  value: _propTypes2.default.number
} : {};
exports.default = LinearProgress;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _RefreshIndicator = __webpack_require__(1828);

var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RefreshIndicator2.default;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _slicedToArray2 = __webpack_require__(510);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autoPrefix = __webpack_require__(195);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIEWBOX_SIZE = 32;

function getStyles(props) {
  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
  return {
    root: {
      position: 'absolute',
      zIndex: 2,
      width: props.size,
      height: props.size,
      padding: padding,
      top: -10000,
      left: -10000,
      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
      opacity: props.status === 'hide' ? 0 : 1,
      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
    }
  };
}

var RefreshIndicator = function (_Component) {
  (0, _inherits3.default)(RefreshIndicator, _Component);

  function RefreshIndicator() {
    (0, _classCallCheck3.default)(this, RefreshIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefreshIndicator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scalePath(this.refs.path, 0);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
      clearTimeout(this.rotateWrapperSecondTimer);

      this.scalePath(this.refs.path, 0);
      this.rotateWrapper(this.refs.wrapper);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.scalePathTimer);
      clearTimeout(this.rotateWrapperTimer);
      clearTimeout(this.rotateWrapperSecondTimer);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var paperSize = this.getPaperSize();

      var childrenCmp = null;
      if (this.props.status !== 'ready') {
        var circleStyle = this.getCircleStyle(paperSize);
        childrenCmp = _react2.default.createElement(
          'div',
          {
            ref: 'wrapper',
            style: prepareStyles({
              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
              width: '100%',
              height: '100%'
            })
          },
          _react2.default.createElement(
            'svg',
            {
              style: {
                width: paperSize,
                height: paperSize
              },
              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
            },
            _react2.default.createElement('circle', (0, _extends3.default)({
              ref: 'path',
              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
              }))
            }, circleStyle.attr))
          )
        );
      } else {
        var _circleStyle = this.getCircleStyle(paperSize);
        var polygonStyle = this.getPolygonStyle(paperSize);
        childrenCmp = _react2.default.createElement(
          'svg',
          {
            style: {
              width: paperSize,
              height: paperSize
            },
            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
          },
          _react2.default.createElement('circle', (0, _extends3.default)({
            style: prepareStyles(_circleStyle.style)
          }, _circleStyle.attr)),
          _react2.default.createElement('polygon', (0, _extends3.default)({
            style: prepareStyles(polygonStyle.style)
          }, polygonStyle.attr))
        );
      }

      return childrenCmp;
    }
  }, {
    key: 'getTheme',
    value: function getTheme() {
      return this.context.muiTheme.refreshIndicator;
    }
  }, {
    key: 'getPaddingSize',
    value: function getPaddingSize() {
      var padding = this.props.size * 0.1;
      return padding;
    }
  }, {
    key: 'getPaperSize',
    value: function getPaperSize() {
      return this.props.size - this.getPaddingSize() * 2;
    }
  }, {
    key: 'getCircleAttr',
    value: function getCircleAttr() {
      return {
        radiu: VIEWBOX_SIZE / 2 - 5,
        originX: VIEWBOX_SIZE / 2,
        originY: VIEWBOX_SIZE / 2,
        strokeWidth: 3
      };
    }
  }, {
    key: 'getArcDeg',
    value: function getArcDeg() {
      var p = this.props.percentage / 100;

      var beginDeg = p * 120;
      var endDeg = p * 410;
      return [beginDeg, endDeg];
    }
  }, {
    key: 'getFactor',
    value: function getFactor() {
      var p = this.props.percentage / 100;
      var p1 = Math.min(1, p / 0.4);

      return p1;
    }
  }, {
    key: 'getCircleStyle',
    value: function getCircleStyle() {
      var isLoading = this.props.status === 'loading';
      var p1 = isLoading ? 1 : this.getFactor();
      var circle = this.getCircleAttr();
      var perimeter = Math.PI * 2 * circle.radiu;

      var _getArcDeg = this.getArcDeg(),
          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
          beginDeg = _getArcDeg2[0],
          endDeg = _getArcDeg2[1];

      var arcLen = (endDeg - beginDeg) * perimeter / 360;
      var dashOffset = -beginDeg * perimeter / 360;

      var theme = this.getTheme();
      return {
        style: {
          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
          strokeDashoffset: dashOffset,
          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
          strokeLinecap: 'round',
          opacity: p1,
          strokeWidth: circle.strokeWidth * p1,
          fill: 'none'
        },
        attr: {
          cx: circle.originX,
          cy: circle.originY,
          r: circle.radiu
        }
      };
    }
  }, {
    key: 'getPolygonStyle',
    value: function getPolygonStyle() {
      var p1 = this.getFactor();
      var circle = this.getCircleAttr();

      var triangleCx = circle.originX + circle.radiu;
      var triangleCy = circle.originY;
      var dx = circle.strokeWidth * 7 / 4 * p1;
      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);

      var _getArcDeg3 = this.getArcDeg(),
          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
          endDeg = _getArcDeg4[1];

      var theme = this.getTheme();
      return {
        style: {
          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
          transform: 'rotate(' + endDeg + 'deg)',
          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
          opacity: p1
        },
        attr: {
          points: trianglePath
        }
      };
    }
  }, {
    key: 'scalePath',
    value: function scalePath(path, step) {
      var _this2 = this;

      if (this.props.status !== 'loading') return;

      var currStep = (step || 0) % 3;

      var circle = this.getCircleAttr();
      var perimeter = Math.PI * 2 * circle.radiu;
      var arcLen = perimeter * 0.64;

      var strokeDasharray = void 0;
      var strokeDashoffset = void 0;
      var transitionDuration = void 0;

      if (currStep === 0) {
        strokeDasharray = '1, 200';
        strokeDashoffset = 0;
        transitionDuration = '0ms';
      } else if (currStep === 1) {
        strokeDasharray = arcLen + ', 200';
        strokeDashoffset = -15;
        transitionDuration = '750ms';
      } else {
        strokeDasharray = arcLen + ', 200';
        strokeDashoffset = -(perimeter - 1);
        transitionDuration = '850ms';
      }

      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);

      this.scalePathTimer = setTimeout(function () {
        return _this2.scalePath(path, currStep + 1);
      }, currStep ? 750 : 250);
    }
  }, {
    key: 'rotateWrapper',
    value: function rotateWrapper(wrapper) {
      var _this3 = this;

      if (this.props.status !== 'loading') return;

      _autoPrefix2.default.set(wrapper.style, 'transform', null);
      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');

      this.rotateWrapperSecondTimer = setTimeout(function () {
        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
      }, 50);

      this.rotateWrapperTimer = setTimeout(function () {
        return _this3.rotateWrapper(wrapper);
      }, 10050);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          top = _props.top,
          left = _props.left,
          percentage = _props.percentage,
          status = _props.status,
          loadingColor = _props.loadingColor,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);


      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({
          circle: true,
          style: (0, _simpleAssign2.default)(styles.root, style)
        }, other),
        this.renderChildren()
      );
    }
  }]);
  return RefreshIndicator;
}(_react.Component);

RefreshIndicator.defaultProps = {
  percentage: 0,
  size: 40,
  status: 'hide'
};
RefreshIndicator.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RefreshIndicator.propTypes =  false ? {
  /**
   * Override the theme's color of the indicator while it's status is
   * "ready" and it's percentage is less than 100.
   */
  color: _propTypes2.default.string,
  /**
   * The absolute left position of the indicator in pixels.
   */
  left: _propTypes2.default.number.isRequired,
  /**
   * Override the theme's color of the indicator while
   * it's status is "loading" or when it's percentage is 100.
   */
  loadingColor: _propTypes2.default.string,
  /**
   * The confirmation progress to fetch data. Max value is 100.
   */
  percentage: _propTypes2.default.number,
  /**
   * Size in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * The display status of the indicator. If the status is
   * "ready", the indicator will display the ready state
   * arrow. If the status is "loading", it will display
   * the loading progress indicator. If the status is "hide",
   * the indicator will be hidden.
   */
  status: _propTypes2.default.oneOf(['ready', 'loading', 'hide']),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The absolute top position of the indicator in pixels.
   */
  top: _propTypes2.default.number.isRequired
} : {};
exports.default = RefreshIndicator;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1830), __esModule: true };

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(451);
__webpack_require__(313);
module.exports = __webpack_require__(1831);


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(653);
var ITERATOR = __webpack_require__(112)('iterator');
var Iterators = __webpack_require__(219);
module.exports = __webpack_require__(73).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1833), __esModule: true };

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(451);
__webpack_require__(313);
module.exports = __webpack_require__(1834);


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(183);
var get = __webpack_require__(652);
module.exports = __webpack_require__(73).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = __webpack_require__(23);

var _TextField2 = _interopRequireDefault(_TextField);

var _DropDownMenu = __webpack_require__(268);

var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props) {
  return {
    label: {
      paddingLeft: 0,
      top: props.floatingLabelText ? 6 : -4
    },
    icon: {
      right: 0,
      top: props.floatingLabelText ? 8 : 0
    },
    hideDropDownUnderline: {
      borderTop: 'none'
    },
    dropDownMenu: {
      display: 'block'
    }
  };
}

var SelectField = function (_Component) {
  (0, _inherits3.default)(SelectField, _Component);

  function SelectField() {
    (0, _classCallCheck3.default)(this, SelectField);
    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoWidth = _props.autoWidth,
          multiple = _props.multiple,
          children = _props.children,
          style = _props.style,
          labelStyle = _props.labelStyle,
          iconStyle = _props.iconStyle,
          id = _props.id,
          underlineDisabledStyle = _props.underlineDisabledStyle,
          underlineFocusStyle = _props.underlineFocusStyle,
          menuItemStyle = _props.menuItemStyle,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          underlineStyle = _props.underlineStyle,
          dropDownMenuProps = _props.dropDownMenuProps,
          errorStyle = _props.errorStyle,
          disabled = _props.disabled,
          floatingLabelFixed = _props.floatingLabelFixed,
          floatingLabelText = _props.floatingLabelText,
          floatingLabelStyle = _props.floatingLabelStyle,
          hintStyle = _props.hintStyle,
          hintText = _props.hintText,
          fullWidth = _props.fullWidth,
          errorText = _props.errorText,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          menuStyle = _props.menuStyle,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          selectionRenderer = _props.selectionRenderer,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);


      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _TextField2.default,
        (0, _extends3.default)({}, other, {
          style: style,
          disabled: disabled,
          floatingLabelFixed: floatingLabelFixed,
          floatingLabelText: floatingLabelText,
          floatingLabelStyle: floatingLabelStyle,
          hintStyle: hintStyle,
          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
          fullWidth: fullWidth,
          errorText: errorText,
          underlineStyle: underlineStyle,
          errorStyle: errorStyle,
          onFocus: onFocus,
          onBlur: onBlur,
          id: id,
          underlineDisabledStyle: underlineDisabledStyle,
          underlineFocusStyle: underlineFocusStyle
        }),
        _react2.default.createElement(
          _DropDownMenu2.default,
          (0, _extends3.default)({
            disabled: disabled,
            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
            menuItemStyle: menuItemStyle,
            selectedMenuItemStyle: selectedMenuItemStyle,
            underlineStyle: styles.hideDropDownUnderline,
            listStyle: listStyle,
            autoWidth: autoWidth,
            value: value,
            onChange: onChange,
            maxHeight: maxHeight,
            multiple: multiple,
            selectionRenderer: selectionRenderer
          }, dropDownMenuProps),
          children
        )
      );
    }
  }]);
  return SelectField;
}(_react.Component);

SelectField.defaultProps = {
  autoWidth: false,
  disabled: false,
  fullWidth: false,
  multiple: false
};
SelectField.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SelectField.propTypes =  false ? {
  /**
   * If true, the width will automatically be set according to the
   * items inside the menu.
   * To control the width in CSS instead, leave this prop set to `false`.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The `MenuItem` elements to populate the select field with.
   * If the menu items have a `label` prop, that value will
   * represent the selected menu item in the rendered select field.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the select field will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Object that can handle and override any property of component DropDownMenu.
   */
  dropDownMenuProps: _propTypes2.default.object,
  /**
   * Override the inline-styles of the error element.
   */
  errorStyle: _propTypes2.default.object,
  /**
   * The error content to display.
   */
  errorText: _propTypes2.default.node,
  /**
   * If true, the floating label will float even when no value is selected.
   */
  floatingLabelFixed: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the floating label.
   */
  floatingLabelStyle: _propTypes2.default.object,
  /**
   * The content of the floating label.
   */
  floatingLabelText: _propTypes2.default.node,
  /**
   * If true, the select field will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the hint element.
   */
  hintStyle: _propTypes2.default.object,
  /**
   * The hint content to display.
   */
  hintText: _propTypes2.default.node,
  /**
   * Override the inline-styles of the icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * The id prop for the text field.
   */
  id: _propTypes2.default.string,
  /**
   * Override the label style when the select field is inactive.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * Override the default max-height of the underlying `DropDownMenu` element.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underlying `DropDownMenu` element.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event Click event targeting the menu item
   * that was selected.
   * @param {number} key The index of the selected menu item, or undefined
   * if `multiple` is true.
   * @param {any} payload If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Customize the rendering of the selected item.
   *
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   * @param {any} menuItem The selected `MenuItem`.
   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
   */
  selectionRenderer: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element when the select
   * field is disabled.
   */
  underlineDisabledStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element when the select field
   * is focused.
   */
  underlineFocusStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the underline element.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   */
  value: _propTypes2.default.any
} : {};
exports.default = SelectField;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(69);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _FocusRipple = __webpack_require__(492);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Verifies min/max range.
 * @param   {Object} props         Properties of the React component.
 * @param   {String} propName      Name of the property to validate.
 * @param   {String} componentName Name of the component whose property is being validated.
 * @returns {Object} Returns an Error if min >= max otherwise null.
 */
var minMaxPropType = function minMaxPropType(props, propName, componentName) {
  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
  if (error !== null) {
    return error;
  }

  if (props.min >= props.max) {
    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
    return new Error(errorMsg);
  }
};

/**
 * Verifies value is within the min/max range.
 * @param   {Object} props         Properties of the React component.
 * @param   {String} propName      Name of the property to validate.
 * @param   {String} componentName Name of the component whose property is being validated.
 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
 */
var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
  if (error !== null) {
    return error;
  }

  var value = props[propName];
  if (value < props.min || props.max < value) {
    return new Error(propName + ' should be within the range specified by min and max');
  }
};

var crossAxisProperty = {
  x: 'height',
  'x-reverse': 'height',
  y: 'width',
  'y-reverse': 'width'
};

var crossAxisOffsetProperty = {
  x: 'top',
  'x-reverse': 'top',
  y: 'left',
  'y-reverse': 'left'
};

var mainAxisProperty = {
  x: 'width',
  'x-reverse': 'width',
  y: 'height',
  'y-reverse': 'height'
};

var mainAxisMarginFromEnd = {
  x: 'marginRight',
  'x-reverse': 'marginLeft',
  y: 'marginTop',
  'y-reverse': 'marginBottom'
};

var mainAxisMarginFromStart = {
  x: 'marginLeft',
  'x-reverse': 'marginRight',
  y: 'marginBottom',
  'y-reverse': 'marginTop'
};

var mainAxisOffsetProperty = {
  x: 'left',
  'x-reverse': 'right',
  y: 'bottom',
  'y-reverse': 'top'
};

var mainAxisClientProperty = {
  x: 'clientWidth',
  'x-reverse': 'clientWidth',
  y: 'clientHeight',
  'y-reverse': 'clientHeight'
};

var mainAxisClientOffsetProperty = {
  x: 'clientX',
  'x-reverse': 'clientX',
  y: 'clientY',
  'y-reverse': 'clientY'
};

var reverseMainAxisOffsetProperty = {
  x: 'right',
  'x-reverse': 'left',
  y: 'top',
  'y-reverse': 'bottom'
};

var isMouseControlInverted = function isMouseControlInverted(axis) {
  return axis === 'x-reverse' || axis === 'y';
};

var calculateAxis = function calculateAxis(axis, isRtl) {
  if (isRtl) {
    switch (axis) {
      case 'x':
        return 'x-reverse';
      case 'x-reverse':
        return 'x';
    }
  }
  return axis;
};

function getPercent(value, min, max) {
  var percent = (value - min) / (max - min);
  if (isNaN(percent)) {
    percent = 0;
  }

  return percent;
}

var getStyles = function getStyles(props, context, state) {
  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;

  var axis = props.axis,
      disabled = props.disabled,
      max = props.max,
      min = props.min;
  var _context$muiTheme = context.muiTheme,
      isRtl = _context$muiTheme.isRtl,
      _context$muiTheme$sli = _context$muiTheme.slider,
      handleColorZero = _context$muiTheme$sli.handleColorZero,
      handleFillColor = _context$muiTheme$sli.handleFillColor,
      handleSize = _context$muiTheme$sli.handleSize,
      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
      trackSize = _context$muiTheme$sli.trackSize,
      trackColor = _context$muiTheme$sli.trackColor,
      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
      rippleColor = _context$muiTheme$sli.rippleColor,
      selectionColor = _context$muiTheme$sli.selectionColor;


  var fillGutter = handleSize / 2;
  var disabledGutter = trackSize + handleSizeDisabled / 2;
  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
  var percent = getPercent(state.value, min, max);
  var calculatedAxis = calculateAxis(axis, isRtl);

  var styles = {
    slider: (_slider = {
      touchCallout: 'none',
      userSelect: 'none',
      cursor: 'default'
    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[calculatedAxis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
    track: (_track = {
      position: 'absolute'
    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[calculatedAxis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[calculatedAxis], trackSize), _track),
    filledAndRemaining: (_filledAndRemaining = {
      directionInvariant: true,
      position: 'absolute'
    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
    handle: (_handle = {
      directionInvariant: true,
      boxSizing: 'border-box',
      position: 'absolute',
      cursor: 'pointer',
      pointerEvents: 'inherit'
    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[calculatedAxis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
      x: trackSize / 2 + 'px 0 0 0',
      'x-reverse': trackSize / 2 + 'px 0 0 0',
      y: '0 0 0 ' + trackSize / 2 + 'px',
      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
      x: 'translate(-50%, -50%)',
      'x-reverse': 'translate(50%, -50%)',
      y: 'translate(-50%, 50%)',
      'y-reverse': 'translate(-50%, -50%)'
    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
    handleWhenDisabled: {
      boxSizing: 'content-box',
      cursor: 'not-allowed',
      backgroundColor: trackColor,
      width: handleSizeDisabled,
      height: handleSizeDisabled,
      border: 'none'
    },
    handleWhenPercentZero: {
      border: trackSize + 'px solid ' + handleColorZero,
      backgroundColor: handleFillColor,
      boxShadow: 'none'
    },
    handleWhenPercentZeroAndDisabled: {
      cursor: 'not-allowed',
      width: handleSizeDisabled,
      height: handleSizeDisabled
    },
    handleWhenPercentZeroAndFocused: {
      border: trackSize + 'px solid ' + trackColorSelected
    },
    handleWhenActive: {
      width: handleSizeActive,
      height: handleSizeActive
    },
    ripple: {
      height: handleSize,
      width: handleSize,
      overflow: 'visible'
    },
    rippleWhenPercentZero: {
      top: -trackSize,
      left: -trackSize
    },
    rippleInner: {
      height: '300%',
      width: '300%',
      top: -handleSize,
      left: -handleSize
    },
    rippleColor: {
      fill: percent === 0 ? handleColorZero : rippleColor
    }
  };
  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[calculatedAxis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[calculatedAxis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));

  return styles;
};

var Slider = function (_Component) {
  (0, _inherits3.default)(Slider, _Component);

  function Slider() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Slider);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: false,
      dragging: false,
      focused: false,
      hovered: false,
      value: 0
    }, _this.track = null, _this.handle = null, _this.resolveValue = function (value, min, max) {
      if (value > max) {
        return max;
      }

      if (value < min) {
        return min;
      }

      return value;
    }, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          axis = _this$props.axis,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step;
      var isRtl = _this.context.muiTheme.isRtl;


      var calculatedAxis = calculateAxis(axis, isRtl);

      var action = void 0;

      switch ((0, _keycode2.default)(event)) {
        case 'page down':
        case 'down':
          if (calculatedAxis === 'y-reverse') {
            action = 'increase';
          } else {
            action = 'decrease';
          }
          break;
        case 'left':
          if (calculatedAxis === 'x-reverse') {
            action = 'increase';
          } else {
            action = 'decrease';
          }
          break;
        case 'page up':
        case 'up':
          if (calculatedAxis === 'y-reverse') {
            action = 'decrease';
          } else {
            action = 'increase';
          }
          break;
        case 'right':
          if (calculatedAxis === 'x-reverse') {
            action = 'decrease';
          } else {
            action = 'increase';
          }
          break;
        case 'home':
          action = 'min';
          break;
        case 'end':
          action = 'max';
          break;
      }

      if (action) {
        var newValue = void 0;

        // Cancel scroll
        event.preventDefault();

        switch (action) {
          case 'decrease':
            newValue = _this.state.value - step;
            break;
          case 'increase':
            newValue = _this.state.value + step;
            break;
          case 'min':
            newValue = min;
            break;
          case 'max':
            newValue = max;
            break;
        }

        // We need to use toFixed() because of float point errors.
        // For example, 0.01 + 0.06 = 0.06999999999999999
        newValue = _this.resolveValue(parseFloat(newValue.toFixed(5)), min, max);

        if (_this.state.value !== newValue) {
          _this.setState({
            value: newValue
          });

          if (_this.props.onChange) {
            _this.props.onChange(event, newValue);
          }
        }
      }
    }, _this.handleDragMouseMove = function (event) {
      _this.onDragUpdate(event, 'mouse');
    }, _this.handleTouchMove = function (event) {
      _this.onDragUpdate(event, 'touch');
    }, _this.handleMouseEnd = function (event) {
      document.removeEventListener('mousemove', _this.handleDragMouseMove);
      document.removeEventListener('mouseup', _this.handleMouseEnd);

      _this.onDragStop(event);
    }, _this.handleTouchEnd = function (event) {
      document.removeEventListener('touchmove', _this.handleTouchMove);
      document.removeEventListener('touchup', _this.handleTouchEnd);
      document.removeEventListener('touchend', _this.handleTouchEnd);
      document.removeEventListener('touchcancel', _this.handleTouchEnd);

      _this.onDragStop(event);
    }, _this.handleTouchStart = function (event) {
      var _this$props2 = _this.props,
          axis = _this$props2.axis,
          disabled = _this$props2.disabled;
      var isRtl = _this.context.muiTheme.isRtl;


      if (disabled) {
        return;
      }

      var calculatedAxis = calculateAxis(axis, isRtl);

      var position = void 0;
      if (isMouseControlInverted(calculatedAxis)) {
        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]];
      } else {
        position = event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
      }
      _this.setValueFromPosition(event, position);

      document.addEventListener('touchmove', _this.handleTouchMove);
      document.addEventListener('touchup', _this.handleTouchEnd);
      document.addEventListener('touchend', _this.handleTouchEnd);
      document.addEventListener('touchcancel', _this.handleTouchEnd);

      _this.onDragStart(event);

      // Cancel scroll and context menu
      event.preventDefault();
    }, _this.handleFocus = function (event) {
      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleBlur = function (event) {
      _this.setState({
        focused: false,
        active: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleMouseDown = function (event) {
      var _this$props3 = _this.props,
          axis = _this$props3.axis,
          disabled = _this$props3.disabled;
      var isRtl = _this.context.muiTheme.isRtl;


      if (disabled) {
        return;
      }

      var calculatedAxis = calculateAxis(axis, isRtl);

      var position = void 0;
      if (isMouseControlInverted(calculatedAxis)) {
        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[calculatedAxis]];
      } else {
        position = event[mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
      }
      _this.setValueFromPosition(event, position);

      document.addEventListener('mousemove', _this.handleDragMouseMove);
      document.addEventListener('mouseup', _this.handleMouseEnd);

      // Cancel text selection
      event.preventDefault();

      // Set focus manually since we called preventDefault()
      _this.handle.focus();

      _this.onDragStart(event);
    }, _this.handleMouseUp = function () {
      if (!_this.props.disabled) {
        _this.setState({
          active: false
        });
      }
    }, _this.handleMouseEnter = function () {
      _this.setState({
        hovered: true
      });
    }, _this.handleMouseLeave = function () {
      _this.setState({
        hovered: false
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Slider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          min = _props.min,
          max = _props.max;
      var value = this.props.value;


      if (value === undefined) {
        value = defaultValue !== undefined ? defaultValue : min;
      }

      this.setState({
        value: this.resolveValue(value, min, max)
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== undefined && !this.state.dragging) {
        var _nextProps$min = nextProps.min,
            min = _nextProps$min === undefined ? this.props.min : _nextProps$min,
            _nextProps$max = nextProps.max,
            max = _nextProps$max === undefined ? this.props.max : _nextProps$max;


        this.setState({
          value: this.resolveValue(nextProps.value, min, max)
        });
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;

      return this.state.value;
    }
  }, {
    key: 'clearValue',
    value: function clearValue() {
       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;

      this.setState({
        value: this.props.min
      });
    }
  }, {
    key: 'getTrackOffset',
    value: function getTrackOffset() {
      var axis = this.props.axis;
      var isRtl = this.context.muiTheme.isRtl;


      var calculatedAxis = calculateAxis(axis, isRtl);

      if (!this.track) return 0;
      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[calculatedAxis]];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(event) {
      this.setState({
        dragging: true,
        active: true
      });

      if (this.props.onDragStart) {
        this.props.onDragStart(event);
      }
    }
  }, {
    key: 'onDragUpdate',
    value: function onDragUpdate(event, type) {
      var _this2 = this;

      var _props2 = this.props,
          axis = _props2.axis,
          disabled = _props2.disabled;
      var isRtl = this.context.muiTheme.isRtl;


      if (this.dragRunning) {
        return;
      }
      this.dragRunning = true;

      requestAnimationFrame(function () {
        _this2.dragRunning = false;

        var calculatedAxis = calculateAxis(axis, isRtl);
        var source = type === 'touch' ? event.touches[0] : event;

        var position = void 0;
        if (isMouseControlInverted(calculatedAxis)) {
          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[calculatedAxis]];
        } else {
          position = source[mainAxisClientOffsetProperty[calculatedAxis]] - _this2.getTrackOffset();
        }

        if (!disabled) {
          _this2.setValueFromPosition(event, position);
        }
      });
    }
  }, {
    key: 'onDragStop',
    value: function onDragStop(event) {
      this.setState({
        dragging: false,
        active: false
      });

      if (this.props.onDragStop) {
        this.props.onDragStop(event);
      }
    }
  }, {
    key: 'setValueFromPosition',
    value: function setValueFromPosition(event, position) {
      var _props3 = this.props,
          axis = _props3.axis,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;
      var isRtl = this.context.muiTheme.isRtl;


      var calculatedAxis = calculateAxis(axis, isRtl);
      var positionMax = this.track[mainAxisClientProperty[calculatedAxis]];

      var value = void 0;

      if (position <= 0) {
        value = min;
      } else if (position >= positionMax) {
        value = max;
      } else {
        value = position / positionMax * (max - min);
        value = Math.round(value / step) * step + min;
        value = parseFloat(value.toFixed(5));
      }

      value = this.resolveValue(value, min, max);

      if (this.state.value !== value) {
        this.setState({
          value: value
        });

        if (this.props.onChange) {
          this.props.onChange(event, value);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props4 = this.props,
          axis = _props4.axis,
          disabled = _props4.disabled,
          disableFocusRipple = _props4.disableFocusRipple,
          max = _props4.max,
          min = _props4.min,
          name = _props4.name,
          onBlur = _props4.onBlur,
          onChange = _props4.onChange,
          onDragStart = _props4.onDragStart,
          onDragStop = _props4.onDragStop,
          onFocus = _props4.onFocus,
          required = _props4.required,
          sliderStyle = _props4.sliderStyle,
          step = _props4.step,
          style = _props4.style,
          propValue = _props4.value,
          other = (0, _objectWithoutProperties3.default)(_props4, ['axis', 'disabled', 'disableFocusRipple', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style', 'value']);
      var _state = this.state,
          active = _state.active,
          focused = _state.focused,
          hovered = _state.hovered,
          value = _state.value;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var percent = getPercent(value, min, max);

      var handleStyles = {};
      if (percent === 0) {
        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
      } else {
        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
      }

      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
        _react2.default.createElement(
          'div',
          {
            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMouseDown: this.handleMouseDown,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onMouseUp: this.handleMouseUp,
            onTouchStart: this.handleTouchStart,
            onKeyDown: !disabled ? this.handleKeyDown : undefined
          },
          _react2.default.createElement(
            'div',
            { ref: function ref(node) {
                return _this3.track = node;
              }, style: prepareStyles(styles.track) },
            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
            _react2.default.createElement(
              'div',
              {
                ref: function ref(node) {
                  return _this3.handle = node;
                },
                style: prepareStyles(handleStyles),
                tabIndex: 0
              },
              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
                style: rippleStyle,
                innerStyle: styles.rippleInner,
                show: (hovered || focused) && !active,
                color: styles.rippleColor.fill
              })
            )
          )
        ),
        _react2.default.createElement('input', {
          type: 'hidden',
          name: name,
          value: value,
          required: required,
          min: min,
          max: max,
          step: step
        })
      );
    }
  }]);
  return Slider;
}(_react.Component);

Slider.defaultProps = {
  axis: 'x',
  disabled: false,
  disableFocusRipple: false,
  max: 1,
  min: 0,
  required: true,
  step: 0.01,
  style: {}
};
Slider.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Slider.propTypes =  false ? {
  /**
   * The axis on which the slider will slide.
   */
  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
  /**
   * The default value of the slider.
   */
  defaultValue: valueInRangePropType,
  /**
   * Disables focus ripple if set to true.
   */
  disableFocusRipple: _propTypes2.default.bool,
  /**
   * If true, the slider will not be interactable.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The maximum value the slider can slide to on
   * a scale from 0 to 1 inclusive. Cannot be equal to min.
   */
  max: minMaxPropType,
  /**
   * The minimum value the slider can slide to on a scale
   * from 0 to 1 inclusive. Cannot be equal to max.
   */
  min: minMaxPropType,
  /**
   * The name of the slider. Behaves like the name attribute
   * of an input element.
   */
  name: _propTypes2.default.string,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event KeyDown event targeting the slider.
   * @param {number} newValue The new value of the slider.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function that is fired when the slider has begun to move.
   *
   * @param {object} event MouseDown or TouchStart event targeting the slider.
   */
  onDragStart: _propTypes2.default.func,
  /**
   * Callback function that is fired when the slide has stopped moving.
   *
   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
   */
  onDragStop: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Whether or not the slider is required in a form.
   */
  required: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the inner slider element.
   */
  sliderStyle: _propTypes2.default.object,
  /**
   * The granularity the slider can step through values.
   */
  step: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The value of the slider.
   */
  value: valueInRangePropType
} : {};
exports.default = Slider;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyles = function getStyles(_ref, _ref2) {
  var index = _ref.index;
  var stepper = _ref2.stepper;
  var orientation = stepper.orientation;

  var styles = {
    root: {
      flex: '0 0 auto'
    }
  };

  if (index > 0) {
    if (orientation === 'horizontal') {
      styles.root.marginLeft = -6;
    } else if (orientation === 'vertical') {
      styles.root.marginTop = -14;
    }
  }

  return styles;
};

var Step = function (_Component) {
  (0, _inherits3.default)(Step, _Component);

  function Step() {
    var _ref3;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Step);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
      var _this$props = _this.props,
          active = _this$props.active,
          completed = _this$props.completed,
          disabled = _this$props.disabled,
          index = _this$props.index,
          last = _this$props.last;


      var icon = index + 1;

      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Step, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          completed = _props.completed,
          disabled = _props.disabled,
          index = _props.index,
          last = _props.last,
          children = _props.children,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
        _react2.default.Children.map(children, this.renderChild)
      );
    }
  }]);
  return Step;
}(_react.Component);

Step.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired,
  stepper: _propTypes2.default.object
};
Step.propTypes =  false ? {
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes2.default.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`.
   */
  children: _propTypes2.default.node,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes2.default.bool,
  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   * Used internally for numbering.
   */
  index: _propTypes2.default.number,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * Override the inline-style of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Step;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedButton = __webpack_require__(114);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _StepLabel = __webpack_require__(780);

var _StepLabel2 = _interopRequireDefault(_StepLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLabel = function isLabel(child) {
  return child && child.type && child.type.muiName === 'StepLabel';
};

var getStyles = function getStyles(props, context, state) {
  var hovered = state.hovered;
  var _context$muiTheme$ste = context.muiTheme.stepper,
      backgroundColor = _context$muiTheme$ste.backgroundColor,
      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;


  var styles = {
    root: {
      padding: 0,
      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
      transition: _transitions2.default.easeOut()
    }
  };

  if (context.stepper.orientation === 'vertical') {
    styles.root.width = '100%';
  }

  return styles;
};

var StepButton = function (_Component) {
  (0, _inherits3.default)(StepButton, _Component);

  function StepButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, StepButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      touched: false
    }, _this.handleMouseEnter = function (event) {
      var onMouseEnter = _this.props.onMouseEnter;
      // Cancel hover styles for touch devices

      if (!_this.state.touched) {
        _this.setState({ hovered: true });
      }
      if (typeof onMouseEnter === 'function') {
        onMouseEnter(event);
      }
    }, _this.handleMouseLeave = function (event) {
      var onMouseLeave = _this.props.onMouseLeave;

      _this.setState({ hovered: false });
      if (typeof onMouseLeave === 'function') {
        onMouseLeave(event);
      }
    }, _this.handleTouchStart = function (event) {
      var onTouchStart = _this.props.onTouchStart;

      if (!_this.state.touched) {
        _this.setState({ touched: true });
      }
      if (typeof onTouchStart === 'function') {
        onTouchStart(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(StepButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          completed = _props.completed,
          disabled = _props.disabled,
          icon = _props.icon,
          iconContainerStyle = _props.iconContainerStyle,
          last = _props.last,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onTouchStart = _props.onTouchStart,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);


      var styles = getStyles(this.props, this.context, this.state);

      var child = isLabel(children) ? children : _react2.default.createElement(
        _StepLabel2.default,
        null,
        children
      );

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({
          disabled: disabled,
          style: (0, _simpleAssign2.default)(styles.root, style),
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onTouchStart: this.handleTouchStart
        }, other),
        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
      );
    }
  }]);
  return StepButton;
}(_react.Component);

StepButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired,
  stepper: _propTypes2.default.object
};
StepButton.propTypes =  false ? {
  /**
   * Passed from `Step` Is passed to StepLabel.
   */
  active: _propTypes2.default.bool,
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: _propTypes2.default.node,
  /**
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: _propTypes2.default.bool,
  /**
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Override the inline-styles of the icon container element.
   */
  iconContainerStyle: _propTypes2.default.object,
  /** @ignore */
  last: _propTypes2.default.bool,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline-style of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = StepButton;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ExpandTransition = __webpack_require__(1840);

var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExpandTransition(props) {
  return _react2.default.createElement(_ExpandTransition2.default, props);
}

var getStyles = function getStyles(props, context) {
  var styles = {
    root: {
      marginTop: -14,
      marginLeft: 14 + 11, // padding + 1/2 icon
      paddingLeft: 24 - 11 + 8,
      paddingRight: 16,
      overflow: 'hidden'
    }
  };

  if (!props.last) {
    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
  }

  return styles;
};

var StepContent = function (_Component) {
  (0, _inherits3.default)(StepContent, _Component);

  function StepContent() {
    (0, _classCallCheck3.default)(this, StepContent);
    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(StepContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          completed = _props.completed,
          last = _props.last,
          style = _props.style,
          transition = _props.transition,
          transitionDuration = _props.transitionDuration,
          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
      var _context = this.context,
          stepper = _context.stepper,
          prepareStyles = _context.muiTheme.prepareStyles;


      if (stepper.orientation !== 'vertical') {
         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
        return null;
      }

      var styles = getStyles(this.props, this.context);
      var transitionProps = {
        enterDelay: transitionDuration,
        transitionDuration: transitionDuration,
        open: active
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
          'div',
          { style: { overflow: 'hidden' } },
          children
        ))
      );
    }
  }]);
  return StepContent;
}(_react.Component);

StepContent.defaultProps = {
  transition: ExpandTransition,
  transitionDuration: 450
};
StepContent.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired,
  stepper: _propTypes2.default.object
};
StepContent.propTypes =  false ? {
  /**
   * Expands the content
   */
  active: _propTypes2.default.bool,
  /**
   * Step content
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  completed: _propTypes2.default.bool,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * Override the inline-style of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * ReactTransitionGroup component.
   */
  transition: _propTypes2.default.func,
  /**
   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
   */
  transitionDuration: _propTypes2.default.number
} : {};
exports.default = StepContent;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(266);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _ExpandTransitionChild = __webpack_require__(1841);

var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandTransition = function (_Component) {
  (0, _inherits3.default)(ExpandTransition, _Component);

  function ExpandTransition() {
    (0, _classCallCheck3.default)(this, ExpandTransition);
    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExpandTransition, [{
    key: 'renderChildren',
    value: function renderChildren(children) {
      var _props = this.props,
          enterDelay = _props.enterDelay,
          transitionDelay = _props.transitionDelay,
          transitionDuration = _props.transitionDuration,
          expandTransitionChildStyle = _props.expandTransitionChildStyle;

      return _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _ExpandTransitionChild2.default,
          {
            enterDelay: enterDelay,
            transitionDelay: transitionDelay,
            transitionDuration: transitionDuration,
            key: child.key,
            style: expandTransitionChildStyle
          },
          child
        );
      }, this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          enterDelay = _props2.enterDelay,
          loading = _props2.loading,
          open = _props2.open,
          style = _props2.style,
          transitionDelay = _props2.transitionDelay,
          transitionDuration = _props2.transitionDuration,
          expandTransitionChildStyle = _props2.expandTransitionChildStyle,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration', 'expandTransitionChildStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        overflow: 'hidden',
        height: 'auto'
      }, style);

      var newChildren = loading ? [] : this.renderChildren(children);

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }, other),
        open && newChildren
      );
    }
  }]);
  return ExpandTransition;
}(_react.Component);

ExpandTransition.defaultProps = {
  enterDelay: 0,
  transitionDelay: 0,
  transitionDuration: 450,
  loading: false,
  open: false
};
ExpandTransition.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ExpandTransition.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  expandTransitionChildStyle: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  transitionDelay: _propTypes2.default.number,
  transitionDuration: _propTypes2.default.number
} : {};
exports.default = ExpandTransition;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reflow = function reflow(elem) {
  return elem.offsetHeight;
};

var ExpandTransitionChild = function (_Component) {
  (0, _inherits3.default)(ExpandTransitionChild, _Component);

  function ExpandTransitionChild() {
    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExpandTransitionChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.enteredTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.open();
      callback();
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.setAutoHeight();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      var _this2 = this;

      var _props = this.props,
          enterDelay = _props.enterDelay,
          transitionDelay = _props.transitionDelay,
          transitionDuration = _props.transitionDuration;

      var element = _reactDom2.default.findDOMNode(this);
      element.style.height = 0;
      this.enterTimer = setTimeout(function () {
        return _this2.open();
      }, enterDelay);
      this.enteredTimer = setTimeout(function () {
        return callback();
      }, enterDelay + transitionDelay + transitionDuration);
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.setAutoHeight();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var _props2 = this.props,
          transitionDelay = _props2.transitionDelay,
          transitionDuration = _props2.transitionDuration;

      var element = _reactDom2.default.findDOMNode(this);
      // Set fixed height first for animated property value
      element.style.height = this.refs.wrapper.clientHeight + 'px';
      reflow(element);
      element.style.transitionDuration = transitionDuration + 'ms';
      element.style.height = 0;
      this.leaveTimer = setTimeout(function () {
        return callback();
      }, transitionDelay + transitionDuration);
    }
  }, {
    key: 'setAutoHeight',
    value: function setAutoHeight() {
      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
          style = _ReactDOM$findDOMNode.style;

      style.transitionDuration = 0;
      style.height = 'auto';
    }
  }, {
    key: 'open',
    value: function open() {
      var element = _reactDom2.default.findDOMNode(this);
      element.style.height = this.refs.wrapper.clientHeight + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          enterDelay = _props3.enterDelay,
          style = _props3.style,
          transitionDelay = _props3.transitionDelay,
          transitionDuration = _props3.transitionDuration,
          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({
        position: 'relative',
        height: 0,
        width: '100%',
        top: 0,
        left: 0,
        overflow: 'hidden',
        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        _react2.default.createElement(
          'div',
          { ref: 'wrapper' },
          children
        )
      );
    }
  }]);
  return ExpandTransitionChild;
}(_react.Component);

ExpandTransitionChild.defaultProps = {
  enterDelay: 0,
  transitionDelay: 0,
  transitionDuration: 450
};
ExpandTransitionChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ExpandTransitionChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  style: _propTypes2.default.object,
  transitionDelay: _propTypes2.default.number,
  transitionDuration: _propTypes2.default.number
} : {};
exports.default = ExpandTransitionChild;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StepConnector = __webpack_require__(1843);

var _StepConnector2 = _interopRequireDefault(_StepConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyles = function getStyles(props) {
  var orientation = props.orientation;

  return {
    root: {
      display: 'flex',
      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
      alignContent: 'center',
      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
      justifyContent: 'space-between'
    }
  };
};

var Stepper = function (_Component) {
  (0, _inherits3.default)(Stepper, _Component);

  function Stepper() {
    (0, _classCallCheck3.default)(this, Stepper);
    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
  }

  (0, _createClass3.default)(Stepper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var orientation = this.props.orientation;

      return { stepper: { orientation: orientation } };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          activeStep = _props.activeStep,
          children = _props.children,
          connector = _props.connector,
          linear = _props.linear,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      /**
       * One day, we may be able to use real CSS tools
       * For now, we need to create our own "pseudo" elements
       * and nth child selectors, etc
       * That's what some of this garbage is for :)
       */
      var numChildren = _react.Children.count(children);
      var steps = _react.Children.map(children, function (step, index) {
        if (!_react2.default.isValidElement(step)) {
          return null;
        }
        var controlProps = { index: index };

        if (activeStep === index) {
          controlProps.active = true;
        } else if (linear && activeStep > index) {
          controlProps.completed = true;
        } else if (linear && activeStep < index) {
          controlProps.disabled = true;
        }

        if (index + 1 === numChildren) {
          controlProps.last = true;
        }

        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
      });

      return _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        steps
      );
    }
  }]);
  return Stepper;
}(_react.Component);

Stepper.defaultProps = {
  connector: _react2.default.createElement(_StepConnector2.default, null),
  orientation: 'horizontal',
  linear: true
};
Stepper.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
Stepper.childContextTypes = { stepper: _propTypes2.default.object };
Stepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index). This will enable `Step` control helpers.
   */
  activeStep: _propTypes2.default.number,
  /**
   * Should be two or more `<Step />` components.
   */
  children: _propTypes2.default.node,
  /**
   * A component to be placed between each step.
   */
  connector: _propTypes2.default.node,
  /**
   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
   */
  linear: _propTypes2.default.bool,
  /**
   * The stepper orientation (layout flow direction)
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  /**
   * Override the inline-style of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Stepper;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlainStepConnector = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * Override the inline-style of the root element.
   */
  style: _propTypes2.default.object
};

var contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired,
  stepper: _propTypes2.default.object
};

var StepConnector = function StepConnector(props, context) {
  var muiTheme = context.muiTheme,
      stepper = context.stepper;


  var styles = {
    wrapper: {
      flex: '1 1 auto'
    },
    line: {
      display: 'block',
      borderColor: muiTheme.stepper.connectorLineColor
    }
  };

  /**
   * Clean up once we can use CSS pseudo elements
   */
  if (stepper.orientation === 'horizontal') {
    styles.line.marginLeft = -6;
    styles.line.borderTopStyle = 'solid';
    styles.line.borderTopWidth = 1;
  } else if (stepper.orientation === 'vertical') {
    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
    styles.line.borderLeftStyle = 'solid';
    styles.line.borderLeftWidth = 1;
    styles.line.minHeight = 28;
  }

  var prepareStyles = muiTheme.prepareStyles;


  return _react2.default.createElement(
    'div',
    { style: prepareStyles(styles.wrapper) },
    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
  );
};

StepConnector.propTypes =  false ? propTypes : {};
StepConnector.contextTypes = contextTypes;

exports.PlainStepConnector = StepConnector;
exports.default = (0, _pure2.default)(StepConnector);

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _ClickAwayListener = __webpack_require__(503);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _SnackbarBody = __webpack_require__(1845);

var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var _context$muiTheme = context.muiTheme,
      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
      zIndex = _context$muiTheme.zIndex;
  var open = state.open;


  var styles = {
    root: {
      position: 'fixed',
      left: '50%',
      display: 'flex',
      bottom: 0,
      zIndex: zIndex.snackbar,
      visibility: open ? 'visible' : 'hidden',
      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
    }
  };

  return styles;
}

var Snackbar = function (_Component) {
  (0, _inherits3.default)(Snackbar, _Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
      if (_this.timerTransitionId) {
        // If transitioning, don't close the snackbar.
        return;
      }

      if (_this.props.open !== null && _this.props.onRequestClose) {
        _this.props.onRequestClose(Snackbar.reasons.CLICKAWAY);
      } else {
        _this.setState({ open: false });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Snackbar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open,
        message: this.props.message,
        action: this.props.action
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.open) {
        this.setAutoHideTimer();
        this.setTransitionTimer();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
        this.setState({
          open: false
        });

        clearTimeout(this.timerOneAtTheTimeId);
        this.timerOneAtTheTimeId = setTimeout(function () {
          _this2.setState({
            message: nextProps.message,
            action: nextProps.action,
            open: true
          });
        }, 400);
      } else {
        var open = nextProps.open;

        this.setState({
          open: open !== null ? open : this.state.open,
          message: nextProps.message,
          action: nextProps.action
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.open !== this.state.open) {
        if (this.state.open) {
          this.setAutoHideTimer();
          this.setTransitionTimer();
        } else {
          clearTimeout(this.timerAutoHideId);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHideId);
      clearTimeout(this.timerTransitionId);
      clearTimeout(this.timerOneAtTheTimeId);
    }
  }, {
    key: 'setAutoHideTimer',


    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer() {
      var _this3 = this;

      var autoHideDuration = this.props.autoHideDuration;

      if (autoHideDuration > 0) {
        clearTimeout(this.timerAutoHideId);
        this.timerAutoHideId = setTimeout(function () {
          if (_this3.props.open !== null && _this3.props.onRequestClose) {
            _this3.props.onRequestClose(Snackbar.reasons.TIMEOUT);
          } else {
            _this3.setState({ open: false });
          }
        }, autoHideDuration);
      }
    }

    // Timer that controls delay before click-away events are captured (based on when animation completes)

  }, {
    key: 'setTransitionTimer',
    value: function setTransitionTimer() {
      var _this4 = this;

      this.timerTransitionId = setTimeout(function () {
        _this4.timerTransitionId = undefined;
      }, 400);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoHideDuration = _props.autoHideDuration,
          contentStyle = _props.contentStyle,
          bodyStyle = _props.bodyStyle,
          messageProp = _props.message,
          onRequestClose = _props.onRequestClose,
          onActionClick = _props.onActionClick,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionClick', 'style']);
      var _state = this.state,
          action = _state.action,
          message = _state.message,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: open ? this.componentClickAway : null },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
          _react2.default.createElement(_SnackbarBody2.default, {
            action: action,
            contentStyle: contentStyle,
            message: message,
            open: open,
            onActionClick: onActionClick,
            style: bodyStyle
          })
        )
      );
    }
  }]);
  return Snackbar;
}(_react.Component);

Snackbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Snackbar.reasons = {
  CLICKAWAY: 'clickaway',
  TIMEOUT: 'timeout'
};
Snackbar.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * The number of milliseconds to wait before automatically dismissing.
   * If no value is specified the snackbar will dismiss normally.
   * If a value is provided the snackbar can still be dismissed normally.
   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
   */
  autoHideDuration: _propTypes2.default.number,
  /**
   * Override the inline-styles of the body element.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _propTypes2.default.func,
  /**
   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
   * `autoHideDuration` timer expires.
   *
   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
   * `open` prop.
   *
   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
   * for example ignoring `clickaway`.
   *
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Snackbar;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarBody = undefined;

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _withWidth = __webpack_require__(1846);

var _withWidth2 = _interopRequireDefault(_withWidth);

var _FlatButton = __webpack_require__(34);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var open = props.open,
      width = props.width;
  var _context$muiTheme = context.muiTheme,
      _context$muiTheme$bas = _context$muiTheme.baseTheme,
      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
      desktopGutter = _context$muiTheme$bas2.desktopGutter,
      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
      fontFamily = _context$muiTheme$bas.fontFamily,
      _context$muiTheme$sna = _context$muiTheme.snackbar,
      backgroundColor = _context$muiTheme$sna.backgroundColor,
      textColor = _context$muiTheme$sna.textColor,
      actionColor = _context$muiTheme$sna.actionColor,
      borderRadius = _context$muiTheme.borderRadius;


  var isSmall = width === _withWidth.SMALL;

  var styles = {
    root: {
      fontFamily: fontFamily,
      backgroundColor: backgroundColor,
      padding: '0 ' + desktopGutter + 'px',
      height: desktopSubheaderHeight,
      lineHeight: desktopSubheaderHeight + 'px',
      borderRadius: isSmall ? 0 : borderRadius,
      maxWidth: isSmall ? 'inherit' : 568,
      minWidth: isSmall ? 'inherit' : 288,
      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
      flexGrow: isSmall ? 1 : 0
    },
    content: {
      fontSize: 14,
      color: textColor,
      opacity: open ? 1 : 0,
      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
    },
    action: {
      color: actionColor,
      float: 'right',
      marginTop: 6,
      marginRight: -16,
      marginLeft: desktopGutter,
      backgroundColor: 'transparent'
    }
  };

  return styles;
}

var SnackbarBody = function SnackbarBody(props, context) {
  var action = props.action,
      contentStyle = props.contentStyle,
      message = props.message,
      open = props.open,
      onActionClick = props.onActionClick,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionClick', 'style']);
  var prepareStyles = context.muiTheme.prepareStyles;

  var styles = getStyles(props, context);

  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
    style: styles.action,
    label: action,
    onClick: onActionClick
  });

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
    _react2.default.createElement(
      'div',
      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
      _react2.default.createElement(
        'span',
        null,
        message
      ),
      actionButton
    )
  );
};

exports.SnackbarBody = SnackbarBody;
SnackbarBody.propTypes =  false ? {
  /**
   * The label for the action on the snackbar.
   */
  action: _propTypes2.default.node,
  /**
   * Override the inline-styles of the content element.
   */
  contentStyle: _propTypes2.default.object,
  /**
   * The message to be displayed.
   *
   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
   * showing again)
   */
  message: _propTypes2.default.node.isRequired,
  /**
   * Fired when the action button is clicked.
   *
   * @param {object} event Action button event.
   */
  onActionClick: _propTypes2.default.func,
  /**
   * @ignore
   * Controls whether the `Snackbar` is opened or not.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   * Width of the screen.
   */
  width: _propTypes2.default.number.isRequired
} : {};

SnackbarBody.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withWidth;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SMALL = exports.SMALL = 1;
var MEDIUM = exports.MEDIUM = 2;
var LARGE = exports.LARGE = 3;

function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$largeWidth = options.largeWidth,
      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
      _options$mediumWidth = options.mediumWidth,
      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
      _options$resizeInterv = options.resizeInterval,
      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;


  return function (MyComponent) {
    return function (_Component) {
      (0, _inherits3.default)(WithWidth, _Component);

      function WithWidth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithWidth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          width: null
        }, _this.handleResize = function () {
          clearTimeout(_this.deferTimer);
          _this.deferTimer = setTimeout(function () {
            _this.updateWidth();
          }, resizeInterval);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithWidth, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateWidth();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.deferTimer);
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth() {
          var innerWidth = window.innerWidth;
          var width = void 0;

          if (innerWidth >= largeWidth) {
            width = LARGE;
          } else if (innerWidth >= mediumWidth) {
            width = MEDIUM;
          } else {
            // innerWidth < 768
            width = SMALL;
          }

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var width = this.state.width;

          /**
           * When rendering the component on the server,
           * we have no idea about the screen width.
           * In order to prevent blinks and help the reconciliation
           * we are not rendering the component.
           *
           * A better alternative would be to send client hints.
           * But the browser support of this API is low:
           * http://caniuse.com/#search=client%20hint
           */
          if (width === null) {
            return null;
          }

          return _react2.default.createElement(
            _reactEventListener2.default,
            { target: 'window', onResize: this.handleResize },
            _react2.default.createElement(MyComponent, (0, _extends3.default)({
              width: width
            }, this.props))
          );
        }
      }]);
      return WithWidth;
    }(_react.Component);
  };
}

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

var _TabTemplate = __webpack_require__(1848);

var _TabTemplate2 = _interopRequireDefault(_TabTemplate);

var _InkBar = __webpack_require__(1849);

var _InkBar2 = _interopRequireDefault(_InkBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var tabs = context.muiTheme.tabs;


  return {
    tabItemContainer: {
      width: '100%',
      backgroundColor: tabs.backgroundColor,
      whiteSpace: 'nowrap',
      display: 'flex'
    }
  };
}

var Tabs = function (_Component) {
  (0, _inherits3.default)(Tabs, _Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabClick = function (value, event, tab) {
      var valueLink = _this.getValueLink(_this.props);
      var index = tab.props.index;

      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
        valueLink.requestChange(value, event, tab);
      }

      _this.setState({ selectedIndex: index });

      if (tab.props.onActive) {
        tab.props.onActive(tab);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var valueLink = this.getValueLink(this.props);
      var initialIndex = this.props.initialSelectedIndex;

      this.setState({
        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps, nextContext) {
      var valueLink = this.getValueLink(newProps);
      var newState = {
        muiTheme: nextContext.muiTheme || this.context.muiTheme
      };

      if (valueLink.value !== undefined) {
        newState.selectedIndex = this.getSelectedIndex(newProps);
      }

      this.setState(newState);
    }
  }, {
    key: 'getTabs',
    value: function getTabs() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var tabs = [];

      _react.Children.forEach(props.children, function (tab) {
        if ((0, _react.isValidElement)(tab)) {
          tabs.push(tab);
        }
      });

      return tabs;
    }
  }, {
    key: 'getTabCount',
    value: function getTabCount() {
      return this.getTabs().length;
    }

    // Do not use outside of this component, it will be removed once valueLink is deprecated

  }, {
    key: 'getValueLink',
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'getSelectedIndex',
    value: function getSelectedIndex(props) {
      var valueLink = this.getValueLink(props);
      var selectedIndex = -1;

      this.getTabs(props).forEach(function (tab, index) {
        if (valueLink.value === tab.props.value) {
          selectedIndex = index;
        }
      });

      return selectedIndex;
    }
  }, {
    key: 'getSelected',
    value: function getSelected(tab, index) {
      var valueLink = this.getValueLink(this.props);
      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          contentContainerClassName = _props.contentContainerClassName,
          contentContainerStyle = _props.contentContainerStyle,
          initialSelectedIndex = _props.initialSelectedIndex,
          inkBarStyle = _props.inkBarStyle,
          inkBarContainerStyle = _props.inkBarContainerStyle,
          onChange = _props.onChange,
          style = _props.style,
          tabItemContainerStyle = _props.tabItemContainerStyle,
          tabTemplate = _props.tabTemplate,
          tabTemplateStyle = _props.tabTemplateStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'inkBarContainerStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var valueLink = this.getValueLink(this.props);
      var tabValue = valueLink.value;
      var tabContent = [];
      var width = 100 / this.getTabCount();

      var tabs = this.getTabs().map(function (tab, index) {
         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;

         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;

        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
          key: index,
          selected: _this2.getSelected(tab, index),
          style: tabTemplateStyle
        }, tab.props.children) : undefined);

        return (0, _react.cloneElement)(tab, {
          key: index,
          index: index,
          selected: _this2.getSelected(tab, index),
          width: width + '%',
          onClick: _this2.handleTabClick
        });
      });

      var realSelectedIndex = valueLink.value ? this.getSelectedIndex(this.props) : this.state.selectedIndex;

      var inkBar = realSelectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
        left: width * realSelectedIndex + '%',
        width: width + '%',
        style: inkBarStyle
      }) : null;

      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
          tabs
        ),
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)({ width: inkBarContainerWidth }, inkBarContainerStyle)) },
          inkBar
        ),
        _react2.default.createElement(
          'div',
          {
            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
            className: contentContainerClassName
          },
          tabContent
        )
      );
    }
  }]);
  return Tabs;
}(_react.Component);

Tabs.defaultProps = {
  initialSelectedIndex: 0,
  onChange: function onChange() {}
};
Tabs.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tabs.propTypes =  false ? {
  /**
   * Should be used to pass `Tab` components.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The css class name of the content's container.
   */
  contentContainerClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the content's container.
   */
  contentContainerStyle: _propTypes2.default.object,
  /**
   * Specify initial visible tab index.
   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
   * `initialSelectedIndex` will revert back to default.
   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
   */
  initialSelectedIndex: _propTypes2.default.number,
  /**
   * Override the inline-styles of the InkBar.
   */
  inkBarStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the InkBar container.
   */
  inkBarContainerStyle: _propTypes2.default.object,
  /**
   * Called when the selected value change.
   */
  onChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the tab-labels container.
   */
  tabItemContainerStyle: _propTypes2.default.object,
  /**
   * Override the default tab template used to wrap the content of each tab element.
   */
  tabTemplate: _propTypes2.default.func,
  /**
   * Override the inline-styles of the tab template.
   */
  tabTemplateStyle: _propTypes2.default.object,
  /**
   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
   */
  value: _propTypes2.default.any
} : {};
exports.default = Tabs;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  width: '100%',
  position: 'relative',
  textAlign: 'initial'
};

var TabTemplate = function TabTemplate(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      style = _ref.style;

  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
  if (!selected) {
    templateStyle.height = 0;
    templateStyle.overflow = 'hidden';
  }

  return _react2.default.createElement(
    'div',
    { style: templateStyle },
    children
  );
};

TabTemplate.propTypes =  false ? {
  children: _propTypes2.default.node,
  selected: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};

exports.default = TabTemplate;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      inkBar = _context$muiTheme.inkBar,
      isRtl = _context$muiTheme.isRtl;


  return {
    root: {
      left: props.left,
      width: props.width,
      bottom: 0,
      display: 'block',
      backgroundColor: props.color || inkBar.backgroundColor,
      height: 2,
      marginTop: -2,
      position: 'relative',
      transition: _transitions2.default.easeOut('1s', isRtl ? 'right' : 'left')
    }
  };
}

var InkBar = function (_Component) {
  (0, _inherits3.default)(InkBar, _Component);

  function InkBar() {
    (0, _classCallCheck3.default)(this, InkBar);
    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(InkBar, [{
    key: 'render',
    value: function render() {
      var style = this.props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
    }
  }]);
  return InkBar;
}(_react.Component);

InkBar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
InkBar.propTypes =  false ? {
  color: _propTypes2.default.string,
  left: _propTypes2.default.string.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  width: _propTypes2.default.string.isRequired
} : {};
exports.default = InkBar;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(56);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      table = _context$muiTheme.table;


  return {
    root: {
      backgroundColor: table.backgroundColor,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      tableLayout: 'fixed',
      fontFamily: baseTheme.fontFamily
    },
    bodyTable: {
      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
      overflowX: 'hidden',
      overflowY: 'auto'
    },
    tableWrapper: {
      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
      overflow: 'auto'
    }
  };
}

var Table = function (_Component) {
  (0, _inherits3.default)(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      allRowsSelected: false
    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
    }, _this.onRowHover = function (rowNumber) {
      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
    }, _this.onRowHoverExit = function (rowNumber) {
      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
    }, _this.onRowSelection = function (selectedRows) {
      if (_this.state.allRowsSelected) {
        _this.setState({ allRowsSelected: false });
      }

      if (_this.props.onRowSelection) {
        _this.props.onRowSelection(selectedRows);
      }
    }, _this.onSelectAll = function () {
      if (_this.props.onRowSelection) {
        if (!_this.state.allRowsSelected) {
          _this.props.onRowSelection('all');
        } else {
          _this.props.onRowSelection('none');
        }
      }

      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Table, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.allRowsSelected) {
        this.setState({ allRowsSelected: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
        this.setState({ allRowsSelected: nextProps.allRowsSelected });
      }
    }
  }, {
    key: 'isScrollbarVisible',
    value: function isScrollbarVisible() {
      var tableDivHeight = this.refs.tableDiv.clientHeight;
      var tableBodyHeight = this.refs.tableBody.clientHeight;

      return tableBodyHeight > tableDivHeight;
    }
  }, {
    key: 'createTableHeader',
    value: function createTableHeader(base) {
      return _react2.default.cloneElement(base, {
        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
        onSelectAll: this.onSelectAll,
        selectAllSelected: this.state.allRowsSelected
      });
    }
  }, {
    key: 'createTableBody',
    value: function createTableBody(base) {
      return _react2.default.cloneElement(base, {
        allRowsSelected: this.state.allRowsSelected,
        multiSelectable: this.props.multiSelectable,
        onCellClick: this.onCellClick,
        onCellHover: this.onCellHover,
        onCellHoverExit: this.onCellHoverExit,
        onRowHover: this.onRowHover,
        onRowHoverExit: this.onRowHoverExit,
        onRowSelection: this.onRowSelection,
        selectable: this.props.selectable
      });
    }
  }, {
    key: 'createTableFooter',
    value: function createTableFooter(base) {
      return base;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          fixedFooter = _props.fixedFooter,
          fixedHeader = _props.fixedHeader,
          style = _props.style,
          wrapperStyle = _props.wrapperStyle,
          headerStyle = _props.headerStyle,
          bodyStyle = _props.bodyStyle,
          footerStyle = _props.footerStyle;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var tHead = void 0;
      var tFoot = void 0;
      var tBody = void 0;

      _react2.default.Children.forEach(children, function (child) {
        if (!_react2.default.isValidElement(child)) return;

        var muiName = child.type.muiName;

        if (muiName === 'TableBody') {
          tBody = _this2.createTableBody(child);
        } else if (muiName === 'TableHeader') {
          tHead = _this2.createTableHeader(child);
        } else if (muiName === 'TableFooter') {
          tFoot = _this2.createTableFooter(child);
        } else {
           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
        }
      });

      // If we could not find a table-header and a table-body, do not attempt to display anything.
      if (!tBody && !tHead) return null;

      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
      var headerTable = void 0;
      var footerTable = void 0;
      var inlineHeader = void 0;
      var inlineFooter = void 0;

      if (fixedHeader) {
        headerTable = _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
          _react2.default.createElement(
            'table',
            { className: className, style: mergedTableStyle },
            tHead
          )
        );
      } else {
        inlineHeader = tHead;
      }

      if (tFoot !== undefined) {
        if (fixedFooter) {
          footerTable = _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
            _react2.default.createElement(
              'table',
              { className: className, style: prepareStyles(mergedTableStyle) },
              tFoot
            )
          );
        } else {
          inlineFooter = tFoot;
        }
      }

      return _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
        headerTable,
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
          _react2.default.createElement(
            'table',
            { className: className, style: mergedTableStyle, ref: 'tableBody' },
            inlineHeader,
            inlineFooter,
            tBody
          )
        ),
        footerTable
      );
    }
  }]);
  return Table;
}(_react.Component);

Table.defaultProps = {
  allRowsSelected: false,
  fixedFooter: true,
  fixedHeader: true,
  height: 'inherit',
  multiSelectable: false,
  selectable: true
};
Table.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Table.propTypes =  false ? {
  /**
   * Set to true to indicate that all rows should be selected.
   */
  allRowsSelected: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the body's table element.
   */
  bodyStyle: _propTypes2.default.object,
  /**
   * Children passed to table.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, the footer will appear fixed below the table.
   * The default value is true.
   */
  fixedFooter: _propTypes2.default.bool,
  /**
   * If true, the header will appear fixed above the table.
   * The default value is true.
   */
  fixedHeader: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the footer's table element.
   */
  footerStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the header's table element.
   */
  headerStyle: _propTypes2.default.object,
  /**
   * The height of the table.
   */
  height: _propTypes2.default.string,
  /**
   * If true, multiple table rows can be selected.
   * CTRL/CMD+Click and SHIFT+Click are valid actions.
   * The default value is false.
   */
  multiSelectable: _propTypes2.default.bool,
  /**
   * Called when a row cell is clicked.
   * rowNumber is the row number and columnId is
   * the column number or the column key.
   */
  onCellClick: _propTypes2.default.func,
  /**
   * Called when a table cell is hovered.
   * rowNumber is the row number of the hovered row
   * and columnId is the column number or the column key of the cell.
   */
  onCellHover: _propTypes2.default.func,
  /**
   * Called when a table cell is no longer hovered.
   * rowNumber is the row number of the row and columnId
   * is the column number or the column key of the cell.
   */
  onCellHoverExit: _propTypes2.default.func,
  /**
   * Called when a table row is hovered.
   * rowNumber is the row number of the hovered row.
   */
  onRowHover: _propTypes2.default.func,
  /**
   * Called when a table row is no longer hovered.
   * rowNumber is the row number of the row that is no longer hovered.
   */
  onRowHoverExit: _propTypes2.default.func,
  /**
   * Called when a row is selected.
   * selectedRows is an array of all row selections.
   * IF all rows have been selected, the string "all"
   * will be returned instead to indicate that all rows have been selected.
   */
  onRowSelection: _propTypes2.default.func,
  /**
   * If true, table rows can be selected.
   * If multiple row selection is desired, enable multiSelectable.
   * The default value is true.
   */
  selectable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of the table's wrapper element.
   */
  wrapperStyle: _propTypes2.default.object
} : {};
exports.default = Table;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TimePickerDialog = __webpack_require__(1852);

var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);

var _TextField = __webpack_require__(23);

var _TextField2 = _interopRequireDefault(_TextField);

var _timeUtils = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyTime = new Date();
emptyTime.setHours(0);
emptyTime.setMinutes(0);
emptyTime.setSeconds(0);
emptyTime.setMilliseconds(0);

var TimePicker = function (_Component) {
  (0, _inherits3.default)(TimePicker, _Component);

  function TimePicker() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TimePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      time: null,
      dialogTime: new Date()
    }, _this.handleAcceptDialog = function (time) {
      _this.setState({
        time: time
      });
      if (_this.props.onChange) _this.props.onChange(null, time);
    }, _this.handleFocusInput = function (event) {
      event.target.blur();
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleClickInput = function (event) {
      event.preventDefault();

      if (!_this.props.disabled) {
        _this.openDialog();
      }

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TimePicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          time: this.getControlledTime(nextProps)
        });
      }
    }

    /**
     * Alias for `openDialog()` for an api consistent with TextField.
     */

  }, {
    key: 'focus',
    value: function focus() {
      this.openDialog();
    }
  }, {
    key: 'openDialog',
    value: function openDialog() {
      this.setState({
        dialogTime: this.state.time
      });
      this.refs.dialogWindow.show();
    }
  }, {
    key: 'isControlled',
    value: function isControlled() {
      return this.props.value !== null;
    }
  }, {
    key: 'getControlledTime',
    value: function getControlledTime() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      var result = null;
      if (props.value instanceof Date) {
        result = props.value;
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoOk = _props.autoOk,
          cancelLabel = _props.cancelLabel,
          defaultTime = _props.defaultTime,
          dialogBodyStyle = _props.dialogBodyStyle,
          dialogStyle = _props.dialogStyle,
          format = _props.format,
          okLabel = _props.okLabel,
          onFocus = _props.onFocus,
          onClick = _props.onClick,
          onShow = _props.onShow,
          onDismiss = _props.onDismiss,
          pedantic = _props.pedantic,
          style = _props.style,
          textFieldStyle = _props.textFieldStyle,
          minutesStep = _props.minutesStep,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onClick', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle', 'minutesStep']);
      var prepareStyles = this.context.muiTheme.prepareStyles;
      var time = this.state.time;


      return _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
          style: textFieldStyle,
          ref: 'input',
          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
          onFocus: this.handleFocusInput,
          onClick: this.handleClickInput
        })),
        _react2.default.createElement(_TimePickerDialog2.default, {
          ref: 'dialogWindow',
          bodyStyle: dialogBodyStyle,
          initialTime: this.state.dialogTime,
          onAccept: this.handleAcceptDialog,
          onShow: onShow,
          onDismiss: onDismiss,
          format: format,
          okLabel: okLabel,
          cancelLabel: cancelLabel,
          autoOk: autoOk,
          style: dialogStyle,
          minutesStep: minutesStep
        })
      );
    }
  }]);
  return TimePicker;
}(_react.Component);

TimePicker.defaultProps = {
  autoOk: false,
  cancelLabel: 'Cancel',
  defaultTime: null,
  disabled: false,
  format: 'ampm',
  okLabel: 'OK',
  pedantic: false,
  style: {},
  value: null,
  minutesStep: 1
};
TimePicker.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TimePicker.propTypes =  false ? {
  /**
   * If true, automatically accept and close the picker on set minutes.
   */
  autoOk: _propTypes2.default.bool,
  /**
   * Override the label of the 'Cancel' button.
   */
  cancelLabel: _propTypes2.default.node,
  /**
   * The initial time value of the TimePicker.
   */
  defaultTime: _propTypes2.default.object,
  /**
   * Override the inline-styles of TimePickerDialog's body element.
   */
  dialogBodyStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of TimePickerDialog's root element.
   */
  dialogStyle: _propTypes2.default.object,
  /**
   * If true, the TimePicker is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
   */
  format: _propTypes2.default.oneOf(['ampm', '24hr']),
  /**
   * How many minutes should be added/subtracted when moving the clock pointer.
   */
  minutesStep: _propTypes2.default.number,
  /**
   * Override the label of the 'OK' button.
   */
  okLabel: _propTypes2.default.node,
  /**
   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
   * Since there is no particular event associated with the change the first argument will always be null
   * and the second argument will be the new Date instance.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the TimePicker is tapped or clicked.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the TimePicker dialog is dismissed.
   */
  onDismiss: _propTypes2.default.func,
  /**
   * Callback function fired when the TimePicker `TextField` gains focus.
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function fired when the TimePicker dialog is shown.
   */
  onShow: _propTypes2.default.func,
  /**
   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
   *
   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
   * ("12 a.m." / "12 p.m.").
   */
  pedantic: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override the inline-styles of TimePicker's TextField element.
   */
  textFieldStyle: _propTypes2.default.object,
  /**
   * Sets the time for the Time Picker programmatically.
   */
  value: _propTypes2.default.object
} : {};
exports.default = TimePicker;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(137);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _keycode = __webpack_require__(101);

var _keycode2 = _interopRequireDefault(_keycode);

var _Clock = __webpack_require__(1853);

var _Clock2 = _interopRequireDefault(_Clock);

var _Dialog = __webpack_require__(36);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _FlatButton = __webpack_require__(34);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimePickerDialog = function (_Component) {
  (0, _inherits3.default)(TimePickerDialog, _Component);

  function TimePickerDialog() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TimePickerDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.handleRequestClose = function () {
      _this.dismiss();
    }, _this.handleClickCancel = function () {
      _this.dismiss();
    }, _this.handleClickOK = function () {
      if (_this.props.onAccept) {
        _this.props.onAccept(_this.refs.clock.getSelectedTime());
      }
      _this.setState({
        open: false
      });
    }, _this.handleKeyUp = function (event) {
      switch ((0, _keycode2.default)(event)) {
        case 'enter':
          _this.handleClickOK();
          break;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TimePickerDialog, [{
    key: 'show',
    value: function show() {
      if (this.props.onShow && !this.state.open) this.props.onShow();
      this.setState({
        open: true
      });
    }
  }, {
    key: 'dismiss',
    value: function dismiss() {
      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
      this.setState({
        open: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bodyStyle = _props.bodyStyle,
          initialTime = _props.initialTime,
          onAccept = _props.onAccept,
          format = _props.format,
          autoOk = _props.autoOk,
          okLabel = _props.okLabel,
          cancelLabel = _props.cancelLabel,
          style = _props.style,
          minutesStep = _props.minutesStep,
          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style', 'minutesStep']);


      var styles = {
        root: {
          fontSize: 14,
          color: this.context.muiTheme.timePicker.clockColor
        },
        dialogContent: {
          width: 280
        },
        body: {
          padding: 0
        }
      };

      var actions = [_react2.default.createElement(_FlatButton2.default, {
        key: 0,
        label: cancelLabel,
        primary: true,
        onClick: this.handleClickCancel
      }), _react2.default.createElement(_FlatButton2.default, {
        key: 1,
        label: okLabel,
        primary: true,
        onClick: this.handleClickOK
      })];

      var onClockChangeMinutes = autoOk === true ? this.handleClickOK : undefined;
      var open = this.state.open;

      return _react2.default.createElement(
        _Dialog2.default,
        (0, _extends3.default)({}, other, {
          style: (0, _simpleAssign2.default)(styles.root, style),
          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
          actions: actions,
          contentStyle: styles.dialogContent,
          repositionOnUpdate: false,
          open: open,
          onRequestClose: this.handleRequestClose
        }),
        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
        open && _react2.default.createElement(_Clock2.default, {
          ref: 'clock',
          format: format,
          initialTime: initialTime,
          onChangeMinutes: onClockChangeMinutes,
          minutesStep: minutesStep
        })
      );
    }
  }]);
  return TimePickerDialog;
}(_react.Component);

TimePickerDialog.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel'
};
TimePickerDialog.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TimePickerDialog.propTypes =  false ? {
  autoOk: _propTypes2.default.bool,
  bodyStyle: _propTypes2.default.object,
  cancelLabel: _propTypes2.default.node,
  format: _propTypes2.default.oneOf(['ampm', '24hr']),
  initialTime: _propTypes2.default.object,
  minutesStep: _propTypes2.default.number,
  okLabel: _propTypes2.default.node,
  onAccept: _propTypes2.default.func,
  onDismiss: _propTypes2.default.func,
  onShow: _propTypes2.default.func,
  style: _propTypes2.default.object
} : {};
exports.default = TimePickerDialog;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TimeDisplay = __webpack_require__(1854);

var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);

var _ClockHours = __webpack_require__(1855);

var _ClockHours2 = _interopRequireDefault(_ClockHours);

var _ClockMinutes = __webpack_require__(1856);

var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Clock = function (_Component) {
  (0, _inherits3.default)(Clock, _Component);

  function Clock() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Clock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedTime: null,
      mode: 'hour'
    }, _this.setMode = function (mode) {
      setTimeout(function () {
        _this.setState({
          mode: mode
        });
      }, 100);
    }, _this.handleSelectAffix = function (affix) {
      if (affix === _this.getAffix()) return;

      var hours = _this.state.selectedTime.getHours();

      if (affix === 'am') {
        _this.handleChangeHours(hours - 12, affix);
        return;
      }

      _this.handleChangeHours(hours + 12, affix);
    }, _this.handleChangeHours = function (hours, finished) {
      var time = new Date(_this.state.selectedTime);
      var affix = void 0;

      if (typeof finished === 'string') {
        affix = finished;
        finished = undefined;
      }
      if (!affix) {
        affix = _this.getAffix();
      }
      if (affix === 'pm' && hours < 12) {
        hours += 12;
      }

      time.setHours(hours);
      _this.setState({
        selectedTime: time
      });

      if (finished) {
        setTimeout(function () {
          _this.setState({
            mode: 'minute'
          });

          var onChangeHours = _this.props.onChangeHours;

          if (onChangeHours) {
            onChangeHours(time);
          }
        }, 100);
      }
    }, _this.handleChangeMinutes = function (minutes, finished) {
      var time = new Date(_this.state.selectedTime);
      time.setMinutes(minutes);
      _this.setState({
        selectedTime: time
      });

      var onChangeMinutes = _this.props.onChangeMinutes;

      if (onChangeMinutes && finished) {
        setTimeout(function () {
          onChangeMinutes(time);
        }, 0);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Clock, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var selectedTime = this.props.initialTime || new Date();
      var minutes = selectedTime.getMinutes();
      selectedTime.setMinutes(minutes - minutes % this.props.minutesStep);

      this.setState({
        selectedTime: selectedTime
      });
    }
  }, {
    key: 'getAffix',
    value: function getAffix() {
      if (this.props.format !== 'ampm') return '';

      var hours = this.state.selectedTime.getHours();
      if (hours < 12) {
        return 'am';
      }

      return 'pm';
    }
  }, {
    key: 'getSelectedTime',
    value: function getSelectedTime() {
      return this.state.selectedTime;
    }
  }, {
    key: 'render',
    value: function render() {
      var clock = null;

      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          timePicker = _context$muiTheme.timePicker;


      var styles = {
        root: {
          userSelect: 'none'
        },
        container: {
          height: 280,
          padding: 10,
          position: 'relative',
          boxSizing: 'content-box'
        },
        circle: {
          position: 'absolute',
          top: 20,
          width: 260,
          height: 260,
          borderRadius: '100%',
          backgroundColor: timePicker.clockCircleColor
        }
      };

      if (this.state.mode === 'hour') {
        clock = _react2.default.createElement(_ClockHours2.default, {
          key: 'hours',
          format: this.props.format,
          onChange: this.handleChangeHours,
          initialHours: this.state.selectedTime.getHours()
        });
      } else {
        clock = _react2.default.createElement(_ClockMinutes2.default, {
          key: 'minutes',
          onChange: this.handleChangeMinutes,
          initialMinutes: this.state.selectedTime.getMinutes(),
          step: this.props.minutesStep
        });
      }

      return _react2.default.createElement(
        'div',
        { style: prepareStyles(styles.root) },
        _react2.default.createElement(_TimeDisplay2.default, {
          selectedTime: this.state.selectedTime,
          mode: this.state.mode,
          format: this.props.format,
          affix: this.getAffix(),
          onSelectAffix: this.handleSelectAffix,
          onSelectHour: this.setMode.bind(this, 'hour'),
          onSelectMin: this.setMode.bind(this, 'minute')
        }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.container) },
          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
          clock
        )
      );
    }
  }]);
  return Clock;
}(_react.Component);

Clock.defaultProps = {
  initialTime: new Date()
};
Clock.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Clock.propTypes =  false ? {
  format: _propTypes2.default.oneOf(['ampm', '24hr']),
  initialTime: _propTypes2.default.object,
  minutesStep: _propTypes2.default.number,
  onChangeHours: _propTypes2.default.func,
  onChangeMinutes: _propTypes2.default.func
} : {};
exports.default = Clock;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(510);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeDisplay = function (_Component) {
  (0, _inherits3.default)(TimeDisplay, _Component);

  function TimeDisplay() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TimeDisplay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      transitionDirection: 'up'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TimeDisplay, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedTime !== this.props.selectedTime) {
        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';

        this.setState({
          transitionDirection: direction
        });
      }
    }
  }, {
    key: 'sanitizeTime',
    value: function sanitizeTime() {
      var hour = this.props.selectedTime.getHours();
      var min = this.props.selectedTime.getMinutes().toString();

      if (this.props.format === 'ampm') {
        hour %= 12;
        hour = hour || 12;
      }

      hour = hour.toString();
      if (hour.length < 2) hour = '0' + hour;
      if (min.length < 2) min = '0' + min;

      return [hour, min];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          affix = _props.affix,
          format = _props.format,
          mode = _props.mode,
          onSelectAffix = _props.onSelectAffix,
          onSelectHour = _props.onSelectHour,
          onSelectMin = _props.onSelectMin,
          selectedTime = _props.selectedTime,
          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          timePicker = _context$muiTheme.timePicker;


      var styles = {
        root: {
          padding: '14px 0',
          borderTopLeftRadius: 2,
          borderTopRightRadius: 2,
          backgroundColor: timePicker.headerColor,
          color: timePicker.textColor
        },
        text: {
          margin: '6px 0',
          lineHeight: '58px',
          height: 58,
          fontSize: 58,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'baseline'
        },
        time: {
          margin: '0 10px'
        },
        affix: {
          flex: 1,
          position: 'relative',
          lineHeight: '17px',
          height: 17,
          fontSize: 17
        },
        affixTop: {
          position: 'absolute',
          top: -20,
          left: 0
        },
        clickable: {
          cursor: 'pointer'
        },
        inactive: {
          opacity: 0.7
        }
      };

      var _sanitizeTime = this.sanitizeTime(),
          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
          hour = _sanitizeTime2[0],
          min = _sanitizeTime2[1];

      var buttons = [];
      if (format === 'ampm') {
        buttons = [_react2.default.createElement(
          'div',
          {
            key: 'pm',
            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
            onClick: function onClick() {
              return onSelectAffix('pm');
            }
          },
          'PM'
        ), _react2.default.createElement(
          'div',
          {
            key: 'am',
            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
            onClick: function onClick() {
              return onSelectAffix('am');
            }
          },
          'AM'
        )];
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.text) },
          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
          _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.time) },
            _react2.default.createElement(
              'span',
              {
                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
                onClick: onSelectHour
              },
              hour
            ),
            _react2.default.createElement(
              'span',
              null,
              ':'
            ),
            _react2.default.createElement(
              'span',
              {
                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
                onClick: onSelectMin
              },
              min
            )
          ),
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
            buttons
          )
        )
      );
    }
  }]);
  return TimeDisplay;
}(_react.Component);

TimeDisplay.defaultProps = {
  affix: '',
  mode: 'hour'
};
TimeDisplay.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TimeDisplay.propTypes =  false ? {
  affix: _propTypes2.default.oneOf(['', 'pm', 'am']),
  format: _propTypes2.default.oneOf(['ampm', '24hr']),
  mode: _propTypes2.default.oneOf(['hour', 'minute']),
  onSelectAffix: _propTypes2.default.func,
  onSelectHour: _propTypes2.default.func,
  onSelectMin: _propTypes2.default.func,
  selectedTime: _propTypes2.default.object.isRequired
} : {};
exports.default = TimeDisplay;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(49);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ClockNumber = __webpack_require__(787);

var _ClockNumber2 = _interopRequireDefault(_ClockNumber);

var _ClockPointer = __webpack_require__(788);

var _ClockPointer2 = _interopRequireDefault(_ClockPointer);

var _timeUtils = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClockHours = function (_Component) {
  (0, _inherits3.default)(ClockHours, _Component);

  function ClockHours() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClockHours);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
      event.preventDefault();
      _this.setClock(event.nativeEvent, true);
    }, _this.handleMove = function (event) {
      event.preventDefault();
      if (_this.isMousePressed(event) !== 1) return;
      _this.setClock(event.nativeEvent, false);
    }, _this.handleTouchMove = function (event) {
      event.preventDefault();
      _this.setClock(event.changedTouches[0], false);
    }, _this.handleTouchEnd = function (event) {
      event.preventDefault();
      _this.setClock(event.changedTouches[0], true);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClockHours, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);

      this.center = {
        x: clockElement.offsetWidth / 2,
        y: clockElement.offsetHeight / 2
      };

      this.basePoint = {
        x: this.center.x,
        y: 0
      };
    }
  }, {
    key: 'isMousePressed',
    value: function isMousePressed(event) {
      if (typeof event.buttons === 'undefined') {
        return event.nativeEvent.which;
      }

      return event.buttons;
    }
  }, {
    key: 'setClock',
    value: function setClock(event, finish) {
      if (typeof event.offsetX === 'undefined') {
        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);

        event.offsetX = offset.offsetX;
        event.offsetY = offset.offsetY;
      }

      var hours = this.getHours(event.offsetX, event.offsetY);

      this.props.onChange(hours, finish);
    }
  }, {
    key: 'getHours',
    value: function getHours(offsetX, offsetY) {
      var step = 30;
      var x = offsetX - this.center.x;
      var y = offsetY - this.center.y;
      var cx = this.basePoint.x - this.center.x;
      var cy = this.basePoint.y - this.center.y;

      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);

      var deg = (0, _timeUtils.rad2deg)(atan);
      deg = Math.round(deg / step) * step;
      deg %= 360;

      var value = Math.floor(deg / step) || 0;

      var delta = Math.pow(x, 2) + Math.pow(y, 2);
      var distance = Math.sqrt(delta);

      value = value || 12;
      if (this.props.format === '24hr') {
        if (distance < 90) {
          value += 12;
          value %= 24;
        }
      } else {
        value %= 12;
      }

      return value;
    }
  }, {
    key: 'getSelected',
    value: function getSelected() {
      var hour = this.props.initialHours;

      if (this.props.format === 'ampm') {
        hour %= 12;
        hour = hour || 12;
      }

      return hour;
    }
  }, {
    key: 'getHourNumbers',
    value: function getHourNumbers() {
      var _this2 = this;

      var style = {
        pointerEvents: 'none'
      };
      var hourSize = this.props.format === 'ampm' ? 12 : 24;

      var hours = [];
      for (var i = 1; i <= hourSize; i++) {
        hours.push(i % 24);
      }

      return hours.map(function (hour) {
        var isSelected = _this2.getSelected() === hour;
        return _react2.default.createElement(_ClockNumber2.default, {
          key: hour,
          style: style,
          isSelected: isSelected,
          type: 'hour',
          value: hour
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = {
        root: {
          height: '100%',
          width: '100%',
          borderRadius: '100%',
          position: 'relative',
          pointerEvents: 'none',
          boxSizing: 'border-box'
        },

        hitMask: {
          height: '100%',
          width: '100%',
          pointerEvents: 'auto'
        }
      };

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var hours = this.getSelected();
      var numbers = this.getHourNumbers();

      return _react2.default.createElement(
        'div',
        { ref: 'clock', style: prepareStyles(styles.root) },
        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
        numbers,
        _react2.default.createElement('div', {
          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
        })
      );
    }
  }]);
  return ClockHours;
}(_react.Component);

ClockHours.defaultProps = {
  initialHours: new Date().getHours(),
  onChange: function onChange() {},
  format: 'ampm'
};
ClockHours.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ClockHours.propTypes =  false ? {
  format: _propTypes2.default.oneOf(['ampm', '24hr']),
  initialHours: _propTypes2.default.number,
  onChange: _propTypes2.default.func
} : {};
exports.default = ClockHours;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClockNumber = __webpack_require__(787);

var _ClockNumber2 = _interopRequireDefault(_ClockNumber);

var _ClockPointer = __webpack_require__(788);

var _ClockPointer2 = _interopRequireDefault(_ClockPointer);

var _timeUtils = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClockMinutes = function (_Component) {
  (0, _inherits3.default)(ClockMinutes, _Component);

  function ClockMinutes() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClockMinutes);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
      event.preventDefault();
      _this.setClock(event.nativeEvent, true);
    }, _this.handleMove = function (event) {
      event.preventDefault();
      if (_this.isMousePressed(event) !== 1) {
        return;
      }
      _this.setClock(event.nativeEvent, false);
    }, _this.handleTouch = function (event) {
      event.preventDefault();
      _this.setClock(event.changedTouches[0], event.type === 'touchend');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClockMinutes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var clockElement = this.refs.mask;

      this.center = {
        x: clockElement.offsetWidth / 2,
        y: clockElement.offsetHeight / 2
      };

      this.basePoint = {
        x: this.center.x,
        y: 0
      };
    }
  }, {
    key: 'isMousePressed',
    value: function isMousePressed(event) {
      if (typeof event.buttons === 'undefined') {
        return event.nativeEvent.which;
      }
      return event.buttons;
    }
  }, {
    key: 'setClock',
    value: function setClock(event, finish) {
      if (typeof event.offsetX === 'undefined') {
        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);

        event.offsetX = offset.offsetX;
        event.offsetY = offset.offsetY;
      }

      var minutes = this.getMinutes(event.offsetX, event.offsetY);

      this.props.onChange(minutes, finish);
    }
  }, {
    key: 'getMinutes',
    value: function getMinutes(offsetX, offsetY) {
      var step = 6 * this.props.step;
      var x = offsetX - this.center.x;
      var y = offsetY - this.center.y;
      var cx = this.basePoint.x - this.center.x;
      var cy = this.basePoint.y - this.center.y;

      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);

      var deg = (0, _timeUtils.rad2deg)(atan);
      deg = Math.round(deg / step) * step;
      deg %= 360;

      var value = Math.floor(deg / step) || 0;

      return value * this.props.step;
    }
  }, {
    key: 'getMinuteNumbers',
    value: function getMinuteNumbers() {
      var minutes = [];
      for (var i = 0; i < 12; i++) {
        minutes.push(i * 5);
      }
      var selectedMinutes = this.props.initialMinutes;
      var hasSelected = false;

      var numbers = minutes.map(function (minute) {
        var isSelected = selectedMinutes === minute;
        if (isSelected) {
          hasSelected = true;
        }
        return _react2.default.createElement(_ClockNumber2.default, {
          key: minute,
          isSelected: isSelected,
          type: 'minute',
          value: minute
        });
      });

      return {
        numbers: numbers,
        hasSelected: hasSelected,
        selected: selectedMinutes
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = {
        root: {
          height: '100%',
          width: '100%',
          borderRadius: '100%',
          position: 'relative',
          pointerEvents: 'none',
          boxSizing: 'border-box'
        },

        hitMask: {
          height: '100%',
          width: '100%',
          pointerEvents: 'auto'
        }
      };

      var prepareStyles = this.context.muiTheme.prepareStyles;

      var minutes = this.getMinuteNumbers();

      return _react2.default.createElement(
        'div',
        { ref: 'clock', style: prepareStyles(styles.root) },
        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
        minutes.numbers,
        _react2.default.createElement('div', {
          ref: 'mask',
          style: prepareStyles(styles.hitMask),
          onTouchMove: this.handleTouch,
          onTouchEnd: this.handleTouch,
          onMouseUp: this.handleUp,
          onMouseMove: this.handleMove
        })
      );
    }
  }]);
  return ClockMinutes;
}(_react.Component);

ClockMinutes.defaultProps = {
  initialMinutes: new Date().getMinutes(),
  onChange: function onChange() {},
  step: 1
};
ClockMinutes.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ClockMinutes.propTypes =  false ? {
  initialMinutes: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  step: _propTypes2.default.number
} : {};
exports.default = ClockMinutes;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(39);

var _transitions2 = _interopRequireDefault(_transitions);

var _Paper = __webpack_require__(78);

var _Paper2 = _interopRequireDefault(_Paper);

var _EnhancedSwitch = __webpack_require__(507);

var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var disabled = props.disabled,
      elementStyle = props.elementStyle,
      trackSwitchedStyle = props.trackSwitchedStyle,
      thumbSwitchedStyle = props.thumbSwitchedStyle,
      trackStyle = props.trackStyle,
      thumbStyle = props.thumbStyle,
      iconStyle = props.iconStyle,
      rippleStyle = props.rippleStyle,
      labelStyle = props.labelStyle;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toggle = _context$muiTheme.toggle;


  var toggleSize = 20;
  var toggleTrackWidth = 36;
  var styles = {
    icon: {
      width: 36,
      padding: '4px 0px 6px 2px'
    },
    ripple: {
      top: -10,
      left: -10,
      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
    },
    toggleElement: {
      width: toggleTrackWidth
    },
    track: {
      transition: _transitions2.default.easeOut(),
      width: '100%',
      height: 14,
      borderRadius: 30,
      backgroundColor: toggle.trackOffColor
    },
    thumb: {
      transition: _transitions2.default.easeOut(),
      position: 'absolute',
      top: 1,
      left: 0,
      width: toggleSize,
      height: toggleSize,
      lineHeight: '24px',
      borderRadius: '50%',
      backgroundColor: toggle.thumbOffColor
    },
    trackWhenSwitched: {
      backgroundColor: toggle.trackOnColor
    },
    thumbWhenSwitched: {
      backgroundColor: toggle.thumbOnColor,
      left: '100%'
    },
    trackWhenDisabled: {
      backgroundColor: toggle.trackDisabledColor
    },
    thumbWhenDisabled: {
      backgroundColor: toggle.thumbDisabledColor
    },
    label: {
      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
    }
  };

  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);

  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);

  if (state.switched) {
    styles.thumb.marginLeft = 0 - styles.thumb.width;
  }

  (0, _simpleAssign2.default)(styles.icon, iconStyle);

  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);

  (0, _simpleAssign2.default)(styles.label, labelStyle);

  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);

  return styles;
}

var Toggle = function (_Component) {
  (0, _inherits3.default)(Toggle, _Component);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      switched: false
    }, _this.handleStateChange = function (newSwitched) {
      _this.setState({
        switched: newSwitched
      });
    }, _this.handleToggle = function (event, isInputChecked) {
      if (_this.props.onToggle) {
        _this.props.onToggle(event, isInputChecked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Toggle, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          toggled = _props.toggled,
          defaultToggled = _props.defaultToggled,
          valueLink = _props.valueLink;


      if (toggled || defaultToggled || valueLink && valueLink.value) {
        this.setState({
          switched: true
        });
      }
    }
  }, {
    key: 'isToggled',
    value: function isToggled() {
      return this.refs.enhancedSwitch.isSwitched();
    }
  }, {
    key: 'setToggled',
    value: function setToggled(newToggledValue) {
      this.refs.enhancedSwitch.setSwitched(newToggledValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          defaultToggled = _props2.defaultToggled,
          elementStyle = _props2.elementStyle,
          onToggle = _props2.onToggle,
          trackSwitchedStyle = _props2.trackSwitchedStyle,
          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
          toggled = _props2.toggled,
          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      var toggleElement = _react2.default.createElement(
        'div',
        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
      );

      var enhancedSwitchProps = {
        ref: 'enhancedSwitch',
        inputType: 'checkbox',
        switchElement: toggleElement,
        rippleStyle: styles.ripple,
        rippleColor: styles.ripple.color,
        iconStyle: styles.icon,
        trackStyle: styles.track,
        thumbStyle: styles.thumb,
        labelStyle: styles.label,
        switched: this.state.switched,
        onSwitch: this.handleToggle,
        onParentShouldUpdate: this.handleStateChange,
        labelPosition: this.props.labelPosition
      };

      if (this.props.hasOwnProperty('toggled')) {
        enhancedSwitchProps.checked = toggled;
      } else if (this.props.hasOwnProperty('defaultToggled')) {
        enhancedSwitchProps.defaultChecked = defaultToggled;
      }

      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
    }
  }]);
  return Toggle;
}(_react.Component);

Toggle.defaultProps = {
  defaultToggled: false,
  disabled: false,
  labelPosition: 'left'
};
Toggle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Toggle.propTypes =  false ? {
  /**
   * Determines whether the Toggle is initially turned on.
   * **Warning:** This cannot be used in conjunction with `toggled`.
   * Decide between using a controlled or uncontrolled input element and remove one of these props.
   * More info: https://fb.me/react-controlled-components
   */
  defaultToggled: _propTypes2.default.bool,
  /**
   * Will disable the toggle if true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides the inline-styles of the Toggle element.
   */
  elementStyle: _propTypes2.default.object,
  /**
   * Overrides the inline-styles of the Icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the inline-styles of the input element.
   */
  inputStyle: _propTypes2.default.object,
  /**
   * Label for toggle.
   */
  label: _propTypes2.default.node,
  /**
   * Where the label will be placed next to the toggle.
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Overrides the inline-styles of the Toggle element label.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function that is fired when the toggle switch is toggled.
   *
   * @param {object} event Change event targeting the toggle.
   * @param {bool} isInputChecked The new value of the toggle.
   */
  onToggle: _propTypes2.default.func,
  /**
   * Override style of ripple.
   */
  rippleStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Override style for thumb.
   */
  thumbStyle: _propTypes2.default.object,
  /**
  * Override the inline styles for thumb when the toggle switch is toggled on.
  */
  thumbSwitchedStyle: _propTypes2.default.object,
  /**
   * Toggled if set to true.
   */
  toggled: _propTypes2.default.bool,
  /**
   * Override style for track.
   */
  trackStyle: _propTypes2.default.object,
  /**
  * Override the inline styles for track when the toggle switch is toggled on.
  */
  trackSwitchedStyle: _propTypes2.default.object,
  /**
   * ValueLink prop for when using controlled toggle.
   */
  valueLink: _propTypes2.default.object
} : {};
exports.default = Toggle;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;

var _Toolbar2 = __webpack_require__(1859);

var _Toolbar3 = _interopRequireDefault(_Toolbar2);

var _ToolbarGroup2 = __webpack_require__(789);

var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);

var _ToolbarSeparator2 = __webpack_require__(790);

var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);

var _ToolbarTitle2 = __webpack_require__(791);

var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Toolbar = _Toolbar3.default;
exports.ToolbarGroup = _ToolbarGroup3.default;
exports.ToolbarSeparator = _ToolbarSeparator3.default;
exports.ToolbarTitle = _ToolbarTitle3.default;
exports.default = _Toolbar3.default;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(22);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(13);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(14);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(16);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(17);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(19);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var noGutter = props.noGutter;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      toolbar = _context$muiTheme.toolbar;


  return {
    root: {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      backgroundColor: toolbar.backgroundColor,
      height: toolbar.height,
      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
}

var Toolbar = function (_Component) {
  (0, _inherits3.default)(Toolbar, _Component);

  function Toolbar() {
    (0, _classCallCheck3.default)(this, Toolbar);
    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Toolbar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          noGutter = _props.noGutter,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
        children
      );
    }
  }]);
  return Toolbar;
}(_react.Component);

Toolbar.defaultProps = {
  noGutter: false
};
Toolbar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Toolbar.propTypes =  false ? {
  /**
   * Can be a `ToolbarGroup` to render a group of related items.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Do not apply `desktopGutter` to the `Toolbar`.
   */
  noGutter: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Toolbar;

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var RabbitModal = function (_React$Component) {
    _inherits(RabbitModal, _React$Component);

    function RabbitModal() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RabbitModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RabbitModal.__proto__ || Object.getPrototypeOf(RabbitModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            lettersIdsArr: []
        }, _this.handleCheck = _this.handleCheck.bind(_this), _this.sendToRabbit = _this.sendToRabbit.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RabbitModal, [{
        key: 'handleCheck',
        value: function handleCheck(id) {
            var idIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(this.state.lettersIdsArr, id);
            if (idIndex < 0) {
                this.setState(function (prevState) {
                    return { lettersIdsArr: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(prevState.lettersIdsArr), [id])) };
                });
            } else {
                this.setState({ lettersIdsArr: this.state.lettersIdsArr.filter(function (item, index) {
                        return index !== idIndex;
                    }) });
            }
        }
    }, {
        key: 'sendToRabbit',
        value: function sendToRabbit() {
            if (this.state.lettersIdsArr.length) {
                this.props.sendToRabbit(this.state.lettersIdsArr);
                this.state.lettersIdsArr = [];
                this.props.handleClose();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                open = _props.open,
                handleClose = _props.handleClose,
                letters = _props.letters;

            var lettersData = letters.data;

            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    _this2.state.lettersIdsArr = [];
                    handleClose();
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'Submit',
                primary: true,
                onClick: this.sendToRabbit
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
                {
                    title: 'Requeue',
                    actions: actions,
                    modal: false,
                    open: open,
                    onRequestClose: function onRequestClose() {
                        _this2.state.lettersIdsArr = [];
                        handleClose();
                    },
                    autoScrollBodyContent: true
                },
                lettersData && lettersData.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default.a, {
                        key: index,
                        value: item._id,
                        label: item.subject,
                        style: { marginTop: 16 },
                        onCheck: function onCheck() {
                            return _this2.handleCheck(item._id);
                        }
                    });
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RabbitModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = RabbitModal;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RabbitModal, 'RabbitModal', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/RabbitModal.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/RabbitModal.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = BrokerMailsModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Base_AwaitableBtn__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











/**
 * 
 * @param {{ 
 *  selectedBrokerMails: string[], selectedListeners: Listener[], handleFilterBroker: Function,
 *  handleClose: Function, brokerMails: string[], showUniqueBrokerMails: boolean,
 *  handleToggleShowUniqueBrokerMails: (e: MouseEvent, isInputChecked: boolean) => void, 
 * listeners: Listener[],
 * }} param0 
 */

function BrokerMailsModal(_ref) {
    var _this = this;

    var selectedBrokerMails = _ref.selectedBrokerMails,
        selectedListeners = _ref.selectedListeners,
        handleFilterBroker = _ref.handleFilterBroker,
        handleClose = _ref.handleClose,
        brokerMails = _ref.brokerMails,
        showUniqueBrokerMails = _ref.showUniqueBrokerMails,
        handleToggleShowUniqueBrokerMails = _ref.handleToggleShowUniqueBrokerMails,
        listeners = _ref.listeners;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(selectedBrokerMails || []),
        _useState2 = _slicedToArray(_useState, 2),
        brokerMailsArr = _useState2[0],
        setBrokerMailsArr = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(selectedListeners || []),
        _useState4 = _slicedToArray(_useState3, 2),
        currentListeners = _useState4[0],
        setCurrentListeners = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(listeners),
        _useState6 = _slicedToArray(_useState5, 2),
        allListeners = _useState6[0],
        setAllListeners = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(brokerMails),
        _useState8 = _slicedToArray(_useState7, 2),
        allBrokerMails = _useState8[0],
        setAllBrokerMails = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState10 = _slicedToArray(_useState9, 2),
        filterString = _useState10[0],
        setFilterString = _useState10[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!filterString) {
            setAllBrokerMails(brokerMails);
            setAllListeners(listeners);
        } else {
            setAllBrokerMails(brokerMails.filter(function (b) {
                return new RegExp(filterString, 'i').test(b);
            }));
            setAllListeners(listeners.filter(function (l) {
                return new RegExp(filterString, 'i').test(l.company.name);
            }));
        }
    }, [filterString]);

    var handleCheck = function handleCheck(value) {
        if (typeof value === 'string') {
            var idIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(brokerMailsArr, value);

            if (idIndex < 0) {
                setBrokerMailsArr(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(brokerMailsArr), [value])));
            } else {
                setBrokerMailsArr(brokerMailsArr.filter(function (_item, index) {
                    return index !== idIndex;
                }));
            }
        } else {
            var _idIndex = currentListeners.findIndex(function (item) {
                return item.company._id === value.company._id;
            });

            if (_idIndex < 0) {
                setCurrentListeners(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq([].concat(_toConsumableArray(currentListeners), [value])));
            } else {
                setCurrentListeners(currentListeners.filter(function (_item, index) {
                    return index !== _idIndex;
                }));
            }
        }
    };

    var handleFilter = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return handleFilterBroker(brokerMailsArr, currentListeners);

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function handleFilter() {
            return _ref2.apply(this, arguments);
        };
    }();

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            style: { display: 'flex', justifyContent: 'flex-end' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '40%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle___default.a, {
                name: 'toggl',
                title: !brokerMailsArr.length ? 'Select broker mail' : '',
                label: 'Unique broker mails',
                labelPosition: 'right',
                style: { padding: '8px 0 0 20px' },
                labelStyle: { display: 'flex' },
                toggled: showUniqueBrokerMails,
                onToggle: handleToggleShowUniqueBrokerMails,
                disabled: !brokerMailsArr.length
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '60%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    handleClose();
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_components_Base_AwaitableBtn__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                    label: 'Filter',
                    primary: true,
                    onClick: handleFilter
                })
            )
        )
    )];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
        {
            title: 'Select broker mails',
            actions: actions,
            modal: false,
            open: true,
            onRequestClose: function onRequestClose() {
                handleClose();
            },
            autoScrollBodyContent: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["A" /* TextField */], {
            hintText: 'Search broker email',
            value: filterString,
            onChange: function onChange(e) {
                return setFilterString(e.target.value);
            }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                style: { minHeight: '90vh' }
            },
            allBrokerMails && allBrokerMails.map(function (item) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default.a, {
                    checked: brokerMailsArr.includes(item),
                    key: item,
                    value: item,
                    label: item,
                    style: { marginTop: 16 },
                    onCheck: function onCheck() {
                        return handleCheck(item);
                    }
                });
            }),
            allListeners && allListeners.map(function (item) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default.a, {
                    checked: currentListeners && !!currentListeners.find(function (stl) {
                        return stl.company._id === item.company._id;
                    }),
                    key: item.company._id,
                    label: '[ ' + item.parser + ' ] ' + item.company.name,
                    style: { marginTop: 16 },
                    onCheck: function onCheck() {
                        return handleCheck(item);
                    }
                });
            })
        )
    );
}

/**
 * @typedef {Object} Listener
 * @property {string} parser 
 * @property {Company} company
 */

/**
 * @typedef {Object} Company
 * @property {string} _id
 * @property {string} name
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BrokerMailsModal, 'BrokerMailsModal', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/BrokerMailsModal.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(232),
    createAssigner = __webpack_require__(794),
    keysIn = __webpack_require__(517);

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

module.exports = assignInWith;


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(255),
    isArrayLike = __webpack_require__(193),
    isIndex = __webpack_require__(271),
    isObject = __webpack_require__(89);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1864 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1865 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(187),
    isLength = __webpack_require__(489),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(671);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(89),
    isPrototype = __webpack_require__(358),
    nativeKeysIn = __webpack_require__(1869);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1869 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(255);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

module.exports = customDefaultsAssignIn;


/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var styles = {
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 20px 0 10px' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '8px',
        padding: '16px 0'
    },
    link: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50px',
        backgroundColor: '#2196F3',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
    },
    linkOpened: {
        backgroundColor: '#4CAF50'
    },
    linkHover: {
        backgroundColor: '#1976D2'
    },
    hint: {
        color: '#666',
        fontSize: '13px',
        marginBottom: '8px'
    }
};

/**
 * opens emails as gazetter!!! tabs via middle click
 * @param {{ letterIds: string[], open?: boolean, handleOpen: Function }} props
 */
function OpenAll(_ref) {
    var _ref$letterIds = _ref.letterIds,
        letterIds = _ref$letterIds === undefined ? [] : _ref$letterIds,
        _ref$open = _ref.open,
        open = _ref$open === undefined ? false : _ref$open,
        handleOpen = _ref.handleOpen;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(new Set()),
        _useState2 = _slicedToArray(_useState, 2),
        openedIds = _useState2[0],
        setOpenedIds = _useState2[1];

    var handleLinkClick = function handleLinkClick(id) {
        setOpenedIds(function (prev) {
            return new Set([].concat(_toConsumableArray(prev), [id]));
        });
    };

    var handleClose = function handleClose() {
        handleOpen();
        // setOpenedIds(new Set());
    };

    var dialogActions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["g" /* FlatButton */], {
        key: 'close',
        label: 'Close',
        onClick: handleClose
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui__["f" /* Dialog */],
            {
                title: 'Middle-click to open in background (' + letterIds.length + ' emails)',
                actions: dialogActions,
                modal: false,
                open: open,
                onRequestClose: handleClose,
                contentStyle: { maxWidth: '500px' },
                autoScrollBodyContent: false,
                bodyStyle: { overflowY: 'auto' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: styles.hint },
                'Middle-click (Ctrl+click or \u2318+click) on each number to open in background tab. Green --- already opened.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: styles.grid },
                letterIds.map(function (id, index) {
                    var isOpened = openedIds.has(id);
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        {
                            key: id,
                            href: '/' + id,
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            onClick: function onClick(e) {
                                return handleLinkClick(id, e);
                            },
                            onAuxClick: function onAuxClick(e) {
                                return handleLinkClick(id, e);
                            },
                            style: _extends({}, styles.link, isOpened ? styles.linkOpened : {})
                        },
                        index + 1
                    );
                })
            )
        )
    );
}

var _default = OpenAll;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/OpenAll.jsx');
    reactHotLoader.register(OpenAll, 'OpenAll', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/OpenAll.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/List/OpenAll.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sagas_letters__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sagas_train__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sagas_annotations__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Management_TextEditor__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HtmlContent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__List_Annotation__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ErrorBoundary__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Content_Annotations__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Sidebar_Types__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Sidebar_SenderTrain__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions_train__ = __webpack_require__(1881);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var TrainPage = function (_React$Component) {
    _inherits(TrainPage, _React$Component);

    function TrainPage(props) {
        _classCallCheck(this, TrainPage);

        var _this = _possibleConstructorReturn(this, (TrainPage.__proto__ || Object.getPrototypeOf(TrainPage)).call(this, props));

        var types = [];

        if (localStorage.getItem('train' + _this.props.userId)) {
            types = JSON.parse(localStorage.getItem('train' + _this.props.userId));
        }

        _this.state = {
            textLetter: '',
            annotations: [],
            selectedTextToTrain: '',
            types: types,
            selectedType: ''
        };

        _this.updatePostAnnotations = _this.updatePostAnnotations.bind(_this);
        _this.resendAnnotations = _this.resendAnnotations.bind(_this);

        _this.changeSelectedTextToTrain = _this.changeSelectedTextToTrain.bind(_this);
        _this.clearSelectedTextToTrain = _this.clearSelectedTextToTrain.bind(_this);

        _this.addNewType = _this.addNewType.bind(_this);
        _this.selectType = _this.selectType.bind(_this);

        _this.sendTrain = _this.sendTrain.bind(_this);
        _this.handleSendToDev = _this.handleSendToDev.bind(_this);
        _this.handleOpenInDev = _this.handleOpenInDev.bind(_this);
        return _this;
    }

    _createClass(TrainPage, [{
        key: 'sendTrain',
        value: function sendTrain() {
            var _state = this.state,
                selectedTextToTrain = _state.selectedTextToTrain,
                selectedType = _state.selectedType;


            this.props.sendTrain({
                text: selectedTextToTrain,
                type: selectedType
            });
        }
    }, {
        key: 'handleSendToDev',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_5_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_8_sagas_lettersNew__["c" /* sendToDev */], this.props.letter._id);

                            case 3:
                                _context.next = 8;
                                break;

                            case 5:
                                _context.prev = 5;
                                _context.t0 = _context['catch'](0);

                                console.error(_context.t0);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 5]]);
            }));

            function handleSendToDev() {
                return _ref.apply(this, arguments);
            }

            return handleSendToDev;
        }()
    }, {
        key: 'handleOpenInDev',
        value: function handleOpenInDev() {
            window.open('http://anotatr.com:5001/' + this.props.letter._id + '/train', '_blank');
        }
    }, {
        key: 'selectType',
        value: function selectType(e, i) {
            this.setState({
                selectedType: this.state.types[i]
            });
        }
    }, {
        key: 'addNewType',
        value: function addNewType(type) {
            var types = this.state.types.slice();

            types.push(type);

            localStorage.setItem('train' + this.props.userId, JSON.stringify(types));

            this.setState({
                types: types
            });
        }
    }, {
        key: 'clearSelectedTextToTrain',
        value: function clearSelectedTextToTrain() {
            this.setState({
                selectedTextToTrain: ''
            });
        }
    }, {
        key: 'changeSelectedTextToTrain',
        value: function changeSelectedTextToTrain(text) {
            this.setState({
                selectedTextToTrain: this.state.selectedTextToTrain + text
            });
        }
    }, {
        key: 'resendAnnotations',
        value: function resendAnnotations() {
            var textLetter = this.state.textLetter;

            this.props.sendTrain({ text: textLetter });
        }
    }, {
        key: 'updatePostAnnotations',
        value: function updatePostAnnotations(textLetter) {
            var _this2 = this;

            this.setState({
                textLetter: textLetter
            }, function () {
                _this2.props.sendTrain({ text: textLetter });
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var textLetter = this.state.textLetter;


            if (textLetter === '' && nextProps.letter.text) {
                textLetter = nextProps.letter.text;
            }

            this.setState({
                textLetter: textLetter,
                letter: nextProps.letter
            });
        }
    }, {
        key: 'getData',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _ref3, letter;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_5_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_6_sagas_letters__["b" /* getLetter */], this.props.routeParams.id);

                            case 3:
                                _ref3 = _context2.sent;
                                letter = _ref3.data;
                                _context2.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_5_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_8_sagas_lettersNew__["c" /* sendToDev */], { text: letter.text });

                            case 7:
                                _context2.next = 12;
                                break;

                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2['catch'](0);

                                console.error(_context2.t0);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 9]]);
            }));

            function getData() {
                return _ref2.apply(this, arguments);
            }

            return getData;
        }()
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.getData();
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                textLetter = _state2.textLetter,
                typeAnnotations = _state2.typeAnnotations,
                selectedTextToTrain = _state2.selectedTextToTrain,
                selectedType = _state2.selectedType,
                types = _state2.types;

            console.log(this.state);

            var _props = this.props,
                letter = _props.letter,
                train = _props.train;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'single-letter-gazetter', className: 'single-letter' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'management' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'management-children', style: { padding: '10px 0' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                label: 'Resend',
                                onClick: this.resendAnnotations,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '0 10px 0 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_13__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Management_TextEditor__["a" /* default */], {
                                    textLetter: textLetter,
                                    typeAnnotations: typeAnnotations,
                                    updatePostAnnotations: this.updatePostAnnotations
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HtmlContent__["a" /* default */], {
                                letter: letter
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                label: 'Send to dev-server',
                                onClick: this.handleSendToDev,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '0 10px 0 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                label: 'Open in dev-server',
                                onClick: this.handleOpenInDev,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '0 10px 0 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                primary: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject' },
                            'SUBJECT: ',
                            letter.subject
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Content_Annotations__["a" /* default */], {
                            textLetter: textLetter,
                            changeSelectedTextToTrain: this.changeSelectedTextToTrain
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__List_Annotation__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'sidebar' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Sidebar_Types__["a" /* default */], {
                            types: types,
                            selectedType: selectedType,
                            selectType: this.selectType,
                            addNewType: this.addNewType
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Sidebar_SenderTrain__["a" /* default */], {
                            selectedTextToTrain: selectedTextToTrain,
                            selectedType: selectedType,
                            clearSelectedTextToTrain: this.clearSelectedTextToTrain,
                            sendTrain: this.sendTrain
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-10' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block absolute small-name' },
                            'Response train'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'mailScore - ',
                            train.mailScore
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'mailType - ',
                            train.mailType
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TrainPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref4) {
    var _ref4$user = _ref4.user,
        _id = _ref4$user.user._id,
        isLogged = _ref4$user.isLogged,
        letter = _ref4.letter,
        train = _ref4.train;

    return {
        isLogged: isLogged,
        userId: _id,
        letter: letter,
        annotations: train.annotations,
        train: train
    };
}, function (dispatch) {
    return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__["a" /* addNotification */],
        sendTrain: __WEBPACK_IMPORTED_MODULE_17_actions_train__["a" /* sendTrain */]
    }, dispatch), { dispatch: dispatch });
})(TrainPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TrainPage, 'TrainPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createCargoOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mocks_cargo_orderNew__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fillCargoType),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fillPorts),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(createOrders),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fillAndCreateCargoOrders),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(createCargoOrders);









function fillCargoType(clarified) {
    var responseCargoTypes, foundedType;
    return regeneratorRuntime.wrap(function fillCargoType$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!clarified.cargo[0].cargoType) {
                        _context.next = 7;
                        break;
                    }

                    _context.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getCargoTypes);

                case 3:
                    responseCargoTypes = _context.sent;


                    responseCargoTypes.data.push({
                        _id: '59970a4513d689b67b8bf20d',
                        name: 'Other'
                    });

                    foundedType = responseCargoTypes.data.find(function (cargoType) {
                        return cargoType._id === clarified.cargo[0].cargoType;
                    });


                    if (foundedType) {
                        clarified.cargo[0].cargoTypeName = foundedType.name;
                    }

                case 7:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function fillPorts(clarified) {
    var _ref, data, _ref2, _data;

    return regeneratorRuntime.wrap(function fillPorts$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    if (!clarified.loadingPort) {
                        _context2.next = 6;
                        break;
                    }

                    _context2.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getPort, { id: clarified.loadingPort });

                case 3:
                    _ref = _context2.sent;
                    data = _ref.data;

                    clarified.loadingPortName = data.name;

                case 6:
                    if (!clarified.unloadingPort) {
                        _context2.next = 12;
                        break;
                    }

                    _context2.next = 9;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getPort, { id: clarified.unloadingPort });

                case 9:
                    _ref2 = _context2.sent;
                    _data = _ref2.data;

                    clarified.unloadingPortName = _data.name;

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function portsFlat(ports, destination) {
    ports = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(ports);
    return ports.forEach(function (item) {
        if (item.oneOf.length > 1) {
            item.oneOf.forEach(function (prt) {
                destination.push({
                    port: prt,
                    sign: prt.andOr
                });
            });
        } else {
            destination.push({
                port: item.oneOf[0],
                sign: 'and'
            });
        }
    });
}

// eslint-disable-next-line require-yield
function createOrders(clarified) {
    var newClarified, loadingPorts, unloadingPorts, loadingPortsNew, unloadingPortsNew, loadingPortsMap, unloadingPortsMap, cancellingDate, readinessDate, currentDate, loadingPortsOr, unloadingPortsOr, loadingPortsAnd, unloadingPortsAnd;
    return regeneratorRuntime.wrap(function createOrders$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    newClarified = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(clarified);
                    loadingPorts = [];
                    unloadingPorts = [];
                    loadingPortsNew = [{
                        oneOf: []
                    }];
                    unloadingPortsNew = [{
                        oneOf: []
                    }];
                    loadingPortsMap = [];
                    unloadingPortsMap = [];


                    newClarified.cargo = newClarified.cargo.map(function (cargo) {
                        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge({}, __WEBPACK_IMPORTED_MODULE_5_mocks_cargo_orderNew__["a" /* orderNew */].cargo[0], cargo);
                    });

                    if (newClarified.loadingPorts) {
                        cancellingDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(newClarified.cancellingDate).utc().startOf('day').toDate();
                        readinessDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(newClarified.readinessDate).utc().startOf('day').toDate();
                        currentDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().utc().startOf('day').toDate();
                        loadingPortsOr = newClarified.loadingPorts && newClarified.loadingPorts.ports ? Object.entries(newClarified.loadingPorts.ports) : [];
                        unloadingPortsOr = newClarified.unloadingPorts && newClarified.unloadingPorts.ports ? Object.entries(newClarified.unloadingPorts.ports) : [];
                        loadingPortsAnd = newClarified.loadingPorts && newClarified.loadingPorts.multiPorts ? Object.entries(newClarified.loadingPorts.multiPorts) : [];
                        unloadingPortsAnd = newClarified.unloadingPorts && newClarified.unloadingPorts.multiPorts ? Object.entries(newClarified.unloadingPorts.multiPorts) : [];

                        // first loading ports (or) 

                        loadingPortsOr.forEach(function (loadingPortOr, loadingPortOrIndex) {
                            if (loadingPortOr[1] && loadingPortOr[1].port) {
                                var _newClarified$loading = newClarified.loadingPorts,
                                    multiPierses = _newClarified$loading.multiPierses,
                                    pierses = _newClarified$loading.pierses;

                                loadingPortsNew[0].oneOf.push({
                                    port: loadingPortOr[1].pId,
                                    portName: loadingPortOr[1].port,
                                    details: multiPierses ? multiPierses[loadingPortOrIndex] || '' : pierses[loadingPortOrIndex] || '',
                                    cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                                    readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                                    cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                                    readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                                    andOr: loadingPortOrIndex === 0 ? 'and' : 'or',
                                    additionalLayCanDetails: undefined,
                                    layCanType: 'layCan'
                                });
                            }
                        });

                        loadingPortsAnd.forEach(function (loadingPortAnd, loadingPortAndIndex) {
                            if (loadingPortAnd[1] && loadingPortAnd[1].port) {
                                var _newClarified$loading2 = newClarified.loadingPorts,
                                    multiPierses = _newClarified$loading2.multiPierses,
                                    pierses = _newClarified$loading2.pierses;

                                loadingPortsNew.push({
                                    oneOf: [{
                                        port: loadingPortAnd[1].pId,
                                        portName: loadingPortAnd[1].port,
                                        details: multiPierses ? multiPierses[loadingPortAndIndex] || '' : pierses[loadingPortAndIndex] || '',
                                        cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                                        readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                                        cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                                        readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                                        andOr: 'and',
                                        additionalLayCanDetails: undefined,
                                        layCanType: 'layCan'
                                    }]
                                });
                            }
                        });

                        // first unloading port
                        unloadingPortsOr.forEach(function (unloadingPortOr, unloadingPortOrIndex) {
                            if (unloadingPortOr[1] && unloadingPortOr[1].port) {
                                var _newClarified$unloadi = newClarified.unloadingPorts,
                                    multiPierses = _newClarified$unloadi.multiPierses,
                                    pierses = _newClarified$unloadi.pierses;

                                unloadingPortsNew[0].oneOf.push({
                                    port: unloadingPortOr[1].pId,
                                    portName: unloadingPortOr[1].port,
                                    details: multiPierses && multiPierses[unloadingPortOrIndex] ? multiPierses[unloadingPortOrIndex] || '' : pierses[unloadingPortOrIndex] || '',
                                    cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                                    readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                                    cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                                    readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                                    andOr: unloadingPortOrIndex === 0 ? 'and' : 'or'
                                });
                            }
                        });

                        unloadingPortsAnd.forEach(function (unloadingPortAnd, unloadingPortAndIndex) {
                            if (unloadingPortAnd[1] && unloadingPortAnd[1].port) {
                                var _newClarified$unloadi2 = newClarified.unloadingPorts,
                                    multiPierses = _newClarified$unloadi2.multiPierses,
                                    pierses = _newClarified$unloadi2.pierses;

                                unloadingPortsNew.push({
                                    oneOf: [{
                                        port: unloadingPortAnd[1].pId,
                                        portName: unloadingPortAnd[1].port,
                                        details: multiPierses && multiPierses[unloadingPortAndIndex] ? multiPierses[unloadingPortAndIndex] || '' : pierses[unloadingPortAndIndex] || '',
                                        cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                                        readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                                        cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                                        readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                                        andOr: 'and'
                                    }]
                                });
                            }
                        });

                        loadingPorts.push({
                            namePort: newClarified.loadingPortName,
                            idPort: newClarified.loadingPort,
                            cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                            readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                            loadingPortDetails: '',
                            cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                            readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                            additionalLayCanDetails: undefined,
                            layCanType: 'layCan'
                        });

                        unloadingPorts.push({
                            namePort: newClarified.unloadingPortName,
                            idPort: newClarified.unloadingPort,
                            unloadingPortDetails: ''
                        });

                        portsFlat(loadingPortsNew, loadingPortsMap);
                        portsFlat(unloadingPortsNew, unloadingPortsMap);
                    }

                    return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge({}, __WEBPACK_IMPORTED_MODULE_5_mocks_cargo_orderNew__["a" /* orderNew */], newClarified, {
                        loadingPorts: loadingPorts,
                        unloadingPorts: unloadingPorts,
                        loadingPortsNew: loadingPortsNew,
                        unloadingPortsNew: unloadingPortsNew,
                        loadingPortsMap: loadingPortsMap,
                        unloadingPortsMap: unloadingPortsMap
                    }));

                case 10:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

/**
 * Fill data from server
 * */
function fillAndCreateCargoOrders(clarified) {
    var newClarified;
    return regeneratorRuntime.wrap(function fillAndCreateCargoOrders$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    newClarified = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(clarified);
                    _context4.next = 3;
                    return fillCargoType(newClarified);

                case 3:
                    _context4.next = 5;
                    return fillPorts(newClarified);

                case 5:
                    _context4.next = 7;
                    return createOrders(newClarified);

                case 7:
                    return _context4.abrupt('return', _context4.sent);

                case 8:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function getUserMail(letter) {
    if (letter.eh === 'api' && letter.owner) {
        return letter.owner.email;
    }
    if (letter.realUserEmail) {
        return letter.realUserEmail;
    }
    return letter.sender && letter.sender[0].address;
}

// eslint-disable-next-line import/prefer-default-export
function createCargoOrders(response) {
    var cargoOrders, clarifiedOnlyCargo, userEmail, key;
    return regeneratorRuntime.wrap(function createCargoOrders$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    cargoOrders = [];

                    if (!(response.status === 200)) {
                        _context5.next = 36;
                        break;
                    }

                    if (!response.data.clarified) {
                        _context5.next = 30;
                        break;
                    }

                    clarifiedOnlyCargo = response.data.clarified.filter(function (c) {
                        return c.typeCategory.includes('request');
                    });
                    userEmail = getUserMail(response.data);

                    if (!(clarifiedOnlyCargo.length > 0)) {
                        _context5.next = 30;
                        break;
                    }

                    key = 0;

                case 7:
                    if (!(key < clarifiedOnlyCargo.length)) {
                        _context5.next = 24;
                        break;
                    }

                    _context5.prev = 8;
                    _context5.t0 = cargoOrders;
                    _context5.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(fillAndCreateCargoOrders, clarifiedOnlyCargo[key]);

                case 12:
                    _context5.t1 = _context5.sent;

                    _context5.t0.push.call(_context5.t0, _context5.t1);

                    _context5.next = 21;
                    break;

                case 16:
                    _context5.prev = 16;
                    _context5.t2 = _context5['catch'](8);
                    _context5.next = 20;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 20:

                    console.error(_context5.t2);

                case 21:
                    key++;
                    _context5.next = 7;
                    break;

                case 24:

                    cargoOrders = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatten(cargoOrders);

                    _context5.next = 27;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Created',
                            message: 'The ' + cargoOrders.length + ' cargo orders created',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 27:
                    _context5.next = 29;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["b" /* createCargoOrders */](cargoOrders, { email: userEmail }));

                case 29:
                    return _context5.abrupt('return');

                case 30:
                    _context5.next = 32;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["e" /* resetCargoOrders */]());

                case 32:
                    _context5.next = 34;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The cargo orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 34:
                    _context5.next = 40;
                    break;

                case 36:
                    _context5.next = 38;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["a" /* addCargoOrder */]());

                case 38:
                    _context5.next = 40;
                    return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_4_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The cargo orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 40:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[8, 16]]);
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fillCargoType, 'fillCargoType', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ordersNew.js');
    reactHotLoader.register(fillPorts, 'fillPorts', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ordersNew.js');
    reactHotLoader.register(portsFlat, 'portsFlat', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ordersNew.js');
    reactHotLoader.register(createOrders, 'createOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ordersNew.js');
    reactHotLoader.register(fillAndCreateCargoOrders, 'fillAndCreateCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ordersNew.js');
    reactHotLoader.register(getUserMail, 'getUserMail', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ordersNew.js');
    reactHotLoader.register(createCargoOrders, 'createCargoOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/cargoes/ordersNew.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createTcOrders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(467);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createTcOrders);







function fillAndCreateTcOrders(clarified) {
    var newClarified = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(clarified);

    return newClarified;
}

// eslint-disable-next-line import/prefer-default-export
function createTcOrders(response) {
    var tcOrders, clarifiedOnlyTc, userEmail, key;
    return regeneratorRuntime.wrap(function createTcOrders$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    tcOrders = [];

                    if (!(response.status === 200)) {
                        _context.next = 35;
                        break;
                    }

                    if (!response.data.clarified) {
                        _context.next = 29;
                        break;
                    }

                    clarifiedOnlyTc = response.data.clarified.filter(function (c) {
                        return c.typeCategory.includes('tc');
                    });
                    userEmail = Object(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* getUserMail */])(response.data);

                    if (!(clarifiedOnlyTc.length > 0)) {
                        _context.next = 29;
                        break;
                    }

                    key = 0;

                case 7:
                    if (!(key < clarifiedOnlyTc.length)) {
                        _context.next = 24;
                        break;
                    }

                    _context.prev = 8;
                    _context.t0 = tcOrders;
                    _context.next = 12;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["a" /* call */])(fillAndCreateTcOrders, clarifiedOnlyTc[key]);

                case 12:
                    _context.t1 = _context.sent;

                    _context.t0.push.call(_context.t0, _context.t1);

                    _context.next = 21;
                    break;

                case 16:
                    _context.prev = 16;
                    _context.t2 = _context['catch'](8);
                    _context.next = 20;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Something went wrong',
                            level: 'error',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 20:

                    console.error(_context.t2);

                case 21:
                    key++;
                    _context.next = 7;
                    break;

                case 24:
                    _context.next = 26;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Created',
                            message: 'The ' + tcOrders.length + ' tc orders created',
                            level: 'success',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 26:
                    _context.next = 28;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_tc_orders__["b" /* createTcOrders */](tcOrders, { email: userEmail }));

                case 28:
                    return _context.abrupt('return');

                case 29:
                    _context.next = 31;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_tc_orders__["d" /* resetTcOrders */]());

                case 31:
                    _context.next = 33;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The tc orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 33:
                    _context.next = 39;
                    break;

                case 35:
                    _context.next = 37;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* put */])(__WEBPACK_IMPORTED_MODULE_1_actions_tc_orders__["a" /* addTcOrder */]());

                case 37:
                    _context.next = 39;
                    return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Warning',
                            message: 'The tc orders did\'t create',
                            level: 'warning',
                            _id: new Date().getMilliseconds(),
                            autoDismiss: 4
                        }
                    });

                case 39:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[8, 16]]);
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fillAndCreateTcOrders, 'fillAndCreateTcOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/orders.js');
    reactHotLoader.register(createTcOrders, 'createTcOrders', '/opt/atlassian/pipelines/agent/build/client/app/sagas/tc/orders.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TextEditor = function (_React$Component) {
    _inherits(TextEditor, _React$Component);

    function TextEditor(props) {
        _classCallCheck(this, TextEditor);

        var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));

        _this.state = {
            open: false,
            textLetter: props.textLetter,
            originalText: props.textLetter
        };

        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.changeTextLetterText = _this.changeTextLetterText.bind(_this);
        _this.update = _this.update.bind(_this);
        _this.returnOriginalText = _this.returnOriginalText.bind(_this);
        return _this;
    }

    _createClass(TextEditor, [{
        key: 'returnOriginalText',
        value: function returnOriginalText() {
            this.setState({
                textLetter: this.state.originalText
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var textLetter = this.state.textLetter;


            this.toggleDialog();
            this.props.updatePostAnnotations(textLetter);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var originalText = this.state.originalText;


            if (originalText === '') {
                originalText = nextProps.textLetter;
            }

            this.setState({
                textLetter: nextProps.textLetter,
                originalText: originalText
            });
        }
    }, {
        key: 'changeTextLetterText',
        value: function changeTextLetterText(e) {
            this.setState({
                textLetter: e.target.value
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            this.setState({
                open: !this.state.open
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                open = _state.open,
                textLetter = _state.textLetter;


            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'RE-ANNOTATE',
                primary: true,
                onClick: this.update
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'RETURN ORIGINAL TEXT',
                primary: true,
                onClick: this.returnOriginalText
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'CLOSE',
                primary: true,
                onClick: this.toggleDialog
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                    onClick: this.toggleDialog,
                    label: 'Editor',
                    labelStyle: { fontSize: '10px' },
                    style: { height: '25px', margin: '0 10px 0 0' },
                    buttonStyle: { height: '25px', lineHeight: '25px' },
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog___default.a,
                    {
                        title: 'Edit letter text',
                        actions: actions,
                        modal: true,
                        contentStyle: { width: '100%', maxWidth: 'none' },
                        open: open
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                        style: { width: '100%', minHeight: '400px' },
                        value: textLetter,
                        onChange: this.changeTextLetterText
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TextEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TextEditor;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TextEditor, 'TextEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Management/TextEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Management/TextEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var AnnotationList = function (_React$Component) {
    _inherits(AnnotationList, _React$Component);

    function AnnotationList(props) {
        _classCallCheck(this, AnnotationList);

        var _this = _possibleConstructorReturn(this, (AnnotationList.__proto__ || Object.getPrototypeOf(AnnotationList)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            annotations: props.annotations,
            searchText: ''
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.filterAnnotations = _this.filterAnnotations.bind(_this);
        return _this;
    }

    _createClass(AnnotationList, [{
        key: 'filterAnnotations',
        value: function filterAnnotations() {
            var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.searchText;
            var annotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.annotations;

            text = text.toLowerCase();

            var filteredAnnotations = annotations.filter(function (annotation) {
                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(annotation, 'features.rule') && annotation.features.rule.toLowerCase().includes(text)) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(annotation, 'features.majorType') && annotation.features.majorType.toLowerCase().includes(text)) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(annotation, 'features.string') && annotation.features.string.toLowerCase().includes(text)) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(annotation, 'type') && annotation.type.toLowerCase().includes(text)) {
                    return true;
                }

                if (annotation.id) {
                    var id = annotation.id + '';
                    if (id.includes(text)) {
                        return true;
                    }
                }

                return false;
            });

            return {
                searchText: text,
                annotations: filteredAnnotations
            };
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var _filterAnnotations = this.filterAnnotations(this.state.searchText, nextProps.annotations),
                annotations = _filterAnnotations.annotations;

            this.setState({
                page: 1,
                annotations: annotations,
                total: nextProps.annotations.length
            }, function () {
                _this2.handleUpdateRow(_this2.state);
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e, value) {
            var _this3 = this;

            var _filterAnnotations2 = this.filterAnnotations(value),
                annotations = _filterAnnotations2.annotations,
                searchText = _filterAnnotations2.searchText;

            this.setState({
                page: 1,
                annotations: annotations,
                searchText: searchText
            }, function () {
                _this3.handleUpdateRow(_this3.state);
            });
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.annotations.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                annotations = _state.annotations,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page,
                numberOfRows = _state.numberOfRows,
                rows = _state.rows,
                searchText = _state.searchText;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'annotations-list-b' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'navigation' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-search' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                            hintText: 'Search',
                            hintStyle: { fontSize: 12 },
                            style: { fontSize: 12 },
                            onChange: this.handleSearch,
                            value: searchText || ''
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-arrows' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                            total: annotations.length,
                            rowsPerPage: rowsPerPage,
                            page: page,
                            numberOfRows: numberOfRows,
                            updateRows: this.handleUpdateRow
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'annotations-table' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["Table"],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeader"],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                                { style: { height: '28px' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Value'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Rule'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Type'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'MajorType'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'id'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableBody"],
                            { displayRowCheckbox: false },
                            rows.map(function (annotation, i) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRow"],
                                    { style: { height: '28px' }, key: i },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.string
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.rule
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.type
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.majorType
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.id
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AnnotationList.propTypes = {
    annotations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

AnnotationList.defaultProps = {
    annotations: []
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref) {
    var train = _ref.train;

    return {
        annotations: train.annotations
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationList, 'AnnotationList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/List/Annotation.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/List/Annotation.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddSelectTextToTrain__ = __webpack_require__(1878);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ContentAnnotations = function (_React$Component) {
    _inherits(ContentAnnotations, _React$Component);

    function ContentAnnotations(props) {
        _classCallCheck(this, ContentAnnotations);

        var _this = _possibleConstructorReturn(this, (ContentAnnotations.__proto__ || Object.getPrototypeOf(ContentAnnotations)).call(this, props));

        _this.state = {
            openAddWordSelection: false,
            textLetter: props.textLetter,
            selectedText: ''
        };

        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.closePopover = _this.closePopover.bind(_this);
        return _this;
    }

    _createClass(ContentAnnotations, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var textLetter = nextProps.textLetter;


            this.setState({
                textLetter: textLetter
            });
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp(ev) {
            var range = __WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* default */].getSelection(ev.target.parentNode);

            if (range.start === range.end) {
                return;
            }

            this.setState({
                openAddWordSelection: true,
                elementTarget: ev.target,
                selectedText: range.string
            });
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.setState({
                openAddWordSelection: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                selectedText = _state.selectedText,
                openAddWordSelection = _state.openAddWordSelection,
                elementTarget = _state.elementTarget,
                textLetter = _state.textLetter;
            var changeSelectedTextToTrain = this.props.changeSelectedTextToTrain;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AddSelectTextToTrain__["a" /* default */], {
                    openAddWordSelection: openAddWordSelection,
                    elementTarget: elementTarget,
                    closePopover: this.closePopover,
                    selectedText: selectedText,
                    changeSelectedTextToTrain: changeSelectedTextToTrain
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'letter-text', onMouseUp: this.onMouseUp },
                    textLetter.split('').map(function (item, key) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { key: key },
                            item
                        );
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ContentAnnotations;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContentAnnotations.propTypes = {};

ContentAnnotations.defaultProps = {};

var _default = ContentAnnotations;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ContentAnnotations, 'ContentAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Content/Annotations.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Content/Annotations.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Popover__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AddWordSelection = function (_React$PureComponent) {
    _inherits(AddWordSelection, _React$PureComponent);

    function AddWordSelection() {
        _classCallCheck(this, AddWordSelection);

        return _possibleConstructorReturn(this, (AddWordSelection.__proto__ || Object.getPrototypeOf(AddWordSelection)).apply(this, arguments));
    }

    _createClass(AddWordSelection, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                openAddWordSelection = _props.openAddWordSelection,
                elementTarget = _props.elementTarget,
                closePopover = _props.closePopover,
                selectedText = _props.selectedText,
                changeSelectedTextToTrain = _props.changeSelectedTextToTrain;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'popup' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Popover___default.a,
                    {
                        open: openAddWordSelection,
                        anchorEl: elementTarget,
                        onRequestClose: closePopover,
                        animation: __WEBPACK_IMPORTED_MODULE_5_material_ui_Popover__["PopoverAnimationVertical"],
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'popup-choose' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'chosen' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'chosen-title' },
                                'Add text to train'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'chosen-row' },
                                '\'' + selectedText + '\''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { margin: '10px' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                                onClick: function onClick() {
                                    changeSelectedTextToTrain(selectedText);
                                },
                                primary: true,
                                label: 'Add or join'
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AddWordSelection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref) {
    var openAddWordSelection = _ref.openAddWordSelection,
        elementTarget = _ref.elementTarget,
        closePopover = _ref.closePopover,
        selectedText = _ref.selectedText,
        changeSelectedTextToTrain = _ref.changeSelectedTextToTrain;

    return {
        openAddWordSelection: openAddWordSelection,
        elementTarget: elementTarget,
        closePopover: closePopover,
        selectedText: selectedText,
        changeSelectedTextToTrain: changeSelectedTextToTrain
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(AddWordSelection);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AddWordSelection, 'AddWordSelection', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Content/AddSelectTextToTrain.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Content/AddSelectTextToTrain.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Types = function (_React$Component) {
    _inherits(Types, _React$Component);

    function Types(props) {
        _classCallCheck(this, Types);

        var _this = _possibleConstructorReturn(this, (Types.__proto__ || Object.getPrototypeOf(Types)).call(this, props));

        _this.state = {
            text: ''
        };

        _this.changeText = _this.changeText.bind(_this);
        _this.saveToTrain = _this.saveToTrain.bind(_this);
        return _this;
    }

    _createClass(Types, [{
        key: 'changeText',
        value: function changeText(e, value) {
            this.setState({
                text: value
            });
        }
    }, {
        key: 'saveToTrain',
        value: function saveToTrain() {
            this.props.addNewType(this.state.text);

            this.setState({
                text: ''
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var text = this.state.text;
            var _props = this.props,
                types = _props.types,
                selectedType = _props.selectedType,
                selectType = _props.selectType;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block margin-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block absolute small-name' },
                    'Types'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    types.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Types',
                                value: selectedType,
                                floatingLabelStyle: { fontSize: '12px' },
                                onChange: selectType
                            },
                            types.map(function (type, key) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                                    value: type,
                                    primaryText: type,
                                    key: key
                                });
                            })
                        )
                    ) : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                            floatingLabelText: 'New type',
                            value: text,
                            onChange: this.changeText,
                            floatingLabelStyle: { fontSize: '12px' }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                            label: 'Add to types',
                            labelStyle: { fontSize: '12px' },
                            disabled: text.length === 0,
                            onClick: this.saveToTrain,
                            primary: true
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Types;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Types.propTypes = {};

var _default = Types;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Types, 'Types', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Sidebar/Types.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Sidebar/Types.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SenderTrain = function (_React$Component) {
    _inherits(SenderTrain, _React$Component);

    function SenderTrain() {
        _classCallCheck(this, SenderTrain);

        return _possibleConstructorReturn(this, (SenderTrain.__proto__ || Object.getPrototypeOf(SenderTrain)).apply(this, arguments));
    }

    _createClass(SenderTrain, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                selectedTextToTrain = _props.selectedTextToTrain,
                clearSelectedTextToTrain = _props.clearSelectedTextToTrain,
                selectedType = _props.selectedType,
                sendTrain = _props.sendTrain;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute small-name' },
                        'Sender render'
                    ),
                    selectedTextToTrain.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        selectedTextToTrain
                    ) : '',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'Clear',
                                onClick: clearSelectedTextToTrain,
                                secondary: true,
                                labelStyle: { textTransform: 'none', fontSize: '12px' }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'Send train',
                                disabled: selectedType === '',
                                primary: true,
                                onClick: sendTrain,
                                labelStyle: { textTransform: 'none', fontSize: '12px' }
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute small-name' },
                        'Model'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'Save',
                                labelStyle: { textTransform: 'none', fontSize: '12px' },
                                onClick: __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].saveModel,
                                primary: true,
                                disabled: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'Load',
                                onClick: __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].loadModel,
                                labelStyle: { textTransform: 'none', fontSize: '12px' },
                                primary: true,
                                disabled: true
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SenderTrain;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SenderTrain.propTypes = {};

var _default = SenderTrain;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SenderTrain, 'SenderTrain', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Sidebar/SenderTrain.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Train/Sidebar/SenderTrain.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = sendTrain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function sendTrain(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_114" /* SEND_TRAIN */].REQUEST,
        data: data
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sendTrain, 'sendTrain', '/opt/atlassian/pipelines/agent/build/client/app/actions/train.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Base_UserSelector__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Sidebar_OrderTable__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Content_AnnotationsEditor__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Content_AnnotationsList__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HtmlContent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Content_TextEditor__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sagas_letters__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sagas_annotations__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_actions_letters__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_actions_vessels_orders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_actions_vessels_request__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Attachments__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ErrorBoundary__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_sagas_orders__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__common_FailedToSent__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__common_ToSpamButton__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-await-in-loop */










































// import Trainings from '../Gazetter/Trainings';







var LetterVessel = function (_React$Component) {
    _inherits(LetterVessel, _React$Component);

    function LetterVessel(props) {
        _classCallCheck(this, LetterVessel);

        var _this = _possibleConstructorReturn(this, (LetterVessel.__proto__ || Object.getPrototypeOf(LetterVessel)).call(this, props));

        _this.toggleAttachmentsDialog = function () {
            _this.setState({
                openedAttachmentsDialog: !_this.state.openedAttachmentsDialog
            });
        };

        _this.toggleFailedToSentOpen = function () {
            _this.setState({
                failedToSentOpen: !_this.state.failedToSentOpen
            });
        };

        if (localStorage.getItem('settings-order-vessel' + props.objUser.user._id)) {
            _this.initialState = JSON.parse(localStorage.getItem('settings-order-vessel' + props.objUser.user._id));
        } else {
            _this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem('settings-order-vessel' + props.objUser.user._id, JSON.stringify(_this.initialState));
        }

        _this.state = _extends({}, _this.initialState, {
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientVessel: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            failedToSentOpen: false,
            isFormChanged: false,
            vesselOrdersDuplicates: []
        });

        _this.addOrderTable = _this.addOrderTable.bind(_this);
        _this.sendRequestVessel = _this.sendRequestVessel.bind(_this);
        _this.sendRequestVesselFromSent = _this.sendRequestVesselFromSent.bind(_this);
        _this.removeOrderTable = _this.removeOrderTable.bind(_this);
        _this.changeAnnotationsServer = _this.changeAnnotationsServer.bind(_this);
        _this.changeClarifiedServer = _this.changeClarifiedServer.bind(_this);
        _this.clearOrderTable = _this.clearOrderTable.bind(_this);
        _this.updatePostGazetters = _this.updatePostGazetters.bind(_this);
        _this.getLetterData = _this.getLetterData.bind(_this);

        _this.handleClientChange = _this.handleClientChange.bind(_this);
        _this.saveRequestsDataCreated = _this.saveRequestsDataCreated.bind(_this);
        return _this;
    }

    _createClass(LetterVessel, [{
        key: 'getLetterData',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(textEdit) {
                var _ref2, letter, annotationsResponse;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_17_sagas_letters__["b" /* getLetter */], this.props.routeParams.id, 'vessel');

                            case 3:
                                _ref2 = _context.sent;
                                letter = _ref2.data;

                                letter.gazettersArr = [];
                                letter.type = 'vessel';
                                letter.fromVesselOrders = true;

                                if (textEdit) {
                                    letter.text = textEdit;
                                }
                                letter.fromVesselOrders = true;
                                _context.next = 12;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_18_sagas_annotations__["b" /* postAnnotations */], letter.text, letter.type, this.state.annotationsServer, {
                                    emailId: letter._id,
                                    subject: letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(letter.date).format('DD-MM-YYYY')
                                });

                            case 12:
                                annotationsResponse = _context.sent;


                                if (annotationsResponse) {
                                    letter.gazettersArr = annotationsResponse.data.annotations;
                                    if (annotationsResponse.data.newclarified) {
                                        letter.newclarified = annotationsResponse.data.newclarified;
                                    }
                                }

                                _context.next = 16;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_19_sagas_lettersNew__["d" /* updateLetter */], __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.omit(letter, 'gazettersArr'), 'vessel', this.state.clarifiedServer);

                            case 16:

                                this.setState({
                                    vesselOrdersDuplicates: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.vesselOrders.items)
                                });
                                _context.next = 22;
                                break;

                            case 19:
                                _context.prev = 19;
                                _context.t0 = _context['catch'](0);

                                Object(__WEBPACK_IMPORTED_MODULE_25_actions_notifications_notifications__["a" /* addNotification */])({
                                    type: __WEBPACK_IMPORTED_MODULE_28_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                                    notification: {
                                        title: 'Error',
                                        message: _context.t0.errors.messages[0],
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 10
                                    }
                                });

                            case 22:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 19]]);
            }));

            function getLetterData(_x) {
                return _ref.apply(this, arguments);
            }

            return getLetterData;
        }()
    }, {
        key: 'changeAnnotationsServer',
        value: function changeAnnotationsServer(e, i, value) {
            var _this2 = this;

            this.initialState = {
                annotationsServer: value,
                clarifiedServer: this.state.clarifiedServer
            };

            localStorage.setItem('settings-order-vessel' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this2.getLetterData();
            });
        }
    }, {
        key: 'changeClarifiedServer',
        value: function changeClarifiedServer(e, i, value) {
            var _this3 = this;

            this.initialState = {
                annotationsServer: this.state.annotationsServer,
                clarifiedServer: value
            };

            localStorage.setItem('settings-order-vessel' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this3.getLetterData();
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var state = this.props.location.state;

            if (state) {
                this.getLetterData(state.modifiedTextLetter);
            } else {
                this.getLetterData();
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(nextProps.vesselOrders, this.state.vesselOrdersDuplicates)) {
                this.setState({ isFormChanged: true });
            } else {
                this.setState({ isFormChanged: false });
            }
        }
    }, {
        key: 'changeServer',
        value: function changeServer(e, i, value) {
            var _this4 = this;

            this.setState({
                selectedServer: value
            }, function () {
                _this4.getLetterData();
            });
        }
    }, {
        key: 'createVesselRequest',
        value: function createVesselRequest(vesselOrder, keyVesselOrder, vesselRequests) {
            var _this5 = this;

            vesselOrder.open.forEach(function (openPosition) {
                vesselRequests.push(_extends({}, vesselOrder, {
                    open: {
                        until: openPosition.until,
                        from: openPosition.from,
                        where: openPosition.where
                    },
                    user: _this5.props.user.email,
                    keyVesselOrder: keyVesselOrder
                }));
            });

            return vesselRequests;
        }
    }, {
        key: 'createTerms',
        value: function createTerms(vesselOrders) {
            vesselOrders.forEach(function (vesselOrder) {
                var terms = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(vesselOrder.terms);

                terms.forEach(function (term) {
                    if (term.type) {
                        term.value = term.type + ' ' + term.value;
                    }
                });

                vesselOrder.terms = terms;
            });
        }
    }, {
        key: 'saveRequestsDataCreated',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(order) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_31_sagas_orders__["a" /* saveRequestsDataCreated */], 'vessel', _extends({}, order, { mailId: this.props.letter._id }));

                            case 3:
                                _context2.next = 8;
                                break;

                            case 5:
                                _context2.prev = 5;
                                _context2.t0 = _context2['catch'](0);

                                console.error(_context2.t0);

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 5]]);
            }));

            function saveRequestsDataCreated(_x2) {
                return _ref3.apply(this, arguments);
            }

            return saveRequestsDataCreated;
        }()
    }, {
        key: 'sendRequestVessel',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this6 = this;

                var vesselOrders, vesselRequests, vesselRequestIndex, vesselRequest;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                vesselOrders = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.vesselOrders);

                                if (vesselOrders.length) {
                                    _context3.next = 3;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 3:
                                vesselRequests = [];


                                this.createTerms(vesselOrders);

                                vesselOrders.forEach(function (vesselOrder, keyVesselOrder) {
                                    if (!vesselOrder.maintenance) {
                                        delete vesselOrder.maintenance;
                                    }

                                    _this6.createVesselRequest(vesselOrder, keyVesselOrder, vesselRequests);
                                });

                                vesselRequestIndex = 0;

                            case 7:
                                if (!(vesselRequestIndex < vesselRequests.length)) {
                                    _context3.next = 17;
                                    break;
                                }

                                vesselRequest = vesselRequests[vesselRequestIndex];


                                if (this.state.clientVessel) {
                                    vesselRequest.realUserEmail = vesselRequest.user;
                                    vesselRequest.user = this.state.clientVessel;
                                }

                                this.saveRequestsDataCreated(vesselRequest);

                                this.props.postRequestVessel(_extends({}, vesselRequest, {
                                    mailId: this.props.letter._id,
                                    eh: this.props.letter.eh,
                                    clientVessel: this.state.clientVessel
                                }));

                                _context3.next = 14;
                                return __WEBPACK_IMPORTED_MODULE_30__helpers__["a" /* default */].sleep(1000);

                            case 14:
                                vesselRequestIndex++;
                                _context3.next = 7;
                                break;

                            case 17:

                                this.setState({
                                    isFormChanged: false,
                                    vesselOrdersDuplicates: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.vesselOrders)
                                });

                            case 18:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function sendRequestVessel() {
                return _ref4.apply(this, arguments);
            }

            return sendRequestVessel;
        }()

        /**
         * @param {import('../../../Letters/common/FailedToSent').FailedTwin} failedTwinLetterData 
         */

    }, {
        key: 'sendRequestVesselFromSent',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(failedTwinLetterData) {
                var _this7 = this;

                var vesselOrders, vesselRequests, results, vesselRequestIndex, vesselRequest, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                vesselOrders = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.vesselOrders);

                                if (vesselOrders.length) {
                                    _context4.next = 3;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 3:
                                vesselRequests = [];
                                results = [];


                                this.createTerms(vesselOrders);

                                vesselOrders.forEach(function (vesselOrder, keyVesselOrder) {
                                    if (!vesselOrder.maintenance) {
                                        delete vesselOrder.maintenance;
                                    }

                                    _this7.createVesselRequest(vesselOrder, keyVesselOrder, vesselRequests);
                                });

                                vesselRequestIndex = 0;

                            case 8:
                                if (!(vesselRequestIndex < vesselRequests.length)) {
                                    _context4.next = 32;
                                    break;
                                }

                                vesselRequest = vesselRequests[vesselRequestIndex];


                                if (failedTwinLetterData.context.kind === 'broker') {
                                    vesselRequest.realUserEmail = failedTwinLetterData.realUserEmail;
                                    vesselRequest.user = failedTwinLetterData.owner.email;
                                    vesselRequest.mailId = failedTwinLetterData._id;
                                }

                                _context4.next = 13;
                                return __WEBPACK_IMPORTED_MODULE_33_services__["a" /* default */].postRequestVessel(_extends({}, vesselRequest, {
                                    mailId: failedTwinLetterData._id,
                                    eh: failedTwinLetterData.context.kind,
                                    clientVessel: failedTwinLetterData.owner
                                }));

                            case 13:
                                response = _context4.sent;

                                if (!(response.status === 200)) {
                                    _context4.next = 20;
                                    break;
                                }

                                results.push(_extends({}, response.data, {
                                    status: 'success'
                                }));
                                _context4.next = 18;
                                return __WEBPACK_IMPORTED_MODULE_33_services__["a" /* default */].sendRefNumber(failedTwinLetterData._id, {
                                    refNo: response.data.refNo,
                                    requestId: response.data.id || response.data._id
                                });

                            case 18:
                                _context4.next = 27;
                                break;

                            case 20:
                                if (!(response.status === 409)) {
                                    _context4.next = 26;
                                    break;
                                }

                                results.push(_extends({
                                    status: 'success'
                                }, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[1]')));
                                _context4.next = 24;
                                return __WEBPACK_IMPORTED_MODULE_33_services__["a" /* default */].sendRefNumber(failedTwinLetterData._id, {
                                    refNo: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[1]').refNo,
                                    requestId: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[1]')._id
                                });

                            case 24:
                                _context4.next = 27;
                                break;

                            case 26:
                                results.push({
                                    status: 'error',
                                    message: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[0]')
                                });

                            case 27:
                                _context4.next = 29;
                                return __WEBPACK_IMPORTED_MODULE_30__helpers__["a" /* default */].sleep(1000);

                            case 29:
                                vesselRequestIndex++;
                                _context4.next = 8;
                                break;

                            case 32:
                                return _context4.abrupt('return', results);

                            case 33:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function sendRequestVesselFromSent(_x3) {
                return _ref5.apply(this, arguments);
            }

            return sendRequestVesselFromSent;
        }()
    }, {
        key: 'removeOrderTable',
        value: function removeOrderTable() {
            this.props.removeLastVesselOrder();
        }
    }, {
        key: 'clearOrderTable',
        value: function clearOrderTable() {
            this.props.removeLastVesselOrder();
            this.props.addVesselOrder();
        }
    }, {
        key: 'addOrderTable',
        value: function addOrderTable() {
            this.props.addVesselOrder();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.removeGazetters();
            this.props.removeAnnotations();
            this.props.removeLetter();
        }
    }, {
        key: 'updatePostGazetters',
        value: function updatePostGazetters(textLetter) {
            var _this8 = this;

            this.setState({
                textLetter: textLetter,
                gazetters: [],
                filteredGazetters: [],
                annotations: [],
                updated: true
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this8.props.postGazetters(textLetter, {
                                    emailId: _this8.props.letter._id,
                                    subject: _this8.props.letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(_this8.props.letter.date).format('DD-MM-YYYY')
                                });

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this8);
            })));
        }
    }, {
        key: 'handleClientChange',
        value: function handleClientChange(e, i, value) {
            this.setState({ clientVessel: value });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this9 = this;

            var _state = this.state,
                annotationsServer = _state.annotationsServer,
                clarifiedServer = _state.clarifiedServer,
                textLetter = _state.textLetter,
                updated = _state.updated,
                clientVessel = _state.clientVessel,
                openedAttachmentsDialog = _state.openedAttachmentsDialog,
                failedToSentOpen = _state.failedToSentOpen;
            var _props = this.props,
                routeParams = _props.routeParams,
                letter = _props.letter,
                router = _props.router,
                vesselOrders = _props.vesselOrders,
                objUser = _props.objUser,
                user = _props.user,
                location = _props.location;
            // from gazetter via react router state

            var modifiedTextLetter = void 0;
            var initialTextLetter = void 0;

            if (location.state) {
                modifiedTextLetter = location.state.modifiedTextLetter;
                initialTextLetter = location.state.initialTextLetter;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'single-letter-cargo', className: 'single-letter' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'management' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'management-children' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                label: 'Gazetteer',
                                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id }),
                                primary: true,
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_29__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HtmlContent__["a" /* default */], {
                                    letter: letter
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Content_TextEditor__["a" /* default */], {
                                textLetter: modifiedTextLetter || textLetter || letter.text,
                                originalText: initialTextLetter || letter.text,
                                removeGazetters: this.props.removeGazetters,
                                removeAnnotations: this.props.removeAnnotations,
                                getLetterData: this.getLetterData,
                                updatePostGazetters: this.updatePostGazetters
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Attachments__["a" /* default */], {
                                openedAttachmentsDialog: openedAttachmentsDialog,
                                toggleAttachmentsDialog: this.toggleAttachmentsDialog,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px -10px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                className: 'btn',
                                attachments: letter.attachments
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Size',
                                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id + '/size/vessel' }),
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_6_store_configureStore__["a" /* UserPerms */].isAdmin() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Annotations server',
                                        className: 'btn',
                                        value: annotationsServer,
                                        onChange: this.changeAnnotationsServer,
                                        style: { width: '155px' },
                                        selected: true
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'mailparse.net', primaryText: 'mailparse.net' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 's4.anotatr.com', primaryText: 's4.anotatr.com' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'nata.im', primaryText: 'nata.im' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'polza', primaryText: 'polza' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'localhost', primaryText: 'localhost' })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Clarified server',
                                        className: 'btn',
                                        value: clarifiedServer,
                                        onChange: this.changeClarifiedServer,
                                        style: { width: '110px' },
                                        selected: true,
                                        autoWidth: true
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'standart', primaryText: 'api' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'localhost:7775', primaryText: 'localhost' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 's4.anotatr.com:7777', primaryText: 's4.anotatr.com' })
                                )
                            ) : '',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__common_ToSpamButton__["a" /* default */], {
                                letterId: letter._id,
                                onSuccess: function onSuccess() {
                                    _this9.getLetterData();
                                },
                                disabled: letter.type === 'spam'
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__common_FailedToSent__["b" /* default */], {
                                open: failedToSentOpen,
                                failedTwinsList: letter.failedTwinsByTextHash || [],
                                handleToggleDialog: this.toggleFailedToSentOpen,
                                disabled: this.state.isFormChanged,
                                sendRequest: this.sendRequestVesselFromSent
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject', style: { width: '150px' } },
                            'SUBJECT: ',
                            letter.subject
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject' },
                            'refNo: ',
                            letter.refNo
                        )
                    ),
                    updated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_29__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Content_AnnotationsEditor__["a" /* default */], { letterText: textLetter || letter.text })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_29__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Content_AnnotationsEditor__["a" /* default */], { letterText: modifiedTextLetter || letter.text })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_29__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Content_AnnotationsList__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'sidebar' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h1',
                        null,
                        'Vessel orders ',
                        vesselOrders.length
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_29__ErrorBoundary__["a" /* default */],
                        null,
                        vesselOrders.map(function (vesselOrder, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Sidebar_OrderTable__["a" /* default */], {
                                numberOrderTable: key,
                                key: key
                            });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Base_UserSelector__["a" /* default */], {
                        handleClientChange: this.handleClientChange,
                        client: clientVessel,
                        user: user,
                        letter: letter,
                        errorUser: vesselOrders[0] && vesselOrders[0].validateErrors.find(function (v) {
                            return v.field === 'user';
                        }),
                        onUserUpdate: this.props.updateVesselOrderUser
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'controller-orders' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_27_styles__["a" /* default */].btnOrders, onClick: this.addOrderTable, label: 'Add' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_27_styles__["a" /* default */].btnOrders, onClick: this.removeOrderTable, label: 'Remove' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_27_styles__["a" /* default */].btnOrders, onClick: this.clearOrderTable, label: 'Clear' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_27_styles__["a" /* default */].btnOrders, onClick: this.sendRequestVessel, label: 'Send' })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LetterVessel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        objUser: state.user,
        user: state.vesselOrders.user,
        vesselOrders: state.vesselOrders.items,
        isLogged: state.user.isLogged,
        letter: state.letter,
        annotations: state.annotations.items,
        vesselRequestsResults: state.vesselRequests.results
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateVesselOrderUser: __WEBPACK_IMPORTED_MODULE_23_actions_vessels_orders__["h" /* updateVesselOrderUser */],
        postAnnotations: __WEBPACK_IMPORTED_MODULE_21_actions_annotations__["a" /* postAnnotations */],
        postGazetters: __WEBPACK_IMPORTED_MODULE_22_actions_gazetters__["a" /* postGazetters */],
        addVesselOrder: __WEBPACK_IMPORTED_MODULE_23_actions_vessels_orders__["a" /* addVesselOrder */],
        removeLastVesselOrder: __WEBPACK_IMPORTED_MODULE_23_actions_vessels_orders__["e" /* removeLastVesselOrder */],
        postRequestVessel: __WEBPACK_IMPORTED_MODULE_24_actions_vessels_request__["c" /* postRequestVessel */],
        removeGazetters: __WEBPACK_IMPORTED_MODULE_22_actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_21_actions_annotations__["b" /* removeAnnotations */],
        removeLetter: __WEBPACK_IMPORTED_MODULE_20_actions_letters__["a" /* removeLetter */]
    }, dispatch);
})(LetterVessel);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LetterVessel, 'LetterVessel', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateUserPopup__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-10-23 10:42:15 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2019-11-27 12:36:25
 */












var UserSelector = function (_React$Component) {
    _inherits(UserSelector, _React$Component);

    function UserSelector(props) {
        _classCallCheck(this, UserSelector);

        var _this = _possibleConstructorReturn(this, (UserSelector.__proto__ || Object.getPrototypeOf(UserSelector)).call(this, props));

        _this.state = {
            email: _this.getUserMail(props),
            emails: [],
            isOpenAddUserPopup: false,
            emailWasSet: false
        };

        _this.changeEmail = _this.changeEmail.bind(_this);
        _this.chooseEmail = _this.chooseEmail.bind(_this);
        _this.openAddUserPopup = _this.openAddUserPopup.bind(_this);
        _this.closeAddUserPopup = _this.closeAddUserPopup.bind(_this);
        return _this;
    }

    _createClass(UserSelector, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.letter.expectedBroker !== this.props.letter.expectedBroker) {
                nextProps.handleClientChange(null, null, nextProps.letter.expectedBroker ? nextProps.letter.expectedBroker.email : '');
            }

            var email = this.getUserMail(nextProps);
            if (email === this.state.email) {
                return;
            }

            if (this.state.emailWasSet) {
                return;
            }

            this.setState({
                email: email,
                emailWasSet: true
            }, function () {
                var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this2.props.user);
                newUser.email = _this2.state.email;
                _this2.props.onUserUpdate(newUser);
            });
        }
    }, {
        key: 'getUserMail',
        value: function getUserMail(props) {
            if (props.letter.eh === 'api' && props.letter.owner) {
                return props.letter.owner.email;
            }
            if (props.letter.realUserEmail) {
                return props.letter.realUserEmail;
            }
            return props.user.email || props.letter.sender && props.letter.sender[0].address;
        }
    }, {
        key: 'loadUserInfo',
        value: function loadUserInfo(emailLike) {
            return __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].findUser(emailLike).then(function (response) {
                return response.data.data.map(function (item) {
                    return {
                        email: item.email,
                        item: item
                    };
                });
            }).catch(function (err) {
                console.error(err);
                return null;
            });
        }
    }, {
        key: 'changeEmail',
        value: function changeEmail(searchText) {
            var _this3 = this;

            this.setState({
                email: searchText
            });
            this.loadUserInfo(searchText).then(function (emails) {
                if (_this3.state.email !== searchText) {
                    return;
                }

                _this3.setState({
                    emails: emails
                });

                var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.props.user);
                newUser.email = _this3.state.email;
                _this3.props.onUserUpdate(newUser);
            });
        }
    }, {
        key: 'chooseEmail',
        value: function chooseEmail(updateProperties) {
            var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.user);
            // newUser.email = updateProperties.email;
            newUser.email = updateProperties.item.email;
            this.props.onUserUpdate(newUser);
        }
    }, {
        key: 'openAddUserPopup',
        value: function openAddUserPopup() {
            this.setState({
                isOpenAddUserPopup: true
            });
        }
    }, {
        key: 'closeAddUserPopup',
        value: function closeAddUserPopup() {
            this.setState({
                isOpenAddUserPopup: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var errorUser = this.props.errorUser ? this.props.errorUser.message : '';
            var _state = this.state,
                email = _state.email,
                emails = _state.emails,
                isOpenAddUserPopup = _state.isOpenAddUserPopup;
            var _props = this.props,
                client = _props.client,
                handleClientChange = _props.handleClientChange,
                letter = _props.letter;


            var isB2BRequest = letter.eh === 'api';
            var emailReceiver = letter.receiver && letter.receiver[0] && letter.receiver[0].address;

            var availableBrokers = [];

            if (letter.expectedBroker) {
                availableBrokers.push({
                    value: letter.expectedBroker.email,
                    name: letter.expectedBroker.email
                });
            }
            if (emailReceiver) {
                if (!availableBrokers.some(function (b) {
                    return b.value === emailReceiver;
                })) {
                    availableBrokers.push({
                        value: emailReceiver,
                        name: emailReceiver
                    });
                }
            }

            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_6_classnames__('sidebar-table', { disabled: isB2BRequest }) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CreateUserPopup__["a" /* default */], {
                    isOpen: isOpenAddUserPopup,
                    user: this.props.user,
                    onUserUpdate: this.props.onUserUpdate,
                    closeAddUserPopup: this.closeAddUserPopup
                }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                    'div',
                    { className: 'title' },
                    'CONTACTS'
                ),
                isB2BRequest && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                    'div',
                    { style: { marginBottom: '1em', fontStyle: 'italic' } },
                    'NOTE: This value handled automatically by system'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                    'div',
                    { className: 'row half' },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'column-left' },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new user',
                            onClick: this.openAddUserPopup,
                            primary: true
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'one-forth', style: { justifyContent: 'start' } },
                        'User email:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'one-forth', style: { justifyContent: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a, {
                            name: 'userEmail',
                            textFieldStyle: { fontSize: '13px' },
                            hintText: 'User email or id',
                            errorText: errorUser,
                            searchText: email,
                            dataSource: emails || [],
                            dataSourceConfig: { text: 'email', value: 'item' },
                            onUpdateInput: this.changeEmail,
                            onNewRequest: this.chooseEmail,
                            filter: __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a.noFilter,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true
                            },
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'one-forth' },
                        'Broker:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["s" /* SelectField */],
                            {
                                title: client,
                                floatingLabelText: 'Broker',
                                style: { fontSize: '13px', marginTop: '-25px' },
                                value: client,
                                fullWidth: true,
                                onChange: handleClientChange,
                                disabled: letter.mailCustomGroup,
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui__["m" /* MenuItem */], { value: '', primaryText: '' }),
                            availableBrokers.map(function (b, i) {
                                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui__["m" /* MenuItem */], { key: 'availableBrokers_' + i, value: b.value, primaryText: b.name, title: b.title || b.value });
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui__["m" /* MenuItem */], { value: 'd.zaharov@shipnext.com', primaryText: 'Test (d.zaharov)' }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_material_ui__["m" /* MenuItem */], { value: 'broker@l3r.net', primaryText: 'l3r' })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return UserSelector;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _default = UserSelector;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(UserSelector, 'UserSelector', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/UserSelector/UserSelector.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/UserSelector/UserSelector.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CreateUserPopup = function (_React$Component) {
    _inherits(CreateUserPopup, _React$Component);

    function CreateUserPopup(props) {
        _classCallCheck(this, CreateUserPopup);

        var _this = _possibleConstructorReturn(this, (CreateUserPopup.__proto__ || Object.getPrototypeOf(CreateUserPopup)).call(this, props));

        _this.state = {
            name: props.user.name,
            surname: props.user.surname,
            email: props.user.email,
            emails: [],
            company: props.user.company,
            companies: [],
            phones: [{
                code: props.user.phoneCode,
                phone: props.user.phone
            }],
            errors: {}
        };

        _this.changeEmail = _this.changeEmail.bind(_this);
        _this.chooseEmail = _this.chooseEmail.bind(_this);
        _this.changeCompany = _this.changeCompany.bind(_this);
        _this.chooseCompany = _this.chooseCompany.bind(_this);

        _this.createNewUser = _this.createNewUser.bind(_this);
        _this.changeField = _this.changeField.bind(_this);
        return _this;
    }

    _createClass(CreateUserPopup, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newState) {
            this.setState({
                name: newState.user.name,
                surname: newState.user.surname,
                email: newState.user.email,
                company: newState.user.company,
                phones: [{
                    code: newState.user.phones[0].phoneCode,
                    phone: newState.user.phones[0].phone
                }]
            });
        }
    }, {
        key: 'changeField',
        value: function changeField(e) {
            var name = e.target.name;
            var value = e.target.value;

            switch (name) {
                case 'name':
                    this.setState({
                        name: value
                    });
                    break;
                case 'surname':
                    this.setState({
                        surname: value
                    });
                    break;
                case 'phonecode':
                    this.setState({
                        phones: [{
                            code: value,
                            phone: this.state.phones[0].phone
                        }]
                    });
                    break;
                case 'phonenumber':
                    this.setState({
                        phones: [{
                            code: this.state.phones[0].code,
                            phone: value
                        }]
                    });
                    break;
            }
        }
    }, {
        key: 'changeEmail',
        value: function changeEmail(searchText) {
            var _this2 = this;

            this.setState({
                email: searchText
            }, function () {
                __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findUser(searchText).then(function (response) {
                    if (response.status === 200) {
                        var emails = response.data.data.map(function (item) {
                            return {
                                email: item.email,
                                item: item
                            };
                        });

                        _this2.setState({
                            emails: emails
                        });
                    }
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'chooseEmail',
        value: function chooseEmail(updateProperties) {
            this.setState({
                email: updateProperties.email
            });
        }
    }, {
        key: 'changeCompany',
        value: function changeCompany(searchText) {
            var _this3 = this;

            this.setState({
                company: searchText
            }, function () {
                __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findCompany(searchText).then(function (response) {
                    if (response.status === 200) {
                        var companies = response.data.data.map(function (item) {
                            return {
                                name: item.name,
                                item: item
                            };
                        });

                        _this3.setState({
                            companies: companies
                        });
                    }
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'createErrorObject',
        value: function createErrorObject(errorsArray) {
            var errors = {};
            errorsArray.forEach(function (error) {
                errors['' + error.field] = {
                    message: error.messages[0]
                };
            });

            this.setState({
                errors: errors
            });
        }
    }, {
        key: 'chooseCompany',
        value: function chooseCompany(updateProperties) {
            this.setState({
                company: updateProperties.name
            });
        }
    }, {
        key: 'createNewUser',
        value: function createNewUser() {
            var _this4 = this;

            var userRequest = {
                email: this.state.email,
                company: this.state.company
            };

            if (this.state.phones[0].code || this.state.phones[0].phone) {
                userRequest.phones = this.state.phones;
            }

            if (this.state.name) {
                userRequest.name = this.state.name;
            }

            if (this.state.surname) {
                userRequest.surname = this.state.surname;
            }

            __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].createNewUser(userRequest).then(function (response) {
                if (response.status === 200) {
                    var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this4.props.user);
                    newUser._id = response.data.data._id;
                    newUser.email = userRequest.email;
                    _this4.props.onUserUpdate(newUser);
                    _this4.props.closeAddUserPopup();

                    _this4.props.addNotification({
                        title: 'Success',
                        message: response.data.data.message,
                        level: 'success',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 10
                    });
                }
            }).catch(function (errors) {
                _this4.createErrorObject(errors.response.data.errors);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var actions = [__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: this.props.closeAddUserPopup
            }), __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'Create',
                primary: true,
                onClick: this.createNewUser
            })];

            var emailError = '';
            if (this.state.errors.email) {
                emailError = this.state.errors.email.message;
            }

            if (this.state.emails.length) {
                emailError = 'User with that email already exists!';
            }

            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
                    {
                        title: 'Create new user',
                        actions: actions,
                        modal: true,
                        open: this.props.isOpen,
                        className: 'create-user-popup'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                errorText: this.state.errors.name ? this.state.errors.name.message : '',
                                hintText: 'Name',
                                name: 'name',
                                defaultValue: this.state.name,
                                onChange: this.changeField
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                errorText: this.state.errors.surname ? this.state.errors.surname.message : '',
                                hintText: 'Surname',
                                name: 'surname',
                                defaultValue: this.state.surname,
                                onChange: this.changeField
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                errorText: this.state.errors['phones.0.code'] ? this.state.errors['phones.0.code'].message : '',
                                hintText: 'Phone code',
                                defaultValue: this.state.phones[0].code,
                                name: 'phonecode',
                                onChange: this.changeField
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                errorText: this.state.errors['phones.0.phone'] ? this.state.errors['phones.0.phone'].message : '',
                                hintText: 'Phone number',
                                defaultValue: this.state.phones[0].phone,
                                name: 'phonenumber',
                                onChange: this.changeField
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                                name: 'email',
                                hintText: 'Email Auto Complete',
                                errorText: emailError,
                                searchText: this.state.email,
                                dataSource: this.state.emails,
                                dataSourceConfig: { text: 'email', value: 'item' },
                                onUpdateInput: this.changeEmail,
                                onNewRequest: this.chooseEmail,
                                filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                                name: 'company',
                                hintText: 'Company Auto Complete',
                                errorText: this.state.errors.company ? this.state.errors.company.message : '',
                                searchText: this.state.company,
                                dataSource: this.state.companies,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: this.changeCompany,
                                onNewRequest: this.chooseCompany,
                                filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CreateUserPopup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(CreateUserPopup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CreateUserPopup, 'CreateUserPopup', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/UserSelector/CreateUserPopup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/UserSelector/CreateUserPopup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_vessels_orders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Order_OpenPosition_Component__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Order_Terms__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Order_DisponentWrapper__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_RequestTitle__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Order_Name__ = __webpack_require__(1892);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var OrderTable = function (_React$Component) {
    _inherits(OrderTable, _React$Component);

    function OrderTable(props) {
        _classCallCheck(this, OrderTable);

        var _this = _possibleConstructorReturn(this, (OrderTable.__proto__ || Object.getPrototypeOf(OrderTable)).call(this, props));

        _this.state = {
            searchTextCargoType: ''
        };

        _this.onMessageClose = _this.onMessageClose.bind(_this);
        return _this;
    }

    _createClass(OrderTable, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            if (props.message) {
                this.setState({
                    message: props.message,
                    isOpenMessage: true
                });
            }
        }
    }, {
        key: 'onMessageClose',
        value: function onMessageClose() {
            var _this2 = this;

            this.setState({
                message: '',
                isOpenMessage: false
            }, function () {
                _this2.props.clearMessage(_this2.props.numberOrderTable);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'sidebar-table' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_RequestTitle__["a" /* default */], {
                    orderNumber: this.props.numberOrderTable + 1,
                    text: 'VESSEL ORDER NUMBER',
                    warnings: this.props.vesselOrder.warnings
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Order_Name__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Order_DisponentWrapper__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Order_OpenPosition_Component__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Order_Terms__["a" /* default */], { numberOrderTable: this.props.numberOrderTable })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return OrderTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var vesselOrder = state.vesselOrders.items[ownProps.numberOrderTable];

    return {
        numberOrderTable: ownProps.numberOrderTable,
        vesselOrder: vesselOrder,
        message: vesselOrder.successMessage.message ? vesselOrder.successMessage.message : ''
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        clearMessage: __WEBPACK_IMPORTED_MODULE_3_actions_vessels_orders__["b" /* clearMessage */]
    }, dispatch);
})(OrderTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(OrderTable, 'OrderTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/OrderTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/OrderTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateNewRegion__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AutoComplete__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Base_DateRangeSelector__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Exdd__ = __webpack_require__(1889);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var OpenPosition = function (_React$Component) {
    _inherits(OpenPosition, _React$Component);

    function OpenPosition(props) {
        _classCallCheck(this, OpenPosition);

        var _this = _possibleConstructorReturn(this, (OpenPosition.__proto__ || Object.getPrototypeOf(OpenPosition)).call(this, props));

        _this.changeExdd = function (_a, __a, value) {
            var _order = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.vesselOrder);
            _order.maintenance = value;
            _this.props.updateVesselOrder(_this.props.numberOrderTable, _order);
        };

        _this.state = {
            listPorts: [],
            openDialog: false,
            canRequestNewRegion: true
        };

        _this.addOpenPosition = _this.addOpenPosition.bind(_this);
        _this.removeOpenPosition = _this.removeOpenPosition.bind(_this);

        _this.changeOpenPosition = _this.changeOpenPosition.bind(_this);
        return _this;
    }

    _createClass(OpenPosition, [{
        key: 'removeOpenPosition',
        value: function removeOpenPosition(key) {
            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);
            newVesselOrder.open.splice(key, 1);
            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
        }
    }, {
        key: 'addOpenPosition',
        value: function addOpenPosition() {
            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);
            var firstLPort = this.props.vesselOrder.open[this.props.vesselOrder.open.length - 1];

            newVesselOrder.open.push({
                where: '',
                namePort: '',
                from: firstLPort.from,
                until: firstLPort.until
            });

            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
        }
    }, {
        key: 'changeOpenPosition',
        value: function changeOpenPosition(key, position) {
            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);
            newVesselOrder.open[key] = _extends({}, newVesselOrder.open[key], position);
            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var errorWhere = this.props.errorWhere ? this.props.errorWhere.messages[0] : '';
            var errorFrom = this.props.errorFrom ? this.props.errorFrom.messages[0] : '';
            var errorUntil = this.props.errorUntil ? this.props.errorUntil.messages[0] : '';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Open positions:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new position',
                            onClick: this.addOpenPosition,
                            primary: true
                        })
                    )
                ),
                this.props.vesselOrder.open.map(function (openPosition, key) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { key: key },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'column-left' },
                                'Open position - ' + (key + 1)
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'row half' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AutoComplete__["a" /* default */], {
                                error: errorWhere,
                                openPosition: openPosition,
                                portKey: key,
                                changeOpenPosition: _this2.changeOpenPosition
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'column-right half' },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CreateNewRegion__["a" /* default */], {
                                    numberOfPort: key,
                                    numberOrderTable: _this2.props.numberOrderTable,
                                    vesselOrder: _this2.props.vesselOrder
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Base_DateRangeSelector__["a" /* default */], {
                            from: openPosition.from,
                            until: openPosition.until,
                            fromHint: openPosition.fromOld,
                            untilHint: openPosition.untilOld,
                            errorFrom: errorFrom,
                            errorUntil: errorUntil,
                            onChange: function onChange(range) {
                                return _this2.changeOpenPosition(key, range);
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'row half' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'column-left' },
                                key === 0 ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                                    labelStyle: { fontSize: '10px' },
                                    style: { height: '25px', margin: '8px 0' },
                                    buttonStyle: { height: '25px', lineHeight: '25px' },
                                    label: 'Remove port',
                                    onClick: function onClick() {
                                        _this2.removeOpenPosition(key);
                                    },
                                    secondary: true
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'column-left' },
                                'Exddss'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'column-right' },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Exdd__["a" /* default */], {
                                    changeExdd: _this2.changeExdd,
                                    exdd: _this2.props.vesselOrder.maintenance || null
                                })
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return OpenPosition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var vesselOrder = state.vesselOrders.items[ownProps.numberOrderTable];

    var errorWhere = vesselOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'open.where';
    });

    var errorFrom = vesselOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'open.from';
    });

    var errorUntil = vesselOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'open.until';
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        errorWhere: errorWhere,
        errorFrom: errorFrom,
        errorUntil: errorUntil,
        vesselOrder: vesselOrder
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselOrder: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__["g" /* updateVesselOrder */]
    }, dispatch);
})(OpenPosition);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(OpenPosition, 'OpenPosition', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/Component.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/Component.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_vessels_orders__ = __webpack_require__(100);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CreateNewRegion = function (_React$Component) {
    _inherits(CreateNewRegion, _React$Component);

    function CreateNewRegion(props) {
        _classCallCheck(this, CreateNewRegion);

        var _this = _possibleConstructorReturn(this, (CreateNewRegion.__proto__ || Object.getPrototypeOf(CreateNewRegion)).call(this, props));

        _this.state = {
            openDialog: false,
            canRequestNewRegion: true,
            value: '',
            openSnackbar: false,
            message: ''
        };

        _this.handleOpenDialog = _this.handleOpenDialog.bind(_this);
        _this.handleCloseDialog = _this.handleCloseDialog.bind(_this);
        _this.onInputNewRegion = _this.onInputNewRegion.bind(_this);
        _this.sendNewRegion = _this.sendNewRegion.bind(_this);
        _this.onSnackbarClose = _this.onSnackbarClose.bind(_this);
        return _this;
    }

    _createClass(CreateNewRegion, [{
        key: 'sendNewRegion',
        value: function sendNewRegion() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_8_services__["a" /* default */].checkAndCreateRegion(this.state.value).then(function (response) {
                if (response.status === 200) {
                    return _this2.setState({
                        openSnackbar: true,
                        message: 'Region success added',
                        openDialog: false,
                        canRequestNewRegion: true,
                        value: ''
                    }, function () {
                        var newVesselOrder = _.cloneDeep(_this2.props.vesselOrder);

                        newVesselOrder.open[_this2.props.numberOfPort].namePort = response.data.data.name;
                        newVesselOrder.open[_this2.props.numberOfPort].where = response.data.data._id;

                        _this2.props.updateVesselOrder(_this2.props.numberOrderTable, newVesselOrder);
                    });
                }

                return _this2.setState({
                    openSnackbar: true,
                    message: 'Region does not added',
                    openDialog: false,
                    canRequestNewRegion: true,
                    value: ''
                });
            }).catch(function () {
                return _this2.setState({
                    openSnackbar: true,
                    message: 'Region does not added',
                    openDialog: false,
                    canRequestNewRegion: true,
                    value: ''
                });
            });
        }
    }, {
        key: 'handleCloseDialog',
        value: function handleCloseDialog() {
            this.setState({
                openDialog: false,
                canRequestNewRegion: true,
                value: ''
            });
        }
    }, {
        key: 'handleOpenDialog',
        value: function handleOpenDialog() {
            this.setState({
                openDialog: true,
                canRequestNewRegion: true
            });
        }
    }, {
        key: 'onInputNewRegion',
        value: function onInputNewRegion(e) {
            var canRequestNewRegion = true;
            var value = e.target.value;

            if (value.length > 0) {
                canRequestNewRegion = false;
            }

            this.setState({
                canRequestNewRegion: canRequestNewRegion,
                value: value
            });
        }
    }, {
        key: 'onSnackbarClose',
        value: function onSnackbarClose() {
            this.setState({
                openSnackbar: false,
                message: ''
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: this.handleCloseDialog
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
                label: 'Send',
                primary: true,
                disabled: this.state.canRequestNewRegion,
                onClick: this.sendNewRegion
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                    labelStyle: { fontSize: '10px' },
                    style: { height: '25px', margin: '10px 0 0 0' },
                    buttonStyle: { height: '25px', lineHeight: '25px' },
                    label: 'Create new region',
                    onClick: this.handleOpenDialog,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Snackbar___default.a, {
                    open: this.state.openSnackbar,
                    message: this.state.message,
                    autoHideDuration: 2000,
                    onRequestClose: this.onSnackbarClose
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
                    {
                        title: 'Create new region',
                        actions: actions,
                        modal: true,
                        open: this.state.openDialog
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                        hintText: 'Enter new region',
                        floatingLabelFixed: true,
                        onChange: this.onInputNewRegion
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CreateNewRegion;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        numberOfPort: ownProps.numberOfPort,
        cargoOrder: ownProps.cargoOrder,
        numberOrderTable: ownProps.numberOrderTable
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateVesselOrder: __WEBPACK_IMPORTED_MODULE_9_actions_vessels_orders__["g" /* updateVesselOrder */]
    }, dispatch);
})(CreateNewRegion);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CreateNewRegion, 'CreateNewRegion', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/CreateNewRegion.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/CreateNewRegion.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var OpenPositionAutoComplete = function (_React$Component) {
    _inherits(OpenPositionAutoComplete, _React$Component);

    function OpenPositionAutoComplete(props) {
        _classCallCheck(this, OpenPositionAutoComplete);

        var _this = _possibleConstructorReturn(this, (OpenPositionAutoComplete.__proto__ || Object.getPrototypeOf(OpenPositionAutoComplete)).call(this, props));

        _this.state = {
            ports: [],
            openPosition: props.openPosition,
            key: props.key,
            error: props.error
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (searchText) {
            if (searchText.length <= 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].findPortAdmin({ name: searchText, withAreas: true }).then(function (response) {
                var ports = [];

                response.data.data.forEach(function (port) {
                    ports.push.apply(ports, _toConsumableArray(_this.createPort(port)));
                });

                _this.setState({
                    ports: ports
                });
            }).catch(function () {
                return null;
            });
        }, 1000);

        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(OpenPositionAutoComplete, [{
        key: 'createPort',
        value: function createPort(port) {
            var ports = [];
            var name = '';

            if (port.sub) {
                port.sub.forEach(function (subPort) {
                    ports.push({
                        item: subPort,
                        text: subPort.name + ' - country ' + port.country.name,
                        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["m" /* MenuItem */], {
                            primaryText: subPort.name + ' - country ' + port.country.name,
                            value: subPort,
                            style: { paddingLeft: '30px' }
                        })
                    });
                });
            }

            if (port.country) {
                name = port.name + ' - country ' + port.country.name;
            } else {
                name = port.name;
            }

            return [{
                item: port,
                text: name,
                value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["m" /* MenuItem */], {
                    primaryText: name,
                    value: port
                })
            }].concat(ports);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                openPosition: nextProps.openPosition,
                key: nextProps.key,
                error: nextProps.error
            });
        }
    }, {
        key: 'changeAutoComplete',
        value: function changeAutoComplete(searchText) {
            var _this2 = this;

            var openPosition = this.state.openPosition;

            openPosition.namePort = searchText;

            this.setState({
                openPosition: openPosition
            }, function () {
                _this2.dAutocomplete(searchText);
            });
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            var _this3 = this;

            if (!updateProperties || typeof updateProperties === 'string') {
                return;
            }

            var openPosition = this.state.openPosition;


            openPosition.where = updateProperties.item._id;
            openPosition.namePort = updateProperties.item.name;

            this.setState({
                openPosition: openPosition
            }, function () {
                var portKey = _this3.props.portKey;


                _this3.props.changeOpenPosition(portKey, openPosition);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                openPosition = _state.openPosition,
                ports = _state.ports,
                error = _state.error;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'column-left half' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'label' },
                    openPosition.where
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                    errorText: error,
                    textFieldStyle: { fontSize: '13px' },
                    hintText: 'Port',
                    searchText: openPosition.namePort,
                    dataSource: ports,
                    onUpdateInput: this.changeAutoComplete,
                    onNewRequest: this.chooseAutoComplete,
                    filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                    listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                    menuStyle: { width: 'auto' },
                    popoverProps: {
                        canAutoPosition: true
                    }
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return OpenPositionAutoComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref) {
    var openPosition = _ref.openPosition,
        error = _ref.error,
        portKey = _ref.portKey,
        changeOpenPosition = _ref.changeOpenPosition;
    return {
        openPosition: openPosition,
        error: error,
        portKey: portKey,
        changeOpenPosition: changeOpenPosition
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(OpenPositionAutoComplete);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(OpenPositionAutoComplete, 'OpenPositionAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/AutoComplete.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/AutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function Exdd(_ref) {
    var exdd = _ref.exdd,
        changeExdd = _ref.changeExdd;


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["s" /* SelectField */],
        {
            floatingLabelText: 'Exdd',
            floatingLabelStyle: { fontSize: '14px' },
            style: { fontSize: '13px' },
            onChange: changeExdd,
            value: exdd,
            autoWidth: true
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], { value: undefined }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], { value: 'exdd', primaryText: 'ex dry dock' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], { value: 'exss', primaryText: 'ex ss' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], { value: 'exddss', primaryText: 'ex dd/ss' })
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(Exdd);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Exdd, 'Exdd', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/Exdd.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/Exdd.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__ = __webpack_require__(100);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var typeTerms = ['Direction dets:', 'Cargo dets:', 'Period dets:', 'Other:'];

var Terms = function (_React$Component) {
    _inherits(Terms, _React$Component);

    function Terms(props) {
        _classCallCheck(this, Terms);

        var _this = _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).call(this, props));

        _this.state = {
            errors: []
        };

        _this.onChangeTerm = _this.onChangeTerm.bind(_this);
        _this.addNewTerm = _this.addNewTerm.bind(_this);
        _this.removeTerm = _this.removeTerm.bind(_this);
        _this.showError = _this.showError.bind(_this);
        _this.onChangeTypeTerm = _this.onChangeTypeTerm.bind(_this);
        return _this;
    }

    _createClass(Terms, [{
        key: 'removeTerm',
        value: function removeTerm(number) {
            this.deleteError(number);
            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);
            newVesselOrder.terms.splice(number, 1);
            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
        }
    }, {
        key: 'addNewTerm',
        value: function addNewTerm() {
            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);
            newVesselOrder.terms.push({ type: '', value: '' });
            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
        }
    }, {
        key: 'onChangeTypeTerm',
        value: function onChangeTypeTerm(key, numberElement) {
            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);
            newVesselOrder.terms[numberElement].type = typeTerms[key];
            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
        }
    }, {
        key: 'onChangeTerm',
        value: function onChangeTerm(value, numberElement) {
            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);
            newVesselOrder.terms[numberElement].value = value;
            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            /*
            if (newProps.validateErrors && newProps.validateErrors.length) {
                const errors = [];
                newProps.validateErrors.forEach((validateError) => {
                    const typeError = validateError.field.split('.');
                     if (typeError[0] === 'terms') {
                        errors.push({ key: +typeError[2], text: validateError.messages[0] });
                    }
                });
                 this.setState({
                    errors,
                });
            }*/
        }
    }, {
        key: 'deleteError',
        value: function deleteError(key) {
            var errors = this.state.errors.filter(function (error) {
                return error.key !== key;
            });

            this.setState({
                errors: errors
            });
        }
    }, {
        key: 'showError',
        value: function showError(key) {
            var errorObject = this.state.errors.find(function (error) {
                return error.key === key;
            });

            return errorObject ? errorObject.text : '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Terms:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new term',
                            onClick: this.addNewTerm,
                            primary: true
                        })
                    )
                ),
                this.props.vesselOrder.terms.map(function (term, key) {
                    var errorMessage = _this2.showError(key);
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { key: key, className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            'Term ' + key
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'column-right' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                                {
                                    style: {
                                        padding: '0 5px',
                                        width: '80%',
                                        fontSize: '13px'
                                    },
                                    defaultValue: term.type,
                                    value: term.type,
                                    onChange: function onChange(e, numberSelected) {
                                        _this2.onChangeTypeTerm(numberSelected, key);
                                    },
                                    maxHeight: 200,
                                    autoWidth: true
                                },
                                typeTerms.map(function (typeTerm, i) {
                                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, {
                                        key: i,
                                        style: { width: 'auto', fontSize: '13px' },
                                        value: typeTerm,
                                        primaryText: typeTerm
                                    });
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                style: { fontSize: '13px' },
                                value: term.value,
                                hintText: 'Term ' + key,
                                errorText: errorMessage,
                                onChange: function onChange(e) {
                                    return _this2.onChangeTerm(e.target.value, key);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Remove term',
                                onClick: function onClick() {
                                    return _this2.removeTerm(key);
                                },
                                secondary: true
                            })
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Terms;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        numberOrderTable: ownProps.numberOrderTable,
        validateErrors: state.vesselOrders.items[ownProps.numberOrderTable].validateErrors,
        vesselOrder: state.vesselOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselOrder: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__["g" /* updateVesselOrder */]
    }, dispatch);
})(Terms);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(typeTerms, 'typeTerms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/Terms.jsx');
    reactHotLoader.register(Terms, 'Terms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/Terms.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/Terms.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Vessels_Single_Rows_DisponentOwner__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_vessels_orders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








function DisponentWrapper(_ref) {
    var numberOrderTable = _ref.numberOrderTable,
        updateVesselOrder = _ref.updateVesselOrder,
        vesselOrder = _ref.vesselOrder,
        context = _ref.context;

    var changeField = function changeField(_ref2) {
        var value = _ref2.value;

        var newVesselOrder = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(vesselOrder);
        newVesselOrder.disponentOwner = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(value, ['name', '_id']);
        updateVesselOrder(numberOrderTable, newVesselOrder);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-left', style: { marginTop: '25px' } },
            'Disponent owner:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Vessels_Single_Rows_DisponentOwner__["a" /* default */], {
                changeField: changeField,
                disponentOwner: vesselOrder.disponentOwner,
                confirmed: context.kind !== 'broker',
                textFieldStyle: { fontSize: '13px' },
                context: context
            })
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        context: state.letter.context,
        numberOrderTable: ownProps.numberOrderTable,
        vesselOrder: state.vesselOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateVesselOrder: __WEBPACK_IMPORTED_MODULE_4_actions_vessels_orders__["g" /* updateVesselOrder */]
    }, dispatch);
})(DisponentWrapper);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DisponentWrapper, 'DisponentWrapper', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/DisponentWrapper.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/DisponentWrapper.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_vessels_orders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Name = function (_React$Component) {
    _inherits(Name, _React$Component);

    function Name(props) {
        _classCallCheck(this, Name);

        var _this = _possibleConstructorReturn(this, (Name.__proto__ || Object.getPrototypeOf(Name)).call(this, props));

        _this.state = {
            vesselNames: [],
            vesselName: props.vesselOrder.vesselName,
            imoNumber: props.vesselOrder.imoNumber,
            DWT: props.vesselOrder.DWT,
            BLT: props.vesselOrder.BLT,
            _id: props.vesselOrder.vessel
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (searchText) {
            __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findVessel(searchText).then(function (response) {
                var vesselNames = response.data.data.map(function (vessel) {
                    return {
                        name: vessel.name + ' (imoNumber - ' + vessel.imoNumber + ')',
                        item: vessel
                    };
                });

                _this.setState({
                    vesselNames: vesselNames
                });
            }).then(function () {
                var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.vesselOrder);
                newVesselOrder.vesselName = searchText;
                _this.props.updateVesselOrder(_this.props.numberOrderTable, newVesselOrder);
            }).catch(function () {
                return null;
            });
        }, 1000);

        _this.changeVesselName = _this.changeVesselName.bind(_this);
        _this.chooseVessel = _this.chooseVessel.bind(_this);
        return _this;
    }

    _createClass(Name, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            this.setState({
                vesselName: props.vesselOrder.vesselName,
                imoNumber: props.vesselOrder.imoNumber,
                DWT: props.vesselOrder.DWT,
                BLT: props.vesselOrder.BLT,
                _id: props.vesselOrder.vessel
            });
        }
    }, {
        key: 'changeVesselName',
        value: function changeVesselName(searchText) {
            var _this2 = this;

            this.setState({
                vesselName: searchText
            }, function () {
                _this2.dAutocomplete(searchText);
            });
        }
    }, {
        key: 'chooseVessel',
        value: function chooseVessel(updateProperties) {
            if (!updateProperties) {
                return;
            }

            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrder);

            newVesselOrder.vesselName = updateProperties.name;
            newVesselOrder.vessel = updateProperties.item._id;
            newVesselOrder.imoNumber = updateProperties.item.imoNumber;
            newVesselOrder.DWT = updateProperties.item.dw.summer;
            newVesselOrder.BLT = updateProperties.item.blt;

            this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);

            this.setState({
                imoNumber: updateProperties.item.imoNumber,
                DWT: updateProperties.item.dw.summer,
                BLT: updateProperties.item.blt,
                _id: updateProperties.item._id
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var errorVesselName = this.props.errorVesselName ? this.props.errorVesselName.messages[0] : '';

            var _state = this.state,
                _id = _state._id,
                vesselName = _state.vesselName;
            var params = this.props.params;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Vessel name:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right', style: { display: 'flex' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a, {
                            name: 'vesselName',
                            textFieldStyle: { fontSize: '13px' },
                            hintText: 'Vessel name',
                            errorText: errorVesselName,
                            searchText: this.state.vesselName || '',
                            dataSource: this.state.vesselNames,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: this.changeVesselName,
                            onNewRequest: this.chooseVessel,
                            filter: __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a.noFilter,
                            fullWidth: true,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true
                            },
                            style: { display: 'flex', width: '70%', marginRight: '10px' }
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["r" /* RaisedButton */], {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px', margin: 'auto 0' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Composition',
                            onClick: function onClick() {
                                var url = 'emailId=' + params.id;
                                if (_id && vesselName) {
                                    url += '&_id=' + _id + '&name=' + vesselName;
                                }
                                window.open(window.location.origin + '/vessels/composition?' + url, '_blank');
                            },
                            secondary: true
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'imoNumber:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            this.state.imoNumber
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'DWT:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            this.state.DWT
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'BLT:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            this.state.BLT
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Name;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var errorVesselName = state.vesselOrders.items[ownProps.numberOrderTable].validateErrors.find(function (validateError) {
        return validateError.field === 'vessel';
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        errorVesselName: errorVesselName,
        vesselOrder: state.vesselOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselOrder: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_orders__["g" /* updateVesselOrder */]
    }, dispatch);
})(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* withRouter */])(Name));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Name, 'Name', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/Name.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Sidebar/Order/Name.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__ = __webpack_require__(100);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SelectedTextPopup = function (_React$Component) {
    _inherits(SelectedTextPopup, _React$Component);

    function SelectedTextPopup(props) {
        _classCallCheck(this, SelectedTextPopup);

        var _this = _possibleConstructorReturn(this, (SelectedTextPopup.__proto__ || Object.getPrototypeOf(SelectedTextPopup)).call(this, props));

        _this.state = {
            numberVesselOrder: null
        };

        _this.selectVesselOrder = _this.selectVesselOrder.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(SelectedTextPopup, [{
        key: 'onChange',
        value: function onChange(e, fieldValue) {
            if (this.state.numberVesselOrder === null) {
                return;
            }

            var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrders[this.state.numberVesselOrder]);
            var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselOrderUser);

            switch (fieldValue) {
                case 'term':
                    newVesselOrder.terms.push({ type: '', value: this.props.chosenText });
                    break;
                // todo check for autocomplete user
                case 'email':
                    newUser.email = this.props.chosenText;
                    break;
                case 'company':
                    newUser.company = this.props.chosenText;
                    break;
                case 'name':
                    newUser.name = this.props.chosenText;
                    break;
                case 'surname':
                    newUser.surname = this.props.chosenText;
                    break;
                case 'phonecode':
                    newUser.phones[0].code = this.props.chosenText;
                    break;
                case 'phone':
                    newUser.phones[0].phone = this.props.chosenText;
                    break;
            }

            this.props.updateVesselOrder(this.state.numberVesselOrder, newVesselOrder);
            this.props.updateVesselOrderUser(newUser);
            this.props.closePopover();
        }
    }, {
        key: 'selectVesselOrder',
        value: function selectVesselOrder(e, index, value) {
            this.setState({
                numberVesselOrder: value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var renderMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default.a,
                { onChange: this.onChange },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Term', value: 'term' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Email user', value: 'email' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Company new user', value: 'company' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Name new user', value: 'name' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Surname new user', value: 'surname' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone code new user', value: 'phonecode' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone number new user', value: 'phone' })
            );

            if (this.state.numberVesselOrder === null) {
                renderMenu = null;
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'popup' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default.a,
                    {
                        open: this.props.openPopover,
                        anchorEl: this.props.anchorEl,
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' },
                        onRequestClose: this.props.closePopover,
                        animation: __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__["PopoverAnimationVertical"]
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'popup-choose' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'chosen' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'chosen-title' },
                                'Chosen text'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'chosen-row' },
                                '\'' + this.props.chosenText + '\''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
                        {
                            floatingLabelText: 'Choose vessel order',
                            value: this.state.numberVesselOrder,
                            onChange: this.selectVesselOrder,
                            style: {
                                width: '200px',
                                padding: '0 10px'
                            }
                        },
                        this.props.vesselOrders.map(function (item, i) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                key: i,
                                value: i,
                                primaryText: 'Vessel order - ' + i
                            });
                        })
                    ),
                    renderMenu
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SelectedTextPopup;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        openPopover: ownProps.openPopover,
        anchorEl: ownProps.anchorEl,
        closePopover: ownProps.closePopover,
        chosenText: ownProps.chosenText,
        vesselOrders: state.vesselOrders.items,
        vesselOrderUser: state.vesselOrders.user
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselOrder: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__["g" /* updateVesselOrder */],
        updateVesselOrderUser: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__["h" /* updateVesselOrderUser */]
    }, dispatch);
})(SelectedTextPopup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SelectedTextPopup, 'SelectedTextPopup', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/SelectedTextPopup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Vessel/Content/SelectedTextPopup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = FailedToSentTable;
/* unused harmony export StyledTableHeaderColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FailedToSent__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FailedToSentRow__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(277);
var _templateObject = _taggedTemplateLiteral(['\n    width: ', ';\n    padding-left: ', ' !important;\n    padding-right: ', ' !important;\n'], ['\n    width: ', ';\n    padding-left: ', ' !important;\n    padding-right: ', ' !important;\n']);

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }







function FailedToSentTable(_ref) {
    var sendRequest = _ref.sendRequest;

    var _useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__FailedToSent__["a" /* FailedTwinsContext */]),
        failedTwins = _useContext.failedTwins;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui__["u" /* Table */],
        {
            fixedHeader: true,
            selectable: false
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["w" /* TableHeader */],
            {
                displaySelectAll: false,
                adjustForCheckbox: false
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledTableHeaderColumn,
                    { width: 34 },
                    'Subject'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledTableHeaderColumn,
                    { width: 5 },
                    'Link'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledTableHeaderColumn,
                    { width: 15 },
                    'Broker Email'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledTableHeaderColumn,
                    { width: 15 },
                    'Real User Email'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledTableHeaderColumn,
                    { width: 15 },
                    'Result refNos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledTableHeaderColumn,
                    { width: 5, pl: 12, pr: 12 },
                    'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledTableHeaderColumn,
                    { width: 11 },
                    'Management'
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["v" /* TableBody */],
            { displayRowCheckbox: false },
            failedTwins.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
                    { key: 'failedTwin_' + index },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FailedToSentRow__["a" /* default */], {
                        key: 'failedTwin_' + index,
                        itemIndex: index,
                        item: item,
                        sendRequest: sendRequest
                    })
                );
            })
        )
    );
}

var StyledTableHeaderColumn = Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */])(_templateObject, function (props) {
    return props.width + '%';
}, function (props) {
    return props.pl + 'px';
}, function (props) {
    return props.pr + 'px';
});
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FailedToSentTable, 'FailedToSentTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentTable.jsx');
    reactHotLoader.register(StyledTableHeaderColumn, 'StyledTableHeaderColumn', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = FailedToSentRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_open_in_new__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_open_in_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_open_in_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done_all__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RefNosTooltip__ = __webpack_require__(1902);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: ', ';\n    padding-left: ', ' !important;\n    padding-right: ', ' !important;\n    position: ', ';\n'], ['\n    width: ', ';\n    padding-left: ', ' !important;\n    padding-right: ', ' !important;\n    position: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n    border-top: 15px solid #00BCD4;\n    border-right: 15px solid transparent;\n    z-index: 1;\n'], ['\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n    border-top: 15px solid #00BCD4;\n    border-right: 15px solid transparent;\n    z-index: 1;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding-left: 12px;\n    width: 36px !important;\n'], ['\n    padding-left: 12px;\n    width: 36px !important;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    color: gray;\n    text-decoration: underline;\n    cursor: pointer;\n'], ['\n    color: gray;\n    text-decoration: underline;\n    cursor: pointer;\n']);

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }









/**
 * 
 * @param {{
 *  item: import('./FailedToSent').FailedTwin & import('./FailedToSent').UpdateStatuses
 *  sendRequest: Function,
 *  itemIndex: number,
 * }} props  
 */
function FailedToSentRow(_ref) {
    var item = _ref.item,
        sendRequest = _ref.sendRequest,
        itemIndex = _ref.itemIndex;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        elementTarget = _useState2[0],
        setElementTarget = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        openRefNosTooltip = _useState4[0],
        setOpenRefNosTooltip = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])( /** @type {'success' | 'error' | 'pending' | undefined } */undefined),
        _useState6 = _slicedToArray(_useState5, 2),
        status = _useState6[0],
        setStatus = _useState6[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setStatus(item.status);
    }, [item.status]);

    var closeTooltip = function closeTooltip() {
        setOpenRefNosTooltip(false);
    };

    var onRefNosClick = function onRefNosClick(event) {
        setElementTarget(event.target);
        setOpenRefNosTooltip(true);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RefNosTooltip__["a" /* default */], {
            elementTarget: elementTarget,
            open: openRefNosTooltip,
            close: closeTooltip,
            refNos: item.refNos || []
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTableRowColumn,
            {
                title: item.subject,
                width: 34,
                isByPayloadHash: item.isByPayloadHash
            },
            item.isByPayloadHash && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TriangleIndicator, { title: 'Found by payload hash' }),
            item.subject
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTableRowColumn,
            { width: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                { style: { transform: 'translateY(10px)', display: 'flex', padding: 'unset' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_open_in_new___default.a, {
                    onClick: function onClick() {
                        return window.open('/' + item._id, '_blank');
                    }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTableRowColumn,
            { width: 15 },
            item.context.mailGateEmail
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTableRowColumn,
            { width: 15 },
            item.realUserEmail || null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTableRowColumn,
            { width: 15 },
            item.refNos && item.refNos.length && status === 'success' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                StyledShow,
                { onClick: function onClick(e) {
                        return onRefNosClick(e);
                    } },
                'Show'
            ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTableRowColumn,
            { width: 5, nop: true, style: { textAlign: 'center' } },
            status === 'pending' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["d" /* CircularProgress */], { size: 20 }) : null,
            status === 'success' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledDone, { color: 'green' }) : null,
            status === 'error' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledNotDone, { color: 'red' }) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledTableRowColumn,
            { width: 11 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                label: 'Send',
                secondary: true,
                onClick: function onClick() {
                    return sendRequest(itemIndex);
                }
            })
        )
    );
}

var StyledTableRowColumn = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */])(_templateObject, function (props) {
    return props.width + '%';
}, function (props) {
    return props.nop ? 'unset' : '24px';
}, function (props) {
    return props.nop ? 'unset' : '24px';
}, function (props) {
    return props.isByPayloadHash ? 'relative' : 'initial';
});

var TriangleIndicator = __WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].div(_templateObject2);

var StyledDone = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_done_all___default.a)(_templateObject3);

var StyledNotDone = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default.a)(_templateObject3);

var StyledShow = __WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].span(_templateObject4);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FailedToSentRow, 'FailedToSentRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentRow.jsx');
    reactHotLoader.register(StyledTableRowColumn, 'StyledTableRowColumn', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentRow.jsx');
    reactHotLoader.register(TriangleIndicator, 'TriangleIndicator', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentRow.jsx');
    reactHotLoader.register(StyledDone, 'StyledDone', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentRow.jsx');
    reactHotLoader.register(StyledNotDone, 'StyledNotDone', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentRow.jsx');
    reactHotLoader.register(StyledShow, 'StyledShow', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/FailedToSentRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* harmony export (immutable) */ __webpack_exports__["b"] = __spreadArray;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
});


/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPropValid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(1898);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);




/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return memoize; });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),
/* 1899 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CHARSET */
/* unused harmony export COMMENT */
/* unused harmony export COUNTER_STYLE */
/* unused harmony export DECLARATION */
/* unused harmony export DOCUMENT */
/* unused harmony export FONT_FACE */
/* unused harmony export FONT_FEATURE_VALUES */
/* unused harmony export IMPORT */
/* unused harmony export KEYFRAMES */
/* unused harmony export LAYER */
/* unused harmony export MEDIA */
/* unused harmony export MOZ */
/* unused harmony export MS */
/* unused harmony export NAMESPACE */
/* unused harmony export PAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return c; });
/* unused harmony export SCOPE */
/* unused harmony export SUPPORTS */
/* unused harmony export VIEWPORT */
/* unused harmony export WEBKIT */
/* unused harmony export abs */
/* unused harmony export alloc */
/* unused harmony export append */
/* unused harmony export assign */
/* unused harmony export caret */
/* unused harmony export char */
/* unused harmony export character */
/* unused harmony export characters */
/* unused harmony export charat */
/* unused harmony export column */
/* unused harmony export combine */
/* unused harmony export comment */
/* unused harmony export commenter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ue; });
/* unused harmony export copy */
/* unused harmony export dealloc */
/* unused harmony export declaration */
/* unused harmony export delimit */
/* unused harmony export delimiter */
/* unused harmony export escaping */
/* unused harmony export filter */
/* unused harmony export from */
/* unused harmony export hash */
/* unused harmony export identifier */
/* unused harmony export indexof */
/* unused harmony export length */
/* unused harmony export lift */
/* unused harmony export line */
/* unused harmony export match */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return be; });
/* unused harmony export namespace */
/* unused harmony export next */
/* unused harmony export node */
/* unused harmony export parse */
/* unused harmony export peek */
/* unused harmony export position */
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return de; });
/* unused harmony export prev */
/* unused harmony export replace */
/* unused harmony export ruleset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return we; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pe; });
/* unused harmony export sizeof */
/* unused harmony export slice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return he; });
/* unused harmony export strlen */
/* unused harmony export substr */
/* unused harmony export token */
/* unused harmony export tokenize */
/* unused harmony export tokenizer */
/* unused harmony export trim */
/* unused harmony export whitespace */
var e="-ms-";var r="-moz-";var a="-webkit-";var n="comm";var c="rule";var s="decl";var t="@page";var u="@media";var i="@import";var f="@charset";var o="@viewport";var l="@supports";var v="@document";var p="@namespace";var h="@keyframes";var b="@font-face";var w="@counter-style";var d="@font-feature-values";var g="@layer";var k="@scope";var $=Math.abs;var m=String.fromCharCode;var x=Object.assign;function y(e,r){return A(e,0)^45?(((r<<2^A(e,0))<<2^A(e,1))<<2^A(e,2))<<2^A(e,3):0}function j(e){return e.trim()}function z(e,r){return(e=r.exec(e))?e[0]:e}function C(e,r,a){return e.replace(r,a)}function O(e,r,a){return e.indexOf(r,a)}function A(e,r){return e.charCodeAt(r)|0}function M(e,r,a){return e.slice(r,a)}function S(e){return e.length}function q(e){return e.length}function B(e,r){return r.push(e),e}function D(e,r){return e.map(r).join("")}function E(e,r){return e.filter((function(e){return!z(e,r)}))}var F=1;var G=1;var H=0;var I=0;var J=0;var K="";function L(e,r,a,n,c,s,t,u){return{value:e,root:r,parent:a,type:n,props:c,children:s,line:F,column:G,length:t,return:"",siblings:u}}function N(e,r){return x(L("",null,null,"",null,null,0,e.siblings),e,{length:-e.length},r)}function P(e){while(e.root)e=N(e.root,{children:[e]});B(e,e.siblings)}function Q(){return J}function R(){J=I>0?A(K,--I):0;if(G--,J===10)G=1,F--;return J}function T(){J=I<H?A(K,I++):0;if(G++,J===10)G=1,F++;return J}function U(){return A(K,I)}function V(){return I}function W(e,r){return M(K,e,r)}function X(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function Y(e){return F=G=1,H=S(K=e),I=0,[]}function Z(e){return K="",e}function _(e){return j(W(I-1,ce(e===91?e+2:e===40?e+1:e)))}function ee(e){return Z(ae(Y(e)))}function re(e){while(J=U())if(J<33)T();else break;return X(e)>2||X(J)>3?"":" "}function ae(e){while(T())switch(X(J)){case 0:B(te(I-1),e);break;case 2:B(_(J),e);break;default:B(m(J),e)}return e}function ne(e,r){while(--r&&T())if(J<48||J>102||J>57&&J<65||J>70&&J<97)break;return W(e,V()+(r<6&&U()==32&&T()==32))}function ce(e){while(T())switch(J){case e:return I;case 34:case 39:if(e!==34&&e!==39)ce(J);break;case 40:if(e===41)ce(e);break;case 92:T();break}return I}function se(e,r){while(T())if(e+J===47+10)break;else if(e+J===42+42&&U()===47)break;return"/*"+W(r,I-1)+"*"+m(e===47?e:T())}function te(e){while(!X(U()))T();return W(e,I)}function ue(e){return Z(ie("",null,null,null,[""],e=Y(e),0,[0],e))}function ie(e,r,a,n,c,s,t,u,i){var f=0;var o=0;var l=t;var v=0;var p=0;var h=0;var b=1;var w=1;var d=1;var g=0;var k="";var x=c;var y=s;var j=n;var z=k;while(w)switch(h=g,g=T()){case 40:if(h!=108&&A(z,l-1)==58){if(O(z+=C(_(g),"&","&\f"),"&\f",$(f?u[f-1]:0))!=-1)d=-1;break}case 34:case 39:case 91:z+=_(g);break;case 9:case 10:case 13:case 32:z+=re(h);break;case 92:z+=ne(V()-1,7);continue;case 47:switch(U()){case 42:case 47:B(oe(se(T(),V()),r,a,i),i);break;default:z+="/"}break;case 123*b:u[f++]=S(z)*d;case 125*b:case 59:case 0:switch(g){case 0:case 125:w=0;case 59+o:if(d==-1)z=C(z,/\f/g,"");if(p>0&&S(z)-l)B(p>32?le(z+";",n,a,l-1,i):le(C(z," ","")+";",n,a,l-2,i),i);break;case 59:z+=";";default:B(j=fe(z,r,a,f,o,c,u,k,x=[],y=[],l,s),s);if(g===123)if(o===0)ie(z,r,j,j,x,s,l,u,y);else switch(v===99&&A(z,3)===110?100:v){case 100:case 108:case 109:case 115:ie(e,j,j,n&&B(fe(e,j,j,0,0,c,u,k,c,x=[],l,y),y),c,y,l,u,n?x:y);break;default:ie(z,j,j,j,[""],y,0,u,y)}}f=o=p=0,b=d=1,k=z="",l=t;break;case 58:l=1+S(z),p=h;default:if(b<1)if(g==123)--b;else if(g==125&&b++==0&&R()==125)continue;switch(z+=m(g),g*b){case 38:d=o>0?1:(z+="\f",-1);break;case 44:u[f++]=(S(z)-1)*d,d=1;break;case 64:if(U()===45)z+=_(T());v=U(),o=l=S(k=z+=te(V())),g++;break;case 45:if(h===45&&S(z)==2)b=0}}return s}function fe(e,r,a,n,s,t,u,i,f,o,l,v){var p=s-1;var h=s===0?t:[""];var b=q(h);for(var w=0,d=0,g=0;w<n;++w)for(var k=0,m=M(e,p+1,p=$(d=u[w])),x=e;k<b;++k)if(x=j(d>0?h[k]+" "+m:C(m,/&\f/g,h[k])))f[g++]=x;return L(e,r,a,s===0?c:i,f,o,l,v)}function oe(e,r,a,c){return L(e,r,a,n,m(Q()),M(e,2,-2),0,c)}function le(e,r,a,n,c){return L(e,r,a,s,M(e,0,n),M(e,n+1,-1),n,c)}function ve(n,c,s){switch(y(n,c)){case 5103:return a+"print-"+n+n;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return a+n+n;case 4789:return r+n+n;case 5349:case 4246:case 4810:case 6968:case 2756:return a+n+r+n+e+n+n;case 5936:switch(A(n,c+11)){case 114:return a+n+e+C(n,/[svh]\w+-[tblr]{2}/,"tb")+n;case 108:return a+n+e+C(n,/[svh]\w+-[tblr]{2}/,"tb-rl")+n;case 45:return a+n+e+C(n,/[svh]\w+-[tblr]{2}/,"lr")+n}case 6828:case 4268:case 2903:return a+n+e+n+n;case 6165:return a+n+e+"flex-"+n+n;case 5187:return a+n+C(n,/(\w+).+(:[^]+)/,a+"box-$1$2"+e+"flex-$1$2")+n;case 5443:return a+n+e+"flex-item-"+C(n,/flex-|-self/g,"")+(!z(n,/flex-|baseline/)?e+"grid-row-"+C(n,/flex-|-self/g,""):"")+n;case 4675:return a+n+e+"flex-line-pack"+C(n,/align-content|flex-|-self/g,"")+n;case 5548:return a+n+e+C(n,"shrink","negative")+n;case 5292:return a+n+e+C(n,"basis","preferred-size")+n;case 6060:return a+"box-"+C(n,"-grow","")+a+n+e+C(n,"grow","positive")+n;case 4554:return a+C(n,/([^-])(transform)/g,"$1"+a+"$2")+n;case 6187:return C(C(C(n,/(zoom-|grab)/,a+"$1"),/(image-set)/,a+"$1"),n,"")+n;case 5495:case 3959:return C(n,/(image-set\([^]*)/,a+"$1"+"$`$1");case 4968:return C(C(n,/(.+:)(flex-)?(.*)/,a+"box-pack:$3"+e+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+a+n+n;case 4200:if(!z(n,/flex-|baseline/))return e+"grid-column-align"+M(n,c)+n;break;case 2592:case 3360:return e+C(n,"template-","")+n;case 4384:case 3616:if(s&&s.some((function(e,r){return c=r,z(e.props,/grid-\w+-end/)}))){return~O(n+(s=s[c].value),"span",0)?n:e+C(n,"-start","")+n+e+"grid-row-span:"+(~O(s,"span",0)?z(s,/\d+/):+z(s,/\d+/)-+z(n,/\d+/))+";"}return e+C(n,"-start","")+n;case 4896:case 4128:return s&&s.some((function(e){return z(e.props,/grid-\w+-start/)}))?n:e+C(C(n,"-end","-span"),"span ","")+n;case 4095:case 3583:case 4068:case 2532:return C(n,/(.+)-inline(.+)/,a+"$1$2")+n;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(S(n)-1-c>6)switch(A(n,c+1)){case 109:if(A(n,c+4)!==45)break;case 102:return C(n,/(.+:)(.+)-([^]+)/,"$1"+a+"$2-$3"+"$1"+r+(A(n,c+3)==108?"$3":"$2-$3"))+n;case 115:return~O(n,"stretch",0)?ve(C(n,"stretch","fill-available"),c,s)+n:n}break;case 5152:case 5920:return C(n,/(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/,(function(r,a,c,s,t,u,i){return e+a+":"+c+i+(s?e+a+"-span:"+(t?u:+u-+c)+i:"")+n}));case 4949:if(A(n,c+6)===121)return C(n,":",":"+a)+n;break;case 6444:switch(A(n,A(n,14)===45?18:11)){case 120:return C(n,/(.+:)([^;\s!]+)(;|(\s+)?!.+)?/,"$1"+a+(A(n,14)===45?"inline-":"")+"box$3"+"$1"+a+"$2$3"+"$1"+e+"$2box$3")+n;case 100:return C(n,":",":"+e)+n}break;case 5719:case 2647:case 2135:case 3927:case 2391:return C(n,"scroll-","scroll-snap-")+n}return n}function pe(e,r){var a="";for(var n=0;n<e.length;n++)a+=r(e[n],n,e,r)||"";return a}function he(e,r,a,t){switch(e.type){case g:if(e.children.length)break;case i:case s:return e.return=e.return||e.value;case n:return"";case h:return e.return=e.value+"{"+pe(e.children,t)+"}";case c:if(!S(e.value=e.props.join(",")))return""}return S(a=pe(e.children,t))?e.return=e.value+"{"+a+"}":""}function be(e){var r=q(e);return function(a,n,c,s){var t="";for(var u=0;u<r;u++)t+=e[u](a,n,c,s)||"";return t}}function we(e){return function(r){if(!r.root)if(r=r.return)e(r)}}function de(n,t,u,i){if(n.length>-1)if(!n.return)switch(n.type){case s:n.return=ve(n.value,n.length,u);return;case h:return pe([N(n,{value:C(n.value,"@","@"+a)})],i);case c:if(n.length)return D(u=n.props,(function(c){switch(z(c,i=/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":P(N(n,{props:[C(c,/:(read-\w+)/,":"+r+"$1")]}));P(N(n,{props:[c]}));x(n,{props:E(u,i)});break;case"::placeholder":P(N(n,{props:[C(c,/:(plac\w+)/,":"+a+"input-$1")]}));P(N(n,{props:[C(c,/:(plac\w+)/,":"+r+"$1")]}));P(N(n,{props:[C(c,/:(plac\w+)/,e+"input-$1")]}));P(N(n,{props:[c]}));x(n,{props:E(u,i)});break}return""}))}}function ge(e){switch(e.type){case c:e.props=e.props.map((function(r){return D(ee(r),(function(r,a,n){switch(A(r,0)){case 12:return M(r,1,S(r));case 0:case 40:case 43:case 62:case 126:return r;case 58:if(n[++a]==="global")n[a]="",n[++a]="\f"+M(n[a],a=1,-1);case 32:return a===1?"":r;default:switch(a){case 0:e=r;return q(n)>1?"":r;case a=q(n)-1:case 2:return a===2?r+e+e:r+e;default:return r}}}))}))}}
//# sourceMappingURL=stylis.mjs.map


/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unitlessKeys; });
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};




/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = RefNosTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_content_copy__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_content_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_content_copy__);
var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    gap: 10px;\n    padding: 10px;\n    flex-direction: column;\n'], ['\n    display: flex;\n    gap: 10px;\n    padding: 10px;\n    flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    font-size: 13px;\n'], ['\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    font-size: 13px;\n']);

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }






function RefNosTooltip(_ref) {
    var open = _ref.open,
        elementTarget = _ref.elementTarget,
        close = _ref.close,
        refNos = _ref.refNos;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui__["o" /* Popover */],
        {
            open: open,
            anchorEl: elementTarget,
            onRequestClose: close,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledBody,
            null,
            refNos.map(function (refNo) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    StyledBodyItem,
                    { key: refNo },
                    refNo,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_content_copy___default.a, {
                        style: { height: '16px', width: '16px', cursor: 'pointer' },
                        onClick: function onClick() {
                            return navigator.clipboard.writeText(refNo);
                        }
                    })
                );
            })
        )
    );
}

var StyledBody = __WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].div(_templateObject);

var StyledBodyItem = __WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* default */].div(_templateObject2);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RefNosTooltip, 'RefNosTooltip', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/RefNosTooltip.jsx');
    reactHotLoader.register(StyledBody, 'StyledBody', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/RefNosTooltip.jsx');
    reactHotLoader.register(StyledBodyItem, 'StyledBodyItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/RefNosTooltip.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Query; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__retryer__ = __webpack_require__(236);




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["h" /* isValidTimeout */])(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* functionalUpdate */])(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["r" /* replaceEqualDeep */])(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !Object(__WEBPACK_IMPORTED_MODULE_1__utils__["v" /* timeUntilStale */])(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* ensureQueryKeyArray */])(this.queryKey);
    var abortController = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getAbortController */])(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new __WEBPACK_IMPORTED_MODULE_4__retryer__["a" /* Retryer */]({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!(Object(__WEBPACK_IMPORTED_MODULE_4__retryer__["c" /* isCancelledError */])(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_4__retryer__["c" /* isCancelledError */])(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          Object(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* getLogger */])().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    __WEBPACK_IMPORTED_MODULE_2__notifyManager__["a" /* notifyManager */].batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          isPaused: true
        });

      case 'continue':
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          isPaused: false
        });

      case 'fetch':
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if (Object(__WEBPACK_IMPORTED_MODULE_4__retryer__["c" /* isCancelledError */])(error) && error.revert && this.revertState) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.revertState);
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queryCache__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutationCache__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focusManager__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__onlineManager__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__infiniteQueryBehavior__ = __webpack_require__(806);








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new __WEBPACK_IMPORTED_MODULE_2__queryCache__["a" /* QueryCache */]();
    this.mutationCache = config.mutationCache || new __WEBPACK_IMPORTED_MODULE_3__mutationCache__["a" /* MutationCache */]();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = __WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].subscribe(function () {
      if (__WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].isFocused() && __WEBPACK_IMPORTED_MODULE_5__onlineManager__["a" /* onlineManager */].isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = __WEBPACK_IMPORTED_MODULE_5__onlineManager__["a" /* onlineManager */].subscribe(function () {
      if (__WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].isFocused() && __WEBPACK_IMPORTED_MODULE_5__onlineManager__["a" /* onlineManager */].isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* parseQueryArgs */])(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, filters, {
      active: true
    });

    return __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* parseQueryArgs */])(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["o" /* parseQueryArgs */])(arg1, arg2, arg3);
    parsedOptions.behavior = Object(__WEBPACK_IMPORTED_MODULE_7__infiniteQueryBehavior__["c" /* infiniteQueryBehavior */])();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* noop */]);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(queryKey) === Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* partialMatchKey */])(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(mutationKey) === Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* partialMatchKey */])(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* hashQueryKeyByOptions */])(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dehydrate */
/* harmony export (immutable) */ __webpack_exports__["a"] = hydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);


// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}

function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}

function dehydrate(client, options) {
  var _options, _options2;

  options = options || {};
  var mutations = [];
  var queries = [];

  if (((_options = options) == null ? void 0 : _options.dehydrateMutations) !== false) {
    var shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(function (mutation) {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (((_options2 = options) == null ? void 0 : _options2.dehydrateQueries) !== false) {
    var shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(function (query) {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations: mutations,
    queries: queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  var mutationCache = client.getMutationCache();
  var queryCache = client.getQueryCache();
  var mutations = dehydratedState.mutations || [];
  var queries = dehydratedState.queries || [];
  mutations.forEach(function (dehydratedMutation) {
    var _options$defaultOptio;

    mutationCache.build(client, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations, {
      mutationKey: dehydratedMutation.mutationKey
    }), dehydratedMutation.state);
  });
  queries.forEach(function (dehydratedQuery) {
    var _options$defaultOptio2;

    var query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
        query.setState(dehydratedQuery.state);
      }

      return;
    } // Restore query


    queryCache.build(client, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries, {
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }), dehydratedQuery.state);
  });
}

/***/ }),
/* 1906 */
/***/ (function(module, exports) {



/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setBatchUpdatesFn__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setLogger__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryClientProvider", function() { return __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useQueryClient", function() { return __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryErrorResetBoundary__ = __webpack_require__(810);
/* unused harmony reexport QueryErrorResetBoundary */
/* unused harmony reexport useQueryErrorResetBoundary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useIsFetching__ = __webpack_require__(1912);
/* unused harmony reexport useIsFetching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useIsMutating__ = __webpack_require__(1913);
/* unused harmony reexport useIsMutating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useMutation__ = __webpack_require__(1914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useMutation", function() { return __WEBPACK_IMPORTED_MODULE_6__useMutation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__useQuery__ = __webpack_require__(1915);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useQuery", function() { return __WEBPACK_IMPORTED_MODULE_7__useQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useQueries__ = __webpack_require__(1916);
/* unused harmony reexport useQueries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__useInfiniteQuery__ = __webpack_require__(1917);
/* unused harmony reexport useInfiniteQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Hydrate__ = __webpack_require__(1918);
/* unused harmony reexport useHydrate */
/* unused harmony reexport Hydrate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__types__);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_11__types__, "QueryClient")) __webpack_require__.d(__webpack_exports__, "QueryClient", function() { return __WEBPACK_IMPORTED_MODULE_11__types__["QueryClient"]; });
// Side effects










 // Types



/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reactBatchedUpdates__ = __webpack_require__(1909);


__WEBPACK_IMPORTED_MODULE_0__core__["notifyManager"].setBatchNotifyFunction(__WEBPACK_IMPORTED_MODULE_1__reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unstable_batchedUpdates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

var unstable_batchedUpdates = __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unstable_batchedUpdates;

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(1911);


Object(__WEBPACK_IMPORTED_MODULE_0__core__["setLogger"])(__WEBPACK_IMPORTED_MODULE_1__logger__["a" /* logger */]);

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
var logger = console;

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useIsFetching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(199);





var checkIsFetching = function checkIsFetching(queryClient, filters, isFetching, setIsFetching) {
  var newIsFetching = queryClient.isFetching(filters);

  if (isFetching !== newIsFetching) {
    setIsFetching(newIsFetching);
  }
};

function useIsFetching(arg1, arg2) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();

  var _parseFilterArgs = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils__["l" /* parseFilterArgs */])(arg1, arg2),
      filters = _parseFilterArgs[0];

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(queryClient.isFetching(filters)),
      isFetching = _React$useState[0],
      setIsFetching = _React$useState[1];

  var filtersRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(filters);
  filtersRef.current = filters;
  var isFetchingRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(isFetching);
  isFetchingRef.current = isFetching;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
    var unsubscribe = queryClient.getQueryCache().subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        checkIsFetching(queryClient, filtersRef.current, isFetchingRef.current, setIsFetching);
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [queryClient]);
  return isFetching;
}

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useIsMutating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(199);




function useIsMutating(arg1, arg2) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  var filters = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils__["n" /* parseMutationFilterArgs */])(arg1, arg2);
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(queryClient.isMutating(filters)),
      isMutating = _React$useState[0],
      setIsMutating = _React$useState[1];

  var filtersRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(filters);
  filtersRef.current = filters;
  var isMutatingRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(isMutating);
  isMutatingRef.current = isMutating;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = queryClient.getMutationCache().subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        var newIsMutating = queryClient.isMutating(filtersRef.current);

        if (isMutatingRef.current !== newIsMutating) {
          setIsMutating(newIsMutating);
        }
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [queryClient]);
  return isMutating;
}

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMutation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mutationObserver__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QueryClientProvider__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(811);






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useRef(false);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(0),
      forceUpdate = _React$useState[1];

  var options = Object(__WEBPACK_IMPORTED_MODULE_3__core_utils__["m" /* parseMutationArgs */])(arg1, arg2, arg3);
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_5__QueryClientProvider__["b" /* useQueryClient */])();
  var obsRef = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useRef();

  if (!obsRef.current) {
    obsRef.current = new __WEBPACK_IMPORTED_MODULE_4__core_mutationObserver__["a" /* MutationObserver */](queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(__WEBPACK_IMPORTED_MODULE_2__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(__WEBPACK_IMPORTED_MODULE_3__core_utils__["k" /* noop */]);
  }, []);

  if (currentResult.error && Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* shouldThrowError */])(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useBaseQuery__ = __webpack_require__(812);


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__core_utils__["o" /* parseQueryArgs */])(arg1, arg2, arg3);
  return Object(__WEBPACK_IMPORTED_MODULE_2__useBaseQuery__["a" /* useBaseQuery */])(parsedOptions, __WEBPACK_IMPORTED_MODULE_0__core__["QueryObserver"]);
}

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useQueries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_queriesObserver__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(199);




function useQueries(queries) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();
  var defaultedQueries = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return queries.map(function (options) {
      var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options

      defaultedOptions.optimisticResults = true;
      return defaultedOptions;
    });
  }, [queries, queryClient]);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(function () {
    return new __WEBPACK_IMPORTED_MODULE_2__core_queriesObserver__["a" /* QueriesObserver */](queryClient, defaultedQueries);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedQueries);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = observer.subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [observer]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setQueries(defaultedQueries, {
      listeners: false
    });
  }, [defaultedQueries, observer]);
  return result;
}

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useInfiniteQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_infiniteQueryObserver__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useBaseQuery__ = __webpack_require__(812);


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = Object(__WEBPACK_IMPORTED_MODULE_1__core_utils__["o" /* parseQueryArgs */])(arg1, arg2, arg3);
  return Object(__WEBPACK_IMPORTED_MODULE_2__useBaseQuery__["a" /* useBaseQuery */])(options, __WEBPACK_IMPORTED_MODULE_0__core_infiniteQueryObserver__["a" /* InfiniteQueryObserver */]);
}

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useHydrate */
/* unused harmony export Hydrate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__ = __webpack_require__(199);



function useHydrate(state, options) {
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__["b" /* useQueryClient */])();
  var optionsRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    if (state) {
      Object(__WEBPACK_IMPORTED_MODULE_1__core__["hydrate"])(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
var Hydrate = function Hydrate(_ref) {
  var children = _ref.children,
      options = _ref.options,
      state = _ref.state;
  useHydrate(state, options);
  return children;
};

/***/ }),
/* 1919 */
/***/ (function(module, exports) {



/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_arrow_back__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_arrow_back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_arrow_back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_arrow_forward__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_arrow_forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_arrow_forward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Sidebar_Size_MainInfo__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Content_AnnotationsEditor__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Content_AnnotationsList__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HtmlContent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Sidebar_Size_SizesTable__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Content_TextEditor__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sagas_letters__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sagas_annotations__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_actions_letters__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_actions_vessels_size__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_actions_vessels_request__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_services_vessels_vessels__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Attachments__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__common_ToSpamButton__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















































var LetterVessel = function (_React$Component) {
    _inherits(LetterVessel, _React$Component);

    function LetterVessel(props) {
        _classCallCheck(this, LetterVessel);

        var _this = _possibleConstructorReturn(this, (LetterVessel.__proto__ || Object.getPrototypeOf(LetterVessel)).call(this, props));

        _this.toggleAttachmentsDialog = function () {
            _this.setState({
                openedAttachmentsDialog: !_this.state.openedAttachmentsDialog
            });
        };

        if (localStorage.getItem('settings-size-vessel' + props.objUser.user._id)) {
            _this.initialState = JSON.parse(localStorage.getItem('settings-size-vessel' + props.objUser.user._id));
        } else {
            _this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem('settings-size-vessel' + props.objUser.user._id, JSON.stringify(_this.initialState));
        }

        _this.state = _extends({}, _this.initialState, {
            textLetter: '',
            currentVesselSizeIndex: 0,
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            openedAttachmentsDialog: false,

            selectedType: '',
            selectedServer: 'mailparse.net',
            tabValue: 0,
            errors: []
        });

        _this.addSizeTable = _this.addSizeTable.bind(_this);
        _this.removeSizeTable = _this.removeSizeTable.bind(_this);
        _this.changeAnnotationsServer = _this.changeAnnotationsServer.bind(_this);
        _this.changeClarifiedServer = _this.changeClarifiedServer.bind(_this);
        _this.clearSizeTable = _this.clearSizeTable.bind(_this);
        _this.loadVesselData = _this.loadVesselData.bind(_this);
        _this.handleArrowBack = _this.handleArrowBack.bind(_this);
        _this.handleArrowForward = _this.handleArrowForward.bind(_this);
        _this.updatePostGazetters = _this.updatePostGazetters.bind(_this);
        _this.getLetterData = _this.getLetterData.bind(_this);

        _this.handleTabChange = _this.handleTabChange.bind(_this);
        return _this;
    }

    _createClass(LetterVessel, [{
        key: 'getLetterData',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(textEdit) {
                var _ref2, letter, annotationsResponse;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_19_sagas_letters__["b" /* getLetter */], this.props.routeParams.id, 'vessel');

                            case 3:
                                _ref2 = _context.sent;
                                letter = _ref2.data;

                                letter.gazettersArr = [];
                                letter.type = 'vessel';
                                // necessary for distinguishing vessel order and vessel sizes in letters.js
                                letter.fromVesselSizes = true;
                                if (textEdit) {
                                    letter.text = textEdit;
                                }

                                _context.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_20_sagas_annotations__["b" /* postAnnotations */], letter.text, letter.type, this.state.annotationsServer, {
                                    emailId: letter._id,
                                    subject: letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(letter.date).format('DD-MM-YYYY')
                                });

                            case 11:
                                annotationsResponse = _context.sent;

                                if (annotationsResponse) {
                                    letter.gazettersArr = annotationsResponse.data.annotations;
                                    if (annotationsResponse.data.newclarified) {
                                        letter.newclarified = annotationsResponse.data.newclarified;
                                    }
                                }

                                _context.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_21_sagas_lettersNew__["d" /* updateLetter */], __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.omit(letter, 'gazettersArr'), 'vessel', this.state.clarifiedServer);

                            case 15:
                                _context.next = 20;
                                break;

                            case 17:
                                _context.prev = 17;
                                _context.t0 = _context['catch'](0);

                                Object(__WEBPACK_IMPORTED_MODULE_27_actions_notifications_notifications__["a" /* addNotification */])({
                                    type: __WEBPACK_IMPORTED_MODULE_31_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                                    notification: {
                                        title: 'Error',
                                        message: _context.t0.errors ? _context.t0.errors.messages[0] : _context.t0,
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 10
                                    }
                                });

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 17]]);
            }));

            function getLetterData(_x) {
                return _ref.apply(this, arguments);
            }

            return getLetterData;
        }()
    }, {
        key: 'changeAnnotationsServer',
        value: function changeAnnotationsServer(e, i, value) {
            var _this2 = this;

            this.initialState = {
                annotationsServer: value,
                clarifiedServer: this.state.clarifiedServer
            };

            localStorage.setItem('settings-size-vessel' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this2.getLetterData();
            });
        }
    }, {
        key: 'changeClarifiedServer',
        value: function changeClarifiedServer(e, i, value) {
            var _this3 = this;

            this.initialState = {
                annotationsServer: this.state.annotationsServer,
                clarifiedServer: value
            };

            localStorage.setItem('settings-size-vessel' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this3.getLetterData();
            });
        }
    }, {
        key: 'loadVesselData',
        value: function loadVesselData(id) {
            var _this4 = this;

            if (id) {
                Object(__WEBPACK_IMPORTED_MODULE_29_services_vessels_vessels__["g" /* getVessel */])(id).then(function (response) {
                    // not using inputs for files -> delete image array
                    if (response.data) {
                        delete response.data.images;
                    }
                    _this4.setState(response.data);
                });
            }
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.getLetterData();
        }
    }, {
        key: 'changeServer',
        value: function changeServer(e, i, value) {
            var _this5 = this;

            this.setState({
                selectedServer: value
            }, function () {
                _this5.getLetterData();
            });
        }
    }, {
        key: 'createTerms',
        value: function createTerms(vesselSizes) {
            vesselSizes.forEach(function (vesselSize) {
                var terms = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(vesselSize.terms);

                terms.forEach(function (term) {
                    if (term.type) {
                        term.value = term.type + ' ' + term.value;
                    }
                });

                vesselSize.terms = terms;
            });
        }
    }, {
        key: 'removeSizeTable',
        value: function removeSizeTable() {
            var currentVesselSizeIndex = this.state.currentVesselSizeIndex;
            var vesselSizes = this.props.vesselSizes;

            this.props.removeLastVesselSize();
            if (!(currentVesselSizeIndex === 0)) {
                this.setState({
                    currentVesselSizeIndex: currentVesselSizeIndex - 1
                });
            } else if (currentVesselSizeIndex === 0 && vesselSizes.length > 1) {
                this.setState({
                    currentVesselSizeIndex: 0
                });
            }
        }
    }, {
        key: 'clearSizeTable',
        value: function clearSizeTable() {
            this.props.removeLastVesselSize();
            this.props.addVesselSize();
        }
    }, {
        key: 'addSizeTable',
        value: function addSizeTable() {
            var vesselSizes = this.props.vesselSizes;

            this.props.addVesselSize();
            if (vesselSizes.length === 0) {
                this.setState({
                    currentVesselSizeIndex: 0
                });
            } else {
                this.setState({
                    currentVesselSizeIndex: vesselSizes.length
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.removeGazetters();
            this.props.removeAnnotations();
            this.props.removeLetter();
        }
    }, {
        key: 'handleArrowBack',
        value: function handleArrowBack(e) {
            e.preventDefault();
            var vesselSizes = this.props.vesselSizes;
            var currentVesselSizeIndex = this.state.currentVesselSizeIndex;

            if (vesselSizes.length > 1) {
                this.setState({
                    currentVesselSizeIndex: currentVesselSizeIndex - 1 < 0 ? vesselSizes.length - 1 : currentVesselSizeIndex - 1
                });
            }
            if (vesselSizes[currentVesselSizeIndex].vessel) {
                this.loadVesselData(vesselSizes[currentVesselSizeIndex].vessel);
            }
        }
    }, {
        key: 'handleArrowForward',
        value: function handleArrowForward(e) {
            e.preventDefault();
            var vesselSizes = this.props.vesselSizes;
            var currentVesselSizeIndex = this.state.currentVesselSizeIndex;

            if (vesselSizes.length > 1) {
                this.setState({
                    currentVesselSizeIndex: currentVesselSizeIndex + 1 === vesselSizes.length ? 0 : currentVesselSizeIndex + 1
                });
            }
            if (vesselSizes[currentVesselSizeIndex].vessel) {
                this.loadVesselData(vesselSizes[currentVesselSizeIndex].vessel);
            }
        }
    }, {
        key: 'updatePostGazetters',
        value: function updatePostGazetters() {
            var _this6 = this;

            var textLetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.textLetter;

            this.setState({
                textLetter: textLetter,
                gazetters: [],
                filteredGazetters: [],
                annotations: []
            }, function () {
                _this6.props.postGazetters(textLetter, {
                    emailId: _this6.props.letter._id,
                    subject: _this6.props.letter.subject,
                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(_this6.props.letter.date).format('DD-MM-YYYY')
                });
            });
        }
    }, {
        key: 'handleTabChange',
        value: function handleTabChange(tabValue) {
            this.setState({
                tabValue: tabValue
            });
            if (this.props.vesselSizes[tabValue] && this.props.vesselSizes[tabValue].vessel) {
                this.loadVesselData(this.props.vesselSizes[tabValue].vessel);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var _state = this.state,
                annotationsServer = _state.annotationsServer,
                clarifiedServer = _state.clarifiedServer,
                currentVesselSizeIndex = _state.currentVesselSizeIndex,
                textLetter = _state.textLetter,
                openedAttachmentsDialog = _state.openedAttachmentsDialog;
            var _props = this.props,
                routeParams = _props.routeParams,
                letter = _props.letter,
                router = _props.router,
                vesselSizes = _props.vesselSizes;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'single-letter-cargo', className: 'single-letter' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content', style: { width: '53vw' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'management' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'management-children' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                label: 'Gazetteer',
                                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id }),
                                primary: true,
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 5px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px', minWidth: '60px' }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__HtmlContent__["a" /* default */], {
                                    letter: letter
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__Attachments__["a" /* default */], {
                                openedAttachmentsDialog: openedAttachmentsDialog,
                                toggleAttachmentsDialog: this.toggleAttachmentsDialog,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 0 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                className: 'btn',
                                attachments: letter.attachments
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Content_TextEditor__["a" /* default */], {
                                    textLetter: letter.text,
                                    getLetterData: this.getLetterData,
                                    updatePostGazetters: this.updatePostGazetters,
                                    removeGazetters: this.props.removeGazetters,
                                    removeAnnotations: this.props.removeAnnotations
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'btn' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                        label: 'Order',
                                        containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id + '/annotator/vessel' }),
                                        labelStyle: { fontSize: '10px' },
                                        style: { height: '25px', marginLeft: '-10px', minWidth: '50px' },
                                        buttonStyle: { height: '25px', lineHeight: '25px' },
                                        primary: true
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_6_store_configureStore__["a" /* UserPerms */].isAdmin() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Annotations server',
                                        className: 'btn',
                                        value: annotationsServer,
                                        onChange: this.changeAnnotationsServer,
                                        style: { width: '155px' },
                                        selected: true
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'mailparse.net', primaryText: 'mailparse.net' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 's4.anotatr.com', primaryText: 's4.anotatr.com' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'nata.im', primaryText: 'nata.im' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'polza', primaryText: 'polza' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'localhost', primaryText: 'localhost' })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Clarified server',
                                        className: 'btn',
                                        value: clarifiedServer,
                                        onChange: this.changeClarifiedServer,
                                        style: { width: '110px' },
                                        selected: true,
                                        autoWidth: true
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'standart', primaryText: 'api' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'localhost:7775', primaryText: 'localhost' })
                                )
                            ) : '',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__common_ToSpamButton__["a" /* default */], {
                                    letterId: letter._id,
                                    onSuccess: function onSuccess() {
                                        _this7.getLetterData();
                                    },
                                    disabled: letter.type === 'spam'
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject', style: { width: '160px' } },
                            'SUBJECT: ',
                            letter.subject
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject', style: { width: '50px' } },
                            'refNo: ',
                            letter.refNo
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Content_AnnotationsEditor__["a" /* default */], { letterText: textLetter || letter.text })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Content_AnnotationsList__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'sidebar', style: { width: '47vw', height: 'calc(100vh - 100px)' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'top-bar' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_arrow_back___default.a, {
                            style: { marginTop: '7px' },
                            fontSize: 'large',
                            color: '#fff',
                            hoverColor: 'red',
                            onClick: this.handleArrowBack

                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h1',
                            null,
                            'Vessel size ',
                            vesselSizes.length ? currentVesselSizeIndex + 1 : 0,
                            ' of ',
                            vesselSizes.length
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_navigation_arrow_forward___default.a, {
                            style: { marginTop: '7px' },
                            fontSize: 'large',
                            color: '#fff',
                            hoverColor: 'red',
                            onClick: this.handleArrowForward
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_32__ErrorBoundary__["a" /* default */],
                        null,
                        vesselSizes[currentVesselSizeIndex] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Sidebar_Size_SizesTable__["a" /* default */], {
                                key: vesselSizes[currentVesselSizeIndex].vessel,
                                numberSizeTable: currentVesselSizeIndex,
                                routeParams: { id: vesselSizes[currentVesselSizeIndex].vessel }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Sidebar_Size_MainInfo__["a" /* default */], null)
                        ) : null
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'controller-orders', style: { width: '47vw' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_30_styles__["a" /* default */].btnOrders, onClick: this.addSizeTable, label: 'Add' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, {
                                style: __WEBPACK_IMPORTED_MODULE_30_styles__["a" /* default */].btnOrders,
                                onClick: this.removeSizeTable,
                                label: 'Remove'
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_30_styles__["a" /* default */].btnOrders, onClick: this.clearSizeTable, label: 'Clear' })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LetterVessel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        vessel: state.vessel,
        objUser: state.user,
        user: state.vesselSizes.user,
        vesselSizes: state.vesselSizes.items,
        isLogged: state.user.isLogged,
        letter: state.letter,
        annotations: state.annotations.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getVesselSizes: __WEBPACK_IMPORTED_MODULE_24_actions_vessels_size__["c" /* getVesselSizes */],
        updateVessel: __WEBPACK_IMPORTED_MODULE_28_actions_vessels_vessels__["i" /* updateVessel */],
        postAnnotations: __WEBPACK_IMPORTED_MODULE_23_actions_annotations__["a" /* postAnnotations */],
        postGazetters: __WEBPACK_IMPORTED_MODULE_26_actions_gazetters__["a" /* postGazetters */],
        addVesselSize: __WEBPACK_IMPORTED_MODULE_24_actions_vessels_size__["a" /* addVesselSize */],
        removeLastVesselSize: __WEBPACK_IMPORTED_MODULE_24_actions_vessels_size__["f" /* removeLastVesselSize */],
        postRequestVessel: __WEBPACK_IMPORTED_MODULE_25_actions_vessels_request__["c" /* postRequestVessel */],
        removeGazetters: __WEBPACK_IMPORTED_MODULE_26_actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_23_actions_annotations__["b" /* removeAnnotations */],
        removeLetter: __WEBPACK_IMPORTED_MODULE_22_actions_letters__["a" /* removeLetter */]
    }, dispatch);
})(LetterVessel);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LetterVessel, 'LetterVessel', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/AnnotatorVesselSizePage.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/AnnotatorVesselSizePage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateUserPopup__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_vessels_size__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MainInfo = function (_React$Component) {
    _inherits(MainInfo, _React$Component);

    function MainInfo(props) {
        _classCallCheck(this, MainInfo);

        var _this = _possibleConstructorReturn(this, (MainInfo.__proto__ || Object.getPrototypeOf(MainInfo)).call(this, props));

        _this.state = {
            user: props.user.email,
            emails: [],
            isOpenAddUserPopup: false
        };

        _this.changeEmail = _this.changeEmail.bind(_this);
        _this.chooseEmail = _this.chooseEmail.bind(_this);
        _this.openAddUserPopup = _this.openAddUserPopup.bind(_this);
        _this.closeAddUserPopup = _this.closeAddUserPopup.bind(_this);
        return _this;
    }

    _createClass(MainInfo, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            this.setState({
                user: props.user.email || this.props.letter.sender && this.props.letter.sender[0].address
            });
        }
    }, {
        key: 'changeEmail',
        value: function changeEmail(searchText) {
            var _this2 = this;

            this.setState({
                user: searchText
            }, function () {
                __WEBPACK_IMPORTED_MODULE_8_services__["a" /* default */].findUser(searchText).then(function (response) {
                    if (response.status === 200) {
                        var emails = response.data.data.map(function (item) {
                            return {
                                email: item.email,
                                item: item
                            };
                        });

                        _this2.setState({
                            emails: emails
                        }, function () {
                            var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this2.props.user);
                            newUser.email = searchText;
                            _this2.props.updateVesselSizeUser(newUser);
                        });
                    }
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'chooseEmail',
        value: function chooseEmail(updateProperties) {
            var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.user);
            newUser.email = updateProperties.item.email;
            this.props.updateVesselSizeUser(newUser);
        }
    }, {
        key: 'openAddUserPopup',
        value: function openAddUserPopup() {
            this.setState({
                isOpenAddUserPopup: true
            });
        }
    }, {
        key: 'closeAddUserPopup',
        value: function closeAddUserPopup() {
            this.setState({
                isOpenAddUserPopup: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var errorUser = this.props.errorUser ? this.props.errorUser.messages[0] : '';
            var _state = this.state,
                user = _state.user,
                emails = _state.emails,
                isOpenAddUserPopup = _state.isOpenAddUserPopup;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'sidebar-table' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CreateUserPopup__["a" /* default */], {
                    isOpen: isOpenAddUserPopup,
                    closeAddUserPopup: this.closeAddUserPopup
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'title' },
                    'CONTACTS'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row half' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new user',
                            onClick: this.openAddUserPopup,
                            primary: true
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'User email'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a, {
                            name: 'userEmail',
                            textFieldStyle: { fontSize: '13px' },
                            hintText: 'User email or id',
                            errorText: errorUser,
                            searchText: user,
                            dataSource: emails,
                            dataSourceConfig: { text: 'email', value: 'item' },
                            onUpdateInput: this.changeEmail,
                            onNewRequest: this.chooseEmail,
                            filter: __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a.noFilter,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true
                            }
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return MainInfo;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    var errorUser = '';

    if (state.vesselSizes.items.length > 0) {
        errorUser = state.vesselSizes.items[0].validateErrors.find(function (validateError) {
            return validateError.field === 'user';
        });
    }

    return {
        user: state.vesselSizes.user,
        errorUser: errorUser,
        letter: state.letter
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselSizeUser: __WEBPACK_IMPORTED_MODULE_7_actions_vessels_size__["h" /* updateVesselSizeUser */]
    }, dispatch);
})(MainInfo);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MainInfo, 'MainInfo', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/MainInfo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/MainInfo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_vessels_orders__ = __webpack_require__(100);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CreateUserPopup = function (_React$Component) {
    _inherits(CreateUserPopup, _React$Component);

    function CreateUserPopup(props) {
        _classCallCheck(this, CreateUserPopup);

        var _this = _possibleConstructorReturn(this, (CreateUserPopup.__proto__ || Object.getPrototypeOf(CreateUserPopup)).call(this, props));

        _this.state = {
            name: props.user.name,
            surname: props.user.surname,
            email: props.user.email,
            emails: [],
            company: props.user.company,
            companies: [],
            phones: [{
                code: props.user.phoneCode,
                phone: props.user.phone
            }],
            errors: {},
            success: '',
            isOpenSuccessMessage: false
        };

        _this.changeEmail = _this.changeEmail.bind(_this);
        _this.chooseEmail = _this.chooseEmail.bind(_this);
        _this.changeCompany = _this.changeCompany.bind(_this);
        _this.chooseCompany = _this.chooseCompany.bind(_this);

        _this.createNewUser = _this.createNewUser.bind(_this);
        _this.changeField = _this.changeField.bind(_this);
        _this.onMessageClose = _this.onMessageClose.bind(_this);
        return _this;
    }

    _createClass(CreateUserPopup, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newState) {
            this.setState({
                name: newState.user.name,
                surname: newState.user.surname,
                email: newState.user.email,
                company: newState.user.company,
                phones: [{
                    code: newState.user.phones[0].phoneCode,
                    phone: newState.user.phones[0].phone
                }]
            });
        }
    }, {
        key: 'onMessageClose',
        value: function onMessageClose() {
            this.setState({
                success: '',
                isOpenSuccessMessage: false
            });
        }
    }, {
        key: 'changeField',
        value: function changeField(e) {
            var name = e.target.name;
            var value = e.target.value;

            switch (name) {
                case 'name':
                    this.setState({
                        name: value
                    });
                    break;
                case 'surname':
                    this.setState({
                        surname: value
                    });
                    break;
                case 'phonecode':
                    this.setState({
                        phones: [{
                            code: value,
                            phone: this.state.phones[0].phone
                        }]
                    });
                    break;
                case 'phonenumber':
                    this.setState({
                        phones: [{
                            code: this.state.phones[0].code,
                            phone: value
                        }]
                    });
                    break;
            }
        }
    }, {
        key: 'changeEmail',
        value: function changeEmail(searchText) {
            var _this2 = this;

            this.setState({
                email: searchText
            }, function () {
                __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].findUser(searchText).then(function (response) {
                    if (response.status === 200) {
                        var emails = response.data.data.map(function (item) {
                            return {
                                email: item.email,
                                item: item
                            };
                        });

                        _this2.setState({
                            emails: emails
                        });
                    }
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'chooseEmail',
        value: function chooseEmail(updateProperties) {
            this.setState({
                email: updateProperties.email
            });
        }
    }, {
        key: 'changeCompany',
        value: function changeCompany(searchText) {
            var _this3 = this;

            this.setState({
                company: searchText
            }, function () {
                __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].findCompany(searchText).then(function (response) {
                    if (response.status === 200) {
                        var companies = response.data.data.map(function (item) {
                            return {
                                name: item.name,
                                item: item
                            };
                        });

                        _this3.setState({
                            companies: companies
                        });
                    }
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'createErrorObject',
        value: function createErrorObject(errorsArray) {
            var errors = {};
            errorsArray.forEach(function (error) {
                errors['' + error.field] = {
                    message: error.messages[0]
                };
            });

            this.setState({
                errors: errors
            });
        }
    }, {
        key: 'chooseCompany',
        value: function chooseCompany(updateProperties) {
            this.setState({
                company: updateProperties.name
            });
        }
    }, {
        key: 'createNewUser',
        value: function createNewUser() {
            var _this4 = this;

            var userRequest = {
                email: this.state.email,
                company: this.state.company
            };

            if (this.state.phones[0].code || this.state.phones[0].phone) {
                userRequest.phones = this.state.phones;
            }

            if (this.state.name) {
                userRequest.name = this.state.name;
            }

            if (this.state.surname) {
                userRequest.surname = this.state.surname;
            }

            __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].createNewUser(userRequest).then(function (response) {
                if (response.status === 200) {
                    _this4.setState({
                        isOpenSuccessMessage: true,
                        success: response.data.data.message
                    }, function () {
                        var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this4.props.user);
                        newUser.email = response.data.data._id;
                        _this4.props.updateVesselOrderUser(newUser);
                        _this4.props.closeAddUserPopup();
                    });
                }
            }).catch(function (errors) {
                _this4.createErrorObject(errors.response.data.errors);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var actions = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: this.props.closeAddUserPopup
            }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
                label: 'Create',
                primary: true,
                onClick: this.createNewUser
            })];

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default.a,
                    {
                        title: 'Create new user',
                        actions: actions,
                        modal: true,
                        open: this.props.isOpen,
                        className: 'create-user-popup'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a, {
                                errorText: this.state.errors.name ? this.state.errors.name.message : '',
                                hintText: 'Name',
                                name: 'name',
                                defaultValue: this.state.name,
                                onChange: this.changeField
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a, {
                                errorText: this.state.errors.surname ? this.state.errors.surname.message : '',
                                hintText: 'Surname',
                                name: 'surname',
                                defaultValue: this.state.surname,
                                onChange: this.changeField
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a, {
                                errorText: this.state.errors['phones.0.code'] ? this.state.errors['phones.0.code'].message : '',
                                hintText: 'Phone code',
                                defaultValue: this.state.phones[0].code,
                                name: 'phonecode',
                                onChange: this.changeField
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default.a, {
                                errorText: this.state.errors['phones.0.phone'] ? this.state.errors['phones.0.phone'].message : '',
                                hintText: 'Phone number',
                                defaultValue: this.state.phones[0].phone,
                                name: 'phonenumber',
                                onChange: this.changeField
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a, {
                                name: 'email',
                                hintText: 'Email Auto Complete',
                                errorText: this.state.errors.email ? this.state.errors.email.message : '',
                                searchText: this.state.email,
                                dataSource: this.state.emails,
                                dataSourceConfig: { text: 'email', value: 'item' },
                                onUpdateInput: this.changeEmail,
                                onNewRequest: this.chooseEmail,
                                filter: __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a.noFilter,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'col' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a, {
                                name: 'company',
                                hintText: 'Company Auto Complete',
                                errorText: this.state.errors.company ? this.state.errors.company.message : '',
                                searchText: this.state.company,
                                dataSource: this.state.companies,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: this.changeCompany,
                                onNewRequest: this.chooseCompany,
                                filter: __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a.noFilter,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar___default.a, {
                    open: this.state.isOpenSuccessMessage,
                    message: this.state.success,
                    autoHideDuration: 2000,
                    onRequestClose: this.onMessageClose
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CreateUserPopup;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        closeAddUserPopup: ownProps.closeAddUserPopup,
        isOpen: ownProps.isOpen,
        vesselOrders: state.vesselOrders.items,
        user: state.vesselOrders.user
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselOrderUser: __WEBPACK_IMPORTED_MODULE_10_actions_vessels_orders__["h" /* updateVesselOrderUser */]
    }, dispatch);
})(CreateUserPopup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CreateUserPopup, 'CreateUserPopup', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/CreateUserPopup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/CreateUserPopup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_annotations__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectedTextPopup__ = __webpack_require__(1924);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var AnnotationsEditor = function (_React$Component) {
    _inherits(AnnotationsEditor, _React$Component);

    function AnnotationsEditor(props) {
        var _this$state;

        _classCallCheck(this, AnnotationsEditor);

        var _this = _possibleConstructorReturn(this, (AnnotationsEditor.__proto__ || Object.getPrototypeOf(AnnotationsEditor)).call(this, props));

        _this.state = (_this$state = {
            renderContent: []
        }, _defineProperty(_this$state, 'renderContent', []), _defineProperty(_this$state, 'openPopover', false), _this$state);

        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.closePopover = _this.closePopover.bind(_this);
        return _this;
    }

    _createClass(AnnotationsEditor, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            var letterText = newProps.letterText,
                annotations = newProps.annotations;


            if (letterText && annotations.length > 0) {
                var clearedAnnotations = this.clearUnusefullWords(annotations);
                var sortedAnnotations = this.sortForLongerAnnotate(clearedAnnotations);

                this.createRenderedContent(letterText, sortedAnnotations);
            } else {
                this.setState({
                    renderContent: undefined,
                    tooltips: undefined
                });
            }
        }
    }, {
        key: 'sortForLongerAnnotate',
        value: function sortForLongerAnnotate(annotations) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(annotations, function (a, b) {
                return -a.features.string.length;
            });
        }
    }, {
        key: 'clearUnusefullWords',
        value: function clearUnusefullWords(annotations) {
            var array = annotations.filter(function (annotation) {
                return annotation.type !== 'Lookup' && annotation.type !== 'Sentence' && annotation.type !== 'Split' && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(annotation, 'features.rule');
            });

            var map = new Map();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    var key = item.type + "-" + item.features.rule + "-" + item.start + "-" + item.end;
                    map.set(key, item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return Array.from(map.values());
        }
    }, {
        key: 'createRenderedContent',
        value: function createRenderedContent(letterText, annotations) {
            var renderContent = letterText.split('');
            if (renderContent.length) {
                renderContent = renderContent.map(function (symbol, symbolPosition) {
                    symbol = symbol === ' ' ? '\xA0' : symbol;
                    return {
                        symbol: symbol,
                        symbolPosition: symbolPosition,
                        style: {},
                        ids: [],
                        tooltipContent: []
                    };
                });

                for (var i = 0; i < annotations.length; i++) {
                    var hashColor = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].createHashColor();
                    for (var j = annotations[i].start; j < annotations[i].end; j++) {
                        if (renderContent[j]) {
                            renderContent[j].style = {
                                background: hashColor
                            };
                            renderContent[j].ids.push(annotations[i].id);
                            renderContent[j].tooltipContent.push({
                                rule: annotations[i].features.rule,
                                type: annotations[i].type
                            });
                        }
                    }
                }

                var tooltips = this.createTooltips(renderContent);

                this.setState({
                    renderContent: renderContent,
                    tooltips: tooltips
                });
            }
        }
    }, {
        key: 'createTooltips',
        value: function createTooltips(characters) {
            var map = new Map();
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = characters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var char = _step2.value;

                    map.set(char.ids.join(''), char);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return Array.from(map.values());
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp(ev) {
            var range = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].getSelection(ev.target.parentNode);

            if (range.start === range.end) {
                return;
            }

            var hashColor = __WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* default */].createHashColor();
            var renderContent = this.state.renderContent.slice(0);

            renderContent.forEach(function (el) {
                if (el.position >= range.start && el.position < range.end) {
                    renderContent.push({
                        style: {
                            background: hashColor
                        }
                    });
                }
            });

            this.setState({
                renderContent: renderContent,
                openPopover: true,
                anchorEl: ev.target,
                chosenText: range.string
            });
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.setState({
                openPopover: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelectedTextPopup__["a" /* default */], {
                    openPopover: this.state.openPopover,
                    anchorEl: this.state.anchorEl,
                    closePopover: this.closePopover,
                    chosenText: this.state.chosenText
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'letter-text', onMouseUp: this.onMouseUp },
                    this.state.renderContent ? Array.from(Object(__WEBPACK_IMPORTED_MODULE_6_helpers_annotations__["b" /* letterMapper */])(this.state.renderContent)) : this.props.letterText
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_helpers_annotations__["a" /* AnnotationTooltip */], { tooltips: this.state.tooltips, renderTooltip: function renderTooltip(tooltip) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'tooltip-row' },
                            tooltip.tooltipContent.map(function (t, k) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { key: k, className: 'tooltip-column' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col' },
                                        'Rule - ' + t.rule + ', '
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col' },
                                        'Type - ' + t.type
                                    )
                                );
                            })
                        );
                    } })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationsEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        letterText: ownProps.letterText,
        annotations: state.annotations.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationsEditor);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationsEditor, 'AnnotationsEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/AnnotationsEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/AnnotationsEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_size__ = __webpack_require__(224);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SelectedTextPopup = function (_React$Component) {
    _inherits(SelectedTextPopup, _React$Component);

    function SelectedTextPopup(props) {
        _classCallCheck(this, SelectedTextPopup);

        var _this = _possibleConstructorReturn(this, (SelectedTextPopup.__proto__ || Object.getPrototypeOf(SelectedTextPopup)).call(this, props));

        _this.state = {
            numberVesselSize: null
        };

        _this.selectVesselSize = _this.selectVesselSize.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(SelectedTextPopup, [{
        key: 'onChange',
        value: function onChange(e, fieldValue) {
            if (this.state.numberVesselSize === null) {
                return;
            }

            var newVesselSize = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselSizes[this.state.numberVesselSize]);
            var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselSizeUser);

            switch (fieldValue) {
                case 'term':
                    newVesselSize.terms.push({ type: '', value: this.props.chosenText });
                    break;
                // todo check for autocomplete user
                case 'email':
                    newUser.email = this.props.chosenText;
                    break;
                case 'company':
                    newUser.company = this.props.chosenText;
                    break;
                case 'name':
                    newUser.name = this.props.chosenText;
                    break;
                case 'surname':
                    newUser.surname = this.props.chosenText;
                    break;
                case 'phonecode':
                    newUser.phones[0].code = this.props.chosenText;
                    break;
                case 'phone':
                    newUser.phones[0].phone = this.props.chosenText;
                    break;
            }

            this.props.updateVesselSize(this.state.numberVesselSize, newVesselSize);
            this.props.updateVesselSizeUser(newUser);
            this.props.closePopover();
        }
    }, {
        key: 'selectVesselSize',
        value: function selectVesselSize(e, index, value) {
            this.setState({
                numberVesselSize: value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var renderMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default.a,
                { onChange: this.onChange },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Term', value: 'term' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Email user', value: 'email' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Company new user', value: 'company' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Name new user', value: 'name' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Surname new user', value: 'surname' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone code new user', value: 'phonecode' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone number new user', value: 'phone' })
            );

            if (this.state.numberVesselSize === null) {
                renderMenu = null;
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'popup' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default.a,
                    {
                        open: this.props.openPopover,
                        anchorEl: this.props.anchorEl,
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' },
                        onRequestClose: this.props.closePopover,
                        animation: __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__["PopoverAnimationVertical"]
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'popup-choose' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'chosen' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'chosen-title' },
                                'Chosen text'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'chosen-row' },
                                '\'' + this.props.chosenText + '\''
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
                        {
                            floatingLabelText: 'Choose vessel size',
                            value: this.state.numberVesselSize,
                            onChange: this.selectVesselSize,
                            style: {
                                width: '200px',
                                padding: '0 10px'
                            }
                        },
                        this.props.vesselSizes.map(function (item, i) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                key: i,
                                value: i,
                                primaryText: 'Vessel size - ' + (i + 1)
                            });
                        })
                    ),
                    renderMenu
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SelectedTextPopup;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        openPopover: ownProps.openPopover,
        anchorEl: ownProps.anchorEl,
        closePopover: ownProps.closePopover,
        chosenText: ownProps.chosenText,
        vesselSizes: state.vesselSizes.items,
        vesselSizesUser: state.vesselSizes.user
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselSize: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_size__["g" /* updateVesselSize */],
        updateVesselSizeUser: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_size__["h" /* updateVesselSizeUser */]
    }, dispatch);
})(SelectedTextPopup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SelectedTextPopup, 'SelectedTextPopup', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/SelectedTextPopup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/SelectedTextPopup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var AnnotationsList = function (_React$Component) {
    _inherits(AnnotationsList, _React$Component);

    function AnnotationsList(props) {
        _classCallCheck(this, AnnotationsList);

        var _this = _possibleConstructorReturn(this, (AnnotationsList.__proto__ || Object.getPrototypeOf(AnnotationsList)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            annotations: _this.props.annotations,
            searchText: ''
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }

    _createClass(AnnotationsList, [{
        key: 'filterAnnotations',
        value: function filterAnnotations(searchArray, searchText) {
            searchText = searchText.toLowerCase();

            return searchArray.filter(function (annotation) {
                if (annotation.features) {
                    if (annotation.features.rule) if (annotation.features.rule.toLowerCase().includes(searchText)) return true;

                    if (annotation.features.majorType) if (annotation.features.majorType.toLowerCase().includes(searchText)) return true;

                    if (annotation.features.string) if (annotation.features.string.toLowerCase().includes(searchText)) return true;
                }

                if (annotation.type) {
                    if (annotation.type.toLowerCase().includes(searchText)) {
                        return true;
                    }
                }

                if (annotation.id) {
                    var id = annotation.id + '';
                    if (id.includes(searchText)) {
                        return true;
                    }
                }

                return false;
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            var _this2 = this;

            if (props.annotations.length) {
                this.setState({
                    annotations: props.annotations,
                    total: props.annotations.length
                }, function () {
                    _this2.handleUpdateRow(_this2.state);
                });
            }
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            var _this3 = this;

            var annotations = this.filterAnnotations(this.props.annotations, e.target.value);

            this.setState({
                annotations: annotations,
                total: annotations.length
            }, function () {
                _this3.handleUpdateRow(_this3.state);
            });
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.annotations.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var renderComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'annotations-list-b' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                        className: this.props.isLoaded ? 'hidden' : '',
                        style: {
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)'
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? 'navigation' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-arrows' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__["a" /* default */], {
                            total: this.state.annotations.length,
                            rowsPerPage: this.state.rowsPerPage,
                            page: this.state.page,
                            numberOfRows: this.state.numberOfRows,
                            updateRows: this.handleUpdateRow
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-search' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                            hintText: 'Search',
                            hintStyle: { fontSize: 12 },
                            style: { fontSize: 12 },
                            onChange: this.handleSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'navigation-info' },
                        'Total annotations: ',
                        this.state.annotations.length
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? 'annotations-table' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeader"],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                                { style: { height: '28px' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Value'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Rule'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'Type'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'MajorType'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                                    { style: { padding: '0 24px', height: '28px' } },
                                    'id'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                            { displayRowCheckbox: false },
                            this.state.rows.map(function (annotation, i) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                                    { style: { height: '28px' }, key: i },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.string
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.rule
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.type
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.features.majorType
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                        { style: { padding: '0 24px', height: '28px' } },
                                        annotation.id
                                    )
                                );
                            })
                        )
                    )
                )
            );
            var renderError = 'Something wrong with request';

            if (this.props.isError) {
                renderComponent = null;
            } else {
                renderError = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                renderComponent,
                renderError
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AnnotationsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        annotations: state.annotations.items,
        isLoaded: state.annotations.isLoaded,
        error: state.annotations.error,
        isError: state.annotations.isError
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationsList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationsList, 'AnnotationsList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/AnnotationsList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/AnnotationsList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

module.exports = {
    bulk: ['Cement Carrier', 'Wood Chips Carrier', 'Aggregate Carrier', 'Limestone Carrier', 'Ore/Sulphuric Acid Carrier', 'Ore Carrier', 'Salt Carrier', 'Slurry Carrier', 'Urea Carrier', 'Self Discharging Bulk Carrier', 'Powder Carrier', 'Bauxite Carrier', 'Grain Carrier', 'Refined Sugar Carrier', 'Bulk Dry Storage Ship', 'Pulp Carrier'],
    bulktank: ['Bulk/Oil Carrier', 'Bulk/Liquid Carrier', 'OBO Carrier (ore/bulk/oil)'],
    mpp: ['Container/Bulk Ship', 'Container/Break Bulk Ship', 'Deck Cargo Carrier', 'Heavy Load Carrier', 'Heavy Lift Vessel', 'Landing Craft', 'Palletised Cargo Carrier', 'Ro-Ro/Pass Carrier', 'Ro-Lo Cargo Carrier', 'Ro-Ro Cargo Carrier', 'Ro-Ro/Container carrier', 'Timber Carrier'],
    livestock: ['Livestock Carrier', 'Open Livestock Carriers', 'Close Livestock Carriers'],
    reefer: ['Reefer/General Cargo', 'Reefer Fish Carrier', 'Reefer/Pallets Carrier', 'Reefer/Ro-Ro Cargo', 'Reefer/Containership'],
    tank: ['Chemical Tanker', 'Chemical/Oil Products Tanker', 'Oil Products Tanker', 'Fruit Juice Carrier', 'Methanol Carrier', 'Molten Sulphur Carrier', 'Oil/Liquid Gas Carrier', 'Oil Recovery Tanker', 'Phosphoric Acid Carrier', 'Shuttle Tanker', 'Sulphuric Acid Carrier', 'Waste Disposal Carrier', 'Water Carrier', 'Asphalt/Bitumen Carrier', 'Bunkering Tanker', 'LNG Tanker', 'LPG Tanker', 'Crude Oil Tanker', 'CO2 Tanker', 'Wine Tanker', 'Edible Oil Tanker', 'Vegetable Oil Carrier', 'Caprolactam Carrier', 'Molasses Carrier', 'Latex Carrier', 'Nuclear Fuel Carrier', 'Beer Carrier', 'FSO/FPSO Tanker'],
    cont: ['Barge/Lichter Carrier', 'Fully Cellular Container Ship', 'Container/Passenger Ship'],
    car: ['Vehicles Carrier', 'Rail/Vehicles Carrier'],
    passcar: ['Passenger/Ro-Ro Cargo Ship', 'Passenger/Cargo Ship'],
    pass: ['Cruise/Passenger Ship']
};

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Divider__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__(10);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








/** @type {Record<string, import('react').CSSProperties>} */
var styles = {
    fileInput: {
        visibility: 'hidden',
        position: 'absolute',
        top: '-100000px',
        left: '-100000px'
    },
    link: {
        textDecoration: 'underline',
        color: '#4380C7'
    }
};

function Attachments(_ref) {
    var attachments = _ref.attachments,
        changeField = _ref.changeField,
        confirmed = _ref.confirmed;

    var fileRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var hasAttachments = !!(attachments || []).length;
    var handleAdd = function handleAdd() {
        var input = /** @type {HTMLInputElement} */fileRef.current;
        var file = input.files[0];
        input.value = '';
        __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].uploadFile({ file: file, type: 'attachment' }).then(function (res) {
            var newAttachments = [].concat(_toConsumableArray(attachments), [res.data.data]);
            changeField({
                field: 'attachmentsArray',
                value: newAttachments
            });
            changeField({
                field: 'attachments',
                value: newAttachments.map(function (a) {
                    return a._id;
                })
            });
        }).catch(console.error);
    };
    var handleRemove = function handleRemove(attachment) {
        var newAttachments = attachments.filter(function (a) {
            return a._id !== attachment._id;
        });
        changeField({
            field: 'attachmentsArray',
            value: newAttachments
        });
        changeField({
            field: 'attachments',
            value: newAttachments.map(function (a) {
                return a._id;
            })
        });
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row', style: { marginBottom: hasAttachments ? '16px' : '0' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block static huge-name', style: { lineHeight: '36px' } },
                    'ATTACHMENTS:'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2 col-xs-offset-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    backgroundColor: 'white',
                    labelStyle: { color: '#333', fontWeight: 'bold' },
                    label: 'ADD',
                    onClick: function onClick() {
                        return (/** @type {HTMLInputElement} */fileRef.current.click()
                        );
                    },
                    disabled: !confirmed
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                type: 'file',
                name: 'files',
                ref: fileRef,
                style: styles.fileInput,
                onChange: handleAdd
            })
        ),
        attachments.map(function (attachment) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-10', style: { lineHeight: '48px', paddingLeft: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            {
                                style: styles.link,
                                href: '/api/v1/file/' + attachment.fileId,
                                download: true
                            },
                            attachment.name
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2', style: { textAlign: 'right' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                            {
                                disabled: !confirmed,
                                onClick: function onClick() {
                                    return handleRemove(attachment);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Divider___default.a, null)
            );
        })
    );
}

var _default = Attachments;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Attachments.jsx');
    reactHotLoader.register(Attachments, 'Attachments', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Attachments.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Attachments.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_vessels_size__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var VesselShortInfo = function (_React$Component) {
    _inherits(VesselShortInfo, _React$Component);

    function VesselShortInfo(props) {
        _classCallCheck(this, VesselShortInfo);

        var _this = _possibleConstructorReturn(this, (VesselShortInfo.__proto__ || Object.getPrototypeOf(VesselShortInfo)).call(this, props));

        _this.state = {
            vesselNames: [],
            vesselName: props.vesselSize.vesselName,
            imoNumber: props.vesselSize.imoNumber,
            DWT: props.vesselSize.DWT,
            BLT: props.vesselSize.BLT
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (searchText) {
            if (searchText) {
                __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findVessel(searchText).then(function (response) {
                    var vesselNames = response.data.data.map(function (vessel) {
                        return {
                            name: vessel.name + ' (imoNumber - ' + vessel.imoNumber + ')',
                            item: vessel
                        };
                    });

                    _this.setState({
                        vesselNames: vesselNames
                    });
                }).then(function () {
                    var newVesselSize = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.props.vesselSize);
                    newVesselSize.vesselName = searchText;
                    _this.props.updateVesselSize(_this.props.numberSizeTable, newVesselSize);
                }).catch(function () {
                    return null;
                });
            }
        }, 1000);

        _this.chooseVessel = _this.chooseVessel.bind(_this);
        _this.changeVesselName = _this.changeVesselName.bind(_this);
        return _this;
    }

    _createClass(VesselShortInfo, [{
        key: 'dAutocomplete',
        value: function dAutocomplete(searchText) {}
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                vesselName: nextProps.vesselSize.vesselName,
                imoNumber: nextProps.vesselSize.imoNumber,
                DWT: nextProps.vesselSize.DWT,
                BLT: nextProps.vesselSize.BLT
            });
        }
    }, {
        key: 'changeVesselName',
        value: function changeVesselName(searchText) {
            var _this2 = this;

            // check if the searchText has only the vessel name
            if (searchText.includes('(imoNumber')) {
                return;
            }
            if (this.state.vesselName !== searchText) {
                this.setState({
                    vesselName: searchText
                }, function () {
                    _this2.dAutocomplete(searchText);
                });
            }
        }
    }, {
        key: 'chooseVessel',
        value: function chooseVessel(updateProperties) {
            if (!updateProperties) {
                return;
            }

            var newVesselSize = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.vesselSize);

            newVesselSize.vesselName = updateProperties.name;
            newVesselSize.vessel = updateProperties.item._id;
            newVesselSize.imoNumber = updateProperties.item.imoNumber;
            newVesselSize.DWT = updateProperties.item.dw.summer;
            newVesselSize.BLT = updateProperties.item.blt;

            this.props.updateVesselSize(this.props.numberSizeTable, newVesselSize);

            this.setState({
                imoNumber: updateProperties.item.imoNumber,
                DWT: updateProperties.item.dw.summer,
                BLT: updateProperties.item.blt
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var errorVesselName = this.props.errorVesselName ? this.props.errorVesselName.messages[0] : '';
            var _state = this.state,
                vesselNames = _state.vesselNames,
                vesselName = _state.vesselName,
                imoNumber = _state.imoNumber,
                DWT = _state.DWT,
                BLT = _state.BLT;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginTop: '-30px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'sidebar-table' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            'Vessel name:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-right' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                                name: 'vesselName',
                                textFieldStyle: { fontSize: '13px' },
                                hintText: 'Vessel name',
                                errorText: errorVesselName,
                                searchText: vesselName || '',
                                dataSource: vesselNames,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: this.changeVesselName,
                                onNewRequest: this.chooseVessel,
                                filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                                fullWidth: true,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            'imoNumber:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-right' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'label' },
                                imoNumber
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            'DWT:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            DWT
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            'BLT:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            BLT
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselShortInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var errorVesselName = state.vesselSizes.items[ownProps.numberSizeTable].validateErrors.find(function (validateError) {
        return validateError.field === 'vessel';
    });

    return {
        numberSizeTable: ownProps.numberSizeTable,
        errorVesselName: errorVesselName,
        vesselSize: state.vesselSizes.items[ownProps.numberSizeTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselSize: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_size__["g" /* updateVesselSize */]
    }, dispatch);
})(VesselShortInfo);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselShortInfo, 'VesselShortInfo', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/VesselShortInfo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/VesselShortInfo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getPlainDeepKeysValues;
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateDeepPaths;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getPlainDeepKeysValues(obj) {
    var pairs = [];

    var walk = function walk(o) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.entries(o)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _step$value = _slicedToArray(_step.value, 2),
                    k = _step$value[0],
                    v = _step$value[1];

                var current = parent ? parent + '.' + k : k;

                if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) !== 'object') {
                    pairs.push(_defineProperty({}, current, v));
                }

                if (Object.prototype.toString.call(v) === '[object Object]' || Array.isArray(v)) {
                    walk(v, current);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };

    walk(obj);

    return pairs;
}

/**
 * @description Convert object to array of (field, value) pairs to show modified
 * @param {{ stateField: string, value: any, arrayIndex?: number }} params 
 */
function calculateDeepPaths(params) {
    var stateField = params.stateField,
        value = params.value,
        arrayIndex = params.arrayIndex;

    var modifications = [];
    var currentIndex = arrayIndex;

    if (Array.isArray(params.value)) {
        value.forEach(function (item) {
            var plains = getPlainDeepKeysValues(item);
            plains.forEach(function (__item) {
                var _Object$entries$ = _slicedToArray(Object.entries(__item)[0], 2),
                    plainKey = _Object$entries$[0],
                    plainValue = _Object$entries$[1];

                var key = stateField + '.';
                if (arrayIndex === 0 || arrayIndex > 0) key += currentIndex + '.';
                modifications.push(_defineProperty({}, getBracketPath('' + key + plainKey), plainValue));
            });
            currentIndex++;
        });
    } else if (Object.prototype.toString.call(value) === '[object Object]') {
        var plains = getPlainDeepKeysValues(value);
        plains.forEach(function (item) {
            var _Object$entries$2 = _slicedToArray(Object.entries(item)[0], 2),
                plainKey = _Object$entries$2[0],
                plainValue = _Object$entries$2[1];

            var key = stateField + '.';
            if (arrayIndex === 0 || arrayIndex > 0) key += currentIndex + '.';
            modifications.push(_defineProperty({}, getBracketPath('' + key + plainKey), plainValue));
        });
    } else {
        modifications.push(_defineProperty({}, stateField, value));
    }

    return modifications;
}

function getBracketPath(path) {
    var items = path.split('.');
    var str = '';

    items.forEach(function (item, index) {
        if (index === 0) {
            str += item;
        } else if (index === items.length - 1) {
            str += '.' + item;
        } else {
            str += '[' + item + ']';
        }
    });

    return str;
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getPlainDeepKeysValues, 'getPlainDeepKeysValues', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/utils.js');
    reactHotLoader.register(calculateDeepPaths, 'calculateDeepPaths', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/utils.js');
    reactHotLoader.register(getBracketPath, 'getBracketPath', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/utils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = CollapsableSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_expand_more__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_expand_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_expand_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_expand_less__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_expand_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_expand_less__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var styles = {
    icon: {
        margin: '-3px 15px 0 0',
        verticalAlign: 'middle',
        color: '#b2b2b2'
    }
};

/**
 * @param {{
 *   title: string,
 *   children: React.ReactNode,
 *   disabled?: boolean,
 *   titleControl?: React.ReactNode,
 *   initiallyCollapsed?: boolean,
 * }} props
 */
function CollapsableSection(_ref) {
    var title = _ref.title,
        children = _ref.children,
        disabled = _ref.disabled,
        titleControl = _ref.titleControl,
        initiallyCollapsed = _ref.initiallyCollapsed;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!!initiallyCollapsed),
        _useState2 = _slicedToArray(_useState, 2),
        collapsed = _useState2[0],
        setCollapsed = _useState2[1];

    var toggleCollapsed = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (!disabled) {
            setCollapsed(function (v) {
                return !v;
            });
        }
    }, [disabled]);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'paper-block margin-bottom' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                        className: 'name-block static huge-name',
                        onClick: toggleCollapsed,
                        style: { cursor: disabled ? 'not-allowed' : 'pointer' }
                    },
                    !disabled && !collapsed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_expand_less___default.a, { style: styles.icon }),
                    (disabled || collapsed) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_expand_more___default.a, { style: styles.icon }),
                    title
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 col-xs-offset-3' },
                !disabled && !collapsed && titleControl
            )
        ),
        !disabled && !collapsed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-12' },
                children
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/CollapsableSection.jsx');
    reactHotLoader.register(CollapsableSection, 'CollapsableSection', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Sidebar/Size/CollapsableSection.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0', minWidth: '50px' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px'
        }
    }
};

var TextEditor = function (_React$Component) {
    _inherits(TextEditor, _React$Component);

    function TextEditor(props) {
        _classCallCheck(this, TextEditor);

        var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));

        _this.state = {
            open: false,
            textLetter: props.textLetter,
            originalText: props.textLetter
        };

        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.changeTextLetterText = _this.changeTextLetterText.bind(_this);
        _this.updateGazetters = _this.updateGazetters.bind(_this);
        _this.returnOriginalText = _this.returnOriginalText.bind(_this);
        return _this;
    }

    _createClass(TextEditor, [{
        key: 'returnOriginalText',
        value: function returnOriginalText() {
            this.setState({
                textLetter: this.props.textLetter
            });
        }
    }, {
        key: 'updateGazetters',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var textLetter;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                textLetter = this.state.textLetter;

                                if (!textLetter) {
                                    _context.next = 8;
                                    break;
                                }

                                this.toggleDialog();

                                this.props.removeAnnotations();
                                this.props.removeGazetters();
                                _context.next = 7;
                                return this.props.getLetterData(textLetter);

                            case 7:
                                this.props.updatePostGazetters(textLetter);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateGazetters() {
                return _ref.apply(this, arguments);
            }

            return updateGazetters;
        }()
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                textLetter: nextProps.textLetter
            });
        }
    }, {
        key: 'changeTextLetterText',
        value: function changeTextLetterText(e) {
            this.setState({
                textLetter: e.target.value
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            this.setState({
                open: !this.state.open
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                open = _state.open,
                textLetter = _state.textLetter;


            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RE-ANNOTATE',
                primary: true,
                onClick: this.updateGazetters
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RETURN ORIGINAL TEXT',
                primary: true,
                onClick: this.returnOriginalText
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'CLOSE',
                primary: true,
                onClick: this.toggleDialog
            })];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    label: 'Editor',
                    labelStyle: styles.button.labelStyle,
                    style: styles.button.style,
                    buttonStyle: styles.button.buttonStyle,
                    onClick: this.toggleDialog,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
                    {
                        title: 'Edit letter text',
                        actions: actions,
                        contentStyle: styles.dialog.contentStyle,
                        open: open,
                        modal: true
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                        style: styles.textarea.style,
                        value: textLetter,
                        onChange: this.changeTextLetterText
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TextEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TextEditor;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/TextEditor.jsx');
    reactHotLoader.register(TextEditor, 'TextEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/TextEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/Content/TextEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false,
            info: {},
            error: {}
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            this.setState({
                hasError: true,
                info: info,
                error: error
            });
        }
    }, {
        key: "render",
        value: function render() {
            var hasError = this.state.hasError;


            if (hasError) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "react-error" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h1",
                        null,
                        "Something went wrong"
                    )
                );
            }

            return this.props.children;
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ErrorBoundary;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/ErrorBoundary.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Size/ErrorBoundary.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Base_UserSelector__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Sidebar_OrderTable__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Content_AnnotationsEditor__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Content_AnnotationsList__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HtmlContent__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Content_TextEditor__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ErrorBoundary__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_helpers_cargoUtils__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sagas_letters__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sagas_annotations__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sagas_orders__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_actions_cargoes_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_actions_cargoes_names__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_actions_termEntities__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_actions_cargoes_requests__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_actions_contracts__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_actions_cargoes_assigners__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_actions_letters__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_Letters_Single_Attachments__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__common_FailedToSent__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Sidebar_Order_VesselRequirements__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__common_ToSpamButton__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-await-in-loop */











































// import Trainings from 'components/Letters/Single/Gazetter/Trainings';







var LetterCargo = function (_React$Component) {
    _inherits(LetterCargo, _React$Component);

    function LetterCargo(props) {
        _classCallCheck(this, LetterCargo);

        var _this = _possibleConstructorReturn(this, (LetterCargo.__proto__ || Object.getPrototypeOf(LetterCargo)).call(this, props));

        _this.saveHandlers = [];

        _this.toggleAttachmentsDialog = function () {
            _this.setState({
                openedAttachmentsDialog: !_this.state.openedAttachmentsDialog
            });
        };

        _this.onUserUpdate = function (newUser) {
            _this.props.updateCargoOrderUser(newUser);
        };

        _this.toggleFailedToSentOpen = function () {
            _this.setState({
                failedToSentOpen: !_this.state.failedToSentOpen
            });
        };

        if (localStorage.getItem('settings-order-cargo' + props.objUser.user._id)) {
            _this.initialState = JSON.parse(localStorage.getItem('settings-order-cargo' + props.objUser.user._id));
        } else {
            _this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem('settings-order-cargo' + props.objUser.user._id, JSON.stringify(_this.initialState));
        }

        _this.state = _extends({}, _this.initialState, {
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientCargo: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            isSimpleForm: false,
            sendStatusPending: false,
            failedToSentOpen: false,
            isFormChanged: false,
            cargoOrdersDuplicates: []
        });

        _this.addOrderTable = _this.addOrderTable.bind(_this);
        _this.sendRequestCargo = _this.sendRequestCargo.bind(_this);
        _this.removeOrderTable = _this.removeOrderTable.bind(_this);
        _this.clearOrderTable = _this.clearOrderTable.bind(_this);
        _this.handleFillRequest = _this.handleFillRequest.bind(_this);
        _this.changeAnnotationsServer = _this.changeAnnotationsServer.bind(_this);
        _this.changeClarifiedServer = _this.changeClarifiedServer.bind(_this);
        _this.getLetterData = _this.getLetterData.bind(_this);

        _this.updatePostGazetters = _this.updatePostGazetters.bind(_this);

        _this.handleClientChange = _this.handleClientChange.bind(_this);

        _this.saveRequestsDataCreated = _this.saveRequestsDataCreated.bind(_this);
        _this.sendRequestCargoFromSent = _this.sendRequestCargoFromSent.bind(_this);
        return _this;
    }

    _createClass(LetterCargo, [{
        key: 'getLetterData',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(textEdit) {
                var _ref2, letter, annotationsResponse;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_20_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_21_sagas_letters__["b" /* getLetter */], this.props.routeParams.id, 'cargo');

                            case 3:
                                _ref2 = _context.sent;
                                letter = _ref2.data;


                                letter.gazettersArr = [];
                                letter.type = 'cargo';
                                letter.fromCargoOrders = true;

                                if (textEdit) {
                                    letter.text = textEdit;
                                }

                                _context.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_20_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_22_sagas_annotations__["b" /* postAnnotations */], letter.text, letter.type, this.state.annotationsServer, {
                                    emailId: letter._id,
                                    isSimpleForm: this.state.isSimpleForm,
                                    subject: letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(letter.date).format('DD-MM-YYYY')
                                });

                            case 11:
                                annotationsResponse = _context.sent;


                                if (annotationsResponse) {
                                    letter.gazettersArr = annotationsResponse.data.annotations;
                                    if (annotationsResponse.data.newclarified) {
                                        letter.newclarified = annotationsResponse.data.newclarified;
                                    }
                                }

                                _context.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_20_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_23_sagas_lettersNew__["d" /* updateLetter */], __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(letter, 'gazettersArr'), 'cargo', this.state.clarifiedServer);

                            case 15:
                                _context.next = 20;
                                break;

                            case 17:
                                _context.prev = 17;
                                _context.t0 = _context['catch'](0);

                                console.error(_context.t0);

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 17]]);
            }));

            function getLetterData(_x) {
                return _ref.apply(this, arguments);
            }

            return getLetterData;
        }()
    }, {
        key: 'changeAnnotationsServer',
        value: function changeAnnotationsServer(e, i, value) {
            var _this2 = this;

            this.initialState = {
                annotationsServer: value,
                clarifiedServer: this.state.clarifiedServer
            };

            localStorage.setItem('settings-order-cargo' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this2.getLetterData(_this2.state.textLetter);
            });
        }
    }, {
        key: 'changeClarifiedServer',
        value: function changeClarifiedServer(e, i, value) {
            var _this3 = this;

            this.initialState = {
                annotationsServer: this.state.annotationsServer,
                clarifiedServer: value
            };

            localStorage.setItem('settings-order-cargo' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this3.getLetterData(_this3.state.textLetter);
            });
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var state;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                state = this.props.location.state;
                                _context2.next = 3;
                                return this.props.getCargoTypes();

                            case 3:
                                _context2.next = 5;
                                return this.props.getCargoAssigners();

                            case 5:
                                _context2.next = 7;
                                return this.props.getTermEntities();

                            case 7:
                                _context2.next = 9;
                                return this.props.getContracts();

                            case 9:
                                _context2.next = 11;
                                return this.props.getCargoesByTypeName({ name: 'Container' });

                            case 11:

                                if (state) {
                                    this.getLetterData(state.modifiedTextLetter);
                                } else {
                                    this.getLetterData();
                                }

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentDidMount() {
                return _ref3.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'removeOrderTable',
        value: function removeOrderTable() {
            this.props.removeLastCargoOrder();
        }
    }, {
        key: 'clearOrderTable',
        value: function clearOrderTable() {
            this.props.removeLastCargoOrder();
            this.props.addCargoOrder();
        }
    }, {
        key: 'addOrderTable',
        value: function addOrderTable() {
            this.props.addCargoOrder();
        }
    }, {
        key: 'saveRequestsDataCreated',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(order) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_20_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_24_sagas_orders__["a" /* saveRequestsDataCreated */], 'cargo', _extends({}, order, { mailId: this.props.letter._id }));

                            case 3:
                                _context3.next = 8;
                                break;

                            case 5:
                                _context3.prev = 5;
                                _context3.t0 = _context3['catch'](0);

                                console.error(_context3.t0);

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 5]]);
            }));

            function saveRequestsDataCreated(_x2) {
                return _ref4.apply(this, arguments);
            }

            return saveRequestsDataCreated;
        }()
    }, {
        key: 'createCargoRequest',
        value: function createCargoRequest(cargoOrder, keyCargoOrder, cargoRequests) {
            var _this4 = this;

            var cargoRequest = _extends({}, cargoOrder, {
                cargo: cargoOrder.cargo,
                keyCargoOrder: keyCargoOrder
            });

            if (this.state.packingListSelection) {
                cargoRequest.cargo[0].packingList = this.state.packingListSelection.items;
            }

            for (var type in cargoRequest.ldRates) {
                for (var key in cargoRequest.ldRates[type].cqd) {
                    if (key !== 'cqd') {
                        cargoRequest.ldRates[type][key] = undefined;
                    }
                }
            }

            this.saveRequestsDataCreated(cargoRequest);

            this.multiplyCargoRequests(cargoRequest, cargoRequests);

            cargoRequests.forEach(function (cargoRequest) {
                cargoRequest.cargo.forEach(function (cargo) {
                    if (Array.isArray(cargo.packing.pack.unitsVolume)) {
                        cargo.packing.pack.unitsVolume = cargo.packing.pack.unitsVolume[0];
                    }

                    if (Array.isArray(cargo.packing.pack.unitsWeight)) {
                        cargo.packing.pack.unitsWeight = cargo.packing.pack.unitsWeight[0];
                    }

                    if (cargo.details === 2) {
                        cargo.clauses = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(cargo.clauses, function (c) {
                            return c.name !== 'Cradles to be for';
                        });
                    } else if (cargo.details === 1) {
                        cargo.clauses = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(cargo.clauses, function (c) {
                            return ['Shipment', 'Cradles to be for'].includes(c.name);
                        });
                    } else {
                        cargo.clauses = [];
                    }
                });

                cargoRequest.user = _this4.props.user.email;
            });

            return cargoRequests;
        }
    }, {
        key: 'multiplyCargoRequests',
        value: function multiplyCargoRequests(cargoRequest, cargoRequests) {
            cargoRequests.push(cargoRequest);
            cargoRequest.cargo.forEach(function (cargo, index) {
                var copy = JSON.parse(JSON.stringify(cargoRequest));
                var changed = false;
                var _cargo$packing$pack = cargo.packing.pack,
                    unitsWeight = _cargo$packing$pack.unitsWeight,
                    unitsVolume = _cargo$packing$pack.unitsVolume;
                var _copy$cargo$index$pac = copy.cargo[index].packing.pack,
                    copyUnitsWeight = _copy$cargo$index$pac.unitsWeight,
                    copyUnitsVolume = _copy$cargo$index$pac.unitsVolume;


                if (unitsWeight[1].value) {
                    copyUnitsWeight[0] = copyUnitsWeight[1];
                    changed = true;
                }

                if (unitsVolume[1].value) {
                    copyUnitsVolume[0] = copyUnitsVolume[1];
                    changed = true;
                }

                if (changed) {
                    cargoRequests.push(copy);
                }
            });

            if (cargoRequest.cargo.length > 1) {
                var copy = JSON.parse(JSON.stringify(cargoRequest));
                var changed = false;
                copy.cargo.forEach(function (item) {
                    var _item$packing$pack = item.packing.pack,
                        unitsWeight = _item$packing$pack.unitsWeight,
                        unitsVolume = _item$packing$pack.unitsVolume;


                    if (unitsWeight[1].value) {
                        unitsWeight[0] = unitsWeight[1];
                        changed = true;
                    }

                    if (unitsVolume[1].value) {
                        unitsVolume[0] = unitsVolume[1];
                        changed = true;
                    }
                });
                if (changed) {
                    cargoRequests.push(copy);
                }
            }
        }
    }, {
        key: 'createTerms',
        value: function createTerms(cargoOrders) {
            cargoOrders.forEach(function (cargoOrder) {
                var user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(cargoOrder.terms.user);

                user.forEach(function (term) {
                    if (term.type) {
                        term.value = term.type + ' ' + term.value;
                    }
                });

                cargoOrder.terms.user = user;
            });
        }

        // flushes form changes that were not applied, such as setting selected "registered class" to the state despite user didn't click on the + button.

    }, {
        key: 'sendRequestCargo',
        value: function sendRequestCargo() {
            var _this5 = this;

            var cargoOrders = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrders);

            cargoOrders.forEach(function (cargoOrder, i) {
                if (!cargoOrder.vesselRequirements) {
                    cargoOrder.vesselRequirements = {};
                }
                _this5.saveHandlers[i](cargoOrder);
            });

            var hasErrors = false;

            cargoOrders.forEach(function (cargoOrder, cIndex) {
                // like that because user error is seperate from main cargo object
                cargoOrder.validateErrors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omitBy(cargoOrder.validateErrors, function (i) {
                    i.field === 'user';
                });

                if (cargoOrder.validateErrors.length) {
                    cargoOrder.validateErrors.forEach(function (error) {
                        _this5.props.addNotification({
                            title: 'Error',
                            message: 'Error in request #' + (cIndex + 1) + '. Field ' + error.field + ' --- ' + (error.message || error.messages[0]),
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 100
                        });
                    });

                    hasErrors = true;
                }
            });

            if (hasErrors) {
                return;
            }

            this.setState({ sendStatusPending: true });

            if (!cargoOrders.length) {
                return;
            }

            this.setState({
                isFormChanged: false,
                cargoOrdersDuplicates: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrders)
            });

            var cargoRequests = [];

            this.createTerms(cargoOrders);

            cargoOrders.forEach(function (cargoOrder, keyCargoOrder) {
                _this5.createCargoRequest(cargoOrder, keyCargoOrder, cargoRequests);
            });

            var _loop = function _loop(cargoRequestIndex) {
                var cargoRequest = cargoRequests[cargoRequestIndex];

                setTimeout(function () {
                    _this5._prepareAndOrSendSingleRequest(cargoRequest, cargoRequestIndex);
                    _this5.setState({ sendStatusPending: false });
                }, 1000);
            };

            for (var cargoRequestIndex = 0; cargoRequestIndex < cargoRequests.length; cargoRequestIndex++) {
                _loop(cargoRequestIndex);
            }
        }

        /**
         * @param {*} cargoRequest
         * @param {*} cargoRequestIndex
         * @param {boolean} [shouldReturnPrepared]
         * @param {import('../../../Letters/common/FailedToSent').FailedTwin} [opts]
         */

    }, {
        key: '_prepareAndOrSendSingleRequest',
        value: function _prepareAndOrSendSingleRequest(cargoRequest, cargoRequestIndex) {
            var _this6 = this;

            var shouldReturnPrepared = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var opts = arguments[3];

            cargoRequest.loading = [];
            cargoRequest.unloading = [];

            Object(__WEBPACK_IMPORTED_MODULE_19_helpers_cargoUtils__["a" /* portsTree */])(cargoRequest.loadingPortsMap, cargoRequest.loading);
            Object(__WEBPACK_IMPORTED_MODULE_19_helpers_cargoUtils__["a" /* portsTree */])(cargoRequest.unloadingPortsMap, cargoRequest.unloading);

            if (cargoRequest.loading[0] && cargoRequest.loading[0].oneOf[0]) {
                cargoRequest.loadingPort = cargoRequest.loading[0].oneOf[0].port;
            }

            if (cargoRequest.unloading[0] && cargoRequest.unloading[0].oneOf[0]) {
                cargoRequest.unloadingPort = cargoRequest.unloading[0].oneOf[0].port;
            }

            if (this.state.clientCargo) {
                cargoRequest.realUserEmail = cargoRequest.user;
                cargoRequest.user = this.state.clientCargo;
                cargoRequest.requestKind = 'broker';
            } else {
                cargoRequest.requestKind = 'public';
            }

            var error = false;

            if (!cargoRequest.cargoType && cargoRequest.cargo[0]) {
                error = true;

                this.props.addNotification({
                    title: 'Error',
                    message: 'Error in request #' + (cargoRequestIndex + 1) + ': main cargo type or cargo in request is not set',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 50
                });
            }

            cargoRequest.cargo.forEach(function (cargo, index) {
                if (cargo.packing.category !== 'container' && !parseInt(cargo.packing.pack.unitsWeight.value, 10) && !parseInt(cargo.packing.pack.unitsVolume.value, 10)) {
                    error = true;
                    _this6.props.addNotification({
                        title: 'Error',
                        message: 'Error in request #' + (cargoRequestIndex + 1) + ', cargo #' + (index + 1) + ': weight OR volume must be specified',
                        level: 'error',
                        _id: Math.random(),
                        autoDismiss: 50
                    });
                }

                if (cargo.packing.category === 'container' && (!cargo.containerDetails.kind || !cargo.packing.pack.bundlesQuantity)) {
                    error = true;
                    _this6.props.addNotification({
                        title: 'Error',
                        message: 'Error in request #' + (cargoRequestIndex + 1) + ', cargo #' + (index + 1) + ': container kind and quantity are required.',
                        level: 'error',
                        _id: Math.random(),
                        autoDismiss: 50
                    });
                }

                if (!cargo.dangerous.unNumber) {
                    cargo.dangerous.unNumber = undefined;
                }

                if (!cargo.dangerous.class[0]) {
                    cargo.dangerous.class = [];
                }

                var sf = cargo.packing.pack.sf;

                if (sf) {
                    if (!parseInt(cargo.packing.pack.unitsVolume.value, 10)) {
                        cargo.packing.pack.unitsVolume.valueCalculated = Math.ceil(cargo.packing.pack.unitsWeight.value * parseFloat(sf));
                        cargo.packing.pack.unitsVolume.value = 0;
                        cargo.packing.pack.unitsVolume.isCalc = true;
                    } else {
                        cargo.packing.pack.unitsVolume.valueCalculated = parseInt(cargo.packing.pack.unitsVolume.value, 10);
                        cargo.packing.pack.unitsVolume.isCalc = false;
                    }

                    if (!parseInt(cargo.packing.pack.unitsWeight.value, 10)) {
                        cargo.packing.pack.unitsWeight.valueCalculated = Math.ceil(cargo.packing.pack.unitsVolume.value / parseFloat(sf));
                        cargo.packing.pack.unitsWeight.value = 0;
                        cargo.packing.pack.unitsWeight.isCalc = true;
                    } else {
                        cargo.packing.pack.unitsWeight.valueCalculated = parseInt(cargo.packing.pack.unitsWeight.value, 10);
                        cargo.packing.pack.unitsWeight.isCalc = false;
                    }
                }

                if (!cargo.packing.pack.unitsWeight.value && !cargo.packing.pack.unitsWeight.valueCalculated) {
                    cargo.packing.pack.unitsWeight = undefined;
                }

                if (!cargo.packing.pack.unitsVolume.value && !cargo.packing.pack.unitsVolume.valueCalculated) {
                    cargo.packing.pack.unitsVolume = undefined;
                }

                if (!cargo.packing.pack.unitsQuantity) {
                    delete cargo.packing.pack.unitsQuantity;
                }

                if (!cargo.hsCodeId._id) {
                    cargo.hsCodeId = undefined;
                } else {
                    cargo.hsCodeId = cargo.hsCodeId._id;
                }

                if (!cargo.packing.pack.bundlesQuantity) {
                    cargo.packing.pack.bundlesQuantity = undefined;
                }

                if (cargo.typeOfTransportation === 'container') {
                    if (cargo.packing.pack.unitWeight && !cargo.packing.pack.bundleWeight) {
                        cargo.packing.pack.bundleWeight = cargo.packing.pack.unitWeight;
                    }
                }

                ['containerDetails'].forEach(function (field) {
                    if (!Object.values(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(cargo[field], ['owner'])).filter(function (i) {
                        return i;
                    }).length) {
                        cargo[field] = undefined;
                    }
                });

                ['bundleBeam', 'bundleHeight', 'unitLength', 'netWeight', 'unitWeight', 'maxUnitLength', 'maxUnitWidth', 'unitBeam', 'unitDiam', 'unitHeight', 'unitVolume', 'bundleLength', 'unitsVolume', 'unitsWeight', 'bundleWeight'].forEach(function (field) {
                    if (!Object.values(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omit(cargo.packing.pack[field], ['unit'])).filter(function (i) {
                        return i;
                    }).length) {
                        cargo.packing.pack[field] = undefined;
                    }
                });

                if (cargo.packing.pack.densities.length === 1 && !Object.values(cargo.packing.pack.densities[0]).filter(function (i) {
                    return i;
                }).length) {
                    cargo.packing.pack.densities = undefined;
                }

                if (cargo.packing.category === 'unpacked' && cargo.details === 10 && cargo.packing.pack.unitBeam && cargo.packing.pack.unitBeam.value) {
                    cargo.packing.pack.maxUnitWidth = cargo.packing.pack.unitBeam;
                }

                cargo.packingList.forEach(function (item, Iindex) {
                    if (!item.name && (item.weight || item.volume || item.quantity || item.width && item.height && item.length)) {
                        error = true;

                        _this6.props.addNotification({
                            title: 'Error',
                            message: 'Error in request #' + (cargoRequestIndex + 1) + ', packing list item #' + (Iindex + 1) + ': name not specified',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 50
                        });
                    }
                });

                cargo.packingList = cargo.packingList.filter(function (item) {
                    return item.name && (item.weight || item.volume || item.quantity || item.width && item.height && item.length);
                });

                if (cargo.containerDetails && cargo.containerDetails.kind) {
                    cargo.cargoId = cargo.containerDetails.kind;
                }
            });

            var nonEmptyLDLoad = Object.values(cargoRequest.ldRates.loading).filter(function (l) {
                return l;
            });
            var nonEmptyLDDisch = Object.values(cargoRequest.ldRates.discharging).filter(function (l) {
                return l;
            });

            if (!nonEmptyLDLoad.length) {
                cargoRequest.ldRates.loading = {
                    type: ''
                };
            } else {
                cargoRequest.ldRates.loading = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(cargoRequest.ldRates.loading, function (i) {
                    return i;
                });
            }

            if (!nonEmptyLDDisch.length) {
                cargoRequest.ldRates.discharging = {
                    type: ''
                };
            } else {
                cargoRequest.ldRates.discharging = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pickBy(cargoRequest.ldRates.discharging, function (i) {
                    return i;
                });
            }

            ['incoterms'].forEach(function (field) {
                if (!Object.values(cargoRequest[field]).filter(function (i) {
                    return i;
                }).length) {
                    cargoRequest[field] = undefined;
                }
            });

            Object(__WEBPACK_IMPORTED_MODULE_40__Sidebar_Order_VesselRequirements__["c" /* fixVesselRequirementsData */])(cargoRequest.vesselRequirements);

            if (!error) {
                var req = _extends({}, cargoRequest, {
                    mailId: this.props.letter._id,
                    eh: this.props.letter.eh,
                    clientCargo: this.state.clientCargo
                });

                if (opts) {
                    req.mailId = opts._id;
                    req.eh = opts.context.kind;
                    req.requestKind = opts.context.kind;
                    req.clientCargo = opts.owner.email;
                    req.user = opts.owner.email;
                    req.realUserEmail = opts.realUserEmail;
                }

                if (shouldReturnPrepared) {
                    return req;
                }

                this.props.postRequestCargo(req);
            }
        }
    }, {
        key: 'handleFillRequest',
        value: function handleFillRequest(data) {
            this.setState({
                packingListSelection: data
            });
        }
    }, {
        key: 'updatePostGazetters',
        value: function updatePostGazetters(textLetter) {
            var _this7 = this;

            this.setState({
                textLetter: textLetter,
                gazetters: [],
                filteredGazetters: [],
                annotations: [],
                updated: true
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this7.props.postGazetters(textLetter, {
                                    emailId: _this7.props.letter._id,
                                    subject: _this7.props.letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(_this7.props.letter.date).format('DD-MM-YYYY')
                                });

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this7);
            })));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.removeGazetters();
            this.props.removeAnnotations();
            this.props.removeLetter();
        }
    }, {
        key: 'handleClientChange',
        value: function handleClientChange(e, i, value) {
            this.setState({ clientCargo: value });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(JSON.stringify(nextProps.cargoOrders), JSON.stringify(this.state.cargoOrdersDuplicates))) {
                this.setState({ isFormChanged: true });
            } else {
                this.setState({ isFormChanged: false });
            }
        }

        /**
         * @param {import('../../../Letters/common/FailedToSent').FailedTwin} failedTwinLetterData
         */

    }, {
        key: 'sendRequestCargoFromSent',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(failedTwinLetterData) {
                var _this8 = this;

                var cargoOrders, hasErrors, cargoRequests, results, cargoRequestIndex, _cargoRequest, req, response;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                cargoOrders = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrders);
                                hasErrors = false;


                                cargoOrders.forEach(function (cargoOrder, cIndex) {
                                    // like that because user error is seperate from main cargo object
                                    cargoOrder.validateErrors = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omitBy(cargoOrder.validateErrors, function (i) {
                                        i.field === 'user';
                                    });

                                    if (cargoOrder.validateErrors.length) {
                                        cargoOrder.validateErrors.forEach(function (error) {
                                            _this8.props.addNotification({
                                                title: 'Error',
                                                message: 'Error in request #' + (cIndex + 1) + '. Field ' + error.field + ' --- ' + (error.message || error.messages[0]),
                                                level: 'error',
                                                _id: Math.random(),
                                                autoDismiss: 100
                                            });
                                        });

                                        hasErrors = true;
                                    }
                                });

                                if (!hasErrors) {
                                    _context5.next = 5;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 5:
                                if (cargoOrders.length) {
                                    _context5.next = 7;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 7:
                                cargoRequests = [];
                                results = [];


                                this.createTerms(cargoOrders);

                                cargoOrders.forEach(function (cargoOrder, keyCargoOrder) {
                                    _this8.createCargoRequest(cargoOrder, keyCargoOrder, cargoRequests);
                                });

                                cargoRequestIndex = 0;

                            case 12:
                                if (!(cargoRequestIndex < cargoRequests.length)) {
                                    _context5.next = 31;
                                    break;
                                }

                                _cargoRequest = cargoRequests[cargoRequestIndex];


                                if (failedTwinLetterData.context.kind === 'broker') {
                                    _cargoRequest.realUserEmail = failedTwinLetterData.realUserEmail;
                                    _cargoRequest.user = failedTwinLetterData.context.mailGateEmail;
                                    _cargoRequest.mailId = failedTwinLetterData._id;
                                }

                                req = this._prepareAndOrSendSingleRequest(_cargoRequest, cargoRequestIndex, true, failedTwinLetterData);
                                _context5.next = 18;
                                return __WEBPACK_IMPORTED_MODULE_38_services__["a" /* default */].postRequestCargo(req);

                            case 18:
                                response = _context5.sent;

                                if (!(response.status === 200)) {
                                    _context5.next = 25;
                                    break;
                                }

                                results.push(_extends({}, response.data, {
                                    status: 'success'
                                }));
                                _context5.next = 23;
                                return __WEBPACK_IMPORTED_MODULE_38_services__["a" /* default */].sendRefNumber(failedTwinLetterData._id, {
                                    refNo: response.data.refNo,
                                    requestId: response.data.id || response.data._id
                                });

                            case 23:
                                _context5.next = 26;
                                break;

                            case 25:
                                results.push({
                                    status: 'error',
                                    message: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(response, 'errors[0].message') || __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(response, 'errors[0].messages[0]')
                                });

                            case 26:
                                _context5.next = 28;
                                return __WEBPACK_IMPORTED_MODULE_39__helpers__["a" /* default */].sleep(1000);

                            case 28:
                                cargoRequestIndex++;
                                _context5.next = 12;
                                break;

                            case 31:
                                return _context5.abrupt('return', results);

                            case 32:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function sendRequestCargoFromSent(_x4) {
                return _ref6.apply(this, arguments);
            }

            return sendRequestCargoFromSent;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _this9 = this;

            var _state = this.state,
                annotationsServer = _state.annotationsServer,
                clarifiedServer = _state.clarifiedServer,
                textLetter = _state.textLetter,
                updated = _state.updated,
                clientCargo = _state.clientCargo,
                openedAttachmentsDialog = _state.openedAttachmentsDialog,
                isSimpleForm = _state.isSimpleForm,
                sendStatusPending = _state.sendStatusPending,
                failedToSentOpen = _state.failedToSentOpen;
            var _props = this.props,
                letter = _props.letter,
                routeParams = _props.routeParams,
                router = _props.router,
                cargoOrders = _props.cargoOrders,
                objUser = _props.objUser,
                user = _props.user,
                location = _props.location;


            var modifiedTextLetter = void 0;
            var initialTextLetter = void 0;

            if (location.state) {
                modifiedTextLetter = location.state.modifiedTextLetter;
                initialTextLetter = location.state.initialTextLetter;
            }

            var hasTcOrder = letter && letter.clarified && letter.clarified.find(function (c) {
                return c.typeCategory && c.typeCategory.includes('tc');
            });

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { id: 'single-letter-cargo', className: 'single-letter' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'content', style: { width: '60vw' } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'management' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'management-children' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Gazetteer',
                                containerElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id }),
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_17__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HtmlContent__["a" /* default */], { letter: letter })
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Content_TextEditor__["a" /* default */], {
                                textLetter: modifiedTextLetter || textLetter || letter.text,
                                originalText: initialTextLetter || letter.text,
                                removeGazetters: this.props.removeGazetters,
                                removeAnnotations: this.props.removeAnnotations,
                                getLetterData: this.getLetterData,
                                updatePostGazetters: this.updatePostGazetters
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_components_Letters_Single_Attachments__["a" /* default */], {
                                openedAttachmentsDialog: openedAttachmentsDialog,
                                toggleAttachmentsDialog: this.toggleAttachmentsDialog,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                className: 'btn',
                                attachments: letter.attachments
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_material_ui_SelectField___default.a,
                                {
                                    floatingLabelText: 'Annotations server',
                                    className: 'btn',
                                    style: { width: '155px' },
                                    value: annotationsServer,
                                    onChange: this.changeAnnotationsServer,
                                    selected: true
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 'mailparse.net', primaryText: 'mailparse.net' }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 's4.anotatr.com', primaryText: 's4.anotatr.com' }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 'nata.im', primaryText: 'nata.im' }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 'polza', primaryText: 'polza' }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 'localhost', primaryText: 'localhost' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_material_ui_SelectField___default.a,
                                {
                                    floatingLabelText: 'Clarified server',
                                    className: 'btn',
                                    style: { width: '110px' },
                                    value: clarifiedServer,
                                    onChange: this.changeClarifiedServer,
                                    selected: true,
                                    autoWidth: true
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 'standart', primaryText: 'api' }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 'localhost:7775', primaryText: 'localhost' }),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_MenuItem___default.a, { value: 's4.anotatr.com:7777', primaryText: 's4.anotatr.com' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_material_ui__["b" /* Checkbox */], {
                                style: {
                                    display: 'inline-block',
                                    width: 'auto',
                                    verticalAlign: 'middle',
                                    margin: '30px 10px 0 0',
                                    fontSize: '14px'
                                },
                                iconStyle: { marginRight: '7px' },
                                label: 'simple',
                                checked: isSimpleForm,
                                onCheck: function onCheck() {
                                    _this9.setState({ isSimpleForm: !isSimpleForm });
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__common_ToSpamButton__["a" /* default */], {
                                letterId: letter._id,
                                onSuccess: function onSuccess() {
                                    _this9.getLetterData();
                                },
                                disabled: letter.type === 'spam'
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__common_FailedToSent__["b" /* default */], {
                                open: failedToSentOpen,
                                failedTwinsList: letter.failedTwinsByTextHash || [],
                                handleToggleDialog: this.toggleFailedToSentOpen,
                                disabled: this.state.isFormChanged,
                                sendRequest: this.sendRequestCargoFromSent
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { style: { width: '150px' }, className: 'subject' },
                            'SUBJECT: ',
                            letter.subject,
                            ' '
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'subject', style: { width: '70px' } },
                            'refNo: ',
                            letter.refNo,
                            ' '
                        )
                    ),
                    updated ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Content_AnnotationsEditor__["a" /* default */], { letterText: textLetter || letter.text })
                    ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Content_AnnotationsEditor__["a" /* default */], { letterText: modifiedTextLetter || letter.text })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Content_AnnotationsList__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'sidebar', style: { width: '40vw' } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'h1',
                        null,
                        'Cargo requests ',
                        cargoOrders.length,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { style: { color: 'red' } },
                            hasTcOrder && ' Has TC requests'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__ErrorBoundary__["a" /* default */],
                        null,
                        cargoOrders.map(function (cargoOrder, i) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Sidebar_OrderTable__["a" /* default */], {
                                captureSaveHandler: function captureSaveHandler(fn) {
                                    _this9.saveHandlers[i] = fn;
                                },
                                numberOrderTable: i,
                                key: i
                            });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_17__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Base_UserSelector__["a" /* default */], {
                            handleClientChange: this.handleClientChange,
                            client: clientCargo,
                            user: user,
                            letter: letter,
                            errorUser: cargoOrders[0] && cargoOrders[0].validateErrors.find(function (v) {
                                return v.field === 'user';
                            }),
                            onUserUpdate: this.onUserUpdate
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'ul',
                        { className: 'controller-orders', style: { width: '40vw' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_18_styles__["a" /* default */].btnNewOrders, onClick: this.addOrderTable, label: 'Add' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_18_styles__["a" /* default */].btnNewOrders, onClick: this.removeOrderTable, label: 'Remove' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_18_styles__["a" /* default */].btnNewOrders, onClick: this.clearOrderTable, label: 'Clear' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default.a, {
                                style: __WEBPACK_IMPORTED_MODULE_18_styles__["a" /* default */].btnNewOrders,
                                onClick: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(this.sendRequestCargo, 500),
                                label: 'Send',
                                disabled: sendStatusPending
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LetterCargo;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref7) {
    var objUser = _ref7.user,
        _ref7$cargoOrders = _ref7.cargoOrders,
        user = _ref7$cargoOrders.user,
        cargoOrders = _ref7$cargoOrders.items,
        isLogged = _ref7.user.isLogged,
        letter = _ref7.letter,
        annotations = _ref7.annotations.items;
    return {
        objUser: objUser,
        user: user,
        cargoOrders: cargoOrders,
        isLogged: isLogged,
        letter: letter,
        annotations: annotations
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        updateCargoOrderUser: __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_orders__["g" /* updateCargoOrderUser */],
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_orders__["f" /* updateCargoOrder */],
        postAnnotations: __WEBPACK_IMPORTED_MODULE_32_actions_annotations__["a" /* postAnnotations */],
        postGazetters: __WEBPACK_IMPORTED_MODULE_33_actions_gazetters__["a" /* postGazetters */],
        getCargoTypes: __WEBPACK_IMPORTED_MODULE_25_actions_cargoes_types__["a" /* getCargoTypes */],
        getTermEntities: __WEBPACK_IMPORTED_MODULE_27_actions_termEntities__["a" /* getTermEntities */],
        addCargoOrder: __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_orders__["a" /* addCargoOrder */],
        postRequestCargo: __WEBPACK_IMPORTED_MODULE_28_actions_cargoes_requests__["c" /* postRequestCargo */],
        getContracts: __WEBPACK_IMPORTED_MODULE_29_actions_contracts__["a" /* getContracts */],
        removeLastCargoOrder: __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_orders__["d" /* removeLastCargoOrder */],
        getCargoAssigners: __WEBPACK_IMPORTED_MODULE_30_actions_cargoes_assigners__["a" /* getCargoAssigners */],
        removeGazetters: __WEBPACK_IMPORTED_MODULE_33_actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_32_actions_annotations__["b" /* removeAnnotations */],
        removeLetter: __WEBPACK_IMPORTED_MODULE_31_actions_letters__["a" /* removeLetter */],
        addNotification: __WEBPACK_IMPORTED_MODULE_34_actions_notifications_notifications__["a" /* addNotification */],
        getCargoesByTypeName: __WEBPACK_IMPORTED_MODULE_26_actions_cargoes_names__["a" /* getCargoesByTypeName */]
    }, dispatch);
})(LetterCargo);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LetterCargo, 'LetterCargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/LetterCargo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/LetterCargo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Order_Name__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Order_Terms__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Order_Type__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Order_CommisionAncContracts__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Order_CargoBlock__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Order_TotalValuesVolWei__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Order_AccountName__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_RequestTitle__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Order_VesselRequirements__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_cargoes_orders__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var OrderTable = function (_React$PureComponent) {
    _inherits(OrderTable, _React$PureComponent);

    function OrderTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, OrderTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderTable.__proto__ || Object.getPrototypeOf(OrderTable)).call.apply(_ref, [this].concat(args))), _this), _this.update = function (data) {
            _this.props.updateCargoOrder(_this.props.numberOrderTable, _extends({}, _this.props.cargoOrder, data));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(OrderTable, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'sidebar-table' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_RequestTitle__["a" /* default */], {
                    orderNumber: this.props.numberOrderTable + 1,
                    text: 'CARGO REQUEST NUMBER',
                    warnings: this.props.cargoOrder.warnings
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Order_Name__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Order_Type__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Order_TotalValuesVolWei__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Order_AccountName__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Order_CargoBlock__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Order_CommisionAncContracts__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Order_VesselRequirements__["b" /* VesselRequirements */], {
                    captureSaveHandler: function captureSaveHandler(fn) {
                        _this2.props.captureSaveHandler(function (cargoOrder) {
                            fn(cargoOrder.vesselRequirements);
                        });
                    },
                    initialState: this.props.cargoOrder.vesselRequirements,
                    onChange: this.update
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Order_Terms__["a" /* default */], { numberOrderTable: this.props.numberOrderTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return OrderTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: cargoOrder
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_12_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(OrderTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(OrderTable, 'OrderTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/OrderTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/OrderTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Name = function (_React$Component) {
    _inherits(Name, _React$Component);

    function Name(props) {
        _classCallCheck(this, Name);

        var _this = _possibleConstructorReturn(this, (Name.__proto__ || Object.getPrototypeOf(Name)).call(this, props));

        _this.onChooseAutoCompleteCargoName = function (updateProperties) {
            if (!updateProperties) {
                return;
            }

            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.cargoOrder);

            newCargoOrder.cargoName = updateProperties.name;
            newCargoOrder.cargoId = updateProperties._id;
            newCargoOrder.cargoType = updateProperties.item.parent.red._id;
            newCargoOrder.cargoTypeName = updateProperties.item.parent.red.name;
            newCargoOrder.details = updateProperties.details;
            newCargoOrder.filterCategory = updateProperties.item.parent.red.name;

            _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);

            _this.setState({
                cargoNames: []
            });
        };

        _this.state = {
            cargoNames: [],
            cargoName: props.cargoOrder.cargoName,
            isShowDialog: false,
            names: []
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (searchText) {
            __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].getCargoNamesAutocomplete(searchText).then(function (response) {
                var cargoNames = response.data.data.map(function (cargoName) {
                    return {
                        name: cargoName.name,
                        item: cargoName,
                        details: cargoName.details
                    };
                });

                _this.setState({
                    cargoNames: cargoNames
                });
            }).then(function () {
                var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.cargoOrder);
                newCargoOrder.cargoName = searchText;
                _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);
            }).catch(function () {
                return null;
            });
        }, 1000);

        _this.onChangeAutoCompleteCargoName = _this.onChangeAutoCompleteCargoName.bind(_this);
        _this.onChooseAutoCompleteCargoName = _this.onChooseAutoCompleteCargoName.bind(_this);
        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.changeSearch = _this.changeSearch.bind(_this);
        _this.chooseCargoName = _this.chooseCargoName.bind(_this);
        return _this;
    }

    _createClass(Name, [{
        key: 'chooseCargoName',
        value: function chooseCargoName(cargo) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);

            newCargoOrder.cargoName = cargo.realCargoName;
            newCargoOrder.cargoType = cargo.CargoCategory;
            newCargoOrder.cargoTypeName = cargo.CargoCategoryName;

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

            this.setState({
                isShowDialog: !this.state.isShowDialog
            });
        }
    }, {
        key: 'searchInPopup',
        value: function searchInPopup(value) {
            return this.props.cargoAssigners.filter(function (cargoAssigner) {
                if (cargoAssigner.value && cargoAssigner.value.toLowerCase().includes(value.toLowerCase())) {
                    return true;
                }

                if (cargoAssigner.realCargoName && cargoAssigner.realCargoName.toLowerCase().includes(value.toLowerCase())) {
                    return true;
                }

                return false;
            });
        }
    }, {
        key: 'changeSearch',
        value: function changeSearch(e, value) {
            var names = this.searchInPopup(value);

            this.setState({
                names: names,
                cargoName: value
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            this.setState({
                cargoName: props.cargoOrder.cargoName
            });
        }
    }, {
        key: 'onChangeAutoCompleteCargoName',
        value: function onChangeAutoCompleteCargoName(searchText) {
            var _this2 = this;

            this.setState({
                cargoName: searchText
            }, function () {
                _this2.dAutocomplete(searchText);
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            var cargoName = this.state.cargoName;

            if (!cargoName) {
                this.props.addNotification({
                    title: 'Error',
                    message: 'Cargo name should be specified',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 2
                });
            } else {
                var names = this.searchInPopup(cargoName);

                this.setState({
                    isShowDialog: !this.state.isShowDialog,
                    names: names
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var errorCargoName = this.props.errorCargoName ? this.props.errorCargoName.messages[0] : '';
            var actions = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: this.toggleDialog
            })];

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog___default.a,
                    {
                        className: 'find-similar-popup',
                        title: 'Find similar (max 10)',
                        actions: actions,
                        open: this.state.isShowDialog,
                        onRequestClose: this.toggleDialog
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'search-block' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_TextField___default.a, {
                            floatingLabelText: 'Search cargo names',
                            onChange: this.changeSearch,
                            value: this.state.cargoName
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'result-header' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'result-line' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                'Cargo real name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                'Cargo name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'button' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'result-body' },
                        this.state.names.map(function (cargoAssigner, i) {
                            if (i < 30) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { key: cargoAssigner.value + '_' + i, className: 'result-line' },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'name' },
                                        cargoAssigner.realCargoName
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'name' },
                                        cargoAssigner.value
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'button' },
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                            labelStyle: { fontSize: '10px' },
                                            style: { height: '25px' },
                                            buttonStyle: { height: '25px', lineHeight: '25px' },
                                            label: 'Choose',
                                            primary: true,
                                            onClick: function onClick() {
                                                _this3.chooseCargoName(cargoAssigner);
                                            }
                                        })
                                    )
                                );
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'column-left' },
                    'Cargo name:'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'column-right' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                        name: 'cargoName',
                        textFieldStyle: { fontSize: '13px' },
                        hintText: 'Cargo name',
                        errorText: errorCargoName,
                        searchText: this.state.cargoName || '',
                        dataSource: this.state.cargoNames,
                        dataSourceConfig: { text: 'name', value: 'item' },
                        onUpdateInput: this.onChangeAutoCompleteCargoName,
                        onNewRequest: this.onChooseAutoCompleteCargoName,
                        filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                        menuStyle: { width: 'auto' },
                        popoverProps: {
                            canAutoPosition: true
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        labelStyle: { fontSize: '10px' },
                        style: { height: '25px' },
                        buttonStyle: { height: '25px', lineHeight: '25px' },
                        label: 'Find in names',
                        primary: true,
                        onClick: this.toggleDialog
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Name;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var errorCargoName = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors.find(function (validateError) {
        return validateError.field === 'cargo.0.cargoName';
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        errorCargoName: errorCargoName,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
        cargoAssigners: state.cargoAssigners.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_orders__["f" /* updateCargoOrder */],
        addNotification: __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(Name);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Name, 'Name', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Name.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Name.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_cargoes_orders__ = __webpack_require__(51);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var typeTerms = ['POL dets:', 'POD dets:', 'POL/POD dets:', 'Laycan dets:', 'Load dets:', 'Disch dets:', 'L/D dets:', 'Comm dets:', 'Freight dets:', 'Vessel dets:', 'Packing dets:', 'Additional dets:', 'Cargo dets:'];

var Terms = function (_React$Component) {
    _inherits(Terms, _React$Component);

    function Terms(props) {
        _classCallCheck(this, Terms);

        var _this = _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).call(this, props));

        _this.state = {
            errors: []
        };

        _this.onChangeTerm = _this.onChangeTerm.bind(_this);
        _this.addNewTerm = _this.addNewTerm.bind(_this);
        _this.removeTerm = _this.removeTerm.bind(_this);
        _this.showError = _this.showError.bind(_this);
        _this.onChangeTypeTerm = _this.onChangeTypeTerm.bind(_this);
        return _this;
    }

    _createClass(Terms, [{
        key: 'removeTerm',
        value: function removeTerm(number) {
            this.deleteError(number);
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.terms.user.splice(number, 1);
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'addNewTerm',
        value: function addNewTerm() {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.terms.user.push({ type: '', value: '' });
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeTypeTerm',
        value: function onChangeTypeTerm(key, numberElement) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.terms.user[numberElement].type = typeTerms[key];
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeTerm',
        value: function onChangeTerm(value, numberElement) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.terms.user[numberElement].value = value;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'deleteError',
        value: function deleteError(key) {
            var errors = this.state.errors.filter(function (error) {
                return error.key !== key;
            });

            this.setState({
                errors: errors
            });
        }
    }, {
        key: 'showError',
        value: function showError(key) {
            var errorObject = this.state.errors.find(function (error) {
                return error.key === key;
            });

            return errorObject ? errorObject.text : '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Terms:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new term',
                            onClick: this.addNewTerm,
                            primary: true
                        })
                    )
                ),
                this.props.cargoOrder.terms.user.map(function (term, key) {
                    var errorMessage = _this2.showError(key);
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { key: key, className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            'Term ' + key
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'column-right' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                                {
                                    style: {
                                        padding: '0 5px',
                                        width: '80%',
                                        fontSize: '13px'
                                    },
                                    defaultValue: term.type,
                                    value: term.type,
                                    onChange: function onChange(e, numberSelected) {
                                        _this2.onChangeTypeTerm(numberSelected, key);
                                    },
                                    maxHeight: 200,
                                    autoWidth: true
                                },
                                typeTerms.map(function (typeTerm, i) {
                                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, {
                                        key: i,
                                        style: { width: 'auto', fontSize: '13px' },
                                        value: typeTerm,
                                        primaryText: typeTerm
                                    });
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                style: { fontSize: '13px' },
                                value: term.value,
                                hintText: 'Term ' + key,
                                errorText: errorMessage,
                                onChange: function onChange(e) {
                                    return _this2.onChangeTerm(e.target.value, key);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Remove term',
                                onClick: function onClick() {
                                    return _this2.removeTerm(key);
                                },
                                secondary: true
                            })
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Terms;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {

    return {
        numberOrderTable: ownProps.numberOrderTable,
        validateErrors: state.cargoOrders.items[ownProps.numberOrderTable].validateErrors,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_8_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Terms);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(typeTerms, 'typeTerms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Terms.jsx');
    reactHotLoader.register(Terms, 'Terms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Terms.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Terms.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__ = __webpack_require__(51);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Type = function (_React$Component) {
    _inherits(Type, _React$Component);

    function Type(props) {
        _classCallCheck(this, Type);

        var _this = _possibleConstructorReturn(this, (Type.__proto__ || Object.getPrototypeOf(Type)).call(this, props));

        _this.state = {
            cargoTypes: props.cargoTypes
        };

        _this.selectDetails = _this.selectDetails.bind(_this);
        _this.onChangeAutoComplete = _this.onChangeAutoComplete.bind(_this);
        _this.onChooseAutoComplete = _this.onChooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(Type, [{
        key: 'selectDetails',
        value: function selectDetails(value) {
            var newCargoOrder = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.cargoOrder);
            newCargoOrder.details = +value;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeAutoComplete',
        value: function onChangeAutoComplete(searchText) {
            var cargoTypes = this.props.cargoTypes;


            cargoTypes = cargoTypes.filter(function (cargoName) {
                if (cargoName.name.toLowerCase().includes(searchText.toLowerCase())) {
                    return {
                        name: cargoName.name,
                        item: cargoName
                    };
                }
                return false;
            });

            this.setState({
                cargoTypes: cargoTypes
            });

            var newCargoOrder = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.cargoOrder);
            newCargoOrder.cargoTypeName = searchText;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChooseAutoComplete',
        value: function onChooseAutoComplete(updateProperties) {
            if (!updateProperties) {
                return;
            }

            var newCargoOrder = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.cargoOrder);
            newCargoOrder.cargoType = updateProperties.item._id;
            newCargoOrder.cargoTypeName = updateProperties.name;
            newCargoOrder.details = updateProperties.item.details;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

            this.setState({
                searchTextCargoType: updateProperties.name
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var errorType = this.props.errorType ? this.props.errorType.messages[0] : '';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Type:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            'Cargo type id - ',
                            this.props.cargoOrder.cargoType ? this.props.cargoOrder.cargoType : 'empty'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            'Details - ',
                            this.props.cargoOrder.details
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                            textFieldStyle: { fontSize: '13px' },
                            hintText: 'Cargo type',
                            searchText: this.props.cargoOrder.cargoTypeName || '',
                            dataSource: this.state.cargoTypes,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: this.onChangeAutoComplete,
                            onNewRequest: this.onChooseAutoComplete,
                            errorText: errorType,
                            filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true
                            }
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Type;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoTypes = state.cargoTypes.map(function (cargoType) {
        return {
            name: cargoType.name,
            item: cargoType
        };
    });

    cargoTypes.push({
        name: 'Other',
        item: {
            _id: '59970a4513d689b67b8bf20d'
        }
    });

    var errorType = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors.find(function (validateError) {
        return validateError.field === 'cargo.0.cargoType';
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoTypes: cargoTypes,
        errorType: errorType,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Type);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Type, 'Type', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Type.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Type.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var styles = {
    selectField: {
        padding: '0 5px',
        width: '256px',
        fontSize: '13px'
    },
    menuItem: {
        width: 'auto',
        fontSize: '13px'
    }
};

var CommisionAndContracts = function (_React$Component) {
    _inherits(CommisionAndContracts, _React$Component);

    function CommisionAndContracts(props) {
        _classCallCheck(this, CommisionAndContracts);

        var _this = _possibleConstructorReturn(this, (CommisionAndContracts.__proto__ || Object.getPrototypeOf(CommisionAndContracts)).call(this, props));

        _this.state = {
            value: _this.props.value
        };

        _this.selectContracts = _this.selectContracts.bind(_this);
        _this.onChangeCommision = _this.onChangeCommision.bind(_this);
        return _this;
    }

    _createClass(CommisionAndContracts, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            if (newProps.value !== this.props.value) {
                this.setState({
                    value: newProps.value
                });
            }
        }
    }, {
        key: 'onChangeCommision',
        value: function onChangeCommision(e) {
            var newCargoOrder = Object.assign({}, this.props.cargoOrder);

            var value = __WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* default */].clearLetters(e.target.value);

            newCargoOrder.comm = value || undefined;

            if (parseFloat(newCargoOrder.comm) !== 0 && !newCargoOrder.comm) {
                newCargoOrder.validateErrors.push({
                    field: 'comm',
                    messages: ['Commission is required']
                });
            } else {
                newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                    return obj.field !== 'comm';
                });
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'selectContracts',
        value: function selectContracts(value) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.props.cargoOrder);
            var contract = this.props.contracts.find(function (item) {
                return item.name === value;
            });

            newCargoOrder.contract = contract._id;

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

            this.setState({ value: contract.name });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var errorCommision = void 0;

            if (this.props.errorCommision) {
                if (this.props.errorCommision.message) {
                    errorCommision = this.props.errorCommision.message || '';
                } else if (this.props.errorCommision.messages) {
                    errorCommision = this.props.errorCommision.messages[0] || '';
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row half' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'column-left',
                        style: {
                            display: 'flex',
                            height: '92px'
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        {
                            style: {
                                display: 'block',
                                margin: '42px 0'
                            }
                        },
                        'Commission:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                        floatingLabelText: 'Commission',
                        errorText: errorCommision,
                        style: { fontSize: '13px', marginLeft: '10px' },
                        value: this.props.cargoOrder.comm || '',
                        hintText: 'Commission',
                        onChange: this.onChangeCommision,
                        name: 'comm'
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column-right half' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: '13px', margin: '40px 10px 0px 0px' } },
                        'Contract:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["s" /* SelectField */],
                        {
                            floatingLabelText: 'Contract',
                            style: styles.selectField,
                            value: this.state.value,
                            onChange: function onChange(_event, _index, value) {
                                _this2.selectContracts(value);
                            },
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.contracts.map(function (contract, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], {
                                key: key,
                                style: styles.menuItem,
                                value: contract.name,
                                primaryText: contract.name
                            });
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CommisionAndContracts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

    if (!cargoOrder.contract) {
        cargoOrder.contract = state.contracts && state.contracts.items.find(function (c) {
            return c.name === 'TBA';
        })._id;
    }

    var errorCommision = cargoOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'comm';
    });

    var value = state.contracts.items.find(function (contract) {
        return contract._id === cargoOrder.contract;
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: cargoOrder,
        errorCommision: errorCommision,
        contracts: state.contracts.items,
        value: value ? value.name : ''
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(CommisionAndContracts);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CommisionAncContracts.jsx');
    reactHotLoader.register(CommisionAndContracts, 'CommisionAndContracts', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CommisionAncContracts.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CommisionAncContracts.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeightVolume__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LDrates__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CargoName__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CargoType__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LUPorts_LUports__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PackingList__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dangerous__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HSIdsCodes_DetailsForCargo__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HSIdsCodes_CargoReferences__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HSIdsCodes_HSCode__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Transportation__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mocks_cargo_orderNew__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Incoterms__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Packing_Packing__ = __webpack_require__(1959);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var CargoBlock = function (_React$Component) {
    _inherits(CargoBlock, _React$Component);

    function CargoBlock(props) {
        _classCallCheck(this, CargoBlock);

        var _this = _possibleConstructorReturn(this, (CargoBlock.__proto__ || Object.getPrototypeOf(CargoBlock)).call(this, props));

        _this.addCargo = _this.addCargo.bind(_this);
        _this.removeCargo = _this.removeCargo.bind(_this);
        _this.changeCargo = _this.changeCargo.bind(_this);
        return _this;
    }

    _createClass(CargoBlock, [{
        key: 'addCargo',
        value: function addCargo() {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo.push(__WEBPACK_IMPORTED_MODULE_17_mocks_cargo_orderNew__["a" /* orderNew */].cargo[0]);
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'removeCargo',
        value: function removeCargo(cargoIndex) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo.splice(cargoIndex, 1);
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }

        /**
         * 
         * @param {[{ field: string, value: any, type: 'number' | 'array' }]} changes 
         */

    }, {
        key: 'changeCargo',
        value: function changeCargo(changes) {
            if (!Array.isArray(changes)) {
                changes = [changes];
            }

            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);

            changes.forEach(function (_ref) {
                var field = _ref.field,
                    value = _ref.value,
                    type = _ref.type;

                if (type === 'number' && value === '') {
                    value = undefined;
                }

                if (type === 'array') {
                    newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(newCargoOrder, field, [].concat(_toConsumableArray(newCargoOrder[field]), [value]));
                } else {
                    newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(newCargoOrder, field, value);
                }
            });

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var cargo = this.props.cargoOrder.cargo;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                cargo.map(function (cargoItem, cargoIndex) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: cargoIndex },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'one-forth' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'one-forth', style: { display: 'flex', justifyContent: 'center', fontSize: '13px' } },
                                'Cargo ',
                                cargoIndex + 1,
                                ':'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'one-forth' },
                                cargoIndex === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton___default.a, {
                                    labelStyle: { fontSize: '10px' },
                                    style: { height: '25px', margin: '0 5px 0 -10px' },
                                    buttonStyle: { height: '25px', lineHeight: '25px' },
                                    label: 'Add',
                                    primary: true,
                                    onClick: function onClick() {
                                        return _this2.addCargo();
                                    }
                                }),
                                cargoIndex !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_RaisedButton___default.a, {
                                    labelStyle: { fontSize: '10px' },
                                    style: { height: '25px' },
                                    buttonStyle: { height: '25px', lineHeight: '25px' },
                                    label: 'Remove',
                                    secondary: true,
                                    onClick: function onClick() {
                                        return _this2.removeCargo(cargoIndex);
                                    }
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CargoName__["a" /* default */], {
                            numberOrderTable: _this2.props.numberOrderTable,
                            cargoPackingIndex: cargoIndex
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CargoType__["a" /* default */], {
                            numberOrderTable: _this2.props.numberOrderTable,
                            cargoPackingIndex: cargoIndex
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__HSIdsCodes_CargoReferences__["a" /* default */], {
                            cargoIndex: cargoIndex,
                            changeCargo: _this2.changeCargo,
                            numberOrderTable: _this2.props.numberOrderTable
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HSIdsCodes_HSCode__["a" /* default */], {
                            cargoIndex: cargoIndex,
                            changeCargo: _this2.changeCargo,
                            numberOrderTable: _this2.props.numberOrderTable
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__HSIdsCodes_DetailsForCargo__["a" /* default */], {
                            cargoIndex: cargoIndex,
                            changeCargo: _this2.changeCargo,
                            numberOrderTable: _this2.props.numberOrderTable
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Transportation__["a" /* default */], {
                            cargoIndex: cargoIndex,
                            changeCargo: _this2.changeCargo,
                            cargoItem: cargoItem
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Incoterms__["a" /* default */], {
                            cargoIndex: cargoIndex,
                            changeCargo: _this2.changeCargo,
                            incoterms: _this2.props.cargoOrder.incoterms
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LUPorts_LUports__["a" /* default */], { numberOrderTable: _this2.props.numberOrderTable }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LDrates__["a" /* default */], { numberOrderTable: _this2.props.numberOrderTable }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__WeightVolume__["a" /* default */], {
                            numberOrderTable: _this2.props.numberOrderTable,
                            cargoPackingIndex: cargoIndex
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Dangerous__["a" /* default */], {
                            numberOrderTable: _this2.props.numberOrderTable,
                            cargoPackingIndex: cargoIndex
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PackingList__["a" /* default */], {
                            numberOrderTable: _this2.props.numberOrderTable,
                            cargoPackingIndex: cargoIndex
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Packing_Packing__["a" /* default */], {
                            numberOrderTable: _this2.props.numberOrderTable,
                            cargoPackingIndex: cargoIndex
                        })
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_12_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(CargoBlock);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoBlock, 'CargoBlock', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CargoBlock.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CargoBlock.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_weightVolume__ = __webpack_require__(1941);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var unitsWeight = ['mm', 'cm', 'm', 'feet', 'inch', 'lb', 'kg', 'mt'];
var unitsVolume = ['m3', 'cbm', 'cbf'];
var terms = ['molchopt', 'moloo', 'per unit', 'per meter'];

var WeightVolume = function (_React$Component) {
    _inherits(WeightVolume, _React$Component);

    function WeightVolume(props) {
        _classCallCheck(this, WeightVolume);

        var _this = _possibleConstructorReturn(this, (WeightVolume.__proto__ || Object.getPrototypeOf(WeightVolume)).call(this, props));

        _this.changeAdditionalPackingData = function (field, value) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.cargoOrder);
            var pack = newCargoOrder.cargo[_this.props.cargoPackingIndex].packing.pack;

            pack[field] = __WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* default */].clearLetters(value);

            var workingOn = [{ min: 'temperatureMin', max: 'temperatureMax' }, { min: 'moistureMin', max: 'moistureMax' }, { min: 'numberOfHeadsMin', max: 'numberOfHeadsMax' }].find(function (f) {
                return f.max === field;
            });

            if (workingOn) {
                if (pack[workingOn.min] && pack[workingOn.max]) {
                    if (+pack[workingOn.min] > +pack[workingOn.max]) {
                        newCargoOrder.validateErrors.push({
                            field: 'packing.pack.' + workingOn.max,
                            messages: ['Min is greater than max']
                        });
                    } else {
                        newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                            return obj.field !== 'packing.pack.' + workingOn.max;
                        });
                    }
                } else {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'packing.pack.' + workingOn.max;
                    });
                }
            }

            _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);
        };

        _this.changeClauses = function (_clause) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.cargoOrder);
            var clause = JSON.parse(_clause);

            _this.setState(_defineProperty({}, clause.name, clause.value));

            var index = newCargoOrder.cargo[_this.props.cargoPackingIndex].clauses.findIndex(function (c) {
                return c.name === clause.name;
            });

            if (index >= 0) {
                newCargoOrder.cargo[_this.props.cargoPackingIndex].clauses.splice(index, 1, clause);
            } else {
                newCargoOrder.cargo[_this.props.cargoPackingIndex].clauses.push(clause);
            }

            _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);
        };

        _this.state = {
            'Pipes not to be overstowed with other cargo': false,
            'Box shaped hold only': false,
            'Wooden dunnaging': false,
            'Pipes with flanges and not streight on ends': false
        };

        _this.onChangeWeight = _this.onChangeWeight.bind(_this);
        _this.changeWeightUnits = _this.changeWeightUnits.bind(_this);

        _this.onChangeVolume = _this.onChangeVolume.bind(_this);
        _this.changeVolumeUnits = _this.changeVolumeUnits.bind(_this);
        _this.onChangeDeviation = _this.onChangeDeviation.bind(_this);
        _this.changeTerm = _this.changeTerm.bind(_this);
        _this.changeDeviationSign = _this.changeDeviationSign.bind(_this);
        _this.onToggleFreeze = _this.onToggleFreeze.bind(_this);
        return _this;
    }

    _createClass(WeightVolume, [{
        key: 'changeTerm',
        value: function changeTerm(key, type) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[type][0].term = terms[key];
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeDeviation',
        value: function onChangeDeviation(e, type) {
            var value = __WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* default */].clearLetters(e.target.value);
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[type][0].deviation = value || undefined;

            var percentObj = type === 'unitsWeight' ? { name: 'weightWithPercent', multiplier: 1000 } : { name: 'volumeWithPercent', multiplier: 1 };

            if (newCargoOrder.totalValues.isCalc) {
                newCargoOrder.totalValues[percentObj.name] = newCargoOrder.cargo.reduce(function (acc, item) {
                    var units = item.packing.pack[type][0];
                    if (units.deviation && parseInt(units.value)) {
                        return acc + parseInt(parseInt(units.value) * (units.deviation / 100 + 1));
                    } else if (!units.deviation && parseInt(units.value)) {
                        return acc + parseInt(units.value);
                    }
                    return acc + 0;
                }, 0) * percentObj.multiplier;
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'changeDeviationSign',
        value: function changeDeviationSign(e, type, sign) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[type][0].deviationSign[sign] = e.target.innerText;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeWeight',
        value: function onChangeWeight(e, index) {
            var value = __WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* default */].clearLetters(e.target.value);
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[index].value = value || undefined;

            if (newCargoOrder.totalValues.isCalc && index === 0) {
                newCargoOrder.totalValues.weight = newCargoOrder.cargo.reduce(function (acc, item) {
                    return acc + parseInt(item.packing.pack.unitsWeight[0].value);
                }, 0) * 1000;

                newCargoOrder.totalValues.weightWithPercent = newCargoOrder.cargo.reduce(function (acc, item) {
                    var uw = item.packing.pack.unitsWeight[0];
                    if (uw.deviation && parseInt(uw.value)) {
                        return acc + parseInt(parseInt(uw.value) * (uw.deviation / 100 + 1));
                    } else if (!uw.deviation && parseInt(uw.value)) {
                        return acc + parseInt(uw.value);
                    }
                    return acc + 0;
                }, 0) * 1000;
            }

            if (+newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[0].value > +newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[1].value) {
                newCargoOrder.validateErrors.push({
                    field: 'packing.pack.unitsWeight.value',
                    messages: ['Min is greater than max']
                });
            } else {
                newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                    return obj.field !== 'packing.pack.unitsWeight.value';
                });
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'changeWeightUnits',
        value: function changeWeightUnits(e, key) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsWeight[0].unit = unitsWeight[key];
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeVolume',
        value: function onChangeVolume(e, index) {
            var value = __WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* default */].clearLetters(e.target.value);
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[index].value = value || undefined;

            if (newCargoOrder.totalValues.isCalc && index === 0) {
                newCargoOrder.totalValues.volume = newCargoOrder.cargo.reduce(function (acc, item) {
                    return acc + parseInt(item.packing.pack.unitsVolume[0].value);
                }, 0);

                newCargoOrder.totalValues.volumeWithPercent = newCargoOrder.cargo.reduce(function (acc, item) {
                    var uv = item.packing.pack.unitsVolume[0];
                    if (uv.deviation && parseInt(uv.value)) {
                        return acc + parseInt(parseInt(uv.value) * (uv.deviation / 100 + 1));
                    } else if (!uv.deviation && parseInt(uv.value)) {
                        return acc + parseInt(uv.value);
                    }

                    return acc + 0;
                }, 0);
            }

            if (+newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[0].value > +newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[1].value) {
                newCargoOrder.validateErrors.push({
                    field: 'packing.pack.unitsVolume.value',
                    messages: ['Min is greater than max']
                });
            } else {
                newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                    return obj.field !== 'packing.pack.unitsVolume.value';
                });
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'changeVolumeUnits',
        value: function changeVolumeUnits(e, key) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack.unitsVolume[0].unit = unitsVolume[key];
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onToggleFreeze',
        value: function onToggleFreeze(unit) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[unit][0].isCalc = !newCargoOrder.cargo[this.props.cargoPackingIndex].packing.pack[unit][0].isCalc;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }

        /**
         * 
         * @param { 'temperatureMin' | 'temperatureMax' | 'moistureMin' | 'moistureMax' | 
         *  'numberOfHeadsMin' | 'numberOfHeadsMax' | 'weightPerHead' | 'ventilation' } field 
         * @param {*} value 
         */


        /**
         * @param {string} _clause
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var errorWeightValue = this.props.errorWeightValue ? this.props.errorWeightValue.messages[0] : '';
            var errorVolumeValue = this.props.errorVolumeValue ? this.props.errorVolumeValue.messages[0] : '';

            var temperatureMaxError = this.props.validateErrors.find(function (e) {
                return e.field === 'packing.pack.temperatureMax';
            });

            var moistureMaxError = this.props.validateErrors.find(function (e) {
                return e.field === 'packing.pack.moistureMax';
            });

            var numberOfHeadsMaxError = this.props.validateErrors.find(function (e) {
                return e.field === 'packing.pack.numberOfHeadsMax';
            });

            var _props$cargoOrder$car = this.props.cargoOrder.cargo[this.props.cargoPackingIndex].packing.pack,
                packUnitsWeight = _props$cargoOrder$car.unitsWeight,
                packUnitsVolume = _props$cargoOrder$car.unitsVolume,
                temperatureMin = _props$cargoOrder$car.temperatureMin,
                temperatureMax = _props$cargoOrder$car.temperatureMax,
                moistureMin = _props$cargoOrder$car.moistureMin,
                moistureMax = _props$cargoOrder$car.moistureMax,
                numberOfHeadsMin = _props$cargoOrder$car.numberOfHeadsMin,
                numberOfHeadsMax = _props$cargoOrder$car.numberOfHeadsMax,
                weightPerHead = _props$cargoOrder$car.weightPerHead,
                ventilation = _props$cargoOrder$car.ventilation;
            var _props$cargoOrder$car2 = this.props.cargoOrder.cargo[this.props.cargoPackingIndex],
                details = _props$cargoOrder$car2.details,
                clauses = _props$cargoOrder$car2.clauses;

            var shipment = JSON.stringify(clauses.find(function (c) {
                return c.name === 'Shipment';
            }));
            var cradlesToBeFor = JSON.stringify(clauses.find(function (c) {
                return c.name === 'Cradles to be for';
            }));

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { fontSize: '14px' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left', style: { fontSize: '13px' } },
                        'Weight/Volume:'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        'Weight:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'unitWeightValue',
                            style: { width: '80%', fontSize: '14px' },
                            value: packUnitsWeight[0].value || '',
                            floatingLabelText: 'Min',
                            onChange: function onChange(e) {
                                return _this2.onChangeWeight(e, 0);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'unitWeightValue',
                            errorText: errorWeightValue,
                            style: { width: '80%', fontSize: '14px' },
                            value: packUnitsWeight[1].value || '',
                            floatingLabelText: 'Max',
                            onChange: function onChange(e) {
                                return _this2.onChangeWeight(e, 1);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Units',
                                style: { width: '80%', fontSize: '14px' },
                                value: packUnitsWeight[0].unit,
                                onChange: this.changeWeightUnits,
                                maxHeight: 200,
                                autoWidth: true
                            },
                            unitsWeight.map(function (unit, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: key,
                                    style: { width: 'auto' },
                                    value: unit,
                                    primaryText: unit
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle___default.a, {
                            label: 'Freezed',
                            style: { width: '60%', fontSize: '14px' },
                            toggled: !!packUnitsWeight[0] && !packUnitsWeight[0].isCalc,
                            onToggle: function onToggle() {
                                return _this2.onToggleFreeze('unitsWeight');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: {
                                    width: '40%',
                                    fontSize: '14px'
                                },
                                floatingLabelText: 'Sign 1',
                                value: packUnitsWeight[0].deviationSign && packUnitsWeight[0].deviationSign.sign1,
                                onChange: function onChange(e) {
                                    return _this2.changeDeviationSign(e, 'unitsWeight', 'sign1');
                                },
                                maxHeight: 200,
                                autoWidth: true
                            },
                            ['+', '-'].map(function (unit, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: key,
                                    style: { width: 'auto' },
                                    value: unit,
                                    primaryText: unit
                                });
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: {
                                    marginLeft: '10px',
                                    width: '40%',
                                    fontSize: '14px'
                                },
                                floatingLabelText: 'Sign 2',
                                value: packUnitsWeight[0].deviationSign && packUnitsWeight[0].deviationSign.sign2,
                                onChange: function onChange(e) {
                                    return _this2.changeDeviationSign(e, 'unitsWeight', 'sign2');
                                },
                                maxHeight: 200,
                                autoWidth: true
                            },
                            ['+', '-'].map(function (unit, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: key,
                                    style: { width: 'auto' },
                                    value: unit,
                                    primaryText: unit
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'unitWeightDeviation',
                            style: { width: '80%', fontSize: '14px' },
                            value: packUnitsWeight[0].deviation || '',
                            floatingLabelText: 'Deviation',
                            onChange: function onChange(e) {
                                _this2.onChangeDeviation(e, 'unitsWeight');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: {
                                    width: '80%',
                                    fontSize: '14px'
                                },
                                floatingLabelText: 'Terms',
                                value: packUnitsWeight[0].term || '',
                                onChange: function onChange(e, key) {
                                    _this2.changeTerm(key, 'unitsWeight');
                                },
                                maxHeight: 200,
                                autoWidth: true
                            },
                            terms.map(function (term, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: key,
                                    style: { width: 'auto' },
                                    value: term,
                                    primaryText: term
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        'Volume:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'unitVolumeValue',
                            style: { width: '80%', fontSize: '14px' },
                            value: packUnitsVolume[0].value || '',
                            floatingLabelText: 'Min',
                            onChange: function onChange(e) {
                                return _this2.onChangeVolume(e, 0);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'unitVolumeValue',
                            errorText: errorVolumeValue,
                            style: { width: '80%', fontSize: '14px' },
                            value: packUnitsVolume[1].value || '',
                            floatingLabelText: 'Max',
                            onChange: function onChange(e) {
                                return _this2.onChangeVolume(e, 1);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: {
                                    width: '80%',
                                    fontSize: '14px'
                                },
                                floatingLabelText: 'Units',
                                value: packUnitsVolume[0].unit,
                                onChange: this.changeVolumeUnits,
                                maxHeight: 200,
                                autoWidth: true
                            },
                            unitsVolume.map(function (unit, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: key,
                                    style: { width: 'auto' },
                                    value: unit,
                                    primaryText: unit
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Toggle___default.a, {
                            label: 'Freezed',
                            style: { width: '60%', fontSize: '14px' },
                            toggled: !!packUnitsVolume[0] && !packUnitsVolume[0].isCalc,
                            onToggle: function onToggle() {
                                return _this2.onToggleFreeze('unitsVolume');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: {
                                    width: '40%',
                                    fontSize: '14px'
                                },
                                floatingLabelText: 'Sign 1',
                                value: packUnitsVolume[0].deviationSign && packUnitsVolume[0].deviationSign.sign1,
                                onChange: function onChange(e) {
                                    return _this2.changeDeviationSign(e, 'unitsVolume', 'sign1');
                                },
                                maxHeight: 200,
                                autoWidth: true
                            },
                            ['+', '-'].map(function (unit, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: key,
                                    style: { width: 'auto' },
                                    value: unit,
                                    primaryText: unit
                                });
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: {
                                    marginLeft: '10px',
                                    width: '40%',
                                    fontSize: '14px'
                                },
                                floatingLabelText: 'Sign 2',
                                value: packUnitsVolume[0].deviationSign && packUnitsVolume[0].deviationSign.sign2,
                                onChange: function onChange(e) {
                                    return _this2.changeDeviationSign(e, 'unitsVolume', 'sign2');
                                },
                                maxHeight: 200,
                                autoWidth: true
                            },
                            ['+', '-'].map(function (unit, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: key,
                                    style: { width: 'auto' },
                                    value: unit,
                                    primaryText: unit
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'unitVolumeDeviation',
                            style: { width: '80%', fontSize: '14px' },
                            value: packUnitsVolume[0].deviation || '',
                            floatingLabelText: 'Deviation',
                            onChange: function onChange(e) {
                                _this2.onChangeDeviation(e, 'unitsVolume');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: {
                                    width: '80%',
                                    fontSize: '14px'
                                },
                                floatingLabelText: 'Terms',
                                value: packUnitsVolume[0].term,
                                onChange: function onChange(e, key) {
                                    _this2.changeTerm(key, 'unitsVolume');
                                },
                                maxHeight: 200,
                                autoWidth: true
                            },
                            terms.map(function (unit, _key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: unit,
                                    style: { width: 'auto' },
                                    value: unit,
                                    primaryText: unit
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'temperatureMin',
                            style: { fontSize: '13px' },
                            value: temperatureMin || '',
                            floatingLabelText: 'Temperature min, \xB0C',
                            hintText: 'Temperature min, \xB0C',
                            onChange: function onChange(e) {
                                return _this2.changeAdditionalPackingData('temperatureMin', e.target.value);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'temperatureMax',
                            style: { fontSize: '13px' },
                            value: temperatureMax || '',
                            errorText: temperatureMaxError && temperatureMaxError.messages[0],
                            floatingLabelText: 'Temperature max, \xB0C',
                            hintText: 'Temperature max, \xB0C',
                            onChange: function onChange(e) {
                                return _this2.changeAdditionalPackingData('temperatureMax', e.target.value);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'moistureMin',
                            style: { fontSize: '13px' },
                            value: moistureMin || '',
                            floatingLabelText: 'Moisture min, %',
                            hintText: 'Moisture min, %',
                            onChange: function onChange(e) {
                                return _this2.changeAdditionalPackingData('moistureMin', e.target.value);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'moistureMax',
                            style: { fontSize: '13px' },
                            value: moistureMax || '',
                            errorText: moistureMaxError && moistureMaxError.messages[0],
                            floatingLabelText: 'Moisture max, %',
                            hintText: 'Moisture max, %',
                            onChange: function onChange(e) {
                                return _this2.changeAdditionalPackingData('moistureMax', e.target.value);
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'numberOfHeadsMin',
                            style: { fontSize: '13px' },
                            value: numberOfHeadsMin || '',
                            floatingLabelText: 'Number of heads (min)',
                            hintText: 'Number of heads (min)',
                            onChange: function onChange(e) {
                                return _this2.changeAdditionalPackingData('numberOfHeadsMin', e.target.value);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'numberOfHeadsMax',
                            style: { fontSize: '13px' },
                            value: numberOfHeadsMax || '',
                            errorText: numberOfHeadsMaxError && numberOfHeadsMaxError.messages[0],
                            floatingLabelText: 'Number of heads (max)',
                            hintText: 'Number of heads (max)',
                            onChange: function onChange(e) {
                                return _this2.changeAdditionalPackingData('numberOfHeadsMax', e.target.value);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            ref: 'weightPerHead',
                            style: { fontSize: '13px' },
                            value: weightPerHead || '',
                            floatingLabelText: 'Weight mt per head',
                            hintText: 'Weight mt per head',
                            onChange: function onChange(e) {
                                return _this2.changeAdditionalPackingData('weightPerHead', e.target.value);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["b" /* Checkbox */], {
                            label: 'Ventilation',
                            style: { marginTop: '24px' },
                            labelStyle: { fontSize: '13px', fontWeight: 'normal' },
                            value: ventilation,
                            onChange: function onChange() {
                                return _this2.changeAdditionalPackingData('ventilation', !ventilation);
                            }
                        })
                    )
                ),
                details === 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: { fontSize: '14px' },
                                floatingLabelText: 'Shipment',
                                value: shipment,
                                onChange: function onChange(_e, _i, value) {
                                    _this2.changeClauses(value);
                                },
                                maxHeight: 200,
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_11_constants_weightVolume__["b" /* SHIPMENT */].map(function (clause) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: clause.value,
                                    style: { width: 'auto' },
                                    value: JSON.stringify(clause),
                                    primaryText: clause.value
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth', style: { padding: '0 20px' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                style: { fontSize: '12px' },
                                labelStyle: { paddingRight: '36px' },
                                floatingLabelText: 'Cradles to be for',
                                iconStyle: { height: '39px', width: '39px' },
                                value: cradlesToBeFor,
                                onChange: function onChange(_e, _i, value) {
                                    _this2.changeClauses(value);
                                },
                                maxHeight: 200,
                                autoWidth: true,
                                fullWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_11_constants_weightVolume__["a" /* CRADLES_TO_BE_FOR */].map(function (clause) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: clause.value,
                                    style: { width: 'auto' },
                                    value: JSON.stringify(clause),
                                    primaryText: clause.value
                                });
                            })
                        )
                    )
                ) : null,
                details === 2 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'one-forth', style: { padding: '0 20px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                                {
                                    style: { fontSize: '14px' },
                                    floatingLabelText: 'Shipment',
                                    value: shipment,
                                    onChange: function onChange(_e, _i, value) {
                                        _this2.changeClauses(value);
                                    },
                                    maxHeight: 200,
                                    autoWidth: true
                                },
                                __WEBPACK_IMPORTED_MODULE_11_constants_weightVolume__["b" /* SHIPMENT */].map(function (clause) {
                                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                        key: clause.value,
                                        style: { width: 'auto' },
                                        value: JSON.stringify(clause),
                                        primaryText: clause.value
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'one-forth', style: { padding: '0 20px' } }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { style: { padding: '0 20px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["b" /* Checkbox */], {
                                label: 'Pipes not to be overstowed with other cargo',
                                style: { marginTop: '24px' },
                                labelStyle: { fontSize: '13px', fontWeight: 'normal', width: '100%' },
                                iconStyle: { marginRight: '6px' },
                                checked: this.state['Pipes not to be overstowed with other cargo'],
                                onCheck: function onCheck() {
                                    return _this2.changeClauses(JSON.stringify({
                                        name: 'Pipes not to be overstowed with other cargo',
                                        value: !_this2.state['Pipes not to be overstowed with other cargo']
                                    }));
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'one-forth', style: { padding: '0 20px 10px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["b" /* Checkbox */], {
                                label: 'Box shaped hold only',
                                style: { marginTop: '24px' },
                                labelStyle: {
                                    fontSize: '12px', fontWeight: 'normal', width: '100%'
                                },
                                iconStyle: { marginRight: '6px' },
                                checked: this.state['Box shaped hold only'],
                                onCheck: function onCheck() {
                                    return _this2.changeClauses(JSON.stringify({
                                        name: 'Box shaped hold only',
                                        value: !_this2.state['Box shaped hold only']
                                    }));
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'one-forth', style: { padding: '0 20px 10px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["b" /* Checkbox */], {
                                label: 'Wooden dunnaging',
                                style: { marginTop: '24px', width: '100%' },
                                labelStyle: {
                                    fontSize: '12px', fontWeight: 'normal', width: '100%'
                                },
                                iconStyle: { marginRight: '6px' },
                                checked: this.state['Wooden dunnaging'],
                                onCheck: function onCheck() {
                                    return _this2.changeClauses(JSON.stringify({
                                        name: 'Wooden dunnaging',
                                        value: !_this2.state['Wooden dunnaging']
                                    }));
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { style: { padding: '0 20px 10px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["b" /* Checkbox */], {
                                label: 'Pipes with flanges and not streight on ends',
                                style: { marginTop: '24px', width: '100%' },
                                labelStyle: {
                                    fontSize: '12px', fontWeight: 'normal', width: '100%'
                                },
                                iconStyle: { marginRight: '6px' },
                                checked: this.state['Pipes with flanges and not streight on ends'],
                                onCheck: function onCheck() {
                                    return _this2.changeClauses(JSON.stringify({
                                        name: 'Pipes with flanges and not streight on ends',
                                        value: !_this2.state['Pipes with flanges and not streight on ends']
                                    }));
                                }
                            })
                        )
                    )
                ) : null
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return WeightVolume;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

    var errorWeightValue = cargoOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'packing.pack.unitsWeight.value';
    });

    var errorVolumeValue = cargoOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'packing.pack.unitsVolume.value';
    });

    var validateErrors = cargoOrder.validateErrors;


    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: cargoOrder,
        errorWeightValue: errorWeightValue,
        errorVolumeValue: errorVolumeValue,
        validateErrors: validateErrors
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_8_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(WeightVolume);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(unitsWeight, 'unitsWeight', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/WeightVolume.jsx');
    reactHotLoader.register(unitsVolume, 'unitsVolume', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/WeightVolume.jsx');
    reactHotLoader.register(terms, 'terms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/WeightVolume.jsx');
    reactHotLoader.register(WeightVolume, 'WeightVolume', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/WeightVolume.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/WeightVolume.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CRADLES_TO_BE_FOR; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var SHIPMENT = [{ name: 'Shipment', value: 'under deck' }, { name: 'Shipment', value: 'on deck' }, { name: 'Shipment', value: 'on/under deck' }];

var CRADLES_TO_BE_FOR = [{ name: 'Cradles to be for', value: 'Charterer\'s account' }, { name: 'Cradles to be for', value: 'Charterer\'s account, and time' }, { name: 'Cradles to be for', value: 'Charterer\'s account, risk and time' }, { name: 'Cradles to be for', value: 'Owner\'s account' }, { name: 'Cradles to be for', value: 'Owner\'s account, and time' }, { name: 'Cradles to be for', value: 'Owner\'s account, risk and time' }];
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SHIPMENT, 'SHIPMENT', '/opt/atlassian/pipelines/agent/build/client/app/constants/weightVolume.js');
    reactHotLoader.register(CRADLES_TO_BE_FOR, 'CRADLES_TO_BE_FOR', '/opt/atlassian/pipelines/agent/build/client/app/constants/weightVolume.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var styles = {
    selectField: { padding: '0 5px', width: '90%', fontSize: '13px' },
    menuItem: { width: 'auto', fontSize: '13px' }
};

/**
 * 
 * @param {'loading' | 'discharging'} type 
 * @param {string} key 
 */
var getLDSetting = function getLDSetting(type, key) {
    if (type === 'loading') {
        return __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["d" /* LOADING_RATES_LIST */].find(function (i) {
            return i.key === key;
        });
    }

    return __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["b" /* DISCHARGING_RATES_LIST */].find(function (i) {
        return i.key === key;
    });
};

var LDrates = function (_React$Component) {
    _inherits(LDrates, _React$Component);

    function LDrates(props) {
        _classCallCheck(this, LDrates);

        var _this = _possibleConstructorReturn(this, (LDrates.__proto__ || Object.getPrototypeOf(LDrates)).call(this, props));

        _initialiseProps.call(_this);

        var loadingSettings = void 0;
        var dischargingSettings = void 0;

        if (_this.props.cargoOrder.ldRates && _this.props.cargoOrder.ldRates.loading && _this.props.cargoOrder.ldRates.loading.type) {
            loadingSettings = getLDSetting('loading', _this.props.cargoOrder.ldRates.loading.type);
        } else {
            loadingSettings = __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["c" /* LOADING_RATES_DEFAULT */];
        }

        if (_this.props.cargoOrder.ldRates && _this.props.cargoOrder.ldRates.discharging && _this.props.cargoOrder.ldRates.discharging.type) {
            dischargingSettings = getLDSetting('discharging', _this.props.cargoOrder.ldRates.discharging.type);
        } else {
            dischargingSettings = __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["a" /* DISCHARGING_RATES_DEFAULT */];
        }

        /**
         * @type {{ 
         *      loadingSettings: { 
         *          key: string, 
         *          value: string, 
         *          detailsDisabled?: string[],
         *          dischargingDisabled?: boolean,
         *          fill?: {
         *              field: string,
         *              value: string,
         *          }
         *      } | null, 
         *      dischargingSettings: { 
         *          key: string, 
         *          value: string, 
         *          detailsDisabled?: string[],
         *      } | null,
         *  }}
         */
        _this.state = {
            loadingSettings: loadingSettings,
            dischargingSettings: dischargingSettings
        };

        _this.selectLdRates = _this.selectLdRates.bind(_this);
        _this.onChangeLdRatesQuantity = _this.onChangeLdRatesQuantity.bind(_this);
        return _this;
    }

    _createClass(LDrates, [{
        key: 'onChangeLdRatesQuantity',
        value: function onChangeLdRatesQuantity(value, type) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.ldRates[type].quantity = value || undefined;

            if (value) {
                this.removeFromErrors(newCargoOrder, type);
            } else {
                this.addToErrors(newCargoOrder, type, 'quantity');
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'selectLdRates',
        value: function selectLdRates(_ref) {
            var type = _ref.type,
                field = _ref.field,
                value = _ref.value;

            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);

            if (newCargoOrder.ldRates[type][field] === value) {
                newCargoOrder.ldRates[type][field] = '';
            } else {
                newCargoOrder.ldRates[type][field] = value;
            }

            if (field === 'dimension' && value) {
                this.removeFromErrors(newCargoOrder, type);
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$errors = this.props.errors,
                errorLoadingQuantity = _props$errors.errorLoadingQuantity,
                errorDischargingQuantity = _props$errors.errorDischargingQuantity,
                errorLoadingDimension = _props$errors.errorLoadingDimension,
                errorDischargingDimension = _props$errors.errorDischargingDimension;
            var termEntities = this.props.termEntities;
            var _props$cargoOrder$ldR = this.props.cargoOrder.ldRates,
                loading = _props$cargoOrder$ldR.loading,
                discharging = _props$cargoOrder$ldR.discharging;
            var _state = this.state,
                loadingSettings = _state.loadingSettings,
                dischargingSettings = _state.dischargingSettings;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                        {
                            floatingLabelText: 'Loading',
                            value: loading.type,
                            style: { fontSize: '13px', width: '200px' },
                            onChange: function onChange(_e, _i, v) {
                                return _this2.selectLDType('loading', v);
                            },
                            autoWidth: true
                        },
                        __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["d" /* LOADING_RATES_LIST */].map(function (item, index) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { key: item.key + '_' + index, value: item.key, primaryText: item.value });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                        errorText: errorLoadingQuantity,
                        style: { fontSize: '13px', width: '58px', marginLeft: '15px' },
                        value: loading.quantity || '',
                        floatingLabelText: 'Quantity',
                        onChange: function onChange(e) {
                            _this2.onChangeLdRatesQuantity(__WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* default */].clearLetters(e.target.value), 'loading');
                        },
                        disabled: loadingSettings && loadingSettings.detailsDisabled.includes('quantity')
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row half' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Dimension',
                                style: styles.selectField,
                                value: loading.dimension,
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'loading', field: 'dimension', value: value });
                                },
                                maxHeight: 200,
                                autoWidth: true,
                                disabled: loadingSettings && loadingSettings.detailsDisabled.includes('dimension'),
                                errorText: errorLoadingDimension
                            },
                            termEntities.dimensions.map(function (d, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: d + '_' + key,
                                    style: styles.menuItem,
                                    value: d,
                                    primaryText: d
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Speed',
                                style: styles.selectField,
                                value: loading.speed,
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'loading', field: 'speed', value: value });
                                },
                                disabled: loadingSettings && loadingSettings.detailsDisabled.includes('speed'),
                                maxHeight: 200,
                                autoWidth: true
                            },
                            termEntities.speed.map(function (s, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: s + '_' + key,
                                    style: styles.menuItem,
                                    value: s,
                                    primaryText: s
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Abbreviation',
                                style: styles.selectField,
                                value: loading.abbreviation,
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'loading', field: 'abbreviation', value: value });
                                },
                                disabled: loadingSettings && loadingSettings.detailsDisabled.includes('abbreviation'),
                                maxHeight: 200,
                                autoWidth: true
                            },
                            termEntities.abbreviation.map(function (a, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: a + '_' + key,
                                    style: styles.menuItem,
                                    value: a,
                                    primaryText: a
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Term',
                                style: styles.selectField,
                                value: loading.term,
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'loading', field: 'term', value: value });
                                },
                                disabled: loadingSettings && loadingSettings.detailsDisabled.includes('term'),
                                maxHeight: 200,
                                autoWidth: true
                            },
                            termEntities.term.map(function (t, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: t + '_' + key,
                                    style: styles.menuItem,
                                    value: t,
                                    primaryText: t
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                        {
                            floatingLabelText: 'Discharging',
                            value: discharging.type,
                            style: { fontSize: '13px', width: '200px' },
                            onChange: function onChange(_e, _i, v) {
                                return _this2.selectLDType('discharging', v);
                            },
                            disabled: loadingSettings && loadingSettings.dischargingDisabled || dischargingSettings && dischargingSettings.detailsDisabled.includes('type'),
                            autoWidth: true

                        },
                        __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["b" /* DISCHARGING_RATES_LIST */].map(function (item, index) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { key: item.key + '_' + index, value: item.key, primaryText: item.value });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                        floatingLabelText: 'Quantity',
                        errorText: errorDischargingQuantity,
                        style: { fontSize: '13px', width: '58px', marginLeft: '15px' },
                        value: discharging.quantity || '',
                        hintText: 'Quantity',
                        disabled: loadingSettings && loadingSettings.dischargingDisabled || dischargingSettings && dischargingSettings.detailsDisabled.includes('quantity'),
                        onChange: function onChange(e) {
                            _this2.onChangeLdRatesQuantity(__WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* default */].clearLetters(e.target.value), 'discharging');
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row half', style: { paddingBottom: '15px' } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Dimension',
                                style: styles.selectField,
                                value: discharging.dimension || '',
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'discharging', field: 'dimension', value: value });
                                },
                                disabled: loadingSettings && loadingSettings.dischargingDisabled || dischargingSettings && dischargingSettings.detailsDisabled.includes('dimension'),
                                maxHeight: 200,
                                autoWidth: true,
                                errorText: errorDischargingDimension
                            },
                            termEntities.dimensions.map(function (d, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: d + '_' + key,
                                    style: styles.menuItem,
                                    value: d,
                                    primaryText: d
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Speed',
                                style: styles.selectField,
                                value: discharging.speed || '',
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'discharging', field: 'speed', value: value });
                                },
                                disabled: loadingSettings && loadingSettings.dischargingDisabled || dischargingSettings && dischargingSettings.detailsDisabled.includes('speed'),
                                maxHeight: 200,
                                autoWidth: true
                            },
                            termEntities.speed.map(function (s, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: s + '_' + key,
                                    style: styles.menuItem,
                                    value: s,
                                    primaryText: s
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Abbreviation',
                                style: styles.selectField,
                                value: discharging.abbreviation || '',
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'discharging', field: 'abbreviation', value: value });
                                },
                                disabled: loadingSettings && loadingSettings.dischargingDisabled || dischargingSettings && dischargingSettings.detailsDisabled.includes('abbreviation'),
                                maxHeight: 200,
                                autoWidth: true
                            },
                            termEntities.abbreviation.map(function (a, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: a + '_' + key,
                                    style: styles.menuItem,
                                    value: a,
                                    primaryText: a
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Term',
                                style: styles.selectField,
                                value: discharging.term || '',
                                onChange: function onChange(_e, _i, value) {
                                    _this2.selectLdRates({ type: 'discharging', field: 'term', value: value });
                                },
                                disabled: loadingSettings && loadingSettings.dischargingDisabled || dischargingSettings && dischargingSettings.detailsDisabled.includes('term'),
                                maxHeight: 200,
                                autoWidth: true
                            },
                            termEntities.term.map(function (t, key) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: t + '_' + key,
                                    style: styles.menuItem,
                                    value: t,
                                    primaryText: t
                                });
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, state) {
            if (props.cargoOrder.ldRates && props.cargoOrder.ldRates.loading && state.loadingSettings && props.cargoOrder.ldRates.loading.type !== state.loadingSettings.key || props.cargoOrder.ldRates && props.cargoOrder.ldRates.discharging && state.dischargingSettings && props.cargoOrder.ldRates.discharging.type !== state.dischargingSettings.key) {
                return {
                    loadingSettings: getLDSetting('loading', props.cargoOrder.ldRates.loading.type),
                    dischargingSettings: getLDSetting('discharging', props.cargoOrder.ldRates.discharging.type)
                };
            }

            return null;
        }
    }]);

    return LDrates;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.selectLDType = function (type, value) {
        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.props.cargoOrder);

        newCargoOrder.ldRates[type].type = value;

        var settings = getLDSetting(type, value);

        if (settings.detailsClear) {
            newCargoOrder.ldRates[type].dimension = undefined;
            newCargoOrder.ldRates[type].quantity = undefined;
            newCargoOrder.ldRates[type].speed = undefined;
            newCargoOrder.ldRates[type].abbreviation = undefined;
            newCargoOrder.ldRates[type].term = undefined;
        }

        if (settings.dischargingDisabled) {
            ['type', 'dimension', 'quantity', 'speed', 'abbreviation', 'term'].forEach(function (f) {
                newCargoOrder.ldRates.discharging[f] = undefined;
            });
            newCargoOrder.ldRates.discharging.type = __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["a" /* DISCHARGING_RATES_DEFAULT */].key;

            var dischargingSettings = getLDSetting('discharging', __WEBPACK_IMPORTED_MODULE_8_constants_ldRates__["a" /* DISCHARGING_RATES_DEFAULT */].key);

            _this3.setState({ dischargingSettings: dischargingSettings });
        }

        if (settings.fill) {
            var fill = settings.fill;

            newCargoOrder.ldRates.loading[fill.field] = fill.value;
        }

        if (settings.requiredFields) {
            settings.requiredFields.forEach(function (f) {
                if (!newCargoOrder.ldRates[type][f]) {
                    _this3.addToErrors(newCargoOrder, type, f);
                } else {
                    _this3.removeFromErrors(newCargoOrder, type);
                }
            });
        } else {
            _this3.removeFromErrors(newCargoOrder, type, { force: true });
        }

        _this3.setState(_defineProperty({}, type + 'Settings', settings));

        _this3.props.updateCargoOrder(_this3.props.numberOrderTable, newCargoOrder);

        return _this3.state;
    };

    this.addToErrors = function (newCargoOrder, type, field) {
        newCargoOrder.validateErrors.push({
            field: 'ldRates.' + type + '.' + field,
            messages: ['Required']
        });
    };

    this.removeFromErrors = function (newCargoOrder, type) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref2$force = _ref2.force,
            force = _ref2$force === undefined ? false : _ref2$force;

        ['dimension', 'quantity', 'type'].forEach(function (f) {
            if (force || newCargoOrder.ldRates[type][f]) {
                newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (e) {
                    return e.field !== 'ldRates.' + type + '.' + f;
                });
            }
        });
    };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var errorLoading = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors.filter(function (validateError) {
        return validateError.field.includes('ldRates.loading');
    }) || [];

    var errorDischarging = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors.filter(function (validateError) {
        return validateError.field.includes('ldRates.discharging');
    }) || [];

    var errorLoadingQuantity = errorLoading.find(function (e) {
        return e.field === 'ldRates.loading.quantity';
    });

    var errorDischargingQuantity = errorDischarging.find(function (e) {
        return e.field === 'ldRates.discharging.quantity';
    });

    var errorLoadingDimension = errorLoading.find(function (e) {
        return e.field === 'ldRates.loading.dimension';
    });

    var errorDischargingDimension = errorDischarging.find(function (e) {
        return e.field === 'ldRates.discharging.dimension';
    });

    var errors = {
        errorLoadingQuantity: errorLoadingQuantity && errorLoadingQuantity.messages[0],
        errorDischargingQuantity: errorDischargingQuantity && errorDischargingQuantity.messages[0],
        errorLoadingDimension: errorLoadingDimension && errorLoadingDimension.messages[0],
        errorDischargingDimension: errorDischargingDimension && errorDischargingDimension.messages[0]
    };

    return {
        termEntities: state.termEntities,
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
        errors: errors
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(LDrates);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LDrates.jsx');
    reactHotLoader.register(getLDSetting, 'getLDSetting', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LDrates.jsx');
    reactHotLoader.register(LDrates, 'LDrates', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LDrates.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LDrates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADING_RATES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISCHARGING_RATES_LIST; });
/* unused harmony export RATE_FIELDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADING_RATES_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISCHARGING_RATES_DEFAULT; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var LOADING_RATES_LIST = [{
    key: undefined,
    value: undefined,
    detailsDisabled: ['quantity', 'dimension', 'speed', 'term', 'abbreviation'],
    detailsClear: true
}, {
    key: 'LoadingRate',
    value: 'Loading rate',
    detailsDisabled: [],
    detailsClear: true,
    requiredFields: ['quantity', 'dimension']
}, {
    key: 'LoadingRateCQD',
    value: 'Loading rate - CQD',
    detailsDisabled: ['quantity', 'dimension'],
    detailsClear: true
}, {
    key: 'LoadingRateScale',
    value: 'Loading Rate - Scale',
    detailsDisabled: ['quantity', 'dimension'],
    detailsClear: true
}, {
    key: 'LRAsFastAsVesselCan',
    value: 'LR - As Fast as Vessel Can',
    detailsDisabled: ['quantity', 'dimension'],
    detailsClear: true
}, {
    key: 'LDRate',
    value: 'L/D Rate',
    detailsDisabled: [],
    dischargingDisabled: true,
    detailsClear: true,
    requiredFields: ['quantity', 'dimension']
}, {
    key: 'LDRatesTotalDays',
    value: 'L/D Rates - Total days',
    dischargingDisabled: true,
    detailsClear: true,
    detailsDisabled: ['dimension'],
    fill: {
        field: 'dimension',
        value: 'days'
    }
}, {
    key: 'LDRatesTotalHours',
    value: 'L/D Rates - Total hours',
    dischargingDisabled: true,
    detailsClear: true,
    detailsDisabled: ['dimension'],
    fill: {
        field: 'dimension',
        value: 'hours'
    }
}];

var DISCHARGING_RATES_LIST = [{
    key: undefined,
    value: undefined,
    detailsDisabled: ['quantity', 'dimension', 'speed', 'term', 'abbreviation'],
    detailsClear: true
}, {
    key: 'DischargingRate',
    value: 'Discharging rate',
    detailsDisabled: [],
    detailsClear: true,
    requiredFields: ['quantity', 'dimension']
}, {
    key: 'DischargingRateCQD',
    value: 'Discharging rate - CQD',
    detailsDisabled: ['quantity', 'dimension'],
    detailsClear: true
}, {
    key: 'DischargingRateScale',
    value: 'Discharging rate - Scale',
    detailsDisabled: ['quantity', 'dimension'],
    detailsClear: true
}, {
    key: 'DRAsFastAsVesselCan',
    value: 'DR - As Fast as Vessel Can',
    detailsDisabled: ['quantity', 'dimension'],
    detailsClear: true
}];

var RATE_FIELDS = {
    dimension: 'dimension',
    speed: 'speed',
    abbreviation: 'abbreviation',
    term: 'term'
};

var LOADING_RATES_DEFAULT = LOADING_RATES_LIST[0];
var DISCHARGING_RATES_DEFAULT = DISCHARGING_RATES_LIST[0];
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LOADING_RATES_LIST, 'LOADING_RATES_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ldRates.js');
    reactHotLoader.register(DISCHARGING_RATES_LIST, 'DISCHARGING_RATES_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/ldRates.js');
    reactHotLoader.register(RATE_FIELDS, 'RATE_FIELDS', '/opt/atlassian/pipelines/agent/build/client/app/constants/ldRates.js');
    reactHotLoader.register(LOADING_RATES_DEFAULT, 'LOADING_RATES_DEFAULT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ldRates.js');
    reactHotLoader.register(DISCHARGING_RATES_DEFAULT, 'DISCHARGING_RATES_DEFAULT', '/opt/atlassian/pipelines/agent/build/client/app/constants/ldRates.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Name = function (_React$Component) {
    _inherits(Name, _React$Component);

    function Name(props) {
        _classCallCheck(this, Name);

        var _this = _possibleConstructorReturn(this, (Name.__proto__ || Object.getPrototypeOf(Name)).call(this, props));

        _this.state = {
            cargoNames: [],
            cargoName: props.cargoOrder.cargo[props.cargoPackingIndex].cargoName,
            isShowDialog: false,
            names: []
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (searchText) {
            __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].getCargoNamesAutocomplete(searchText).then(function (response) {
                var cargoNames = response.data.data.map(function (cargoName) {
                    return {
                        name: cargoName.name,
                        item: cargoName
                    };
                });

                _this.setState({
                    cargoNames: cargoNames
                });
            }).then(function () {
                var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.cargoOrder);
                newCargoOrder.cargo[_this.props.cargoPackingIndex].cargoName = searchText;
                _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);
            }).catch(function () {
                return null;
            });
        }, 1000);

        _this.onChangeAutoCompleteCargoName = _this.onChangeAutoCompleteCargoName.bind(_this);
        _this.onChooseAutoCompleteCargoName = _this.onChooseAutoCompleteCargoName.bind(_this);
        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.changeSearch = _this.changeSearch.bind(_this);
        _this.chooseCargoName = _this.chooseCargoName.bind(_this);
        return _this;
    }

    _createClass(Name, [{
        key: 'chooseCargoName',
        value: function chooseCargoName(cargo) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);

            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoName = cargo.realCargoName;
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoType = cargo.CargoCategory;
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoTypeName = cargo.CargoCategoryName;
            newCargoOrder.cargo[this.props.cargoPackingIndex].details = cargo.details;

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

            this.setState({
                isShowDialog: !this.state.isShowDialog
            });
        }
    }, {
        key: 'searchInPopup',
        value: function searchInPopup(value) {
            return this.props.cargoAssigners.filter(function (cargoAssigner) {
                if (cargoAssigner.value && cargoAssigner.value.toLowerCase().includes(value.toLowerCase())) {
                    return true;
                }

                if (cargoAssigner.realCargoName && cargoAssigner.realCargoName.toLowerCase().includes(value.toLowerCase())) {
                    return true;
                }

                return false;
            });
        }
    }, {
        key: 'changeSearch',
        value: function changeSearch(e, value) {
            var names = this.searchInPopup(value);

            this.setState({
                names: names,
                cargoName: value
            });
        }
    }, {
        key: 'onChangeAutoCompleteCargoName',
        value: function onChangeAutoCompleteCargoName(searchText) {
            var _this2 = this;

            this.setState({
                cargoName: searchText
            }, function () {
                _this2.dAutocomplete(searchText);
            });
        }
    }, {
        key: 'onChooseAutoCompleteCargoName',
        value: function onChooseAutoCompleteCargoName(updateProperties) {
            if (!updateProperties) {
                return;
            }

            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);

            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoName = updateProperties.name;
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoId = updateProperties._id;
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoType = updateProperties.item.parent.red._id;
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoTypeName = updateProperties.item.parent.red.name;
            newCargoOrder.cargo[this.props.cargoPackingIndex].details = updateProperties.item.details;
            newCargoOrder.cargo[this.props.cargoPackingIndex].filterCategory = updateProperties.item.parent.red.name;

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

            this.setState({
                cargoNames: []
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            this.setState({
                cargoName: props.cargoOrder.cargo[this.props.cargoPackingIndex].cargoName || ''
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            var cargoName = this.state.cargoName;

            if (!cargoName) {
                this.props.addNotification({
                    title: 'Error',
                    message: 'Cargo name should be specified',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 2
                });
            } else {
                var names = this.searchInPopup(cargoName);

                this.setState({
                    isShowDialog: !this.state.isShowDialog,
                    names: names
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var errorCargoName = this.props.errorCargoName ? this.props.errorCargoName.messages[0] : '';
            var actions = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: this.toggleDialog
            })];

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_Dialog___default.a,
                    {
                        className: 'find-similar-popup',
                        title: 'Find similar (max 10)',
                        actions: actions,
                        open: this.state.isShowDialog,
                        onRequestClose: this.toggleDialog
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'search-block' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_TextField___default.a, {
                            floatingLabelText: 'Search cargo names',
                            onChange: this.changeSearch,
                            value: this.state.cargoName
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'result-header' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'result-line' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                'Cargo real name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                'Cargo name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'button' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'result-body' },
                        this.state.names.map(function (cargoAssigner, i) {
                            if (i < 30) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { key: i, className: 'result-line' },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'name' },
                                        cargoAssigner.realCargoName
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'name' },
                                        cargoAssigner.value
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'div',
                                        { className: 'button' },
                                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                            labelStyle: { fontSize: '10px' },
                                            style: { height: '25px' },
                                            buttonStyle: { height: '25px', lineHeight: '25px' },
                                            label: 'Choose',
                                            primary: true,
                                            onClick: function onClick() {
                                                _this3.chooseCargoName(cargoAssigner);
                                            }
                                        })
                                    )
                                );
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'column-left' },
                    'Cargo name:'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'column-right' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                        name: 'cargoName',
                        textFieldStyle: { fontSize: '13px' },
                        hintText: 'Cargo name',
                        errorText: errorCargoName,
                        searchText: this.state.cargoName || '',
                        dataSource: this.state.cargoNames,
                        dataSourceConfig: { text: 'name', value: 'item' },
                        onUpdateInput: this.onChangeAutoCompleteCargoName,
                        onNewRequest: this.onChooseAutoCompleteCargoName,
                        filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                        menuStyle: { width: 'auto' },
                        popoverProps: {
                            canAutoPosition: true
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        labelStyle: { fontSize: '10px' },
                        style: { height: '25px' },
                        buttonStyle: { height: '25px', lineHeight: '25px' },
                        label: 'Find in names',
                        primary: true,
                        onClick: this.toggleDialog
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Name;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var errorCargoName = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors.find(function (validateError) {
        return validateError.field === 'cargo.0.cargoName';
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        errorCargoName: errorCargoName,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
        cargoAssigners: state.cargoAssigners.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_orders__["f" /* updateCargoOrder */],
        addNotification: __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(Name);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Name, 'Name', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CargoName.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CargoName.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__ = __webpack_require__(51);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Type = function (_React$Component) {
    _inherits(Type, _React$Component);

    function Type(props) {
        _classCallCheck(this, Type);

        var _this = _possibleConstructorReturn(this, (Type.__proto__ || Object.getPrototypeOf(Type)).call(this, props));

        _this.state = {
            cargoTypes: props.cargoTypes
        };

        _this.selectDetails = _this.selectDetails.bind(_this);
        _this.onChangeAutoComplete = _this.onChangeAutoComplete.bind(_this);
        _this.onChooseAutoComplete = _this.onChooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(Type, [{
        key: 'selectDetails',
        value: function selectDetails(value) {
            var newCargoOrder = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].details = +value;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeAutoComplete',
        value: function onChangeAutoComplete(searchText) {
            var cargoTypes = this.props.cargoTypes;


            cargoTypes = cargoTypes.filter(function (cargoName) {
                if (cargoName.name.toLowerCase().includes(searchText.toLowerCase())) {
                    return {
                        name: cargoName.name,
                        item: cargoName,
                        details: cargoName.details
                    };
                }
            });

            this.setState({
                cargoTypes: cargoTypes
            });

            var newCargoOrder = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoTypeName = searchText;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChooseAutoComplete',
        value: function onChooseAutoComplete(updateProperties) {
            if (!updateProperties) {
                return;
            }

            var newCargoOrder = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoType = updateProperties.item._id;
            newCargoOrder.cargo[this.props.cargoPackingIndex].cargoTypeName = updateProperties.name;
            newCargoOrder.cargo[this.props.cargoPackingIndex].details = updateProperties.item.details;
            newCargoOrder.cargo[this.props.cargoPackingIndex].filterCategory = updateProperties.name;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var errorType = this.props.errorType && this.props.errorType.messages ? this.props.errorType.messages[0] : '';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Type:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            'Cargo type id - ',
                            this.props.cargoOrder.cargo[this.props.cargoPackingIndex].cargoType
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            'Details - ',
                            this.props.cargoOrder.cargo[this.props.cargoPackingIndex].details
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                            textFieldStyle: { fontSize: '13px' },
                            hintText: 'Cargo type',
                            searchText: this.props.cargoOrder.cargo[this.props.cargoPackingIndex].cargoTypeName || '',
                            dataSource: this.state.cargoTypes,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: this.onChangeAutoComplete,
                            onNewRequest: this.onChooseAutoComplete,
                            errorText: errorType,
                            filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true
                            }
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Type;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoTypes = state.cargoTypes.map(function (cargoType) {
        return {
            name: cargoType.name,
            item: cargoType
        };
    });

    cargoTypes.push({
        name: 'Other',
        item: {
            _id: '59970a4513d689b67b8bf20d'
        }
    });

    var errorType = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors.find(function (validateError) {
        return validateError.field === 'cargo.0.cargoType';
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoTypes: cargoTypes,
        errorType: errorType,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Type);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Type, 'Type', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CargoType.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CargoType.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreateNewRegion__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LUportBlock__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Base_DateRangeSelector__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_layCan__ = __webpack_require__(1949);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var getValueByLayCanType = function getValueByLayCanType(key) {
    return __WEBPACK_IMPORTED_MODULE_13_constants_layCan__["a" /* LAYCAN_TYPES */].find(function (i) {
        return i.key === key;
    });
};

var LUports = function (_React$Component) {
    _inherits(LUports, _React$Component);

    function LUports(props) {
        _classCallCheck(this, LUports);

        var _this = _possibleConstructorReturn(this, (LUports.__proto__ || Object.getPrototypeOf(LUports)).call(this, props));

        _this.handleOpen = function (key) {
            _this.setState({
                openDialogs: _extends({}, _this.state.openDialogs, _defineProperty({}, 'dialog' + key, true))
            });
        };

        _this.handleClose = function (key) {
            _this.setState({
                openDialogs: _extends({}, _this.state.openDialogs, _defineProperty({}, 'dialog' + key, false))
            });
        };

        _this.handleChangeLayCanType = function (index, value) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.props.cargoOrder);

            newCargoOrder.loadingPortsMap[index].port.layCanType = value;

            _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);
        };

        _this.hanleChangeAdditionalLayCanDetails = function (index, value) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.props.cargoOrder);

            newCargoOrder.loadingPortsMap[index].port.additionalLayCanDetails = value;

            _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);
        };

        _this.state = {
            openDialogs: {},
            loadingPortsMap: props.cargoOrder.loadingPortsMap,
            unloadingPortsMap: props.cargoOrder.unloadingPortsMap
        };

        props.cargoOrder.loadingPortsMap && props.cargoOrder.loadingPortsMap.forEach(function (_port, index) {
            _this.state.openDialogs['dialog' + index] = false;
        });

        _this.addNewPort = _this.addNewPort.bind(_this);
        _this.removePort = _this.removePort.bind(_this);

        _this.changePort = _this.changePort.bind(_this);
        return _this;
    }

    _createClass(LUports, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            if (newProps.cargoOrder.loadingPortsMap !== this.state.loadingPortsMap) {
                this.setState({ loadingPortsMap: newProps.cargoOrder.loadingPortsMap });
            }

            if (newProps.cargoOrder.unloadingPortsMap !== this.state.unloadingPortsMap) {
                this.setState({ unloadingPortsMap: newProps.cargoOrder.unloadingPortsMap });
            }
        }
    }, {
        key: 'changePort',
        value: function changePort(key, type, port) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);
            if (type === 'loading') {
                newCargoOrder.loadingPortsMap[key] = _extends({}, newCargoOrder.loadingPortsMap[key], {
                    port: _extends({}, newCargoOrder.loadingPortsMap[key].port, port)
                });
            } else {
                newCargoOrder.unloadingPortsMap[key] = _extends({}, newCargoOrder.unloadingPortsMap[key], {
                    port: _extends({}, newCargoOrder.unloadingPortsMap[key].port, port)
                });
            }

            newCargoOrder.readinessDate = port.readinessDate;
            newCargoOrder.cancellingDate = port.cancellingDate;

            if (type === 'loading') {
                if (!newCargoOrder.loadingPortsMap[key].port.readinessDate || !newCargoOrder.loadingPortsMap[key].port.cancellingDate) {
                    newCargoOrder.validateErrors.push({
                        field: 'laycan',
                        messages: ['Readiness/cancelling date required']
                    });
                } else {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'laycan';
                    });

                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'readinessDate';
                    });
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'cancellingDate';
                    });
                }
            }

            if (port.andOr) {
                newCargoOrder[type + 'PortsMap'][key] = {
                    port: port,
                    sign: port.andOr.toLowerCase()
                };
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'removePort',
        value: function removePort(key, type) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);

            if (type === 'loading') {
                newCargoOrder.loadingPortsMap.splice(key, 1);
            } else {
                newCargoOrder.unloadingPortsMap.splice(key, 1);
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'addNewPort',
        value: function addNewPort(type) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);
            if (type === 'loading') {
                var firstLPort = this.state.loadingPortsMap[0];
                newCargoOrder.loadingPortsMap.push({
                    port: {
                        port: '',
                        portName: '',
                        details: '',
                        cancellingDate: firstLPort.port.cancellingDate,
                        readinessDate: firstLPort.port.readinessDate,
                        loadingPortDetails: '',
                        andOr: 'and',
                        additionalLayCanDetails: undefined,
                        layCanType: 'layCan'
                    },
                    sign: 'and'
                });
            } else {
                newCargoOrder.unloadingPortsMap.push({
                    port: {
                        portName: '',
                        port: '',
                        details: '',
                        andOr: 'and'
                    },
                    sign: 'and'
                });
            }

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var errorLoadingPort = this.props.errorLoadingPort ? this.props.errorLoadingPort.messages[0] : '';
            var errorUnloadingPort = this.props.errorUnloadingPort ? this.props.errorUnloadingPort.messages[0] : '';

            var errorReadinessDate = this.props.errorReadinessDate ? this.props.errorReadinessDate.messages[0] : '';
            var errorCancellingDate = this.props.errorCancellingDate ? this.props.errorCancellingDate.messages[0] : '';

            var _props$cargoOrder = this.props.cargoOrder,
                loadingPortsMap = _props$cargoOrder.loadingPortsMap,
                unloadingPortsMap = _props$cargoOrder.unloadingPortsMap;


            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_FlatButton___default.a, {
                label: 'Ok',
                primary: true,
                onClick: function onClick() {
                    var entries = Object.entries(_this2.state.openDialogs);
                    return entries.forEach(function (entrie) {
                        return entrie[1] && _this2.handleClose(entrie[0].substr(-1));
                    });
                }
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Loading ports:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px', marginBottom: '10px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new loading port',
                            onClick: function onClick() {
                                return _this2.addNewPort('loading');
                            },
                            primary: true
                        })
                    )
                ),
                loadingPortsMap && loadingPortsMap.map(function (portItem, key) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: key },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'column-left' },
                                'Loading port - ' + (key + 1)
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'label' },
                                portItem.port.port
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LUportBlock__["a" /* default */], {
                                error: errorLoadingPort,
                                port: portItem.port,
                                typeOfPort: 'loading',
                                portKey: key,
                                changePort: _this2.changePort,
                                removePort: _this2.removePort
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { marginBottom: '15px', background: '' + (portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'one-forth' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CreateNewRegion__["a" /* default */], {
                                    typeOfPort: 'loading',
                                    numberOfPort: key,
                                    numberOrderTable: _this2.props.numberOrderTable,
                                    cargoOrder: _this2.props.cargoOrder
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'one-forth' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                    labelStyle: { fontSize: '10px' },
                                    style: { height: '25px' },
                                    buttonStyle: { height: '25px', lineHeight: '25px' },
                                    label: 'Laycan',
                                    onClick: function onClick() {
                                        return _this2.handleOpen(key);
                                    },
                                    primary: true
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'one-forth', style: { fontSize: '12px', display: 'block' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    getValueByLayCanType(portItem.port.layCanType).value,
                                    ':'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        {
                                            style: {
                                                fontSize: '12px',
                                                color: portItem.port.readinessDateOld ? '#f00' : 'unset'
                                            }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_2_moment___default()(portItem.port.readinessDate).utc().format('DD-MM-YYYY'),
                                        ' ---'
                                    ),
                                    portItem.port.cancellingDateOld ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { style: { color: '#f00', fontSize: '12px' } },
                                        __WEBPACK_IMPORTED_MODULE_2_moment___default()(portItem.port.cancellingDateOld).format('DD-MM-YYYY')
                                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { style: { fontSize: '12px' } },
                                        __WEBPACK_IMPORTED_MODULE_2_moment___default()(portItem.port.cancellingDate).utc().format('DD-MM-YYYY')
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'one-forth', style: { fontSize: '12px', display: 'block' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Details:'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    portItem.port.additionalLayCanDetails
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_10_material_ui_Dialog___default.a,
                                {
                                    title: 'Readiness/Cancelling dates',
                                    actions: actions,
                                    modal: false,
                                    open: !!_this2.state.openDialogs['dialog' + key],
                                    onRequestClose: function onRequestClose() {
                                        return _this2.handleClose(key);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_12_material_ui__["s" /* SelectField */],
                                        {
                                            hintText: 'LayCan type',
                                            value: portItem.port.layCanType,
                                            style: { fontSize: '13px', width: '200px' },
                                            onChange: function onChange(_e, _i, v) {
                                                return _this2.handleChangeLayCanType(key, v);
                                            },
                                            autoWidth: true
                                        },
                                        __WEBPACK_IMPORTED_MODULE_13_constants_layCan__["a" /* LAYCAN_TYPES */].map(function (item) {
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui__["m" /* MenuItem */], { key: item.key, value: item.key, primaryText: item.value });
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui__["A" /* TextField */], {
                                        className: 'additionalLayCanDetails',
                                        value: portItem.port.additionalLayCanDetails || '',
                                        hintText: 'Details (optional)',
                                        style: { marginLeft: '10px', width: '250px' },
                                        hintStyle: { fontSize: '13px' },
                                        onChange: function onChange(e) {
                                            return _this2.hanleChangeAdditionalLayCanDetails(key, e.target.value);
                                        }
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Base_DateRangeSelector__["a" /* default */], {
                                    from: portItem.port.readinessDate || null,
                                    until: portItem.port.cancellingDate || null,
                                    fromLabel: 'Readiness date',
                                    untilLabel: 'Cancelling date',
                                    fromHint: new Date(portItem.port.readinessDateOld),
                                    untilHint: portItem.port.cancellingDateOld,

                                    errorFrom: errorReadinessDate,
                                    errorUntil: errorCancellingDate,
                                    onChange: function onChange(range) {
                                        return _this2.changePort(loadingPortsMap.indexOf(portItem), 'loading', { readinessDate: range.from, cancellingDate: range.until });
                                    }
                                })
                            )
                        )
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Unloading ports:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px', marginBottom: '10px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new unloading port',
                            onClick: function onClick() {
                                return _this2.addNewPort('unloading');
                            },
                            primary: true
                        })
                    )
                ),
                unloadingPortsMap && unloadingPortsMap.map(function (portItem, key) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: key },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'column-left' },
                                'Unloading port - ' + (key + 1)
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'label' },
                                portItem.port.port
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LUportBlock__["a" /* default */], {
                                error: errorUnloadingPort,
                                port: portItem.port,
                                typeOfPort: 'unloading',
                                portKey: key,
                                changePort: _this2.changePort,
                                removePort: _this2.removePort
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { marginBottom: '15px', background: '' + (portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'one-forth' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CreateNewRegion__["a" /* default */], {
                                    typeOfPort: 'unloading',
                                    numberOfPort: key,
                                    numberOrderTable: _this2.props.numberOrderTable,
                                    cargoOrder: _this2.props.cargoOrder
                                })
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LUports;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

    var errorUnloadingPort = cargoOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'unloadingPort';
    });

    var errorLoadingPort = cargoOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'loadingPort';
    });

    var errorReadinessDate = cargoOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'readinessDate';
    });

    var errorCancellingDate = cargoOrder.validateErrors.find(function (validateError) {
        return validateError.field === 'cancellingDate';
    });

    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: cargoOrder,
        errorUnloadingPort: errorUnloadingPort,
        errorLoadingPort: errorLoadingPort,
        errorReadinessDate: errorReadinessDate,
        errorCancellingDate: errorCancellingDate
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(LUports);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getValueByLayCanType, 'getValueByLayCanType', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LUPorts/LUports.jsx');
    reactHotLoader.register(LUports, 'LUports', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LUPorts/LUports.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LUPorts/LUports.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_cargoes_orders__ = __webpack_require__(51);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CreateNewRegion = function (_React$Component) {
    _inherits(CreateNewRegion, _React$Component);

    function CreateNewRegion(props) {
        _classCallCheck(this, CreateNewRegion);

        var _this = _possibleConstructorReturn(this, (CreateNewRegion.__proto__ || Object.getPrototypeOf(CreateNewRegion)).call(this, props));

        _this.state = {
            openDialog: false,
            canRequestNewRegion: true,
            value: '',
            openSnackbar: false,
            message: ''
        };

        _this.handleOpenDialog = _this.handleOpenDialog.bind(_this);
        _this.handleCloseDialog = _this.handleCloseDialog.bind(_this);
        _this.onInputNewRegion = _this.onInputNewRegion.bind(_this);
        _this.sendNewRegion = _this.sendNewRegion.bind(_this);
        _this.onSnackbarClose = _this.onSnackbarClose.bind(_this);
        return _this;
    }

    _createClass(CreateNewRegion, [{
        key: 'sendNewRegion',
        value: function sendNewRegion() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].checkAndCreateRegion(this.state.value).then(function (response) {
                if (response.status === 200) {
                    return _this2.setState({
                        openSnackbar: true,
                        message: 'Region success added',
                        openDialog: false,
                        canRequestNewRegion: true,
                        value: ''
                    }, function () {
                        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(_this2.props.cargoOrder);

                        if (_this2.props.typeOfPort === 'loading') {
                            newCargoOrder.loadingPortsMap[_this2.props.numberOfPort].namePort = response.data.data.name;
                            newCargoOrder.loadingPortsMap[_this2.props.numberOfPort].idPort = response.data.data._id;
                        } else {
                            newCargoOrder.unloadingPortsMap[_this2.props.numberOfPort].namePort = response.data.data.name;
                            newCargoOrder.unloadingPortsMap[_this2.props.numberOfPort].idPort = response.data.data._id;
                        }

                        _this2.props.updateCargoOrder(_this2.props.numberOrderTable, newCargoOrder);
                    });
                }

                return _this2.setState({
                    openSnackbar: true,
                    message: 'Region does not added',
                    openDialog: false,
                    canRequestNewRegion: true,
                    value: ''
                });
            }).catch(function () {
                return _this2.setState({
                    openSnackbar: true,
                    message: 'Region does not added',
                    openDialog: false,
                    canRequestNewRegion: true,
                    value: ''
                });
            });
        }
    }, {
        key: 'handleCloseDialog',
        value: function handleCloseDialog() {
            this.setState({
                openDialog: false,
                canRequestNewRegion: true,
                value: ''
            });
        }
    }, {
        key: 'handleOpenDialog',
        value: function handleOpenDialog() {
            this.setState({
                openDialog: true,
                canRequestNewRegion: true
            });
        }
    }, {
        key: 'onInputNewRegion',
        value: function onInputNewRegion(e) {
            var canRequestNewRegion = true;
            var value = e.target.value;

            if (value.length > 0) {
                canRequestNewRegion = false;
            }

            this.setState({
                canRequestNewRegion: canRequestNewRegion,
                value: value
            });
        }
    }, {
        key: 'onSnackbarClose',
        value: function onSnackbarClose() {
            this.setState({
                openSnackbar: false,
                message: ''
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: this.handleCloseDialog
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton___default.a, {
                label: 'Send',
                primary: true,
                disabled: this.state.canRequestNewRegion,
                onClick: this.sendNewRegion
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default.a, {
                    labelStyle: { fontSize: '10px' },
                    style: { height: '25px' },
                    buttonStyle: { height: '25px', lineHeight: '25px' },
                    label: 'Create new region',
                    onClick: this.handleOpenDialog,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Snackbar___default.a, {
                    open: this.state.openSnackbar,
                    message: this.state.message,
                    autoHideDuration: 2000,
                    onRequestClose: this.onSnackbarClose
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog___default.a,
                    {
                        title: 'Create new region',
                        actions: actions,
                        modal: true,
                        open: this.state.openDialog
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                        hintText: 'Enter new region',
                        floatingLabelFixed: true,
                        onChange: this.onInputNewRegion
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CreateNewRegion;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        typeOfPort: ownProps.typeOfPort,
        numberOfPort: ownProps.numberOfPort,
        cargoOrder: ownProps.cargoOrder,
        numberOrderTable: ownProps.numberOrderTable
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_10_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(CreateNewRegion);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CreateNewRegion, 'CreateNewRegion', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CreateNewRegion.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/CreateNewRegion.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var LUportBlock = function (_React$Component) {
    _inherits(LUportBlock, _React$Component);

    function LUportBlock(props) {
        _classCallCheck(this, LUportBlock);

        var _this = _possibleConstructorReturn(this, (LUportBlock.__proto__ || Object.getPrototypeOf(LUportBlock)).call(this, props));

        _this.state = {
            ports: [],
            port: props.port,
            key: props.key,
            error: props.error,
            typeOfPort: props.typeOfPort
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (searchText) {
            if (searchText.length <= 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].findPortAdmin({ name: searchText, withAreas: true }).then(function (response) {
                var ports = [];

                response.data.data.forEach(function (port) {
                    ports.push.apply(ports, _toConsumableArray(_this.createPort(port)));
                });

                _this.setState({
                    ports: ports
                });
            }).catch(function () {
                return null;
            });
        }, 1000);

        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);
        _this.chooseAutoComplete = _this.chooseAutoComplete.bind(_this);

        _this.changeDetails = _this.changeDetails.bind(_this);
        _this.handleAndOrChange = _this.handleAndOrChange.bind(_this);
        return _this;
    }

    _createClass(LUportBlock, [{
        key: 'changeDetails',
        value: function changeDetails(e, value) {
            var _this2 = this;

            var port = this.state.port;


            port.details = value;

            this.setState({
                port: port
            }, function () {
                _this2.props.changePort(_this2.props.portKey, _this2.props.typeOfPort, _this2.state.port);
            });
        }
    }, {
        key: 'createPort',
        value: function createPort(port) {
            var ports = [];
            var name = '';

            if (port.sub) {
                port.sub.forEach(function (subPort) {
                    ports.push({
                        item: subPort,
                        text: subPort.name + ' - country ' + port.country.name,
                        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                            primaryText: subPort.name + ' - country ' + port.country.name,
                            value: subPort,
                            style: { paddingLeft: '30px' }
                        })
                    });
                });
            }

            if (port.country) {
                name = port.name + ' - country ' + port.country.name;
            } else {
                name = port.name;
            }

            return [{
                item: port,
                text: name,
                value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                    primaryText: name,
                    value: port
                })
            }].concat(ports);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                port: nextProps.port,
                key: nextProps.key,
                error: nextProps.error,
                typeOfPort: nextProps.typeOfPort
            });
        }
    }, {
        key: 'changeAutoComplete',
        value: function changeAutoComplete(searchText) {
            var _this3 = this;

            var port = this.state.port;

            port.portName = searchText;

            this.setState({
                port: port
            }, function () {
                _this3.dAutocomplete(searchText);
            });
        }
    }, {
        key: 'chooseAutoComplete',
        value: function chooseAutoComplete(updateProperties) {
            var _this4 = this;

            if (!updateProperties) {
                return;
            }

            var port = this.state.port;

            port.port = updateProperties.item._id;
            port.portName = updateProperties.item.name;

            this.setState({
                port: port
            }, function () {
                _this4.props.changePort(_this4.props.portKey, _this4.props.typeOfPort, _this4.state.port);
            });
        }
    }, {
        key: 'handleAndOrChange',
        value: function handleAndOrChange(e, i, value) {
            var _this5 = this;

            var port = this.state.port;


            port.andOr = value;

            this.setState({
                andOr: value
            }, function () {
                _this5.props.changePort(_this5.props.portKey, _this5.props.typeOfPort, _this5.state.port);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                port = _state.port,
                ports = _state.ports,
                typeOfPort = _state.typeOfPort,
                error = _state.error;
            var _props = this.props,
                removePort = _props.removePort,
                portKey = _props.portKey;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'one-forth' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete___default.a, {
                        errorText: error,
                        textFieldStyle: { fontSize: '13px' },
                        hintText: typeOfPort + ' port',
                        searchText: port.portName,
                        dataSource: ports,
                        onUpdateInput: this.changeAutoComplete,
                        onNewRequest: this.chooseAutoComplete,
                        filter: __WEBPACK_IMPORTED_MODULE_7_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                        popoverProps: {
                            canAutoPosition: true,
                            style: {
                                width: '400px'
                            }
                        },
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'one-forth' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_TextField___default.a, {
                        floatingLabelText: 'Details',
                        style: { fontSize: '13px', marginTop: '-25px', width: 'auto' },
                        value: port.details,
                        onChange: this.changeDetails,
                        fullWidth: true
                    })
                ),
                this.props.portKey !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'And/Or',
                                value: port.andOr && port.andOr.charAt(0).toUpperCase() + port.andOr.slice(1),
                                onChange: this.handleAndOrChange,
                                style: { marginTop: '-25px', fontSize: '13px' }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'And', primaryText: 'And' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'Or', primaryText: 'Or' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'one-forth' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                            label: 'Remove Port',
                            secondary: true,
                            style: { height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            labelStyle: { fontSize: '13px' },
                            onClick: function onClick() {
                                removePort(portKey, typeOfPort);
                            }
                        })
                    )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'one-forth' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                        {
                            floatingLabelText: 'And/Or',
                            value: port.andOr && port.andOr.charAt(0).toUpperCase() + port.andOr.slice(1),
                            onChange: this.handleAndOrChange,
                            style: { marginTop: '-25px', fontSize: '13px' },
                            disabled: true
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'And', primaryText: 'And' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'Or', primaryText: 'Or' })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LUportBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref) {
    var port = _ref.port,
        error = _ref.error,
        portKey = _ref.portKey,
        typeOfPort = _ref.typeOfPort,
        changePort = _ref.changePort;
    return {
        port: port,
        error: error,
        portKey: portKey,
        typeOfPort: typeOfPort,
        changePort: changePort
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(LUportBlock);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LUportBlock, 'LUportBlock', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LUPorts/LUportBlock.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/LUPorts/LUportBlock.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LAYCAN_TYPES; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var LAYCAN_TYPES = [{
    key: 'layCan',
    value: 'Laycan'
}, {
    key: 'shipmentDates',
    value: 'Shipment dates'
}, {
    key: 'shipmentDatesAbout',
    value: 'Shipment dates (abt)'
}, {
    key: 'readinessDates',
    value: 'Readiness dates'
}];
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LAYCAN_TYPES, 'LAYCAN_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/constants/layCan.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_CollapseCustomizable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var styles = {
    tableRow: {
        width: '85px',
        padding: '15px',
        whiteSpace: 'pre-wrap',
        textAlign: 'center',
        verticalAlign: 'middle',
        fontSize: '13px'
    },
    tableRowMain: {
        width: '120px',
        padding: '0',
        wordWrap: 'break-word',
        textAlign: 'center',
        verticalAlign: 'middle',
        fontSize: '13px'
    },
    tableRowFixedColumn: {
        width: '65px',
        whiteSpace: 'pre-wrap',
        textAlign: 'center',
        verticalAlign: 'middle',
        margin: '30px',
        background: '#FFFFFF'
    }
};

function defaultPackingList() {
    return {
        name: '',
        weight: undefined,
        weightIsCalc: undefined,
        length: undefined,
        width: undefined,
        height: undefined,
        quantity: undefined,
        totalWeight: undefined,
        imdg: undefined,
        grossWeight: undefined,
        netWeight: undefined,
        tareWeight: undefined,
        area: undefined,
        areaIsCalc: undefined,
        volume: undefined,
        volumeIsCalc: undefined
    };
}

var PACKING_FIELDS = ['length', 'width', 'height', 'quantity', 'weight', 'totalWeight', 'volume', 'area', 'imdg', 'grossWeight', 'netWeight', 'taraWeight'];

var PackingList = function (_React$Component) {
    _inherits(PackingList, _React$Component);

    function PackingList(props) {
        _classCallCheck(this, PackingList);

        var _this = _possibleConstructorReturn(this, (PackingList.__proto__ || Object.getPrototypeOf(PackingList)).call(this, props));

        _this.addRow = _this.addRow.bind(_this);
        _this.removeRow = _this.removeRow.bind(_this);
        _this.changeValue = _this.changeValue.bind(_this);
        return _this;
    }

    _createClass(PackingList, [{
        key: 'addRow',
        value: function addRow() {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packingList.push(defaultPackingList());
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'removeRow',
        value: function removeRow(index) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);
            newCargoOrder.cargo[this.props.cargoPackingIndex].packingList.splice(index, 1);
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'changeValue',
        value: function changeValue(e, index, field) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.props.cargoOrder);
            var _newCargoOrder$cargo$ = newCargoOrder.cargo[this.props.cargoPackingIndex],
                packing = _newCargoOrder$cargo$.packing,
                packingList = _newCargoOrder$cargo$.packingList;
            var value = e.target.value;


            if (field !== 'name') {
                value = __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value);

                value = value || undefined;
            }

            packingList[index][field] = value;

            if (['quantity', 'weight'].includes(field)) {
                var opposite = field === 'quantity' ? 'weight' : 'quantity';

                if (packingList[index].weight || packingList[index].quantity) {
                    packingList[index].totalWeight = e.target.value * packingList[index][opposite];

                    if (packing.pack.unitsWeight[0].isCalc) {
                        packing.pack.unitsWeight[0].value = packingList.reduce(function (acc, item) {
                            if (item.totalWeight) {
                                return acc + item.totalWeight;
                            }
                            return acc + 0;
                        }, 0);
                    }

                    if (packing.pack.unitsQuantityIsCalc) {
                        packing.pack.unitsQuantity = packingList.reduce(function (acc, item) {
                            return acc + parseInt(item.quantity);
                        }, 0);
                    }

                    if (newCargoOrder.totalValues.isCalc) {
                        newCargoOrder.totalValues.weight = newCargoOrder.cargo.reduce(function (acc, item) {
                            return acc + item.packingList.reduce(function (acc, item) {
                                return acc + item.totalWeight;
                            }, 0);
                        }, 0) * 1000;

                        newCargoOrder.totalValues.weightWithPercent = parseInt(newCargoOrder.cargo.reduce(function (acc, item) {
                            var deviation = item.packing.pack.unitsWeight[0].deviation;

                            var sumValue = item.packingList.reduce(function (acc, item) {
                                return acc + item.totalWeight;
                            }, 0);
                            if (deviation && sumValue) {
                                return acc + sumValue * (deviation / 100 + 1);
                            } else if (!deviation && sumValue) {
                                return acc + sumValue;
                            }
                            return acc + 0;
                        }, 0) * 1000);
                    }
                }
            }

            if (field === 'volume') {
                if (packing.pack.unitsVolume[0].isCalc) {
                    packing.pack.unitsVolume[0].value = packingList.reduce(function (acc, item) {
                        if (item.volume) {
                            return acc + parseInt(item.volume);
                        }
                        return acc + 0;
                    }, 0);
                }

                if (newCargoOrder.totalValues.isCalc) {
                    newCargoOrder.totalValues.volume = newCargoOrder.cargo.reduce(function (acc, item) {
                        return acc + item.packingList.reduce(function (acc, item) {
                            return acc + parseInt(item.volume);
                        }, 0);
                    }, 0);

                    newCargoOrder.totalValues.volumeWithPercent = parseInt(newCargoOrder.cargo.reduce(function (acc, item) {
                        var uv = item.packing.pack.unitsVolume[0];
                        var sumValue = item.packingList.reduce(function (acc, item) {
                            return acc + item.volume;
                        }, 0);
                        if (uv.deviation && sumValue) {
                            return acc + sumValue * (uv.deviation / 100 + 1);
                        } else if (!uv.deviation && sumValue) {
                            return acc + sumValue;
                        }
                        return acc + 0;
                    }, 0));
                }
            }
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var packingList = this.props.cargoOrder.cargo[this.props.cargoPackingIndex].packingList;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_CollapseCustomizable__["a" /* default */], {
                    _key: 'packingList',
                    bodyStyle: {
                        borderBottom: '1px solid #E0E0E0'
                    },
                    head: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { fontSize: '16px', lineHeight: '22px' } },
                            'PACKING LIST'
                        )
                    ),
                    body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["Table"],
                            {
                                bodyStyle: { overflow: 'visible' },
                                headerStyle: { width: 'auto' }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeader"],
                                {
                                    displaySelectAll: false,
                                    enableSelectAll: false,
                                    adjustForCheckbox: false
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRowMain },
                                        'Name'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'L, m'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'B, m'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'H, m'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'Qty'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'Weight, mt'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'TTL weight, mt'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'Volume, m3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'Area, m2'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'IMDG'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'Gross Weight, mt'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'Net Weight, mt'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"],
                                        { style: styles.tableRow },
                                        'Tare Weight, mt'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableHeaderColumn"], { style: styles.tableRow })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableBody"],
                                {
                                    displayRowCheckbox: false
                                },
                                packingList.map(function (packItem, packIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRow"],
                                        {
                                            key: packItem.name + '_' + packIndex,
                                            displayBorder: true,
                                            selectable: false,
                                            style: { fontSize: '14px' }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                            { style: styles.tableRowMain },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                                                name: 'name',
                                                value: packItem.name,
                                                type: 'text',
                                                min: 0,
                                                style: { width: '5em', fontSize: '14px' },
                                                onChange: function onChange(e) {
                                                    return _this2.changeValue(e, packIndex, 'name');
                                                }
                                            })
                                        ),
                                        PACKING_FIELDS.map(function (field, index) {
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                                {
                                                    key: field + '_' + index,
                                                    style: styles.tableRow
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                                                    name: field,
                                                    value: packItem[field] || '',
                                                    type: 'number',
                                                    min: 0,
                                                    style: { width: '3em', fontSize: '14px' },
                                                    onChange: function onChange(e) {
                                                        return _this2.changeValue(e, packIndex, field);
                                                    }
                                                })
                                            );
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui_Table__["TableRowColumn"],
                                            { style: styles.tableRowFixedColumn },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                                                null,
                                                packIndex !== packingList.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                                    color: 'red',
                                                    onClick: function onClick() {
                                                        return _this2.removeRow(packIndex);
                                                    }
                                                }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                                    color: 'green',
                                                    onClick: function onClick() {
                                                        return _this2.addRow();
                                                    }
                                                })
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PackingList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: cargoOrder
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(PackingList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/PackingList.jsx');
    reactHotLoader.register(defaultPackingList, 'defaultPackingList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/PackingList.jsx');
    reactHotLoader.register(PACKING_FIELDS, 'PACKING_FIELDS', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/PackingList.jsx');
    reactHotLoader.register(PackingList, 'PackingList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/PackingList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/PackingList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128438
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Dangerous = function (_React$Component) {
    _inherits(Dangerous, _React$Component);

    function Dangerous(props) {
        _classCallCheck(this, Dangerous);

        var _this = _possibleConstructorReturn(this, (Dangerous.__proto__ || Object.getPrototypeOf(Dangerous)).call(this, props));

        _this.onChangeValues = function (path, value) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.cargoOrder);
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.set(newCargoOrder.cargo[_this.props.cargoPackingIndex], path, value);
            _this.props.updateCargoOrder(_this.props.numberOrderTable, newCargoOrder);
        };

        _this.onChangeDangerousClass = _this.onChangeDangerousClass.bind(_this);
        _this.onChangeDangerousUnNumber = _this.onChangeDangerousUnNumber.bind(_this);
        return _this;
    }

    _createClass(Dangerous, [{
        key: 'onChangeDangerousClass',
        value: function onChangeDangerousClass(e) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            if (typeof newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous === 'undefined') {
                newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous = {
                    class: [],
                    unNumber: ''
                };
            }

            var value = __WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* default */].clearLetters(e.target.value);

            newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous.class[0] = value || undefined;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeDangerousUnNumber',
        value: function onChangeDangerousUnNumber(e) {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);

            if (typeof newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous === 'undefined') {
                newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous = {
                    class: [],
                    unNumber: ''
                };
            }

            var value = __WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* default */].clearLetters(e.target.value);

            if (value.length > 4) {
                return;
            }

            newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous.unNumber = value || undefined;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var cargoData = this.props.cargoOrder.cargo[this.props.cargoPackingIndex];

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third', style: { justifyContent: 'space-evenly' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { style: { display: 'block', fontSize: '13px', alignSelf: 'center' } },
                            'Stw Factor:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            style: { fontSize: '13px', width: '25px' },
                            value: cargoData.packing.pack.sf,
                            hintText: 'SF',
                            onChange: function onChange(e) {
                                return _this2.onChangeValues('packing.pack.sf', __WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["s" /* SelectField */],
                            {
                                hintText: 'cbm/mt',
                                style: { width: '71px', fontSize: '13px' },
                                value: cargoData.packing.pack.sfUnit,
                                hintStyle: { fontSize: '13px' },
                                iconStyle: {
                                    padding: '12px 0', width: 'unset', height: 'unset'
                                },
                                onChange: function onChange(_e, _i, value) {
                                    return _this2.onChangeValues('packing.pack.sfUnit', value);
                                },
                                labelStyle: { paddingRight: 0 },
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { value: 'cbm/mt', primaryText: 'cbm/mt' }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { value: 'cbf/mt', primaryText: 'cbf/mt' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third', style: { justifyContent: 'space-evenly' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["b" /* Checkbox */], {
                            style: { width: 'unset', alignSelf: 'center' },
                            checked: cargoData.dangerous.value,
                            labelStyle: { display: 'none' },
                            onCheck: function onCheck() {
                                return _this2.onChangeValues('dangerous.value', !cargoData.dangerous.value);
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            {
                                style: {
                                    display: 'block', width: '77px', fontSize: '13px', alignSelf: 'center'
                                }
                            },
                            'Dangerous Class (IMDG)'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            style: { fontSize: '13px', width: '42px' },
                            value: cargoData.dangerous && cargoData.dangerous.class[0] || '',
                            hintText: 'Class',
                            onChange: this.onChangeDangerousClass
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third', style: { justifyContent: 'space-evenly' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            {
                                style: {
                                    display: 'block', width: '96px', fontSize: '13px', alignSelf: 'center'
                                }
                            },
                            'Dangerous Good UnNumber (UN)'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            style: { fontSize: '13px', width: '61px' },
                            value: cargoData.dangerous && cargoData.dangerous.unNumber || '',
                            hintText: 'unNumber',
                            onChange: this.onChangeDangerousUnNumber
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Dangerous;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Dangerous);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Dangerous, 'Dangerous', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Dangerous.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Dangerous.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







/**
 * 
 * @param {{ 
 *  cargoIndex: number, 
 *  cargoOrder: any, 
 *  numberOrderTable: number,
 *  changeCargo: Function }} value
 */
function DetailsForCargo(_ref) {
    var cargoIndex = _ref.cargoIndex,
        cargoOrder = _ref.cargoOrder,
        changeCargo = _ref.changeCargo;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(cargoOrder ? cargoOrder.cargo[cargoIndex].additionalCargoDetails : undefined),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoOrder) {
            changeCargo([{
                field: 'cargo.' + cargoIndex + '.additionalCargoDetails',
                value: value || undefined
            }]);
        }
    }, [value]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            id: 'details-for-cargo',
            className: 'row'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-left' },
            'Details for cargo:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                className: 'details-for-cargo_value',
                value: value || '',
                hintText: 'Additional details',
                hintStyle: { fontSize: '13px' },
                style: { fontSize: '13px' },
                onChange: function onChange(e) {
                    return setValue(e.target.value);
                }
            })
        )
    );
}

DetailsForCargo.propTypes = {
    cargoOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    numberOrderTable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

DetailsForCargo.defaultProps = {
    cargoOrder: undefined,
    numberOrderTable: 0
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: cargoOrder
    };
}, null)(DetailsForCargo));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DetailsForCargo, 'DetailsForCargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/DetailsForCargo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/DetailsForCargo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







/**
 * Change customer id for one cargo inside cargo request
 * @param {{ 
 *  clientRefNo: string | undefined,
 *  cargoOrder: any, 
 *  changeCargo: Function }} value
 */
function CargoReferences(_ref) {
    var cargoOrder = _ref.cargoOrder,
        clientRefNo = _ref.clientRefNo,
        changeCargo = _ref.changeCargo;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(clientRefNo || undefined),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoOrder) {
            changeCargo([{
                field: 'clientRefNo',
                value: value || undefined
            }]);
        }
    }, [value]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            id: 'customer-id',
            className: 'row'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-left' },
            'Cargo reference(s):'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                className: 'cargoReferences_value',
                value: value || '',
                hintText: 'Cargo reference(s)',
                hintStyle: { fontSize: '13px' },
                style: { fontSize: '13px' },
                onChange: function onChange(e) {
                    return setValue(e.target.value);
                }
            })
        )
    );
}

CargoReferences.propTypes = {
    cargoOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

CargoReferences.defaultProps = {
    cargoOrder: undefined
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    return {
        cargoOrder: cargoOrder
    };
}, null)(CargoReferences));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoReferences, 'CargoReferences', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/CargoReferences.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/CargoReferences.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HSIdsCodes_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_react_utils__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_hsCodes__ = __webpack_require__(680);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









var hsCodesConfig = {
    text: 'text',
    value: '_id'
};

/**
 * 
 * @param {{ 
 *  cargoIndex: number,
 *  cargoOrder: any, 
 *  changeCargo: Function,
 *  numberOrderTable?: number,}} value
 */
function HSCode(_ref) {
    var _this = this;

    var cargoIndex = _ref.cargoIndex,
        cargoOrder = _ref.cargoOrder,
        changeCargo = _ref.changeCargo;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        hsCodes = _useState2[0],
        setHsCodes = _useState2[1];

    var _useRefState = Object(__WEBPACK_IMPORTED_MODULE_5_helpers_react_utils__["a" /* useRefState */])(''),
        _useRefState2 = _slicedToArray(_useRefState, 3),
        search = _useRefState2[0],
        setSearch = _useRefState2[1],
        searchRef = _useRefState2[2];

    /**
     * @param {string} e 
     */


    var onChangeAutoCompleteHSCode = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var _hsCodes;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setSearch(e);

                            if (!(e.trim().length < 3)) {
                                _context.next = 4;
                                break;
                            }

                            changeCargo([{
                                field: 'cargo.' + cargoIndex + '.hsCodeId',
                                value: { _id: undefined, name: null }
                            }]);
                            return _context.abrupt('return');

                        case 4:

                            changeCargo([{
                                field: 'cargo.' + cargoIndex + '.hsCodeId',
                                value: { _id: undefined, name: e }
                            }]);

                            _context.next = 7;
                            return Object(__WEBPACK_IMPORTED_MODULE_6_services_hsCodes__["a" /* hsCodeFind */])(e);

                        case 7:
                            _hsCodes = _context.sent;

                            if (!(searchRef.current !== e)) {
                                _context.next = 10;
                                break;
                            }

                            return _context.abrupt('return');

                        case 10:

                            setHsCodes(_hsCodes);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function onChangeAutoCompleteHSCode(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var onChooseAutoCompleteHSCode = function onChooseAutoCompleteHSCode(value) {
        changeCargo([{
            field: 'cargo.' + cargoIndex + '.hsCodeId',
            value: value
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            id: 'details-for-cargo',
            className: 'row'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-left' },
            'Hs Code:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-right', style: { width: '359px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */], {
                name: 'hsCode',
                textFieldStyle: { fontSize: '13px' },
                hintText: 'Hs Code',
                hintStyle: { fontSize: '13px' },
                searchText: search || (cargoOrder && cargoOrder.cargo[cargoIndex] ? cargoOrder.cargo[cargoIndex].hsCodeId.text : ''),
                dataSource: hsCodes,
                onUpdateInput: onChangeAutoCompleteHSCode,
                onNewRequest: onChooseAutoCompleteHSCode,
                dataSourceConfig: hsCodesConfig,
                filter: __WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */].noFilter,
                listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                menuStyle: { width: 'auto' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true
            })
        )
    );
}

HSCode.propTypes = {
    cargoOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    changeCargo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

HSCode.defaultProps = {
    cargoOrder: undefined,
    changeCargo: undefined
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    return {
        cargoOrder: cargoOrder
    };
}, null)(HSCode));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(hsCodesConfig, 'hsCodesConfig', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/HSCode.jsx');
    reactHotLoader.register(HSCode, 'HSCode', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/HSCode.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/HSCode.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Packing_common__ = __webpack_require__(129);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var DEFAULT_TYPE = 'breakbulk';

/**
 * @param {number} cargoType
 */
function getTransportationTypes(cargoType) {
    var found = Object(__WEBPACK_IMPORTED_MODULE_2__Packing_common__["h" /* getPackingTransportation */])(cargoType);

    return Object.keys(found);
}

/**
 * 
 * @param {{ 
 *  cargoIndex: number, 
 *  cargoItem: any, 
 *  changeCargo: Function }} value
 */
function Transportation(_ref) {
    var cargoIndex = _ref.cargoIndex,
        cargoItem = _ref.cargoItem,
        changeCargo = _ref.changeCargo;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(DEFAULT_TYPE),
        _useState2 = _slicedToArray(_useState, 2),
        transportation = _useState2[0],
        setTransportation = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_2__Packing_common__["d" /* TRANSPORTATION_ALL */]),
        _useState4 = _slicedToArray(_useState3, 2),
        currentTypes = _useState4[0],
        setCurrentTypes = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var availableTransportation = getTransportationTypes(cargoItem.cargoTypeName);

        var value = cargoItem.typeOfTransportation || availableTransportation[0];

        setTransportation(value);
        changeCargo([{
            field: 'cargo.' + cargoIndex + '.typeOfTransportation',
            value: value
        }, {
            field: 'typeOfTransportation',
            value: value
        }]);

        setCurrentTypes(availableTransportation);
    }, [cargoItem.cargoType, cargoItem.typeOfTransportation]);

    var selectTransportation = function selectTransportation(e) {
        var value = e.target.value;

        setTransportation(value);
        changeCargo([{
            field: 'cargo.' + cargoIndex + '.typeOfTransportation',
            value: value
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            id: 'transportation',
            className: 'row',
            style: { height: '48px' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-left' },
            'Category:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButtonGroup"],
                {
                    name: 'transportation_selector',
                    defaultSelected: transportation,
                    valueSelected: transportation,
                    style: { display: 'flex', fontSize: '13px' },
                    onChange: selectTransportation
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                    value: 'breakbulk',
                    label: 'Breakbulk',
                    disabled: !currentTypes.includes('breakbulk')
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                    value: 'bulk',
                    label: 'Dry bulk',
                    disabled: !currentTypes.includes('bulk')
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                    value: 'wetbulk',
                    label: 'Wet bulk',
                    disabled: !currentTypes.includes('wetbulk')
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                    value: 'container',
                    label: 'Containerized',
                    disabled: !currentTypes.includes('container')
                })
            )
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Transportation);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DEFAULT_TYPE, 'DEFAULT_TYPE', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Transportation.jsx');
    reactHotLoader.register(getTransportationTypes, 'getTransportationTypes', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Transportation.jsx');
    reactHotLoader.register(Transportation, 'Transportation', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Transportation.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Transportation.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_incoterms__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





/**
 * 
 * @param {{ 
 *  cargoIndex: number, 
 *  incoterms: any,
 *  changeCargo: Function }} value
 */
function Incoterms(_ref) {
    var _ref$incoterms = _ref.incoterms,
        incoterms = _ref$incoterms === undefined ? {} : _ref$incoterms,
        cargoIndex = _ref.cargoIndex,
        changeCargo = _ref.changeCargo;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(incoterms && incoterms.place),
        _useState2 = _slicedToArray(_useState, 2),
        currentPortOrPlace = _useState2[0],
        setCurrentPortOrPlace = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCurrentPortOrPlace(incoterms.place);
    }, [incoterms.place]);

    var handleChangeIncoterms = function handleChangeIncoterms(value) {
        var changes = [{
            field: 'incoterms.kind',
            value: value
        }];

        if (!value) {
            changes.push({
                field: 'incoterms.place',
                value: undefined
            });
            setCurrentPortOrPlace(undefined);
        }

        changeCargo(changes);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                id: 'transportation',
                className: 'row'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'column-left' },
                'INCOTERMS:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'column-right' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                id: 'transportation',
                className: 'row',
                style: { display: 'flex' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["s" /* SelectField */],
                    {
                        hintText: 'INCOTERMS',
                        floatingLabelText: 'INCOTERMS',
                        value: incoterms.kind || '',
                        style: { fontSize: '13px', width: '110px' },
                        onChange: function onChange(_e, _i, v) {
                            return handleChangeIncoterms(v);
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], { value: null, primaryText: '' }),
                    __WEBPACK_IMPORTED_MODULE_1_constants_incoterms__["a" /* INCOTERMS_LIST */].map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], { key: item, value: item, primaryText: item });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                    value: currentPortOrPlace || '',
                    disabled: !incoterms.kind,
                    hintText: 'Port or pla\u0441e',
                    floatingLabelText: 'Port or pla\u0441e',
                    style: {
                        width: '100%',
                        fontSize: '13px'
                    },
                    onChange: function onChange(e) {
                        return changeCargo([{
                            field: 'incoterms.place',
                            value: e.target.value
                        }]);
                    }
                })
            )
        )
    );
}

var _default = Incoterms;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Incoterms, 'Incoterms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Incoterms.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Incoterms.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INCOTERMS_LIST; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

// eslint-disable-next-line import/prefer-default-export
var INCOTERMS_LIST = ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CIP', 'CPT', 'DPU', 'DAP', 'DDP'];
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(INCOTERMS_LIST, 'INCOTERMS_LIST', '/opt/atlassian/pipelines/agent/build/client/app/constants/incoterms.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Bulk__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Unpacked__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Packed__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Loose__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WetBulk__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Container__ = __webpack_require__(1966);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();














var allCategories = ['bulk', 'unpacked', 'packed', 'loose', 'wetBulk', 'container'];

function Packing(_ref) {
    var numberOrderTable = _ref.numberOrderTable,
        cargoPackingIndex = _ref.cargoPackingIndex,
        cargoOrder = _ref.cargoOrder,
        updateCargoOrder = _ref.updateCargoOrder;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(allCategories),
        _useState2 = _slicedToArray(_useState, 2),
        currentEnabled = _useState2[0],
        setCurrentEnabled = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var fields = Object(__WEBPACK_IMPORTED_MODULE_8__common__["h" /* getPackingTransportation */])(cargoOrder.cargo[cargoPackingIndex].cargoTypeName);
        var _cargoOrder$cargo$car = cargoOrder.cargo[cargoPackingIndex],
            typeOfTransportation = _cargoOrder$cargo$car.typeOfTransportation,
            details = _cargoOrder$cargo$car.details;


        var availablePacked = fields[typeOfTransportation];

        var resetTransportation = void 0;
        var resetPacking = void 0;

        if (!availablePacked) {
            resetTransportation = Object.keys(fields)[0];
            resetPacking = Object.values(fields)[0];
        }

        if (typeOfTransportation === 'breakbulk' || resetTransportation === 'breakbulk') {
            availablePacked = Object(__WEBPACK_IMPORTED_MODULE_8__common__["g" /* getPackingForBreakBulk */])(details);
        }

        setCurrentEnabled(availablePacked || resetPacking);

        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(cargoOrder);
        if (availablePacked && !resetTransportation) {
            __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex].packing, 'category', availablePacked[0]);
        } else {
            __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex].packing, 'category', resetPacking[0]);
            __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex], 'typeOfTransportation', resetTransportation);
        }
        updateCargoOrder(numberOrderTable, newCargoOrder);
    }, [cargoOrder.cargo[cargoPackingIndex].typeOfTransportation, cargoOrder.cargo[cargoPackingIndex].cargoType]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { fontSize: '16px', lineHeight: '22px' } },
            'PACKING*'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Bulk__["a" /* default */], {
            numberOrderTable: numberOrderTable,
            cargoPackingIndex: cargoPackingIndex,
            canCheck: currentEnabled.includes('bulk')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Unpacked__["a" /* default */], {
            numberOrderTable: numberOrderTable,
            cargoPackingIndex: cargoPackingIndex,
            canCheck: currentEnabled.includes('unpacked')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Packed__["a" /* default */], {
            numberOrderTable: numberOrderTable,
            cargoPackingIndex: cargoPackingIndex,
            canCheck: currentEnabled.includes('packed')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Loose__["a" /* default */], {
            numberOrderTable: numberOrderTable,
            cargoPackingIndex: cargoPackingIndex,
            canCheck: currentEnabled.includes('loose')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WetBulk__["a" /* default */], {
            numberOrderTable: numberOrderTable,
            cargoPackingIndex: cargoPackingIndex,
            canCheck: currentEnabled.includes('wetBulk')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Container__["a" /* default */], {
            numberOrderTable: numberOrderTable,
            cargoPackingIndex: cargoPackingIndex,
            canCheck: currentEnabled.includes('container')
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Packing));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(allCategories, 'allCategories', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Packing.jsx');
    reactHotLoader.register(Packing, 'Packing', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Packing.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Packing.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_CollapseCustomizable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










function Bulk(_ref) {
    var numberOrderTable = _ref.numberOrderTable,
        cargoPackingIndex = _ref.cargoPackingIndex,
        cargoOrder = _ref.cargoOrder,
        updateCargoOrder = _ref.updateCargoOrder,
        _ref$canCheck = _ref.canCheck,
        canCheck = _ref$canCheck === undefined ? false : _ref$canCheck;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(cargoOrder.cargo[cargoPackingIndex].packing.category),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setValue(cargoOrder.cargo[cargoPackingIndex].packing.category);
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    var _onCheck = function _onCheck() {
        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(cargoOrder);
        newCargoOrder.cargo[cargoPackingIndex].packing.category = 'bulk';
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_common_CollapseCustomizable__["a" /* default */], {
            _key: 'bulk',
            head: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* RadioElement */], {
                checkedValue: value,
                disabled: !canCheck,
                value: 'bulk',
                onCheck: function onCheck() {
                    return _onCheck();
                },
                label: 'bulk',
                _key: 'bulk'
            }),
            withCollapseIcon: false,
            headStyle: {
                borderBottom: '1px solid #E0E0E0',
                cursor: 'inherit'
            }
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    return { cargoOrder: cargoOrder };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Bulk));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Bulk, 'Bulk', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Bulk.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Bulk.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












function Unpacked(_ref) {
    var updateCargoOrder = _ref.updateCargoOrder,
        numberOrderTable = _ref.numberOrderTable,
        cargoPackingIndex = _ref.cargoPackingIndex,
        cargoOrder = _ref.cargoOrder,
        cargoPacking = _ref.cargoPacking,
        _ref$canCheck = _ref.canCheck,
        canCheck = _ref$canCheck === undefined ? false : _ref$canCheck;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        disabledAll = _useState2[0],
        setDisableAll = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        stackableDisabled = _useState4[0],
        setStackableDisabled = _useState4[1];

    /**
     * 
     * @param {string} fieldPath field path
     * @param {any} value 
     * @param {{ fieldPath: string, value: any }[]} multiple
     */


    var modifyField = function modifyField(fieldPath, value) {
        var multiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);

        if (multiple.length) {
            multiple.forEach(function (item) {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex].packing, item.fieldPath, item.value);
            });
        } else {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex].packing, fieldPath, value);
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoOrder.cargo[cargoPackingIndex].packing.category !== 'unpacked') {
            var _getDefaultCargoReque = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque.pack;

            __WEBPACK_IMPORTED_MODULE_4__common__["a" /* NOT_RESET_FIELDS */].forEach(function (field) {
                metaPack[field] = cargoPacking.pack[field];
            });

            setDisableAll(true);
            modifyField('pack', metaPack);
        } else {
            setDisableAll(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var details = cargoOrder.cargo[cargoPackingIndex].details;

        var _getDefaultCargoReque2 = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
            metaPack = _getDefaultCargoReque2.pack;

        if (details === 1) {
            setStackableDisabled(true);
            modifyField('pack.stackable', metaPack.stackable);
        } else {
            setStackableDisabled(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].details]);

    var changeStackable = function changeStackable() {
        var newStackableValue = !cargoPacking.pack.stackable.value;

        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);

        newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable.value = newStackableValue;

        if (!newStackableValue) {
            var _getDefaultCargoReque3 = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque3.pack;

            newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable = metaPack.stackable;
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__["a" /* default */], {
            _key: 'unpacked',
            head: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* RadioElement */], {
                checkedValue: cargoPacking.category,
                value: 'unpacked',
                disabled: !canCheck,
                onCheck: function onCheck() {
                    return modifyField('category', 'unpacked');
                },
                label: 'unpacked',
                _key: 'unpacked'
            }),
            headStyle: { borderBottom: '1px solid #E0E0E0' },
            body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitsQuantity', disabledAll),
                            hintText: 'Number of units',
                            floatingLabelText: 'Number of units',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField(undefined, undefined, [{ fieldPath: 'pack.unitsQuantity', value: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value) }, { fieldPath: 'pack.bundlesQuantity', value: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value) }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitLength.value', disabledAll),
                            hintText: 'Max Length, mm',
                            floatingLabelText: 'Max Length, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.unitLength.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitBeam.value', disabledAll),
                            hintText: 'Max Beam, mm',
                            floatingLabelText: 'Max Beam, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.unitBeam.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitHeight.value', disabledAll),
                            hintText: 'Max Height, mm',
                            floatingLabelText: 'Max Height, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.unitHeight.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitWeight.value', disabledAll),
                            hintText: 'Unit Weight, mt',
                            floatingLabelText: 'Unit Weight, mt',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.unitWeight.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Stackable',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.value', disabledAll),
                            onCheck: changeStackable,
                            disabled: disabledAll || stackableDisabled,
                            style: {
                                marginTop: '28px'
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.tiers', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            hintText: 'Tiers',
                            floatingLabelText: 'Tiers',
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.stackable.tiers', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Inter-tier dunn...',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.dunnaging', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            onCheck: function onCheck() {
                                return modifyField('pack.stackable.dunnaging', !cargoPacking.pack.stackable.dunnaging);
                            },
                            style: {
                                marginTop: '28px'
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Nested',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.nested', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            onCheck: function onCheck() {
                                return modifyField('pack.stackable.nested', !cargoPacking.pack.stackable.nested);
                            },
                            style: {
                                marginTop: '28px'
                            }
                        })
                    )
                )
            )
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    var cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
    return {
        cargoOrder: cargoOrder,
        cargoPacking: cargoPacking
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Unpacked));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Unpacked, 'Unpacked', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Unpacked.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Unpacked.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_packingType__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();













function Packed(_ref) {
    var updateCargoOrder = _ref.updateCargoOrder,
        numberOrderTable = _ref.numberOrderTable,
        cargoPackingIndex = _ref.cargoPackingIndex,
        cargoOrder = _ref.cargoOrder,
        cargoPacking = _ref.cargoPacking,
        _ref$canCheck = _ref.canCheck,
        canCheck = _ref$canCheck === undefined ? false : _ref$canCheck;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        disabledAll = _useState2[0],
        setDisableAll = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoPacking.category !== 'packed') {
            var _getDefaultCargoReque = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque.pack;

            __WEBPACK_IMPORTED_MODULE_4__common__["a" /* NOT_RESET_FIELDS */].forEach(function (field) {
                metaPack[field] = cargoPacking.pack[field];
            });

            setDisableAll(true);
            modifyField('pack', metaPack);
        } else {
            setDisableAll(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    /**
     * 
     * @param {string} fieldPath field path 
     * @param {any} value 
     */
    var modifyField = function modifyField(fieldPath, value) {
        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex].packing, fieldPath, value);
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    var changeStackable = function changeStackable() {
        var newStackableValue = !cargoPacking.pack.stackable.value;

        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);

        newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable.value = newStackableValue;

        if (!newStackableValue) {
            var _getDefaultCargoReque2 = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque2.pack;

            newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable = metaPack.stackable;
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__["a" /* default */], {
            _key: 'packed',
            head: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* RadioElement */], {
                value: 'packed',
                checkedValue: cargoPacking.category,
                disabled: !canCheck,
                onCheck: function onCheck() {
                    return modifyField('category', 'packed');
                },
                label: 'packed',
                _key: 'packed'
            }),
            headStyle: { borderBottom: '1px solid #E0E0E0' },
            body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["s" /* SelectField */],
                            {
                                value: cargoPacking.pack.name || '',
                                hintText: 'Packing type',
                                floatingLabelText: 'Packing type',
                                disabled: disabledAll,
                                style: {
                                    width: '100%',
                                    fontSize: '13px',
                                    marginRight: '15px'
                                },
                                onChange: function onChange(_e, _i, v) {
                                    return modifyField('pack.name', v);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_8_constants_packingType__["a" /* PACKING_TYPES */].map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["m" /* MenuItem */], {
                                    key: item + '_' + index,
                                    value: item,
                                    primaryText: item
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.bundleLength.value', disabledAll),
                            hintText: 'Length, mm',
                            floatingLabelText: 'Length, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.bundleLength.value', __WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.bundleBeam.value', disabledAll),
                            hintText: 'Width, mm',
                            floatingLabelText: 'Width, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.bundleBeam.value', __WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.bundleHeight.value', disabledAll),
                            hintText: 'Height, mm',
                            floatingLabelText: 'Height, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.bundleHeight.value', __WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.bundlesQuantity', disabledAll),
                            hintText: 'Quantity',
                            floatingLabelText: 'Quantity',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.bundlesQuantity', __WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Stackable',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.value', disabledAll),
                            onCheck: changeStackable,
                            disabled: disabledAll,
                            style: {
                                marginTop: '28px'
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.tiers', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            hintText: 'Tiers',
                            floatingLabelText: 'Tiers',
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.stackable.tiers', __WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Inter-tier dunn...',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.dunnaging', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            onCheck: function onCheck() {
                                return modifyField('pack.stackable.dunnaging', !cargoPacking.pack.stackable.dunnaging);
                            },
                            style: {
                                marginTop: '28px'
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Nested',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.nested', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            onCheck: function onCheck() {
                                return modifyField('pack.stackable.nested', !cargoPacking.pack.stackable.nested);
                            },
                            style: {
                                marginTop: '28px'
                            }
                        })
                    )
                )
            )
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    var cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
    return {
        cargoOrder: cargoOrder,
        cargoPacking: cargoPacking
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Packed));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Packed, 'Packed', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Packed.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Packed.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PACKING_TYPES; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var PACKING_TYPES = [undefined, 'bundles', 'pallets', 'sling bags', 'bags', 'jumbo bags', 'big bags', 'boxes', 'containers', 'crates', 'cases', 'trays', 'bales', 'barrels', 'drums', 'rolls', 'coils', 'cages', 'packages'];
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PACKING_TYPES, 'PACKING_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/constants/packingType.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












function Loose(_ref) {
    var updateCargoOrder = _ref.updateCargoOrder,
        numberOrderTable = _ref.numberOrderTable,
        cargoPackingIndex = _ref.cargoPackingIndex,
        cargoOrder = _ref.cargoOrder,
        cargoPacking = _ref.cargoPacking,
        _ref$canCheck = _ref.canCheck,
        canCheck = _ref$canCheck === undefined ? false : _ref$canCheck;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        disabledAll = _useState2[0],
        setDisableAll = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoPacking.category !== 'loose') {
            var _getDefaultCargoReque = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque.pack;

            __WEBPACK_IMPORTED_MODULE_4__common__["a" /* NOT_RESET_FIELDS */].forEach(function (field) {
                metaPack[field] = cargoPacking.pack[field];
            });

            setDisableAll(true);
            modifyField('pack', metaPack);
        } else {
            setDisableAll(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    /**
     * r
     * @param {string} fieldPath field path 
     * @param {any} value 
     */
    var modifyField = function modifyField(fieldPath, value) {
        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex].packing, fieldPath, value);
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    var changeStackable = function changeStackable() {
        var newStackableValue = !cargoPacking.pack.stackable.value;

        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);

        newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable.value = newStackableValue;

        if (!newStackableValue) {
            var _getDefaultCargoReque2 = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque2.pack;

            newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable = metaPack.stackable;
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__["a" /* default */], {
            _key: 'loose',
            head: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* RadioElement */], {
                value: 'loose',
                checkedValue: cargoPacking.category,
                disabled: !canCheck,
                onCheck: function onCheck() {
                    return modifyField('category', 'loose');
                },
                label: 'loose',
                _key: 'loose'
            }),
            headStyle: { borderBottom: '1px solid #E0E0E0' },
            body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.maxUnitLength.value', disabledAll),
                            hintText: 'Length, mm',
                            floatingLabelText: 'Length, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.maxUnitLength.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.maxUnitWidth.value', disabledAll),
                            hintText: 'Max Width, mm',
                            floatingLabelText: 'Max Width, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.maxUnitWidth.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitHeight.value', disabledAll),
                            hintText: 'Unit Height, mm',
                            floatingLabelText: 'Unit Height, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.unitHeight.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitDiam.value', disabledAll),
                            hintText: 'Max Diameter, mm',
                            floatingLabelText: 'Max Diameter, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.unitDiam.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitWeight.value', disabledAll),
                            hintText: 'Unit Weight, mt',
                            floatingLabelText: 'Unit Weight, mt',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.unitWeight.value', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Stackable',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.value', disabledAll),
                            onCheck: changeStackable,
                            disabled: disabledAll,
                            style: {
                                marginTop: '28px'
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.tiers', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            hintText: 'Tiers',
                            floatingLabelText: 'Tiers',
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyField('pack.stackable.tiers', __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].clearLetters(e.target.value));
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Inter-tier dunn...',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.dunnaging', disabledAll),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            onCheck: function onCheck() {
                                return modifyField('pack.stackable.dunnaging', !cargoPacking.pack.stackable.dunnaging);
                            },
                            style: {
                                marginTop: '28px'
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: 'Nested',
                            checked: !!Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.stackable.nested', disabledAll, false),
                            disabled: !cargoPacking.pack.stackable.value || disabledAll,
                            onCheck: function onCheck() {
                                return modifyField('pack.stackable.nested', !cargoPacking.pack.stackable.nested);
                            },
                            style: {
                                marginTop: '28px'
                            }
                        })
                    )
                )
            )
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    var cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
    return {
        cargoOrder: cargoOrder,
        cargoPacking: cargoPacking
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Loose));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Loose, 'Loose', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Loose.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Loose.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_CollapseCustomizable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tank__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_validateFields__ = __webpack_require__(852);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












function WetBulk(_ref) {
    var updateCargoOrder = _ref.updateCargoOrder,
        numberOrderTable = _ref.numberOrderTable,
        cargoPackingIndex = _ref.cargoPackingIndex,
        cargoOrder = _ref.cargoOrder,
        cargoPacking = _ref.cargoPacking,
        _ref$canCheck = _ref.canCheck,
        canCheck = _ref$canCheck === undefined ? false : _ref$canCheck,
        errors = _ref.errors;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        disabledAll = _useState2[0],
        setDisableAll = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoPacking.category !== 'wetBulk') {
            var _getDefaultCargoReque = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque.pack;

            __WEBPACK_IMPORTED_MODULE_4__common__["a" /* NOT_RESET_FIELDS */].forEach(function (field) {
                metaPack[field] = cargoPacking.pack[field];
            });

            Object.values(__WEBPACK_IMPORTED_MODULE_8_constants_validateFields__["a" /* fieldsMap */]).forEach(function (_ref2) {
                var max = _ref2.max;

                cargoOrder.validateErrors = cargoOrder.validateErrors.filter(function (obj) {
                    return obj.field !== 'packing.pack.' + max;
                });
            });

            setDisableAll(true);
            modifyFields([{ field: 'packing.pack', value: metaPack }, { field: 'validateErrors', value: cargoOrder.validateErrors }]);
        } else {
            setDisableAll(false);
        }
    }, [cargoPacking.category]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!cargoPacking.pack.flammable) {
            modifyFields([{ field: 'packing.pack.flashPointMin', value: undefined }]);
        }
    }, [cargoPacking.pack.flammable]);

    /**
     * 
     * @param {{ field: string, value: any }[]} changes
     */
    var modifyFields = function modifyFields(changes) {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);

        changes.forEach(function (_ref3) {
            var field = _ref3.field,
                value = _ref3.value;

            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex], field, value);

            var fieldToValidate = Object(__WEBPACK_IMPORTED_MODULE_8_constants_validateFields__["b" /* getValidateFields */])(field);

            if (fieldToValidate) {
                var min = fieldToValidate.min,
                    max = fieldToValidate.max;


                if (!newCargoOrder.cargo[cargoPackingIndex].packing.pack[max]) {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'packing.pack.' + max;
                    });
                } else if (+newCargoOrder.cargo[cargoPackingIndex].packing.pack[min] > +(newCargoOrder.cargo[cargoPackingIndex].packing.pack[max] || 0)) {
                    newCargoOrder.validateErrors.push({
                        field: 'packing.pack.' + max,
                        messages: ['Min is greater than max']
                    });
                } else {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'packing.pack.' + max;
                    });
                }
            }
        });

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_common_CollapseCustomizable__["a" /* default */], {
            _key: 'wetBulk',
            head: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* RadioElement */], {
                value: 'wetBulk',
                checkedValue: cargoPacking.category,
                disabled: !canCheck,
                onCheck: function onCheck() {
                    return modifyFields([{ field: 'packing.category', value: 'wetBulk' }]);
                },
                label: 'wetBulk',
                _key: 'wetBulk'
            }),
            headStyle: { borderBottom: '1px solid #E0E0E0' },
            body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Tank__["a" /* default */], {
                category: 'wetBulk',
                cargoPacking: cargoPacking,
                disabledAll: disabledAll,
                modifyFields: modifyFields,
                errors: errors
            })
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    var cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;

    var errors = {
        pourPointMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.pourPointMax';
        }),
        boilingPointMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.boilingPointMax';
        }),
        meltingPointMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.meltingPointMax';
        }),

        voyageHeatMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.voyageHeatMax';
        }),
        loadingHeatMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.loadingHeatMax';
        }),
        dischargeHeatMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.dischargeHeatMax';
        })
    };

    return {
        cargoOrder: cargoOrder,
        cargoPacking: cargoPacking,
        errors: errors
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(WetBulk));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(WetBulk, 'WetBulk', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/WetBulk.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/WetBulk.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tank__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__General__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_validateFields__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_cargoes_names__ = __webpack_require__(676);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
















function Container(_ref) {
    var _this = this;

    var updateCargoOrder = _ref.updateCargoOrder,
        numberOrderTable = _ref.numberOrderTable,
        cargoPackingIndex = _ref.cargoPackingIndex,
        cargoOrder = _ref.cargoOrder,
        cargoPacking = _ref.cargoPacking,
        _ref$canCheck = _ref.canCheck,
        canCheck = _ref$canCheck === undefined ? false : _ref$canCheck,
        cargoContainerDetails = _ref.cargoContainerDetails,
        errors = _ref.errors,
        containerParentId = _ref.containerParentId;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        disabledAll = _useState2[0],
        setDisableAll = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isTank = _useState4[0],
        setIsTank = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isGeneral = _useState6[0],
        setIsGenaral = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState8 = _slicedToArray(_useState7, 2),
        containerTypes = _useState8[0],
        setContainerTypes = _useState8[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoPacking.category !== 'container') {
            var _getDefaultCargoReque = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('packing'),
                metaPack = _getDefaultCargoReque.pack;

            var details = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('containerDetails');

            __WEBPACK_IMPORTED_MODULE_4__common__["a" /* NOT_RESET_FIELDS */].forEach(function (field) {
                metaPack[field] = cargoPacking.pack[field];
            });

            Object.values(__WEBPACK_IMPORTED_MODULE_10_constants_validateFields__["a" /* fieldsMap */]).forEach(function (_ref2) {
                var max = _ref2.max;

                cargoOrder.validateErrors = cargoOrder.validateErrors.filter(function (obj) {
                    return obj.field !== 'packing.pack.' + max;
                });
            });

            setDisableAll(true);
            setIsTank(false);
            setIsGenaral(false);
            modifyFields([{ field: 'packing.pack', value: metaPack }, { field: 'containerDetails', value: details }, { field: 'validateErrors', value: cargoOrder.validateErrors }]);
        } else {
            setDisableAll(false);
        }
    }, [cargoPacking.category]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var getContainerTypes = function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _ref4, data;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_12_services_cargoes_names__["a" /* getCargoByNameOrType */])({ name: 'Container', type: containerParentId });

                            case 2:
                                _ref4 = _context.sent;
                                data = _ref4.data;


                                setContainerTypes(data.map(function (i) {
                                    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pick(i, ['_id', 'name']);
                                }));

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function getContainerTypes() {
                return _ref3.apply(this, arguments);
            };
        }();

        getContainerTypes();
    }, []);

    /**
     * @param {{ field: string, value: any }[]} changes 
     */
    var modifyFields = function modifyFields(changes) {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(cargoOrder);

        changes.forEach(function (_ref5) {
            var field = _ref5.field,
                value = _ref5.value;

            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(newCargoOrder.cargo[cargoPackingIndex], field, value);

            var fieldToValidate = Object(__WEBPACK_IMPORTED_MODULE_10_constants_validateFields__["b" /* getValidateFields */])(field);

            if (fieldToValidate) {
                var min = fieldToValidate.min,
                    max = fieldToValidate.max;


                if (!newCargoOrder.cargo[cargoPackingIndex].packing.pack[max]) {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'packing.pack.' + max;
                    });
                } else if (+newCargoOrder.cargo[cargoPackingIndex].packing.pack[min] > +(newCargoOrder.cargo[cargoPackingIndex].packing.pack[max] || 0)) {
                    newCargoOrder.validateErrors.push({
                        field: 'packing.pack.' + max,
                        messages: ['Min is greater than max']
                    });
                } else {
                    newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(function (obj) {
                        return obj.field !== 'packing.pack.' + max;
                    });
                }
            }
        });

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    /**
     * @param {'general' | 'tank'} type 
     */
    var changeMode = function changeMode(type) {
        var metaDensity = Object(__WEBPACK_IMPORTED_MODULE_4__common__["f" /* getDefaultCargoRequestValue */])('density');

        var dropAllTankFields = [{ field: 'packing.pack.densities', value: [metaDensity] }, { field: 'packing.pack.pourPointMin', value: undefined }, { field: 'packing.pack.pourPointMax', value: undefined }, { field: 'packing.pack.boilingPointMin', value: undefined }, { field: 'packing.pack.boilingPointMax', value: undefined }, { field: 'packing.pack.meltingPointMin', value: undefined }, { field: 'packing.pack.meltingPointMax', value: undefined }, { field: 'packing.pack.flammable', value: false }, { field: 'packing.pack.flashPointMin', value: undefined }, { field: 'packing.pack.voyageHeatMin', value: undefined }, { field: 'packing.pack.voyageHeatMax', value: undefined }, { field: 'packing.pack.loadingHeatMin', value: undefined }, { field: 'packing.pack.loadingHeatMax', value: undefined }, { field: 'packing.pack.dischargeHeatMin', value: undefined }, { field: 'packing.pack.dischargeHeatMax', value: undefined }, { field: 'packing.pack.maxAdjacentHeat', value: undefined }];

        var dropAllGeneralFields = [{
            field: 'packing.pack.temperatureMin',
            value: cargoPacking.pack.temperatureMin
        }, {
            field: 'packing.pack.temperatureMax',
            value: cargoPacking.pack.temperatureMax
        }, {
            field: 'packing.pack.moistureMin',
            value: cargoPacking.pack.moistureMin
        }, {
            field: 'packing.pack.moistureMax',
            value: cargoPacking.pack.moistureMax
        }];

        if (type === 'general') {
            setIsGenaral(!isGeneral);
            setIsTank(false);
            modifyFields([].concat(dropAllTankFields, _toConsumableArray(!isGeneral ? dropAllGeneralFields : [])));
        } else {
            setIsTank(!isTank);
            setIsGenaral(false);
            modifyFields([].concat(dropAllGeneralFields, _toConsumableArray(!isTank ? dropAllTankFields : [])));
        }
    };

    var errorProps = {};

    if (!disabledAll) {
        errorProps.errorText = !cargoContainerDetails.kind;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_common_CollapseCustomizable__["a" /* default */], {
            _key: 'container',
            head: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common__["c" /* RadioElement */], {
                value: 'container',
                checkedValue: cargoPacking.category,
                disabled: !canCheck,
                onCheck: function onCheck() {
                    return modifyFields([{ field: 'packing.category', value: 'container' }]);
                },
                label: 'container',
                _key: 'container'
            }),
            headStyle: { borderBottom: '1px solid #E0E0E0' },
            body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["s" /* SelectField */],
                            {
                                value: cargoContainerDetails.kind || '',
                                hintText: 'Type of Container*',
                                floatingLabelText: 'Type of Container*',
                                disabled: disabledAll,
                                underlineStyle: !disabledAll && !cargoContainerDetails.kind ? { borderColor: 'red' } : {},
                                style: {
                                    width: '100%',
                                    fontSize: '13px',
                                    marginRight: '15px'
                                },
                                onChange: function onChange(_e, _i, value) {
                                    modifyFields([{ field: 'containerDetails.kind', value: value }]);
                                }
                            },
                            containerTypes.map(function (item) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["m" /* MenuItem */], {
                                    key: item._id,
                                    value: item._id,
                                    primaryText: item.name
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoPacking.pack.bundlesQuantity || '',
                            hintText: 'Quantity*',
                            floatingLabelText: 'Quantity*',
                            underlineStyle: !disabledAll && !cargoPacking.pack.bundlesQuantity ? { borderColor: 'red' } : {},
                            disabled: !cargoContainerDetails.kind || disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.bundlesQuantity',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.unitWeight.value', disabledAll),
                            hintText: 'Unit Weight, mt',
                            floatingLabelText: 'Unit Weight, mt',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.unitWeight.value',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoContainerDetails.ownNum || '',
                            hintText: 'Container No',
                            floatingLabelText: 'Container No',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'containerDetails.ownNum',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoContainerDetails.seal || '',
                            hintText: 'Seal',
                            floatingLabelText: 'Seal',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'containerDetails.seal',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["s" /* SelectField */],
                            {
                                value: cargoContainerDetails.owner || 'shipper',
                                hintText: 'Owner',
                                floatingLabelText: 'Owner',
                                disabled: disabledAll,
                                style: {
                                    width: '100%',
                                    fontSize: '13px',
                                    marginRight: '15px'
                                },
                                onChange: function onChange(_e, _i, value) {
                                    modifyFields([{
                                        field: 'containerDetails.owner',
                                        value: value
                                    }]);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_4__common__["b" /* OWNER_TYPES */].map(function (ownerType) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["m" /* MenuItem */], {
                                    key: ownerType.name,
                                    value: ownerType.name,
                                    primaryText: ownerType.value
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: 'col-xs-3',
                            style: { height: '48px', display: 'flex', alignItems: 'center' }
                        },
                        'CARGO'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: 'col-xs-3',
                            style: {
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'row-reverse'
                            }
                        },
                        'MODE'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: 'col-xs-3',
                            style: { height: '48px', display: 'flex', alignItems: 'center' }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: '\xB0C mode (General)',
                            checked: isGeneral,
                            disabled: disabledAll,
                            labelStyle: { width: '100%' },
                            onCheck: function onCheck() {
                                return changeMode('general');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: 'col-xs-3',
                            style: { height: '48px', display: 'flex', alignItems: 'center' }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                            label: '\xB0C mode (Tank)',
                            checked: isTank,
                            disabled: disabledAll,
                            onCheck: function onCheck() {
                                return changeMode('tank');
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoContainerDetails.stc || '',
                            hintText: 'STC',
                            floatingLabelText: 'STC',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'containerDetails.stc',
                                    value: e.target.value
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoPacking.pack.netWeight.value || '',
                            hintText: 'Total net weight, mt',
                            floatingLabelText: 'Total net weight, mt',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.netWeight.value',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoPacking.pack.maxUnitLength.value || '',
                            hintText: 'Max Length, mm',
                            floatingLabelText: 'Max Length, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.maxUnitLength.value',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoPacking.pack.bundleBeam.value || '',
                            hintText: 'Max Beam, mm',
                            floatingLabelText: 'Max Beam, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.bundleBeam.value',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoPacking.pack.bundleHeight.value || '',
                            hintText: 'Max Height, mm',
                            floatingLabelText: 'Max Height, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.bundleHeight.value',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: cargoPacking.pack.unitDiam.value || '',
                            hintText: 'Max Diameter, mm',
                            floatingLabelText: 'Max Diameter, mm',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.unitDiam.value',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'row',
                        style: { width: '100%', height: '92px' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.numberOfHeadsMin', disabledAll),
                            hintText: 'Number of heads (min)',
                            floatingLabelText: 'Number of heads (min)',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.numberOfHeadsMin',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3_flex' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.numberOfHeadsMax', disabledAll),
                            errorText: errors.numberOfHeadsMax && errors.numberOfHeadsMax.messages[0],
                            hintText: 'Number of heads (max)',
                            floatingLabelText: 'Number of heads (max)',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '0px 5px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.numberOfHeadsMax',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                            value: Object(__WEBPACK_IMPORTED_MODULE_4__common__["e" /* displayValue */])(cargoPacking, 'pack.weightPerHead', disabledAll),
                            hintText: 'Weight mt per head',
                            floatingLabelText: 'Weight mt per head',
                            disabled: disabledAll,
                            style: {
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px'
                            },
                            onChange: function onChange(e) {
                                return modifyFields([{
                                    field: 'packing.pack.weightPerHead',
                                    value: __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].clearLetters(e.target.value)
                                }]);
                            }
                        })
                    )
                ),
                isGeneral ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__General__["a" /* default */], {
                    cargoPacking: cargoPacking,
                    disabledAll: disabledAll,
                    modifyFields: modifyFields,
                    errors: errors
                }) : null,
                isTank ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Tank__["a" /* default */], {
                    cargoPacking: cargoPacking,
                    category: 'container',
                    disabledAll: disabledAll,
                    modifyFields: modifyFields,
                    errors: errors
                }) : null
            )
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
    var cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
    var cargoContainerDetails = cargoOrder.cargo[ownProps.cargoPackingIndex].containerDetails || {};

    var containerParentId = state.cargoesNames.items.find(function (n) {
        return n.parent.red.name === 'Containers';
    }).parent.red._id;

    var errors = {
        pourPointMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.pourPointMax';
        }),
        boilingPointMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.boilingPointMax';
        }),
        meltingPointMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.meltingPointMax';
        }),

        voyageHeatMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.voyageHeatMax';
        }),
        loadingHeatMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.loadingHeatMax';
        }),
        dischargeHeatMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.dischargeHeatMax';
        }),
        numberOfHeadsMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.numberOfHeadsMax';
        }),

        temperatureMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.temperatureMax';
        }),
        moistureMax: cargoOrder.validateErrors.find(function (validateError) {
            return validateError.field === 'packing.pack.moistureMax';
        })
    };

    return {
        cargoOrder: cargoOrder,
        cargoPacking: cargoPacking,
        cargoContainerDetails: cargoContainerDetails,
        errors: errors,
        containerParentId: containerParentId
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(Container));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Container, 'Container', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Container.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Container.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = General;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function General(_ref) {
    var cargoPacking = _ref.cargoPacking,
        disabledAll = _ref.disabledAll,
        modifyFields = _ref.modifyFields,
        errors = _ref.errors;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(errors),
        _useState2 = _slicedToArray(_useState, 2),
        _errors = _useState2[0],
        set_errors = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        set_errors(errors);
    }, [errors]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            {
                className: 'row',
                style: { width: '100%', height: '92px' }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* displayValue */])(cargoPacking, 'pack.temperatureMin', disabledAll),
                    hintText: 'Temperature min, \xB0C',
                    floatingLabelText: 'Temperature min, \xB0C',
                    disabled: disabledAll,
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields([{
                            field: 'packing.pack.temperatureMin',
                            value: __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].clearLetters(e.target.value)
                        }]);
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* displayValue */])(cargoPacking, 'pack.temperatureMax', disabledAll),
                    errorText: _errors.temperatureMax && _errors.temperatureMax.messages[0],
                    hintText: 'Temperature max, \xB0C',
                    floatingLabelText: 'Temperature max, \xB0C',
                    disabled: disabledAll,
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields([{
                            field: 'packing.pack.temperatureMax',
                            value: __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].clearLetters(e.target.value)
                        }]);
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* displayValue */])(cargoPacking, 'pack.moistureMin', disabledAll),
                    hintText: 'Moisture min, %',
                    floatingLabelText: 'Moisture min, %',
                    disabled: disabledAll,
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '15px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields([{
                            field: 'packing.pack.moistureMin',
                            value: __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].clearLetters(e.target.value)
                        }]);
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-3_flex' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                    value: Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* displayValue */])(cargoPacking, 'pack.moistureMax', disabledAll),
                    errorText: _errors.moistureMax && _errors.moistureMax.messages[0],
                    hintText: 'Moisture max, %',
                    floatingLabelText: 'Moisture max, %',
                    disabled: disabledAll,
                    style: {
                        width: '100%',
                        fontSize: '13px',
                        marginRight: '0px 5px'
                    },
                    onChange: function onChange(e) {
                        return modifyFields([{
                            field: 'packing.pack.moistureMax',
                            value: __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].clearLetters(e.target.value)
                        }]);
                    }
                })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(General, 'General', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/General.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TotalValuesVolWei = function (_React$Component) {
    _inherits(TotalValuesVolWei, _React$Component);

    function TotalValuesVolWei(props) {
        _classCallCheck(this, TotalValuesVolWei);

        var _this = _possibleConstructorReturn(this, (TotalValuesVolWei.__proto__ || Object.getPrototypeOf(TotalValuesVolWei)).call(this, props));

        _this.onToggleFreeze = _this.onToggleFreeze.bind(_this);
        _this.onChangeQuantity = _this.onChangeQuantity.bind(_this);
        return _this;
    }

    _createClass(TotalValuesVolWei, [{
        key: 'onToggleFreeze',
        value: function onToggleFreeze() {
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);
            var totalValues = newCargoOrder.totalValues;

            newCargoOrder.totalValues.isCalc = !totalValues.isCalc;
            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'onChangeQuantity',
        value: function onChangeQuantity(e, type) {
            var value = parseInt(__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* default */].clearLetters(e.target.value));
            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrder);

            newCargoOrder.totalValues = _extends({}, newCargoOrder.totalValues, _defineProperty({}, type, ['weight', 'weightWithPercent'].includes(type) ? value * 1000 : value));

            this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$cargoOrder$tot = this.props.cargoOrder.totalValues,
                isCalc = _props$cargoOrder$tot.isCalc,
                weight = _props$cargoOrder$tot.weight,
                weightWithPercent = _props$cargoOrder$tot.weightWithPercent,
                volume = _props$cargoOrder$tot.volume,
                volumeWithPercent = _props$cargoOrder$tot.volumeWithPercent;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left', style: { fontSize: '13px' } },
                        'Total Values (weight/volume):'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle___default.a, {
                            label: 'Freeze',
                            style: { width: '50%', fontSize: '14px' },
                            toggled: !isCalc || false,
                            onToggle: function onToggle() {
                                return _this2.onToggleFreeze();
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            value: weight && weight / 1000 || '',
                            style: { width: '50%', fontSize: '14px' },
                            floatingLabelText: 'Weight, mt',
                            onChange: function onChange(e) {
                                _this2.onChangeQuantity(e, 'weight');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            value: weightWithPercent && weightWithPercent / 1000 || '',
                            style: { width: '50%', fontSize: '14px' },
                            floatingLabelText: 'Weight+%, mt',
                            onChange: function onChange(e) {
                                _this2.onChangeQuantity(e, 'weightWithPercent');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'one-third' }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            value: volume || '',
                            style: { width: '50%', fontSize: '14px' },
                            floatingLabelText: 'Volume, m3',
                            onChange: function onChange(e) {
                                _this2.onChangeQuantity(e, 'volume');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'one-third' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            value: volumeWithPercent || '',
                            style: { width: '50%', fontSize: '14px' },
                            floatingLabelText: 'Volume+%, m3',
                            onChange: function onChange(e) {
                                _this2.onChangeQuantity(e, 'volumeWithPercent');
                            }
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TotalValuesVolWei;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

    return {
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: cargoOrder
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(TotalValuesVolWei);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TotalValuesVolWei, 'TotalValuesVolWei', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/TotalValuesVolWei.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/TotalValuesVolWei.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_react_utils__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_realCompanies__ = __webpack_require__(520);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var accountsConfig = {
    text: 'name',
    value: '_id'
};

function loadCompanies(search, withRealCompanies) {
    if (search.length < 2) {
        return [];
    }
    return __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].findCompany(search, withRealCompanies).then(function (response) {
        return response.data.data;
    }).catch(function (err) {
        console.error(err);
        return null;
    });
}

function AccountName(_ref) {
    var _this = this;

    var updateCargoOrder = _ref.updateCargoOrder,
        cargoOrder = _ref.cargoOrder,
        numberOrderTable = _ref.numberOrderTable,
        context = _ref.context;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        accounts = _useState2[0],
        setAccounts = _useState2[1];

    var _useRefState = Object(__WEBPACK_IMPORTED_MODULE_7_helpers_react_utils__["a" /* useRefState */])(''),
        _useRefState2 = _slicedToArray(_useRefState, 3),
        search = _useRefState2[0],
        setSearch = _useRefState2[1],
        searchRef = _useRefState2[2];

    var onChangeAutoCompleteAccount = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var newCargoOrder, withRealCompanies, companies;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setSearch(e);

                            newCargoOrder = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(cargoOrder);

                            newCargoOrder.account = {
                                _id: undefined,
                                name: e
                            };
                            updateCargoOrder(numberOrderTable, newCargoOrder);

                            withRealCompanies = Object(__WEBPACK_IMPORTED_MODULE_8_helpers_realCompanies__["a" /* calculateIsIfchorBroker */])(context.userId.email);
                            _context.next = 7;
                            return loadCompanies(e, withRealCompanies);

                        case 7:
                            companies = _context.sent;

                            if (!(searchRef.current !== e)) {
                                _context.next = 10;
                                break;
                            }

                            return _context.abrupt('return');

                        case 10:

                            setAccounts(companies);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function onChangeAutoCompleteAccount(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var onChooseAutoCompleteAccount = function onChooseAutoCompleteAccount(e) {
        var newCargoOrder = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(cargoOrder);
        newCargoOrder.account = e;
        updateCargoOrder(numberOrderTable, newCargoOrder);
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-left' },
            'Account name:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'column-right' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */], {
                name: 'accountNameCargo',
                floatingLabelText: 'Account Name',
                textFieldStyle: { fontSize: '13px' },
                hintText: 'Account',
                searchText: search || cargoOrder.account && cargoOrder.account.name || '',
                dataSource: accounts,
                onUpdateInput: onChangeAutoCompleteAccount,
                onNewRequest: onChooseAutoCompleteAccount,
                dataSourceConfig: accountsConfig,
                filter: __WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */].noFilter,
                listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                menuStyle: { width: 'auto' },
                popoverProps: {
                    canAutoPosition: true
                },
                fullWidth: true
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        context: state.letter.context,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(AccountName);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(accountsConfig, 'accountsConfig', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/AccountName.jsx');
    reactHotLoader.register(loadCompanies, 'loadCompanies', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/AccountName.jsx');
    reactHotLoader.register(AccountName, 'AccountName', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/AccountName.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Sidebar/Order/AccountName.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formConfigUtils; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var formConfigUtils = {
    validateNum: function validateNum(_ref) {
        var value = _ref.value,
            min = _ref.min,
            max = _ref.max;

        if (value !== null && value !== undefined && (min !== undefined && value < min || max !== undefined && value > max)) {
            return min + ' - ' + max;
        }
        return null;
    },


    validateMin: function validateMin(_ref2) {
        var maxFieldName = _ref2.maxFieldName,
            min = _ref2.min,
            max = _ref2.max;
        return function (value, values) {
            var otherValue = values[maxFieldName];

            if (value !== null && value !== undefined && otherValue !== null && otherValue !== undefined) {
                if (value > otherValue) {
                    return 'Min is greater than max';
                } else if (value >= otherValue && !formConfigUtils.validateNum({ value: otherValue, min: min, max: max })) {
                    return { clearErrorFor: maxFieldName };
                }
            }

            return formConfigUtils.validateNum({ value: value, min: min, max: max });
        };
    },

    validateMax: function validateMax(_ref3) {
        var minFieldName = _ref3.minFieldName,
            min = _ref3.min,
            max = _ref3.max;
        return function (value, values) {
            var otherValue = values[minFieldName];

            if (value !== null && value !== undefined && otherValue !== null && otherValue !== undefined) {
                if (value < otherValue) {
                    return 'Max is less than min';
                } else if (value >= otherValue && !formConfigUtils.validateNum({ value: otherValue, min: min, max: max })) {
                    return { clearErrorFor: minFieldName };
                }
            }

            return formConfigUtils.validateNum({ value: value, min: min, max: max });
        };
    }
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(formConfigUtils, 'formConfigUtils', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/formConfig.utils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = FormCheckbox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var styles = {
    checkbox: {
        marginTop: '30px'
    }
};

function FormCheckbox(_ref) {
    var name = _ref.name,
        rest = _objectWithoutProperties(_ref, ['name']);

    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var conf = form.config[name] || {};
    var value = form.values[name];

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["b" /* Checkbox */], _extends({
        label: conf.label,
        checked: value,
        onCheck: function onCheck(e) {
            return form.onChange({ field: name, value: e.target.checked });
        },
        style: styles.checkbox
    }, rest));
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormCheckbox.jsx');
    reactHotLoader.register(FormCheckbox, 'FormCheckbox', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormCheckbox.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = FormSelectFlags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Vessels_Single_Rows_Flag__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var styles = {
    checkbox: {
        marginTop: '30px'
    },
    add: {
        marginTop: '25px',
        display: 'flex',
        justifyContent: 'center'
    },
    chips: {
        margin: '8px 8px 0 0'
    }
};

function FormSelectFlags() {
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),
        _useState2 = _slicedToArray(_useState, 2),
        flag = _useState2[0],
        setFlag = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        excluded = _useState4[0],
        setExcluded = _useState4[1];

    var _form$values$flags = form.values.flags,
        flags = _form$values$flags === undefined ? [] : _form$values$flags;


    var addFlag = function addFlag() {
        if (!flag._id) return flags;

        var newFlags = flags;
        var exists = flags.some(function (x) {
            return x.flag._id === flag._id;
        });
        if (!exists) {
            var newFlag = { flag: flag, excluded: excluded };
            newFlags = [].concat(_toConsumableArray(flags), [newFlag]);
            form.onChange({ field: 'flags', value: newFlags });
        }
        setFlag({});
        setExcluded(false);
        return newFlags;
    };

    // captureSaveHandler doesn't work correctly otherwise
    var addFlagRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();
    addFlagRef.current = addFlag;

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        form.addSaveHandler(function (values) {
            values.flags = addFlagRef.current();
        });
    }, []);

    var deleteFlag = function deleteFlag(index) {
        form.onChange({ field: 'flags', value: flags.filter(function (_, i) {
                return i !== index;
            }) });
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-8' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Vessels_Single_Rows_Flag__["a" /* default */], {
                    changeAutoComplete: function changeAutoComplete(_, data) {
                        return setFlag(data);
                    },
                    flagObject: flag
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-2', style: styles.checkbox },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["b" /* Checkbox */], {
                    label: 'Excluded',
                    checked: excluded,
                    onCheck: function onCheck() {
                        return setExcluded(!excluded);
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'col-xs-2', style: styles.add },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_add_circle_outline___default.a, {
                        onClick: addFlag,
                        color: 'green'
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                {
                    className: 'col-xs-12',
                    style: {
                        display: 'flex',
                        flexFlow: 'wrap'
                    }
                },
                flags && flags.map(function (f, index) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
                        {
                            key: index,
                            onRequestDelete: function onRequestDelete() {
                                return deleteFlag(index);
                            },
                            style: _extends({}, styles.chips, {
                                backgroundColor: f.excluded ? '#e6e6e6' : '#d6edbd'
                            })
                        },
                        f.excluded && '- ',
                        f.flag.name
                    );
                })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormSelectFlags.jsx');
    reactHotLoader.register(FormSelectFlags, 'FormSelectFlags', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormSelectFlags.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export useInitialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = FormGears;
/* harmony export (immutable) */ __webpack_exports__["b"] = FormGrabs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Vessels_Single_Rows_GearV2__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Vessels_Single_Rows_GrabV2__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Vessels_Single_Rows_GearedGrabbed__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Letters_SingleNew_Cargo_Sidebar_Order_VesselRequirements__ = __webpack_require__(530);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var useInitialState = function useInitialState() {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__Letters_SingleNew_Cargo_Sidebar_Order_VesselRequirements__["a" /* InitialVesselRequirementsContext */]);
};

var defaultGearV2 = {
    summary: [{
        type: null,
        quantity: null,
        capacity: null,
        outreach: null,
        maxSWL: null,
        combinable: false
    }]
};

var defaultGrabV2 = {
    summary: [{
        type: null,
        quantity: null,
        volume: null
    }]
};

function FormGears() {
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var initialState = useInitialState();

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(FormGearsOrGrabs, {
        title: 'GEAR:',
        isSetName: 'geared',
        onChangeIsSet: function onChangeIsSet(value) {
            return form.onChange([{ field: 'geared', value: value }, !value && { field: 'grabbed', value: value }, !value && { field: 'gearV2', value: defaultGearV2 }, !value && { field: 'grabV2', value: defaultGrabV2 }]);
        },
        name: 'gearV2',
        defaultValue: initialState.gearV2 || defaultGearV2,
        render: function render(_ref) {
            var value = _ref.value,
                onChange = _ref.onChange;
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Vessels_Single_Rows_GearV2__["a" /* default */], { gearV2: value, changeField: onChange, fromTc: true });
        }
    });
}

function FormGrabs() {
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var initialState = useInitialState();
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(FormGearsOrGrabs, {
        title: 'GRABS:',
        isSetName: 'grabbed',
        onChangeIsSet: function onChangeIsSet(value) {
            return form.onChange([{ field: 'grabbed', value: value }, !value && { field: 'grabV2', value: defaultGrabV2 }]);
        },
        name: 'grabV2',
        defaultValue: initialState.grabV2 || defaultGrabV2,
        render: function render(_ref2) {
            var value = _ref2.value,
                onChange = _ref2.onChange;
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Vessels_Single_Rows_GrabV2__["a" /* default */], { grabs: value, changeField: onChange, fromTc: true });
        }
    });
}

var styles = {
    underlineStyle: {
        borderColor: __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors__["orange500"]
    }
};

function FormGearsOrGrabs(_ref3) {
    var title = _ref3.title,
        isSetName = _ref3.isSetName,
        onChangeIsSet = _ref3.onChangeIsSet,
        name = _ref3.name,
        defaultValue = _ref3.defaultValue,
        render = _ref3.render;

    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('hr', { style: { opacity: '0.2', marginTop: '20px' } }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'row', style: { height: '60px' } },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: 'col-xs-1' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'span',
                    { className: 'name-block static huge-name' },
                    title
                )
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 col-xs-offset-8' },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Vessels_Single_Rows_GearedGrabbed__["a" /* default */], {
                    confirmed: true,
                    modifiedFields: null,
                    fieldName: isSetName,
                    gearedGrabbed: form.values[isSetName],
                    onChange: onChangeIsSet,
                    styles: styles
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                { className: 'col-xs-12' },
                render({
                    value: form.values[name] || defaultValue,
                    onChange: function onChange(changes) {
                        (Array.isArray(changes) ? changes : [changes]).forEach(function (change) {
                            var fieldMatch = change.field.match(/\w+/);
                            if (!fieldMatch) return;

                            var field = fieldMatch[0];
                            var value = form.values[field] || defaultValue;
                            var newValue = void 0;

                            var match = change.field.match(/\[(\d+)\]\.(\w+)/);
                            if (match) {
                                var index = +match[1];
                                var prop = match[2];
                                newValue = _extends({}, value, {
                                    summary: value.summary.map(function (item, i) {
                                        return i === index ? _extends({}, item, _defineProperty({}, prop, change.value)) : item;
                                    })
                                });
                            } else {
                                newValue = change.value;
                            }

                            form.onChange({
                                field: field,
                                value: newValue
                            });
                        });
                    }
                })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(useInitialState, 'useInitialState', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormGearsAndGrabs.jsx');
    reactHotLoader.register(defaultGearV2, 'defaultGearV2', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormGearsAndGrabs.jsx');
    reactHotLoader.register(defaultGrabV2, 'defaultGrabV2', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormGearsAndGrabs.jsx');
    reactHotLoader.register(FormGears, 'FormGears', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormGearsAndGrabs.jsx');
    reactHotLoader.register(FormGrabs, 'FormGrabs', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormGearsAndGrabs.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormGearsAndGrabs.jsx');
    reactHotLoader.register(FormGearsOrGrabs, 'FormGearsOrGrabs', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormGearsAndGrabs.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = FormPumps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Vessels_Single_Rows_Pumps__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function FormPumps() {
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var pumps = form.values.pumps;

    if (!pumps || !pumps.length) {
        pumps = [{ capacity: '', quantity: '', type: '' }];
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Vessels_Single_Rows_Pumps__["a" /* default */], {
                type: 'cargo',
                pumps: pumps,
                confirmed: false,
                changeField: function changeField(changes) {
                    var change = Array.isArray(changes) ? changes[0] : changes;

                    var value = void 0;

                    var match = change.field.match(/\[(\d+)\]\.(\w+)/);
                    if (match) {
                        var index = +match[1];
                        var prop = match[2];
                        value = pumps.map(function (pump, i) {
                            return i === index ? _extends({}, pump, _defineProperty({}, prop, change.value)) : pump;
                        });
                    } else {
                        value = change.value;
                    }

                    form.onChange({
                        field: 'pumps',
                        value: value
                    });
                },
                underStyle: { borderColor: __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_colors__["orange500"] }
            })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FormPumps, 'FormPumps', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormPumps.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = FormIGS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormInput__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_vesselRequirements__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormSelect__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormField__ = __webpack_require__(854);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











var defaultSystem = { type: '', capacity: '', percentage: '' };
function FormIGS() {
    var form = Object(__WEBPACK_IMPORTED_MODULE_0__form__["c" /* useFormContext */])();
    var _form$values$igs = form.values.igs,
        igs = _form$values$igs === undefined ? {} : _form$values$igs;
    var fitted = igs.fitted;
    var systems = igs.systems;

    if (!systems || !systems.length) {
        systems = [defaultSystem];
    }

    var addRow = function addRow() {
        return form.onChange({
            field: 'igs',
            value: { fitted: fitted, systems: [].concat(_toConsumableArray(systems), [defaultSystem]) }
        });
    };

    var removeRow = function removeRow(index) {
        return form.onChange({
            field: 'igs',
            value: { fitted: fitted, systems: systems.filter(function (_, i) {
                    return i !== index;
                }) }
        });
    };

    var change = function change(index, key, value) {
        return form.onChange({
            field: 'igs',
            value: {
                fitted: fitted,
                systems: systems.map(function (system, i) {
                    return i === index ? _extends({}, system, _defineProperty({}, key, value)) : system;
                })
            }
        });
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
        null,
        systems.map(function (system, index) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'row', key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    index === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormSelect__["b" /* Select */], {
                        name: 'igs.fitted',
                        value: fitted,
                        label: 'IGS',
                        onChange: function onChange(_ref) {
                            var value = _ref.value;
                            return form.onChange({
                                field: 'igs',
                                value: { fitted: value, systems: systems }
                            });
                        },
                        options: [{ value: null, label: undefined }, { value: true, label: 'Yes' }, { value: false, label: 'No' }]
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormSelect__["b" /* Select */], {
                        name: 'type',
                        label: 'IGS type',
                        value: system.type,
                        onChange: function onChange(_ref2) {
                            var field = _ref2.field,
                                value = _ref2.value;

                            change(index, field, value);
                        },
                        disabled: !fitted,
                        options: [''].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__constants_vesselRequirements__["b" /* IGS_TYPES */]))
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FormField__["a" /* Field */], {
                        value: system.capacity,
                        label: 'Capacity, cbm/hr',
                        disabled: !fitted,
                        floatNumber: true,
                        onChange: function onChange(_, value) {
                            change(index, 'capacity', value);
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FormField__["a" /* Field */], {
                        value: system.percentage,
                        label: '%',
                        disabled: !fitted,
                        floatNumber: true,
                        onChange: function onChange(_, value) {
                            change(index, 'percentage', value);
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-1' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { margin: '25px 0 0 0' } },
                        index === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                            {
                                disabled: !fitted,
                                onClick: addRow
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' })
                        ),
                        index !== 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                            {
                                disabled: !fitted,
                                onClick: function onClick() {
                                    return removeRow(index);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                        )
                    )
                )
            );
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(defaultSystem, 'defaultSystem', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormIGS.jsx');
    reactHotLoader.register(FormIGS, 'FormIGS', '/opt/atlassian/pipelines/agent/build/client/app/components/common/Form/FormIGS.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_cargoes_orders__ = __webpack_require__(51);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SelectedTextPopup = function (_React$Component) {
    _inherits(SelectedTextPopup, _React$Component);

    function SelectedTextPopup(props) {
        _classCallCheck(this, SelectedTextPopup);

        var _this = _possibleConstructorReturn(this, (SelectedTextPopup.__proto__ || Object.getPrototypeOf(SelectedTextPopup)).call(this, props));

        _this.state = {
            numberCargoOrder: null
        };

        _this.selectCargoOrder = _this.selectCargoOrder.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(SelectedTextPopup, [{
        key: 'getFirstSetNumbersFromString',
        value: function getFirstSetNumbersFromString() {
            var reg = new RegExp(/[.,0-9]+/gi);
            var matchArray = this.props.chosenText.match(reg);

            if (matchArray) {
                return matchArray[0].replace(',', '.');
            }

            return '';
        }
    }, {
        key: 'onChange',
        value: function onChange(e, fieldValue) {
            if (this.state.numberCargoOrder === null) {
                return;
            }

            var newCargoOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrders[this.state.numberCargoOrder]);
            var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.cargoOrderUser);

            switch (fieldValue) {
                case 'cargoName':
                    newCargoOrder.cargo.cargoName = this.props.chosenText;
                    break;
                case 'uport':
                    newCargoOrder.loadingPorts[0].namePort = this.props.chosenText;
                    break;
                case 'lport':
                    newCargoOrder.unloadingPorts[0].namePort = this.props.chosenText;
                    break;
                case 'term':
                    newCargoOrder.terms.user.push({ type: '', value: this.props.chosenText });
                    break;
                case 'comm':
                    newCargoOrder.comm = this.props.chosenText;
                    break;
                case 'sf':
                    newCargoOrder.cargo.sf = this.props.chosenText;
                    break;
                case 'un':
                    newCargoOrder.cargo.dangerous.unNumber = this.getFirstSetNumbersFromString();
                    break;
                case 'imdg':
                    newCargoOrder.cargo.dangerous.class[0] = this.getFirstSetNumbersFromString();
                    break;
                case 'weight':
                    newCargoOrder.cargo.packing.pack.unitsWeight.value = this.getFirstSetNumbersFromString();
                    break;
                case 'volume':
                    newCargoOrder.cargo.packing.pack.unitsVolume.value = this.getFirstSetNumbersFromString();
                    break;
                // todo check for autocomplete user
                case 'email':
                    newUser.email = this.props.chosenText;
                    break;
                case 'company':
                    newUser.company = this.props.chosenText;
                    break;
                case 'name':
                    newUser.name = this.props.chosenText;
                    break;
                case 'surname':
                    newUser.surname = this.props.chosenText;
                    break;
                case 'phonecode':
                    newUser.phones[0].code = this.props.chosenText;
                    break;
                case 'phone':
                    newUser.phones[0].phone = this.props.chosenText;
                    break;
            }

            this.props.updateCargoOrder(this.state.numberCargoOrder, newCargoOrder);
            this.props.updateCargoOrderUser(newUser);
            this.props.closePopover();
        }
    }, {
        key: 'selectCargoOrder',
        value: function selectCargoOrder(e, index, value) {
            this.setState({
                numberCargoOrder: value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var renderMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_Menu___default.a,
                { onChange: this.onChange },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Cargo Name', value: 'cargoName' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Unloading port', value: 'uport' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Loading port', value: 'lport' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Term', value: 'term' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Commision', value: 'comm' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'SF', value: 'sf' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'unNumber', value: 'un' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'IMDG', value: 'imdg' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Weight', value: 'weight' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Volume', value: 'volume' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Email user', value: 'email' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Company new user', value: 'company' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Name new user', value: 'name' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Surname new user', value: 'surname' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone code new user', value: 'phonecode' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone number new user', value: 'phone' })
            );

            if (this.state.numberCargoOrder === null) {
                renderMenu = null;
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'popup' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default.a,
                    {
                        open: this.props.openPopover,
                        anchorEl: this.props.anchorEl,
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' },
                        onRequestClose: this.props.closePopover,
                        animation: __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__["PopoverAnimationVertical"]
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'popup-choose' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'chosen' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'chosen-title' },
                                'Chosen text'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'chosen-row' },
                                '\'' + this.props.chosenText + '\''
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                floatingLabelText: 'Choose cargo order',
                                value: this.state.numberCargoOrder,
                                onChange: this.selectCargoOrder,
                                style: {
                                    width: '200px',
                                    padding: '0 10px'
                                }
                            },
                            this.props.cargoOrders.map(function (item, i) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    key: i,
                                    value: i,
                                    primaryText: 'Cargo order - ' + i
                                });
                            })
                        ),
                        renderMenu
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SelectedTextPopup;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        openPopover: ownProps.openPopover,
        anchorEl: ownProps.anchorEl,
        closePopover: ownProps.closePopover,
        chosenText: ownProps.chosenText,
        cargoOrders: state.cargoOrders.items,
        cargoOrderUser: state.cargoOrders.user
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_8_actions_cargoes_orders__["f" /* updateCargoOrder */],
        updateCargoOrderUser: __WEBPACK_IMPORTED_MODULE_8_actions_cargoes_orders__["g" /* updateCargoOrderUser */]
    }, dispatch);
})(SelectedTextPopup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SelectedTextPopup, 'SelectedTextPopup', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/SelectedTextPopup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Cargo/Content/SelectedTextPopup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export portsFlat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return portsTree; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function portsFlat(ports, destination) {
    ports = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(ports);
    return ports.forEach(function (item) {
        if (item.length > 1) {
            item.oneOf.forEach(function (prt) {
                destination.push({
                    port: prt,
                    sign: 'or'
                });
            });
        } else {
            destination.push({
                port: item.oneOf[0],
                sign: 'and'
            });
        }
    });
}

function portsTree(ports, destination) {
    ports = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(ports);
    return ports.forEach(function (item) {
        if (item.sign === 'and') {
            destination.push({ oneOf: [item.port] });
        } else {
            destination[destination.length - 1].oneOf.push(item.port);
        }
    });
}


;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(portsFlat, 'portsFlat', '/opt/atlassian/pipelines/agent/build/client/app/helpers/cargoUtils.js');
    reactHotLoader.register(portsTree, 'portsTree', '/opt/atlassian/pipelines/agent/build/client/app/helpers/cargoUtils.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCargoesByTypeName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoesByTypeName(filter) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_10" /* GET_CARGOES_BY_TYPE_NAME */].REQUEST,
        filter: filter
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoesByTypeName, 'getCargoesByTypeName', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/names.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SingleNew_ArchiveLetter__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Single_HtmlContent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextEditor__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Single_Attachments__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ErrorBoundary__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ToSpamButton__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();














// import Trainings from '../Single/Gazetter/Trainings';



function Management(_ref) {
    var letter = _ref.letter,
        textLetter = _ref.textLetter,
        router = _ref.router,
        routeParams = _ref.routeParams,
        openedAttachmentsDialog = _ref.openedAttachmentsDialog,
        originalText = _ref.originalText,
        removeGazetters = _ref.removeGazetters,
        removeAnnotations = _ref.removeAnnotations,
        getLetterData = _ref.getLetterData,
        updatePostGazetters = _ref.updatePostGazetters,
        toggleAttachmentsDialog = _ref.toggleAttachmentsDialog,
        setServers = _ref.setServers,
        servers = _ref.servers;

    var changeAnnotationsServer = function changeAnnotationsServer(e, i, value) {
        setServers(_extends({}, servers, { annotationsServer: value }));
        getLetterData();
    };

    var changeClarifiedServer = function changeClarifiedServer(e, i, value) {
        setServers(_extends({}, servers, { clarifiedServer: value }));
        getLetterData();
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'management' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'management-children' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                label: 'Gazetteer',
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */], { to: '/' + routeParams.id }),
                primary: true,
                className: 'btn',
                labelStyle: { fontSize: '10px' },
                style: { height: '25px', margin: '10px 10px 10px 0' },
                buttonStyle: { height: '25px', lineHeight: '25px' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__common_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SingleNew_ArchiveLetter__["a" /* default */], { router: router })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__common_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Single_HtmlContent__["a" /* default */], {
                    letter: letter
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TextEditor__["a" /* default */], {
                textLetter: textLetter,
                originalText: originalText,
                removeGazetters: removeGazetters,
                removeAnnotations: removeAnnotations,
                getLetterData: getLetterData,
                updatePostGazetters: updatePostGazetters
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Single_Attachments__["a" /* default */], {
                openedAttachmentsDialog: openedAttachmentsDialog,
                toggleAttachmentsDialog: toggleAttachmentsDialog,
                labelStyle: { fontSize: '10px' },
                style: { height: '25px', margin: '10px 10px 10px -10px' },
                buttonStyle: { height: '25px', lineHeight: '25px' },
                attachments: letter.attachments
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                className: 'btn',
                labelStyle: { fontSize: '10px' },
                style: { height: '25px', margin: '10px 10px 10px 0' },
                buttonStyle: { height: '25px', lineHeight: '25px' },
                label: 'Size',
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */], { to: '/' + routeParams.id + '/size/vessel' }),
                primary: true
            }),
            __WEBPACK_IMPORTED_MODULE_11_store_configureStore__["a" /* UserPerms */].isAdmin() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
                    {
                        floatingLabelText: 'Annotations server',
                        className: 'btn',
                        value: servers.annotationsServer,
                        onChange: changeAnnotationsServer,
                        style: { width: '155px' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'mailparse.net', primaryText: 'mailparse.net' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 's4.anotatr.com', primaryText: 's4.anotatr.com' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'nata.im', primaryText: 'nata.im' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'polza', primaryText: 'polza' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'localhost', primaryText: 'localhost' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
                    {
                        floatingLabelText: 'Clarified server',
                        className: 'btn',
                        value: servers.clarifiedServer,
                        onChange: changeClarifiedServer,
                        style: { width: '110px' },
                        autoWidth: true
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'standart', primaryText: 'api' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'localhost:7775', primaryText: 'localhost' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 's4.anotatr.com:7777', primaryText: 's4.anotatr.com' })
                )
            ) : '',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ToSpamButton__["a" /* default */], {
                letterId: letter._id,
                onSuccess: function onSuccess() {
                    getLetterData();
                },
                disabled: letter.type === 'spam'
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'subject', style: { width: '150px' } },
            'SUBJECT: ',
            letter.subject
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'subject' },
            'refNo: ',
            letter.refNo
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(function (state) {
    return {
        objUser: state.user,
        user: state.vesselOrders.user,
        isLogged: state.user.isLogged
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])({
        // postAnnotations,
        // postGazetters,
        removeGazetters: __WEBPACK_IMPORTED_MODULE_9__actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_10__actions_annotations__["b" /* removeAnnotations */]
    }, dispatch);
})(Management);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Management, 'Management', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/Management.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/Management.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px'
        }
    }
};

// TODO: reuse that in other components

var TextEditor = function TextEditor(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        open = _useState2[0],
        setOpen = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.textLetter),
        _useState4 = _slicedToArray(_useState3, 2),
        textLetter = _useState4[0],
        setTextLetter = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.originalText),
        _useState6 = _slicedToArray(_useState5, 2),
        originalText = _useState6[0],
        setOriginalText = _useState6[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setTextLetter(props.textLetter);
        setOriginalText(props.originalText);
    }, [props.textLetter, props.originalText]);

    var returnOriginalText = function returnOriginalText() {
        setTextLetter(props.originalText);
    };

    var toggleDialog = function toggleDialog() {
        setOpen(!open);
    };

    var updateGazetters = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!textLetter) {
                                _context.next = 7;
                                break;
                            }

                            toggleDialog();
                            props.removeAnnotations();
                            props.removeGazetters();
                            _context.next = 6;
                            return props.getLetterData(textLetter);

                        case 6:
                            props.updatePostGazetters(textLetter);

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function updateGazetters() {
            return _ref.apply(this, arguments);
        };
    }();

    var changeTextLetterText = function changeTextLetterText(e) {
        setTextLetter(e.target.value);
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
        label: 'RE-ANNOTATE',
        primary: true,
        onClick: updateGazetters
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
        label: 'RETURN ORIGINAL TEXT',
        primary: true,
        onClick: returnOriginalText
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
        label: 'CLOSE',
        primary: true,
        onClick: toggleDialog
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
            label: 'Editor',
            labelStyle: styles.button.labelStyle,
            style: styles.button.style,
            buttonStyle: styles.button.buttonStyle,
            onClick: toggleDialog,
            primary: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
            {
                title: 'Edit letter text',
                actions: actions,
                contentStyle: styles.dialog.contentStyle,
                open: open,
                modal: true
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                style: styles.textarea.style,
                value: textLetter,
                onChange: changeTextLetterText
            })
        )
    );
};

var _default = TextEditor;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/TextEditor.jsx');
    reactHotLoader.register(TextEditor, 'TextEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/TextEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/TextEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(1)) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.ReactErrorBoundary = {}, global.React));
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_annotations__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectedTextPopup__ = __webpack_require__(1983);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










var AnnotationsEditor = function AnnotationsEditor(_ref) {
    var letterText = _ref.letterText,
        annotations = _ref.annotations;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        renderContent = _useState2[0],
        setRenderContent = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        openPopover = _useState4[0],
        setOpenPopover = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState6 = _slicedToArray(_useState5, 2),
        anchorEl = _useState6[0],
        setAnchorEl = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState8 = _slicedToArray(_useState7, 2),
        chosenText = _useState8[0],
        setChosenText = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState10 = _slicedToArray(_useState9, 2),
        tooltips = _useState10[0],
        setTooltips = _useState10[1];

    var sortForLongerAnnotate = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (ann) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(ann, function (a, b) {
            return -a.features.string.length;
        });
    }, []);

    var clearUnusefullWords = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (ann) {
        var array = ann.filter(function (annotation) {
            return annotation.type !== 'Lookup' && annotation.type !== 'Sentence' && annotation.type !== 'Split' && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(annotation, 'features.rule');
        });

        var map = new Map();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                var key = item.type + '-' + item.features.rule + '-' + item.start + '-' + item.end;
                map.set(key, item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return Array.from(map.values());
    }, []);

    var createTooltips = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (characters) {
        var map = new Map();
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = characters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var char = _step2.value;

                map.set(char.ids.join(''), char);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return Array.from(map.values());
    }, []);

    var createRenderedContent = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_letterText, _annotations) {
        var _renderContent = _letterText.split('');

        _renderContent = _renderContent.map(function (symbol, symbolPosition) {
            symbol = symbol === ' ' ? '\xA0' : symbol;
            return {
                symbol: symbol,
                symbolPosition: symbolPosition,
                style: {},
                ids: [],
                tooltipContent: []
            };
        });

        for (var i = 0; i < _annotations.length; i++) {
            var hashColor = __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].createHashColor();
            for (var j = _annotations[i].start; j < _annotations[i].end; j++) {
                if (_renderContent[j]) {
                    _renderContent[j].style = {
                        background: hashColor
                    };
                    _renderContent[j].ids.push(_annotations[i].id);
                    _renderContent[j].tooltipContent.push({
                        rule: _annotations[i].features.rule,
                        type: _annotations[i].type
                    });
                }
            }
        }

        var _tooltips = createTooltips(_renderContent);

        setRenderContent(_renderContent);
        setTooltips(_tooltips);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (letterText && annotations.length > 0) {
            var clearedAnnotations = clearUnusefullWords(annotations);
            var sortedAnnotations = sortForLongerAnnotate(clearedAnnotations);

            createRenderedContent(letterText, sortedAnnotations);
        } else {
            setRenderContent(undefined);
            setTooltips(undefined);
        }
    }, [letterText, annotations, clearUnusefullWords, sortForLongerAnnotate, createRenderedContent]);

    var onMouseUp = function onMouseUp(ev) {
        var range = __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].getSelection(ev.target.parentNode);

        if (range.start === range.end) {
            return;
        }

        var hashColor = __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].createHashColor();
        var newRenderContent = renderContent.slice(0);

        newRenderContent.forEach(function (el) {
            if (el.position >= range.start && el.position < range.end) {
                newRenderContent.push({
                    style: {
                        background: hashColor
                    }
                });
            }
        });

        setRenderContent(newRenderContent);
        setOpenPopover(true);
        setAnchorEl(ev.target);
        setChosenText(range.string);
    };

    var closePopover = function closePopover() {
        setOpenPopover(false);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SelectedTextPopup__["a" /* default */], {
            openPopover: openPopover,
            anchorEl: anchorEl,
            closePopover: closePopover,
            chosenText: chosenText
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'letter-text', onMouseUp: onMouseUp },
            renderContent ? Array.from(Object(__WEBPACK_IMPORTED_MODULE_4_helpers_annotations__["b" /* letterMapper */])(renderContent)) : letterText
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_helpers_annotations__["a" /* AnnotationTooltip */], {
            tooltips: tooltips,
            renderTooltip: function renderTooltip(tooltip) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'tooltip-row' },
                    tooltip.tooltipContent.map(function (t, k) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: k, className: 'tooltip-column' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col' },
                                'Rule - ' + t.rule + ', '
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col' },
                                'Type - ' + t.type
                            )
                        );
                    })
                );
            }
        })
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        annotations: state.annotations.items
    };
}, null)(AnnotationsEditor);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationsEditor, 'AnnotationsEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/AnnotationsEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/AnnotationsEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__ = __webpack_require__(100);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();













var SelectedTextPopup = function SelectedTextPopup(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        numberVesselOrder = _useState2[0],
        setNumberVesselOrder = _useState2[1];

    var onChange = function onChange(e, fieldValue) {
        if (numberVesselOrder === null) {
            return;
        }

        var newVesselOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(props.vesselOrders[numberVesselOrder]);
        var newUser = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(props.vesselOrderUser);

        switch (fieldValue) {
            case 'term':
                newVesselOrder.terms.push({ type: '', value: props.chosenText });
                break;
            // todo check for autocomplete user
            case 'email':
                newUser.email = props.chosenText;
                break;
            case 'company':
                newUser.company = props.chosenText;
                break;
            case 'name':
                newUser.name = props.chosenText;
                break;
            case 'surname':
                newUser.surname = props.chosenText;
                break;
            case 'phonecode':
                newUser.phones[0].code = props.chosenText;
                break;
            case 'phone':
                newUser.phones[0].phone = props.chosenText;
                break;
        }

        props.updateVesselOrder(numberVesselOrder, newVesselOrder);
        props.updateVesselOrderUser(newUser);
        props.closePopover();
    };

    var selectVesselOrder = function selectVesselOrder(_e, _index, value) {
        setNumberVesselOrder(value);
    };

    var renderMenu = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default.a,
        { onChange: onChange },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Term', value: 'term' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Email user', value: 'email' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Company new user', value: 'company' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Name new user', value: 'name' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Surname new user', value: 'surname' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone code new user', value: 'phonecode' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { primaryText: 'Phone number new user', value: 'phone' })
    );

    if (numberVesselOrder === null) {
        renderMenu = null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'popup' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default.a,
            {
                open: props.openPopover,
                anchorEl: props.anchorEl,
                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                targetOrigin: { horizontal: 'left', vertical: 'top' },
                onRequestClose: props.closePopover,
                animation: __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__["PopoverAnimationVertical"]
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'popup-choose' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'chosen' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'chosen-title' },
                        'Chosen text'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'chosen-row' },
                        '\'' + props.chosenText + '\''
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
                {
                    floatingLabelText: 'Choose vessel order',
                    value: numberVesselOrder,
                    onChange: selectVesselOrder,
                    style: {
                        width: '200px',
                        padding: '0 10px'
                    }
                },
                props.vesselOrders.map(function (item, i) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                        key: i,
                        value: i,
                        primaryText: 'Vessel order - ' + i
                    });
                })
            ),
            renderMenu
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        openPopover: ownProps.openPopover,
        anchorEl: ownProps.anchorEl,
        closePopover: ownProps.closePopover,
        chosenText: ownProps.chosenText,
        vesselOrders: state.vesselOrders.items,
        vesselOrderUser: state.vesselOrders.user
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselOrder: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__["g" /* updateVesselOrder */],
        updateVesselOrderUser: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_orders__["h" /* updateVesselOrderUser */]
    }, dispatch);
})(SelectedTextPopup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SelectedTextPopup, 'SelectedTextPopup', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/SelectedTextPopup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/SelectedTextPopup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_RequestTitle__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VesselInfo__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__podPol_PodPorsBlock__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__content_Fields__ = __webpack_require__(1988);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function HiresTable(_ref) {
    var hireOrderNumber = _ref.hireOrderNumber,
        hireOrder = _ref.hireOrder;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(hireOrder),
        _useState2 = _slicedToArray(_useState, 2),
        order = _useState2[0],
        setOrder = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setOrder(hireOrder);
    }, [hireOrder]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'sidebar-table', style: { position: 'relative' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_RequestTitle__["a" /* default */], {
            orderNumber: hireOrderNumber + 1,
            text: 'HIRE ORDER NUMBER',
            warnings: []
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block margin-bottom', style: { padding: '10px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__VesselInfo__["a" /* default */], { orderIndex: 0, hireOrder: order })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block margin-bottom' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__podPol_PodPorsBlock__["a" /* default */], { order: order, orderIndex: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block margin-bottom' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__content_Fields__["a" /* default */], { hireOrder: order, orderIndex: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
    );
}

var _default = HiresTable;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HiresTable, 'HiresTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/HiresTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/HiresTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export generateSpeedConsString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LetterHire__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(44);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();









function generateSpeedConsString(s) {
    var ifoString = s.ifo ? (s.ifo.typeIfo || '') + ' - ' + (s.ifo.cons || '') : '';
    var mdoString = s.mdo ? (s.mdo.typeMdo || '') + ' - ' + (s.mdo.cons || '') : '';

    return 'Mode: ' + s.mode + ' | Speed: ' + (s.speed || '-') + ' | Ifo: ' + ifoString + ' | Mdo: ' + mdoString;
}

var VesselInfo = function VesselInfo(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        vesselNames = _useState2[0],
        setVesselNames = _useState2[1];
    /** @type {import('./hireOrdersReducer').TDispatchHireOrders} */


    var dispatchHireOrders = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__LetterHire__["a" /* ContextDispatchHireOrders */]);

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.hireOrder),
        _useState4 = _slicedToArray(_useState3, 2),
        hireOrder = _useState4[0],
        setHireOrder = _useState4[1];

    var dAutocomplete = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (searchText) {
        __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findVessel(searchText).then(function (response) {
            var _vesselNames = response.data.data.map(function (vessel) {
                return {
                    name: vessel.name + ' (imoNumber - ' + vessel.imoNumber + ')',
                    item: vessel
                };
            });

            setVesselNames(_vesselNames);
        }).catch(function () {
            return null;
        });
    }, 1000), [props]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setHireOrder(props.hireOrder);
    }, [props.hireOrder]);

    var changeVesselName = function changeVesselName(searchText) {
        var newHireOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(hireOrder);
        newHireOrder.vesselName = searchText;
        dispatchHireOrders({
            type: 'UPDATE_ORDER',
            payload: { index: props.orderIndex, value: newHireOrder }
        });
        dAutocomplete(searchText);
    };

    var chooseVessel = function chooseVessel(updateProperties) {
        if (!updateProperties) {
            return;
        }

        var newHireOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(hireOrder);

        newHireOrder.vesselName = updateProperties.name;

        var vesselData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(updateProperties.item, ['_id', 'imoNumber', 'deadWeight', 'blt', 'capacityV2', 'typeByConstruction', 'geared', 'speedConsumptionV2', 'gearV2']);

        newHireOrder.vesselData = {
            _id: vesselData._id,
            sDWT: vesselData.deadWeight.sDWT,
            imoNumber: vesselData.imoNumber,
            blt: vesselData.blt,
            geared: typeof vesselData.geared === 'boolean' ? vesselData.geared : undefined,
            typeByConstruction: vesselData.typeByConstruction
        };

        if (vesselData.capacityV2) {
            newHireOrder.vesselData.capacityV2Bale = vesselData.capacityV2.bale;
            newHireOrder.vesselData.capacityV2Grain = vesselData.capacityV2.grain;
        }

        if (vesselData.gearV2 && vesselData.gearV2.summary && vesselData.gearV2.summary.length) {
            newHireOrder.vesselData.maxCraneCapacity = vesselData.gearV2.summary.reduce(function (m, s) {
                return s.capacity > m ? s.capacity : m;
            }, 0);
        }

        if (vesselData.speedConsumptionV2 && vesselData.speedConsumptionV2.length) {
            newHireOrder.vesselData.speedConsumptionV2 = vesselData.speedConsumptionV2.filter(function (s) {
                return ['Laden', 'Ballast', 'Eco'].includes(s.mode);
            }).map(function (s) {
                return generateSpeedConsString(s);
            });
        }

        dispatchHireOrders({
            type: 'UPDATE_ORDER',
            payload: { index: props.orderIndex, value: newHireOrder }
        });
    };

    /**
     * @param {string} label 
     * @param {string[] | string} value 
     */
    var renderInfo = function renderInfo(label, value) {
        if (Array.isArray(value)) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', style: { padding: '0 10px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column-left', style: { alignSelf: 'baseline' } },
                    label
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column-right' },
                    value.map(function (v) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: v, className: 'label' },
                            v
                        );
                    })
                )
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row', style: { padding: '0 10px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'column-left', style: { alignSelf: 'baseline' } },
                label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'column-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'label' },
                    value
                )
            )
        );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row', style: { padding: '0 10px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'column-left' },
                'Vessel name:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'column-right', style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                    name: 'vesselName',
                    textFieldStyle: { fontSize: '13px' },
                    hintText: 'Vessel name',
                    searchText: props.hireOrder.vesselName || '',
                    dataSource: vesselNames,
                    dataSourceConfig: { text: 'name', value: 'item' },
                    onUpdateInput: changeVesselName,
                    onNewRequest: chooseVessel,
                    filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                    fullWidth: true,
                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                    popoverProps: {
                        canAutoPosition: true
                    },
                    style: { display: 'flex', width: '70%', marginRight: '10px' }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                    labelStyle: { fontSize: '10px' },
                    style: { height: '25px', margin: 'auto 0' },
                    buttonStyle: { height: '25px', lineHeight: '25px' },
                    label: 'Composition',
                    disabled: !props.hireOrder.vesselId,
                    onClick: function onClick() {
                        var url = 'emailId=' + props.params.id;
                        if (props.hireOrder.vesselId && props.hireOrder.vesselName) {
                            url += '&_id=' + props.hireOrder.vesselId + '&name=' + props.hireOrder.vesselName;
                        }
                        window.open(window.location.origin + '/vessels/composition?' + url, '_blank');
                    },
                    secondary: true
                })
            )
        ),
        renderInfo('imoNumber:', hireOrder.vesselData.imoNumber),
        renderInfo('DWT:', hireOrder.vesselData.sDWT),
        renderInfo('BLT:', hireOrder.vesselData.blt),
        renderInfo('Geared:', hireOrder.vesselData.imoNumber ? String(hireOrder.vesselData.geared) : ''),
        renderInfo('Type By Construction:', hireOrder.vesselData.typeByConstruction),
        renderInfo('Max Crane Capacity:', hireOrder.vesselData.maxCraneCapacity),
        renderInfo('Speed & Consumption:', hireOrder.vesselData.speedConsumptionV2)
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["f" /* withRouter */])(VesselInfo));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(generateSpeedConsString, 'generateSpeedConsString', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/VesselInfo.jsx');
    reactHotLoader.register(VesselInfo, 'VesselInfo', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/VesselInfo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/VesselInfo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PodPol__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Base_DateRangeSelector__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LetterHire__ = __webpack_require__(371);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










var PodPorsBlock = function PodPorsBlock(_ref) {
    var order = _ref.order,
        orderIndex = _ref.orderIndex;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState2 = _slicedToArray(_useState, 2),
        openDialogs = _useState2[0],
        setOpenDialogs = _useState2[1];
    /** @type {import('../hireOrdersReducer').TDispatchHireOrders} */


    var dispatchHireOrders = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__LetterHire__["a" /* ContextDispatchHireOrders */]);

    var changePortData = function changePortData(type, port) {
        var _order = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(order);
        _order[type] = port;
        dispatchHireOrders({
            type: 'UPDATE_ORDER',
            payload: { index: orderIndex, value: _order }
        });
    };

    var handleToggleLayCanDialog = function handleToggleLayCanDialog() {
        setOpenDialogs(_extends({}, openDialogs, {
            laycan: !openDialogs.laycan
        }));
    };

    var changeLayCan = function changeLayCan(dates) {
        var _order = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(order);
        var lay = dates.lay,
            can = dates.can;

        _order.lay = lay;
        _order.can = can;
        dispatchHireOrders({
            type: 'UPDATE_ORDER',
            payload: { index: orderIndex, value: _order }
        });
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
        label: 'Ok',
        primary: true,
        onClick: function onClick() {
            handleToggleLayCanDialog();
        }
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '97%', marginLeft: '10px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', style: { background: '#EEF8E4' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column-left' },
                    'Port of delivery'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', style: { background: '#EEF8E4' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PodPol__["a" /* default */], {
                    port: order.delivery,
                    portType: 'delivery',
                    changePortData: changePortData
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                    labelStyle: { fontSize: '10px' },
                    style: { height: '25px', margin: '35px 0 0 23px' },
                    buttonStyle: { height: '25px', lineHeight: '25px' },
                    label: 'Laycan',
                    onClick: function onClick() {
                        return handleToggleLayCanDialog();
                    },
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: '12px', fontWeight: 'bold', margin: '40px 0 0 5px' } },
                    __WEBPACK_IMPORTED_MODULE_6_moment___default()(order.lay).utc().format('DD-MM-YYYY'),
                    ' --- ',
                    __WEBPACK_IMPORTED_MODULE_6_moment___default()(order.can).utc().format('DD-MM-YYYY')
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
                {
                    title: 'Dialog With Date Picker',
                    actions: actions,
                    modal: false,
                    open: !!openDialogs.laycan,
                    onRequestClose: function onRequestClose() {
                        return handleToggleLayCanDialog();
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Base_DateRangeSelector__["a" /* default */], {
                    from: __WEBPACK_IMPORTED_MODULE_6_moment___default()(order.lay).utc().toDate(),
                    until: __WEBPACK_IMPORTED_MODULE_6_moment___default()(order.can).utc().toDate(),
                    fromLabel: 'Readiness date',
                    untilLabel: 'Cancelling date',
                    onChange: function onChange(range) {
                        return changeLayCan({ lay: range.from, can: range.until });
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '97%', marginLeft: '10px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', style: { background: '#E8F0F8' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column-left' },
                    'Port of redelivery '
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', style: { background: '#E8F0F8' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PodPol__["a" /* default */], {
                    port: order.redelivery,
                    portType: 'redelivery',
                    changePortData: changePortData
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
        )
    );
};

PodPorsBlock.propTypes = {
    order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    orderIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(PodPorsBlock);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PodPorsBlock, 'PodPorsBlock', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/podPol/PodPorsBlock.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/podPol/PodPorsBlock.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








var PodPor = function PodPor(_ref) {
    var portType = _ref.portType,
        port = _ref.port,
        changePortData = _ref.changePortData;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        ports = _useState2[0],
        setPorts = _useState2[1];

    var dAutocomplete = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function (searchText) {
        if (searchText.length < 2) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findPort({ name: searchText, withAreas: true }).then(function (response) {
            var _ports = response.data.data.flatMap(function (_port) {
                return createPort(_port);
            });
            setPorts(_ports);
        }).catch(function () {
            return null;
        });
    }, 500);

    var createPort = function createPort(_port) {
        var _ports = [];
        var name = '';

        if (_port.sub) {
            _port.sub.forEach(function (subPort) {
                _ports.push({
                    item: subPort,
                    text: subPort.name + ' - country ' + _port.country.name,
                    _id: _port._id,
                    value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                        primaryText: subPort.name + ' - country ' + _port.country.name,
                        value: subPort,
                        style: { paddingLeft: '30px' }
                    })
                });
            });
        }

        name = _port.country ? _port.name + ' - country ' + _port.country.name : _port.name;

        return [{
            _id: _port._id,
            text: name,
            item: _port,
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                primaryText: name,
                value: _port
            })
        }].concat(_ports);
    };

    var changeAutoComplete = function changeAutoComplete(searchText) {
        var updatedPort = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(port);
        updatedPort.name = searchText;
        if (!searchText) {
            delete updatedPort._id;
        }
        changePortData(portType, updatedPort);
        dAutocomplete(searchText);
    };

    var chooseAutoComplete = function chooseAutoComplete(selectedPort) {
        if (!selectedPort) {
            return;
        }

        changePortData(portType, _extends({}, port, {
            port: selectedPort.item,
            _id: selectedPort.item._id
        }));
    };

    var label = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["capitalize"])(portType);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row', style: { display: 'flex' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
                floatingLabelText: label,
                textFieldStyle: { fontSize: '13px' },
                hintText: label,
                searchText: port.name || '',
                dataSource: ports,
                onUpdateInput: changeAutoComplete,
                onNewRequest: chooseAutoComplete,
                required: true,
                filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
                listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                menuStyle: { width: 'auto' },
                popoverProps: {
                    canAutoPosition: true
                },
                style: { marginLeft: '10px' }
            })
        )
    );
};

PodPor.propTypes = {
    portType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['delivery', 'redelivery']).isRequired,
    port: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
    changePortData: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(PodPor);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PodPor, 'PodPor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/podPol/PodPol.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/podPol/PodPol.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LetterHire__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_hire__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CargoRegion__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CargoName__ = __webpack_require__(1990);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();









var Fields = function Fields(_ref) {
    var hireOrder = _ref.hireOrder,
        orderIndex = _ref.orderIndex;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(hireOrder),
        _useState2 = _slicedToArray(_useState, 2),
        order = _useState2[0],
        setOrder = _useState2[1];
    /** @type {import('../hireOrdersReducer').TDispatchHireOrders} */


    var dispatchHireOrders = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__LetterHire__["a" /* ContextDispatchHireOrders */]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setOrder(hireOrder);
    }, [hireOrder]);

    var updateField = function updateField(field, value) {
        var _order = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(order);

        _order[field] = value;

        dispatchHireOrders({
            type: 'UPDATE_ORDER',
            payload: { index: orderIndex, value: _order }
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 flexed' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["s" /* SelectField */],
                    {
                        value: hireOrder.hireType,
                        onChange: function onChange(_e, _i, value) {
                            return updateField('hireType', value);
                        },
                        style: { fontSize: '13px' },
                        name: 'hireType',
                        floatingLabelText: 'Hire Type',
                        fullWidth: true,
                        autoWidth: true
                    },
                    __WEBPACK_IMPORTED_MODULE_4_constants_hire__["a" /* HIRE_TYPES_MAP */].map(function (t) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], { key: t.field, value: t.field, primaryText: t.placeHolder });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 flexed' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                    name: 'hire',
                    floatingLabelText: 'Hire',
                    value: hireOrder.hire || '',
                    style: { fontSize: '13px' },
                    onChange: function onChange(e) {
                        return updateField('hire', e.target.value);
                    },
                    type: 'number',
                    required: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 flexed' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                    name: 'duration',
                    floatingLabelText: 'Duration',
                    style: { fontSize: '13px' },
                    value: hireOrder.duration || '',
                    onChange: function onChange(e) {
                        return updateField('duration', e.target.value);
                    }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 flexed' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CargoName__["a" /* default */], { cargo: hireOrder.cargo, updateField: updateField })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 flexed' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CargoRegion__["a" /* default */], { cargoRegion: hireOrder.cargoRegion, updateField: updateField })
            )
        )
    );
};

var _default = Fields;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Fields, 'Fields', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/content/Fields.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/content/Fields.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_PortsAutoComplete__ = __webpack_require__(283);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var CargoRegion = function CargoRegion(_ref) {
    var cargoRegion = _ref.cargoRegion,
        updateField = _ref.updateField;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(cargoRegion),
        _useState2 = _slicedToArray(_useState, 2),
        region = _useState2[0],
        setRegion = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setRegion(cargoRegion);
    }, [cargoRegion]);

    var selectPort = function selectPort(value) {
        updateField('cargoRegion', value);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_PortsAutoComplete__["a" /* default */], {
        customValue: region.name || '',
        selectValue: selectPort,
        floatingLabelText: 'Cargo region',
        hintText: null,
        inputStyle: { fontSize: '13px', marginTop: '14px' },
        menuStyle: { width: '300px' },
        style: { display: 'flex', width: '100%' },
        textFieldStyle: { height: '72px' },
        popoverProps: {
            style: { width: '300px' }
        },
        withAreas: true,
        onlyAreas: true
    });
};

var _default = CargoRegion;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoRegion, 'CargoRegion', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/content/CargoRegion.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/content/CargoRegion.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = CargoName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_CargoAutoComplete__ = __webpack_require__(1991);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function CargoName(_ref) {
    var cargo = _ref.cargo,
        updateField = _ref.updateField;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_CargoAutoComplete__["a" /* default */], {
        item: cargo,
        _preventFirstSearch: true,
        updateItem: function updateItem(value) {
            return updateField('cargo', value);
        },
        style: { display: 'flex' }
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoName, 'CargoName', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/content/CargoName.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = CargoNameAutoComplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * 
 * @param {Props} props 
 */
function CargoNameAutoComplete(_ref) {
    var _ref$_preventFirstSea = _ref._preventFirstSearch,
        _preventFirstSearch = _ref$_preventFirstSea === undefined ? true : _ref$_preventFirstSea,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$menuStyle = _ref.menuStyle,
        menuStyle = _ref$menuStyle === undefined ? {} : _ref$menuStyle,
        _ref$popoverProps = _ref.popoverProps,
        popoverProps = _ref$popoverProps === undefined ? {} : _ref$popoverProps,
        _ref$inputStyle = _ref.inputStyle,
        inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
        _ref$underlineStyle = _ref.underlineStyle,
        underlineStyle = _ref$underlineStyle === undefined ? {} : _ref$underlineStyle,
        _ref$textFieldStyle = _ref.textFieldStyle,
        textFieldStyle = _ref$textFieldStyle === undefined ? {} : _ref$textFieldStyle,
        props = _objectWithoutProperties(_ref, ['_preventFirstSearch', 'style', 'menuStyle', 'popoverProps', 'inputStyle', 'underlineStyle', 'textFieldStyle']);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        cargoes = _useState2[0],
        setCargoes = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.item),
        _useState4 = _slicedToArray(_useState3, 2),
        item = _useState4[0],
        setItem = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_preventFirstSearch),
        _useState6 = _slicedToArray(_useState5, 2),
        preventFirstSearch = _useState6[0],
        setPreventFirstSearch = _useState6[1];

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_5_helpers_useDebounce__["a" /* default */])(item.name, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].getCargoNamesAutocomplete(debouncedSearchValue).then(function (response) {
            var _cargoes = response.data.data.map(function (cgo) {
                return {
                    name: cgo.name,
                    item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], {
                        value: cgo,
                        primaryText: cgo.name,
                        secondaryText: ['admin', 'moderator'].includes(cgo.addedByRole) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings___default.a, {
                            style: {
                                position: 'absolute',
                                left: -10,
                                marginTop: '11px',
                                color: '#9E9E9E'
                            }
                        }),
                        style: { paddingLeft: '25px' }
                    })
                };
            });

            setCargoes(_cargoes);
            document.body.scrollTop += 1;
            document.body.scrollTop -= 1;
        }).catch(function () {
            return null;
        });
    }, [debouncedSearchValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPreventFirstSearch(!_preventFirstSearch);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setItem(props.item);
    }, [props.item.name]);

    var onUpdateInputCargoName = function onUpdateInputCargoName(searchText) {
        props.updateItem(_extends({}, item, {
            name: searchText
        }));
    };

    var onNewRequestCargoes = function onNewRequestCargoes(updateProperties) {
        if (!updateProperties) {
            return;
        }

        var _item = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(item);

        _item.name = updateProperties.name;
        _item._id = updateProperties.item.props.value._id;

        props.updateItem(_item);
        setCargoes([]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["a" /* AutoComplete */], {
        name: props.name || 'cargo',
        textFieldStyle: _extends({}, __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].autoCompleteCSS, textFieldStyle),
        hintText: props.hintText === null ? null : 'Cargo name',
        floatingLabelText: props.hintText === null ? null : 'Cargo name',
        searchText: item.name || '',
        dataSource: cargoes,
        dataSourceConfig: { text: 'name', value: 'item' },
        onUpdateInput: onUpdateInputCargoName,
        onNewRequest: onNewRequestCargoes,
        filter: __WEBPACK_IMPORTED_MODULE_2_material_ui__["a" /* AutoComplete */].noFilter,
        listStyle: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].autoCompleteListStyle,
        inputStyle: _extends({ fontSize: '13px' }, inputStyle),
        style: _extends({ fontSize: '13px', width: '100%' }, style),
        popoverProps: _extends({
            canAutoPosition: true,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' }
        }, popoverProps),
        floatingLabelStyle: props.floatingLabelStyle,
        menuStyle: menuStyle,
        underlineStyle: underlineStyle
    });
}

/**
 * props
 * @typedef {Object} Props
 * @property {Item} item
 * @property {boolean} _preventFirstSearch
 * @property {Function} updateItem
 * @property {React.CSSProperties} [style]
 * @property {React.CSSProperties} [floatingLabelStyle]
 * @property {React.CSSProperties} [underlineStyle]
 * @property {string} [hintText]
 * @property {React.CSSProperties} [menuStyle]
 * @property {any} [popoverProps]
 * @property {React.CSSProperties} [inputStyle]
 * @property {string} [name]
 * @property {React.CSSProperties} [textFieldStyle]
 */

/**
 * @typedef Item
 * @property {string} _id
 * @property {string} [name]
 * @property {number} [details]
 * @property {Parent} [parent]
 */

/**
 * @typedef Parent
 * @property {{ _id?: string, name?: string }} red
*/

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoNameAutoComplete, 'CargoNameAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/common/CargoAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Table__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








/**
 * 
 * @param {{
 *  annotations: any[],
 *  annotationsLoaded: boolean,
 * }} props 
 * @returns 
 */
var AnnotationsList = function AnnotationsList(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([10, 20, 30]),
        _useState2 = _slicedToArray(_useState, 1),
        rowsPerPage = _useState2[0];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        rows = _useState4[0],
        setRows = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(10),
        _useState6 = _slicedToArray(_useState5, 2),
        numberOfRows = _useState6[0],
        setNumberOfRows = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState8 = _slicedToArray(_useState7, 2),
        page = _useState8[0],
        setPage = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState10 = _slicedToArray(_useState9, 2),
        total = _useState10[0],
        setTotal = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.annotations),
        _useState12 = _slicedToArray(_useState11, 2),
        annotations = _useState12[0],
        setAnnotations = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState14 = _slicedToArray(_useState13, 2),
        searchText = _useState14[0],
        setSearchText = _useState14[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (props.annotations.length) {
            setAnnotations(props.annotations);
            setTotal(props.annotations.length);
            handleUpdateRow({ annotations: props.annotations, numberOfRows: numberOfRows, page: page });
        }
    }, [props.annotations]);

    var filterAnnotations = function filterAnnotations(searchArray, _searchText) {
        _searchText = _searchText.toLowerCase();

        return searchArray.filter(function (annotation) {
            if (annotation.features) {
                if (annotation.features.rule && annotation.features.rule.toLowerCase().includes(_searchText)) {
                    return true;
                }

                if (annotation.features.majorType && annotation.features.majorType.toLowerCase().includes(_searchText)) {
                    return true;
                }

                if (annotation.features.string && annotation.features.string.toLowerCase().includes(_searchText)) {
                    return true;
                }
            }

            if (annotation.type && annotation.type.toLowerCase().includes(_searchText)) {
                return true;
            }

            if (annotation.id) {
                var id = annotation.id + '';
                if (id.includes(_searchText)) {
                    return true;
                }
            }

            return false;
        });
    };

    var changeRowsByPagination = function changeRowsByPagination(state) {
        var elementsOnPage = state.numberOfRows;
        var offset = state.page - 1;
        var from = offset * elementsOnPage;
        var to = offset * elementsOnPage + elementsOnPage;

        return (state.annotations || props.annotations).slice(from, to);
    };

    var handleUpdateRow = function handleUpdateRow(newState) {
        var updatedRows = changeRowsByPagination(newState);
        setNumberOfRows(newState.numberOfRows);
        setPage(newState.page);
        setRows(updatedRows);
    };

    var handleSearch = function handleSearch(e) {
        var filteredAnnotations = filterAnnotations(props.annotations, e.target.value);
        setAnnotations(filteredAnnotations);
        setTotal(filteredAnnotations.length);
        handleUpdateRow({ annotations: filteredAnnotations, numberOfRows: numberOfRows, page: 1 });
    };

    var renderComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'annotations-list-b' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default.a, {
                className: props.annotationsLoaded ? 'hidden' : '',
                style: {
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: props.annotationsLoaded ? 'navigation' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'navigation-arrows' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Libs_Pagination__["a" /* default */], {
                    total: annotations.length,
                    rowsPerPage: rowsPerPage,
                    page: page,
                    numberOfRows: numberOfRows,
                    updateRows: handleUpdateRow
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'navigation-search' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                    hintText: 'Search',
                    hintStyle: { fontSize: 12 },
                    style: { fontSize: 12 },
                    onChange: handleSearch
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'navigation-info' },
                'Total annotations: ',
                annotations.length
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: props.annotationsLoaded ? 'annotations-table' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["Table"],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeader"],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRow"],
                        { style: { height: '28px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                            { style: { padding: '0 24px', height: '28px' } },
                            'Value'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                            { style: { padding: '0 24px', height: '28px' } },
                            'Rule'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                            { style: { padding: '0 24px', height: '28px' } },
                            'Type'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                            { style: { padding: '0 24px', height: '28px' } },
                            'MajorType'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                            { style: { padding: '0 24px', height: '28px' } },
                            'id'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false },
                    rows.map(function (annotation, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRow"],
                            { style: { height: '28px' }, key: i },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                                { style: { padding: '0 24px', height: '28px' } },
                                annotation.features.string
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                                { style: { padding: '0 24px', height: '28px' } },
                                annotation.features.rule
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                                { style: { padding: '0 24px', height: '28px' } },
                                annotation.type
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                                { style: { padding: '0 24px', height: '28px' } },
                                annotation.features.majorType
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                                { style: { padding: '0 24px', height: '28px' } },
                                annotation.id
                            )
                        );
                    })
                )
            )
        )
    );

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        renderComponent
    );
};

var _default = AnnotationsList;
/* harmony default export */ __webpack_exports__["a"] = (_default);

// export default connect(
//     (state, ownProps) => ({
//         // annotations: state.annotations.items || ownProps.annotations,
//         // isLoaded: state.annotations.isLoaded,
//         // error: state.annotations.error,
//         // isError: state.annotations.isError,
//     }),
//     null,
// )(AnnotationsList);

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnnotationsList, 'AnnotationsList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/AnnotationsList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/common/AnnotationsList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mocks_hire_order__ = __webpack_require__(1994);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable no-case-declarations */



/**
 * 
 * @param {*[]} state 
 * @param {{ type: DispatchTypes, payload?: any }} action 
 * @returns 
 */
var reducer = function reducer(state, action) {
    switch (action.type) {
        case 'ADD_ORDER':
            return [].concat(_toConsumableArray(state), [__WEBPACK_IMPORTED_MODULE_1_mocks_hire_order__["a" /* order */]]);
        case 'REMOVE_ORDER':
            return state.slice(0, -1);
        case 'CLEAR_ORDERS':
            return [__WEBPACK_IMPORTED_MODULE_1_mocks_hire_order__["a" /* order */]];
        case 'UPDATE_ORDER':
            var stateCopy = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);
            var _action$payload = action.payload,
                index = _action$payload.index,
                value = _action$payload.value;


            stateCopy[index] = value;

            return stateCopy;
        default:
            return state;
    }
};

/**
 * @typedef {React.Dispatch<{type: DispatchTypes; payload?: any;}>} TDispatchHireOrders
 */

/**
 * @typedef {'ADD_ORDER' | 'REMOVE_ORDER' | 'CLEAR_ORDERS' | 'UPDATE_ORDER'} DispatchTypes
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(reducer, 'reducer', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/Hire/hireOrdersReducer.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return order; });
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

var portRegion = {
  _id: undefined,
  name: undefined
};

var order = {
  vesselName: undefined,
  vesselId: undefined,
  hire: undefined,
  hireType: undefined,
  delivery: Object.assign({}, portRegion),
  redelivery: Object.assign({}, portRegion),
  mainRegionDelivery: Object.assign({}, portRegion),
  mainRegionRedelivery: Object.assign({}, portRegion),
  lay: new Date(new Date().setHours(0, 0, 0, 0)),
  can: new Date(new Date().setHours(23, 59, 59, 999)),
  duration: undefined,
  cargoId: undefined,
  cargo: {
    _id: undefined,
    name: undefined
    // parent: {
    //     red: {
    //         _id: undefined,
    //         name: undefined,
    //     },
    // },
  },
  cargoRegionId: undefined,
  cargoRegion: {
    _id: undefined,
    name: undefined
  },
  vesselData: {}
};

/**
 * @typedef {'hireIdea' | 'fixedRate' | 'offerRate'} HireType
 */

/**
 * @typedef {Object} Cargo
 * @property {string | undefined} _id
 * @property {string | undefined} name
 */

/**
 * @typedef {Object} CargoRegion
 * @property {string | undefined} _id
 * @property {string | undefined} name
 */

/**
 * @typedef {Object} DelRedel
 * @property {string | undefined} _id
 * @property {string | undefined} name
 */

/**
 * @typedef {Object} HireOrderRaw
 * @property {string | undefined} vesselName
 * @property {string | undefined} vesselId
 * @property {string | undefined} hire
 * @property {HireType | undefined} hireType
 * @property {DelRedel} delivery
 * @property {DelRedel} redelivery
 * @property {Date | undefined} mainRegionDelivery
 * @property {Date | undefined} mainRegionRedelivery
 * @property {string | undefined} duration
 * @property {string | undefined} cargoId
 * @property {Cargo} cargo
 * @property {CargoRegion} cargoRegion
 * @property {string | undefined} cargoRegionId
 * @property {{ _id: string, name: string }} vesselData
 */

/**
 * @typedef {Object} HireOrder
 * @property {string} vesselId
 * @property {number} hire
 * @property {HireType} hireType
 * @property {string} delivery
 * @property {string} redelivery
 * @property {string} [duration]
 * @property {string} [cargoId]
 * @property {string} [cargoRegionId]
 */

;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(portRegion, "portRegion", "/opt/atlassian/pipelines/agent/build/client/app/mocks/hire/order.js");
  reactHotLoader.register(order, "order", "/opt/atlassian/pipelines/agent/build/client/app/mocks/hire/order.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Base_UserSelector__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Order_SalesOrder__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Vessel_Content_AnnotationsEditor__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Vessel_Content_AnnotationsList__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HtmlContent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Vessel_Content_TextEditor__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sagas_letters__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sagas_annotations__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_actions_letters__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_actions_vessels_sales__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Attachments__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Vessel_ErrorBoundary__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_sagas_orders__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_FailedToSent__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__common_ToSpamButton__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */










































// import Trainings from '../Gazetter/Trainings';






var VesselSales = function (_React$Component) {
    _inherits(VesselSales, _React$Component);

    function VesselSales(props) {
        var _this2 = this;

        _classCallCheck(this, VesselSales);

        var _this = _possibleConstructorReturn(this, (VesselSales.__proto__ || Object.getPrototypeOf(VesselSales)).call(this, props));

        _this.toggleAttachmentsDialog = function () {
            _this.setState({
                openedAttachmentsDialog: !_this.state.openedAttachmentsDialog
            });
        };

        _this.toggleFailedToSentOpen = function () {
            _this.setState({
                failedToSentOpen: !_this.state.failedToSentOpen
            });
        };

        _this.sendRequestSaleFromSent = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(failedTwinLetterData) {
                var vesselSales, results, vesselSalesRequests, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, vesselSalesRequest, response;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vesselSales = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this.props.vesselSales);

                                if (vesselSales.length) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:
                                results = [];
                                vesselSalesRequests = [];


                                vesselSales.forEach(function (vesselSale, keyVesselSale) {
                                    vesselSalesRequests.push({
                                        mailId: failedTwinLetterData._id,
                                        ideaPrice: vesselSale.ideaPrice,
                                        salePrice: vesselSale.salePrice,
                                        vessel: vesselSale.vessel,
                                        context: failedTwinLetterData.context,
                                        realUserEmail: failedTwinLetterData.realUserEmail,
                                        keyVesselSale: keyVesselSale
                                    });
                                });

                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 9;
                                _iterator = vesselSalesRequests[Symbol.iterator]();

                            case 11:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 33;
                                    break;
                                }

                                vesselSalesRequest = _step.value;
                                _context.next = 15;
                                return __WEBPACK_IMPORTED_MODULE_31_services__["a" /* default */].postVesselSale(vesselSalesRequest.vessel, vesselSalesRequest);

                            case 15:
                                response = _context.sent;

                                if (!(response.status === 200)) {
                                    _context.next = 23;
                                    break;
                                }

                                results.push(_extends({}, response.data, {
                                    status: 'success'
                                }));
                                _context.next = 20;
                                return __WEBPACK_IMPORTED_MODULE_31_services__["a" /* default */].sendRefNumber(failedTwinLetterData._id, {
                                    refNo: response.data.refNo,
                                    requestId: response.data.id || response.data._id
                                });

                            case 20:
                                _this.saveRequestsDataCreated(vesselSalesRequest);
                                _context.next = 30;
                                break;

                            case 23:
                                if (!(response.status === 409)) {
                                    _context.next = 29;
                                    break;
                                }

                                results.push(_extends({
                                    status: 'success'
                                }, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[1]')));
                                _context.next = 27;
                                return __WEBPACK_IMPORTED_MODULE_31_services__["a" /* default */].sendRefNumber(failedTwinLetterData._id, {
                                    refNo: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[1]').refNo,
                                    requestId: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[1]')._id
                                });

                            case 27:
                                _context.next = 30;
                                break;

                            case 29:
                                results.push({
                                    status: 'error',
                                    message: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'errors[0].messages[0]')
                                });

                            case 30:
                                _iteratorNormalCompletion = true;
                                _context.next = 11;
                                break;

                            case 33:
                                _context.next = 39;
                                break;

                            case 35:
                                _context.prev = 35;
                                _context.t0 = _context['catch'](9);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 39:
                                _context.prev = 39;
                                _context.prev = 40;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 42:
                                _context.prev = 42;

                                if (!_didIteratorError) {
                                    _context.next = 45;
                                    break;
                                }

                                throw _iteratorError;

                            case 45:
                                return _context.finish(42);

                            case 46:
                                return _context.finish(39);

                            case 47:
                                return _context.abrupt('return', results);

                            case 48:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[9, 35, 39, 47], [40,, 42, 46]]);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        if (localStorage.getItem('settings-sales-vessel' + props.objUser.user._id)) {
            _this.initialState = JSON.parse(localStorage.getItem('settings-sales-vessel' + props.objUser.user._id));
        } else {
            _this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem('settings-sales-vessel' + props.objUser.user._id, JSON.stringify(_this.initialState));
        }

        _this.state = _extends({}, _this.initialState, {
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientVessel: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            failedToSentOpen: false,
            isFormChanged: false,
            vesselSalesDuplicates: []
        });

        _this.addSaleTable = _this.addSaleTable.bind(_this);
        _this.sendRequestSale = _this.sendRequestSale.bind(_this);
        _this.removeSaleTable = _this.removeSaleTable.bind(_this);
        _this.changeAnnotationsServer = _this.changeAnnotationsServer.bind(_this);
        _this.changeClarifiedServer = _this.changeClarifiedServer.bind(_this);
        _this.clearSaleTable = _this.clearSaleTable.bind(_this);
        _this.updatePostGazetters = _this.updatePostGazetters.bind(_this);
        _this.getLetterData = _this.getLetterData.bind(_this);

        _this.handleClientChange = _this.handleClientChange.bind(_this);
        _this.saveRequestsDataCreated = _this.saveRequestsDataCreated.bind(_this);
        return _this;
    }

    _createClass(VesselSales, [{
        key: 'getLetterData',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(textEdit) {
                var _ref3, letter, annotationsResponse;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_17_sagas_letters__["b" /* getLetter */], this.props.routeParams.id, 'vessel');

                            case 3:
                                _ref3 = _context2.sent;
                                letter = _ref3.data;

                                letter.gazettersArr = [];
                                letter.type = 'vessel';
                                if (textEdit) {
                                    letter.text = textEdit;
                                }
                                letter.fromVesselSales = true;
                                _context2.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_18_sagas_annotations__["b" /* postAnnotations */], letter.text, letter.type, this.state.annotationsServer, {
                                    emailId: letter._id,
                                    subject: letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(letter.date).format('DD-MM-YYYY')
                                });

                            case 11:
                                annotationsResponse = _context2.sent;


                                if (annotationsResponse) {
                                    letter.gazettersArr = annotationsResponse.data.annotations;
                                    if (annotationsResponse.data.newclarified) {
                                        letter.newclarified = annotationsResponse.data.newclarified;
                                    }
                                }

                                _context2.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_19_sagas_lettersNew__["d" /* updateLetter */], __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.omit(letter, 'gazettersArr'), 'vessel', this.state.clarifiedServer);

                            case 15:
                                _context2.next = 20;
                                break;

                            case 17:
                                _context2.prev = 17;
                                _context2.t0 = _context2['catch'](0);

                                Object(__WEBPACK_IMPORTED_MODULE_24_actions_notifications_notifications__["a" /* addNotification */])({
                                    type: __WEBPACK_IMPORTED_MODULE_27_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                                    notification: {
                                        title: 'Error',
                                        message: _context2.t0.errors.messages[0],
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 10
                                    }
                                });

                            case 20:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 17]]);
            }));

            function getLetterData(_x2) {
                return _ref2.apply(this, arguments);
            }

            return getLetterData;
        }()
    }, {
        key: 'changeAnnotationsServer',
        value: function changeAnnotationsServer(e, i, value) {
            var _this3 = this;

            this.initialState = {
                annotationsServer: value,
                clarifiedServer: this.state.clarifiedServer
            };

            localStorage.setItem('settings-sales-vessel' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this3.getLetterData();
            });
        }
    }, {
        key: 'changeClarifiedServer',
        value: function changeClarifiedServer(e, i, value) {
            var _this4 = this;

            this.initialState = {
                annotationsServer: this.state.annotationsServer,
                clarifiedServer: value
            };

            localStorage.setItem('settings-sales-vessel' + this.props.objUser.user._id, JSON.stringify(this.initialState));

            this.setState(this.initialState, function () {
                _this4.getLetterData();
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var state = this.props.location.state;

            if (state) {
                this.getLetterData(state.modifiedTextLetter);
            } else {
                this.getLetterData();
            }
        }
    }, {
        key: 'changeServer',
        value: function changeServer(e, i, value) {
            var _this5 = this;

            this.setState({
                selectedServer: value
            }, function () {
                _this5.getLetterData();
            });
        }
    }, {
        key: 'createVesselSalesRequest',
        value: function createVesselSalesRequest(vesselSale, keyVesselSale, vesselSalesRequests) {
            var _props$letter = this.props.letter,
                _id = _props$letter._id,
                _props$letter$context = _props$letter.context,
                kind = _props$letter$context.kind,
                parser = _props$letter$context.parser,
                companyId = _props$letter$context.companyId,
                userId = _props$letter$context.userId,
                realUserEmail = _props$letter.realUserEmail;

            vesselSalesRequests.push({
                mailId: this.props.letter._id,
                ideaPrice: vesselSale.ideaPrice,
                salePrice: vesselSale.salePrice,
                vessel: vesselSale.vessel,
                context: {
                    kind: kind,
                    parser: parser,
                    companyId: companyId._id,
                    userId: userId._id
                },
                realUserEmail: realUserEmail,
                keyVesselSale: keyVesselSale
            });
        }
    }, {
        key: 'saveRequestsDataCreated',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(order) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_29_sagas_orders__["a" /* saveRequestsDataCreated */], 'sales', order);

                            case 3:
                                _context3.next = 8;
                                break;

                            case 5:
                                _context3.prev = 5;
                                _context3.t0 = _context3['catch'](0);

                                console.error(_context3.t0);

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 5]]);
            }));

            function saveRequestsDataCreated(_x3) {
                return _ref4.apply(this, arguments);
            }

            return saveRequestsDataCreated;
        }()
    }, {
        key: 'sendRequestSale',
        value: function sendRequestSale() {
            var _this6 = this;

            var vesselSales = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.vesselSales);

            if (!vesselSales.length) {
                return;
            }

            this.setState({
                isFormChanged: false,
                vesselSalesDuplicates: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.vesselSales)
            });

            var vesselSalesRequests = [];

            vesselSales.forEach(function (vesselSale, keyVesselSale) {
                _this6.saveRequestsDataCreated(vesselSale);
                _this6.createVesselSalesRequest(vesselSale, keyVesselSale, vesselSalesRequests);
            });

            vesselSalesRequests.forEach(function (vesselSalesRequest) {
                _this6.props.postVesselSale(vesselSalesRequest.vessel, vesselSalesRequest);
            });
        }
    }, {
        key: 'removeSaleTable',
        value: function removeSaleTable() {
            this.props.removeLastVesselSale();
        }
    }, {
        key: 'clearSaleTable',
        value: function clearSaleTable() {
            this.props.removeLastVesselSale();
            this.props.addVesselSale();
        }
    }, {
        key: 'addSaleTable',
        value: function addSaleTable() {
            this.props.addVesselSale();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.removeGazetters();
            this.props.removeAnnotations();
            this.props.removeLetter();
        }
    }, {
        key: 'updatePostGazetters',
        value: function updatePostGazetters(textLetter) {
            var _this7 = this;

            this.setState({
                textLetter: textLetter,
                gazetters: [],
                filteredGazetters: [],
                annotations: [],
                updated: true
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this7.props.postGazetters(textLetter, {
                                    emailId: _this7.props.letter._id,
                                    subject: _this7.props.letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(_this7.props.letter.date).format('DD-MM-YYYY')
                                });

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this7);
            })));
        }
    }, {
        key: 'handleClientChange',
        value: function handleClientChange(e, i, value) {
            this.setState({ clientVessel: value });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(nextProps.vesselSales, this.state.vesselSalesDuplicates)) {
                this.setState({ isFormChanged: true });
            } else {
                this.setState({ isFormChanged: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this8 = this;

            var _state = this.state,
                annotationsServer = _state.annotationsServer,
                clarifiedServer = _state.clarifiedServer,
                textLetter = _state.textLetter,
                updated = _state.updated,
                clientVessel = _state.clientVessel,
                openedAttachmentsDialog = _state.openedAttachmentsDialog,
                failedToSentOpen = _state.failedToSentOpen;
            var _props = this.props,
                routeParams = _props.routeParams,
                letter = _props.letter,
                router = _props.router,
                vesselSales = _props.vesselSales,
                user = _props.user,
                location = _props.location;


            var modifiedTextLetter = void 0;
            var initialTextLetter = void 0;

            if (location.state) {
                modifiedTextLetter = location.state.modifiedTextLetter;
                initialTextLetter = location.state.initialTextLetter;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'single-letter-cargo', className: 'single-letter' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'management' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'management-children' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                label: 'Gazetteer',
                                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id }),
                                primary: true,
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_28__Vessel_ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HtmlContent__["a" /* default */], {
                                    letter: letter
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Vessel_Content_TextEditor__["a" /* default */], {
                                textLetter: modifiedTextLetter || textLetter || letter.text,
                                originalText: initialTextLetter || letter.text,
                                removeGazetters: this.props.removeGazetters,
                                removeAnnotations: this.props.removeAnnotations,
                                getLetterData: this.getLetterData,
                                updatePostGazetters: this.updatePostGazetters
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Attachments__["a" /* default */], {
                                openedAttachmentsDialog: openedAttachmentsDialog,
                                toggleAttachmentsDialog: this.toggleAttachmentsDialog,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px -10px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                className: 'btn',
                                attachments: letter.attachments
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Size',
                                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id + '/size/vessel' }),
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_6_store_configureStore__["a" /* UserPerms */].isAdmin() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Annotations server',
                                        className: 'btn',
                                        value: annotationsServer,
                                        onChange: this.changeAnnotationsServer,
                                        style: { width: '155px' }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'mailparse.net', primaryText: 'mailparse.net' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 's4.anotatr.com', primaryText: 's4.anotatr.com' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'nata.im', primaryText: 'nata.im' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'localhost', primaryText: 'localhost' })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Clarified server',
                                        className: 'btn',
                                        value: clarifiedServer,
                                        onChange: this.changeClarifiedServer,
                                        style: { width: '110px' },
                                        autoWidth: true
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'standart', primaryText: 'api' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 'localhost:7775', primaryText: 'localhost' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { value: 's4.anotatr.com:7777', primaryText: 's4.anotatr.com' })
                                )
                            ) : '',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__common_ToSpamButton__["a" /* default */], {
                                letterId: letter._id,
                                onSuccess: function onSuccess() {
                                    _this8.getLetterData();
                                },
                                disabled: letter.type === 'spam'
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common_FailedToSent__["b" /* default */], {
                                open: failedToSentOpen,
                                failedTwinsList: letter.failedTwinsByTextHash || [],
                                handleToggleDialog: this.toggleFailedToSentOpen,
                                disabled: this.state.isFormChanged,
                                sendRequest: this.sendRequestSaleFromSent
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject', style: { width: '150px' } },
                            'SUBJECT: ',
                            letter.subject
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject' },
                            'refNo: ',
                            letter.refNo
                        )
                    ),
                    updated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_28__Vessel_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Vessel_Content_AnnotationsEditor__["a" /* default */], { letterText: textLetter || letter.text })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_28__Vessel_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Vessel_Content_AnnotationsEditor__["a" /* default */], { letterText: modifiedTextLetter || letter.text })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_28__Vessel_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Vessel_Content_AnnotationsList__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'sidebar' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h1',
                        null,
                        'Vessel  sales ',
                        vesselSales.length
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_28__Vessel_ErrorBoundary__["a" /* default */],
                        null,
                        vesselSales.map(function (vesselSale, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Order_SalesOrder__["a" /* default */], {
                                numberSaleTable: key,
                                key: key
                            });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Base_UserSelector__["a" /* default */], {
                        handleClientChange: this.handleClientChange,
                        client: clientVessel,
                        user: user,
                        letter: letter,
                        errorUser: vesselSales[0] && vesselSales[0].validateErrors.find(function (v) {
                            return v.field === 'user';
                        }),
                        onUserUpdate: this.props.updateVesselSaleUser
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'controller-orders' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_26_styles__["a" /* default */].btnOrders, onClick: this.addSaleTable, label: 'Add' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_26_styles__["a" /* default */].btnOrders, onClick: this.removeSaleTable, label: 'Remove' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_26_styles__["a" /* default */].btnOrders, onClick: this.clearSaleTable, label: 'Clear' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_26_styles__["a" /* default */].btnOrders, onClick: this.sendRequestSale, label: 'Send' })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselSales;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        objUser: state.user,
        user: state.vesselSales.user,
        vesselSales: state.vesselSales.items,
        isLogged: state.user.isLogged,
        letter: state.letter,
        annotations: state.annotations.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateVesselSaleUser: __WEBPACK_IMPORTED_MODULE_23_actions_vessels_sales__["i" /* updateVesselSaleUser */],
        postAnnotations: __WEBPACK_IMPORTED_MODULE_21_actions_annotations__["a" /* postAnnotations */],
        postGazetters: __WEBPACK_IMPORTED_MODULE_22_actions_gazetters__["a" /* postGazetters */],
        addVesselSale: __WEBPACK_IMPORTED_MODULE_23_actions_vessels_sales__["a" /* addVesselSale */],
        removeLastVesselSale: __WEBPACK_IMPORTED_MODULE_23_actions_vessels_sales__["f" /* removeLastVesselSale */],
        postVesselSale: __WEBPACK_IMPORTED_MODULE_23_actions_vessels_sales__["e" /* postVesselSale */],
        removeGazetters: __WEBPACK_IMPORTED_MODULE_22_actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_21_actions_annotations__["b" /* removeAnnotations */],
        removeLetter: __WEBPACK_IMPORTED_MODULE_20_actions_letters__["a" /* removeLetter */]
    }, dispatch);
})(VesselSales);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselSales, 'VesselSales', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sale__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Name__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_RequestTitle__ = __webpack_require__(272);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SalesOrder = function (_React$Component) {
    _inherits(SalesOrder, _React$Component);

    function SalesOrder(props) {
        _classCallCheck(this, SalesOrder);

        var _this = _possibleConstructorReturn(this, (SalesOrder.__proto__ || Object.getPrototypeOf(SalesOrder)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(SalesOrder, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'sidebar-table' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_RequestTitle__["a" /* default */], {
                    orderNumber: this.props.numberSaleTable + 1,
                    text: 'VESSEL SALE NUMBER',
                    warnings: this.props.vesselSale.warnings
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Name__["a" /* default */], { numberSaleTable: this.props.numberSaleTable }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sale__["a" /* default */], { numberSaleTable: this.props.numberSaleTable })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SalesOrder;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {

    var vesselSale = state.vesselSales.items[ownProps.numberSaleTable];

    return {
        numberSaleTable: ownProps.numberSaleTable,
        vesselSale: vesselSale,
        message: vesselSale.successMessage.message ? vesselSale.successMessage.message : ''
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        // clearMessage,
    }, dispatch);
})(SalesOrder);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SalesOrder, 'SalesOrder', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Order/SalesOrder.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Order/SalesOrder.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_vessels_sales__ = __webpack_require__(191);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SaleInputs = function (_React$Component) {
    _inherits(SaleInputs, _React$Component);

    function SaleInputs() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SaleInputs);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SaleInputs.__proto__ || Object.getPrototypeOf(SaleInputs)).call.apply(_ref, [this].concat(args))), _this), _this.onChangePrice = function (type, value) {
            _this.props.updateVesselSale(_this.props.numberSaleTable, _extends({}, Object.assign({}, _this.props.vesselSale), _defineProperty({}, type, value)));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SaleInputs, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$vesselSale = this.props.vesselSale,
                ideaPrice = _props$vesselSale.ideaPrice,
                salePrice = _props$vesselSale.salePrice;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                        style: { fontSize: '13px', marginLeft: "10px" },
                        value: ideaPrice || '',
                        hintText: 'Price Idea',
                        onChange: function onChange(e) {
                            return _this2.onChangePrice("ideaPrice", e.target.value);
                        },
                        floatingLabelText: 'Price Idea'
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                        style: { fontSize: '13px', marginLeft: "10px" },
                        value: salePrice || '',
                        hintText: 'Sale Price',
                        onChange: function onChange(e) {
                            return _this2.onChangePrice("salePrice", e.target.value);
                        },
                        floatingLabelText: 'Sale Price'
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SaleInputs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {

    var errorVesselName = state.vesselSales.items[ownProps.numberSaleTable].validateErrors.find(function (validateError) {
        return validateError.field === 'vessel';
    });

    return {
        numberSaleTable: ownProps.numberSaleTable,
        errorVesselName: errorVesselName,
        vesselSale: state.vesselSales.items[ownProps.numberSaleTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateVesselSale: __WEBPACK_IMPORTED_MODULE_4_actions_vessels_sales__["h" /* updateVesselSale */]
    }, dispatch);
})(SaleInputs);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SaleInputs, 'SaleInputs', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Order/Sale.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Order/Sale.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_vessels_sales__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Name = function (_React$Component) {
    _inherits(Name, _React$Component);

    function Name(props) {
        _classCallCheck(this, Name);

        var _this = _possibleConstructorReturn(this, (Name.__proto__ || Object.getPrototypeOf(Name)).call(this, props));

        _this.state = {
            vesselNames: [],
            vesselName: props.vesselSale.vesselName,
            imoNumber: props.vesselSale.imoNumber,
            DWT: props.vesselSale.DWT,
            BLT: props.vesselSale.BLT,
            _id: props.vesselSale.vessel
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (searchText) {
            __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findVessel(searchText).then(function (response) {
                var vesselNames = response.data.data.map(function (vessel) {
                    return {
                        name: vessel.name + ' (imoNumber - ' + vessel.imoNumber + ')',
                        item: vessel
                    };
                });

                _this.setState({
                    vesselNames: vesselNames
                });
            }).then(function () {
                var newVesselSale = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.vesselSale);
                newVesselSale.vesselName = searchText;
                _this.props.updateVesselSale(_this.props.numberSaleTable, newVesselSale);
            }).catch(function () {
                return null;
            });
        }, 1000);

        _this.changeVesselName = _this.changeVesselName.bind(_this);
        _this.chooseVessel = _this.chooseVessel.bind(_this);
        return _this;
    }

    _createClass(Name, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            this.setState({
                vesselName: props.vesselSale.vesselName,
                imoNumber: props.vesselSale.imoNumber,
                DWT: props.vesselSale.DWT,
                BLT: props.vesselSale.BLT,
                _id: props.vesselSale.vessel
            });
        }
    }, {
        key: 'changeVesselName',
        value: function changeVesselName(searchText) {
            var _this2 = this;

            this.setState({
                vesselName: searchText
            }, function () {
                _this2.dAutocomplete(searchText);
            });
        }
    }, {
        key: 'chooseVessel',
        value: function chooseVessel(updateProperties) {
            if (!updateProperties) {
                return;
            }

            var newVesselSale = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.props.vesselSale);

            newVesselSale.vesselName = updateProperties.name;
            newVesselSale.vessel = updateProperties.item._id;
            newVesselSale.imoNumber = updateProperties.item.imoNumber;
            newVesselSale.DWT = updateProperties.item.dw.summer;
            newVesselSale.BLT = updateProperties.item.blt;

            this.props.updateVesselSale(this.props.numberSaleTable, newVesselSale);

            this.setState({
                imoNumber: updateProperties.item.imoNumber,
                DWT: updateProperties.item.dw.summer,
                BLT: updateProperties.item.blt,
                _id: updateProperties.item._id
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var errorVesselName = this.props.errorVesselName ? this.props.errorVesselName.messages[0] : '';

            var _state = this.state,
                _id = _state._id,
                vesselName = _state.vesselName;
            var params = this.props.params;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Vessel name:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right', style: { display: 'flex' } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a, {
                            name: 'vesselName',
                            textFieldStyle: { fontSize: '13px' },
                            hintText: 'Vessel name',
                            errorText: errorVesselName,
                            searchText: this.state.vesselName || '',
                            dataSource: this.state.vesselNames,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: this.changeVesselName,
                            onNewRequest: this.chooseVessel,
                            filter: __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a.noFilter,
                            fullWidth: true,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true
                            },
                            style: { display: 'flex', width: '70%', marginRight: '10px' }
                        }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["r" /* RaisedButton */], {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px', margin: 'auto 0' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Composition',
                            onClick: function onClick() {
                                var url = 'emailId=' + params.id;
                                if (_id && vesselName) {
                                    url += '&_id=' + _id + '&name=' + vesselName;
                                }
                                window.open(window.location.origin + '/vessels/composition?' + url, '_blank');
                            },
                            secondary: true
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'imoNumber:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            this.state.imoNumber
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'DWT:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            this.state.DWT
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'BLT:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'label' },
                            this.state.BLT
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Name;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var errorVesselName = state.vesselSales.items[ownProps.numberSaleTable].validateErrors.find(function (validateError) {
        return validateError.field === 'vessel';
    });

    return {
        numberSaleTable: ownProps.numberSaleTable,
        errorVesselName: errorVesselName,
        vesselSale: state.vesselSales.items[ownProps.numberSaleTable]
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateVesselSale: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_sales__["h" /* updateVesselSale */]
    }, dispatch);
})(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* withRouter */])(Name));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Name, 'Name', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Order/Name.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Sales/Order/Name.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sagas_letters__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sagas_gazetters__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_actions_cargoes_orders__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_actions_vessels_orders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Sidebar_UniqueGazetters__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Sidebar_FiltersAnnotations__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Content_ChooseContent__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Management_AnnotateLike__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Management_TextEditor__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Management_AddMailRecognizeSpam__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__HtmlContent__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__List_Annotation__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__List_Gazetter__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Attachments__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__PredictorType__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SaveLink__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__HOC__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__common_ToSpamButton__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__SingleNew_ArchiveLetter__ = __webpack_require__(864);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













































// import Trainings from './Trainings';







var styles = {
    select: {
        style: {
            width: '130px'
        }
    },
    textField: {
        style: {
            width: '50px',
            marginRight: '10px'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    checkbox: {
        style: {
            display: 'inline-block',
            width: 'auto',
            verticalAlign: 'middle',
            margin: '0 10px 0 0',
            fontSize: '12px'
        }
    }
};

var GazetterPage = function (_React$Component) {
    _inherits(GazetterPage, _React$Component);

    function GazetterPage(props) {
        var _this2 = this;

        _classCallCheck(this, GazetterPage);

        var _this = _possibleConstructorReturn(this, (GazetterPage.__proto__ || Object.getPrototypeOf(GazetterPage)).call(this, props));

        _this.toggleAttachmentsDialog = function () {
            _this.setState({
                openedAttachmentsDialog: !_this.state.openedAttachmentsDialog
            });
        };

        _this.fetchPredictorType = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _this$state, letter, textLetter, response;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$state = _this.state, letter = _this$state.letter, textLetter = _this$state.textLetter;

                            if (letter) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt('return');

                        case 3:

                            _this.setState({ predictorLoading: true });
                            _context.next = 6;
                            return __WEBPACK_IMPORTED_MODULE_13_services__["a" /* default */].fetchPredictorType({
                                _id: letter._id,
                                text: textLetter,
                                owner: letter.owner ? letter.owner._id : undefined
                            });

                        case 6:
                            response = _context.sent;


                            _this.setState({
                                predictorData: response.status === 200 ? response.data : null,
                                predictorLoading: false
                            });

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.onToggleShowUsefulLines = function () {
            _this.setState(function (prev) {
                return { showUsefulLines: !prev.showUsefulLines };
            });
        };

        _this.state = {
            textLetter: '',
            selectedType: '',

            withChildren: false,

            selectedServer: 'mailparse.net',

            gazetters: [],
            filteredGazetters: [],

            annotations: [],

            searchTextGazetter: '',

            typeAnnotations: 'annotate',
            timeout: 40,

            openedAttachmentsDialog: false,
            isSimpleForm: false,

            gazettersChanges: [],
            // predictor
            predictorData: null,
            predictorLoading: false,
            showUsefulLines: false
        };

        _this.selectTypeLetter = _this.selectTypeLetter.bind(_this);
        _this.selectTypeServer = _this.selectTypeServer.bind(_this);

        _this.updatePostGazetters = _this.updatePostGazetters.bind(_this);
        _this.updatePostAnnotations = _this.updatePostAnnotations.bind(_this);

        _this.changeTypeAnnotations = _this.changeTypeAnnotations.bind(_this);
        _this.resendAnnotations = _this.resendAnnotations.bind(_this);
        _this.filterGazetters = _this.filterGazetters.bind(_this);

        _this.changeGazetter = _this.changeGazetter.bind(_this);
        _this.addNewGazetter = _this.addNewGazetter.bind(_this);
        _this.removeGazetter = _this.removeGazetter.bind(_this);
        _this.clearGazetter = _this.clearGazetter.bind(_this);
        _this.saveGazetters = _this.saveGazetters.bind(_this);

        _this.renderWithAnnotationFilters = _this.renderWithAnnotationFilters.bind(_this);
        _this.renderOriginalAnnotations = _this.renderOriginalAnnotations.bind(_this);

        _this.changeWithChildren = _this.changeWithChildren.bind(_this);
        _this.changeTimeout = _this.changeTimeout.bind(_this);

        _this.saveEmailToDev = _this.saveEmailToDev.bind(_this);
        _this.openEmailFromDev = _this.openEmailFromDev.bind(_this);
        return _this;
    }

    _createClass(GazetterPage, [{
        key: 'changeWithChildren',
        value: function changeWithChildren() {
            this.setState(function (state) {
                return {
                    withChildren: !state.withChildren
                };
            });
        }
    }, {
        key: 'renderWithAnnotationFilters',
        value: function renderWithAnnotationFilters(levelList) {
            var annotations = this.props.annotations;

            var filteredAnnotations = [];

            levelList = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(levelList);

            if (levelList.length === 0) {
                return;
            }

            levelList = levelList.filter(function (level) {
                if (level.rulesList.length === 0) {
                    return false;
                }

                level.rulesList = level.rulesList.filter(function (ruleInner) {
                    return ruleInner._type !== '' || ruleInner.rule !== '';
                });

                return level.rulesList.length !== 0;
            });

            levelList.forEach(function (level, indexLevel) {
                level.rulesList.forEach(function (rule) {
                    var levels = [];

                    if (rule.typeOfRule === 'single') {
                        levels = annotations.filter(function (annotation) {
                            if (rule._type && rule._type !== '') {
                                if (annotation.type.toLowerCase() === rule._type.toLowerCase()) {
                                    return true;
                                }
                            }

                            if (rule.rule && rule.rule !== '') {
                                if (!annotation.features.rule) {
                                    return false;
                                }

                                if (annotation.features.rule.toLowerCase() === rule.rule.toLowerCase()) {
                                    return true;
                                }
                            }

                            return false;
                        });
                    } else {
                        levels = annotations.filter(function (annotation) {
                            if (rule._type && rule._type !== '') {
                                if (annotation.type.toLowerCase().includes(rule._type.toLowerCase())) {
                                    return true;
                                }
                            }

                            if (rule.rule && rule.rule !== '') {
                                if (!annotation.features.rule) {
                                    return false;
                                }

                                if (annotation.features.rule.toLowerCase().includes(rule.rule.toLowerCase())) {
                                    return true;
                                }
                            }

                            return false;
                        });
                    }

                    levels = levels.map(function (item) {
                        return _extends({}, item, {
                            priority: indexLevel,
                            styles: _extends({}, item.styles, {
                                background: rule.color === '' ? '' : rule.color
                            })
                        });
                    });

                    filteredAnnotations.push(levels);
                });
            });

            this.setState({
                annotations: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flatten(filteredAnnotations)
            });
        }
    }, {
        key: 'renderOriginalAnnotations',
        value: function renderOriginalAnnotations() {
            this.setState({
                annotations: this.props.annotations
            });
        }
    }, {
        key: 'filterGazetters',
        value: function filterGazetters() {
            var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var gazetters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.gazetters;

            text = text.toLowerCase();

            var filteredGazetters = gazetters.filter(function (gazetter) {
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(gazetter, 'gazetteerName') && gazetter.gazetteerName.toLowerCase().includes(text)) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(gazetter, 'value') && gazetter.value.toLowerCase().includes(text)) {
                    return true;
                }

                return false;
            });

            this.setState({
                searchTextGazetter: text,
                filteredGazetters: filteredGazetters,
                gazetters: gazetters
            });
        }
    }, {
        key: 'changeTypeAnnotations',
        value: function changeTypeAnnotations(typeAnnotations) {
            var _this3 = this;

            this.setState({
                typeAnnotations: typeAnnotations,
                annotations: [],
                gazetters: [],
                filteredGazetters: []
            }, function () {
                if (typeAnnotations === 'gazetter') {
                    _this3.updatePostAnnotations();
                } else {
                    _this3.updatePostGazetters();
                }
            });
        }
    }, {
        key: 'resendAnnotations',
        value: function resendAnnotations() {
            var _state = this.state,
                textLetter = _state.textLetter,
                selectedType = _state.selectedType,
                selectedServer = _state.selectedServer,
                timeout = _state.timeout;

            this.props.postAnnotations(textLetter, selectedType, selectedServer, {
                emailId: this.state.letter._id,
                isSimpleForm: this.state.isSimpleForm,
                timeout: timeout,
                subject: this.props.letter.subject,
                date: __WEBPACK_IMPORTED_MODULE_4_moment__(this.props.letter.date).format('DD-MM-YYYY')
            });
        }
    }, {
        key: 'updatePostAnnotations',
        value: function updatePostAnnotations() {
            var textLetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.textLetter;

            var _this4 = this;

            var selectedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.selectedType;
            var selectedServer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.selectedServer;

            this.setState({
                textLetter: textLetter,
                annotations: [],
                gazetters: [],
                filteredGazetters: []
            }, function () {
                _this4.props.postAnnotations(textLetter, selectedType, selectedServer, {
                    emailId: _this4.state.letter._id,
                    timeout: _this4.state.timeout,
                    isSimpleForm: _this4.state.isSimpleForm,
                    subject: _this4.props.letter.subject,
                    date: __WEBPACK_IMPORTED_MODULE_4_moment__(_this4.props.letter.date).format('DD-MM-YYYY')
                });
            });
        }
    }, {
        key: 'updatePostGazetters',
        value: function updatePostGazetters() {
            var _this5 = this;

            var textLetter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.textLetter;

            this.setState({
                textLetter: textLetter,
                gazetters: [],
                filteredGazetters: [],
                annotations: []
            }, function () {
                _this5.props.postGazetters(textLetter, {
                    isSimpleForm: _this5.state.isSimpleForm,
                    subject: _this5.props.letter.subject,
                    date: __WEBPACK_IMPORTED_MODULE_4_moment__(_this5.props.letter.date).format('DD-MM-YYYY')
                });
            });
        }
    }, {
        key: 'selectTypeServer',
        value: function selectTypeServer(e, i, choosenType) {
            var _this6 = this;

            if (this.state.typeAnnotations === 'gazetter') {
                this.setState({
                    selectedServer: choosenType,
                    timeout: choosenType === 'nata.im' ? 300 : 40
                }, function () {
                    _this6.resendAnnotations();
                });

                return;
            }

            this.setState({
                selectedServer: choosenType
            });
        }
    }, {
        key: 'selectTypeLetter',
        value: function selectTypeLetter(e, i, choosenType) {
            var _this7 = this;

            if (this.state.typeAnnotations === 'gazetter') {
                this.setState({
                    selectedType: choosenType
                }, function () {
                    _this7.resendAnnotations();
                });

                return;
            }

            this.setState({
                selectedType: choosenType
            });
        }
    }, {
        key: 'addPropertiesToGazetters',
        value: function addPropertiesToGazetters(gazetters) {
            var someArray = [];
            var cloneGazetters = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(gazetters);

            gazetters.forEach(function (gazetter) {
                someArray.push(cloneGazetters.filter(function (gaz) {
                    return gaz.gazetteerName === gazetter.gazetteerName;
                }));

                cloneGazetters = cloneGazetters.filter(function (gaz) {
                    return gaz.gazetteerName !== gazetter.gazetteerName;
                });
            });

            someArray.forEach(function (item) {
                var color = __WEBPACK_IMPORTED_MODULE_12_helpers__["a" /* default */].createHashColor();

                item.forEach(function (one) {
                    one.color = color;
                });
            });

            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flatten(someArray);
        }
    }, {
        key: 'saveGazetters',
        value: function saveGazetters() {
            this.saveGazettersToServer();
            this.saveGazettersToServerLegacy();
        }
    }, {
        key: 'saveGazettersToServer',
        value: function saveGazettersToServer() {
            var _this8 = this;

            var gazettersChanges = this.state.gazettersChanges;


            if (!gazettersChanges.length) {
                return this.props.addNotification({
                    title: 'No changes',
                    message: 'There are no changes to save.',
                    level: 'info',
                    _id: Math.random(),
                    autoDismiss: 2
                });
            }

            var payload = gazettersChanges.map(function (_ref2) {
                var status = _ref2.status,
                    value = _ref2.value,
                    oldValue = _ref2.oldValue,
                    fileName = _ref2.fileName;
                return {
                    fileName: fileName,
                    status: status,
                    value: value,
                    oldValue: oldValue
                };
            });

            this.props.saveMutation(payload, {
                onSuccess: function onSuccess() {
                    _this8.setState({ gazettersChanges: [] });
                    _this8.updatePostGazetters();
                },
                onError: function onError(error) {
                    _this8.props.addNotification({
                        title: 'Save Failed',
                        message: error.message || 'An unknown error occurred.',
                        level: 'error',
                        _id: Math.random(),
                        autoDismiss: 4
                    });
                }
            });
        }
    }, {
        key: 'saveGazettersToServerLegacy',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this9 = this;

                var gazetters, sendGazetters, formatGazetter, _sendGazetters$reduce, _sendGazetters$reduce2, legacyGazetters, dispatch, response;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                gazetters = this.state.gazetters;
                                sendGazetters = gazetters.filter(function (gazetter) {
                                    return gazetter.status;
                                });

                                if (sendGazetters.length) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return', this.props.addNotification({
                                    title: 'Error',
                                    message: 'gazetters empty',
                                    level: 'error',
                                    _id: Math.random(),
                                    autoDismiss: 2
                                }));

                            case 4:
                                formatGazetter = function formatGazetter(item) {
                                    var oldGazetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                                    var baseFormat = {
                                        fileName: item.gazetteerName,
                                        status: item.status,
                                        value: item.value.trim().replace(/(\r\n|\n|\r)/gm, '')
                                    };

                                    var legacyFormat = _extends({}, baseFormat, {
                                        GazetterName: item.gazetteerName,
                                        GazetterType: item.gazetteerType,
                                        gazType: item.gazetteerType
                                    });

                                    if (item.status === 'replace' && oldGazetter) {
                                        legacyFormat.oldValue = oldGazetter.value || '';
                                    }

                                    return { legacyFormat: legacyFormat, newFormat: baseFormat };
                                };

                                _sendGazetters$reduce = sendGazetters.reduce(function (acc, item) {
                                    var oldGazetter = _this9.props.gazetters.find(function (gaz) {
                                        return gaz.id === item.id;
                                    });

                                    var _formatGazetter = formatGazetter(item, oldGazetter),
                                        legacyFormat = _formatGazetter.legacyFormat,
                                        newFormat = _formatGazetter.newFormat;

                                    return [[].concat(_toConsumableArray(acc[0]), [legacyFormat]), [].concat(_toConsumableArray(acc[1]), [newFormat])];
                                }, [[], []]), _sendGazetters$reduce2 = _slicedToArray(_sendGazetters$reduce, 1), legacyGazetters = _sendGazetters$reduce2[0];
                                dispatch = this.props.dispatch;
                                _context2.prev = 7;
                                _context2.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_14_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_16_sagas_gazetters__["d" /* saveGazetters */], legacyGazetters);

                            case 10:
                                response = _context2.sent;


                                if (response.status === 200) {
                                    this.updatePostGazetters();
                                }
                                _context2.next = 19;
                                break;

                            case 14:
                                _context2.prev = 14;
                                _context2.t0 = _context2['catch'](7);

                                this.props.addNotification({
                                    title: 'Error',
                                    message: _context2.t0.message,
                                    level: 'error',
                                    _id: Math.random(),
                                    autoDismiss: 2
                                });

                                dispatch({
                                    type: __WEBPACK_IMPORTED_MODULE_23_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].FAILURE,
                                    errors: _context2.t0.message
                                });

                                return _context2.abrupt('return', _context2.t0);

                            case 19:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[7, 14]]);
            }));

            function saveGazettersToServerLegacy() {
                return _ref3.apply(this, arguments);
            }

            return saveGazettersToServerLegacy;
        }()
    }, {
        key: 'clearGazetter',
        value: function clearGazetter(gazetter) {
            var _this10 = this;

            var gazetters = this.state.gazetters.map(function (item, i) {
                if (item.id === gazetter.id) {
                    return _extends({}, _this10.props.gazetters.find(function (gaz) {
                        return gaz.id === item.id;
                    }), {
                        id: item.id,
                        color: item.color,
                        status: ''
                    });
                }

                return item;
            });

            this.setState(function (prevState) {
                return {
                    gazettersChanges: prevState.gazettersChanges.filter(function (change) {
                        return change.id !== gazetter.id;
                    })
                };
            });

            this.filterGazetters(this.state.searchTextGazetter, gazetters);
        }
    }, {
        key: 'removeGazetter',
        value: function removeGazetter(gazetter) {
            var _state2 = this.state,
                gazetters = _state2.gazetters,
                gazettersChanges = _state2.gazettersChanges;

            var newGazetters = [];
            var newGazettersChanges = structuredClone(gazettersChanges);

            if (gazetter.status === 'new') {
                newGazetters = gazetters.filter(function (item) {
                    return item.id !== gazetter.id;
                });
                newGazettersChanges = newGazettersChanges.filter(function (item) {
                    return item.id !== gazetter.id;
                });
            } else {
                newGazetters = gazetters.map(function (item) {
                    if (item.id === gazetter.id) {
                        return _extends({}, gazetter, {
                            status: 'remove'
                        });
                    }

                    return item;
                });

                var changeIndex = newGazettersChanges.findIndex(function (item) {
                    return item.id === gazetter.id;
                });
                var change = {
                    id: gazetter.id,
                    fileName: gazetter.gazetteerName,
                    status: 'remove',
                    value: gazetter.value
                };

                if (changeIndex > -1) {
                    newGazettersChanges[changeIndex] = change;
                } else {
                    newGazettersChanges.push(change);
                }
            }

            this.setState({ gazettersChanges: newGazettersChanges });
            this.filterGazetters(this.state.searchTextGazetter, newGazetters);
        }
    }, {
        key: 'changeGazetter',
        value: function changeGazetter(gazetter) {
            var gazetters = this.state.gazetters.map(function (item) {
                if (item.id === gazetter.id) {
                    if (item.status !== 'new') {
                        return _extends({}, gazetter, {
                            status: 'replace'
                        });
                    }
                    return _extends({}, gazetter);
                }

                return item;
            });

            var gazettersChanges = this.state.gazettersChanges;

            var newGazettersChanges = structuredClone(gazettersChanges);
            var changeIndex = newGazettersChanges.findIndex(function (item) {
                return item.id === gazetter.id;
            });
            var originalGazetter = this.state.gazetters.find(function (g) {
                return g.id === gazetter.id;
            });

            if (originalGazetter && originalGazetter.value === gazetter.value) {
                // value is the same as original - remove from changes if it exists
                if (changeIndex > -1) {
                    newGazettersChanges.splice(changeIndex, 1);
                }
            } else {
                var change = {
                    id: gazetter.id,
                    fileName: gazetter.gazetteerName,
                    status: 'replace',
                    value: gazetter.value,
                    oldValue: originalGazetter ? originalGazetter.value : undefined
                };

                if (changeIndex > -1) {
                    var existingChange = newGazettersChanges[changeIndex];
                    if (existingChange.status === 'new') {
                        existingChange.value = gazetter.value;
                    } else {
                        newGazettersChanges[changeIndex] = change;
                    }
                } else {
                    newGazettersChanges.push(change);
                }
            }

            this.setState({
                gazettersChanges: newGazettersChanges
            });

            this.filterGazetters(this.state.searchTextGazetter, gazetters);
        }
    }, {
        key: 'addNewGazetter',
        value: function addNewGazetter(_ref4) {
            var _ref4$gazetteerName = _ref4.gazetteerName,
                gazetteerName = _ref4$gazetteerName === undefined ? '' : _ref4$gazetteerName,
                _ref4$gazetteerType = _ref4.gazetteerType,
                gazetteerType = _ref4$gazetteerType === undefined ? 'common' : _ref4$gazetteerType,
                _ref4$fileName = _ref4.fileName,
                fileName = _ref4$fileName === undefined ? '' : _ref4$fileName,
                _ref4$gazType = _ref4.gazType,
                gazType = _ref4$gazType === undefined ? 'common' : _ref4$gazType,
                _ref4$value = _ref4.value,
                value = _ref4$value === undefined ? '' : _ref4$value;

            if (/:/.test(value)) {
                this.props.addNotification({
                    title: 'Error',
                    message: 'Resticted symbol \':\'',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 2
                });

                this.props.dispatch({
                    type: __WEBPACK_IMPORTED_MODULE_23_constants_ActionTypes__["_96" /* SAVE_GAZETTERS */].FAILURE,
                    errors: 'Resticted symbol \':\''
                });

                return;
            }

            var gazetters = this.state.gazetters;


            var newGazetter = {
                gazetteerName: gazetteerName,
                gazetteerType: gazetteerType,

                fileName: fileName,
                gazType: gazType,

                status: 'new',
                value: value,

                id: __WEBPACK_IMPORTED_MODULE_12_helpers__["a" /* default */].getNextId(gazetters)
            };

            gazetters.unshift(newGazetter);

            this.setState(function (prevState) {
                return {
                    gazettersChanges: [].concat(_toConsumableArray(prevState.gazettersChanges), [{
                        id: newGazetter.id,
                        fileName: gazetteerName || fileName,
                        value: value,
                        status: 'new'
                    }])
                };
            });

            this.filterGazetters(this.state.searchTextGazetter, gazetters);
        }
    }, {
        key: 'changeTimeout',
        value: function changeTimeout(e, timeout) {
            this.setState({
                timeout: timeout
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this11 = this;

            var _state3 = this.state,
                textLetter = _state3.textLetter,
                selectedType = _state3.selectedType;


            if (textLetter === '' && nextProps.letter.text) {
                textLetter = nextProps.letter.text;
            }

            if (selectedType === '' && nextProps.letter.type) {
                selectedType = nextProps.letter.type;
            }

            var gazetters = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.state.gazetters, nextProps.gazetters) ? this.state.gazetters : this.addPropertiesToGazetters(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(nextProps.gazetters));

            this.setState({
                gazetters: gazetters,
                annotations: nextProps.annotations,
                selectedType: selectedType,
                textLetter: textLetter,
                letter: nextProps.letter
            }, function () {
                var _state4 = _this11.state,
                    searchTextGazetter = _state4.searchTextGazetter,
                    gazetters = _state4.gazetters,
                    typeAnnotations = _state4.typeAnnotations;


                if (typeAnnotations !== 'gazetters') {
                    _this11.filterGazetters(searchTextGazetter, gazetters);
                }
            });
        }
    }, {
        key: 'getData',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _ref6, letter;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_14_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_15_sagas_letters__["b" /* getLetter */], this.props.routeParams.id);

                            case 3:
                                _ref6 = _context3.sent;
                                letter = _ref6.data;

                                this.setState({
                                    initialTextLetter: letter.text
                                });
                                _context3.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_14_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_16_sagas_gazetters__["b" /* getListGazetters */]);

                            case 8:
                                _context3.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_14_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_16_sagas_gazetters__["c" /* postGazetters */], letter.text, {
                                    isSimpleForm: this.state.isSimpleForm,
                                    subject: this.props.letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_4_moment__(this.props.letter.date).format('DD-MM-YYYY')
                                });

                            case 10:
                                _context3.next = 15;
                                break;

                            case 12:
                                _context3.prev = 12;
                                _context3.t0 = _context3['catch'](0);

                                console.error(_context3.t0);

                            case 15:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 12]]);
            }));

            function getData() {
                return _ref5.apply(this, arguments);
            }

            return getData;
        }()
    }, {
        key: 'saveEmailToDev',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;
                                _context4.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_14_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_17_sagas_lettersNew__["c" /* sendToDev */], this.props.letter._id);

                            case 3:
                                _context4.next = 8;
                                break;

                            case 5:
                                _context4.prev = 5;
                                _context4.t0 = _context4['catch'](0);

                                console.error(_context4.t0);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[0, 5]]);
            }));

            function saveEmailToDev() {
                return _ref7.apply(this, arguments);
            }

            return saveEmailToDev;
        }()
    }, {
        key: 'openEmailFromDev',
        value: function openEmailFromDev() {
            window.open('https://anotatr.com:5001/' + this.props.letter._id, '_blank');
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.getData();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.state.selectedType === 'vessel') {
                this.props.removeAllVesselOrders();
            } else {
                this.props.removeAllCargoOrders();
            }

            this.props.removeGazetters();
            this.props.removeAnnotations();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this12 = this;

            var _state5 = this.state,
                textLetter = _state5.textLetter,
                selectedType = _state5.selectedType,
                selectedServer = _state5.selectedServer,
                typeAnnotations = _state5.typeAnnotations,
                filteredGazetters = _state5.filteredGazetters,
                searchTextGazetter = _state5.searchTextGazetter,
                annotations = _state5.annotations,
                withChildren = _state5.withChildren,
                timeout = _state5.timeout,
                initialTextLetter = _state5.initialTextLetter,
                openedAttachmentsDialog = _state5.openedAttachmentsDialog,
                isSimpleForm = _state5.isSimpleForm,
                gazettersChanges = _state5.gazettersChanges,
                predictorData = _state5.predictorData,
                predictorLoading = _state5.predictorLoading,
                showUsefulLines = _state5.showUsefulLines;


            console.log(gazettersChanges);

            var _props = this.props,
                letter = _props.letter,
                routeParams = _props.routeParams;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'single-letter-gazetter', className: 'single-letter' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'management' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'management-children' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Management_AnnotateLike__["a" /* default */], {
                                    changeTypeAnnotations: this.changeTypeAnnotations,
                                    isSpam: selectedType === 'spam'
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                                {
                                    className: 'btn',
                                    value: selectedType,
                                    onChange: this.selectTypeLetter,
                                    style: styles.select.style,
                                    selected: true,
                                    fullWidth: true
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'cargo', primaryText: 'as cargo' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'vessel', primaryText: 'as vessel' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'polza', primaryText: 'as polza' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'sizes', primaryText: 'as sizes' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                                {
                                    className: 'btn',
                                    value: selectedServer,
                                    onChange: this.selectTypeServer,
                                    style: styles.select.style,
                                    selected: true,
                                    fullWidth: true
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'mailparse.net', primaryText: 'mailparse.net' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 's11.anotatr.com', primaryText: 's11.anotatr.com' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 's1.anotatr.com', primaryText: 's1.anotatr.com' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: '1-shipdev.me', primaryText: 'shipdev.me' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 's4.anotatr.com', primaryText: 's4.anotatr.com' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'nata.im', primaryText: 'nata.im' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'polza', primaryText: 'polza' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_TextField___default.a, {
                                hintText: 'timeout',
                                type: 'number',
                                value: timeout,
                                onChange: this.changeTimeout,
                                style: styles.textField.style
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox___default.a, {
                                style: styles.checkbox.style,
                                label: 'simple',
                                checked: isSimpleForm,
                                onCheck: function onCheck() {
                                    _this12.setState({ isSimpleForm: !isSimpleForm });
                                }
                            }),
                            typeAnnotations !== 'gazetter' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Checkbox___default.a, {
                                style: styles.checkbox.style,
                                label: 'children',
                                checked: withChildren,
                                onCheck: this.changeWithChildren
                            }) : '',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Management_TextEditor__["a" /* default */], {
                                textLetter: textLetter,
                                typeAnnotations: typeAnnotations,
                                updatePostGazetters: this.updatePostGazetters,
                                updatePostAnnotations: this.updatePostAnnotations
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__Attachments__["a" /* default */], {
                                openedAttachmentsDialog: openedAttachmentsDialog,
                                toggleAttachmentsDialog: this.toggleAttachmentsDialog,
                                buttonStyle: styles.button.buttonStyle,
                                labelStyle: styles.button.labelStyle,
                                style: styles.button.style,
                                attachments: letter.attachments
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__HtmlContent__["a" /* default */], {
                                letter: letter
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__SingleNew_ArchiveLetter__["a" /* default */], { letter: letter })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_tooltip___default.a, { id: 'spam-tooltip', effect: 'solid', html: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                {
                                    'data-tip': selectedType === 'spam' ? 'Mail type <b>spam</b>, can not annotate as <b>spam</b>' : null,
                                    'data-for': 'spam-tooltip'
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                    className: 'btn',
                                    label: 'Order',
                                    labelStyle: styles.button.labelStyle,
                                    style: styles.button.style,
                                    buttonStyle: styles.button.buttonStyle,
                                    primary: true,
                                    disabled: selectedType === 'spam',
                                    containerElement: selectedType !== 'spam' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router__["a" /* Link */], {
                                        to: {
                                            pathname: '/' + routeParams.id + '/annotator/' + selectedType,
                                            state: {
                                                modifiedTextLetter: textLetter,
                                                initialTextLetter: initialTextLetter
                                            }
                                        }
                                    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                {
                                    'data-tip': selectedType === 'spam' ? 'Mail type <b>spam</b>, can not annotate as <b>spam</b>' : null,
                                    'data-for': 'spam-tooltip'
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                    className: 'btn',
                                    label: 'Size',
                                    labelStyle: styles.button.labelStyle,
                                    style: styles.button.style,
                                    buttonStyle: styles.button.buttonStyle,
                                    primary: true,
                                    disabled: selectedType === 'spam',
                                    containerElement: selectedType !== 'spam' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router__["a" /* Link */], { to: '/' + routeParams.id + '/size/' + selectedType }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__common_ToSpamButton__["a" /* default */], {
                                letterId: letter._id,
                                onSuccess: function onSuccess() {
                                    _this12.getData();
                                },
                                disabled: letter.type === 'spam'
                            }),
                            typeAnnotations === 'gazetter' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                label: 'Resend',
                                onClick: this.resendAnnotations,
                                labelStyle: styles.button.labelStyle,
                                style: styles.button.style,
                                buttonStyle: styles.button.buttonStyle,
                                primary: true
                            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Management_AddMailRecognizeSpam__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Save to dev',
                                onClick: this.saveEmailToDev,
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Open from dev',
                                onClick: this.openEmailFromDev,
                                primary: true
                            }),
                            this.state.letter ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__PredictorType__["a" /* default */], {
                                type: predictorData && predictorData.type || '',
                                isLoading: predictorLoading,
                                onFetch: this.fetchPredictorType,
                                onToggleShowUsefulLines: this.onToggleShowUsefulLines
                            }) : null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__SaveLink__["a" /* default */], null)
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject' },
                            'SUBJECT: ',
                            letter.subject
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Content_ChooseContent__["a" /* default */], {
                            gazetters: filteredGazetters,
                            annotations: annotations,
                            textLetter: textLetter,
                            typeAnnotations: typeAnnotations,
                            selectedType: selectedType,
                            addNewGazetter: this.addNewGazetter,
                            withChildren: withChildren,
                            predictorData: predictorData,
                            showUsefulLines: showUsefulLines
                        })
                    ),
                    typeAnnotations === 'gazetter' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__List_Annotation__["a" /* default */], null)
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__List_Gazetter__["a" /* default */], {
                            removeGazetter: this.removeGazetter,
                            changeGazetter: this.changeGazetter,
                            clearGazetter: this.clearGazetter,
                            saveGazetters: this.saveGazetters,

                            searchText: searchTextGazetter,
                            gazetters: filteredGazetters,
                            filterGazetters: this.filterGazetters
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'sidebar' },
                    typeAnnotations === 'gazetter' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Sidebar_FiltersAnnotations__["a" /* default */], {
                            selectedType: selectedType,
                            annotations: annotations,
                            renderWithAnnotationFilters: this.renderWithAnnotationFilters,
                            renderOriginalAnnotations: this.renderOriginalAnnotations
                        })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_33__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Sidebar_UniqueGazetters__["a" /* default */], {
                            gazetters: filteredGazetters
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return GazetterPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref8) {
    var listGazetters = _ref8.listGazetters,
        isLogged = _ref8.user.isLogged,
        letter = _ref8.letter,
        _ref8$gazetters = _ref8.gazetters,
        gazetters = _ref8$gazetters.items,
        isLoadedGazetters = _ref8$gazetters.isLoaded,
        annotations = _ref8.annotations.items;
    return {
        isLogged: isLogged,
        letter: letter,
        isLoadedGazetters: isLoadedGazetters,
        gazetters: gazetters,
        annotations: annotations,
        listGazetters: listGazetters
    };
}, function (dispatch) {
    return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        postGazetters: __WEBPACK_IMPORTED_MODULE_18_actions_gazetters__["a" /* postGazetters */],
        postAnnotations: __WEBPACK_IMPORTED_MODULE_19_actions_annotations__["a" /* postAnnotations */],
        addNotification: __WEBPACK_IMPORTED_MODULE_20_actions_notifications_notifications__["a" /* addNotification */],
        removeAllCargoOrders: __WEBPACK_IMPORTED_MODULE_21_actions_cargoes_orders__["c" /* removeAllCargoOrders */],
        removeAllVesselOrders: __WEBPACK_IMPORTED_MODULE_22_actions_vessels_orders__["d" /* removeAllVesselOrders */],
        removeGazetters: __WEBPACK_IMPORTED_MODULE_18_actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_19_actions_annotations__["b" /* removeAnnotations */]
    }, dispatch), {
        dispatch: dispatch
    });
})(Object(__WEBPACK_IMPORTED_MODULE_37__HOC__["a" /* withGazettersSave */])(GazetterPage));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Page.jsx');
    reactHotLoader.register(GazetterPage, 'GazetterPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var UniqueGazetters = function (_React$Component) {
    _inherits(UniqueGazetters, _React$Component);

    function UniqueGazetters(props) {
        _classCallCheck(this, UniqueGazetters);

        var _this = _possibleConstructorReturn(this, (UniqueGazetters.__proto__ || Object.getPrototypeOf(UniqueGazetters)).call(this, props));

        _this.state = {
            gazetters: _this.createSameGazetters(props.gazetters)
        };
        return _this;
    }

    _createClass(UniqueGazetters, [{
        key: 'makeUniqueGazetters',
        value: function makeUniqueGazetters(gazetters) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqWith(gazetters, function (a, b) {
                return a.gazetteerName.toLowerCase() === b.gazetteerName.toLowerCase();
            });
        }
    }, {
        key: 'createSameGazetters',
        value: function createSameGazetters(gazetters) {
            var uniqueGazetters = this.makeUniqueGazetters(gazetters);

            return uniqueGazetters.sort(function (a, b) {
                if (a.gazetteerName < b.gazetteerName) {
                    return -1;
                } else if (a.gazetteerName > b.gazetteerName) {
                    return 1;
                }

                return 0;
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                gazetters: this.createSameGazetters(nextProps.gazetters)
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var gazetters = this.state.gazetters;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'sidebar-table' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute small-name' },
                        'Total found unique gazetters: ',
                        gazetters.length
                    ),
                    gazetters.map(function (gazetter, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { padding: '5px', background: gazetter.color }, key: i },
                            gazetter.gazetteerName
                        );
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return UniqueGazetters;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var gazetters = _ref.gazetters;
    return {
        gazetters: gazetters
    };
}, function (dispatch) {
    return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch), {
        dispatch: dispatch
    });
})(UniqueGazetters);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(UniqueGazetters, 'UniqueGazetters', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/UniqueGazetters.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/UniqueGazetters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dnd_html5_backend__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dnd__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_preferences_index__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_preferences_filterAnnotations__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LevelList__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Settings__ = __webpack_require__(2154);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var styles = {
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    }
};

function immutablySwapItems(items, firstIndex, secondIndex) {
    var results = items.slice();
    var firstItem = items[firstIndex];

    results[firstIndex] = items[secondIndex];
    results[secondIndex] = firstItem;

    return results;
}

function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

var FiltersAnnotations = function (_React$Component) {
    _inherits(FiltersAnnotations, _React$Component);

    function FiltersAnnotations(props) {
        _classCallCheck(this, FiltersAnnotations);

        var _this = _possibleConstructorReturn(this, (FiltersAnnotations.__proto__ || Object.getPrototypeOf(FiltersAnnotations)).call(this, props));

        _this.state = {
            levelList: [],
            disabledActions: false
        };

        _this.addLevel = _this.addLevel.bind(_this);
        _this.removeLevel = _this.removeLevel.bind(_this);
        _this.changeLevelList = _this.changeLevelList.bind(_this);

        _this.moveLevel = _this.moveLevel.bind(_this);

        _this.sendNewPreference = _this.sendNewPreference.bind(_this);
        _this.selectPreference = _this.selectPreference.bind(_this);
        _this.deletePreference = _this.deletePreference.bind(_this);
        _this.updatePreference = _this.updatePreference.bind(_this);
        _this.toggleShared = _this.toggleShared.bind(_this);
        return _this;
    }

    _createClass(FiltersAnnotations, [{
        key: 'toggleShared',
        value: function toggleShared(e, value) {
            this.props.changePreference({
                shared: value,
                levelList: this.state.levelList
            });
        }
    }, {
        key: 'moveLevel',
        value: function moveLevel(dragIndex, hoverIndex) {
            var levelList = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.state.levelList);

            levelList = immutablySwapItems(levelList, dragIndex, hoverIndex).map(function (item, key) {
                return _extends({}, item, {
                    priority: key
                });
            });

            this.changeLevelList(levelList);
        }
    }, {
        key: 'addLevel',
        value: function addLevel() {
            var levelList = this.state.levelList;


            levelList.push({
                id: guid(),
                priority: levelList.length,
                levelType: 'single',
                rulesList: []
            });

            this.changeLevelList(levelList);
        }
    }, {
        key: 'removeLevel',
        value: function removeLevel() {
            var levelList = this.state.levelList;

            levelList.splice(levelList.length - 1, 1);
            this.changeLevelList(levelList);
        }
    }, {
        key: 'deletePreference',
        value: function deletePreference() {
            this.props.deletePreference({
                _id: this.props.selected._id
            });
        }
    }, {
        key: 'updatePreference',
        value: function updatePreference() {
            this.props.updatePreference(this.props.selected.filter, this.props.selected._id);
            this.props.updatePreferenceMeta(this.props.selected);
        }
    }, {
        key: 'changeLevelList',
        value: function changeLevelList(levelList) {
            this.props.changePreference({ levelList: levelList });
        }
    }, {
        key: 'sendNewPreference',
        value: function sendNewPreference(name) {
            this.props.createFilterAnnotations({
                name: name,
                targetType: this.props.selectedType,
                levelList: this.state.levelList
            });
        }
    }, {
        key: 'selectPreference',
        value: function selectPreference(_id) {
            this.props.selectPreference({
                _id: _id
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var disabledActions = false;

            if (nextProps.selected.userId !== this.props.userId) {
                disabledActions = true;
            }

            this.setState({
                levelList: nextProps.selected._id ? nextProps.selected.filter.levelList : [],
                disabledActions: disabledActions
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                levelList = _state.levelList,
                disabledActions = _state.disabledActions;
            var _props = this.props,
                renderWithAnnotationFilters = _props.renderWithAnnotationFilters,
                renderOriginalAnnotations = _props.renderOriginalAnnotations,
                selectedType = _props.selectedType,
                selected = _props.selected;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'sidebar-table' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Settings__["a" /* default */], {
                    selectedType: selectedType,
                    sendNewPreference: this.sendNewPreference,
                    selectPreference: this.selectPreference,
                    updatePreference: this.updatePreference,
                    deletePreference: this.deletePreference,
                    toggleShared: this.toggleShared
                }),
                selected._id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-10' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block absolute small-name' },
                            'Management'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-3' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default.a, {
                                    label: 'render',
                                    labelStyle: styles.button.labelStyle,
                                    style: styles.button.style,
                                    buttonStyle: styles.button.buttonStyle,
                                    primary: true,
                                    onClick: function onClick() {
                                        renderWithAnnotationFilters(levelList);
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-3' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_RaisedButton___default.a, {
                                    label: 'clear',
                                    labelStyle: styles.button.labelStyle,
                                    style: styles.button.style,
                                    buttonStyle: styles.button.buttonStyle,
                                    primary: true,
                                    onClick: function onClick() {
                                        renderOriginalAnnotations(levelList);
                                    }
                                })
                            ),
                            !disabledActions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-3 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { fontSize: '12px' } },
                                    'Levels'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_10_material_ui_IconButton___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                        onClick: this.addLevel,
                                        color: 'green'
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_10_material_ui_IconButton___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                        onClick: this.removeLevel,
                                        color: 'red'
                                    })
                                )
                            ) : ''
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__LevelList__["a" /* default */], {
                        changeLevelList: this.changeLevelList,
                        levelList: levelList,
                        moveLevel: this.moveLevel,
                        disabledActions: disabledActions
                    })
                ) : ''
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return FiltersAnnotations;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FiltersAnnotations.propTypes = {
    renderWithAnnotationFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    renderOriginalAnnotations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    selectedType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    createFilterAnnotations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    selectPreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    changePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    deletePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    updatePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    updatePreferenceMeta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var ConnectFiltersAnnotations = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var selected = _ref.preferences.selected,
        user = _ref.user.user;
    var toggleShared = _ref2.toggleShared,
        renderWithAnnotationFilters = _ref2.renderWithAnnotationFilters,
        renderOriginalAnnotations = _ref2.renderOriginalAnnotations,
        selectedType = _ref2.selectedType;

    return {
        userId: user._id,
        renderWithAnnotationFilters: renderWithAnnotationFilters,
        renderOriginalAnnotations: renderOriginalAnnotations,
        selectedType: selectedType,
        selected: selected,
        toggleShared: toggleShared
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        createFilterAnnotations: __WEBPACK_IMPORTED_MODULE_8_actions_preferences_filterAnnotations__["a" /* createFilterAnnotations */],
        selectPreference: __WEBPACK_IMPORTED_MODULE_7_actions_preferences_index__["f" /* selectPreference */],
        changePreference: __WEBPACK_IMPORTED_MODULE_7_actions_preferences_index__["a" /* changePreference */],
        deletePreference: __WEBPACK_IMPORTED_MODULE_7_actions_preferences_index__["c" /* deletePreference */],
        updatePreference: __WEBPACK_IMPORTED_MODULE_7_actions_preferences_index__["g" /* updatePreference */],
        updatePreferenceMeta: __WEBPACK_IMPORTED_MODULE_7_actions_preferences_index__["h" /* updatePreferenceMeta */]
    }, dispatch);
})(FiltersAnnotations);

var _default = Object(__WEBPACK_IMPORTED_MODULE_6_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_5_react_dnd_html5_backend___default.a)(ConnectFiltersAnnotations);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx');
    reactHotLoader.register(immutablySwapItems, 'immutablySwapItems', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx');
    reactHotLoader.register(guid, 'guid', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx');
    reactHotLoader.register(s4, 's4', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx');
    reactHotLoader.register(FiltersAnnotations, 'FiltersAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx');
    reactHotLoader.register(ConnectFiltersAnnotations, 'ConnectFiltersAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/FiltersAnnotations.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */


var _defaults = __webpack_require__(792);

var _defaults2 = _interopRequireDefault(_defaults);

var _shallowEqual = __webpack_require__(2003);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _EnterLeaveCounter = __webpack_require__(2004);

var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);

var _BrowserDetector = __webpack_require__(867);

var _OffsetUtils = __webpack_require__(2005);

var _NativeDragSources = __webpack_require__(2007);

var _NativeTypes = __webpack_require__(533);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTML5Backend = function () {
	function HTML5Backend(manager) {
		_classCallCheck(this, HTML5Backend);

		this.actions = manager.getActions();
		this.monitor = manager.getMonitor();
		this.registry = manager.getRegistry();
		this.context = manager.getContext();

		this.sourcePreviewNodes = {};
		this.sourcePreviewNodeOptions = {};
		this.sourceNodes = {};
		this.sourceNodeOptions = {};
		this.enterLeaveCounter = new _EnterLeaveCounter2.default();

		this.dragStartSourceIds = [];
		this.dropTargetIds = [];
		this.dragEnterTargetIds = [];
		this.currentNativeSource = null;
		this.currentNativeHandle = null;
		this.currentDragSourceNode = null;
		this.currentDragSourceNodeOffset = null;
		this.currentDragSourceNodeOffsetChanged = false;
		this.altKeyPressed = false;
		this.mouseMoveTimeoutTimer = null;

		this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
		this.handleTopDragStart = this.handleTopDragStart.bind(this);
		this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
		this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
		this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
		this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
		this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
		this.handleTopDragOver = this.handleTopDragOver.bind(this);
		this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
		this.handleTopDrop = this.handleTopDrop.bind(this);
		this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
		this.handleSelectStart = this.handleSelectStart.bind(this);
		this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
		this.endDragNativeItem = this.endDragNativeItem.bind(this);
		this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
		this.isNodeInDocument = this.isNodeInDocument.bind(this);
	}

	_createClass(HTML5Backend, [{
		key: 'setup',
		value: function setup() {
			if (this.window === undefined) {
				return;
			}

			if (this.window.__isReactDndBackendSetUp) {
				throw new Error('Cannot have two HTML5 backends at the same time.');
			}
			this.window.__isReactDndBackendSetUp = true;
			this.addEventListeners(this.window);
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			if (this.window === undefined) {
				return;
			}

			this.window.__isReactDndBackendSetUp = false;
			this.removeEventListeners(this.window);
			this.clearCurrentDragSourceNode();
			if (this.asyncEndDragFrameId) {
				this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
			}
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.addEventListener) {
				return;
			}
			target.addEventListener('dragstart', this.handleTopDragStart);
			target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.addEventListener('dragend', this.handleTopDragEndCapture, true);
			target.addEventListener('dragenter', this.handleTopDragEnter);
			target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.addEventListener('dragover', this.handleTopDragOver);
			target.addEventListener('dragover', this.handleTopDragOverCapture, true);
			target.addEventListener('drop', this.handleTopDrop);
			target.addEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'removeEventListeners',
		value: function removeEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.removeEventListener) {
				return;
			}
			target.removeEventListener('dragstart', this.handleTopDragStart);
			target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
			target.removeEventListener('dragenter', this.handleTopDragEnter);
			target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.removeEventListener('dragover', this.handleTopDragOver);
			target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
			target.removeEventListener('drop', this.handleTopDrop);
			target.removeEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview(sourceId, node, options) {
			var _this = this;

			this.sourcePreviewNodeOptions[sourceId] = options;
			this.sourcePreviewNodes[sourceId] = node;

			return function () {
				delete _this.sourcePreviewNodes[sourceId];
				delete _this.sourcePreviewNodeOptions[sourceId];
			};
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource(sourceId, node, options) {
			var _this2 = this;

			this.sourceNodes[sourceId] = node;
			this.sourceNodeOptions[sourceId] = options;

			var handleDragStart = function handleDragStart(e) {
				return _this2.handleDragStart(e, sourceId);
			};
			var handleSelectStart = function handleSelectStart(e) {
				return _this2.handleSelectStart(e, sourceId);
			};

			node.setAttribute('draggable', true);
			node.addEventListener('dragstart', handleDragStart);
			node.addEventListener('selectstart', handleSelectStart);

			return function () {
				delete _this2.sourceNodes[sourceId];
				delete _this2.sourceNodeOptions[sourceId];

				node.removeEventListener('dragstart', handleDragStart);
				node.removeEventListener('selectstart', handleSelectStart);
				node.setAttribute('draggable', false);
			};
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget(targetId, node) {
			var _this3 = this;

			var handleDragEnter = function handleDragEnter(e) {
				return _this3.handleDragEnter(e, targetId);
			};
			var handleDragOver = function handleDragOver(e) {
				return _this3.handleDragOver(e, targetId);
			};
			var handleDrop = function handleDrop(e) {
				return _this3.handleDrop(e, targetId);
			};

			node.addEventListener('dragenter', handleDragEnter);
			node.addEventListener('dragover', handleDragOver);
			node.addEventListener('drop', handleDrop);

			return function () {
				node.removeEventListener('dragenter', handleDragEnter);
				node.removeEventListener('dragover', handleDragOver);
				node.removeEventListener('drop', handleDrop);
			};
		}
	}, {
		key: 'getCurrentSourceNodeOptions',
		value: function getCurrentSourceNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourceNodeOptions = this.sourceNodeOptions[sourceId];

			return (0, _defaults2.default)(sourceNodeOptions || {}, {
				dropEffect: this.altKeyPressed ? 'copy' : 'move'
			});
		}
	}, {
		key: 'getCurrentDropEffect',
		value: function getCurrentDropEffect() {
			if (this.isDraggingNativeItem()) {
				// It makes more sense to default to 'copy' for native resources
				return 'copy';
			}

			return this.getCurrentSourceNodeOptions().dropEffect;
		}
	}, {
		key: 'getCurrentSourcePreviewNodeOptions',
		value: function getCurrentSourcePreviewNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];

			return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
				anchorX: 0.5,
				anchorY: 0.5,
				captureDraggingState: false
			});
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset(sourceId) {
			return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
		}
	}, {
		key: 'isDraggingNativeItem',
		value: function isDraggingNativeItem() {
			var itemType = this.monitor.getItemType();
			return Object.keys(NativeTypes).some(function (key) {
				return NativeTypes[key] === itemType;
			});
		}
	}, {
		key: 'beginDragNativeItem',
		value: function beginDragNativeItem(type) {
			this.clearCurrentDragSourceNode();

			var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
			this.currentNativeSource = new SourceType();
			this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
			this.actions.beginDrag([this.currentNativeHandle]);
		}
	}, {
		key: 'asyncEndDragNativeItem',
		value: function asyncEndDragNativeItem() {
			this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
		}
	}, {
		key: 'endDragNativeItem',
		value: function endDragNativeItem() {
			if (!this.isDraggingNativeItem()) {
				return;
			}

			this.actions.endDrag();
			this.registry.removeSource(this.currentNativeHandle);
			this.currentNativeHandle = null;
			this.currentNativeSource = null;
		}
	}, {
		key: 'isNodeInDocument',
		value: function isNodeInDocument(node) {
			// Check the node either in the main document or in the current context
			return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
		}
	}, {
		key: 'endDragIfSourceWasRemovedFromDOM',
		value: function endDragIfSourceWasRemovedFromDOM() {
			var node = this.currentDragSourceNode;
			if (this.isNodeInDocument(node)) {
				return;
			}

			if (this.clearCurrentDragSourceNode()) {
				this.actions.endDrag();
			}
		}
	}, {
		key: 'setCurrentDragSourceNode',
		value: function setCurrentDragSourceNode(node) {
			var _this4 = this;

			this.clearCurrentDragSourceNode();
			this.currentDragSourceNode = node;
			this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
			this.currentDragSourceNodeOffsetChanged = false;

			// A timeout of > 0 is necessary to resolve Firefox issue referenced
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			var MOUSE_MOVE_TIMEOUT = 1000;

			// Receiving a mouse event in the middle of a dragging operation
			// means it has ended and the drag source node disappeared from DOM,
			// so the browser didn't dispatch the dragend event.
			//
			// We need to wait before we start listening for mousemove events.
			// This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
			// immediately in some browsers.
			//
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			//
			this.mouseMoveTimeoutTimer = setTimeout(function () {
				_this4.mouseMoveTimeoutId = null;
				return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
			}, MOUSE_MOVE_TIMEOUT);
		}
	}, {
		key: 'clearCurrentDragSourceNode',
		value: function clearCurrentDragSourceNode() {
			if (this.currentDragSourceNode) {
				this.currentDragSourceNode = null;
				this.currentDragSourceNodeOffset = null;
				this.currentDragSourceNodeOffsetChanged = false;
				this.window.clearTimeout(this.mouseMoveTimeoutTimer);
				this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
				this.mouseMoveTimeoutTimer = null;
				return true;
			}

			return false;
		}
	}, {
		key: 'checkIfCurrentDragSourceRectChanged',
		value: function checkIfCurrentDragSourceRectChanged() {
			var node = this.currentDragSourceNode;
			if (!node) {
				return false;
			}

			if (this.currentDragSourceNodeOffsetChanged) {
				return true;
			}

			this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);

			return this.currentDragSourceNodeOffsetChanged;
		}
	}, {
		key: 'handleTopDragStartCapture',
		value: function handleTopDragStartCapture() {
			this.clearCurrentDragSourceNode();
			this.dragStartSourceIds = [];
		}
	}, {
		key: 'handleDragStart',
		value: function handleDragStart(e, sourceId) {
			this.dragStartSourceIds.unshift(sourceId);
		}
	}, {
		key: 'handleTopDragStart',
		value: function handleTopDragStart(e) {
			var _this5 = this;

			var dragStartSourceIds = this.dragStartSourceIds;

			this.dragStartSourceIds = null;

			var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);

			// Avoid crashing if we missed a drop event or our previous drag died
			if (this.monitor.isDragging()) {
				this.actions.endDrag();
			}

			// Don't publish the source just yet (see why below)
			this.actions.beginDrag(dragStartSourceIds, {
				publishSource: false,
				getSourceClientOffset: this.getSourceClientOffset,
				clientOffset: clientOffset
			});

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (this.monitor.isDragging()) {
				if (typeof dataTransfer.setDragImage === 'function') {
					// Use custom drag image if user specifies it.
					// If child drag source refuses drag but parent agrees,
					// use parent's node as drag image. Neither works in IE though.
					var sourceId = this.monitor.getSourceId();
					var sourceNode = this.sourceNodes[sourceId];
					var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;

					var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
					    anchorX = _getCurrentSourcePrev.anchorX,
					    anchorY = _getCurrentSourcePrev.anchorY,
					    offsetX = _getCurrentSourcePrev.offsetX,
					    offsetY = _getCurrentSourcePrev.offsetY;

					var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
					var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
					var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);

					dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
				}

				try {
					// Firefox won't drag without setting data
					dataTransfer.setData('application/json', {});
				} catch (err) {}
				// IE doesn't support MIME types in setData


				// Store drag source node so we can check whether
				// it is removed from DOM and trigger endDrag manually.
				this.setCurrentDragSourceNode(e.target);

				// Now we are ready to publish the drag source.. or are we not?

				var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
				    captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;

				if (!captureDraggingState) {
					// Usually we want to publish it in the next tick so that browser
					// is able to screenshot the current (not yet dragging) state.
					//
					// It also neatly avoids a situation where render() returns null
					// in the same tick for the source element, and browser freaks out.
					setTimeout(function () {
						return _this5.actions.publishDragSource();
					});
				} else {
					// In some cases the user may want to override this behavior, e.g.
					// to work around IE not supporting custom drag previews.
					//
					// When using a custom drag layer, the only way to prevent
					// the default drag preview from drawing in IE is to screenshot
					// the dragging state in which the node itself has zero opacity
					// and height. In this case, though, returning null from render()
					// will abruptly end the dragging, which is not obvious.
					//
					// This is the reason such behavior is strictly opt-in.
					this.actions.publishDragSource();
				}
			} else if (nativeType) {
				// A native item (such as URL) dragged from inside the document
				this.beginDragNativeItem(nativeType);
			} else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
				// Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
				// Just let it drag. It's a native type (URL or text) and will be picked up in
				// dragenter handler.
				return; // eslint-disable-line no-useless-return
			} else {
				// If by this time no drag source reacted, tell browser not to drag.
				e.preventDefault();
			}
		}
	}, {
		key: 'handleTopDragEndCapture',
		value: function handleTopDragEndCapture() {
			if (this.clearCurrentDragSourceNode()) {
				// Firefox can dispatch this event in an infinite loop
				// if dragend handler does something like showing an alert.
				// Only proceed if we have not handled it already.
				this.actions.endDrag();
			}
		}
	}, {
		key: 'handleTopDragEnterCapture',
		value: function handleTopDragEnterCapture(e) {
			this.dragEnterTargetIds = [];

			var isFirstEnter = this.enterLeaveCounter.enter(e.target);
			if (!isFirstEnter || this.monitor.isDragging()) {
				return;
			}

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (nativeType) {
				// A native item (such as file or URL) dragged from outside the document
				this.beginDragNativeItem(nativeType);
			}
		}
	}, {
		key: 'handleDragEnter',
		value: function handleDragEnter(e, targetId) {
			this.dragEnterTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragEnter',
		value: function handleTopDragEnter(e) {
			var _this6 = this;

			var dragEnterTargetIds = this.dragEnterTargetIds;

			this.dragEnterTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				return;
			}

			this.altKeyPressed = e.altKey;

			if (!(0, _BrowserDetector.isFirefox)()) {
				// Don't emit hover in `dragenter` on Firefox due to an edge case.
				// If the target changes position as the result of `dragenter`, Firefox
				// will still happily dispatch `dragover` despite target being no longer
				// there. The easy solution is to only fire `hover` in `dragover` on FF.
				this.actions.hover(dragEnterTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
			}

			var canDrop = dragEnterTargetIds.some(function (targetId) {
				return _this6.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// IE requires this to fire dragover events
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			}
		}
	}, {
		key: 'handleTopDragOverCapture',
		value: function handleTopDragOverCapture() {
			this.dragOverTargetIds = [];
		}
	}, {
		key: 'handleDragOver',
		value: function handleDragOver(e, targetId) {
			this.dragOverTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragOver',
		value: function handleTopDragOver(e) {
			var _this7 = this;

			var dragOverTargetIds = this.dragOverTargetIds;

			this.dragOverTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				// Prevent default "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
				return;
			}

			this.altKeyPressed = e.altKey;

			this.actions.hover(dragOverTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});

			var canDrop = dragOverTargetIds.some(function (targetId) {
				return _this7.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// Show user-specified drop effect.
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			} else if (this.isDraggingNativeItem()) {
				// Don't show a nice cursor but still prevent default
				// "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
			} else if (this.checkIfCurrentDragSourceRectChanged()) {
				// Prevent animating to incorrect position.
				// Drop effect must be other than 'none' to prevent animation.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'move';
			}
		}
	}, {
		key: 'handleTopDragLeaveCapture',
		value: function handleTopDragLeaveCapture(e) {
			if (this.isDraggingNativeItem()) {
				e.preventDefault();
			}

			var isLastLeave = this.enterLeaveCounter.leave(e.target);
			if (!isLastLeave) {
				return;
			}

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			}
		}
	}, {
		key: 'handleTopDropCapture',
		value: function handleTopDropCapture(e) {
			this.dropTargetIds = [];
			e.preventDefault();

			if (this.isDraggingNativeItem()) {
				this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
			}

			this.enterLeaveCounter.reset();
		}
	}, {
		key: 'handleDrop',
		value: function handleDrop(e, targetId) {
			this.dropTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDrop',
		value: function handleTopDrop(e) {
			var dropTargetIds = this.dropTargetIds;

			this.dropTargetIds = [];

			this.actions.hover(dropTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});
			this.actions.drop({ dropEffect: this.getCurrentDropEffect() });

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			} else {
				this.endDragIfSourceWasRemovedFromDOM();
			}
		}
	}, {
		key: 'handleSelectStart',
		value: function handleSelectStart(e) {
			var target = e.target;

			// Only IE requires us to explicitly say
			// we want drag drop operation to start

			if (typeof target.dragDrop !== 'function') {
				return;
			}

			// Inputs and textareas should be selectable
			if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
				return;
			}

			// For other targets, ask IE
			// to enable drag and drop
			e.preventDefault();
			target.dragDrop();
		}
	}, {
		key: 'window',
		get: function get() {
			if (this.context && this.context.window) {
				return this.context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		}
	}]);

	return HTML5Backend;
}();

exports.default = HTML5Backend;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _union = __webpack_require__(731);

var _union2 = _interopRequireDefault(_union);

var _without = __webpack_require__(866);

var _without2 = _interopRequireDefault(_without);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterLeaveCounter = function () {
	function EnterLeaveCounter() {
		_classCallCheck(this, EnterLeaveCounter);

		this.entered = [];
	}

	_createClass(EnterLeaveCounter, [{
		key: 'enter',
		value: function enter(enteringNode) {
			var previousLength = this.entered.length;

			var isNodeEntered = function isNodeEntered(node) {
				return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
			};

			this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);

			return previousLength === 0 && this.entered.length > 0;
		}
	}, {
		key: 'leave',
		value: function leave(leavingNode) {
			var previousLength = this.entered.length;

			this.entered = (0, _without2.default)(this.entered.filter(function (node) {
				return document.documentElement.contains(node);
			}), leavingNode);

			return previousLength > 0 && this.entered.length === 0;
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.entered = [];
		}
	}]);

	return EnterLeaveCounter;
}();

exports.default = EnterLeaveCounter;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getNodeClientOffset = getNodeClientOffset;
exports.getEventClientOffset = getEventClientOffset;
exports.getDragPreviewOffset = getDragPreviewOffset;

var _BrowserDetector = __webpack_require__(867);

var _MonotonicInterpolant = __webpack_require__(2006);

var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint
   no-mixed-operators: off
*/
var ELEMENT_NODE = 1;

function getNodeClientOffset(node) {
	var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

	if (!el) {
		return null;
	}

	var _el$getBoundingClient = el.getBoundingClientRect(),
	    top = _el$getBoundingClient.top,
	    left = _el$getBoundingClient.left;

	return { x: left, y: top };
}

function getEventClientOffset(e) {
	return {
		x: e.clientX,
		y: e.clientY
	};
}

function isImageNode(node) {
	return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
	var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;

	// Work around @2x coordinate discrepancies in browsers
	if ((0, _BrowserDetector.isSafari)() && isImage) {
		dragPreviewHeight /= window.devicePixelRatio;
		dragPreviewWidth /= window.devicePixelRatio;
	}
	return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
	// The browsers will use the image intrinsic size under different conditions.
	// Firefox only cares if it's an image, but WebKit also wants it to be detached.
	var isImage = isImageNode(dragPreview);
	var dragPreviewNode = isImage ? sourceNode : dragPreview;
	var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	var offsetFromDragPreview = {
		x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
		y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	};
	var sourceWidth = sourceNode.offsetWidth,
	    sourceHeight = sourceNode.offsetHeight;
	var anchorX = anchorPoint.anchorX,
	    anchorY = anchorPoint.anchorY;

	var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
	    dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
	    dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

	var calculateYOffset = function calculateYOffset() {
		var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the top
		offsetFromDragPreview.y,
		// Align at the center
		offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
		// Dock to the bottom
		offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
		var y = interpolantY.interpolate(anchorY);
		// Work around Safari 8 positioning bug
		if ((0, _BrowserDetector.isSafari)() && isImage) {
			// We'll have to wait for @3x to see if this is entirely correct
			y += (window.devicePixelRatio - 1) * dragPreviewHeight;
		}
		return y;
	};

	var calculateXOffset = function calculateXOffset() {
		// Interpolate coordinates depending on anchor point
		// If you know a simpler way to do this, let me know
		var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the left
		offsetFromDragPreview.x,
		// Align at the center
		offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
		// Dock to the right
		offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
		return interpolantX.interpolate(anchorX);
	};

	// Force offsets if specified in the options.
	var offsetX = offsetPoint.offsetX,
	    offsetY = offsetPoint.offsetY;

	var isManualOffsetX = offsetX === 0 || offsetX;
	var isManualOffsetY = offsetY === 0 || offsetY;
	return {
		x: isManualOffsetX ? offsetX : calculateXOffset(),
		y: isManualOffsetY ? offsetY : calculateYOffset()
	};
}

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint
   no-plusplus: off,
   no-mixed-operators: off
*/
var MonotonicInterpolant = function () {
	function MonotonicInterpolant(xs, ys) {
		_classCallCheck(this, MonotonicInterpolant);

		var length = xs.length;

		// Rearrange xs and ys so that xs is sorted
		var indexes = [];
		for (var i = 0; i < length; i++) {
			indexes.push(i);
		}
		indexes.sort(function (a, b) {
			return xs[a] < xs[b] ? -1 : 1;
		});

		// Get consecutive differences and slopes
		var dys = [];
		var dxs = [];
		var ms = [];
		var dx = void 0;
		var dy = void 0;
		for (var _i = 0; _i < length - 1; _i++) {
			dx = xs[_i + 1] - xs[_i];
			dy = ys[_i + 1] - ys[_i];
			dxs.push(dx);
			dys.push(dy);
			ms.push(dy / dx);
		}

		// Get degree-1 coefficients
		var c1s = [ms[0]];
		for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
			var _m = ms[_i2];
			var mNext = ms[_i2 + 1];
			if (_m * mNext <= 0) {
				c1s.push(0);
			} else {
				dx = dxs[_i2];
				var dxNext = dxs[_i2 + 1];
				var common = dx + dxNext;
				c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
			}
		}
		c1s.push(ms[ms.length - 1]);

		// Get degree-2 and degree-3 coefficients
		var c2s = [];
		var c3s = [];
		var m = void 0;
		for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
			m = ms[_i3];
			var c1 = c1s[_i3];
			var invDx = 1 / dxs[_i3];
			var _common = c1 + c1s[_i3 + 1] - m - m;
			c2s.push((m - c1 - _common) * invDx);
			c3s.push(_common * invDx * invDx);
		}

		this.xs = xs;
		this.ys = ys;
		this.c1s = c1s;
		this.c2s = c2s;
		this.c3s = c3s;
	}

	_createClass(MonotonicInterpolant, [{
		key: "interpolate",
		value: function interpolate(x) {
			var xs = this.xs,
			    ys = this.ys,
			    c1s = this.c1s,
			    c2s = this.c2s,
			    c3s = this.c3s;

			// The rightmost point in the dataset should give an exact result

			var i = xs.length - 1;
			if (x === xs[i]) {
				return ys[i];
			}

			// Search for the interval x is in, returning the corresponding y if x is one of the original xs
			var low = 0;
			var high = c3s.length - 1;
			var mid = void 0;
			while (low <= high) {
				mid = Math.floor(0.5 * (low + high));
				var xHere = xs[mid];
				if (xHere < x) {
					low = mid + 1;
				} else if (xHere > x) {
					high = mid - 1;
				} else {
					return ys[mid];
				}
			}
			i = Math.max(0, high);

			// Interpolate
			var diff = x - xs[i];
			var diffSq = diff * diff;
			return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
		}
	}]);

	return MonotonicInterpolant;
}();

exports.default = MonotonicInterpolant;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nativeTypesConfig;

exports.createNativeDragSource = createNativeDragSource;
exports.matchNativeItemType = matchNativeItemType;

var _NativeTypes = __webpack_require__(533);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
		return resultSoFar || dataTransfer.getData(typeToTry);
	}, null);

	return result != null // eslint-disable-line eqeqeq
	? result : defaultValue;
}

var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	exposeProperty: 'files',
	matchesTypes: ['Files'],
	getData: function getData(dataTransfer) {
		return Array.prototype.slice.call(dataTransfer.files);
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	exposeProperty: 'urls',
	matchesTypes: ['Url', 'text/uri-list'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	exposeProperty: 'text',
	matchesTypes: ['Text', 'text/plain'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	}
}), _nativeTypesConfig);

function createNativeDragSource(type) {
	var _nativeTypesConfig$ty = nativeTypesConfig[type],
	    exposeProperty = _nativeTypesConfig$ty.exposeProperty,
	    matchesTypes = _nativeTypesConfig$ty.matchesTypes,
	    getData = _nativeTypesConfig$ty.getData;


	return function () {
		function NativeDragSource() {
			var _item, _mutatorMap;

			_classCallCheck(this, NativeDragSource);

			this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
				// eslint-disable-next-line no-console
				console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
				return null;
			}, _defineEnumerableProperties(_item, _mutatorMap), _item);
		}

		_createClass(NativeDragSource, [{
			key: 'mutateItemByReadingDataTransfer',
			value: function mutateItemByReadingDataTransfer(dataTransfer) {
				delete this.item[exposeProperty];
				this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				return true;
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				return this.item;
			}
		}, {
			key: 'isDragging',
			value: function isDragging(monitor, handle) {
				return handle === monitor.getSourceId();
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {}
		}]);

		return NativeDragSource;
	}();
}

function matchNativeItemType(dataTransfer) {
	var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);

	return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
		var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;

		return matchesTypes.some(function (t) {
			return dataTransferTypes.indexOf(t) > -1;
		});
	})[0] || null;
}

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
	if (!emptyImage) {
		emptyImage = new Image();
		emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	}

	return emptyImage;
}

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropManager = __webpack_require__(2010);

Object.defineProperty(exports, 'DragDropManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropManager).default;
  }
});

var _DragSource = __webpack_require__(2026);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(2027);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

var _createTestBackend = __webpack_require__(2028);

Object.defineProperty(exports, 'createTestBackend', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createTestBackend).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createStore = __webpack_require__(2011);

var _createStore2 = _interopRequireDefault(_createStore);

var _reducers = __webpack_require__(2012);

var _reducers2 = _interopRequireDefault(_reducers);

var _dragDrop = __webpack_require__(374);

var dragDropActions = _interopRequireWildcard(_dragDrop);

var _DragDropMonitor = __webpack_require__(2021);

var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropManager = function () {
	function DragDropManager(createBackend) {
		var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, DragDropManager);

		var store = (0, _createStore2.default)(_reducers2.default);
		this.context = context;
		this.store = store;
		this.monitor = new _DragDropMonitor2.default(store);
		this.registry = this.monitor.registry;
		this.backend = createBackend(this);

		store.subscribe(this.handleRefCountChange.bind(this));
	}

	_createClass(DragDropManager, [{
		key: 'handleRefCountChange',
		value: function handleRefCountChange() {
			var shouldSetUp = this.store.getState().refCount > 0;
			if (shouldSetUp && !this.isSetUp) {
				this.backend.setup();
				this.isSetUp = true;
			} else if (!shouldSetUp && this.isSetUp) {
				this.backend.teardown();
				this.isSetUp = false;
			}
		}
	}, {
		key: 'getContext',
		value: function getContext() {
			return this.context;
		}
	}, {
		key: 'getMonitor',
		value: function getMonitor() {
			return this.monitor;
		}
	}, {
		key: 'getBackend',
		value: function getBackend() {
			return this.backend;
		}
	}, {
		key: 'getRegistry',
		value: function getRegistry() {
			return this.registry;
		}
	}, {
		key: 'getActions',
		value: function getActions() {
			var manager = this;
			var dispatch = this.store.dispatch;


			function bindActionCreator(actionCreator) {
				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var action = actionCreator.apply(manager, args);
					if (typeof action !== 'undefined') {
						dispatch(action);
					}
				};
			}

			return Object.keys(dragDropActions).filter(function (key) {
				return typeof dragDropActions[key] === 'function';
			}).reduce(function (boundActions, key) {
				var action = dragDropActions[key];
				boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
				return boundActions;
			}, {});
		}
	}]);

	return DragDropManager;
}();

exports.default = DragDropManager;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ActionTypes = undefined;
exports['default'] = createStore;

var _isPlainObject = __webpack_require__(164);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(431);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2['default'])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2['default']] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
}

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = reduce;

var _dragOffset = __webpack_require__(870);

var _dragOffset2 = _interopRequireDefault(_dragOffset);

var _dragOperation = __webpack_require__(2013);

var _dragOperation2 = _interopRequireDefault(_dragOperation);

var _refCount = __webpack_require__(2014);

var _refCount2 = _interopRequireDefault(_refCount);

var _dirtyHandlerIds = __webpack_require__(872);

var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);

var _stateId = __webpack_require__(2020);

var _stateId2 = _interopRequireDefault(_stateId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	return {
		dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
		dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
		refCount: (0, _refCount2.default)(state.refCount, action),
		dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
		stateId: (0, _stateId2.default)(state.stateId)
	};
}

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOperation;

var _without = __webpack_require__(866);

var _without2 = _interopRequireDefault(_without);

var _dragDrop = __webpack_require__(374);

var _registry = __webpack_require__(375);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
	itemType: null,
	item: null,
	sourceId: null,
	targetIds: [],
	dropResult: null,
	didDrop: false,
	isSourcePublic: null
};

function dragOperation() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return _extends({}, state, {
				itemType: action.itemType,
				item: action.item,
				sourceId: action.sourceId,
				isSourcePublic: action.isSourcePublic,
				dropResult: null,
				didDrop: false
			});
		case _dragDrop.PUBLISH_DRAG_SOURCE:
			return _extends({}, state, {
				isSourcePublic: true
			});
		case _dragDrop.HOVER:
			return _extends({}, state, {
				targetIds: action.targetIds
			});
		case _registry.REMOVE_TARGET:
			if (state.targetIds.indexOf(action.targetId) === -1) {
				return state;
			}
			return _extends({}, state, {
				targetIds: (0, _without2.default)(state.targetIds, action.targetId)
			});
		case _dragDrop.DROP:
			return _extends({}, state, {
				dropResult: action.dropResult,
				didDrop: true,
				targetIds: []
			});
		case _dragDrop.END_DRAG:
			return _extends({}, state, {
				itemType: null,
				item: null,
				sourceId: null,
				dropResult: null,
				didDrop: false,
				isSourcePublic: null,
				targetIds: []
			});
		default:
			return state;
	}
}

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = refCount;

var _registry = __webpack_require__(375);

function refCount() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var action = arguments[1];

	switch (action.type) {
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
			return state + 1;
		case _registry.REMOVE_SOURCE:
		case _registry.REMOVE_TARGET:
			return state - 1;
		default:
			return state;
	}
}

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(873),
    baseRest = __webpack_require__(136),
    baseXor = __webpack_require__(2016),
    isArrayLikeObject = __webpack_require__(265);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(484),
    baseFlatten = __webpack_require__(341),
    baseUniq = __webpack_require__(732);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(256),
    baseIntersection = __webpack_require__(2018),
    baseRest = __webpack_require__(136),
    castArrayLikeObject = __webpack_require__(2019);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(338),
    arrayIncludes = __webpack_require__(339),
    arrayIncludesWith = __webpack_require__(485),
    arrayMap = __webpack_require__(256),
    baseUnary = __webpack_require__(486),
    cacheHas = __webpack_require__(340);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(265);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stateId;
function stateId() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

	return state + 1;
}

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(67);

var _isArray2 = _interopRequireDefault(_isArray);

var _matchesType = __webpack_require__(871);

var _matchesType2 = _interopRequireDefault(_matchesType);

var _HandlerRegistry = __webpack_require__(2022);

var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);

var _dragOffset = __webpack_require__(870);

var _dirtyHandlerIds = __webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropMonitor = function () {
	function DragDropMonitor(store) {
		_classCallCheck(this, DragDropMonitor);

		this.store = store;
		this.registry = new _HandlerRegistry2.default(store);
	}

	_createClass(DragDropMonitor, [{
		key: 'subscribeToStateChange',
		value: function subscribeToStateChange(listener) {
			var _this = this;

			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var handlerIds = options.handlerIds;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
			(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');

			var prevStateId = this.store.getState().stateId;
			var handleChange = function handleChange() {
				var state = _this.store.getState();
				var currentStateId = state.stateId;
				try {
					var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);

					if (!canSkipListener) {
						listener();
					}
				} finally {
					prevStateId = currentStateId;
				}
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'subscribeToOffsetChange',
		value: function subscribeToOffsetChange(listener) {
			var _this2 = this;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');

			var previousState = this.store.getState().dragOffset;
			var handleChange = function handleChange() {
				var nextState = _this2.store.getState().dragOffset;
				if (nextState === previousState) {
					return;
				}

				previousState = nextState;
				listener();
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'canDragSource',
		value: function canDragSource(sourceId) {
			var source = this.registry.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (this.isDragging()) {
				return false;
			}

			return source.canDrag(this, sourceId);
		}
	}, {
		key: 'canDropOnTarget',
		value: function canDropOnTarget(targetId) {
			var target = this.registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected to find a valid target.');

			if (!this.isDragging() || this.didDrop()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			return Boolean(this.getItemType());
		}
	}, {
		key: 'isDraggingSource',
		value: function isDraggingSource(sourceId) {
			var source = this.registry.getSource(sourceId, true);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (!this.isDragging() || !this.isSourcePublic()) {
				return false;
			}

			var sourceType = this.registry.getSourceType(sourceId);
			var draggedItemType = this.getItemType();
			if (sourceType !== draggedItemType) {
				return false;
			}

			return source.isDragging(this, sourceId);
		}
	}, {
		key: 'isOverTarget',
		value: function isOverTarget(targetId) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
			var shallow = options.shallow;

			if (!this.isDragging()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				return false;
			}

			var targetIds = this.getTargetIds();
			if (!targetIds.length) {
				return false;
			}

			var index = targetIds.indexOf(targetId);
			if (shallow) {
				return index === targetIds.length - 1;
			} else {
				return index > -1;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.store.getState().dragOperation.itemType;
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.store.getState().dragOperation.item;
		}
	}, {
		key: 'getSourceId',
		value: function getSourceId() {
			return this.store.getState().dragOperation.sourceId;
		}
	}, {
		key: 'getTargetIds',
		value: function getTargetIds() {
			return this.store.getState().dragOperation.targetIds;
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.store.getState().dragOperation.dropResult;
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.store.getState().dragOperation.didDrop;
		}
	}, {
		key: 'isSourcePublic',
		value: function isSourcePublic() {
			return this.store.getState().dragOperation.isSourcePublic;
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.store.getState().dragOffset.initialClientOffset;
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.store.getState().dragOffset.initialSourceClientOffset;
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.store.getState().dragOffset.clientOffset;
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
		}
	}]);

	return DragDropMonitor;
}();

exports.default = DragDropMonitor;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(67);

var _isArray2 = _interopRequireDefault(_isArray);

var _asap = __webpack_require__(2023);

var _asap2 = _interopRequireDefault(_asap);

var _registry = __webpack_require__(375);

var _getNextUniqueId = __webpack_require__(2025);

var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HandlerRoles = {
	SOURCE: 'SOURCE',
	TARGET: 'TARGET'
};

function validateSourceContract(source) {
	(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}

function validateTargetContract(target) {
	(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
	(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}

function validateType(type, allowArray) {
	if (allowArray && (0, _isArray2.default)(type)) {
		type.forEach(function (t) {
			return validateType(t, false);
		});
		return;
	}

	(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

function getNextHandlerId(role) {
	var id = (0, _getNextUniqueId2.default)().toString();
	switch (role) {
		case HandlerRoles.SOURCE:
			return 'S' + id;
		case HandlerRoles.TARGET:
			return 'T' + id;
		default:
			(0, _invariant2.default)(false, 'Unknown role: ' + role);
	}
}

function parseRoleFromHandlerId(handlerId) {
	switch (handlerId[0]) {
		case 'S':
			return HandlerRoles.SOURCE;
		case 'T':
			return HandlerRoles.TARGET;
		default:
			(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
	}
}

var HandlerRegistry = function () {
	function HandlerRegistry(store) {
		_classCallCheck(this, HandlerRegistry);

		this.store = store;

		this.types = {};
		this.handlers = {};

		this.pinnedSourceId = null;
		this.pinnedSource = null;
	}

	_createClass(HandlerRegistry, [{
		key: 'addSource',
		value: function addSource(type, source) {
			validateType(type);
			validateSourceContract(source);

			var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
			this.store.dispatch((0, _registry.addSource)(sourceId));
			return sourceId;
		}
	}, {
		key: 'addTarget',
		value: function addTarget(type, target) {
			validateType(type, true);
			validateTargetContract(target);

			var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
			this.store.dispatch((0, _registry.addTarget)(targetId));
			return targetId;
		}
	}, {
		key: 'addHandler',
		value: function addHandler(role, type, handler) {
			var id = getNextHandlerId(role);
			this.types[id] = type;
			this.handlers[id] = handler;

			return id;
		}
	}, {
		key: 'containsHandler',
		value: function containsHandler(handler) {
			var _this = this;

			return Object.keys(this.handlers).some(function (key) {
				return _this.handlers[key] === handler;
			});
		}
	}, {
		key: 'getSource',
		value: function getSource(sourceId, includePinned) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');

			var isPinned = includePinned && sourceId === this.pinnedSourceId;
			var source = isPinned ? this.pinnedSource : this.handlers[sourceId];

			return source;
		}
	}, {
		key: 'getTarget',
		value: function getTarget(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.handlers[targetId];
		}
	}, {
		key: 'getSourceType',
		value: function getSourceType(sourceId) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
			return this.types[sourceId];
		}
	}, {
		key: 'getTargetType',
		value: function getTargetType(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.types[targetId];
		}
	}, {
		key: 'isSourceId',
		value: function isSourceId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.SOURCE;
		}
	}, {
		key: 'isTargetId',
		value: function isTargetId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.TARGET;
		}
	}, {
		key: 'removeSource',
		value: function removeSource(sourceId) {
			var _this2 = this;

			(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
			this.store.dispatch((0, _registry.removeSource)(sourceId));

			(0, _asap2.default)(function () {
				delete _this2.handlers[sourceId];
				delete _this2.types[sourceId];
			});
		}
	}, {
		key: 'removeTarget',
		value: function removeTarget(targetId) {
			var _this3 = this;

			(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
			this.store.dispatch((0, _registry.removeTarget)(targetId));

			(0, _asap2.default)(function () {
				delete _this3.handlers[targetId];
				delete _this3.types[targetId];
			});
		}
	}, {
		key: 'pinSource',
		value: function pinSource(sourceId) {
			var source = this.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected an existing source.');

			this.pinnedSourceId = sourceId;
			this.pinnedSource = source;
		}
	}, {
		key: 'unpinSource',
		value: function unpinSource() {
			(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');

			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	}]);

	return HandlerRegistry;
}();

exports.default = HandlerRegistry;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(2024);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getNextUniqueId;
var nextUniqueId = 0;

function getNextUniqueId() {
	return nextUniqueId++;
}

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragSource = function () {
	function DragSource() {
		_classCallCheck(this, DragSource);
	}

	_createClass(DragSource, [{
		key: "canDrag",
		value: function canDrag() {
			return true;
		}
	}, {
		key: "isDragging",
		value: function isDragging(monitor, handle) {
			return handle === monitor.getSourceId();
		}
	}, {
		key: "endDrag",
		value: function endDrag() {}
	}]);

	return DragSource;
}();

exports.default = DragSource;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropTarget = function () {
	function DropTarget() {
		_classCallCheck(this, DropTarget);
	}

	_createClass(DropTarget, [{
		key: "canDrop",
		value: function canDrop() {
			return true;
		}
	}, {
		key: "hover",
		value: function hover() {}
	}, {
		key: "drop",
		value: function drop() {}
	}]);

	return DropTarget;
}();

exports.default = DropTarget;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createBackend;

var _noop = __webpack_require__(490);

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TestBackend = function () {
	function TestBackend(manager) {
		_classCallCheck(this, TestBackend);

		this.actions = manager.getActions();
	}

	_createClass(TestBackend, [{
		key: 'setup',
		value: function setup() {
			this.didCallSetup = true;
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			this.didCallTeardown = true;
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource() {
			return _noop2.default;
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview() {
			return _noop2.default;
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget() {
			return _noop2.default;
		}
	}, {
		key: 'simulateBeginDrag',
		value: function simulateBeginDrag(sourceIds, options) {
			this.actions.beginDrag(sourceIds, options);
		}
	}, {
		key: 'simulatePublishDragSource',
		value: function simulatePublishDragSource() {
			this.actions.publishDragSource();
		}
	}, {
		key: 'simulateHover',
		value: function simulateHover(targetIds, options) {
			this.actions.hover(targetIds, options);
		}
	}, {
		key: 'simulateDrop',
		value: function simulateDrop() {
			this.actions.drop();
		}
	}, {
		key: 'simulateEndDrag',
		value: function simulateEndDrag() {
			this.actions.endDrag();
		}
	}]);

	return TestBackend;
}();

function createBackend(manager) {
	return new TestBackend(manager);
}

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragDropContext = __webpack_require__(868);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This class is a React-Component based version of the DragDropContext.
 * This is an alternative to decorating an application component with an ES7 decorator.
 */
var DragDropContextProvider = (_temp = _class = function (_Component) {
	_inherits(DragDropContextProvider, _Component);

	function DragDropContextProvider(props, context) {
		_classCallCheck(this, DragDropContextProvider);

		/**
   * This property determines which window global to use for creating the DragDropManager.
   * If a window has been injected explicitly via props, that is used first. If it is available
   * as a context value, then use that, otherwise use the browser global.
   */
		var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));

		var getWindow = function getWindow() {
			if (props && props.window) {
				return props.window;
			} else if (context && context.window) {
				return context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		};

		_this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
		_this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
			window: getWindow()
		});
		return _this;
	}

	_createClass(DragDropContextProvider, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
				throw new Error('DragDropContextProvider backend and window props must not change.');
			}
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			return this.childContext;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react.Children.only(this.props.children);
		}
	}]);

	return DragDropContextProvider;
}(_react.Component), _class.propTypes = {
	backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
	children: _propTypes2.default.element.isRequired,
	window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
}, _class.defaultProps = {
	window: undefined
}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
	window: _propTypes2.default.object
}, _temp);
exports.default = DragDropContextProvider;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = DragLayer;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(180);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _isPlainObject = __webpack_require__(164);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _shallowEqual = __webpack_require__(536);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(874);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

var _checkDecoratorArguments = __webpack_require__(376);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DragLayer(collect) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);

	return function decorateLayer(DecoratedComponent) {
		var _class, _temp;

		var _options$arePropsEqua = options.arePropsEqual,
		    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragLayerContainer = (_temp = _class = function (_Component) {
			_inherits(DragLayerContainer, _Component);

			_createClass(DragLayerContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate(nextProps, nextState) {
					return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
				}
			}]);

			function DragLayerContainer(props, context) {
				_classCallCheck(this, DragLayerContainer);

				var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));

				_this.handleChange = _this.handleChange.bind(_this);

				_this.manager = context.dragDropManager;
				(0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

				_this.state = _this.getCurrentState();
				return _this;
			}

			_createClass(DragLayerContainer, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.isCurrentlyMounted = true;

					var monitor = this.manager.getMonitor();
					this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
					this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);

					this.handleChange();
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this.isCurrentlyMounted = false;

					this.unsubscribeFromOffsetChange();
					this.unsubscribeFromStateChange();
				}
			}, {
				key: 'handleChange',
				value: function handleChange() {
					if (!this.isCurrentlyMounted) {
						return;
					}

					var nextState = this.getCurrentState();
					if (!(0, _shallowEqual2.default)(nextState, this.state)) {
						this.setState(nextState);
					}
				}
			}, {
				key: 'getCurrentState',
				value: function getCurrentState() {
					var monitor = this.manager.getMonitor();
					return collect(monitor, this.props);
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragLayerContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
			dragDropManager: _propTypes2.default.object.isRequired
		}, _temp);


		return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
	};
}

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DragSource;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(164);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(376);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(875);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerSource = __webpack_require__(2036);

var _registerSource2 = _interopRequireDefault(_registerSource);

var _createSourceFactory = __webpack_require__(2037);

var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);

var _createSourceMonitor = __webpack_require__(2038);

var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);

var _createSourceConnector = __webpack_require__(2039);

var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);

var _isValidType = __webpack_require__(878);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DragSource(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
	var createSource = (0, _createSourceFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);

	return function decorateSource(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, sourceId) {
				return backend.connectDragSource(sourceId);
			},
			containerDisplayName: 'DragSource',
			createHandler: createSource,
			registerHandler: _registerSource2.default,
			createMonitor: _createSourceMonitor2.default,
			createConnector: _createSourceConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isDisposable2 = __webpack_require__(537);

var _isDisposable3 = _interopRequireDefault(_isDisposable2);

exports.isDisposable = _isDisposable3['default'];

var _Disposable2 = __webpack_require__(2033);

var _Disposable3 = _interopRequireDefault(_Disposable2);

exports.Disposable = _Disposable3['default'];

var _CompositeDisposable2 = __webpack_require__(2034);

var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);

exports.CompositeDisposable = _CompositeDisposable3['default'];

var _SerialDisposable2 = __webpack_require__(2035);

var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);

exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};

/**
 * The basic disposable.
 */

var Disposable = (function () {
  _createClass(Disposable, null, [{
    key: "empty",
    value: { dispose: noop },
    enumerable: true
  }]);

  function Disposable(action) {
    _classCallCheck(this, Disposable);

    this.isDisposed = false;
    this.action = action || noop;
  }

  Disposable.prototype.dispose = function dispose() {
    if (!this.isDisposed) {
      this.action.call(null);
      this.isDisposed = true;
    }
  };

  return Disposable;
})();

exports["default"] = Disposable;
module.exports = exports["default"];

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(537);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

/**
 * Represents a group of disposable resources that are disposed together.
 */

var CompositeDisposable = (function () {
  function CompositeDisposable() {
    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
      disposables[_key] = arguments[_key];
    }

    _classCallCheck(this, CompositeDisposable);

    if (Array.isArray(disposables[0]) && disposables.length === 1) {
      disposables = disposables[0];
    }

    for (var i = 0; i < disposables.length; i++) {
      if (!_isDisposable2['default'](disposables[i])) {
        throw new Error('Expected a disposable');
      }
    }

    this.disposables = disposables;
    this.isDisposed = false;
  }

  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Disposable} item Disposable to add.
   */

  CompositeDisposable.prototype.add = function add(item) {
    if (this.isDisposed) {
      item.dispose();
    } else {
      this.disposables.push(item);
    }
  };

  /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Disposable} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */

  CompositeDisposable.prototype.remove = function remove(item) {
    if (this.isDisposed) {
      return false;
    }

    var index = this.disposables.indexOf(item);
    if (index === -1) {
      return false;
    }

    this.disposables.splice(index, 1);
    item.dispose();
    return true;
  };

  /**
   * Disposes all disposables in the group and removes them from the group.
   */

  CompositeDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    var len = this.disposables.length;
    var currentDisposables = new Array(len);
    for (var i = 0; i < len; i++) {
      currentDisposables[i] = this.disposables[i];
    }

    this.isDisposed = true;
    this.disposables = [];
    this.length = 0;

    for (var i = 0; i < len; i++) {
      currentDisposables[i].dispose();
    }
  };

  return CompositeDisposable;
})();

exports['default'] = CompositeDisposable;
module.exports = exports['default'];

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(537);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

var SerialDisposable = (function () {
  function SerialDisposable() {
    _classCallCheck(this, SerialDisposable);

    this.isDisposed = false;
    this.current = null;
  }

  /**
   * Gets the underlying disposable.
   * @return The underlying disposable.
   */

  SerialDisposable.prototype.getDisposable = function getDisposable() {
    return this.current;
  };

  /**
   * Sets the underlying disposable.
   * @param {Disposable} value The new underlying disposable.
   */

  SerialDisposable.prototype.setDisposable = function setDisposable() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    if (value != null && !_isDisposable2['default'](value)) {
      throw new Error('Expected either an empty value or a valid disposable');
    }

    var isDisposed = this.isDisposed;
    var previous = undefined;

    if (!isDisposed) {
      previous = this.current;
      this.current = value;
    }

    if (previous) {
      previous.dispose();
    }

    if (isDisposed && value) {
      value.dispose();
    }
  };

  /**
   * Disposes the underlying disposable as well as all future replacements.
   */

  SerialDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    this.isDisposed = true;
    var previous = this.current;
    this.current = null;

    if (previous) {
      previous.dispose();
    }
  };

  return SerialDisposable;
})();

exports['default'] = SerialDisposable;
module.exports = exports['default'];

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerSource;
function registerSource(type, source, manager) {
	var registry = manager.getRegistry();
	var sourceId = registry.addSource(type, source);

	function unregisterSource() {
		registry.removeSource(sourceId);
	}

	return {
		handlerId: sourceId,
		unregister: unregisterSource
	};
}

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceFactory;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(164);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

function createSourceFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});
	REQUIRED_SPEC_METHODS.forEach(function (key) {
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});

	var Source = function () {
		function Source(monitor) {
			_classCallCheck(this, Source);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Source, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				if (!spec.canDrag) {
					return true;
				}

				return spec.canDrag(this.props, this.monitor);
			}
		}, {
			key: 'isDragging',
			value: function isDragging(globalMonitor, sourceId) {
				if (!spec.isDragging) {
					return sourceId === globalMonitor.getSourceId();
				}

				return spec.isDragging(this.props, this.monitor);
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				var item = spec.beginDrag(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
				}
				return item;
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {
				if (!spec.endDrag) {
					return;
				}

				spec.endDrag(this.props, this.monitor, this.component);
			}
		}]);

		return Source;
	}();

	return function createSource(monitor) {
		return new Source(monitor);
	};
}

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceMonitor;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrag = false;
var isCallingIsDragging = false;

var SourceMonitor = function () {
	function SourceMonitor(manager) {
		_classCallCheck(this, SourceMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(SourceMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(sourceId) {
			this.sourceId = sourceId;
		}
	}, {
		key: 'canDrag',
		value: function canDrag() {
			(0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingCanDrag = true;
				return this.internalMonitor.canDragSource(this.sourceId);
			} finally {
				isCallingCanDrag = false;
			}
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			(0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingIsDragging = true;
				return this.internalMonitor.isDraggingSource(this.sourceId);
			} finally {
				isCallingIsDragging = false;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return SourceMonitor;
}();

function createSourceMonitor(manager) {
	return new SourceMonitor(manager);
}

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createSourceConnector;

var _wrapConnectorHooks = __webpack_require__(876);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(877);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createSourceConnector(backend) {
	var currentHandlerId = void 0;

	var currentDragSourceNode = void 0;
	var currentDragSourceOptions = void 0;
	var disconnectCurrentDragSource = void 0;

	var currentDragPreviewNode = void 0;
	var currentDragPreviewOptions = void 0;
	var disconnectCurrentDragPreview = void 0;

	function reconnectDragSource() {
		if (disconnectCurrentDragSource) {
			disconnectCurrentDragSource();
			disconnectCurrentDragSource = null;
		}

		if (currentHandlerId && currentDragSourceNode) {
			disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
		}
	}

	function reconnectDragPreview() {
		if (disconnectCurrentDragPreview) {
			disconnectCurrentDragPreview();
			disconnectCurrentDragPreview = null;
		}

		if (currentHandlerId && currentDragPreviewNode) {
			disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDragSource();
		reconnectDragPreview();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dragSource: function connectDragSource(node, options) {
			if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
				return;
			}

			currentDragSourceNode = node;
			currentDragSourceOptions = options;

			reconnectDragSource();
		},

		dragPreview: function connectDragPreview(node, options) {
			if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
				return;
			}

			currentDragPreviewNode = node;
			currentDragPreviewOptions = options;

			reconnectDragPreview();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = cloneWithRef;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneWithRef(element, newRef) {
	var previousRef = element.ref;
	(0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

	if (!previousRef) {
		// When there is no ref on the element, use the new ref directly
		return (0, _react.cloneElement)(element, {
			ref: newRef
		});
	}

	return (0, _react.cloneElement)(element, {
		ref: function ref(node) {
			newRef(node);

			if (previousRef) {
				previousRef(node);
			}
		}
	});
}

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DropTarget;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(164);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(376);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(875);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerTarget = __webpack_require__(2042);

var _registerTarget2 = _interopRequireDefault(_registerTarget);

var _createTargetFactory = __webpack_require__(2043);

var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);

var _createTargetMonitor = __webpack_require__(2044);

var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);

var _createTargetConnector = __webpack_require__(2045);

var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);

var _isValidType = __webpack_require__(878);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropTarget(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
	var createTarget = (0, _createTargetFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);

	return function decorateTarget(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, targetId) {
				return backend.connectDropTarget(targetId);
			},
			containerDisplayName: 'DropTarget',
			createHandler: createTarget,
			registerHandler: _registerTarget2.default,
			createMonitor: _createTargetMonitor2.default,
			createConnector: _createTargetConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerTarget;
function registerTarget(type, target, manager) {
	var registry = manager.getRegistry();
	var targetId = registry.addTarget(type, target);

	function unregisterTarget() {
		registry.removeTarget(targetId);
	}

	return {
		handlerId: targetId,
		unregister: unregisterTarget
	};
}

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetFactory;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(164);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

function createTargetFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	});

	var Target = function () {
		function Target(monitor) {
			_classCallCheck(this, Target);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Target, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveMonitor',
			value: function receiveMonitor(monitor) {
				this.monitor = monitor;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrop',
			value: function canDrop() {
				if (!spec.canDrop) {
					return true;
				}

				return spec.canDrop(this.props, this.monitor);
			}
		}, {
			key: 'hover',
			value: function hover() {
				if (!spec.hover) {
					return;
				}

				spec.hover(this.props, this.monitor, this.component);
			}
		}, {
			key: 'drop',
			value: function drop() {
				if (!spec.drop) {
					return undefined;
				}

				var dropResult = spec.drop(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
				}
				return dropResult;
			}
		}]);

		return Target;
	}();

	return function createTarget(monitor) {
		return new Target(monitor);
	};
}

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetMonitor;

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrop = false;

var TargetMonitor = function () {
	function TargetMonitor(manager) {
		_classCallCheck(this, TargetMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(TargetMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(targetId) {
			this.targetId = targetId;
		}
	}, {
		key: 'canDrop',
		value: function canDrop() {
			(0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');

			try {
				isCallingCanDrop = true;
				return this.internalMonitor.canDropOnTarget(this.targetId);
			} finally {
				isCallingCanDrop = false;
			}
		}
	}, {
		key: 'isOver',
		value: function isOver(options) {
			return this.internalMonitor.isOverTarget(this.targetId, options);
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return TargetMonitor;
}();

function createTargetMonitor(manager) {
	return new TargetMonitor(manager);
}

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createTargetConnector;

var _wrapConnectorHooks = __webpack_require__(876);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(877);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTargetConnector(backend) {
	var currentHandlerId = void 0;

	var currentDropTargetNode = void 0;
	var currentDropTargetOptions = void 0;
	var disconnectCurrentDropTarget = void 0;

	function reconnectDropTarget() {
		if (disconnectCurrentDropTarget) {
			disconnectCurrentDropTarget();
			disconnectCurrentDropTarget = null;
		}

		if (currentHandlerId && currentDropTargetNode) {
			disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDropTarget();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dropTarget: function connectDropTarget(node, options) {
			if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
				return;
			}

			currentDropTargetNode = node;
			currentDropTargetOptions = options;

			reconnectDropTarget();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = createFilterAnnotations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function createFilterAnnotations(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["D" /* CREATE_FILTER_ANNOTATIONS_PREFERENCE */].REQUEST,
        data: data
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(createFilterAnnotations, 'createFilterAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/filterAnnotations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_html5_backend__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LevelItem__ = __webpack_require__(2048);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var LevelList = function (_React$Component) {
    _inherits(LevelList, _React$Component);

    function LevelList() {
        _classCallCheck(this, LevelList);

        return _possibleConstructorReturn(this, (LevelList.__proto__ || Object.getPrototypeOf(LevelList)).apply(this, arguments));
    }

    _createClass(LevelList, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                changeLevelList = _props.changeLevelList,
                levelList = _props.levelList,
                moveLevel = _props.moveLevel,
                disabledActions = _props.disabledActions;


            return levelList.map(function (level, indexLevel) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LevelItem__["a" /* default */], {
                    key: level.id,
                    changeLevelList: changeLevelList,
                    levelList: levelList,
                    level: level,
                    indexLevel: indexLevel,
                    moveLevel: moveLevel,
                    disabledActions: disabledActions
                });
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LevelList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LevelList.propTypes = {
    changeLevelList: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    levelList: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
    moveLevel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    disabledActions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_1_react_dnd_html5_backend___default.a)(LevelList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LevelList, 'LevelList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/LevelList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/LevelList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dnd__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RuleItem__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Types = {
    LEVEL: 'level'
};

var levelSource = {
    beginDrag: function beginDrag(props) {
        return {
            indexLevel: props.indexLevel,
            id: props.level.id
        };
    },
    canDrag: function canDrag(props) {
        return !props.disabledActions;
    }
};

var levelTarget = {
    hover: function hover(props, monitor, component) {
        var dragIndex = monitor.getItem().indexLevel;
        var hoverIndex = props.indexLevel;

        if (dragIndex === hoverIndex) {
            return;
        }

        var hoverBoundingRect = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component).getBoundingClientRect();
        var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        var clientOffset = monitor.getClientOffset();
        var hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        props.moveLevel(dragIndex, hoverIndex);

        monitor.getItem().indexLevel = hoverIndex;
    }
};

var LevelItem = function (_React$Component) {
    _inherits(LevelItem, _React$Component);

    function LevelItem(props) {
        _classCallCheck(this, LevelItem);

        var _this = _possibleConstructorReturn(this, (LevelItem.__proto__ || Object.getPrototypeOf(LevelItem)).call(this, props));

        _this.addRule = _this.addRule.bind(_this);
        _this.changeTypeNewRule = _this.changeTypeNewRule.bind(_this);
        return _this;
    }

    _createClass(LevelItem, [{
        key: 'changeTypeNewRule',
        value: function changeTypeNewRule(index, value) {
            var _props = this.props,
                levelList = _props.levelList,
                changeLevelList = _props.changeLevelList;

            levelList[index].levelType = value;
            changeLevelList(levelList);
        }
    }, {
        key: 'addRule',
        value: function addRule(indexLevel, type) {
            var _props2 = this.props,
                levelList = _props2.levelList,
                changeLevelList = _props2.changeLevelList;


            levelList[indexLevel].rulesList.push({
                typeOfRule: type,
                rule: '',
                _type: '',
                color: __WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* default */].createHashColor()
            });

            changeLevelList(levelList);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                isDragging = _props3.isDragging,
                connectDragSource = _props3.connectDragSource,
                connectDropTarget = _props3.connectDropTarget,
                level = _props3.level,
                indexLevel = _props3.indexLevel,
                levelList = _props3.levelList,
                changeLevelList = _props3.changeLevelList,
                disabledActions = _props3.disabledActions;


            var opacity = isDragging ? 0 : 1;

            return connectDragSource(connectDropTarget(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block', style: { opacity: opacity } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block absolute small-name' },
                    'Level - ',
                    level.priority
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                            {
                                fullWidth: true,
                                value: levelList[indexLevel].levelType,
                                onChange: function onChange(e, i, value) {
                                    _this2.changeTypeNewRule(indexLevel, value);
                                },
                                floatingLabelText: 'Type of filter',
                                disabled: disabledActions
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'single', primaryText: 'Single' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { value: 'multi', primaryText: 'Multi' })
                        )
                    ),
                    !disabledActions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6 center-xs middle-xs', style: { display: 'flex' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            'Add rule'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default.a,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                onClick: function onClick() {
                                    _this2.addRule(indexLevel, levelList[indexLevel].levelType);
                                },
                                color: 'green',
                                disabled: disabledActions
                            })
                        )
                    ) : ''
                ),
                levelList[indexLevel].rulesList.map(function (rule, indexRule) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RuleItem__["a" /* default */], {
                        key: indexRule,
                        rule: rule,
                        indexRule: indexRule,
                        indexLevel: indexLevel,
                        levelList: levelList,
                        changeLevelList: changeLevelList,
                        disabledActions: disabledActions
                    });
                })
            )));
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LevelItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LevelItem.propTypes = {
    changeLevelList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    levelList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    indexLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,

    connectDragSource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    connectDropTarget: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

    isDragging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

    moveLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    disabledActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var _default = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.flow([Object(__WEBPACK_IMPORTED_MODULE_3_react_dnd__["DragSource"])(Types.LEVEL, levelSource, function (connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}), Object(__WEBPACK_IMPORTED_MODULE_3_react_dnd__["DropTarget"])(Types.LEVEL, levelTarget, function (connect) {
    return {
        connectDropTarget: connect.dropTarget()
    };
})])(LevelItem);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Types, 'Types', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/LevelItem.jsx');
    reactHotLoader.register(levelSource, 'levelSource', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/LevelItem.jsx');
    reactHotLoader.register(levelTarget, 'levelTarget', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/LevelItem.jsx');
    reactHotLoader.register(LevelItem, 'LevelItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/LevelItem.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/LevelItem.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorPickerPopup__ = __webpack_require__(2050);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var RuleItem = function (_React$Component) {
    _inherits(RuleItem, _React$Component);

    function RuleItem(props) {
        _classCallCheck(this, RuleItem);

        var _this = _possibleConstructorReturn(this, (RuleItem.__proto__ || Object.getPrototypeOf(RuleItem)).call(this, props));

        _this.state = {
            rules: [],
            types: []
        };

        _this.removeRule = _this.removeRule.bind(_this);
        _this.filterAutoComplete = _this.filterAutoComplete.bind(_this);
        _this.onInputAutoComplete = _this.onInputAutoComplete.bind(_this);
        _this.changeColor = _this.changeColor.bind(_this);
        return _this;
    }

    _createClass(RuleItem, [{
        key: 'changeColor',
        value: function changeColor(indexLevel, indexRule, color) {
            var _props = this.props,
                levelList = _props.levelList,
                changeLevelList = _props.changeLevelList,
                rule = _props.rule;


            levelList[indexLevel].rulesList[indexRule] = _extends({}, rule, {
                color: color
            });

            changeLevelList(levelList);
        }
    }, {
        key: 'removeRule',
        value: function removeRule(indexLevel, indexRule) {
            var _props2 = this.props,
                levelList = _props2.levelList,
                changeLevelList = _props2.changeLevelList;


            levelList[indexLevel].rulesList.splice(indexRule, 1);

            changeLevelList(levelList);
        }
    }, {
        key: 'onInputAutoComplete',
        value: function onInputAutoComplete(indexLevel, indexRule, type, value) {
            var _props3 = this.props,
                levelList = _props3.levelList,
                changeLevelList = _props3.changeLevelList,
                rule = _props3.rule;


            levelList[indexLevel].rulesList[indexRule] = _extends({}, rule, _defineProperty({}, type, value));

            changeLevelList(levelList);
        }
    }, {
        key: 'filterAutoComplete',
        value: function filterAutoComplete(searchText, key) {
            var regExp = new RegExp(searchText, 'i');

            return regExp.test(key.toLowerCase());
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var rules = [];

            nextProps.annotations.forEach(function (item) {
                if (item.features.rule) {
                    rules.push(item.features.rule);
                }
            });

            rules = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(rules);

            var types = nextProps.annotations.map(function (item) {
                return item.type;
            });

            types = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(types);

            this.setState({
                rules: rules,
                types: types
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                rules = _state.rules,
                types = _state.types;
            var _props4 = this.props,
                rule = _props4.rule,
                indexRule = _props4.indexRule,
                indexLevel = _props4.indexLevel,
                disabledActions = _props4.disabledActions;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block absolute small-name' },
                    'Type of rule - ',
                    rule.typeOfRule
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a, {
                            searchText: rule.rule,
                            dataSource: rules,
                            floatingLabelText: 'Rule',
                            onUpdateInput: function onUpdateInput(value) {
                                _this2.onInputAutoComplete(indexLevel, indexRule, 'rule', value);
                            },
                            filter: this.filterAutoComplete,
                            textFieldStyle: { fontSize: '13px' },
                            listStyle: { overflow: 'auto', maxHeight: '300px', fontSize: '13px' },
                            popoverProps: {
                                style: { width: 'auto' },
                                canAutoPosition: true
                            },
                            fullWidth: true,
                            disabled: disabledActions
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a, {
                            searchText: rule._type,
                            dataSource: types,
                            floatingLabelText: 'Type',
                            onUpdateInput: function onUpdateInput(value) {
                                _this2.onInputAutoComplete(indexLevel, indexRule, '_type', value);
                            },
                            filter: this.filterAutoComplete,
                            textFieldStyle: { fontSize: '13px' },
                            listStyle: { overflow: 'auto', maxHeight: '300px', fontSize: '13px' },
                            popoverProps: {
                                style: { width: 'auto' },
                                canAutoPosition: true
                            },
                            disabled: disabledActions,
                            fullWidth: true
                        })
                    ),
                    !disabledActions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ColorPickerPopup__["a" /* default */], {
                                indexLevel: indexLevel,
                                indexRule: indexRule,
                                color: rule.color,
                                changeColor: this.changeColor
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                    onClick: function onClick() {
                                        _this2.removeRule(indexLevel, indexRule);
                                    },
                                    color: 'red',
                                    disabled: disabledActions
                                })
                            )
                        )
                    ) : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '5px', background: rule.color } })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RuleItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RuleItem.propTypes = {
    annotations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    changeLevelList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    levelList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    indexLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    indexRule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    rule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    disabledActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var annotations = _ref.annotations;
    var changeLevelList = _ref2.changeLevelList,
        levelList = _ref2.levelList,
        indexLevel = _ref2.indexLevel,
        indexRule = _ref2.indexRule,
        rule = _ref2.rule,
        disabledActions = _ref2.disabledActions;

    return {
        annotations: annotations.items,
        changeLevelList: changeLevelList,
        levelList: levelList,
        indexLevel: indexLevel,
        indexRule: indexRule,
        rule: rule,
        disabledActions: disabledActions
    };
}, function (dispatch) {
    return {};
})(RuleItem);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RuleItem, 'RuleItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/RuleItem.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/RuleItem.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_image_palette__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_image_palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_image_palette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_color__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_color__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ColorPickerPopup = function (_React$Component) {
    _inherits(ColorPickerPopup, _React$Component);

    function ColorPickerPopup(props) {
        _classCallCheck(this, ColorPickerPopup);

        var _this = _possibleConstructorReturn(this, (ColorPickerPopup.__proto__ || Object.getPrototypeOf(ColorPickerPopup)).call(this, props));

        _this.state = {
            elTarget: null,
            isOpenPopover: false,
            iconColor: props.color
        };

        _this.togglePopover = _this.togglePopover.bind(_this);
        _this.closePopover = _this.closePopover.bind(_this);
        _this.changeColor = _this.changeColor.bind(_this);
        return _this;
    }

    _createClass(ColorPickerPopup, [{
        key: 'changeColor',
        value: function changeColor(_ref) {
            var hex = _ref.hex;
            var _props = this.props,
                indexLevel = _props.indexLevel,
                indexRule = _props.indexRule,
                changeColor = _props.changeColor;


            this.setState({
                iconColor: hex
            }, function () {
                changeColor(indexLevel, indexRule, hex);
            });
        }
    }, {
        key: 'togglePopover',
        value: function togglePopover(e) {
            this.setState({
                isOpenPopover: !this.state.isOpenPopover,
                elTarget: e.target
            });
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.setState({
                isOpenPopover: !this.state.isOpenPopover,
                elTarget: null
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                iconColor: nextProps.color
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                elTarget = _state.elTarget,
                isOpenPopover = _state.isOpenPopover,
                iconColor = _state.iconColor;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover___default.a,
                    {
                        open: isOpenPopover,
                        anchorEl: elTarget,
                        onRequestClose: this.closePopover,
                        animation: __WEBPACK_IMPORTED_MODULE_4_material_ui_Popover__["PopoverAnimationVertical"],
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_color__["ChromePicker"], {
                        color: iconColor,
                        onChangeComplete: this.changeColor
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_image_palette___default.a, {
                        onClick: function onClick(e) {
                            _this2.togglePopover(e);
                        },
                        color: iconColor
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ColorPickerPopup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ColorPickerPopup.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    indexLevel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    indexRule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    changeColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var _default = ColorPickerPopup;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ColorPickerPopup, 'ColorPickerPopup', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/ColorPickerPopup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/ColorPickerPopup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;

var _Alpha = __webpack_require__(2052);

Object.defineProperty(exports, 'AlphaPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Block = __webpack_require__(2121);

Object.defineProperty(exports, 'BlockPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Block).default;
  }
});

var _Circle = __webpack_require__(2123);

Object.defineProperty(exports, 'CirclePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Chrome = __webpack_require__(2125);

Object.defineProperty(exports, 'ChromePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chrome).default;
  }
});

var _Compact = __webpack_require__(2129);

Object.defineProperty(exports, 'CompactPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Compact).default;
  }
});

var _Github = __webpack_require__(2132);

Object.defineProperty(exports, 'GithubPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Github).default;
  }
});

var _Hue = __webpack_require__(2134);

Object.defineProperty(exports, 'HuePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Material = __webpack_require__(2136);

Object.defineProperty(exports, 'MaterialPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Material).default;
  }
});

var _Photoshop = __webpack_require__(2137);

Object.defineProperty(exports, 'PhotoshopPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Photoshop).default;
  }
});

var _Sketch = __webpack_require__(2143);

Object.defineProperty(exports, 'SketchPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sketch).default;
  }
});

var _Slider = __webpack_require__(2146);

Object.defineProperty(exports, 'SliderPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _Swatches = __webpack_require__(2150);

Object.defineProperty(exports, 'SwatchesPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatches).default;
  }
});

var _Twitter = __webpack_require__(2153);

Object.defineProperty(exports, 'TwitterPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitter).default;
  }
});

var _ColorWrap = __webpack_require__(898);

Object.defineProperty(exports, 'CustomPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Chrome2 = _interopRequireDefault(_Chrome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chrome2.default;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

var _AlphaPointer = __webpack_require__(2120);

var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _AlphaPointer2.default
};

exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(2054);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(539);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(164);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(143);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(187),
    isArray = __webpack_require__(67),
    isObjectLike = __webpack_require__(135);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2056);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 2056 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(358),
    nativeKeys = __webpack_require__(2058);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(869);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2060),
    getMatchData = __webpack_require__(2072),
    matchesStrictComparable = __webpack_require__(893);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(540),
    baseIsEqual = __webpack_require__(883);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(319);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2062 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2063 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2064 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(319),
    Map = __webpack_require__(464),
    MapCache = __webpack_require__(463);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(540),
    equalArrays = __webpack_require__(884),
    equalByTag = __webpack_require__(2068),
    equalObjects = __webpack_require__(2069),
    getTag = __webpack_require__(890),
    isArray = __webpack_require__(67),
    isBuffer = __webpack_require__(518),
    isTypedArray = __webpack_require__(796);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2067 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223),
    Uint8Array = __webpack_require__(885),
    eq = __webpack_require__(255),
    equalArrays = __webpack_require__(884),
    mapToArray = __webpack_require__(886),
    setToArray = __webpack_require__(343);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(887);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(188),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(188),
    root = __webpack_require__(77);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(892),
    keys = __webpack_require__(240);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(883),
    get = __webpack_require__(71),
    hasIn = __webpack_require__(2074),
    isKey = __webpack_require__(462),
    isStrictComparable = __webpack_require__(892),
    matchesStrictComparable = __webpack_require__(893),
    toKey = __webpack_require__(257);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2075),
    hasPath = __webpack_require__(894);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 2075 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(2077),
    basePropertyDeep = __webpack_require__(2078),
    isKey = __webpack_require__(462),
    toKey = __webpack_require__(257);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 2077 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(670);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(542),
    isArrayLike = __webpack_require__(193);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(193);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(539);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(2082);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(2083);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(540),
    arrayEach = __webpack_require__(543),
    assignValue = __webpack_require__(357),
    baseAssign = __webpack_require__(2084),
    baseAssignIn = __webpack_require__(2085),
    cloneBuffer = __webpack_require__(2086),
    copyArray = __webpack_require__(544),
    copySymbols = __webpack_require__(2087),
    copySymbolsIn = __webpack_require__(2088),
    getAllKeys = __webpack_require__(887),
    getAllKeysIn = __webpack_require__(2089),
    getTag = __webpack_require__(890),
    initCloneArray = __webpack_require__(2090),
    initCloneByTag = __webpack_require__(2091),
    initCloneObject = __webpack_require__(2100),
    isArray = __webpack_require__(67),
    isBuffer = __webpack_require__(518),
    isObject = __webpack_require__(89),
    keys = __webpack_require__(240);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(232),
    keys = __webpack_require__(240);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(232),
    keysIn = __webpack_require__(517);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(77);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(232),
    getSymbols = __webpack_require__(541);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(232),
    getSymbolsIn = __webpack_require__(895);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(888),
    getSymbolsIn = __webpack_require__(895),
    keysIn = __webpack_require__(517);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 2090 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(545),
    cloneDataView = __webpack_require__(2092),
    cloneMap = __webpack_require__(2093),
    cloneRegExp = __webpack_require__(2095),
    cloneSet = __webpack_require__(2096),
    cloneSymbol = __webpack_require__(2098),
    cloneTypedArray = __webpack_require__(2099);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(545);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(2094),
    arrayReduce = __webpack_require__(546),
    mapToArray = __webpack_require__(886);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 2094 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 2095 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(2097),
    arrayReduce = __webpack_require__(546),
    setToArray = __webpack_require__(343);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 2097 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(223);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(545);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(377),
    getPrototype = __webpack_require__(535),
    isPrototype = __webpack_require__(358);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(539);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _alpha = __webpack_require__(2106);

var alpha = _interopRequireWildcard(_alpha);

var _Checkboard = __webpack_require__(896);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = alpha.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react.PureComponent || _react.Component);

exports.default = Alpha;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (props.hsl.a !== a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (props.a !== _a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
  var checkboard = render(c1, c2, size, serverCanvas);

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  checkboardCache[key] = checkboard;
  return checkboard;
};

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      if (_this.props.label) {
        _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
      } else {
        _this.props.onChange && _this.props.onChange(e.target.value, e);
      }

      _this.setState({ value: e.target.value });
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var stringValue = String(e.target.value);
      var isPercentage = stringValue.indexOf('%') > -1;
      var number = Number(stringValue.replace(/%/g, ''));
      if (!isNaN(number)) {
        var amount = _this.props.arrowOffset || 1;

        // Up
        if (e.keyCode === 38) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number + amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number + amount + '%' });
          } else {
            _this.setState({ value: number + amount });
          }
        }

        // Down
        if (e.keyCode === 40) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number - amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number - amount + '%' });
          } else {
            _this.setState({ value: number - amount });
          }
        }
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var input = this.input;
      if (nextProps.value !== this.state.value) {
        if (input === document.activeElement) {
          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
        } else {
          this.setState({ value: String(nextProps.value).toUpperCase(), blurValue: !this.state.blurValue && String(nextProps.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
          'span',
          { style: styles.label, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react.PureComponent || _react.Component);

exports.default = EditableInput;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _hue = __webpack_require__(2110);

var hue = _interopRequireWildcard(_hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = hue.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react.PureComponent || _react.Component);

exports.default = Hue;

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (props.hsl.h !== h) {
      return {
        h: h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (props.hsl.h !== _h) {
      return {
        h: _h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Raised = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children;

  var styles = (0, _reactcss2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2
};

exports.default = Raised;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _throttle = __webpack_require__(2113);

var _throttle2 = _interopRequireDefault(_throttle);

var _saturation = __webpack_require__(2115);

var saturation = _interopRequireWildcard(_saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e, skip) {
      _this.props.onChange && _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react.PureComponent || _react.Component);

exports.default = Saturation;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(897),
    isObject = __webpack_require__(89);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(77);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();

  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  } else if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left * 100 / containerWidth;
  var bright = -(top * 100 / containerHeight) + 100;

  return {
    h: props.hsl.h,
    s: saturation,
    v: bright,
    a: props.hsl.a,
    source: 'rgb'
  };
};

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(899);


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _interaction = __webpack_require__(2119);

var _ = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_.Checkboard, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focus, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2.default.createElement(Component, _extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2.default.Component);
};

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = AlphaPointer;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

var _BlockSwatches = __webpack_require__(2122);

var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = exports.Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    _color2.default.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: _color2.default.getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, { 'hide-triangle': triangle === 'hide' });

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.head },
      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
      _react2.default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['top', 'hide'])
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top'
};

exports.default = (0, _common.ColorWrap)(Block);

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockSwatches = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(143);

var _map2 = _interopRequireDefault(_map);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_common.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = BlockSwatches;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(143);

var _map2 = _interopRequireDefault(_map);

var _materialColors = __webpack_require__(900);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(61);

var _CircleSwatch = __webpack_require__(2124);

var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = exports.Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  });

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  circleSize: _propTypes2.default.number,
  circleSpacing: _propTypes2.default.number
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']]
};

exports.default = (0, _common.ColorWrap)(Circle);

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleSwatch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chrome = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

var _ChromeFields = __webpack_require__(2126);

var _ChromeFields2 = _interopRequireDefault(_ChromeFields);

var _ChromePointer = __webpack_require__(2127);

var _ChromePointer2 = _interopRequireDefault(_ChromePointer);

var _ChromePointerCircle = __webpack_require__(2128);

var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = exports.Chrome = function Chrome(_ref) {
  var onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        width: '225px',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.color },
          _react2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2.default.createElement('div', { style: styles.active }),
            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  disableAlpha: _propTypes2.default.bool
};

Chrome.defaultProps = {
  disableAlpha: false
};

exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromeFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = exports.ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChromeFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      view: ''
    }, _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    }, _this.handleChange = function (data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(data.s && data.s || _this.props.hsl.s),
          l: Number(data.l && data.l || _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    }, _this.showHighlight = function (e) {
      e.target.style.background = '#eee';
    }, _this.hideHighlight = function (e) {
      e.target.style.background = 'transparent';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChromeFields, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
        this.setState({ view: 'hex' });
      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2.default.createElement(
          'div',
          { style: styles.toggle },
          _react2.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2.default.createElement(
              'svg',
              {
                style: styles.svg,
                viewBox: '0 0 24 24',
                onMouseOver: this.showHighlight,
                onMouseEnter: this.showHighlight,
                onMouseOut: this.hideHighlight
              },
              _react2.default.createElement('path', {
                ref: function ref(iconUp) {
                  return _this2.iconUp = iconUp;
                },
                fill: '#333',
                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
              }),
              _react2.default.createElement('path', {
                ref: function ref(iconDown) {
                  return _this2.iconDown = iconDown;
                },
                fill: '#333',
                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
              })
            )
          )
        )
      );
    }
  }]);

  return ChromeFields;
}(_react2.default.Component);

exports.default = ChromeFields;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = exports.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointer;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointerCircle;

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compact = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(143);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

var _CompactColor = __webpack_require__(2130);

var _CompactColor2 = _interopRequireDefault(_CompactColor);

var _CompactFields = __webpack_require__(2131);

var _CompactFields2 = _interopRequireDefault(_CompactFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Compact = exports.Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    { style: styles.Compact },
    _react2.default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      _react2.default.createElement(
        'div',
        null,
        (0, _map2.default)(colors, function (c) {
          return _react2.default.createElement(_CompactColor2.default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        _react2.default.createElement('div', { style: styles.clear })
      ),
      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
};

exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactColor = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactColor = exports.CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: _color2.default.getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return _react2.default.createElement(
    _common.Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement('div', { style: styles.dot })
  );
};

exports.default = CompactColor;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactFields = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactFields = exports.CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement('div', { style: styles.active }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

exports.default = CompactFields;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Github = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(143);

var _map2 = _interopRequireDefault(_map);

var _common = __webpack_require__(61);

var _GithubSwatch = __webpack_require__(2133);

var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Github = exports.Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle == 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right'])
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left'
};

exports.default = (0, _common.ColorWrap)(Github);

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GithubSwatch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HuePicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

var _HuePointer = __webpack_require__(2135);

var _HuePointer2 = _interopRequireDefault(_HuePointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HuePicker = exports.HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  });

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _HuePointer2.default
};

exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Material = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Material = exports.Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    null,
    _react2.default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      _react2.default.createElement(_common.EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      _react2.default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Photoshop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

var _PhotoshopFields = __webpack_require__(2138);

var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);

var _PhotoshopPointerCircle = __webpack_require__(2139);

var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);

var _PhotoshopPointer = __webpack_require__(2140);

var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);

var _PhotoshopButton = __webpack_require__(2141);

var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);

var _PhotoshopPreviews = __webpack_require__(2142);

var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = exports.Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props$className = this.props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0, _reactcss2.default)({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        _react2.default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        _react2.default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.saturation },
            _react2.default.createElement(_common.Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: _PhotoshopPointerCircle2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: _PhotoshopPointer2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.controls },
            _react2.default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              _react2.default.createElement(
                'div',
                { style: styles.previews },
                _react2.default.createElement(_PhotoshopPreviews2.default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              _react2.default.createElement(
                'div',
                { style: styles.actions },
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
                _react2.default.createElement(_PhotoshopFields2.default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(_react2.default.Component);

Photoshop.propTypes = {
  header: _propTypes2.default.string
};

Photoshop.defaultProps = {
  header: 'Color Picker'
};

exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPicker = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      _color2.default.isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields },
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    _react2.default.createElement(
      'div',
      { style: styles.fieldSymbols },
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

exports.default = PhotoshopPicker;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.pointer },
    _react2.default.createElement(
      'div',
      { style: styles.left },
      _react2.default.createElement('div', { style: styles.leftInside })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.right },
      _react2.default.createElement('div', { style: styles.rightInside })
    )
  );
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopBotton = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopBotton = exports.PhotoshopBotton = function PhotoshopBotton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

exports.default = PhotoshopBotton;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPreviews = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement('div', { style: styles.new }),
      _react2.default.createElement('div', { style: styles.current })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

exports.default = PhotoshopPreviews;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sketch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

var _SketchFields = __webpack_require__(2144);

var _SketchFields2 = _interopRequireDefault(_SketchFields);

var _SketchPresetColors = __webpack_require__(2145);

var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sketch = exports.Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    },
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      _react2.default.createElement(
        'div',
        { style: styles.sliders },
        _react2.default.createElement(
          'div',
          { style: styles.hue },
          _react2.default.createElement(_common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.alpha },
          _react2.default.createElement(_common.Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: styles.color },
        _react2.default.createElement(_common.Checkboard, null),
        _react2.default.createElement('div', { style: styles.activeColor })
      )
    ),
    _react2.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    _react2.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: _propTypes2.default.bool,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchFields = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var SketchFields = exports.SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement(
      'div',
      { style: styles.double },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.alpha },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

exports.default = SketchFields;

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchPresetColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return _react2.default.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        _react2.default.createElement(_common.Swatch, _extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    color: _propTypes2.default.string,
    title: _propTypes2.default.string
  })])).isRequired
};

exports.default = SketchPresetColors;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(61);

var _SliderSwatches = __webpack_require__(2147);

var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);

var _SliderPointer = __webpack_require__(2149);

var _SliderPointer2 = _interopRequireDefault(_SliderPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = exports.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { className: 'slider-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.hue },
      _react2.default.createElement(_common.Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.defaultProps = {
  pointer: _SliderPointer2.default
};

exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatches = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _SliderSwatch = __webpack_require__(2148);

var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.80',
        active: Math.round(hsl.l * 100) / 100 === 0.80 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick,
        first: true
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.65',
        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.50',
        active: Math.round(hsl.l * 100) / 100 === 0.50 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.35',
        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.20',
        active: Math.round(hsl.l * 100) / 100 === 0.20 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick,
        last: true
      })
    ),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = SliderSwatches;

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

exports.default = SliderSwatch;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatches = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(143);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _materialColors = __webpack_require__(900);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(61);

var _SwatchesGroup = __webpack_require__(2151);

var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swatches = exports.Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    _color2.default.isValidHex(data) && onChange({
      hex: data,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    _react2.default.createElement(
      _common.Raised,
      null,
      _react2.default.createElement(
        'div',
        { style: styles.overflow },
        _react2.default.createElement(
          'div',
          { style: styles.body },
          (0, _map2.default)(colors, function (group) {
            return _react2.default.createElement(_SwatchesGroup2.default, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          _react2.default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string))

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
};

exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesGroup = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(143);

var _map2 = _interopRequireDefault(_map);

var _SwatchesColor = __webpack_require__(2152);

var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.group },
    (0, _map2.default)(group, function (color, i) {
      return _react2.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

exports.default = SwatchesGroup;

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesColor = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        fill: _color2.default.getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        fill: '#333'
      }
    },
    'transparent': {
      check: {
        fill: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return _react2.default.createElement(
    _common.Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement(
      'div',
      { style: styles.check },
      _react2.default.createElement(
        'svg',
        { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
        _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
      )
    )
  );
};

exports.default = SwatchesColor;

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(35);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(143);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(117);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = exports.Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    _color2.default.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      (0, _map2.default)(colors, function (c, i) {
        return _react2.default.createElement(_common.Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      _react2.default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      _react2.default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left'
};

exports.default = (0, _common.ColorWrap)(Twitter);

/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_preferences_index__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Settings = function (_React$Component) {
    _inherits(Settings, _React$Component);

    function Settings(props) {
        _classCallCheck(this, Settings);

        var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

        _this.state = {
            status: '',
            selected: {},
            name: '',
            textDisabled: true,
            disabled: false
        };

        /*
        * status can be new, '', selected
        * */

        _this.createNewPreference = _this.createNewPreference.bind(_this);
        _this.onChangeName = _this.onChangeName.bind(_this);
        return _this;
    }

    _createClass(Settings, [{
        key: 'onChangeName',
        value: function onChangeName(e, value) {
            var textDisabled = false;

            if (value.length === 0) {
                textDisabled = true;
            }

            this.setState({
                name: value,
                textDisabled: textDisabled
            });
        }
    }, {
        key: 'createNewPreference',
        value: function createNewPreference() {
            this.props.clearSelectPreference();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var disabled = false;

            if (nextProps.selectedType !== this.props.selectedType) {
                return this.props.clearSelectPreference();
            }

            if (nextProps.selected.userId !== this.props.userId) {
                disabled = true;
            }

            this.setState({
                selected: nextProps.selected,
                status: nextProps.selected._id ? 'selected' : 'new',
                disabled: disabled
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getPreferences({ type: 'filter' });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                status = _state.status,
                name = _state.name,
                selected = _state.selected,
                textDisabled = _state.textDisabled,
                disabled = _state.disabled;
            var _props = this.props,
                preferences = _props.preferences,
                sendNewPreference = _props.sendNewPreference,
                selectPreference = _props.selectPreference,
                updatePreference = _props.updatePreference,
                deletePreference = _props.deletePreference,
                toggleShared = _props.toggleShared,
                selectedType = _props.selectedType;


            var _preferences = preferences.filter(function (preference) {
                return preference.filter.targetType === selectedType;
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute small-name' },
                        'Create settings'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                label: 'create new',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '0 10px 0 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                onClick: this.createNewPreference,
                                primary: true
                            })
                        )
                    ),
                    status === 'new' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default.a, {
                                name: 'name of settings',
                                hintText: 'Name setting',
                                className: 'btn',
                                hintStyle: { fontSize: '12px' },
                                value: name,
                                onChange: this.onChangeName,
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                label: 'save to server',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '0 10px 0 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                primary: true,
                                disabled: textDisabled,
                                onClick: function onClick() {
                                    sendNewPreference(name);
                                }
                            })
                        )
                    ) : ''
                ),
                _preferences.length !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute small-name' },
                        'Settings'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
                                {
                                    name: 'name of settings',
                                    hintText: 'Select settings',
                                    className: 'btn',
                                    hintStyle: { fontSize: '12px' },
                                    value: selected._id ? selected._id : '',
                                    onChange: function onChange(e, i, value) {
                                        selectPreference(value);
                                    },
                                    fullWidth: true,
                                    selected: true
                                },
                                _preferences.map(function (preference) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default.a, {
                                        key: preference._id,
                                        value: preference._id,
                                        primaryText: preference.name
                                    });
                                })
                            )
                        )
                    ),
                    status === 'selected' ? !disabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                label: 'update',
                                primary: true,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '0 10px 0 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                onClick: function onClick() {
                                    updatePreference();
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                label: 'delete',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '0 10px 0 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                secondary: true,
                                onClick: function onClick() {
                                    deletePreference();
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Toggle___default.a, {
                                label: 'Shared',
                                labelStyle: { fontSize: '12px' },
                                onToggle: toggleShared,
                                toggled: selected.shared
                            })
                        )
                    ) : '' : ''
                ) : ''
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Settings;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Settings.propTypes = {
    user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    selectedType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    preferences: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    sendNewPreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    selectPreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getPreferences: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    updatePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getPreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    deletePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    clearSelectPreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    toggleShared: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var _ref$preferences = _ref.preferences,
        preferences = _ref$preferences.items,
        selected = _ref$preferences.selected,
        user = _ref.user.user;
    var selectedType = _ref2.selectedType,
        sendNewPreference = _ref2.sendNewPreference,
        selectPreference = _ref2.selectPreference,
        updatePreference = _ref2.updatePreference,
        deletePreference = _ref2.deletePreference,
        toggleShared = _ref2.toggleShared;


    return {
        userId: user._id,
        selectedType: selectedType,
        preferences: preferences.filter(function (item) {
            return item.type === 'filter';
        }),
        selected: selected,
        sendNewPreference: sendNewPreference,
        selectPreference: selectPreference,
        updatePreference: updatePreference,
        deletePreference: deletePreference,
        toggleShared: toggleShared
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getPreferences: __WEBPACK_IMPORTED_MODULE_4_actions_preferences_index__["e" /* getPreferences */],
        getPreference: __WEBPACK_IMPORTED_MODULE_4_actions_preferences_index__["d" /* getPreference */],
        clearSelectPreference: __WEBPACK_IMPORTED_MODULE_4_actions_preferences_index__["b" /* clearSelectPreference */]
    }, dispatch);
})(Settings);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Settings, 'Settings', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/Settings.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Sidebar/Settings.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gazetters__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Annotations__ = __webpack_require__(2158);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var ChooseContent = function ChooseContent(_ref) {
    var _ref$typeAnnotations = _ref.typeAnnotations,
        typeAnnotations = _ref$typeAnnotations === undefined ? 'annotate' : _ref$typeAnnotations,
        selectedType = _ref.selectedType,
        textLetter = _ref.textLetter,
        annotations = _ref.annotations,
        gazetters = _ref.gazetters,
        addNewGazetter = _ref.addNewGazetter,
        withChildren = _ref.withChildren,
        predictorData = _ref.predictorData,
        showUsefulLines = _ref.showUsefulLines;

    if (typeAnnotations === 'annotate') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Gazetters__["a" /* default */], {
            withChildren: withChildren,
            gazetters: gazetters,
            addNewGazetter: addNewGazetter,
            textLetter: textLetter,
            predictorData: predictorData,
            showUsefulLines: showUsefulLines
        });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Annotations__["a" /* default */], {
        selectedType: selectedType,
        typeAnnotations: typeAnnotations,
        annotations: annotations,
        textLetter: textLetter,
        predictorData: predictorData,
        showUsefulLines: showUsefulLines
    });
};

var _default = ChooseContent;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ChooseContent, 'ChooseContent', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/ChooseContent.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/ChooseContent.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddWordSelection__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_annotations__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(901);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










var ContentGazetter = function ContentGazetter(_ref) {
    var textLetter = _ref.textLetter,
        gazetters = _ref.gazetters,
        addNewGazetter = _ref.addNewGazetter,
        withChildren = _ref.withChildren,
        predictorData = _ref.predictorData,
        showUsefulLines = _ref.showUsefulLines;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openAddWordSelection = _useState2[0],
        setOpenAddWordSelection = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState4 = _slicedToArray(_useState3, 2),
        elementTarget = _useState4[0],
        setElementTarget = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState6 = _slicedToArray(_useState5, 2),
        selectedText = _useState6[0],
        setSelectedText = _useState6[1];

    console.log(showUsefulLines);

    var createCharacters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (text, gazettersFromServer) {
        var gazettersCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(gazettersFromServer);
        var characters = text.split('');

        characters = characters.map(function (symbol, symbolPosition) {
            return {
                symbol: symbol,
                symbolPosition: symbolPosition,
                style: {},
                ids: [],
                tooltipContent: []
            };
        });

        gazettersCopy.sort(function (first, second) {
            if (withChildren) {
                if (first.end - first.start < second.end - second.start) {
                    return -1;
                }
                if (first.end - first.start > second.end - second.start) {
                    return 1;
                }
                return 0;
            }
            if (first.end - first.start > second.end - second.start) {
                return -1;
            }
            if (first.end - first.start < second.end - second.start) {
                return 1;
            }
            return 0;
        });

        gazettersCopy.forEach(function (g) {
            for (var j = g.start; j < g.end; j++) {
                characters[j].style = {
                    background: g.color
                };
                characters[j].ids.push(g.id);
                characters[j].tooltipContent.push({
                    gazetteerName: g.gazetteerName,
                    gazetteerType: g.gazetteerType
                });
            }
        });

        return characters;
    }, [withChildren]);

    var createTooltips = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (characters) {
        var map = new Map();
        characters.forEach(function (char) {
            map.set(char.ids.join(''), char);
        });
        return Array.from(map.values());
    }, []);

    var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        if (textLetter && textLetter.length && gazetters && gazetters.length) {
            var chars = createCharacters(textLetter, gazetters);
            return {
                characters: chars,
                tooltips: createTooltips(chars)
            };
        }
        return { characters: undefined, tooltips: undefined };
    }, [textLetter, gazetters, createCharacters, createTooltips]),
        characters = _useMemo.characters,
        tooltips = _useMemo.tooltips;

    var onMouseUp = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (ev) {
        var range = __WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* default */].getSelection(ev.target.parentNode);

        if (range.start === range.end) {
            return;
        }

        setOpenAddWordSelection(true);
        setElementTarget(ev.target);
        setSelectedText(range.string);
    }, []);

    var closePopover = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        setOpenAddWordSelection(false);
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AddWordSelection__["a" /* default */], {
            addNewGazetter: addNewGazetter,
            openAddWordSelection: openAddWordSelection,
            elementTarget: elementTarget,
            closePopover: closePopover,
            selectedText: selectedText
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'letter-text', onMouseUp: onMouseUp },
            function () {
                if (showUsefulLines) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* renderUsefulLines */])(predictorData, textLetter);
                }
                if (characters) {
                    return Array.from(Object(__WEBPACK_IMPORTED_MODULE_4_helpers_annotations__["b" /* letterMapper */])(characters));
                }
                return textLetter;
            }()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_helpers_annotations__["a" /* AnnotationTooltip */], {
            tooltips: tooltips,
            renderTooltip: function renderTooltip(tooltip) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'tooltip-row' },
                    tooltip.tooltipContent.map(function (t, k) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: k, className: 'tooltip-column' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col' },
                                'GazetteerName - ' + t.gazetteerName + ', '
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col' },
                                'GazetteerType - ' + t.gazetteerType
                            )
                        );
                    })
                );
            }
        })
    );
};

var _default = ContentGazetter;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ContentGazetter, 'ContentGazetter', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/Gazetters.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/Gazetters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_cargoes_orders__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var AddWordSelection = function (_React$PureComponent) {
    _inherits(AddWordSelection, _React$PureComponent);

    function AddWordSelection(props) {
        _classCallCheck(this, AddWordSelection);

        var _this = _possibleConstructorReturn(this, (AddWordSelection.__proto__ || Object.getPrototypeOf(AddWordSelection)).call(this, props));

        _this.state = {
            dataSource: [],
            searchText: '',
            type: 'common',
            gazetter: {
                gazetteerName: '',
                gazetteerType: 'common',
                fileName: '',
                gazType: 'common',
                value: props.selectedText
            }
        };

        _this.onUpdateInput = _this.onUpdateInput.bind(_this);
        _this.onNewRequest = _this.onNewRequest.bind(_this);

        _this.handleChangeType = _this.handleChangeType.bind(_this);
        return _this;
    }

    _createClass(AddWordSelection, [{
        key: 'handleChangeType',
        value: function handleChangeType(event, index, value) {
            this.setState({
                type: value,
                gazetter: _extends({}, this.state.gazetter, {
                    gazType: value,
                    gazetteerType: value
                })
            });
        }
    }, {
        key: 'onUpdateInput',
        value: function onUpdateInput(searchText) {
            var dataSource = this.props.listGazetters.filteredList.filter(function (item) {
                return item.fileName.toLowerCase().includes(searchText.toLowerCase());
            });

            this.setState({
                searchText: searchText,
                dataSource: dataSource.map(function (item) {
                    return {
                        name: item.fileName,
                        item: item
                    };
                })
            });
        }
    }, {
        key: 'onNewRequest',
        value: function onNewRequest(updateProperties) {
            if (!updateProperties) {
                return;
            }

            this.setState({
                searchText: updateProperties.name,
                dataSource: [],
                type: updateProperties.item.$target,
                gazetter: _extends({}, this.state.gazetter, {
                    gazetteerName: updateProperties.name,
                    fileName: updateProperties.name,
                    gazType: updateProperties.item.$target,
                    gazetteerType: updateProperties.item.$target
                })
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                gazetter: _extends({}, this.state.gazetter, {
                    value: nextProps.selectedText
                })
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                dataSource = _state.dataSource,
                searchText = _state.searchText,
                type = _state.type,
                gazetter = _state.gazetter;
            var _props = this.props,
                openAddWordSelection = _props.openAddWordSelection,
                elementTarget = _props.elementTarget,
                closePopover = _props.closePopover,
                selectedText = _props.selectedText,
                addNewGazetter = _props.addNewGazetter;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'popup' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_material_ui_Popover___default.a,
                    {
                        open: openAddWordSelection,
                        anchorEl: elementTarget,
                        onRequestClose: closePopover,
                        animation: __WEBPACK_IMPORTED_MODULE_8_material_ui_Popover__["PopoverAnimationVertical"],
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'popup-choose' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'chosen' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'chosen-title' },
                                'Add word to gazetter'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'chosen-row' },
                                '\'' + selectedText + '\''
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { margin: '10px 0' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                                    textFieldStyle: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].autoCompleteCSS,
                                    floatingLabelText: 'Choose gazetter',
                                    searchText: searchText,
                                    dataSource: dataSource,
                                    dataSourceConfig: { text: 'name', value: 'item' },
                                    onUpdateInput: this.onUpdateInput,
                                    onNewRequest: this.onNewRequest,
                                    filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                                    listStyle: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].autoCompleteListStyle,
                                    popoverProps: {
                                        canAutoPosition: true,
                                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                        targetOrigin: { horizontal: 'left', vertical: 'top' }
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { margin: '10px 0' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Group',
                                        value: type,
                                        onChange: this.handleChangeType
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'common', primaryText: 'common' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'cargo', primaryText: 'cargo' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { value: 'vessel', primaryText: 'vessel' })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { margin: '10px 0', textAlign: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                    onClick: function onClick() {
                                        closePopover();
                                        addNewGazetter(gazetter);
                                    },
                                    primary: true,
                                    label: 'Add word'
                                })
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AddWordSelection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        listGazetters: state.listGazetters
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateCargoOrder: __WEBPACK_IMPORTED_MODULE_10_actions_cargoes_orders__["f" /* updateCargoOrder */]
    }, dispatch);
})(AddWordSelection);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AddWordSelection, 'AddWordSelection', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/AddWordSelection.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/AddWordSelection.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_annotations__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(901);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var ContentAnnotations = function ContentAnnotations(_ref) {
    var textLetter = _ref.textLetter,
        annotations = _ref.annotations,
        predictorData = _ref.predictorData,
        showUsefulLines = _ref.showUsefulLines;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
        _useState2 = _slicedToArray(_useState, 2),
        characters = _useState2[0],
        setCharacters = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
        _useState4 = _slicedToArray(_useState3, 2),
        tooltips = _useState4[0],
        setTooltips = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (annotations.length > 0) {
            var newCharacters = createCharacters(textLetter, annotations);
            var newTooltips = createTooltips(newCharacters);

            setCharacters(newCharacters);
            setTooltips(newTooltips);
        } else {
            setCharacters(undefined);
            setTooltips(undefined);
        }
    }, [textLetter, annotations]);

    var createCharacters = function createCharacters(textLetter, annotations) {
        var characters = textLetter.split('');

        characters = characters.map(function (symbol, symbolPosition) {
            symbol = symbol === ' ' ? '\xA0' : symbol;

            return {
                symbol: symbol,
                symbolPosition: symbolPosition,
                style: {},
                ids: [],
                tooltipContent: []
            };
        });

        var sortedAnnotations = [].concat(_toConsumableArray(annotations)).sort(function (a, b) {
            if (a.priority > b.priority) {
                return -1;
            }

            if (a.priority < b.priority) {
                return 1;
            }

            return 0;
        });

        for (var i = 0; i < sortedAnnotations.length; i++) {
            var hashColor = __WEBPACK_IMPORTED_MODULE_1_helpers__["a" /* default */].createHashColor();

            for (var j = sortedAnnotations[i].start; j < sortedAnnotations[i].end; j++) {
                if (sortedAnnotations[i].styles.background === '') {
                    characters[j].style = _extends({}, sortedAnnotations[i].styles, {
                        background: hashColor
                    });
                } else {
                    characters[j].style = sortedAnnotations[i].styles;
                }

                characters[j].ids.push(sortedAnnotations[i].id);
                characters[j].tooltipContent.push({
                    rule: sortedAnnotations[i].features.rule,
                    type: sortedAnnotations[i].type
                });
            }
        }

        return characters;
    };

    var createTooltips = function createTooltips(characters) {
        var map = new Map();
        characters.forEach(function (char) {
            map.set(char.ids.join(''), char);
        });
        return Array.from(map.values());
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'letter-text' },
            function () {
                if (showUsefulLines) {
                    return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* renderUsefulLines */])(predictorData, textLetter);
                }
                if (characters) {
                    return Array.from(Object(__WEBPACK_IMPORTED_MODULE_2_helpers_annotations__["b" /* letterMapper */])(characters));
                }
                return textLetter;
            }()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_helpers_annotations__["a" /* AnnotationTooltip */], {
            tooltips: tooltips,
            renderTooltip: function renderTooltip(tooltip) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'tooltip-row' },
                    tooltip.tooltipContent.map(function (t, k) {
                        var rule = t.rule && 'Rule - ' + t.rule + ', ';

                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: k, className: 'tooltip-column' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col' },
                                rule
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col' },
                                'Type - ' + t.type
                            )
                        );
                    })
                );
            }
        })
    );
};

var _default = ContentAnnotations;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ContentAnnotations, 'ContentAnnotations', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/Annotations.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Content/Annotations.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_tooltip__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var styles = {
    btn: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    }
};

/**
 * @typedef {Object} AnnotateLikeProps
 * @property {(status: 'annotate' | 'gazetter') => void} changeTypeAnnotations - callback fired when annotation type changes
 * @property {boolean} [isSpam] - whether the mail type is spam
 */

/**
 * toggle button component for switching between 'annotate' and 'gazetter' modes
 * 
 * @param {AnnotateLikeProps} props
 */
var AnnotateLike = function AnnotateLike(_ref) {
    var changeTypeAnnotations = _ref.changeTypeAnnotations,
        _ref$isSpam = _ref.isSpam,
        isSpam = _ref$isSpam === undefined ? false : _ref$isSpam;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('annotate'),
        _useState2 = _slicedToArray(_useState, 2),
        status = _useState2[0],
        setStatus = _useState2[1];

    var handleAnnotate = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (isSpam) return;
        var newStatus = status === 'annotate' ? 'gazetter' : 'annotate';
        setStatus(newStatus);
        changeTypeAnnotations(newStatus);
    }, [status, changeTypeAnnotations, isSpam]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
                'data-tip': isSpam ? 'Mail type <b>spam</b>, can not annotate as <b>spam</b>' : null,
                'data-for': 'spam-tooltip'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                labelStyle: styles.btn.labelStyle,
                style: styles.btn.style,
                buttonStyle: styles.btn.buttonStyle,
                label: status,
                onClick: handleAnnotate,
                disabled: isSpam,
                primary: true
            })
        ),
        isSpam && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tooltip___default.a, {
            id: 'spam-tooltip',
            effect: 'solid',
            html: true
        })
    );
};

AnnotateLike.displayName = 'AnnotateLike';

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(AnnotateLike);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/AnnotateLike.jsx');
    reactHotLoader.register(AnnotateLike, 'AnnotateLike', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/AnnotateLike.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/AnnotateLike.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px'
        }
    }
};

var TextEditor = function (_React$Component) {
    _inherits(TextEditor, _React$Component);

    function TextEditor(props) {
        _classCallCheck(this, TextEditor);

        var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this, props));

        _this.state = {
            open: false,
            textLetter: props.textLetter,
            originalText: props.textLetter
        };

        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.changeTextLetterText = _this.changeTextLetterText.bind(_this);
        _this.updateGazetters = _this.updateGazetters.bind(_this);
        _this.returnOriginalText = _this.returnOriginalText.bind(_this);
        return _this;
    }

    _createClass(TextEditor, [{
        key: 'returnOriginalText',
        value: function returnOriginalText() {
            this.setState({
                textLetter: this.state.originalText
            });
        }
    }, {
        key: 'updateGazetters',
        value: function updateGazetters() {
            var textLetter = this.state.textLetter;


            this.toggleDialog();

            if (this.props.typeAnnotations === 'gazetter') {
                this.props.updatePostAnnotations(textLetter);
            } else {
                this.props.updatePostGazetters(textLetter);
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var originalText = this.state.originalText;


            if (originalText === '') {
                originalText = nextProps.textLetter;
            }

            this.setState({
                textLetter: nextProps.textLetter,
                originalText: originalText
            });
        }
    }, {
        key: 'changeTextLetterText',
        value: function changeTextLetterText(e) {
            this.setState({
                textLetter: e.target.value
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            this.setState({
                open: !this.state.open
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                open = _state.open,
                textLetter = _state.textLetter;


            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RE-ANNOTATE',
                primary: true,
                onClick: this.updateGazetters
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'RETURN ORIGINAL TEXT',
                primary: true,
                onClick: this.returnOriginalText
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'CLOSE',
                primary: true,
                onClick: this.toggleDialog
            })];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    onClick: this.toggleDialog,
                    label: 'Editor',
                    labelStyle: styles.button.labelStyle,
                    style: styles.button.style,
                    buttonStyle: styles.button.buttonStyle,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
                    {
                        title: 'Edit letter text',
                        actions: actions,
                        contentStyle: styles.dialog.contentStyle,
                        open: open,
                        modal: true
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                        style: styles.textarea.style,
                        value: textLetter,
                        onChange: this.changeTextLetterText
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TextEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = TextEditor;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/TextEditor.jsx');
    reactHotLoader.register(TextEditor, 'TextEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/TextEditor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/TextEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_preferences_mailRecognizeSpamList__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_preferences_index__ = __webpack_require__(538);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px'
        }
    }
};

var AddMailRecognizeSpam = function (_React$Component) {
    _inherits(AddMailRecognizeSpam, _React$Component);

    function AddMailRecognizeSpam(props) {
        _classCallCheck(this, AddMailRecognizeSpam);

        var _this = _possibleConstructorReturn(this, (AddMailRecognizeSpam.__proto__ || Object.getPrototypeOf(AddMailRecognizeSpam)).call(this, props));

        _this.state = {
            open: false,
            text: ''
        };

        _this.toggleDialog = _this.toggleDialog.bind(_this);

        _this.savePostMailRecognizeSpam = _this.savePostMailRecognizeSpam.bind(_this);
        _this.changeTextLetterText = _this.changeTextLetterText.bind(_this);
        return _this;
    }

    _createClass(AddMailRecognizeSpam, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (!nextProps.preferences.isLoaded) {
                return;
            }

            var preferences = nextProps.preferences.items.filter(function (item) {
                return item.type === 'mailRecognizeSpamList';
            });

            this.setState({
                text: preferences[0] ? preferences[0].mailRecognizeSpamList.join('\n') : ''
            });
        }
    }, {
        key: 'savePostMailRecognizeSpam',
        value: function savePostMailRecognizeSpam() {
            var text = this.state.text;


            this.props.updatePreference(text.split('\n'), this.props.preferences.items[0]._id);
        }
    }, {
        key: 'changeTextLetterText',
        value: function changeTextLetterText(e) {
            this.setState({
                text: e.target.value
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog() {
            if (!this.state.open) {
                this.props.getMailRecognizeSpamList();
            }

            this.setState({
                open: !this.state.open
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                open = _state.open,
                text = _state.text;


            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], {
                label: 'SAVE',
                primary: true,
                onClick: function onClick() {
                    _this2.savePostMailRecognizeSpam();
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], {
                label: 'CLOSE',
                primary: true,
                onClick: this.toggleDialog
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                    onClick: this.toggleDialog,
                    label: 'Recognize spam',
                    labelStyle: styles.button.labelStyle,
                    style: styles.button.style,
                    buttonStyle: styles.button.buttonStyle,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["f" /* Dialog */],
                    {
                        title: 'Edit recognize spam',
                        actions: actions,
                        contentStyle: styles.dialog.contentStyle,
                        open: open
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                        style: styles.textarea.style,
                        value: text,
                        onChange: this.changeTextLetterText
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AddMailRecognizeSpam;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref) {
    var preferences = _ref.preferences;


    return {
        preferences: preferences
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getMailRecognizeSpamList: __WEBPACK_IMPORTED_MODULE_5_actions_preferences_mailRecognizeSpamList__["a" /* getMailRecognizeSpamList */],
        updatePreference: __WEBPACK_IMPORTED_MODULE_6_actions_preferences_index__["g" /* updatePreference */]
    }, dispatch);
})(AddMailRecognizeSpam);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/AddMailRecognizeSpam.jsx');
    reactHotLoader.register(AddMailRecognizeSpam, 'AddMailRecognizeSpam', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/AddMailRecognizeSpam.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/Management/AddMailRecognizeSpam.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getMailRecognizeSpamList;
/* unused harmony export createMailRecognizeSpamList */
/* unused harmony export updateMailRecognizeSpamList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getMailRecognizeSpamList() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_35" /* GET_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST
    };
}

function createMailRecognizeSpamList(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["E" /* CREATE_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST,
        data: data
    };
}

function updateMailRecognizeSpamList(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_132" /* UPDATE_MAIL_RECOGNIZE_SPAM_LIST */].REQUEST,
        data: data
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getMailRecognizeSpamList, 'getMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(createMailRecognizeSpamList, 'createMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/mailRecognizeSpamList.js');
    reactHotLoader.register(updateMailRecognizeSpamList, 'updateMailRecognizeSpamList', '/opt/atlassian/pipelines/agent/build/client/app/actions/preferences/mailRecognizeSpamList.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












var styles = {
    textField: {
        hintStyle: { fontSize: 12 },
        style: { fontSize: 12, width: 'unset' }
    },
    table: {
        // Base styles for all columns
        baseColumnStyle: {
            padding: '8px 10px',
            fontSize: '13px',
            borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
            height: 'auto',
            overflow: 'visible',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            lineHeight: '1.4'
        },

        row: {
            style: {
                height: 'auto',
                borderBottom: '1px solid rgba(0, 188, 212, 0.1)',
                transition: 'background-color 0.2s ease',
                ':hover': {
                    backgroundColor: 'rgba(0, 188, 212, 0.05)'
                }
            }
        },

        col: {
            style: {
                padding: '8px 10px',
                fontSize: '13px',
                fontWeight: '500',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4'
            }
        },

        sortLayoutByn: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },

        smallCol: {
            style: {
                position: 'relative',
                cursor: 'pointer',
                padding: '8px 10px',
                fontWeight: '500',
                width: '55px',
                fontSize: '13px',
                textAlign: 'center',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4'
            }
        },

        firstCol: {
            style: {
                padding: '8px 10px',
                fontSize: '13px',
                fontWeight: '500',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4'
            }
        },

        fullColumn: {
            style: {
                width: '300px',
                padding: '8px 10px',
                fontSize: '13px',
                borderBottom: '1px solid rgba(0, 188, 212, 0.2)',
                height: 'auto',
                overflow: 'visible',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
                hyphens: 'auto',
                lineHeight: '1.4',
                backgroundColor: 'rgba(0, 188, 212, 0.03)'
                // fontFamily: 'Roboto, sans-serif',
            }
        },

        headerStyle: {
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
                color: 'rgb(0, 188, 212)',
                borderBottom: '2px solid rgb(0, 188, 212)',
                textTransform: 'uppercase',
                padding: '10px',
                backgroundColor: 'rgba(0, 188, 212, 0.05)'
            }
        }
    }
};

var AnnotationList = function AnnotationList(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState2 = _slicedToArray(_useState, 2),
        directionById = _useState2[0],
        setDirectionById = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([10, 20, 30]),
        _useState4 = _slicedToArray(_useState3, 1),
        rowsPerPage = _useState4[0];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        rows = _useState6[0],
        setRows = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(10),
        _useState8 = _slicedToArray(_useState7, 2),
        numberOfRows = _useState8[0],
        setNumberOfRows = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState10 = _slicedToArray(_useState9, 2),
        page = _useState10[0],
        setPage = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState12 = _slicedToArray(_useState11, 2),
        total = _useState12[0],
        setTotal = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.annotations),
        _useState14 = _slicedToArray(_useState13, 2),
        annotations = _useState14[0],
        setAnnotations = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState16 = _slicedToArray(_useState15, 2),
        searchText = _useState16[0],
        setSearchText = _useState16[1];

    var sortById = function sortById(items) {
        var newItems = [].concat(_toConsumableArray(items));

        newItems.sort(function (a, b) {
            if (directionById) {
                if (a.id > b.id) {
                    return 1;
                }

                if (a.id < b.id) {
                    return -1;
                }

                return 1;
            }
            if (a.id < b.id) {
                return 1;
            }

            if (a.id > b.id) {
                return -1;
            }

            return 1;
        });

        return newItems;
    };

    var changeSortById = function changeSortById() {
        setDirectionById(!directionById);

        var _filterAnnotations = filterAnnotations(searchText, props.annotations),
            filteredAnnotations = _filterAnnotations.annotations;

        setPage(1);
        var sortedAnnotations = sortById(filteredAnnotations);
        setAnnotations(sortedAnnotations);
        setTotal(filteredAnnotations.length);

        setTimeout(function () {
            handleUpdateRow({
                page: 1,
                numberOfRows: numberOfRows,
                annotations: sortedAnnotations
            });
        }, 0);
    };

    var filterAnnotations = function filterAnnotations() {
        var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchText;
        var annotationsData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.annotations;

        var searchLower = text.toLowerCase();

        var filteredAnnotations = annotationsData.filter(function (annotation) {
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(annotation, 'features.rule') && annotation.features.rule.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(annotation, 'features.majorType') && annotation.features.majorType.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(annotation, 'features.string') && annotation.features.string.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(annotation, 'type') && annotation.type.toLowerCase().includes(searchLower)) {
                return true;
            }

            if (annotation.id) {
                var id = annotation.id + '';
                if (id.includes(searchLower)) {
                    return true;
                }
            }

            return false;
        });

        return {
            searchText: text,
            annotations: filteredAnnotations
        };
    };

    var handleSearch = function handleSearch(e, value) {
        var _filterAnnotations2 = filterAnnotations(value),
            filteredAnnotations = _filterAnnotations2.annotations;

        setPage(1);
        setAnnotations(filteredAnnotations);
        setSearchText(value);

        setTimeout(function () {
            handleUpdateRow({
                page: 1,
                numberOfRows: numberOfRows,
                annotations: filteredAnnotations
            });
        }, 0);
    };

    var changeRowsByPagination = function changeRowsByPagination(state) {
        var elementsOnPage = state.numberOfRows;
        var offset = state.page - 1;
        var from = offset * elementsOnPage;
        var to = offset * elementsOnPage + elementsOnPage;

        return (state.annotations || annotations).slice(from, to);
    };

    var handleUpdateRow = function handleUpdateRow(newState) {
        var newRows = changeRowsByPagination(newState);
        setRows(newRows);

        if (newState.page !== page) {
            setPage(newState.page);
        }

        if (newState.numberOfRows !== numberOfRows) {
            setNumberOfRows(newState.numberOfRows);
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var _filterAnnotations3 = filterAnnotations(searchText, props.annotations),
            filteredAnnotations = _filterAnnotations3.annotations;

        var sortedAnnotations = sortById(filteredAnnotations);

        setPage(1);
        setAnnotations(sortedAnnotations);
        setTotal(props.annotations.length);

        handleUpdateRow({
            page: 1,
            numberOfRows: numberOfRows,
            annotations: sortedAnnotations
        });
    }, [props.annotations]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        handleUpdateRow({
            page: page,
            numberOfRows: numberOfRows,
            annotations: annotations
        });
    }, []);

    var annotationsHeaders = props.annotationsHeaders;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'annotations-list-b' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'navigation',
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: '2px solid rgba(0, 188, 212, 0.3)',
                    backgroundColor: 'rgba(0, 188, 212, 0.05)',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                    borderTopLeftRadius: '2px',
                    borderTopRightRadius: '2px'
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'navigation-search',
                    style: {
                        marginRight: '20px',
                        display: 'flex',
                        alignItems: 'center'
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: {
                            fontSize: '13px',
                            fontWeight: 'bold',
                            color: 'rgb(0, 188, 212)',
                            marginRight: '8px'
                        }
                    },
                    'Search:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                    hintText: 'Enter search term...',
                    hintStyle: _extends({}, styles.textField.hintStyle, {
                        color: 'rgba(0, 0, 0, 0.3)'
                    }),
                    style: _extends({}, styles.textField.style, {
                        marginBottom: 0
                    }),
                    inputStyle: {
                        padding: '2px 5px',
                        border: '1px solid rgba(0, 188, 212, 0.3)',
                        borderRadius: '3px',
                        backgroundColor: 'white'
                    },
                    underlineShow: false,
                    onChange: handleSearch,
                    value: searchText || ''
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'navigation-arrows',
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '20px',
                        padding: '0 10px',
                        borderLeft: '1px solid rgba(0, 188, 212, 0.2)',
                        borderRight: '1px solid rgba(0, 188, 212, 0.2)'
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__["a" /* default */], {
                    total: annotations.length,
                    rowsPerPage: rowsPerPage,
                    page: page,
                    numberOfRows: numberOfRows,
                    updateRows: handleUpdateRow
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'navigation-info',
                    style: {
                        fontSize: '12px',
                        color: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        flexDirection: 'column'
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginBottom: '3px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontWeight: 'bold', color: 'rgb(0, 188, 212)' } },
                        'Annotations:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { marginLeft: '5px' } },
                        annotations.length
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { marginRight: '10px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { fontWeight: 'bold', color: 'rgb(0, 188, 212)' } },
                            'Time:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { marginLeft: '5px' } },
                            annotationsHeaders['x-parse-time'],
                            ' ms'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { fontWeight: 'bold', color: 'rgb(0, 188, 212)' } },
                            'Server:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { marginLeft: '5px' } },
                            annotationsHeaders['x-server-name']
                        )
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'annotations-table', style: { overflow: 'auto' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
                {
                    selectable: false,
                    fixedHeader: true,
                    wrapperStyle: { height: '100%' },
                    bodyStyle: { height: 'calc(100% - 42px)' }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeader"],
                    {
                        displaySelectAll: false,
                        adjustForCheckbox: false
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                        { style: styles.table.row.style },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                            { style: _extends({}, styles.table.col.style, styles.table.headerStyle.style) },
                            'Value'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                            { style: _extends({}, styles.table.col.style, styles.table.headerStyle.style) },
                            'Rule'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                            { style: _extends({}, styles.table.col.style, styles.table.headerStyle.style) },
                            'Type'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                            { style: _extends({}, styles.table.col.style, styles.table.headerStyle.style) },
                            'MajorType'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                            { style: _extends({}, styles.table.fullColumn.style, styles.table.headerStyle.style) },
                            'Features'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                            { style: _extends({}, styles.table.smallCol.style, styles.table.headerStyle.style) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: styles.table.sortLayoutByn, onClick: changeSortById },
                                'id ',
                                directionById ? '▲' : '▼'
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false, style: { height: 'calc(100% - 42px)' } },
                    rows.map(function (annotation, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                            {
                                style: _extends({}, styles.table.row.style, {
                                    backgroundColor: i % 2 === 0 ? 'rgba(0, 188, 212, 0.02)' : 'transparent'
                                }),
                                key: i,
                                hoverable: true
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                { style: _extends({}, styles.table.firstCol.style, {
                                        color: 'rgba(0, 0, 0, 0.8)',
                                        fontWeight: 500
                                    })
                                },
                                annotation.features.string
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                { style: styles.table.col.style },
                                annotation.features.rule
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                { style: styles.table.col.style },
                                annotation.type
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                { style: styles.table.col.style },
                                annotation.features.majorType
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                { style: _extends({}, styles.table.fullColumn.style, {
                                        backgroundColor: 'rgba(0, 188, 212, 0.03)',
                                        borderLeft: '1px solid rgba(0, 188, 212, 0.1)',
                                        borderRight: '1px solid rgba(0, 188, 212, 0.1)'
                                    })
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'pre',
                                    { style: {
                                            margin: 0,
                                            padding: 0,
                                            fontSize: '12px',
                                            fontFamily: 'monospace',
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word'
                                        }
                                    },
                                    annotation.features ? JSON.stringify(annotation.features, null, 2) : ''
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                                { style: _extends({}, styles.table.smallCol.style, {
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        color: 'rgba(0, 188, 212, 0.8)'
                                    })
                                },
                                annotation.id
                            )
                        );
                    })
                )
            )
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var _ref$annotations = _ref.annotations,
        annotations = _ref$annotations.items,
        annotationsHeaders = _ref$annotations.headers;
    return {
        annotations: annotations,
        annotationsHeaders: annotationsHeaders
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(AnnotationList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/List/Annotation.jsx');
    reactHotLoader.register(AnnotationList, 'AnnotationList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/List/Annotation.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/List/Annotation.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_autocomplete__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_virtualized_dist_es_AutoSizer__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_virtualized_dist_es_List__ = __webpack_require__(549);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var styles = {
    textField: {
        hintStyle: {
            fontSize: '12px'
        },
        style: {
            fontSize: '12px'
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    tableButton: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px' },
        buttonStyle: { height: '25px', lineHeight: '25px' }
    },
    autocomplete: {
        menuStyle: {
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 0',
            fontSize: '16px',
            position: 'absolute',
            overflow: 'auto',
            left: 0,
            bottom: 0,
            top: '25px',
            minHeight: '200px',
            zIndex: 1111

        },
        wrapperStyle: {
            width: '100%',
            position: 'relative'
        }

    }
};

var GazetterList = function (_React$PureComponent) {
    _inherits(GazetterList, _React$PureComponent);

    function GazetterList(props) {
        _classCallCheck(this, GazetterList);

        var _this = _possibleConstructorReturn(this, (GazetterList.__proto__ || Object.getPrototypeOf(GazetterList)).call(this, props));

        _this.renderRow = _this.renderRow.bind(_this);
        _this.changeRow = _this.changeRow.bind(_this);
        return _this;
    }

    _createClass(GazetterList, [{
        key: 'changeRow',
        value: function changeRow(fields, gazetter) {
            var cloneGazetter = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(gazetter);

            fields.forEach(function (item) {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(cloneGazetter, item.field, item.value);
            });

            this.props.changeGazetter(_extends({}, cloneGazetter, {
                value: cloneGazetter.value,
                gazetteerName: cloneGazetter.gazetteerName
            }));
        }
    }, {
        key: 'renderRow',
        value: function renderRow(_ref) {
            var _this2 = this;

            var index = _ref.index,
                key = _ref.key,
                style = _ref.style;
            var _props = this.props,
                gazetters = _props.gazetters,
                listGazetters = _props.listGazetters,
                removeGazetter = _props.removeGazetter,
                clearGazetter = _props.clearGazetter;

            var gazetter = gazetters[index];
            var featuresValue = JSON.stringify(gazetter.features || {}, null, 2);

            function renderMenu(items, value, style) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: _extends({}, style, this.menuStyle), children: items });
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    style: _extends({}, style),
                    key: key,
                    className: 'gazetter-row ' + gazetter.status
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column', style: { width: '25%' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_autocomplete___default.a, {
                        menuStyle: styles.autocomplete.menuStyle,
                        wrapperStyle: styles.autocomplete.wrapperStyle,
                        getItemValue: function getItemValue(item) {
                            return item.fileName;
                        },
                        items: listGazetters.filteredList,
                        renderMenu: renderMenu,
                        renderItem: function renderItem(item, isHighlighted) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: index, style: { height: '25px', cursor: 'pointer', background: isHighlighted ? 'lightgray' : 'white' } },
                                item.fileName
                            );
                        },
                        shouldItemRender: function shouldItemRender(item, value) {
                            return item.fileName.toLowerCase().indexOf(value.toLowerCase()) > -1;
                        },
                        value: gazetter.gazetteerName,
                        onChange: function onChange(e) {
                            _this2.changeRow([{ field: 'gazetteerName', value: e.target.value }], gazetter);
                        },
                        onSelect: function onSelect(name, item) {
                            _this2.changeRow([{ field: 'gazetteerName', value: name }, { field: 'gazetteerType', value: item.$target }], gazetter);
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column', style: { width: '25%' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        type: 'text',
                        value: gazetter.value,
                        onChange: function onChange(e) {
                            _this2.changeRow([{ field: 'value', value: e.target.value }], gazetter);
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column features', title: featuresValue, style: { width: '40%' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'features-value' },
                        featuresValue
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'column management', style: { width: '10%', justifyContent: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.button.labelStyle,
                        style: styles.button.style,
                        buttonStyle: styles.button.buttonStyle,
                        label: 'DELETE',
                        onClick: function onClick() {
                            removeGazetter(gazetter);
                        },
                        secondary: true
                    }),
                    gazetter.status && gazetter.status !== 'new' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        labelStyle: styles.button.labelStyle,
                        style: styles.button.style,
                        buttonStyle: styles.button.buttonStyle,
                        label: 'CLEAR',
                        onClick: function onClick() {
                            clearGazetter(gazetter);
                        },
                        primary: true
                    }) : null
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                gazetters = _props2.gazetters,
                searchText = _props2.searchText,
                filterGazetters = _props2.filterGazetters,
                saveGazetters = _props2.saveGazetters,
                isError = _props2.isError;


            var renderComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'gazetters-list-b container-fluid' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row middle-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            hintText: 'Search',
                            hintStyle: styles.textField.hintStyle,
                            style: styles.textField.style,
                            onChange: function onChange(e, value) {
                                filterGazetters(value);
                            },
                            value: searchText
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-9' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                            label: 'Save gazetters',
                            labelStyle: styles.button.labelStyle,
                            style: styles.button.style,
                            buttonStyle: styles.button.buttonStyle,
                            onClick: saveGazetters,
                            primary: true
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { fontSize: '13px', marginLeft: '10px' } },
                            'Total found unique words: ',
                            gazetters.length
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'gazetters-table' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'gazetter-row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'header-column', style: { width: '25%' } },
                            'Gazetter'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'header-column', style: { width: '25%' } },
                            'Word'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'header-column', style: { width: '40%' } },
                            'Features'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'header-column', style: { width: '10%' } },
                            '\xA0'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'gazetter-table-body' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_react_virtualized_dist_es_AutoSizer__["a" /* AutoSizer */],
                            null,
                            function (_ref2) {
                                var width = _ref2.width,
                                    height = _ref2.height;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_virtualized_dist_es_List__["a" /* List */], {
                                    ref: function ref(list) {
                                        _this3.list = list;
                                    },
                                    rowRenderer: _this3.renderRow,
                                    height: height,
                                    width: width,
                                    rowHeight: 25,
                                    rowCount: gazetters.length,
                                    gazetters: gazetters
                                });
                            }
                        )
                    )
                )
            );

            var renderError = 'Something wrong with request';

            if (isError) {
                renderComponent = null;
            } else {
                renderError = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                renderComponent,
                renderError
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return GazetterList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        isError: state.gazetters.isError,
        listGazetters: state.listGazetters
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(GazetterList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/List/Gazetter.jsx');
    reactHotLoader.register(GazetterList, 'GazetterList', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/List/Gazetter.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/List/Gazetter.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(5);

var _require = __webpack_require__(49),
    findDOMNode = _require.findDOMNode;

var scrollIntoView = __webpack_require__(2166);

var IMPERATIVE_API = ['blur', 'checkValidity', 'click', 'focus', 'select', 'setCustomValidity', 'setSelectionRange', 'setRangeText'];

function getScrollOffset() {
  return {
    x: window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
    y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
  };
}

var Autocomplete = function (_React$Component) {
  _inherits(Autocomplete, _React$Component);

  function Autocomplete(props) {
    _classCallCheck(this, Autocomplete);

    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));

    _this.state = {
      isOpen: false,
      highlightedIndex: null
    };
    _this._debugStates = [];
    _this.ensureHighlightedIndex = _this.ensureHighlightedIndex.bind(_this);
    _this.exposeAPI = _this.exposeAPI.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.maybeAutoCompleteText = _this.maybeAutoCompleteText.bind(_this);
    return _this;
  }

  _createClass(Autocomplete, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // this.refs is frozen, so we need to assign a new object to it
      this.refs = {};
      this._ignoreBlur = false;
      this._ignoreFocus = false;
      this._scrollOffset = null;
      this._scrollTimer = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._scrollTimer);
      this._scrollTimer = null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.highlightedIndex !== null) {
        this.setState(this.ensureHighlightedIndex);
      }
      if (nextProps.autoHighlight && (this.props.value !== nextProps.value || this.state.highlightedIndex === null)) {
        this.setState(this.maybeAutoCompleteText);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isOpen()) {
        this.setMenuPositions();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isOpen && !prevState.isOpen || 'open' in this.props && this.props.open && !prevProps.open) this.setMenuPositions();

      this.maybeScrollItemIntoView();
      if (prevState.isOpen !== this.state.isOpen) {
        this.props.onMenuVisibilityChange(this.state.isOpen);
      }
    }
  }, {
    key: 'exposeAPI',
    value: function exposeAPI(el) {
      var _this2 = this;

      this.refs.input = el;
      IMPERATIVE_API.forEach(function (ev) {
        return _this2[ev] = el && el[ev] && el[ev].bind(el);
      });
    }
  }, {
    key: 'maybeScrollItemIntoView',
    value: function maybeScrollItemIntoView() {
      if (this.isOpen() && this.state.highlightedIndex !== null) {
        var itemNode = this.refs['item-' + this.state.highlightedIndex];
        var menuNode = this.refs.menu;
        scrollIntoView(findDOMNode(itemNode), findDOMNode(menuNode), { onlyScrollIfNeeded: true });
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (Autocomplete.keyDownHandlers[event.key]) Autocomplete.keyDownHandlers[event.key].call(this, event);else if (!this.isOpen()) {
        this.setState({
          isOpen: true
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.props.onChange(event, event.target.value);
    }
  }, {
    key: 'getFilteredItems',
    value: function getFilteredItems(props) {
      var items = props.items;

      if (props.shouldItemRender) {
        items = items.filter(function (item) {
          return props.shouldItemRender(item, props.value);
        });
      }

      if (props.sortItems) {
        items.sort(function (a, b) {
          return props.sortItems(a, b, props.value);
        });
      }

      return items;
    }
  }, {
    key: 'maybeAutoCompleteText',
    value: function maybeAutoCompleteText(state, props) {
      var highlightedIndex = state.highlightedIndex;
      var value = props.value,
          getItemValue = props.getItemValue;

      var index = highlightedIndex === null ? 0 : highlightedIndex;
      var items = this.getFilteredItems(props);
      for (var i = 0; i < items.length; i++) {
        if (props.isItemSelectable(items[index])) break;
        index = (index + 1) % items.length;
      }
      var matchedItem = items[index] && props.isItemSelectable(items[index]) ? items[index] : null;
      if (value !== '' && matchedItem) {
        var itemValue = getItemValue(matchedItem);
        var itemValueDoesMatch = itemValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
        if (itemValueDoesMatch) {
          return { highlightedIndex: index };
        }
      }
      return { highlightedIndex: null };
    }
  }, {
    key: 'ensureHighlightedIndex',
    value: function ensureHighlightedIndex(state, props) {
      if (state.highlightedIndex >= this.getFilteredItems(props).length) {
        return { highlightedIndex: null };
      }
    }
  }, {
    key: 'setMenuPositions',
    value: function setMenuPositions() {
      var node = this.refs.input;
      var rect = node.getBoundingClientRect();
      var computedStyle = global.window.getComputedStyle(node);
      var marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
      var marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
      var marginRight = parseInt(computedStyle.marginRight, 10) || 0;
      this.setState({
        menuTop: rect.bottom + marginBottom,
        menuLeft: rect.left + marginLeft,
        menuWidth: rect.width + marginLeft + marginRight
      });
    }
  }, {
    key: 'highlightItemFromMouse',
    value: function highlightItemFromMouse(index) {
      this.setState({ highlightedIndex: index });
    }
  }, {
    key: 'selectItemFromMouse',
    value: function selectItemFromMouse(item) {
      var _this3 = this;

      var value = this.props.getItemValue(item);
      // The menu will de-render before a mouseLeave event
      // happens. Clear the flag to release control over focus
      this.setIgnoreBlur(false);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, function () {
        _this3.props.onSelect(value, item);
      });
    }
  }, {
    key: 'setIgnoreBlur',
    value: function setIgnoreBlur(ignore) {
      this._ignoreBlur = ignore;
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this4 = this;

      var items = this.getFilteredItems(this.props).map(function (item, index) {
        var element = _this4.props.renderItem(item, _this4.state.highlightedIndex === index, { cursor: 'default' });
        return React.cloneElement(element, {
          onMouseEnter: _this4.props.isItemSelectable(item) ? function () {
            return _this4.highlightItemFromMouse(index);
          } : null,
          onClick: _this4.props.isItemSelectable(item) ? function () {
            return _this4.selectItemFromMouse(item);
          } : null,
          ref: function ref(e) {
            return _this4.refs['item-' + index] = e;
          }
        });
      });
      var style = {
        left: this.state.menuLeft,
        top: this.state.menuTop,
        minWidth: this.state.menuWidth
      };
      var menu = this.props.renderMenu(items, this.props.value, style);
      return React.cloneElement(menu, {
        ref: function ref(e) {
          return _this4.refs.menu = e;
        },
        // Ignore blur to prevent menu from de-rendering before we can process click
        onTouchStart: function onTouchStart() {
          return _this4.setIgnoreBlur(true);
        },
        onMouseEnter: function onMouseEnter() {
          return _this4.setIgnoreBlur(true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this4.setIgnoreBlur(false);
        }
      });
    }
  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur(event) {
      var _this5 = this;

      if (this._ignoreBlur) {
        this._ignoreFocus = true;
        this._scrollOffset = getScrollOffset();
        this.refs.input.focus();
        return;
      }
      var setStateCallback = void 0;
      var highlightedIndex = this.state.highlightedIndex;

      if (this.props.selectOnBlur && highlightedIndex !== null) {
        var items = this.getFilteredItems(this.props);
        var item = items[highlightedIndex];
        var value = this.props.getItemValue(item);
        setStateCallback = function setStateCallback() {
          return _this5.props.onSelect(value, item);
        };
      }
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, setStateCallback);
      var onBlur = this.props.inputProps.onBlur;

      if (onBlur) {
        onBlur(event);
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(event) {
      var _this6 = this;

      if (this._ignoreFocus) {
        this._ignoreFocus = false;
        var _scrollOffset = this._scrollOffset,
            x = _scrollOffset.x,
            y = _scrollOffset.y;

        this._scrollOffset = null;
        // Focus will cause the browser to scroll the <input> into view.
        // This can cause the mouse coords to change, which in turn
        // could cause a new highlight to happen, cancelling the click
        // event (when selecting with the mouse)
        window.scrollTo(x, y);
        // Some browsers wait until all focus event handlers have been
        // processed before scrolling the <input> into view, so let's
        // scroll again on the next tick to ensure we're back to where
        // the user was before focus was lost. We could do the deferred
        // scroll only, but that causes a jarring split second jump in
        // some browsers that scroll before the focus event handlers
        // are triggered.
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(function () {
          _this6._scrollTimer = null;
          window.scrollTo(x, y);
        }, 0);
        return;
      }
      this.setState({ isOpen: true });
      var onFocus = this.props.inputProps.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    }
  }, {
    key: 'isInputFocused',
    value: function isInputFocused() {
      var el = this.refs.input;
      return el.ownerDocument && el === el.ownerDocument.activeElement;
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick() {
      // Input will not be focused if it's disabled
      if (this.isInputFocused() && !this.isOpen()) this.setState({ isOpen: true });
    }
  }, {
    key: 'composeEventHandlers',
    value: function composeEventHandlers(internal, external) {
      return external ? function (e) {
        internal(e);external(e);
      } : internal;
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return 'open' in this.props ? this.props.open : this.state.isOpen;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.debug) {
        // you don't like it, you love it
        this._debugStates.push({
          id: this._debugStates.length,
          state: this.state
        });
      }

      var inputProps = this.props.inputProps;

      var open = this.isOpen();
      return React.createElement(
        'div',
        _extends({ style: _extends({}, this.props.wrapperStyle) }, this.props.wrapperProps),
        this.props.renderInput(_extends({}, inputProps, {
          role: 'combobox',
          'aria-autocomplete': 'list',
          'aria-expanded': open,
          autoComplete: 'off',
          ref: this.exposeAPI,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          onChange: this.handleChange,
          onKeyDown: this.composeEventHandlers(this.handleKeyDown, inputProps.onKeyDown),
          onClick: this.composeEventHandlers(this.handleInputClick, inputProps.onClick),
          value: this.props.value
        })),
        open && this.renderMenu(),
        this.props.debug && React.createElement(
          'pre',
          { style: { marginLeft: 300 } },
          JSON.stringify(this._debugStates.slice(Math.max(0, this._debugStates.length - 5), this._debugStates.length), null, 2)
        )
      );
    }
  }]);

  return Autocomplete;
}(React.Component);

Autocomplete.propTypes = {
  /**
   * The items to display in the dropdown menu
   */
  items: PropTypes.array.isRequired,
  /**
   * The value to display in the input field
   */
  value: PropTypes.any,
  /**
   * Arguments: `event: Event, value: String`
   *
   * Invoked every time the user changes the input's value.
   */
  onChange: PropTypes.func,
  /**
   * Arguments: `value: String, item: Any`
   *
   * Invoked when the user selects an item from the dropdown menu.
   */
  onSelect: PropTypes.func,
  /**
   * Arguments: `item: Any, value: String`
   *
   * Invoked for each entry in `items` and its return value is used to
   * determine whether or not it should be displayed in the dropdown menu.
   * By default all items are always rendered.
   */
  shouldItemRender: PropTypes.func,
  /**
   * Arguments: `item: Any`
   *
   * Invoked when attempting to select an item. The return value is used to
   * determine whether the item should be selectable or not.
   * By default all items are selectable.
   */
  isItemSelectable: PropTypes.func,
  /**
   * Arguments: `itemA: Any, itemB: Any, value: String`
   *
   * The function which is used to sort `items` before display.
   */
  sortItems: PropTypes.func,
  /**
   * Arguments: `item: Any`
   *
   * Used to read the display value from each entry in `items`.
   */
  getItemValue: PropTypes.func.isRequired,
  /**
   * Arguments: `item: Any, isHighlighted: Boolean, styles: Object`
   *
   * Invoked for each entry in `items` that also passes `shouldItemRender` to
   * generate the render tree for each item in the dropdown menu. `styles` is
   * an optional set of styles that can be applied to improve the look/feel
   * of the items in the dropdown menu.
   */
  renderItem: PropTypes.func.isRequired,
  /**
   * Arguments: `items: Array<Any>, value: String, styles: Object`
   *
   * Invoked to generate the render tree for the dropdown menu. Ensure the
   * returned tree includes every entry in `items` or else the highlight order
   * and keyboard navigation logic will break. `styles` will contain
   * { top, left, minWidth } which are the coordinates of the top-left corner
   * and the width of the dropdown menu.
   */
  renderMenu: PropTypes.func,
  /**
   * Styles that are applied to the dropdown menu in the default `renderMenu`
   * implementation. If you override `renderMenu` and you want to use
   * `menuStyle` you must manually apply them (`this.props.menuStyle`).
   */
  menuStyle: PropTypes.object,
  /**
   * Arguments: `props: Object`
   *
   * Invoked to generate the input element. The `props` argument is the result
   * of merging `props.inputProps` with a selection of props that are required
   * both for functionality and accessibility. At the very least you need to
   * apply `props.ref` and all `props.on<event>` event handlers. Failing to do
   * this will cause `Autocomplete` to behave unexpectedly.
   */
  renderInput: PropTypes.func,
  /**
   * Props passed to `props.renderInput`. By default these props will be
   * applied to the `<input />` element rendered by `Autocomplete`, unless you
   * have specified a custom value for `props.renderInput`. Any properties
   * supported by `HTMLInputElement` can be specified, apart from the
   * following which are set by `Autocomplete`: value, autoComplete, role,
   * aria-autocomplete. `inputProps` is commonly used for (but not limited to)
   * placeholder, event handlers (onFocus, onBlur, etc.), autoFocus, etc..
   */
  inputProps: PropTypes.object,
  /**
   * Props that are applied to the element which wraps the `<input />` and
   * dropdown menu elements rendered by `Autocomplete`.
   */
  wrapperProps: PropTypes.object,
  /**
   * This is a shorthand for `wrapperProps={{ style: <your styles> }}`.
   * Note that `wrapperStyle` is applied before `wrapperProps`, so the latter
   * will win if it contains a `style` entry.
   */
  wrapperStyle: PropTypes.object,
  /**
   * Whether or not to automatically highlight the top match in the dropdown
   * menu.
   */
  autoHighlight: PropTypes.bool,
  /**
   * Whether or not to automatically select the highlighted item when the
   * `<input>` loses focus.
   */
  selectOnBlur: PropTypes.bool,
  /**
   * Arguments: `isOpen: Boolean`
   *
   * Invoked every time the dropdown menu's visibility changes (i.e. every
   * time it is displayed/hidden).
   */
  onMenuVisibilityChange: PropTypes.func,
  /**
   * Used to override the internal logic which displays/hides the dropdown
   * menu. This is useful if you want to force a certain state based on your
   * UX/business logic. Use it together with `onMenuVisibilityChange` for
   * fine-grained control over the dropdown menu dynamics.
   */
  open: PropTypes.bool,
  debug: PropTypes.bool
};
Autocomplete.defaultProps = {
  value: '',
  wrapperProps: {},
  wrapperStyle: {
    display: 'inline-block'
  },
  inputProps: {},
  renderInput: function renderInput(props) {
    return React.createElement('input', props);
  },
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  isItemSelectable: function isItemSelectable() {
    return true;
  },
  renderMenu: function renderMenu(items, value, style) {
    return React.createElement('div', { style: _extends({}, style, this.menuStyle), children: items });
  },

  menuStyle: {
    borderRadius: '3px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
    background: 'rgba(255, 255, 255, 0.9)',
    padding: '2px 0',
    fontSize: '90%',
    position: 'fixed',
    overflow: 'auto',
    maxHeight: '50%' },
  autoHighlight: true,
  selectOnBlur: false,
  onMenuVisibilityChange: function onMenuVisibilityChange() {}
};
Autocomplete.keyDownHandlers = {
  ArrowDown: function ArrowDown(event) {
    event.preventDefault();
    var items = this.getFilteredItems(this.props);
    if (!items.length) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === null ? -1 : highlightedIndex;
    for (var i = 0; i < items.length; i++) {
      var p = (index + i + 1) % items.length;
      if (this.props.isItemSelectable(items[p])) {
        index = p;
        break;
      }
    }
    if (index > -1 && index !== highlightedIndex) {
      this.setState({
        highlightedIndex: index,
        isOpen: true
      });
    }
  },
  ArrowUp: function ArrowUp(event) {
    event.preventDefault();
    var items = this.getFilteredItems(this.props);
    if (!items.length) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === null ? items.length : highlightedIndex;
    for (var i = 0; i < items.length; i++) {
      var p = (index - (1 + i) + items.length) % items.length;
      if (this.props.isItemSelectable(items[p])) {
        index = p;
        break;
      }
    }
    if (index !== items.length) {
      this.setState({
        highlightedIndex: index,
        isOpen: true
      });
    }
  },
  Enter: function Enter(event) {
    var _this7 = this;

    // Key code 229 is used for selecting items from character selectors (Pinyin, Kana, etc)
    if (event.keyCode !== 13) return;
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
    if (!this.isOpen()) {
      // menu is closed so there is no selection to accept -> do nothing
      return;
    } else if (this.state.highlightedIndex == null) {
      // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
      this.setState({
        isOpen: false
      }, function () {
        _this7.refs.input.select();
      });
    } else {
      // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
      event.preventDefault();
      var item = this.getFilteredItems(this.props)[this.state.highlightedIndex];
      var value = this.props.getItemValue(item);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, function () {
        //this.refs.input.focus() // TODO: file issue
        _this7.refs.input.setSelectionRange(value.length, value.length);
        _this7.props.onSelect(value, item);
      });
    }
  },
  Escape: function Escape() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
    this.setState({
      highlightedIndex: null,
      isOpen: false
    });
  },
  Tab: function Tab() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
  }
};


module.exports = Autocomplete;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2167);


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(2168);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset, ch, cw, containerScroll,
    diffTop, diffBottom, win,
    winScroll, ww, wh;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left,
      top: elemOffset.top - winScroll.top
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww),
      top: elemOffset.top + eh - (winScroll.top + wh)
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left +
      (parseFloat(util.css(container, 'borderLeftWidth')) || 0)),
      top: elemOffset.top - (containerOffset.top +
      (parseFloat(util.css(container, 'borderTopWidth')) || 0))
    };
    diffBottom = {
      left: elemOffset.left + ew -
      (containerOffset.left + cw +
      (parseFloat(util.css(container, 'borderRightWidth')) || 0)),
      top: elemOffset.top + eh -
      (containerOffset.top + ch +
      (parseFloat(util.css(container, 'borderBottomWidth')) || 0))
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;


/***/ }),
/* 2168 */
/***/ (function(module, exports) {

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box, x, y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {left: x, top: y};
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    //ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      //quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle) {
  var val = '';
  var d = elem.ownerDocument;

  // https://github.com/kissyteam/kissy/issues/61
  if ((computedStyle = (computedStyle || d.defaultView.getComputedStyle(elem, null)))) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/,
  CURRENT_STYLE = 'currentStyle',
  RUNTIME_STYLE = 'runtimeStyle',
  LEFT = 'left',
  PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style,
      left = style[LEFT],
      rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : (ret || 0);
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem),
    ret = {},
    current, key;

  for (key in offset) {
    current = parseFloat(css(elem, key)) || 0;
    ret[key] = current + offset[key] - old[key];
  }
  css(elem, ret);
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'],
  CONTENT_INDEX = -1,
  PADDING_INDEX = 2,
  BORDER_INDEX = 1,
  MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {},
    style = elem.style,
    name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    old[name] = style[name];
    style[name] = options[name];
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    style[name] = old[name];
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0, prop, j, i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /*jshint eqeqeq:false*/
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
      //firefox chrome documentElement.scrollHeight< body.scrollHeight
      //ie standard mode : documentElement.scrollHeight> body.scrollHeight
      d.documentElement['scroll' + name],
      //quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      d.body['scroll' + name],
      domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name,
      doc = win.document,
      body = doc.body,
      documentElement = doc.documentElement,
      documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp ||
      body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'],
    borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || (Number(cssBoxValue)) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'],
          which, computedStyle);
    } else {
      return cssBoxValue;
    }
  } else if (borderBoxValueOrIsBorderBox) {
    return val + (extra === BORDER_INDEX ? 0 :
        (extra === PADDING_INDEX ?
          -getPBMWidth(elem, ['border'], which, computedStyle) :
          getPBMWidth(elem, ['margin'], which, computedStyle)));
  } else {
    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra),
        which, computedStyle);
  }
}

var cssShow = {position: 'absolute', visibility: 'hidden', display: 'block'};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val, args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function css(el, name, value) {
  if (typeof name === 'object') {
    for (var i in name) {
      css(el, i, name[i]);
    }
    return;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
  } else {
    return getComputedStyleX(el, name);
  }
}

function mix(to, from) {
  for (var i in from) {
    to[i] = from[i];
  }
  return to;
}

var utils = module.exports = {
  getWindow: function (node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function (el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function (obj) {
    var ret = {};
    for (var i in obj) {
      ret[i] = obj[i];
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        ret.overflow[i] = obj.overflow[i];
      }
    }
    return ret;
  },
  mix: mix,
  scrollLeft: function (w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      } else {
        window.scrollTo(v, getScrollTop(w));
      }
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      } else {
        w.scrollLeft = v;
      }
    }
  },
  scrollTop: function (w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      } else {
        window.scrollTo(getScrollLeft(w), v);
      }
    } else {
      if (v === undefined) {
        return w.scrollTop;
      } else {
        w.scrollTop = v;
      }
    }
  },
  merge: function () {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);


/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(80)))

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2171), __esModule: true };

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2172);
var $Object = __webpack_require__(73).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(185);
var $getOwnPropertyDescriptor = __webpack_require__(455).f;

__webpack_require__(443)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var babelPluginFlowReactPropTypes_proptype_VisibleCellRange = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_VisibleCellRange || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(5).any;

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Used in deferred mode to track which cells have been queued for measurement.

  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeAndPositionData = {};
    this._lastMeasuredIndex = -1;
    this._lastBatchedIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (_currentOffset === offset) {
          return middle;
        } else if (_currentOffset < offset) {
          low = middle + 1;
        } else if (_currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);

/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome && !!window.chrome.webstore;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;


function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(550);
var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(5).any;



/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2180);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(2181));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
var babelPluginFlowReactPropTypes_proptype_OverscanIndices = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_OverscanIndices || __webpack_require__(5).any;

var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams || __webpack_require__(5).any;

var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false,
            info: {},
            error: {}
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            this.setState({
                hasError: true,
                info: info,
                error: error
            });
        }
    }, {
        key: "render",
        value: function render() {
            var hasError = this.state.hasError;


            if (hasError) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "react-error" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h1",
                        null,
                        "Something went wrong"
                    )
                );
            }

            return this.props.children;
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ErrorBoundary;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/ErrorBoundary.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/ErrorBoundary.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




/**
 * @param {{ 
 *  type?: string, 
 *  isLoading: boolean, 
 *  onFetch: Function,
 *  onToggleShowUsefulLines: Function,
 * }} props 
 * @returns 
 */
function PredictorType(_ref) {
    var isLoading = _ref.isLoading,
        onFetch = _ref.onFetch,
        type = _ref.type,
        onToggleShowUsefulLines = _ref.onToggleShowUsefulLines;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: {
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0px 7px',
                borderRadius: '8px',
                gap: '10px',
                backgroundColor: '#f5f5f5',
                border: '1px solid #e0e0e0'
            }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
            className: 'btn',
            labelStyle: { fontSize: '10px', color: 'white' },
            style: { height: '25px', margin: '10px 0' },
            buttonStyle: { height: '25px', lineHeight: '25px', backgroundColor: '#B26E63' },
            label: 'Predictor type',
            onClick: onFetch,
            disabled: isLoading
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { fontWeight: 'bold' } },
            type
        ),
        type && type !== 'Error' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["b" /* Checkbox */], {
            label: 'Show useful lines',
            onCheck: onToggleShowUsefulLines,
            style: { width: 'auto', display: 'inline-block', fontSize: '13px' },
            labelStyle: { width: '120px' },
            iconStyle: { marginRight: '5px' }
        }) : null
    );
}

var _default = PredictorType;
/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * @typedef {Object} MailData
 * @property {string} _id
 * @property {string} text
 * @property {string} owner
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PredictorType, 'PredictorType', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/PredictorType.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/PredictorType.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = SaveLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Analytics_AddUpdateModal__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function SaveLink() {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openDialog = _useState2[0],
        setOpenDialog = _useState2[1];

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'span',
        { style: { display: 'inline-block', marginLeft: '10px' } },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components_Analytics_AddUpdateModal__["a" /* default */], {
            open: openDialog,
            setOpen: setOpenDialog,
            type: 'add',
            fromLetter: true
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
            className: 'btn',
            labelStyle: { fontSize: '10px', color: 'white' },
            style: { height: '25px', margin: '10px 10px 10px 0' },
            buttonStyle: { height: '25px', lineHeight: '25px', backgroundColor: '#B26E63' },
            label: 'Dashboard',
            onClick: function onClick() {
                return setOpenDialog(!openDialog);
            }
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SaveLink, 'SaveLink', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/SaveLink.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1)

module.exports = function (props) { return (
  React.createElement( 'button', { type: 'button', className: props.classNames.selectedTag, title: 'Click to remove tag', onClick: props.onDelete },
    React.createElement( 'span', { className: props.classNames.selectedTagName }, props.tag.name)
  )
); }


/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1)

var SIZER_STYLES = {
  position: 'absolute',
  width: 0,
  height: 0,
  visibility: 'hidden',
  overflow: 'scroll',
  whiteSpace: 'pre'
}

var STYLE_PROPS = [
  'fontSize',
  'fontFamily',
  'fontWeight',
  'fontStyle',
  'letterSpacing'
]

var Input = (function (superclass) {
  function Input (props) {
    superclass.call(this, props)
    this.state = { inputWidth: null }
  }

  if ( superclass ) Input.__proto__ = superclass;
  Input.prototype = Object.create( superclass && superclass.prototype );
  Input.prototype.constructor = Input;

  Input.prototype.componentDidMount = function componentDidMount () {
    if (this.props.autoresize) {
      this.copyInputStyles()
      this.updateInputWidth()
    }

    if (this.props.autofocus) {
      this.input.focus()
    }
  };

  Input.prototype.componentDidUpdate = function componentDidUpdate (prevProps) {
    this.updateInputWidth()
  };

  Input.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
    if (this.input.value !== newProps.query) {
      this.input.value = newProps.query
    }
  };

  Input.prototype.copyInputStyles = function copyInputStyles () {
    var this$1 = this;

    var inputStyle = window.getComputedStyle(this.input)

    STYLE_PROPS.forEach(function (prop) {
      this$1.sizer.style[prop] = inputStyle[prop]
    })
  };

  Input.prototype.updateInputWidth = function updateInputWidth () {
    var inputWidth

    if (this.props.autoresize) {
      // scrollWidth is designed to be fast not accurate.
      // +2 is completely arbitrary but does the job.
      inputWidth = Math.ceil(this.sizer.scrollWidth) + 2
    }

    if (inputWidth !== this.state.inputWidth) {
      this.setState({ inputWidth: inputWidth })
    }
  };

  Input.prototype.render = function render () {
    var this$1 = this;

    var sizerText = this.props.query || this.props.placeholder

    var ref = this.props;
    var expandable = ref.expandable;
    var placeholder = ref.placeholder;
    var listboxId = ref.listboxId;
    var selectedIndex = ref.selectedIndex;

    var selectedId = listboxId + "-" + selectedIndex

    return (
      React.createElement( 'div', { className: this.props.classNames.searchInput },
        React.createElement( 'input', {
          ref: function (c) { this$1.input = c }, role: 'combobox', 'aria-autocomplete': 'list', 'aria-label': placeholder, 'aria-owns': listboxId, 'aria-activedescendant': selectedIndex > -1 ? selectedId : null, 'aria-expanded': expandable, placeholder: placeholder, style: { width: this.state.inputWidth } }),
        React.createElement( 'div', { ref: function (c) { this$1.sizer = c }, style: SIZER_STYLES }, sizerText)
      )
    )
  };

  return Input;
}(React.Component));

module.exports = Input


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1)

function escapeForRegExp (query) {
  return query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
}

function markIt (input, query) {
  var regex = RegExp(escapeForRegExp(query), 'gi')

  return {
    __html: input.replace(regex, '<mark>$&</mark>')
  }
}

function filterSuggestions (query, suggestions, length) {
  var regex = new RegExp(("(?:^|\\s)" + (escapeForRegExp(query))), 'i')
  return suggestions.filter(function (item) { return regex.test(item.name); }).slice(0, length)
}

var Suggestions = (function (superclass) {
  function Suggestions (props) {
    superclass.call(this, props)

    this.state = {
      options: filterSuggestions(this.props.query, this.props.suggestions, this.props.maxSuggestionsLength)
    }
  }

  if ( superclass ) Suggestions.__proto__ = superclass;
  Suggestions.prototype = Object.create( superclass && superclass.prototype );
  Suggestions.prototype.constructor = Suggestions;

  Suggestions.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
    this.setState({
      options: filterSuggestions(newProps.query, newProps.suggestions, newProps.maxSuggestionsLength)
    })
  };

  Suggestions.prototype.handleMouseDown = function handleMouseDown (item, e) {
    // focus is shifted on mouse down but calling preventDefault prevents this
    e.preventDefault()
    this.props.addTag(item)
  };

  Suggestions.prototype.render = function render () {
    var this$1 = this;

    if (!this.props.expandable || !this.state.options.length) {
      return null
    }

    var options = this.state.options.map(function (item, i) {
      var key = (this$1.props.listboxId) + "-" + i
      var classNames = []

      if (this$1.props.selectedIndex === i) {
        classNames.push(this$1.props.classNames.suggestionActive)
      }

      if (item.disabled) {
        classNames.push(this$1.props.classNames.suggestionDisabled)
      }

      return (
        React.createElement( 'li', {
          id: key, key: key, role: 'option', className: classNames.join(' '), 'aria-disabled': item.disabled === true, onMouseDown: this$1.handleMouseDown.bind(this$1, item) },
          React.createElement( 'span', { dangerouslySetInnerHTML: markIt(item.name, this$1.props.query) })
        )
      )
    })

    return (
      React.createElement( 'div', { className: this.props.classNames.suggestions },
        React.createElement( 'ul', { role: 'listbox', id: this.props.listboxId }, options)
      )
    )
  };

  return Suggestions;
}(React.Component));

module.exports = Suggestions


/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withGazettersSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HOC_common__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_gazetters__ = __webpack_require__(258);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();




/**
 * @param {Function} mutateAsync - function to trigger the mutation
 * @param {object} mutationResult - full result object from useMutation, containing isLoading, etc
 * @returns {object} props to be passed to the wrapped component
 */
var mapMutationToProps = function mapMutationToProps(mutateAsync, _ref) {
  var isLoading = _ref.isLoading;
  return {
    saveMutation: mutateAsync,
    isSaving: isLoading
  };
};

/**
 * a hoc that provides gazetteer save functionality to a component
 */
var withGazettersSave = Object(__WEBPACK_IMPORTED_MODULE_0__HOC_common__["a" /* withMutation */])({
  mutationFn: __WEBPACK_IMPORTED_MODULE_1_services_gazetters__["i" /* saveGazettersNew */],
  mapMutationToProps: mapMutationToProps
});
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapMutationToProps, 'mapMutationToProps', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/HOC.jsx');
  reactHotLoader.register(withGazettersSave, 'withGazettersSave', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Single/Gazetter/HOC.jsx');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Table__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var PortsAltNames = function (_React$Component) {
    _inherits(PortsAltNames, _React$Component);

    function PortsAltNames(props) {
        _classCallCheck(this, PortsAltNames);

        return _possibleConstructorReturn(this, (PortsAltNames.__proto__ || Object.getPrototypeOf(PortsAltNames)).call(this, props));
    }

    _createClass(PortsAltNames, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getAllPorts();
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'alt-ports', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden ' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'ports alternative names'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Table__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PortsAltNames;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        isLoaded: state.ports.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getAllPorts: __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__["d" /* getAllPorts */]
    }, dispatch);
})(PortsAltNames);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsAltNames, 'PortsAltNames', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortsAltNames/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortsAltNames/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Row__ = __webpack_require__(910);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PortsAltNamesTable = function (_React$Component) {
    _inherits(PortsAltNamesTable, _React$Component);

    function PortsAltNamesTable(props) {
        _classCallCheck(this, PortsAltNamesTable);

        var _this = _possibleConstructorReturn(this, (PortsAltNamesTable.__proto__ || Object.getPrototypeOf(PortsAltNamesTable)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            ports: []
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }

    _createClass(PortsAltNamesTable, [{
        key: 'filterSearch',
        value: function filterSearch(searchArray, searchText) {
            if (searchText === '') {
                return searchArray;
            }

            return searchArray.filter(function (item) {
                if (item.prevState.name) {
                    if (item.prevState.name.toLowerCase().includes(searchText)) {
                        return true;
                    }
                }

                for (var i = 0; i < item.prevState.alt.length; i++) {
                    if (item.prevState.alt[i].toLowerCase().includes(searchText)) {
                        return true;
                    }
                }

                return false;
            });
        }
    }, {
        key: 'makeFilter',
        value: function makeFilter(props) {
            var _this2 = this;

            var page = this.state.page;

            if (props.searchText !== this.props.searchText) {
                page = 1;
            }

            var ports = this.filterSearch(props.ports, props.searchText);

            this.setState({
                searchText: props.searchText,
                ports: ports,
                page: page,
                total: props.ports.length
            }, function () {
                _this2.handleUpdateRow(_this2.state);
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            if (props.ports.length) {
                this.makeFilter(props);
            }
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.ports.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            this.props.searchPort(e.target.value.toLowerCase());
        }
    }, {
        key: 'render',
        value: function render() {
            var searchText = this.props.searchText;
            var rows = this.state.rows;

            var renderSuggestions = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'port-suggestions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'title' },
                    'This name has been already used:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content' },
                    this.props.suggestionsPorts.map(function (port) {
                        return port.alt ? ' ' + port.name + ' - (' + port.alt.join(', ') + '), ' : port.name + ', ';
                    })
                )
            );

            var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                total: this.state.ports.length,
                rowsPerPage: this.state.rowsPerPage,
                page: this.state.page,
                numberOfRows: this.state.numberOfRows,
                updateRows: this.handleUpdateRow
            });

            var renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnCSS },
                            'name port'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnCSS },
                            'alt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false },
                    rows.map(function (row) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Row__["a" /* default */], { key: row._id, item: row });
                    })
                )
            );

            if (!this.props.suggestionsPorts.length) {
                renderSuggestions = null;
            }

            if (!rows.length) {
                renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'nothing-found' },
                    'Not found'
                );
                renderPagination = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            defaultValue: searchText,
                            floatingLabelText: 'Search',
                            onChange: this.handleSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        renderPagination
                    )
                ),
                renderSuggestions,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    renderTable
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PortsAltNamesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        searchText: state.ports.searchText,
        ports: state.ports.items,
        suggestionsPorts: state.ports.suggestions
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        searchPort: __WEBPACK_IMPORTED_MODULE_6_actions_regions_ports__["h" /* searchPort */]
    }, dispatch);
})(PortsAltNamesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsAltNamesTable, 'PortsAltNamesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortsAltNames/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortsAltNames/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Table__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__ = __webpack_require__(53);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










var PortsPage = function PortsPage(_ref) {
    var page = _ref.page,
        query = _ref.query,
        onlyChanged = _ref.onlyChanged,
        sort = _ref.sort,
        getPorts = _ref.getPorts,
        hasRecommended = _ref.hasRecommended;

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getPorts({
            page: page, query: query, onlyChanged: onlyChanged, sort: sort, hasRecommended: hasRecommended
        });
    }, [page, query, onlyChanged, sort, getPorts]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'ports', className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Ports'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Table__["a" /* default */], null)
        )
    );
};

PortsPage.propTypes = {
    isLogged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    getPorts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    page: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onlyChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

PortsPage.defaultProps = {
    isLogged: false,
    getPorts: function getPorts() {
        console.error('PortsPage didn\'t find getPorts function');
    },
    page: 1,
    query: '',
    onlyChanged: false,
    sort: ''
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref2) {
    var isLogged = _ref2.user.isLogged,
        _ref2$ports = _ref2.ports,
        page = _ref2$ports.page,
        query = _ref2$ports.query,
        onlyChanged = _ref2$ports.onlyChanged,
        sort = _ref2$ports.sort,
        hasRecommended = _ref2$ports.hasRecommended;
    return {
        isLogged: isLogged,
        page: page,
        query: query,
        onlyChanged: onlyChanged,
        hasRecommended: hasRecommended,
        sort: sort
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getPorts: __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__["f" /* getPorts */]
    }, dispatch);
})(PortsPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsPage, 'PortsPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Ports/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Ports/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Row__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles__ = __webpack_require__(20);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();


















var PortsListTable = function PortsListTable(props) {
    var ports = props.ports,
        getPorts = props.getPorts;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState2 = _slicedToArray(_useState, 2),
        page = _useState2[0],
        setPage = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        portsList = _useState4[0],
        setPortsList = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('name'),
        _useState6 = _slicedToArray(_useState5, 2),
        sort = _useState6[0],
        setSort = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(ports.query),
        _useState8 = _slicedToArray(_useState7, 2),
        query = _useState8[0],
        setQuery = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(ports.onlyChanged || false),
        _useState10 = _slicedToArray(_useState9, 2),
        onlyChanged = _useState10[0],
        setOnlyChanged = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(ports.hasRecommended || false),
        _useState12 = _slicedToArray(_useState11, 2),
        hasRecommended = _useState12[0],
        setHasRecommended = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState14 = _slicedToArray(_useState13, 2),
        expiredRecommended = _useState14[0],
        setExpiredRecommended = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState16 = _slicedToArray(_useState15, 2),
        loading = _useState16[0],
        setLoading = _useState16[1];

    var isLoadingRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

    var changePortList = function changePortList(_ref) {
        var _ref$direction = _ref.direction,
            direction = _ref$direction === undefined ? undefined : _ref$direction;

        if (isLoadingRef.current) return;
        var newPage = 1;

        if (typeof direction !== 'undefined' && ports.previous && direction < 0) {
            newPage = ports.previous;
        } else if (typeof direction !== 'undefined' && ports.next && direction > 0) {
            newPage = ports.next;
        }

        isLoadingRef.current = true;
        setLoading(true);

        getPorts({
            page: newPage,
            query: query,
            onlyChanged: onlyChanged,
            sort: sort,
            hasRecommended: hasRecommended
        });
    };

    /**
     * 
     * @param {{
        *  onlyChanged?: boolean,
        *  hasRecommended?: boolean,
        *  expiredRecommended?: boolean,
        * }} opts
        */
    var resetAndLoadPorts = function resetAndLoadPorts(opts) {
        setPage(1);
        getPorts({
            page: 1,
            query: query,
            onlyChanged: opts.onlyChanged,
            hasRecommended: opts.hasRecommended,
            expiredRecommended: opts.expiredRecommended
        });
    };

    var isOnlyChanged = function isOnlyChanged() {
        var newOnlyChanged = onlyChanged ? undefined : true;
        setOnlyChanged(newOnlyChanged);
        resetAndLoadPorts({ onlyChanged: newOnlyChanged, hasRecommended: hasRecommended, expiredRecommended: expiredRecommended });
    };

    var isWithRecommendedProviders = function isWithRecommendedProviders() {
        var newHasRecommended = hasRecommended ? undefined : true;
        setHasRecommended(newHasRecommended);
        resetAndLoadPorts({ hasRecommended: newHasRecommended, onlyChanged: onlyChanged, expiredRecommended: expiredRecommended });
    };

    var isWithExpiredRecommendedProviders = function isWithExpiredRecommendedProviders() {
        var newExpiredRecommended = expiredRecommended ? undefined : true;
        setExpiredRecommended(newExpiredRecommended);
        resetAndLoadPorts({ expiredRecommended: newExpiredRecommended, onlyChanged: onlyChanged, hasRecommended: hasRecommended });
    };

    var nextPage = function nextPage() {
        changePortList({ direction: 1 });
    };

    var prevPage = function prevPage() {
        changePortList({ direction: -1 });
    };

    var handleChangeSearch = function handleChangeSearch(e, value) {
        setQuery(value);
    };

    var handleSearch = function handleSearch() {
        changePortList({});
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (ports.isLoaded) {
            setPortsList(ports.data);
            setPage(ports.page);
            setLoading(false);
            isLoadingRef.current = false;
        }
    }, [ports.isLoaded]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (ports.query !== query) {
            setQuery(ports.query);
        }

        setOnlyChanged(ports.onlyChanged);
        setHasRecommended(ports.hasRecommended);
    }, [ports.query, ports.onlyChanged, ports.hasRecommended]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4 center-xs middle-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["A" /* TextField */], {
                        defaultValue: query,
                        floatingLabelText: 'Search by name',
                        onChange: handleChangeSearch,
                        disabled: loading,
                        onKeyPress: function onKeyPress(event) {
                            if (event.charCode === 13) {
                                event.preventDefault();
                                handleSearch();
                            }
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["r" /* RaisedButton */], {
                        label: 'Search',
                        style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].RaisedButton,
                        primary: true,
                        disabled: loading,
                        onClick: handleSearch
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'col-xs-4 start-xs middle-xs',
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '2px',
                            fontSize: '13px'
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["b" /* Checkbox */], {
                        label: 'Only changed ports',
                        checked: onlyChanged,
                        disabled: loading,
                        onCheck: isOnlyChanged
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["b" /* Checkbox */], {
                        label: 'With recommended providers',
                        checked: hasRecommended,
                        disabled: loading,
                        onCheck: isWithRecommendedProviders
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4 center-xs middle-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["r" /* RaisedButton */], {
                        label: 'Create new port',
                        style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].RaisedButton,
                        primary: true,
                        disabled: loading,
                        containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */], { to: '/regions/ports/add' })
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12 center-xs middle-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].navigationLeft,
                            name: 'navigationLeft',
                            onClick: prevPage,
                            disabled: loading
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        'Page: ',
                        page
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].navigationRight,
                            name: 'navigationRight',
                            onClick: nextPage,
                            disabled: loading
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_material_ui__["u" /* Table */],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["w" /* TableHeader */],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["y" /* TableRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'UN/LOCODE'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Country'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Parent Name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Status'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Actions'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["v" /* TableBody */],
                    { displayRowCheckbox: false },
                    ports.data.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Row__["a" /* default */], {
                            key: item._id,
                            item: item
                        });
                    })
                )
            )
        )
    );
};

PortsListTable.propTypes = {
    ports: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    getPorts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PortsListTable.defaultProps = {
    ports: {},
    getPorts: function getPorts() {
        console.error('PortsListTable didn\'t find getPorts function');
    }
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (_ref2) {
    var ports = _ref2.ports;
    return {
        ports: ports
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        getPorts: __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__["f" /* getPorts */]
    }, dispatch);
})(PortsListTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsListTable, 'PortsListTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Ports/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Ports/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortManagement_common_Labels__ = __webpack_require__(911);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












var resetScroll = function resetScroll() {
    var containers = document.querySelectorAll('div[style*="overflow-y: auto"]');
    containers.forEach(function (container) {
        container.scrollTop = 0;
    });
};

var PortsRow = function PortsRow(_ref) {
    var item = _ref.item;

    var handleEditClick = function handleEditClick() {
        resetScroll();
    };

    var handleApproveClick = function handleApproveClick() {
        resetScroll();
    };

    var labels = Object(__WEBPACK_IMPORTED_MODULE_6__PortManagement_common_Labels__["b" /* getPortLabelTypes */])(item);

    var changes = item.changes,
        _id = item._id,
        name = item.name,
        unLoCode = item.unLoCode,
        parent = item.parent,
        country = item.country;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRow"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
            name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
            unLoCode
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
            country && country.name ? country.name : ''
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
            parent && parent.name ? parent.name : ''
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
            Object(__WEBPACK_IMPORTED_MODULE_6__PortManagement_common_Labels__["a" /* default */])(labels)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
            changes && changes > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Approve changes',
                primary: true,
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */], { to: '/regions/ports/approve/' + _id }),
                onClick: handleApproveClick
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Edit',
                primary: true,
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */], { to: '/regions/ports/' + _id }),
                onClick: handleEditClick
            })
        )
    );
};

PortsRow.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

PortsRow.defaultProps = {
    item: {}
};

var _default = PortsRow;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(resetScroll, 'resetScroll', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Ports/Row.jsx');
    reactHotLoader.register(PortsRow, 'PortsRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Ports/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Ports/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_done__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_done__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sagas_regions_ports__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Sidebar__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ServiceProviders_Component__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PortRestrictions__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LiftAndCranes_List__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Facilities__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Warehouses__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Other__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Regions_PortAdd_MapComponent__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_constants__ = __webpack_require__(203);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this3 = this;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




































var styles = {
    btnBack: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' }
    },
    btnSubmit: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' }
    }
};

var PortSinglePage = function (_React$Component) {
    _inherits(PortSinglePage, _React$Component);

    function PortSinglePage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PortSinglePage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PortSinglePage.__proto__ || Object.getPrototypeOf(PortSinglePage)).call.apply(_ref, [this].concat(args))), _this), _this.shouldDiaplayCoordsError = function (coord) {
            var leftLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -180;
            var rightLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 180;

            var result = false;
            var value = parseFloat(coord);

            if (isNaN(value)) {
                result = true;
                return result;
            }

            if (value < leftLimit || value > rightLimit) {
                result = true;
            }

            return result;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PortSinglePage, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearPort();
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _props = this.props,
                id = _props.routeParams.id,
                getPort = _props.getPort,
                getCountries = _props.getCountries;

            getPort({ id: id, history: true, all: true });
            getCountries();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.port.firstLoad && nextProps.port.history && nextProps.port.history.length > 0) {
                nextProps.clearPort();
                nextProps.router.push('/regions/ports/approve/' + nextProps.routeParams.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container', id: 'single-port' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'management' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'btn' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default.a, {
                            label: 'Back to list',
                            style: styles.btnBack.style,
                            labelStyle: styles.btnBack.labelStyle,
                            labelPosition: 'before',
                            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left___default.a, null),
                            containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* Link */], { to: '/regions/ports' }),
                            primary: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'btn' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default.a, {
                            label: 'Send modification',
                            style: styles.btnSubmit.style,
                            labelStyle: styles.btnSubmit.labelStyle,
                            labelPosition: 'before',
                            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_done___default.a, null),
                            backgroundColor: '#a4c639',
                            onClick: function onClick() {
                                return _this2.props.submit('port-update');
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Sidebar__["a" /* default */], null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-lg-9 col-xs-9 main' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'form',
                            { autoComplete: 'off', onSubmit: this.props.handleSubmit },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'add-coords-map' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'main__title' },
                                        'Coordinates'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Regions_PortAdd_MapComponent__["a" /* default */], {
                                        coordinates: this.props.port.coordinates,
                                        change: function change(key, value) {
                                            _this2.props.changePort({ coordinates: value });
                                        },
                                        googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_25_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
                                        loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                                        containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '100%', height: '300px' } }),
                                        mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } })
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_TextField___default.a, {
                                        floatingLabelText: 'Latitude',
                                        value: this.props.port.coordinates[1],
                                        onChange: function onChange(e, value) {
                                            var lat = value.replace(/[a-zA-Z,]/g, '');
                                            _this2.props.changePort({ coordinates: [_this2.props.port.coordinates[0], parseFloat(lat)] });
                                        },
                                        errorText: this.shouldDiaplayCoordsError(this.props.port.coordinates[0], -180, 180) ? 'wrong format' : '',
                                        fullWidth: true
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_TextField___default.a, {
                                        floatingLabelText: 'Longitude',
                                        value: this.props.port.coordinates[0],
                                        onChange: function onChange(e, value) {
                                            var lon = value.replace(/[a-zA-Z,]/g, '');
                                            _this2.props.changePort({ coordinates: [parseFloat(lon), _this2.props.port.coordinates[1]] });
                                        },
                                        errorText: this.shouldDiaplayCoordsError(this.props.port.coordinates[1], -90, 90) ? 'wrong format' : '',
                                        fullWidth: true
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ServiceProviders_Component__["a" /* default */], {
                                    parentProps: this.props
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PortRestrictions__["a" /* default */], null)
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__LiftAndCranes_List__["a" /* default */], {
                                    parentProps: this.props
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Facilities__["a" /* default */], null)
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Warehouses__["a" /* default */], null)
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Other__["a" /* default */], null)
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PortSinglePage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortSinglePage.propTypes = {};

PortSinglePage.defaultProps = {};

var handleSubmit = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, dispatch) {
        var data, response, errors;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(values);

                        data.serviceProviders.map(function (provider) {
                            if (!provider.activities.includes('Stevedoring Company')) {
                                provider.limitations = [];
                            }
                        });

                        Object.keys(data.portLimitations).forEach(function (key) {
                            if (!data.portLimitations[key]) {
                                delete data.portLimitations[key];
                            }
                        });

                        _context.next = 5;
                        return Object(__WEBPACK_IMPORTED_MODULE_11_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_12_sagas_regions_ports__["c" /* updatePort */], data);

                    case 5:
                        response = _context.sent;

                        if (!(response.status !== 200)) {
                            _context.next = 10;
                            break;
                        }

                        errors = {};


                        response.errors.forEach(function (error) {
                            errors = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(errors, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.set({}, error.field, error.messages[0]));
                        });

                        throw new __WEBPACK_IMPORTED_MODULE_3_redux_form__["c" /* SubmissionError */](errors);

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this3);
    }));

    return function handleSubmit(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

var MainPage = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_24_data_formNames__["a" /* formName */].portUpdate,
    enableReinitialize: true,
    onSubmit: handleSubmit
})(PortSinglePage);

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (_ref3) {
    var port = _ref3.port,
        isLogged = _ref3.user.isLogged;
    return {
        isLogged: isLogged,
        initialValues: _extends({}, port),
        port: port
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
        getPort: __WEBPACK_IMPORTED_MODULE_22_actions_regions_ports__["e" /* getPort */],
        submit: __WEBPACK_IMPORTED_MODULE_3_redux_form__["h" /* submit */],
        getCountries: __WEBPACK_IMPORTED_MODULE_23_actions_countries__["a" /* getCountries */],
        updatePort: __WEBPACK_IMPORTED_MODULE_22_actions_regions_ports__["i" /* updatePort */],
        clearPort: __WEBPACK_IMPORTED_MODULE_22_actions_regions_ports__["c" /* clearPort */],
        changePort: __WEBPACK_IMPORTED_MODULE_22_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(MainPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Page.jsx');
    reactHotLoader.register(PortSinglePage, 'PortSinglePage', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Page.jsx');
    reactHotLoader.register(handleSubmit, 'handleSubmit', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Page.jsx');
    reactHotLoader.register(MainPage, 'MainPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_data_gmt__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AltNames__ = __webpack_require__(915);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




























var styles = {
    dialog: {
        contentStyle: { width: '300px', padding: '18px' }
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    icon: { color: '#CBCBCB' }
};

var Sidebar = function Sidebar(props) {
    var port = props.port,
        countries = props.countries,
        handleSubmit = props.handleSubmit,
        change = props.change,
        changePort = props.changePort;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openDialog = _useState2[0],
        setOpenDialog = _useState2[1];

    var handleOpenDialog = function handleOpenDialog() {
        setOpenDialog(true);
    };

    var handleCloseDialog = function handleCloseDialog() {
        setOpenDialog(false);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_material_ui_Dialog___default.a,
            {
                modal: false,
                open: openDialog,
                contentStyle: styles.dialog.contentStyle,
                onRequestClose: handleCloseDialog
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                    component: __WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui__["TextField"],
                    name: 'name',
                    floatingLabelText: 'Name',
                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                    validate: [Object(__WEBPACK_IMPORTED_MODULE_11_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_11_redux_form_validators__["length"])({ min: 3 })],
                    fullWidth: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],
                    {
                        component: __WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui__["SelectField"],
                        name: 'country._id',
                        floatingLabelText: 'Country',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        autoWidth: true,
                        validate: Object(__WEBPACK_IMPORTED_MODULE_11_redux_form_validators__["required"])(),
                        onChange: function onChange(e, value) {
                            e.preventDefault();
                            change('country', countries.find(function (country) {
                                return country._id === value;
                            }));
                        },
                        fullWidth: true
                    },
                    countries.map(function (country, key) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, {
                            key: key,
                            value: country._id,
                            primaryText: country.name
                        });
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                    component: __WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui__["TextField"],
                    name: 'unLoCode',
                    floatingLabelText: 'UN LOCODE',
                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                    fullWidth: true,
                    validate: [Object(__WEBPACK_IMPORTED_MODULE_11_redux_form_validators__["length"])({ max: 5 })]
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],
                    {
                        component: __WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui__["SelectField"],
                        name: 'timezone',
                        floatingLabelText: 'timezone',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        fullWidth: true
                    },
                    __WEBPACK_IMPORTED_MODULE_14_data_gmt__["a" /* default */].map(function (gmt, key) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, { key: key, value: gmt, primaryText: gmt });
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                    component: __WEBPACK_IMPORTED_MODULE_12_redux_form_material_ui__["TextField"],
                    name: 'site',
                    floatingLabelText: 'Web site',
                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                    fullWidth: true,
                    validate: [Object(__WEBPACK_IMPORTED_MODULE_11_redux_form_validators__["length"])({ min: 8, allowBlank: true })]
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex' }, className: 'between-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, {
                        label: 'Cancel',
                        onClick: handleCloseDialog,
                        secondary: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_RaisedButton___default.a, {
                        label: 'Save',
                        style: { background: '#7FC931' },
                        primary: true,
                        onClick: handleSubmit(function (submit) {
                            handleCloseDialog();
                            changePort(submit);
                        })
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-lg-3 col-xs-3 sidebar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                component: function component(_ref) {
                    var input = _ref.input,
                        label = _ref.label,
                        type = _ref.type,
                        port = _ref.port,
                        _ref$meta = _ref.meta,
                        touched = _ref$meta.touched,
                        error = _ref$meta.error;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: error ? 'validate-error name' : 'name' },
                        port.name + ' ' + (error || '')
                    );
                },
                name: 'name',
                props: { port: port }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                component: function component(_ref2) {
                    var input = _ref2.input,
                        label = _ref2.label,
                        type = _ref2.type,
                        port = _ref2.port,
                        _ref2$meta = _ref2.meta,
                        touched = _ref2$meta.touched,
                        error = _ref2$meta.error;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: error ? 'validate-error name country' : 'name country' },
                        (port.country ? port.country.name : '') + ' ' + (error || '')
                    );
                },
                name: 'country.name',
                props: { port: port }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'divider' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                    component: function component(_ref3) {
                        var input = _ref3.input,
                            label = _ref3.label,
                            type = _ref3.type,
                            port = _ref3.port,
                            _ref3$meta = _ref3.meta,
                            touched = _ref3$meta.touched,
                            error = _ref3$meta.error;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: error ? 'validate-error info__title' : 'info__title' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                null,
                                'UN LOCODE: '
                            ),
                            ' ',
                            port.unLoCode + ' ' + (error || '')
                        );
                    },
                    name: 'unLoCode',
                    props: { port: port }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                    component: function component(_ref4) {
                        var input = _ref4.input,
                            label = _ref4.label,
                            type = _ref4.type,
                            port = _ref4.port,
                            _ref4$meta = _ref4.meta,
                            touched = _ref4$meta.touched,
                            error = _ref4$meta.error;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: error ? 'validate-error info__title' : 'info__title' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                null,
                                'Time Zone:'
                            ),
                            '  ',
                            port.timezone + ' ' + (error || '')
                        );
                    },
                    name: 'timezone',
                    props: { port: port }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                    component: function component(_ref5) {
                        var input = _ref5.input,
                            label = _ref5.label,
                            type = _ref5.type,
                            port = _ref5.port,
                            _ref5$meta = _ref5.meta,
                            touched = _ref5$meta.touched,
                            error = _ref5$meta.error;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { className: error ? 'validate-error info__website' : 'info__website' },
                            (port.site ? port.site : '') + ' ' + (error || '')
                        );
                    },
                    name: 'site',
                    props: { port: port }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'info__change' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                        {
                            iconStyle: styles.icon,
                            onClick: handleOpenDialog
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create___default.a, {
                            style: styles.icon
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__AltNames__["a" /* default */], {
                    port: port,
                    onEditAltNames: handleOpenDialog
                })
            )
        )
    );
};

Sidebar.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    countries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    changePort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Sidebar.defaultProps = {
    port: {},
    countries: []
};

var MyForm = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_15_data_formNames__["a" /* formName */].portUpdate,
    enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true
})(Sidebar);

var selector = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_15_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        countries: state.countries.items,
        initialValues: _extends({}, state.port),
        port: selector(state, 'name', 'timezone', 'country', 'unLoCode', 'site', 'alt')
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_13_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(MyForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Sidebar.jsx');
    reactHotLoader.register(Sidebar, 'Sidebar', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Sidebar.jsx');
    reactHotLoader.register(MyForm, 'MyForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Sidebar.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Sidebar.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Sidebar.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

var _file = __webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var absence = (0, _helpers.memoize)(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless;

  msg = msg || message;

  return (0, _helpers.prepare)(ifCond, unless, false, function (value) {
    if (typeof value === 'string' ? value.trim() : (0, _file.isFileList)(value) && !isNaN(value.length) ? value.length : value) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'absence'));
    }
  });
});

exports.default = absence;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineMessages = defineMessages;
// This simply returns what's passed-in because it's meant to be a hook for
// babel-plugin-react-intl.
function defineMessages(messageDescriptors) {
  return messageDescriptors;
}

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var acceptance = (0, _helpers.memoize)(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref.accept,
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless;

  msg = msg || message;

  return (0, _helpers.prepare)(ifCond, unless, false, function (value) {
    if ([].concat(accept || _validators2.default.defaultOptions.accept).map(String).indexOf(value) < 0) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'acceptance'));
    }
  });
});

exports.default = acceptance;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addValidator;

var _messages = __webpack_require__(912);

var _messages2 = _interopRequireDefault(_messages);

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addValidator(_ref) {
  var validator = _ref.validator,
      defaultMessage = _ref.defaultMessage,
      defaultMsg = _ref.defaultMsg;

  defaultMsg = (0, _helpers.toObjectMsg)(defaultMsg || defaultMessage) || _messages2.default.invalid;

  return (0, _helpers.memoize)(function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var msg = (0, _helpers.toObjectMsg)(options.msg || options.message) || defaultMsg;

    return (0, _helpers.prepare)(options.if, options.unless, options.allowBlank, function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var result = validator.apply(undefined, [options].concat(args));
      if (typeof result !== 'boolean') {
        return result ? _validators2.default.formatMessage(result) : null;
      }
      if (!result) {
        return _validators2.default.formatMessage(msg);
      }
    });
  });
}

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmation = (0, _helpers.memoize)(function (_ref) {
  var field = _ref.field,
      fieldLabel = _ref.fieldLabel,
      caseSensitive = _ref.caseSensitive,
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless;

  msg = msg || message;

  return (0, _helpers.prepare)(ifCond, unless, false, function (value, allValues) {
    // Immutable.js compatibility
    var fieldValue = typeof allValues.getIn === 'function' ? allValues.getIn(field.split('.')) : allValues[field];
    fieldValue = '' + (fieldValue || '');

    var cs = caseSensitive != null ? caseSensitive : _validators2.default.defaultOptions.caseSensitive;

    if (cs ? value !== fieldValue : value.toLowerCase() !== fieldValue.toLowerCase()) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'confirmation', { fieldLabel: fieldLabel || field }));
    }
  });
});

exports.default = confirmation;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DATE_METHODS = {
  y: function y(d) {
    return d.getFullYear();
  },
  m: function m(d) {
    return d.getMonth() + 1;
  },
  d: function d(_d) {
    return _d.getDate();
  }
};

var PARSE_REG = /(y+|m+|d+)/g;

var TO_STRING = {}.toString;

var date = (0, _helpers.memoize)(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      format = _ref.format,
      ymd = _ref.ymd,
      eq = _ref['='],
      diff = _ref['!='],
      gt = _ref['>'],
      gte = _ref['>='],
      lt = _ref['<'],
      lte = _ref['<='],
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless,
      allowBlank = _ref.allowBlank;

  msg = msg || message;

  return (0, _helpers.prepare)(ifCond, unless, allowBlank, function (value) {
    var normFormat = normalizeFormat(format, ymd);
    var date = normParseDate(value, normFormat, false);
    if (date === 'wrongFormat') {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateFormat', { format: format }));
    }
    if (date === 'invalid') {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateInvalid'));
    }
    if (date) {
      var date2 = void 0;
      if (eq && +date !== +(date2 = getDate(eq))) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateRange', values('=', date2, normFormat)));
      }
      if (diff && +date === +(date2 = getDate(diff))) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateRange', values('!=', date2, normFormat)));
      }
      if (gt && date <= (date2 = getDate(gt))) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateRange', values('>', date2, normFormat)));
      }
      if (gte && date < (date2 = getDate(gte))) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateRange', values('>=', date2, normFormat)));
      }
      if (lt && date >= (date2 = getDate(lt))) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateRange', values('<', date2, normFormat)));
      }
      if (lte && date > (date2 = getDate(lte))) {
        return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'dateRange', values('<=', date2, normFormat)));
      }
    }
  });
});

date.parseDate = parseDate;
date.formatDate = formatDate;

exports.default = date;


function parseDate(strDate, format, ymd) {
  return normParseDate(strDate, normalizeFormat(format, ymd), true);
}

function formatDate(date, format, ymd) {
  if (!(date instanceof Date) && TO_STRING.call(date) !== '[object Date]') {
    return null;
  }
  var t = new Date(date).getTime();
  // eslint-disable-next-line no-self-compare
  return t !== t ? null : normFormatDate(date, normalizeFormat(format, ymd));
}

function values(op, date, format) {
  return { op: op, date: normFormatDate(date, format), dateObject: date };
}

function getDate(d) {
  if (typeof d === 'function') {
    return new Date(+d());
  }
  if (isNaN(d) && ('' + d).toLowerCase() === 'today') {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }
  return new Date(+d);
}

// FORMAT
function normFormatDate(date, format) {
  return format.replace(PARSE_REG, function (m) {
    var sym = m.charAt(0);
    var len = m.length;
    var padded = padding(DATE_METHODS[sym](date), len);
    return sym === 'y' ? padded.slice(padded.length - len, padded.length) : padded;
  });
}
function normalizeFormat(format, ymd) {
  var _reverseMapping;

  if (format == null) {
    format = _validators2.default.defaultOptions.dateFormat;
  }
  if (!ymd) {
    ymd = _validators2.default.defaultOptions.dateYmd;
  }
  if (!ymd || ymd === 'ymd') {
    return format;
  }
  var reverseMapping = (_reverseMapping = {}, _defineProperty(_reverseMapping, ymd.charAt(0), 'y'), _defineProperty(_reverseMapping, ymd.charAt(1), 'm'), _defineProperty(_reverseMapping, ymd.charAt(2), 'd'), _reverseMapping);
  return format.replace(new RegExp('[' + ymd + ']', 'g'), function (sym) {
    return reverseMapping[sym];
  });
}
function padding(num, pad) {
  return '0'.repeat(Math.max(0, pad - ('' + num).length)) + num;
}

// PARSE
function normParseDate(value, format, parse) {
  var order = [];
  var reg = new RegExp('^' + format.replace(PARSE_REG, function (m) {
    order.push(m.charAt(0));
    return '([0-9]{' + m.length + '})';
  }) + '$');
  var match = value.match(reg);
  if (match) {
    var flags = {};
    order.forEach(function (token, index) {
      flags[token] = +match[index + 1];
    });
    var comparable = flags.y != null ? flags.m != null ? true : flags.d == null : false;
    flags = Object.assign({ y: 1970, m: 1, d: 1 }, flags);
    if (flags.y < 100) {
      flags.y = currentCentury(flags.y >= 69 ? -1 : 0) * 100 + flags.y;
    }
    var _date = new Date(flags.y, flags.m - 1, flags.d);
    return checkFlags(_date, flags) ? comparable || parse ? _date : null : parse ? new Date(NaN) : 'invalid';
  }
  return parse ? new Date(NaN) : 'wrongFormat';
}

function checkFlags(date, flags) {
  var _ref2 = [date.getFullYear(), date.getMonth() + 1, date.getDate()],
      year = _ref2[0],
      month = _ref2[1],
      day = _ref2[2];

  return year === flags.y && month === flags.m && day === flags.d;
}

function currentCentury(add) {
  var century = (0, _helpers.trunc)(new Date().getFullYear() / 100);
  return century < 0 ? century - add : century + add;
}

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = __webpack_require__(85);

// eslint-disable-next-line no-useless-escape
var REG_EMAIL = /^[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

// Uses "regFormat" internally which is already memoized
var email = (0, _helpers.regFormat)(function () {
  return REG_EMAIL;
}, 'email');

email.REG_EMAIL = REG_EMAIL;

exports.default = email;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = (0, _helpers.memoize)(function (_ref) {
  var wit = _ref.with,
      without = _ref.without,
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless,
      allowBlank = _ref.allowBlank;

  msg = msg || message;

  return (0, _helpers.prepare)(ifCond, unless, allowBlank, function (value) {
    if (wit && !value.match(wit) || without && value.match(without)) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'invalid'));
    }
  });
});

exports.default = format;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inclusion = __webpack_require__(913);

var _helpers = __webpack_require__(85);

var exclusion = (0, _helpers.memoize)(function (options) {
  return (0, _inclusion.inclusionExclusion)(false, options);
});

exports.default = exclusion;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var length = (0, _helpers.memoize)(function (_ref) {
  var equal = _ref['='],
      is = _ref.is,
      max = _ref.max,
      maximum = _ref.maximum,
      min = _ref.min,
      minimum = _ref.minimum,
      range = _ref.in,
      within = _ref.within,
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless,
      allowBlank = _ref.allowBlank;

  msg = msg || message;

  equal = (0, _helpers.selectNum)(equal, is);
  min = (0, _helpers.selectNum)(min, minimum);
  max = (0, _helpers.selectNum)(max, maximum);

  range = range || within;
  if (range && (0, _helpers.isNumber)(range[0]) && (0, _helpers.isNumber)(range[1])) {
    min = range[0];
    max = range[1];
  }

  return (0, _helpers.prepare)(ifCond, unless, allowBlank, function (value) {
    if (equal !== null && value.length !== equal) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'wrongLength', { count: equal }));
    }
    if (max !== null && value.length > max) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'tooLong', { count: max }));
    }
    if (min !== null && value.length < min) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'tooShort', { count: min }));
    }
  });
});

exports.default = length;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numericality = (0, _helpers.memoize)(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      int = _ref.int,
      integer = _ref.integer,
      even = _ref.even,
      odd = _ref.odd,
      equal = _ref['='],
      equalTo = _ref.equalTo,
      diff = _ref['!='],
      otherThan = _ref.otherThan,
      greater = _ref['>'],
      greaterThan = _ref.greaterThan,
      less = _ref['<'],
      lessThan = _ref.lessThan,
      greaterOrEqual = _ref['>='],
      greaterThanOrEqualTo = _ref.greaterThanOrEqualTo,
      lessOrEqual = _ref['<='],
      lessThanOrEqualTo = _ref.lessThanOrEqualTo,
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless,
      allowBlank = _ref.allowBlank;

  msg = msg || message;

  int = int || integer;
  equal = (0, _helpers.selectNum)(equal, equalTo);
  diff = (0, _helpers.selectNum)(diff, otherThan);
  greater = (0, _helpers.selectNum)(greater, greaterThan);
  greaterOrEqual = (0, _helpers.selectNum)(greaterOrEqual, greaterThanOrEqualTo);
  less = (0, _helpers.selectNum)(less, lessThan);
  lessOrEqual = (0, _helpers.selectNum)(lessOrEqual, lessThanOrEqualTo);

  return (0, _helpers.prepare)(ifCond, unless, allowBlank, function (value) {
    if (!(0, _helpers.isNumber)(value)) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'notANumber'));
    }
    if (int && +value % 1) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'notAnInteger'));
    }
    if (equal !== null && +value !== equal) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'equalTo', { count: equal }));
    }
    if (diff !== null && +value === diff) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'otherThan', { count: diff }));
    }
    if (greater !== null && +value <= greater) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'greaterThan', { count: greater }));
    }
    if (greaterOrEqual !== null && +value < greaterOrEqual) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'greaterThanOrEqualTo', { count: greaterOrEqual }));
    }
    if (less !== null && +value >= less) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'lessThan', { count: less }));
    }
    if (lessOrEqual !== null && +value > lessOrEqual) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'lessThanOrEqualTo', { count: lessOrEqual }));
    }
    if (even && (0, _helpers.trunc)(+value) % 2) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'even'));
    }
    if (odd && !((0, _helpers.trunc)(+value) % 2)) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'odd'));
    }
  });
});

exports.default = numericality;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _file = __webpack_require__(553);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var presence = (0, _helpers.memoize)(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref.if,
      unless = _ref.unless;

  msg = msg || message;

  return (0, _helpers.prepare)(ifCond, unless, false, function (value) {
    if (typeof value === 'string' ? !value.trim() : (0, _file.isFileList)(value) && !isNaN(value.length) ? !value.length : !value) {
      return _validators2.default.formatMessage((0, _helpers.prepareMsg)(msg, 'presence'));
    }
  });
});

exports.default = presence;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validators = __webpack_require__(84);

var _validators2 = _interopRequireDefault(_validators);

var _helpers = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REG_URL = /^(?:(?:(?:https?):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

// Uses "format" internally which is already memoized
var url = (0, _helpers.regFormat)(function (options) {
  var protocols = [].concat(options.protocols || options.protocol || _validators2.default.defaultOptions.urlProtocols).join('|');
  return protocols !== 'http|https' ? new RegExp(REG_URL.source.replace('https?', protocols), REG_URL.flags) : REG_URL;
}, 'url');

url.REG_URL = REG_URL;

exports.default = url;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Toggle = __webpack_require__(126);

var _Toggle2 = _interopRequireDefault(_Toggle);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_Toggle2.default, function (_ref) {
  var _ref$input = _ref.input,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      inputProps = _objectWithoutProperties(_ref$input, ['onChange', 'value']),
      defaultToggled = _ref.defaultToggled,
      meta = _ref.meta,
      props = _objectWithoutProperties(_ref, ['input', 'defaultToggled', 'meta']);

  return _extends({}, inputProps, props, {
    onToggle: onChange,
    toggled: !!value
  });
});

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Slider = __webpack_require__(511);

var _Slider2 = _interopRequireDefault(_Slider);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_Slider2.default, function (_ref) {
  var _ref$input = _ref.input,
      onDragStart = _ref$input.onDragStart,
      _onChange = _ref$input.onChange,
      name = _ref$input.name,
      value = _ref$input.value,
      onChangeFromField = _ref.onChange,
      defaultValue = _ref.defaultValue,
      meta = _ref.meta,
      props = _objectWithoutProperties(_ref, ['input', 'onChange', 'defaultValue', 'meta']);

  return _extends({}, props, {
    name: name,
    value: value,
    onChange: function onChange(event, value) {
      _onChange(value);
      if (onChangeFromField) {
        onChangeFromField(value);
      }
    }
  });
});

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Checkbox = __webpack_require__(57);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_Checkbox2.default, function (_ref) {
  var _ref$input = _ref.input,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      inputProps = _objectWithoutProperties(_ref$input, ['onChange', 'value']),
      meta = _ref.meta,
      _onCheck = _ref.onCheck,
      defaultChecked = _ref.defaultChecked,
      props = _objectWithoutProperties(_ref, ['input', 'meta', 'onCheck', 'defaultChecked']);

  return _extends({}, inputProps, props, {
    checked: value ? true : false,
    onCheck: function onCheck(event, isInputChecked) {
      onChange(isInputChecked);
      if (_onCheck) {
        _onCheck(isInputChecked);
      }
    }
  });
});

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextField = __webpack_require__(23);

var _TextField2 = _interopRequireDefault(_TextField);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(202);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_TextField2.default, function (_ref) {
  var defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ['defaultValue']);

  return (0, _mapError2.default)(props);
});

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TimePicker = __webpack_require__(786);

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(202);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_TimePicker2.default, function (_ref) {
  var _ref$input = _ref.input,
      onBlur = _ref$input.onBlur,
      inputProps = _objectWithoutProperties(_ref$input, ['onBlur']),
      defaultTime = _ref.defaultTime,
      _onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['input', 'defaultTime', 'onChange']);

  return _extends({}, inputProps, (0, _mapError2.default)(props), {
    onChange: function onChange(event, value) {
      inputProps.onChange(value);
      if (_onChange) {
        _onChange(value);
      }
    }
  });
});

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _DatePicker = __webpack_require__(115);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(202);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_DatePicker2.default, function (_ref) {
  var _ref$input = _ref.input,
      onBlur = _ref$input.onBlur,
      inputProps = _objectWithoutProperties(_ref$input, ['onBlur']),
      defaultDate = _ref.defaultDate,
      _onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['input', 'defaultDate', 'onChange']);

  return _extends({}, inputProps, (0, _mapError2.default)(props), {
    onChange: function onChange(event, value) {
      inputProps.onChange(value);
      if (_onChange) {
        _onChange(value);
      }
    }
  });
});

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _SelectField = __webpack_require__(31);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(202);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_SelectField2.default, function (_ref) {
  var _ref$input = _ref.input,
      _onChange = _ref$input.onChange,
      value = _ref$input.value,
      _onBlur = _ref$input.onBlur,
      inputProps = _objectWithoutProperties(_ref$input, ['onChange', 'value', 'onBlur']),
      onChangeFromField = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['input', 'onChange']);

  return _extends({}, (0, _mapError2.default)(props), inputProps, {
    value: value,
    onChange: function onChange(event, index, value) {
      _onChange(value);
      if (onChangeFromField) {
        onChangeFromField(value);
      }
    },
    onBlur: function onBlur() {
      return _onBlur(value);
    }
  });
});

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AutoComplete = __webpack_require__(29);

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(202);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_AutoComplete2.default, function (_ref) {
  var _ref$input = _ref.input,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      _onNewRequest = _ref.onNewRequest,
      dataSourceConfig = _ref.dataSourceConfig,
      dataSource = _ref.dataSource,
      props = _objectWithoutProperties(_ref, ['input', 'onNewRequest', 'dataSourceConfig', 'dataSource']);

  return _extends({}, (0, _mapError2.default)(props), {
    dataSourceConfig: dataSourceConfig,
    dataSource: dataSource,
    searchText: dataSourceConfig && dataSource ? (dataSource.find(function (item) {
      return item[dataSourceConfig.value] === value;
    }) || {})[dataSourceConfig.text] : value,
    onNewRequest: function onNewRequest(value, index) {
      onChange((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && dataSourceConfig ? value[dataSourceConfig.value] : value);
      if (_onNewRequest) {
        _onNewRequest(value, index);
      }
    },
    onUpdateInput: function onUpdateInput(value) {
      if (!dataSourceConfig) {
        onChange(value);
      }
    }
  });
});

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _RadioButton = __webpack_require__(269);

var _createComponent = __webpack_require__(130);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(202);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var mapValueToValueSelected = function mapValueToValueSelected(_ref, errorProp) {
  var inputProps = _objectWithoutProperties(_ref.input, []),
      props = _objectWithoutProperties(_ref, ['input']);

  return (0, _mapError2.default)(_extends({}, props, {
    input: _extends({}, inputProps, { valueSelected: inputProps.value })
  }), errorProp);
};

exports.default = (0, _createComponent2.default)(_RadioButton.RadioButtonGroup, mapValueToValueSelected);

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false,
            info: {},
            error: {}
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            this.setState({
                hasError: true,
                info: info,
                error: error
            });
        }
    }, {
        key: "render",
        value: function render() {
            var hasError = this.state.hasError;


            if (hasError) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "react-error" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h1",
                        null,
                        "Something went wrong"
                    )
                );
            }

            return this.props.children;
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ErrorBoundary;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ErrorBoundary, "ErrorBoundary", "/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ErrorBoundary.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ErrorBoundary.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ServiceProvider__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_history__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortManagement_blocks_ServiceProviders_ServiceProvidersView_ServiceProvidersHistoryDialog__ = __webpack_require__(919);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ServiceProviders = function (_React$Component) {
    _inherits(ServiceProviders, _React$Component);

    function ServiceProviders(props) {
        _classCallCheck(this, ServiceProviders);

        var _this = _possibleConstructorReturn(this, (ServiceProviders.__proto__ || Object.getPrototypeOf(ServiceProviders)).call(this, props));

        _this.toggleHistoryDialog = function () {
            _this.setState({
                openHistoryDialog: !_this.state.openHistoryDialog
            });
        };

        _this.state = {
            openHistoryDialog: false

        };
        return _this;
    }

    _createClass(ServiceProviders, [{
        key: 'render',
        value: function render() {
            var openHistoryDialog = this.state.openHistoryDialog;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { margin: '0' }, className: 'main__title row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-11' },
                        'Service providers'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-1' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                            { onClick: this.toggleHistoryDialog },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_action_history___default.a, { color: '#B3B3B3' })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'service-providers' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["b" /* FieldArray */], {
                        name: 'serviceProviders',
                        component: __WEBPACK_IMPORTED_MODULE_3__ServiceProvider__["a" /* default */]
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PortManagement_blocks_ServiceProviders_ServiceProvidersView_ServiceProvidersHistoryDialog__["a" /* default */], {
                    open: openHistoryDialog,
                    toggle: this.toggleHistoryDialog
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ServiceProviders;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ServiceProviders.propTypes = {};

ServiceProviders.defaultProps = {};

var _default = ServiceProviders;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ServiceProviders, 'ServiceProviders', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Component.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/Component.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StevedoringPopover__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AddServiceProvider__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditServiceProvider__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_info_outline__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_info_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_info_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helpers_ports__ = __webpack_require__(554);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




















var styles = {
    btn: {
        style: { margin: '20px 0 70px 0' },
        labelStyle: { textTransform: 'none', fontSize: '13px' }
    }
};

function ServiceProvider(props) {
    var fields = props.fields,
        serviceProviders = props.serviceProviders;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openEditDialog = _useState2[0],
        setOpenEditDialog = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        openAddDialog = _useState4[0],
        setOpenAddDialog = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ field: '' }),
        _useState6 = _slicedToArray(_useState5, 2),
        current = _useState6[0],
        setCurrent = _useState6[1];

    var checkHasRecommended = function checkHasRecommended() {
        if (Array.isArray(serviceProviders)) {
            return serviceProviders.find(function (s) {
                return s.recommended && s.recommended.endAt;
            });
        }

        return {};
    };

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(checkHasRecommended()),
        _useState8 = _slicedToArray(_useState7, 2),
        hasRecommended = _useState8[0],
        setHasRecommended = _useState8[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setHasRecommended(checkHasRecommended());
    }, [serviceProviders]);

    var addServiceProvider = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var emptyServiceProvider = {
            activities: [],
            name: undefined,
            address: undefined,
            PIC: undefined,
            emails: [undefined],
            phones: [{
                phone: undefined,
                code: undefined
            }],
            recommended: { endAt: null, at: null, addedBy: null },
            companyId: undefined,
            limitations: [{
                maxDraught: undefined,
                maxBeam: undefined,
                maxLOA: undefined,
                maxDWT: undefined,
                channelDepth: undefined,
                anchorageDepth: undefined
            }]
        };

        fields.push(emptyServiceProvider);
        setCurrent({ field: fields.name + '[' + fields.length + ']' });
        setOpenAddDialog(true);
    }, [fields]);

    var toggleEditDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (c) {
        if (c) setCurrent(c);
        setOpenEditDialog(function (prev) {
            return !prev;
        });
    }, []);

    var toggleAddDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (c) {
        if (c) setCurrent(c);
        setOpenAddDialog(function (prev) {
            return !prev;
        });
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-col' },
                        'Activities'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-col' },
                        'Company Name'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-col' },
                        'Contact Details'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-body' },
                fields.map(function (field, index) {
                    if (!serviceProviders[index]) {
                        return null;
                    }

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-row', key: index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col info' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                serviceProviders[index].activities && serviceProviders[index].activities.includes('Stevedoring Company') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StevedoringPopover__["a" /* default */], {
                                    serviceProvider: serviceProviders[index]
                                }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    serviceProviders[index].activities.map(function (activity, idx) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { key: 'activity_' + idx },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                null,
                                                activity
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name company' },
                                serviceProviders[index].name
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'list' },
                                serviceProviders[index].emails.map(function (email, emailIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { key: emailIndex, className: 'email' },
                                        email
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'list' },
                                serviceProviders[index].phones.map(function (phone, phoneIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { key: phoneIndex, className: 'phone' },
                                        phone.code + ' ' + phone.phone
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                serviceProviders[index].address
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                'PIC: ',
                                serviceProviders[index].PIC
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'table-col edit',
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    position: 'relative',
                                    width: '122px'
                                }
                            },
                            serviceProviders[index].recommended && serviceProviders[index].recommended.endAt ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_material_ui__["c" /* Chip */],
                                {
                                    style: {
                                        backgroundColor: '#E8F5E9',
                                        height: 24,
                                        position: 'absolute',
                                        top: 10,
                                        right: 0,
                                        zIndex: 1000,
                                        width: 118
                                    },
                                    labelStyle: {
                                        color: '#2E7D32',
                                        lineHeight: '24px',
                                        fontSize: '12px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }
                                },
                                'Recommended',
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                                    {
                                        tooltip: Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ports__["a" /* getRecommendedTitle */])(serviceProviders[index]),
                                        tooltipPosition: 'bottom-left',
                                        style: {
                                            width: 20,
                                            height: 18,
                                            padding: 0
                                        },
                                        iconStyle: { width: 16, height: 16, color: '#2E7D32' }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_info_outline___default.a, null)
                                )
                            ) : null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'icon edit-icon' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                                    {
                                        iconStyle: { color: '#CBCBCB' },
                                        onClick: function onClick() {
                                            toggleEditDialog({ field: field });
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_create___default.a, null)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'icon delete-icon' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                                    {
                                        iconStyle: { color: '#CBCBCB' },
                                        onClick: function onClick() {
                                            fields.remove(index);
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_delete___default.a, null)
                                )
                            )
                        )
                    );
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
            label: 'Add Service Provider',
            labelStyle: styles.btn.labelStyle,
            style: styles.btn.style,
            labelPosition: 'before',
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add___default.a, null),
            primary: true,
            onClick: addServiceProvider
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EditServiceProvider__["a" /* default */], {
            open: openEditDialog,
            toggle: toggleEditDialog,
            field: current.field,
            hasRecommended: hasRecommended
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AddServiceProvider__["a" /* default */], {
            open: openAddDialog,
            toggle: toggleAddDialog,
            field: current.field,
            fields: fields,
            hasRecommended: hasRecommended
        })
    );
}

ServiceProvider.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    serviceProviders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

ServiceProvider.defaultProps = {
    port: {},
    fields: {},
    serviceProviders: []
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        serviceProviders: state.port.serviceProviders
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(ServiceProvider);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvider.jsx');
    reactHotLoader.register(ServiceProvider, 'ServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvider.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvider.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var StevedoringPopover = function (_React$Component) {
    _inherits(StevedoringPopover, _React$Component);

    function StevedoringPopover(props) {
        _classCallCheck(this, StevedoringPopover);

        var _this = _possibleConstructorReturn(this, (StevedoringPopover.__proto__ || Object.getPrototypeOf(StevedoringPopover)).call(this, props));

        _this.state = {
            openPopover: false,
            anchorElPopover: {}
        };

        _this.handleRequestClosePopover = _this.handleRequestClosePopover.bind(_this);
        _this.handleClickPopover = _this.handleClickPopover.bind(_this);
        return _this;
    }

    _createClass(StevedoringPopover, [{
        key: 'handleClickPopover',
        value: function handleClickPopover(event) {
            // This prevents ghost click.
            event.preventDefault();

            this.setState({
                openPopover: true,
                anchorElPopover: event.currentTarget
            });
        }
    }, {
        key: 'handleRequestClosePopover',
        value: function handleRequestClosePopover() {
            this.setState({
                openPopover: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                openPopover = _state.openPopover,
                anchorElPopover = _state.anchorElPopover;
            var serviceProvider = this.props.serviceProvider;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                serviceProvider.activities.map(function (activity, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: 'activity_' + index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            activity
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'icon info-icon' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["o" /* Popover */],
                        {
                            open: openPopover,
                            anchorEl: anchorElPopover,
                            anchorOrigin: { "horizontal": "middle", "vertical": "center" },
                            targetOrigin: { "horizontal": "middle", "vertical": "center" },
                            onRequestClose: this.handleRequestClosePopover
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'paper-block stevedoring-popover' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'title' },
                                serviceProvider.activities.join(',')
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'limitations' },
                                serviceProvider.limitations.map(function (limitation, limitationIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { key: 'limitation_stevedoring_' + limitationIndex },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            { className: 'limitation__counter' },
                                            'Limitation: ' + (limitationIndex + 1)
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'limitation' },
                                            'Berth ',
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                { style: { wordBreak: 'break-all', position: 'inherit' } },
                                                limitation.berth
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'limitation' },
                                            'Max draft ',
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                null,
                                                limitation.maxDraught,
                                                ' m'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'limitation' },
                                            'Max beam ',
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                null,
                                                limitation.maxBeam,
                                                ' m'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'limitation' },
                                            'Max LOA ',
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                null,
                                                limitation.maxLOA,
                                                ' m'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'limitation' },
                                            'Max DWT ',
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                null,
                                                limitation.maxDWT,
                                                ' m'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'limitation' },
                                            'Channel depth ',
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                null,
                                                limitation.channelDepth,
                                                ' m'
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                        {
                            iconStyle: { color: '#CBCBCB' },
                            onClick: this.handleClickPopover },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline___default.a, {
                            style: { color: '#CBCBCB' }
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return StevedoringPopover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

StevedoringPopover.propTypes = {};

StevedoringPopover.defaultProps = {};

var _default = StevedoringPopover;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StevedoringPopover, 'StevedoringPopover', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/StevedoringPopover.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/StevedoringPopover.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormFields__ = __webpack_require__(916);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();















var styles = {
    dialog: {
        contentStyle: { width: '843px', padding: '20px' }
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    },
    btn: {
        labelStyle: { color: '#fff' }
    }
};

function AddServiceProvider(props) {
    var open = props.open,
        field = props.field,
        toggle = props.toggle,
        serviceProvider = props.serviceProvider,
        fields = props.fields,
        handleSubmit = props.handleSubmit,
        changePort = props.changePort,
        formChange = props.change,
        hasRecommended = props.hasRecommended;


    var onRequestClose = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        fields.pop();
        toggle();
    }, [fields, toggle]);

    var onSubmit = function onSubmit(submit) {
        toggle();
        changePort(submit);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
        {
            open: open,
            contentStyle: styles.dialog.contentStyle,
            onRequestClose: onRequestClose,
            paperClassName: 'dialog-service-provider',
            bodyStyle: { overflowY: 'auto' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'title' },
                    'Add Service Provider: ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    'Marine equipment & spare parts'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormFields__["a" /* default */], {
                    field: field,
                    serviceProvider: serviceProvider,
                    formChange: formChange,
                    hasRecommended: hasRecommended
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12', style: { display: 'flex', gap: '10px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                            label: 'Cancel',
                            primary: true,
                            onClick: onRequestClose
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                            label: 'Add',
                            backgroundColor: '#7FC931',
                            labelStyle: styles.btn.labelStyle,
                            onClick: handleSubmit(onSubmit)
                        })
                    )
                )
            )
        )
    );
}

AddServiceProvider.propTypes = {};

AddServiceProvider.defaultProps = {};

var FormAddServiceProvider = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_6_data_formNames__["a" /* formName */].portUpdateAddServiceProvider,
    enableReinitialize: true
})(AddServiceProvider);

var selector = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_6_data_formNames__["a" /* formName */].portUpdate);
var selectorAddServiceProvider = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_6_data_formNames__["a" /* formName */].portUpdateAddServiceProvider);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        initialValues: { serviceProviders: selector(state, 'serviceProviders') },
        serviceProvider: selectorAddServiceProvider(state, ownProps.field)
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(FormAddServiceProvider);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx');
    reactHotLoader.register(AddServiceProvider, 'AddServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx');
    reactHotLoader.register(FormAddServiceProvider, 'FormAddServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx');
    reactHotLoader.register(selectorAddServiceProvider, 'selectorAddServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormFields__ = __webpack_require__(916);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();















var styles = {
    dialog: {
        contentStyle: { width: '843px', padding: '20px' }
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    },
    btn: {
        labelStyle: { color: '#fff' }
    }
};

var EditServiceProvider = function EditServiceProvider(props) {
    var open = props.open,
        toggle = props.toggle,
        field = props.field,
        serviceProvider = props.serviceProvider,
        handleSubmit = props.handleSubmit,
        changePort = props.changePort,
        formChange = props.change,
        hasRecommended = props.hasRecommended,
        reset = props.reset;


    var onRequestClose = function onRequestClose() {
        reset();
        toggle();
    };

    var onSubmit = function onSubmit(submit) {
        toggle();
        changePort(submit);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
        {
            open: open,
            contentStyle: styles.dialog.contentStyle,
            onRequestClose: onRequestClose,
            paperClassName: 'dialog-service-provider',
            bodyStyle: { overflowY: 'auto' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'title' },
                    'Edit Service Provider: ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    'Marine equipment & spare parts'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormFields__["a" /* default */], {
                    field: field,
                    serviceProvider: serviceProvider,
                    formChange: formChange,
                    hasRecommended: hasRecommended
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12', style: { display: 'flex', gap: '10px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                            label: 'Cancel',
                            primary: true,
                            onClick: onRequestClose
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                            label: 'Save',
                            backgroundColor: '#7FC931',
                            labelStyle: styles.btn.labelStyle,
                            onClick: handleSubmit(onSubmit)
                        })
                    )
                )
            )
        )
    );
};

EditServiceProvider.propTypes = {};

EditServiceProvider.defaultProps = {};

var FormEditServiceProvider = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_6_data_formNames__["a" /* formName */].portUpdateEditServiceProvider,
    enableReinitialize: true
})(EditServiceProvider);

var selector = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_6_data_formNames__["a" /* formName */].portUpdate);
var selectorEditProvider = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_6_data_formNames__["a" /* formName */].portUpdateEditServiceProvider);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        initialValues: { serviceProviders: selector(state, 'serviceProviders') },
        serviceProvider: selectorEditProvider(state, ownProps.field)
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(FormEditServiceProvider);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/EditServiceProvider.jsx');
    reactHotLoader.register(EditServiceProvider, 'EditServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/EditServiceProvider.jsx');
    reactHotLoader.register(FormEditServiceProvider, 'FormEditServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/EditServiceProvider.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/EditServiceProvider.jsx');
    reactHotLoader.register(selectorEditProvider, 'selectorEditProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/EditServiceProvider.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/EditServiceProvider.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var styles = {
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    }
};

var PortRestrictions = function PortRestrictions() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'main__title' },
            'PORT Restrictions'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'port-restrictions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'list' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: 'portLimitations.maxDraught',
                        floatingLabelText: 'Max Draft, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: 'portLimitations.maxBeam',
                        floatingLabelText: 'Max Beam, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: 'portLimitations.maxLOA',
                        floatingLabelText: 'Max LOA, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000, allowBlank: true })],
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: 'portLimitations.maxDWT',
                        floatingLabelText: 'Max DWT, mt:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000000, allowBlank: true })],
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: 'portLimitations.channelDepth',
                        floatingLabelText: 'Channel Depth, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: 'portLimitations.anchorageDepth',
                        floatingLabelText: 'Anchorage Depth, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        name: 'portLimitations.meanTide',
                        floatingLabelText: 'Mean Tide, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                        fullWidth: true
                    })
                )
            )
        )
    );
};

var _default = PortRestrictions;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/PortRestrictions.jsx');
    reactHotLoader.register(PortRestrictions, 'PortRestrictions', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/PortRestrictions.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/PortRestrictions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();









var LiftAndCranesList = function LiftAndCranesList(_ref) {
    var _ref$liftsCranes = _ref.liftsCranes,
        liftsCranes = _ref$liftsCranes === undefined ? {} : _ref$liftsCranes;

    var items = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        return Object.values(liftsCranes);
    }, [liftsCranes]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'main__title' },
            'Available Lift and Cranes'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'lift-and-cranes' },
            items.map(function (liftCrane, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Item__["a" /* default */], {
                    key: '' + (liftCrane.id || index),
                    liftCrane: liftCrane,
                    liftsCranes: liftsCranes
                });
            })
        )
    );
};

var selector = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_4_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref2) {
    var parentProps = _ref2.parentProps;
    return {
        forms: state.form,
        formName: parentProps.form,
        liftsCranes: selector(state, 'liftsCranes')
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({}, dispatch);
})(LiftAndCranesList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LiftAndCranesList, 'LiftAndCranesList', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/List.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_hardware_keyboard_arrow_down__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_hardware_keyboard_arrow_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_hardware_keyboard_arrow_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_up__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Details__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var styles = {
    checkbox: {
        labelStyle: { fontSize: '14px' },
        style: { width: '750px' }
    },
    icon: {
        iconStyle: { color: '#00bcd4' }
    }
};

var LiftAndCranesItem = function LiftAndCranesItem(_ref) {
    var liftCrane = _ref.liftCrane,
        liftsCranes = _ref.liftsCranes,
        changePort = _ref.changePort;

    var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        showDetails = _React$useState2[0],
        setShowDetails = _React$useState2[1];

    var toggleDetails = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
        setShowDetails(function (prev) {
            return !prev;
        });
    }, []);

    var handleChangeVal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (_i, val, __i, name) {
        if (!val) {
            var key = name.split('.')[1];
            var _liftsCranes = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(liftsCranes);

            var updatedCrane = _extends({}, _liftsCranes[key], {
                checked: false,
                details: []
            });

            changePort({
                liftsCranes: _extends({}, _liftsCranes, _defineProperty({}, key, updatedCrane))
            });
        }
    }, [liftsCranes, changePort]);

    var _React$useMemo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        if (!liftCrane.name) return { min: 0, max: 100 };

        var _liftCrane$name$split = liftCrane.name.split('-'),
            _liftCrane$name$split2 = _slicedToArray(_liftCrane$name$split, 2),
            minStr = _liftCrane$name$split2[0],
            maxStr = _liftCrane$name$split2[1];

        return {
            min: parseInt(minStr) || 0,
            max: parseInt(maxStr) || 100
        };
    }, [liftCrane.name]),
        min = _React$useMemo.min,
        max = _React$useMemo.max;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'line-head' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12 middle-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__["Checkbox"],
                        name: 'liftsCranes.' + liftCrane.name + '.checked',
                        label: liftCrane.label,
                        labelStyle: styles.checkbox.labelStyle,
                        style: styles.checkbox.style,
                        onChange: handleChangeVal
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: liftCrane.checked ? 'more' : 'hidden more',
                            onClick: toggleDetails
                        },
                        'More details'
                    ),
                    liftCrane.checked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_IconButton___default.a,
                        {
                            iconStyle: styles.icon.iconStyle,
                            onClick: toggleDetails
                        },
                        showDetails ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_up___default.a, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_hardware_keyboard_arrow_down___default.a, null)
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: showDetails && liftCrane.checked ? 'line-body' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* FieldArray */], {
                name: 'liftsCranes.' + liftCrane.name + '.details',
                component: __WEBPACK_IMPORTED_MODULE_9__Details__["a" /* default */],
                props: liftCrane,
                min: min,
                max: max
            })
        )
    );
};

LiftAndCranesItem.propTypes = {
    liftCrane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    }).isRequired,
    liftsCranes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    changePort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        liftCrane: ownProps.liftCrane,
        liftsCranes: ownProps.liftsCranes
    };
}, {
    changePort: __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__["b" /* changePort */]
})(LiftAndCranesItem);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/Item.jsx');
    reactHotLoader.register(LiftAndCranesItem, 'LiftAndCranesItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AddDetail__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditDetail__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_data_formNames__ = __webpack_require__(64);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var styles = {
    icon: { iconStyle: { color: '#00bcd4' } }
};

var Details = function (_React$Component) {
    _inherits(Details, _React$Component);

    function Details(props) {
        _classCallCheck(this, Details);

        var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

        _this.state = {
            openEditDialog: false,
            openAddDialog: false,
            current: {
                field: '',
                min: 0,
                max: 0
            }
        };

        _this.toggleEditDialog = _this.toggleEditDialog.bind(_this);
        _this.toggleAddDialog = _this.toggleAddDialog.bind(_this);
        _this.addCapacity = _this.addCapacity.bind(_this);
        return _this;
    }

    _createClass(Details, [{
        key: 'addCapacity',
        value: function addCapacity() {
            var fields = this.props.fields;


            fields.push({
                name: '',
                value: ''
            });

            this.toggleAddDialog({
                field: fields.name + '[' + fields.length + ']'
            });
        }
    }, {
        key: 'toggleAddDialog',
        value: function toggleAddDialog() {
            var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.current;

            this.setState({
                openAddDialog: !this.state.openAddDialog,
                current: current
            });
        }
    }, {
        key: 'toggleEditDialog',
        value: function toggleEditDialog() {
            var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.current;

            this.setState({
                openEditDialog: !this.state.openEditDialog,
                current: current
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                openEditDialog = _state.openEditDialog,
                openAddDialog = _state.openAddDialog,
                current = _state.current;
            var _props = this.props,
                fields = _props.fields,
                name = _props.name,
                port = _props.port,
                max = _props.max,
                min = _props.min;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                fields.map(function (detail, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                        { key: index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item middle-xs' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: function component(_ref) {
                                    var input = _ref.input,
                                        label = _ref.label,
                                        type = _ref.type,
                                        port = _ref.port,
                                        detail = _ref.detail,
                                        _ref$meta = _ref.meta,
                                        touched = _ref$meta.touched,
                                        error = _ref$meta.error;
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'count' },
                                        (_.get(port, detail) ? _.get(port, detail) : '') + ' mt: ',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            { className: 'error' },
                                            '' + (error || '')
                                        )
                                    );
                                },
                                name: detail + '.value',
                                props: { port: port, detail: detail + '.value' }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: function component(_ref2) {
                                    var input = _ref2.input,
                                        label = _ref2.label,
                                        type = _ref2.type,
                                        port = _ref2.port,
                                        detail = _ref2.detail,
                                        _ref2$meta = _ref2.meta,
                                        touched = _ref2$meta.touched,
                                        error = _ref2$meta.error;
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'name' },
                                        (_.get(port, detail) ? _.get(port, detail) : '') + ' ',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            { className: 'error' },
                                            '' + (error || '')
                                        )
                                    );
                                },
                                name: detail + '.name',
                                props: { port: port, detail: detail + '.name' }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'edit' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'icon edit-icon' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                        {
                                            iconStyle: styles.icon.iconStyle,
                                            onClick: function onClick() {
                                                _this2.toggleEditDialog({
                                                    field: detail
                                                });
                                            }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create___default.a, null)
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'icon delete-icon' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                        {
                                            iconStyle: styles.icon.iconStyle,
                                            onClick: function onClick() {
                                                fields.remove(index);
                                            }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete___default.a, null)
                                    )
                                )
                            )
                        )
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AddDetail__["a" /* default */], {
                    open: openAddDialog,
                    toggle: this.toggleAddDialog,
                    field: current.field,
                    fields: fields,
                    name: name,
                    min: min,
                    max: max
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EditDetail__["a" /* default */], {
                    open: openEditDialog,
                    toggle: this.toggleEditDialog,
                    field: current.field,
                    name: name,
                    min: min,
                    max: max
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row add-capacity' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 middle-xs end-xs' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'text' },
                            'Add capacity'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                            {
                                iconStyle: styles.icon.iconStyle,
                                onClick: this.addCapacity
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_image_control_point___default.a, null)
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Details;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Details.propTypes = {};

Details.defaultProps = {};

var selector = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_12_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        liftsCranes: selector(state, 'liftsCranes'),
        port: state.port
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(Details);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/Details.jsx');
    reactHotLoader.register(Details, 'Details', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/Details.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/Details.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/Details.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_data_formNames__ = __webpack_require__(64);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var styles = {
    dialog: {
        contentStyle: { width: '500px', padding: '18px' }
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    }
};

var AddDetail = function (_React$Component) {
    _inherits(AddDetail, _React$Component);

    function AddDetail(props) {
        _classCallCheck(this, AddDetail);

        var _this = _possibleConstructorReturn(this, (AddDetail.__proto__ || Object.getPrototypeOf(AddDetail)).call(this, props));

        _this.onRequestClose = _this.onRequestClose.bind(_this);
        return _this;
    }

    _createClass(AddDetail, [{
        key: 'onRequestClose',
        value: function onRequestClose() {
            this.props.toggle();
            this.props.fields.pop();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                open = _props.open,
                toggle = _props.toggle,
                field = _props.field,
                name = _props.name,
                min = _props.min,
                max = _props.max;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui__["f" /* Dialog */],
                {
                    open: open,
                    contentStyle: styles.dialog.contentStyle,
                    onRequestClose: this.onRequestClose
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'dialog-header' },
                            'add capacity between ',
                            name,
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */], {
                            component: __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__["TextField"],
                            name: field + '.name',
                            floatingLabelText: 'Name',
                            fullWidth: true,
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            validate: [Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["length"])({ max: 266 })]
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */], {
                            component: __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__["TextField"],
                            name: field + '.value',
                            floatingLabelText: 'Value',
                            fullWidth: true,
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            validate: [Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["numericality"])({ '<=': max, '>=': min, int: true })]
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                            label: 'Cancel',
                            primary: true,
                            onClick: this.onRequestClose
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                            label: 'Add',
                            onClick: this.props.handleSubmit(function (submit) {
                                toggle();
                                _this2.props.changePort(submit);
                            })
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AddDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AddDetail.propTypes = {};

AddDetail.defaultProps = {};

var FormAddDetail = Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_9_data_formNames__["a" /* formName */].portUpdateAddDetail,
    enableReinitialize: true
})(AddDetail);

var selector = Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_9_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        initialValues: { liftsCranes: selector(state, 'liftsCranes') },
        name: ownProps.name,
        min: ownProps.min,
        max: ownProps.max
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(FormAddDetail);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/AddDetail.jsx');
    reactHotLoader.register(AddDetail, 'AddDetail', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/AddDetail.jsx');
    reactHotLoader.register(FormAddDetail, 'FormAddDetail', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/AddDetail.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/AddDetail.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/AddDetail.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_data_formNames__ = __webpack_require__(64);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var styles = {
    dialog: {
        contentStyle: { width: '500px', padding: '18px' }
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    }
};

var EditDetail = function (_React$Component) {
    _inherits(EditDetail, _React$Component);

    function EditDetail(props) {
        _classCallCheck(this, EditDetail);

        var _this = _possibleConstructorReturn(this, (EditDetail.__proto__ || Object.getPrototypeOf(EditDetail)).call(this, props));

        _this.onRequestClose = _this.onRequestClose.bind(_this);
        return _this;
    }

    _createClass(EditDetail, [{
        key: 'onRequestClose',
        value: function onRequestClose() {
            this.props.toggle();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                open = _props.open,
                toggle = _props.toggle,
                field = _props.field,
                name = _props.name,
                min = _props.min,
                max = _props.max;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui__["f" /* Dialog */],
                {
                    open: open,
                    contentStyle: styles.dialog.contentStyle,
                    onRequestClose: this.onRequestClose
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'dialog-header' },
                            'edit capacity between ',
                            name,
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */], {
                            component: __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__["TextField"],
                            name: field + '.name',
                            floatingLabelText: 'Name',
                            fullWidth: true,
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            validate: [Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["length"])({ min: 3, max: 266 })]
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */], {
                            component: __WEBPACK_IMPORTED_MODULE_7_redux_form_material_ui__["TextField"],
                            name: field + '.value',
                            floatingLabelText: 'Value',
                            fullWidth: true,
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            validate: [Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["numericality"])({ int: true }), Object(__WEBPACK_IMPORTED_MODULE_8_redux_form_validators__["numericality"])({ '<=': max, '>=': min })]
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                            label: 'Cancel',
                            primary: true,
                            onClick: this.onRequestClose
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                            label: 'Save',
                            style: { background: '#7FC931' },
                            onClick: this.props.handleSubmit(function (submit) {
                                toggle();
                                _this2.props.changePort(submit);
                            })
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return EditDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EditDetail.propTypes = {};

EditDetail.defaultProps = {};

var FormEditDetail = Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_9_data_formNames__["a" /* formName */].portUpdateEditDetail,
    enableReinitialize: true
})(EditDetail);

var selector = Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_9_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        initialValues: { liftsCranes: selector(state, 'liftsCranes') },
        name: ownProps.name,
        min: ownProps.min,
        max: ownProps.max
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_5_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(FormEditDetail);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/EditDetail.jsx');
    reactHotLoader.register(EditDetail, 'EditDetail', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/EditDetail.jsx');
    reactHotLoader.register(FormEditDetail, 'FormEditDetail', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/EditDetail.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/EditDetail.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/LiftAndCranes/EditDetail.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var styles = {
    checkbox: {
        labelStyle: { fontSize: '14px', color: '#333' }
    }
};

var Facilities = function (_React$Component) {
    _inherits(Facilities, _React$Component);

    function Facilities() {
        _classCallCheck(this, Facilities);

        return _possibleConstructorReturn(this, (Facilities.__proto__ || Object.getPrototypeOf(Facilities)).apply(this, arguments));
    }

    _createClass(Facilities, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'main__title' },
                    'facilities'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'facilities' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row divided' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4 border-bottom' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.breakBulk',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Break Bulk',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.dryDock',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Dry Dock',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.roro',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Ro-Ro',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.container',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Container',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.lpg',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'LPG',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.lng',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'LNG',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.liquid',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Liquid',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.multipurpose',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Multipurpose',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.passenger',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Passenger',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.dryBulk',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Dry Bulk',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.bunkering',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Bunkering',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.steel',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Steel',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.shipyard',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Shipyard',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                                name: 'facilities.reefer',
                                component: __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["Checkbox"],
                                label: 'Reefer',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Facilities;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Facilities.propTypes = {};

Facilities.defaultProps = {};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(Facilities);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Facilities.jsx');
    reactHotLoader.register(Facilities, 'Facilities', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Facilities.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Facilities.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var styles = {
    checkbox: {
        labelStyle: { fontSize: '14px', color: '#333' }
    }
};

var Warehouses = function Warehouses() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'warehouses' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row divided' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3', style: styles.checkbox.labelStyle },
                    'WAREHOUSES'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row divided' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.timber',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'Timber',
                        labelStyle: styles.checkbox.labelStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.grain',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'Grain',
                        labelStyle: styles.checkbox.labelStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.lpg',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'LPG',
                        labelStyle: styles.checkbox.labelStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.chemicals',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'Chemicals',
                        labelStyle: styles.checkbox.labelStyle
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row divided' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.dryBulk',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'Dry bulk (ore, coal, etc)',
                        labelStyle: styles.checkbox.labelStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.liquid',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'Liquid',
                        labelStyle: styles.checkbox.labelStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.general',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'General cargo',
                        labelStyle: styles.checkbox.labelStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.reefer',
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: 'Reefer cargo',
                        labelStyle: styles.checkbox.labelStyle
                    })
                )
            )
        )
    );
};

Warehouses.propTypes = {};

Warehouses.defaultProps = {};

var _default = Warehouses;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Warehouses.jsx');
    reactHotLoader.register(Warehouses, 'Warehouses', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Warehouses.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Warehouses.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_data_formNames__ = __webpack_require__(64);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var styles = {
    dialog: {
        contentStyle: { width: 'auto', padding: '18px' }
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    button: {
        style: { background: '#7FC931' }

    }
};

var Other = function (_React$Component) {
    _inherits(Other, _React$Component);

    function Other(props) {
        _classCallCheck(this, Other);

        var _this = _possibleConstructorReturn(this, (Other.__proto__ || Object.getPrototypeOf(Other)).call(this, props));

        _this.state = {
            open: false
        };

        _this.toggleDialog = _this.toggleDialog.bind(_this);
        return _this;
    }

    _createClass(Other, [{
        key: 'toggleDialog',
        value: function toggleDialog() {
            this.setState({
                open: !this.state.open
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var open = this.state.open;
            var additionalDescription = this.props.additionalDescription;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog___default.a,
                    {
                        open: open,
                        contentStyle: styles.dialog.contentStyle,
                        onRequestClose: this.toggleDialog
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                        name: 'additionalDescription',
                        component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                        floatingLabelText: 'Other',
                        multiLine: true,
                        fullWidth: true,
                        floatingLabelStyle: styles.textField.floatingLabelStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["r" /* RaisedButton */], {
                        label: 'Save',
                        style: styles.button.style,
                        primary: true,
                        onClick: function onClick() {
                            _this2.toggleDialog();
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'main__title' },
                    'other'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'other' },
                    additionalDescription,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'other-change' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,
                            {
                                iconStyle: { color: '#CBCBCB' },
                                onClick: this.toggleDialog },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_create___default.a, null)
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Other;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Other.propTypes = {
    additionalDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Other.defaultProps = {
    additionalDescription: ''
};

var selector = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_11_data_formNames__["a" /* formName */].portUpdate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        additionalDescription: selector(state, 'additionalDescription')
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(Other);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Other.jsx');
    reactHotLoader.register(Other, 'Other', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Other.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Other.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/Other.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(22)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(385)

var _bind3 = _interopRequireDefault(_bind2)

exports.withScriptjs = withScriptjs

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(931)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _recompose = __webpack_require__(932)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var LOADING_STATE_NONE = "NONE"
var LOADING_STATE_BEGIN = "BEGIN"
var LOADING_STATE_LOADED = "LOADED"

function withScriptjs(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          loadingState: LOADING_STATE_NONE,
        }),
        (_this.isUnmounted = false),
        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "handleLoaded",
        value: function handleLoaded() {
          if (this.isUnmounted) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_LOADED,
          })
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            loadingElement = _props.loadingElement,
            googleMapURL = _props.googleMapURL

          ;(0, _invariant2.default)(
            !!loadingElement && !!googleMapURL,
            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
          )
        },
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          var loadingState = this.state.loadingState

          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_BEGIN,
          })
          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
          // eslint-disable-next-line global-require
          var scriptjs = __webpack_require__(2253)
          var googleMapURL = this.props.googleMapURL

          scriptjs(googleMapURL, this.handleLoaded)
        },
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            loadingElement = _props2.loadingElement,
            googleMapURL = _props2.googleMapURL,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "loadingElement",
              "googleMapURL",
            ])
          var loadingState = this.state.loadingState

          if (loadingState === LOADING_STATE_LOADED) {
            return factory(restProps)
          } else {
            return loadingElement
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    loadingElement: _propTypes2.default.node.isRequired,
    googleMapURL: _propTypes2.default.string.isRequired,
  }

  return Container
}

exports.default = withScriptjs


/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(921),
    createBind = __webpack_require__(2236),
    createCurry = __webpack_require__(2237),
    createHybrid = __webpack_require__(923),
    createPartial = __webpack_require__(2248),
    getData = __webpack_require__(927),
    mergeData = __webpack_require__(2249),
    setData = __webpack_require__(929),
    setWrapToString = __webpack_require__(930),
    toInteger = __webpack_require__(2250);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(386),
    root = __webpack_require__(77);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(342),
    createCtor = __webpack_require__(386),
    createHybrid = __webpack_require__(923),
    createRecurry = __webpack_require__(926),
    getHolder = __webpack_require__(557),
    replaceHolders = __webpack_require__(387),
    root = __webpack_require__(77);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 2238 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(555),
    getData = __webpack_require__(927),
    getFuncName = __webpack_require__(2240),
    lodash = __webpack_require__(2242);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(2241);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 2241 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(555),
    LodashWrapper = __webpack_require__(928),
    baseLodash = __webpack_require__(556),
    isArray = __webpack_require__(67),
    isObjectLike = __webpack_require__(135),
    wrapperClone = __webpack_require__(2243);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(555),
    LodashWrapper = __webpack_require__(928),
    copyArray = __webpack_require__(544);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 2244 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 2245 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(543),
    arrayIncludes = __webpack_require__(339);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(544),
    isIndex = __webpack_require__(271);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(342),
    createCtor = __webpack_require__(386),
    root = __webpack_require__(77);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(924),
    composeArgsRight = __webpack_require__(925),
    replaceHolders = __webpack_require__(387);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(2251);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(547);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(22)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(385)

var _bind3 = _interopRequireDefault(_bind2)

exports.withGoogleMap = withGoogleMap

var _warning = __webpack_require__(56)

var _warning2 = _interopRequireDefault(_warning)

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _recompose = __webpack_require__(932)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function withGoogleMap(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          map: null,
        }),
        (_this.handleComponentMount = (0, _bind3.default)(
          _this.handleComponentMount,
          _this
        )),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "getChildContext",
        value: function getChildContext() {
          return (0, _defineProperty3.default)(
            {},
            _constants.MAP,
            this.state.map
          )
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement

          ;(0, _invariant2.default)(
            !!containerElement && !!mapElement,
            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
          )
        },
      },
      {
        key: "handleComponentMount",
        value: function handleComponentMount(node) {
          if (this.state.map || node === null) {
            return
          }
          ;(0, _warning2.default)(
            "undefined" !== typeof google,
            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
          )
          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
          var map = new google.maps.Map(node)
          this.setState({ map: map })
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "containerElement",
              "mapElement",
            ])
          var map = this.state.map

          if (map) {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null, factory(restProps))
            )
          } else {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null)
            )
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired,
  }
  Container.childContextTypes = (0, _defineProperty3.default)(
    {},
    _constants.MAP,
    _propTypes2.default.object
  )

  return Container
}

exports.default = withGoogleMap


/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GoogleMap = exports.Map = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _toConsumableArray2 = __webpack_require__(220)

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Map`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
 */
var Map = (exports.Map = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Map, _React$PureComponent)
  ;(0, _createClass3.default)(Map, [
    {
      key: "fitBounds",

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
      value: function fitBounds() {
        var _context$MAP

        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
          _context$MAP,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panBy",
      value: function panBy() {
        var _context$MAP2

        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
          _context$MAP2,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panTo",
      value: function panTo() {
        var _context$MAP3

        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
          _context$MAP3,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panToBounds",
      value: function panToBounds() {
        var _context$MAP4

        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
          _context$MAP4,
          arguments
        )
      },

      /*
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
     */
    },
  ])

  function Map(props, context) {
    ;(0, _classCallCheck3.default)(this, Map)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
        this,
        props,
        context
      )
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      GoogleMap.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP]
    )
    return _this
  }

  ;(0, _createClass3.default)(Map, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
       * @type LatLngBoundsnullundefined
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.context[_constants.MAP].getBounds()
      },

      /**
       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
       * @type LatLngLatLngLatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.context[_constants.MAP].getCenter()
      },

      /**
       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickableIcons",
      value: function getClickableIcons() {
        return this.context[_constants.MAP].getClickableIcons()
      },

      /**
       *
       * @type Element
       * @public
       */
    },
    {
      key: "getDiv",
      value: function getDiv() {
        return this.context[_constants.MAP].getDiv()
      },

      /**
       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
       * @type number
       * @public
       */
    },
    {
      key: "getHeading",
      value: function getHeading() {
        return this.context[_constants.MAP].getHeading()
      },

      /**
       *
       * @type MapTypeId|string
       * @public
       */
    },
    {
      key: "getMapTypeId",
      value: function getMapTypeId() {
        return this.context[_constants.MAP].getMapTypeId()
      },

      /**
       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
       * @type ProjectionProjectionprojection_changed
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.context[_constants.MAP].getProjection()
      },

      /**
       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
       * @public
       */
    },
    {
      key: "getStreetView",
      value: function getStreetView() {
        return this.context[_constants.MAP].getStreetView()
      },

      /**
       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
       * @type number045satellitehybridsetTiltsetTilt
       * @public
       */
    },
    {
      key: "getTilt",
      value: function getTilt() {
        return this.context[_constants.MAP].getTilt()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return Map
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

Map.displayName = "GoogleMap"
Map.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
   * @type Array<[id:string, mapType:MapType|*]>
   */
  defaultExtraMapTypes: _propTypes2.default.arrayOf(
    _propTypes2.default.arrayOf(_propTypes2.default.any)
  ),

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultHeading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  defaultMapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  defaultStreetView: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultTilt: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  heading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  mapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  streetView: _propTypes2.default.any,

  /**
   * @type number
   */
  tilt: _propTypes2.default.number,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMapTypeIdChanged: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onTilesLoaded: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onHeadingChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIdle: _propTypes2.default.func,

  /**
   * function
   */
  onProjectionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onTiltChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
Map.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
var GoogleMap = (exports.GoogleMap = Map)

exports.default = Map

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  extraMapTypes: function extraMapTypes(instance, extra) {
    extra.forEach(function(it) {
      var _instance$mapTypes

      return (_instance$mapTypes = instance.mapTypes).set.apply(
        _instance$mapTypes,
        (0, _toConsumableArray3.default)(it)
      )
    })
  },
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  clickableIcons: function clickableIcons(instance, _clickableIcons) {
    instance.setClickableIcons(_clickableIcons)
  },
  heading: function heading(instance, _heading) {
    instance.setHeading(_heading)
  },
  mapTypeId: function mapTypeId(instance, _mapTypeId) {
    instance.setMapTypeId(_mapTypeId)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  streetView: function streetView(instance, _streetView) {
    instance.setStreetView(_streetView)
  },
  tilt: function tilt(instance, _tilt) {
    instance.setTilt(_tilt)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(546),
    baseEach = __webpack_require__(542),
    baseIteratee = __webpack_require__(882),
    baseReduce = __webpack_require__(2257),
    isArray = __webpack_require__(67);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 2257 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(2259);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(2260),
    hasUnicode = __webpack_require__(933),
    stringToArray = __webpack_require__(2262),
    toString = __webpack_require__(674);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(2261);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 2261 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(2263),
    hasUnicode = __webpack_require__(933),
    unicodeToArray = __webpack_require__(2264);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 2263 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 2264 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(2266),
    hasPath = __webpack_require__(894);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 2266 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Circle = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Circle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Circle = (exports.Circle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Circle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
   */
  function Circle(props, context) {
    ;(0, _classCallCheck3.default)(this, Circle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
        this,
        props,
        context
      )
    )

    var circle = new google.maps.Circle()
    ;(0, _MapChildHelper.construct)(
      Circle.propTypes,
      updaterMap,
      _this.props,
      circle
    )
    circle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
    return _this
  }

  ;(0, _createClass3.default)(Circle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.CIRCLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.CIRCLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var circle = this.state[_constants.CIRCLE]
        if (circle) {
          circle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this Circle.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.CIRCLE].getBounds()
      },

      /**
       * Returns the center of this circle.
       * @type LatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.state[_constants.CIRCLE].getCenter()
      },

      /**
       * Returns whether this circle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.CIRCLE].getDraggable()
      },

      /**
       * Returns whether this circle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.CIRCLE].getEditable()
      },

      /**
       * Returns the radius of this circle (in meters).
       * @type number
       * @public
       */
    },
    {
      key: "getRadius",
      value: function getRadius() {
        return this.state[_constants.CIRCLE].getRadius()
      },

      /**
       * Returns whether this circle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.CIRCLE].getVisible()
      },
    },
  ])
  return Circle
})(_react2.default.PureComponent))

Circle.propTypes = {
  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRadius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type number
   */
  radius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onRadiusChanged: _propTypes2.default.func,
}
Circle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Circle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onRadiusChanged: "radius_changed",
}

var updaterMap = {
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Marker = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _Marker$contextTypes /*
                           * -----------------------------------------------------------------------------
                           * This file is auto-generated from the corresponding file at `src/macros/`.
                           * Please **DO NOT** edit this file directly when creating PRs.
                           * -----------------------------------------------------------------------------
                           */
/* global google */

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Marker`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
 */
var Marker = (exports.Marker = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Marker, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
   */
  function Marker(props, context) {
    ;(0, _classCallCheck3.default)(this, Marker)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
        this,
        props,
        context
      )
    )

    var marker = new google.maps.Marker()
    ;(0, _MapChildHelper.construct)(
      Marker.propTypes,
      updaterMap,
      _this.props,
      marker
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
    } else {
      marker.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
    return _this
  }

  ;(0, _createClass3.default)(Marker, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.ANCHOR,
          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var marker = this.state[_constants.MARKER]
        if (marker) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
          }
          marker.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER].getZIndex()
      },
    },
  ])
  return Marker
})(_react2.default.PureComponent))

Marker.propTypes = {
  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
Marker.contextTypes = ((_Marker$contextTypes = {}),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_Marker$contextTypes)
Marker.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.ANCHOR,
  _propTypes2.default.object
)
exports.default = Marker

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polyline = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polyline`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polyline = (exports.Polyline = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polyline, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
   */
  function Polyline(props, context) {
    ;(0, _classCallCheck3.default)(this, Polyline)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
        this,
        props,
        context
      )
    )

    var polyline = new google.maps.Polyline()
    ;(0, _MapChildHelper.construct)(
      Polyline.propTypes,
      updaterMap,
      _this.props,
      polyline
    )
    polyline.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.POLYLINE,
      polyline
    )
    return _this
  }

  ;(0, _createClass3.default)(Polyline, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYLINE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYLINE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polyline = this.state[_constants.POLYLINE]
        if (polyline) {
          polyline.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYLINE].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYLINE].getEditable()
      },

      /**
       * Retrieves the path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYLINE].getPath()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYLINE].getVisible()
      },
    },
  ])
  return Polyline
})(_react2.default.PureComponent))

Polyline.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polyline.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polyline

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polygon = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polygon`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polygon = (exports.Polygon = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polygon, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
   */
  function Polygon(props, context) {
    ;(0, _classCallCheck3.default)(this, Polygon)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
        this,
        props,
        context
      )
    )

    var polygon = new google.maps.Polygon()
    ;(0, _MapChildHelper.construct)(
      Polygon.propTypes,
      updaterMap,
      _this.props,
      polygon
    )
    polygon.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
    return _this
  }

  ;(0, _createClass3.default)(Polygon, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYGON],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYGON],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polygon = this.state[_constants.POLYGON]
        if (polygon) {
          polygon.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYGON].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYGON].getEditable()
      },

      /**
       * Retrieves the first path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYGON].getPath()
      },

      /**
       * Retrieves the paths for this polygon.
       * @type MVCArray<MVCArray<LatLng>>
       * @public
       */
    },
    {
      key: "getPaths",
      value: function getPaths() {
        return this.state[_constants.POLYGON].getPaths()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYGON].getVisible()
      },
    },
  ])
  return Polygon
})(_react2.default.PureComponent))

Polygon.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  defaultPaths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  paths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polygon.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polygon

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Rectangle = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Rectangle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
   */
  function Rectangle(props, context) {
    ;(0, _classCallCheck3.default)(this, Rectangle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
        this,
        props,
        context
      )
    )

    var rectangle = new google.maps.Rectangle()
    ;(0, _MapChildHelper.construct)(
      Rectangle.propTypes,
      updaterMap,
      _this.props,
      rectangle
    )
    rectangle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.RECTANGLE,
      rectangle
    )
    return _this
  }

  ;(0, _createClass3.default)(Rectangle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var rectangle = this.state[_constants.RECTANGLE]
        if (rectangle) {
          rectangle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the bounds of this rectangle.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.RECTANGLE].getBounds()
      },

      /**
       * Returns whether this rectangle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.RECTANGLE].getDraggable()
      },

      /**
       * Returns whether this rectangle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.RECTANGLE].getEditable()
      },

      /**
       * Returns whether this rectangle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.RECTANGLE].getVisible()
      },
    },
  ])
  return Rectangle
})(_react2.default.PureComponent))

Rectangle.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Rectangle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Rectangle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.InfoWindow = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _InfoWindow$contextTy /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(931)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(49)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.InfoWindow`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
 */
var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
   */
  function InfoWindow(props, context) {
    ;(0, _classCallCheck3.default)(this, InfoWindow)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
        this,
        props,
        context
      )
    )

    var infoWindow = new google.maps.InfoWindow()
    ;(0, _MapChildHelper.construct)(
      InfoWindow.propTypes,
      updaterMap,
      _this.props,
      infoWindow
    )
    infoWindow.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.INFO_WINDOW,
      infoWindow
    )
    return _this
  }

  ;(0, _createClass3.default)(InfoWindow, [
    {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!_canUseDom2.default || this.containerElement) {
          return
        }
        if (_react2.default.version.match(/^16/)) {
          this.containerElement = document.createElement("div")
        }
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap
        )
        if (_react2.default.version.match(/^16/)) {
          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
          open(
            this.state[_constants.INFO_WINDOW],
            this.context[_constants.ANCHOR]
          )
          return
        }
        var content = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          content
        )
        this.state[_constants.INFO_WINDOW].setContent(content)
        open(
          this.state[_constants.INFO_WINDOW],
          this.context[_constants.ANCHOR]
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap,
          updaterMap,
          prevProps
        )
        if (_react2.default.version.match(/^16/)) {
          return
        }
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.INFO_WINDOW].getContent()
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var infoWindow = this.state[_constants.INFO_WINDOW]
        if (infoWindow) {
          if (
            !_react2.default.version.match(/^16/) &&
            infoWindow.getContent()
          ) {
            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
          }
          infoWindow.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        if (_react2.default.version.match(/^16/)) {
          return _reactDom2.default.createPortal(
            _react2.default.Children.only(this.props.children),
            this.containerElement
          )
        }
        return false
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.INFO_WINDOW].getPosition()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.INFO_WINDOW].getZIndex()
      },
    },
  ])
  return InfoWindow
})(_react2.default.PureComponent))

InfoWindow.propTypes = {
  /**
   * @type InfoWindowOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type InfoWindowOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onDomReady: _propTypes2.default.func,

  /**
   * function
   */
  onContentChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_InfoWindow$contextTy)
exports.default = InfoWindow

var open = function open(infoWindow, anchor) {
  if (anchor) {
    infoWindow.open(infoWindow.getMap(), anchor)
  } else if (infoWindow.getPosition()) {
    infoWindow.open(infoWindow.getMap())
  } else {
    ;(0, _invariant2.default)(
      false,
      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
    )
  }
}

var eventMap = {
  onCloseClick: "closeclick",
  onDomReady: "domready",
  onContentChanged: "content_changed",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.OverlayView = undefined

var _extends2 = __webpack_require__(21)

var _extends3 = _interopRequireDefault(_extends2)

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _delay2 = __webpack_require__(2274)

var _delay3 = _interopRequireDefault(_delay2)

var _assign2 = __webpack_require__(2276)

var _assign3 = _interopRequireDefault(_assign2)

var _bind2 = __webpack_require__(385)

var _bind3 = _interopRequireDefault(_bind2)

var _OverlayView$contextT /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(49)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _OverlayViewHelper = __webpack_require__(2277)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.OverlayView`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
 */
var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  function OverlayView(props, context) {
    ;(0, _classCallCheck3.default)(this, OverlayView)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
      ).call(this, props, context)
    )

    var overlayView = new google.maps.OverlayView()
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
    _this.onPositionElement = (0, _bind3.default)(
      _this.onPositionElement,
      _this
    )
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.OVERLAY_VIEW,
      overlayView
    )
    return _this
  }

  ;(0, _createClass3.default)(OverlayView, [
    {
      key: "onAdd",
      value: function onAdd() {
        this.containerElement = document.createElement("div")
        this.containerElement.style.position = "absolute"
      },
    },
    {
      key: "draw",
      value: function draw() {
        var mapPaneName = this.props.mapPaneName

        ;(0, _invariant2.default)(
          !!mapPaneName,
          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
          mapPaneName
        )
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
        mapPanes[mapPaneName].appendChild(this.containerElement)

        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          this.containerElement,
          this.onPositionElement
        )
      },
    },
    {
      key: "onPositionElement",
      value: function onPositionElement() {
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
        var mapCanvasProjection = this.state[
          _constants.OVERLAY_VIEW
        ].getProjection()

        var offset = (0, _extends3.default)(
          {
            x: 0,
            y: 0,
          },
          (0, _OverlayViewHelper.getOffsetOverride)(
            this.containerElement,
            this.props
          )
        )
        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
          mapCanvasProjection,
          offset,
          this.props
        )
        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
      },
    },
    {
      key: "onRemove",
      value: function onRemove() {
        this.containerElement.parentNode.removeChild(this.containerElement)
        _reactDom2.default.unmountComponentAtNode(this.containerElement)
        this.containerElement = null
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap,
          updaterMap,
          prevProps
        )
        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var overlayView = this.state[_constants.OVERLAY_VIEW]
        if (overlayView) {
          overlayView.setMap(null)
          // You must implement three methods: onAdd(), draw(), and onRemove().
          overlayView.onAdd = null
          overlayView.draw = null
          overlayView.onRemove = null
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
       * @type MapPanesonAdd
       * @public
       */
    },
    {
      key: "getPanes",
      value: function getPanes() {
        return this.state[_constants.OVERLAY_VIEW].getPanes()
      },

      /**
       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.state[_constants.OVERLAY_VIEW].getProjection()
      },
    },
  ])
  return OverlayView
})(_react2.default.PureComponent))

OverlayView.FLOAT_PANE = "floatPane"
OverlayView.MAP_PANE = "mapPane"
OverlayView.MARKER_LAYER = "markerLayer"
OverlayView.OVERLAY_LAYER = "overlayLayer"
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
OverlayView.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  mapPaneName: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  position: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  bounds: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  getPixelPositionOffset: _propTypes2.default.func,
}
OverlayView.contextTypes = ((_OverlayView$contextT = {}),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_OverlayView$contextT)
exports.default = OverlayView

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(2275),
    baseRest = __webpack_require__(136),
    toNumber = __webpack_require__(547);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 2275 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(357),
    copyObject = __webpack_require__(232),
    createAssigner = __webpack_require__(794),
    isArrayLike = __webpack_require__(193),
    isPrototype = __webpack_require__(358),
    keys = __webpack_require__(240);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _isFunction2 = __webpack_require__(318)

var _isFunction3 = _interopRequireDefault(_isFunction2)

exports.getOffsetOverride = getOffsetOverride
exports.getLayoutStyles = getLayoutStyles

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(
      containerElement.offsetWidth,
      containerElement.offsetHeight
    )
  } else {
    return {}
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng)
}

function createLatLngBounds(inst, Type) {
  return new Type(
    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
  )
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst
  } else {
    return factory(inst, type)
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
  if (point) {
    var x = point.x,
      y = point.y

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(
      props.bounds,
      google.maps.LatLngBounds,
      createLatLngBounds
    )
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
  } else {
    var position = ensureOfType(
      props.position,
      google.maps.LatLng,
      createLatLng
    )
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
  }
}


/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GroundOverlay = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _warning = __webpack_require__(56)

var _warning2 = _interopRequireDefault(_warning)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.GroundOverlay`
 *
 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
 */
var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
   */
  function GroundOverlay(props, context) {
    ;(0, _classCallCheck3.default)(this, GroundOverlay)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
      ).call(this, props, context)
    )

    ;(0, _warning2.default)(
      !props.url || !props.bounds,
      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
    )
    var groundOverlay = new google.maps.GroundOverlay(
      props.defaultUrl || props.url,
      props.defaultBounds || props.bounds
    )
    ;(0, _MapChildHelper.construct)(
      GroundOverlay.propTypes,
      updaterMap,
      _this.props,
      groundOverlay
    )
    groundOverlay.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.GROUND_LAYER,
      groundOverlay
    )
    return _this
  }

  ;(0, _createClass3.default)(GroundOverlay, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var GroundOverlay = this.state[_constants.GROUND_LAYER]
        if (GroundOverlay) {
          GroundOverlay.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this overlay.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.GROUND_LAYER].getBounds()
      },

      /**
       * Returns the opacity of this ground overlay.
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.GROUND_LAYER].getOpacity()
      },

      /**
       * Gets the url of the projected image.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.GROUND_LAYER].getUrl()
      },
    },
  ])
  return GroundOverlay
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */
/* global google */

GroundOverlay.propTypes = {
  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   */,

  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
   * @type string
   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
   */,

  url: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
   */
  bounds: _propTypes2.default.object,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
GroundOverlay.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = GroundOverlay

var eventMap = {
  onDblClick: "dblclick",
  onClick: "click",
}

var updaterMap = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
}


/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.DirectionsRenderer = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.DirectionsRenderer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var DirectionsRenderer = (exports.DirectionsRenderer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
   */
  function DirectionsRenderer(props, context) {
    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        DirectionsRenderer.__proto__ ||
        (0, _getPrototypeOf2.default)(DirectionsRenderer)
      ).call(this, props, context)
    )

    var directionsRenderer = new google.maps.DirectionsRenderer()
    ;(0, _MapChildHelper.construct)(
      DirectionsRenderer.propTypes,
      updaterMap,
      _this.props,
      directionsRenderer
    )
    directionsRenderer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.DIRECTIONS_RENDERER,
      directionsRenderer
    )
    return _this
  }

  ;(0, _createClass3.default)(DirectionsRenderer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
        if (directionsRenderer) {
          directionsRenderer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the renderer's current set of directions.
       * @type DirectionsResult
       * @public
       */
    },
    {
      key: "getDirections",
      value: function getDirections() {
        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
      },

      /**
       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
       * @type Node<div>DirectionsResult
       * @public
       */
    },
    {
      key: "getPanel",
      value: function getPanel() {
        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
      },

      /**
       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
       * @type numberDirectionsRenderer
       * @public
       */
    },
    {
      key: "getRouteIndex",
      value: function getRouteIndex() {
        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
      },
    },
  ])
  return DirectionsRenderer
})(_react2.default.PureComponent))

DirectionsRenderer.propTypes = {
  /**
   * @type DirectionsResult
   */
  defaultDirections: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type Node
   */
  defaultPanel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRouteIndex: _propTypes2.default.number,

  /**
   * @type DirectionsResult
   */
  directions: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type Node
   */
  panel: _propTypes2.default.any,

  /**
   * @type number
   */
  routeIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDirectionsChanged: _propTypes2.default.func,
}
DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = DirectionsRenderer

var eventMap = {
  onDirectionsChanged: "directions_changed",
}

var updaterMap = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel)
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex)
  },
}


/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.KmlLayer = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.KmlLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
   */
  function KmlLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, KmlLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
        this,
        props,
        context
      )
    )

    var kmlLayer = new google.maps.KmlLayer()
    ;(0, _MapChildHelper.construct)(
      KmlLayer.propTypes,
      updaterMap,
      _this.props,
      kmlLayer
    )
    kmlLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.KML_LAYER,
      kmlLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(KmlLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var kmlLayer = this.state[_constants.KML_LAYER]
        if (kmlLayer) {
          kmlLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Get the default viewport for the layer being displayed.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getDefaultViewport",
      value: function getDefaultViewport() {
        return this.state[_constants.KML_LAYER].getDefaultViewport()
      },

      /**
       * Get the metadata associated with this layer, as specified in the layer markup.
       * @type KmlLayerMetadata
       * @public
       */
    },
    {
      key: "getMetadata",
      value: function getMetadata() {
        return this.state[_constants.KML_LAYER].getMetadata()
      },

      /**
       * Get the status of the layer, set once the requested document has loaded.
       * @type KmlLayerStatus
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.state[_constants.KML_LAYER].getStatus()
      },

      /**
       * Gets the URL of the KML file being displayed.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.KML_LAYER].getUrl()
      },

      /**
       * Gets the z-index of the KML Layer.
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.KML_LAYER].getZIndex()
      },
    },
  ])
  return KmlLayer
})(_react2.default.PureComponent))

KmlLayer.propTypes = {
  /**
   * @type KmlLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type KmlLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  url: _propTypes2.default.string,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDefaultViewportChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,
}
KmlLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = KmlLayer

var eventMap = {
  onDefaultViewportChanged: "defaultviewport_changed",
  onClick: "click",
  onStatusChanged: "status_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  url: function url(instance, _url) {
    instance.setUrl(_url)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.TrafficLayer = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.TrafficLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, TrafficLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
      ).call(this, props, context)
    )

    var trafficLayer = new google.maps.TrafficLayer()
    ;(0, _MapChildHelper.construct)(
      TrafficLayer.propTypes,
      updaterMap,
      _this.props,
      trafficLayer
    )
    trafficLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.TRAFFIC_LAYER,
      trafficLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(TrafficLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
        if (trafficLayer) {
          trafficLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return TrafficLayer
})(_react2.default.PureComponent))

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any,
}
TrafficLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = TrafficLayer

var eventMap = {}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.StreetViewPanorama = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(38)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.StreetViewPanorama`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
 */
var StreetViewPanorama = (exports.StreetViewPanorama = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)

  function StreetViewPanorama(props, context) {
    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        StreetViewPanorama.__proto__ ||
        (0, _getPrototypeOf2.default)(StreetViewPanorama)
      ).call(this, props, context)
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      StreetViewPanorama.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP].getStreetView()
    )
    return _this
  }

  ;(0, _createClass3.default)(StreetViewPanorama, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.MAP,
          this.context[_constants.MAP].getStreetView()
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
        if (streetViewPanorama) {
          streetViewPanorama.setVisible(false)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the set of navigation links for the Street View panorama.
       * @type Array<StreetViewLink>
       * @public
       */
    },
    {
      key: "getLinks",
      value: function getLinks() {
        return this.context[_constants.MAP].getLinks()
      },

      /**
       * Returns the StreetViewLocation of the current panorama.
       * @type StreetViewLocation
       * @public
       */
    },
    {
      key: "getLocation",
      value: function getLocation() {
        return this.context[_constants.MAP].getLocation()
      },

      /**
       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
       * @type boolean
       * @public
       */
    },
    {
      key: "getMotionTracking",
      value: function getMotionTracking() {
        return this.context[_constants.MAP].getMotionTracking()
      },

      /**
       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
       * @type string
       * @public
       */
    },
    {
      key: "getPano",
      value: function getPano() {
        return this.context[_constants.MAP].getPano()
      },

      /**
       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
       * @type StreetViewPovpano_changed
       * @public
       */
    },
    {
      key: "getPhotographerPov",
      value: function getPhotographerPov() {
        return this.context[_constants.MAP].getPhotographerPov()
      },

      /**
       * Returns the current `LatLng` position for the Street View panorama.
       * @type LatLngLatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.context[_constants.MAP].getPosition()
      },

      /**
       * Returns the current point of view for the Street View panorama.
       * @type StreetViewPov
       * @public
       */
    },
    {
      key: "getPov",
      value: function getPov() {
        return this.context[_constants.MAP].getPov()
      },

      /**
       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
       * @type StreetViewStatussetPosition()setPano()
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.context[_constants.MAP].getStatus()
      },

      /**
       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
       * @type booleantrue
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.context[_constants.MAP].getVisible()
      },

      /**
       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return StreetViewPanorama
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

StreetViewPanorama.propTypes = {
  /**
   * @type Array<StreetViewLink>
   */
  defaultLinks: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultMotionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultPano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  defaultPov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type Array<StreetViewLink>
   */
  links: _propTypes2.default.any,

  /**
   * @type boolean
   */
  motionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  pano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  pov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onPanoChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPovChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = StreetViewPanorama

var eventMap = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  links: function links(instance, _links) {
    instance.setLinks(_links)
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.MarkerWithLabel = undefined

var _defineProperty2 = __webpack_require__(69)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(15)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(13)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(14)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(16)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(17)

var _inherits3 = _interopRequireDefault(_inherits2)

var _MarkerWithLabel$cont /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _react = __webpack_require__(1)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(5)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _markerwithlabel = __webpack_require__(2286)

var _markerwithlabel2 = _interopRequireDefault(_markerwithlabel)

var _reactDom = __webpack_require__(49)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _MapChildHelper = __webpack_require__(75)

var _constants = __webpack_require__(72)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `MarkerWithLabel`
 *
 * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
 */
var MarkerWithLabel = (exports.MarkerWithLabel = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(MarkerWithLabel, _React$PureComponent)

  /*
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  function MarkerWithLabel(props, context) {
    ;(0, _classCallCheck3.default)(this, MarkerWithLabel)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        MarkerWithLabel.__proto__ ||
        (0, _getPrototypeOf2.default)(MarkerWithLabel)
      ).call(this, props, context)
    )

    var NativeMarkerWithLabel = (0, _markerwithlabel2.default)(google.maps)
    var markerWithLabel = new NativeMarkerWithLabel()
    ;(0, _MapChildHelper.construct)(
      MarkerWithLabel.propTypes,
      updaterMap,
      _this.props,
      markerWithLabel
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(markerWithLabel, !!_this.props.noRedraw)
    } else {
      markerWithLabel.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.MARKER_WITH_LABEL,
      markerWithLabel
    )
    return _this
  }

  ;(0, _createClass3.default)(MarkerWithLabel, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER_WITH_LABEL],
          eventMap
        )
        var container = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          container
        )
        this.state[_constants.MARKER_WITH_LABEL].set("labelContent", container)
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER_WITH_LABEL],
          eventMap,
          updaterMap,
          prevProps
        )
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.MARKER_WITH_LABEL].get("labelContent")
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var markerWithLabel = this.state[_constants.MARKER_WITH_LABEL]
        if (markerWithLabel) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(markerWithLabel, !!this.props.noRedraw)
          }
          if (markerWithLabel.get("labelContent")) {
            _reactDom2.default.unmountComponentAtNode(
              markerWithLabel.get("labelContent")
            )
          }
          markerWithLabel.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER_WITH_LABEL].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER_WITH_LABEL].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER_WITH_LABEL].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER_WITH_LABEL].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER_WITH_LABEL].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER_WITH_LABEL].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER_WITH_LABEL].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER_WITH_LABEL].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER_WITH_LABEL].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER_WITH_LABEL].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER_WITH_LABEL].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER_WITH_LABEL].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER_WITH_LABEL].getZIndex()
      },
    },
  ])
  return MarkerWithLabel
})(_react2.default.PureComponent))

MarkerWithLabel.propTypes = {
  /**
   * It will be `MarkerWithLabel#labelContent`.
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  children: _propTypes2.default.node,

  /**
   * For `MarkerWithLabel`
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelAnchor: _propTypes2.default.object,

  /**
   * For `MarkerWithLabel`
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelClass: _propTypes2.default.string,

  /**
   * For `MarkerWithLabel`. This is for native JS style object, so you may
   * expect some React shorthands for inline styles not working here.
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelStyle: _propTypes2.default.object,

  /**
   * For `MarkerWithLabel`
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelVisible: _propTypes2.default.bool,

  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
MarkerWithLabel.defaultProps = {
  labelVisible: true,
}
MarkerWithLabel.contextTypes = ((_MarkerWithLabel$cont = {}),
(0, _defineProperty3.default)(
  _MarkerWithLabel$cont,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _MarkerWithLabel$cont,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_MarkerWithLabel$cont)
exports.default = MarkerWithLabel

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  /**
   * For `MarkerWithLabel`
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelAnchor: function labelAnchor(instance, _labelAnchor) {
    instance.set("labelAnchor", _labelAnchor)
  },

  /**
   * For `MarkerWithLabel`
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelClass: function labelClass(instance, _labelClass) {
    instance.set("labelClass", _labelClass)
  },

  /**
   * For `MarkerWithLabel`
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelStyle: function labelStyle(instance, _labelStyle) {
    instance.set("labelStyle", _labelStyle)
  },

  /**
   * For `MarkerWithLabel`
   * @see https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerwithlabel/src/markerwithlabel.js
   */
  labelVisible: function labelVisible(instance, _labelVisible) {
    instance.set("labelVisible", _labelVisible)
  },
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 2286 */
/***/ (function(module, exports) {

/**
 * @name MarkerWithLabel for V3
 * @version 1.1.9 [June 30, 2013]
 * @author Gary Little (inspired by code from Marc Ridey of Google).
 * @copyright Copyright 2012 Gary Little [gary at luxcentral.com]
 * @fileoverview MarkerWithLabel extends the Google Maps JavaScript API V3
 *  <code>google.maps.Marker</code> class.
 *  <p>
 *  MarkerWithLabel allows you to define markers with associated labels. As you would expect,
 *  if the marker is draggable, so too will be the label. In addition, a marker with a label
 *  responds to all mouse events in the same manner as a regular marker. It also fires mouse
 *  events and "property changed" events just as a regular marker would. Version 1.1 adds
 *  support for the raiseOnDrag feature introduced in API V3.3.
 *  <p>
 *  If you drag a marker by its label, you can cancel the drag and return the marker to its
 *  original position by pressing the <code>Esc</code> key. This doesn't work if you drag the marker
 *  itself because this feature is not (yet) supported in the <code>google.maps.Marker</code> class.
 */

/*!
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*jslint browser:true */
/*global document,google */

/**
 * @param {Function} childCtor Child class.
 * @param {Function} parentCtor Parent class.
 */
function inherits(childCtor, parentCtor) {
  /** @constructor */
  function tempCtor() {};
  tempCtor.prototype = parentCtor.prototype;
  childCtor.superClass_ = parentCtor.prototype;
  childCtor.prototype = new tempCtor();
  /** @override */
  childCtor.prototype.constructor = childCtor;
}

/**
 * @param {Object} gMapsApi The Google Maps API instance (usually `google.maps`)
 * @return {Function} The instantiable MarkerWithLabel class
 */
module.exports = function(gMapsApi) {

  /**
   * This constructor creates a label and associates it with a marker.
   * It is for the private use of the MarkerWithLabel class.
   * @constructor
   * @param {Marker} marker The marker with which the label is to be associated.
   * @param {string} crossURL The URL of the cross image =.
   * @param {string} handCursor The URL of the hand cursor.
   * @private
   */
  function MarkerLabel_(marker, crossURL, handCursorURL) {
    this.marker_ = marker;
    this.handCursorURL_ = marker.handCursorURL;

    this.labelDiv_ = document.createElement("div");
    this.labelDiv_.style.cssText = "position: absolute; overflow: hidden;";

    // Set up the DIV for handling mouse events in the label. This DIV forms a transparent veil
    // in the "overlayMouseTarget" pane, a veil that covers just the label. This is done so that
    // events can be captured even if the label is in the shadow of a google.maps.InfoWindow.
    // Code is included here to ensure the veil is always exactly the same size as the label.
    this.eventDiv_ = document.createElement("div");
    this.eventDiv_.style.cssText = this.labelDiv_.style.cssText;

    // This is needed for proper behavior on MSIE:
    this.eventDiv_.addEventListener('selectstart', function() { return false; });
    this.eventDiv_.addEventListener('dragstart', function() { return false; });

    // Get the DIV for the "X" to be displayed when the marker is raised.
    this.crossDiv_ = MarkerLabel_.getSharedCross(crossURL);
  }
  inherits(MarkerLabel_, gMapsApi.OverlayView);

  /**
   * Returns the DIV for the cross used when dragging a marker when the
   * raiseOnDrag parameter set to true. One cross is shared with all markers.
   * @param {string} crossURL The URL of the cross image =.
   * @private
   */
  MarkerLabel_.getSharedCross = function (crossURL) {
    var div;
    if (typeof MarkerLabel_.getSharedCross.crossDiv === "undefined") {
      div = document.createElement("img");
      div.style.cssText = "position: absolute; z-index: 1000002; display: none;";
      // Hopefully Google never changes the standard "X" attributes:
      div.style.marginLeft = "-8px";
      div.style.marginTop = "-9px";
      div.src = crossURL;
      MarkerLabel_.getSharedCross.crossDiv = div;
    }
    return MarkerLabel_.getSharedCross.crossDiv;
  };

  /**
   * Adds the DIV representing the label to the DOM. This method is called
   * automatically when the marker's <code>setMap</code> method is called.
   * @private
   */
  MarkerLabel_.prototype.onAdd = function () {
    var me = this;
    var cMouseIsDown = false;
    var cDraggingLabel = false;
    var cSavedZIndex;
    var cLatOffset, cLngOffset;
    var cIgnoreClick;
    var cRaiseEnabled;
    var cStartPosition;
    var cStartCenter;
    // Constants:
    var cRaiseOffset = 20;
    var cDraggingCursor = "url(" + this.handCursorURL_ + ")";

    // Stops all processing of an event.
    //
    var cAbortEvent = function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
      e.cancelBubble = true;
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    };

    var cStopBounce = function () {
      me.marker_.setAnimation(null);
    };

    this.getPanes().markerLayer.appendChild(this.labelDiv_);
    this.getPanes().overlayMouseTarget.appendChild(this.eventDiv_);
    // One cross is shared with all markers, so only add it once:
    if (typeof MarkerLabel_.getSharedCross.processed === "undefined") {
      this.getPanes().markerLayer.appendChild(this.crossDiv_);
      MarkerLabel_.getSharedCross.processed = true;
    }

    this.listeners_ = [
      gMapsApi.event.addDomListener(this.eventDiv_, "mouseover", function (e) {
        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
          this.style.cursor = "pointer";
          gMapsApi.event.trigger(me.marker_, "mouseover", e);
        }
      }),
      gMapsApi.event.addDomListener(this.eventDiv_, "mouseout", function (e) {
        if ((me.marker_.getDraggable() || me.marker_.getClickable()) && !cDraggingLabel) {
          this.style.cursor = me.marker_.getCursor();
          gMapsApi.event.trigger(me.marker_, "mouseout", e);
        }
      }),
      gMapsApi.event.addDomListener(this.eventDiv_, "mousedown", function (e) {
        cDraggingLabel = false;
        if (me.marker_.getDraggable()) {
          cMouseIsDown = true;
          this.style.cursor = cDraggingCursor;
        }
        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
          gMapsApi.event.trigger(me.marker_, "mousedown", e);
          cAbortEvent(e); // Prevent map pan when starting a drag on a label
        }
      }),
      gMapsApi.event.addDomListener(document, "mouseup", function (mEvent) {
        var position;
        if (cMouseIsDown) {
          cMouseIsDown = false;
          me.eventDiv_.style.cursor = "pointer";
          gMapsApi.event.trigger(me.marker_, "mouseup", mEvent);
        }
        if (cDraggingLabel) {
          if (cRaiseEnabled) { // Lower the marker & label
            position = me.getProjection().fromLatLngToDivPixel(me.marker_.getPosition());
            position.y += cRaiseOffset;
            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
            // This is not the same bouncing style as when the marker portion is dragged,
            // but it will have to do:
            try { // Will fail if running Google Maps API earlier than V3.3
              me.marker_.setAnimation(gMapsApi.Animation.BOUNCE);
              setTimeout(cStopBounce, 1406);
            } catch (e) {}
          }
          me.crossDiv_.style.display = "none";
          me.marker_.setZIndex(cSavedZIndex);
          cIgnoreClick = true; // Set flag to ignore the click event reported after a label drag
          cDraggingLabel = false;
          mEvent.latLng = me.marker_.getPosition();
          gMapsApi.event.trigger(me.marker_, "dragend", mEvent);
        }
      }),
      gMapsApi.event.addListener(me.marker_.getMap(), "mousemove", function (mEvent) {
        var position;
        if (cMouseIsDown) {
          if (cDraggingLabel) {
            // Change the reported location from the mouse position to the marker position:
            mEvent.latLng = new gMapsApi.LatLng(mEvent.latLng.lat() - cLatOffset, mEvent.latLng.lng() - cLngOffset);
            position = me.getProjection().fromLatLngToDivPixel(mEvent.latLng);
            if (cRaiseEnabled) {
              me.crossDiv_.style.left = position.x + "px";
              me.crossDiv_.style.top = position.y + "px";
              me.crossDiv_.style.display = "";
              position.y -= cRaiseOffset;
            }
            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
            if (cRaiseEnabled) { // Don't raise the veil; this hack needed to make MSIE act properly
              me.eventDiv_.style.top = (position.y + cRaiseOffset) + "px";
            }
            gMapsApi.event.trigger(me.marker_, "drag", mEvent);
          } else {
            // Calculate offsets from the click point to the marker position:
            cLatOffset = mEvent.latLng.lat() - me.marker_.getPosition().lat();
            cLngOffset = mEvent.latLng.lng() - me.marker_.getPosition().lng();
            cSavedZIndex = me.marker_.getZIndex();
            cStartPosition = me.marker_.getPosition();
            cStartCenter = me.marker_.getMap().getCenter();
            cRaiseEnabled = me.marker_.get("raiseOnDrag");
            cDraggingLabel = true;
            me.marker_.setZIndex(1000000); // Moves the marker & label to the foreground during a drag
            mEvent.latLng = me.marker_.getPosition();
            gMapsApi.event.trigger(me.marker_, "dragstart", mEvent);
          }
        }
      }),
      gMapsApi.event.addDomListener(document, "keydown", function (e) {
        if (cDraggingLabel) {
          if (e.keyCode === 27) { // Esc key
            cRaiseEnabled = false;
            me.marker_.setPosition(cStartPosition);
            me.marker_.getMap().setCenter(cStartCenter);
            gMapsApi.event.trigger(document, "mouseup", e);
          }
        }
      }),
      gMapsApi.event.addDomListener(this.eventDiv_, "click", function (e) {
        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
          if (cIgnoreClick) { // Ignore the click reported when a label drag ends
            cIgnoreClick = false;
          } else {
            gMapsApi.event.trigger(me.marker_, "click", e);
            cAbortEvent(e); // Prevent click from being passed on to map
          }
        }
      }),
      gMapsApi.event.addDomListener(this.eventDiv_, "dblclick", function (e) {
        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
          gMapsApi.event.trigger(me.marker_, "dblclick", e);
          cAbortEvent(e); // Prevent map zoom when double-clicking on a label
        }
      }),
      gMapsApi.event.addListener(this.marker_, "dragstart", function (mEvent) {
        if (!cDraggingLabel) {
          cRaiseEnabled = this.get("raiseOnDrag");
        }
      }),
      gMapsApi.event.addListener(this.marker_, "drag", function (mEvent) {
        if (!cDraggingLabel) {
          if (cRaiseEnabled) {
            me.setPosition(cRaiseOffset);
            // During a drag, the marker's z-index is temporarily set to 1000000 to
            // ensure it appears above all other markers. Also set the label's z-index
            // to 1000000 (plus or minus 1 depending on whether the label is supposed
            // to be above or below the marker).
            me.labelDiv_.style.zIndex = 1000000 + (this.get("labelInBackground") ? -1 : +1);
          }
        }
      }),
      gMapsApi.event.addListener(this.marker_, "dragend", function (mEvent) {
        if (!cDraggingLabel) {
          if (cRaiseEnabled) {
            me.setPosition(0); // Also restores z-index of label
          }
        }
      }),
      gMapsApi.event.addListener(this.marker_, "position_changed", function () {
        me.setPosition();
      }),
      gMapsApi.event.addListener(this.marker_, "zindex_changed", function () {
        me.setZIndex();
      }),
      gMapsApi.event.addListener(this.marker_, "visible_changed", function () {
        me.setVisible();
      }),
      gMapsApi.event.addListener(this.marker_, "labelvisible_changed", function () {
        me.setVisible();
      }),
      gMapsApi.event.addListener(this.marker_, "title_changed", function () {
        me.setTitle();
      }),
      gMapsApi.event.addListener(this.marker_, "labelcontent_changed", function () {
        me.setContent();
      }),
      gMapsApi.event.addListener(this.marker_, "labelanchor_changed", function () {
        me.setAnchor();
      }),
      gMapsApi.event.addListener(this.marker_, "labelclass_changed", function () {
        me.setStyles();
      }),
      gMapsApi.event.addListener(this.marker_, "labelstyle_changed", function () {
        me.setStyles();
      })
    ];
  };

  /**
   * Removes the DIV for the label from the DOM. It also removes all event handlers.
   * This method is called automatically when the marker's <code>setMap(null)</code>
   * method is called.
   * @private
   */
  MarkerLabel_.prototype.onRemove = function () {
    var i;
    if (this.labelDiv_.parentNode) {
      this.labelDiv_.parentNode.removeChild(this.labelDiv_);
      this.eventDiv_.parentNode.removeChild(this.eventDiv_);
    }
    
    // Remove event listeners:
    if (this.listeners_) {
      for (i = 0; i < this.listeners_.length; i++) {
        gMapsApi.event.removeListener(this.listeners_[i]);
      }
    }
  };

  /**
   * Draws the label on the map.
   * @private
   */
  MarkerLabel_.prototype.draw = function () {
    this.setContent();
    this.setTitle();
    this.setStyles();
  };

  /**
   * Sets the content of the label.
   * The content can be plain text or an HTML DOM node.
   * @private
   */
  MarkerLabel_.prototype.setContent = function () {
    var content = this.marker_.get("labelContent");
    if (typeof content.nodeType === "undefined") {
      this.labelDiv_.innerHTML = content;
      this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
    } else {
      // Remove current content
      while (this.labelDiv_.lastChild) {
        this.labelDiv_.removeChild(this.labelDiv_.lastChild);
      }

      while (this.eventDiv_.lastChild) {
        this.eventDiv_.removeChild(this.eventDiv_.lastChild);
      }

      this.labelDiv_.appendChild(content);
      content = content.cloneNode(true);
      this.eventDiv_.appendChild(content);
    }
  };

  /**
   * Sets the content of the tool tip for the label. It is
   * always set to be the same as for the marker itself.
   * @private
   */
  MarkerLabel_.prototype.setTitle = function () {
    this.eventDiv_.title = this.marker_.getTitle() || "";
  };

  /**
   * Sets the style of the label by setting the style sheet and applying
   * other specific styles requested.
   * @private
   */
  MarkerLabel_.prototype.setStyles = function () {
    var i, labelStyle;

    // Apply style values from the style sheet defined in the labelClass parameter:
    this.labelDiv_.className = this.marker_.get("labelClass");
    this.eventDiv_.className = this.labelDiv_.className;

    // Clear existing inline style values:
    this.labelDiv_.style.cssText = "";
    this.eventDiv_.style.cssText = "";
    // Apply style values defined in the labelStyle parameter:
    labelStyle = this.marker_.get("labelStyle");
    for (i in labelStyle) {
      if (labelStyle.hasOwnProperty(i)) {
        this.labelDiv_.style[i] = labelStyle[i];
        this.eventDiv_.style[i] = labelStyle[i];
      }
    }
    this.setMandatoryStyles();
  };

  /**
   * Sets the mandatory styles to the DIV representing the label as well as to the
   * associated event DIV. This includes setting the DIV position, z-index, and visibility.
   * @private
   */
  MarkerLabel_.prototype.setMandatoryStyles = function () {
    this.labelDiv_.style.position = "absolute";
    this.labelDiv_.style.overflow = "hidden";
    // Make sure the opacity setting causes the desired effect on MSIE:
    if (typeof this.labelDiv_.style.opacity !== "undefined" && this.labelDiv_.style.opacity !== "") {
      this.labelDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")\"";
      this.labelDiv_.style.filter = "alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")";
    }

    this.eventDiv_.style.position = this.labelDiv_.style.position;
    this.eventDiv_.style.overflow = this.labelDiv_.style.overflow;
    this.eventDiv_.style.opacity = 0.01; // Don't use 0; DIV won't be clickable on MSIE
    this.eventDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=1)\"";
    this.eventDiv_.style.filter = "alpha(opacity=1)"; // For MSIE

    this.setAnchor();
    this.setPosition(); // This also updates z-index, if necessary.
    this.setVisible();
  };

  /**
   * Sets the anchor point of the label.
   * @private
   */
  MarkerLabel_.prototype.setAnchor = function () {
    var anchor = this.marker_.get("labelAnchor");
    this.labelDiv_.style.marginLeft = -anchor.x + "px";
    this.labelDiv_.style.marginTop = -anchor.y + "px";
    this.eventDiv_.style.marginLeft = -anchor.x + "px";
    this.eventDiv_.style.marginTop = -anchor.y + "px";
  };

  /**
   * Sets the position of the label. The z-index is also updated, if necessary.
   * @private
   */
  MarkerLabel_.prototype.setPosition = function (yOffset) {
    var position = this.getProjection().fromLatLngToDivPixel(this.marker_.getPosition());
    if (typeof yOffset === "undefined") {
      yOffset = 0;
    }
    this.labelDiv_.style.left = Math.round(position.x) + "px";
    this.labelDiv_.style.top = Math.round(position.y - yOffset) + "px";
    this.eventDiv_.style.left = this.labelDiv_.style.left;
    this.eventDiv_.style.top = this.labelDiv_.style.top;

    this.setZIndex();
  };

  /**
   * Sets the z-index of the label. If the marker's z-index property has not been defined, the z-index
   * of the label is set to the vertical coordinate of the label. This is in keeping with the default
   * stacking order for Google Maps: markers to the south are in front of markers to the north.
   * @private
   */
  MarkerLabel_.prototype.setZIndex = function () {
    var zAdjust = (this.marker_.get("labelInBackground") ? -1 : +1);
    if (typeof this.marker_.getZIndex() === "undefined") {
      this.labelDiv_.style.zIndex = parseInt(this.labelDiv_.style.top, 10) + zAdjust;
      this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
    } else {
      this.labelDiv_.style.zIndex = this.marker_.getZIndex() + zAdjust;
      this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
    }
  };

  /**
   * Sets the visibility of the label. The label is visible only if the marker itself is
   * visible (i.e., its visible property is true) and the labelVisible property is true.
   * @private
   */
  MarkerLabel_.prototype.setVisible = function () {
    if (this.marker_.get("labelVisible")) {
      this.labelDiv_.style.display = this.marker_.getVisible() ? "block" : "none";
    } else {
      this.labelDiv_.style.display = "none";
    }
    this.eventDiv_.style.display = this.labelDiv_.style.display;
  };

  /**
   * @name MarkerWithLabelOptions
   * @class This class represents the optional parameter passed to the {@link MarkerWithLabel} constructor.
   *  The properties available are the same as for <code>google.maps.Marker</code> with the addition
   *  of the properties listed below. To change any of these additional properties after the labeled
   *  marker has been created, call <code>google.maps.Marker.set(propertyName, propertyValue)</code>.
   *  <p>
   *  When any of these properties changes, a property changed event is fired. The names of these
   *  events are derived from the name of the property and are of the form <code>propertyname_changed</code>.
   *  For example, if the content of the label changes, a <code>labelcontent_changed</code> event
   *  is fired.
   *  <p>
   * @property {string|Node} [labelContent] The content of the label (plain text or an HTML DOM node).
   * @property {Point} [labelAnchor] By default, a label is drawn with its anchor point at (0,0) so
   *  that its top left corner is positioned at the anchor point of the associated marker. Use this
   *  property to change the anchor point of the label. For example, to center a 50px-wide label
   *  beneath a marker, specify a <code>labelAnchor</code> of <code>google.maps.Point(25, 0)</code>.
   *  (Note: x-values increase to the right and y-values increase to the top.)
   * @property {string} [labelClass] The name of the CSS class defining the styles for the label.
   *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
   *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
   *  <code>marginTop</code> are ignored; these styles are for internal use only.
   * @property {Object} [labelStyle] An object literal whose properties define specific CSS
   *  style values to be applied to the label. Style values defined here override those that may
   *  be defined in the <code>labelClass</code> style sheet. If this property is changed after the
   *  label has been created, all previously set styles (except those defined in the style sheet)
   *  are removed from the label before the new style values are applied.
   *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
   *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
   *  <code>marginTop</code> are ignored; these styles are for internal use only.
   * @property {boolean} [labelInBackground] A flag indicating whether a label that overlaps its
   *  associated marker should appear in the background (i.e., in a plane below the marker).
   *  The default is <code>false</code>, which causes the label to appear in the foreground.
   * @property {boolean} [labelVisible] A flag indicating whether the label is to be visible.
   *  The default is <code>true</code>. Note that even if <code>labelVisible</code> is
   *  <code>true</code>, the label will <i>not</i> be visible unless the associated marker is also
   *  visible (i.e., unless the marker's <code>visible</code> property is <code>true</code>).
   * @property {boolean} [raiseOnDrag] A flag indicating whether the label and marker are to be
   *  raised when the marker is dragged. The default is <code>true</code>. If a draggable marker is
   *  being created and a version of Google Maps API earlier than V3.3 is being used, this property
   *  must be set to <code>false</code>.
   * @property {boolean} [optimized] A flag indicating whether rendering is to be optimized for the
   *  marker. <b>Important: The optimized rendering technique is not supported by MarkerWithLabel,
   *  so the value of this parameter is always forced to <code>false</code>.
   * @property {string} [crossImage="http://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png"]
   *  The URL of the cross image to be displayed while dragging a marker.
   * @property {string} [handCursor="http://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur"]
   *  The URL of the cursor to be displayed while dragging a marker.
   */
  /**
   * Creates a MarkerWithLabel with the options specified in {@link MarkerWithLabelOptions}.
   * @constructor
   * @param {MarkerWithLabelOptions} [opt_options] The optional parameters.
   */
  function MarkerWithLabel(opt_options) {
    opt_options = opt_options || {};
    opt_options.labelContent = opt_options.labelContent || "";
    opt_options.labelAnchor = opt_options.labelAnchor || new gMapsApi.Point(0, 0);
    opt_options.labelClass = opt_options.labelClass || "markerLabels";
    opt_options.labelStyle = opt_options.labelStyle || {};
    opt_options.labelInBackground = opt_options.labelInBackground || false;
    if (typeof opt_options.labelVisible === "undefined") {
      opt_options.labelVisible = true;
    }
    if (typeof opt_options.raiseOnDrag === "undefined") {
      opt_options.raiseOnDrag = true;
    }
    if (typeof opt_options.clickable === "undefined") {
      opt_options.clickable = true;
    }
    if (typeof opt_options.draggable === "undefined") {
      opt_options.draggable = false;
    }
    if (typeof opt_options.optimized === "undefined") {
      opt_options.optimized = false;
    }
    opt_options.crossImage = opt_options.crossImage || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png";
    opt_options.handCursor = opt_options.handCursor || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur";
    opt_options.optimized = false; // Optimized rendering is not supported

    this.label = new MarkerLabel_(this, opt_options.crossImage, opt_options.handCursor); // Bind the label to the marker

    // Call the parent constructor. It calls Marker.setValues to initialize, so all
    // the new parameters are conveniently saved and can be accessed with get/set.
    // Marker.set triggers a property changed event (called "propertyname_changed")
    // that the marker label listens for in order to react to state changes.
    gMapsApi.Marker.apply(this, arguments);
  }
  inherits(MarkerWithLabel, gMapsApi.Marker);

  /**
   * Overrides the standard Marker setMap function.
   * @param {Map} theMap The map to which the marker is to be added.
   * @private
   */
  MarkerWithLabel.prototype.setMap = function (theMap) {

    // Call the inherited function...
    gMapsApi.Marker.prototype.setMap.apply(this, arguments);

    // ... then deal with the label:
    this.label.setMap(theMap);
  };

  return MarkerWithLabel;
}


/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_done__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_done__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PortAddForm__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AreaAutoAssignmentConfirmModal__ = __webpack_require__(2297);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

















var styles = {
    btn: {
        labelStyle: {
            color: '#fff', textTransform: 'none', fontSize: '13px'
        },
        style: {
            margin: '20px 0'
        }
    }
};

/** @type {import('react').FC<any>} */
var PortAdd = function PortAdd(_ref) {
    var clearPort = _ref.clearPort,
        addNewPort = _ref.addNewPort,
        submit = _ref.submit,
        router = _ref.router,
        port = _ref.port;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        values = _useState2[0],
        setValues = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        areaAssignmentConfirmShown = _useState4[0],
        setAreaAssignmentConfirmShown = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        return function () {
            // unmount handler
            clearPort();
        };
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        // A new ID appear in the store when a port is created
        if (port._id) {
            router.push('/regions/ports/' + port._id);
        }
    }, [port._id]);

    var handleSubmit = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function (values, dispatch, props) {
        setValues(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(values));
        setAreaAssignmentConfirmShown(true);
    }, []);

    var asyncValidate = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, dispatch, props) {
            var response;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (values.unLoCode) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].findPortAdmin({ name: values.unLoCode });

                        case 4:
                            response = _context.sent;

                            if (!(response.status !== 200 || response.data.data.length === 0)) {
                                _context.next = 7;
                                break;
                            }

                            return _context.abrupt('return');

                        case 7:
                            if (!(response.data.data[0].unLoCode === values.unLoCode)) {
                                _context.next = 9;
                                break;
                            }

                            throw { unLoCode: 'unLoCode has been already created into ' + response.data.data[0].name + '. link - ' + location.origin + '/regions/ports/' + response.data.data[0]._id };

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2, _x3) {
            return _ref2.apply(this, arguments);
        };
    }(), []);

    var closeAreaAssignmentConfirm = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function (parents) {
        setAreaAssignmentConfirmShown(false);
        addNewPort(_extends({}, values, {
            country: values.country._id,
            parents: parents
        }));
    }, [values]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container', id: 'single-port' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'management' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                    label: 'Back to list',
                    style: styles.btn.style,
                    labelStyle: styles.btn.labelStyle,
                    labelPosition: 'before',
                    icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_hardware_keyboard_arrow_left___default.a, null),
                    containerElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* Link */], { to: '/regions/ports' }),
                    primary: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'btn' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                    label: 'Create port',
                    style: styles.btn.style,
                    labelStyle: styles.btn.labelStyle,
                    labelPosition: 'before',
                    icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_done___default.a, null),
                    backgroundColor: '#a4c639',
                    onClick: function onClick() {
                        return submit('port-create');
                    }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PortAddForm__["a" /* default */], {
                onSubmit: handleSubmit,
                asyncValidate: asyncValidate
            })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AreaAutoAssignmentConfirmModal__["a" /* default */], {
            shown: areaAssignmentConfirmShown,
            onClose: closeAreaAssignmentConfirm
        })
    );
};

PortAdd.displayName = 'PortAdd';

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(
/** @param {any} param0 */
function (_ref3) {
    var port = _ref3.port;
    return {
        port: port
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        submit: __WEBPACK_IMPORTED_MODULE_5_redux_form__["h" /* submit */],
        clearPort: __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__["c" /* clearPort */],
        addNewPort: __WEBPACK_IMPORTED_MODULE_9_actions_regions_ports__["a" /* addNewPort */]
    }, dispatch);
})(PortAdd);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Page.jsx');
    reactHotLoader.register(PortAdd, 'PortAdd', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_data_gmt__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Coordinates__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ServiceProviders__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PortRestrictions__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Facilities__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Warehouses__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LiftAndCranes_List__ = __webpack_require__(2294);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





















var styles = {
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    },
    btn: {
        addServiceProvider: {
            style: {
                margin: '20px 0 70px 0'
            }
        },
        labelStyle: {
            color: '#fff', textTransform: 'none', fontSize: '13px'
        },
        style: {
            margin: '20px 0'
        }
    }
};

/**
 * @typedef {{
 *  handleSubmit: () => void,
 *  change: (name: string, value: any) => void,
 *  countries: any[],
 *  getCountries: () => void;
 *  customWarning: string | null;
 * }} Props
 * @type {import('react').FC<Props>}
 */
var PortAddForm = function PortAddForm(_ref) {
    var handleSubmit = _ref.handleSubmit,
        change = _ref.change,
        countries = _ref.countries,
        getCountries = _ref.getCountries,
        customWarning = _ref.customWarning;

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getCountries();
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        { autoComplete: 'off', className: 'main add-port', onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'main__title' },
            'Coordinates'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Coordinates__["a" /* default */], { change: change }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'main__title' },
            'Main info'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                    component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                    name: 'name',
                    validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["length"])({ min: 3 })],
                    floatingLabelText: 'Name',
                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                    fullWidth: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],
                    {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["SelectField"],
                        name: 'country._id',
                        floatingLabelText: 'Country',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        autoWidth: true,
                        fullWidth: true,
                        validate: Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["required"])(),
                        onChange: function onChange(e, value) {
                            e.preventDefault();

                            change('country', countries.find(function (country) {
                                return country._id === value;
                            }));
                        }
                    },
                    countries.map(function (country, key) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], {
                            key: key,
                            value: country._id,
                            primaryText: country.name
                        });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                    component: CustomTextField,
                    name: 'unLoCode',
                    validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["length"])({ max: 5, min: 5, allowBlank: true })],
                    floatingLabelText: 'UN LOCODE',
                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                    fullWidth: true,
                    customWarning: customWarning,
                    normalize: function normalize(value) {
                        return value ? value.toUpperCase() : '';
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],
                    {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["SelectField"],
                        name: 'timezone',
                        floatingLabelText: 'timezone',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        fullWidth: true
                    },
                    __WEBPACK_IMPORTED_MODULE_7_data_gmt__["a" /* default */].map(function (gmt, key) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], {
                            key: key,
                            value: gmt,
                            primaryText: gmt
                        });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                    component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                    name: 'site',
                    floatingLabelText: 'Web site',
                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                    fullWidth: true,
                    validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["length"])({ min: 8, allowBlank: true })]
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'main__title' },
            'SERVICE PROVIDERS'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* FieldArray */], {
                name: 'serviceProviders',
                component: __WEBPACK_IMPORTED_MODULE_12__ServiceProviders__["a" /* default */],
                styles: styles
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PortRestrictions__["a" /* default */], { styles: styles })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__LiftAndCranes_List__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Facilities__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Warehouses__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'main__title' },
                'other'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
                        name: 'additionalDescription',
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                        floatingLabelText: 'Other',
                        multiLine: true,
                        fullWidth: true,
                        floatingLabelStyle: styles.textField.floatingLabelStyle
                    })
                )
            )
        )
    );
};

var CustomTextField = function CustomTextField(_ref2) {
    var input = _ref2.input,
        label = _ref2.label,
        _ref2$meta = _ref2.meta,
        touched = _ref2$meta.touched,
        error = _ref2$meta.error,
        customWarning = _ref2.customWarning,
        custom = _objectWithoutProperties(_ref2, ['input', 'label', 'meta', 'customWarning']);

    var hasError = touched && error;
    var hasWarning = !!customWarning;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"], _extends({}, input, custom, {
            errorText: hasError ? error : hasWarning ? customWarning : null,
            errorStyle: hasWarning && !hasError ? { color: 'orange' } : { color: 'red' }
        }))
    );
};

PortAddForm.displayName = 'PortAddForm';

var PortAddReduxForm = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_8_data_formNames__["a" /* formName */].portCreate,
    enableReinitialize: true,
    asyncBlurFields: ['unLoCode']
})( /** @type {any} */PortAddForm); // TODO: @types/redux-form should fix this

var selector = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_8_data_formNames__["a" /* formName */].portCreate);

var getUnLoCodeWarning = function getUnLoCodeWarning(country, unLoCode) {
    var shortNameCode = country ? country.shortNameCode : null;

    if (shortNameCode && unLoCode && !unLoCode.startsWith(shortNameCode)) {
        return 'UN LOCODE should start with country code: ' + shortNameCode;
    }
    return null;
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(
/** @param {any} state */
function (state) {
    var port = state.port,
        countries = state.countries;


    var country = selector(state, 'country');
    var unLoCode = selector(state, 'unLoCode');

    var customWarning = getUnLoCodeWarning(country, unLoCode);

    return {
        countries: countries.items,
        initialValues: _extends({}, port),
        customWarning: customWarning
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({
        getCountries: __WEBPACK_IMPORTED_MODULE_9_actions_countries__["a" /* getCountries */]
    }, dispatch);
})(PortAddReduxForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortAddForm.jsx');
    reactHotLoader.register(PortAddForm, 'PortAddForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortAddForm.jsx');
    reactHotLoader.register(CustomTextField, 'CustomTextField', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortAddForm.jsx');
    reactHotLoader.register(PortAddReduxForm, 'PortAddReduxForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortAddForm.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortAddForm.jsx');
    reactHotLoader.register(getUnLoCodeWarning, 'getUnLoCodeWarning', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortAddForm.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortAddForm.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MapComponent__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var styles = {
    textField: {
        floatingLabelStyle: {
            fontSize: '12px'
        }
    },
    icon: {
        color: 'rgb(0, 188, 212)'
    }
};

var Coordinates = function (_React$Component) {
    _inherits(Coordinates, _React$Component);

    function Coordinates(props) {
        _classCallCheck(this, Coordinates);

        return _possibleConstructorReturn(this, (Coordinates.__proto__ || Object.getPrototypeOf(Coordinates)).call(this, props));
    }

    _createClass(Coordinates, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                coordinates = _props.coordinates,
                change = _props.change;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], {
                            component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                            name: 'coordinates[1]',
                            floatingLabelText: 'Latitude',
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            fullWidth: true,
                            validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ '<=': 90, '>=': -90 })]
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], {
                            component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                            name: 'coordinates[0]',
                            floatingLabelText: 'Longitute',
                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                            validate: [Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_10_redux_form_validators__["numericality"])({ '<=': 180, '>=': -180 })],
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-8' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MapComponent__["a" /* default */], {
                            coordinates: coordinates,
                            change: change,
                            googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_8_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
                            loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                            containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '100%', height: '300px' } }),
                            mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } })
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Coordinates;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Coordinates.propTypes = {};

Coordinates.defaultProps = {};

var selector = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_7_data_formNames__["a" /* formName */].portCreate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        coordinates: selector(state, 'coordinates')
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(Coordinates);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Coordinates.jsx');
    reactHotLoader.register(Coordinates, 'Coordinates', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Coordinates.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Coordinates.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Coordinates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_add__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_data_portActivities__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Port_ServiceProviders_Emails__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Port_ServiceProviders_Phones__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var emptyLimitation = {
    maxDraught: undefined,
    maxBeam: undefined,
    maxLOA: undefined,
    maxDWT: undefined,
    channelDepth: undefined,
    berth: undefined
};

var emptyServiceProvider = {
    activities: [],
    name: undefined,
    address: undefined,
    PIC: undefined,
    emails: [undefined],
    phones: [{
        phone: undefined,
        code: undefined
    }],
    limitations: [emptyLimitation]
};

var ServiceProviders = function (_React$Component) {
    _inherits(ServiceProviders, _React$Component);

    function ServiceProviders(props) {
        _classCallCheck(this, ServiceProviders);

        var _this = _possibleConstructorReturn(this, (ServiceProviders.__proto__ || Object.getPrototypeOf(ServiceProviders)).call(this, props));

        _this.addPortLimitation = function (providerIndex) {
            var serviceProvidersCopy = __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(_this.props.serviceProviders);

            serviceProvidersCopy[providerIndex].limitations.push(emptyLimitation);

            _this.props.changePort({
                serviceProviders: serviceProvidersCopy
            });
        };

        _this.removePortLimitation = function (providerIndex, limitationIndex) {
            var serviceProvidersCopy = __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.cloneDeep(_this.props.serviceProviders);

            serviceProvidersCopy[providerIndex].limitations = serviceProvidersCopy[providerIndex].limitations.splice(limitationIndex, 1);

            _this.props.changePort({
                serviceProviders: serviceProvidersCopy
            });
        };

        _this.removeServiceProvider = _this.removeServiceProvider.bind(_this);
        _this.addServiceProvider = _this.addServiceProvider.bind(_this);
        return _this;
    }

    _createClass(ServiceProviders, [{
        key: 'removeServiceProvider',
        value: function removeServiceProvider(index) {
            var fields = this.props.fields;

            fields.remove(index);
        }
    }, {
        key: 'addServiceProvider',
        value: function addServiceProvider() {
            var fields = this.props.fields;


            fields.push(emptyServiceProvider);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                fields = _props.fields,
                serviceProviders = _props.serviceProviders,
                styles = _props.styles;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                fields.map(function (field, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: 'serviceProvider_' + index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'paper-block' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["r" /* RaisedButton */], {
                                label: 'Remove Service Provider',
                                labelStyle: styles.btn.labelStyle,
                                style: styles.btn.style,
                                labelPosition: 'before',
                                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete___default.a, null),
                                secondary: true,
                                onClick: function onClick() {
                                    _this2.removeServiceProvider(index);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],
                                        {
                                            component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["SelectField"],
                                            name: field + '.activities',
                                            multiple: true,
                                            floatingLabelText: 'Activities',
                                            floatingLabelStyle: styles.textField.floatingLabelStyle,
                                            fullWidth: true,
                                            autoWidth: true,
                                            value: serviceProviders[index].activities,
                                            validate: Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["required"])()
                                        },
                                        __WEBPACK_IMPORTED_MODULE_12_data_portActivities__["a" /* default */].map(function (portActivity, index) {
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["m" /* MenuItem */], {
                                                key: index,
                                                value: portActivity,
                                                primaryText: portActivity
                                            });
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                                        name: field + '.name',
                                        floatingLabelText: 'Company name',
                                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                                        fullWidth: true,
                                        validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["length"])({ min: 3, max: 266 })]
                                    })
                                )
                            ),
                            serviceProviders[index].activities && serviceProviders[index].activities.includes('Stevedoring Company') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* FieldArray */], {
                                name: field + '.limitations',
                                component: renderLimitations,
                                styles: styles
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* FieldArray */], {
                                        name: field + '.emails',
                                        component: __WEBPACK_IMPORTED_MODULE_13__Port_ServiceProviders_Emails__["a" /* default */]
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* FieldArray */], {
                                        name: field + '.phones',
                                        component: __WEBPACK_IMPORTED_MODULE_14__Port_ServiceProviders_Phones__["a" /* default */]
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                                        name: field + '.address',
                                        floatingLabelText: 'Address',
                                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                                        fullWidth: true,
                                        validate: Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["required"])()
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                                        name: field + '.PIC',
                                        floatingLabelText: 'PIC',
                                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                                        fullWidth: true,
                                        validate: Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["required"])()
                                    })
                                )
                            )
                        )
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["r" /* RaisedButton */], {
                    label: 'Add Service Provider',
                    labelStyle: styles.btn.labelStyle,
                    style: styles.btn.addServiceProvider.style,
                    labelPosition: 'before',
                    icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_add___default.a, null),
                    primary: true,
                    onClick: this.addServiceProvider
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ServiceProviders;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

function renderLimitations(_ref) {
    var fields = _ref.fields,
        styles = _ref.styles;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        fields.map(function (field, limitationIndex) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'row'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                        name: field + '.berth',
                        floatingLabelText: 'Berth',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%' }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                        name: field + '.maxDraught',
                        floatingLabelText: 'Max draft, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                        name: field + '.maxBeam',
                        floatingLabelText: 'Max beam, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                        name: field + '.maxLOA',
                        floatingLabelText: 'Max LOA, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                        name: field + '.maxDWT',
                        floatingLabelText: 'Max DWT, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000000, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                        component: __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],
                        name: field + '.channelDepth',
                        floatingLabelText: 'Channel Depth, m:',
                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                        style: { width: '14%', marginLeft: '10px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_5_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'center-xs', style: { display: 'inline-flex', width: '11%' } },
                        limitationIndex === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["h" /* IconButton */],
                            {
                                iconStyle: styles.icon,
                                onClick: function onClick() {
                                    return fields.push(emptyLimitation);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_image_control_point___default.a, null)
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["h" /* IconButton */],
                            {
                                iconStyle: styles.icon,
                                onClick: function onClick() {
                                    return fields.remove(limitationIndex);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                        )
                    )
                )
            );
        })
    );
}

ServiceProviders.propTypes = {};

ServiceProviders.defaultProps = {};

var selector = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_15__data_formNames__["a" /* formName */].portCreate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        serviceProviders: selector(state, 'serviceProviders')
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_11_actions_regions_ports__["b" /* changePort */],
        change: __WEBPACK_IMPORTED_MODULE_4_redux_form__["d" /* change */]
    }, dispatch);
})(ServiceProviders);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(emptyLimitation, 'emptyLimitation', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/ServiceProviders.jsx');
    reactHotLoader.register(emptyServiceProvider, 'emptyServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/ServiceProviders.jsx');
    reactHotLoader.register(ServiceProviders, 'ServiceProviders', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/ServiceProviders.jsx');
    reactHotLoader.register(renderLimitations, 'renderLimitations', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/ServiceProviders.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/ServiceProviders.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/ServiceProviders.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PortRestrictions = function (_React$Component) {
    _inherits(PortRestrictions, _React$Component);

    function PortRestrictions(props) {
        _classCallCheck(this, PortRestrictions);

        return _possibleConstructorReturn(this, (PortRestrictions.__proto__ || Object.getPrototypeOf(PortRestrictions)).call(this, props));
    }

    _createClass(PortRestrictions, [{
        key: 'render',
        value: function render() {
            var styles = this.props.styles;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'main__title' },
                    'PORT Restrictions'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'port-restrictions' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'list' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'portLimitations.maxDraught',
                                floatingLabelText: 'Max Draft, m:',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'portLimitations.maxBeam',
                                floatingLabelText: 'Max Beam, m:',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'portLimitations.maxLOA',
                                floatingLabelText: 'Max LOA, m:',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000, allowBlank: true })],
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'portLimitations.maxDWT',
                                floatingLabelText: 'Max DWT, mt:',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["numericality"])({ '>=': 0, '<=': 1000000, allowBlank: true })],
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'portLimitations.channelDepth',
                                floatingLabelText: 'Channel Depth, m:',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'portLimitations.anchorageDepth',
                                floatingLabelText: 'Anchorage Depth, m:',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'portLimitations.meanTide',
                                floatingLabelText: 'Mean Tide, m:',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["numericality"])({ '>=': 0, '<=': 100, allowBlank: true })],
                                fullWidth: true
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PortRestrictions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortRestrictions.propTypes = {};

PortRestrictions.defaultProps = {};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref) {
    var styles = _ref.styles;
    return {
        styles: styles
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_6_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(PortRestrictions);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortRestrictions, 'PortRestrictions', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortRestrictions.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/PortRestrictions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = {
    checkbox: {
        labelStyle: { fontSize: '14px', color: '#333' }
    }
};

var Facilities = function (_React$Component) {
    _inherits(Facilities, _React$Component);

    function Facilities() {
        _classCallCheck(this, Facilities);

        return _possibleConstructorReturn(this, (Facilities.__proto__ || Object.getPrototypeOf(Facilities)).apply(this, arguments));
    }

    _createClass(Facilities, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'main__title' },
                    'facilities'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'facilities' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row divided' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4 border-bottom' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.breakBulk',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Break Bulk',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.dryDock',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Dry Dock',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.roro',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Ro-Ro',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.container',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Container',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.lpg',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'LPG',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.lng',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'LNG',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.liquid',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Liquid',
                                labelStyle: styles.checkbox.labelStyle
                            }),
                            '  '
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.multipurpose',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Multipurpose',
                                labelStyle: styles.checkbox.labelStyle
                            }),
                            '  '
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.passenger',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Passenger',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.dryBulk',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Dry Bulk',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.bunkering',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Bunkering',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.steel',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Steel',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.shipyard',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Shipyard',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'facilities.reefer',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Reefer',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Facilities;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Facilities.propTypes = {};

Facilities.defaultProps = {};

var _default = Facilities;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Facilities.jsx');
    reactHotLoader.register(Facilities, 'Facilities', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Facilities.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Facilities.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = {
    checkbox: {
        labelStyle: { fontSize: '14px', color: '#333' }
    }
};

var Warehouses = function (_React$Component) {
    _inherits(Warehouses, _React$Component);

    function Warehouses() {
        _classCallCheck(this, Warehouses);

        return _possibleConstructorReturn(this, (Warehouses.__proto__ || Object.getPrototypeOf(Warehouses)).apply(this, arguments));
    }

    _createClass(Warehouses, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'warehouses' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row divided' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3', style: styles.checkbox.labelStyle },
                            'WAREHOUSES'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row divided' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.timber',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Timber',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.grain',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Grain',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.lpg',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'LPG',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.chemicals',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Chemicals',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row divided' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.dryBulk',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Dry bulk (ore, coal, etc)',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.liquid',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Liquid',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.general',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'General cargo',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-3' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                                name: 'warehouses.reefer',
                                component: __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["Checkbox"],
                                label: 'Reefer cargo',
                                labelStyle: styles.checkbox.labelStyle
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Warehouses;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Warehouses.propTypes = {};

Warehouses.defaultProps = {};

var _default = Warehouses;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Warehouses.jsx');
    reactHotLoader.register(Warehouses, 'Warehouses', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Warehouses.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/Warehouses.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(40);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LiftAndCranesList = function (_React$Component) {
    _inherits(LiftAndCranesList, _React$Component);

    function LiftAndCranesList() {
        _classCallCheck(this, LiftAndCranesList);

        return _possibleConstructorReturn(this, (LiftAndCranesList.__proto__ || Object.getPrototypeOf(LiftAndCranesList)).apply(this, arguments));
    }

    _createClass(LiftAndCranesList, [{
        key: 'render',
        value: function render() {
            var items = [];
            var liftsCranes = this.props.liftsCranes;


            for (var key in liftsCranes) {
                items.push(liftsCranes[key]);
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'main__title' },
                    'Available Lift and Cranes'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'lift-and-cranes' },
                    items.map(function (liftCrane, key) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */], {
                            key: key,
                            liftCrane: liftCrane,
                            liftsCranes: liftsCranes
                        });
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LiftAndCranesList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LiftAndCranesList.propTypes = {};

LiftAndCranesList.defaultProps = {};

var selector = Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_5_data_formNames__["a" /* formName */].portCreate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        liftsCranes: selector(state, 'liftsCranes')
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(LiftAndCranesList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LiftAndCranesList, 'LiftAndCranesList', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/List.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_down__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_hardware_keyboard_arrow_up__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_hardware_keyboard_arrow_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_hardware_keyboard_arrow_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Details__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__ = __webpack_require__(53);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var styles = {
    checkbox: {
        labelStyle: { fontSize: '14px' },
        style: { width: '90%' }
    },
    icon: {
        iconStyle: { color: '#00bcd4' }
    }
};

var LiftAndCranesItem = function (_React$Component) {
    _inherits(LiftAndCranesItem, _React$Component);

    function LiftAndCranesItem(props) {
        _classCallCheck(this, LiftAndCranesItem);

        return _possibleConstructorReturn(this, (LiftAndCranesItem.__proto__ || Object.getPrototypeOf(LiftAndCranesItem)).call(this, props));
    }

    _createClass(LiftAndCranesItem, [{
        key: 'render',
        value: function render() {
            var liftCrane = this.props.liftCrane;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'line-head' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12 middle-xs' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_9_redux_form_material_ui__["Checkbox"],
                                name: 'liftsCranes.' + liftCrane.name + '.checked',
                                label: liftCrane.label,
                                labelStyle: styles.checkbox.labelStyle,
                                style: styles.checkbox.style
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'line-body' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* FieldArray */], {
                        name: 'liftsCranes.' + liftCrane.name + '.details',
                        component: __WEBPACK_IMPORTED_MODULE_8__Details__["a" /* default */],
                        props: liftCrane,
                        min: liftCrane.name ? parseInt(liftCrane.name.split('-')[0]) : 0,
                        max: liftCrane.name ? parseInt(liftCrane.name.split('-')[1]) : 100
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LiftAndCranesItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LiftAndCranesItem.propTypes = {
    liftCrane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

LiftAndCranesItem.defaultProps = {
    liftCrane: {}
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref) {
    var liftCrane = _ref.liftCrane;

    return { liftCrane: liftCrane };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(LiftAndCranesItem);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/Item.jsx');
    reactHotLoader.register(LiftAndCranesItem, 'LiftAndCranesItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_redux_form_validators__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var styles = {
    icon: { iconStyle: { color: '#00bcd4' } },
    textField: {
        floatingLabelStyle: {
            fontSize: '14px'
        }
    }
};

var Details = function (_React$Component) {
    _inherits(Details, _React$Component);

    function Details(props) {
        _classCallCheck(this, Details);

        var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

        _this.addCapacity = _this.addCapacity.bind(_this);
        _this.removeCapacity = _this.removeCapacity.bind(_this);
        return _this;
    }

    _createClass(Details, [{
        key: 'addCapacity',
        value: function addCapacity() {
            var fields = this.props.fields;


            fields.push({
                name: '',
                value: ''
            });
        }
    }, {
        key: 'removeCapacity',
        value: function removeCapacity(index) {
            var fields = this.props.fields;


            fields.remove(index);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                fields = _props.fields,
                min = _props.min,
                max = _props.max;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                fields.map(function (field, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                        { key: index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item middle-xs' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: field + '.name',
                                floatingLabelText: 'Name',
                                fullWidth: true,
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_12_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_12_redux_form_validators__["length"])({ min: 3, max: 266 })]
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: field + '.value',
                                floatingLabelText: 'Value',
                                fullWidth: true,
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_12_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_12_redux_form_validators__["numericality"])({ '<=': max, '>=': min, int: true })]
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'edit' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'icon delete-icon' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["h" /* IconButton */],
                                        {
                                            iconStyle: styles.icon.iconStyle,
                                            onClick: function onClick() {
                                                _this2.removeCapacity(index);
                                            } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_action_delete___default.a, null)
                                    )
                                )
                            )
                        )
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row add-capacity' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 middle-xs end-xs' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'text' },
                            'Add capacity'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["h" /* IconButton */],
                            {
                                iconStyle: styles.icon.iconStyle,
                                onClick: this.addCapacity },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_image_control_point___default.a, null)
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Details;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Details.propTypes = {};

Details.defaultProps = {};

var selector = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_11_data_formNames__["a" /* formName */].portCreate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        liftsCranes: selector(state, 'liftsCranes'),
        port: state.port
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        changePort: __WEBPACK_IMPORTED_MODULE_10_actions_regions_ports__["b" /* changePort */]
    }, dispatch);
})(Details);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/Details.jsx');
    reactHotLoader.register(Details, 'Details', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/Details.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/Details.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/LiftAndCranes/Details.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_regions_areas__ = __webpack_require__(675);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









var styles = {
    dialog: {
        header: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '0px 0px -1px',
            padding: '24px 24px 20px'
        },
        title: {
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: '22px',
            lineHeight: '32px',
            fontWeight: '400'
        }
    }
};

/**
 * @typedef {{
 *  shown: boolean,
 *  onClose: (parents: string[]) => void,
 *  coordinates: [number, number],
 * }} Props
 * @type {import('react').FC<Props>}
 */
var AreaAutoAssignmentConfirmModal = function AreaAutoAssignmentConfirmModal(_ref) {
    var shown = _ref.shown,
        onClose = _ref.onClose,
        coordinates = _ref.coordinates;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        areas = _useState2[0],
        setAreas = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        checkedAreaIds = _useState4[0],
        setCheckedAreaIds = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!coordinates || coordinates.length != 2) return;
        setAreas(null);
        Object(__WEBPACK_IMPORTED_MODULE_6_services_regions_areas__["g" /* getAreasAtPoint */])(coordinates).then(function (_ref2) {
            var data = _ref2.data;

            setAreas(data);
            setCheckedAreaIds(data.map(function (area) {
                return area._id;
            }));
        });
    }, [coordinates]);

    var handleAccept = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (!areas) return;
        onClose(checkedAreaIds);
    }, [areas, checkedAreaIds, onClose]);

    var handleDecline = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (!areas) return;
        onClose([]);
    }, [areas, checkedAreaIds, onClose]);

    var handleCheck = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event, checked) {
        var checkedId = event.target.value;
        if (checked) {
            setCheckedAreaIds([].concat(_toConsumableArray(checkedAreaIds), [checkedId]));
        } else {
            setCheckedAreaIds(checkedAreaIds.filter(function (id) {
                return id != checkedId;
            }));
        }
    }, [checkedAreaIds]);

    var selectAll = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        setCheckedAreaIds(areas.map(function (a) {
            return a._id;
        }));
    }, [areas]);

    var selectNone = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        setCheckedAreaIds([]);
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui__["f" /* Dialog */],
        {
            title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.dialog.header },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: styles.dialog.title },
                        'Add into areas'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], {
                            label: 'Select All',
                            secondary: true,
                            onClick: selectAll
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], {
                            label: 'Select None',
                            secondary: true,
                            onClick: selectNone
                        })
                    )
                )
            ),
            open: shown,
            autoScrollBodyContent: true,
            actions: areas && areas.length === 0 ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], { label: 'Continue', onClick: handleDecline })] : [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], { label: 'No', onClick: handleDecline }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], {
                label: 'Yes',
                primary: true,
                keyboardFocused: true,
                onClick: handleAccept,
                disabled: !areas
            })]
        },
        !!areas && areas.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["j" /* List */],
            null,
            areas.map(function (area) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["k" /* ListItem */],
                    {
                        key: area._id,
                        leftCheckbox: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["b" /* Checkbox */], {
                            onCheck: handleCheck,
                            value: area._id,
                            checked: checkedAreaIds.includes(area._id)
                        })
                    },
                    area.name
                );
            })
        ),
        !!areas && areas.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { margin: '15px 0', textAlign: 'center' } },
            'There is no areas at this point.'
        ),
        !areas && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["d" /* CircularProgress */], null)
    );
};

AreaAutoAssignmentConfirmModal.displayName = 'AreaAutoAssignmentConfirmModal';

var selectPortFormValue = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_5__data_formNames__["a" /* formName */].portCreate);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return _extends({}, ownProps, {
        coordinates: selectPortFormValue(state, 'coordinates')
    });
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({}, dispatch);
})(AreaAutoAssignmentConfirmModal);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/AreaAutoAssignmentConfirmModal.jsx');
    reactHotLoader.register(AreaAutoAssignmentConfirmModal, 'AreaAutoAssignmentConfirmModal', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/AreaAutoAssignmentConfirmModal.jsx');
    reactHotLoader.register(selectPortFormValue, 'selectPortFormValue', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/AreaAutoAssignmentConfirmModal.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortAdd/AreaAutoAssignmentConfirmModal.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Table__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_regions_areas__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AreasAltNames = function (_React$Component) {
    _inherits(AreasAltNames, _React$Component);

    function AreasAltNames(props) {
        _classCallCheck(this, AreasAltNames);

        return _possibleConstructorReturn(this, (AreasAltNames.__proto__ || Object.getPrototypeOf(AreasAltNames)).call(this, props));
    }

    _createClass(AreasAltNames, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getAreas();
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'alt-areas', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'areas alternative names'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Table__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AreasAltNames;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        isLoaded: state.areas.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getAreas: __WEBPACK_IMPORTED_MODULE_5_actions_regions_areas__["c" /* getAreas */]
    }, dispatch);
})(AreasAltNames);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AreasAltNames, 'AreasAltNames', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/AreasAltNames/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/AreasAltNames/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_regions_areas__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Row__ = __webpack_require__(2300);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var AreasAltNamesTable = function (_React$Component) {
    _inherits(AreasAltNamesTable, _React$Component);

    function AreasAltNamesTable(props) {
        _classCallCheck(this, AreasAltNamesTable);

        var _this = _possibleConstructorReturn(this, (AreasAltNamesTable.__proto__ || Object.getPrototypeOf(AreasAltNamesTable)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            areas: []
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }

    _createClass(AreasAltNamesTable, [{
        key: 'filterSearch',
        value: function filterSearch(searchArray, searchText) {
            if (searchText === '') {
                return searchArray;
            }

            searchText = searchText.toLowerCase();

            return searchArray.filter(function (item) {
                if (item.prevState.name) {
                    if (item.prevState.name.toLowerCase().includes(searchText)) {
                        return true;
                    }
                }

                for (var i = 0; i < item.prevState.alt.length; i++) {
                    if (item.prevState.alt[i].toLowerCase().includes(searchText)) {
                        return true;
                    }
                }

                return false;
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e, value) {
            this.props.searchArea(value.toLowerCase());
        }
    }, {
        key: 'makeFilter',
        value: function makeFilter(props) {
            var _this2 = this;

            var page = this.state.page;

            if (props.searchText !== this.state.searchText) {
                page = 1;
            }

            var areas = this.filterSearch(props.areas, props.searchText);

            this.setState({
                searchText: props.searchText,
                areas: areas,
                page: page,
                total: props.areas.length
            }, function () {
                _this2.handleUpdateRow(_this2.state);
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            if (props.areas.length) {
                this.makeFilter(props);
            }
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.areas.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var searchText = this.props.searchText;
            var rows = this.state.rows;


            var renderSuggestions = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'port-suggestions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'title' },
                    'This name has been already used:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content' },
                    this.props.suggestionsAreas.map(function (area) {
                        return area.alt ? ' ' + area.name + ' - (' + area.alt.join(', ') + '), ' : area.name + ', ';
                    })
                )
            );

            var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                total: this.state.areas.length,
                rowsPerPage: this.state.rowsPerPage,
                page: this.state.page,
                numberOfRows: this.state.numberOfRows,
                updateRows: this.handleUpdateRow
            });

            var renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnCSS },
                            'name area'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnCSS },
                            'alt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false },
                    rows.map(function (row) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Row__["a" /* default */], { key: row._id, item: row });
                    })
                )
            );

            if (!this.props.suggestionsAreas.length) {
                renderSuggestions = null;
            }

            if (!rows.length) {
                renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'nothing-found' },
                    'Not found'
                );
                renderPagination = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            defaultValue: searchText,
                            floatingLabelText: 'Search',
                            onChange: this.handleSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        renderPagination
                    )
                ),
                renderSuggestions,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    renderTable
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AreasAltNamesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        searchText: state.areas.searchText,
        areas: state.areas.items,
        suggestionsAreas: state.areas.suggestions
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        searchArea: __WEBPACK_IMPORTED_MODULE_6_actions_regions_areas__["f" /* searchArea */]
    }, dispatch);
})(AreasAltNamesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AreasAltNamesTable, 'AreasAltNamesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/AreasAltNames/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/AreasAltNames/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_regions_areas__ = __webpack_require__(165);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var AreasAltNamesRow = function (_React$Component) {
    _inherits(AreasAltNamesRow, _React$Component);

    function AreasAltNamesRow(props) {
        _classCallCheck(this, AreasAltNamesRow);

        var _this = _possibleConstructorReturn(this, (AreasAltNamesRow.__proto__ || Object.getPrototypeOf(AreasAltNamesRow)).call(this, props));

        _this.state = {
            item: props.item,
            tags: props.tags
        };

        _this.handleAddition = _this.handleAddition.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.updateArea = _this.updateArea.bind(_this);
        return _this;
    }

    _createClass(AreasAltNamesRow, [{
        key: 'updateArea',
        value: function updateArea() {
            this.props.updateAreaAlt(this.state.item);
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(searchText) {
            var _this2 = this;

            if (searchText.length < 3) {
                this.props.updateAreaSuggestions([]);
                return;
            }

            __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].findPortAdmin({ name: searchText, withAreas: true }).then(function (response) {
                _this2.props.updateAreaSuggestions(response.data.data);
            });
        }
    }, {
        key: 'handleDelete',
        value: function handleDelete(i) {
            var _this3 = this;

            var tags = this.state.tags.slice(0);
            tags.splice(i, 1);

            var item = this.state.item;
            item.isUpdate = true;
            item.alt = tags.map(function (newTag) {
                return newTag.name;
            });

            this.setState({ tags: tags, item: item }, function () {
                _this3.props.updateAreaSuggestions([]);
                _this3.props.saveArea(_this3.state.item);
            });
        }
    }, {
        key: 'handleAddition',
        value: function handleAddition(tag) {
            var _this4 = this;

            if (!tag.name.replace(/\s/g, '').length) {
                return;
            }

            var suggestionsAreas = this.props.suggestionsAreas.filter(function (item) {
                if (item.name.toLowerCase() === tag.name.toLowerCase()) {
                    return true;
                }
                return false;
            });

            if (suggestionsAreas.length) {
                return;
            }

            var tags = [].concat(this.state.tags, tag);
            var item = this.state.item;
            item.isUpdate = true;
            item.alt = tags.map(function (newTag) {
                return newTag.name;
            });

            this.setState({ tags: tags, item: item }, function () {
                _this4.props.updateAreaSuggestions([]);
                _this4.props.saveArea(_this4.state.item);
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            this.setState({
                tags: newProps.tags,
                item: newProps.item
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS },
                    this.props.item.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default.a, {
                        allowNew: true,
                        autofocus: false,
                        tags: this.state.tags,
                        suggestions: [],
                        handleDelete: this.handleDelete,
                        handleAddition: this.handleAddition,
                        handleInputChange: this.handleInputChange
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: this.props.item.isUpdate ? 'update-item' : 'hidden update-item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, { label: 'Update', primary: true, onClick: this.updateArea })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AreasAltNamesRow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var tags = ownProps.item.alt.map(function (item, key) {
        return {
            id: key,
            name: item
        };
    });

    return {
        item: ownProps.item,
        tags: tags,
        suggestionsAreas: state.areas.suggestions
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        saveArea: __WEBPACK_IMPORTED_MODULE_8_actions_regions_areas__["e" /* saveArea */],
        updateAreaSuggestions: __WEBPACK_IMPORTED_MODULE_8_actions_regions_areas__["i" /* updateAreaSuggestions */],
        updateAreaAlt: __WEBPACK_IMPORTED_MODULE_8_actions_regions_areas__["h" /* updateAreaAlt */]
    }, dispatch);
})(AreasAltNamesRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AreasAltNamesRow, 'AreasAltNamesRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/AreasAltNames/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/AreasAltNames/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Map__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants__ = __webpack_require__(203);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var MergingAreas = function (_React$Component) {
    _inherits(MergingAreas, _React$Component);

    function MergingAreas(props) {
        _classCallCheck(this, MergingAreas);

        var _this = _possibleConstructorReturn(this, (MergingAreas.__proto__ || Object.getPrototypeOf(MergingAreas)).call(this, props));

        _this.state = {
            sourceObject: {
                name: ''
            },
            sourceItems: [],

            destinationObject: {
                name: ''
            },
            destinationItems: []
        };

        _this.onUpdateInput = _this.onUpdateInput.bind(_this);
        _this.onChooseAutoComplete = _this.onChooseAutoComplete.bind(_this);
        _this.merge = _this.merge.bind(_this);
        _this.join = _this.join.bind(_this);
        _this.add = _this.add.bind(_this);
        return _this;
    }

    _createClass(MergingAreas, [{
        key: 'merge',
        value: function merge() {
            this.props.mergeAreas();
        }
    }, {
        key: 'join',
        value: function join() {
            this.props.joinAreas();
        }
    }, {
        key: 'add',
        value: function add() {
            this.props.addAreaToArea();
        }
    }, {
        key: 'updateInputSource',
        value: function updateInputSource(searchText) {
            var _this2 = this;

            var sourceObject = { name: searchText };

            this.setState({
                sourceObject: sourceObject
            }, function () {
                _this2.props.addValue('sourceArea', sourceObject);

                if (searchText.length <= 1) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findPortAdmin({ name: searchText, onlyAreasWithChild: true }).then(function (response) {
                    if (response.status === 200) {
                        var sourceItems = [];

                        response.data.data.forEach(function (item) {
                            sourceItems.push({
                                name: item.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    style: { width: '100%' },
                                    primaryText: item.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                    item: item
                                })
                            });

                            if (item.alt && item.alt.length > 0) {
                                item.alt.forEach(function (alternativeName) {
                                    sourceItems.push({
                                        name: alternativeName + ' (alternative name)',
                                        item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                            style: { width: '100%', padding: '0 0 0 20px' },
                                            primaryText: alternativeName + ' (alternative name)',
                                            item: item
                                        })
                                    });
                                });
                            }

                            if (item.sub && item.sub.length > 0) {
                                item.sub.forEach(function (subPort) {
                                    sourceItems.push({
                                        name: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                        item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                            style: { width: '100%', padding: '0 0 0 20px' },
                                            primaryText: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                            item: subPort
                                        })
                                    });
                                });
                            }
                        });

                        _this2.setState({
                            sourceItems: sourceItems
                        }, function () {
                            document.body.scrollTop = document.body.scrollTop + 1;
                            document.body.scrollTop = document.body.scrollTop - 1;
                        });
                    }
                });
            });
        }
    }, {
        key: 'updateInputDestination',
        value: function updateInputDestination(searchText) {
            var _this3 = this;

            var destinationObject = { name: searchText };

            this.setState({
                destinationObject: destinationObject
            }, function () {
                _this3.props.addValue('destinationArea', {});

                if (searchText.length <= 1) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findPortAdmin({ name: searchText, onlyAreasWithChild: true }).then(function (response) {
                    if (response.status === 200) {
                        var destinationItems = [];

                        response.data.data.forEach(function (item) {
                            destinationItems.push({
                                name: item.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    style: { width: '100%' },
                                    primaryText: item.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                    item: item
                                })
                            });

                            if (item.alt && item.alt.length > 0) {
                                item.alt.forEach(function (alternativeName) {
                                    destinationItems.push({
                                        name: alternativeName + ' (alternative name)',
                                        item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                            style: { width: '100%', padding: '0 0 0 20px' },
                                            primaryText: alternativeName + ' (alternative name)',
                                            item: item
                                        })
                                    });
                                });
                            }

                            if (item.sub && item.sub.length > 0) {
                                item.sub.forEach(function (subPort) {
                                    destinationItems.push({
                                        name: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                        item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                            style: { width: '100%', padding: '0 0 0 20px' },
                                            primaryText: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                            item: subPort
                                        })
                                    });
                                });
                            }
                        });

                        _this3.setState({
                            destinationItems: destinationItems
                        }, function () {
                            document.body.scrollTop = document.body.scrollTop + 1;
                            document.body.scrollTop = document.body.scrollTop - 1;
                        });
                    }
                });
            });
        }
    }, {
        key: 'onUpdateInput',
        value: function onUpdateInput(searchText, type) {
            switch (type) {
                case 'source':
                    this.updateInputSource(searchText);
                    break;
                case 'destination':
                    this.updateInputDestination(searchText);
                    break;
            }
        }
    }, {
        key: 'onChooseSource',
        value: function onChooseSource(updateProperties) {
            var _this4 = this;

            if (typeof updateProperties === 'string' && this.state.sourceItems.length > 0) {
                var _sourceObject = this.state.sourceObject;

                _sourceObject = this.state.sourceItems[0].item.props.item;

                this.setState({
                    sourceObject: _sourceObject,
                    sourceItems: []
                }, function () {
                    _this4.props.addValue('sourceArea', _sourceObject);
                });

                return;
            }

            if (!updateProperties || typeof updateProperties === 'string') {
                return;
            }

            var sourceObject = this.state.sourceObject;

            sourceObject = updateProperties.item.props.item;

            this.setState({
                sourceObject: sourceObject,
                sourceItems: []
            }, function () {
                _this4.props.addValue('sourceArea', sourceObject);
            });
        }
    }, {
        key: 'onChooseDestination',
        value: function onChooseDestination(updateProperties) {
            var _this5 = this;

            if (typeof updateProperties === 'string' && this.state.destinationItems.length > 0) {
                var _destinationObject = this.state.destinationObject;

                _destinationObject = this.state.destinationItems[0].item.props.item;

                this.setState({
                    destinationObject: _destinationObject,
                    destinationItems: []
                }, function () {
                    _this5.props.addValue('destinationArea', _destinationObject);
                });

                return;
            }

            if (!updateProperties || typeof updateProperties === 'string') {
                return;
            }

            var destinationObject = this.state.destinationObject;

            destinationObject = updateProperties.item.props.item;

            this.setState({
                destinationObject: destinationObject,
                destinationItems: []
            }, function () {
                _this5.props.addValue('destinationArea', destinationObject);
            });
        }
    }, {
        key: 'onChooseAutoComplete',
        value: function onChooseAutoComplete(updateProperties, type) {
            switch (type) {
                case 'source':
                    this.onChooseSource(updateProperties);
                    break;
                case 'destination':
                    this.onChooseDestination(updateProperties);
                    break;
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.clearAreas) {
                return this.setState({
                    sourceObject: {
                        name: ''
                    },
                    sourceItems: [],

                    destinationObject: {
                        name: ''
                    },
                    destinationItems: []
                });
            }

            this.setState({
                sourceObject: nextProps.sourceArea
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var _state = this.state,
                sourceObject = _state.sourceObject,
                sourceItems = _state.sourceItems,
                destinationObject = _state.destinationObject,
                destinationItems = _state.destinationItems;
            var _props = this.props,
                disabledBtn = _props.disabledBtn,
                disabledAddAreaToArea = _props.disabledAddAreaToArea;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h3',
                        { className: 'col-xs-3' },
                        'Merge area to area'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { style: { fontSize: '12px' } },
                            'Auto Complete only areas (Search fields are name, alt name). ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                            'Area doesn\'t have country field.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                            textFieldStyle: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].autoCompleteCSS,
                            floatingLabelText: 'Source',
                            searchText: sourceObject.name,
                            dataSource: sourceItems,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: function onUpdateInput(searchText) {
                                _this6.onUpdateInput(searchText, 'source');
                            },
                            onNewRequest: function onNewRequest(chosenRequest) {
                                _this6.onChooseAutoComplete(chosenRequest, 'source');
                            },
                            filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                            style: { width: '100%' },
                            listStyle: { maxHeight: '300px', overflow: 'auto' },
                            fullWidth: true,
                            popoverProps: {
                                canAutoPosition: true,
                                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                targetOrigin: { horizontal: 'left', vertical: 'top' }
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { style: { fontSize: '12px' } },
                            'Auto Complete only areas (Search fields are name, alt name). ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                            'Area doesn\'t have country field.'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                            textFieldStyle: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].autoCompleteCSS,
                            floatingLabelText: 'Destination',
                            searchText: destinationObject.name,
                            dataSource: destinationItems,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: function onUpdateInput(searchText) {
                                _this6.onUpdateInput(searchText, 'destination');
                            },
                            onNewRequest: function onNewRequest(chosenRequest) {
                                _this6.onChooseAutoComplete(chosenRequest, 'destination');
                            },
                            filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                            style: { width: '100%' },
                            listStyle: { maxHeight: '300px', overflow: 'auto' },
                            fullWidth: true,
                            popoverProps: {
                                canAutoPosition: true,
                                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                targetOrigin: { horizontal: 'left', vertical: 'top' }
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                primary: true,
                                disabled: disabledBtn,
                                label: 'merge areas',
                                onClick: this.merge
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { margin: '10px 0 0 0' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                primary: true,
                                disabled: disabledAddAreaToArea,
                                label: 'add area to area',
                                onClick: this.add
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        !sourceObject.childs || sourceObject.childs.length === 0 ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Map__["a" /* default */], {
                            coordinates: sourceObject.childs,
                            type: 'area',
                            loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                            containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '300px' } }),
                            mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                            areaPolygon: sourceObject.areaCoordinates
                        }),
                        sourceObject.childs && sourceObject.childs.length === 0 ? 'Area doesn`t have ports' : ''
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        !destinationObject.childs || destinationObject.childs.length === 0 ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Map__["a" /* default */], {
                            coordinates: destinationObject.childs,
                            type: 'area',
                            loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                            containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '300px' } }),
                            mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                            areaPolygon: sourceObject.areaCoordinates
                        }),
                        destinationObject.childs && destinationObject.childs.length === 0 ? 'Area doesn`t have ports' : ''
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return MergingAreas;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var mergeAreas = _ref.mergeAreas,
        joinAreas = _ref.joinAreas,
        addValue = _ref.addValue,
        disabledBtn = _ref.disabledBtn,
        clearAreas = _ref.clearAreas;
    return {
        mergeAreas: mergeAreas,
        joinAreas: joinAreas,
        addValue: addValue,
        disabledBtn: disabledBtn,
        clearAreas: clearAreas
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(MergingAreas);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MergingAreas, 'MergingAreas', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Areas.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Areas.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Map__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Base_Chips_BasicChip__ = __webpack_require__(2303);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();















var menuSeparatorStyle = {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '36px',
    gap: '10px',
    color: '#9E9E9E',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '18px',
    minHeight: '24px'
};

var MergingPorts = function MergingPorts(_ref) {
    var mergePorts = _ref.mergePorts,
        addValue = _ref.addValue,
        disabledBtn = _ref.disabledBtn,
        clearPorts = _ref.clearPorts,
        sourcePort = _ref.sourcePort;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ name: '' }),
        _useState2 = _slicedToArray(_useState, 2),
        sourceObject = _useState2[0],
        setSourceObject = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        sourceItems = _useState4[0],
        setSourceItems = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ name: '' }),
        _useState6 = _slicedToArray(_useState5, 2),
        destinationObject = _useState6[0],
        setDestinationObject = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState8 = _slicedToArray(_useState7, 2),
        destinationItems = _useState8[0],
        setDestinationItems = _useState8[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (clearPorts) {
            setSourceObject({ name: '' });
            setSourceItems([]);
            setDestinationObject({ name: '' });
            setDestinationItems([]);
        }
    }, [clearPorts]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (clearPorts) return;
        setSourceObject(sourcePort);
    }, [sourcePort, clearPorts]);

    var merge = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        mergePorts();
    }, [mergePorts]);

    var updateInputSource = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (searchText) {
        var searchOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var newSourceObject = { name: searchText };
        setSourceObject(newSourceObject);

        addValue('sourcePort', {});

        if (searchText.length <= 1) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findPortAdmin(_extends({ name: searchText, withAreasWithChild: true }, searchOpts)).then(function (response) {
            if (response.status === 200) {
                var newSourceItems = [];
                response.data.data.forEach(function (item) {
                    newSourceItems.push({
                        name: item.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                        item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                            style: { width: '100%' },
                            primaryText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    item.name + ' ' + (item.country ? '(' + item.country.name + ')' : '')
                                ),
                                item.addedBy && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_Chips_BasicChip__["a" /* default */], { label: 'User' })
                            ),
                            item: item
                        })
                    });

                    if (item.alt && item.alt.length > 0) {
                        newSourceItems.push({
                            name: 'ALTERNATIVE NAME',
                            item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                disabled: true,
                                primaryText: 'ALTERNATIVE NAME',
                                style: _extends({}, menuSeparatorStyle)
                            })
                        });
                        item.alt.forEach(function (alternativeName) {
                            newSourceItems.push({
                                name: '' + alternativeName,
                                item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    style: { width: '100%', padding: '0 0 0 20px' },
                                    primaryText: '' + alternativeName,
                                    item: item
                                })
                            });
                        });
                    }

                    if (item.sub && item.sub.length > 0) {
                        newSourceItems.push({
                            name: 'SUB PORTS',
                            item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { disabled: true, primaryText: 'SUB PORTS', style: menuSeparatorStyle })
                        });
                        item.sub.forEach(function (subPort) {
                            newSourceItems.push({
                                name: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    style: { width: '100%', padding: '0 0 0 20px' },
                                    primaryText: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                    item: subPort
                                })
                            });
                        });
                    }
                });

                setSourceItems(newSourceItems);
                document.body.scrollTop = document.body.scrollTop + 1;
                document.body.scrollTop = document.body.scrollTop - 1;
            }
        });
    }, [addValue]);

    var updateInputDestination = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (searchText) {
        var newDestinationObject = { name: searchText };
        setDestinationObject(newDestinationObject);

        addValue('destinationPort', {});

        if (searchText.length <= 1) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findPortAdmin({ name: searchText }).then(function (response) {
            if (response.status === 200) {
                var newDestinationItems = [];
                response.data.data.forEach(function (item) {
                    newDestinationItems.push({
                        name: item.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                        item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                            style: { width: '100%' },
                            primaryText: item.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                            item: item
                        })
                    });

                    if (item.alt && item.alt.length > 0) {
                        newDestinationItems.push({
                            name: 'ALTERNATIVE NAME',
                            item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { disabled: true, primaryText: 'ALTERNATIVE NAME', style: menuSeparatorStyle })
                        });
                        item.alt.forEach(function (alternativeName) {
                            newDestinationItems.push({
                                name: '' + alternativeName,
                                item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    style: { width: '100%', padding: '0 0 0 20px' },
                                    primaryText: '' + alternativeName,
                                    item: item
                                })
                            });
                        });
                    }

                    if (item.sub && item.sub.length > 0) {
                        newDestinationItems.push({
                            name: 'SUB PORTS',
                            item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, { disabled: true, primaryText: 'SUB PORTS', style: menuSeparatorStyle })
                        });
                        item.sub.forEach(function (subPort) {
                            newDestinationItems.push({
                                name: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_MenuItem___default.a, {
                                    style: { width: '100%', padding: '0 0 0 20px' },
                                    primaryText: subPort.name + ' ' + (item.country ? '(' + item.country.name + ')' : ''),
                                    item: subPort
                                })
                            });
                        });
                    }
                });

                setDestinationItems(newDestinationItems);
                document.body.scrollTop = document.body.scrollTop + 1;
                document.body.scrollTop = document.body.scrollTop - 1;
            }
        });
    }, [addValue]);

    var _onUpdateInput = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (searchText, type) {
        switch (type) {
            case 'source':
                updateInputSource(searchText, { withUserPorts: true });
                break;
            case 'destination':
                updateInputDestination(searchText);
                break;
            default:
                break;
        }
    }, [updateInputSource, updateInputDestination]);

    var onChooseSource = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (updateProperties) {
        if (typeof updateProperties === 'string' && sourceItems.length > 0) {
            var _newSourceObject = sourceItems[0].item.props.item;
            setSourceObject(_newSourceObject);
            setSourceItems([]);
            addValue('sourcePort', _newSourceObject);
            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        var newSourceObject = updateProperties.item.props.item;
        setSourceObject(newSourceObject);
        setSourceItems([]);
        addValue('sourcePort', newSourceObject);
    }, [addValue, sourceItems]);

    var onChooseDestination = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (updateProperties) {
        if (typeof updateProperties === 'string' && destinationItems.length > 0) {
            var _newDestinationObject = destinationItems[0].item.props.item;
            setDestinationObject(_newDestinationObject);
            setDestinationItems([]);
            addValue('destinationPort', _newDestinationObject);
            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        var newDestinationObject = updateProperties.item.props.item;
        setDestinationObject(newDestinationObject);
        setDestinationItems([]);
        addValue('destinationPort', newDestinationObject);
    }, [addValue, destinationItems]);

    var onChooseAutoComplete = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (updateProperties, type) {
        switch (type) {
            case 'source':
                onChooseSource(updateProperties);
                break;
            case 'destination':
                onChooseDestination(updateProperties);
                break;
            default:
                break;
        }
    }, [onChooseSource, onChooseDestination]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'col-xs-3' },
                'Port or area to port'
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: '12px' } },
                    'Auto Complete area and ports (Search fields are name, alt name). ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                    textFieldStyle: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].autoCompleteCSS,
                    floatingLabelText: 'Source',
                    searchText: sourceObject.name,
                    dataSource: sourceItems,
                    dataSourceConfig: { text: 'name', value: 'item' },
                    onUpdateInput: function onUpdateInput(searchText) {
                        _onUpdateInput(searchText, 'source');
                    },
                    onNewRequest: function onNewRequest(chosenRequest) {
                        onChooseAutoComplete(chosenRequest, 'source');
                    },
                    filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                    style: { width: '100%' },
                    listStyle: { maxHeight: '300px', overflow: 'auto' },
                    fullWidth: true,
                    popoverProps: {
                        canAutoPosition: true,
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' }
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: '12px' } },
                    'Auto Complete only ports (Search fields are name, alt name). ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                    textFieldStyle: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].autoCompleteCSS,
                    floatingLabelText: 'Destination',
                    searchText: destinationObject.name,
                    dataSource: destinationItems,
                    dataSourceConfig: { text: 'name', value: 'item' },
                    onUpdateInput: function onUpdateInput(searchText) {
                        _onUpdateInput(searchText, 'destination');
                    },
                    onNewRequest: function onNewRequest(chosenRequest) {
                        onChooseAutoComplete(chosenRequest, 'destination');
                    },
                    filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                    style: { width: '100%' },
                    listStyle: { maxHeight: '300px', overflow: 'auto' },
                    fullWidth: true,
                    popoverProps: {
                        canAutoPosition: true,
                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' }
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                    primary: true,
                    disabled: disabledBtn,
                    label: 'merge ports',
                    onClick: merge
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                sourceObject.country ? !sourceObject.coordinates ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Map__["a" /* default */], {
                    coordinates: sourceObject.coordinates,
                    type: 'ports',
                    googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_9_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
                    loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                    containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '300px' } }),
                    mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } })
                }) : !sourceObject.childs || sourceObject.childs.length === 0 ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Map__["a" /* default */], {
                    coordinates: sourceObject.childs,
                    type: 'area',
                    googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_9_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
                    loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                    containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '300px' } }),
                    mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                    areaPolygon: sourceObject.areaCoordinates
                }),
                sourceObject.childs && sourceObject.childs.length === 0 ? 'Area doesn`t has ports' : ''
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-4' },
                !destinationObject.coordinates ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Map__["a" /* default */], {
                    coordinates: destinationObject.coordinates,
                    type: 'ports',
                    googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_9_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
                    loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                    containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '300px' } }),
                    mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                    areaPolygon: sourceObject.areaCoordinates
                })
            )
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref2) {
    var mergePorts = _ref2.mergePorts,
        addValue = _ref2.addValue,
        disabledBtn = _ref2.disabledBtn,
        clearPorts = _ref2.clearPorts,
        sourcePort = _ref2.sourcePort;
    return {
        mergePorts: mergePorts,
        addValue: addValue,
        disabledBtn: disabledBtn,
        clearPorts: clearPorts,
        sourcePort: sourcePort
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(MergingPorts);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(menuSeparatorStyle, 'menuSeparatorStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Ports.jsx');
    reactHotLoader.register(MergingPorts, 'MergingPorts', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Ports.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/Ports.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var chipStyle = {
    display: 'flex',
    height: '20px',
    padding: '0px 12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    borderRadius: '20px',
    background: '#75C422',
    color: '#333',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px'
};

var BasicChip = function BasicChip(_ref) {
    var label = _ref.label,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { style: _extends({}, chipStyle, style) },
        label
    );
};

var _default = BasicChip;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(chipStyle, 'chipStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/Chips/BasicChip.jsx');
    reactHotLoader.register(BasicChip, 'BasicChip', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/Chips/BasicChip.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/Chips/BasicChip.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = MergeErrorDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function MergeErrorDialog(_ref) {
    var isMergeErrorOpened = _ref.isMergeErrorOpened,
        handleMergeErrorOpened = _ref.handleMergeErrorOpened,
        errorAltNames = _ref.errorAltNames,
        handleBypassError = _ref.handleBypassError;

    var actions = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["g" /* FlatButton */], {
        label: 'Cancel',
        primary: true,
        onClick: handleMergeErrorOpened
    }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["g" /* FlatButton */], {
        label: 'Submit',
        primary: true,
        keyboardFocused: true,
        onClick: handleBypassError
    })];

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["f" /* Dialog */],
        {
            title: 'Approve required',
            actions: actions,
            modal: false,
            open: isMergeErrorOpened,
            onRequestClose: handleMergeErrorOpened
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'To merge specified regoins, alt name ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'b',
                null,
                '\'',
                errorAltNames.join(', '),
                '\''
            ),
            ' has to be removed from destination area and then areas will be merged. Do you want to proceed?'
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MergeErrorDialog, 'MergeErrorDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Merging/MergeErrorDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_regions_areas__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FilterAreas_Component__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AreaEditor__ = __webpack_require__(2309);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











var RegionsDashboards = function RegionsDashboards(props) {
    var ports = props.ports,
        areas = props.areas,
        router = props.router,
        getAllPorts = props.getAllPorts,
        getAreas = props.getAreas;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        areaId = _useState2[0],
        setAreaId = _useState2[1];
    // const [searchArea, setSearchArea] = useState(null);

    // Fetch data on component mount (replaces componentWillMount)


    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getAllPorts();
        getAreas();
    }, [getAllPorts, getAreas]);

    var onSelectAreaById = function onSelectAreaById(id) {
        setAreaId(id);
    };

    var onSelectArea = function onSelectArea(selectedArea) {
        selectedArea.isNew = false;
        onSelectAreaById(selectedArea._id);
    };

    var selectParentArea = function selectParentArea(searchAreaId) {
        onSelectAreaById(searchAreaId);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'regions-dashboard', className: 'page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container-fluid' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FilterAreas_Component__["a" /* default */], {
                        router: router,
                        areas: areas,
                        selectedArea: areaId,
                        onSelectArea: onSelectArea
                        // searchArea={searchArea}
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AreaEditor__["a" /* AreaEditor */], {
                        ports: ports,
                        areas: areas,
                        areaId: areaId,
                        selectArea: onSelectAreaById,
                        router: router,
                        selectParentArea: selectParentArea
                    })
                )
            )
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var ports = _ref.ports,
        areas = _ref.areas,
        user = _ref.user;
    return {
        ports: ports,
        areas: areas,
        isLogged: user.isLogged
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getAreas: __WEBPACK_IMPORTED_MODULE_3_actions_regions_areas__["c" /* getAreas */],
        getAllPorts: __WEBPACK_IMPORTED_MODULE_4_actions_regions_ports__["d" /* getAllPorts */]
    }, dispatch);
})(RegionsDashboards);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RegionsDashboards, 'RegionsDashboards', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_virtualized_dist_es_AutoSizer__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_virtualized_dist_es_List__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton_IconButton__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_search__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Search__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Filter__ = __webpack_require__(2308);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();














var FilterAreas = function FilterAreas(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState2 = _slicedToArray(_useState, 2),
        areaName = _useState2[0],
        setAreaName = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('all'),
        _useState4 = _slicedToArray(_useState3, 2),
        filter = _useState4[0],
        setFilter = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        filteredAreas = _useState6[0],
        setFilteredAreas = _useState6[1];

    var listRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

    var checkSelect = function checkSelect(item) {
        var updatedAreas = filteredAreas.map(function (area) {
            return _extends({}, area, {
                isActive: item._id === area._id
            });
        });

        setFilteredAreas(updatedAreas);
        props.onSelectArea(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(item));
    };

    var filterAreas = function filterAreas(areas) {
        var filtered = areas.filter(function (area) {
            if (area.name.toLowerCase().includes(areaName.toLowerCase())) {
                return true;
            }

            if (!area.fields) {
                return false;
            }

            return area.fields.some(function (field) {
                return field.name.toLowerCase().includes(areaName.toLowerCase());
            });
        });

        switch (filter) {
            case 'noPorts':
                return filtered.filter(function (a) {
                    return !a.mainRegion;
                }).filter(function (area) {
                    return area.childs.length === 0;
                });
            case 'noMainPorts':
                return filtered.filter(function (a) {
                    return !a.mainRegion;
                }).filter(function (area) {
                    return !(area.mainPorts && area.mainPorts.length > 0);
                });
            case 'mainRegions':
                return filtered.filter(function (area) {
                    return area.mainRegion;
                });
            default:
                return filtered.filter(function (a) {
                    return !a.mainRegion;
                });
        }
    };

    var changeSearch = function changeSearch(value) {
        setAreaName(value);
    };

    var changeFilter = function changeFilter(value) {
        setFilter(value);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setFilteredAreas(filterAreas(props.areas.items));
    }, [filter, areaName]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setFilteredAreas(filterAreas(props.areas.items));
    }, [props.areas.items]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (props.selectedArea) {
            var areaIndex = filteredAreas.findIndex(function (area) {
                return area._id === props.selectedArea;
            });
            if (listRef.current) {
                listRef.current.scrollToRow(areaIndex);
            }
        }
    }, [props.selectedArea, filteredAreas]);

    var renderRow = function renderRow(_ref) {
        var index = _ref.index,
            key = _ref.key,
            style = _ref.style;

        var area = filteredAreas[index];
        var selected = props.selectedArea === area._id;
        var parentCount = (area.parents || []).map(function (id) {
            return props.areas.items.find(function (a) {
                return a._id === id;
            });
        }).reduce(function (count, area) {
            return area ? count + 1 : count;
        }, 0);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                role: 'button',
                tabIndex: 0,
                style: _extends({}, style, { display: 'flex', justifyContent: 'space-between', fontWeight: area.mainRegion ? 'bold' : 'normal'
                }),
                key: key,
                className: __WEBPACK_IMPORTED_MODULE_6_classnames__('list-item', { active: selected }),
                onClick: function onClick() {
                    checkSelect(area);
                },
                onKeyPress: function onKeyPress(e) {
                    if (e.key === 'Enter') {
                        checkSelect(area);
                    }
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { lineHeight: '16px', paddingTop: '8px' } },
                area.name,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 'smaller' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        { style: { color: parentCount > 1 ? 'rgb(255, 64, 129)' : '' } },
                        parentCount
                    ),
                    parentCount === 1 ? ' parent ' : ' parents ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        null,
                        area.childAreaCount
                    ),
                    area.childAreaCount === 1 ? ' child ' : ' children ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        null,
                        area.childPortCount
                    ),
                    area.childPortCount === 1 ? ' port' : ' ports'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton_IconButton___default.a,
                { onClick: function onClick() {
                        props.searchArea(area.name);
                        props.router.push('/regions/altareas');
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_search___default.a, null)
            )
        );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'area-panel' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Search__["a" /* default */], { changeSearch: changeSearch }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Filter__["a" /* default */], { changeFilter: changeFilter }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block margin-10 area-list' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'name-block absolute small-name' },
                'Areas to select'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'list' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_virtualized_dist_es_AutoSizer__["a" /* AutoSizer */],
                    null,
                    function (_ref2) {
                        var width = _ref2.width,
                            height = _ref2.height;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_virtualized_dist_es_List__["a" /* List */], {
                            ref: listRef,
                            _updateOnly: props.areas,
                            selectedArea: props.selectedArea // only to cause update
                            , rowRenderer: renderRow,
                            height: height,
                            width: width,
                            rowHeight: 48,
                            rowCount: filteredAreas.length
                        });
                    }
                )
            )
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref3) {
    var selectedArea = _ref3.selectedArea,
        areas = _ref3.areas,
        onSelectArea = _ref3.onSelectArea,
        router = _ref3.router;
    return {
        selectedArea: selectedArea,
        areas: areas,
        onSelectArea: onSelectArea,
        router: router
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        searchArea: __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__["f" /* searchArea */]
    }, dispatch);
})(FilterAreas);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FilterAreas, 'FilterAreas', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/FilterAreas/Component.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/FilterAreas/Component.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var Search = function Search(props) {
    var searchInputRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

    var onChangeInput = function onChangeInput(value) {
        props.changeSearch(value);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'paper-block margin-10' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'name-block absolute small-name' },
            'Search areas'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
            inputRef: searchInputRef,
            floatingLabelText: 'Find area',
            defaultValue: '',
            onChange: function onChange(e) {
                return onChangeInput(e.target.value);
            },
            fullWidth: true
        })
    );
};

var _default = Search;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Search, 'Search', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/FilterAreas/Search.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/FilterAreas/Search.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var Filter = function Filter(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('all'),
        _useState2 = _slicedToArray(_useState, 2),
        select = _useState2[0],
        setSelect = _useState2[1];

    var onChangeRadioBtn = function onChangeRadioBtn(e, value) {
        setSelect(value);
        props.changeFilter(value);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'paper-block margin-10' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'name-block absolute small-name' },
            'Filter areas'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButtonGroup"],
            { onChange: onChangeRadioBtn, name: 'filter-areas', valueSelected: select },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                value: 'all',
                label: 'All'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                value: 'noPorts',
                label: 'No ports'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                value: 'noMainPorts',
                label: 'No main ports'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RadioButton__["RadioButton"], {
                value: 'mainRegions',
                label: 'Main regions'
            })
        )
    );
};

var _default = Filter;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Filter, 'Filter', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/FilterAreas/Filter.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/FilterAreas/Filter.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export Editor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Editor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Ports_Component__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Map_Component__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Management__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Areas_Areas__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sagas_regions_areas__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @Author: Sergiy Samborskiy
 * @Date: 2017-11-15 15:47:13
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2017-11-28 19:08:17
 */




















var AreaEditor = function (_React$Component) {
    _inherits(AreaEditor, _React$Component);

    function AreaEditor(props) {
        _classCallCheck(this, AreaEditor);

        var _this = _possibleConstructorReturn(this, (AreaEditor.__proto__ || Object.getPrototypeOf(AreaEditor)).call(this, props));

        _this.toggleMainChildPort = _this.toggleMainChildPort.bind(_this);
        _this.removePort = _this.removePort.bind(_this);
        _this.addPort = _this.addPort.bind(_this);
        _this.togglePort = _this.togglePort.bind(_this);
        _this.showPort = _this.showPort.bind(_this);

        _this.addPortToRegion = _this.addPortToRegion.bind(_this);
        _this.onChangePortFromAutoComplete = _this.onChangePortFromAutoComplete.bind(_this);

        _this.onChangeArea = _this.onChangeArea.bind(_this);
        _this.createAreaOnServer = _this.createAreaOnServer.bind(_this);
        _this.updateAreaOnServer = _this.updateAreaOnServer.bind(_this);
        _this.deleteAreaOnServer = _this.deleteAreaOnServer.bind(_this);
        _this.createNewArea = _this.createNewArea.bind(_this);

        _this.handleAreaPathReady = _this.handleAreaPathReady.bind(_this);

        _this.toggleRecalculateChilds = _this.toggleRecalculateChilds.bind(_this);
        _this.toggleShowMarkersOnlyInThisArea = _this.toggleShowMarkersOnlyInThisArea.bind(_this);
        _this.getDefaultArea = _this.getDefaultArea.bind(_this);

        _this.changeMapView = _this.changeMapView.bind(_this);

        _this.toggleShowPorts = _this.toggleShowPorts.bind(_this);
        _this.toggleShowAreas = _this.toggleShowAreas.bind(_this);
        _this.selectParentArea = _this.selectParentArea.bind(_this);
        _this.toggleMainPort = _this.toggleMainPort.bind(_this);
        _this.toggleRecalculateMainPorts = _this.toggleRecalculateMainPorts.bind(_this);

        _this.areaPath = [];
        _this.state = {
            area: _this.getDefaultArea(props.areaId, props.area),
            recalculateChildPorts: false,
            recalculateMainPorts: false,
            areaId: undefined,
            showMarkersOnlyInThisArea: false,
            showPortOnMap: undefined,
            portFromAutoComplete: {
                name: ''
            },
            ports: {
                items: []
            },
            showView: 'map',
            showChilds: 'ports'
        };
        return _this;
    }

    _createClass(AreaEditor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getCountries();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var area = this.getDefaultArea(nextProps.areaId, nextProps.area);
            var areaChanged = this.props.areaId !== nextProps.areaId;
            var newState = {
                ports: nextProps.ports,
                area: _extends({}, this.state.area, {
                    childs: area.childs,
                    mainPorts: area.mainPorts,
                    mainChildPorts: area.mainChildPorts,
                    areaCoordinatesPolygons: area.areaCoordinatesPolygons
                }),
                recalculateChildPorts: false,
                recalculateMainPorts: false
                // showChilds: 'ports',
            };

            if (this.state.showMarkersOnlyInThisArea) {
                newState.ports = this.getPortsFromArea(nextProps.ports, area);
            }

            if (areaChanged) {
                newState.area = area;
            }

            this.setState(newState);

            if (nextProps.areaId && areaChanged) {
                this.areaPath = [];

                __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].getArea(nextProps.areaId).then(function (response) {
                    _this2.setState({
                        area: _this2.getDefaultArea(nextProps.areaId, response.data),
                        recalculateChildPorts: false,
                        recalculateMainPorts: false
                    });
                });
            }
        }
    }, {
        key: 'changeMapView',
        value: function changeMapView(status) {
            var _this3 = this;

            this.setState({
                showView: status
            }, function () {
                _this3.setState({
                    area: _this3.getDefaultArea(_this3.props.areaId, _this3.state.area)
                }, function () {
                    google.maps.event.trigger(window.mainMap, 'resize');

                    var ports = _this3.getPortsFromArea(_this3.props.ports, _this3.state.area);

                    ports = ports.items.map(function (item) {
                        return {
                            lng: item.coordinates[0],
                            lat: item.coordinates[1]
                        };
                    });

                    if (ports.length === 0) {
                        return;
                    }

                    var bounds = new google.maps.LatLngBounds();

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = ports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var point = _step.value;

                            bounds.extend(point);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    window.mainMap.fitBounds(bounds);
                });
            });
        }
    }, {
        key: 'showPort',
        value: function showPort(port) {
            var isChilds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var area = this.state.area;


            if (isChilds) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = area.childs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var id = _step2.value;

                        if (port._id === id) {
                            area.showPortOnMap = id;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            } else {
                area.showPortOnMap = port._id;
            }

            this.setState({
                area: area
            });
        }
    }, {
        key: 'getDefaultArea',
        value: function getDefaultArea(id) {
            var newArea = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return _extends({
                _id: id,
                isNew: id === undefined,
                showPortOnMap: undefined,
                name: '',
                areaCoordinatesPolygons: {
                    type: 'MultiPolygon',
                    coordinates: []
                }
            }, newArea, {
                childs: new Set(newArea ? newArea.childs : []),
                mainPorts: new Set(newArea ? newArea.mainPorts : []),
                mainChildPorts: new Set(newArea ? newArea.mainChildPorts : [])
            });
        }
    }, {
        key: 'getPortsFromArea',
        value: function getPortsFromArea(nextPorts, area) {
            var ports = { items: [] };

            ports.items = nextPorts.items.filter(function (port) {
                return area.childs.has(port._id);
            });

            return ports;
        }
    }, {
        key: 'toggleShowMarkersOnlyInThisArea',
        value: function toggleShowMarkersOnlyInThisArea(value) {
            var ports = [];

            if (value) {
                ports = this.getPortsFromArea(this.props.ports, this.state.area);
            } else {
                ports = this.props.ports;
            }

            this.setState({
                showMarkersOnlyInThisArea: value,
                ports: ports
            });
        }
    }, {
        key: 'toggleRecalculateChilds',
        value: function toggleRecalculateChilds(value) {
            this.setState({
                recalculateChildPorts: value
            });
        }
    }, {
        key: 'toggleRecalculateMainPorts',
        value: function toggleRecalculateMainPorts(value) {
            this.setState({
                recalculateMainPorts: value
            });
        }
    }, {
        key: 'deleteAreaOnServer',
        value: function deleteAreaOnServer() {
            var _this4 = this;

            var prevArea = this.state.area;

            this.setState({
                area: _extends({}, this.getDefaultArea(), {
                    isNew: true,
                    showPortOnMap: undefined
                }),
                areaId: '',
                showMarkersOnlyInThisArea: false,
                recalculateChildPorts: false,
                recalculateMainPorts: false
            }, function () {
                _this4.props.deleteArea(prevArea);
            });
        }
    }, {
        key: 'updateAreaOnServer',
        value: function updateAreaOnServer(_ref) {
            var _this5 = this;

            var setAreaAsDefault = _ref.setAreaAsDefault;

            this.computeNextArea(function (area) {
                _this5.props.updateArea(_extends({}, area, {
                    areaCoordinatesPolygons: area.areaCoordinatesPolygons && area.areaCoordinatesPolygons.coordinates,
                    setAreaAsDefault: setAreaAsDefault
                }));
            });
        }
    }, {
        key: 'createAreaOnServer',
        value: function createAreaOnServer(_ref2) {
            var _this6 = this;

            var setAreaAsDefault = _ref2.setAreaAsDefault;

            this.computeNextArea(function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(area) {
                    var toSave, result;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    toSave = _extends({}, area, {
                                        areaCoordinatesPolygons: area.areaCoordinatesPolygons && area.areaCoordinatesPolygons.coordinates,
                                        setAreaAsDefault: setAreaAsDefault
                                    });
                                    _context.next = 3;
                                    return Object(__WEBPACK_IMPORTED_MODULE_9_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_10_sagas_regions_areas__["a" /* createArea */], toSave);

                                case 3:
                                    result = _context.sent;

                                    if (result) {
                                        // may be undefined on error
                                        _this6.props.selectArea(result._id);
                                    }

                                case 5:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this6);
                }));

                return function (_x3) {
                    return _ref3.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'computeNextArea',
        value: function computeNextArea(cb) {
            var _this7 = this;

            var coords = [];

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this.areaPath[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var path = _step3.value;

                    coords.push([this.getPolygonCoords(path)]);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            this.setState(function (state) {
                return {
                    area: _extends({}, state.area, {
                        areaCoordinatesPolygons: _extends({}, state.areaCoordinatesPolygons, {
                            type: 'MultiPolygon',
                            coordinates: coords
                        }),
                        showPortOnMap: undefined
                    })
                };
            }, function () {
                cb(_extends({}, _this7.state.area, {
                    recalculateChildPorts: _this7.state.recalculateChildPorts,
                    recalculateMainPorts: _this7.state.recalculateMainPorts
                }));
            });
        }
    }, {
        key: 'onChangeArea',
        value: function onChangeArea(area) {
            this.setState({
                area: area
            });
        }
    }, {
        key: 'createNewArea',
        value: function createNewArea() {
            var _this8 = this;

            this.setState({
                area: this.getDefaultArea(undefined),
                areaId: undefined,
                showMarkersOnlyInThisArea: false,
                ports: this.props.ports,
                showPortOnMap: undefined
            }, function () {
                _this8.areaPath = [];
                _this8.props.selectArea(_this8.state.area._id);
            });
        }
    }, {
        key: 'getPolygonCoords',
        value: function getPolygonCoords(path) {
            return path.getArray().map(function (item) {
                return [item.lng(), item.lat()];
            });
        }
    }, {
        key: 'handleAreaPathReady',
        value: function handleAreaPathReady(polygons) {
            this.areaPath = polygons;
        }
    }, {
        key: 'onChangePortFromAutoComplete',
        value: function onChangePortFromAutoComplete(portFromAutoComplete) {
            this.setState({
                portFromAutoComplete: portFromAutoComplete
            });
        }
    }, {
        key: 'addPortToRegion',
        value: function addPortToRegion() {
            this.addPort(this.state.portFromAutoComplete);
        }
    }, {
        key: 'toggleMainChildPort',
        value: function toggleMainChildPort(port, value) {
            var area = this.state.area;


            if (value) {
                area.mainChildPorts.add(port._id);
            } else {
                area.mainChildPorts.delete(port._id);
            }

            this.setState({
                area: _extends({}, area, {
                    showPortOnMap: undefined
                }),
                recalculateChildPorts: false
            });
        }
    }, {
        key: 'toggleMainPort',
        value: function toggleMainPort(port, value) {
            var area = this.state.area;


            area.mainPorts.clear();

            if (value) {
                area.mainPorts.add(port._id);
            }

            this.setState({
                area: _extends({}, area, {
                    showPortOnMap: undefined
                }),
                recalculateMainPorts: false
            });
        }
    }, {
        key: 'removePorts',
        value: function removePorts(ports) {
            var area = this.state.area;


            ports.forEach(function (item) {
                area.childs.delete(item._id);
                area.mainChildPorts.delete(item._id);
            });

            this.setState({
                area: _extends({}, area, {
                    showPortOnMap: undefined
                }),
                recalculateChildPorts: false

            });
        }
    }, {
        key: 'removePort',
        value: function removePort(port) {
            var area = this.state.area;


            area.mainChildPorts.delete(port._id);
            area.mainPorts.delete(port._id);
            area.childs.delete(port._id);

            this.setState({
                area: _extends({}, area, {
                    showPortOnMap: undefined
                }),
                recalculateChildPorts: false
            });
        }
    }, {
        key: 'addPort',
        value: function addPort(port) {
            var area = this.state.area;


            area.childs.add(port._id);

            this.setState({
                area: _extends({}, area, {
                    showPortOnMap: undefined
                }),
                portFromAutoComplete: {
                    name: ''
                }
            });
        }
    }, {
        key: 'togglePort',
        value: function togglePort(port) {
            var area = this.state.area;


            if (Array.isArray(port)) {
                return this.removePorts(port);
            }

            if (area.childs.has(port._id)) {
                this.removePort(port);
            } else {
                this.addPort(port);
            }
        }
    }, {
        key: 'toggleShowPorts',
        value: function toggleShowPorts() {
            this.setState({
                showChilds: 'ports'
            });
        }
    }, {
        key: 'toggleShowAreas',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.setState({
                                    showChilds: 'areas'
                                });

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function toggleShowAreas() {
                return _ref4.apply(this, arguments);
            }

            return toggleShowAreas;
        }()
    }, {
        key: 'selectParentArea',
        value: function selectParentArea(areaId) {
            var _this9 = this;

            __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].getArea(areaId).then(function (response) {
                _this9.setState({
                    area: _this9.getDefaultArea(areaId, response.data),
                    recalculateChildPorts: false
                }, function () {
                    _this9.props.selectParentArea(_this9.state.area._id);
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                showMarkersOnlyInThisArea = _state.showMarkersOnlyInThisArea,
                ports = _state.ports,
                portFromAutoComplete = _state.portFromAutoComplete,
                area = _state.area,
                recalculateChildPorts = _state.recalculateChildPorts,
                recalculateMainPorts = _state.recalculateMainPorts,
                showView = _state.showView,
                showChilds = _state.showChilds;
            var user = this.props.user;


            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'col-xs-4' },
                    showChilds === 'ports' ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Ports_Component__["a" /* default */], {
                        portFromAutoComplete: portFromAutoComplete,
                        selectedArea: area,
                        toggleMainChildPort: this.toggleMainChildPort,
                        toggleMainPort: this.toggleMainPort,
                        removePort: this.removePort,
                        showPort: this.showPort,
                        addPort: this.addPort,
                        onChangeArea: this.onChangeArea,
                        onChangePortFromAutoComplete: this.onChangePortFromAutoComplete,
                        toggleShowPorts: this.toggleShowPorts,
                        toggleShowAreas: this.toggleShowAreas,
                        showChilds: showChilds
                    }) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Areas_Areas__["a" /* default */], {
                        toggleShowPorts: this.toggleShowPorts,
                        toggleShowAreas: this.toggleShowAreas,
                        area: area,
                        selectParentArea: this.selectParentArea,
                        showChilds: showChilds
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'col-xs-8' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Management__["a" /* default */], {
                        area: area,
                        user: user,
                        showView: showView,
                        portFromAutoComplete: portFromAutoComplete,
                        changeMapView: this.changeMapView,
                        addPortToRegion: this.addPortToRegion,
                        onChangeArea: this.onChangeArea,
                        createNewArea: this.createNewArea,
                        createAreaOnServer: this.createAreaOnServer,
                        updateAreaOnServer: this.updateAreaOnServer,
                        deleteAreaOnServer: this.deleteAreaOnServer,
                        recalculateOnSave: recalculateChildPorts,
                        recalculateMainPorts: recalculateMainPorts,
                        toggleRecalculateChilds: this.toggleRecalculateChilds,
                        toggleRecalculateMainPorts: this.toggleRecalculateMainPorts,
                        showMarkersOnlyInThisArea: showMarkersOnlyInThisArea,
                        toggleShowMarkersOnlyInThisArea: this.toggleShowMarkersOnlyInThisArea,
                        addPort: this.addPort,
                        router: this.props.router,
                        countries: this.props.countries
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Map_Component__["a" /* default */], {
                        showView: showView,
                        area: area,
                        ports: ports,
                        onChangeArea: this.onChangeArea,
                        onAreaPathReady: this.handleAreaPathReady,
                        createNewArea: this.createNewArea,
                        togglePort: this.togglePort,
                        showMarkersOnlyInThisArea: showMarkersOnlyInThisArea,
                        updateAreaOnServer: this.updateAreaOnServer
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AreaEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
    var area = __WEBPACK_IMPORTED_MODULE_2_lodash__["find"](state.areas.items, { _id: props.areaId });
    return {
        user: state.user.user,
        area: area,
        ports: state.ports,
        countries: __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](state, 'countries.items', [])
    };
}

var Editor = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
    getArea: __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__["b" /* getArea */],
    updateArea: __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__["g" /* updateArea */],
    deleteArea: __WEBPACK_IMPORTED_MODULE_7_actions_regions_areas__["a" /* deleteArea */],
    getCountries: __WEBPACK_IMPORTED_MODULE_8_actions_countries__["a" /* getCountries */]
})(AreaEditor);


;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AreaEditor, 'AreaEditor', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/AreaEditor.jsx');
    reactHotLoader.register(mapStateToProps, 'mapStateToProps', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/AreaEditor.jsx');
    reactHotLoader.register(Editor, 'Editor', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/AreaEditor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortsAutoComplete__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PortItem__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortsAreasToggler__ = __webpack_require__(937);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Ports = function (_React$Component) {
    _inherits(Ports, _React$Component);

    function Ports(props) {
        _classCallCheck(this, Ports);

        return _possibleConstructorReturn(this, (Ports.__proto__ || Object.getPrototypeOf(Ports)).call(this, props));
    }

    _createClass(Ports, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                selectedArea = _props.selectedArea,
                relatedPorts = _props.relatedPorts,
                onChangeArea = _props.onChangeArea,
                onChangePortFromAutoComplete = _props.onChangePortFromAutoComplete,
                toggleMainChildPort = _props.toggleMainChildPort,
                toggleMainPort = _props.toggleMainPort,
                portFromAutoComplete = _props.portFromAutoComplete,
                removePort = _props.removePort,
                addPort = _props.addPort,
                showPort = _props.showPort,
                showChilds = _props.showChilds,
                toggleShowPorts = _props.toggleShowPorts,
                toggleShowAreas = _props.toggleShowAreas;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-9' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PortsAutoComplete__["a" /* default */], {
                            showPort: showPort,
                            onChangeArea: onChangeArea,
                            selectedArea: selectedArea,
                            onChangePortFromAutoComplete: onChangePortFromAutoComplete,
                            portFromAutoComplete: portFromAutoComplete
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PortsAreasToggler__["a" /* default */], {
                            toggleShowPorts: toggleShowPorts,
                            toggleShowAreas: toggleShowAreas,
                            showChilds: showChilds
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-9' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute small-name' },
                        'List of ports'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { overflowY: 'scroll', height: '75vh', width: '100%' } },
                        selectedArea.childs.size ? Array.from(selectedArea.childs, function (portId, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PortItem__["a" /* PortItem */], {
                                key: index,
                                showPort: showPort,
                                child: relatedPorts.get(portId),
                                isMainChildPort: selectedArea.mainChildPorts.has(portId),
                                isMainPort: selectedArea.mainPorts.has(portId),
                                removePort: removePort,
                                toggleMainChildPort: toggleMainChildPort,
                                toggleMainPort: toggleMainPort
                            });
                        }) : null
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Ports;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

function mapStateToProps(state, props) {
    var relatedPorts = new Map();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = props.selectedArea.childs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var portId = _step.value;

            relatedPorts.set(portId, __WEBPACK_IMPORTED_MODULE_2_lodash__["find"](state.ports.items, { _id: portId }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return {
        relatedPorts: relatedPorts
    };
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Ports);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Ports, 'Ports', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Ports/Component.jsx');
    reactHotLoader.register(mapStateToProps, 'mapStateToProps', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Ports/Component.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Ports/Component.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton_IconButton__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PortsAutoComplete = function (_React$Component) {
    _inherits(PortsAutoComplete, _React$Component);

    function PortsAutoComplete(props) {
        _classCallCheck(this, PortsAutoComplete);

        var _this = _possibleConstructorReturn(this, (PortsAutoComplete.__proto__ || Object.getPrototypeOf(PortsAutoComplete)).call(this, props));

        _this.state = {
            ports: []
        };

        _this.onUpdateInput = _this.onUpdateInput.bind(_this);
        _this.onChooseAutoComplete = _this.onChooseAutoComplete.bind(_this);
        return _this;
    }

    _createClass(PortsAutoComplete, [{
        key: 'onUpdateInput',
        value: function onUpdateInput(searchText) {
            var _this2 = this;

            this.props.onChangePortFromAutoComplete({ name: searchText });

            if (searchText.length <= 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].findPortAdmin({ name: searchText }).then(function (response) {
                if (response.status === 200) {
                    var ports = [];

                    response.data.data.forEach(function (item) {
                        ports.push({
                            name: item.name + ' (' + (item.country ? item.country.name : '') + ')',
                            item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                                primaryText: item.name + ' (' + (item.country ? item.country.name : '') + ')',
                                item: item

                            })
                        });

                        if (item.sub && item.sub.length > 0) {
                            item.sub.forEach(function (subPort) {
                                ports.push({
                                    name: subPort.name + ' (' + (item.country ? item.country.name : '') + ')',
                                    item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                                        style: { padding: '0 0 0 20px' },
                                        primaryText: subPort.name + ' (' + (item.country ? item.country.name : '') + ')',
                                        item: subPort

                                    })
                                });
                            });
                        }
                    });

                    _this2.setState({
                        ports: ports
                    }, function () {
                        document.body.scrollTop = document.body.scrollTop + 1;
                        document.body.scrollTop = document.body.scrollTop - 1;

                        var selectedArea = _this2.props.selectedArea;

                        selectedArea.isAddPort = false;
                        _this2.props.onChangeArea(selectedArea);
                    });
                }
            });
        }
    }, {
        key: 'onChooseAutoComplete',
        value: function onChooseAutoComplete(updateProperties) {
            var _this3 = this;

            var portName = null;

            if (typeof updateProperties === 'string') {
                return;
            }

            portName = updateProperties.item.props.item.name;

            this.setState({
                canShow: false,
                selectedPort: updateProperties.item.props.item,
                portName: portName,
                ports: []
            }, function () {
                var selectedArea = _this3.props.selectedArea;

                selectedArea.isAddPort = true;
                _this3.props.onChangeArea(selectedArea);
                _this3.props.onChangePortFromAutoComplete(updateProperties.item.props.item);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var ports = this.state.ports;
            var _props = this.props,
                portFromAutoComplete = _props.portFromAutoComplete,
                showPort = _props.showPort;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block margin-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block absolute small-name' },
                    'Ports Auto Complete'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'middle-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
                        floatingLabelText: 'Port name',
                        searchText: portFromAutoComplete.name,
                        dataSource: ports,
                        dataSourceConfig: { text: 'name', value: 'item' },
                        onUpdateInput: this.onUpdateInput,
                        onNewRequest: this.onChooseAutoComplete,
                        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
                        style: { width: '100%' },
                        listStyle: { maxHeight: '300px', overflow: 'auto' },
                        fullWidth: true,
                        popoverProps: {
                            canAutoPosition: true,
                            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                            targetOrigin: { horizontal: 'left', vertical: 'top' }
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_IconButton_IconButton___default.a,
                        {
                            disabled: portFromAutoComplete._id ? false : true,
                            onClick: function onClick() {
                                showPort(portFromAutoComplete, false);
                            } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility___default.a, null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PortsAutoComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = PortsAutoComplete;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsAutoComplete, 'PortsAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Ports/PortsAutoComplete.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Ports/PortsAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = PortItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton_IconButton__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_close__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_toggle_star__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_toggle_star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_toggle_star__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_toggle_star_border__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_toggle_star_border___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_toggle_star_border__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/*
 * @Author: Sergiy Samborskiy
 * @Date: 2017-11-15 17:18:56
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2017-11-15 17:29:35
 */










function PortItem(props) {
    var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        showMarkMain = _React$useState2[0],
        setShowMarkMain = _React$useState2[1];

    var child = props.child,
        isMainPort = props.isMainPort,
        isMainChildPort = props.isMainChildPort,
        toggleMainChildPort = props.toggleMainChildPort,
        toggleMainPort = props.toggleMainPort,
        removePort = props.removePort,
        showPort = props.showPort;


    if (!child) {
        return '';
    }

    /**
     * 
     * @param {MouseEvent} e 
     */
    var show = function show(e) {
        e.preventDefault();
        setShowMarkMain(true);
    };

    /**
     * 
     * @param {MouseEvent} e 
     */
    var notShow = function notShow(e) {
        e.preventDefault();
        setShowMarkMain(false);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        {
            style: { width: '100%', margin: 0 },
            onMouseOver: function onMouseOver(e) {
                return show(e);
            },
            onMouseLeave: function onMouseLeave(e) {
                return notShow(e);
            }
        },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            {
                style: {
                    width: '100%', fontSize: '12px', display: 'flex', alignItems: 'center'
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default.a, {
                checked: isMainChildPort,
                style: { width: '80%', display: 'block' },
                label: child.name,
                onCheck: function onCheck(e, value) {
                    toggleMainChildPort(child, value);
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton_IconButton___default.a,
                {
                    onClick: function onClick() {
                        toggleMainPort(child, !isMainPort);
                    }
                },
                isMainPort ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_toggle_star___default.a, null) : showMarkMain && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_toggle_star_border___default.a, null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton_IconButton___default.a,
                { onClick: function onClick() {
                        showPort(child);
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_visibility___default.a, null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton_IconButton___default.a,
                { onClick: function onClick() {
                        removePort(child);
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_close___default.a, null)
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortItem, 'PortItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Ports/PortItem.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapPorts__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Regions_Merging_Page__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Regions_ByCoords_ByCoordsPage__ = __webpack_require__(2320);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MapDashboard = function (_React$Component) {
    _inherits(MapDashboard, _React$Component);

    function MapDashboard() {
        _classCallCheck(this, MapDashboard);

        return _possibleConstructorReturn(this, (MapDashboard.__proto__ || Object.getPrototypeOf(MapDashboard)).apply(this, arguments));
    }

    _createClass(MapDashboard, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                area = _props.area,
                ports = _props.ports,
                togglePort = _props.togglePort,
                onAreaPathReady = _props.onAreaPathReady,
                showMarkersOnlyInThisArea = _props.showMarkersOnlyInThisArea,
                showView = _props.showView,
                createNewArea = _props.createNewArea,
                onChangeArea = _props.onChangeArea;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { position: 'relative', width: '100%', height: '79.7vh' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: showView === 'map' ? 'paper-block margin-10' : 'hidden' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block absolute small-name' },
                            'Map'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MapPorts__["a" /* default */], {
                            area: area,
                            togglePort: togglePort,
                            ports: ports,
                            onAreaPathReady: onAreaPathReady,
                            showMarkersOnlyInThisArea: showMarkersOnlyInThisArea
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: showView === 'merge' ? 'paper-block margin-10' : 'hidden', style: { height: '78.5vh', overflow: 'auto' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block absolute small-name' },
                            'MERGING'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Regions_Merging_Page__["a" /* default */], {
                            area: area,
                            createNewArea: createNewArea
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: showView === 'addByCoords' ? 'paper-block margin-10' : 'hidden', style: { height: '77.8vh', overflow: 'auto' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block absolute small-name' },
                            'Create/update port by coords'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Regions_ByCoords_ByCoordsPage__["a" /* default */], {
                            area: area,
                            onChangeArea: onChangeArea
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return MapDashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = MapDashboard;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MapDashboard, 'MapDashboard', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/Component.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/Component.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__markerClusterer__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_images_chart_png__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_images_chart_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_images_chart_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_images_chart_blue_png__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_images_chart_blue_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_images_chart_blue_png__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
        _classCallCheck(this, Map);

        var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

        _this.state = {
            ports: [],
            childs: []
        };

        _this.showMarkerInfo = _this.showMarkerInfo.bind(_this);

        _this.drawingManager = undefined;
        _this.polygons = [];

        _this.DMforDeletePolygon = undefined;
        _this.polygonForDelete = undefined;

        _this.markerClusterer = undefined;
        return _this;
    }

    _createClass(Map, [{
        key: 'showMarkerInfo',
        value: function showMarkerInfo(port) {
            this.props.togglePort(port);
        }
    }, {
        key: 'addMarkerClusterToMap',
        value: function addMarkerClusterToMap(ports) {
            var _this2 = this;

            var markers = [];
            this.markers = new window.Map();

            if (this.markerClusterer) {
                this.markerClusterer.clearMarkers();
            }

            var portsLenght = ports.length;

            var _loop = function _loop(i) {
                if (ports[i].coordinates) {
                    var marker = new google.maps.Marker({
                        position: {
                            lat: ports[i].coordinates[1],
                            lng: ports[i].coordinates[0]
                        },
                        icon: {
                            labelOrigin: new google.maps.Point(11, 50),
                            url: __WEBPACK_IMPORTED_MODULE_3_assets_images_chart_png___default.a,
                            size: new google.maps.Size(22, 40),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(11, 40)
                        },
                        title: 'noSelected',
                        label: {
                            color: 'black',
                            fontWeight: 'bold',
                            text: ports[i].name
                        }
                    });

                    google.maps.event.addListener(marker, 'click', function () {
                        _this2.showMarkerInfo(ports[i]);
                    });

                    _this2.markers.set(ports[i]._id, marker);
                    markers.push(marker);
                }
            };

            for (var i = 0; i < portsLenght; i++) {
                _loop(i);
            }

            var opt = {
                legend: {
                    noSelected: '#9dffa1',
                    selected: '#0000ff'
                }
            };

            this.markerClusterer = new __WEBPACK_IMPORTED_MODULE_2__markerClusterer__["a" /* default */](this.map, markers, opt);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var isSameArea = nextProps.area._id === this.props.area._id;

            if (nextProps.showMarkersOnlyInThisArea && !isSameArea || nextProps.ports.items.length !== this.props.ports.items.length) {
                this.addMarkerClusterToMap(nextProps.ports.items);
            }

            this.colorizeMarkers(nextProps);

            var childs = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = nextProps.area.childs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var value = _step.value;

                    childs.push(value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.markerClusterer && !__WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"](childs, this.state.childs)) {
                this.markerClusterer.repaint();
            }

            this.setState({
                ports: nextProps.ports.items,
                childs: childs
            });
        }
    }, {
        key: 'colorizeMarkers',
        value: function colorizeMarkers(nextProps) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = nextProps.ports.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var port = _step2.value;

                    var marker = this.markers.get(port._id);

                    if (marker && marker.getLabel().color === 'blue' && !nextProps.area.childs.has(port._id)) {
                        marker && marker.setLabel(_extends({}, marker.getLabel(), {
                            color: 'black'
                        }));

                        marker && marker.setIcon(_extends({}, marker.getIcon(), {
                            url: __WEBPACK_IMPORTED_MODULE_3_assets_images_chart_png___default.a
                        }));

                        marker.title = 'noSelected';
                    }

                    if (nextProps.area.childs.has(port._id)) {
                        marker && marker.setLabel(_extends({}, marker.getLabel(), {
                            color: 'blue'
                        }));

                        marker && marker.setIcon(_extends({}, marker.getIcon(), {
                            url: __WEBPACK_IMPORTED_MODULE_4_assets_images_chart_blue_png___default.a
                        }));

                        marker.title = 'selected';
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: 'updateAreaDataStorage',
        value: function updateAreaDataStorage() {
            this.props.onAreaPathReady(this.polygons.map(function (p) {
                return p.getPath();
            }));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.map = new google.maps.Map(this.refs.map, {
                zoom: 2,
                center: {
                    lat: 49.171839,
                    lng: 10.433250
                },
                gestureHandling: 'greedy',
                styles: [{
                    featureType: 'administrative.locality',
                    elementType: 'labels',
                    stylers: [{ visibility: 'off' }]
                }]
            });

            window.mainMap = this.map;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _this3 = this;

            if (!this.map) {
                return;
            }

            if (!google.maps) {
                return;
            }

            if (this.props.area.showPortOnMap) {
                var currentPort = this.props.ports.items.filter(function (port) {
                    return _this3.props.area.showPortOnMap === port._id;
                });

                this.map.setCenter(this.toLatLng([currentPort[0].coordinates])[0]);
                this.map.setZoom(10);
            }

            var isSameArea = this.props.area._id === prevProps.area._id;
            var shapeEquals = __WEBPACK_IMPORTED_MODULE_1_lodash__["isEqual"](this.props.area.areaCoordinatesPolygons, prevProps.area.areaCoordinatesPolygons);
            var markersChanged = prevProps.showMarkersOnlyInThisArea !== this.props.showMarkersOnlyInThisArea;

            if (isSameArea && shapeEquals && !markersChanged && (this.drawingManager || this.polygons.length > 0)) {
                return;
            }

            if (this.drawingManager) {
                this.clearDrawingManager();
            }

            this.setupDrawingManager();

            this.removePolygon();

            this.setBoundsCoordinates();
            this.drawAreas();
            this.checkIsNewArea();
            this.createDeletePolygon();
        }
    }, {
        key: 'setBoundsCoordinates',
        value: function setBoundsCoordinates() {
            var _this4 = this;

            var areasPorts = this.props.ports.items.filter(function (port) {
                if (_this4.props.area.childs.has(port._id)) {
                    return port;
                }
            });

            if (areasPorts.length > 0) {
                var coords = this.toLatLng(areasPorts.map(function (port) {
                    return port.coordinates;
                }));

                if (coords.length === 1) {
                    this.map.setCenter(coords[0]);
                    this.map.setZoom(10);
                } else {
                    this.fitBounds(coords);
                }
            } else {
                this.polyFitBounds(this.props.area.areaCoordinatesPolygons);
            }
        }
    }, {
        key: 'polyFitBounds',
        value: function polyFitBounds(multiPolygon) {
            if (!multiPolygon || !Array.isArray(multiPolygon.coordinates)) {
                return;
            }

            var bounds = new google.maps.LatLngBounds();

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = multiPolygon.coordinates[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var polygon = _step3.value;

                    var curr = new google.maps.LatLngBounds();

                    // we only use outer polygon to calculate bounds
                    // because inner paths must be enclosed in it
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = this.toLatLng(polygon[0])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var point = _step4.value;

                            curr.extend(point);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    bounds.union(curr);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            if (bounds.isEmpty()) {
                return;
            }

            this.map.fitBounds(bounds);
        }
    }, {
        key: 'clearDrawingManager',
        value: function clearDrawingManager() {
            this.drawingManager.setMap(null);

            google.maps.event.clearInstanceListeners(this.drawingManager);

            this.drawingManager = undefined;
        }
    }, {
        key: 'drawAreas',
        value: function drawAreas() {
            var multiPolygons = this.props.area.areaCoordinatesPolygons.coordinates;
            if (!multiPolygons) return;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = multiPolygons[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var polCoords = _step5.value;

                    if (this.hasValidPolygon(polCoords[0])) {
                        var coords = this.toLatLng(polCoords[0]);

                        var polygon = new google.maps.Polygon({
                            paths: coords,
                            strokeColor: '#00f',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: '#00f',
                            fillOpacity: 0.35,
                            editable: true,
                            draggable: true
                        });

                        polygon.setMap(this.map);
                        this.handlePolygon(polygon);
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
    }, {
        key: 'checkIsNewArea',
        value: function checkIsNewArea() {
            if (this.props.area.isNew) {
                if (!(this.polygonForDelete && this.DMforDeletePolygon)) {
                    return;
                }

                this.DMforDeletePolygon.setMap(null);
                this.polygonForDelete.setMap(null);

                google.maps.event.clearInstanceListeners(this.polygonForDelete);

                this.polygonForDelete = undefined;

                return;
            }
        }
    }, {
        key: 'setupDrawingManager',
        value: function setupDrawingManager() {
            var _this5 = this;

            if (this.drawingManager) {
                return;
            }
            this.drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon']
                },
                polygonOptions: {
                    editable: true,
                    fillColor: '#00f',
                    strokeColor: '#00f'
                }
            });

            google.maps.event.addListener(this.drawingManager, 'polygoncomplete', function (polygon) {
                _this5.handlePolygon(polygon);
            });

            this.drawingManager.setMap(this.map);
        }
    }, {
        key: 'createDeletePolygon',
        value: function createDeletePolygon() {
            var _this6 = this;

            var self = this;
            var checkbox = new Checkbox();
            var label = new Label();
            var parentControl = new ParentControl();

            parentControl.appendChild(label);
            parentControl.appendChild(checkbox);

            checkbox.addEventListener('change', function (e) {
                if (!e.target.checked) {
                    self.DMforDeletePolygon.setMap(null);

                    if (!self.polygonForDelete) {
                        return;
                    }

                    self.polygonForDelete.setMap(null);
                    google.maps.event.clearInstanceListeners(self.polygonForDelete);
                    self.polygonForDelete = undefined;
                    self.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].removeAt(1);

                    return;
                }

                _this6.DMforDeletePolygon = new google.maps.drawing.DrawingManager({
                    drawingMode: google.maps.drawing.OverlayType.POLYGON,
                    drawingControl: true,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.BOTTOM_CENTER,
                        drawingModes: ['polygon']
                    },
                    polygonOptions: {
                        editable: true,
                        fillColor: '#f00',
                        strokeColor: '#f00'
                    }
                });

                google.maps.event.addListener(self.DMforDeletePolygon, 'polygoncomplete', function (polygon) {
                    var parentControl = new ParentControl();
                    var buttonDelete = new ButtonDelete();

                    self.polygonForDelete = polygon;

                    self.polygonForDelete.setEditable(true);
                    self.polygonForDelete.setDraggable(true);

                    parentControl.appendChild(buttonDelete);
                    self.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(parentControl);

                    buttonDelete.addEventListener('click', function () {
                        var items = self.state.ports.filter(function (port) {
                            return self.props.area.childs.has(port._id);
                        });

                        self.itemsToDelete = items.filter(function (item) {
                            return google.maps.geometry.poly.containsLocation(new google.maps.LatLng(item.coordinates[1], item.coordinates[0]), self.polygonForDelete);
                        });

                        self.props.togglePort(self.itemsToDelete);

                        checkbox.checked = false;

                        self.DMforDeletePolygon.setMap(null);
                        self.polygonForDelete.setMap(null);

                        google.maps.event.clearInstanceListeners(self.polygonForDelete);
                        self.polygonForDelete = undefined;

                        self.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].removeAt(1);
                    });

                    _this6.DMforDeletePolygon.setMap(null);
                });

                _this6.DMforDeletePolygon.setMap(self.map);
            });

            this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear();
            this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(parentControl);
        }
    }, {
        key: 'fitBounds',
        value: function fitBounds(coords) {
            var bounds = new google.maps.LatLngBounds();

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = coords[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var point = _step6.value;

                    bounds.extend(point);
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            this.map.fitBounds(bounds);
        }
    }, {
        key: 'removePolygon',
        value: function removePolygon(only) {
            var toRemove = this.polygons;
            if (Array.isArray(only)) {
                toRemove = this.polygons.filter(function (p) {
                    return only.includes(p);
                });
            }
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = toRemove[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var polygon = _step7.value;

                    polygon.setMap(null);
                    google.maps.event.clearInstanceListeners(polygon);
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            this.polygons = this.polygons.filter(function (p) {
                return !toRemove.includes(p);
            });
        }
    }, {
        key: 'hasValidPolygon',
        value: function hasValidPolygon(polygon) {
            return polygon && polygon.length >= 3;
        }
    }, {
        key: 'handlePolygon',
        value: function handlePolygon(polygon) {
            var _this7 = this;

            this.polygons.push(polygon);

            var path = polygon.getPath();
            this.updateAreaDataStorage();

            var deleteMenu = buildDeleteBtn();
            var deletePolygon = buildDeletePolygon();

            var clean = function clean() {
                _this7.removePolygon([polygon]);
                _this7.updateAreaDataStorage();
            };

            google.maps.event.addListener(path, 'remove_at', function () {
                if (path.getLength() < 3) {
                    clean();
                }
            });

            google.maps.event.addListener(polygon, 'rightclick', function (e) {
                // Check if click was on a vertex control point
                if (e.vertex != undefined) {
                    return deleteMenu.open(_this7.map, polygon.getPath(), e.vertex);
                }

                deletePolygon.open(_this7.map, polygon, e, clean);
            });
        }
    }, {
        key: 'toLatLng',
        value: function toLatLng(array) {
            return array.map(function (point) {
                return { lng: point[0], lat: point[1] };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { ref: 'map', style: { height: '75vh' } });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Map;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Map;
/* harmony default export */ __webpack_exports__["a"] = (_default);


function Checkbox() {
    var checkbox = document.createElement('input');

    checkbox.type = 'checkbox';
    checkbox.id = 'remove-ports';

    checkbox.style.display = 'inlineBlock';
    checkbox.style.width = '15px';
    checkbox.style.height = '15px';
    checkbox.style.cursor = 'pointer';

    return checkbox;
}

function Label() {
    var label = document.createElement('label');

    label.htmlFor = 'remove-ports';
    label.innerHTML = 'Remove ports';

    label.style.fontSize = '18px';
    label.style.marginRight = '10px';
    label.style.display = 'inlineBlock';
    label.style.cursor = 'pointer';

    return label;
}

function ButtonDelete() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DELETE PORTS';

    var button = document.createElement('button');

    button.style.backgroundColor = '#fff';
    button.style.fontSize = '16px';
    button.innerHTML = text;

    return button;
}

function ParentControl() {
    var controlDiv = document.createElement('div');

    controlDiv.type = 'checkbox';
    controlDiv.id = 'parent-block-remove-ports';

    controlDiv.style.backgroundColor = '#fff';
    controlDiv.style.width = '160px';
    controlDiv.style.height = '24px';
    controlDiv.style.marginBottom = '5px';
    controlDiv.style.padding = '10px';
    controlDiv.style.display = 'flex';
    controlDiv.style.justifyContent = 'center';
    controlDiv.style.alignItems = 'center';

    return controlDiv;
}

function buildDeleteBtn() {
    function DeleteMenu() {
        this.div_ = document.createElement('div');
        this.div_.className = 'delete-menu';
        this.div_.innerHTML = 'Delete';

        var menu = this;

        google.maps.event.addDomListener(this.div_, 'click', function () {
            menu.removeVertex();
        });
    }

    DeleteMenu.prototype = new google.maps.OverlayView();

    DeleteMenu.prototype.onAdd = function () {
        var deleteMenu = this;
        var map = this.getMap();
        this.getPanes().floatPane.appendChild(this.div_);

        // mousedown anywhere on the map except on the menu div will close the
        // menu.
        this.divListener_ = google.maps.event.addDomListener(map.getDiv(), 'mousedown', function (e) {
            if (e.target != deleteMenu.div_) {
                deleteMenu.close();
            }
        }, true);
    };

    DeleteMenu.prototype.onRemove = function () {
        google.maps.event.removeListener(this.divListener_);
        this.div_.parentNode.removeChild(this.div_);

        // clean up
        this.set('position');
        this.set('path');
        this.set('vertex');
    };

    DeleteMenu.prototype.close = function () {
        this.setMap(null);
    };

    DeleteMenu.prototype.draw = function () {
        var position = this.get('position');
        var projection = this.getProjection();

        if (!(position && projection)) {
            return;
        }

        var point = projection.fromLatLngToDivPixel(position);
        this.div_.style.top = point.y + 'px';
        this.div_.style.left = point.x + 'px';
    };

    /**
     * Opens the menu at a vertex of a given path.
     */
    DeleteMenu.prototype.open = function (map, path, vertex) {
        this.set('position', path.getAt(vertex));
        this.set('path', path);
        this.set('vertex', vertex);
        this.setMap(map);
        this.draw();
    };

    /**
     * Deletes the vertex from the path.
     */
    DeleteMenu.prototype.removeVertex = function () {
        var path = this.get('path');
        var vertex = this.get('vertex');

        if (!path || vertex == undefined) {
            this.close();
            return;
        }

        path.removeAt(vertex);
        this.close();
    };

    return new DeleteMenu();
}

function buildDeletePolygon() {
    function deletePolygonBtn() {
        this.div_ = document.createElement('div');
        this.div_.className = 'delete-menu';
        this.div_.innerHTML = 'Delete polygon';

        var self = this;

        google.maps.event.addDomListener(this.div_, 'click', function () {
            self.removeCurrentPolygon();
        });
    }

    deletePolygonBtn.prototype = new google.maps.OverlayView();

    deletePolygonBtn.prototype.removeCurrentPolygon = function () {
        this.get('onClick')();

        this.close();
    };

    deletePolygonBtn.prototype.onAdd = function () {
        var deleteMenu = this;
        var map = this.getMap();
        this.getPanes().floatPane.appendChild(this.div_);

        this.divListener_ = google.maps.event.addDomListener(map.getDiv(), 'mousedown', function (e) {
            if (e.target != deleteMenu.div_) {
                deleteMenu.close();
            }
        }, true);
    };

    deletePolygonBtn.prototype.onRemove = function () {
        google.maps.event.removeListener(this.divListener_);
        this.div_.parentNode.removeChild(this.div_);

        // clean up
        this.set('position');
        this.set('polygon');
        this.set('onClick');
    };

    deletePolygonBtn.prototype.open = function (map, polygon, event, onClick) {
        this.set('position', event.latLng);
        this.set('polygon', polygon);
        this.set('onClick', onClick);

        this.setMap(map);
        this.draw();
    };

    deletePolygonBtn.prototype.close = function () {
        this.setMap(null);
    };

    deletePolygonBtn.prototype.draw = function () {
        var position = this.get('position');
        var projection = this.getProjection();

        if (!position || !projection) {
            return;
        }

        var point = projection.fromLatLngToDivPixel(position);
        this.div_.style.top = point.y + 'px';
        this.div_.style.left = point.x + 'px';
    };

    return new deletePolygonBtn();
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Map, 'Map', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    reactHotLoader.register(Checkbox, 'Checkbox', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    reactHotLoader.register(Label, 'Label', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    reactHotLoader.register(ButtonDelete, 'ButtonDelete', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    reactHotLoader.register(ParentControl, 'ParentControl', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    reactHotLoader.register(buildDeleteBtn, 'buildDeleteBtn', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    reactHotLoader.register(buildDeletePolygon, 'buildDeletePolygon', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/MapPorts.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libs_chartist__ = __webpack_require__(2316);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/**
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0.1
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 * <br/>
 * This is a v3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >v2 MarkerClusterer</a>.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * A Marker Clusterer that clusters markers.
 *
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>=} opt_markers Optional markers to add to
 *   the cluster.
 * @param {Object=} opt_options support the following options:
 *     'gridSize': (number) The grid size of a cluster in pixels.
 *     'maxZoom': (number) The maximum zoom level that a marker can be part of a
 *                cluster.
 *     'zoomOnClick': (boolean) Whether the default behaviour of clicking on a
 *                    cluster is to zoom into it.
 *     'averageCenter': (boolean) Whether the center of each cluster should be
 *                      the average of all markers in the cluster.
 *     'minimumClusterSize': (number) The minimum number of markers to be in a
 *                           cluster before the markers are hidden and a count
 *                           is shown.
 *     'styles': (object) An object that has style properties:
 *       'url': (string) The image url.
 *       'height': (number) The image height.
 *       'width': (number) The image width.
 *       'anchor': (Array) The anchor position of the label text.
 *       'textColor': (string) The text color.
 *       'textSize': (number) The text size.
 *       'backgroundPosition': (string) The position of the backgound x, y.
 * @constructor
 * @extends google.maps.OverlayView
 */

function MarkerClusterer(map, opt_markers, opt_options) {
    // MarkerClusterer implements google.maps.OverlayView interface. We use the
    // extend function to extend MarkerClusterer with google.maps.OverlayView
    // because it might not always be available when the code is defined so we
    // look for it at the last possible moment. If it doesn't exist now then
    // there is no point going ahead :)

    this.extend(MarkerClusterer, google.maps.OverlayView);
    this.map_ = map;

    /**
     * @type {Array.<google.maps.Marker>}
     * @private
     */
    this.markers_ = [];

    /**
     *  @type {Array.<Cluster>}
     */
    this.clusters_ = [];

    this.sizes = [53, 56, 66, 78, 90];

    /**
     * @private
     */
    this.styles_ = [];

    /**
     * @type {boolean}
     * @private
     */
    this.ready_ = false;

    var options = opt_options || {};

    /**
     * @type {number}
     * @private
     */
    this.gridSize_ = options['gridSize'] || 60;

    /**
     * @private
     */
    this.minClusterSize_ = options['minimumClusterSize'] || 2;

    /**
     * @private
     */
    this.legend_ = options['legend'] || {};

    /**
     * @type {?number}
     * @private
     */
    this.maxZoom_ = options['maxZoom'] || null;

    this.styles_ = options['styles'] || [];

    /**
     * @type {string}
     * @private
     */
    this.imagePath_ = options['imagePath'] || this.MARKER_CLUSTER_IMAGE_PATH_;

    /**
     * @type {string}
     * @private
     */
    this.imageExtension_ = options['imageExtension'] || this.MARKER_CLUSTER_IMAGE_EXTENSION_;

    /**
     * @type {boolean}
     * @private
     */
    this.zoomOnClick_ = true;

    if (options['zoomOnClick'] != undefined) {
        this.zoomOnClick_ = options['zoomOnClick'];
    }

    /**
     * @type {boolean}
     * @private
     */
    this.averageCenter_ = false;

    if (options['averageCenter'] != undefined) {
        this.averageCenter_ = options['averageCenter'];
    }

    this.setupStyles_();

    this.setMap(map);

    /**
     * @type {number}
     * @private
     */
    this.prevZoom_ = this.map_.getZoom();

    // Add the map event listeners
    var that = this;
    google.maps.event.addListener(this.map_, 'zoom_changed', function () {
        // Determines map type and prevent illegal zoom levels
        var zoom = that.map_.getZoom();
        var minZoom = that.map_.minZoom || 0;
        var maxZoom = Math.min(that.map_.maxZoom || 100, that.map_.mapTypes[that.map_.getMapTypeId()].maxZoom);
        zoom = Math.min(Math.max(zoom, minZoom), maxZoom);

        if (that.prevZoom_ != zoom) {
            that.prevZoom_ = zoom;
            that.resetViewport();
        }
    });

    google.maps.event.addListener(this.map_, 'idle', function () {
        that.redraw();
    });

    // Finally, add the markers
    if (opt_markers && (opt_markers.length || Object.keys(opt_markers).length)) {
        this.addMarkers(opt_markers, false);
    }
}

/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = 'https://raw.githubusercontent.com/googlemaps/js-marker-clusterer/gh-pages/images/m';

/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';

/**
 * Extends a objects prototype by anothers.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function (obj1, obj2) {
    return function (object) {
        for (var property in object.prototype) {
            this.prototype[property] = object.prototype[property];
        }
        return this;
    }.apply(obj1, [obj2]);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function () {
    this.setReady_(true);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function () {};

/**
 * Sets up the styles object.
 *
 * @private
 */
MarkerClusterer.prototype.setupStyles_ = function () {
    if (this.styles_.length) {
        return;
    }

    for (var i = 0, size; size = this.sizes[i]; i++) {
        this.styles_.push({
            url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
            height: size,
            width: size
        });
    }
};

/**
 *  Fit the map to the bounds of the markers in the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0, marker; marker = markers[i]; i++) {
        bounds.extend(marker.getPosition());
    }

    this.map_.fitBounds(bounds);
};

/**
 *  Sets the styles.
 *
 *  @param {Object} styles The style to set.
 */
MarkerClusterer.prototype.setStyles = function (styles) {
    this.styles_ = styles;
};

/**
 *  Gets the styles.
 *
 *  @return {Object} The styles object.
 */
MarkerClusterer.prototype.getStyles = function () {
    return this.styles_;
};

/**
 *  Sets the Legend.
 *
 *  @param {Object} styles The legend to set.
 */
MarkerClusterer.prototype.setLegend = function (legend) {
    this.legend_ = legend;
};

/**
 *  Gets the Legend.
 *
 *  @return {Object} The legend object.
 */
MarkerClusterer.prototype.getLegend = function () {
    return this.legend_;
};

/**
 * Whether zoom on click is set.
 *
 * @return {boolean} True if zoomOnClick_ is set.
 */
MarkerClusterer.prototype.isZoomOnClick = function () {
    return this.zoomOnClick_;
};

/**
 * Whether average center is set.
 *
 * @return {boolean} True if averageCenter_ is set.
 */
MarkerClusterer.prototype.isAverageCenter = function () {
    return this.averageCenter_;
};

/**
 *  Returns the array of markers in the clusterer.
 *
 *  @return {Array.<google.maps.Marker>} The markers.
 */
MarkerClusterer.prototype.getMarkers = function () {
    return this.markers_;
};

/**
 *  Returns the number of markers in the clusterer
 *
 *  @return {Number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function () {
    return this.markers_.length;
};

/**
 *  Sets the max zoom for the clusterer.
 *
 *  @param {number} maxZoom The max zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom_ = maxZoom;
};

/**
 *  Gets the max zoom for the clusterer.
 *
 *  @return {number} The max zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function () {
    return this.maxZoom_;
};

/**
 *  The function for calculating the cluster icon image.
 *
 *  @param {Array.<google.maps.Marker>} markers The markers in the clusterer.
 *  @param {number} numStyles The number of styles available.
 *  @return {Object} A object properties: 'text' (string) and 'index' (number).
 *  @private
 */
MarkerClusterer.prototype.calculator_ = function (markers, numStyles) {
    var index = 0;
    var count = markers.length;
    var dv = count;
    while (dv !== 0) {
        dv = parseInt(dv / 10, 10);
        index++;
    }

    index = Math.min(index, numStyles);
    return {
        text: count,
        index: index
    };
};

/**
 * Set the calculator function.
 *
 * @param {function(Array, number)} calculator The function to set as the
 *     calculator. The function should return a object properties:
 *     'text' (string) and 'index' (number).
 *
 */
MarkerClusterer.prototype.setCalculator = function (calculator) {
    this.calculator_ = calculator;
};

/**
 * Get the calculator function.
 *
 * @return {function(Array, number)} the calculator function.
 */
MarkerClusterer.prototype.getCalculator = function () {
    return this.calculator_;
};

/**
 * Add an array of markers to the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
    if (markers.length) {
        for (var i = 0, marker; marker = markers[i]; i++) {
            this.pushMarkerTo_(marker);
        }
    } else if (Object.keys(markers).length) {
        for (var marker in markers) {
            this.pushMarkerTo_(markers[marker]);
        }
    }
    if (!opt_nodraw) {
        this.redraw();
    }
};

/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
    marker.isAdded = false;
    if (marker['draggable']) {
        // If the marker is draggable add a listener so we update the clusters on
        // the drag end.
        var that = this;
        google.maps.event.addListener(marker, 'dragend', function () {
            marker.isAdded = false;
            that.repaint();
        });
    }
    this.markers_.push(marker);
};

/**
 * Adds a marker to the clusterer and redraws if needed.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
    this.pushMarkerTo_(marker);
    if (!opt_nodraw) {
        this.redraw();
    }
};

/**
 * Removes a marker and returns true if removed, false if not
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 * @private
 */
MarkerClusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;
    if (this.markers_.indexOf) {
        index = this.markers_.indexOf(marker);
    } else {
        for (var i = 0, m; m = this.markers_[i]; i++) {
            if (m == marker) {
                index = i;
                break;
            }
        }
    }

    if (index == -1) {
        // Marker is not in our list of markers.
        return false;
    }

    marker.setMap(null);

    this.markers_.splice(index, 1);

    return true;
};

/**
 * Remove a marker from the cluster.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 * @return {boolean} True if the marker was removed.
 */
MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
    var removed = this.removeMarker_(marker);

    if (!opt_nodraw && removed) {
        this.resetViewport();
        this.redraw();
        return true;
    } else {
        return false;
    }
};

/**
 * Removes an array of markers from the cluster.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 */
MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
    var removed = false;

    for (var i = 0, marker; marker = markers[i]; i++) {
        var r = this.removeMarker_(marker);
        removed = removed || r;
    }

    if (!opt_nodraw && removed) {
        this.resetViewport();
        this.redraw();
        return true;
    }
};

/**
 * Sets the clusterer's ready state.
 *
 * @param {boolean} ready The state.
 * @private
 */
MarkerClusterer.prototype.setReady_ = function (ready) {
    if (!this.ready_) {
        this.ready_ = ready;
        this.createClusters_();
    }
};

/**
 * Returns the number of clusters in the clusterer.
 *
 * @return {number} The number of clusters.
 */
MarkerClusterer.prototype.getTotalClusters = function () {
    return this.clusters_.length;
};

/**
 * Returns the google map that the clusterer is associated with.
 *
 * @return {google.maps.Map} The map.
 */
MarkerClusterer.prototype.getMap = function () {
    return this.map_;
};

/**
 * Sets the google map that the clusterer is associated with.
 *
 * @param {google.maps.Map} map The map.
 */
MarkerClusterer.prototype.setMap = function (map) {
    this.map_ = map;
};

/**
 * Returns the size of the grid.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function () {
    return this.gridSize_;
};

/**
 * Sets the size of the grid.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setGridSize = function (size) {
    this.gridSize_ = size;
};

/**
 * Returns the min cluster size.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getMinClusterSize = function () {
    return this.minClusterSize_;
};

/**
 * Sets the min cluster size.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setMinClusterSize = function (size) {
    this.minClusterSize_ = size;
};

/**
 * Extends a bounds object by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 */
MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
    var projection = this.getProjection();

    // Turn the bounds into latlng.
    var tr = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
    var bl = new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng());

    // Convert the points to pixels and the extend out by the grid size.
    var trPix = projection.fromLatLngToDivPixel(tr);
    trPix.x += this.gridSize_;
    trPix.y -= this.gridSize_;

    var blPix = projection.fromLatLngToDivPixel(bl);
    blPix.x -= this.gridSize_;
    blPix.y += this.gridSize_;

    // Convert the pixel points back to LatLng
    var ne = projection.fromDivPixelToLatLng(trPix);
    var sw = projection.fromDivPixelToLatLng(blPix);

    // Extend the bounds to contain the new bounds.
    bounds.extend(ne);
    bounds.extend(sw);

    return bounds;
};

/**
 * Determins if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 * @private
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
    return bounds.contains(marker.getPosition());
};

/**
 * Clears all clusters and markers from the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);

    // Set the markers a empty array.
    this.markers_ = [];
};

/**
 * Clears all existing clusters and recreates them.
 * @param {boolean} opt_hide To also hide the marker.
 */
MarkerClusterer.prototype.resetViewport = function (opt_hide) {
    // Remove all the clusters
    for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
        cluster.remove();
    }

    // Reset the markers to not be added and to be invisible.
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
        marker.isAdded = false;
        if (opt_hide) {
            marker.setMap(null);
        }
    }

    this.clusters_ = [];
};

/**
 *
 */
MarkerClusterer.prototype.repaint = function () {
    var oldClusters = this.clusters_.slice();
    this.clusters_.length = 0;
    this.resetViewport();
    this.redraw();

    // Remove the old clusters.
    // Do it in a timeout so the other clusters have been drawn first.
    window.setTimeout(function () {
        for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
            cluster.remove();
        }
    }, 0);
};

/**
 * Redraws the clusters.
 */
MarkerClusterer.prototype.redraw = function () {
    this.createClusters_();
};

/**
 * Calculates the distance between two latlng locations in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @private
 */
MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
    if (!p1 || !p2) {
        return 0;
    }
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};

/**
 * Add a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
    var distance = 40000; // Some large number
    var clusterToAddTo = null;
    var pos = marker.getPosition();
    for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
        var center = cluster.getCenter();
        if (center) {
            var d = this.distanceBetweenPoints_(center, marker.getPosition());
            if (d < distance) {
                distance = d;
                clusterToAddTo = cluster;
            }
        }
    }

    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
        clusterToAddTo.addMarker(marker);
    } else {
        var cluster = new Cluster(this);
        cluster.addMarker(marker);
        this.clusters_.push(cluster);
    }
};

/**
 * Creates the clusters.
 *
 * @private
 */
MarkerClusterer.prototype.createClusters_ = function () {
    if (!this.ready_) {
        return;
    }
    // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(), this.map_.getBounds().getNorthEast());
    var bounds = this.getExtendedBounds(mapBounds);

    for (var i = 0, marker; marker = this.markers_[i]; i++) {
        if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
            this.addToClosestCluster_(marker);
        }
    }
};

/**
 * A cluster that contains markers.
 *
 * @param {MarkerClusterer} markerClusterer The markerclusterer that this
 *     cluster is associated with.
 * @constructor
 * @ignore
 */
function Cluster(markerClusterer) {
    this.markerClusterer_ = markerClusterer;
    this.map_ = markerClusterer.getMap();
    this.gridSize_ = markerClusterer.getGridSize();
    this.minClusterSize_ = markerClusterer.getMinClusterSize();
    this.averageCenter_ = markerClusterer.isAverageCenter();
    this.center_ = null;
    this.markers_ = [];
    this.bounds_ = null;

    this.legend_ = markerClusterer.getLegend();
    this.chartData_ = {};
    this.initializeChartData_();

    this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(), markerClusterer.getGridSize());
}

/**
 * Initialize the chart slice values for the cluster chart
 */
Cluster.prototype.initializeChartData_ = function () {
    for (var key in this.legend_) {
        if (this.legend_.hasOwnProperty(key)) {
            this.chartData_[key] = this.legend_[key];
            this.chartData_[key] = 0;
        }
    }
};

Cluster.prototype.getChartData = function () {
    return this.chartData_;
};

/**
 * Determins if a marker is already added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker is already added.
 */
Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers_.indexOf) {
        return this.markers_.indexOf(marker) != -1;
    } else {
        for (var i = 0, m; m = this.markers_[i]; i++) {
            if (m == marker) {
                return true;
            }
        }
    }
    return false;
};

/**
 * Add a marker the cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @return {boolean} True if the marker was added.
 */
Cluster.prototype.addMarker = function (marker) {
    if (this.isMarkerAlreadyAdded(marker)) {
        return false;
    }

    if (!this.center_) {
        this.center_ = marker.getPosition();
        this.calculateBounds_();
    } else {
        if (this.averageCenter_) {
            var l = this.markers_.length + 1;
            var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
            var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
            this.center_ = new google.maps.LatLng(lat, lng);
            this.calculateBounds_();
        }
    }

    marker.isAdded = true;
    this.markers_.push(marker);

    this.chartData_[marker.getTitle()]++;

    var len = this.markers_.length;
    if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
        // Min cluster size not reached so show the marker.
        marker.setMap(this.map_);
    }

    if (len == this.minClusterSize_) {
        // Hide the markers that were showing.
        for (var i = 0; i < len; i++) {
            this.markers_[i].setMap(null);
        }
    }

    if (len >= this.minClusterSize_) {
        marker.setMap(null);
    }

    this.updateIcon();
    return true;
};

/**
 * Returns the marker clusterer that the cluster is associated with.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 */
Cluster.prototype.getMarkerClusterer = function () {
    return this.markerClusterer_;
};

/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 */
Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    var markers = this.getMarkers();
    for (var i = 0, marker; marker = markers[i]; i++) {
        bounds.extend(marker.getPosition());
    }
    return bounds;
};

/**
 * Removes the cluster
 */
Cluster.prototype.remove = function () {
    this.clusterIcon_.remove();
    this.markers_.length = 0;
    delete this.markers_;
};

/**
 * Returns the center of the cluster.
 *
 * @return {number} The cluster center.
 */
Cluster.prototype.getSize = function () {
    return this.markers_.length;
};

/**
 * Returns the center of the cluster.
 *
 * @return {Array.<google.maps.Marker>} The cluster center.
 */
Cluster.prototype.getMarkers = function () {
    return this.markers_;
};

/**
 * Returns the center of the cluster.
 *
 * @return {google.maps.LatLng} The cluster center.
 */
Cluster.prototype.getCenter = function () {
    return this.center_;
};

/**
 * Calculated the extended bounds of the cluster with the grid.
 *
 * @private
 */
Cluster.prototype.calculateBounds_ = function () {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};

/**
 * Determines if a marker lies in the clusters bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 */
Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    return this.bounds_.contains(marker.getPosition());
};

/**
 * Returns the map that the cluster is associated with.
 *
 * @return {google.maps.Map} The map.
 */
Cluster.prototype.getMap = function () {
    return this.map_;
};

/**
 * Updates the cluster icon
 */
Cluster.prototype.updateIcon = function () {
    var zoom = this.map_.getZoom();
    var mz = this.markerClusterer_.getMaxZoom();

    if (mz && zoom > mz) {
        // The zoom is greater than our max zoom so show all the markers in cluster.
        for (var i = 0, marker; marker = this.markers_[i]; i++) {
            marker.setMap(this.map_);
        }
        return;
    }

    if (this.markers_.length < this.minClusterSize_) {
        // Min cluster size not yet reached.
        this.clusterIcon_.hide();
        return;
    }

    var numStyles = this.markerClusterer_.getStyles().length;
    var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
    this.clusterIcon_.setCenter(this.center_);
    this.clusterIcon_.setSums(sums);
    this.clusterIcon_.show();
};

/**
 * A cluster icon
 *
 * @param {Cluster} cluster The cluster to be associated with.
 * @param {Object} styles An object that has style properties:
 *     'url': (string) The image url.
 *     'height': (number) The image height.
 *     'width': (number) The image width.
 *     'anchor': (Array) The anchor position of the label text.
 *     'textColor': (string) The text color.
 *     'textSize': (number) The text size.
 *     'backgroundPosition: (string) The background postition x, y.
 * @param {number=} opt_padding Optional padding to apply to the cluster icon.
 * @constructor
 * @extends google.maps.OverlayView
 * @ignore
 */
function ClusterIcon(cluster, styles, opt_padding) {
    cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

    this.styles_ = styles;
    this.padding_ = opt_padding || 0;
    this.cluster_ = cluster;
    this.center_ = null;
    this.map_ = cluster.getMap();
    this.div_ = null;
    this.sums_ = null;
    this.visible_ = false;
    this.setMap(this.map_);
}

/**
 * Triggers the clusterclick event and zoom's if the option is set.
 */
ClusterIcon.prototype.triggerClusterClick = function () {
    var markerClusterer = this.cluster_.getMarkerClusterer();

    // Trigger the clusterclick event.
    google.maps.event.trigger(markerClusterer, 'clusterclick', this.cluster_);

    if (markerClusterer.isZoomOnClick()) {
        // Zoom into the cluster.
        this.map_.fitBounds(this.cluster_.getBounds());
    }
};

/**
 * Adding the cluster icon to the dom.
 * @ignore
 */
ClusterIcon.prototype.onAdd = function () {
    var _this = this;

    this.div_ = document.createElement('DIV');

    //  console.log('onAdd', !!this.visible_);

    if (this.visible_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(pos);
        this.div_.innerHTML = '<div class="piehole"><span>' + this.sums_.text + '</span></div><div class="ct-chart chart-container"></div>';
    }

    var panes = this.getPanes();

    panes.overlayMouseTarget.appendChild(this.div_);

    google.maps.event.addDomListener(this.div_, 'click', function () {
        _this.triggerClusterClick();
    });
};

/**
 * Returns the position to place the div dending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 * @private
 */
ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    pos.x -= parseInt(this.width_ / 2, 10);
    pos.y -= parseInt(this.height_ / 2, 10);
    return pos;
};

/**
 * Draw the icon.
 * @ignore
 */
ClusterIcon.prototype.draw = function () {
    // console.log('draw', !!this.visible_);

    if (this.visible_) {
        var pos = this.getPosFromLatLng_(this.center_);

        this.div_.style.top = pos.y + 'px';
        this.div_.style.left = pos.x + 'px';

        this.renderCharts_();
    }
};

/**
 * Hide the icon.
 */
ClusterIcon.prototype.hide = function () {
    // console.log('hide', !!this.div_);

    if (this.div_) {
        this.div_.style.display = 'none';
    }

    this.visible_ = false;
};

/**
 * Position and show the icon.
 */
ClusterIcon.prototype.show = function () {
    //  console.log('show', !!this.div_);

    if (this.div_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(pos);
        this.div_.style.display = '';
    }

    this.visible_ = true;
};

ClusterIcon.prototype.renderCharts_ = function () {
    var clusterChartData = this.cluster_.getChartData();
    var dataArray = [];
    var self = this;
    //console.log('renderCharts')

    for (var key in clusterChartData) {
        dataArray.push({
            value: clusterChartData[key],
            className: key
        });
        //  dataArray.push([key, clusterChartData[key]]);
        //  chartColorsSeq.push(clusterLegend[key]);
    }

    if (!this.div_.querySelector('.ct-chart')) {
        return;
    }

    var chart = new __WEBPACK_IMPORTED_MODULE_0_libs_chartist__["a" /* default */].Pie(this.div_.querySelector('.ct-chart'), {
        series: dataArray
    }, {
        donut: true,
        chartPadding: 0,
        height: '100%',
        width: '100%',
        donutWidth: '5px',
        donutHeight: '100%',
        donutSolid: true,
        startAngle: 360,
        showLabel: false
    });

    chart.on('created', function (data) {
        if (!self.div_) {
            return;
        }

        if (data.chartRect.height() > self.div_.clientHeight || data.chartRect.height() < self.div_.clientHeight) {
            setTimeout(function () {
                chart.update();
            }, 500);
        }
    });
};

/**
 * Remove the icon from the map
 */
ClusterIcon.prototype.remove = function () {
    //  console.log('remove',);
    this.setMap(null);
};

/**
 * Implementation of the onRemove interface.
 * @ignore
 */
ClusterIcon.prototype.onRemove = function () {

    //  console.log('onRemove', this.div_ && this.div_.parentNode);

    if (this.div_ && this.div_.parentNode) {
        this.hide();
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null;
    }
};

/**
 * Set the sums of the icon.
 *
 * @param {Object} sums The sums containing:
 *   'text': (string) The text to display in the icon.
 *   'index': (number) The style index of the icon.
 */
ClusterIcon.prototype.setSums = function (sums) {
    //console.log('setSums', this.div_);

    this.sums_ = sums;

    if (this.div_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(pos);
        this.div_.innerHTML = '<div class="piehole"><span>' + sums.text + '</span></div><div class="ct-chart chart-container"></div>';
    }

    this.useStyle();
};

/**
 * Sets the icon to the the styles.
 */
ClusterIcon.prototype.useStyle = function () {
    var index = Math.max(0, this.sums_.index - 1);
    index = Math.min(this.styles_.length - 1, index);
    var style = this.styles_[index];
    //this.url_ = style['url'];
    this.height_ = style['height'];
    this.width_ = style['width'];
    this.textColor_ = style['textColor'];
    this.anchor_ = style['anchor'];
    this.textSize_ = style['textSize'];
    this.backgroundPosition_ = style['backgroundPosition'];
};

/**
 * Sets the center of the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function (center) {
    this.center_ = center;
};

/**
 * Create the css text based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position.
 * @return {string} The css style text.
 */
ClusterIcon.prototype.createCss = function (pos) {
    var style = [];
    style.push('background-image:url(' + this.url_ + ');');
    var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
    style.push('background-position:' + backgroundPosition + ';');

    if (_typeof(this.anchor_) === 'object') {
        if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 && this.anchor_[0] < this.height_) {
            style.push('height:' + (this.height_ - this.anchor_[0]) + 'px; padding-top:' + this.anchor_[0] + 'px;');
        } else {
            style.push('height:' + this.height_ + 'px; line-height:' + this.height_ + 'px;');
        }
        if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 && this.anchor_[1] < this.width_) {
            style.push('width:' + (this.width_ - this.anchor_[1]) + 'px; padding-left:' + this.anchor_[1] + 'px;');
        } else {
            style.push('width:' + this.width_ + 'px; text-align:center;');
        }
    } else {
        style.push('height:' + this.height_ + 'px; line-height:' + this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
    }

    var txtColor = this.textColor_ ? this.textColor_ : 'black';
    var txtSize = this.textSize_ ? this.textSize_ : 11;

    style.push('cursor:pointer; top:' + pos.y + 'px; left:' + pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' + txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
    return style.join('');
};

var _default = MarkerClusterer;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(MarkerClusterer, 'MarkerClusterer', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/markerClusterer.js');
    reactHotLoader.register(Cluster, 'Cluster', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/markerClusterer.js');
    reactHotLoader.register(ClusterIcon, 'ClusterIcon', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/markerClusterer.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Map/markerClusterer.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exports_loader_Chartist_chartist__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exports_loader_Chartist_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_exports_loader_Chartist_chartist__);
(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-08-17 18:55:59 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-09-24 12:41:57
 */



var _default = __WEBPACK_IMPORTED_MODULE_0_exports_loader_Chartist_chartist__;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Libs/chartist/index.js");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

/* Chartist.js 0.11.0
 * Copyright © 2017 Gion Kunz
 * Free to use under either the WTFPL license or the MIT license.
 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-WTFPL
 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-MIT
 */
/**
 * The core module of Chartist that is mainly providing static functions and higher level functions for chart modules.
 *
 * @module Chartist.Core
 */
var Chartist = {
  version: '0.11.0'
};

(function (window, document, Chartist) {
  'use strict';

  /**
   * This object contains all namespaces used within Chartist.
   *
   * @memberof Chartist.Core
   * @type {{svg: string, xmlns: string, xhtml: string, xlink: string, ct: string}}
   */

  Chartist.namespaces = {
    svg: 'http://www.w3.org/2000/svg',
    xmlns: 'http://www.w3.org/2000/xmlns/',
    xhtml: 'http://www.w3.org/1999/xhtml',
    xlink: 'http://www.w3.org/1999/xlink',
    ct: 'http://gionkunz.github.com/chartist-js/ct'
  };

  /**
   * Helps to simplify functional style code
   *
   * @memberof Chartist.Core
   * @param {*} n This exact value will be returned by the noop function
   * @return {*} The same value that was provided to the n parameter
   */
  Chartist.noop = function (n) {
    return n;
  };

  /**
   * Generates a-z from a number 0 to 26
   *
   * @memberof Chartist.Core
   * @param {Number} n A number from 0 to 26 that will result in a letter a-z
   * @return {String} A character from a-z based on the input number n
   */
  Chartist.alphaNumerate = function (n) {
    // Limit to a-z
    return String.fromCharCode(97 + n % 26);
  };

  /**
   * Simple recursive object extend
   *
   * @memberof Chartist.Core
   * @param {Object} target Target object where the source will be merged into
   * @param {Object...} sources This object (objects) will be merged into target and then target is returned
   * @return {Object} An object that has the same reference as target but is extended and merged with the properties of source
   */
  Chartist.extend = function (target) {
    var i, source, sourceProp;
    target = target || {};

    for (i = 1; i < arguments.length; i++) {
      source = arguments[i];
      for (var prop in source) {
        sourceProp = source[prop];
        if ((typeof sourceProp === 'undefined' ? 'undefined' : _typeof(sourceProp)) === 'object' && sourceProp !== null && !(sourceProp instanceof Array)) {
          target[prop] = Chartist.extend(target[prop], sourceProp);
        } else {
          target[prop] = sourceProp;
        }
      }
    }

    return target;
  };

  /**
   * Replaces all occurrences of subStr in str with newSubStr and returns a new string.
   *
   * @memberof Chartist.Core
   * @param {String} str
   * @param {String} subStr
   * @param {String} newSubStr
   * @return {String}
   */
  Chartist.replaceAll = function (str, subStr, newSubStr) {
    return str.replace(new RegExp(subStr, 'g'), newSubStr);
  };

  /**
   * Converts a number to a string with a unit. If a string is passed then this will be returned unmodified.
   *
   * @memberof Chartist.Core
   * @param {Number} value
   * @param {String} unit
   * @return {String} Returns the passed number value with unit.
   */
  Chartist.ensureUnit = function (value, unit) {
    if (typeof value === 'number') {
      value = value + unit;
    }

    return value;
  };

  /**
   * Converts a number or string to a quantity object.
   *
   * @memberof Chartist.Core
   * @param {String|Number} input
   * @return {Object} Returns an object containing the value as number and the unit as string.
   */
  Chartist.quantity = function (input) {
    if (typeof input === 'string') {
      var match = /^(\d+)\s*(.*)$/g.exec(input);
      return {
        value: +match[1],
        unit: match[2] || undefined
      };
    }
    return { value: input };
  };

  /**
   * This is a wrapper around document.querySelector that will return the query if it's already of type Node
   *
   * @memberof Chartist.Core
   * @param {String|Node} query The query to use for selecting a Node or a DOM node that will be returned directly
   * @return {Node}
   */
  Chartist.querySelector = function (query) {
    return query instanceof Node ? query : document.querySelector(query);
  };

  /**
   * Functional style helper to produce array with given length initialized with undefined values
   *
   * @memberof Chartist.Core
   * @param length
   * @return {Array}
   */
  Chartist.times = function (length) {
    return Array.apply(null, new Array(length));
  };

  /**
   * Sum helper to be used in reduce functions
   *
   * @memberof Chartist.Core
   * @param previous
   * @param current
   * @return {*}
   */
  Chartist.sum = function (previous, current) {
    return previous + (current ? current : 0);
  };

  /**
   * Multiply helper to be used in `Array.map` for multiplying each value of an array with a factor.
   *
   * @memberof Chartist.Core
   * @param {Number} factor
   * @returns {Function} Function that can be used in `Array.map` to multiply each value in an array
   */
  Chartist.mapMultiply = function (factor) {
    return function (num) {
      return num * factor;
    };
  };

  /**
   * Add helper to be used in `Array.map` for adding a addend to each value of an array.
   *
   * @memberof Chartist.Core
   * @param {Number} addend
   * @returns {Function} Function that can be used in `Array.map` to add a addend to each value in an array
   */
  Chartist.mapAdd = function (addend) {
    return function (num) {
      return num + addend;
    };
  };

  /**
   * Map for multi dimensional arrays where their nested arrays will be mapped in serial. The output array will have the length of the largest nested array. The callback function is called with variable arguments where each argument is the nested array value (or undefined if there are no more values).
   *
   * @memberof Chartist.Core
   * @param arr
   * @param cb
   * @return {Array}
   */
  Chartist.serialMap = function (arr, cb) {
    var result = [],
        length = Math.max.apply(null, arr.map(function (e) {
      return e.length;
    }));

    Chartist.times(length).forEach(function (e, index) {
      var args = arr.map(function (e) {
        return e[index];
      });

      result[index] = cb.apply(null, args);
    });

    return result;
  };

  /**
   * This helper function can be used to round values with certain precision level after decimal. This is used to prevent rounding errors near float point precision limit.
   *
   * @memberof Chartist.Core
   * @param {Number} value The value that should be rounded with precision
   * @param {Number} [digits] The number of digits after decimal used to do the rounding
   * @returns {number} Rounded value
   */
  Chartist.roundWithPrecision = function (value, digits) {
    var precision = Math.pow(10, digits || Chartist.precision);
    return Math.round(value * precision) / precision;
  };

  /**
   * Precision level used internally in Chartist for rounding. If you require more decimal places you can increase this number.
   *
   * @memberof Chartist.Core
   * @type {number}
   */
  Chartist.precision = 8;

  /**
   * A map with characters to escape for strings to be safely used as attribute values.
   *
   * @memberof Chartist.Core
   * @type {Object}
   */
  Chartist.escapingMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  };

  /**
   * This function serializes arbitrary data to a string. In case of data that can't be easily converted to a string, this function will create a wrapper object and serialize the data using JSON.stringify. The outcoming string will always be escaped using Chartist.escapingMap.
   * If called with null or undefined the function will return immediately with null or undefined.
   *
   * @memberof Chartist.Core
   * @param {Number|String|Object} data
   * @return {String}
   */
  Chartist.serialize = function (data) {
    if (data === null || data === undefined) {
      return data;
    } else if (typeof data === 'number') {
      data = '' + data;
    } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
      data = JSON.stringify({ data: data });
    }

    return Object.keys(Chartist.escapingMap).reduce(function (result, key) {
      return Chartist.replaceAll(result, key, Chartist.escapingMap[key]);
    }, data);
  };

  /**
   * This function de-serializes a string previously serialized with Chartist.serialize. The string will always be unescaped using Chartist.escapingMap before it's returned. Based on the input value the return type can be Number, String or Object. JSON.parse is used with try / catch to see if the unescaped string can be parsed into an Object and this Object will be returned on success.
   *
   * @memberof Chartist.Core
   * @param {String} data
   * @return {String|Number|Object}
   */
  Chartist.deserialize = function (data) {
    if (typeof data !== 'string') {
      return data;
    }

    data = Object.keys(Chartist.escapingMap).reduce(function (result, key) {
      return Chartist.replaceAll(result, Chartist.escapingMap[key], key);
    }, data);

    try {
      data = JSON.parse(data);
      data = data.data !== undefined ? data.data : data;
    } catch (e) {}

    return data;
  };

  /**
   * Create or reinitialize the SVG element for the chart
   *
   * @memberof Chartist.Core
   * @param {Node} container The containing DOM Node object that will be used to plant the SVG element
   * @param {String} width Set the width of the SVG element. Default is 100%
   * @param {String} height Set the height of the SVG element. Default is 100%
   * @param {String} className Specify a class to be added to the SVG element
   * @return {Object} The created/reinitialized SVG element
   */
  Chartist.createSvg = function (container, width, height, className) {
    var svg;

    width = width || '100%';
    height = height || '100%';

    // Check if there is a previous SVG element in the container that contains the Chartist XML namespace and remove it
    // Since the DOM API does not support namespaces we need to manually search the returned list http://www.w3.org/TR/selectors-api/
    Array.prototype.slice.call(container.querySelectorAll('svg')).filter(function filterChartistSvgObjects(svg) {
      return svg.getAttributeNS(Chartist.namespaces.xmlns, 'ct');
    }).forEach(function removePreviousElement(svg) {
      container.removeChild(svg);
    });

    // Create svg object with width and height or use 100% as default
    svg = new Chartist.Svg('svg').attr({
      width: width,
      height: height
    }).addClass(className);

    svg._node.style.width = width;
    svg._node.style.height = height;

    // Add the DOM node to our container
    container.appendChild(svg._node);

    return svg;
  };

  /**
   * Ensures that the data object passed as second argument to the charts is present and correctly initialized.
   *
   * @param  {Object} data The data object that is passed as second argument to the charts
   * @return {Object} The normalized data object
   */
  Chartist.normalizeData = function (data, reverse, multi) {
    var labelCount;
    var output = {
      raw: data,
      normalized: {}
    };

    // Check if we should generate some labels based on existing series data
    output.normalized.series = Chartist.getDataArray({
      series: data.series || []
    }, reverse, multi);

    // If all elements of the normalized data array are arrays we're dealing with
    // multi series data and we need to find the largest series if they are un-even
    if (output.normalized.series.every(function (value) {
      return value instanceof Array;
    })) {
      // Getting the series with the the most elements
      labelCount = Math.max.apply(null, output.normalized.series.map(function (series) {
        return series.length;
      }));
    } else {
      // We're dealing with Pie data so we just take the normalized array length
      labelCount = output.normalized.series.length;
    }

    output.normalized.labels = (data.labels || []).slice();
    // Padding the labels to labelCount with empty strings
    Array.prototype.push.apply(output.normalized.labels, Chartist.times(Math.max(0, labelCount - output.normalized.labels.length)).map(function () {
      return '';
    }));

    if (reverse) {
      Chartist.reverseData(output.normalized);
    }

    return output;
  };

  /**
   * This function safely checks if an objects has an owned property.
   *
   * @param {Object} object The object where to check for a property
   * @param {string} property The property name
   * @returns {boolean} Returns true if the object owns the specified property
   */
  Chartist.safeHasProperty = function (object, property) {
    return object !== null && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.hasOwnProperty(property);
  };

  /**
   * Checks if a value is considered a hole in the data series.
   *
   * @param {*} value
   * @returns {boolean} True if the value is considered a data hole
   */
  Chartist.isDataHoleValue = function (value) {
    return value === null || value === undefined || typeof value === 'number' && isNaN(value);
  };

  /**
   * Reverses the series, labels and series data arrays.
   *
   * @memberof Chartist.Core
   * @param data
   */
  Chartist.reverseData = function (data) {
    data.labels.reverse();
    data.series.reverse();
    for (var i = 0; i < data.series.length; i++) {
      if (_typeof(data.series[i]) === 'object' && data.series[i].data !== undefined) {
        data.series[i].data.reverse();
      } else if (data.series[i] instanceof Array) {
        data.series[i].reverse();
      }
    }
  };

  /**
   * Convert data series into plain array
   *
   * @memberof Chartist.Core
   * @param {Object} data The series object that contains the data to be visualized in the chart
   * @param {Boolean} [reverse] If true the whole data is reversed by the getDataArray call. This will modify the data object passed as first parameter. The labels as well as the series order is reversed. The whole series data arrays are reversed too.
   * @param {Boolean} [multi] Create a multi dimensional array from a series data array where a value object with `x` and `y` values will be created.
   * @return {Array} A plain array that contains the data to be visualized in the chart
   */
  Chartist.getDataArray = function (data, reverse, multi) {
    // Recursively walks through nested arrays and convert string values to numbers and objects with value properties
    // to values. Check the tests in data core -> data normalization for a detailed specification of expected values
    function recursiveConvert(value) {
      if (Chartist.safeHasProperty(value, 'value')) {
        // We are dealing with value object notation so we need to recurse on value property
        return recursiveConvert(value.value);
      } else if (Chartist.safeHasProperty(value, 'data')) {
        // We are dealing with series object notation so we need to recurse on data property
        return recursiveConvert(value.data);
      } else if (value instanceof Array) {
        // Data is of type array so we need to recurse on the series
        return value.map(recursiveConvert);
      } else if (Chartist.isDataHoleValue(value)) {
        // We're dealing with a hole in the data and therefore need to return undefined
        // We're also returning undefined for multi value output
        return undefined;
      } else {
        // We need to prepare multi value output (x and y data)
        if (multi) {
          var multiValue = {};

          // Single series value arrays are assumed to specify the Y-Axis value
          // For example: [1, 2] => [{x: undefined, y: 1}, {x: undefined, y: 2}]
          // If multi is a string then it's assumed that it specified which dimension should be filled as default
          if (typeof multi === 'string') {
            multiValue[multi] = Chartist.getNumberOrUndefined(value);
          } else {
            multiValue.y = Chartist.getNumberOrUndefined(value);
          }

          multiValue.x = value.hasOwnProperty('x') ? Chartist.getNumberOrUndefined(value.x) : multiValue.x;
          multiValue.y = value.hasOwnProperty('y') ? Chartist.getNumberOrUndefined(value.y) : multiValue.y;

          return multiValue;
        } else {
          // We can return simple data
          return Chartist.getNumberOrUndefined(value);
        }
      }
    }

    return data.series.map(recursiveConvert);
  };

  /**
   * Converts a number into a padding object.
   *
   * @memberof Chartist.Core
   * @param {Object|Number} padding
   * @param {Number} [fallback] This value is used to fill missing values if a incomplete padding object was passed
   * @returns {Object} Returns a padding object containing top, right, bottom, left properties filled with the padding number passed in as argument. If the argument is something else than a number (presumably already a correct padding object) then this argument is directly returned.
   */
  Chartist.normalizePadding = function (padding, fallback) {
    fallback = fallback || 0;

    return typeof padding === 'number' ? {
      top: padding,
      right: padding,
      bottom: padding,
      left: padding
    } : {
      top: typeof padding.top === 'number' ? padding.top : fallback,
      right: typeof padding.right === 'number' ? padding.right : fallback,
      bottom: typeof padding.bottom === 'number' ? padding.bottom : fallback,
      left: typeof padding.left === 'number' ? padding.left : fallback
    };
  };

  Chartist.getMetaData = function (series, index) {
    var value = series.data ? series.data[index] : series[index];
    return value ? value.meta : undefined;
  };

  /**
   * Calculate the order of magnitude for the chart scale
   *
   * @memberof Chartist.Core
   * @param {Number} value The value Range of the chart
   * @return {Number} The order of magnitude
   */
  Chartist.orderOfMagnitude = function (value) {
    return Math.floor(Math.log(Math.abs(value)) / Math.LN10);
  };

  /**
   * Project a data length into screen coordinates (pixels)
   *
   * @memberof Chartist.Core
   * @param {Object} axisLength The svg element for the chart
   * @param {Number} length Single data value from a series array
   * @param {Object} bounds All the values to set the bounds of the chart
   * @return {Number} The projected data length in pixels
   */
  Chartist.projectLength = function (axisLength, length, bounds) {
    return length / bounds.range * axisLength;
  };

  /**
   * Get the height of the area in the chart for the data series
   *
   * @memberof Chartist.Core
   * @param {Object} svg The svg element for the chart
   * @param {Object} options The Object that contains all the optional values for the chart
   * @return {Number} The height of the area in the chart for the data series
   */
  Chartist.getAvailableHeight = function (svg, options) {
    return Math.max((Chartist.quantity(options.height).value || svg.height()) - (options.chartPadding.top + options.chartPadding.bottom) - options.axisX.offset, 0);
  };

  /**
   * Get highest and lowest value of data array. This Array contains the data that will be visualized in the chart.
   *
   * @memberof Chartist.Core
   * @param {Array} data The array that contains the data to be visualized in the chart
   * @param {Object} options The Object that contains the chart options
   * @param {String} dimension Axis dimension 'x' or 'y' used to access the correct value and high / low configuration
   * @return {Object} An object that contains the highest and lowest value that will be visualized on the chart.
   */
  Chartist.getHighLow = function (data, options, dimension) {
    // TODO: Remove workaround for deprecated global high / low config. Axis high / low configuration is preferred
    options = Chartist.extend({}, options, dimension ? options['axis' + dimension.toUpperCase()] : {});

    var highLow = {
      high: options.high === undefined ? -Number.MAX_VALUE : +options.high,
      low: options.low === undefined ? Number.MAX_VALUE : +options.low
    };
    var findHigh = options.high === undefined;
    var findLow = options.low === undefined;

    // Function to recursively walk through arrays and find highest and lowest number
    function recursiveHighLow(data) {
      if (data === undefined) {
        return undefined;
      } else if (data instanceof Array) {
        for (var i = 0; i < data.length; i++) {
          recursiveHighLow(data[i]);
        }
      } else {
        var value = dimension ? +data[dimension] : +data;

        if (findHigh && value > highLow.high) {
          highLow.high = value;
        }

        if (findLow && value < highLow.low) {
          highLow.low = value;
        }
      }
    }

    // Start to find highest and lowest number recursively
    if (findHigh || findLow) {
      recursiveHighLow(data);
    }

    // Overrides of high / low based on reference value, it will make sure that the invisible reference value is
    // used to generate the chart. This is useful when the chart always needs to contain the position of the
    // invisible reference value in the view i.e. for bipolar scales.
    if (options.referenceValue || options.referenceValue === 0) {
      highLow.high = Math.max(options.referenceValue, highLow.high);
      highLow.low = Math.min(options.referenceValue, highLow.low);
    }

    // If high and low are the same because of misconfiguration or flat data (only the same value) we need
    // to set the high or low to 0 depending on the polarity
    if (highLow.high <= highLow.low) {
      // If both values are 0 we set high to 1
      if (highLow.low === 0) {
        highLow.high = 1;
      } else if (highLow.low < 0) {
        // If we have the same negative value for the bounds we set bounds.high to 0
        highLow.high = 0;
      } else if (highLow.high > 0) {
        // If we have the same positive value for the bounds we set bounds.low to 0
        highLow.low = 0;
      } else {
        // If data array was empty, values are Number.MAX_VALUE and -Number.MAX_VALUE. Set bounds to prevent errors
        highLow.high = 1;
        highLow.low = 0;
      }
    }

    return highLow;
  };

  /**
   * Checks if a value can be safely coerced to a number. This includes all values except null which result in finite numbers when coerced. This excludes NaN, since it's not finite.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {Boolean}
   */
  Chartist.isNumeric = function (value) {
    return value === null ? false : isFinite(value);
  };

  /**
   * Returns true on all falsey values except the numeric value 0.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {boolean}
   */
  Chartist.isFalseyButZero = function (value) {
    return !value && value !== 0;
  };

  /**
   * Returns a number if the passed parameter is a valid number or the function will return undefined. On all other values than a valid number, this function will return undefined.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {*}
   */
  Chartist.getNumberOrUndefined = function (value) {
    return Chartist.isNumeric(value) ? +value : undefined;
  };

  /**
   * Checks if provided value object is multi value (contains x or y properties)
   *
   * @memberof Chartist.Core
   * @param value
   */
  Chartist.isMultiValue = function (value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && ('x' in value || 'y' in value);
  };

  /**
   * Gets a value from a dimension `value.x` or `value.y` while returning value directly if it's a valid numeric value. If the value is not numeric and it's falsey this function will return `defaultValue`.
   *
   * @memberof Chartist.Core
   * @param value
   * @param dimension
   * @param defaultValue
   * @returns {*}
   */
  Chartist.getMultiValue = function (value, dimension) {
    if (Chartist.isMultiValue(value)) {
      return Chartist.getNumberOrUndefined(value[dimension || 'y']);
    } else {
      return Chartist.getNumberOrUndefined(value);
    }
  };

  /**
   * Pollard Rho Algorithm to find smallest factor of an integer value. There are more efficient algorithms for factorization, but this one is quite efficient and not so complex.
   *
   * @memberof Chartist.Core
   * @param {Number} num An integer number where the smallest factor should be searched for
   * @returns {Number} The smallest integer factor of the parameter num.
   */
  Chartist.rho = function (num) {
    if (num === 1) {
      return num;
    }

    function gcd(p, q) {
      if (p % q === 0) {
        return q;
      } else {
        return gcd(q, p % q);
      }
    }

    function f(x) {
      return x * x + 1;
    }

    var x1 = 2,
        x2 = 2,
        divisor;
    if (num % 2 === 0) {
      return 2;
    }

    do {
      x1 = f(x1) % num;
      x2 = f(f(x2)) % num;
      divisor = gcd(Math.abs(x1 - x2), num);
    } while (divisor === 1);

    return divisor;
  };

  /**
   * Calculate and retrieve all the bounds for the chart and return them in one array
   *
   * @memberof Chartist.Core
   * @param {Number} axisLength The length of the Axis used for
   * @param {Object} highLow An object containing a high and low property indicating the value range of the chart.
   * @param {Number} scaleMinSpace The minimum projected length a step should result in
   * @param {Boolean} onlyInteger
   * @return {Object} All the values to set the bounds of the chart
   */
  Chartist.getBounds = function (axisLength, highLow, scaleMinSpace, onlyInteger) {
    var i,
        optimizationCounter = 0,
        newMin,
        newMax,
        bounds = {
      high: highLow.high,
      low: highLow.low
    };

    bounds.valueRange = bounds.high - bounds.low;
    bounds.oom = Chartist.orderOfMagnitude(bounds.valueRange);
    bounds.step = Math.pow(10, bounds.oom);
    bounds.min = Math.floor(bounds.low / bounds.step) * bounds.step;
    bounds.max = Math.ceil(bounds.high / bounds.step) * bounds.step;
    bounds.range = bounds.max - bounds.min;
    bounds.numberOfSteps = Math.round(bounds.range / bounds.step);

    // Optimize scale step by checking if subdivision is possible based on horizontalGridMinSpace
    // If we are already below the scaleMinSpace value we will scale up
    var length = Chartist.projectLength(axisLength, bounds.step, bounds);
    var scaleUp = length < scaleMinSpace;
    var smallestFactor = onlyInteger ? Chartist.rho(bounds.range) : 0;

    // First check if we should only use integer steps and if step 1 is still larger than scaleMinSpace so we can use 1
    if (onlyInteger && Chartist.projectLength(axisLength, 1, bounds) >= scaleMinSpace) {
      bounds.step = 1;
    } else if (onlyInteger && smallestFactor < bounds.step && Chartist.projectLength(axisLength, smallestFactor, bounds) >= scaleMinSpace) {
      // If step 1 was too small, we can try the smallest factor of range
      // If the smallest factor is smaller than the current bounds.step and the projected length of smallest factor
      // is larger than the scaleMinSpace we should go for it.
      bounds.step = smallestFactor;
    } else {
      // Trying to divide or multiply by 2 and find the best step value
      while (true) {
        if (scaleUp && Chartist.projectLength(axisLength, bounds.step, bounds) <= scaleMinSpace) {
          bounds.step *= 2;
        } else if (!scaleUp && Chartist.projectLength(axisLength, bounds.step / 2, bounds) >= scaleMinSpace) {
          bounds.step /= 2;
          if (onlyInteger && bounds.step % 1 !== 0) {
            bounds.step *= 2;
            break;
          }
        } else {
          break;
        }

        if (optimizationCounter++ > 1000) {
          throw new Error('Exceeded maximum number of iterations while optimizing scale step!');
        }
      }
    }

    var EPSILON = 2.221E-16;
    bounds.step = Math.max(bounds.step, EPSILON);
    function safeIncrement(value, increment) {
      // If increment is too small use *= (1+EPSILON) as a simple nextafter
      if (value === (value += increment)) {
        value *= 1 + (increment > 0 ? EPSILON : -EPSILON);
      }
      return value;
    }

    // Narrow min and max based on new step
    newMin = bounds.min;
    newMax = bounds.max;
    while (newMin + bounds.step <= bounds.low) {
      newMin = safeIncrement(newMin, bounds.step);
    }
    while (newMax - bounds.step >= bounds.high) {
      newMax = safeIncrement(newMax, -bounds.step);
    }
    bounds.min = newMin;
    bounds.max = newMax;
    bounds.range = bounds.max - bounds.min;

    var values = [];
    for (i = bounds.min; i <= bounds.max; i = safeIncrement(i, bounds.step)) {
      var value = Chartist.roundWithPrecision(i);
      if (value !== values[values.length - 1]) {
        values.push(value);
      }
    }
    bounds.values = values;
    return bounds;
  };

  /**
   * Calculate cartesian coordinates of polar coordinates
   *
   * @memberof Chartist.Core
   * @param {Number} centerX X-axis coordinates of center point of circle segment
   * @param {Number} centerY X-axis coordinates of center point of circle segment
   * @param {Number} radius Radius of circle segment
   * @param {Number} angleInDegrees Angle of circle segment in degrees
   * @return {{x:Number, y:Number}} Coordinates of point on circumference
   */
  Chartist.polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians)
    };
  };

  /**
   * Initialize chart drawing rectangle (area where chart is drawn) x1,y1 = bottom left / x2,y2 = top right
   *
   * @memberof Chartist.Core
   * @param {Object} svg The svg element for the chart
   * @param {Object} options The Object that contains all the optional values for the chart
   * @param {Number} [fallbackPadding] The fallback padding if partial padding objects are used
   * @return {Object} The chart rectangles coordinates inside the svg element plus the rectangles measurements
   */
  Chartist.createChartRect = function (svg, options, fallbackPadding) {
    var hasAxis = !!(options.axisX || options.axisY);
    var yAxisOffset = hasAxis ? options.axisY.offset : 0;
    var xAxisOffset = hasAxis ? options.axisX.offset : 0;
    // If width or height results in invalid value (including 0) we fallback to the unitless settings or even 0
    var width = svg.width() || Chartist.quantity(options.width).value || 0;
    var height = svg.height() || Chartist.quantity(options.height).value || 0;
    var normalizedPadding = Chartist.normalizePadding(options.chartPadding, fallbackPadding);

    // If settings were to small to cope with offset (legacy) and padding, we'll adjust
    width = Math.max(width, yAxisOffset + normalizedPadding.left + normalizedPadding.right);
    height = Math.max(height, xAxisOffset + normalizedPadding.top + normalizedPadding.bottom);

    var chartRect = {
      padding: normalizedPadding,
      width: function width() {
        return this.x2 - this.x1;
      },
      height: function height() {
        return this.y1 - this.y2;
      }
    };

    if (hasAxis) {
      if (options.axisX.position === 'start') {
        chartRect.y2 = normalizedPadding.top + xAxisOffset;
        chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
      } else {
        chartRect.y2 = normalizedPadding.top;
        chartRect.y1 = Math.max(height - normalizedPadding.bottom - xAxisOffset, chartRect.y2 + 1);
      }

      if (options.axisY.position === 'start') {
        chartRect.x1 = normalizedPadding.left + yAxisOffset;
        chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
      } else {
        chartRect.x1 = normalizedPadding.left;
        chartRect.x2 = Math.max(width - normalizedPadding.right - yAxisOffset, chartRect.x1 + 1);
      }
    } else {
      chartRect.x1 = normalizedPadding.left;
      chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
      chartRect.y2 = normalizedPadding.top;
      chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
    }

    return chartRect;
  };

  /**
   * Creates a grid line based on a projected value.
   *
   * @memberof Chartist.Core
   * @param position
   * @param index
   * @param axis
   * @param offset
   * @param length
   * @param group
   * @param classes
   * @param eventEmitter
   */
  Chartist.createGrid = function (position, index, axis, offset, length, group, classes, eventEmitter) {
    var positionalData = {};
    positionalData[axis.units.pos + '1'] = position;
    positionalData[axis.units.pos + '2'] = position;
    positionalData[axis.counterUnits.pos + '1'] = offset;
    positionalData[axis.counterUnits.pos + '2'] = offset + length;

    var gridElement = group.elem('line', positionalData, classes.join(' '));

    // Event for grid draw
    eventEmitter.emit('draw', Chartist.extend({
      type: 'grid',
      axis: axis,
      index: index,
      group: group,
      element: gridElement
    }, positionalData));
  };

  /**
   * Creates a grid background rect and emits the draw event.
   *
   * @memberof Chartist.Core
   * @param gridGroup
   * @param chartRect
   * @param className
   * @param eventEmitter
   */
  Chartist.createGridBackground = function (gridGroup, chartRect, className, eventEmitter) {
    var gridBackground = gridGroup.elem('rect', {
      x: chartRect.x1,
      y: chartRect.y2,
      width: chartRect.width(),
      height: chartRect.height()
    }, className, true);

    // Event for grid background draw
    eventEmitter.emit('draw', {
      type: 'gridBackground',
      group: gridGroup,
      element: gridBackground
    });
  };

  /**
   * Creates a label based on a projected value and an axis.
   *
   * @memberof Chartist.Core
   * @param position
   * @param length
   * @param index
   * @param labels
   * @param axis
   * @param axisOffset
   * @param labelOffset
   * @param group
   * @param classes
   * @param useForeignObject
   * @param eventEmitter
   */
  Chartist.createLabel = function (position, length, index, labels, axis, axisOffset, labelOffset, group, classes, useForeignObject, eventEmitter) {
    var labelElement;
    var positionalData = {};

    positionalData[axis.units.pos] = position + labelOffset[axis.units.pos];
    positionalData[axis.counterUnits.pos] = labelOffset[axis.counterUnits.pos];
    positionalData[axis.units.len] = length;
    positionalData[axis.counterUnits.len] = Math.max(0, axisOffset - 10);

    if (useForeignObject) {
      // We need to set width and height explicitly to px as span will not expand with width and height being
      // 100% in all browsers
      var content = document.createElement('span');
      content.className = classes.join(' ');
      content.setAttribute('xmlns', Chartist.namespaces.xhtml);
      content.innerText = labels[index];
      content.style[axis.units.len] = Math.round(positionalData[axis.units.len]) + 'px';
      content.style[axis.counterUnits.len] = Math.round(positionalData[axis.counterUnits.len]) + 'px';

      labelElement = group.foreignObject(content, Chartist.extend({
        style: 'overflow: visible;'
      }, positionalData));
    } else {
      labelElement = group.elem('text', positionalData, classes.join(' ')).text(labels[index]);
    }

    eventEmitter.emit('draw', Chartist.extend({
      type: 'label',
      axis: axis,
      index: index,
      group: group,
      element: labelElement,
      text: labels[index]
    }, positionalData));
  };

  /**
   * Helper to read series specific options from options object. It automatically falls back to the global option if
   * there is no option in the series options.
   *
   * @param {Object} series Series object
   * @param {Object} options Chartist options object
   * @param {string} key The options key that should be used to obtain the options
   * @returns {*}
   */
  Chartist.getSeriesOption = function (series, options, key) {
    if (series.name && options.series && options.series[series.name]) {
      var seriesOptions = options.series[series.name];
      return seriesOptions.hasOwnProperty(key) ? seriesOptions[key] : options[key];
    } else {
      return options[key];
    }
  };

  /**
   * Provides options handling functionality with callback for options changes triggered by responsive options and media query matches
   *
   * @memberof Chartist.Core
   * @param {Object} options Options set by user
   * @param {Array} responsiveOptions Optional functions to add responsive behavior to chart
   * @param {Object} eventEmitter The event emitter that will be used to emit the options changed events
   * @return {Object} The consolidated options object from the defaults, base and matching responsive options
   */
  Chartist.optionsProvider = function (options, responsiveOptions, eventEmitter) {
    var baseOptions = Chartist.extend({}, options),
        currentOptions,
        mediaQueryListeners = [],
        i;

    function updateCurrentOptions(mediaEvent) {
      var previousOptions = currentOptions;
      currentOptions = Chartist.extend({}, baseOptions);

      if (responsiveOptions) {
        for (i = 0; i < responsiveOptions.length; i++) {
          var mql = window.matchMedia(responsiveOptions[i][0]);
          if (mql.matches) {
            currentOptions = Chartist.extend(currentOptions, responsiveOptions[i][1]);
          }
        }
      }

      if (eventEmitter && mediaEvent) {
        eventEmitter.emit('optionsChanged', {
          previousOptions: previousOptions,
          currentOptions: currentOptions
        });
      }
    }

    function removeMediaQueryListeners() {
      mediaQueryListeners.forEach(function (mql) {
        mql.removeListener(updateCurrentOptions);
      });
    }

    if (!window.matchMedia) {
      throw 'window.matchMedia not found! Make sure you\'re using a polyfill.';
    } else if (responsiveOptions) {

      for (i = 0; i < responsiveOptions.length; i++) {
        var mql = window.matchMedia(responsiveOptions[i][0]);
        mql.addListener(updateCurrentOptions);
        mediaQueryListeners.push(mql);
      }
    }
    // Execute initially without an event argument so we get the correct options
    updateCurrentOptions();

    return {
      removeMediaQueryListeners: removeMediaQueryListeners,
      getCurrentOptions: function getCurrentOptions() {
        return Chartist.extend({}, currentOptions);
      }
    };
  };

  /**
   * Splits a list of coordinates and associated values into segments. Each returned segment contains a pathCoordinates
   * valueData property describing the segment.
   *
   * With the default options, segments consist of contiguous sets of points that do not have an undefined value. Any
   * points with undefined values are discarded.
   *
   * **Options**
   * The following options are used to determine how segments are formed
   * ```javascript
   * var options = {
   *   // If fillHoles is true, undefined values are simply discarded without creating a new segment. Assuming other options are default, this returns single segment.
   *   fillHoles: false,
   *   // If increasingX is true, the coordinates in all segments have strictly increasing x-values.
   *   increasingX: false
   * };
   * ```
   *
   * @memberof Chartist.Core
   * @param {Array} pathCoordinates List of point coordinates to be split in the form [x1, y1, x2, y2 ... xn, yn]
   * @param {Array} values List of associated point values in the form [v1, v2 .. vn]
   * @param {Object} options Options set by user
   * @return {Array} List of segments, each containing a pathCoordinates and valueData property.
   */
  Chartist.splitIntoSegments = function (pathCoordinates, valueData, options) {
    var defaultOptions = {
      increasingX: false,
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    var segments = [];
    var hole = true;

    for (var i = 0; i < pathCoordinates.length; i += 2) {
      // If this value is a "hole" we set the hole flag
      if (Chartist.getMultiValue(valueData[i / 2].value) === undefined) {
        // if(valueData[i / 2].value === undefined) {
        if (!options.fillHoles) {
          hole = true;
        }
      } else {
        if (options.increasingX && i >= 2 && pathCoordinates[i] <= pathCoordinates[i - 2]) {
          // X is not increasing, so we need to make sure we start a new segment
          hole = true;
        }

        // If it's a valid value we need to check if we're coming out of a hole and create a new empty segment
        if (hole) {
          segments.push({
            pathCoordinates: [],
            valueData: []
          });
          // As we have a valid value now, we are not in a "hole" anymore
          hole = false;
        }

        // Add to the segment pathCoordinates and valueData
        segments[segments.length - 1].pathCoordinates.push(pathCoordinates[i], pathCoordinates[i + 1]);
        segments[segments.length - 1].valueData.push(valueData[i / 2]);
      }
    }

    return segments;
  };
})(window, document, Chartist);
; /**
  * Chartist path interpolation functions.
  *
  * @module Chartist.Interpolation
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  Chartist.Interpolation = {};

  /**
   * This interpolation function does not smooth the path and the result is only containing lines and no curves.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.none({
   *     fillHoles: false
   *   })
   * });
   *
   *
   * @memberof Chartist.Interpolation
   * @return {Function}
   */
  Chartist.Interpolation.none = function (options) {
    var defaultOptions = {
      fillHoles: false
    };
    options = Chartist.extend({}, defaultOptions, options);
    return function none(pathCoordinates, valueData) {
      var path = new Chartist.Svg.Path();
      var hole = true;

      for (var i = 0; i < pathCoordinates.length; i += 2) {
        var currX = pathCoordinates[i];
        var currY = pathCoordinates[i + 1];
        var currData = valueData[i / 2];

        if (Chartist.getMultiValue(currData.value) !== undefined) {

          if (hole) {
            path.move(currX, currY, false, currData);
          } else {
            path.line(currX, currY, false, currData);
          }

          hole = false;
        } else if (!options.fillHoles) {
          hole = true;
        }
      }

      return path;
    };
  };

  /**
   * Simple smoothing creates horizontal handles that are positioned with a fraction of the length between two data points. You can use the divisor option to specify the amount of smoothing.
   *
   * Simple smoothing can be used instead of `Chartist.Smoothing.cardinal` if you'd like to get rid of the artifacts it produces sometimes. Simple smoothing produces less flowing lines but is accurate by hitting the points and it also doesn't swing below or above the given data point.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The simple interpolation function accepts one configuration parameter `divisor`, between 1 and ∞, which controls the smoothing characteristics.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.simple({
   *     divisor: 2,
   *     fillHoles: false
   *   })
   * });
   *
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the simple interpolation factory function.
   * @return {Function}
   */
  Chartist.Interpolation.simple = function (options) {
    var defaultOptions = {
      divisor: 2,
      fillHoles: false
    };
    options = Chartist.extend({}, defaultOptions, options);

    var d = 1 / Math.max(1, options.divisor);

    return function simple(pathCoordinates, valueData) {
      var path = new Chartist.Svg.Path();
      var prevX, prevY, prevData;

      for (var i = 0; i < pathCoordinates.length; i += 2) {
        var currX = pathCoordinates[i];
        var currY = pathCoordinates[i + 1];
        var length = (currX - prevX) * d;
        var currData = valueData[i / 2];

        if (currData.value !== undefined) {

          if (prevData === undefined) {
            path.move(currX, currY, false, currData);
          } else {
            path.curve(prevX + length, prevY, currX - length, currY, currX, currY, false, currData);
          }

          prevX = currX;
          prevY = currY;
          prevData = currData;
        } else if (!options.fillHoles) {
          prevX = currX = prevData = undefined;
        }
      }

      return path;
    };
  };

  /**
   * Cardinal / Catmull-Rome spline interpolation is the default smoothing function in Chartist. It produces nice results where the splines will always meet the points. It produces some artifacts though when data values are increased or decreased rapidly. The line may not follow a very accurate path and if the line should be accurate this smoothing function does not produce the best results.
   *
   * Cardinal splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The cardinal interpolation function accepts one configuration parameter `tension`, between 0 and 1, which controls the smoothing intensity.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.cardinal({
   *     tension: 1,
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the cardinal factory function.
   * @return {Function}
   */
  Chartist.Interpolation.cardinal = function (options) {
    var defaultOptions = {
      tension: 1,
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    var t = Math.min(1, Math.max(0, options.tension)),
        c = 1 - t;

    return function cardinal(pathCoordinates, valueData) {
      // First we try to split the coordinates into segments
      // This is necessary to treat "holes" in line charts
      var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
        fillHoles: options.fillHoles
      });

      if (!segments.length) {
        // If there were no segments return 'Chartist.Interpolation.none'
        return Chartist.Interpolation.none()([]);
      } else if (segments.length > 1) {
        // If the split resulted in more that one segment we need to interpolate each segment individually and join them
        // afterwards together into a single path.
        var paths = [];
        // For each segment we will recurse the cardinal function
        segments.forEach(function (segment) {
          paths.push(cardinal(segment.pathCoordinates, segment.valueData));
        });
        // Join the segment path data into a single path and return
        return Chartist.Svg.Path.join(paths);
      } else {
        // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
        // segment
        pathCoordinates = segments[0].pathCoordinates;
        valueData = segments[0].valueData;

        // If less than two points we need to fallback to no smoothing
        if (pathCoordinates.length <= 4) {
          return Chartist.Interpolation.none()(pathCoordinates, valueData);
        }

        var path = new Chartist.Svg.Path().move(pathCoordinates[0], pathCoordinates[1], false, valueData[0]),
            z;

        for (var i = 0, iLen = pathCoordinates.length; iLen - 2 * !z > i; i += 2) {
          var p = [{ x: +pathCoordinates[i - 2], y: +pathCoordinates[i - 1] }, { x: +pathCoordinates[i], y: +pathCoordinates[i + 1] }, { x: +pathCoordinates[i + 2], y: +pathCoordinates[i + 3] }, { x: +pathCoordinates[i + 4], y: +pathCoordinates[i + 5] }];
          if (z) {
            if (!i) {
              p[0] = { x: +pathCoordinates[iLen - 2], y: +pathCoordinates[iLen - 1] };
            } else if (iLen - 4 === i) {
              p[3] = { x: +pathCoordinates[0], y: +pathCoordinates[1] };
            } else if (iLen - 2 === i) {
              p[2] = { x: +pathCoordinates[0], y: +pathCoordinates[1] };
              p[3] = { x: +pathCoordinates[2], y: +pathCoordinates[3] };
            }
          } else {
            if (iLen - 4 === i) {
              p[3] = p[2];
            } else if (!i) {
              p[0] = { x: +pathCoordinates[i], y: +pathCoordinates[i + 1] };
            }
          }

          path.curve(t * (-p[0].x + 6 * p[1].x + p[2].x) / 6 + c * p[2].x, t * (-p[0].y + 6 * p[1].y + p[2].y) / 6 + c * p[2].y, t * (p[1].x + 6 * p[2].x - p[3].x) / 6 + c * p[2].x, t * (p[1].y + 6 * p[2].y - p[3].y) / 6 + c * p[2].y, p[2].x, p[2].y, false, valueData[(i + 2) / 2]);
        }

        return path;
      }
    };
  };

  /**
   * Monotone Cubic spline interpolation produces a smooth curve which preserves monotonicity. Unlike cardinal splines, the curve will not extend beyond the range of y-values of the original data points.
   *
   * Monotone Cubic splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
   *
   * The x-values of subsequent points must be increasing to fit a Monotone Cubic spline. If this condition is not met for a pair of adjacent points, then there will be a break in the curve between those data points.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.monotoneCubic({
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the monotoneCubic factory function.
   * @return {Function}
   */
  Chartist.Interpolation.monotoneCubic = function (options) {
    var defaultOptions = {
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    return function monotoneCubic(pathCoordinates, valueData) {
      // First we try to split the coordinates into segments
      // This is necessary to treat "holes" in line charts
      var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
        fillHoles: options.fillHoles,
        increasingX: true
      });

      if (!segments.length) {
        // If there were no segments return 'Chartist.Interpolation.none'
        return Chartist.Interpolation.none()([]);
      } else if (segments.length > 1) {
        // If the split resulted in more that one segment we need to interpolate each segment individually and join them
        // afterwards together into a single path.
        var paths = [];
        // For each segment we will recurse the monotoneCubic fn function
        segments.forEach(function (segment) {
          paths.push(monotoneCubic(segment.pathCoordinates, segment.valueData));
        });
        // Join the segment path data into a single path and return
        return Chartist.Svg.Path.join(paths);
      } else {
        // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
        // segment
        pathCoordinates = segments[0].pathCoordinates;
        valueData = segments[0].valueData;

        // If less than three points we need to fallback to no smoothing
        if (pathCoordinates.length <= 4) {
          return Chartist.Interpolation.none()(pathCoordinates, valueData);
        }

        var xs = [],
            ys = [],
            i,
            n = pathCoordinates.length / 2,
            ms = [],
            ds = [],
            dys = [],
            dxs = [],
            path;

        // Populate x and y coordinates into separate arrays, for readability

        for (i = 0; i < n; i++) {
          xs[i] = pathCoordinates[i * 2];
          ys[i] = pathCoordinates[i * 2 + 1];
        }

        // Calculate deltas and derivative

        for (i = 0; i < n - 1; i++) {
          dys[i] = ys[i + 1] - ys[i];
          dxs[i] = xs[i + 1] - xs[i];
          ds[i] = dys[i] / dxs[i];
        }

        // Determine desired slope (m) at each point using Fritsch-Carlson method
        // See: http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation

        ms[0] = ds[0];
        ms[n - 1] = ds[n - 2];

        for (i = 1; i < n - 1; i++) {
          if (ds[i] === 0 || ds[i - 1] === 0 || ds[i - 1] > 0 !== ds[i] > 0) {
            ms[i] = 0;
          } else {
            ms[i] = 3 * (dxs[i - 1] + dxs[i]) / ((2 * dxs[i] + dxs[i - 1]) / ds[i - 1] + (dxs[i] + 2 * dxs[i - 1]) / ds[i]);

            if (!isFinite(ms[i])) {
              ms[i] = 0;
            }
          }
        }

        // Now build a path from the slopes

        path = new Chartist.Svg.Path().move(xs[0], ys[0], false, valueData[0]);

        for (i = 0; i < n - 1; i++) {
          path.curve(
          // First control point
          xs[i] + dxs[i] / 3, ys[i] + ms[i] * dxs[i] / 3,
          // Second control point
          xs[i + 1] - dxs[i] / 3, ys[i + 1] - ms[i + 1] * dxs[i] / 3,
          // End point
          xs[i + 1], ys[i + 1], false, valueData[i + 1]);
        }

        return path;
      }
    };
  };

  /**
   * Step interpolation will cause the line chart to move in steps rather than diagonal or smoothed lines. This interpolation will create additional points that will also be drawn when the `showPoint` option is enabled.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The step interpolation function accepts one configuration parameter `postpone`, that can be `true` or `false`. The default value is `true` and will cause the step to occur where the value actually changes. If a different behaviour is needed where the step is shifted to the left and happens before the actual value, this option can be set to `false`.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.step({
   *     postpone: true,
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param options
   * @returns {Function}
   */
  Chartist.Interpolation.step = function (options) {
    var defaultOptions = {
      postpone: true,
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    return function step(pathCoordinates, valueData) {
      var path = new Chartist.Svg.Path();

      var prevX, prevY, prevData;

      for (var i = 0; i < pathCoordinates.length; i += 2) {
        var currX = pathCoordinates[i];
        var currY = pathCoordinates[i + 1];
        var currData = valueData[i / 2];

        // If the current point is also not a hole we can draw the step lines
        if (currData.value !== undefined) {
          if (prevData === undefined) {
            path.move(currX, currY, false, currData);
          } else {
            if (options.postpone) {
              // If postponed we should draw the step line with the value of the previous value
              path.line(currX, prevY, false, prevData);
            } else {
              // If not postponed we should draw the step line with the value of the current value
              path.line(prevX, currY, false, currData);
            }
            // Line to the actual point (this should only be a Y-Axis movement
            path.line(currX, currY, false, currData);
          }

          prevX = currX;
          prevY = currY;
          prevData = currData;
        } else if (!options.fillHoles) {
          prevX = prevY = prevData = undefined;
        }
      }

      return path;
    };
  };
})(window, document, Chartist);
; /**
  * A very basic event module that helps to generate and catch events.
  *
  * @module Chartist.Event
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  Chartist.EventEmitter = function () {
    var handlers = [];

    /**
     * Add an event handler for a specific event
     *
     * @memberof Chartist.Event
     * @param {String} event The event name
     * @param {Function} handler A event handler function
     */
    function addEventHandler(event, handler) {
      handlers[event] = handlers[event] || [];
      handlers[event].push(handler);
    }

    /**
     * Remove an event handler of a specific event name or remove all event handlers for a specific event.
     *
     * @memberof Chartist.Event
     * @param {String} event The event name where a specific or all handlers should be removed
     * @param {Function} [handler] An optional event handler function. If specified only this specific handler will be removed and otherwise all handlers are removed.
     */
    function removeEventHandler(event, handler) {
      // Only do something if there are event handlers with this name existing
      if (handlers[event]) {
        // If handler is set we will look for a specific handler and only remove this
        if (handler) {
          handlers[event].splice(handlers[event].indexOf(handler), 1);
          if (handlers[event].length === 0) {
            delete handlers[event];
          }
        } else {
          // If no handler is specified we remove all handlers for this event
          delete handlers[event];
        }
      }
    }

    /**
     * Use this function to emit an event. All handlers that are listening for this event will be triggered with the data parameter.
     *
     * @memberof Chartist.Event
     * @param {String} event The event name that should be triggered
     * @param {*} data Arbitrary data that will be passed to the event handler callback functions
     */
    function emit(event, data) {
      // Only do something if there are event handlers with this name existing
      if (handlers[event]) {
        handlers[event].forEach(function (handler) {
          handler(data);
        });
      }

      // Emit event to star event handlers
      if (handlers['*']) {
        handlers['*'].forEach(function (starHandler) {
          starHandler(event, data);
        });
      }
    }

    return {
      addEventHandler: addEventHandler,
      removeEventHandler: removeEventHandler,
      emit: emit
    };
  };
})(window, document, Chartist);
; /**
  * This module provides some basic prototype inheritance utilities.
  *
  * @module Chartist.Class
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  function listToArray(list) {
    var arr = [];
    if (list.length) {
      for (var i = 0; i < list.length; i++) {
        arr.push(list[i]);
      }
    }
    return arr;
  }

  /**
   * Method to extend from current prototype.
   *
   * @memberof Chartist.Class
   * @param {Object} properties The object that serves as definition for the prototype that gets created for the new class. This object should always contain a constructor property that is the desired constructor for the newly created class.
   * @param {Object} [superProtoOverride] By default extens will use the current class prototype or Chartist.class. With this parameter you can specify any super prototype that will be used.
   * @return {Function} Constructor function of the new class
   *
   * @example
   * var Fruit = Class.extend({
     * color: undefined,
     *   sugar: undefined,
     *
     *   constructor: function(color, sugar) {
     *     this.color = color;
     *     this.sugar = sugar;
     *   },
     *
     *   eat: function() {
     *     this.sugar = 0;
     *     return this;
     *   }
     * });
   *
   * var Banana = Fruit.extend({
     *   length: undefined,
     *
     *   constructor: function(length, sugar) {
     *     Banana.super.constructor.call(this, 'Yellow', sugar);
     *     this.length = length;
     *   }
     * });
   *
   * var banana = new Banana(20, 40);
   * console.log('banana instanceof Fruit', banana instanceof Fruit);
   * console.log('Fruit is prototype of banana', Fruit.prototype.isPrototypeOf(banana));
   * console.log('bananas prototype is Fruit', Object.getPrototypeOf(banana) === Fruit.prototype);
   * console.log(banana.sugar);
   * console.log(banana.eat().sugar);
   * console.log(banana.color);
   */
  function extend(properties, superProtoOverride) {
    var superProto = superProtoOverride || this.prototype || Chartist.Class;
    var proto = Object.create(superProto);

    Chartist.Class.cloneDefinitions(proto, properties);

    var constr = function constr() {
      var fn = proto.constructor || function () {},
          instance;

      // If this is linked to the Chartist namespace the constructor was not called with new
      // To provide a fallback we will instantiate here and return the instance
      instance = this === Chartist ? Object.create(proto) : this;
      fn.apply(instance, Array.prototype.slice.call(arguments, 0));

      // If this constructor was not called with new we need to return the instance
      // This will not harm when the constructor has been called with new as the returned value is ignored
      return instance;
    };

    constr.prototype = proto;
    constr.super = superProto;
    constr.extend = this.extend;

    return constr;
  }

  // Variable argument list clones args > 0 into args[0] and retruns modified args[0]
  function cloneDefinitions() {
    var args = listToArray(arguments);
    var target = args[0];

    args.splice(1, args.length - 1).forEach(function (source) {
      Object.getOwnPropertyNames(source).forEach(function (propName) {
        // If this property already exist in target we delete it first
        delete target[propName];
        // Define the property with the descriptor from source
        Object.defineProperty(target, propName, Object.getOwnPropertyDescriptor(source, propName));
      });
    });

    return target;
  }

  Chartist.Class = {
    extend: extend,
    cloneDefinitions: cloneDefinitions
  };
})(window, document, Chartist);
; /**
  * Base for all chart types. The methods in Chartist.Base are inherited to all chart types.
  *
  * @module Chartist.Base
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  // TODO: Currently we need to re-draw the chart on window resize. This is usually very bad and will affect performance.
  // This is done because we can't work with relative coordinates when drawing the chart because SVG Path does not
  // work with relative positions yet. We need to check if we can do a viewBox hack to switch to percentage.
  // See http://mozilla.6506.n7.nabble.com/Specyfing-paths-with-percentages-unit-td247474.html
  // Update: can be done using the above method tested here: http://codepen.io/gionkunz/pen/KDvLj
  // The problem is with the label offsets that can't be converted into percentage and affecting the chart container
  /**
   * Updates the chart which currently does a full reconstruction of the SVG DOM
   *
   * @param {Object} [data] Optional data you'd like to set for the chart before it will update. If not specified the update method will use the data that is already configured with the chart.
   * @param {Object} [options] Optional options you'd like to add to the previous options for the chart before it will update. If not specified the update method will use the options that have been already configured with the chart.
   * @param {Boolean} [override] If set to true, the passed options will be used to extend the options that have been configured already. Otherwise the chart default options will be used as the base
   * @memberof Chartist.Base
   */

  function update(data, options, override) {
    if (data) {
      this.data = data || {};
      this.data.labels = this.data.labels || [];
      this.data.series = this.data.series || [];
      // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
      this.eventEmitter.emit('data', {
        type: 'update',
        data: this.data
      });
    }

    if (options) {
      this.options = Chartist.extend({}, override ? this.options : this.defaultOptions, options);

      // If chartist was not initialized yet, we just set the options and leave the rest to the initialization
      // Otherwise we re-create the optionsProvider at this point
      if (!this.initializeTimeoutId) {
        this.optionsProvider.removeMediaQueryListeners();
        this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
      }
    }

    // Only re-created the chart if it has been initialized yet
    if (!this.initializeTimeoutId) {
      this.createChart(this.optionsProvider.getCurrentOptions());
    }

    // Return a reference to the chart object to chain up calls
    return this;
  }

  /**
   * This method can be called on the API object of each chart and will un-register all event listeners that were added to other components. This currently includes a window.resize listener as well as media query listeners if any responsive options have been provided. Use this function if you need to destroy and recreate Chartist charts dynamically.
   *
   * @memberof Chartist.Base
   */
  function detach() {
    // Only detach if initialization already occurred on this chart. If this chart still hasn't initialized (therefore
    // the initializationTimeoutId is still a valid timeout reference, we will clear the timeout
    if (!this.initializeTimeoutId) {
      window.removeEventListener('resize', this.resizeListener);
      this.optionsProvider.removeMediaQueryListeners();
    } else {
      window.clearTimeout(this.initializeTimeoutId);
    }

    return this;
  }

  /**
   * Use this function to register event handlers. The handler callbacks are synchronous and will run in the main thread rather than the event loop.
   *
   * @memberof Chartist.Base
   * @param {String} event Name of the event. Check the examples for supported events.
   * @param {Function} handler The handler function that will be called when an event with the given name was emitted. This function will receive a data argument which contains event data. See the example for more details.
   */
  function on(event, handler) {
    this.eventEmitter.addEventHandler(event, handler);
    return this;
  }

  /**
   * Use this function to un-register event handlers. If the handler function parameter is omitted all handlers for the given event will be un-registered.
   *
   * @memberof Chartist.Base
   * @param {String} event Name of the event for which a handler should be removed
   * @param {Function} [handler] The handler function that that was previously used to register a new event handler. This handler will be removed from the event handler list. If this parameter is omitted then all event handlers for the given event are removed from the list.
   */
  function off(event, handler) {
    this.eventEmitter.removeEventHandler(event, handler);
    return this;
  }

  function initialize() {
    // Add window resize listener that re-creates the chart
    window.addEventListener('resize', this.resizeListener);

    // Obtain current options based on matching media queries (if responsive options are given)
    // This will also register a listener that is re-creating the chart based on media changes
    this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
    // Register options change listener that will trigger a chart update
    this.eventEmitter.addEventHandler('optionsChanged', function () {
      this.update();
    }.bind(this));

    // Before the first chart creation we need to register us with all plugins that are configured
    // Initialize all relevant plugins with our chart object and the plugin options specified in the config
    if (this.options.plugins) {
      this.options.plugins.forEach(function (plugin) {
        if (plugin instanceof Array) {
          plugin[0](this, plugin[1]);
        } else {
          plugin(this);
        }
      }.bind(this));
    }

    // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
    this.eventEmitter.emit('data', {
      type: 'initial',
      data: this.data
    });

    // Create the first chart
    this.createChart(this.optionsProvider.getCurrentOptions());

    // As chart is initialized from the event loop now we can reset our timeout reference
    // This is important if the chart gets initialized on the same element twice
    this.initializeTimeoutId = undefined;
  }

  /**
   * Constructor of chart base class.
   *
   * @param query
   * @param data
   * @param defaultOptions
   * @param options
   * @param responsiveOptions
   * @constructor
   */
  function Base(query, data, defaultOptions, options, responsiveOptions) {
    this.container = Chartist.querySelector(query);
    this.data = data || {};
    this.data.labels = this.data.labels || [];
    this.data.series = this.data.series || [];
    this.defaultOptions = defaultOptions;
    this.options = options;
    this.responsiveOptions = responsiveOptions;
    this.eventEmitter = Chartist.EventEmitter();
    this.supportsForeignObject = Chartist.Svg.isSupported('Extensibility');
    this.supportsAnimations = Chartist.Svg.isSupported('AnimationEventsAttribute');
    this.resizeListener = function resizeListener() {
      this.update();
    }.bind(this);

    if (this.container) {
      // If chartist was already initialized in this container we are detaching all event listeners first
      if (this.container.__chartist__) {
        this.container.__chartist__.detach();
      }

      this.container.__chartist__ = this;
    }

    // Using event loop for first draw to make it possible to register event listeners in the same call stack where
    // the chart was created.
    this.initializeTimeoutId = setTimeout(initialize.bind(this), 0);
  }

  // Creating the chart base class
  Chartist.Base = Chartist.Class.extend({
    constructor: Base,
    optionsProvider: undefined,
    container: undefined,
    svg: undefined,
    eventEmitter: undefined,
    createChart: function createChart() {
      throw new Error('Base chart type can\'t be instantiated!');
    },
    update: update,
    detach: detach,
    on: on,
    off: off,
    version: Chartist.version,
    supportsForeignObject: false
  });
})(window, document, Chartist);
; /**
  * Chartist SVG module for simple SVG DOM abstraction
  *
  * @module Chartist.Svg
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  /**
   * Chartist.Svg creates a new SVG object wrapper with a starting element. You can use the wrapper to fluently create sub-elements and modify them.
   *
   * @memberof Chartist.Svg
   * @constructor
   * @param {String|Element} name The name of the SVG element to create or an SVG dom element which should be wrapped into Chartist.Svg
   * @param {Object} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param {String} className This class or class list will be added to the SVG element
   * @param {Object} parent The parent SVG wrapper object where this newly created wrapper and it's element will be attached to as child
   * @param {Boolean} insertFirst If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   */

  function Svg(name, attributes, className, parent, insertFirst) {
    // If Svg is getting called with an SVG element we just return the wrapper
    if (name instanceof Element) {
      this._node = name;
    } else {
      this._node = document.createElementNS(Chartist.namespaces.svg, name);

      // If this is an SVG element created then custom namespace
      if (name === 'svg') {
        this.attr({
          'xmlns:ct': Chartist.namespaces.ct
        });
      }
    }

    if (attributes) {
      this.attr(attributes);
    }

    if (className) {
      this.addClass(className);
    }

    if (parent) {
      if (insertFirst && parent._node.firstChild) {
        parent._node.insertBefore(this._node, parent._node.firstChild);
      } else {
        parent._node.appendChild(this._node);
      }
    }
  }

  /**
   * Set attributes on the current SVG element of the wrapper you're currently working on.
   *
   * @memberof Chartist.Svg
   * @param {Object|String} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added. If this parameter is a String then the function is used as a getter and will return the attribute value.
   * @param {String} [ns] If specified, the attribute will be obtained using getAttributeNs. In order to write namepsaced attributes you can use the namespace:attribute notation within the attributes object.
   * @return {Object|String} The current wrapper object will be returned so it can be used for chaining or the attribute value if used as getter function.
   */
  function attr(attributes, ns) {
    if (typeof attributes === 'string') {
      if (ns) {
        return this._node.getAttributeNS(ns, attributes);
      } else {
        return this._node.getAttribute(attributes);
      }
    }

    Object.keys(attributes).forEach(function (key) {
      // If the attribute value is undefined we can skip this one
      if (attributes[key] === undefined) {
        return;
      }

      if (key.indexOf(':') !== -1) {
        var namespacedAttribute = key.split(':');
        this._node.setAttributeNS(Chartist.namespaces[namespacedAttribute[0]], key, attributes[key]);
      } else {
        this._node.setAttribute(key, attributes[key]);
      }
    }.bind(this));

    return this;
  }

  /**
   * Create a new SVG element whose wrapper object will be selected for further operations. This way you can also create nested groups easily.
   *
   * @memberof Chartist.Svg
   * @param {String} name The name of the SVG element that should be created as child element of the currently selected element wrapper
   * @param {Object} [attributes] An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param {String} [className] This class or class list will be added to the SVG element
   * @param {Boolean} [insertFirst] If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper object that can be used to modify the containing SVG data
   */
  function elem(name, attributes, className, insertFirst) {
    return new Chartist.Svg(name, attributes, className, this, insertFirst);
  }

  /**
   * Returns the parent Chartist.SVG wrapper object
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper around the parent node of the current node. If the parent node is not existing or it's not an SVG node then this function will return null.
   */
  function parent() {
    return this._node.parentNode instanceof SVGElement ? new Chartist.Svg(this._node.parentNode) : null;
  }

  /**
   * This method returns a Chartist.Svg wrapper around the root SVG element of the current tree.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The root SVG element wrapped in a Chartist.Svg element
   */
  function root() {
    var node = this._node;
    while (node.nodeName !== 'svg') {
      node = node.parentNode;
    }
    return new Chartist.Svg(node);
  }

  /**
   * Find the first child SVG element of the current element that matches a CSS selector. The returned object is a Chartist.Svg wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} selector A CSS selector that is used to query for child SVG elements
   * @return {Chartist.Svg} The SVG wrapper for the element found or null if no element was found
   */
  function querySelector(selector) {
    var foundNode = this._node.querySelector(selector);
    return foundNode ? new Chartist.Svg(foundNode) : null;
  }

  /**
   * Find the all child SVG elements of the current element that match a CSS selector. The returned object is a Chartist.Svg.List wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} selector A CSS selector that is used to query for child SVG elements
   * @return {Chartist.Svg.List} The SVG wrapper list for the element found or null if no element was found
   */
  function querySelectorAll(selector) {
    var foundNodes = this._node.querySelectorAll(selector);
    return foundNodes.length ? new Chartist.Svg.List(foundNodes) : null;
  }

  /**
   * Returns the underlying SVG node for the current element.
   *
   * @memberof Chartist.Svg
   * @returns {Node}
   */
  function getNode() {
    return this._node;
  }

  /**
   * This method creates a foreignObject (see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/foreignObject) that allows to embed HTML content into a SVG graphic. With the help of foreignObjects you can enable the usage of regular HTML elements inside of SVG where they are subject for SVG positioning and transformation but the Browser will use the HTML rendering capabilities for the containing DOM.
   *
   * @memberof Chartist.Svg
   * @param {Node|String} content The DOM Node, or HTML string that will be converted to a DOM Node, that is then placed into and wrapped by the foreignObject
   * @param {String} [attributes] An object with properties that will be added as attributes to the foreignObject element that is created. Attributes with undefined values will not be added.
   * @param {String} [className] This class or class list will be added to the SVG element
   * @param {Boolean} [insertFirst] Specifies if the foreignObject should be inserted as first child
   * @return {Chartist.Svg} New wrapper object that wraps the foreignObject element
   */
  function foreignObject(content, attributes, className, insertFirst) {
    // If content is string then we convert it to DOM
    // TODO: Handle case where content is not a string nor a DOM Node
    if (typeof content === 'string') {
      var container = document.createElement('div');
      container.innerHTML = content;
      content = container.firstChild;
    }

    // Adding namespace to content element
    content.setAttribute('xmlns', Chartist.namespaces.xmlns);

    // Creating the foreignObject without required extension attribute (as described here
    // http://www.w3.org/TR/SVG/extend.html#ForeignObjectElement)
    var fnObj = this.elem('foreignObject', attributes, className, insertFirst);

    // Add content to foreignObjectElement
    fnObj._node.appendChild(content);

    return fnObj;
  }

  /**
   * This method adds a new text element to the current Chartist.Svg wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} t The text that should be added to the text element that is created
   * @return {Chartist.Svg} The same wrapper object that was used to add the newly created element
   */
  function text(t) {
    this._node.appendChild(document.createTextNode(t));
    return this;
  }

  /**
   * This method will clear all child nodes of the current wrapper object.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The same wrapper object that got emptied
   */
  function empty() {
    while (this._node.firstChild) {
      this._node.removeChild(this._node.firstChild);
    }

    return this;
  }

  /**
   * This method will cause the current wrapper to remove itself from its parent wrapper. Use this method if you'd like to get rid of an element in a given DOM structure.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The parent wrapper object of the element that got removed
   */
  function remove() {
    this._node.parentNode.removeChild(this._node);
    return this.parent();
  }

  /**
   * This method will replace the element with a new element that can be created outside of the current DOM.
   *
   * @memberof Chartist.Svg
   * @param {Chartist.Svg} newElement The new Chartist.Svg object that will be used to replace the current wrapper object
   * @return {Chartist.Svg} The wrapper of the new element
   */
  function replace(newElement) {
    this._node.parentNode.replaceChild(newElement._node, this._node);
    return newElement;
  }

  /**
   * This method will append an element to the current element as a child.
   *
   * @memberof Chartist.Svg
   * @param {Chartist.Svg} element The Chartist.Svg element that should be added as a child
   * @param {Boolean} [insertFirst] Specifies if the element should be inserted as first child
   * @return {Chartist.Svg} The wrapper of the appended object
   */
  function append(element, insertFirst) {
    if (insertFirst && this._node.firstChild) {
      this._node.insertBefore(element._node, this._node.firstChild);
    } else {
      this._node.appendChild(element._node);
    }

    return this;
  }

  /**
   * Returns an array of class names that are attached to the current wrapper element. This method can not be chained further.
   *
   * @memberof Chartist.Svg
   * @return {Array} A list of classes or an empty array if there are no classes on the current element
   */
  function classes() {
    return this._node.getAttribute('class') ? this._node.getAttribute('class').trim().split(/\s+/) : [];
  }

  /**
   * Adds one or a space separated list of classes to the current element and ensures the classes are only existing once.
   *
   * @memberof Chartist.Svg
   * @param {String} names A white space separated list of class names
   * @return {Chartist.Svg} The wrapper of the current element
   */
  function addClass(names) {
    this._node.setAttribute('class', this.classes(this._node).concat(names.trim().split(/\s+/)).filter(function (elem, pos, self) {
      return self.indexOf(elem) === pos;
    }).join(' '));

    return this;
  }

  /**
   * Removes one or a space separated list of classes from the current element.
   *
   * @memberof Chartist.Svg
   * @param {String} names A white space separated list of class names
   * @return {Chartist.Svg} The wrapper of the current element
   */
  function removeClass(names) {
    var removedClasses = names.trim().split(/\s+/);

    this._node.setAttribute('class', this.classes(this._node).filter(function (name) {
      return removedClasses.indexOf(name) === -1;
    }).join(' '));

    return this;
  }

  /**
   * Removes all classes from the current element.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The wrapper of the current element
   */
  function removeAllClasses() {
    this._node.setAttribute('class', '');

    return this;
  }

  /**
   * Get element height using `getBoundingClientRect`
   *
   * @memberof Chartist.Svg
   * @return {Number} The elements height in pixels
   */
  function height() {
    return this._node.getBoundingClientRect().height;
  }

  /**
   * Get element width using `getBoundingClientRect`
   *
   * @memberof Chartist.Core
   * @return {Number} The elements width in pixels
   */
  function width() {
    return this._node.getBoundingClientRect().width;
  }

  /**
   * The animate function lets you animate the current element with SMIL animations. You can add animations for multiple attributes at the same time by using an animation definition object. This object should contain SMIL animation attributes. Please refer to http://www.w3.org/TR/SVG/animate.html for a detailed specification about the available animation attributes. Additionally an easing property can be passed in the animation definition object. This can be a string with a name of an easing function in `Chartist.Svg.Easing` or an array with four numbers specifying a cubic Bézier curve.
   * **An animations object could look like this:**
   * ```javascript
   * element.animate({
   *   opacity: {
   *     dur: 1000,
   *     from: 0,
   *     to: 1
   *   },
   *   x1: {
   *     dur: '1000ms',
   *     from: 100,
   *     to: 200,
   *     easing: 'easeOutQuart'
   *   },
   *   y1: {
   *     dur: '2s',
   *     from: 0,
   *     to: 100
   *   }
   * });
   * ```
   * **Automatic unit conversion**
   * For the `dur` and the `begin` animate attribute you can also omit a unit by passing a number. The number will automatically be converted to milli seconds.
   * **Guided mode**
   * The default behavior of SMIL animations with offset using the `begin` attribute is that the attribute will keep it's original value until the animation starts. Mostly this behavior is not desired as you'd like to have your element attributes already initialized with the animation `from` value even before the animation starts. Also if you don't specify `fill="freeze"` on an animate element or if you delete the animation after it's done (which is done in guided mode) the attribute will switch back to the initial value. This behavior is also not desired when performing simple one-time animations. For one-time animations you'd want to trigger animations immediately instead of relative to the document begin time. That's why in guided mode Chartist.Svg will also use the `begin` property to schedule a timeout and manually start the animation after the timeout. If you're using multiple SMIL definition objects for an attribute (in an array), guided mode will be disabled for this attribute, even if you explicitly enabled it.
   * If guided mode is enabled the following behavior is added:
   * - Before the animation starts (even when delayed with `begin`) the animated attribute will be set already to the `from` value of the animation
   * - `begin` is explicitly set to `indefinite` so it can be started manually without relying on document begin time (creation)
   * - The animate element will be forced to use `fill="freeze"`
   * - The animation will be triggered with `beginElement()` in a timeout where `begin` of the definition object is interpreted in milli seconds. If no `begin` was specified the timeout is triggered immediately.
   * - After the animation the element attribute value will be set to the `to` value of the animation
   * - The animate element is deleted from the DOM
   *
   * @memberof Chartist.Svg
   * @param {Object} animations An animations object where the property keys are the attributes you'd like to animate. The properties should be objects again that contain the SMIL animation attributes (usually begin, dur, from, and to). The property begin and dur is auto converted (see Automatic unit conversion). You can also schedule multiple animations for the same attribute by passing an Array of SMIL definition objects. Attributes that contain an array of SMIL definition objects will not be executed in guided mode.
   * @param {Boolean} guided Specify if guided mode should be activated for this animation (see Guided mode). If not otherwise specified, guided mode will be activated.
   * @param {Object} eventEmitter If specified, this event emitter will be notified when an animation starts or ends.
   * @return {Chartist.Svg} The current element where the animation was added
   */
  function animate(animations, guided, eventEmitter) {
    if (guided === undefined) {
      guided = true;
    }

    Object.keys(animations).forEach(function createAnimateForAttributes(attribute) {

      function createAnimate(animationDefinition, guided) {
        var attributeProperties = {},
            animate,
            timeout,
            easing;

        // Check if an easing is specified in the definition object and delete it from the object as it will not
        // be part of the animate element attributes.
        if (animationDefinition.easing) {
          // If already an easing Bézier curve array we take it or we lookup a easing array in the Easing object
          easing = animationDefinition.easing instanceof Array ? animationDefinition.easing : Chartist.Svg.Easing[animationDefinition.easing];
          delete animationDefinition.easing;
        }

        // If numeric dur or begin was provided we assume milli seconds
        animationDefinition.begin = Chartist.ensureUnit(animationDefinition.begin, 'ms');
        animationDefinition.dur = Chartist.ensureUnit(animationDefinition.dur, 'ms');

        if (easing) {
          animationDefinition.calcMode = 'spline';
          animationDefinition.keySplines = easing.join(' ');
          animationDefinition.keyTimes = '0;1';
        }

        // Adding "fill: freeze" if we are in guided mode and set initial attribute values
        if (guided) {
          animationDefinition.fill = 'freeze';
          // Animated property on our element should already be set to the animation from value in guided mode
          attributeProperties[attribute] = animationDefinition.from;
          this.attr(attributeProperties);

          // In guided mode we also set begin to indefinite so we can trigger the start manually and put the begin
          // which needs to be in ms aside
          timeout = Chartist.quantity(animationDefinition.begin || 0).value;
          animationDefinition.begin = 'indefinite';
        }

        animate = this.elem('animate', Chartist.extend({
          attributeName: attribute
        }, animationDefinition));

        if (guided) {
          // If guided we take the value that was put aside in timeout and trigger the animation manually with a timeout
          setTimeout(function () {
            // If beginElement fails we set the animated attribute to the end position and remove the animate element
            // This happens if the SMIL ElementTimeControl interface is not supported or any other problems occured in
            // the browser. (Currently FF 34 does not support animate elements in foreignObjects)
            try {
              animate._node.beginElement();
            } catch (err) {
              // Set animated attribute to current animated value
              attributeProperties[attribute] = animationDefinition.to;
              this.attr(attributeProperties);
              // Remove the animate element as it's no longer required
              animate.remove();
            }
          }.bind(this), timeout);
        }

        if (eventEmitter) {
          animate._node.addEventListener('beginEvent', function handleBeginEvent() {
            eventEmitter.emit('animationBegin', {
              element: this,
              animate: animate._node,
              params: animationDefinition
            });
          }.bind(this));
        }

        animate._node.addEventListener('endEvent', function handleEndEvent() {
          if (eventEmitter) {
            eventEmitter.emit('animationEnd', {
              element: this,
              animate: animate._node,
              params: animationDefinition
            });
          }

          if (guided) {
            // Set animated attribute to current animated value
            attributeProperties[attribute] = animationDefinition.to;
            this.attr(attributeProperties);
            // Remove the animate element as it's no longer required
            animate.remove();
          }
        }.bind(this));
      }

      // If current attribute is an array of definition objects we create an animate for each and disable guided mode
      if (animations[attribute] instanceof Array) {
        animations[attribute].forEach(function (animationDefinition) {
          createAnimate.bind(this)(animationDefinition, false);
        }.bind(this));
      } else {
        createAnimate.bind(this)(animations[attribute], guided);
      }
    }.bind(this));

    return this;
  }

  Chartist.Svg = Chartist.Class.extend({
    constructor: Svg,
    attr: attr,
    elem: elem,
    parent: parent,
    root: root,
    querySelector: querySelector,
    querySelectorAll: querySelectorAll,
    getNode: getNode,
    foreignObject: foreignObject,
    text: text,
    empty: empty,
    remove: remove,
    replace: replace,
    append: append,
    classes: classes,
    addClass: addClass,
    removeClass: removeClass,
    removeAllClasses: removeAllClasses,
    height: height,
    width: width,
    animate: animate
  });

  /**
   * This method checks for support of a given SVG feature like Extensibility, SVG-animation or the like. Check http://www.w3.org/TR/SVG11/feature for a detailed list.
   *
   * @memberof Chartist.Svg
   * @param {String} feature The SVG 1.1 feature that should be checked for support.
   * @return {Boolean} True of false if the feature is supported or not
   */
  Chartist.Svg.isSupported = function (feature) {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#' + feature, '1.1');
  };

  /**
   * This Object contains some standard easing cubic bezier curves. Then can be used with their name in the `Chartist.Svg.animate`. You can also extend the list and use your own name in the `animate` function. Click the show code button to see the available bezier functions.
   *
   * @memberof Chartist.Svg
   */
  var easingCubicBeziers = {
    easeInSine: [0.47, 0, 0.745, 0.715],
    easeOutSine: [0.39, 0.575, 0.565, 1],
    easeInOutSine: [0.445, 0.05, 0.55, 0.95],
    easeInQuad: [0.55, 0.085, 0.68, 0.53],
    easeOutQuad: [0.25, 0.46, 0.45, 0.94],
    easeInOutQuad: [0.455, 0.03, 0.515, 0.955],
    easeInCubic: [0.55, 0.055, 0.675, 0.19],
    easeOutCubic: [0.215, 0.61, 0.355, 1],
    easeInOutCubic: [0.645, 0.045, 0.355, 1],
    easeInQuart: [0.895, 0.03, 0.685, 0.22],
    easeOutQuart: [0.165, 0.84, 0.44, 1],
    easeInOutQuart: [0.77, 0, 0.175, 1],
    easeInQuint: [0.755, 0.05, 0.855, 0.06],
    easeOutQuint: [0.23, 1, 0.32, 1],
    easeInOutQuint: [0.86, 0, 0.07, 1],
    easeInExpo: [0.95, 0.05, 0.795, 0.035],
    easeOutExpo: [0.19, 1, 0.22, 1],
    easeInOutExpo: [1, 0, 0, 1],
    easeInCirc: [0.6, 0.04, 0.98, 0.335],
    easeOutCirc: [0.075, 0.82, 0.165, 1],
    easeInOutCirc: [0.785, 0.135, 0.15, 0.86],
    easeInBack: [0.6, -0.28, 0.735, 0.045],
    easeOutBack: [0.175, 0.885, 0.32, 1.275],
    easeInOutBack: [0.68, -0.55, 0.265, 1.55]
  };

  Chartist.Svg.Easing = easingCubicBeziers;

  /**
   * This helper class is to wrap multiple `Chartist.Svg` elements into a list where you can call the `Chartist.Svg` functions on all elements in the list with one call. This is helpful when you'd like to perform calls with `Chartist.Svg` on multiple elements.
   * An instance of this class is also returned by `Chartist.Svg.querySelectorAll`.
   *
   * @memberof Chartist.Svg
   * @param {Array<Node>|NodeList} nodeList An Array of SVG DOM nodes or a SVG DOM NodeList (as returned by document.querySelectorAll)
   * @constructor
   */
  function SvgList(nodeList) {
    var list = this;

    this.svgElements = [];
    for (var i = 0; i < nodeList.length; i++) {
      this.svgElements.push(new Chartist.Svg(nodeList[i]));
    }

    // Add delegation methods for Chartist.Svg
    Object.keys(Chartist.Svg.prototype).filter(function (prototypeProperty) {
      return ['constructor', 'parent', 'querySelector', 'querySelectorAll', 'replace', 'append', 'classes', 'height', 'width'].indexOf(prototypeProperty) === -1;
    }).forEach(function (prototypeProperty) {
      list[prototypeProperty] = function () {
        var args = Array.prototype.slice.call(arguments, 0);
        list.svgElements.forEach(function (element) {
          Chartist.Svg.prototype[prototypeProperty].apply(element, args);
        });
        return list;
      };
    });
  }

  Chartist.Svg.List = Chartist.Class.extend({
    constructor: SvgList
  });
})(window, document, Chartist);
; /**
  * Chartist SVG path module for SVG path description creation and modification.
  *
  * @module Chartist.Svg.Path
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  /**
   * Contains the descriptors of supported element types in a SVG path. Currently only move, line and curve are supported.
   *
   * @memberof Chartist.Svg.Path
   * @type {Object}
   */

  var elementDescriptions = {
    m: ['x', 'y'],
    l: ['x', 'y'],
    c: ['x1', 'y1', 'x2', 'y2', 'x', 'y'],
    a: ['rx', 'ry', 'xAr', 'lAf', 'sf', 'x', 'y']
  };

  /**
   * Default options for newly created SVG path objects.
   *
   * @memberof Chartist.Svg.Path
   * @type {Object}
   */
  var defaultOptions = {
    // The accuracy in digit count after the decimal point. This will be used to round numbers in the SVG path. If this option is set to false then no rounding will be performed.
    accuracy: 3
  };

  function element(command, params, pathElements, pos, relative, data) {
    var pathElement = Chartist.extend({
      command: relative ? command.toLowerCase() : command.toUpperCase()
    }, params, data ? { data: data } : {});

    pathElements.splice(pos, 0, pathElement);
  }

  function forEachParam(pathElements, cb) {
    pathElements.forEach(function (pathElement, pathElementIndex) {
      elementDescriptions[pathElement.command.toLowerCase()].forEach(function (paramName, paramIndex) {
        cb(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
      });
    });
  }

  /**
   * Used to construct a new path object.
   *
   * @memberof Chartist.Svg.Path
   * @param {Boolean} close If set to true then this path will be closed when stringified (with a Z at the end)
   * @param {Object} options Options object that overrides the default objects. See default options for more details.
   * @constructor
   */
  function SvgPath(close, options) {
    this.pathElements = [];
    this.pos = 0;
    this.close = close;
    this.options = Chartist.extend({}, defaultOptions, options);
  }

  /**
   * Gets or sets the current position (cursor) inside of the path. You can move around the cursor freely but limited to 0 or the count of existing elements. All modifications with element functions will insert new elements at the position of this cursor.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} [pos] If a number is passed then the cursor is set to this position in the path element array.
   * @return {Chartist.Svg.Path|Number} If the position parameter was passed then the return value will be the path object for easy call chaining. If no position parameter was passed then the current position is returned.
   */
  function position(pos) {
    if (pos !== undefined) {
      this.pos = Math.max(0, Math.min(this.pathElements.length, pos));
      return this;
    } else {
      return this.pos;
    }
  }

  /**
   * Removes elements from the path starting at the current position.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} count Number of path elements that should be removed from the current position.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function remove(count) {
    this.pathElements.splice(this.pos, count);
    return this;
  }

  /**
   * Use this function to add a new move SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The x coordinate for the move element.
   * @param {Number} y The y coordinate for the move element.
   * @param {Boolean} [relative] If set to true the move element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function move(x, y, relative, data) {
    element('M', {
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Use this function to add a new line SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The x coordinate for the line element.
   * @param {Number} y The y coordinate for the line element.
   * @param {Boolean} [relative] If set to true the line element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function line(x, y, relative, data) {
    element('L', {
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Use this function to add a new curve SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x1 The x coordinate for the first control point of the bezier curve.
   * @param {Number} y1 The y coordinate for the first control point of the bezier curve.
   * @param {Number} x2 The x coordinate for the second control point of the bezier curve.
   * @param {Number} y2 The y coordinate for the second control point of the bezier curve.
   * @param {Number} x The x coordinate for the target point of the curve element.
   * @param {Number} y The y coordinate for the target point of the curve element.
   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function curve(x1, y1, x2, y2, x, y, relative, data) {
    element('C', {
      x1: +x1,
      y1: +y1,
      x2: +x2,
      y2: +y2,
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Use this function to add a new non-bezier curve SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} rx The radius to be used for the x-axis of the arc.
   * @param {Number} ry The radius to be used for the y-axis of the arc.
   * @param {Number} xAr Defines the orientation of the arc
   * @param {Number} lAf Large arc flag
   * @param {Number} sf Sweep flag
   * @param {Number} x The x coordinate for the target point of the curve element.
   * @param {Number} y The y coordinate for the target point of the curve element.
   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function arc(rx, ry, xAr, lAf, sf, x, y, relative, data) {
    element('A', {
      rx: +rx,
      ry: +ry,
      xAr: +xAr,
      lAf: +lAf,
      sf: +sf,
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Parses an SVG path seen in the d attribute of path elements, and inserts the parsed elements into the existing path object at the current cursor position. Any closing path indicators (Z at the end of the path) will be ignored by the parser as this is provided by the close option in the options of the path object.
   *
   * @memberof Chartist.Svg.Path
   * @param {String} path Any SVG path that contains move (m), line (l) or curve (c) components.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function parse(path) {
    // Parsing the SVG path string into an array of arrays [['M', '10', '10'], ['L', '100', '100']]
    var chunks = path.replace(/([A-Za-z])([0-9])/g, '$1 $2').replace(/([0-9])([A-Za-z])/g, '$1 $2').split(/[\s,]+/).reduce(function (result, element) {
      if (element.match(/[A-Za-z]/)) {
        result.push([]);
      }

      result[result.length - 1].push(element);
      return result;
    }, []);

    // If this is a closed path we remove the Z at the end because this is determined by the close option
    if (chunks[chunks.length - 1][0].toUpperCase() === 'Z') {
      chunks.pop();
    }

    // Using svgPathElementDescriptions to map raw path arrays into objects that contain the command and the parameters
    // For example {command: 'M', x: '10', y: '10'}
    var elements = chunks.map(function (chunk) {
      var command = chunk.shift(),
          description = elementDescriptions[command.toLowerCase()];

      return Chartist.extend({
        command: command
      }, description.reduce(function (result, paramName, index) {
        result[paramName] = +chunk[index];
        return result;
      }, {}));
    });

    // Preparing a splice call with the elements array as var arg params and insert the parsed elements at the current position
    var spliceArgs = [this.pos, 0];
    Array.prototype.push.apply(spliceArgs, elements);
    Array.prototype.splice.apply(this.pathElements, spliceArgs);
    // Increase the internal position by the element count
    this.pos += elements.length;

    return this;
  }

  /**
   * This function renders to current SVG path object into a final SVG string that can be used in the d attribute of SVG path elements. It uses the accuracy option to round big decimals. If the close parameter was set in the constructor of this path object then a path closing Z will be appended to the output string.
   *
   * @memberof Chartist.Svg.Path
   * @return {String}
   */
  function stringify() {
    var accuracyMultiplier = Math.pow(10, this.options.accuracy);

    return this.pathElements.reduce(function (path, pathElement) {
      var params = elementDescriptions[pathElement.command.toLowerCase()].map(function (paramName) {
        return this.options.accuracy ? Math.round(pathElement[paramName] * accuracyMultiplier) / accuracyMultiplier : pathElement[paramName];
      }.bind(this));

      return path + pathElement.command + params.join(',');
    }.bind(this), '') + (this.close ? 'Z' : '');
  }

  /**
   * Scales all elements in the current SVG path object. There is an individual parameter for each coordinate. Scaling will also be done for control points of curves, affecting the given coordinate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The number which will be used to scale the x, x1 and x2 of all path elements.
   * @param {Number} y The number which will be used to scale the y, y1 and y2 of all path elements.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function scale(x, y) {
    forEachParam(this.pathElements, function (pathElement, paramName) {
      pathElement[paramName] *= paramName[0] === 'x' ? x : y;
    });
    return this;
  }

  /**
   * Translates all elements in the current SVG path object. The translation is relative and there is an individual parameter for each coordinate. Translation will also be done for control points of curves, affecting the given coordinate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The number which will be used to translate the x, x1 and x2 of all path elements.
   * @param {Number} y The number which will be used to translate the y, y1 and y2 of all path elements.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function translate(x, y) {
    forEachParam(this.pathElements, function (pathElement, paramName) {
      pathElement[paramName] += paramName[0] === 'x' ? x : y;
    });
    return this;
  }

  /**
   * This function will run over all existing path elements and then loop over their attributes. The callback function will be called for every path element attribute that exists in the current path.
   * The method signature of the callback function looks like this:
   * ```javascript
   * function(pathElement, paramName, pathElementIndex, paramIndex, pathElements)
   * ```
   * If something else than undefined is returned by the callback function, this value will be used to replace the old value. This allows you to build custom transformations of path objects that can't be achieved using the basic transformation functions scale and translate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Function} transformFnc The callback function for the transformation. Check the signature in the function description.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function transform(transformFnc) {
    forEachParam(this.pathElements, function (pathElement, paramName, pathElementIndex, paramIndex, pathElements) {
      var transformed = transformFnc(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
      if (transformed || transformed === 0) {
        pathElement[paramName] = transformed;
      }
    });
    return this;
  }

  /**
   * This function clones a whole path object with all its properties. This is a deep clone and path element objects will also be cloned.
   *
   * @memberof Chartist.Svg.Path
   * @param {Boolean} [close] Optional option to set the new cloned path to closed. If not specified or false, the original path close option will be used.
   * @return {Chartist.Svg.Path}
   */
  function clone(close) {
    var c = new Chartist.Svg.Path(close || this.close);
    c.pos = this.pos;
    c.pathElements = this.pathElements.slice().map(function cloneElements(pathElement) {
      return Chartist.extend({}, pathElement);
    });
    c.options = Chartist.extend({}, this.options);
    return c;
  }

  /**
   * Split a Svg.Path object by a specific command in the path chain. The path chain will be split and an array of newly created paths objects will be returned. This is useful if you'd like to split an SVG path by it's move commands, for example, in order to isolate chunks of drawings.
   *
   * @memberof Chartist.Svg.Path
   * @param {String} command The command you'd like to use to split the path
   * @return {Array<Chartist.Svg.Path>}
   */
  function splitByCommand(command) {
    var split = [new Chartist.Svg.Path()];

    this.pathElements.forEach(function (pathElement) {
      if (pathElement.command === command.toUpperCase() && split[split.length - 1].pathElements.length !== 0) {
        split.push(new Chartist.Svg.Path());
      }

      split[split.length - 1].pathElements.push(pathElement);
    });

    return split;
  }

  /**
   * This static function on `Chartist.Svg.Path` is joining multiple paths together into one paths.
   *
   * @memberof Chartist.Svg.Path
   * @param {Array<Chartist.Svg.Path>} paths A list of paths to be joined together. The order is important.
   * @param {boolean} close If the newly created path should be a closed path
   * @param {Object} options Path options for the newly created path.
   * @return {Chartist.Svg.Path}
   */

  function join(paths, close, options) {
    var joinedPath = new Chartist.Svg.Path(close, options);
    for (var i = 0; i < paths.length; i++) {
      var path = paths[i];
      for (var j = 0; j < path.pathElements.length; j++) {
        joinedPath.pathElements.push(path.pathElements[j]);
      }
    }
    return joinedPath;
  }

  Chartist.Svg.Path = Chartist.Class.extend({
    constructor: SvgPath,
    position: position,
    remove: remove,
    move: move,
    line: line,
    curve: curve,
    arc: arc,
    scale: scale,
    translate: translate,
    transform: transform,
    parse: parse,
    stringify: stringify,
    clone: clone,
    splitByCommand: splitByCommand
  });

  Chartist.Svg.Path.elementDescriptions = elementDescriptions;
  Chartist.Svg.Path.join = join;
})(window, document, Chartist);
; /* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  var axisUnits = {
    x: {
      pos: 'x',
      len: 'width',
      dir: 'horizontal',
      rectStart: 'x1',
      rectEnd: 'x2',
      rectOffset: 'y2'
    },
    y: {
      pos: 'y',
      len: 'height',
      dir: 'vertical',
      rectStart: 'y2',
      rectEnd: 'y1',
      rectOffset: 'x1'
    }
  };

  function Axis(units, chartRect, ticks, options) {
    this.units = units;
    this.counterUnits = units === axisUnits.x ? axisUnits.y : axisUnits.x;
    this.chartRect = chartRect;
    this.axisLength = chartRect[units.rectEnd] - chartRect[units.rectStart];
    this.gridOffset = chartRect[units.rectOffset];
    this.ticks = ticks;
    this.options = options;
  }

  function createGridAndLabels(gridGroup, labelGroup, useForeignObject, chartOptions, eventEmitter) {
    var axisOptions = chartOptions['axis' + this.units.pos.toUpperCase()];
    var projectedValues = this.ticks.map(this.projectValue.bind(this));
    var labelValues = this.ticks.map(axisOptions.labelInterpolationFnc);

    projectedValues.forEach(function (projectedValue, index) {
      var labelOffset = {
        x: 0,
        y: 0
      };

      // TODO: Find better solution for solving this problem
      // Calculate how much space we have available for the label
      var labelLength;
      if (projectedValues[index + 1]) {
        // If we still have one label ahead, we can calculate the distance to the next tick / label
        labelLength = projectedValues[index + 1] - projectedValue;
      } else {
        // If we don't have a label ahead and we have only two labels in total, we just take the remaining distance to
        // on the whole axis length. We limit that to a minimum of 30 pixel, so that labels close to the border will
        // still be visible inside of the chart padding.
        labelLength = Math.max(this.axisLength - projectedValue, 30);
      }

      // Skip grid lines and labels where interpolated label values are falsey (execpt for 0)
      if (Chartist.isFalseyButZero(labelValues[index]) && labelValues[index] !== '') {
        return;
      }

      // Transform to global coordinates using the chartRect
      // We also need to set the label offset for the createLabel function
      if (this.units.pos === 'x') {
        projectedValue = this.chartRect.x1 + projectedValue;
        labelOffset.x = chartOptions.axisX.labelOffset.x;

        // If the labels should be positioned in start position (top side for vertical axis) we need to set a
        // different offset as for positioned with end (bottom)
        if (chartOptions.axisX.position === 'start') {
          labelOffset.y = this.chartRect.padding.top + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
        } else {
          labelOffset.y = this.chartRect.y1 + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
        }
      } else {
        projectedValue = this.chartRect.y1 - projectedValue;
        labelOffset.y = chartOptions.axisY.labelOffset.y - (useForeignObject ? labelLength : 0);

        // If the labels should be positioned in start position (left side for horizontal axis) we need to set a
        // different offset as for positioned with end (right side)
        if (chartOptions.axisY.position === 'start') {
          labelOffset.x = useForeignObject ? this.chartRect.padding.left + chartOptions.axisY.labelOffset.x : this.chartRect.x1 - 10;
        } else {
          labelOffset.x = this.chartRect.x2 + chartOptions.axisY.labelOffset.x + 10;
        }
      }

      if (axisOptions.showGrid) {
        Chartist.createGrid(projectedValue, index, this, this.gridOffset, this.chartRect[this.counterUnits.len](), gridGroup, [chartOptions.classNames.grid, chartOptions.classNames[this.units.dir]], eventEmitter);
      }

      if (axisOptions.showLabel) {
        Chartist.createLabel(projectedValue, labelLength, index, labelValues, this, axisOptions.offset, labelOffset, labelGroup, [chartOptions.classNames.label, chartOptions.classNames[this.units.dir], axisOptions.position === 'start' ? chartOptions.classNames[axisOptions.position] : chartOptions.classNames['end']], useForeignObject, eventEmitter);
      }
    }.bind(this));
  }

  Chartist.Axis = Chartist.Class.extend({
    constructor: Axis,
    createGridAndLabels: createGridAndLabels,
    projectValue: function projectValue(value, index, data) {
      throw new Error('Base axis can\'t be instantiated!');
    }
  });

  Chartist.Axis.units = axisUnits;
})(window, document, Chartist);
; /**
  * The auto scale axis uses standard linear scale projection of values along an axis. It uses order of magnitude to find a scale automatically and evaluates the available space in order to find the perfect amount of ticks for your chart.
  * **Options**
  * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
  * ```javascript
  * var options = {
  *   // If high is specified then the axis will display values explicitly up to this value and the computed maximum from the data is ignored
  *   high: 100,
  *   // If low is specified then the axis will display values explicitly down to this value and the computed minimum from the data is ignored
  *   low: 0,
  *   // This option will be used when finding the right scale division settings. The amount of ticks on the scale will be determined so that as many ticks as possible will be displayed, while not violating this minimum required space (in pixel).
  *   scaleMinSpace: 20,
  *   // Can be set to true or false. If set to true, the scale will be generated with whole numbers only.
  *   onlyInteger: true,
  *   // The reference value can be used to make sure that this value will always be on the chart. This is especially useful on bipolar charts where the bipolar center always needs to be part of the chart.
  *   referenceValue: 5
  * };
  * ```
  *
  * @module Chartist.AutoScaleAxis
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  function AutoScaleAxis(axisUnit, data, chartRect, options) {
    // Usually we calculate highLow based on the data but this can be overriden by a highLow object in the options
    var highLow = options.highLow || Chartist.getHighLow(data, options, axisUnit.pos);
    this.bounds = Chartist.getBounds(chartRect[axisUnit.rectEnd] - chartRect[axisUnit.rectStart], highLow, options.scaleMinSpace || 20, options.onlyInteger);
    this.range = {
      min: this.bounds.min,
      max: this.bounds.max
    };

    Chartist.AutoScaleAxis.super.constructor.call(this, axisUnit, chartRect, this.bounds.values, options);
  }

  function projectValue(value) {
    return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.bounds.min) / this.bounds.range;
  }

  Chartist.AutoScaleAxis = Chartist.Axis.extend({
    constructor: AutoScaleAxis,
    projectValue: projectValue
  });
})(window, document, Chartist);
; /**
  * The fixed scale axis uses standard linear projection of values along an axis. It makes use of a divisor option to divide the range provided from the minimum and maximum value or the options high and low that will override the computed minimum and maximum.
  * **Options**
  * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
  * ```javascript
  * var options = {
  *   // If high is specified then the axis will display values explicitly up to this value and the computed maximum from the data is ignored
  *   high: 100,
  *   // If low is specified then the axis will display values explicitly down to this value and the computed minimum from the data is ignored
  *   low: 0,
  *   // If specified then the value range determined from minimum to maximum (or low and high) will be divided by this number and ticks will be generated at those division points. The default divisor is 1.
  *   divisor: 4,
  *   // If ticks is explicitly set, then the axis will not compute the ticks with the divisor, but directly use the data in ticks to determine at what points on the axis a tick need to be generated.
  *   ticks: [1, 10, 20, 30]
  * };
  * ```
  *
  * @module Chartist.FixedScaleAxis
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  function FixedScaleAxis(axisUnit, data, chartRect, options) {
    var highLow = options.highLow || Chartist.getHighLow(data, options, axisUnit.pos);
    this.divisor = options.divisor || 1;
    this.ticks = options.ticks || Chartist.times(this.divisor).map(function (value, index) {
      return highLow.low + (highLow.high - highLow.low) / this.divisor * index;
    }.bind(this));
    this.ticks.sort(function (a, b) {
      return a - b;
    });
    this.range = {
      min: highLow.low,
      max: highLow.high
    };

    Chartist.FixedScaleAxis.super.constructor.call(this, axisUnit, chartRect, this.ticks, options);

    this.stepLength = this.axisLength / this.divisor;
  }

  function projectValue(value) {
    return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.range.min) / (this.range.max - this.range.min);
  }

  Chartist.FixedScaleAxis = Chartist.Axis.extend({
    constructor: FixedScaleAxis,
    projectValue: projectValue
  });
})(window, document, Chartist);
; /**
  * The step axis for step based charts like bar chart or step based line charts. It uses a fixed amount of ticks that will be equally distributed across the whole axis length. The projection is done using the index of the data value rather than the value itself and therefore it's only useful for distribution purpose.
  * **Options**
  * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
  * ```javascript
  * var options = {
  *   // Ticks to be used to distribute across the axis length. As this axis type relies on the index of the value rather than the value, arbitrary data that can be converted to a string can be used as ticks.
  *   ticks: ['One', 'Two', 'Three'],
  *   // If set to true the full width will be used to distribute the values where the last value will be at the maximum of the axis length. If false the spaces between the ticks will be evenly distributed instead.
  *   stretch: true
  * };
  * ```
  *
  * @module Chartist.StepAxis
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  function StepAxis(axisUnit, data, chartRect, options) {
    Chartist.StepAxis.super.constructor.call(this, axisUnit, chartRect, options.ticks, options);

    var calc = Math.max(1, options.ticks.length - (options.stretch ? 1 : 0));
    this.stepLength = this.axisLength / calc;
  }

  function projectValue(value, index) {
    return this.stepLength * index;
  }

  Chartist.StepAxis = Chartist.Axis.extend({
    constructor: StepAxis,
    projectValue: projectValue
  });
})(window, document, Chartist);
; /**
  * The Chartist line chart can be used to draw Line or Scatter charts. If used in the browser you can access the global `Chartist` namespace where you find the `Line` function as a main entry point.
  *
  * For examples on how to use the line chart please check the examples of the `Chartist.Line` method.
  *
  * @module Chartist.Line
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  /**
   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Line
   */

  var defaultOptions = {
    // Options for X-Axis
    axisX: {
      // The offset of the labels to the chart area
      offset: 30,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'end',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // Set the axis type to be used to project values on this axis. If not defined, Chartist.StepAxis will be used for the X-Axis, where the ticks option will be set to the labels in the data and the stretch option will be set to the global fullWidth option. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
      type: undefined
    },
    // Options for Y-Axis
    axisY: {
      // The offset of the labels to the chart area
      offset: 40,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'start',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // Set the axis type to be used to project values on this axis. If not defined, Chartist.AutoScaleAxis will be used for the Y-Axis, where the high and low options will be set to the global high and low options. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
      type: undefined,
      // This value specifies the minimum height in pixel of the scale steps
      scaleMinSpace: 20,
      // Use only integer values (whole numbers) for the scale steps
      onlyInteger: false
    },
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // If the line should be drawn or not
    showLine: true,
    // If dots should be drawn or not
    showPoint: true,
    // If the line chart should draw an area
    showArea: false,
    // The base for the area chart that will be used to close the area shape (is normally 0)
    areaBase: 0,
    // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions available in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
    lineSmooth: true,
    // If the line chart should add a background fill to the .ct-grids group.
    showGridBackground: false,
    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
    low: undefined,
    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
    high: undefined,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: {
      top: 15,
      right: 15,
      bottom: 5,
      left: 10
    },
    // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full available width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
    fullWidth: false,
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // Override the class names that get used to generate the SVG structure of the chart
    classNames: {
      chart: 'ct-chart-line',
      label: 'ct-label',
      labelGroup: 'ct-labels',
      series: 'ct-series',
      line: 'ct-line',
      point: 'ct-point',
      area: 'ct-area',
      grid: 'ct-grid',
      gridGroup: 'ct-grids',
      gridBackground: 'ct-grid-background',
      vertical: 'ct-vertical',
      horizontal: 'ct-horizontal',
      start: 'ct-start',
      end: 'ct-end'
    }
  };

  /**
   * Creates a new chart
   *
   */
  function createChart(options) {
    var data = Chartist.normalizeData(this.data, options.reverseData, true);

    // Create new svg object
    this.svg = Chartist.createSvg(this.container, options.width, options.height, options.classNames.chart);
    // Create groups for labels, grid and series
    var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
    var seriesGroup = this.svg.elem('g');
    var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);

    var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
    var axisX, axisY;

    if (options.axisX.type === undefined) {
      axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data.normalized.series, chartRect, Chartist.extend({}, options.axisX, {
        ticks: data.normalized.labels,
        stretch: options.fullWidth
      }));
    } else {
      axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data.normalized.series, chartRect, options.axisX);
    }

    if (options.axisY.type === undefined) {
      axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data.normalized.series, chartRect, Chartist.extend({}, options.axisY, {
        high: Chartist.isNumeric(options.high) ? options.high : options.axisY.high,
        low: Chartist.isNumeric(options.low) ? options.low : options.axisY.low
      }));
    } else {
      axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data.normalized.series, chartRect, options.axisY);
    }

    axisX.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
    axisY.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);

    if (options.showGridBackground) {
      Chartist.createGridBackground(gridGroup, chartRect, options.classNames.gridBackground, this.eventEmitter);
    }

    // Draw the series
    data.raw.series.forEach(function (series, seriesIndex) {
      var seriesElement = seriesGroup.elem('g');

      // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
      seriesElement.attr({
        'ct:series-name': series.name,
        'ct:meta': Chartist.serialize(series.meta)
      });

      // Use series class from series data or if not set generate one
      seriesElement.addClass([options.classNames.series, series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex)].join(' '));

      var pathCoordinates = [],
          pathData = [];

      data.normalized.series[seriesIndex].forEach(function (value, valueIndex) {
        var p = {
          x: chartRect.x1 + axisX.projectValue(value, valueIndex, data.normalized.series[seriesIndex]),
          y: chartRect.y1 - axisY.projectValue(value, valueIndex, data.normalized.series[seriesIndex])
        };
        pathCoordinates.push(p.x, p.y);
        pathData.push({
          value: value,
          valueIndex: valueIndex,
          meta: Chartist.getMetaData(series, valueIndex)
        });
      }.bind(this));

      var seriesOptions = {
        lineSmooth: Chartist.getSeriesOption(series, options, 'lineSmooth'),
        showPoint: Chartist.getSeriesOption(series, options, 'showPoint'),
        showLine: Chartist.getSeriesOption(series, options, 'showLine'),
        showArea: Chartist.getSeriesOption(series, options, 'showArea'),
        areaBase: Chartist.getSeriesOption(series, options, 'areaBase')
      };

      var smoothing = typeof seriesOptions.lineSmooth === 'function' ? seriesOptions.lineSmooth : seriesOptions.lineSmooth ? Chartist.Interpolation.monotoneCubic() : Chartist.Interpolation.none();
      // Interpolating path where pathData will be used to annotate each path element so we can trace back the original
      // index, value and meta data
      var path = smoothing(pathCoordinates, pathData);

      // If we should show points we need to create them now to avoid secondary loop
      // Points are drawn from the pathElements returned by the interpolation function
      // Small offset for Firefox to render squares correctly
      if (seriesOptions.showPoint) {

        path.pathElements.forEach(function (pathElement) {
          var point = seriesElement.elem('line', {
            x1: pathElement.x,
            y1: pathElement.y,
            x2: pathElement.x + 0.01,
            y2: pathElement.y
          }, options.classNames.point).attr({
            'ct:value': [pathElement.data.value.x, pathElement.data.value.y].filter(Chartist.isNumeric).join(','),
            'ct:meta': Chartist.serialize(pathElement.data.meta)
          });

          this.eventEmitter.emit('draw', {
            type: 'point',
            value: pathElement.data.value,
            index: pathElement.data.valueIndex,
            meta: pathElement.data.meta,
            series: series,
            seriesIndex: seriesIndex,
            axisX: axisX,
            axisY: axisY,
            group: seriesElement,
            element: point,
            x: pathElement.x,
            y: pathElement.y
          });
        }.bind(this));
      }

      if (seriesOptions.showLine) {
        var line = seriesElement.elem('path', {
          d: path.stringify()
        }, options.classNames.line, true);

        this.eventEmitter.emit('draw', {
          type: 'line',
          values: data.normalized.series[seriesIndex],
          path: path.clone(),
          chartRect: chartRect,
          index: seriesIndex,
          series: series,
          seriesIndex: seriesIndex,
          seriesMeta: series.meta,
          axisX: axisX,
          axisY: axisY,
          group: seriesElement,
          element: line
        });
      }

      // Area currently only works with axes that support a range!
      if (seriesOptions.showArea && axisY.range) {
        // If areaBase is outside the chart area (< min or > max) we need to set it respectively so that
        // the area is not drawn outside the chart area.
        var areaBase = Math.max(Math.min(seriesOptions.areaBase, axisY.range.max), axisY.range.min);

        // We project the areaBase value into screen coordinates
        var areaBaseProjected = chartRect.y1 - axisY.projectValue(areaBase);

        // In order to form the area we'll first split the path by move commands so we can chunk it up into segments
        path.splitByCommand('M').filter(function onlySolidSegments(pathSegment) {
          // We filter only "solid" segments that contain more than one point. Otherwise there's no need for an area
          return pathSegment.pathElements.length > 1;
        }).map(function convertToArea(solidPathSegments) {
          // Receiving the filtered solid path segments we can now convert those segments into fill areas
          var firstElement = solidPathSegments.pathElements[0];
          var lastElement = solidPathSegments.pathElements[solidPathSegments.pathElements.length - 1];

          // Cloning the solid path segment with closing option and removing the first move command from the clone
          // We then insert a new move that should start at the area base and draw a straight line up or down
          // at the end of the path we add an additional straight line to the projected area base value
          // As the closing option is set our path will be automatically closed
          return solidPathSegments.clone(true).position(0).remove(1).move(firstElement.x, areaBaseProjected).line(firstElement.x, firstElement.y).position(solidPathSegments.pathElements.length + 1).line(lastElement.x, areaBaseProjected);
        }).forEach(function createArea(areaPath) {
          // For each of our newly created area paths, we'll now create path elements by stringifying our path objects
          // and adding the created DOM elements to the correct series group
          var area = seriesElement.elem('path', {
            d: areaPath.stringify()
          }, options.classNames.area, true);

          // Emit an event for each area that was drawn
          this.eventEmitter.emit('draw', {
            type: 'area',
            values: data.normalized.series[seriesIndex],
            path: areaPath.clone(),
            series: series,
            seriesIndex: seriesIndex,
            axisX: axisX,
            axisY: axisY,
            chartRect: chartRect,
            index: seriesIndex,
            group: seriesElement,
            element: area
          });
        }.bind(this));
      }
    }.bind(this));

    this.eventEmitter.emit('created', {
      bounds: axisY.bounds,
      chartRect: chartRect,
      axisX: axisX,
      axisY: axisY,
      svg: this.svg,
      options: options
    });
  }

  /**
   * This method creates a new line chart.
   *
   * @memberof Chartist.Line
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object that needs to consist of a labels and a series array
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object which exposes the API for the created chart
   *
   * @example
   * // Create a simple line chart
   * var data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // As options we currently only set a static size of 300x200 px
   * var options = {
   *   width: '300px',
   *   height: '200px'
   * };
   *
   * // In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
   * new Chartist.Line('.ct-chart', data, options);
   *
   * @example
   * // Use specific interpolation function with configuration from the Chartist.Interpolation module
   *
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [
   *     [1, 1, 8, 1, 7]
   *   ]
   * }, {
   *   lineSmooth: Chartist.Interpolation.cardinal({
   *     tension: 0.2
   *   })
   * });
   *
   * @example
   * // Create a line chart with responsive options
   *
   * var data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In addition to the regular options we specify responsive option overrides that will override the default configutation based on the matching media queries.
   * var responsiveOptions = [
   *   ['screen and (min-width: 641px) and (max-width: 1024px)', {
   *     showPoint: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return Mon, Tue, Wed etc. on medium screens
   *         return value.slice(0, 3);
   *       }
   *     }
   *   }],
   *   ['screen and (max-width: 640px)', {
   *     showLine: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return M, T, W etc. on small screens
   *         return value[0];
   *       }
   *     }
   *   }]
   * ];
   *
   * new Chartist.Line('.ct-chart', data, null, responsiveOptions);
   *
   */
  function Line(query, data, options, responsiveOptions) {
    Chartist.Line.super.constructor.call(this, query, data, defaultOptions, Chartist.extend({}, defaultOptions, options), responsiveOptions);
  }

  // Creating line chart type in Chartist namespace
  Chartist.Line = Chartist.Base.extend({
    constructor: Line,
    createChart: createChart
  });
})(window, document, Chartist);
; /**
  * The bar chart module of Chartist that can be used to draw unipolar or bipolar bar and grouped bar charts.
  *
  * @module Chartist.Bar
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  /**
   * Default options in bar charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Bar
   */

  var defaultOptions = {
    // Options for X-Axis
    axisX: {
      // The offset of the chart drawing area to the border of the container
      offset: 30,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'end',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // This value specifies the minimum width in pixel of the scale steps
      scaleMinSpace: 30,
      // Use only integer values (whole numbers) for the scale steps
      onlyInteger: false
    },
    // Options for Y-Axis
    axisY: {
      // The offset of the chart drawing area to the border of the container
      offset: 40,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'start',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // This value specifies the minimum height in pixel of the scale steps
      scaleMinSpace: 20,
      // Use only integer values (whole numbers) for the scale steps
      onlyInteger: false
    },
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
    high: undefined,
    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
    low: undefined,
    // Unless low/high are explicitly set, bar chart will be centered at zero by default. Set referenceValue to null to auto scale.
    referenceValue: 0,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: {
      top: 15,
      right: 15,
      bottom: 5,
      left: 10
    },
    // Specify the distance in pixel of bars in a group
    seriesBarDistance: 15,
    // If set to true this property will cause the series bars to be stacked. Check the `stackMode` option for further stacking options.
    stackBars: false,
    // If set to 'overlap' this property will force the stacked bars to draw from the zero line.
    // If set to 'accumulate' this property will form a total for each series point. This will also influence the y-axis and the overall bounds of the chart. In stacked mode the seriesBarDistance property will have no effect.
    stackMode: 'accumulate',
    // Inverts the axes of the bar chart in order to draw a horizontal bar chart. Be aware that you also need to invert your axis settings as the Y Axis will now display the labels and the X Axis the values.
    horizontalBars: false,
    // If set to true then each bar will represent a series and the data array is expected to be a one dimensional array of data values rather than a series array of series. This is useful if the bar chart should represent a profile rather than some data over time.
    distributeSeries: false,
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // If the bar chart should add a background fill to the .ct-grids group.
    showGridBackground: false,
    // Override the class names that get used to generate the SVG structure of the chart
    classNames: {
      chart: 'ct-chart-bar',
      horizontalBars: 'ct-horizontal-bars',
      label: 'ct-label',
      labelGroup: 'ct-labels',
      series: 'ct-series',
      bar: 'ct-bar',
      grid: 'ct-grid',
      gridGroup: 'ct-grids',
      gridBackground: 'ct-grid-background',
      vertical: 'ct-vertical',
      horizontal: 'ct-horizontal',
      start: 'ct-start',
      end: 'ct-end'
    }
  };

  /**
   * Creates a new chart
   *
   */
  function createChart(options) {
    var data;
    var highLow;

    if (options.distributeSeries) {
      data = Chartist.normalizeData(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y');
      data.normalized.series = data.normalized.series.map(function (value) {
        return [value];
      });
    } else {
      data = Chartist.normalizeData(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y');
    }

    // Create new svg element
    this.svg = Chartist.createSvg(this.container, options.width, options.height, options.classNames.chart + (options.horizontalBars ? ' ' + options.classNames.horizontalBars : ''));

    // Drawing groups in correct order
    var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
    var seriesGroup = this.svg.elem('g');
    var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);

    if (options.stackBars && data.normalized.series.length !== 0) {

      // If stacked bars we need to calculate the high low from stacked values from each series
      var serialSums = Chartist.serialMap(data.normalized.series, function serialSums() {
        return Array.prototype.slice.call(arguments).map(function (value) {
          return value;
        }).reduce(function (prev, curr) {
          return {
            x: prev.x + (curr && curr.x) || 0,
            y: prev.y + (curr && curr.y) || 0
          };
        }, { x: 0, y: 0 });
      });

      highLow = Chartist.getHighLow([serialSums], options, options.horizontalBars ? 'x' : 'y');
    } else {

      highLow = Chartist.getHighLow(data.normalized.series, options, options.horizontalBars ? 'x' : 'y');
    }

    // Overrides of high / low from settings
    highLow.high = +options.high || (options.high === 0 ? 0 : highLow.high);
    highLow.low = +options.low || (options.low === 0 ? 0 : highLow.low);

    var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);

    var valueAxis, labelAxisTicks, labelAxis, axisX, axisY;

    // We need to set step count based on some options combinations
    if (options.distributeSeries && options.stackBars) {
      // If distributed series are enabled and bars need to be stacked, we'll only have one bar and therefore should
      // use only the first label for the step axis
      labelAxisTicks = data.normalized.labels.slice(0, 1);
    } else {
      // If distributed series are enabled but stacked bars aren't, we should use the series labels
      // If we are drawing a regular bar chart with two dimensional series data, we just use the labels array
      // as the bars are normalized
      labelAxisTicks = data.normalized.labels;
    }

    // Set labelAxis and valueAxis based on the horizontalBars setting. This setting will flip the axes if necessary.
    if (options.horizontalBars) {
      if (options.axisX.type === undefined) {
        valueAxis = axisX = new Chartist.AutoScaleAxis(Chartist.Axis.units.x, data.normalized.series, chartRect, Chartist.extend({}, options.axisX, {
          highLow: highLow,
          referenceValue: 0
        }));
      } else {
        valueAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data.normalized.series, chartRect, Chartist.extend({}, options.axisX, {
          highLow: highLow,
          referenceValue: 0
        }));
      }

      if (options.axisY.type === undefined) {
        labelAxis = axisY = new Chartist.StepAxis(Chartist.Axis.units.y, data.normalized.series, chartRect, {
          ticks: labelAxisTicks
        });
      } else {
        labelAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data.normalized.series, chartRect, options.axisY);
      }
    } else {
      if (options.axisX.type === undefined) {
        labelAxis = axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data.normalized.series, chartRect, {
          ticks: labelAxisTicks
        });
      } else {
        labelAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data.normalized.series, chartRect, options.axisX);
      }

      if (options.axisY.type === undefined) {
        valueAxis = axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data.normalized.series, chartRect, Chartist.extend({}, options.axisY, {
          highLow: highLow,
          referenceValue: 0
        }));
      } else {
        valueAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data.normalized.series, chartRect, Chartist.extend({}, options.axisY, {
          highLow: highLow,
          referenceValue: 0
        }));
      }
    }

    // Projected 0 point
    var zeroPoint = options.horizontalBars ? chartRect.x1 + valueAxis.projectValue(0) : chartRect.y1 - valueAxis.projectValue(0);
    // Used to track the screen coordinates of stacked bars
    var stackedBarValues = [];

    labelAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
    valueAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);

    if (options.showGridBackground) {
      Chartist.createGridBackground(gridGroup, chartRect, options.classNames.gridBackground, this.eventEmitter);
    }

    // Draw the series
    data.raw.series.forEach(function (series, seriesIndex) {
      // Calculating bi-polar value of index for seriesOffset. For i = 0..4 biPol will be -1.5, -0.5, 0.5, 1.5 etc.
      var biPol = seriesIndex - (data.raw.series.length - 1) / 2;
      // Half of the period width between vertical grid lines used to position bars
      var periodHalfLength;
      // Current series SVG element
      var seriesElement;

      // We need to set periodHalfLength based on some options combinations
      if (options.distributeSeries && !options.stackBars) {
        // If distributed series are enabled but stacked bars aren't, we need to use the length of the normaizedData array
        // which is the series count and divide by 2
        periodHalfLength = labelAxis.axisLength / data.normalized.series.length / 2;
      } else if (options.distributeSeries && options.stackBars) {
        // If distributed series and stacked bars are enabled we'll only get one bar so we should just divide the axis
        // length by 2
        periodHalfLength = labelAxis.axisLength / 2;
      } else {
        // On regular bar charts we should just use the series length
        periodHalfLength = labelAxis.axisLength / data.normalized.series[seriesIndex].length / 2;
      }

      // Adding the series group to the series element
      seriesElement = seriesGroup.elem('g');

      // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
      seriesElement.attr({
        'ct:series-name': series.name,
        'ct:meta': Chartist.serialize(series.meta)
      });

      // Use series class from series data or if not set generate one
      seriesElement.addClass([options.classNames.series, series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex)].join(' '));

      data.normalized.series[seriesIndex].forEach(function (value, valueIndex) {
        var projected, bar, previousStack, labelAxisValueIndex;

        // We need to set labelAxisValueIndex based on some options combinations
        if (options.distributeSeries && !options.stackBars) {
          // If distributed series are enabled but stacked bars aren't, we can use the seriesIndex for later projection
          // on the step axis for label positioning
          labelAxisValueIndex = seriesIndex;
        } else if (options.distributeSeries && options.stackBars) {
          // If distributed series and stacked bars are enabled, we will only get one bar and therefore always use
          // 0 for projection on the label step axis
          labelAxisValueIndex = 0;
        } else {
          // On regular bar charts we just use the value index to project on the label step axis
          labelAxisValueIndex = valueIndex;
        }

        // We need to transform coordinates differently based on the chart layout
        if (options.horizontalBars) {
          projected = {
            x: chartRect.x1 + valueAxis.projectValue(value && value.x ? value.x : 0, valueIndex, data.normalized.series[seriesIndex]),
            y: chartRect.y1 - labelAxis.projectValue(value && value.y ? value.y : 0, labelAxisValueIndex, data.normalized.series[seriesIndex])
          };
        } else {
          projected = {
            x: chartRect.x1 + labelAxis.projectValue(value && value.x ? value.x : 0, labelAxisValueIndex, data.normalized.series[seriesIndex]),
            y: chartRect.y1 - valueAxis.projectValue(value && value.y ? value.y : 0, valueIndex, data.normalized.series[seriesIndex])
          };
        }

        // If the label axis is a step based axis we will offset the bar into the middle of between two steps using
        // the periodHalfLength value. Also we do arrange the different series so that they align up to each other using
        // the seriesBarDistance. If we don't have a step axis, the bar positions can be chosen freely so we should not
        // add any automated positioning.
        if (labelAxis instanceof Chartist.StepAxis) {
          // Offset to center bar between grid lines, but only if the step axis is not stretched
          if (!labelAxis.options.stretch) {
            projected[labelAxis.units.pos] += periodHalfLength * (options.horizontalBars ? -1 : 1);
          }
          // Using bi-polar offset for multiple series if no stacked bars or series distribution is used
          projected[labelAxis.units.pos] += options.stackBars || options.distributeSeries ? 0 : biPol * options.seriesBarDistance * (options.horizontalBars ? -1 : 1);
        }

        // Enter value in stacked bar values used to remember previous screen value for stacking up bars
        previousStack = stackedBarValues[valueIndex] || zeroPoint;
        stackedBarValues[valueIndex] = previousStack - (zeroPoint - projected[labelAxis.counterUnits.pos]);

        // Skip if value is undefined
        if (value === undefined) {
          return;
        }

        var positions = {};
        positions[labelAxis.units.pos + '1'] = projected[labelAxis.units.pos];
        positions[labelAxis.units.pos + '2'] = projected[labelAxis.units.pos];

        if (options.stackBars && (options.stackMode === 'accumulate' || !options.stackMode)) {
          // Stack mode: accumulate (default)
          // If bars are stacked we use the stackedBarValues reference and otherwise base all bars off the zero line
          // We want backwards compatibility, so the expected fallback without the 'stackMode' option
          // to be the original behaviour (accumulate)
          positions[labelAxis.counterUnits.pos + '1'] = previousStack;
          positions[labelAxis.counterUnits.pos + '2'] = stackedBarValues[valueIndex];
        } else {
          // Draw from the zero line normally
          // This is also the same code for Stack mode: overlap
          positions[labelAxis.counterUnits.pos + '1'] = zeroPoint;
          positions[labelAxis.counterUnits.pos + '2'] = projected[labelAxis.counterUnits.pos];
        }

        // Limit x and y so that they are within the chart rect
        positions.x1 = Math.min(Math.max(positions.x1, chartRect.x1), chartRect.x2);
        positions.x2 = Math.min(Math.max(positions.x2, chartRect.x1), chartRect.x2);
        positions.y1 = Math.min(Math.max(positions.y1, chartRect.y2), chartRect.y1);
        positions.y2 = Math.min(Math.max(positions.y2, chartRect.y2), chartRect.y1);

        var metaData = Chartist.getMetaData(series, valueIndex);

        // Create bar element
        bar = seriesElement.elem('line', positions, options.classNames.bar).attr({
          'ct:value': [value.x, value.y].filter(Chartist.isNumeric).join(','),
          'ct:meta': Chartist.serialize(metaData)
        });

        this.eventEmitter.emit('draw', Chartist.extend({
          type: 'bar',
          value: value,
          index: valueIndex,
          meta: metaData,
          series: series,
          seriesIndex: seriesIndex,
          axisX: axisX,
          axisY: axisY,
          chartRect: chartRect,
          group: seriesElement,
          element: bar
        }, positions));
      }.bind(this));
    }.bind(this));

    this.eventEmitter.emit('created', {
      bounds: valueAxis.bounds,
      chartRect: chartRect,
      axisX: axisX,
      axisY: axisY,
      svg: this.svg,
      options: options
    });
  }

  /**
   * This method creates a new bar chart and returns API object that you can use for later changes.
   *
   * @memberof Chartist.Bar
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object that needs to consist of a labels and a series array
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object which exposes the API for the created chart
   *
   * @example
   * // Create a simple bar chart
   * var data = {
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In the global name space Chartist we call the Bar function to initialize a bar chart. As a first parameter we pass in a selector where we would like to get our chart created and as a second parameter we pass our data object.
   * new Chartist.Bar('.ct-chart', data);
   *
   * @example
   * // This example creates a bipolar grouped bar chart where the boundaries are limitted to -10 and 10
   * new Chartist.Bar('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5, 6, 7],
   *   series: [
   *     [1, 3, 2, -5, -3, 1, -6],
   *     [-5, -2, -4, -1, 2, -3, 1]
   *   ]
   * }, {
   *   seriesBarDistance: 12,
   *   low: -10,
   *   high: 10
   * });
   *
   */
  function Bar(query, data, options, responsiveOptions) {
    Chartist.Bar.super.constructor.call(this, query, data, defaultOptions, Chartist.extend({}, defaultOptions, options), responsiveOptions);
  }

  // Creating bar chart type in Chartist namespace
  Chartist.Bar = Chartist.Base.extend({
    constructor: Bar,
    createChart: createChart
  });
})(window, document, Chartist);
; /**
  * The pie chart module of Chartist that can be used to draw pie, donut or gauge charts
  *
  * @module Chartist.Pie
  */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  /**
   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Pie
   */

  var defaultOptions = {
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: 5,
    // Override the class names that are used to generate the SVG structure of the chart
    classNames: {
      chartPie: 'ct-chart-pie',
      chartDonut: 'ct-chart-donut',
      series: 'ct-series',
      slicePie: 'ct-slice-pie',
      sliceDonut: 'ct-slice-donut',
      sliceDonutSolid: 'ct-slice-donut-solid',
      label: 'ct-label'
    },
    // The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
    startAngle: 0,
    // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
    total: undefined,
    // If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
    donut: false,
    // If specified the donut segments will be drawn as shapes instead of strokes.
    donutSolid: false,
    // Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
    // This option can be set as number or string to specify a relative width (i.e. 100 or '30%').
    donutWidth: 60,
    // If a label should be shown or not
    showLabel: true,
    // Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
    labelOffset: 0,
    // This option can be set to 'inside', 'outside' or 'center'. Positioned with 'inside' the labels will be placed on half the distance of the radius to the border of the Pie by respecting the 'labelOffset'. The 'outside' option will place the labels at the border of the pie and 'center' will place the labels in the absolute center point of the chart. The 'center' option only makes sense in conjunction with the 'labelOffset' option.
    labelPosition: 'inside',
    // An interpolation function for the label value
    labelInterpolationFnc: Chartist.noop,
    // Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
    labelDirection: 'neutral',
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // If true empty values will be ignored to avoid drawing unncessary slices and labels
    ignoreEmptyValues: false
  };

  /**
   * Determines SVG anchor position based on direction and center parameter
   *
   * @param center
   * @param label
   * @param direction
   * @return {string}
   */
  function determineAnchorPosition(center, label, direction) {
    var toTheRight = label.x > center.x;

    if (toTheRight && direction === 'explode' || !toTheRight && direction === 'implode') {
      return 'start';
    } else if (toTheRight && direction === 'implode' || !toTheRight && direction === 'explode') {
      return 'end';
    } else {
      return 'middle';
    }
  }

  /**
   * Creates the pie chart
   *
   * @param options
   */
  function createChart(options) {
    var data = Chartist.normalizeData(this.data);
    var seriesGroups = [],
        labelsGroup,
        chartRect,
        radius,
        labelRadius,
        totalDataSum,
        startAngle = options.startAngle;

    // Create SVG.js draw
    this.svg = Chartist.createSvg(this.container, options.width, options.height, options.donut ? options.classNames.chartDonut : options.classNames.chartPie);
    // Calculate charting rect
    chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
    // Get biggest circle radius possible within chartRect
    radius = Math.min(chartRect.width() / 2, chartRect.height() / 2);
    // Calculate total of all series to get reference value or use total reference from optional options
    totalDataSum = options.total || data.normalized.series.reduce(function (previousValue, currentValue) {
      return previousValue + currentValue;
    }, 0);

    var donutWidth = Chartist.quantity(options.donutWidth);
    if (donutWidth.unit === '%') {
      donutWidth.value *= radius / 100;
    }

    // If this is a donut chart we need to adjust our radius to enable strokes to be drawn inside
    // Unfortunately this is not possible with the current SVG Spec
    // See this proposal for more details: http://lists.w3.org/Archives/Public/www-svg/2003Oct/0000.html
    radius -= options.donut && !options.donutSolid ? donutWidth.value / 2 : 0;

    // If labelPosition is set to `outside` or a donut chart is drawn then the label position is at the radius,
    // if regular pie chart it's half of the radius
    if (options.labelPosition === 'outside' || options.donut && !options.donutSolid) {
      labelRadius = radius;
    } else if (options.labelPosition === 'center') {
      // If labelPosition is center we start with 0 and will later wait for the labelOffset
      labelRadius = 0;
    } else if (options.donutSolid) {
      labelRadius = radius - donutWidth.value / 2;
    } else {
      // Default option is 'inside' where we use half the radius so the label will be placed in the center of the pie
      // slice
      labelRadius = radius / 2;
    }
    // Add the offset to the labelRadius where a negative offset means closed to the center of the chart
    labelRadius += options.labelOffset;

    // Calculate end angle based on total sum and current data value and offset with padding
    var center = {
      x: chartRect.x1 + chartRect.width() / 2,
      y: chartRect.y2 + chartRect.height() / 2
    };

    // Check if there is only one non-zero value in the series array.
    var hasSingleValInSeries = data.raw.series.filter(function (val) {
      return val.hasOwnProperty('value') ? val.value !== 0 : val !== 0;
    }).length === 1;

    // Creating the series groups
    data.raw.series.forEach(function (series, index) {
      seriesGroups[index] = this.svg.elem('g', null, null);
    }.bind(this));
    //if we need to show labels we create the label group now
    if (options.showLabel) {
      labelsGroup = this.svg.elem('g', null, null);
    }

    // Draw the series
    // initialize series groups
    data.raw.series.forEach(function (series, index) {
      // If current value is zero and we are ignoring empty values then skip to next value
      if (data.normalized.series[index] === 0 && options.ignoreEmptyValues) return;

      // If the series is an object and contains a name or meta data we add a custom attribute
      seriesGroups[index].attr({
        'ct:series-name': series.name
      });

      // Use series class from series data or if not set generate one
      seriesGroups[index].addClass([options.classNames.series, series.className || options.classNames.series + '-' + Chartist.alphaNumerate(index)].join(' '));

      // If the whole dataset is 0 endAngle should be zero. Can't divide by 0.
      var endAngle = totalDataSum > 0 ? startAngle + data.normalized.series[index] / totalDataSum * 360 : 0;

      // Use slight offset so there are no transparent hairline issues
      var overlappigStartAngle = Math.max(0, startAngle - (index === 0 || hasSingleValInSeries ? 0 : 0.2));

      // If we need to draw the arc for all 360 degrees we need to add a hack where we close the circle
      // with Z and use 359.99 degrees
      if (endAngle - overlappigStartAngle >= 359.99) {
        endAngle = overlappigStartAngle + 359.99;
      }

      var start = Chartist.polarToCartesian(center.x, center.y, radius, overlappigStartAngle),
          end = Chartist.polarToCartesian(center.x, center.y, radius, endAngle);

      var innerStart, innerEnd, donutSolidRadius;

      // Create a new path element for the pie chart. If this isn't a donut chart we should close the path for a correct stroke
      var path = new Chartist.Svg.Path(!options.donut || options.donutSolid).move(end.x, end.y).arc(radius, radius, 0, endAngle - startAngle > 180, 0, start.x, start.y);

      // If regular pie chart (no donut) we add a line to the center of the circle for completing the pie
      if (!options.donut) {
        path.line(center.x, center.y);
      } else if (options.donutSolid) {
        donutSolidRadius = radius - donutWidth.value;
        innerStart = Chartist.polarToCartesian(center.x, center.y, donutSolidRadius, startAngle - (index === 0 || hasSingleValInSeries ? 0 : 0.2));
        innerEnd = Chartist.polarToCartesian(center.x, center.y, donutSolidRadius, endAngle);
        path.line(innerStart.x, innerStart.y);
        path.arc(donutSolidRadius, donutSolidRadius, 0, endAngle - startAngle > 180, 1, innerEnd.x, innerEnd.y);
      }

      // Create the SVG path
      // If this is a donut chart we add the donut class, otherwise just a regular slice
      var pathClassName = options.classNames.slicePie;
      if (options.donut) {
        pathClassName = options.classNames.sliceDonut;
        if (options.donutSolid) {
          pathClassName = options.classNames.sliceDonutSolid;
        }
      }
      var pathElement = seriesGroups[index].elem('path', {
        d: path.stringify()
      }, pathClassName);

      // Adding the pie series value to the path
      pathElement.attr({
        'ct:value': data.normalized.series[index],
        'ct:meta': Chartist.serialize(series.meta)
      });

      // If this is a donut, we add the stroke-width as style attribute
      if (options.donut && !options.donutSolid) {
        pathElement._node.style.strokeWidth = donutWidth.value + 'px';
      }

      // Fire off draw event
      this.eventEmitter.emit('draw', {
        type: 'slice',
        value: data.normalized.series[index],
        totalDataSum: totalDataSum,
        index: index,
        meta: series.meta,
        series: series,
        group: seriesGroups[index],
        element: pathElement,
        path: path.clone(),
        center: center,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
      });

      // If we need to show labels we need to add the label for this slice now
      if (options.showLabel) {
        var labelPosition;
        if (data.raw.series.length === 1) {
          // If we have only 1 series, we can position the label in the center of the pie
          labelPosition = {
            x: center.x,
            y: center.y
          };
        } else {
          // Position at the labelRadius distance from center and between start and end angle
          labelPosition = Chartist.polarToCartesian(center.x, center.y, labelRadius, startAngle + (endAngle - startAngle) / 2);
        }

        var rawValue;
        if (data.normalized.labels && !Chartist.isFalseyButZero(data.normalized.labels[index])) {
          rawValue = data.normalized.labels[index];
        } else {
          rawValue = data.normalized.series[index];
        }

        var interpolatedValue = options.labelInterpolationFnc(rawValue, index);

        if (interpolatedValue || interpolatedValue === 0) {
          var labelElement = labelsGroup.elem('text', {
            dx: labelPosition.x,
            dy: labelPosition.y,
            'text-anchor': determineAnchorPosition(center, labelPosition, options.labelDirection)
          }, options.classNames.label).text('' + interpolatedValue);

          // Fire off draw event
          this.eventEmitter.emit('draw', {
            type: 'label',
            index: index,
            group: labelsGroup,
            element: labelElement,
            text: '' + interpolatedValue,
            x: labelPosition.x,
            y: labelPosition.y
          });
        }
      }

      // Set next startAngle to current endAngle.
      // (except for last slice)
      startAngle = endAngle;
    }.bind(this));

    this.eventEmitter.emit('created', {
      chartRect: chartRect,
      svg: this.svg,
      options: options
    });
  }

  /**
   * This method creates a new pie chart and returns an object that can be used to redraw the chart.
   *
   * @memberof Chartist.Pie
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object in the pie chart needs to have a series property with a one dimensional data array. The values will be normalized against each other and don't necessarily need to be in percentage. The series property can also be an array of value objects that contain a value property and a className property to override the CSS class name for the series group.
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object with a version and an update method to manually redraw the chart
   *
   * @example
   * // Simple pie chart example with four series
   * new Chartist.Pie('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * });
   *
   * @example
   * // Drawing a donut chart
   * new Chartist.Pie('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * }, {
   *   donut: true
   * });
   *
   * @example
   * // Using donut, startAngle and total to draw a gauge chart
   * new Chartist.Pie('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   donut: true,
   *   donutWidth: 20,
   *   startAngle: 270,
   *   total: 200
   * });
   *
   * @example
   * // Drawing a pie chart with padding and labels that are outside the pie
   * new Chartist.Pie('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   chartPadding: 30,
   *   labelOffset: 50,
   *   labelDirection: 'explode'
   * });
   *
   * @example
   * // Overriding the class names for individual series as well as a name and meta data.
   * // The name will be written as ct:series-name attribute and the meta data will be serialized and written
   * // to a ct:meta attribute.
   * new Chartist.Pie('.ct-chart', {
   *   series: [{
   *     value: 20,
   *     name: 'Series 1',
   *     className: 'my-custom-class-one',
   *     meta: 'Meta One'
   *   }, {
   *     value: 10,
   *     name: 'Series 2',
   *     className: 'my-custom-class-two',
   *     meta: 'Meta Two'
   *   }, {
   *     value: 70,
   *     name: 'Series 3',
   *     className: 'my-custom-class-three',
   *     meta: 'Meta Three'
   *   }]
   * });
   */
  function Pie(query, data, options, responsiveOptions) {
    Chartist.Pie.super.constructor.call(this, query, data, defaultOptions, Chartist.extend({}, defaultOptions, options), responsiveOptions);
  }

  // Creating pie chart type in Chartist namespace
  Chartist.Pie = Chartist.Base.extend({
    constructor: Pie,
    createChart: createChart,
    determineAnchorPosition: determineAnchorPosition
  });
})(window, document, Chartist);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Chartist, 'Chartist', '/opt/atlassian/pipelines/agent/build/client/app/components/Libs/chartist/chartist.js');
  leaveModule(module);
})();

;

/*** EXPORTS FROM exports-loader ***/
module.exports = Chartist;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/chart.png";

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/chart-blue.png";

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Merging_Map__ = __webpack_require__(558);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








function getDefaultCoords() {
    return {
        lat: 0,
        lng: 0
    };
}

function mapCoordsToArray(coords) {
    return coords.map(function (coord) {
        return [coord.lng, coord.lat];
    });
}

function ByCoordsPage(_ref) {
    var area = _ref.area,
        onChangeArea = _ref.onChangeArea;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        coords = _useState2[0],
        setCoords = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState4 = _slicedToArray(_useState3, 2),
        editCoordsMarker = _useState4[0],
        setEditCoordsMarker = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (area) {
            if (area.areaCoordinates && area.areaCoordinates.length) {
                var selectedAreaCoords = area.areaCoordinates.map(function (item) {
                    return {
                        lat: item[1],
                        lng: item[0]
                    };
                });
                setCoords(selectedAreaCoords);
            } else if (area.isNew || !area.areaCoordinatesPolygons || !area.areaCoordinatesPolygons.coordinates || !area.areaCoordinatesPolygons.coordinates.length) {
                setCoords([getDefaultCoords()]);
            }
        } else {
            setCoords([]);
        }
    }, [area]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (coords[0] && coords[coords.length - 1] && (coords[0].lat !== coords[coords.length - 1].lat || coords[0].lng !== coords[coords.length - 1].lng)) {
            var newCoords = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(coords);
            newCoords[coords.length] = newCoords[0];
            setCoords(newCoords);
        }
    }, [coords]);

    var changeCoords = function changeCoords(changes) {
        var newCoords = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(coords);

        changes.forEach(function (_ref2) {
            var index = _ref2.index,
                type = _ref2.type,
                value = _ref2.value;

            newCoords[index][type] = parseFloat(value);
        });

        setCoords(newCoords);
        var mappedCoords = mapCoordsToArray(newCoords);
        onChangeArea(_extends({}, area, {
            areaCoordinates: mappedCoords,
            areaCoordinatesPolygons: {
                type: 'MultiPolygon',
                coordinates: [[mappedCoords]]
            }
        }));
    };

    var changeCoordsList = function changeCoordsList(type, index) {
        var newCoords = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(coords);
        if (type === 'add') {
            newCoords.splice(index + 1, 0, getDefaultCoords());
            setCoords(newCoords);
        }

        if (type === 'rm') {
            if (coords.length === 1) {
                setCoords([getDefaultCoords()]);
            } else {
                newCoords.splice(index, 1);
                setCoords(newCoords);
            }
        }

        var mappedCoords = mapCoordsToArray(newCoords);
        onChangeArea(_extends({}, area, {
            areaCoordinates: mappedCoords,
            areaCoordinatesPolygons: {
                type: 'MultiPolygon',
                coordinates: [[mappedCoords]]
            }
        }));
    };

    var onCoordsMouseOver = function onCoordsMouseOver(index) {
        setEditCoordsMarker(index);
    };

    var onCoordsMouseOut = function onCoordsMouseOut() {
        setEditCoordsMarker(null);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'col-xs-4',
                style: { overflowY: 'auto', height: '74.5vh' }
            },
            coords.map(function (coord, _i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CoordsPair, {
                    key: 'coords_' + _i,
                    index: _i,
                    changeCoords: changeCoords,
                    changeCoordsList: changeCoordsList,
                    lat: coord.lat,
                    lng: coord.lng,
                    isLast: _i === coords.length - 1,
                    onMouseOver: onCoordsMouseOver,
                    onMouseOut: onCoordsMouseOut
                });
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-8' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Merging_Map__["a" /* default */], {
                coordinates: [],
                type: 'area',
                loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '450px' } }),
                mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                areaPolygon: coords,
                editCoordsMarker: editCoordsMarker
            })
        )
    );
}

function CoordsPair(_ref3) {
    var lat = _ref3.lat,
        lng = _ref3.lng,
        changeCoords = _ref3.changeCoords,
        changeCoordsList = _ref3.changeCoordsList,
        index = _ref3.index,
        isLast = _ref3.isLast,
        _onMouseOver = _ref3.onMouseOver,
        onMouseOut = _ref3.onMouseOut;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            className: 'row',
            onMouseOver: function onMouseOver() {
                return _onMouseOver(index);
            },
            onMouseOut: onMouseOut
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                onChange: function onChange(_e, value) {
                    return changeCoords([{ index: index, type: 'lat', value: value }]);
                },
                value: lat || '',
                hintText: 'Lat',
                type: 'number',
                fullWidth: true,
                disabled: index !== 0 && isLast,
                errorText: !lat && 'Enter latitude.',
                style: { fontSize: '13px' }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                onChange: function onChange(_e, value) {
                    return changeCoords([{ index: index, type: 'lng', value: value }]);
                },
                value: lng || '',
                hintText: 'Lng',
                type: 'number',
                fullWidth: true,
                disabled: index !== 0 && isLast,
                errorText: !lng && 'Enter longitude.',
                style: { fontSize: '13px' }
            })
        ),
        (index === 0 || !isLast) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-1' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add___default.a, { color: 'green', onClick: function onClick() {
                            return changeCoordsList('add', index);
                        } })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-1' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove___default.a, { color: 'red', onClick: function onClick() {
                            return changeCoordsList('rm', index);
                        } })
                )
            )
        )
    );
}

var _default = ByCoordsPage;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getDefaultCoords, 'getDefaultCoords', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/ByCoords/ByCoordsPage.jsx');
    reactHotLoader.register(mapCoordsToArray, 'mapCoordsToArray', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/ByCoords/ByCoordsPage.jsx');
    reactHotLoader.register(ByCoordsPage, 'ByCoordsPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/ByCoords/ByCoordsPage.jsx');
    reactHotLoader.register(CoordsPair, 'CoordsPair', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/ByCoords/ByCoordsPage.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/ByCoords/ByCoordsPage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sagas_regions_areas__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AreaToPortDialog__ = __webpack_require__(2322);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ManagementArea = function (_React$Component) {
    _inherits(ManagementArea, _React$Component);

    function ManagementArea(props) {
        var _this2 = this;

        _classCallCheck(this, ManagementArea);

        var _this = _possibleConstructorReturn(this, (ManagementArea.__proto__ || Object.getPrototypeOf(ManagementArea)).call(this, props));

        _this.handleChangeAreaToPort = function (e, value, key) {
            _this.setState({
                areaToPort: _extends({}, _this.state.areaToPort, _defineProperty({}, key, value)),
                areaToPortErrors: _extends({}, _this.state.areaToPortErrors, _defineProperty({}, key, ''))
            });
        };

        _this.isValidAreaToPort = function () {
            var _this$state = _this.state,
                areaToPort = _this$state.areaToPort,
                areaName = _this$state.areaName;

            var errors = {};

            if (!areaName) {
                errors.name = 'required';
            }

            if (!areaToPort.country) {
                errors.country = 'required';
            }

            if (!new RegExp(/^\-?\d+(\.\d+)?$/).test('' + areaToPort.coordinates[0])) {
                errors.coordinates = 'wrong format';
            }

            if (!areaToPort.coordinates[0]) {
                errors.coordinates = 'required';
            }

            if (!new RegExp(/^\-?\d+(\.\d+)?$/).test('' + areaToPort.coordinates[1])) {
                errors.coordinates = 'wrong format';
            }

            if (areaToPort.coordinates[0] && areaToPort.coordinates[1] && (areaToPort.coordinates[0] < -180 || areaToPort.coordinates[0] > 180 || areaToPort.coordinates[1] < -90 || areaToPort.coordinates[1] > 90)) {
                errors.coordinates = 'wrong format';
            }

            if (!areaToPort.coordinates[1]) {
                errors.coordinates = 'required';
            }

            // if (!areaToPort.unLoCode) {
            //   errors.unLoCode = 'required';
            // }

            if (Object.keys(errors).length) {
                _this.setState({ areaToPortErrors: errors });

                return false;
            }

            return true;
        };

        _this.transformAreaToPort = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _this$props, router, _this$props$area, _this$props$area$_id, id, _this$state2, areaToPort, areaName, response, errors;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$props = _this.props, router = _this$props.router, _this$props$area = _this$props.area;
                            _this$props$area = _this$props$area === undefined ? {} : _this$props$area;
                            _this$props$area$_id = _this$props$area._id, id = _this$props$area$_id === undefined ? '' : _this$props$area$_id;
                            _this$state2 = _this.state, areaToPort = _this$state2.areaToPort, areaName = _this$state2.areaName;

                            if (id) {
                                _context.next = 6;
                                break;
                            }

                            return _context.abrupt('return', false);

                        case 6:
                            if (_this.isValidAreaToPort()) {
                                _context.next = 8;
                                break;
                            }

                            return _context.abrupt('return', false);

                        case 8:
                            _context.next = 10;
                            return Object(__WEBPACK_IMPORTED_MODULE_6_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_7_sagas_regions_areas__["d" /* transformAreaToPort */], id, _extends({}, areaToPort, { name: areaName }));

                        case 10:
                            response = _context.sent;


                            if (response.status === 200) {
                                _this.toggleOpenDialog('openDialogTransformArea');
                                router.push('/regions/ports/' + id);
                            } else {
                                errors = {};


                                response.errors.forEach(function (er) {
                                    errors[er.field] = er.messages[0];
                                });

                                _this.setState({ areaToPortErrors: errors });
                            }

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.duplicateArea = function () {
            var _this$props2 = _this.props,
                area = _this$props2.area,
                createNewArea = _this$props2.createNewArea,
                onChangeArea = _this$props2.onChangeArea;

            var areaCopy = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(area);
            createNewArea();
            setTimeout(function () {
                onChangeArea(_extends({}, areaCopy, {
                    _id: undefined,
                    isNew: true,
                    name: areaCopy.name + '_duplicate'
                }));
            }, 0);
        };

        _this.state = {
            areaName: '',
            openDialog: false,
            openDialogTransformArea: false,
            areaToPort: {
                coordinates: [0, 0],
                country: '',
                unLoCode: ''
            },
            areaToPortErrors: {},
            setAreaAsDefault: false
        };

        _this.onChangeName = _this.onChangeName.bind(_this);
        _this.toggleOpenDialog = _this.toggleOpenDialog.bind(_this);
        _this.toggleAreaAsDefault = _this.toggleAreaAsDefault.bind(_this);
        return _this;
    }

    _createClass(ManagementArea, [{
        key: 'toggleOpenDialog',
        value: function toggleOpenDialog() {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'openDialog';

            this.setState(_defineProperty({}, key, !this.state[key]));
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.area) {
                if (!this.props.area) {
                    this.setState({
                        areaName: nextProps.area.name
                    });

                    return;
                }

                this.setState({
                    areaName: nextProps.area.name
                });
            }
        }
    }, {
        key: 'toggleAreaAsDefault',
        value: function toggleAreaAsDefault(value) {
            var _this3 = this;

            this.setState({
                setAreaAsDefault: value
            }, function () {
                var area = _this3.props.area;

                area.setAreaAsDefault = _this3.state.setAreaAsDefault;
                _this3.props.onChangeArea(area);
            });
        }
    }, {
        key: 'onChangeName',
        value: function onChangeName(e, value) {
            var _this4 = this;

            this.setState({
                areaName: value,
                areaToPortErrors: _extends({}, this.state.areaToPortErrors, {
                    name: ''
                })
            }, function () {
                var area = _this4.props.area;

                area.name = value;
                _this4.props.onChangeArea(area);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _state = this.state,
                areaName = _state.areaName,
                setAreaAsDefault = _state.setAreaAsDefault,
                areaToPort = _state.areaToPort,
                areaToPortErrors = _state.areaToPortErrors;
            var _props = this.props,
                area = _props.area,
                recalculateOnSave = _props.recalculateOnSave,
                recalculateMainPorts = _props.recalculateMainPorts,
                portFromAutoComplete = _props.portFromAutoComplete,
                toggleRecalculateChilds = _props.toggleRecalculateChilds,
                toggleRecalculateMainPorts = _props.toggleRecalculateMainPorts,
                createNewArea = _props.createNewArea,
                createAreaOnServer = _props.createAreaOnServer,
                updateAreaOnServer = _props.updateAreaOnServer,
                deleteAreaOnServer = _props.deleteAreaOnServer,
                showMarkersOnlyInThisArea = _props.showMarkersOnlyInThisArea,
                toggleShowMarkersOnlyInThisArea = _props.toggleShowMarkersOnlyInThisArea,
                changeMapView = _props.changeMapView,
                showView = _props.showView,
                user = _props.user,
                countries = _props.countries;


            var isRestricted = area.mainRegion || area.isWWR;

            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'Ok',
                primary: true,
                onClick: function onClick() {
                    _this5.toggleOpenDialog();deleteAreaOnServer();
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    return _this5.toggleOpenDialog();
                }
            })];

            var btnRender = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'save',
                primary: true,
                disabled: areaName.length === 0,
                onClick: function onClick() {
                    createAreaOnServer({ setAreaAsDefault: setAreaAsDefault });
                },
                style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                buttonStyle: { lineHeight: '25px', height: '25px' },
                labelStyle: { fontSize: '11px' }
            });

            if (area && !area.isNew) {
                btnRender = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                        label: 'update',
                        style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                        buttonStyle: { lineHeight: '25px', height: '25px' },
                        labelStyle: { fontSize: '11px' },
                        onClick: function onClick() {
                            updateAreaOnServer({ setAreaAsDefault: setAreaAsDefault });
                        },
                        primary: true
                    }),
                    user.role === 'admin' && !isRestricted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                        label: 'remove',
                        style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                        buttonStyle: { lineHeight: '25px', height: '25px' },
                        labelStyle: { fontSize: '11px' },
                        onClick: function onClick() {
                            return _this5.toggleOpenDialog();
                        },
                        secondary: true
                    }) : null,
                    area && area._id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                            label: 'Area To Port',
                            onClick: function onClick() {
                                return _this5.toggleOpenDialog('openDialogTransformArea');
                            },
                            style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                            buttonStyle: { lineHeight: '25px', height: '25px' },
                            labelStyle: { fontSize: '11px' }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                            label: 'Duplicate area',
                            onClick: this.duplicateArea,
                            style: { lineHeight: '25px', height: '25px' },
                            buttonStyle: { lineHeight: '25px', height: '25px' },
                            labelStyle: { fontSize: '11px', padding: '0 11px' }
                        })
                    )
                );
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block margin-10', style: { height: '102px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default.a, {
                    title: 'Do you really want to delete area?',
                    actions: actions,
                    open: this.state.openDialog,
                    modal: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AreaToPortDialog__["a" /* default */], {
                    open: this.state.openDialogTransformArea,
                    onClose: function onClose() {
                        return _this5.toggleOpenDialog('openDialogTransformArea');
                    },
                    onSubmit: function onSubmit(data) {
                        console.log('Form submitted with data:', data);
                        _this5.setState({
                            areaToPort: _extends({}, _this5.state.areaToPort, {
                                coordinates: data.coordinates,
                                country: data.country,
                                unLoCode: data.unLoCode
                            }),
                            areaName: data.name
                        }, function () {
                            _this5.transformAreaToPort();
                        });
                    },
                    initialValues: {
                        name: areaName,
                        country: areaToPort.country,
                        unLoCode: areaToPort.unLoCode,
                        coordinates: [0, 0]
                    },
                    countries: countries
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block absolute small-name' },
                    'Management'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3', style: { position: 'relative' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                            ref: 'areaName',
                            floatingLabelText: 'Area name',
                            value: areaName,
                            onChange: this.onChangeName,
                            fullWidth: true,
                            disabled: isRestricted
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-5 middle-xs' },
                        btnRender,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { display: 'flex', alignItems: 'center' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default.a, {
                                style: { margin: '10px 0 0 0', fontSize: '12px', width: '46%' },
                                checked: recalculateOnSave,
                                label: 'Recalculate area ports',
                                iconStyle: { marginRight: '10px' },
                                onCheck: function onCheck(e, value) {
                                    toggleRecalculateChilds(value);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default.a, {
                                style: { margin: '10px 0 0 0', fontSize: '12px', width: '50%' },
                                checked: recalculateMainPorts,
                                label: 'Recalculate main port \u2605',
                                iconStyle: { marginRight: '10px' },
                                onCheck: function onCheck(e, value) {
                                    toggleRecalculateMainPorts(value);
                                }
                            }),
                            area._id && !isRestricted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'Duplicate area',
                                onClick: this.duplicateArea,
                                style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                                buttonStyle: { lineHeight: '25px', height: '25px' },
                                labelStyle: { fontSize: '11px', padding: '0 11px' }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4 middle-xs' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            !isRestricted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: showView === 'map' ? 'merge' : 'map',
                                style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                                buttonStyle: { lineHeight: '25px', height: '25px' },
                                labelStyle: { fontSize: '11px' },
                                primary: true,
                                onClick: function onClick() {
                                    if (showView === 'map') {
                                        changeMapView('merge');
                                    } else {
                                        changeMapView('map');
                                    }
                                }
                            }) : null,
                            area && portFromAutoComplete._id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'add port to region',
                                style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                                buttonStyle: { lineHeight: '25px', height: '25px' },
                                labelStyle: { fontSize: '11px' },
                                onClick: this.props.addPortToRegion
                            }) : null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'create new',
                                onClick: createNewArea,
                                style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                                buttonStyle: { lineHeight: '25px', height: '25px' },
                                labelStyle: { fontSize: '11px' }
                            }),
                            !isRestricted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                                label: 'create/update (by coords)',
                                onClick: function onClick() {
                                    return changeMapView('addByCoords');
                                },
                                secondary: true,
                                style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                                buttonStyle: { lineHeight: '25px', height: '25px' },
                                labelStyle: { fontSize: '11px' }
                            }) : null
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { display: 'flex', gap: '5px' } },
                            area._id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default.a, {
                                style: { fontSize: '12px', display: 'flex', width: '69%' },
                                checked: showMarkersOnlyInThisArea,
                                labelStyle: { marginTop: '10px' },
                                iconStyle: { marginRight: '10px', marginTop: '5px' },
                                label: 'Show markers only in this area',
                                onCheck: function onCheck(e, value) {
                                    toggleShowMarkersOnlyInThisArea(value);
                                }
                            }) : null
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ManagementArea;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = ManagementArea;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ManagementArea, 'ManagementArea', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Management.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Management.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_hook_form__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Regions_PortAdd_MapComponent__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








var TransformAreaToPortDialog = function TransformAreaToPortDialog(_ref) {
    var open = _ref.open,
        onClose = _ref.onClose,
        onSubmit = _ref.onSubmit,
        initialValues = _ref.initialValues,
        countries = _ref.countries;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState2 = _slicedToArray(_useState, 2),
        warnings = _useState2[0],
        setWarnings = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState4 = _slicedToArray(_useState3, 2),
        customErrors = _useState4[0],
        setCustomErrors = _useState4[1];

    var initialCoordinates = initialValues && initialValues.coordinates ? [typeof initialValues.coordinates[0] === 'string' ? parseFloat(initialValues.coordinates[0]) || 0 : initialValues.coordinates[0] || 0, typeof initialValues.coordinates[1] === 'string' ? parseFloat(initialValues.coordinates[1]) || 0 : initialValues.coordinates[1] || 0] : [0, 0];
    var defaultValues = {
        name: initialValues ? initialValues.name : '',
        country: initialValues ? initialValues.country : '',
        unLoCode: initialValues ? initialValues.unLoCode : '',
        coordinates: initialCoordinates,
        'coordinates.0': initialCoordinates[0],
        'coordinates.1': initialCoordinates[1]
    };

    var _useForm = Object(__WEBPACK_IMPORTED_MODULE_1_react_hook_form__["c" /* useForm */])({
        defaultValues: defaultValues,
        mode: 'all'
    }),
        control = _useForm.control,
        handleSubmit = _useForm.handleSubmit,
        errors = _useForm.errors,
        setValue = _useForm.setValue,
        watch = _useForm.watch,
        trigger = _useForm.trigger,
        reset = _useForm.reset;

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (open) {
            reset(defaultValues);
        }
        return function () {
            reset(defaultValues);
        };
    }, [open]);

    var coordinates = watch('coordinates');
    var lat = watch('coordinates.0');
    var lng = watch('coordinates.1');
    var country = watch('country');
    var unLoCode = watch('unLoCode');

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (country && unLoCode) {
            var countryObj = countries.find(function (c) {
                return c._id === country;
            });
            if (countryObj && countryObj.shortNameCode) {
                if (!unLoCode.startsWith(countryObj.shortNameCode)) {
                    setWarnings(function (prev) {
                        return _extends({}, prev, {
                            unLoCode: 'UN LOCODE should start with country code: ' + countryObj.shortNameCode
                        });
                    });
                } else {
                    setWarnings(function (prev) {
                        var newWarnings = _extends({}, prev);
                        delete newWarnings.unLoCode;
                        return newWarnings;
                    });
                }
            }
        } else {
            setWarnings(function (prev) {
                var newWarnings = _extends({}, prev);
                delete newWarnings.unLoCode;
                return newWarnings;
            });
        }
    }, [country, unLoCode, countries]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (unLoCode && (unLoCode.length > 5 || unLoCode.length < 5)) {
            setCustomErrors(function (prev) {
                return _extends({}, prev, {
                    unLoCode: 'UN LOCODE must be 5 characters long'
                });
            });
        } else {
            setCustomErrors(function (prev) {
                var newErrors = _extends({}, prev);
                delete newErrors.unLoCode;
                return newErrors;
            });
        }
    }, [unLoCode]);

    var onFormSubmit = function onFormSubmit(formData) {
        if (Object.keys(customErrors).length > 0) {
            return;
        }

        var formattedData = _extends({}, formData, {
            coordinates: [parseFloat(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(formData, 'coordinates.0', 0)) || 0, parseFloat(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(formData, 'coordinates.1', 0)) || 0]
        });

        onSubmit(formattedData);
    };

    var handleMapCoordinateChange = function handleMapCoordinateChange(key, value) {
        if (key === 'coordinates') {
            var numericCoords = [parseFloat(value[0]) || 0, parseFloat(value[1]) || 0];

            setValue('coordinates', numericCoords);
            setValue('coordinates.0', numericCoords[0]);
            setValue('coordinates.1', numericCoords[1]);
        }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui__["f" /* Dialog */],
        {
            title: 'Transform area to port.',
            actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["g" /* FlatButton */], {
                label: 'OK',
                primary: true,
                onClick: handleSubmit(onFormSubmit)
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["g" /* FlatButton */], {
                label: 'Cancel',
                primary: true,
                onClick: onClose
            })],
            open: open,
            autoScrollBodyContent: true,
            modal: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_hook_form__["a" /* Controller */], {
                name: 'name',
                control: control,
                rules: { required: 'Port name is required' },
                defaultValue: initialValues ? initialValues.name : '',
                render: function render(_ref2) {
                    var onChange = _ref2.onChange,
                        _onBlur = _ref2.onBlur,
                        value = _ref2.value,
                        name = _ref2.name,
                        ref = _ref2.ref;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                        value: value,
                        defaultValue: value,
                        onChange: onChange,
                        onBlur: function onBlur() {
                            _onBlur();
                            trigger('name');
                        },
                        name: name,
                        inputRef: ref,
                        floatingLabelText: 'Port name',
                        errorText: errors.name ? errors.name.message : null,
                        fullWidth: true
                    });
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_hook_form__["a" /* Controller */], {
                name: 'country',
                control: control,
                rules: { required: 'Country is required' },
                defaultValue: initialValues ? initialValues.country : '',
                render: function render(_ref3) {
                    var _onChange = _ref3.onChange,
                        _onBlur2 = _ref3.onBlur,
                        value = _ref3.value,
                        name = _ref3.name,
                        ref = _ref3.ref;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["s" /* SelectField */],
                        {
                            value: value,
                            onChange: function onChange(_e, _i, selectedValue) {
                                return _onChange(selectedValue);
                            },
                            onBlur: function onBlur() {
                                _onBlur2();
                                trigger('country');
                            },
                            name: name,
                            ref: ref,
                            floatingLabelText: 'Country',
                            maxHeight: 200,
                            errorText: errors.country ? errors.country.message : null,
                            fullWidth: true
                        },
                        countries.map(function (c, i) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], {
                                key: 'country_' + i,
                                value: c._id,
                                primaryText: c.name
                            });
                        })
                    );
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_hook_form__["a" /* Controller */], {
                name: 'unLoCode',
                control: control,
                defaultValue: initialValues ? initialValues.unLoCode : '',
                render: function render(_ref4) {
                    var _onChange2 = _ref4.onChange,
                        onBlur = _ref4.onBlur,
                        value = _ref4.value,
                        name = _ref4.name,
                        ref = _ref4.ref;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                            value: value,
                            onChange: function onChange(e) {
                                var input = e.target;
                                var start = input.selectionStart;
                                var end = input.selectionEnd;
                                var upperValue = e.target.value.toUpperCase();

                                _onChange2(upperValue);

                                setTimeout(function () {
                                    input.setSelectionRange(start, end);
                                }, 0);
                            },
                            onBlur: onBlur,
                            name: name,
                            inputRef: ref,
                            floatingLabelText: 'UN LOCODE',
                            fullWidth: true,
                            errorText: customErrors.unLoCode || null
                        }),
                        !customErrors.unLoCode && warnings.unLoCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: {
                                    color: 'orange', fontSize: '12px', marginTop: '4px', marginBottom: '8px'
                                }
                            },
                            warnings.unLoCode
                        )
                    );
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_hook_form__["a" /* Controller */], {
                name: 'coordinates.0',
                control: control,
                rules: {
                    required: 'Latitude is required',
                    validate: function validate(value) {
                        return !isNaN(parseFloat(value)) || 'Must be a number';
                    }
                },
                defaultValue: initialCoordinates[0],
                render: function render(_ref5) {
                    var _onChange3 = _ref5.onChange,
                        onBlur = _ref5.onBlur,
                        value = _ref5.value,
                        name = _ref5.name,
                        ref = _ref5.ref;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                        value: value,
                        onChange: function onChange(e) {
                            var numValue = parseFloat(e.target.value) || 0;
                            _onChange3(numValue);
                            setValue('coordinates', [numValue, parseFloat(lng) || 0]);
                        },
                        onBlur: onBlur,
                        name: name,
                        inputRef: ref,
                        floatingLabelText: 'Latitude',
                        fullWidth: true,
                        errorText: errors['coordinates.0'] ? errors['coordinates.0'].message : null
                    });
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_hook_form__["a" /* Controller */], {
                name: 'coordinates.1',
                control: control,
                rules: {
                    required: 'Longitude is required',
                    validate: function validate(value) {
                        return !isNaN(parseFloat(value)) || 'Must be a number';
                    }
                },
                defaultValue: initialCoordinates[1],
                render: function render(_ref6) {
                    var _onChange4 = _ref6.onChange,
                        onBlur = _ref6.onBlur,
                        value = _ref6.value,
                        name = _ref6.name,
                        ref = _ref6.ref;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
                        value: value,
                        onChange: function onChange(e) {
                            var numValue = parseFloat(e.target.value) || 0;
                            _onChange4(numValue);
                            setValue('coordinates', [parseFloat(lat) || 0, numValue]);
                        },
                        onBlur: onBlur,
                        name: name,
                        inputRef: ref,
                        floatingLabelText: 'Longitude',
                        fullWidth: true,
                        errorText: errors['coordinates.1'] ? errors['coordinates.1'].message : null
                    });
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Regions_PortAdd_MapComponent__["a" /* default */], {
                coordinates: [parseFloat(lat) || 0, parseFloat(lng) || 0],
                change: handleMapCoordinateChange,
                googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_4_constants__["a" /* default */].GOOGLE_MAP_API_KEY,
                loadingElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } }),
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '100%', height: '300px', marginTop: '20px' } }),
                mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '100%' } })
            })
        )
    );
};

var _default = TransformAreaToPortDialog;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TransformAreaToPortDialog, 'TransformAreaToPortDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/AreaToPortDialog.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/AreaToPortDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_regions_areas__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortsAreasToggler__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AreaList__ = __webpack_require__(2324);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();









function selectParentAreasOf(areaId) {
    return function (state) {
        return state.areas.items.filter(function (a) {
            return a.childs && a.childs.includes(areaId);
        });
    };
}

function selectChildAreasOf(areaId) {
    return function (state) {
        return state.areas.items.filter(function (a) {
            return a.parents && a.parents.includes(areaId);
        });
    };
}

function Areas(_ref) {
    var area = _ref.area,
        parents = _ref.parents,
        childAreas = _ref.childAreas,
        toggleShowPorts = _ref.toggleShowPorts,
        toggleShowAreas = _ref.toggleShowAreas,
        showChilds = _ref.showChilds,
        selectParentArea = _ref.selectParentArea,
        isUpdating = _ref.isUpdating,
        allAreas = _ref.allAreas,
        removeAreaChild = _ref.removeAreaChild;

    var handleRemoveChildArea = function handleRemoveChildArea(childId) {
        removeAreaChild(area._id, childId);
    };

    var handleRemoveParentArea = function handleRemoveParentArea(parentId) {
        removeAreaChild(parentId, area._id);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 col-xs-offset-9' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PortsAreasToggler__["a" /* default */], {
                    toggleShowPorts: toggleShowPorts,
                    toggleShowAreas: toggleShowAreas,
                    showChilds: showChilds
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block margin-9' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'name-block absolute small-name' },
                'Areas related to ',
                area.name || 'selected one'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { overflowY: 'scroll', height: '75vh', width: '100%' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["t" /* Subheader */],
                    null,
                    'Parents'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AreaList__["a" /* default */], {
                    areas: isUpdating ? null : parents,
                    allAreas: allAreas,
                    onAreaClick: selectParentArea,
                    onRemoveClick: handleRemoveParentArea,
                    emptyText: 'No parent areas'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["t" /* Subheader */],
                    null,
                    'Children'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AreaList__["a" /* default */], {
                    areas: isUpdating ? null : childAreas,
                    allAreas: allAreas,
                    onAreaClick: selectParentArea,
                    onRemoveClick: handleRemoveChildArea,
                    emptyText: 'No subregions'
                })
            )
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(
/**
 * @param {*} state 
 * @param {*} props
 */
function (state, props) {
    return {
        parents: selectParentAreasOf(props.area._id)(state),
        childAreas: selectChildAreasOf(props.area._id)(state),
        isUpdating: state.areas.isUpdating,
        allAreas: state.areas.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({
        removeAreaChild: __WEBPACK_IMPORTED_MODULE_4_actions_regions_areas__["d" /* removeAreaChild */]
    }, dispatch);
})(Areas));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(selectParentAreasOf, 'selectParentAreasOf', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Areas/Areas.jsx');
    reactHotLoader.register(selectChildAreasOf, 'selectChildAreasOf', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Areas/Areas.jsx');
    reactHotLoader.register(Areas, 'Areas', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Areas/Areas.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Areas/Areas.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_close__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_close__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





/**
 * @param {{
 *  areas: Array,
 *  allAreas: Array,
 *  onAreaClick: Function,
 *  onRemoveClick: Function,
 *  emptyText: string,
 * }} param0 
 */
function AreaList(_ref) {
    var areas = _ref.areas,
        allAreas = _ref.allAreas,
        onAreaClick = _ref.onAreaClick,
        onRemoveClick = _ref.onRemoveClick,
        emptyText = _ref.emptyText;

    if (!!areas && areas.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { color: '#888', fontSize: 'smaller', textAlign: 'center' } },
            emptyText
        );
    }
    if (!areas) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["d" /* CircularProgress */], { size: 16, thickness: 2 })
        );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui__["j" /* List */],
        null,
        areas.map(function (area, index) {
            var parentCount = (area.parents || []).map(function (id) {
                return allAreas.find(function (a) {
                    return a._id === id;
                });
            }).reduce(function (count, area) {
                return area ? count + 1 : count;
            }, 0);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["k" /* ListItem */]
            // use index for key, not date, because date is invoked once, resulting in similar keys => if you have 
            // an area that is the child of two different areas => error and parent tree is displayed wrong
            , { key: area._id + index,
                primaryText: area.name,
                secondaryText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 'smaller' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        { style: { color: parentCount > 1 ? 'rgb(255, 64, 129)' : '' } },
                        parentCount
                    ),
                    parentCount === 1 ? ' parent ' : ' parents ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        null,
                        area.childAreaCount
                    ),
                    area.childAreaCount === 1 ? ' child ' : ' children ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        null,
                        area.childPortCount
                    ),
                    area.childPortCount === 1 ? ' port' : ' ports'
                ),
                rightIconButton: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                    { onClick: function onClick() {
                            return onRemoveClick(area._id);
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_navigation_close___default.a, null)
                ),
                onClick: function onClick() {
                    return onAreaClick(area._id);
                },
                initiallyOpen: true,
                style: { fontSize: '12px !important' }
            });
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(AreaList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AreaList, 'AreaList', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Areas/AreaList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Dashboard/Areas/AreaList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Port_AltNames__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Labels__ = __webpack_require__(911);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










var Sidebar = function Sidebar(_ref) {
    var port = _ref.port,
        newPort = _ref.newPort,
        onEditAltNames = _ref.onEditAltNames;

    var labels = Object(__WEBPACK_IMPORTED_MODULE_6__common_Labels__["b" /* getPortLabelTypes */])(newPort);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-lg-3 col-xs-3 sidebar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'name' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_utils__["a" /* CheckDiffText */], {
                    oldValue: port.name,
                    newValue: newPort.name
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'name country' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_utils__["a" /* CheckDiffText */], {
                    oldValue: newPort.country ? newPort.country.name : newPort.country,
                    newValue: newPort.country ? newPort.country.name : newPort.country
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_6__common_Labels__["a" /* default */])(labels)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'divider' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'info__title' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'gray' },
                        'UN LOCODE: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_utils__["a" /* CheckDiffText */], {
                        oldValue: port.unLoCode,
                        newValue: newPort.unLoCode
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'info__title' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'gray' },
                        'Time Zone: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_utils__["a" /* CheckDiffText */], {
                        oldValue: port.timezone,
                        newValue: newPort.timezone
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: port.site, className: 'info__website' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_utils__["a" /* CheckDiffText */], {
                        oldValue: port.site,
                        newValue: newPort.site
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Port_AltNames__["a" /* default */], {
                    port: port,
                    onEditAltNames: onEditAltNames,
                    isForApproval: true
                })
            )
        )
    );
};

Sidebar.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    newPort: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    onEditAltNames: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

Sidebar.defaultProps = {
    onEditAltNames: function onEditAltNames() {}
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref2) {
    var port = _ref2.port,
        newPort = _ref2.newPort;
    return {
        port: port,
        newPort: newPort
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(Sidebar);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Sidebar, 'Sidebar', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/Sidebar.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/Sidebar.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_BlockWrapper__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Facilities_scss__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Facilities_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Facilities_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FacilitiesApproval__ = __webpack_require__(2328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FacilitiesForm__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FacilitiesView__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var Facilities = function Facilities(_ref) {
    var port = _ref.port,
        pendingChanges = _ref.pendingChanges,
        onApproveField = _ref.onApproveField,
        onRejectField = _ref.onRejectField,
        updatePortField = _ref.updatePortField;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isEditing = _useState2[0],
        setIsEditing = _useState2[1];

    var saveChanges = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(change) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            updatePortField('facilities', change, function () {
                                setIsEditing(false);
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveChanges(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var processedStatus = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'processedFields.facilities.status');

    var isApproved = processedStatus === 'approved';
    var isRejected = processedStatus === 'rejected';

    if (!isApproved && !isRejected && Object(__WEBPACK_IMPORTED_MODULE_8__common_utils__["b" /* hasChanges */])(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'originalValues.facilities'), __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'changedValues.facilities'))) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__common_BlockWrapper__["a" /* BlockWrapper */],
            { title: 'Facilities' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FacilitiesApproval__["a" /* default */], {
                originalValues: pendingChanges.originalValues.facilities,
                changedValues: pendingChanges.changedValues.facilities,
                onApprove: onApproveField,
                onReject: onRejectField
            })
        );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__common_BlockWrapper__["a" /* BlockWrapper */],
        { title: 'Facilities' },
        isEditing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FacilitiesForm__["a" /* default */], {
            initialValues: port.facilities,
            onSubmit: function onSubmit(values) {
                return saveChanges(values);
            },
            onCancel: function onCancel() {
                return setIsEditing(false);
            }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FacilitiesView__["a" /* default */], { values: port.facilities }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'edit-actions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                    label: 'Edit Facilities',
                    onClick: function onClick() {
                        return setIsEditing(true);
                    },
                    primary: true
                })
            )
        )
    );
};

Facilities.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
        facilities: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
    }).isRequired,
    pendingChanges: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
        originalValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
            facilities: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
        }),
        changedValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
            facilities: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
        }),
        processedFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
    }),
    onApproveField: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onRejectField: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onSaveChanges: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};

var _default = Facilities;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Facilities, 'Facilities', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/Facilities.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/Facilities.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128629
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Facilities_scss__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Facilities_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Facilities_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ports__ = __webpack_require__(166);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








var FacilitiesApproval = function FacilitiesApproval(_ref) {
    var _ref$changedValues = _ref.changedValues,
        changedValues = _ref$changedValues === undefined ? {} : _ref$changedValues,
        _ref$originalValues = _ref.originalValues,
        originalValues = _ref$originalValues === undefined ? {} : _ref$originalValues,
        onApprove = _ref.onApprove,
        onReject = _ref.onReject;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'facilities-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'facilities-grid' },
            __WEBPACK_IMPORTED_MODULE_5_constants_ports__["a" /* PORT_FACILITIES */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        key: name,
                        className: 'facility-item ' + (changedValues[name] !== originalValues[name] ? 'dirty-element' : '')
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox___default.a, {
                        checked: changedValues[name],
                        label: label,
                        disabled: true
                    })
                );
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Approve',
                primary: true,
                onClick: function onClick() {
                    return onApprove('facilities');
                },
                className: 'approve-button'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Reject',
                secondary: true,
                onClick: function onClick() {
                    return onReject('facilities');
                },
                className: 'reject-button'
            })
        )
    );
};

FacilitiesApproval.propTypes = {
    changedValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    originalValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    onApprove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onReject: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

FacilitiesApproval.defaultProps = {
    changedValues: {},
    originalValues: {}
};

var _default = FacilitiesApproval;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FacilitiesApproval, 'FacilitiesApproval', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/FacilitiesApproval.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/FacilitiesApproval.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Facilities_scss__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Facilities_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Facilities_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ports__ = __webpack_require__(166);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var FacilitiesForm = function FacilitiesForm(_ref) {
    var initialValues = _ref.initialValues,
        onSubmit = _ref.onSubmit,
        onCancel = _ref.onCancel;

    var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(initialValues || {}),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        values = _React$useState2[0],
        setValues = _React$useState2[1];

    var handleChange = function handleChange(name, checked) {
        setValues(function (prev) {
            return _extends({}, prev, _defineProperty({}, name, checked));
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'facilities-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'facilities-grid' },
            __WEBPACK_IMPORTED_MODULE_5_constants_ports__["a" /* PORT_FACILITIES */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: name },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox___default.a, {
                        checked: values[name] || false,
                        label: label,
                        onCheck: function onCheck(e, checked) {
                            return handleChange(name, checked);
                        }
                    })
                );
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Save',
                primary: true,
                onClick: function onClick() {
                    return onSubmit(values);
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Cancel',
                secondary: true,
                onClick: onCancel
            })
        )
    );
};

FacilitiesForm.propTypes = {
    initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = FacilitiesForm;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FacilitiesForm, 'FacilitiesForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/FacilitiesForm.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/FacilitiesForm.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Facilities_scss__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Facilities_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Facilities_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ports__ = __webpack_require__(166);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var FacilitiesView = function FacilitiesView(_ref) {
    var values = _ref.values;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'facilities-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'facilities-grid' },
            __WEBPACK_IMPORTED_MODULE_4_constants_ports__["a" /* PORT_FACILITIES */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: name },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Checkbox___default.a, {
                        checked: values[name] || false,
                        label: label,
                        disabled: true
                    })
                );
            })
        )
    );
};

FacilitiesView.propTypes = {
    values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var _default = FacilitiesView;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FacilitiesView, 'FacilitiesView', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/FacilitiesView.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Facilities/FacilitiesView.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortRestrictionsApproval__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PortRestrictionsForm__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PortRestrictionsView__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BlockWrapper__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











var PortRestrictions = function PortRestrictions(_ref) {
    var port = _ref.port,
        pendingChanges = _ref.pendingChanges,
        onApproveField = _ref.onApproveField,
        onRejectField = _ref.onRejectField,
        updatePortField = _ref.updatePortField;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isEditing = _useState2[0],
        setIsEditing = _useState2[1];

    var processedStatus = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(pendingChanges, 'processedFields.portLimitations.status');

    var isApproved = processedStatus === 'approved';
    var isRejected = processedStatus === 'rejected';

    var hasPortRestrictionChanges = !isApproved && !isRejected && Object(__WEBPACK_IMPORTED_MODULE_6__common_utils__["b" /* hasChanges */])(__WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(pendingChanges, 'originalValues.portLimitations'), __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(pendingChanges, 'changedValues.portLimitations'));

    var saveChanges = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(change) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            updatePortField('portLimitations', change, function () {
                                setIsEditing(false);
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveChanges(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    if (hasPortRestrictionChanges) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__common_BlockWrapper__["a" /* BlockWrapper */],
            { title: 'Port Restrictions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PortRestrictionsApproval__["a" /* default */], {
                originalValues: pendingChanges.originalValues.portLimitations || {},
                changedValues: pendingChanges.changedValues.portLimitations || {},
                onApprove: onApproveField,
                onReject: onRejectField
            })
        );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__common_BlockWrapper__["a" /* BlockWrapper */],
        { title: 'Port Restrictions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'port-restrictions-block' },
            isEditing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PortRestrictionsForm__["a" /* default */], {
                initialValues: { portLimitations: port.portLimitations },
                onSubmit: function onSubmit(values) {
                    saveChanges(values.portLimitations);
                },
                onCancel: function onCancel() {
                    return setIsEditing(false);
                }
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PortRestrictionsView__["a" /* default */], { values: port.portLimitations }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-actions' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                        label: 'Edit Port Restrictions',
                        onClick: function onClick() {
                            return setIsEditing(true);
                        },
                        primary: true
                    })
                )
            )
        )
    );
};

PortRestrictions.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        portLimitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    }).isRequired,
    pendingChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        originalValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            portLimitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
        }),
        changedValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            portLimitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
        })
    }),
    onApproveField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRejectField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSaveChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = PortRestrictions;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortRestrictions, 'PortRestrictions', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictions.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortRestrictions_scss__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PortRestrictions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PortRestrictions_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__(105);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var PortRestrictionsApproval = function PortRestrictionsApproval(_ref) {
    var _ref$originalValues = _ref.originalValues,
        originalValues = _ref$originalValues === undefined ? {} : _ref$originalValues,
        _ref$changedValues = _ref.changedValues,
        changedValues = _ref$changedValues === undefined ? {} : _ref$changedValues,
        onApprove = _ref.onApprove,
        onReject = _ref.onReject;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'port-restrictions-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'port-restrictions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'list' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Max Draft, m:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* CheckDiffText */], {
                        oldValue: originalValues.maxDraught,
                        newValue: changedValues.maxDraught
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Max Beam, m:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* CheckDiffText */], {
                        oldValue: originalValues.maxBeam,
                        newValue: changedValues.maxBeam
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Max LOA, m:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* CheckDiffText */], {
                        oldValue: originalValues.maxLOA,
                        newValue: changedValues.maxLOA
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Max DWT, mt:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* CheckDiffText */], {
                        oldValue: originalValues.maxDWT,
                        newValue: changedValues.maxDWT
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Channel Depth, m:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* CheckDiffText */], {
                        oldValue: originalValues.channelDepth,
                        newValue: changedValues.channelDepth
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Anchorage Depth, m:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* CheckDiffText */], {
                        oldValue: originalValues.anchorageDepth,
                        newValue: changedValues.anchorageDepth
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'Mean Tide, m:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_utils__["a" /* CheckDiffText */], {
                        oldValue: originalValues.meanTide,
                        newValue: changedValues.meanTide
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Approve',
                primary: true,
                onClick: function onClick() {
                    return onApprove('portLimitations');
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Reject',
                secondary: true,
                onClick: function onClick() {
                    return onReject('portLimitations');
                }
            })
        )
    );
};

PortRestrictionsApproval.propTypes = {
    originalValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    changedValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    onApprove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onReject: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = PortRestrictionsApproval;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortRestrictionsApproval, 'PortRestrictionsApproval', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsApproval.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsApproval.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ports__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortRestrictions_scss__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PortRestrictions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PortRestrictions_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(6);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












var PortRestrictionsForm = function PortRestrictionsForm(_ref) {
    var handleSubmit = _ref.handleSubmit,
        onCancel = _ref.onCancel;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'port-restrictions-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'restrictions-grid' },
            __WEBPACK_IMPORTED_MODULE_5_constants_ports__["b" /* PORT_RESTRICTIONS */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: name, className: 'restriction-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'portLimitations.' + name,
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"],
                        floatingLabelText: label,
                        floatingLabelStyle: { fontSize: '12px' },
                        validate: [Object(__WEBPACK_IMPORTED_MODULE_4_redux_form_validators__["numericality"])({ '>=': 0, allowBlank: true })],
                        fullWidth: true,
                        parse: function parse(value) {
                            if (value === '' || value === null || value === undefined) return '';
                            // replace comma with dot
                            var normalized = value.replace(',', '.');
                            // allow only numbers, dot, and comma
                            if (!/^[0-9]*[.,]?[0-9]*$/.test(value)) return '';
                            // if value ends with a dot or comma, return as string so user can keep typing
                            if (/[.,]$/.test(value)) return value;
                            var asNumber = Number(normalized);
                            return isNaN(asNumber) ? value : asNumber;
                        },
                        inputProps: {
                            inputMode: 'decimal',
                            pattern: '[0-9.,]*'
                        },
                        onInput: function onInput(e) {
                            e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
                        }
                    })
                );
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Save',
                primary: true,
                onClick: handleSubmit
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Cancel',
                secondary: true,
                onClick: onCancel
            })
        )
    );
};

PortRestrictionsForm.propTypes = {
    portLimitations: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    handleSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onCancel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};

var selector = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* formValueSelector */])(__WEBPACK_IMPORTED_MODULE_8_data_formNames__["a" /* formName */].portUpdate);
var mapStateToProps = function mapStateToProps(state) {
    return {
        portLimitations: selector(state, 'portLimitations')
    };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* reduxForm */])({
    form: __WEBPACK_IMPORTED_MODULE_8_data_formNames__["a" /* formName */].portUpdate,
    enableReinitialize: true
})(PortRestrictionsForm));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortRestrictionsForm, 'PortRestrictionsForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsForm.jsx');
    reactHotLoader.register(selector, 'selector', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsForm.jsx');
    reactHotLoader.register(mapStateToProps, 'mapStateToProps', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsForm.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsForm.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ports__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PortRestrictions_scss__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PortRestrictions_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PortRestrictions_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var PortRestrictionsView = function PortRestrictionsView(_ref) {
    var _ref$values = _ref.values,
        values = _ref$values === undefined ? {} : _ref$values;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'port-restrictions-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'restrictions-grid' },
            __WEBPACK_IMPORTED_MODULE_3_constants_ports__["b" /* PORT_RESTRICTIONS */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: name, className: 'restriction-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default.a, {
                        floatingLabelText: label,
                        value: values[name] || '',
                        style: { fontSize: '12px' },
                        disabled: true,
                        fullWidth: true
                    })
                );
            })
        )
    );
};

PortRestrictionsView.propTypes = {
    values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var _default = PortRestrictionsView;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortRestrictionsView, 'PortRestrictionsView', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsView.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsView.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WarehousesApproval__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WarehousesForm__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WarehousesView__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BlockWrapper__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Warehouses_scss__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Warehouses_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Warehouses_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var Warehouses = function Warehouses(_ref) {
    var port = _ref.port,
        pendingChanges = _ref.pendingChanges,
        onApproveField = _ref.onApproveField,
        onRejectField = _ref.onRejectField,
        updatePortField = _ref.updatePortField;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isEditing = _useState2[0],
        setIsEditing = _useState2[1];

    var saveChanges = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(change) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            updatePortField('warehouses', change, function () {
                                setIsEditing(false);
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveChanges(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var processedStatus = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'processedFields.warehouses.status');

    var isApproved = processedStatus === 'approved';
    var isRejected = processedStatus === 'rejected';

    var hasWarehouseChanges = !isApproved && !isRejected && Object(__WEBPACK_IMPORTED_MODULE_3__common_utils__["b" /* hasChanges */])(__WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'originalValues.warehouses'), __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'changedValues.warehouses'));

    if (hasWarehouseChanges) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__common_BlockWrapper__["a" /* BlockWrapper */],
            { title: 'Warehouses' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__WarehousesApproval__["a" /* default */], {
                originalValues: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'originalValues.warehouses'),
                changedValues: __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(pendingChanges, 'changedValues.warehouses'),
                onApprove: onApproveField,
                onReject: onRejectField
            })
        );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__common_BlockWrapper__["a" /* BlockWrapper */],
        { title: 'Warehouses' },
        isEditing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__WarehousesForm__["a" /* default */], {
            initialValues: { warehouses: port.warehouses },
            onSubmit: function onSubmit(values) {
                return saveChanges(values.warehouses);
            },
            onCancel: function onCancel() {
                return setIsEditing(false);
            }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WarehousesView__["a" /* default */], { values: port.warehouses }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'edit-actions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                    label: 'Edit Warehouses',
                    onClick: function onClick() {
                        return setIsEditing(true);
                    },
                    primary: true
                })
            )
        )
    );
};

Warehouses.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        warehouses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    }).isRequired,
    pendingChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        changedValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            warehouses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
        })
    }),
    onApproveField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRejectField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSaveChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = Warehouses;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Warehouses, 'Warehouses', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/Warehouses.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/Warehouses.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ports__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Warehouses_scss__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Warehouses_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Warehouses_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var WarehousesApproval = function WarehousesApproval(_ref) {
    var _ref$originalValues = _ref.originalValues,
        originalValues = _ref$originalValues === undefined ? {} : _ref$originalValues,
        _ref$changedValues = _ref.changedValues,
        changedValues = _ref$changedValues === undefined ? {} : _ref$changedValues,
        onApprove = _ref.onApprove,
        onReject = _ref.onReject;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'warehouses-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'warehouses-grid' },
            __WEBPACK_IMPORTED_MODULE_3_constants_ports__["c" /* PORT_WAREHOUSE_TYPES */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        key: name,
                        className: changedValues[name] !== originalValues[name] ? 'dirty-element' : ''
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default.a, {
                        checked: changedValues[name] || false,
                        label: label,
                        disabled: true
                    })
                );
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Approve',
                primary: true,
                onClick: function onClick() {
                    return onApprove('warehouses');
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Reject',
                secondary: true,
                onClick: function onClick() {
                    return onReject('warehouses');
                }
            })
        )
    );
};

var _default = WarehousesApproval;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(WarehousesApproval, 'WarehousesApproval', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/WarehousesApproval.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/WarehousesApproval.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ports__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Warehouses_scss__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Warehouses_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Warehouses_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








var WarehousesForm = function WarehousesForm(_ref) {
    var handleSubmit = _ref.handleSubmit,
        onCancel = _ref.onCancel;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'warehouses-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'warehouses-grid' },
            __WEBPACK_IMPORTED_MODULE_4_constants_ports__["c" /* PORT_WAREHOUSE_TYPES */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: name, className: 'warehouse-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
                        name: 'warehouses.' + name,
                        component: __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["Checkbox"],
                        label: label
                    })
                );
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Save',
                primary: true,
                onClick: handleSubmit
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Cancel',
                secondary: true,
                onClick: onCancel
            })
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["g" /* reduxForm */])({
    form: 'warehousesForm',
    enableReinitialize: true
})(WarehousesForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(WarehousesForm, 'WarehousesForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/WarehousesForm.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/WarehousesForm.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ports__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Warehouses_scss__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Warehouses_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Warehouses_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var WarehousesView = function WarehousesView(_ref) {
    var values = _ref.values;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'warehouses-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'warehouses-grid' },
            __WEBPACK_IMPORTED_MODULE_3_constants_ports__["c" /* PORT_WAREHOUSE_TYPES */].map(function (_ref2) {
                var name = _ref2.name,
                    label = _ref2.label;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: name, className: 'warehouse-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["b" /* Checkbox */], {
                        checked: values[name] || false,
                        label: label,
                        disabled: true
                    })
                );
            })
        )
    );
};

WarehousesView.propTypes = {
    values: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};

var _default = WarehousesView;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(WarehousesView, 'WarehousesView', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/WarehousesView.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Warehouses/WarehousesView.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BlockWrapper__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Other_scss__ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Other_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Other_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










var OtherView = function OtherView(_ref) {
    var originalValue = _ref.originalValue,
        changedValue = _ref.changedValue;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'other' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_utils__["a" /* CheckDiffText */], {
            oldValue: originalValue,
            newValue: changedValue
        })
    );
};

var OtherApproval = function OtherApproval(_ref2) {
    var changedValue = _ref2.changedValue,
        originalValue = _ref2.originalValue,
        onApprove = _ref2.onApprove,
        onReject = _ref2.onReject;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'other-block' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'other' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_utils__["a" /* CheckDiffText */], {
                oldValue: originalValue,
                newValue: changedValue
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Approve',
                primary: true,
                onClick: function onClick() {
                    return onApprove('additionalDescription');
                },
                className: 'approve-button'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Reject',
                secondary: true,
                onClick: function onClick() {
                    return onReject('additionalDescription');
                },
                className: 'reject-button'
            })
        )
    );
};

var Other = function Other(_ref3) {
    var port = _ref3.port,
        pendingChanges = _ref3.pendingChanges,
        onApproveField = _ref3.onApproveField,
        onRejectField = _ref3.onRejectField,
        updatePortField = _ref3.updatePortField;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isEditing = _useState2[0],
        setIsEditing = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        additionalDescription: port.additionalDescription
    }),
        _useState4 = _slicedToArray(_useState3, 2),
        values = _useState4[0],
        setValues = _useState4[1];

    var saveChanges = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(change) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            updatePortField('additionalDescription', change, function () {
                                setIsEditing(false);
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveChanges(_x) {
            return _ref4.apply(this, arguments);
        };
    }();

    var processedStatus = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'processedFields.additionalDescription.status');

    var isApproved = processedStatus === 'approved';
    var isRejected = processedStatus === 'rejected';

    var hasOtherChanges = !isApproved && !isRejected && Object(__WEBPACK_IMPORTED_MODULE_6__common_utils__["b" /* hasChanges */])(__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'originalValues.additionalDescription'), __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'changedValues.additionalDescription'));

    var cancelEditing = function cancelEditing() {
        setIsEditing(false);
        setValues({
            additionalDescription: port.additionalDescription
        });
    };

    var enableEdit = function enableEdit() {
        setIsEditing(true);
        setValues({
            additionalDescription: port.additionalDescription
        });
    };

    if (hasOtherChanges) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__common_BlockWrapper__["a" /* BlockWrapper */],
            { title: 'Other' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OtherApproval, {
                originalValue: __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'originalValues.additionalDescription'),
                changedValue: __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'changedValues.additionalDescription'),
                onApprove: onApproveField,
                onReject: onRejectField
            })
        );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__common_BlockWrapper__["a" /* BlockWrapper */],
        { title: 'Other' },
        isEditing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'other-form' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form_material_ui__["TextField"], {
                name: 'additionalDescription',
                value: values.additionalDescription || '',
                onChange: function onChange(e) {
                    return setValues(_extends({}, values, { additionalDescription: e.target.value }));
                },
                floatingLabelText: 'Other',
                multiLine: true,
                fullWidth: true,
                floatingLabelStyle: { fontSize: '12px' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-actions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                    label: 'Save',
                    primary: true,
                    onClick: function onClick() {
                        return saveChanges(values.additionalDescription);
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                    label: 'Cancel',
                    secondary: true,
                    onClick: cancelEditing
                })
            )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OtherView, {
            originalValue: port.additionalDescription,
            changedValue: pendingChanges && pendingChanges.changedValues && pendingChanges.changedValues.additionalDescription
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'block-buttons' },
            !isEditing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_RaisedButton___default.a, {
                label: 'Edit Other',
                onClick: enableEdit,
                primary: true
            })
        )
    );
};

Other.propTypes = {
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        additionalDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }).isRequired,
    pendingChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        changedValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            additionalDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        })
    }),
    onApproveField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRejectField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSaveChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = Other;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(OtherView, 'OtherView', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Other/Other.jsx');
    reactHotLoader.register(OtherApproval, 'OtherApproval', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Other/Other.jsx');
    reactHotLoader.register(Other, 'Other', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Other/Other.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/Other/Other.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128668
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_BlockWrapper__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LiftAndCranesApproval__ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LiftAndCranesForm__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LiftAndCranesView__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










var LiftsAndCranes = function LiftsAndCranes(_ref) {
    var port = _ref.port,
        pendingChanges = _ref.pendingChanges,
        onApproveField = _ref.onApproveField,
        onRejectField = _ref.onRejectField,
        updatePortField = _ref.updatePortField;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isEditing = _useState2[0],
        setIsEditing = _useState2[1];

    var saveChanges = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(change) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            updatePortField('liftsCranes', change, function () {
                                setIsEditing(false);
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function saveChanges(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var processedStatus = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'processedFields.liftsCranes.status');

    var isApproved = processedStatus === 'approved';
    var isRejected = processedStatus === 'rejected';

    if (!isApproved && !isRejected && Object(__WEBPACK_IMPORTED_MODULE_2__common_utils__["c" /* hasChangesLiftsCranes */])(__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'originalValues.liftsCranes'), __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'changedValues.liftsCranes'))) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__common_BlockWrapper__["a" /* BlockWrapper */],
            { title: 'Available Lift and Cranes' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LiftAndCranesApproval__["a" /* default */], {
                originalValues: __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'originalValues.liftsCranes'),
                changedValues: __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(pendingChanges, 'changedValues.liftsCranes'),
                onApprove: onApproveField,
                onReject: onRejectField
            })
        );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__common_BlockWrapper__["a" /* BlockWrapper */],
        { title: 'Available Lift and Cranes' },
        isEditing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LiftAndCranesForm__["a" /* default */], {
            liftsCranes: port.liftsCranes,
            onSubmit: function onSubmit(values) {
                return saveChanges(values);
            },
            onCancel: function onCancel() {
                return setIsEditing(false);
            }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LiftAndCranesView__["a" /* default */], { liftsCranes: port.liftsCranes }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'edit-actions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                    label: 'Edit Lift and Cranes',
                    onClick: function onClick() {
                        return setIsEditing(true);
                    },
                    primary: true
                })
            )
        )
    );
};

LiftsAndCranes.proptypes = {};

var _default = LiftsAndCranes;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LiftsAndCranes, 'LiftsAndCranes', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranes.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranes.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(105);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var LiftAndCranesApproval = function LiftAndCranesApproval(_ref) {
    var originalValues = _ref.originalValues,
        changedValues = _ref.changedValues,
        onApprove = _ref.onApprove,
        onReject = _ref.onReject;

    var items = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        return Object.entries(changedValues).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];

            return _extends({}, value, {
                name: key,
                label: key + ' mt:'
            });
        });
    }, [changedValues]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'lift-and-cranes', style: { margin: 'unset' } },
            items.map(function (liftCrane, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LiftAndCranesItem, {
                    key: liftCrane.name + '_' + index,
                    liftCrane: liftCrane,
                    port: { liftsCranes: originalValues },
                    newPort: { liftsCranes: changedValues }
                });
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                label: 'Approve',
                primary: true,
                onClick: function onClick() {
                    return onApprove('liftsCranes');
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                label: 'Reject',
                secondary: true,
                onClick: function onClick() {
                    return onReject('liftsCranes');
                }
            })
        )
    );
};

LiftAndCranesApproval.propTypes = {
    originalValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    changedValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    onApprove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onReject: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = LiftAndCranesApproval;
/* harmony default export */ __webpack_exports__["a"] = (_default);

var LiftAndCranesItem = function LiftAndCranesItem(_ref4) {
    var liftCrane = _ref4.liftCrane,
        port = _ref4.port,
        newPort = _ref4.newPort;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'line-head' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: port.liftsCranes && newPort.liftsCranes[liftCrane.name].checked !== port.liftsCranes[liftCrane.name].checked ? 'col-xs-12 middle-xs dirty-element' : 'col-xs-12 middle-xs'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["b" /* Checkbox */], {
                        name: 'liftsCranes.' + liftCrane.name + '.checked',
                        label: liftCrane.label,
                        labelStyle: { fontSize: '14px' },
                        style: { width: '750px' },
                        disabled: true,
                        checked: newPort.liftsCranes[liftCrane.name].checked
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'line-body' },
            liftCrane.details.map(function (detail, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    { key: index },
                    (detail.status === 'new' || detail.status === 'normal') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: detail.status === 'new' ? 'item middle-xs dirty-element' : 'item middle-xs ' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'count' },
                            detail ? detail.value : '',
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name' },
                            detail ? detail.name : ''
                        )
                    ),
                    detail.status === 'remove' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item middle-xs dirty-element' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'count' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.value : '',
                                newValue: null
                            }),
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.name : '',
                                newValue: null
                            })
                        )
                    ),
                    detail.status === 'change' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item middle-xs dirty-element' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'count' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.value : '',
                                newValue: detail.changes.value ? detail.changes.value : ''
                            }),
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.name : '',
                                newValue: detail.changes.name ? detail.changes.name : ''
                            })
                        )
                    )
                );
            })
        )
    );
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LiftAndCranesApproval, 'LiftAndCranesApproval', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesApproval.jsx');
    reactHotLoader.register(LiftAndCranesItem, 'LiftAndCranesItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesApproval.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesApproval.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Misc_Details__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_down__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_hardware_keyboard_arrow_up__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_hardware_keyboard_arrow_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_hardware_keyboard_arrow_up__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var styles = {
    checkbox: {
        labelStyle: { fontSize: '14px' },
        style: { width: '750px' }
    },
    icon: {
        iconStyle: { color: '#00bcd4' }
    }
};

var LiftAndCranesForm = function LiftAndCranesForm(_ref) {
    var liftsCranes = _ref.liftsCranes,
        onSubmit = _ref.onSubmit,
        onCancel = _ref.onCancel;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(liftsCranes),
        _useState2 = _slicedToArray(_useState, 2),
        values = _useState2[0],
        setValues = _useState2[1];

    var handleSubmit = function handleSubmit() {
        onSubmit(values);
    };

    var items = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        return Object.entries(values).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];

            return _extends({}, value, {
                name: key,
                label: key + ' mt:'
            });
        });
    }, [values]);

    console.log('values', values);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'lift-and-cranes' },
            items.map(function (liftCrane, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LiftAndCranesItem, {
                    key: '' + (liftCrane.id || index),
                    liftCrane: liftCrane,
                    liftsCranes: values,
                    changePort: setValues
                });
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Save',
                primary: true,
                onClick: handleSubmit
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                label: 'Cancel',
                onClick: onCancel,
                style: { marginRight: '10px' },
                secondary: true
            })
        )
    );
};

LiftAndCranesForm.propTypes = {
    liftsCranes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = LiftAndCranesForm;
/* harmony default export */ __webpack_exports__["a"] = (_default);

var LiftAndCranesItem = function LiftAndCranesItem(_ref4) {
    var liftCrane = _ref4.liftCrane,
        liftsCranes = _ref4.liftsCranes,
        changePort = _ref4.changePort;

    var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        showDetails = _React$useState2[0],
        setShowDetails = _React$useState2[1];

    var toggleDetails = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
        setShowDetails(function (prev) {
            return !prev;
        });
    }, []);

    var handleChangeVal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (val, name) {
        var _liftsCranes = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(liftsCranes);

        var updatedCrane = _extends({}, _liftsCranes[name], {
            checked: val
        });

        if (!updatedCrane.checked) {
            updatedCrane.details = [];
        }

        changePort(_extends({}, _liftsCranes, _defineProperty({}, name, updatedCrane)));
    }, [liftsCranes, changePort]);

    var _React$useMemo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        if (!liftCrane.name) return { min: 0, max: 100 };

        var _liftCrane$name$split = liftCrane.name.split('-'),
            _liftCrane$name$split2 = _slicedToArray(_liftCrane$name$split, 2),
            minStr = _liftCrane$name$split2[0],
            maxStr = _liftCrane$name$split2[1];

        return {
            min: parseInt(minStr, 10) || 0,
            max: parseInt(maxStr, 10) || 100
        };
    }, [liftCrane.name]),
        min = _React$useMemo.min,
        max = _React$useMemo.max;

    var handleChangeDetails = function handleChangeDetails(updatedDetails) {
        changePort(_extends({}, liftsCranes, _defineProperty({}, liftCrane.name, _extends({}, liftCrane, {
            details: updatedDetails
        }))));
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'line-head' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12 middle-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["b" /* Checkbox */], {
                        name: 'liftsCranes.' + liftCrane.name + '.checked',
                        label: liftCrane.label,
                        labelStyle: styles.checkbox.labelStyle,
                        style: styles.checkbox.style,
                        onCheck: function onCheck(e, val) {
                            return handleChangeVal(val, liftCrane.name);
                        },
                        checked: liftCrane.checked
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: liftCrane.checked ? 'more' : 'hidden more',
                            onClick: toggleDetails
                        },
                        'More details'
                    ),
                    liftCrane.checked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                        {
                            iconStyle: styles.icon.iconStyle,
                            onClick: toggleDetails
                        },
                        showDetails ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_hardware_keyboard_arrow_up___default.a, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_hardware_keyboard_arrow_down___default.a, null)
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: showDetails && liftCrane.checked ? 'line-body' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Misc_Details__["a" /* default */], {
                details: liftCrane.details,
                onAdd: function onAdd(newDetail) {
                    var updatedDetails = [].concat(_toConsumableArray(liftCrane.details), [newDetail]);
                    handleChangeDetails(updatedDetails);
                },
                onEdit: function onEdit(editedDetail, index) {
                    var updatedDetails = [].concat(_toConsumableArray(liftCrane.details));
                    updatedDetails[index] = editedDetail;
                    handleChangeDetails(updatedDetails);
                },
                onDelete: function onDelete(index) {
                    var updatedDetails = liftCrane.details.filter(function (_, i) {
                        return i !== index;
                    });
                    handleChangeDetails(updatedDetails);
                },
                name: liftCrane.name,
                min: min,
                max: max
            })
        )
    );
};

LiftAndCranesItem.propTypes = {
    liftCrane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
    }).isRequired,
    liftsCranes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    changePort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesForm.jsx');
    reactHotLoader.register(LiftAndCranesForm, 'LiftAndCranesForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesForm.jsx');
    reactHotLoader.register(LiftAndCranesItem, 'LiftAndCranesItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesForm.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesForm.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddDetail__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditDetail__ = __webpack_require__(2346);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











var styles = {
    icon: { iconStyle: { color: '#00bcd4' } }
};

var Details = function Details(_ref) {
    var details = _ref.details,
        onAdd = _ref.onAdd,
        onEdit = _ref.onEdit,
        onDelete = _ref.onDelete,
        name = _ref.name,
        min = _ref.min,
        max = _ref.max;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        openEditDialog: false,
        openAddDialog: false,
        current: {
            detail: null,
            index: -1
        }
    }),
        _useState2 = _slicedToArray(_useState, 2),
        dialogState = _useState2[0],
        setDialogState = _useState2[1];

    var toggleAddDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        setDialogState(function (prev) {
            return _extends({}, prev, {
                openAddDialog: !prev.openAddDialog
            });
        });
    }, []);

    var toggleEditDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

        setDialogState(function (prev) {
            return _extends({}, prev, {
                openEditDialog: !prev.openEditDialog,
                current: { detail: detail, index: index }
            });
        });
    }, []);

    var handleAdd = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (newDetail) {
        onAdd(newDetail);
        toggleAddDialog();
    }, [onAdd, toggleAddDialog]);

    var handleEdit = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (editedDetail) {
        onEdit(editedDetail, dialogState.current.index);
        toggleEditDialog();
    }, [onEdit, toggleEditDialog]);

    var openEditDialog = dialogState.openEditDialog,
        openAddDialog = dialogState.openAddDialog,
        current = dialogState.current;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        details.map(function (detail, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                { key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item middle-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'count' },
                        detail.value,
                        ' mt'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name' },
                        detail.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'edit' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'icon edit-icon' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                                {
                                    iconStyle: styles.icon.iconStyle,
                                    onClick: function onClick() {
                                        return toggleEditDialog(detail, index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create___default.a, null)
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'icon delete-icon' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                                {
                                    iconStyle: styles.icon.iconStyle,
                                    onClick: function onClick() {
                                        return onDelete(index);
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete___default.a, null)
                            )
                        )
                    )
                )
            );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AddDetail__["a" /* default */], {
            open: openAddDialog,
            onClose: toggleAddDialog,
            onSubmit: handleAdd,
            name: name,
            min: min,
            max: max
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EditDetail__["a" /* default */], {
            open: openEditDialog,
            onClose: toggleEditDialog,
            onSubmit: handleEdit,
            detail: current.detail,
            name: name,
            min: min,
            max: max
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row add-capacity' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-9' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 middle-xs end-xs' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'text' },
                    'Add capacity'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                    {
                        iconStyle: styles.icon.iconStyle,
                        onClick: toggleAddDialog
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_image_control_point___default.a, null)
                )
            )
        )
    );
};

Details.propTypes = {
    details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired
    })).isRequired,
    onAdd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var _default = Details;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/Details.jsx');
    reactHotLoader.register(Details, 'Details', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/Details.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/Details.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var AddDetail = function AddDetail(_ref) {
    var open = _ref.open,
        onClose = _ref.onClose,
        onSubmit = _ref.onSubmit,
        name = _ref.name,
        min = _ref.min,
        max = _ref.max;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        name: '',
        value: ''
    }),
        _useState2 = _slicedToArray(_useState, 2),
        detail = _useState2[0],
        setDetail = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState4 = _slicedToArray(_useState3, 2),
        errors = _useState4[0],
        setErrors = _useState4[1];

    var validate = function validate(values) {
        var newErrors = {};
        if (!values.name) newErrors.name = 'Required';
        if (!values.value) newErrors.value = 'Required';

        var value = parseInt(values.value, 10);
        if (isNaN(value)) newErrors.value = 'Must be a number';
        if (value < min) newErrors.value = 'Minimum value is ' + min;
        if (value > max) newErrors.value = 'Maximum value is ' + max;

        return newErrors;
    };

    var handleChange = function handleChange(field) {
        return function (event) {
            var newDetail = _extends({}, detail, _defineProperty({}, field, event.target.value));

            var fieldErrors = validate(newDetail);
            setErrors(function (prev) {
                return _extends({}, prev, _defineProperty({}, field, fieldErrors[field] || ''));
            });

            setDetail(newDetail);
        };
    };

    var handleSubmit = function handleSubmit() {
        var newErrors = validate(detail);
        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            onSubmit(detail);
            setDetail({ name: '', value: '' });
        }
    };

    var handleClose = function handleClose() {
        setDetail({ name: '', value: '' });
        setErrors({});
        onClose();
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
        label: 'Cancel',
        onClick: handleClose
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
        label: 'Add',
        primary: true,
        onClick: handleSubmit
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
        {
            title: 'Add ' + name,
            actions: actions,
            modal: false,
            open: open,
            onRequestClose: handleClose
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                    floatingLabelText: 'Value',
                    value: detail.value,
                    onChange: handleChange('value'),
                    errorText: errors.value,
                    fullWidth: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                    floatingLabelText: 'Name',
                    value: detail.name,
                    onChange: handleChange('name'),
                    errorText: errors.name,
                    fullWidth: true
                })
            )
        )
    );
};

AddDetail.propTypes = {
    open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var _default = AddDetail;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AddDetail, 'AddDetail', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/AddDetail.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/AddDetail.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var EditDetail = function EditDetail(_ref) {
    var open = _ref.open,
        onClose = _ref.onClose,
        onSubmit = _ref.onSubmit,
        detail = _ref.detail,
        name = _ref.name,
        min = _ref.min,
        max = _ref.max;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
        name: '',
        value: ''
    }),
        _useState2 = _slicedToArray(_useState, 2),
        editedDetail = _useState2[0],
        setEditedDetail = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState4 = _slicedToArray(_useState3, 2),
        errors = _useState4[0],
        setErrors = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (detail) {
            setEditedDetail({
                name: detail.name || '',
                value: detail.value || ''
            });
        }
    }, [detail]);

    var handleChange = function handleChange(field) {
        return function (event) {
            setEditedDetail(function (prev) {
                return _extends({}, prev, _defineProperty({}, field, event.target.value));
            });
            setErrors(function (prev) {
                return _extends({}, prev, _defineProperty({}, field, ''));
            });
        };
    };

    var validate = function validate() {
        var newErrors = {};
        if (!editedDetail.name) newErrors.name = 'Required';
        if (!editedDetail.value) newErrors.value = 'Required';

        var value = parseInt(editedDetail.value);
        if (isNaN(value)) newErrors.value = 'Must be a number';
        if (value < min) newErrors.value = 'Minimum value is ' + min;
        if (value > max) newErrors.value = 'Maximum value is ' + max;

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    var handleSubmit = function handleSubmit() {
        if (validate()) {
            onSubmit(editedDetail);
        }
    };

    var handleClose = function handleClose() {
        setErrors({});
        onClose();
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
        label: 'Cancel',
        onClick: handleClose
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_FlatButton___default.a, {
        label: 'Update',
        primary: true,
        onClick: handleSubmit
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
        {
            title: 'Edit ' + name,
            actions: actions,
            modal: false,
            open: open,
            onRequestClose: handleClose
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                    floatingLabelText: 'Value',
                    value: editedDetail.value,
                    onChange: handleChange('value'),
                    errorText: errors.value,
                    fullWidth: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                    floatingLabelText: 'Name',
                    value: editedDetail.name,
                    onChange: handleChange('name'),
                    errorText: errors.name,
                    fullWidth: true
                })
            )
        )
    );
};

EditDetail.propTypes = {
    open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    detail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
    }),
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var _default = EditDetail;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(EditDetail, 'EditDetail', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/EditDetail.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/EditDetail.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__(105);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






var LiftAndCranesView = function LiftAndCranesView(_ref) {
    var liftsCranes = _ref.liftsCranes;

    var items = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        return Object.entries(liftsCranes).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];

            return _extends({}, value, {
                name: key,
                label: key + ' mt:'
            });
        });
    }, [liftsCranes]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'lift-and-cranes', style: { margin: 'unset' } },
            items.map(function (liftCrane, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LiftAndCranesItem, {
                    key: '' + (liftCrane.id || index),
                    liftCrane: liftCrane
                });
            })
        )
    );
};

LiftAndCranesView.propTypes = {
    liftsCranes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var _default = LiftAndCranesView;
/* harmony default export */ __webpack_exports__["a"] = (_default);

var LiftAndCranesItem = function LiftAndCranesItem(_ref4) {
    var liftCrane = _ref4.liftCrane;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'line-head' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12 middle-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["b" /* Checkbox */], {
                        name: 'liftsCranes.' + liftCrane.name + '.checked',
                        label: liftCrane.label,
                        labelStyle: { fontSize: '14px' },
                        style: { width: '750px' },
                        disabled: true,
                        checked: liftCrane.checked
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'line-body' },
            liftCrane.details.map(function (detail, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    { key: index },
                    (detail.status === 'new' || detail.status === 'normal') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: detail.status === 'new' ? 'item middle-xs dirty-element' : 'item middle-xs ' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'count' },
                            detail ? detail.value : '',
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name' },
                            detail ? detail.name : ''
                        )
                    ),
                    detail.status === 'remove' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item middle-xs dirty-element' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'count' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.value : '',
                                newValue: null
                            }),
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.name : '',
                                newValue: null
                            })
                        )
                    ),
                    detail.status === 'change' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item middle-xs dirty-element' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'count' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.value : '',
                                newValue: detail.changes.value ? detail.changes.value : ''
                            }),
                            ' mt'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_utils__["a" /* CheckDiffText */], {
                                oldValue: detail ? detail.name : '',
                                newValue: detail.changes.name ? detail.changes.name : ''
                            })
                        )
                    )
                );
            })
        )
    );
};

LiftAndCranesItem.propTypes = {
    liftCrane: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    port: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    newPort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

LiftAndCranesItem.defaultProps = {
    liftCrane: {},
    port: {},
    newPort: {}
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LiftAndCranesView, 'LiftAndCranesView', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesView.jsx');
    reactHotLoader.register(LiftAndCranesItem, 'LiftAndCranesItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesView.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesView.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128653
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ServiceProvider__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Regions_Port_ServiceProviders_ServiceProvidersHistoryDialog__ = __webpack_require__(3256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








var ServiceProviders = function ServiceProviders(_ref) {
    var serviceProviders = _ref.serviceProviders,
        rejectServiceProvider = _ref.rejectServiceProvider,
        approveServiceProvider = _ref.approveServiceProvider;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openHistoryDialog = _useState2[0],
        setOpenHistoryDialog = _useState2[1];

    var toggleHistoryDialog = function toggleHistoryDialog() {
        setOpenHistoryDialog(!openHistoryDialog);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'main__title row', style: { margin: 0, display: 'flex', flexDirection: 'row-reverse' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-1' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["h" /* IconButton */],
                    { onClick: toggleHistoryDialog },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons__["ActionHistory"], { color: '#B3B3B3' })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'service-providers' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table', style: { margin: '0 0 70px 0' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col' },
                            'Activity'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col' },
                            'Company Name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col' },
                            'Contact Details'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    serviceProviders.map(function (serviceProvider, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ServiceProvider__["a" /* default */], {
                            key: 'service-provider-' + index,
                            serviceProvider: serviceProvider,
                            rejectServiceProvider: rejectServiceProvider,
                            approveServiceProvider: approveServiceProvider
                        });
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Regions_Port_ServiceProviders_ServiceProvidersHistoryDialog__["a" /* default */], {
                open: openHistoryDialog,
                toggle: toggleHistoryDialog
            })
        )
    );
};

ServiceProviders.propTypes = {
    serviceProviders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    rejectServiceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    approveServiceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

ServiceProviders.defaultProps = {
    serviceProviders: [],
    rejectServiceProvider: function rejectServiceProvider() {},
    approveServiceProvider: function approveServiceProvider() {}
};

var _default = ServiceProviders;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ServiceProviders, 'ServiceProviders', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/Component.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/Component.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StevedoringData__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_ports__ = __webpack_require__(554);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











var styles = {
    btnBack: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' }
    },
    btnSubmit: {
        labelStyle: { color: '#fff', textTransform: 'none', fontSize: '13px' },
        style: { margin: '20px 0 70px 0' }
    }
};

var ShowDiffEmails = function ShowDiffEmails(_ref) {
    var _ref$emails = _ref.emails,
        emails = _ref$emails === undefined ? [] : _ref$emails,
        _ref$providerEmails = _ref.providerEmails,
        providerEmails = _ref$providerEmails === undefined ? [] : _ref$providerEmails;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        emails.map(function (email, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: i, className: 'phone' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                    newValue: providerEmails[i],
                    oldValue: email
                })
            );
        }),
        providerEmails.slice(emails.length).map(function (email, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'new-' + i, className: 'email' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                    newValue: email,
                    oldValue: null
                })
            );
        })
    );
};

var ShowDiffPhones = function ShowDiffPhones(_ref2) {
    var _ref2$phones = _ref2.phones,
        phones = _ref2$phones === undefined ? [] : _ref2$phones,
        _ref2$providerPhones = _ref2.providerPhones,
        providerPhones = _ref2$providerPhones === undefined ? [] : _ref2$providerPhones;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        phones.map(function (phone, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: i, className: 'phone' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                    newValue: providerPhones[i] ? providerPhones[i].code : null,
                    oldValue: phone.code
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                    newValue: providerPhones[i] ? providerPhones[i].phone : null,
                    oldValue: phone.phone
                })
            );
        }),
        providerPhones.slice(phones.length).map(function (phone, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'new-' + i, className: 'phone' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                    newValue: phone.code,
                    oldValue: null
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                    newValue: phone.phone,
                    oldValue: null
                })
            );
        })
    );
};

var ActionButtons = function ActionButtons(_ref3) {
    var onApprove = _ref3.onApprove,
        onReject = _ref3.onReject;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'column', gap: '10px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                label: 'Approve',
                labelStyle: styles.btnSubmit.labelStyle,
                labelPosition: 'before',
                backgroundColor: '#a4c639',
                onClick: onApprove
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                label: 'Reject',
                labelStyle: styles.btnSubmit.labelStyle,
                labelPosition: 'before',
                backgroundColor: '#f00',
                onClick: onReject
            })
        )
    );
};

var ServiceProvider = function ServiceProvider(_ref4) {
    var serviceProvider = _ref4.serviceProvider,
        rejectServiceProvider = _ref4.rejectServiceProvider,
        approveServiceProvider = _ref4.approveServiceProvider;

    var isChanged = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        if (serviceProvider.status === 'remove') return true;
        if (serviceProvider.status !== 'change') return false;

        var changes = [[serviceProvider.provider.activities.join(','), serviceProvider.activities.join(',')], [serviceProvider.provider.name, serviceProvider.name], [serviceProvider.emails, serviceProvider.provider.emails], [serviceProvider.phones, serviceProvider.provider.phones], [serviceProvider.provider.address, serviceProvider.address], [serviceProvider.provider.PIC, serviceProvider.PIC], [serviceProvider.provider.limitations, serviceProvider.limitations]];

        return changes.some(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                newValue = _ref6[0],
                oldValue = _ref6[1];

            return !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(newValue, oldValue);
        });
    }, [serviceProvider]);

    var isStevedoring = function isStevedoring(activities) {
        return activities.includes('Stevedoring Company');
    };

    var renderChangeView = function renderChangeView() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    isStevedoring(serviceProvider.activities) || isStevedoring(serviceProvider.provider.activities) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StevedoringData__["a" /* default */], { serviceProvider: serviceProvider }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: serviceProvider.provider.activities.join(','),
                        oldValue: serviceProvider.activities.join(',')
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name company' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: serviceProvider.provider.name,
                        oldValue: serviceProvider.name
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShowDiffEmails, {
                        emails: serviceProvider.emails,
                        providerEmails: serviceProvider.provider.emails
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShowDiffPhones, {
                        phones: serviceProvider.phones,
                        providerPhones: serviceProvider.provider.phones
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: serviceProvider.provider.address,
                        oldValue: serviceProvider.address
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    'PIC:',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: serviceProvider.provider.PIC,
                        oldValue: serviceProvider.PIC
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'table-col edit',
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        width: '122px'
                    }
                },
                serviceProvider.recommended && serviceProvider.recommended.endAt ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["c" /* Chip */],
                    {
                        style: {
                            backgroundColor: '#E8F5E9',
                            height: 24,
                            position: 'absolute',
                            top: 10,
                            right: 0,
                            zIndex: 1000,
                            width: 118
                        },
                        labelStyle: {
                            color: '#2E7D32',
                            lineHeight: '24px',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center'
                        }
                    },
                    'Recommended',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                        {
                            tooltip: Object(__WEBPACK_IMPORTED_MODULE_7_helpers_ports__["a" /* getRecommendedTitle */])(serviceProvider) // no import for now
                            , tooltipPosition: 'bottom-left',
                            style: {
                                width: 20,
                                height: 18,
                                padding: 0
                            },
                            iconStyle: { width: 16, height: 16, color: '#2E7D32' }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info___default.a, null)
                    )
                ) : null,
                isChanged && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionButtons, {
                    onApprove: function onApprove() {
                        return approveServiceProvider(serviceProvider);
                    },
                    onReject: function onReject() {
                        return rejectServiceProvider(serviceProvider);
                    }
                })
            )
        );
    };

    var renderRemoveView = function renderRemoveView() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-row dirty-element' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    isStevedoring(serviceProvider.activities) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StevedoringData__["a" /* default */], { serviceProvider: serviceProvider }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: null,
                        oldValue: serviceProvider.activities
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name company' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: null,
                        oldValue: serviceProvider.name
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list' },
                    serviceProvider.emails.map(function (email, emailIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: emailIndex, className: 'email' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                                newValue: null,
                                oldValue: email
                            })
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list' },
                    serviceProvider.phones.map(function (phone, phoneIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: phoneIndex, className: 'phone' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                                newValue: null,
                                oldValue: phone.code
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                                newValue: null,
                                oldValue: phone.phone
                            })
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: null,
                        oldValue: serviceProvider.address
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    'PIC:',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* CheckDiffText */], {
                        newValue: null,
                        oldValue: serviceProvider.PIC
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col edit' },
                isChanged && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionButtons, {
                    onApprove: function onApprove() {
                        return approveServiceProvider(serviceProvider, { isRemove: true });
                    },
                    onReject: function onReject() {
                        return rejectServiceProvider(serviceProvider, { isRemove: true });
                    }
                })
            )
        );
    };

    var renderNormalView = function renderNormalView() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: serviceProvider.status === 'new' ? 'dirty-element table-row' : 'table-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    isStevedoring(serviceProvider.activities) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StevedoringData__["a" /* default */], { serviceProvider: serviceProvider }) : serviceProvider.activities.join(',')
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name company' },
                    serviceProvider.name
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list' },
                    serviceProvider.emails.map(function (email, emailIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: emailIndex, className: 'email' },
                            email
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'list' },
                    serviceProvider.phones.map(function (phone, phoneIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: phoneIndex, className: 'phone' },
                            phone.code + ' ' + phone.phone
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    serviceProvider.address
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name' },
                    'PIC: ',
                    serviceProvider.PIC
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-col edit' },
                serviceProvider.status === 'new' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionButtons, {
                    onApprove: function onApprove() {
                        return approveServiceProvider(serviceProvider, { isNew: true });
                    },
                    onReject: function onReject() {
                        return rejectServiceProvider(serviceProvider, { isNew: true });
                    }
                })
            )
        );
    };

    switch (serviceProvider.status) {
        case 'change':
            return renderChangeView();
        case 'remove':
            return renderRemoveView();
        case 'normal':
        case 'new':
            return renderNormalView();
        default:
            return null;
    }
};

ServiceProvider.propTypes = {
    serviceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['change', 'remove', 'normal', 'new']).isRequired,
        activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        emails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
        phones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
            phone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
        })).isRequired,
        address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        PIC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        provider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
            name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
            emails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
            phones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
                code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
                phone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
            })).isRequired,
            address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
            PIC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
        })
    }).isRequired,
    rejectServiceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    approveServiceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = ServiceProvider;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/ServiceProvider.jsx');
    reactHotLoader.register(ShowDiffEmails, 'ShowDiffEmails', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/ServiceProvider.jsx');
    reactHotLoader.register(ShowDiffPhones, 'ShowDiffPhones', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/ServiceProvider.jsx');
    reactHotLoader.register(ActionButtons, 'ActionButtons', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/ServiceProvider.jsx');
    reactHotLoader.register(ServiceProvider, 'ServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/ServiceProvider.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/ServiceProvider.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__(105);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var StevedoringData = function StevedoringData(_ref) {
    var serviceProvider = _ref.serviceProvider;

    var shouldMap = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        if (serviceProvider.provider && serviceProvider.provider.limitations && serviceProvider.provider.limitations.length > serviceProvider.limitations.length) {
            return serviceProvider.provider.limitations;
        }
        return serviceProvider.limitations;
    }, [serviceProvider]);

    var renderNormalView = function renderNormalView() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block', style: { backgroundColor: 'inherit' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'title' },
                serviceProvider.activities.join(',')
            ),
            serviceProvider.limitations.map(function (limitation, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'limitations',
                        key: 'Limitation: ' + (index + 1)
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Limitation: ' + (index + 1)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Berth ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { wordBreak: 'break-all', display: 'inline' } },
                            limitation.berth
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max draft ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            limitation.maxDraught,
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max beam ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            limitation.maxBeam,
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max LOA ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            limitation.maxLOA,
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max DWT ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            limitation.maxDWT,
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Channel depth ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            limitation.channelDepth,
                            ' m'
                        )
                    )
                );
            })
        );
    };

    var renderRemoveView = function renderRemoveView() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'title' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                    oldValue: serviceProvider.activities.join(','),
                    newValue: null
                })
            ),
            serviceProvider.limitations.map(function (limitation, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'limitations',
                        key: 'Limitation: ' + (index + 1)
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Limitation: ' + (index + 1)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Berth ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: limitation.berth,
                                newValue: null
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max draft ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: limitation.maxDraught,
                                newValue: null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max beam ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: limitation.maxBeam,
                                newValue: null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max LOA ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: limitation.maxLOA,
                                newValue: null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max DWT ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: limitation.maxDWT,
                                newValue: null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Channel depth ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: limitation.channelDepth,
                                newValue: null
                            }),
                            ' m'
                        )
                    )
                );
            })
        );
    };

    var renderChangeView = function renderChangeView() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'paper-block', style: { backgroundColor: 'inherit' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'title' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                    oldValue: serviceProvider.activities.join(','),
                    newValue: (serviceProvider.provider.activities || []).join(',')
                })
            ),
            shouldMap.map(function (_, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'limitations',
                        key: 'Limitation: ' + (index + 1)
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Limitation: ' + (index + 1)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Berth ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { wordBreak: 'break-all', display: 'inline' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: serviceProvider.limitations[index] && serviceProvider.limitations[index].berth || '',
                                newValue: serviceProvider.provider.limitations[index] && serviceProvider.provider.limitations[index].berth || null
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max draft ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: serviceProvider.limitations[index] && serviceProvider.limitations[index].maxDraught || '',
                                newValue: serviceProvider.provider.limitations[index] && serviceProvider.provider.limitations[index].maxDraught || null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max beam ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: serviceProvider.limitations[index] && serviceProvider.limitations[index].maxBeam || '',
                                newValue: serviceProvider.provider.limitations[index] && serviceProvider.provider.limitations[index].maxBeam || null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max LOA ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: serviceProvider.limitations[index] && serviceProvider.limitations[index].maxLOA || '',
                                newValue: serviceProvider.provider.limitations[index] && serviceProvider.provider.limitations[index].maxLOA || null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Max DWT ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: serviceProvider.limitations[index] && serviceProvider.limitations[index].maxDWT || '',
                                newValue: serviceProvider.provider.limitations[index] && serviceProvider.provider.limitations[index].maxDWT || null
                            }),
                            ' m'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitation' },
                        'Channel depth ',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_utils__["a" /* CheckDiffText */], {
                                oldValue: serviceProvider.limitations[index] && serviceProvider.limitations[index].channelDepth || '',
                                newValue: serviceProvider.provider.limitations[index] && serviceProvider.provider.limitations[index].channelDepth || null
                            }),
                            ' m'
                        )
                    )
                );
            })
        );
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        (serviceProvider.status === 'new' || serviceProvider.status === 'normal') && renderNormalView(),
        serviceProvider.status === 'remove' && renderRemoveView(),
        serviceProvider.status === 'change' && renderChangeView()
    );
};

StevedoringData.propTypes = {
    serviceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['new', 'normal', 'remove', 'change']).isRequired,
        activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
        limitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            berth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxDraught: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxBeam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxLOA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxDWT: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            channelDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        })).isRequired,
        provider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
            limitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
        })
    }).isRequired
};

var _default = StevedoringData;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StevedoringData, 'StevedoringData', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/StevedoringData.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/StevedoringData.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAccessibility = function ActionAccessibility(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z' })
  );
};
ActionAccessibility = (0, _pure2.default)(ActionAccessibility);
ActionAccessibility.displayName = 'ActionAccessibility';
ActionAccessibility.muiName = 'SvgIcon';

exports.default = ActionAccessibility;

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAccessible = function ActionAccessible(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '4', r: '2' }),
    _react2.default.createElement('path', { d: 'M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z' })
  );
};
ActionAccessible = (0, _pure2.default)(ActionAccessible);
ActionAccessible.displayName = 'ActionAccessible';
ActionAccessible.muiName = 'SvgIcon';

exports.default = ActionAccessible;

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAccountBalanceWallet = function ActionAccountBalanceWallet(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
ActionAccountBalanceWallet = (0, _pure2.default)(ActionAccountBalanceWallet);
ActionAccountBalanceWallet.displayName = 'ActionAccountBalanceWallet';
ActionAccountBalanceWallet.muiName = 'SvgIcon';

exports.default = ActionAccountBalanceWallet;

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAccountBalance = function ActionAccountBalance(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z' })
  );
};
ActionAccountBalance = (0, _pure2.default)(ActionAccountBalance);
ActionAccountBalance.displayName = 'ActionAccountBalance';
ActionAccountBalance.muiName = 'SvgIcon';

exports.default = ActionAccountBalance;

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAccountBox = function ActionAccountBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z' })
  );
};
ActionAccountBox = (0, _pure2.default)(ActionAccountBox);
ActionAccountBox.displayName = 'ActionAccountBox';
ActionAccountBox.muiName = 'SvgIcon';

exports.default = ActionAccountBox;

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAccountCircle = function ActionAccountCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
  );
};
ActionAccountCircle = (0, _pure2.default)(ActionAccountCircle);
ActionAccountCircle.displayName = 'ActionAccountCircle';
ActionAccountCircle.muiName = 'SvgIcon';

exports.default = ActionAccountCircle;

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAddShoppingCart = function ActionAddShoppingCart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z' })
  );
};
ActionAddShoppingCart = (0, _pure2.default)(ActionAddShoppingCart);
ActionAddShoppingCart.displayName = 'ActionAddShoppingCart';
ActionAddShoppingCart.muiName = 'SvgIcon';

exports.default = ActionAddShoppingCart;

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAlarmAdd = function ActionAlarmAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
  );
};
ActionAlarmAdd = (0, _pure2.default)(ActionAlarmAdd);
ActionAlarmAdd.displayName = 'ActionAlarmAdd';
ActionAlarmAdd.muiName = 'SvgIcon';

exports.default = ActionAlarmAdd;

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAlarmOff = function ActionAlarmOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z' })
  );
};
ActionAlarmOff = (0, _pure2.default)(ActionAlarmOff);
ActionAlarmOff.displayName = 'ActionAlarmOff';
ActionAlarmOff.muiName = 'SvgIcon';

exports.default = ActionAlarmOff;

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAlarmOn = function ActionAlarmOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z' })
  );
};
ActionAlarmOn = (0, _pure2.default)(ActionAlarmOn);
ActionAlarmOn.displayName = 'ActionAlarmOn';
ActionAlarmOn.muiName = 'SvgIcon';

exports.default = ActionAlarmOn;

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAlarm = function ActionAlarm(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
ActionAlarm = (0, _pure2.default)(ActionAlarm);
ActionAlarm.displayName = 'ActionAlarm';
ActionAlarm.muiName = 'SvgIcon';

exports.default = ActionAlarm;

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAllOut = function ActionAllOut(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z' })
  );
};
ActionAllOut = (0, _pure2.default)(ActionAllOut);
ActionAllOut.displayName = 'ActionAllOut';
ActionAllOut.muiName = 'SvgIcon';

exports.default = ActionAllOut;

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAndroid = function ActionAndroid(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z' })
  );
};
ActionAndroid = (0, _pure2.default)(ActionAndroid);
ActionAndroid.displayName = 'ActionAndroid';
ActionAndroid.muiName = 'SvgIcon';

exports.default = ActionAndroid;

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAnnouncement = function ActionAnnouncement(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z' })
  );
};
ActionAnnouncement = (0, _pure2.default)(ActionAnnouncement);
ActionAnnouncement.displayName = 'ActionAnnouncement';
ActionAnnouncement.muiName = 'SvgIcon';

exports.default = ActionAnnouncement;

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAspectRatio = function ActionAspectRatio(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
  );
};
ActionAspectRatio = (0, _pure2.default)(ActionAspectRatio);
ActionAspectRatio.displayName = 'ActionAspectRatio';
ActionAspectRatio.muiName = 'SvgIcon';

exports.default = ActionAspectRatio;

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssessment = function ActionAssessment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
  );
};
ActionAssessment = (0, _pure2.default)(ActionAssessment);
ActionAssessment.displayName = 'ActionAssessment';
ActionAssessment.muiName = 'SvgIcon';

exports.default = ActionAssessment;

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignmentInd = function ActionAssignmentInd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z' })
  );
};
ActionAssignmentInd = (0, _pure2.default)(ActionAssignmentInd);
ActionAssignmentInd.displayName = 'ActionAssignmentInd';
ActionAssignmentInd.muiName = 'SvgIcon';

exports.default = ActionAssignmentInd;

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignmentLate = function ActionAssignmentLate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
  );
};
ActionAssignmentLate = (0, _pure2.default)(ActionAssignmentLate);
ActionAssignmentLate.displayName = 'ActionAssignmentLate';
ActionAssignmentLate.muiName = 'SvgIcon';

exports.default = ActionAssignmentLate;

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignmentReturn = function ActionAssignmentReturn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z' })
  );
};
ActionAssignmentReturn = (0, _pure2.default)(ActionAssignmentReturn);
ActionAssignmentReturn.displayName = 'ActionAssignmentReturn';
ActionAssignmentReturn.muiName = 'SvgIcon';

exports.default = ActionAssignmentReturn;

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignmentReturned = function ActionAssignmentReturned(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z' })
  );
};
ActionAssignmentReturned = (0, _pure2.default)(ActionAssignmentReturned);
ActionAssignmentReturned.displayName = 'ActionAssignmentReturned';
ActionAssignmentReturned.muiName = 'SvgIcon';

exports.default = ActionAssignmentReturned;

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignmentTurnedIn = function ActionAssignmentTurnedIn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
  );
};
ActionAssignmentTurnedIn = (0, _pure2.default)(ActionAssignmentTurnedIn);
ActionAssignmentTurnedIn.displayName = 'ActionAssignmentTurnedIn';
ActionAssignmentTurnedIn.muiName = 'SvgIcon';

exports.default = ActionAssignmentTurnedIn;

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignment = function ActionAssignment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z' })
  );
};
ActionAssignment = (0, _pure2.default)(ActionAssignment);
ActionAssignment.displayName = 'ActionAssignment';
ActionAssignment.muiName = 'SvgIcon';

exports.default = ActionAssignment;

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAutorenew = function ActionAutorenew(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' })
  );
};
ActionAutorenew = (0, _pure2.default)(ActionAutorenew);
ActionAutorenew.displayName = 'ActionAutorenew';
ActionAutorenew.muiName = 'SvgIcon';

exports.default = ActionAutorenew;

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBackup = function ActionBackup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
  );
};
ActionBackup = (0, _pure2.default)(ActionBackup);
ActionBackup.displayName = 'ActionBackup';
ActionBackup.muiName = 'SvgIcon';

exports.default = ActionBackup;

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBook = function ActionBook(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
  );
};
ActionBook = (0, _pure2.default)(ActionBook);
ActionBook.displayName = 'ActionBook';
ActionBook.muiName = 'SvgIcon';

exports.default = ActionBook;

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBookmarkBorder = function ActionBookmarkBorder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
  );
};
ActionBookmarkBorder = (0, _pure2.default)(ActionBookmarkBorder);
ActionBookmarkBorder.displayName = 'ActionBookmarkBorder';
ActionBookmarkBorder.muiName = 'SvgIcon';

exports.default = ActionBookmarkBorder;

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBookmark = function ActionBookmark(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
  );
};
ActionBookmark = (0, _pure2.default)(ActionBookmark);
ActionBookmark.displayName = 'ActionBookmark';
ActionBookmark.muiName = 'SvgIcon';

exports.default = ActionBookmark;

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBugReport = function ActionBugReport(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z' })
  );
};
ActionBugReport = (0, _pure2.default)(ActionBugReport);
ActionBugReport.displayName = 'ActionBugReport';
ActionBugReport.muiName = 'SvgIcon';

exports.default = ActionBugReport;

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBuild = function ActionBuild(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z' })
  );
};
ActionBuild = (0, _pure2.default)(ActionBuild);
ActionBuild.displayName = 'ActionBuild';
ActionBuild.muiName = 'SvgIcon';

exports.default = ActionBuild;

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCameraEnhance = function ActionCameraEnhance(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z' })
  );
};
ActionCameraEnhance = (0, _pure2.default)(ActionCameraEnhance);
ActionCameraEnhance.displayName = 'ActionCameraEnhance';
ActionCameraEnhance.muiName = 'SvgIcon';

exports.default = ActionCameraEnhance;

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCardGiftcard = function ActionCardGiftcard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
  );
};
ActionCardGiftcard = (0, _pure2.default)(ActionCardGiftcard);
ActionCardGiftcard.displayName = 'ActionCardGiftcard';
ActionCardGiftcard.muiName = 'SvgIcon';

exports.default = ActionCardGiftcard;

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCardMembership = function ActionCardMembership(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z' })
  );
};
ActionCardMembership = (0, _pure2.default)(ActionCardMembership);
ActionCardMembership.displayName = 'ActionCardMembership';
ActionCardMembership.muiName = 'SvgIcon';

exports.default = ActionCardMembership;

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCardTravel = function ActionCardTravel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z' })
  );
};
ActionCardTravel = (0, _pure2.default)(ActionCardTravel);
ActionCardTravel.displayName = 'ActionCardTravel';
ActionCardTravel.muiName = 'SvgIcon';

exports.default = ActionCardTravel;

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionChangeHistory = function ActionChangeHistory(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z' })
  );
};
ActionChangeHistory = (0, _pure2.default)(ActionChangeHistory);
ActionChangeHistory.displayName = 'ActionChangeHistory';
ActionChangeHistory.muiName = 'SvgIcon';

exports.default = ActionChangeHistory;

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionChromeReaderMode = function ActionChromeReaderMode(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z' })
  );
};
ActionChromeReaderMode = (0, _pure2.default)(ActionChromeReaderMode);
ActionChromeReaderMode.displayName = 'ActionChromeReaderMode';
ActionChromeReaderMode.muiName = 'SvgIcon';

exports.default = ActionChromeReaderMode;

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionClass = function ActionClass(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
  );
};
ActionClass = (0, _pure2.default)(ActionClass);
ActionClass.displayName = 'ActionClass';
ActionClass.muiName = 'SvgIcon';

exports.default = ActionClass;

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCode = function ActionCode(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
  );
};
ActionCode = (0, _pure2.default)(ActionCode);
ActionCode.displayName = 'ActionCode';
ActionCode.muiName = 'SvgIcon';

exports.default = ActionCode;

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCompareArrows = function ActionCompareArrows(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z' })
  );
};
ActionCompareArrows = (0, _pure2.default)(ActionCompareArrows);
ActionCompareArrows.displayName = 'ActionCompareArrows';
ActionCompareArrows.muiName = 'SvgIcon';

exports.default = ActionCompareArrows;

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCopyright = function ActionCopyright(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ActionCopyright = (0, _pure2.default)(ActionCopyright);
ActionCopyright.displayName = 'ActionCopyright';
ActionCopyright.muiName = 'SvgIcon';

exports.default = ActionCopyright;

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCreditCard = function ActionCreditCard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
  );
};
ActionCreditCard = (0, _pure2.default)(ActionCreditCard);
ActionCreditCard.displayName = 'ActionCreditCard';
ActionCreditCard.muiName = 'SvgIcon';

exports.default = ActionCreditCard;

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDashboard = function ActionDashboard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' })
  );
};
ActionDashboard = (0, _pure2.default)(ActionDashboard);
ActionDashboard.displayName = 'ActionDashboard';
ActionDashboard.muiName = 'SvgIcon';

exports.default = ActionDashboard;

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDateRange = function ActionDateRange(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z' })
  );
};
ActionDateRange = (0, _pure2.default)(ActionDateRange);
ActionDateRange.displayName = 'ActionDateRange';
ActionDateRange.muiName = 'SvgIcon';

exports.default = ActionDateRange;

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDeleteForever = function ActionDeleteForever(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z' })
  );
};
ActionDeleteForever = (0, _pure2.default)(ActionDeleteForever);
ActionDeleteForever.displayName = 'ActionDeleteForever';
ActionDeleteForever.muiName = 'SvgIcon';

exports.default = ActionDeleteForever;

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDns = function ActionDns(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
ActionDns = (0, _pure2.default)(ActionDns);
ActionDns.displayName = 'ActionDns';
ActionDns.muiName = 'SvgIcon';

exports.default = ActionDns;

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDonutLarge = function ActionDonutLarge(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z' })
  );
};
ActionDonutLarge = (0, _pure2.default)(ActionDonutLarge);
ActionDonutLarge.displayName = 'ActionDonutLarge';
ActionDonutLarge.muiName = 'SvgIcon';

exports.default = ActionDonutLarge;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDonutSmall = function ActionDonutSmall(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z' })
  );
};
ActionDonutSmall = (0, _pure2.default)(ActionDonutSmall);
ActionDonutSmall.displayName = 'ActionDonutSmall';
ActionDonutSmall.muiName = 'SvgIcon';

exports.default = ActionDonutSmall;

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionEject = function ActionEject(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 17h14v2H5zm7-12L5.33 15h13.34z' })
  );
};
ActionEject = (0, _pure2.default)(ActionEject);
ActionEject.displayName = 'ActionEject';
ActionEject.muiName = 'SvgIcon';

exports.default = ActionEject;

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionEuroSymbol = function ActionEuroSymbol(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z' })
  );
};
ActionEuroSymbol = (0, _pure2.default)(ActionEuroSymbol);
ActionEuroSymbol.displayName = 'ActionEuroSymbol';
ActionEuroSymbol.muiName = 'SvgIcon';

exports.default = ActionEuroSymbol;

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionEventSeat = function ActionEventSeat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z' })
  );
};
ActionEventSeat = (0, _pure2.default)(ActionEventSeat);
ActionEventSeat.displayName = 'ActionEventSeat';
ActionEventSeat.muiName = 'SvgIcon';

exports.default = ActionEventSeat;

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionEvent = function ActionEvent(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
  );
};
ActionEvent = (0, _pure2.default)(ActionEvent);
ActionEvent.displayName = 'ActionEvent';
ActionEvent.muiName = 'SvgIcon';

exports.default = ActionEvent;

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionExitToApp = function ActionExitToApp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
ActionExitToApp = (0, _pure2.default)(ActionExitToApp);
ActionExitToApp.displayName = 'ActionExitToApp';
ActionExitToApp.muiName = 'SvgIcon';

exports.default = ActionExitToApp;

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionExplore = function ActionExplore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' })
  );
};
ActionExplore = (0, _pure2.default)(ActionExplore);
ActionExplore.displayName = 'ActionExplore';
ActionExplore.muiName = 'SvgIcon';

exports.default = ActionExplore;

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionExtension = function ActionExtension(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' })
  );
};
ActionExtension = (0, _pure2.default)(ActionExtension);
ActionExtension.displayName = 'ActionExtension';
ActionExtension.muiName = 'SvgIcon';

exports.default = ActionExtension;

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFace = function ActionFace(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z' })
  );
};
ActionFace = (0, _pure2.default)(ActionFace);
ActionFace.displayName = 'ActionFace';
ActionFace.muiName = 'SvgIcon';

exports.default = ActionFace;

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFavoriteBorder = function ActionFavoriteBorder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z' })
  );
};
ActionFavoriteBorder = (0, _pure2.default)(ActionFavoriteBorder);
ActionFavoriteBorder.displayName = 'ActionFavoriteBorder';
ActionFavoriteBorder.muiName = 'SvgIcon';

exports.default = ActionFavoriteBorder;

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFavorite = function ActionFavorite(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' })
  );
};
ActionFavorite = (0, _pure2.default)(ActionFavorite);
ActionFavorite.displayName = 'ActionFavorite';
ActionFavorite.muiName = 'SvgIcon';

exports.default = ActionFavorite;

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFeedback = function ActionFeedback(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
  );
};
ActionFeedback = (0, _pure2.default)(ActionFeedback);
ActionFeedback.displayName = 'ActionFeedback';
ActionFeedback.muiName = 'SvgIcon';

exports.default = ActionFeedback;

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFindInPage = function ActionFindInPage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z' })
  );
};
ActionFindInPage = (0, _pure2.default)(ActionFindInPage);
ActionFindInPage.displayName = 'ActionFindInPage';
ActionFindInPage.muiName = 'SvgIcon';

exports.default = ActionFindInPage;

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFindReplace = function ActionFindReplace(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z' })
  );
};
ActionFindReplace = (0, _pure2.default)(ActionFindReplace);
ActionFindReplace.displayName = 'ActionFindReplace';
ActionFindReplace.muiName = 'SvgIcon';

exports.default = ActionFindReplace;

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFingerprint = function ActionFingerprint(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z' })
  );
};
ActionFingerprint = (0, _pure2.default)(ActionFingerprint);
ActionFingerprint.displayName = 'ActionFingerprint';
ActionFingerprint.muiName = 'SvgIcon';

exports.default = ActionFingerprint;

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFlightLand = function ActionFlightLand(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z' })
  );
};
ActionFlightLand = (0, _pure2.default)(ActionFlightLand);
ActionFlightLand.displayName = 'ActionFlightLand';
ActionFlightLand.muiName = 'SvgIcon';

exports.default = ActionFlightLand;

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFlightTakeoff = function ActionFlightTakeoff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z' })
  );
};
ActionFlightTakeoff = (0, _pure2.default)(ActionFlightTakeoff);
ActionFlightTakeoff.displayName = 'ActionFlightTakeoff';
ActionFlightTakeoff.muiName = 'SvgIcon';

exports.default = ActionFlightTakeoff;

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFlipToBack = function ActionFlipToBack(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z' })
  );
};
ActionFlipToBack = (0, _pure2.default)(ActionFlipToBack);
ActionFlipToBack.displayName = 'ActionFlipToBack';
ActionFlipToBack.muiName = 'SvgIcon';

exports.default = ActionFlipToBack;

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionFlipToFront = function ActionFlipToFront(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z' })
  );
};
ActionFlipToFront = (0, _pure2.default)(ActionFlipToFront);
ActionFlipToFront.displayName = 'ActionFlipToFront';
ActionFlipToFront.muiName = 'SvgIcon';

exports.default = ActionFlipToFront;

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGTranslate = function ActionGTranslate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z' })
  );
};
ActionGTranslate = (0, _pure2.default)(ActionGTranslate);
ActionGTranslate.displayName = 'ActionGTranslate';
ActionGTranslate.muiName = 'SvgIcon';

exports.default = ActionGTranslate;

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGavel = function ActionGavel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z' })
  );
};
ActionGavel = (0, _pure2.default)(ActionGavel);
ActionGavel.displayName = 'ActionGavel';
ActionGavel.muiName = 'SvgIcon';

exports.default = ActionGavel;

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGetApp = function ActionGetApp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
  );
};
ActionGetApp = (0, _pure2.default)(ActionGetApp);
ActionGetApp.displayName = 'ActionGetApp';
ActionGetApp.muiName = 'SvgIcon';

exports.default = ActionGetApp;

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGif = function ActionGif(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z' })
  );
};
ActionGif = (0, _pure2.default)(ActionGif);
ActionGif.displayName = 'ActionGif';
ActionGif.muiName = 'SvgIcon';

exports.default = ActionGif;

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGrade = function ActionGrade(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
  );
};
ActionGrade = (0, _pure2.default)(ActionGrade);
ActionGrade.displayName = 'ActionGrade';
ActionGrade.muiName = 'SvgIcon';

exports.default = ActionGrade;

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGroupWork = function ActionGroupWork(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
  );
};
ActionGroupWork = (0, _pure2.default)(ActionGroupWork);
ActionGroupWork.displayName = 'ActionGroupWork';
ActionGroupWork.muiName = 'SvgIcon';

exports.default = ActionGroupWork;

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHelpOutline = function ActionHelpOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
  );
};
ActionHelpOutline = (0, _pure2.default)(ActionHelpOutline);
ActionHelpOutline.displayName = 'ActionHelpOutline';
ActionHelpOutline.muiName = 'SvgIcon';

exports.default = ActionHelpOutline;

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHelp = function ActionHelp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
  );
};
ActionHelp = (0, _pure2.default)(ActionHelp);
ActionHelp.displayName = 'ActionHelp';
ActionHelp.muiName = 'SvgIcon';

exports.default = ActionHelp;

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHome = function ActionHome(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
  );
};
ActionHome = (0, _pure2.default)(ActionHome);
ActionHome.displayName = 'ActionHome';
ActionHome.muiName = 'SvgIcon';

exports.default = ActionHome;

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHourglassEmpty = function ActionHourglassEmpty(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z' })
  );
};
ActionHourglassEmpty = (0, _pure2.default)(ActionHourglassEmpty);
ActionHourglassEmpty.displayName = 'ActionHourglassEmpty';
ActionHourglassEmpty.muiName = 'SvgIcon';

exports.default = ActionHourglassEmpty;

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHourglassFull = function ActionHourglassFull(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z' })
  );
};
ActionHourglassFull = (0, _pure2.default)(ActionHourglassFull);
ActionHourglassFull.displayName = 'ActionHourglassFull';
ActionHourglassFull.muiName = 'SvgIcon';

exports.default = ActionHourglassFull;

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHttp = function ActionHttp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z' })
  );
};
ActionHttp = (0, _pure2.default)(ActionHttp);
ActionHttp.displayName = 'ActionHttp';
ActionHttp.muiName = 'SvgIcon';

exports.default = ActionHttp;

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionHttps = function ActionHttps(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
  );
};
ActionHttps = (0, _pure2.default)(ActionHttps);
ActionHttps.displayName = 'ActionHttps';
ActionHttps.muiName = 'SvgIcon';

exports.default = ActionHttps;

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionImportantDevices = function ActionImportantDevices(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z' })
  );
};
ActionImportantDevices = (0, _pure2.default)(ActionImportantDevices);
ActionImportantDevices.displayName = 'ActionImportantDevices';
ActionImportantDevices.muiName = 'SvgIcon';

exports.default = ActionImportantDevices;

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionInput = function ActionInput(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z' })
  );
};
ActionInput = (0, _pure2.default)(ActionInput);
ActionInput.displayName = 'ActionInput';
ActionInput.muiName = 'SvgIcon';

exports.default = ActionInput;

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionInvertColors = function ActionInvertColors(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z' })
  );
};
ActionInvertColors = (0, _pure2.default)(ActionInvertColors);
ActionInvertColors.displayName = 'ActionInvertColors';
ActionInvertColors.muiName = 'SvgIcon';

exports.default = ActionInvertColors;

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLabelOutline = function ActionLabelOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z' })
  );
};
ActionLabelOutline = (0, _pure2.default)(ActionLabelOutline);
ActionLabelOutline.displayName = 'ActionLabelOutline';
ActionLabelOutline.muiName = 'SvgIcon';

exports.default = ActionLabelOutline;

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLabel = function ActionLabel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z' })
  );
};
ActionLabel = (0, _pure2.default)(ActionLabel);
ActionLabel.displayName = 'ActionLabel';
ActionLabel.muiName = 'SvgIcon';

exports.default = ActionLabel;

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLanguage = function ActionLanguage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' })
  );
};
ActionLanguage = (0, _pure2.default)(ActionLanguage);
ActionLanguage.displayName = 'ActionLanguage';
ActionLanguage.muiName = 'SvgIcon';

exports.default = ActionLanguage;

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLaunch = function ActionLaunch(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
  );
};
ActionLaunch = (0, _pure2.default)(ActionLaunch);
ActionLaunch.displayName = 'ActionLaunch';
ActionLaunch.muiName = 'SvgIcon';

exports.default = ActionLaunch;

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLightbulbOutline = function ActionLightbulbOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z' })
  );
};
ActionLightbulbOutline = (0, _pure2.default)(ActionLightbulbOutline);
ActionLightbulbOutline.displayName = 'ActionLightbulbOutline';
ActionLightbulbOutline.muiName = 'SvgIcon';

exports.default = ActionLightbulbOutline;

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLineStyle = function ActionLineStyle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z' })
  );
};
ActionLineStyle = (0, _pure2.default)(ActionLineStyle);
ActionLineStyle.displayName = 'ActionLineStyle';
ActionLineStyle.muiName = 'SvgIcon';

exports.default = ActionLineStyle;

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLineWeight = function ActionLineWeight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z' })
  );
};
ActionLineWeight = (0, _pure2.default)(ActionLineWeight);
ActionLineWeight.displayName = 'ActionLineWeight';
ActionLineWeight.muiName = 'SvgIcon';

exports.default = ActionLineWeight;

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLockOpen = function ActionLockOpen(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' })
  );
};
ActionLockOpen = (0, _pure2.default)(ActionLockOpen);
ActionLockOpen.displayName = 'ActionLockOpen';
ActionLockOpen.muiName = 'SvgIcon';

exports.default = ActionLockOpen;

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLockOutline = function ActionLockOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z' })
  );
};
ActionLockOutline = (0, _pure2.default)(ActionLockOutline);
ActionLockOutline.displayName = 'ActionLockOutline';
ActionLockOutline.muiName = 'SvgIcon';

exports.default = ActionLockOutline;

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLock = function ActionLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
  );
};
ActionLock = (0, _pure2.default)(ActionLock);
ActionLock.displayName = 'ActionLock';
ActionLock.muiName = 'SvgIcon';

exports.default = ActionLock;

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLoyalty = function ActionLoyalty(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z' })
  );
};
ActionLoyalty = (0, _pure2.default)(ActionLoyalty);
ActionLoyalty.displayName = 'ActionLoyalty';
ActionLoyalty.muiName = 'SvgIcon';

exports.default = ActionLoyalty;

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionMarkunreadMailbox = function ActionMarkunreadMailbox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z' })
  );
};
ActionMarkunreadMailbox = (0, _pure2.default)(ActionMarkunreadMailbox);
ActionMarkunreadMailbox.displayName = 'ActionMarkunreadMailbox';
ActionMarkunreadMailbox.muiName = 'SvgIcon';

exports.default = ActionMarkunreadMailbox;

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionMotorcycle = function ActionMotorcycle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z' })
  );
};
ActionMotorcycle = (0, _pure2.default)(ActionMotorcycle);
ActionMotorcycle.displayName = 'ActionMotorcycle';
ActionMotorcycle.muiName = 'SvgIcon';

exports.default = ActionMotorcycle;

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionNoteAdd = function ActionNoteAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z' })
  );
};
ActionNoteAdd = (0, _pure2.default)(ActionNoteAdd);
ActionNoteAdd.displayName = 'ActionNoteAdd';
ActionNoteAdd.muiName = 'SvgIcon';

exports.default = ActionNoteAdd;

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionOfflinePin = function ActionOfflinePin(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z' })
  );
};
ActionOfflinePin = (0, _pure2.default)(ActionOfflinePin);
ActionOfflinePin.displayName = 'ActionOfflinePin';
ActionOfflinePin.muiName = 'SvgIcon';

exports.default = ActionOfflinePin;

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionOpacity = function ActionOpacity(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z' })
  );
};
ActionOpacity = (0, _pure2.default)(ActionOpacity);
ActionOpacity.displayName = 'ActionOpacity';
ActionOpacity.muiName = 'SvgIcon';

exports.default = ActionOpacity;

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionOpenInBrowser = function ActionOpenInBrowser(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z' })
  );
};
ActionOpenInBrowser = (0, _pure2.default)(ActionOpenInBrowser);
ActionOpenInBrowser.displayName = 'ActionOpenInBrowser';
ActionOpenInBrowser.muiName = 'SvgIcon';

exports.default = ActionOpenInBrowser;

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionOpenWith = function ActionOpenWith(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z' })
  );
};
ActionOpenWith = (0, _pure2.default)(ActionOpenWith);
ActionOpenWith.displayName = 'ActionOpenWith';
ActionOpenWith.muiName = 'SvgIcon';

exports.default = ActionOpenWith;

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPageview = function ActionPageview(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z' })
  );
};
ActionPageview = (0, _pure2.default)(ActionPageview);
ActionPageview.displayName = 'ActionPageview';
ActionPageview.muiName = 'SvgIcon';

exports.default = ActionPageview;

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPanTool = function ActionPanTool(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z' })
  );
};
ActionPanTool = (0, _pure2.default)(ActionPanTool);
ActionPanTool.displayName = 'ActionPanTool';
ActionPanTool.muiName = 'SvgIcon';

exports.default = ActionPanTool;

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPayment = function ActionPayment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
  );
};
ActionPayment = (0, _pure2.default)(ActionPayment);
ActionPayment.displayName = 'ActionPayment';
ActionPayment.muiName = 'SvgIcon';

exports.default = ActionPayment;

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermCameraMic = function ActionPermCameraMic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z' })
  );
};
ActionPermCameraMic = (0, _pure2.default)(ActionPermCameraMic);
ActionPermCameraMic.displayName = 'ActionPermCameraMic';
ActionPermCameraMic.muiName = 'SvgIcon';

exports.default = ActionPermCameraMic;

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermContactCalendar = function ActionPermContactCalendar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z' })
  );
};
ActionPermContactCalendar = (0, _pure2.default)(ActionPermContactCalendar);
ActionPermContactCalendar.displayName = 'ActionPermContactCalendar';
ActionPermContactCalendar.muiName = 'SvgIcon';

exports.default = ActionPermContactCalendar;

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermDataSetting = function ActionPermDataSetting(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
ActionPermDataSetting = (0, _pure2.default)(ActionPermDataSetting);
ActionPermDataSetting.displayName = 'ActionPermDataSetting';
ActionPermDataSetting.muiName = 'SvgIcon';

exports.default = ActionPermDataSetting;

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermDeviceInformation = function ActionPermDeviceInformation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
  );
};
ActionPermDeviceInformation = (0, _pure2.default)(ActionPermDeviceInformation);
ActionPermDeviceInformation.displayName = 'ActionPermDeviceInformation';
ActionPermDeviceInformation.muiName = 'SvgIcon';

exports.default = ActionPermDeviceInformation;

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermIdentity = function ActionPermIdentity(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
  );
};
ActionPermIdentity = (0, _pure2.default)(ActionPermIdentity);
ActionPermIdentity.displayName = 'ActionPermIdentity';
ActionPermIdentity.muiName = 'SvgIcon';

exports.default = ActionPermIdentity;

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermMedia = function ActionPermMedia(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z' })
  );
};
ActionPermMedia = (0, _pure2.default)(ActionPermMedia);
ActionPermMedia.displayName = 'ActionPermMedia';
ActionPermMedia.muiName = 'SvgIcon';

exports.default = ActionPermMedia;

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermPhoneMsg = function ActionPermPhoneMsg(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z' })
  );
};
ActionPermPhoneMsg = (0, _pure2.default)(ActionPermPhoneMsg);
ActionPermPhoneMsg.displayName = 'ActionPermPhoneMsg';
ActionPermPhoneMsg.muiName = 'SvgIcon';

exports.default = ActionPermPhoneMsg;

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermScanWifi = function ActionPermScanWifi(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z' })
  );
};
ActionPermScanWifi = (0, _pure2.default)(ActionPermScanWifi);
ActionPermScanWifi.displayName = 'ActionPermScanWifi';
ActionPermScanWifi.muiName = 'SvgIcon';

exports.default = ActionPermScanWifi;

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPets = function ActionPets(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '4.5', cy: '9.5', r: '2.5' }),
    _react2.default.createElement('circle', { cx: '9', cy: '5.5', r: '2.5' }),
    _react2.default.createElement('circle', { cx: '15', cy: '5.5', r: '2.5' }),
    _react2.default.createElement('circle', { cx: '19.5', cy: '9.5', r: '2.5' }),
    _react2.default.createElement('path', { d: 'M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z' })
  );
};
ActionPets = (0, _pure2.default)(ActionPets);
ActionPets.displayName = 'ActionPets';
ActionPets.muiName = 'SvgIcon';

exports.default = ActionPets;

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPictureInPictureAlt = function ActionPictureInPictureAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z' })
  );
};
ActionPictureInPictureAlt = (0, _pure2.default)(ActionPictureInPictureAlt);
ActionPictureInPictureAlt.displayName = 'ActionPictureInPictureAlt';
ActionPictureInPictureAlt.muiName = 'SvgIcon';

exports.default = ActionPictureInPictureAlt;

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPictureInPicture = function ActionPictureInPicture(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z' })
  );
};
ActionPictureInPicture = (0, _pure2.default)(ActionPictureInPicture);
ActionPictureInPicture.displayName = 'ActionPictureInPicture';
ActionPictureInPicture.muiName = 'SvgIcon';

exports.default = ActionPictureInPicture;

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPlayForWork = function ActionPlayForWork(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z' })
  );
};
ActionPlayForWork = (0, _pure2.default)(ActionPlayForWork);
ActionPlayForWork.displayName = 'ActionPlayForWork';
ActionPlayForWork.muiName = 'SvgIcon';

exports.default = ActionPlayForWork;

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPolymer = function ActionPolymer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z' })
  );
};
ActionPolymer = (0, _pure2.default)(ActionPolymer);
ActionPolymer.displayName = 'ActionPolymer';
ActionPolymer.muiName = 'SvgIcon';

exports.default = ActionPolymer;

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPowerSettingsNew = function ActionPowerSettingsNew(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z' })
  );
};
ActionPowerSettingsNew = (0, _pure2.default)(ActionPowerSettingsNew);
ActionPowerSettingsNew.displayName = 'ActionPowerSettingsNew';
ActionPowerSettingsNew.muiName = 'SvgIcon';

exports.default = ActionPowerSettingsNew;

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPregnantWoman = function ActionPregnantWoman(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z' })
  );
};
ActionPregnantWoman = (0, _pure2.default)(ActionPregnantWoman);
ActionPregnantWoman.displayName = 'ActionPregnantWoman';
ActionPregnantWoman.muiName = 'SvgIcon';

exports.default = ActionPregnantWoman;

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPrint = function ActionPrint(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
  );
};
ActionPrint = (0, _pure2.default)(ActionPrint);
ActionPrint.displayName = 'ActionPrint';
ActionPrint.muiName = 'SvgIcon';

exports.default = ActionPrint;

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionQueryBuilder = function ActionQueryBuilder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
  );
};
ActionQueryBuilder = (0, _pure2.default)(ActionQueryBuilder);
ActionQueryBuilder.displayName = 'ActionQueryBuilder';
ActionQueryBuilder.muiName = 'SvgIcon';

exports.default = ActionQueryBuilder;

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionQuestionAnswer = function ActionQuestionAnswer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
  );
};
ActionQuestionAnswer = (0, _pure2.default)(ActionQuestionAnswer);
ActionQuestionAnswer.displayName = 'ActionQuestionAnswer';
ActionQuestionAnswer.muiName = 'SvgIcon';

exports.default = ActionQuestionAnswer;

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionReceipt = function ActionReceipt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z' })
  );
};
ActionReceipt = (0, _pure2.default)(ActionReceipt);
ActionReceipt.displayName = 'ActionReceipt';
ActionReceipt.muiName = 'SvgIcon';

exports.default = ActionReceipt;

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRecordVoiceOver = function ActionRecordVoiceOver(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '9', cy: '9', r: '4' }),
    _react2.default.createElement('path', { d: 'M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z' })
  );
};
ActionRecordVoiceOver = (0, _pure2.default)(ActionRecordVoiceOver);
ActionRecordVoiceOver.displayName = 'ActionRecordVoiceOver';
ActionRecordVoiceOver.muiName = 'SvgIcon';

exports.default = ActionRecordVoiceOver;

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRedeem = function ActionRedeem(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
  );
};
ActionRedeem = (0, _pure2.default)(ActionRedeem);
ActionRedeem.displayName = 'ActionRedeem';
ActionRedeem.muiName = 'SvgIcon';

exports.default = ActionRedeem;

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRemoveShoppingCart = function ActionRemoveShoppingCart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z' })
  );
};
ActionRemoveShoppingCart = (0, _pure2.default)(ActionRemoveShoppingCart);
ActionRemoveShoppingCart.displayName = 'ActionRemoveShoppingCart';
ActionRemoveShoppingCart.muiName = 'SvgIcon';

exports.default = ActionRemoveShoppingCart;

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionReorder = function ActionReorder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z' })
  );
};
ActionReorder = (0, _pure2.default)(ActionReorder);
ActionReorder.displayName = 'ActionReorder';
ActionReorder.muiName = 'SvgIcon';

exports.default = ActionReorder;

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionReportProblem = function ActionReportProblem(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};
ActionReportProblem = (0, _pure2.default)(ActionReportProblem);
ActionReportProblem.displayName = 'ActionReportProblem';
ActionReportProblem.muiName = 'SvgIcon';

exports.default = ActionReportProblem;

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRestorePage = function ActionRestorePage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z' })
  );
};
ActionRestorePage = (0, _pure2.default)(ActionRestorePage);
ActionRestorePage.displayName = 'ActionRestorePage';
ActionRestorePage.muiName = 'SvgIcon';

exports.default = ActionRestorePage;

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRestore = function ActionRestore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
  );
};
ActionRestore = (0, _pure2.default)(ActionRestore);
ActionRestore.displayName = 'ActionRestore';
ActionRestore.muiName = 'SvgIcon';

exports.default = ActionRestore;

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRoom = function ActionRoom(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
  );
};
ActionRoom = (0, _pure2.default)(ActionRoom);
ActionRoom.displayName = 'ActionRoom';
ActionRoom.muiName = 'SvgIcon';

exports.default = ActionRoom;

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRoundedCorner = function ActionRoundedCorner(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z' })
  );
};
ActionRoundedCorner = (0, _pure2.default)(ActionRoundedCorner);
ActionRoundedCorner.displayName = 'ActionRoundedCorner';
ActionRoundedCorner.muiName = 'SvgIcon';

exports.default = ActionRoundedCorner;

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRowing = function ActionRowing(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z' })
  );
};
ActionRowing = (0, _pure2.default)(ActionRowing);
ActionRowing.displayName = 'ActionRowing';
ActionRowing.muiName = 'SvgIcon';

exports.default = ActionRowing;

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSchedule = function ActionSchedule(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
  );
};
ActionSchedule = (0, _pure2.default)(ActionSchedule);
ActionSchedule.displayName = 'ActionSchedule';
ActionSchedule.muiName = 'SvgIcon';

exports.default = ActionSchedule;

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsApplications = function ActionSettingsApplications(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z' })
  );
};
ActionSettingsApplications = (0, _pure2.default)(ActionSettingsApplications);
ActionSettingsApplications.displayName = 'ActionSettingsApplications';
ActionSettingsApplications.muiName = 'SvgIcon';

exports.default = ActionSettingsApplications;

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsBackupRestore = function ActionSettingsBackupRestore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z' })
  );
};
ActionSettingsBackupRestore = (0, _pure2.default)(ActionSettingsBackupRestore);
ActionSettingsBackupRestore.displayName = 'ActionSettingsBackupRestore';
ActionSettingsBackupRestore.muiName = 'SvgIcon';

exports.default = ActionSettingsBackupRestore;

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsBluetooth = function ActionSettingsBluetooth(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z' })
  );
};
ActionSettingsBluetooth = (0, _pure2.default)(ActionSettingsBluetooth);
ActionSettingsBluetooth.displayName = 'ActionSettingsBluetooth';
ActionSettingsBluetooth.muiName = 'SvgIcon';

exports.default = ActionSettingsBluetooth;

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsBrightness = function ActionSettingsBrightness(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z' })
  );
};
ActionSettingsBrightness = (0, _pure2.default)(ActionSettingsBrightness);
ActionSettingsBrightness.displayName = 'ActionSettingsBrightness';
ActionSettingsBrightness.muiName = 'SvgIcon';

exports.default = ActionSettingsBrightness;

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsCell = function ActionSettingsCell(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z' })
  );
};
ActionSettingsCell = (0, _pure2.default)(ActionSettingsCell);
ActionSettingsCell.displayName = 'ActionSettingsCell';
ActionSettingsCell.muiName = 'SvgIcon';

exports.default = ActionSettingsCell;

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsEthernet = function ActionSettingsEthernet(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z' })
  );
};
ActionSettingsEthernet = (0, _pure2.default)(ActionSettingsEthernet);
ActionSettingsEthernet.displayName = 'ActionSettingsEthernet';
ActionSettingsEthernet.muiName = 'SvgIcon';

exports.default = ActionSettingsEthernet;

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsInputAntenna = function ActionSettingsInputAntenna(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z' })
  );
};
ActionSettingsInputAntenna = (0, _pure2.default)(ActionSettingsInputAntenna);
ActionSettingsInputAntenna.displayName = 'ActionSettingsInputAntenna';
ActionSettingsInputAntenna.muiName = 'SvgIcon';

exports.default = ActionSettingsInputAntenna;

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsInputComponent = function ActionSettingsInputComponent(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
  );
};
ActionSettingsInputComponent = (0, _pure2.default)(ActionSettingsInputComponent);
ActionSettingsInputComponent.displayName = 'ActionSettingsInputComponent';
ActionSettingsInputComponent.muiName = 'SvgIcon';

exports.default = ActionSettingsInputComponent;

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsInputComposite = function ActionSettingsInputComposite(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
  );
};
ActionSettingsInputComposite = (0, _pure2.default)(ActionSettingsInputComposite);
ActionSettingsInputComposite.displayName = 'ActionSettingsInputComposite';
ActionSettingsInputComposite.muiName = 'SvgIcon';

exports.default = ActionSettingsInputComposite;

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsInputHdmi = function ActionSettingsInputHdmi(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z' })
  );
};
ActionSettingsInputHdmi = (0, _pure2.default)(ActionSettingsInputHdmi);
ActionSettingsInputHdmi.displayName = 'ActionSettingsInputHdmi';
ActionSettingsInputHdmi.muiName = 'SvgIcon';

exports.default = ActionSettingsInputHdmi;

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsInputSvideo = function ActionSettingsInputSvideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
  );
};
ActionSettingsInputSvideo = (0, _pure2.default)(ActionSettingsInputSvideo);
ActionSettingsInputSvideo.displayName = 'ActionSettingsInputSvideo';
ActionSettingsInputSvideo.muiName = 'SvgIcon';

exports.default = ActionSettingsInputSvideo;

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsOverscan = function ActionSettingsOverscan(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
  );
};
ActionSettingsOverscan = (0, _pure2.default)(ActionSettingsOverscan);
ActionSettingsOverscan.displayName = 'ActionSettingsOverscan';
ActionSettingsOverscan.muiName = 'SvgIcon';

exports.default = ActionSettingsOverscan;

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsPhone = function ActionSettingsPhone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z' })
  );
};
ActionSettingsPhone = (0, _pure2.default)(ActionSettingsPhone);
ActionSettingsPhone.displayName = 'ActionSettingsPhone';
ActionSettingsPhone.muiName = 'SvgIcon';

exports.default = ActionSettingsPhone;

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsPower = function ActionSettingsPower(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z' })
  );
};
ActionSettingsPower = (0, _pure2.default)(ActionSettingsPower);
ActionSettingsPower.displayName = 'ActionSettingsPower';
ActionSettingsPower.muiName = 'SvgIcon';

exports.default = ActionSettingsPower;

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsRemote = function ActionSettingsRemote(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z' })
  );
};
ActionSettingsRemote = (0, _pure2.default)(ActionSettingsRemote);
ActionSettingsRemote.displayName = 'ActionSettingsRemote';
ActionSettingsRemote.muiName = 'SvgIcon';

exports.default = ActionSettingsRemote;

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSettingsVoice = function ActionSettingsVoice(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z' })
  );
};
ActionSettingsVoice = (0, _pure2.default)(ActionSettingsVoice);
ActionSettingsVoice.displayName = 'ActionSettingsVoice';
ActionSettingsVoice.muiName = 'SvgIcon';

exports.default = ActionSettingsVoice;

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionShopTwo = function ActionShopTwo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z' })
  );
};
ActionShopTwo = (0, _pure2.default)(ActionShopTwo);
ActionShopTwo.displayName = 'ActionShopTwo';
ActionShopTwo.muiName = 'SvgIcon';

exports.default = ActionShopTwo;

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionShop = function ActionShop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z' })
  );
};
ActionShop = (0, _pure2.default)(ActionShop);
ActionShop.displayName = 'ActionShop';
ActionShop.muiName = 'SvgIcon';

exports.default = ActionShop;

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionShoppingBasket = function ActionShoppingBasket(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
ActionShoppingBasket = (0, _pure2.default)(ActionShoppingBasket);
ActionShoppingBasket.displayName = 'ActionShoppingBasket';
ActionShoppingBasket.muiName = 'SvgIcon';

exports.default = ActionShoppingBasket;

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionShoppingCart = function ActionShoppingCart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
  );
};
ActionShoppingCart = (0, _pure2.default)(ActionShoppingCart);
ActionShoppingCart.displayName = 'ActionShoppingCart';
ActionShoppingCart.muiName = 'SvgIcon';

exports.default = ActionShoppingCart;

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSpeakerNotesOff = function ActionSpeakerNotesOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z' })
  );
};
ActionSpeakerNotesOff = (0, _pure2.default)(ActionSpeakerNotesOff);
ActionSpeakerNotesOff.displayName = 'ActionSpeakerNotesOff';
ActionSpeakerNotesOff.muiName = 'SvgIcon';

exports.default = ActionSpeakerNotesOff;

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSpellcheck = function ActionSpellcheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z' })
  );
};
ActionSpellcheck = (0, _pure2.default)(ActionSpellcheck);
ActionSpellcheck.displayName = 'ActionSpellcheck';
ActionSpellcheck.muiName = 'SvgIcon';

exports.default = ActionSpellcheck;

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionStars = function ActionStars(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z' })
  );
};
ActionStars = (0, _pure2.default)(ActionStars);
ActionStars.displayName = 'ActionStars';
ActionStars.muiName = 'SvgIcon';

exports.default = ActionStars;

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionStore = function ActionStore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
  );
};
ActionStore = (0, _pure2.default)(ActionStore);
ActionStore.displayName = 'ActionStore';
ActionStore.muiName = 'SvgIcon';

exports.default = ActionStore;

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSubject = function ActionSubject(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' })
  );
};
ActionSubject = (0, _pure2.default)(ActionSubject);
ActionSubject.displayName = 'ActionSubject';
ActionSubject.muiName = 'SvgIcon';

exports.default = ActionSubject;

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSupervisorAccount = function ActionSupervisorAccount(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z' })
  );
};
ActionSupervisorAccount = (0, _pure2.default)(ActionSupervisorAccount);
ActionSupervisorAccount.displayName = 'ActionSupervisorAccount';
ActionSupervisorAccount.muiName = 'SvgIcon';

exports.default = ActionSupervisorAccount;

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSwapHoriz = function ActionSwapHoriz(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' })
  );
};
ActionSwapHoriz = (0, _pure2.default)(ActionSwapHoriz);
ActionSwapHoriz.displayName = 'ActionSwapHoriz';
ActionSwapHoriz.muiName = 'SvgIcon';

exports.default = ActionSwapHoriz;

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSwapVert = function ActionSwapVert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' })
  );
};
ActionSwapVert = (0, _pure2.default)(ActionSwapVert);
ActionSwapVert.displayName = 'ActionSwapVert';
ActionSwapVert.muiName = 'SvgIcon';

exports.default = ActionSwapVert;

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSwapVerticalCircle = function ActionSwapVerticalCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z' })
  );
};
ActionSwapVerticalCircle = (0, _pure2.default)(ActionSwapVerticalCircle);
ActionSwapVerticalCircle.displayName = 'ActionSwapVerticalCircle';
ActionSwapVerticalCircle.muiName = 'SvgIcon';

exports.default = ActionSwapVerticalCircle;

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSystemUpdateAlt = function ActionSystemUpdateAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' })
  );
};
ActionSystemUpdateAlt = (0, _pure2.default)(ActionSystemUpdateAlt);
ActionSystemUpdateAlt.displayName = 'ActionSystemUpdateAlt';
ActionSystemUpdateAlt.muiName = 'SvgIcon';

exports.default = ActionSystemUpdateAlt;

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTabUnselected = function ActionTabUnselected(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z' })
  );
};
ActionTabUnselected = (0, _pure2.default)(ActionTabUnselected);
ActionTabUnselected.displayName = 'ActionTabUnselected';
ActionTabUnselected.muiName = 'SvgIcon';

exports.default = ActionTabUnselected;

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTab = function ActionTab(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z' })
  );
};
ActionTab = (0, _pure2.default)(ActionTab);
ActionTab.displayName = 'ActionTab';
ActionTab.muiName = 'SvgIcon';

exports.default = ActionTab;

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTheaters = function ActionTheaters(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
  );
};
ActionTheaters = (0, _pure2.default)(ActionTheaters);
ActionTheaters.displayName = 'ActionTheaters';
ActionTheaters.muiName = 'SvgIcon';

exports.default = ActionTheaters;

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionThreeDRotation = function ActionThreeDRotation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z' })
  );
};
ActionThreeDRotation = (0, _pure2.default)(ActionThreeDRotation);
ActionThreeDRotation.displayName = 'ActionThreeDRotation';
ActionThreeDRotation.muiName = 'SvgIcon';

exports.default = ActionThreeDRotation;

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionThumbDown = function ActionThumbDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z' })
  );
};
ActionThumbDown = (0, _pure2.default)(ActionThumbDown);
ActionThumbDown.displayName = 'ActionThumbDown';
ActionThumbDown.muiName = 'SvgIcon';

exports.default = ActionThumbDown;

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionThumbUp = function ActionThumbUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z' })
  );
};
ActionThumbUp = (0, _pure2.default)(ActionThumbUp);
ActionThumbUp.displayName = 'ActionThumbUp';
ActionThumbUp.muiName = 'SvgIcon';

exports.default = ActionThumbUp;

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionThumbsUpDown = function ActionThumbsUpDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z' })
  );
};
ActionThumbsUpDown = (0, _pure2.default)(ActionThumbsUpDown);
ActionThumbsUpDown.displayName = 'ActionThumbsUpDown';
ActionThumbsUpDown.muiName = 'SvgIcon';

exports.default = ActionThumbsUpDown;

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTimeline = function ActionTimeline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z' })
  );
};
ActionTimeline = (0, _pure2.default)(ActionTimeline);
ActionTimeline.displayName = 'ActionTimeline';
ActionTimeline.muiName = 'SvgIcon';

exports.default = ActionTimeline;

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionToc = function ActionToc(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z' })
  );
};
ActionToc = (0, _pure2.default)(ActionToc);
ActionToc.displayName = 'ActionToc';
ActionToc.muiName = 'SvgIcon';

exports.default = ActionToc;

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionToday = function ActionToday(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z' })
  );
};
ActionToday = (0, _pure2.default)(ActionToday);
ActionToday.displayName = 'ActionToday';
ActionToday.muiName = 'SvgIcon';

exports.default = ActionToday;

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionToll = function ActionToll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z' })
  );
};
ActionToll = (0, _pure2.default)(ActionToll);
ActionToll.displayName = 'ActionToll';
ActionToll.muiName = 'SvgIcon';

exports.default = ActionToll;

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTouchApp = function ActionTouchApp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z' })
  );
};
ActionTouchApp = (0, _pure2.default)(ActionTouchApp);
ActionTouchApp.displayName = 'ActionTouchApp';
ActionTouchApp.muiName = 'SvgIcon';

exports.default = ActionTouchApp;

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTrackChanges = function ActionTrackChanges(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z' })
  );
};
ActionTrackChanges = (0, _pure2.default)(ActionTrackChanges);
ActionTrackChanges.displayName = 'ActionTrackChanges';
ActionTrackChanges.muiName = 'SvgIcon';

exports.default = ActionTrackChanges;

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTranslate = function ActionTranslate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z' })
  );
};
ActionTranslate = (0, _pure2.default)(ActionTranslate);
ActionTranslate.displayName = 'ActionTranslate';
ActionTranslate.muiName = 'SvgIcon';

exports.default = ActionTranslate;

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTrendingDown = function ActionTrendingDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z' })
  );
};
ActionTrendingDown = (0, _pure2.default)(ActionTrendingDown);
ActionTrendingDown.displayName = 'ActionTrendingDown';
ActionTrendingDown.muiName = 'SvgIcon';

exports.default = ActionTrendingDown;

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTrendingFlat = function ActionTrendingFlat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 12l-4-4v3H3v2h15v3z' })
  );
};
ActionTrendingFlat = (0, _pure2.default)(ActionTrendingFlat);
ActionTrendingFlat.displayName = 'ActionTrendingFlat';
ActionTrendingFlat.muiName = 'SvgIcon';

exports.default = ActionTrendingFlat;

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTrendingUp = function ActionTrendingUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z' })
  );
};
ActionTrendingUp = (0, _pure2.default)(ActionTrendingUp);
ActionTrendingUp.displayName = 'ActionTrendingUp';
ActionTrendingUp.muiName = 'SvgIcon';

exports.default = ActionTrendingUp;

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTurnedInNot = function ActionTurnedInNot(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
  );
};
ActionTurnedInNot = (0, _pure2.default)(ActionTurnedInNot);
ActionTurnedInNot.displayName = 'ActionTurnedInNot';
ActionTurnedInNot.muiName = 'SvgIcon';

exports.default = ActionTurnedInNot;

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTurnedIn = function ActionTurnedIn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
  );
};
ActionTurnedIn = (0, _pure2.default)(ActionTurnedIn);
ActionTurnedIn.displayName = 'ActionTurnedIn';
ActionTurnedIn.muiName = 'SvgIcon';

exports.default = ActionTurnedIn;

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionUpdate = function ActionUpdate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z' })
  );
};
ActionUpdate = (0, _pure2.default)(ActionUpdate);
ActionUpdate.displayName = 'ActionUpdate';
ActionUpdate.muiName = 'SvgIcon';

exports.default = ActionUpdate;

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVerifiedUser = function ActionVerifiedUser(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
  );
};
ActionVerifiedUser = (0, _pure2.default)(ActionVerifiedUser);
ActionVerifiedUser.displayName = 'ActionVerifiedUser';
ActionVerifiedUser.muiName = 'SvgIcon';

exports.default = ActionVerifiedUser;

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewAgenda = function ActionViewAgenda(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' })
  );
};
ActionViewAgenda = (0, _pure2.default)(ActionViewAgenda);
ActionViewAgenda.displayName = 'ActionViewAgenda';
ActionViewAgenda.muiName = 'SvgIcon';

exports.default = ActionViewAgenda;

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewArray = function ActionViewArray(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z' })
  );
};
ActionViewArray = (0, _pure2.default)(ActionViewArray);
ActionViewArray.displayName = 'ActionViewArray';
ActionViewArray.muiName = 'SvgIcon';

exports.default = ActionViewArray;

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewCarousel = function ActionViewCarousel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z' })
  );
};
ActionViewCarousel = (0, _pure2.default)(ActionViewCarousel);
ActionViewCarousel.displayName = 'ActionViewCarousel';
ActionViewCarousel.muiName = 'SvgIcon';

exports.default = ActionViewCarousel;

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewColumn = function ActionViewColumn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z' })
  );
};
ActionViewColumn = (0, _pure2.default)(ActionViewColumn);
ActionViewColumn.displayName = 'ActionViewColumn';
ActionViewColumn.muiName = 'SvgIcon';

exports.default = ActionViewColumn;

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewDay = function ActionViewDay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z' })
  );
};
ActionViewDay = (0, _pure2.default)(ActionViewDay);
ActionViewDay.displayName = 'ActionViewDay';
ActionViewDay.muiName = 'SvgIcon';

exports.default = ActionViewDay;

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewHeadline = function ActionViewHeadline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z' })
  );
};
ActionViewHeadline = (0, _pure2.default)(ActionViewHeadline);
ActionViewHeadline.displayName = 'ActionViewHeadline';
ActionViewHeadline.muiName = 'SvgIcon';

exports.default = ActionViewHeadline;

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewList = function ActionViewList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z' })
  );
};
ActionViewList = (0, _pure2.default)(ActionViewList);
ActionViewList.displayName = 'ActionViewList';
ActionViewList.muiName = 'SvgIcon';

exports.default = ActionViewList;

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewModule = function ActionViewModule(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z' })
  );
};
ActionViewModule = (0, _pure2.default)(ActionViewModule);
ActionViewModule.displayName = 'ActionViewModule';
ActionViewModule.muiName = 'SvgIcon';

exports.default = ActionViewModule;

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewQuilt = function ActionViewQuilt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' })
  );
};
ActionViewQuilt = (0, _pure2.default)(ActionViewQuilt);
ActionViewQuilt.displayName = 'ActionViewQuilt';
ActionViewQuilt.muiName = 'SvgIcon';

exports.default = ActionViewQuilt;

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewStream = function ActionViewStream(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z' })
  );
};
ActionViewStream = (0, _pure2.default)(ActionViewStream);
ActionViewStream.displayName = 'ActionViewStream';
ActionViewStream.muiName = 'SvgIcon';

exports.default = ActionViewStream;

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewWeek = function ActionViewWeek(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z' })
  );
};
ActionViewWeek = (0, _pure2.default)(ActionViewWeek);
ActionViewWeek.displayName = 'ActionViewWeek';
ActionViewWeek.muiName = 'SvgIcon';

exports.default = ActionViewWeek;

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionVisibilityOff = function ActionVisibilityOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z' })
  );
};
ActionVisibilityOff = (0, _pure2.default)(ActionVisibilityOff);
ActionVisibilityOff.displayName = 'ActionVisibilityOff';
ActionVisibilityOff.muiName = 'SvgIcon';

exports.default = ActionVisibilityOff;

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionWatchLater = function ActionWatchLater(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z' })
  );
};
ActionWatchLater = (0, _pure2.default)(ActionWatchLater);
ActionWatchLater.displayName = 'ActionWatchLater';
ActionWatchLater.muiName = 'SvgIcon';

exports.default = ActionWatchLater;

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionWork = function ActionWork(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' })
  );
};
ActionWork = (0, _pure2.default)(ActionWork);
ActionWork.displayName = 'ActionWork';
ActionWork.muiName = 'SvgIcon';

exports.default = ActionWork;

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionYoutubeSearchedFor = function ActionYoutubeSearchedFor(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z' })
  );
};
ActionYoutubeSearchedFor = (0, _pure2.default)(ActionYoutubeSearchedFor);
ActionYoutubeSearchedFor.displayName = 'ActionYoutubeSearchedFor';
ActionYoutubeSearchedFor.muiName = 'SvgIcon';

exports.default = ActionYoutubeSearchedFor;

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionZoomIn = function ActionZoomIn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z' })
  );
};
ActionZoomIn = (0, _pure2.default)(ActionZoomIn);
ActionZoomIn.displayName = 'ActionZoomIn';
ActionZoomIn.muiName = 'SvgIcon';

exports.default = ActionZoomIn;

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionZoomOut = function ActionZoomOut(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z' })
  );
};
ActionZoomOut = (0, _pure2.default)(ActionZoomOut);
ActionZoomOut.displayName = 'ActionZoomOut';
ActionZoomOut.muiName = 'SvgIcon';

exports.default = ActionZoomOut;

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertAddAlert = function AlertAddAlert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z' })
  );
};
AlertAddAlert = (0, _pure2.default)(AlertAddAlert);
AlertAddAlert.displayName = 'AlertAddAlert';
AlertAddAlert.muiName = 'SvgIcon';

exports.default = AlertAddAlert;

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertErrorOutline = function AlertErrorOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
AlertErrorOutline = (0, _pure2.default)(AlertErrorOutline);
AlertErrorOutline.displayName = 'AlertErrorOutline';
AlertErrorOutline.muiName = 'SvgIcon';

exports.default = AlertErrorOutline;

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertError = function AlertError(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
  );
};
AlertError = (0, _pure2.default)(AlertError);
AlertError.displayName = 'AlertError';
AlertError.muiName = 'SvgIcon';

exports.default = AlertError;

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvAddToQueue = function AvAddToQueue(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z' })
  );
};
AvAddToQueue = (0, _pure2.default)(AvAddToQueue);
AvAddToQueue.displayName = 'AvAddToQueue';
AvAddToQueue.muiName = 'SvgIcon';

exports.default = AvAddToQueue;

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvAirplay = function AvAirplay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
AvAirplay = (0, _pure2.default)(AvAirplay);
AvAirplay.displayName = 'AvAirplay';
AvAirplay.muiName = 'SvgIcon';

exports.default = AvAirplay;

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvAlbum = function AvAlbum(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
  );
};
AvAlbum = (0, _pure2.default)(AvAlbum);
AvAlbum.displayName = 'AvAlbum';
AvAlbum.muiName = 'SvgIcon';

exports.default = AvAlbum;

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvArtTrack = function AvArtTrack(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z' })
  );
};
AvArtTrack = (0, _pure2.default)(AvArtTrack);
AvArtTrack.displayName = 'AvArtTrack';
AvArtTrack.muiName = 'SvgIcon';

exports.default = AvArtTrack;

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvAvTimer = function AvAvTimer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z' })
  );
};
AvAvTimer = (0, _pure2.default)(AvAvTimer);
AvAvTimer.displayName = 'AvAvTimer';
AvAvTimer.muiName = 'SvgIcon';

exports.default = AvAvTimer;

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvBrandingWatermark = function AvBrandingWatermark(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z' })
  );
};
AvBrandingWatermark = (0, _pure2.default)(AvBrandingWatermark);
AvBrandingWatermark.displayName = 'AvBrandingWatermark';
AvBrandingWatermark.muiName = 'SvgIcon';

exports.default = AvBrandingWatermark;

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvCallToAction = function AvCallToAction(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z' })
  );
};
AvCallToAction = (0, _pure2.default)(AvCallToAction);
AvCallToAction.displayName = 'AvCallToAction';
AvCallToAction.muiName = 'SvgIcon';

exports.default = AvCallToAction;

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvClosedCaption = function AvClosedCaption(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z' })
  );
};
AvClosedCaption = (0, _pure2.default)(AvClosedCaption);
AvClosedCaption.displayName = 'AvClosedCaption';
AvClosedCaption.muiName = 'SvgIcon';

exports.default = AvClosedCaption;

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvEqualizer = function AvEqualizer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z' })
  );
};
AvEqualizer = (0, _pure2.default)(AvEqualizer);
AvEqualizer.displayName = 'AvEqualizer';
AvEqualizer.muiName = 'SvgIcon';

exports.default = AvEqualizer;

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvExplicit = function AvExplicit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z' })
  );
};
AvExplicit = (0, _pure2.default)(AvExplicit);
AvExplicit.displayName = 'AvExplicit';
AvExplicit.muiName = 'SvgIcon';

exports.default = AvExplicit;

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFastForward = function AvFastForward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z' })
  );
};
AvFastForward = (0, _pure2.default)(AvFastForward);
AvFastForward.displayName = 'AvFastForward';
AvFastForward.muiName = 'SvgIcon';

exports.default = AvFastForward;

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFastRewind = function AvFastRewind(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z' })
  );
};
AvFastRewind = (0, _pure2.default)(AvFastRewind);
AvFastRewind.displayName = 'AvFastRewind';
AvFastRewind.muiName = 'SvgIcon';

exports.default = AvFastRewind;

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFeaturedPlayList = function AvFeaturedPlayList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z' })
  );
};
AvFeaturedPlayList = (0, _pure2.default)(AvFeaturedPlayList);
AvFeaturedPlayList.displayName = 'AvFeaturedPlayList';
AvFeaturedPlayList.muiName = 'SvgIcon';

exports.default = AvFeaturedPlayList;

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFeaturedVideo = function AvFeaturedVideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z' })
  );
};
AvFeaturedVideo = (0, _pure2.default)(AvFeaturedVideo);
AvFeaturedVideo.displayName = 'AvFeaturedVideo';
AvFeaturedVideo.muiName = 'SvgIcon';

exports.default = AvFeaturedVideo;

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFiberDvr = function AvFiberDvr(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z' })
  );
};
AvFiberDvr = (0, _pure2.default)(AvFiberDvr);
AvFiberDvr.displayName = 'AvFiberDvr';
AvFiberDvr.muiName = 'SvgIcon';

exports.default = AvFiberDvr;

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFiberManualRecord = function AvFiberManualRecord(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '8' })
  );
};
AvFiberManualRecord = (0, _pure2.default)(AvFiberManualRecord);
AvFiberManualRecord.displayName = 'AvFiberManualRecord';
AvFiberManualRecord.muiName = 'SvgIcon';

exports.default = AvFiberManualRecord;

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFiberNew = function AvFiberNew(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z' })
  );
};
AvFiberNew = (0, _pure2.default)(AvFiberNew);
AvFiberNew.displayName = 'AvFiberNew';
AvFiberNew.muiName = 'SvgIcon';

exports.default = AvFiberNew;

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFiberPin = function AvFiberPin(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z' })
  );
};
AvFiberPin = (0, _pure2.default)(AvFiberPin);
AvFiberPin.displayName = 'AvFiberPin';
AvFiberPin.muiName = 'SvgIcon';

exports.default = AvFiberPin;

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvFiberSmartRecord = function AvFiberSmartRecord(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('circle', { cx: '9', cy: '12', r: '8' }),
      _react2.default.createElement('path', { d: 'M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z' })
    )
  );
};
AvFiberSmartRecord = (0, _pure2.default)(AvFiberSmartRecord);
AvFiberSmartRecord.displayName = 'AvFiberSmartRecord';
AvFiberSmartRecord.muiName = 'SvgIcon';

exports.default = AvFiberSmartRecord;

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvForward10 = function AvForward10(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
  );
};
AvForward10 = (0, _pure2.default)(AvForward10);
AvForward10.displayName = 'AvForward10';
AvForward10.muiName = 'SvgIcon';

exports.default = AvForward10;

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvForward30 = function AvForward30(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z' })
  );
};
AvForward30 = (0, _pure2.default)(AvForward30);
AvForward30.displayName = 'AvForward30';
AvForward30.muiName = 'SvgIcon';

exports.default = AvForward30;

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvForward5 = function AvForward5(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z' })
  );
};
AvForward5 = (0, _pure2.default)(AvForward5);
AvForward5.displayName = 'AvForward5';
AvForward5.muiName = 'SvgIcon';

exports.default = AvForward5;

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvGames = function AvGames(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
  );
};
AvGames = (0, _pure2.default)(AvGames);
AvGames.displayName = 'AvGames';
AvGames.muiName = 'SvgIcon';

exports.default = AvGames;

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvHd = function AvHd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z' })
  );
};
AvHd = (0, _pure2.default)(AvHd);
AvHd.displayName = 'AvHd';
AvHd.muiName = 'SvgIcon';

exports.default = AvHd;

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvHearing = function AvHearing(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z' })
  );
};
AvHearing = (0, _pure2.default)(AvHearing);
AvHearing.displayName = 'AvHearing';
AvHearing.muiName = 'SvgIcon';

exports.default = AvHearing;

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvHighQuality = function AvHighQuality(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z' })
  );
};
AvHighQuality = (0, _pure2.default)(AvHighQuality);
AvHighQuality.displayName = 'AvHighQuality';
AvHighQuality.muiName = 'SvgIcon';

exports.default = AvHighQuality;

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvLibraryAdd = function AvLibraryAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
  );
};
AvLibraryAdd = (0, _pure2.default)(AvLibraryAdd);
AvLibraryAdd.displayName = 'AvLibraryAdd';
AvLibraryAdd.muiName = 'SvgIcon';

exports.default = AvLibraryAdd;

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvLibraryBooks = function AvLibraryBooks(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z' })
  );
};
AvLibraryBooks = (0, _pure2.default)(AvLibraryBooks);
AvLibraryBooks.displayName = 'AvLibraryBooks';
AvLibraryBooks.muiName = 'SvgIcon';

exports.default = AvLibraryBooks;

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvLibraryMusic = function AvLibraryMusic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z' })
  );
};
AvLibraryMusic = (0, _pure2.default)(AvLibraryMusic);
AvLibraryMusic.displayName = 'AvLibraryMusic';
AvLibraryMusic.muiName = 'SvgIcon';

exports.default = AvLibraryMusic;

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvLoop = function AvLoop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
  );
};
AvLoop = (0, _pure2.default)(AvLoop);
AvLoop.displayName = 'AvLoop';
AvLoop.muiName = 'SvgIcon';

exports.default = AvLoop;

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvMicNone = function AvMicNone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
  );
};
AvMicNone = (0, _pure2.default)(AvMicNone);
AvMicNone.displayName = 'AvMicNone';
AvMicNone.muiName = 'SvgIcon';

exports.default = AvMicNone;

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvMicOff = function AvMicOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z' })
  );
};
AvMicOff = (0, _pure2.default)(AvMicOff);
AvMicOff.displayName = 'AvMicOff';
AvMicOff.muiName = 'SvgIcon';

exports.default = AvMicOff;

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvMic = function AvMic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
  );
};
AvMic = (0, _pure2.default)(AvMic);
AvMic.displayName = 'AvMic';
AvMic.muiName = 'SvgIcon';

exports.default = AvMic;

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvMovie = function AvMovie(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
  );
};
AvMovie = (0, _pure2.default)(AvMovie);
AvMovie.displayName = 'AvMovie';
AvMovie.muiName = 'SvgIcon';

exports.default = AvMovie;

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvMusicVideo = function AvMusicVideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z' })
  );
};
AvMusicVideo = (0, _pure2.default)(AvMusicVideo);
AvMusicVideo.displayName = 'AvMusicVideo';
AvMusicVideo.muiName = 'SvgIcon';

exports.default = AvMusicVideo;

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvNewReleases = function AvNewReleases(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z' })
  );
};
AvNewReleases = (0, _pure2.default)(AvNewReleases);
AvNewReleases.displayName = 'AvNewReleases';
AvNewReleases.muiName = 'SvgIcon';

exports.default = AvNewReleases;

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvNotInterested = function AvNotInterested(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
  );
};
AvNotInterested = (0, _pure2.default)(AvNotInterested);
AvNotInterested.displayName = 'AvNotInterested';
AvNotInterested.muiName = 'SvgIcon';

exports.default = AvNotInterested;

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvNote = function AvNote(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z' })
  );
};
AvNote = (0, _pure2.default)(AvNote);
AvNote.displayName = 'AvNote';
AvNote.muiName = 'SvgIcon';

exports.default = AvNote;

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPauseCircleFilled = function AvPauseCircleFilled(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z' })
  );
};
AvPauseCircleFilled = (0, _pure2.default)(AvPauseCircleFilled);
AvPauseCircleFilled.displayName = 'AvPauseCircleFilled';
AvPauseCircleFilled.muiName = 'SvgIcon';

exports.default = AvPauseCircleFilled;

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPauseCircleOutline = function AvPauseCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z' })
  );
};
AvPauseCircleOutline = (0, _pure2.default)(AvPauseCircleOutline);
AvPauseCircleOutline.displayName = 'AvPauseCircleOutline';
AvPauseCircleOutline.muiName = 'SvgIcon';

exports.default = AvPauseCircleOutline;

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPause = function AvPause(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' })
  );
};
AvPause = (0, _pure2.default)(AvPause);
AvPause.displayName = 'AvPause';
AvPause.muiName = 'SvgIcon';

exports.default = AvPause;

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlayArrow = function AvPlayArrow(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 5v14l11-7z' })
  );
};
AvPlayArrow = (0, _pure2.default)(AvPlayArrow);
AvPlayArrow.displayName = 'AvPlayArrow';
AvPlayArrow.muiName = 'SvgIcon';

exports.default = AvPlayArrow;

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlayCircleFilled = function AvPlayCircleFilled(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z' })
  );
};
AvPlayCircleFilled = (0, _pure2.default)(AvPlayCircleFilled);
AvPlayCircleFilled.displayName = 'AvPlayCircleFilled';
AvPlayCircleFilled.muiName = 'SvgIcon';

exports.default = AvPlayCircleFilled;

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlayCircleOutline = function AvPlayCircleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
AvPlayCircleOutline = (0, _pure2.default)(AvPlayCircleOutline);
AvPlayCircleOutline.displayName = 'AvPlayCircleOutline';
AvPlayCircleOutline.muiName = 'SvgIcon';

exports.default = AvPlayCircleOutline;

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlaylistAddCheck = function AvPlaylistAddCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z' })
  );
};
AvPlaylistAddCheck = (0, _pure2.default)(AvPlaylistAddCheck);
AvPlaylistAddCheck.displayName = 'AvPlaylistAddCheck';
AvPlaylistAddCheck.muiName = 'SvgIcon';

exports.default = AvPlaylistAddCheck;

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlaylistAdd = function AvPlaylistAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z' })
  );
};
AvPlaylistAdd = (0, _pure2.default)(AvPlaylistAdd);
AvPlaylistAdd.displayName = 'AvPlaylistAdd';
AvPlaylistAdd.muiName = 'SvgIcon';

exports.default = AvPlaylistAdd;

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlaylistPlay = function AvPlaylistPlay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z' })
  );
};
AvPlaylistPlay = (0, _pure2.default)(AvPlaylistPlay);
AvPlaylistPlay.displayName = 'AvPlaylistPlay';
AvPlaylistPlay.muiName = 'SvgIcon';

exports.default = AvPlaylistPlay;

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvQueueMusic = function AvQueueMusic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z' })
  );
};
AvQueueMusic = (0, _pure2.default)(AvQueueMusic);
AvQueueMusic.displayName = 'AvQueueMusic';
AvQueueMusic.muiName = 'SvgIcon';

exports.default = AvQueueMusic;

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvQueuePlayNext = function AvQueuePlayNext(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z' })
  );
};
AvQueuePlayNext = (0, _pure2.default)(AvQueuePlayNext);
AvQueuePlayNext.displayName = 'AvQueuePlayNext';
AvQueuePlayNext.muiName = 'SvgIcon';

exports.default = AvQueuePlayNext;

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvQueue = function AvQueue(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
  );
};
AvQueue = (0, _pure2.default)(AvQueue);
AvQueue.displayName = 'AvQueue';
AvQueue.muiName = 'SvgIcon';

exports.default = AvQueue;

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvRadio = function AvRadio(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z' })
  );
};
AvRadio = (0, _pure2.default)(AvRadio);
AvRadio.displayName = 'AvRadio';
AvRadio.muiName = 'SvgIcon';

exports.default = AvRadio;

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvRecentActors = function AvRecentActors(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z' })
  );
};
AvRecentActors = (0, _pure2.default)(AvRecentActors);
AvRecentActors.displayName = 'AvRecentActors';
AvRecentActors.muiName = 'SvgIcon';

exports.default = AvRecentActors;

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvRemoveFromQueue = function AvRemoveFromQueue(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z' })
  );
};
AvRemoveFromQueue = (0, _pure2.default)(AvRemoveFromQueue);
AvRemoveFromQueue.displayName = 'AvRemoveFromQueue';
AvRemoveFromQueue.muiName = 'SvgIcon';

exports.default = AvRemoveFromQueue;

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvRepeatOne = function AvRepeatOne(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z' })
  );
};
AvRepeatOne = (0, _pure2.default)(AvRepeatOne);
AvRepeatOne.displayName = 'AvRepeatOne';
AvRepeatOne.muiName = 'SvgIcon';

exports.default = AvRepeatOne;

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvRepeat = function AvRepeat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z' })
  );
};
AvRepeat = (0, _pure2.default)(AvRepeat);
AvRepeat.displayName = 'AvRepeat';
AvRepeat.muiName = 'SvgIcon';

exports.default = AvRepeat;

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvReplay10 = function AvReplay10(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
  );
};
AvReplay10 = (0, _pure2.default)(AvReplay10);
AvReplay10.displayName = 'AvReplay10';
AvReplay10.muiName = 'SvgIcon';

exports.default = AvReplay10;

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvReplay30 = function AvReplay30(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
  );
};
AvReplay30 = (0, _pure2.default)(AvReplay30);
AvReplay30.displayName = 'AvReplay30';
AvReplay30.muiName = 'SvgIcon';

exports.default = AvReplay30;

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvReplay5 = function AvReplay5(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z' })
  );
};
AvReplay5 = (0, _pure2.default)(AvReplay5);
AvReplay5.displayName = 'AvReplay5';
AvReplay5.muiName = 'SvgIcon';

exports.default = AvReplay5;

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvShuffle = function AvShuffle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z' })
  );
};
AvShuffle = (0, _pure2.default)(AvShuffle);
AvShuffle.displayName = 'AvShuffle';
AvShuffle.muiName = 'SvgIcon';

exports.default = AvShuffle;

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSkipNext = function AvSkipNext(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z' })
  );
};
AvSkipNext = (0, _pure2.default)(AvSkipNext);
AvSkipNext.displayName = 'AvSkipNext';
AvSkipNext.muiName = 'SvgIcon';

exports.default = AvSkipNext;

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSkipPrevious = function AvSkipPrevious(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' })
  );
};
AvSkipPrevious = (0, _pure2.default)(AvSkipPrevious);
AvSkipPrevious.displayName = 'AvSkipPrevious';
AvSkipPrevious.muiName = 'SvgIcon';

exports.default = AvSkipPrevious;

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSlowMotionVideo = function AvSlowMotionVideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z' })
  );
};
AvSlowMotionVideo = (0, _pure2.default)(AvSlowMotionVideo);
AvSlowMotionVideo.displayName = 'AvSlowMotionVideo';
AvSlowMotionVideo.muiName = 'SvgIcon';

exports.default = AvSlowMotionVideo;

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSnooze = function AvSnooze(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z' })
  );
};
AvSnooze = (0, _pure2.default)(AvSnooze);
AvSnooze.displayName = 'AvSnooze';
AvSnooze.muiName = 'SvgIcon';

exports.default = AvSnooze;

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSortByAlpha = function AvSortByAlpha(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z' })
  );
};
AvSortByAlpha = (0, _pure2.default)(AvSortByAlpha);
AvSortByAlpha.displayName = 'AvSortByAlpha';
AvSortByAlpha.muiName = 'SvgIcon';

exports.default = AvSortByAlpha;

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvStop = function AvStop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 6h12v12H6z' })
  );
};
AvStop = (0, _pure2.default)(AvStop);
AvStop.displayName = 'AvStop';
AvStop.muiName = 'SvgIcon';

exports.default = AvStop;

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSubscriptions = function AvSubscriptions(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z' })
  );
};
AvSubscriptions = (0, _pure2.default)(AvSubscriptions);
AvSubscriptions.displayName = 'AvSubscriptions';
AvSubscriptions.muiName = 'SvgIcon';

exports.default = AvSubscriptions;

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSubtitles = function AvSubtitles(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z' })
  );
};
AvSubtitles = (0, _pure2.default)(AvSubtitles);
AvSubtitles.displayName = 'AvSubtitles';
AvSubtitles.muiName = 'SvgIcon';

exports.default = AvSubtitles;

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSurroundSound = function AvSurroundSound(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
AvSurroundSound = (0, _pure2.default)(AvSurroundSound);
AvSurroundSound.displayName = 'AvSurroundSound';
AvSurroundSound.muiName = 'SvgIcon';

exports.default = AvSurroundSound;

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVideoCall = function AvVideoCall(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z' })
  );
};
AvVideoCall = (0, _pure2.default)(AvVideoCall);
AvVideoCall.displayName = 'AvVideoCall';
AvVideoCall.muiName = 'SvgIcon';

exports.default = AvVideoCall;

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVideoLabel = function AvVideoLabel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z' })
  );
};
AvVideoLabel = (0, _pure2.default)(AvVideoLabel);
AvVideoLabel.displayName = 'AvVideoLabel';
AvVideoLabel.muiName = 'SvgIcon';

exports.default = AvVideoLabel;

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVideoLibrary = function AvVideoLibrary(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z' })
  );
};
AvVideoLibrary = (0, _pure2.default)(AvVideoLibrary);
AvVideoLibrary.displayName = 'AvVideoLibrary';
AvVideoLibrary.muiName = 'SvgIcon';

exports.default = AvVideoLibrary;

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVideocamOff = function AvVideocamOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z' })
  );
};
AvVideocamOff = (0, _pure2.default)(AvVideocamOff);
AvVideocamOff.displayName = 'AvVideocamOff';
AvVideocamOff.muiName = 'SvgIcon';

exports.default = AvVideocamOff;

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVideocam = function AvVideocam(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z' })
  );
};
AvVideocam = (0, _pure2.default)(AvVideocam);
AvVideocam.displayName = 'AvVideocam';
AvVideocam.muiName = 'SvgIcon';

exports.default = AvVideocam;

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVolumeDown = function AvVolumeDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z' })
  );
};
AvVolumeDown = (0, _pure2.default)(AvVolumeDown);
AvVolumeDown.displayName = 'AvVolumeDown';
AvVolumeDown.muiName = 'SvgIcon';

exports.default = AvVolumeDown;

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVolumeMute = function AvVolumeMute(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 9v6h4l5 5V4l-5 5H7z' })
  );
};
AvVolumeMute = (0, _pure2.default)(AvVolumeMute);
AvVolumeMute.displayName = 'AvVolumeMute';
AvVolumeMute.muiName = 'SvgIcon';

exports.default = AvVolumeMute;

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVolumeOff = function AvVolumeOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' })
  );
};
AvVolumeOff = (0, _pure2.default)(AvVolumeOff);
AvVolumeOff.displayName = 'AvVolumeOff';
AvVolumeOff.muiName = 'SvgIcon';

exports.default = AvVolumeOff;

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvVolumeUp = function AvVolumeUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' })
  );
};
AvVolumeUp = (0, _pure2.default)(AvVolumeUp);
AvVolumeUp.displayName = 'AvVolumeUp';
AvVolumeUp.muiName = 'SvgIcon';

exports.default = AvVolumeUp;

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvWebAsset = function AvWebAsset(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z' })
  );
};
AvWebAsset = (0, _pure2.default)(AvWebAsset);
AvWebAsset.displayName = 'AvWebAsset';
AvWebAsset.muiName = 'SvgIcon';

exports.default = AvWebAsset;

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvWeb = function AvWeb(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z' })
  );
};
AvWeb = (0, _pure2.default)(AvWeb);
AvWeb.displayName = 'AvWeb';
AvWeb.muiName = 'SvgIcon';

exports.default = AvWeb;

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationBusiness = function CommunicationBusiness(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
  );
};
CommunicationBusiness = (0, _pure2.default)(CommunicationBusiness);
CommunicationBusiness.displayName = 'CommunicationBusiness';
CommunicationBusiness.muiName = 'SvgIcon';

exports.default = CommunicationBusiness;

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallEnd = function CommunicationCallEnd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z' })
  );
};
CommunicationCallEnd = (0, _pure2.default)(CommunicationCallEnd);
CommunicationCallEnd.displayName = 'CommunicationCallEnd';
CommunicationCallEnd.muiName = 'SvgIcon';

exports.default = CommunicationCallEnd;

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallMade = function CommunicationCallMade(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z' })
  );
};
CommunicationCallMade = (0, _pure2.default)(CommunicationCallMade);
CommunicationCallMade.displayName = 'CommunicationCallMade';
CommunicationCallMade.muiName = 'SvgIcon';

exports.default = CommunicationCallMade;

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallMerge = function CommunicationCallMerge(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
  );
};
CommunicationCallMerge = (0, _pure2.default)(CommunicationCallMerge);
CommunicationCallMerge.displayName = 'CommunicationCallMerge';
CommunicationCallMerge.muiName = 'SvgIcon';

exports.default = CommunicationCallMerge;

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallMissedOutgoing = function CommunicationCallMissedOutgoing(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z' })
  );
};
CommunicationCallMissedOutgoing = (0, _pure2.default)(CommunicationCallMissedOutgoing);
CommunicationCallMissedOutgoing.displayName = 'CommunicationCallMissedOutgoing';
CommunicationCallMissedOutgoing.muiName = 'SvgIcon';

exports.default = CommunicationCallMissedOutgoing;

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallMissed = function CommunicationCallMissed(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z' })
  );
};
CommunicationCallMissed = (0, _pure2.default)(CommunicationCallMissed);
CommunicationCallMissed.displayName = 'CommunicationCallMissed';
CommunicationCallMissed.muiName = 'SvgIcon';

exports.default = CommunicationCallMissed;

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallReceived = function CommunicationCallReceived(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z' })
  );
};
CommunicationCallReceived = (0, _pure2.default)(CommunicationCallReceived);
CommunicationCallReceived.displayName = 'CommunicationCallReceived';
CommunicationCallReceived.muiName = 'SvgIcon';

exports.default = CommunicationCallReceived;

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallSplit = function CommunicationCallSplit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z' })
  );
};
CommunicationCallSplit = (0, _pure2.default)(CommunicationCallSplit);
CommunicationCallSplit.displayName = 'CommunicationCallSplit';
CommunicationCallSplit.muiName = 'SvgIcon';

exports.default = CommunicationCallSplit;

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCall = function CommunicationCall(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
  );
};
CommunicationCall = (0, _pure2.default)(CommunicationCall);
CommunicationCall.displayName = 'CommunicationCall';
CommunicationCall.muiName = 'SvgIcon';

exports.default = CommunicationCall;

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationChatBubbleOutline = function CommunicationChatBubbleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z' })
  );
};
CommunicationChatBubbleOutline = (0, _pure2.default)(CommunicationChatBubbleOutline);
CommunicationChatBubbleOutline.displayName = 'CommunicationChatBubbleOutline';
CommunicationChatBubbleOutline.muiName = 'SvgIcon';

exports.default = CommunicationChatBubbleOutline;

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationChatBubble = function CommunicationChatBubble(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z' })
  );
};
CommunicationChatBubble = (0, _pure2.default)(CommunicationChatBubble);
CommunicationChatBubble.displayName = 'CommunicationChatBubble';
CommunicationChatBubble.muiName = 'SvgIcon';

exports.default = CommunicationChatBubble;

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationChat = function CommunicationChat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z' })
  );
};
CommunicationChat = (0, _pure2.default)(CommunicationChat);
CommunicationChat.displayName = 'CommunicationChat';
CommunicationChat.muiName = 'SvgIcon';

exports.default = CommunicationChat;

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationClearAll = function CommunicationClearAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z' })
  );
};
CommunicationClearAll = (0, _pure2.default)(CommunicationClearAll);
CommunicationClearAll.displayName = 'CommunicationClearAll';
CommunicationClearAll.muiName = 'SvgIcon';

exports.default = CommunicationClearAll;

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationComment = function CommunicationComment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
CommunicationComment = (0, _pure2.default)(CommunicationComment);
CommunicationComment.displayName = 'CommunicationComment';
CommunicationComment.muiName = 'SvgIcon';

exports.default = CommunicationComment;

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationContactMail = function CommunicationContactMail(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z' })
  );
};
CommunicationContactMail = (0, _pure2.default)(CommunicationContactMail);
CommunicationContactMail.displayName = 'CommunicationContactMail';
CommunicationContactMail.muiName = 'SvgIcon';

exports.default = CommunicationContactMail;

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationContactPhone = function CommunicationContactPhone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z' })
  );
};
CommunicationContactPhone = (0, _pure2.default)(CommunicationContactPhone);
CommunicationContactPhone.displayName = 'CommunicationContactPhone';
CommunicationContactPhone.muiName = 'SvgIcon';

exports.default = CommunicationContactPhone;

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationContacts = function CommunicationContacts(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z' })
  );
};
CommunicationContacts = (0, _pure2.default)(CommunicationContacts);
CommunicationContacts.displayName = 'CommunicationContacts';
CommunicationContacts.muiName = 'SvgIcon';

exports.default = CommunicationContacts;

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationDialerSip = function CommunicationDialerSip(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
  );
};
CommunicationDialerSip = (0, _pure2.default)(CommunicationDialerSip);
CommunicationDialerSip.displayName = 'CommunicationDialerSip';
CommunicationDialerSip.muiName = 'SvgIcon';

exports.default = CommunicationDialerSip;

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationDialpad = function CommunicationDialpad(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
CommunicationDialpad = (0, _pure2.default)(CommunicationDialpad);
CommunicationDialpad.displayName = 'CommunicationDialpad';
CommunicationDialpad.muiName = 'SvgIcon';

exports.default = CommunicationDialpad;

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationEmail = function CommunicationEmail(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
  );
};
CommunicationEmail = (0, _pure2.default)(CommunicationEmail);
CommunicationEmail.displayName = 'CommunicationEmail';
CommunicationEmail.muiName = 'SvgIcon';

exports.default = CommunicationEmail;

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationForum = function CommunicationForum(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
  );
};
CommunicationForum = (0, _pure2.default)(CommunicationForum);
CommunicationForum.displayName = 'CommunicationForum';
CommunicationForum.muiName = 'SvgIcon';

exports.default = CommunicationForum;

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationImportContacts = function CommunicationImportContacts(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z' })
  );
};
CommunicationImportContacts = (0, _pure2.default)(CommunicationImportContacts);
CommunicationImportContacts.displayName = 'CommunicationImportContacts';
CommunicationImportContacts.muiName = 'SvgIcon';

exports.default = CommunicationImportContacts;

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationImportExport = function CommunicationImportExport(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z' })
  );
};
CommunicationImportExport = (0, _pure2.default)(CommunicationImportExport);
CommunicationImportExport.displayName = 'CommunicationImportExport';
CommunicationImportExport.muiName = 'SvgIcon';

exports.default = CommunicationImportExport;

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationInvertColorsOff = function CommunicationInvertColorsOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z' })
  );
};
CommunicationInvertColorsOff = (0, _pure2.default)(CommunicationInvertColorsOff);
CommunicationInvertColorsOff.displayName = 'CommunicationInvertColorsOff';
CommunicationInvertColorsOff.muiName = 'SvgIcon';

exports.default = CommunicationInvertColorsOff;

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationLiveHelp = function CommunicationLiveHelp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
  );
};
CommunicationLiveHelp = (0, _pure2.default)(CommunicationLiveHelp);
CommunicationLiveHelp.displayName = 'CommunicationLiveHelp';
CommunicationLiveHelp.muiName = 'SvgIcon';

exports.default = CommunicationLiveHelp;

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationLocationOff = function CommunicationLocationOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z' })
  );
};
CommunicationLocationOff = (0, _pure2.default)(CommunicationLocationOff);
CommunicationLocationOff.displayName = 'CommunicationLocationOff';
CommunicationLocationOff.muiName = 'SvgIcon';

exports.default = CommunicationLocationOff;

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationLocationOn = function CommunicationLocationOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
  );
};
CommunicationLocationOn = (0, _pure2.default)(CommunicationLocationOn);
CommunicationLocationOn.displayName = 'CommunicationLocationOn';
CommunicationLocationOn.muiName = 'SvgIcon';

exports.default = CommunicationLocationOn;

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationMailOutline = function CommunicationMailOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z' })
  );
};
CommunicationMailOutline = (0, _pure2.default)(CommunicationMailOutline);
CommunicationMailOutline.displayName = 'CommunicationMailOutline';
CommunicationMailOutline.muiName = 'SvgIcon';

exports.default = CommunicationMailOutline;

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationMessage = function CommunicationMessage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
CommunicationMessage = (0, _pure2.default)(CommunicationMessage);
CommunicationMessage.displayName = 'CommunicationMessage';
CommunicationMessage.muiName = 'SvgIcon';

exports.default = CommunicationMessage;

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationNoSim = function CommunicationNoSim(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
  );
};
CommunicationNoSim = (0, _pure2.default)(CommunicationNoSim);
CommunicationNoSim.displayName = 'CommunicationNoSim';
CommunicationNoSim.muiName = 'SvgIcon';

exports.default = CommunicationNoSim;

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPhone = function CommunicationPhone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
  );
};
CommunicationPhone = (0, _pure2.default)(CommunicationPhone);
CommunicationPhone.displayName = 'CommunicationPhone';
CommunicationPhone.muiName = 'SvgIcon';

exports.default = CommunicationPhone;

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPhonelinkErase = function CommunicationPhonelinkErase(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
  );
};
CommunicationPhonelinkErase = (0, _pure2.default)(CommunicationPhonelinkErase);
CommunicationPhonelinkErase.displayName = 'CommunicationPhonelinkErase';
CommunicationPhonelinkErase.muiName = 'SvgIcon';

exports.default = CommunicationPhonelinkErase;

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPhonelinkLock = function CommunicationPhonelinkLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z' })
  );
};
CommunicationPhonelinkLock = (0, _pure2.default)(CommunicationPhonelinkLock);
CommunicationPhonelinkLock.displayName = 'CommunicationPhonelinkLock';
CommunicationPhonelinkLock.muiName = 'SvgIcon';

exports.default = CommunicationPhonelinkLock;

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPhonelinkRing = function CommunicationPhonelinkRing(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z' })
  );
};
CommunicationPhonelinkRing = (0, _pure2.default)(CommunicationPhonelinkRing);
CommunicationPhonelinkRing.displayName = 'CommunicationPhonelinkRing';
CommunicationPhonelinkRing.muiName = 'SvgIcon';

exports.default = CommunicationPhonelinkRing;

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPhonelinkSetup = function CommunicationPhonelinkSetup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
  );
};
CommunicationPhonelinkSetup = (0, _pure2.default)(CommunicationPhonelinkSetup);
CommunicationPhonelinkSetup.displayName = 'CommunicationPhonelinkSetup';
CommunicationPhonelinkSetup.muiName = 'SvgIcon';

exports.default = CommunicationPhonelinkSetup;

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPortableWifiOff = function CommunicationPortableWifiOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z' })
  );
};
CommunicationPortableWifiOff = (0, _pure2.default)(CommunicationPortableWifiOff);
CommunicationPortableWifiOff.displayName = 'CommunicationPortableWifiOff';
CommunicationPortableWifiOff.muiName = 'SvgIcon';

exports.default = CommunicationPortableWifiOff;

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationPresentToAll = function CommunicationPresentToAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z' })
  );
};
CommunicationPresentToAll = (0, _pure2.default)(CommunicationPresentToAll);
CommunicationPresentToAll.displayName = 'CommunicationPresentToAll';
CommunicationPresentToAll.muiName = 'SvgIcon';

exports.default = CommunicationPresentToAll;

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationRingVolume = function CommunicationRingVolume(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z' })
  );
};
CommunicationRingVolume = (0, _pure2.default)(CommunicationRingVolume);
CommunicationRingVolume.displayName = 'CommunicationRingVolume';
CommunicationRingVolume.muiName = 'SvgIcon';

exports.default = CommunicationRingVolume;

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationRssFeed = function CommunicationRssFeed(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '6.18', cy: '17.82', r: '2.18' }),
    _react2.default.createElement('path', { d: 'M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z' })
  );
};
CommunicationRssFeed = (0, _pure2.default)(CommunicationRssFeed);
CommunicationRssFeed.displayName = 'CommunicationRssFeed';
CommunicationRssFeed.muiName = 'SvgIcon';

exports.default = CommunicationRssFeed;

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationScreenShare = function CommunicationScreenShare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z' })
  );
};
CommunicationScreenShare = (0, _pure2.default)(CommunicationScreenShare);
CommunicationScreenShare.displayName = 'CommunicationScreenShare';
CommunicationScreenShare.muiName = 'SvgIcon';

exports.default = CommunicationScreenShare;

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationSpeakerPhone = function CommunicationSpeakerPhone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z' })
  );
};
CommunicationSpeakerPhone = (0, _pure2.default)(CommunicationSpeakerPhone);
CommunicationSpeakerPhone.displayName = 'CommunicationSpeakerPhone';
CommunicationSpeakerPhone.muiName = 'SvgIcon';

exports.default = CommunicationSpeakerPhone;

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationStayCurrentLandscape = function CommunicationStayCurrentLandscape(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
  );
};
CommunicationStayCurrentLandscape = (0, _pure2.default)(CommunicationStayCurrentLandscape);
CommunicationStayCurrentLandscape.displayName = 'CommunicationStayCurrentLandscape';
CommunicationStayCurrentLandscape.muiName = 'SvgIcon';

exports.default = CommunicationStayCurrentLandscape;

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationStayCurrentPortrait = function CommunicationStayCurrentPortrait(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
  );
};
CommunicationStayCurrentPortrait = (0, _pure2.default)(CommunicationStayCurrentPortrait);
CommunicationStayCurrentPortrait.displayName = 'CommunicationStayCurrentPortrait';
CommunicationStayCurrentPortrait.muiName = 'SvgIcon';

exports.default = CommunicationStayCurrentPortrait;

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationStayPrimaryLandscape = function CommunicationStayPrimaryLandscape(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
  );
};
CommunicationStayPrimaryLandscape = (0, _pure2.default)(CommunicationStayPrimaryLandscape);
CommunicationStayPrimaryLandscape.displayName = 'CommunicationStayPrimaryLandscape';
CommunicationStayPrimaryLandscape.muiName = 'SvgIcon';

exports.default = CommunicationStayPrimaryLandscape;

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationStayPrimaryPortrait = function CommunicationStayPrimaryPortrait(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
  );
};
CommunicationStayPrimaryPortrait = (0, _pure2.default)(CommunicationStayPrimaryPortrait);
CommunicationStayPrimaryPortrait.displayName = 'CommunicationStayPrimaryPortrait';
CommunicationStayPrimaryPortrait.muiName = 'SvgIcon';

exports.default = CommunicationStayPrimaryPortrait;

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationStopScreenShare = function CommunicationStopScreenShare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z' })
  );
};
CommunicationStopScreenShare = (0, _pure2.default)(CommunicationStopScreenShare);
CommunicationStopScreenShare.displayName = 'CommunicationStopScreenShare';
CommunicationStopScreenShare.muiName = 'SvgIcon';

exports.default = CommunicationStopScreenShare;

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationSwapCalls = function CommunicationSwapCalls(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z' })
  );
};
CommunicationSwapCalls = (0, _pure2.default)(CommunicationSwapCalls);
CommunicationSwapCalls.displayName = 'CommunicationSwapCalls';
CommunicationSwapCalls.muiName = 'SvgIcon';

exports.default = CommunicationSwapCalls;

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationTextsms = function CommunicationTextsms(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
  );
};
CommunicationTextsms = (0, _pure2.default)(CommunicationTextsms);
CommunicationTextsms.displayName = 'CommunicationTextsms';
CommunicationTextsms.muiName = 'SvgIcon';

exports.default = CommunicationTextsms;

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationVoicemail = function CommunicationVoicemail(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z' })
  );
};
CommunicationVoicemail = (0, _pure2.default)(CommunicationVoicemail);
CommunicationVoicemail.displayName = 'CommunicationVoicemail';
CommunicationVoicemail.muiName = 'SvgIcon';

exports.default = CommunicationVoicemail;

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationVpnKey = function CommunicationVpnKey(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
CommunicationVpnKey = (0, _pure2.default)(CommunicationVpnKey);
CommunicationVpnKey.displayName = 'CommunicationVpnKey';
CommunicationVpnKey.muiName = 'SvgIcon';

exports.default = CommunicationVpnKey;

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddBox = function ContentAddBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
  );
};
ContentAddBox = (0, _pure2.default)(ContentAddBox);
ContentAddBox.displayName = 'ContentAddBox';
ContentAddBox.muiName = 'SvgIcon';

exports.default = ContentAddBox;

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentAddCircle = function ContentAddCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
  );
};
ContentAddCircle = (0, _pure2.default)(ContentAddCircle);
ContentAddCircle.displayName = 'ContentAddCircle';
ContentAddCircle.muiName = 'SvgIcon';

exports.default = ContentAddCircle;

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentArchive = function ContentArchive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z' })
  );
};
ContentArchive = (0, _pure2.default)(ContentArchive);
ContentArchive.displayName = 'ContentArchive';
ContentArchive.muiName = 'SvgIcon';

exports.default = ContentArchive;

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentBackspace = function ContentBackspace(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z' })
  );
};
ContentBackspace = (0, _pure2.default)(ContentBackspace);
ContentBackspace.displayName = 'ContentBackspace';
ContentBackspace.muiName = 'SvgIcon';

exports.default = ContentBackspace;

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentBlock = function ContentBlock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z' })
  );
};
ContentBlock = (0, _pure2.default)(ContentBlock);
ContentBlock.displayName = 'ContentBlock';
ContentBlock.muiName = 'SvgIcon';

exports.default = ContentBlock;

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContentCut = function ContentContentCut(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z' })
  );
};
ContentContentCut = (0, _pure2.default)(ContentContentCut);
ContentContentCut.displayName = 'ContentContentCut';
ContentContentCut.muiName = 'SvgIcon';

exports.default = ContentContentCut;

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContentPaste = function ContentContentPaste(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z' })
  );
};
ContentContentPaste = (0, _pure2.default)(ContentContentPaste);
ContentContentPaste.displayName = 'ContentContentPaste';
ContentContentPaste.muiName = 'SvgIcon';

exports.default = ContentContentPaste;

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentDrafts = function ContentDrafts(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z' })
  );
};
ContentDrafts = (0, _pure2.default)(ContentDrafts);
ContentDrafts.displayName = 'ContentDrafts';
ContentDrafts.muiName = 'SvgIcon';

exports.default = ContentDrafts;

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFilterList = function ContentFilterList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' })
  );
};
ContentFilterList = (0, _pure2.default)(ContentFilterList);
ContentFilterList.displayName = 'ContentFilterList';
ContentFilterList.muiName = 'SvgIcon';

exports.default = ContentFilterList;

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFlag = function ContentFlag(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
  );
};
ContentFlag = (0, _pure2.default)(ContentFlag);
ContentFlag.displayName = 'ContentFlag';
ContentFlag.muiName = 'SvgIcon';

exports.default = ContentFlag;

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentFontDownload = function ContentFontDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
  );
};
ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
ContentFontDownload.displayName = 'ContentFontDownload';
ContentFontDownload.muiName = 'SvgIcon';

exports.default = ContentFontDownload;

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentForward = function ContentForward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8V4l8 8-8 8v-4H4V8z' })
  );
};
ContentForward = (0, _pure2.default)(ContentForward);
ContentForward.displayName = 'ContentForward';
ContentForward.muiName = 'SvgIcon';

exports.default = ContentForward;

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentGesture = function ContentGesture(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z' })
  );
};
ContentGesture = (0, _pure2.default)(ContentGesture);
ContentGesture.displayName = 'ContentGesture';
ContentGesture.muiName = 'SvgIcon';

exports.default = ContentGesture;

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentInbox = function ContentInbox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z' })
  );
};
ContentInbox = (0, _pure2.default)(ContentInbox);
ContentInbox.displayName = 'ContentInbox';
ContentInbox.muiName = 'SvgIcon';

exports.default = ContentInbox;

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentLink = function ContentLink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
  );
};
ContentLink = (0, _pure2.default)(ContentLink);
ContentLink.displayName = 'ContentLink';
ContentLink.muiName = 'SvgIcon';

exports.default = ContentLink;

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentLowPriority = function ContentLowPriority(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z' })
  );
};
ContentLowPriority = (0, _pure2.default)(ContentLowPriority);
ContentLowPriority.displayName = 'ContentLowPriority';
ContentLowPriority.muiName = 'SvgIcon';

exports.default = ContentLowPriority;

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentMail = function ContentMail(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
  );
};
ContentMail = (0, _pure2.default)(ContentMail);
ContentMail.displayName = 'ContentMail';
ContentMail.muiName = 'SvgIcon';

exports.default = ContentMail;

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentMarkunread = function ContentMarkunread(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
  );
};
ContentMarkunread = (0, _pure2.default)(ContentMarkunread);
ContentMarkunread.displayName = 'ContentMarkunread';
ContentMarkunread.muiName = 'SvgIcon';

exports.default = ContentMarkunread;

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentMoveToInbox = function ContentMoveToInbox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z' })
  );
};
ContentMoveToInbox = (0, _pure2.default)(ContentMoveToInbox);
ContentMoveToInbox.displayName = 'ContentMoveToInbox';
ContentMoveToInbox.muiName = 'SvgIcon';

exports.default = ContentMoveToInbox;

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentNextWeek = function ContentNextWeek(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z' })
  );
};
ContentNextWeek = (0, _pure2.default)(ContentNextWeek);
ContentNextWeek.displayName = 'ContentNextWeek';
ContentNextWeek.muiName = 'SvgIcon';

exports.default = ContentNextWeek;

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentRedo = function ContentRedo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z' })
  );
};
ContentRedo = (0, _pure2.default)(ContentRedo);
ContentRedo.displayName = 'ContentRedo';
ContentRedo.muiName = 'SvgIcon';

exports.default = ContentRedo;

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentRemoveCircle = function ContentRemoveCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
  );
};
ContentRemoveCircle = (0, _pure2.default)(ContentRemoveCircle);
ContentRemoveCircle.displayName = 'ContentRemoveCircle';
ContentRemoveCircle.muiName = 'SvgIcon';

exports.default = ContentRemoveCircle;

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentReplyAll = function ContentReplyAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
  );
};
ContentReplyAll = (0, _pure2.default)(ContentReplyAll);
ContentReplyAll.displayName = 'ContentReplyAll';
ContentReplyAll.muiName = 'SvgIcon';

exports.default = ContentReplyAll;

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentReply = function ContentReply(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
  );
};
ContentReply = (0, _pure2.default)(ContentReply);
ContentReply.displayName = 'ContentReply';
ContentReply.muiName = 'SvgIcon';

exports.default = ContentReply;

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentReport = function ContentReport(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z' })
  );
};
ContentReport = (0, _pure2.default)(ContentReport);
ContentReport.displayName = 'ContentReport';
ContentReport.muiName = 'SvgIcon';

exports.default = ContentReport;

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSelectAll = function ContentSelectAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z' })
  );
};
ContentSelectAll = (0, _pure2.default)(ContentSelectAll);
ContentSelectAll.displayName = 'ContentSelectAll';
ContentSelectAll.muiName = 'SvgIcon';

exports.default = ContentSelectAll;

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSend = function ContentSend(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' })
  );
};
ContentSend = (0, _pure2.default)(ContentSend);
ContentSend.displayName = 'ContentSend';
ContentSend.muiName = 'SvgIcon';

exports.default = ContentSend;

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentSort = function ContentSort(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z' })
  );
};
ContentSort = (0, _pure2.default)(ContentSort);
ContentSort.displayName = 'ContentSort';
ContentSort.muiName = 'SvgIcon';

exports.default = ContentSort;

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentTextFormat = function ContentTextFormat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z' })
  );
};
ContentTextFormat = (0, _pure2.default)(ContentTextFormat);
ContentTextFormat.displayName = 'ContentTextFormat';
ContentTextFormat.muiName = 'SvgIcon';

exports.default = ContentTextFormat;

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentUnarchive = function ContentUnarchive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z' })
  );
};
ContentUnarchive = (0, _pure2.default)(ContentUnarchive);
ContentUnarchive.displayName = 'ContentUnarchive';
ContentUnarchive.muiName = 'SvgIcon';

exports.default = ContentUnarchive;

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentUndo = function ContentUndo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z' })
  );
};
ContentUndo = (0, _pure2.default)(ContentUndo);
ContentUndo.displayName = 'ContentUndo';
ContentUndo.muiName = 'SvgIcon';

exports.default = ContentUndo;

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWeekend = function ContentWeekend(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z' })
  );
};
ContentWeekend = (0, _pure2.default)(ContentWeekend);
ContentWeekend.displayName = 'ContentWeekend';
ContentWeekend.muiName = 'SvgIcon';

exports.default = ContentWeekend;

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAccessAlarm = function DeviceAccessAlarm(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
DeviceAccessAlarm = (0, _pure2.default)(DeviceAccessAlarm);
DeviceAccessAlarm.displayName = 'DeviceAccessAlarm';
DeviceAccessAlarm.muiName = 'SvgIcon';

exports.default = DeviceAccessAlarm;

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAccessAlarms = function DeviceAccessAlarms(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z' })
  );
};
DeviceAccessAlarms = (0, _pure2.default)(DeviceAccessAlarms);
DeviceAccessAlarms.displayName = 'DeviceAccessAlarms';
DeviceAccessAlarms.muiName = 'SvgIcon';

exports.default = DeviceAccessAlarms;

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAccessTime = function DeviceAccessTime(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
  );
};
DeviceAccessTime = (0, _pure2.default)(DeviceAccessTime);
DeviceAccessTime.displayName = 'DeviceAccessTime';
DeviceAccessTime.muiName = 'SvgIcon';

exports.default = DeviceAccessTime;

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAddAlarm = function DeviceAddAlarm(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
  );
};
DeviceAddAlarm = (0, _pure2.default)(DeviceAddAlarm);
DeviceAddAlarm.displayName = 'DeviceAddAlarm';
DeviceAddAlarm.muiName = 'SvgIcon';

exports.default = DeviceAddAlarm;

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAirplanemodeActive = function DeviceAirplanemodeActive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.18 9' }),
    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
  );
};
DeviceAirplanemodeActive = (0, _pure2.default)(DeviceAirplanemodeActive);
DeviceAirplanemodeActive.displayName = 'DeviceAirplanemodeActive';
DeviceAirplanemodeActive.muiName = 'SvgIcon';

exports.default = DeviceAirplanemodeActive;

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceAirplanemodeInactive = function DeviceAirplanemodeInactive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z' })
  );
};
DeviceAirplanemodeInactive = (0, _pure2.default)(DeviceAirplanemodeInactive);
DeviceAirplanemodeInactive.displayName = 'DeviceAirplanemodeInactive';
DeviceAirplanemodeInactive.muiName = 'SvgIcon';

exports.default = DeviceAirplanemodeInactive;

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBattery20 = function DeviceBattery20(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z' }),
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z' })
  );
};
DeviceBattery20 = (0, _pure2.default)(DeviceBattery20);
DeviceBattery20.displayName = 'DeviceBattery20';
DeviceBattery20.muiName = 'SvgIcon';

exports.default = DeviceBattery20;

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBattery30 = function DeviceBattery30(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z' }),
    _react2.default.createElement('path', { d: 'M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z' })
  );
};
DeviceBattery30 = (0, _pure2.default)(DeviceBattery30);
DeviceBattery30.displayName = 'DeviceBattery30';
DeviceBattery30.muiName = 'SvgIcon';

exports.default = DeviceBattery30;

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBattery50 = function DeviceBattery50(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z' }),
    _react2.default.createElement('path', { d: 'M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z' })
  );
};
DeviceBattery50 = (0, _pure2.default)(DeviceBattery50);
DeviceBattery50.displayName = 'DeviceBattery50';
DeviceBattery50.muiName = 'SvgIcon';

exports.default = DeviceBattery50;

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBattery60 = function DeviceBattery60(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z' }),
    _react2.default.createElement('path', { d: 'M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z' })
  );
};
DeviceBattery60 = (0, _pure2.default)(DeviceBattery60);
DeviceBattery60.displayName = 'DeviceBattery60';
DeviceBattery60.muiName = 'SvgIcon';

exports.default = DeviceBattery60;

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBattery80 = function DeviceBattery80(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z' }),
    _react2.default.createElement('path', { d: 'M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z' })
  );
};
DeviceBattery80 = (0, _pure2.default)(DeviceBattery80);
DeviceBattery80.displayName = 'DeviceBattery80';
DeviceBattery80.muiName = 'SvgIcon';

exports.default = DeviceBattery80;

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBattery90 = function DeviceBattery90(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z' }),
    _react2.default.createElement('path', { d: 'M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z' })
  );
};
DeviceBattery90 = (0, _pure2.default)(DeviceBattery90);
DeviceBattery90.displayName = 'DeviceBattery90';
DeviceBattery90.muiName = 'SvgIcon';

exports.default = DeviceBattery90;

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryAlert = function DeviceBatteryAlert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z' })
  );
};
DeviceBatteryAlert = (0, _pure2.default)(DeviceBatteryAlert);
DeviceBatteryAlert.displayName = 'DeviceBatteryAlert';
DeviceBatteryAlert.muiName = 'SvgIcon';

exports.default = DeviceBatteryAlert;

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryCharging20 = function DeviceBatteryCharging20(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z' }),
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z' })
  );
};
DeviceBatteryCharging20 = (0, _pure2.default)(DeviceBatteryCharging20);
DeviceBatteryCharging20.displayName = 'DeviceBatteryCharging20';
DeviceBatteryCharging20.muiName = 'SvgIcon';

exports.default = DeviceBatteryCharging20;

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryCharging30 = function DeviceBatteryCharging30(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z' }),
    _react2.default.createElement('path', { d: 'M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z' })
  );
};
DeviceBatteryCharging30 = (0, _pure2.default)(DeviceBatteryCharging30);
DeviceBatteryCharging30.displayName = 'DeviceBatteryCharging30';
DeviceBatteryCharging30.muiName = 'SvgIcon';

exports.default = DeviceBatteryCharging30;

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryCharging50 = function DeviceBatteryCharging50(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z' }),
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z' })
  );
};
DeviceBatteryCharging50 = (0, _pure2.default)(DeviceBatteryCharging50);
DeviceBatteryCharging50.displayName = 'DeviceBatteryCharging50';
DeviceBatteryCharging50.muiName = 'SvgIcon';

exports.default = DeviceBatteryCharging50;

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryCharging60 = function DeviceBatteryCharging60(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z' }),
    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z' })
  );
};
DeviceBatteryCharging60 = (0, _pure2.default)(DeviceBatteryCharging60);
DeviceBatteryCharging60.displayName = 'DeviceBatteryCharging60';
DeviceBatteryCharging60.muiName = 'SvgIcon';

exports.default = DeviceBatteryCharging60;

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryCharging80 = function DeviceBatteryCharging80(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z' }),
    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z' })
  );
};
DeviceBatteryCharging80 = (0, _pure2.default)(DeviceBatteryCharging80);
DeviceBatteryCharging80.displayName = 'DeviceBatteryCharging80';
DeviceBatteryCharging80.muiName = 'SvgIcon';

exports.default = DeviceBatteryCharging80;

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryCharging90 = function DeviceBatteryCharging90(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z' }),
    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z' })
  );
};
DeviceBatteryCharging90 = (0, _pure2.default)(DeviceBatteryCharging90);
DeviceBatteryCharging90.displayName = 'DeviceBatteryCharging90';
DeviceBatteryCharging90.muiName = 'SvgIcon';

exports.default = DeviceBatteryCharging90;

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryChargingFull = function DeviceBatteryChargingFull(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z' })
  );
};
DeviceBatteryChargingFull = (0, _pure2.default)(DeviceBatteryChargingFull);
DeviceBatteryChargingFull.displayName = 'DeviceBatteryChargingFull';
DeviceBatteryChargingFull.muiName = 'SvgIcon';

exports.default = DeviceBatteryChargingFull;

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryFull = function DeviceBatteryFull(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
  );
};
DeviceBatteryFull = (0, _pure2.default)(DeviceBatteryFull);
DeviceBatteryFull.displayName = 'DeviceBatteryFull';
DeviceBatteryFull.muiName = 'SvgIcon';

exports.default = DeviceBatteryFull;

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryStd = function DeviceBatteryStd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
  );
};
DeviceBatteryStd = (0, _pure2.default)(DeviceBatteryStd);
DeviceBatteryStd.displayName = 'DeviceBatteryStd';
DeviceBatteryStd.muiName = 'SvgIcon';

exports.default = DeviceBatteryStd;

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryUnknown = function DeviceBatteryUnknown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z' })
  );
};
DeviceBatteryUnknown = (0, _pure2.default)(DeviceBatteryUnknown);
DeviceBatteryUnknown.displayName = 'DeviceBatteryUnknown';
DeviceBatteryUnknown.muiName = 'SvgIcon';

exports.default = DeviceBatteryUnknown;

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBluetoothConnected = function DeviceBluetoothConnected(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z' })
  );
};
DeviceBluetoothConnected = (0, _pure2.default)(DeviceBluetoothConnected);
DeviceBluetoothConnected.displayName = 'DeviceBluetoothConnected';
DeviceBluetoothConnected.muiName = 'SvgIcon';

exports.default = DeviceBluetoothConnected;

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBluetoothDisabled = function DeviceBluetoothDisabled(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z' })
  );
};
DeviceBluetoothDisabled = (0, _pure2.default)(DeviceBluetoothDisabled);
DeviceBluetoothDisabled.displayName = 'DeviceBluetoothDisabled';
DeviceBluetoothDisabled.muiName = 'SvgIcon';

exports.default = DeviceBluetoothDisabled;

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBluetoothSearching = function DeviceBluetoothSearching(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
  );
};
DeviceBluetoothSearching = (0, _pure2.default)(DeviceBluetoothSearching);
DeviceBluetoothSearching.displayName = 'DeviceBluetoothSearching';
DeviceBluetoothSearching.muiName = 'SvgIcon';

exports.default = DeviceBluetoothSearching;

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBluetooth = function DeviceBluetooth(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z' })
  );
};
DeviceBluetooth = (0, _pure2.default)(DeviceBluetooth);
DeviceBluetooth.displayName = 'DeviceBluetooth';
DeviceBluetooth.muiName = 'SvgIcon';

exports.default = DeviceBluetooth;

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBrightnessAuto = function DeviceBrightnessAuto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z' })
  );
};
DeviceBrightnessAuto = (0, _pure2.default)(DeviceBrightnessAuto);
DeviceBrightnessAuto.displayName = 'DeviceBrightnessAuto';
DeviceBrightnessAuto.muiName = 'SvgIcon';

exports.default = DeviceBrightnessAuto;

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBrightnessHigh = function DeviceBrightnessHigh(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
  );
};
DeviceBrightnessHigh = (0, _pure2.default)(DeviceBrightnessHigh);
DeviceBrightnessHigh.displayName = 'DeviceBrightnessHigh';
DeviceBrightnessHigh.muiName = 'SvgIcon';

exports.default = DeviceBrightnessHigh;

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBrightnessLow = function DeviceBrightnessLow(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
  );
};
DeviceBrightnessLow = (0, _pure2.default)(DeviceBrightnessLow);
DeviceBrightnessLow.displayName = 'DeviceBrightnessLow';
DeviceBrightnessLow.muiName = 'SvgIcon';

exports.default = DeviceBrightnessLow;

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBrightnessMedium = function DeviceBrightnessMedium(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
  );
};
DeviceBrightnessMedium = (0, _pure2.default)(DeviceBrightnessMedium);
DeviceBrightnessMedium.displayName = 'DeviceBrightnessMedium';
DeviceBrightnessMedium.muiName = 'SvgIcon';

exports.default = DeviceBrightnessMedium;

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceDataUsage = function DeviceDataUsage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z' })
  );
};
DeviceDataUsage = (0, _pure2.default)(DeviceDataUsage);
DeviceDataUsage.displayName = 'DeviceDataUsage';
DeviceDataUsage.muiName = 'SvgIcon';

exports.default = DeviceDataUsage;

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceDeveloperMode = function DeviceDeveloperMode(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z' })
  );
};
DeviceDeveloperMode = (0, _pure2.default)(DeviceDeveloperMode);
DeviceDeveloperMode.displayName = 'DeviceDeveloperMode';
DeviceDeveloperMode.muiName = 'SvgIcon';

exports.default = DeviceDeveloperMode;

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceDevices = function DeviceDevices(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
  );
};
DeviceDevices = (0, _pure2.default)(DeviceDevices);
DeviceDevices.displayName = 'DeviceDevices';
DeviceDevices.muiName = 'SvgIcon';

exports.default = DeviceDevices;

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceDvr = function DeviceDvr(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z' })
  );
};
DeviceDvr = (0, _pure2.default)(DeviceDvr);
DeviceDvr.displayName = 'DeviceDvr';
DeviceDvr.muiName = 'SvgIcon';

exports.default = DeviceDvr;

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceGpsFixed = function DeviceGpsFixed(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
DeviceGpsFixed = (0, _pure2.default)(DeviceGpsFixed);
DeviceGpsFixed.displayName = 'DeviceGpsFixed';
DeviceGpsFixed.muiName = 'SvgIcon';

exports.default = DeviceGpsFixed;

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceGpsNotFixed = function DeviceGpsNotFixed(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
DeviceGpsNotFixed = (0, _pure2.default)(DeviceGpsNotFixed);
DeviceGpsNotFixed.displayName = 'DeviceGpsNotFixed';
DeviceGpsNotFixed.muiName = 'SvgIcon';

exports.default = DeviceGpsNotFixed;

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceGpsOff = function DeviceGpsOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
  );
};
DeviceGpsOff = (0, _pure2.default)(DeviceGpsOff);
DeviceGpsOff.displayName = 'DeviceGpsOff';
DeviceGpsOff.muiName = 'SvgIcon';

exports.default = DeviceGpsOff;

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceGraphicEq = function DeviceGraphicEq(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z' })
  );
};
DeviceGraphicEq = (0, _pure2.default)(DeviceGraphicEq);
DeviceGraphicEq.displayName = 'DeviceGraphicEq';
DeviceGraphicEq.muiName = 'SvgIcon';

exports.default = DeviceGraphicEq;

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceLocationDisabled = function DeviceLocationDisabled(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
  );
};
DeviceLocationDisabled = (0, _pure2.default)(DeviceLocationDisabled);
DeviceLocationDisabled.displayName = 'DeviceLocationDisabled';
DeviceLocationDisabled.muiName = 'SvgIcon';

exports.default = DeviceLocationDisabled;

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceLocationSearching = function DeviceLocationSearching(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
DeviceLocationSearching = (0, _pure2.default)(DeviceLocationSearching);
DeviceLocationSearching.displayName = 'DeviceLocationSearching';
DeviceLocationSearching.muiName = 'SvgIcon';

exports.default = DeviceLocationSearching;

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceNetworkCell = function DeviceNetworkCell(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
  );
};
DeviceNetworkCell = (0, _pure2.default)(DeviceNetworkCell);
DeviceNetworkCell.displayName = 'DeviceNetworkCell';
DeviceNetworkCell.muiName = 'SvgIcon';

exports.default = DeviceNetworkCell;

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceNetworkWifi = function DeviceNetworkWifi(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
  );
};
DeviceNetworkWifi = (0, _pure2.default)(DeviceNetworkWifi);
DeviceNetworkWifi.displayName = 'DeviceNetworkWifi';
DeviceNetworkWifi.muiName = 'SvgIcon';

exports.default = DeviceNetworkWifi;

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceNfc = function DeviceNfc(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z' })
  );
};
DeviceNfc = (0, _pure2.default)(DeviceNfc);
DeviceNfc.displayName = 'DeviceNfc';
DeviceNfc.muiName = 'SvgIcon';

exports.default = DeviceNfc;

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceScreenLockLandscape = function DeviceScreenLockLandscape(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z' })
  );
};
DeviceScreenLockLandscape = (0, _pure2.default)(DeviceScreenLockLandscape);
DeviceScreenLockLandscape.displayName = 'DeviceScreenLockLandscape';
DeviceScreenLockLandscape.muiName = 'SvgIcon';

exports.default = DeviceScreenLockLandscape;

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceScreenLockPortrait = function DeviceScreenLockPortrait(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z' })
  );
};
DeviceScreenLockPortrait = (0, _pure2.default)(DeviceScreenLockPortrait);
DeviceScreenLockPortrait.displayName = 'DeviceScreenLockPortrait';
DeviceScreenLockPortrait.muiName = 'SvgIcon';

exports.default = DeviceScreenLockPortrait;

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceScreenLockRotation = function DeviceScreenLockRotation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z' })
  );
};
DeviceScreenLockRotation = (0, _pure2.default)(DeviceScreenLockRotation);
DeviceScreenLockRotation.displayName = 'DeviceScreenLockRotation';
DeviceScreenLockRotation.muiName = 'SvgIcon';

exports.default = DeviceScreenLockRotation;

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceScreenRotation = function DeviceScreenRotation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z' })
  );
};
DeviceScreenRotation = (0, _pure2.default)(DeviceScreenRotation);
DeviceScreenRotation.displayName = 'DeviceScreenRotation';
DeviceScreenRotation.muiName = 'SvgIcon';

exports.default = DeviceScreenRotation;

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSdStorage = function DeviceSdStorage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
  );
};
DeviceSdStorage = (0, _pure2.default)(DeviceSdStorage);
DeviceSdStorage.displayName = 'DeviceSdStorage';
DeviceSdStorage.muiName = 'SvgIcon';

exports.default = DeviceSdStorage;

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSettingsSystemDaydream = function DeviceSettingsSystemDaydream(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
  );
};
DeviceSettingsSystemDaydream = (0, _pure2.default)(DeviceSettingsSystemDaydream);
DeviceSettingsSystemDaydream.displayName = 'DeviceSettingsSystemDaydream';
DeviceSettingsSystemDaydream.muiName = 'SvgIcon';

exports.default = DeviceSettingsSystemDaydream;

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellular0Bar = function DeviceSignalCellular0Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' })
  );
};
DeviceSignalCellular0Bar = (0, _pure2.default)(DeviceSignalCellular0Bar);
DeviceSignalCellular0Bar.displayName = 'DeviceSignalCellular0Bar';
DeviceSignalCellular0Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellular0Bar;

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellular1Bar = function DeviceSignalCellular1Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
    _react2.default.createElement('path', { d: 'M12 12L2 22h10z' })
  );
};
DeviceSignalCellular1Bar = (0, _pure2.default)(DeviceSignalCellular1Bar);
DeviceSignalCellular1Bar.displayName = 'DeviceSignalCellular1Bar';
DeviceSignalCellular1Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellular1Bar;

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellular2Bar = function DeviceSignalCellular2Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
    _react2.default.createElement('path', { d: 'M14 10L2 22h12z' })
  );
};
DeviceSignalCellular2Bar = (0, _pure2.default)(DeviceSignalCellular2Bar);
DeviceSignalCellular2Bar.displayName = 'DeviceSignalCellular2Bar';
DeviceSignalCellular2Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellular2Bar;

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellular3Bar = function DeviceSignalCellular3Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
  );
};
DeviceSignalCellular3Bar = (0, _pure2.default)(DeviceSignalCellular3Bar);
DeviceSignalCellular3Bar.displayName = 'DeviceSignalCellular3Bar';
DeviceSignalCellular3Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellular3Bar;

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellular4Bar = function DeviceSignalCellular4Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 22h20V2z' })
  );
};
DeviceSignalCellular4Bar = (0, _pure2.default)(DeviceSignalCellular4Bar);
DeviceSignalCellular4Bar.displayName = 'DeviceSignalCellular4Bar';
DeviceSignalCellular4Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellular4Bar;

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularConnectedNoInternet0Bar = function DeviceSignalCellularConnectedNoInternet0Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
    _react2.default.createElement('path', { d: 'M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z' })
  );
};
DeviceSignalCellularConnectedNoInternet0Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet0Bar);
DeviceSignalCellularConnectedNoInternet0Bar.displayName = 'DeviceSignalCellularConnectedNoInternet0Bar';
DeviceSignalCellularConnectedNoInternet0Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularConnectedNoInternet0Bar;

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularConnectedNoInternet1Bar = function DeviceSignalCellularConnectedNoInternet1Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
    _react2.default.createElement('path', { d: 'M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z' })
  );
};
DeviceSignalCellularConnectedNoInternet1Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet1Bar);
DeviceSignalCellularConnectedNoInternet1Bar.displayName = 'DeviceSignalCellularConnectedNoInternet1Bar';
DeviceSignalCellularConnectedNoInternet1Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularConnectedNoInternet1Bar;

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularConnectedNoInternet2Bar = function DeviceSignalCellularConnectedNoInternet2Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
    _react2.default.createElement('path', { d: 'M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
  );
};
DeviceSignalCellularConnectedNoInternet2Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet2Bar);
DeviceSignalCellularConnectedNoInternet2Bar.displayName = 'DeviceSignalCellularConnectedNoInternet2Bar';
DeviceSignalCellularConnectedNoInternet2Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularConnectedNoInternet2Bar;

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularConnectedNoInternet3Bar = function DeviceSignalCellularConnectedNoInternet3Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
    _react2.default.createElement('path', { d: 'M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
  );
};
DeviceSignalCellularConnectedNoInternet3Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet3Bar);
DeviceSignalCellularConnectedNoInternet3Bar.displayName = 'DeviceSignalCellularConnectedNoInternet3Bar';
DeviceSignalCellularConnectedNoInternet3Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularConnectedNoInternet3Bar;

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularConnectedNoInternet4Bar = function DeviceSignalCellularConnectedNoInternet4Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z' })
  );
};
DeviceSignalCellularConnectedNoInternet4Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet4Bar);
DeviceSignalCellularConnectedNoInternet4Bar.displayName = 'DeviceSignalCellularConnectedNoInternet4Bar';
DeviceSignalCellularConnectedNoInternet4Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularConnectedNoInternet4Bar;

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularNoSim = function DeviceSignalCellularNoSim(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
  );
};
DeviceSignalCellularNoSim = (0, _pure2.default)(DeviceSignalCellularNoSim);
DeviceSignalCellularNoSim.displayName = 'DeviceSignalCellularNoSim';
DeviceSignalCellularNoSim.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularNoSim;

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularNull = function DeviceSignalCellularNull(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z' })
  );
};
DeviceSignalCellularNull = (0, _pure2.default)(DeviceSignalCellularNull);
DeviceSignalCellularNull.displayName = 'DeviceSignalCellularNull';
DeviceSignalCellularNull.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularNull;

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalCellularOff = function DeviceSignalCellularOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z' })
  );
};
DeviceSignalCellularOff = (0, _pure2.default)(DeviceSignalCellularOff);
DeviceSignalCellularOff.displayName = 'DeviceSignalCellularOff';
DeviceSignalCellularOff.muiName = 'SvgIcon';

exports.default = DeviceSignalCellularOff;

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi0Bar = function DeviceSignalWifi0Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
  );
};
DeviceSignalWifi0Bar = (0, _pure2.default)(DeviceSignalWifi0Bar);
DeviceSignalWifi0Bar.displayName = 'DeviceSignalWifi0Bar';
DeviceSignalWifi0Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi0Bar;

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi1BarLock = function DeviceSignalWifi1BarLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
    _react2.default.createElement('path', { d: 'M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z' })
  );
};
DeviceSignalWifi1BarLock = (0, _pure2.default)(DeviceSignalWifi1BarLock);
DeviceSignalWifi1BarLock.displayName = 'DeviceSignalWifi1BarLock';
DeviceSignalWifi1BarLock.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi1BarLock;

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi1Bar = function DeviceSignalWifi1Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
    _react2.default.createElement('path', { d: 'M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z' })
  );
};
DeviceSignalWifi1Bar = (0, _pure2.default)(DeviceSignalWifi1Bar);
DeviceSignalWifi1Bar.displayName = 'DeviceSignalWifi1Bar';
DeviceSignalWifi1Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi1Bar;

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi2BarLock = function DeviceSignalWifi2BarLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
    _react2.default.createElement('path', { d: 'M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z' })
  );
};
DeviceSignalWifi2BarLock = (0, _pure2.default)(DeviceSignalWifi2BarLock);
DeviceSignalWifi2BarLock.displayName = 'DeviceSignalWifi2BarLock';
DeviceSignalWifi2BarLock.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi2BarLock;

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi2Bar = function DeviceSignalWifi2Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
    _react2.default.createElement('path', { d: 'M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z' })
  );
};
DeviceSignalWifi2Bar = (0, _pure2.default)(DeviceSignalWifi2Bar);
DeviceSignalWifi2Bar.displayName = 'DeviceSignalWifi2Bar';
DeviceSignalWifi2Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi2Bar;

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi3BarLock = function DeviceSignalWifi3BarLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { opacity: '.3', d: 'M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z' }),
    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9' })
  );
};
DeviceSignalWifi3BarLock = (0, _pure2.default)(DeviceSignalWifi3BarLock);
DeviceSignalWifi3BarLock.displayName = 'DeviceSignalWifi3BarLock';
DeviceSignalWifi3BarLock.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi3BarLock;

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi3Bar = function DeviceSignalWifi3Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
  );
};
DeviceSignalWifi3Bar = (0, _pure2.default)(DeviceSignalWifi3Bar);
DeviceSignalWifi3Bar.displayName = 'DeviceSignalWifi3Bar';
DeviceSignalWifi3Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi3Bar;

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi4BarLock = function DeviceSignalWifi4BarLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z' })
  );
};
DeviceSignalWifi4BarLock = (0, _pure2.default)(DeviceSignalWifi4BarLock);
DeviceSignalWifi4BarLock.displayName = 'DeviceSignalWifi4BarLock';
DeviceSignalWifi4BarLock.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi4BarLock;

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifi4Bar = function DeviceSignalWifi4Bar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
  );
};
DeviceSignalWifi4Bar = (0, _pure2.default)(DeviceSignalWifi4Bar);
DeviceSignalWifi4Bar.displayName = 'DeviceSignalWifi4Bar';
DeviceSignalWifi4Bar.muiName = 'SvgIcon';

exports.default = DeviceSignalWifi4Bar;

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSignalWifiOff = function DeviceSignalWifiOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z' })
  );
};
DeviceSignalWifiOff = (0, _pure2.default)(DeviceSignalWifiOff);
DeviceSignalWifiOff.displayName = 'DeviceSignalWifiOff';
DeviceSignalWifiOff.muiName = 'SvgIcon';

exports.default = DeviceSignalWifiOff;

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceStorage = function DeviceStorage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' })
  );
};
DeviceStorage = (0, _pure2.default)(DeviceStorage);
DeviceStorage.displayName = 'DeviceStorage';
DeviceStorage.muiName = 'SvgIcon';

exports.default = DeviceStorage;

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceUsb = function DeviceUsb(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z' })
  );
};
DeviceUsb = (0, _pure2.default)(DeviceUsb);
DeviceUsb.displayName = 'DeviceUsb';
DeviceUsb.muiName = 'SvgIcon';

exports.default = DeviceUsb;

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceWallpaper = function DeviceWallpaper(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z' })
  );
};
DeviceWallpaper = (0, _pure2.default)(DeviceWallpaper);
DeviceWallpaper.displayName = 'DeviceWallpaper';
DeviceWallpaper.muiName = 'SvgIcon';

exports.default = DeviceWallpaper;

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceWidgets = function DeviceWidgets(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z' })
  );
};
DeviceWidgets = (0, _pure2.default)(DeviceWidgets);
DeviceWidgets.displayName = 'DeviceWidgets';
DeviceWidgets.muiName = 'SvgIcon';

exports.default = DeviceWidgets;

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceWifiLock = function DeviceWifiLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
  );
};
DeviceWifiLock = (0, _pure2.default)(DeviceWifiLock);
DeviceWifiLock.displayName = 'DeviceWifiLock';
DeviceWifiLock.muiName = 'SvgIcon';

exports.default = DeviceWifiLock;

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceWifiTethering = function DeviceWifiTethering(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z' })
  );
};
DeviceWifiTethering = (0, _pure2.default)(DeviceWifiTethering);
DeviceWifiTethering.displayName = 'DeviceWifiTethering';
DeviceWifiTethering.muiName = 'SvgIcon';

exports.default = DeviceWifiTethering;

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorAttachFile = function EditorAttachFile(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' })
  );
};
EditorAttachFile = (0, _pure2.default)(EditorAttachFile);
EditorAttachFile.displayName = 'EditorAttachFile';
EditorAttachFile.muiName = 'SvgIcon';

exports.default = EditorAttachFile;

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorAttachMoney = function EditorAttachMoney(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' })
  );
};
EditorAttachMoney = (0, _pure2.default)(EditorAttachMoney);
EditorAttachMoney.displayName = 'EditorAttachMoney';
EditorAttachMoney.muiName = 'SvgIcon';

exports.default = EditorAttachMoney;

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderAll = function EditorBorderAll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z' })
  );
};
EditorBorderAll = (0, _pure2.default)(EditorBorderAll);
EditorBorderAll.displayName = 'EditorBorderAll';
EditorBorderAll.muiName = 'SvgIcon';

exports.default = EditorBorderAll;

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderBottom = function EditorBorderBottom(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z' })
  );
};
EditorBorderBottom = (0, _pure2.default)(EditorBorderBottom);
EditorBorderBottom.displayName = 'EditorBorderBottom';
EditorBorderBottom.muiName = 'SvgIcon';

exports.default = EditorBorderBottom;

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderClear = function EditorBorderClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
  );
};
EditorBorderClear = (0, _pure2.default)(EditorBorderClear);
EditorBorderClear.displayName = 'EditorBorderClear';
EditorBorderClear.muiName = 'SvgIcon';

exports.default = EditorBorderClear;

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderColor = function EditorBorderColor(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z' }),
    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
  );
};
EditorBorderColor = (0, _pure2.default)(EditorBorderColor);
EditorBorderColor.displayName = 'EditorBorderColor';
EditorBorderColor.muiName = 'SvgIcon';

exports.default = EditorBorderColor;

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderHorizontal = function EditorBorderHorizontal(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z' })
  );
};
EditorBorderHorizontal = (0, _pure2.default)(EditorBorderHorizontal);
EditorBorderHorizontal.displayName = 'EditorBorderHorizontal';
EditorBorderHorizontal.muiName = 'SvgIcon';

exports.default = EditorBorderHorizontal;

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderInner = function EditorBorderInner(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z' })
  );
};
EditorBorderInner = (0, _pure2.default)(EditorBorderInner);
EditorBorderInner.displayName = 'EditorBorderInner';
EditorBorderInner.muiName = 'SvgIcon';

exports.default = EditorBorderInner;

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderLeft = function EditorBorderLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
  );
};
EditorBorderLeft = (0, _pure2.default)(EditorBorderLeft);
EditorBorderLeft.displayName = 'EditorBorderLeft';
EditorBorderLeft.muiName = 'SvgIcon';

exports.default = EditorBorderLeft;

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderOuter = function EditorBorderOuter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z' })
  );
};
EditorBorderOuter = (0, _pure2.default)(EditorBorderOuter);
EditorBorderOuter.displayName = 'EditorBorderOuter';
EditorBorderOuter.muiName = 'SvgIcon';

exports.default = EditorBorderOuter;

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderRight = function EditorBorderRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z' })
  );
};
EditorBorderRight = (0, _pure2.default)(EditorBorderRight);
EditorBorderRight.displayName = 'EditorBorderRight';
EditorBorderRight.muiName = 'SvgIcon';

exports.default = EditorBorderRight;

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderStyle = function EditorBorderStyle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z' })
  );
};
EditorBorderStyle = (0, _pure2.default)(EditorBorderStyle);
EditorBorderStyle.displayName = 'EditorBorderStyle';
EditorBorderStyle.muiName = 'SvgIcon';

exports.default = EditorBorderStyle;

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderTop = function EditorBorderTop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z' })
  );
};
EditorBorderTop = (0, _pure2.default)(EditorBorderTop);
EditorBorderTop.displayName = 'EditorBorderTop';
EditorBorderTop.muiName = 'SvgIcon';

exports.default = EditorBorderTop;

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBorderVertical = function EditorBorderVertical(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z' })
  );
};
EditorBorderVertical = (0, _pure2.default)(EditorBorderVertical);
EditorBorderVertical.displayName = 'EditorBorderVertical';
EditorBorderVertical.muiName = 'SvgIcon';

exports.default = EditorBorderVertical;

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorBubbleChart = function EditorBubbleChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '7.2', cy: '14.4', r: '3.2' }),
    _react2.default.createElement('circle', { cx: '14.8', cy: '18', r: '2' }),
    _react2.default.createElement('circle', { cx: '15.2', cy: '8.8', r: '4.8' })
  );
};
EditorBubbleChart = (0, _pure2.default)(EditorBubbleChart);
EditorBubbleChart.displayName = 'EditorBubbleChart';
EditorBubbleChart.muiName = 'SvgIcon';

exports.default = EditorBubbleChart;

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorDragHandle = function EditorDragHandle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z' })
  );
};
EditorDragHandle = (0, _pure2.default)(EditorDragHandle);
EditorDragHandle.displayName = 'EditorDragHandle';
EditorDragHandle.muiName = 'SvgIcon';

exports.default = EditorDragHandle;

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignCenter = function EditorFormatAlignCenter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignCenter = (0, _pure2.default)(EditorFormatAlignCenter);
EditorFormatAlignCenter.displayName = 'EditorFormatAlignCenter';
EditorFormatAlignCenter.muiName = 'SvgIcon';

exports.default = EditorFormatAlignCenter;

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignJustify = function EditorFormatAlignJustify(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z' })
  );
};
EditorFormatAlignJustify = (0, _pure2.default)(EditorFormatAlignJustify);
EditorFormatAlignJustify.displayName = 'EditorFormatAlignJustify';
EditorFormatAlignJustify.muiName = 'SvgIcon';

exports.default = EditorFormatAlignJustify;

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignLeft = function EditorFormatAlignLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignLeft = (0, _pure2.default)(EditorFormatAlignLeft);
EditorFormatAlignLeft.displayName = 'EditorFormatAlignLeft';
EditorFormatAlignLeft.muiName = 'SvgIcon';

exports.default = EditorFormatAlignLeft;

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatAlignRight = function EditorFormatAlignRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z' })
  );
};
EditorFormatAlignRight = (0, _pure2.default)(EditorFormatAlignRight);
EditorFormatAlignRight.displayName = 'EditorFormatAlignRight';
EditorFormatAlignRight.muiName = 'SvgIcon';

exports.default = EditorFormatAlignRight;

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatBold = function EditorFormatBold(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' })
  );
};
EditorFormatBold = (0, _pure2.default)(EditorFormatBold);
EditorFormatBold.displayName = 'EditorFormatBold';
EditorFormatBold.muiName = 'SvgIcon';

exports.default = EditorFormatBold;

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatClear = function EditorFormatClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z' })
  );
};
EditorFormatClear = (0, _pure2.default)(EditorFormatClear);
EditorFormatClear.displayName = 'EditorFormatClear';
EditorFormatClear.muiName = 'SvgIcon';

exports.default = EditorFormatClear;

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatColorFill = function EditorFormatColorFill(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z' }),
    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
  );
};
EditorFormatColorFill = (0, _pure2.default)(EditorFormatColorFill);
EditorFormatColorFill.displayName = 'EditorFormatColorFill';
EditorFormatColorFill.muiName = 'SvgIcon';

exports.default = EditorFormatColorFill;

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatColorReset = function EditorFormatColorReset(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z' })
  );
};
EditorFormatColorReset = (0, _pure2.default)(EditorFormatColorReset);
EditorFormatColorReset.displayName = 'EditorFormatColorReset';
EditorFormatColorReset.muiName = 'SvgIcon';

exports.default = EditorFormatColorReset;

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatColorText = function EditorFormatColorText(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' }),
    _react2.default.createElement('path', { d: 'M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z' })
  );
};
EditorFormatColorText = (0, _pure2.default)(EditorFormatColorText);
EditorFormatColorText.displayName = 'EditorFormatColorText';
EditorFormatColorText.muiName = 'SvgIcon';

exports.default = EditorFormatColorText;

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatIndentDecrease = function EditorFormatIndentDecrease(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
  );
};
EditorFormatIndentDecrease = (0, _pure2.default)(EditorFormatIndentDecrease);
EditorFormatIndentDecrease.displayName = 'EditorFormatIndentDecrease';
EditorFormatIndentDecrease.muiName = 'SvgIcon';

exports.default = EditorFormatIndentDecrease;

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatIndentIncrease = function EditorFormatIndentIncrease(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
  );
};
EditorFormatIndentIncrease = (0, _pure2.default)(EditorFormatIndentIncrease);
EditorFormatIndentIncrease.displayName = 'EditorFormatIndentIncrease';
EditorFormatIndentIncrease.muiName = 'SvgIcon';

exports.default = EditorFormatIndentIncrease;

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatItalic = function EditorFormatItalic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
  );
};
EditorFormatItalic = (0, _pure2.default)(EditorFormatItalic);
EditorFormatItalic.displayName = 'EditorFormatItalic';
EditorFormatItalic.muiName = 'SvgIcon';

exports.default = EditorFormatItalic;

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatLineSpacing = function EditorFormatLineSpacing(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z' })
  );
};
EditorFormatLineSpacing = (0, _pure2.default)(EditorFormatLineSpacing);
EditorFormatLineSpacing.displayName = 'EditorFormatLineSpacing';
EditorFormatLineSpacing.muiName = 'SvgIcon';

exports.default = EditorFormatLineSpacing;

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatListBulleted = function EditorFormatListBulleted(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
  );
};
EditorFormatListBulleted = (0, _pure2.default)(EditorFormatListBulleted);
EditorFormatListBulleted.displayName = 'EditorFormatListBulleted';
EditorFormatListBulleted.muiName = 'SvgIcon';

exports.default = EditorFormatListBulleted;

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatListNumbered = function EditorFormatListNumbered(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' })
  );
};
EditorFormatListNumbered = (0, _pure2.default)(EditorFormatListNumbered);
EditorFormatListNumbered.displayName = 'EditorFormatListNumbered';
EditorFormatListNumbered.muiName = 'SvgIcon';

exports.default = EditorFormatListNumbered;

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatPaint = function EditorFormatPaint(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z' })
  );
};
EditorFormatPaint = (0, _pure2.default)(EditorFormatPaint);
EditorFormatPaint.displayName = 'EditorFormatPaint';
EditorFormatPaint.muiName = 'SvgIcon';

exports.default = EditorFormatPaint;

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatQuote = function EditorFormatQuote(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z' })
  );
};
EditorFormatQuote = (0, _pure2.default)(EditorFormatQuote);
EditorFormatQuote.displayName = 'EditorFormatQuote';
EditorFormatQuote.muiName = 'SvgIcon';

exports.default = EditorFormatQuote;

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatShapes = function EditorFormatShapes(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z' })
  );
};
EditorFormatShapes = (0, _pure2.default)(EditorFormatShapes);
EditorFormatShapes.displayName = 'EditorFormatShapes';
EditorFormatShapes.muiName = 'SvgIcon';

exports.default = EditorFormatShapes;

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatSize = function EditorFormatSize(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z' })
  );
};
EditorFormatSize = (0, _pure2.default)(EditorFormatSize);
EditorFormatSize.displayName = 'EditorFormatSize';
EditorFormatSize.muiName = 'SvgIcon';

exports.default = EditorFormatSize;

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatStrikethrough = function EditorFormatStrikethrough(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z' })
  );
};
EditorFormatStrikethrough = (0, _pure2.default)(EditorFormatStrikethrough);
EditorFormatStrikethrough.displayName = 'EditorFormatStrikethrough';
EditorFormatStrikethrough.muiName = 'SvgIcon';

exports.default = EditorFormatStrikethrough;

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatTextdirectionLToR = function EditorFormatTextdirectionLToR(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z' })
  );
};
EditorFormatTextdirectionLToR = (0, _pure2.default)(EditorFormatTextdirectionLToR);
EditorFormatTextdirectionLToR.displayName = 'EditorFormatTextdirectionLToR';
EditorFormatTextdirectionLToR.muiName = 'SvgIcon';

exports.default = EditorFormatTextdirectionLToR;

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatTextdirectionRToL = function EditorFormatTextdirectionRToL(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z' })
  );
};
EditorFormatTextdirectionRToL = (0, _pure2.default)(EditorFormatTextdirectionRToL);
EditorFormatTextdirectionRToL.displayName = 'EditorFormatTextdirectionRToL';
EditorFormatTextdirectionRToL.muiName = 'SvgIcon';

exports.default = EditorFormatTextdirectionRToL;

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatUnderlined = function EditorFormatUnderlined(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z' })
  );
};
EditorFormatUnderlined = (0, _pure2.default)(EditorFormatUnderlined);
EditorFormatUnderlined.displayName = 'EditorFormatUnderlined';
EditorFormatUnderlined.muiName = 'SvgIcon';

exports.default = EditorFormatUnderlined;

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFunctions = function EditorFunctions(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z' })
  );
};
EditorFunctions = (0, _pure2.default)(EditorFunctions);
EditorFunctions.displayName = 'EditorFunctions';
EditorFunctions.muiName = 'SvgIcon';

exports.default = EditorFunctions;

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorHighlight = function EditorHighlight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z' })
  );
};
EditorHighlight = (0, _pure2.default)(EditorHighlight);
EditorHighlight.displayName = 'EditorHighlight';
EditorHighlight.muiName = 'SvgIcon';

exports.default = EditorHighlight;

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertChart = function EditorInsertChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
  );
};
EditorInsertChart = (0, _pure2.default)(EditorInsertChart);
EditorInsertChart.displayName = 'EditorInsertChart';
EditorInsertChart.muiName = 'SvgIcon';

exports.default = EditorInsertChart;

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertComment = function EditorInsertComment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
EditorInsertComment = (0, _pure2.default)(EditorInsertComment);
EditorInsertComment.displayName = 'EditorInsertComment';
EditorInsertComment.muiName = 'SvgIcon';

exports.default = EditorInsertComment;

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertDriveFile = function EditorInsertDriveFile(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' })
  );
};
EditorInsertDriveFile = (0, _pure2.default)(EditorInsertDriveFile);
EditorInsertDriveFile.displayName = 'EditorInsertDriveFile';
EditorInsertDriveFile.muiName = 'SvgIcon';

exports.default = EditorInsertDriveFile;

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertEmoticon = function EditorInsertEmoticon(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
  );
};
EditorInsertEmoticon = (0, _pure2.default)(EditorInsertEmoticon);
EditorInsertEmoticon.displayName = 'EditorInsertEmoticon';
EditorInsertEmoticon.muiName = 'SvgIcon';

exports.default = EditorInsertEmoticon;

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertInvitation = function EditorInsertInvitation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
  );
};
EditorInsertInvitation = (0, _pure2.default)(EditorInsertInvitation);
EditorInsertInvitation.displayName = 'EditorInsertInvitation';
EditorInsertInvitation.muiName = 'SvgIcon';

exports.default = EditorInsertInvitation;

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertLink = function EditorInsertLink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
  );
};
EditorInsertLink = (0, _pure2.default)(EditorInsertLink);
EditorInsertLink.displayName = 'EditorInsertLink';
EditorInsertLink.muiName = 'SvgIcon';

exports.default = EditorInsertLink;

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertPhoto = function EditorInsertPhoto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
  );
};
EditorInsertPhoto = (0, _pure2.default)(EditorInsertPhoto);
EditorInsertPhoto.displayName = 'EditorInsertPhoto';
EditorInsertPhoto.muiName = 'SvgIcon';

exports.default = EditorInsertPhoto;

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorLinearScale = function EditorLinearScale(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z' })
  );
};
EditorLinearScale = (0, _pure2.default)(EditorLinearScale);
EditorLinearScale.displayName = 'EditorLinearScale';
EditorLinearScale.muiName = 'SvgIcon';

exports.default = EditorLinearScale;

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorMergeType = function EditorMergeType(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
  );
};
EditorMergeType = (0, _pure2.default)(EditorMergeType);
EditorMergeType.displayName = 'EditorMergeType';
EditorMergeType.muiName = 'SvgIcon';

exports.default = EditorMergeType;

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorModeComment = function EditorModeComment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z' })
  );
};
EditorModeComment = (0, _pure2.default)(EditorModeComment);
EditorModeComment.displayName = 'EditorModeComment';
EditorModeComment.muiName = 'SvgIcon';

exports.default = EditorModeComment;

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorMonetizationOn = function EditorMonetizationOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z' })
  );
};
EditorMonetizationOn = (0, _pure2.default)(EditorMonetizationOn);
EditorMonetizationOn.displayName = 'EditorMonetizationOn';
EditorMonetizationOn.muiName = 'SvgIcon';

exports.default = EditorMonetizationOn;

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorMoneyOff = function EditorMoneyOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z' })
  );
};
EditorMoneyOff = (0, _pure2.default)(EditorMoneyOff);
EditorMoneyOff.displayName = 'EditorMoneyOff';
EditorMoneyOff.muiName = 'SvgIcon';

exports.default = EditorMoneyOff;

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorMultilineChart = function EditorMultilineChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z' })
  );
};
EditorMultilineChart = (0, _pure2.default)(EditorMultilineChart);
EditorMultilineChart.displayName = 'EditorMultilineChart';
EditorMultilineChart.muiName = 'SvgIcon';

exports.default = EditorMultilineChart;

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorPieChartOutlined = function EditorPieChartOutlined(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z' })
  );
};
EditorPieChartOutlined = (0, _pure2.default)(EditorPieChartOutlined);
EditorPieChartOutlined.displayName = 'EditorPieChartOutlined';
EditorPieChartOutlined.muiName = 'SvgIcon';

exports.default = EditorPieChartOutlined;

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorPieChart = function EditorPieChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z' })
  );
};
EditorPieChart = (0, _pure2.default)(EditorPieChart);
EditorPieChart.displayName = 'EditorPieChart';
EditorPieChart.muiName = 'SvgIcon';

exports.default = EditorPieChart;

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorPublish = function EditorPublish(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z' })
  );
};
EditorPublish = (0, _pure2.default)(EditorPublish);
EditorPublish.displayName = 'EditorPublish';
EditorPublish.muiName = 'SvgIcon';

exports.default = EditorPublish;

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorShortText = function EditorShortText(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 9h16v2H4zm0 4h10v2H4z' })
  );
};
EditorShortText = (0, _pure2.default)(EditorShortText);
EditorShortText.displayName = 'EditorShortText';
EditorShortText.muiName = 'SvgIcon';

exports.default = EditorShortText;

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorShowChart = function EditorShowChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z' })
  );
};
EditorShowChart = (0, _pure2.default)(EditorShowChart);
EditorShowChart.displayName = 'EditorShowChart';
EditorShowChart.muiName = 'SvgIcon';

exports.default = EditorShowChart;

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorSpaceBar = function EditorSpaceBar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 9v4H6V9H4v6h16V9z' })
  );
};
EditorSpaceBar = (0, _pure2.default)(EditorSpaceBar);
EditorSpaceBar.displayName = 'EditorSpaceBar';
EditorSpaceBar.muiName = 'SvgIcon';

exports.default = EditorSpaceBar;

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorStrikethroughS = function EditorStrikethroughS(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z' })
  );
};
EditorStrikethroughS = (0, _pure2.default)(EditorStrikethroughS);
EditorStrikethroughS.displayName = 'EditorStrikethroughS';
EditorStrikethroughS.muiName = 'SvgIcon';

exports.default = EditorStrikethroughS;

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorTextFields = function EditorTextFields(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z' })
  );
};
EditorTextFields = (0, _pure2.default)(EditorTextFields);
EditorTextFields.displayName = 'EditorTextFields';
EditorTextFields.muiName = 'SvgIcon';

exports.default = EditorTextFields;

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorTitle = function EditorTitle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 4v3h5.5v12h3V7H19V4z' })
  );
};
EditorTitle = (0, _pure2.default)(EditorTitle);
EditorTitle.displayName = 'EditorTitle';
EditorTitle.muiName = 'SvgIcon';

exports.default = EditorTitle;

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorVerticalAlignBottom = function EditorVerticalAlignBottom(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z' })
  );
};
EditorVerticalAlignBottom = (0, _pure2.default)(EditorVerticalAlignBottom);
EditorVerticalAlignBottom.displayName = 'EditorVerticalAlignBottom';
EditorVerticalAlignBottom.muiName = 'SvgIcon';

exports.default = EditorVerticalAlignBottom;

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorVerticalAlignCenter = function EditorVerticalAlignCenter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z' })
  );
};
EditorVerticalAlignCenter = (0, _pure2.default)(EditorVerticalAlignCenter);
EditorVerticalAlignCenter.displayName = 'EditorVerticalAlignCenter';
EditorVerticalAlignCenter.muiName = 'SvgIcon';

exports.default = EditorVerticalAlignCenter;

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorVerticalAlignTop = function EditorVerticalAlignTop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z' })
  );
};
EditorVerticalAlignTop = (0, _pure2.default)(EditorVerticalAlignTop);
EditorVerticalAlignTop.displayName = 'EditorVerticalAlignTop';
EditorVerticalAlignTop.muiName = 'SvgIcon';

exports.default = EditorVerticalAlignTop;

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorWrapText = function EditorWrapText(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z' })
  );
};
EditorWrapText = (0, _pure2.default)(EditorWrapText);
EditorWrapText.displayName = 'EditorWrapText';
EditorWrapText.muiName = 'SvgIcon';

exports.default = EditorWrapText;

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloudCircle = function FileCloudCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z' })
  );
};
FileCloudCircle = (0, _pure2.default)(FileCloudCircle);
FileCloudCircle.displayName = 'FileCloudCircle';
FileCloudCircle.muiName = 'SvgIcon';

exports.default = FileCloudCircle;

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloudDone = function FileCloudDone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z' })
  );
};
FileCloudDone = (0, _pure2.default)(FileCloudDone);
FileCloudDone.displayName = 'FileCloudDone';
FileCloudDone.muiName = 'SvgIcon';

exports.default = FileCloudDone;

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloudDownload = function FileCloudDownload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z' })
  );
};
FileCloudDownload = (0, _pure2.default)(FileCloudDownload);
FileCloudDownload.displayName = 'FileCloudDownload';
FileCloudDownload.muiName = 'SvgIcon';

exports.default = FileCloudDownload;

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloudOff = function FileCloudOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z' })
  );
};
FileCloudOff = (0, _pure2.default)(FileCloudOff);
FileCloudOff.displayName = 'FileCloudOff';
FileCloudOff.muiName = 'SvgIcon';

exports.default = FileCloudOff;

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloudQueue = function FileCloudQueue(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z' })
  );
};
FileCloudQueue = (0, _pure2.default)(FileCloudQueue);
FileCloudQueue.displayName = 'FileCloudQueue';
FileCloudQueue.muiName = 'SvgIcon';

exports.default = FileCloudQueue;

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloudUpload = function FileCloudUpload(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
  );
};
FileCloudUpload = (0, _pure2.default)(FileCloudUpload);
FileCloudUpload.displayName = 'FileCloudUpload';
FileCloudUpload.muiName = 'SvgIcon';

exports.default = FileCloudUpload;

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCloud = function FileCloud(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z' })
  );
};
FileCloud = (0, _pure2.default)(FileCloud);
FileCloud.displayName = 'FileCloud';
FileCloud.muiName = 'SvgIcon';

exports.default = FileCloud;

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCreateNewFolder = function FileCreateNewFolder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z' })
  );
};
FileCreateNewFolder = (0, _pure2.default)(FileCreateNewFolder);
FileCreateNewFolder.displayName = 'FileCreateNewFolder';
FileCreateNewFolder.muiName = 'SvgIcon';

exports.default = FileCreateNewFolder;

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFolderOpen = function FileFolderOpen(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z' })
  );
};
FileFolderOpen = (0, _pure2.default)(FileFolderOpen);
FileFolderOpen.displayName = 'FileFolderOpen';
FileFolderOpen.muiName = 'SvgIcon';

exports.default = FileFolderOpen;

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFolderShared = function FileFolderShared(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z' })
  );
};
FileFolderShared = (0, _pure2.default)(FileFolderShared);
FileFolderShared.displayName = 'FileFolderShared';
FileFolderShared.muiName = 'SvgIcon';

exports.default = FileFolderShared;

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFolder = function FileFolder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' })
  );
};
FileFolder = (0, _pure2.default)(FileFolder);
FileFolder.displayName = 'FileFolder';
FileFolder.muiName = 'SvgIcon';

exports.default = FileFolder;

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareCastConnected = function HardwareCastConnected(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
HardwareCastConnected = (0, _pure2.default)(HardwareCastConnected);
HardwareCastConnected.displayName = 'HardwareCastConnected';
HardwareCastConnected.muiName = 'SvgIcon';

exports.default = HardwareCastConnected;

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareCast = function HardwareCast(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z' })
  );
};
HardwareCast = (0, _pure2.default)(HardwareCast);
HardwareCast.displayName = 'HardwareCast';
HardwareCast.muiName = 'SvgIcon';

exports.default = HardwareCast;

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareComputer = function HardwareComputer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
  );
};
HardwareComputer = (0, _pure2.default)(HardwareComputer);
HardwareComputer.displayName = 'HardwareComputer';
HardwareComputer.muiName = 'SvgIcon';

exports.default = HardwareComputer;

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDesktopMac = function HardwareDesktopMac(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z' })
  );
};
HardwareDesktopMac = (0, _pure2.default)(HardwareDesktopMac);
HardwareDesktopMac.displayName = 'HardwareDesktopMac';
HardwareDesktopMac.muiName = 'SvgIcon';

exports.default = HardwareDesktopMac;

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDesktopWindows = function HardwareDesktopWindows(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z' })
  );
};
HardwareDesktopWindows = (0, _pure2.default)(HardwareDesktopWindows);
HardwareDesktopWindows.displayName = 'HardwareDesktopWindows';
HardwareDesktopWindows.muiName = 'SvgIcon';

exports.default = HardwareDesktopWindows;

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDeveloperBoard = function HardwareDeveloperBoard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z' })
  );
};
HardwareDeveloperBoard = (0, _pure2.default)(HardwareDeveloperBoard);
HardwareDeveloperBoard.displayName = 'HardwareDeveloperBoard';
HardwareDeveloperBoard.muiName = 'SvgIcon';

exports.default = HardwareDeveloperBoard;

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDeviceHub = function HardwareDeviceHub(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z' })
  );
};
HardwareDeviceHub = (0, _pure2.default)(HardwareDeviceHub);
HardwareDeviceHub.displayName = 'HardwareDeviceHub';
HardwareDeviceHub.muiName = 'SvgIcon';

exports.default = HardwareDeviceHub;

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDevicesOther = function HardwareDevicesOther(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z' })
  );
};
HardwareDevicesOther = (0, _pure2.default)(HardwareDevicesOther);
HardwareDevicesOther.displayName = 'HardwareDevicesOther';
HardwareDevicesOther.muiName = 'SvgIcon';

exports.default = HardwareDevicesOther;

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDock = function HardwareDock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z' })
  );
};
HardwareDock = (0, _pure2.default)(HardwareDock);
HardwareDock.displayName = 'HardwareDock';
HardwareDock.muiName = 'SvgIcon';

exports.default = HardwareDock;

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareGamepad = function HardwareGamepad(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
  );
};
HardwareGamepad = (0, _pure2.default)(HardwareGamepad);
HardwareGamepad.displayName = 'HardwareGamepad';
HardwareGamepad.muiName = 'SvgIcon';

exports.default = HardwareGamepad;

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareHeadsetMic = function HardwareHeadsetMic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z' })
  );
};
HardwareHeadsetMic = (0, _pure2.default)(HardwareHeadsetMic);
HardwareHeadsetMic.displayName = 'HardwareHeadsetMic';
HardwareHeadsetMic.muiName = 'SvgIcon';

exports.default = HardwareHeadsetMic;

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareHeadset = function HardwareHeadset(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z' })
  );
};
HardwareHeadset = (0, _pure2.default)(HardwareHeadset);
HardwareHeadset.displayName = 'HardwareHeadset';
HardwareHeadset.muiName = 'SvgIcon';

exports.default = HardwareHeadset;

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardBackspace = function HardwareKeyboardBackspace(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z' })
  );
};
HardwareKeyboardBackspace = (0, _pure2.default)(HardwareKeyboardBackspace);
HardwareKeyboardBackspace.displayName = 'HardwareKeyboardBackspace';
HardwareKeyboardBackspace.muiName = 'SvgIcon';

exports.default = HardwareKeyboardBackspace;

/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardCapslock = function HardwareKeyboardCapslock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z' })
  );
};
HardwareKeyboardCapslock = (0, _pure2.default)(HardwareKeyboardCapslock);
HardwareKeyboardCapslock.displayName = 'HardwareKeyboardCapslock';
HardwareKeyboardCapslock.muiName = 'SvgIcon';

exports.default = HardwareKeyboardCapslock;

/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardHide = function HardwareKeyboardHide(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z' })
  );
};
HardwareKeyboardHide = (0, _pure2.default)(HardwareKeyboardHide);
HardwareKeyboardHide.displayName = 'HardwareKeyboardHide';
HardwareKeyboardHide.muiName = 'SvgIcon';

exports.default = HardwareKeyboardHide;

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardReturn = function HardwareKeyboardReturn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z' })
  );
};
HardwareKeyboardReturn = (0, _pure2.default)(HardwareKeyboardReturn);
HardwareKeyboardReturn.displayName = 'HardwareKeyboardReturn';
HardwareKeyboardReturn.muiName = 'SvgIcon';

exports.default = HardwareKeyboardReturn;

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardTab = function HardwareKeyboardTab(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z' })
  );
};
HardwareKeyboardTab = (0, _pure2.default)(HardwareKeyboardTab);
HardwareKeyboardTab.displayName = 'HardwareKeyboardTab';
HardwareKeyboardTab.muiName = 'SvgIcon';

exports.default = HardwareKeyboardTab;

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardVoice = function HardwareKeyboardVoice(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
  );
};
HardwareKeyboardVoice = (0, _pure2.default)(HardwareKeyboardVoice);
HardwareKeyboardVoice.displayName = 'HardwareKeyboardVoice';
HardwareKeyboardVoice.muiName = 'SvgIcon';

exports.default = HardwareKeyboardVoice;

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboard = function HardwareKeyboard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z' })
  );
};
HardwareKeyboard = (0, _pure2.default)(HardwareKeyboard);
HardwareKeyboard.displayName = 'HardwareKeyboard';
HardwareKeyboard.muiName = 'SvgIcon';

exports.default = HardwareKeyboard;

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareLaptopChromebook = function HardwareLaptopChromebook(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z' })
  );
};
HardwareLaptopChromebook = (0, _pure2.default)(HardwareLaptopChromebook);
HardwareLaptopChromebook.displayName = 'HardwareLaptopChromebook';
HardwareLaptopChromebook.muiName = 'SvgIcon';

exports.default = HardwareLaptopChromebook;

/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareLaptopMac = function HardwareLaptopMac(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
  );
};
HardwareLaptopMac = (0, _pure2.default)(HardwareLaptopMac);
HardwareLaptopMac.displayName = 'HardwareLaptopMac';
HardwareLaptopMac.muiName = 'SvgIcon';

exports.default = HardwareLaptopMac;

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareLaptopWindows = function HardwareLaptopWindows(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z' })
  );
};
HardwareLaptopWindows = (0, _pure2.default)(HardwareLaptopWindows);
HardwareLaptopWindows.displayName = 'HardwareLaptopWindows';
HardwareLaptopWindows.muiName = 'SvgIcon';

exports.default = HardwareLaptopWindows;

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareLaptop = function HardwareLaptop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
  );
};
HardwareLaptop = (0, _pure2.default)(HardwareLaptop);
HardwareLaptop.displayName = 'HardwareLaptop';
HardwareLaptop.muiName = 'SvgIcon';

exports.default = HardwareLaptop;

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareMemory = function HardwareMemory(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z' })
  );
};
HardwareMemory = (0, _pure2.default)(HardwareMemory);
HardwareMemory.displayName = 'HardwareMemory';
HardwareMemory.muiName = 'SvgIcon';

exports.default = HardwareMemory;

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareMouse = function HardwareMouse(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z' })
  );
};
HardwareMouse = (0, _pure2.default)(HardwareMouse);
HardwareMouse.displayName = 'HardwareMouse';
HardwareMouse.muiName = 'SvgIcon';

exports.default = HardwareMouse;

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwarePhoneAndroid = function HardwarePhoneAndroid(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z' })
  );
};
HardwarePhoneAndroid = (0, _pure2.default)(HardwarePhoneAndroid);
HardwarePhoneAndroid.displayName = 'HardwarePhoneAndroid';
HardwarePhoneAndroid.muiName = 'SvgIcon';

exports.default = HardwarePhoneAndroid;

/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwarePhoneIphone = function HardwarePhoneIphone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z' })
  );
};
HardwarePhoneIphone = (0, _pure2.default)(HardwarePhoneIphone);
HardwarePhoneIphone.displayName = 'HardwarePhoneIphone';
HardwarePhoneIphone.muiName = 'SvgIcon';

exports.default = HardwarePhoneIphone;

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwarePhonelinkOff = function HardwarePhonelinkOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z' })
  );
};
HardwarePhonelinkOff = (0, _pure2.default)(HardwarePhonelinkOff);
HardwarePhonelinkOff.displayName = 'HardwarePhonelinkOff';
HardwarePhonelinkOff.muiName = 'SvgIcon';

exports.default = HardwarePhonelinkOff;

/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwarePhonelink = function HardwarePhonelink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
  );
};
HardwarePhonelink = (0, _pure2.default)(HardwarePhonelink);
HardwarePhonelink.displayName = 'HardwarePhonelink';
HardwarePhonelink.muiName = 'SvgIcon';

exports.default = HardwarePhonelink;

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwarePowerInput = function HardwarePowerInput(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z' })
  );
};
HardwarePowerInput = (0, _pure2.default)(HardwarePowerInput);
HardwarePowerInput.displayName = 'HardwarePowerInput';
HardwarePowerInput.muiName = 'SvgIcon';

exports.default = HardwarePowerInput;

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareRouter = function HardwareRouter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z' })
  );
};
HardwareRouter = (0, _pure2.default)(HardwareRouter);
HardwareRouter.displayName = 'HardwareRouter';
HardwareRouter.muiName = 'SvgIcon';

exports.default = HardwareRouter;

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareScanner = function HardwareScanner(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z' })
  );
};
HardwareScanner = (0, _pure2.default)(HardwareScanner);
HardwareScanner.displayName = 'HardwareScanner';
HardwareScanner.muiName = 'SvgIcon';

exports.default = HardwareScanner;

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareSecurity = function HardwareSecurity(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z' })
  );
};
HardwareSecurity = (0, _pure2.default)(HardwareSecurity);
HardwareSecurity.displayName = 'HardwareSecurity';
HardwareSecurity.muiName = 'SvgIcon';

exports.default = HardwareSecurity;

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareSimCard = function HardwareSimCard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z' })
  );
};
HardwareSimCard = (0, _pure2.default)(HardwareSimCard);
HardwareSimCard.displayName = 'HardwareSimCard';
HardwareSimCard.muiName = 'SvgIcon';

exports.default = HardwareSimCard;

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareSmartphone = function HardwareSmartphone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
  );
};
HardwareSmartphone = (0, _pure2.default)(HardwareSmartphone);
HardwareSmartphone.displayName = 'HardwareSmartphone';
HardwareSmartphone.muiName = 'SvgIcon';

exports.default = HardwareSmartphone;

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareSpeakerGroup = function HardwareSpeakerGroup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' }),
    _react2.default.createElement('circle', { cx: '14', cy: '12.5', r: '2.5' }),
    _react2.default.createElement('path', { d: 'M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z' })
  );
};
HardwareSpeakerGroup = (0, _pure2.default)(HardwareSpeakerGroup);
HardwareSpeakerGroup.displayName = 'HardwareSpeakerGroup';
HardwareSpeakerGroup.muiName = 'SvgIcon';

exports.default = HardwareSpeakerGroup;

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareSpeaker = function HardwareSpeaker(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
HardwareSpeaker = (0, _pure2.default)(HardwareSpeaker);
HardwareSpeaker.displayName = 'HardwareSpeaker';
HardwareSpeaker.muiName = 'SvgIcon';

exports.default = HardwareSpeaker;

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareTabletAndroid = function HardwareTabletAndroid(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z' })
  );
};
HardwareTabletAndroid = (0, _pure2.default)(HardwareTabletAndroid);
HardwareTabletAndroid.displayName = 'HardwareTabletAndroid';
HardwareTabletAndroid.muiName = 'SvgIcon';

exports.default = HardwareTabletAndroid;

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareTabletMac = function HardwareTabletMac(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z' })
  );
};
HardwareTabletMac = (0, _pure2.default)(HardwareTabletMac);
HardwareTabletMac.displayName = 'HardwareTabletMac';
HardwareTabletMac.muiName = 'SvgIcon';

exports.default = HardwareTabletMac;

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareTablet = function HardwareTablet(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z' })
  );
};
HardwareTablet = (0, _pure2.default)(HardwareTablet);
HardwareTablet.displayName = 'HardwareTablet';
HardwareTablet.muiName = 'SvgIcon';

exports.default = HardwareTablet;

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareToys = function HardwareToys(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z' })
  );
};
HardwareToys = (0, _pure2.default)(HardwareToys);
HardwareToys.displayName = 'HardwareToys';
HardwareToys.muiName = 'SvgIcon';

exports.default = HardwareToys;

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareTv = function HardwareTv(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z' })
  );
};
HardwareTv = (0, _pure2.default)(HardwareTv);
HardwareTv.displayName = 'HardwareTv';
HardwareTv.muiName = 'SvgIcon';

exports.default = HardwareTv;

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareVideogameAsset = function HardwareVideogameAsset(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
HardwareVideogameAsset = (0, _pure2.default)(HardwareVideogameAsset);
HardwareVideogameAsset.displayName = 'HardwareVideogameAsset';
HardwareVideogameAsset.muiName = 'SvgIcon';

exports.default = HardwareVideogameAsset;

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareWatch = function HardwareWatch(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z' })
  );
};
HardwareWatch = (0, _pure2.default)(HardwareWatch);
HardwareWatch.displayName = 'HardwareWatch';
HardwareWatch.muiName = 'SvgIcon';

exports.default = HardwareWatch;

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAddAPhoto = function ImageAddAPhoto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z' })
  );
};
ImageAddAPhoto = (0, _pure2.default)(ImageAddAPhoto);
ImageAddAPhoto.displayName = 'ImageAddAPhoto';
ImageAddAPhoto.muiName = 'SvgIcon';

exports.default = ImageAddAPhoto;

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAddToPhotos = function ImageAddToPhotos(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
  );
};
ImageAddToPhotos = (0, _pure2.default)(ImageAddToPhotos);
ImageAddToPhotos.displayName = 'ImageAddToPhotos';
ImageAddToPhotos.muiName = 'SvgIcon';

exports.default = ImageAddToPhotos;

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAdjust = function ImageAdjust(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z' })
  );
};
ImageAdjust = (0, _pure2.default)(ImageAdjust);
ImageAdjust.displayName = 'ImageAdjust';
ImageAdjust.muiName = 'SvgIcon';

exports.default = ImageAdjust;

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAssistantPhoto = function ImageAssistantPhoto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
  );
};
ImageAssistantPhoto = (0, _pure2.default)(ImageAssistantPhoto);
ImageAssistantPhoto.displayName = 'ImageAssistantPhoto';
ImageAssistantPhoto.muiName = 'SvgIcon';

exports.default = ImageAssistantPhoto;

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAssistant = function ImageAssistant(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z' })
  );
};
ImageAssistant = (0, _pure2.default)(ImageAssistant);
ImageAssistant.displayName = 'ImageAssistant';
ImageAssistant.muiName = 'SvgIcon';

exports.default = ImageAssistant;

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAudiotrack = function ImageAudiotrack(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z' })
  );
};
ImageAudiotrack = (0, _pure2.default)(ImageAudiotrack);
ImageAudiotrack.displayName = 'ImageAudiotrack';
ImageAudiotrack.muiName = 'SvgIcon';

exports.default = ImageAudiotrack;

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBlurCircular = function ImageBlurCircular(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
  );
};
ImageBlurCircular = (0, _pure2.default)(ImageBlurCircular);
ImageBlurCircular.displayName = 'ImageBlurCircular';
ImageBlurCircular.muiName = 'SvgIcon';

exports.default = ImageBlurCircular;

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBlurLinear = function ImageBlurLinear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z' })
  );
};
ImageBlurLinear = (0, _pure2.default)(ImageBlurLinear);
ImageBlurLinear.displayName = 'ImageBlurLinear';
ImageBlurLinear.muiName = 'SvgIcon';

exports.default = ImageBlurLinear;

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBlurOff = function ImageBlurOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z' })
  );
};
ImageBlurOff = (0, _pure2.default)(ImageBlurOff);
ImageBlurOff.displayName = 'ImageBlurOff';
ImageBlurOff.muiName = 'SvgIcon';

exports.default = ImageBlurOff;

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBlurOn = function ImageBlurOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
  );
};
ImageBlurOn = (0, _pure2.default)(ImageBlurOn);
ImageBlurOn.displayName = 'ImageBlurOn';
ImageBlurOn.muiName = 'SvgIcon';

exports.default = ImageBlurOn;

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness1 = function ImageBrightness1(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' })
  );
};
ImageBrightness1 = (0, _pure2.default)(ImageBrightness1);
ImageBrightness1.displayName = 'ImageBrightness1';
ImageBrightness1.muiName = 'SvgIcon';

exports.default = ImageBrightness1;

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness2 = function ImageBrightness2(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z' })
  );
};
ImageBrightness2 = (0, _pure2.default)(ImageBrightness2);
ImageBrightness2.displayName = 'ImageBrightness2';
ImageBrightness2.muiName = 'SvgIcon';

exports.default = ImageBrightness2;

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness3 = function ImageBrightness3(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z' })
  );
};
ImageBrightness3 = (0, _pure2.default)(ImageBrightness3);
ImageBrightness3.displayName = 'ImageBrightness3';
ImageBrightness3.muiName = 'SvgIcon';

exports.default = ImageBrightness3;

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness4 = function ImageBrightness4(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
  );
};
ImageBrightness4 = (0, _pure2.default)(ImageBrightness4);
ImageBrightness4.displayName = 'ImageBrightness4';
ImageBrightness4.muiName = 'SvgIcon';

exports.default = ImageBrightness4;

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness5 = function ImageBrightness5(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
  );
};
ImageBrightness5 = (0, _pure2.default)(ImageBrightness5);
ImageBrightness5.displayName = 'ImageBrightness5';
ImageBrightness5.muiName = 'SvgIcon';

exports.default = ImageBrightness5;

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness6 = function ImageBrightness6(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
  );
};
ImageBrightness6 = (0, _pure2.default)(ImageBrightness6);
ImageBrightness6.displayName = 'ImageBrightness6';
ImageBrightness6.muiName = 'SvgIcon';

exports.default = ImageBrightness6;

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness7 = function ImageBrightness7(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
  );
};
ImageBrightness7 = (0, _pure2.default)(ImageBrightness7);
ImageBrightness7.displayName = 'ImageBrightness7';
ImageBrightness7.muiName = 'SvgIcon';

exports.default = ImageBrightness7;

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrokenImage = function ImageBrokenImage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z' })
  );
};
ImageBrokenImage = (0, _pure2.default)(ImageBrokenImage);
ImageBrokenImage.displayName = 'ImageBrokenImage';
ImageBrokenImage.muiName = 'SvgIcon';

exports.default = ImageBrokenImage;

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrush = function ImageBrush(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z' })
  );
};
ImageBrush = (0, _pure2.default)(ImageBrush);
ImageBrush.displayName = 'ImageBrush';
ImageBrush.muiName = 'SvgIcon';

exports.default = ImageBrush;

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBurstMode = function ImageBurstMode(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z' })
  );
};
ImageBurstMode = (0, _pure2.default)(ImageBurstMode);
ImageBurstMode.displayName = 'ImageBurstMode';
ImageBurstMode.muiName = 'SvgIcon';

exports.default = ImageBurstMode;

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCameraAlt = function ImageCameraAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
  );
};
ImageCameraAlt = (0, _pure2.default)(ImageCameraAlt);
ImageCameraAlt.displayName = 'ImageCameraAlt';
ImageCameraAlt.muiName = 'SvgIcon';

exports.default = ImageCameraAlt;

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCameraFront = function ImageCameraFront(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z' })
  );
};
ImageCameraFront = (0, _pure2.default)(ImageCameraFront);
ImageCameraFront.displayName = 'ImageCameraFront';
ImageCameraFront.muiName = 'SvgIcon';

exports.default = ImageCameraFront;

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCameraRear = function ImageCameraRear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z' })
  );
};
ImageCameraRear = (0, _pure2.default)(ImageCameraRear);
ImageCameraRear.displayName = 'ImageCameraRear';
ImageCameraRear.muiName = 'SvgIcon';

exports.default = ImageCameraRear;

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCameraRoll = function ImageCameraRoll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z' })
  );
};
ImageCameraRoll = (0, _pure2.default)(ImageCameraRoll);
ImageCameraRoll.displayName = 'ImageCameraRoll';
ImageCameraRoll.muiName = 'SvgIcon';

exports.default = ImageCameraRoll;

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCamera = function ImageCamera(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z' })
  );
};
ImageCamera = (0, _pure2.default)(ImageCamera);
ImageCamera.displayName = 'ImageCamera';
ImageCamera.muiName = 'SvgIcon';

exports.default = ImageCamera;

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCenterFocusStrong = function ImageCenterFocusStrong(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z' })
  );
};
ImageCenterFocusStrong = (0, _pure2.default)(ImageCenterFocusStrong);
ImageCenterFocusStrong.displayName = 'ImageCenterFocusStrong';
ImageCenterFocusStrong.muiName = 'SvgIcon';

exports.default = ImageCenterFocusStrong;

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCenterFocusWeak = function ImageCenterFocusWeak(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
ImageCenterFocusWeak = (0, _pure2.default)(ImageCenterFocusWeak);
ImageCenterFocusWeak.displayName = 'ImageCenterFocusWeak';
ImageCenterFocusWeak.muiName = 'SvgIcon';

exports.default = ImageCenterFocusWeak;

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCollectionsBookmark = function ImageCollectionsBookmark(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z' })
  );
};
ImageCollectionsBookmark = (0, _pure2.default)(ImageCollectionsBookmark);
ImageCollectionsBookmark.displayName = 'ImageCollectionsBookmark';
ImageCollectionsBookmark.muiName = 'SvgIcon';

exports.default = ImageCollectionsBookmark;

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCollections = function ImageCollections(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
  );
};
ImageCollections = (0, _pure2.default)(ImageCollections);
ImageCollections.displayName = 'ImageCollections';
ImageCollections.muiName = 'SvgIcon';

exports.default = ImageCollections;

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageColorLens = function ImageColorLens(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
ImageColorLens = (0, _pure2.default)(ImageColorLens);
ImageColorLens.displayName = 'ImageColorLens';
ImageColorLens.muiName = 'SvgIcon';

exports.default = ImageColorLens;

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageColorize = function ImageColorize(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z' })
  );
};
ImageColorize = (0, _pure2.default)(ImageColorize);
ImageColorize.displayName = 'ImageColorize';
ImageColorize.muiName = 'SvgIcon';

exports.default = ImageColorize;

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCompare = function ImageCompare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
  );
};
ImageCompare = (0, _pure2.default)(ImageCompare);
ImageCompare.displayName = 'ImageCompare';
ImageCompare.muiName = 'SvgIcon';

exports.default = ImageCompare;

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageControlPointDuplicate = function ImageControlPointDuplicate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z' })
  );
};
ImageControlPointDuplicate = (0, _pure2.default)(ImageControlPointDuplicate);
ImageControlPointDuplicate.displayName = 'ImageControlPointDuplicate';
ImageControlPointDuplicate.muiName = 'SvgIcon';

exports.default = ImageControlPointDuplicate;

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCrop169 = function ImageCrop169(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z' })
  );
};
ImageCrop169 = (0, _pure2.default)(ImageCrop169);
ImageCrop169.displayName = 'ImageCrop169';
ImageCrop169.muiName = 'SvgIcon';

exports.default = ImageCrop169;

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCrop32 = function ImageCrop32(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z' })
  );
};
ImageCrop32 = (0, _pure2.default)(ImageCrop32);
ImageCrop32.displayName = 'ImageCrop32';
ImageCrop32.muiName = 'SvgIcon';

exports.default = ImageCrop32;

/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCrop54 = function ImageCrop54(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
  );
};
ImageCrop54 = (0, _pure2.default)(ImageCrop54);
ImageCrop54.displayName = 'ImageCrop54';
ImageCrop54.muiName = 'SvgIcon';

exports.default = ImageCrop54;

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCrop75 = function ImageCrop75(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z' })
  );
};
ImageCrop75 = (0, _pure2.default)(ImageCrop75);
ImageCrop75.displayName = 'ImageCrop75';
ImageCrop75.muiName = 'SvgIcon';

exports.default = ImageCrop75;

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropDin = function ImageCropDin(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
  );
};
ImageCropDin = (0, _pure2.default)(ImageCropDin);
ImageCropDin.displayName = 'ImageCropDin';
ImageCropDin.muiName = 'SvgIcon';

exports.default = ImageCropDin;

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropFree = function ImageCropFree(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z' })
  );
};
ImageCropFree = (0, _pure2.default)(ImageCropFree);
ImageCropFree.displayName = 'ImageCropFree';
ImageCropFree.muiName = 'SvgIcon';

exports.default = ImageCropFree;

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropLandscape = function ImageCropLandscape(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
  );
};
ImageCropLandscape = (0, _pure2.default)(ImageCropLandscape);
ImageCropLandscape.displayName = 'ImageCropLandscape';
ImageCropLandscape.muiName = 'SvgIcon';

exports.default = ImageCropLandscape;

/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropOriginal = function ImageCropOriginal(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' })
  );
};
ImageCropOriginal = (0, _pure2.default)(ImageCropOriginal);
ImageCropOriginal.displayName = 'ImageCropOriginal';
ImageCropOriginal.muiName = 'SvgIcon';

exports.default = ImageCropOriginal;

/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropPortrait = function ImageCropPortrait(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z' })
  );
};
ImageCropPortrait = (0, _pure2.default)(ImageCropPortrait);
ImageCropPortrait.displayName = 'ImageCropPortrait';
ImageCropPortrait.muiName = 'SvgIcon';

exports.default = ImageCropPortrait;

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropRotate = function ImageCropRotate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z' })
  );
};
ImageCropRotate = (0, _pure2.default)(ImageCropRotate);
ImageCropRotate.displayName = 'ImageCropRotate';
ImageCropRotate.muiName = 'SvgIcon';

exports.default = ImageCropRotate;

/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropSquare = function ImageCropSquare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' })
  );
};
ImageCropSquare = (0, _pure2.default)(ImageCropSquare);
ImageCropSquare.displayName = 'ImageCropSquare';
ImageCropSquare.muiName = 'SvgIcon';

exports.default = ImageCropSquare;

/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCrop = function ImageCrop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z' })
  );
};
ImageCrop = (0, _pure2.default)(ImageCrop);
ImageCrop.displayName = 'ImageCrop';
ImageCrop.muiName = 'SvgIcon';

exports.default = ImageCrop;

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageDehaze = function ImageDehaze(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z' })
  );
};
ImageDehaze = (0, _pure2.default)(ImageDehaze);
ImageDehaze.displayName = 'ImageDehaze';
ImageDehaze.muiName = 'SvgIcon';

exports.default = ImageDehaze;

/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageDetails = function ImageDetails(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z' })
  );
};
ImageDetails = (0, _pure2.default)(ImageDetails);
ImageDetails.displayName = 'ImageDetails';
ImageDetails.muiName = 'SvgIcon';

exports.default = ImageDetails;

/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposureNeg1 = function ImageExposureNeg1(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z' })
  );
};
ImageExposureNeg1 = (0, _pure2.default)(ImageExposureNeg1);
ImageExposureNeg1.displayName = 'ImageExposureNeg1';
ImageExposureNeg1.muiName = 'SvgIcon';

exports.default = ImageExposureNeg1;

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposureNeg2 = function ImageExposureNeg2(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z' })
  );
};
ImageExposureNeg2 = (0, _pure2.default)(ImageExposureNeg2);
ImageExposureNeg2.displayName = 'ImageExposureNeg2';
ImageExposureNeg2.muiName = 'SvgIcon';

exports.default = ImageExposureNeg2;

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposurePlus1 = function ImageExposurePlus1(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z' })
  );
};
ImageExposurePlus1 = (0, _pure2.default)(ImageExposurePlus1);
ImageExposurePlus1.displayName = 'ImageExposurePlus1';
ImageExposurePlus1.muiName = 'SvgIcon';

exports.default = ImageExposurePlus1;

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposurePlus2 = function ImageExposurePlus2(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z' })
  );
};
ImageExposurePlus2 = (0, _pure2.default)(ImageExposurePlus2);
ImageExposurePlus2.displayName = 'ImageExposurePlus2';
ImageExposurePlus2.muiName = 'SvgIcon';

exports.default = ImageExposurePlus2;

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposureZero = function ImageExposureZero(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z' })
  );
};
ImageExposureZero = (0, _pure2.default)(ImageExposureZero);
ImageExposureZero.displayName = 'ImageExposureZero';
ImageExposureZero.muiName = 'SvgIcon';

exports.default = ImageExposureZero;

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposure = function ImageExposure(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z' })
  );
};
ImageExposure = (0, _pure2.default)(ImageExposure);
ImageExposure.displayName = 'ImageExposure';
ImageExposure.muiName = 'SvgIcon';

exports.default = ImageExposure;

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter1 = function ImageFilter1(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
  );
};
ImageFilter1 = (0, _pure2.default)(ImageFilter1);
ImageFilter1.displayName = 'ImageFilter1';
ImageFilter1.muiName = 'SvgIcon';

exports.default = ImageFilter1;

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter2 = function ImageFilter2(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z' })
  );
};
ImageFilter2 = (0, _pure2.default)(ImageFilter2);
ImageFilter2.displayName = 'ImageFilter2';
ImageFilter2.muiName = 'SvgIcon';

exports.default = ImageFilter2;

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter3 = function ImageFilter3(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z' })
  );
};
ImageFilter3 = (0, _pure2.default)(ImageFilter3);
ImageFilter3.displayName = 'ImageFilter3';
ImageFilter3.muiName = 'SvgIcon';

exports.default = ImageFilter3;

/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter4 = function ImageFilter4(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
  );
};
ImageFilter4 = (0, _pure2.default)(ImageFilter4);
ImageFilter4.displayName = 'ImageFilter4';
ImageFilter4.muiName = 'SvgIcon';

exports.default = ImageFilter4;

/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter5 = function ImageFilter5(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z' })
  );
};
ImageFilter5 = (0, _pure2.default)(ImageFilter5);
ImageFilter5.displayName = 'ImageFilter5';
ImageFilter5.muiName = 'SvgIcon';

exports.default = ImageFilter5;

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter6 = function ImageFilter6(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z' })
  );
};
ImageFilter6 = (0, _pure2.default)(ImageFilter6);
ImageFilter6.displayName = 'ImageFilter6';
ImageFilter6.muiName = 'SvgIcon';

exports.default = ImageFilter6;

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter7 = function ImageFilter7(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z' })
  );
};
ImageFilter7 = (0, _pure2.default)(ImageFilter7);
ImageFilter7.displayName = 'ImageFilter7';
ImageFilter7.muiName = 'SvgIcon';

exports.default = ImageFilter7;

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter8 = function ImageFilter8(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z' })
  );
};
ImageFilter8 = (0, _pure2.default)(ImageFilter8);
ImageFilter8.displayName = 'ImageFilter8';
ImageFilter8.muiName = 'SvgIcon';

exports.default = ImageFilter8;

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter9Plus = function ImageFilter9Plus(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z' })
  );
};
ImageFilter9Plus = (0, _pure2.default)(ImageFilter9Plus);
ImageFilter9Plus.displayName = 'ImageFilter9Plus';
ImageFilter9Plus.muiName = 'SvgIcon';

exports.default = ImageFilter9Plus;

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter9 = function ImageFilter9(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z' })
  );
};
ImageFilter9 = (0, _pure2.default)(ImageFilter9);
ImageFilter9.displayName = 'ImageFilter9';
ImageFilter9.muiName = 'SvgIcon';

exports.default = ImageFilter9;

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterBAndW = function ImageFilterBAndW(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z' })
  );
};
ImageFilterBAndW = (0, _pure2.default)(ImageFilterBAndW);
ImageFilterBAndW.displayName = 'ImageFilterBAndW';
ImageFilterBAndW.muiName = 'SvgIcon';

exports.default = ImageFilterBAndW;

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterCenterFocus = function ImageFilterCenterFocus(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ImageFilterCenterFocus = (0, _pure2.default)(ImageFilterCenterFocus);
ImageFilterCenterFocus.displayName = 'ImageFilterCenterFocus';
ImageFilterCenterFocus.muiName = 'SvgIcon';

exports.default = ImageFilterCenterFocus;

/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterDrama = function ImageFilterDrama(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z' })
  );
};
ImageFilterDrama = (0, _pure2.default)(ImageFilterDrama);
ImageFilterDrama.displayName = 'ImageFilterDrama';
ImageFilterDrama.muiName = 'SvgIcon';

exports.default = ImageFilterDrama;

/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterFrames = function ImageFilterFrames(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12' })
  );
};
ImageFilterFrames = (0, _pure2.default)(ImageFilterFrames);
ImageFilterFrames.displayName = 'ImageFilterFrames';
ImageFilterFrames.muiName = 'SvgIcon';

exports.default = ImageFilterFrames;

/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterHdr = function ImageFilterHdr(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
  );
};
ImageFilterHdr = (0, _pure2.default)(ImageFilterHdr);
ImageFilterHdr.displayName = 'ImageFilterHdr';
ImageFilterHdr.muiName = 'SvgIcon';

exports.default = ImageFilterHdr;

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterNone = function ImageFilterNone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
  );
};
ImageFilterNone = (0, _pure2.default)(ImageFilterNone);
ImageFilterNone.displayName = 'ImageFilterNone';
ImageFilterNone.muiName = 'SvgIcon';

exports.default = ImageFilterNone;

/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterTiltShift = function ImageFilterTiltShift(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z' })
  );
};
ImageFilterTiltShift = (0, _pure2.default)(ImageFilterTiltShift);
ImageFilterTiltShift.displayName = 'ImageFilterTiltShift';
ImageFilterTiltShift.muiName = 'SvgIcon';

exports.default = ImageFilterTiltShift;

/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterVintage = function ImageFilterVintage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
  );
};
ImageFilterVintage = (0, _pure2.default)(ImageFilterVintage);
ImageFilterVintage.displayName = 'ImageFilterVintage';
ImageFilterVintage.muiName = 'SvgIcon';

exports.default = ImageFilterVintage;

/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilter = function ImageFilter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
  );
};
ImageFilter = (0, _pure2.default)(ImageFilter);
ImageFilter.displayName = 'ImageFilter';
ImageFilter.muiName = 'SvgIcon';

exports.default = ImageFilter;

/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFlare = function ImageFlare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z' })
  );
};
ImageFlare = (0, _pure2.default)(ImageFlare);
ImageFlare.displayName = 'ImageFlare';
ImageFlare.muiName = 'SvgIcon';

exports.default = ImageFlare;

/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFlashAuto = function ImageFlashAuto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z' })
  );
};
ImageFlashAuto = (0, _pure2.default)(ImageFlashAuto);
ImageFlashAuto.displayName = 'ImageFlashAuto';
ImageFlashAuto.muiName = 'SvgIcon';

exports.default = ImageFlashAuto;

/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFlashOff = function ImageFlashOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z' })
  );
};
ImageFlashOff = (0, _pure2.default)(ImageFlashOff);
ImageFlashOff.displayName = 'ImageFlashOff';
ImageFlashOff.muiName = 'SvgIcon';

exports.default = ImageFlashOff;

/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFlashOn = function ImageFlashOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 2v11h3v9l7-12h-4l4-8z' })
  );
};
ImageFlashOn = (0, _pure2.default)(ImageFlashOn);
ImageFlashOn.displayName = 'ImageFlashOn';
ImageFlashOn.muiName = 'SvgIcon';

exports.default = ImageFlashOn;

/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFlip = function ImageFlip(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z' })
  );
};
ImageFlip = (0, _pure2.default)(ImageFlip);
ImageFlip.displayName = 'ImageFlip';
ImageFlip.muiName = 'SvgIcon';

exports.default = ImageFlip;

/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageGradient = function ImageGradient(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z' })
  );
};
ImageGradient = (0, _pure2.default)(ImageGradient);
ImageGradient.displayName = 'ImageGradient';
ImageGradient.muiName = 'SvgIcon';

exports.default = ImageGradient;

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageGrain = function ImageGrain(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
ImageGrain = (0, _pure2.default)(ImageGrain);
ImageGrain.displayName = 'ImageGrain';
ImageGrain.muiName = 'SvgIcon';

exports.default = ImageGrain;

/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageGridOff = function ImageGridOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z' })
  );
};
ImageGridOff = (0, _pure2.default)(ImageGridOff);
ImageGridOff.displayName = 'ImageGridOff';
ImageGridOff.muiName = 'SvgIcon';

exports.default = ImageGridOff;

/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageGridOn = function ImageGridOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z' })
  );
};
ImageGridOn = (0, _pure2.default)(ImageGridOn);
ImageGridOn.displayName = 'ImageGridOn';
ImageGridOn.muiName = 'SvgIcon';

exports.default = ImageGridOn;

/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageHdrOff = function ImageHdrOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z' })
  );
};
ImageHdrOff = (0, _pure2.default)(ImageHdrOff);
ImageHdrOff.displayName = 'ImageHdrOff';
ImageHdrOff.muiName = 'SvgIcon';

exports.default = ImageHdrOff;

/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageHdrOn = function ImageHdrOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z' })
  );
};
ImageHdrOn = (0, _pure2.default)(ImageHdrOn);
ImageHdrOn.displayName = 'ImageHdrOn';
ImageHdrOn.muiName = 'SvgIcon';

exports.default = ImageHdrOn;

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageHdrStrong = function ImageHdrStrong(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
ImageHdrStrong = (0, _pure2.default)(ImageHdrStrong);
ImageHdrStrong.displayName = 'ImageHdrStrong';
ImageHdrStrong.muiName = 'SvgIcon';

exports.default = ImageHdrStrong;

/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageHdrWeak = function ImageHdrWeak(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
  );
};
ImageHdrWeak = (0, _pure2.default)(ImageHdrWeak);
ImageHdrWeak.displayName = 'ImageHdrWeak';
ImageHdrWeak.muiName = 'SvgIcon';

exports.default = ImageHdrWeak;

/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageHealing = function ImageHealing(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z' })
  );
};
ImageHealing = (0, _pure2.default)(ImageHealing);
ImageHealing.displayName = 'ImageHealing';
ImageHealing.muiName = 'SvgIcon';

exports.default = ImageHealing;

/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageImageAspectRatio = function ImageImageAspectRatio(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z' })
  );
};
ImageImageAspectRatio = (0, _pure2.default)(ImageImageAspectRatio);
ImageImageAspectRatio.displayName = 'ImageImageAspectRatio';
ImageImageAspectRatio.muiName = 'SvgIcon';

exports.default = ImageImageAspectRatio;

/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageImage = function ImageImage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
  );
};
ImageImage = (0, _pure2.default)(ImageImage);
ImageImage.displayName = 'ImageImage';
ImageImage.muiName = 'SvgIcon';

exports.default = ImageImage;

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageIso = function ImageIso(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z' })
  );
};
ImageIso = (0, _pure2.default)(ImageIso);
ImageIso.displayName = 'ImageIso';
ImageIso.muiName = 'SvgIcon';

exports.default = ImageIso;

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLandscape = function ImageLandscape(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
  );
};
ImageLandscape = (0, _pure2.default)(ImageLandscape);
ImageLandscape.displayName = 'ImageLandscape';
ImageLandscape.muiName = 'SvgIcon';

exports.default = ImageLandscape;

/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLeakAdd = function ImageLeakAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z' })
  );
};
ImageLeakAdd = (0, _pure2.default)(ImageLeakAdd);
ImageLeakAdd.displayName = 'ImageLeakAdd';
ImageLeakAdd.muiName = 'SvgIcon';

exports.default = ImageLeakAdd;

/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLeakRemove = function ImageLeakRemove(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z' })
  );
};
ImageLeakRemove = (0, _pure2.default)(ImageLeakRemove);
ImageLeakRemove.displayName = 'ImageLeakRemove';
ImageLeakRemove.muiName = 'SvgIcon';

exports.default = ImageLeakRemove;

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLens = function ImageLens(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z' })
  );
};
ImageLens = (0, _pure2.default)(ImageLens);
ImageLens.displayName = 'ImageLens';
ImageLens.muiName = 'SvgIcon';

exports.default = ImageLens;

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLinkedCamera = function ImageLinkedCamera(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '14', r: '3.2' }),
    _react2.default.createElement('path', { d: 'M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6' }),
    _react2.default.createElement('path', { d: 'M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
  );
};
ImageLinkedCamera = (0, _pure2.default)(ImageLinkedCamera);
ImageLinkedCamera.displayName = 'ImageLinkedCamera';
ImageLinkedCamera.muiName = 'SvgIcon';

exports.default = ImageLinkedCamera;

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLooks3 = function ImageLooks3(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z' })
  );
};
ImageLooks3 = (0, _pure2.default)(ImageLooks3);
ImageLooks3.displayName = 'ImageLooks3';
ImageLooks3.muiName = 'SvgIcon';

exports.default = ImageLooks3;

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLooks4 = function ImageLooks4(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z' })
  );
};
ImageLooks4 = (0, _pure2.default)(ImageLooks4);
ImageLooks4.displayName = 'ImageLooks4';
ImageLooks4.muiName = 'SvgIcon';

exports.default = ImageLooks4;

/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLooks5 = function ImageLooks5(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z' })
  );
};
ImageLooks5 = (0, _pure2.default)(ImageLooks5);
ImageLooks5.displayName = 'ImageLooks5';
ImageLooks5.muiName = 'SvgIcon';

exports.default = ImageLooks5;

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLooks6 = function ImageLooks6(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z' })
  );
};
ImageLooks6 = (0, _pure2.default)(ImageLooks6);
ImageLooks6.displayName = 'ImageLooks6';
ImageLooks6.muiName = 'SvgIcon';

exports.default = ImageLooks6;

/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLooksOne = function ImageLooksOne(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z' })
  );
};
ImageLooksOne = (0, _pure2.default)(ImageLooksOne);
ImageLooksOne.displayName = 'ImageLooksOne';
ImageLooksOne.muiName = 'SvgIcon';

exports.default = ImageLooksOne;

/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLooksTwo = function ImageLooksTwo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z' })
  );
};
ImageLooksTwo = (0, _pure2.default)(ImageLooksTwo);
ImageLooksTwo.displayName = 'ImageLooksTwo';
ImageLooksTwo.muiName = 'SvgIcon';

exports.default = ImageLooksTwo;

/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLooks = function ImageLooks(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z' })
  );
};
ImageLooks = (0, _pure2.default)(ImageLooks);
ImageLooks.displayName = 'ImageLooks';
ImageLooks.muiName = 'SvgIcon';

exports.default = ImageLooks;

/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageLoupe = function ImageLoupe(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ImageLoupe = (0, _pure2.default)(ImageLoupe);
ImageLoupe.displayName = 'ImageLoupe';
ImageLoupe.muiName = 'SvgIcon';

exports.default = ImageLoupe;

/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageMonochromePhotos = function ImageMonochromePhotos(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z' })
  );
};
ImageMonochromePhotos = (0, _pure2.default)(ImageMonochromePhotos);
ImageMonochromePhotos.displayName = 'ImageMonochromePhotos';
ImageMonochromePhotos.muiName = 'SvgIcon';

exports.default = ImageMonochromePhotos;

/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageMovieCreation = function ImageMovieCreation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
  );
};
ImageMovieCreation = (0, _pure2.default)(ImageMovieCreation);
ImageMovieCreation.displayName = 'ImageMovieCreation';
ImageMovieCreation.muiName = 'SvgIcon';

exports.default = ImageMovieCreation;

/***/ }),
/* 3020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageMovieFilter = function ImageMovieFilter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z' })
  );
};
ImageMovieFilter = (0, _pure2.default)(ImageMovieFilter);
ImageMovieFilter.displayName = 'ImageMovieFilter';
ImageMovieFilter.muiName = 'SvgIcon';

exports.default = ImageMovieFilter;

/***/ }),
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageMusicNote = function ImageMusicNote(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z' })
  );
};
ImageMusicNote = (0, _pure2.default)(ImageMusicNote);
ImageMusicNote.displayName = 'ImageMusicNote';
ImageMusicNote.muiName = 'SvgIcon';

exports.default = ImageMusicNote;

/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageNaturePeople = function ImageNaturePeople(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z' })
  );
};
ImageNaturePeople = (0, _pure2.default)(ImageNaturePeople);
ImageNaturePeople.displayName = 'ImageNaturePeople';
ImageNaturePeople.muiName = 'SvgIcon';

exports.default = ImageNaturePeople;

/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageNature = function ImageNature(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z' })
  );
};
ImageNature = (0, _pure2.default)(ImageNature);
ImageNature.displayName = 'ImageNature';
ImageNature.muiName = 'SvgIcon';

exports.default = ImageNature;

/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageNavigateBefore = function ImageNavigateBefore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
  );
};
ImageNavigateBefore = (0, _pure2.default)(ImageNavigateBefore);
ImageNavigateBefore.displayName = 'ImageNavigateBefore';
ImageNavigateBefore.muiName = 'SvgIcon';

exports.default = ImageNavigateBefore;

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageNavigateNext = function ImageNavigateNext(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
  );
};
ImageNavigateNext = (0, _pure2.default)(ImageNavigateNext);
ImageNavigateNext.displayName = 'ImageNavigateNext';
ImageNavigateNext.muiName = 'SvgIcon';

exports.default = ImageNavigateNext;

/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanoramaFishEye = function ImagePanoramaFishEye(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ImagePanoramaFishEye = (0, _pure2.default)(ImagePanoramaFishEye);
ImagePanoramaFishEye.displayName = 'ImagePanoramaFishEye';
ImagePanoramaFishEye.muiName = 'SvgIcon';

exports.default = ImagePanoramaFishEye;

/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanoramaHorizontal = function ImagePanoramaHorizontal(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z' })
  );
};
ImagePanoramaHorizontal = (0, _pure2.default)(ImagePanoramaHorizontal);
ImagePanoramaHorizontal.displayName = 'ImagePanoramaHorizontal';
ImagePanoramaHorizontal.muiName = 'SvgIcon';

exports.default = ImagePanoramaHorizontal;

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanoramaVertical = function ImagePanoramaVertical(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z' })
  );
};
ImagePanoramaVertical = (0, _pure2.default)(ImagePanoramaVertical);
ImagePanoramaVertical.displayName = 'ImagePanoramaVertical';
ImagePanoramaVertical.muiName = 'SvgIcon';

exports.default = ImagePanoramaVertical;

/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanoramaWideAngle = function ImagePanoramaWideAngle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z' })
  );
};
ImagePanoramaWideAngle = (0, _pure2.default)(ImagePanoramaWideAngle);
ImagePanoramaWideAngle.displayName = 'ImagePanoramaWideAngle';
ImagePanoramaWideAngle.muiName = 'SvgIcon';

exports.default = ImagePanoramaWideAngle;

/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanorama = function ImagePanorama(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z' })
  );
};
ImagePanorama = (0, _pure2.default)(ImagePanorama);
ImagePanorama.displayName = 'ImagePanorama';
ImagePanorama.muiName = 'SvgIcon';

exports.default = ImagePanorama;

/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoAlbum = function ImagePhotoAlbum(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z' })
  );
};
ImagePhotoAlbum = (0, _pure2.default)(ImagePhotoAlbum);
ImagePhotoAlbum.displayName = 'ImagePhotoAlbum';
ImagePhotoAlbum.muiName = 'SvgIcon';

exports.default = ImagePhotoAlbum;

/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoCamera = function ImagePhotoCamera(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
  );
};
ImagePhotoCamera = (0, _pure2.default)(ImagePhotoCamera);
ImagePhotoCamera.displayName = 'ImagePhotoCamera';
ImagePhotoCamera.muiName = 'SvgIcon';

exports.default = ImagePhotoCamera;

/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoFilter = function ImagePhotoFilter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z' })
  );
};
ImagePhotoFilter = (0, _pure2.default)(ImagePhotoFilter);
ImagePhotoFilter.displayName = 'ImagePhotoFilter';
ImagePhotoFilter.muiName = 'SvgIcon';

exports.default = ImagePhotoFilter;

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoLibrary = function ImagePhotoLibrary(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
  );
};
ImagePhotoLibrary = (0, _pure2.default)(ImagePhotoLibrary);
ImagePhotoLibrary.displayName = 'ImagePhotoLibrary';
ImagePhotoLibrary.muiName = 'SvgIcon';

exports.default = ImagePhotoLibrary;

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoSizeSelectActual = function ImagePhotoSizeSelectActual(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z' })
  );
};
ImagePhotoSizeSelectActual = (0, _pure2.default)(ImagePhotoSizeSelectActual);
ImagePhotoSizeSelectActual.displayName = 'ImagePhotoSizeSelectActual';
ImagePhotoSizeSelectActual.muiName = 'SvgIcon';

exports.default = ImagePhotoSizeSelectActual;

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoSizeSelectLarge = function ImagePhotoSizeSelectLarge(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z' })
  );
};
ImagePhotoSizeSelectLarge = (0, _pure2.default)(ImagePhotoSizeSelectLarge);
ImagePhotoSizeSelectLarge.displayName = 'ImagePhotoSizeSelectLarge';
ImagePhotoSizeSelectLarge.muiName = 'SvgIcon';

exports.default = ImagePhotoSizeSelectLarge;

/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhotoSizeSelectSmall = function ImagePhotoSizeSelectSmall(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z' })
  );
};
ImagePhotoSizeSelectSmall = (0, _pure2.default)(ImagePhotoSizeSelectSmall);
ImagePhotoSizeSelectSmall.displayName = 'ImagePhotoSizeSelectSmall';
ImagePhotoSizeSelectSmall.muiName = 'SvgIcon';

exports.default = ImagePhotoSizeSelectSmall;

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePhoto = function ImagePhoto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
  );
};
ImagePhoto = (0, _pure2.default)(ImagePhoto);
ImagePhoto.displayName = 'ImagePhoto';
ImagePhoto.muiName = 'SvgIcon';

exports.default = ImagePhoto;

/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePictureAsPdf = function ImagePictureAsPdf(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z' })
  );
};
ImagePictureAsPdf = (0, _pure2.default)(ImagePictureAsPdf);
ImagePictureAsPdf.displayName = 'ImagePictureAsPdf';
ImagePictureAsPdf.muiName = 'SvgIcon';

exports.default = ImagePictureAsPdf;

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePortrait = function ImagePortrait(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
  );
};
ImagePortrait = (0, _pure2.default)(ImagePortrait);
ImagePortrait.displayName = 'ImagePortrait';
ImagePortrait.muiName = 'SvgIcon';

exports.default = ImagePortrait;

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageRemoveRedEye = function ImageRemoveRedEye(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ImageRemoveRedEye = (0, _pure2.default)(ImageRemoveRedEye);
ImageRemoveRedEye.displayName = 'ImageRemoveRedEye';
ImageRemoveRedEye.muiName = 'SvgIcon';

exports.default = ImageRemoveRedEye;

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageRotate90DegreesCcw = function ImageRotate90DegreesCcw(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z' })
  );
};
ImageRotate90DegreesCcw = (0, _pure2.default)(ImageRotate90DegreesCcw);
ImageRotate90DegreesCcw.displayName = 'ImageRotate90DegreesCcw';
ImageRotate90DegreesCcw.muiName = 'SvgIcon';

exports.default = ImageRotate90DegreesCcw;

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageRotateLeft = function ImageRotateLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z' })
  );
};
ImageRotateLeft = (0, _pure2.default)(ImageRotateLeft);
ImageRotateLeft.displayName = 'ImageRotateLeft';
ImageRotateLeft.muiName = 'SvgIcon';

exports.default = ImageRotateLeft;

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageRotateRight = function ImageRotateRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z' })
  );
};
ImageRotateRight = (0, _pure2.default)(ImageRotateRight);
ImageRotateRight.displayName = 'ImageRotateRight';
ImageRotateRight.muiName = 'SvgIcon';

exports.default = ImageRotateRight;

/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSlideshow = function ImageSlideshow(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
  );
};
ImageSlideshow = (0, _pure2.default)(ImageSlideshow);
ImageSlideshow.displayName = 'ImageSlideshow';
ImageSlideshow.muiName = 'SvgIcon';

exports.default = ImageSlideshow;

/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageStraighten = function ImageStraighten(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z' })
  );
};
ImageStraighten = (0, _pure2.default)(ImageStraighten);
ImageStraighten.displayName = 'ImageStraighten';
ImageStraighten.muiName = 'SvgIcon';

exports.default = ImageStraighten;

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageStyle = function ImageStyle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z' })
  );
};
ImageStyle = (0, _pure2.default)(ImageStyle);
ImageStyle.displayName = 'ImageStyle';
ImageStyle.muiName = 'SvgIcon';

exports.default = ImageStyle;

/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSwitchCamera = function ImageSwitchCamera(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
  );
};
ImageSwitchCamera = (0, _pure2.default)(ImageSwitchCamera);
ImageSwitchCamera.displayName = 'ImageSwitchCamera';
ImageSwitchCamera.muiName = 'SvgIcon';

exports.default = ImageSwitchCamera;

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageSwitchVideo = function ImageSwitchVideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
  );
};
ImageSwitchVideo = (0, _pure2.default)(ImageSwitchVideo);
ImageSwitchVideo.displayName = 'ImageSwitchVideo';
ImageSwitchVideo.muiName = 'SvgIcon';

exports.default = ImageSwitchVideo;

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTagFaces = function ImageTagFaces(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
  );
};
ImageTagFaces = (0, _pure2.default)(ImageTagFaces);
ImageTagFaces.displayName = 'ImageTagFaces';
ImageTagFaces.muiName = 'SvgIcon';

exports.default = ImageTagFaces;

/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTexture = function ImageTexture(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z' })
  );
};
ImageTexture = (0, _pure2.default)(ImageTexture);
ImageTexture.displayName = 'ImageTexture';
ImageTexture.muiName = 'SvgIcon';

exports.default = ImageTexture;

/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTimelapse = function ImageTimelapse(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
ImageTimelapse = (0, _pure2.default)(ImageTimelapse);
ImageTimelapse.displayName = 'ImageTimelapse';
ImageTimelapse.muiName = 'SvgIcon';

exports.default = ImageTimelapse;

/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTimer10 = function ImageTimer10(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z' })
  );
};
ImageTimer10 = (0, _pure2.default)(ImageTimer10);
ImageTimer10.displayName = 'ImageTimer10';
ImageTimer10.muiName = 'SvgIcon';

exports.default = ImageTimer10;

/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTimer3 = function ImageTimer3(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z' })
  );
};
ImageTimer3 = (0, _pure2.default)(ImageTimer3);
ImageTimer3.displayName = 'ImageTimer3';
ImageTimer3.muiName = 'SvgIcon';

exports.default = ImageTimer3;

/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTimerOff = function ImageTimerOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z' })
  );
};
ImageTimerOff = (0, _pure2.default)(ImageTimerOff);
ImageTimerOff.displayName = 'ImageTimerOff';
ImageTimerOff.muiName = 'SvgIcon';

exports.default = ImageTimerOff;

/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTimer = function ImageTimer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
ImageTimer = (0, _pure2.default)(ImageTimer);
ImageTimer.displayName = 'ImageTimer';
ImageTimer.muiName = 'SvgIcon';

exports.default = ImageTimer;

/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTonality = function ImageTonality(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z' })
  );
};
ImageTonality = (0, _pure2.default)(ImageTonality);
ImageTonality.displayName = 'ImageTonality';
ImageTonality.muiName = 'SvgIcon';

exports.default = ImageTonality;

/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTransform = function ImageTransform(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z' })
  );
};
ImageTransform = (0, _pure2.default)(ImageTransform);
ImageTransform.displayName = 'ImageTransform';
ImageTransform.muiName = 'SvgIcon';

exports.default = ImageTransform;

/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageTune = function ImageTune(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z' })
  );
};
ImageTune = (0, _pure2.default)(ImageTune);
ImageTune.displayName = 'ImageTune';
ImageTune.muiName = 'SvgIcon';

exports.default = ImageTune;

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageViewComfy = function ImageViewComfy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z' })
  );
};
ImageViewComfy = (0, _pure2.default)(ImageViewComfy);
ImageViewComfy.displayName = 'ImageViewComfy';
ImageViewComfy.muiName = 'SvgIcon';

exports.default = ImageViewComfy;

/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageViewCompact = function ImageViewCompact(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z' })
  );
};
ImageViewCompact = (0, _pure2.default)(ImageViewCompact);
ImageViewCompact.displayName = 'ImageViewCompact';
ImageViewCompact.muiName = 'SvgIcon';

exports.default = ImageViewCompact;

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageVignette = function ImageVignette(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z' })
  );
};
ImageVignette = (0, _pure2.default)(ImageVignette);
ImageVignette.displayName = 'ImageVignette';
ImageVignette.muiName = 'SvgIcon';

exports.default = ImageVignette;

/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWbAuto = function ImageWbAuto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z' })
  );
};
ImageWbAuto = (0, _pure2.default)(ImageWbAuto);
ImageWbAuto.displayName = 'ImageWbAuto';
ImageWbAuto.muiName = 'SvgIcon';

exports.default = ImageWbAuto;

/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWbCloudy = function ImageWbCloudy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z' })
  );
};
ImageWbCloudy = (0, _pure2.default)(ImageWbCloudy);
ImageWbCloudy.displayName = 'ImageWbCloudy';
ImageWbCloudy.muiName = 'SvgIcon';

exports.default = ImageWbCloudy;

/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWbIncandescent = function ImageWbIncandescent(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z' })
  );
};
ImageWbIncandescent = (0, _pure2.default)(ImageWbIncandescent);
ImageWbIncandescent.displayName = 'ImageWbIncandescent';
ImageWbIncandescent.muiName = 'SvgIcon';

exports.default = ImageWbIncandescent;

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWbIridescent = function ImageWbIridescent(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z' })
  );
};
ImageWbIridescent = (0, _pure2.default)(ImageWbIridescent);
ImageWbIridescent.displayName = 'ImageWbIridescent';
ImageWbIridescent.muiName = 'SvgIcon';

exports.default = ImageWbIridescent;

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWbSunny = function ImageWbSunny(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z' })
  );
};
ImageWbSunny = (0, _pure2.default)(ImageWbSunny);
ImageWbSunny.displayName = 'ImageWbSunny';
ImageWbSunny.muiName = 'SvgIcon';

exports.default = ImageWbSunny;

/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsAddLocation = function MapsAddLocation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z' })
  );
};
MapsAddLocation = (0, _pure2.default)(MapsAddLocation);
MapsAddLocation.displayName = 'MapsAddLocation';
MapsAddLocation.muiName = 'SvgIcon';

exports.default = MapsAddLocation;

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsBeenhere = function MapsBeenhere(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z' })
  );
};
MapsBeenhere = (0, _pure2.default)(MapsBeenhere);
MapsBeenhere.displayName = 'MapsBeenhere';
MapsBeenhere.muiName = 'SvgIcon';

exports.default = MapsBeenhere;

/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsBike = function MapsDirectionsBike(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z' })
  );
};
MapsDirectionsBike = (0, _pure2.default)(MapsDirectionsBike);
MapsDirectionsBike.displayName = 'MapsDirectionsBike';
MapsDirectionsBike.muiName = 'SvgIcon';

exports.default = MapsDirectionsBike;

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsBoat = function MapsDirectionsBoat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z' })
  );
};
MapsDirectionsBoat = (0, _pure2.default)(MapsDirectionsBoat);
MapsDirectionsBoat.displayName = 'MapsDirectionsBoat';
MapsDirectionsBoat.muiName = 'SvgIcon';

exports.default = MapsDirectionsBoat;

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsBus = function MapsDirectionsBus(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z' })
  );
};
MapsDirectionsBus = (0, _pure2.default)(MapsDirectionsBus);
MapsDirectionsBus.displayName = 'MapsDirectionsBus';
MapsDirectionsBus.muiName = 'SvgIcon';

exports.default = MapsDirectionsBus;

/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsCar = function MapsDirectionsCar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
  );
};
MapsDirectionsCar = (0, _pure2.default)(MapsDirectionsCar);
MapsDirectionsCar.displayName = 'MapsDirectionsCar';
MapsDirectionsCar.muiName = 'SvgIcon';

exports.default = MapsDirectionsCar;

/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsRailway = function MapsDirectionsRailway(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z' })
  );
};
MapsDirectionsRailway = (0, _pure2.default)(MapsDirectionsRailway);
MapsDirectionsRailway.displayName = 'MapsDirectionsRailway';
MapsDirectionsRailway.muiName = 'SvgIcon';

exports.default = MapsDirectionsRailway;

/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsRun = function MapsDirectionsRun(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z' })
  );
};
MapsDirectionsRun = (0, _pure2.default)(MapsDirectionsRun);
MapsDirectionsRun.displayName = 'MapsDirectionsRun';
MapsDirectionsRun.muiName = 'SvgIcon';

exports.default = MapsDirectionsRun;

/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsSubway = function MapsDirectionsSubway(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
  );
};
MapsDirectionsSubway = (0, _pure2.default)(MapsDirectionsSubway);
MapsDirectionsSubway.displayName = 'MapsDirectionsSubway';
MapsDirectionsSubway.muiName = 'SvgIcon';

exports.default = MapsDirectionsSubway;

/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsTransit = function MapsDirectionsTransit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
  );
};
MapsDirectionsTransit = (0, _pure2.default)(MapsDirectionsTransit);
MapsDirectionsTransit.displayName = 'MapsDirectionsTransit';
MapsDirectionsTransit.muiName = 'SvgIcon';

exports.default = MapsDirectionsTransit;

/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirectionsWalk = function MapsDirectionsWalk(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7' })
  );
};
MapsDirectionsWalk = (0, _pure2.default)(MapsDirectionsWalk);
MapsDirectionsWalk.displayName = 'MapsDirectionsWalk';
MapsDirectionsWalk.muiName = 'SvgIcon';

exports.default = MapsDirectionsWalk;

/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsDirections = function MapsDirections(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z' })
  );
};
MapsDirections = (0, _pure2.default)(MapsDirections);
MapsDirections.displayName = 'MapsDirections';
MapsDirections.muiName = 'SvgIcon';

exports.default = MapsDirections;

/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsEditLocation = function MapsEditLocation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z' })
  );
};
MapsEditLocation = (0, _pure2.default)(MapsEditLocation);
MapsEditLocation.displayName = 'MapsEditLocation';
MapsEditLocation.muiName = 'SvgIcon';

exports.default = MapsEditLocation;

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsEvStation = function MapsEvStation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z' })
  );
};
MapsEvStation = (0, _pure2.default)(MapsEvStation);
MapsEvStation.displayName = 'MapsEvStation';
MapsEvStation.muiName = 'SvgIcon';

exports.default = MapsEvStation;

/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsFlight = function MapsFlight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.18 9' }),
    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
  );
};
MapsFlight = (0, _pure2.default)(MapsFlight);
MapsFlight.displayName = 'MapsFlight';
MapsFlight.muiName = 'SvgIcon';

exports.default = MapsFlight;

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsHotel = function MapsHotel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
  );
};
MapsHotel = (0, _pure2.default)(MapsHotel);
MapsHotel.displayName = 'MapsHotel';
MapsHotel.muiName = 'SvgIcon';

exports.default = MapsHotel;

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLayersClear = function MapsLayersClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z' })
  );
};
MapsLayersClear = (0, _pure2.default)(MapsLayersClear);
MapsLayersClear.displayName = 'MapsLayersClear';
MapsLayersClear.muiName = 'SvgIcon';

exports.default = MapsLayersClear;

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLayers = function MapsLayers(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' })
  );
};
MapsLayers = (0, _pure2.default)(MapsLayers);
MapsLayers.displayName = 'MapsLayers';
MapsLayers.muiName = 'SvgIcon';

exports.default = MapsLayers;

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalActivity = function MapsLocalActivity(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
  );
};
MapsLocalActivity = (0, _pure2.default)(MapsLocalActivity);
MapsLocalActivity.displayName = 'MapsLocalActivity';
MapsLocalActivity.muiName = 'SvgIcon';

exports.default = MapsLocalActivity;

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalAirport = function MapsLocalAirport(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
  );
};
MapsLocalAirport = (0, _pure2.default)(MapsLocalAirport);
MapsLocalAirport.displayName = 'MapsLocalAirport';
MapsLocalAirport.muiName = 'SvgIcon';

exports.default = MapsLocalAirport;

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalAtm = function MapsLocalAtm(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z' })
  );
};
MapsLocalAtm = (0, _pure2.default)(MapsLocalAtm);
MapsLocalAtm.displayName = 'MapsLocalAtm';
MapsLocalAtm.muiName = 'SvgIcon';

exports.default = MapsLocalAtm;

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalBar = function MapsLocalBar(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z' })
  );
};
MapsLocalBar = (0, _pure2.default)(MapsLocalBar);
MapsLocalBar.displayName = 'MapsLocalBar';
MapsLocalBar.muiName = 'SvgIcon';

exports.default = MapsLocalBar;

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalCafe = function MapsLocalCafe(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z' })
  );
};
MapsLocalCafe = (0, _pure2.default)(MapsLocalCafe);
MapsLocalCafe.displayName = 'MapsLocalCafe';
MapsLocalCafe.muiName = 'SvgIcon';

exports.default = MapsLocalCafe;

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalCarWash = function MapsLocalCarWash(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z' })
  );
};
MapsLocalCarWash = (0, _pure2.default)(MapsLocalCarWash);
MapsLocalCarWash.displayName = 'MapsLocalCarWash';
MapsLocalCarWash.muiName = 'SvgIcon';

exports.default = MapsLocalCarWash;

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalConvenienceStore = function MapsLocalConvenienceStore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z' })
  );
};
MapsLocalConvenienceStore = (0, _pure2.default)(MapsLocalConvenienceStore);
MapsLocalConvenienceStore.displayName = 'MapsLocalConvenienceStore';
MapsLocalConvenienceStore.muiName = 'SvgIcon';

exports.default = MapsLocalConvenienceStore;

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalDining = function MapsLocalDining(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
  );
};
MapsLocalDining = (0, _pure2.default)(MapsLocalDining);
MapsLocalDining.displayName = 'MapsLocalDining';
MapsLocalDining.muiName = 'SvgIcon';

exports.default = MapsLocalDining;

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalDrink = function MapsLocalDrink(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z' })
  );
};
MapsLocalDrink = (0, _pure2.default)(MapsLocalDrink);
MapsLocalDrink.displayName = 'MapsLocalDrink';
MapsLocalDrink.muiName = 'SvgIcon';

exports.default = MapsLocalDrink;

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalFlorist = function MapsLocalFlorist(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z' })
  );
};
MapsLocalFlorist = (0, _pure2.default)(MapsLocalFlorist);
MapsLocalFlorist.displayName = 'MapsLocalFlorist';
MapsLocalFlorist.muiName = 'SvgIcon';

exports.default = MapsLocalFlorist;

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalGasStation = function MapsLocalGasStation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
  );
};
MapsLocalGasStation = (0, _pure2.default)(MapsLocalGasStation);
MapsLocalGasStation.displayName = 'MapsLocalGasStation';
MapsLocalGasStation.muiName = 'SvgIcon';

exports.default = MapsLocalGasStation;

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalGroceryStore = function MapsLocalGroceryStore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
  );
};
MapsLocalGroceryStore = (0, _pure2.default)(MapsLocalGroceryStore);
MapsLocalGroceryStore.displayName = 'MapsLocalGroceryStore';
MapsLocalGroceryStore.muiName = 'SvgIcon';

exports.default = MapsLocalGroceryStore;

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalHospital = function MapsLocalHospital(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z' })
  );
};
MapsLocalHospital = (0, _pure2.default)(MapsLocalHospital);
MapsLocalHospital.displayName = 'MapsLocalHospital';
MapsLocalHospital.muiName = 'SvgIcon';

exports.default = MapsLocalHospital;

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalHotel = function MapsLocalHotel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
  );
};
MapsLocalHotel = (0, _pure2.default)(MapsLocalHotel);
MapsLocalHotel.displayName = 'MapsLocalHotel';
MapsLocalHotel.muiName = 'SvgIcon';

exports.default = MapsLocalHotel;

/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalLaundryService = function MapsLocalLaundryService(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
  );
};
MapsLocalLaundryService = (0, _pure2.default)(MapsLocalLaundryService);
MapsLocalLaundryService.displayName = 'MapsLocalLaundryService';
MapsLocalLaundryService.muiName = 'SvgIcon';

exports.default = MapsLocalLaundryService;

/***/ }),
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalLibrary = function MapsLocalLibrary(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z' })
  );
};
MapsLocalLibrary = (0, _pure2.default)(MapsLocalLibrary);
MapsLocalLibrary.displayName = 'MapsLocalLibrary';
MapsLocalLibrary.muiName = 'SvgIcon';

exports.default = MapsLocalLibrary;

/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalMall = function MapsLocalMall(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z' })
  );
};
MapsLocalMall = (0, _pure2.default)(MapsLocalMall);
MapsLocalMall.displayName = 'MapsLocalMall';
MapsLocalMall.muiName = 'SvgIcon';

exports.default = MapsLocalMall;

/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalMovies = function MapsLocalMovies(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
  );
};
MapsLocalMovies = (0, _pure2.default)(MapsLocalMovies);
MapsLocalMovies.displayName = 'MapsLocalMovies';
MapsLocalMovies.muiName = 'SvgIcon';

exports.default = MapsLocalMovies;

/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalOffer = function MapsLocalOffer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z' })
  );
};
MapsLocalOffer = (0, _pure2.default)(MapsLocalOffer);
MapsLocalOffer.displayName = 'MapsLocalOffer';
MapsLocalOffer.muiName = 'SvgIcon';

exports.default = MapsLocalOffer;

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalParking = function MapsLocalParking(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z' })
  );
};
MapsLocalParking = (0, _pure2.default)(MapsLocalParking);
MapsLocalParking.displayName = 'MapsLocalParking';
MapsLocalParking.muiName = 'SvgIcon';

exports.default = MapsLocalParking;

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalPharmacy = function MapsLocalPharmacy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z' })
  );
};
MapsLocalPharmacy = (0, _pure2.default)(MapsLocalPharmacy);
MapsLocalPharmacy.displayName = 'MapsLocalPharmacy';
MapsLocalPharmacy.muiName = 'SvgIcon';

exports.default = MapsLocalPharmacy;

/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalPhone = function MapsLocalPhone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
  );
};
MapsLocalPhone = (0, _pure2.default)(MapsLocalPhone);
MapsLocalPhone.displayName = 'MapsLocalPhone';
MapsLocalPhone.muiName = 'SvgIcon';

exports.default = MapsLocalPhone;

/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalPizza = function MapsLocalPizza(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
MapsLocalPizza = (0, _pure2.default)(MapsLocalPizza);
MapsLocalPizza.displayName = 'MapsLocalPizza';
MapsLocalPizza.muiName = 'SvgIcon';

exports.default = MapsLocalPizza;

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalPlay = function MapsLocalPlay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
  );
};
MapsLocalPlay = (0, _pure2.default)(MapsLocalPlay);
MapsLocalPlay.displayName = 'MapsLocalPlay';
MapsLocalPlay.muiName = 'SvgIcon';

exports.default = MapsLocalPlay;

/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalPostOffice = function MapsLocalPostOffice(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
  );
};
MapsLocalPostOffice = (0, _pure2.default)(MapsLocalPostOffice);
MapsLocalPostOffice.displayName = 'MapsLocalPostOffice';
MapsLocalPostOffice.muiName = 'SvgIcon';

exports.default = MapsLocalPostOffice;

/***/ }),
/* 3111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalPrintshop = function MapsLocalPrintshop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
  );
};
MapsLocalPrintshop = (0, _pure2.default)(MapsLocalPrintshop);
MapsLocalPrintshop.displayName = 'MapsLocalPrintshop';
MapsLocalPrintshop.muiName = 'SvgIcon';

exports.default = MapsLocalPrintshop;

/***/ }),
/* 3112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalSee = function MapsLocalSee(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
  );
};
MapsLocalSee = (0, _pure2.default)(MapsLocalSee);
MapsLocalSee.displayName = 'MapsLocalSee';
MapsLocalSee.muiName = 'SvgIcon';

exports.default = MapsLocalSee;

/***/ }),
/* 3113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalShipping = function MapsLocalShipping(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
MapsLocalShipping = (0, _pure2.default)(MapsLocalShipping);
MapsLocalShipping.displayName = 'MapsLocalShipping';
MapsLocalShipping.muiName = 'SvgIcon';

exports.default = MapsLocalShipping;

/***/ }),
/* 3114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalTaxi = function MapsLocalTaxi(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
  );
};
MapsLocalTaxi = (0, _pure2.default)(MapsLocalTaxi);
MapsLocalTaxi.displayName = 'MapsLocalTaxi';
MapsLocalTaxi.muiName = 'SvgIcon';

exports.default = MapsLocalTaxi;

/***/ }),
/* 3115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsMap = function MapsMap(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z' })
  );
};
MapsMap = (0, _pure2.default)(MapsMap);
MapsMap.displayName = 'MapsMap';
MapsMap.muiName = 'SvgIcon';

exports.default = MapsMap;

/***/ }),
/* 3116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsMyLocation = function MapsMyLocation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
MapsMyLocation = (0, _pure2.default)(MapsMyLocation);
MapsMyLocation.displayName = 'MapsMyLocation';
MapsMyLocation.muiName = 'SvgIcon';

exports.default = MapsMyLocation;

/***/ }),
/* 3117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsNavigation = function MapsNavigation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z' })
  );
};
MapsNavigation = (0, _pure2.default)(MapsNavigation);
MapsNavigation.displayName = 'MapsNavigation';
MapsNavigation.muiName = 'SvgIcon';

exports.default = MapsNavigation;

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsNearMe = function MapsNearMe(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z' })
  );
};
MapsNearMe = (0, _pure2.default)(MapsNearMe);
MapsNearMe.displayName = 'MapsNearMe';
MapsNearMe.muiName = 'SvgIcon';

exports.default = MapsNearMe;

/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsPersonPinCircle = function MapsPersonPinCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z' })
  );
};
MapsPersonPinCircle = (0, _pure2.default)(MapsPersonPinCircle);
MapsPersonPinCircle.displayName = 'MapsPersonPinCircle';
MapsPersonPinCircle.muiName = 'SvgIcon';

exports.default = MapsPersonPinCircle;

/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsPersonPin = function MapsPersonPin(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z' })
  );
};
MapsPersonPin = (0, _pure2.default)(MapsPersonPin);
MapsPersonPin.displayName = 'MapsPersonPin';
MapsPersonPin.muiName = 'SvgIcon';

exports.default = MapsPersonPin;

/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsPinDrop = function MapsPinDrop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z' })
  );
};
MapsPinDrop = (0, _pure2.default)(MapsPinDrop);
MapsPinDrop.displayName = 'MapsPinDrop';
MapsPinDrop.muiName = 'SvgIcon';

exports.default = MapsPinDrop;

/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsPlace = function MapsPlace(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
  );
};
MapsPlace = (0, _pure2.default)(MapsPlace);
MapsPlace.displayName = 'MapsPlace';
MapsPlace.muiName = 'SvgIcon';

exports.default = MapsPlace;

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsRateReview = function MapsRateReview(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z' })
  );
};
MapsRateReview = (0, _pure2.default)(MapsRateReview);
MapsRateReview.displayName = 'MapsRateReview';
MapsRateReview.muiName = 'SvgIcon';

exports.default = MapsRateReview;

/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsRestaurantMenu = function MapsRestaurantMenu(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
  );
};
MapsRestaurantMenu = (0, _pure2.default)(MapsRestaurantMenu);
MapsRestaurantMenu.displayName = 'MapsRestaurantMenu';
MapsRestaurantMenu.muiName = 'SvgIcon';

exports.default = MapsRestaurantMenu;

/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsRestaurant = function MapsRestaurant(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z' })
  );
};
MapsRestaurant = (0, _pure2.default)(MapsRestaurant);
MapsRestaurant.displayName = 'MapsRestaurant';
MapsRestaurant.muiName = 'SvgIcon';

exports.default = MapsRestaurant;

/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsSatellite = function MapsSatellite(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z' })
  );
};
MapsSatellite = (0, _pure2.default)(MapsSatellite);
MapsSatellite.displayName = 'MapsSatellite';
MapsSatellite.muiName = 'SvgIcon';

exports.default = MapsSatellite;

/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsStoreMallDirectory = function MapsStoreMallDirectory(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
  );
};
MapsStoreMallDirectory = (0, _pure2.default)(MapsStoreMallDirectory);
MapsStoreMallDirectory.displayName = 'MapsStoreMallDirectory';
MapsStoreMallDirectory.muiName = 'SvgIcon';

exports.default = MapsStoreMallDirectory;

/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsStreetview = function MapsStreetview(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z' }),
    _react2.default.createElement('circle', { cx: '18', cy: '6', r: '5' }),
    _react2.default.createElement('path', { d: 'M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z' })
  );
};
MapsStreetview = (0, _pure2.default)(MapsStreetview);
MapsStreetview.displayName = 'MapsStreetview';
MapsStreetview.muiName = 'SvgIcon';

exports.default = MapsStreetview;

/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsSubway = function MapsSubway(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '15.5', cy: '16', r: '1' }),
    _react2.default.createElement('circle', { cx: '8.5', cy: '16', r: '1' }),
    _react2.default.createElement('path', { d: 'M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z' })
  );
};
MapsSubway = (0, _pure2.default)(MapsSubway);
MapsSubway.displayName = 'MapsSubway';
MapsSubway.muiName = 'SvgIcon';

exports.default = MapsSubway;

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsTerrain = function MapsTerrain(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
  );
};
MapsTerrain = (0, _pure2.default)(MapsTerrain);
MapsTerrain.displayName = 'MapsTerrain';
MapsTerrain.muiName = 'SvgIcon';

exports.default = MapsTerrain;

/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsTraffic = function MapsTraffic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z' })
  );
};
MapsTraffic = (0, _pure2.default)(MapsTraffic);
MapsTraffic.displayName = 'MapsTraffic';
MapsTraffic.muiName = 'SvgIcon';

exports.default = MapsTraffic;

/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsTrain = function MapsTrain(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
MapsTrain = (0, _pure2.default)(MapsTrain);
MapsTrain.displayName = 'MapsTrain';
MapsTrain.muiName = 'SvgIcon';

exports.default = MapsTrain;

/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsTram = function MapsTram(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z' })
  );
};
MapsTram = (0, _pure2.default)(MapsTram);
MapsTram.displayName = 'MapsTram';
MapsTram.muiName = 'SvgIcon';

exports.default = MapsTram;

/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsTransferWithinAStation = function MapsTransferWithinAStation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75' })
  );
};
MapsTransferWithinAStation = (0, _pure2.default)(MapsTransferWithinAStation);
MapsTransferWithinAStation.displayName = 'MapsTransferWithinAStation';
MapsTransferWithinAStation.muiName = 'SvgIcon';

exports.default = MapsTransferWithinAStation;

/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsZoomOutMap = function MapsZoomOutMap(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z' })
  );
};
MapsZoomOutMap = (0, _pure2.default)(MapsZoomOutMap);
MapsZoomOutMap.displayName = 'MapsZoomOutMap';
MapsZoomOutMap.muiName = 'SvgIcon';

exports.default = MapsZoomOutMap;

/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationApps = function NavigationApps(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z' })
  );
};
NavigationApps = (0, _pure2.default)(NavigationApps);
NavigationApps.displayName = 'NavigationApps';
NavigationApps.muiName = 'SvgIcon';

exports.default = NavigationApps;

/***/ }),
/* 3137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDownward = function NavigationArrowDownward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' })
  );
};
NavigationArrowDownward = (0, _pure2.default)(NavigationArrowDownward);
NavigationArrowDownward.displayName = 'NavigationArrowDownward';
NavigationArrowDownward.muiName = 'SvgIcon';

exports.default = NavigationArrowDownward;

/***/ }),
/* 3138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropDownCircle = function NavigationArrowDropDownCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z' })
  );
};
NavigationArrowDropDownCircle = (0, _pure2.default)(NavigationArrowDropDownCircle);
NavigationArrowDropDownCircle.displayName = 'NavigationArrowDropDownCircle';
NavigationArrowDropDownCircle.muiName = 'SvgIcon';

exports.default = NavigationArrowDropDownCircle;

/***/ }),
/* 3139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropUp = function NavigationArrowDropUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' })
  );
};
NavigationArrowDropUp = (0, _pure2.default)(NavigationArrowDropUp);
NavigationArrowDropUp.displayName = 'NavigationArrowDropUp';
NavigationArrowDropUp.muiName = 'SvgIcon';

exports.default = NavigationArrowDropUp;

/***/ }),
/* 3140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationFirstPage = function NavigationFirstPage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z' })
  );
};
NavigationFirstPage = (0, _pure2.default)(NavigationFirstPage);
NavigationFirstPage.displayName = 'NavigationFirstPage';
NavigationFirstPage.muiName = 'SvgIcon';

exports.default = NavigationFirstPage;

/***/ }),
/* 3141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationFullscreenExit = function NavigationFullscreenExit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z' })
  );
};
NavigationFullscreenExit = (0, _pure2.default)(NavigationFullscreenExit);
NavigationFullscreenExit.displayName = 'NavigationFullscreenExit';
NavigationFullscreenExit.muiName = 'SvgIcon';

exports.default = NavigationFullscreenExit;

/***/ }),
/* 3142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationFullscreen = function NavigationFullscreen(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' })
  );
};
NavigationFullscreen = (0, _pure2.default)(NavigationFullscreen);
NavigationFullscreen.displayName = 'NavigationFullscreen';
NavigationFullscreen.muiName = 'SvgIcon';

exports.default = NavigationFullscreen;

/***/ }),
/* 3143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationLastPage = function NavigationLastPage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z' })
  );
};
NavigationLastPage = (0, _pure2.default)(NavigationLastPage);
NavigationLastPage.displayName = 'NavigationLastPage';
NavigationLastPage.muiName = 'SvgIcon';

exports.default = NavigationLastPage;

/***/ }),
/* 3144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationMoreHoriz = function NavigationMoreHoriz(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
  );
};
NavigationMoreHoriz = (0, _pure2.default)(NavigationMoreHoriz);
NavigationMoreHoriz.displayName = 'NavigationMoreHoriz';
NavigationMoreHoriz.muiName = 'SvgIcon';

exports.default = NavigationMoreHoriz;

/***/ }),
/* 3145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationRefresh = function NavigationRefresh(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' })
  );
};
NavigationRefresh = (0, _pure2.default)(NavigationRefresh);
NavigationRefresh.displayName = 'NavigationRefresh';
NavigationRefresh.muiName = 'SvgIcon';

exports.default = NavigationRefresh;

/***/ }),
/* 3146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationSubdirectoryArrowLeft = function NavigationSubdirectoryArrowLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z' })
  );
};
NavigationSubdirectoryArrowLeft = (0, _pure2.default)(NavigationSubdirectoryArrowLeft);
NavigationSubdirectoryArrowLeft.displayName = 'NavigationSubdirectoryArrowLeft';
NavigationSubdirectoryArrowLeft.muiName = 'SvgIcon';

exports.default = NavigationSubdirectoryArrowLeft;

/***/ }),
/* 3147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationSubdirectoryArrowRight = function NavigationSubdirectoryArrowRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z' })
  );
};
NavigationSubdirectoryArrowRight = (0, _pure2.default)(NavigationSubdirectoryArrowRight);
NavigationSubdirectoryArrowRight.displayName = 'NavigationSubdirectoryArrowRight';
NavigationSubdirectoryArrowRight.muiName = 'SvgIcon';

exports.default = NavigationSubdirectoryArrowRight;

/***/ }),
/* 3148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationUnfoldLess = function NavigationUnfoldLess(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z' })
  );
};
NavigationUnfoldLess = (0, _pure2.default)(NavigationUnfoldLess);
NavigationUnfoldLess.displayName = 'NavigationUnfoldLess';
NavigationUnfoldLess.muiName = 'SvgIcon';

exports.default = NavigationUnfoldLess;

/***/ }),
/* 3149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationUnfoldMore = function NavigationUnfoldMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z' })
  );
};
NavigationUnfoldMore = (0, _pure2.default)(NavigationUnfoldMore);
NavigationUnfoldMore.displayName = 'NavigationUnfoldMore';
NavigationUnfoldMore.muiName = 'SvgIcon';

exports.default = NavigationUnfoldMore;

/***/ }),
/* 3150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropRight = function NavigationArrowDropRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.5,7l5,5l-5,5V7z' })
  );
};

NavigationArrowDropRight = (0, _pure2.default)(NavigationArrowDropRight);
NavigationArrowDropRight.displayName = 'NavigationArrowDropRight';
NavigationArrowDropRight.muiName = 'SvgIcon';

exports.default = NavigationArrowDropRight;

/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAdb = function NotificationAdb(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
  );
};
NotificationAdb = (0, _pure2.default)(NotificationAdb);
NotificationAdb.displayName = 'NotificationAdb';
NotificationAdb.muiName = 'SvgIcon';

exports.default = NotificationAdb;

/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatFlatAngled = function NotificationAirlineSeatFlatAngled(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z' })
  );
};
NotificationAirlineSeatFlatAngled = (0, _pure2.default)(NotificationAirlineSeatFlatAngled);
NotificationAirlineSeatFlatAngled.displayName = 'NotificationAirlineSeatFlatAngled';
NotificationAirlineSeatFlatAngled.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatFlatAngled;

/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatFlat = function NotificationAirlineSeatFlat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z' })
  );
};
NotificationAirlineSeatFlat = (0, _pure2.default)(NotificationAirlineSeatFlat);
NotificationAirlineSeatFlat.displayName = 'NotificationAirlineSeatFlat';
NotificationAirlineSeatFlat.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatFlat;

/***/ }),
/* 3154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatIndividualSuite = function NotificationAirlineSeatIndividualSuite(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z' })
  );
};
NotificationAirlineSeatIndividualSuite = (0, _pure2.default)(NotificationAirlineSeatIndividualSuite);
NotificationAirlineSeatIndividualSuite.displayName = 'NotificationAirlineSeatIndividualSuite';
NotificationAirlineSeatIndividualSuite.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatIndividualSuite;

/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatLegroomExtra = function NotificationAirlineSeatLegroomExtra(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z' })
  );
};
NotificationAirlineSeatLegroomExtra = (0, _pure2.default)(NotificationAirlineSeatLegroomExtra);
NotificationAirlineSeatLegroomExtra.displayName = 'NotificationAirlineSeatLegroomExtra';
NotificationAirlineSeatLegroomExtra.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatLegroomExtra;

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatLegroomNormal = function NotificationAirlineSeatLegroomNormal(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z' })
  );
};
NotificationAirlineSeatLegroomNormal = (0, _pure2.default)(NotificationAirlineSeatLegroomNormal);
NotificationAirlineSeatLegroomNormal.displayName = 'NotificationAirlineSeatLegroomNormal';
NotificationAirlineSeatLegroomNormal.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatLegroomNormal;

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatLegroomReduced = function NotificationAirlineSeatLegroomReduced(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z' })
  );
};
NotificationAirlineSeatLegroomReduced = (0, _pure2.default)(NotificationAirlineSeatLegroomReduced);
NotificationAirlineSeatLegroomReduced.displayName = 'NotificationAirlineSeatLegroomReduced';
NotificationAirlineSeatLegroomReduced.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatLegroomReduced;

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatReclineExtra = function NotificationAirlineSeatReclineExtra(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z' })
  );
};
NotificationAirlineSeatReclineExtra = (0, _pure2.default)(NotificationAirlineSeatReclineExtra);
NotificationAirlineSeatReclineExtra.displayName = 'NotificationAirlineSeatReclineExtra';
NotificationAirlineSeatReclineExtra.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatReclineExtra;

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationAirlineSeatReclineNormal = function NotificationAirlineSeatReclineNormal(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z' })
  );
};
NotificationAirlineSeatReclineNormal = (0, _pure2.default)(NotificationAirlineSeatReclineNormal);
NotificationAirlineSeatReclineNormal.displayName = 'NotificationAirlineSeatReclineNormal';
NotificationAirlineSeatReclineNormal.muiName = 'SvgIcon';

exports.default = NotificationAirlineSeatReclineNormal;

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationBluetoothAudio = function NotificationBluetoothAudio(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
  );
};
NotificationBluetoothAudio = (0, _pure2.default)(NotificationBluetoothAudio);
NotificationBluetoothAudio.displayName = 'NotificationBluetoothAudio';
NotificationBluetoothAudio.muiName = 'SvgIcon';

exports.default = NotificationBluetoothAudio;

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationConfirmationNumber = function NotificationConfirmationNumber(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z' })
  );
};
NotificationConfirmationNumber = (0, _pure2.default)(NotificationConfirmationNumber);
NotificationConfirmationNumber.displayName = 'NotificationConfirmationNumber';
NotificationConfirmationNumber.muiName = 'SvgIcon';

exports.default = NotificationConfirmationNumber;

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationDiscFull = function NotificationDiscFull(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
  );
};
NotificationDiscFull = (0, _pure2.default)(NotificationDiscFull);
NotificationDiscFull.displayName = 'NotificationDiscFull';
NotificationDiscFull.muiName = 'SvgIcon';

exports.default = NotificationDiscFull;

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationDoNotDisturbAlt = function NotificationDoNotDisturbAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z' })
  );
};
NotificationDoNotDisturbAlt = (0, _pure2.default)(NotificationDoNotDisturbAlt);
NotificationDoNotDisturbAlt.displayName = 'NotificationDoNotDisturbAlt';
NotificationDoNotDisturbAlt.muiName = 'SvgIcon';

exports.default = NotificationDoNotDisturbAlt;

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationDoNotDisturbOff = function NotificationDoNotDisturbOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z' })
  );
};
NotificationDoNotDisturbOff = (0, _pure2.default)(NotificationDoNotDisturbOff);
NotificationDoNotDisturbOff.displayName = 'NotificationDoNotDisturbOff';
NotificationDoNotDisturbOff.muiName = 'SvgIcon';

exports.default = NotificationDoNotDisturbOff;

/***/ }),
/* 3165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationDoNotDisturbOn = function NotificationDoNotDisturbOn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
  );
};
NotificationDoNotDisturbOn = (0, _pure2.default)(NotificationDoNotDisturbOn);
NotificationDoNotDisturbOn.displayName = 'NotificationDoNotDisturbOn';
NotificationDoNotDisturbOn.muiName = 'SvgIcon';

exports.default = NotificationDoNotDisturbOn;

/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationDoNotDisturb = function NotificationDoNotDisturb(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
  );
};
NotificationDoNotDisturb = (0, _pure2.default)(NotificationDoNotDisturb);
NotificationDoNotDisturb.displayName = 'NotificationDoNotDisturb';
NotificationDoNotDisturb.muiName = 'SvgIcon';

exports.default = NotificationDoNotDisturb;

/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationDriveEta = function NotificationDriveEta(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
  );
};
NotificationDriveEta = (0, _pure2.default)(NotificationDriveEta);
NotificationDriveEta.displayName = 'NotificationDriveEta';
NotificationDriveEta.muiName = 'SvgIcon';

exports.default = NotificationDriveEta;

/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationEnhancedEncryption = function NotificationEnhancedEncryption(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z' })
  );
};
NotificationEnhancedEncryption = (0, _pure2.default)(NotificationEnhancedEncryption);
NotificationEnhancedEncryption.displayName = 'NotificationEnhancedEncryption';
NotificationEnhancedEncryption.muiName = 'SvgIcon';

exports.default = NotificationEnhancedEncryption;

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationEventAvailable = function NotificationEventAvailable(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
  );
};
NotificationEventAvailable = (0, _pure2.default)(NotificationEventAvailable);
NotificationEventAvailable.displayName = 'NotificationEventAvailable';
NotificationEventAvailable.muiName = 'SvgIcon';

exports.default = NotificationEventAvailable;

/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationEventBusy = function NotificationEventBusy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
  );
};
NotificationEventBusy = (0, _pure2.default)(NotificationEventBusy);
NotificationEventBusy.displayName = 'NotificationEventBusy';
NotificationEventBusy.muiName = 'SvgIcon';

exports.default = NotificationEventBusy;

/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationEventNote = function NotificationEventNote(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z' })
  );
};
NotificationEventNote = (0, _pure2.default)(NotificationEventNote);
NotificationEventNote.displayName = 'NotificationEventNote';
NotificationEventNote.muiName = 'SvgIcon';

exports.default = NotificationEventNote;

/***/ }),
/* 3172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationFolderSpecial = function NotificationFolderSpecial(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z' })
  );
};
NotificationFolderSpecial = (0, _pure2.default)(NotificationFolderSpecial);
NotificationFolderSpecial.displayName = 'NotificationFolderSpecial';
NotificationFolderSpecial.muiName = 'SvgIcon';

exports.default = NotificationFolderSpecial;

/***/ }),
/* 3173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationLiveTv = function NotificationLiveTv(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z' })
  );
};
NotificationLiveTv = (0, _pure2.default)(NotificationLiveTv);
NotificationLiveTv.displayName = 'NotificationLiveTv';
NotificationLiveTv.muiName = 'SvgIcon';

exports.default = NotificationLiveTv;

/***/ }),
/* 3174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationMms = function NotificationMms(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z' })
  );
};
NotificationMms = (0, _pure2.default)(NotificationMms);
NotificationMms.displayName = 'NotificationMms';
NotificationMms.muiName = 'SvgIcon';

exports.default = NotificationMms;

/***/ }),
/* 3175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationMore = function NotificationMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
  );
};
NotificationMore = (0, _pure2.default)(NotificationMore);
NotificationMore.displayName = 'NotificationMore';
NotificationMore.muiName = 'SvgIcon';

exports.default = NotificationMore;

/***/ }),
/* 3176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationNetworkCheck = function NotificationNetworkCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z' })
  );
};
NotificationNetworkCheck = (0, _pure2.default)(NotificationNetworkCheck);
NotificationNetworkCheck.displayName = 'NotificationNetworkCheck';
NotificationNetworkCheck.muiName = 'SvgIcon';

exports.default = NotificationNetworkCheck;

/***/ }),
/* 3177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationNetworkLocked = function NotificationNetworkLocked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
  );
};
NotificationNetworkLocked = (0, _pure2.default)(NotificationNetworkLocked);
NotificationNetworkLocked.displayName = 'NotificationNetworkLocked';
NotificationNetworkLocked.muiName = 'SvgIcon';

exports.default = NotificationNetworkLocked;

/***/ }),
/* 3178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationNoEncryption = function NotificationNoEncryption(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z' })
  );
};
NotificationNoEncryption = (0, _pure2.default)(NotificationNoEncryption);
NotificationNoEncryption.displayName = 'NotificationNoEncryption';
NotificationNoEncryption.muiName = 'SvgIcon';

exports.default = NotificationNoEncryption;

/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationOndemandVideo = function NotificationOndemandVideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z' })
  );
};
NotificationOndemandVideo = (0, _pure2.default)(NotificationOndemandVideo);
NotificationOndemandVideo.displayName = 'NotificationOndemandVideo';
NotificationOndemandVideo.muiName = 'SvgIcon';

exports.default = NotificationOndemandVideo;

/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPersonalVideo = function NotificationPersonalVideo(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z' })
  );
};
NotificationPersonalVideo = (0, _pure2.default)(NotificationPersonalVideo);
NotificationPersonalVideo.displayName = 'NotificationPersonalVideo';
NotificationPersonalVideo.muiName = 'SvgIcon';

exports.default = NotificationPersonalVideo;

/***/ }),
/* 3181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPhoneBluetoothSpeaker = function NotificationPhoneBluetoothSpeaker(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
  );
};
NotificationPhoneBluetoothSpeaker = (0, _pure2.default)(NotificationPhoneBluetoothSpeaker);
NotificationPhoneBluetoothSpeaker.displayName = 'NotificationPhoneBluetoothSpeaker';
NotificationPhoneBluetoothSpeaker.muiName = 'SvgIcon';

exports.default = NotificationPhoneBluetoothSpeaker;

/***/ }),
/* 3182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPhoneForwarded = function NotificationPhoneForwarded(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
  );
};
NotificationPhoneForwarded = (0, _pure2.default)(NotificationPhoneForwarded);
NotificationPhoneForwarded.displayName = 'NotificationPhoneForwarded';
NotificationPhoneForwarded.muiName = 'SvgIcon';

exports.default = NotificationPhoneForwarded;

/***/ }),
/* 3183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPhoneInTalk = function NotificationPhoneInTalk(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z' })
  );
};
NotificationPhoneInTalk = (0, _pure2.default)(NotificationPhoneInTalk);
NotificationPhoneInTalk.displayName = 'NotificationPhoneInTalk';
NotificationPhoneInTalk.muiName = 'SvgIcon';

exports.default = NotificationPhoneInTalk;

/***/ }),
/* 3184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPhoneLocked = function NotificationPhoneLocked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z' })
  );
};
NotificationPhoneLocked = (0, _pure2.default)(NotificationPhoneLocked);
NotificationPhoneLocked.displayName = 'NotificationPhoneLocked';
NotificationPhoneLocked.muiName = 'SvgIcon';

exports.default = NotificationPhoneLocked;

/***/ }),
/* 3185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPhoneMissed = function NotificationPhoneMissed(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z' })
  );
};
NotificationPhoneMissed = (0, _pure2.default)(NotificationPhoneMissed);
NotificationPhoneMissed.displayName = 'NotificationPhoneMissed';
NotificationPhoneMissed.muiName = 'SvgIcon';

exports.default = NotificationPhoneMissed;

/***/ }),
/* 3186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPhonePaused = function NotificationPhonePaused(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z' })
  );
};
NotificationPhonePaused = (0, _pure2.default)(NotificationPhonePaused);
NotificationPhonePaused.displayName = 'NotificationPhonePaused';
NotificationPhonePaused.muiName = 'SvgIcon';

exports.default = NotificationPhonePaused;

/***/ }),
/* 3187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPower = function NotificationPower(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z' })
  );
};
NotificationPower = (0, _pure2.default)(NotificationPower);
NotificationPower.displayName = 'NotificationPower';
NotificationPower.muiName = 'SvgIcon';

exports.default = NotificationPower;

/***/ }),
/* 3188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPriorityHigh = function NotificationPriorityHigh(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '12', cy: '19', r: '2' }),
    _react2.default.createElement('path', { d: 'M10 3h4v12h-4z' })
  );
};
NotificationPriorityHigh = (0, _pure2.default)(NotificationPriorityHigh);
NotificationPriorityHigh.displayName = 'NotificationPriorityHigh';
NotificationPriorityHigh.muiName = 'SvgIcon';

exports.default = NotificationPriorityHigh;

/***/ }),
/* 3189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationRvHookup = function NotificationRvHookup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
  );
};
NotificationRvHookup = (0, _pure2.default)(NotificationRvHookup);
NotificationRvHookup.displayName = 'NotificationRvHookup';
NotificationRvHookup.muiName = 'SvgIcon';

exports.default = NotificationRvHookup;

/***/ }),
/* 3190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSdCard = function NotificationSdCard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
  );
};
NotificationSdCard = (0, _pure2.default)(NotificationSdCard);
NotificationSdCard.displayName = 'NotificationSdCard';
NotificationSdCard.muiName = 'SvgIcon';

exports.default = NotificationSdCard;

/***/ }),
/* 3191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSimCardAlert = function NotificationSimCardAlert(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z' })
  );
};
NotificationSimCardAlert = (0, _pure2.default)(NotificationSimCardAlert);
NotificationSimCardAlert.displayName = 'NotificationSimCardAlert';
NotificationSimCardAlert.muiName = 'SvgIcon';

exports.default = NotificationSimCardAlert;

/***/ }),
/* 3192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSmsFailed = function NotificationSmsFailed(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
  );
};
NotificationSmsFailed = (0, _pure2.default)(NotificationSmsFailed);
NotificationSmsFailed.displayName = 'NotificationSmsFailed';
NotificationSmsFailed.muiName = 'SvgIcon';

exports.default = NotificationSmsFailed;

/***/ }),
/* 3193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSms = function NotificationSms(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
  );
};
NotificationSms = (0, _pure2.default)(NotificationSms);
NotificationSms.displayName = 'NotificationSms';
NotificationSms.muiName = 'SvgIcon';

exports.default = NotificationSms;

/***/ }),
/* 3194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSyncDisabled = function NotificationSyncDisabled(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z' })
  );
};
NotificationSyncDisabled = (0, _pure2.default)(NotificationSyncDisabled);
NotificationSyncDisabled.displayName = 'NotificationSyncDisabled';
NotificationSyncDisabled.muiName = 'SvgIcon';

exports.default = NotificationSyncDisabled;

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSyncProblem = function NotificationSyncProblem(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z' })
  );
};
NotificationSyncProblem = (0, _pure2.default)(NotificationSyncProblem);
NotificationSyncProblem.displayName = 'NotificationSyncProblem';
NotificationSyncProblem.muiName = 'SvgIcon';

exports.default = NotificationSyncProblem;

/***/ }),
/* 3196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSync = function NotificationSync(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
  );
};
NotificationSync = (0, _pure2.default)(NotificationSync);
NotificationSync.displayName = 'NotificationSync';
NotificationSync.muiName = 'SvgIcon';

exports.default = NotificationSync;

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSystemUpdate = function NotificationSystemUpdate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z' })
  );
};
NotificationSystemUpdate = (0, _pure2.default)(NotificationSystemUpdate);
NotificationSystemUpdate.displayName = 'NotificationSystemUpdate';
NotificationSystemUpdate.muiName = 'SvgIcon';

exports.default = NotificationSystemUpdate;

/***/ }),
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationTapAndPlay = function NotificationTapAndPlay(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z' })
  );
};
NotificationTapAndPlay = (0, _pure2.default)(NotificationTapAndPlay);
NotificationTapAndPlay.displayName = 'NotificationTapAndPlay';
NotificationTapAndPlay.muiName = 'SvgIcon';

exports.default = NotificationTapAndPlay;

/***/ }),
/* 3199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationTimeToLeave = function NotificationTimeToLeave(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
  );
};
NotificationTimeToLeave = (0, _pure2.default)(NotificationTimeToLeave);
NotificationTimeToLeave.displayName = 'NotificationTimeToLeave';
NotificationTimeToLeave.muiName = 'SvgIcon';

exports.default = NotificationTimeToLeave;

/***/ }),
/* 3200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationVibration = function NotificationVibration(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z' })
  );
};
NotificationVibration = (0, _pure2.default)(NotificationVibration);
NotificationVibration.displayName = 'NotificationVibration';
NotificationVibration.muiName = 'SvgIcon';

exports.default = NotificationVibration;

/***/ }),
/* 3201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationVoiceChat = function NotificationVoiceChat(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z' })
  );
};
NotificationVoiceChat = (0, _pure2.default)(NotificationVoiceChat);
NotificationVoiceChat.displayName = 'NotificationVoiceChat';
NotificationVoiceChat.muiName = 'SvgIcon';

exports.default = NotificationVoiceChat;

/***/ }),
/* 3202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationVpnLock = function NotificationVpnLock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z' })
  );
};
NotificationVpnLock = (0, _pure2.default)(NotificationVpnLock);
NotificationVpnLock.displayName = 'NotificationVpnLock';
NotificationVpnLock.muiName = 'SvgIcon';

exports.default = NotificationVpnLock;

/***/ }),
/* 3203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationWc = function NotificationWc(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z' })
  );
};
NotificationWc = (0, _pure2.default)(NotificationWc);
NotificationWc.displayName = 'NotificationWc';
NotificationWc.muiName = 'SvgIcon';

exports.default = NotificationWc;

/***/ }),
/* 3204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationWifi = function NotificationWifi(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z' })
  );
};
NotificationWifi = (0, _pure2.default)(NotificationWifi);
NotificationWifi.displayName = 'NotificationWifi';
NotificationWifi.muiName = 'SvgIcon';

exports.default = NotificationWifi;

/***/ }),
/* 3205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesAcUnit = function PlacesAcUnit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z' })
  );
};
PlacesAcUnit = (0, _pure2.default)(PlacesAcUnit);
PlacesAcUnit.displayName = 'PlacesAcUnit';
PlacesAcUnit.muiName = 'SvgIcon';

exports.default = PlacesAcUnit;

/***/ }),
/* 3206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesAirportShuttle = function PlacesAirportShuttle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z' })
  );
};
PlacesAirportShuttle = (0, _pure2.default)(PlacesAirportShuttle);
PlacesAirportShuttle.displayName = 'PlacesAirportShuttle';
PlacesAirportShuttle.muiName = 'SvgIcon';

exports.default = PlacesAirportShuttle;

/***/ }),
/* 3207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesAllInclusive = function PlacesAllInclusive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z' })
  );
};
PlacesAllInclusive = (0, _pure2.default)(PlacesAllInclusive);
PlacesAllInclusive.displayName = 'PlacesAllInclusive';
PlacesAllInclusive.muiName = 'SvgIcon';

exports.default = PlacesAllInclusive;

/***/ }),
/* 3208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesBeachAccess = function PlacesBeachAccess(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z' })
  );
};
PlacesBeachAccess = (0, _pure2.default)(PlacesBeachAccess);
PlacesBeachAccess.displayName = 'PlacesBeachAccess';
PlacesBeachAccess.muiName = 'SvgIcon';

exports.default = PlacesBeachAccess;

/***/ }),
/* 3209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesBusinessCenter = function PlacesBusinessCenter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z' })
  );
};
PlacesBusinessCenter = (0, _pure2.default)(PlacesBusinessCenter);
PlacesBusinessCenter.displayName = 'PlacesBusinessCenter';
PlacesBusinessCenter.muiName = 'SvgIcon';

exports.default = PlacesBusinessCenter;

/***/ }),
/* 3210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesCasino = function PlacesCasino(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z' })
  );
};
PlacesCasino = (0, _pure2.default)(PlacesCasino);
PlacesCasino.displayName = 'PlacesCasino';
PlacesCasino.muiName = 'SvgIcon';

exports.default = PlacesCasino;

/***/ }),
/* 3211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesChildCare = function PlacesChildCare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '14.5', cy: '10.5', r: '1.25' }),
    _react2.default.createElement('circle', { cx: '9.5', cy: '10.5', r: '1.25' }),
    _react2.default.createElement('path', { d: 'M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z' })
  );
};
PlacesChildCare = (0, _pure2.default)(PlacesChildCare);
PlacesChildCare.displayName = 'PlacesChildCare';
PlacesChildCare.muiName = 'SvgIcon';

exports.default = PlacesChildCare;

/***/ }),
/* 3212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesChildFriendly = function PlacesChildFriendly(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z' })
  );
};
PlacesChildFriendly = (0, _pure2.default)(PlacesChildFriendly);
PlacesChildFriendly.displayName = 'PlacesChildFriendly';
PlacesChildFriendly.muiName = 'SvgIcon';

exports.default = PlacesChildFriendly;

/***/ }),
/* 3213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesFitnessCenter = function PlacesFitnessCenter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z' })
  );
};
PlacesFitnessCenter = (0, _pure2.default)(PlacesFitnessCenter);
PlacesFitnessCenter.displayName = 'PlacesFitnessCenter';
PlacesFitnessCenter.muiName = 'SvgIcon';

exports.default = PlacesFitnessCenter;

/***/ }),
/* 3214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesFreeBreakfast = function PlacesFreeBreakfast(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z' })
  );
};
PlacesFreeBreakfast = (0, _pure2.default)(PlacesFreeBreakfast);
PlacesFreeBreakfast.displayName = 'PlacesFreeBreakfast';
PlacesFreeBreakfast.muiName = 'SvgIcon';

exports.default = PlacesFreeBreakfast;

/***/ }),
/* 3215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesGolfCourse = function PlacesGolfCourse(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '19.5', cy: '19.5', r: '1.5' }),
    _react2.default.createElement('path', { d: 'M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z' })
  );
};
PlacesGolfCourse = (0, _pure2.default)(PlacesGolfCourse);
PlacesGolfCourse.displayName = 'PlacesGolfCourse';
PlacesGolfCourse.muiName = 'SvgIcon';

exports.default = PlacesGolfCourse;

/***/ }),
/* 3216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesHotTub = function PlacesHotTub(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '7', cy: '6', r: '2' }),
    _react2.default.createElement('path', { d: 'M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z' })
  );
};
PlacesHotTub = (0, _pure2.default)(PlacesHotTub);
PlacesHotTub.displayName = 'PlacesHotTub';
PlacesHotTub.muiName = 'SvgIcon';

exports.default = PlacesHotTub;

/***/ }),
/* 3217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesKitchen = function PlacesKitchen(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z' })
  );
};
PlacesKitchen = (0, _pure2.default)(PlacesKitchen);
PlacesKitchen.displayName = 'PlacesKitchen';
PlacesKitchen.muiName = 'SvgIcon';

exports.default = PlacesKitchen;

/***/ }),
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesPool = function PlacesPool(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z' }),
    _react2.default.createElement('circle', { cx: '16.5', cy: '5.5', r: '2.5' })
  );
};
PlacesPool = (0, _pure2.default)(PlacesPool);
PlacesPool.displayName = 'PlacesPool';
PlacesPool.muiName = 'SvgIcon';

exports.default = PlacesPool;

/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesRoomService = function PlacesRoomService(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z' })
  );
};
PlacesRoomService = (0, _pure2.default)(PlacesRoomService);
PlacesRoomService.displayName = 'PlacesRoomService';
PlacesRoomService.muiName = 'SvgIcon';

exports.default = PlacesRoomService;

/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesRvHookup = function PlacesRvHookup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
  );
};
PlacesRvHookup = (0, _pure2.default)(PlacesRvHookup);
PlacesRvHookup.displayName = 'PlacesRvHookup';
PlacesRvHookup.muiName = 'SvgIcon';

exports.default = PlacesRvHookup;

/***/ }),
/* 3221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesSmokeFree = function PlacesSmokeFree(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z' })
  );
};
PlacesSmokeFree = (0, _pure2.default)(PlacesSmokeFree);
PlacesSmokeFree.displayName = 'PlacesSmokeFree';
PlacesSmokeFree.muiName = 'SvgIcon';

exports.default = PlacesSmokeFree;

/***/ }),
/* 3222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesSmokingRooms = function PlacesSmokingRooms(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z' })
  );
};
PlacesSmokingRooms = (0, _pure2.default)(PlacesSmokingRooms);
PlacesSmokingRooms.displayName = 'PlacesSmokingRooms';
PlacesSmokingRooms.muiName = 'SvgIcon';

exports.default = PlacesSmokingRooms;

/***/ }),
/* 3223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesSpa = function PlacesSpa(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z' }),
    _react2.default.createElement('path', { d: 'M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z' })
  );
};
PlacesSpa = (0, _pure2.default)(PlacesSpa);
PlacesSpa.displayName = 'PlacesSpa';
PlacesSpa.muiName = 'SvgIcon';

exports.default = PlacesSpa;

/***/ }),
/* 3224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialCake = function SocialCake(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z' })
  );
};
SocialCake = (0, _pure2.default)(SocialCake);
SocialCake.displayName = 'SocialCake';
SocialCake.muiName = 'SvgIcon';

exports.default = SocialCake;

/***/ }),
/* 3225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialDomain = function SocialDomain(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
  );
};
SocialDomain = (0, _pure2.default)(SocialDomain);
SocialDomain.displayName = 'SocialDomain';
SocialDomain.muiName = 'SvgIcon';

exports.default = SocialDomain;

/***/ }),
/* 3226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialGroupAdd = function SocialGroupAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z' })
  );
};
SocialGroupAdd = (0, _pure2.default)(SocialGroupAdd);
SocialGroupAdd.displayName = 'SocialGroupAdd';
SocialGroupAdd.muiName = 'SvgIcon';

exports.default = SocialGroupAdd;

/***/ }),
/* 3227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialGroup = function SocialGroup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
  );
};
SocialGroup = (0, _pure2.default)(SocialGroup);
SocialGroup.displayName = 'SocialGroup';
SocialGroup.muiName = 'SvgIcon';

exports.default = SocialGroup;

/***/ }),
/* 3228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLocationCity = function SocialLocationCity(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z' })
  );
};
SocialLocationCity = (0, _pure2.default)(SocialLocationCity);
SocialLocationCity.displayName = 'SocialLocationCity';
SocialLocationCity.muiName = 'SvgIcon';

exports.default = SocialLocationCity;

/***/ }),
/* 3229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMoodBad = function SocialMoodBad(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
  );
};
SocialMoodBad = (0, _pure2.default)(SocialMoodBad);
SocialMoodBad.displayName = 'SocialMoodBad';
SocialMoodBad.muiName = 'SvgIcon';

exports.default = SocialMoodBad;

/***/ }),
/* 3230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMood = function SocialMood(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
  );
};
SocialMood = (0, _pure2.default)(SocialMood);
SocialMood.displayName = 'SocialMood';
SocialMood.muiName = 'SvgIcon';

exports.default = SocialMood;

/***/ }),
/* 3231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotificationsActive = function SocialNotificationsActive(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z' })
  );
};
SocialNotificationsActive = (0, _pure2.default)(SocialNotificationsActive);
SocialNotificationsActive.displayName = 'SocialNotificationsActive';
SocialNotificationsActive.muiName = 'SvgIcon';

exports.default = SocialNotificationsActive;

/***/ }),
/* 3232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotificationsNone = function SocialNotificationsNone(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z' })
  );
};
SocialNotificationsNone = (0, _pure2.default)(SocialNotificationsNone);
SocialNotificationsNone.displayName = 'SocialNotificationsNone';
SocialNotificationsNone.muiName = 'SvgIcon';

exports.default = SocialNotificationsNone;

/***/ }),
/* 3233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotificationsOff = function SocialNotificationsOff(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z' })
  );
};
SocialNotificationsOff = (0, _pure2.default)(SocialNotificationsOff);
SocialNotificationsOff.displayName = 'SocialNotificationsOff';
SocialNotificationsOff.muiName = 'SvgIcon';

exports.default = SocialNotificationsOff;

/***/ }),
/* 3234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotificationsPaused = function SocialNotificationsPaused(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z' })
  );
};
SocialNotificationsPaused = (0, _pure2.default)(SocialNotificationsPaused);
SocialNotificationsPaused.displayName = 'SocialNotificationsPaused';
SocialNotificationsPaused.muiName = 'SvgIcon';

exports.default = SocialNotificationsPaused;

/***/ }),
/* 3235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotifications = function SocialNotifications(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' })
  );
};
SocialNotifications = (0, _pure2.default)(SocialNotifications);
SocialNotifications.displayName = 'SocialNotifications';
SocialNotifications.muiName = 'SvgIcon';

exports.default = SocialNotifications;

/***/ }),
/* 3236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPages = function SocialPages(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z' })
  );
};
SocialPages = (0, _pure2.default)(SocialPages);
SocialPages.displayName = 'SocialPages';
SocialPages.muiName = 'SvgIcon';

exports.default = SocialPages;

/***/ }),
/* 3237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPartyMode = function SocialPartyMode(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z' })
  );
};
SocialPartyMode = (0, _pure2.default)(SocialPartyMode);
SocialPartyMode.displayName = 'SocialPartyMode';
SocialPartyMode.muiName = 'SvgIcon';

exports.default = SocialPartyMode;

/***/ }),
/* 3238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPeopleOutline = function SocialPeopleOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z' })
  );
};
SocialPeopleOutline = (0, _pure2.default)(SocialPeopleOutline);
SocialPeopleOutline.displayName = 'SocialPeopleOutline';
SocialPeopleOutline.muiName = 'SvgIcon';

exports.default = SocialPeopleOutline;

/***/ }),
/* 3239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPeople = function SocialPeople(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
  );
};
SocialPeople = (0, _pure2.default)(SocialPeople);
SocialPeople.displayName = 'SocialPeople';
SocialPeople.muiName = 'SvgIcon';

exports.default = SocialPeople;

/***/ }),
/* 3240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPersonAdd = function SocialPersonAdd(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
  );
};
SocialPersonAdd = (0, _pure2.default)(SocialPersonAdd);
SocialPersonAdd.displayName = 'SocialPersonAdd';
SocialPersonAdd.muiName = 'SvgIcon';

exports.default = SocialPersonAdd;

/***/ }),
/* 3241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPersonOutline = function SocialPersonOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
  );
};
SocialPersonOutline = (0, _pure2.default)(SocialPersonOutline);
SocialPersonOutline.displayName = 'SocialPersonOutline';
SocialPersonOutline.muiName = 'SvgIcon';

exports.default = SocialPersonOutline;

/***/ }),
/* 3242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPerson = function SocialPerson(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
  );
};
SocialPerson = (0, _pure2.default)(SocialPerson);
SocialPerson.displayName = 'SocialPerson';
SocialPerson.muiName = 'SvgIcon';

exports.default = SocialPerson;

/***/ }),
/* 3243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPlusOne = function SocialPlusOne(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z' })
  );
};
SocialPlusOne = (0, _pure2.default)(SocialPlusOne);
SocialPlusOne.displayName = 'SocialPlusOne';
SocialPlusOne.muiName = 'SvgIcon';

exports.default = SocialPlusOne;

/***/ }),
/* 3244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPoll = function SocialPoll(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
  );
};
SocialPoll = (0, _pure2.default)(SocialPoll);
SocialPoll.displayName = 'SocialPoll';
SocialPoll.muiName = 'SvgIcon';

exports.default = SocialPoll;

/***/ }),
/* 3245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialPublic = function SocialPublic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
  );
};
SocialPublic = (0, _pure2.default)(SocialPublic);
SocialPublic.displayName = 'SocialPublic';
SocialPublic.muiName = 'SvgIcon';

exports.default = SocialPublic;

/***/ }),
/* 3246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSchool = function SocialSchool(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z' })
  );
};
SocialSchool = (0, _pure2.default)(SocialSchool);
SocialSchool.displayName = 'SocialSchool';
SocialSchool.muiName = 'SvgIcon';

exports.default = SocialSchool;

/***/ }),
/* 3247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSentimentDissatisfied = function SocialSentimentDissatisfied(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' })
  );
};
SocialSentimentDissatisfied = (0, _pure2.default)(SocialSentimentDissatisfied);
SocialSentimentDissatisfied.displayName = 'SocialSentimentDissatisfied';
SocialSentimentDissatisfied.muiName = 'SvgIcon';

exports.default = SocialSentimentDissatisfied;

/***/ }),
/* 3248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSentimentNeutral = function SocialSentimentNeutral(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 14h6v1.5H9z' }),
    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
  );
};
SocialSentimentNeutral = (0, _pure2.default)(SocialSentimentNeutral);
SocialSentimentNeutral.displayName = 'SocialSentimentNeutral';
SocialSentimentNeutral.muiName = 'SvgIcon';

exports.default = SocialSentimentNeutral;

/***/ }),
/* 3249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSentimentSatisfied = function SocialSentimentSatisfied(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z' })
  );
};
SocialSentimentSatisfied = (0, _pure2.default)(SocialSentimentSatisfied);
SocialSentimentSatisfied.displayName = 'SocialSentimentSatisfied';
SocialSentimentSatisfied.muiName = 'SvgIcon';

exports.default = SocialSentimentSatisfied;

/***/ }),
/* 3250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSentimentVeryDissatisfied = function SocialSentimentVeryDissatisfied(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
  );
};
SocialSentimentVeryDissatisfied = (0, _pure2.default)(SocialSentimentVeryDissatisfied);
SocialSentimentVeryDissatisfied.displayName = 'SocialSentimentVeryDissatisfied';
SocialSentimentVeryDissatisfied.muiName = 'SvgIcon';

exports.default = SocialSentimentVeryDissatisfied;

/***/ }),
/* 3251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSentimentVerySatisfied = function SocialSentimentVerySatisfied(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
  );
};
SocialSentimentVerySatisfied = (0, _pure2.default)(SocialSentimentVerySatisfied);
SocialSentimentVerySatisfied.displayName = 'SocialSentimentVerySatisfied';
SocialSentimentVerySatisfied.muiName = 'SvgIcon';

exports.default = SocialSentimentVerySatisfied;

/***/ }),
/* 3252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialShare = function SocialShare(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
  );
};
SocialShare = (0, _pure2.default)(SocialShare);
SocialShare.displayName = 'SocialShare';
SocialShare.muiName = 'SvgIcon';

exports.default = SocialShare;

/***/ }),
/* 3253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialWhatshot = function SocialWhatshot(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z' })
  );
};
SocialWhatshot = (0, _pure2.default)(SocialWhatshot);
SocialWhatshot.displayName = 'SocialWhatshot';
SocialWhatshot.muiName = 'SvgIcon';

exports.default = SocialWhatshot;

/***/ }),
/* 3254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleIndeterminateCheckBox = function ToggleIndeterminateCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' })
  );
};
ToggleIndeterminateCheckBox = (0, _pure2.default)(ToggleIndeterminateCheckBox);
ToggleIndeterminateCheckBox.displayName = 'ToggleIndeterminateCheckBox';
ToggleIndeterminateCheckBox.muiName = 'SvgIcon';

exports.default = ToggleIndeterminateCheckBox;

/***/ }),
/* 3255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(3);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(2);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleStarHalf = function ToggleStarHalf(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
  );
};
ToggleStarHalf = (0, _pure2.default)(ToggleStarHalf);
ToggleStarHalf.displayName = 'ToggleStarHalf';
ToggleStarHalf.muiName = 'SvgIcon';

exports.default = ToggleStarHalf;

/***/ }),
/* 3256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_regions_serviceProvider__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var dialogStyles = {
    contentStyle: { width: '76%', padding: '20px', maxWidth: 'unset' }
};
var statusesList = [{ name: 'All', value: null }, { name: 'Approved', value: ['approved'] }, { name: 'Rejected', value: ['rejected'] }];

var ServiceProvidersHistoryDialog = function (_React$Component) {
    _inherits(ServiceProvidersHistoryDialog, _React$Component);

    function ServiceProvidersHistoryDialog(props) {
        _classCallCheck(this, ServiceProvidersHistoryDialog);

        var _this = _possibleConstructorReturn(this, (ServiceProvidersHistoryDialog.__proto__ || Object.getPrototypeOf(ServiceProvidersHistoryDialog)).call(this, props));

        _initialiseProps.call(_this);

        var pagination = {};
        pagination = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["defaults"])(pagination, {
            page: 1,
            filters: {
                query: '',
                dateFrom: '',
                dateTo: '',
                statuses: null
            },
            limit: 25
        });
        _this.state = {
            rowsPerPage: [25, 50, 100],
            pagination: pagination,
            serviceProvidersHistory: [],
            total: 0
        };
        return _this;
    }

    _createClass(ServiceProvidersHistoryDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateRows();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var open = this.props.open;
            var _state = this.state,
                _state$pagination = _state.pagination,
                _state$pagination$fil = _state$pagination.filters,
                query = _state$pagination$fil.query,
                dateFrom = _state$pagination$fil.dateFrom,
                dateTo = _state$pagination$fil.dateTo,
                statuses = _state$pagination$fil.statuses,
                page = _state$pagination.page,
                limit = _state$pagination.limit,
                rowsPerPage = _state.rowsPerPage,
                serviceProvidersHistory = _state.serviceProvidersHistory,
                total = _state.total;

            var minDate = new Date();
            var maxDate = new Date();

            minDate.setFullYear(minDate.getFullYear() - 1);
            maxDate.setFullYear(maxDate.getFullYear() + 1);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["f" /* Dialog */],
                {
                    open: open,
                    contentStyle: dialogStyles.contentStyle,
                    onRequestClose: this.onRequestClose,
                    paperClassName: 'dialog-service-provider',
                    bodyStyle: { overflowY: 'auto' },
                    modal: true
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'title-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            { className: 'title' },
                            'Service Provider History'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                            { onClick: this.onRequestClose },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_navigation_close___default.a, { color: '#B3B3B3' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'service-providers-history' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'service-providers-history__header' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'service-providers-history__header-item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form_material_ui__["TextField"], {
                                    defaultValue: query,
                                    value: query,
                                    onChange: this.handleChangeSearch,
                                    hintText: 'Search',
                                    ref: 'search',
                                    onKeyPress: function onKeyPress(event) {
                                        if (event.charCode === 13) {
                                            event.preventDefault();
                                            _this2.handleSearch();
                                        }
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'service-providers-history__header-item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                                    label: 'Search',
                                    style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].RaisedButton,
                                    primary: true,
                                    onClick: this.handleSearch
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'service-providers-history__header-item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_11_material_ui_SelectField___default.a,
                                    {
                                        style: { width: '100%' },
                                        fullWidth: true,
                                        autoWidth: true,
                                        value: statuses,
                                        onChange: this.handleSelectStatus
                                    },
                                    statusesList.map(function (s, key) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: s.value, primaryText: s.name });
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'service-providers-history__header-item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
                                    total: total,
                                    rowsPerPage: rowsPerPage,
                                    page: page,
                                    numberOfRows: limit,
                                    updateRows: this.handleChangePagination
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'service-providers-history__filters' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'service-providers-history__filters-item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["e" /* DatePicker */], {
                                    floatingLabelText: 'Filter start date:',
                                    autoOk: true,
                                    minDate: minDate,
                                    maxDate: maxDate,
                                    textFieldStyle: { width: '120px' },
                                    shouldDisableDate: function shouldDisableDate(dateSelected) {
                                        return dateSelected.getTime() > new Date(dateTo).getTime();
                                    },
                                    onChange: this.handleStartDateFilter,
                                    value: dateFrom ? Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["a" /* fromUTC */])(dateFrom) : undefined
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                                    {
                                        style: { margin: '25px 7px 0 -7px' },
                                        disabled: !dateFrom,
                                        onClick: function onClick() {
                                            return _this2.handleRemoveDate('from');
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                        color: dateFrom ? 'red' : 'black'
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'service-providers-history__filters-item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["e" /* DatePicker */], {
                                    floatingLabelText: 'Filter end date:',
                                    autoOk: true,
                                    minDate: minDate,
                                    maxDate: maxDate,
                                    textFieldStyle: { width: '120px' },
                                    shouldDisableDate: function shouldDisableDate(dateSelected) {
                                        return dateSelected.getTime() < new Date(dateFrom).getTime();
                                    },
                                    onChange: this.handleEndDateFilter,
                                    value: dateTo ? Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["a" /* fromUTC */])(dateTo) : undefined
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                                    {
                                        style: { margin: '25px 0 0 -7px' },
                                        disabled: !dateTo,
                                        onClick: function onClick() {
                                            return _this2.handleRemoveDate('to');
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                        color: dateTo ? 'red' : 'black'
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-body service-providers-history__table' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["u" /* Table */],
                                { selectable: false },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["w" /* TableHeader */],
                                    { displaySelectAll: false, adjustForCheckbox: false },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                            'company'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                            'activity'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                            'address'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                            'PIC'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                            'phone'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                                            'email'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '21%' }) },
                                            'by User'
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["v" /* TableBody */],
                                    { displayRowCheckbox: false },
                                    serviceProvidersHistory.map(function (item) {
                                        return item.newServiceProvider && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, {
                                            key: item.newServiceProvider._id + item.statusAt,
                                            item: item
                                        });
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ServiceProvidersHistoryDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.updateRows = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.state;

            var portId, _state$pagination2, page, limit, filters, res;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            portId = window.location.pathname.split('/').slice(-1)[0];
                            _state$pagination2 = state.pagination, page = _state$pagination2.page, limit = _state$pagination2.limit, filters = _state$pagination2.filters;
                            _context.next = 4;
                            return Object(__WEBPACK_IMPORTED_MODULE_8_services_regions_serviceProvider__["d" /* getServiceProvidersHistory */])(portId, { page: page, limit: limit, filters: filters });

                        case 4:
                            res = _context.sent;

                            _this4.setState({ serviceProvidersHistory: res.data, total: res.total });

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this4);
        }));

        return function () {
            return _ref.apply(this, arguments);
        };
    }();

    this.onRequestClose = function () {
        _this4.props.toggle();
    };

    this.handleChangeSearch = function (e, value) {
        var pagination = _extends({}, _this4.state.pagination, {
            page: 1,
            filters: _extends({}, _this4.state.pagination.filters, {
                query: value
            })
        });
        _this4.setState({
            pagination: pagination
        });
    };

    this.handleSearch = function () {
        _this4.updateRows();
    };

    this.handleStartDateFilter = function (e, date) {
        var pagination = _extends({}, _this4.state.pagination, {
            page: 1,
            filters: _extends({}, _this4.state.pagination.filters, {
                dateFrom: Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["d" /* toUTC */])(date)
            })
        });
        _this4.setState({
            pagination: pagination
        }, function () {
            _this4.updateRows(_this4.state);
        });
    };

    this.handleEndDateFilter = function (e, date) {
        var newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59));
        var pagination = _extends({}, _this4.state.pagination, {
            page: 1,
            filters: _extends({}, _this4.state.pagination.filters, {
                dateTo: newDate.toISOString()
            })

        });
        _this4.setState({
            pagination: pagination
        }, function () {
            _this4.updateRows(_this4.state);
        });
    };

    this.handleRemoveDate = function (type) {
        var state = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_this4.state);

        if (type === 'from') {
            state.pagination.filters.dateFrom = '';
        } else if (type === 'to') {
            state.pagination.filters.dateTo = '';
        }

        _this4.setState(_extends({}, state), function () {
            _this4.updateRows(_this4.state);
        });
    };

    this.handleChangePagination = function (_ref2) {
        var page = _ref2.page,
            numberOfRows = _ref2.numberOfRows;

        _this4.setState({
            pagination: _extends({}, _this4.state.pagination, {
                page: page,
                limit: numberOfRows
            })
        }, function () {
            _this4.updateRows(_this4.state);
        });
    };

    this.handleSelectStatus = function (ev, i, value) {
        var pagination = _extends({}, _this4.state.pagination, {
            page: 1,
            filters: _extends({}, _this4.state.pagination.filters, {
                statuses: value
            })

        });
        _this4.setState({
            pagination: pagination
        }, function () {
            _this4.updateRows(_this4.state);
        });
    };
};

var Row = function (_React$Component2) {
    _inherits(Row, _React$Component2);

    function Row() {
        _classCallCheck(this, Row);

        return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
    }

    _createClass(Row, [{
        key: 'render',
        value: function render() {
            var _props$item = this.props.item,
                _props$item$newServic = _props$item.newServiceProvider,
                name = _props$item$newServic.name,
                activities = _props$item$newServic.activities,
                address = _props$item$newServic.address,
                PIC = _props$item$newServic.PIC,
                phones = _props$item$newServic.phones,
                emails = _props$item$newServic.emails,
                statusAt = _props$item.statusAt,
                status = _props$item.status,
                email = _props$item.statusBy.email;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                    name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                    activities.join(', ')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                    address
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                    PIC
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                    phones.map(function (phone, phoneIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: phoneIndex },
                            phone.code + ' ' + phone.phone
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '13%' }) },
                    emails.map(function (em, emIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: emIndex },
                            em
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS, { width: '21%' }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'service-providers-history__table-cell status-at' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'status', style: status === 'approved' ? { color: '#4D9E0E' } : { color: '#E34848' } },
                            status
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            Object(__WEBPACK_IMPORTED_MODULE_9_helpers_dates__["a" /* fromUTC */])(statusAt).toLocaleString()
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            'by ' + email
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Row;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ServiceProvidersHistoryDialog.propTypes = {};

ServiceProvidersHistoryDialog.defaultProps = {};
var _default = ServiceProvidersHistoryDialog;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(dialogStyles, 'dialogStyles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(statusesList, 'statusesList', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(ServiceProvidersHistoryDialog, 'ServiceProvidersHistoryDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(Row, 'Row', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ServiceProvidersHistoryDialog__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServiceProvidersList__ = __webpack_require__(3258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








var ServiceProvidersView = function ServiceProvidersView(_ref) {
    var serviceProviders = _ref.serviceProviders,
        updateServiceProviders = _ref.updateServiceProviders;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openHistoryDialog = _useState2[0],
        setOpenHistoryDialog = _useState2[1];

    var toggleHistoryDialog = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
        setOpenHistoryDialog(function (prev) {
            return !prev;
        });
    }, []);

    var handleChangeServiceProviders = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (newServiceProviders) {
        updateServiceProviders(newServiceProviders);
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { margin: 0, display: 'flex', flexDirection: 'row-reverse' }, className: 'main__title row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-1' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["h" /* IconButton */],
                    { onClick: toggleHistoryDialog },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history___default.a, { color: '#B3B3B3' })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'service-providers' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ServiceProvidersList__["a" /* default */], {
                serviceProviders: serviceProviders,
                handleChangeServiceProviders: handleChangeServiceProviders
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ServiceProvidersHistoryDialog__["a" /* default */], {
            open: openHistoryDialog,
            toggle: toggleHistoryDialog
        })
    );
};

ServiceProvidersView.propTypes = {
    serviceProviders: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired,
    updateServiceProviders: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

var _default = ServiceProvidersView;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ServiceProvidersView, 'ServiceProvidersView', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersView.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersView.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info_outline__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StevedoringPopover__ = __webpack_require__(3259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddServiceProvider__ = __webpack_require__(3260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EditServiceProvider__ = __webpack_require__(3261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ServiceProviders__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ports__ = __webpack_require__(554);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }















var styles = {
    btn: {
        style: { margin: '20px 0 0 0' },
        labelStyle: { textTransform: 'none', fontSize: '13px' }
    }
};

var ServiceProvidersList = function ServiceProvidersList(_ref) {
    var serviceProviders = _ref.serviceProviders,
        handleChangeServiceProviders = _ref.handleChangeServiceProviders;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openEditDialog = _useState2[0],
        setOpenEditDialog = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        openAddDialog = _useState4[0],
        setOpenAddDialog = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState6 = _slicedToArray(_useState5, 2),
        currentProvider = _useState6[0],
        setCurrentProvider = _useState6[1];

    var isEditModeOn = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__ServiceProviders__["a" /* IsEditModeOnContext */]);

    var hasRecommended = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
        return Array.isArray(serviceProviders) ? serviceProviders.find(function (s) {
            return s.recommended && s.recommended.endAt;
        }) : null;
    }, [serviceProviders]);

    console.log(hasRecommended);

    var handleAdd = function handleAdd(newProvider) {
        handleChangeServiceProviders([].concat(_toConsumableArray(serviceProviders), [newProvider]));
    };

    var handleEdit = function handleEdit(editedProvider) {
        var index = serviceProviders.indexOf(currentProvider);
        if (index !== -1) {
            var updatedProviders = [].concat(_toConsumableArray(serviceProviders));
            updatedProviders[index] = editedProvider;
            handleChangeServiceProviders(updatedProviders);
        }
    };

    var handleDelete = function handleDelete(index) {
        handleChangeServiceProviders(serviceProviders.filter(function (_, i) {
            return i !== index;
        }));
    };

    var emptyServiceProvider = {
        activities: [],
        name: '',
        address: '',
        PIC: '',
        emails: [''],
        phones: [{
            phone: '',
            code: ''
        }],
        limitations: [{
            maxDraught: undefined,
            maxBeam: undefined,
            maxLOA: undefined,
            maxDWT: undefined,
            channelDepth: undefined,
            anchorageDepth: undefined
        }],
        companyId: undefined,
        contactPersonId: undefined,
        recommended: undefined
    };

    var handleEditClick = function handleEditClick(provider) {
        setCurrentProvider(provider);
        setOpenEditDialog(true);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-col', style: { width: '169px' } },
                        'Activities'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-col', style: { width: '168px' } },
                        'Company Name'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-col' },
                        'Contact Details'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-body' },
                serviceProviders.map(function (serviceProvider, index) {
                    if (!serviceProvider) return null;

                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-row', key: serviceProvider._id + '-' + index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col info' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                serviceProvider.activities && serviceProvider.activities.includes('Stevedoring Company') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StevedoringPopover__["a" /* default */], { serviceProvider: serviceProvider }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    serviceProvider.activities && serviceProvider.activities.map(function (activity, idx) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { key: 'activity_' + idx },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                null,
                                                activity
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                                        );
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name company' },
                                serviceProvider.name
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-col' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'list' },
                                serviceProvider.emails.map(function (email, emailIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { key: emailIndex, className: 'email' },
                                        email
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'list' },
                                serviceProvider.phones.map(function (phone, phoneIndex) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { key: phoneIndex, className: 'phone' },
                                        phone.code + ' ' + phone.phone
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                serviceProvider.address
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'name' },
                                'PIC: ',
                                serviceProvider.PIC
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'table-col edit',
                                style: {
                                    display: 'flex', alignItems: 'center', position: 'relative', width: '144px'
                                }
                            },
                            serviceProvider.recommended && serviceProvider.recommended.endAt ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["c" /* Chip */],
                                {
                                    style: {
                                        backgroundColor: '#E8F5E9',
                                        height: 24,
                                        position: 'absolute',
                                        top: 10,
                                        right: 0,
                                        zIndex: 1000,
                                        width: 118
                                    },
                                    labelStyle: {
                                        color: '#2E7D32',
                                        lineHeight: '24px',
                                        fontSize: '12px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }
                                },
                                'Recommended',
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                                    {
                                        tooltip: Object(__WEBPACK_IMPORTED_MODULE_11_helpers_ports__["a" /* getRecommendedTitle */])(serviceProvider),
                                        tooltipPosition: 'bottom-left',
                                        style: { width: 20, height: 18, padding: 0 },
                                        iconStyle: { width: 16, height: 16, color: '#2E7D32' }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_action_info_outline___default.a, null)
                                )
                            ) : null,
                            isEditModeOn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { display: 'flex', width: '100%', justifyContent: 'space-evenly' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'icon edit-icon' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                                        {
                                            iconStyle: { color: '#CBCBCB' },
                                            onClick: function onClick() {
                                                return handleEditClick(serviceProvider);
                                            }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_create___default.a, null)
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'icon delete-icon' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                                        {
                                            iconStyle: { color: '#CBCBCB' },
                                            onClick: function onClick() {
                                                return handleDelete(index);
                                            }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_delete___default.a, null)
                                    )
                                )
                            ) : null
                        )
                    );
                })
            )
        ),
        isEditModeOn && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                label: 'Add Service Provider',
                labelStyle: styles.btn.labelStyle,
                style: styles.btn.style,
                labelPosition: 'before',
                icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add___default.a, null),
                primary: true,
                onClick: function onClick() {
                    return setOpenAddDialog(true);
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__EditServiceProvider__["a" /* default */], {
                    key: currentProvider && currentProvider._id,
                    open: openEditDialog,
                    onClose: function onClose() {
                        setOpenEditDialog(false);
                        setCurrentProvider(null);
                    },
                    onSubmit: handleEdit,
                    serviceProvider: currentProvider,
                    hasRecommended: hasRecommended
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AddServiceProvider__["a" /* default */], {
                open: openAddDialog,
                onClose: function onClose() {
                    return setOpenAddDialog(false);
                },
                onSubmit: handleAdd,
                initialValues: emptyServiceProvider,
                hasRecommended: hasRecommended
            })
        )
    );
};

ServiceProvidersList.propTypes = {
    serviceProviders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        PIC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        emails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        phones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            phone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        })),
        limitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            berth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxDraught: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxBeam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxLOA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxDWT: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            channelDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            anchorageDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
        }))
    })),
    handleChangeServiceProviders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

ServiceProvidersList.defaultProps = {
    serviceProviders: []
};

var _default = ServiceProvidersList;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersList.jsx');
    reactHotLoader.register(ServiceProvidersList, 'ServiceProvidersList', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







var StevedoringPopover = function StevedoringPopover(_ref) {
    var serviceProvider = _ref.serviceProvider;

    var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState({
        openPopover: false,
        anchorElPopover: null
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        popoverState = _React$useState2[0],
        setPopoverState = _React$useState2[1];

    var handleClickPopover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (event) {
        // This prevents ghost click
        event.preventDefault();
        setPopoverState({
            openPopover: true,
            anchorElPopover: event.currentTarget
        });
    }, []);

    var handleRequestClosePopover = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
        setPopoverState(function (prev) {
            return _extends({}, prev, {
                openPopover: false
            });
        });
    }, []);

    var openPopover = popoverState.openPopover,
        anchorElPopover = popoverState.anchorElPopover;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        serviceProvider.activities.map(function (activity, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'activity_' + index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    activity
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
            );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'icon info-icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui__["o" /* Popover */],
                {
                    open: openPopover,
                    anchorEl: anchorElPopover,
                    anchorOrigin: { horizontal: 'middle', vertical: 'center' },
                    targetOrigin: { horizontal: 'middle', vertical: 'center' },
                    onRequestClose: handleRequestClosePopover
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block stevedoring-popover' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'title' },
                        serviceProvider.activities.join(',')
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'limitations' },
                        (serviceProvider.limitations || []).map(function (limitation, limitationIndex) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: 'limitation_stevedoring_' + limitationIndex },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'limitation__counter' },
                                    'Limitation: ' + (limitationIndex + 1)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'limitation' },
                                    'Berth',
                                    ' ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { style: { wordBreak: 'break-all', position: 'inherit' } },
                                        limitation.berth
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'limitation' },
                                    'Max draft ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        null,
                                        limitation.maxDraught,
                                        ' m'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'limitation' },
                                    'Max beam ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        null,
                                        limitation.maxBeam,
                                        ' m'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'limitation' },
                                    'Max LOA ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        null,
                                        limitation.maxLOA,
                                        ' m'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'limitation' },
                                    'Max DWT ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        null,
                                        limitation.maxDWT,
                                        ' m'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'limitation' },
                                    'Channel depth ',
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        null,
                                        limitation.channelDepth,
                                        ' m'
                                    )
                                )
                            );
                        })
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                {
                    iconStyle: { color: '#CBCBCB' },
                    onClick: handleClickPopover
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_info_outline___default.a, { style: { color: '#CBCBCB' } })
            )
        )
    );
};

StevedoringPopover.propTypes = {
    serviceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
        limitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            berth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxDraught: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxBeam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxLOA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxDWT: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            channelDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
        })).isRequired
    }).isRequired
};

var _default = StevedoringPopover;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StevedoringPopover, 'StevedoringPopover', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/StevedoringPopover.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/StevedoringPopover.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hook_form__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_data_portActivities__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Emails__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Phones__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PortManagement__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CompaniesAutoComplete__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_UserAutoComplete__ = __webpack_require__(382);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/* eslint-disable react/require-default-props */
















var styles = {
    dialog: {
        contentStyle: { width: '843px', padding: '20px' }
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    btn: {
        labelStyle: { color: '#fff' }
    }
};

var emptyLimitation = {
    maxDraught: '',
    maxBeam: '',
    maxLOA: '',
    maxDWT: '',
    channelDepth: '',
    anchorageDepth: '',
    berth: ''
};

var LimitationField = function LimitationField(_ref) {
    var control = _ref.control,
        name = _ref.name,
        label = _ref.label,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? '14%' : _ref$width,
        _ref$marginLeft = _ref.marginLeft,
        marginLeft = _ref$marginLeft === undefined ? '0px' : _ref$marginLeft,
        _ref$maxValue = _ref.maxValue,
        maxValue = _ref$maxValue === undefined ? 100 : _ref$maxValue;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
        name: name,
        control: control,
        defaultValue: '',
        rules: {
            validate: function validate(value) {
                return !value || Number(value) >= 0 && Number(value) <= maxValue || 'Must be between 0 and ' + maxValue;
            }
        },
        render: function render(_ref2) {
            var _onChange = _ref2.onChange,
                value = _ref2.value,
                error = _ref2.error;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                floatingLabelText: label,
                floatingLabelStyle: styles.textField.floatingLabelStyle,
                style: { width: width, marginLeft: marginLeft },
                onChange: function onChange(e) {
                    return _onChange(e.target.value);
                },
                value: value,
                errorText: error && error.message
            });
        }
    });
};

var PortLimitations = function PortLimitations(_ref3) {
    var control = _ref3.control,
        fields = _ref3.fields,
        append = _ref3.append,
        remove = _ref3.remove;

    var limitationFields = [{ name: 'berth', label: 'Berth', noValidation: true }, { name: 'maxDraught', label: 'Max draft, m:' }, { name: 'maxBeam', label: 'Max beam, m:' }, { name: 'maxLOA', label: 'Max LOA, m:' }, { name: 'maxDWT', label: 'Max DWT, m:', maxValue: 1000000 }, { name: 'channelDepth', label: 'Channel Depth, m:' }];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        fields.map(function (field, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: field.id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    limitationFields.map(function (fieldConfig, fieldIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LimitationField, {
                            key: fieldConfig.name,
                            control: control,
                            name: 'limitations.' + index + '.' + fieldConfig.name,
                            label: fieldConfig.label,
                            marginLeft: fieldIndex > 0 ? '10px' : '0px',
                            maxValue: fieldConfig.maxValue
                        });
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'center-xs', style: { display: 'inline-flex', width: '8%' } },
                        index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                            { onClick: function onClick() {
                                    return append(emptyLimitation);
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point___default.a, null)
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                            { onClick: function onClick() {
                                    return remove(index);
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                        )
                    )
                )
            );
        })
    );
};

LimitationField.propTypes = {
    control: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    maxValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var AddServiceProvider = function AddServiceProvider(_ref4) {
    var open = _ref4.open,
        onClose = _ref4.onClose,
        onSubmit = _ref4.onSubmit,
        _ref4$initialValues = _ref4.initialValues,
        initialValues = _ref4$initialValues === undefined ? {
        activities: [],
        name: '',
        address: '',
        PIC: '',
        emails: [''],
        phones: [{ code: '', phone: '' }],
        limitations: [emptyLimitation],
        companyId: undefined,
        contactPersonId: undefined,
        recommended: undefined
    } : _ref4$initialValues,
        hasRecommended = _ref4.hasRecommended;

    var countries = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__PortManagement__["a" /* ContextCountries */]);

    var _useForm = Object(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["c" /* useForm */])({
        defaultValues: initialValues,
        mode: 'onChange'
    }),
        control = _useForm.control,
        handleSubmit = _useForm.handleSubmit,
        watch = _useForm.watch,
        errors = _useForm.errors,
        register = _useForm.register,
        setValue = _useForm.setValue;

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
        register('companyId');
    }, [register]);

    var _useFieldArray = Object(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["b" /* useFieldArray */])({
        control: control,
        name: 'limitations'
    }),
        fields = _useFieldArray.fields,
        append = _useFieldArray.append,
        remove = _useFieldArray.remove;

    var activities = watch('activities', []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        register('recommended');
    }, [register]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!Array.isArray(activities)) return;
        if (!activities.includes('Port Agency')) {
            setValue('recommended', undefined);
        }
    }, [activities, setValue]);

    var canBeRecommended = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
        return !hasRecommended;
    }, [hasRecommended]);

    var onSubmitForm = function onSubmitForm(data) {
        onSubmit(data);
        onClose();
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
        {
            open: open,
            contentStyle: styles.dialog.contentStyle,
            onRequestClose: onClose,
            paperClassName: 'dialog-service-provider',
            bodyStyle: { overflowY: 'auto' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: handleSubmit(onSubmitForm) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'title' },
                'Add Service Provider: ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                'Marine equipment & spare parts'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        name: 'activities',
                        control: control,
                        rules: { required: 'Activities are required' },
                        render: function render(_ref5) {
                            var _onChange2 = _ref5.onChange,
                                value = _ref5.value;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                                {
                                    floatingLabelText: 'Activities',
                                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                                    multiple: true,
                                    value: value,
                                    onChange: function onChange(_e, _index, next) {
                                        _onChange2(next);
                                        var arr = Array.isArray(next) ? next : [];
                                        if (!arr.includes('Port Agency')) {
                                            setValue('recommended', undefined);
                                        }
                                    },
                                    fullWidth: true,
                                    autoWidth: true,
                                    errorText: errors.activities && errors.activities.message
                                },
                                __WEBPACK_IMPORTED_MODULE_8_data_portActivities__["a" /* default */].map(function (activity, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                        key: index,
                                        value: activity,
                                        primaryText: activity
                                    });
                                })
                            );
                        }
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        name: 'contactPersonId',
                        control: control,
                        rules: {
                            validate: function validate(val) {
                                if (!val) return true;
                                if (!val._id && val.email) return 'Select user from list';
                                if (val.email && val.email.length < 3) return 'User email must be at least 3 characters long';
                                return true;
                            }
                        },
                        render: function render(_ref6) {
                            var value = _ref6.value;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_UserAutoComplete__["a" /* default */], {
                                customValue: value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.email || '' : value || '',
                                onUserSelected: function onUserSelected(val) {
                                    var item = val && val.item ? val.item : null;
                                    if (!item) return;
                                    setValue('contactPersonId', { _id: item._id, email: item.email });
                                    if (item.company) {
                                        setValue('companyId', { _id: item.company._id, name: item.company.name });
                                        setValue('name', item.company.name);
                                    }
                                },
                                onUserChanging: function onUserChanging(text) {
                                    setValue('contactPersonId', { _id: '', email: text });
                                },
                                textFieldStyle: { height: '72px' },
                                inputStyle: { marginTop: '12px' },
                                hintText: 'Contact person',
                                floatingLabelText: 'Contact person',
                                withExtendedData: true
                            });
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        name: 'name',
                        control: control,
                        rules: {
                            required: 'Company name is required',
                            minLength: { value: 3, message: 'Minimum length is 3' },
                            maxLength: { value: 266, message: 'Maximum length is 266' }
                        },
                        render: function render(_ref7) {
                            var value = _ref7.value;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_CompaniesAutoComplete__["a" /* default */], {
                                customValue: value || '',
                                onTextChange: function onTextChange(val) {
                                    setValue('name', val);
                                    setValue('companyId', undefined);
                                    setValue('contactPersonId', { _id: '', email: '' });
                                },
                                onCompanySelected: function onCompanySelected(val) {
                                    var name = val && val.name ? val.name : '';
                                    var item = val && val.item ? val.item : null;
                                    var _id = item && item._id ? item._id : undefined;
                                    setValue('name', name);
                                    setValue('companyId', _id ? { _id: _id, name: name } : null);
                                },
                                floatingLabelText: 'Company name',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                errorText: errors.name && errors.name.message
                            });
                        }
                    })
                )
            ),
            activities.includes('Stevedoring Company') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PortLimitations, {
                control: control,
                fields: fields,
                append: append,
                remove: remove
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        control: control,
                        name: 'emails',
                        render: function render(_ref8) {
                            var value = _ref8.value,
                                onChange = _ref8.onChange;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Emails__["a" /* default */], {
                                emails: value,
                                onChange: onChange,
                                error: errors.emails && errors.emails.message
                            });
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        control: control,
                        name: 'phones',
                        render: function render(_ref9) {
                            var value = _ref9.value,
                                onChange = _ref9.onChange;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Phones__["a" /* default */], {
                                phones: value,
                                onChange: onChange,
                                error: errors.phones && errors.phones.message,
                                countries: countries
                            });
                        }
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        name: 'address',
                        control: control,
                        rules: { required: 'Address is required' },
                        render: function render(_ref10) {
                            var _onChange3 = _ref10.onChange,
                                value = _ref10.value;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                floatingLabelText: 'Address',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                fullWidth: true,
                                onChange: function onChange(e) {
                                    return _onChange3(e.target.value);
                                },
                                value: value,
                                errorText: errors.address && errors.address.message
                            });
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        name: 'PIC',
                        control: control,
                        rules: { required: 'PIC is required' },
                        render: function render(_ref11) {
                            var _onChange4 = _ref11.onChange,
                                value = _ref11.value;
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                floatingLabelText: 'PIC',
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                fullWidth: true,
                                onChange: function onChange(e) {
                                    return _onChange4(e.target.value);
                                },
                                value: value,
                                errorText: errors.PIC && errors.PIC.message
                            });
                        }
                    })
                )
            ),
            Array.isArray(activities) && activities.includes('Port Agency') && canBeRecommended() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-5' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-7' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                        name: 'recommended.endAt',
                        control: control,
                        rules: {
                            validate: function validate(val) {
                                if (!val) return true;
                                var d = val instanceof Date ? val : new Date(val);
                                var today = new Date();
                                today.setHours(0, 0, 0, 0);
                                return d.getTime() > today.getTime() || 'Select a future date';
                            }
                        },
                        render: function render(_ref12) {
                            var _onChange5 = _ref12.onChange,
                                value = _ref12.value,
                                error = _ref12.error;

                            var today = new Date();
                            today.setHours(0, 0, 0, 0);

                            var base = function base() {
                                return value ? new Date(value) : new Date();
                            };
                            var addMonths = function addMonths(n) {
                                var d = base();
                                d.setMonth(d.getMonth() + n);
                                _onChange5(d);
                            };
                            var addYears = function addYears(n) {
                                var d = base();
                                d.setFullYear(d.getFullYear() + n);
                                _onChange5(d);
                            };

                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: {
                                        display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end'
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["e" /* DatePicker */], {
                                    value: value || null,
                                    onChange: function onChange(_e, date) {
                                        return _onChange5(date);
                                    },
                                    shouldDisableDate: function shouldDisableDate(dateSelected) {
                                        return dateSelected.getTime() <= today.getTime();
                                    },
                                    errorText: error && error.message,
                                    textFieldStyle: { fontSize: '13px' },
                                    minDate: today,
                                    floatingLabelText: 'Recommended until',
                                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                                    fullWidth: true
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                                    label: '+1 month',
                                    type: 'button',
                                    labelStyle: { fontSize: '12px', padding: 0 },
                                    style: { marginTop: '16px' },
                                    onClick: function onClick() {
                                        return addMonths(1);
                                    }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                                    label: '+1 year',
                                    type: 'button',
                                    labelStyle: { fontSize: '12px', padding: 0 },
                                    style: { marginTop: '16px' },
                                    onClick: function onClick() {
                                        return addYears(1);
                                    }
                                }),
                                value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                                    {
                                        title: 'Remove recommended',
                                        style: {
                                            width: 32, height: 32, padding: 0, marginTop: '16px'
                                        },
                                        iconStyle: { color: '#d32f2f' },
                                        onClick: function onClick() {
                                            return _onChange5(undefined);
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                                ) : null
                            );
                        }
                    })
                )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12', style: { display: 'flex', flexDirection: 'row-reverse', gap: '10px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Cancel',
                        primary: true,
                        onClick: onClose
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Add',
                        backgroundColor: '#7FC931',
                        labelStyle: styles.btn.labelStyle,
                        type: 'submit'
                    })
                )
            )
        )
    );
};

AddServiceProvider.propTypes = {
    open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        PIC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        emails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        phones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            phone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        })),
        limitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            berth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxDraught: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxBeam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxLOA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxDWT: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            channelDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            anchorageDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
        }))
    }),
    hasRecommended: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var _default = AddServiceProvider;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/AddServiceProvider.jsx');
    reactHotLoader.register(emptyLimitation, 'emptyLimitation', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/AddServiceProvider.jsx');
    reactHotLoader.register(LimitationField, 'LimitationField', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/AddServiceProvider.jsx');
    reactHotLoader.register(PortLimitations, 'PortLimitations', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/AddServiceProvider.jsx');
    reactHotLoader.register(AddServiceProvider, 'AddServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/AddServiceProvider.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/AddServiceProvider.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hook_form__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_data_portActivities__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Emails__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Phones__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PortManagement__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CompaniesAutoComplete__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_UserAutoComplete__ = __webpack_require__(382);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/* eslint-disable react/require-default-props */
















var styles = {
    dialog: {
        contentStyle: { width: '843px', padding: '20px' }
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    btn: {
        labelStyle: { color: '#fff' }
    }
};

var emptyLimitation = {
    maxDraught: undefined,
    maxBeam: undefined,
    maxLOA: undefined,
    maxDWT: undefined,
    channelDepth: undefined,
    anchorageDepth: undefined,
    berth: undefined
};

var LimitationField = function LimitationField(_ref) {
    var control = _ref.control,
        name = _ref.name,
        label = _ref.label,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? '14%' : _ref$width,
        _ref$marginLeft = _ref.marginLeft,
        marginLeft = _ref$marginLeft === undefined ? '0px' : _ref$marginLeft,
        _ref$maxValue = _ref.maxValue,
        maxValue = _ref$maxValue === undefined ? 100 : _ref$maxValue;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
        name: name,
        control: control,
        defaultValue: '',
        rules: {
            validate: function validate(value) {
                return !value || Number(value) >= 0 && Number(value) <= maxValue || 'Must be between 0 and ' + maxValue;
            }
        },
        render: function render(_ref2) {
            var _onChange = _ref2.onChange,
                value = _ref2.value,
                error = _ref2.error;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                floatingLabelText: label,
                floatingLabelStyle: styles.textField.floatingLabelStyle,
                style: { width: width, marginLeft: marginLeft },
                onChange: function onChange(e) {
                    return _onChange(e.target.value);
                },
                value: value,
                errorText: error && error.message
            });
        }
    });
};

var PortLimitations = function PortLimitations(_ref3) {
    var control = _ref3.control,
        fields = _ref3.fields,
        append = _ref3.append,
        remove = _ref3.remove;

    var limitationFields = [{ name: 'berth', label: 'Berth', noValidation: true }, { name: 'maxDraught', label: 'Max draft, m:' }, { name: 'maxBeam', label: 'Max beam, m:' }, { name: 'maxLOA', label: 'Max LOA, m:' }, { name: 'maxDWT', label: 'Max DWT, m:', maxValue: 1000000 }, { name: 'channelDepth', label: 'Channel Depth, m:' }];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        fields.map(function (field, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row', key: field.id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    limitationFields.map(function (fieldConfig, fieldIndex) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LimitationField, {
                            key: fieldConfig.name,
                            control: control,
                            name: 'limitations.' + index + '.' + fieldConfig.name,
                            label: fieldConfig.label,
                            marginLeft: fieldIndex > 0 ? '10px' : '0px',
                            maxValue: fieldConfig.maxValue
                        });
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'center-xs', style: { display: 'inline-flex', width: '8%' } },
                        index === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                            { onClick: function onClick() {
                                    return append(emptyLimitation);
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_image_control_point___default.a, null)
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                            { onClick: function onClick() {
                                    return remove(index);
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                        )
                    )
                )
            );
        })
    );
};

var EditServiceProvider = function EditServiceProvider(props) {
    var open = props.open,
        onClose = props.onClose,
        onSubmit = props.onSubmit,
        serviceProvider = props.serviceProvider,
        hasRecommended = props.hasRecommended;


    var countries = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__PortManagement__["a" /* ContextCountries */]);

    var canBeRecommended = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
        return !hasRecommended;
    }, [hasRecommended]);

    var _useForm = Object(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["c" /* useForm */])({
        defaultValues: serviceProvider || {
            activities: [],
            name: '',
            address: '',
            PIC: '',
            emails: [''],
            phones: [{ code: '', phone: '' }],
            limitations: [emptyLimitation],
            companyId: undefined,
            contactPersonId: undefined,
            recommended: undefined
        },
        mode: 'onChange',
        shouldUnregister: false,
        resolver: function resolver(values) {
            var _errors = {};

            if (values.emails) {
                var emailErrors = values.emails.map(function (email) {
                    if (!email) return 'Email is required';
                    var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                    return re.test(email) ? undefined : 'Invalid email address';
                });

                if (emailErrors.some(function (error) {
                    return error;
                })) {
                    _errors.emails = emailErrors;
                }
            }

            if (values.phones) {
                var phoneErrors = values.phones.map(function (phone) {
                    var _err = {};
                    if (!phone.code) _err.code = 'Required';
                    if (!phone.phone) _err.phone = 'Required';else if (!/^\d+$/.test(phone.phone)) _err.phone = 'Must be a number';else if (phone.phone.length < 6 || phone.phone.length > 15) {
                        _err.phone = 'Must be between 7 and 15 digits';
                    }
                    return Object.keys(_err).length ? _err : undefined;
                });

                if (phoneErrors.some(function (error) {
                    return error;
                })) {
                    _errors.phones = phoneErrors;
                }
            }

            return {
                values: values,
                errors: _errors
            };
        }
    }),
        control = _useForm.control,
        handleSubmit = _useForm.handleSubmit,
        watch = _useForm.watch,
        errors = _useForm.errors,
        reset = _useForm.reset,
        setValue = _useForm.setValue,
        register = _useForm.register;

    var _useFieldArray = Object(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["b" /* useFieldArray */])({
        control: control,
        name: 'limitations'
    }),
        fields = _useFieldArray.fields,
        append = _useFieldArray.append,
        remove = _useFieldArray.remove;

    var activities = watch('activities', []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        register('recommended');
    }, [register]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!Array.isArray(activities)) return;
        if (!activities.includes('Port Agency')) {
            setValue('recommended', undefined);
        }
    }, [activities, setValue]);

    var onSubmitForm = function onSubmitForm(data) {
        onSubmit(_extends({}, serviceProvider, data));
        onClose();
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (serviceProvider) {
            reset(serviceProvider);
        }
    }, [serviceProvider, reset]);

    console.log(Array.isArray(activities) && activities.includes('Port Agency') && canBeRecommended());

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
            {
                modal: false,
                open: open,
                contentStyle: styles.dialog.contentStyle,
                onRequestClose: onClose,
                paperClassName: 'dialog-service-provider',
                bodyStyle: { overflowY: 'auto' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: handleSubmit(onSubmitForm) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'title' },
                    'Edit Service Provider: ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    'Marine equipment & spare parts'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            name: 'activities',
                            control: control,
                            rules: { required: 'Activities are required' },
                            render: function render(_ref4) {
                                var _onChange2 = _ref4.onChange,
                                    value = _ref4.value;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_SelectField___default.a,
                                    {
                                        floatingLabelText: 'Activities',
                                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                                        multiple: true,
                                        value: value,
                                        onChange: function onChange(_e, _index, next) {
                                            _onChange2(next);
                                            var arr = Array.isArray(next) ? next : [];
                                            if (!arr.includes('Port Agency')) {
                                                setValue('recommended', undefined);
                                            }
                                        },
                                        fullWidth: true,
                                        autoWidth: true,
                                        errorText: errors.activities && errors.activities.message
                                    },
                                    __WEBPACK_IMPORTED_MODULE_8_data_portActivities__["a" /* default */].map(function (activity, index) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                            key: index,
                                            value: activity,
                                            primaryText: activity
                                        });
                                    })
                                );
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            name: 'contactPersonId',
                            control: control,
                            rules: {
                                validate: function validate(val) {
                                    if (!val) return true;
                                    if (!val._id && val.email) return 'Select user from list';
                                    if (val.email && val.email.length < 3) return 'User email must be at least 3 characters long';
                                    return true;
                                }
                            },
                            render: function render(_ref5) {
                                var value = _ref5.value;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_UserAutoComplete__["a" /* default */], {
                                    customValue: value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.email || '' : value || '',
                                    onUserSelected: function onUserSelected(val) {
                                        var item = val && val.item ? val.item : null;
                                        if (!item) return;
                                        setValue('contactPersonId', { _id: item._id, email: item.email });
                                        if (item.company) {
                                            setValue('companyId', { _id: item.company._id, name: item.company.name });
                                            setValue('name', item.company.name);
                                        }
                                    },
                                    onUserChanging: function onUserChanging(text) {
                                        setValue('contactPersonId', { _id: '', email: text });
                                    },
                                    textFieldStyle: { height: '72px' },
                                    inputStyle: { marginTop: '12px' },
                                    hintText: 'Contact person',
                                    floatingLabelText: 'Contact person',
                                    withExtendedData: true
                                });
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            name: 'name',
                            control: control,
                            rules: {
                                required: 'Company name is required',
                                minLength: { value: 3, message: 'Minimum length is 3' },
                                maxLength: { value: 266, message: 'Maximum length is 266' }
                            },
                            render: function render(_ref6) {
                                var value = _ref6.value;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_CompaniesAutoComplete__["a" /* default */], {
                                    customValue: value || '',
                                    onTextChange: function onTextChange(val) {
                                        setValue('name', val);
                                        setValue('companyId', undefined);
                                        setValue('contactPersonId', { _id: '', email: '' });
                                    },
                                    onCompanySelected: function onCompanySelected(val) {
                                        var name = val && val.name ? val.name : '';
                                        var item = val && val.item ? val.item : null;
                                        var _id = item && item._id ? item._id : undefined;
                                        setValue('name', name);
                                        setValue('companyId', _id ? { _id: _id, name: name } : null);
                                    },
                                    floatingLabelText: 'Company name',
                                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                                    errorText: errors.name && errors.name.message
                                });
                            }
                        })
                    )
                ),
                activities.includes('Stevedoring Company') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PortLimitations, {
                    control: control,
                    fields: fields,
                    append: append,
                    remove: remove
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            name: 'emails',
                            control: control,
                            defaultValue: [''],
                            rules: {
                                validate: function validate(emails) {
                                    if (!emails || !emails.length) return 'At least one email is required';
                                    return emails.every(function (email) {
                                        if (!email) return 'Email is required';
                                        var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                                        return re.test(email) || 'Invalid email address';
                                    }) || 'Invalid email(s)';
                                }
                            },
                            render: function render(_ref7) {
                                var onChange = _ref7.onChange,
                                    value = _ref7.value;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Emails__["a" /* default */], {
                                    emails: value,
                                    onChange: onChange,
                                    error: errors.emails && errors.emails.message
                                });
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            control: control,
                            name: 'phones',
                            render: function render(_ref8) {
                                var value = _ref8.value,
                                    onChange = _ref8.onChange;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Phones__["a" /* default */], {
                                    phones: value,
                                    onChange: onChange,
                                    error: errors.phones && errors.phones.message,
                                    countries: countries
                                });
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            name: 'address',
                            control: control,
                            rules: { required: 'Address is required' },
                            render: function render(_ref9) {
                                var _onChange3 = _ref9.onChange,
                                    value = _ref9.value;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                    floatingLabelText: 'Address',
                                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                                    fullWidth: true,
                                    onChange: function onChange(e) {
                                        return _onChange3(e.target.value);
                                    },
                                    value: value,
                                    errorText: errors.address && errors.address.message
                                });
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            name: 'PIC',
                            control: control,
                            rules: { required: 'PIC is required' },
                            render: function render(_ref10) {
                                var _onChange4 = _ref10.onChange,
                                    value = _ref10.value;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                    floatingLabelText: 'PIC',
                                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                                    fullWidth: true,
                                    onChange: function onChange(e) {
                                        return _onChange4(e.target.value);
                                    },
                                    value: value,
                                    errorText: errors.PIC && errors.PIC.message
                                });
                            }
                        })
                    )
                ),
                Array.isArray(activities) && activities.includes('Port Agency') && canBeRecommended() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-5' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-7' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_hook_form__["a" /* Controller */], {
                            name: 'recommended.endAt',
                            control: control,
                            rules: {
                                validate: function validate(val) {
                                    if (!val) return true;
                                    var d = val instanceof Date ? val : new Date(val);
                                    var today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    return d.getTime() > today.getTime() || 'Select a future date';
                                }
                            },
                            render: function render(_ref11) {
                                var _onChange5 = _ref11.onChange,
                                    value = _ref11.value,
                                    error = _ref11.error;

                                var today = new Date();
                                today.setHours(0, 0, 0, 0);

                                var base = function base() {
                                    return value ? new Date(value) : new Date();
                                };
                                var addMonths = function addMonths(n) {
                                    var d = base();
                                    d.setMonth(d.getMonth() + n);
                                    _onChange5(d);
                                };
                                var addYears = function addYears(n) {
                                    var d = base();
                                    d.setFullYear(d.getFullYear() + n);
                                    _onChange5(d);
                                };

                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: {
                                            display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end'
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["e" /* DatePicker */], {
                                        value: value ? new Date(value) : null,
                                        onChange: function onChange(_e, date) {
                                            return _onChange5(date);
                                        },
                                        shouldDisableDate: function shouldDisableDate(dateSelected) {
                                            return dateSelected.getTime() <= today.getTime();
                                        },
                                        errorText: error && error.message,
                                        textFieldStyle: { fontSize: '13px' },
                                        minDate: today,
                                        floatingLabelText: 'Recommended until',
                                        floatingLabelStyle: styles.textField.floatingLabelStyle,
                                        fullWidth: true
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                                        label: '+1 month',
                                        type: 'button',
                                        labelStyle: { fontSize: '12px', padding: 0 },
                                        style: { marginTop: '16px' },
                                        onClick: function onClick() {
                                            return addMonths(1);
                                        }
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                                        label: '+1 year',
                                        type: 'button',
                                        labelStyle: { fontSize: '12px', padding: 0 },
                                        style: { marginTop: '16px' },
                                        onClick: function onClick() {
                                            return addYears(1);
                                        }
                                    }),
                                    value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                                        {
                                            title: 'Remove recommended',
                                            style: {
                                                width: 32, height: 32, padding: 0, marginTop: '16px'
                                            },
                                            iconStyle: { color: '#d32f2f' },
                                            onClick: function onClick() {
                                                return _onChange5(null);
                                            }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_remove_circle_outline___default.a, null)
                                    ) : null
                                );
                            }
                        })
                    )
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12', style: { display: 'flex', flexDirection: 'row-reverse', gap: '10px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                            label: 'Cancel',
                            primary: true,
                            onClick: onClose
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                            label: 'Add',
                            backgroundColor: '#7FC931',
                            labelStyle: styles.btn.labelStyle,
                            type: 'submit'
                        })
                    )
                )
            )
        )
    );
};

EditServiceProvider.propTypes = {
    open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    serviceProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        PIC: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        emails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
        phones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            phone: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
        })),
        limitations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
            berth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            maxDraught: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxBeam: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxLOA: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            maxDWT: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            channelDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
            anchorageDepth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
        }))
    })
};

var _default = EditServiceProvider;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/EditServiceProvider.jsx');
    reactHotLoader.register(emptyLimitation, 'emptyLimitation', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/EditServiceProvider.jsx');
    reactHotLoader.register(LimitationField, 'LimitationField', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/EditServiceProvider.jsx');
    reactHotLoader.register(PortLimitations, 'PortLimitations', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/EditServiceProvider.jsx');
    reactHotLoader.register(EditServiceProvider, 'EditServiceProvider', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/EditServiceProvider.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/EditServiceProvider.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(3263);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mutations__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__mutations__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries__ = __webpack_require__(3264);
/* unused harmony namespace reexport */



/***/ }),
/* 3263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePortMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useServiceProvidersMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_query__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__(28);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var handleError = function handleError(message) {
    Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])(message, 'error');
};

var handleSuccess = function handleSuccess(message) {
    Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])(message, 'success');
};

/**
 * hook for port-related mutations
 * @param {string} portId - The ID of the port
 */
var usePortMutations = function usePortMutations(portId) {
    var queryClient = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useQueryClient"])();

    /** @param {void} - invalidates port queries */
    var invalidatePort = function invalidatePort() {
        return queryClient.invalidateQueries(['port', portId]);
    };

    /**
     * mutation for approving port modifications
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var approve = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref) {
        var _id = _ref._id,
            historyId = _ref.historyId,
            updateAt = _ref.updateAt;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].approvePortModifications({ _id: _id, historyId: historyId, updateAt: updateAt });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Port modifications approved');
        },
        onError: handleError
    });

    /**
     * mutation for rejecting port modifications
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var reject = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref2) {
        var _id = _ref2._id,
            historyId = _ref2.historyId,
            updateAt = _ref2.updateAt;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].rejectPortModifications({ _id: _id, historyId: historyId, updateAt: updateAt });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Port modifications rejected');
        },
        onError: handleError
    });

    /**
     * mutation for updating a single field
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var updateField = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref3) {
        var _id = _ref3._id,
            historyId = _ref3.historyId,
            updateAt = _ref3.updateAt,
            toUpdate = _ref3.toUpdate;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updatePortModificationField({
            _id: _id, historyId: historyId, updateAt: updateAt, toUpdate: toUpdate
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Port modification field updated');
        },
        onError: handleError
    });

    /**
     * mutation for approving a single field
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var approveField = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref4) {
        var _id = _ref4._id,
            historyId = _ref4.historyId,
            fields = _ref4.fields,
            updateAt = _ref4.updateAt;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].approvePortModificationField({
            _id: _id, historyId: historyId, fields: fields, updateAt: updateAt
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Port modification field approved');
        },
        onError: handleError
    });

    /**
     * mutation for rejecting a single field
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var rejectField = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref5) {
        var _id = _ref5._id,
            historyId = _ref5.historyId,
            fields = _ref5.fields,
            updateAt = _ref5.updateAt;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].rejectPortModificationField({
            _id: _id, historyId: historyId, fields: fields, updateAt: updateAt
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Port modification field rejected');
        },
        onError: handleError
    });

    return {
        approve: approve, reject: reject, updateField: updateField, approveField: approveField, rejectField: rejectField
    };
};

/**
 * Hook for service provider-related mutations
 * @param {string} portId - The ID of the port
 */
var useServiceProvidersMutations = function useServiceProvidersMutations(portId) {
    var queryClient = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useQueryClient"])();
    var invalidatePort = function invalidatePort() {
        return queryClient.invalidateQueries(['port', portId]);
    };

    /**
     * mutation for approving a service provider
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var approve = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref6) {
        var _id = _ref6._id,
            historyId = _ref6.historyId,
            updateAt = _ref6.updateAt;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].approveServiceProvider({ _id: _id, historyId: historyId, updateAt: updateAt });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Service provider approved');
        },
        onError: handleError
    });

    /**
     * mutation for rejecting a service provider
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var reject = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref7) {
        var _id = _ref7._id,
            historyId = _ref7.historyId,
            updateAt = _ref7.updateAt;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].rejectServiceProvider({ _id: _id, historyId: historyId, updateAt: updateAt });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Service provider rejected');
        },
        onError: handleError
    });

    /**
     * mutation for updating a service provider
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var update = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref8) {
        var _id = _ref8._id,
            historyId = _ref8.historyId,
            updateAt = _ref8.updateAt,
            serviceProviders = _ref8.serviceProviders;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].updateServiceProviders({
            _id: _id, historyId: historyId, updateAt: updateAt, serviceProviders: serviceProviders
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Service provider updated');
        },
        onError: handleError
    });

    /**
     * mutation for approving a new service provider
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var approveNew = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref9) {
        var _id = _ref9._id,
            historyId = _ref9.historyId,
            updateAt = _ref9.updateAt,
            providerId = _ref9.providerId;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].approveNewServiceProvider({
            _id: _id, historyId: historyId, updateAt: updateAt, providerId: providerId
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('New service provider approved');
        },
        onError: handleError
    });

    /**
     * mutation for rejecting a new service provider
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var rejectNew = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref10) {
        var _id = _ref10._id,
            historyId = _ref10.historyId,
            updateAt = _ref10.updateAt,
            providerId = _ref10.providerId;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].rejectNewServiceProvider({
            _id: _id, historyId: historyId, updateAt: updateAt, providerId: providerId
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('New service provider rejected');
        },
        onError: handleError
    });

    /**
     * mutation for approving a remove service provider
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var approveRemove = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref11) {
        var _id = _ref11._id,
            historyId = _ref11.historyId,
            updateAt = _ref11.updateAt,
            providerId = _ref11.providerId;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].approveRemoveServiceProvider({
            _id: _id, historyId: historyId, updateAt: updateAt, providerId: providerId
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Remove service provider approved');
        },
        onError: handleError
    });

    /**
     * mutation for rejecting a remove service provider
     * @type {import('react-query').UseMutationResult<*, Error, PortModification>}
     */
    var rejectRemove = Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useMutation"])(function (_ref12) {
        var _id = _ref12._id,
            historyId = _ref12.historyId,
            updateAt = _ref12.updateAt,
            providerId = _ref12.providerId;
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].rejectRemoveServiceProvider({
            _id: _id, historyId: historyId, updateAt: updateAt, providerId: providerId
        });
    }, {
        onSuccess: function onSuccess() {
            invalidatePort();
            handleSuccess('Remove service provider rejected');
        },
        onError: handleError
    });

    return {
        approveServiceProvider: approve,
        rejectServiceProvider: reject,
        updateServiceProvider: update,
        approveNewServiceProvider: approveNew,
        rejectNewServiceProvider: rejectNew,
        approveRemoveServiceProvider: approveRemove,
        rejectRemoveServiceProvider: rejectRemove
    };
};

/**
 * @typedef {Object} PortModification
 * @property {string} _id - port id
 * @property {string} historyId - history record id
 * @property {number} [updateAt] - timestamp of the update
 * @property {Record<string, any>} [toUpdate] - field update data
 * @property {string} [toUpdate.field] - field name to update
 * @property {string[]} [toApprove] - field name to approve
 * @property {string[]} [toReject] - field name to reject
 * @property {*} [toUpdate.value] - new value for the field
 * @property {string[]} [fields] - fields to approve or reject
 * @property {any[]} [serviceProviders] - service providers to update
 * @property {string} [providerId] - provider id to approve or reject
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(handleError, 'handleError', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/hooks/ports/mutations.js');
    reactHotLoader.register(handleSuccess, 'handleSuccess', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/hooks/ports/mutations.js');
    reactHotLoader.register(usePortMutations, 'usePortMutations', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/hooks/ports/mutations.js');
    reactHotLoader.register(useServiceProvidersMutations, 'useServiceProvidersMutations', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/hooks/ports/mutations.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export usePort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_query__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var usePort = function usePort(portId) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react_query__["useQuery"])(['port', portId], function () {
        return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].getPort({ id: portId, history: true, all: true });
    });
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(usePort, 'usePort', '/opt/atlassian/pipelines/agent/build/client/app/components/Regions/PortManagement/hooks/ports/queries.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CargoEditorTable__ = __webpack_require__(3266);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function CargoEditorPage(props) {
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        props.getCargoTypes();
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'cargo-assigners', className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'cargo editor'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CargoEditorTable__["a" /* default */], null)
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCargoTypes: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_types__["a" /* getCargoTypes */]
    }, dispatch);
})(CargoEditorPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoEditorPage, 'CargoEditorPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorPage.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorPage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_gazetters__ = __webpack_require__(3267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Base_AwaitableBtn__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_gazetters__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CargoEditorRow__ = __webpack_require__(3268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















var rowsPerPage = [50, 100];

function CargoEditorTable(_ref) {
    var _this = this;

    var getCargoGazetters = _ref.getCargoGazetters,
        deleteCargoGazetter = _ref.deleteCargoGazetter,
        _ref$_items = _ref._items,
        _items = _ref$_items === undefined ? [] : _ref$_items,
        _total = _ref._total,
        _details = _ref._details,
        _search = _ref._search,
        _onlyEmpty = _ref._onlyEmpty,
        _page = _ref._page,
        _limit = _ref._limit,
        isLoaded = _ref.isLoaded;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_search || undefined),
        _useState2 = _slicedToArray(_useState, 2),
        search = _useState2[0],
        setSearch = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        searchApplied = _useState4[0],
        setSearchApplied = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState6 = _slicedToArray(_useState5, 2),
        page = _useState6[0],
        setPage = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(50),
        _useState8 = _slicedToArray(_useState7, 2),
        limit = _useState8[0],
        setLimit = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState10 = _slicedToArray(_useState9, 2),
        details = _useState10[0],
        setDetails = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_items),
        _useState12 = _slicedToArray(_useState11, 2),
        rows = _useState12[0],
        setRows = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState14 = _slicedToArray(_useState13, 2),
        total = _useState14[0],
        setTotal = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState16 = _slicedToArray(_useState15, 2),
        onlyEmpty = _useState16[0],
        setOnlyEmpty = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState18 = _slicedToArray(_useState17, 2),
        pendingUpdatesCount = _useState18[0],
        setPendingUpdatesCount = _useState18[1];

    var _useState19 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState20 = _slicedToArray(_useState19, 2),
        showNotUpdatedDialog = _useState20[0],
        setShowNotUpdatedDialog = _useState20[1];

    var _useState21 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState22 = _slicedToArray(_useState21, 2),
        tempNav = _useState22[0],
        setTempNav = _useState22[1];

    var _useState23 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState24 = _slicedToArray(_useState23, 2),
        cargoNamesMatches = _useState24[0],
        setCargoNamesMatches = _useState24[1];

    var fetchCargoMatches = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(names) {
            var response, matchesData;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(!names || !names.length)) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            _context.prev = 2;
                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_12_services__["a" /* default */].getCargoNamesMatches(names);

                        case 5:
                            response = _context.sent;
                            matchesData = response.data || [];

                            setCargoNamesMatches(matchesData);
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](2);

                            setCargoNamesMatches([]);

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[2, 10]]);
        }));

        return function fetchCargoMatches(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (rows.length > 0) {
            fetchCargoMatches(rows.filter(function (row) {
                return !row.realCargoId;
            }).map(function (row) {
                return row.value;
            }));
        }
    }, [rows]);

    var updateCargoMatches = function updateCargoMatches(newCargoMatches) {
        setCargoNamesMatches(newCargoMatches);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPage(1);
        getCargoGazetters({ page: 1, limit: limit, filters: { search: search, details: details, onlyEmpty: onlyEmpty } });
    }, [onlyEmpty]);

    var searchGazetters = function searchGazetters() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$newPage = _ref3.newPage,
            newPage = _ref3$newPage === undefined ? 1 : _ref3$newPage,
            _ref3$newLimit = _ref3.newLimit,
            newLimit = _ref3$newLimit === undefined ? 50 : _ref3$newLimit,
            _ref3$newSearchApplie = _ref3.newSearchApplied,
            newSearchApplied = _ref3$newSearchApplie === undefined ? false : _ref3$newSearchApplie;

        getCargoGazetters({
            page: newPage,
            limit: newLimit,
            filters: {
                search: newSearchApplied ? search : undefined,
                details: details,
                onlyEmpty: onlyEmpty
            }
        });
    };

    var handleSearchClick = function handleSearchClick() {
        setPage(1);
        setSearchApplied(!!search);
        searchGazetters({ newSearchApplied: !!search });
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setTotal(_total);
        setRows(_items);
        setDetails(_details);

        return function () {
            setTotal(0);
            setRows([]);
            setDetails([]);
            setCargoNamesMatches([]);
            setPendingUpdatesCount(0);
        };
    }, [_total, _items, _page, _limit, _details]);

    var handleUpdateRow = function handleUpdateRow(data) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (pendingUpdatesCount && !opts.force) {
            setShowNotUpdatedDialog(true);
            setTempNav({
                page: data.page,
                numberOfRows: data.numberOfRows
            });
            return;
        }

        if (!data) {
            data = tempNav;
            setShowNotUpdatedDialog(false);
            setTempNav({});
        }

        setLimit(data.numberOfRows);
        setPage(data.page);
        searchGazetters({
            newPage: data.page,
            newLimit: data.numberOfRows,
            newSearchApplied: searchApplied
        });
    };

    var syncGazetteersToDbEntries = function syncGazetteersToDbEntries() {
        var answer = prompt('This operation will block gazetteer resources while running and may take up to a minute!\nType \'sync\' to confirm action');
        if (answer === 'sync') {
            return __WEBPACK_IMPORTED_MODULE_8_services_gazetters__["l" /* syncFeaturesFromDb */]();
        }

        return null;
    };

    var removeGazetter = function removeGazetter(itemId) {
        deleteCargoGazetter(itemId);
        searchGazetters();
    };

    /**
     * @param {'-' | '+'} sign
     */
    var changePendingUpdates = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (sign) {
        var currentCount = pendingUpdatesCount;
        if (sign === '-') {
            currentCount && setPendingUpdatesCount(currentCount - 1);
        } else {
            setPendingUpdatesCount(currentCount + 1);
        }
    }, [pendingUpdatesCount]);

    var navigateActions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["g" /* FlatButton */], {
        label: 'Cancel',
        primary: true,
        onClick: function onClick() {
            return setShowNotUpdatedDialog(!showNotUpdatedDialog);
        }
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["g" /* FlatButton */], {
        label: 'Submit',
        primary: true,
        keyboardFocused: true,
        onClick: function onClick() {
            return handleUpdateRow(undefined, { force: true });
        }
    })];

    var updateRowsRealCargoData = function updateRowsRealCargoData(newRealCargoData) {
        var _rows = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(rows);

        _rows.forEach(function (row) {
            if (row.realCargoId === newRealCargoData._id) {
                row.realCargoName = newRealCargoData.name;
                row.details = newRealCargoData.details;
                row.CargoCategoryName = newRealCargoData.parent.red.name;
                row.CargoCategory = newRealCargoData.parent.red._id;
            }
        });

        setRows(_rows);
    };

    var updateRow = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (updatedItem) {
        setRows(function (prevRows) {
            return (
                // Create a new array with the updated item
                prevRows.map(function (row) {
                    return row._id === updatedItem._id ? updatedItem : row;
                })
            );
        });
    }, []);

    console.log(rows);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_material_ui__["f" /* Dialog */],
            {
                title: '',
                open: showNotUpdatedDialog,
                actions: navigateActions,
                onRequestClose: function onRequestClose() {
                    return setShowNotUpdatedDialog(!showNotUpdatedDialog);
                }
            },
            'Are you sure you want to navigate? Some cargoes are pending updates.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header', style: { justifyContent: 'space-between' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["A" /* TextField */], {
                    defaultValue: search || '',
                    floatingLabelText: 'Search',
                    onChange: function onChange(e) {
                        return setSearch(e.target.value || undefined);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return e.keyCode === 13 && handleSearchClick();
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["b" /* Checkbox */], {
                    label: 'Empty fields',
                    checked: onlyEmpty,
                    onCheck: function onCheck() {
                        return setOnlyEmpty(!onlyEmpty);
                    },
                    style: { fontSize: '13px' }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                    label: 'Search',
                    onClick: handleSearchClick,
                    primary: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_components_Base_AwaitableBtn__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                        label: 'Sync cargo features',
                        disabled: !__WEBPACK_IMPORTED_MODULE_9_store_configureStore__["a" /* UserPerms */].isAdmin(),
                        onClick: syncGazetteersToDbEntries,
                        primary: true
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                    total: total,
                    rowsPerPage: rowsPerPage,
                    page: page,
                    numberOfRows: limit,
                    updateRows: handleUpdateRow
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui__["u" /* Table */],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["w" /* TableHeader */],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["y" /* TableRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Cargo name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Real Cargo name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Cargo type'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'Last modified'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnSmallCSS },
                            'Details'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                            'By user'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnSmallCSS },
                            null
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnSmallCSS, { width: '48px' }) },
                            null
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnSmallCSS, { width: '48px' }) },
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["v" /* TableBody */],
                    {
                        className: isLoaded ? '' : 'hidden',
                        displayRowCheckbox: false
                    },
                    isLoaded ? rows.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CargoEditorRow__["a" /* default */], {
                            key: item._id,
                            item: item,
                            cargoNameMatch: (cargoNamesMatches || []).find(function (match) {
                                return match.query === item.value;
                            }),
                            cargoNameMatches: cargoNamesMatches,
                            removeGazetter: removeGazetter,
                            changePendingUpdates: changePendingUpdates,
                            updateRowsRealCargoData: updateRowsRealCargoData,
                            updateCargoMatches: updateCargoMatches,
                            updateRow: updateRow
                        });
                    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["d" /* CircularProgress */], {
                        style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].circularProgress
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    var _state$cargoGazetters = state.cargoGazetters,
        items = _state$cargoGazetters.items,
        total = _state$cargoGazetters.total,
        filters = _state$cargoGazetters.filters,
        page = _state$cargoGazetters.page,
        limit = _state$cargoGazetters.limit,
        isLoaded = _state$cargoGazetters.isLoaded;


    return {
        _items: items || [],
        _total: total,
        _details: filters ? filters.details : undefined,
        _search: filters ? filters.search : undefined,
        _onlyEmpty: filters ? filters.onlyEmpty : false,
        _page: page,
        _limit: limit || 50,
        isLoaded: isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCargoGazetters: __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_gazetters__["b" /* getCargoGazetters */],
        deleteCargoGazetter: __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_gazetters__["a" /* deleteCargoGazetter */]
    }, dispatch);
})(CargoEditorTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(rowsPerPage, 'rowsPerPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorTable.jsx');
    reactHotLoader.register(CargoEditorTable, 'CargoEditorTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["b"] = getCargoGazetters;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteCargoGazetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoGazetters(opts) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_14" /* GET_CARGO_GAZETTERS */].REQUEST,
        opts: opts
    };
}

function deleteCargoGazetter(item) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["M" /* DELETE_CARGO_GAZETTER */].REQUEST,
        item: item
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoGazetters, 'getCargoGazetters', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/gazetters.js');
    reactHotLoader.register(deleteCargoGazetter, 'deleteCargoGazetter', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/gazetters.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_assigners__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_settings__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UpdateRealCargoDialog__ = __webpack_require__(3269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CargoEditorRow_styles_scss__ = __webpack_require__(3273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CargoEditorRow_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CargoEditorRow_styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_common_HOC_withClearButton__ = __webpack_require__(954);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



















var AutoCompleteWithClear = Object(__WEBPACK_IMPORTED_MODULE_16_components_common_HOC_withClearButton__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_material_ui__["a" /* AutoComplete */]);

/**
 * @param {{
 *  updateCargoAssigner: (item: Item) => void,
 *  saveStatusCargoAssigner: (item: Item) => void,
 *  cargoTypes: any[],
 *  addNotification: (any) => void,
 *  updateRowsRealCargoData: (rows: Item[]) => void,
 *  cargoNameMatch: CargoNameMatch | null,
 *  item: Item,
 *  changePendingUpdates: (pendingUpdates: string) => void,
 *  updateCargoMatches: (cargoMatches: CargoNameMatch[]) => void,
 *  cargoNameMatches: CargoNameMatch[],
 *  updateRow: (row: Item) => void,
 * }} param0 
 * @returns 
 */
function CargoEditorRow(_ref) {
    var _this = this;

    var updateCargoAssigner = _ref.updateCargoAssigner,
        saveStatusCargoAssigner = _ref.saveStatusCargoAssigner,
        cargoTypes = _ref.cargoTypes,
        addNotification = _ref.addNotification,
        updateRowsRealCargoData = _ref.updateRowsRealCargoData,
        cargoNameMatch = _ref.cargoNameMatch,
        updateCargoMatches = _ref.updateCargoMatches,
        cargoNameMatches = _ref.cargoNameMatches,
        updateRow = _ref.updateRow,
        props = _objectWithoutProperties(_ref, ['updateCargoAssigner', 'saveStatusCargoAssigner', 'cargoTypes', 'addNotification', 'updateRowsRealCargoData', 'cargoNameMatch', 'updateCargoMatches', 'cargoNameMatches', 'updateRow']);

    var _cargoCategoryNames = cargoTypes.map(function (item) {
        return {
            name: item.name,
            item: item
        };
    });

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.item),
        _useState2 = _slicedToArray(_useState, 2),
        item = _useState2[0],
        setItem = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        realCargoNames = _useState4[0],
        setRealCargoNames = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_cargoCategoryNames),
        _useState6 = _slicedToArray(_useState5, 2),
        cargoCategoryNames = _useState6[0],
        _setCargoCategoryNames = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.item.realCargoName),
        _useState8 = _slicedToArray(_useState7, 2),
        realCargoName = _useState8[0],
        setRealCargoName = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState10 = _slicedToArray(_useState9, 2),
        preventFirstSearch = _useState10[0],
        setPreventFirstSearch = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState12 = _slicedToArray(_useState11, 2),
        isModifyDialogOpen = _useState12[0],
        setIsModifyDialogOpen = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState14 = _slicedToArray(_useState13, 2),
        isSuggesting = _useState14[0],
        setIsSuggesting = _useState14[1];

    var hasSearchedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
    var isInitialRender = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(true);

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_12_helpers_useDebounce__["a" /* default */])(realCargoName, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch || isInitialRender.current || // skip if the component is still initializing
        !debouncedSearchValue || debouncedSearchValue.length < 2 || !item._id ||
        // skip if the value is the initial value
        !hasSearchedRef.current && debouncedSearchValue === props.item.realCargoName ||
        // skip if the value is from a suggestion match
        isSuggesting && cargoNameMatch && cargoNameMatch.suggestedCargo && cargoNameMatch.suggestedCargo.realCargoName === debouncedSearchValue) {
            return;
        }

        hasSearchedRef.current = true;

        __WEBPACK_IMPORTED_MODULE_8_services__["a" /* default */].getCargoNamesAutocomplete(debouncedSearchValue).then(function (response) {
            var _realCargoNames = response.data.data.map(function (_realCargoName) {
                return {
                    name: _realCargoName.name,
                    item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["m" /* MenuItem */], {
                        value: _realCargoName,
                        primaryText: _realCargoName.name,
                        secondaryText: ['admin', 'moderator'].includes(_realCargoName.addedByRole) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_settings___default.a, {
                            style: {
                                position: 'absolute',
                                left: -10,
                                marginTop: '11px',
                                color: '#9E9E9E'
                            }
                        }),
                        style: { paddingLeft: '25px' }
                    })
                };
            });

            setRealCargoNames(_realCargoNames);
            document.body.scrollTop += 1;
            document.body.scrollTop -= 1;
        }).catch(function () {
            return null;
        });
    }, [debouncedSearchValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        props.changePendingUpdates(item.isUpdate ? '+' : '-');
    }, [item.isUpdate]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setItem(props.item);
        setRealCargoName(props.item.realCargoName);
    }, [props.item]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        // longer initial delay to ensure everything is properly initialized
        var timer = setTimeout(function () {
            setPreventFirstSearch(false);
            isInitialRender.current = false; // Mark component as fully mounted
        }, 1500);

        return function () {
            return clearTimeout(timer);
        };
    }, [props.item._id]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (cargoNameMatch && cargoNameMatch.suggestedCargo) {
            setIsSuggesting(true);

            var _item = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(item);
            _item.realCargoName = cargoNameMatch.suggestedCargo.realCargoName;
            _item.realCargoId = cargoNameMatch.suggestedCargo.realCargoId;
            _item.details = cargoNameMatch.suggestedCargo.details;
            _item.CargoCategory = cargoNameMatch.suggestedCargo.CargoCategory;
            _item.CargoCategoryName = cargoNameMatch.suggestedCargo.CargoCategoryName;
            _item.isSuggest = true;

            setItem(_item);
            setRealCargoName(cargoNameMatch.suggestedCargo.realCargoName);
            saveStatusCargoAssigner(_item);
        } else {
            setIsSuggesting(false);
        }
    }, [cargoNameMatch]);

    var onNewRequestRealCargoNames = function onNewRequestRealCargoNames(updateProperties) {
        if (!updateProperties) {
            return;
        }

        var _item = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(item);

        if (updateProperties.item.props.value.parent) {
            cargoTypes.forEach(function (cargoType) {
                if (updateProperties.item.props.value.parent.red._id === cargoType._id) {
                    _item.CargoCategory = cargoType._id;
                    _item.CargoCategoryName = cargoType.name;
                }
            });
        }

        _item.realCargoName = updateProperties.name;
        _item.realCargoId = updateProperties.item.props.value._id;
        _item.details = updateProperties.item.props.value.details;
        _item.isUpdate = true;

        setItem(_item);
        setRealCargoNames([]);
        saveStatusCargoAssigner(_item);
    };

    var onUpdateInputCargoType = function onUpdateInputCargoType(searchText) {
        var _item = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(item);
        _item.CargoCategoryName = searchText;

        _item.isUpdate = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* checkIfUpdateGazetter */])(_item, cargoTypes);

        setItem(_item);

        saveStatusCargoAssigner(_item);
    };

    var onNewRequestCargoTypes = function onNewRequestCargoTypes(updateProperties) {
        if (!updateProperties.name) {
            return;
        }

        var _item = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(item);

        _item.isUpdate = false;
        _item.isSuggest = false;
        _item.CargoCategoryName = updateProperties.name;
        _item.CargoCategory = updateProperties.item._id;
        _item.details = updateProperties.item.details;

        if (_item.realCargoName && _item.realCargoName.length >= 3) {
            _item.isUpdate = true;
        }

        setItem(_item);

        saveStatusCargoAssigner(_item);
    };

    var handleChangeDetail = function handleChangeDetail(value) {
        var _item = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(item);
        _item.isUpdate = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* checkIfUpdateGazetter */])(_item, cargoTypes);
        _item.details = value;

        setItem(_item);

        saveStatusCargoAssigner(_item);
    };

    var handleUpdateAssigner = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var updated, _item;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_8_services__["a" /* default */].updateCargoAssigner(item);

                        case 2:
                            updated = _context.sent;

                            if (updated.status === 200) {
                                _item = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(updated.data);

                                _item.isUpdate = false;
                                _item.isSuggest = false;
                                setItem(_item);
                                addNotification({
                                    title: 'Success',
                                    message: 'Cargo updated',
                                    level: 'success',
                                    _id: updated.data._id,
                                    autoDismiss: 2
                                });
                                setIsSuggesting(false);
                                updateCargoMatches(cargoNameMatches.filter(function (match) {
                                    return match.query !== cargoNameMatch.query;
                                }));
                                updateRow(_item);
                            } else {
                                addNotification({
                                    title: 'Error',
                                    message: updated.errors[0].messages[0],
                                    level: 'error',
                                    _id: item,
                                    autoDismiss: 10
                                });
                            }

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function handleUpdateAssigner() {
            return _ref2.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
        { className: isSuggesting ? 'suggestingRow' : '' },
        isModifyDialogOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__UpdateRealCargoDialog__["a" /* default */], {
            handleCloseDialog: setIsModifyDialogOpen,
            open: isModifyDialogOpen,
            item: item,
            cargoTypes: cargoTypes,
            updateRowsRealCargoData: updateRowsRealCargoData
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            {
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS, { position: 'relative' }),
                className: 'cargo-assigner_name_column'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'name' },
                isSuggesting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'matchIndicator' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'matchAsterisk' },
                        '*'
                    )
                ),
                item.value
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            {
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS, {
                    position: 'relative'
                })
            },
            isSuggesting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'scoreIndicator' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'scoreBadge' },
                    cargoNameMatch && cargoNameMatch.score ? 'Match: ' + Math.round(cargoNameMatch.score * 100) + '%' : 'Suggested'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCompleteWithClear, {
                textFieldStyle: _extends({}, __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].autoCompleteCSS, {
                    width: '100%'
                }),
                hintText: 'Real cargo name',
                searchText: realCargoName || '',
                dataSource: realCargoNames,
                dataSourceConfig: { text: 'name', value: 'item' },
                onUpdateInput: function onUpdateInput(text) {
                    setRealCargoName(text);

                    // only update the item state and trigger side effects if:
                    // 1. not in initial rendering phase
                    // 2. the component is fully mounted
                    // 3. user is actually typing (not just getting a suggestion)
                    if (!preventFirstSearch && !isInitialRender.current && text !== props.item.realCargoName) {
                        setItem(_extends({}, item, {
                            isUpdate: Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* checkIfUpdateGazetter */])(_extends({}, item, { realCargoName: text }), cargoTypes),
                            isSuggest: false,
                            realCargoName: text,
                            realCargoId: undefined
                        }));
                        setIsSuggesting(false);
                    }
                },
                onNewRequest: onNewRequestRealCargoNames,
                filter: __WEBPACK_IMPORTED_MODULE_5_material_ui__["a" /* AutoComplete */].noFilter,
                listStyle: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].autoCompleteListStyle,
                popoverProps: {
                    canAutoPosition: true,
                    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                    targetOrigin: { horizontal: 'left', vertical: 'top' }
                },
                containerStyle: {
                    width: '100%',
                    position: 'relative'
                },
                inputStyle: {
                    paddingRight: '30px'
                },
                value: realCargoName,
                clearValue: !!realCargoName,
                onClear: function onClear() {
                    setRealCargoName('');
                    setItem(_extends({}, item, {
                        realCargoName: '',
                        realCargoId: undefined,
                        CargoCategory: undefined,
                        CargoCategoryName: undefined,
                        details: undefined,
                        isUpdate: Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* checkIfUpdateGazetter */])(_extends({}, item, { realCargoName: '' }), cargoTypes),
                        isSuggest: false
                    }));
                    setIsSuggesting(false);
                },
                style: { width: '100%' }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            {
                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS,
                className: isSuggesting ? 'highlightedColumn' : ''
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["a" /* AutoComplete */], {
                textFieldStyle: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].autoCompleteCSS,
                hintText: 'Cargo type',
                searchText: item.CargoCategoryName || '',
                dataSource: cargoCategoryNames,
                dataSourceConfig: { text: 'name', value: 'item' },
                onUpdateInput: onUpdateInputCargoType,
                onNewRequest: onNewRequestCargoTypes,
                filter: __WEBPACK_IMPORTED_MODULE_5_material_ui__["a" /* AutoComplete */].caseInsensitiveFilter,
                listStyle: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].autoCompleteListStyle,
                popoverProps: {
                    canAutoPosition: true
                },
                disabled: !!item.realCargoId,
                underlineDisabledStyle: { borderBottom: '1px solid rgba(0,0,0,0.1)' }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS },
            __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(item, 'lastModify.date') ? new Date(item.lastModify.date).toLocaleString() : ''
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            {
                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui__["s" /* SelectField */],
                {
                    style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].selectFieldCSS,
                    value: item.details,
                    onChange: function onChange(_e, _i, v) {
                        return handleChangeDetail(v);
                    },
                    maxHeight: 200,
                    autoWidth: true,
                    disabled: !!item.realCargoId,
                    underlineDisabledStyle: { borderBottom: '1px solid rgba(0,0,0,0.1)' }
                },
                [].concat(_toConsumableArray(new Array(15))).map(function (_un, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["m" /* MenuItem */], { key: 'details-' + i, style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].menuItemCSS, value: i + 1, primaryText: i + 1 });
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS },
            __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.has(item, 'lastModify.user.email') ? item.lastModify.user.email : ''
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: item.isUpdate || item.isSuggest ? 'update-item' : 'hidden update-item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], { label: 'Update', primary: true, onClick: handleUpdateAssigner })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS, { width: '48px' }) },
            item.realCargoId && !item.isUpdate ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui__["h" /* IconButton */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_content_create___default.a, {
                    onClick: function onClick() {
                        return setIsModifyDialogOpen(!isModifyDialogOpen);
                    },
                    color: '#eaeaea',
                    hoverColor: '#00BCD4'
                })
            ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS, { width: '48px' }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui__["h" /* IconButton */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_delete___default.a, {
                    onClick: function onClick() {
                        return props.removeGazetter(item._id);
                    },
                    color: '#eaeaea',
                    hoverColor: 'red'
                })
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var cargoTypes = state.cargoTypes;
    var item = ownProps.item;


    return {
        cargoTypes: cargoTypes,
        item: item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateCargoAssigner: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_assigners__["d" /* updateCargoAssigner */],
        saveStatusCargoAssigner: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_assigners__["c" /* saveStatusCargoAssigner */],
        addNotification: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(CargoEditorRow));

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * item
 * @typedef {Object} Item
 * @property {string} _id
 * @property {number} details
 * @property {string} value
 * @property {string} [realCargoId]
 * @property {string} realCargoName
 * @property {boolean} [isUpdate]
 * @property {boolean} [isSuggest]
 * @property {string} CargoCategory
 * @property {string} CargoCategoryName
 * @property {string} [lastModify.date]
 * @property {string} [lastModify.user.email]
 */

/**
 * @typedef {Object} SuggestedCargoData
 * @property {string} realCargoName - The suggested real cargo name
 * @property {string} realCargoId - The unique ID of the suggested cargo in the database
 * @property {number} details - The details level for the cargo (1-15)
 * @property {string} CargoCategory - The unique ID of the cargo category
 * @property {string} CargoCategoryName - The human-readable name of the cargo category
 */

/** 
 * @typedef {Object} CargoNameMatch
 * @property {string} query
 * @property {string} match
 * @property {number} score
 * @property {number} details
 * @property {string} cargoType
 * @property {SuggestedCargoData} suggestedCargo
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AutoCompleteWithClear, 'AutoCompleteWithClear', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorRow.jsx');
    reactHotLoader.register(CargoEditorRow, 'CargoEditorRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorRow.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/CargoEditorRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_common_RealCargoNameAutoComplete__ = __webpack_require__(3270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_common_CargoCategoryAutoComplete__ = __webpack_require__(3271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UpdateRealCargoGazTable__ = __webpack_require__(3272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













/**
 * 
 * @param {{
 *  open: boolean, 
 *  handleCloseDialog: Function, 
 *  item: import('./CargoEditorRow').Item,
 *  cargoTypes: any[],
 *  updateRowsRealCargoData: Function,
 * }} props 
 */
function UpdateRealCargoDialog(_ref) {
    var addNotification = _ref.addNotification,
        props = _objectWithoutProperties(_ref, ['addNotification']);

    var open = props.open,
        handleCloseDialog = props.handleCloseDialog,
        item = props.item,
        cargoTypes = props.cargoTypes;

    /**
     * @type {[RealCargo, React.Dispatch<RealCargo>]} state
     */

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])( /**@type {RealCargo} */{}),
        _useState2 = _slicedToArray(_useState, 2),
        realCargo = _useState2[0],
        setRealCargo = _useState2[1];

    /**
     * get real cargo data with gazetters
     * @param {string} realCargoId 
     */


    var getRealCargo = function getRealCargo(realCargoId) {
        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].getRealCargoNameWithGaz(realCargoId).then(function (response) {
            setRealCargo(_extends({}, response.data, {
                isUpdate: false
            }));
        });
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getRealCargo(item.realCargoId);
    }, []);

    var handleChangeDetail = function handleChangeDetail(value) {
        setRealCargo(_extends({}, realCargo, {
            details: value,
            isUpdate: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* checkIfUpdate */])(realCargo, cargoTypes)
        }));
    };

    var updateItem = function updateItem(updatedItem) {
        setRealCargo(_extends({}, updatedItem, {
            isUpdate: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* checkIfUpdate */])(updatedItem, cargoTypes)
        }));
    };

    var handleUpdateRealCargo = function handleUpdateRealCargo() {
        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].updateCargoRealName(realCargo).then(function (response) {
            if (response.status === 200) {
                addNotification({
                    title: 'Success',
                    message: 'Real cargo and gazetters updated successfully.',
                    level: 'success',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 10
                });
                getRealCargo(realCargo._id);
                props.updateRowsRealCargoData(realCargo);
            } else {
                addNotification({
                    title: 'Error',
                    message: 'Failed to upload real cargo',
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 20
                });
            }
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
        {
            open: open,
            contentStyle: { maxWidth: '1100px' },
            actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    return handleCloseDialog();
                }
            })],
            title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { display: 'flex' } },
                    'EDIT REAL CARGO NAME'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: '13px' } },
                    '\u201CCargo type\u201D and \u201CDetails\u201D changes will update all the same Cargo Real Names: ',
                    realCargo.name
                )
            )
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                style: { display: 'flex', gap: '24px', maxWidth: '1100px' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_common_RealCargoNameAutoComplete__["a" /* default */], {
                item: realCargo,
                cargoTypes: cargoTypes,
                _preventFirstSearch: true,
                updateItem: updateItem,
                isAutoComplete: false
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_common_CargoCategoryAutoComplete__["a" /* default */], {
                item: realCargo,
                cargoTypes: cargoTypes,
                updateItem: updateItem
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                {
                    style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].selectFieldCSS, { width: '72px' }),
                    value: realCargo.details,
                    labelStyle: { overflow: 'unset', fontSize: '16px' },
                    onChange: function onChange(_e, _i, v) {
                        return handleChangeDetail(v);
                    },
                    maxHeight: 200,
                    autoWidth: true,
                    floatingLabelText: 'Details',
                    iconStyle: { width: '24px', height: '24px' },
                    underlineDisabledStyle: { borderBottom: '1px solid rgba(0,0,0,0.1)' }
                },
                [].concat(_toConsumableArray(new Array(15))).map(function (_un, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], { key: 'details-' + i, style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: i + 1, primaryText: i + 1 });
                })
            ),
            realCargo.isUpdate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                label: 'update',
                onClick: handleUpdateRealCargo,
                style: {
                    alignSelf: 'center',
                    marginTop: '20px'
                },
                primary: true
            })
        ),
        realCargo._id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__UpdateRealCargoGazTable__["a" /* default */], {
            gazetters: realCargo.gazetters || []
        })
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(UpdateRealCargoDialog);

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * @typedef RealCargo
 * @property {string} _id
 * @property {string} [name]
 * @property {number} [details]
 * @property {Parent} [parent]
 * @property {[Gazetter] | []} gazetters
 * @property {boolean} [isUpdate]
 */

/**
 * @typedef Parent
 * @property {{ _id?: string, name?: string }} red
*/

/**
 * @typedef Gazetter
 * @property {string} _id
 * @property {string} value
 * @property {string} CargoCategory
 * @property {string} CargoCategoryName
 * @property {number} details
 * @property {string} realCargoId
 * @property {string} realCargoName
*/

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(UpdateRealCargoDialog, 'UpdateRealCargoDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/UpdateRealCargoDialog.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/UpdateRealCargoDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = RealCargoNameAutoComplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * 
 * @param {Props} props 
 */
function RealCargoNameAutoComplete(_ref) {
    var cargoTypes = _ref.cargoTypes,
        saveStatusCargoAssigner = _ref.saveStatusCargoAssigner,
        _ref$_preventFirstSea = _ref._preventFirstSearch,
        _preventFirstSearch = _ref$_preventFirstSea === undefined ? true : _ref$_preventFirstSea,
        props = _objectWithoutProperties(_ref, ['cargoTypes', 'saveStatusCargoAssigner', '_preventFirstSearch']);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        realCargoNames = _useState2[0],
        setRealCargoNames = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.item),
        _useState4 = _slicedToArray(_useState3, 2),
        item = _useState4[0],
        setItem = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_preventFirstSearch),
        _useState6 = _slicedToArray(_useState5, 2),
        preventFirstSearch = _useState6[0],
        setPreventFirstSearch = _useState6[1];

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_5_helpers_useDebounce__["a" /* default */])(item.name, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].getCargoNamesAutocomplete(debouncedSearchValue).then(function (response) {
            var _realCargoNames = response.data.data.map(function (realCargoName) {
                return {
                    name: realCargoName.name,
                    item: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], {
                        value: realCargoName,
                        primaryText: realCargoName.name,
                        secondaryText: ['admin', 'moderator'].includes(realCargoName.addedByRole) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_settings___default.a, {
                            style: {
                                position: 'absolute',
                                left: -10,
                                marginTop: '11px',
                                color: '#9E9E9E'
                            }
                        }),
                        style: { paddingLeft: '25px' }
                    })
                };
            });

            setRealCargoNames(_realCargoNames);
            document.body.scrollTop += 1;
            document.body.scrollTop -= 1;
        }).catch(function () {
            return null;
        });
    }, [debouncedSearchValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPreventFirstSearch(!_preventFirstSearch);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setItem(props.item);
    }, [props.item]);

    var onUpdateInputCargoName = function onUpdateInputCargoName(searchText) {
        props.updateItem(_extends({}, item, {
            name: searchText,
            isUpdate: _extends({}, item, { name: searchText })
            // _id: undefined, // if we set _id to undefined then we will not update existing cargo
        }));
    };

    var onNewRequestRealCargoNames = function onNewRequestRealCargoNames(updateProperties) {
        if (!updateProperties) {
            return;
        }

        var _item = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(item);

        if (updateProperties.item.props.value.parent) {
            cargoTypes.forEach(function (cargoType) {
                if (updateProperties.item.props.value.parent.red._id === cargoType._id) {
                    _item.parent.red._id = cargoType._id;
                    _item.parent.red.name = cargoType.name;
                }
            });
        }

        _item.name = updateProperties.name;
        _item._id = updateProperties.item.props.value._id;
        _item.details = updateProperties.item.props.value.details;
        _item.isUpdate = true;

        props.updateItem(_item);
        setRealCargoNames([]);
        saveStatusCargoAssigner && saveStatusCargoAssigner(_item);
    };

    var inputCargoName = function inputCargoName(value) {
        var _item = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(item);

        _item.name = value;

        props.updateItem(_item);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        props.isAutoComplete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["a" /* AutoComplete */], {
            textFieldStyle: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].autoCompleteCSS,
            hintText: 'Real cargo name',
            floatingLabelText: 'Real cargo name',
            searchText: item.name || '',
            dataSource: realCargoNames,
            dataSourceConfig: { text: 'name', value: 'item' },
            onUpdateInput: onUpdateInputCargoName,
            onNewRequest: onNewRequestRealCargoNames,
            filter: __WEBPACK_IMPORTED_MODULE_2_material_ui__["a" /* AutoComplete */].noFilter,
            listStyle: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].autoCompleteListStyle,
            inputStyle: { fontSize: '16px' },
            disabled: true,
            popoverProps: {
                canAutoPosition: true,
                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                targetOrigin: { horizontal: 'left', vertical: 'top' }
            }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["A" /* TextField */], {
            value: item.name || '',
            hintText: 'Real cargo name',
            floatingLabelText: 'Real cargo name',
            onChange: function onChange(e) {
                return inputCargoName(e.target.value);
            },
            style: { fontSize: '16px' }
        })
    );
}

/**
 * props
 * @typedef {Object} Props
 * @property {import('../Cargoes/Assigners/UpdateRealCargoDialog.jsx').RealCargo} item
 * @property {any} cargoTypes
 * @property {Function} [saveStatusCargoAssigner]
 * @property {boolean} _preventFirstSearch
 * @property {Function} updateItem
 * @property {boolean} isAutoComplete
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RealCargoNameAutoComplete, 'RealCargoNameAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/common/RealCargoNameAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = CargoCategoryAutoComplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Cargoes_Assigners_utils__ = __webpack_require__(565);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







/**
 * 
 * @param {Props} props 
 */
function CargoCategoryAutoComplete(_ref) {
    var cargoTypes = _ref.cargoTypes,
        saveStatusCargoAssigner = _ref.saveStatusCargoAssigner,
        _ref$underlineDisable = _ref.underlineDisabledStyle,
        underlineDisabledStyle = _ref$underlineDisable === undefined ? {} : _ref$underlineDisable,
        disabled = _ref.disabled,
        props = _objectWithoutProperties(_ref, ['cargoTypes', 'saveStatusCargoAssigner', 'underlineDisabledStyle', 'disabled']);

    var _cargoCategoryNames = cargoTypes.map(function (item) {
        return {
            name: item.name,
            item: item
        };
    });

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.item),
        _useState2 = _slicedToArray(_useState, 2),
        item = _useState2[0],
        setItem = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_cargoCategoryNames),
        _useState4 = _slicedToArray(_useState3, 1),
        cargoCategoryNames = _useState4[0];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setItem(props.item);
    }, [props.item]);

    var onUpdateInputCargoType = function onUpdateInputCargoType(searchText) {
        var _item = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(item);
        _item.parent.red.name = searchText;

        _item.isUpdate = Object(__WEBPACK_IMPORTED_MODULE_4_components_Cargoes_Assigners_utils__["a" /* checkIfUpdate */])(item, cargoTypes);

        props.updateItem(_item);

        saveStatusCargoAssigner && saveStatusCargoAssigner(_item);
    };

    var onNewRequestCargoTypes = function onNewRequestCargoTypes(updateProperties) {
        if (!updateProperties.name) {
            return;
        }

        var _item = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(item);

        _item.isUpdate = false;

        _item.parent.red.name = updateProperties.name;
        _item.parent.red._id = updateProperties.item._id;
        _item.details = updateProperties.item.details;

        if (_item.name && _item.name.length >= 3) {
            _item.isUpdate = true;
        }

        props.updateItem(_item);

        saveStatusCargoAssigner && saveStatusCargoAssigner(_item);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */], {
        textFieldStyle: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].autoCompleteCSS,
        hintText: 'Cargo type',
        floatingLabelText: 'Cargo type',
        searchText: item && item.parent ? item.parent.red.name : '',
        dataSource: cargoCategoryNames,
        dataSourceConfig: { text: 'name', value: 'item' },
        onUpdateInput: onUpdateInputCargoType,
        onNewRequest: onNewRequestCargoTypes,
        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */].caseInsensitiveFilter,
        listStyle: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].autoCompleteListStyle,
        inputStyle: { fontSize: '16px' },
        popoverProps: {
            canAutoPosition: true
        },
        disabled: !!disabled,
        underlineDisabledStyle: _extends({}, underlineDisabledStyle)
    });
}

/**
 * props
 * @typedef {Object} Props
 * @property {import('../Cargoes/Assigners/UpdateRealCargoDialog').RealCargo} item
 * @property {any} cargoTypes
 * @property {any} [underlineDisabledStyle]
 * @property {Function} [saveStatusCargoAssigner]
 * @property {boolean} [disabled]
 * @property {Function} updateItem
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoCategoryAutoComplete, 'CargoCategoryAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/common/CargoCategoryAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = UpdateRealCargoGazTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




/** @type {Record<string, import('react').CSSProperties>} */
var styles = {
    headRow: { height: '35px', display: 'block', borderBottom: '1px solid #000' },
    headRowCol: {
        height: '35px', width: '234px', padding: 0, fontSize: '12px', color: 'rgba(0, 0, 0, 0.60)'
    },
    body: {
        maxHeight: '400px', overflowX: 'hidden', overflowY: 'auto'
    },
    bodyRow: { display: 'flex', height: '46px', borderBottom: '1px solid #000' },
    bodyRowCol: {
        height: '46px', width: '234px', padding: '11px 0', color: 'rgba(0, 0, 0, 0.60)'
    }
};

/**
 * 
 * @param {Props} props 
 */
function UpdateRealCargoGazTable(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
        { selectable: false, bodyStyle: styles.body },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui__["w" /* TableHeader */],
            {
                displaySelectAll: false,
                adjustForCheckbox: false
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                { style: styles.headRow },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                    { style: styles.headRowCol },
                    'CargoName'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                    { style: styles.headRowCol },
                    'Cargo Real Name'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                    { style: styles.headRowCol },
                    'Cargo type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                    { style: styles.headRowCol },
                    'Details'
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
            {
                displayRowCheckbox: false
            },
            props.gazetters.map(function (gazetter) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                    {
                        key: gazetter._id,
                        style: styles.bodyRow
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: styles.bodyRowCol },
                        gazetter.value
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: styles.bodyRowCol },
                        gazetter.realCargoName
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: styles.bodyRowCol },
                        gazetter.CargoCategoryName
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: styles.bodyRowCol },
                        gazetter.details
                    )
                );
            })
        )
    );
}

/**
 * @typedef Props
 * @property {import('./UpdateRealCargoDialog').Gazetter[]} gazetters
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/UpdateRealCargoGazTable.jsx');
    reactHotLoader.register(UpdateRealCargoGazTable, 'UpdateRealCargoGazTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Assigners/UpdateRealCargoGazTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3273 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128613
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RealNamesTable__ = __webpack_require__(955);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function RealNamesPage(props) {
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        props.getCargoTypes();
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'cargo-realnames', className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container', style: { width: '84rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'real cargo names'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RealNamesTable__["c" /* default */], null)
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCargoTypes: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_types__["a" /* getCargoTypes */]
    }, dispatch);
})(RealNamesPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RealNamesPage, 'RealNamesPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesPage.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesPage.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCargoTagsCategories;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCargoTagsCategories() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_19" /* GET_CARGO_TAGS_CATEGORIES */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCargoTagsCategories, 'getCargoTagsCategories', '/opt/atlassian/pipelines/agent/build/client/app/actions/cargoes/tags.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Tabs__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_notifications_notifications__ = __webpack_require__(41);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












function AddTagsModal(_ref) {
    var _this = this;

    var manageTagsModalOpen = _ref.manageTagsModalOpen,
        handleToggleManageTags = _ref.handleToggleManageTags,
        addNotification = _ref.addNotification,
        getCategories = _ref.getCategories,
        initialTagsCategories = _ref.initialTagsCategories;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState2 = _slicedToArray(_useState, 2),
        category = _useState2[0],
        setCategory = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState4 = _slicedToArray(_useState3, 2),
        selectedCategory = _useState4[0],
        setSelectedCategory = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState6 = _slicedToArray(_useState5, 2),
        description = _useState6[0],
        setDescription = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState8 = _slicedToArray(_useState7, 2),
        tag = _useState8[0],
        setTag = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState10 = _slicedToArray(_useState9, 2),
        isSending = _useState10[0],
        setIsSending = _useState10[1];

    var isMounted = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        return function () {
            isMounted.current = false;
        };
    }, []);

    var onChangeCategory = function onChangeCategory(value) {
        setCategory(value);
    };

    var onChangeDesciption = function onChangeDesciption(value) {
        setDescription(value);
    };

    var onChangeTag = function onChangeTag(value) {
        setTag(value);
    };

    var onSelectCategory = function onSelectCategory(value) {
        setSelectedCategory(value);
    };

    var addCategory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_category, _description) {
            var response;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!isSending) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', false);

                        case 2:

                            setIsSending(true);

                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].addTagsCategories(_category, _description);

                        case 5:
                            response = _context.sent;


                            if (response.errors) {
                                addNotification({
                                    title: 'Error',
                                    message: response.errors[0].message || response.errors[0].messages[0],
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                            } else {
                                addNotification({
                                    title: 'Successful creation',
                                    message: 'Category created!',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                                getCategories();
                                setCategory('');
                                setDescription('');
                            }

                            setIsSending(false);

                            if (isMounted.current) {
                                setIsSending(false);
                            }

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }(), [isSending]);

    var addTag = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_tag, _selectedCategory) {
            var response;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!isSending) {
                                _context2.next = 2;
                                break;
                            }

                            return _context2.abrupt('return', false);

                        case 2:

                            setIsSending(true);

                            if (!(!_tag || !_selectedCategory)) {
                                _context2.next = 7;
                                break;
                            }

                            addNotification({
                                title: 'Error',
                                message: 'Tag name and category must be specified!',
                                level: 'error',
                                _id: new Date().getMilliseconds(),
                                autoDismiss: 3
                            });
                            setIsSending(false);
                            return _context2.abrupt('return');

                        case 7:
                            _context2.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].addTag(_tag, _selectedCategory.value);

                        case 9:
                            response = _context2.sent;


                            if (response.errors && response.errors.length) {
                                console.log(response);
                            } else {
                                addNotification({
                                    title: 'Successful creation',
                                    message: 'Tag created!',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                                setSelectedCategory('');
                                setTag('');
                            }

                            if (isMounted.current) {
                                setIsSending(false);
                            }

                            setIsSending(false);

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x3, _x4) {
            return _ref3.apply(this, arguments);
        };
    }(), [isSending]);

    var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["g" /* FlatButton */], {
        label: 'Cancel',
        primary: true,
        onClick: function onClick() {
            handleToggleManageTags();
        }
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Dialog___default.a,
            {
                open: manageTagsModalOpen,
                actions: actions,
                onRequestClose: handleToggleManageTags
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Tabs__["Tabs"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Tabs__["Tab"],
                    { label: 'Add Category' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["A" /* TextField */], {
                                floatingLabelText: 'Add Category',
                                value: category || '',
                                onChange: function onChange(e) {
                                    return onChangeCategory(e.target.value);
                                },
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["A" /* TextField */], {
                                floatingLabelText: 'Category Description',
                                value: description || '',
                                onChange: function onChange(e) {
                                    return onChangeDesciption(e.target.value);
                                },
                                multiLine: true,
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4', style: { margin: 'auto', textAlign: 'center' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                                onClick: function onClick() {
                                    return addCategory(category, description);
                                },
                                label: 'Add',
                                primary: true,
                                disabled: isSending
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Tabs__["Tab"],
                    { label: 'Add Tag' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["A" /* TextField */], {
                                floatingLabelText: 'Add Tag',
                                value: tag || '',
                                onChange: function onChange(e) {
                                    return onChangeTag(e.target.value);
                                },
                                errorText: !tag && 'Tag name required',
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui__["s" /* SelectField */],
                                {
                                    floatingLabelText: 'Select Category',
                                    value: selectedCategory,
                                    onChange: function onChange(_e, _i, value) {
                                        return onSelectCategory(value);
                                    },
                                    maxHeight: 300,
                                    errorText: tag && !selectedCategory && 'Select tag category'
                                },
                                initialTagsCategories.map(function (cat, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], {
                                        key: 'tagCategory_' + index,
                                        value: cat,
                                        primaryText: __WEBPACK_IMPORTED_MODULE_1_lodash__["capitalize"](cat.value)
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4', style: { margin: 'auto', textAlign: 'center' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                                onClick: function onClick() {
                                    return addTag(tag, selectedCategory);
                                },
                                label: 'Add',
                                primary: true,
                                disabled: !tag || isSending
                            })
                        )
                    )
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_8_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(AddTagsModal);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AddTagsModal, 'AddTagsModal', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/AddTagsModal.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/AddTagsModal.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_realNames__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalEditRow__ = __webpack_require__(3278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_check_circle__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_check_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_check_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tags__ = __webpack_require__(3280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RealNamesTable__ = __webpack_require__(955);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();














/**
 * @param {RealNamesRowProps} prop0
 * @returns 
 */
function RealNamesRow(_ref) {
    var _item = _ref.item,
        SEARATES_CATEGORIES = _ref.SEARATES_CATEGORIES,
        cargoTypes = _ref.cargoTypes,
        deleteCargoRealName = _ref.deleteCargoRealName,
        updateCargoRealName = _ref.updateCargoRealName,
        saveStatusCargoRealName = _ref.saveStatusCargoRealName;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isModalEditOpened = _useState2[0],
        setIsModalEditOpened = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        openDeleteDialog = _useState4[0],
        setOpenDeleteDialog = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState6 = _slicedToArray(_useState5, 2),
        textDialog = _useState6[0],
        setTextDialog = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_item),
        _useState8 = _slicedToArray(_useState7, 2),
        item = _useState8[0],
        setItem = _useState8[1];

    var isCargoesFromUsers = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__RealNamesTable__["b" /* IsCargoesFromUsersContext */]);
    var handleToggleConvertDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__RealNamesTable__["a" /* HandleToggleConvertDialogContext */]);

    var handleCancelDelete = function handleCancelDelete() {
        setOpenDeleteDialog(!openDeleteDialog);
        setTextDialog('');
    };

    var toggleModalEdit = function toggleModalEdit() {
        setIsModalEditOpened(!isModalEditOpened);
    };

    var handleDeleteItem = function handleDeleteItem() {
        setOpenDeleteDialog(false);
        setTextDialog('');

        deleteCargoRealName(item);
    };

    var checkIfUpdate = function checkIfUpdate(itemToCheck) {
        if (itemToCheck.name === '') {
            return false;
        }

        var isChecked = cargoTypes.find(function (cargoType) {
            if (itemToCheck.parent.red) {
                return itemToCheck.parent.red.name === cargoType.name;
            }

            return true;
        });

        return !!isChecked;
    };

    var inputCargoName = function inputCargoName(value) {
        var clonedItem = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);

        clonedItem.name = value;
        clonedItem.isUpdate = checkIfUpdate(item);

        setItem(clonedItem);
    };

    var blurCargoName = function blurCargoName() {
        saveStatusCargoRealName(item);
    };

    var handleChangeCargoType = function handleChangeCargoType(itemName) {
        var clonedItem = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);
        var newCargoType = cargoTypes.filter(function (cargoName) {
            return cargoName.name === itemName;
        });

        if (clonedItem.parent.red) {
            clonedItem.parent.red.name = newCargoType[0].name;
            clonedItem.parent.red._id = newCargoType[0]._id;
        } else {
            clonedItem.parent.red = {
                name: newCargoType[0].name,
                _id: newCargoType[0]._id
            };
        }

        clonedItem.isUpdate = checkIfUpdate(clonedItem);

        setItem(clonedItem);
        saveStatusCargoRealName(clonedItem);
    };

    var handleChangeDetail = function handleChangeDetail(value) {
        var clonedItem = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);

        clonedItem.details = value;
        clonedItem.isUpdate = checkIfUpdate(clonedItem);

        setItem(clonedItem);
        saveStatusCargoRealName(clonedItem);
    };

    var handleUpdateCargoName = function handleUpdateCargoName() {
        var clonedItem = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);
        clonedItem.isUpdate = false;

        setItem(clonedItem);
        updateCargoRealName(clonedItem);
    };

    var handleOpenDeleteDialog = function handleOpenDeleteDialog() {
        __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].checkForDeleteCargoName(item).then(function (response) {
            if (response.data.data.status === 200) {
                setOpenDeleteDialog(true);
                setTextDialog('Found ' + response.data.data.counter + ' requests.');
            }
        });
    };

    var handleChangeSf = function handleChangeSf(value) {
        var clonedItem = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(item);
        clonedItem.sf = { user: value };

        clonedItem.isUpdate = checkIfUpdate(clonedItem);

        setItem(clonedItem);
        saveStatusCargoRealName(clonedItem);
    };

    var actionsDelete = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], {
        label: 'Cancel',
        primary: true,
        onClick: handleCancelDelete
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["g" /* FlatButton */], {
        label: 'Submit',
        primary: true,
        onClick: handleDeleteItem
    })];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui__["y" /* TableRow */],
        {
            key: 'realNames_' + item._id
        },
        isModalEditOpened ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModalEditRow__["a" /* default */], {
            isDialogOpened: isModalEditOpened,
            toggleDialog: toggleModalEdit,
            data: item,
            SEARATES_CATEGORIES: SEARATES_CATEGORIES,
            key: Date.now()
        }) : null,
        openDeleteDialog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["f" /* Dialog */],
            {
                title: 'Do you want to delete?',
                actions: actionsDelete,
                modal: false,
                open: openDeleteDialog,
                onRequestClose: handleCancelDelete
            },
            textDialog
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
            {
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS, { height: '54px', width: '20%', maxWidth: 'unset'
                }),
                className: 'cargo-realnames_name_column'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["A" /* TextField */], {
                value: item.name,
                hintText: 'realCargoName',
                onChange: function onChange(e) {
                    return inputCargoName(e.target.value);
                },
                onBlur: blurCargoName,
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].textField, { width: '57%' })
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_check_circle___default.a, {
                style: { margin: '0 0 -7px 10px', display: item.hasSeaRates ? 'inline-block' : 'none' },
                color: '#00BAD1'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'btn-update hide' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                    label: 'More',
                    onClick: toggleModalEdit,
                    labelStyle: { fontSize: '11px' },
                    style: {
                        margin: '0 0 0 10px', lineHeight: '25px', height: '25px', minWidth: '62px'
                    },
                    buttonStyle: { lineHeight: '25px', height: '25px' },
                    primary: true
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS, { width: '20%', maxWidth: 'unset' }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui__["s" /* SelectField */],
                {
                    style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].selectFieldCSS, { display: 'block' }),
                    value: item.parent.red ? item.parent.red.name : null,
                    onChange: function onChange(_e, _i, v) {
                        return handleChangeCargoType(v);
                    },
                    maxHeight: 200,
                    autoWidth: true
                },
                cargoTypes.map(function (cargoCategoryName, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], {
                        key: cargoCategoryName.name + '_' + index,
                        style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS,
                        value: cargoCategoryName.name,
                        primaryText: cargoCategoryName.name
                    });
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS, { width: '10%', maxWidth: 'unset' }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui__["s" /* SelectField */],
                {
                    style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].selectFieldCSS, { display: 'block' }),
                    value: item.details,
                    onChange: function onChange(_e, _i, v) {
                        return handleChangeDetail(v);
                    },
                    maxHeight: 200,
                    autoWidth: true
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 1, primaryText: 1 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 2, primaryText: 2 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 3, primaryText: 3 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 4, primaryText: 4 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 5, primaryText: 5 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 6, primaryText: 6 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 7, primaryText: 7 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 8, primaryText: 8 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 9, primaryText: 9 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 10, primaryText: 10 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 11, primaryText: 11 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 12, primaryText: 12 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 13, primaryText: 13 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 14, primaryText: 14 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].menuItemCSS, value: 15, primaryText: 15 })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS, { width: '7%' }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["A" /* TextField */], {
                value: item.sf ? item.sf.user : null,
                hintText: 'SF',
                onChange: function onChange(e) {
                    return handleChangeSf(parseFloat(e.target.value));
                },
                onBlur: blurCargoName,
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].textField, { width: '57%' }),
                type: 'number'
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS, { overflow: 'unset', width: '20%', maxWidth: 'unset'
                })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Tags__["a" /* default */], {
                key: 'realNames_' + item._id + '_tag',
                cargoId: item._id,
                cargoName: item.name,
                cargoDetails: item.details,
                initialTags: item.tags || []
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS, {
                    overflow: 'unset',
                    display: 'flex',
                    gap: '10px',
                    maxWidth: 'unset',
                    height: '54px',
                    alignItems: 'center',
                    width: '23%'
                })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { visibility: item.isUpdate ? 'visible' : 'hidden' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                    label: 'Update',
                    primary: true,
                    onClick: handleUpdateCargoName
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                label: 'To admin',
                backgroundColor: '#F8BF50',
                labelStyle: { padding: '0 6px' },
                onClick: function onClick() {
                    return handleToggleConvertDialog(item._id);
                },
                style: {
                    visibility: isCargoesFromUsers ? 'visible' : 'hidden'
                }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["r" /* RaisedButton */], {
                label: 'Delete',
                secondary: true,
                onClick: handleOpenDeleteDialog
            })
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        deleteCargoRealName: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_realNames__["a" /* deleteCargoRealName */],
        updateCargoRealName: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_realNames__["d" /* updateCargoRealName */],
        saveStatusCargoRealName: __WEBPACK_IMPORTED_MODULE_3_actions_cargoes_realNames__["c" /* saveStatusCargoRealName */]
    }, dispatch);
})(RealNamesRow));

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * item
 * @typedef {Object} RealNamesItemProps
 * @property {string} name 
 * @property {string} _id
 * @property {any[]} tags
 * @property {number} details
 * @property {boolean} isUpdate
 * @property {{ user: number }} [sf]
 */

/**
 * props
 * @typedef {Object} RealNamesRowProps
 * @property {RealNamesItemProps} item 
 * @property {any[]} SEARATES_CATEGORIES
 * @property {any[]} cargoTypes
 * @property {Function} deleteCargoRealName
 * @property {Function} updateCargoRealName
 * @property {Function} saveStatusCargoRealName
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RealNamesRow, 'RealNamesRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesRow.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/RealNamesRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FontIcon__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_FontIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_FontIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var ModalEditRow = function (_Component) {
    _inherits(ModalEditRow, _Component);

    function ModalEditRow() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, ModalEditRow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalEditRow.__proto__ || Object.getPrototypeOf(ModalEditRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: _extends({
                type: [],
                sf: '',
                seaRatesCategories: [],
                cargoMaxVolume: 0,
                cargoMaxWeight: 0
            }, _this.props.data),
            errors: {},
            values: [],
            vesselType: ['bulk', 'bulktank', 'car', 'cont', 'livestock', 'mpp', 'pass', 'passcar', 'reefer', 'tank'],
            searchQuery: '',
            error: ''
        }, _this.searchCategories = function (cats, text) {
            var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var parentName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
            var parentNode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (cats || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var cat = _step.value;

                    if (~cat.title.toLowerCase().trim().indexOf(text.toLowerCase().trim())) {
                        result.push({
                            title: '' + (parentName ? parentName + ' / ' : '') + cat.title,
                            value: parentNode.concat([cat])
                        });
                    }
                    if (cat.childCategories && cat.childCategories.length) {
                        var res = _this.searchCategories(cat.childCategories, text, result, '' + (parentName ? parentName + ' / ' : '') + cat.title, parentNode.concat([cat]));
                        result.concat(res);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return result;
        }, _this.prepareSeaRatesCategories = function () {
            var cats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var constCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

            if (!cats.length || i === cats.length) {
                return result;
            }

            var finded = constCategories.find(function (c) {
                return c.id === cats[i].id;
            });
            return !finded ? result : _this.prepareSeaRatesCategories(cats, ++i, finded.childCategories || [], result.concat([finded]));
        }, _this.handleChange = function () {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'type';
            var value = arguments[1];
            return _this.setState({
                data: _extends({}, _this.state.data, _defineProperty({}, key, value)),
                errors: {},
                error: ''
            });
        }, _this.handleSearch = function (value) {
            _this.setState({ searchQuery: value });
        }, _this.handleChangeNumber = function () {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sf';
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            var dots = 0;
            value = value.replace(/[^\d|\.|-]/, '').replace(/\./g, function () {
                return dots++ > 0 ? '' : '.';
            }).replace(/\-/g, function (match, str) {
                return str === 0 ? '-' : '';
            });

            _this.setState({
                data: _extends({}, _this.state.data, _defineProperty({}, key, value)),
                errors: _extends({}, _this.state.errors, _defineProperty({}, key, value && !isNaN(parseFloat(value)) ? '' : 'required')),
                error: ''
            });
        }, _this.renderCategiryPicker = function () {
            var _this$state$data$seaR = _this.state.data.seaRatesCategories,
                seaRatesCategories = _this$state$data$seaR === undefined ? [] : _this$state$data$seaR;

            return seaRatesCategories.map(function (cat, i) {
                return cat.childCategories && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
                        {
                            key: 'add-cat-' + cat.id,
                            hintText: 'Select category',
                            floatingLabelText: 'Select category',
                            value: seaRatesCategories[i + 1] || {},
                            onChange: function onChange(event, index, value) {
                                _this.handleChange('seaRatesCategories', seaRatesCategories.slice(0, i + 1).concat([value]));
                            },
                            fullWidth: true
                        },
                        cat.childCategories.map(function (catChild) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default.a, {
                                key: catChild.id,
                                value: catChild,
                                primaryText: catChild.title
                            });
                        })
                    ),
                    seaRatesCategories[i + 1] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: 'text-click-remove',
                            onClick: function onClick() {
                                return _this.handleChange('seaRatesCategories', seaRatesCategories.slice(0, i + 1));
                            }
                        },
                        seaRatesCategories[i + 1].title,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_FontIcon___default.a,
                            { className: 'material-icons', color: __WEBPACK_IMPORTED_MODULE_9_material_ui_styles_colors__["red500"] },
                            'close'
                        )
                    )
                );
            });
        }, _this.submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _this$state, _this$state$data, _this$state$data$type, type, _this$state$data$sf, sf, _this$state$data$seaR2, seaRatesCategories, _this$state$data$carg, cargoMaxVolume, _this$state$data$carg2, cargoMaxWeight, errors, item, data, result;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this$state = _this.state, _this$state$data = _this$state.data, _this$state$data$type = _this$state$data.type, type = _this$state$data$type === undefined ? [] : _this$state$data$type, _this$state$data$sf = _this$state$data.sf, sf = _this$state$data$sf === undefined ? '' : _this$state$data$sf, _this$state$data$seaR2 = _this$state$data.seaRatesCategories, seaRatesCategories = _this$state$data$seaR2 === undefined ? [] : _this$state$data$seaR2, _this$state$data$carg = _this$state$data.cargoMaxVolume, cargoMaxVolume = _this$state$data$carg === undefined ? '' : _this$state$data$carg, _this$state$data$carg2 = _this$state$data.cargoMaxWeight, cargoMaxWeight = _this$state$data$carg2 === undefined ? '' : _this$state$data$carg2, errors = _this$state.errors;
                            item = _this.props.data;

                            if (!Object.keys(errors).reduce(function (res, key) {
                                return errors[key] ? true : res;
                            }, false)) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])('There is an error. Check out inputs', 'error'));

                        case 4:
                            data = {
                                vesselTypes: type,
                                sf: +sf || 0,
                                cargoMaxVolume: +cargoMaxVolume || 0,
                                cargoMaxWeight: +cargoMaxWeight || 0,
                                seaRatesCategories: seaRatesCategories.map(function (c) {
                                    return { title: c.title, id: c.id };
                                })
                            };
                            _context.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].updateRealAdditionalInfo(item._id, data);

                        case 7:
                            result = _context.sent;

                            if (!(result.status === 200)) {
                                _context.next = 11;
                                break;
                            }

                            Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])('Success');
                            return _context.abrupt('return', _this.props.toggleDialog());

                        case 11:

                            _this.setState(_extends({}, Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["b" /* getNormalErrors */])(result)));
                            Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])(_this.state.error, 'error');

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        })), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ModalEditRow, [{
        key: 'componentDidMount',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _props, data, isDialogOpened, res;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _props = this.props, data = _props.data, isDialogOpened = _props.isDialogOpened;

                                if (!isDialogOpened) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].getOneCargoByRealCargoId(data._id);

                            case 4:
                                res = _context2.sent;

                                if (res.status === 200) {
                                    if (!res.data.hasOwnProperty('_id')) {
                                        Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])('Cargo real name does not have assigned cargo names', 'error');
                                    } else {
                                        this.setState({
                                            data: _extends({}, this.state.data, {
                                                type: res.data.vesselTypes,
                                                sf: res.data.sf,
                                                cargoMaxVolume: res.data.cargoMaxVolume,
                                                cargoMaxWeight: res.data.cargoMaxWeight,
                                                seaRatesCategories: this.prepareSeaRatesCategories(res.data.seaRatesCategories, 0, this.props.SEARATES_CATEGORIES)
                                            })
                                        });
                                    }
                                }

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentDidMount() {
                return _ref3.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                toggleDialog = _props2.toggleDialog,
                isDialogOpened = _props2.isDialogOpened,
                _props2$SEARATES_CATE = _props2.SEARATES_CATEGORIES,
                SEARATES_CATEGORIES = _props2$SEARATES_CATE === undefined ? [] : _props2$SEARATES_CATE;
            var _state = this.state,
                _state$data = _state.data,
                _state$data$type = _state$data.type,
                type = _state$data$type === undefined ? [] : _state$data$type,
                _state$data$sf = _state$data.sf,
                sf = _state$data$sf === undefined ? '' : _state$data$sf,
                _state$data$seaRatesC = _state$data.seaRatesCategories,
                seaRatesCategories = _state$data$seaRatesC === undefined ? [] : _state$data$seaRatesC,
                _state$data$cargoMaxV = _state$data.cargoMaxVolume,
                cargoMaxVolume = _state$data$cargoMaxV === undefined ? 0 : _state$data$cargoMaxV,
                _state$data$cargoMaxW = _state$data.cargoMaxWeight,
                cargoMaxWeight = _state$data$cargoMaxW === undefined ? 0 : _state$data$cargoMaxW,
                error = _state.error,
                errors = _state.errors,
                vesselType = _state.vesselType,
                searchQuery = _state.searchQuery;

            var searatesSearchCategories = searchQuery.length > 2 ? this.searchCategories(SEARATES_CATEGORIES, searchQuery) : [];
            console.log(this.state);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Dialog___default.a,
                {
                    title: 'Edit',
                    actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton___default.a, {
                        key: 'FlatButton' + 1,
                        label: 'Ok',
                        primary: true,
                        onClick: this.submit
                    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_FlatButton___default.a, {
                        key: 'FlatButton' + 2,
                        label: 'Cancel',
                        primary: true,
                        onClick: toggleDialog
                    })],
                    open: isDialogOpened,
                    contentStyle: {
                        width: '80%'
                    },
                    autoScrollBodyContent: true,
                    modal: true
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    { className: 'm-b-0' },
                    'Choose vessel types'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
                    {
                        multiple: true,
                        hintText: 'Select vessel type',
                        value: type,
                        onChange: function onChange(event, index, values) {
                            return _this3.handleChange('type', values);
                        },
                        fullWidth: true
                    },
                    vesselType.map(function (name) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default.a, {
                            key: name,
                            insetChildren: true,
                            checked: type && type.indexOf(name) > -1,
                            value: name,
                            primaryText: name
                        });
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Vessel type: ' + (type.length ? type.join(', ') : 'None')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    { className: 'm-b-0' },
                    'SF'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                    value: sf,
                    hintText: 'SF',
                    onChange: function onChange(e, value) {
                        return _this3.handleChangeNumber('sf', value);
                    },
                    fullWidth: true,
                    errorText: errors.sf
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    { className: 'm-b-0' },
                    'Search Searates categories'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_AutoComplete___default.a, {
                    hintText: 'Name',
                    floatingLabelText: 'Name',
                    dataSource: searatesSearchCategories,
                    dataSourceConfig: { text: 'title', value: 'value' },
                    onUpdateInput: function onUpdateInput(value) {
                        return _this3.handleSearch(value);
                    },
                    onNewRequest: function onNewRequest(selected) {
                        return _this3.handleChange('seaRatesCategories', selected.value);
                    },
                    fullWidth: true,
                    filter: __WEBPACK_IMPORTED_MODULE_10_material_ui_AutoComplete___default.a.noFilter,
                    menuStyle: { maxHeight: '300px', overflowY: 'auto' }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    { className: 'm-b-0' },
                    'Searates categories'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
                    {
                        key: 'SelectField-categories',
                        hintText: 'Select category',
                        floatingLabelText: 'Select category',
                        value: seaRatesCategories && seaRatesCategories[0] || {},
                        onChange: function onChange(event, index, value) {
                            return _this3.handleChange('seaRatesCategories', [value]);
                        },
                        fullWidth: true
                    },
                    SEARATES_CATEGORIES.map(function (cat) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default.a, {
                            key: cat.id,
                            value: cat,
                            primaryText: cat.title
                        });
                    })
                ),
                seaRatesCategories && seaRatesCategories[0] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: 'text-click-remove',
                        onClick: function onClick() {
                            return _this3.handleChange('seaRatesCategories', []);
                        }
                    },
                    seaRatesCategories[0].title,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_FontIcon___default.a,
                        { className: 'material-icons', color: __WEBPACK_IMPORTED_MODULE_9_material_ui_styles_colors__["red500"] },
                        'close'
                    )
                ),
                this.renderCategiryPicker(),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    { className: 'm-b-0' },
                    'Max weight (t)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                    value: cargoMaxWeight,
                    hintText: 'Cargo max weight',
                    onChange: function onChange(e, value) {
                        return _this3.handleChangeNumber('cargoMaxWeight', value);
                    },
                    fullWidth: true,
                    errorText: errors.cargoMaxWeight
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    { className: 'm-b-0' },
                    'Max volume (m^3)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                    value: cargoMaxVolume,
                    hintText: 'Cargo max volume',
                    onChange: function onChange(e, value) {
                        return _this3.handleChangeNumber('cargoMaxVolume', value);
                    },
                    fullWidth: true,
                    errorText: errors.cargoMaxVolume
                }),
                error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'error' },
                    error
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ModalEditRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = ModalEditRow;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ModalEditRow, 'ModalEditRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/ModalEditRow.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/ModalEditRow.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3279 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(357),
    castPath = __webpack_require__(461),
    isIndex = __webpack_require__(271),
    isObject = __webpack_require__(89),
    toKey = __webpack_require__(257);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 3280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tag_autocomplete__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tag_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_tag_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_realNames__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_scss__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















var referenceTags = ['BAUXITE', 'COAL', 'COKE', 'FERTILIZERS', 'GRAINS', 'ORE', 'OTHERS', 'PETCOKE', 'SALT', 'STEELS', 'SUGAR'];
var tagMatchMap = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.fromPairs(referenceTags.map(function (t) {
    return [t.replace(/e?s$/i, ''), t];
}));
var recommendMatcher = new RegExp(referenceTags.map(function (t) {
    return '\\b' + t.replace(/e?s$/i, '') + '\\b';
}).join('|'), 'ig');

var RoroTAG = 'RORO';
var ProjectsTAG = 'PROJECTS';

var tagsByDetails = {
    1: [ProjectsTAG],
    11: [RoroTAG],
    12: [ProjectsTAG],
    13: [ProjectsTAG]
};

function findRecommendedTags(name, cargoDetails) {
    var matches = name.matchAll(recommendMatcher);

    var tags = Array.from(matches, function (m) {
        return { value: tagMatchMap[m[0].toUpperCase()], categoryName: 'cargo' };
    });

    tagsByDetails[cargoDetails] && tagsByDetails[cargoDetails].forEach(function (tagName) {
        tags.push({ value: tagName.toUpperCase(), categoryName: 'cargo' });
    });

    return tags;
}

function initializeInitialTags(initialTags, cargoName, cargoDetails) {
    var tags = [];

    initialTags.forEach(function (tag) {
        tags.push(_extends({}, tag, { saved: true }));
    });

    if (!tags.length) {
        var recommendTags = findRecommendedTags(cargoName || '', cargoDetails);

        recommendTags.forEach(function (tag) {
            tags.push(tag);
        });
    }

    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(tags, 'value');
}

function Tags(_ref) {
    var _this = this;

    var cargoId = _ref.cargoId,
        cargoName = _ref.cargoName,
        cargoDetails = _ref.cargoDetails,
        addNotification = _ref.addNotification,
        initialTags = _ref.initialTags,
        updateTagsDataInRow = _ref.updateTagsDataInRow;

    var _pureTags = initializeInitialTags(initialTags, cargoName, cargoDetails);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_pureTags),
        _useState2 = _slicedToArray(_useState, 2),
        tags = _useState2[0],
        setTags = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_pureTags),
        _useState4 = _slicedToArray(_useState3, 2),
        pureTags = _useState4[0],
        setPureTags = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        suggestions = _useState6[0],
        setSuggestions = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState8 = _slicedToArray(_useState7, 2),
        searchTag = _useState8[0],
        setSearchTag = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState10 = _slicedToArray(_useState9, 2),
        isSaving = _useState10[0],
        setIsSaving = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(tags.some(function (t) {
        return !t.saved;
    })),
        _useState12 = _slicedToArray(_useState11, 2),
        isChanged = _useState12[0],
        setIsChanged = _useState12[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        initialTags.forEach(function (tag) {
            handleAddition(_extends({}, tag, { saved: true }));
        });

        if (!initialTags.length) {
            var _tags = findRecommendedTags(cargoName || '', cargoDetails);

            _tags.forEach(function (tag) {
                handleAddition(tag);
            });
        }
    }, [initialTags]);

    var handleDelete = function handleDelete(index) {
        if (index < 0) return;

        var tagsCopy = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(tags);
        var removed = tagsCopy.splice(index, 1);
        setTags(tagsCopy);

        setIsChanged(shouldRemovedSetChanged(removed[0], tagsCopy));
    };

    var shouldRemovedSetChanged = function shouldRemovedSetChanged(removed, newTags) {
        if (!removed) return false;

        if (isChanged && (pureTags.find(function (r) {
            return r._id === removed._id;
        }) || newTags.find(function (t) {
            return !t.saved;
        }) || pureTags.length && !pureTags.some(function (t) {
            return newTags.find(function (n) {
                return n._id === t._id;
            });
        }))) return true;

        return removed.saved;
    };

    var handleAddition = function handleAddition(tag) {
        var newTags = __WEBPACK_IMPORTED_MODULE_10_immer__["b" /* produce */](tags, function (draftTags) {
            if (!draftTags.some(function (dt) {
                return dt.value === tag.value;
            })) {
                draftTags.push(tag);
            }
        });

        setTags(newTags);
        setIsChanged(newTags.some(function (t) {
            return !t.saved;
        }));
    };

    var debouncedSearchTag = Object(__WEBPACK_IMPORTED_MODULE_3_helpers_useDebounce__["a" /* default */])(searchTag, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (debouncedSearchTag && debouncedSearchTag.length > 1) {
            __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].searchTags(debouncedSearchTag, 'cargo').then(function (results) {
                setSuggestions(results);
            });
        } else {
            setSuggestions([]);
        }
    }, [debouncedSearchTag]);

    var saveTags = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cargoId, _tags) {
            var response, savedTags, resp;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!isSaving) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', false);

                        case 2:
                            updateTagsDataInRow(cargoId, _tags);
                            setIsSaving(true);

                            _context.prev = 4;
                            _context.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].saveTags(cargoId, _tags);

                        case 7:
                            response = _context.sent;
                            savedTags = __WEBPACK_IMPORTED_MODULE_10_immer__["b" /* produce */](_tags, function (draftTags) {
                                draftTags.forEach(function (t) {
                                    return t.saved = true;
                                });
                            });


                            setIsChanged(false);
                            setTags(savedTags);
                            setPureTags(savedTags);

                            addNotification({
                                title: 'Successful saving',
                                message: 'Tags saved!',
                                level: 'success',
                                autoDismiss: 3
                            });
                            _context.next = 19;
                            break;

                        case 15:
                            _context.prev = 15;
                            _context.t0 = _context['catch'](4);
                            resp = _context.t0.response.data;

                            addNotification({
                                title: 'Error',
                                message: resp.errors[0].message || resp.errors[0].messages[0],
                                level: 'error',
                                autoDismiss: 3
                            });

                        case 19:

                            setIsSaving(false);

                        case 20:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[4, 15]]);
        }));

        return function (_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }(), [setIsSaving]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '70%' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tag_autocomplete___default.a, {
                allowNew: false,
                autofocus: false,
                tags: tags,
                suggestions: suggestions,
                handleDelete: handleDelete,
                handleAddition: handleAddition,
                handleInputChange: function handleInputChange(val) {
                    return setSearchTag(val);
                },
                placeholder: 'Add Tag',
                tagComponent: Tag
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                    width: '30%', textAlign: 'center', margin: 'auto', display: isChanged ? 'block' : 'none'
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                onClick: function onClick() {
                    return saveTags(cargoId, tags);
                },
                labelStyle: { padding: 0, margin: 0 },
                label: 'Save Tags',
                primary: true
            })
        )
    );
}

function Tag(_ref3) {
    var tag = _ref3.tag,
        removeButtonText = _ref3.removeButtonText,
        onDelete = _ref3.onDelete;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { type: 'button', title: removeButtonText, onClick: onDelete },
        tag.value,
        tag.saved ? '' : '*'
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__["a" /* addNotification */],
        updateTagsDataInRow: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_realNames__["e" /* updateTagsDataInRow */]
    }, dispatch);
})(Tags);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(referenceTags, 'referenceTags', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(tagMatchMap, 'tagMatchMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(recommendMatcher, 'recommendMatcher', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(RoroTAG, 'RoroTAG', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(ProjectsTAG, 'ProjectsTAG', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(tagsByDetails, 'tagsByDetails', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(findRecommendedTags, 'findRecommendedTags', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(initializeInitialTags, 'initializeInitialTags', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(Tags, 'Tags', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(Tag, 'Tag', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/Tags.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = ConvertCargoDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





/**
 * 
 * @param {{
 *  open: boolean, 
 *  handleClose: () => void, 
 *  actions: any[], 
 *  handleConvert: (param: 'userToAdmin' | 'adminToUser') => void,
 * }} param0 
 * @returns 
 */
function ConvertCargoDialog(_ref) {
    var open = _ref.open,
        handleClose = _ref.handleClose,
        actions = _ref.actions;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["f" /* Dialog */],
        {
            open: open,
            actions: actions,
            onRequestClose: handleClose
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'convert-dialog' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                'Cargo will be converted to as approved by admin (that might generate a duplicate, which can be handled on ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { href: '/cargoes/duplicates', target: '_blank' },
                    'duplicate cargoes page'
                ),
                ')'
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ConvertCargoDialog, 'ConvertCargoDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RealNames/ConvertCargoDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Table__ = __webpack_require__(3283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_duplicates__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_index__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var CargoDuplicatesPage = function (_React$Component) {
    _inherits(CargoDuplicatesPage, _React$Component);

    function CargoDuplicatesPage(props) {
        _classCallCheck(this, CargoDuplicatesPage);

        return _possibleConstructorReturn(this, (CargoDuplicatesPage.__proto__ || Object.getPrototypeOf(CargoDuplicatesPage)).call(this, props));
    }

    _createClass(CargoDuplicatesPage, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getCargoDuplicates();
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'cargo-duplicates', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_6_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'cargo editor duplicates'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Table__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoDuplicatesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        isLoaded: state.cargoDuplicates.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCargoDuplicates: __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_duplicates__["c" /* getCargoDuplicates */]
    }, dispatch);
})(CargoDuplicatesPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoDuplicatesPage, 'CargoDuplicatesPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Duplicates/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Duplicates/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_duplicates__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Row__ = __webpack_require__(3284);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var CargoDuplicatesTable = function (_React$Component) {
    _inherits(CargoDuplicatesTable, _React$Component);

    function CargoDuplicatesTable(props) {
        _classCallCheck(this, CargoDuplicatesTable);

        var _this = _possibleConstructorReturn(this, (CargoDuplicatesTable.__proto__ || Object.getPrototypeOf(CargoDuplicatesTable)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            cargoDuplicates: []
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }

    _createClass(CargoDuplicatesTable, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            var _this2 = this;

            if (props.cargoDuplicates) {
                (function () {
                    var arr = [];
                    var keys = Object.keys(props.cargoDuplicates);
                    var page = _this2.state.page;

                    var _loop = function _loop(i) {
                        props.cargoDuplicates[keys[i]].entities.forEach(function (entity) {
                            var categoryName = entity.parent ? entity.parent.name : null;

                            arr.push({
                                name: props.cargoDuplicates[keys[i]]._id,
                                id: entity._id,
                                categoryName: categoryName,
                                details: entity.details,
                                sf: entity.sf,
                                addedByRole: entity.addedByRole,
                                errors: props.cargoDuplicates[keys[i]].errors
                            });
                        });
                    };

                    for (var i = 0; i < keys.length; i++) {
                        _loop(i);
                    }

                    if (props.searchText !== _this2.props.searchText) {
                        page = 1;
                    }

                    _this2.setState({
                        searchText: props.searchText,
                        total: arr.length,
                        cargoDuplicates: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].filterSearch(arr, props.searchText, ['name', 'categoryName']),
                        page: page
                    }, function () {
                        _this2.handleUpdateRow(_this2.state);
                    });
                })();
            }
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.cargoDuplicates.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            this.props.searchCargoDuplicates(e.target.value.toLowerCase());
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearDuplicates();
        }
    }, {
        key: 'render',
        value: function render() {
            var rows = this.state.rows;


            var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                total: this.state.cargoDuplicates.length,
                rowsPerPage: this.state.rowsPerPage,
                page: this.state.page,
                numberOfRows: this.state.numberOfRows,
                updateRows: this.handleUpdateRow
            });
            var renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            {
                                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS
                            },
                            'Cargo name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            {
                                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS
                            },
                            'Cargo type'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            {
                                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnCSS
                            },
                            'Details'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            {
                                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS
                            },
                            'Sf'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            {
                                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableRowColumnSmallCSS
                            },
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false },
                    rows.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Row__["a" /* default */], { key: item.id, item: item });
                    })
                )
            );

            if (!rows.length) {
                renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'nothing-found' },
                    'Not found'
                );
                renderPagination = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            defaultValue: this.props.searchText,
                            floatingLabelText: 'Search',
                            onChange: this.handleSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        renderPagination
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    renderTable
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoDuplicatesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        searchText: state.cargoDuplicates.searchText,
        cargoDuplicates: state.cargoDuplicates.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        searchCargoDuplicates: __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_duplicates__["d" /* searchCargoDuplicates */],
        clearDuplicates: __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_duplicates__["a" /* clearDuplicates */]
    }, dispatch);
})(CargoDuplicatesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoDuplicatesTable, 'CargoDuplicatesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Duplicates/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Duplicates/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_duplicates__ = __webpack_require__(567);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var DuplicatesRow = function (_React$Component) {
    _inherits(DuplicatesRow, _React$Component);

    function DuplicatesRow(props) {
        _classCallCheck(this, DuplicatesRow);

        var _this = _possibleConstructorReturn(this, (DuplicatesRow.__proto__ || Object.getPrototypeOf(DuplicatesRow)).call(this, props));

        _this.state = {
            item: _this.props.item,
            realCargoNames: [],
            disableButton: false
        };

        _this.handleRemoveItem = _this.handleRemoveItem.bind(_this);
        return _this;
    }

    _createClass(DuplicatesRow, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.item.errors.length > 0) {
                this.setState({
                    disableButton: false
                });
            }
        }
    }, {
        key: 'handleRemoveItem',
        value: function handleRemoveItem() {
            this.props.deleteCargoDuplicate(this.state.item);

            this.setState({
                disableButton: true
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state$item = this.state.item,
                name = _state$item.name,
                categoryName = _state$item.categoryName,
                details = _state$item.details,
                sf = _state$item.sf,
                addedByRole = _state$item.addedByRole;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                { style: { backgroundColor: 'rgba(0,188,212, ' + (addedByRole === 'admin' ? '0.05' : 0) + ')' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    categoryName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    details
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnSmallCSS },
                    sf ? sf.user : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnSmallCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'update-item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                            label: 'Remove',
                            disabled: this.state.disableButton,
                            secondary: true,
                            onClick: this.handleRemoveItem
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return DuplicatesRow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var item = ownProps.item;


    return {
        item: item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        deleteCargoDuplicate: __WEBPACK_IMPORTED_MODULE_6_actions_cargoes_duplicates__["b" /* deleteCargoDuplicate */]
    }, dispatch);
})(DuplicatesRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DuplicatesRow, 'DuplicatesRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Duplicates/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Duplicates/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_ldRates__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_termEntities__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(3286);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var LDRatesPage = function (_React$Component) {
    _inherits(LDRatesPage, _React$Component);

    function LDRatesPage(props) {
        _classCallCheck(this, LDRatesPage);

        return _possibleConstructorReturn(this, (LDRatesPage.__proto__ || Object.getPrototypeOf(LDRatesPage)).call(this, props));
    }

    _createClass(LDRatesPage, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getLoadingAndDischarging();
            this.props.getTermEntities();
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'cargo-ldrates', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Loading and discharging'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LDRatesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        isLoaded: state.ldRates.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_4_actions_cargoes_ldRates__["c" /* getLoadingAndDischarging */],
        getTermEntities: __WEBPACK_IMPORTED_MODULE_5_actions_termEntities__["a" /* getTermEntities */]
    }, dispatch);
})(LDRatesPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LDRatesPage, 'LDRatesPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/LDRates/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/LDRates/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_ldRates__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Row__ = __webpack_require__(3287);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CargoLDRatesTable = function (_React$Component) {
    _inherits(CargoLDRatesTable, _React$Component);

    function CargoLDRatesTable(props) {
        _classCallCheck(this, CargoLDRatesTable);

        var _this = _possibleConstructorReturn(this, (CargoLDRatesTable.__proto__ || Object.getPrototypeOf(CargoLDRatesTable)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            loadingAndDischarging: [],
            checkedEmptyFields: false
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.updateCheckEmptyFields = _this.updateCheckEmptyFields.bind(_this);
        return _this;
    }

    _createClass(CargoLDRatesTable, [{
        key: 'updateCheckEmptyFields',
        value: function updateCheckEmptyFields() {
            var _this2 = this;

            this.setState({
                page: 1,
                checkedEmptyFields: !this.state.checkedEmptyFields
            }, function () {
                _this2.makeFilter(_this2.props);
            });
        }
    }, {
        key: 'filterSearch',
        value: function filterSearch(searchArray, searchText, searchFields) {
            var filteredArray = [];

            for (var i = 0; i < searchArray.length; i++) {
                var splitString = '';

                for (var j = 0; j < searchFields.length; j++) {
                    if (searchArray[i].prevState[searchFields[j]]) {
                        splitString = splitString + ' ' + searchArray[i].prevState[searchFields[j]];
                    }
                }

                if (splitString.toLowerCase().includes(searchText.toLowerCase())) {
                    filteredArray.push(searchArray[i]);
                }
            }

            return filteredArray;
        }
    }, {
        key: 'makeFilter',
        value: function makeFilter(props) {
            var _this3 = this;

            var page = this.state.page;

            if (props.searchText !== this.state.searchText) {
                page = 1;
            }

            var loadingAndDischarging = this.filterSearch(props.loadingAndDischarging, props.searchText, ['value']);

            if (this.state.checkedEmptyFields) {
                loadingAndDischarging = loadingAndDischarging.filter(function (item) {

                    if (_.has(item.prevState, 'ldRates.loading')) {
                        for (var key in item.prevState.ldRates.loading) {
                            if (key !== 'cqd') {
                                if (item.prevState.ldRates.loading[key]) {
                                    return false;
                                }
                            }
                        }
                    }

                    if (_.has(item.prevState, 'ldRates.discharging')) {
                        for (var _key in item.prevState.ldRates.discharging) {
                            if (_key !== 'cqd') {
                                if (item.prevState.ldRates.discharging[_key]) {
                                    return false;
                                }
                            }
                        }
                    }

                    return true;
                });
            }

            this.setState({
                searchText: props.searchText,
                loadingAndDischarging: loadingAndDischarging,
                page: page,
                total: loadingAndDischarging.length
            }, function () {
                _this3.handleUpdateRow(_this3.state);
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            if (props.loadingAndDischarging) {
                this.makeFilter(props);
            }
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.loadingAndDischarging.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            this.props.searchLoadingAndDischarging(e.target.value.toLowerCase());
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                rows = _state.rows,
                loadingAndDischarging = _state.loadingAndDischarging,
                checkedEmptyFields = _state.checkedEmptyFields,
                rowsPerPage = _state.rowsPerPage,
                page = _state.page,
                numberOfRows = _state.numberOfRows;
            var _props = this.props,
                termEntities = _props.termEntities,
                searchText = _props.searchText;


            var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                total: loadingAndDischarging.length,
                rowsPerPage: rowsPerPage,
                page: page,
                numberOfRows: numberOfRows,
                updateRows: this.handleUpdateRow
            });

            var renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Dimension'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Speed'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Abbreviation'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Term'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'cqd'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            null
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false },
                    rows.map(function (row, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Row__["a" /* default */], {
                            key: row._id + index,
                            item: row,
                            termEntities: termEntities
                        });
                    })
                )
            );

            if (!rows.length) {
                renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'nothing-found' },
                    'Not found'
                );
                renderPagination = null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                            defaultValue: searchText,
                            floatingLabelText: 'Search',
                            onChange: this.handleSearch
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox___default.a, {
                            label: 'Empty fields',
                            checked: checkedEmptyFields,
                            onCheck: this.updateCheckEmptyFields,
                            style: { fontSize: '13px' }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        renderPagination
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    renderTable
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoLDRatesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var ldRates = _ref.ldRates,
        termEntities = _ref.termEntities;

    return {
        loadingAndDischarging: ldRates.items,
        searchText: ldRates.searchText,
        termEntities: termEntities
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        searchLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_ldRates__["e" /* searchLoadingAndDischarging */]
    }, dispatch);
})(CargoLDRatesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoLDRatesTable, 'CargoLDRatesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/LDRates/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/LDRates/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_ldRates__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var CargoLDRatesRow = function (_React$Component) {
    _inherits(CargoLDRatesRow, _React$Component);

    function CargoLDRatesRow(props) {
        _classCallCheck(this, CargoLDRatesRow);

        var _this = _possibleConstructorReturn(this, (CargoLDRatesRow.__proto__ || Object.getPrototypeOf(CargoLDRatesRow)).call(this, props));

        var item = _this.props.item;


        if (!item.ldRates) {
            item.ldRates = {
                loading: {
                    dimension: '',
                    speed: '',
                    abbreviation: '',
                    term: '',
                    cqd: false
                },
                discharging: {
                    dimension: '',
                    speed: '',
                    abbreviation: '',
                    term: '',
                    cqd: false
                }
            };
        }

        _this.state = {
            item: item
        };

        _this.handleChangeSelect = _this.handleChangeSelect.bind(_this);
        _this.handleChangeCheckbox = _this.handleChangeCheckbox.bind(_this);

        _this.handleUpdateItem = _this.handleUpdateItem.bind(_this);
        _this.handleDeleteItem = _this.handleDeleteItem.bind(_this);
        return _this;
    }

    _createClass(CargoLDRatesRow, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.item !== this.props.item;
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (!nextProps.item.ldRates) {
                nextProps.item.ldRates = {
                    loading: {
                        dimension: '',
                        speed: '',
                        abbreviation: '',
                        term: '',
                        cqd: false
                    },
                    discharging: {
                        dimension: '',
                        speed: '',
                        abbreviation: '',
                        term: '',
                        cqd: false
                    }
                };
            }

            if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(nextProps.item, this.props.item)) {
                this.setState({
                    item: nextProps.item
                });
            }
        }
    }, {
        key: 'handleChangeCheckbox',
        value: function handleChangeCheckbox(type) {
            var _this2 = this;

            var item = this.state.item;

            item.isUpdate = true;

            item.ldRates[type[0]][type[1]] = !item.ldRates[type[0]][type[1]];

            this.setState({
                item: item
            }, function () {
                _this2.props.saveStatusLoadingAndDischarging(_this2.state.item);
            });
        }
    }, {
        key: 'handleChangeSelect',
        value: function handleChangeSelect(value, dropdown) {
            var _this3 = this;

            var item = this.state.item;

            var ldRates = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(item.ldRates);

            item.isUpdate = true;
            ldRates[dropdown[0]][dropdown[1]] = value;

            this.setState({
                item: _extends({}, item, {
                    ldRates: ldRates
                })
            }, function () {
                _this3.props.saveStatusLoadingAndDischarging(_this3.state.item);
            });
        }
    }, {
        key: 'handleUpdateItem',
        value: function handleUpdateItem() {
            var _this4 = this;

            var item = this.state.item;


            item.isUpdate = false;
            this.setState({
                item: item
            }, function () {
                _this4.props.updateLoadingAndDischarging(_this4.state.item);
            });
        }
    }, {
        key: 'handleDeleteItem',
        value: function handleDeleteItem() {
            this.props.deleteLoadingAndDischarging(this.state.item);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var item = this.state.item;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                    item.value
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.dimension') ? item.ldRates.loading.dimension : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['loading', 'dimension']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.dimensions.map(function (d, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: d, primaryText: d });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.dimension') ? item.ldRates.discharging.dimension : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['discharging', 'dimension']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.dimensions.map(function (d, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: d, primaryText: d });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.speed') ? item.ldRates.loading.speed : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['loading', 'speed']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.speed.map(function (s, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: s, primaryText: s });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.speed') ? item.ldRates.discharging.speed : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['discharging', 'speed']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.speed.map(function (s, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: s, primaryText: s });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.abbreviation') ? item.ldRates.loading.abbreviation : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['loading', 'abbreviation']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.abbreviation.map(function (a, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: a, primaryText: a.toUpperCase() });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.abbreviation') ? item.ldRates.discharging.abbreviation : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['discharging', 'abbreviation']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.abbreviation.map(function (a, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: a, primaryText: a.toUpperCase() });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.term') ? item.ldRates.loading.term : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['loading', 'term']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.term.map(function (t, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: t, primaryText: t.toUpperCase() });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                        {
                            style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].selectFieldCSS,
                            value: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.term') ? item.ldRates.discharging.term : '',
                            onChange: function onChange(event, index, value) {
                                _this5.handleChangeSelect(value, ['discharging', 'term']);
                            },
                            disabled: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false,
                            maxHeight: 200,
                            autoWidth: true
                        },
                        this.props.termEntities.term.map(function (t, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, { key: key, style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].menuItemCSS, value: t, primaryText: t.toUpperCase() });
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnSmallCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox___default.a, {
                        checked: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.loading.cqd') ? item.ldRates.loading.cqd : false,
                        onCheck: function onCheck() {
                            _this5.handleChangeCheckbox(['loading', 'cqd']);
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox___default.a, {
                        checked: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'ldRates.discharging.cqd') ? item.ldRates.discharging.cqd : false,
                        onCheck: function onCheck() {
                            _this5.handleChangeCheckbox(['discharging', 'cqd']);
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnSmallCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: item.isUpdate ? 'update-item' : 'hidden update-item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, { label: 'UPDATE', primary: true, onClick: this.handleUpdateItem })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableRowColumnSmallCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, { label: 'Delete', secondary: true, onClick: this.handleDeleteItem })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoLDRatesRow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    var item = ownProps.item;
    var termEntities = ownProps.termEntities;

    return {
        item: item,
        termEntities: termEntities
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_ldRates__["f" /* updateLoadingAndDischarging */],
        deleteLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_ldRates__["b" /* deleteLoadingAndDischarging */],
        saveStatusLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_ldRates__["d" /* saveStatusLoadingAndDischarging */],
        clearStatusLoadingAndDischarging: __WEBPACK_IMPORTED_MODULE_9_actions_cargoes_ldRates__["a" /* clearStatusLoadingAndDischarging */]
    }, dispatch);
})(CargoLDRatesRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoLDRatesRow, 'CargoLDRatesRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/LDRates/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/LDRates/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List__ = __webpack_require__(3289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_index__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var CargoRequestsPage = function (_React$Component) {
    _inherits(CargoRequestsPage, _React$Component);

    function CargoRequestsPage(props) {
        _classCallCheck(this, CargoRequestsPage);

        return _possibleConstructorReturn(this, (CargoRequestsPage.__proto__ || Object.getPrototypeOf(CargoRequestsPage)).call(this, props));
    }

    _createClass(CargoRequestsPage, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getCargoTypes();
        }
    }, {
        key: 'render',
        value: function render() {
            var isLoaded = this.props.isLoaded;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'cargo-requests', className: 'requests-page page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_6_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            '\u0421argo requests'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__List__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoRequestsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var isLoaded = _ref.cargoRequests.isLoaded;
    return {
        isLoaded: isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getCargoTypes: __WEBPACK_IMPORTED_MODULE_5_actions_cargoes_types__["a" /* getCargoTypes */]
    }, dispatch);
})(CargoRequestsPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoRequestsPage, 'CargoRequestsPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_cargoes_requests__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Item__ = __webpack_require__(3290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Base_EhSelector__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_dates__ = __webpack_require__(91);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var styles = {
    radioGroup: {
        margin: '20px 0'
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%'
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

function parseQueryString() {
    return document.location.search.substr(1).split('&').reduce(function (acc, p) {
        var _p$split$map = p.split('=').map(decodeURIComponent),
            _p$split$map2 = _slicedToArray(_p$split$map, 2),
            _1 = _p$split$map2[0],
            _2 = _p$split$map2[1];

        acc[_1] = _2;
        return acc;
    }, {});
}

var CargoRequestsList = function (_React$Component) {
    _inherits(CargoRequestsList, _React$Component);

    function CargoRequestsList(props) {
        _classCallCheck(this, CargoRequestsList);

        var _this = _possibleConstructorReturn(this, (CargoRequestsList.__proto__ || Object.getPrototypeOf(CargoRequestsList)).call(this, props));

        var query = parseQueryString();

        _this.state = {
            page: 1,
            search: query.q || '',

            volumeMax: '',
            volumeMin: '',

            weightMax: '',
            weightMin: '',

            cargoName: '',
            cargoId: '',
            cargoNames: [],

            cargoType: '',
            cargoTypeName: '',
            cargoTypeNames: [],

            listUnloadingPorts: [],
            unloadingPortName: '',
            unloadingPort: '',

            listLoadingPorts: [],
            loadingPortName: '',
            loadingPort: '',

            readinessDate: '',
            cancellingDate: '',

            eh: []
        };

        _this.updateRows = _this.updateRows.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);

        _this.prevPage = _this.prevPage.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);

        _this.onChooseAutoComplete = _this.onChooseAutoComplete.bind(_this);
        _this.onChangeAutoComplete = _this.onChangeAutoComplete.bind(_this);

        _this.onUpdateInputCargoType = _this.onUpdateInputCargoType.bind(_this);
        _this.onNewRequestCargoTypes = _this.onNewRequestCargoTypes.bind(_this);

        _this.onUpdateInputCargoName = _this.onUpdateInputCargoName.bind(_this);
        _this.onNewRequestCargoName = _this.onNewRequestCargoName.bind(_this);

        _this.changeDate = _this.changeDate.bind(_this);

        _this.changeValues = _this.changeValues.bind(_this);
        _this.handleClearFilters = _this.handleClearFilters.bind(_this);
        _this.handleEhChange = _this.handleEhChange.bind(_this);
        return _this;
    }

    _createClass(CargoRequestsList, [{
        key: 'handleClearFilters',
        value: function handleClearFilters() {
            var _this2 = this;

            this.setState({
                page: 1,
                search: '',

                volumeMax: '',
                volumeMin: '',

                weightMax: '',
                weightMin: '',

                cargoName: '',
                cargoId: '',
                cargoNames: [],

                cargoType: '',
                cargoTypeName: '',

                listUnloadingPorts: [],
                unloadingPortName: '',
                unloadingPort: '',

                listLoadingPorts: [],
                loadingPortName: '',
                loadingPort: '',

                readinessDate: '',
                cancellingDate: '',

                eh: []
            }, function () {
                _this2.updateRows(_this2.state);
            });
        }
    }, {
        key: 'changeValues',
        value: function changeValues(type, value) {
            var state = this.state;
            state[type] = value;
            this.setState(state);
        }
    }, {
        key: 'changeDate',
        value: function changeDate(type, date) {
            if (type === 'readinessDate') {
                this.setState({
                    readinessDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(date)
                });
            } else {
                this.setState({
                    cancellingDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(date)
                });
            }

            console.log('type', type);
            console.log('date', date);
        }
    }, {
        key: 'onUpdateInputCargoName',
        value: function onUpdateInputCargoName(searchText) {
            var _this3 = this;

            this.setState({
                cargoName: searchText
            }, function () {
                __WEBPACK_IMPORTED_MODULE_13_services__["a" /* default */].getCargoNamesAutocomplete(searchText).then(function (response) {
                    var cargoNames = response.data.data.map(function (realCargoName) {
                        return {
                            name: realCargoName.name,
                            item: realCargoName
                        };
                    });

                    _this3.setState({
                        cargoNames: cargoNames
                    });
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'onNewRequestCargoName',
        value: function onNewRequestCargoName(updateProperties) {
            if (!updateProperties) {
                return;
            }

            this.setState({
                cargoName: updateProperties.name,
                cargoId: updateProperties.item._id
            });
        }
    }, {
        key: 'onUpdateInputCargoType',
        value: function onUpdateInputCargoType(searchText) {
            this.setState({
                cargoTypeName: searchText
            });
        }
    }, {
        key: 'onNewRequestCargoTypes',
        value: function onNewRequestCargoTypes(updateProperties) {
            if (!updateProperties.name) {
                return;
            }

            this.setState({
                cargoTypeName: updateProperties.name,
                cargoType: updateProperties.item._id
            });
        }
    }, {
        key: 'onChangeAutoComplete',
        value: function onChangeAutoComplete(searchText, type) {
            var _this4 = this;

            if (type === 'loading') {
                this.setState({
                    loadingPortName: searchText,
                    loadingPort: ''
                });
            } else {
                this.setState({
                    unloadingPortName: searchText,
                    unloadingPort: ''
                });
            }

            if (searchText.length <= 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_13_services__["a" /* default */].findPortAdmin({ name: searchText, withAreas: true }).then(function (response) {
                if (type === 'loading') {
                    var listLoadingPorts = [];
                    response.data.data.forEach(function (port) {
                        if (port.sub) {
                            port.sub.forEach(function (subPort) {
                                listLoadingPorts.push({
                                    name: subPort.name + ' - country ' + port.country.name,
                                    item: subPort
                                });
                            });
                        }

                        var name = '';
                        if (port.country) {
                            name = port.name + ' - country ' + port.country.name;
                        } else {
                            name = port.name;
                        }

                        listLoadingPorts.push({
                            name: name,
                            item: port
                        });
                    });

                    _this4.setState({
                        listLoadingPorts: listLoadingPorts
                    });
                } else {
                    var listUnloadingPorts = [];

                    response.data.data.forEach(function (port) {
                        if (port.sub) {
                            port.sub.forEach(function (subPort) {
                                listUnloadingPorts.push({
                                    name: subPort.name + ' - country ' + port.country.name,
                                    item: subPort
                                });
                            });
                        }

                        var name = '';
                        if (port.country) {
                            name = port.name + ' - country ' + port.country.name;
                        } else {
                            name = port.name;
                        }

                        listUnloadingPorts.push({
                            name: name,
                            item: port
                        });
                    });

                    _this4.setState({
                        listUnloadingPorts: listUnloadingPorts
                    });
                }
            }).catch(function () {
                return null;
            });
        }
    }, {
        key: 'onChooseAutoComplete',
        value: function onChooseAutoComplete(type, updateProperties) {
            if (!updateProperties) {
                return;
            }

            if (type === 'loading') {
                this.setState({
                    loadingPort: updateProperties.item._id,
                    loadingPortName: updateProperties.name
                });
            } else {
                this.setState({
                    unloadingPort: updateProperties.item._id,
                    unloadingPortName: updateProperties.name
                });
            }
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            var _this5 = this;

            this.setState({
                page: this.props.cargoRequests.next
            }, function () {
                _this5.updateRows(_this5.state);
            });
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            var _this6 = this;

            this.setState({
                page: this.props.cargoRequests.previous
            }, function () {
                _this6.updateRows(_this6.state);
            });
        }
    }, {
        key: 'updateRows',
        value: function updateRows(state) {
            console.log(state);
            this.props.getRequestsCargo({
                page: state.page,
                limit: state.numberOfRows,
                filters: {
                    all: true,
                    search: state.search.length !== 0 ? state.search : undefined,
                    readinessDate: state.readinessDate.length !== 0 ? state.readinessDate : undefined,
                    cancellingDate: state.cancellingDate.length !== 0 ? state.cancellingDate : undefined,
                    loadingPort: state.loadingPort.length !== 0 ? state.loadingPort : undefined,
                    unloadingPort: state.unloadingPort.length !== 0 ? state.unloadingPort : undefined,
                    weightMin: state.weightMin.length !== 0 ? state.weightMin : undefined,
                    weightMax: state.weightMax.length !== 0 ? state.weightMax : undefined,
                    volumeMin: state.volumeMin.length !== 0 ? state.volumeMin : undefined,
                    volumeMax: state.volumeMax.length !== 0 ? state.volumeMax : undefined,
                    cargoName: state.cargoName.length !== 0 ? state.cargoName : undefined,
                    cargoType: state.cargoType.length !== 0 ? state.cargoType : undefined,
                    eh: state.eh
                }
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.updateRows(this.state);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            var cargoTypeNames = props.cargoTypes.map(function (item) {
                return {
                    name: item.name,
                    item: item
                };
            });

            this.setState({
                page: props.cargoRequests.page,
                cargoTypeNames: cargoTypeNames,
                filters: _extends({}, props.cargoRequests.filters, this.state.filters)
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch() {
            var _this7 = this;

            this.setState({
                page: 1
            }, function () {
                _this7.updateRows(_this7.state);
            });
        }
    }, {
        key: 'handleEhChange',
        value: function handleEhChange(eh) {
            var _this8 = this;

            this.setState(_extends({}, this.state, {
                eh: eh
            }), function () {
                _this8.updateRows(_this8.state);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this9 = this;

            var _state = this.state,
                search = _state.search,
                page = _state.page,
                loadingPortName = _state.loadingPortName,
                listLoadingPorts = _state.listLoadingPorts,
                unloadingPortName = _state.unloadingPortName,
                listUnloadingPorts = _state.listUnloadingPorts,
                weightMin = _state.weightMin,
                weightMax = _state.weightMax,
                volumeMax = _state.volumeMax,
                volumeMin = _state.volumeMin,
                cargoName = _state.cargoName,
                cargoNames = _state.cargoNames,
                cargoTypeName = _state.cargoTypeName,
                cargoTypeNames = _state.cargoTypeNames,
                readinessDate = _state.readinessDate,
                cancellingDate = _state.cancellingDate;


            var cargoRequests = this.props.cargoRequests;
            var cargoRequestsItems = cargoRequests.data;

            if (!cargoRequestsItems) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'filter' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'search filter-column', style: { width: '100%', justifyContent: 'space-between' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                value: search,
                                floatingLabelText: 'Search',
                                onChange: function onChange(e, value) {
                                    _this9.changeValues('search', value);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Base_EhSelector__["a" /* EhSelector */], { values: this.state.eh, onChange: this.handleEhChange }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'span',
                                { style: { display: 'flex', alignItems: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationLeft,
                                        name: 'navigationLeft',
                                        onClick: this.prevPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { className: 'item' },
                                    'Page: ',
                                    this.state.page
                                ),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationRight,
                                        name: 'navigationRight',
                                        onClick: this.nextPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                label: 'Search',
                                style: { fontSize: '13px', margin: '0 0 0 10px' },
                                onClick: this.handleSearch,
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                                label: 'Clear filters',
                                style: { fontSize: '13px', margin: '0 0 0 10px' },
                                onClick: this.handleClearFilters,
                                primary: true
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'filter-column paper-block' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name-block absolute small-name' },
                                'Dates'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_DatePicker___default.a, {
                                value: cancellingDate ? Object(__WEBPACK_IMPORTED_MODULE_16__helpers_dates__["d" /* toUTC */])(cancellingDate) : undefined,
                                onChange: function onChange(e, date) {
                                    _this9.changeDate('cancellingDate', date);
                                },
                                floatingLabelText: 'cancellingDate',
                                formatDate: function formatDate(date) {
                                    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('MM-DD-YYYY');
                                },
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },
                                autoOk: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_DatePicker___default.a, {
                                value: readinessDate ? Object(__WEBPACK_IMPORTED_MODULE_16__helpers_dates__["d" /* toUTC */])(readinessDate) : undefined,
                                onChange: function onChange(e, date) {
                                    _this9.changeDate('readinessDate', date);
                                },
                                floatingLabelText: 'readinessDate',
                                formatDate: function formatDate(date) {
                                    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('MM-DD-YYYY');
                                },
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },
                                autoOk: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'filter-column paper-block' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name-block absolute small-name' },
                                'LUports'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a, {
                                floatingLabelText: 'Loading port',
                                searchText: loadingPortName,
                                dataSource: listLoadingPorts,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: function onUpdateInput(e) {
                                    return _this9.onChangeAutoComplete(e, 'loading');
                                },
                                onNewRequest: this.onChooseAutoComplete.bind(this, 'loading'),
                                filter: __WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a.noFilter,
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },

                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a, {
                                floatingLabelText: 'Unloading port',
                                searchText: unloadingPortName,
                                dataSource: listUnloadingPorts,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: function onUpdateInput(e) {
                                    return _this9.onChangeAutoComplete(e, 'unloading');
                                },
                                onNewRequest: this.onChooseAutoComplete.bind(this, 'unloading'),
                                filter: __WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a.noFilter,
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },

                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'filter-column paper-block' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name-block absolute small-name' },
                                'Weight'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                type: 'number',
                                floatingLabelText: 'weightMin',
                                value: weightMin,
                                style: { width: '75%' },
                                inputStyle: { width: '75%' },
                                onChange: function onChange(e) {
                                    _this9.changeValues('weightMin', e.target.value);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                type: 'number',
                                floatingLabelText: 'weightMax',
                                value: weightMax,
                                style: { width: '75%' },
                                inputStyle: { width: '75%' },
                                onChange: function onChange(e) {
                                    _this9.changeValues('weightMax', e.target.value);
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'filter-column paper-block' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name-block absolute small-name' },
                                'Volume'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                type: 'number',
                                floatingLabelText: 'volumeMin',
                                value: volumeMin,
                                style: { width: '75%' },
                                inputStyle: { width: '75%' },
                                onChange: function onChange(e) {
                                    _this9.changeValues('volumeMin', e.target.value);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                type: 'number',
                                floatingLabelText: 'volumeMax',
                                value: volumeMax,
                                style: { width: '75%' },
                                inputStyle: { width: '75%' },
                                onChange: function onChange(e) {
                                    _this9.changeValues('volumeMax', e.target.value);
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'filter-column paper-block' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'name-block absolute small-name' },
                                'Cargoes info'
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a, {
                                floatingLabelText: 'Cargo names',
                                searchText: cargoName,
                                dataSource: cargoNames,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: this.onUpdateInputCargoName,
                                onNewRequest: this.onNewRequestCargoName,
                                filter: __WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a.caseInsensitiveFilter,
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a, {
                                floatingLabelText: 'Cargo types',
                                searchText: cargoTypeName,
                                dataSource: cargoTypeNames,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: this.onUpdateInputCargoType,
                                onNewRequest: this.onNewRequestCargoTypes,
                                filter: __WEBPACK_IMPORTED_MODULE_8_material_ui_AutoComplete___default.a.caseInsensitiveFilter,
                                style: { width: '75%' },
                                textFieldStyle: { width: '75%' },
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'ul',
                            { className: 'list-requests' },
                            cargoRequestsItems.map(function (item) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Item__["a" /* default */], { key: item._id, item: item });
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoRequestsList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        cargoRequests: state.cargoRequests,
        cargoTypes: state.cargoTypes
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getRequestsCargo: __WEBPACK_IMPORTED_MODULE_12_actions_cargoes_requests__["b" /* getRequestsCargo */]
    }, dispatch);
})(CargoRequestsList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/List.jsx');
    reactHotLoader.register(parseQueryString, 'parseQueryString', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/List.jsx');
    reactHotLoader.register(CargoRequestsList, 'CargoRequestsList', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_requests__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Base_Mails_OpenMailBlock__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sagas_orders__ = __webpack_require__(163);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Item = function (_React$Component) {
    _inherits(Item, _React$Component);

    function Item(props) {
        var _this2 = this;

        _classCallCheck(this, Item);

        var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));

        _this.saveRequestsDataDeleted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return Object(__WEBPACK_IMPORTED_MODULE_10_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_11_sagas_orders__["b" /* saveRequestsDataDeleted */], 'cargo', { mailId: _this.props.item.mailId });

                        case 3:
                            _context.next = 8;
                            break;

                        case 5:
                            _context.prev = 5;
                            _context.t0 = _context['catch'](0);

                            console.error(_context.t0);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 5]]);
        }));


        _this.state = {
            userEmails: [],
            name: _this.props.item.addedBy.name || '',
            surname: _this.props.item.addedBy.surname || '',
            email: _this.props.item.addedBy.email || '',
            cargoRequestId: _this.props.item._id,
            id: _this.props.item.addedBy._id,
            isUpdate: false
        };

        _this.changeUser = _this.changeUser.bind(_this);
        _this.chooseUser = _this.chooseUser.bind(_this);
        _this.deleteCargoRequest = _this.deleteCargoRequest.bind(_this);
        _this.updateCargoRequest = _this.updateCargoRequest.bind(_this);
        _this.saveRequestsDataDeleted = _this.saveRequestsDataDeleted.bind(_this);
        return _this;
    }

    _createClass(Item, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                isUpdate: nextProps.item.isUpdate,
                item: nextProps.item
            });
        }
    }, {
        key: 'deleteCargoRequest',
        value: function deleteCargoRequest() {
            this.props.item.mailId && this.saveRequestsDataDeleted();
            this.props.deleteRequestCargo(this.state.cargoRequestId);
        }
    }, {
        key: 'updateCargoRequest',
        value: function updateCargoRequest() {
            this.props.updateRequestCargo(this.state.cargoRequestId, this.state.id);
        }
    }, {
        key: 'changeUser',
        value: function changeUser(searchText) {
            var _this3 = this;

            this.setState({
                email: searchText,
                isUpdate: false
            }, function () {
                __WEBPACK_IMPORTED_MODULE_8_services__["a" /* default */].findUser(searchText).then(function (response) {
                    var userEmails = response.data.data.map(function (user) {
                        return {
                            name: user.email + ' - (' + (user.name || '') + ' ' + (user.surname || '') + ')',
                            item: user
                        };
                    });

                    _this3.setState({
                        userEmails: userEmails

                    });
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'chooseUser',
        value: function chooseUser(updateProperties) {
            if (!updateProperties) {
                return;
            }

            this.setState({
                name: updateProperties.item.name,
                surname: updateProperties.item.surname,
                email: updateProperties.item.email,
                id: updateProperties.item._id,
                isUpdate: true
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                email = _state.email,
                userEmails = _state.userEmails,
                isUpdate = _state.isUpdate,
                name = _state.name,
                surname = _state.surname;
            var item = this.props.item;


            var autoComplete = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a, {
                textFieldStyle: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].autoCompleteCSS,
                hintText: 'User',
                searchText: email,
                dataSource: userEmails,
                dataSourceConfig: { text: 'name', value: 'item' },
                onUpdateInput: this.changeUser,
                onNewRequest: this.chooseUser,
                filter: __WEBPACK_IMPORTED_MODULE_5_material_ui_AutoComplete___default.a.noFilter,
                fullWidth: true,
                listStyle: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].autoCompleteListStyle,
                popoverProps: {
                    canAutoPosition: true,
                    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                    targetOrigin: { horizontal: 'left', vertical: 'top' }
                }
            });

            var managementBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name-block absolute small-name' },
                    'Managment'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                    onClick: this.deleteCargoRequest,
                    label: 'Delete',
                    style: { margin: '0 10px 0 0' },
                    secondary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                    onClick: this.updateCargoRequest,
                    disabled: !isUpdate,
                    label: 'Update user',
                    style: { margin: '0 10px 0 0' },
                    primary: true
                })
            );

            if (item.fixed) {
                managementBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Fixed'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'FIXED: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                );

                autoComplete = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Email: '
                    ),
                    email
                );
            }

            if (this.props.item.deleteBy) {
                managementBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Deleted'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Delete at: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.deleteAt).format('MM-DD-YYYY'),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Delete by: '
                    ),
                    item.deleteBy.email
                );
                autoComplete = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Email: '
                    ),
                    this.state.email
                );
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block item-request' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'unique info'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'refNo: '
                        ),
                        item.refNo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'requests'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Freight Requests count: '
                        ),
                        item.freightRequests,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Offers Requests count: '
                        ),
                        item.offersRequests,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Recommended count: '
                        ),
                        item.recommended,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'POL'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Loading port: '
                        ),
                        item.loadingPort ? item.loadingPort.name : '',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Cancelling Date: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.cancellingDate).startOf('day').toDate().toLocaleDateString(),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Readiness Date: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.readinessDate).startOf('day').toDate().toLocaleDateString(),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'POD'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Unloading Port: '
                        ),
                        item.unloadingPort ? item.unloadingPort.name : '',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'cargo'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Cargo: '
                        ),
                        item.cargo[0]
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Total Values'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Volume: '
                        ),
                        item.totalValues.volume,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Volume With Percent: '
                        ),
                        item.totalValues.volumeWithPercent,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Weight: '
                        ),
                        item.totalValues.weight,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Weight With Percent: '
                        ),
                        item.totalValues.weightWithPercent,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Company'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        item.addedBy.company ? item.addedBy.company.name : ''
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'User'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        name,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Surname: '
                        ),
                        surname,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        autoComplete
                    ),
                    item.realUser && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Real user'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Email: '
                        ),
                        item.realUser.email,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    ),
                    managementBlock,
                    item.mailId && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Base_Mails_OpenMailBlock__["a" /* default */], { mailId: item.mailId })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Item;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        item: ownProps.item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateRequestCargo: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_requests__["d" /* updateRequestCargo */],
        deleteRequestCargo: __WEBPACK_IMPORTED_MODULE_7_actions_cargoes_requests__["a" /* deleteRequestCargo */]
    }, dispatch);
})(Item);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Item, 'Item', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/Requests/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = EhSelector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EhSelector_scss__ = __webpack_require__(3292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EhSelector_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EhSelector_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function EhSelector(_ref) {
    var values = _ref.values,
        onChange = _ref.onChange;

    function handleClick(e) {
        var set = new Set(values);

        if (e.target.checked) {
            set.add(e.target.dataset.eh);
        } else {
            set.delete(e.target.dataset.eh);
        }
        onChange(Array.from(set));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('eh-selector') },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'h3',
            { className: 'title' },
            'From: '
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default.a, {
            label: 'Fix',
            'data-eh': 'fix',
            checked: values.includes('fix'),
            onCheck: handleClick
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default.a, {
            label: 'Varamar',
            'data-eh': 'varamar',
            checked: values.includes('varamar'),
            onCheck: handleClick
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default.a, {
            label: 'Fixture',
            'data-eh': 'fixture',
            checked: values.includes('fixture'),
            onCheck: handleClick
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default.a, {
            label: 'Api',
            'data-eh': 'api',
            checked: values.includes('api'),
            onCheck: handleClick
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_material_ui_Checkbox___default.a, {
            label: 'Broker',
            'data-eh': 'broker',
            checked: values.includes('broker'),
            onCheck: handleClick
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(EhSelector, 'EhSelector', '/opt/atlassian/pipelines/agent/build/client/app/components/Base/EhSelector/EhSelector.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3292 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128568
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(3294);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











function VesselListPage(props) {
    var isLoaded = props.isLoaded,
        vessels = props.vessels,
        getVessels = props.getVessels;


    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getVessels({
            page: vessels.page,
            limit: vessels.limit,
            notConfirmed: vessels.notConfirmed,
            sanctioned: vessels.sanctioned,
            isNameSuggestion: vessels.isNameSuggestion
        });
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'vessel-list', className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, { className: !isLoaded ? '' : 'hidden', style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].circularProgress }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: isLoaded ? '' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container-fluid' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h2',
                    null,
                    'Vessels'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */], null)
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var isLogged = _ref.user.isLogged,
        vessels = _ref.vessels;
    return {
        isLogged: isLogged,
        vessels: vessels,
        isLoaded: vessels.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getVessels: __WEBPACK_IMPORTED_MODULE_4_actions_vessels_vessels__["f" /* getVessels */]
    }, dispatch);
})(VesselListPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselListPage, 'VesselListPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Row__ = __webpack_require__(3295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VesselImport__ = __webpack_require__(3296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Filters__ = __webpack_require__(3303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(957);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


















function VesselListTable(props) {
    var _this = this;

    var vessels = props.vessels,
        getVessels = props.getVessels;


    var rowsPerPage = [25, 50, 100];

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        rows = _useState2[0],
        setRows = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(25),
        _useState4 = _slicedToArray(_useState3, 2),
        numberOfRows = _useState4[0],
        setNumberOfRows = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState6 = _slicedToArray(_useState5, 2),
        page = _useState6[0],
        setPage = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState8 = _slicedToArray(_useState7, 2),
        total = _useState8[0],
        setTotal = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState10 = _slicedToArray(_useState9, 2),
        notConfirmed = _useState10[0],
        setNotConfirmed = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState12 = _slicedToArray(_useState11, 2),
        sanctioned = _useState12[0],
        setSanctioned = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState14 = _slicedToArray(_useState13, 2),
        vesselImportModalOpen = _useState14[0],
        setVesselImportModalOpen = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState16 = _slicedToArray(_useState15, 2),
        isNameSuggestion = _useState16[0],
        setIsNameSuggestion = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('all'),
        _useState18 = _slicedToArray(_useState17, 2),
        modifiedFilter = _useState18[0],
        setModifiedFilter = _useState18[1];

    var _useState19 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('all'),
        _useState20 = _slicedToArray(_useState19, 2),
        photosFilter = _useState20[0],
        setPhotosFilter = _useState20[1];

    var _useState21 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState22 = _slicedToArray(_useState21, 2),
        filterCargoExclusions = _useState22[0],
        setFilterCargoExclusions = _useState22[1];

    var _useState23 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState24 = _slicedToArray(_useState23, 2),
        filterTradingRestrictions = _useState24[0],
        setFilterTradingRestrictions = _useState24[1];

    var _useState25 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
        _useState26 = _slicedToArray(_useState25, 1),
        search = _useState26[0];

    var _useState27 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState28 = _slicedToArray(_useState27, 2),
        typeByPurpose = _useState28[0],
        setTypeByPurpose = _useState28[1];

    var _useState29 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState30 = _slicedToArray(_useState29, 2),
        typeBySpecialty = _useState30[0],
        setTypeBySpecialty = _useState30[1];

    var _useState31 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState32 = _slicedToArray(_useState31, 2),
        dwtMin = _useState32[0],
        setDwtMin = _useState32[1];

    var _useState33 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState34 = _slicedToArray(_useState33, 2),
        dwtMax = _useState34[0],
        setDwtMax = _useState34[1];

    var _useState35 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState36 = _slicedToArray(_useState35, 2),
        bltMin = _useState36[0],
        setBltMin = _useState36[1];

    var _useState37 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState38 = _slicedToArray(_useState37, 2),
        bltMax = _useState38[0],
        setBltMax = _useState38[1];

    var _useState39 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('name'),
        _useState40 = _slicedToArray(_useState39, 2),
        sortField = _useState40[0],
        setSortField = _useState40[1];

    var _useState41 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState42 = _slicedToArray(_useState41, 2),
        sortValue = _useState42[0],
        setSortValue = _useState42[1];

    var searchRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var importDialogRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!vessels) return;
        setTotal(vessels.total);
        setRows(vessels.data);
        setPage(vessels.page);
        setNumberOfRows(vessels.limit);
        setNotConfirmed(vessels.notConfirmed);
        setSanctioned(vessels.sanctioned);
        setFilterCargoExclusions(vessels.filterCargoExclusions);
        setFilterTradingRestrictions(vessels.filterTradingRestrictions);
        setIsNameSuggestion(vessels.isNameSuggestion);
        setPhotosFilter(vessels.photosFilter);
        setTypeByPurpose(vessels.typeByPurpose || '');
        setTypeBySpecialty(vessels.typeBySpecialty || '');
        setDwtMin(vessels.dwtMin || null);
        setDwtMax(vessels.dwtMax || null);
        setBltMin(vessels.bltMin || null);
        setBltMax(vessels.bltMax || null);
        setSortField(vessels.sortField);
        setSortValue(typeof vessels.sortValue === 'number' ? vessels.sortValue : 1);
    }, [vessels]);

    var clearSearch = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_e, value) {
        if ((value || '').length === 0) {
            getVessels({
                page: page,
                limit: numberOfRows
            });
        }
    }, [getVessels, page, numberOfRows]);

    var handleSearch = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var value;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        value = (searchRef.current && searchRef.current.input && searchRef.current.input.value || '').trim();

                        if (searchRef.current && searchRef.current.input) {
                            searchRef.current.input.value = value;
                        }

                        if (value.length) {
                            _context.next = 4;
                            break;
                        }

                        return _context.abrupt('return');

                    case 4:
                        _context.next = 6;
                        return __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].findVessel(value, !notConfirmed, isNameSuggestion).then(function (response) {
                            if (response.status === 200) {
                                setRows(response.data.data);
                                setPage(1);
                                setNumberOfRows(25);
                            }
                        });

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    })), [notConfirmed, isNameSuggestion]);

    var _updateRows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (state) {
        getVessels({
            page: state.page,
            limit: state.numberOfRows,
            notConfirmed: notConfirmed,
            sanctioned: sanctioned,
            isNameSuggestion: isNameSuggestion,
            photosFilter: photosFilter,
            typeByPurpose: typeByPurpose,
            dwtMin: dwtMin,
            dwtMax: dwtMax,
            typeBySpecialty: typeBySpecialty,
            bltMin: bltMin,
            bltMax: bltMax,
            sortField: sortField,
            sortValue: sortValue
        });
    }, [getVessels, notConfirmed, sanctioned, isNameSuggestion, photosFilter, typeByPurpose, dwtMin, dwtMax, sortField, sortValue, typeBySpecialty, bltMin, bltMax]);

    var handleCloseImportVessels = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        return setVesselImportModalOpen(false);
    }, []);
    var handleUpdateImportDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (importDialogRef.current && typeof importDialogRef.current.forceUpdate === 'function') {
            importDialogRef.current.forceUpdate();
        }
    }, []);

    var handleFilters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (fieldOrUpdates, value) {
        var updates = (typeof fieldOrUpdates === 'undefined' ? 'undefined' : _typeof(fieldOrUpdates)) === 'object' ? fieldOrUpdates : _defineProperty({}, fieldOrUpdates, value);

        if ('typeByPurpose' in updates) {
            setTypeByPurpose(updates.typeByPurpose || '');

            if (!updates.typeByPurpose) {
                updates.typeBySpecialty = '';
            }
        }

        if ('typeBySpecialty' in updates) setTypeBySpecialty(updates.typeBySpecialty);

        if ('isNameSuggestion' in updates) setIsNameSuggestion(!!updates.isNameSuggestion);
        if ('notConfirmed' in updates) setNotConfirmed(!!updates.notConfirmed);
        if ('sanctioned' in updates) setSanctioned(updates.sanctioned);
        if ('modifiedFilter' in updates) setModifiedFilter(updates.modifiedFilter);
        if ('photosFilter' in updates) setPhotosFilter(updates.photosFilter);
        if ('dwtMin' in updates) setDwtMin(updates.dwtMin || null);
        if ('dwtMax' in updates) setDwtMax(updates.dwtMax || null);
        if ('bltMin' in updates) setBltMin(updates.bltMin || null);
        if ('bltMax' in updates) setBltMax(updates.bltMax || null);
        if ('sortField' in updates) setSortField(updates.sortField || 'name');
        if ('sortValue' in updates) setSortValue(updates.sortValue);

        var next = _extends({
            isNameSuggestion: isNameSuggestion,
            notConfirmed: notConfirmed,
            sanctioned: sanctioned,
            modifiedFilter: modifiedFilter,
            photosFilter: photosFilter,
            typeByPurpose: typeByPurpose,
            dwtMin: dwtMin,
            dwtMax: dwtMax,
            typeBySpecialty: typeBySpecialty,
            bltMin: bltMin,
            bltMax: bltMax,
            sortField: sortField,
            sortValue: sortValue
        }, updates);

        if (next.bltMin && String(next.bltMin).length !== 4) return;
        if (next.bltMax && String(next.bltMax).length !== 4) return;
        if (next.bltMin && next.bltMax && next.bltMin > next.bltMax) return;

        getVessels({
            page: 1,
            limit: numberOfRows,
            isNameSuggestion: !!next.isNameSuggestion,
            notConfirmed: !!next.notConfirmed,
            sanctioned: next.sanctioned,
            photosFilter: next.photosFilter,
            typeByPurpose: next.typeByPurpose,
            dwtMin: next.dwtMin,
            dwtMax: next.dwtMax,
            typeBySpecialty: next.typeBySpecialty,
            bltMin: next.bltMin,
            bltMax: next.bltMax,
            sortField: next.sortField,
            sortValue: next.sortValue
        });
    }, [getVessels, numberOfRows, isNameSuggestion, notConfirmed, sanctioned, photosFilter, typeByPurpose, dwtMin, dwtMax, sortField, sortValue, typeBySpecialty, bltMin, bltMax]);

    var handleNameSuggested = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        handleFilters('isNameSuggestion', !isNameSuggestion);
    }, [isNameSuggestion]);

    var handleConfirmed = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        handleFilters('notConfirmed', !notConfirmed);
    }, [notConfirmed]);

    var handleSanctioned = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var next = !sanctioned || undefined;
        handleFilters('sanctioned', next);
    }, [sanctioned]);

    var handleExclusions = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (period, property) {
        if (!property) return;
        var nextVal = period ? new Date(period).toISOString() : undefined;

        if (property === 'filterCargoExclusions') {
            setFilterCargoExclusions(nextVal);
        } else if (property === 'filterTradingRestrictions') {
            setFilterTradingRestrictions(nextVal);
        }

        getVessels(_defineProperty({
            page: page,
            limit: numberOfRows,
            isNameSuggestion: isNameSuggestion,
            notConfirmed: notConfirmed,
            sanctioned: sanctioned,
            photosFilter: photosFilter
        }, property, nextVal));
    }, [getVessels, page, numberOfRows, isNameSuggestion, notConfirmed, sanctioned, photosFilter]);

    var pagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            className: 'center-xs middle-xs',
            style: { display: 'flex' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__["a" /* default */], {
            total: total,
            rowsPerPage: rowsPerPage,
            page: page,
            numberOfRows: numberOfRows,
            updateRows: function updateRows(s) {
                setPage(s.page);
                setNumberOfRows(s.numberOfRows);
                _updateRows(s);
            }
        })
    );

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Dialog___default.a,
            {
                ref: importDialogRef,
                title: 'Import/Update vessels from LOTUS',
                modal: false,
                open: vesselImportModalOpen,
                onRequestClose: handleCloseImportVessels,
                autoScrollBodyContent: true,
                style: { height: '60vh', width: '90vw' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__VesselImport__["a" /* default */], { onUpdate: handleUpdateImportDialog })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Filters__["a" /* default */], {
            searchRef: searchRef,
            defaultSearchValue: search,
            clearSearch: clearSearch,
            handleSearch: handleSearch,
            isNameSuggestion: isNameSuggestion,
            notConfirmed: notConfirmed,
            handleNameSuggested: handleNameSuggested,
            handleConfirmed: handleConfirmed,
            modifiedFilter: modifiedFilter,
            handleFilters: handleFilters,
            filterCargoExclusions: filterCargoExclusions,
            filterTradingRestrictions: filterTradingRestrictions,
            handleExclusions: handleExclusions,
            photosFilter: photosFilter,
            sanctioned: sanctioned,
            handleSanctioned: handleSanctioned,
            typeByPurpose: typeByPurpose,
            dwtMin: dwtMin,
            dwtMax: dwtMax,
            sortValue: sortValue,
            sortField: sortField,
            typeBySpecialty: typeBySpecialty,
            bltMin: bltMin,
            bltMax: bltMax,
            rightPart: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'center-xs middle-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'VESSELS: ',
                        vessels.total
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* CenterBox */],
                    null,
                    pagination
                )
            )
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnSmallCSS },
                            'imoNumber'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnSmallCSS },
                            'name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnSmallCSS },
                            'Year'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Type By Purpose'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Class'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnCSS },
                            'Gears'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnSmallCSS },
                            'Capacity (G/B)'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnSmallCSS },
                            'DWT'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnModified },
                            'Modified'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnModified },
                            'Sanction (RT)'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnSmallCSS },
                            'Actions'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false },
                    rows.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Row__["a" /* default */], { key: item._id, item: item });
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref3) {
    var vessels = _ref3.vessels,
        user = _ref3.user;
    return {
        vessels: vessels,
        userId: user._id
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getVessels: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_vessels__["f" /* getVessels */]
    }, dispatch);
})(VesselListTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselListTable, 'VesselListTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();













function VesselListRow(props) {
    var item = props.item;
    var modifiedFields = item.modifiedFields;


    var fields = [];
    if (modifiedFields) {
        fields = modifiedFields.map(function (i) {
            return i.updatedField;
        });
    }

    var showModifiedFields = function showModifiedFields() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnModifed },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                fields.includes('typeByConstruction') ? 'Type by construction' : null,
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                fields.includes('geared') ? 'Geared' : null,
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                fields.includes('deadWeight.sTpc') ? 'TPC' : null,
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                fields.includes('grabbed') ? 'Grab fitted' : null,
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                fields.includes('registerClass') ? 'Register class' : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
            )
        );
    };

    var gears = item.gearV2All ? item.gearV2All.join(', ') : null;
    if (!gears && item.geared) {
        gears = 'Geared';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRow"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS },
            item.imoNumber
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS },
            item.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS },
            item.blt
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
            item.typeByPurpose
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
            item.registerClass && item.registerClass.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
            gears
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS },
            item.capacity && item.capacity.grain
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS },
            item.dw && item.dw.summer
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnModifed },
            showModifiedFields()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS },
            item.rt && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'text-center' },
                item.rt.countryName,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.rt.enteredAt).format('DD-MM-YYYY')
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnSmallCSS },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                label: 'Edit',
                primary: true,
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */], { to: '/vessels/' + item._id })
            })
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, _ref) {
    var item = _ref.item;
    return {
        item: item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(VesselListRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselListRow, 'VesselListRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dropzone__ = __webpack_require__(3297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_upload__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_flatMap__ = __webpack_require__(3301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_vessels_import__ = __webpack_require__(3302);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-04-19 14:57:06 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-04-23 13:46:07
 */








var styles = {
    dropzone: {
        width: "100%",
        height: "200px",
        borderWidth: "2px",
        borderColor: "rgb(102, 102, 102)",
        borderStyle: "dashed",
        borderRadius: "5px",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        cursor: "pointer"
    },
    uploadIconStyle: {
        color: "rgb(154, 154, 154)",
        width: "48px",
        height: "48px"
    },
    resultWrapper: {
        flexDirection: "column"
    },
    resultHeader: {
        textAlign: "center"
    },
    itemsContainer: {
        maxHeight: "400px",
        overflowY: "auto"
    },
    itemHeader: {
        textAlign: "center",
        paddingTop: "0.5em",
        marginTop: "0.5em",
        marginBottom: "0.5em",
        borderTop: "1px #909090 solid",
        display: "block"
    },
    itemStyle: {
        margin: "0"
    },
    forceUpdate: {
        margin: "1em auto 0"
    }
};

var VesselImport = function (_React$Component) {
    _inherits(VesselImport, _React$Component);

    function VesselImport(props, context) {
        _classCallCheck(this, VesselImport);

        var _this = _possibleConstructorReturn(this, (VesselImport.__proto__ || Object.getPrototypeOf(VesselImport)).call(this, props, context));

        _this.state = {};

        _this.onDrop = _this.onDrop.bind(_this);
        _this.forceUpdateVessels = _this.forceUpdateVessels.bind(_this);
        return _this;
    }

    _createClass(VesselImport, [{
        key: "forceUpdateVessels",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.tryImport(this.lastFile, true);

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function forceUpdateVessels() {
                return _ref.apply(this, arguments);
            }

            return forceUpdateVessels;
        }()
    }, {
        key: "onDrop",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(acceptedFiles, rejectedFiles) {
                var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.lastFile = acceptedFiles[0];

                                _context2.next = 3;
                                return this.tryImport(this.lastFile);

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function onDrop(_x, _x2) {
                return _ref2.apply(this, arguments);
            }

            return onDrop;
        }()
    }, {
        key: "tryImport",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(file) {
                var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                var response, _error$response$data, status, statusText, errors;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.setState({ loading: true });
                                _context3.prev = 1;
                                _context3.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_5_services_vessels_import__["a" /* importVessels */])(file, forceUpdate);

                            case 4:
                                response = _context3.sent;


                                this.setState({
                                    loading: false,
                                    forceSaveAvailable: false,
                                    header: "No changes to save",
                                    data: undefined
                                });
                                _context3.next = 12;
                                break;

                            case 8:
                                _context3.prev = 8;
                                _context3.t0 = _context3["catch"](1);
                                _error$response$data = _context3.t0.response.data, status = _error$response$data.status, statusText = _error$response$data.statusText, errors = _error$response$data.errors;


                                this.setState({
                                    loading: false,
                                    forceSaveAvailable: status == 409,
                                    header: statusText,
                                    data: errors
                                });

                            case 12:
                                _context3.prev = 12;

                                this.props.onUpdate && this.props.onUpdate();
                                return _context3.finish(12);

                            case 15:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[1, 8, 12, 15]]);
            }));

            function tryImport(_x4) {
                return _ref3.apply(this, arguments);
            }

            return tryImport;
        }()
    }, {
        key: "render",
        value: function render() {
            var dropzoneStyle = _extends({}, styles.dropzone, {
                cursor: this.state.loading ? "wait" : "pointer"
            });
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                "div",
                { className: "content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        __WEBPACK_IMPORTED_MODULE_1_react_dropzone__["a" /* default */],
                        { multiple: false, style: dropzoneStyle, onDrop: this.onDrop },
                        this.state.loading ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            "p",
                            null,
                            "Loading..."
                        ) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_file_file_upload___default.a, { style: styles.uploadIconStyle }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                "p",
                                null,
                                "Choose a file or drag it here"
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    { className: "row" },
                    this.state.forceSaveAvailable && this.lastFile ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, { label: "Update", secondary: true, disabled: this.state.loading, style: styles.forceUpdate, onClick: this.forceUpdateVessels }) : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    { className: "row", style: styles.resultWrapper },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "h3",
                        { style: styles.resultHeader },
                        this.state.header
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "div",
                        { style: styles.itemsContainer },
                        this.state.data ? __WEBPACK_IMPORTED_MODULE_4_lodash_flatMap___default()(this.state.data, function (error) {
                            return [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                "b",
                                { style: styles.itemHeader },
                                error.ship
                            )].concat(_toConsumableArray(error.messages.map(function (item) {
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { style: styles.itemStyle, dangerouslySetInnerHTML: { __html: item } });
                            })));
                        }) : ""
                    )
                )
            );
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselImport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = VesselImport;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, "styles", "/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/VesselImport.jsx");
    reactHotLoader.register(VesselImport, "VesselImport", "/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/VesselImport.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/VesselImport.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(3298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(3300);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 3298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(3299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 3299 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 3300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 3301 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(341),
    map = __webpack_require__(143);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 3302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = importVessels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-04-19 15:29:44 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-04-23 13:09:22
 */



var base = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: '/api/v1/'
});

function importVessels(file, forceUpdate) {
    var formData = new FormData();
    formData.append("file", file);

    return base.patch("vessels/upload", formData, { params: { forceOverwriteAll: forceUpdate || undefined } });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(base, "base", "/opt/atlassian/pipelines/agent/build/client/app/services/vessels/import.js");
    reactHotLoader.register(importVessels, "importVessels", "/opt/atlassian/pipelines/agent/build/client/app/services/vessels/import.js");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = VesselsListFilters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_vesselTypes__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Single_Rows_TypeBySpecialty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(957);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();













var getDate = function getDate(type) {
    var date = new Date();
    switch (type) {
        case 'week':
            date.setDate(date.getDate() - 7);return date;
        case 'month':
            date.setMonth(date.getMonth() - 1);return date;
        case 'year':
            date.setFullYear(date.getFullYear() - 1);return date;
        default:
            return date;
    }
};

var exclusionsAndRestrictions = [{ date: null, label: 'Any' }, { date: getDate('week'), label: 'Last Week' }, { date: getDate('month'), label: 'Last Month' }, { date: getDate('year'), label: 'Last Year' }];

var filterRowStyle = {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: 16,
    width: '70%'
};

var selectStyle = {
    width: 150,
    textAlign: 'left',
    fontSize: '13px'
};

var labelStyle = {
    left: '0',
    fontSize: '13px'
};

var numberInputStyle = {
    width: 90,
    fontSize: '13px'
};

var checkboxStyle = {
    display: 'inline-block',
    width: 'auto',
    whiteSpace: 'nowrap'
};

var checkboxLabelStyle = {
    fontSize: '13px'
};

function VesselsListFilters(_ref) {
    var searchRef = _ref.searchRef,
        defaultSearchValue = _ref.defaultSearchValue,
        clearSearch = _ref.clearSearch,
        handleSearch = _ref.handleSearch,
        isNameSuggestion = _ref.isNameSuggestion,
        notConfirmed = _ref.notConfirmed,
        handleNameSuggested = _ref.handleNameSuggested,
        handleConfirmed = _ref.handleConfirmed,
        modifiedFilter = _ref.modifiedFilter,
        handleFilters = _ref.handleFilters,
        filterCargoExclusions = _ref.filterCargoExclusions,
        filterTradingRestrictions = _ref.filterTradingRestrictions,
        handleExclusions = _ref.handleExclusions,
        photosFilter = _ref.photosFilter,
        sanctioned = _ref.sanctioned,
        handleSanctioned = _ref.handleSanctioned,
        rightPart = _ref.rightPart,
        typeByPurpose = _ref.typeByPurpose,
        typeBySpecialty = _ref.typeBySpecialty,
        dwtMin = _ref.dwtMin,
        dwtMax = _ref.dwtMax,
        bltMin = _ref.bltMin,
        bltMax = _ref.bltMax,
        sortValue = _ref.sortValue,
        sortField = _ref.sortField;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: { width: '60%' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: {
                            display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                        defaultValue: defaultSearchValue,
                        floatingLabelText: 'Search by IMO or name',
                        ref: searchRef,
                        style: { width: 200 },
                        onChange: clearSearch,
                        onKeyPress: function onKeyPress(event) {
                            if (event.charCode === 13) {
                                event.preventDefault();
                                handleSearch();
                            }
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                        label: 'Search',
                        style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].RaisedButton,
                        primary: true,
                        onClick: handleSearch
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox___default.a, {
                        label: 'Not confirmed',
                        checked: notConfirmed,
                        onCheck: handleConfirmed,
                        style: checkboxStyle,
                        labelStyle: checkboxLabelStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox___default.a, {
                        label: 'Rename suggestion',
                        checked: isNameSuggestion,
                        onCheck: handleNameSuggested,
                        style: checkboxStyle,
                        labelStyle: checkboxLabelStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Checkbox___default.a, {
                        label: 'Sanctioned',
                        checked: sanctioned,
                        onCheck: handleSanctioned,
                        style: checkboxStyle,
                        labelStyle: checkboxLabelStyle
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: { width: '40%' } },
                rightPart
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: filterRowStyle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                    {
                        floatingLabelText: 'Type by purpose',
                        floatingLabelStyle: labelStyle,
                        value: typeByPurpose || '',
                        onChange: function onChange(_e, _i, val) {
                            return handleFilters('typeByPurpose', val || '');
                        },
                        style: selectStyle
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: '', primaryText: '' }),
                    __WEBPACK_IMPORTED_MODULE_8_constants_vesselTypes__["b" /* types */].map(function (tp) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { key: tp, value: tp, primaryText: tp });
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Single_Rows_TypeBySpecialty__["a" /* default */], {
                    typeBySpecialty: typeBySpecialty || '',
                    fromTcOrder: false,

                    style: selectStyle,
                    changeField: function changeField(vals) {
                        var v = vals.find(function (val) {
                            return val.field === 'typeBySpecialty';
                        }).value;
                        return handleFilters('typeBySpecialty', v === '' ? undefined : v);
                    },
                    typeByPurpose: typeByPurpose,
                    withoutSpecialtyEnabled: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'flex-end', gap: 8 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                        floatingLabelText: 'DWT min',
                        type: 'number',
                        value: dwtMin || '',
                        onChange: function onChange(_e, v) {
                            return handleFilters('dwtMin', v === '' ? null : Number(v));
                        },
                        style: numberInputStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { paddingBottom: 10, color: '#888' } },
                        '\u2013'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                        floatingLabelText: 'DWT max',
                        type: 'number',
                        value: dwtMax || '',
                        onChange: function onChange(_e, v) {
                            return handleFilters('dwtMax', v === '' ? null : Number(v));
                        },
                        style: numberInputStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'flex-end', gap: 8 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                        floatingLabelText: 'BLT min',
                        type: 'number',
                        value: bltMin || '',
                        onChange: function onChange(_e, v) {
                            return handleFilters('bltMin', v === '' ? null : Number(v));
                        },
                        style: numberInputStyle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { paddingBottom: 10, color: '#888' } },
                        '\u2013'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                        floatingLabelText: 'BLT max',
                        type: 'number',
                        value: bltMax || '',
                        onChange: function onChange(_e, v) {
                            return handleFilters('bltMax', v === '' ? null : Number(v));
                        },
                        style: numberInputStyle
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                    {
                        floatingLabelText: 'Sort by BLT',
                        floatingLabelStyle: labelStyle,
                        value: sortField === 'blt' ? sortValue : null,
                        onChange: function onChange(_e, _i, val) {
                            var isBlank = val == null;
                            handleFilters({
                                sortField: isBlank ? undefined : 'blt',
                                sortValue: isBlank ? undefined : val
                            });
                        },
                        style: _extends({}, selectStyle, { width: 130 })
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: null, primaryText: '' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: -1, primaryText: 'Newest first' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 1, primaryText: 'Oldest first' })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* CenterBox */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                        label: 'ADD NEW VESSEL',
                        style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].RaisedButton,
                        primary: true,
                        containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* Link */], { to: '/vessels/add' })
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: filterRowStyle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                    {
                        floatingLabelText: 'Modified',
                        floatingLabelStyle: labelStyle,
                        value: modifiedFilter,
                        onChange: function onChange(_ev, _idx, val) {
                            return handleFilters('modifiedFilter', val);
                        },
                        style: selectStyle
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'all', primaryText: 'All' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'modified', primaryText: 'Modified' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'notModified', primaryText: 'Not modified' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                    {
                        floatingLabelText: 'Photos',
                        floatingLabelStyle: labelStyle,
                        value: photosFilter,
                        onChange: function onChange(_ev, _idx, val) {
                            return handleFilters('photosFilter', val);
                        },
                        style: selectStyle
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'all', primaryText: 'All' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'withPhotos', primaryText: 'With photos' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'withoutPhotos', primaryText: 'Without photos' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { borderLeft: '1px solid #ccc', height: 28, margin: '0 4px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                    {
                        floatingLabelText: 'Cargo exclusions',
                        floatingLabelStyle: labelStyle,
                        value: filterCargoExclusions,
                        onChange: function onChange(_ev, _idx, val) {
                            return handleExclusions(val, 'filterCargoExclusions');
                        },
                        style: _extends({}, selectStyle, { width: 160 })
                    },
                    exclusionsAndRestrictions.map(function (excl, idx) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                            key: idx,
                            value: excl.date ? excl.date.toISOString() : null,
                            primaryText: excl.label
                        });
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                    {
                        floatingLabelText: 'Trading restrictions',
                        floatingLabelStyle: labelStyle,
                        value: filterTradingRestrictions,
                        onChange: function onChange(_ev, _idx, val) {
                            return handleExclusions(val, 'filterTradingRestrictions');
                        },
                        style: _extends({}, selectStyle, { width: 170 })
                    },
                    exclusionsAndRestrictions.map(function (excl, idx) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, {
                            key: idx,
                            value: excl.date ? excl.date.toISOString() : null,
                            primaryText: excl.label
                        });
                    })
                )
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getDate, 'getDate', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(exclusionsAndRestrictions, 'exclusionsAndRestrictions', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(filterRowStyle, 'filterRowStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(selectStyle, 'selectStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(labelStyle, 'labelStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(numberInputStyle, 'numberInputStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(checkboxStyle, 'checkboxStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(checkboxLabelStyle, 'checkboxLabelStyle', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    reactHotLoader.register(VesselsListFilters, 'VesselsListFilters', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/List/Filters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List__ = __webpack_require__(3305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_vessels_request__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_index__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var RequestsPage = function (_React$Component) {
    _inherits(RequestsPage, _React$Component);

    function RequestsPage(props) {
        _classCallCheck(this, RequestsPage);

        return _possibleConstructorReturn(this, (RequestsPage.__proto__ || Object.getPrototypeOf(RequestsPage)).call(this, props));
    }

    _createClass(RequestsPage, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getRequestsVessel({
                page: 1,
                filters: {
                    all: true
                },
                sort: {
                    field: 'addedAt',
                    value: -1
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'vessel-requests', className: 'requests-page page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_6_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Vessel requests'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__List__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RequestsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        isLoaded: state.vesselRequests.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getRequestsVessel: __WEBPACK_IMPORTED_MODULE_5_actions_vessels_request__["b" /* getRequestsVessel */]
    }, dispatch);
})(RequestsPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RequestsPage, 'RequestsPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Requests/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Requests/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_request__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Item__ = __webpack_require__(3306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Base_EhSelector__ = __webpack_require__(569);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var styles = {
    radioGroup: {
        margin: '20px 0'
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%'
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

var List = function (_React$Component) {
    _inherits(List, _React$Component);

    function List(props) {
        _classCallCheck(this, List);

        var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

        _this.state = {
            page: 1,
            filters: {
                search: '',
                eh: []
            }
        };

        _this.updateRows = _this.updateRows.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);

        _this.prevPage = _this.prevPage.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);
        _this.handleEhChange = _this.handleEhChange.bind(_this);
        return _this;
    }

    _createClass(List, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            this.setState({
                page: props.vesselRequests.page
            });
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            var _this2 = this;

            this.setState({
                page: this.props.vesselRequests.next
            }, function () {
                _this2.updateRows(_this2.state);
            });
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            var _this3 = this;

            this.setState({
                page: this.props.vesselRequests.previous
            }, function () {
                _this3.updateRows(_this3.state);
            });
        }
    }, {
        key: 'updateRows',
        value: function updateRows(state) {
            this.props.getRequestsVessel({
                page: state.page,
                filters: {
                    all: true,
                    search: state.filters.search.length !== 0 ? state.filters.search : undefined,
                    eh: state.filters.eh
                },
                sort: {
                    field: 'addedAt',
                    value: -1
                }
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch() {
            var _this4 = this;

            this.setState({
                page: 1,
                filters: _extends({}, this.state.filters, {
                    search: this.refs.search.input.value
                })
            }, function () {
                _this4.updateRows(_this4.state);
            });
        }
    }, {
        key: 'handleEhChange',
        value: function handleEhChange(eh) {
            var _this5 = this;

            this.setState(_extends({}, this.state, {
                filters: _extends({}, this.state.filters, {
                    eh: eh
                })
            }), function () {
                _this5.updateRows(_this5.state);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var vesselRequests = this.props.vesselRequests;
            var vesselRequestsItems = vesselRequests.data;

            if (!vesselRequestsItems) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'filter' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'search filter-column', style: { width: '100%', justifyContent: 'space-between' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                                defaultValue: this.state.search,
                                floatingLabelText: 'Search',
                                ref: 'search',
                                onKeyPress: function onKeyPress(event) {
                                    if (event.charCode === 13) {
                                        event.preventDefault();
                                        _this6.handleSearch();
                                    }
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Base_EhSelector__["a" /* EhSelector */], { values: this.state.filters.eh, onChange: this.handleEhChange }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { style: { display: 'flex', alignItems: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationLeft,
                                        name: 'navigationLeft',
                                        onClick: this.prevPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'item' },
                                    'Page: ',
                                    this.state.page
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationRight,
                                        name: 'navigationRight',
                                        onClick: this.nextPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                                label: 'Search',
                                style: { fontSize: '13px', margin: '0 0 0 10px' },
                                primary: true,
                                onClick: this.handleSearch
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'ul',
                            { className: 'list-requests' },
                            vesselRequestsItems.map(function (item) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Item__["a" /* default */], { key: item._id, item: item });
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return List;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        vesselRequests: state.vesselRequests
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getRequestsVessel: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_request__["b" /* getRequestsVessel */]
    }, dispatch);
})(List);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Requests/List.jsx');
    reactHotLoader.register(List, 'List', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Requests/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Requests/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_request__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Base_Mails_OpenMailBlock__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sagas_orders__ = __webpack_require__(163);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var Item = function (_React$Component) {
    _inherits(Item, _React$Component);

    function Item(props) {
        var _this2 = this;

        _classCallCheck(this, Item);

        var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));

        _this.saveRequestsDataDeleted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return Object(__WEBPACK_IMPORTED_MODULE_11_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_12_sagas_orders__["b" /* saveRequestsDataDeleted */], 'vessel', { mailId: _this.props.item.mailId });

                        case 3:
                            _context.next = 8;
                            break;

                        case 5:
                            _context.prev = 5;
                            _context.t0 = _context['catch'](0);

                            console.error(_context.t0);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 5]]);
        }));


        _this.state = {
            userEmails: [],
            item: props.item || {},
            name: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(props.item, 'addedBy.name') ? props.item.addedBy.name : '',
            surname: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(props.item, 'addedBy.surname') ? props.item.addedBy.surname : '',
            email: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(props.item, 'addedBy.email') ? props.item.addedBy.email : '',
            id: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(props.item, 'addedBy._id') ? props.item.addedBy._id : '',
            vesselRequestId: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(props.item, '_id') ? props.item._id : '',
            isUpdate: false
        };

        _this.changeUser = _this.changeUser.bind(_this);
        _this.chooseUser = _this.chooseUser.bind(_this);
        _this.deleteVesselRequest = _this.deleteVesselRequest.bind(_this);
        _this.updateVesselRequest = _this.updateVesselRequest.bind(_this);
        _this.saveRequestsDataDeleted = _this.saveRequestsDataDeleted.bind(_this);
        return _this;
    }

    _createClass(Item, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                isUpdate: nextProps.item.isUpdate,
                item: nextProps.item
            });
        }
    }, {
        key: 'deleteVesselRequest',
        value: function deleteVesselRequest() {
            this.props.item.mailId && this.saveRequestsDataDeleted();
            this.props.deleteRequestVessel(this.props.item.vessel, this.props.item._id);
        }
    }, {
        key: 'updateVesselRequest',
        value: function updateVesselRequest() {
            var _this3 = this;

            this.setState({
                isUpdate: true
            }, function () {
                _this3.props.updateRequestVessel(_this3.state.vesselRequestId, _this3.state.id);
            });
        }
    }, {
        key: 'changeUser',
        value: function changeUser(searchText) {
            var _this4 = this;

            this.setState({
                email: searchText,
                isUpdate: false
            }, function () {
                __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].findUser(searchText).then(function (response) {
                    var userEmails = response.data.data.map(function (user) {
                        return {
                            name: user.email + ' - (' + (user.name || '') + ' ' + (user.surname || '') + ')',
                            item: user
                        };
                    });

                    _this4.setState({
                        userEmails: userEmails
                    });
                }).catch(function () {
                    return null;
                });
            });
        }
    }, {
        key: 'chooseUser',
        value: function chooseUser(updateProperties) {
            if (!updateProperties) {
                return;
            }

            this.setState({
                name: updateProperties.item.name,
                surname: updateProperties.item.surname,
                email: updateProperties.item.email,
                id: updateProperties.item._id,
                isUpdate: true
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                name = _state.name,
                surname = _state.surname,
                email = _state.email,
                userEmails = _state.userEmails,
                isUpdate = _state.isUpdate;
            var item = this.props.item;


            var autoComplete = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a, {
                textFieldStyle: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].autoCompleteCSS,
                hintText: 'User',
                searchText: email,
                dataSource: userEmails,
                dataSourceConfig: { text: 'name', value: 'item' },
                onUpdateInput: this.changeUser,
                onNewRequest: this.chooseUser,
                filter: __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a.noFilter,
                fullWidth: true,
                listStyle: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].autoCompleteListStyle,
                popoverProps: {
                    canAutoPosition: true,
                    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                    targetOrigin: { horizontal: 'left', vertical: 'top' }
                }
            });

            var managementBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name-block absolute small-name' },
                    'Managment'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                    onClick: this.deleteVesselRequest,
                    label: 'Delete',
                    style: { margin: '0 10px 0 0' },
                    secondary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                    onClick: this.updateVesselRequest,
                    disabled: !isUpdate,
                    label: 'Update user',
                    style: { margin: '0 10px 0 0' },
                    primary: true
                })
            );

            if (item.deleteBy) {
                managementBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Deleted'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Delete at: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.deleteAt).format('MM-DD-YYYY'),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Delete by: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(item, 'deleteBy.email') ? item.deleteBy.email : ''
                );

                autoComplete = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Email: '
                    ),
                    this.state.email
                );
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block item-request' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'unique info'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'refNo: '
                        ),
                        item.refNo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'info'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'name: '
                        ),
                        item.name,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'dwt: '
                        ),
                        item.dwt,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'imoNumber: '
                        ),
                        item.imoNumber,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Company'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(item, 'addedBy.company.name') ? item.addedBy.company.name : ''
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Open position'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        item.open.name,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'From: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.open.from).startOf('day').toDate().toLocaleDateString(),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Until: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.open.until).startOf('day').toDate().toLocaleDateString(),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'User'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        name,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Surname: '
                        ),
                        surname,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        autoComplete
                    ),
                    item.realUser && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Real user'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Email: '
                        ),
                        item.realUser.email,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    ),
                    managementBlock,
                    item.mailId && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Base_Mails_OpenMailBlock__["a" /* default */], { mailId: item.mailId })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Item;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {
        item: ownProps.item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ updateRequestVessel: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_request__["d" /* updateRequestVessel */], deleteRequestVessel: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_request__["a" /* deleteRequestVessel */] }, dispatch);
})(Item);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Item, 'Item', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Requests/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Requests/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_vessels_sales__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(3308);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var VesselsSalesPage = function (_React$PureComponent) {
    _inherits(VesselsSalesPage, _React$PureComponent);

    function VesselsSalesPage() {
        _classCallCheck(this, VesselsSalesPage);

        return _possibleConstructorReturn(this, (VesselsSalesPage.__proto__ || Object.getPrototypeOf(VesselsSalesPage)).apply(this, arguments));
    }

    _createClass(VesselsSalesPage, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'vessel-requests', className: 'requests-page page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["d" /* CircularProgress */], {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_5_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Vessel Sales'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__List__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselsSalesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLoaded: state.vesselSales.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getVesselSales: __WEBPACK_IMPORTED_MODULE_3_actions_vessels_sales__["d" /* getVesselSales */]
    }, dispatch);
})(VesselsSalesPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselsSalesPage, 'VesselsSalesPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Sales/VesselSales.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Sales/VesselSales.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_vessels_sales__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Item__ = __webpack_require__(3309);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var styles = {
    radioGroup: {
        margin: '20px 0'
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%'
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

var List = function (_React$Component) {
    _inherits(List, _React$Component);

    function List(props) {
        _classCallCheck(this, List);

        var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

        _this.state = {
            page: 1,
            filters: {
                search: ''
                // eh: [],
            }
        };

        _this.updateRows = _this.updateRows.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);

        _this.prevPage = _this.prevPage.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);
        return _this;
    }

    _createClass(List, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getVesselSales({
                page: 1,
                filters: {}
            });
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            var _this2 = this;

            this.setState({
                page: this.props.vesselSales.next
            }, function () {
                _this2.updateRows(_this2.state);
            });
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            var _this3 = this;

            this.setState({
                page: this.props.vesselSales.previous
            }, function () {
                _this3.updateRows(_this3.state);
            });
        }
    }, {
        key: 'updateRows',
        value: function updateRows(state) {
            this.props.getVesselSales({
                page: state.page,
                filters: {
                    search: state.filters.search.length !== 0 ? state.filters.search : undefined
                }
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch() {
            var _this4 = this;

            this.setState({
                page: 1,
                filters: _extends({}, this.state.filters, {
                    search: this.refs.search.input.value
                })
            }, function () {
                _this4.updateRows(_this4.state);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var vesselSales = this.props.vesselSales;
            var vesselSalesItems = vesselSales.data;
            if (!vesselSalesItems) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'filter' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'filter-row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'search filter-column', style: { width: '100%', justifyContent: 'space-between' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                                    defaultValue: this.state.search,
                                    floatingLabelText: 'Search',
                                    ref: 'search',
                                    onKeyPress: function onKeyPress(event) {
                                        if (event.charCode === 13) {
                                            event.preventDefault();
                                            _this5.handleSearch();
                                        }
                                    }
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                                    label: 'Search',
                                    style: { fontSize: '13px', margin: '0 0 0 50px' },
                                    primary: true,
                                    onClick: this.handleSearch
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { style: { display: 'flex', alignItems: 'center' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationLeft,
                                        name: 'navigationLeft',
                                        onClick: this.prevPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'item' },
                                    'Page: ',
                                    this.state.page
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: styles.navigationRight,
                                        name: 'navigationRight',
                                        onClick: this.nextPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'ul',
                            { className: 'list-requests' },
                            vesselSalesItems.map(function (item) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Item__["a" /* default */], { key: item._id, item: item });
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return List;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        vesselSales: state.vesselSales
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getVesselSales: __WEBPACK_IMPORTED_MODULE_8_actions_vessels_sales__["d" /* getVesselSales */]
    }, dispatch);
})(List);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Sales/List.jsx');
    reactHotLoader.register(List, 'List', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Sales/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Sales/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_vessels_sales__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sagas_orders__ = __webpack_require__(163);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Item = function (_React$PureComponent) {
    _inherits(Item, _React$PureComponent);

    function Item() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, Item);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.saveRequestsDataDeleted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return Object(__WEBPACK_IMPORTED_MODULE_7_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_8_sagas_orders__["b" /* saveRequestsDataDeleted */], 'vessel', { mailId: _this.props.item.mailId });

                        case 3:
                            _context.next = 8;
                            break;

                        case 5:
                            _context.prev = 5;
                            _context.t0 = _context['catch'](0);

                            console.error(_context.t0);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 5]]);
        })), _this.deleteVesselRequest = function () {
            _this.props.item.mailId && _this.saveRequestsDataDeleted();
            _this.props.deleteVesselSale(_this.props.item._id);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Item, [{
        key: 'render',
        value: function render() {
            var item = this.props.item;


            var managementBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name-block absolute small-name' },
                    'Managment'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                    onClick: this.deleteVesselRequest,
                    label: 'Delete',
                    style: { margin: '0 10px 0 0' },
                    secondary: true
                })
            );

            if (item.deleteBy) {
                managementBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Deleted'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Delete at: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.deleteAt).format('MM-DD-YYYY'),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Delete by: '
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'deleteBy.email') ? item.deleteBy.email : ''
                );
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block item-request' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'unique info'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'refNo: '
                        ),
                        item.refNo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'info'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'name: '
                        ),
                        item.vesselData.name,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'dwt: '
                        ),
                        item.vesselData.deadWeight.sDWT,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'imoNumber: '
                        ),
                        item.vesselData.imoNumber,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Company'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'companyData.name') ? item.companyData.name : ''
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'User'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        item.userData.name,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Surname: '
                        ),
                        item.userData.surname,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Surname: '
                        ),
                        item.userData.email,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-4' },
                    item.salePrice || item.ideaPrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Sale info'
                        ),
                        item.salePrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                null,
                                'Sale price: '
                            ),
                            item.salePrice,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                        ) : null,
                        item.ideaPrice ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                null,
                                'Idea price: '
                            ),
                            item.ideaPrice,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                        ) : null
                    ) : null,
                    item.realUserEmail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Real user'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Email: '
                        ),
                        item.realUserEmail,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    ),
                    managementBlock
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Item;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, ownProps) {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ deleteVesselSale: __WEBPACK_IMPORTED_MODULE_6_actions_vessels_sales__["c" /* deleteVesselSale */] }, dispatch);
})(Item);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Item, 'Item', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Sales/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Sales/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List__ = __webpack_require__(3311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_vessels_claims__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_index__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var VesselClaimsListPage = function (_React$Component) {
    _inherits(VesselClaimsListPage, _React$Component);

    function VesselClaimsListPage(props) {
        _classCallCheck(this, VesselClaimsListPage);

        return _possibleConstructorReturn(this, (VesselClaimsListPage.__proto__ || Object.getPrototypeOf(VesselClaimsListPage)).call(this, props));
    }

    _createClass(VesselClaimsListPage, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getVesselClaims();
        }
    }, {
        key: 'render',
        value: function render() {
            var isLoaded = this.props.isLoaded;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'vessel-claims', className: 'page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_6_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Vessel claims'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__List__["a" /* default */], null)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselClaimsListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var isLogged = _ref.user.isLogged,
        isLoaded = _ref.vesselClaims.isLoaded;

    return {
        isLogged: isLogged,
        isLoaded: isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getVesselClaims: __WEBPACK_IMPORTED_MODULE_5_actions_vessels_claims__["b" /* getVesselClaims */]
    }, dispatch);
})(VesselClaimsListPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselClaimsListPage, 'VesselClaimsListPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Claims/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Claims/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item__ = __webpack_require__(3312);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var VesselClaimsList = function (_React$Component) {
    _inherits(VesselClaimsList, _React$Component);

    function VesselClaimsList(props) {
        _classCallCheck(this, VesselClaimsList);

        return _possibleConstructorReturn(this, (VesselClaimsList.__proto__ || Object.getPrototypeOf(VesselClaimsList)).call(this, props));
    }

    _createClass(VesselClaimsList, [{
        key: 'render',
        value: function render() {
            var items = this.props.vesselClaims.items;


            if (!items) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'list-claims' },
                        items.map(function (item, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Item__["a" /* default */], { key: key, item: item });
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselClaimsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var vesselClaims = _ref.vesselClaims;

    return {
        vesselClaims: vesselClaims
    };
})(VesselClaimsList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselClaimsList, 'VesselClaimsList', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Claims/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Claims/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_vessels_claims__ = __webpack_require__(502);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var VesselClaimsItem = function (_React$Component) {
    _inherits(VesselClaimsItem, _React$Component);

    function VesselClaimsItem(props) {
        _classCallCheck(this, VesselClaimsItem);

        var _this = _possibleConstructorReturn(this, (VesselClaimsItem.__proto__ || Object.getPrototypeOf(VesselClaimsItem)).call(this, props));

        _this.handleAccept = _this.handleAccept.bind(_this);
        _this.handleReject = _this.handleReject.bind(_this);
        return _this;
    }

    _createClass(VesselClaimsItem, [{
        key: 'handleAccept',
        value: function handleAccept(userId, vesselId) {
            this.props.acceptUserClaimsToVessel(userId, vesselId);
        }
    }, {
        key: 'handleReject',
        value: function handleReject(userId, vesselId) {
            this.props.rejectUserClaimsToVessel(userId, vesselId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var item = this.props.item;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item-claim row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'name-block absolute small-name' },
                            'Vessel info ',
                            item._id
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Name: '
                        ),
                        item.name,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Capacity: '
                        ),
                        item.capacity,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'Built: '
                        ),
                        item.built,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            'ImoNumber: '
                        ),
                        item.imoNumber
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col col-xs-9' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        item.users.map(function (user, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: key, className: 'paper-block col-xs-4' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'name-block absolute small-name' },
                                    'User info ',
                                    user._id
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Name: '
                                ),
                                user.name,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Surname: '
                                ),
                                user.surname,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'email: '
                                ),
                                user.email,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'addedAt: '
                                ),
                                __WEBPACK_IMPORTED_MODULE_3_moment___default()(user.addedAt).format('MM-DD-YYYY'),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Company: '
                                ),
                                user.company ? user.company.name : '',
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                                    onClick: function onClick() {
                                        _this2.handleReject(user._id, item._id);
                                    },
                                    label: 'reject',
                                    secondary: true
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                                    onClick: function onClick() {
                                        _this2.handleAccept(user._id, item._id);
                                    },
                                    label: 'accept',
                                    primary: true
                                })
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselClaimsItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var item = _ref.item;

    return {
        item: item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        acceptUserClaimsToVessel: __WEBPACK_IMPORTED_MODULE_5_actions_vessels_claims__["a" /* acceptUserClaimsToVessel */],
        rejectUserClaimsToVessel: __WEBPACK_IMPORTED_MODULE_5_actions_vessels_claims__["c" /* rejectUserClaimsToVessel */]
    }, dispatch);
})(VesselClaimsItem);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselClaimsItem, 'VesselClaimsItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Claims/Item.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Claims/Item.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Rows_SuggestionNames__ = __webpack_require__(3314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Rows_Flag__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Rows_Blt__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Rows_Areas__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Rows_Manager__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Rows_PortOfRegistry__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Rows_HoldsHatchesTop__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Rows_Strength__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Rows_StackWeight__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Rows_OtherFields__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Rows_ImoNumber__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Rows_Name__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Sidebar__ = __webpack_require__(3316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Rows_BuilderCountry__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Rows_BuilderYard__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Rows_RegisterClass__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Rows_PIClub__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Rows_TypeByPurpose__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Rows_TypeByConstruction__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Rows_TypeBySpecialty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Rows_GearV2__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Rows_GrabV2__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Rows_TechEquipCertificate__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Rows_CargoExclussionsV2__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Rows_TradingRestrictions__ = __webpack_require__(3318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Rows_Deadweight__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Rows_Tonnage__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Rows_Dimensions__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Rows_CapacityV2__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Rows_Cells__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Rows_ExNames__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_services_vessels_vessels__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Rows_SpeedConsumptionV2__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Rows_Bunkers__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Rows_Description__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Rows_Design__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Rows_DisponentOwner__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Rows_LinerMeter__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Rows_GearedGrabbed__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Rows_Nationalities__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Rows_RegisterClasses__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Rows_TypeBySize__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Rows_Pumps__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Rows_LastCargo__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Rows_CapacityTanker__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Rows_Manifolds__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Rows_CertificateOfFitness__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_components_Base_NumberField__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Rows_RegisteredOwner__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_helpers_vessels__ = __webpack_require__(528);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

































































function scroll() {
    this.blur();
}

var defaultCargo = {
    cargo: { _id: '', name: '' },
    date: null
};

function getInitialState() {
    return {
        confirmed: true,
        imoClass: '',
        areas: {},
        capacity: {},
        speeds: {},
        dimensions: {
            loa: undefined,
            beam: undefined,
            depth: undefined,
            lbp: undefined
        },
        strength: {
            tanktopByHolds: ['']
        },
        stackWeight: {},
        bunkers: [{
            quantity: undefined,
            typeOfFuel: ''
        }],
        consumptions: {
            laden: [],
            ballast: [],
            eco: [],
            portIdle: [],
            portWorking: []
        },
        holds: { lowerDims: [], tweenDims: [] },
        hatches: { size: [] },
        holdsHatchesProducer: '',

        builderV2: {
            yard: { _id: '', name: '' },
            country: { _id: '', name: '' }
        },
        registerClass: { _id: '', name: '' },
        piClubObject: { _id: '', name: '' },
        iacsRegister: false,
        isRewriteOwnerExclusions: false,
        type: '',
        typeByPurpose: undefined,
        typeByConstruction: undefined,
        typeBySize: '',
        typeBySpecialty: '',
        openHatch: null,
        boxShaped: null,
        gearV2: {
            summary: [{
                type: '',
                quantity: '',
                capacity: '',
                outreach: '',
                maxSWL: '',
                combinable: false
            }]
        },
        gearV2All: [],
        geared: null,
        grabV2: {
            summary: [{
                type: '',
                quantity: '',
                volume: ''
            }]
        },
        grabbed: null,
        techEquipCertificate: {
            co2Fitted: null,
            a60BulkheadFitted: null,
            cementHolesCount: '',
            cementHolesDia: '',
            newPanama: null,
            cementHolesFitted: null,
            referPlugFitted: null,
            itfFitted: null,
            lakesFitted: null,
            strengthenHeavy: null,
            logsFitted: null,
            aussieFitted: null,
            iceClass: '',
            ventilation: '',
            ventilationFitted: null,
            imoApp: '',
            imoClass: '',
            imoFitted: null,
            bwts: null,
            coiled: null,
            containerFitted: null,
            carFitted: null,
            rampway: null,
            lxb: '',
            grainFitted: null,
            grainHoles: '',
            grainDia: '',
            cargoTankDryer: null,
            cargoCoolingSystem: null,
            crudeOilWashing: null,
            rcttms: null,
            rctpms: null,
            bowChainStopper: null,
            chainSize: '',
            ngs: null,
            ngsCapacity: '',
            vrs: null,
            vrsNumLines: '',
            bowThruster: null,
            bowThrusterNum: '',
            bowThrusterBhp: '',
            bowThrusterKw: '',
            stemThruster: null,
            stemThrusterNum: '',
            stemThrusterBhp: '',
            stemThrusterKw: '',
            igs: {
                fitted: null,
                systems: [{
                    type: '',
                    capacity: '',
                    percentage: ''
                }]
            },
            referPlugsAmount: undefined
        },
        design: { _id: '', name: '' },
        cargoExclusionV2List: [],
        cargoExclusionsV2: [],
        tradingRestrictions: [],
        deadWeight: {
            sLoaded: undefined,
            sDWT: undefined,
            sDWCC: undefined,
            sDraft: undefined,
            sTpc: undefined,
            sTpi: undefined,
            tLoaded: undefined,
            tDWT: undefined,
            tDWCC: undefined,
            tDraft: undefined,
            tTpc: undefined,
            tTpi: undefined,
            wLoaded: undefined,
            wDWT: undefined,
            wDWCC: undefined,
            wDraft: undefined,
            wTpc: undefined,
            wTpi: undefined,
            fLoaded: undefined,
            fDWT: undefined,
            fDWCC: undefined,
            fDraft: undefined,
            fTpc: undefined,
            fTpi: undefined
        },
        rt: {
            gt: undefined,
            nt: undefined,
            suezGt: undefined,
            suezNt: undefined,
            panamaGt: undefined,
            panamaNt: undefined
        },
        capacityV2: {
            grain: undefined,
            bale: undefined,
            teu: undefined,
            feu: undefined,
            constant: undefined,
            summary: [{
                hold: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined
                },
                tweenDeck: {
                    grain: undefined,
                    bale: undefined,
                    teu: undefined,
                    feu: undefined
                }
            }]
        },
        capacityTanker: {
            segregation: '',
            details: '',
            ttlCapacity: '',
            cargoGrades: '',
            tanks: [{
                port: '',
                starboard: ''
            }],
            slops: [{
                port: '',
                starboard: ''
            }],
            ballastTanks: [{
                port: '',
                starboard: ''
            }],
            cargoCapacity: '',
            slopsCapacity: '',
            ballastCapacity: '',
            wholeTank: '',
            coatingType: '',
            heating: {
                exchanger: null,
                medium: '',
                maxLoaded: '',
                maxMaintained: ''
            }
        },
        holdsV2: [],
        cells: [{
            holds: {
                l: '',
                b: '',
                h: '',
                area: ''
            },
            tweenDecks: [{
                l: '', b: '', h: '', area: ''
            }, {
                l: '', b: '', h: '', area: ''
            }],
            hatches: [{ l: '', b: '', area: '' }, { l: '', b: '', area: '' }]
        }],
        temporaryHohaAreas: {
            mainDeckSummArea: null,
            tweenDecksSummArea: null,
            hatchesSummArea: null
        },
        speedConsumptionV2: [{
            mode: '',
            speed: '',
            ifo: {
                typeIfo: 'HFO 180',
                cons: ''
            },
            mdo: {
                typeMdo: 'MGO',
                cons: ''
            },
            lngCons: undefined
        }],
        exNames: [],
        nationalities: [],
        registerNumber: '',
        registerClasses: [{ _id: '', name: '' }],
        classNotation: '',
        doubleHull: undefined,
        hullNumber: '',
        callSign: '',
        officialNumber: '',
        mmsi: '',
        pumps: {
            cargo: [{
                type: '',
                quantity: '',
                capacity: ''
            }],
            ballast: [{
                type: '',
                quantity: '',
                capacity: ''
            }]
        },
        lastCargo: [{
            cargoes: [__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo)]
        }],
        manifolds: {
            bcm: undefined,
            scm: undefined,
            betweenManifolds: undefined,
            list: [{
                number: undefined,
                size: undefined,
                commonLine: undefined
            }]
        },
        certificateOfFitness: [],

        flagObject: { _id: '', name: '' },
        managerObject: { _id: '', name: '' },
        ownerObject: { _id: '', name: '' },
        registeredOwnerObject: { _id: '', name: '' },
        homePortObject: { _id: '', name: '' },
        suggestedName: undefined,
        name: undefined,
        imoNumber: undefined,
        image: undefined,
        blt: undefined,
        cargoExclusions: undefined,
        engineLocation: undefined,
        engines: [{
            type: undefined,
            number: undefined,
            capacity: undefined,
            rpm: undefined,
            makeType: undefined
        }],

        images: [],
        attachments: [],
        attachmentsArray: [],

        typeOfPage: 'new',
        toggleSpeedConsAll: {
            IFO: false,
            MDO: false
        },
        windScale: undefined,
        description: undefined,
        disponentOwner: { _id: '', name: '' },
        errors: []
    };
}

var VesselSingle = function (_React$Component) {
    _inherits(VesselSingle, _React$Component);

    function VesselSingle(props) {
        _classCallCheck(this, VesselSingle);

        var _this = _possibleConstructorReturn(this, (VesselSingle.__proto__ || Object.getPrototypeOf(VesselSingle)).call(this, props));

        _this.checkCapacity = function (array) {
            return array.filter(function (item) {
                var _item$hold = item.hold,
                    hg = _item$hold.grain,
                    hb = _item$hold.bale,
                    ht = _item$hold.teu,
                    hf = _item$hold.feu,
                    _item$tweenDeck = item.tweenDeck,
                    tg = _item$tweenDeck.grain,
                    tb = _item$tweenDeck.bale,
                    tt = _item$tweenDeck.teu,
                    tf = _item$tweenDeck.feu;


                return hg || hb || ht || hf || tg || tb || tt || tf;
            });
        };

        _this.changeFieldsMultiple = function (changes) {
            var state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.state);

            if (!Array.isArray(changes)) {
                changes = [changes];
            }

            changes.forEach(function (_ref) {
                var field = _ref.field,
                    value = _ref.value;

                state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, value);
            });

            _this.setState(state);
        };

        _this.state = _extends({}, getInitialState(), props.vessel);

        _this.toggleReeferPlugs = _this.toggleReeferPlugs.bind(_this);

        _this.toggleIacsRegister = _this.toggleIacsRegister.bind(_this);
        _this.toggleIsRewriteOwnerExclusions = _this.toggleIsRewriteOwnerExclusions.bind(_this);

        _this.toggleOpenHatch = _this.toggleOpenHatch.bind(_this);
        _this.toggleBoxShaped = _this.toggleBoxShaped.bind(_this);

        _this.changeGeared = _this.changeGeared.bind(_this);

        _this.changeGrabbed = _this.changeGrabbed.bind(_this);

        _this.changeField = _this.changeField.bind(_this);
        _this.getError = _this.getError.bind(_this);
        _this.changeAutoComplete = _this.changeAutoComplete.bind(_this);

        _this.changeHolds = _this.changeHolds.bind(_this);
        _this.changeHatches = _this.changeHatches.bind(_this);

        _this.loadImage = _this.loadImage.bind(_this);
        _this.loadAttachment = _this.loadAttachment.bind(_this);
        _this.removeAttachment = _this.removeAttachment.bind(_this);
        _this.removeImage = _this.removeImage.bind(_this);

        _this.changeAreas = _this.changeAreas.bind(_this);

        _this.fetchVesselDataAndSetToState = _this.fetchVesselDataAndSetToState.bind(_this);
        _this.toggleModifySpeedCons = _this.toggleModifySpeedCons.bind(_this);
        _this.updateSuggestedName = _this.updateSuggestedName.bind(_this);
        _this.clearError = _this.clearError.bind(_this);
        return _this;
    }

    _createClass(VesselSingle, [{
        key: 'changeAreas',
        value: function changeAreas(_ref2) {
            var field = _ref2.field,
                value = _ref2.value,
                hatchesField = _ref2.hatchesField;
            var hatchesSummArea = this.state.temporaryHohaAreas.hatchesSummArea;

            hatchesSummArea = parseFloat(hatchesSummArea) || null;

            var _state$areas = this.state.areas,
                mainDeck = _state$areas.mainDeck,
                tweenDeck = _state$areas.tweenDeck,
                weatherDeck = _state$areas.weatherDeck,
                total = _state$areas.total;

            mainDeck = parseFloat(mainDeck) || null;
            tweenDeck = parseFloat(tweenDeck) || null;
            weatherDeck = parseFloat(weatherDeck) || null;
            total = parseFloat(total) || null;
            value = parseFloat(value) || null;

            if (field === 'areas.mainDeck') {
                this.changeField({
                    field: field,
                    value: value
                });
                this.setState({
                    areas: _extends({}, this.state.areas, {
                        mainDeck: value,
                        total: (value || 0) + (tweenDeck || 0) + (weatherDeck || 0) + (hatchesSummArea || 0)
                    })
                });
            } else if (field === 'areas.tweenDeck') {
                this.changeField({
                    field: field,
                    value: value
                });
                this.setState({
                    areas: _extends({}, this.state.areas, {
                        tweenDeck: value,
                        total: (value || 0) + (mainDeck || 0) + (weatherDeck || 0) + (hatchesSummArea || 0)
                    })
                });
            } else if (field === 'areas.weatherDeck') {
                this.changeField({
                    field: field,
                    value: value
                });
                this.setState({
                    areas: _extends({}, this.state.areas, {
                        weatherDeck: value,
                        total: (value || 0) + (mainDeck || 0) + (weatherDeck || 0) + (hatchesSummArea || 0)
                    })
                });
            } else if (hatchesField) {
                this.changeField({
                    field: field,
                    value: value
                });
                var cells = this.state.cells;

                hatchesSummArea = 0;
                cells.forEach(function (cell) {
                    hatchesSummArea += parseFloat(cell.hatches[0].area || 0) + parseFloat(cell.hatches[1].area || 0);
                });

                this.changeField({
                    field: 'temporaryHohaAreas.hatchesSummArea',
                    value: hatchesSummArea
                });
                this.changeField({
                    field: 'areas.total',
                    value: (hatchesSummArea || 0) + (mainDeck || 0) + (tweenDeck || 0) + (weatherDeck || 0) /* + (total || 0)*/
                });
            } else {
                var state = this.state;

                state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, value);
                var _state = state,
                    _cells = _state.cells,
                    temporaryHohaAreas = _state.temporaryHohaAreas;


                tweenDeck = typeof tweenDeck === 'undefined' ? 0 : parseFloat(tweenDeck);
                weatherDeck = parseFloat(weatherDeck) || 0;

                mainDeck = 0;
                tweenDeck = 0;

                _cells.forEach(function (cell) {
                    mainDeck += temporaryHohaAreas.mainDeckSummArea + (parseFloat(cell.holds.area) || 0);
                    tweenDeck += (temporaryHohaAreas.tweenDecksSummArea || 0) + (parseFloat(cell.tweenDecks[0].area) || 0) + (parseFloat(cell.tweenDecks[1].area) || 0);
                });

                state.areas.mainDeck = mainDeck;
                state.areas.tweenDeck = tweenDeck;
                state.areas.total = mainDeck + tweenDeck + weatherDeck + hatchesSummArea;

                state.errors = state.errors.filter(function (error) {
                    if (!error.field) {
                        return false;
                    }

                    return !error.field.includes(field);
                });

                this.setState(state);
            }
        }
    }, {
        key: 'loadImage',
        value: function loadImage(e) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_39_services__["a" /* default */].uploadFile({
                file: e.target.files[0]
            }).then(function (response) {
                _this2.setState({
                    images: [response.data.data._id],
                    image: response.data.data.url
                });
            }).catch(function (e1) {
                return _this2.props.addNotification({
                    title: 'Error',
                    message: e1.response.data.errors[0].messages[0],
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 2
                });
            });
        }
    }, {
        key: 'removeImage',
        value: function removeImage() {
            this.setState({
                images: [],
                image: undefined
            });
        }
    }, {
        key: 'loadAttachment',
        value: function loadAttachment(e) {
            var _this3 = this;

            var attachments = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state.attachments);
            var attachmentsArray = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state.attachmentsArray);

            __WEBPACK_IMPORTED_MODULE_39_services__["a" /* default */].uploadFile({
                file: e.target.files[0],
                type: 'attachment'
            }).then(function (response) {
                attachmentsArray.push(response.data.data);
                attachments.push(response.data.data._id);

                _this3.setState({
                    attachmentsArray: attachmentsArray,
                    attachments: attachments
                });
            }).catch(function (e1) {
                return _this3.props.addNotification({
                    title: 'Error',
                    message: e1.response.data.errors[0].messages[0],
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 2
                });
            });
        }
    }, {
        key: 'removeAttachment',
        value: function removeAttachment(key) {
            var attachments = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state.attachments);
            var attachmentsArray = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state.attachmentsArray);

            attachmentsArray.splice(key, 1);
            attachments.splice(key, 1);

            this.setState({
                attachments: attachments,
                attachmentsArray: attachmentsArray
            });
        }
    }, {
        key: 'checkIfEmptyArray',
        value: function checkIfEmptyArray(array) {
            return array.filter(function (item) {
                for (var key in item) {
                    return !!item[key];
                }
            });
        }
    }, {
        key: 'checkGears',
        value: function checkGears(array) {
            return array.filter(function (item) {
                if (item.combinable) {
                    return true;
                }

                for (var key in item) {
                    if (key !== 'combinable') {
                        return !!item[key];
                    }
                }
            });
        }
    }, {
        key: 'prepareToLoad',
        value: function prepareToLoad(vessel) {
            vessel.flag = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'flagObject._id') && vessel.flagObject._id !== '' ? vessel.flagObject._id : undefined;
            vessel.piClub = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'piClubObject._id') && vessel.piClubObject._id !== '' ? vessel.piClubObject._id : undefined;
            vessel.registeredOwner = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'registeredOwnerObject._id') && vessel.registeredOwnerObject._id !== '' ? vessel.registeredOwnerObject._id : undefined;
            vessel.manager = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'managerObject._id') && vessel.managerObject._id !== '' ? vessel.managerObject._id : undefined;
            vessel.homePort = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel, 'homePortObject._id') && vessel.homePortObject._id !== '' ? vessel.homePortObject._id : undefined;

            vessel.gearV2.summary = this.checkGears(vessel.gearV2.summary);
            vessel.grabV2.summary = Object(__WEBPACK_IMPORTED_MODULE_60_helpers_vessels__["a" /* checkGrabs */])(vessel.grabV2.summary);

            vessel.capacityV2.summary = this.checkCapacity(vessel.capacityV2.summary);

            vessel.bunkers = this.checkIfEmptyArray(vessel.bunkers);
            vessel.capacityV2.summary = this.checkIfEmptyArray(vessel.capacityV2.summary);

            if (!vessel.disponentOwner._id && !vessel.disponentOwner.name) {
                delete vessel.disponentOwner;
            }

            if (vessel.pumps && vessel.pumps.cargo) {
                vessel.pumps.cargo = vessel.pumps.cargo.filter(function (p) {
                    return p.type || p.quantity || p.capacity;
                });
            }
            if (vessel.pumps && vessel.pumps.ballast) {
                vessel.pumps.ballast = vessel.pumps.ballast.filter(function (p) {
                    return p.type || p.quantity || p.capacity;
                });
            }
            if (vessel.registerClasses) {
                vessel.registerClasses = vessel.registerClasses.filter(function (c) {
                    return c._id || c.name || c.iacsRegister;
                }).map(function (c) {
                    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(c, ['_id', 'name', 'iacsRegister']);
                });
            }
            if (vessel.capacityTanker.tanks) {
                vessel.capacityTanker.tanks = vessel.capacityTanker.tanks.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.capacityTanker.slops) {
                vessel.capacityTanker.slops = vessel.capacityTanker.slops.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.capacityTanker.ballastTanks) {
                vessel.capacityTanker.ballastTanks = vessel.capacityTanker.ballastTanks.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.manifolds && vessel.manifolds.list) {
                vessel.manifolds.list = vessel.manifolds.list.filter(function (m) {
                    return m.number || m.size || m.commonLine;
                });
            }
            if (vessel.lastCargo) {
                vessel.lastCargo = vessel.lastCargo.map(function (tank) {
                    return {
                        cargoes: tank.cargoes.filter(function (c) {
                            return c.cargo._id && c.date;
                        }).map(function (c) {
                            return _extends({}, c, {
                                cargo: c.cargo._id.toString()
                            });
                        })
                    };
                });
            }
            if (vessel.certificateOfFitness) {
                vessel.certificateOfFitness = vessel.certificateOfFitness.map(function (c) {
                    return c._id;
                });
            }
            if (vessel.strength && vessel.strength.tanktopByHolds) {
                vessel.strength.tanktopByHolds = vessel.strength.tanktopByHolds.map(function (s) {
                    return parseInt(s, 10);
                }).filter(function (s) {
                    return !isNaN(s);
                });
            }

            delete vessel.dw;
            delete vessel.gears;
            return vessel;
        }
    }, {
        key: 'deleteVessel',
        value: function deleteVessel() {
            this.props.deleteVessel(this.props.parentState);
        }
    }, {
        key: 'toggleReeferPlugs',
        value: function toggleReeferPlugs(e, value) {
            this.setState({
                isReeferPlugs: value
            });
        }
    }, {
        key: 'toggleIacsRegister',
        value: function toggleIacsRegister(e, value) {
            this.setState({
                iacsRegister: value
            });
        }
    }, {
        key: 'toggleIsRewriteOwnerExclusions',
        value: function toggleIsRewriteOwnerExclusions(e, value) {
            this.setState({
                isRewriteOwnerExclusions: value
            });
        }
    }, {
        key: 'toggleOpenHatch',
        value: function toggleOpenHatch(e, value) {
            this.setState({
                openHatch: value
            });
        }
    }, {
        key: 'toggleBoxShaped',
        value: function toggleBoxShaped(e, value) {
            this.setState({
                boxShaped: value
            });
        }
    }, {
        key: 'changeGeared',
        value: function changeGeared(value) {
            var change = {
                geared: value
            };

            if (!value) {
                var _getInitialState = getInitialState(),
                    grabbed = _getInitialState.grabbed,
                    gearV2 = _getInitialState.gearV2,
                    grabV2 = _getInitialState.grabV2;

                change.gearV2 = gearV2;
                change.grabV2 = grabV2;
                change.grabbed = grabbed;
            }

            this.setState(change);
        }
    }, {
        key: 'changeGrabbed',
        value: function changeGrabbed(value) {
            var change = {
                grabbed: value
            };

            if (!value) {
                var _getInitialState2 = getInitialState(),
                    grabV2 = _getInitialState2.grabV2;

                change.grabV2 = grabV2;
            }

            this.setState(change);
        }
    }, {
        key: 'toggleGrabbed',
        value: function toggleGrabbed(e, value) {
            this.setState({
                grabbed: value
            });
        }
    }, {
        key: 'toggleModifySpeedCons',
        value: function toggleModifySpeedCons(type) {
            this.setState({
                toggleSpeedConsAll: _extends({}, this.state.toggleSpeedConsAll, _defineProperty({}, type, !this.state.toggleSpeedConsAll[type]))
            });
        }
    }, {
        key: 'changeAutoComplete',
        value: function changeAutoComplete(type, object) {
            var _this4 = this;

            var state = this.state;


            state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, type, object._id);
            state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, type + 'Object', {
                name: object.name,
                _id: object._id
            });

            this.setState(state, function () {
                _this4.clearError(type);
            });
        }
    }, {
        key: 'changeField',
        value: function changeField(changes) {
            var _this5 = this;

            if (!Array.isArray(changes)) {
                changes = [changes];
            }

            var state = this.state;


            changes.forEach(function (_ref3) {
                var field = _ref3.field,
                    value = _ref3.value,
                    type = _ref3.type;

                if (type === 'number' && value === '') {
                    value = undefined;
                }

                if ((_this5.state.toggleSpeedConsAll.IFO || _this5.state.toggleSpeedConsAll.MDO) && (field.endsWith('.typeIfo') || field.endsWith('.typeMdo'))) {
                    var _state$toggleSpeedCon = _this5.state.toggleSpeedConsAll,
                        toggleIfo = _state$toggleSpeedCon.IFO,
                        toggleMdo = _state$toggleSpeedCon.MDO;

                    var typeFuel = field.replace(/[\[\]]/g, '.').replace(/\.+/g, '.').split('.')[2];
                    var speedConsCopy = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this5.state.speedConsumptionV2);
                    var modifiedFieldsCopy = new Set(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this5.state.modifiedFields));

                    typeFuel === 'ifo' && toggleIfo && speedConsCopy.forEach(function (item, index) {
                        modifiedFieldsCopy.add('speedConsumptionV2[' + index + '].ifo.typeIfo');
                        item[typeFuel].typeIfo = value;
                    });

                    typeFuel === 'mdo' && toggleMdo && speedConsCopy.forEach(function (item, index) {
                        modifiedFieldsCopy.add('speedConsumptionV2[' + index + '].mdo.typeMdo');
                        item[typeFuel].typeMdo = value;
                    });

                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, 'speedConsumptionV2', speedConsCopy);
                    _this5.setState({
                        currentlyModifiedFields: [].concat(_toConsumableArray(modifiedFieldsCopy)),
                        modifiedFields: [].concat(_toConsumableArray(modifiedFieldsCopy))
                    });
                }

                if (type === 'array') {
                    state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, [].concat(_toConsumableArray(state[field]), [value]));
                } else {
                    state = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(state, field, value);
                }

                state.errors = state.errors.filter(function (error) {
                    if (!error.field) {
                        return false;
                    }

                    return !error.field.includes(field.replace(/\[|\]\./g, '.'));
                });
            });

            this.setState(state);
        }
    }, {
        key: 'getError',
        value: function getError(field) {
            if (!this.state.errors.length) {
                return '';
            }

            var errorObject = this.state.errors.find(function (error) {
                return error.field === field;
            });

            return errorObject ? errorObject.messages[0] : '';
        }
    }, {
        key: 'clearError',
        value: function clearError(field) {
            var errors = this.state.errors.filter(function (error) {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes(field);
            });

            this.setState({
                errors: errors
            });
        }
    }, {
        key: 'changeSizeArray',
        value: function changeSizeArray(array, value) {
            var diff = Math.abs(array.length - value);

            if (value > array.length) {
                for (var i = 0; i <= diff - 1; i++) {
                    array.push({});
                }
            } else if (value < array.length) {
                array.splice(value, diff);
            }

            return array;
        }
    }, {
        key: 'changeHolds',
        value: function changeHolds(value) {
            value = Math.abs(parseInt(value, 10));

            var state = this.state;

            state.holds.quantity = value;

            var lowerDims = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.holds.lowerDims);
            var tweenDims = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.holds.tweenDims);

            state.holds.lowerDims = this.changeSizeArray(lowerDims, value);
            state.holds.tweenDims = this.changeSizeArray(tweenDims, value);

            state.errors = state.errors.filter(function (error) {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes('holds.quantity');
            });

            this.setState(state);
        }
    }, {
        key: 'changeHatches',
        value: function changeHatches(value) {
            value = Math.abs(parseInt(value, 10));

            var state = this.state;

            state.hatches.quantity = value;

            var size = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(state.hatches.size);

            state.hatches.size = this.changeSizeArray(size, value);

            state.errors = state.errors.filter(function (error) {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes('hatches.quantity');
            });

            this.setState(state);
        }
    }, {
        key: 'findType',
        value: function findType(type) {
            switch (type) {
                case 'CONT':
                case 'Fully Cellular Container':
                    return 'CONT';
                case 'ROLO':
                case 'Passenger/Cargo Vessel':
                case 'Deck Cargo Carrier':
                case 'Ro-Ro/Lo-Lo':
                case 'Reefer/Ro-Ro Cargo':
                case 'Reefer/Pallets Carrier':
                case 'Ro-Ro/Container':
                case 'Product Carrier/Ro-Ro':
                case 'Barge Carrier':
                    return 'ROLO';
                case 'RORO':
                case 'Pass./Car Ferry':
                case 'Ro-Ro Freight/Passenger':
                case 'Ro-Ro':
                case 'Pure Car Carrier':
                case 'Palletised Cargo Carrier':
                    return 'RORO';
                case 'SID':
                case 'minibulk':
                case 'panamax':
                case 'Miscellaneous Dry Bulk':
                case 'Cement Carrier':
                case 'Aggregate Carrier':
                case 'Bulk Carrier':
                case 'Ore Carrier':
                case 'Ore/Oil Carrier':
                case 'Urea Carrier':
                case 'Open Hatch Carrier':
                case 'Chip Carrier':
                case 'Slurry Carrier':
                case 'handymax':
                case 'Ore & Sulphuric Acid Carrier':
                case 'Forest Product Carrier':
                case 'supramax':
                case 'overpanamax':
                case 'Salt Carrier':
                case 'capesize':
                case 'handysize':
                    return 'SID';
                case 'TWEEN':
                case 'General Cargo':
                case 'Reefer':
                case 'Reefer/General Cargo':
                case 'Miscellaneous Cargo':
                case 'Multi-Purpose':
                case 'Multi-Purpose/Heavy Lift Cargo':
                case 'Products/Multi-Purpose Cargo':
                case 'Heavy Lift Cargo Vessel':
                    return 'TWEEN';
                case 'Product Carrier':
                case 'Chemical Unknown Carrier':
                case 'Bunkering Vessel':
                case 'Chemical Bulk Tanker':
                case 'Chemical & Oil Carrier':
                case 'Chem Parcel Tanker':
                case 'Molten Sulphur Carrier':
                case 'Asphalt & Bitumen Carrier':
                case 'Tanker':
                case 'Water Carrier':
                case 'Edible Oil Carrier':
                case 'Sulphuric Acid Carrier':
                case 'Oil & Liquid Gas Carrier':
                case 'Fruit Juice Carrier':
                case 'Methanol Carrier':
                case 'Phosphoric Acid Carrier':
                case 'Shuttle Tanker':
                case 'Oil Recovery Tanker':
                    return 'TANK';
                case 'Cruise Ship':
                case 'Landing Craft':
                case 'Pass./Car Catamaran Vessel':
                case 'Passenger Vessel':
                case 'Waste Disposal Carrier':
                case 'Livestock Carrier':
                case 'Limestone Carrier':
                case 'Reefer Fish Carrier':
                    return 'OTHER';
            }

            return type;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.clearVessel();
        }
    }, {
        key: 'sortArrayByDate',
        value: function sortArrayByDate(arr) {
            return [].concat(_toConsumableArray(arr)).map(function (i) {
                return _extends({}, i, { date: new Date(i.date) });
            }).sort(function (f, s) {
                return s.date - f.date;
            });
        }
    }, {
        key: 'getOldData',
        value: function getOldData(vesselData) {
            var vessel = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.merge({}, this.state, vesselData);
            vessel.isReeferPlugs = false;

            vessel.nameSuggestion = undefined;
            vessel.suggestedName = undefined;

            if (Array.isArray(vesselData.nameSuggestion) && vesselData.nameSuggestion && vesselData.nameSuggestion.length > 0) {
                vessel.nameSuggestion = this.sortArrayByDate(vesselData.nameSuggestion);
                vessel.suggestedName = vessel.nameSuggestion[0];
            }

            // fill old fields

            if (vessel.flag && typeof vessel.flag !== 'string') {
                vessel.flagObject = vessel.flag;
                vessel.flag = vessel.flagObject._id;
            }

            if (vessel.piClub && typeof vessel.piClub !== 'string') {
                vessel.piClubObject = vessel.piClub;
                vessel.piClub = vessel.piClubObject._id;
            }

            if (vessel.registeredOwner) {
                vessel.registeredOwnerObject = vessel.registeredOwner;
            }

            if (vessel.manager && typeof vessel.manager !== 'string') {
                vessel.managerObject = vessel.manager;
                vessel.manager = vessel.managerObject._id;
            }

            if (vessel.homePort && typeof vessel.homePort !== 'string') {
                vessel.homePortObject = vessel.homePort;
                vessel.homePort = vessel.homePortObject._id;
            }

            if (vessel.images.length > 0 && typeof vessel.images[0] !== 'string') {
                vessel.image = vessel.images[0].url;
                vessel.images[0] = vessel.images[0]._id;
            }

            if (vessel.reeferPlugs && vessel.reeferPlugs > 0) {
                vessel.isReeferPlugs = true;
            }

            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(vessel.attachments[0], 'name')) {
                vessel.attachmentsArray = [];

                vessel.attachments.forEach(function (item) {
                    vessel.attachmentsArray.push(item);
                });

                vessel.attachments = [];

                vessel.attachmentsArray.forEach(function (item) {
                    vessel.attachments.push(item._id);
                });
            }

            if (vessel.rt) {
                vessel.rt.panamaNt = vessel.rt.panamaNt || undefined;
                vessel.rt.suezGt = vessel.rt.suezGt || undefined;
                vessel.rt.suezNt = vessel.rt.suezNt || undefined;
                vessel.rt.nt = vessel.rt.nt || undefined;
                vessel.rt.gt = vessel.rt.gt || undefined;
            }

            if (vessel.dimensions) {
                vessel.dimensions.loa = vessel.dimensions.loa || undefined;
                vessel.dimensions.beam = vessel.dimensions.beam || undefined;
                vessel.dimensions.depth = vessel.dimensions.depth || undefined;
                vessel.dimensions.lbp = vessel.dimensions.lbp || undefined;
            }

            if (vessel.areas) {
                vessel.areas.mainDeck = vessel.areas.mainDeck || undefined;
                vessel.areas.tweenDeck = vessel.areas.tweenDeck || undefined;
                vessel.areas.weatherDeck = vessel.areas.weatherDeck || undefined;
                vessel.areas.total = vessel.areas.total || undefined;
            }

            if (vessel.strength) {
                vessel.strength.maxTt = vessel.strength.maxTt || undefined;
                vessel.strength.maxTween = vessel.strength.maxTween || undefined;
                vessel.strength.maxWeather = vessel.strength.maxWeather || undefined;
            }

            if (vessel.stackWeight) {
                vessel.stackWeight['20hold'] = vessel.stackWeight['20hold'] || undefined;
                vessel.stackWeight['20deck'] = vessel.stackWeight['20deck'] || undefined;
                vessel.stackWeight['40hold'] = vessel.stackWeight['40hold'] || undefined;
                vessel.stackWeight['40deck'] = vessel.stackWeight['40deck'] || undefined;
            }

            if (vessel.holds) {
                vessel.holds.quantity = vessel.holds.quantity || undefined;

                if (vessel.holds.lowerDims && vessel.holds.lowerDims.length) {
                    vessel.holds.lowerDims.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                        dim.h = dim.h || undefined;
                    });
                }

                if (vessel.holds.tweenDims && vessel.holds.tweenDims.length) {
                    vessel.holds.tweenDims.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                        dim.h = dim.h || undefined;
                    });
                }
            }
            if (vessel.hatches) {
                if (vessel.hatches.hatchType === 'Mc Greegor') {
                    vessel.hatches.hatchType = 'Mc Gregor';
                }
                if (vessel.hatches.size && vessel.hatches.size.length) {
                    vessel.hatches.size.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                    });
                }
            }

            vessel.draft = vessel.draft || undefined;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = vessel.lastCargo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var tank = _step.value;

                    for (var i = tank.cargoes.length; i < 3; i++) {
                        tank.cargoes.push(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultCargo));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (vessel.registerClass && vessel.registerClass._id && !vessel.registerClasses[0]._id && vessel.registerClasses.length === 1) {
                vessel.registerClasses[0] = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(vessel.registerClass);
            }

            return vessel;
        }
    }, {
        key: 'updateSuggestedName',
        value: function updateSuggestedName(sName) {
            var name = this.state.name;


            this.setState({
                suggestedName: sName && sName.name ? sName : name
            });
        }
    }, {
        key: 'fetchVesselDataAndSetToState',
        value: function fetchVesselDataAndSetToState(id) {
            var _this6 = this;

            Object(__WEBPACK_IMPORTED_MODULE_36_services_vessels_vessels__["g" /* getVessel */])(id).then(function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                    var vessel;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    response.data.type = _this6.findType(response.data.type);

                                    Object.keys(response.data).forEach(function (item) {
                                        var obj = response.data[item];
                                        // remove empty objects
                                        if (obj === null || obj === undefined || Array.isArray(obj) && obj.length === 0 || Object.keys(obj).length === 0 && obj.constructor === Object) {
                                            delete response.data[item];
                                        }
                                    });

                                    vessel = _this6.getOldData(response.data);


                                    _this6.setState(_extends({}, vessel, {
                                        typeOfPage: 'update'
                                    }));

                                case 4:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this6);
                }));

                return function (_x) {
                    return _ref4.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this7 = this;

            this.changeField({
                field: 'temporaryHohaAreas',
                value: {
                    mainDeckSummArea: parseFloat(this.state.areas.mainDeck) || 0,
                    tweenDecksSummArea: parseFloat(this.state.areas.tweenDeck) || 0
                }
            });

            var typeOfPage = this.state.typeOfPage;

            if (this.props.params.id) {
                this.setState(getInitialState(), function () {
                    _this7.fetchVesselDataAndSetToState(_this7.props.params.id);
                });
                typeOfPage = 'update';
            }

            this.setState({
                typeOfPage: typeOfPage
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this8 = this;

            if (nextProps.params.id !== this.props.params.id) {
                this.setState(getInitialState(), function () {
                    _this8.fetchVesselDataAndSetToState(_this8.props.params.id);
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            /* delete scroll event listener from input elements */
            var inputs = document.querySelectorAll('input[type=number]');

            inputs.forEach(function (input) {
                input.removeEventListener('mousewheel', scroll);
                input.addEventListener('mousewheel', scroll);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this9 = this;

            var _state2 = this.state,
                _id = _state2._id,
                areas = _state2.areas,
                flagObject = _state2.flagObject,
                builderV2 = _state2.builderV2,
                registerClass = _state2.registerClass,
                piClubObject = _state2.piClubObject,
                isRewriteOwnerExclusions = _state2.isRewriteOwnerExclusions,
                typeByPurpose = _state2.typeByPurpose,
                typeByConstruction = _state2.typeByConstruction,
                typeBySpecialty = _state2.typeBySpecialty,
                typeBySize = _state2.typeBySize,
                openHatch = _state2.openHatch,
                boxShaped = _state2.boxShaped,
                gearV2 = _state2.gearV2,
                geared = _state2.geared,
                grabV2 = _state2.grabV2,
                grabbed = _state2.grabbed,
                techEquipCertificate = _state2.techEquipCertificate,
                cargoExclusionV2Object = _state2.cargoExclusionV2Object,
                cargoExclusionV2List = _state2.cargoExclusionV2List,
                cargoExclusionsV2 = _state2.cargoExclusionsV2,
                tradingRestrictions = _state2.tradingRestrictions,
                deadWeight = _state2.deadWeight,
                holds = _state2.holds,
                dimensions = _state2.dimensions,
                capacityV2 = _state2.capacityV2,
                cells = _state2.cells,
                temporaryHohaAreas = _state2.temporaryHohaAreas,
                speedConsumptionV2 = _state2.speedConsumptionV2,
                exNames = _state2.exNames,
                managerObject = _state2.managerObject,
                registeredOwnerObject = _state2.registeredOwnerObject,
                bunkers = _state2.bunkers,
                hatches = _state2.hatches,
                holdsHatchesProducer = _state2.holdsHatchesProducer,
                strength = _state2.strength,
                stackWeight = _state2.stackWeight,
                typeOfPage = _state2.typeOfPage,
                name = _state2.name,
                imoNumber = _state2.imoNumber,
                blt = _state2.blt,
                rt = _state2.rt,
                engineLocation = _state2.engineLocation,
                engines = _state2.engines,
                confirmed = _state2.confirmed,
                homePortObject = _state2.homePortObject,
                toggleSpeedConsAll = _state2.toggleSpeedConsAll,
                windScale = _state2.windScale,
                description = _state2.description,
                design = _state2.design,
                disponentOwner = _state2.disponentOwner,
                linerMeter = _state2.linerMeter,
                nationalities = _state2.nationalities,
                registerNumber = _state2.registerNumber,
                registerClasses = _state2.registerClasses,
                classNotation = _state2.classNotation,
                doubleHull = _state2.doubleHull,
                hullNumber = _state2.hullNumber,
                callSign = _state2.callSign,
                officialNumber = _state2.officialNumber,
                mmsi = _state2.mmsi,
                pumps = _state2.pumps,
                lastCargo = _state2.lastCargo,
                capacityTanker = _state2.capacityTanker,
                manifolds = _state2.manifolds,
                certificateOfFitness = _state2.certificateOfFitness;
            var vessel = this.props.vessel;


            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(vessel)) {
                return null;
            }

            var linerMeterDisabled = !new RegExp('ro-(ro|lo)', 'i').test(typeBySpecialty);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'vessel-single', className: 'page container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tooltip___default.a, { type: 'light', border: true, offset: 15 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block ' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        { ref: 'form' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                {
                                    className: 'col-xs-3',
                                    style: this.state.attachmentsArray.length <= 7 || window.screen.height < 700 ? { position: 'fixed', width: 'min-content', minWidth: '19em' } : { position: 'absolute' }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Sidebar__["a" /* default */], {
                                    loadImage: this.loadImage,
                                    removeImage: this.removeImage,
                                    loadAttachment: this.loadAttachment,
                                    removeAttachment: this.removeAttachment,
                                    parentState: this.state,
                                    changeField: this.changeField,
                                    typeOfPage: typeOfPage,
                                    confirmed: !confirmed
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-offset-3 col-xs-9' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-5' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Rows_Name__["a" /* default */], {
                                                name: name,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__Rows_ExNames__["a" /* default */], {
                                            exNames: exNames,
                                            confirmed: !confirmed,
                                            changeField: this.changeField,
                                            getError: this.getError
                                        })
                                    ),
                                    this.state.nameSuggestion && this.state.suggestedName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-5' }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Rows_SuggestionNames__["a" /* default */], {
                                            key: _id,
                                            refreshVessel: function refreshVessel() {
                                                return _this9.fetchVesselDataAndSetToState(_this9.props.params.id);
                                            },
                                            updateSuggestedName: this.updateSuggestedName,
                                            vessel: this.state
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-5' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Rows_ImoNumber__["a" /* default */], {
                                                imoNumber: imoNumber,
                                                confirmed: !confirmed,
                                                typeOfPage: typeOfPage,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__Rows_Nationalities__["a" /* default */], {
                                            value: nationalities,
                                            confirmed: !confirmed,
                                            changeField: this.changeField,
                                            getError: this.getError
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-3' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Rows_Blt__["a" /* default */], {
                                                blt: blt,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-9' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'row' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'div',
                                                    { className: 'col-xs-2' },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        'div',
                                                        {
                                                            style: {
                                                                margin: '40px 0 0 40px'
                                                            }
                                                        },
                                                        'Builder:'
                                                    )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'div',
                                                    { className: 'col-xs-5' },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Rows_BuilderYard__["a" /* default */], {
                                                        getError: this.getError,
                                                        changeField: this.changeField,
                                                        yard: builderV2.yard,
                                                        confirmed: !confirmed
                                                    })
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'div',
                                                    { className: 'col-xs-5' },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Rows_BuilderCountry__["a" /* default */], {
                                                        getError: this.getError,
                                                        changeAutoComplete: this.changeAutoComplete,
                                                        country: builderV2.country,
                                                        confirmed: !confirmed
                                                    })
                                                )
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Rows_Flag__["a" /* default */], {
                                                changeAutoComplete: this.changeAutoComplete,
                                                getError: this.getError,
                                                flagObject: flagObject,
                                                confirmed: !confirmed
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Rows_PortOfRegistry__["a" /* default */], {
                                                homePortObject: homePortObject,
                                                confirmed: !confirmed,
                                                changeAutoComplete: this.changeAutoComplete,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["A" /* TextField */], {
                                                name: 'registerNumber',
                                                disabled: !confirmed,
                                                value: registerNumber,
                                                floatingLabelText: 'Registry \u2116',
                                                onChange: function onChange(e) {
                                                    return _this9.changeField( /** @type {any} */{
                                                        field: 'registerNumber',
                                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                                    });
                                                },
                                                fullWidth: true
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__Rows_RegisterClasses__["a" /* default */], {
                                        registerClasses: registerClasses,
                                        changeField: this.changeFieldsMultiple,
                                        confirmed: confirmed,
                                        getError: this.getError,
                                        clearError: this.clearError
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["A" /* TextField */], {
                                        name: 'classNotation',
                                        disabled: !confirmed,
                                        value: classNotation,
                                        floatingLabelText: 'Class notation',
                                        onChange: function onChange(e) {
                                            return _this9.changeField( /** @type {any} */{
                                                field: 'classNotation',
                                                value: /** @type {HTMLInputElement} */e.currentTarget.value
                                            });
                                        },
                                        fullWidth: true
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Rows_PIClub__["a" /* default */], {
                                                piClubObject: piClubObject,
                                                changeField: this.changeField,
                                                confirmed: !confirmed,
                                                getError: this.getError,
                                                clearError: this.clearError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__Rows_RegisteredOwner__["a" /* default */], {
                                                _registeredOwnerObject: registeredOwnerObject,
                                                confirmed: !confirmed,
                                                changeAutoComplete: this.changeAutoComplete,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Rows_Manager__["a" /* default */], {
                                                managerObject: managerObject,
                                                confirmed: !confirmed,
                                                changeAutoComplete: this.changeAutoComplete,
                                                getError: this.getError
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__Rows_Design__["a" /* default */], {
                                                design: design,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__Rows_DisponentOwner__["a" /* default */], {
                                                changeField: this.changeField,
                                                confirmed: !confirmed,
                                                disponentOwner: disponentOwner
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            {
                                                className: 'col-xs-2 middle-xs start-xs',
                                                style: { display: 'flex' }
                                            },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_48_material_ui__["s" /* SelectField */],
                                                {
                                                    value: openHatch,
                                                    onChange: function onChange(e, i, value) {
                                                        return _this9.changeFieldsMultiple([{ field: 'openHatch', value: value }]);
                                                    },
                                                    disabled: !confirmed,
                                                    name: 'openHatch',
                                                    floatingLabelText: 'Open Hatch',
                                                    floatingLabelStyle: { fontSize: '13px' },
                                                    autoWidth: true,
                                                    fullWidth: true
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["m" /* MenuItem */], { value: null, primaryText: undefined }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["m" /* MenuItem */], { value: true, primaryText: 'Yes' }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["m" /* MenuItem */], { value: false, primaryText: 'No' })
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            {
                                                className: 'col-xs-2 middle-xs start-xs',
                                                style: { display: 'flex' }
                                            },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_48_material_ui__["s" /* SelectField */],
                                                {
                                                    value: boxShaped,
                                                    onChange: function onChange(e, i, value) {
                                                        return _this9.changeFieldsMultiple([{ field: 'boxShaped', value: value }]);
                                                    },
                                                    disabled: !confirmed,
                                                    name: 'boxShaped',
                                                    floatingLabelText: 'Box Shaped',
                                                    floatingLabelStyle: { fontSize: '13px' },
                                                    autoWidth: true,
                                                    fullWidth: true
                                                },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["m" /* MenuItem */], { value: null, primaryText: undefined }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["m" /* MenuItem */], { value: true, primaryText: 'Yes' }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["m" /* MenuItem */], { value: false, primaryText: 'No' })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51_material_ui_Checkbox___default.a, {
                                                style: { margin: '40px 0 0' },
                                                label: 'Double hull',
                                                checked: doubleHull,
                                                disabled: !confirmed,
                                                onCheck: function onCheck() {
                                                    return _this9.changeField( /** @type {any} */{
                                                        field: 'doubleHull',
                                                        value: !doubleHull
                                                    });
                                                }
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["A" /* TextField */], {
                                                name: 'hullNumber',
                                                disabled: !confirmed,
                                                value: hullNumber,
                                                floatingLabelText: 'Hull number',
                                                onChange: function onChange(e) {
                                                    return _this9.changeField( /** @type {any} */{
                                                        field: 'hullNumber',
                                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                                    });
                                                },
                                                fullWidth: true
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["A" /* TextField */], {
                                                name: 'callSign',
                                                disabled: !confirmed,
                                                value: callSign,
                                                floatingLabelText: 'Call sign',
                                                onChange: function onChange(e) {
                                                    return _this9.changeField( /** @type {any} */{
                                                        field: 'callSign',
                                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                                    });
                                                },
                                                fullWidth: true
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["A" /* TextField */], {
                                                name: 'officialNumber',
                                                disabled: !confirmed,
                                                value: officialNumber,
                                                floatingLabelText: 'Official number',
                                                onChange: function onChange(e) {
                                                    return _this9.changeField( /** @type {any} */{
                                                        field: 'officialNumber',
                                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                                    });
                                                },
                                                fullWidth: true
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48_material_ui__["A" /* TextField */], {
                                                name: 'mmsi',
                                                disabled: !confirmed,
                                                value: mmsi,
                                                floatingLabelText: 'MMSI',
                                                onChange: function onChange(e) {
                                                    return _this9.changeField( /** @type {any} */{
                                                        field: 'mmsi',
                                                        value: /** @type {HTMLInputElement} */e.currentTarget.value
                                                    });
                                                },
                                                fullWidth: true
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__Rows_LinerMeter__["a" /* default */], {
                                                linerMeter: linerMeter,
                                                linerMeterDisabled: linerMeterDisabled,
                                                changeFieldsMultiple: this.changeFieldsMultiple
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-3' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Rows_TypeByPurpose__["a" /* default */], {
                                                type: typeByPurpose,
                                                confirmed: !confirmed,
                                                changeField: this.changeFieldsMultiple,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-3' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Rows_TypeBySpecialty__["a" /* default */], {
                                                typeBySpecialty: typeBySpecialty,
                                                confirmed: !confirmed,
                                                changeField: this.changeFieldsMultiple,
                                                getError: this.getError,
                                                typeByPurpose: typeByPurpose
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-3' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Rows_TypeByConstruction__["a" /* default */], {
                                                type: typeByConstruction,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-3' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__Rows_TypeBySize__["a" /* default */], {
                                                type: typeBySize,
                                                confirmed: confirmed,
                                                changeField: this.changeFieldsMultiple,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-1' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                { className: 'name-block static huge-name' },
                                                'GEAR:'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            {
                                                className: 'col-xs-3 col-xs-offset-8'
                                            },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__Rows_GearedGrabbed__["a" /* default */], {
                                                confirmed: confirmed,
                                                fieldName: 'geared',
                                                gearedGrabbed: geared,
                                                onChange: this.changeGeared
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Rows_GearV2__["a" /* default */], {
                                                gearV2: gearV2,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-1' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                { className: 'name-block static huge-name' },
                                                'GRABS:'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-3 col-xs-offset-8' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__Rows_GearedGrabbed__["a" /* default */], {
                                                confirmed: confirmed,
                                                fieldName: 'grabbed',
                                                gearedGrabbed: grabbed,
                                                onChange: this.changeGrabbed
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Rows_GrabV2__["a" /* default */], {
                                                grabs: grabV2,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                { className: 'name-block static huge-name' },
                                                'PUMPS:'
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__Rows_Pumps__["a" /* default */], {
                                                type: 'cargo',
                                                pumps: pumps.cargo,
                                                confirmed: !confirmed,
                                                changeField: this.changeFieldsMultiple,
                                                getError: this.getError
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__Rows_Pumps__["a" /* default */], {
                                                type: 'ballast',
                                                pumps: pumps.ballast,
                                                confirmed: !confirmed,
                                                changeField: this.changeFieldsMultiple,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Rows_TechEquipCertificate__["a" /* default */], {
                                                confirmed: !confirmed,
                                                techEquipCertificate: techEquipCertificate,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'TONNAGE, reg tons'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__Rows_Tonnage__["a" /* default */], {
                                                confirmed: !confirmed,
                                                rt: rt,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-8' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                { className: 'name-block static huge-name' },
                                                'CARGO EXCLUSIONS'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { style: { margin: '0 0 15px 35px' } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_material_ui_Toggle___default.a, {
                                                    disabled: !confirmed,
                                                    label: 'Rewrite owners exclusions',
                                                    toggled: isRewriteOwnerExclusions,
                                                    onToggle: this.toggleIsRewriteOwnerExclusions
                                                })
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { style: { marginBottom: '15px' }, className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Rows_CargoExclussionsV2__["a" /* default */], {
                                                cargoExclusionV2Object: cargoExclusionV2Object,
                                                cargoExclusionV2List: cargoExclusionV2List,
                                                cargoExclusionsV2: cargoExclusionsV2,
                                                deleteOwners: isRewriteOwnerExclusions,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'TRADING RESTRICTIONS'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Rows_TradingRestrictions__["a" /* default */], {
                                                deleteOwners: isRewriteOwnerExclusions,
                                                tradingRestrictions: tradingRestrictions,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                { className: 'name-block static huge-name' },
                                                'Last 3 Cargo'
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__Rows_LastCargo__["a" /* default */], {
                                                lastCargo: lastCargo,
                                                disabled: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { style: { float: 'right', marginTop: '-28px' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_58_components_Base_NumberField__["a" /* default */], {
                                            name: 'capacityV2.constant',
                                            disabled: !confirmed,
                                            value: capacityV2.constant,
                                            floatingLabelText: 'Constant, mt',
                                            onChange: function onChange(e, value) {
                                                return _this9.changeField( /** @type {any} */{
                                                    field: 'capacityV2.constant',
                                                    value: value
                                                });
                                            },
                                            fullWidth: true,
                                            floatNumber: true
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'DEADWEIGHT / OTHER'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Rows_Deadweight__["a" /* default */], {
                                                deadWeight: deadWeight,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'CAPACITY GENERAL'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__Rows_CapacityV2__["a" /* default */], {
                                                capacityV2: capacityV2,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'HO/HA'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Rows_HoldsHatchesTop__["a" /* default */], {
                                        holds: holds,
                                        confirmed: !confirmed,
                                        hatches: hatches,
                                        holdsHatchesProducer: holdsHatchesProducer,
                                        changeHolds: this.changeHolds,
                                        changeHatches: this.changeHatches,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__Rows_Cells__["a" /* default */], {
                                        cells: cells,
                                        changeAreas: this.changeAreas,
                                        changeField: this.changeField,
                                        confirmed: !confirmed,
                                        getError: this.getError,
                                        temporaryHohaAreas: temporaryHohaAreas
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Rows_Areas__["a" /* default */], {
                                        areas: areas,
                                        confirmed: !confirmed,
                                        changeAreas: this.changeAreas,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'CAPACITY TANKER'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__Rows_CapacityTanker__["a" /* default */], {
                                        capacityTanker: capacityTanker,
                                        confirmed: !confirmed,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'DIMENSIONS, m'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__Rows_Dimensions__["a" /* default */], {
                                                dimensions: dimensions,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'MANIFOLDS'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56__Rows_Manifolds__["a" /* default */], {
                                        manifolds: manifolds,
                                        confirmed: !confirmed,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-3' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                { className: 'name-block static huge-name' },
                                                'SPEED & CONSUMPTION:'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            {
                                                className: 'col-xs-offset-5',
                                                style: { marginTop: '2px' }
                                            },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'span',
                                                {
                                                    className: 'name-block static huge-name',
                                                    style: {
                                                        color: '#b0b0b0',
                                                        fontSize: '14px'
                                                    }
                                                },
                                                'Modify all:'
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-1' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_material_ui_Toggle___default.a, {
                                                name: 'modifyAllIfo',
                                                label: 'IFO',
                                                disabled: !confirmed,
                                                toggled: toggleSpeedConsAll.IFO,
                                                onToggle: function onToggle() {
                                                    return _this9.toggleModifySpeedCons('IFO');
                                                }
                                            })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-1' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_material_ui_Toggle___default.a, {
                                                name: 'modifyAllMdo',
                                                label: 'MDO',
                                                disabled: !confirmed,
                                                toggled: toggleSpeedConsAll.MDO,
                                                onToggle: function onToggle() {
                                                    return _this9.toggleModifySpeedCons('MDO');
                                                }
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__Rows_SpeedConsumptionV2__["a" /* default */], {
                                                speedConsumptionV2: speedConsumptionV2,
                                                confirmed: !confirmed,
                                                changeField: this.changeField,
                                                getError: this.getError
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'BUNKERS'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__Rows_Bunkers__["a" /* default */], {
                                        bunkers: bunkers,
                                        confirmed: !confirmed,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'PERMISSIBLE LOADS'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Rows_Strength__["a" /* default */], {
                                        strength: strength,
                                        confirmed: !confirmed,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Rows_StackWeight__["a" /* default */], {
                                        stackWeight: stackWeight,
                                        confirmed: !confirmed,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'CERTIFICATE OF FITNESS'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__Rows_CertificateOfFitness__["a" /* default */], {
                                        confirmed: confirmed,
                                        certificateOfFitness: certificateOfFitness,
                                        changeField: this.changeField
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'OTHER FIELDS'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Rows_OtherFields__["a" /* default */], {
                                        confirmed: !confirmed,
                                        engineLocation: engineLocation,
                                        engines: engines,
                                        windScale: windScale,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'paper-block margin-bottom' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { className: 'name-block static huge-name' },
                                        'DESCRIPTION'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__Rows_Description__["a" /* default */], {
                                        confirmed: !confirmed,
                                        description: description,
                                        changeField: this.changeField,
                                        getError: this.getError
                                    })
                                )
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselSingle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref5) {
    var countries = _ref5.countries,
        vessel = _ref5.vessel,
        isLogged = _ref5.user.isLogged;
    return {
        countries: countries.items,
        vessel: vessel,
        isLogged: isLogged
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getVessel: __WEBPACK_IMPORTED_MODULE_36_services_vessels_vessels__["g" /* getVessel */],
        getCountries: __WEBPACK_IMPORTED_MODULE_38_actions_countries__["a" /* getCountries */],
        clearVessel: __WEBPACK_IMPORTED_MODULE_37_actions_vessels_vessels__["b" /* clearVessel */]
    }, dispatch);
})(VesselSingle);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(scroll, 'scroll', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Page.jsx');
    reactHotLoader.register(defaultCargo, 'defaultCargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Page.jsx');
    reactHotLoader.register(getInitialState, 'getInitialState', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Page.jsx');
    reactHotLoader.register(VesselSingle, 'VesselSingle', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SuggestionNamesList__ = __webpack_require__(3315);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var SuggestionNames = function (_Component) {
    _inherits(SuggestionNames, _Component);

    function SuggestionNames(props) {
        _classCallCheck(this, SuggestionNames);

        var _this = _possibleConstructorReturn(this, (SuggestionNames.__proto__ || Object.getPrototypeOf(SuggestionNames)).call(this, props));

        _this.state = {
            loading: false
        };

        _this.renameVessel = _this.renameVessel.bind(_this);

        _this.changeSuggestedName = _this.changeSuggestedName.bind(_this);

        _this.cancelSuggestion = _this.cancelSuggestion.bind(_this);
        return _this;
    }

    _createClass(SuggestionNames, [{
        key: 'renameVessel',
        value: function renameVessel() {
            var _this2 = this;

            var _props = this.props,
                vessel = _props.vessel,
                refreshVessel = _props.refreshVessel;


            this.setState({
                loading: true
            }, function () {
                return _this2.props.renameVessel(_extends({}, vessel), refreshVessel);
            });
        }
    }, {
        key: 'changeSuggestedName',
        value: function changeSuggestedName(sName) {
            var updateSuggestedName = this.props.updateSuggestedName;


            updateSuggestedName(sName);
        }
    }, {
        key: 'cancelSuggestion',
        value: function cancelSuggestion() {
            var _props2 = this.props,
                suggestedName = _props2.vessel.suggestedName,
                refreshVessel = _props2.refreshVessel;


            if (!suggestedName) return;

            this.props.deleteNameSuggestion({ vessel: this.props.vessel, refreshVessel: refreshVessel, suggestedName: suggestedName });
        }
    }, {
        key: 'render',
        value: function render() {
            var vessel = this.props.vessel;
            var loading = this.state.loading;


            var showNameSuggestionBlock = !!(vessel.nameSuggestion && vessel.suggestedName);

            if (loading && showNameSuggestionBlock) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-7 center-xs middle-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_CircularProgress___default.a, null)
                );
            }

            return showNameSuggestionBlock && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-7 middle-xs' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SuggestionNamesList__["a" /* default */], {
                        suggestedName: vessel.suggestedName,
                        nameSuggestion: vessel.nameSuggestion,
                        changeSuggestedName: this.changeSuggestedName
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row center-xs bottom-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                            primary: true,
                            label: 'Save',
                            style: { margin: '0 20px 0 0' },
                            onClick: this.renameVessel
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
                            secondary: true,
                            style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].autoHeightContainer,
                            overlayStyle: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].autoHeightButton,
                            onClick: this.cancelSuggestion,
                            label: 'Cancel'

                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SuggestionNames;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        renameVessel: __WEBPACK_IMPORTED_MODULE_7_actions_vessels_vessels__["g" /* renameVessel */],

        deleteNameSuggestion: __WEBPACK_IMPORTED_MODULE_7_actions_vessels_vessels__["d" /* deleteNameSuggestion */]
    }, dispatch);
})(SuggestionNames);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SuggestionNames, 'SuggestionNames', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SuggestionNames.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SuggestionNames.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SuggestionNamesList = function (_Component) {
    _inherits(SuggestionNamesList, _Component);

    function SuggestionNamesList(props) {
        _classCallCheck(this, SuggestionNamesList);

        var _this = _possibleConstructorReturn(this, (SuggestionNamesList.__proto__ || Object.getPrototypeOf(SuggestionNamesList)).call(this, props));

        _this.state = {
            open: false,

            anchorEl: null
        };

        _this.handleOpen = _this.handleOpen.bind(_this);

        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }

    _createClass(SuggestionNamesList, [{
        key: 'handleOpen',
        value: function handleOpen(ev) {
            ev.preventDefault();

            this.setState({
                open: true,

                anchorEl: ev.currentTarget
            });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.setState({
                open: false
            });
        }
    }, {
        key: 'menuItems',
        value: function menuItems(suggestedNames) {
            var _this2 = this;

            var _id = this.props.suggestedName._id;

            return suggestedNames.map(function (sName, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_MenuItem___default.a, {
                    key: index,
                    value: sName.name,
                    style: sName._id === _id ? { backgroundColor: 'rgb(0, 188, 212)', color: '#fff' } : null,
                    primaryText: 'Name: ' + sName.name + '; From: ' + sName.from + '; Date: ' + new Date(sName.date).toLocaleDateString('en-US'),
                    onClick: function onClick() {
                        return _this2.changeSuggestedName(sName);
                    }
                });
            });
        }
    }, {
        key: 'changeSuggestedName',
        value: function changeSuggestedName(name) {
            var changeSuggestedName = this.props.changeSuggestedName;


            changeSuggestedName(name);

            this.setState({
                open: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                nameSuggestion = _props.nameSuggestion,
                name = _props.suggestedName.name;
            var _state = this.state,
                anchorEl = _state.anchorEl,
                open = _state.open;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'col-xs',
                    style: {
                        display: 'flex',

                        flexDirection: 'column',

                        alignItems: 'center'
                    }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block huge-name' },
                    'VESSEL\'S SUGGESTED NAMES:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                    onClick: this.handleOpen,
                    label: name,
                    labelColor: __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_colors__["red500"],
                    style: { margin: '10px 0px' }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Popover___default.a,
                    {
                        open: open,
                        anchorEl: anchorEl,
                        anchorOrigin: {
                            horizontal: 'left',

                            vertical: 'bottom'
                        },
                        targetOrigin: { horizontal: 'left', vertical: 'top' },
                        onRequestClose: this.handleClose
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Menu___default.a,
                        null,
                        this.menuItems(nameSuggestion)
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SuggestionNamesList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = SuggestionNamesList;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SuggestionNamesList, 'SuggestionNamesList', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SuggestionNamesList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/SuggestionNamesList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_highlight_off__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_highlight_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_highlight_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions_yards__ = __webpack_require__(3317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_vessels_vessels__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_action_open_in_new__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_action_open_in_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_action_open_in_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Rows_withExclusions__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_helpers_vessels__ = __webpack_require__(528);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var Sidebar = function (_React$Component) {
    _inherits(Sidebar, _React$Component);

    function Sidebar(props) {
        _classCallCheck(this, Sidebar);

        var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

        _this.state = {
            openDialogDelete: false,
            openDialogDeleteImage: false,
            parentState: props.parentState,
            confirmed: props.confirmed
        };

        _this.addVessel = _this.addVessel.bind(_this);
        _this.deleteVessel = _this.deleteVessel.bind(_this);
        _this.updateVessel = _this.updateVessel.bind(_this);
        _this.toggleDialog = _this.toggleDialog.bind(_this);
        _this.confirmVessel = _this.confirmVessel.bind(_this);
        _this.updateImageOnly = _this.updateImageOnly.bind(_this);
        return _this;
    }

    _createClass(Sidebar, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextState.parentState.image !== this.state.parentState.image || nextState.parentState.attachmentsArray !== this.state.parentState.attachmentsArray || nextState.openDialogDelete !== this.state.openDialogDelete || nextState.openDialogDeleteImage !== this.state.openDialogDeleteImage || nextProps.confirmed !== this.state.confirmed;
        }

        /**
         * The function serializes the vessel data into a backend JSON.
         */

    }, {
        key: 'prepareToLoad',
        value: function prepareToLoad(vessel) {
            if (vessel.errors.length > 0) {
                var el = document.getElementsByName(vessel.errors[0].field)[0];
                el.scrollIntoView();

                return;
            }

            vessel.flag = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'flagObject._id') && vessel.flagObject._id !== '' ? vessel.flagObject._id : undefined;
            vessel.builderV2.country = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'builderV2.countryObject._id') && vessel.builderV2.countryObject._id !== '' ? vessel.builderV2.countryObject._id : undefined;
            vessel.piClub = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'piClubObject._id') && vessel.piClubObject._id !== '' ? vessel.piClubObject._id : undefined;
            vessel.cargoExclusionV2 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'cargoExclusionV2Object._id') && vessel.cargoExclusionV2Object._id !== '' ? vessel.cargoExclusionV2Object._id.map(function (excl) {
                return excl.cargoExclusion._id;
            }) : undefined;
            vessel.owner = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'owner._id') && vessel.owner._id !== '' ? vessel.owner._id : undefined;
            vessel.registeredOwner = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'registeredOwnerObject._id') && vessel.registeredOwnerObject._id !== '' ? vessel.registeredOwnerObject._id : undefined;
            vessel.manager = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'managerObject._id') && vessel.managerObject._id !== '' ? vessel.managerObject._id : undefined;
            vessel.homePort = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(vessel, 'homePortObject._id') && vessel.homePortObject._id !== '' ? vessel.homePortObject._id : undefined;

            if (vessel.gearV2) {
                vessel.gearV2.summary.forEach(function (gear) {
                    gear.quantity = parseFloat(gear.quantity) || undefined;
                    gear.capacity = parseFloat(gear.capacity) || undefined;
                    gear.outreach = parseFloat(gear.outreach) || undefined;
                    gear.maxSWL = parseFloat(gear.maxSWL) || undefined;
                });
            }

            delete vessel.gears;

            vessel.grabV2.summary = Object(__WEBPACK_IMPORTED_MODULE_16_helpers_vessels__["a" /* checkGrabs */])(vessel.grabV2.summary);

            vessel.bunkers = this.checkIfEmptyArray(vessel.bunkers);

            if (vessel.rt) {
                vessel.rt.panamaNt = vessel.rt.panamaNt || undefined;
                vessel.rt.suezGt = vessel.rt.suezGt || undefined;
                vessel.rt.suezNt = vessel.rt.suezNt || undefined;
                vessel.rt.nt = vessel.rt.nt || undefined;
                vessel.rt.gt = vessel.rt.gt || undefined;
            }

            if (vessel.dimensions) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.entries(vessel.dimensions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _step$value = _slicedToArray(_step.value, 2),
                            key = _step$value[0],
                            value = _step$value[1];

                        if (!value) {
                            vessel.dimensions[key] = undefined;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (vessel.engines) {
                for (var i = 0; i < vessel.engines.length; i++) {
                    var engine = vessel.engines[i];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = Object.entries(engine)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _step2$value = _slicedToArray(_step2.value, 2),
                                key = _step2$value[0],
                                value = _step2$value[1];

                            if (!value) {
                                engine[key] = undefined;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }

            if (vessel.deadWeight) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = Object.entries(vessel.deadWeight)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var _step3$value = _slicedToArray(_step3.value, 2),
                            key = _step3$value[0],
                            value = _step3$value[1];

                        vessel.deadWeight[key] = value ? parseFloat(value) : undefined;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }

            if (vessel.techEquipCertificate) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = Object.entries(vessel.techEquipCertificate)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var _step4$value = _slicedToArray(_step4.value, 2),
                            key = _step4$value[0],
                            value = _step4$value[1];

                        if (!value) {
                            vessel.techEquipCertificate[key] = undefined;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }

                var igs = vessel.techEquipCertificate.igs;

                if (igs) {
                    igs.fitted = igs.fitted || undefined;
                    if (igs.systems) {
                        igs.systems = igs.systems.filter(function (s) {
                            return s.type || s.capacity || s.percentage;
                        }).map(function (s) {
                            return {
                                type: s.type || undefined,
                                capacity: parseFloat(s.capacity) || undefined,
                                percentage: parseFloat(s.percentage) || undefined
                            };
                        });
                    }
                }
            }

            if (vessel.areas) {
                vessel.areas.mainDeck = vessel.areas.mainDeck || undefined;
                vessel.areas.tweenDeck = vessel.areas.tweenDeck || undefined;
                vessel.areas.weatherDeck = vessel.areas.weatherDeck || undefined;
                vessel.areas.total = vessel.areas.total || undefined;
            }

            if (vessel.strength) {
                vessel.strength.maxTt = vessel.strength.maxTt || undefined;
                vessel.strength.maxTween = vessel.strength.maxTween || undefined;
                vessel.strength.maxWeather = vessel.strength.maxWeather || undefined;
            }

            if (vessel.stackWeight) {
                vessel.stackWeight['20hold'] = vessel.stackWeight['20hold'] || undefined;
                vessel.stackWeight['20deck'] = vessel.stackWeight['20deck'] || undefined;
                vessel.stackWeight['40hold'] = vessel.stackWeight['40hold'] || undefined;
                vessel.stackWeight['40deck'] = vessel.stackWeight['40deck'] || undefined;
            }

            if (vessel.cargoExclusionsV2.length) {
                vessel.cargoExclusionsV2 = Object(__WEBPACK_IMPORTED_MODULE_15__Rows_withExclusions__["b" /* prepareExclToLoad */])(vessel.cargoExclusionsV2, vessel.isRewriteOwnerExclusions);
            }

            if (vessel.tradingRestrictions.length) {
                vessel.tradingRestrictions = Object(__WEBPACK_IMPORTED_MODULE_15__Rows_withExclusions__["b" /* prepareExclToLoad */])(vessel.tradingRestrictions, vessel.isRewriteOwnerExclusions);
            }

            vessel.cells = vessel.cells.filter(function (item) {
                var holdsLen = Object.values(item.holds).filter(function (_item) {
                    return _item;
                }).length;
                var tweenDecksLen0 = Object.values(item.tweenDecks[0]).filter(function (_item) {
                    return _item;
                }).length;
                var tweenDecksLen1 = Object.values(item.tweenDecks[1]).filter(function (_item) {
                    return _item;
                }).length;

                var hatchesLen0 = Object.values(item.hatches[0]).filter(function (_item) {
                    return _item;
                }).length;
                var hatchesLen1 = Object.values(item.hatches[1]).filter(function (_item) {
                    return _item;
                }).length;

                return holdsLen || tweenDecksLen0 || tweenDecksLen1 || hatchesLen0 || hatchesLen1;
            });

            if (vessel.cells) {
                vessel.cells.forEach(function (cell) {
                    cell.holds.l = parseFloat(cell.holds.l) || undefined;
                    cell.holds.b = parseFloat(cell.holds.b) || undefined;
                    cell.holds.h = parseFloat(cell.holds.h) || undefined;
                    cell.holds.area = parseFloat(cell.holds.area) || undefined;

                    cell.tweenDecks[0].l = parseFloat(cell.tweenDecks[0].l) || undefined;
                    cell.tweenDecks[0].b = parseFloat(cell.tweenDecks[0].b) || undefined;
                    cell.tweenDecks[0].h = parseFloat(cell.tweenDecks[0].h) || undefined;
                    cell.tweenDecks[0].area = parseFloat(cell.tweenDecks[0].area) || undefined;

                    cell.tweenDecks[1].l = parseFloat(cell.tweenDecks[1].l) || undefined;
                    cell.tweenDecks[1].b = parseFloat(cell.tweenDecks[1].b) || undefined;
                    cell.tweenDecks[1].h = parseFloat(cell.tweenDecks[1].h) || undefined;
                    cell.tweenDecks[1].area = parseFloat(cell.tweenDecks[1].area) || undefined;

                    cell.hatches[0].l = parseFloat(cell.hatches[0].l) || undefined;
                    cell.hatches[0].b = parseFloat(cell.hatches[0].b) || undefined;
                    cell.hatches[0].area = parseFloat(cell.hatches[0].area) || undefined;

                    cell.hatches[1].l = parseFloat(cell.hatches[1].l) || undefined;
                    cell.hatches[1].b = parseFloat(cell.hatches[1].b) || undefined;
                    cell.hatches[1].area = parseFloat(cell.hatches[1].area) || undefined;
                });
            }

            if (vessel.speedConsumptionV2) {
                vessel.speedConsumptionV2.forEach(function (val) {
                    val.speed = parseFloat(val.speed) || undefined;
                    val.ifo.cons = parseFloat(val.ifo.cons) || undefined;
                    val.mdo.cons = parseFloat(val.mdo.cons) || undefined;
                    val.lngCons = parseFloat(val.lngCons) || undefined;
                });
            }

            delete vessel.consumptions;

            vessel.speedConsumptionV2 = vessel.speedConsumptionV2.filter(function (item) {
                return item.mode;
            });

            if (vessel.capacityV2) {
                vessel.capacityV2.constant = parseFloat(vessel.capacityV2.constant) || undefined;
                vessel.capacityV2.grain = parseFloat(vessel.capacityV2.grain) || undefined;
                vessel.capacityV2.bale = parseFloat(vessel.capacityV2.bale) || undefined;
                vessel.capacityV2.teu = parseFloat(vessel.capacityV2.teu) || undefined;
                vessel.capacityV2.feu = parseFloat(vessel.capacityV2.feu) || undefined;

                vessel.capacityV2.summary.forEach(function (item) {
                    item.hold.grain = parseFloat(item.hold.grain) || undefined;
                    item.hold.bale = parseFloat(item.hold.bale) || undefined;
                    item.hold.teu = parseFloat(item.hold.teu) || undefined;
                    item.hold.feu = parseFloat(item.hold.feu) || undefined;

                    item.tweenDeck.grain = parseFloat(item.tweenDeck.grain) || undefined;
                    item.tweenDeck.bale = parseFloat(item.tweenDeck.bale) || undefined;
                    item.tweenDeck.teu = parseFloat(item.tweenDeck.teu) || undefined;
                    item.tweenDeck.feu = parseFloat(item.tweenDeck.feu) || undefined;
                });
            }

            vessel.capacityV2.summary = this.checkCapacity(vessel.capacityV2.summary);

            if (vessel.gearV2) {
                vessel.gearV2.summary.forEach(function (gear) {
                    gear.type = gear.type || '';
                    gear.quantity = gear.quantity || undefined;
                    gear.capacity = gear.capacity || undefined;
                    gear.outreach = gear.outreach || undefined;
                    gear.maxSWL = gear.maxSWL || undefined;
                });
            }

            if (vessel.grabV2) {
                vessel.grabV2.summary.forEach(function (grab) {
                    grab.type = grab.type || '';
                    grab.quantity = grab.quantity || undefined;
                    grab.volume = grab.volume || undefined;
                });
            }

            if (vessel.holds) {
                vessel.holds.quantity = vessel.holds.quantity || undefined;

                if (vessel.holds.lowerDims && vessel.holds.lowerDims.length) {
                    vessel.holds.lowerDims.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                        dim.h = dim.h || undefined;
                    });
                }

                if (vessel.holds.tweenDims && vessel.holds.tweenDims.length) {
                    vessel.holds.tweenDims.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                        dim.h = dim.h || undefined;
                    });
                }
            }
            if (vessel.hatches) {
                if (vessel.hatches.hatchType === 'Mc Greegor') {
                    vessel.hatches.hatchType = 'Mc Gregor';
                }
                if (vessel.hatches.size && vessel.hatches.size.length) {
                    vessel.hatches.size.forEach(function (dim) {
                        dim.l = dim.l || undefined;
                        dim.b = dim.b || undefined;
                    });
                }
            }

            if (vessel.bunkers.length > 0) {
                vessel.bunkers = vessel.bunkers.filter(function (item) {
                    return item.quantity && item.typeOfFuel;
                });
            }

            vessel.imoClass = vessel.imoClass || undefined;

            if (!vessel.disponentOwner._id && !vessel.disponentOwner.name) {
                delete vessel.disponentOwner;
            }

            if (vessel.pumps && vessel.pumps.cargo) {
                vessel.pumps.cargo = vessel.pumps.cargo.filter(function (p) {
                    return p.type || p.quantity || p.capacity;
                });
            }
            if (vessel.pumps && vessel.pumps.ballast) {
                vessel.pumps.ballast = vessel.pumps.ballast.filter(function (p) {
                    return p.type || p.quantity || p.capacity;
                });
            }
            if (vessel.registerClasses) {
                vessel.registerClasses = vessel.registerClasses.filter(function (c) {
                    return c.name && (c._id || c.iacsRegister === true || c.iacsRegister === false);
                }).map(function (c) {
                    return {
                        _id: c._id || undefined,
                        name: c.name || undefined,
                        iacsRegister: c.iacsRegister === true || c.iacsRegister === false ? c.iacsRegister : undefined
                    };
                });
                vessel.registerClass = undefined;
            }
            if (vessel.capacityTanker.tanks) {
                vessel.capacityTanker.tanks = vessel.capacityTanker.tanks.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.capacityTanker.slops) {
                vessel.capacityTanker.slops = vessel.capacityTanker.slops.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.capacityTanker.ballastTanks) {
                vessel.capacityTanker.ballastTanks = vessel.capacityTanker.ballastTanks.filter(function (t) {
                    return t.port || t.starboard;
                });
            }
            if (vessel.manifolds && vessel.manifolds.list) {
                vessel.manifolds.list = vessel.manifolds.list.filter(function (m) {
                    return m.number || m.size || m.commonLine;
                });
            }
            if (vessel.lastCargo) {
                vessel.lastCargo = vessel.lastCargo.map(function (tank) {
                    return {
                        cargoes: tank.cargoes.filter(function (c) {
                            return c.cargo._id && c.date;
                        }).map(function (c) {
                            return _extends({}, c, {
                                cargo: c.cargo._id.toString()
                            });
                        })
                    };
                });
            }
            if (vessel.certificateOfFitness) {
                vessel.certificateOfFitness = vessel.certificateOfFitness.map(function (c) {
                    return c._id;
                });
            }
            if (vessel.strength && vessel.strength.tanktopByHolds) {
                vessel.strength.tanktopByHolds = vessel.strength.tanktopByHolds.map(function (s) {
                    return parseInt(s, 10);
                }).filter(function (s) {
                    return !isNaN(s);
                });
            }

            delete vessel.draft;
            delete vessel.tonnage;
            delete vessel.dw;
            delete vessel.capacity;
            delete vessel.speeds;
            return vessel;
        }
    }, {
        key: 'addVessel',
        value: function addVessel() {
            var vessel = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.parentState);
            vessel = this.prepareToLoad(vessel);

            if (!vessel.typeByPurpose) {
                return this.props.addNotification({
                    title: 'Error',
                    message: 'Type by purpose is required',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 5
                });
            }

            vessel && this.props.addVessel(vessel);
        }
    }, {
        key: 'confirmVessel',
        value: function confirmVessel() {
            this.props.confirmVessel(this.props.parentState._id);
            this.props.changeField({
                field: 'typeOfPage',
                value: 'update'
            });

            this.props.changeField({
                field: 'confirmed',
                value: 'true'
            });
        }
    }, {
        key: 'updateVessel',
        value: function updateVessel() {
            var vessel = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.props.parentState);
            vessel = this.prepareToLoad(vessel);

            if (!vessel.typeByPurpose) {
                return this.props.addNotification({
                    title: 'Error',
                    message: 'Type by purpose is required',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 5
                });
            }

            vessel && this.props.updateVessel(vessel);
        }
    }, {
        key: 'deleteVessel',
        value: function deleteVessel() {
            this.props.deleteVessel(this.props.parentState);
        }
    }, {
        key: 'checkIfEmptyAndReplace',
        value: function checkIfEmptyAndReplace(array) {
            return array.map(function (item) {
                for (var key in item) {
                    if (item[key]) {
                        return item;
                    }
                }

                return {};
            });
        }
    }, {
        key: 'checkIfEmptyArray',
        value: function checkIfEmptyArray(array) {
            return array.filter(function (item) {
                for (var key in item) {
                    return !!item[key];
                }
            });
        }
    }, {
        key: 'checkGears',
        value: function checkGears(array) {
            return array.filter(function (item) {
                if (item.combinable) {
                    return true;
                }

                for (var key in item) {
                    if (key !== 'combinable') {
                        return !!item[key];
                    }
                }
            });
        }
    }, {
        key: 'checkCapacity',
        value: function checkCapacity(array) {
            return array.filter(function (item) {
                var _item$hold = item.hold,
                    hg = _item$hold.grain,
                    hb = _item$hold.bale,
                    ht = _item$hold.teu,
                    hf = _item$hold.feu,
                    _item$tweenDeck = item.tweenDeck,
                    tg = _item$tweenDeck.grain,
                    tb = _item$tweenDeck.bale,
                    tt = _item$tweenDeck.teu,
                    tf = _item$tweenDeck.feu;


                return hg || hb || ht || hf || tg || tb || tt || tf;
            });
        }
    }, {
        key: 'toggleDialog',
        value: function toggleDialog(field) {
            this.setState(_defineProperty({}, field, !this.state[field]));
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                parentState: nextProps.parentState,
                confirmed: nextProps.confirmed
            });
        }
    }, {
        key: 'updateImageOnly',
        value: function updateImageOnly() {
            var _props$parentState = this.props.parentState,
                images = _props$parentState.images,
                _id = _props$parentState._id;

            if (images && images[0]) {
                this.props.updateVesselImage(_id, images[0]);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                openDialogDelete = _state.openDialogDelete,
                openDialogDeleteImage = _state.openDialogDeleteImage,
                confirmed = _state.confirmed;
            var _props = this.props,
                typeOfPage = _props.typeOfPage,
                loadImage = _props.loadImage,
                loadAttachment = _props.loadAttachment,
                removeAttachment = _props.removeAttachment,
                removeImage = _props.removeImage;
            var _state$parentState = this.state.parentState,
                image = _state$parentState.image,
                attachmentsArray = _state$parentState.attachmentsArray,
                deleteBy = _state$parentState.deleteBy;


            var getDialogActions = function getDialogActions(type) {
                if (type === 'deleteVessel') {
                    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, {
                        label: 'Cancel',
                        primary: true,
                        onClick: function onClick() {
                            return _this2.toggleDialog('openDialogDelete');
                        }
                    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, {
                        label: 'Submit',
                        primary: true,
                        onClick: _this2.deleteVessel
                    })];
                } else if (type === 'deleteImage') {
                    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, {
                        label: 'Cancel',
                        primary: true,
                        onClick: function onClick() {
                            return _this2.toggleDialog('openDialogDeleteImage');
                        }
                    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_FlatButton___default.a, {
                        label: 'Submit',
                        primary: true,
                        onClick: function onClick() {
                            removeImage();
                            _this2.toggleDialog('openDialogDeleteImage');
                        }
                    })];
                }

                return [];
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Dialog___default.a,
                    {
                        title: confirmed ? 'Reject' : 'Delete',
                        actions: getDialogActions('deleteVessel'),
                        modal: false,
                        open: openDialogDelete,
                        onRequestClose: function onRequestClose() {
                            return _this2.toggleDialog('openDialogDelete');
                        }
                    },
                    'Do you want to ',
                    confirmed ? 'reject' : 'delete',
                    ' this vessel?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Dialog___default.a,
                    {
                        title: 'Delete image',
                        actions: getDialogActions('deleteImage'),
                        modal: false,
                        open: openDialogDeleteImage,
                        onRequestClose: function onRequestClose() {
                            return _this2.toggleDialog('openDialogDeleteImage');
                        }
                    },
                    'Do you want to delete image?'
                ),
                ' ',
                typeOfPage === 'new' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom middle-xs center-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Management'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        primary: true,
                        label: 'Create',
                        onClick: this.addVessel
                    })
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    !deleteBy ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-bottom middle-xs center-xs', style: { display: 'flex' } },
                        confirmed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                primary: true,
                                label: 'Confirm',
                                style: { margin: '0 20px 0 0' },
                                onClick: this.confirmVessel
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                secondary: true,
                                label: 'Reject',
                                onClick: function onClick() {
                                    return _this2.toggleDialog('openDialogDelete');
                                }
                            })
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                primary: true,
                                label: 'Update',
                                style: { margin: '0 20px 0 0' },
                                onClick: this.updateVessel
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                secondary: true,
                                label: 'Delete',
                                onClick: function onClick() {
                                    return _this2.toggleDialog('openDialogDelete');
                                }
                            })
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        'deleteBy ',
                        deleteBy
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom center-xs', style: { display: 'flex', flexFlow: 'wrap' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Image'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { position: 'relative' } },
                        image ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,
                                {
                                    style: {
                                        position: 'absolute', right: 0, width: '36px', height: '36px', padding: 0
                                    }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_highlight_off___default.a, {
                                    color: 'red',
                                    onClick: function onClick() {
                                        return _this2.toggleDialog('openDialogDeleteImage');
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                                style: { width: '100%' },
                                src: image,
                                alt: 'alt1'
                            })
                        ) : null
                    ),
                    !deleteBy ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a,
                        {
                            disabled: confirmed,
                            containerElement: 'label',
                            label: image ? 'Change image' : 'Add image',
                            labelStyle: { fontSize: '11px' }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                            type: 'file',
                            accept: 'image/*',
                            onChange: loadImage,
                            style: { display: 'none' }
                        })
                    ) : '',
                    image && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        primary: true,
                        label: 'Update image only',
                        style: { marginLeft: '8px' },
                        labelStyle: { fontSize: '11px' },
                        onClick: this.updateImageOnly
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom middle-xs center-xs', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        primary: true,
                        label: 'Back to list',
                        containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/vessels/list' })
                    })
                ),
                this.state.parentState.imoNumber ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            href: 'https://www.vesselfinder.com/vessels/details/' + this.state.parentState.imoNumber,
                            style: {
                                display: 'flex', alignItems: 'center', color: 'inherit', marginBottom: '10px', fontSize: '14px'
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_action_open_in_new___default.a, { className: 'icon', color: '#757575', size: 20, style: { marginRight: '5px' } }),
                        'Open on vesselfinder.com'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            href: 'https://www.marinetraffic.com/en/ais/details/ships/imo:' + this.state.parentState.imoNumber,
                            style: {
                                display: 'flex', alignItems: 'center', color: 'inherit', fontSize: '14px'
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_action_open_in_new___default.a, { className: 'icon', color: '#757575', size: 20, style: { marginRight: '5px' } }),
                        'Open on marinetraffic.com'
                    )
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom center-xs', style: { display: 'flex', flexFlow: 'wrap' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Attachments'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'attachments-list' },
                        attachmentsArray.map(function (item, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: key, className: 'item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'name' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'a',
                                        { href: item.url, target: '_blank' },
                                        item.name
                                    )
                                ),
                                !deleteBy ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                        onClick: function onClick() {
                                            removeAttachment(key);
                                        },
                                        color: 'red'
                                    })
                                ) : ''
                            );
                        })
                    ),
                    !deleteBy ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a,
                        { disabled: confirmed, containerElement: 'label', label: 'Add' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                            type: 'file',
                            accept: 'xls, .xlsx, .txt, .csv, .pdf, .jpg, .jpeg, .png, .doc, .docx, .rtf',
                            onChange: function onChange(e) {
                                loadAttachment(e);
                            },
                            style: { display: 'none' }
                        })
                    ) : ''
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var parentState = _ref.parentState,
        changeField = _ref.changeField,
        typeOfPage = _ref.typeOfPage;
    return {
        parentState: parentState,
        changeField: changeField,
        typeOfPage: typeOfPage
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addVessel: __WEBPACK_IMPORTED_MODULE_13_actions_vessels_vessels__["a" /* addVessel */],
        addYard: __WEBPACK_IMPORTED_MODULE_12_actions_yards__["a" /* addYard */],
        updateVessel: __WEBPACK_IMPORTED_MODULE_13_actions_vessels_vessels__["i" /* updateVessel */],
        deleteVessel: __WEBPACK_IMPORTED_MODULE_13_actions_vessels_vessels__["e" /* deleteVessel */],
        addNotification: __WEBPACK_IMPORTED_MODULE_11_actions_notifications_notifications__["a" /* addNotification */],
        confirmVessel: __WEBPACK_IMPORTED_MODULE_13_actions_vessels_vessels__["c" /* confirmVessel */],
        updateVesselImage: __WEBPACK_IMPORTED_MODULE_13_actions_vessels_vessels__["j" /* updateVesselImage */]
    }, dispatch);
})(Sidebar);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Sidebar, 'Sidebar', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Sidebar.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Sidebar.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = addYard;
/* unused harmony export findYards */
/* unused harmony export getYard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function addYard(yard) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants_ActionTypes__["l" /* ADD_YARD */].REQUEST,
        yard: yard
    };
}

function findYards(yard) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants_ActionTypes__["_3" /* FIND_YARDS */].REQUEST,
        yard: yard
    };
}

function getYard(id) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants_ActionTypes__["_64" /* GET_YARD */].REQUEST,
        id: id
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(addYard, 'addYard', '/opt/atlassian/pipelines/agent/build/client/app/actions/yards.js');
    reactHotLoader.register(findYards, 'findYards', '/opt/atlassian/pipelines/agent/build/client/app/actions/yards.js');
    reactHotLoader.register(getYard, 'getYard', '/opt/atlassian/pipelines/agent/build/client/app/actions/yards.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export TradingRestrictions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withExclusions_js__ = __webpack_require__(369);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var type = 'tradingRestrictions';
var TradingRestrictions = function (_Component) {
    _inherits(TradingRestrictions, _Component);

    function TradingRestrictions() {
        _classCallCheck(this, TradingRestrictions);

        return _possibleConstructorReturn(this, (TradingRestrictions.__proto__ || Object.getPrototypeOf(TradingRestrictions)).apply(this, arguments));
    }

    _createClass(TradingRestrictions, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                underStyle = _props.underStyle,
                confirmed = _props.confirmed,
                modifiedFields = _props.modifiedFields,
                getError = _props.getError,
                renderExcl = _props.renderExcl,
                choose = _props.choose,
                change = _props.change,
                dataSource = _props.dataSource,
                currentExcl = _props.currentExcl;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', flexDirection: 'column' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', flexWrap: 'wrap' } },
                    renderExcl(type)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
                    name: type,
                    disabled: confirmed,
                    dataSource: dataSource,
                    dataSourceConfig: { text: 'name', value: 'tradingRestriction' },
                    floatingLabelText: 'Trading Restrictions',
                    onUpdateInput: change,
                    searchText: currentExcl.name || '',
                    onNewRequest: function onNewRequest(excl) {
                        return choose(type, excl);
                    },
                    filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
                    errorText: getError('tradingRestrictions'),
                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                    popoverProps: {
                        canAutoPosition: true
                    },
                    fullWidth: true,
                    underlineStyle: modifiedFields && modifiedFields.includes('tradingRestrictions') ? underStyle : null
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TradingRestrictions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_3__withExclusions_js__["a" /* default */])(function (name) {
    return __WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */].findPortAdmin({ name: name });
}, TradingRestrictions);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(type, 'type', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TradingRestrictions.jsx');
    reactHotLoader.register(TradingRestrictions, 'TradingRestrictions', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TradingRestrictions.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/TradingRestrictions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_statistics_users__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table_Table__ = __webpack_require__(3320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RangeDates__ = __webpack_require__(3322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RegistrationsCharts__ = __webpack_require__(3323);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var StatisticsUsersPage = function (_React$Component) {
    _inherits(StatisticsUsersPage, _React$Component);

    function StatisticsUsersPage(props) {
        _classCallCheck(this, StatisticsUsersPage);

        var _this = _possibleConstructorReturn(this, (StatisticsUsersPage.__proto__ || Object.getPrototypeOf(StatisticsUsersPage)).call(this, props));

        _this.state = {
            from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day').add(-1, 'month').toDate(),
            until: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day').toDate()
        };

        _this.changeDateRange = _this.changeDateRange.bind(_this);
        return _this;
    }

    _createClass(StatisticsUsersPage, [{
        key: 'changeDateRange',
        value: function changeDateRange(from, until) {
            this.setState({
                from: from,
                until: until
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _state = this.state,
                from = _state.from,
                until = _state.until;


            this.props.getStatisticsUsers(__WEBPACK_IMPORTED_MODULE_3_moment___default()(from).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(until).utcOffset(0, true).valueOf());
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                from = _state2.from,
                until = _state2.until;
            var isLoaded = this.props.isLoaded;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'statistics-users', className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Statistics users'
                ),
                isLoaded ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RegistrationsCharts__["a" /* default */], { from: from, until: until }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RangeDates__["a" /* default */], { from: from, until: until, changeDateRange: this.changeDateRange }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Table_Table__["a" /* default */], null)
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default.a, {
                    style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].circularProgress
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return StatisticsUsersPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var isLogged = _ref.user.isLogged,
        statisticsUsers = _ref.statisticsUsers;

    return {
        isLogged: isLogged,
        isLoaded: statisticsUsers.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getStatisticsUsers: __WEBPACK_IMPORTED_MODULE_6_actions_statistics_users__["a" /* getStatisticsUsers */]
    }, dispatch);
})(StatisticsUsersPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StatisticsUsersPage, 'StatisticsUsersPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_statistics_users__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Row__ = __webpack_require__(3321);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var StatisticsUsersTable = function (_React$Component) {
    _inherits(StatisticsUsersTable, _React$Component);

    function StatisticsUsersTable(props) {
        _classCallCheck(this, StatisticsUsersTable);

        var _this = _possibleConstructorReturn(this, (StatisticsUsersTable.__proto__ || Object.getPrototypeOf(StatisticsUsersTable)).call(this, props));

        var statisticsUsers = props.statisticsUsers,
            searchText = props.searchText;


        _this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: statisticsUsers.length,
            statisticsUsers: _this.filterSearch(statisticsUsers, searchText)
        };

        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }

    _createClass(StatisticsUsersTable, [{
        key: 'filterSearch',
        value: function filterSearch(items, searchText) {
            if (!searchText) {
                return items;
            }
            return items.filter(function (item) {
                if (item.name && item.name.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (item.surname && item.surname.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (item.email && item.email.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'item.company.name') && item.company.name.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.has(item, 'item.phones[0].phone') && item.phones[0].phone.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                return false;
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.handleUpdateRow(this.state);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var statisticsUsers = nextProps.statisticsUsers,
                searchText = nextProps.searchText;
            var page = this.state.page;


            if (searchText !== this.props.searchText) {
                page = 1;
            }

            this.setState({
                searchText: searchText,
                statisticsUsers: this.filterSearch(statisticsUsers, searchText),
                page: page,
                total: statisticsUsers.length
            }, function () {
                _this2.handleUpdateRow(_this2.state);
            });
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.statisticsUsers.slice(from, to);
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(newState) {
            var rows = this.changeRowsByPagination(newState);
            var state = newState;
            state.rows = rows;

            this.setState(state);
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e, value) {
            this.props.searchStatisticsUsers(value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                rows = _state.rows,
                rowsPerPage = _state.rowsPerPage,
                statisticsUsers = _state.statisticsUsers,
                page = _state.page,
                numberOfRows = _state.numberOfRows;
            var searchText = this.props.searchText;


            var sumUsersVerified = 0;
            var sumUsersEnterOnSite = 0;
            var sumRegistrations = 0;

            statisticsUsers.forEach(function (user) {
                if (user.emailVerified) {
                    sumUsersVerified += 1;
                }
                if (user.password) {
                    sumUsersEnterOnSite += 1;
                }

                if (user.createdAt) {
                    sumRegistrations += 1;
                }
            });

            var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
                total: statisticsUsers.length,
                rowsPerPage: rowsPerPage,
                page: page,
                numberOfRows: numberOfRows,
                updateRows: this.handleUpdateRow
            });

            var renderTable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["Table"],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeader"],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Name'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Surname'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Email'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Company'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Organization'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Country'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Phone'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Registration date'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Email verified'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Email verified date'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Login'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Current subscription'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Subscription starts'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                            { style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                            'Subscription ends'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableBody"],
                    { displayRowCheckbox: false },
                    rows.map(function (row, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Row__["a" /* default */], {
                            key: row._id + index,
                            item: row
                        });
                    })
                )
            );

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'In this dates range:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'Verified emails - ',
                            sumUsersVerified
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'Enter on site - ',
                            sumUsersEnterOnSite
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'Registration - ',
                            sumRegistrations
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                            defaultValue: searchText,
                            floatingLabelText: 'Search',
                            onChange: this.handleSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'item' },
                        renderPagination
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    renderTable
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return StatisticsUsersTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var _ref$statisticsUsers = _ref.statisticsUsers,
        items = _ref$statisticsUsers.items,
        searchText = _ref$statisticsUsers.searchText;

    return {
        statisticsUsers: items,
        searchText: searchText
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        searchStatisticsUsers: __WEBPACK_IMPORTED_MODULE_8_actions_statistics_users__["b" /* searchStatisticsUsers */]
    }, dispatch);
})(StatisticsUsersTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StatisticsUsersTable, 'StatisticsUsersTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Table/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Table/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();

function checkRelevantDateRange(currentDate, currentMonth, subscription) {
    return currentDate >= __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.from).date() && (currentDate <= __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.to).date() || currentMonth < __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.to).month());
}

function getCurrentSubscription(subscriptions) {
    var currentYear = now.year();
    var currentMonth = now.month();
    var currentDate = now.date();

    var subscriptionsWithinMonth = subscriptions.filter(function (subscription) {
        var fromYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.from).year();
        var fromMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.from).month();
        var toYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.to).year();
        var toMonth = __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.to).month();

        return currentYear >= fromYear && currentMonth >= fromMonth && currentYear <= toYear && currentMonth <= toMonth;
    });

    var result = subscriptionsWithinMonth && subscriptionsWithinMonth.length && subscriptionsWithinMonth[0].packageType || 0;
    if (subscriptionsWithinMonth.length > 1) {
        subscriptionsWithinMonth.forEach(function (subscription) {
            if (currentMonth > __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.from).month()) {
                if (currentMonth < __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.to).month()) {
                    result = subscription.packageType;
                } else {
                    // here currentMonth is equal to toMonth
                    if (checkRelevantDateRange(currentDate, currentMonth, subscription)) {
                        result = subscription.packageType;
                    }
                }
            } else if (currentMonth >= __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.from).month() && currentMonth <= __WEBPACK_IMPORTED_MODULE_3_moment___default()(subscription.to).month()) {
                if (checkRelevantDateRange(currentDate, currentMonth, subscription)) {
                    result = subscription.packageType;
                }
            }
        });
    }

    return result;
}

var StatisticsUsersRow = function (_React$Component) {
    _inherits(StatisticsUsersRow, _React$Component);

    function StatisticsUsersRow(props) {
        _classCallCheck(this, StatisticsUsersRow);

        var _this = _possibleConstructorReturn(this, (StatisticsUsersRow.__proto__ || Object.getPrototypeOf(StatisticsUsersRow)).call(this, props));

        _this.state = {
            item: props.item
        };

        return _this;
    }

    _createClass(StatisticsUsersRow, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                item: nextProps.item
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var item = this.state.item;

            var phone = '';

            if (item.phones && item.phones.length) {
                if (item.phones[0].code) {
                    phone = '+' + item.phones[0].code.replace('+', '') + ' ' + item.phones[0].phone;
                } else {
                    phone = item.phones[0].phone;
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.surname
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.email
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.companyName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.organizationType
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.country
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    phone
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.createdAt).format('MM-DD-YYYY')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.emailVerified ? '+' : '-'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.emailVerifiedAt ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.emailVerifiedAt).format('MM-DD-YYYY') : '-'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.password ? '+' : '-'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.subscriptions.length && getCurrentSubscription(item.subscriptions)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.subscriptions.length && __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.subscriptions[0].from).format('MM-DD-YYYY')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowColumnCSS },
                    item.subscriptions.length && __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.subscriptions[item.subscriptions.length - 1].to).format('MM-DD-YYYY')
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return StatisticsUsersRow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var item = _ref.item;

    return {
        item: item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(StatisticsUsersRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(now, 'now', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Table/Row.jsx');
    reactHotLoader.register(checkRelevantDateRange, 'checkRelevantDateRange', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Table/Row.jsx');
    reactHotLoader.register(getCurrentSubscription, 'getCurrentSubscription', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Table/Row.jsx');
    reactHotLoader.register(StatisticsUsersRow, 'StatisticsUsersRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Table/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/Table/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_statistics_users__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var RangeDates = function (_React$PureComponent) {
    _inherits(RangeDates, _React$PureComponent);

    function RangeDates(props) {
        _classCallCheck(this, RangeDates);

        var _this = _possibleConstructorReturn(this, (RangeDates.__proto__ || Object.getPrototypeOf(RangeDates)).call(this, props));

        var from = props.from,
            until = props.until;


        _this.state = {
            fromMinDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()([2017, 0, 2]).toDate(),
            fromMaxDate: until,

            untilMinDate: from,
            untilMaxDate: until,

            fromDate: from,
            untilDate: until
        };

        _this.changeFromDate = _this.changeFromDate.bind(_this);
        _this.changeUntilDate = _this.changeUntilDate.bind(_this);
        return _this;
    }

    _createClass(RangeDates, [{
        key: 'changeFromDate',
        value: function changeFromDate(e, date) {
            var _this2 = this;

            this.setState({
                fromDate: date,
                untilMinDate: date
            }, function () {
                var _state = _this2.state,
                    fromDate = _state.fromDate,
                    untilDate = _state.untilDate;


                _this2.props.changeDateRange(fromDate, untilDate);
                _this2.props.getStatisticsUsers(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).startOf('day').utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(untilDate).startOf('day').utcOffset(0, true).valueOf());
            });
        }
    }, {
        key: 'changeUntilDate',
        value: function changeUntilDate(e, date) {
            var _this3 = this;

            this.setState({
                untilDate: date,
                fromMaxDate: date
            }, function () {
                var _state2 = _this3.state,
                    fromDate = _state2.fromDate,
                    untilDate = _state2.untilDate;


                _this3.props.changeDateRange(fromDate, untilDate);
                _this3.props.getStatisticsUsers(__WEBPACK_IMPORTED_MODULE_3_moment___default()(fromDate).startOf('day').utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).startOf('day').utcOffset(0, true).valueOf());
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state3 = this.state,
                fromMinDate = _state3.fromMinDate,
                fromMaxDate = _state3.fromMaxDate,
                untilMinDate = _state3.untilMinDate,
                untilMaxDate = _state3.untilMaxDate,
                fromDate = _state3.fromDate,
                untilDate = _state3.untilDate;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker___default.a, {
                        floatingLabelText: 'From',
                        autoOk: true,
                        minDate: fromMinDate,
                        maxDate: fromMaxDate,
                        onChange: this.changeFromDate,
                        value: fromDate,
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY');
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker___default.a, {
                        floatingLabelText: 'Until',
                        autoOk: true,
                        minDate: untilMinDate,
                        maxDate: untilMaxDate,
                        onChange: this.changeUntilDate,
                        value: untilDate,
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY');
                        }
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RangeDates;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var from = _ref.from,
        until = _ref.until,
        changeDateRange = _ref.changeDateRange;

    return {
        from: from, until: until, changeDateRange: changeDateRange
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getStatisticsUsers: __WEBPACK_IMPORTED_MODULE_4_actions_statistics_users__["a" /* getStatisticsUsers */]
    }, dispatch);
})(RangeDates);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RangeDates, 'RangeDates', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/RangeDates.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/RangeDates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var RegistrationsCharts = function (_React$PureComponent) {
    _inherits(RegistrationsCharts, _React$PureComponent);

    function RegistrationsCharts(props) {
        _classCallCheck(this, RegistrationsCharts);

        var _this = _possibleConstructorReturn(this, (RegistrationsCharts.__proto__ || Object.getPrototypeOf(RegistrationsCharts)).call(this, props));

        var statisticsUsers = props.statisticsUsers,
            searchText = props.searchText;


        _this.state = {
            statisticsUsers: _this.filterSearch(statisticsUsers, searchText),
            chart: {}
        };
        return _this;
    }

    _createClass(RegistrationsCharts, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.createRangeDates();
        }
    }, {
        key: 'filterSearch',
        value: function filterSearch(items, searchText) {
            return items.filter(function (item) {
                if (item.name && item.name.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (item.surname && item.surname.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (item.email && item.email.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(item, 'item.company.name') && item.company.name.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(item, 'item.phones[0].phone') && item.phones[0].phone.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
                }

                return false;
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var statisticsUsers = nextProps.statisticsUsers,
                searchText = nextProps.searchText;


            if (!statisticsUsers.length) {
                return;
            }

            this.setState({
                statisticsUsers: this.filterSearch(statisticsUsers, searchText)
            }, function () {
                _this2.createRangeDates();
            });
        }
    }, {
        key: 'createRangeDates',
        value: function createRangeDates() {
            var _state = this.state,
                statisticsUsers = _state.statisticsUsers,
                chart = _state.chart;
            var _props = this.props,
                from = _props.from,
                until = _props.until;


            var countOfDays = __WEBPACK_IMPORTED_MODULE_4_moment___default()(until).startOf('day').diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(from).startOf('day'), 'days');

            var rangeDates = {};

            var labels = [];
            var verified = [];
            var visited = [];
            var registered = [];

            for (var i = 0; i <= countOfDays; i++) {
                rangeDates[__WEBPACK_IMPORTED_MODULE_4_moment___default()(from).add(i, 'days').format('MM-DD-YYYY')] = {
                    date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(from).add(i, 'days'),
                    verified: 0,
                    visited: 0,
                    registered: 0
                };
            }

            statisticsUsers.forEach(function (user) {
                var date = rangeDates[__WEBPACK_IMPORTED_MODULE_4_moment___default()(user.createdAt).startOf('day').utcOffset(0, true).format('MM-DD-YYYY')];

                if (!date) {
                    return;
                }

                date.registered += 1;

                if (user.password) {
                    date.visited += 1;
                }

                if (user.emailVerified) {
                    date.verified += 1;
                }
            });

            for (var key in rangeDates) {
                labels.push(__WEBPACK_IMPORTED_MODULE_4_moment___default()(rangeDates[key].date).format('DD-MM'));
                verified.push(rangeDates[key].verified);
                visited.push(rangeDates[key].visited);
                registered.push(rangeDates[key].registered);
            }

            var datasets = [{
                label: 'Verified email',
                backgroundColor: '#ffa',
                borderColor: '#ffa',
                data: verified
            }, {
                label: 'Visited site',
                backgroundColor: '#faf',
                borderColor: '#faf',
                data: visited
            }, {
                label: 'registered on site',
                backgroundColor: '#aff',
                borderColor: '#aff',
                data: registered
            }];

            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(chart)) {
                chart = this.createChart(labels, datasets);
            } else {
                chart = this.updateChart(chart, labels, datasets);
            }

            this.setState({
                chart: chart
            });
        }
    }, {
        key: 'updateChart',
        value: function updateChart(chart, labels, datasets) {
            chart.data.labels = labels;
            chart.data.datasets = datasets;

            chart.update(0);

            return chart;
        }
    }, {
        key: 'createChart',
        value: function createChart(labels, datasets) {
            var ctx = this.refs.chart.getContext('2d');
            var chart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    tooltips: {
                        mode: 'label'
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            return chart;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { ref: 'chart' })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RegistrationsCharts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var _ref$statisticsUsers = _ref.statisticsUsers,
        items = _ref$statisticsUsers.items,
        searchText = _ref$statisticsUsers.searchText;
    var from = _ref2.from,
        until = _ref2.until;

    return {
        statisticsUsers: items,
        searchText: searchText,
        from: from,
        until: until
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(RegistrationsCharts);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RegistrationsCharts, 'RegistrationsCharts', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/RegistrationsCharts.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Users/RegistrationsCharts.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);

defaults._set('global', {
	responsive: true,
	responsiveAnimationDuration: 0,
	maintainAspectRatio: true,
	events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	showLines: true,

	// Element defaults defined in element extensions
	elements: {},

	// Layout options such as padding
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	Chart.Chart = Chart;

	return Chart;
};


/***/ }),
/* 3325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(390);

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

module.exports = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.easingEffects = effects;


/***/ }),
/* 3326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(390);

/**
 * @namespace Chart.helpers.canvas
 */
var exports = module.exports = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {Number} width - The rectangle's width.
	 * @param {Number} height - The rectangle's height.
	 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			// NOTE(SB) `epsilon` helps to prevent minor artifacts appearing
			// on Chrome when `r` is exactly half the height or the width.
			var epsilon = 0.0000001;
			var r = Math.min(radius, (height / 2) - epsilon, (width / 2) - epsilon);

			ctx.moveTo(x + r, y);
			ctx.lineTo(x + width - r, y);
			ctx.arcTo(x + width, y, x + width, y + r, r);
			ctx.lineTo(x + width, y + height - r);
			ctx.arcTo(x + width, y + height, x + width - r, y + height, r);
			ctx.lineTo(x + r, y + height);
			ctx.arcTo(x, y + height, x, y + height - r, r);
			ctx.lineTo(x, y + r);
			ctx.arcTo(x, y, x + r, y, r);
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, edgeLength, xOffset, yOffset, height, size;
		rotation = rotation || 0;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.save();
		ctx.translate(x, y);
		ctx.rotate(rotation * Math.PI / 180);
		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(0, 0, radius, 0, Math.PI * 2);
			ctx.closePath();
			break;
		case 'triangle':
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(-edgeLength / 2, height / 3);
			ctx.lineTo(edgeLength / 2, height / 3);
			ctx.lineTo(0, -2 * height / 3);
			ctx.closePath();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.rect(-size, -size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = -offset;
			var topY = -offset;
			var sideSize = Math.SQRT2 * radius;

			// NOTE(SB) the rounded rect implementation changed to use `arcTo`
			// instead of `quadraticCurveTo` since it generates better results
			// when rect is almost a circle. 0.425 (instead of 0.5) produces
			// results visually closer to the previous impl.
			this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius * 0.425);
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.moveTo(-size, 0);
			ctx.lineTo(0, size);
			ctx.lineTo(size, 0);
			ctx.lineTo(0, -size);
			ctx.closePath();
			break;
		case 'cross':
			ctx.moveTo(0, radius);
			ctx.lineTo(0, -radius);
			ctx.moveTo(-radius, 0);
			ctx.lineTo(radius, 0);
			break;
		case 'crossRot':
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(-xOffset, -yOffset);
			ctx.lineTo(xOffset, yOffset);
			ctx.moveTo(-xOffset, yOffset);
			ctx.lineTo(xOffset, -yOffset);
			break;
		case 'star':
			ctx.moveTo(0, radius);
			ctx.lineTo(0, -radius);
			ctx.moveTo(-radius, 0);
			ctx.lineTo(radius, 0);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(-xOffset, -yOffset);
			ctx.lineTo(xOffset, yOffset);
			ctx.moveTo(-xOffset, yOffset);
			ctx.lineTo(xOffset, -yOffset);
			break;
		case 'line':
			ctx.moveTo(-radius, 0);
			ctx.lineTo(radius, 0);
			break;
		case 'dash':
			ctx.moveTo(0, 0);
			ctx.lineTo(radius, 0);
			break;
		}

		ctx.fill();
		ctx.stroke();
		ctx.restore();
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.clear = exports.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports.roundedRect.apply(exports, arguments);
};


/***/ }),
/* 3327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(390);

/**
 * @alias Chart.helpers.options
 * @namespace
 */
module.exports = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {Number|Object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {Object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array[]} inputs - An array of values, falling back to the last value.
	 * @param {Object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {Number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};


/***/ }),
/* 3328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */
/* global document: false */


var color = __webpack_require__(958);
var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);
var scaleService = __webpack_require__(167);

module.exports = function() {

	// -- Basic js utility methods

	helpers.configMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = helpers.scaleMerge(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers.merge(tval, [scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.scaleMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers.merge(target[key][i], [scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers.merge(target[key][i], scale);
						}
					}
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);

			return isPowerOf10 ? powerOf10 : exponent;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension / parseInt(padding, 10) : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.host) {
			parent = parent.host;
		}
		return parent;
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = helpers._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = helpers._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers.color = !color ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};


/***/ }),
/* 3329 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(959);
var route = __webpack_require__(3330);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),
/* 3330 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(959);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),
/* 3331 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(960);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/i,
       hex =  /^#([a-fA-F0-9]{6})$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),
/* 3332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);
var helpers = __webpack_require__(45);

defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		}
	}
});

module.exports = Element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;

		ctx.beginPath();

		ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

		ctx.closePath();
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;

		ctx.fillStyle = vm.backgroundColor;

		ctx.fill();
		ctx.lineJoin = 'bevel';

		if (vm.borderWidth) {
			ctx.stroke();
		}
	}
});


/***/ }),
/* 3333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);
var helpers = __webpack_require__(45);

var globalDefaults = defaults.global;

defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

module.exports = Element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});


/***/ }),
/* 3334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);
var helpers = __webpack_require__(45);

var defaultColor = defaults.global.defaultColor;

defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderColor: defaultColor,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

module.exports = Element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var model = this._model;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || (model.x >= chartArea.left && chartArea.right * errMargin >= model.x && model.y >= chartArea.top && chartArea.bottom * errMargin >= model.y)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});


/***/ }),
/* 3335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);

defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: defaults.global.defaultColor,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(bar) {
	return bar._view.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(bar) {
	var vm = bar._view;
	var x1, x2, y1, y2;

	if (isVertical(bar)) {
		// vertical
		var halfWidth = vm.width / 2;
		x1 = vm.x - halfWidth;
		x2 = vm.x + halfWidth;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		// horizontal bar
		var halfHeight = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - halfHeight;
		y2 = vm.y + halfHeight;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

module.exports = Element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var left, right, top, bottom, signX, signY, borderSkipped;
		var borderWidth = vm.borderWidth;

		if (!vm.horizontal) {
			// bar
			left = vm.x - vm.width / 2;
			right = vm.x + vm.width / 2;
			top = vm.y;
			bottom = vm.base;
			signX = 1;
			signY = bottom > top ? 1 : -1;
			borderSkipped = vm.borderSkipped || 'bottom';
		} else {
			// horizontal bar
			left = vm.base;
			right = vm.x;
			top = vm.y - vm.height / 2;
			bottom = vm.y + vm.height / 2;
			signX = right > left ? 1 : -1;
			signY = 1;
			borderSkipped = vm.borderSkipped || 'left';
		}

		// Canvas doesn't allow us to stroke inside the width so we can
		// adjust the sizes to fit if we're setting a stroke on the line
		if (borderWidth) {
			// borderWidth shold be less than bar width and bar height.
			var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
			borderWidth = borderWidth > barSize ? barSize : borderWidth;
			var halfStroke = borderWidth / 2;
			// Adjust borderWidth when bar top position is near vm.base(zero).
			var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
			var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
			var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
			var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
			// not become a vertical line?
			if (borderLeft !== borderRight) {
				top = borderTop;
				bottom = borderBottom;
			}
			// not become a horizontal line?
			if (borderTop !== borderBottom) {
				left = borderLeft;
				right = borderRight;
			}
		}

		ctx.beginPath();
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = borderWidth;

		// Corner points, from bottom-left to bottom-right clockwise
		// | 1 2 |
		// | 0 3 |
		var corners = [
			[left, bottom],
			[left, top],
			[right, top],
			[right, bottom]
		];

		// Find first (starting) corner with fallback to 'bottom'
		var borders = ['bottom', 'left', 'top', 'right'];
		var startCorner = borders.indexOf(borderSkipped, 0);
		if (startCorner === -1) {
			startCorner = 0;
		}

		function cornerAt(index) {
			return corners[(startCorner + index) % 4];
		}

		// Draw rectangle from 'startCorner'
		var corner = cornerAt(0);
		ctx.moveTo(corner[0], corner[1]);

		for (var i = 1; i < 4; i++) {
			corner = cornerAt(i);
			ctx.lineTo(corner[0], corner[1]);
		}

		ctx.fill();
		if (borderWidth) {
			ctx.stroke();
		}
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		var inRange = false;

		if (this._view) {
			var bounds = getBarBounds(this);
			inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inLabelRange: function(mouseX, mouseY) {
		var me = this;
		if (!me._view) {
			return false;
		}

		var inRange = false;
		var bounds = getBarBounds(me);

		if (isVertical(me)) {
			inRange = mouseX >= bounds.left && mouseX <= bounds.right;
		} else {
			inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inXRange: function(mouseX) {
		var bounds = getBarBounds(this);
		return mouseX >= bounds.left && mouseX <= bounds.right;
	},

	inYRange: function(mouseY) {
		var bounds = getBarBounds(this);
		return mouseY >= bounds.top && mouseY <= bounds.bottom;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(this)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;
		return vm.width * Math.abs(vm.y - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});


/***/ }),
/* 3336 */
/***/ (function(module, exports) {

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

module.exports = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};


/***/ }),
/* 3337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Chart.Platform implementation for targeting a web browser
 */



var helpers = __webpack_require__(45);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {Number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addEventListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var resizer = document.createElement('div');
	var cls = CSS_PREFIX + 'size-monitor';
	var maxSize = 1000000;
	var style =
		'position:absolute;' +
		'left:0;' +
		'top:0;' +
		'right:0;' +
		'bottom:0;' +
		'overflow:hidden;' +
		'pointer-events:none;' +
		'visibility:hidden;' +
		'z-index:-1;';

	resizer.style.cssText = style;
	resizer.className = cls;
	resizer.innerHTML =
		'<div class="' + cls + '-expand" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:' + maxSize + 'px;' +
				'height:' + maxSize + 'px;' +
				'left:0;' +
				'top:0">' +
			'</div>' +
		'</div>' +
		'<div class="' + cls + '-shrink" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:200%;' +
				'height:200%;' +
				'left:0; ' +
				'top:0">' +
			'</div>' +
		'</div>';

	var expand = resizer.childNodes[0];
	var shrink = resizer.childNodes[1];

	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};
	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers.each(ANIMATION_START_EVENTS, function(type) {
		addEventListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			removeEventListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			return listener(createEvent('resize', chart));
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// http://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

module.exports = {
	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	initialize: function() {
		var keyframes = 'from{opacity:0.99}to{opacity:1}';

		injectCSS(this,
			// DOM rendering detection
			// https://davidwalsh.name/detect-node-insertion
			'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'.' + CSS_RENDER_MONITOR + '{' +
				'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
			'}'
		);
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addEventListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas, listener);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeEventListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.addEvent = addEventListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.removeEvent = removeEventListener;


/***/ }),
/* 3338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Animation = __webpack_require__(961);
var animations = __webpack_require__(962);
var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);
var Interaction = __webpack_require__(963);
var layouts = __webpack_require__(287);
var platform = __webpack_require__(964);
var plugins = __webpack_require__(965);
var scaleService = __webpack_require__(167);
var Tooltip = __webpack_require__(966);

module.exports = function(Chart) {

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			defaults.global,
			defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		helpers.each(chart.scales, function(scale) {
			layouts.removeBox(chart, scale);
		});

		newOptions = helpers.configMerge(
			Chart.defaults.global,
			Chart.defaults[chart.config.type],
			newOptions);

		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildOrUpdateScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			animations.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update({
					duration: me.options.responsiveAnimationDuration
				});
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}

				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});

			me.scales = scales;

			scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
					meta.controller.linkScales();
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			plugins._invalidate(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
			}

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			layouts.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var duration = config.duration;
			var lazy = config.lazy;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (me.width <= 0 || me.height <= 0) {
				return;
			}

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};


/***/ }),
/* 3339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);

module.exports = function(Chart) {

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element) {
			helpers.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var getHoverColor = helpers.getHoverColor;
			var model = element._model;

			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length - 1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};


/***/ }),
/* 3340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);
var Scale = __webpack_require__(288);

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var factor;
	var precision;
	var spacing;

	if (generationOptions.stepSize && generationOptions.stepSize > 0) {
		spacing = generationOptions.stepSize;
	} else {
		var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
		spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);

		precision = generationOptions.precision;
		if (precision !== undefined) {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	}
	var niceMin = Math.floor(dataRange.min / spacing) * spacing;
	var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (!helpers.isNullOrUndef(generationOptions.min) && !helpers.isNullOrUndef(generationOptions.max) && generationOptions.stepSize) {
		// If very close to our whole number, use it.
		if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
			niceMin = generationOptions.min;
			niceMax = generationOptions.max;
		}
	}

	var numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	precision = 1;
	if (spacing < 1) {
		precision = Math.pow(10, 1 - Math.floor(helpers.log10(spacing)));
		niceMin = Math.round(niceMin * precision) / precision;
		niceMax = Math.round(niceMax * precision) / precision;
	}
	ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * precision) / precision);
	}
	ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

	return ticks;
}

module.exports = function(Chart) {

	var noop = helpers.noop;

	Chart.LinearScaleBase = Scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return Scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};


/***/ }),
/* 3341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Scale = __webpack_require__(288);
var scaleService = __webpack_require__(167);

module.exports = function() {

	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	scaleService.registerScaleType('category', DatasetScale, defaultConfig);
};


/***/ }),
/* 3342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);
var scaleService = __webpack_require__(167);
var Ticks = __webpack_require__(289);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
			} else {
				pixel = me.bottom - (me.height / range * (rightValue - start));
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});

	scaleService.registerScaleType('linear', LinearScale, defaultConfig);
};


/***/ }),
/* 3343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(45);
var Scale = __webpack_require__(288);
var scaleService = __webpack_require__(167);
var Ticks = __webpack_require__(289);

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	var valueOrDefault = helpers.valueOrDefault;

	// Figure out what the max number of ticks we can support it is based on the size of
	// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
	// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
	// the graph
	var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

	var endExp = Math.floor(helpers.log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(helpers.log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(helpers.log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}


module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}
							values[index] = values[index] || 0;
							values[index] += value;
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					}
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;

			me.min = valueOrDefault(tickOpts.min, me.min);
			me.max = valueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(helpers.log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(helpers.log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(helpers.log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var reverse = !me.isHorizontal();

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = generateTicks(generationOptions, me);

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		/**
		 * Returns the value of the first tick.
		 * @param {Number} value - The minimum not zero value.
		 * @return {Number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(helpers.log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));

			return significand * Math.pow(10, exp);
		},
		getPixelForValue: function(value) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var offset = 0;
			var innerDimension, pixel, start, end, sign;

			value = +me.getRightValue(value);
			if (reverse) {
				start = me.end;
				end = me.start;
				sign = -1;
			} else {
				start = me.start;
				end = me.end;
				sign = 1;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				pixel = reverse ? me.right : me.left;
			} else {
				innerDimension = me.height;
				sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
				pixel = reverse ? me.top : me.bottom;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					innerDimension -= offset;
					start = firstTickValue;
				}
				if (value !== 0) {
					offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
				}
				pixel += sign * offset;
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var innerDimension, start, end, value;

			if (reverse) {
				start = me.end;
				end = me.start;
			} else {
				start = me.start;
				end = me.end;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = reverse ? me.right - pixel : pixel - me.left;
			} else {
				innerDimension = me.height;
				value = reverse ? pixel - me.top : me.bottom - pixel;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					var offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					value -= offset;
					innerDimension -= offset;
					start = firstTickValue;
				}
				value *= log10(end) - log10(start);
				value /= innerDimension;
				value = Math.pow(10, log10(start) + value);
			}
			return value;
		}
	});

	scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
};


/***/ }),
/* 3344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);
var scaleService = __webpack_require__(167);
var Ticks = __webpack_require__(289);

module.exports = function(Chart) {

	var globalDefaults = defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = helpers.valueAtIndexOrDefault(pointLabelOpts.fontColor, i, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;

			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);

				// Tick Font
				var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});

	scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
};


/***/ }),
/* 3345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var moment = __webpack_require__(24);
moment = typeof moment === 'function' ? moment : window.moment;

var defaults = __webpack_require__(58);
var helpers = __webpack_require__(45);
var Scale = __webpack_require__(288);
var scaleService = __webpack_require__(167);

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 15, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 15, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

/**
 * Convert the given value to a moment object using the given time options.
 * @see http://momentjs.com/docs/#/parsing/
 */
function momentify(value, options) {
	var parser = options.parser;
	var format = options.parser || options.format;

	if (typeof parser === 'function') {
		return parser(value);
	}

	if (typeof value === 'string' && typeof format === 'string') {
		return moment(value, format);
	}

	if (!(value instanceof moment)) {
		value = moment(value);
	}

	if (value.isValid()) {
		return value;
	}

	// Labels are in an incompatible moment format and no `parser` has been provided.
	// The user might still use the deprecated `format` option to convert his inputs.
	if (typeof format === 'function') {
		return format(value);
	}

	return value;
}

function parse(input, scale) {
	if (helpers.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = momentify(scale.getRightValue(input), options);
	if (!value.isValid()) {
		return null;
	}

	if (options.round) {
		value.startOf(options.round);
	}

	return value.valueOf();
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / (capacity * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(ticks, minUnit, min, max) {
	var duration = moment.duration(moment(max).diff(moment(min)));
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(min, max, capacity, options) {
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = moment(min);
	var last = moment(max);
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = first.isoWeekday(weekday);
		last = last.isoWeekday(weekday);
	}

	// Align first/last ticks on unit
	first = first.startOf(weekday ? 'day' : minor);
	last = last.startOf(weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last.add(1, minor);
	}

	time = moment(first);

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time.startOf(major);
		time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time.add(stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the right and left offsets from edges in the form of {left, right}.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var left = 0;
	var right = 0;
	var upper, lower;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			upper = ticks.length > 1 ? ticks[1] : max;
			lower = ticks[0];
			left = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
		if (!options.time.max) {
			upper = ticks[ticks.length - 1];
			lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
			right = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
	}

	return {left: left, right: right};
}

function ticksFromTimestamps(values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

function determineLabelFormat(data, timeOpts) {
	var i, momentDate, hasTime;
	var ilen = data.length;

	// find the label with the most parts (milliseconds, minutes, etc.)
	// format all labels with the same level of detail as the most specific label
	for (i = 0; i < ilen; i++) {
		momentDate = momentify(data[i], timeOpts);
		if (momentDate.millisecond() !== 0) {
			return 'MMM D, YYYY h:mm:ss.SSS a';
		}
		if (momentDate.second() !== 0 || momentDate.minute() !== 0 || momentDate.hour() !== 0) {
			hasTime = true;
		}
	}
	if (hasTime) {
		return 'MMM D, YYYY h:mm:ss a';
	}
	return 'MMM D, YYYY';
}

module.exports = function() {

	var defaultConfig = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm a', // 11:20 AM
				hour: 'hA', // 5PM
				day: 'MMM D', // Sep 4
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var TimeScale = Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			this.mergeTicksOptions();

			Scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;

			// DEPRECATIONS: output a message only one time per update
			if (options.time && options.time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			return Scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return Scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var timeOpts = me.options.time;
			var unit = timeOpts.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;

			// Convert labels to timestamps
			for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
				labels.push(parse(chart.data.labels[i], me));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(data[j], me);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						timestamps.push.apply(timestamps, labels);
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +moment().startOf(unit) : min;
			max = max === MIN_INTEGER ? +moment().endOf(unit) + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(min, max, me.getLabelCapacity(min), options);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
			me._labelFormat = determineLabelFormat(me._timestamps.data, timeOpts);

			return ticksFromTimestamps(ticks, me._majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return momentify(label, timeOpts).format(timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}

			return momentify(label, timeOpts).format(me._labelFormat);
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(tick, index, ticks, formatOverride) {
			var me = this;
			var options = me.options;
			var time = tick.valueOf();
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = tick.clone().startOf(majorUnit).valueOf();
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = interpolate(me._table, 'time', time, 'pos');

			return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(value, me);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
			var time = interpolate(me._table, 'pos', pos, 'time');

			return moment(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;

			var capacity = Math.floor(innerWidth / tickLabelWidth);
			return capacity > 0 ? capacity : 1;
		}
	});

	scaleService.registerScaleType('time', TimeScale, defaultConfig);
};


/***/ }),
/* 3346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var elements = __webpack_require__(168);
var helpers = __webpack_require__(45);

defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',

			// Specific to Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			position: 'left',
			type: 'category',

			// Specific to Horizontal Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		callbacks: {
			title: function(item, data) {
				// Pick first xLabel for now
				var title = '';

				if (item.length > 0) {
					if (item[0].yLabel) {
						title = item[0].yLabel;
					} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
						title = data.labels[item[0].index];
					}
				}

				return title;
			},

			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				return datasetLabel + ': ' + item.xLabel;
			}
		},
		mode: 'index',
		axis: 'y'
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale.isHorizontal() ? scale.width : scale.height;
	var ticks = scale.getTicks();
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, pixels[i] - pixels[i - 1]);
	}

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, curr - prev) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var size, ratio;

	if (helpers.isNullOrUndef(thickness)) {
		size = ruler.min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale end extremity.
		prev = curr - (next === null ? ruler.end - curr : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - ((curr - prev) / 2) * percent;
	size = ((next - prev) / 2) * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

module.exports = function(Chart) {

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {Number} [last] - The dataset index
		 * @returns {Array} The stack list
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks;
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {Number} [datasetIndex] - The dataset index
		 * @param {String} [name] - The stack name to find
		 * @returns {Number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present

			return (index === -1)
				? stacks.length - 1
				: index;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var pixels = [];
			var i, ilen, min;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			min = helpers.isNullOrUndef(scale.options.barThickness)
				? computeMinSampleSize(scale, pixels)
				: -1;

			return {
				min: min,
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = scale.getRightValue(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);

			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				helpers.valueOrDefault(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);

			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me.getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},
	});

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};


/***/ }),
/* 3347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var elements = __webpack_require__(168);
var helpers = __webpack_require__(45);

defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});


module.exports = function(Chart) {

	Chart.controllers.bubble = Chart.DatasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,

		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};

			point.pivot();
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
			model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
			model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
			model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var resolve = helpers.options.resolve;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle',
				'rotation'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			// Custom radius resolution
			values.radius = resolve([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);
			return values;
		}
	});
};


/***/ }),
/* 3348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var elements = __webpack_require__(168);
var helpers = __webpack_require__(45);

defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

defaults._set('pie', helpers.clone(defaults.doughnut));
defaults._set('pie', {
	cutoutPercentage: 0
});

module.exports = function(Chart) {

	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
			var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;

			// Resets the visual styles
			var custom = arc.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var elementOpts = this.chart.options.elements.arc;
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (Math.abs(value) / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var max = 0;
			var index = this.index;
			var length = arcs.length;
			var borderWidth;
			var hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
				hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};


/***/ }),
/* 3349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var elements = __webpack_require__(168);
var helpers = __webpack_require__(45);

defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

module.exports = function(Chart) {

	function lineEnabled(dataset, options) {
		return helpers.valueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
				borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		getPointRotation: function(point, index) {
			var pointRotation = this.chart.options.elements.point.rotation;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.rotation)) {
				pointRotation = custom.rotation;
			} else if (!isNaN(dataset.pointRotation) || helpers.isArray(dataset.pointRotation)) {
				pointRotation = helpers.valueAtIndexOrDefault(dataset.pointRotation, index, pointRotation);
			}
			return pointRotation;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				rotation: me.getPointRotation(point, index),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var halfBorderWidth;
			var i = 0;

			if (lineEnabled(me.getDataset(), chart.options)) {
				halfBorderWidth = (meta.dataset._model.borderWidth || 0) / 2;

				helpers.canvas.clipArea(chart.ctx, {
					left: area.left,
					right: area.right,
					top: area.top - halfBorderWidth,
					bottom: area.bottom + halfBorderWidth
				});

				meta.dataset.draw();

				helpers.canvas.unclipArea(chart.ctx);
			}

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(element) {
			// Point
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;

			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
		},
	});
};


/***/ }),
/* 3350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var elements = __webpack_require__(168);
var helpers = __webpack_require__(45);

defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var i, ilen, angle;

			me._updateRadius();

			meta.count = me.countVisibleElements();

			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			var elementOpts = this.chart.options.elements.arc;
			var custom = arc.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var model = arc._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);

			arc.pivot();
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();

			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}

			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			return helpers.options.resolve([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
};


/***/ }),
/* 3351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var elements = __webpack_require__(168);
var helpers = __webpack_require__(45);

defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
					rotation: custom.rotation ? custom.rotation : helpers.valueAtIndexOrDefault(dataset.pointRotation, index, pointElementOptions.rotation),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},
	});
};


/***/ }),
/* 3352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);

defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

module.exports = function(Chart) {

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

};


/***/ }),
/* 3353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 3354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};


/***/ }),
/* 3355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};


/***/ }),
/* 3356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};


/***/ }),
/* 3357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};


/***/ }),
/* 3358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 3359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};


/***/ }),
/* 3360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.filler = __webpack_require__(3361);
module.exports.legend = __webpack_require__(3362);
module.exports.title = __webpack_require__(3363);


/***/ }),
/* 3361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Plugin based on discussion from the following Chart.js issues:
 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
 */



var defaults = __webpack_require__(58);
var elements = __webpack_require__(168);
var helpers = __webpack_require__(45);

defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePosition) {
		target = scale.getBasePosition();
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (typeof target === 'number' && isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1;

	ctx.beginPath();

	for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

module.exports = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetDraw: function(chart, args) {
		var meta = args.meta.$filler;
		if (!meta) {
			return;
		}

		var ctx = chart.ctx;
		var el = meta.el;
		var view = el._view;
		var points = el._children || [];
		var mapper = meta.mapper;
		var color = view.backgroundColor || defaults.global.defaultColor;

		if (mapper && color && points.length) {
			helpers.canvas.clipArea(ctx, chart.chartArea);
			doFill(ctx, points, mapper, view, color, el._loop);
			helpers.canvas.unclipArea(ctx);
		}
	}
};


/***/ }),
/* 3362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);
var helpers = __webpack_require__(45);
var layouts = __webpack_require__(287);

var noop = helpers.noop;

defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param labelopts {Object} the label options on the legend
 * @param fontSize {Number} the label font size
 * @return {Number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle ?
		fontSize * Math.SQRT2 :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = Element.extend({

	initialize: function(config) {
		helpers.extend(this, config);

		// Contains hit boxes for each dataset (in dataset order)
		this.legendHitBoxes = [];

		// Are we in doughnut mode which has a different data type
		this.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var globalDefault = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;
		var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
		var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
		var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
		var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (display) {
			ctx.font = labelFont;

			if (isHorizontal) {
				// Labels

				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'top';

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
						totalHeight += fontSize + (labelOpts.padding);
						lineWidths[lineWidths.length] = me.left;
					}

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};

					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});

				minSize.height += totalHeight;

			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
				var itemHeight = fontSize + vPadding;

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					// If too tall, go to new column
					if (currentColHeight + itemHeight > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width

						currentColWidth = 0;
						currentColHeight = 0;
					}

					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += itemHeight;

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});

				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				minSize.width += totalWidth;
			}
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefault = defaults.global;
		var lineDefault = globalDefault.elements.line;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (opts.display) {
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var cursor;

			// Canvas setup
			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont;

			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;

			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}

				// Set the ctx for the box
				ctx.save();

				ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
				ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
				var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
				}

				if (opts.labels && opts.labels.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = fontSize * Math.SQRT2 / 2;
					var offSet = radius / Math.SQRT2;
					var centerX = x + offSet;
					var centerY = y + offSet;

					// Draw pointStyle as legend symbol
					helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
				} else {
					// Draw box as legend symbol
					if (!isLineWidthZero) {
						ctx.strokeRect(x, y, boxWidth, fontSize);
					}
					ctx.fillRect(x, y, boxWidth, fontSize);
				}

				ctx.restore();
			};
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = boxWidth + halfFontSize + x;
				var yMiddle = y + halfFontSize;

				ctx.fillText(legendItem.text, xLeft, yMiddle);

				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(xLeft + textWidth, yMiddle);
					ctx.stroke();
				}
			};

			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + ((legendWidth - lineWidths[0]) / 2),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			}

			var itemHeight = fontSize + labelOpts.padding;
			helpers.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;

				if (isHorizontal) {
					if (x + width >= legendWidth) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
					}
				} else if (y + itemHeight > me.bottom) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					y = cursor.y = me.top + labelOpts.padding;
					cursor.line++;
				}

				drawLegendBox(x, y, legendItem);

				hitboxes[i].left = x;
				hitboxes[i].top = y;

				// Fill the actual label
				fillText(x, y, legendItem, textWidth);

				if (isHorizontal) {
					cursor.x += width + (labelOpts.padding);
				} else {
					cursor.y += itemHeight;
				}

			});
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @return {Boolean} true if a change occured
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var changed = false;

		if (type === 'mousemove') {
			if (!opts.onHover) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		var x = e.x;
		var y = e.y;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			var lh = me.legendHitBoxes;
			for (var i = 0; i < lh.length; ++i) {
				var hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					if (type === 'click') {
						// use e.native for backwards compatibility
						opts.onClick.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					} else if (type === 'mousemove') {
						// use e.native for backwards compatibility
						opts.onHover.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					}
				}
			}
		}

		return changed;
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	layouts.configure(chart, legend, legendOpts);
	layouts.addBox(chart, legend);
	chart.legend = legend;
}

module.exports = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers.mergeIf(legendOpts, defaults.global.legend);

			if (legend) {
				layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};


/***/ }),
/* 3363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var Element = __webpack_require__(131);
var helpers = __webpack_require__(45);
var layouts = __webpack_require__(287);

var noop = helpers.noop;

defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		lineHeight: 1.2,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = Element.extend({
	initialize: function(config) {
		var me = this;
		helpers.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: noop,
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var display = opts.display;
		var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
		var minSize = me.minSize;
		var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
		var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
		var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

		if (me.isHorizontal()) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = textSize;
		} else {
			minSize.width = textSize;
			minSize.height = me.maxHeight; // fill all the height
		}

		me.width = minSize.width;
		me.height = minSize.height;

	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var globalDefaults = defaults.global;

		if (opts.display) {
			var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
			var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;

			ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
			ctx.font = titleFont;

			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}

			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			var text = opts.text;
			if (helpers.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}

			ctx.restore();
		}
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	layouts.configure(chart, title, titleOpts);
	layouts.addBox(chart, title);
	chart.titleBlock = title;
}

module.exports = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers.mergeIf(titleOpts, defaults.global.title);

			if (titleBlock) {
				layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};


/***/ }),
/* 3364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_statistics_emails__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RangeDates__ = __webpack_require__(3365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Charts__ = __webpack_require__(3366);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

/* eslint-disable one-var */










function getPercentFixed(amount, total) {
    return amount && total ? (amount / total * 100).toFixed(2) : 0;
}

var StatisticsEmailsPage = function StatisticsEmailsPage(_ref) {
    var getStatisticsEmails = _ref.getStatisticsEmails,
        statisticsEmails = _ref.statisticsEmails;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'w').startOf('day').toDate()),
        _useState2 = _slicedToArray(_useState, 2),
        from = _useState2[0],
        setFrom = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day').toDate()),
        _useState4 = _slicedToArray(_useState3, 2),
        until = _useState4[0],
        setUntil = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState6 = _slicedToArray(_useState5, 2),
        showNormalized = _useState6[0],
        setShowNormalized = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isWorkingHours = _useState8[0],
        setIsWorkingHours = _useState8[1];

    var fetchEmails = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        getStatisticsEmails(__WEBPACK_IMPORTED_MODULE_3_moment___default()(from).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(until).utcOffset(0, true).valueOf(), isWorkingHours);
    }, [from, until, getStatisticsEmails, isWorkingHours]);

    var handleWorkingHours = function handleWorkingHours() {
        setIsWorkingHours(!isWorkingHours);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        fetchEmails();
    }, [fetchEmails]);

    var changeDateRange = function changeDateRange(from, until) {
        setFrom(from);
        setUntil(until);
    };

    var handleNormalize = function handleNormalize() {
        setShowNormalized(!showNormalized);
    };

    var total = 0,
        failed = 0,
        sent = 0,
        sentManual = 0,
        spam = 0;

    var totalShipnext = 0,
        totalShipnextFailed = 0,
        totalShipnextSent = 0,
        totalShipnextSpam = 0,
        totalShipnextSentManual = 0;

    var totalConnect = 0,
        totalConnectFailed = 0,
        totalConnectSent = 0,
        totalConnectSpam = 0;

    var totalVaramar = 0,
        totalVaramarFailed = 0,
        totalVaramarSent = 0,
        totalVaramarSpam = 0,
        totalVaramarSentManual = 0;

    var totalBroker = 0,
        totalBrokerFailed = 0,
        totalBrokerSent = 0,
        totalBrokerSpam = 0,
        totalBrokerSentManual = 0;

    var shipnextCargo = 0,
        shipnextCargoFailed = 0,
        shipnextCargoSent = 0,
        shipnextCargoSentManual = 0,
        shipnextVessel = 0,
        shipnextVesselFailed = 0,
        shipnextVesselSent = 0,
        shipnextVesselSentManual = 0;

    var connectCargo = 0,
        connectCargoFailed = 0,
        connectCargoSent = 0,
        connectVessel = 0,
        connectVesselFailed = 0,
        connectVesselSent = 0;

    var varamarCargo = 0,
        varamarCargoFailed = 0,
        varamarCargoSent = 0,
        varamarCargoSentManual = 0,
        varamarVessel = 0,
        varamarVesselFailed = 0,
        varamarVesselSent = 0,
        varamarVesselSentManual = 0;

    var brokerCargo = 0,
        brokerCargoFailed = 0,
        brokerCargoSent = 0,
        brokerCargoSentManual = 0,
        brokerVessel = 0,
        brokerVesselFailed = 0,
        brokerVesselSent = 0,
        brokerVesselSentManual = 0;

    var stats = {};

    statisticsEmails.forEach(function (item) {
        totalShipnext += item.shipnext.sent + item.shipnext.failed + item.shipnext.spam;
        totalShipnextFailed += item.shipnext.failed;
        totalShipnextSent += item.shipnext.sent;
        totalShipnextSentManual += item.shipnext.totalSentManual || 0;
        totalShipnextSpam += item.shipnext.spam;

        shipnextCargoFailed += item.shipnext.cargoFailed;
        shipnextCargoSent += item.shipnext.cargoSent;
        shipnextCargoSentManual += item.shipnext.sentManualCargo || 0;
        shipnextCargo += item.shipnext.cargoFailed + item.shipnext.cargoSent;

        shipnextVesselFailed += item.shipnext.vesselFailed;
        shipnextVesselSent += item.shipnext.vesselSent;
        shipnextVesselSentManual += item.shipnext.sentManualVessel || 0;
        shipnextVessel += item.shipnext.vesselFailed + item.shipnext.vesselSent;

        totalConnect += item.api.sent + item.api.failed + item.api.spam;
        totalConnectFailed += item.api.failed;
        totalConnectSent += item.api.sent;
        totalConnectSpam += item.api.spam;

        connectCargoFailed += item.api.cargoFailed;
        connectCargoSent += item.api.cargoSent;
        connectCargo += item.api.cargoFailed + item.api.cargoSent;

        connectVesselFailed += item.api.vesselFailed;
        connectVesselSent += item.api.vesselSent;
        connectVessel += item.api.vesselFailed + item.api.vesselSent;

        totalVaramar += item.varamar.sent + item.varamar.failed + item.varamar.spam;
        totalVaramarFailed += item.varamar.failed;
        totalVaramarSent += item.varamar.sent;
        totalVaramarSentManual += item.varamar.totalSentManual || 0;
        totalVaramarSpam += item.varamar.spam;

        varamarCargoFailed += item.varamar.cargoFailed;
        varamarCargoSent += item.varamar.cargoSent;
        varamarCargoSentManual += item.varamar.sentManualCargo || 0;
        varamarCargo += item.varamar.cargoFailed + item.varamar.cargoSent;

        varamarVesselFailed += item.varamar.vesselFailed;
        varamarVesselSent += item.varamar.vesselSent;
        varamarVesselSentManual += item.varamar.sentManualVessel || 0;
        varamarVessel += item.varamar.vesselFailed + item.varamar.vesselSent;

        totalBroker += item.broker.sent + item.broker.failed + item.broker.spam;
        totalBrokerFailed += item.broker.failed;
        totalBrokerSent += item.broker.sent;
        totalBrokerSentManual += item.broker.totalSentManual || 0;
        totalBrokerSpam += item.broker.spam;

        brokerCargoFailed += item.broker.cargoFailed;
        brokerCargoSent += item.broker.cargoSent;
        brokerCargoSentManual += item.broker.sentManualCargo || 0;
        brokerCargo += item.broker.cargoFailed + item.broker.cargoSent;

        brokerVesselFailed += item.broker.vesselFailed;
        brokerVesselSent += item.broker.vesselSent;
        brokerVesselSentManual += item.broker.sentManualVessel || 0;
        brokerVessel += item.broker.vesselFailed + item.broker.vesselSent;

        sent += item.varamar.sent + item.shipnext.sent + item.api.sent + item.broker.sent;
        failed += item.varamar.failed + item.shipnext.failed + item.api.failed + item.broker.failed;
        spam += item.varamar.spam + item.shipnext.spam + item.api.spam + item.broker.spam;
    });
    total += totalShipnext + totalConnect + totalVaramar + totalBroker;
    sentManual += totalShipnextSentManual + totalVaramarSentManual + totalBrokerSentManual;

    stats.cargoVessel = {
        // total
        allCargo: shipnextCargo + connectCargo + varamarCargo + brokerCargo,
        allVessel: shipnextVessel + connectVessel + varamarVessel + brokerVessel,

        allCargoSent: shipnextCargoSent + connectCargoSent + varamarCargoSent + brokerCargoSent,
        allCargoSentManual: shipnextCargoSentManual + varamarCargoSentManual + brokerCargoSentManual,
        allVesselSent: shipnextVesselSent + connectVesselSent + varamarVesselSent + brokerVesselSent,
        allVesselSentManual: shipnextVesselSentManual + varamarVesselSentManual + brokerVesselSentManual,

        allCargoFailed: shipnextCargoFailed + connectCargoFailed + varamarCargoFailed + brokerCargoFailed,
        allVesselFailed: shipnextVesselFailed + connectVesselFailed + varamarVesselFailed + brokerVesselFailed
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'statistics-emails', className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Statistics emails'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Charts__["a" /* default */], {
            showNormalized: showNormalized
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RangeDates__["a" /* default */], {
            from: from,
            until: until,
            changeDateRange: changeDateRange,
            handleNormalize: handleNormalize,
            checked: showNormalized,
            handleWorkingHours: handleWorkingHours,
            workingHours: isWorkingHours
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'General statistics:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'All'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Total - ',
                        total
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Spam - ',
                        spam + ' (' + getPercentFixed(spam, total) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        sent + ' (' + getPercentFixed(sent, total) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        sentManual + ' (' + getPercentFixed(sentManual, total) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        failed + ' (' + getPercentFixed(failed, total) + '%)'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Varamar'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Total - ',
                        totalVaramar
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Spam - ',
                        totalVaramarSpam + ' (' + getPercentFixed(totalVaramarSpam, totalVaramar) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        totalVaramarSent + ' (' + getPercentFixed(totalVaramarSent, totalVaramar) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        totalVaramarSentManual + ' (' + getPercentFixed(totalVaramarSentManual, totalVaramar) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        totalVaramarFailed + ' (' + getPercentFixed(totalVaramarFailed, totalVaramar) + '%)'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Shipnext'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Total - ',
                        totalShipnext
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Spam - ',
                        totalShipnextSpam + ' (' + getPercentFixed(totalShipnextSpam, totalShipnext) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        totalShipnextSent + ' (' + getPercentFixed(totalShipnextSent, totalShipnext) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        totalShipnextSentManual + ' (' + getPercentFixed(totalShipnextSentManual, totalShipnext) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        totalShipnextFailed + ' (' + getPercentFixed(totalShipnextFailed, totalShipnext) + '%)'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Connect'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Total - ',
                        totalConnect
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Spam - ',
                        totalConnectSpam + ' (' + getPercentFixed(totalConnectSpam, totalConnect) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        totalConnectSent + ' (' + getPercentFixed(totalConnectSent, totalConnect) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        totalConnectFailed + ' (' + getPercentFixed(totalConnectFailed, totalConnect) + '%)'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Broker'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Total - ',
                        totalBroker
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Spam - ',
                        totalBrokerSpam + ' (' + getPercentFixed(totalBrokerSpam, totalBroker) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        totalBrokerSent + ' (' + getPercentFixed(totalBrokerSent, totalBroker) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        totalBrokerSentManual + ' (' + getPercentFixed(totalBrokerSentManual, totalBroker) + '%)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        totalBrokerFailed + ' (' + getPercentFixed(totalBrokerFailed, totalBroker) + '%)'
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Cargo / Vessel statistics:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'All'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Cargo/Vessel - ',
                        stats.cargoVessel.allCargo + ' / ' + stats.cargoVessel.allVessel
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        stats.cargoVessel.allCargoSent + ' / ' + stats.cargoVessel.allVesselSent
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        stats.cargoVessel.allCargoSentManual + ' / ' + stats.cargoVessel.allVesselSentManual
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        stats.cargoVessel.allCargoFailed + ' / ' + stats.cargoVessel.allVesselFailed
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Varamar'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Cargo/Vessel - ',
                        varamarCargo + ' / ' + varamarVessel
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        varamarCargoSent + ' / ' + varamarVesselSent
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        varamarCargoSentManual + ' / ' + varamarVesselSentManual
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        varamarCargoFailed + ' / ' + varamarVesselFailed
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Shipnext'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Cargo/Vessel - ',
                        shipnextCargo + ' / ' + shipnextVessel
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        shipnextCargoSent + ' / ' + shipnextVesselSent
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        shipnextCargoSentManual + ' / ' + shipnextVesselSentManual
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        shipnextCargoFailed + ' / ' + shipnextVesselFailed
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Connect'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Cargo/Vessel - ',
                        connectCargo + ' / ' + connectVessel
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        connectCargoSent + ' / ' + connectVesselSent
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        connectCargoFailed + ' / ' + connectVesselFailed
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-2-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'name-block absolute small-name' },
                        'Broker'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Cargo/Vessel - ',
                        brokerCargo + ' / ' + brokerVessel
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent - ',
                        brokerCargoSent + ' / ' + brokerVesselSent
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Sent (manual) - ',
                        brokerCargoSentManual + ' / ' + brokerVesselSentManual
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Failed - ',
                        brokerCargoFailed + ' / ' + brokerVesselFailed
                    )
                )
            )
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        statisticsEmails: state.statisticsEmails.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getStatisticsEmails: __WEBPACK_IMPORTED_MODULE_4_actions_statistics_emails__["a" /* getStatisticsEmails */]
    }, dispatch);
})(StatisticsEmailsPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getPercentFixed, 'getPercentFixed', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/Page.jsx');
    reactHotLoader.register(StatisticsEmailsPage, 'StatisticsEmailsPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_statistics_emails__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











/**
 * @param {{
 *  from: Date,
 *  until: Date,
 *  changeDateRange: (from: Date, until: Date) => void,
 *  getStatisticsEmails: (from: number, until: number) => void,
 *  handleNormalize: () => void,
 *  checked: boolean,
 *  handleWorkingHours: () => void,
 *  workingHours: boolean,
 * }} param0 
 * @returns 
 */
var RangeDates = function RangeDates(_ref) {
    var from = _ref.from,
        until = _ref.until,
        changeDateRange = _ref.changeDateRange,
        getStatisticsEmails = _ref.getStatisticsEmails,
        handleNormalize = _ref.handleNormalize,
        checked = _ref.checked,
        handleWorkingHours = _ref.handleWorkingHours,
        workingHours = _ref.workingHours;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_3_moment___default()([2017, 10, 3]).toDate()),
        _useState2 = _slicedToArray(_useState, 1),
        fromMinDate = _useState2[0];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(until),
        _useState4 = _slicedToArray(_useState3, 2),
        fromMaxDate = _useState4[0],
        setFromMaxDate = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(from),
        _useState6 = _slicedToArray(_useState5, 2),
        untilMinDate = _useState6[0],
        setUntilMinDate = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_3_moment___default()().toDate()),
        _useState8 = _slicedToArray(_useState7, 1),
        untilMaxDate = _useState8[0];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(from),
        _useState10 = _slicedToArray(_useState9, 2),
        fromDate = _useState10[0],
        setFromDate = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(until),
        _useState12 = _slicedToArray(_useState11, 2),
        untilDate = _useState12[0],
        setUntilDate = _useState12[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setFromMaxDate(until);
        setUntilMinDate(from);
        setFromDate(from);
        setUntilDate(until);
    }, [from, until]);

    var changeFromDate = function changeFromDate(e, date) {
        setFromDate(date);
        setUntilMinDate(date);

        changeDateRange(date, untilDate);
        getStatisticsEmails(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(untilDate).utcOffset(0, true).valueOf());
    };

    var changeUntilDate = function changeUntilDate(e, date) {
        setUntilDate(date);
        setFromMaxDate(date);

        changeDateRange(fromDate, date);
        getStatisticsEmails(__WEBPACK_IMPORTED_MODULE_3_moment___default()(fromDate).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).utcOffset(0, true).valueOf());
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker___default.a, {
                floatingLabelText: 'From',
                autoOk: true,
                minDate: fromMinDate,
                maxDate: fromMaxDate,
                onChange: changeFromDate,
                value: fromDate,
                formatDate: function formatDate(date) {
                    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('DD-MM-YYYY');
                }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_DatePicker___default.a, {
                floatingLabelText: 'Until',
                autoOk: true,
                minDate: untilMinDate,
                maxDate: untilMaxDate,
                onChange: changeUntilDate,
                value: untilDate,
                formatDate: function formatDate(date) {
                    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('DD-MM-YYYY');
                }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sx-2', style: { width: '200px', marginTop: '40px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox___default.a, {
                label: 'Normalized',
                labelStyle: { fontSize: '12px' },
                onCheck: handleNormalize,
                checked: checked
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-sx-2', style: { width: '200px', marginTop: '40px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Checkbox___default.a, {
                label: 'Working hours(GMT+2)',
                labelStyle: { fontSize: '12px' },
                onCheck: handleWorkingHours,
                checked: workingHours
            })
        )
    );
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref2) {
    var from = _ref2.from,
        until = _ref2.until,
        changeDateRange = _ref2.changeDateRange;
    return {
        from: from, until: until, changeDateRange: changeDateRange
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getStatisticsEmails: __WEBPACK_IMPORTED_MODULE_4_actions_statistics_emails__["a" /* getStatisticsEmails */]
    }, dispatch);
})(RangeDates);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RangeDates, 'RangeDates', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/RangeDates.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/RangeDates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function createDiagonalPattern() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'black';

    var shape = document.createElement('canvas');
    shape.width = 10;
    shape.height = 10;
    var c = shape.getContext('2d');
    c.strokeStyle = color;
    c.fillStyle = 'green';
    c.fillRect(0, 0, shape.width, shape.height);
    c.beginPath();
    c.moveTo(2, 0);
    c.lineTo(10, 8);
    c.stroke();
    c.beginPath();
    c.moveTo(0, 8);
    c.lineTo(2, 10);
    c.stroke();
    return c.createPattern(shape, 'repeat');
}

var EmailsCharts = function (_React$PureComponent) {
    _inherits(EmailsCharts, _React$PureComponent);

    function EmailsCharts(props) {
        _classCallCheck(this, EmailsCharts);

        var _this = _possibleConstructorReturn(this, (EmailsCharts.__proto__ || Object.getPrototypeOf(EmailsCharts)).call(this, props));

        var statisticsEmails = props.statisticsEmails;


        _this.state = {
            statisticsEmails: statisticsEmails,
            rangeDates: [],
            labels: [],
            datasets: [],
            chart: {}
        };
        return _this;
    }

    _createClass(EmailsCharts, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.createRangeDates();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var statisticsEmails = nextProps.statisticsEmails,
                showNormalized = nextProps.showNormalized;


            if (!statisticsEmails.length) {
                return;
            }

            this.setState({
                statisticsEmails: statisticsEmails
            }, function () {
                _this2.createRangeDates(showNormalized);
            });
        }
    }, {
        key: 'createRangeDates',
        value: function createRangeDates(showNormalized) {
            var _state = this.state,
                statisticsEmails = _state.statisticsEmails,
                chart = _state.chart;


            var MAX = 100;

            var labels = [];

            var varamarSpam = [];
            var varamarSent = [];
            var varamarSentManual = [];
            var varamarFailed = [];

            var shipnextSpam = [];
            var shipnextSent = [];
            var shipnextSentManual = [];
            var shipnextFailed = [];

            var connectSpam = [];
            var connectSent = [];
            var connectFailed = [];

            var brokerSpam = [];
            var brokerSent = [];
            var brokerSentManual = [];
            var brokerFailed = [];

            statisticsEmails.forEach(function (item) {
                labels.push(__WEBPACK_IMPORTED_MODULE_4_moment___default()(item.realDate).format('MM-DD-YYYY'));

                var num = (item.varamar.failed || 0) + (item.varamar.sent || 0) + (item.varamar.spam || 0) + (item.varamar.totalSentManual || 0);

                var rate = showNormalized ? num / MAX : 1;

                varamarSpam.push(rate === 0 ? 0 : (item.varamar.spam || 0) / rate);
                varamarSent.push(rate === 0 ? 0 : (item.varamar.sent || 0) / rate);
                varamarSentManual.push(rate === 0 ? 0 : (item.varamar.totalSentManual || 0) / rate);
                varamarFailed.push(rate === 0 ? 0 : (item.varamar.failed || 0) / rate);

                num = (item.shipnext.failed || 0) + (item.shipnext.sent || 0) + (item.shipnext.spam || 0) + (item.shipnext.totalSentManual || 0);
                rate = showNormalized ? num / MAX : 1;

                shipnextSpam.push(rate === 0 ? 0 : (item.shipnext.spam || 0) / rate);
                shipnextSent.push(rate === 0 ? 0 : (item.shipnext.sent || 0) / rate);
                shipnextSentManual.push(rate === 0 ? 0 : (item.shipnext.totalSentManual || 0) / rate);
                shipnextFailed.push(rate === 0 ? 0 : (item.shipnext.failed || 0) / rate);

                num = (item.api.failed || 0) + (item.api.sent || 0) + (item.api.spam || 0);
                rate = showNormalized ? num / MAX : 1;

                connectSpam.push(rate === 0 ? 0 : (item.api.spam || 0) / rate);
                connectSent.push(rate === 0 ? 0 : (item.api.sent || 0) / rate);
                connectFailed.push(rate === 0 ? 0 : (item.api.failed || 0) / rate);

                num = (item.broker.failed || 0) + (item.broker.sent || 0) + (item.broker.spam || 0) + (item.broker.totalSentManual || 0);
                rate = showNormalized ? num / MAX : 1;

                brokerSpam.push(rate === 0 ? 0 : (item.broker.spam || 0) / rate);
                brokerSent.push(rate === 0 ? 0 : (item.broker.sent || 0) / rate);
                brokerSentManual.push(rate === 0 ? 0 : (item.broker.totalSentManual || 0) / rate);
                brokerFailed.push(rate === 0 ? 0 : (item.broker.failed || 0) / rate);
            });

            var postfix = showNormalized ? ' (%)' : '';

            var datasets = [
            // varamar
            {
                label: 'Varamar spam' + postfix,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 0',
                data: varamarSpam
            }, {
                label: 'Varamar sent' + postfix,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 0',
                data: varamarSent
            }, {
                label: 'Varamar sent (manual)' + postfix,
                backgroundColor: createDiagonalPattern('white'),
                borderColor: 'green',
                stack: 'Stack 0',
                data: varamarSentManual
            }, {
                label: 'Varamar failed' + postfix,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 0',
                data: varamarFailed
            },

            // shipnext
            {
                label: 'Shipnext spam' + postfix,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 1',
                data: shipnextSpam
            }, {
                label: 'Shipnext sent' + postfix,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 1',
                data: shipnextSent
            }, {
                label: 'Shipnext sent (manual)' + postfix,
                backgroundColor: createDiagonalPattern('white'),
                borderColor: 'green',
                stack: 'Stack 1',
                data: shipnextSentManual
            }, {
                label: 'Shipnext failed' + postfix,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 1',
                data: shipnextFailed
            },

            // connect
            {
                label: 'Connect spam' + postfix,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 2',
                data: connectSpam
            }, {
                label: 'Connect sent' + postfix,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 2',
                data: connectSent
            }, {
                label: 'Connect failed' + postfix,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 2',
                data: connectFailed
            },

            // broker
            {
                label: 'Broker spam' + postfix,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 3',
                data: brokerSpam
            }, {
                label: 'Broker sent' + postfix,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 3',
                data: brokerSent
            }, {
                label: 'Broker sent (manual)' + postfix,
                backgroundColor: createDiagonalPattern('white'),
                borderColor: 'green',
                stack: 'Stack 3',
                data: brokerSentManual
            }, {
                label: 'Broker failed' + postfix,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 3',
                data: brokerFailed
            }];

            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(this.state.chart)) {
                chart = this.createChart(labels, datasets);
            } else {
                chart = this.updateChart(chart, labels, datasets);
            }

            this.setState({
                labels: labels,
                datasets: datasets,
                chart: chart
            });
        }
    }, {
        key: 'updateChart',
        value: function updateChart(chart, labels, datasets) {
            chart.data.labels = labels;
            chart.data.datasets = datasets;

            if (this.props.showNormalized) {
                chart.options.scales.yAxes = [{
                    stacked: true,
                    ticks: {
                        max: 100
                    }
                }];
            } else {
                chart.options.scales.yAxes = [{
                    stacked: true
                }];
            }

            chart.update(0);

            return chart;
        }
    }, {
        key: 'createChart',
        value: function createChart(labels, datasets) {
            var ctx = this.refs.chart.getContext('2d');
            var chart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    tooltips: {
                        mode: 'label'
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            return chart;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { ref: 'chart' })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return EmailsCharts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var _ref$statisticsEmails = _ref.statisticsEmails,
        items = _ref$statisticsEmails.items,
        searchText = _ref$statisticsEmails.searchText;
    var from = _ref2.from,
        until = _ref2.until;
    return {
        statisticsEmails: items,
        searchText: searchText,
        from: from,
        until: until
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(EmailsCharts);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(createDiagonalPattern, 'createDiagonalPattern', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/Charts.jsx');
    reactHotLoader.register(EmailsCharts, 'EmailsCharts', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/Charts.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Emails/Charts.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_statistics_vesselPositions__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_statistics_cargoRequests__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RangeDates__ = __webpack_require__(3368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VesselPositionsChart__ = __webpack_require__(3369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CargoRequestsChart__ = __webpack_require__(3370);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var StatisticsMonitorPage = function (_React$Component) {
    _inherits(StatisticsMonitorPage, _React$Component);

    function StatisticsMonitorPage(props) {
        _classCallCheck(this, StatisticsMonitorPage);

        var _this = _possibleConstructorReturn(this, (StatisticsMonitorPage.__proto__ || Object.getPrototypeOf(StatisticsMonitorPage)).call(this, props));

        _this.state = {
            from: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day').add(-1, 'month').toDate(),
            until: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('day').toDate()
        };

        _this.changeDateRange = _this.changeDateRange.bind(_this);
        return _this;
    }

    _createClass(StatisticsMonitorPage, [{
        key: 'changeDateRange',
        value: function changeDateRange(from, until) {
            this.setState({
                from: from,
                until: until
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _state = this.state,
                from = _state.from,
                until = _state.until;


            this.props.getStatisticsVesselPositions(__WEBPACK_IMPORTED_MODULE_3_moment___default()(from).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(until).utcOffset(0, true).valueOf());

            this.props.getStatisticsCargoRequests(__WEBPACK_IMPORTED_MODULE_3_moment___default()(from).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(until).utcOffset(0, true).valueOf());
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                from = _state2.from,
                until = _state2.until;
            var _props = this.props,
                isLoadedCargoRequests = _props.isLoadedCargoRequests,
                isLoadedVesselPositions = _props.isLoadedVesselPositions;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'statistics-monitor', className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h3',
                            null,
                            'Statistics vessel positions'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h3',
                            null,
                            'Statistics cargo requests'
                        )
                    )
                ),
                isLoadedCargoRequests && isLoadedVesselPositions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__VesselPositionsChart__["a" /* default */], { from: from, until: until })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CargoRequestsChart__["a" /* default */], { from: from, until: until })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RangeDates__["a" /* default */], { from: from, until: until, changeDateRange: this.changeDateRange })
                    )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_CircularProgress___default.a, {
                    style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].circularProgress
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return StatisticsMonitorPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var isLogged = _ref.user.isLogged,
        statisticsCargoRequests = _ref.statisticsCargoRequests,
        statisticsVesselPositions = _ref.statisticsVesselPositions;
    return {
        isLogged: isLogged,
        isLoadedCargoRequests: statisticsCargoRequests.isLoaded,
        isLoadedVesselPositions: statisticsVesselPositions.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getStatisticsVesselPositions: __WEBPACK_IMPORTED_MODULE_6_actions_statistics_vesselPositions__["a" /* getStatisticsVesselPositions */],
        getStatisticsCargoRequests: __WEBPACK_IMPORTED_MODULE_7_actions_statistics_cargoRequests__["a" /* getStatisticsCargoRequests */]
    }, dispatch);
})(StatisticsMonitorPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StatisticsMonitorPage, 'StatisticsMonitorPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_statistics_vesselPositions__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_statistics_cargoRequests__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_DatePicker__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var RangeDates = function (_React$PureComponent) {
    _inherits(RangeDates, _React$PureComponent);

    function RangeDates(props) {
        _classCallCheck(this, RangeDates);

        var _this = _possibleConstructorReturn(this, (RangeDates.__proto__ || Object.getPrototypeOf(RangeDates)).call(this, props));

        var from = props.from,
            until = props.until;


        _this.state = {
            fromMinDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()([2017, 9, 1]).toDate(),
            fromMaxDate: until,

            untilMinDate: from,
            untilMaxDate: until,

            fromDate: from,
            untilDate: until
        };

        _this.changeFromDate = _this.changeFromDate.bind(_this);
        _this.changeUntilDate = _this.changeUntilDate.bind(_this);
        return _this;
    }

    _createClass(RangeDates, [{
        key: 'changeFromDate',
        value: function changeFromDate(e, date) {
            var _this2 = this;

            this.setState({
                fromDate: date,
                untilMinDate: date
            }, function () {
                var _state = _this2.state,
                    fromDate = _state.fromDate,
                    untilDate = _state.untilDate;


                _this2.props.changeDateRange(fromDate, untilDate);

                _this2.props.getStatisticsVesselPositions(__WEBPACK_IMPORTED_MODULE_3_moment___default()(fromDate).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(untilDate).utcOffset(0, true).valueOf());

                _this2.props.getStatisticsCargoRequests(__WEBPACK_IMPORTED_MODULE_3_moment___default()(fromDate).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(untilDate).utcOffset(0, true).valueOf());
            });
        }
    }, {
        key: 'changeUntilDate',
        value: function changeUntilDate(e, date) {
            var _this3 = this;

            this.setState({
                untilDate: date,
                fromMaxDate: date
            }, function () {
                var _state2 = _this3.state,
                    fromDate = _state2.fromDate,
                    untilDate = _state2.untilDate;


                _this3.props.changeDateRange(fromDate, untilDate);
                _this3.props.getStatisticsVesselPositions(__WEBPACK_IMPORTED_MODULE_3_moment___default()(fromDate).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(untilDate).utcOffset(0, true).valueOf());

                _this3.props.getStatisticsCargoRequests(__WEBPACK_IMPORTED_MODULE_3_moment___default()(fromDate).utcOffset(0, true).valueOf(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(untilDate).utcOffset(0, true).valueOf());
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state3 = this.state,
                fromMinDate = _state3.fromMinDate,
                fromMaxDate = _state3.fromMaxDate,
                untilMinDate = _state3.untilMinDate,
                untilMaxDate = _state3.untilMaxDate,
                fromDate = _state3.fromDate,
                untilDate = _state3.untilDate;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_DatePicker___default.a, {
                        floatingLabelText: 'From',
                        autoOk: true,
                        minDate: fromMinDate,
                        maxDate: fromMaxDate,
                        onChange: this.changeFromDate,
                        value: fromDate,
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY');
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_DatePicker___default.a, {
                        floatingLabelText: 'Until',
                        autoOk: true,
                        minDate: untilMinDate,
                        maxDate: untilMaxDate,
                        onChange: this.changeUntilDate,
                        value: untilDate,
                        formatDate: function formatDate(date) {
                            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MM-DD-YYYY');
                        }
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RangeDates;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var from = _ref.from,
        until = _ref.until,
        changeDateRange = _ref.changeDateRange;

    return {
        from: from, until: until, changeDateRange: changeDateRange
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getStatisticsVesselPositions: __WEBPACK_IMPORTED_MODULE_4_actions_statistics_vesselPositions__["a" /* getStatisticsVesselPositions */],
        getStatisticsCargoRequests: __WEBPACK_IMPORTED_MODULE_5_actions_statistics_cargoRequests__["a" /* getStatisticsCargoRequests */]
    }, dispatch);
})(RangeDates);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RangeDates, 'RangeDates', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/RangeDates.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/RangeDates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var VesselPositionsChart = function (_React$Component) {
    _inherits(VesselPositionsChart, _React$Component);

    function VesselPositionsChart(props) {
        _classCallCheck(this, VesselPositionsChart);

        var _this = _possibleConstructorReturn(this, (VesselPositionsChart.__proto__ || Object.getPrototypeOf(VesselPositionsChart)).call(this, props));

        _this.state = {
            chart: {}
        };
        return _this;
    }

    _createClass(VesselPositionsChart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.createRangeDates(this.props);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.createRangeDates(nextProps);
        }
    }, {
        key: 'createRangeDates',
        value: function createRangeDates(props) {
            var chart = this.state.chart;
            var statistics = props.statistics;


            var labels = [];
            var requests = [];
            var onRoute = [];
            var totalVessels = [];

            statistics.forEach(function (request) {
                labels.push(__WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(request.date).format('MM-DD-YYYY'));
                requests.push(request.quantity);
                onRoute.push(request.onRoute | 0);
                totalVessels.push(request.totalVessels | 0);
            });

            var datasets = [{
                name: 'Total Vessels',
                type: 'line',
                data: totalVessels,
                yAxisIndex: 1,
                stack: 'Total Vessels',
                label: 'Total Vessels',
                symbolSize: 6,
                lineStyle: {
                    width: 2
                },
                borderColor: '#22d661'
            }, {
                label: 'Real',
                backgroundColor: 'blue',
                borderColor: 'blue',
                data: requests
            }, {
                label: 'On route',
                backgroundColor: 'pink',
                borderColor: 'pink',
                data: onRoute
            }];

            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(chart)) {
                chart = this.createChart(labels, datasets);
            } else {
                chart = this.updateChart(chart, labels, datasets);
            }

            this.setState({
                chart: chart
            });
        }
    }, {
        key: 'updateChart',
        value: function updateChart(chart, labels, datasets) {
            chart.data.labels = labels;
            chart.data.datasets = datasets;

            chart.update(0);

            return chart;
        }
    }, {
        key: 'createChart',
        value: function createChart(labels, datasets) {
            var ctx = this.refs.chart.getContext('2d');
            var chart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    tooltips: {
                        mode: 'label'
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            return chart;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { ref: 'chart' });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselPositionsChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var items = _ref.statisticsVesselPositions.items;
    var from = _ref2.from,
        until = _ref2.until;
    return {
        statistics: items,
        from: from,
        until: until
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(VesselPositionsChart);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselPositionsChart, 'VesselPositionsChart', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/VesselPositionsChart.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/VesselPositionsChart.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_dates__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CargoRequestsChart = function (_React$Component) {
    _inherits(CargoRequestsChart, _React$Component);

    function CargoRequestsChart(props) {
        _classCallCheck(this, CargoRequestsChart);

        var _this = _possibleConstructorReturn(this, (CargoRequestsChart.__proto__ || Object.getPrototypeOf(CargoRequestsChart)).call(this, props));

        _this.state = {
            chart: {}
        };
        return _this;
    }

    _createClass(CargoRequestsChart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.createRangeDates(this.props);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.createRangeDates(nextProps);
        }
    }, {
        key: 'createRangeDates',
        value: function createRangeDates(props) {
            var chart = this.state.chart;
            var statistics = props.statistics;


            var labels = [];
            var requests = [];
            var fromApi = [];
            var fromFix = [];
            var fromVaramar = [];
            var fromBroker = [];
            statistics.forEach(function (request) {
                labels.push(__WEBPACK_IMPORTED_MODULE_4_moment___default()(Object(__WEBPACK_IMPORTED_MODULE_6_helpers_dates__["a" /* fromUTC */])(request.date)).format('MM-DD-YYYY'));
                requests.push(request.quantity - request.fromApi - request.fromFix - request.fromVaramar - request.fromBroker);
                fromApi.push(request.fromApi || 0);
                fromFix.push(request.fromFix || 0);
                fromVaramar.push(request.fromVaramar || 0);
                fromBroker.push(request.fromBroker || 0);
            });

            var datasets = [{
                label: 'Connect',
                backgroundColor: '#ECC30B',
                borderColor: '#ECC30B',
                data: fromApi
            }, {
                label: 'Varamar',
                backgroundColor: '#D62C2F',
                borderColor: '#D62C2F',
                data: fromVaramar
            }, {
                label: 'Fix',
                backgroundColor: '#F37748',
                borderColor: '#F37748',
                data: fromFix
            }, {
                label: 'Broker',
                backgroundColor: '#2B9EB3',
                borderColor: '#2B9EB3',
                data: fromBroker
            }, {
                label: 'Others',
                backgroundColor: 'blue',
                borderColor: 'blue',
                data: requests
            }];

            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(chart)) {
                chart = this.createChart(labels, datasets);
            } else {
                chart = this.updateChart(chart, labels, datasets);
            }

            this.setState({
                chart: chart
            });
        }
    }, {
        key: 'updateChart',
        value: function updateChart(chart, labels, datasets) {
            chart.data.labels = labels;
            chart.data.datasets = datasets;

            chart.update(0);

            return chart;
        }
    }, {
        key: 'createChart',
        value: function createChart(labels, datasets) {
            var ctx = this.refs.chart.getContext('2d');
            var chart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    tooltips: {
                        mode: 'label'
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            return chart;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { ref: 'chart' });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CargoRequestsChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref, _ref2) {
    var items = _ref.statisticsCargoRequests.items;
    var from = _ref2.from,
        until = _ref2.until;

    return {
        statistics: items,
        from: from,
        until: until
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(CargoRequestsChart);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CargoRequestsChart, 'CargoRequestsChart', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/CargoRequestsChart.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Monitor/CargoRequestsChart.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Info_index__ = __webpack_require__(3372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Charts_index__ = __webpack_require__(3375);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var StatisticsStPage = function (_React$Component) {
    _inherits(StatisticsStPage, _React$Component);

    function StatisticsStPage(props) {
        _classCallCheck(this, StatisticsStPage);

        var _this = _possibleConstructorReturn(this, (StatisticsStPage.__proto__ || Object.getPrototypeOf(StatisticsStPage)).call(this, props));

        _this.state = {
            users: [],
            currentUser: {},
            fromMin: __WEBPACK_IMPORTED_MODULE_4_moment___default()([2018, 5, 5]).toDate(),
            fromMax: __WEBPACK_IMPORTED_MODULE_4_moment___default()().toDate(),

            untilMin: __WEBPACK_IMPORTED_MODULE_4_moment___default()([2018, 5, 5]).toDate(),
            untilMax: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add('years', 2).toDate(),

            from: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'months').toDate(),
            until: __WEBPACK_IMPORTED_MODULE_4_moment___default()().toDate()
        };

        _this.changeFrom = _this.changeFrom.bind(_this);
        _this.changeUntil = _this.changeUntil.bind(_this);

        _this.countRequests = _this.countRequests.bind(_this);
        _this.showCurrent = _this.showCurrent.bind(_this);
        return _this;
    }

    _createClass(StatisticsStPage, [{
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _state, from, until, response;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _state = this.state, from = _state.from, until = _state.until;
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getStatisticsSt({ from: from.getTime(), until: until.getTime() });

                            case 3:
                                response = _context.sent;

                                if (!(response.status === 200)) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt('return', this.setState({
                                    users: response.data,
                                    currentUser: {}
                                }));

                            case 6:
                                return _context.abrupt('return', null);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'changeFrom',
        value: function changeFrom(e, date) {
            var _this2 = this;

            this.setState({
                from: date,
                untilMin: date
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _state2, from, until, response;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _state2 = _this2.state, from = _state2.from, until = _state2.until;
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getStatisticsSt({ from: from.getTime(), until: until.getTime() });

                            case 3:
                                response = _context2.sent;

                                if (!(response.status === 200)) {
                                    _context2.next = 6;
                                    break;
                                }

                                return _context2.abrupt('return', _this2.setState({
                                    users: response.data,
                                    currentUser: {}
                                }));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            })));
        }
    }, {
        key: 'changeUntil',
        value: function changeUntil(e, date) {
            var _this3 = this;

            this.setState({
                until: date,
                fromMax: date
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _state3, from, until, response;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _state3 = _this3.state, from = _state3.from, until = _state3.until;
                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getStatisticsSt({ from: from.getTime(), until: until.getTime() });

                            case 3:
                                response = _context3.sent;

                                if (!(response.status === 200)) {
                                    _context3.next = 6;
                                    break;
                                }

                                return _context3.abrupt('return', _this3.setState({
                                    users: response.data,
                                    currentUser: {}
                                }));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            })));
        }
    }, {
        key: 'showCurrent',
        value: function showCurrent(currentUser) {
            this.setState({
                currentUser: currentUser
            });
        }
    }, {
        key: 'countRequests',
        value: function countRequests(array, type) {
            return array.reduce(function (accumulator, currentValue) {
                return currentValue.type === type ? accumulator + 1 : accumulator;
            }, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state4 = this.state,
                until = _state4.until,
                untilMin = _state4.untilMin,
                untilMax = _state4.untilMax,
                from = _state4.from,
                fromMin = _state4.fromMin,
                fromMax = _state4.fromMax,
                users = _state4.users,
                currentUser = _state4.currentUser;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'statistics-st', className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Statistics st'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2 middle-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["e" /* DatePicker */], {
                                floatingLabelText: 'From',
                                minDate: fromMin,
                                maxDate: fromMax,
                                onChange: this.changeFrom,
                                value: from,
                                autoOk: true,
                                fullWidth: true,
                                formatDate: function formatDate(date) {
                                    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('DD-MM-YYYY');
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2 middle-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["e" /* DatePicker */], {
                                floatingLabelText: 'Until',
                                minDate: untilMin,
                                maxDate: untilMax,
                                onChange: this.changeUntil,
                                value: until,
                                autoOk: true,
                                fullWidth: true,
                                formatDate: function formatDate(date) {
                                    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('DD-MM-YYYY');
                                }
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["u" /* Table */],
                    { selectable: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["w" /* TableHeader */],
                        { displaySelectAll: false, adjustForCheckbox: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                'email'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                'name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                'request(cargo)'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                'request(vessel)'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                'request(tc)'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                'gazetter'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                null
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["v" /* TableBody */],
                        { displayRowCheckbox: false },
                        users.map(function (user, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                                { key: index },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                    user.user.email
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                    user.user.name
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                    _this4.countRequests(user.addRequest, 'cargo')
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                    _this4.countRequests(user.addRequest, 'vessel')
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                    _this4.countRequests(user.addRequest, 'tc')
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                    user.addGazeteer.length
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                                        onClick: function onClick() {
                                            _this4.showCurrent(user);
                                        },
                                        label: 'details'
                                    })
                                )
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Info_index__["a" /* default */], {
                    current: currentUser,
                    from: from,
                    until: until
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Charts_index__["a" /* default */], {
                    current: currentUser,
                    from: from,
                    until: until
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return StatisticsStPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, props) {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(StatisticsStPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(StatisticsStPage, 'StatisticsStPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Gazetters__ = __webpack_require__(3373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Requests__ = __webpack_require__(3374);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Info = function (_React$PureComponent) {
    _inherits(Info, _React$PureComponent);

    function Info() {
        _classCallCheck(this, Info);

        return _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).apply(this, arguments));
    }

    _createClass(Info, [{
        key: 'render',
        value: function render() {
            var current = this.props.current;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                current.user ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    current.addGazeteer.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Gazetters__["a" /* default */], { gazetters: current.addGazeteer }) : '',
                    current.addRequest.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Requests__["a" /* default */], { requests: current.addRequest }) : ''
                ) : ''
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Info;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var from = _ref.from,
        until = _ref.until,
        current = _ref.current;

    return {
        from: from,
        until: until,
        current: current
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(Info);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Info, 'Info', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Info/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Info/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var InfoGazetters = function (_React$PureComponent) {
    _inherits(InfoGazetters, _React$PureComponent);

    function InfoGazetters(props) {
        _classCallCheck(this, InfoGazetters);

        var _this = _possibleConstructorReturn(this, (InfoGazetters.__proto__ || Object.getPrototypeOf(InfoGazetters)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            gazetters: props.gazetters,
            search: ''
        };

        _this.onSearch = _this.onSearch.bind(_this);
        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        return _this;
    }

    _createClass(InfoGazetters, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.setState({
                total: this.props.gazetters.length,
                gazetters: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].filterSearch(this.props.gazetters, this.state.search, ['gazetteerName', 'fileName', 'gazType', 'status', 'value']),
                page: 1
            }, function () {
                _this2.handleUpdateRow(_this2.state);
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            var _this3 = this;

            this.setState({
                total: props.gazetters.length,
                gazetters: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].filterSearch(props.gazetters, this.state.search, ['gazetteerName', 'fileName', 'gazType', 'status', 'value']),
                page: 1
            }, function () {
                _this3.handleUpdateRow(_this3.state);
            });
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.gazetters.slice(from, to);
        }
    }, {
        key: 'onSearch',
        value: function onSearch(e, value) {
            var _this4 = this;

            this.setState({
                search: value,
                total: this.props.gazetters.length,
                gazetters: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].filterSearch(this.props.gazetters, value, ['gazetteerName', 'fileName', 'gazType', 'status', 'value']),
                page: 1
            }, function () {
                _this4.handleUpdateRow(_this4.state);
            });
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(state) {
            var cloneState = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state);

            this.setState(_extends({}, cloneState, {
                rows: this.changeRowsByPagination(cloneState)
            }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                search = _state.search,
                gazetters = _state.gazetters,
                rows = _state.rows,
                rowsPerPage = _state.rowsPerPage,
                numberOfRows = _state.numberOfRows,
                page = _state.page;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block margin-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block absolute' },
                    'Gazetters'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["A" /* TextField */], {
                            value: search,
                            floatingLabelText: 'Search',
                            onChange: this.onSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                            total: gazetters.length,
                            rowsPerPage: rowsPerPage,
                            page: page,
                            numberOfRows: numberOfRows,
                            updateRows: this.handleUpdateRow
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["u" /* Table */],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["w" /* TableHeader */],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_material_ui__["y" /* TableRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'date'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'GazetterName'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'fileName'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'gazType'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'status'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'value'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["v" /* TableBody */],
                            { displayRowCheckbox: false },
                            rows.map(function (gazetter, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["y" /* TableRow */],
                                    { key: index },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        __WEBPACK_IMPORTED_MODULE_4_moment___default()(gazetter.date).format('DD.MM.YYYY HH.mm.ss')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        gazetter.gazetteerName
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        gazetter.fileName
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        gazetter.gazType
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        gazetter.status
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        gazetter.value
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return InfoGazetters;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var requests = _ref.requests;
    return {
        requests: requests
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(InfoGazetters);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(InfoGazetters, 'InfoGazetters', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Info/Gazetters.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Info/Gazetters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var InfoRequests = function (_React$PureComponent) {
    _inherits(InfoRequests, _React$PureComponent);

    function InfoRequests(props) {
        _classCallCheck(this, InfoRequests);

        var _this = _possibleConstructorReturn(this, (InfoRequests.__proto__ || Object.getPrototypeOf(InfoRequests)).call(this, props));

        _this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            requests: props.requests,
            search: ''
        };

        _this.onSearch = _this.onSearch.bind(_this);
        _this.handleUpdateRow = _this.handleUpdateRow.bind(_this);
        return _this;
    }

    _createClass(InfoRequests, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.setState({
                total: this.props.requests.length,
                requests: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].filterSearch(this.props.requests, this.state.search, ['mailId', 'type']),
                page: 1
            }, function () {
                _this2.handleUpdateRow(_this2.state);
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {
            var _this3 = this;

            this.setState({
                total: props.requests.length,
                requests: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].filterSearch(props.requests, this.state.search, ['mailId', 'type']),
                page: 1
            }, function () {
                _this3.handleUpdateRow(_this3.state);
            });
        }
    }, {
        key: 'changeRowsByPagination',
        value: function changeRowsByPagination(state) {
            var elementsOnPage = state.numberOfRows;
            var offset = state.page - 1;
            var from = offset * elementsOnPage;
            var to = offset * elementsOnPage + elementsOnPage;

            return this.state.requests.slice(from, to);
        }
    }, {
        key: 'onSearch',
        value: function onSearch(e, value) {
            var _this4 = this;

            this.setState({
                search: value,
                total: this.props.requests.length,
                requests: __WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* default */].filterSearch(this.props.requests, value, ['mailId', 'type']),
                page: 1
            }, function () {
                _this4.handleUpdateRow(_this4.state);
            });
        }
    }, {
        key: 'handleUpdateRow',
        value: function handleUpdateRow(state) {
            var cloneState = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(state);

            this.setState(_extends({}, cloneState, {
                rows: this.changeRowsByPagination(cloneState)
            }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                search = _state.search,
                requests = _state.requests,
                rows = _state.rows,
                rowsPerPage = _state.rowsPerPage,
                numberOfRows = _state.numberOfRows,
                page = _state.page;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'paper-block margin-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name-block absolute' },
                    'Requests'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["A" /* TextField */], {
                            value: search,
                            floatingLabelText: 'Search',
                            onChange: this.onSearch
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Libs_Pagination__["a" /* default */], {
                            total: requests.length,
                            rowsPerPage: rowsPerPage,
                            page: page,
                            numberOfRows: numberOfRows,
                            updateRows: this.handleUpdateRow
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-10' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["u" /* Table */],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["w" /* TableHeader */],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_material_ui__["y" /* TableRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'date'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'eh'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'error'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'mailId'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'status'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'type'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_material_ui__["v" /* TableBody */],
                            { displayRowCheckbox: false },
                            rows.map(function (request, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui__["y" /* TableRow */],
                                    { key: index },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        __WEBPACK_IMPORTED_MODULE_4_moment___default()(request.date).format('DD.MM.YYYY HH.mm.ss')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        request.eh
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        request.error ? request.error.messages[0] : ''
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'a',
                                            { target: '_blank', href: '/' + request.mailId },
                                            request.mailId
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        request.status
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_6_styles__["a" /* default */].tableRowColumnCSS },
                                        request.type
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return InfoRequests;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var requests = _ref.requests;

    return {
        requests: requests
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(InfoRequests);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(InfoRequests, 'InfoRequests', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Info/Requests.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Info/Requests.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Gazetters__ = __webpack_require__(3376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Requests__ = __webpack_require__(3377);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Charts = function (_React$PureComponent) {
    _inherits(Charts, _React$PureComponent);

    function Charts() {
        _classCallCheck(this, Charts);

        return _possibleConstructorReturn(this, (Charts.__proto__ || Object.getPrototypeOf(Charts)).apply(this, arguments));
    }

    _createClass(Charts, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                current = _props.current,
                until = _props.until,
                from = _props.from;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                current.user ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    current.addGazeteer.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Gazetters__["a" /* default */], { gazetters: current.addGazeteer, until: until, from: from }) : '',
                    current.addRequest.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Requests__["a" /* default */], { requests: current.addRequest, until: until, from: from }) : ''
                ) : ''
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Charts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var from = _ref.from,
        until = _ref.until,
        current = _ref.current;

    return {
        from: from,
        until: until,
        current: current
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(Charts);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Charts, 'Charts', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Charts/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Charts/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ChartGazetters = function (_React$PureComponent) {
    _inherits(ChartGazetters, _React$PureComponent);

    function ChartGazetters(props) {
        _classCallCheck(this, ChartGazetters);

        var _this = _possibleConstructorReturn(this, (ChartGazetters.__proto__ || Object.getPrototypeOf(ChartGazetters)).call(this, props));

        _this.state = {
            gazetters: props.gazetters,
            rangeDates: [],
            labels: [],
            datasets: [],
            chart: {}
        };
        return _this;
    }

    _createClass(ChartGazetters, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.createRangeDates();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var gazetters = nextProps.gazetters;


            if (!gazetters.length) {
                return;
            }

            this.setState({
                gazetters: gazetters
            }, function () {
                _this2.createRangeDates();
            });
        }
    }, {
        key: 'createLabels',
        value: function createLabels() {
            var _props = this.props,
                from = _props.from,
                until = _props.until;


            var labels = [];
            var currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(from);
            var untilMoment = __WEBPACK_IMPORTED_MODULE_4_moment___default()(until);

            while (currentDate <= untilMoment) {
                labels.push(__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentDate).startOf('day').format('DD.MM.YYYY'));
                currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(currentDate).add(1, 'days');
            }

            return labels;
        }
    }, {
        key: 'createRangeDates',
        value: function createRangeDates() {
            var _state = this.state,
                gazetters = _state.gazetters,
                chart = _state.chart;


            var labels = this.createLabels();
            var values = [];

            labels.forEach(function (item) {
                // labels.push(moment    (item.date).utc().endOf('day').format('MM-DD-YYYY'));
                var count = 0;
                gazetters.forEach(function (gazetter) {
                    if (item === __WEBPACK_IMPORTED_MODULE_4_moment___default()(gazetter.date).utc().startOf('day').format('DD.MM.YYYY')) {
                        count++;
                    }
                });

                values.push(count);
            });

            var datasets = [{
                label: 'Gazetters',
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 0',
                data: values
            }];

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(chart)) {
                chart = this.createChart(labels, datasets);
            } else {
                chart = this.updateChart(chart, labels, datasets);
            }

            this.setState({
                labels: labels,
                datasets: datasets,
                chart: chart
            });
        }
    }, {
        key: 'updateChart',
        value: function updateChart(chart, labels, datasets) {
            chart.data.labels = labels;
            chart.data.datasets = datasets;

            chart.update(0);

            return chart;
        }
    }, {
        key: 'createChart',
        value: function createChart(labels, datasets) {
            var ctx = this.refs.chartGazetters.getContext('2d');
            var chart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    tooltips: {
                        mode: 'label'
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            return chart;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { ref: 'chartGazetters' })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ChartGazetters;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var gazetters = _ref.gazetters;

    return {
        gazetters: gazetters
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(ChartGazetters);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ChartGazetters, 'ChartGazetters', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Charts/Gazetters.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Charts/Gazetters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ChartRequests = function (_React$PureComponent) {
    _inherits(ChartRequests, _React$PureComponent);

    function ChartRequests(props) {
        _classCallCheck(this, ChartRequests);

        var _this = _possibleConstructorReturn(this, (ChartRequests.__proto__ || Object.getPrototypeOf(ChartRequests)).call(this, props));

        _this.state = {
            requests: props.requests,
            rangeDates: [],
            labels: [],
            datasets: [],
            chart: {}
        };
        return _this;
    }

    _createClass(ChartRequests, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.createRangeDates();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var requests = nextProps.requests;


            if (!requests.length) {
                return;
            }

            this.setState({
                requests: requests
            }, function () {
                _this2.createRangeDates();
            });
        }
    }, {
        key: 'createLabels',
        value: function createLabels() {
            var _props = this.props,
                from = _props.from,
                until = _props.until;


            var labels = [];
            var currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(from);
            var untilMoment = __WEBPACK_IMPORTED_MODULE_4_moment___default()(until);

            while (currentDate <= untilMoment) {
                labels.push(__WEBPACK_IMPORTED_MODULE_4_moment___default()(currentDate).startOf('day').format('DD.MM.YYYY'));
                currentDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(currentDate).add(1, 'days');
            }

            return labels;
        }
    }, {
        key: 'createRangeDates',
        value: function createRangeDates() {
            var _state = this.state,
                requests = _state.requests,
                chart = _state.chart;


            var labels = this.createLabels();
            var values = [];

            labels.forEach(function (item) {
                var count = 0;
                requests.forEach(function (gazetter) {
                    if (item === __WEBPACK_IMPORTED_MODULE_4_moment___default()(gazetter.date).utc().startOf('day').format('DD.MM.YYYY')) {
                        count++;
                    }
                });

                values.push(count);
            });

            var datasets = [{
                label: 'Requests',
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 0',
                data: values
            }];

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(chart)) {
                chart = this.createChart(labels, datasets);
            } else {
                chart = this.updateChart(chart, labels, datasets);
            }

            this.setState({
                labels: labels,
                datasets: datasets,
                chart: chart
            });
        }
    }, {
        key: 'updateChart',
        value: function updateChart(chart, labels, datasets) {
            chart.data.labels = labels;
            chart.data.datasets = datasets;

            chart.update(0);

            return chart;
        }
    }, {
        key: 'createChart',
        value: function createChart(labels, datasets) {
            var ctx = this.refs.chartRequests.getContext('2d');
            var chart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    tooltips: {
                        mode: 'label'
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            return chart;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', { ref: 'chartRequests' })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ChartRequests;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref) {
    var requests = _ref.requests;

    return {
        requests: requests
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(ChartRequests);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ChartRequests, 'ChartRequests', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Charts/Requests.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/St/Charts/Requests.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = CompositionStats;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RangeDates__ = __webpack_require__(3379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Chart__ = __webpack_require__(3380);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function CompositionStats() {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_0_moment___default()().add(-1, 'w').startOf('day').toDate()),
        _useState2 = _slicedToArray(_useState, 2),
        from = _useState2[0],
        setFrom = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').toDate()),
        _useState4 = _slicedToArray(_useState3, 2),
        until = _useState4[0],
        setUntil = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        stats = _useState6[0],
        setStats = _useState6[1];

    var modifyFrom = function modifyFrom(_from) {
        setFrom(_from);
    };

    var modifyUntil = function modifyUntil(_until) {
        setUntil(__WEBPACK_IMPORTED_MODULE_0_moment___default()(_until).endOf('day').toDate());
    };

    var getStats = function getStats() {
        __WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].getCompositionStats(from, until).then(function (response) {
            if (response.status > 300) {
                return;
            }
            setStats(response.data.stats);
        });
    };

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        getStats();
    }, [from, until]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { id: 'statistics-emails', className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            'Statistics composition'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Chart__["a" /* default */], {
            stats: stats
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RangeDates__["a" /* default */], {
            from: from,
            until: until,
            modifyFrom: modifyFrom,
            modifyUntil: modifyUntil
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CompositionStats, 'CompositionStats', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Composition/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = RangeDates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var fromMinDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()([2017, 10, 3]).toDate();
var untilMaxDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate();

function RangeDates(_ref) {
    var from = _ref.from,
        until = _ref.until,
        modifyFrom = _ref.modifyFrom,
        modifyUntil = _ref.modifyUntil;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(until),
        _useState2 = _slicedToArray(_useState, 2),
        fromMaxDate = _useState2[0],
        _setFromMaxDate = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(from),
        _useState4 = _slicedToArray(_useState3, 2),
        untilMinDate = _useState4[0],
        _setUntilMinDate = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(from),
        _useState6 = _slicedToArray(_useState5, 2),
        fromDate = _useState6[0],
        setFromDate = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(until),
        _useState8 = _slicedToArray(_useState7, 2),
        untilDate = _useState8[0],
        setUntilDate = _useState8[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        _setFromMaxDate(until);
        _setUntilMinDate(from);
        setFromDate(from);
        setUntilDate(until);
    }, [from, until]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker___default.a, {
                floatingLabelText: 'From',
                autoOk: true,
                minDate: fromMinDate,
                maxDate: fromMaxDate,
                onChange: function onChange(_e, d) {
                    return modifyFrom(d);
                },
                value: fromDate,
                formatDate: function formatDate(date) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('MM-DD-YYYY');
                }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-6' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_DatePicker___default.a, {
                floatingLabelText: 'Until',
                autoOk: true,
                minDate: untilMinDate,
                maxDate: untilMaxDate,
                onChange: function onChange(_e, d) {
                    return modifyUntil(d);
                },
                value: untilDate,
                formatDate: function formatDate(date) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('MM-DD-YYYY');
                }
            })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(fromMinDate, 'fromMinDate', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Composition/RangeDates.jsx');
    reactHotLoader.register(untilMaxDate, 'untilMaxDate', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Composition/RangeDates.jsx');
    reactHotLoader.register(RangeDates, 'RangeDates', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Composition/RangeDates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Chart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function Chart(_ref) {
    var stats = _ref.stats;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),
        _useState2 = _slicedToArray(_useState, 2),
        chart = _useState2[0],
        setChart = _useState2[1];

    var chartRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);

    var updateChart = function updateChart(_chart, _labels, _datasets) {
        _chart.data.labels = _labels;
        _chart.data.datasets = _datasets;

        _chart.options.scales.yAxes = [{
            stacked: true
        }];

        _chart.update(0);

        return chart;
    };

    var createChart = function createChart(_labels, _datasets) {
        var ctx = chartRef.current.getContext('2d');
        var __chart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, {
            type: 'bar',
            data: {
                labels: _labels,
                datasets: _datasets
            },
            options: {
                tooltips: {
                    mode: 'label'
                },
                scales: {
                    yAxes: [{
                        stacked: true
                    }]
                }
            }
        });

        return __chart;
    };

    var populateChart = function populateChart() {
        var _stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var vessels = [];
        var sizes = [];
        var labels = [];

        _stats.forEach(function (stat) {
            labels.push(stat.date);
            vessels.push(stat.vessels);
            sizes.push(stat.sizes);
        });

        var datasets = [{
            label: 'Vessels',
            data: vessels,
            borderColor: 'red',
            backgroundColor: 'salmon',
            stack: 'combined',
            type: 'bar'
        }, {
            label: 'Sizes',
            data: sizes,
            borderColor: 'blue',
            stack: 'combined',
            type: 'line'
        }];

        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(chart)) {
            setChart(createChart(labels, datasets));
        } else {
            setChart(updateChart(chart, labels, datasets));
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        populateChart(stats);
    }, [stats]);

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        populateChart();
    }, []);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'row' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-12' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('canvas', { ref: chartRef })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Chart, 'Chart', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Composition/Chart.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(3382);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var UserBanListPage = function (_React$Component) {
    _inherits(UserBanListPage, _React$Component);

    function UserBanListPage(props) {
        _classCallCheck(this, UserBanListPage);

        return _possibleConstructorReturn(this, (UserBanListPage.__proto__ || Object.getPrototypeOf(UserBanListPage)).call(this, props));
    }

    _createClass(UserBanListPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getUserList({ page: 1 });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'users-ban', className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_5_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Users list'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */], null)
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return UserBanListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        isLoaded: state.users.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getUserList: __WEBPACK_IMPORTED_MODULE_4_actions_users__["e" /* getUserList */]
    }, dispatch);
})(UserBanListPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(UserBanListPage, 'UserBanListPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BanList/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BanList/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fuse_js__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_companies__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Row__ = __webpack_require__(3383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var AutoCompleteWrapper = function (_React$Component) {
    _inherits(AutoCompleteWrapper, _React$Component);

    function AutoCompleteWrapper(props) {
        _classCallCheck(this, AutoCompleteWrapper);

        var _this = _possibleConstructorReturn(this, (AutoCompleteWrapper.__proto__ || Object.getPrototypeOf(AutoCompleteWrapper)).call(this, props));

        _this.state = {
            companies: [],
            autocompleteSource: [],
            value: '',
            _id: undefined
        };

        _this.handleCompanySelect = _this.handleCompanySelect.bind(_this);
        _this.handleAutocomplete = _this.handleAutocomplete.bind(_this);
        return _this;
    }

    _createClass(AutoCompleteWrapper, [{
        key: 'handleAutocomplete',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
                var found;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(value.length < 2)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                found = this.props.fuse.search(value);
                                _context.next = 5;
                                return this.setState(function () {
                                    return {
                                        value: value,
                                        autocompleteSource: found
                                    };
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function handleAutocomplete(_x) {
                return _ref.apply(this, arguments);
            }

            return handleAutocomplete;
        }()
    }, {
        key: 'handleCompanySelect',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(selected) {
                var companyMembers;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (selected._id) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                this.setState({ _id: selected._id });

                                _context2.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_12__services_companies__["f" /* findMembersOfCompany */])({ _id: selected._id });

                            case 5:
                                companyMembers = _context2.sent;


                                this.props.updateUserListWithCompanyFilter(companyMembers);
                                this.props.toggleFilterByCompanies(selected._id);

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function handleCompanySelect(_x2) {
                return _ref2.apply(this, arguments);
            }

            return handleCompanySelect;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui__["a" /* AutoComplete */], {
                floatingLabelText: 'Search by company name',
                dataSource: this.state.autocompleteSource,
                dataSourceConfig: { text: 'name', value: '_id' },
                onUpdateInput: this.handleAutocomplete,
                filter: __WEBPACK_IMPORTED_MODULE_15_material_ui__["a" /* AutoComplete */].caseInsensitiveFilter,
                maxSearchResults: 20,
                menuStyle: { maxHeight: '500px' },
                onKeyDown: function onKeyDown(e) {
                    if (e.key === 'Enter') {
                        e.stopPropagation();
                        return false;
                    }
                },
                onNewRequest: function onNewRequest(selected, e, r) {
                    _this2.handleCompanySelect(selected);
                    _this2.props.toggleRoleSetting(_this2.state.value);
                }
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AutoCompleteWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var TableUsersBan = function (_React$Component2) {
    _inherits(TableUsersBan, _React$Component2);

    function TableUsersBan(props) {
        _classCallCheck(this, TableUsersBan);

        var _this3 = _possibleConstructorReturn(this, (TableUsersBan.__proto__ || Object.getPrototypeOf(TableUsersBan)).call(this, props));

        _this3.state = {
            page: 1,
            users: [],
            companies: [],
            companyNames: [],
            search: '',
            isDataFromAutoComplete: false,
            isFilteredByCompany: false,
            isSettingRoleEnabled: false
        };

        _this3.prevPage = _this3.prevPage.bind(_this3);
        _this3.nextPage = _this3.nextPage.bind(_this3);

        _this3.keyPress = _this3.keyPress.bind(_this3);
        _this3.onChange = _this3.onChange.bind(_this3);

        _this3.toggleCompanyRole = _this3.toggleCompanyRole.bind(_this3);
        _this3.toggleRoleSetting = _this3.toggleRoleSetting.bind(_this3);
        _this3.toggleFilterByCompanies = _this3.toggleFilterByCompanies.bind(_this3);
        _this3.updateCompanyMemberStatus = _this3.updateCompanyMemberStatus.bind(_this3);
        _this3.updateUserListWithCompanyFilter = _this3.updateUserListWithCompanyFilter.bind(_this3);
        return _this3;
    }

    _createClass(TableUsersBan, [{
        key: 'onChange',
        value: function onChange(e, value) {
            var _this4 = this;

            this.setState({
                search: value
            }, function () {
                if (_this4.state.search === '') {
                    _this4.props.getUserList({
                        page: 1
                    });
                }
            });
        }
    }, {
        key: 'keyPress',
        value: function keyPress(e) {
            var _this5 = this;

            if (e.keyCode === 13) {
                if (this.state.search === '') return;

                var companyName = void 0;
                if (this.state.isFilteredByCompany) companyName = this.state.search;

                __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].findUser(this.state.search, true, companyName).then(function (response) {
                    _this5.props.addUsersFromAutocomplete(response.data);
                }).catch(function (response) {
                    console.error(response);
                });
            }
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            this.props.getUserList({
                page: this.state.next,
                limit: 25
            });
            this.setState(function () {
                return {
                    isFilteredByCompany: false
                };
            });
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            this.props.getUserList({
                page: this.state.previous,
                limit: 25
            });
            this.setState(function () {
                return {
                    isFilteredByCompany: false
                };
            });
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_12__services_companies__["h" /* getCompanies */])();

                            case 2:
                                response = _context3.sent;


                                this.setState(function () {
                                    return {
                                        companies: response.data
                                    };
                                });

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function componentDidMount() {
                return _ref3.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'updateUserListWithCompanyFilter',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(newUserListWithCompanyRoles) {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.setState(function () {
                                    return {
                                        users: newUserListWithCompanyRoles
                                    };
                                });

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function updateUserListWithCompanyFilter(_x3) {
                return _ref4.apply(this, arguments);
            }

            return updateUserListWithCompanyFilter;
        }()
    }, {
        key: 'updateCompanyMemberStatus',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(user) {
                var updatedUser, updatedUsers;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].findUserById(user);

                            case 2:
                                updatedUser = _context5.sent;
                                updatedUsers = this.state.users.map(function (oldUser) {
                                    if (oldUser.user._id === updatedUser._id) {
                                        oldUser.user.approved = updatedUser.approved;
                                        oldUser.role = updatedUser.role;
                                    }
                                    return oldUser;
                                });


                                this.setState(function () {
                                    return {
                                        users: updatedUsers
                                    };
                                });

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function updateCompanyMemberStatus(_x4) {
                return _ref5.apply(this, arguments);
            }

            return updateCompanyMemberStatus;
        }()
    }, {
        key: 'toggleRoleSetting',
        value: function toggleRoleSetting(autocompleteSearchStr) {
            if (autocompleteSearchStr.length < 2 || !autocompleteSearchStr.length) {

                this.setState(function () {
                    return {
                        isSettingRoleEnabled: false
                    };
                });

                return;
            }

            this.setState(function () {
                return {
                    isSettingRoleEnabled: true
                };
            });
        }
    }, {
        key: 'toggleCompanyRole',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(user) {
                var _this6 = this;

                var responseBeforeUpdate, companyUsers, company, updatedCompanyUsers;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(user.role === 'owner')) {
                                    _context6.next = 2;
                                    break;
                                }

                                return _context6.abrupt('return');

                            case 2:
                                if (!(user.role === 'pending')) {
                                    _context6.next = 4;
                                    break;
                                }

                                return _context6.abrupt('return');

                            case 4:
                                _context6.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_12__services_companies__["e" /* findCompanyById */])(user.company._id);

                            case 6:
                                responseBeforeUpdate = _context6.sent;
                                companyUsers = responseBeforeUpdate.participants;

                                if (!(user.role === 'manager')) {
                                    _context6.next = 11;
                                    break;
                                }

                                _context6.next = 11;
                                return companyUsers.forEach(function (userInCompany) {
                                    userInCompany.company = { _id: user.company._id };
                                    if (userInCompany.role !== 'pending') {
                                        userInCompany.role = 'manager';
                                        if (userInCompany._id === user._id) {
                                            userInCompany.role = 'owner';
                                        }
                                    }
                                });

                            case 11:
                                _context6.next = 13;
                                return __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].setNewParticipantsRoles(companyUsers, user.company._id);

                            case 13:
                                _context6.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_12__services_companies__["e" /* findCompanyById */])(user.company._id);

                            case 15:
                                company = _context6.sent;
                                updatedCompanyUsers = company.participants;
                                _context6.next = 19;
                                return updatedCompanyUsers.forEach(function (newUser) {
                                    newUser.company = { _id: company._id, name: company.name };
                                    newUser.user = {};
                                    _this6.state.users.forEach(function (oldUser) {
                                        if (oldUser._id === newUser._id) {
                                            newUser.user._id = oldUser.user._id;
                                            newUser.user.approved = oldUser.user.approved;
                                            newUser.user.emailVerified = oldUser.user.emailVerified;
                                            newUser.user.createdAt = oldUser.user.createdAt;
                                        }
                                    });
                                });

                            case 19:

                                this.updateUserListWithCompanyFilter(updatedCompanyUsers);

                            case 20:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function toggleCompanyRole(_x5) {
                return _ref6.apply(this, arguments);
            }

            return toggleCompanyRole;
        }()
    }, {
        key: 'toggleFilterByCompanies',
        value: function toggleFilterByCompanies(searchValue) {
            if (!searchValue.length) {
                this.setState(function (prevState) {
                    return {
                        isFilteredByCompany: false
                    };
                });
                return;
            }

            this.setState(function (prevState) {
                return {
                    isFilteredByCompany: true
                };
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(nextProps) {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.setState({
                                    users: nextProps.users.data,
                                    page: nextProps.users.page || 1,
                                    previous: nextProps.users.previous,
                                    next: nextProps.users.next,
                                    isDataFromAutoComplete: nextProps.users.isDataFromAutoComplete
                                });

                            case 2:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function UNSAFE_componentWillReceiveProps(_x6) {
                return _ref7.apply(this, arguments);
            }

            return UNSAFE_componentWillReceiveProps;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var _state = this.state,
                users = _state.users,
                page = _state.page,
                isDataFromAutoComplete = _state.isDataFromAutoComplete;


            var fuse = new __WEBPACK_IMPORTED_MODULE_3_fuse_js__(this.state.companies, {
                threshold: 0,
                location: 0,
                distance: 10,
                maxPatternLength: 10,
                minMatchCharLength: 2,
                keys: ['name']
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4 middle-xs', style: { display: 'flex' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { width: '100%' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                                floatingLabelText: 'Search',
                                onChange: this.onChange,
                                onKeyDown: this.keyPress,
                                fullWidth: true
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4 middle-xs', style: { display: 'flex' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCompleteWrapper, {
                            fuse: fuse,
                            toggleRoleSetting: this.toggleRoleSetting,
                            updateUserListWithCompanyFilter: this.updateUserListWithCompanyFilter,
                            toggleFilterByCompanies: this.toggleFilterByCompanies
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: ' center-xs middle-xs', style: { width: '100%', display: 'flex' } },
                            !isDataFromAutoComplete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].navigationLeft,
                                        name: 'navigationLeft',
                                        onClick: this.prevPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Page: ',
                                    page
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].navigationRight,
                                        name: 'navigationRight',
                                        onClick: this.nextPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            ) : null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'table-body' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["Table"],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeader"],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRow"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'Name'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableRowColumnBigCSS },
                                    'Email'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'Role'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'CreatedAt'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'Company name'
                                ),
                                this.state.isSettingRoleEnabled && this.state.isFilteredByCompany ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'Company role'
                                ) : null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Email verification status'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"],
                                    { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'User approval'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableHeaderColumn"], { style: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].tableHeaderColumnCSS })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableBody"],
                            { displayRowCheckbox: false },
                            users.map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Row__["a" /* default */], {
                                    key: item.user && item.user._id || item._id,
                                    item: item,
                                    isFilteredByCompany: _this7.state.isFilteredByCompany,
                                    isVerifiedEmail: _this7.state.users[index].emailVerified,
                                    isApproved: item.user && item.user.approved || item.approved,
                                    companyRoleMode: _this7.state.isSettingRoleEnabled,
                                    toggleCompanyRole: _this7.toggleCompanyRole,
                                    companyRole: item.role || 'unset',
                                    updateCompanyMemberStatus: _this7.updateCompanyMemberStatus
                                });
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TableUsersBan;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref8) {
    var users = _ref8.users;

    return {
        users: users
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getUserList: __WEBPACK_IMPORTED_MODULE_10_actions_users__["e" /* getUserList */],
        addUsersFromAutocomplete: __WEBPACK_IMPORTED_MODULE_10_actions_users__["a" /* addUsersFromAutocomplete */]
    }, dispatch);
})(TableUsersBan);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AutoCompleteWrapper, 'AutoCompleteWrapper', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BanList/Table.jsx');
    reactHotLoader.register(TableUsersBan, 'TableUsersBan', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BanList/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BanList/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_companies__ = __webpack_require__(465);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Row = function (_React$Component) {
    _inherits(Row, _React$Component);

    function Row(props) {
        _classCallCheck(this, Row);

        var _this = _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).call(this, props));

        _this.state = {
            companyRole: _this.props.companyRole,
            isMemberApproved: false
        };

        _this.setRoleBgColor = _this.setRoleBgColor.bind(_this);
        _this.toggleCompanyMemberStatus = _this.toggleCompanyMemberStatus.bind(_this);
        return _this;
    }

    _createClass(Row, [{
        key: 'setRoleBgColor',
        value: function setRoleBgColor(role) {
            if (role === 'manager') return 'rgb(50, 168, 82)';
            if (role === 'owner') return 'rgb(245, 188, 66)';
            if (role === 'pending' || role === 'unset') return 'rgb(135, 66, 245)';
        }
    }, {
        key: 'toggleCompanyMemberStatus',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var member;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                member = this.props.item;

                                if (!(this.props.isApproved || this.props.item.user.approved)) {
                                    _context.next = 6;
                                    break;
                                }

                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_9__services_companies__["c" /* disapproveUser */])(member);

                            case 4:

                                this.props.updateCompanyMemberStatus(member);
                                return _context.abrupt('return');

                            case 6:
                                _context.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_9__services_companies__["a" /* approveUser */])(member);

                            case 8:

                                this.props.updateCompanyMemberStatus(member);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function toggleCompanyMemberStatus() {
                return _ref.apply(this, arguments);
            }

            return toggleCompanyMemberStatus;
        }()
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (nextState !== this.state) return true;

            if (nextProps !== this.props) {
                this.setState(function () {
                    return {
                        companyRole: nextProps.companyRole
                    };
                });

                return true;
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                item = _props.item,
                banUserById = _props.banUserById,
                unbanUserById = _props.unbanUserById,
                companyRoleMode = _props.companyRoleMode,
                isApproved = _props.isApproved,
                isFilteredByCompany = _props.isFilteredByCompany;

            var isVerifiedEmail = item.user ? item.user.emailVerified : item.emailVerified;
            var emailStatusClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()({
                'verify-email-success': isVerifiedEmail,
                'verify-email-failure': !isVerifiedEmail
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnCSS },
                    item.name || item.user && item.user.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnBigCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */],
                        {
                            to: '/users/' + (item.user && item.user._id || item._id),
                            className: 'common-link'
                        },
                        item.email || item.user && item.user.email
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnCSS },
                    item.role
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnCSS },
                    isFilteredByCompany ? new Date(item.user && item.user.createdAt).toLocaleDateString() : new Date(item.createdAt).toLocaleDateString()
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnCSS },
                    item.company && item.company.name
                ),
                companyRoleMode && this.props.isFilteredByCompany ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        label: this.state.companyRole,
                        labelColor: '#fff',
                        backgroundColor: this.setRoleBgColor(this.state.companyRole),
                        onClick: function onClick() {
                            return _this2.props.toggleCompanyRole(item);
                        }
                    })
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: emailStatusClass },
                        'email',
                        isVerifiedEmail ? ' is ' : ' isn\'t ',
                        'verified'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    _defineProperty({ style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS }, 'style', { textAlign: 'center', padding: '0' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        backgroundColor: isApproved ? 'rgb(250, 76, 52)' : 'rgb(164, 198, 57)',
                        label: isApproved ? 'Disapprove' : 'Approve',
                        labelColor: '#fff',
                        onClick: this.toggleCompanyMemberStatus,
                        disabled: isFilteredByCompany ? false : true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnCSS },
                    !item.banAt ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        label: 'ban',
                        onClick: function onClick() {
                            banUserById(item);
                        },
                        secondary: true
                    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                        label: 'unban',
                        onClick: function onClick() {
                            unbanUserById(item);
                        },
                        primary: true
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Row;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, _ref2) {
    var item = _ref2.item;

    return {
        item: item
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        banUserById: __WEBPACK_IMPORTED_MODULE_7_actions_users__["c" /* banUserById */],
        unbanUserById: __WEBPACK_IMPORTED_MODULE_7_actions_users__["j" /* unbanUserById */]
    }, dispatch);
})(Row);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Row, 'Row', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BanList/Row.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BanList/Row.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3384 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./": 391,
	"./Subscription": 972,
	"./Subscription.js": 972,
	"./index": 391,
	"./index.js": 391
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3384;

/***/ }),
/* 3385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(3386);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var BlackAndWhiteListsPage = function (_React$Component) {
    _inherits(BlackAndWhiteListsPage, _React$Component);

    function BlackAndWhiteListsPage(props) {
        _classCallCheck(this, BlackAndWhiteListsPage);

        return _possibleConstructorReturn(this, (BlackAndWhiteListsPage.__proto__ || Object.getPrototypeOf(BlackAndWhiteListsPage)).call(this, props));
    }

    _createClass(BlackAndWhiteListsPage, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getUserLimitationsList();
            this.props.getUserList({ page: 1 });
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'users-ban', className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                    className: !this.props.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_5_styles_index__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.props.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'Black And White Lists'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */], null)
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return BlackAndWhiteListsPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        isLogged: state.user.isLogged,
        isLoaded: state.users.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getUserList: __WEBPACK_IMPORTED_MODULE_4_actions_users__["e" /* getUserList */],
        getUserLimitationsList: __WEBPACK_IMPORTED_MODULE_4_actions_users__["d" /* getUserLimitationsList */]
    }, dispatch);
})(BlackAndWhiteListsPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BlackAndWhiteListsPage, 'BlackAndWhiteListsPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WhiteList__ = __webpack_require__(3387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BlackList__ = __webpack_require__(3388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SelectedUserInfo__ = __webpack_require__(3389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var TableUsersBan = function (_React$Component) {
    _inherits(TableUsersBan, _React$Component);

    function TableUsersBan(props) {
        _classCallCheck(this, TableUsersBan);

        var _this = _possibleConstructorReturn(this, (TableUsersBan.__proto__ || Object.getPrototypeOf(TableUsersBan)).call(this, props));

        _this.state = {
            page: 1,
            users: [],
            search: '',
            isDataFromAutoComplete: false,
            selectedUser: undefined,
            selected: []
        };

        _this.prevPage = _this.prevPage.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);

        _this.keyPress = _this.keyPress.bind(_this);
        _this.onChange = _this.onChange.bind(_this);

        _this.handleRowSelection = _this.handleRowSelection.bind(_this);

        _this.isSelected = _this.isSelected.bind(_this);
        return _this;
    }

    _createClass(TableUsersBan, [{
        key: 'isSelected',
        value: function isSelected(index) {
            return this.state.selected.indexOf(index) !== -1;
        }
    }, {
        key: 'handleRowSelection',
        value: function handleRowSelection(selectedRows) {
            if (selectedRows.length !== 0) {
                this.setState({
                    selected: selectedRows,
                    selectedUser: this.state.users.find(function (user, indexUser) {
                        return indexUser === selectedRows[0];
                    })
                });
            } else {
                this.setState({
                    selectedUser: this.state.selectedUser
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e, value) {
            var _this2 = this;

            this.setState({
                search: value
            }, function () {
                if (_this2.state.search === '') {
                    _this2.props.getUserList({
                        page: 1
                    });

                    _this2.setState({
                        selected: [],
                        selectedUser: undefined
                    });
                }
            });
        }
    }, {
        key: 'keyPress',
        value: function keyPress(e) {
            var _this3 = this;

            if (e.keyCode === 13) {
                if (this.state.search === '') {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_12_services__["a" /* default */].findUser(this.state.search, true).then(function (response) {
                    _this3.setState({
                        selected: [],
                        selectedUser: undefined
                    }, function () {
                        _this3.props.addUsersFromAutocomplete(response.data);
                    });
                }).catch(function (response) {
                    console.error(response);
                });
            }
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            var _this4 = this;

            this.setState({
                selected: [],
                selectedUser: undefined
            }, function () {
                _this4.props.getUserList({
                    page: _this4.state.next,
                    limit: 25
                });
            });
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            var _this5 = this;

            this.setState({
                selected: [],
                selectedUser: undefined
            }, function () {
                _this5.props.getUserList({
                    page: _this5.state.previous,
                    limit: 25
                });
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                users: nextProps.users.data,
                page: nextProps.users.page || 1,
                previous: nextProps.users.previous,
                next: nextProps.users.next,
                isDataFromAutoComplete: nextProps.users.isDataFromAutoComplete
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var _state = this.state,
                users = _state.users,
                page = _state.page,
                isDataFromAutoComplete = _state.isDataFromAutoComplete,
                selectedUser = _state.selectedUser;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4 middle-xs', style: { display: 'flex' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { width: '100%' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                floatingLabelText: 'Search (min 3 symbols, then push enter)',
                                onChange: this.onChange,
                                onKeyDown: this.keyPress,
                                fullWidth: true
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-2' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: ' center-xs middle-xs', style: { width: '100%', display: 'flex' } },
                            !isDataFromAutoComplete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].navigationLeft,
                                        name: 'navigationLeft',
                                        onClick: this.prevPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Page: ',
                                    page
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui_IconButton___default.a,
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_13_styles__["a" /* default */].navigationRight,
                                        name: 'navigationRight',
                                        onClick: this.nextPage
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            ) : null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-9' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'paper-block' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'table-body' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                                    { onRowSelection: this.handleRowSelection },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                                        { displaySelectAll: false },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                                                null,
                                                'Name'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                                                null,
                                                'Email'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                                                null,
                                                'Company name'
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                                        null,
                                        users.map(function (user, indexUser) {
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                                                { selected: _this6.isSelected(indexUser), key: user._id },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                                                    null,
                                                    user.name
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                                                    null,
                                                    user.email
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                                                    null,
                                                    user.company && user.company.name
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SelectedUserInfo__["a" /* default */], {
                            selectedUser: selectedUser
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__WhiteList__["a" /* default */], {
                            selectedUser: selectedUser
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BlackList__["a" /* default */], {
                            selectedUser: selectedUser
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TableUsersBan;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var users = _ref.users,
        userLimitations = _ref.userLimitations;

    return {
        users: users,
        userLimitations: userLimitations
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getUserList: __WEBPACK_IMPORTED_MODULE_11_actions_users__["e" /* getUserList */],
        addUsersFromAutocomplete: __WEBPACK_IMPORTED_MODULE_11_actions_users__["a" /* addUsersFromAutocomplete */]
    }, dispatch);
})(TableUsersBan);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TableUsersBan, 'TableUsersBan', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/Table.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/Table.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var WhiteList = function (_React$Component) {
    _inherits(WhiteList, _React$Component);

    function WhiteList(props) {
        _classCallCheck(this, WhiteList);

        var _this = _possibleConstructorReturn(this, (WhiteList.__proto__ || Object.getPrototypeOf(WhiteList)).call(this, props));

        _this.state = {
            whiteList: [],
            emails: [],
            searchText: '',
            whiteActive: false,
            filteredList: [],
            filterText: ''
        };

        _this.onUpdateInput = _this.onUpdateInput.bind(_this);

        _this.addItem = _this.addItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);

        _this.onUpdateList = _this.onUpdateList.bind(_this);
        _this.filterList = _this.filterList.bind(_this);
        _this.onToggleWhiteList = _this.onToggleWhiteList.bind(_this);
        return _this;
    }

    _createClass(WhiteList, [{
        key: 'onToggleWhiteList',
        value: function onToggleWhiteList() {
            var _this2 = this;

            this.setState({
                whiteActive: !this.state.whiteActive
            }, function () {
                _this2.props.toggleWhiteList(_this2.props.selectedUser, _this2.state.whiteActive);
            });
        }
    }, {
        key: 'filterList',
        value: function filterList(value) {
            this.setState({
                filterText: value,
                filteredList: this.state.whiteList.filter(function (item) {
                    return item.toLowerCase().includes(value.toLowerCase());
                })
            });
        }
    }, {
        key: 'onUpdateList',
        value: function onUpdateList() {
            if (this.props.selectedUser) {
                this.props.setUserToWhiteList(this.state.whiteList, this.props.selectedUser);
            }
        }
    }, {
        key: 'addItem',
        value: function addItem() {
            var _this3 = this;

            var _state = this.state,
                whiteList = _state.whiteList,
                searchText = _state.searchText;


            if (searchText.length === 0) {
                return;
            }

            if (whiteList.find(function (item) {
                return searchText === item;
            })) {
                return;
            }

            whiteList.push(searchText);

            this.setState({
                whiteList: whiteList,
                emails: [],
                searchText: '',
                filteredList: whiteList.filter(function (item) {
                    return item.toLowerCase().includes(_this3.state.filterText.toLowerCase());
                })
            });
        }
    }, {
        key: 'removeItem',
        value: function removeItem(email) {
            var _this4 = this;

            var whiteList = this.state.whiteList;


            whiteList.splice(whiteList.indexOf(email), 1);

            this.setState({
                whiteList: whiteList,
                filteredList: whiteList.filter(function (item) {
                    return item.toLowerCase().includes(_this4.state.filterText.toLowerCase());
                })
            });
        }
    }, {
        key: 'onUpdateInput',
        value: function onUpdateInput(searchText) {
            var _this5 = this;

            this.setState({
                searchText: searchText
            }, function () {
                if (_this5.state.searchText.length <= 2) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_11_services__["a" /* default */].findUser(searchText, true).then(function (response) {
                    if (response.status === 200) {
                        var emails = response.data.data.map(function (item) {
                            return item.email;
                        });

                        _this5.setState({
                            emails: emails
                        });
                    }
                });
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(_ref) {
            var _this6 = this;

            var selectedUser = _ref.selectedUser;

            if (!selectedUser) {
                return;
            }

            if (selectedUser.limitations) {
                var whiteList = selectedUser.limitations.white.map(function (whiteItem) {
                    return whiteItem.email;
                });

                this.setState({
                    whiteList: whiteList,
                    whiteActive: selectedUser.limitations.whiteActive,
                    filteredList: whiteList.filter(function (item) {
                        return item.toLowerCase().includes(_this6.state.filterText.toLowerCase());
                    })
                });
            } else {
                this.setState({
                    filteredList: [],
                    whiteList: [],
                    emails: [],
                    searchText: '',
                    whiteActive: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var _state2 = this.state,
                filteredList = _state2.filteredList,
                emails = _state2.emails,
                searchText = _state2.searchText,
                filterText = _state2.filterText,
                whiteActive = _state2.whiteActive;
            var selectedUser = this.props.selectedUser;


            if (!selectedUser) {
                return null;
            } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block', style: { fontSize: '12px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute' },
                        'White list'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                floatingLabelText: 'Filter by substring',
                                style: { fontSize: '13px' },
                                value: filterText,
                                onChange: function onChange(e, value) {
                                    _this7.filterList(value);
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-10' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a, {
                                textFieldStyle: __WEBPACK_IMPORTED_MODULE_12_styles__["a" /* default */].autoCompleteCSS,
                                floatingLabelText: 'Email user',
                                searchText: searchText,
                                dataSource: emails,
                                onUpdateInput: function onUpdateInput(searchText) {
                                    _this7.onUpdateInput(searchText);
                                },
                                filter: __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a.noFilter,
                                listStyle: __WEBPACK_IMPORTED_MODULE_12_styles__["a" /* default */].autoCompleteListStyle,
                                fullWidth: true,
                                popoverProps: {
                                    style: { width: 'auto' },
                                    canAutoPosition: true,
                                    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                    targetOrigin: { horizontal: 'left', vertical: 'top' }
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2 middle-xs center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default.a,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                    onClick: function onClick() {
                                        _this7.addItem();
                                    },
                                    color: 'green'
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden' } },
                        filteredList.map(function (email, indexEmail) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: indexEmail, className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-10 middle-xs', style: { display: 'flex', fontSize: '12px' } },
                                    email
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-2 middle-xs center-xs', style: { display: 'flex' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_7_material_ui_IconButton___default.a,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                            onClick: function onClick() {
                                                _this7.removeItem(email);
                                            },
                                            color: 'red'
                                        })
                                    )
                                )
                            );
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12 center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Toggle___default.a, {
                                label: 'On/Off white list',
                                toggled: whiteActive,
                                onToggle: this.onToggleWhiteList
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12 center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                label: 'Update white list',
                                primary: true,
                                onClick: this.onUpdateList
                            })
                        )
                    )
                );
            }
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return WhiteList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref2, _ref3) {
    var selectedUser = _ref3.selectedUser;

    _objectDestructuringEmpty(_ref2);

    return {
        selectedUser: selectedUser
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        setUserToWhiteList: __WEBPACK_IMPORTED_MODULE_10_actions_users__["h" /* setUserToWhiteList */],
        toggleWhiteList: __WEBPACK_IMPORTED_MODULE_10_actions_users__["i" /* toggleWhiteList */]
    }, dispatch);
})(WhiteList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(WhiteList, 'WhiteList', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/WhiteList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/WhiteList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_users__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var BlackList = function (_React$Component) {
    _inherits(BlackList, _React$Component);

    function BlackList(props) {
        _classCallCheck(this, BlackList);

        var _this = _possibleConstructorReturn(this, (BlackList.__proto__ || Object.getPrototypeOf(BlackList)).call(this, props));

        _this.state = {
            blackList: [],
            emails: [],
            searchText: '',

            filteredList: [],
            filterText: ''
        };

        _this.onUpdateInput = _this.onUpdateInput.bind(_this);

        _this.addItem = _this.addItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);

        _this.onUpdateList = _this.onUpdateList.bind(_this);
        _this.filterList = _this.filterList.bind(_this);
        return _this;
    }

    _createClass(BlackList, [{
        key: 'filterList',
        value: function filterList(value) {
            this.setState({
                filterText: value,
                filteredList: this.state.blackList.filter(function (item) {
                    return item.toLowerCase().includes(value.toLowerCase());
                })
            });
        }
    }, {
        key: 'onUpdateList',
        value: function onUpdateList() {
            if (this.props.selectedUser) {
                this.props.setUserToBlackList(this.state.blackList, this.props.selectedUser);
            }
        }
    }, {
        key: 'addItem',
        value: function addItem() {
            var _this2 = this;

            var _state = this.state,
                blackList = _state.blackList,
                searchText = _state.searchText;


            if (searchText.length === 0) {
                return;
            }

            if (blackList.find(function (item) {
                return searchText === item;
            })) {
                return;
            }

            blackList.push(searchText);

            this.setState({
                blackList: blackList,
                emails: [],
                searchText: '',
                filteredList: blackList.filter(function (item) {
                    return item.toLowerCase().includes(_this2.state.filterText.toLowerCase());
                })
            });
        }
    }, {
        key: 'removeItem',
        value: function removeItem(email) {
            var _this3 = this;

            var blackList = this.state.blackList;


            blackList.splice(blackList.indexOf(email), 1);

            this.setState({
                blackList: blackList,
                filteredList: blackList.filter(function (item) {
                    return item.toLowerCase().includes(_this3.state.filterText.toLowerCase());
                })
            });
        }
    }, {
        key: 'onUpdateInput',
        value: function onUpdateInput(searchText) {
            var _this4 = this;

            this.setState({
                searchText: searchText
            }, function () {
                if (_this4.state.searchText.length <= 2) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].findUser(searchText, true).then(function (response) {
                    if (response.status === 200) {
                        var emails = response.data.data.map(function (item) {
                            return item.email;
                        });

                        _this4.setState({
                            emails: emails
                        });
                    }
                });
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(_ref) {
            var _this5 = this;

            var selectedUser = _ref.selectedUser;

            if (!selectedUser) {
                return;
            }

            if (selectedUser.limitations) {
                var blackList = selectedUser.limitations.black.map(function (blackItem) {
                    return blackItem.email;
                });

                this.setState({
                    blackList: blackList,
                    filteredList: blackList.filter(function (item) {
                        return item.toLowerCase().includes(_this5.state.filterText.toLowerCase());
                    })
                });
            } else {
                this.setState({
                    blackList: [],
                    emails: [],
                    searchText: '',
                    filteredList: []
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var _state2 = this.state,
                filteredList = _state2.filteredList,
                emails = _state2.emails,
                searchText = _state2.searchText,
                filterText = _state2.filterText;
            var selectedUser = this.props.selectedUser;


            if (!selectedUser) {
                return null;
            } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block', style: { fontSize: '12px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute' },
                        'Black list'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                floatingLabelText: 'Filter by substring',
                                style: { fontSize: '13px' },
                                value: filterText,
                                onChange: function onChange(e, value) {
                                    _this6.filterList(value);
                                }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-10' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a, {
                                textFieldStyle: __WEBPACK_IMPORTED_MODULE_11_styles__["a" /* default */].autoCompleteCSS,
                                floatingLabelText: 'Email user',
                                searchText: searchText,
                                dataSource: emails,
                                onUpdateInput: function onUpdateInput(searchText) {
                                    _this6.onUpdateInput(searchText);
                                },
                                filter: __WEBPACK_IMPORTED_MODULE_3_material_ui_AutoComplete___default.a.noFilter,
                                listStyle: __WEBPACK_IMPORTED_MODULE_11_styles__["a" /* default */].autoCompleteListStyle,
                                fullWidth: true,
                                popoverProps: {
                                    style: { width: 'auto' },
                                    canAutoPosition: true,
                                    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                    targetOrigin: { horizontal: 'left', vertical: 'top' }
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2 middle-xs center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                    onClick: function onClick() {
                                        _this6.addItem();
                                    },
                                    color: 'green'
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden' } },
                        filteredList.map(function (email, indexEmail) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: indexEmail, className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-10 middle-xs', style: { display: 'flex', fontSize: '12px' } },
                                    email
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-xs-2 middle-xs center-xs', style: { display: 'flex' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui_IconButton___default.a,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                            onClick: function onClick() {
                                                _this6.removeItem(email);
                                            },
                                            color: 'red'
                                        })
                                    )
                                )
                            );
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12 center-xs', style: { display: 'flex' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                label: 'Update black list',
                                primary: true,
                                onClick: this.onUpdateList
                            })
                        )
                    )
                );
            }
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return BlackList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref2, _ref3) {
    var selectedUser = _ref3.selectedUser;

    _objectDestructuringEmpty(_ref2);

    return {
        selectedUser: selectedUser
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        setUserToBlackList: __WEBPACK_IMPORTED_MODULE_9_actions_users__["g" /* setUserToBlackList */]
    }, dispatch);
})(BlackList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BlackList, 'BlackList', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/BlackList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/BlackList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SelectedUserInfo = function (_React$Component) {
    _inherits(SelectedUserInfo, _React$Component);

    function SelectedUserInfo(props) {
        _classCallCheck(this, SelectedUserInfo);

        return _possibleConstructorReturn(this, (SelectedUserInfo.__proto__ || Object.getPrototypeOf(SelectedUserInfo)).call(this, props));
    }

    _createClass(SelectedUserInfo, [{
        key: 'render',
        value: function render() {
            var selectedUser = this.props.selectedUser;


            if (!selectedUser) {
                return null;
            } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block', style: { fontSize: '12px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block absolute' },
                        'Selected user'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        ' Name - ',
                        selectedUser.name ? selectedUser.name : '',
                        ' '
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        ' Email - ',
                        selectedUser.email ? selectedUser.email : '',
                        '  '
                    )
                );
            }
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SelectedUserInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = SelectedUserInfo;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SelectedUserInfo, 'SelectedUserInfo', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/SelectedUserInfo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/BlackAndWhiteLists/SelectedUserInfo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = SuspiciousSessionsPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Slider__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Slider__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










function SuspiciousSessionsPage() {
    var onSelect = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(indexes) {
            var item;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(indexes.length == 0)) {
                                _context.next = 4;
                                break;
                            }

                            setSelected(undefined);
                            setAdditionalInfo(undefined);
                            return _context.abrupt("return");

                        case 4:
                            item = items[indexes];

                            setSelected(item);
                            setAdditionalInfo(undefined);
                            loadSpecificUser(item._id);

                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function onSelect(_x) {
            return _ref3.apply(this, arguments);
        };
    }();

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        items = _useState2[0],
        setItems = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState4 = _slicedToArray(_useState3, 2),
        page = _useState4[0],
        setPage = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(4),
        _useState6 = _slicedToArray(_useState5, 2),
        minSessions = _useState6[0],
        setMinSessions = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
        _useState8 = _slicedToArray(_useState7, 2),
        selectedAcc = _useState8[0],
        setSelected = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
        _useState10 = _slicedToArray(_useState9, 2),
        selectedAccInfo = _useState10[0],
        setAdditionalInfo = _useState10[1];

    function loadUsers(nextPage, minSessions) {
        if (items.length == 0 && nextPage > page) {
            return;
        }
        nextPage = Math.max(1, nextPage);

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/api/v2/stats/concurrent-sessions", {
            params: {
                page: nextPage,
                minSessions: minSessions
            }
        }).then(function (resp) {
            setItems(resp.data.data);
            setPage(nextPage);
        });
    }

    function loadSpecificUser(userId) {
        Promise.all([__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/api/v2/stats/concurrent-sessions", { params: { userId: userId } }).then(function (resp) {
            return resp.data.data[0];
        }), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/socket.io/api/activeSessions", { params: { userId: userId } }).then(function (resp) {
            return resp.data;
        }).catch(function () {
            return null;
        })]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                info = _ref2[0],
                sockets = _ref2[1];

            var items = __WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"](info.perHour, function (i) {
                return i.hour;
            });

            info.perHour = [];
            var format = "YYYY-MM-DD HH";
            if (items.length > 0) {
                var _loop = function _loop(date) {
                    var cTime = date.format(format);
                    var item = items.find(function (i) {
                        return i.hour == cTime;
                    });
                    if (item) {
                        info.perHour.push(item);
                        items.shift();
                    } else {
                        info.perHour.push({ hour: cTime, sessions: [] });
                    }
                };

                for (var date = __WEBPACK_IMPORTED_MODULE_3_moment__["utc"](items[0].hour, format); date.isBefore(__WEBPACK_IMPORTED_MODULE_3_moment__()); date.add(1, "hour")) {
                    _loop(date);
                }
            }

            info.currentStatus = sockets;

            setAdditionalInfo(info);
        });
    }

    function onMinSessionsChanged(e, val) {
        setMinSessions(val);
        setPage(1);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        loadUsers(page, minSessions);
    }, [minSessions]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h3",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { className: "text-center" },
                "Suspicious user sessions"
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { height: "30px", display: "flex", alignItems: "center" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { display: "flex", justifyContent: "space-around", alignItems: "center", width: "200px", height: "100%" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    { onClick: function onClick() {
                            return loadUsers(page - 1, minSessions);
                        } },
                    "Prev"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    page
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    { onClick: function onClick() {
                            return loadUsers(page + 1, minSessions);
                        } },
                    "Next"
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    "Min sessions: ",
                    minSessions
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Slider___default.a, { value: minSessions, onChange: onMinSessionsChanged,
                    min: 1, max: 10, step: 1, style: { width: 200, height: "100%" }, axis: "x",
                    sliderStyle: { margin: 0 }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "col-md-5" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SuspiciousUserTable, { items: items, selected: selectedAcc, onSelection: onSelect })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "col-md-7" },
                selectedAcc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Details, { account: selectedAcc, info: selectedAccInfo })
            )
        )
    );
}

function SuspiciousUserTable(_ref4) {
    var items = _ref4.items,
        selected = _ref4.selected,
        onSelection = _ref4.onSelection;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["Table"],
        {
            fixedHeader: true,
            selectable: true,
            onRowSelection: onSelection
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeader"],
            {
                adjustForCheckbox: true
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                    { tooltip: "Name" },
                    "Name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                    { tooltip: "Email" },
                    "Email"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                    { tooltip: "Company" },
                    "Company"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableHeaderColumn"],
                    { tooltip: "Sessions" },
                    "Sessions"
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableBody"],
            {
                displayRowCheckbox: true,
                deselectOnClickaway: false
            },
            items.map(function (item) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRow"],
                    { key: item._id, selected: item == selected },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                        null,
                        value(item.user.name)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                        null,
                        value(item.user.email)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                        null,
                        value(item.user.company && item.user.company.name)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui_Table__["TableRowColumn"],
                        null,
                        value(item.maxSessions)
                    )
                );
            })
        )
    );
}

function value(val) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { title: val },
        val
    );
}

function Details(_ref5) {
    var account = _ref5.account,
        info = _ref5.info;

    console.log(info);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: "flex", flexDirection: "row", paddingLeft: "1.5em" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { flex: "1", display: "flex", flexDirection: "column", lineHeight: "2" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "b",
                        null,
                        "Name:"
                    ),
                    " ",
                    account.user.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "b",
                        null,
                        "Company:"
                    ),
                    " ",
                    account.user.company && account.user.company.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "b",
                        null,
                        "Email:"
                    ),
                    " ",
                    account.user.email
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { flex: "1", display: "flex", flexDirection: "column", lineHeight: "2" } },
                info && info.currentStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "b",
                            null,
                            "Connections:"
                        ),
                        " ",
                        info.currentStatus.connectionCount
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "b",
                            null,
                            "Sessions:"
                        ),
                        " ",
                        info.currentStatus.sessions.join(", ")
                    )
                )
            )
        ),
        info && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BaseChart, { items: info.perHour.map(function (h) {
                    return [h.hour, h.sessions.length];
                }) })
        )
    );
}

function BaseChart(_ref6) {
    var items = _ref6.items;

    var chartRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var chart = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        chart.current = createChart([], []);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var _drawChart = drawChart(items),
            _drawChart2 = _slicedToArray(_drawChart, 2),
            labels = _drawChart2[0],
            datasets = _drawChart2[1];

        updateChart(chart.current, labels, datasets);
    }, [items]);

    function drawChart(items) {
        var labels = [];
        var points = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _item = _step.value;

                labels.push(_item[0]);
                points.push(_item[1]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var datasets = [{
            label: "Unique sessions",
            backgroundColor: "rgba(135, 197, 239, 0.5)",
            borderColor: "rgb(54, 162, 235)",
            data: points
        }];

        return [labels, datasets];
    }

    function updateChart(chart, labels, datasets) {
        chart.clear();
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update();

        return chart;
    }

    function createChart(labels, datasets) {
        var ctx = chartRef.current.getContext("2d");
        var chart = new __WEBPACK_IMPORTED_MODULE_5_chart_js___default.a(ctx, {
            type: "line",
            data: {
                labels: labels,
                datasets: datasets
            },
            options: {
                tooltips: {
                    mode: "label"
                },
                scales: {
                    xAxes: [{
                        stacked: true

                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            min: 0
                        }
                    }]
                }
            }
        });

        return chart;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("canvas", { ref: chartRef });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SuspiciousSessionsPage, "SuspiciousSessionsPage", "/opt/atlassian/pipelines/agent/build/client/app/components/Users/SuspiciousSessions/Page.jsx");
    reactHotLoader.register(SuspiciousUserTable, "SuspiciousUserTable", "/opt/atlassian/pipelines/agent/build/client/app/components/Users/SuspiciousSessions/Page.jsx");
    reactHotLoader.register(value, "value", "/opt/atlassian/pipelines/agent/build/client/app/components/Users/SuspiciousSessions/Page.jsx");
    reactHotLoader.register(Details, "Details", "/opt/atlassian/pipelines/agent/build/client/app/components/Users/SuspiciousSessions/Page.jsx");
    reactHotLoader.register(BaseChart, "BaseChart", "/opt/atlassian/pipelines/agent/build/client/app/components/Users/SuspiciousSessions/Page.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconMenu__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_IconMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_IconMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_virtualized_dist_es_AutoSizer__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_virtualized_dist_es_List__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_virtualized_dist_es_ScrollSync__ = __webpack_require__(3392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_image_edit__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_image_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_image_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_content_delete_sweep__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_content_delete_sweep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_content_delete_sweep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_navigation_more_vert__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_navigation_more_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_navigation_more_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Base_AwaitableBtn__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__service__ = __webpack_require__(3394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_services_gazetters__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_helpers_index__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss__ = __webpack_require__(3395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HOC__ = __webpack_require__(3396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




































var DynamicKey = function () {
    function DynamicKey() {
        _classCallCheck(this, DynamicKey);

        this.KEY = Symbol('dynamic key');
        this.value = 1;
    }

    /**
     * @private
     */


    _createClass(DynamicKey, [{
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }, {
        key: 'next',
        get: function get() {
            this.value += 1;return this.value;
        }
    }]);

    return DynamicKey;
}();

var GazetteerEditorPage = function GazetteerEditorPage(_ref) {
    var saveContentMutation = _ref.saveContentMutation,
        isSavingContent = _ref.isSavingContent,
        isSaveContentSuccess = _ref.isSaveContentSuccess;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        defData = _useState2[0],
        setDefData = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        defView = _useState4[0],
        setDefView = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState6 = _slicedToArray(_useState5, 2),
        defVersion = _useState6[0],
        setDefVersion = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState8 = _slicedToArray(_useState7, 2),
        selectedLst = _useState8[0],
        setSelectedLst = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(new Map()),
        _useState10 = _slicedToArray(_useState9, 2),
        defIndex = _useState10[0],
        setDefIndex = _useState10[1];

    var lstData = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var lstView = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(new Map()),
        _useState12 = _slicedToArray(_useState11, 2),
        lstIndex = _useState12[0],
        setLstIndex = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState14 = _slicedToArray(_useState13, 2),
        lstDuplicatesCount = _useState14[0],
        setLstDuplicatesCount = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState16 = _slicedToArray(_useState15, 2),
        selectedDefKey = _useState16[0],
        setSelectedDefKey = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
        _useState18 = _slicedToArray(_useState17, 2),
        selectedLstVersion = _useState18[0],
        setSelectedLstVersion = _useState18[1];

    var columns = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Set());
    var lstLocalVersion = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
    var isNewFeatureNameValid = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);

    var dKey = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new DynamicKey()).current;
    var defList = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var lstList = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var featureNameRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var invalidDefRows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Set());
    var invalidRows = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Set());
    var originalLstData = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);
    var originalLstIndex = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Map());
    var gazetteersChanged = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);
    var originalColumns = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(new Set());

    // hook to replicate this.forceUpdate() to preserve the original component's logic

    var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (x) {
        return x + 1;
    }, 0),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        forceUpdate = _useReducer2[1];

    var prepareData = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (items) {
        var map = new Map();
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (!item[dKey.KEY]) {
                item[dKey.KEY] = dKey.next;
            }
            map.set(item[dKey.KEY], item);
        }
        return map;
    }, [dKey]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var init = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _ref3, _ref4, data;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_21_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_18__service__["e" /* loadDefFile */]);

                            case 2:
                                _ref3 = _context.sent;
                                _ref4 = _slicedToArray(_ref3, 2);
                                data = _ref4[1];

                                setDefIndex(prepareData(data));
                                setDefData(data);
                                setDefView([].concat(_toConsumableArray(data)));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function init() {
                return _ref2.apply(this, arguments);
            };
        }();
        init();
        return function () {
            gazetteersChanged.current = [];
        };
    }, [prepareData]);

    var recalculateRowChanges = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (indexOverride) {
        var currentChanges = gazetteersChanged.current;
        var renames = currentChanges.filter(function (c) {
            return c.status === 'renameFeature';
        });
        var newRowChanges = [];

        // 1. calculate 'new' and 'replace' changes by iterating current data
        lstData.current.forEach(function (currentItem) {
            var key = currentItem[dKey.KEY];
            var originalItem = originalLstIndex.current.get(key);

            if (!originalItem) {
                // this is a new row
                var features = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(currentItem);
                delete features[dKey.KEY];
                delete features.$value;
                newRowChanges.push({
                    key: key, status: 'new', value: currentItem.$value, lastFeatures: features
                });
                return;
            }

            // for existing rows, "un-project" the current item to compare with the original
            var unprojectedCurrent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(currentItem);
            [].concat(_toConsumableArray(renames)).reverse().forEach(function (rename) {
                if (unprojectedCurrent.hasOwnProperty(rename.value)) {
                    unprojectedCurrent[rename.oldValue] = unprojectedCurrent[rename.value];
                    delete unprojectedCurrent[rename.value];
                }
            });

            var allKeys = new Set([].concat(_toConsumableArray(Object.keys(originalItem)), _toConsumableArray(Object.keys(unprojectedCurrent))));
            var normalizedOriginal = {};
            var normalizedCurrent = {};

            allKeys.forEach(function (key) {
                var originalValue = originalItem[key];
                var currentValue = unprojectedCurrent[key];
                var isNewKey = !originalItem.hasOwnProperty(key);

                if (isNewKey && (currentValue === null || currentValue === undefined || currentValue === '')) {
                    return;
                }
                normalizedOriginal[key] = originalValue === null || originalValue === undefined ? '' : originalValue;
                normalizedCurrent[key] = currentValue === null || currentValue === undefined ? '' : currentValue;
            });

            if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(normalizedCurrent, normalizedOriginal)) {
                var _features = {};
                columns.current.forEach(function (colName) {
                    if (currentItem.hasOwnProperty(colName)) {
                        _features[colName] = currentItem[colName];
                    }
                });
                if (currentItem.$value === originalItem.$value) {
                    newRowChanges.push({
                        key: key, status: 'replace', value: currentItem.$value, lastFeatures: _features
                    });
                } else {
                    newRowChanges.push({
                        key: key, status: 'replace', value: currentItem.$value, oldValue: originalItem.$value, lastFeatures: _features
                    });
                }
            }
        });

        // 2. calculate 'remove' changes by iterating original data
        originalLstData.current.forEach(function (originalItem) {
            var key = originalItem[dKey.KEY];
            var indexToUse = indexOverride || lstIndex;
            if (!indexToUse.get(key)) {
                newRowChanges.push({ key: key, status: 'remove', value: originalItem.$value });
            }
        });

        // 3. combine rename records with the newly calculated row changes
        gazetteersChanged.current = [].concat(_toConsumableArray(renames), newRowChanges);
        forceUpdate();
    }, [dKey.KEY, lstData.current, lstIndex]);

    var _updateGazetteerChanges = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_ref5) {
        var type = _ref5.type,
            payload = _ref5.payload;

        var newChanges = gazetteersChanged.current;

        if (type === 'FEATURE_RENAMED') {
            var oldName = payload.oldName,
                newName = payload.newName;


            newChanges.forEach(function (change) {
                if (change.lastFeatures && change.lastFeatures.hasOwnProperty(oldName)) {
                    change.lastFeatures[newName] = change.lastFeatures[oldName];
                    delete change.lastFeatures[oldName];
                }
            });

            var existingRenameIndex = newChanges.findIndex(function (c) {
                return c.status === 'renameFeature' && c.value === oldName;
            });

            if (existingRenameIndex > -1) {
                var existingRename = newChanges[existingRenameIndex];
                if (existingRename.oldValue === newName) {
                    newChanges.splice(existingRenameIndex, 1);
                } else {
                    existingRename.value = newName;
                }
            } else if (oldName !== newName) {
                newChanges.push({ status: 'renameFeature', value: newName, oldValue: oldName });
            }
        }
    }, []);

    var onDownloadLst = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var content = Object(__WEBPACK_IMPORTED_MODULE_18__service__["a" /* buildLst */])(lstData.current, columns.current);
        var url = window.URL.createObjectURL(new window.Blob([content], { type: 'text/plain' }));
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('download', selectedLst);
        element.click();
        window.URL.revokeObjectURL(url);
    }, [selectedLst]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (isSaveContentSuccess) {
            originalLstData.current = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(lstData.current);
            originalColumns.current = new Set(columns.current);
            originalLstIndex.current = prepareData(originalLstData.current);
            gazetteersChanged.current = [];
            forceUpdate();
        }
    }, [isSaveContentSuccess, prepareData]);

    var onSaveLst = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var emptyFeatures;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        if (gazetteersChanged.current.length) {
                            _context2.next = 2;
                            break;
                        }

                        return _context2.abrupt('return');

                    case 2:
                        emptyFeatures = Object(__WEBPACK_IMPORTED_MODULE_18__service__["d" /* getEmptyFeatures */])(lstData.current, columns.current);

                        if (!(emptyFeatures.length > 0)) {
                            _context2.next = 6;
                            break;
                        }

                        Object(__WEBPACK_IMPORTED_MODULE_24_helpers__["c" /* showNotification */])('Gazetteer ' + selectedLst + ' has empty features: ' + emptyFeatures.join(', ') + '. \nRemove them or fill with at least one value per feature.', 'error');
                        return _context2.abrupt('return');

                    case 6:
                        _context2.next = 8;
                        return saveContentMutation({
                            gazetterName: selectedLst,
                            values: gazetteersChanged.current
                        });

                    case 8:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    })), [selectedLst, saveContentMutation]);

    var onSaveDef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _ref8, _ref9, _newVersion, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (!(invalidDefRows.current.size > 0)) {
                            _context3.next = 3;
                            break;
                        }

                        Object(__WEBPACK_IMPORTED_MODULE_24_helpers__["c" /* showNotification */])('File has ' + invalidDefRows.current.size + ' error(s)! Fix them before saving def.', 'error');
                        return _context3.abrupt('return');

                    case 3:
                        _context3.next = 5;
                        return Object(__WEBPACK_IMPORTED_MODULE_21_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_18__service__["h" /* saveDef */], defVersion, defData);

                    case 5:
                        _ref8 = _context3.sent;
                        _ref9 = _slicedToArray(_ref8, 2);
                        _newVersion = _ref9[0];
                        data = _ref9[1];


                        setDefIndex(prepareData(data));
                        setDefData(data);
                        setDefView([].concat(_toConsumableArray(data)));
                        setDefVersion(_newVersion);

                    case 13:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    })), [defData, defVersion, prepareData]);

    var loadLst = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(defEntry) {
            var version, items, _ref12, _ref13, liveIndex, duplicatesCount, newColumns;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            gazetteersChanged.current = [];
                            invalidRows.current.clear();

                            version = void 0;
                            items = [_defineProperty({}, dKey.KEY, dKey.next)];
                            _context4.prev = 4;
                            _context4.next = 7;
                            return Object(__WEBPACK_IMPORTED_MODULE_21_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_18__service__["f" /* loadLstFile */], defEntry.fileName);

                        case 7:
                            _ref12 = _context4.sent;
                            _ref13 = _slicedToArray(_ref12, 2);
                            version = _ref13[0];
                            items = _ref13[1];
                            _context4.next = 15;
                            break;

                        case 13:
                            _context4.prev = 13;
                            _context4.t0 = _context4['catch'](4);

                        case 15:
                            liveIndex = prepareData(items);


                            originalLstData.current = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(items);
                            originalLstIndex.current = prepareData(originalLstData.current);

                            duplicatesCount = Object(__WEBPACK_IMPORTED_MODULE_18__service__["b" /* calculateDuplicateEntries */])(items);
                            newColumns = Object(__WEBPACK_IMPORTED_MODULE_18__service__["c" /* getColumns */])(items);

                            newColumns.delete('$value');
                            columns.current = newColumns;
                            originalColumns.current = new Set(columns.current);

                            lstLocalVersion.current = 0;
                            lstData.current = items;
                            lstView.current = [].concat(_toConsumableArray(items));
                            setLstIndex(liveIndex);
                            setLstDuplicatesCount(duplicatesCount);
                            setSelectedDefKey(defEntry[dKey.KEY]);
                            setSelectedLstVersion(version);
                            setSelectedLst(defEntry.fileName);
                            gazetteersChanged.current = [];

                        case 32:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this, [[4, 13]]);
        }));

        return function (_x) {
            return _ref10.apply(this, arguments);
        };
    }(), [dKey, prepareData]);

    var onDedupLst = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var defEntry;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_21_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_18__service__["g" /* removeDuplicates */], selectedLst);

                    case 2:
                        defEntry = defIndex.get(selectedDefKey);

                        if (!defEntry) {
                            _context5.next = 7;
                            break;
                        }

                        _context5.next = 6;
                        return loadLst(defEntry);

                    case 6:
                        gazetteersChanged.current = [];

                    case 7:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    })), [defIndex, selectedDefKey, selectedLst, loadLst]);

    var getValKey = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, key) {
        return field + ':' + key;
    }, []);

    var addInvalidMark = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (invRows) {
        var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        var value = getValKey(field, key);
        invRows.add(value);
    }, [getValKey]);

    var removeInvalidMark = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (invRows) {
        var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        var escapedField = __WEBPACK_IMPORTED_MODULE_20_helpers_index__["a" /* default */].escapeRegExp(field);
        var escapedKey = __WEBPACK_IMPORTED_MODULE_20_helpers_index__["a" /* default */].escapeRegExp(key);
        var keyReg = escapedField + ':' + escapedKey;
        invRows.forEach(function (invalidRow) {
            if (invalidRow.match(keyReg)) {
                invRows.delete(invalidRow);
            }
        });
    }, []);

    var onDefCellChanged = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e, value) {
        var el = e.target;
        if (value === undefined) value = el.value;
        var field = el.dataset.field;
        var index = parseInt(el.closest('[data-key]').dataset.key);

        if (__WEBPACK_IMPORTED_MODULE_18__service__["i" /* validator */].defValue(value)) {
            el.classList.remove('invalid');
            removeInvalidMark(invalidDefRows.current, field, index.toString());
        } else {
            el.classList.add('invalid');
            addInvalidMark(invalidDefRows.current, field, index.toString());
        }

        var item = defIndex.get(index);
        if (item) {
            item[field] = value;
        }
    }, [defIndex, addInvalidMark, removeInvalidMark]);

    var onLstCellChanged = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e, value) {
        var el = e.target;
        if (value === undefined) value = el.value;
        var field = el.dataset.field;
        var key = parseInt(el.closest('[data-key]').dataset.key);

        var validatorFn = field === '$value' ? __WEBPACK_IMPORTED_MODULE_18__service__["i" /* validator */].lstValue : __WEBPACK_IMPORTED_MODULE_18__service__["i" /* validator */].lstFeature;
        if (validatorFn(value)) {
            el.classList.remove('invalid');
            removeInvalidMark(invalidRows.current, field, key.toString());
        } else {
            el.classList.add('invalid');
            addInvalidMark(invalidRows.current, field, key.toString());
        }

        var item = lstIndex.get(key);
        if (item) {
            item[field] = value;
            // no need to setLstData, just trigger recalculation
            recalculateRowChanges();
        }
    }, [lstIndex, recalculateRowChanges, addInvalidMark, removeInvalidMark]);

    var onLoadLst = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e) {
            var el, key, defEntry;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            el = e.target;
                            key = parseInt(el.closest('[data-key]').dataset.key);
                            defEntry = defIndex.get(key);

                            if (!defEntry) {
                                _context6.next = 6;
                                break;
                            }

                            _context6.next = 6;
                            return loadLst(defEntry);

                        case 6:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this);
        }));

        return function (_x6) {
            return _ref15.apply(this, arguments);
        };
    }(), [defIndex, loadLst]);

    var onAddFeature = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var textEdit = featureNameRef.current;
        if (columns.current && textEdit) {
            var featureName = textEdit.getValue().trim();

            isNewFeatureNameValid.current = __WEBPACK_IMPORTED_MODULE_18__service__["i" /* validator */].lstFeature(featureName);
            if (!isNewFeatureNameValid.current || featureName === '') {
                forceUpdate();
                return;
            }

            textEdit.input.value = '';
            if (!featureName) {
                return alert('You should write valid feature name first');
            }
            columns.current.add(featureName);
            lstLocalVersion.current++;
            forceUpdate();
        }
    }, []);

    var onAddLstEntry = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _newRow;

        var newRow = (_newRow = {}, _defineProperty(_newRow, dKey.KEY, dKey.next), _defineProperty(_newRow, '$value', ''), _newRow);
        lstData.current.push(newRow);
        lstView.current = [].concat(_toConsumableArray(lstData.current));
        var newIndex = prepareData(lstData.current);
        setLstIndex(newIndex);

        recalculateRowChanges(newIndex);

        setTimeout(function () {
            if (lstList.current) {
                lstList.current.scrollToRow(lstData.current.length);
            }
        });
    }, [dKey, prepareData, recalculateRowChanges]);

    var onDeleteLstEntry = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        var el = e.target;
        var key = parseInt(el.closest('[data-key]').dataset.key);

        removeInvalidMark(invalidRows.current, '', key.toString());

        var itemToRemove = lstIndex.get(key);
        lstData.current = lstData.current.filter(function (item) {
            return item !== itemToRemove;
        });
        lstView.current = lstData.current.filter(function (item) {
            return item !== itemToRemove;
        });
        var newIndex = prepareData(lstData.current);
        setLstIndex(newIndex);

        lstLocalVersion.current++;
        recalculateRowChanges(newIndex);
    }, [prepareData, removeInvalidMark, recalculateRowChanges]);

    var onAddDefRow = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var _row;

        var row = (_row = {}, _defineProperty(_row, dKey.KEY, dKey.next), _defineProperty(_row, 'fileName', ''), _defineProperty(_row, 'majorType', ''), _defineProperty(_row, 'minorType', ''), _defineProperty(_row, 'language', ''), _defineProperty(_row, 'local', true), _row);
        defData.push(row);
        defIndex.set(row[dKey.KEY], row);
        setDefView([].concat(_toConsumableArray(defData)));
        forceUpdate();
        setTimeout(function () {
            if (defList.current) {
                defList.current.scrollBy(0, Number.MAX_SAFE_INTEGER);
            }
        });
    }, [dKey, defData, defIndex]);

    var onDeleteDefEntry = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        var el = e.target;
        var index = parseInt(el.closest('[data-key]').dataset.key);
        var itemToDelete = defIndex.get(index);
        if (!confirm('Are you sure to remove ' + itemToDelete.fileName)) {
            return;
        }
        var newDefData = defData.filter(function (item) {
            return item !== itemToDelete;
        });
        setDefData(newDefData);
        setDefView([].concat(_toConsumableArray(newDefData)));
        defIndex.delete(index);
        forceUpdate();
    }, [defData, defIndex]);

    var updateInvalidMark = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (invRows, oldField, newField) {
        var escaped = __WEBPACK_IMPORTED_MODULE_20_helpers_index__["a" /* default */].escapeRegExp(oldField);
        var keyReg = escaped + ':([^:]+)';
        invRows.forEach(function (invalidRow) {
            var match = invalidRow.match(keyReg);
            if (match) {
                invRows.delete(invalidRow);
                invRows.add(getValKey(newField, match[1]));
            }
        });
    }, [getValKey]);

    var onLstFeatureChanged = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (oldValue, newValue) {
        var remove = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (remove) {
            if (!originalColumns.current.has(oldValue)) {
                // new feature being deleted
                // 1. remove the feature from all existing change records
                gazetteersChanged.current.forEach(function (change) {
                    if (change.lastFeatures && change.lastFeatures.hasOwnProperty(oldValue)) {
                        delete change.lastFeatures[oldValue];
                    }
                });

                // 2. remove the column from the live data model
                columns.current.delete(oldValue);
                lstData.current.forEach(function (item) {
                    delete item[oldValue];
                });

                // 3. re-evaluate all changes to see if any are now void
                var stillChanged = gazetteersChanged.current.filter(function (change) {
                    if (change.status === 'remove' || change.status === 'renameFeature') {
                        return true;
                    }
                    var originalItem = originalLstIndex.current.get(change.key);
                    var currentItem = lstData.current.find(function (item) {
                        return item[dKey.KEY] === change.key;
                    });

                    if (originalItem && currentItem) {
                        var cleanCurrent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(currentItem);
                        delete cleanCurrent[dKey.KEY];
                        delete cleanCurrent.$value;

                        var cleanOriginal = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(originalItem);
                        delete cleanOriginal[dKey.KEY];
                        delete cleanOriginal.$value;

                        return !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(cleanCurrent, cleanOriginal);
                    }
                    return change.status === 'new' && currentItem;
                });
                gazetteersChanged.current = stillChanged;
            } else {
                // this is an original feature -> remove it visually
                columns.current.delete(oldValue);
                gazetteersChanged.current.push({ status: 'deleteFeature', value: oldValue });
            }

            lstLocalVersion.current++;
            removeInvalidMark(invalidRows.current, oldValue);
            forceUpdate();
            return;
        }

        if (!newValue || !columns.current.has(oldValue) || columns.current.has(newValue)) {
            forceUpdate();
            return;
        }

        // 1. mutate the live data structures FIRST
        updateInvalidMark(invalidRows.current, oldValue, newValue);
        var cols = Array.from(columns.current);
        var index = cols.indexOf(oldValue);
        cols[index] = newValue;
        columns.current = new Set(cols);

        lstData.current.forEach(function (item) {
            item[newValue] = item[oldValue];
            delete item[oldValue];
        });

        // 2. update the rename records based on the action
        var isOriginalFeature = originalColumns.current.has(oldValue);
        var isPreviouslyRenamedFeature = gazetteersChanged.current.some(function (c) {
            return c.status === 'renameFeature' && c.value === oldValue;
        });

        if (isOriginalFeature || isPreviouslyRenamedFeature) {
            _updateGazetteerChanges({ type: 'FEATURE_RENAMED', payload: { oldName: oldValue, newName: newValue } });
        }

        // 3. with all data consistent, recalculate all row changes
        recalculateRowChanges();

        // 4. finally, trigger the re-render
        lstLocalVersion.current++;
        forceUpdate();
    }, [recalculateRowChanges, lstData.current, removeInvalidMark, updateInvalidMark, dKey.KEY, _updateGazetteerChanges]);

    var onFilterDef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (e, text) {
        if (text.length === 0) {
            setDefView(defData);
            return;
        }
        var fuse = new __WEBPACK_IMPORTED_MODULE_1_fuse_js__(defData, {
            keys: ['fileName', 'majorType', 'minorType'],
            shouldSort: false,
            threshold: 0.1,
            distance: 320,
            maxPatternLength: 32
        });
        var items = fuse.search(text);
        setDefView(items);
    }, 150, { leading: true }), [defData]);

    var find_custom = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (items, fields, text) {
        var pattern = new RegExp(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.escapeRegExp(text), 'i');
        return items.filter(function (i) {
            return fields.some(function (f) {
                return pattern.test(i[f] || '');
            });
        });
    }, []);

    var onFilterLst = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (e, text) {
        if (text.length === 0) {
            lstView.current = lstData.current;
            lstLocalVersion.current++;
            forceUpdate();
            return;
        }
        var items = find_custom(lstData.current, ['$value'].concat(_toConsumableArray(Array.from(columns.current, function (col) {
            return col;
        }))), text);
        lstView.current = items;
        lstLocalVersion.current++;
        forceUpdate();
    }, [find_custom]), []);

    var renderDefRow = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (item) {
        var key = item[dKey.KEY];
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'tr',
            { key: key, 'data-key': key, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ loaded: key === selectedDefKey }) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'td',
                { className: 'cell readonly' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input', { disabled: !item.local, defaultValue: item.fileName, 'data-field': 'fileName', onChange: onDefCellChanged })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'td',
                { className: 'cell' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input', { defaultValue: item.majorType, 'data-field': 'majorType', onChange: onDefCellChanged })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'td',
                { className: 'cell' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input', { defaultValue: item.minorType, 'data-field': 'minorType', onChange: onDefCellChanged })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'select',
                    { 'data-field': '$target', defaultValue: item.$target, onChange: onDefCellChanged },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'option',
                        { value: 'common' },
                        'common'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'option',
                        { value: 'cargo' },
                        'cargo'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'option',
                        { value: 'vessel' },
                        'vessel'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'td',
                { className: 'controls' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_image_edit___default.a, { className: 'edit', onClick: onLoadLst }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_delete___default.a, { className: 'delete', onClick: onDeleteDefEntry })
            )
        );
    }, [selectedDefKey, onDefCellChanged, onLoadLst, onDeleteDefEntry, dKey.KEY]);

    var renderDefTable = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var disableAdminFunctions = !__WEBPACK_IMPORTED_MODULE_21_store_configureStore__["a" /* UserPerms */].isAdmin();
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { className: 'paper-block margin-10' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'span',
                    { className: 'name-block absolute small-name' },
                    'Manage gazetteer index file'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, { label: 'Add row', primary: true, onClick: onAddDefRow }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    __WEBPACK_IMPORTED_MODULE_17_components_Base_AwaitableBtn__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, { label: 'Save', primary: true, onClick: onSaveDef })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'right' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        __WEBPACK_IMPORTED_MODULE_17_components_Base_AwaitableBtn__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, { label: 'Sync lst', disabled: disableAdminFunctions, onClick: __WEBPACK_IMPORTED_MODULE_19_services_gazetters__["k" /* saveToStaging */], primary: true })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        __WEBPACK_IMPORTED_MODULE_17_components_Base_AwaitableBtn__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, { label: 'Deploy', disabled: disableAdminFunctions, onClick: __WEBPACK_IMPORTED_MODULE_19_services_gazetters__["j" /* saveToProduction */], secondary: true })
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, { placeholder: 'Search here...', fullWidth: true, onChange: onFilterDef })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { ref: defList, className: 'def-list' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'table',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'thead',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            'tr',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                'th',
                                null,
                                'File'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                'th',
                                null,
                                'Major type'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                'th',
                                null,
                                'Minor type'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                'th',
                                null,
                                'Type'
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'tbody',
                        null,
                        defView.map(renderDefRow)
                    )
                )
            )
        );
    }, [defView, renderDefRow, onAddDefRow, onSaveDef, onFilterDef]);

    var renderLstFeaturesRow = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_ref16) {
        var index = _ref16.index,
            style = _ref16.style;

        var item = lstView.current[index];
        var key = item[dKey.KEY];
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            {
                key: '' + key + selectedLst + lstLocalVersion.current,
                'data-key': key,
                style: _extends({}, style, { display: 'flex', width: 'auto' })
            },
            Array.from(columns.current, function (field) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { key: key + field, className: 'cell' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input', {
                        style: { height: style.height },
                        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ invalid: invalidRows.current.has(getValKey(field, key)) }),
                        defaultValue: item[field],
                        'data-field': field,
                        onChange: onLstCellChanged
                    })
                );
            })
        );
    }, [selectedLst, selectedLstVersion, onLstCellChanged, dKey.KEY, getValKey]);

    var renderLstTable = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        if (!lstView.current) {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { className: 'empty' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'span',
                    null,
                    'Select .lst from left list to edit'
                )
            );
        }

        prettyPrint(gazetteersChanged);
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { className: 'paper-block margin-10' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'span',
                    { className: 'name-block absolute small-name' },
                    'Manage gazetteer file'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'with-input' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                        ref: featureNameRef,
                        defaultValue: '',
                        errorText: !isNewFeatureNameValid.current && 'invalid feature name',
                        style: { height: 35 },
                        underlineStyle: { bottom: 0 },
                        underlineFocusStyle: { bottom: 0 }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, { label: 'Add feature', primary: true, onClick: onAddFeature })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, { label: 'Add row', primary: true, onClick: onAddLstEntry }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                    label: isSavingContent ? 'Saving...' : 'Save',
                    primary: true,
                    onClick: onSaveLst,
                    disabled: isSavingContent
                }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    { className: 'statuses' },
                    lstDuplicatesCount > 0 && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'div',
                        { className: 'dups' },
                        lstDuplicatesCount,
                        ' duplicate(s)'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_IconMenu___default.a,
                    {
                        iconButtonElement: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            __WEBPACK_IMPORTED_MODULE_8_material_ui_IconButton___default.a,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_material_ui_svg_icons_navigation_more_vert___default.a, null)
                        ),
                        anchorOrigin: { horizontal: 'left', vertical: 'top' },
                        targetOrigin: { horizontal: 'left', vertical: 'top' },
                        className: 'additional-fns'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { primaryText: 'Download', leftIcon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download___default.a, null), onClick: onDownloadLst }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { primaryText: 'Dedup', leftIcon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_content_delete_sweep___default.a, null), onClick: onDedupLst })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                    placeholder: 'Search here...',
                    fullWidth: true,
                    onChange: onFilterLst,
                    onKeyPress: function onKeyPress(e) {
                        if (e.charCode === 13) onFilterLst(e, e.target.value);
                    }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                __WEBPACK_IMPORTED_MODULE_11_react_virtualized_dist_es_ScrollSync__["a" /* ScrollSync */],
                null,
                function (_ref17) {
                    var onScroll = _ref17.onScroll,
                        scrollTop = _ref17.scrollTop;
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        'div',
                        { className: 'lst-list' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            'div',
                            { className: 'lst-left' },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                'div',
                                { className: 'lst-header' },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                    'div',
                                    { className: 'lst-row fixed-column' },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                        'div',
                                        { className: 'cell cell-header' },
                                        'Value'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                'div',
                                { className: 'lst-side-body' },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                    __WEBPACK_IMPORTED_MODULE_9_react_virtualized_dist_es_AutoSizer__["a" /* AutoSizer */],
                                    null,
                                    function (_ref18) {
                                        var width = _ref18.width,
                                            height = _ref18.height;
                                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_virtualized_dist_es_List__["a" /* List */], {
                                            key: '' + selectedLstVersion + selectedLst + lstLocalVersion.current,
                                            ref: lstList,
                                            className: 'fixed-column',
                                            height: height,
                                            overscanRowCount: 10,
                                            rowCount: lstView.current.length,
                                            rowHeight: 35,
                                            rowRenderer: function rowRenderer(_ref19) {
                                                var index = _ref19.index,
                                                    style = _ref19.style;

                                                var item = lstView.current[index];
                                                var key = item[dKey.KEY];
                                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                                    'div',
                                                    {
                                                        key: '' + key + selectedLst + selectedLstVersion,
                                                        'data-key': key,
                                                        style: style,
                                                        className: 'lst-row'
                                                    },
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                                        'div',
                                                        { className: 'controls' },
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_delete___default.a, {
                                                            className: 'delete',
                                                            onClick: onDeleteLstEntry
                                                        })
                                                    ),
                                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                                        'div',
                                                        { key: key + '$value', className: 'cell' },
                                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input', {
                                                            style: { height: style.height },
                                                            defaultValue: item.$value,
                                                            'data-field': '$value',
                                                            onChange: onLstCellChanged
                                                        })
                                                    )
                                                );
                                            },
                                            width: width,
                                            onScroll: onScroll,
                                            scrollTop: scrollTop
                                        });
                                    }
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            'div',
                            { className: 'lst-right' },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                'div',
                                { className: 'lst-right-wrapper' },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                    'div',
                                    { className: 'lst-header' },
                                    Array.from(columns.current, function (field) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](EditableHeader, { key: field, defaultValue: field, onChange: onLstFeatureChanged });
                                    })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                    'div',
                                    { className: 'lst-side-body' },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                        __WEBPACK_IMPORTED_MODULE_9_react_virtualized_dist_es_AutoSizer__["a" /* AutoSizer */],
                                        null,
                                        function (_ref20) {
                                            var width = _ref20.width,
                                                height = _ref20.height;
                                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_virtualized_dist_es_List__["a" /* List */], {
                                                key: '' + selectedLstVersion + selectedLst + columns.current.size + lstLocalVersion.current,
                                                className: 'grid',
                                                height: height,
                                                overscanRowCount: 10,
                                                rowCount: lstView.current.length,
                                                rowHeight: 35,
                                                rowRenderer: renderLstFeaturesRow,
                                                width: width,
                                                onScroll: onScroll,
                                                scrollTop: scrollTop
                                            });
                                        }
                                    )
                                )
                            )
                        )
                    );
                }
            )
        );
    }, [onAddFeature, onAddLstEntry, onSaveLst, lstDuplicatesCount, onDownloadLst, onDedupLst, onFilterLst, selectedLstVersion, selectedLst, onDeleteLstEntry, onLstCellChanged, dKey.KEY, onLstFeatureChanged, renderLstFeaturesRow]);

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: 'container-fluid gazetteer-editor' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { className: 'col-xs-6 def-file-entry' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    null,
                    'Gazetteer Index File'
                ),
                renderDefTable()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { className: 'col-xs-6 lst-file-entry' },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'div',
                    null,
                    'Gazetteer: ',
                    selectedLst
                ),
                renderLstTable()
            )
        )
    );
};

function EditableHeader(props) {
    var onChange = props.onChange,
        defaultValue = props.defaultValue;

    var session = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(Math.random().toFixed(6)).current;

    var onBlur = function onBlur(e) {
        if (e.relatedTarget && e.relatedTarget.dataset.session === session) return;
        onChange(defaultValue, e.target.value);
    };

    var onKeyUp = function onKeyUp(e) {
        if (e.key === 'Enter') {
            onChange(defaultValue, e.target.value);
            e.target.blur();
        }
    };

    var onRemoveClicked = function onRemoveClicked() {
        onChange(defaultValue, null, true);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { key: defaultValue, className: 'cell cell-header editable' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('input', _extends({}, props, { key: defaultValue + session, onKeyUp: onKeyUp, onBlur: onBlur, onChange: function onChange() {} })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            { className: 'remove', tabIndex: 0, 'data-session': session, onClick: onRemoveClicked },
            '\u274C'
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_23__HOC__["a" /* withGazetterContentSave */])(GazetteerEditorPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);

function prettyPrint(gazetteersChanged) {
    console.group('%c Gazetteer Changes ', 'background: #222; color: #bada55; font-size: 14px; font-weight: bold; border-radius: 3px; padding: 2px;');
    gazetteersChanged.current.forEach(function (change) {
        var key = change.key,
            rest = _objectWithoutProperties(change, ['key']);

        var statusStyle = 'color: ' + (change.status === 'new' ? 'green' : change.status === 'remove' ? 'red' : 'orange') + '; font-weight: bold;';
        console.log('%c[' + change.status.toUpperCase() + ']', statusStyle, rest);
    });
    console.groupEnd();
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DynamicKey, 'DynamicKey', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/Page.jsx');
    reactHotLoader.register(GazetteerEditorPage, 'GazetteerEditorPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/Page.jsx');
    reactHotLoader.register(EditableHeader, 'EditableHeader', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/Page.jsx');
    reactHotLoader.register(prettyPrint, 'prettyPrint', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(3393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 3393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _PureComponent);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          clientHeight = _state.clientHeight,
          clientWidth = _state.clientWidth,
          scrollHeight = _state.scrollHeight,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop,
          scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;

      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 3394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = buildLst;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEmptyFeatures;
/* harmony export (immutable) */ __webpack_exports__["c"] = getColumns;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return validator; });
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateDuplicateEntries;
/* harmony export (immutable) */ __webpack_exports__["e"] = loadDefFile;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadLstFile;
/* unused harmony export saveLst */
/* harmony export (immutable) */ __webpack_exports__["h"] = saveDef;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeDuplicates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__ = __webpack_require__(11);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadDefFile),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadLstFile),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(saveLst),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(saveDef),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(removeDuplicates),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(notify);

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-02-06 11:51:30 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-09-11 11:31:59
 */

/**
 * 
 * @param {LstEntry[]} entries 
 * @param {Set<String>} columns 
 */
function buildLst(entries, columns) {
    var keys = new Set(columns);
    keys.delete('$value');
    var fields = Array.from(keys);
    return entries.map(function (entry) {
        if (!entry.$value) {
            return undefined;
        }
        return entry.$value.trimRight() + fields.map(function (key) {
            return entry[key] ? ':' + key + '=' + entry[key].trimRight() : '';
        }).join('');
    }).filter(function (e) {
        return e;
    }).join('\n') + '\n';
}

function getEmptyFeatures(entries, columns) {
    var keys = new Set(columns);
    keys.delete('$value');

    entries.forEach(function (entry) {
        keys.forEach(function (field) {
            if (entry[field]) {
                keys.delete(field);
            }
        });
    });
    return Array.from(keys);
}

function getColumns(items) {
    var columns = new Set();
    items.forEach(function (item) {
        Array.from(Object.keys(item)).forEach(function (key) {
            columns.add(key);
        });
    });
    return columns;
}

var validator = {
    defValue: function defValue(value) {
        return !/[:]/.test(value);
    },
    lstValue: function lstValue(value) {
        return !/[:]/.test(value);
    },
    lstFeature: function lstFeature(value) {
        return !/[:=]/.test(value);
    }
};

function calculateDuplicateEntries(entries) {
    var duplicatesCount = 0;
    var set = new Set();
    entries.forEach(function (entry) {
        if (set.has(entry.$value)) {
            duplicatesCount += 1;
        }
        set.add(entry.$value);
    });
    return duplicatesCount;
}






function loadDefFile() {
    var response;
    return regeneratorRuntime.wrap(function loadDefFile$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].loadGazetteerIndex);

                case 2:
                    response = _context.sent;
                    return _context.abrupt('return', [response.headers['x-version'], response.data]);

                case 4:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function loadLstFile(filename) {
    var response, lines;
    return regeneratorRuntime.wrap(function loadLstFile$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].loadGazetteer, encodeURIComponent(filename));

                case 2:
                    response = _context2.sent;
                    lines = getLines(response.data);
                    return _context2.abrupt('return', [response.headers['x-version'], fastMap(lines, parseLstLine)]);

                case 5:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function saveLst(filename, version, text) {
    var response;
    return regeneratorRuntime.wrap(function saveLst$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveGazetteer, encodeURIComponent(filename), version, text);

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return notify('Lst ' + filename + ' file successfully saved');

                case 6:
                    return _context3.abrupt('return', response.headers['x-version']);

                case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 13;
                    return notify(new Error((_context3.t0.response || {}).data));

                case 13:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 9]]);
}

function saveDef(version, items) {
    var response;
    return regeneratorRuntime.wrap(function saveDef$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].saveGazetteerIndex, version, items);

                case 3:
                    response = _context4.sent;
                    _context4.next = 6;
                    return notify('Def file successfully saved');

                case 6:
                    return _context4.abrupt('return', [response.headers['x-version'], response.data]);

                case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 13;
                    return notify(new Error((_context4.t0.response || {}).data));

                case 13:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 9]]);
}

function removeDuplicates(filename) {
    var response, _response$data, beforeItemsCount, afterItemsCount;

    return regeneratorRuntime.wrap(function removeDuplicates$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].removeGazetteerDuplicates, encodeURIComponent(filename));

                case 3:
                    response = _context5.sent;
                    _response$data = response.data, beforeItemsCount = _response$data.beforeItemsCount, afterItemsCount = _response$data.afterItemsCount;
                    _context5.next = 7;
                    return notify(beforeItemsCount - afterItemsCount + ' duplicates successfully removed from gazetteer ' + filename);

                case 7:
                    _context5.next = 13;
                    break;

                case 9:
                    _context5.prev = 9;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 13;
                    return notify(new Error((_context5.t0.response || {}).data));

                case 13:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 9]]);
}

function notify(obj) {
    return regeneratorRuntime.wrap(function notify$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    if (!(obj instanceof Error)) {
                        _context6.next = 6;
                        break;
                    }

                    if (!obj.message) {
                        console.error(obj);
                    }
                    _context6.next = 4;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Error',
                            message: 'Error: ' + obj.message || 'unknown',
                            level: 'error',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 4:
                    _context6.next = 8;
                    break;

                case 6:
                    _context6.next = 8;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
                        type: __WEBPACK_IMPORTED_MODULE_2_constants_ActionTypes__["e" /* ADD_NOTIFICATION */],
                        notification: {
                            title: 'Success',
                            message: obj,
                            level: 'success',
                            _id: Math.random(),
                            autoDismiss: 2
                        }
                    });

                case 8:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function getLines(text) {
    return text.split(/\r\n|\r|\n/);
}

var featureMatcher = /([^=]+)=([^=]+)/i;

var lstLineHandler = function lstLineHandler(matched, value) {
    if (matched === 0) {
        return ['$value', value];
    }
    var match = featureMatcher.exec(value);
    if (match) {
        return [match[1], match[2]];
    }
    return [undefined];
};

/**
 * 
 * @param {String} line 
 */
function parseLstLine(line) {
    return parseGateDicts(line, lstLineHandler);
}

/**
 * 
 * @param {String} line 
 */
function parseGateDicts(line, resolver) {
    var result = {};

    var matched = 0;
    var current = '';
    // c.clear();
    var length = line.length;
    for (var i = 0; i < length; i++) {
        if (line[i] === ':') {
            var _resolver = resolver(matched++, current),
                _resolver2 = _slicedToArray(_resolver, 2),
                target = _resolver2[0],
                value = _resolver2[1];
            // const [target, value] = resolver(matched++, c.toString());


            if (target !== undefined) {
                result[target] = value;
            }
            current = '';
            // c.clear();
        } else {
            current += line[i];
            // c.append(line[i]);
        }
    }
    if (current.length > 0) {
        // if (c.size > 0) {
        var _resolver3 = resolver(matched++, current),
            _resolver4 = _slicedToArray(_resolver3, 2),
            _target = _resolver4[0],
            _value = _resolver4[1];
        // const [target, value] = resolver(matched++, c.toString());


        if (_target !== undefined) {
            result[_target] = _value;
        }
    }

    return result;
}

/**
 * Fast version of Array::map without checks for holes and mapper context
 */
function fastMap(arr, fn) {
    var length = arr.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
        result[i] = fn(arr[i]);
    }
    return result;
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(buildLst, 'buildLst', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(getEmptyFeatures, 'getEmptyFeatures', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(getColumns, 'getColumns', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(validator, 'validator', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(calculateDuplicateEntries, 'calculateDuplicateEntries', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(loadDefFile, 'loadDefFile', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(loadLstFile, 'loadLstFile', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(saveLst, 'saveLst', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(saveDef, 'saveDef', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(removeDuplicates, 'removeDuplicates', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(notify, 'notify', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(getLines, 'getLines', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(featureMatcher, 'featureMatcher', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(lstLineHandler, 'lstLineHandler', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(parseLstLine, 'parseLstLine', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(parseGateDicts, 'parseGateDicts', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    reactHotLoader.register(fastMap, 'fastMap', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/service/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3395 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128422
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withGazetterContentSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HOC_common__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_gazetters__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__(28);
var _this = this;

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





/**
 * mutation function that calls the service
 * @param {object} params
 * @param {string} params.gazetterName - name of the file to save
 * @param {import('services/gazetters').GazetteerOperation[]} params.values - gazetteer operations
 * @returns {Promise<string>} new version of the file from the server
 */
var saveContentMutationFn = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var gazetterName = _ref2.gazetterName,
            values = _ref2.values;
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_1_services_gazetters__["g" /* saveGazetterPartially */](gazetterName, values);

                    case 2:
                        response = _context.sent;
                        return _context.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function saveContentMutationFn(_x) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * hoc that provides gazetteer content-saving functionality to a component
 */
var withGazetterContentSave = Object(__WEBPACK_IMPORTED_MODULE_0__HOC_common__["a" /* withMutation */])({
    mutationFn: saveContentMutationFn,
    mutationOptions: {
        onSuccess: function onSuccess() {
            Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])('Gazetteer saved successfully!');
        },
        onError: function onError(error) {
            Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])('Failed to save gazetteer. ' + (error.message || ''), 'error');
        }
    },
    mapMutationToProps: function mapMutationToProps(mutateAsync, _ref3) {
        var isLoading = _ref3.isLoading,
            isSuccess = _ref3.isSuccess,
            data = _ref3.data;
        return {
            saveContentMutation: mutateAsync,
            isSavingContent: isLoading,
            newVersion: data ? data.data : null,
            isSaveContentSuccess: isSuccess
        };
    }
});
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(saveContentMutationFn, 'saveContentMutationFn', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/HOC.jsx');
    reactHotLoader.register(withGazetterContentSave, 'withGazetterContentSave', '/opt/atlassian/pipelines/agent/build/client/app/components/Gazetteers/HOC.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PackingListSelector__ = __webpack_require__(3398);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-02-23 18:04:21 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-03-06 14:42:15
 */





var PackingListPage = function (_React$Component) {
    _inherits(PackingListPage, _React$Component);

    function PackingListPage() {
        _classCallCheck(this, PackingListPage);

        return _possibleConstructorReturn(this, (PackingListPage.__proto__ || Object.getPrototypeOf(PackingListPage)).apply(this, arguments));
    }

    _createClass(PackingListPage, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                "div",
                { className: "packing-list-page" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__PackingListSelector__["a" /* default */], { mailId: "5a995b5cebeb7d5dd652f133" }),
                ";"
            );
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PackingListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = PackingListPage;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PackingListPage, "PackingListPage", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/Page.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/Page.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Subheader__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Subheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Subheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_List__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Tabs__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_action_speaker_notes__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_action_speaker_notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_action_speaker_notes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_list__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_description__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_description__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_av_replay__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_av_replay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_av_replay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss__ = __webpack_require__(3402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_scss__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-03-02 16:53:54 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-08-17 13:19:48
 */
























var SelectableList = Object(__WEBPACK_IMPORTED_MODULE_7_material_ui_List__["makeSelectable"])(__WEBPACK_IMPORTED_MODULE_7_material_ui_List__["List"]);

var SKIPPED_CELL = Symbol("skipped-cell");

var USE_CELL_MERGES = false;

var PackingListSelector = function (_React$Component) {
    _inherits(PackingListSelector, _React$Component);

    function PackingListSelector(props, context) {
        _classCallCheck(this, PackingListSelector);

        var _this = _possibleConstructorReturn(this, (PackingListSelector.__proto__ || Object.getPrototypeOf(PackingListSelector)).call(this, props, context));

        _this.state = {
            tables: [],
            selectedEntry: undefined,
            workbooks: {},
            sheets: {},
            columnTypes: []
        };

        _this.handleReplayRecognition = _this.handleReplayRecognition.bind(_this);
        _this.handleEntrySelectionChange = _this.handleEntrySelectionChange.bind(_this);
        _this.handleLoadSourceFile = _this.handleLoadSourceFile.bind(_this);
        _this.handleRecognizedDataRowClicked = _this.handleRecognizedDataRowClicked.bind(_this);
        _this.handleTabChange = _this.handleTabChange.bind(_this);
        return _this;
    }

    _createClass(PackingListSelector, [{
        key: "componentDidMount",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                var mailId, response, tables, _props$initialSelecti, selectedEntry, indexes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, index, data;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                mailId = this.props.mailId;


                                __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].loadFieldTypes().then(function (resp) {
                                    _this2.setState({
                                        columnTypes: resp.data
                                    });
                                }).catch(function (err) {
                                    console.error("Error while loading field types", err);
                                });

                                _context.prev = 2;
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].parseMailAttachments(mailId, this.props.attachments);

                            case 5:
                                response = _context.sent;
                                tables = __WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"](response.data.entries.map(function (entry) {
                                    return entry.tables.map(function (table) {
                                        return _extends({}, table, {
                                            fileName: entry.fileName,
                                            logs: table.logs,
                                            selectedDataRows: new Array(table.data.length).fill(false)
                                        });
                                    });
                                }));

                                if (!this.props.initialSelection) {
                                    _context.next = 28;
                                    break;
                                }

                                _props$initialSelecti = this.props.initialSelection, selectedEntry = _props$initialSelecti.selectedEntry, indexes = _props$initialSelecti.indexes;
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 12;

                                for (_iterator = indexes[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    index = _step.value;

                                    tables[selectedEntry].selectedDataRows[index] = true;
                                }
                                _context.next = 20;
                                break;

                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context["catch"](12);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 20:
                                _context.prev = 20;
                                _context.prev = 21;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 23:
                                _context.prev = 23;

                                if (!_didIteratorError) {
                                    _context.next = 26;
                                    break;
                                }

                                throw _iteratorError;

                            case 26:
                                return _context.finish(23);

                            case 27:
                                return _context.finish(20);

                            case 28:

                                this.setState({
                                    selectedEntry: this.props.initialSelection && this.props.initialSelection.selectedEntry,
                                    tables: tables
                                });
                                _context.next = 36;
                                break;

                            case 31:
                                _context.prev = 31;
                                _context.t1 = _context["catch"](2);
                                data = _context.t1.response.data || {};

                                this.setState({
                                    error: "Can't recognize attachments",
                                    errorAdditional: data.error && data.error.stack
                                });
                                console.error("Error getting recognition info", _context.t1);

                            case 36:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[2, 31], [12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: "handleLoadSourceFile",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var _state, selectedEntry, tables, entry, workbook, sheet, data, workbookData, _workbook, _sheet;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _state = this.state, selectedEntry = _state.selectedEntry, tables = _state.tables;
                                entry = tables[selectedEntry];
                                workbook = this._getCurrentWorkbook(this.state);
                                sheet = this._getCurrentSheet(workbook);

                                if (!workbook) {
                                    _context2.next = 8;
                                    break;
                                }

                                if (entry.fileName !== sheet.fileName || entry.meta.sheetIndex !== sheet.sheetIndex) {
                                    this.setState(Object(__WEBPACK_IMPORTED_MODULE_4_immer__["a" /* default */])(function (state) {
                                        var workbook = _this3._getCurrentWorkbook(state);

                                        workbook.sheetIndex = entry.meta.sheetIndex;
                                        var sheet = _this3.prepareSheetData(workbook);

                                        workbook.sheets[sheet.sheetIndex] = sheet;
                                    }));
                                }
                                _context2.next = 22;
                                break;

                            case 8:
                                _context2.prev = 8;
                                _context2.next = 11;
                                return __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].loadXls(entry.fileName);

                            case 11:
                                data = _context2.sent;
                                workbookData = __WEBPACK_IMPORTED_MODULE_1_xlsx__["read"](data, { type: "array" });
                                _workbook = {
                                    data: workbookData,
                                    fileName: entry.fileName,
                                    sheetIndex: entry.meta.sheetIndex,
                                    sheets: {}
                                };
                                _sheet = this.prepareSheetData(_workbook);


                                _workbook.sheets[_sheet.sheetIndex] = _sheet;

                                this.setState(Object(__WEBPACK_IMPORTED_MODULE_4_immer__["a" /* default */])(function (state) {
                                    state.workbooks[entry.fileName] = _workbook;
                                }));
                                _context2.next = 22;
                                break;

                            case 19:
                                _context2.prev = 19;
                                _context2.t0 = _context2["catch"](8);

                                this.setState(Object(__WEBPACK_IMPORTED_MODULE_4_immer__["a" /* default */])(function (state) {
                                    state.workbooks[entry.fileName] = {
                                        data: undefined,
                                        fileName: entry.fileName,
                                        error: String(_context2.t0.data)
                                    };
                                }));

                            case 22:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[8, 19]]);
            }));

            function handleLoadSourceFile() {
                return _ref2.apply(this, arguments);
            }

            return handleLoadSourceFile;
        }()
    }, {
        key: "prepareSheetData",
        value: function prepareSheetData(workbook, sheetIndex) {
            var sheet = this._getCurrentSheet(workbook);

            if (sheet) {
                return sheet;
            }

            var wsname = workbook.data.SheetNames[workbook.sheetIndex];
            var ws = workbook.data.Sheets[wsname];

            if (!ws) {
                return {
                    sheetIndex: workbook.sheetIndex,
                    fileName: workbook.fileName,
                    error: "There is no sheet found"
                };
            }

            var _prepareData = prepareData(ws, { maxRows: 100, maxCols: 40 }),
                _prepareData2 = _slicedToArray(_prepareData, 2),
                data = _prepareData2[0],
                cols = _prepareData2[1];

            return {
                sheetIndex: workbook.sheetIndex,
                fileName: workbook.fileName,
                data: data,
                cols: cols
            };
        }
    }, {
        key: "handleEntrySelectionChange",
        value: function handleEntrySelectionChange(event, index) {
            var _this4 = this;

            var tables = this.state.tables;

            var entry = tables[index];
            if (!entry) {
                return;
            }

            this.setState({
                selectedEntry: index
            }, function () {
                if (_this4.state.selectedTab === "source-tab") {
                    _this4.handleLoadSourceFile();
                }
            });
        }
    }, {
        key: "handleRecognizedDataRowClicked",
        value: function handleRecognizedDataRowClicked(e) {
            var _this5 = this;

            e.stopPropagation();

            var shiftKey = e.shiftKey;
            var el = e.target.closest("tr[data-index]");
            var rowIndex = el.dataset.index;

            this.setState(function (prev) {
                return Object(__WEBPACK_IMPORTED_MODULE_4_immer__["a" /* default */])(prev, function (state) {
                    var entry = state.tables[state.selectedEntry];

                    var row = !(entry.selectedDataRows[rowIndex] || false);

                    _this5.fillSelection(shiftKey && entry.lastSelected !== undefined ? entry.lastSelected : rowIndex, rowIndex, entry.selectedDataRows, row);
                    entry.lastSelected = rowIndex;
                });
            });
        }
    }, {
        key: "handleDownloadSource",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
                var filename, blob, url, link;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                filename = e.currentTarget.dataset.src;
                                _context3.prev = 1;
                                _context3.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].loadXls(filename, true);

                            case 4:
                                blob = _context3.sent;
                                url = window.URL.createObjectURL(blob);
                                link = document.createElement("a");

                                link.href = url;
                                link.setAttribute("download", getFilename(filename));
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                _context3.next = 17;
                                break;

                            case 14:
                                _context3.prev = 14;
                                _context3.t0 = _context3["catch"](1);

                                console.error("Error while downloading source file " + filename, _context3.t0);

                            case 17:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[1, 14]]);
            }));

            function handleDownloadSource(_x) {
                return _ref3.apply(this, arguments);
            }

            return handleDownloadSource;
        }()
    }, {
        key: "handleReplayRecognition",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
                var index, table, hints, hint, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step2$value, col, types, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, type, attachment, _ref5, data;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                index = e.currentTarget.dataset.index;
                                table = this.state.tables[index];
                                hints = [];

                                if (!(this.sheet && index == this.state.selectedEntry)) {
                                    _context4.next = 49;
                                    break;
                                }

                                hint = {
                                    sheet: table.meta.sheetIndex,
                                    cols: []
                                };
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context4.prev = 8;
                                _iterator2 = this.sheet.state.columns[Symbol.iterator]();

                            case 10:
                                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                    _context4.next = 34;
                                    break;
                                }

                                _step2$value = _slicedToArray(_step2.value, 2), col = _step2$value[0], types = _step2$value[1];
                                _iteratorNormalCompletion3 = true;
                                _didIteratorError3 = false;
                                _iteratorError3 = undefined;
                                _context4.prev = 15;

                                for (_iterator3 = types[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    type = _step3.value;

                                    hint.cols.push({
                                        col: col,
                                        type: type
                                    });
                                }
                                _context4.next = 23;
                                break;

                            case 19:
                                _context4.prev = 19;
                                _context4.t0 = _context4["catch"](15);
                                _didIteratorError3 = true;
                                _iteratorError3 = _context4.t0;

                            case 23:
                                _context4.prev = 23;
                                _context4.prev = 24;

                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }

                            case 26:
                                _context4.prev = 26;

                                if (!_didIteratorError3) {
                                    _context4.next = 29;
                                    break;
                                }

                                throw _iteratorError3;

                            case 29:
                                return _context4.finish(26);

                            case 30:
                                return _context4.finish(23);

                            case 31:
                                _iteratorNormalCompletion2 = true;
                                _context4.next = 10;
                                break;

                            case 34:
                                _context4.next = 40;
                                break;

                            case 36:
                                _context4.prev = 36;
                                _context4.t1 = _context4["catch"](8);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context4.t1;

                            case 40:
                                _context4.prev = 40;
                                _context4.prev = 41;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 43:
                                _context4.prev = 43;

                                if (!_didIteratorError2) {
                                    _context4.next = 46;
                                    break;
                                }

                                throw _iteratorError2;

                            case 46:
                                return _context4.finish(43);

                            case 47:
                                return _context4.finish(40);

                            case 48:

                                if (hint.cols.length > 0) {
                                    hints.push(hint);
                                }

                            case 49:
                                _context4.prev = 49;
                                attachment = this.props.attachments.find(function (a) {
                                    return a.s3.path + "/" + a.name == table.fileName;
                                });
                                _context4.next = 53;
                                return __WEBPACK_IMPORTED_MODULE_5_services__["a" /* default */].parseMailAttachments(this.props.mailId, [_extends({}, attachment, {
                                    sheets: [table.meta.sheetIndex],
                                    hints: hints.length > 0 ? hints : undefined
                                })], true);

                            case 53:
                                _ref5 = _context4.sent;
                                data = _ref5.data;


                                this.setState(Object(__WEBPACK_IMPORTED_MODULE_4_immer__["a" /* default */])(function (state) {
                                    var _iteratorNormalCompletion4 = true;
                                    var _didIteratorError4 = false;
                                    var _iteratorError4 = undefined;

                                    try {
                                        var _loop = function _loop() {
                                            var entry = _step4.value;
                                            var _iteratorNormalCompletion5 = true;
                                            var _didIteratorError5 = false;
                                            var _iteratorError5 = undefined;

                                            try {
                                                var _loop2 = function _loop2() {
                                                    var table = _step5.value;

                                                    var item = state.tables.find(function (t) {
                                                        return t.fileName == entry.fileName && t.meta.sheetIndex == table.meta.sheetIndex;
                                                    });
                                                    if (item) {
                                                        item.data = table.data;
                                                        item.logs = table.logs;
                                                        item.meta = table.meta;
                                                    } else {
                                                        console.error("Recognized table not found as opened", table);
                                                    }
                                                };

                                                for (var _iterator5 = entry.tables[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                    _loop2();
                                                }
                                            } catch (err) {
                                                _didIteratorError5 = true;
                                                _iteratorError5 = err;
                                            } finally {
                                                try {
                                                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                        _iterator5.return();
                                                    }
                                                } finally {
                                                    if (_didIteratorError5) {
                                                        throw _iteratorError5;
                                                    }
                                                }
                                            }
                                        };

                                        for (var _iterator4 = data.entries[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                            _loop();
                                        }
                                    } catch (err) {
                                        _didIteratorError4 = true;
                                        _iteratorError4 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                                _iterator4.return();
                                            }
                                        } finally {
                                            if (_didIteratorError4) {
                                                throw _iteratorError4;
                                            }
                                        }
                                    }
                                }));
                                _context4.next = 61;
                                break;

                            case 58:
                                _context4.prev = 58;
                                _context4.t2 = _context4["catch"](49);

                                console.error("Error while recognizing source file " + table.fileName, _context4.t2);

                            case 61:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[8, 36, 40, 48], [15, 19, 23, 31], [24,, 26, 30], [41,, 43, 47], [49, 58]]);
            }));

            function handleReplayRecognition(_x2) {
                return _ref4.apply(this, arguments);
            }

            return handleReplayRecognition;
        }()
    }, {
        key: "handleTabChange",
        value: function handleTabChange(tabValue) {
            this.setState({
                selectedTab: tabValue
            });
        }
    }, {
        key: "fillSelection",
        value: function fillSelection(from, to, source, value) {
            var min = parseInt(from);
            var max = parseInt(to);
            if (max < min) {
                var _ref6 = [max, min];
                min = _ref6[0];
                max = _ref6[1];
            }
            for (var i = min; i <= max; i++) {
                source[i] = value;
            }
        }
    }, {
        key: "getSelectedData",
        value: function getSelectedData() {
            var _state2 = this.state,
                tables = _state2.tables,
                selectedEntry = _state2.selectedEntry;


            var entry = tables[selectedEntry];

            var data = {
                items: [],
                selectedEntry: selectedEntry, // data from only one sheet stored now
                indexes: []
            };

            entry.selectedDataRows.forEach(function (row, index) {
                if (!row) {
                    return;
                }
                data.indexes.push(index);
                data.items.push(entry.data[index]);
            });

            return data;
        }
    }, {
        key: "_getCurrentWorkbook",
        value: function _getCurrentWorkbook(state) {
            var tables = state.tables,
                selectedEntry = state.selectedEntry,
                workbooks = state.workbooks;


            var table = tables[selectedEntry];
            return workbooks[table.fileName];
        }
    }, {
        key: "_getCurrentSheet",
        value: function _getCurrentSheet(workbook) {
            return workbook && workbook.sheets[workbook.sheetIndex];
        }
    }, {
        key: "renderRecognizedData",
        value: function renderRecognizedData(data, header, selections) {
            var _this6 = this;

            var columnTypes = this.state.columnTypes;

            if (!header.types) {
                return "No header types found";
            }

            var headerTypes = header.types;
            function getFieldProp(type, prop) {
                var field = columnTypes.find(function (field) {
                    return field.type === type;
                });
                return field && field[prop];
            }

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                "table",
                { className: "table table-responsive table-striped" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "thead",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "tr",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            "th",
                            null,
                            "Use"
                        ),
                        headerTypes.map(function (headerProp) {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                "th",
                                null,
                                getFieldProp(headerProp.type, "title")
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "tbody",
                    null,
                    data.map(function (item, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            "tr",
                            { "data-index": index, onClick: _this6.handleRecognizedDataRowClicked },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                "td",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", checked: selections[index], onClick: _this6.handleRecognizedDataRowClicked })
                            ),

                            // TODO: wait until headerProp.field available to remove temp _.camelCase
                            headerTypes.map(function (headerProp) {
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                    "td",
                                    null,
                                    item[getFieldProp(headerProp.type, "fieldName")]
                                );
                            })
                        );
                    })
                )
            );
        }
    }, {
        key: "renderTabs",
        value: function renderTabs() {
            var _this7 = this;

            var _state3 = this.state,
                tables = _state3.tables,
                selectedEntry = _state3.selectedEntry,
                selectedTab = _state3.selectedTab;


            var table = tables[selectedEntry];

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                __WEBPACK_IMPORTED_MODULE_8_material_ui_Tabs__["Tabs"],
                { ref: function ref(t) {
                        return _this7.tabs = t;
                    }, value: selectedTab, onChange: this.handleTabChange, className: "tabs", contentContainerClassName: "tab-container" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    __WEBPACK_IMPORTED_MODULE_8_material_ui_Tabs__["Tab"],
                    {
                        icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_material_ui_svg_icons_action_list___default.a, null),
                        label: "Data",
                        value: "data-tab"
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "div",
                        { className: "data-tab" },
                        table && this.renderRecognizedData(table.data, table.meta.header, table.selectedDataRows)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    __WEBPACK_IMPORTED_MODULE_8_material_ui_Tabs__["Tab"],
                    {
                        icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_material_ui_svg_icons_action_description___default.a, null),
                        label: "Source",
                        value: "source-tab",
                        onActive: this.handleLoadSourceFile
                    },
                    this.renderCurrentSheet()
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    __WEBPACK_IMPORTED_MODULE_8_material_ui_Tabs__["Tab"],
                    {
                        icon: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_material_ui_svg_icons_action_speaker_notes___default.a, null),
                        label: "Logs",
                        value: "logs-tab"
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "div",
                        { className: "logs-tab" },
                        table && table.logs.map(function (log) {
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Log, { data: log });
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "spacer" })
                    )
                )
            );
        }
    }, {
        key: "renderCurrentSheet",
        value: function renderCurrentSheet() {
            var _this8 = this;

            var _state4 = this.state,
                tables = _state4.tables,
                selectedEntry = _state4.selectedEntry,
                selectedTab = _state4.selectedTab,
                columnTypes = _state4.columnTypes;


            var table = tables[selectedEntry];

            var workbook = this._getCurrentWorkbook(this.state);
            if (!workbook) {
                // selectedTab !== "source-tab"
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    null,
                    "Loading..."
                );
            }

            var sheet = this._getCurrentSheet(workbook);

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                "div",
                { key: selectedEntry + "@" + workbook.sheetIndex, className: "source-tab" },
                workbook.error ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    null,
                    "Some Error: ",
                    workbook.error
                ) : sheet.fileName ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sheet, { ref: function ref(c) {
                        return _this8.sheet = c;
                    }, file: sheet, header: table.meta.header, columnTypes: columnTypes }) : null
            );
        }
    }, {
        key: "renderRecognizedTablesIndex",
        value: function renderRecognizedTablesIndex(tables) {
            var _this9 = this;

            return tables.map(function (table, index) {
                var filename = decodeURIComponent(table.fileName);
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    __WEBPACK_IMPORTED_MODULE_7_material_ui_List__["ListItem"],
                    { value: index, className: "entry", innerDivStyle: { display: "flex", justifyContent: "space-between", alignItems: "center" } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "div",
                        { className: "info" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            "span",
                            { className: "name" },
                            table.meta.sheetName || "Table " + (index + 1)
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            "span",
                            { className: "filename", title: filename },
                            getFilename(filename)
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "div",
                        { className: "actions" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_material_ui_svg_icons_av_replay___default.a, { className: "replay", onClick: _this9.handleReplayRecognition, "data-index": index }),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_material_ui_svg_icons_file_file_download___default.a, { className: "download", onClick: _this9.handleDownloadSource, "data-src": filename })
                    )
                );
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _state5 = this.state,
                error = _state5.error,
                tables = _state5.tables,
                selectedEntry = _state5.selectedEntry;


            var content = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                "div",
                { className: "no-content" },
                "Select recognized entry from the left"
            );
            if (error) {
                content = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    { className: "no-content" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "h2",
                        null,
                        error
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "div",
                        { style: { whiteSpace: "pre-wrap", textAlign: "left" } },
                        this.state.errorAdditional
                    )
                );
            } else {
                content = selectedEntry !== undefined && this.renderTabs();
            }

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                "div",
                { className: "packing-list" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    { className: "col-xs-3" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        SelectableList,
                        { value: selectedEntry, className: "entries-list", onChange: this.handleEntrySelectionChange },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            __WEBPACK_IMPORTED_MODULE_6_material_ui_Subheader___default.a,
                            null,
                            "Recognized tables"
                        ),
                        tables.length > 0 && this.renderRecognizedTablesIndex(tables)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    { className: "col-xs-9" },
                    content
                )
            );
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PackingListSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = PackingListSelector;
/* harmony default export */ __webpack_exports__["a"] = (_default);


function Log(_ref7) {
    var data = _ref7.data;

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        "div",
        { className: "log-entry" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            "span",
            { className: "log-time" },
            new Date(data.timestamp).toLocaleTimeString(),
            ": "
        ),
        data.scope ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            "span",
            { className: "log-scope" },
            data.scope
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            "div",
            { className: "log-text" },
            data.message
        ),
        data.data ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            "div",
            { className: "log-details" },
            renderLogDetails(data.data)
        ) : null
    );
}

function renderLogDetails(data) {
    switch (typeof data === "undefined" ? "undefined" : _typeof(data)) {
        case "string":
            return data;
        default:
            return JSON.stringify(data, null, 2);
    }
}

var Sheet = function (_React$Component2) {
    _inherits(Sheet, _React$Component2);

    function Sheet(props, context) {
        _classCallCheck(this, Sheet);

        var _this10 = _possibleConstructorReturn(this, (Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call(this, props, context));

        _this10.state = {
            columns: _this10.prepareColumnMap(props.header.types),
            initialColumns: _this10.prepareColumnMap(props.header.types)
        };

        _this10.handleColumnTypeChanged = _this10.handleColumnTypeChanged.bind(_this10);
        return _this10;
    }

    _createClass(Sheet, [{
        key: "prepareColumnMap",
        value: function prepareColumnMap(types) {
            var columnMap = new Map();
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = (types || [])[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var type = _step6.value;
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = type.cols[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var col = _step7.value;

                            var columnTypes = columnMap.get(col.col);

                            if (!columnTypes) {
                                columnMap.set(col.col, columnTypes = []);
                            }
                            columnTypes.push(col.type);
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            return columnMap;
        }
    }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            this.setState({
                columns: this.prepareColumnMap(nextProps.header.types),
                initialColumns: this.prepareColumnMap(nextProps.header.types)
            });
        }
    }, {
        key: "handleColumnTypeChanged",
        value: function handleColumnTypeChanged(column, values) {
            this.state.columns.set(column, values);
            this.forceUpdate();
        }
    }, {
        key: "selectionRenderer",
        value: function selectionRenderer(values) {
            switch (values.length) {
                case 0:
                    return "";
                case 1:
                    return values[0];
                default:
                    return values.length + " fields";
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this11 = this;

            var _props = this.props,
                file = _props.file,
                header = _props.header;
            var fileName = file.fileName,
                data = file.data,
                cols = file.cols,
                error = file.error;
            var _state6 = this.state,
                columns = _state6.columns,
                initialColumns = _state6.initialColumns;


            if (error) {
                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "div",
                    null,
                    error
                );
            }

            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                header.types ? null : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "h2",
                    null,
                    "No header types found"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    "table",
                    { className: "table table-responsive" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "thead",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                            "tr",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                "th",
                                null,
                                "#"
                            ),
                            cols.map(function (col) {
                                var colTypes = columns.get(col.key);
                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                    "th",
                                    { key: col.key },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                        "div",
                                        { className: "with-hint" },
                                        col.name,
                                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                            __WEBPACK_IMPORTED_MODULE_9_material_ui_SelectField___default.a,
                                            { value: colTypes || [],
                                                onChange: function onChange(_1, _2, values) {
                                                    return _this11.handleColumnTypeChanged(col.key, values);
                                                },
                                                selectionRenderer: _this11.selectionRenderer, multiple: true, fullWidth: true },
                                            _this11.props.columnTypes.map(function (c) {
                                                return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_material_ui_MenuItem___default.a, {
                                                    innerDivStyle: { padding: 0, textAlign: "center", maxWidth: 100 },
                                                    key: c.type,
                                                    insetChildren: true,
                                                    value: c.type,
                                                    primaryText: c.title
                                                });
                                            })
                                        )
                                    )
                                );
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                        "tbody",
                        null,
                        data.map(function (row, index) {
                            var isHeaderRow = inRowRange(header, index + 1);
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                "tr",
                                { key: index, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "recognized-header-row": isHeaderRow }) },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                    "td",
                                    null,
                                    index + 1
                                ),
                                cols.map(function (col, index) {
                                    var initialValueColumn = initialColumns.get(index + 1);

                                    var cell = row[index];
                                    if (cell === SKIPPED_CELL) {
                                        return null;
                                    }
                                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                                        "td",
                                        {
                                            colSpan: cell && cell.colspan,
                                            rowSpan: cell && cell.rowspan,
                                            key: col.key,
                                            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "recognized-value-col": initialValueColumn, "with-tooltip": isHeaderRow && initialValueColumn }),
                                            title: initialValueColumn && buildTextForValueColumn(header.types, initialValueColumn)
                                        },
                                        cell && ((typeof cell === "undefined" ? "undefined" : _typeof(cell)) === "object" ? cell.value : cell)
                                    );
                                })
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Sheet;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/**
 * 
 * @param {*} ws 
 * @param {{ maxRows?: number, maxCols?: number }} opts 
 */


function prepareData(ws) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var ut = __WEBPACK_IMPORTED_MODULE_1_xlsx__["utils"];
    var range = __WEBPACK_IMPORTED_MODULE_1_xlsx__["utils"].decode_range(ws["!ref"] || "CW101");
    var end = {
        c: Math.min(opts.maxCols || range.e.c, range.e.c),
        r: Math.min(opts.maxRows || range.e.r, range.e.r)
    };

    var data = __WEBPACK_IMPORTED_MODULE_1_xlsx__["utils"].sheet_to_json(ws, { header: 1, blankrows: true, range: __WEBPACK_IMPORTED_MODULE_1_xlsx__["utils"].encode_range({ c: 0, r: 0 }, end) });

    data = data.slice(0, opts.maxRows || Infinity);

    if (USE_CELL_MERGES && ws["!merges"]) {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = ws["!merges"][Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var merge = _step8.value;


                var value = data[merge.s.r][merge.s.c];

                for (var r = merge.s.r; r <= merge.e.r; r++) {
                    for (var c = merge.s.c; c <= merge.e.c; c++) {
                        data[r][c] = SKIPPED_CELL;
                    }
                }

                data[merge.s.r][merge.s.c] = { value: value, colspan: merge.e.c - merge.s.c + 1, rowspan: merge.e.r - merge.s.r + 1 };
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }
    }

    var cols = [];
    var actualMaxCols = 0;
    var lastRowWithCols = 0;
    for (var rowIndex = 0; rowIndex < data.length; rowIndex++) {
        if (data[rowIndex].length > actualMaxCols) {
            actualMaxCols = data[rowIndex].length;
        }
        if (data[rowIndex].length > 0) {
            lastRowWithCols = rowIndex;
        }
    }
    if (actualMaxCols > 0) {
        cols = make_cols(__WEBPACK_IMPORTED_MODULE_1_xlsx__["utils"].encode_col(actualMaxCols - 1) + "1", opts.maxCols);
    }
    if (lastRowWithCols < data.length) {
        data = data.slice(0, lastRowWithCols + 1);
    }

    return [data, cols];
}

function getFilename(path) {
    return path.match(/[^\/]+$/i)[0];
}

function inRowRange(header, index) {
    return header.startRow <= index && header.row >= index;
}

function buildTextForValueColumn(types, columns) {
    var cols = __WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"](types.map(function (t) {
        return t.cols;
    })).filter(function (c) {
        return columns.includes(c.type);
    });
    return cols.map(function (col, index) {
        return "Type" + (index + 1) + ": " + col.type + "\nValue" + (index + 1) + ": " + col.value;
    }).join("\n-------------\n");
}

function make_cols(refstr) {
    var maxCols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;

    var o = [],
        C = Math.min(__WEBPACK_IMPORTED_MODULE_1_xlsx__["utils"].decode_range(refstr).e.c + 1, maxCols);
    for (var i = 0; i < C; ++i) {
        o[i] = {
            name: __WEBPACK_IMPORTED_MODULE_1_xlsx__["utils"].encode_col(i),
            key: i + 1
        };
    }
    return o;
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SelectableList, "SelectableList", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(SKIPPED_CELL, "SKIPPED_CELL", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(USE_CELL_MERGES, "USE_CELL_MERGES", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(PackingListSelector, "PackingListSelector", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(Log, "Log", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(renderLogDetails, "renderLogDetails", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(Sheet, "Sheet", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(prepareData, "prepareData", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(getFilename, "getFilename", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(inRowRange, "inRowRange", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(buildTextForValueColumn, "buildTextForValueColumn", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(make_cols, "make_cols", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/PackingList/PackingListSelector.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3399 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*!

JSZip - A Javascript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE

Note: since JSZip 3 removed critical functionality, this version assigns to the
`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
*/
(function(e){
	if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();
	else if(true){JSZipSync=e();!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
	else{
		var f;
		"undefined"!=typeof window?f=window:
		"undefined"!=typeof global?f=global:
		"undefined"!=typeof $ && $.global?f=$.global:
		"undefined"!=typeof self&&(f=self),f.JSZipSync=e()
	}
}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input, utf8) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {

        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
            enc4 = 64;
        }

        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

    }

    return output;
};

// public method for decoding
exports.decode = function(input, utf8) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
        }

    }

    return output;

};

},{}],2:[function(_dereq_,module,exports){
'use strict';
function CompressedObject() {
    this.compressedSize = 0;
    this.uncompressedSize = 0;
    this.crc32 = 0;
    this.compressionMethod = null;
    this.compressedContent = null;
}

CompressedObject.prototype = {
    /**
     * Return the decompressed content in an unspecified format.
     * The format will depend on the decompressor.
     * @return {Object} the decompressed content.
     */
    getContent: function() {
        return null; // see implementation
    },
    /**
     * Return the compressed content in an unspecified format.
     * The format will depend on the compressed conten source.
     * @return {Object} the compressed content.
     */
    getCompressedContent: function() {
        return null; // see implementation
    }
};
module.exports = CompressedObject;

},{}],3:[function(_dereq_,module,exports){
'use strict';
exports.STORE = {
    magic: "\x00\x00",
    compress: function(content) {
        return content; // no compression
    },
    uncompress: function(content) {
        return content; // no compression
    },
    compressInputType: null,
    uncompressInputType: null
};
exports.DEFLATE = _dereq_('./flate');

},{"./flate":8}],4:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

var table = [
    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
];

/**
 *
 *  Javascript crc32
 *  http://www.webtoolkit.info/
 *
 */
module.exports = function crc32(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if (typeof(crc) == "undefined") {
        crc = 0;
    }
    var x = 0;
    var y = 0;
    var b = 0;

    crc = crc ^ (-1);
    for (var i = 0, iTop = input.length; i < iTop; i++) {
        b = isArray ? input[i] : input.charCodeAt(i);
        y = (crc ^ b) & 0xFF;
        x = table[y];
        crc = (crc >>> 8) ^ x;
    }

    return crc ^ (-1);
};
// vim: set shiftwidth=4 softtabstop=4:

},{"./utils":21}],5:[function(_dereq_,module,exports){
'use strict';
var utils = _dereq_('./utils');

function DataReader(data) {
    this.data = null; // type : see implementation
    this.length = 0;
    this.index = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1); // second
    }
};
module.exports = DataReader;

},{"./utils":21}],6:[function(_dereq_,module,exports){
'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = false;
exports.date = null;
exports.compression = null;
exports.comment = null;

},{}],7:[function(_dereq_,module,exports){
'use strict';
var utils = _dereq_('./utils');

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2binary = function(str) {
    return utils.string2binary(str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2Uint8Array = function(str) {
    return utils.transformTo("uint8array", str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.uint8Array2String = function(array) {
    return utils.transformTo("string", array);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.string2Blob = function(str) {
    var buffer = utils.transformTo("arraybuffer", str);
    return utils.arrayBuffer2Blob(buffer);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.arrayBuffer2Blob = function(buffer) {
    return utils.arrayBuffer2Blob(buffer);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.transformTo = function(outputType, input) {
    return utils.transformTo(outputType, input);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.getTypeOf = function(input) {
    return utils.getTypeOf(input);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.checkSupport = function(type) {
    return utils.checkSupport(type);
};

/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */
exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;

/**
 * @deprecated
 * This value will be removed in a future version without replacement.
 */
exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;


/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.pretty = function(str) {
    return utils.pretty(str);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.findCompression = function(compressionMethod) {
    return utils.findCompression(compressionMethod);
};

/**
 * @deprecated
 * This function will be removed in a future version without replacement.
 */
exports.isRegExp = function (object) {
    return utils.isRegExp(object);
};


},{"./utils":21}],8:[function(_dereq_,module,exports){
'use strict';
var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = _dereq_("pako");
exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";
exports.compress = function(input) {
    return pako.deflateRaw(input);
};
exports.uncompress =  function(input) {
    return pako.inflateRaw(input);
};

},{"pako":24}],9:[function(_dereq_,module,exports){
'use strict';

var base64 = _dereq_('./base64');

/**
Usage:
   zip = new JSZip();
   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
   zip.folder("images").file("smile.gif", base64Data, {base64: true});
   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
   zip.remove("tempfile");

   base64zip = zip.generate();

**/

/**
 * Representation a of zip file in js
 * @constructor
 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
 * @param {Object=} options the options for creating this objects (optional).
 */
function JSZipSync(data, options) {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZipSync)) return new JSZipSync(data, options);

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    if (data) {
        this.load(data, options);
    }
    this.clone = function() {
        var newObj = new JSZipSync();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZipSync.prototype = _dereq_('./object');
JSZipSync.prototype.load = _dereq_('./load');
JSZipSync.support = _dereq_('./support');
JSZipSync.defaults = _dereq_('./defaults');

/**
 * @deprecated
 * This namespace will be removed in a future version without replacement.
 */
JSZipSync.utils = _dereq_('./deprecatedPublicUtils');

JSZipSync.base64 = {
    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    encode : function(input) {
        return base64.encode(input);
    },
    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    decode : function(input) {
        return base64.decode(input);
    }
};
JSZipSync.compressions = _dereq_('./compressions');
module.exports = JSZipSync;

},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){
'use strict';
var base64 = _dereq_('./base64');
var ZipEntries = _dereq_('./zipEntries');
module.exports = function(data, options) {
    var files, zipEntries, i, input;
    options = options || {};
    if (options.base64) {
        data = base64.decode(data);
    }

    zipEntries = new ZipEntries(data, options);
    files = zipEntries.files;
    for (i = 0; i < files.length; i++) {
        input = files[i];
        this.file(input.fileName, input.decompressed, {
            binary: true,
            optimizedBinaryString: true,
            date: input.date,
            dir: input.dir,
            comment : input.fileComment.length ? input.fileComment : null,
            createFolders: options.createFolders
        });
    }
    if (zipEntries.zipComment.length) {
        this.comment = zipEntries.zipComment;
    }

    return this;
};

},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){
(function (Buffer){
'use strict';
if(typeof Buffer !== 'undefined') {
	// $FlowIgnore
	if(!Buffer.from) Buffer.from = function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); };
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
}
module.exports = function(data, encoding){
    return typeof data == 'number' ? Buffer.alloc(data) : Buffer.from(data, encoding);
};
module.exports.test = function(b){
    return Buffer.isBuffer(b);
};
}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
},{}],12:[function(_dereq_,module,exports){
'use strict';
var Uint8ArrayReader = _dereq_('./uint8ArrayReader');

function NodeBufferReader(data) {
    this.data = data;
    this.length = this.data.length;
    this.index = 0;
}
NodeBufferReader.prototype = new Uint8ArrayReader();

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;

},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){
'use strict';
var support = _dereq_('./support');
var utils = _dereq_('./utils');
var crc32 = _dereq_('./crc32');
var signature = _dereq_('./signature');
var defaults = _dereq_('./defaults');
var base64 = _dereq_('./base64');
var compressions = _dereq_('./compressions');
var CompressedObject = _dereq_('./compressedObject');
var nodeBuffer = _dereq_('./nodeBuffer');
var utf8 = _dereq_('./utf8');
var StringWriter = _dereq_('./stringWriter');
var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');

/**
 * Returns the raw data of a ZipObject, decompress the content if necessary.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */
var getRawData = function(file) {
    if (file._data instanceof CompressedObject) {
        file._data = file._data.getContent();
        file.options.binary = true;
        file.options.base64 = false;

        if (utils.getTypeOf(file._data) === "uint8array") {
            var copy = file._data;
            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
            file._data = new Uint8Array(copy.length);
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            if (copy.length !== 0) {
                file._data.set(copy, 0);
            }
        }
    }
    return file._data;
};

/**
 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
 * @param {ZipObject} file the file to use.
 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
 */
var getBinaryData = function(file) {
    var result = getRawData(file),
        type = utils.getTypeOf(result);
    if (type === "string") {
        if (!file.options.binary) {
            // unicode text !
            // unicode string => binary string is a painful process, check if we can avoid it.
            if (support.nodebuffer) {
                return nodeBuffer(result, "utf-8");
            }
        }
        return file.asBinary();
    }
    return result;
};

/**
 * Transform this._data into a string.
 * @param {function} filter a function String -> String, applied if not null on the result.
 * @return {String} the string representing this._data.
 */
var dataToString = function(asUTF8) {
    var result = getRawData(this);
    if (result === null || typeof result === "undefined") {
        return "";
    }
    // if the data is a base64 string, we decode it before checking the encoding !
    if (this.options.base64) {
        result = base64.decode(result);
    }
    if (asUTF8 && this.options.binary) {
        // JSZip.prototype.utf8decode supports arrays as input
        // skip to array => string step, utf8decode will do it.
        result = out.utf8decode(result);
    }
    else {
        // no utf8 transformation, do the array => string step.
        result = utils.transformTo("string", result);
    }

    if (!asUTF8 && !this.options.binary) {
        result = utils.transformTo("string", out.utf8encode(result));
    }
    return result;
};
/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;

    this._data = data;
    this.options = options;

    /*
     * This object contains initial values for dir and date.
     * With them, we can check if the user changed the deprecated metadata in
     * `ZipObject#options` or not.
     */
    this._initialMetadata = {
      dir : options.dir,
      date : options.date
    };
};

ZipObject.prototype = {
    /**
     * Return the content as UTF8 string.
     * @return {string} the UTF8 string.
     */
    asText: function() {
        return dataToString.call(this, true);
    },
    /**
     * Returns the binary content.
     * @return {string} the content as binary.
     */
    asBinary: function() {
        return dataToString.call(this, false);
    },
    /**
     * Returns the content as a nodejs Buffer.
     * @return {Buffer} the content as a Buffer.
     */
    asNodeBuffer: function() {
        var result = getBinaryData(this);
        return utils.transformTo("nodebuffer", result);
    },
    /**
     * Returns the content as an Uint8Array.
     * @return {Uint8Array} the content as an Uint8Array.
     */
    asUint8Array: function() {
        var result = getBinaryData(this);
        return utils.transformTo("uint8array", result);
    },
    /**
     * Returns the content as an ArrayBuffer.
     * @return {ArrayBuffer} the content as an ArrayBufer.
     */
    asArrayBuffer: function() {
        return this.asUint8Array().buffer;
    }
};

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "",
        i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
var extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transforms the (incomplete) options from the user into the complete
 * set of options to create a file.
 * @private
 * @param {Object} o the options from the user.
 * @return {Object} the complete set of options.
 */
var prepareFileAttrs = function(o) {
    o = o || {};
    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
        o.binary = true;
    }
    o = extend(o, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) o.compression = o.compression.toUpperCase();

    return o;
};

/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} o the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, o) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;

    o = prepareFileAttrs(o);

    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    if (o.dir || data === null || typeof data === "undefined") {
        o.base64 = false;
        o.binary = false;
        data = null;
    }
    else if (dataType === "string") {
        if (o.binary && !o.base64) {
            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
            if (o.optimizedBinaryString !== true) {
                // this is a string, not in a base64 format.
                // Be sure that this is a correct "binary string"
                data = utils.string2binary(data);
            }
        }
    }
    else { // arraybuffer, uint8array, ...
        o.base64 = false;
        o.binary = true;

        if (!dataType && !(data instanceof CompressedObject)) {
            throw new Error("The data of '" + name + "' is in an unsupported format !");
        }

        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = utils.transformTo("uint8array", data);
        }
    }

    var object = new ZipObject(name, data, o);
    this.files[name] = object;
    return object;
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) == '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    // Check the name ends with a /
    if (name.slice(-1) != "/") {
        name += "/"; // IE doesn't like substr(-1)
    }

    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
 * Generate a JSZip.CompressedObject for a given zipOject.
 * @param {ZipObject} file the object to read.
 * @param {JSZip.compression} compression the compression to use.
 * @return {JSZip.CompressedObject} the compressed result.
 */
var generateCompressedObjectFrom = function(file, compression) {
    var result = new CompressedObject(),
        content;

    // the data has not been decompressed, we might reuse things !
    if (file._data instanceof CompressedObject) {
        result.uncompressedSize = file._data.uncompressedSize;
        result.crc32 = file._data.crc32;

        if (result.uncompressedSize === 0 || file.dir) {
            compression = compressions['STORE'];
            result.compressedContent = "";
            result.crc32 = 0;
        }
        else if (file._data.compressionMethod === compression.magic) {
            result.compressedContent = file._data.getCompressedContent();
        }
        else {
            content = file._data.getContent();
            // need to decompress / recompress
            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
        }
    }
    else {
        // have uncompressed data
        content = getBinaryData(file);
        if (!content || content.length === 0 || file.dir) {
            compression = compressions['STORE'];
            content = "";
        }
        result.uncompressedSize = content.length;
        result.crc32 = crc32(content);
        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
    }

    result.compressedSize = result.compressedContent.length;
    result.compressionMethod = compression.magic;

    return result;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {string} name the file name.
 * @param {ZipObject} file the file content.
 * @param {JSZip.CompressedObject} compressedObject the compressed object.
 * @param {number} offset the current offset from the start of the zip file.
 * @return {object} the zip parts.
 */
var generateZipParts = function(name, file, compressedObject, offset) {
    var data = compressedObject.compressedContent,
        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
        comment = file.comment || "",
        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
        useUTF8ForComment = utfEncodedComment.length !== comment.length,
        o = file.options,
        dosTime,
        dosDate,
        extraFields = "",
        unicodePathExtraField = "",
        unicodeCommentExtraField = "",
        dir, date;


    // handle the deprecated options.dir
    if (file._initialMetadata.dir !== file.dir) {
        dir = file.dir;
    } else {
        dir = o.dir;
    }

    // handle the deprecated options.date
    if(file._initialMetadata.date !== file.date) {
        date = file.date;
    } else {
        date = o.date;
    }


    dosTime = date.getHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getSeconds() / 2;

    dosDate = date.getFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(utfEncodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(this.crc32(utfEncodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    // set bit 11 if utf8
    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
    // compression method
    header += compressedObject.compressionMethod;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(compressedObject.crc32, 4);
    // compressed size
    header += decToHex(compressedObject.compressedSize, 4);
    // uncompressed size
    header += decToHex(compressedObject.uncompressedSize, 4);
    // file name length
    header += decToHex(utfEncodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
    // version made by (00: DOS)
    "\x14\x00" +
    // file header (common to file and central directory)
    header +
    // file comment length
    decToHex(utfEncodedComment.length, 2) +
    // disk number start
    "\x00\x00" +
    // internal file attributes TODO
    "\x00\x00" +
    // external file attributes
    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
    // relative offset of local header
    decToHex(offset, 4) +
    // file name
    utfEncodedFileName +
    // extra field
    extraFields +
    // file comment
    utfEncodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord,
        compressedObject: compressedObject
    };
};


// return the actual prototype of JSZip
var out = {
    /**
     * Read an existing zip and merge the data in the current JSZip object.
     * The implementation is in jszip-load.js, don't forget to include it.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
     * @param {Object} options Options for loading the stream.
     *  options.base64 : is the stream in base64 ? default : false
     * @return {JSZip} the current JSZip object
     */
    load: function(stream, options) {
        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [],
            filename, relativePath, file, fileClone;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            // return a new object, don't let the user mess with our internal objects :)
            fileClone = new ZipObject(file.name, file._data, extend(file.options));
            relativePath = filename.slice(this.root.length, filename.length);
            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
            search(relativePath, fileClone)) { // and the file matches the function
                result.push(fileClone);
            }
        }
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (utils.isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                return this.filter(function(relativePath, file) {
                    return !file.dir && relativePath === name;
                })[0] || null;
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (utils.isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) != "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - base64, (deprecated, use type instead) true to generate base64.
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        options = extend(options || {}, {
            base64: true,
            compression: "STORE",
            type: "base64",
            comment: null
        });

        utils.checkSupport(options.type);

        var zipData = [],
            localDirLength = 0,
            centralDirLength = 0,
            writer, i,
            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));

        // first, generate all the zip parts.
        for (var name in this.files) {
            if (!this.files.hasOwnProperty(name)) {
                continue;
            }
            var file = this.files[name];

            var compressionName = file.options.compression || options.compression.toUpperCase();
            var compression = compressions[compressionName];
            if (!compression) {
                throw new Error(compressionName + " is not a valid compression method !");
            }

            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);

            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
            centralDirLength += zipPart.dirRecord.length;
            zipData.push(zipPart);
        }

        var dirEnd = "";

        // end of central dir signature
        dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(zipData.length, 2) +
        // total number of entries in the central directory
        decToHex(zipData.length, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(utfEncodedComment.length, 2) +
        // .ZIP file comment
        utfEncodedComment;


        // we have all the parts (and the total length)
        // time to create a writer !
        var typeName = options.type.toLowerCase();
        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
        }else{
            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
        }

        for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].fileRecord);
            writer.append(zipData[i].compressedObject.compressedContent);
        }
        for (i = 0; i < zipData.length; i++) {
            writer.append(zipData[i].dirRecord);
        }

        writer.append(dirEnd);

        var zip = writer.finalize();



        switch(options.type.toLowerCase()) {
            // case "zip is an Uint8Array"
            case "uint8array" :
            case "arraybuffer" :
            case "nodebuffer" :
               return utils.transformTo(options.type.toLowerCase(), zip);
            case "blob" :
               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
            // case "zip is a string"
            case "base64" :
               return (options.base64) ? base64.encode(zip) : zip;
            default : // case "string" :
               return zip;
         }

    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    crc32: function (input, crc) {
        return crc32(input, crc);
    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    utf8encode: function (string) {
        return utils.transformTo("string", utf8.utf8encode(string));
    },

    /**
     * @deprecated
     * This method will be removed in a future version without replacement.
     */
    utf8decode: function (input) {
        return utf8.utf8decode(input);
    }
};
module.exports = out;

},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){
'use strict';
exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";

},{}],15:[function(_dereq_,module,exports){
'use strict';
var DataReader = _dereq_('./dataReader');
var utils = _dereq_('./utils');

function StringReader(data, optimizedBinaryString) {
    this.data = data;
    if (!optimizedBinaryString) {
        this.data = utils.string2binary(this.data);
    }
    this.length = this.data.length;
    this.index = 0;
}
StringReader.prototype = new DataReader();
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig);
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;

},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

/**
 * An object to write any content to a string.
 * @constructor
 */
var StringWriter = function() {
    this.data = [];
};
StringWriter.prototype = {
    /**
     * Append any content to the current string.
     * @param {Object} input the content to add.
     */
    append: function(input) {
        input = utils.transformTo("string", input);
        this.data.push(input);
    },
    /**
     * Finalize the construction an return the result.
     * @return {string} the generated string.
     */
    finalize: function() {
        return this.data.join("");
    }
};

module.exports = StringWriter;

},{"./utils":21}],17:[function(_dereq_,module,exports){
(function (Buffer){
'use strict';
exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
// Browserify will provide a Buffer implementation for browsers, which is
// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
},{}],18:[function(_dereq_,module,exports){
'use strict';
var DataReader = _dereq_('./dataReader');

function Uint8ArrayReader(data) {
    if (data) {
        this.data = data;
        this.length = this.data.length;
        this.index = 0;
    }
}
Uint8ArrayReader.prototype = new DataReader();
/**
 * @see DataReader.byteAt
 */
Uint8ArrayReader.prototype.byteAt = function(i) {
    return this.data[i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i;
        }
    }

    return -1;
};
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.index, this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;

},{"./dataReader":5}],19:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');

/**
 * An object to write any content to an Uint8Array.
 * @constructor
 * @param {number} length The length of the array.
 */
var Uint8ArrayWriter = function(length) {
    this.data = new Uint8Array(length);
    this.index = 0;
};
Uint8ArrayWriter.prototype = {
    /**
     * Append any content to the current array.
     * @param {Object} input the content to add.
     */
    append: function(input) {
        if (input.length !== 0) {
            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
            input = utils.transformTo("uint8array", input);
            this.data.set(input, this.index);
            this.index += input.length;
        }
    },
    /**
     * Finalize the construction an return the result.
     * @return {Uint8Array} the generated array.
     */
    finalize: function() {
        return this.data;
    }
};

module.exports = Uint8ArrayWriter;

},{"./utils":21}],20:[function(_dereq_,module,exports){
'use strict';

var utils = _dereq_('./utils');
var support = _dereq_('./support');
var nodeBuffer = _dereq_('./nodeBuffer');

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if (((c & 0xfc00) === 0xd800) && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += (c < 0x80) ? 1 : ((c < 0x800) ? 2 : ((c < 0x10000) ? 3 : 4));
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodeBuffer(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    // return buf2string(buf);
    // Chrome prefers to work with "small" chunks of data
    // for the method buf2string.
    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
    var result = [], k = 0, len = buf.length, chunk = 65536;
    while (k < len) {
        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
        if (support.uint8array) {
            result.push(buf2string(buf.subarray(k, nextBoundary)));
        } else {
            result.push(buf2string(buf.slice(k, nextBoundary)));
        }
        k = nextBoundary;
    }
    return result.join("");

};
// vim: set shiftwidth=4 softtabstop=4:

},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){
'use strict';
var support = _dereq_('./support');
var compressions = _dereq_('./compressions');
var nodeBuffer = _dereq_('./nodeBuffer');
/**
 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
 * @param {string} str the string to transform.
 * @return {String} the binary string.
 */
exports.string2binary = function(str) {
    var result = "";
    for (var i = 0; i < str.length; i++) {
        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
    }
    return result;
};
exports.arrayBuffer2Blob = function(buffer) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob([buffer], {
            type: "application/zip"
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            return builder.getBlob('application/zip');
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    var chunk = 65536;
    var result = [],
        len = array.length,
        type = exports.getTypeOf(array),
        k = 0,
        canUseApply = true;
      try {
         switch(type) {
            case "uint8array":
               String.fromCharCode.apply(null, new Uint8Array(0));
               break;
            case "nodebuffer":
               String.fromCharCode.apply(null, nodeBuffer(0));
               break;
         }
      } catch(e) {
         canUseApply = false;
      }

      // no apply : slow and painful algorithm
      // default browser on android 4.*
      if (!canUseApply) {
         var resultStr = "";
         for(var i = 0; i < array.length;i++) {
            resultStr += String.fromCharCode(array[i]);
         }
    return resultStr;
    }
    while (k < len && chunk > 1) {
        try {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        catch (e) {
            chunk = Math.floor(chunk / 2);
        }
    }
    return result.join("");
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodeBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodeBuffer(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodeBuffer(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodeBuffer(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodeBuffer.test(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this browser");
    }
};
exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
exports.findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};
/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
exports.isRegExp = function (object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
};


},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){
'use strict';
var StringReader = _dereq_('./stringReader');
var NodeBufferReader = _dereq_('./nodeBufferReader');
var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
var utils = _dereq_('./utils');
var sig = _dereq_('./signature');
var ZipEntry = _dereq_('./zipEntry');
var support = _dereq_('./support');
var jszipProto = _dereq_('./object');
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(data, loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
    if (data) {
        this.load(data);
    }
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        var signature = this.reader.readString(4);
        if (signature !== expectedSignature) {
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        this.zipComment = this.reader.readString(this.zipCommentLength);
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded.
        this.zipComment = jszipProto.utf8decode(this.zipComment);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.versionMadeBy = this.reader.readString(2);
        this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readString(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset === -1) {
            throw new Error("Corrupted zip : can't find end of central directory");
        }
        this.reader.setIndex(offset);
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset === -1) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }
    },
    prepareReader: function(data) {
        var type = utils.getTypeOf(data);
        if (type === "string" && !support.uint8array) {
            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
        }
        else if (type === "nodebuffer") {
            this.reader = new NodeBufferReader(data);
        }
        else {
            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
        }
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;

},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){
'use strict';
var StringReader = _dereq_('./stringReader');
var utils = _dereq_('./utils');
var CompressedObject = _dereq_('./compressedObject');
var jszipProto = _dereq_('./object');
// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Prepare the function used to generate the compressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
     */
    prepareCompressedContent: function(reader, from, length) {
        return function() {
            var previousIndex = reader.index;
            reader.setIndex(from);
            var compressedFileData = reader.readData(length);
            reader.setIndex(previousIndex);

            return compressedFileData;
        };
    },
    /**
     * Prepare the function used to generate the uncompressed content from this ZipFile.
     * @param {DataReader} reader the reader to use.
     * @param {number} from the offset from where we should read the data.
     * @param {number} length the length of the data to read.
     * @param {JSZip.compression} compression the compression used on this file.
     * @param {number} uncompressedSize the uncompressed size to expect.
     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
     */
    prepareContent: function(reader, from, length, compression, uncompressedSize) {
        return function() {

            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
            var uncompressedFileData = compression.uncompress(compressedFileData);

            if (uncompressedFileData.length !== uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }

            return uncompressedFileData;
        };
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        this.fileName = reader.readString(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
        }

        compression = utils.findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
        }
        this.decompressed = new CompressedObject();
        this.decompressed.compressedSize = this.compressedSize;
        this.decompressed.uncompressedSize = this.uncompressedSize;
        this.decompressed.crc32 = this.crc32;
        this.decompressed.compressionMethod = this.compressionMethod;
        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);

        // we need to compute the crc32...
        if (this.loadOptions.checkCRC32) {
            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
                throw new Error("Corrupted zip : CRC32 mismatch");
            }
        }
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readString(2);
        this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        this.fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        this.fileName = reader.readString(this.fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readString(this.fileCommentLength);

        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
    },
    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = new StringReader(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var start = reader.index,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        this.extraFields = this.extraFields || {};

        while (reader.index < start + this.extraFieldsLength) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readString(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        if (this.useUTF8()) {
            this.fileName = jszipProto.utf8decode(this.fileName);
            this.fileComment = jszipProto.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileName = upath;
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileComment = ucomment;
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = new StringReader(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = new StringReader(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;

},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){
// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = _dereq_('./lib/utils/common').assign;

var deflate   = _dereq_('./lib/deflate');
var inflate   = _dereq_('./lib/inflate');
var constants = _dereq_('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;
},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){
'use strict';


var zlib_deflate = _dereq_('./zlib/deflate.js');
var utils = _dereq_('./utils/common');
var strings = _dereq_('./utils/strings');
var msg = _dereq_('./zlib/messages');
var zstream = _dereq_('./zlib/zstream');


/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overriden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
var Deflate = function(options) {

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new zstream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }
};

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data. Strings will be converted to
 *   utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function(data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && _mode === Z_FINISH)) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function(status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate alrorythm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;
},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){
'use strict';


var zlib_inflate = _dereq_('./zlib/inflate.js');
var utils = _dereq_('./utils/common');
var strings = _dereq_('./utils/strings');
var c = _dereq_('./zlib/constants');
var msg = _dereq_('./zlib/messages');
var zstream = _dereq_('./zlib/zstream');
var gzheader = _dereq_('./zlib/gzheader');


/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overriden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
var Inflate = function(options) {

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new zstream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new gzheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
};

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
 * [[Inflate#onEnd]].
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function(data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && _mode === c.Z_FINISH)) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }
  } while ((strm.avail_in > 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }
  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function(chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell inflate that input stream complete
 * or error happenned. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function(status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 alligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof(source) !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs+len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for(var i=0; i<len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function(chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i=0, l=chunks.length; i<l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i=0, l=chunks.length; i<l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for(var i=0; i<len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function(chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);
},{}],28:[function(_dereq_,module,exports){
// String encode/decode helpers
'use strict';


var utils = _dereq_('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safary
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [0]); } catch(__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch(__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
      c2 = str.charCodeAt(m_pos+1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i=0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
      c2 = str.charCodeAt(m_pos+1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // use fallback for big arrays to avoid stack overflow
  if (len < 65537) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for(var i=0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function(buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function(str) {
  var buf = new utils.Buf8(str.length);
  for(var i=0, len=buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len*2);

  for (out=0, i=0; i<len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function(buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max-1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Fuckup - very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means vuffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":27}],29:[function(_dereq_,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0
    , s2 = ((adler >>> 16) & 0xffff) |0
    , n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;
},{}],30:[function(_dereq_,module,exports){
module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
},{}],31:[function(_dereq_,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.


// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for(var n =0; n < 256; n++){
    c = n;
    for(var k =0; k < 8; k++){
      c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable
    , end = pos + len;

  crc = crc ^ (-1);

  for (var i = pos; i < end; i++ ) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;
},{}],32:[function(_dereq_,module,exports){
'use strict';

var utils   = _dereq_('../utils/common');
var trees   = _dereq_('./trees');
var adler32 = _dereq_('./adler32');
var crc32   = _dereq_('./crc32');
var msg   = _dereq_('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2*L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only (s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH-1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH-1)) ? s.strstart : MIN_MATCH-1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH-1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size-MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH-1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1- s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length-1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH-1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH-1 ? s.strstart : MIN_MATCH-1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
};

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2*D_CODES+1) * 2);
  this.bl_tree    = new utils.Buf16((2*BL_CODES+1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS+1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2*L_CODES+1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2*L_CODES+1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  s.d_buf = s.lit_bufsize >> 1;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg){
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}

/* =========================================================================
 * Copy the source state to the destination state
 */
//function deflateCopy(dest, source) {
//
//}

exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/
},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){
'use strict';


function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;
},{}],34:[function(_dereq_,module,exports){
'use strict';

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  var window;                 /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],35:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');
var adler32 = _dereq_('./adler32');
var crc32   = _dereq_('./crc32');
var inflate_fast = _dereq_('./inffast');
var inflate_table = _dereq_('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function ZSWAP32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, {bits: 9});

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, {bits: 5});

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window,src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window,src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window,src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = ZSWAP32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = {bits: state.lenbits};
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = {bits: state.lenbits};
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = {bits: state.distbits};
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) -1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) -1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
        if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}


exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/
},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
      base = extra = work;    /* dummy value--not used */
      end = 19;
  } else if (type === LENS) {
      base = lbase;
      base_index -= 257;
      extra = lext;
      extra_index -= 257;
      end = 256;
  } else {                    /* DISTS */
      base = dbase;
      extra = dext;
      end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  var i=0;
  /* process all codes and make table entries */
  for (;;) {
    i++;
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":27}],37:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  '2':    'need dictionary',     /* Z_NEED_DICT       2  */
  '1':    'stream end',          /* Z_STREAM_END      1  */
  '0':    '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};
},{}],38:[function(_dereq_,module,exports){
'use strict';


var utils = _dereq_('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2*L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES+2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH-MIN_MATCH+1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
};


var static_l_desc;
var static_d_desc;
var static_bl_desc;


var TreeDesc = function(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
};



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short (s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c*2]/*.Code*/, tree[c*2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max]*2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max+1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n*2 +1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n*2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n-base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n*2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length-1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits+1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m*2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m*2 + 1]/*.Len*/)*tree[m*2]/*.Freq*/;
        tree[m*2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS+1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits-1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n*2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n*2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS+1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES-1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1<<extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length-1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0 ; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1<<extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for ( ; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1<<(extra_dbits[code]-7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n*2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n*2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n*2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n*2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES+1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n*2 + 1]/*.Len*/ = 5;
    static_dtree[n*2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS+1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc =new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n*2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n*2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n*2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK*2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n*2;
  var _m2 = m*2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j+1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx*2] << 8) | (s.pending_buf[s.d_buf + lx*2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code+LITERALS+1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n*2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node*2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n*2 + 1]/*.Dad*/ = tree[m*2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code+1)*2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n+1)*2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6*2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10*2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138*2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n+1)*2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count-3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count-3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count-11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES-1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex]*2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3*(max_blindex+1) + 5+5+4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes-257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes-1,   5);
  send_bits(s, blcodes-4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank]*2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes-1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes-1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n*2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK<<1)+(last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES<<1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len+3+7) >>> 3;
    static_lenb = (s.static_len+3+7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len+4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES<<1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES<<1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code+1, s.d_desc.max_code+1, max_blindex+1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc*2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc]+LITERALS+1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize-1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;
},{"../utils/common":27}],39:[function(_dereq_,module,exports){
'use strict';


function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;
},{}]},{},[9])
(9)
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228).Buffer))

/***/ }),
/* 3400 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3401 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3402 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128378
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_sender__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var SenderPage = function (_React$Component) {
    _inherits(SenderPage, _React$Component);

    function SenderPage(props) {
        _classCallCheck(this, SenderPage);

        var _this = _possibleConstructorReturn(this, (SenderPage.__proto__ || Object.getPrototypeOf(SenderPage)).call(this, props));

        _this.state = {
            search: ''
        };

        _this.prevPage = _this.prevPage.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);

        _this.keyPress = _this.keyPress.bind(_this);
        _this.onChange = _this.onChange.bind(_this);

        _this.search = _this.search.bind(_this);
        return _this;
    }

    _createClass(SenderPage, [{
        key: 'search',
        value: function search() {
            this.props.getSendEmailList({
                page: 1,
                filters: {
                    search: this.state.search
                }
            });
        }
    }, {
        key: 'keyPress',
        value: function keyPress(e) {
            var search = this.state.search;


            if (e.keyCode === 13 && (search.length > 2 || search.length < 40)) {
                this.props.getSendEmailList({
                    page: 1,
                    filters: { search: search }
                });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e, value) {
            var _this2 = this;

            this.setState({
                search: value
            }, function () {
                if (_this2.state.search === '') {
                    _this2.props.getSendEmailList({
                        page: 1
                    });
                }
            });
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            this.props.getSendEmailList({
                page: this.props.senderList.next
            });
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            this.props.getSendEmailList({
                page: this.props.senderList.previous || 1
            });
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getSendEmailList();
        }
    }, {
        key: 'getStatus',
        value: function getStatus(status, name) {
            if (!Array.isArray(status)) return 0;
            var count = 0;
            status.forEach(function (item) {
                if (item.name === name) count++;
            });
            return count;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props$senderList = this.props.senderList,
                data = _props$senderList.data,
                page = _props$senderList.page,
                loading = _props$senderList.loading;
            var search = this.state.search;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'sender-page', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        null,
                        'Sender email list'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-10' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["h" /* IconButton */],
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].navigationLeft,
                                        name: 'navigationLeft',
                                        onClick: this.prevPage,
                                        disabled: !loading
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Page: ',
                                    page
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["h" /* IconButton */],
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].navigationRight,
                                        name: 'navigationRight',
                                        onClick: this.nextPage,
                                        disabled: !loading
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-4 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["A" /* TextField */], {
                                    hintText: 'Search',
                                    value: search,
                                    onChange: this.onChange,
                                    onKeyDown: this.keyPress
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { margin: '0 0 0 20px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                                        label: 'search',
                                        primary: true,
                                        disabled: search.length <= 2 || search.length >= 40,
                                        onClick: this.search
                                    })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["u" /* Table */],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["w" /* TableHeader */],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui__["y" /* TableRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'info'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'message'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'send'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'open'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'processed'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'delivered'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'click'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'dropped'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    null
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["v" /* TableBody */],
                            { displayRowCheckbox: false },
                            data.map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_6_material_ui__["y" /* TableRow */],
                                    { key: index },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableRowColumnCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'p',
                                            null,
                                            item._id
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'p',
                                            null,
                                            'added - ',
                                            __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.addedAt).format('DD.MM.YYYY')
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'p',
                                            null,
                                            'updated - ',
                                            __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.updatedAt).format('DD.MM.YYYY')
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'p',
                                            null,
                                            'category - ',
                                            item.category
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableRowColumnCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'p',
                                            null,
                                            'to:',
                                            item.to
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'p',
                                            null,
                                            item.subject
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        _this3.getStatus(item.status, 'send')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        _this3.getStatus(item.status, 'open')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        _this3.getStatus(item.status, 'processed')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        _this3.getStatus(item.status, 'delivered')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        _this3.getStatus(item.status, 'click')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        _this3.getStatus(item.status, 'dropped')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_6_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                                            label: 'show',
                                            primary: true,
                                            containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */], { to: '/sender/' + item._id })
                                        })
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SenderPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var senderList = _ref.senderList;

    return {
        senderList: senderList
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getSendEmailList: __WEBPACK_IMPORTED_MODULE_5_actions_sender__["b" /* getSendEmailList */]
    }, dispatch);
})(SenderPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SenderPage, 'SenderPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Sender/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Sender/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_sender__ = __webpack_require__(976);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SingleSenderPage = function (_React$Component) {
    _inherits(SingleSenderPage, _React$Component);

    function SingleSenderPage() {
        _classCallCheck(this, SingleSenderPage);

        return _possibleConstructorReturn(this, (SingleSenderPage.__proto__ || Object.getPrototypeOf(SingleSenderPage)).apply(this, arguments));
    }

    _createClass(SingleSenderPage, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.props.getSendEmail(this.props.routeParams.id);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$sender = this.props.sender,
                _id = _props$sender._id,
                html = _props$sender.html,
                subject = _props$sender.subject,
                to = _props$sender.to,
                category = _props$sender.category,
                updateAt = _props$sender.updateAt,
                addedAt = _props$sender.addedAt,
                status = _props$sender.status;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'sender-single-page', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        null,
                        'Email'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-10' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                                    label: 'back to the list',
                                    containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Link */], { to: '/sender/list' }),
                                    primary: true
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'paper-block margin-10' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'name-block small-name absolute' },
                                    'info'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'id'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        _id
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'subject'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        subject
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'to'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        to
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'category'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        category
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'updateAt'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        __WEBPACK_IMPORTED_MODULE_3_moment___default()(updateAt).format('MM.DD.YYYY')
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'addedAt'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        __WEBPACK_IMPORTED_MODULE_3_moment___default()(addedAt).format('MM.DD.YYYY')
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'updateAt'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        updateAt
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-2' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'addedAt'
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-xs-10' },
                                        addedAt
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'paper-block margin-10' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'name-block small-name absolute' },
                                    'status'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'pre',
                                    null,
                                    JSON.stringify(this.props.sender.status, null, ' ')
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'paper-block margin-10' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { className: 'name-block small-name absolute' },
                                    'original'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { srcDoc: html, sandbox: true, style: { overflow: 'auto', border: 'none', width: '100%', height: '100vh' }, ref: 'iframe', frameBorder: '0' })
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return SingleSenderPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref) {
    var sender = _ref.sender;

    return {
        sender: sender
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        getSendEmail: __WEBPACK_IMPORTED_MODULE_6_actions_sender__["a" /* getSendEmail */]
    }, dispatch);
})(SingleSenderPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(SingleSenderPage, 'SingleSenderPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Sender/Single.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/Sender/Single.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_domains__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Delete__ = __webpack_require__(3406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Connect__ = __webpack_require__(3407);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Domains = function (_React$Component) {
    _inherits(Domains, _React$Component);

    function Domains(props) {
        _classCallCheck(this, Domains);

        var _this = _possibleConstructorReturn(this, (Domains.__proto__ || Object.getPrototypeOf(Domains)).call(this, props));

        _this.state = {
            isOpenDeleteDialog: false,
            isOpenConnectDialog: false,
            selectedItemToDelete: ''
        };

        _this.toggleDeleteDialog = _this.toggleDeleteDialog.bind(_this);
        _this.toggleConnectDialog = _this.toggleConnectDialog.bind(_this);
        return _this;
    }

    _createClass(Domains, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getListDomain();
        }
    }, {
        key: 'toggleDeleteDialog',
        value: function toggleDeleteDialog() {
            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.setState({
                isOpenDeleteDialog: !this.state.isOpenDeleteDialog,
                selectedItemToDelete: id
            });
        }
    }, {
        key: 'toggleConnectDialog',
        value: function toggleConnectDialog() {
            this.setState({
                isOpenConnectDialog: !this.state.isOpenConnectDialog
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                isOpenDeleteDialog = _state.isOpenDeleteDialog,
                isOpenConnectDialog = _state.isOpenConnectDialog,
                selectedItemToDelete = _state.selectedItemToDelete;
            var domains = this.props.domains;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'domains-page', className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Delete__["a" /* default */], {
                    id: selectedItemToDelete,
                    toggle: this.toggleDeleteDialog,
                    isOpen: isOpenDeleteDialog
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        null,
                        'Domains'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-10' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-6 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Connect__["a" /* default */], {
                                    isOpen: isOpenConnectDialog,
                                    toggle: this.toggleConnectDialog
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["u" /* Table */],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["w" /* TableHeader */],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["y" /* TableRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'domain'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'user'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'added at'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */], { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["v" /* TableBody */],
                            { displayRowCheckbox: false },
                            domains.items.map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["y" /* TableRow */],
                                    { key: index },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS },
                                        item.domain
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS },
                                        item.user ? item.user.name + ' ' + item.user.surname + ' ' + item.user.email : '-'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS },
                                        item.addedAt
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                                            label: 'Delete',
                                            secondary: true,
                                            onClick: function onClick() {
                                                return _this2.toggleDeleteDialog(item._id);
                                            }
                                        })
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Domains;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var domains = _ref.domains;

    return {
        domains: domains
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getListDomain: __WEBPACK_IMPORTED_MODULE_5_actions_domains__["b" /* getListDomain */]
    }, dispatch);
})(Domains);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Domains, 'Domains', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_domains__ = __webpack_require__(571);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DeleteDomain = function (_React$Component) {
    _inherits(DeleteDomain, _React$Component);

    function DeleteDomain() {
        _classCallCheck(this, DeleteDomain);

        return _possibleConstructorReturn(this, (DeleteDomain.__proto__ || Object.getPrototypeOf(DeleteDomain)).apply(this, arguments));
    }

    _createClass(DeleteDomain, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                toggle = _props.toggle,
                isOpen = _props.isOpen,
                deleteDomain = _props.deleteDomain,
                getListDomain = _props.getListDomain,
                id = _props.id;


            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
                label: 'Delete',
                secondary: true,
                onClick: function onClick() {
                    deleteDomain({ id: id });
                    getListDomain();
                    toggle();
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
                label: 'Cancel',
                primary: true,
                onClick: toggle
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */], {
                title: 'Do you really want to delete domain?',
                actions: actions,
                modal: false,
                open: isOpen,
                onRequestClose: this.toggle
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return DeleteDomain;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function () {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ deleteDomain: __WEBPACK_IMPORTED_MODULE_4_actions_domains__["a" /* deleteDomain */], getListDomain: __WEBPACK_IMPORTED_MODULE_4_actions_domains__["b" /* getListDomain */] }, dispatch);
})(DeleteDomain);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DeleteDomain, 'DeleteDomain', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Delete.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Delete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AutoComplete__ = __webpack_require__(3408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sagas_domains__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_domains__ = __webpack_require__(571);
var _this2 = this;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var styles = {
    autoComplete: {
        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
        menuStyle: { width: 'auto' },
        textFieldStyle: { fontSize: '13px' }
    },
    textField: {
        style: {
            fontSize: '13px'
        }
    }
};

var autoCompleteOptions = {
    dataSourceConfig: { text: 'email', value: 'item' }
};

var DeleteDomain = function (_React$Component) {
    _inherits(DeleteDomain, _React$Component);

    function DeleteDomain(props) {
        _classCallCheck(this, DeleteDomain);

        var _this = _possibleConstructorReturn(this, (DeleteDomain.__proto__ || Object.getPrototypeOf(DeleteDomain)).call(this, props));

        _this.state = {
            users: []
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.debounce(function (searchText) {
            if (searchText.length <= 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].findUser(searchText).then(function (response) {
                var users = [];

                response.data.data.forEach(function (user) {
                    users.push(user);
                });

                _this.setState({
                    users: users
                });
            }).catch(function () {
                return null;
            });
        }, 1000);

        _this.onChange = _this.onChange.bind(_this);
        _this.onNewRequest = _this.onNewRequest.bind(_this);
        return _this;
    }

    _createClass(DeleteDomain, [{
        key: 'onChange',
        value: function onChange(searchText) {
            this.dAutocomplete(searchText);
        }
    }, {
        key: 'onNewRequest',
        value: function onNewRequest(updateProperties, value) {
            this.props.change('user', value._id);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                toggle = _props.toggle,
                isOpen = _props.isOpen;
            var users = this.state.users;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                    label: 'Connect new domain',
                    onClick: toggle,
                    primary: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
                    {
                        title: 'Connect new domain',
                        modal: false,
                        open: isOpen,
                        onRequestClose: this.toggle
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        { autoComplete: 'off', onSubmit: this.props.handleSubmit },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-6' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                    component: __WEBPACK_IMPORTED_MODULE_8_redux_form_material_ui__["TextField"],
                                    name: 'domain',
                                    floatingLabelText: 'Domain',
                                    validate: [Object(__WEBPACK_IMPORTED_MODULE_9_redux_form_validators__["format"])({ with: /^([\w\.]+)\.([a-z]{2,6}\.?)(\/[\w\.]*)*\/?$/ }), Object(__WEBPACK_IMPORTED_MODULE_9_redux_form_validators__["required"])()],
                                    style: styles.textField.style
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-6' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                    name: 'userSearch',
                                    component: __WEBPACK_IMPORTED_MODULE_6__AutoComplete__["a" /* default */],
                                    hintText: 'User',
                                    onUpdateInput: this.onChange,
                                    onNewRequest: this.onNewRequest,
                                    dataSource: users,
                                    floatingLabelText: 'User',
                                    dataSourceConfig: autoCompleteOptions.dataSourceConfig,
                                    selectValue: function selectValue(value) {
                                        return value.item;
                                    },

                                    props: {
                                        listStyle: styles.autoComplete.listStyle,
                                        menuStyle: styles.autoComplete.menuStyle,
                                        textFieldStyle: styles.autoComplete.textFieldStyle,
                                        popoverProps: { canAutoPosition: true },
                                        filter: __WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */].noFilter
                                    }
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                            name: 'user',
                            validate: [Object(__WEBPACK_IMPORTED_MODULE_9_redux_form_validators__["required"])()],
                            component: function component(_ref) {
                                var value = _ref.input.value,
                                    _ref$meta = _ref.meta,
                                    error = _ref$meta.error,
                                    ddd = _objectWithoutProperties(_ref$meta, ['error']);

                                if (error) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'error' },
                                        'Error field user: ' + error
                                    );
                                }

                                return value ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    'Id user - ' + value
                                ) : '';
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { margin: '30px 0 0 0' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                                label: 'Cancel',
                                onClick: toggle,
                                secondary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                                label: 'Connect',
                                type: 'submit',
                                style: { margin: '0 0 0 10px' },
                                primary: true
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return DeleteDomain;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DeleteDomain.propTypes = {};

DeleteDomain.defaultProps = {};

var handleSubmit = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, dispatch, props) {
        var response, errors;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_12_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_11_sagas_domains__["a" /* connectNewDomainToUser */], values);

                    case 2:
                        response = _context.sent;

                        if (!(response.status !== 200)) {
                            _context.next = 9;
                            break;
                        }

                        errors = {};


                        response.data.errors.forEach(function (error) {
                            errors = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.merge(errors, __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.set({}, error.field, error.messages[0]));
                        });

                        throw new __WEBPACK_IMPORTED_MODULE_4_redux_form__["c" /* SubmissionError */](errors);

                    case 9:
                        props.getListDomain();
                        props.toggle();

                    case 11:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this2);
    }));

    return function handleSubmit(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();

var MyForm = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["g" /* reduxForm */])({
    form: 'connect-domain-to-user',
    enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    onSubmit: handleSubmit
})(DeleteDomain);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function () {
    return {
        initialValues: { domain: '', user: '', userSearch: '' }
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ getListDomain: __WEBPACK_IMPORTED_MODULE_13_actions_domains__["b" /* getListDomain */] }, dispatch);
})(MyForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Connect.jsx');
    reactHotLoader.register(autoCompleteOptions, 'autoCompleteOptions', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Connect.jsx');
    reactHotLoader.register(DeleteDomain, 'DeleteDomain', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Connect.jsx');
    reactHotLoader.register(handleSubmit, 'handleSubmit', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Connect.jsx');
    reactHotLoader.register(MyForm, 'MyForm', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Connect.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/Connect.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form_material_ui_lib_createComponent__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form_material_ui_lib_createComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_form_material_ui_lib_createComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form_material_ui_lib_mapError__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form_material_ui_lib_mapError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_form_material_ui_lib_mapError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AutoCompleteHOC__ = __webpack_require__(3409);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var _default = __WEBPACK_IMPORTED_MODULE_0_redux_form_material_ui_lib_createComponent___default()(__WEBPACK_IMPORTED_MODULE_2__AutoCompleteHOC__["a" /* default */], function (_ref) {
    var _ref$input = _ref.input,
        onChange = _ref$input.onChange,
        _onBlur = _ref$input.onBlur,
        value = _ref$input.value,
        _onNewRequest = _ref.onNewRequest,
        _onUpdateInput = _ref.onUpdateInput,
        dataSourceConfig = _ref.dataSourceConfig,
        selectValue = _ref.selectValue,
        dataSource = _ref.dataSource,
        props = _objectWithoutProperties(_ref, ['input', 'onNewRequest', 'onUpdateInput', 'dataSourceConfig', 'selectValue', 'dataSource']);

    var searchText = dataSourceConfig && dataSource ? (dataSource.find(function (item) {
        return item[dataSourceConfig.text] === value;
    }) || {})[dataSourceConfig.text] : value;

    var defaultSelectValue = function defaultSelectValue() {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && dataSourceConfig ? value[dataSourceConfig.value] : value;
    };

    return _extends({}, __WEBPACK_IMPORTED_MODULE_1_redux_form_material_ui_lib_mapError___default()(props), {
        dataSourceConfig: dataSourceConfig,
        dataSource: dataSource,
        searchText: searchText || value,
        onNewRequest: function onNewRequest(value) {
            var selectedValue = selectValue ? selectValue(value) : defaultSelectValue;

            onChange(selectedValue, value);

            if (_onNewRequest) {
                _onNewRequest(selectedValue, value);
            }
        },
        onUpdateInput: function onUpdateInput(value) {
            onChange(value);

            if (_onUpdateInput) {
                _onUpdateInput(value);
            }
        },
        onBlur: function onBlur() {
            return _onBlur(value);
        }
    });
});

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/AutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AutoCompleteHOC = function (_React$Component) {
    _inherits(AutoCompleteHOC, _React$Component);

    function AutoCompleteHOC(props) {
        _classCallCheck(this, AutoCompleteHOC);

        var _this = _possibleConstructorReturn(this, (AutoCompleteHOC.__proto__ || Object.getPrototypeOf(AutoCompleteHOC)).call(this, props));

        _this.handleUpdateInput = function (searchText) {
            _this.setState({
                searchText: searchText
            }, function () {
                _this.props.onUpdateInput(searchText);
            });
        };

        _this.handleNewRequest = function (chosenRequest, index) {
            var text = _this.props.dataSourceConfig.text;


            if (index === -1) {
                return;
            }

            _this.setState({
                searchText: chosenRequest[text]
            });

            _this.props.onNewRequest(chosenRequest, index);
        };

        _this.state = {
            searchText: props.searchText
        };

        _this.handleNewRequest = _this.handleNewRequest.bind(_this);
        _this.handleUpdateInput = _this.handleUpdateInput.bind(_this);
        return _this;
    }

    _createClass(AutoCompleteHOC, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.searchText !== nextProps.searchText) {
                this.setState({
                    searchText: nextProps.searchText || ''
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, _extends({}, this.props, {
                searchText: this.state.searchText,
                onNewRequest: this.handleNewRequest,
                onUpdateInput: this.handleUpdateInput
            }));
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return AutoCompleteHOC;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = AutoCompleteHOC;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AutoCompleteHOC, 'AutoCompleteHOC', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/AutoCompleteHOC.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Domains/AutoCompleteHOC.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_users_subscribers__ = __webpack_require__(3411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Subscribers = function (_React$Component) {
    _inherits(Subscribers, _React$Component);

    function Subscribers(props) {
        _classCallCheck(this, Subscribers);

        var _this = _possibleConstructorReturn(this, (Subscribers.__proto__ || Object.getPrototypeOf(Subscribers)).call(this, props));

        _this.state = {
            search: '',
            onlyCompleted: false
        };

        _this.prevPage = _this.prevPage.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);

        _this.keyPress = _this.keyPress.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onToggleOnlyCompleted = _this.onToggleOnlyCompleted.bind(_this);

        _this.search = _this.search.bind(_this);
        return _this;
    }

    _createClass(Subscribers, [{
        key: 'search',
        value: function search() {
            this._loadData(1);
        }
    }, {
        key: 'keyPress',
        value: function keyPress(e) {
            var search = this.state.search;


            if (e.keyCode === 13 && (search.length > 2 || search.length < 40)) {
                this._loadData(1);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e, value) {
            var _this2 = this;

            this.setState({
                search: value
            }, function () {
                if (_this2.state.search === '') {
                    _this2._loadData(1);
                }
            });
        }
    }, {
        key: 'onToggleOnlyCompleted',
        value: function onToggleOnlyCompleted(e, value) {
            var _this3 = this;

            this.setState({
                onlyCompleted: value
            }, function () {
                _this3._loadData();
            });
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            this._loadData(this.props.subscribers.next);
        }
    }, {
        key: 'prevPage',
        value: function prevPage() {
            this._loadData(this.props.subscribers.previous || 1);
        }
    }, {
        key: '_loadData',
        value: function _loadData() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.subscribers.page;

            this.props.getSubscribers({
                page: page,
                filters: {
                    search: this.state.search,
                    success: this.state.onlyCompleted
                }
            });
        }
    }, {
        key: 'changeAmount',
        value: function changeAmount(amount) {
            var remainderAmount = amount % 100;

            if ((remainderAmount + '').length == 1) {
                remainderAmount = "0" + remainderAmount;
            }

            return (amount / 100 | 0) + '.' + remainderAmount;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._loadData(1);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props$subscribers = this.props.subscribers,
                data = _props$subscribers.data,
                page = _props$subscribers.page,
                loading = _props$subscribers.loading;
            var _state = this.state,
                search = _state.search,
                onlyCompleted = _state.onlyCompleted;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'sender-page', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        null,
                        'Subscribers list'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-10' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["h" /* IconButton */],
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].navigationLeft,
                                        onClick: this.prevPage,
                                        disabled: !loading
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_chevron_left___default.a, null)
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Page: ',
                                    page
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["h" /* IconButton */],
                                    {
                                        iconStyle: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].navigationRight,
                                        onClick: this.nextPage,
                                        disabled: !loading
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_chevron_right___default.a, null)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-4 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                                    hintText: 'Search by Order ID',
                                    value: search,
                                    onChange: this.onChange,
                                    onKeyDown: this.keyPress
                                }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { margin: '0 0 0 20px' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                                        label: 'search',
                                        primary: true,
                                        disabled: search.length <= 2 || search.length >= 40,
                                        onClick: this.search
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-4 middle-xs', style: { display: 'flex' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["b" /* Checkbox */], {
                                    label: 'Only completed',
                                    checked: onlyCompleted,
                                    onCheck: this.onToggleOnlyCompleted
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["u" /* Table */],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["w" /* TableHeader */],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'User'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Order ID'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Package Type'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Amount'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Amount (USD)'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Completed At'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Added At'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Transaction Code'
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["v" /* TableBody */],
                            { displayRowCheckbox: false },
                            data.map(function (item, index) {
                                var userBlock = null;
                                if (item.user) {
                                    var _restoreEmail = restoreEmail(item.user.email),
                                        isRemoved = _restoreEmail.isRemoved,
                                        email = _restoreEmail.email;

                                    userBlock = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            ((item.user.name || "") + " " + (item.user.surname || "")).trim() || '(no name)',
                                            ' '
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            { style: { fontStyle: "italic" } },
                                            item.user.company && item.user.company.name
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        isRemoved && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'p',
                                            { style: { color: "red", margin: 0 } },
                                            'Removed'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'a',
                                            { style: { textDecoration: "none" }, href: 'mailto:' + email },
                                            email
                                        )
                                    );
                                }
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                                    { key: index },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: _extends({}, __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS, { padding: "5px 5px" }) },
                                        userBlock
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        item.OrderID ? item.OrderID : ''
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        item.packageType ? item.packageType : ''
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        item.TotalAmount ? _this4.changeAmount(item.TotalAmount) + ' uah' : ''
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        item.AltTotalAmount ? _this4.changeAmount(item.AltTotalAmount) + ' usd' : ''
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            item.completedAt && __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.completedAt).format('DD.MM.YYYY')
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            item.completedAt && __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.completedAt).format('hh:mm:ss')
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            item.addedAt && __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.addedAt).format('DD.MM.YYYY')
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            item.addedAt && __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.addedAt).format('hh:mm:ss')
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].tableRowColumnSmallCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            item.TranCode
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            item.status
                                        )
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Subscribers;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var subscribers = _ref.subscribers;
    return { subscribers: subscribers };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ getSubscribers: __WEBPACK_IMPORTED_MODULE_4_actions_users_subscribers__["a" /* getSubscribers */] }, dispatch);
})(Subscribers);

/* harmony default export */ __webpack_exports__["a"] = (_default);

function restoreEmail(email) {
    var match = /^removeduser_[a-z0-9]{10}_(.+)$/i.exec(email);

    return {
        isRemoved: !!match,
        email: match ? match[1] : email,
        raw: email
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Subscribers, 'Subscribers', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Subscribers/Page.jsx');
    reactHotLoader.register(restoreEmail, 'restoreEmail', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Subscribers/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Users/Subscribers/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getSubscribers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getSubscribers(data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_49" /* GET_SUBSCRIBERS */].REQUEST,
        data: data
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getSubscribers, 'getSubscribers', '/opt/atlassian/pipelines/agent/build/client/app/actions/users/subscribers.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_backendNotifications__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Create__ = __webpack_require__(3413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Update__ = __webpack_require__(3414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Delete__ = __webpack_require__(3415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var BackendNotifications = function (_React$Component) {
    _inherits(BackendNotifications, _React$Component);

    function BackendNotifications(props) {
        _classCallCheck(this, BackendNotifications);

        var _this = _possibleConstructorReturn(this, (BackendNotifications.__proto__ || Object.getPrototypeOf(BackendNotifications)).call(this, props));

        _this.state = {
            openCreate: false,
            openUpdate: false,
            openDelete: false,
            current: ''
        };

        _this.toggleCreate = _this.toggleCreate.bind(_this);
        _this.toggleUpdate = _this.toggleUpdate.bind(_this);
        _this.toggleDelete = _this.toggleDelete.bind(_this);
        return _this;
    }

    _createClass(BackendNotifications, [{
        key: 'toggleDelete',
        value: function toggleDelete() {
            var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.setState({
                openDelete: !this.state.openDelete,
                current: current
            });
        }
    }, {
        key: 'toggleCreate',
        value: function toggleCreate() {
            this.setState({
                openCreate: !this.state.openCreate
            });
        }
    }, {
        key: 'toggleUpdate',
        value: function toggleUpdate() {
            var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.setState({
                openUpdate: !this.state.openUpdate,
                current: current
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getBackendNotifications();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                openCreate = _state.openCreate,
                openUpdate = _state.openUpdate,
                openDelete = _state.openDelete,
                current = _state.current;
            var items = this.props.backendNotifications.items;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'sender-page', className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        null,
                        'Notifications list'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Delete__["a" /* default */], {
                        open: openDelete,
                        toggle: this.toggleDelete,
                        deleteId: current
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Update__["a" /* default */], {
                        open: openUpdate,
                        toggle: this.toggleUpdate,
                        updateId: current
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Create__["a" /* default */], {
                        open: openCreate,
                        toggle: this.toggleCreate
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'paper-block margin-10' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-3' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                                    label: 'create',
                                    primary: true,
                                    onClick: this.toggleCreate
                                })
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["u" /* Table */],
                        { selectable: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["w" /* TableHeader */],
                            { displaySelectAll: false, adjustForCheckbox: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'Actual version'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnCSS },
                                    'Message'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Platform'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Required update'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'Show'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    'AddedAt'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    null
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                    { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                    null
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["v" /* TableBody */],
                            { displayRowCheckbox: false },
                            items.map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                                    { key: index },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableRowColumnCSS },
                                        item.actualVersion
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableRowColumnCSS },
                                        item.message
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        item.platform
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        item.requiredUpdate ? 'true' : 'false'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        item.show ? 'true' : 'false'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.addedAt).format('DD.MM.YYYY')
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                                            label: 'delete',
                                            secondary: true,
                                            onClick: function onClick() {
                                                return _this2.toggleDelete(item._id);
                                            }
                                        })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                        { style: __WEBPACK_IMPORTED_MODULE_9_styles__["a" /* default */].tableHeaderColumnSmallCSS },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                                            label: 'update',
                                            primary: true,
                                            onClick: function onClick() {
                                                return _this2.toggleUpdate(item._id);
                                            }
                                        })
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return BackendNotifications;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
    var backendNotifications = _ref.backendNotifications;
    return { backendNotifications: backendNotifications };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ getBackendNotifications: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_backendNotifications__["b" /* getBackendNotifications */] }, dispatch);
})(BackendNotifications);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BackendNotifications, 'BackendNotifications', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/List.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/List.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sagas_notifications_backendNotifications__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _this2 = this;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var platforms = ['iOS', 'Android', 'All'];

var styles = {
    dialog: {
        contentStyle: { width: '300px', padding: '18px' }
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    raisedButton: {
        style: { background: '#7FC931' }
    },
    icon: { color: '#CBCBCB' },
    message: {
        style: { maxHeight: '192px', overflowY: 'scroll' }
    }
};

// import { createBackendNotification } from 'actions/notifications/backendNotifications';

var CreateBackendNotification = function (_React$Component) {
    _inherits(CreateBackendNotification, _React$Component);

    function CreateBackendNotification(props) {
        _classCallCheck(this, CreateBackendNotification);

        return _possibleConstructorReturn(this, (CreateBackendNotification.__proto__ || Object.getPrototypeOf(CreateBackendNotification)).call(this, props));
    }

    _createClass(CreateBackendNotification, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                toggle = _props.toggle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
                {
                    title: 'Do you want to create notification?',
                    modal: false,
                    open: open,
                    onRequestClose: toggle
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { onSubmit: this.props.handleSubmit },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],
                                {
                                    component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["SelectField"],
                                    name: 'platform',
                                    floatingLabelText: 'Platform',
                                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                                    autoWidth: true,
                                    fullWidth: true,
                                    validate: Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["required"])()
                                },
                                platforms.map(function (platform, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                        key: index,
                                        value: platform,
                                        primaryText: platform });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'actualVersion',
                                floatingLabelText: 'ActualVersion',
                                fullWidth: true,
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["required"])({
                                    if: function _if(values) {
                                        return values.platform !== 'All';
                                    }
                                }), Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["format"])({
                                    if: function _if(values) {
                                        return values.platform !== 'All';
                                    },
                                    with: /(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)/,
                                    message: 'format must be 0.0.0'
                                })]
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12', style: styles.message.style },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'message',
                                floatingLabelText: 'Message',
                                fullWidth: true,
                                multiLine: true,
                                rows: 6,
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["required"])(), Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["length"])({ min: 5, max: 1024 })]
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["Checkbox"],
                                name: 'requiredUpdate',
                                label: 'Required Update'
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["Checkbox"],
                                name: 'show',
                                label: 'Show'
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Cancel',
                        primary: true,
                        onClick: toggle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Save',
                        type: 'submit',
                        style: styles.raisedButton.style
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CreateBackendNotification;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var handleSubmit = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, dispatch, props) {
        var response, errors;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        values = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.cloneDeep(values);

                        _context.next = 3;
                        return Object(__WEBPACK_IMPORTED_MODULE_8_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_6_sagas_notifications_backendNotifications__["a" /* createBackendNotification */], values);

                    case 3:
                        response = _context.sent;

                        if (!(response.status !== 200)) {
                            _context.next = 8;
                            break;
                        }

                        errors = {};


                        response.errors.forEach(function (error) {
                            errors = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.merge(errors, __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.set({}, error.field, error.messages[0]));
                        });

                        throw new __WEBPACK_IMPORTED_MODULE_4_redux_form__["c" /* SubmissionError */](errors);

                    case 8:

                        props.toggle();

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this2);
    }));

    return function handleSubmit(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var MyForm = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["g" /* reduxForm */])({
    form: 'notifications/create',
    enableReinitialize: true,
    onSubmit: handleSubmit,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true
})(CreateBackendNotification);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(MyForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(platforms, 'platforms', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Create.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Create.jsx');
    reactHotLoader.register(CreateBackendNotification, 'CreateBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Create.jsx');
    reactHotLoader.register(handleSubmit, 'handleSubmit', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Create.jsx');
    reactHotLoader.register(MyForm, 'MyForm', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Create.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Create.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sagas_notifications_backendNotifications__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_validators__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_formNames__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this2 = this;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var platforms = ['iOS', 'Android', 'All'];

var styles = {
    dialog: {
        contentStyle: { width: '300px', padding: '18px' }
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' }
    },
    raisedButton: {
        style: { background: '#7FC931' }
    },
    icon: { color: '#CBCBCB' },
    message: {
        style: { maxHeight: '192px', overflowY: 'scroll' }
    }
};

// import { createBackendNotification } from 'actions/notifications/backendNotifications';

var CreateBackendNotification = function (_React$Component) {
    _inherits(CreateBackendNotification, _React$Component);

    function CreateBackendNotification(props) {
        _classCallCheck(this, CreateBackendNotification);

        return _possibleConstructorReturn(this, (CreateBackendNotification.__proto__ || Object.getPrototypeOf(CreateBackendNotification)).call(this, props));
    }

    _createClass(CreateBackendNotification, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                toggle = _props.toggle;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */],
                {
                    title: 'Do you want to create notification?',
                    modal: false,
                    open: open,
                    onRequestClose: toggle
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { onSubmit: this.props.handleSubmit },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],
                                {
                                    component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["SelectField"],
                                    name: 'platform',
                                    floatingLabelText: 'Platform',
                                    floatingLabelStyle: styles.textField.floatingLabelStyle,
                                    autoWidth: true,
                                    fullWidth: true,
                                    validate: Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["required"])()
                                },
                                platforms.map(function (platform, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                        key: index,
                                        value: platform,
                                        primaryText: platform });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'actualVersion',
                                floatingLabelText: 'ActualVersion',
                                fullWidth: true,
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["required"])({
                                    if: function _if(values) {
                                        return values.platform !== 'All';
                                    }
                                }), Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["format"])({
                                    if: function _if(values) {
                                        return values.platform !== 'All';
                                    },
                                    with: /(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)/,
                                    message: 'format must be 0.0.0'
                                })]
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-12', style: styles.message.style },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],
                                name: 'message',
                                floatingLabelText: 'Message',
                                fullWidth: true,
                                multiLine: true,
                                rows: 6,
                                floatingLabelStyle: styles.textField.floatingLabelStyle,
                                validate: [Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["required"])({}), Object(__WEBPACK_IMPORTED_MODULE_7_redux_form_validators__["length"])({ min: 5, max: 1024 })]
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["Checkbox"],
                                name: 'requiredUpdate',
                                label: 'Required Update'
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */], {
                                component: __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["Checkbox"],
                                name: 'show',
                                label: 'Show'
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Cancel',
                        primary: true,
                        onClick: toggle
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Save',
                        type: 'submit',
                        style: styles.raisedButton.style
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CreateBackendNotification;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var handleSubmit = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, dispatch, props) {
        var response, errors;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        values = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.cloneDeep(values);

                        _context.next = 3;
                        return Object(__WEBPACK_IMPORTED_MODULE_8_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_6_sagas_notifications_backendNotifications__["c" /* updateBackendNotification */], values);

                    case 3:
                        response = _context.sent;

                        if (!(response.status !== 200)) {
                            _context.next = 8;
                            break;
                        }

                        errors = {};


                        response.errors.forEach(function (error) {
                            errors = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.merge(errors, __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.set({}, error.field, error.messages[0]));
                        });

                        throw new __WEBPACK_IMPORTED_MODULE_4_redux_form__["c" /* SubmissionError */](errors);

                    case 8:

                        props.toggle();

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this2);
    }));

    return function handleSubmit(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var MyForm = Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["g" /* reduxForm */])({
    form: 'notifications/update',
    enableReinitialize: true,
    onSubmit: handleSubmit,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true
})(CreateBackendNotification);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref2, props) {
    var backendNotifications = _ref2.backendNotifications;

    return {
        initialValues: _extends({}, backendNotifications.items.find(function (item) {
            return item._id === props.updateId;
        }))
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({}, dispatch);
})(MyForm);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(platforms, 'platforms', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Update.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Update.jsx');
    reactHotLoader.register(CreateBackendNotification, 'CreateBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Update.jsx');
    reactHotLoader.register(handleSubmit, 'handleSubmit', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Update.jsx');
    reactHotLoader.register(MyForm, 'MyForm', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Update.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Update.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_backendNotifications__ = __webpack_require__(977);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DeleteBackendNotification = function (_React$Component) {
    _inherits(DeleteBackendNotification, _React$Component);

    function DeleteBackendNotification(props) {
        _classCallCheck(this, DeleteBackendNotification);

        var _this = _possibleConstructorReturn(this, (DeleteBackendNotification.__proto__ || Object.getPrototypeOf(DeleteBackendNotification)).call(this, props));

        _this.delete = _this.delete.bind(_this);
        return _this;
    }

    _createClass(DeleteBackendNotification, [{
        key: 'delete',
        value: function _delete() {
            this.props.deleteBackendNotification(this.props.deleteId);
            this.props.toggle();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                toggle = _props.toggle;


            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
                label: 'Yes',
                onClick: this.delete
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["g" /* FlatButton */], {
                label: 'No',
                onClick: toggle
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["f" /* Dialog */], {
                title: 'Do you want to delete notification?',
                modal: false,
                open: open,
                onRequestClose: toggle,
                actions: actions
            });
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return DeleteBackendNotification;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state, props) {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({ deleteBackendNotification: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_backendNotifications__["a" /* deleteBackendNotification */] }, dispatch);
})(DeleteBackendNotification);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DeleteBackendNotification, 'DeleteBackendNotification', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Delete.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/BackendNotifications/Delete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3416 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./": 392,
	"./Base/region": 393,
	"./Base/region.js": 393,
	"./Bulk": 394,
	"./Bulk/": 394,
	"./Bulk/index": 394,
	"./Bulk/index.js": 394,
	"./Bulk/region": 572,
	"./Bulk/region.js": 572,
	"./Mpp": 396,
	"./Mpp/": 396,
	"./Mpp/index": 396,
	"./Mpp/index.js": 396,
	"./Mpp/region": 573,
	"./Mpp/region.js": 573,
	"./RegionModalAdd": 395,
	"./RegionModalAdd.js": 395,
	"./Requests/Item": 574,
	"./Requests/Item.jsx": 574,
	"./Requests/List": 576,
	"./Requests/List.jsx": 576,
	"./Requests/Page": 577,
	"./Requests/Page.jsx": 577,
	"./index": 392,
	"./index.js": 392
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3416;

/***/ }),
/* 3417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FuelEntity__ = __webpack_require__(3418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








var Fuel = function Fuel() {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        fuel = _useState2[0],
        setFuel = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        updating = _useState4[0],
        setUpdating = _useState4[1];

    var getFuelList = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].fuel.fetchList();

                    case 2:
                        result = _context.sent;

                        if (result.status === 200) {
                            setFuel(result.data);
                        }

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    })), []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getFuelList();
    }, []);

    var updateAll = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        setUpdating(true);
                        _context2.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].fuel.updateAll();

                    case 3:
                        result = _context2.sent;

                        if (!(result.status === 200)) {
                            _context2.next = 8;
                            break;
                        }

                        setUpdating(false);
                        _context2.next = 8;
                        return getFuelList();

                    case 8:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    })), []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12 text-center m-v-1' },
                updating ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Updating...'
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
                    label: 'Update all',
                    primary: true,
                    onClick: updateAll,
                    style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                    buttonStyle: { lineHeight: '25px', height: '25px' },
                    labelStyle: { fontSize: '11px' }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'text-center color-common' },
            'Fuel'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["Table"],
            { selectable: false, className: 'fuel-table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeader"],
                { displaySelectAll: false, adjustForCheckbox: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],
                    { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'Name'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'IFO 180'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'IFO 380'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'MGO'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'VLSFO'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'ULSFO'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'LSMGO'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                        null,
                        'Date'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                fuel.length ? fuel.map(function (f) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FuelEntity__["a" /* default */], {
                        data: f,
                        key: 'fuel_price-' + f._id,
                        getFuelList: getFuelList,
                        type: 'mpp'
                    });
                }) : 'No data'
            )
        )
    );
};

var _default = Fuel;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Fuel, 'Fuel', '/opt/atlassian/pipelines/agent/build/client/app/components/Fuel/index.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Fuel/index.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_fuel__ = __webpack_require__(3419);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















var FuelEntity = function FuelEntity(_ref) {
    var initialData = _ref.data,
        getFuelList = _ref.getFuelList;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialData),
        _useState2 = _slicedToArray(_useState, 2),
        data = _useState2[0],
        setData = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState4 = _slicedToArray(_useState3, 2),
        errors = _useState4[0],
        setErrors = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setData(initialData);
    }, [initialData]);

    var handleChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        function validateValue(value) {
            if (typeof value !== 'boolean') {
                var dots = 0;
                value = value.replace(/[^\d|\.|-]/, '').replace(/\./g, function () {
                    return dots++ > 0 ? '' : '.';
                }).replace(/\-/g, function (match, str) {
                    return str === 0 ? '-' : '';
                });
            }
            return value;
        }

        var newData = JSON.parse(JSON.stringify(data));
        var newErrors = {};

        changes.forEach(function (v) {
            __WEBPACK_IMPORTED_MODULE_2_lodash_set___default()(newData, v.key, parseFloat(validateValue(v.value)));
            if (!v.noError) {
                newErrors[v.key] = v.value && typeof v.value !== 'boolean' && !isNaN(parseFloat(v.value)) ? '' : 'required';
            }
        });

        setData(newData);
        setErrors(function (prevErrors) {
            return _extends({}, prevErrors, newErrors);
        });
    }, [data]);

    var save = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!Object.values(errors).some(function (error) {
                            return !!error;
                        })) {
                            _context.next = 2;
                            break;
                        }

                        return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["c" /* showNotification */])('There is an error. Check out inputs', 'error'));

                    case 2:
                        _context.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].fuel.updateOne(data);

                    case 4:
                        result = _context.sent;


                        if (result.status === 200) {
                            Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["c" /* showNotification */])('Fuel has been updated');
                            getFuelList();
                        } else {
                            Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["c" /* showNotification */])(Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["b" /* getNormalErrors */])(result).error, 'error');
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    })), [data, errors, getFuelList]);

    var _data$actualFuelPrice = data.actualFuelPrice,
        actualFuelPrice = _data$actualFuelPrice === undefined ? {} : _data$actualFuelPrice;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRow"],
        { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            { style: {
                    display: 'flex',
                    justifyContent: 'flex-start',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    flexWrap: 'wrap'
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { whiteSpace: 'pre-wrap' } },
                    data.name || 'no name'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_RaisedButton___default.a, {
                    label: 'Update',
                    primary: true,
                    onClick: save,
                    style: { margin: '0 10px 0 25px', lineHeight: '25px', height: '25px' },
                    buttonStyle: { lineHeight: '25px', height: '25px' },
                    labelStyle: { fontSize: '11px' }
                })
            )
        ),
        Object.values(__WEBPACK_IMPORTED_MODULE_9_constants_fuel__["a" /* default */]).map(function (fuelType, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
                { key: fuelType },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                    value: actualFuelPrice[fuelType] || '',
                    hintText: '0',
                    style: { marginLeft: index > 0 ? '10px' : '0' },
                    onChange: function onChange(e, value) {
                        handleChange([{ key: 'actualFuelPrice.' + fuelType, value: value }, { key: 'fuel.' + fuelType, value: value }]);
                    },
                    type: 'number',
                    fullWidth: true,
                    errorText: errors['actualFuelPrice.' + fuelType] ? 'required' : ''
                })
            );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_material_ui_Table__["TableRowColumn"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_moment___default()(actualFuelPrice.date || new Date()).format('DD:MM:YYYY hh:mm')
                )
            )
        )
    );
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(FuelEntity);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FuelEntity, 'FuelEntity', '/opt/atlassian/pipelines/agent/build/client/app/components/Fuel/FuelEntity.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Fuel/FuelEntity.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var FUEL_TYPES = {
    IFO_180: 'ifo180',
    IFO_380: 'ifo380',
    MGO: 'mgo',
    VLSFO: 'vlsfo',
    ULSFO: 'ulsfo',
    LSMGO: 'lsmgo'
};

var _default = FUEL_TYPES;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FUEL_TYPES, 'FUEL_TYPES', '/opt/atlassian/pipelines/agent/build/client/app/constants/fuel.js');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/constants/fuel.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegionModalAdd__ = __webpack_require__(3421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Region__ = __webpack_require__(3422);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var DWT_GROUPS = {
  mpp: {
    '3000_4500': 'DWT 3000-4500',
    '4501_6700': 'DWT 4501-6700',
    '6701_9000': 'DWT 6701-9000',
    '9001_12900': 'DWT 9001-12900',
    '12901_17800': 'DWT 12901-17800',
    '17801_24000': 'DWT 17801-24000'
  },
  bulk: {
    'minibulk': '< 10000 minibulker',
    'handysize': '10000 - 34999 handysize',
    'handymax': '35000 - 59999 handymax (supramax)',
    'panamax': '60000 -79999 panamax (new panamax)',
    'capesize': '80000 - 179999 Capesize',
    'verylarge': '180000 - 320000 VLCC (Very Large Crude Carriers)',
    'ultraverylarge': '> 320000 ULCC (Ultra Large Crude Carriers)'
  }
};
var ROWS = ['averagePortCostsUsdDay'];

var Disbursement = function (_PureComponent) {
  _inherits(Disbursement, _PureComponent);

  function Disbursement() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, Disbursement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Disbursement.__proto__ || Object.getPrototypeOf(Disbursement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      regions: [],
      searchFilter: '',
      isDialogOpened: false,
      unfoldView: localStorage.getItem('unfoldView') ? JSON.parse(localStorage.getItem('unfoldView')) : true
    }, _this.getRegions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].disbursement.fetchList();

            case 2:
              result = _context.sent;


              if (result.status === 200) {
                _this.setState({ regions: result.data });
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.removeRegion = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var result, errors;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].disbursement.remove(id);

              case 2:
                result = _context2.sent;

                if (!(result.status === 200)) {
                  _context2.next = 8;
                  break;
                }

                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])('Region has been removed');
                _context2.next = 7;
                return _this.getRegions();

              case 7:
                return _context2.abrupt('return', _context2.sent);

              case 8:
                errors = Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["b" /* getNormalErrors */])(result);

                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(errors.error, 'error');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), _this.toggleState = function (e) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'isDialogOpened';

      _this.setState(_defineProperty({}, key, !_this.state[key]));
    }, _this.handleChange = function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'searchFilter';
      var value = arguments[1];

      _this.setState(_defineProperty({}, key, value));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Disbursement, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getRegions();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          _state$regions = _state.regions,
          regions = _state$regions === undefined ? [] : _state$regions,
          isDialogOpened = _state.isDialogOpened,
          unfoldView = _state.unfoldView,
          searchFilter = _state.searchFilter;

      var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
        total: 10,
        rowsPerPage: [10],
        page: 1,
        numberOfRows: 10,
        updateRows: function updateRows() {}
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'text-center color-common' },
            'Disbursements'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3', style: {
                  display: 'flex',
                  alignItems: 'center'
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
                label: 'Unfold: ' + unfoldView,
                primary: true,
                onClick: function onClick() {
                  _this3.toggleState(null, 'unfoldView');
                  localStorage.setItem('unfoldView', !unfoldView);
                },
                style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
                buttonStyle: { lineHeight: '25px', height: '25px' },
                labelStyle: { fontSize: '11px' }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-md-3 text-center' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-md-6' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RegionModalAdd__["a" /* default */], {
            isDialogOpened: isDialogOpened,
            toggleDialog: this.toggleState,
            getRegions: this.getRegions,
            config: { dwtGroups: DWT_GROUPS }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
            { selectable: false, className: 'time-charter-table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
              { displaySelectAll: false, adjustForCheckbox: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: { width: '20%' } },
                  'Region'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: { width: '80%' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                    { selectable: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                      {
                        displaySelectAll: false,
                        adjustForCheckbox: false,
                        style: { borderBottom: 'none' }
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                          { colSpan: 2 },
                          'MPP'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                          { colSpan: 2 },
                          'BULK'
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        { style: { borderBottom: 'none' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                          null,
                          'DWT groups (mt)'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                          null,
                          'Average Port Costs, usd/day'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                          null,
                          'DWT groups (mt)'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                          null,
                          'Average Port Costs, usd/day'
                        )
                      )
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
              { displayRowCheckbox: false },
              regions.length ? regions.map(function (r, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Region__["a" /* default */], {
                  data: r,
                  key: 'time-charter-region-' + r._id,
                  ts: Date.now(),
                  removeRegion: _this3.removeRegion,
                  getRegions: _this3.getRegions,
                  dwtGroups: DWT_GROUPS,
                  rows: ROWS,
                  unfold: unfoldView
                });
              }) : 'No data'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'm-v-1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_RaisedButton___default.a, {
              label: '+ Add',
              primary: true,
              onClick: this.toggleState,
              style: { margin: '0 10px 0 0', lineHeight: '25px', height: '25px' },
              buttonStyle: { lineHeight: '25px', height: '25px' },
              labelStyle: { fontSize: '11px' }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-md-6 col-md-offset-6' })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Disbursement;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var _default = Disbursement;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DWT_GROUPS, 'DWT_GROUPS', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/index.js');
  reactHotLoader.register(ROWS, 'ROWS', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/index.js');
  reactHotLoader.register(Disbursement, 'Disbursement', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/index.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/index.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var RegionModalAdd = function (_Component) {
  _inherits(RegionModalAdd, _Component);

  function RegionModalAdd() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, RegionModalAdd);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegionModalAdd.__proto__ || Object.getPrototypeOf(RegionModalAdd)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      data: {},
      areaType: 'port', // port, country
      countries: [],
      areas: [],
      errors: {},
      error: ''
    }, _this.fetchAreas = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value.length < 2)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].findPortAdmin({ name: value });

              case 4:
                result = _context.sent;


                if (result.status === 200) {
                  _this.setState({
                    areas: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(result, 'data.data', []).map(function (ar) {
                      return { title: '' + ar.name + (ar.unLoCode ? ' (' + ar.unLoCode + ')' : ''),
                        value: ar._id };
                    })
                  });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }(), _this.handleChange = function (key) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (key !== '_id') {
        var dots = 0;
        value = value.replace(/[^\d|\.|-]/, '').replace(/\./g, function () {
          return dots++ > 0 ? '' : '.';
        }).replace(/\-/g, function (match, str) {
          return str === 0 ? '-' : '';
        });
      }

      var data = _this.state.data;
      __WEBPACK_IMPORTED_MODULE_1_lodash_set___default()(data, key, value);

      _this.setState({
        data: data,
        errors: _extends({}, _this.state.errors, _defineProperty({}, key, value && (key === '_id' ? true : !isNaN(parseFloat(value))) ? '' : 'required')),
        error: ''
      });
    }, _this.validate = function () {
      var data = _this.state.data;

      var errors = {};

      if (!data._id) {
        errors._id = 'required';
      }

      if (!Object.keys(errors).length) {
        return true;
      }

      _this.setState({ errors: errors });
      return false;
    }, _this.save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$state, data, areaType, type, result;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state = _this.state, data = _this$state.data, areaType = _this$state.areaType;
              type = areaType === 'port' ? 'region' : 'country';

              if (_this.validate()) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_10_helpers__["c" /* showNotification */])('There is an error. Check out inputs', 'error'));

            case 4:
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].disbursement.create(_defineProperty({
                type: areaType
              }, type, data._id));

            case 6:
              result = _context2.sent;

              if (!(result.status === 200)) {
                _context2.next = 12;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_10_helpers__["c" /* showNotification */])('Region has been created');
              _context2.next = 11;
              return _this.props.getRegions();

            case 11:
              return _context2.abrupt('return', _this.props.toggleDialog());

            case 12:

              _this.setState(_extends({}, Object(__WEBPACK_IMPORTED_MODULE_10_helpers__["b" /* getNormalErrors */])(result)));
              Object(__WEBPACK_IMPORTED_MODULE_10_helpers__["c" /* showNotification */])(_this.state.error, 'error');

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RegionModalAdd, [{
    key: 'toggleType',
    value: function toggleType() {
      var _this3 = this;

      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _state$countries = this.state.countries,
          countries = _state$countries === undefined ? [] : _state$countries;


      if (!countries.length && value === 'country') {
        __WEBPACK_IMPORTED_MODULE_9_services__["a" /* default */].getCountries().then(function (countries) {
          return _this3.setState({ countries: countries.data || [] });
        });
      }

      this.setState({ areaType: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          toggleDialog = _props.toggleDialog,
          isDialogOpened = _props.isDialogOpened;
      var _state = this.state,
          data = _state.data,
          error = _state.error,
          areas = _state.areas,
          areaType = _state.areaType,
          _state$countries2 = _state.countries,
          countries = _state$countries2 === undefined ? [] : _state$countries2;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Dialog___default.a,
        {
          title: 'Add new region',
          actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
            label: 'Ok',
            primary: true,
            onClick: this.save
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_FlatButton___default.a, {
            label: 'Cancel',
            primary: true,
            onClick: toggleDialog
          })],
          open: isDialogOpened,
          autoScrollBodyContent: true,
          modal: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'm-b-0' },
          'Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
          {
            value: areaType,
            onChange: function onChange(e, some, value) {
              return _this4.toggleType(value);
            },
            hintText: 'Type',
            floatingLabelText: 'Type',
            fullWidth: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default.a, { key: 'port', value: 'port', primaryText: 'Port' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default.a, { key: 'country', value: 'country', primaryText: 'Country' })
        ),
        areaType === 'port' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a, {
          hintText: 'Name',
          floatingLabelText: 'Name',
          dataSource: areas,
          dataSourceConfig: { text: 'title', value: 'value' },
          onUpdateInput: function onUpdateInput(value) {
            _this4.handleChange('_id', '');_this4.fetchAreas(value);
          },
          onNewRequest: function onNewRequest(selected) {
            return _this4.handleChange('_id', selected.value);
          },
          fullWidth: true,
          filter: __WEBPACK_IMPORTED_MODULE_6_material_ui_AutoComplete___default.a.noFilter,
          menuStyle: { maxHeight: '300px', overflowY: 'auto' },
          errorText: data._id ? '' : 'required'
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_material_ui_SelectField___default.a,
          {
            value: data._id,
            onChange: function onChange(e, some, value) {
              return _this4.handleChange('_id', value);
            },
            hintText: 'Name',
            floatingLabelText: 'Country',
            fullWidth: true,
            errorText: data._id ? '' : 'required'
          },
          countries.map(function (country, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_MenuItem___default.a, {
              key: index,
              value: country._id,
              primaryText: country.name
            });
          })
        ),
        error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'error' },
          error
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RegionModalAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = RegionModalAdd;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RegionModalAdd, 'RegionModalAdd', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/RegionModalAdd.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/RegionModalAdd.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_DropDownMenu__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_DropDownMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_DropDownMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













function transformRegion(region) {
  return _extends({}, region, {
    dwtGroup: Object.keys(region.dwtGroup).reduce(function (res, type) {
      res[type] = region.dwtGroup[type].reduce(function (resType, value) {
        resType[value.nameDwtGroup] = value.averagePortCostsUsdDay;

        return resType;
      }, {});

      return res;
    }, {})
  });
}

var Region = function (_Component) {
  _inherits(Region, _Component);

  function Region(props) {
    var _this2 = this;

    _classCallCheck(this, Region);

    var _this = _possibleConstructorReturn(this, (Region.__proto__ || Object.getPrototypeOf(Region)).call(this, props));

    _this.transformRegion = transformRegion;

    _this.toggleUnfold = function () {
      _this.setState({ unfold: !_this.state.unfold });
    };

    _this.save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$state, data, errors, tcRates, result;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, data = _this$state.data, errors = _this$state.errors;
              tcRates = _this.props.tcRates;

              if (!Object.keys(errors).reduce(function (res, key) {
                if (errors[key]) {
                  res = true;
                  return res;
                }
              }, false)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["c" /* showNotification */])('There is an error. Check out inputs', 'error'));

            case 4:
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].disbursement.updateOne(_extends({}, data, {
                dwtGroup: Object.keys(data.dwtGroup).reduce(function (res, type) {
                  res[type] = Object.keys(data.dwtGroup[type]).reduce(function (resGroup, key) {
                    resGroup.push({
                      nameDwtGroup: key,
                      averagePortCostsUsdDay: data.dwtGroup[type][key]
                    });

                    return resGroup;
                  }, []);

                  return res;
                }, {})
              }));

            case 6:
              result = _context.sent;

              if (!(result.status === 200)) {
                _context.next = 12;
                break;
              }

              Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["c" /* showNotification */])('Region has been updated');
              _context.next = 11;
              return _this.props.getRegions();

            case 11:
              return _context.abrupt('return', _context.sent);

            case 12:

              Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["c" /* showNotification */])(Object(__WEBPACK_IMPORTED_MODULE_8_helpers__["b" /* getNormalErrors */])(result).error, 'error');

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.remove = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.props.removeRegion(_this.state.data._id);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));


    _this.state = {
      data: _this.transformRegion(_this.props.data),
      ts: _this.props.ts,
      unfold: _this.props.unfold,
      defaultUnfold: _this.props.unfold,
      errors: {}
    };
    return _this;
  }

  _createClass(Region, [{
    key: 'handleChange',
    value: function handleChange() {
      var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


      function validateValue(value) {
        if (typeof value !== 'boolean') {
          var dots = 0;
          value = value.replace(/[^\d|\.|-]/, '').replace(/\./g, function () {
            return dots++ > 0 ? '' : '.';
          }).replace(/\-/g, function (match, str) {
            return str === 0 ? '-' : '';
          });
        }
        return value;
      }

      var data = JSON.parse(JSON.stringify(this.state.data));
      var errors = {};

      changes.forEach(function (v) {
        __WEBPACK_IMPORTED_MODULE_1_lodash_set___default()(data, v.key, validateValue(v.value));
        if (!v.noError) {
          errors[v.key] = v.value && typeof v.value !== 'boolean' && !isNaN(parseFloat(v.value)) ? '' : 'required';
        }
      });

      this.setState({
        data: data,
        errors: _extends({}, this.state.errors, errors)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          dwtGroup = _state.data.dwtGroup,
          data = _state.data,
          _state$unfold = _state.unfold,
          unfold = _state$unfold === undefined ? true : _state$unfold,
          errors = _state.errors;
      var dwtGroups = this.props.dwtGroups;

      var name = data.type === 'country' ? __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data, 'country.name', '') + ' (country)' : __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data, 'region.name', '') + ' (port)';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
        { style: { borderBottom: '4px solid rgb(224, 224, 224)' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
          { style: { width: '20%' } },
          unfold ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_material_ui_DropDownMenu___default.a,
              {
                value: 'save',
                style: { padding: 0 },
                onChange: function onChange(e, key, handler) {
                  return _this3[handler]();
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'save', primaryText: 'save' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_MenuItem___default.a, { value: 'remove', primaryText: 'remove' })
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            {
              onClick: this.toggleUnfold,
              style: { cursor: 'pointer' }
            },
            name
          )
        ),
        unfold ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroups.mpp).map(function (key, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                    { key: 'dwt-group-name-' + i },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                      null,
                      dwtGroups.mpp[key]
                    )
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                  { key: 'dwt-group-name-100' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"], null)
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroup.mpp).map(function (key, j) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                    { key: 'tc-rate-' + j },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                        value: dwtGroup.mpp[key],
                        hintText: '0',
                        onChange: function onChange(e, value) {
                          _this3.handleChange([{ key: 'dwtGroup.mpp.' + key, value: value }]);
                        },
                        fullWidth: true,
                        errorText: errors['dwtGroup.mpp.' + key] ? 'required' : ''
                      })
                    )
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                  { key: 'tc-rate-100' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"], null)
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroups.bulk).map(function (key, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                    { key: 'dwt-group-name-' + i },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                      null,
                      dwtGroups.bulk[key]
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                Object.keys(dwtGroup.bulk).map(function (key, j) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                    { key: 'tc-rate-' + j },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_TextField___default.a, {
                        value: dwtGroup.bulk[key],
                        hintText: '0',
                        onChange: function onChange(e, value) {
                          _this3.handleChange([{ key: 'dwtGroup.bulk.' + key, value: value }]);
                        },
                        fullWidth: true,
                        errorText: errors['dwtGroup.bulk.' + key] ? 'required' : ''
                      })
                    )
                  );
                })
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRowColumn"], null)
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(state, 'data._id', null) != __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(props, 'data._id', null) || state.ts != props.ts) {
        var unfoldChange = {};

        if (__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(state, 'defaultUnfold', null) != __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(props, 'unfold', null)) {
          unfoldChange = {
            unfold: props.unfold,
            defaultUnfold: props.unfold
          };
        }

        return _extends({
          data: transformRegion(props.data),
          ts: props.ts
        }, unfoldChange);
      }

      return null;
    }
  }]);

  return Region;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Region;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(transformRegion, 'transformRegion', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/Region.js');
  reactHotLoader.register(Region, 'Region', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/Region.js');
  reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Disbursement/Region.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(3424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_integrators_integrators__ = __webpack_require__(290);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var IntegratorsListPage = function (_Component) {
  _inherits(IntegratorsListPage, _Component);

  function IntegratorsListPage() {
    _classCallCheck(this, IntegratorsListPage);

    return _possibleConstructorReturn(this, (IntegratorsListPage.__proto__ || Object.getPrototypeOf(IntegratorsListPage)).apply(this, arguments));
  }

  _createClass(IntegratorsListPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var getIntegrators = this.props.getIntegrators;

      getIntegrators();
    }
  }, {
    key: "render",
    value: function render() {
      var isLoaded = this.props.isLoaded;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "integrators-list", className: "table-page" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default.a, {
          className: !isLoaded ? "" : "hidden",
          style: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].circularProgress
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: isLoaded ? "" : "hidden" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "container-fluid" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              null,
              "List of Integrators"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */], null)
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return IntegratorsListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (_ref) {
  var integrators = _ref.integrators;

  return {
    isLoaded: integrators.isLoaded,
    integrators: integrators.data
  };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
    getIntegrators: __WEBPACK_IMPORTED_MODULE_6_actions_integrators_integrators__["c" /* getIntegrators */]
  }, dispatch);
})(IntegratorsListPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IntegratorsListPage, "IntegratorsListPage", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/Page.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/Page.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export IntegratorsTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IntegratorRow__ = __webpack_require__(3425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddIntegrator__ = __webpack_require__(3426);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var IntegratorsTable = function (_Component) {
  _inherits(IntegratorsTable, _Component);

  function IntegratorsTable() {
    _classCallCheck(this, IntegratorsTable);

    return _possibleConstructorReturn(this, (IntegratorsTable.__proto__ || Object.getPrototypeOf(IntegratorsTable)).apply(this, arguments));
  }

  _createClass(IntegratorsTable, [{
    key: "render",
    value: function render() {
      var integrators = this.props.integrators;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AddIntegrator__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row", style: { marginTop: "1rem" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "table-body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
              { selectable: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                { displaySelectAll: false, adjustForCheckbox: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                    "Name of company Integrator"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                    "Email of company"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                    "LIST OF API"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                    "API LIMITS (used)"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                    "Token"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                    "Integrator ID"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                integrators.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__IntegratorRow__["a" /* default */], { key: item._id, item: item });
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return IntegratorsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
  var integrators = _ref.integrators;
  return {
    integrators: integrators.data
  };
})(IntegratorsTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IntegratorsTable, "IntegratorsTable", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/Table.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/Table.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export IntegratorRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var IntegratorRow = function (_Component) {
  _inherits(IntegratorRow, _Component);

  function IntegratorRow(props) {
    _classCallCheck(this, IntegratorRow);

    var _this = _possibleConstructorReturn(this, (IntegratorRow.__proto__ || Object.getPrototypeOf(IntegratorRow)).call(this, props));

    _this.copyToClipboard = _this.copyToClipboard.bind(_this);
    return _this;
  }

  _createClass(IntegratorRow, [{
    key: "copyToClipboard",
    value: function copyToClipboard() {
      var _props = this.props,
          token = _props.item.token,
          addNotification = _props.addNotification;

      if (!navigator.clipboard) {
        var textArea = document.createElement("textarea");
        textArea.value = token;
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand('copy');
          addNotification({
            title: "Success copy",
            message: "Token has been copied to clipboard!",
            level: "success",
            _id: new Date().getMilliseconds(),
            autoDismiss: 3
          });
        } catch (err) {
          addNotification({
            title: "Error",
            message: "Error copying token!" + err,
            level: "error",
            _id: new Date().getMilliseconds(),
            autoDismiss: 3
          });
        }

        document.body.removeChild(textArea);
        return;
      }
      navigator.clipboard.writeText(token).then(function () {
        return addNotification({
          title: "Success copy",
          message: "Token has been copied to clipboard!",
          level: "success",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3
        });
      }).catch(function (err) {
        return addNotification({
          title: "Error",
          message: "Error copying token!" + err,
          level: "error",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props$item = this.props.item,
          _props$item$name = _props$item.name,
          name = _props$item$name === undefined ? "-" : _props$item$name,
          _props$item$email = _props$item.email,
          email = _props$item$email === undefined ? "-" : _props$item$email,
          _props$item$token = _props$item.token,
          token = _props$item$token === undefined ? "-" : _props$item$token,
          _props$item$apiList = _props$item.apiList,
          apiList = _props$item$apiList === undefined ? [] : _props$item$apiList,
          _id = _props$item._id;
      var copyToClipboard = this.copyToClipboard;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].tableRowBordered },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */],
            { to: "/integrators/companies/" + _id },
            name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].tableRowBordered },
          email
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].tableRowBordered },
          apiList.map(function (api, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { key: api.name },
              i + 1 + ". API " + api.name
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].tableRowBordered },
          apiList.map(function (api) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { key: api.name },
              api.used
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].tableRowBordered },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].fullHeightFlexContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default.a, {
              style: { alignSelf: "flex-end" },
              label: "COPY",
              onClick: copyToClipboard,
              primary: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].tableRowBordered },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: __WEBPACK_IMPORTED_MODULE_1_styles__["a" /* default */].fullHeightFlexContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              _id
            )
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return IntegratorRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])({
    addNotification: __WEBPACK_IMPORTED_MODULE_5_actions_notifications_notifications__["a" /* addNotification */]
  }, dispatch);
})(IntegratorRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IntegratorRow, "IntegratorRow", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/IntegratorRow.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/IntegratorRow.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export AddIntegrator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_integrators_integrators__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var AddIntegrator = function (_Component) {
  _inherits(AddIntegrator, _Component);

  function AddIntegrator(props) {
    _classCallCheck(this, AddIntegrator);

    var _this = _possibleConstructorReturn(this, (AddIntegrator.__proto__ || Object.getPrototypeOf(AddIntegrator)).call(this, props));

    _this.state = {
      name: "",
      email: "",
      showForm: false,
      errors: {
        name: "",
        email: ""
      }
    };
    _this.form = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.createIntegrator = _this.createIntegrator.bind(_this);
    _this.toggleForm = _this.toggleForm.bind(_this);
    _this.setEmail = _this.setEmail.bind(_this);
    return _this;
  }

  _createClass(AddIntegrator, [{
    key: "setEmail",
    value: function setEmail(_ref) {
      var value = _ref.target.value;

      this.setState(function (state) {
        var obj = {
          email: value
        };
        if (value.match(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* emailRegExp */])) {
          obj.errors = _extends({}, state, {
            email: ""
          });
        }
        return obj;
      });
    }
  }, {
    key: "toggleForm",
    value: function toggleForm() {
      this.setState(function (state) {
        return state.showForm ? { showForm: !state.showForm, name: "", email: "", errors: {} } : { showForm: !state.showForm };
      });
    }
  }, {
    key: "createIntegrator",
    value: function createIntegrator(ev) {
      ev && ev.preventDefault();
      var _state = this.state,
          name = _state.name,
          email = _state.email;

      if (name.length < 1 || email.length < 1) return;
      if (!email.match(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* emailRegExp */])) {
        this.setState(function (state) {
          return {
            errors: _extends({}, state.errors, { email: "Invalid email!" })
          };
        });
        return;
      }
      var _props = this.props,
          addNotification = _props.addNotification,
          getIntegrators = _props.getIntegrators;
      var toggleForm = this.toggleForm;

      __WEBPACK_IMPORTED_MODULE_9_axios___default()({
        method: "post",
        url: "/api/v2/integrators",
        data: {
          name: name,
          email: email
        }
      }).then(function (integrator) {
        addNotification({
          title: "Successful creation",
          message: "Integrator has been successfully created!",
          level: "success",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3
        });
        getIntegrators();
        toggleForm();
      }).catch(function (err) {
        addNotification({
          title: "Creation error",
          message: "Integrator has not been created!" + err,
          level: "error",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var form = this.form,
          createIntegrator = this.createIntegrator,
          toggleForm = this.toggleForm,
          setEmail = this.setEmail;
      var _state2 = this.state,
          name = _state2.name,
          email = _state2.email,
          showForm = _state2.showForm,
          errors = _state2.errors;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "row",
          style: {
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            overflow: "hidden"
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
          onClick: toggleForm,
          label: "Add Integrator",
          secondary: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              maxHeight: showForm ? +form.current.offsetHeight + 100 + "px" : "0px",
              transition: "0.3s ease-in-out"
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "form",
            { ref: form, method: "POST", onSubmit: createIntegrator },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { htmlFor: "name" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  { style: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].textLabel },
                  "Name: "
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                  value: name,
                  style: { marginRight: "1rem" },
                  name: "name",
                  onChange: function onChange(ev) {
                    return _this2.setState({ name: ev.target.value });
                  },
                  onKeyPress: function onKeyPress(ev) {
                    return ev.which === 13 && createIntegrator();
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { htmlFor: "email" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  { style: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].textLabel },
                  "Email: "
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_TextField___default.a, {
                  value: email,
                  name: "email",
                  errorText: errors.email,
                  onChange: setEmail,
                  onKeyPress: function onKeyPress(ev) {
                    return ev.which === 13 && createIntegrator();
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_RaisedButton___default.a, {
              label: "Create integrator",
              primary: true,
              disabled: name.length < 1 || email.length < 1,
              style: { marginTop: "0.5rem" },
              onClick: createIntegrator
            })
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return AddIntegrator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(null, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_6_redux__["bindActionCreators"])({
    addNotification: __WEBPACK_IMPORTED_MODULE_4_actions_notifications_notifications__["a" /* addNotification */],
    getIntegrators: __WEBPACK_IMPORTED_MODULE_7_actions_integrators_integrators__["c" /* getIntegrators */]
  }, dispatch);
})(AddIntegrator);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AddIntegrator, "AddIntegrator", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/AddIntegrator.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/List/AddIntegrator.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export IntegratorCompaniesPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(3428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_integrators_integrators__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(397);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var IntegratorCompaniesPage = function (_Component) {
  _inherits(IntegratorCompaniesPage, _Component);

  function IntegratorCompaniesPage() {
    _classCallCheck(this, IntegratorCompaniesPage);

    return _possibleConstructorReturn(this, (IntegratorCompaniesPage.__proto__ || Object.getPrototypeOf(IntegratorCompaniesPage)).apply(this, arguments));
  }

  _createClass(IntegratorCompaniesPage, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _props = this.props,
          _props$params = _props.params;
      _props$params = _props$params === undefined ? {} : _props$params;
      var _props$params$id = _props$params.id,
          id = _props$params$id === undefined ? "" : _props$params$id,
          getIntegratorCompanies = _props.getIntegratorCompanies,
          page = _props.page,
          limit = _props.limit;

      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* checkParams */])(id);
      getIntegratorCompanies({
        id: id,
        page: page,
        limit: limit
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isLoaded = this.props.isLoaded;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "companies-list", className: "table-page" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default.a, {
          className: !isLoaded ? "" : "hidden",
          style: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].circularProgress
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: isLoaded ? "" : "hidden" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "container-fluid" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              null,
              "Integrator's companies"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */], null)
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return IntegratorCompaniesPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (_ref) {
  var integratorCompanies = _ref.integratorCompanies;
  return {
    isLoaded: integratorCompanies.isLoaded,
    page: integratorCompanies.page,
    limit: integratorCompanies.limit
  };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
    getIntegratorCompanies: __WEBPACK_IMPORTED_MODULE_6_actions_integrators_integrators__["b" /* getIntegratorCompanies */]
  }, dispatch);
})(IntegratorCompaniesPage);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IntegratorCompaniesPage, "IntegratorCompaniesPage", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/Companies/Page.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/Companies/Page.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export IntegratorCompaniesTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_integrators_integrators__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CompanyRow__ = __webpack_require__(3429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_reducers_integrators_user__ = __webpack_require__(734);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var IntegratorCompaniesTable = function (_Component) {
  _inherits(IntegratorCompaniesTable, _Component);

  function IntegratorCompaniesTable(props) {
    _classCallCheck(this, IntegratorCompaniesTable);

    var _this = _possibleConstructorReturn(this, (IntegratorCompaniesTable.__proto__ || Object.getPrototypeOf(IntegratorCompaniesTable)).call(this, props));

    _this.state = {
      filter: "",
      rowsPerPage: [25, 50, 100],
      autocomplete: []
    };
    _this.updateFilter = _this.updateFilter.bind(_this);
    _this.updateRows = _this.updateRows.bind(_this);
    return _this;
  }

  _createClass(IntegratorCompaniesTable, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.companies !== this.props.companies) {
        var autocomplete = nextProps.companies.map(function (c) {
          return c.name.toLowerCase() + " " + c.owner.email.toLowerCase() + " " + c.members.map(function (m) {
            return m.email.toLowerCase();
          });
        }).join(" ").split(" ");
        this.setState({
          autocomplete: autocomplete
        });
      }
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(value) {
      this.setState({
        filter: value
      });
    }
  }, {
    key: "updateRows",
    value: function updateRows(state) {
      var _props = this.props,
          getIntegratorCompanies = _props.getIntegratorCompanies,
          integratorId = _props.integratorId;

      getIntegratorCompanies({
        id: integratorId,
        page: state.page,
        limit: state.numberOfRows
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          companies = _props2.companies,
          page = _props2.page,
          total = _props2.total,
          numberOfRows = _props2.numberOfRows;
      var _state = this.state,
          rowsPerPage = _state.rowsPerPage,
          filter = _state.filter,
          autocomplete = _state.autocomplete;
      var updateFilter = this.updateFilter,
          updateRows = this.updateRows;

      if (filter.length > 0) {
        companies = companies.filter(function (c) {
          var name = String(c.name).toLowerCase();
          var ownerEmail = String(c.owner.email);
          var f = filter.toLowerCase();
          return name.includes(f) || ownerEmail.includes(f) || c.members.some(function (member) {
            return String(member.email).includes(f);
          });
        });
      }

      if (companies.length < 1 && filter.length < 1) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "container-fluid text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            null,
            "Integrator has no companies."
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                display: "flex",
                width: "100%",
                justifyContent: "space-between"
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_AutoComplete___default.a, {
              animated: true,
              hintText: "Enter company name or user's email",
              dataSource: autocomplete,
              filter: function filter(searchText, key) {
                return searchText !== '' && key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
              },
              onUpdateInput: updateFilter,
              textFieldStyle: { width: "300px" }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Libs_Pagination__["a" /* default */], {
              total: total,
              rowsPerPage: rowsPerPage,
              page: page,
              numberOfRows: numberOfRows,
              updateRows: updateRows
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "table-body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["Table"],
              { selectable: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeader"],
                { displaySelectAll: false, adjustForCheckbox: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableRow"],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowBorderedTop },
                    "Email of company"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowBorderedTop },
                    "Company name"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowBorderedTop },
                    "Name, surname of owner"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowBorderedTop },
                    "Email of owner"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowBorderedTop },
                    "Emails of members"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].tableRowBorderedTop },
                    "API limits (used)"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_material_ui_Table__["TableBody"],
                { displayRowCheckbox: false },
                companies.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CompanyRow__["a" /* default */], { key: item._id || item.name, item: item });
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return IntegratorCompaniesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
  var integratorCompanies = _ref.integratorCompanies;
  return {
    companies: integratorCompanies.data,
    page: integratorCompanies.page,
    integratorId: integratorCompanies.integratorId,
    total: integratorCompanies.total || 0,
    numberOfRows: integratorCompanies.limit
  };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
    getIntegratorCompanies: __WEBPACK_IMPORTED_MODULE_4_actions_integrators_integrators__["b" /* getIntegratorCompanies */]
  }, dispatch);
})(IntegratorCompaniesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IntegratorCompaniesTable, "IntegratorCompaniesTable", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/Companies/Table.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/Companies/Table.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export CompanyRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CompanyRow = function (_Component) {
  _inherits(CompanyRow, _Component);

  function CompanyRow() {
    _classCallCheck(this, CompanyRow);

    return _possibleConstructorReturn(this, (CompanyRow.__proto__ || Object.getPrototypeOf(CompanyRow)).apply(this, arguments));
  }

  _createClass(CompanyRow, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$item = _props.item,
          _props$item$name = _props$item.name,
          name = _props$item$name === undefined ? "-" : _props$item$name,
          _props$item$emails = _props$item.emails,
          emails = _props$item$emails === undefined ? [] : _props$item$emails,
          _props$item$members = _props$item.members,
          members = _props$item$members === undefined ? [] : _props$item$members,
          _props$item$owner = _props$item.owner,
          owner = _props$item$owner === undefined ? {} : _props$item$owner,
          _props$item$apiList = _props$item.apiList,
          apiList = _props$item$apiList === undefined ? [] : _props$item$apiList,
          integratorId = _props.integratorId;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRow"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          emails.map(function (email) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { key: email },
              email
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          owner.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */],
            {
              to: "/integrators/" + integratorId + "/user/" + owner._id,
              key: owner._id
            },
            owner.email
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          members.map(function (member) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { key: member._id },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */],
                {
                  to: "/integrators/" + integratorId + "/user/" + member._id,
                  key: member._id
                },
                member.email
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          apiList.map(function (api) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              { key: api.name },
              api.name,
              " - ",
              api.used
            );
          })
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CompanyRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function (_ref) {
  var integratorId = _ref.integratorCompanies.integratorId;
  return { integratorId: integratorId };
}, null)(CompanyRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CompanyRow, "CompanyRow", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/Companies/CompanyRow.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/Companies/CompanyRow.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export IntegratorCompanyUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(3431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_integrators_integrators__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(397);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var IntegratorCompanyUser = function (_Component) {
  _inherits(IntegratorCompanyUser, _Component);

  function IntegratorCompanyUser() {
    _classCallCheck(this, IntegratorCompanyUser);

    return _possibleConstructorReturn(this, (IntegratorCompanyUser.__proto__ || Object.getPrototypeOf(IntegratorCompanyUser)).apply(this, arguments));
  }

  _createClass(IntegratorCompanyUser, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _props = this.props,
          _props$params = _props.params;
      _props$params = _props$params === undefined ? {} : _props$params;
      var _props$params$id = _props$params.id,
          id = _props$params$id === undefined ? "" : _props$params$id,
          _props$params$integra = _props$params.integratorId,
          integratorId = _props$params$integra === undefined ? "" : _props$params$integra,
          getCompanyUser = _props.getCompanyUser;

      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* checkParams */])(id);

      getCompanyUser(id, integratorId);
    }
  }, {
    key: "render",
    value: function render() {
      var isLoaded = this.props.isLoaded;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "companies-list", className: "table-page" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_CircularProgress___default.a, {
          className: !isLoaded ? "" : "hidden",
          style: __WEBPACK_IMPORTED_MODULE_3_styles__["a" /* default */].circularProgress
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: isLoaded ? "" : "hidden" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "container-fluid" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              null,
              "User's statistics"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */], null)
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return IntegratorCompanyUser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (_ref) {
  var companyUser = _ref.companyUser;

  return {
    isLoaded: companyUser.isLoaded
  };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
    getCompanyUser: __WEBPACK_IMPORTED_MODULE_6_actions_integrators_integrators__["a" /* getCompanyUser */]
  }, dispatch);
})(IntegratorCompanyUser);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IntegratorCompanyUser, "IntegratorCompanyUser", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/User/Page.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/User/Page.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export IntegratorCompanyUserTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Rows_UserRow__ = __webpack_require__(3432);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var IntegratorCompanyUserTable = function (_Component) {
  _inherits(IntegratorCompanyUserTable, _Component);

  function IntegratorCompanyUserTable() {
    _classCallCheck(this, IntegratorCompanyUserTable);

    return _possibleConstructorReturn(this, (IntegratorCompanyUserTable.__proto__ || Object.getPrototypeOf(IntegratorCompanyUserTable)).apply(this, arguments));
  }

  _createClass(IntegratorCompanyUserTable, [{
    key: "render",
    value: function render() {
      if (Object.keys(this.props.user).length === 0 && this.props.user.constructor === Object) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "container-fluid text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            null,
            "No user found."
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "table-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
            { selectable: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
              { displaySelectAll: false, adjustForCheckbox: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                  "Email"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                  "Name, surname"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                  "Company name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                  "Subscription"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                  "LIST OF API"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  {
                    style: _extends({}, __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowColumnBigCSS, {
                      padding: "0px",
                      borderTop: "1px solid rgb(224, 224, 224)"
                    })
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
                    { selectable: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeader"],
                      {
                        displaySelectAll: false,
                        adjustForCheckbox: false
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "p",
                            {
                              style: {
                                margin: "10px 0px",
                                textAlign: "center"
                              }
                            },
                            "Limits"
                          )
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
                      { displayRowCheckbox: false },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                        { style: { color: "rgb(158, 158, 158)" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].nestedRowColumn },
                          "Today"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                          {
                            style: _extends({}, __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].nestedRowColumn, {
                              borderLeft: "1px solid rgb(224, 224, 224)",
                              borderRight: "1px solid rgb(224, 224, 224)"
                            })
                          },
                          "Yesterday"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].nestedRowColumn },
                          "Month"
                        )
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableHeaderColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBorderedTop },
                  "USED API LIMITS"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
              { displayRowCheckbox: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Rows_UserRow__["a" /* default */], null)
            )
          )
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return IntegratorCompanyUserTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
  var companyUser = _ref.companyUser;
  return {
    user: companyUser.data
  };
})(IntegratorCompanyUserTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IntegratorCompanyUserTable, "IntegratorCompanyUserTable", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/User/Table.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/User/Table.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export UserRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(397);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var UserRow = function (_Component) {
  _inherits(UserRow, _Component);

  function UserRow() {
    _classCallCheck(this, UserRow);

    return _possibleConstructorReturn(this, (UserRow.__proto__ || Object.getPrototypeOf(UserRow)).apply(this, arguments));
  }

  _createClass(UserRow, [{
    key: "render",
    value: function render() {
      var _props$user = this.props.user,
          _props$user$email = _props$user.email,
          email = _props$user$email === undefined ? "" : _props$user$email,
          _props$user$apiList = _props$user.apiList,
          apiList = _props$user$apiList === undefined ? [] : _props$user$apiList,
          _props$user$company = _props$user.company,
          company = _props$user$company === undefined ? {} : _props$user$company,
          _props$user$endAt = _props$user.endAt,
          endAt = _props$user$endAt === undefined ? "" : _props$user$endAt,
          _props$user$name = _props$user.name,
          name = _props$user$name === undefined ? "" : _props$user$name,
          _props$user$startAt = _props$user.startAt,
          startAt = _props$user$startAt === undefined ? "" : _props$user$startAt,
          _props$user$subscript = _props$user.subscription,
          subscription = _props$user$subscript === undefined ? "" : _props$user$subscript,
          _props$user$surname = _props$user.surname,
          surname = _props$user$surname === undefined ? "" : _props$user$surname;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          email
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          {
            style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered
          },
          name + ", " + surname
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          company.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered },
          subscription
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          {
            style: _extends({}, __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered, { verticalAlign: "top" })
          },
          Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* renderApiList */])(apiList)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          {
            style: _extends({}, __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowColumnBigCSS, { padding: "0px" })
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["Table"],
            { selectable: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableBody"],
              { displayRowCheckbox: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRow"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].nestedRowColumn },
                  Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* renderApiDetails */])(apiList, "today", 'perDayLimit')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                  {
                    style: _extends({}, __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].nestedRowColumn, {
                      borderLeft: "1px solid rgb(224, 224, 224)",
                      borderRight: "1px solid rgb(224, 224, 224)"
                    })
                  },
                  Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* renderApiDetails */])(apiList, "dayBefore", 'perDayLimit')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
                  { style: __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].nestedRowColumn },
                  Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* renderApiDetails */])(apiList, "thisMonth", 'perMonthLimit')
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Table__["TableRowColumn"],
          {
            style: _extends({}, __WEBPACK_IMPORTED_MODULE_2_styles__["a" /* default */].tableRowBordered, {
              padding: "15px",
              height: "100%",
              verticalAlign: "top",
              maxWidth: "200px"
            })
          },
          Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* renderApiDetails */])(apiList, "thisMonth", "perMonthLimit")
        )
      );
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return UserRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref) {
  var companyUser = _ref.companyUser;
  return {
    user: companyUser.data
  };
})(UserRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(UserRow, "UserRow", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/User/Rows/UserRow.jsx");
  reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Integrators/User/Rows/UserRow.jsx");
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_reqldRates_reqRates__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReqLDRatesTable__ = __webpack_require__(3434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var initialFilter = {
    country: { _id: '', name: '' },
    port: { _id: '', name: '' },
    cargo: { _id: '', name: '' },
    minWeight: null,
    maxWeight: null,
    minVolume: null,
    maxVolume: null,
    ld: 'ld'
};

var RequestLDRates = function (_React$Component) {
    _inherits(RequestLDRates, _React$Component);

    function RequestLDRates(props) {
        _classCallCheck(this, RequestLDRates);

        var _this = _possibleConstructorReturn(this, (RequestLDRates.__proto__ || Object.getPrototypeOf(RequestLDRates)).call(this, props));

        _initialiseProps.call(_this);

        var pagination = {
            page: 1,
            limit: 25,
            filter: Object.assign({}, initialFilter)
        };

        _this.state = {
            isLoaded: false,
            rowsPerPage: [10, 25, 50, 100],
            rows: [],
            ports: [],
            cargoes: [],
            numberOfRows: 25,
            pagination: pagination,
            total: props.total,
            reqLDRates: [],
            openAddDialog: false
        };
        return _this;
    }

    _createClass(RequestLDRates, [{
        key: 'UNSAFE_componentWillMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.updateRows(this.state).then(function () {
                                    return _this2.setState({
                                        isLoaded: true
                                    });
                                });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function UNSAFE_componentWillMount() {
                return _ref.apply(this, arguments);
            }

            return UNSAFE_componentWillMount;
        }()
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getCountries();
        }
    }, {
        key: 'updateRows',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state) {
                var pagination;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                pagination = _extends({}, state.pagination);
                                _context2.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_8_store_configureStore__["b" /* execute */])(this.loadRates, pagination);

                            case 3:

                                this.setState({
                                    pagination: pagination
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function updateRows(_x) {
                return _ref2.apply(this, arguments);
            }

            return updateRows;
        }()
    }, {
        key: 'loadRates',
        value: /*#__PURE__*/regeneratorRuntime.mark(function loadRates(pagination) {
            var response;
            return regeneratorRuntime.wrap(function loadRates$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].getReqLDRates, pagination);

                        case 2:
                            response = _context3.sent;

                            if (!(response && response.status === 400)) {
                                _context3.next = 8;
                                break;
                            }

                            pagination.page = 1;
                            _context3.next = 7;
                            return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].getReqLDRates, pagination);

                        case 7:
                            response = _context3.sent;

                        case 8:
                            _context3.next = 10;
                            return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["c" /* put */])({
                                type: __WEBPACK_IMPORTED_MODULE_7_constants_ActionTypes__["_41" /* GET_REQ_LD_RATES */],
                                data: response
                            });

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, loadRates, this);
        })
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                _state$pagination = _state.pagination,
                page = _state$pagination.page,
                limit = _state$pagination.limit,
                _state$pagination$fil = _state$pagination.filter,
                country = _state$pagination$fil.country,
                port = _state$pagination$fil.port,
                cargo = _state$pagination$fil.cargo,
                maxWeight = _state$pagination$fil.maxWeight,
                minWeight = _state$pagination$fil.minWeight,
                maxVolume = _state$pagination$fil.maxVolume,
                minVolume = _state$pagination$fil.minVolume,
                ld = _state$pagination$fil.ld,
                rowsPerPage = _state.rowsPerPage,
                ports = _state.ports,
                cargoes = _state.cargoes,
                openAddDialog = _state.openAddDialog;
            var _props = this.props,
                total = _props.total,
                countries = _props.countries;


            var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
                total: total,
                rowsPerPage: rowsPerPage,
                page: page,
                numberOfRows: limit,
                updateRows: this.handleChangePagination
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_CircularProgress___default.a, {
                    className: !this.state.isLoaded ? '' : 'hidden',
                    style: __WEBPACK_IMPORTED_MODULE_11_styles__["a" /* default */].circularProgress
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: this.state.isLoaded ? '' : 'hidden' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            null,
                            'cargo request LD rates'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-header' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'item' },
                                renderPagination
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14_material_ui__["s" /* SelectField */],
                                    {
                                        style: { width: '300px', marginLeft: '10px' },
                                        floatingLabelText: 'Country',
                                        floatingLabelStyle: { fontSize: '13px' },
                                        maxHeight: 400,
                                        value: country._id,
                                        name: 'countries',
                                        onChange: this.handleSelectCountry
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["m" /* MenuItem */], {
                                        value: '',
                                        primaryText: ''
                                    }),
                                    countries && countries.map(function (country) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["m" /* MenuItem */], {
                                            key: country._id,
                                            value: country._id,
                                            primaryText: country.name
                                        });
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["a" /* AutoComplete */], {
                                    name: 'port',
                                    floatingLabelText: 'Port name',
                                    searchText: port.name,
                                    dataSource: ports,
                                    dataSourceConfig: { text: 'name', value: 'port' },
                                    floatingLabelStyle: { fontSize: '13px' },
                                    onUpdateInput: this.changePortAutoCompete,
                                    onNewRequest: this.choosePortAutoComplete,
                                    filter: __WEBPACK_IMPORTED_MODULE_14_material_ui__["a" /* AutoComplete */].noFilter,
                                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                                    style: { marginLeft: '10px', width: '300px' },
                                    menuStyle: { width: '300px' },
                                    popoverProps: {
                                        canAutoPosition: true
                                    },
                                    fullWidth: true
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["a" /* AutoComplete */], {
                                    name: 'cargo name',
                                    floatingLabelText: 'Cargo name',
                                    searchText: cargo.name,
                                    dataSource: cargoes,
                                    dataSourceConfig: { text: 'name', value: 'cargo' },
                                    floatingLabelStyle: { fontSize: '13px' },
                                    onUpdateInput: this.changeCargoAutoCompete,
                                    onNewRequest: this.chooseCargoAutoComplete,
                                    filter: __WEBPACK_IMPORTED_MODULE_14_material_ui__["a" /* AutoComplete */].noFilter,
                                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                                    style: { marginLeft: '10px', width: '300px' },
                                    menuStyle: { width: '300px' },
                                    popoverProps: {
                                        canAutoPosition: true
                                    },
                                    fullWidth: true
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["r" /* RaisedButton */], {
                                    style: { margin: '27px 0 0 10px' },
                                    primary: true,
                                    label: 'Search',
                                    onClick: this.handleFilter
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["r" /* RaisedButton */], {
                                    style: { margin: '27px 0 0 10px' },
                                    secondary: true,
                                    label: 'Reset',
                                    onClick: this.handleReset
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["r" /* RaisedButton */], {
                                    style: { margin: '27px 0 0 10px' },
                                    backgroundColor: '#a4c639',
                                    labelColor: '#fff',
                                    label: 'ADD',
                                    onClick: this.handleOpenAddDialog
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                    style: { width: '90px', marginLeft: '10px' },
                                    floatingLabelText: 'Min weight',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    type: 'number',
                                    value: minWeight || '',
                                    onChange: function onChange(e) {
                                        return _this3.handleChangeWeightVolume(e, 'minWeight');
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                    style: { width: '90px', marginLeft: '10px' },
                                    floatingLabelText: 'Max weight',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    type: 'number',
                                    value: maxWeight || '',
                                    onChange: function onChange(e) {
                                        return _this3.handleChangeWeightVolume(e, 'maxWeight');
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                    style: { width: '90px', marginLeft: '10px' },
                                    floatingLabelText: 'Min volume',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    type: 'number',
                                    value: minVolume || '',
                                    onChange: function onChange(e) {
                                        return _this3.handleChangeWeightVolume(e, 'minVolume');
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'text-right' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_TextField___default.a, {
                                    style: { width: '90px', marginLeft: '10px' },
                                    floatingLabelText: 'Max volume',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    type: 'number',
                                    value: maxVolume || '',
                                    onChange: function onChange(e) {
                                        return _this3.handleChangeWeightVolume(e, 'maxVolume');
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_14_material_ui__["s" /* SelectField */],
                                    {
                                        style: { width: '90px', marginLeft: '10px' },
                                        floatingLabelText: 'Type',
                                        floatingLabelStyle: { fontSize: '13px' },
                                        maxHeight: 400,
                                        value: ld,
                                        name: 'ld',
                                        onChange: function onChange(e, i, v) {
                                            return _this3.handleSelectLD(v);
                                        }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["m" /* MenuItem */], {
                                        key: 'L/D',
                                        value: 'ld',
                                        primaryText: 'L/D'
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["m" /* MenuItem */], {
                                        key: 'L',
                                        value: 'loading',
                                        primaryText: 'L'
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["m" /* MenuItem */], {
                                        key: 'D',
                                        value: 'discharging',
                                        primaryText: 'D'
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'table-body' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ReqLDRatesTable__["a" /* default */], {
                                rates: this.props.reqLDRates,
                                pagination: this.state.pagination,
                                loadRates: this.loadRates,
                                countries: countries,
                                openAddDialog: openAddDialog,
                                handleOpenAddDialog: this.handleOpenAddDialog
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            renderPagination
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return RequestLDRates;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleChangePagination = function (_ref3) {
        var page = _ref3.page,
            numberOfRows = _ref3.numberOfRows;

        _this4.setState({
            pagination: _extends({}, _this4.state.pagination, {
                page: page,
                limit: numberOfRows
            })
        }, function () {
            _this4.updateRows(_this4.state);
        });
    };

    this.handleSelectCountry = function (e, i) {
        e.preventDefault();
        if (i === 0) {
            _this4.updatePaginationFilter('country', { name: '', _id: '' });
            return;
        }

        var _props$countries = _this4.props.countries[i - 1],
            _id = _props$countries._id,
            name = _props$countries.name;


        _this4.updatePaginationFilter('country', { name: name, _id: _id });
    };

    this.changePortAutoCompete = function (searchPort) {
        _this4.updatePaginationFilter('port', { name: searchPort, _id: '' }, function () {
            var name = _this4.state.pagination.filter.port.name;


            if (name.length < 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].findPortAdmin({ name: name }).then(function (response) {
                if (response.status === 200) {
                    var ports = response.data.data.map(function (port) {
                        return {
                            name: port.country ? port.name + ', ' + port.country.name : port.name,
                            _id: port._id
                        };
                    });

                    _this4.setState({
                        ports: ports
                    });
                }
            }).catch(function (error) {
                console.error('Error AutoComplete ports - port of registry', error);

                return null;
            });
        });
    };

    this.choosePortAutoComplete = function (_ref4) {
        var name = _ref4.name,
            _id = _ref4._id;

        _this4.updatePaginationFilter('port', { name: name, _id: _id });
    };

    this.changeCargoAutoCompete = function (searchCargo) {
        _this4.updatePaginationFilter('cargo', { name: searchCargo, _id: '' }, function () {
            var name = _this4.state.pagination.filter.cargo.name;


            if (name.length < 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_10_services__["a" /* default */].getCargoNamesAutocomplete(name).then(function (response) {
                if (response.status === 200) {
                    var cargoes = response.data.data.map(function (cargo) {
                        return {
                            name: cargo.name,
                            _id: cargo._id
                        };
                    });

                    _this4.setState({
                        cargoes: cargoes
                    });
                }
            }).catch(function (error) {
                console.error('Error AutoComplete cargoes - cargo of registry', error);

                return null;
            });
        });
    };

    this.chooseCargoAutoComplete = function (_ref5) {
        var name = _ref5.name,
            _id = _ref5._id;

        _this4.updatePaginationFilter('cargo', { name: name, _id: _id });
    };

    this.handleChangeWeightVolume = function (e, type) {
        _this4.updatePaginationFilter(type, parseInt(e.target.value));
    };

    this.handleFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var pagination;
        return regeneratorRuntime.wrap(function _callee3$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        pagination = _extends({}, _this4.state.pagination, {
                            page: 1
                        });

                        _this4.setState({
                            pagination: pagination
                        });

                        _context4.next = 4;
                        return Object(__WEBPACK_IMPORTED_MODULE_8_store_configureStore__["b" /* execute */])(_this4.loadRates, pagination);

                    case 4:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee3, _this4);
    }));

    this.handleReset = function () {
        var updateState = {
            pagination: _extends({}, _this4.state.pagination, {
                filter: _extends({}, Object.assign({}, initialFilter))
            }),
            ports: [],
            cargoes: [],
            isLoaded: false
        };

        // this.setState(updateState);
        _this4.updateRows(updateState).then(function () {
            return _this4.setState(_extends({}, updateState, {
                isLoaded: true
            }));
        });
    };

    this.updatePaginationFilter = function (filter, data, cb) {
        _this4.setState({
            pagination: _extends({}, _this4.state.pagination, {
                filter: _extends({}, _this4.state.pagination.filter, _defineProperty({}, filter, data))
            })
        }, cb);
    };

    this.handleOpenAddDialog = function () {
        _this4.setState({
            openAddDialog: !_this4.state.openAddDialog
        });
    };

    this.handleSelectLD = function (val) {
        _this4.updatePaginationFilter('ld', val);
    };
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        reqLDRates: state.reqLDRates.reRatesList,
        total: state.reqLDRates.reqRatesTotalCount,
        countries: state.countries.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getReqRates: __WEBPACK_IMPORTED_MODULE_3_actions_reqldRates_reqRates__["b" /* getReqRates */],
        getCountries: __WEBPACK_IMPORTED_MODULE_4_actions_countries__["a" /* getCountries */]
    }, dispatch);
})(RequestLDRates);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(initialFilter, 'initialFilter', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRates.jsx');
    reactHotLoader.register(RequestLDRates, 'RequestLDRates', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRates.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EditDialog__ = __webpack_require__(3435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_reqldRates_reqRates__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_ActionTypes__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var defaultStyles = {
    textAlign: 'center',
    padding: 0
};

var styles = {
    longText: _extends({}, defaultStyles, {
        width: '120px'
    }),
    middleText: _extends({}, defaultStyles, {
        width: '80px'
    }),
    smallText: _extends({}, defaultStyles, {
        width: '65px'
    })

};

var initialRateEditAddState = {
    _id: '',
    cargoName: '',
    cargoTypeName: '',
    type: '',
    cargoWeight: '',
    cargoVolume: '',
    port: {},
    country: {},
    rate: {}
};

var initialRateDeleteState = {
    _id: ''
};

var ReqLDRatesTable = function (_React$Component) {
    _inherits(ReqLDRatesTable, _React$Component);

    function ReqLDRatesTable(props) {
        var _this2 = this;

        _classCallCheck(this, ReqLDRatesTable);

        var _this = _possibleConstructorReturn(this, (ReqLDRatesTable.__proto__ || Object.getPrototypeOf(ReqLDRatesTable)).call(this, props));

        _this.handleOpenEdit = function (_ref) {
            var _id = _ref._id,
                cargoName = _ref.cargoName,
                cargoTypeName = _ref.cargoTypeName,
                type = _ref.type,
                cargoWeight = _ref.cargoWeight,
                cargoVolume = _ref.cargoVolume,
                port = _ref.port,
                country = _ref.country,
                rate = _ref.rate;

            _this.setState({
                rateEditAdd: {
                    _id: _id, cargoName: cargoName, cargoTypeName: cargoTypeName, type: type, cargoWeight: cargoWeight, cargoVolume: cargoVolume, port: port, country: country, rate: rate
                },
                openEditDialog: true
            });
        };

        _this.handleOpenDelete = function (_id) {
            _this.setState({
                rateDelete: { _id: _id },
                openDeleteDialog: true
            });
        };

        _this.handleRateDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_2_store_configureStore__["b" /* execute */])(_this.deleteRate, _this.state.rateDelete._id);

                        case 2:

                            _this.setState({
                                openDeleteDialog: false,
                                rateDelete: Object.assign({}, initialRateDeleteState)
                            });

                            _context.next = 5;
                            return Object(__WEBPACK_IMPORTED_MODULE_2_store_configureStore__["b" /* execute */])(_this.props.loadRates, _this.props.pagination);

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.handleCloseDialog = function (type) {
            var _this$setState;

            var fields = {};

            switch (type) {
                case 'edit':
                    fields = {
                        dialog: 'openEditDialog',
                        init: Object.assign({}, initialRateEditAddState),
                        state: 'rateEditAdd'
                    };
                    break;
                case 'delete':
                    fields = {
                        dialog: 'openDeleteDialog',
                        init: Object.assign({}, initialRateDeleteState),
                        state: 'rateDelete'
                    };
                    break;
                case 'add':
                    _this.props.handleOpenAddDialog();
                    _this.setState({
                        rateEditAdd: Object.assign({}, initialRateEditAddState)
                    });
                    return;
            }

            _this.setState((_this$setState = {}, _defineProperty(_this$setState, fields.dialog, false), _defineProperty(_this$setState, fields.state, fields.init), _this$setState));
        };

        _this.updateEditAddState = function (type, data, cb) {
            if (!data.hasOwnProperty('value')) {
                _this.setState({
                    rateEditAdd: _extends({}, _this.state.rateEditAdd, _defineProperty({}, type, data))
                }, cb);
            } else {
                _this.setState({
                    rateEditAdd: _extends({}, _this.state.rateEditAdd, {
                        rate: _extends({}, _this.state.rateEditAdd.rate, _defineProperty({}, type, data.value))
                    })
                }, cb);
            }
        };

        _this.handleRateEditAdd = function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(type) {
                var _this$state$rateEditA, cargoName, cargoTypeName, cargoVolume, cargoWeight, country, port, _this$state$rateEditA2, quantity, dimension, response;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this$state$rateEditA = _this.state.rateEditAdd, cargoName = _this$state$rateEditA.cargoName, cargoTypeName = _this$state$rateEditA.cargoTypeName, cargoVolume = _this$state$rateEditA.cargoVolume, cargoWeight = _this$state$rateEditA.cargoWeight, country = _this$state$rateEditA.country, port = _this$state$rateEditA.port, _this$state$rateEditA2 = _this$state$rateEditA.rate, quantity = _this$state$rateEditA2.quantity, dimension = _this$state$rateEditA2.dimension;

                                if (!(!cargoName || !cargoTypeName || !(parseInt(cargoVolume) || parseInt(cargoWeight)) || !country._id || !port._id || !parseInt(quantity) || !dimension)) {
                                    _context2.next = 4;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])('Specify all required fields', 'error');
                                return _context2.abrupt('return');

                            case 4:
                                response = void 0;

                                if (!(type === 'edit')) {
                                    _context2.next = 11;
                                    break;
                                }

                                _context2.next = 8;
                                return Object(__WEBPACK_IMPORTED_MODULE_2_store_configureStore__["b" /* execute */])(_this.editRate, _this.state.rateEditAdd);

                            case 8:
                                response = _context2.sent;
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.next = 13;
                                return Object(__WEBPACK_IMPORTED_MODULE_2_store_configureStore__["b" /* execute */])(_this.addRate, _this.state.rateEditAdd);

                            case 13:
                                response = _context2.sent;

                            case 14:
                                if (response) {
                                    _context2.next = 16;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 16:

                                _this.setState({
                                    openEditDialog: false,
                                    rateEditAdd: Object.assign({}, initialRateEditAddState)
                                });

                                if (!(type === 'add')) {
                                    _context2.next = 20;
                                    break;
                                }

                                _context2.next = 20;
                                return _this.props.handleOpenAddDialog();

                            case 20:
                                _context2.next = 22;
                                return Object(__WEBPACK_IMPORTED_MODULE_2_store_configureStore__["b" /* execute */])(_this.props.loadRates, _this.props.pagination);

                            case 22:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref3.apply(this, arguments);
            };
        }();

        _this.handleSelectCountry = function (e, i) {
            e.preventDefault();
            if (i === 0) {
                _this.updateEditAddState('country', { name: '', _id: '' });
                return;
            }

            var _this$props$countries = _this.props.countries[i],
                _id = _this$props$countries._id,
                name = _this$props$countries.name;


            _this.updateEditAddState('country', { name: name, _id: _id });
        };

        _this.changePortAutoCompete = function (searchPort) {
            _this.updateEditAddState('port', { name: searchPort, _id: '' }, function () {
                var name = _this.state.rateEditAdd.port.name;


                if (name.length < 2) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].findPortAdmin({ name: name }).then(function (response) {
                    if (response.status === 200) {
                        var ports = response.data.data.map(function (port) {
                            return {
                                name: port.country ? port.name + ', ' + port.country.name : port.name,
                                _id: port._id
                            };
                        });

                        _this.setState({
                            ports: ports
                        });
                    }
                }).catch(function (error) {
                    console.error('Error AutoComplete ports - port of registry', error);

                    return null;
                });
            });
        };

        _this.choosePortAutoComplete = function (_ref4) {
            var name = _ref4.name,
                _id = _ref4._id;

            _this.updateEditAddState('port', { name: name.split(',')[0], _id: _id });
        };

        _this.changeCargoAutoCompete = function (searchCargo) {
            _this.updateEditAddState('cargoName', searchCargo, function () {
                var cargoName = _this.state.rateEditAdd.cargoName;


                if (cargoName.length < 2) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].getCargoNamesAutocomplete(cargoName).then(function (response) {
                    if (response.status === 200) {
                        var cargoes = response.data.data.map(function (cargo) {
                            return {
                                name: cargo.name,
                                _id: cargo._id
                            };
                        });

                        _this.setState({
                            cargoes: cargoes
                        });
                    }
                }).catch(function (error) {
                    console.error('Error AutoComplete cargoes - cargo of registry', error);

                    return null;
                });
            });
        };

        _this.chooseCargoAutoComplete = function (_ref5) {
            var name = _ref5.name;

            _this.updateEditAddState('cargoName', name);
        };

        _this.state = {
            openEditDialog: false,
            openDeleteDialog: false,
            rateEditAdd: Object.assign({}, initialRateEditAddState),
            rateDelete: Object.assign({}, initialRateDeleteState),
            ports: [],
            cargoes: []
        };
        return _this;
    }

    _createClass(ReqLDRatesTable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.getCargoTypes();
        }
    }, {
        key: 'deleteRate',
        value: /*#__PURE__*/regeneratorRuntime.mark(function deleteRate(_id) {
            var response;
            return regeneratorRuntime.wrap(function deleteRate$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].deleteReqLDRate, _id);

                        case 2:
                            response = _context3.sent;


                            if (response.status === 200) {
                                Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])(response.data.message, 'success');
                            }

                            _context3.next = 6;
                            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                                type: __WEBPACK_IMPORTED_MODULE_13_constants_ActionTypes__["_41" /* GET_REQ_LD_RATES */],
                                data: response
                            });

                        case 6:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, deleteRate, this);
        })
    }, {
        key: 'editRate',
        value: /*#__PURE__*/regeneratorRuntime.mark(function editRate(data) {
            var response;
            return regeneratorRuntime.wrap(function editRate$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].editReqLDRate, data);

                        case 2:
                            response = _context4.sent;

                            if (!(response.status === 200)) {
                                _context4.next = 7;
                                break;
                            }

                            Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])(response.data.message, 'success');
                            _context4.next = 9;
                            break;

                        case 7:
                            Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])(response.errors[0].message, 'error');
                            return _context4.abrupt('return', false);

                        case 9:
                            _context4.next = 11;
                            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                                type: __WEBPACK_IMPORTED_MODULE_13_constants_ActionTypes__["_2" /* EDIT_REQ_LD_RATES */],
                                data: response
                            });

                        case 11:
                            return _context4.abrupt('return', true);

                        case 12:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, editRate, this);
        })
    }, {
        key: 'addRate',
        value: /*#__PURE__*/regeneratorRuntime.mark(function addRate(data) {
            var response;
            return regeneratorRuntime.wrap(function addRate$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(__WEBPACK_IMPORTED_MODULE_14_services__["a" /* default */].addReqLDRate, data);

                        case 2:
                            response = _context5.sent;

                            if (!(response && response.status === 200)) {
                                _context5.next = 7;
                                break;
                            }

                            Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])(response.data.message, 'success');
                            _context5.next = 9;
                            break;

                        case 7:
                            Object(__WEBPACK_IMPORTED_MODULE_12_helpers__["c" /* showNotification */])(response.errors[0].message, 'error');
                            return _context5.abrupt('return', false);

                        case 9:
                            _context5.next = 11;
                            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])({
                                type: __WEBPACK_IMPORTED_MODULE_13_constants_ActionTypes__["_2" /* EDIT_REQ_LD_RATES */],
                                data: response
                            });

                        case 11:
                            return _context5.abrupt('return', true);

                        case 12:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, addRate, this);
        })
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                rates = _props.rates,
                countries = _props.countries;

            if (!rates) {
                return null;
            }

            var _state = this.state,
                openEditDialog = _state.openEditDialog,
                openDeleteDialog = _state.openDeleteDialog,
                rateEditAdd = _state.rateEditAdd,
                ports = _state.ports,
                cargoes = _state.cargoes;
            var _props2 = this.props,
                openAddDialog = _props2.openAddDialog,
                cargoTypes = _props2.cargoTypes;


            var deleteActions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["g" /* FlatButton */], {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    return _this3.handleCloseDialog('delete');
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["g" /* FlatButton */], {
                label: 'Submit',
                primary: true,
                keyboardFocused: true,
                onClick: this.handleRateDelete
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__EditDialog__["a" /* default */], {
                    openEditDialog: openEditDialog,
                    openAddDialog: openAddDialog,
                    handleCloseDialog: this.handleCloseDialog,
                    handleSelectCountry: this.handleSelectCountry,
                    rateEditAdd: rateEditAdd,
                    countries: countries,
                    ports: ports,
                    cargoes: cargoes,
                    changePortAutoCompete: this.changePortAutoCompete,
                    choosePortAutoComplete: this.choosePortAutoComplete,
                    changeCargoAutoCompete: this.changeCargoAutoCompete,
                    chooseCargoAutoComplete: this.chooseCargoAutoComplete,
                    updateRate: this.updateEditAddState,
                    handleRateEditAdd: this.handleRateEditAdd,
                    cargoTypes: cargoTypes
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_material_ui_Dialog___default.a,
                    {
                        title: 'Delete rate',
                        open: openDeleteDialog,
                        actions: deleteActions,
                        onRequestClose: function onRequestClose() {
                            return _this3.handleCloseDialog('delete');
                        }
                    },
                    'Are you sure you want to delete l/d rate?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["u" /* Table */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["w" /* TableHeader */],
                        {
                            displaySelectAll: false,
                            enableSelectAll: false,
                            adjustForCheckbox: false
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.longText },
                                'Name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.longText },
                                'Type'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'Weight'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'Volume'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'Quantity'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'Dimension'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.longText },
                                'Speed'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'Abbr'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'Term'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'L/D'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'Port'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.middleText },
                                'Country'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */], { style: { width: '40px' } })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["v" /* TableBody */],
                        {
                            displayRowCheckbox: false
                        },
                        rates.map(function (item) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                                {
                                    key: item._id,
                                    displayBorder: true,
                                    selectable: false,
                                    hoverable: true
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: _extends({}, styles.longText, { textAlign: 'start', whiteSpace: 'initial' }) },
                                    item.cargoName
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: _extends({}, styles.longText, { textAlign: 'start', whiteSpace: 'initial' }) },
                                    item.cargoTypeName
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: _extends({}, styles.smallText, { padding: 0 }) },
                                    item.cargoWeight || '-'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    item.cargoVolume || '-'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    item.rate.quantity
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    item.rate.dimension || '-'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: _extends({}, styles.longText, { whiteSpace: 'initial' }) },
                                    item.rate.speed || '-'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    item.rate.abbreviation || '-'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    item.rate.term || '-'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    item.type === 'loading' ? 'L' : 'D'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    item.port.name
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.middleText },
                                    item.country.name
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["z" /* TableRowColumn */],
                                    {
                                        style: { width: '40px', padding: 0 }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_create___default.a, {
                                        cursor: 'pointer',
                                        color: '#09BCD4',
                                        onClick: function onClick() {
                                            return _this3.handleOpenEdit(item);
                                        }
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_action_delete___default.a, {
                                        cursor: 'pointer',
                                        color: '#FF4081',
                                        onClick: function onClick() {
                                            return _this3.handleOpenDelete(item._id);
                                        }
                                    })
                                )
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return ReqLDRatesTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
    return {
        cargoTypes: state.cargoTypes
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        deleteReqRates: __WEBPACK_IMPORTED_MODULE_10_actions_reqldRates_reqRates__["a" /* deleteReqRates */],
        getCargoTypes: __WEBPACK_IMPORTED_MODULE_11_actions_cargoes_types__["a" /* getCargoTypes */]
    }, dispatch);
})(ReqLDRatesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(defaultStyles, 'defaultStyles', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRatesTable.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRatesTable.jsx');
    reactHotLoader.register(initialRateEditAddState, 'initialRateEditAddState', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRatesTable.jsx');
    reactHotLoader.register(initialRateDeleteState, 'initialRateDeleteState', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRatesTable.jsx');
    reactHotLoader.register(ReqLDRatesTable, 'ReqLDRatesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRatesTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/ReqLDRatesTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var types = ['bulk', 'bulktank', 'car', 'cont', 'livestock', 'mpp', 'pass', 'passcar', 'reefer', 'tank', 'sid', 'tween'];

var EditDialog = function (_React$Component) {
    _inherits(EditDialog, _React$Component);

    function EditDialog() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, EditDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditDialog.__proto__ || Object.getPrototypeOf(EditDialog)).call.apply(_ref, [this].concat(args))), _this), _this.handleDimensionSelect = function (e, i, value) {
            _this.props.updateRate('dimension', { value: value });
        }, _this.handleCargoTypeNameSelect = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, i) {
                var cargoTypes;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                cargoTypes = _this.props.cargoTypes;
                                _context.next = 3;
                                return _this.props.updateRate('cargoTypeName', cargoTypes[i].name);

                            case 3:
                                _context.next = 5;
                                return _this.props.updateRate('cargoTypeId', cargoTypes[i]._id);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }(), _this.handleCargoRateTypeSelect = function (e, i, value) {
            _this.props.updateRate('type', value);
        }, _this.handleCargoTypeSelect = function (e, i, value) {
            _this.props.updateRate('cargoType', value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EditDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                openEditDialog = _props.openEditDialog,
                openAddDialog = _props.openAddDialog,
                handleCloseDialog = _props.handleCloseDialog,
                _props$rateEditAdd = _props.rateEditAdd,
                _id = _props$rateEditAdd._id,
                cargoName = _props$rateEditAdd.cargoName,
                cargoTypeName = _props$rateEditAdd.cargoTypeName,
                type = _props$rateEditAdd.type,
                cargoWeight = _props$rateEditAdd.cargoWeight,
                cargoVolume = _props$rateEditAdd.cargoVolume,
                port = _props$rateEditAdd.port,
                country = _props$rateEditAdd.country,
                cargoType = _props$rateEditAdd.cargoType,
                _props$rateEditAdd$ra = _props$rateEditAdd.rate,
                quantity = _props$rateEditAdd$ra.quantity,
                dimension = _props$rateEditAdd$ra.dimension,
                speed = _props$rateEditAdd$ra.speed,
                abbreviation = _props$rateEditAdd$ra.abbreviation,
                term = _props$rateEditAdd$ra.term,
                countries = _props.countries,
                handleSelectCountry = _props.handleSelectCountry,
                ports = _props.ports,
                cargoes = _props.cargoes,
                changePortAutoCompete = _props.changePortAutoCompete,
                choosePortAutoComplete = _props.choosePortAutoComplete,
                updateRate = _props.updateRate,
                handleRateEditAdd = _props.handleRateEditAdd,
                changeCargoAutoCompete = _props.changeCargoAutoCompete,
                chooseCargoAutoComplete = _props.chooseCargoAutoComplete,
                cargoTypes = _props.cargoTypes;


            var editActions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["g" /* FlatButton */], {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    return handleCloseDialog(openEditDialog ? 'edit' : 'add');
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["g" /* FlatButton */], {
                label: 'Submit',
                primary: true,
                onClick: function onClick() {
                    return handleRateEditAdd(openEditDialog ? 'edit' : 'add');
                }
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["f" /* Dialog */],
                    {
                        title: openEditDialog ? 'Edit rate' : 'Add rate',
                        open: openEditDialog || openAddDialog,
                        actions: editActions,
                        onRequestClose: function onRequestClose() {
                            return handleCloseDialog(openEditDialog ? 'edit' : 'add');
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        openEditDialog ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { padding: '10px' } },
                                'Cargo name: ',
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'black' } },
                                    cargoName
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { padding: '10px' } },
                                'Cargo type: ',
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'black' } },
                                    cargoTypeName
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { padding: '10px' } },
                                'L/D: ',
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { style: { color: 'black' } },
                                    type
                                )
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */], {
                                    name: 'cargo name',
                                    floatingLabelText: 'Cargo name',
                                    searchText: cargoName,
                                    dataSource: cargoes,
                                    dataSourceConfig: { text: 'name', value: 'cargo' },
                                    floatingLabelStyle: { fontSize: '13px' },
                                    onUpdateInput: changeCargoAutoCompete,
                                    onNewRequest: chooseCargoAutoComplete,
                                    filter: __WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */].noFilter,
                                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                                    style: { marginLeft: '10px', width: '220px' },
                                    popoverProps: {
                                        canAutoPosition: true
                                    },
                                    errorText: !cargoName && 'Required',
                                    errorStyle: { color: 'red' },
                                    required: true,
                                    fullWidth: true
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
                                    {
                                        floatingLabelText: 'Cargo Type',
                                        style: { width: '220px', marginLeft: '10px' },
                                        floatingLabelStyle: { fontSize: '13px' },
                                        value: cargoTypeName || '',
                                        onChange: this.handleCargoTypeNameSelect,
                                        errorText: !cargoTypeName && 'Required',
                                        errorStyle: { color: 'red' }
                                    },
                                    cargoTypes && cargoTypes.map(function (item) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { key: item._id, value: item.name, primaryText: item.name });
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
                                    {
                                        floatingLabelText: 'Type',
                                        style: { width: '120px', marginLeft: '10px' },
                                        floatingLabelStyle: { fontSize: '13px' },
                                        value: cargoType || '',
                                        onChange: this.handleCargoTypeSelect,
                                        errorText: !cargoType && 'Required',
                                        errorStyle: { color: 'red' }
                                    },
                                    types.map(function (item) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { key: item, value: item, primaryText: item });
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
                                    {
                                        floatingLabelText: 'Rate type',
                                        style: { width: '120px', marginLeft: '10px' },
                                        floatingLabelStyle: { fontSize: '13px' },
                                        value: type || '',
                                        onChange: this.handleCargoRateTypeSelect,
                                        errorText: !type && 'Required',
                                        errorStyle: { color: 'red' }
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'loading', primaryText: 'loading' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'discharging', primaryText: 'discharging' })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
                                {
                                    style: { width: '220px', marginLeft: '10px' },
                                    floatingLabelText: 'Country',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    maxHeight: 400,
                                    value: country._id,
                                    name: 'countries',
                                    onChange: handleSelectCountry,
                                    errorText: !country._id && 'Required',
                                    errorStyle: { color: 'red' }
                                },
                                countries && countries.map(function (country) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], {
                                        key: country._id,
                                        value: country._id,
                                        primaryText: country.name
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */], {
                                name: 'port',
                                floatingLabelText: 'Port name',
                                searchText: port.name,
                                dataSource: ports,
                                dataSourceConfig: { text: 'name', value: 'port' },
                                floatingLabelStyle: { fontSize: '13px' },
                                onUpdateInput: changePortAutoCompete,
                                onNewRequest: choosePortAutoComplete,
                                filter: __WEBPACK_IMPORTED_MODULE_1_material_ui__["a" /* AutoComplete */].noFilter,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                style: { marginLeft: '10px', width: '220px' },
                                popoverProps: {
                                    canAutoPosition: true
                                },
                                fullWidth: true,
                                errorText: !port._id && port.name && 'Wrong port name' || !port._id && !port.name && 'Required',
                                errorStyle: { color: 'red' }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                                style: { width: '100px', marginLeft: '10px' },
                                floatingLabelText: 'Weight',
                                floatingLabelStyle: { fontSize: '13px' },
                                type: 'number',
                                value: cargoWeight || '',
                                onChange: function onChange(e) {
                                    return updateRate('cargoWeight', e.target.value);
                                },
                                errorText: !(parseInt(cargoVolume) || parseInt(cargoWeight)) && 'Required',
                                errorStyle: { color: 'red' }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                                style: { width: '100px', marginLeft: '10px' },
                                floatingLabelText: 'Volume',
                                floatingLabelStyle: { fontSize: '13px' },
                                type: 'number',
                                value: cargoVolume || '',
                                onChange: function onChange(e) {
                                    return updateRate('cargoVolume', e.target.value);
                                },
                                errorText: !(parseInt(cargoVolume) || parseInt(cargoWeight)) && 'Required',
                                errorStyle: { color: 'red' }
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                                style: { width: '100px', marginLeft: '10px' },
                                floatingLabelText: 'Quantity',
                                floatingLabelStyle: { fontSize: '13px' },
                                type: 'number',
                                value: quantity || '',
                                onChange: function onChange(e) {
                                    return updateRate('quantity', { value: e.target.value });
                                },
                                errorText: !parseInt(quantity) && 'Required',
                                errorStyle: { color: 'red' }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
                                {
                                    floatingLabelText: 'Dimension',
                                    style: { width: '100px', marginLeft: '10px' },
                                    floatingLabelStyle: { fontSize: '13px' },
                                    value: dimension || '',
                                    onChange: this.handleDimensionSelect,
                                    errorText: !dimension && 'Required',
                                    errorStyle: { color: 'red' }
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'MT', primaryText: 'MT' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'Days', primaryText: 'Days' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'Hrs', primaryText: 'Hrs' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: 'Cbm', primaryText: 'Cbm' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                                style: { width: '280px', marginLeft: '10px' },
                                floatingLabelText: 'Speed',
                                floatingLabelStyle: { fontSize: '13px' },
                                value: speed || '',
                                onChange: function onChange(e) {
                                    return updateRate('speed', { value: e.target.value });
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                                style: { width: '100px', marginLeft: '10px' },
                                floatingLabelText: 'Abbreviation',
                                floatingLabelStyle: { fontSize: '13px' },
                                value: abbreviation || '',
                                onChange: function onChange(e) {
                                    return updateRate('abbreviation', { value: e.target.value });
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                                style: { width: '100px', marginLeft: '10px' },
                                floatingLabelText: 'Term',
                                floatingLabelStyle: { fontSize: '13px' },
                                value: term || '',
                                onChange: function onChange(e) {
                                    return updateRate('term', { value: e.target.value });
                                }
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return EditDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = EditDialog;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(types, 'types', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/EditDialog.jsx');
    reactHotLoader.register(EditDialog, 'EditDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/EditDialog.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Cargoes/RequestsLDRates/EditDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_statistics_vessel_updater__ = __webpack_require__(3437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss__ = __webpack_require__(3438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var VesselUpdaterPage = function (_React$Component) {
    _inherits(VesselUpdaterPage, _React$Component);

    function VesselUpdaterPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, VesselUpdaterPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VesselUpdaterPage.__proto__ || Object.getPrototypeOf(VesselUpdaterPage)).call.apply(_ref, [this].concat(args))), _this), _this.groups = {
            MarineMap: "marine_traffic/loadMapData",
            MarineShip: "marine_traffic/getShipInfo",
            MarineVesselDetails: "marine_traffic/getVesselDetails",

            ShipnextNewVessel: "shipnext/newVesselOnMonitor",
            ShipnextLocationAvailable: "shipnext/notifyLocationAvailable",
            ShipnextNewPosition: "shipnext/notifyNewPosition",
            ShipnextVesselAvailable: "shipnext/notifyVesselAvailable",

            InternalSaveRoutePoint: "saveRoutePoint",
            InternalScheduleOnRouteUpdates: "scheduleOnRouteUpdates",
            InternalProxyUse: "internal/proxyUse",

            ApiVesselPosition: "api/vesselPosition",
            ApiShipsNearPort: "api/getShipsNearPort",
            ApiShipsDirectingToPort: "api/getShipsDirectingToPort",
            ApiVesselsForceUpdate: "api/scheduleVesselUpdates"
        }, _this.periods = [{
            title: "1s",
            value: "1second",
            fetchCount: 60
        }, {
            title: "1m",
            value: "1minute"
        }, {
            title: "5m",
            value: "5minutes"
        }, {
            title: "10m",
            value: "10minutes"
        }, {
            title: "1h",
            value: "1hour"
        }, {
            title: "1d",
            value: "1day"
        }], _this.state = { periodIndex: 0, data: { "saveRoutePoint": [[1594980000, 0], [1594983600, 0], [1594987200, 1]] } }, _this.setPeriod = function (periodIndex) {
            return function () {
                _this.setState({ periodIndex: periodIndex }, function () {
                    _this.loadData(_this.period);
                });
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(VesselUpdaterPage, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.loadData(this.period);
        }
    }, {
        key: "loadData",
        value: function loadData(period) {
            var _this2 = this;

            Object(__WEBPACK_IMPORTED_MODULE_4_services_statistics_vessel_updater__["a" /* getTimeSeries */])(Object.values(this.groups), period.value, period.fetchCount || 20).then(function (data) {
                _this2.setState(function (state) {
                    return _extends({}, state, {
                        data: _extends({}, state.data, data)
                    });
                });
            });
        }
    }, {
        key: "renderChart",
        value: function renderChart(name) {
            var data = this.state.data;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    null,
                    name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BaseChart, { data: data[name], period: this.period.value })
            );
        }
    }, {
        key: "render",
        value: function render() {
            var periodIndex = this.state.periodIndex;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h3",
                        { style: { textAlign: "center", width: "100%" } },
                        "Vessel-updater stats"
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-1 col-xs-offset-4", style: { display: "flex", alignItems: "center" } },
                        "Period:"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-3" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PeriodSelector, { periods: this.periods, selectedIndex: periodIndex, setPeriod: this.setPeriod })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    null,
                    "MARINE"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-12" },
                        this.renderChart(this.groups.MarineShip)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.MarineMap)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.MarineVesselDetails)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    null,
                    "API"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ApiVesselPosition)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ApiShipsNearPort)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ApiShipsDirectingToPort)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ApiVesselsForceUpdate)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    null,
                    "SHIPNEXT"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ShipnextNewVessel)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ShipnextLocationAvailable)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ShipnextVesselAvailable)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.ShipnextNewPosition)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "p",
                    null,
                    "INTERNAL"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.InternalSaveRoutePoint)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-6" },
                        this.renderChart(this.groups.InternalScheduleOnRouteUpdates)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "col-xs-12" },
                        this.renderChart(this.groups.InternalProxyUse)
                    )
                )
            );
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }, {
        key: "period",
        get: function get() {
            return this.periods[this.state.periodIndex];
        }
    }]);

    return VesselUpdaterPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = VesselUpdaterPage;
/* harmony default export */ __webpack_exports__["a"] = (_default);


function PeriodSelector(_ref2) {
    var periods = _ref2.periods,
        selectedIndex = _ref2.selectedIndex,
        setPeriod = _ref2.setPeriod;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "period-selector" },
        periods.map(function (p, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { key: "period_" + i, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("period", { "selected": i === selectedIndex }), onClick: setPeriod(i) },
                p.title
            );
        })
    );
}

var BaseChart = function (_React$Component2) {
    _inherits(BaseChart, _React$Component2);

    function BaseChart() {
        _classCallCheck(this, BaseChart);

        return _possibleConstructorReturn(this, (BaseChart.__proto__ || Object.getPrototypeOf(BaseChart)).apply(this, arguments));
    }

    _createClass(BaseChart, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.drawChart();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.drawChart();
        }
    }, {
        key: "drawChart",
        value: function drawChart() {
            var _props = this.props,
                _props$data = _props.data,
                data = _props$data === undefined ? [] : _props$data,
                period = _props.period;


            var labels = [];
            var points = [];

            var periodFn = {
                "1second": function second(time) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(time).get("seconds");
                },
                "1minute": function minute(time) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(time).get("minutes");
                },
                "5minutes": function minutes(time) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(time).get("minutes");
                },
                "10minutes": function minutes(time) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(time).get("minutes");
                },
                "1hour": function hour(time) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(time).format("hh");
                },
                "1day": function day(time) {
                    return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(time).format("dd");
                }
            }[period];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    labels.push(periodFn(item[0] * 1000));
                    points.push(item[1]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var datasets = [{
                label: "Real",
                backgroundColor: "rgb(135 197 239)",
                borderColor: "rgb(54, 162, 235)",
                data: points
            }];

            if (!this.chart) {
                this.chart = this.createChart(labels, datasets);
            } else {
                this.chart = this.updateChart(this.chart, labels, datasets);
            }
        }
    }, {
        key: "updateChart",
        value: function updateChart(chart, labels, datasets) {
            chart.clear();
            chart.data.labels = labels;
            chart.data.datasets = datasets;

            chart.update();

            return chart;
        }
    }, {
        key: "createChart",
        value: function createChart(labels, datasets) {
            var ctx = this.refs.chart.getContext("2d");
            var chart = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
                type: "line",
                data: {
                    labels: labels,
                    datasets: datasets
                },
                fill: true,
                options: {
                    tooltips: {
                        mode: "label"
                    },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true
                        }]
                    }
                }
            });

            return chart;
        }
    }, {
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("canvas", { ref: "chart" });
        }
    }, {
        key: "__reactstandin__regenerateByEval",
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return BaseChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselUpdaterPage, "VesselUpdaterPage", "/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/vessel-updater/Page.jsx");
    reactHotLoader.register(PeriodSelector, "PeriodSelector", "/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/vessel-updater/Page.jsx");
    reactHotLoader.register(BaseChart, "BaseChart", "/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/vessel-updater/Page.jsx");
    reactHotLoader.register(_default, "default", "/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/vessel-updater/Page.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getTimeSeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getTimeSeries(groups, period) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: '/vessel-updater/stats?groups=' + groups.join(",") + '&period=' + period + '&count=' + count
    }).then(function (response) {
        return response.data;
    }).catch(function (response) {
        return response.response.data;
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getTimeSeries, 'getTimeSeries', '/opt/atlassian/pipelines/agent/build/client/app/services/statistics/vessel-updater.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3438 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128583
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PdaTable__ = __webpack_require__(3440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PdaFilters__ = __webpack_require__(3442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_countries__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var vesselTypes = ['bulk', 'mpp', 'cont', 'car', 'reefer', 'tank', 'passcar'];

var initialFilter = {
    vessel: { _id: '', name: '', imoNumber: '' },
    vesselType: '',
    port: { _id: '', name: '' },
    country: { _id: '', name: '' },
    dwtMin: null,
    dwtMax: null,
    confirmed: true
};

var pagination = {
    page: 1,
    limit: 25
};

var Pda = function (_React$Component) {
    _inherits(Pda, _React$Component);

    function Pda(props) {
        var _this2 = this;

        _classCallCheck(this, Pda);

        var _this = _possibleConstructorReturn(this, (Pda.__proto__ || Object.getPrototypeOf(Pda)).call(this, props));

        _this.handleChangePagination = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
                var page = _ref2.page,
                    numberOfRows = _ref2.numberOfRows;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this.setState({
                                    pagination: {
                                        page: page,
                                        limit: numberOfRows
                                    }
                                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                                    return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return _this.handleFilter();

                                                case 2:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this2);
                                })));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.modifyFilter = function (field, data, cb) {
            _this.setState({
                filter: _extends({}, _this.state.filter, _defineProperty({}, field, data))
            }, cb);
        };

        _this.handleFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var reqObj, res, _res$data, total, pdas;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            reqObj = _extends({}, _this.state.pagination, {
                                filter: _this.state.filter
                            });
                            _context3.next = 3;
                            return _this.getPdaData(reqObj);

                        case 3:
                            res = _context3.sent;


                            if (res.status === 200) {
                                _res$data = res.data, total = _res$data.total, pdas = _res$data.pdas;

                                _this.setState(_extends({}, _this.state, {
                                    pdas: pdas,
                                    total: total
                                }));
                                Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])('PDA loaded', 'success');
                            } else {
                                Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])(res.errors[0].messages[0], 'error');
                            }

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2);
        }));

        _this.handleModifyPdaState = function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(index) {
                var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var data = arguments[2];
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (field) {
                                    _this.setState(function (_ref6) {
                                        var pdas = _ref6.pdas;
                                        return {
                                            pdas: [].concat(_toConsumableArray(pdas.slice(0, index - 1)), [_extends({}, pdas[index], _defineProperty({}, field, data))], _toConsumableArray(pdas.slice(index + 1)))
                                        };
                                    });
                                }

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this2);
            }));

            return function (_x2) {
                return _ref5.apply(this, arguments);
            };
        }();

        _this.handleOpenAddDialog = function () {
            _this.setState({
                openAddDialog: !_this.state.openAddDialog
            });
        };

        _this.handleReset = function () {
            _this.setState({
                filter: _extends({}, Object.assign({}, initialFilter)),
                pagination: pagination
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this.handleFilter();

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this2);
            })));
        };

        _this.state = {
            isLoaded: false,
            rowsPerPage: [10, 25, 50, 100],
            total: 0,
            pagination: pagination,
            pdas: [],
            countries: [],
            filter: Object.assign({}, initialFilter),
            openAddDialog: false
        };
        return _this;
    }

    _createClass(Pda, [{
        key: 'UNSAFE_componentWillMount',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var _state, _state$pagination, page, limit, filter, res, _res$data2, total, pdas;

                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _state = this.state, _state$pagination = _state.pagination, page = _state$pagination.page, limit = _state$pagination.limit, filter = _state.filter;


                                this.props.getCountries();

                                _context6.next = 4;
                                return this.getPdaData({ page: page, limit: limit, filter: filter });

                            case 4:
                                res = _context6.sent;

                                if (res.status === 200) {
                                    _res$data2 = res.data, total = _res$data2.total, pdas = _res$data2.pdas;

                                    this.setState({
                                        pdas: pdas,
                                        total: total,
                                        isLoaded: true
                                    });
                                    Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])('PDA loaded', 'success');
                                } else {
                                    Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* showNotification */])(res.errors[0].messages[0], 'error');
                                }

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function UNSAFE_componentWillMount() {
                return _ref8.apply(this, arguments);
            }

            return UNSAFE_componentWillMount;
        }()
    }, {
        key: 'getPdaData',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(data) {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].pdaGetAll(data);

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function getPdaData(_x4) {
                return _ref9.apply(this, arguments);
            }

            return getPdaData;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                total = _state2.total,
                rowsPerPage = _state2.rowsPerPage,
                _state2$pagination = _state2.pagination,
                page = _state2$pagination.page,
                limit = _state2$pagination.limit,
                filter = _state2.filter,
                pdas = _state2.pdas,
                openAddDialog = _state2.openAddDialog;
            var countries = this.props.countries;


            var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Libs_Pagination__["a" /* default */], {
                total: total,
                rowsPerPage: rowsPerPage,
                page: page,
                numberOfRows: limit,
                updateRows: this.handleChangePagination
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        null,
                        'Pda'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'table-header' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'item' },
                            renderPagination
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PdaFilters__["a" /* default */], {
                        filter: filter,
                        modifyFilter: this.modifyFilter,
                        handleFilter: this.handleFilter,
                        handleOpenAddDialog: this.handleOpenAddDialog,
                        vesselTypes: vesselTypes,
                        handleReset: this.handleReset
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_CircularProgress___default.a, {
                        className: !this.state.isLoaded ? '' : 'hidden',
                        style: __WEBPACK_IMPORTED_MODULE_8_styles__["a" /* default */].circularProgress
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: this.state.isLoaded ? 'table-body' : 'table-body hidden' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PdaTable__["a" /* default */], {
                            pdas: pdas,
                            handleModifyPdaState: this.handleModifyPdaState,
                            handleOpenAddDialog: this.handleOpenAddDialog,
                            handleFilter: this.handleFilter,
                            countries: countries,
                            openAddDialog: openAddDialog,
                            vesselTypes: vesselTypes,
                            shouldShowConfirmCheckbox: !filter.confirmed
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Pda;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(function (state) {
    return {
        countries: state.countries.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({
        getCountries: __WEBPACK_IMPORTED_MODULE_7_actions_countries__["a" /* getCountries */]
    }, dispatch);
})(Pda);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(vesselTypes, 'vesselTypes', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/Pda.jsx');
    reactHotLoader.register(initialFilter, 'initialFilter', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/Pda.jsx');
    reactHotLoader.register(pagination, 'pagination', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/Pda.jsx');
    reactHotLoader.register(Pda, 'Pda', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/Pda.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/Pda.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditAddDialog__ = __webpack_require__(3441);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var defaultStyles = {
    textAlign: 'center',
    padding: 0
};

var styles = {
    longText: _extends({}, defaultStyles, {
        width: '120px'
    }),
    middleText: _extends({}, defaultStyles, {
        width: '80px'
    }),
    smallText: _extends({}, defaultStyles, {
        width: '65px'
    })

};

var initialPdaEditAddState = {
    _id: '',
    approved: true,
    averagePortCostsUsdDay: null,
    param: {
        country: {},
        port: {},
        vessel: {},
        dwt: '',
        ourGroup: ''
    }
};

var initialPdaDeleteState = {
    _id: ''
};

var PdaTable = function (_React$Component) {
    _inherits(PdaTable, _React$Component);

    function PdaTable(props) {
        var _this2 = this;

        _classCallCheck(this, PdaTable);

        var _this = _possibleConstructorReturn(this, (PdaTable.__proto__ || Object.getPrototypeOf(PdaTable)).call(this, props));

        _this.handleCloseDialog = function (type) {
            var _this$setState;

            var fields = {};

            switch (type) {
                case 'edit':
                    fields = {
                        dialog: 'openEditDialog',
                        init: Object.assign({}, initialPdaEditAddState),
                        state: 'pdaEditAdd'
                    };
                    break;
                case 'delete':
                    fields = {
                        dialog: 'openDeleteDialog',
                        init: Object.assign({}, initialPdaDeleteState),
                        state: 'rateDelete'
                    };
                    break;
                case 'add':
                    _this.props.handleOpenAddDialog();
                    _this.setState({
                        pdaEditAdd: Object.assign({}, initialPdaEditAddState)
                    });
                    return;
            }

            _this.setState((_this$setState = {}, _defineProperty(_this$setState, fields.dialog, false), _defineProperty(_this$setState, fields.state, fields.init), _this$setState));
        };

        _this.handleOpenDelete = function (_id) {
            _this.setState({
                pdaDelete: { _id: _id },
                openDeleteDialog: true
            });
        };

        _this.handlePdaDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var res;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].pdaDelete(_this.state.pdaDelete._id);

                        case 2:
                            res = _context.sent;


                            if (res.status === 200) {
                                _this.setState({
                                    openDeleteDialog: false,
                                    pdaDelete: Object.assign({}, initialPdaDeleteState)
                                });
                                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])('PDA deleted', 'success');
                            } else {
                                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(res.errors[0].messages[0], 'error');
                            }
                            _this.props.handleFilter();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.handleOpenEdit = function (pdaEditAdd) {
            _this.setState({
                pdaEditAdd: pdaEditAdd,
                openEditDialog: true
            });
        };

        _this.handleSelectCountry = function (e, i) {
            e.preventDefault();
            if (i === 0) {
                _this.updateEditAddState('country', { value: { name: '', _id: '' } });
                return;
            }

            var _this$props$countries = _this.props.countries[i],
                _id = _this$props$countries._id,
                name = _this$props$countries.name;


            _this.updateEditAddState('country', { value: { name: name, _id: _id } });
        };

        _this.updateEditAddState = function (type, data, cb) {
            if (!data.hasOwnProperty('value')) {
                _this.setState({
                    pdaEditAdd: _extends({}, _this.state.pdaEditAdd, _defineProperty({}, type, data))
                }, cb);
            } else {
                _this.setState({
                    pdaEditAdd: _extends({}, _this.state.pdaEditAdd, {
                        param: _extends({}, _this.state.pdaEditAdd.param, _defineProperty({}, type, data.value))
                    })
                }, cb);
            }
        };

        _this.changeVesselAutoComplete = function (searchVessel) {
            _this.updateEditAddState('vessel', { value: { _id: _this.state.pdaEditAdd.param.vessel._id, name: searchVessel } }, function () {
                if (!searchVessel) {
                    _this.updateEditAddState('vessel', { value: { _id: '', name: searchVessel } });
                }
                if (searchVessel.length < 2) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findVessel(searchVessel).then(function (response) {
                    var vessels = response.data.data.map(function (vessel) {
                        return {
                            name: vessel.name + ' (' + vessel.imoNumber + ')',
                            item: vessel
                        };
                    });

                    _this.setState({
                        vessels: vessels
                    });
                }).catch(function (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(e, 'error');
                });
            });
        };

        _this.chooseVesselAutoComplete = function (_ref2) {
            var name = _ref2.name,
                _ref2$item = _ref2.item,
                _id = _ref2$item._id,
                imoNumber = _ref2$item.imoNumber;

            _this.updateEditAddState('vessel', { value: { _id: _id, name: name, imoNumber: imoNumber } });
        };

        _this.handleSelectVesselType = function (e) {
            e.preventDefault();
            _this.updateEditAddState('ourGroup', { value: e.target.innerText });
        };

        _this.handleChangeDwt = function (e) {
            e.preventDefault();
            _this.updateEditAddState('dwt', { value: e.target.value });
        };

        _this.handleChangePda = function (e) {
            e.preventDefault();
            _this.updateEditAddState('averagePortCostsUsdDay', parseInt(e.target.value).toFixed());
        };

        _this.changePortName = function (searchPort) {
            _this.updateEditAddState('port', { value: { _id: _this.state.pdaEditAdd.param.port._id, name: searchPort } }, function () {
                if (!searchPort) {
                    _this.updateEditAddState('port', { value: { _id: '', name: searchPort } });
                }
                if (searchPort.length < 2) {
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findPortAdmin({ name: searchPort }).then(function (response) {
                    var ports = response.data.data.map(function (port) {
                        return {
                            name: '' + port.name,
                            item: port
                        };
                    });

                    _this.setState({
                        ports: ports
                    });
                }).catch(function (e) {
                    Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(e, 'error');
                });
            });
        };

        _this.choosePort = function (_ref3) {
            var name = _ref3.name,
                _id = _ref3.item._id;

            _this.updateEditAddState('port', { value: { _id: _id, name: name } });
        };

        _this.handleCheckConfirmed = function () {
            _this.updateEditAddState('approved', !_this.state.pdaEditAdd.approved);
        };

        _this.handleRateEditAdd = function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type) {
                var _this$state$pdaEditAd, _id, averagePortCostsUsdDay, approved, _this$state$pdaEditAd2, country, port, vessel, dwt, ourGroup, body, response;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _this$state$pdaEditAd = _this.state.pdaEditAdd, _id = _this$state$pdaEditAd._id, averagePortCostsUsdDay = _this$state$pdaEditAd.averagePortCostsUsdDay, approved = _this$state$pdaEditAd.approved, _this$state$pdaEditAd2 = _this$state$pdaEditAd.param, country = _this$state$pdaEditAd2.country, port = _this$state$pdaEditAd2.port, vessel = _this$state$pdaEditAd2.vessel, dwt = _this$state$pdaEditAd2.dwt, ourGroup = _this$state$pdaEditAd2.ourGroup;

                                if (!(!parseInt(averagePortCostsUsdDay) || !country._id || !port._id || !vessel._id || !parseInt(dwt) || !ourGroup)) {
                                    _context3.next = 4;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])('Specify all required fields', 'error');
                                return _context3.abrupt('return');

                            case 4:
                                body = {
                                    _id: _id,
                                    averagePortCostsUsdDay: parseInt(averagePortCostsUsdDay),
                                    approved: approved,
                                    param: {
                                        portID: port._id,
                                        countryID: country._id,
                                        dwt: dwt,
                                        ourGroup: ourGroup,
                                        vesselId: vessel._id
                                    }
                                };
                                response = void 0;

                                if (!(type === 'edit')) {
                                    _context3.next = 12;
                                    break;
                                }

                                _context3.next = 9;
                                return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].pdaUpdate(body);

                            case 9:
                                response = _context3.sent;
                                _context3.next = 15;
                                break;

                            case 12:
                                _context3.next = 14;
                                return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].pdaAdd(body);

                            case 14:
                                response = _context3.sent;

                            case 15:
                                if (!(response.status !== 200)) {
                                    _context3.next = 18;
                                    break;
                                }

                                Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])(response.errors[0].messages[0], 'error');
                                return _context3.abrupt('return');

                            case 18:

                                type === 'add' && _this.props.handleOpenAddDialog();
                                _this.setState({
                                    openEditDialog: false,
                                    pdaEditAdd: Object.assign({}, initialPdaEditAddState)
                                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    Object(__WEBPACK_IMPORTED_MODULE_5_helpers__["c" /* showNotification */])('PDA ' + (type === 'add' ? 'created' : 'modified'), 'success');
                                                    _context2.next = 3;
                                                    return _this.props.handleFilter();

                                                case 3:
                                                case 'end':
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, _this2);
                                })));

                            case 20:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }));

            return function (_x) {
                return _ref4.apply(this, arguments);
            };
        }();

        _this.state = {
            openDeleteDialog: false,
            openEditDialog: false,
            vessels: [],
            ports: [],
            pdaEditAdd: Object.assign({}, initialPdaEditAddState),
            pdaDelete: Object.assign({}, initialPdaDeleteState)
        };
        return _this;
    }

    _createClass(PdaTable, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                pdas = _props.pdas,
                countries = _props.countries,
                openAddDialog = _props.openAddDialog,
                handleOpenAddDialog = _props.handleOpenAddDialog,
                vesselTypes = _props.vesselTypes,
                shouldShowConfirmCheckbox = _props.shouldShowConfirmCheckbox;
            var _state = this.state,
                openDeleteDialog = _state.openDeleteDialog,
                openEditDialog = _state.openEditDialog,
                vessels = _state.vessels,
                ports = _state.ports,
                pdaEditAdd = _state.pdaEditAdd;


            var deleteActions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["g" /* FlatButton */], {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    return _this3.handleCloseDialog('delete');
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["g" /* FlatButton */], {
                label: 'Delete',
                primary: true,
                keyboardFocused: true,
                onClick: this.handlePdaDelete
            })];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EditAddDialog__["a" /* default */], {
                    openAddDialog: openAddDialog,
                    openEditDialog: openEditDialog,
                    countries: countries,
                    handleCloseDialog: this.handleCloseDialog,
                    handleSelectCountry: this.handleSelectCountry,
                    handleOpenAddDialog: handleOpenAddDialog,
                    vesselTypes: vesselTypes,
                    vessels: vessels,
                    ports: ports,
                    pdaEditAdd: pdaEditAdd,
                    changeVesselAutoComplete: this.changeVesselAutoComplete,
                    chooseVesselAutoComplete: this.chooseVesselAutoComplete,
                    handleSelectVesselType: this.handleSelectVesselType,
                    handleChangeDwt: this.handleChangeDwt,
                    handleChangePda: this.handleChangePda,
                    changePortName: this.changePortName,
                    choosePort: this.choosePort,
                    handleCheckConfirmed: this.handleCheckConfirmed,
                    handleRateEditAdd: this.handleRateEditAdd,
                    shouldShowConfirmCheckbox: shouldShowConfirmCheckbox
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["f" /* Dialog */],
                    {
                        title: 'Delete rate',
                        open: openDeleteDialog,
                        actions: deleteActions,
                        onRequestClose: function onRequestClose() {
                            return _this3.handleCloseDialog('delete');
                        }
                    },
                    'Are you sure you want to delete pda?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["w" /* TableHeader */],
                        {
                            displaySelectAll: false,
                            enableSelectAll: false,
                            adjustForCheckbox: false
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.longText },
                                'Vessel'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.middleText },
                                'Vessel Type'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'DWT'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.longText },
                                'Port'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.smallText },
                                'P D/A'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: styles.middleText },
                                'Country'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */], { style: styles.smallText })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
                        {
                            displayRowCheckbox: false
                        },
                        pdas && pdas.map(function (item, index) {
                            var averagePortCostsUsdDay = item.averagePortCostsUsdDay,
                                _item$param = item.param,
                                country = _item$param.country,
                                dwt = _item$param.dwt,
                                ourGroup = _item$param.ourGroup,
                                port = _item$param.port,
                                vessel = _item$param.vessel;


                            if (vessel.imoNumber && !vessel.name.includes(' (')) {
                                vessel.name = vessel.name + ' (' + vessel.imoNumber + ')';
                            }

                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                {
                                    key: item._id,
                                    displayBorder: true,
                                    selectable: false,
                                    hoverable: true
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.longText },
                                    vessel.name
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.middleText },
                                    ourGroup
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    dwt
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.longText },
                                    port.name
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.smallText },
                                    averagePortCostsUsdDay.toFixed()
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                    { style: styles.middleText },
                                    country.name
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                    {
                                        style: styles.smallText
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_create___default.a, {
                                        cursor: 'pointer',
                                        color: '#09BCD4',
                                        onClick: function onClick() {
                                            return _this3.handleOpenEdit(item);
                                        }
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete___default.a, {
                                        cursor: 'pointer',
                                        color: '#FF4081',
                                        onClick: function onClick() {
                                            return _this3.handleOpenDelete(item._id);
                                        }
                                    })
                                )
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PdaTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = PdaTable;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(defaultStyles, 'defaultStyles', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaTable.jsx');
    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaTable.jsx');
    reactHotLoader.register(initialPdaEditAddState, 'initialPdaEditAddState', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaTable.jsx');
    reactHotLoader.register(initialPdaDeleteState, 'initialPdaDeleteState', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaTable.jsx');
    reactHotLoader.register(PdaTable, 'PdaTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var EditAddDialog = function (_React$Component) {
    _inherits(EditAddDialog, _React$Component);

    function EditAddDialog() {
        _classCallCheck(this, EditAddDialog);

        return _possibleConstructorReturn(this, (EditAddDialog.__proto__ || Object.getPrototypeOf(EditAddDialog)).apply(this, arguments));
    }

    _createClass(EditAddDialog, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                openEditDialog = _props.openEditDialog,
                openAddDialog = _props.openAddDialog,
                handleCloseDialog = _props.handleCloseDialog,
                vessels = _props.vessels,
                ports = _props.ports,
                countries = _props.countries,
                vesselTypes = _props.vesselTypes,
                _props$pdaEditAdd = _props.pdaEditAdd,
                _id = _props$pdaEditAdd._id,
                approved = _props$pdaEditAdd.approved,
                averagePortCostsUsdDay = _props$pdaEditAdd.averagePortCostsUsdDay,
                _props$pdaEditAdd$par = _props$pdaEditAdd.param,
                country = _props$pdaEditAdd$par.country,
                port = _props$pdaEditAdd$par.port,
                vessel = _props$pdaEditAdd$par.vessel,
                dwt = _props$pdaEditAdd$par.dwt,
                ourGroup = _props$pdaEditAdd$par.ourGroup,
                changeVesselAutoComplete = _props.changeVesselAutoComplete,
                chooseVesselAutoComplete = _props.chooseVesselAutoComplete,
                handleSelectVesselType = _props.handleSelectVesselType,
                handleChangeDwt = _props.handleChangeDwt,
                handleChangePda = _props.handleChangePda,
                handleSelectCountry = _props.handleSelectCountry,
                changePortName = _props.changePortName,
                choosePort = _props.choosePort,
                handleCheckConfirmed = _props.handleCheckConfirmed,
                handleRateEditAdd = _props.handleRateEditAdd,
                shouldShowConfirmCheckbox = _props.shouldShowConfirmCheckbox;


            if (vessel.imoNumber && !vessel.name.includes(' (')) {
                vessel.name = vessel.name + ' (' + vessel.imoNumber + ')';
            }

            var editActions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'Cancel',
                primary: true,
                onClick: function onClick() {
                    return handleCloseDialog(openEditDialog ? 'edit' : 'add');
                }
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'Save',
                primary: true,
                onClick: function onClick() {
                    return handleRateEditAdd(openEditDialog ? 'edit' : 'add');
                }
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default.a,
                    {
                        title: openEditDialog ? 'Edit pda' : 'Add pda',
                        open: openEditDialog || openAddDialog,
                        actions: editActions,
                        onRequestClose: function onRequestClose() {
                            return handleCloseDialog(openEditDialog ? 'edit' : 'add');
                        }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */], {
                                name: 'vessel name',
                                floatingLabelText: 'Vessel name',
                                searchText: vessel.name,
                                dataSource: vessels,
                                dataSourceConfig: { text: 'name', value: 'cargo' },
                                floatingLabelStyle: { fontSize: '13px' },
                                onUpdateInput: changeVesselAutoComplete,
                                onNewRequest: chooseVesselAutoComplete,
                                filter: __WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */].noFilter,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                style: { marginLeft: '10px', width: '220px' },
                                popoverProps: {
                                    canAutoPosition: true
                                },
                                errorText: !vessel.name && 'Required',
                                errorStyle: { color: 'red' },
                                required: true,
                                fullWidth: true
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                                {
                                    style: { width: '130px', marginLeft: '10px' },
                                    floatingLabelText: 'Vessel Type',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    maxHeight: 400,
                                    value: ourGroup,
                                    name: 'Vessel Types',
                                    autoWidth: true,
                                    errorText: !ourGroup && 'Required',
                                    errorStyle: { color: 'red' },
                                    onChange: handleSelectVesselType
                                },
                                vesselTypes.map(function (vesselType) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                        key: vesselType,
                                        value: vesselType,
                                        primaryText: vesselType
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                                style: { width: '75px', marginLeft: '20px' },
                                floatingLabelText: 'DWT',
                                floatingLabelStyle: { fontSize: '13px' },
                                type: 'number',
                                value: dwt || '',
                                errorText: !dwt && 'Required',
                                errorStyle: { color: 'red' },
                                onChange: handleChangeDwt
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                                style: { width: '75px', marginLeft: '20px' },
                                floatingLabelText: 'P D/A',
                                floatingLabelStyle: { fontSize: '13px' },
                                type: 'number',
                                errorText: !averagePortCostsUsdDay && 'Required',
                                errorStyle: { color: 'red' },
                                value: averagePortCostsUsdDay && parseInt(averagePortCostsUsdDay).toFixed() || '',
                                onChange: handleChangePda
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                                {
                                    style: { width: '130px', marginLeft: '10px' },
                                    floatingLabelText: 'Country',
                                    floatingLabelStyle: { fontSize: '13px' },
                                    maxHeight: 400,
                                    value: country._id,
                                    name: 'Countries',
                                    autoWidth: true,
                                    errorText: !country._id && 'Required',
                                    errorStyle: { color: 'red' },
                                    onChange: handleSelectCountry
                                },
                                countries.map(function (country) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                        key: country._id,
                                        value: country._id,
                                        primaryText: country.name
                                    });
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */], {
                                name: 'portName',
                                textFieldStyle: { fontSize: '16px', marginLeft: '10px' },
                                style: { width: '130px' },
                                floatingLabelText: 'Port Name',
                                floatingLabelStyle: { fontSize: '13px' },
                                hintText: 'Port name',
                                searchText: port.name,
                                dataSource: ports,
                                dataSourceConfig: { text: 'name', value: 'item' },
                                onUpdateInput: changePortName,
                                onNewRequest: choosePort,
                                filter: __WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */].noFilter,
                                errorText: !port.name && 'Required',
                                errorStyle: { color: 'red' },
                                fullWidth: true,
                                listStyle: { overflow: 'auto', maxHeight: '300px' },
                                popoverProps: {
                                    canAutoPosition: true,
                                    style: {
                                        width: '300px'
                                    }
                                }
                            })
                        ),
                        shouldShowConfirmCheckbox && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["b" /* Checkbox */], {
                                label: 'Confirm',
                                value: approved,
                                style: { margin: '40px -25px 0 20px', width: '165px' },
                                labelStyle: { marginLeft: '-7px' },
                                onCheck: handleCheckConfirmed
                            })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return EditAddDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = EditAddDialog;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(EditAddDialog, 'EditAddDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/EditAddDialog.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/EditAddDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_actions_countries__ = __webpack_require__(128);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PdaFilters = function (_React$Component) {
    _inherits(PdaFilters, _React$Component);

    function PdaFilters(props) {
        _classCallCheck(this, PdaFilters);

        var _this = _possibleConstructorReturn(this, (PdaFilters.__proto__ || Object.getPrototypeOf(PdaFilters)).call(this, props));

        _this.changeVesselName = function (searchText) {
            if (_this.props.filter.vessel.name !== searchText) {
                _this.props.modifyFilter('vessel', { _id: '', name: searchText }, function () {
                    _this.vesselAutoComplete(searchText);
                });
            }
        };

        _this.chooseVessel = function (selectedVessel) {
            if (!selectedVessel) {
                return;
            }

            var _selectedVessel$item = selectedVessel.item,
                _id = _selectedVessel$item._id,
                name = _selectedVessel$item.name,
                imoNumber = _selectedVessel$item.imoNumber;

            _this.props.modifyFilter('vessel', { _id: _id, name: name + ' (' + imoNumber + ')' });
        };

        _this.changePortName = function (searchText) {
            if (_this.props.filter.port.name !== searchText) {
                _this.props.modifyFilter('port', { _id: '', name: searchText }, function () {
                    _this.portAutoComplete(searchText);
                });
            }
        };

        _this.choosePort = function (selectedPort) {
            if (!selectedPort) {
                return;
            }

            var _selectedPort$item = selectedPort.item,
                _id = _selectedPort$item._id,
                name = _selectedPort$item.name;

            _this.props.modifyFilter('port', { _id: _id, name: name });
        };

        _this.handleSelectCountry = function (e, i) {
            e.preventDefault();
            if (i === 0) {
                _this.props.modifyFilter('country', { name: '', _id: '' });
                return;
            }

            var _this$props$countries = _this.props.countries[i - 1],
                _id = _this$props$countries._id,
                name = _this$props$countries.name;


            _this.props.modifyFilter('country', { name: name, _id: _id });
        };

        _this.handleSelectVesselType = function (e) {
            e.preventDefault();
            _this.props.modifyFilter('vesselType', e.target.innerText);
        };

        _this.handleChangeDwt = function (e, type) {
            _this.props.modifyFilter(type, parseInt(e.target.value));
        };

        _this.handleCheckConfirmed = function () {
            _this.props.modifyFilter('confirmed', !_this.props.filter.confirmed);
        };

        _this.state = {
            vesselName: '',
            vesselNames: [],
            ports: []
        };

        _this.vesselAutoComplete = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (searchText) {
            if (searchText) {
                __WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].findVessel(searchText).then(function (response) {
                    var vesselNames = response.data.data.map(function (vessel) {
                        return {
                            name: vessel.name + ' (' + vessel.imoNumber + ')',
                            item: vessel
                        };
                    });

                    _this.setState({
                        vesselNames: vesselNames
                    });
                }).catch(function () {
                    return null;
                });
            }
        }, 1000);

        _this.portAutoComplete = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (searchText) {
            if (searchText) {
                __WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].findPortAdmin({ name: searchText }).then(function (response) {
                    var ports = response.data.data.map(function (port) {
                        return {
                            name: '' + port.name,
                            item: port
                        };
                    });

                    _this.setState({
                        ports: ports
                    });
                }).catch(function () {
                    return null;
                });
            }
        }, 1000);
        return _this;
    }

    _createClass(PdaFilters, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$filter = _props.filter,
                vessel = _props$filter.vessel,
                vesselType = _props$filter.vesselType,
                port = _props$filter.port,
                country = _props$filter.country,
                dwtMin = _props$filter.dwtMin,
                dwtMax = _props$filter.dwtMax,
                confirmed = _props$filter.confirmed,
                handleFilter = _props.handleFilter,
                countries = _props.countries,
                handleOpenAddDialog = _props.handleOpenAddDialog,
                vesselTypes = _props.vesselTypes,
                handleReset = _props.handleReset;
            var _state = this.state,
                vesselNames = _state.vesselNames,
                ports = _state.ports;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginLeft: '8px', marginRight: '8px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
                            name: 'vesselName',
                            textFieldStyle: { fontSize: '13px' },
                            style: { width: '180px' },
                            floatingLabelText: 'Vessel Name',
                            hintText: 'Vessel Name',
                            searchText: vessel.name,
                            dataSource: vesselNames,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: this.changeVesselName,
                            onNewRequest: this.chooseVessel,
                            filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
                            fullWidth: true,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true,
                                style: {
                                    width: '300px'
                                }
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                            {
                                style: { width: '130px', marginLeft: '10px' },
                                floatingLabelText: 'Vessel Type',
                                floatingLabelStyle: { fontSize: '13px' },
                                maxHeight: 400,
                                value: vesselType,
                                name: 'Vessel Types',
                                onChange: this.handleSelectVesselType
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__["MenuItem"], {
                                value: '',
                                primaryText: ''
                            }),
                            vesselTypes.map(function (vesselType) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__["MenuItem"], {
                                    key: vesselType,
                                    value: vesselType,
                                    primaryText: vesselType
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_material_ui_SelectField___default.a,
                            {
                                style: { width: '130px', marginLeft: '10px' },
                                floatingLabelText: 'Country',
                                floatingLabelStyle: { fontSize: '13px' },
                                maxHeight: 400,
                                value: country._id,
                                name: 'countries',
                                onChange: this.handleSelectCountry,
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__["MenuItem"], {
                                value: '',
                                primaryText: ''
                            }),
                            countries && countries.map(function (country) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Menu__["MenuItem"], {
                                    key: country._id,
                                    value: country._id,
                                    primaryText: country.name
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
                            name: 'portName',
                            textFieldStyle: { fontSize: '13px', marginLeft: '10px' },
                            style: { width: '130px' },
                            floatingLabelText: 'Port Name',
                            hintText: 'Port name',
                            searchText: port.name,
                            dataSource: ports,
                            dataSourceConfig: { text: 'name', value: 'item' },
                            onUpdateInput: this.changePortName,
                            onNewRequest: this.choosePort,
                            filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
                            fullWidth: true,
                            listStyle: { overflow: 'auto', maxHeight: '300px' },
                            popoverProps: {
                                canAutoPosition: true,
                                style: {
                                    width: '300px'
                                }
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                            style: { width: '75px', marginLeft: '20px' },
                            floatingLabelText: 'Min DWT',
                            floatingLabelStyle: { fontSize: '13px' },
                            type: 'number',
                            value: dwtMin || '',
                            onChange: function onChange(e) {
                                return _this2.handleChangeDwt(e, 'dwtMin');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_TextField___default.a, {
                            style: { width: '75px', marginLeft: '10px' },
                            floatingLabelText: 'Max DWT',
                            floatingLabelStyle: { fontSize: '13px' },
                            type: 'number',
                            value: dwtMax || '',
                            onChange: function onChange(e) {
                                return _this2.handleChangeDwt(e, 'dwtMax');
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Checkbox___default.a, {
                            label: 'Not Confirmed',
                            checked: !confirmed,
                            style: { margin: '40px -25px 0 10px', width: '165px' },
                            labelStyle: { marginLeft: '-15px' },
                            onCheck: this.handleCheckConfirmed
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default.a, {
                            style: { margin: '27px 0 0 10px' },
                            primary: true,
                            label: 'Search',
                            onClick: handleFilter
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default.a, {
                            style: { margin: '27px 0 0 10px' },
                            secondary: true,
                            label: 'Reset',
                            onClick: handleReset
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_RaisedButton___default.a, {
                            style: { margin: '27px 0 0 10px' },
                            backgroundColor: '#a4c639',
                            labelColor: '#fff',
                            label: 'ADD',
                            onClick: handleOpenAddDialog
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PdaFilters;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

// export default PdaFilters;


var _default = Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(function (state) {
    return {
        countries: state.countries.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["bindActionCreators"])({
        getCountries: __WEBPACK_IMPORTED_MODULE_11_actions_countries__["a" /* getCountries */]
    }, dispatch);
})(PdaFilters);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PdaFilters, 'PdaFilters', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaFilters.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Prices/Pda/PdaFilters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginAsPage__ = __webpack_require__(978);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LoginAsPage__["a"]; });


/***/ }),
/* 3444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginAsPage_scss__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginAsPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LoginAsPage_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__ = __webpack_require__(41);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









var nameMapper = {
    oid2uuid: {
        name: 'ObjectId->uuid',
        from: 'ObjectId',
        to: 'uuid'
    },
    uuid2oid: {
        name: 'uuid->ObjectId',
        from: 'uuid',
        to: 'ObjectId'
    }
};

function IdsConverter(_ref) {
    var _this = this;

    var addNotification = _ref.addNotification;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])('uuid2oid'),
        _useState2 = _slicedToArray(_useState, 2),
        current = _useState2[0],
        setCurrent = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),
        _useState4 = _slicedToArray(_useState3, 2),
        toConvert = _useState4[0],
        setToConvert = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),
        _useState6 = _slicedToArray(_useState5, 2),
        result = _useState6[0],
        setResult = _useState6[1];

    var convert = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var res;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (toConvert) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].idsConvert(current, toConvert);

                        case 4:
                            res = _context.sent;


                            setResult(res);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function convert() {
            return _ref2.apply(this, arguments);
        };
    }();

    var copy = function copy() {
        navigator.clipboard.writeText(result);
        addNotification({
            title: 'Success',
            message: 'Copied to clipboard',
            level: 'success',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3
        });
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["n" /* Paper */],
        { style: { padding: '20px' }, zDepth: 2, rounded: false, className: 'wrapper' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h4',
                null,
                'That block allows ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'code',
                    null,
                    'ObjectId-',
                    '>',
                    'uuid'
                ),
                ' and ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'code',
                    null,
                    'uuid-',
                    '>',
                    'ObjectId'
                ),
                ' conversion.'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'converter-ops' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'manage' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["s" /* SelectField */],
                        {
                            value: current,
                            onChange: function onChange(_e, _i, v) {
                                return setCurrent(v);
                            },
                            style: { fontSize: '13px', width: '30%' }
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], { value: 'uuid2oid', primaryText: 'uuid->ObjectId' }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["m" /* MenuItem */], { value: 'oid2uuid', primaryText: 'ObjectId->uuid' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["r" /* RaisedButton */], { label: 'Convert', primary: true, onClick: convert })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                        value: toConvert,
                        hintText: nameMapper[current].from,
                        onChange: function onChange(e) {
                            return setToConvert(e.target.value);
                        },
                        style: { fontSize: '13px' },
                        onKeyDown: function onKeyDown(e) {
                            return e.keyCode === 13 && convert;
                        }
                    }),
                    result ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'code',
                            { style: { color: 'gray' } },
                            ' ',
                            '-->',
                            ' '
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            {
                                role: 'button',
                                style: { cursor: 'pointer' },
                                onClick: copy,
                                tabIndex: 0
                            },
                            result
                        )
                    ) : null
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_6_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(IdsConverter);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(nameMapper, 'nameMapper', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/IdsManipulators/IdsConverter.jsx');
    reactHotLoader.register(IdsConverter, 'IdsConverter', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/IdsManipulators/IdsConverter.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/IdsManipulators/IdsConverter.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = IdsEntities;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginAsPage_scss__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginAsPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LoginAsPage_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var namesMapper = {
    mail: 'Mail',
    mailArchive: 'Mail archived',
    cargo: 'Cargo',
    cargoRequest: 'Cargo request',
    position: 'Position',
    tc: 'Tc',
    sales: 'Sales',
    user: 'User',
    company: 'Company',
    vessel: 'Vessel',
    calculation: 'Calculation',
    contract: 'Contract',
    contractTc: 'Contract Tc',
    contractVoy: 'Contract Voyage',
    mailGate: 'Mail Gate',
    port: 'Port',
    region: 'Region'
};

function IdsEntities() {
    var _this = this;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),
        _useState2 = _slicedToArray(_useState, 2),
        toIdentify = _useState2[0],
        setToIdentify = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),
        _useState4 = _slicedToArray(_useState3, 2),
        result = _useState4[0],
        setResult = _useState4[1];

    var identify = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var res, resString;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (toIdentify) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            _context.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].idsEntities(toIdentify);

                        case 4:
                            res = _context.sent;
                            resString = '';


                            if (res.data && Object.keys(res.data).length) {
                                Object.entries(res.data).filter(function (_ref2) {
                                    var _ref3 = _slicedToArray(_ref2, 2),
                                        _key = _ref3[0],
                                        value = _ref3[1];

                                    return value;
                                }).forEach(function (_ref4) {
                                    var _ref5 = _slicedToArray(_ref4, 2),
                                        key = _ref5[0],
                                        _value = _ref5[1];

                                    resString += '' + (resString ? ', ' : '') + namesMapper[key];
                                });
                            }

                            setResult(resString);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function identify() {
            return _ref.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["n" /* Paper */],
        { style: { padding: '20px' }, zDepth: 2, rounded: false, className: 'wrapper' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h4',
                null,
                'That block allows to identify system entity by id.'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'idsEntities-ops' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                    value: toIdentify,
                    hintText: 'Entity ObjectId',
                    onChange: function onChange(e) {
                        return setToIdentify(e.target.value);
                    },
                    style: { fontSize: '13px' },
                    onKeyDown: function onKeyDown(e) {
                        return e.keyCode === 13 && identify;
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["r" /* RaisedButton */], { label: 'Submit', primary: true, onClick: identify }),
                result ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'code',
                        { style: { color: 'gray' } },
                        ' ',
                        '-->',
                        ' '
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        null,
                        result
                    )
                ) : null
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { color: 'gray', fontSize: '13px', marginTop: '15px' } },
                'Possible values: Mail, Mail archived, Cargo, Cargo request, Position, Tc, Sales, Port, Region, User, Company, Vessel, Calculation, Contract, Contract Tc, Contract Voyage, Mail Gate.'
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(namesMapper, 'namesMapper', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/IdsManipulators/IdsEntities.jsx');
    reactHotLoader.register(IdsEntities, 'IdsEntities', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/IdsManipulators/IdsEntities.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_contracts__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_configureStore__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sagas_lettersNew__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sagas_annotations__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Cargo_ErrorBoundary__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HtmlContent__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Cargo_Content_TextEditor__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Letters_Single_Attachments__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Cargo_Content_AnnotationsEditor__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Cargo_Content_AnnotationsList__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Base_UserSelector__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_actions_gazetters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_actions_annotations__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_actions_cargoes_types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_actions_tc_requests__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__TcOrderTable__ = __webpack_require__(3447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_sagas_orders__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_FailedToSent__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__common_ToSpamButton__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */



















// import Trainings from 'components/Letters/Single/Gazetter/Trainings';















var LetterTc = function (_React$Component) {
    _inherits(LetterTc, _React$Component);

    function LetterTc(props) {
        var _this2 = this;

        _classCallCheck(this, LetterTc);

        var _this = _possibleConstructorReturn(this, (LetterTc.__proto__ || Object.getPrototypeOf(LetterTc)).call(this, props));

        _this.getLetterData = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(textEdit) {
                var _ref2, letter, annotationsResponse;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_7_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_8_sagas_lettersNew__["a" /* getLetter */], _this.props.routeParams.id);

                            case 3:
                                _ref2 = _context.sent;
                                letter = _ref2.data;


                                letter.gazettersArr = [];
                                letter.type = 'cargo';
                                letter.fromTcOrders = true;

                                if (textEdit) {
                                    letter.text = textEdit;
                                }

                                _context.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_7_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_9_sagas_annotations__["b" /* postAnnotations */], letter.text, letter.type, _this.state.annotationsServer, {
                                    emailId: letter._id,
                                    subject: letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(letter.date).format('DD-MM-YYYY')
                                });

                            case 11:
                                annotationsResponse = _context.sent;


                                if (annotationsResponse) {
                                    letter.gazettersArr = annotationsResponse.data.annotations;
                                    if (annotationsResponse.data.newclarified) {
                                        letter.newclarified = annotationsResponse.data.newclarified;
                                    }
                                }

                                _context.next = 15;
                                return Object(__WEBPACK_IMPORTED_MODULE_7_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_8_sagas_lettersNew__["d" /* updateLetter */], __WEBPACK_IMPORTED_MODULE_27_lodash___default.a.omit(letter, 'gazettersArr'), 'cargo', _this.state.clarifiedServer);

                            case 15:

                                if (!_this.props.tcOrders || _this.props.tcOrders.length === 0) {
                                    _this.props.addTcOrder();
                                }
                                _context.next = 21;
                                break;

                            case 18:
                                _context.prev = 18;
                                _context.t0 = _context['catch'](0);

                                console.error(_context.t0);

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[0, 18]]);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.updatePostGazetters = function (textLetter) {
            _this.setState({
                textLetter: textLetter,
                gazetters: [],
                filteredGazetters: [],
                annotations: [],
                updated: true
            }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this.props.postGazetters(textLetter, {
                                    emailId: _this.props.letter._id,
                                    subject: _this.props.letter.subject,
                                    date: __WEBPACK_IMPORTED_MODULE_5_moment__(_this.props.letter.date).format('DD-MM-YYYY')
                                });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            })));
        };

        _this.toggleAttachmentsDialog = function () {
            _this.setState({
                openedAttachmentsDialog: !_this.state.openedAttachmentsDialog
            });
        };

        _this.changeAnnotationsServer = function (e, i, value) {
            _this.initialState = {
                annotationsServer: value,
                clarifiedServer: _this.state.clarifiedServer
            };

            localStorage.setItem('settings-order-tc' + _this.props.objUser.user._id, JSON.stringify(_this.initialState));

            _this.setState(_this.initialState, function () {
                _this.getLetterData(_this.state.textLetter);
            });
        };

        _this.changeClarifiedServer = function (e, i, value) {
            _this.initialState = {
                annotationsServer: _this.state.annotationsServer,
                clarifiedServer: value
            };

            localStorage.setItem('settings-order-tc' + _this.props.objUser.user._id, JSON.stringify(_this.initialState));

            _this.setState(_this.initialState, function () {
                _this.getLetterData(_this.state.textLetter);
            });
        };

        _this.removeOrderTable = function () {
            _this.props.removeLastTcOrder();
        };

        _this.clearOrderTable = function () {
            _this.props.removeLastTcOrder();
            _this.props.addTcOrder();
        };

        _this.addOrderTable = function () {
            _this.props.addTcOrder();
        };

        _this.saveRequestsDataCreated = function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(order) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_7_store_configureStore__["b" /* execute */])(__WEBPACK_IMPORTED_MODULE_28_sagas_orders__["a" /* saveRequestsDataCreated */], 'tc', order);

                            case 3:
                                _context3.next = 8;
                                break;

                            case 5:
                                _context3.prev = 5;
                                _context3.t0 = _context3['catch'](0);

                                console.error(_context3.t0);

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2, [[0, 5]]);
            }));

            return function (_x2) {
                return _ref4.apply(this, arguments);
            };
        }();

        _this.prepareTc = function (tcToPrepare, letter) {
            if (tcToPrepare.account) {
                if (tcToPrepare.account._id) {
                    tcToPrepare.account = { _id: tcToPrepare.account._id };
                } else if (tcToPrepare.account.name) {
                    tcToPrepare.account = { name: tcToPrepare.account.name };
                }
            }

            if (tcToPrepare.vesselRequirements.typeByPurpose) {
                tcToPrepare.vesselRequirements.typeByPurpose = tcToPrepare.vesselRequirements.typeByPurpose.toLowerCase();
            } else {
                tcToPrepare.vesselRequirements.typeByPurpose = undefined;
            }

            if (tcToPrepare.vesselRequirements.typeByConstruction) {
                tcToPrepare.vesselRequirements.typeByConstruction = tcToPrepare.vesselRequirements.typeByConstruction.toLowerCase();
            } else {
                tcToPrepare.vesselRequirements.typeByConstruction = undefined;
            }

            if (!tcToPrepare.vesselRequirements.typeBySpecialty) {
                tcToPrepare.vesselRequirements.typeBySpecialty = undefined;
            }

            if (tcToPrepare.vesselRequirements.iceClass) {
                tcToPrepare.vesselRequirements.iceClass = tcToPrepare.vesselRequirements.iceClass.toLowerCase();
            }

            if (tcToPrepare.vesselRequirements.registerClasses) {
                tcToPrepare.vesselRequirements.registerClasses = tcToPrepare.vesselRequirements.registerClasses.map(function (item) {
                    return {
                        registerClass: item._id,
                        iacsRegister: item.iacsRegister,
                        excluded: item.excluded
                    };
                });
            }

            if (tcToPrepare.contract) {
                tcToPrepare.contractId = tcToPrepare.contract;
            }

            tcToPrepare.deliveryPlaces = tcToPrepare.deliveryPlaces.filter(function (p, i) {
                return i === 0 || p.port._id;
            });
            tcToPrepare.redeliveryPlaces = tcToPrepare.redeliveryPlaces.filter(function (p, i) {
                return i === 0 || p.port._id;
            });

            if (!tcToPrepare.readinessDate) {
                tcToPrepare.readinessDate = new Date();
            }

            if (!tcToPrepare.cancellingDate) {
                tcToPrepare.cancellingDate = new Date();
            }

            if (tcToPrepare.account && !tcToPrepare.account.name && !tcToPrepare.account._id) {
                delete tcToPrepare.account;
            }

            tcToPrepare.context = {
                companyId: letter.context.companyId && letter.context.companyId._id || undefined,
                userId: letter.context.userId ? letter.context.userId._id : undefined,
                kind: letter.context.kind,
                parser: letter.context.parser
            };

            [tcToPrepare.cargo.included, tcToPrepare.cargo.excluded].forEach(function (cg) {
                cg.forEach(function (item) {
                    if (item.cargoType && !item.cargoType.name) {
                        item.cargoType = null;
                    }
                });
            });

            if (!tcToPrepare.vesselRequirements.dwtMin || !tcToPrepare.vesselRequirements.dwtMax) {
                var elements = document.getElementsByName('dwtMin');

                elements && elements[0] && elements[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
                return;
            }

            tcToPrepare.terms.user && tcToPrepare.terms.user.forEach(function (item) {
                if (item.type) {
                    item.value = item.type + ' ' + item.value;
                }
            });

            if (tcToPrepare.vesselRequirements.gearV2) {
                tcToPrepare.vesselRequirements.gearV2.summary = tcToPrepare.vesselRequirements.gearV2.summary.filter(function (i) {
                    return i.type;
                });

                if (tcToPrepare.vesselRequirements.geared !== undefined && tcToPrepare.vesselRequirements.gearV2.summary.length === 0) {
                    tcToPrepare.vesselRequirements.geared = false;
                }
            }

            if (tcToPrepare.vesselRequirements.grabV2) {
                tcToPrepare.vesselRequirements.grabV2.summary = tcToPrepare.vesselRequirements.grabV2.summary.filter(function (i) {
                    return i.type;
                });

                if (tcToPrepare.vesselRequirements.grabV2.summary.length === 0) {
                    tcToPrepare.vesselRequirements.grabbed = false;
                }
            }

            if (!tcToPrepare.mailId) {
                tcToPrepare.mailId = letter._id;
            }

            if (letter.realUserEmail) {
                tcToPrepare.realUserEmail = letter.realUserEmail;
            }

            return tcToPrepare;
        };

        _this.sendRequestTc = function () {
            var normalizedTc = __WEBPACK_IMPORTED_MODULE_27_lodash___default.a.cloneDeep(_this.props.tcOrders);
            var letter = _this.props.letter;


            var errored = document.getElementsByClassName('hasValidationError')[0];

            if (errored) {
                errored.scrollIntoView({ behavior: 'smooth' });
                return;
            }

            _this.setState({
                isFormChanged: false,
                tcOrdersDuplicates: __WEBPACK_IMPORTED_MODULE_27_lodash___default.a.cloneDeep(_this.props.tcOrders)
            });

            normalizedTc.forEach(function (tc, index) {
                var preparedTc = _this.prepareTc(tc, letter);

                _this.saveRequestsDataCreated(preparedTc);

                _this.props.postRequestTC(preparedTc, index);
            });
        };

        _this.handleClientChange = function (value) {
            _this.setState({ clientTc: value });
        };

        _this.toggleFailedToSentOpen = function () {
            _this.setState({
                failedToSentOpen: !_this.state.failedToSentOpen
            });
        };

        _this.sendRequestTcFromSent = function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(failedTwinLetterData) {
                var normalizedTc, letter, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, index, tc, preparedTc, response;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                normalizedTc = __WEBPACK_IMPORTED_MODULE_27_lodash___default.a.cloneDeep(_this.props.tcOrders);
                                letter = _this.props.letter;
                                results = [];
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context4.prev = 6;
                                _iterator = Object.entries(normalizedTc)[Symbol.iterator]();

                            case 8:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context4.next = 25;
                                    break;
                                }

                                _step$value = _slicedToArray(_step.value, 2), index = _step$value[0], tc = _step$value[1];
                                preparedTc = _this.prepareTc(tc, letter);


                                if (failedTwinLetterData.context.kind === 'broker') {
                                    preparedTc.realUserEmail = failedTwinLetterData.realUserEmail;
                                    preparedTc.mailId = failedTwinLetterData._id;
                                    preparedTc.context = failedTwinLetterData.context;
                                }

                                _context4.next = 14;
                                return __WEBPACK_IMPORTED_MODULE_30_services__["a" /* default */].postRequestTc(preparedTc);

                            case 14:
                                response = _context4.sent;

                                if (!(response.data && response.errors && !response.errors.length)) {
                                    _context4.next = 21;
                                    break;
                                }

                                results.push(_extends({}, response.data, {
                                    status: 'success'
                                }));
                                _context4.next = 19;
                                return __WEBPACK_IMPORTED_MODULE_30_services__["a" /* default */].sendRefNumber(failedTwinLetterData._id, {
                                    refNo: response.data.refNo,
                                    requestId: response.data.id || response.data._id
                                });

                            case 19:
                                _context4.next = 22;
                                break;

                            case 21:
                                results.push({
                                    status: 'error',
                                    message: __WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(response, 'errors[0].message') || __WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(response, 'errors[0].messages[0]')
                                });

                            case 22:
                                _iteratorNormalCompletion = true;
                                _context4.next = 8;
                                break;

                            case 25:
                                _context4.next = 31;
                                break;

                            case 27:
                                _context4.prev = 27;
                                _context4.t0 = _context4['catch'](6);
                                _didIteratorError = true;
                                _iteratorError = _context4.t0;

                            case 31:
                                _context4.prev = 31;
                                _context4.prev = 32;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 34:
                                _context4.prev = 34;

                                if (!_didIteratorError) {
                                    _context4.next = 37;
                                    break;
                                }

                                throw _iteratorError;

                            case 37:
                                return _context4.finish(34);

                            case 38:
                                return _context4.finish(31);

                            case 39:
                                return _context4.abrupt('return', results);

                            case 40:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this2, [[6, 27, 31, 39], [32,, 34, 38]]);
            }));

            return function (_x3) {
                return _ref5.apply(this, arguments);
            };
        }();

        if (localStorage.getItem('settings-order-tc' + props.objUser.user._id)) {
            _this.initialState = JSON.parse(localStorage.getItem('settings-order-tc' + props.objUser.user._id));
        } else {
            _this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem('settings-order-tc' + props.objUser.user._id, JSON.stringify(_this.initialState));
        }

        _this.state = _extends({}, _this.initialState, {
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientTc: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            failedToSentOpen: false,
            isFormChanged: false,
            tcOrdersDuplicates: []
        });
        return _this;
    }

    _createClass(LetterTc, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var state = this.props.location.state;


            this.props.getTimeContracts();
            this.props.getCargoTypes();

            if (state) {
                this.getLetterData(state.modifiedTextLetter);
            } else {
                this.getLetterData();
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (!__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.isEqual(nextProps.tcOrders, this.state.tcOrdersDuplicates)) {
                if (this.state.tcOrdersDuplicates.length) {
                    this.setState({ isFormChanged: true });
                }
            } else {
                this.setState({ isFormChanged: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                annotationsServer = _state.annotationsServer,
                clarifiedServer = _state.clarifiedServer,
                textLetter = _state.textLetter,
                updated = _state.updated,
                clientTc = _state.clientTc,
                openedAttachmentsDialog = _state.openedAttachmentsDialog,
                failedToSentOpen = _state.failedToSentOpen;
            var _props = this.props,
                letter = _props.letter,
                routeParams = _props.routeParams,
                router = _props.router,
                objUser = _props.objUser,
                user = _props.user,
                tcOrders = _props.tcOrders,
                location = _props.location;


            var modifiedTextLetter = void 0;
            var initialTextLetter = void 0;

            if (location.state) {
                modifiedTextLetter = location.state.modifiedTextLetter;
                initialTextLetter = location.state.initialTextLetter;
            }

            var hasCargoOrder = letter && letter.clarified && letter.clarified.find(function (c) {
                return c.typeCategory.includes('request');
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'single-letter-cargo', className: 'single-letter' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'content', style: { width: '60vw' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'management' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'management-children' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_RaisedButton___default.a, {
                                className: 'btn',
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px 0' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Gazetteer',
                                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Link */], { to: '/' + routeParams.id }),
                                primary: true
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_14__Cargo_ErrorBoundary__["a" /* default */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HtmlContent__["a" /* default */], { letter: letter })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Cargo_Content_TextEditor__["a" /* default */], {
                                textLetter: modifiedTextLetter || textLetter || letter.text,
                                originalText: initialTextLetter || letter.text,
                                removeGazetters: this.props.removeGazetters,
                                removeAnnotations: this.props.removeAnnotations,
                                getLetterData: this.getLetterData,
                                updatePostGazetters: this.updatePostGazetters
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Letters_Single_Attachments__["a" /* default */], {
                                openedAttachmentsDialog: openedAttachmentsDialog,
                                toggleAttachmentsDialog: this.toggleAttachmentsDialog,
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '10px 10px 10px -10px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                className: 'btn',
                                attachments: letter.attachments
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_13_material_ui_SelectField___default.a,
                                {
                                    floatingLabelText: 'Annotations server',
                                    className: 'btn',
                                    style: { width: '155px' },
                                    value: annotationsServer,
                                    onChange: this.changeAnnotationsServer
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 'mailparse.net', primaryText: 'mailparse.net' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 's4.anotatr.com', primaryText: 's4.anotatr.com' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 'nata.im', primaryText: 'nata.im' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 'polza', primaryText: 'polza' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 'localhost', primaryText: 'localhost' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_13_material_ui_SelectField___default.a,
                                {
                                    floatingLabelText: 'Clarified server',
                                    className: 'btn',
                                    style: { width: '110px' },
                                    value: clarifiedServer,
                                    onChange: this.changeClarifiedServer,
                                    autoWidth: true
                                },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 'standart', primaryText: 'api' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 'localhost:7775', primaryText: 'localhost' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_MenuItem___default.a, { value: 's4.anotatr.com:7777', primaryText: 's4.anotatr.com' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__common_ToSpamButton__["a" /* default */], {
                                letterId: letter._id,
                                onSuccess: function onSuccess() {
                                    _this3.getLetterData();
                                },
                                disabled: letter.type === 'spam'
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__common_FailedToSent__["b" /* default */], {
                                open: failedToSentOpen,
                                failedTwinsList: letter.failedTwinsByTextHash || [],
                                handleToggleDialog: this.toggleFailedToSentOpen,
                                disabled: this.state.isFormChanged || !this.state.tcOrdersDuplicates.length,
                                sendRequest: this.sendRequestTcFromSent
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { width: '150px' }, className: 'subject' },
                            'SUBJECT: ',
                            letter.subject,
                            ' '
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'subject', style: { width: '70px' } },
                            'refNo: ',
                            letter.refNo,
                            ' '
                        )
                    ),
                    updated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__Cargo_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Cargo_Content_AnnotationsEditor__["a" /* default */], { letterText: textLetter || letter.text })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__Cargo_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Cargo_Content_AnnotationsEditor__["a" /* default */], { letterText: modifiedTextLetter || letter.text })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__Cargo_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Cargo_Content_AnnotationsList__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'sidebar', style: { width: '40vw', height: 'calc(100vh - 100px)' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h1',
                        null,
                        'TC requests ',
                        tcOrders.length,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { color: 'red' } },
                            hasCargoOrder && ' Has cargo requests'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__Cargo_ErrorBoundary__["a" /* default */],
                        null,
                        tcOrders.map(function (tcOrder, key) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__TcOrderTable__["a" /* default */], {
                                numberOrderTable: key,
                                tcOrder: tcOrder,
                                key: ['tcOrder', key].join('_')
                            });
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_14__Cargo_ErrorBoundary__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Base_UserSelector__["a" /* default */], {
                            handleClientChange: function handleClientChange(_e, _i, value) {
                                return _this3.handleClientChange(value);
                            },
                            client: clientTc,
                            user: user,
                            letter: letter,
                            onUserUpdate: this.props.updateTcOrderUser
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'controller-orders', style: { width: '40vw' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].btnNewOrders, onClick: this.addOrderTable, label: 'Add' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].btnNewOrders, onClick: this.removeOrderTable, label: 'Remove' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].btnNewOrders, onClick: this.clearOrderTable, label: 'Clear' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_FlatButton___default.a, { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].btnNewOrders, onClick: this.sendRequestTc, label: 'Send' })
                        )
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return LetterTc;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref6) {
    var objUser = _ref6.user,
        _ref6$tcOrders = _ref6.tcOrders,
        tcOrders = _ref6$tcOrders.items,
        user = _ref6$tcOrders.user,
        isLogged = _ref6.user.isLogged,
        letter = _ref6.letter,
        annotations = _ref6.annotations.items;
    return {
        objUser: objUser,
        user: user,
        tcOrders: tcOrders,
        isLogged: isLogged,
        letter: letter,
        annotations: annotations
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateTcOrderUser: __WEBPACK_IMPORTED_MODULE_24_actions_tc_orders__["f" /* updateTcOrderUser */],
        removeLastTcOrder: __WEBPACK_IMPORTED_MODULE_24_actions_tc_orders__["c" /* removeLastTcOrder */],
        postGazetters: __WEBPACK_IMPORTED_MODULE_21_actions_gazetters__["a" /* postGazetters */],
        getCargoTypes: __WEBPACK_IMPORTED_MODULE_23_actions_cargoes_types__["a" /* getCargoTypes */],
        addTcOrder: __WEBPACK_IMPORTED_MODULE_24_actions_tc_orders__["a" /* addTcOrder */],
        createTcOrders: __WEBPACK_IMPORTED_MODULE_24_actions_tc_orders__["b" /* createTcOrders */],
        postRequestTC: __WEBPACK_IMPORTED_MODULE_25_actions_tc_requests__["c" /* postRequestTC */],
        getTimeContracts: __WEBPACK_IMPORTED_MODULE_6_actions_contracts__["b" /* getTimeContracts */],
        removeGazetters: __WEBPACK_IMPORTED_MODULE_21_actions_gazetters__["b" /* removeGazetters */],
        removeAnnotations: __WEBPACK_IMPORTED_MODULE_22_actions_annotations__["b" /* removeAnnotations */]
    }, dispatch);
})(LetterTc);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LetterTc, 'LetterTc', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/LetterTc.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/LetterTc.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content_Account__ = __webpack_require__(3448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content_podPor_PodPorsBlock__ = __webpack_require__(3449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__content_TCDuration__ = __webpack_require__(3451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__content_VesselRequirements__ = __webpack_require__(3452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__content_Cargo__ = __webpack_require__(3454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__content_CommissionAndContracts__ = __webpack_require__(3455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__content_Terms__ = __webpack_require__(3456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_RequestTitle__ = __webpack_require__(272);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TcOrderTable = function (_React$PureComponent) {
    _inherits(TcOrderTable, _React$PureComponent);

    function TcOrderTable() {
        _classCallCheck(this, TcOrderTable);

        return _possibleConstructorReturn(this, (TcOrderTable.__proto__ || Object.getPrototypeOf(TcOrderTable)).apply(this, arguments));
    }

    _createClass(TcOrderTable, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                numberOrderTable = _props.numberOrderTable,
                tcOrder = _props.tcOrder;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'sidebar-table' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_RequestTitle__["a" /* default */], {
                    orderNumber: this.props.numberOrderTable + 1,
                    text: 'TC REQUEST \u2116',
                    warnings: tcOrder.warnings
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Account'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__content_Account__["a" /* default */], {
                        numberOrderTable: numberOrderTable,
                        tcOrder: tcOrder
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'POD / POR'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__content_podPor_PodPorsBlock__["a" /* default */], {
                        numberOrderTable: numberOrderTable,
                        tcOrder: tcOrder
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'TC Duration'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__content_TCDuration__["a" /* default */], {
                        numberOrderTable: numberOrderTable,
                        tcOrder: tcOrder
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Vessel requirements'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__content_VesselRequirements__["a" /* default */], {
                        numberOrderTable: numberOrderTable,
                        tcOrder: tcOrder
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Cargo'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__content_Cargo__["a" /* default */], {
                        numberOrderTable: numberOrderTable,
                        tcOrder: tcOrder
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Commission and contract'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__content_CommissionAndContracts__["a" /* default */], {
                        numberOrderTable: numberOrderTable,
                        tcOrder: tcOrder
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'paper-block margin-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name-block static huge-name' },
                        'Terms:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__content_Terms__["a" /* default */], {
                        numberOrderTable: this.props.numberOrderTable,
                        tcOrder: tcOrder
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TcOrderTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = TcOrderTable;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TcOrderTable, 'TcOrderTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/TcOrderTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/TcOrderTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_realCompanies__ = __webpack_require__(520);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var accountsConfig = {
    text: 'name',
    value: '_id'
};

var Account = function (_React$Component) {
    _inherits(Account, _React$Component);

    function Account(props) {
        _classCallCheck(this, Account);

        var _this = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props));

        _this.onChangeAutoCompleteAccount = function (searchText) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.account = {
                name: searchText
            };

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);

            _this.dAutocomplete(searchText);
        };

        _this.onChooseAutoCompleteAccount = function (updateProperties) {
            if (!updateProperties) {
                return;
            }

            var _tcOrder = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.account = {
                _id: updateProperties.item._id,
                name: updateProperties.name
            };

            _this.setState({
                accounts: []
            });

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        };

        _this.state = {
            accounts: [],
            companies: []
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (searchText) {
            if (searchText.length <= 2) {
                return;
            }

            var withRealCompanies = Object(__WEBPACK_IMPORTED_MODULE_7_helpers_realCompanies__["a" /* calculateIsIfchorBroker */])(_this.props.context.userId.email);

            __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].findCompany(searchText, withRealCompanies).then(function (response) {
                var accounts = response.data.data.map(function (company) {
                    return {
                        name: company.name,
                        _id: company._id,
                        item: company
                    };
                });

                _this.setState({
                    accounts: accounts
                });
            }).catch(function () {
                return null;
            });
        }, 1000);
        return _this;
    }

    _createClass(Account, [{
        key: 'render',
        value: function render() {
            var accounts = this.state.accounts;
            var account = this.props.tcOrder.account;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
                        name: 'account',
                        floatingLabelText: 'Account',
                        textFieldStyle: { fontSize: '13px' },
                        hintText: 'Account',
                        searchText: account && account.name || '',
                        dataSource: accounts,
                        onUpdateInput: this.onChangeAutoCompleteAccount,
                        onNewRequest: this.onChooseAutoCompleteAccount,
                        dataSourceConfig: accountsConfig,
                        filter: __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                        menuStyle: { width: 'auto' },
                        popoverProps: {
                            canAutoPosition: true
                        }
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Account;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref, ownProps) {
    var tcOrders = _ref.tcOrders.items,
        context = _ref.letter.context;

    return {
        tcOrders: tcOrders,
        tcOrder: tcOrders[ownProps.numberOrderTable],
        context: context
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_1_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(Account);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(accountsConfig, 'accountsConfig', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Account.jsx');
    reactHotLoader.register(Account, 'Account', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Account.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Account.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PodPor__ = __webpack_require__(3450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Base_DateRangeSelector__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PodPorsBlock = function (_React$Component) {
    _inherits(PodPorsBlock, _React$Component);

    function PodPorsBlock(props) {
        _classCallCheck(this, PodPorsBlock);

        var _this = _possibleConstructorReturn(this, (PodPorsBlock.__proto__ || Object.getPrototypeOf(PodPorsBlock)).call(this, props));

        _this.getDefaultDelRedel = function () {
            return {
                details: null,
                main: false,
                port: {
                    _id: null,
                    name: null
                }
            };
        };

        _this.addNewPort = function (type) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder[type + 'Places'].push(_this.getDefaultDelRedel());

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        };

        _this.removePort = function (key, type) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder[type + 'Places'].splice(key, 1);

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        };

        _this.changePortData = function (key, type, port) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder[type + 'Places'][key] = port;

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        };

        _this.handleCloseLayCanDialog = function (index) {
            _this.setState({
                openDialogs: _extends({}, _this.state.openDialogs, _defineProperty({}, 'dialog' + index, false))
            });
        };

        _this.handleOpenLayCanDialog = function (index) {
            _this.setState({
                openDialogs: _extends({}, _this.state.openDialogs, _defineProperty({}, 'dialog' + index, true))
            });
        };

        _this.changeLayCan = function (dates) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_this.props.tcOrder);
            var readinessDate = dates.readinessDate,
                cancellingDate = dates.cancellingDate;


            _tcOrder.readinessDate = readinessDate;
            _tcOrder.cancellingDate = cancellingDate;

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        };

        _this.state = {
            openLayCanDialog: false,
            openDialogs: {}
        };
        return _this;
    }

    _createClass(PodPorsBlock, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$tcOrder = this.props.tcOrder,
                deliveryPlaces = _props$tcOrder.deliveryPlaces,
                redeliveryPlaces = _props$tcOrder.redeliveryPlaces,
                cancellingDate = _props$tcOrder.cancellingDate,
                readinessDate = _props$tcOrder.readinessDate;

            var actions = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["g" /* FlatButton */], {
                label: 'Ok',
                primary: true,
                onClick: function onClick() {
                    var entries = Object.entries(_this2.state.openDialogs);
                    return entries.forEach(function (entrie) {
                        return entrie[1] && _this2.handleCloseLayCanDialog(entrie[0].substr(-1));
                    });
                }
            })];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-9', style: { fontSize: '14px' } },
                        'Ports of delivery:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px', marginBottom: '10px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new delivery port',
                            onClick: function onClick() {
                                return _this2.addNewPort('delivery');
                            },
                            primary: true
                        })
                    )
                ),
                deliveryPlaces && deliveryPlaces.map(function (portData, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            style: { width: '97%', marginLeft: '10px' },
                            key: ['deliveryPlaces', index].join('_')
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portData.main || index === 0 ? '#EEF8E4' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'column-left' },
                                'Port of delivery - ' + (index + 1)
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portData.main || index === 0 ? '#EEF8E4' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PodPor__["a" /* default */], {
                                key: ['podPor', index].join('_'),
                                port: portData,
                                portType: 'delivery',
                                portIndex: index,
                                changePortData: _this2.changePortData,
                                removePort: _this2.removePort
                            }),
                            index === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px', margin: '35px 0 0 23px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Laycan',
                                onClick: function onClick() {
                                    return _this2.handleOpenLayCanDialog(index);
                                },
                                primary: true
                            }),
                            index === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { style: { fontSize: '12px', fontWeight: 'bold', margin: '40px 0 0 5px' } },
                                __WEBPACK_IMPORTED_MODULE_9_moment___default()(readinessDate).utc().format('DD-MM-YYYY'),
                                ' --- ',
                                __WEBPACK_IMPORTED_MODULE_9_moment___default()(cancellingDate).utc().format('DD-MM-YYYY')
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_material_ui__["f" /* Dialog */],
                            {
                                title: 'Dialog With Date Picker',
                                actions: actions,
                                modal: false,
                                open: !!_this2.state.openDialogs['dialog' + index],
                                onRequestClose: function onRequestClose() {
                                    return _this2.handleCloseLayCanDialog(index);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Base_DateRangeSelector__["a" /* default */], {
                                from: __WEBPACK_IMPORTED_MODULE_9_moment___default()(readinessDate).utc().toDate(),
                                until: __WEBPACK_IMPORTED_MODULE_9_moment___default()(cancellingDate).utc().toDate(),
                                fromLabel: 'Readiness date',
                                untilLabel: 'Cancelling date',
                                onChange: function onChange(range) {
                                    return _this2.changeLayCan({ readinessDate: range.from, cancellingDate: range.until });
                                }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-9', style: { fontSize: '14px' } },
                        'Ports of redelivery:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["r" /* RaisedButton */], {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px', marginBottom: '10px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new redelivery port',
                            onClick: function onClick() {
                                return _this2.addNewPort('redelivery');
                            },
                            primary: true
                        })
                    )
                ),
                redeliveryPlaces && redeliveryPlaces.map(function (portData, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            style: { width: '97%', marginLeft: '10px' },
                            key: ['redeliveryPlaces', index].join('_')
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portData.main || index === 0 ? '#E8F0F8' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'column-left' },
                                'Port of redelivery - ' + (index + 1)
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'row',
                                style: { background: '' + (portData.main || index === 0 ? '#E8F0F8' : '#F5F5F5') }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PodPor__["a" /* default */], {
                                key: ['podPor', index].join('_'),
                                port: portData,
                                portType: 'redelivery',
                                portIndex: index,
                                changePortData: _this2.changePortData,
                                removePort: _this2.removePort
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PodPorsBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PodPorsBlock.propTypes = {
    tcOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    numberOrderTable: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    updateTcOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref, ownProps) {
    var tcOrders = _ref.tcOrders.items;
    return {
        tcOrders: tcOrders
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_4_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(PodPorsBlock);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PodPorsBlock, 'PodPorsBlock', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/podPor/PodPorsBlock.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/podPor/PodPorsBlock.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PodPor = function (_React$Component) {
    _inherits(PodPor, _React$Component);

    function PodPor(props) {
        _classCallCheck(this, PodPor);

        var _this = _possibleConstructorReturn(this, (PodPor.__proto__ || Object.getPrototypeOf(PodPor)).call(this, props));

        _this.changeAutoComplete = function (searchText) {
            var port = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.props.port);
            port.port.name = searchText;
            if (!searchText) {
                delete port.port._id;
            }
            _this.props.changePortData(_this.props.portIndex, _this.props.portType, port);

            _this.dAutocomplete(searchText);
        };

        _this.chooseAutoComplete = function (port) {
            if (!port) {
                return;
            }

            _this.props.changePortData(_this.props.portIndex, _this.props.portType, _extends({}, _this.props.port, {
                port: port.item
            }));
        };

        _this.getDefaultPort = function () {
            return {
                port: {
                    _id: null,
                    name: null
                },
                details: null,
                main: false
            };
        };

        _this.changeDetails = function (_e, value) {
            var port = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.props.port);
            port.details = value;
            _this.props.changePortData(_this.props.portIndex, _this.props.portType, port);
        };

        _this.state = {
            ports: []
        };

        _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (searchText) {
            if (searchText.length < 2) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findPortAdmin({ name: searchText, withAreas: true }).then(function (response) {
                var ports = [];

                response.data.data.forEach(function (port) {
                    ports.push.apply(ports, _toConsumableArray(_this.createPort(port)));
                });

                _this.setState({
                    ports: ports
                });
            }).catch(function () {
                return null;
            });
        }, 500);
        return _this;
    }

    _createClass(PodPor, [{
        key: 'createPort',
        value: function createPort(port) {
            var ports = [];
            var name = '';

            if (port.sub) {
                port.sub.forEach(function (subPort) {
                    ports.push({
                        item: subPort,
                        text: subPort.name + ' - country ' + port.country.name,
                        _id: port._id,
                        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                            primaryText: subPort.name + ' - country ' + port.country.name,
                            value: subPort,
                            style: { paddingLeft: '30px' }
                        })
                    });
                });
            }

            if (port.country) {
                name = port.name + ' - country ' + port.country.name;
            } else {
                name = port.name;
            }

            return [{
                _id: port._id,
                text: name,
                item: port,
                value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                    primaryText: name,
                    value: port
                })
            }].concat(ports);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                portType = _props.portType,
                portIndex = _props.portIndex,
                removePort = _props.removePort,
                port = _props.port;
            var ports = this.state.ports;


            var label = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["capitalize"])(portType) + ' port' + (portIndex === 0 && portType === 'delivery' ? '*' : '');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
                        floatingLabelText: label,
                        textFieldStyle: { fontSize: '13px' },
                        hintText: label,
                        searchText: port.port.name || '',
                        dataSource: ports,
                        onUpdateInput: this.changeAutoComplete,
                        onNewRequest: this.chooseAutoComplete
                        // dataSourceConfig={{ text: 'name', value: '_id' }}
                        , required: portIndex === 0,
                        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                        menuStyle: { width: 'auto' },
                        popoverProps: {
                            canAutoPosition: true
                        },
                        style: { marginLeft: '10px' }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                        floatingLabelText: 'Details',
                        style: { fontSize: '13px', marginLeft: '15px', width: 'auto' },
                        value: port.details || '',
                        onChange: this.changeDetails,
                        fullWidth: true
                    }),
                    this.props.portIndex !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                            label: 'Remove Port',
                            secondary: true,
                            style: { margin: '35px 0 0 15px', height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            labelStyle: { fontSize: '13px' },
                            onClick: function onClick() {
                                removePort(portIndex, portType);
                            }
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return PodPor;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PodPor.propTypes = {
    portIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    portType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['delivery', 'redelivery']),
    port: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    removePort: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    changePortData: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var _default = PodPor;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PodPor, 'PodPor', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/podPor/PodPor.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/podPor/PodPor.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(9);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var defaultDuration = [{ text: 'ABT', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'ABT' }) }, { text: 'AGW', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'AGW' }) }, { text: 'WP', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'WP' }) }, { text: 'WOG', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'WOG' }) }, { text: 'AGW WP', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'AGW WP' }) }, { text: 'AGW WP WOG', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'AGW WP WOG' }) }, { text: 'AGW WOG', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'AGW WOG' }) }, { text: 'WP WOG', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'WP WOG' }) }, { text: 'ABT AGW WP', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'ABT AGW WP' }) }, { text: 'ABT AGW WP WOG', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'ABT AGW WP WOG' }) }, { text: 'ABT WP WOG', value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["m" /* MenuItem */], { primaryText: 'ABT WP WOG' }) }];

var TCDuration = function (_React$PureComponent) {
    _inherits(TCDuration, _React$PureComponent);

    function TCDuration() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TCDuration);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TCDuration.__proto__ || Object.getPrototypeOf(TCDuration)).call.apply(_ref, [this].concat(args))), _this), _this.changeAutoComplete = function (searchText) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.tcDuration = searchText;

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TCDuration, [{
        key: 'render',
        value: function render() {
            var tcDuration = this.props.tcOrder.tcDuration;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a, {
                        floatingLabelText: 'T/C Duration',
                        textFieldStyle: { fontSize: '13px' },
                        hintText: 'T/C Duration',
                        searchText: tcDuration || '',
                        dataSource: defaultDuration,
                        onUpdateInput: this.changeAutoComplete,
                        filter: __WEBPACK_IMPORTED_MODULE_1_material_ui_AutoComplete___default.a.noFilter,
                        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
                        menuStyle: { width: 'auto' },
                        popoverProps: {
                            canAutoPosition: true
                        }
                    })
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return TCDuration;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function () {
    return {
        // tcOrders,
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_4_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(TCDuration);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(defaultDuration, 'defaultDuration', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/TCDuration.jsx');
    reactHotLoader.register(TCDuration, 'TCDuration', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/TCDuration.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/TCDuration.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Vessels_Single_Rows_TypeByPurpose__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Vessels_Single_Rows_TypeBySpecialty__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Vessels_Single_Rows_TypeByConstruction__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Vessels_Single_Rows_Flag__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Vessels_Single_Rows_RegisterClassMulti__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Vessels_Single_Rows_GearV2__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Vessels_Single_Rows_GrabV2__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes__ = __webpack_require__(3453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Vessels_Single_Rows_GearedGrabbed__ = __webpack_require__(370);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var styles = {
    radioButton: {
        marginBottom: 16
    },
    redioGroup: {
        display: 'flex'
    },
    checkbox: {
        marginTop: '30px'
    },
    add: {
        marginTop: '25px',
        display: 'flex',
        justifyContent: 'center'
    },
    chips: {
        margin: '8px 8px 0 0'
    }
};

var defaultGearV2 = {
    summary: [{
        type: null,
        quantity: null,
        capacity: null,
        outreach: null,
        maxSWL: null,
        combinable: false
    }]
};

var defaultGrabV2 = {
    summary: [{
        type: null,
        quantity: null,
        volume: null
    }]
};

var defaultSelectedCountry = {
    flag: { _id: null, name: null },
    excluded: false
};

var VesselRequirements = function (_React$PureComponent) {
    _inherits(VesselRequirements, _React$PureComponent);

    function VesselRequirements() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, VesselRequirements);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VesselRequirements.__proto__ || Object.getPrototypeOf(VesselRequirements)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            selectedCountry: defaultSelectedCountry,
            dwtMinError: '',
            dwtMaxError: '',
            capacityMinError: '',
            capacityMaxError: '',
            teuMinError: '',
            teuMaxError: '',
            linerMeterMinError: '',
            linerMeterMaxError: '',
            ageMinError: '',
            ageMaxError: ''
        }, _this.changeField = function (changes) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this.props.tcOrder);

            if (!Array.isArray(changes)) {
                changes = [changes];
            }

            var that = _this;

            var change = {};
            changes.forEach(function (_ref2) {
                var field = _ref2.field,
                    value = _ref2.value;

                if (!field) return;

                if (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.has(that.state, [field + 'Error'])) {
                    switch (field) {
                        case 'dwtMin':
                            if (!value) {
                                change.dwtMinError = 'Min dwt is required';
                            } else if (value > _tcOrder.vesselRequirements.dwtMax) {
                                change.dwtMinError = 'Min is greater than max';
                            } else if (value <= _tcOrder.vesselRequirements.dwtMax) {
                                change.dwtMinError = '';
                                change.dwtMaxError = '';
                            } else {
                                change.dwtMinError = '';
                            }
                            break;
                        case 'dwtMax':
                            if (!value) {
                                change.dwtMaxError = 'Max dwt is required';
                            } else if (value < _tcOrder.vesselRequirements.dwtMin) {
                                change.dwtMaxError = 'Max is less than min';
                            } else if (value >= _tcOrder.vesselRequirements.dwtMin) {
                                change.dwtMaxError = '';
                                change.dwtMinError = '';
                            } else {
                                change.dwtMaxError = '';
                            }
                            break;
                        case 'capacityMin':
                            if (value > _tcOrder.vesselRequirements.capacityMax) {
                                change.capacityMinError = 'Min is greater than max';
                            } else if (value <= _tcOrder.vesselRequirements.capacityMax) {
                                change.capacityMinError = '';
                                change.capacityMaxError = '';
                            } else {
                                change.capacityMinError = '';
                            }
                            break;
                        case 'capacityMax':
                            if (value < _tcOrder.vesselRequirements.capacityMin) {
                                change.capacityMaxError = 'Max is less than min';
                            } else if (value >= _tcOrder.vesselRequirements.capacityMin) {
                                change.capacityMaxError = '';
                                change.capacityMinError = '';
                            } else {
                                change.capacityMaxError = '';
                            }
                            break;
                        case 'teuMin':
                            if (value > _tcOrder.vesselRequirements.teuMax) {
                                change.teuMinError = 'Min is greater than max';
                            } else if (value < _tcOrder.vesselRequirements.teuMax) {
                                change.teuMinError = '';
                                var teuMax = _tcOrder.vesselRequirements.teuMax;

                                if (teuMax && teuMax >= 50 && teuMax <= 30000) {
                                    change.teuMaxError = '';
                                }
                            } else {
                                change.teuMinError = '';
                            }

                            if (value && (value < 50 || value > 30000)) {
                                change.teuMinError = '50 - 30000';
                            }
                            break;
                        case 'teuMax':
                            if (value < _tcOrder.vesselRequirements.teuMin) {
                                change.teuMaxError = 'Max is less than min';
                            } else if (value > _tcOrder.vesselRequirements.teuMin) {
                                change.teuMaxError = '';
                                var teuMin = _tcOrder.vesselRequirements.teuMin;

                                if (teuMin && teuMin >= 50 && teuMin <= 30000) {
                                    change.teuMinError = '';
                                }
                            } else {
                                change.teuMaxError = '';
                            }

                            if (value && (value < 50 || value > 30000)) {
                                change.teuMaxError = '50 - 30000';
                            }
                            break;
                        case 'linerMeterMin':
                            if (_tcOrder.vesselRequirements.linerMeterMax && value > _tcOrder.vesselRequirements.linerMeterMax) {
                                change.linerMeterMinError = 'Min is greater than max';
                            } else if (value < _tcOrder.vesselRequirements.linerMeterMax) {
                                change.linerMeterMinError = '';
                                change.linerMeterMaxError = '';
                            } else {
                                change.linerMeterMinError = '';
                            }
                            break;
                        case 'linerMeterMax':
                            if (value < _tcOrder.vesselRequirements.linerMeterMin) {
                                change.linerMeterMaxError = 'Max is less than min';
                            } else if (value > _tcOrder.vesselRequirements.linerMeterMin) {
                                change.linerMeterMaxError = '';
                                change.linerMeterMinError = '';
                            } else {
                                change.linerMeterMaxError = '';
                            }
                            break;
                        case 'ageMin':
                            if (_tcOrder.vesselRequirements.ageMax && value > _tcOrder.vesselRequirements.ageMax) {
                                change.ageMinError = 'Min is greater than max';
                            } else if (value < _tcOrder.vesselRequirements.ageMax) {
                                change.ageMinError = '';
                                change.ageMaxError = '';
                            } else {
                                change.ageMinError = '';
                            }
                            break;
                        case 'ageMax':
                            if (value < _tcOrder.vesselRequirements.ageMin) {
                                change.ageMaxError = 'Max is less than min';
                            } else if (value > _tcOrder.vesselRequirements.ageMin) {
                                change.ageMaxError = '';
                                change.ageMinError = '';
                            } else {
                                change.ageMaxError = '';
                            }
                            break;
                        default:
                            break;
                    }

                    that.setState(change);
                }

                _tcOrder.vesselRequirements = _extends({}, _tcOrder.vesselRequirements, _defineProperty({}, field, value === '' ? null : value));
            });

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _this.changeGearsGrabs = function (changes) {
            var vesselRequirements = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this.props.tcOrder.vesselRequirements);

            if (!Array.isArray(changes)) {
                changes = [changes];
            }

            var toChange = [];

            changes.forEach(function (_ref3) {
                var field = _ref3.field,
                    value = _ref3.value,
                    type = _ref3.type;

                var tcField = field.split('[')[0];

                if (type === 'number') {
                    value = parseFloat(value);
                }

                vesselRequirements = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(vesselRequirements, field, value);

                toChange.push({ field: tcField, value: vesselRequirements[tcField] });
            });

            _this.changeField(toChange);
        }, _this.changeFlag = function () {
            var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'flag';
            var value = arguments[1];

            _this.setState({
                selectedCountry: _extends({}, _this.state.selectedCountry, _defineProperty({}, field, value))
            });
        }, _this.addFlag = function () {
            var flags = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this.props.tcOrder.vesselRequirements.flags);

            var exists = flags.find(function (flag) {
                return flag.flag._id === _this.state.selectedCountry.flag._id;
            });

            if (!exists && _this.state.selectedCountry.flag._id) {
                flags.push(_this.state.selectedCountry);

                _this.changeField([{ field: 'flags', value: flags }]);
            }

            _this.setState({
                selectedCountry: defaultSelectedCountry
            });
        }, _this.deleteFlag = function (index) {
            var flags = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this.props.tcOrder.vesselRequirements.flags);
            flags.splice(index, 1);
            _this.changeField([{ field: 'flags', value: flags }]);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(VesselRequirements, [{
        key: 'renderSelectFitted',


        /**
         * 
         * @param {*} field 
         * @param {*} value 
         * @param {*} label 
         * @param {(...e: any[])=>void} [onChange] 
         * @param {*} [disabled] 
         * @returns 
         */
        value: function renderSelectFitted(field, value, label, onChange) {
            var _this2 = this;

            var disabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            var _onChange = function _onChange(e, i, _value) {
                if (onChange) {
                    return onChange(e, i, _value);
                }
                return _this2.changeField([{ field: field, value: _value }]);
            };
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                {
                    value: value,
                    onChange: _onChange,
                    disabled: disabled,
                    name: field,
                    floatingLabelText: label,
                    floatingLabelStyle: { fontSize: '13px' },
                    autoWidth: true,
                    fullWidth: true
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], { value: null, primaryText: undefined }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], { value: true, primaryText: 'Yes' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], { value: false, primaryText: 'No' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props$tcOrder$vessel = this.props.tcOrder.vesselRequirements,
                dwtMin = _props$tcOrder$vessel.dwtMin,
                dwtMax = _props$tcOrder$vessel.dwtMax,
                capacityMin = _props$tcOrder$vessel.capacityMin,
                capacityMax = _props$tcOrder$vessel.capacityMax,
                typeByPurpose = _props$tcOrder$vessel.typeByPurpose,
                typeBySpecialty = _props$tcOrder$vessel.typeBySpecialty,
                typeByConstruction = _props$tcOrder$vessel.typeByConstruction,
                iceClass = _props$tcOrder$vessel.iceClass,
                ageMax = _props$tcOrder$vessel.ageMax,
                ageMin = _props$tcOrder$vessel.ageMin,
                boxShaped = _props$tcOrder$vessel.boxShaped,
                openHatch = _props$tcOrder$vessel.openHatch,
                flags = _props$tcOrder$vessel.flags,
                geared = _props$tcOrder$vessel.geared,
                gearV2 = _props$tcOrder$vessel.gearV2,
                grabbed = _props$tcOrder$vessel.grabbed,
                grabV2 = _props$tcOrder$vessel.grabV2,
                co2Fitted = _props$tcOrder$vessel.co2Fitted,
                a60BulkheadFitted = _props$tcOrder$vessel.a60BulkheadFitted,
                cementHolesFitted = _props$tcOrder$vessel.cementHolesFitted,
                itfFitted = _props$tcOrder$vessel.itfFitted,
                logsFitted = _props$tcOrder$vessel.logsFitted,
                forHeavyCargoes = _props$tcOrder$vessel.forHeavyCargoes,
                strengthenHeavy = _props$tcOrder$vessel.strengthenHeavy,
                lakesFitted = _props$tcOrder$vessel.lakesFitted,
                aussieFitted = _props$tcOrder$vessel.aussieFitted,
                ventilationFitted = _props$tcOrder$vessel.ventilationFitted,
                ventilationType = _props$tcOrder$vessel.ventilationType,
                imoFitted = _props$tcOrder$vessel.imoFitted,
                imoApp = _props$tcOrder$vessel.imoApp,
                imoClass = _props$tcOrder$vessel.imoClass,
                referPlugFitted = _props$tcOrder$vessel.referPlugFitted,
                referPlugQuantity = _props$tcOrder$vessel.referPlugQuantity,
                typeSizes = _props$tcOrder$vessel.typeSizes,
                teuMin = _props$tcOrder$vessel.teuMin,
                teuMax = _props$tcOrder$vessel.teuMax,
                linerMeterMin = _props$tcOrder$vessel.linerMeterMin,
                linerMeterMax = _props$tcOrder$vessel.linerMeterMax,
                loaMax = _props$tcOrder$vessel.loaMax,
                beamMax = _props$tcOrder$vessel.beamMax,
                draftMax = _props$tcOrder$vessel.draftMax,
                piClubMember = _props$tcOrder$vessel.piClubMember,
                scrubberFitted = _props$tcOrder$vessel.scrubberFitted,
                referPlugsAmount = _props$tcOrder$vessel.referPlugsAmount;
            var _state = this.state,
                selectedCountry = _state.selectedCountry,
                dwtMinError = _state.dwtMinError,
                dwtMaxError = _state.dwtMaxError,
                capacityMinError = _state.capacityMinError,
                capacityMaxError = _state.capacityMaxError,
                teuMinError = _state.teuMinError,
                teuMaxError = _state.teuMaxError,
                linerMeterMinError = _state.linerMeterMinError,
                linerMeterMaxError = _state.linerMeterMaxError,
                ageMinError = _state.ageMinError,
                ageMaxError = _state.ageMaxError;

            var linerMeterDisabled = !new RegExp('ro-(ro|lo)', 'i').test(typeBySpecialty);
            var teuDisabled = !['MPP', 'CONT'].includes(typeByPurpose);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VesselTypesSelector, { typeSizes: typeSizes, changeField: this.changeField })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row', style: { display: 'flex' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'dwtMin',
                            floatingLabelText: 'DWT min*',
                            required: true,
                            value: dwtMin || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'dwtMin', value: parseFloat(e.target.value) }]);
                            },
                            fullWidth: true,
                            floatingLabelStyle: dwtMinError ? { color: '#f44336' } : {},
                            className: dwtMinError && 'hasValidationError',
                            errorText: dwtMinError
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'dwtMax',
                            floatingLabelText: 'DWT max*',
                            value: dwtMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'dwtMax', value: parseFloat(e.target.value) }]);
                            },
                            fullWidth: true,
                            required: true,
                            floatingLabelStyle: dwtMaxError ? { color: '#f44336' } : {},
                            className: dwtMaxError && 'hasValidationError',
                            errorText: dwtMaxError
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'capacityMin',
                            type: 'number',
                            floatingLabelText: 'Capacity min',
                            value: capacityMin || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'capacityMin', value: parseFloat(e.target.value) }]);
                            },
                            fullWidth: true,
                            required: true,
                            floatingLabelStyle: capacityMinError ? { color: '#f44336' } : {},
                            className: capacityMinError && 'hasValidationError',
                            errorText: capacityMinError
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'capacityMax',
                            floatingLabelText: 'Capacity max',
                            type: 'number',
                            value: capacityMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'capacityMax', value: parseFloat(e.target.value) }]);
                            },
                            fullWidth: true,
                            floatingLabelStyle: capacityMaxError ? { color: '#f44336' } : {},
                            className: capacityMaxError && 'hasValidationError',
                            errorText: capacityMaxError
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Vessels_Single_Rows_TypeByPurpose__["a" /* default */], {
                            type: typeByPurpose,
                            changeField: this.changeField,
                            fromTcOrder: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Vessels_Single_Rows_TypeBySpecialty__["a" /* default */], {
                            typeBySpecialty: typeBySpecialty,
                            changeField: this.changeField,
                            typeByPurpose: typeByPurpose,
                            fromTcOrder: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Vessels_Single_Rows_TypeByConstruction__["a" /* default */], {
                            type: typeByConstruction,
                            changeField: this.changeField
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                            {
                                value: iceClass,
                                onChange: function onChange(_e, _i, value) {
                                    return _this3.changeField([{ field: 'iceClass', value: value }]);
                                },
                                name: 'iceClass',
                                floatingLabelText: 'Ice Class',
                                fullWidth: true,
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["e" /* iceClassNames */].map(function (iceClassName, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                    key: index,
                                    value: iceClassName || '',
                                    primaryText: iceClassName
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row', style: { alignItems: 'end' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'teuMin',
                            floatingLabelText: 'Teu min, m',
                            value: teuMin || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'teuMin', value: parseFloat(e.target.value) }]);
                            },
                            disabled: teuDisabled,
                            type: 'number',
                            floatingLabelStyle: teuMinError ? { color: '#f44336' } : {},
                            errorText: teuMinError,
                            className: teuMinError && 'hasValidationError',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'teuMax',
                            floatingLabelText: 'Teu max, m',
                            value: teuMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'teuMax', value: parseFloat(e.target.value) }]);
                            },
                            disabled: teuDisabled,
                            type: 'number',
                            floatingLabelStyle: teuMaxError ? { color: '#f44336' } : {},
                            errorText: teuMaxError,
                            className: teuMaxError && 'hasValidationError',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'linerMeterMin',
                            floatingLabelText: 'Liner meter min, m',
                            value: linerMeterMin || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'linerMeterMin', value: parseFloat(e.target.value) }]);
                            },
                            disabled: linerMeterDisabled,
                            type: 'number',
                            floatingLabelStyle: linerMeterMinError ? { color: '#f44336' } : {},
                            errorText: linerMeterMinError,
                            className: linerMeterMinError && 'hasValidationError',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'linerMeterMax',
                            floatingLabelText: 'Liner meter max, m',
                            value: linerMeterMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'linerMeterMax', value: parseFloat(e.target.value) }]);
                            },
                            disabled: linerMeterDisabled,
                            type: 'number',
                            floatingLabelStyle: linerMeterMaxError ? { color: '#f44336' } : {},
                            errorText: linerMeterMaxError,
                            className: linerMeterMaxError && 'hasValidationError',
                            fullWidth: true
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'loaMax',
                            floatingLabelText: 'LOA max, m',
                            value: loaMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'loaMax', value: parseFloat(e.target.value) }]);
                            },
                            type: 'number',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'beamMax',
                            floatingLabelText: 'Beam max, m',
                            value: beamMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'beamMax', value: parseFloat(e.target.value) }]);
                            },
                            type: 'number',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'draftMax',
                            floatingLabelText: 'Draft max, m',
                            value: draftMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'draftMax', value: parseFloat(e.target.value) }]);
                            },
                            type: 'number',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].boxShaped, boxShaped, 'Box shaped')
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'ageMin',
                            floatingLabelText: 'Age min',
                            value: ageMin || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'ageMin', value: parseFloat(e.target.value) }]);
                            },
                            floatingLabelStyle: ageMinError ? { color: '#f44336' } : {},
                            errorText: ageMinError,
                            className: ageMinError && 'hasValidationError',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            name: 'ageMax',
                            floatingLabelText: 'Age max',
                            value: ageMax || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'ageMax', value: parseFloat(e.target.value) }]);
                            },
                            floatingLabelStyle: ageMaxError ? { color: '#f44336' } : {},
                            errorText: ageMaxError,
                            className: ageMaxError && 'hasValidationError',
                            fullWidth: true
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed', style: styles.checkbox },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["b" /* Checkbox */], {
                            label: 'PI Club',
                            checked: !!piClubMember,
                            onCheck: function onCheck() {
                                return _this3.changeField([{ field: 'piClubMember', value: !piClubMember }]);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 flexed' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].openHatch, openHatch, 'Open hatch')
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Vessels_Single_Rows_RegisterClassMulti__["b" /* default */], {
                    numberOrderTable: this.props.numberOrderTable,
                    tcOrder: this.props.tcOrder
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-8' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Vessels_Single_Rows_Flag__["a" /* default */], {
                            changeAutoComplete: this.changeFlag,
                            flagObject: selectedCountry.flag
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2', style: styles.checkbox },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["b" /* Checkbox */], {
                            label: 'Excluded',
                            checked: !!selectedCountry.excluded,
                            onCheck: function onCheck() {
                                return _this3.changeFlag('excluded', !selectedCountry.excluded);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2', style: styles.add },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["h" /* IconButton */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                onClick: function onClick() {
                                    _this3.addFlag();
                                },
                                color: 'green'
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12', style: { display: 'flex', flexFlow: 'wrap' } },
                        flags && flags.map(function (flag, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
                                {
                                    key: 'flags_inc_exc_' + index,
                                    onRequestDelete: function onRequestDelete() {
                                        return _this3.deleteFlag(index);
                                    },
                                    style: _extends({}, styles.chips, { backgroundColor: flag.excluded ? '#e6e6e6' : '#d6edbd' })
                                },
                                flag.excluded && '- ',
                                flag.flag.name
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { style: { opacity: '0.2', marginTop: '20px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row', style: { height: '60px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-1' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block static huge-name' },
                            'GEAR:'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3 col-xs-offset-8' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Vessels_Single_Rows_GearedGrabbed__["a" /* default */], {
                            confirmed: true,
                            modifiedFields: null,
                            fieldName: 'geared',
                            gearedGrabbed: geared,
                            onChange: function onChange(value) {
                                return _this3.changeField([{ field: 'geared', value: value }, !value ? { field: 'grabbed', value: value } : { field: null }, !value ? { field: 'gearV2.summary', value: [{}] } : { field: null }, !value ? { field: 'grabV2.summary', value: [{}] } : { field: null }]);
                            },
                            styles: styles
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Vessels_Single_Rows_GearV2__["a" /* default */], {
                            gearV2: gearV2 || defaultGearV2,
                            changeField: function changeField(val) {
                                return _this3.changeGearsGrabs(val);
                            },
                            fromTc: true
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { style: { opacity: '0.2', marginTop: '20px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row', style: { height: '60px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-1', style: { marginTop: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block static huge-name' },
                            'GRABS:'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-offset-8 col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Vessels_Single_Rows_GearedGrabbed__["a" /* default */], {
                            confirmed: true,
                            modifiedFields: null,
                            fieldName: 'grabbed',
                            gearedGrabbed: grabbed,
                            onChange: function onChange(value) {
                                return _this3.changeField([{ field: 'grabbed', value: value }, !value ? { field: 'grabV2.summary', value: [{}] } : { field: null }]);
                            },
                            styles: styles
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Vessels_Single_Rows_GrabV2__["a" /* default */], {
                            grabs: grabV2 || defaultGrabV2,
                            changeField: function changeField(val) {
                                return _this3.changeGearsGrabs(val);
                            },
                            fromTc: true
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { style: { opacity: '0.2', marginTop: '20px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12', style: { marginTop: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'name-block static huge-name' },
                            'TECHNICAL EQUIPMENT / CERTIFICATE:'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4', style: styles.checkbox },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].co2Fitted, co2Fitted, 'CO2Fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4', style: styles.checkbox },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].a60BulkheadFitted, a60BulkheadFitted, 'A60 bulkhead fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4', style: styles.checkbox },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].cementHolesFitted, cementHolesFitted, 'Cement holes fitted')
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].itfFitted, itfFitted, 'Itf fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].logsFitted, logsFitted, 'Logs fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].forHeavyCargoes, forHeavyCargoes, 'Strengthened heavy', function () {
                            _this3.changeField([{ field: 'strengthenHeavy', value: !strengthenHeavy }, { field: 'forHeavyCargoes', value: !forHeavyCargoes }]);
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].lakesFitted, lakesFitted, 'Lakes fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].aussieFitted, aussieFitted, 'Aussie fitted')
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].scrubberFitted, scrubberFitted, 'Scrubber fitted')
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].ventilationFitted, ventilationFitted, 'Ventilation fitted', function (e, i, _value) {
                            return _this3.changeField([{ field: __WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].ventilationFitted, value: _value }, !_value ? { field: 'ventilationType', value: '' } : {}]);
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-5' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                            {
                                value: ventilationType,
                                onChange: function onChange(_e, _i, value) {
                                    _this3.changeField([{ field: 'ventilationType', value: value }]);
                                },
                                disabled: !ventilationFitted,
                                name: 'ventilationType',
                                floatingLabelText: 'Ventilation',
                                fullWidth: true,
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], { key: 'electrical', value: 'electrical', primaryText: 'Electrical' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], { key: 'natural', value: 'natural', primaryText: 'Natural' })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].imoFitted, imoFitted, 'Imo fitted', function (_e, _i, _value) {
                            return _this3.changeField([{ field: __WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].imoFitted, value: _value }, !_value ? { field: 'imoApp', value: '' } : {}, !_value ? { field: 'imoClass', value: '' } : {}]);
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                            {
                                value: imoApp,
                                onChange: function onChange(_e, _i, value) {
                                    return _this3.changeField([{ field: 'imoApp', value: value }, { field: 'imoFitted', value: true }]);
                                },
                                disabled: !imoFitted,
                                name: 'imoApp',
                                floatingLabelText: 'Imo app',
                                fullWidth: true,
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["f" /* imoAppNames */].map(function (imoAppName, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                    key: 'imoApp_' + index,
                                    value: imoAppName,
                                    primaryText: imoAppName
                                });
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                            {
                                value: imoClass,
                                onChange: function onChange(_e, _i, value) {
                                    return _this3.changeField([{ field: 'imoClass', value: value }]);
                                },
                                name: 'imoClass',
                                disabled: !imoFitted,
                                floatingLabelText: 'Imo class',
                                fullWidth: true,
                                autoWidth: true
                            },
                            __WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["g" /* imoClassNames */].map(function (imoClassName, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                    key: 'imoClass_' + index,
                                    value: imoClassName,
                                    primaryText: imoClassName
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-4' },
                        this.renderSelectFitted(__WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].referPlugFitted, referPlugFitted, 'Reefer plug fitted', function (_e, _i, _value) {
                            return _this3.changeField([{ field: __WEBPACK_IMPORTED_MODULE_15_constants_vesselRequirements__["d" /* fitted */].referPlugFitted, value: _value }, !_value ? { field: 'referPlugsAmount', value: '' } : {}, !_value ? { field: 'referPlugsQuantity', value: '' } : {}]);
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-5' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["A" /* TextField */], {
                            value: referPlugsAmount || '',
                            onChange: function onChange(e) {
                                return _this3.changeField([{ field: 'referPlugsAmount', value: parseFloat(e.target.value) }, { field: 'referPlugsQuantity', value: parseFloat(e.target.value) }]);
                            },
                            disabled: !referPlugFitted,
                            name: 'referPlugsAmount',
                            floatingLabelText: 'Quantity',
                            fullWidth: true,
                            type: 'number'
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselRequirements;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref5) {
    var tcOrders = _ref5.tcOrders.items,
        countries = _ref5.countries;
    return {
        countries: countries && countries.items,
        tcOrders: tcOrders
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_5_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(VesselRequirements));

/* harmony default export */ __webpack_exports__["a"] = (_default);

var VesselTypesSelector = function (_React$PureComponent2) {
    _inherits(VesselTypesSelector, _React$PureComponent2);

    function VesselTypesSelector() {
        var _ref4;

        var _temp2, _this4, _ret2;

        _classCallCheck(this, VesselTypesSelector);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref4 = VesselTypesSelector.__proto__ || Object.getPrototypeOf(VesselTypesSelector)).call.apply(_ref4, [this].concat(args))), _this4), _this4.state = {
            selected: _this4.props.typeSizes && _this4.props.typeSizes.length > 0 ? 'vessel_type' : 'dwt'
        }, _this4.changeSelected = function (selected) {
            _this4.setState({ selected: selected });

            if (selected === 'dwt') {
                _this4.props.changeField([{ field: 'typeSizes', value: [] }]);
            }
        }, _this4.addTypeSize = function (e, i, value) {
            var typeSizesValue = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(_this4.props.typeSizes), [value]))));

            _this4.props.changeField([{ field: 'typeSizes', value: typeSizesValue }].concat(_toConsumableArray(_this4.calculateMinMax(typeSizesValue))));
        }, _this4.removeTypeSize = function (typeSize) {
            var typeSizesValue = _this4.props.typeSizes.filter(function (t) {
                return t !== typeSize;
            });

            _this4.props.changeField([{ field: 'typeSizes', value: typeSizesValue }].concat(_toConsumableArray(_this4.calculateMinMax(typeSizesValue))));
        }, _this4.calculateMinMax = function (typeSizesArr) {
            if (typeSizesArr.length > 0) {
                var firstTypeSize = __WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes___default.a.find(function (v) {
                    return Object.keys(v)[0] === typeSizesArr[0];
                });
                var lastTypeSize = __WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes___default.a.find(function (v) {
                    return Object.keys(v)[0] === typeSizesArr[typeSizesArr.length - 1];
                });

                return [{ field: 'dwtMin', value: firstTypeSize[Object.keys(firstTypeSize)[0]].min }, { field: 'dwtMax', value: lastTypeSize[Object.keys(lastTypeSize)[0]].max }];
            }
            return [];
        }, _temp2), _possibleConstructorReturn(_this4, _ret2);
    }

    _createClass(VesselTypesSelector, [{
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _state2 = this.state,
                selected = _state2.selected,
                selectedType = _state2.selectedType;
            var typeSizes = this.props.typeSizes;


            var typeSizesToShow = [];

            var indexOfLast = typeSizes.length - 1;
            if (indexOfLast >= 0) {
                var indexOfType = __WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes___default.a.findIndex(function (v) {
                    return Object.keys(v)[0] === typeSizes[indexOfLast];
                });
                typeSizesToShow = __WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes___default.a.slice(indexOfType + 1);
            } else {
                typeSizesToShow = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_14__VesselTypeSizes___default.a);
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["q" /* RadioButtonGroup */],
                            {
                                name: 'shipSelector',
                                defaultSelected: selected,
                                style: styles.redioGroup,
                                onChange: function onChange(_t, selected) {
                                    return _this5.changeSelected(selected);
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["p" /* RadioButton */], {
                                value: 'dwt',
                                label: 'DWT',
                                style: styles.radioButton
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["p" /* RadioButton */], {
                                value: 'vessel_type',
                                label: 'Vessel Type',
                                style: styles.radioButton
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-6' },
                        selected === 'vessel_type' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["s" /* SelectField */],
                            {
                                value: selectedType,
                                onChange: function onChange(e, i, value) {
                                    return _this5.addTypeSize(e, i, value);
                                },
                                name: 'geared',
                                floatingLabelText: 'Vessel type',
                                style: { marginTop: '-40px' },
                                fullWidth: true,
                                autoWidth: true
                            },
                            typeSizesToShow && typeSizesToShow.map(function (vesselType, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                                    key: 'vesselType_' + index,
                                    value: Object.keys(vesselType)[0],
                                    primaryText: Object.keys(vesselType)[0]
                                });
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-12', style: { display: 'flex', flexFlow: 'wrap' } },
                        typeSizes && typeSizes.map(function (typeSize, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
                                {
                                    key: 'typeSize_' + index,
                                    onRequestDelete: function onRequestDelete() {
                                        return _this5.removeTypeSize(typeSize);
                                    },
                                    style: _extends({}, styles.chips, { backgroundColor: '#d6edbd' })
                                },
                                typeSize
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return VesselTypesSelector;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx');
    reactHotLoader.register(defaultGearV2, 'defaultGearV2', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx');
    reactHotLoader.register(defaultGrabV2, 'defaultGrabV2', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx');
    reactHotLoader.register(defaultSelectedCountry, 'defaultSelectedCountry', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx');
    reactHotLoader.register(VesselRequirements, 'VesselRequirements', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx');
    reactHotLoader.register(VesselTypesSelector, 'VesselTypesSelector', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/VesselRequirements.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3453 */
/***/ (function(module, exports) {

module.exports = [{
    OMSKIY: { min: 3174, max: 3174 }
}, {
    AMUR: { min: 3329, max: 3329 }
}, {
    SORMOVSKIY: { min: 3353, max: 3353 }
}, {
    SIBIRSKIY: { min: 3427, max: 3427 }
}, {
    VOLGO_BALT: { min: 3474, max: 3474 }
}, {
    VOLGO_DON: { min: 5885, max: 5885 }
}, {
    HANDYSIZE: { min: 24000, max: 34999 }
}, {
    HANDYMAX: { min: 35000, max: 49999 }
}, {
    SUPRAMAX: { min: 50000, max: 59999 }
}, {
    ULTRAMAX: { min: 60000, max: 64999 }
}, {
    PANAMAX: { min: 65000, max: 79999 }
}, {
    KAMSARMAX: { min: 80000, max: 82999 }
}, {
    L_MODERN_ECOTYPE: { min: 80000, max: 99999 }
}, {
    POSTPANAMAX: { min: 83000, max: 99999 }
}, {
    AFRAMAX: { min: 80000, max: 120000 }
}, {
    BABYCAPE: { min: 100000, max: 119999 }
}, {
    CAPESIZE: { min: 120000, max: 189999 }
}, {
    SUEZMAX: { min: 120000, max: 200000 }
}, {
    NEWCASTLEMAX: { min: 190000, max: 209999 }
}, {
    VLOC: { min: 210000, max: 379999 }
}, {
    VALEMAX: { min: 380000, max: 400000 }
}];

/***/ }),
/* 3454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_alert_warning__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_alert_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_alert_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_tc_orders__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var styles = {
    add: {
        display: 'flex',
        justifyContent: 'center'
    },
    chips: {
        margin: '8px 8px 0 0'
    }
};

var getDefaultIncExc = function getDefaultIncExc() {
    return {
        cargoId: null,
        cargoName: null,
        dangerous: false,
        bulk: 'dry-bulk',
        cargoType: {
            name: null
        }
    };
};

var Cargo = function (_React$PureComponent) {
    _inherits(Cargo, _React$PureComponent);

    function Cargo() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Cargo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cargo.__proto__ || Object.getPrototypeOf(Cargo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            cargoNames: [],
            includedCargo: getDefaultIncExc(),
            excludedCargo: getDefaultIncExc()
        }, _this.dAutocomplete = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (searchText) {
            __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].getCargoNamesAutocomplete(searchText).then(function (response) {
                var cargoNames = response.data.data.map(function (cargoName) {
                    return {
                        name: cargoName.name,
                        item: cargoName
                    };
                });

                _this.setState({
                    cargoNames: cargoNames
                });
            }).catch(function () {
                return null;
            });
        }, 1000), _this.onChangeAutoCompleteCargoName = function (value, type) {
            _this.setState(_defineProperty({}, type + 'Cargo', _extends({}, _this.state[type + 'Cargo'], {
                cargoName: value,
                cargoId: null
            })), function () {
                _this.dAutocomplete(value);
            });
        }, _this.onChooseAutoCompleteCargoName = function (selected, type) {
            var _this$setState2;

            if (!selected) {
                return;
            }

            var _selected$item = selected.item,
                cargoId = _selected$item._id,
                cargoName = _selected$item.name,
                parent = _selected$item.parent;


            _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, type + 'Cargo', _extends({}, _this.state[type + 'Cargo'], {
                cargoId: cargoId,
                cargoName: cargoName,
                cargoType: _extends({
                    details: selected.item.details
                }, selected.item.parent.red)
            })), _defineProperty(_this$setState2, 'cargoNames', []), _this$setState2));
        }, _this.addCargo = function (type) {
            var _this$state$ = _this.state[type + 'Cargo'],
                cargoId = _this$state$.cargoId,
                cargoName = _this$state$.cargoName,
                cargoType = _this$state$.cargoType,
                dangerous = _this$state$.dangerous,
                bulk = _this$state$.bulk;


            var _tcOrder = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.props.tcOrder);

            var alreadyExists = _tcOrder.cargo[type].find(function (i) {
                return i.cargoId === cargoId && i.cargoType._id === cargoType._id && i.dangerous === dangerous && i.bulk === bulk;
            });

            if (!alreadyExists) {
                _tcOrder.cargo[type].push({
                    cargoId: cargoId, cargoName: cargoName, cargoType: cargoType, dangerous: dangerous, bulk: bulk
                });

                _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
            }

            _this.setState(_defineProperty({}, type + 'Cargo', getDefaultIncExc()));
        }, _this.deleteCargo = function (type, index) {
            var cargoIncExc = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.props.tcOrder.cargo[type]);

            cargoIncExc.splice(index, 1);

            _this.props.updateTcOrder(_this.props.numberOrderTable, _extends({}, _this.props.tcOrder, {
                cargo: _extends({}, _this.props.tcOrder.cargo, _defineProperty({}, type, cargoIncExc))
            }));
        }, _this.changeField = function (type, field, value) {
            _this.setState(_defineProperty({}, type + 'Cargo', _extends({}, _this.state[type + 'Cargo'], _defineProperty({}, field, value))));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Cargo, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var cargoNames = this.state.cargoNames;
            var _props = this.props,
                _props$cargoTypes = _props.cargoTypes,
                cargoTypes = _props$cargoTypes === undefined ? [] : _props$cargoTypes,
                cargo = _props.tcOrder.cargo;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                ['included', 'excluded'].map(function (typeIncExc, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: typeIncExc },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row', key: 'typeIncExc_' + index },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-3' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["a" /* AutoComplete */], {
                                    name: 'cargoName',
                                    textFieldStyle: { fontSize: '13px' },
                                    hintText: 'Cargo name (' + typeIncExc + ')',
                                    searchText: _this2.state[typeIncExc + 'Cargo'].cargoName || '',
                                    dataSource: cargoNames,
                                    dataSourceConfig: { text: 'name', value: 'item' },
                                    onUpdateInput: function onUpdateInput(value) {
                                        return _this2.onChangeAutoCompleteCargoName(value, typeIncExc);
                                    },
                                    onNewRequest: function onNewRequest(value) {
                                        return _this2.onChooseAutoCompleteCargoName(value, typeIncExc);
                                    },
                                    filter: __WEBPACK_IMPORTED_MODULE_4_material_ui__["a" /* AutoComplete */].noFilter,
                                    listStyle: { overflow: 'auto', maxHeight: '300px' },
                                    menuStyle: { width: '500px' },
                                    popoverProps: {
                                        canAutoPosition: true,
                                        style: { width: 'auto' }
                                    },
                                    fullWidth: true
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-3' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["s" /* SelectField */],
                                    {
                                        value: _this2.state[typeIncExc + 'Cargo'].cargoType._id || '',
                                        onChange: function onChange(_e, _i, value) {
                                            return _this2.changeField(typeIncExc, 'cargoType', {
                                                _id: value,
                                                name: cargoTypes.find(function (ct) {
                                                    return ct._id === value;
                                                }).name
                                            });
                                        },
                                        name: 'Cargo Type',
                                        disabled: !!_this2.state[typeIncExc + 'Cargo'].cargoId,
                                        floatingLabelText: 'Cargo Type',
                                        floatingLabelStyle: { fontSize: '13px' },
                                        style: { marginTop: '-22px', fontSize: '13px' },
                                        fullWidth: true,
                                        autoWidth: true
                                    },
                                    cargoTypes.map(function (cargoType) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], {
                                            key: 'cargoType_' + cargoType._id,
                                            value: cargoType._id,
                                            primaryText: cargoType.name
                                        });
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["s" /* SelectField */],
                                    {
                                        value: _this2.state[typeIncExc + 'Cargo'].bulk || '',
                                        style: { marginTop: '12px', fontSize: '13px' },
                                        onChange: function onChange(_e, _i, value) {
                                            return _this2.changeField(typeIncExc, 'bulk', value);
                                        },
                                        fullWidth: true,
                                        autoWidth: true
                                    },
                                    ['Dry-bulk', 'Wet-bulk', 'Break-bulk'].map(function (anotherCargoType) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], {
                                            key: 'anotherCargoType_' + anotherCargoType,
                                            value: anotherCargoType.toLowerCase(),
                                            primaryText: anotherCargoType
                                        });
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["b" /* Checkbox */], {
                                    label: 'Dangerous',
                                    iconStyle: { marginRight: '5px' },
                                    checked: _this2.state[typeIncExc + 'Cargo'].dangerous,
                                    onCheck: function onCheck() {
                                        return _this2.changeField(typeIncExc, 'dangerous', !_this2.state[typeIncExc + 'Cargo'].dangerous);
                                    }
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-2', style: styles.add },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4_material_ui__["h" /* IconButton */],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                        onClick: function onClick() {
                                            _this2.addCargo(typeIncExc);
                                        },
                                        color: 'green'
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-12', style: { display: 'flex', flexFlow: 'wrap' } },
                                cargo && cargo[typeIncExc] && cargo[typeIncExc].map(function (cgo, index) {
                                    var backgroundColor = typeIncExc === 'excluded' ? '#e6e6e6' : '#d6edbd';
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["c" /* Chip */],
                                        {
                                            key: 'cgo_' + index,
                                            onRequestDelete: function onRequestDelete() {
                                                return _this2.deleteCargo(typeIncExc, index);
                                            },
                                            style: _extends({}, styles.chips, { backgroundColor: backgroundColor, whiteSpace: 'initial' })
                                        },
                                        cgo.dangerous && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_alert_warning___default.a, { style: { margin: '0 4px -6px 0' }, color: 'red' }),
                                        (cgo.cargoName || 'Any') + ' (' + (cgo.cargoType.name ? cgo.cargoType.name + ', ' : '') + cgo.bulk + ')'
                                    );
                                })
                            )
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Cargo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref2) {
    var tcOrders = _ref2.tcOrders,
        cargoTypes = _ref2.cargoTypes;
    return {
        // tcOrders,
        cargoTypes: cargoTypes
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_8_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(Cargo);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(styles, 'styles', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Cargo.jsx');
    reactHotLoader.register(getDefaultIncExc, 'getDefaultIncExc', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Cargo.jsx');
    reactHotLoader.register(Cargo, 'Cargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Cargo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Cargo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_tc_orders__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var tcContracts = [];

var CommissionAndContracts = function (_React$PureComponent) {
    _inherits(CommissionAndContracts, _React$PureComponent);

    function CommissionAndContracts() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CommissionAndContracts);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommissionAndContracts.__proto__ || Object.getPrototypeOf(CommissionAndContracts)).call.apply(_ref, [this].concat(args))), _this), _this.handleChangeCommission = function (value) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.commission = value;

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _this.changeContract = function (value) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.contract = value;

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CommissionAndContracts, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$tcOrder = this.props.tcOrder,
                _props$tcOrder$contra = _props$tcOrder.contract,
                contract = _props$tcOrder$contra === undefined ? null : _props$tcOrder$contra,
                _props$tcOrder$commis = _props$tcOrder.commission,
                commission = _props$tcOrder$commis === undefined ? null : _props$tcOrder$commis;
            var contracts = this.props.contracts;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    'Commission:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["A" /* TextField */], {
                        name: 'commission',
                        style: { fontSize: '13px' },
                        value: commission || '',
                        type: 'number',
                        onChange: function onChange(e) {
                            return _this2.handleChangeCommission(parseFloat(e.target.value));
                        },
                        fullWidth: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    'Contract:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_material_ui__["s" /* SelectField */],
                        {
                            onChange: function onChange(_e, _i, value) {
                                return _this2.changeContract(value);
                            },
                            value: contract,
                            style: { marginTop: '12px', fontSize: '13px' },
                            fullWidth: true,
                            autoWidth: true
                        },
                        contracts && contracts.map(function (ctr, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["m" /* MenuItem */], {
                                key: 'ctr_' + index,
                                value: ctr._id,
                                primaryText: ctr.name
                            });
                        })
                    )
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return CommissionAndContracts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref2) {
    var contracts = _ref2.contracts;

    return {
        contracts: contracts.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_3_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(CommissionAndContracts);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(tcContracts, 'tcContracts', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/CommissionAndContracts.jsx');
    reactHotLoader.register(CommissionAndContracts, 'CommissionAndContracts', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/CommissionAndContracts.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/CommissionAndContracts.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_tc_orders__ = __webpack_require__(127);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var typeTerms = ['POL dets:', 'POD dets:', 'POL/POD dets:', 'Laycan dets:', 'Load dets:', 'Disch dets:', 'L/D dets:', 'Comm dets:', 'Freight dets:', 'Vessel dets:', 'Packing dets:', 'Additional dets:', 'Cargo dets:'];

var Terms = function (_React$PureComponent) {
    _inherits(Terms, _React$PureComponent);

    function Terms() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Terms);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Terms.__proto__ || Object.getPrototypeOf(Terms)).call.apply(_ref, [this].concat(args))), _this), _this.removeTerm = function (number) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.terms.user.splice(number, 1);

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _this.addNewTerm = function () {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.terms.user.push({ type: '', value: '' });

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _this.onChangeTypeTerm = function (key, numberElement) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.terms.user[numberElement].type = typeTerms[key];

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _this.onChangeTerm = function (value, numberElement) {
            var _tcOrder = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.props.tcOrder);

            _tcOrder.terms.user[numberElement].value = value;

            _this.props.updateTcOrder(_this.props.numberOrderTable, _tcOrder);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Terms, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$tcOrder$terms$ = this.props.tcOrder.terms.user,
                user = _props$tcOrder$terms$ === undefined ? [] : _props$tcOrder$terms$;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-left' },
                        'Terms:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'column-right' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                            labelStyle: { fontSize: '10px' },
                            style: { height: '25px' },
                            buttonStyle: { height: '25px', lineHeight: '25px' },
                            label: 'Add new term',
                            onClick: this.addNewTerm,
                            primary: true
                        })
                    )
                ),
                user.map(function (term, key) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { key: 'term_' + key, className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'column-left' },
                            'Term ' + key
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'column-right' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_material_ui_SelectField___default.a,
                                {
                                    style: {
                                        padding: '0 5px',
                                        width: '80%',
                                        fontSize: '13px'
                                    },
                                    value: term.type,
                                    onChange: function onChange(e, numberSelected) {
                                        _this2.onChangeTypeTerm(numberSelected, key);
                                    },
                                    maxHeight: 200,
                                    autoWidth: true
                                },
                                typeTerms.map(function (typeTerm, i) {
                                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_MenuItem___default.a, {
                                        key: i,
                                        style: { width: 'auto', fontSize: '13px' },
                                        value: typeTerm,
                                        primaryText: typeTerm
                                    });
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a, {
                                style: { fontSize: '13px' },
                                value: term.value || '',
                                hintText: 'Term ' + key,
                                onChange: function onChange(e) {
                                    return _this2.onChangeTerm(e.target.value, key);
                                }
                            }),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_RaisedButton___default.a, {
                                labelStyle: { fontSize: '10px' },
                                style: { height: '25px' },
                                buttonStyle: { height: '25px', lineHeight: '25px' },
                                label: 'Remove term',
                                onClick: function onClick() {
                                    return _this2.removeTerm(key);
                                },
                                secondary: true
                            })
                        )
                    );
                })
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Terms;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {};
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        updateTcOrder: __WEBPACK_IMPORTED_MODULE_8_actions_tc_orders__["e" /* updateTcOrder */]
    }, dispatch);
})(Terms);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(typeTerms, 'typeTerms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Terms.jsx');
    reactHotLoader.register(Terms, 'Terms', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Terms.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Letters/SingleNew/TC/content/Terms.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_companies__ = __webpack_require__(3458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_realCompanies__ = __webpack_require__(3459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CompaniesRealNamesTable__ = __webpack_require__(3460);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












function CompanyRealName(_ref) {
    var getCompanies = _ref.getCompanies,
        getRealCompanies = _ref.getRealCompanies,
        isLoaded = _ref.isLoaded;


    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getCompanies();
        getRealCompanies();
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress___default.a, {
            className: !isLoaded ? '' : 'hidden',
            style: __WEBPACK_IMPORTED_MODULE_2_styles_index__["a" /* default */].circularProgress
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: isLoaded ? '' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h2',
                    null,
                    'real companies names'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CompaniesRealNamesTable__["a" /* default */], null)
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state) {
    return {
        isLoaded: state.companies.isLoaded
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getCompanies: __WEBPACK_IMPORTED_MODULE_5_actions_companies__["a" /* getCompanies */],
        getRealCompanies: __WEBPACK_IMPORTED_MODULE_6_actions_realCompanies__["a" /* getRealCompanies */]
    }, dispatch);
})(CompanyRealName);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CompanyRealName, 'CompanyRealName', '/opt/atlassian/pipelines/agent/build/client/app/components/Companies/CompanyRealName/Page.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Companies/CompanyRealName/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getCompanies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getCompanies() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_21" /* GET_COMPANIES */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getCompanies, 'getCompanies', '/opt/atlassian/pipelines/agent/build/client/app/actions/companies.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getRealCompanies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getRealCompanies() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_40" /* GET_REAL_COMPANIES */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getRealCompanies, 'getRealCompanies', '/opt/atlassian/pipelines/agent/build/client/app/actions/realCompanies.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompaniesRealNamesRow__ = __webpack_require__(3461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











function CompaniesRealNamesTable(_ref) {
    var companies = _ref.companies;


    var rowsPerPage = [20, 50, 100];

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        rows = _useState2[0],
        setRows = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        rowsForPagination = _useState4[0],
        setRowsForPagination = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState6 = _slicedToArray(_useState5, 2),
        page = _useState6[0],
        setPage = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(20),
        _useState8 = _slicedToArray(_useState7, 2),
        numberOfRows = _useState8[0],
        setNumberOfRows = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState10 = _slicedToArray(_useState9, 2),
        searchText = _useState10[0],
        setSearchText = _useState10[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        handleUpdateRow({ page: page, numberOfRows: numberOfRows }, searchText);
    }, [companies]);

    var changeRowsByPagination = function changeRowsByPagination(page, numberOfRows, searchText) {
        var elementsOnPage = numberOfRows;
        var offset = page - 1;
        var from = offset * elementsOnPage;
        var to = offset * elementsOnPage + elementsOnPage;

        var companiesCopy = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(companies);

        if (searchText) {
            var regex = new RegExp('^' + searchText, 'i');
            companiesCopy = companiesCopy.filter(function (i) {
                return regex.test(i.name);
            });
        }

        setRowsForPagination(companiesCopy);

        return companiesCopy.slice(from, to);
    };

    var handleUpdateRow = function handleUpdateRow(_ref2, searchText) {
        var page = _ref2.page,
            numberOfRows = _ref2.numberOfRows;

        setRows(changeRowsByPagination(page, numberOfRows, searchText));
        setPage(page);
        setNumberOfRows(numberOfRows);
    };

    var handleSearch = function handleSearch(e) {
        var searchText = e.target.value;
        if (searchText.length < 2) {
            setRows(changeRowsByPagination(1, numberOfRows, ''));
            setSearchText('');
            return;
        }
        setPage(1);

        handleUpdateRow({ page: 1, numberOfRows: numberOfRows }, searchText);
        setSearchText(searchText);
    };

    var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Libs_Pagination__["a" /* default */], {
        total: rowsForPagination.length,
        rowsPerPage: rowsPerPage,
        page: page,
        numberOfRows: numberOfRows,
        updateRows: function updateRows(e) {
            return handleUpdateRow(e, searchText);
        }
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header', style: { justifyContent: 'space-between' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                defaultValue: searchText,
                floatingLabelText: 'Search',
                onChange: handleSearch
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                renderPagination
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
                    { selectable: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["w" /* TableHeader */],
                        { displaySelectAll: false, adjustForCheckbox: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS },
                                'Company name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */], { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS },
                                'Real Company name'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnCSS },
                                null
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
                        { displayRowCheckbox: false },
                        rows.map(function (company) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompaniesRealNamesRow__["a" /* default */], {
                                key: company._id,
                                company: company
                            });
                        })
                    )
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
    return {
        companies: state.companies.items
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        // searchCargoRealNames,
    }, dispatch);
})(CompaniesRealNamesTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CompaniesRealNamesTable, 'CompaniesRealNamesTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Companies/CompanyRealName/CompaniesRealNamesTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Companies/CompanyRealName/CompaniesRealNamesTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_react_utils__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Base_AwaitableBtn__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_notifications_notifications__ = __webpack_require__(41);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













function CompaniesRealNamesRow(_ref) {
    var _this = this;

    var key = _ref.key,
        company = _ref.company,
        addNotification = _ref.addNotification,
        realCompaniesIds = _ref.realCompaniesIds;

    var _useRefState = Object(__WEBPACK_IMPORTED_MODULE_5_helpers_react_utils__["a" /* useRefState */])(''),
        _useRefState2 = _slicedToArray(_useRefState, 3),
        search = _useRefState2[0],
        setSearch = _useRefState2[1],
        searchRef = _useRefState2[2];

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        companies = _useState2[0],
        setCompanies = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState4 = _slicedToArray(_useState3, 2),
        selectedCompany = _useState4[0],
        setSelectedCompany = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(company.realCompany || null),
        _useState6 = _slicedToArray(_useState5, 2),
        realCompany = _useState6[0],
        setRealCompany = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState8 = _slicedToArray(_useState7, 2),
        shouldShowUpdate = _useState8[0],
        setShouldShowUpdate = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!!realCompany),
        _useState10 = _slicedToArray(_useState9, 2),
        shouldShowDelete = _useState10[0],
        setShouldShowDelete = _useState10[1];

    var searchCompanies = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchText) {
            var companies;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setSearch(searchText);

                            if (!(searchText.length < 2)) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt('return');

                        case 3:
                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].findRealCompany('ifchor', searchText);

                        case 5:
                            companies = _context.sent;

                            if (!(searchRef.current !== searchText)) {
                                _context.next = 8;
                                break;
                            }

                            return _context.abrupt('return');

                        case 8:

                            if (companies.status === 200) {
                                setCompanies(companies.data.data);
                            }

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function searchCompanies(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var onCompanySelected = function onCompanySelected(company) {
        setSelectedCompany(company);
        setShouldShowUpdate(true);
    };

    var handleUpdateCompany = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(parentCompany, selectedCompany) {
            var response;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(!parentCompany || !selectedCompany)) {
                                _context2.next = 2;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 2:
                            _context2.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].saveRealCompany(parentCompany._id, selectedCompany._id);

                        case 4:
                            response = _context2.sent;


                            if (response.status === 200) {
                                if (response.errors && response.errors.length) {
                                    addNotification({
                                        title: "Error",
                                        message: response.errors[0].message || response.errors[0].messages[0],
                                        level: "error",
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 3
                                    });
                                } else {
                                    addNotification({
                                        title: "Success",
                                        message: "Real name updated successfully",
                                        level: "success",
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 3
                                    });
                                    setShouldShowUpdate(false);
                                    setShouldShowDelete(true);
                                }
                            }

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function handleUpdateCompany(_x2, _x3) {
            return _ref3.apply(this, arguments);
        };
    }();

    var handleDeleteRealCompany = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
            var _id = _ref5._id,
                realCompanyFromDb = _ref5.realCompany;
            var realCompanyId, response;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            realCompanyId = void 0;

                            if (!realCompanyFromDb) {
                                realCompanyId = selectedCompany._id;
                            } else {
                                realCompanyId = realCompanyFromDb.company._id;
                            }

                            if (!(!_id || !realCompanyId)) {
                                _context3.next = 4;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 4:
                            _context3.next = 6;
                            return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].deleteRealCompany(_id, realCompanyId);

                        case 6:
                            response = _context3.sent;


                            if (response.status === 200) {
                                if (response.errors && response.errors.length) {
                                    addNotification({
                                        title: "Error",
                                        message: response.errors[0].message || response.errors[0].messages[0],
                                        level: "error",
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 3
                                    });
                                } else {
                                    addNotification({
                                        title: "Success",
                                        message: "Real name removed successfully",
                                        level: "success",
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 3
                                    });
                                    setShouldShowDelete(false);
                                    setRealCompany(null);
                                    setSearch('');
                                }
                            }

                        case 8:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function handleDeleteRealCompany(_x4) {
            return _ref4.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_material_ui__["y" /* TableRow */],
        {
            key: key
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
            {
                style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS,
                className: 'cargo-realnames_name_column'
            },
            company.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
            null,
            realCompaniesIds.includes(company._id) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'b',
                null,
                'IFCHOR'
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
            { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */], {
                name: 'companyName',
                textFieldStyle: { fontSize: "13px" },
                hintText: 'Company name',
                searchText: search || realCompany && realCompany.company.name || '',
                dataSource: companies,
                dataSourceConfig: { text: "name", value: "item" },
                onUpdateInput: searchCompanies,
                onNewRequest: onCompanySelected,
                filter: __WEBPACK_IMPORTED_MODULE_3_material_ui__["a" /* AutoComplete */].noFilter,
                listStyle: { overflow: "auto", maxHeight: "300px" },
                popoverProps: {
                    canAutoPosition: true
                }
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
            { style: __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: shouldShowUpdate ? '' : 'hidden', style: { textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_components_Base_AwaitableBtn__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Update',
                        primary: true,
                        onClick: function onClick() {
                            return handleUpdateCompany(company, selectedCompany);
                        }
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: shouldShowDelete ? '' : 'hidden', style: { textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_components_Base_AwaitableBtn__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Clear',
                        secondary: true,
                        onClick: function onClick() {
                            return handleDeleteRealCompany(company);
                        }
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
    return {
        realCompaniesIds: state.realCompanies.items.map(function (c) {
            return c._id;
        })
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_8_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(CompaniesRealNamesRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(CompaniesRealNamesRow, 'CompaniesRealNamesRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Companies/CompanyRealName/CompaniesRealNamesRow.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Companies/CompanyRealName/CompaniesRealNamesRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_analytics_linksList__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LinksList__ = __webpack_require__(3463);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











function AnalyticsDashboard(_ref) {
    var isLoaded = _ref.isLoaded,
        getAnalyticsLinksList = _ref.getAnalyticsLinksList;


    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        getAnalyticsLinksList();
    }, []);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui_CircularProgress___default.a, {
            className: !isLoaded ? '' : 'hidden',
            style: __WEBPACK_IMPORTED_MODULE_4_styles_index__["a" /* default */].circularProgress
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: isLoaded ? '' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'container' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h2',
                    null,
                    'Analytics dashboard'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LinksList__["a" /* default */], null)
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        isLoaded: true
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getAnalyticsLinksList: __WEBPACK_IMPORTED_MODULE_5_actions_analytics_linksList__["a" /* getAnalyticsLinksList */]
    }, dispatch);
})(AnalyticsDashboard);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AnalyticsDashboard, 'AnalyticsDashboard', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/AnalyticsDashboard.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/AnalyticsDashboard.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Libs_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RangeDates__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AddUpdateModal__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TagsModal__ = __webpack_require__(3464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LinksTags__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LinksRow__ = __webpack_require__(3466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_actions_analytics_linksList__ = __webpack_require__(979);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


















function LinksList(_ref) {
    var analyticsLinksList = _ref.analyticsLinksList,
        getAnalyticsLinksList = _ref.getAnalyticsLinksList;

    var rowsPerPage = [20, 50, 100];

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        rows = _useState2[0],
        setRows = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        rowsForPagination = _useState4[0],
        setRowsForPagination = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState6 = _slicedToArray(_useState5, 2),
        page = _useState6[0],
        setPage = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(20),
        _useState8 = _slicedToArray(_useState7, 2),
        numberOfRows = _useState8[0],
        setNumberOfRows = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState10 = _slicedToArray(_useState9, 2),
        searchText = _useState10[0],
        setSearchText = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState12 = _slicedToArray(_useState11, 2),
        tags = _useState12[0],
        setTags = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState14 = _slicedToArray(_useState13, 2),
        from = _useState14[0],
        setFrom = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState16 = _slicedToArray(_useState15, 2),
        until = _useState16[0],
        setUntil = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState18 = _slicedToArray(_useState17, 2),
        openDialog = _useState18[0],
        setOpenDialog = _useState18[1];

    var _useState19 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState20 = _slicedToArray(_useState19, 2),
        currentDialogType = _useState20[0],
        setCurrentDialogType = _useState20[1];

    var _useState21 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState22 = _slicedToArray(_useState21, 2),
        allTags = _useState22[0],
        setAllTags = _useState22[1];

    var changeRowsByPagination = function changeRowsByPagination(_page, _numberOfRows, _searchText, _tags, _fromDate, _untilDate) {
        var elementsOnPage = _numberOfRows;
        var offset = _page - 1;
        var _from = offset * elementsOnPage;
        var _to = offset * elementsOnPage + elementsOnPage;

        var analyticsLinksListCopy = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(analyticsLinksList);

        if (_searchText) {
            var regex = new RegExp('' + _searchText, 'i');
            analyticsLinksListCopy = analyticsLinksListCopy.filter(function (i) {
                return regex.test(i.value);
            });
        }

        if (_tags && _tags.length) {
            var tagsValues = _tags.map(function (_t) {
                return _t.value;
            });
            analyticsLinksListCopy = analyticsLinksListCopy.filter(function (item) {
                var itemTagsValues = item.tags.map(function (t) {
                    return t.value;
                });
                // return _.intersection(tagsValues, itemTagsValues).length; // has any of tags
                return tagsValues.every(function (t) {
                    return itemTagsValues.includes(t);
                }); // has all specified tags
            });
        }

        if (_fromDate) {
            analyticsLinksListCopy = analyticsLinksListCopy.filter(function (item) {
                return __WEBPACK_IMPORTED_MODULE_12_moment___default()(_fromDate).isSameOrBefore(item.createdAt);
            });
        }

        if (_untilDate) {
            analyticsLinksListCopy = analyticsLinksListCopy.filter(function (item) {
                return __WEBPACK_IMPORTED_MODULE_12_moment___default()(_untilDate).isSameOrAfter(item.createdAt);
            });
        }

        setRowsForPagination(analyticsLinksListCopy);

        return analyticsLinksListCopy.slice(_from, _to);
    };

    var handleUpdateRow = function handleUpdateRow(_ref2, _searchText, _tags, _fromDate, _untilDate) {
        var p = _ref2.page,
            n = _ref2.numberOfRows;

        setRows(changeRowsByPagination(p, n, _searchText, _tags || tags, _fromDate, _untilDate));
        setPage(p);
        setNumberOfRows(n);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        handleUpdateRow({ page: page, numberOfRows: numberOfRows }, searchText, tags, from, until);

        var uniqueTags = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.flatten(analyticsLinksList.map(function (a) {
            return a.tags;
        })), 'value'), ['value']);
        setAllTags(uniqueTags);
    }, [analyticsLinksList]);

    var handleSearch = function handleSearch(e) {
        var _searchText = e.target.value;
        if (_searchText.length < 2) {
            setRows(changeRowsByPagination(1, numberOfRows, '', tags, from, until));
            setSearchText('');
            return;
        }
        setPage(1);

        handleUpdateRow({ page: 1, numberOfRows: numberOfRows }, _searchText, tags, from, until);
        setSearchText(_searchText);
    };

    var handleChangeTags = function handleChangeTags(_tags) {
        setTags(_tags);
        handleUpdateRow({ page: 1, numberOfRows: numberOfRows }, searchText, _tags, from, until);
    };

    var renderPagination = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Libs_Pagination__["a" /* default */], {
        total: rowsForPagination.length,
        rowsPerPage: rowsPerPage,
        page: page,
        numberOfRows: numberOfRows,
        updateRows: function updateRows(e) {
            return handleUpdateRow(e, searchText);
        }
    });

    var changeFilterByDate = function changeFilterByDate(type, date) {
        if (type === 'from') {
            setFrom(date);
            handleUpdateRow({ page: 1, numberOfRows: numberOfRows }, searchText, tags, date, until);
        } else {
            setUntil(date);
            handleUpdateRow({ page: 1, numberOfRows: numberOfRows }, searchText, tags, from, date);
        }
    };

    var handleOpenDialog = function handleOpenDialog(type) {
        setOpenDialog(true);
        setCurrentDialogType(type);
    };

    var handleModifyLinksList = function handleModifyLinksList() {
        getAnalyticsLinksList();
    };

    var pushToTagsSearch = function pushToTagsSearch(tag) {
        handleChangeTags(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniqBy([].concat(_toConsumableArray(tags), [tag]), 'value'));
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AddUpdateModal__["a" /* default */], {
            open: currentDialogType === 'add' && openDialog,
            setOpen: setOpenDialog,
            type: currentDialogType,
            handleSearch: handleSearch,
            handleModifyLinksList: handleModifyLinksList
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TagsModal__["a" /* default */], {
            open: currentDialogType === 'tags' && openDialog,
            setOpen: setOpenDialog,
            allTags: allTags,
            pushToTagsSearch: pushToTagsSearch
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item' },
                renderPagination
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["A" /* TextField */], {
                    defaultValue: searchText,
                    floatingLabelText: 'Search',
                    onChange: handleSearch,
                    style: { marginRight: '30px' }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RangeDates__["a" /* default */], {
                    from: from,
                    until: until,
                    changeDateRange: changeFilterByDate,
                    handleChangeDate: changeFilterByDate
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: { display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { width: '50%', marginTop: '15px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LinksTags__["a" /* default */], {
                        tags: tags,
                        setTags: handleChangeTags
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { width: '50%' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                        style: { margin: '20px 0 0 20px' },
                        label: 'Add record',
                        secondary: true,
                        onClick: function onClick() {
                            return handleOpenDialog('add');
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["r" /* RaisedButton */], {
                        style: { margin: '20px 0 0 20px' },
                        label: 'All tags',
                        onClick: function onClick() {
                            return handleOpenDialog('tags');
                        }
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-body' },
            !rows.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'nothing-found' },
                'Not found'
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_material_ui__["u" /* Table */],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["w" /* TableHeader */],
                    { displaySelectAll: false, adjustForCheckbox: false },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_material_ui__["y" /* TableRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnCSS, { width: '53%' }) },
                            'Value'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '17%' }) },
                            'User Info'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '20%' }) },
                            'Tags'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_material_ui__["x" /* TableHeaderColumn */],
                            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_10_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '10%' }) },
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_material_ui__["v" /* TableBody */],
                    { displayRowCheckbox: false },
                    rows.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LinksRow__["a" /* default */], {
                            key: item._id,
                            item: item,
                            handleModifyLinksList: handleModifyLinksList
                        });
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
    return {
        analyticsLinksList: state.linksList.items || [],
        isLoaded: true
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getAnalyticsLinksList: __WEBPACK_IMPORTED_MODULE_13_actions_analytics_linksList__["a" /* getAnalyticsLinksList */]
    }, dispatch);
})(LinksList);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LinksList, 'LinksList', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/LinksList.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/LinksList.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Paper__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_scss__ = __webpack_require__(3465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_scss__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function TagsModal(_ref) {
    var open = _ref.open,
        setOpen = _ref.setOpen,
        allTags = _ref.allTags,
        pushToTagsSearch = _ref.pushToTagsSearch;

    var addTagToSearch = function addTagToSearch(tag) {
        pushToTagsSearch(_extends({}, tag, { name: tag.value }));
        setOpen(false);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default.a,
        {
            open: open,
            onRequestClose: function onRequestClose() {
                return setOpen(false);
            },
            autoScrollBodyContent: true
        },
        allTags.map(function (tag, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    key: tag.value + '_' + index,
                    style: { marginBottom: '10px' }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui_Paper___default.a,
                    {
                        zDepth: 1,
                        className: 'paper_tag'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["l" /* Menu */],
                        {
                            listStyle: { paddingTop: 0, paddingBottom: 0 }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                            primaryText: tag.value,
                            onClick: function onClick() {
                                return addTagToSearch(tag);
                            },
                            style: {
                                backgroundColor: 'none',
                                fontSize: '13px',
                                wordBreak: 'break-word',
                                whiteSpace: 'unset'
                            }
                        })
                    )
                )
            );
        })
    );
}

var _default = TagsModal;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TagsModal, 'TagsModal', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/TagsModal.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/TagsModal.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3465 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128338
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LinksTags__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_save__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_open_in_new__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_open_in_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_open_in_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

















function LinksRow(_ref) {
    var _this = this;

    var key = _ref.key,
        item = _ref.item,
        addNotification = _ref.addNotification,
        handleModifyLinksList = _ref.handleModifyLinksList;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(item.value),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(item.tags.map(function (t) {
        return _extends({}, t, { name: t.value });
    })),
        _useState4 = _slicedToArray(_useState3, 2),
        tags = _useState4[0],
        setTags = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState6 = _slicedToArray(_useState5, 2),
        toUpdate = _useState6[0],
        setToUpdate = _useState6[1];

    var changeValue = function changeValue(e) {
        setValue(e.target.value);
        setToUpdate(true);
    };

    var changeTags = function changeTags(_tags) {
        setTags(_tags.map(function (t) {
            return _extends({}, t, { value: t.name });
        }));
        setToUpdate(true);
    };

    var handleUpdate = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var response;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!value) {
                                addNotification({
                                    title: 'Error',
                                    message: 'Value can not be empty',
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                            }

                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_12_services__["a" /* default */].updateAnalyticsLinksList(_extends({}, item, { value: value, tags: tags }));

                        case 3:
                            response = _context.sent;


                            if (!response.errors.length) {
                                addNotification({
                                    title: 'Success',
                                    message: 'Record updated successfully',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                                setToUpdate(false);
                            } else {
                                addNotification({
                                    title: 'Error',
                                    message: response.errors[0].message || response.errors[0].messages[0],
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                            }

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function handleUpdate() {
            return _ref2.apply(this, arguments);
        };
    }();

    var handleDelete = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var response;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_12_services__["a" /* default */].deleteAnalyticLink(item._id);

                        case 2:
                            response = _context2.sent;


                            if (!response.errors.length) {
                                addNotification({
                                    title: 'Success',
                                    message: 'Record removed successfully',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                                setToUpdate(false);
                                handleModifyLinksList();
                            } else {
                                addNotification({
                                    title: 'Error',
                                    message: response.errors[0].message || response.errors[0].messages[0],
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                            }

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function handleDelete() {
            return _ref3.apply(this, arguments);
        };
    }();

    var urlInValue = value && __WEBPACK_IMPORTED_MODULE_11_helpers__["a" /* default */].getUrlFromString(value);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["y" /* TableRow */],
        {
            key: key
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            {
                style: _extends({}, __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableRowColumnCSS, { width: '53%', maxWidth: 'unset' }),
                className: 'cargo-realnames_name_column'
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                name: 'record_' + key,
                value: value,
                onChange: changeValue,
                style: { fontSize: '14px', width: '90%' },
                multiLine: true,
                rowsMax: 10
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                { disabled: !urlInValue, style: { transform: 'translateY(10px)' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_svg_icons_action_open_in_new___default.a, {
                    onClick: function onClick() {
                        return urlInValue && window.open(urlInValue, '_blank');
                    }
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            {
                style: { width: '17%', padding: 0 }
            },
            'User: ',
            item.addedBy.email,
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            'Date: ',
            __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.createdAt).format('lll')
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnSmallCSS, { width: '20%' }) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LinksTags__["a" /* default */], {
                placeHolder: 'Add tags',
                tags: tags,
                setTags: changeTags
            })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_4_styles__["a" /* default */].tableHeaderColumnSmallCSS, { display: 'flex', margin: 'auto' }) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: toUpdate ? '' : 'hidden', style: { textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_save___default.a, {
                        onClick: handleUpdate,
                        style: { margin: '70px 0 0 0' },
                        color: '#09BCD4'
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_svg_icons_action_delete___default.a, {
                        onClick: handleDelete,
                        style: { margin: '70px 0 0 0' },
                        color: '#FF7DA9'
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        realCompaniesIds: state.realCompanies.items.map(function (c) {
            return c._id;
        })
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_7_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(LinksRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LinksRow, 'LinksRow', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/LinksRow.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/LinksRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_flagCompliance__ = __webpack_require__(3468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FlagComplianceTable__ = __webpack_require__(981);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










function FlagCompliance(_ref) {
    var getFlagCompliance = _ref.getFlagCompliance,
        isLoaded = _ref.isLoaded;

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getFlagCompliance();
    }, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_CircularProgress___default.a, {
            className: !isLoaded ? '' : 'hidden',
            style: __WEBPACK_IMPORTED_MODULE_5_styles__["a" /* default */].circularProgress
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: isLoaded ? '' : 'hidden' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h2',
                    null,
                    'Flag compliance'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FlagComplianceTable__["a" /* default */], null)
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function () {
    return {
        isLoaded: true
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({
        getFlagCompliance: __WEBPACK_IMPORTED_MODULE_4_actions_flagCompliance__["a" /* getFlagCompliance */]
    }, dispatch);
})(FlagCompliance);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FlagCompliance, 'FlagCompliance', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagCompliance.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagCompliance.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getFlagCompliance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function getFlagCompliance() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_25" /* GET_FLAG_COMPLIANCE */].REQUEST
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getFlagCompliance, 'getFlagCompliance', '/opt/atlassian/pipelines/agent/build/client/app/actions/flagCompliance.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_save__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_editor_mode_edit__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_editor_mode_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_editor_mode_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FlagComplianceTable__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FlagsComplianceAutoComplete__ = __webpack_require__(3470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(7);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













var chipStyles = {
    chip: {
        margin: 4
    },
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    }
};

function FlagComplianceRow(_ref) {
    var _this = this;

    var key = _ref.key,
        item = _ref.item,
        addNotification = _ref.addNotification;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(item.riskFactor),
        _useState2 = _slicedToArray(_useState, 2),
        riskFactor = _useState2[0],
        setRiskFactor = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(item.compatibility),
        _useState4 = _slicedToArray(_useState3, 2),
        avoid = _useState4[0],
        setAvoid = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState6 = _slicedToArray(_useState5, 2),
        toUpdate = _useState6[0],
        setToUpdate = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState8 = _slicedToArray(_useState7, 2),
        showAdd = _useState8[0],
        setShowAdd = _useState8[1];

    var changeRiskFaktor = function changeRiskFaktor(value) {
        setRiskFactor(value);
        setToUpdate(true);
    };

    var handleUpdate = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var response;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].updateFlagCompliance(item._id, { riskFactor: riskFactor || null, avoid: avoid.map(function (a) {
                                    return a._id;
                                }) });

                        case 2:
                            response = _context.sent;


                            if (!response.errors.length) {
                                addNotification({
                                    title: 'Success',
                                    message: 'Record updated successfully',
                                    level: 'success',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                                setToUpdate(false);
                            } else {
                                addNotification({
                                    title: 'Error',
                                    message: response.errors[0].message || response.errors[0].messages[0],
                                    level: 'error',
                                    _id: new Date().getMilliseconds(),
                                    autoDismiss: 3
                                });
                            }

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function handleUpdate() {
            return _ref2.apply(this, arguments);
        };
    }();

    var handleDeleteCountryChip = function handleDeleteCountryChip(countryId) {
        setAvoid(avoid.filter(function (country) {
            return country._id !== countryId;
        }));
        setToUpdate(true);
    };

    var addToAvoid = function addToAvoid(country) {
        var includes = avoid.find(function (a) {
            return a._id === country._id;
        });

        if (!includes) {
            setAvoid(avoid.concat(country));
            setToUpdate(true);
        }
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["y" /* TableRow */],
        {
            key: key
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            {
                style: __WEBPACK_IMPORTED_MODULE_4__FlagComplianceTable__["b" /* styles */].flag
            },
            item.flag
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            {
                style: __WEBPACK_IMPORTED_MODULE_4__FlagComplianceTable__["b" /* styles */].riskFactor
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                name: 'riskFaktor',
                value: riskFactor || '',
                onChange: function onChange(e) {
                    return changeRiskFaktor(e.target.value);
                },
                style: { fontSize: '14px' },
                type: 'number'
            })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            {
                style: __WEBPACK_IMPORTED_MODULE_4__FlagComplianceTable__["b" /* styles */].avoid
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: showAdd ? '' : 'hidden' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FlagsComplianceAutoComplete__["a" /* default */], {
                    addToAvoid: addToAvoid
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: chipStyles.wrapper },
                avoid.map(function (_avoid) {
                    return renderChip(_avoid, handleDeleteCountryChip);
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
            {
                style: __WEBPACK_IMPORTED_MODULE_4__FlagComplianceTable__["b" /* styles */].controls
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                {
                    className: toUpdate ? '' : 'hidden',
                    style: { textAlign: 'center', justifyContent: 'center' }
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_save___default.a, {
                        onClick: handleUpdate,
                        style: { margin: '70px 0 0 0' },
                        color: '#09BCD4'
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                {
                    className: showAdd ? 'hidden' : ''
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_editor_mode_edit___default.a, {
                    onClick: function onClick() {
                        return setShowAdd(!showAdd);
                    },
                    style: { margin: '70px 0 0 0' },
                    color: '#A6A6A6'
                })
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state) {
    return {
        realCompaniesIds: state.realCompanies.items.map(function (c) {
            return c._id;
        })
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_7_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(FlagComplianceRow);

/* harmony default export */ __webpack_exports__["a"] = (_default);

function renderChip(item, handleDeleteCountry) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["c" /* Chip */],
        {
            key: item._id,
            onRequestDelete: function onRequestDelete() {
                return handleDeleteCountry(item._id);
            },
            style: chipStyles.chip
        },
        item.flag
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(chipStyles, 'chipStyles', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagComplianceRow.jsx');
    reactHotLoader.register(FlagComplianceRow, 'FlagComplianceRow', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagComplianceRow.jsx');
    reactHotLoader.register(renderChip, 'renderChip', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagComplianceRow.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagComplianceRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function getInitialValue() {
    return { _id: '', flag: '' };
}

function FlagsComplianceAutoComplete(_ref) {
    var _ref$items = _ref.items,
        items = _ref$items === undefined ? [] : _ref$items,
        addToAvoid = _ref.addToAvoid;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(getInitialValue()),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    var handleSelectCountry = function handleSelectCountry(country) {
        addToAvoid(country);
        setValue(getInitialValue);
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_AutoComplete___default.a, {
        searchText: value.flag,
        hintText: 'Type anything',
        dataSource: items,
        dataSourceConfig: { text: 'flag', value: '_id' },
        onNewRequest: handleSelectCountry,
        onUpdateInput: function onUpdateInput(val) {
            return setValue({ _id: '', flag: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize(val) });
        },
        floatingLabelText: 'Search country',
        hintStyle: { fontSize: '13px' },
        textFieldStyle: { fontSize: '13px' },
        menuStyle: {
            width: '350px',
            maxHeight: '300px'
        },
        popoverProps: {
            canAutoPosition: true
        }
    });
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return {
        items: state.flagCompliance.items.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(item, ['_id', 'flag']);
        })
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["bindActionCreators"])({}, dispatch);
})(FlagsComplianceAutoComplete);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getInitialValue, 'getInitialValue', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagsComplianceAutoComplete.jsx');
    reactHotLoader.register(FlagsComplianceAutoComplete, 'FlagsComplianceAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagsComplianceAutoComplete.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/FlagCompliance/FlagsComplianceAutoComplete.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetentionsContent__ = __webpack_require__(3472);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function Detentions() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Vessel Detentions / Compliance'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DetentionsContent__["a" /* default */], null)
        )
    );
}

var _default = Detentions;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Detentions, 'Detentions', '/opt/atlassian/pipelines/agent/build/client/app/components/Detentions/Detentions.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Detentions/Detentions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_VesselAutoComplete__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Vessels_Single_Rows_Detentions__ = __webpack_require__(3473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Vessels_Single_Rows_Sanctions__ = __webpack_require__(3474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__ = __webpack_require__(41);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













function DetentionsContent(_ref) {
    var _this = this;

    var addNotification = _ref.addNotification;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        vessel = _useState2[0],
        setVessel = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isLoading = _useState4[0],
        setIsLoading = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(null),
        _useState6 = _slicedToArray(_useState5, 2),
        complianceId = _useState6[0],
        setComplianceId = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(getDefaultDetentionsSanctions().detentions),
        _useState8 = _slicedToArray(_useState7, 2),
        detentions = _useState8[0],
        setDetentions = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(getDefaultDetentionsSanctions().sanctions),
        _useState10 = _slicedToArray(_useState9, 2),
        sanctions = _useState10[0],
        setSanctions = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
        _useState12 = _slicedToArray(_useState11, 2),
        clearDetentions = _useState12[0],
        setClearDetentions = _useState12[1];

    var getSanctions = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(imo) {
            var vesselSanctions, _vesselSanctions$data, detentionsFromDB, sanctionsFromDB, _id, _getDefaultDetentions, defaultDetentions, defaultSanctions;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].getVesselSanctions(imo);

                        case 2:
                            vesselSanctions = _context.sent;


                            if (vesselSanctions.data) {
                                _vesselSanctions$data = vesselSanctions.data, detentionsFromDB = _vesselSanctions$data.detentions, sanctionsFromDB = _vesselSanctions$data.sanctions, _id = _vesselSanctions$data._id;
                                _getDefaultDetentions = getDefaultDetentionsSanctions(), defaultDetentions = _getDefaultDetentions.detentions, defaultSanctions = _getDefaultDetentions.sanctions;


                                setDetentions(detentionsFromDB.length ? detentionsFromDB : defaultDetentions);

                                sanctionsFromDB.forEach(function (s) {
                                    s.programs = s.program;
                                });

                                if (sanctionsFromDB.length === 1) {
                                    sanctionsFromDB.push(defaultSanctions[1]);
                                    setSanctions(sanctionsFromDB);
                                } else if (sanctionsFromDB.length === 2) {
                                    setSanctions(sanctionsFromDB);
                                } else {
                                    setSanctions(defaultSanctions);
                                }
                                setComplianceId(_id);
                                setIsLoading(false);
                            }

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function getSanctions(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    var selectVessel = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(selectedVessel) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            setVessel(selectedVessel);
                            setIsLoading(true);

                            _context2.next = 4;
                            return getSanctions(selectedVessel.imoNumber);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function selectVessel(_x2) {
            return _ref3.apply(this, arguments);
        };
    }();

    var changeField = function changeField(changes) {
        var _sanctions = { sanctions: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(sanctions) };
        var _detentions = { detentions: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(detentions) };

        changes.forEach(function (change) {
            if (change.field.includes('sanctions')) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(_sanctions, change.field, change.value);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.set(_detentions, change.field, change.value);
            }
        });
        setSanctions(_sanctions.sanctions);
        setDetentions(_detentions.detentions);
    };

    var updateCompliance = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type) {
            var _sanctions, _detentions, sanctionsLength;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _sanctions = void 0;
                            _detentions = void 0;

                            if (!(type === 'detentions')) {
                                _context3.next = 10;
                                break;
                            }

                            if (detentions.length === 1) {
                                if (!detentions[0]._id && !detentions[0].port._id && !detentions[0].detained && !detentions[0].released && !detentions[0].deficienciesNature.length && !detentions[0].deficienciesNumber) {
                                    _detentions = [];
                                }
                            }

                            if (!(!_detentions && detentions.find(function (d) {
                                return d.port && !d.detained || !d.port && d.detained;
                            }))) {
                                _context3.next = 7;
                                break;
                            }

                            addNotification({
                                title: 'Error',
                                message: 'Port and detained date are required for detentions',
                                level: 'error',
                                _id: new Date().getMilliseconds(),
                                autoDismiss: 3
                            });
                            return _context3.abrupt('return');

                        case 7:

                            detentions.forEach(function (item) {
                                if (item.port && item.port.name) {
                                    item.externalPortName = item.port.name;
                                    item.portId = item.port._id;
                                }
                                item.deficiencies = {
                                    list: item.deficienciesNature,
                                    knownNumber: parseInt(item.deficienciesNumber)
                                };
                            });
                            _context3.next = 15;
                            break;

                        case 10:
                            if (!sanctions.find(function (s) {
                                return s.remarks && !(s.programs.filter(Boolean).length && s.list);
                            })) {
                                _context3.next = 13;
                                break;
                            }

                            addNotification({
                                title: 'Error',
                                message: 'List and Program are required if remarks are set',
                                level: 'error',
                                _id: new Date().getMilliseconds(),
                                autoDismiss: 3
                            });
                            return _context3.abrupt('return');

                        case 13:
                            sanctionsLength = sanctions.filter(function (s) {
                                return s.list || s.programs.filter(Boolean).length;
                            }).length;


                            if (sanctionsLength === 0) {
                                _sanctions = [];
                            } else if (!sanctions[1].list && !sanctions[1].programs.filter(Boolean).length && !sanctions[1].remarks) {
                                _sanctions = [sanctions[0]];
                            }

                        case 15:

                            __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].updateVesselCompliance(vessel.imoNumber, complianceId, type, type === 'ofac' ? _sanctions || sanctions : _detentions || detentions).then(function (response) {
                                if (response.status && response.status !== 200) {
                                    showErrorNotification(response.errors);
                                } else {
                                    showSuccessNotification(response.data.message);
                                }
                            });

                        case 16:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this);
        }));

        return function updateCompliance(_x3) {
            return _ref4.apply(this, arguments);
        };
    }();

    var showSuccessNotification = function showSuccessNotification(message) {
        addNotification({
            title: 'Success',
            message: message,
            level: 'success',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3
        });
    };

    var showErrorNotification = function showErrorNotification(errors) {
        addNotification({
            title: 'Error',
            message: Object.values(errors)[0].message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3
        });
    };

    var clear = function clear(type) {
        var _getDefaultDetentions2 = getDefaultDetentionsSanctions(),
            defaultDetentions = _getDefaultDetentions2.detentions,
            defaultSanctions = _getDefaultDetentions2.sanctions;

        if (type === 'ofac') {
            setSanctions(defaultSanctions);
        } else {
            setClearDetentions(true);
            setTimeout(function () {
                setDetentions(defaultDetentions);
                setTimeout(function () {
                    setClearDetentions(false);
                }, 0);
            }, 0);
        }
    };

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'table-header' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                {
                    className: 'item',
                    style: { display: 'flex' }
                },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'div',
                    {
                        style: { width: '30%' }
                    },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components_common_VesselAutoComplete__["a" /* default */], {
                        selectValue: selectVessel
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'div',
                    { style: { margin: 'auto 50px', fontSize: '14px' } },
                    vessel && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'span',
                        null,
                        vessel.name,
                        ' (',
                        vessel.imoNumber,
                        ')'
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'table-body' },
            isLoading ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["d" /* CircularProgress */], {
                className: !isLoading ? '' : 'hidden',
                style: __WEBPACK_IMPORTED_MODULE_7_styles__["a" /* default */].circularProgress
            }) : vessel && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'span',
                        { style: { display: 'block', margin: '20px 0 0 0' } },
                        'Sanctions'
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Vessels_Single_Rows_Sanctions__["a" /* default */], {
                        changeFieldsMultiple: changeField,
                        sanctions: sanctions
                    }),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', justifyContent: 'flex-end' } },
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                            style: { marginTop: '30px', marginRight: '30px' },
                            label: 'Clear',
                            secondary: true,
                            onClick: function onClick() {
                                return clear('ofac');
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                            style: { marginTop: '30px', float: 'right' },
                            label: 'Save',
                            primary: true,
                            onClick: function onClick() {
                                return updateCompliance('ofac');
                            }
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'span',
                        { style: { display: 'block', margin: '20px 0 0 0' } },
                        'Detentions'
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Vessels_Single_Rows_Detentions__["a" /* default */], {
                        detentions: detentions,
                        changeField: changeField,
                        clearDetentions: clearDetentions
                    }),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', justifyContent: 'flex-end' } },
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                            style: { marginTop: '30px', marginRight: '30px' },
                            label: 'Clear',
                            secondary: true,
                            onClick: function onClick() {
                                return clear('detentions');
                            }
                        }),
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                            style: { marginTop: '30px', float: 'right' },
                            label: 'Save',
                            primary: true,
                            onClick: function onClick() {
                                return updateCompliance('detentions');
                            }
                        })
                    )
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_10_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(DetentionsContent);

/* harmony default export */ __webpack_exports__["a"] = (_default);

function getDefaultDetentionsSanctions() {
    return {
        sanctions: [{
            _id: '',
            list: '',
            programs: [],
            program: [],
            remarks: ''
        }, {
            _id: '',
            list: '',
            programs: [],
            program: [],
            remarks: ''
        }],
        detentions: [{
            _id: '',
            detained: null,
            released: null,
            port: {
                _id: '',
                name: '',
                country: {
                    _id: '',
                    name: ''
                }
            },
            deficienciesNumber: null,
            deficienciesNature: []
        }]
    };
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DetentionsContent, 'DetentionsContent', '/opt/atlassian/pipelines/agent/build/client/app/components/Detentions/DetentionsContent.jsx');
    reactHotLoader.register(getDefaultDetentionsSanctions, 'getDefaultDetentionsSanctions', '/opt/atlassian/pipelines/agent/build/client/app/components/Detentions/DetentionsContent.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Detentions/DetentionsContent.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











function getDefaultDetention() {
    return {
        _id: '',
        detained: null,
        released: null,
        port: {
            _id: '',
            name: '',
            country: {
                _id: '',
                name: ''
            }
        },
        deficienciesNumber: null,
        deficienciesNature: []
    };
}

function Detentions(_ref) {
    var detentions = _ref.detentions,
        changeField = _ref.changeField,
        clearDetentions = _ref.clearDetentions;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        openNatureDialog = _useState2[0],
        setOpenNatureDialog = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),
        _useState4 = _slicedToArray(_useState3, 2),
        currentDetentionDialogRow = _useState4[0],
        setCurrentDetentionDialogRow = _useState4[1];

    var selectPort = function selectPort(port, index) {
        changeField([{
            field: 'detentions[' + index + '].port',
            value: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(port, ['_id', 'name'])
        }, {
            field: 'detentions[' + index + '].port.country',
            value: port.country
        }]);
    };

    var setSelectedDate = function setSelectedDate(date, type, index) {
        changeField([{
            field: 'detentions[' + index + '].' + type,
            value: date
        }]);
    };

    var removeDetention = function removeDetention(index) {
        var _detentions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(detentions);

        _detentions.splice(index, 1);

        changeField([{
            field: 'detentions',
            value: _detentions
        }]);
    };

    var addDetention = function addDetention() {
        var _detentions = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(detentions);

        _detentions.push(getDefaultDetention());

        changeField([{
            field: 'detentions',
            value: _detentions
        }]);
    };

    var handleOpenNatureDialog = function handleOpenNatureDialog() {
        var rowIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var cellIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        if ((cellIndex || cellIndex === 0) && cellIndex !== 5) {
            return;
        }

        setOpenNatureDialog(!openNatureDialog);
        setCurrentDetentionDialogRow(rowIndex);
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["u" /* Table */],
            {
                selectable: false,
                onCellClick: function onCellClick(rowIndex, cellIndex) {
                    return handleOpenNatureDialog(rowIndex, cellIndex);
                }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_material_ui__["w" /* TableHeader */],
                {
                    adjustForCheckbox: false,
                    displaySelectAll: false
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_material_ui__["y" /* TableRow */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '15.5%', textAlign: 'center' } },
                        'Port'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '15.5%', textAlign: 'center' } },
                        'Country'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '9.5%', textAlign: 'center', padding: 0 } },
                        'Detained'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '9.5%', textAlign: 'center', padding: 0 } },
                        'Released'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                        {
                            style: { width: '12%', whiteSpace: 'break-spaces', textAlign: 'center' }
                        },
                        'Number of Deficiences'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '34%', textAlign: 'center' } },
                        'Nature of Deficiences'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["x" /* TableHeaderColumn */], { style: { textAlign: 'center' } })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_material_ui__["v" /* TableBody */],
                { displayRowCheckbox: false },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NatureDialog, {
                    changeField: changeField,
                    detention: detentions[currentDetentionDialogRow - 1],
                    detentions: detentions,
                    detentionIndex: currentDetentionDialogRow - 1,
                    handleOpenNatureDialog: handleOpenNatureDialog,
                    openNatureDialog: openNatureDialog
                }),
                detentions && detentions.map(function (detention, index) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["y" /* TableRow */],
                        {
                            displayBorder: true,
                            key: 'detention_' + index
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
                            { style: { border: '1px solid #dfdfdf', width: '15.5%', padding: '0 5px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PortsAutoComplete, {
                                index: index,
                                key: 'detention_port_' + index,
                                port: detention.port,
                                selectPort: selectPort,
                                clearDetentions: clearDetentions
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
                            { style: { border: '1px solid #dfdfdf', width: '15.5%', padding: '0 5px' } },
                            detention.port.country && detention.port.country.name
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
                            { style: { border: '1px solid #dfdfdf', width: '9.5%', padding: '0 5px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DatesSelector, {
                                type: 'detained',
                                value: detention.detained,
                                index: index,
                                setSelectedDate: setSelectedDate,
                                minDate: undefined,
                                maxDate: detention.released && new Date(detention.released)
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
                            { style: { border: '1px solid #dfdfdf', width: '9.5%', padding: '0 5px' } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DatesSelector, {
                                type: 'released',
                                value: detention.released,
                                index: index,
                                setSelectedDate: setSelectedDate,
                                minDate: detention.detained && new Date(detention.detained),
                                maxDate: undefined
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
                            { style: { border: '1px solid #dfdfdf', width: '12%', padding: '0 5px', textAlign: 'center' } },
                            generateTextFields({
                                value: detention.deficienciesNumber,
                                field: 'detentions[' + index + '].deficienciesNumber',
                                changeField: changeField,
                                type: 'number',
                                style: { width: '35%' }
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
                            {
                                style: { width: '34%', border: '1px solid #dfdfdf', padding: '0 5px', cursor: 'pointer' }
                            },
                            detention.deficienciesNature && detention.deficienciesNature.map(function (def, defIndex) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { key: 'deficiences_' + defIndex },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                        'span',
                                        { style: { fontSize: '13px', whiteSpace: 'break-spaces' } },
                                        defIndex + 1 + ' - ' + def
                                    ),
                                    ' ',
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null)
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_material_ui__["z" /* TableRowColumn */],
                            { style: { border: '1px solid #dfdfdf', padding: 0, textAlign: 'center' } },
                            index === detentions.length - 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                                {
                                    style: { padding: 0, width: '35px' }
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline___default.a, {
                                    onClick: addDetention,
                                    color: 'green'
                                })
                            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                                {
                                    style: { padding: 0, width: '35px' }
                                },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                                    onClick: function onClick() {
                                        removeDetention(index);
                                    },
                                    color: 'red'
                                })
                            )
                        )
                    );
                })
            )
        )
    );
}

var _default = Detentions;
/* harmony default export */ __webpack_exports__["a"] = (_default);

function generateTextFields(_ref2) {
    var value = _ref2.value,
        field = _ref2.field,
        changeField = _ref2.changeField,
        _ref2$type = _ref2.type,
        type = _ref2$type === undefined ? 'string' : _ref2$type,
        _ref2$style = _ref2.style,
        style = _ref2$style === undefined ? {} : _ref2$style;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
        name: field,
        value: value || '',
        onChange: function onChange(e) {
            changeField([{
                field: field,
                value: e.target.value
            }]);
        },
        type: type,
        style: _extends({ width: '100%', fontSize: '13px' }, style),
        underlineStyle: { display: 'none' }
    });
}

function PortsAutoComplete(_ref3) {
    var index = _ref3.index,
        port = _ref3.port,
        selectPort = _ref3.selectPort,
        clearDetentions = _ref3.clearDetentions;

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        ports = _useState6[0],
        setPorts = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),
        _useState8 = _slicedToArray(_useState7, 2),
        searchText = _useState8[0],
        setSearchText = _useState8[1];

    var debouncedSearch = Object(__WEBPACK_IMPORTED_MODULE_3_helpers_useDebounce__["a" /* default */])(searchText, 500);

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (debouncedSearch && debouncedSearch.length > 1) {
            __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].findPortAdmin({ name: debouncedSearch }).then(function (results) {
                var _ports = results.data.data.map(function (p) {
                    return _extends({}, p, {
                        name: p.name + ' (' + p.country.name + ')'
                    });
                });
                setPorts(_ports);
            }).catch(function (e) {
                return console.error(e);
            });
        } else {
            setPorts([]);
        }
    }, [debouncedSearch]);

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (clearDetentions) {
            setSearchText('');
        }
    }, [clearDetentions]);

    var changeAutoComplete = function changeAutoComplete(_searchText) {
        setSearchText(_searchText);
    };

    var chooseAutoComplete = function chooseAutoComplete(_port) {
        _port.name = _port.name.split(' (')[0];
        setSearchText('');
        selectPort(_port, index);
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a, {
        searchText: searchText || port && port.name,
        textFieldStyle: { fontSize: '13px' },
        name: 'portAutocomplete.' + index,
        dataSource: ports,
        value: port && port._id,
        dataSourceConfig: { text: 'name', value: 'item' },
        onUpdateInput: changeAutoComplete,
        onNewRequest: chooseAutoComplete,
        filter: __WEBPACK_IMPORTED_MODULE_2_material_ui_AutoComplete___default.a.noFilter,
        listStyle: { overflow: 'auto', maxHeight: '300px', width: 'auto' },
        menuStyle: { width: 'auto' },
        underlineStyle: { display: 'none' },
        popoverProps: {
            canAutoPosition: true
        }
    });
}

function DatesSelector(_ref4) {
    var type = _ref4.type,
        value = _ref4.value,
        index = _ref4.index,
        maxDate = _ref4.maxDate,
        minDate = _ref4.minDate,
        setSelectedDate = _ref4.setSelectedDate;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["e" /* DatePicker */], {
        autoOk: true,
        maxDate: maxDate,
        minDate: minDate,
        value: value && new Date(value),
        id: 'uniqueid_' + index,
        onChange: function onChange(e, date) {
            setSelectedDate(__WEBPACK_IMPORTED_MODULE_6_moment___default()(date).utcOffset(0, true).format(), type, index);
        },
        underlineStyle: { display: 'none' },
        inputStyle: { fontSize: '13px' },
        textFieldStyle: { cursor: 'pointer' },
        formatDate: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('DD-MM-YYYY');
        }
    });
}

var NatureDialog = function NatureDialog(_ref5) {
    var detentionIndex = _ref5.detentionIndex,
        detention = _ref5.detention,
        detentions = _ref5.detentions,
        changeField = _ref5.changeField,
        handleOpenNatureDialog = _ref5.handleOpenNatureDialog,
        openNatureDialog = _ref5.openNatureDialog;

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(detention)),
        _useState10 = _slicedToArray(_useState9, 2),
        _detention = _useState10[0],
        set_detention = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(detentions)),
        _useState12 = _slicedToArray(_useState11, 2),
        _detentions = _useState12[0],
        set_detentions = _useState12[1];

    var forceUpdate = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState()[1].bind(null, {});

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        set_detentions(detentions);
        set_detention(detention);

        return function () {
            set_detention(detention);
        };
    }, [detention, detentions]);

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (_detention && _detention.deficienciesNature.length === 0) {
            set_detention(_extends({}, detention, {
                deficienciesNature: ['']
            }));
        }
    }, [_detention]);

    function applyDetentionChanges() {
        var _detentionsCopy = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_detentions);

        _detentionsCopy[detentionIndex].deficienciesNature = _detention.deficienciesNature.filter(function (d) {
            return d;
        });

        changeField([{
            field: 'detentions',
            value: _detentionsCopy
        }]);

        handleOpenNatureDialog();
    }

    function removeNatureOfDeficiency(natureIndex) {
        var _detentionCopy = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_detention);
        _detentionCopy.deficienciesNature.splice(natureIndex, 1);

        set_detention(_detentionCopy);
        forceUpdate();
    }

    function addNatureOfDeficiency() {
        set_detention(_extends({}, _detention, {
            deficienciesNature: [].concat(_toConsumableArray(_detention.deficienciesNature), [''])
        }));
    }

    function handleClose() {
        set_detention(detention);
        handleOpenNatureDialog();
    }

    var handleChangeDeficiency = function handleChangeDeficiency(defIndex, value) {
        var _detentionCopy = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_detention);
        _detentionCopy.deficienciesNature[defIndex] = value;

        set_detention(_detentionCopy);
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["g" /* FlatButton */], {
        label: 'Submit',
        primary: true,
        onClick: applyDetentionChanges
    }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["g" /* FlatButton */], {
        label: 'Close',
        primary: true,
        onClick: handleClose
    })];

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["f" /* Dialog */],
        {
            open: openNatureDialog,
            actions: actions,
            onRequestClose: handleClose
        },
        _detention && _detention.deficienciesNature && _detention.deficienciesNature.map(function (def, defIndex) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                {
                    key: 'deficiences_' + defIndex,
                    style: { display: 'flex', textAlign: 'center' }
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["A" /* TextField */], {
                    style: { fontSize: '13px', width: '90%' },
                    hintText: 'Nature of deficiences',
                    value: def || '',
                    name: 'deficiency',
                    onChange: function onChange(e) {
                        return handleChangeDeficiency(defIndex, e.target.value);
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { width: '10%' } },
                    defIndex === 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                        {
                            style: { padding: 0 }
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_content_add_circle_outline___default.a, {
                            onClick: addNatureOfDeficiency,
                            color: 'green'
                        })
                    ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_material_ui__["h" /* IconButton */],
                        {
                            style: { padding: 0 }
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_svg_icons_content_remove_circle_outline___default.a, {
                            onClick: function onClick() {
                                removeNatureOfDeficiency(defIndex);
                            },
                            color: 'red'
                        })
                    )
                )
            );
        })
    );
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getDefaultDetention, 'getDefaultDetention', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Detentions.jsx');
    reactHotLoader.register(Detentions, 'Detentions', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Detentions.jsx');
    reactHotLoader.register(generateTextFields, 'generateTextFields', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Detentions.jsx');
    reactHotLoader.register(PortsAutoComplete, 'PortsAutoComplete', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Detentions.jsx');
    reactHotLoader.register(DatesSelector, 'DatesSelector', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Detentions.jsx');
    reactHotLoader.register(NatureDialog, 'NatureDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Detentions.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Detentions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Sanctions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_sancitons__ = __webpack_require__(3475);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function Sanctions(_ref) {
    var sanctions = _ref.sanctions,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
            {
                selectable: false
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui__["w" /* TableHeader */],
                {
                    adjustForCheckbox: false,
                    displaySelectAll: false
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '18.5%' } },
                        null
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '16.5%' } },
                        'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '16.5%' } },
                        'List'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                        { style: { width: '16.5%' } },
                        'Program'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                        null,
                        'Remarks'
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
                {
                    displayRowCheckbox: false
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                    {
                        displayBorder: true
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: { border: '1px solid #dfdfdf', width: '18.5%', padding: 10 } },
                        'Sanctions'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: { border: '1px solid #dfdfdf', padding: 0, width: '16.5%' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
                            { allRowsSelected: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
                                { displayRowCheckbox: false },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                        { style: { padding: '0 5px' } },
                                        'OFAC'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                        { style: { padding: '0 5px' } },
                                        'Other Sanctions'
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: { border: '1px solid #dfdfdf', padding: 0, width: '16.5%' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
                            { allRowsSelected: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
                                { displayRowCheckbox: false },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                        { style: { padding: '0 5px' } },
                                        sanctions[0] && generateSelectors({
                                            value: sanctions[0].list,
                                            sanctionsList: __WEBPACK_IMPORTED_MODULE_2_constants_sancitons__["a" /* sanctionsLists */],
                                            field: 'sanctions[0].list',
                                            multiple: false,
                                            changeField: changeFieldsMultiple,
                                            checked: false
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                        { style: { padding: '0 5px' } },
                                        sanctions[1] && generateTextFields({
                                            value: sanctions[1].list,
                                            field: 'sanctions[1].list',
                                            changeField: changeFieldsMultiple
                                        })
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: { border: '1px solid #dfdfdf', padding: 0, width: '16.5%' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
                            { allRowsSelected: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
                                { displayRowCheckbox: false },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                        { style: { padding: '0 5px' } },
                                        sanctions[0] && generateSelectors({
                                            value: sanctions[0].programs || sanctions[0].program,
                                            sanctionsList: __WEBPACK_IMPORTED_MODULE_2_constants_sancitons__["b" /* sanctionsPrograms */],
                                            field: 'sanctions[0].programs',
                                            multiple: true,
                                            changeField: changeFieldsMultiple,
                                            checked: true
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                                        { style: { padding: '0 5px' } },
                                        sanctions[1] && generateTextFields({
                                            value: sanctions[1].programs || sanctions[1].program,
                                            field: 'sanctions[1].programs',
                                            changeField: changeFieldsMultiple,
                                            asArray: true
                                        })
                                    )
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["z" /* TableRowColumn */],
                        { style: { border: '1px solid #dfdfdf', padding: 0 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1_material_ui__["u" /* Table */],
                            { allRowsSelected: false },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_material_ui__["v" /* TableBody */],
                                { displayRowCheckbox: false },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                        { style: { padding: '0 5px' } },
                                        sanctions[0] && generateTextFields({
                                            value: sanctions[0].remarks,
                                            field: 'sanctions[0].remarks',
                                            changeField: changeFieldsMultiple
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_material_ui__["y" /* TableRow */],
                                    { selectable: false, displayBorder: true },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1_material_ui__["x" /* TableHeaderColumn */],
                                        { style: { padding: '0 5px' } },
                                        sanctions[1] && generateTextFields({
                                            value: sanctions[1].remarks,
                                            field: 'sanctions[1].remarks',
                                            changeField: changeFieldsMultiple
                                        })
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
}

function generateSelectors(_ref2) {
    var value = _ref2.value,
        sanctionsList = _ref2.sanctionsList,
        field = _ref2.field,
        multiple = _ref2.multiple,
        changeField = _ref2.changeField,
        checked = _ref2.checked;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
        {
            multiple: multiple,
            autoWidth: true,
            value: value || [],
            style: { width: '100%', fontSize: '13px' },
            iconStyle: { display: 'none' },
            underlineStyle: { display: 'none' },
            labelStyle: { height: '45px', padding: 0 },
            onChange: function onChange(_e, _i, _value) {
                var toChange = [{
                    field: field,
                    value: _value
                }];
                if (field === 'program') {
                    toChange.push({
                        field: 'programs',
                        value: _value
                    });
                }
                changeField(toChange);
            }
        },
        sanctionsList.map(function (program) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], {
                key: program,
                checked: checked && value && value.includes(program),
                value: program,
                primaryText: program
            });
        })
    );
}

function generateTextFields(_ref3) {
    var value = _ref3.value,
        field = _ref3.field,
        changeField = _ref3.changeField,
        _ref3$asArray = _ref3.asArray,
        asArray = _ref3$asArray === undefined ? false : _ref3$asArray;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
        name: field,
        value: value,
        onChange: function onChange(e) {
            var toChange = [{
                field: field,
                value: asArray ? [e.target.value] : e.target.value
            }];

            if (field.includes('programs')) {
                toChange.push({
                    field: field.split('.')[0] + '.program',
                    value: [e.target.value]
                });
            }

            changeField(toChange);
        },
        style: { width: '100%', fontSize: '13px' },
        underlineStyle: { display: 'none' }
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Sanctions, 'Sanctions', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Sanctions.jsx');
    reactHotLoader.register(generateSelectors, 'generateSelectors', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Sanctions.jsx');
    reactHotLoader.register(generateTextFields, 'generateTextFields', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Single/Rows/Sanctions.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sanctionsPrograms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sanctionsLists; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var sanctionsPrograms = ['561-Related', 'BALKANS', 'BELARUS', 'BELARUS-EO14038', 'BURMA-EO14014', 'BURUNDI', 'CAATSA - IRAN', 'CAATSA - RUSSIA', 'CAR', 'CMIC-EO13959', 'CUBA', 'CYBER2', 'DARFUR', 'DPRK', 'DPRK2', 'DPRK3', 'DPRK4', 'DPRK-NKSPEA', 'DRCONGO', 'ELECTION-EO13848', 'FSE-IR', 'FSE-SY', 'FTO', 'GLOMAG', 'HIFPAA', 'HK-EO13936', 'HRIT-IR', 'HRIT-SY', 'IFCA', 'IFSR', 'IRAN', 'IRAN-CON-ARMS-EO', 'IRAN-EO13846', 'IRAN-EO13871', 'IRAN-EO13876', 'IRAN-EO13902', 'IRAN-HR', 'IRAN-TRA', 'IRAQ2', 'IRAQ3', 'IRGC', 'ISA', 'LEBANON', 'LIBYA2', 'LIBYA3', 'MAGNIT', 'MALI-EO13882', 'NICARAGUA', 'NICARAGUA-NHRAA', 'NPWMD', 'NS-PLC', 'PEESA', 'PEESA-EO', 'RUSSIA-EO14024', 'SDGT', 'SDNT', 'SDNTK', 'SOMALIA', 'SOUTH SUDAN', 'SYRIA', 'SYRIA-CAESAR', 'SYRIA-EO13894', 'TCO', 'UKRAINE-EO13660', 'UKRAINE-EO13661', 'UKRAINE-EO13662', 'UKRAINE-EO13685', 'VENEZUELA', 'VENEZUELA-EO13850', 'VENEZUELA-EO13884', 'YEMEN', 'ZIMBABWE'];

var sanctionsLists = ['', 'Non-SDN', 'SDN'];
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(sanctionsPrograms, 'sanctionsPrograms', '/opt/atlassian/pipelines/agent/build/client/app/constants/sancitons.js');
    reactHotLoader.register(sanctionsLists, 'sanctionsLists', '/opt/atlassian/pipelines/agent/build/client/app/constants/sancitons.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Letters_Single_Train_ErrorBoundary__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Filters__ = __webpack_require__(3477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Collapses__ = __webpack_require__(3484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Size__ = __webpack_require__(3485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Composition__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Libs_Pagination__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














var rowsPerPage = [50, 100];

var urlParams = new URLSearchParams(window.location.search);
var defaultFilters = {
    /**@returns {FiltersState} */
    get: function get() {
        return {
            vessel: urlParams.has('_id') ? {
                _id: urlParams.get('_id'),
                name: urlParams.get('name')
            } : {},
            emailId: urlParams.get('emailId') || '',
            approved: null,
            params: []
        };
    }
};

var PageContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(1);

function VesselsCompositionMain(_ref) {
    var addNotification = _ref.addNotification;

    /**
     * @namespace {Object}
     * @property {FiltersState} 
     * @property {FiltersStateSetter} 
     */
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultFilters.get),
        _useState2 = _slicedToArray(_useState, 2),
        filters = _useState2[0],
        setFilters = _useState2[1];

    /**  @type {[ LeftSide, LeftSideSetter ]} LeftSide */


    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('vesselsList'),
        _useState4 = _slicedToArray(_useState3, 2),
        leftSide = _useState4[0],
        setLeftSide = _useState4[1];

    /** @type {[ RightSide, RightSideSetter ]} RightSide */


    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState6 = _slicedToArray(_useState5, 2),
        rightSide = _useState6[0],
        setRightSide = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState8 = _slicedToArray(_useState7, 2),
        sizes = _useState8[0],
        setSizes = _useState8[1];

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState10 = _slicedToArray(_useState9, 2),
        modifySizes = _useState10[0],
        setModifySizes = _useState10[1];

    var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState12 = _slicedToArray(_useState11, 2),
        forMultiTransfer = _useState12[0],
        setForMultiTransfer = _useState12[1];

    var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState14 = _slicedToArray(_useState13, 2),
        loading = _useState14[0],
        setLoading = _useState14[1];

    var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState16 = _slicedToArray(_useState15, 2),
        initialLoaded = _useState16[0],
        setInitialLoaded = _useState16[1];

    var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),
        _useState18 = _slicedToArray(_useState17, 2),
        page = _useState18[0],
        setPage = _useState18[1];

    var _useState19 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState20 = _slicedToArray(_useState19, 2),
        sizesCounters = _useState20[0],
        setSizesCounters = _useState20[1];

    var _useState21 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
        _useState22 = _slicedToArray(_useState21, 2),
        totalPages = _useState22[0],
        setTotalPages = _useState22[1];

    var _useState23 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(50),
        _useState24 = _slicedToArray(_useState23, 2),
        numberOfRows = _useState24[0],
        setNumberOfRows = _useState24[1];

    function getCounters() {
        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].getVesselsCompositions(_extends({}, filters, { page: page, limit: numberOfRows })).then(function (response) {
            if (response.errors && response.errors.length) {
                addNotification({
                    title: 'Error',
                    message: response.errors[0].messages,
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3
                });
            }
            if (response.data) {
                var data = response.data;

                if (initialLoaded) {
                    setSizesCounters(data.sizes);
                } else {
                    setInitialLoaded(true);
                    setSizesCounters(data.sizes);
                }
                setTotalPages(data.total);
            }
        });
    }

    var selectVessel = function selectVessel(vessel) {
        setLeftSide('vessel');
        // setPage(1);
        setInitialLoaded(false);
        setFilters(function (f) {
            return _extends({}, f, { vessel: __WEBPACK_IMPORTED_MODULE_3_lodash__["pick"](vessel, ['_id', 'name']) });
        });
    };

    var addToMultiTransfer = function addToMultiTransfer(obj) {
        setForMultiTransfer(function (s) {
            return [].concat(_toConsumableArray(s), [obj]);
        });
    };

    function getSizes() {
        var _this = this;

        setForMultiTransfer([]);
        setLoading(true);

        if (leftSide === 'vessel') {
            if (!filters.vessel._id && !filters.emailId || !filters.vessel._id) {
                setLeftSide('vesselsList');
                getCounters();
                return;
            }
        } else {
            setLeftSide('vesselsList');
            if (page === 1) {
                getCounters();
                return;
            }
        }

        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].getEmailsForVesselComposition(_extends({}, filters, { page: page })).then(function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (response.errors && response.errors.length) {
                                    addNotification({
                                        title: 'Error',
                                        message: response.errors[0].messages,
                                        level: 'error',
                                        _id: new Date().getMilliseconds(),
                                        autoDismiss: 3
                                    });
                                }
                                if (response.data) {
                                    setSizes(response.data);
                                }
                                _context.next = 4;
                                return setTimeout(function () {
                                    setRightSide('vessel');
                                    setLoading(false);
                                }, 50);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }());
    }

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setRightSide(null);
        setSizes(null);
        getSizes();
    }, [filters]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (initialLoaded) {
            getCounters();
        }
    }, [page]);

    var reloadSizes = function reloadSizes() {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        // crazy, isn't it?
        setFilters(function (f) {
            return _extends({}, f, { vessel: Object.assign({}, filters.vessel) });
        });
    };

    /**
     * @param {string | null} emailId 
     */
    var setEmailIdFilter = function setEmailIdFilter(emailId) {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        setFilters(function (f) {
            return _extends({}, f, { emailId: emailId });
        });
    };

    var setApprovedFilter = function setApprovedFilter(approved) {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        setFilters(function (f) {
            return _extends({}, f, { approved: approved });
        });
    };

    var clearVesselFilter = function clearVesselFilter() {
        if (!filters.vessel._id) {
            return;
        }
        selectVessel({});
    };

    var setParamsFilter = function setParamsFilter(params) {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        setFilters(function (f) {
            return _extends({}, f, { params: params });
        });
    };

    var handleUpdateRow = function handleUpdateRow(_ref3) {
        var p = _ref3.page,
            n = _ref3.numberOfRows;

        setPage(p);
        setNumberOfRows(n);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'single-letter' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'content', style: { width: '53vw', height: 'calc(100vh - 65px)', overflowY: 'auto' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'management' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Filters__["a" /* default */], {
                    selectVessel: selectVessel,
                    filters: filters,
                    setModifySizes: setModifySizes,
                    forMultiTransfer: forMultiTransfer,
                    reloadSizes: reloadSizes,
                    setEmailIdFilter: setEmailIdFilter,
                    clearVesselFilter: clearVesselFilter,
                    setApprovedFilter: setApprovedFilter,
                    setParamsFilter: setParamsFilter
                })
            ),
            !loading && !sizes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'sizes__empty' },
                'Sizes not found!'
            ),
            leftSide === 'vesselsList' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Composition__["a" /* default */], {
                    filters: filters,
                    selectSize: selectVessel,
                    sizesCounters: sizesCounters
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    PageContext.Provider,
                    { value: page },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Paginator, {
                        totalPages: totalPages
                        // page={page}
                        , numberOfRows: numberOfRows,
                        handleUpdateRow: handleUpdateRow
                    })
                )
            ) : sizes && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_components_Letters_Single_Train_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Collapses__["a" /* default */], {
                    sizes: sizes,
                    vessel: filters.vessel,
                    getSizes: getSizes,
                    setModifySizes: setModifySizes,
                    addToMultiTransfer: addToMultiTransfer,
                    shouldGenerateCollapses: leftSide === 'vessel',
                    shouldShowApproveReject: !filters.approved
                })
            ),
            filters.emailId && sizes && sizes.emailData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'filter-column paper-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'name-block absolute small-name' },
                    'Email'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: '13px' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'b',
                        null,
                        'Subject:'
                    ),
                    ' ',
                    sizes.emailData.subject
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { whiteSpace: 'pre-line' } },
                    sizes.emailData.text
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'sidebar', style: { width: '47vw' } },
            rightSide === 'vessel' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_components_Letters_Single_Train_ErrorBoundary__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Size__["a" /* default */], {
                    vesselId: filters.vessel._id,
                    modifySizes: modifySizes
                })
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_9_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(VesselsCompositionMain);

/* harmony default export */ __webpack_exports__["a"] = (_default);

function Paginator(_ref4) {
    var totalPages = _ref4.totalPages,
        numberOfRows = _ref4.numberOfRows,
        handleUpdateRow = _ref4.handleUpdateRow;

    var page = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(PageContext);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Libs_Pagination__["a" /* default */], {
        total: totalPages,
        rowsPerPage: rowsPerPage,
        page: page,
        numberOfRows: numberOfRows,
        updateRows: function updateRows(e) {
            return handleUpdateRow(e);
        }
    });
}

/**
 * @typedef {null | 'vessel' | 'vesselsList'} LeftSide 
 * @typedef {Function} LeftSideSetter
 * 
 * @typedef {null | 'vessel'} RightSide 
 * @typedef {Function} RightSideSetter
 * 
 * @typedef {{ 
 *      vessel: { _id?: string, name?: string },
 *      emailId?: string,
 *      approved: boolean,
 *      params: [string?]
 * }} FiltersState
 * 
 * @callback FiltersStateSetter
 * @param {FiltersState} state
 * @returns {void}
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(rowsPerPage, 'rowsPerPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Main.jsx');
    reactHotLoader.register(urlParams, 'urlParams', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Main.jsx');
    reactHotLoader.register(defaultFilters, 'defaultFilters', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Main.jsx');
    reactHotLoader.register(PageContext, 'PageContext', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Main.jsx');
    reactHotLoader.register(VesselsCompositionMain, 'VesselsCompositionMain', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Main.jsx');
    reactHotLoader.register(Paginator, 'Paginator', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Main.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Main.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Filters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransferAll__ = __webpack_require__(3479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reload__ = __webpack_require__(3480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailIdInput__ = __webpack_require__(3481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_close__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ApprovedRejected__ = __webpack_require__(3482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ParamsFilter__ = __webpack_require__(3483);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











function Filters(_ref) {
    var selectVessel = _ref.selectVessel,
        filters = _ref.filters,
        setModifySizes = _ref.setModifySizes,
        forMultiTransfer = _ref.forMultiTransfer,
        reloadSizes = _ref.reloadSizes,
        setEmailIdFilter = _ref.setEmailIdFilter,
        clearVesselFilter = _ref.clearVesselFilter,
        setApprovedFilter = _ref.setApprovedFilter,
        setParamsFilter = _ref.setParamsFilter;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(filters),
        _useState2 = _slicedToArray(_useState, 2),
        currentFilters = _useState2[0],
        setCurrentFilters = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(forMultiTransfer),
        _useState4 = _slicedToArray(_useState3, 2),
        currentMultiTransfer = _useState4[0],
        setCurrentMultiTransfer = _useState4[1];

    var multiTransfer = function multiTransfer() {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var current = _step.value;

                setTimeout(function () {
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils__["m" /* transfer */])(current, setModifySizes);
                }, 30);
            };

            for (var _iterator = currentMultiTransfer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCurrentMultiTransfer([]);
        setCurrentFilters(filters);
    }, [filters]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCurrentMultiTransfer(forMultiTransfer);
    }, [forMultiTransfer]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'filters' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'filters--vessel' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_svg_icons_navigation_close___default.a, {
                id: 'filters--vessel__remove',
                color: filters.vessel._id ? 'black' : 'grey',
                style: { cursor: currentFilters.vessel._id ? 'pointer' : 'auto' },
                onClick: clearVesselFilter
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__["a" /* default */], {
                id: 'filters--vessel__input',
                selectValue: selectVessel,
                customValue: currentFilters.vessel && currentFilters.vessel.name
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EmailIdInput__["a" /* default */], {
            setEmailIdFilter: setEmailIdFilter,
            currentEmailId: filters.emailId
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ApprovedRejected__["a" /* default */], {
            approved: filters.approved,
            setApprovedFilter: setApprovedFilter
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ParamsFilter__["a" /* default */], {
            setParamsFilter: setParamsFilter,
            paramsFilter: currentFilters.params
        }),
        filters.vessel._id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Reload__["a" /* default */], {
            reloadAction: reloadSizes
        }),
        filters.vessel._id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TransferAll__["a" /* default */], {
            id: 'transfer-all',
            multiTransfer: multiTransfer
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Filters, 'Filters', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Filters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Collapse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function Collapse(_ref) {
    var head = _ref.head,
        body = _ref.body,
        _ref$maxHeight = _ref.maxHeight,
        maxHeight = _ref$maxHeight === undefined ? '0px' : _ref$maxHeight,
        key = _ref.key,
        _ref$controls = _ref.controls,
        controls = _ref$controls === undefined ? null : _ref$controls;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState2 = _slicedToArray(_useState, 2),
        isCollapsed = _useState2[0],
        setIsCollapsed = _useState2[1];

    var collapse = function collapse() {
        setIsCollapsed(!isCollapsed);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'basic-collapse', key: key },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'basic-collapse-head',
                onClick: collapse
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'basic-collapse-head__label' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'b',
                    null,
                    head
                )
            ),
            controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'basic-collapse-head__controls' },
                controls
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
                className: 'basic-collapse-body',
                style: isCollapsed ? { maxHeight: '0px', padding: 0 } : { maxHeight: maxHeight, padding: '10px' }
            },
            body
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Collapse, 'Collapse', '/opt/atlassian/pipelines/agent/build/client/app/components/common/CollapseBasic.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = TransferAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_arrow_forward__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_arrow_forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_arrow_forward__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function TransferAll(_ref) {
    var multiTransfer = _ref.multiTransfer,
        id = _ref.id;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_arrow_forward___default.a, {
            style: { cursor: 'pointer' },
            onClick: multiTransfer
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TransferAll, 'TransferAll', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/TransferAll.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Reload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_cached__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_cached___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_cached__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function Reload(_ref) {
    var reloadAction = _ref.reloadAction;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_cached___default.a, {
        style: {
            transform: 'translate(10px, 10px)',
            cursor: 'pointer'
        },
        onClick: reloadAction
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Reload, 'Reload', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Reload.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = EmailIdInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_done__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_done__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





/**
 * @param {{ 
 *      setEmailIdFilter: Function,
 *      currentEmailId: string,
 * }} SetEmailIdFilter
 */

function EmailIdInput(_ref) {
    var setEmailIdFilter = _ref.setEmailIdFilter,
        currentEmailId = _ref.currentEmailId;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(currentEmailId || ''),
        _useState2 = _slicedToArray(_useState, 2),
        emailId = _useState2[0],
        setEmailId = _useState2[1];

    var applyEmailId = function applyEmailId(id) {
        if (!id) {
            setEmailIdFilter('');
            return;
        }
        setEmailIdFilter(id.trim());
    };

    var modifyEmailId = function modifyEmailId(value) {
        setEmailId(value);
        if (!value) {
            applyEmailId('');
        }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'emailIdInput' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_done___default.a, {
            className: 'emailIdInput--applier',
            style: { cursor: emailId ? 'pointer' : 'auto' },

            onClick: function onClick() {
                return applyEmailId(emailId);
            },
            color: emailId ? 'black' : 'grey'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
            className: 'emailIdInput--input',
            hintText: 'Email id',
            onChange: function onChange(e) {
                return modifyEmailId(e.target.value);
            },
            value: emailId
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(EmailIdInput, 'EmailIdInput', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/EmailIdInput.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = ApprovedRejected;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




/**
 * @param {{ 
 *      setApprovedFilter: Function,
 *      approved: boolean,
 * }} ApprovedRejected
 */
function ApprovedRejected(_ref) {
    var approved = _ref.approved,
        setApprovedFilter = _ref.setApprovedFilter;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
            id: "filters--approved"
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui__["s" /* SelectField */],
            {
                value: approved,
                labelStyle: { fontSize: '13px' },
                floatingLabelStyle: { display: 'none' },
                errorStyle: { display: 'none' },
                onChange: function onChange(_e, _i, v) {
                    return setApprovedFilter(v);
                },
                fullWidth: true
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: null, primaryText: "All" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: true, primaryText: "Approved" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], { value: false, primaryText: "Not Approved" })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ApprovedRejected, "ApprovedRejected", "/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/ApprovedRejected.jsx");
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = ParamsFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function ParamsFilter(_ref) {
    var setParamsFilter = _ref.setParamsFilter,
        paramsFilter = _ref.paramsFilter;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(paramsFilter),
        _useState2 = _slicedToArray(_useState, 2),
        currentParamsFilter = _useState2[0],
        setCurrentParamsFilter = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCurrentParamsFilter(paramsFilter);
    }, [paramsFilter]);

    var handleChange = function handleChange(_e, _i, values) {
        var lastKey = Object.keys(values[values.length - 1])[0];
        var currentKeys = currentParamsFilter.map(function (c) {
            return Object.keys(c)[0];
        });

        if (currentKeys.includes(lastKey)) {
            setParamsFilter(values.filter(function (v) {
                return Object.keys(v)[0] !== lastKey;
            }));
        } else {
            setParamsFilter(values);
        }
    };

    var menuItems = function menuItems() {
        return Object.entries(__WEBPACK_IMPORTED_MODULE_4_lodash__["omit"](__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* sizesMap */], ['grouppedByHatches', 'grouppedByHolds'])).map(function (size) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                key: size[0],
                insetChildren: true,
                checked: currentParamsFilter.some(function (c) {
                    return Object.keys(c)[0] === size[0];
                }),
                value: _defineProperty({}, size[0], __WEBPACK_IMPORTED_MODULE_3__utils__["j" /* sizesFieldsNamesMap */][size[0]]),
                primaryText: size[1],
                style: { fontSize: '13px' }
            });
        });
    };

    var selectionRenderer = function selectionRenderer() {
        switch (currentParamsFilter.length) {
            case 0:
                return '';
            case 1:
                return __WEBPACK_IMPORTED_MODULE_3__utils__["k" /* sizesMap */][Object.keys(currentParamsFilter[0])[0]];
            default:
                return currentParamsFilter.length + ' names selected';
        }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
        {
            multiple: true,
            hintText: 'Select size',
            value: currentParamsFilter,
            onChange: handleChange,
            selectionRenderer: selectionRenderer,
            style: { fontSize: '13px', width: '250px' }
        },
        menuItems()
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ParamsFilter, 'ParamsFilter', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/ParamsFilter.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_notifications_notifications__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(398);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function Collapses(_ref) {
    var sizes = _ref.sizes,
        vessel = _ref.vessel,
        getSizes = _ref.getSizes,
        setModifySizes = _ref.setModifySizes,
        addNotification = _ref.addNotification,
        addToMultiTransfer = _ref.addToMultiTransfer,
        shouldGenerateCollapses = _ref.shouldGenerateCollapses,
        shouldShowApproveReject = _ref.shouldShowApproveReject;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        collapses = _useState2[0],
        setCollapses = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* sizesFieldsNamesMap */]),
        _useState4 = _slicedToArray(_useState3, 2),
        sizesFieldsNames = _useState4[0],
        __ = _useState4[1];

    var transferOne = function transferOne(modification) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["m" /* transfer */])(modification, setModifySizes);
    };

    var accept = function accept(modification) {
        var _transferOne = transferOne(modification),
            groupField = _transferOne.groupField,
            emailIds = _transferOne.emailIds,
            field = _transferOne.field,
            _sizes = _transferOne.sizes,
            type = _transferOne.type;

        var sizeIds = void 0;
        if (groupField) {
            sizeIds = _sizes[type][groupField].map(function (v) {
                return v._id;
            });
        }

        __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].approveVesselSize(vessel._id, emailIds, field, sizeIds).then(function () {
            getSizes();
            addNotification({
                title: 'Success',
                message: 'Value applied and marked as approved',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3
            });
        });
    };

    var reject = function reject(params) {
        var emailIds = params.emailIds,
            type = params.type,
            _sizes = params.sizes,
            field = params.field,
            reason = params.reason;

        var sizeIds = void 0;
        if (field) {
            sizeIds = _sizes[type][field].map(function (v) {
                return v._id;
            });
        }

        __WEBPACK_IMPORTED_MODULE_1_services__["a" /* default */].rejectVesselSize(vessel._id, emailIds, sizesFieldsNames[type], sizeIds, reason).then(function () {
            // TODO: set error notification here
            getSizes();
            addNotification({
                title: 'Success',
                message: 'Value declined and removed',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3
            });
        });
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCollapses([]);
        if (!shouldGenerateCollapses) return;
        setCollapses(generateCollapseList({
            sizes: sizes, techEquipCertificateFieldsNamesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["l" /* techEquipCertificateFieldsNamesMap */], shouldShowApproveReject: shouldShowApproveReject, capacityV2FieldsNamesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["c" /* capacityV2FieldsNamesMap */]
        }));
        return function () {
            setCollapses([]);
        };
    }, [sizes, shouldGenerateCollapses, shouldShowApproveReject]);

    function generateCollapseList(_ref2) {
        var sizes = _ref2.sizes,
            techEquipCertificateFieldsNamesMap = _ref2.techEquipCertificateFieldsNamesMap,
            shouldShowApproveReject = _ref2.shouldShowApproveReject,
            capacityV2FieldsNamesMap = _ref2.capacityV2FieldsNamesMap;

        var collapsesData = [];
        var grouppedByTypeByPurpose = sizes.grouppedByTypeByPurpose,
            grouppedByTypeByConstruction = sizes.grouppedByTypeByConstruction,
            grouppedByTypeBySpecialty = sizes.grouppedByTypeBySpecialty,
            grouppedByTechEquipCertificate = sizes.grouppedByTechEquipCertificate,
            grouppedByDeadWeight = sizes.grouppedByDeadWeight,
            grouppedByRt = sizes.grouppedByRt,
            grouppedByGears = sizes.grouppedByGears,
            grouppedBySpeedConsumption = sizes.grouppedBySpeedConsumption,
            grouppedByBoxShaped = sizes.grouppedByBoxShaped,
            grouppedByOpenHatch = sizes.grouppedByOpenHatch,
            grouppedByCells = sizes.grouppedByCells,
            grouppedByHatches = sizes.grouppedByHatches,
            grouppedByHolds = sizes.grouppedByHolds,
            grouppedByCapacityV2 = sizes.grouppedByCapacityV2,
            grouppedByFlags = sizes.grouppedByFlags,
            grouppedByRegisterClass = sizes.grouppedByRegisterClass,
            grouppedByPIClub = sizes.grouppedByPIClub,
            grouppedByGrabs = sizes.grouppedByGrabs,
            grouppedByDimensions = sizes.grouppedByDimensions;


        if (grouppedByTypeByPurpose && Object.keys(grouppedByTypeByPurpose).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByTypeByPurpose,
                body: generateCollapseBody({
                    key: 'grouppedByTypeByPurpose',
                    nameValue: [{ name: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByTypeByPurpose, value: 'typeByPurpose' }],
                    group: grouppedByTypeByPurpose,
                    type: 'string'
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByTypeByConstruction && Object.keys(grouppedByTypeByConstruction).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByTypeByConstruction,
                body: generateCollapseBody({
                    key: 'grouppedByTypeByConstruction',
                    nameValue: [{ name: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByTypeByConstruction, value: 'typeByConstruction' }],
                    group: grouppedByTypeByConstruction,
                    type: 'string'
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByTypeBySpecialty && Object.keys(grouppedByTypeBySpecialty).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByTypeBySpecialty,
                body: generateCollapseBody({
                    key: 'grouppedByTypeBySpecialty',
                    nameValue: [{ name: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByTypeBySpecialty, value: 'typeBySpecialty' }],
                    group: grouppedByTypeBySpecialty,
                    type: 'string'
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByBoxShaped && Object.keys(grouppedByBoxShaped).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByBoxShaped,
                body: generateCollapseBody({
                    key: 'grouppedByBoxShaped',
                    nameValue: [{ name: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByBoxShaped, value: 'boxShaped' }],
                    group: grouppedByBoxShaped,
                    type: 'string'
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByOpenHatch && Object.keys(grouppedByOpenHatch).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByOpenHatch,
                body: generateCollapseBody({
                    key: 'grouppedByOpenHatch',
                    nameValue: [{ name: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByOpenHatch, value: 'openHatch' }],
                    group: grouppedByOpenHatch,
                    type: 'string'
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByGears && Object.keys(grouppedByGears).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByGears,
                body: generateCollapseBody({
                    key: 'grouppedByGears',
                    nameValue: [{ name: 'Type', value: 'type' }, { name: 'Quantity', value: 'quantity' }, { name: 'Capacity', value: 'capacity' }, { name: 'Max SWL', value: 'maxSWL' }],
                    group: grouppedByGears,
                    type: 'array'
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByGrabs && Object.keys(grouppedByGrabs).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByGrabs,
                body: generateCollapseBody({
                    key: 'grouppedByGrabs',
                    nameValue: [{ name: 'Type', value: 'type' }, { name: 'Quantity', value: 'quantity' }, { name: 'Volume', value: 'volume' }],
                    group: grouppedByGrabs,
                    type: 'array'
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedBySpeedConsumption && Object.keys(grouppedBySpeedConsumption).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedBySpeedConsumption,
                body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    Object.entries(grouppedBySpeedConsumption).map(function (g, index) {
                        var value = g[1];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: 'grouppedBySpeedConsumption_' + g[0], className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-6' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'b',
                                        null,
                                        'Mode:'
                                    ),
                                    ' ',
                                    value[0].mode,
                                    '\xA0\xA0\xA0',
                                    value[0].speed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            'Speed:'
                                        ),
                                        ' ',
                                        value[0].speed
                                    ),
                                    '\xA0\xA0\xA0',
                                    value[0].ifo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'b',
                                                null,
                                                'Ifo:'
                                            ),
                                            ' ',
                                            value[0].ifo.typeIfo
                                        ),
                                        '\xA0\xA0\xA0',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'b',
                                                null,
                                                'Cons:'
                                            ),
                                            ' ',
                                            value[0].ifo.cons
                                        ),
                                        '\xA0\xA0\xA0'
                                    ),
                                    value[0].mdo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'b',
                                                null,
                                                'Mdo:'
                                            ),
                                            ' ',
                                            value[0].mdo.typeMdo
                                        ),
                                        '\xA0\xA0\xA0',
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'b',
                                                null,
                                                'Cons:'
                                            ),
                                            ' ',
                                            value[0].mdo.cons
                                        ),
                                        '\xA0\xA0\xA0'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-5' },
                                value.map(function (v) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'p',
                                        { style: { display: 'inline-block' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'a',
                                            { href: window.location.origin + '/' + v.emailId, target: '_blank' },
                                            v.emailId
                                        ),
                                        '\xA0\xA0\xA0'
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-1', style: { padding: 0 } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* default */], {
                                    type: 'grouppedBySpeedConsumption',
                                    size: sizes && {
                                        speedConsumptionV2: {
                                            value: sizes.grouppedBySpeedConsumption[g[0]][0]
                                        }
                                    },
                                    sizes: sizes,
                                    field: g[0],
                                    emailIds: value.map(function (v) {
                                        return v.emailId;
                                    }),
                                    index: index,
                                    accept: accept,
                                    reject: reject,
                                    transfer: transferOne,
                                    addToMultiTransfer: addToMultiTransfer,
                                    shouldShowApproveReject: shouldShowApproveReject
                                })
                            )
                        );
                    })
                )
            });
        }

        if (grouppedByTechEquipCertificate && Object.keys(grouppedByTechEquipCertificate).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByTechEquipCertificate,
                body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    Object.entries(grouppedByTechEquipCertificate).map(function (g, index) {
                        var values = g[1];
                        var techEntries = Object.entries(__WEBPACK_IMPORTED_MODULE_4_lodash__["omit"](values[0].techEquipCertificate.value, ['_id']));

                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: 'grouppedByTechEquipCertificate_' + g[0], className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-6' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    null,
                                    techEntries.map(function (te, teIdex) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            {
                                                id: te[0] + '_' + index + '_' + teIdex,
                                                key: te[0] + '_' + index + '_' + teIdex
                                            },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'b',
                                                null,
                                                techEquipCertificateFieldsNamesMap[te[0]],
                                                ': '
                                            ),
                                            te[1] === true ? 'true' : te[1],
                                            '\xA0\xA0\xA0'
                                        );
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-5' },
                                values.map(function (v) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'p',
                                        { style: { display: 'inline-block' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'a',
                                            { href: window.location.origin + '/' + v.emailId, target: '_blank' },
                                            v.emailId
                                        ),
                                        '\xA0\xA0\xA0'
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-1', style: { padding: 0 } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* default */], {
                                    type: 'grouppedByTechEquipCertificate',
                                    size: sizes && sizes.grouppedByTechEquipCertificate[g[0]][0],
                                    index: index,
                                    emailIds: values.map(function (v) {
                                        return v.emailId;
                                    }),
                                    accept: accept,
                                    reject: reject,
                                    transfer: transferOne,
                                    addToMultiTransfer: addToMultiTransfer,
                                    shouldShowApproveReject: shouldShowApproveReject
                                })
                            )
                        );
                    })
                )
            });
        }

        if (grouppedByDeadWeight && Object.keys(grouppedByDeadWeight).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByDeadWeight,
                body: generateCollapseBody({
                    key: 'grouppedByDeadWeight',
                    group: grouppedByDeadWeight,
                    type: 'object',
                    namesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* deadWeightFieldsNamesMap */]
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByDimensions && Object.keys(grouppedByDimensions).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByDimensions,
                body: generateCollapseBody({
                    key: 'grouppedByDimensions',
                    group: grouppedByDimensions,
                    type: 'object',
                    namesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["f" /* dimensionsFieldsMap */]
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByRt && Object.keys(grouppedByRt).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByRt,
                body: generateCollapseBody({
                    key: 'grouppedByRt',
                    group: grouppedByRt,
                    type: 'object',
                    namesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["i" /* rtFieldsNamesMap */]
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByHatches && Object.keys(grouppedByHatches).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByHatches,
                body: generateCollapseBody({
                    key: 'grouppedByHatches',
                    group: grouppedByHatches,
                    type: 'object',
                    namesMap: { quantity: 'Quantity' }
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByHolds && Object.keys(grouppedByHolds).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByHolds,
                body: generateCollapseBody({
                    key: 'grouppedByHolds',
                    group: grouppedByHolds,
                    type: 'object',
                    namesMap: { quantity: 'Quantity' }
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByCapacityV2 && Object.keys(grouppedByCapacityV2).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByCapacityV2,
                body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    ' ',
                    Object.entries(grouppedByCapacityV2).map(function (g, index) {
                        var value = g[1];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: 'grouppedByCapacityV2_' + g[0], className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-6' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_4_lodash__["sortBy"](Object.entries(__WEBPACK_IMPORTED_MODULE_4_lodash__["omit"](value[0].capacityV2.value, ['_id'])), function (e) {
                                        return e[0];
                                    }).map(function (d) {
                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'span',
                                            { key: d[0] + '_' + d[1] },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'b',
                                                null,
                                                capacityV2FieldsNamesMap[d[0]],
                                                ': '
                                            ),
                                            typeof d[1] === 'number' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                                null,
                                                d[1] + '',
                                                '\xA0\xA0\xA0'
                                            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'div',
                                                    null,
                                                    'Holds:',
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                    Object.keys(d[1][0]).length ? d[1].map(function (summItem, sIndex) {
                                                        var items = Object.entries(summItem.hold);
                                                        var elem = '';
                                                        items.forEach(function (item) {
                                                            elem += capacityV2FieldsNamesMap[item[0]] + ': ' + item[1] + ' ';
                                                        });

                                                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'span',
                                                            { id: 'summItem_' + sIndex },
                                                            elem,
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                                                        );
                                                    }) : null
                                                )
                                            )
                                        );
                                    })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-5' },
                                value.map(function (v) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'p',
                                        { key: v.emailId, style: { display: 'inline-block' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'a',
                                            { href: window.location.origin + '/' + v.emailId, target: '_blank' },
                                            v.emailId
                                        ),
                                        '\xA0\xA0\xA0'
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-1', style: { padding: 0 } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* default */], {
                                    type: 'grouppedByCapacityV2',
                                    size: sizes && sizes.grouppedByCapacityV2[g[0]][0],
                                    emailIds: value.map(function (v) {
                                        return v.emailId;
                                    }),
                                    index: index,
                                    accept: accept,
                                    reject: reject,
                                    transfer: transferOne,
                                    addToMultiTransfer: addToMultiTransfer,
                                    shouldShowApproveReject: shouldShowApproveReject
                                })
                            )
                        );
                    })
                )
            });
        }

        if (grouppedByCells && Object.keys(grouppedByCells).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByCells,
                body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    ' ',
                    Object.entries(grouppedByCells).map(function (g, index) {
                        var values = g[1];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: 'grouppedByCells_' + g[0], className: 'row' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-6' },
                                values[0].cells.value.map(function (v, vIndex) {
                                    var holds = v.holds,
                                        hatches = v.hatches,
                                        tweenDecks = v.tweenDecks;

                                    var fHolds = __WEBPACK_IMPORTED_MODULE_4_lodash__["omit"](holds, ['_id']);
                                    var fHatches = hatches.map(function (h) {
                                        return __WEBPACK_IMPORTED_MODULE_4_lodash__["omit"](h, ['_id']);
                                    });
                                    var fTweenDecks = tweenDecks.map(function (t) {
                                        return __WEBPACK_IMPORTED_MODULE_4_lodash__["omit"](t, ['_id']);
                                    });

                                    var hatchStr0 = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["g" /* generateHatchTweenDeckStr */])(fHatches[0]);
                                    var hatchStr1 = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["g" /* generateHatchTweenDeckStr */])(fHatches[1]);
                                    var tweenDecksStr0 = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["g" /* generateHatchTweenDeckStr */])(fTweenDecks[0]);
                                    var tweenDecksStr1 = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["g" /* generateHatchTweenDeckStr */])(fTweenDecks[1]);
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { key: 'grouppedByCells_' + g[0] + '_' + vIndex, className: 'row' },
                                        Object.keys(fHolds).length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'p',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'b',
                                                    null,
                                                    'Holds: '
                                                ),
                                                ' L: ',
                                                fHolds.l,
                                                ', B: ',
                                                fHolds.b,
                                                ', H: ',
                                                fHolds.h
                                            )
                                        ) : null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            hatchStr0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'p',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'b',
                                                    null,
                                                    'Hatches: '
                                                ),
                                                hatchStr0
                                            ),
                                            hatchStr1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'p',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'b',
                                                    null,
                                                    'Hatches: '
                                                ),
                                                hatchStr1
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-xs-4' },
                                            tweenDecksStr0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'p',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'b',
                                                    null,
                                                    'TweenDecks: '
                                                ),
                                                tweenDecksStr0
                                            ),
                                            tweenDecksStr1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'p',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'b',
                                                    null,
                                                    'TweenDecks: '
                                                ),
                                                tweenDecksStr1
                                            )
                                        )
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-5' },
                                values.map(function (v) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'p',
                                        { style: { display: 'inline-block' } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'a',
                                            { href: window.location.origin + '/' + v.emailId, target: '_blank' },
                                            v.emailId
                                        ),
                                        '\xA0\xA0\xA0'
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'col-xs-1', style: { padding: 0 } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* default */], {
                                    type: 'grouppedByCells',
                                    size: values[0],
                                    emailIds: values.map(function (v) {
                                        return v.emailId;
                                    }),
                                    sizes: sizes,
                                    index: index,
                                    accept: accept,
                                    reject: reject,
                                    transfer: transferOne,
                                    addToMultiTransfer: addToMultiTransfer,
                                    shouldShowApproveReject: shouldShowApproveReject
                                })
                            )
                        );
                    })
                )
            });
        }

        if (grouppedByFlags && Object.keys(grouppedByFlags).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByFlags,
                body: generateCollapseBody({
                    key: 'grouppedByFlags',
                    group: grouppedByFlags,
                    type: 'object',
                    namesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* basicNamesFieldsMap */]
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByRegisterClass && Object.keys(grouppedByRegisterClass).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByRegisterClass,
                body: generateCollapseBody({
                    key: 'grouppedByRegisterClass',
                    group: grouppedByRegisterClass,
                    type: 'object',
                    namesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["h" /* registerClassFieldsMap */]
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        if (grouppedByPIClub && Object.keys(grouppedByPIClub).length) {
            collapsesData.push({
                head: __WEBPACK_IMPORTED_MODULE_6__utils__["k" /* sizesMap */].grouppedByPIClub,
                body: generateCollapseBody({
                    key: 'grouppedByPIClub',
                    group: grouppedByPIClub,
                    type: 'object',
                    namesMap: __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* basicNamesFieldsMap */]
                }, sizes, accept, reject, transferOne, {}, { addToMultiTransfer: addToMultiTransfer, shouldShowApproveReject: shouldShowApproveReject })
            });
        }

        return collapsesData;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        collapses.map(function (c, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* CollapseBody */], {
                key: 'c_' + i,
                head: c.head,
                body: c.body,
                maxHeight: '300px'
            });
        })
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        addNotification: __WEBPACK_IMPORTED_MODULE_5_actions_notifications_notifications__["a" /* addNotification */]
    }, dispatch);
})(Collapses);

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * @param {{ 
    *      type: 'object'|'array'|'string', 
    *      key: string, 
    *      nameValue?: {name: string, value: string}[], 
    *      group: any,
    *      namesMap?: any }} opts
    */
function generateCollapseBody(opts, sizes, accept, reject, transferOne) {
    var statuses = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var sideEffects = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    var type = opts.type,
        key = opts.key,
        group = opts.group,
        nameValue = opts.nameValue,
        namesMap = opts.namesMap;

    var valueFieldName = '';
    var keep_id = false;

    switch (type) {
        case 'string':
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                ' ',
                Object.entries(group).map(function (g, index) {
                    var value = g[1];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: key + '_' + g[0] + '_' + index, className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: key + '_' + g[0] + '_' + index, className: 'col-xs-6', style: statuses.typeByConstruction && { opacity: 0.5 } },
                            nameValue.map(function (nv, nvIndex) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    { key: '' + nv.name + nvIndex },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'b',
                                        null,
                                        nv.name,
                                        ':'
                                    ),
                                    ' ',
                                    value[0][nv.value].value + ''
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-5' },
                            value.map(function (v) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    { key: v.emailId, style: { display: 'inline-block' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'a',
                                        { href: window.location.origin + '/' + v.emailId, target: '_blank' },
                                        v.emailId
                                    ),
                                    '\xA0\xA0\xA0'
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1', style: { padding: 0 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* default */], {
                                type: key,
                                size: sizes && sizes[key][g[0]][index],
                                emailIds: value.map(function (v) {
                                    return v.emailId;
                                }),
                                index: index,
                                accept: accept,
                                reject: reject,
                                transfer: transferOne,
                                addToMultiTransfer: sideEffects.addToMultiTransfer,
                                shouldShowApproveReject: sideEffects.shouldShowApproveReject
                            })
                        )
                    );
                })
            );
        case 'array':
            if (key === 'grouppedByGears') {
                valueFieldName = 'gearV2';
            } else if (key === 'grouppedByGrabs') {
                valueFieldName = 'grabV2';
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                Object.entries(group).map(function (g, index) {
                    var value = g[1];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: key + '_' + g[0], className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            nameValue.map(function (nv) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'b',
                                        null,
                                        nv.name,
                                        ':'
                                    ),
                                    ' ',
                                    value[0][nv.value]
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-5' },
                            value.map(function (v) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    { style: { display: 'inline-block' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'a',
                                        { href: window.location.origin + '/' + v.emailId },
                                        v.emailId
                                    ),
                                    '\xA0\xA0\xA0'
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1', style: { padding: 0 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* default */], {
                                type: key,
                                size: sizes && _defineProperty({}, valueFieldName, {
                                    value: sizes[key][g[0]][index]
                                }),
                                sizes: sizes,
                                field: g[0],
                                emailIds: value.map(function (v) {
                                    return v.emailId;
                                }),
                                index: index,
                                accept: accept,
                                reject: reject,
                                transfer: transferOne,
                                addToMultiTransfer: sideEffects.addToMultiTransfer,
                                shouldShowApproveReject: sideEffects.shouldShowApproveReject
                            })
                        )
                    );
                })
            );
        case 'object':
            if (key === 'grouppedByRt') {
                valueFieldName = 'rt';
            } else if (key === 'grouppedByDeadWeight') {
                valueFieldName = 'deadWeight';
            } else if (key === 'grouppedByDimensions') {
                valueFieldName = 'dimensions';
            } else if (key === 'grouppedByHatches') {
                valueFieldName = 'hatches';
            } else if (key === 'grouppedByHolds') {
                valueFieldName = 'holds';
            } else if (key === 'grouppedByCapacityV2') {
                valueFieldName = 'capacityV2';
            } else if (key === 'grouppedByFlags') {
                valueFieldName = 'flag';
                keep_id = true;
            } else if (key === 'grouppedByRegisterClass') {
                valueFieldName = 'registerClass';
                keep_id = true;
            } else if (key === 'grouppedByPIClub') {
                valueFieldName = 'piClub';
                keep_id = true;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                Object.entries(group).map(function (g, index) {
                    var value = g[1];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: key + '_' + g[0], className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                Object.entries(__WEBPACK_IMPORTED_MODULE_4_lodash__["omit"](value[0][valueFieldName].value, ['_id'])).map(function (d) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { key: d[0] + '_' + d[1] },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'b',
                                            null,
                                            namesMap[d[0]],
                                            ': '
                                        ),
                                        d[1] + '',
                                        '\xA0\xA0\xA0'
                                    );
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-5' },
                            value.map(function (v) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'p',
                                    { style: { display: 'inline-block' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'a',
                                        { href: window.location.origin + '/' + v.emailId, target: '_blank' },
                                        v.emailId
                                    ),
                                    '\xA0\xA0\xA0'
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-1', style: { padding: 0 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* default */], {
                                type: key,
                                size: sizes && sizes['' + key][g[0]][0],
                                emailIds: value.map(function (v) {
                                    return v.emailId;
                                }),
                                index: index,
                                accept: accept,
                                reject: reject,
                                transfer: transferOne,
                                keep_id: keep_id,
                                addToMultiTransfer: sideEffects.addToMultiTransfer,
                                shouldShowApproveReject: sideEffects.shouldShowApproveReject
                            })
                        )
                    );
                })
            );
    }
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Collapses, 'Collapses', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Collapses.jsx');
    reactHotLoader.register(generateCollapseBody, 'generateCollapseBody', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Collapses.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Collapses.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Size;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_ErrorBoundary__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Letters_Single_Size_Sidebar_Size_SizesTable__ = __webpack_require__(814);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function Size(_ref) {
    var vesselId = _ref.vesselId,
        modifySizes = _ref.modifySizes;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        routeParamsId = _useState2[0],
        setRouteParamsId = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setRouteParamsId(vesselId);
        return function () {
            setRouteParamsId(null);
        };
    }, [vesselId]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        routeParamsId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_components_common_ErrorBoundary__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Letters_Single_Size_Sidebar_Size_SizesTable__["a" /* default */], {
                key: vesselId,
                routeParams: { id: routeParamsId },
                showAddButton: false,
                modifySizes: modifySizes
            })
        ) : null
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Size, 'Size', '/opt/atlassian/pipelines/agent/build/client/app/components/Vessels/Composition/Size.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128544
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(399);

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || Object(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* default */])(b);
}

/* unused harmony default export */ var _unused_webpack_default_export = (v1);

/***/ }),
/* 3488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);

/***/ }),
/* 3489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__(3490);


var v3 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v3);

/***/ }),
/* 3490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';

  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));

  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),
/* 3491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(399);



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* default */])(rnds);
}

/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),
/* 3492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__(3493);


var v5 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (v5);

/***/ }),
/* 3493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);

    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }

    M[_i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);

    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }

    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),
/* 3494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ('00000000-0000-0000-0000-000000000000');

/***/ }),
/* 3495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(400);


function version(uuid) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

/* unused harmony default export */ var _unused_webpack_default_export = (version);

/***/ }),
/* 3496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TcIndexRow__ = __webpack_require__(3497);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function TcIndexTable(_ref) {
    var rows = _ref.rows,
        _errors = _ref.errors;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_errors),
        _useState2 = _slicedToArray(_useState, 2),
        errors = _useState2[0],
        setErrors = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setErrors(_errors);
    }, [_errors]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["Table"],
            {
                selectable: false
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeader"],
                {
                    displaySelectAll: false,
                    adjustForCheckbox: false
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Index'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'IMO'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Vessel Type General*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Vessel Type*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'DWT group*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerCol },
                    'Place from'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerCol },
                    'Region from*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerCol },
                    'Place to'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerCol },
                    'Region to*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerCol },
                    'VIA'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Round trip'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Clean'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerCol },
                    'LayCan*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Duration, d'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Balast bonus, $'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Intake, mt'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'T/C index, $/day*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerCol },
                    'Last update'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Approve'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Reject'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableHeaderColumn"],
                    { style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].headerColSm },
                    'Delete'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_material_ui_Table__["TableBody"],
                {
                    displayRowCheckbox: false
                },
                rows.map(function (row, countIndex) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TcIndexRow__["a" /* default */], {
                        countIndex: countIndex,
                        key: row._id || row.key,
                        hireData: row,
                        errors: errors
                    });
                })
            )
        )
    );
}

var _default = TcIndexTable;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TcIndexTable, 'TcIndexTable', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = TcIndexRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RowData_DwtGroup__ = __webpack_require__(3498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RowData_Imo__ = __webpack_require__(3499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RowData_IndexSelector__ = __webpack_require__(3500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RowData_FromTo__ = __webpack_require__(3501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RowData_TypeGeneral__ = __webpack_require__(3502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RowData_VesselType__ = __webpack_require__(3503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RowData_RoundClean__ = __webpack_require__(3504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RowData_LayCan__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RowData_Durations__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RowData_BalastBonus__ = __webpack_require__(3506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RowData_Intake__ = __webpack_require__(3507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RowData_TcIndexValue__ = __webpack_require__(3508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TcIndexPage__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RowData_ManageButtons__ = __webpack_require__(3509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__RowData_Via__ = __webpack_require__(3510);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





















var s = {
    small: _extends({}, __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].tableRowSm),
    normal: _extends({}, __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].tableRow)
};

function TcIndexRow(_ref) {
    var hireData = _ref.hireData,
        countIndex = _ref.countIndex,
        _errors = _ref.errors;

    var changeFieldsMultiple = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_16__TcIndexPage__["b" /* ChangeFieldsContext */]);
    var handleUpdateErrors = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_16__TcIndexPage__["c" /* HandleUpdateErrorsContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_errors),
        _useState2 = _slicedToArray(_useState, 2),
        errors = _useState2[0],
        setErrors = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setErrors(_errors[countIndex]);
    }, [_errors]);

    var handleErrors = function handleErrors(field, value) {
        handleUpdateErrors(countIndex, field, value);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RowData_IndexSelector__["a" /* default */], {
                    hireData: hireData,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RowData_Imo__["a" /* default */], {
                    imo: hireData.vessel ? hireData.vessel.imoNumber : null,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, errors && errors.typeGeneral ? __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RowData_TypeGeneral__["a" /* default */], {
                    typeGeneral: hireData.typeByPurpose,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex,
                    required: true,
                    setHasErrors: handleErrors
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                {
                    style: _extends({}, s.small, errors && errors.vesselDwtGroup ? __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].error : {}, {
                        backgroundColor: hireData.typeByPurpose ? 'inherit' : '#eaeaea'
                    })
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RowData_VesselType__["a" /* default */], {
                    vesselType: hireData.vesselDwtGroup,
                    currentTypeGeneral: hireData.typeByPurpose,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex,
                    required: true,
                    setHasErrors: handleErrors,
                    disabled: !hireData.typeByPurpose
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, errors && errors.vesselDwtGroup ? __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].error : {}, {
                        backgroundColor: hireData.typeByPurpose ? 'inherit' : '#eaeaea'
                    })
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RowData_DwtGroup__["a" /* default */], {
                    vesselType: hireData.vesselDwtGroup,
                    currentTypeGeneral: hireData.typeByPurpose,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex,
                    required: true,
                    setHasErrors: handleErrors,
                    disabled: !hireData.typeByPurpose
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RowData_FromTo__["a" /* default */], {
                    field: 'placeFrom',
                    data: hireData.placeFrom,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex,
                    mainRegions: false,
                    withAreas: false
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal, errors && errors.regionFrom ? __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RowData_FromTo__["a" /* default */], {
                    field: 'regionFrom',
                    data: hireData.regionFrom,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex,
                    required: true,
                    setHasErrors: handleErrors,
                    mainRegions: true,
                    withAreas: true,
                    isInBalticIndex: true,
                    onlyAreas: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RowData_FromTo__["a" /* default */], {
                    field: 'placeTo',
                    data: hireData.placeTo,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex,
                    mainRegions: false,
                    withAreas: false
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal, errors && errors.regionTo ? __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RowData_FromTo__["a" /* default */], {
                    field: 'regionTo',
                    data: hireData.regionTo,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex,
                    required: true,
                    setHasErrors: handleErrors,
                    mainRegions: true,
                    withAreas: true,
                    onlyAreas: true,
                    isInBalticIndex: true
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__RowData_Via__["a" /* default */], {
                    via: hireData.via,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, { textAlign: 'center' }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RowData_RoundClean__["a" /* default */], {
                    checked: hireData.roundTrip,
                    field: 'roundTrip',
                    countIndex: countIndex,
                    changeFieldsMultiple: changeFieldsMultiple
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, { textAlign: 'center' }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RowData_RoundClean__["a" /* default */], {
                    checked: hireData.clean,
                    field: 'clean',
                    countIndex: countIndex,
                    changeFieldsMultiple: changeFieldsMultiple
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal, errors && errors.layCan ? __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RowData_LayCan__["a" /* default */], {
                    lay: hireData.lay,
                    can: hireData.can,
                    required: true,
                    setHasErrors: handleErrors,
                    countIndex: countIndex,
                    changeFieldsMultiple: changeFieldsMultiple
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RowData_Durations__["a" /* default */], {
                    duration: hireData.duration,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__RowData_BalastBonus__["a" /* default */], {
                    balastBonus: hireData.balastBonus,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RowData_Intake__["a" /* default */], {
                    intake: hireData.intake,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, errors && errors.tcIndex ? __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].error : {}) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RowData_TcIndexValue__["a" /* default */], {
                    tcIndex: hireData.tcIndex,
                    required: true,
                    setHasErrors: handleErrors,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.normal) },
                hireData.lastUpdate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: '9px', textOverflow: 'ellipsis' } },
                    hireData.lastUpdate.user.email,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    hireData.lastUpdate.user.company.name,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_1_moment___default()(hireData.lastUpdate.date).format('DD MM YYYY hh:mm:ss'),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, { textOverflow: 'unset' }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__RowData_ManageButtons__["a" /* Approve */], {
                    confirmed: hireData.confirmed,
                    hireDataId: hireData._id,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, { textOverflow: 'unset' }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__RowData_ManageButtons__["b" /* Reject */], {
                    rejected: hireData.rejected,
                    changeFieldsMultiple: changeFieldsMultiple,
                    hireDataId: hireData._id || hireData.unique_id,
                    countIndex: countIndex
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                { style: _extends({}, s.small, { borderRight: __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].borderRight, textOverflow: 'unset' }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__RowData_ManageButtons__["c" /* Remove */], {
                    hireDataId: hireData._id || hireData.unique_id,
                    changeFieldsMultiple: changeFieldsMultiple,
                    countIndex: countIndex
                })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(s, 's', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexRow.jsx');
    reactHotLoader.register(TcIndexRow, 'TcIndexRow', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/TcIndexRow.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Basic_BasicSelector__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TcIndexPage__ = __webpack_require__(132);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function DwtGroup(_ref) {
    var vesselType = _ref.vesselType,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        setHasErrors = _ref.setHasErrors,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        currentTypeGeneral = _ref.currentTypeGeneral;

    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__TcIndexPage__["f" /* VesselDwtTypesContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(vesselDwtTypes),
        _useState2 = _slicedToArray(_useState, 2),
        dataList = _useState2[0],
        setDataList = _useState2[1];

    var selectVesselType = function selectVesselType(_id) {
        var toChange = [{
            index: countIndex,
            field: 'vesselDwtGroup',
            value: vesselDwtTypes.find(function (t) {
                return t._id === _id;
            })
        }];

        toChange.push({
            index: countIndex,
            field: 'vesselId',
            value: ''
        }, {
            index: countIndex,
            field: 'vessel.imoNumber',
            value: ''
        });

        changeFieldsMultiple(toChange);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!vesselType || !vesselType._id) {
                setHasErrors('vesselDwtGroup', true);
            } else {
                setHasErrors('vesselDwtGroup', false);
            }
        }
    }, [vesselType]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (currentTypeGeneral) {
            setDataList(vesselDwtTypes.filter(function (d) {
                return d.typeByPurpose.includes(currentTypeGeneral);
            }));
        }
    }, [currentTypeGeneral]);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Basic_BasicSelector__["a" /* default */], {
        value: vesselType && vesselType._id,
        dataList: dataList,
        onChange: function onChange(e, _i, value) {
            return selectVesselType(value);
        },
        iconStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        labelStyle: { padding: 0, top: 'unset' },
        fields: ['min', 'max'],
        disabled: disabled
    });
}

DwtGroup.protoTypes = {
    vesselType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        _id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    changeFieldsMultiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    countIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(DwtGroup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DwtGroup, 'DwtGroup', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/DwtGroup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/DwtGroup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcIndexPage__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(292);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




// import { types } from 'constants/vesselTypes';



function Imo(_ref) {
    var _imo = _ref.imo,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__TcIndexPage__["f" /* VesselDwtTypesContext */]);

    var selectVessel = function selectVessel(vessel) {
        var vesselData = Object(__WEBPACK_IMPORTED_MODULE_3__common__["b" /* selectTypes */])(vessel, vesselDwtTypes);

        changeFieldsMultiple([{
            index: countIndex,
            field: 'vesselId',
            value: vessel._id || null
        }, {
            index: countIndex,
            field: 'vessel.imoNumber',
            value: vessel.imoNumber
        }, {
            index: countIndex,
            field: 'vessel.typeByPurpose',
            value: vesselData.typeByPurpose
        }, {
            index: countIndex,
            field: 'typeByPurpose',
            value: vesselData.typeByPurpose
        }, {
            index: countIndex,
            field: 'vesselDwtGroup',
            value: vesselData.vesselDwtGroup
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__["a" /* default */], {
        customValue: _imo,
        selectValue: selectVessel,
        hintText: null,
        underlineStyle: { display: 'none' },
        menuStyle: { width: '300px' },
        popoverProps: {
            style: { width: '300px' }
        },
        inputStyle: { fontSize: '9px' },
        field: 'imoNumber'
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Imo);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Imo, 'Imo', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Imo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Imo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TcIndexPage__ = __webpack_require__(132);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function IndexSelector(_ref) {
    var hireData = _ref.hireData,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex;

    var indexes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__TcIndexPage__["d" /* PredefinedIndexesContext */]);
    var dwtGroups = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__TcIndexPage__["f" /* VesselDwtTypesContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(hireData.predefinedTcIndex),
        _useState2 = _slicedToArray(_useState, 2),
        currentIndex = _useState2[0],
        setCurrentIndex = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState4 = _slicedToArray(_useState3, 2),
        shouldRecheck = _useState4[0],
        setShouldRecheck = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (shouldRecheck) {
            var found = indexes.find(function (index) {
                return index.clean === hireData.clean && index.roundTrip === hireData.roundTrip && (hireData.vesselDwtGroup ? index.vesselType === hireData.vesselDwtGroup.name : true) && (index.preciseFrom && index.preciseFrom.length ? checkInMultiple(index.preciseFrom, hireData.placeFrom) : checkInMultiple(index.from, hireData.regionFrom)) && (index.preciseTo && index.preciseTo.length ? checkInMultiple(index.preciseTo, hireData.placeTo) : checkInMultiple(index.to, hireData.regionTo)) && checkInMultiple(index.via, hireData.via);
            });

            if (found) {
                setCurrentIndex(found);
            } else {
                setCurrentIndex({});
            }
        } else {
            setShouldRecheck(true);
        }
    }, [hireData.clean, hireData.roundTrip, hireData.vesselDwtGroup, hireData.placeFrom, hireData.placeTo, hireData.regionFrom, hireData.regionTo, hireData.via]);

    var checkInMultiple = function checkInMultiple(indexValue, hireValue) {
        if (indexValue.length === 0) return true;
        if (!hireValue) return false;

        var found = indexValue.findIndex(function (v) {
            return v._id === hireValue._id;
        });

        if (found >= 0) return true;

        return false;
    };

    var hanleChangeIndex = function hanleChangeIndex(value) {
        var index = indexes.find(function (i) {
            return i._id === value;
        });
        setCurrentIndex(index);
        setShouldRecheck(false);

        var typeGeneral = dwtGroups.filter(function (d) {
            return d.name;
        }).find(function (d) {
            return d.name === index.vesselType;
        });
        changeFieldsMultiple([{ index: countIndex, field: 'predefinedTcIndex', value: index }, { index: countIndex, field: 'clean', value: index.clean }, { index: countIndex, field: 'roundTrip', value: index.roundTrip }, { index: countIndex, field: 'placeFrom', value: index.preciseFrom ? index.preciseFrom[0] : {} }, { index: countIndex, field: 'placeTo', value: index.preciseTo ? index.preciseTo[0] : {} }, { index: countIndex, field: 'regionFrom', value: index.from[0] }, { index: countIndex, field: 'regionTo', value: index.to[0] }, { index: countIndex, field: 'via', value: index.via[0] }, {
            index: countIndex,
            field: 'vesselDwtGroup',
            value: dwtGroups.filter(function (d) {
                return d.name;
            }).find(function (d) {
                return d.name === index.vesselType;
            })
        } || {}, {
            index: countIndex,
            field: 'typeGeneral',
            value: typeGeneral ? typeGeneral.typeByPurpose[0] : ''
        }, {
            index: countIndex,
            field: 'typeByPurpose',
            value: typeGeneral ? typeGeneral.typeByPurpose[0] : ''
        }, { index: countIndex, field: 'vessel.imoNumber', value: '' }, { index: countIndex, field: 'vesselId', value: null }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui_SelectField___default.a,
            {
                value: currentIndex && currentIndex._id,
                onChange: function onChange(_e, _i, val) {
                    return hanleChangeIndex(val);
                },
                style: { width: '100%', fontSize: '10px' },
                iconStyle: { display: 'none' },
                underlineStyle: { display: 'none' },
                labelStyle: { height: '45px', padding: 0 },
                floatingLabelStyle: { fontSize: '10px' },
                autoWidth: true
            },
            indexes.length && indexes.map(function (i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a, {
                    value: i._id,
                    primaryText: i.name,
                    key: i._id
                });
            })
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(IndexSelector);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(IndexSelector, 'IndexSelector', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/IndexSelector.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/IndexSelector.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_PortsAutoComplete__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






/**
 * @param {{
 *  field: string,
 *  data: any,
 *  changeFieldsMultiple: Function,
 *  countIndex: number,
 *  required?: boolean,
 *  setHasErrors: Function,
 *  mainRegions?: boolean,
 *  withAreas?: boolean,
 *  onlyAreas?: boolean,
 *  isInBalticIndex?: boolean,
 *  placeFrom?: string,
 *  placeTo?: string,
 *  regionFrom?: string,
 *  regionTo?: string,
 *  checkRequiredMain?: boolean,
 *  name?: string,
 * }} param0 
 */
function FromTo(_ref) {
    var _this = this;

    var field = _ref.field,
        data = _ref.data,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        _ref$setHasErrors = _ref.setHasErrors,
        setHasErrors = _ref$setHasErrors === undefined ? function (_a, _b) {} : _ref$setHasErrors,
        mainRegions = _ref.mainRegions,
        withAreas = _ref.withAreas,
        _ref$onlyAreas = _ref.onlyAreas,
        onlyAreas = _ref$onlyAreas === undefined ? false : _ref$onlyAreas,
        _ref$isInBalticIndex = _ref.isInBalticIndex,
        isInBalticIndex = _ref$isInBalticIndex === undefined ? false : _ref$isInBalticIndex,
        _ref$placeFrom = _ref.placeFrom,
        placeFrom = _ref$placeFrom === undefined ? 'placeFrom' : _ref$placeFrom,
        _ref$placeTo = _ref.placeTo,
        placeTo = _ref$placeTo === undefined ? 'placeTo' : _ref$placeTo,
        _ref$regionFrom = _ref.regionFrom,
        regionFrom = _ref$regionFrom === undefined ? 'regionFrom' : _ref$regionFrom,
        _ref$regionTo = _ref.regionTo,
        regionTo = _ref$regionTo === undefined ? 'regionTo' : _ref$regionTo,
        _ref$checkRequiredMai = _ref.checkRequiredMain,
        checkRequiredMain = _ref$checkRequiredMai === undefined ? true : _ref$checkRequiredMai,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(data),
        _useState2 = _slicedToArray(_useState, 2),
        current = _useState2[0],
        setCurrent = _useState2[1];

    var selectPort = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(port) {
            var toChange, main;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setCurrent(port);

                            toChange = [{
                                index: countIndex,
                                field: field,
                                value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(port, ['_id', 'name'])
                            }];

                            if (![regionFrom, regionTo].includes(field)) {
                                _context.next = 6;
                                break;
                            }

                            toChange.push({
                                index: countIndex,
                                field: field === regionFrom ? placeFrom : placeTo,
                                value: {}
                            });
                            _context.next = 10;
                            break;

                        case 6:
                            _context.next = 8;
                            return __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].getPortMainRegion(port._id);

                        case 8:
                            main = _context.sent;

                            toChange.push({
                                index: countIndex,
                                field: field === placeFrom ? regionFrom : regionTo,
                                value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(main.data[0] || {}, ['_id', 'name'])
                            });

                        case 10:

                            changeFieldsMultiple(toChange);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function selectPort(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCurrent(data);
    }, [data]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            var hasError = !data || !data._id;
            if (checkRequiredMain && [regionFrom, regionTo].includes(field)) {
                setHasErrors(field, hasError);
            } else if (!checkRequiredMain) {
                setHasErrors(field, hasError);
            }
        }
    }, [current]);

    var handleChangeCustomValue = function handleChangeCustomValue(value) {
        changeFieldsMultiple([{
            index: countIndex,
            field: field,
            value: value
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_common_PortsAutoComplete__["a" /* default */], {
        name: name,
        customValue: current ? current.name : '',
        selectValue: selectPort,
        floatingLabelStyle: { display: 'none' },
        hintText: null,
        underlineStyle: { display: 'none' },
        inputStyle: { fontSize: '10px' },
        style: { top: 'unset' },
        menuStyle: { width: '300px' },
        popoverProps: {
            style: { width: '300px' }
        },
        withAreas: withAreas,
        mainRegions: mainRegions,
        onlyAreas: onlyAreas,
        handleChangeCustomValue: handleChangeCustomValue,
        isInBalticIndex: isInBalticIndex
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(FromTo);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(FromTo, 'FromTo', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/FromTo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/FromTo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Basic_BasicSelector__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_vesselTypes__ = __webpack_require__(279);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function TypesGeneral(_ref) {
    var typeGeneral = _ref.typeGeneral,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        setHasErrors = _ref.setHasErrors;

    var handleChange = function handleChange(value) {
        var toChange = [{
            index: countIndex,
            field: 'typeByPurpose',
            value: value
        }];

        if (value !== typeGeneral) {
            toChange.push({
                index: countIndex,
                field: 'vesselId',
                value: null
            }, {
                index: countIndex,
                field: 'vessel.imoNumber',
                value: ''
            }, {
                index: countIndex,
                field: 'vesselDwtGroup',
                value: {}
            });
        }
        changeFieldsMultiple(toChange);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!typeGeneral) {
                setHasErrors('typeGeneral', true);
            } else {
                setHasErrors('typeGeneral', false);
            }
        }
    }, [typeGeneral]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Basic_BasicSelector__["a" /* default */], {
        value: typeGeneral,
        dataList: __WEBPACK_IMPORTED_MODULE_2_constants_vesselTypes__["b" /* types */],
        onChange: function onChange(e, _i, value) {
            return handleChange(value);
        },
        style: { fontSize: '9px' },
        underlineStyle: { display: 'none' },
        iconStyle: { display: 'none' },
        labelStyle: { padding: 0, top: 'unset' },
        fields: ['name']
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(TypesGeneral);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TypesGeneral, 'TypesGeneral', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/TypeGeneral.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/TypeGeneral.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TcIndexPage__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Basic_BasicSelector__ = __webpack_require__(146);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function _VesselType(_ref) {
    var vesselType = _ref.vesselType,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        setHasErrors = _ref.setHasErrors,
        _ref$labelStyle = _ref.labelStyle,
        labelStyle = _ref$labelStyle === undefined ? {} : _ref$labelStyle,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        currentTypeGeneral = _ref.currentTypeGeneral;

    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__TcIndexPage__["f" /* VesselDwtTypesContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(vesselDwtTypes),
        _useState2 = _slicedToArray(_useState, 2),
        dataList = _useState2[0],
        setDataList = _useState2[1];

    var selectVesselType = function selectVesselType(_id) {
        var toChange = [{
            index: countIndex,
            field: 'vesselDwtGroup',
            value: vesselDwtTypes.find(function (t) {
                return t._id === _id;
            })
        }];

        if (_id !== vesselType._id) {
            toChange.push({
                index: countIndex,
                field: 'vesselId',
                value: null
            }, {
                index: countIndex,
                field: 'vessel.imoNumber',
                value: ''
            });
        }

        changeFieldsMultiple(toChange);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!vesselType || !vesselType._id) {
                setHasErrors('vesselDwtGroup', true);
            } else {
                setHasErrors('vesselDwtGroup', false);
            }
        }
    }, [vesselType]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (currentTypeGeneral) {
            setDataList(vesselDwtTypes.filter(function (d) {
                return d.typeByPurpose.includes(currentTypeGeneral);
            }));
        }
    }, [currentTypeGeneral]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Basic_BasicSelector__["a" /* default */], {
        value: vesselType && vesselType._id,
        dataList: dataList,
        onChange: function onChange(e, _i, value) {
            return selectVesselType(value);
        },
        iconStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        labelStyle: _extends({ padding: 0, top: 'unset' }, labelStyle),
        fields: ['name'],
        disabled: disabled || !dataList.length || !dataList.some(function (d) {
            return d.name;
        })
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(_VesselType);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(_VesselType, '_VesselType', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/VesselType.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/VesselType.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Basic_BasicCheckBox__ = __webpack_require__(986);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function RoundClean(_ref) {
    var changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex,
        checked = _ref.checked,
        field = _ref.field;

    var handleChange = function handleChange(value) {
        changeFieldsMultiple([{
            index: countIndex,
            field: field,
            value: value
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Basic_BasicCheckBox__["a" /* default */], {
        handleChange: handleChange,
        checked: checked,
        labelStyle: { display: 'none' }
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(RoundClean);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RoundClean, 'RoundClean', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/RoundClean.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/RoundClean.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = RangeDates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_DatePicker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(291);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function RangeDates(_ref) {
    var from = _ref.from,
        until = _ref.until,
        minDate = _ref.minDate,
        handleChangeDate = _ref.handleChangeDate;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_DatePicker___default.a, {
            name: Object(__WEBPACK_IMPORTED_MODULE_4_uuid__["a" /* v4 */])(),
            autoOk: true,
            minDate: minDate
            // maxDate={until ? new Date(until) : undefined}
            , onChange: function onChange(_, date) {
                return handleChangeDate('lay', __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).utcOffset(0, true));
            },
            value: from ? Object(__WEBPACK_IMPORTED_MODULE_0_helpers_dates__["a" /* fromUTC */])(from) : undefined,
            inputStyle: { fontSize: '9px', cursor: 'pointer', textAlign: 'center' },
            underlineStyle: { display: 'none' },
            textFieldStyle: { width: 'unset', height: 'unset', lineHeight: 'unset' }
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_DatePicker___default.a, {
            name: Object(__WEBPACK_IMPORTED_MODULE_4_uuid__["a" /* v4 */])(),
            autoOk: true,
            minDate: from ? new Date(from) : undefined,
            onChange: function onChange(_, date) {
                return handleChangeDate('can', __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).utcOffset(0, true).set({ hour: 23, minute: 59, second: 59 }));
            },
            inputStyle: { fontSize: '9px', cursor: 'pointer', textAlign: 'center' },
            value: until ? Object(__WEBPACK_IMPORTED_MODULE_0_helpers_dates__["a" /* fromUTC */])(until) : undefined,
            underlineStyle: { display: 'none' },
            textFieldStyle: { width: 'unset', height: 'unset', lineHeight: 'unset' }
        })
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(RangeDates, 'RangeDates', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Basic/RangeDates.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__ = __webpack_require__(243);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function BalastBonus(_ref) {
    var balastBonus = _ref.balastBonus,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(balastBonus),
        _useState2 = _slicedToArray(_useState, 2),
        stateBonus = _useState2[0],
        setStateBonus = _useState2[1];

    var changeBalastBonus = function changeBalastBonus() {
        balastBonus !== stateBonus && changeFieldsMultiple([{
            index: countIndex,
            field: 'balastBonus',
            value: stateBonus
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__["a" /* default */], {
        name: 'balastBonus',
        value: stateBonus,
        onChange: function onChange(e) {
            return setStateBonus(e.target.value);
        },
        floatingLabelStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        type: 'number',
        onBlur: changeBalastBonus
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(BalastBonus);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BalastBonus, 'BalastBonus', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/BalastBonus.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/BalastBonus.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__ = __webpack_require__(243);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function Intake(_ref) {
    var intake = _ref.intake,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(intake),
        _useState2 = _slicedToArray(_useState, 2),
        stateIntake = _useState2[0],
        setStateIntake = _useState2[1];

    var changeIntake = function changeIntake() {
        intake !== stateIntake && changeFieldsMultiple([{
            index: countIndex,
            field: 'intake',
            value: stateIntake
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__["a" /* default */], {
        name: 'intake',
        value: stateIntake,
        onChange: function onChange(e) {
            return setStateIntake(e.target.value);
        },
        floatingLabelStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        type: 'number',
        onBlur: changeIntake
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Intake);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Intake, 'Intake', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Intake.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Intake.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__ = __webpack_require__(243);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function TcIndexValue(_ref) {
    var tcIndex = _ref.tcIndex,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        setHasErrors = _ref.setHasErrors;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(tcIndex),
        _useState2 = _slicedToArray(_useState, 2),
        stateIndex = _useState2[0],
        setStateIndex = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!stateIndex) {
                setHasErrors('tcIndex', true);
            } else {
                setHasErrors('tcIndex', false);
            }
        }
    }, [stateIndex]);

    var changeTcIndex = function changeTcIndex() {
        tcIndex !== stateIndex && changeFieldsMultiple([{
            index: countIndex,
            field: 'tcIndex',
            value: stateIndex
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Basic_BasicInput__["a" /* default */], {
        name: 'tcIndex',
        value: stateIndex,
        onChange: function onChange(e) {
            return setStateIndex(e.target.value);
        },
        floatingLabelStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        type: 'number',
        onBlur: changeTcIndex
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(TcIndexValue);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TcIndexValue, 'TcIndexValue', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/TcIndexValue.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/TcIndexValue.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Approve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Reject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Remove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_check__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_clear__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Basic_BasicIconButton__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Base_AwaitableBtn_styles_scss__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Base_AwaitableBtn_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Base_AwaitableBtn_styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TcIndexPage__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TcIndex__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers_miscellaneous__ = __webpack_require__(580);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();
















function _Approve(_ref) {
    var countIndex = _ref.countIndex,
        confirmed = _ref.confirmed,
        hireDataId = _ref.hireDataId,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    var addNotification = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__TcIndex__["a" /* NotificationContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState2 = _slicedToArray(_useState, 2),
        isLoaded = _useState2[0],
        setIsLoaded = _useState2[1];

    var approve = function approve() {
        if (confirmed) return;
        setIsLoaded(false);

        __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].approveHireIdea(hireDataId).then(function (res) {
            if (!res.errors || !res.errors.length) {
                changeFieldsMultiple([{
                    index: countIndex,
                    field: 'confirmed',
                    value: true
                }, {
                    index: countIndex,
                    field: 'rejected',
                    value: false
                }]);
                setIsLoaded(true);
                addNotification(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* notifications */].success('Approved successfully.'));
            } else {
                addNotification(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* notifications */].error(res.errors[0].message));
            }
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'awaitable-btn ' + (isLoaded ? '' : 'wait') },
        isLoaded && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_navigation_check___default.a, {
            onClick: approve,
            color: confirmed ? '#eaeaea' : 'green'
        })
    );
}

var Approve = Object(__WEBPACK_IMPORTED_MODULE_4__Basic_BasicIconButton__["a" /* default */])(_Approve);

function _Reject(_ref2) {
    var countIndex = _ref2.countIndex,
        rejected = _ref2.rejected,
        hireDataId = _ref2.hireDataId,
        changeFieldsMultiple = _ref2.changeFieldsMultiple;

    var addNotification = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__TcIndex__["a" /* NotificationContext */]);

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState4 = _slicedToArray(_useState3, 2),
        isLoaded = _useState4[0],
        setIsLoaded = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isNew = _useState6[0],
        setIsNew = _useState6[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_10_helpers_miscellaneous__["a" /* isValidUuid */])(hireDataId)) {
            setIsNew(true);
        }
    }, [hireDataId]);

    var reject = function reject() {
        if (rejected) return;
        if (isNew) return;

        setIsLoaded(false);

        __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].rejectHireIdea(hireDataId).then(function (res) {
            if (!res.errors || !res.errors.length) {
                changeFieldsMultiple([{
                    index: countIndex,
                    field: 'rejected',
                    value: true
                }, {
                    index: countIndex,
                    field: 'confirmed',
                    value: false
                }]);
                setIsLoaded(true);
                addNotification(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* notifications */].success('Rejected successfully.'));
            } else {
                addNotification(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* notifications */].error(res.errors[0].message));
            }
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'awaitable-btn ' + (isLoaded ? '' : 'wait') },
        isLoaded && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_content_clear___default.a, {
            onClick: reject,
            color: rejected || isNew ? '#eaeaea' : '#F4A261'
        })
    );
}

var Reject = Object(__WEBPACK_IMPORTED_MODULE_4__Basic_BasicIconButton__["a" /* default */])(_Reject);

function _Remove(_ref3) {
    var countIndex = _ref3.countIndex,
        hireDataId = _ref3.hireDataId;

    var addNotification = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__TcIndex__["a" /* NotificationContext */]);
    var removeRow = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__TcIndexPage__["e" /* RemoveRowContext */]);

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState8 = _slicedToArray(_useState7, 2),
        isLoaded = _useState8[0],
        setIsLoaded = _useState8[1];

    var remove = function remove() {
        if (Object(__WEBPACK_IMPORTED_MODULE_10_helpers_miscellaneous__["a" /* isValidUuid */])(hireDataId)) {
            removeRow(countIndex);
            setIsLoaded(true);
            addNotification(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* notifications */].success('Removed successfully.'));

            return;
        }

        __WEBPACK_IMPORTED_MODULE_6_services__["a" /* default */].updateHireIdea({ delete: [hireDataId] }).then(function (res) {
            if (!res.errors || !res.errors.length) {
                removeRow(countIndex);
                setIsLoaded(true);
                addNotification(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* notifications */].success('Removed successfully.'));
            } else {
                addNotification(__WEBPACK_IMPORTED_MODULE_9__common__["a" /* notifications */].error(res.errors[0].message));
            }
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'awaitable-btn ' + (isLoaded ? '' : 'wait') },
        isLoaded && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_action_delete___default.a, {
            onClick: remove,
            color: 'red'
        })
    );
}

var Remove = Object(__WEBPACK_IMPORTED_MODULE_4__Basic_BasicIconButton__["a" /* default */])(_Remove);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(_Approve, '_Approve', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/ManageButtons.jsx');
    reactHotLoader.register(Approve, 'Approve', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/ManageButtons.jsx');
    reactHotLoader.register(_Reject, '_Reject', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/ManageButtons.jsx');
    reactHotLoader.register(Reject, 'Reject', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/ManageButtons.jsx');
    reactHotLoader.register(_Remove, '_Remove', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/ManageButtons.jsx');
    reactHotLoader.register(Remove, 'Remove', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/ManageButtons.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Basic_BasicSelector__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcIndexPage__ = __webpack_require__(132);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function Via(_ref) {
    var via = _ref.via,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex;

    var vias = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__TcIndexPage__["g" /* ViasContext */]);

    var selectVesselType = function selectVesselType(_id) {
        changeFieldsMultiple([{
            index: countIndex,
            field: 'via',
            value: vias.find(function (t) {
                return t._id === _id;
            })
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Basic_BasicSelector__["a" /* default */], {
        value: via && via._id,
        dataList: vias,
        onChange: function onChange(e, _i, value) {
            return selectVesselType(value);
        },
        iconStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '10px' },
        labelStyle: { padding: 0, top: 'unset' },
        fields: ['name']
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Via);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Via, 'Via', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Via.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/Via.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Filters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_common_PortsAutoComplete__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Basic_BasicCheckBox__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Basic_BasicSelector__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RowData_AddUpdateButtons__ = __webpack_require__(3512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TcIndexPage__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(205);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













function Filters(_ref) {
    var filters = _ref.filters,
        changeFilters = _ref.changeFilters,
        clearFilters = _ref.clearFilters;

    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__TcIndexPage__["f" /* VesselDwtTypesContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        clear = _useState2[0],
        setClear = _useState2[1];

    var maxDate = new Date();

    var selectVessel = function selectVessel(vessel) {
        changeFilters({ vesselId: vessel._id });
    };

    var selectVesselType = function selectVesselType(vesselDwtGroup) {
        changeFilters({ vesselDwtGroup: vesselDwtGroup });
    };

    var selectPort = function selectPort(field, val) {
        changeFilters(_defineProperty({}, field, val._id));
    };

    var handleChangeDate = function handleChangeDate(field, val) {
        changeFilters(_defineProperty({}, field, val));
    };

    var handleChangeConfirmed = function handleChangeConfirmed(val) {
        changeFilters({ confirmed: val });
    };

    var _clearFilters = function _clearFilters() {
        clearFilters();
        setClear(true);
    };

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'item', style: { marginRight: '10px' } },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__["a" /* default */], {
                        selectValue: selectVessel,
                        hintText: 'Vessel',
                        shouldClearCustomValue: clear
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-3' },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Basic_BasicSelector__["a" /* default */], {
                        value: filters.vesselDwtGroup,
                        dataList: vesselDwtTypes.filter(function (v) {
                            return v.name;
                        }),
                        hintText: 'Vessel Type',
                        onChange: function onChange(e, _i, value) {
                            return selectVesselType(value);
                        },
                        style: { fontSize: '13px', height: '48px' },
                        labelStyle: { padding: 0, top: 'unset' },
                        floatingLabelStyle: { top: '14px' },
                        fields: ['name']
                    })
                ),
                [{ field: 'regionFrom', hintText: 'Region From' }, { field: 'regionTo', hintText: 'Region To' }].map(function (v, i) {
                    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components_common_PortsAutoComplete__["a" /* default */], {
                            key: v.field + '_' + i,
                            customValue: filters[v.field] ? filters[v.field].name : '',
                            shouldClearCustomValue: clear,
                            handleChangeCustomValue: function handleChangeCustomValue() {},
                            selectValue: function selectValue(e) {
                                return selectPort(v.field, e);
                            },
                            floatingLabelStyle: { display: 'none' },
                            hintText: v.hintText,
                            inputStyle: { fontSize: '10px' },
                            style: { top: 'unset' },
                            menuStyle: { width: '300px' },
                            popoverProps: {
                                style: { width: '300px' }
                            },
                            textFieldStyle: { height: '48px' },
                            withAreas: true,
                            mainRegions: true,
                            onlyAreas: true,
                            isInBalticIndex: true
                        })
                    );
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            { className: 'item' },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: 'row' },
                [{ field: 'lay', hintText: 'Lay' }, { field: 'can', hintText: 'Can' }].map(function (v, i) {
                    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2', key: v.field + '_' + i },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["e" /* DatePicker */], {
                            autoOk: true,
                            maxDate: v.field === 'lay' ? filters.can ? new Date(filters.can) : maxDate : null,
                            minDate: v.field === 'can' ? filters.lay ? new Date(filters.lay) : undefined : null,
                            onChange: function onChange(_, date) {
                                v.field === 'lay' && handleChangeDate(v.field, __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).utcOffset(0, true));
                                v.field === 'can' && handleChangeDate(v.field, __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).utc().endOf('day').add(1, 'day'));
                            },
                            value: filters[v.field] ? Object(__WEBPACK_IMPORTED_MODULE_2_helpers_dates__["a" /* fromUTC */])(filters[v.field]) : undefined,
                            inputStyle: { fontSize: '13px', cursor: 'pointer', textAlign: 'center' },
                            textFieldStyle: { width: 'unset' },
                            hintText: v.hintText,
                            hintStyle: { fontSize: '13px' }
                        })
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Basic_BasicCheckBox__["a" /* default */], {
                        label: 'Not confirmed',
                        labelStyle: { fontSize: '10px', width: '100%' },
                        iconStyle: { marginRight: 0 },
                        style: { paddingTop: '15px' },
                        checked: !filters.confirmed,
                        handleChange: function handleChange(c) {
                            return handleChangeConfirmed(!c);
                        }
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-2' },
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["r" /* RaisedButton */], {
                        label: 'Clear',
                        labelStyle: { fontSize: '13px' },
                        style: _extends({}, __WEBPACK_IMPORTED_MODULE_10__styles__["a" /* default */].buttons.style),
                        onClick: _clearFilters
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RowData_AddUpdateButtons__["a" /* default */], {
                    style: _extends({}, __WEBPACK_IMPORTED_MODULE_10__styles__["a" /* default */].buttons.style),
                    labelStyle: _extends({}, __WEBPACK_IMPORTED_MODULE_10__styles__["a" /* default */].buttons.labelStyle)
                })
            )
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Filters, 'Filters', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Filters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcIndexPage__ = __webpack_require__(132);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function AddUpdateButtons(_ref) {
    var style = _ref.style,
        labelStyle = _ref.labelStyle;

    var addUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__TcIndexPage__["a" /* AddUpdateContext */]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                label: 'Add',
                onClick: addUpdate.addRow,
                primary: true,
                style: style,
                labelStyle: labelStyle
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                label: 'Update',
                onClick: addUpdate.updateRows,
                secondary: true,
                style: style,
                labelStyle: labelStyle
            })
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(AddUpdateButtons);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AddUpdateButtons, 'AddUpdateButtons', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/AddUpdateButtons.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/RowData/AddUpdateButtons.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = getTcHireIdeas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__ = __webpack_require__(11);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



// export function postRequestTC(tcRequest, index) {
//     return {
//         type: actionTypes.POST_TC_REQUEST.REQUEST,
//         tcRequest,
//         index
//     };
// }

function getTcHireIdeas(filter) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0_constants_ActionTypes__["_50" /* GET_TC_INDEXES */].REQUEST,
        filter: filter
    };
}

// export function deleteRequestTC(tcRequestId) {
//     return {
//         type: actionTypes.DELETE_TC_REQUEST.REQUEST,
//         tcRequestId,
//     };
// }

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(getTcHireIdeas, 'getTcHireIdeas', '/opt/atlassian/pipelines/agent/build/client/app/actions/tc/indexes.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Misc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_query__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_more_vert__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_more_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_more_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_tc_indexes__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TcIndex__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_misc__ = __webpack_require__(3515);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











/**
 * @typedef {Object} Filters
 * @property {string} [refNo]
 * @property {string} [vesselName]
 * @property {string} [vesselType]
 * @property {string} [vesselDwt]
 * @property {string} [vesselDwtType]
 * @property {string} [vesselOwner]
 * @property {string} [vesselManager]
 */

function Misc(_ref) {
    var _this = this;

    var filters = _ref.filters;

    var addNotification = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__TcIndex__["a" /* NotificationContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isQueryEnabled = _useState2[0],
        setIsQueryEnabled = _useState2[1];

    var _useQuery = Object(__WEBPACK_IMPORTED_MODULE_1_react_query__["useQuery"])(['exportData', filters], function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5_services_tc_indexes__["b" /* exportTcIndexes */])(filters);
    }, { enabled: isQueryEnabled }),
        refetch = _useQuery.refetch;

    var exportToExcel = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _ref3, data, error, transformedData, sheet, columnWidths, range, R, C, cellAddress, cellRef, book, excelBuffer, blob, url, a;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setIsQueryEnabled(true);

                            _context.next = 3;
                            return refetch();

                        case 3:
                            _ref3 = _context.sent;
                            data = _ref3.data;
                            error = _ref3.error;

                            if (!error) {
                                _context.next = 9;
                                break;
                            }

                            addNotification(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* notifications */].error('Could not generate export file.'));
                            return _context.abrupt('return');

                        case 9:
                            if (!(!data || data.errors && data.errors.length)) {
                                _context.next = 12;
                                break;
                            }

                            addNotification(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* notifications */].error('Could not generate export file.'));
                            return _context.abrupt('return');

                        case 12:
                            transformedData = transformArray(data.data);
                            sheet = __WEBPACK_IMPORTED_MODULE_4_xlsx__["utils"].json_to_sheet(transformedData, {
                                cellStyles: true
                            });
                            columnWidths = transformedData.reduce(function (acc, row) {
                                Object.keys(row).forEach(function (key) {
                                    var cellValue = row[key];
                                    var cellLength = String(cellValue).length;
                                    acc[key] = Math.max(acc[key] || 0, cellLength);
                                });
                                return acc;
                            }, {});


                            sheet['!cols'] = Object.keys(columnWidths).map(function (key) {
                                return {
                                    wch: Math.max(columnWidths[key], key.length),
                                    style: { alignment: { horizontal: 'left', wrapText: true } }
                                };
                            });

                            range = __WEBPACK_IMPORTED_MODULE_4_xlsx__["utils"].decode_range(sheet['!ref']);
                            R = range.s.r;

                        case 18:
                            if (!(R <= range.e.r)) {
                                _context.next = 34;
                                break;
                            }

                            C = range.s.c;

                        case 20:
                            if (!(C <= range.e.c)) {
                                _context.next = 31;
                                break;
                            }

                            cellAddress = { c: C, r: R };
                            cellRef = __WEBPACK_IMPORTED_MODULE_4_xlsx__["utils"].encode_cell(cellAddress);

                            if (sheet[cellRef]) {
                                _context.next = 25;
                                break;
                            }

                            return _context.abrupt('continue', 28);

                        case 25:

                            if (!sheet[cellRef].s) sheet[cellRef].s = {};
                            sheet[cellRef].s.alignment = {
                                horizontal: 'left',
                                wrapText: true
                            };

                            if (typeof sheet[cellRef].v === 'number') {
                                sheet[cellRef].z = '@';
                            }

                        case 28:
                            ++C;
                            _context.next = 20;
                            break;

                        case 31:
                            ++R;
                            _context.next = 18;
                            break;

                        case 34:
                            book = __WEBPACK_IMPORTED_MODULE_4_xlsx__["utils"].book_new();

                            __WEBPACK_IMPORTED_MODULE_4_xlsx__["utils"].book_append_sheet(book, sheet, 'Sheet1');
                            excelBuffer = __WEBPACK_IMPORTED_MODULE_4_xlsx__["write"](book, { bookType: 'xlsx', type: 'array' });
                            blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            url = URL.createObjectURL(blob);
                            a = document.createElement('a');

                            a.href = url;
                            a.download = 'TC Indexes.xlsx';
                            a.click();
                            URL.revokeObjectURL(url);
                            setIsQueryEnabled(false);

                        case 45:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function exportToExcel() {
            return _ref2.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui__["i" /* IconMenu */],
        {
            disableAutoFocus: true,
            iconButtonElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["h" /* IconButton */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_more_vert___default.a, null)
            ),
            anchorOrigin: { horizontal: 'left', vertical: 'top' },
            targetOrigin: { horizontal: 'left', vertical: 'top' },
            style: { display: 'flex', alignItems: 'center' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["m" /* MenuItem */], {
            primaryText: 'Export',
            onClick: exportToExcel,
            style: {
                margin: '6px 10px',
                fontSize: '13px',
                textAlign: 'center',
                color: 'white',
                backgroundColor: '#FF4081'
            }
        })
    );
}

function transformArray(array) {
    return array.map(function (obj) {
        var mapKeys = Array.from(__WEBPACK_IMPORTED_MODULE_8_constants_misc__["a" /* tcIndexFieldsMapping */].keys());

        var transformedEntries = mapKeys.map(function (key) {
            var field = __WEBPACK_IMPORTED_MODULE_8_constants_misc__["a" /* tcIndexFieldsMapping */].get(key);
            var value = obj[key];

            if (field.isBoolean) {
                value = obj[key] ? 'Yes' : 'No';
            }

            return [field.placeHolder, value];
        });

        return Object.fromEntries(transformedEntries);
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Misc, 'Misc', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Misc.jsx');
    reactHotLoader.register(transformArray, 'transformArray', '/opt/atlassian/pipelines/agent/build/client/app/components/TcIndex/Misc.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tcIndexFieldsMapping; });
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var tcIndexFieldsMapping = new Map([['index.name', { placeHolder: 'Index name' }], ['vessel.imoNumber', { placeHolder: 'Imo number' }], ['vessel.name', { placeHolder: 'Name' }], ['typeByPurpose', { placeHolder: 'Type by Purpose' }], ['vesselDwtGroup.name', { placeHolder: 'Dwt group' }], ['vesselDwtGroup.min', { placeHolder: 'Dwt group (min)' }], ['vesselDwtGroup.max', { placeHolder: 'Dwt group (max)' }], ['placeFrom.name', { placeHolder: 'Place from' }], ['regionFrom.name', { placeHolder: 'Region from' }], ['regionFrom.mainRegion', { placeHolder: 'Region from (main region)', isBoolean: true }], ['regionFrom.isInBalticIndex', { placeHolder: 'Region from (baltic index)', isBoolean: true }], ['placeTo.name', { placeHolder: 'Place to' }], ['regionTo.name', { placeHolder: 'Region to' }], ['regionTo.mainRegion', { placeHolder: 'Region to (main region)', isBoolean: true }], ['regionTo.isInBalticIndex', { placeHolder: 'Region to (baltic index)', isBoolean: true }], ['lay', { placeHolder: 'Lay' }], ['can', { placeHolder: 'Can' }], ['via.name', { placeHolder: 'Via' }], ['roundTrip', { placeHolder: 'Round trip', isBoolean: true }], ['clean', { placeHolder: 'Clean', isBoolean: true }], ['duration', { placeHolder: 'Duration' }], ['balastBonus', { placeHolder: 'Balast bonus' }], ['intake', { placeHolder: 'Intake' }], ['tcIndex', { placeHolder: 'Tc Index' }],
// ['rejected', { placeHolder: 'Rejected' }],
['endAt', { placeHolder: 'End at' }], ['lastUpdate.user.email', { placeHolder: 'Last update by' }], ['lastUpdate.date', { placeHolder: 'Last update' }], ['confirmed', { placeHolder: 'Confirmed', isBoolean: true }]]);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(tcIndexFieldsMapping, 'tcIndexFieldsMapping', '/opt/atlassian/pipelines/agent/build/client/app/constants/misc.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add_circle_outline__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_miscellaneous__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss__ = __webpack_require__(3517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_scss__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











function Mailers(_ref) {
    var userId = _ref.userId;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        mailers = _useState2[0],
        setMailers = _useState2[1];

    var handleAddMailer = function handleAddMailer() {
        Object(__WEBPACK_IMPORTED_MODULE_6_helpers_miscellaneous__["b" /* postRegularForm */])('/api/v1/users/mailGates/fromTemplate/gmail', { userId: userId, isA: true }, '_self');
    };

    var getMailers = function getMailers() {
        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].getInternalMailers().then(function (response) {
            setMailers(response.data);
        });
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        getMailers();
    }, []);

    /**
     * @param {string} id 
     */
    var removeMailer = function removeMailer(id) {
        __WEBPACK_IMPORTED_MODULE_7_services__["a" /* default */].removeInternalMailer(id).then(function () {
            return getMailers();
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-page' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Mailers'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                        label: 'Add Mailer Google',
                        onClick: handleAddMailer,
                        primary: true
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["u" /* Table */],
                { selectable: false },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["w" /* TableHeader */],
                    {
                        displaySelectAll: false,
                        adjustForCheckbox: false,
                        className: 'mailer-table-header'
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                            null,
                            'Receiver'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                            null,
                            'Enabled'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                            null,
                            'Expire time'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                            null,
                            'Last update'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                            null,
                            null
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["v" /* TableBody */],
                    {
                        displayRowCheckbox: false,
                        className: 'mailer-table-body'
                    },
                    mailers.map(function (mailer) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2_material_ui__["y" /* TableRow */],
                            {
                                key: mailer._id
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                                null,
                                mailer.receiver.username
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                                null,
                                mailer.enabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_content_add_circle_outline___default.a, { color: 'green' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_remove_circle_outline___default.a, { color: 'red' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_1_moment___default()(mailer.auth.expires).format('MMMM Do YYYY, h:mm:ss a')
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_1_moment___default()(mailer.updatedAt).format('MMMM Do YYYY, h:mm:ss a')
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["r" /* RaisedButton */], {
                                    label: 'Delete',
                                    onClick: function onClick() {
                                        return removeMailer(mailer._id);
                                    },
                                    secondary: true
                                })
                            )
                        );
                    })
                )
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function (_ref2) {
    var user = _ref2.user;
    return {
        userId: user.user._id
    };
}, {})(Mailers);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Mailers, 'Mailers', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/mailers/Mailers.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Analytics/mailers/Mailers.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128525
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Topics__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Status__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__List__ = __webpack_require__(990);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








function IssueItem(_ref) {
    var issue = _ref.issue,
        handleChangeIssue = _ref.handleChangeIssue,
        index = _ref.index;

    var user = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__List__["a" /* UserContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isMine = _useState2[0],
        setIsMine = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (issue.status === 'new' || issue.statusBy && user.email === issue.statusBy.email || !issue.statusBy) {
            setIsMine(true);
        } else {
            setIsMine(false);
        }
    }, [issue]);

    /**
     * @param {string} status 
     */
    var handleChangeStatus = function handleChangeStatus(status) {
        handleChangeIssue(index, { status: status, _id: issue._id });
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        {
            className: 'issues-list-item ' + (!isMine ? 'isNotMine' : '')
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'TOPICS:'
                ),
                ' ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Topics__["a" /* default */], { topics: issue.topics })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'REPORTER:'
                ),
                ' ',
                issue.addedBy.email
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'DATE:'
                ),
                ' ',
                Object(__WEBPACK_IMPORTED_MODULE_0_helpers_dates__["a" /* fromUTC */])(issue.addedAt).toLocaleString()
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'refNo: ',
                    issue.refNo
                )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'STATUS:'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Status__["a" /* default */], {
                    status: issue.status,
                    handleChangeStatus: handleChangeStatus
                })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'UPDATED:'
                ),
                issue.statusAt ? new Date(issue.statusAt).toLocaleString() : null
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inner-item' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'title' },
                    'BY USER:'
                ),
                issue.statusBy ? issue.statusBy.email : null
            )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'column' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */],
                { to: issue._id, target: '_blank' },
                'OPEN'
            )
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(IssueItem);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(IssueItem, 'IssueItem', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/IssueItem.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/List/IssueItem.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_issues__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IssueManagement__ = __webpack_require__(3520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sidebar__ = __webpack_require__(3526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_socket__ = __webpack_require__(515);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











function Issue(props) {
    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState2 = _slicedToArray(_useState, 2),
        issue = _useState2[0],
        setIssue = _useState2[1];

    var issueRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(issue);

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
        // trigger capture any issue change (run on every rerender)
        // that prevent keeping old issues state 
        issueRef.current = issue;
    });

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var getIssueData = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                props.getIssue(props.routeParams.id);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function getIssueData() {
                return _ref.apply(this, arguments);
            };
        }();

        getIssueData();
    }, []);

    var messageHandler = function messageHandler(message, issueCurrent) {
        var id = message.id,
            status = message.status,
            statusHistory = message.statusHistory,
            user = message.user;


        if (issueCurrent._id === id) {
            setIssue(_extends({}, issueCurrent, {
                status: status,
                statusHistory: statusHistory,
                statusBy: user
            }));
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var socket = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_socket__["a" /* getSocketconnection */])({ userId: props.user._id });

        var handler = function handler(message) {
            return messageHandler(message, issueRef.current);
        };

        socket.on('admin:newIssueChanges', handler);
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setIssue(props.issue);
    }, [props.issue]);

    var handleChangeIssue = function handleChangeIssue(_ref2) {
        var _id = _ref2._id,
            status = _ref2.status;

        props.updateIssueStatus(_id, status);
        setIssue(_extends({}, issue, {
            status: status
        }));
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'issue-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__IssueManagement__["a" /* default */], { issue: issue, handleChangeIssue: handleChangeIssue })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'sidebar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Sidebar__["a" /* default */], { issue: issue, user: props.user })
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (_ref3) {
    var issue = _ref3.issue,
        user = _ref3.user.user;
    return {
        isLoaded: issue && issue.isLoaded,
        issue: issue,
        user: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pick(user, ['_id', 'email'])
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({
        getIssue: __WEBPACK_IMPORTED_MODULE_5_actions_issues__["c" /* getIssue */],
        updateIssueStatus: __WEBPACK_IMPORTED_MODULE_5_actions_issues__["f" /* updateIssueStatus */]
    }, dispatch);
})(Issue));

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Issue, 'Issue', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/Issue.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/Issue.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = IssueManagement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List_Status__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List_Topics__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TextDisplayer__ = __webpack_require__(3521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Attachments__ = __webpack_require__(3522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__History__ = __webpack_require__(3523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__comments_Comments__ = __webpack_require__(3524);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();












function IssueManagement(_ref) {
    var _issue = _ref.issue,
        handleChangeIssue = _ref.handleChangeIssue;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        historyOpen = _useState2[0],
        setHistoryOpen = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState4 = _slicedToArray(_useState3, 2),
        issue = _useState4[0],
        setIssue = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setIssue(_extends({}, _issue));
    }, [_issue]);

    var handleChangeStatus = function handleChangeStatus(newStatus) {
        handleChangeIssue({ _id: issue._id, status: newStatus });
    };

    var handleHistoryOpen = function handleHistoryOpen() {
        setHistoryOpen(!historyOpen);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'management' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__History__["a" /* default */], {
            open: historyOpen,
            handleHistoryOpen: handleHistoryOpen,
            history: issue.statusHistory
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'management-children' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'info-basic' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'nonChange' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'ref' },
                        'Ref: ',
                        issue.refNo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1_material_ui_IconButton___default.a,
                        {
                            onClick: function onClick() {
                                return setHistoryOpen(!historyOpen);
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_history___default.a, {
                            style: { padding: '8px' },
                            color: '#b3b3b3'
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        'Reporter: ',
                        issue.addedBy && issue.addedBy.email
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'change' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__List_Status__["a" /* default */], {
                        className: 'status',
                        style: { height: '20px' },
                        handleChangeStatus: handleChangeStatus,
                        status: issue.status
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'info-topics' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'name' },
                    'TOPICS: '
                ),
                issue.topics ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__List_Topics__["a" /* default */], { topics: issue.topics }) : null
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TextDisplayer__["a" /* default */], { text: issue.text || '' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Attachments__["a" /* default */], { attachments: issue.attachments || [] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__comments_Comments__["a" /* default */], null)
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(IssueManagement, 'IssueManagement', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/IssueManagement.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = TextDisplayer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



function TextDisplayer(_ref) {
    var text = _ref.text;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'text' },
        text
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TextDisplayer, 'TextDisplayer', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/TextDisplayer.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Attachments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_file_download__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_file_download__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function Attachments(_ref) {
    var attachments = _ref.attachments;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'attachments' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'name' },
            'Attachments'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list' },
            attachments && attachments.map(function (attachment) {
                var url = '/api/v1/file/' + attachment._id;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'item', key: attachment._id, href: url, download: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_file_file_download___default.a, { className: 'icon', color: '#757575' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'name' },
                        attachment.name
                    )
                );
            })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Attachments, 'Attachments', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/Attachments.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = History;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Analytics_RangeDates__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List_Status__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();










/**
 * 
 * @param {{
 *  open: boolean,
 *  handleHistoryOpen: React.MouseEventHandler,
 *  history: HistoryEvent[]
 * }} param0 
 * @returns 
 */
function History(_ref) {
    var _ref$open = _ref.open,
        open = _ref$open === undefined ? false : _ref$open,
        handleHistoryOpen = _ref.handleHistoryOpen,
        _history = _ref.history;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState2 = _slicedToArray(_useState, 2),
        history = _useState2[0],
        setHistory = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        filtered = _useState4[0],
        setFiltered = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState6 = _slicedToArray(_useState5, 2),
        from = _useState6[0],
        setFrom = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState8 = _slicedToArray(_useState7, 2),
        until = _useState8[0],
        setUntil = _useState8[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var copy = _history ? __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(_history) : [];
        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.reverse(copy);
        setHistory(copy);
        setFiltered(copy);
    }, [_history]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var preFiltered = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.cloneDeep(filtered);

        if (from) {
            preFiltered = preFiltered.filter(function (f) {
                return new Date(f.statusAt).getTime() > from.valueOf();
            });
        }

        if (until) {
            preFiltered = preFiltered.filter(function (f) {
                return new Date(f.statusAt).getTime() < until.valueOf();
            });
        }

        if (!from && !until) {
            preFiltered = history;
        }

        setFiltered(preFiltered);
    }, [from, until]);

    /**
     * @param {'from' | 'until'} type 
     * @param {Date} value
     */
    var changeDateRange = function changeDateRange(type, value) {
        if (type === 'from') {
            setFrom(value);
        } else {
            setUntil(value);
        }
    };

    /**
     * @param {'from' | 'until'} type 
     */
    var handleChangeDate = function handleChangeDate(type) {
        if (type === 'from') {
            setFrom(null);
        } else {
            setUntil(null);
        }
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_material_ui_Dialog___default.a,
        {
            title: 'HISTORY',
            open: open,
            onRequestClose: handleHistoryOpen,
            actions: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_FlatButton___default.a, {
                label: 'Close',
                primary: true,
                onClick: handleHistoryOpen
            })]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'historyFilter' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Analytics_RangeDates__["a" /* default */], {
                from: from,
                until: until,
                changeDateRange: changeDateRange,
                handleChangeDate: handleChangeDate
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { id: 'historyList' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_material_ui__["u" /* Table */],
                {
                    className: 'table',
                    fixedHeader: true,
                    height: '400px'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["w" /* TableHeader */],
                    { displaySelectAll: false, adjustForCheckbox: false, style: { borderBottom: 'none' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                        { width: '29%', style: { padding: 0, height: '15px' } },
                        'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                        { width: '47%', style: { padding: 0, height: '15px' } },
                        'By user'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_material_ui__["x" /* TableHeaderColumn */],
                        { width: '24%', style: { padding: 0, height: '15px' } },
                        'Date'
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["v" /* TableBody */],
                    {
                        displayRowCheckbox: false,
                        className: 'historyList-body',
                        showRowHover: true
                    },
                    (filtered || []).map(function (event) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_material_ui__["y" /* TableRow */],
                            { key: event._id },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
                                { style: { fontSize: '12px', width: '29%', padding: 0 } },
                                __WEBPACK_IMPORTED_MODULE_6__List_Status__["b" /* statuses */][event.status].chip
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
                                { style: { fontSize: '12px', width: '47%', padding: 0 } },
                                event.statusBy.email
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_material_ui__["z" /* TableRowColumn */],
                                { style: { fontSize: '12px', width: '24%', padding: 0 } },
                                __WEBPACK_IMPORTED_MODULE_5_moment___default()(event.statusAt).format('DD.MM.YYYY hh:mm:ss').toString()
                            )
                        );
                    })
                )
            )
        )
    );
}

/**
 * @typedef {Object} HistoryEvent
 * @property {string} _id
 * @property {string} status
 * @property {string} statusAt
 * @property {{ email: string }} statusBy
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(History, 'History', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/History.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Comment__ = __webpack_require__(3525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_issues__ = __webpack_require__(581);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();









/**
 * 
 * @param {{
 *  comments: Comment[],
 * }} param0 
 * @returns 
 */
function Comments(_ref) {
    var issue = _ref.issue,
        addIssueComment = _ref.addIssueComment,
        deleteIssueComment = _ref.deleteIssueComment,
        updateIssueComment = _ref.updateIssueComment,
        user = _ref.user;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(issue.comments || []),
        _useState2 = _slicedToArray(_useState, 2),
        comments = _useState2[0],
        setComments = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState4 = _slicedToArray(_useState3, 2),
        newComment = _useState4[0],
        setNewComment = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState6 = _slicedToArray(_useState5, 2),
        commentInEditMode = _useState6[0],
        setCommentInEditMode = _useState6[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setComments(issue.comments);
    }, [issue.comments]);

    var addComment = function addComment() {
        if (!newComment) return;
        addIssueComment(issue._id, { text: newComment });
        setNewComment('');
    };

    var deleteComment = function deleteComment(commentId) {
        deleteIssueComment(issue._id, commentId);
    };

    var handleCommentInput = function handleCommentInput(value) {
        setNewComment(value);
    };

    /**
     * @param {Comment} comment 
     */
    var toggleEditMode = function toggleEditMode(comment) {
        setCommentInEditMode(comment);
        setNewComment(comment.text);
    };

    var cancelEditMode = function cancelEditMode() {
        setCommentInEditMode(null);
        setNewComment('');
    };

    var handleEditComment = function handleEditComment() {
        updateIssueComment(issue._id, commentInEditMode._id, { text: newComment });
        setCommentInEditMode(null);
        setNewComment('');
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            className: 'comments'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'input' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["A" /* TextField */], {
                    hintText: 'Comment',
                    value: newComment,
                    fullWidth: true,
                    multiLine: true,
                    underlineShow: false,
                    rows: 2,
                    onChange: function onChange(e) {
                        return handleCommentInput(e.target.value);
                    },
                    style: { height: '56px', fontSize: '13px', lineHeight: '19.5px' },
                    hintStyle: { marginTop: 'unset', bottom: 'unset', fontSize: '13px' },
                    textareaStyle: { marginTop: 'unset', marginBottom: 'unset', height: '56px' }
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'button' },
                commentInEditMode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                        label: 'Edit',
                        onClick: handleEditComment,
                        primary: true,
                        disabled: !newComment
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                        className: 'cancel',
                        label: 'Cancel',
                        buttonStyle: { backgroundColor: '#FFFAF0' },
                        onClick: cancelEditMode,
                        primary: true
                    })
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                    label: 'Send',
                    onClick: addComment,
                    primary: true,
                    disabled: !newComment
                })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list' },
            comments.map(function (comment) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Comment__["a" /* default */], {
                    key: comment._id,
                    comment: comment,
                    deleteComment: deleteComment,
                    isInEditMode: (commentInEditMode || {})._id === comment._id,
                    toggleEditMode: toggleEditMode,
                    canEditOrDelete: user._id === comment.addedBy._id
                });
            })
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_ref2) {
    var issue = _ref2.issue,
        user = _ref2.user.user;

    return {
        isLoaded: issue && issue.isLoaded,
        issue: _extends({}, issue, { comments: issue.comments || [] }),
        comments: issue.comments || [],
        user: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.pick(user, ['_id', 'email'])
    };
}, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])({
        getIssue: __WEBPACK_IMPORTED_MODULE_6_actions_issues__["c" /* getIssue */],
        addIssueComment: __WEBPACK_IMPORTED_MODULE_6_actions_issues__["a" /* addIssueComment */],
        deleteIssueComment: __WEBPACK_IMPORTED_MODULE_6_actions_issues__["b" /* deleteIssueComment */],
        updateIssueComment: __WEBPACK_IMPORTED_MODULE_6_actions_issues__["e" /* updateIssueComment */]
    }, dispatch);
})(Comments);

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * @typedef {Object} Comment
 * @property {string} _id
 * @property {string} text
 * @property {Date} addedAt
 * @property {AddedBy} addedBy
 */

/**
 * @typedef {Object} AddedBy
 * @property {string} _id
 * @property {string} email
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Comments, 'Comments', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/comments/Comments.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/comments/Comments.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Comment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_create__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






/**
 * 
 * @param {{
 *  comment: import('./Comments').Comment,
 *  deleteComment: Function,
 *  isInEditMode: boolean,
 *  toggleEditMode: Function,
 *  canEditOrDelete: boolean,
 * }} param0 
 * @returns 
 */
function Comment(_ref) {
    var _comment = _ref.comment,
        deleteComment = _ref.deleteComment,
        isInEditMode = _ref.isInEditMode,
        toggleEditMode = _ref.toggleEditMode,
        canEditOrDelete = _ref.canEditOrDelete;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_comment),
        _useState2 = _slicedToArray(_useState, 2),
        comment = _useState2[0],
        setComment = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setComment(_comment);
    }, [_comment]);

    var handleToggleEditMode = function handleToggleEditMode() {
        toggleEditMode(comment);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'comment ' + (isInEditMode ? 'isInEditMode' : '') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'comment-control' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'control-info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'email' },
                    comment.addedBy && comment.addedBy.email
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'date' },
                    __WEBPACK_IMPORTED_MODULE_3_moment___default()(comment.addedAt).format('DD.MM.YYYY hh:mm:ss')
                )
            ),
            canEditOrDelete ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'control-buttons' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_content_create___default.a, {
                    color: isInEditMode ? '#00BCD4' : '#EAEAEA',
                    style: { cursor: 'pointer' },
                    onClick: handleToggleEditMode
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_delete___default.a, {
                    color: '#EAEAEA',
                    style: { cursor: 'pointer' },
                    onClick: function onClick() {
                        return deleteComment(comment._id);
                    }
                })
            ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'comment-text' },
            comment.text
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Comment, 'Comment', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/comments/Comment.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_upward__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_upward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_upward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_content_copy__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_content_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_content_copy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(3527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * 
 * @param {string} redirectUrl 
 * @param {string} userId 
 */
var loginInNewPage = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(redirectUrl, userId) {
        var session, link, form;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_6_helpers__["a" /* default */].prepareOneTimeAuthSession(userId);

                    case 2:
                        session = _context.sent;
                        link = "https://shipnext.com" + '/api/v1/auth/loginAs?key=' + session.key + '&&redirect=' + redirectUrl;
                        form = document.createElement('form');

                        form.method = 'POST';
                        form.action = link;
                        form.target = '_blank';

                        document.body.appendChild(form);

                        form.submit();
                        form.remove();

                    case 11:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loginInNewPage(_x, _x2) {
        return _ref4.apply(this, arguments);
    };
}();

/**
 * @param {{ 
 *  value?: string, 
 *  element: { label: string, canOpenOnMain?: boolean, getUrl: (_id: string) => string },
 *  _id?: string,
 *  user?: { _id: string, email: string }
 * }} props 
 */


(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









function Sidebar(_ref) {
    var issue = _ref.issue,
        user = _ref.user;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState2 = _slicedToArray(_useState, 2),
        userElements = _useState2[0],
        setUserElements = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
        _useState4 = _slicedToArray(_useState3, 2),
        systemElements = _useState4[0],
        setSystemElements = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* elementsMapping */]),
        _useState6 = _slicedToArray(_useState5, 2),
        elementsMapping = _useState6[0],
        _e = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_6_helpers__["a" /* default */].isDevAllowed(user.email)),
        _useState8 = _slicedToArray(_useState7, 2),
        hasUserPrivileges = _useState8[0],
        _s = _useState8[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        issue.userElements && setUserElements(issue.userElements);
        issue.systemElements && setSystemElements(issue.systemElements);
    }, [issue]);

    var renderElements = function renderElements(elements) {
        var rows = [];

        Object.entries(elements).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];

            value.forEach(function (item) {
                if (typeof item === 'string') {
                    rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, {
                        key: item,
                        value: item,
                        element: elementsMapping[key]
                    }));
                } else {
                    var refNo = item.refNo,
                        imoNumber = item.imoNumber,
                        _id = item._id;

                    rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, {
                        key: _id,
                        _id: elementsMapping[key].customId && item[elementsMapping[key].customId] || _id,
                        value: refNo || imoNumber || _id,
                        element: elementsMapping[key],
                        user: issue.addedBy
                    }));
                }
            });
        });

        return rows;
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_material_ui__["n" /* Paper */],
            {
                className: 'elements',
                zDepth: 1
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { id: 'block-name' },
                'Elements'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'elements-list' },
                renderElements(userElements),
                renderElements(systemElements)
            )
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Sidebar);

/* harmony default export */ __webpack_exports__["a"] = (_default);function Row(_ref5) {
    var _ref5$element = _ref5.element,
        label = _ref5$element.label,
        canOpenOnMain = _ref5$element.canOpenOnMain,
        getUrl = _ref5$element.getUrl,
        value = _ref5.value,
        _id = _ref5._id,
        user = _ref5.user;

    var hasUrl = Boolean(getUrl);

    var onClick = function onClick() {
        var redirectUrl = getUrl(_id);

        if (canOpenOnMain) {
            return loginInNewPage(redirectUrl, user._id);
        }

        return window.open(redirectUrl, '_blank');
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
            className: 'elements-list-row'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'elements-list__label' },
            label,
            ': ',
            value,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
                {
                    style: { padding: 0, marginLeft: '10px' },
                    onClick: function onClick() {
                        return navigator.clipboard.writeText(value);
                    },
                    iconStyle: { height: '18px', width: '18px', display: 'flex' }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_content_content_copy___default.a, { className: 'icon-copy', color: '#666666', style: { height: '18px', width: '18px' } })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_IconButton___default.a,
            {
                disabled: !canOpenOnMain,
                className: 'button',
                style: { opacity: hasUrl ? 1 : 0.2 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_upward___default.a, {
                className: 'icon',
                onClick: onClick
            })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Sidebar, 'Sidebar', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/Sidebar.jsx');
    reactHotLoader.register(loginInNewPage, 'loginInNewPage', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/Sidebar.jsx');
    reactHotLoader.register(Row, 'Row', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/Sidebar.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/Sidebar.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return elementsMapping; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers__ = __webpack_require__(28);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();



var mainSiteOrigin =  false ? 'https://test.shipnext.com' : 'https://shipnext.com';

var elementsMapping = {
    cargos: {
        label: 'Cargo ref',
        canOpenOnMain: true,
        getUrl: function getUrl(_id) {
            return mainSiteOrigin + '/main-deck/general/' + _id;
        }
    },
    vessels: {
        label: 'Vessel'
    },
    ais: {
        label: 'Ais'
    },
    snpVessels: {
        label: 'Snp',
        canOpenOnMain: true,
        getUrl: function getUrl(_id) {
            return mainSiteOrigin + '/fleetmonitor/spfleet/' + _id;
        }
    },
    myVessels: {
        label: 'My vessel'
    },
    orders: {
        label: 'Tc',
        canOpenOnMain: true,
        getUrl: function getUrl(_id) {
            return mainSiteOrigin + '/main-deck/tc/' + _id;
        }
    },
    positions: {
        label: 'Position ref',
        canOpenOnMain: true,
        customId: 'vessel',
        getUrl: function getUrl(_id) {
            return mainSiteOrigin + '/main-deck/general/-/' + _id;
        }
    },
    mails: {
        label: 'Email',
        getUrl: function getUrl(_id) {
            return window.location.origin + '/' + _id;
        }
    },
    mailThreads: {
        label: 'Emal thread'
    },
    mailThreadsRefNos: {
        label: 'Email thread ref'
    },
    voyageChartersDocuments: {
        label: 'Voyage Charter Documets'
    },
    timeChartersDocuments: {
        label: 'Time Charter Documets'
    },
    bookingNoteDocuments: {
        label: 'Booking Note Documets'
    },
    billOfLadingDocuments: {
        label: 'Bill of Lading Documets'
    }
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(mainSiteOrigin, 'mainSiteOrigin', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/helpers.js');
    reactHotLoader.register(elementsMapping, 'elementsMapping', '/opt/atlassian/pipelines/agent/build/client/app/components/Issues/Issue/helpers.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = LoginAsPageCustom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginAsPage__ = __webpack_require__(978);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function LoginAsPageCustom(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LoginAsPage__["a" /* LoginAsPage */], {
        customCompanyName: 'varamar'
    });
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(LoginAsPageCustom, 'LoginAsPageCustom', '/opt/atlassian/pipelines/agent/build/client/app/components/LoginAsPage/LoginAsPageCustom.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = Hires;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HiresPage__ = __webpack_require__(169);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function Hires() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'table-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container', style: { width: '90rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Hires'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__HiresPage__["g" /* default */], null)
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Hires, 'Hires', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/Hires.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_VesselAutoComplete__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_dates__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddUpdateButtons__ = __webpack_require__(3531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TcIndex_styles__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_hire__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TcIndex_Basic_BasicSelector__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_PortsAutoCompleteMulti__ = __webpack_require__(3532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_UserAutoComplete__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_vessel__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HiresPage__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_HOC_withClearButton__ = __webpack_require__(954);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















var VesselAutoCompleteWithClearButton = Object(__WEBPACK_IMPORTED_MODULE_14__common_HOC_withClearButton__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__common_VesselAutoComplete__["a" /* default */]);
var UserAutoCompleteWithClearButton = Object(__WEBPACK_IMPORTED_MODULE_14__common_HOC_withClearButton__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__common_UserAutoComplete__["a" /* default */]);
var DatePickerWithClearButton = Object(__WEBPACK_IMPORTED_MODULE_14__common_HOC_withClearButton__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_material_ui__["e" /* DatePicker */]);

/**
 * 
 * @param {{
 *  filters: Filters,
 *  changeFilters: Function,
 *  clearFilters: Function,
 * }} param0 
 * @returns 
 */
function Filters(_ref) {
    var filters = _ref.filters,
        changeFilters = _ref.changeFilters,
        clearFilters = _ref.clearFilters;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        clear = _useState2[0],
        setClear = _useState2[1];

    var maxDate = new Date();
    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__HiresPage__["f" /* VesselDwtTypesContext */]);

    var selectVessel = function selectVessel(vessel) {
        changeFilters({ vesselId: vessel._id });
    };

    var selectHireType = function selectHireType(hireType) {
        changeFilters({ hireType: hireType });
    };

    var selectPort = function selectPort(field, val) {
        changeFilters(_defineProperty({}, field, val.map(function (v) {
            return v._id;
        })));
    };

    var handleChangeDate = function handleChangeDate(field, val) {
        changeFilters(_defineProperty({}, field, val));
    };

    var _clearFilters = function _clearFilters() {
        clearFilters();
        setClear(true);
    };

    var onUserSelected = function onUserSelected(value) {
        changeFilters({
            addedBy: value ? value.item._id : value
        });
    };
    var dwtGroups = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
        return filters.typeByPurpose ? vesselDwtTypes.filter(function (d) {
            return d.typeByPurpose.includes(filters.typeByPurpose);
        }) : [];
    }, [filters.typeByPurpose, vesselDwtTypes]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: { marginRight: '10px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VesselAutoCompleteWithClearButton, {
                            selectValue: selectVessel,
                            hintText: 'Vessel',
                            shouldClearCustomValue: clear,
                            value: filters.vesselId,
                            onClear: function onClear() {
                                changeFilters({ vesselId: undefined });
                                setClear(true);
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TcIndex_Basic_BasicSelector__["a" /* default */], {
                            value: filters.hireType,
                            dataList: __WEBPACK_IMPORTED_MODULE_7__constants_hire__["a" /* HIRE_TYPES_MAP */],
                            hintText: 'Hire type',
                            onChange: function onChange(e, _i, value) {
                                return selectHireType(value);
                            },
                            style: { fontSize: '13px', height: '48px' },
                            labelStyle: { padding: 0, top: 'unset' },
                            floatingLabelStyle: { top: '14px' },
                            iconStyle: { width: '40px' },
                            fields: ['name'],
                            multiple: true,
                            customRender: __WEBPACK_IMPORTED_MODULE_7__constants_hire__["a" /* HIRE_TYPES_MAP */].map(function (item) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], {
                                    key: item.field,
                                    value: item.field,
                                    primaryText: item.placeHolder
                                });
                            }),
                            selectionRenderer: function selectionRenderer(values) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: {
                                            maxWidth: 'calc(100% - 20px)',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }
                                    },
                                    values.map(function (v) {
                                        return __WEBPACK_IMPORTED_MODULE_7__constants_hire__["a" /* HIRE_TYPES_MAP */].find(function (h) {
                                            return h.field === v;
                                        }).placeHolder;
                                    }).join(', ')
                                );
                            }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UserAutoCompleteWithClearButton, {
                            onUserSelected: onUserSelected,
                            hintText: 'Added by (email)',
                            resetInput: clear,
                            value: filters.addedBy,
                            onClear: function onClear() {
                                changeFilters({ addedBy: undefined });
                                setClear(true);
                            }
                        })
                    ),
                    [{ field: 'addedBefore', hintText: 'Added before' }, { field: 'addedAfter', hintText: 'Added After' }].map(function (v, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2', key: v.field + '_' + i },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["e" /* DatePicker */], {
                                autoOk: true,
                                maxDate: function () {
                                    if (v.field === 'lay') {
                                        return filters.can ? new Date(filters.can) : maxDate;
                                    }
                                    return null;
                                }(),
                                minDate: function () {
                                    if (v.field === 'can') {
                                        return filters.lay ? new Date(filters.lay) : undefined;
                                    }
                                    return null;
                                }(),
                                onChange: function onChange(__, date) {
                                    v.field === 'addedAfter' && handleChangeDate(v.field, __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).utcOffset(0, true));
                                    v.field === 'addedBefore' && handleChangeDate(v.field, __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).utc().endOf('day').add(1, 'day'));
                                },
                                value: filters[v.field] ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dates__["a" /* fromUTC */])(filters[v.field]) : undefined,
                                inputStyle: { fontSize: '13px', cursor: 'pointer', textAlign: 'center' },
                                textFieldStyle: { width: 'unset' },
                                hintText: v.hintText,
                                hintStyle: { fontSize: '13px' }
                            })
                        );
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    [{ field: 'lay', hintText: 'Lay' }, { field: 'can', hintText: 'Can' }].map(function (v, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-2', key: v.field + '_' + i },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DatePickerWithClearButton, {
                                key: v.field + '_' + filters[v.field],
                                autoOk: true,
                                maxDate: function () {
                                    if (v.field === 'lay') {
                                        return filters.can ? new Date(filters.can) : undefined;
                                    }
                                    return null;
                                }(),
                                minDate: function () {
                                    if (v.field === 'can') {
                                        return filters.lay ? new Date(filters.lay) : undefined;
                                    }
                                    return null;
                                }(),
                                onChange: function onChange(__, date) {
                                    v.field === 'lay' && handleChangeDate(v.field, __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).utcOffset(0, true));
                                    v.field === 'can' && handleChangeDate(v.field, __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).utc().endOf('day').add(1, 'day'));
                                },
                                value: filters[v.field] ? Object(__WEBPACK_IMPORTED_MODULE_3__helpers_dates__["a" /* fromUTC */])(filters[v.field]) : null,
                                inputStyle: { fontSize: '13px', cursor: 'pointer' },
                                textFieldStyle: { width: 'unset' },
                                hintText: v.hintText,
                                hintStyle: { fontSize: '13px' },
                                clearValue: filters[v.field],
                                onClear: function onClear() {
                                    changeFilters(_defineProperty({}, v.field, undefined));
                                }
                            })
                        );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-2' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                            label: 'Clear',
                            labelStyle: { fontSize: '13px' },
                            style: _extends({}, __WEBPACK_IMPORTED_MODULE_6__TcIndex_styles__["a" /* default */].buttons.style),
                            onClick: _clearFilters
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AddUpdateButtons__["a" /* default */], {
                        style: _extends({}, __WEBPACK_IMPORTED_MODULE_6__TcIndex_styles__["a" /* default */].buttons.style),
                        labelStyle: _extends({}, __WEBPACK_IMPORTED_MODULE_6__TcIndex_styles__["a" /* default */].buttons.labelStyle)
                    })
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item', style: { marginRight: '10px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TcIndex_Basic_BasicSelector__["a" /* default */], {
                            value: filters.vesselDwtGroup ? filters.vesselDwtGroup._id : '',
                            hintText: 'DWT group',
                            dataList: [undefined].concat(_toConsumableArray(dwtGroups)),
                            onChange: function onChange(e, _i, value) {
                                return changeFilters({ vesselDwtGroup: __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.pick(dwtGroups.find(function (d) {
                                        return d._id === value;
                                    }), ['_id', 'min', 'max']) });
                            },
                            style: { fontSize: '13px', height: '48px' },
                            labelStyle: { padding: 0, top: 'unset' },
                            iconStyle: { width: '40px' },
                            fields: ['min', 'max'],
                            disabled: !filters.typeByPurpose
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TcIndex_Basic_BasicSelector__["a" /* default */], {
                            value: filters.typeByConstruction,
                            dataList: __WEBPACK_IMPORTED_MODULE_11_constants_vessel__["a" /* TYPES_BY_CONSTRUCTION */],
                            onChange: function onChange(e, _i, value) {
                                return changeFilters({ typeByConstruction: value });
                            },
                            hintText: 'Type by construction',
                            style: { fontSize: '13px', height: '48px' },
                            labelStyle: { padding: 0, top: 'unset' },
                            iconStyle: { width: '40px' }
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3', style: { paddingLeft: '20px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TcIndex_Basic_BasicSelector__["a" /* default */], {
                            value: filters.geared,
                            dataList: ['', true, false],
                            onChange: function onChange(e, _i, value) {
                                return changeFilters({ geared: value });
                            },
                            hintText: 'Geared',
                            style: { fontSize: '13px', height: '48px' },
                            labelStyle: { padding: 0, top: 'unset' },
                            iconStyle: { width: '40px' },
                            customRender: ['', true, false].map(function (item, index) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], {
                                    key: 'geared_' + index,
                                    value: item === '' ? undefined : item,
                                    primaryText: String(item)
                                });
                            })
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'col-xs-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TcIndex_Basic_BasicSelector__["a" /* default */], {
                            value: filters.maxGearsCapacity || '',
                            dataList: [undefined, 1, 5, 10, 15, 20, 30, 35, 40],
                            onChange: function onChange(e, _i, value) {
                                return changeFilters({ maxGearsCapacity: value });
                            },
                            hintText: 'Max gear capacity',
                            style: { fontSize: '13px', height: '48px' },
                            labelStyle: { padding: 0, top: 'unset' },
                            iconStyle: { width: '40px' }
                        })
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    [{ field: 'mainRegionDeliveries', hintText: 'Main Region dels' }, { field: 'mainRegionRedeliveries', hintText: 'Main Region redels' }].map(function (v, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-xs-4', key: v.field },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_PortsAutoCompleteMulti__["a" /* default */], {
                                key: v.field + '_' + i,
                                customValue: filters[v.field] ? filters[v.field].name : '',
                                shouldClearCustomValue: clear,
                                handleChangeCustomValue: function handleChangeCustomValue() {},
                                selectValue: function selectValue(e) {
                                    return selectPort(v.field, e);
                                },
                                floatingLabelStyle: { display: 'none' },
                                hintText: v.hintText,
                                inputStyle: { fontSize: '13px' },
                                style: { top: 'unset' },
                                menuStyle: { width: '300px', maxHeight: '200px' },

                                textFieldStyle: { height: '26px' },
                                withAreas: true,
                                mainRegions: true,
                                onlyAreas: true,
                                isInBalticIndex: true
                            })
                        );
                    })
                )
            )
        )
    );
}

/**
 * @typedef {Object} Filters
 * @property {string} [vesselId]
 * @property {import('constants/hire').HireType} [hireType]
 * @property {Date} [addedAfter]
 * @property {Date} [addedBefore]
 * @property {Date} [lay]
 * @property {Date} [can]
 * @property {string} [addedBy]
 * @property {string} [mainRegionDeliveries]
 * @property {string} [mainRegionRedeliveries]
 * @property {'MPP' | 'BULK'} [typeByPurpose]
 * @property {'TWEEN' | 'SID'} [typeByConstruction]
 * @property {any} [vesselDwtGroup]
 * @property {boolean | null} [geared]
 * @property {number} [maxGearsCapacity]
 */

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(Filters, function (prevProps, nextProps) {
    return __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEqual(prevProps.filters, nextProps.filters);
});

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(VesselAutoCompleteWithClearButton, 'VesselAutoCompleteWithClearButton', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/Filters.jsx');
    reactHotLoader.register(UserAutoCompleteWithClearButton, 'UserAutoCompleteWithClearButton', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/Filters.jsx');
    reactHotLoader.register(DatePickerWithClearButton, 'DatePickerWithClearButton', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/Filters.jsx');
    reactHotLoader.register(Filters, 'Filters', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/Filters.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/Filters.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HiresPage__ = __webpack_require__(169);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





function AddUpdateButtons(_ref) {
    var style = _ref.style,
        labelStyle = _ref.labelStyle;

    var addUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__HiresPage__["a" /* AddUpdateContext */]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                label: 'Add',
                onClick: addUpdate.addRow,
                primary: true,
                style: style,
                labelStyle: labelStyle
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                label: 'Update',
                onClick: addUpdate.updateRows,
                secondary: true,
                style: style,
                labelStyle: labelStyle
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-xs-2', style: { height: '48px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["r" /* RaisedButton */], {
                label: 'Export',
                onClick: addUpdate.handleOpenExportDialog,
                primary: true,
                style: style,
                labelStyle: labelStyle
            })
        )
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(AddUpdateButtons);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(AddUpdateButtons, 'AddUpdateButtons', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/AddUpdateButtons.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/AddUpdateButtons.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_useDebounce__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






function PortsAutoCompleteMulti(_ref) {
    var selectValue = _ref.selectValue,
        _ref$customValue = _ref.customValue,
        customValue = _ref$customValue === undefined ? '' : _ref$customValue,
        _ref$floatingLabelTex = _ref.floatingLabelText,
        floatingLabelText = _ref$floatingLabelTex === undefined ? '' : _ref$floatingLabelTex,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        _ref$textFieldStyle = _ref.textFieldStyle,
        textFieldStyle = _ref$textFieldStyle === undefined ? {} : _ref$textFieldStyle,
        _ref$floatingLabelSty = _ref.floatingLabelStyle,
        floatingLabelStyle = _ref$floatingLabelSty === undefined ? {} : _ref$floatingLabelSty,
        hintText = _ref.hintText,
        _ref$menuStyle = _ref.menuStyle,
        menuStyle = _ref$menuStyle === undefined ? {} : _ref$menuStyle,
        _ref$inputStyle = _ref.inputStyle,
        inputStyle = _ref$inputStyle === undefined ? {} : _ref$inputStyle,
        _ref$field = _ref.field,
        field = _ref$field === undefined ? '' : _ref$field,
        _ref$handleChangeCust = _ref.handleChangeCustomValue,
        handleChangeCustomValue = _ref$handleChangeCust === undefined ? function (v) {} : _ref$handleChangeCust,
        _ref$withAreas = _ref.withAreas,
        withAreas = _ref$withAreas === undefined ? false : _ref$withAreas,
        _ref$mainRegions = _ref.mainRegions,
        mainRegions = _ref$mainRegions === undefined ? false : _ref$mainRegions,
        onlyAreas = _ref.onlyAreas,
        _ref$shouldClearCusto = _ref.shouldClearCustomValue,
        shouldClearCustomValue = _ref$shouldClearCusto === undefined ? false : _ref$shouldClearCusto,
        _ref$isInBalticIndex = _ref.isInBalticIndex,
        isInBalticIndex = _ref$isInBalticIndex === undefined ? false : _ref$isInBalticIndex,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
        _useState2 = _slicedToArray(_useState, 2),
        portValue = _useState2[0],
        setPortValue = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState4 = _slicedToArray(_useState3, 2),
        ports = _useState4[0],
        setPorts = _useState4[1];

    var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
        _useState6 = _slicedToArray(_useState5, 2),
        selectedPorts = _useState6[0],
        setSelectedPorts = _useState6[1];

    var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState8 = _slicedToArray(_useState7, 2),
        preventFirstSearch = _useState8[0],
        setPreventFirstSearch = _useState8[1];

    var dropdownRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var inputRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

    var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState10 = _slicedToArray(_useState9, 2),
        showDropdown = _useState10[0],
        setShowDropdown = _useState10[1];

    var debouncedSearchValue = Object(__WEBPACK_IMPORTED_MODULE_1_helpers_useDebounce__["a" /* default */])(portValue, 500);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPortValue('');
        setSelectedPorts([]);
    }, [shouldClearCustomValue]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (preventFirstSearch) return;

        if (!debouncedSearchValue || debouncedSearchValue.length < 2) {
            handleChangeCustomValue({});
            setShowDropdown(false);
            return;
        }

        __WEBPACK_IMPORTED_MODULE_2_services__["a" /* default */].findPort({
            name: debouncedSearchValue, withAreas: withAreas, onlyAreas: onlyAreas, mainRegions: mainRegions, isInBalticIndex: isInBalticIndex
        }).then(function (result) {
            setPorts(result.data.data);
            setShowDropdown(true);
        });
    }, [debouncedSearchValue]);

    var handleClickOutside = function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPreventFirstSearch(false);
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setPortValue(customValue);
    }, [customValue]);

    var choosePort = function choosePort(selectedValue) {
        if (!selectedPorts.some(function (port) {
            return port._id === selectedValue._id;
        })) {
            var newSelectedPorts = [].concat(_toConsumableArray(selectedPorts), [selectedValue]);
            setSelectedPorts(newSelectedPorts);
            selectValue(newSelectedPorts);
        }
        setPortValue('');
        setShowDropdown(false);
        setTimeout(function () {
            inputRef.current.focus();
        }, 0);
    };

    var removePort = function removePort(portToRemove) {
        var newSelectedPorts = selectedPorts.filter(function (port) {
            return port._id !== portToRemove._id;
        });
        setSelectedPorts(newSelectedPorts);
        selectValue(newSelectedPorts);
    };

    var changePortValue = function changePortValue(val) {
        setPortValue(val);
    };

    var inputId = 'ports-autocomplete-input';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: style },
        floatingLabelText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { htmlFor: inputId, style: _extends({}, floatingLabelStyle) },
            floatingLabelText
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #ccc',
                    padding: '4px',
                    borderRadius: '4px',
                    minHeight: '40px',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }
            },
            selectedPorts.map(function (port) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_material_ui__["c" /* Chip */],
                    {
                        key: port._id,
                        onRequestDelete: function onRequestDelete() {
                            return removePort(port);
                        },
                        style: { margin: '2px' },
                        labelStyle: { fontSize: '13px' }
                    },
                    port[field || 'name']
                );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                id: inputId,
                ref: inputRef,
                type: 'text',
                value: portValue,
                onChange: function onChange(e) {
                    return changePortValue(e.target.value);
                },
                placeholder: hintText || 'Port',
                style: _extends({}, textFieldStyle, inputStyle, { border: 'none', outline: 'none', flex: 1, minWidth: '100px'
                }),
                disabled: disabled
            })
        ),
        showDropdown && ports.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            {
                ref: dropdownRef,
                style: _extends({}, menuStyle, {
                    listStyleType: 'none',
                    padding: '8px 0',
                    margin: '2px 0 0',
                    maxHeight: '300px',
                    overflow: 'auto',
                    position: 'absolute',
                    zIndex: 1000,
                    backgroundColor: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
                })
            },
            ports.map(function (port, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    {
                        key: index,
                        onClick: function onClick() {
                            return choosePort(port);
                        },
                        onKeyDown: function onKeyDown(e) {
                            return e.key === 'Enter' && choosePort(port);
                        },
                        tabIndex: 0,
                        role: 'option',
                        'aria-selected': false,
                        style: {
                            cursor: 'pointer',
                            fontSize: '13px',
                            padding: '8px 16px',
                            lineHeight: '1.5',
                            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                        }
                    },
                    port[field || 'name']
                );
            })
        )
    );
}

var _default = PortsAutoCompleteMulti;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(PortsAutoCompleteMulti, 'PortsAutoCompleteMulti', '/opt/atlassian/pipelines/agent/build/client/app/components/common/PortsAutoCompleteMulti.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/common/PortsAutoCompleteMulti.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HiresTableRow__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(3543);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();







function HiresTable(_ref) {
    var rows = _ref.rows,
        _errors = _ref.errors,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(_errors),
        _useState2 = _slicedToArray(_useState, 2),
        errors = _useState2[0],
        setErrors = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setErrors(_errors);
    }, [_errors]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["u" /* Table */],
            { selectable: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["w" /* TableHeader */],
                {
                    displaySelectAll: false,
                    adjustForCheckbox: false
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'IMO'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Type by purpose'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Type by construction'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Geared'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Max crane capacity'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm, { position: 'relative' }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* TooltipWrapper */], { text: 'Picked by priority: Eco Laden, Eco Ballast, Laden, Ballast, Working, Idle with highest speed.' }),
                    'Speed & Cons'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'DWT group*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'Place from'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'Region from*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'Place to'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'Region to*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'LayCan*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Hire type*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Hire*'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm, { position: 'relative' }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* TooltipWrapper */], { text: 'Parsed value. Changing will modify only vlsfo.' }),
                    'Fuel price'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: _extends({}, __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol, { position: 'relative' }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* TooltipWrapper */], { text: 'Main region.' }),
                    'Bunker place'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Duration, d'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'Cargo Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerCol },
                    'Cargo Region'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_material_ui__["x" /* TableHeaderColumn */],
                    { style: __WEBPACK_IMPORTED_MODULE_1__TcIndex_styles__["a" /* default */].headerColSm },
                    'Delete'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_material_ui__["v" /* TableBody */],
                { displayRowCheckbox: false },
                rows.map(function (row, rowIndex) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HiresTableRow__["a" /* default */], {
                        rowIndex: rowIndex,
                        key: 'HiresTableRow__' + (row._id || row.uniqueId) + '_' + rowIndex,
                        hireData: row,
                        errors: errors,
                        changeFieldsMultiple: changeFieldsMultiple
                    });
                })
            )
        )
    );
}

var _default = Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(HiresTable);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HiresTable, 'HiresTable', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresTable.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/HiresTable.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcIndex_Basic_BasicSelector__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_hire__ = __webpack_require__(372);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function HireType(_ref) {
    var hireType = _ref.hireType,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        setHasErrors = _ref.setHasErrors,
        required = _ref.required;

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!hireType) {
                setHasErrors('hireType', true);
            } else {
                setHasErrors('hireType', false);
            }
        }
    }, [hireType]);

    var selectVesselType = function selectVesselType(value) {
        changeFieldsMultiple([{
            index: countIndex,
            field: 'hireType',
            value: value
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TcIndex_Basic_BasicSelector__["a" /* default */], {
        value: hireType,
        dataList: __WEBPACK_IMPORTED_MODULE_3_constants_hire__["a" /* HIRE_TYPES_MAP */],
        onChange: function onChange(e, _i, value) {
            return selectVesselType(value);
        },
        iconStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '10px' },
        labelStyle: { padding: 0, top: 'unset' },
        fields: ['placeHolder'],
        customRender: __WEBPACK_IMPORTED_MODULE_3_constants_hire__["a" /* HIRE_TYPES_MAP */].map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["m" /* MenuItem */], {
                key: item.field,
                value: item.field,
                primaryText: item.placeHolder
            });
        })
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(HireType);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HireType, 'HireType', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireType.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireType.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TcIndex_Basic_BasicInput__ = __webpack_require__(243);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




function HireValue(_ref) {
    var hire = _ref.hire,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        setHasErrors = _ref.setHasErrors;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(hire),
        _useState2 = _slicedToArray(_useState, 2),
        stateHire = _useState2[0],
        setStateIndex = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!hire) {
                setHasErrors('hire', true);
            } else {
                setHasErrors('hire', false);
            }
        }
        setStateIndex(hire);
    }, [hire]);

    var changeHire = function changeHire() {
        hire !== stateHire && changeFieldsMultiple([{
            index: countIndex,
            field: 'hire',
            value: stateHire
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TcIndex_Basic_BasicInput__["a" /* default */], {
        name: 'hire',
        value: stateHire,
        onChange: function onChange(e) {
            return setStateIndex(e.target.value);
        },
        floatingLabelStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        type: 'number',
        onBlur: changeHire
    });
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(HireValue);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HireValue, 'HireValue', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireValue.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireValue.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export generateSpeedConsString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcIndex_common__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HiresPage__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TcIndex_styles__ = __webpack_require__(205);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();








function generateSpeedConsString(s) {
    if (!s.speed && !s.mode && (!s.ifo || !s.ifo.cons) && (!s.mdo || !s.mdo.cons)) return '';

    var ifoString = s.ifo ? (s.ifo.typeIfo || '') + ' - ' + (s.ifo.cons || '') : '';
    var mdoString = s.mdo ? (s.mdo.typeMdo || '') + ' - ' + (s.mdo.cons || '') : '';

    return 'Mode: ' + s.mode + ' | Speed: ' + (s.speed || '-') + ' | Ifo: ' + ifoString + ' | Mdo: ' + mdoString;
}

var PRIORITY_MODES = ['Eco Laden', 'Eco Ballast', 'Laden', 'Ballast', 'Working', 'Idle'];

var selectBestSpeedCons = function selectBestSpeedCons(speedConsData) {
    if (!speedConsData || !speedConsData.length) return {};

    // find first available mode by priority
    // eslint-disable-next-line no-restricted-syntax
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var mode = _step.value;

            var modeEntries = speedConsData.filter(function (s) {
                return s.mode === mode;
            });
            if (modeEntries.length) {
                // if multiple entries of same mode exist, get one with the highest speed
                return {
                    v: modeEntries.reduce(function (best, current) {
                        if (current.speed > best.speed) return current;
                        if (current.speed === best.speed) {
                            // сompare total consumption (ifo + mdo) if speeds are equal
                            var bestTotalCons = (best.ifo && best.ifo.cons && !isNaN(best.ifo.cons) ? best.ifo.cons : 0) + (best.mdo && best.mdo.cons && !isNaN(best.mdo.cons) ? best.mdo.cons : 0);
                            var currentTotalCons = (current.ifo && current.ifo.cons && !isNaN(current.ifo.cons) ? current.ifo.cons : 0) + (current.mdo && current.mdo.cons && !isNaN(current.mdo.cons) ? current.mdo.cons : 0);
                            if (currentTotalCons > bestTotalCons) return current;
                        }
                        return best;
                    }, modeEntries[0])
                };
            }
        };

        for (var _iterator = PRIORITY_MODES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ret = _loop();

            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return {};
};

var VesselColumn = function VesselColumn(_ref) {
    var children = _ref.children;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
        { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5__TcIndex_styles__["a" /* default */].tableRowSm, { fontSize: '9px' }) },
        children || ''
    );
};

var spawnVesselInfoCols = function spawnVesselInfoCols(vesselData) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            VesselColumn,
            null,
            vesselData && vesselData.typeByPurpose
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            VesselColumn,
            null,
            vesselData && vesselData.typeByConstruction
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            VesselColumn,
            null,
            vesselData && vesselData.imoNumber && (typeof vesselData.geared === 'boolean' ? String(vesselData.geared) : undefined)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            VesselColumn,
            null,
            vesselData && vesselData.gearV2 && vesselData.gearV2.summary && vesselData.gearV2.summary.reduce(function (max, s) {
                return Math.max(max, s.capacity);
            }, 0)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            VesselColumn,
            null,
            vesselData && vesselData.speedConsumptionV2 && generateSpeedConsString(selectBestSpeedCons(vesselData.speedConsumptionV2))
        )
    );
};

function VesselInfo(_ref2) {
    var _vessel = _ref2.vessel,
        countIndex = _ref2.countIndex,
        changeFieldsMultiple = _ref2.changeFieldsMultiple,
        required = _ref2.required,
        setHasErrors = _ref2.setHasErrors;

    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__HiresPage__["f" /* VesselDwtTypesContext */]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!_vessel || !_vessel._id) {
                setHasErrors('vessel', true);
            } else {
                setHasErrors('vessel', false);
            }
        }
    }, [_vessel ? _vessel._id : _vessel]);

    var selectVessel = function selectVessel(vessel) {
        var vesselData = Object(__WEBPACK_IMPORTED_MODULE_2__TcIndex_common__["b" /* selectTypes */])(vessel, vesselDwtTypes);

        changeFieldsMultiple([{
            index: countIndex,
            field: 'vessel',
            value: vessel
        }, {
            index: countIndex,
            field: 'vesselDwtGroup',
            value: vesselData.vesselDwtGroup
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_5__TcIndex_styles__["a" /* default */].tableRow) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_common_VesselAutoComplete__["a" /* default */], {
                customValue: _vessel ? _vessel.name : '',
                selectValue: selectVessel,
                hintText: null,
                underlineStyle: { display: 'none' },
                menuStyle: { width: '300px' },
                popoverProps: {
                    style: { width: '300px' }
                },
                inputStyle: { fontSize: '9px' },
                dataSourceConfig: {
                    withName: true,
                    withBlt: true,
                    withImo: true
                }
            })
        ),
        spawnVesselInfoCols(_vessel)
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(VesselInfo, function (prevProps, nextProps) {
    if (!prevProps.vessel || !nextProps.vessel) return prevProps.vessel === nextProps.vessel;

    return prevProps.vessel._id === nextProps.vessel._id && prevProps.vessel.typeByPurpose === nextProps.vessel.typeByPurpose && prevProps.vessel.typeByConstruction === nextProps.vessel.typeByConstruction && prevProps.vessel.geared === nextProps.vessel.geared && prevProps.vessel.speedConsumptionV2 === nextProps.vessel.speedConsumptionV2;
});

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(generateSpeedConsString, 'generateSpeedConsString', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/VesselInfo.jsx');
    reactHotLoader.register(PRIORITY_MODES, 'PRIORITY_MODES', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/VesselInfo.jsx');
    reactHotLoader.register(selectBestSpeedCons, 'selectBestSpeedCons', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/VesselInfo.jsx');
    reactHotLoader.register(VesselColumn, 'VesselColumn', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/VesselInfo.jsx');
    reactHotLoader.register(spawnVesselInfoCols, 'spawnVesselInfoCols', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/VesselInfo.jsx');
    reactHotLoader.register(VesselInfo, 'VesselInfo', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/VesselInfo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/VesselInfo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export FuelPrice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TcIndex_Basic_BasicInput__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HiresTableRow__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







/**
 * Converts a date string to yyyy-mm-dd format
 * @param {string | Date} dateString - The date string to convert
 * @returns {string} - The formatted date
 */
var formatDate = function formatDate(dateString) {
    var date = new Date(dateString);
    var today = new Date();

    // no need to provide date if it's today
    if (date.toISOString().split('T')[0] === today.toISOString().split('T')[0]) {
        return undefined;
    }

    return date.toISOString().split('T')[0];
};

/**
 * @param {{
 *  fuelPrice: FuelPrice,
 *  countIndex: number,
 *  changeFieldsMultiple: Function,
 *  lay: Date,
 *  bunkerPlace: any,
*   mainRegionDelivery: any
 * }} param0 
 * @returns 
 */
var FuelPrice = function FuelPrice(_ref) {
    var fuelPrice = _ref.fuelPrice,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex,
        lay = _ref.lay,
        bunkerPlace = _ref.bunkerPlace,
        mainRegionDelivery = _ref.mainRegionDelivery;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
        _useState2 = _slicedToArray(_useState, 2),
        selectedFuelType = _useState2[0],
        setSelectedFuelType = _useState2[1];

    var hasMounted = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false); // need that to prevent price call on first render

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
        _useState4 = _slicedToArray(_useState3, 2),
        fuelPriceLoading = _useState4[0],
        setFuelPriceLoading = _useState4[1];

    var updatePricesInStore = function updatePricesInStore(value) {
        changeFieldsMultiple([{ index: countIndex, field: 'fuelPrice', value: value }, { index: countIndex, field: 'mainRegionDelivery', value: mainRegionDelivery }].concat(_toConsumableArray(!bunkerPlace ? [{ index: countIndex, field: 'bunkerPlace', value: mainRegionDelivery }] : [])));
    };

    var pickCurrentFuelPrice = function pickCurrentFuelPrice(_fuelPrice) {
        var _ref2 = _fuelPrice || {},
            ifo380 = _ref2.ifo380,
            mgo = _ref2.mgo,
            vlsfo = _ref2.vlsfo;

        if (vlsfo) {
            setSelectedFuelType('vlsfo');
        } else if (ifo380) {
            setSelectedFuelType('ifo380');
        } else if (mgo) {
            setSelectedFuelType('mgo');
        } else {
            setSelectedFuelType(null);
        }
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        pickCurrentFuelPrice(fuelPrice);
    }, [fuelPrice]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var fetchFuelPrice = function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var portId;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                portId = bunkerPlace && bunkerPlace._id;

                                if (!portId) {
                                    _context.next = 5;
                                    break;
                                }

                                setFuelPriceLoading(true);
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_4_services__["a" /* default */].fuel.getFuelPriceFilteredV2({
                                    date: formatDate(lay),
                                    entityId: portId,
                                    isArea: !!bunkerPlace.areaParent
                                }).then(function (res) {
                                    if (res.data && (!res.errors || res.errors && !res.errors.length)) {
                                        var dataToUpdate = void 0;

                                        // Check if fuelPrices is a string "Fuel price not found" or not a valid object
                                        if (res.data.fuelPrice === 'Fuel price not found' || _typeof(res.data.fuelPrice) !== 'object' || res.data.fuelPrice === null) {
                                            // Check if averageFuelPricesByChilds exists and is an object
                                            if (res.data.averageFuelPricesByChilds && _typeof(res.data.averageFuelPricesByChilds) === 'object') {
                                                // Use averageFuelPricesByChilds instead
                                                dataToUpdate = res.data.averageFuelPricesByChilds;
                                            }
                                        } else {
                                            // Use fuelPrice if it's a valid object
                                            dataToUpdate = res.data.fuelPrice;
                                        }

                                        updatePricesInStore(dataToUpdate);
                                    }
                                }).finally(function () {
                                    return setFuelPriceLoading(false);
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function fetchFuelPrice() {
                return _ref3.apply(this, arguments);
            };
        }();

        if (hasMounted.current) {
            fetchFuelPrice();
        } else {
            hasMounted.current = true;
        }
    }, [lay, bunkerPlace]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        pickCurrentFuelPrice(fuelPrice);
    }, []);

    var handleInputChange = function handleInputChange(e) {
        var newValue = e.target.value;
        updatePricesInStore({
            vlsfo: newValue ? parseFloat(newValue) : undefined
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui__["z" /* TableRowColumn */],
            { style: _extends({}, __WEBPACK_IMPORTED_MODULE_3__HiresTableRow__["b" /* s */].small, { textAlign: fuelPriceLoading ? 'center' : 'unset' }) },
            fuelPriceLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["d" /* CircularProgress */], { size: 16 }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TcIndex_Basic_BasicInput__["a" /* default */], {
                name: 'fuelPriceValue',
                value: fuelPrice && (fuelPrice[selectedFuelType] || ''),
                placeholder: '-',
                onFocus: function onFocus(e) {
                    return e.target.placeholder = '';
                },
                onBlur: function onBlur(e) {
                    return e.target.placeholder = '-';
                },
                onChange: handleInputChange,
                floatingLabelStyle: { display: 'none' },
                underlineStyle: { display: 'none' },
                style: { fontSize: '9px' },
                type: 'number'
            })
        )
    );
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(FuelPrice);

/* harmony default export */ __webpack_exports__["a"] = (_default);

/**
 * @typedef {Object} FuelPrice
 * @property {number} [ifo380]
 * @property {number} [mgo]
 * @property {number} [vlsfo]
 */

;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(formatDate, 'formatDate', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/FuelPrice.jsx');
    reactHotLoader.register(FuelPrice, 'FuelPrice', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/FuelPrice.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/FuelPrice.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HiresPage__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcIndex_Basic_BasicSelector__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();


// import CargoNameAutoComplete from '../../common/CargoAutoComplete';





function HireCargo(_ref) {
    var cargo = _ref.cargo,
        cargoType = _ref.cargoType,
        countIndex = _ref.countIndex,
        changeFieldsMultiple = _ref.changeFieldsMultiple;

    var cargoTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__HiresPage__["b" /* CargoTypesContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(cargoType),
        _useState2 = _slicedToArray(_useState, 2),
        cargoTypeValue = _useState2[0],
        setCargoTypeValue = _useState2[1];
    // ---- that is commented because according to task, cargo value must be hidden
    // ---- ---- i will keep that here, because i am sure the task will later be changed
    // const changeCargo = useCallback((value) => {
    //     const toChange = [{ index: countIndex, field: 'cargo', value }];

    //     if (value.parent && value.parent.red && value.parent.red._id) {
    //         toChange.push({
    //             index: countIndex, field: 'cargoType', value: value.parent.red,
    //         });
    //     }

    //     changeFieldsMultiple(toChange);
    // }, [countIndex, changeFieldsMultiple]);

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setCargoTypeValue(cargoType);
    }, [cargoType]);

    var selectCargoType = function selectCargoType(value) {
        changeFieldsMultiple([{ index: countIndex, field: 'cargo', value: undefined }, { index: countIndex, field: 'cargoTypeId', value: cargoTypes.find(function (c) {
                return c._id === value;
            }) }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TcIndex_Basic_BasicSelector__["a" /* default */], {
            value: cargoType ? cargoType._id : '',
            dataList: cargoTypes || [],
            onChange: function onChange(e, _i, value) {
                return selectCargoType(value);
            },
            iconStyle: { display: 'none' },
            underlineStyle: { display: 'none' },
            style: { fontSize: '9px' },
            labelStyle: { padding: 0, top: 'unset' },
            customRender: (cargoTypes || []).map(function (item) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["m" /* MenuItem */], {
                    key: item._id,
                    value: item._id,
                    primaryText: item.name
                });
            })
        })
    );
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(HireCargo, function (prev, next) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(prev.cargoType, next.cargoType) && prev.countIndex === next.countIndex && Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(prev.changeFieldsMultiple, next.changeFieldsMultiple);
});

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HireCargo, 'HireCargo', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireCargo.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireCargo.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_PortsAutoComplete__ = __webpack_require__(283);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();




var HireCargoRegion = function HireCargoRegion(_ref) {
    var cargoRegion = _ref.cargoRegion,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(cargoRegion),
        _useState2 = _slicedToArray(_useState, 2),
        region = _useState2[0],
        setRegion = _useState2[1];

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setRegion(cargoRegion);
    }, [cargoRegion]);

    var selectPort = function selectPort(value) {
        changeFieldsMultiple([{
            index: countIndex,
            field: 'cargoRegionId',
            value: value
        }]);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_PortsAutoComplete__["a" /* default */], {
        name: 'cargoRegion_' + countIndex,
        customValue: region ? region.name : '',
        selectValue: selectPort,
        floatingLabelText: 'Cargo region',
        withAreas: true,
        mainRegions: true,
        onlyAreas: false,
        floatingLabelStyle: { display: 'none' },
        hintText: null,
        underlineStyle: { display: 'none' },
        inputStyle: { fontSize: '10px', marginTop: 'unset' },
        style: { top: 'unset' },
        menuStyle: { width: '300px' },
        popoverProps: {
            style: { width: '300px' }
        }
    });
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(HireCargoRegion);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(HireCargoRegion, 'HireCargoRegion', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireCargoRegion.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/HireCargoRegion.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Remove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_delete__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_AwaitableBtn_styles_scss__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_AwaitableBtn_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Base_AwaitableBtn_styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_miscellaneous__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HiresPage__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TcIndex_Basic_BasicIconButton__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();











function _Remove(_ref) {
    var countIndex = _ref.countIndex,
        hireDataId = _ref.hireDataId;

    var removeRow = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__HiresPage__["e" /* RemoveRowContext */]);

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
        _useState2 = _slicedToArray(_useState, 2),
        isLoaded = _useState2[0],
        setIsLoaded = _useState2[1];

    var remove = function remove() {
        if (Object(__WEBPACK_IMPORTED_MODULE_4_helpers_miscellaneous__["a" /* isValidUuid */])(hireDataId)) {
            removeRow(countIndex);
            setIsLoaded(true);
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_services__["a" /* default */].updateHireIdeas({ toDelete: [hireDataId] }).then(function (res) {
            if (res && (!res.errors || !res.errors.length)) {
                removeRow(countIndex);
                setIsLoaded(true);
                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])('Removed successfully.', 'success');
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_7_helpers__["c" /* showNotification */])(res.errors[0].messages[0], 'error');
            }
        });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'awaitable-btn ' + (isLoaded ? '' : 'wait') },
        isLoaded && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_svg_icons_action_delete___default.a, {
            onClick: remove,
            color: 'red'
        })
    );
}

var Remove = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_6__TcIndex_Basic_BasicIconButton__["a" /* default */])(_Remove));
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(_Remove, '_Remove', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/Remove.jsx');
    reactHotLoader.register(Remove, 'Remove', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/Remove.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HiresPage__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TcIndex_Basic_BasicSelector__ = __webpack_require__(146);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();






function DwtGroup(_ref) {
    var vesselType = _ref.vesselType,
        changeFieldsMultiple = _ref.changeFieldsMultiple,
        countIndex = _ref.countIndex,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        setHasErrors = _ref.setHasErrors,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        currentDwtGroups = _ref.currentDwtGroups;

    var vesselDwtTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__HiresPage__["f" /* VesselDwtTypesContext */]);

    var selectVesselType = function selectVesselType(_id) {
        var toChange = [{
            index: countIndex,
            field: 'vesselDwtGroup',
            value: vesselDwtTypes.find(function (t) {
                return t._id === _id;
            })
        }, {
            index: countIndex,
            field: 'vessel',
            value: undefined
        }];

        changeFieldsMultiple(toChange);
    };

    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (required) {
            if (!vesselType || !vesselType._id) {
                setHasErrors('vesselDwtGroup', true);
            } else {
                setHasErrors('vesselDwtGroup', false);
            }
        }
    }, [vesselType]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TcIndex_Basic_BasicSelector__["a" /* default */], {
        value: vesselType && vesselType._id,
        dataList: currentDwtGroups,
        onChange: function onChange(e, _i, value) {
            return selectVesselType(value);
        },
        iconStyle: { display: 'none' },
        underlineStyle: { display: 'none' },
        style: { fontSize: '9px' },
        labelStyle: { padding: 0, top: 'unset' },
        fields: ['min', 'max'],
        disabled: disabled
    });
}

DwtGroup.protoTypes = {
    vesselType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        _id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    changeFieldsMultiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    countIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(DwtGroup);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(DwtGroup, 'DwtGroup', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/DwtGroup.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/DwtGroup.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FromTo__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





/**
 * 
 * @param {import('./FromTo').FromToProps} props 
 * @returns 
 */
function BunkerPlace(props) {
    var _this = this;

    var selectPortCustom = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(port) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            props.changeFieldsMultiple([{
                                index: props.countIndex,
                                field: props.field,
                                value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(port, ['_id', 'name', 'areaParent'])
                            }]);

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function selectPortCustom(_x) {
            return _ref.apply(this, arguments);
        };
    }();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FromTo__["a" /* default */], _extends({}, props, {
        selectPortCustom: selectPortCustom
    }));
}

var _default = __WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(BunkerPlace);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(BunkerPlace, 'BunkerPlace', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/BunkerPlace.jsx');
    reactHotLoader.register(_default, 'default', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/rowData/BunkerPlace.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_info__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_info__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();





var TooltipWrapper = function TooltipWrapper(_ref) {
    var text = _ref.text;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
                'data-tip': text,
                style: {
                    position: 'absolute', pointerEvents: 'all', top: 1, right: 1
                }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_svg_icons_action_info___default.a, { style: { height: '1em', width: '1em', color: '#969696' } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tooltip___default.a, { type: 'light', border: true, offset: 15 })
    );
};
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(TooltipWrapper, 'TooltipWrapper', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/utils.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = ExportDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/**
 * 
 * @param {{ open: boolean, handleOpenExportDialog: Function, exportRows: Function }} param0 
 */
function ExportDialog(_ref) {
    var _ref$open = _ref.open,
        open = _ref$open === undefined ? false : _ref$open,
        handleOpenExportDialog = _ref.handleOpenExportDialog,
        exportRows = _ref.exportRows;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* EXPORT_MAP */]),
        _useState2 = _slicedToArray(_useState, 2),
        items = _useState2[0],
        setItems = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),
        _useState4 = _slicedToArray(_useState3, 2),
        allSelected = _useState4[0],
        setAllSelected = _useState4[1];

    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (!Object.values(items).every(function (i) {
            return i.value === 1;
        })) {
            setAllSelected(false);
        }
    }, [items]);

    var handleSelectAll = function handleSelectAll() {
        var copy = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(items);
        var changeTo = allSelected ? 0 : 1;

        Object.keys(copy).forEach(function (key) {
            copy[key].value = changeTo;
        });
        setItems(copy);
        setAllSelected(!allSelected);
    };

    var handleCheckboxChange = function handleCheckboxChange(key) {
        setItems(function (prev) {
            return _extends({}, prev, _defineProperty({}, key, _extends({}, prev[key], {
                value: prev[key].value === 1 ? 0 : 1
            })));
        });
    };

    var handleClose = function handleClose() {
        setItems(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* EXPORT_MAP */]);
        setAllSelected(true);
        handleOpenExportDialog();
    };

    var actions = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["g" /* FlatButton */], {
        label: 'JSON',
        primary: true,
        onClick: function onClick() {
            return exportRows('json', Object.fromEntries(Object.keys(items).map(function (key) {
                return [key, items[key].value];
            })));
        }
    }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["g" /* FlatButton */], {
        label: 'CSV',
        primary: true,
        onClick: function onClick() {
            return exportRows('csv', Object.fromEntries(Object.keys(items).map(function (key) {
                return [key, items[key].value];
            })));
        }
    }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["g" /* FlatButton */], {
        label: 'Cancel',
        secondary: true,
        onClick: handleClose
    })];

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_material_ui__["f" /* Dialog */],
        {
            open: open,
            actions: actions,
            key: 'dialog_' + open,
            bodyStyle: {
                overflowY: 'scroll'
            }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_material_ui__["j" /* List */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_material_ui__["k" /* ListItem */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["b" /* Checkbox */], {
                    label: 'Select All',
                    labelStyle: { color: '#bcbbbb' },
                    checked: Object.values(items).every(function (i) {
                        return i.value === 1;
                    }),
                    onCheck: handleSelectAll
                })
            ),
            Object.keys(items).map(function (key) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_material_ui__["k" /* ListItem */],
                    { key: key, innerDivStyle: { padding: '2px 16px' } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_material_ui__["b" /* Checkbox */], {
                        label: items[key].label,
                        checked: items[key].value === 1,
                        onCheck: function onCheck() {
                            return handleCheckboxChange(key);
                        }
                    })
                );
            })
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(ExportDialog, 'ExportDialog', '/opt/atlassian/pipelines/agent/build/client/app/components/Hires/ExportDialog.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["a"] = StatsRabbitmq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_query__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss__ = __webpack_require__(3546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_scss__);
(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var queryClient = new __WEBPACK_IMPORTED_MODULE_1_react_query__["QueryClient"]();

function StatsRabbitmq() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_query__["QueryClientProvider"],
        { client: queryClient },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Page, null)
    );
}

function Page() {
    var _useQuery = Object(__WEBPACK_IMPORTED_MODULE_1_react_query__["useQuery"])({
        queryKey: ['queue-status'],
        refetchInterval: 10000,
        queryFn: function queryFn() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _ref, d;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/v2/adminPanel/queue-status?filter=cargo,vessel,requests');

                            case 2:
                                _ref = _context.sent;
                                d = _ref.data;
                                return _context.abrupt('return', d.data);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }),
        data = _useQuery.data,
        error = _useQuery.error;

    if (error) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'error-message' },
            'Error fetching ack rate: ',
            error.message
        );
    }

    var cargoQueues = data ? data.filter(function (item) {
        return item.queue.includes('cargo-');
    }) : [];
    var vesselQueues = data ? data.filter(function (item) {
        return item.queue.includes('vessel-');
    }) : [];
    var tcQueues = data ? data.filter(function (item) {
        return item.queue.includes('tc-');
    }) : [];
    var salesQueues = data ? data.filter(function (item) {
        return item.queue.includes('sales-');
    }) : [];
    var otherQueues = data ? data.filter(function (item) {
        return !item.queue.includes('cargo-') && !item.queue.includes('vessel-') && !item.queue.includes('tc-') && !item.queue.includes('sales-');
    }) : [];

    var sort = {
        '-to-annotate': 1,
        '-completed': 2,
        '-requests': 3,
        '--requests-result': 4
    };

    var getPriority = function getPriority(queueName) {
        var priority = Infinity;
        Object.keys(sort).forEach(function (suffix) {
            if (queueName.endsWith(suffix)) {
                priority = sort[suffix];
            }
        });
        return priority;
    };

    var sortQueues = function sortQueues(queues) {
        return queues.sort(function (a, b) {
            return getPriority(a.queue) - getPriority(b.queue);
        });
    };

    var sortedCargoQueues = sortQueues(cargoQueues);
    var sortedVesselQueues = sortQueues(vesselQueues);
    var sortedTcQueues = sortQueues(tcQueues);
    var sortedSalesQueues = sortQueues(salesQueues);

    var RateBlock = function RateBlock(_ref2) {
        var item = _ref2.item;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rate-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rate-details' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'label' },
                    'Queue:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'value' },
                    item.queue
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rate-details' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'label' },
                    'In work:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'value' },
                    item.total
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rate-details' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'label' },
                    'Work Rate:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'value' },
                    item.ackRate.toFixed(2),
                    '/s'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rate-details' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'label' },
                    'Workers:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'value' },
                    item.workers
                )
            )
        );
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'acknowledgment-rates' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'title' },
            'RabbitMQ Acknowledgment Rates'
        ),
        sortedCargoQueues.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Cargo Queues'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rates-container' },
                sortedCargoQueues.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RateBlock, { key: index, item: item });
                })
            )
        ),
        sortedVesselQueues.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Vessel Queues'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rates-container' },
                sortedVesselQueues.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RateBlock, { key: index, item: item });
                })
            )
        ),
        sortedTcQueues.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Tc Queues'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rates-container' },
                sortedTcQueues.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RateBlock, { key: index, item: item });
                })
            )
        ),
        sortedSalesQueues.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Sales Queues'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rates-container' },
                sortedSalesQueues.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RateBlock, { key: index, item: item });
                })
            )
        ),
        otherQueues.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Other Queues'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rates-container' },
                otherQueues.map(function (item, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RateBlock, { key: index, item: item });
                })
            )
        ),
        cargoQueues.length === 0 && vesselQueues.length === 0 && otherQueues.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'no-data' },
            'No data available'
        )
    );
}
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(queryClient, 'queryClient', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Queues/Page.jsx');
    reactHotLoader.register(StatsRabbitmq, 'StatsRabbitmq', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Queues/Page.jsx');
    reactHotLoader.register(Page, 'Page', '/opt/atlassian/pipelines/agent/build/client/app/components/Statistics/Queues/Page.jsx');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)(module)))

/***/ }),
/* 3546 */
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1770813128486
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),
/* 3547 */
/***/ (function(module, exports) {

var CALLBACK_NAME = '__googleMapsApiOnLoadCallback'

var OPTIONS_KEYS = ['channel', 'client', 'key', 'language', 'region', 'v']

var promise = null

module.exports = function (options) {
  options = options || {}

  if (!promise) {
    promise = new Promise(function (resolve, reject) {
      // Reject the promise after a timeout
      var timeoutId = setTimeout(function () {
        window[CALLBACK_NAME] = function () {} // Set the on load callback to a no-op
        reject(new Error('Could not load the Google Maps API'))
      }, options.timeout || 10000)

      // Hook up the on load callback
      window[CALLBACK_NAME] = function () {
        if (timeoutId !== null) {
          clearTimeout(timeoutId)
        }
        resolve(window.google.maps)
        delete window[CALLBACK_NAME]
      }

      // Prepare the `script` tag to be inserted into the page
      var scriptElement = document.createElement('script')
      var params = ['callback=' + CALLBACK_NAME]
      OPTIONS_KEYS.forEach(function (key) {
        if (options[key]) {
          params.push(key + '=' + options[key])
        }
      })
      if (options.libraries && options.libraries.length) {
        params.push('libraries=' + options.libraries.join(','))
      }
      scriptElement.src =
        'https://maps.googleapis.com/maps/api/js?' + params.join('&')

      // Insert the `script` tag
      document.body.appendChild(scriptElement)
    })
  }

  return promise
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.58f1f612da3df12c461b.js